(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
module.exports.download = require("../src/download");
module.exports.write = require("../src/write");
module.exports.zip = require("../src/zip");

},{"../src/download":2,"../src/write":9,"../src/zip":10}],2:[function(require,module,exports){
var zip = require('./zip');
var saveAs = require("file-saver").saveAs;

/**
 * @deprecated may be removed in a future version, please use an external 
 * download library
 */
module.exports = function (gj, options) {
  let filename = 'download';

  // since we only need a single filename object, we can use either the folder or
  // filename, depending on what was passed in
  if (options && (options.filename || options.folder)) {
    filename = (options.filename || options.folder);
  }
  zip(gj, options).then(function (blob) { saveAs(blob, filename + '.zip'); });
};

},{"./zip":10,"file-saver":19}],3:[function(require,module,exports){
module.exports.enlarge = function enlargeExtent(extent, pt) {
    if (pt[0] < extent.xmin) extent.xmin = pt[0];
    if (pt[0] > extent.xmax) extent.xmax = pt[0];
    if (pt[1] < extent.ymin) extent.ymin = pt[1];
    if (pt[1] > extent.ymax) extent.ymax = pt[1];
    return extent;
};

module.exports.enlargeExtent = function enlargeExtent(extent, ext) {
    if (ext.xmax > extent.xmax) extent.xmax = ext.xmax;
    if (ext.xmin < extent.xmin) extent.xmin = ext.xmin;
    if (ext.ymax > extent.ymax) extent.ymax = ext.ymax;
    if (ext.ymin < extent.ymin) extent.ymin = ext.ymin;
    return extent;
};

module.exports.blank = function() {
    return {
        xmin: Number.MAX_VALUE,
        ymin: Number.MAX_VALUE,
        xmax: -Number.MAX_VALUE,
        ymax: -Number.MAX_VALUE
    };
};

},{}],4:[function(require,module,exports){
module.exports.point = justType("Point", "POINT");
module.exports.line = justType("LineString", "POLYLINE");
module.exports.multiline = justType("MultiLineString", "POLYLINE");
module.exports.polygon = justType("Polygon", "POLYGON");
module.exports.multipolygon = justType("MultiPolygon", "POLYGON");

/**
 * Generate a function that returns an object with the geometries, properties, and type of the given GeoJSON type
 * @param {string} type the GeoJSON type
 * @param {string} TYPE the Shapefile type
 * @returns {(gj: { features: Feature[] }) => { geometries: number[] | number[][] | number[][][] | number[][][][], properties: {Object.<string, string>}, type: string }}
 */
function justType(gjType, shpType) {
  return function (gj) {
    var oftype = gj.features.filter(isType(gjType));
    return {
      geometries: shpType === 'POLYLINE' ? [oftype.map(justCoords)] : oftype.map(justCoords),
      properties: oftype.map(justProps),
      type: shpType,
    };
  };
}

/**
 * 
 * @param {Feature} feature The feature to get the coordinates from
 * @returns {number[] | number[][] | number[][][] | number[][][][]}
 */
function justCoords(feature) {
  return feature.geometry.coordinates;
}

/**
 * 
 * @param {Feature} feature The feature to get the properties from 
 * @returns {Object.<string, string>}
 */
function justProps(feature) {
  return feature.properties;
}

/**
 * Generate a function that filters features based on their geometry.type
 * @param {string | string[]} type the GeoJSON type to filter with
 * @returns {(f: Feature) => boolean} a function that returns true if the feature's type is in {@link type}
 */
function isType(type) {
  if (Array.isArray(type))
    return function (f) {
      return type.includes(f.geometry.type);
    };
  else
    return function (f) {
      return f.geometry.type === type;
    };
}

},{}],5:[function(require,module,exports){
var ext = require('./extent');

module.exports.write = function writePoints(coordinates, extent, shpView, shxView) {

    var contentLength = 28, // 8 header, 20 content
        fileLength = 100,
        shpI = 0,
        shxI = 0;

    coordinates.forEach(function writePoint(coords, i) {
        // HEADER
        // 4 record number
        // 4 content length in 16-bit words (20/2)
        shpView.setInt32(shpI, i + 1);
        shpView.setInt32(shpI + 4, 10);

        // record
        // (8 + 8) + 4 = 20 content length
        shpView.setInt32(shpI + 8, 1, true); // POINT=1
        shpView.setFloat64(shpI + 12, coords[0], true); // X
        shpView.setFloat64(shpI + 20, coords[1], true); // Y

        // index
        shxView.setInt32(shxI, fileLength / 2); // length in 16-bit words
        shxView.setInt32(shxI + 4, 10);

        shxI += 8;
        shpI += contentLength;
        fileLength += contentLength;
    });
};

module.exports.extent = function(coordinates) {
    return coordinates.reduce(function(extent, coords) {
        return ext.enlarge(extent, coords);
    }, ext.blank());
};

module.exports.parts = function parts(geometries, TYPE) {
    return geometries.length;
};

module.exports.shxLength = function(coordinates) {
    return coordinates.length * 8;
};

module.exports.shpLength = function(coordinates) {
    return coordinates.length * 28;
};

},{"./extent":3}],6:[function(require,module,exports){
var ext = require('./extent'),
    types = require('./types');

module.exports.write = function writePoints(geometries, extent, shpView, shxView, TYPE) {

    var shpI = 0,
        shxI = 0,
        shxOffset = 100;

    geometries.forEach(writePolyLine);

    function writePolyLine(coordinates, i) {

        var flattened = justCoords(coordinates),
            noParts = parts([coordinates], TYPE),
            contentLength = (flattened.length * 16) + 48 + (noParts - 1) * 4;

        var featureExtent = flattened.reduce(function(extent, c) {
            return ext.enlarge(extent, c);
        }, ext.blank());

        // INDEX
        shxView.setInt32(shxI, shxOffset / 2); // offset
        shxView.setInt32(shxI + 4, contentLength / 2); // offset length

        shxI += 8;
        shxOffset += contentLength + 8;

        shpView.setInt32(shpI, i + 1); // record number
        shpView.setInt32(shpI + 4, contentLength / 2); // length
        shpView.setInt32(shpI + 8, TYPE, true); // POLYLINE=3
        shpView.setFloat64(shpI + 12, featureExtent.xmin, true); // EXTENT
        shpView.setFloat64(shpI + 20, featureExtent.ymin, true);
        shpView.setFloat64(shpI + 28, featureExtent.xmax, true);
        shpView.setFloat64(shpI + 36, featureExtent.ymax, true);
        shpView.setInt32(shpI + 44, noParts, true);
        shpView.setInt32(shpI + 48, flattened.length, true); // POINTS
        shpView.setInt32(shpI + 52, 0, true); // The first part - index zero

        var onlyParts = coordinates.reduce(function (arr, coords) {
            if (Array.isArray(coords[0][0])) {
                arr = arr.concat(coords);
            } else {
                arr.push(coords);
            }
            return arr;
        }, []);
        for (var p = 1; p < noParts; p++) {
            shpView.setInt32( // set part index
                shpI + 52 + (p * 4),
                onlyParts.reduce(function (a, b, idx) {
                    return idx < p ? a + b.length : a;
                }, 0),
                true
            );
        }

        flattened.forEach(function writeLine(coords, i) {
            shpView.setFloat64(shpI + 56 + (i * 16) + (noParts - 1) * 4, coords[0], true); // X
            shpView.setFloat64(shpI + 56 + (i * 16) + (noParts - 1) * 4 + 8, coords[1], true); // Y
        });

        shpI += contentLength + 8;
    }
};

module.exports.shpLength = function(geometries) {
    return (geometries.length * 56) +
        // points
        (justCoords(geometries).length * 16);
};

module.exports.shxLength = function(geometries) {
    return geometries.length * 8;
};

module.exports.extent = function(coordinates) {
    return justCoords(coordinates).reduce(function(extent, c) {
        return ext.enlarge(extent, c);
    }, ext.blank());
};

function parts(geometries, TYPE) {
    var no = 1;
    if (TYPE === types.geometries.POLYGON || TYPE === types.geometries.POLYLINE)  {
        no = geometries.reduce(function (no, coords) {
            no += coords.length;
            if (Array.isArray(coords[0][0][0])) { // multi
                no += coords.reduce(function (no, rings) {
                    return no + rings.length - 1; // minus outer
                }, 0);
            }
            return no;
        }, 0);
    }
    return no;
}

module.exports.parts = parts;

function totalPoints(geometries) {
    var sum = 0;
    geometries.forEach(function(g) { sum += g.length; });
    return sum;
}

function justCoords(coords, l) {
    if (l === undefined) l = [];
    if (typeof coords[0][0] == 'object') {
        return coords.reduce(function(memo, c) {
            return memo.concat(justCoords(c));
        }, l);
    } else {
        return coords;
    }
}


},{"./extent":3,"./types":8}],7:[function(require,module,exports){
module.exports = 'GEOGCS["GCS_WGS_1984",DATUM["D_WGS_1984",SPHEROID["WGS_1984",6378137,298.257223563]],PRIMEM["Greenwich",0],UNIT["Degree",0.017453292519943295]]';

},{}],8:[function(require,module,exports){
module.exports.geometries = {
    NULL: 0,
    POINT: 1,
    POLYLINE: 3,
    POLYGON: 5,
    MULTIPOINT: 8,
    POINTZ: 11,
    POLYLINEZ: 13,
    POLYGONZ: 15,
    MULTIPOINTZ: 18,
    POINTM: 21,
    POLYLINEM: 23,
    POLYGONM: 25,
    MULTIPOINTM: 28,
    MULTIPATCH: 31,
};

},{}],9:[function(require,module,exports){
var types = require('./types');
var dbf = require('dbf');
var prj = require('./prj');
var pointWriter = require('./points');
var polyWriter = require('./poly');

var writers = {
    1: pointWriter,
    5: polyWriter,
    3: polyWriter
};

module.exports = write;

// Low-level writing interface
function write(rows, geometry_type, geometries, callback) {

    var TYPE = types.geometries[geometry_type];
    var writer = writers[TYPE];
    var parts = writer.parts(geometries, TYPE);
    var shpLength = 100 + (parts - geometries.length) * 4 + writer.shpLength(geometries);
    var shxLength = 100 + writer.shxLength(geometries);
    var shpBuffer = new ArrayBuffer(shpLength);
    var shpView = new DataView(shpBuffer);
    var shxBuffer = new ArrayBuffer(shxLength);
    var shxView = new DataView(shxBuffer);
    var extent = writer.extent(geometries);

    writeHeader(shpView, TYPE);
    writeHeader(shxView, TYPE);
    writeExtent(extent, shpView);
    writeExtent(extent, shxView);

    writer.write(geometries, extent,
        new DataView(shpBuffer, 100),
        new DataView(shxBuffer, 100),
        TYPE);

    shpView.setInt32(24, shpLength / 2);
    shxView.setInt32(24, (50 + geometries.length * 4));

    var dbfBuf = dbf.structure(rows);

    callback(null, {
        shp: shpView,
        shx: shxView,
        dbf: dbfBuf,
        prj: prj
    });
}

function writeHeader(view, TYPE) {
    view.setInt32(0, 9994);
    view.setInt32(28, 1000, true);
    view.setInt32(32, TYPE, true);
}

function writeExtent(extent, view) {
    view.setFloat64(36, extent.xmin, true);
    view.setFloat64(44, extent.ymin, true);
    view.setFloat64(52, extent.xmax, true);
    view.setFloat64(60, extent.ymax, true);
}

},{"./points":5,"./poly":6,"./prj":7,"./types":8,"dbf":13}],10:[function(require,module,exports){
var write = require("./write");
var geojson = require("./geojson");
var defaultPrj = require('./prj');
var JSZip = require("jszip");


module.exports = function (
  gj,
  options,
  stream = false
) {
  let zip = new JSZip();
  let zipTarget = zip;
  if (options && options.folder) {
    zipTarget = zip.folder(options.folder);
  }

  var prj = (options && options.prj) ? options.prj : defaultPrj;

  [
    geojson.point(gj),
    geojson.line(gj),
    geojson.polygon(gj),
    geojson.multipolygon(gj),
    geojson.multiline(gj),
  ].forEach(function (l) {
    if (l.geometries.length && l.geometries[0].length) {
      write(
        // field definitions
        l.properties,
        // geometry type
        l.type,
        // geometries
        l.geometries,
        function (err, files) {
          var fileName =
            options && options.types && options.types[l.type.toLowerCase()]
              ? options.types[l.type.toLowerCase()]
              : l.type;
          zipTarget.file(fileName + ".shp", files.shp.buffer, { binary: true });
          zipTarget.file(fileName + ".shx", files.shx.buffer, { binary: true });
          zipTarget.file(fileName + ".dbf", files.dbf.buffer, { binary: true });
          zipTarget.file(fileName + ".prj", prj);
        }
      );
    }
  });

  var zipOptions = {};
  if (!options || !options.outputType) {
    zipOptions.type = "base64";
  } else {
    zipOptions.type = options.outputType;
  }

  if (!options || !options.compression) {
    zipOptions.compression = "DEFLATE";
  } else {
    zipOptions.compression = options.compression;
  }

  if (stream) {
    return zip.generateNodeStream({ ...zipOptions, streamFiles: true });
  }

  return zip.generateAsync(zipOptions);
};

},{"./geojson":4,"./prj":7,"./write":9,"jszip":22}],11:[function(require,module,exports){
'use strict'

exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function getLens (b64) {
  var len = b64.length

  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // Trim off extra bytes after placeholder bytes are found
  // See: https://github.com/beatgammit/base64-js/issues/42
  var validLen = b64.indexOf('=')
  if (validLen === -1) validLen = len

  var placeHoldersLen = validLen === len
    ? 0
    : 4 - (validLen % 4)

  return [validLen, placeHoldersLen]
}

// base64 is 4/3 + up to two characters of the original data
function byteLength (b64) {
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function _byteLength (b64, validLen, placeHoldersLen) {
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function toByteArray (b64) {
  var tmp
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]

  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))

  var curByte = 0

  // if there are placeholders, only get up to the last complete 4 chars
  var len = placeHoldersLen > 0
    ? validLen - 4
    : validLen

  var i
  for (i = 0; i < len; i += 4) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 18) |
      (revLookup[b64.charCodeAt(i + 1)] << 12) |
      (revLookup[b64.charCodeAt(i + 2)] << 6) |
      revLookup[b64.charCodeAt(i + 3)]
    arr[curByte++] = (tmp >> 16) & 0xFF
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 2) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 2) |
      (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 1) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 10) |
      (revLookup[b64.charCodeAt(i + 1)] << 4) |
      (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] +
    lookup[num >> 12 & 0x3F] +
    lookup[num >> 6 & 0x3F] +
    lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp =
      ((uint8[i] << 16) & 0xFF0000) +
      ((uint8[i + 1] << 8) & 0xFF00) +
      (uint8[i + 2] & 0xFF)
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    parts.push(
      lookup[tmp >> 2] +
      lookup[(tmp << 4) & 0x3F] +
      '=='
    )
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
    parts.push(
      lookup[tmp >> 10] +
      lookup[(tmp >> 4) & 0x3F] +
      lookup[(tmp << 2) & 0x3F] +
      '='
    )
  }

  return parts.join('')
}

},{}],12:[function(require,module,exports){
(function (Buffer){(function (){
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */

'use strict'

var base64 = require('base64-js')
var ieee754 = require('ieee754')

exports.Buffer = Buffer
exports.SlowBuffer = SlowBuffer
exports.INSPECT_MAX_BYTES = 50

var K_MAX_LENGTH = 0x7fffffff
exports.kMaxLength = K_MAX_LENGTH

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */
Buffer.TYPED_ARRAY_SUPPORT = typedArraySupport()

if (!Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' &&
    typeof console.error === 'function') {
  console.error(
    'This browser lacks typed array (Uint8Array) support which is required by ' +
    '`buffer` v5.x. Use `buffer` v4.x if you require old browser support.'
  )
}

function typedArraySupport () {
  // Can typed array instances can be augmented?
  try {
    var arr = new Uint8Array(1)
    arr.__proto__ = { __proto__: Uint8Array.prototype, foo: function () { return 42 } }
    return arr.foo() === 42
  } catch (e) {
    return false
  }
}

Object.defineProperty(Buffer.prototype, 'parent', {
  enumerable: true,
  get: function () {
    if (!Buffer.isBuffer(this)) return undefined
    return this.buffer
  }
})

Object.defineProperty(Buffer.prototype, 'offset', {
  enumerable: true,
  get: function () {
    if (!Buffer.isBuffer(this)) return undefined
    return this.byteOffset
  }
})

function createBuffer (length) {
  if (length > K_MAX_LENGTH) {
    throw new RangeError('The value "' + length + '" is invalid for option "size"')
  }
  // Return an augmented `Uint8Array` instance
  var buf = new Uint8Array(length)
  buf.__proto__ = Buffer.prototype
  return buf
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new TypeError(
        'The "string" argument must be of type string. Received type number'
      )
    }
    return allocUnsafe(arg)
  }
  return from(arg, encodingOrOffset, length)
}

// Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
if (typeof Symbol !== 'undefined' && Symbol.species != null &&
    Buffer[Symbol.species] === Buffer) {
  Object.defineProperty(Buffer, Symbol.species, {
    value: null,
    configurable: true,
    enumerable: false,
    writable: false
  })
}

Buffer.poolSize = 8192 // not used by this implementation

function from (value, encodingOrOffset, length) {
  if (typeof value === 'string') {
    return fromString(value, encodingOrOffset)
  }

  if (ArrayBuffer.isView(value)) {
    return fromArrayLike(value)
  }

  if (value == null) {
    throw TypeError(
      'The first argument must be one of type string, Buffer, ArrayBuffer, Array, ' +
      'or Array-like Object. Received type ' + (typeof value)
    )
  }

  if (isInstance(value, ArrayBuffer) ||
      (value && isInstance(value.buffer, ArrayBuffer))) {
    return fromArrayBuffer(value, encodingOrOffset, length)
  }

  if (typeof value === 'number') {
    throw new TypeError(
      'The "value" argument must not be of type number. Received type number'
    )
  }

  var valueOf = value.valueOf && value.valueOf()
  if (valueOf != null && valueOf !== value) {
    return Buffer.from(valueOf, encodingOrOffset, length)
  }

  var b = fromObject(value)
  if (b) return b

  if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null &&
      typeof value[Symbol.toPrimitive] === 'function') {
    return Buffer.from(
      value[Symbol.toPrimitive]('string'), encodingOrOffset, length
    )
  }

  throw new TypeError(
    'The first argument must be one of type string, Buffer, ArrayBuffer, Array, ' +
    'or Array-like Object. Received type ' + (typeof value)
  )
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(value, encodingOrOffset, length)
}

// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Buffer.prototype.__proto__ = Uint8Array.prototype
Buffer.__proto__ = Uint8Array

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be of type number')
  } else if (size < 0) {
    throw new RangeError('The value "' + size + '" is invalid for option "size"')
  }
}

function alloc (size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(size).fill(fill, encoding)
      : createBuffer(size).fill(fill)
  }
  return createBuffer(size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(size, fill, encoding)
}

function allocUnsafe (size) {
  assertSize(size)
  return createBuffer(size < 0 ? 0 : checked(size) | 0)
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(size)
}

function fromString (string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('Unknown encoding: ' + encoding)
  }

  var length = byteLength(string, encoding) | 0
  var buf = createBuffer(length)

  var actual = buf.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual)
  }

  return buf
}

function fromArrayLike (array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  var buf = createBuffer(length)
  for (var i = 0; i < length; i += 1) {
    buf[i] = array[i] & 255
  }
  return buf
}

function fromArrayBuffer (array, byteOffset, length) {
  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('"offset" is outside of buffer bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('"length" is outside of buffer bounds')
  }

  var buf
  if (byteOffset === undefined && length === undefined) {
    buf = new Uint8Array(array)
  } else if (length === undefined) {
    buf = new Uint8Array(array, byteOffset)
  } else {
    buf = new Uint8Array(array, byteOffset, length)
  }

  // Return an augmented `Uint8Array` instance
  buf.__proto__ = Buffer.prototype
  return buf
}

function fromObject (obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    var buf = createBuffer(len)

    if (buf.length === 0) {
      return buf
    }

    obj.copy(buf, 0, 0, len)
    return buf
  }

  if (obj.length !== undefined) {
    if (typeof obj.length !== 'number' || numberIsNaN(obj.length)) {
      return createBuffer(0)
    }
    return fromArrayLike(obj)
  }

  if (obj.type === 'Buffer' && Array.isArray(obj.data)) {
    return fromArrayLike(obj.data)
  }
}

function checked (length) {
  // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= K_MAX_LENGTH) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + K_MAX_LENGTH.toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return b != null && b._isBuffer === true &&
    b !== Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
}

Buffer.compare = function compare (a, b) {
  if (isInstance(a, Uint8Array)) a = Buffer.from(a, a.offset, a.byteLength)
  if (isInstance(b, Uint8Array)) b = Buffer.from(b, b.offset, b.byteLength)
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError(
      'The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array'
    )
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!Array.isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = Buffer.allocUnsafe(length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (isInstance(buf, Uint8Array)) {
      buf = Buffer.from(buf)
    }
    if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    }
    buf.copy(buffer, pos)
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (ArrayBuffer.isView(string) || isInstance(string, ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    throw new TypeError(
      'The "string" argument must be one of type string, Buffer, or ArrayBuffer. ' +
      'Received type ' + typeof string
    )
  }

  var len = string.length
  var mustMatch = (arguments.length > 2 && arguments[2] === true)
  if (!mustMatch && len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) {
          return mustMatch ? -1 : utf8ToBytes(string).length // assume utf8
        }
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  var loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  var i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  var len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  var len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  var len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  var length = this.length
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.toLocaleString = Buffer.prototype.toString

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.INSPECT_MAX_BYTES
  str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim()
  if (this.length > max) str += ' ... '
  return '<Buffer ' + str + '>'
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (isInstance(target, Uint8Array)) {
    target = Buffer.from(target, target.offset, target.byteLength)
  }
  if (!Buffer.isBuffer(target)) {
    throw new TypeError(
      'The "target" argument must be one of type Buffer or Uint8Array. ' +
      'Received type ' + (typeof target)
    )
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  var x = thisEnd - thisStart
  var y = end - start
  var len = Math.min(x, y)

  var thisCopy = this.slice(thisStart, thisEnd)
  var targetCopy = target.slice(start, end)

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset // Coerce to Number.
  if (numberIsNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1
  var arrLength = arr.length
  var valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i
  if (dir) {
    var foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      var found = true
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  var strLen = string.length

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (numberIsNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function latin1Write (buf, string, offset, length) {
  return asciiWrite(buf, string, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset >>> 0
    if (isFinite(length)) {
      length = length >>> 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
        return asciiWrite(this, string, offset, length)

      case 'latin1':
      case 'binary':
        return latin1Write(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF) ? 4
      : (firstByte > 0xDF) ? 3
        : (firstByte > 0xBF) ? 2
          : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; ++i) {
    out += toHex(buf[i])
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  for (var i = 0; i < bytes.length; i += 2) {
    res += String.fromCharCode(bytes[i] + (bytes[i + 1] * 256))
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf = this.subarray(start, end)
  // Return an augmented `Uint8Array` instance
  newBuf.__proto__ = Buffer.prototype
  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  this[offset] = (value & 0xff)
  this[offset + 1] = (value >>> 8)
  return offset + 2
}

Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  this[offset] = (value >>> 8)
  this[offset + 1] = (value & 0xff)
  return offset + 2
}

Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  this[offset + 3] = (value >>> 24)
  this[offset + 2] = (value >>> 16)
  this[offset + 1] = (value >>> 8)
  this[offset] = (value & 0xff)
  return offset + 4
}

Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  this[offset] = (value >>> 24)
  this[offset + 1] = (value >>> 16)
  this[offset + 2] = (value >>> 8)
  this[offset + 3] = (value & 0xff)
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    var limit = Math.pow(2, (8 * byteLength) - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    var limit = Math.pow(2, (8 * byteLength) - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  this[offset] = (value & 0xff)
  this[offset + 1] = (value >>> 8)
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  this[offset] = (value >>> 8)
  this[offset + 1] = (value & 0xff)
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  this[offset] = (value & 0xff)
  this[offset + 1] = (value >>> 8)
  this[offset + 2] = (value >>> 16)
  this[offset + 3] = (value >>> 24)
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  this[offset] = (value >>> 24)
  this[offset + 1] = (value >>> 16)
  this[offset + 2] = (value >>> 8)
  this[offset + 3] = (value & 0xff)
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer')
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('Index out of range')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start

  if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') {
    // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end)
  } else if (this === target && start < targetStart && targetStart < end) {
    // descending copy from end
    for (var i = len - 1; i >= 0; --i) {
      target[i + targetStart] = this[i + start]
    }
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, end),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if ((encoding === 'utf8' && code < 128) ||
          encoding === 'latin1') {
        // Fast path: If `val` fits into a single byte, use that numeric value.
        val = code
      }
    }
  } else if (typeof val === 'number') {
    val = val & 255
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : Buffer.from(val, encoding)
    var len = bytes.length
    if (len === 0) {
      throw new TypeError('The value "' + val +
        '" is invalid for argument "value"')
    }
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node takes equal signs as end of the Base64 encoding
  str = str.split('=')[0]
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = str.trim().replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function toHex (n) {
  if (n < 16) return '0' + n.toString(16)
  return n.toString(16)
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function isInstance (obj, type) {
  return obj instanceof type ||
    (obj != null && obj.constructor != null && obj.constructor.name != null &&
      obj.constructor.name === type.name)
}
function numberIsNaN (obj) {
  // For IE11 support
  return obj !== obj // eslint-disable-line no-self-compare
}

}).call(this)}).call(this,require("buffer").Buffer)
},{"base64-js":11,"buffer":12,"ieee754":20}],13:[function(require,module,exports){
module.exports.structure = require('./src/structure');

},{"./src/structure":17}],14:[function(require,module,exports){
var fieldSize = require('./fieldsize');

var types = {
    string: 'C',
    number: 'N',
    boolean: 'L',
    // type to use if all values of a field are null
    null: 'C'
};

module.exports.multi = multi;
module.exports.bytesPer = bytesPer;
module.exports.obj = obj;

function multi(features) {
    var fields = {};
    features.forEach(collect);
    function collect(f) { inherit(fields, f); }
    return obj(fields);
}

/**
 * @param {Object} a
 * @param {Object} b
 * @returns {Object}
 */
function inherit(a, b) {
    for (var i in b) {
        var isDef = typeof b[i] !== 'undefined' && b[i] !== null;
        if (typeof a[i] === 'undefined' || isDef) {
          a[i] = b[i];
        }
    }
    return a;
}

function obj(_) {
    var fields = {}, o = [];
    for (var p in _) fields[p] = _[p] === null ? 'null' : typeof _[p];
    for (var n in fields) {
        var t = types[fields[n]];
        if(t){
             o.push({
                name: n,
                type: t,
                size: fieldSize[t]
            });
        }
    }
    return o;
}

/**
 * @param {Array} fields
 * @returns {Array}
 */
function bytesPer(fields) {
    // deleted flag
    return fields.reduce(function(memo, f) { return memo + f.size; }, 1);
}

},{"./fieldsize":15}],15:[function(require,module,exports){
module.exports = {
    // string
    C: 254,
    // boolean
    L: 1,
    // date
    D: 8,
    // number
    N: 18,
    // number
    M: 18,
    // number, float
    F: 18,
    // number
    B: 8,
};

},{}],16:[function(require,module,exports){
/**
 * @param {string} str
 * @param {number} len
 * @param {string} char
 * @returns {string}
 */
module.exports.lpad = function lpad(str, len, char) {
    while (str.length < len) { str = char + str; } return str;
};

/**
 * @param {string} str
 * @param {number} len
 * @param {string} char
 * @returns {string}
 */
module.exports.rpad = function rpad(str, len, char) {
    while (str.length < len) { str = str + char; } return str;
};

/**
 * @param {object} view
 * @param {number} fieldLength
 * @param {string} str
 * @param {number} offset
 * @returns {number}
 */
module.exports.writeField = function writeField(view, fieldLength, str, offset) {
    for (var i = 0; i < fieldLength; i++) {
        view.setUint8(offset, str.charCodeAt(i)); offset++;
    }
    return offset;
};

},{}],17:[function(require,module,exports){
var fieldSize = require('./fieldsize'),
    lib = require('./lib'),
    fields = require('./fields');

/**
 * @param {Array} data
 * @param {Array} meta
 * @returns {Object} view
 */
module.exports = function structure(data, meta) {

    var field_meta = meta || fields.multi(data),
        fieldDescLength = (32 * field_meta.length) + 1,
        bytesPerRecord = fields.bytesPer(field_meta), // deleted flag
        buffer = new ArrayBuffer(
            // field header
            fieldDescLength +
            // header
            32 +
            // contents
            (bytesPerRecord * data.length) +
            // EOF marker
            1
    ),
        now = new Date(),
        view = new DataView(buffer);

    // version number - dBase III
    view.setUint8(0, 0x03);
    // date of last update
    view.setUint8(1, now.getFullYear() - 1900);
    view.setUint8(2, now.getMonth() + 1);
    view.setUint8(3, now.getDate());
    // number of records
    view.setUint32(4, data.length, true);

    // length of header
    var headerLength = fieldDescLength + 32;
    view.setUint16(8, headerLength, true);
    // length of each record
    view.setUint16(10, bytesPerRecord, true);

    // Terminator
    view.setInt8(32 + fieldDescLength - 1, 0x0D);

    field_meta.forEach(function(f, i) {
        // field name
        f.name.split('').slice(0, 10).forEach(function(c, x) {
            view.setInt8(32 + i * 32 + x, c.charCodeAt(0));
        });
        // field type
        view.setInt8(32 + i * 32 + 11, f.type.charCodeAt(0));
        // field length
        view.setInt8(32 + i * 32 + 16, f.size);
        if (f.type == 'N') view.setInt8(32 + i * 32 + 17, 3);
    });

    var offset = fieldDescLength + 32;

    data.forEach(function(row, num) {
        // delete flag: this is not deleted
        view.setUint8(offset, 32);
        offset++;
        field_meta.forEach(function(f) {
            var val = row[f.name];
            if (val === null || typeof val === 'undefined') val = '';

            switch (f.type) {
                // boolean
                case 'L':
                    view.setUint8(offset, val ? 84 : 70);
                    offset++;
                    break;

                // date
                case 'D':
                    offset = lib.writeField(view, 8,
                        lib.lpad(val.toString(), 8, ' '), offset);
                    break;

                // number
                case 'N':
                    offset = lib.writeField(view, f.size,
                        lib.lpad(val.toString(), f.size, ' ').substr(0, 18),
                        offset);
                    break;

                // string
                case 'C':
                    offset = lib.writeField(view, f.size,
                        lib.rpad(val.toString(), f.size, ' '), offset);
                    break;

                default:
                    throw new Error('Unknown field type');
            }
        });
    });

    // EOF flag
    view.setUint8(offset, 0x1A);

    return view;
};

},{"./fields":14,"./fieldsize":15,"./lib":16}],18:[function(require,module,exports){
(function (global){(function (){
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define([], factory);
  } else if (typeof exports !== "undefined") {
    factory();
  } else {
    var mod = {
      exports: {}
    };
    factory();
    global.FileSaver = mod.exports;
  }
})(this, function () {
  "use strict";

  /*
  * FileSaver.js
  * A saveAs() FileSaver implementation.
  *
  * By Eli Grey, http://eligrey.com
  *
  * License : https://github.com/eligrey/FileSaver.js/blob/master/LICENSE.md (MIT)
  * source  : http://purl.eligrey.com/github/FileSaver.js
  */
  // The one and only way of getting global scope in all environments
  // https://stackoverflow.com/q/3277182/1008999
  var _global = typeof window === 'object' && window.window === window ? window : typeof self === 'object' && self.self === self ? self : typeof global === 'object' && global.global === global ? global : void 0;

  function bom(blob, opts) {
    if (typeof opts === 'undefined') opts = {
      autoBom: false
    };else if (typeof opts !== 'object') {
      console.warn('Deprecated: Expected third argument to be a object');
      opts = {
        autoBom: !opts
      };
    } // prepend BOM for UTF-8 XML and text/* types (including HTML)
    // note: your browser will automatically convert UTF-16 U+FEFF to EF BB BF

    if (opts.autoBom && /^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(blob.type)) {
      return new Blob([String.fromCharCode(0xFEFF), blob], {
        type: blob.type
      });
    }

    return blob;
  }

  function download(url, name, opts) {
    var xhr = new XMLHttpRequest();
    xhr.open('GET', url);
    xhr.responseType = 'blob';

    xhr.onload = function () {
      saveAs(xhr.response, name, opts);
    };

    xhr.onerror = function () {
      console.error('could not download file');
    };

    xhr.send();
  }

  function corsEnabled(url) {
    var xhr = new XMLHttpRequest(); // use sync to avoid popup blocker

    xhr.open('HEAD', url, false);

    try {
      xhr.send();
    } catch (e) {}

    return xhr.status >= 200 && xhr.status <= 299;
  } // `a.click()` doesn't work for all browsers (#465)


  function click(node) {
    try {
      node.dispatchEvent(new MouseEvent('click'));
    } catch (e) {
      var evt = document.createEvent('MouseEvents');
      evt.initMouseEvent('click', true, true, window, 0, 0, 0, 80, 20, false, false, false, false, 0, null);
      node.dispatchEvent(evt);
    }
  } // Detect WebView inside a native macOS app by ruling out all browsers
  // We just need to check for 'Safari' because all other browsers (besides Firefox) include that too
  // https://www.whatismybrowser.com/guides/the-latest-user-agent/macos


  var isMacOSWebView = _global.navigator && /Macintosh/.test(navigator.userAgent) && /AppleWebKit/.test(navigator.userAgent) && !/Safari/.test(navigator.userAgent);
  var saveAs = _global.saveAs || ( // probably in some web worker
  typeof window !== 'object' || window !== _global ? function saveAs() {}
  /* noop */
  // Use download attribute first if possible (#193 Lumia mobile) unless this is a macOS WebView
  : 'download' in HTMLAnchorElement.prototype && !isMacOSWebView ? function saveAs(blob, name, opts) {
    var URL = _global.URL || _global.webkitURL;
    var a = document.createElement('a');
    name = name || blob.name || 'download';
    a.download = name;
    a.rel = 'noopener'; // tabnabbing
    // TODO: detect chrome extensions & packaged apps
    // a.target = '_blank'

    if (typeof blob === 'string') {
      // Support regular links
      a.href = blob;

      if (a.origin !== location.origin) {
        corsEnabled(a.href) ? download(blob, name, opts) : click(a, a.target = '_blank');
      } else {
        click(a);
      }
    } else {
      // Support blobs
      a.href = URL.createObjectURL(blob);
      setTimeout(function () {
        URL.revokeObjectURL(a.href);
      }, 4E4); // 40s

      setTimeout(function () {
        click(a);
      }, 0);
    }
  } // Use msSaveOrOpenBlob as a second approach
  : 'msSaveOrOpenBlob' in navigator ? function saveAs(blob, name, opts) {
    name = name || blob.name || 'download';

    if (typeof blob === 'string') {
      if (corsEnabled(blob)) {
        download(blob, name, opts);
      } else {
        var a = document.createElement('a');
        a.href = blob;
        a.target = '_blank';
        setTimeout(function () {
          click(a);
        });
      }
    } else {
      navigator.msSaveOrOpenBlob(bom(blob, opts), name);
    }
  } // Fallback to using FileReader and a popup
  : function saveAs(blob, name, opts, popup) {
    // Open a popup immediately do go around popup blocker
    // Mostly only available on user interaction and the fileReader is async so...
    popup = popup || open('', '_blank');

    if (popup) {
      popup.document.title = popup.document.body.innerText = 'downloading...';
    }

    if (typeof blob === 'string') return download(blob, name, opts);
    var force = blob.type === 'application/octet-stream';

    var isSafari = /constructor/i.test(_global.HTMLElement) || _global.safari;

    var isChromeIOS = /CriOS\/[\d]+/.test(navigator.userAgent);

    if ((isChromeIOS || force && isSafari || isMacOSWebView) && typeof FileReader !== 'undefined') {
      // Safari doesn't allow downloading of blob URLs
      var reader = new FileReader();

      reader.onloadend = function () {
        var url = reader.result;
        url = isChromeIOS ? url : url.replace(/^data:[^;]*;/, 'data:attachment/file;');
        if (popup) popup.location.href = url;else location = url;
        popup = null; // reverse-tabnabbing #460
      };

      reader.readAsDataURL(blob);
    } else {
      var URL = _global.URL || _global.webkitURL;
      var url = URL.createObjectURL(blob);
      if (popup) popup.location = url;else location.href = url;
      popup = null; // reverse-tabnabbing #460

      setTimeout(function () {
        URL.revokeObjectURL(url);
      }, 4E4); // 40s
    }
  });
  _global.saveAs = saveAs.saveAs = saveAs;

  if (typeof module !== 'undefined') {
    module.exports = saveAs;
  }
});

}).call(this)}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],19:[function(require,module,exports){
(function (global){(function (){
(function(a,b){if("function"==typeof define&&define.amd)define([],b);else if("undefined"!=typeof exports)b();else{b(),a.FileSaver={exports:{}}.exports}})(this,function(){"use strict";function b(a,b){return"undefined"==typeof b?b={autoBom:!1}:"object"!=typeof b&&(console.warn("Deprecated: Expected third argument to be a object"),b={autoBom:!b}),b.autoBom&&/^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(a.type)?new Blob(["\uFEFF",a],{type:a.type}):a}function c(a,b,c){var d=new XMLHttpRequest;d.open("GET",a),d.responseType="blob",d.onload=function(){g(d.response,b,c)},d.onerror=function(){console.error("could not download file")},d.send()}function d(a){var b=new XMLHttpRequest;b.open("HEAD",a,!1);try{b.send()}catch(a){}return 200<=b.status&&299>=b.status}function e(a){try{a.dispatchEvent(new MouseEvent("click"))}catch(c){var b=document.createEvent("MouseEvents");b.initMouseEvent("click",!0,!0,window,0,0,0,80,20,!1,!1,!1,!1,0,null),a.dispatchEvent(b)}}var f="object"==typeof window&&window.window===window?window:"object"==typeof self&&self.self===self?self:"object"==typeof global&&global.global===global?global:void 0,a=f.navigator&&/Macintosh/.test(navigator.userAgent)&&/AppleWebKit/.test(navigator.userAgent)&&!/Safari/.test(navigator.userAgent),g=f.saveAs||("object"!=typeof window||window!==f?function(){}:"download"in HTMLAnchorElement.prototype&&!a?function(b,g,h){var i=f.URL||f.webkitURL,j=document.createElement("a");g=g||b.name||"download",j.download=g,j.rel="noopener","string"==typeof b?(j.href=b,j.origin===location.origin?e(j):d(j.href)?c(b,g,h):e(j,j.target="_blank")):(j.href=i.createObjectURL(b),setTimeout(function(){i.revokeObjectURL(j.href)},4E4),setTimeout(function(){e(j)},0))}:"msSaveOrOpenBlob"in navigator?function(f,g,h){if(g=g||f.name||"download","string"!=typeof f)navigator.msSaveOrOpenBlob(b(f,h),g);else if(d(f))c(f,g,h);else{var i=document.createElement("a");i.href=f,i.target="_blank",setTimeout(function(){e(i)})}}:function(b,d,e,g){if(g=g||open("","_blank"),g&&(g.document.title=g.document.body.innerText="downloading..."),"string"==typeof b)return c(b,d,e);var h="application/octet-stream"===b.type,i=/constructor/i.test(f.HTMLElement)||f.safari,j=/CriOS\/[\d]+/.test(navigator.userAgent);if((j||h&&i||a)&&"undefined"!=typeof FileReader){var k=new FileReader;k.onloadend=function(){var a=k.result;a=j?a:a.replace(/^data:[^;]*;/,"data:attachment/file;"),g?g.location.href=a:location=a,g=null},k.readAsDataURL(b)}else{var l=f.URL||f.webkitURL,m=l.createObjectURL(b);g?g.location=m:location.href=m,g=null,setTimeout(function(){l.revokeObjectURL(m)},4E4)}});f.saveAs=g.saveAs=g,"undefined"!=typeof module&&(module.exports=g)});


}).call(this)}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],20:[function(require,module,exports){
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = ((value * c) - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}

},{}],21:[function(require,module,exports){
/**
 * JSTS. See https://github.com/bjornharrtell/jsts
 * https://github.com/bjornharrtell/jsts/blob/master/LICENSE_EDLv1.txt
 * https://github.com/bjornharrtell/jsts/blob/master/LICENSE_EPLv1.txt
 * @license
 */
!function(t,e){"object"==typeof exports&&"undefined"!=typeof module?e(exports):"function"==typeof define&&define.amd?define(["exports"],e):e((t="undefined"!=typeof globalThis?globalThis:t||self).jsts={})}(this,(function(t){"use strict";class e{static equalsWithTolerance(t,e,s){return Math.abs(t-e)<=s}}class s extends Error{constructor(t){super(t),this.name=Object.keys({Exception:s})[0]}toString(){return this.message}}class n extends s{constructor(t){super(t),this.name=Object.keys({IllegalArgumentException:n})[0]}}class i{constructor(t,e){this.low=e||0,this.high=t||0}static toBinaryString(t){let e,s="";for(e=2147483648;e>0;e>>>=1)s+=(t.high&e)===e?"1":"0";for(e=2147483648;e>0;e>>>=1)s+=(t.low&e)===e?"1":"0";return s}}function r(){}function o(){}function l(){}r.NaN=NaN,r.isNaN=t=>Number.isNaN(t),r.isInfinite=t=>!Number.isFinite(t),r.MAX_VALUE=Number.MAX_VALUE,r.POSITIVE_INFINITY=Number.POSITIVE_INFINITY,r.NEGATIVE_INFINITY=Number.NEGATIVE_INFINITY,"function"==typeof Float64Array&&"function"==typeof Int32Array?function(){const t=2146435072,e=new Float64Array(1),s=new Int32Array(e.buffer);r.doubleToLongBits=function(n){e[0]=n;let r=0|s[0],o=0|s[1];return(o&t)===t&&1048575&o&&0!==r&&(r=0,o=2146959360),new i(o,r)},r.longBitsToDouble=function(t){return s[0]=t.low,s[1]=t.high,e[0]}}():function(){const t=1023,e=Math.log2,s=Math.floor,n=Math.pow,o=function(){for(let t=53;t>0;t--){const i=n(2,t)-1;if(s(e(i))+1===t)return i}return 0}();r.doubleToLongBits=function(r){let l,a,c,h,u,g,d,_,p;if(r<0||1/r===Number.NEGATIVE_INFINITY?(g=1<<31,r=-r):g=0,0===r)return p=0,_=g,new i(_,p);if(r===1/0)return p=0,_=2146435072|g,new i(_,p);if(r!=r)return p=0,_=2146959360,new i(_,p);if(h=0,p=0,l=s(r),l>1)if(l<=o)h=s(e(l)),h<=20?(p=0,_=l<<20-h&1048575):(c=h-20,a=n(2,c),p=l%a<<32-c,_=l/a&1048575);else for(c=l,p=0;a=c/2,c=s(a),0!==c;)h++,p>>>=1,p|=(1&_)<<31,_>>>=1,a!==c&&(_|=524288);if(d=h+t,u=0===l,l=r-l,h<52&&0!==l)for(c=0;;){if(a=2*l,a>=1?(l=a-1,u?(d--,u=!1):(c<<=1,c|=1,h++)):(l=a,u?0==--d&&(h++,u=!1):(c<<=1,h++)),20===h)_|=c,c=0;else if(52===h){p|=c;break}if(1===a){h<20?_|=c<<20-h:h<52&&(p|=c<<52-h);break}}return _|=d<<20,_|=g,new i(_,p)},r.longBitsToDouble=function(e){let s,i,r,o;const l=e.high,a=e.low,c=l&1<<31?-1:1;for(r=((2146435072&l)>>20)-t,o=0,i=1<<19,s=1;s<=20;s++)l&i&&(o+=n(2,-s)),i>>>=1;for(i=1<<31,s=21;s<=52;s++)a&i&&(o+=n(2,-s)),i>>>=1;if(-1023===r){if(0===o)return 0*c;r=-1022}else{if(1024===r)return 0===o?c/0:NaN;o+=1}return c*o*n(2,r)}}();class a extends s{constructor(t){super(t),this.name=Object.keys({RuntimeException:a})[0]}}class c extends a{constructor(){super(),c.constructor_.apply(this,arguments)}static constructor_(){if(0===arguments.length)a.constructor_.call(this);else if(1===arguments.length){const t=arguments[0];a.constructor_.call(this,t)}}}class h{static isTrue(){if(1===arguments.length){const t=arguments[0];h.isTrue(t,null)}else if(2===arguments.length){const t=arguments[1];if(!arguments[0])throw null===t?new c:new c(t)}}static shouldNeverReachHere(){if(0===arguments.length)h.shouldNeverReachHere(null);else if(1===arguments.length){const t=arguments[0];throw new c("Should never reach here"+(null!==t?": "+t:""))}}static equals(){if(2===arguments.length){const t=arguments[0],e=arguments[1];h.equals(t,e,null)}else if(3===arguments.length){const t=arguments[0],e=arguments[1],s=arguments[2];if(!e.equals(t))throw new c("Expected "+t+" but encountered "+e+(null!==s?": "+s:""))}}}function u(){}function g(){}const d=new ArrayBuffer(8),_=new Float64Array(d),p=new Int32Array(d);class m{constructor(){m.constructor_.apply(this,arguments)}static constructor_(){if(this.x=null,this.y=null,this.z=null,0===arguments.length)m.constructor_.call(this,0,0);else if(1===arguments.length){const t=arguments[0];m.constructor_.call(this,t.x,t.y,t.getZ())}else if(2===arguments.length){const t=arguments[0],e=arguments[1];m.constructor_.call(this,t,e,m.NULL_ORDINATE)}else if(3===arguments.length){const t=arguments[0],e=arguments[1],s=arguments[2];this.x=t,this.y=e,this.z=s}}static hashCode(t){return _[0]=t,p[0]^p[1]}equals2D(){if(1===arguments.length){const t=arguments[0];return this.x===t.x&&this.y===t.y}if(2===arguments.length){const t=arguments[0],s=arguments[1];return!!e.equalsWithTolerance(this.x,t.x,s)&&!!e.equalsWithTolerance(this.y,t.y,s)}}setM(t){throw new n("Invalid ordinate index: "+m.M)}equals3D(t){return this.x===t.x&&this.y===t.y&&(this.getZ()===t.getZ()||r.isNaN(this.getZ())&&r.isNaN(t.getZ()))}setX(t){this.x=t}compareTo(t){const e=t;return this.x<e.x?-1:this.x>e.x?1:this.y<e.y?-1:this.y>e.y?1:0}getX(){return this.x}copy(){return new m(this)}toString(){return"("+this.x+", "+this.y+", "+this.getZ()+")"}distance3D(t){const e=this.x-t.x,s=this.y-t.y,n=this.getZ()-t.getZ();return Math.sqrt(e*e+s*s+n*n)}getY(){return this.y}getM(){return r.NaN}setOrdinate(t,e){switch(t){case m.X:this.x=e;break;case m.Y:this.y=e;break;case m.Z:this.setZ(e);break;default:throw new n("Invalid ordinate index: "+t)}}getZ(){return this.z}getOrdinate(t){switch(t){case m.X:return this.x;case m.Y:return this.y;case m.Z:return this.getZ()}throw new n("Invalid ordinate index: "+t)}equals(t){return t instanceof m&&this.equals2D(t)}equalInZ(t,s){return e.equalsWithTolerance(this.getZ(),t.getZ(),s)}setZ(t){this.z=t}clone(){try{return null}catch(t){if(t instanceof CloneNotSupportedException)return h.shouldNeverReachHere("this shouldn't happen because this class is Cloneable"),null;throw t}}setY(t){this.y=t}distance(t){const e=this.x-t.x,s=this.y-t.y;return Math.sqrt(e*e+s*s)}hashCode(){let t=17;return t=37*t+m.hashCode(this.x),t=37*t+m.hashCode(this.y),t}setCoordinate(t){this.x=t.x,this.y=t.y,this.z=t.getZ()}get interfaces_(){return[o,u,l]}}class f{constructor(){f.constructor_.apply(this,arguments)}static constructor_(){if(this._dimensionsToTest=2,0===arguments.length)f.constructor_.call(this,2);else if(1===arguments.length){const t=arguments[0];if(2!==t&&3!==t)throw new n("only 2 or 3 dimensions may be specified");this._dimensionsToTest=t}}static compare(t,e){return t<e?-1:t>e?1:r.isNaN(t)?r.isNaN(e)?0:-1:r.isNaN(e)?1:0}compare(t,e){const s=f.compare(t.x,e.x);if(0!==s)return s;const n=f.compare(t.y,e.y);if(0!==n)return n;if(this._dimensionsToTest<=2)return 0;return f.compare(t.getZ(),e.getZ())}get interfaces_(){return[g]}}m.DimensionalComparator=f,m.NULL_ORDINATE=r.NaN,m.X=0,m.Y=1,m.Z=2,m.M=3;class y extends m{constructor(){super(),y.constructor_.apply(this,arguments)}static constructor_(){if(0===arguments.length)m.constructor_.call(this);else if(1===arguments.length){if(arguments[0]instanceof y){const t=arguments[0];m.constructor_.call(this,t.x,t.y)}else if(arguments[0]instanceof m){const t=arguments[0];m.constructor_.call(this,t.x,t.y)}}else if(2===arguments.length){const t=arguments[0],e=arguments[1];m.constructor_.call(this,t,e,m.NULL_ORDINATE)}}setOrdinate(t,e){switch(t){case y.X:this.x=e;break;case y.Y:this.y=e;break;default:throw new n("Invalid ordinate index: "+t)}}setZ(t){throw new n("CoordinateXY dimension 2 does not support z-ordinate")}copy(){return new y(this)}toString(){return"("+this.x+", "+this.y+")"}setCoordinate(t){this.x=t.x,this.y=t.y,this.z=t.getZ()}getZ(){return m.NULL_ORDINATE}getOrdinate(t){switch(t){case y.X:return this.x;case y.Y:return this.y}throw new n("Invalid ordinate index: "+t)}}y.X=0,y.Y=1,y.Z=-1,y.M=-1;class x extends m{constructor(){super(),x.constructor_.apply(this,arguments)}static constructor_(){if(this._m=null,0===arguments.length)m.constructor_.call(this),this._m=0;else if(1===arguments.length){if(arguments[0]instanceof x){const t=arguments[0];m.constructor_.call(this,t.x,t.y),this._m=t._m}else if(arguments[0]instanceof m){const t=arguments[0];m.constructor_.call(this,t.x,t.y),this._m=this.getM()}}else if(3===arguments.length){const t=arguments[0],e=arguments[1],s=arguments[2];m.constructor_.call(this,t,e,m.NULL_ORDINATE),this._m=s}}setM(t){this._m=t}setZ(t){throw new n("CoordinateXY dimension 2 does not support z-ordinate")}copy(){return new x(this)}toString(){return"("+this.x+", "+this.y+" m="+this.getM()+")"}setCoordinate(t){this.x=t.x,this.y=t.y,this.z=t.getZ(),this._m=t.getM()}getM(){return this._m}setOrdinate(t,e){switch(t){case x.X:this.x=e;break;case x.Y:this.y=e;break;case x.M:this._m=e;break;default:throw new n("Invalid ordinate index: "+t)}}getZ(){return m.NULL_ORDINATE}getOrdinate(t){switch(t){case x.X:return this.x;case x.Y:return this.y;case x.M:return this._m}throw new n("Invalid ordinate index: "+t)}}x.X=0,x.Y=1,x.Z=-1,x.M=2;class E extends m{constructor(){super(),E.constructor_.apply(this,arguments)}static constructor_(){if(this._m=null,0===arguments.length)m.constructor_.call(this),this._m=0;else if(1===arguments.length){if(arguments[0]instanceof E){const t=arguments[0];m.constructor_.call(this,t),this._m=t._m}else if(arguments[0]instanceof m){const t=arguments[0];m.constructor_.call(this,t),this._m=this.getM()}}else if(4===arguments.length){const t=arguments[0],e=arguments[1],s=arguments[2],n=arguments[3];m.constructor_.call(this,t,e,s),this._m=n}}setM(t){this._m=t}getOrdinate(t){switch(t){case m.X:return this.x;case m.Y:return this.y;case m.Z:return this.getZ();case m.M:return this.getM()}throw new n("Invalid ordinate index: "+t)}copy(){return new E(this)}toString(){return"("+this.x+", "+this.y+", "+this.getZ()+" m="+this.getM()+")"}setCoordinate(t){this.x=t.x,this.y=t.y,this.z=t.getZ(),this._m=t.getM()}getM(){return this._m}setOrdinate(t,e){switch(t){case m.X:this.x=e;break;case m.Y:this.y=e;break;case m.Z:this.z=e;break;case m.M:this._m=e;break;default:throw new n("Invalid ordinate index: "+t)}}}function I(t,e){return t.interfaces_&&t.interfaces_.indexOf(e)>-1}class N{add(){}addAll(){}isEmpty(){}iterator(){}size(){}toArray(){}remove(){}}class w extends s{constructor(t){super(t),this.name=Object.keys({IndexOutOfBoundsException:w})[0]}}class C extends N{get(){}set(){}isEmpty(){}}class S extends s{constructor(t){super(t),this.name=Object.keys({NoSuchElementException:S})[0]}}class L extends C{constructor(t){super(),this.array=[],t instanceof N&&this.addAll(t)}get interfaces_(){return[C,N]}ensureCapacity(){}add(t){return 1===arguments.length?this.array.push(t):this.array.splice(arguments[0],0,arguments[1]),!0}clear(){this.array=[]}addAll(t){for(const e of t)this.array.push(e)}set(t,e){const s=this.array[t];return this.array[t]=e,s}iterator(){return new T(this)}get(t){if(t<0||t>=this.size())throw new w;return this.array[t]}isEmpty(){return 0===this.array.length}sort(t){t?this.array.sort(((e,s)=>t.compare(e,s))):this.array.sort()}size(){return this.array.length}toArray(){return this.array.slice()}remove(t){for(let e=0,s=this.array.length;e<s;e++)if(this.array[e]===t)return!!this.array.splice(e,1);return!1}[Symbol.iterator](){return this.array.values()}}let T=class{constructor(t){this.arrayList=t,this.position=0}next(){if(this.position===this.arrayList.size())throw new S;return this.arrayList.get(this.position++)}hasNext(){return this.position<this.arrayList.size()}set(t){return this.arrayList.set(this.position-1,t)}remove(){this.arrayList.remove(this.arrayList.get(this.position))}};class R extends L{constructor(){super(),R.constructor_.apply(this,arguments)}static constructor_(){if(0===arguments.length);else if(1===arguments.length){const t=arguments[0];this.ensureCapacity(t.length),this.add(t,!0)}else if(2===arguments.length){const t=arguments[0],e=arguments[1];this.ensureCapacity(t.length),this.add(t,e)}}getCoordinate(t){return this.get(t)}addAll(){if(2===arguments.length&&"boolean"==typeof arguments[1]&&I(arguments[0],N)){const t=arguments[1];let e=!1;for(let s=arguments[0].iterator();s.hasNext();)this.add(s.next(),t),e=!0;return e}return super.addAll.apply(this,arguments)}clone(){const t=super.clone.call(this);for(let e=0;e<this.size();e++)t.add(e,this.get(e).clone());return t}closeRing(){if(this.size()>0){const t=this.get(0).copy();this.add(t,!1)}}toCoordinateArray(){if(0===arguments.length)return this.toArray(R.coordArrayType);if(1===arguments.length){if(arguments[0])return this.toArray(R.coordArrayType);const t=this.size(),e=new Array(t).fill(null);for(let s=0;s<t;s++)e[s]=this.get(t-s-1);return e}}add(){if(1===arguments.length){const t=arguments[0];return super.add.call(this,t)}if(2===arguments.length){if(arguments[0]instanceof Array&&"boolean"==typeof arguments[1]){const t=arguments[0],e=arguments[1];return this.add(t,e,!0),!0}if(arguments[0]instanceof m&&"boolean"==typeof arguments[1]){const t=arguments[0];if(!arguments[1]&&this.size()>=1){if(this.get(this.size()-1).equals2D(t))return null}super.add.call(this,t)}else if(arguments[0]instanceof Object&&"boolean"==typeof arguments[1]){const t=arguments[0],e=arguments[1];return this.add(t,e),!0}}else if(3===arguments.length){if("boolean"==typeof arguments[2]&&arguments[0]instanceof Array&&"boolean"==typeof arguments[1]){const t=arguments[0],e=arguments[1];if(arguments[2])for(let s=0;s<t.length;s++)this.add(t[s],e);else for(let s=t.length-1;s>=0;s--)this.add(t[s],e);return!0}if("boolean"==typeof arguments[2]&&Number.isInteger(arguments[0])&&arguments[1]instanceof m){const t=arguments[0],e=arguments[1];if(!arguments[2]){const s=this.size();if(s>0){if(t>0){if(this.get(t-1).equals2D(e))return null}if(t<s){if(this.get(t).equals2D(e))return null}}}super.add.call(this,t,e)}}else if(4===arguments.length){const t=arguments[0],e=arguments[1],s=arguments[2],n=arguments[3];let i=1;s>n&&(i=-1);for(let r=s;r!==n;r+=i)this.add(t[r],e);return!0}}}R.coordArrayType=new Array(0).fill(null);class P{filter(t,e){}isGeometryChanged(){}isDone(){}}class O{constructor(){O.constructor_.apply(this,arguments)}static constructor_(){if(this._minx=null,this._maxx=null,this._miny=null,this._maxy=null,0===arguments.length)this.init();else if(1===arguments.length){if(arguments[0]instanceof m){const t=arguments[0];this.init(t.x,t.x,t.y,t.y)}else if(arguments[0]instanceof O){const t=arguments[0];this.init(t)}}else if(2===arguments.length){const t=arguments[0],e=arguments[1];this.init(t.x,e.x,t.y,e.y)}else if(4===arguments.length){const t=arguments[0],e=arguments[1],s=arguments[2],n=arguments[3];this.init(t,e,s,n)}}static intersects(){if(3===arguments.length){const t=arguments[0],e=arguments[1],s=arguments[2];return s.x>=(t.x<e.x?t.x:e.x)&&s.x<=(t.x>e.x?t.x:e.x)&&s.y>=(t.y<e.y?t.y:e.y)&&s.y<=(t.y>e.y?t.y:e.y)}if(4===arguments.length){const t=arguments[0],e=arguments[1],s=arguments[2],n=arguments[3];let i=Math.min(s.x,n.x),r=Math.max(s.x,n.x),o=Math.min(t.x,e.x),l=Math.max(t.x,e.x);return!(o>r)&&(!(l<i)&&(i=Math.min(s.y,n.y),r=Math.max(s.y,n.y),o=Math.min(t.y,e.y),l=Math.max(t.y,e.y),!(o>r)&&!(l<i)))}}getArea(){return this.getWidth()*this.getHeight()}getMinX(){return this._minx}expandToInclude(){if(1===arguments.length){if(arguments[0]instanceof m){const t=arguments[0];this.expandToInclude(t.x,t.y)}else if(arguments[0]instanceof O){const t=arguments[0];if(t.isNull())return null;this.isNull()?(this._minx=t.getMinX(),this._maxx=t.getMaxX(),this._miny=t.getMinY(),this._maxy=t.getMaxY()):(t._minx<this._minx&&(this._minx=t._minx),t._maxx>this._maxx&&(this._maxx=t._maxx),t._miny<this._miny&&(this._miny=t._miny),t._maxy>this._maxy&&(this._maxy=t._maxy))}}else if(2===arguments.length){const t=arguments[0],e=arguments[1];this.isNull()?(this._minx=t,this._maxx=t,this._miny=e,this._maxy=e):(t<this._minx&&(this._minx=t),t>this._maxx&&(this._maxx=t),e<this._miny&&(this._miny=e),e>this._maxy&&(this._maxy=e))}}compareTo(t){const e=t;return this.isNull()?e.isNull()?0:-1:e.isNull()?1:this._minx<e._minx?-1:this._minx>e._minx?1:this._miny<e._miny?-1:this._miny>e._miny?1:this._maxx<e._maxx?-1:this._maxx>e._maxx?1:this._maxy<e._maxy?-1:this._maxy>e._maxy?1:0}translate(t,e){if(this.isNull())return null;this.init(this.getMinX()+t,this.getMaxX()+t,this.getMinY()+e,this.getMaxY()+e)}copy(){return new O(this)}expandBy(){if(1===arguments.length){const t=arguments[0];this.expandBy(t,t)}else if(2===arguments.length){const t=arguments[0],e=arguments[1];if(this.isNull())return null;this._minx-=t,this._maxx+=t,this._miny-=e,this._maxy+=e,(this._minx>this._maxx||this._miny>this._maxy)&&this.setToNull()}}contains(){if(1===arguments.length){if(arguments[0]instanceof O){const t=arguments[0];return this.covers(t)}if(arguments[0]instanceof m){const t=arguments[0];return this.covers(t)}}else if(2===arguments.length){const t=arguments[0],e=arguments[1];return this.covers(t,e)}}hashCode(){let t=17;return t=37*t+m.hashCode(this._minx),t=37*t+m.hashCode(this._maxx),t=37*t+m.hashCode(this._miny),t=37*t+m.hashCode(this._maxy),t}equals(t){if(!(t instanceof O))return!1;const e=t;return this.isNull()?e.isNull():this._maxx===e.getMaxX()&&this._maxy===e.getMaxY()&&this._minx===e.getMinX()&&this._miny===e.getMinY()}intersection(t){if(this.isNull()||t.isNull()||!this.intersects(t))return new O;const e=this._minx>t._minx?this._minx:t._minx,s=this._miny>t._miny?this._miny:t._miny,n=this._maxx<t._maxx?this._maxx:t._maxx,i=this._maxy<t._maxy?this._maxy:t._maxy;return new O(e,n,s,i)}isNull(){return this._maxx<this._minx}getMaxX(){return this._maxx}covers(){if(1===arguments.length){if(arguments[0]instanceof m){const t=arguments[0];return this.covers(t.x,t.y)}if(arguments[0]instanceof O){const t=arguments[0];return!this.isNull()&&!t.isNull()&&(t.getMinX()>=this._minx&&t.getMaxX()<=this._maxx&&t.getMinY()>=this._miny&&t.getMaxY()<=this._maxy)}}else if(2===arguments.length){const t=arguments[0],e=arguments[1];return!this.isNull()&&(t>=this._minx&&t<=this._maxx&&e>=this._miny&&e<=this._maxy)}}intersects(){if(1===arguments.length){if(arguments[0]instanceof O){const t=arguments[0];return!this.isNull()&&!t.isNull()&&!(t._minx>this._maxx||t._maxx<this._minx||t._miny>this._maxy||t._maxy<this._miny)}if(arguments[0]instanceof m){const t=arguments[0];return this.intersects(t.x,t.y)}}else if(2===arguments.length){if(arguments[0]instanceof m&&arguments[1]instanceof m){const t=arguments[0],e=arguments[1];if(this.isNull())return!1;if((t.x<e.x?t.x:e.x)>this._maxx)return!1;if((t.x>e.x?t.x:e.x)<this._minx)return!1;if((t.y<e.y?t.y:e.y)>this._maxy)return!1;return!((t.y>e.y?t.y:e.y)<this._miny)}if("number"==typeof arguments[0]&&"number"==typeof arguments[1]){const t=arguments[0],e=arguments[1];return!this.isNull()&&!(t>this._maxx||t<this._minx||e>this._maxy||e<this._miny)}}}getMinY(){return this._miny}getDiameter(){if(this.isNull())return 0;const t=this.getWidth(),e=this.getHeight();return Math.sqrt(t*t+e*e)}minExtent(){if(this.isNull())return 0;const t=this.getWidth(),e=this.getHeight();return t<e?t:e}getWidth(){return this.isNull()?0:this._maxx-this._minx}toString(){return"Env["+this._minx+" : "+this._maxx+", "+this._miny+" : "+this._maxy+"]"}setToNull(){this._minx=0,this._maxx=-1,this._miny=0,this._maxy=-1}disjoint(t){return!(!this.isNull()&&!t.isNull())||(t._minx>this._maxx||t._maxx<this._minx||t._miny>this._maxy||t._maxy<this._miny)}getHeight(){return this.isNull()?0:this._maxy-this._miny}maxExtent(){if(this.isNull())return 0;const t=this.getWidth(),e=this.getHeight();return t>e?t:e}centre(){return this.isNull()?null:new m((this.getMinX()+this.getMaxX())/2,(this.getMinY()+this.getMaxY())/2)}init(){if(0===arguments.length)this.setToNull();else if(1===arguments.length){if(arguments[0]instanceof m){const t=arguments[0];this.init(t.x,t.x,t.y,t.y)}else if(arguments[0]instanceof O){const t=arguments[0];this._minx=t._minx,this._maxx=t._maxx,this._miny=t._miny,this._maxy=t._maxy}}else if(2===arguments.length){const t=arguments[0],e=arguments[1];this.init(t.x,e.x,t.y,e.y)}else if(4===arguments.length){const t=arguments[0],e=arguments[1],s=arguments[2],n=arguments[3];t<e?(this._minx=t,this._maxx=e):(this._minx=e,this._maxx=t),s<n?(this._miny=s,this._maxy=n):(this._miny=n,this._maxy=s)}}getMaxY(){return this._maxy}distance(t){if(this.intersects(t))return 0;let e=0;this._maxx<t._minx?e=t._minx-this._maxx:this._minx>t._maxx&&(e=this._minx-t._maxx);let s=0;return this._maxy<t._miny?s=t._miny-this._maxy:this._miny>t._maxy&&(s=this._miny-t._maxy),0===e?s:0===s?e:Math.sqrt(e*e+s*s)}get interfaces_(){return[o,l]}}class v{constructor(t){this.str=t}append(t){this.str+=t}setCharAt(t,e){this.str=this.str.substr(0,t)+e+this.str.substr(t+1)}toString(){return this.str}}class M{constructor(t){this.value=t}intValue(){return this.value}compareTo(t){return this.value<t?-1:this.value>t?1:0}static compare(t,e){return t<e?-1:t>e?1:0}static isNan(t){return Number.isNaN(t)}static valueOf(t){return new M(t)}}class b{static isWhitespace(t){return t<=32&&t>=0||127===t}static toUpperCase(t){return t.toUpperCase()}}class D extends s{constructor(t){super(t),this.name=Object.keys({IllegalStateException:D})[0]}}class A{constructor(){A.constructor_.apply(this,arguments)}static constructor_(){if(this._hi=0,this._lo=0,0===arguments.length)this.init(0);else if(1===arguments.length){if("number"==typeof arguments[0]){const t=arguments[0];this.init(t)}else if(arguments[0]instanceof A){const t=arguments[0];this.init(t)}else if("string"==typeof arguments[0]){const t=arguments[0];A.constructor_.call(this,A.parse(t))}}else if(2===arguments.length){const t=arguments[0],e=arguments[1];this.init(t,e)}}static determinant(){if("number"==typeof arguments[3]&&"number"==typeof arguments[2]&&"number"==typeof arguments[0]&&"number"==typeof arguments[1]){const t=arguments[0],e=arguments[1],s=arguments[2],n=arguments[3];return A.determinant(A.valueOf(t),A.valueOf(e),A.valueOf(s),A.valueOf(n))}if(arguments[3]instanceof A&&arguments[2]instanceof A&&arguments[0]instanceof A&&arguments[1]instanceof A){const t=arguments[1],e=arguments[2],s=arguments[3];return arguments[0].multiply(s).selfSubtract(t.multiply(e))}}static sqr(t){return A.valueOf(t).selfMultiply(t)}static valueOf(){if("string"==typeof arguments[0]){const t=arguments[0];return A.parse(t)}if("number"==typeof arguments[0]){return new A(arguments[0])}}static sqrt(t){return A.valueOf(t).sqrt()}static parse(t){let e=0;const s=t.length;for(;b.isWhitespace(t.charAt(e));)e++;let n=!1;if(e<s){const s=t.charAt(e);"-"!==s&&"+"!==s||(e++,"-"===s&&(n=!0))}const i=new A;let r=0,o=0,l=0,a=!1;for(;!(e>=s);){const s=t.charAt(e);if(e++,b.isDigit(s)){const t=s-"0";i.selfMultiply(A.TEN),i.selfAdd(t),r++}else{if("."!==s){if("e"===s||"E"===s){const s=t.substring(e);try{l=M.parseInt(s)}catch(e){throw e instanceof NumberFormatException?new NumberFormatException("Invalid exponent "+s+" in string "+t):e}break}throw new NumberFormatException("Unexpected character '"+s+"' at position "+e+" in string "+t)}o=r,a=!0}}let c=i;a||(o=r);const h=r-o-l;if(0===h)c=i;else if(h>0){const t=A.TEN.pow(h);c=i.divide(t)}else if(h<0){const t=A.TEN.pow(-h);c=i.multiply(t)}return n?c.negate():c}static createNaN(){return new A(r.NaN,r.NaN)}static copy(t){return new A(t)}static magnitude(t){const e=Math.abs(t),s=Math.log(e)/Math.log(10);let n=Math.trunc(Math.floor(s));return 10*Math.pow(10,n)<=e&&(n+=1),n}static stringOfChar(t,e){const s=new v;for(let n=0;n<e;n++)s.append(t);return s.toString()}le(t){return this._hi<t._hi||this._hi===t._hi&&this._lo<=t._lo}extractSignificantDigits(t,e){let s=this.abs(),n=A.magnitude(s._hi);const i=A.TEN.pow(n);s=s.divide(i),s.gt(A.TEN)?(s=s.divide(A.TEN),n+=1):s.lt(A.ONE)&&(s=s.multiply(A.TEN),n-=1);const r=n+1,o=new v,l=A.MAX_PRINT_DIGITS-1;for(let e=0;e<=l;e++){t&&e===r&&o.append(".");const n=Math.trunc(s._hi);if(n<0)break;let i=!1,a=0;n>9?(i=!0,a="9"):a="0"+n,o.append(a),s=s.subtract(A.valueOf(n)).multiply(A.TEN),i&&s.selfAdd(A.TEN);let c=!0;const h=A.magnitude(s._hi);if(h<0&&Math.abs(h)>=l-e&&(c=!1),!c)break}return e[0]=n,o.toString()}sqr(){return this.multiply(this)}getSpecialNumberString(){return this.isZero()?"0.0":this.isNaN()?"NaN ":null}setValue(){if(arguments[0]instanceof A){const t=arguments[0];return this.init(t),this}if("number"==typeof arguments[0]){const t=arguments[0];return this.init(t),this}}multiply(){if(arguments[0]instanceof A){const t=arguments[0];return t.isNaN()?A.createNaN():A.copy(this).selfMultiply(t)}if("number"==typeof arguments[0]){const t=arguments[0];return r.isNaN(t)?A.createNaN():A.copy(this).selfMultiply(t,0)}}isNaN(){return r.isNaN(this._hi)}reciprocal(){let t=null,e=null,s=null,n=null,i=null,r=null,o=null,l=null;i=1/this._hi,r=A.SPLIT*i,t=r-i,l=A.SPLIT*this._hi,t=r-t,e=i-t,s=l-this._hi,o=i*this._hi,s=l-s,n=this._hi-s,l=t*s-o+t*n+e*s+e*n,r=(1-o-l-i*this._lo)/this._hi;const a=i+r;return new A(a,i-a+r)}doubleValue(){return this._hi+this._lo}subtract(){if(arguments[0]instanceof A){const t=arguments[0];return this.add(t.negate())}if("number"==typeof arguments[0]){const t=arguments[0];return this.add(-t)}}equals(){if(1===arguments.length&&arguments[0]instanceof A){const t=arguments[0];return this._hi===t._hi&&this._lo===t._lo}}isZero(){return 0===this._hi&&0===this._lo}selfSubtract(){if(arguments[0]instanceof A){const t=arguments[0];return this.isNaN()?this:this.selfAdd(-t._hi,-t._lo)}if("number"==typeof arguments[0]){const t=arguments[0];return this.isNaN()?this:this.selfAdd(-t,0)}}min(t){return this.le(t)?this:t}selfDivide(){if(1===arguments.length){if(arguments[0]instanceof A){const t=arguments[0];return this.selfDivide(t._hi,t._lo)}if("number"==typeof arguments[0]){const t=arguments[0];return this.selfDivide(t,0)}}else if(2===arguments.length){const t=arguments[0],e=arguments[1];let s=null,n=null,i=null,r=null,o=null,l=null,a=null,c=null;return o=this._hi/t,l=A.SPLIT*o,s=l-o,c=A.SPLIT*t,s=l-s,n=o-s,i=c-t,a=o*t,i=c-i,r=t-i,c=s*i-a+s*r+n*i+n*r,l=(this._hi-a-c+this._lo-o*e)/t,c=o+l,this._hi=c,this._lo=o-c+l,this}}dump(){return"DD<"+this._hi+", "+this._lo+">"}divide(){if(arguments[0]instanceof A){const t=arguments[0];let e=null,s=null,n=null,i=null,r=null,o=null,l=null,a=null;r=this._hi/t._hi,o=A.SPLIT*r,e=o-r,a=A.SPLIT*t._hi,e=o-e,s=r-e,n=a-t._hi,l=r*t._hi,n=a-n,i=t._hi-n,a=e*n-l+e*i+s*n+s*i,o=(this._hi-l-a+this._lo-r*t._lo)/t._hi,a=r+o;return new A(a,r-a+o)}if("number"==typeof arguments[0]){const t=arguments[0];return r.isNaN(t)?A.createNaN():A.copy(this).selfDivide(t,0)}}ge(t){return this._hi>t._hi||this._hi===t._hi&&this._lo>=t._lo}pow(t){if(0===t)return A.valueOf(1);let e=new A(this),s=A.valueOf(1),n=Math.abs(t);if(n>1)for(;n>0;)n%2==1&&s.selfMultiply(e),n/=2,n>0&&(e=e.sqr());else s=e;return t<0?s.reciprocal():s}ceil(){if(this.isNaN())return A.NaN;const t=Math.ceil(this._hi);let e=0;return t===this._hi&&(e=Math.ceil(this._lo)),new A(t,e)}compareTo(t){const e=t;return this._hi<e._hi?-1:this._hi>e._hi?1:this._lo<e._lo?-1:this._lo>e._lo?1:0}rint(){if(this.isNaN())return this;return this.add(.5).floor()}max(t){return this.ge(t)?this:t}sqrt(){if(this.isZero())return A.valueOf(0);if(this.isNegative())return A.NaN;const t=1/Math.sqrt(this._hi),e=this._hi*t,s=A.valueOf(e),n=this.subtract(s.sqr())._hi*(.5*t);return s.add(n)}selfAdd(){if(1===arguments.length){if(arguments[0]instanceof A){const t=arguments[0];return this.selfAdd(t._hi,t._lo)}if("number"==typeof arguments[0]){const t=arguments[0];let e=null,s=null,n=null,i=null,r=null,o=null;return n=this._hi+t,r=n-this._hi,i=n-r,i=t-r+(this._hi-i),o=i+this._lo,e=n+o,s=o+(n-e),this._hi=e+s,this._lo=s+(e-this._hi),this}}else if(2===arguments.length){const t=arguments[0],e=arguments[1];let s=null,n=null,i=null,r=null,o=null,l=null,a=null,c=null;o=this._hi+t,i=this._lo+e,a=o-this._hi,c=i-this._lo,l=o-a,r=i-c,l=t-a+(this._hi-l),r=e-c+(this._lo-r),a=l+i,s=o+a,n=a+(o-s),a=r+n;const h=s+a,u=a+(s-h);return this._hi=h,this._lo=u,this}}selfMultiply(){if(1===arguments.length){if(arguments[0]instanceof A){const t=arguments[0];return this.selfMultiply(t._hi,t._lo)}if("number"==typeof arguments[0]){const t=arguments[0];return this.selfMultiply(t,0)}}else if(2===arguments.length){const t=arguments[0],e=arguments[1];let s=null,n=null,i=null,r=null,o=null,l=null;o=A.SPLIT*this._hi,s=o-this._hi,l=A.SPLIT*t,s=o-s,n=this._hi-s,i=l-t,o=this._hi*t,i=l-i,r=t-i,l=s*i-o+s*r+n*i+n*r+(this._hi*e+this._lo*t);const a=o+l;s=o-a;const c=l+s;return this._hi=a,this._lo=c,this}}selfSqr(){return this.selfMultiply(this)}floor(){if(this.isNaN())return A.NaN;const t=Math.floor(this._hi);let e=0;return t===this._hi&&(e=Math.floor(this._lo)),new A(t,e)}negate(){return this.isNaN()?this:new A(-this._hi,-this._lo)}clone(){try{return null}catch(t){if(t instanceof CloneNotSupportedException)return null;throw t}}intValue(){return Math.trunc(this._hi)}toString(){const t=A.magnitude(this._hi);return t>=-3&&t<=20?this.toStandardNotation():this.toSciNotation()}toStandardNotation(){const t=this.getSpecialNumberString();if(null!==t)return t;const e=new Array(1).fill(null),s=this.extractSignificantDigits(!0,e),n=e[0]+1;let i=s;if("."===s.charAt(0))i="0"+s;else if(n<0)i="0."+A.stringOfChar("0",-n)+s;else if(-1===s.indexOf(".")){const t=n-s.length;i=s+A.stringOfChar("0",t)+".0"}return this.isNegative()?"-"+i:i}toSciNotation(){if(this.isZero())return A.SCI_NOT_ZERO;const t=this.getSpecialNumberString();if(null!==t)return t;const e=new Array(1).fill(null),s=this.extractSignificantDigits(!1,e),n=A.SCI_NOT_EXPONENT_CHAR+e[0];if("0"===s.charAt(0))throw new D("Found leading zero: "+s);let i="";s.length>1&&(i=s.substring(1));const r=s.charAt(0)+"."+i;return this.isNegative()?"-"+r+n:r+n}abs(){return this.isNaN()?A.NaN:this.isNegative()?this.negate():new A(this)}isPositive(){return this._hi>0||0===this._hi&&this._lo>0}lt(t){return this._hi<t._hi||this._hi===t._hi&&this._lo<t._lo}add(){if(arguments[0]instanceof A){const t=arguments[0];return A.copy(this).selfAdd(t)}if("number"==typeof arguments[0]){const t=arguments[0];return A.copy(this).selfAdd(t)}}init(){if(1===arguments.length){if("number"==typeof arguments[0]){const t=arguments[0];this._hi=t,this._lo=0}else if(arguments[0]instanceof A){const t=arguments[0];this._hi=t._hi,this._lo=t._lo}}else if(2===arguments.length){const t=arguments[0],e=arguments[1];this._hi=t,this._lo=e}}gt(t){return this._hi>t._hi||this._hi===t._hi&&this._lo>t._lo}isNegative(){return this._hi<0||0===this._hi&&this._lo<0}trunc(){return this.isNaN()?A.NaN:this.isPositive()?this.floor():this.ceil()}signum(){return this._hi>0?1:this._hi<0?-1:this._lo>0?1:this._lo<0?-1:0}get interfaces_(){return[l,o,u]}}A.PI=new A(3.141592653589793,12246467991473532e-32),A.TWO_PI=new A(6.283185307179586,24492935982947064e-32),A.PI_2=new A(1.5707963267948966,6123233995736766e-32),A.E=new A(2.718281828459045,14456468917292502e-32),A.NaN=new A(r.NaN,r.NaN),A.EPS=123259516440783e-46,A.SPLIT=134217729,A.MAX_PRINT_DIGITS=32,A.TEN=A.valueOf(10),A.ONE=A.valueOf(1),A.SCI_NOT_EXPONENT_CHAR="E",A.SCI_NOT_ZERO="0.0E0";class F{static orientationIndex(t,e,s){const n=F.orientationIndexFilter(t,e,s);if(n<=1)return n;const i=A.valueOf(e.x).selfAdd(-t.x),r=A.valueOf(e.y).selfAdd(-t.y),o=A.valueOf(s.x).selfAdd(-e.x),l=A.valueOf(s.y).selfAdd(-e.y);return i.selfMultiply(l).selfSubtract(r.selfMultiply(o)).signum()}static signOfDet2x2(){if(arguments[3]instanceof A&&arguments[2]instanceof A&&arguments[0]instanceof A&&arguments[1]instanceof A){const t=arguments[1],e=arguments[2],s=arguments[3];return arguments[0].multiply(s).selfSubtract(t.multiply(e)).signum()}if("number"==typeof arguments[3]&&"number"==typeof arguments[2]&&"number"==typeof arguments[0]&&"number"==typeof arguments[1]){const t=arguments[0],e=arguments[1],s=arguments[2],n=arguments[3],i=A.valueOf(t),r=A.valueOf(e),o=A.valueOf(s),l=A.valueOf(n);return i.multiply(l).selfSubtract(r.multiply(o)).signum()}}static intersection(t,e,s,n){const i=new A(t.y).selfSubtract(e.y),o=new A(e.x).selfSubtract(t.x),l=new A(t.x).selfMultiply(e.y).selfSubtract(new A(e.x).selfMultiply(t.y)),a=new A(s.y).selfSubtract(n.y),c=new A(n.x).selfSubtract(s.x),h=new A(s.x).selfMultiply(n.y).selfSubtract(new A(n.x).selfMultiply(s.y)),u=o.multiply(h).selfSubtract(c.multiply(l)),g=a.multiply(l).selfSubtract(i.multiply(h)),d=i.multiply(c).selfSubtract(a.multiply(o)),_=u.selfDivide(d).doubleValue(),p=g.selfDivide(d).doubleValue();return r.isNaN(_)||r.isInfinite(_)||r.isNaN(p)||r.isInfinite(p)?null:new m(_,p)}static orientationIndexFilter(t,e,s){let n=null;const i=(t.x-s.x)*(e.y-s.y),r=(t.y-s.y)*(e.x-s.x),o=i-r;if(i>0){if(r<=0)return F.signum(o);n=i+r}else{if(!(i<0))return F.signum(o);if(r>=0)return F.signum(o);n=-i-r}const l=F.DP_SAFE_EPSILON*n;return o>=l||-o>=l?F.signum(o):2}static signum(t){return t>0?1:t<0?-1:0}}F.DP_SAFE_EPSILON=1e-15;class G{getCoordinate(){}getCoordinateCopy(t){}createCoordinate(){}getDimension(){}hasM(){return this.getMeasures()>0}getX(t){}hasZ(){return this.getDimension()-this.getMeasures()>2}getMeasures(){return 0}expandEnvelope(t){}copy(){}getY(t){}toCoordinateArray(){}getM(t){if(this.hasM()){const e=this.getDimension()-this.getMeasures();return this.getOrdinate(t,e)}return r.NaN}setOrdinate(t,e,s){}getZ(t){return this.hasZ()?this.getOrdinate(t,2):r.NaN}size(){}getOrdinate(t,e){}get interfaces_(){return[u]}}G.X=0,G.Y=1,G.Z=2,G.M=3;class q{static isCCW(){if(arguments[0]instanceof Array){const t=arguments[0],e=t.length-1;if(e<3)throw new n("Ring has fewer than 4 points, so orientation cannot be determined");let s=t[0],i=0;for(let n=1;n<=e;n++){const e=t[n];e.y>s.y&&(s=e,i=n)}let r=i;do{r-=1,r<0&&(r=e)}while(t[r].equals2D(s)&&r!==i);let o=i;do{o=(o+1)%e}while(t[o].equals2D(s)&&o!==i);const l=t[r],a=t[o];if(l.equals2D(s)||a.equals2D(s)||l.equals2D(a))return!1;const c=q.index(l,s,a);let h=null;return h=0===c?l.x>a.x:c>0,h}if(I(arguments[0],G)){const t=arguments[0],e=t.size()-1;if(e<3)throw new n("Ring has fewer than 4 points, so orientation cannot be determined");let s=t.getCoordinate(0),i=0;for(let n=1;n<=e;n++){const e=t.getCoordinate(n);e.y>s.y&&(s=e,i=n)}let r=null,o=i;do{o-=1,o<0&&(o=e),r=t.getCoordinate(o)}while(r.equals2D(s)&&o!==i);let l=null,a=i;do{a=(a+1)%e,l=t.getCoordinate(a)}while(l.equals2D(s)&&a!==i);if(r.equals2D(s)||l.equals2D(s)||r.equals2D(l))return!1;const c=q.index(r,s,l);let h=null;return h=0===c?r.x>l.x:c>0,h}}static index(t,e,s){return F.orientationIndex(t,e,s)}}q.CLOCKWISE=-1,q.RIGHT=q.CLOCKWISE,q.COUNTERCLOCKWISE=1,q.LEFT=q.COUNTERCLOCKWISE,q.COLLINEAR=0,q.STRAIGHT=q.COLLINEAR;class B{static intersection(t,e,s,n){const i=t.x<e.x?t.x:e.x,o=t.y<e.y?t.y:e.y,l=t.x>e.x?t.x:e.x,a=t.y>e.y?t.y:e.y,c=s.x<n.x?s.x:n.x,h=s.y<n.y?s.y:n.y,u=s.x>n.x?s.x:n.x,g=s.y>n.y?s.y:n.y,d=((i>c?i:c)+(l<u?l:u))/2,_=((o>h?o:h)+(a<g?a:g))/2,p=t.x-d,f=t.y-_,y=e.x-d,x=e.y-_,E=s.x-d,I=s.y-_,N=n.x-d,w=n.y-_,C=f-x,S=y-p,L=p*x-y*f,T=I-w,R=N-E,P=E*w-N*I,O=C*R-T*S,v=(S*P-R*L)/O,M=(T*L-C*P)/O;return r.isNaN(v)||r.isInfinite(v)||r.isNaN(M)||r.isInfinite(M)?null:new m(v+d,M+_)}}class Y{static arraycopy(t,e,s,n,i){let r=0;for(let o=e;o<e+i;o++)s[n+r]=t[o],r++}static getProperty(t){return{"line.separator":"\n"}[t]}}class z{static log10(t){const e=Math.log(t);return r.isInfinite(e)||r.isNaN(e)?e:e/z.LOG_10}static min(t,e,s,n){let i=t;return e<i&&(i=e),s<i&&(i=s),n<i&&(i=n),i}static clamp(){if("number"==typeof arguments[2]&&"number"==typeof arguments[0]&&"number"==typeof arguments[1]){const t=arguments[0],e=arguments[1],s=arguments[2];return t<e?e:t>s?s:t}if(Number.isInteger(arguments[2])&&Number.isInteger(arguments[0])&&Number.isInteger(arguments[1])){const t=arguments[0],e=arguments[1],s=arguments[2];return t<e?e:t>s?s:t}}static average(t,e){return(t+e)/2}static wrap(t,e){return t<0?e- -t%e:t%e}static max(){if(3===arguments.length){const t=arguments[1],e=arguments[2];let s=arguments[0];return t>s&&(s=t),e>s&&(s=e),s}if(4===arguments.length){const t=arguments[1],e=arguments[2],s=arguments[3];let n=arguments[0];return t>n&&(n=t),e>n&&(n=e),s>n&&(n=s),n}}}z.LOG_10=Math.log(10);class V{static pointToSegmentString(t,e){if(0===e.length)throw new n("Line array must contain at least one vertex");let s=t.distance(e[0]);for(let n=0;n<e.length-1;n++){const i=V.pointToSegment(t,e[n],e[n+1]);i<s&&(s=i)}return s}static segmentToSegment(t,e,s,n){if(t.equals(e))return V.pointToSegment(t,s,n);if(s.equals(n))return V.pointToSegment(n,t,e);let i=!1;if(O.intersects(t,e,s,n)){const r=(e.x-t.x)*(n.y-s.y)-(e.y-t.y)*(n.x-s.x);if(0===r)i=!0;else{const o=(t.y-s.y)*(n.x-s.x)-(t.x-s.x)*(n.y-s.y),l=((t.y-s.y)*(e.x-t.x)-(t.x-s.x)*(e.y-t.y))/r,a=o/r;(a<0||a>1||l<0||l>1)&&(i=!0)}}else i=!0;return i?z.min(V.pointToSegment(t,s,n),V.pointToSegment(e,s,n),V.pointToSegment(s,t,e),V.pointToSegment(n,t,e)):0}static pointToLinePerpendicular(t,e,s){const n=(s.x-e.x)*(s.x-e.x)+(s.y-e.y)*(s.y-e.y),i=((e.y-t.y)*(s.x-e.x)-(e.x-t.x)*(s.y-e.y))/n;return Math.abs(i)*Math.sqrt(n)}static pointToSegment(t,e,s){if(e.x===s.x&&e.y===s.y)return t.distance(e);const n=(s.x-e.x)*(s.x-e.x)+(s.y-e.y)*(s.y-e.y),i=((t.x-e.x)*(s.x-e.x)+(t.y-e.y)*(s.y-e.y))/n;if(i<=0)return t.distance(e);if(i>=1)return t.distance(s);const r=((e.y-t.y)*(s.x-e.x)-(e.x-t.x)*(s.y-e.y))/n;return Math.abs(r)*Math.sqrt(n)}}class k{static ofLine(t){const e=t.size();if(e<=1)return 0;let s=0;const n=new m;t.getCoordinate(0,n);let i=n.x,r=n.y;for(let o=1;o<e;o++){t.getCoordinate(o,n);const e=n.x,l=n.y,a=e-i,c=l-r;s+=Math.sqrt(a*a+c*c),i=e,r=l}return s}}class X{filter(t){}}class U extends s{constructor(t){super(t),this.name=Object.keys({UnsupportedOperationException:U})[0]}}class H{static measures(t){return t instanceof y?0:t instanceof x||t instanceof E?1:0}static create(){if(1===arguments.length){const t=arguments[0];return H.create(t,0)}if(2===arguments.length){const t=arguments[0],e=arguments[1];return 2===t?new y:3===t&&0===e?new m:3===t&&1===e?new x:4===t&&1===e?new E:new m}}static dimension(t){return t instanceof y?2:t instanceof x?3:t instanceof E?4:3}}class W{static scroll(t,e){const s=W.indexOf(e,t);if(s<0)return null;const n=new Array(t.length).fill(null);Y.arraycopy(t,s,n,0,t.length-s),Y.arraycopy(t,0,n,t.length-s,s),Y.arraycopy(n,0,t,0,t.length)}static removeRepeatedPoints(t){if(!W.hasRepeatedPoints(t))return t;return new R(t,!1).toCoordinateArray()}static reverse(t){const e=t.length-1,s=Math.trunc(e/2);for(let n=0;n<=s;n++){const s=t[n];t[n]=t[e-n],t[e-n]=s}}static removeNull(t){let e=0;for(let s=0;s<t.length;s++)null!==t[s]&&e++;const s=new Array(e).fill(null);if(0===e)return s;let n=0;for(let e=0;e<t.length;e++)null!==t[e]&&(s[n++]=t[e]);return s}static copyDeep(){if(1===arguments.length){const t=arguments[0],e=new Array(t.length).fill(null);for(let s=0;s<t.length;s++)e[s]=t[s].copy();return e}if(5===arguments.length){const t=arguments[0],e=arguments[1],s=arguments[2],n=arguments[3],i=arguments[4];for(let r=0;r<i;r++)s[n+r]=t[e+r].copy()}}static isEqualReversed(t,e){for(let s=0;s<t.length;s++){const n=t[s],i=e[t.length-s-1];if(0!==n.compareTo(i))return!1}return!0}static envelope(t){const e=new O;for(let s=0;s<t.length;s++)e.expandToInclude(t[s]);return e}static extract(t,e,s){e=z.clamp(e,0,t.length);let n=(s=z.clamp(s,-1,t.length))-e+1;s<0&&(n=0),e>=t.length&&(n=0),s<e&&(n=0);const i=new Array(n).fill(null);if(0===n)return i;let r=0;for(let n=e;n<=s;n++)i[r++]=t[n];return i}static isRing(t){return!(t.length<4)&&!!t[0].equals2D(t[t.length-1])}static ptNotInList(t,e){for(let s=0;s<t.length;s++){const n=t[s];if(W.indexOf(n,e)<0)return n}return null}static equals(){if(2===arguments.length){const t=arguments[0],e=arguments[1];if(t===e)return!0;if(null===t||null===e)return!1;if(t.length!==e.length)return!1;for(let s=0;s<t.length;s++)if(!t[s].equals(e[s]))return!1;return!0}if(3===arguments.length){const t=arguments[0],e=arguments[1],s=arguments[2];if(t===e)return!0;if(null===t||null===e)return!1;if(t.length!==e.length)return!1;for(let n=0;n<t.length;n++)if(0!==s.compare(t[n],e[n]))return!1;return!0}}static intersection(t,e){const s=new R;for(let n=0;n<t.length;n++)e.intersects(t[n])&&s.add(t[n],!0);return s.toCoordinateArray()}static measures(t){if(null===t||0===t.length)return 0;let e=0;for(const s of t)e=Math.max(e,H.measures(s));return e}static hasRepeatedPoints(t){for(let e=1;e<t.length;e++)if(t[e-1].equals(t[e]))return!0;return!1}static toCoordinateArray(t){return t.toArray(W.coordArrayType)}static dimension(t){if(null===t||0===t.length)return 3;let e=0;for(const s of t)e=Math.max(e,H.dimension(s));return e}static atLeastNCoordinatesOrNothing(t,e){return e.length>=t?e:[]}static indexOf(t,e){for(let s=0;s<e.length;s++)if(t.equals(e[s]))return s;return-1}static increasingDirection(t){for(let e=0;e<Math.trunc(t.length/2);e++){const s=t.length-1-e,n=t[e].compareTo(t[s]);if(0!==n)return n}return 1}static compare(t,e){let s=0;for(;s<t.length&&s<e.length;){const n=t[s].compareTo(e[s]);if(0!==n)return n;s++}return s<e.length?-1:s<t.length?1:0}static minCoordinate(t){let e=null;for(let s=0;s<t.length;s++)(null===e||e.compareTo(t[s])>0)&&(e=t[s]);return e}}W.ForwardComparator=class{compare(t,e){const s=t,n=e;return W.compare(s,n)}get interfaces_(){return[g]}},W.BidirectionalComparator=class{compare(t,e){const s=t,n=e;if(s.length<n.length)return-1;if(s.length>n.length)return 1;if(0===s.length)return 0;const i=W.compare(s,n);return W.isEqualReversed(s,n)?0:i}OLDcompare(t,e){const s=t,n=e;if(s.length<n.length)return-1;if(s.length>n.length)return 1;if(0===s.length)return 0;const i=W.increasingDirection(s),r=W.increasingDirection(n);let o=i>0?0:s.length-1,l=r>0?0:s.length-1;for(let t=0;t<s.length;t++){const t=s[o].compareTo(n[l]);if(0!==t)return t;o+=i,l+=r}return 0}get interfaces_(){return[g]}},W.coordArrayType=new Array(0).fill(null);class Z{static toDimensionSymbol(t){switch(t){case Z.FALSE:return Z.SYM_FALSE;case Z.TRUE:return Z.SYM_TRUE;case Z.DONTCARE:return Z.SYM_DONTCARE;case Z.P:return Z.SYM_P;case Z.L:return Z.SYM_L;case Z.A:return Z.SYM_A}throw new n("Unknown dimension value: "+t)}static toDimensionValue(t){switch(b.toUpperCase(t)){case Z.SYM_FALSE:return Z.FALSE;case Z.SYM_TRUE:return Z.TRUE;case Z.SYM_DONTCARE:return Z.DONTCARE;case Z.SYM_P:return Z.P;case Z.SYM_L:return Z.L;case Z.SYM_A:return Z.A}throw new n("Unknown dimension symbol: "+t)}}Z.P=0,Z.L=1,Z.A=2,Z.FALSE=-1,Z.TRUE=-2,Z.DONTCARE=-3,Z.SYM_FALSE="F",Z.SYM_TRUE="T",Z.SYM_DONTCARE="*",Z.SYM_P="0",Z.SYM_L="1",Z.SYM_A="2";class j{constructor(){j.constructor_.apply(this,arguments)}isGeometryCollection(){return this.getTypeCode()===j.TYPECODE_GEOMETRYCOLLECTION}getFactory(){return this._factory}getGeometryN(t){return this}getArea(){return 0}isRectangle(){return!1}equalsExact(t){return this===t||this.equalsExact(t,0)}geometryChanged(){this.apply(j.geometryChangedFilter)}geometryChangedAction(){this._envelope=null}equalsNorm(t){return null!==t&&this.norm().equalsExact(t.norm())}getLength(){return 0}getNumGeometries(){return 1}compareTo(){let t;if(1===arguments.length){const e=arguments[0];return t=e,this.getTypeCode()!==t.getTypeCode()?this.getTypeCode()-t.getTypeCode():this.isEmpty()&&t.isEmpty()?0:this.isEmpty()?-1:t.isEmpty()?1:this.compareToSameClass(e)}if(2===arguments.length){const e=arguments[0],s=arguments[1];return t=e,this.getTypeCode()!==t.getTypeCode()?this.getTypeCode()-t.getTypeCode():this.isEmpty()&&t.isEmpty()?0:this.isEmpty()?-1:t.isEmpty()?1:this.compareToSameClass(e,s)}}getUserData(){return this._userData}getSRID(){return this._SRID}getEnvelope(){return this.getFactory().toGeometry(this.getEnvelopeInternal())}static checkNotGeometryCollection(t){if(t.getTypeCode()===j.TYPECODE_GEOMETRYCOLLECTION)throw new n("This method does not support GeometryCollection arguments")}equal(t,e,s){return 0===s?t.equals(e):t.distance(e)<=s}norm(){const t=this.copy();return t.normalize(),t}reverse(){const t=this.reverseInternal();return null!=this.envelope&&(t.envelope=this.envelope.copy()),t.setSRID(this.getSRID()),t}copy(){const t=this.copyInternal();return t.envelope=null==this._envelope?null:this._envelope.copy(),t._SRID=this._SRID,t._userData=this._userData,t}getPrecisionModel(){return this._factory.getPrecisionModel()}getEnvelopeInternal(){return null===this._envelope&&(this._envelope=this.computeEnvelopeInternal()),new O(this._envelope)}setSRID(t){this._SRID=t}setUserData(t){this._userData=t}compare(t,e){const s=t.iterator(),n=e.iterator();for(;s.hasNext()&&n.hasNext();){const t=s.next(),e=n.next(),i=t.compareTo(e);if(0!==i)return i}return s.hasNext()?1:n.hasNext()?-1:0}hashCode(){return this.getEnvelopeInternal().hashCode()}isEquivalentClass(t){return this.getTypeCode()==t.getTypeCode()}get interfaces_(){return[u,o,l]}getClass(){return j}static hasNonEmptyElements(t){for(let e=0;e<t.length;e++)if(!t[e].isEmpty())return!0;return!1}static hasNullElements(t){for(let e=0;e<t.length;e++)if(null===t[e])return!0;return!1}}j.constructor_=function(t){t&&(this._envelope=null,this._userData=null,this._factory=t,this._SRID=t.getSRID())},j.TYPECODE_POINT=0,j.TYPECODE_MULTIPOINT=1,j.TYPECODE_LINESTRING=2,j.TYPECODE_LINEARRING=3,j.TYPECODE_MULTILINESTRING=4,j.TYPECODE_POLYGON=5,j.TYPECODE_MULTIPOLYGON=6,j.TYPECODE_GEOMETRYCOLLECTION=7,j.TYPENAME_POINT="Point",j.TYPENAME_MULTIPOINT="MultiPoint",j.TYPENAME_LINESTRING="LineString",j.TYPENAME_LINEARRING="LinearRing",j.TYPENAME_MULTILINESTRING="MultiLineString",j.TYPENAME_POLYGON="Polygon",j.TYPENAME_MULTIPOLYGON="MultiPolygon",j.TYPENAME_GEOMETRYCOLLECTION="GeometryCollection",j.geometryChangedFilter={get interfaces_(){return[X]},filter(t){t.geometryChangedAction()}};class K{filter(t){}}class Q{}class J{static scroll(){if(2===arguments.length){if(I(arguments[0],G)&&Number.isInteger(arguments[1])){const t=arguments[0],e=arguments[1];J.scroll(t,e,J.isRing(t))}else if(I(arguments[0],G)&&arguments[1]instanceof m){const t=arguments[0],e=arguments[1],s=J.indexOf(e,t);if(s<=0)return null;J.scroll(t,s)}}else if(3===arguments.length){const t=arguments[0],e=arguments[1],s=arguments[2];if(e<=0)return null;const n=t.copy(),i=s?t.size()-1:t.size();for(let s=0;s<i;s++)for(let r=0;r<t.getDimension();r++)t.setOrdinate(s,r,n.getOrdinate((e+s)%i,r));if(s)for(let e=0;e<t.getDimension();e++)t.setOrdinate(i,e,t.getOrdinate(0,e))}}static isEqual(t,e){const s=t.size();if(s!==e.size())return!1;const n=Math.min(t.getDimension(),e.getDimension());for(let i=0;i<s;i++)for(let s=0;s<n;s++){const n=t.getOrdinate(i,s),o=e.getOrdinate(i,s);if(t.getOrdinate(i,s)!==e.getOrdinate(i,s)&&(!r.isNaN(n)||!r.isNaN(o)))return!1}return!0}static minCoordinateIndex(){if(1===arguments.length){const t=arguments[0];return J.minCoordinateIndex(t,0,t.size()-1)}if(3===arguments.length){const t=arguments[0],e=arguments[2];let s=-1,n=null;for(let i=arguments[1];i<=e;i++){const e=t.getCoordinate(i);(null===n||n.compareTo(e)>0)&&(n=e,s=i)}return s}}static extend(t,e,s){const n=t.create(s,e.getDimension()),i=e.size();if(J.copy(e,0,n,0,i),i>0)for(let t=i;t<s;t++)J.copy(e,i-1,n,t,1);return n}static reverse(t){const e=t.size()-1,s=Math.trunc(e/2);for(let n=0;n<=s;n++)J.swap(t,n,e-n)}static ensureValidRing(t,e){const s=e.size();if(0===s)return e;if(s<=3)return J.createClosedRing(t,e,4);return e.getOrdinate(0,G.X)===e.getOrdinate(s-1,G.X)&&e.getOrdinate(0,G.Y)===e.getOrdinate(s-1,G.Y)?e:J.createClosedRing(t,e,s+1)}static minCoordinate(t){let e=null;for(let s=0;s<t.size();s++){const n=t.getCoordinate(s);(null===e||e.compareTo(n)>0)&&(e=n)}return e}static copyCoord(t,e,s,n){const i=Math.min(t.getDimension(),s.getDimension());for(let r=0;r<i;r++)s.setOrdinate(n,r,t.getOrdinate(e,r))}static isRing(t){const e=t.size();return 0===e||!(e<=3)&&(t.getOrdinate(0,G.X)===t.getOrdinate(e-1,G.X)&&t.getOrdinate(0,G.Y)===t.getOrdinate(e-1,G.Y))}static swap(t,e,s){if(e===s)return null;for(let n=0;n<t.getDimension();n++){const i=t.getOrdinate(e,n);t.setOrdinate(e,n,t.getOrdinate(s,n)),t.setOrdinate(s,n,i)}}static copy(t,e,s,n,i){for(let r=0;r<i;r++)J.copyCoord(t,e+r,s,n+r)}static indexOf(t,e){for(let s=0;s<e.size();s++)if(t.x===e.getOrdinate(s,G.X)&&t.y===e.getOrdinate(s,G.Y))return s;return-1}static createClosedRing(t,e,s){const n=t.create(s,e.getDimension()),i=e.size();J.copy(e,0,n,0,i);for(let t=i;t<s;t++)J.copy(e,0,n,t,1);return n}}class ${filter(t){}}class tt extends j{constructor(){super(),tt.constructor_.apply(this,arguments)}static constructor_(){if(this._points=null,0===arguments.length);else if(2===arguments.length){const t=arguments[0],e=arguments[1];j.constructor_.call(this,e),this.init(t)}}computeEnvelopeInternal(){return this.isEmpty()?new O:this._points.expandEnvelope(new O)}isRing(){return this.isClosed()&&W.isRing(this.getCoordinates())}getCoordinates(){return this._points.toCoordinateArray()}copyInternal(){return new tt(this._points.copy(),this._factory)}equalsExact(){if(2===arguments.length&&"number"==typeof arguments[1]&&arguments[0]instanceof j){const t=arguments[0],e=arguments[1];if(!this.isEquivalentClass(t))return!1;const s=t;if(this._points.size()!==s._points.size())return!1;for(let t=0;t<this._points.size();t++)if(!this.equal(this._points.getCoordinate(t),s._points.getCoordinate(t),e))return!1;return!0}return super.equalsExact.apply(this,arguments)}isClosed(){return!this.isEmpty()&&this.getCoordinateN(0).equals2D(this.getCoordinateN(this.getNumPoints()-1))}reverseInternal(){const t=this._points.copy();return J.reverse(t),this.getFactory().createLineString(t)}getEndPoint(){return this.isEmpty()?null:this.getPointN(this.getNumPoints()-1)}getTypeCode(){return j.TYPECODE_LINESTRING}getDimension(){return 1}getBoundary(){throw new U}isEquivalentClass(t){return t instanceof tt}getCoordinateSequence(){return this._points}getPointN(t){return this.getFactory().createPoint(this._points.getCoordinate(t))}normalize(){for(let t=0;t<Math.trunc(this._points.size()/2);t++){const e=this._points.size()-1-t;if(!this._points.getCoordinate(t).equals(this._points.getCoordinate(e))){if(this._points.getCoordinate(t).compareTo(this._points.getCoordinate(e))>0){const t=this._points.copy();J.reverse(t),this._points=t}return null}}}getCoordinate(){return this.isEmpty()?null:this._points.getCoordinate(0)}getBoundaryDimension(){return this.isClosed()?Z.FALSE:0}getLength(){return k.ofLine(this._points)}getNumPoints(){return this._points.size()}compareToSameClass(){if(1===arguments.length){const t=arguments[0];let e=0,s=0;for(;e<this._points.size()&&s<t._points.size();){const n=this._points.getCoordinate(e).compareTo(t._points.getCoordinate(s));if(0!==n)return n;e++,s++}return e<this._points.size()?1:s<t._points.size()?-1:0}if(2===arguments.length){const t=arguments[0];return arguments[1].compare(this._points,t._points)}}apply(){if(I(arguments[0],K)){const t=arguments[0];for(let e=0;e<this._points.size();e++)t.filter(this._points.getCoordinate(e))}else if(I(arguments[0],P)){const t=arguments[0];if(0===this._points.size())return null;for(let e=0;e<this._points.size()&&(t.filter(this._points,e),!t.isDone());e++);t.isGeometryChanged()&&this.geometryChanged()}else if(I(arguments[0],$)){arguments[0].filter(this)}else if(I(arguments[0],X)){arguments[0].filter(this)}}getCoordinateN(t){return this._points.getCoordinate(t)}getGeometryType(){return j.TYPENAME_LINESTRING}isEmpty(){return 0===this._points.size()}init(t){if(null===t&&(t=this.getFactory().getCoordinateSequenceFactory().create([])),1===t.size())throw new n("Invalid number of points in LineString (found "+t.size()+" - must be 0 or >= 2)");this._points=t}isCoordinate(t){for(let e=0;e<this._points.size();e++)if(this._points.getCoordinate(e).equals(t))return!0;return!1}getStartPoint(){return this.isEmpty()?null:this.getPointN(0)}get interfaces_(){return[Q]}}class et extends tt{constructor(){super(),et.constructor_.apply(this,arguments)}static constructor_(){const t=arguments[0],e=arguments[1];tt.constructor_.call(this,t,e),this.validateConstruction()}copyInternal(){return new et(this._points.copy(),this._factory)}getBoundaryDimension(){return Z.FALSE}isClosed(){return!!this.isEmpty()||super.isClosed.call(this)}reverseInternal(){const t=this._points.copy();return J.reverse(t),this.getFactory().createLinearRing(t)}getTypeCode(){return j.TYPECODE_LINEARRING}validateConstruction(){if(!this.isEmpty()&&!super.isClosed.call(this))throw new n("Points of LinearRing do not form a closed linestring");if(this.getCoordinateSequence().size()>=1&&this.getCoordinateSequence().size()<et.MINIMUM_VALID_SIZE)throw new n("Invalid number of points in LinearRing (found "+this.getCoordinateSequence().size()+" - must be 0 or >= 4)")}getGeometryType(){return j.TYPENAME_LINEARRING}}et.MINIMUM_VALID_SIZE=4;class st{create(){if(1===arguments.length)arguments[0]instanceof Array||I(arguments[0],G);else if(2===arguments.length);else if(3===arguments.length){const t=arguments[0],e=arguments[1];return this.create(t,e)}}}class nt{constructor(t){this.str=t}append(t){this.str+=t}setCharAt(t,e){this.str=this.str.substr(0,t)+e+this.str.substr(t+1)}toString(){return this.str}}class it{constructor(){it.constructor_.apply(this,arguments)}static constructor_(){if(this._dimension=3,this._measures=0,this._coordinates=null,1===arguments.length){if(arguments[0]instanceof Array){const t=arguments[0];it.constructor_.call(this,t,W.dimension(t),W.measures(t))}else if(Number.isInteger(arguments[0])){const t=arguments[0];this._coordinates=new Array(t).fill(null);for(let e=0;e<t;e++)this._coordinates[e]=new m}else if(I(arguments[0],G)){const t=arguments[0];if(null===t)return this._coordinates=new Array(0).fill(null),null;this._dimension=t.getDimension(),this._measures=t.getMeasures(),this._coordinates=new Array(t.size()).fill(null);for(let e=0;e<this._coordinates.length;e++)this._coordinates[e]=t.getCoordinateCopy(e)}}else if(2===arguments.length){if(arguments[0]instanceof Array&&Number.isInteger(arguments[1])){const t=arguments[0],e=arguments[1];it.constructor_.call(this,t,e,W.measures(t))}else if(Number.isInteger(arguments[0])&&Number.isInteger(arguments[1])){const t=arguments[0],e=arguments[1];this._coordinates=new Array(t).fill(null),this._dimension=e;for(let s=0;s<t;s++)this._coordinates[s]=H.create(e)}}else if(3===arguments.length)if(Number.isInteger(arguments[2])&&arguments[0]instanceof Array&&Number.isInteger(arguments[1])){const t=arguments[0],e=arguments[1],s=arguments[2];this._dimension=e,this._measures=s,this._coordinates=null===t?new Array(0).fill(null):t}else if(Number.isInteger(arguments[2])&&Number.isInteger(arguments[0])&&Number.isInteger(arguments[1])){const t=arguments[0],e=arguments[1],s=arguments[2];this._coordinates=new Array(t).fill(null),this._dimension=e,this._measures=s;for(let e=0;e<t;e++)this._coordinates[e]=this.createCoordinate()}}getCoordinate(){if(1===arguments.length){const t=arguments[0];return this._coordinates[t]}if(2===arguments.length){const t=arguments[0];arguments[1].setCoordinate(this._coordinates[t])}}getCoordinateCopy(t){const e=this.createCoordinate();return e.setCoordinate(this._coordinates[t]),e}createCoordinate(){return H.create(this.getDimension(),this.getMeasures())}getDimension(){return this._dimension}getX(t){return this._coordinates[t].x}getMeasures(){return this._measures}expandEnvelope(t){for(let e=0;e<this._coordinates.length;e++)t.expandToInclude(this._coordinates[e]);return t}copy(){const t=new Array(this.size()).fill(null);for(let e=0;e<this._coordinates.length;e++){const s=this.createCoordinate();s.setCoordinate(this._coordinates[e]),t[e]=s}return new it(t,this._dimension,this._measures)}toString(){if(this._coordinates.length>0){const t=new nt(17*this._coordinates.length);t.append("("),t.append(this._coordinates[0]);for(let e=1;e<this._coordinates.length;e++)t.append(", "),t.append(this._coordinates[e]);return t.append(")"),t.toString()}return"()"}getY(t){return this._coordinates[t].y}toCoordinateArray(){return this._coordinates}getM(t){return this.hasM()?this._coordinates[t].getM():r.NaN}setOrdinate(t,e,s){switch(e){case G.X:this._coordinates[t].x=s;break;case G.Y:this._coordinates[t].y=s;break;default:this._coordinates[t].setOrdinate(e,s)}}getZ(t){return this.hasZ()?this._coordinates[t].getZ():r.NaN}size(){return this._coordinates.length}getOrdinate(t,e){switch(e){case G.X:return this._coordinates[t].x;case G.Y:return this._coordinates[t].y;default:return this._coordinates[t].getOrdinate(e)}}get interfaces_(){return[G,l]}}class rt{static instance(){return rt.instanceObject}readResolve(){return rt.instance()}create(){if(1===arguments.length){if(arguments[0]instanceof Array){return new it(arguments[0])}if(I(arguments[0],G)){return new it(arguments[0])}}else{if(2===arguments.length){let t=arguments[1];return t>3&&(t=3),t<2&&(t=2),new it(arguments[0],t)}if(3===arguments.length){let t=arguments[2],e=arguments[1]-t;return t>1&&(t=1),e>3&&(e=3),e<2&&(e=2),new it(arguments[0],e+t,t)}}}get interfaces_(){return[st,l]}}rt.instanceObject=new rt;class ot extends N{contains(){}}class lt extends ot{}class at extends lt{constructor(t){super(),this.array=[],t instanceof N&&this.addAll(t)}contains(t){for(const e of this.array)if(0===e.compareTo(t))return!0;return!1}add(t){if(this.contains(t))return!1;for(let e=0,s=this.array.length;e<s;e++){if(1===this.array[e].compareTo(t))return!!this.array.splice(e,0,t)}return this.array.push(t),!0}addAll(t){for(const e of t)this.add(e);return!0}remove(){throw new U}size(){return this.array.length}isEmpty(){return 0===this.array.length}toArray(){return this.array.slice()}iterator(){return new ct(this.array)}}let ct=class{constructor(t){this.array=t,this.position=0}next(){if(this.position===this.array.length)throw new S;return this.array[this.position++]}hasNext(){return this.position<this.array.length}remove(){throw new U}};class ht{static sort(){const t=arguments[0];if(1===arguments.length)t.sort(((t,e)=>t.compareTo(e)));else if(2===arguments.length)t.sort(((t,e)=>arguments[1].compare(t,e)));else if(3===arguments.length){const e=t.slice(arguments[1],arguments[2]);e.sort();const s=t.slice(0,arguments[1]).concat(e,t.slice(arguments[2],t.length));t.splice(0,t.length);for(const e of s)t.push(e)}else if(4===arguments.length){const e=t.slice(arguments[1],arguments[2]);e.sort(((t,e)=>arguments[3].compare(t,e)));const s=t.slice(0,arguments[1]).concat(e,t.slice(arguments[2],t.length));t.splice(0,t.length);for(const e of s)t.push(e)}}static asList(t){const e=new L;for(const s of t)e.add(s);return e}static copyOf(t,e){return t.slice(0,e)}}class ut extends j{constructor(){super(),ut.constructor_.apply(this,arguments)}static constructor_(){if(this._geometries=null,0===arguments.length);else if(2===arguments.length){let t=arguments[0],e=arguments[1];if(j.constructor_.call(this,e),null===t&&(t=[]),j.hasNullElements(t))throw new n("geometries must not contain null elements");this._geometries=t}}computeEnvelopeInternal(){const t=new O;for(let e=0;e<this._geometries.length;e++)t.expandToInclude(this._geometries[e].getEnvelopeInternal());return t}getGeometryN(t){return this._geometries[t]}getCoordinates(){const t=new Array(this.getNumPoints()).fill(null);let e=-1;for(let s=0;s<this._geometries.length;s++){const n=this._geometries[s].getCoordinates();for(let s=0;s<n.length;s++)e++,t[e]=n[s]}return t}getArea(){let t=0;for(let e=0;e<this._geometries.length;e++)t+=this._geometries[e].getArea();return t}copyInternal(){const t=new Array(this._geometries.length).fill(null);for(let e=0;e<t.length;e++)t[e]=this._geometries[e].copy();return new ut(t,this._factory)}equalsExact(){if(2===arguments.length&&"number"==typeof arguments[1]&&arguments[0]instanceof j){const t=arguments[0],e=arguments[1];if(!this.isEquivalentClass(t))return!1;const s=t;if(this._geometries.length!==s._geometries.length)return!1;for(let t=0;t<this._geometries.length;t++)if(!this._geometries[t].equalsExact(s._geometries[t],e))return!1;return!0}return super.equalsExact.apply(this,arguments)}reverseInternal(){const t=this._geometries.length,e=new L(t);for(let s=0;s<t;s++)e.add(this._geometries[s].reverse());return this.getFactory().buildGeometry(e)}getTypeCode(){return j.TYPECODE_GEOMETRYCOLLECTION}getDimension(){let t=Z.FALSE;for(let e=0;e<this._geometries.length;e++)t=Math.max(t,this._geometries[e].getDimension());return t}getNumGeometries(){return this._geometries.length}getBoundary(){return j.checkNotGeometryCollection(this),h.shouldNeverReachHere(),null}getGeometryType(){return j.TYPENAME_GEOMETRYCOLLECTION}isEmpty(){for(let t=0;t<this._geometries.length;t++)if(!this._geometries[t].isEmpty())return!1;return!0}normalize(){for(let t=0;t<this._geometries.length;t++)this._geometries[t].normalize();ht.sort(this._geometries)}getCoordinate(){return this.isEmpty()?null:this._geometries[0].getCoordinate()}getBoundaryDimension(){let t=Z.FALSE;for(let e=0;e<this._geometries.length;e++)t=Math.max(t,this._geometries[e].getBoundaryDimension());return t}getLength(){let t=0;for(let e=0;e<this._geometries.length;e++)t+=this._geometries[e].getLength();return t}getNumPoints(){let t=0;for(let e=0;e<this._geometries.length;e++)t+=this._geometries[e].getNumPoints();return t}compareToSameClass(){if(1===arguments.length){const t=arguments[0],e=new at(ht.asList(this._geometries)),s=new at(ht.asList(t._geometries));return this.compare(e,s)}if(2===arguments.length){const t=arguments[1],e=arguments[0],s=this.getNumGeometries(),n=e.getNumGeometries();let i=0;for(;i<s&&i<n;){const s=this.getGeometryN(i),n=e.getGeometryN(i),r=s.compareToSameClass(n,t);if(0!==r)return r;i++}return i<s?1:i<n?-1:0}}apply(){if(I(arguments[0],K)){const t=arguments[0];for(let e=0;e<this._geometries.length;e++)this._geometries[e].apply(t)}else if(I(arguments[0],P)){const t=arguments[0];if(0===this._geometries.length)return null;for(let e=0;e<this._geometries.length&&(this._geometries[e].apply(t),!t.isDone());e++);t.isGeometryChanged()&&this.geometryChanged()}else if(I(arguments[0],$)){const t=arguments[0];t.filter(this);for(let e=0;e<this._geometries.length;e++)this._geometries[e].apply(t)}else if(I(arguments[0],X)){const t=arguments[0];t.filter(this);for(let e=0;e<this._geometries.length;e++)this._geometries[e].apply(t)}}}class gt{}class dt extends ut{constructor(){super(),dt.constructor_.apply(this,arguments)}static constructor_(){const t=arguments[0],e=arguments[1];ut.constructor_.call(this,t,e)}copyInternal(){const t=new Array(this._geometries.length).fill(null);for(let e=0;e<t.length;e++)t[e]=this._geometries[e].copy();return new dt(t,this._factory)}equalsExact(){if(2===arguments.length&&"number"==typeof arguments[1]&&arguments[0]instanceof j){const t=arguments[0],e=arguments[1];return!!this.isEquivalentClass(t)&&super.equalsExact.call(this,t,e)}return super.equalsExact.apply(this,arguments)}getBoundaryDimension(){return 1}getTypeCode(){return j.TYPECODE_MULTIPOLYGON}getDimension(){return 2}getBoundary(){if(this.isEmpty())return this.getFactory().createMultiLineString();const t=new L;for(let e=0;e<this._geometries.length;e++){const s=this._geometries[e].getBoundary();for(let e=0;e<s.getNumGeometries();e++)t.add(s.getGeometryN(e))}const e=new Array(t.size()).fill(null);return this.getFactory().createMultiLineString(t.toArray(e))}getGeometryType(){return j.TYPENAME_MULTIPOLYGON}get interfaces_(){return[gt]}}let _t=class{get(){}put(){}size(){}values(){}entrySet(){}};class pt extends ot{constructor(t){super(),this.map=new Map,t instanceof N&&this.addAll(t)}contains(t){const e=t.hashCode?t.hashCode():t;return!!this.map.has(e)}add(t){const e=t.hashCode?t.hashCode():t;return!this.map.has(e)&&!!this.map.set(e,t)}addAll(t){for(const e of t)this.add(e);return!0}remove(){throw new U}size(){return this.map.size}isEmpty(){return 0===this.map.size}toArray(){return Array.from(this.map.values())}iterator(){return new mt(this.map)}[Symbol.iterator](){return this.map}}let mt=class{constructor(t){this.iterator=t.values();const{done:e,value:s}=this.iterator.next();this.done=e,this.value=s}next(){if(this.done)throw new S;const t=this.value,{done:e,value:s}=this.iterator.next();return this.done=e,this.value=s,t}hasNext(){return!this.done}remove(){throw new U}};class ft extends _t{constructor(){super(),this.map=new Map}get(t){return this.map.get(t)||null}put(t,e){return this.map.set(t,e),e}values(){const t=new L,e=this.map.values();let s=e.next();for(;!s.done;)t.add(s.value),s=e.next();return t}entrySet(){const t=new pt;return this.map.entries().forEach((e=>t.add(e))),t}size(){return this.map.size()}}class yt{constructor(){yt.constructor_.apply(this,arguments)}static constructor_(){if(this._modelType=null,this._scale=null,0===arguments.length)this._modelType=yt.FLOATING;else if(1===arguments.length)if(arguments[0]instanceof xt){const t=arguments[0];this._modelType=t,t===yt.FIXED&&this.setScale(1)}else if("number"==typeof arguments[0]){const t=arguments[0];this._modelType=yt.FIXED,this.setScale(t)}else if(arguments[0]instanceof yt){const t=arguments[0];this._modelType=t._modelType,this._scale=t._scale}}static mostPrecise(t,e){return t.compareTo(e)>=0?t:e}equals(t){if(!(t instanceof yt))return!1;const e=t;return this._modelType===e._modelType&&this._scale===e._scale}compareTo(t){const e=t,s=this.getMaximumSignificantDigits(),n=e.getMaximumSignificantDigits();return M.compare(s,n)}getType(){return this._modelType}toString(){let t="UNKNOWN";return this._modelType===yt.FLOATING?t="Floating":this._modelType===yt.FLOATING_SINGLE?t="Floating-Single":this._modelType===yt.FIXED&&(t="Fixed (Scale="+this.getScale()+")"),t}makePrecise(){if("number"==typeof arguments[0]){const t=arguments[0];if(r.isNaN(t))return t;if(this._modelType===yt.FLOATING_SINGLE){return t}return this._modelType===yt.FIXED?Math.round(t*this._scale)/this._scale:t}if(arguments[0]instanceof m){const t=arguments[0];if(this._modelType===yt.FLOATING)return null;t.x=this.makePrecise(t.x),t.y=this.makePrecise(t.y)}}getMaximumSignificantDigits(){let t=16;return this._modelType===yt.FLOATING?t=16:this._modelType===yt.FLOATING_SINGLE?t=6:this._modelType===yt.FIXED&&(t=1+Math.trunc(Math.ceil(Math.log(this.getScale())/Math.log(10)))),t}setScale(t){this._scale=Math.abs(t)}getScale(){return this._scale}isFloating(){return this._modelType===yt.FLOATING||this._modelType===yt.FLOATING_SINGLE}get interfaces_(){return[l,o]}}class xt{constructor(){xt.constructor_.apply(this,arguments)}static constructor_(){this._name=null;const t=arguments[0];this._name=t,xt.nameToTypeMap.put(t,this)}readResolve(){return xt.nameToTypeMap.get(this._name)}toString(){return this._name}get interfaces_(){return[l]}}xt.nameToTypeMap=new ft,yt.Type=xt,yt.FIXED=new xt("FIXED"),yt.FLOATING=new xt("FLOATING"),yt.FLOATING_SINGLE=new xt("FLOATING SINGLE"),yt.maximumPreciseValue=9007199254740992;class Et extends ut{constructor(){super(),Et.constructor_.apply(this,arguments)}static constructor_(){const t=arguments[0],e=arguments[1];ut.constructor_.call(this,t,e)}copyInternal(){const t=new Array(this._geometries.length).fill(null);for(let e=0;e<t.length;e++)t[e]=this._geometries[e].copy();return new Et(t,this._factory)}equalsExact(){if(2===arguments.length&&"number"==typeof arguments[1]&&arguments[0]instanceof j){const t=arguments[0],e=arguments[1];return!!this.isEquivalentClass(t)&&super.equalsExact.call(this,t,e)}return super.equalsExact.apply(this,arguments)}getBoundaryDimension(){return this.isClosed()?Z.FALSE:0}isClosed(){if(this.isEmpty())return!1;for(let t=0;t<this._geometries.length;t++)if(!this._geometries[t].isClosed())return!1;return!0}getTypeCode(){return j.TYPECODE_MULTILINESTRING}getDimension(){return 1}getBoundary(){throw new U}getGeometryType(){return j.TYPENAME_MULTILINESTRING}get interfaces_(){return[Q]}}class It{}class Nt extends j{constructor(){super(),Nt.constructor_.apply(this,arguments)}static constructor_(){this._coordinates=null;const t=arguments[0],e=arguments[1];j.constructor_.call(this,e),this.init(t)}computeEnvelopeInternal(){if(this.isEmpty())return new O;const t=new O;return t.expandToInclude(this._coordinates.getX(0),this._coordinates.getY(0)),t}getCoordinates(){return this.isEmpty()?[]:[this.getCoordinate()]}copyInternal(){return new Nt(this._coordinates.copy(),this._factory)}equalsExact(){if(2===arguments.length&&"number"==typeof arguments[1]&&arguments[0]instanceof j){const t=arguments[0],e=arguments[1];return!!this.isEquivalentClass(t)&&(!(!this.isEmpty()||!t.isEmpty())||this.isEmpty()===t.isEmpty()&&this.equal(t.getCoordinate(),this.getCoordinate(),e))}return super.equalsExact.apply(this,arguments)}reverseInternal(){return this.getFactory().createPoint(this._coordinates.copy())}getTypeCode(){return j.TYPECODE_POINT}getDimension(){return 0}getNumPoints(){return this.isEmpty()?0:1}getX(){if(null===this.getCoordinate())throw new D("getX called on empty Point");return this.getCoordinate().x}getBoundary(){return this.getFactory().createGeometryCollection()}getGeometryType(){return j.TYPENAME_POINT}getCoordinateSequence(){return this._coordinates}getY(){if(null===this.getCoordinate())throw new D("getY called on empty Point");return this.getCoordinate().y}isSimple(){return!0}normalize(){}getCoordinate(){return 0!==this._coordinates.size()?this._coordinates.getCoordinate(0):null}getBoundaryDimension(){return Z.FALSE}compareToSameClass(){if(1===arguments.length){const t=arguments[0];return this.getCoordinate().compareTo(t.getCoordinate())}if(2===arguments.length){const t=arguments[0];return arguments[1].compare(this._coordinates,t._coordinates)}}apply(){if(I(arguments[0],K)){const t=arguments[0];if(this.isEmpty())return null;t.filter(this.getCoordinate())}else if(I(arguments[0],P)){const t=arguments[0];if(this.isEmpty())return null;t.filter(this._coordinates,0),t.isGeometryChanged()&&this.geometryChanged()}else if(I(arguments[0],$)){arguments[0].filter(this)}else if(I(arguments[0],X)){arguments[0].filter(this)}}isEmpty(){return 0===this._coordinates.size()}init(t){null===t&&(t=this.getFactory().getCoordinateSequenceFactory().create([])),h.isTrue(t.size()<=1),this._coordinates=t}get interfaces_(){return[It]}}class wt{static ofRingSigned(){if(arguments[0]instanceof Array){const t=arguments[0];if(t.length<3)return 0;let e=0;const s=t[0].x;for(let n=1;n<t.length-1;n++){const i=t[n].x-s,r=t[n+1].y;e+=i*(t[n-1].y-r)}return e/2}if(I(arguments[0],G)){const t=arguments[0],e=t.size();if(e<3)return 0;const s=new m,n=new m,i=new m;t.getCoordinate(0,n),t.getCoordinate(1,i);const r=n.x;i.x-=r;let o=0;for(let l=1;l<e-1;l++)s.y=n.y,n.x=i.x,n.y=i.y,t.getCoordinate(l+1,i),i.x-=r,o+=n.x*(s.y-i.y);return o/2}}static ofRing(){if(arguments[0]instanceof Array){const t=arguments[0];return Math.abs(wt.ofRingSigned(t))}if(I(arguments[0],G)){const t=arguments[0];return Math.abs(wt.ofRingSigned(t))}}}class Ct extends j{constructor(){super(),Ct.constructor_.apply(this,arguments)}static constructor_(){this._shell=null,this._holes=null;let t=arguments[0],e=arguments[1],s=arguments[2];if(j.constructor_.call(this,s),null===t&&(t=this.getFactory().createLinearRing()),null===e&&(e=[]),j.hasNullElements(e))throw new n("holes must not contain null elements");if(t.isEmpty()&&j.hasNonEmptyElements(e))throw new n("shell is empty but holes are not");this._shell=t,this._holes=e}computeEnvelopeInternal(){return this._shell.getEnvelopeInternal()}getCoordinates(){if(this.isEmpty())return[];const t=new Array(this.getNumPoints()).fill(null);let e=-1;const s=this._shell.getCoordinates();for(let n=0;n<s.length;n++)e++,t[e]=s[n];for(let s=0;s<this._holes.length;s++){const n=this._holes[s].getCoordinates();for(let s=0;s<n.length;s++)e++,t[e]=n[s]}return t}getArea(){let t=0;t+=wt.ofRing(this._shell.getCoordinateSequence());for(let e=0;e<this._holes.length;e++)t-=wt.ofRing(this._holes[e].getCoordinateSequence());return t}equalsExact(){if(2===arguments.length&&"number"==typeof arguments[1]&&arguments[0]instanceof j){const t=arguments[0],e=arguments[1];if(!this.isEquivalentClass(t))return!1;const s=t,n=this._shell,i=s._shell;if(!n.equalsExact(i,e))return!1;if(this._holes.length!==s._holes.length)return!1;for(let t=0;t<this._holes.length;t++)if(!this._holes[t].equalsExact(s._holes[t],e))return!1;return!0}return super.equalsExact.apply(this,arguments)}reverseInternal(){const t=this.getExteriorRing().reverse(),e=new Array(this.getNumInteriorRing()).fill(null);for(let t=0;t<e.length;t++)e[t]=this.getInteriorRingN(t).reverse();return this.getFactory().createPolygon(t,e)}getTypeCode(){return j.TYPECODE_POLYGON}getDimension(){return 2}getBoundary(){if(this.isEmpty())return this.getFactory().createMultiLineString();const t=new Array(this._holes.length+1).fill(null);t[0]=this._shell;for(let e=0;e<this._holes.length;e++)t[e+1]=this._holes[e];return t.length<=1?this.getFactory().createLinearRing(t[0].getCoordinateSequence()):this.getFactory().createMultiLineString(t)}getGeometryType(){return j.TYPENAME_POLYGON}getExteriorRing(){return this._shell}copyInternal(){const t=this._shell.copy(),e=new Array(this._holes.length).fill(null);for(let t=0;t<this._holes.length;t++)e[t]=this._holes[t].copy();return new Ct(t,e,this._factory)}isRectangle(){if(0!==this.getNumInteriorRing())return!1;if(null===this._shell)return!1;if(5!==this._shell.getNumPoints())return!1;const t=this._shell.getCoordinateSequence(),e=this.getEnvelopeInternal();for(let s=0;s<5;s++){const n=t.getX(s);if(n!==e.getMinX()&&n!==e.getMaxX())return!1;const i=t.getY(s);if(i!==e.getMinY()&&i!==e.getMaxY())return!1}let s=t.getX(0),n=t.getY(0);for(let e=1;e<=4;e++){const i=t.getX(e),r=t.getY(e);if(i!==s===(r!==n))return!1;s=i,n=r}return!0}normalize(){if(0===arguments.length){this._shell=this.normalized(this._shell,!0);for(let t=0;t<this._holes.length;t++)this._holes[t]=this.normalized(this._holes[t],!1);ht.sort(this._holes)}else if(2===arguments.length){const t=arguments[0],e=arguments[1];if(t.isEmpty())return null;const s=t.getCoordinateSequence(),n=J.minCoordinateIndex(s,0,s.size()-2);J.scroll(s,n,!0),q.isCCW(s)===e&&J.reverse(s)}}getCoordinate(){return this._shell.getCoordinate()}getNumInteriorRing(){return this._holes.length}getBoundaryDimension(){return 1}getLength(){let t=0;t+=this._shell.getLength();for(let e=0;e<this._holes.length;e++)t+=this._holes[e].getLength();return t}getNumPoints(){let t=this._shell.getNumPoints();for(let e=0;e<this._holes.length;e++)t+=this._holes[e].getNumPoints();return t}convexHull(){return this.getExteriorRing().convexHull()}normalized(t,e){const s=t.copy();return this.normalize(s,e),s}compareToSameClass(){if(1===arguments.length){const t=arguments[0],e=this._shell,s=t._shell;return e.compareToSameClass(s)}if(2===arguments.length){const t=arguments[1],e=arguments[0],s=this._shell,n=e._shell,i=s.compareToSameClass(n,t);if(0!==i)return i;const r=this.getNumInteriorRing(),o=e.getNumInteriorRing();let l=0;for(;l<r&&l<o;){const s=this.getInteriorRingN(l),n=e.getInteriorRingN(l),i=s.compareToSameClass(n,t);if(0!==i)return i;l++}return l<r?1:l<o?-1:0}}apply(){if(I(arguments[0],K)){const t=arguments[0];this._shell.apply(t);for(let e=0;e<this._holes.length;e++)this._holes[e].apply(t)}else if(I(arguments[0],P)){const t=arguments[0];if(this._shell.apply(t),!t.isDone())for(let e=0;e<this._holes.length&&(this._holes[e].apply(t),!t.isDone());e++);t.isGeometryChanged()&&this.geometryChanged()}else if(I(arguments[0],$)){arguments[0].filter(this)}else if(I(arguments[0],X)){const t=arguments[0];t.filter(this),this._shell.apply(t);for(let e=0;e<this._holes.length;e++)this._holes[e].apply(t)}}isEmpty(){return this._shell.isEmpty()}getInteriorRingN(t){return this._holes[t]}get interfaces_(){return[gt]}}class St extends ut{constructor(){super(),St.constructor_.apply(this,arguments)}static constructor_(){const t=arguments[0],e=arguments[1];ut.constructor_.call(this,t,e)}equalsExact(){if(2===arguments.length&&"number"==typeof arguments[1]&&arguments[0]instanceof j){const t=arguments[0],e=arguments[1];return!!this.isEquivalentClass(t)&&super.equalsExact.call(this,t,e)}return super.equalsExact.apply(this,arguments)}getTypeCode(){return j.TYPECODE_MULTIPOINT}getDimension(){return 0}getBoundary(){return this.getFactory().createGeometryCollection()}getGeometryType(){return j.TYPENAME_MULTIPOINT}copyInternal(){const t=new Array(this._geometries.length).fill(null);for(let e=0;e<t.length;e++)t[e]=this._geometries[e].copy();return new St(t,this._factory)}isValid(){return!0}getCoordinate(){if(1===arguments.length&&Number.isInteger(arguments[0])){const t=arguments[0];return this._geometries[t].getCoordinate()}return super.getCoordinate.apply(this,arguments)}getBoundaryDimension(){return Z.FALSE}get interfaces_(){return[It]}}class Lt{constructor(){Lt.constructor_.apply(this,arguments)}static constructor_(){if(this._precisionModel=null,this._coordinateSequenceFactory=null,this._SRID=null,0===arguments.length)Lt.constructor_.call(this,new yt,0);else if(1===arguments.length){if(I(arguments[0],st)){const t=arguments[0];Lt.constructor_.call(this,new yt,0,t)}else if(arguments[0]instanceof yt){const t=arguments[0];Lt.constructor_.call(this,t,0,Lt.getDefaultCoordinateSequenceFactory())}}else if(2===arguments.length){const t=arguments[0],e=arguments[1];Lt.constructor_.call(this,t,e,Lt.getDefaultCoordinateSequenceFactory())}else if(3===arguments.length){const t=arguments[0],e=arguments[1],s=arguments[2];this._precisionModel=t,this._coordinateSequenceFactory=s,this._SRID=e}}static toMultiPolygonArray(t){const e=new Array(t.size()).fill(null);return t.toArray(e)}static toGeometryArray(t){if(null===t)return null;const e=new Array(t.size()).fill(null);return t.toArray(e)}static getDefaultCoordinateSequenceFactory(){return rt.instance()}static toMultiLineStringArray(t){const e=new Array(t.size()).fill(null);return t.toArray(e)}static toLineStringArray(t){const e=new Array(t.size()).fill(null);return t.toArray(e)}static toMultiPointArray(t){const e=new Array(t.size()).fill(null);return t.toArray(e)}static toLinearRingArray(t){const e=new Array(t.size()).fill(null);return t.toArray(e)}static toPointArray(t){const e=new Array(t.size()).fill(null);return t.toArray(e)}static toPolygonArray(t){const e=new Array(t.size()).fill(null);return t.toArray(e)}static createPointFromInternalCoord(t,e){return e.getPrecisionModel().makePrecise(t),e.getFactory().createPoint(t)}createEmpty(t){switch(t){case-1:return this.createGeometryCollection();case 0:return this.createPoint();case 1:return this.createLineString();case 2:return this.createPolygon();default:throw new n("Invalid dimension: "+t)}}toGeometry(t){return t.isNull()?this.createPoint():t.getMinX()===t.getMaxX()&&t.getMinY()===t.getMaxY()?this.createPoint(new m(t.getMinX(),t.getMinY())):t.getMinX()===t.getMaxX()||t.getMinY()===t.getMaxY()?this.createLineString([new m(t.getMinX(),t.getMinY()),new m(t.getMaxX(),t.getMaxY())]):this.createPolygon(this.createLinearRing([new m(t.getMinX(),t.getMinY()),new m(t.getMinX(),t.getMaxY()),new m(t.getMaxX(),t.getMaxY()),new m(t.getMaxX(),t.getMinY()),new m(t.getMinX(),t.getMinY())]),null)}createLineString(){if(0===arguments.length)return this.createLineString(this.getCoordinateSequenceFactory().create([]));if(1===arguments.length){if(arguments[0]instanceof Array){const t=arguments[0];return this.createLineString(null!==t?this.getCoordinateSequenceFactory().create(t):null)}if(I(arguments[0],G)){return new tt(arguments[0],this)}}}createMultiLineString(){if(0===arguments.length)return new Et(null,this);if(1===arguments.length){return new Et(arguments[0],this)}}createPolygon(){if(0===arguments.length)return this.createPolygon(null,null);if(1===arguments.length){if(I(arguments[0],G)){const t=arguments[0];return this.createPolygon(this.createLinearRing(t))}if(arguments[0]instanceof Array){const t=arguments[0];return this.createPolygon(this.createLinearRing(t))}if(arguments[0]instanceof et){const t=arguments[0];return this.createPolygon(t,null)}}else if(2===arguments.length){return new Ct(arguments[0],arguments[1],this)}}getSRID(){return this._SRID}createGeometryCollection(){if(0===arguments.length)return new ut(null,this);if(1===arguments.length){return new ut(arguments[0],this)}}getPrecisionModel(){return this._precisionModel}createLinearRing(){if(0===arguments.length)return this.createLinearRing(this.getCoordinateSequenceFactory().create([]));if(1===arguments.length){if(arguments[0]instanceof Array){const t=arguments[0];return this.createLinearRing(null!==t?this.getCoordinateSequenceFactory().create(t):null)}if(I(arguments[0],G)){return new et(arguments[0],this)}}}createMultiPolygon(){if(0===arguments.length)return new dt(null,this);if(1===arguments.length){return new dt(arguments[0],this)}}createMultiPoint(){if(0===arguments.length)return new St(null,this);if(1===arguments.length){if(arguments[0]instanceof Array){return new St(arguments[0],this)}if(I(arguments[0],G)){const t=arguments[0];if(null===t)return this.createMultiPoint(new Array(0).fill(null));const e=new Array(t.size()).fill(null);for(let s=0;s<t.size();s++){const n=this.getCoordinateSequenceFactory().create(1,t.getDimension(),t.getMeasures());J.copy(t,s,n,0,1),e[s]=this.createPoint(n)}return this.createMultiPoint(e)}}}buildGeometry(t){let e=null,s=!1,n=!1;for(let i=t.iterator();i.hasNext();){const t=i.next(),r=t.getTypeCode();null===e&&(e=r),r!==e&&(s=!0),t instanceof ut&&(n=!0)}if(null===e)return this.createGeometryCollection();if(s||n)return this.createGeometryCollection(Lt.toGeometryArray(t));const i=t.iterator().next();if(t.size()>1){if(i instanceof Ct)return this.createMultiPolygon(Lt.toPolygonArray(t));if(i instanceof tt)return this.createMultiLineString(Lt.toLineStringArray(t));if(i instanceof Nt)return this.createMultiPoint(Lt.toPointArray(t));h.shouldNeverReachHere("Unhandled geometry type: "+i.getGeometryType())}return i}createMultiPointFromCoords(t){return this.createMultiPoint(null!==t?this.getCoordinateSequenceFactory().create(t):null)}createPoint(){if(0===arguments.length)return this.createPoint(this.getCoordinateSequenceFactory().create([]));if(1===arguments.length){if(arguments[0]instanceof m){const t=arguments[0];return this.createPoint(null!==t?this.getCoordinateSequenceFactory().create([t]):null)}if(I(arguments[0],G)){return new Nt(arguments[0],this)}}}getCoordinateSequenceFactory(){return this._coordinateSequenceFactory}get interfaces_(){return[l]}}const Tt="XY",Rt="XYZ",Pt="XYM",Ot="XYZM",vt={POINT:"Point",LINE_STRING:"LineString",LINEAR_RING:"LinearRing",POLYGON:"Polygon",MULTI_POINT:"MultiPoint",MULTI_LINE_STRING:"MultiLineString",MULTI_POLYGON:"MultiPolygon",GEOMETRY_COLLECTION:"GeometryCollection",CIRCLE:"Circle"},Mt="EMPTY",bt=1,Dt=2,At=3,Ft=4,Gt=5,qt=6;for(const t in vt)vt[t].toUpperCase();class Bt{constructor(t){this.wkt=t,this.index_=-1}isAlpha_(t){return t>="a"&&t<="z"||t>="A"&&t<="Z"}isNumeric_(t,e){return t>="0"&&t<="9"||"."==t&&!(void 0!==e&&e)}isWhiteSpace_(t){return" "==t||"\t"==t||"\r"==t||"\n"==t}nextChar_(){return this.wkt.charAt(++this.index_)}nextToken(){const t=this.nextChar_(),e=this.index_;let s,n=t;if("("==t)s=Dt;else if(","==t)s=Gt;else if(")"==t)s=At;else if(this.isNumeric_(t)||"-"==t)s=Ft,n=this.readNumber_();else if(this.isAlpha_(t))s=bt,n=this.readText_();else{if(this.isWhiteSpace_(t))return this.nextToken();if(""!==t)throw new Error("Unexpected character: "+t);s=qt}return{position:e,value:n,type:s}}readNumber_(){let t;const e=this.index_;let s=!1,n=!1;do{"."==t?s=!0:"e"!=t&&"E"!=t||(n=!0),t=this.nextChar_()}while(this.isNumeric_(t,s)||!n&&("e"==t||"E"==t)||n&&("-"==t||"+"==t));return parseFloat(this.wkt.substring(e,this.index_--))}readText_(){let t;const e=this.index_;do{t=this.nextChar_()}while(this.isAlpha_(t));return this.wkt.substring(e,this.index_--).toUpperCase()}}class Yt{constructor(t,e){this.lexer_=t,this.token_,this.layout_=Tt,this.factory=e}consume_(){this.token_=this.lexer_.nextToken()}isTokenType(t){return this.token_.type==t}match(t){const e=this.isTokenType(t);return e&&this.consume_(),e}parse(){this.consume_();return this.parseGeometry_()}parseGeometryLayout_(){let t=Tt;const e=this.token_;if(this.isTokenType(bt)){const s=e.value;"Z"===s?t=Rt:"M"===s?t=Pt:"ZM"===s&&(t=Ot),t!==Tt&&this.consume_()}return t}parseGeometryCollectionText_(){if(this.match(Dt)){const t=[];do{t.push(this.parseGeometry_())}while(this.match(Gt));if(this.match(At))return t}else if(this.isEmptyGeometry_())return[];throw new Error(this.formatErrorMessage_())}parsePointText_(){if(this.match(Dt)){const t=this.parsePoint_();if(this.match(At))return t}else if(this.isEmptyGeometry_())return null;throw new Error(this.formatErrorMessage_())}parseLineStringText_(){if(this.match(Dt)){const t=this.parsePointList_();if(this.match(At))return t}else if(this.isEmptyGeometry_())return[];throw new Error(this.formatErrorMessage_())}parsePolygonText_(){if(this.match(Dt)){const t=this.parseLineStringTextList_();if(this.match(At))return t}else if(this.isEmptyGeometry_())return[];throw new Error(this.formatErrorMessage_())}parseMultiPointText_(){if(this.match(Dt)){let t;if(t=this.token_.type==Dt?this.parsePointTextList_():this.parsePointList_(),this.match(At))return t}else if(this.isEmptyGeometry_())return[];throw new Error(this.formatErrorMessage_())}parseMultiLineStringText_(){if(this.match(Dt)){const t=this.parseLineStringTextList_();if(this.match(At))return t}else if(this.isEmptyGeometry_())return[];throw new Error(this.formatErrorMessage_())}parseMultiPolygonText_(){if(this.match(Dt)){const t=this.parsePolygonTextList_();if(this.match(At))return t}else if(this.isEmptyGeometry_())return[];throw new Error(this.formatErrorMessage_())}parsePoint_(){const t=[],e=this.layout_.length;for(let s=0;s<e;++s){const e=this.token_;if(!this.match(Ft))break;t.push(e.value)}if(t.length==e)return t;throw new Error(this.formatErrorMessage_())}parsePointList_(){const t=[this.parsePoint_()];for(;this.match(Gt);)t.push(this.parsePoint_());return t}parsePointTextList_(){const t=[this.parsePointText_()];for(;this.match(Gt);)t.push(this.parsePointText_());return t}parseLineStringTextList_(){const t=[this.parseLineStringText_()];for(;this.match(Gt);)t.push(this.parseLineStringText_());return t}parsePolygonTextList_(){const t=[this.parsePolygonText_()];for(;this.match(Gt);)t.push(this.parsePolygonText_());return t}isEmptyGeometry_(){const t=this.isTokenType(bt)&&this.token_.value==Mt;return t&&this.consume_(),t}formatErrorMessage_(){return"Unexpected `"+this.token_.value+"` at position "+this.token_.position+" in `"+this.lexer_.wkt+"`"}parseGeometry_(){const t=this.factory,e=t=>t?new m(...t):new m,s=s=>{const n=s.map((s=>t.createLinearRing(s.map(e))));return n.length>1?t.createPolygon(n[0],n.slice(1)):1===n.length?t.createPolygon(n[0]):t.createPolygon()},n=this.token_;if(this.match(bt)){const i=n.value;if(this.layout_=this.parseGeometryLayout_(),"GEOMETRYCOLLECTION"==i){const e=this.parseGeometryCollectionText_();return t.createGeometryCollection(e)}switch(i){case"POINT":{const e=this.parsePointText_();return e?t.createPoint(new m(...e)):t.createPoint()}case"LINESTRING":{const s=this.parseLineStringText_().map(e);return t.createLineString(s)}case"LINEARRING":{const s=this.parseLineStringText_().map(e);return t.createLinearRing(s)}case"POLYGON":{const e=this.parsePolygonText_();return e&&0!==e.length?s(e):t.createPolygon()}case"MULTIPOINT":{const s=this.parseMultiPointText_();if(!s||0===s.length)return t.createMultiPoint();const n=s.map(e).map((e=>t.createPoint(e)));return t.createMultiPoint(n)}case"MULTILINESTRING":{const s=this.parseMultiLineStringText_().map((s=>t.createLineString(s.map(e))));return t.createMultiLineString(s)}case"MULTIPOLYGON":{const e=this.parseMultiPolygonText_();if(!e||0===e.length)return t.createMultiPolygon();const n=e.map(s);return t.createMultiPolygon(n)}default:throw new Error("Invalid geometry type: "+i)}}throw new Error(this.formatErrorMessage_())}}function zt(t){if(t.isEmpty())return"";const e=t.getCoordinate(),s=[e.x,e.y];return void 0===e.z||Number.isNaN(e.z)||s.push(e.z),void 0===e.m||Number.isNaN(e.m)||s.push(e.m),s.join(" ")}function Vt(t){const e=t.getCoordinates().map((t=>{const e=[t.x,t.y];return void 0===t.z||Number.isNaN(t.z)||e.push(t.z),void 0===t.m||Number.isNaN(t.m)||e.push(t.m),e})),s=[];for(let t=0,n=e.length;t<n;++t)s.push(e[t].join(" "));return s.join(", ")}function kt(t){const e=[];e.push("("+Vt(t.getExteriorRing())+")");for(let s=0,n=t.getNumInteriorRing();s<n;++s)e.push("("+Vt(t.getInteriorRingN(s))+")");return e.join(", ")}const Xt={Point:zt,LineString:Vt,LinearRing:Vt,Polygon:kt,MultiPoint:function(t){const e=[];for(let s=0,n=t.getNumGeometries();s<n;++s)e.push("("+zt(t.getGeometryN(s))+")");return e.join(", ")},MultiLineString:function(t){const e=[];for(let s=0,n=t.getNumGeometries();s<n;++s)e.push("("+Vt(t.getGeometryN(s))+")");return e.join(", ")},MultiPolygon:function(t){const e=[];for(let s=0,n=t.getNumGeometries();s<n;++s)e.push("("+kt(t.getGeometryN(s))+")");return e.join(", ")},GeometryCollection:function(t){const e=[];for(let s=0,n=t.getNumGeometries();s<n;++s)e.push(Ut(t.getGeometryN(s)));return e.join(", ")}};function Ut(t){let e=t.getGeometryType();const s=Xt[e];e=e.toUpperCase();const n=function(t){let e="";if(t.isEmpty())return e;const s=t.getCoordinate();return void 0===s.z||Number.isNaN(s.z)||(e+="Z"),void 0===s.m||Number.isNaN(s.m)||(e+="M"),e}(t);if(n.length>0&&(e+=" "+n),t.isEmpty())return e+" "+Mt;return e+" ("+s(t)+")"}class Ht{constructor(t){this.geometryFactory=t||new Lt,this.precisionModel=this.geometryFactory.getPrecisionModel()}read(t){const e=new Bt(t);return new Yt(e,this.geometryFactory).parse()}write(t){return Ut(t)}}class Wt{constructor(t){this.parser=new Ht(t)}write(t){return this.parser.write(t)}static toLineString(t,e){if(2!==arguments.length)throw new Error("Not implemented");return"LINESTRING ( "+t.x+" "+t.y+", "+e.x+" "+e.y+" )"}}class Zt{constructor(){Zt.constructor_.apply(this,arguments)}static constructor_(){this._result=null,this._inputLines=Array(2).fill().map((()=>Array(2))),this._intPt=new Array(2).fill(null),this._intLineIndex=null,this._isProper=null,this._pa=null,this._pb=null,this._precisionModel=null,this._intPt[0]=new m,this._intPt[1]=new m,this._pa=this._intPt[0],this._pb=this._intPt[1],this._result=0}static nonRobustComputeEdgeDistance(t,e,s){const n=t.x-e.x,i=t.y-e.y,r=Math.sqrt(n*n+i*i);return h.isTrue(!(0===r&&!t.equals(e)),"Invalid distance calculation"),r}static computeEdgeDistance(t,e,s){const n=Math.abs(s.x-e.x),i=Math.abs(s.y-e.y);let r=-1;if(t.equals(e))r=0;else if(t.equals(s))r=n>i?n:i;else{const s=Math.abs(t.x-e.x),o=Math.abs(t.y-e.y);r=n>i?s:o,0!==r||t.equals(e)||(r=Math.max(s,o))}return h.isTrue(!(0===r&&!t.equals(e)),"Bad distance calculation"),r}computeIntersection(t,e,s,n){this._inputLines[0][0]=t,this._inputLines[0][1]=e,this._inputLines[1][0]=s,this._inputLines[1][1]=n,this._result=this.computeIntersect(t,e,s,n)}getIntersectionNum(){return this._result}computeIntLineIndex(){if(0===arguments.length)null===this._intLineIndex&&(this._intLineIndex=Array(2).fill().map((()=>Array(2))),this.computeIntLineIndex(0),this.computeIntLineIndex(1));else if(1===arguments.length){const t=arguments[0];this.getEdgeDistance(t,0)>this.getEdgeDistance(t,1)?(this._intLineIndex[t][0]=0,this._intLineIndex[t][1]=1):(this._intLineIndex[t][0]=1,this._intLineIndex[t][1]=0)}}isInteriorIntersection(){if(0===arguments.length)return!!this.isInteriorIntersection(0)||!!this.isInteriorIntersection(1);if(1===arguments.length){const t=arguments[0];for(let e=0;e<this._result;e++)if(!this._intPt[e].equals2D(this._inputLines[t][0])&&!this._intPt[e].equals2D(this._inputLines[t][1]))return!0;return!1}}getIntersection(t){return this._intPt[t]}getEdgeDistance(t,e){return Zt.computeEdgeDistance(this._intPt[e],this._inputLines[t][0],this._inputLines[t][1])}isCollinear(){return this._result===Zt.COLLINEAR_INTERSECTION}toString(){return Wt.toLineString(this._inputLines[0][0],this._inputLines[0][1])+" - "+Wt.toLineString(this._inputLines[1][0],this._inputLines[1][1])+this.getTopologySummary()}getEndpoint(t,e){return this._inputLines[t][e]}getIndexAlongSegment(t,e){return this.computeIntLineIndex(),this._intLineIndex[t][e]}getTopologySummary(){const t=new nt;return this.isEndPoint()&&t.append(" endpoint"),this._isProper&&t.append(" proper"),this.isCollinear()&&t.append(" collinear"),t.toString()}isProper(){return this.hasIntersection()&&this._isProper}setPrecisionModel(t){this._precisionModel=t}isEndPoint(){return this.hasIntersection()&&!this._isProper}hasIntersection(){return this._result!==Zt.NO_INTERSECTION}isIntersection(t){for(let e=0;e<this._result;e++)if(this._intPt[e].equals2D(t))return!0;return!1}getIntersectionAlongSegment(t,e){return this.computeIntLineIndex(),this._intPt[this._intLineIndex[t][e]]}}Zt.DONT_INTERSECT=0,Zt.DO_INTERSECT=1,Zt.COLLINEAR=2,Zt.NO_INTERSECTION=0,Zt.POINT_INTERSECTION=1,Zt.COLLINEAR_INTERSECTION=2;class jt extends Zt{constructor(){super()}static nearestEndpoint(t,e,s,n){let i=t,r=V.pointToSegment(t,s,n),o=V.pointToSegment(e,s,n);return o<r&&(r=o,i=e),o=V.pointToSegment(s,t,e),o<r&&(r=o,i=s),o=V.pointToSegment(n,t,e),o<r&&(r=o,i=n),i}isInSegmentEnvelopes(t){const e=new O(this._inputLines[0][0],this._inputLines[0][1]),s=new O(this._inputLines[1][0],this._inputLines[1][1]);return e.contains(t)&&s.contains(t)}computeIntersection(){if(3!==arguments.length)return super.computeIntersection.apply(this,arguments);{const t=arguments[0],e=arguments[1],s=arguments[2];if(this._isProper=!1,O.intersects(e,s,t)&&0===q.index(e,s,t)&&0===q.index(s,e,t))return this._isProper=!0,(t.equals(e)||t.equals(s))&&(this._isProper=!1),this._result=Zt.POINT_INTERSECTION,null;this._result=Zt.NO_INTERSECTION}}intersection(t,e,s,n){let i=this.intersectionSafe(t,e,s,n);return this.isInSegmentEnvelopes(i)||(i=new m(jt.nearestEndpoint(t,e,s,n))),null!==this._precisionModel&&this._precisionModel.makePrecise(i),i}checkDD(t,e,s,n,i){const r=F.intersection(t,e,s,n),o=this.isInSegmentEnvelopes(r);Y.out.println("DD in env = "+o+"  --------------------- "+r),i.distance(r)>1e-4&&Y.out.println("Distance = "+i.distance(r))}intersectionSafe(t,e,s,n){let i=B.intersection(t,e,s,n);return null===i&&(i=jt.nearestEndpoint(t,e,s,n)),i}computeCollinearIntersection(t,e,s,n){const i=O.intersects(t,e,s),r=O.intersects(t,e,n),o=O.intersects(s,n,t),l=O.intersects(s,n,e);return i&&r?(this._intPt[0]=s,this._intPt[1]=n,Zt.COLLINEAR_INTERSECTION):o&&l?(this._intPt[0]=t,this._intPt[1]=e,Zt.COLLINEAR_INTERSECTION):i&&o?(this._intPt[0]=s,this._intPt[1]=t,!s.equals(t)||r||l?Zt.COLLINEAR_INTERSECTION:Zt.POINT_INTERSECTION):i&&l?(this._intPt[0]=s,this._intPt[1]=e,!s.equals(e)||r||o?Zt.COLLINEAR_INTERSECTION:Zt.POINT_INTERSECTION):r&&o?(this._intPt[0]=n,this._intPt[1]=t,!n.equals(t)||i||l?Zt.COLLINEAR_INTERSECTION:Zt.POINT_INTERSECTION):r&&l?(this._intPt[0]=n,this._intPt[1]=e,!n.equals(e)||i||o?Zt.COLLINEAR_INTERSECTION:Zt.POINT_INTERSECTION):Zt.NO_INTERSECTION}computeIntersect(t,e,s,n){if(this._isProper=!1,!O.intersects(t,e,s,n))return Zt.NO_INTERSECTION;const i=q.index(t,e,s),r=q.index(t,e,n);if(i>0&&r>0||i<0&&r<0)return Zt.NO_INTERSECTION;const o=q.index(s,n,t),l=q.index(s,n,e);if(o>0&&l>0||o<0&&l<0)return Zt.NO_INTERSECTION;return 0===i&&0===r&&0===o&&0===l?this.computeCollinearIntersection(t,e,s,n):(0===i||0===r||0===o||0===l?(this._isProper=!1,t.equals2D(s)||t.equals2D(n)?this._intPt[0]=t:e.equals2D(s)||e.equals2D(n)?this._intPt[0]=e:0===i?this._intPt[0]=new m(s):0===r?this._intPt[0]=new m(n):0===o?this._intPt[0]=new m(t):0===l&&(this._intPt[0]=new m(e))):(this._isProper=!0,this._intPt[0]=this.intersection(t,e,s,n)),Zt.POINT_INTERSECTION)}}class Kt{constructor(){Kt.constructor_.apply(this,arguments)}static constructor_(){if(this.p0=null,this.p1=null,0===arguments.length)Kt.constructor_.call(this,new m,new m);else if(1===arguments.length){const t=arguments[0];Kt.constructor_.call(this,t.p0,t.p1)}else if(2===arguments.length){const t=arguments[0],e=arguments[1];this.p0=t,this.p1=e}else if(4===arguments.length){const t=arguments[0],e=arguments[1],s=arguments[2],n=arguments[3];Kt.constructor_.call(this,new m(t,e),new m(s,n))}}static midPoint(t,e){return new m((t.x+e.x)/2,(t.y+e.y)/2)}minX(){return Math.min(this.p0.x,this.p1.x)}orientationIndex(){if(arguments[0]instanceof Kt){const t=arguments[0],e=q.index(this.p0,this.p1,t.p0),s=q.index(this.p0,this.p1,t.p1);return e>=0&&s>=0||e<=0&&s<=0?Math.max(e,s):0}if(arguments[0]instanceof m){const t=arguments[0];return q.index(this.p0,this.p1,t)}}toGeometry(t){return t.createLineString([this.p0,this.p1])}isVertical(){return this.p0.x===this.p1.x}minY(){return Math.min(this.p0.y,this.p1.y)}midPoint(){return Kt.midPoint(this.p0,this.p1)}maxY(){return Math.max(this.p0.y,this.p1.y)}pointAlongOffset(t,e){const s=this.p0.x+t*(this.p1.x-this.p0.x),n=this.p0.y+t*(this.p1.y-this.p0.y),i=this.p1.x-this.p0.x,r=this.p1.y-this.p0.y,o=Math.sqrt(i*i+r*r);let l=0,a=0;if(0!==e){if(o<=0)throw new D("Cannot compute offset from zero-length line segment");l=e*i/o,a=e*r/o}return new m(s-a,n+l)}setCoordinates(){if(1===arguments.length){const t=arguments[0];this.setCoordinates(t.p0,t.p1)}else if(2===arguments.length){const t=arguments[0],e=arguments[1];this.p0.x=t.x,this.p0.y=t.y,this.p1.x=e.x,this.p1.y=e.y}}segmentFraction(t){let e=this.projectionFactor(t);return e<0?e=0:(e>1||r.isNaN(e))&&(e=1),e}toString(){return"LINESTRING( "+this.p0.x+" "+this.p0.y+", "+this.p1.x+" "+this.p1.y+")"}distance(){if(arguments[0]instanceof Kt){const t=arguments[0];return V.segmentToSegment(this.p0,this.p1,t.p0,t.p1)}if(arguments[0]instanceof m){const t=arguments[0];return V.pointToSegment(t,this.p0,this.p1)}}equals(t){if(!(t instanceof Kt))return!1;const e=t;return this.p0.equals(e.p0)&&this.p1.equals(e.p1)}intersection(t){const e=new jt;return e.computeIntersection(this.p0,this.p1,t.p0,t.p1),e.hasIntersection()?e.getIntersection(0):null}project(){if(arguments[0]instanceof m){const t=arguments[0];if(t.equals(this.p0)||t.equals(this.p1))return new m(t);const e=this.projectionFactor(t),s=new m;return s.x=this.p0.x+e*(this.p1.x-this.p0.x),s.y=this.p0.y+e*(this.p1.y-this.p0.y),s}if(arguments[0]instanceof Kt){const t=arguments[0],e=this.projectionFactor(t.p0),s=this.projectionFactor(t.p1);if(e>=1&&s>=1)return null;if(e<=0&&s<=0)return null;let n=this.project(t.p0);e<0&&(n=this.p0),e>1&&(n=this.p1);let i=this.project(t.p1);return s<0&&(i=this.p0),s>1&&(i=this.p1),new Kt(n,i)}}normalize(){this.p1.compareTo(this.p0)<0&&this.reverse()}angle(){return Math.atan2(this.p1.y-this.p0.y,this.p1.x-this.p0.x)}getCoordinate(t){return 0===t?this.p0:this.p1}distancePerpendicular(t){return V.pointToLinePerpendicular(t,this.p0,this.p1)}closestPoint(t){const e=this.projectionFactor(t);if(e>0&&e<1)return this.project(t);return this.p0.distance(t)<this.p1.distance(t)?this.p0:this.p1}projectionFactor(t){if(t.equals(this.p0))return 0;if(t.equals(this.p1))return 1;const e=this.p1.x-this.p0.x,s=this.p1.y-this.p0.y,n=e*e+s*s;if(n<=0)return r.NaN;return((t.x-this.p0.x)*e+(t.y-this.p0.y)*s)/n}closestPoints(t){const e=this.intersection(t);if(null!==e)return[e,e];const s=new Array(2).fill(null);let n=r.MAX_VALUE,i=null;const o=this.closestPoint(t.p0);n=o.distance(t.p0),s[0]=o,s[1]=t.p0;const l=this.closestPoint(t.p1);i=l.distance(t.p1),i<n&&(n=i,s[0]=l,s[1]=t.p1);const a=t.closestPoint(this.p0);i=a.distance(this.p0),i<n&&(n=i,s[0]=this.p0,s[1]=a);const c=t.closestPoint(this.p1);return i=c.distance(this.p1),i<n&&(n=i,s[0]=this.p1,s[1]=c),s}maxX(){return Math.max(this.p0.x,this.p1.x)}getLength(){return this.p0.distance(this.p1)}compareTo(t){const e=t,s=this.p0.compareTo(e.p0);return 0!==s?s:this.p1.compareTo(e.p1)}reverse(){const t=this.p0;this.p0=this.p1,this.p1=t}equalsTopo(t){return this.p0.equals(t.p0)&&this.p1.equals(t.p1)||this.p0.equals(t.p1)&&this.p1.equals(t.p0)}lineIntersection(t){return B.intersection(this.p0,this.p1,t.p0,t.p1)}isHorizontal(){return this.p0.y===this.p1.y}reflect(t){const e=this.p1.getY()-this.p0.getY(),s=this.p0.getX()-this.p1.getX(),n=this.p0.getY()*(this.p1.getX()-this.p0.getX())-this.p0.getX()*(this.p1.getY()-this.p0.getY()),i=e*e+s*s,r=e*e-s*s,o=t.getX(),l=t.getY();return new m((-r*o-2*e*s*l-2*e*n)/i,(r*l-2*e*s*o-2*s*n)/i)}pointAlong(t){const e=new m;return e.x=this.p0.x+t*(this.p1.x-this.p0.x),e.y=this.p0.y+t*(this.p1.y-this.p0.y),e}hashCode(){let t=r.doubleToLongBits(this.p0.x);t^=31*r.doubleToLongBits(this.p0.y);const e=Math.trunc(t)^Math.trunc(t>>32);let s=r.doubleToLongBits(this.p1.x);s^=31*r.doubleToLongBits(this.p1.y);return e^(Math.trunc(s)^Math.trunc(s>>32))}get interfaces_(){return[o,l]}}class Qt{static toLocationSymbol(t){switch(t){case Qt.EXTERIOR:return"e";case Qt.BOUNDARY:return"b";case Qt.INTERIOR:return"i";case Qt.NONE:return"-"}throw new n("Unknown location value: "+t)}}Qt.INTERIOR=0,Qt.BOUNDARY=1,Qt.EXTERIOR=2,Qt.NONE=-1;class Jt{constructor(){Jt.constructor_.apply(this,arguments)}static constructor_(){if(this._matrix=null,0===arguments.length)this._matrix=Array(3).fill().map((()=>Array(3))),this.setAll(Z.FALSE);else if(1===arguments.length)if("string"==typeof arguments[0]){const t=arguments[0];Jt.constructor_.call(this),this.set(t)}else if(arguments[0]instanceof Jt){const t=arguments[0];Jt.constructor_.call(this),this._matrix[Qt.INTERIOR][Qt.INTERIOR]=t._matrix[Qt.INTERIOR][Qt.INTERIOR],this._matrix[Qt.INTERIOR][Qt.BOUNDARY]=t._matrix[Qt.INTERIOR][Qt.BOUNDARY],this._matrix[Qt.INTERIOR][Qt.EXTERIOR]=t._matrix[Qt.INTERIOR][Qt.EXTERIOR],this._matrix[Qt.BOUNDARY][Qt.INTERIOR]=t._matrix[Qt.BOUNDARY][Qt.INTERIOR],this._matrix[Qt.BOUNDARY][Qt.BOUNDARY]=t._matrix[Qt.BOUNDARY][Qt.BOUNDARY],this._matrix[Qt.BOUNDARY][Qt.EXTERIOR]=t._matrix[Qt.BOUNDARY][Qt.EXTERIOR],this._matrix[Qt.EXTERIOR][Qt.INTERIOR]=t._matrix[Qt.EXTERIOR][Qt.INTERIOR],this._matrix[Qt.EXTERIOR][Qt.BOUNDARY]=t._matrix[Qt.EXTERIOR][Qt.BOUNDARY],this._matrix[Qt.EXTERIOR][Qt.EXTERIOR]=t._matrix[Qt.EXTERIOR][Qt.EXTERIOR]}}static isTrue(t){return t>=0||t===Z.TRUE}static matches(){if(Number.isInteger(arguments[0])&&"string"==typeof arguments[1]){const t=arguments[0],e=arguments[1];return e===Z.SYM_DONTCARE||(e===Z.SYM_TRUE&&(t>=0||t===Z.TRUE)||(e===Z.SYM_FALSE&&t===Z.FALSE||(e===Z.SYM_P&&t===Z.P||(e===Z.SYM_L&&t===Z.L||e===Z.SYM_A&&t===Z.A))))}if("string"==typeof arguments[0]&&"string"==typeof arguments[1]){const t=arguments[1];return new Jt(arguments[0]).matches(t)}}isIntersects(){return!this.isDisjoint()}set(){if(1===arguments.length){const t=arguments[0];for(let e=0;e<t.length;e++){const s=Math.trunc(e/3),n=e%3;this._matrix[s][n]=Z.toDimensionValue(t.charAt(e))}}else if(3===arguments.length){const t=arguments[0],e=arguments[1],s=arguments[2];this._matrix[t][e]=s}}isContains(){return Jt.isTrue(this._matrix[Qt.INTERIOR][Qt.INTERIOR])&&this._matrix[Qt.EXTERIOR][Qt.INTERIOR]===Z.FALSE&&this._matrix[Qt.EXTERIOR][Qt.BOUNDARY]===Z.FALSE}isWithin(){return Jt.isTrue(this._matrix[Qt.INTERIOR][Qt.INTERIOR])&&this._matrix[Qt.INTERIOR][Qt.EXTERIOR]===Z.FALSE&&this._matrix[Qt.BOUNDARY][Qt.EXTERIOR]===Z.FALSE}isTouches(t,e){return t>e?this.isTouches(e,t):(t===Z.A&&e===Z.A||t===Z.L&&e===Z.L||t===Z.L&&e===Z.A||t===Z.P&&e===Z.A||t===Z.P&&e===Z.L)&&(this._matrix[Qt.INTERIOR][Qt.INTERIOR]===Z.FALSE&&(Jt.isTrue(this._matrix[Qt.INTERIOR][Qt.BOUNDARY])||Jt.isTrue(this._matrix[Qt.BOUNDARY][Qt.INTERIOR])||Jt.isTrue(this._matrix[Qt.BOUNDARY][Qt.BOUNDARY])))}isOverlaps(t,e){return t===Z.P&&e===Z.P||t===Z.A&&e===Z.A?Jt.isTrue(this._matrix[Qt.INTERIOR][Qt.INTERIOR])&&Jt.isTrue(this._matrix[Qt.INTERIOR][Qt.EXTERIOR])&&Jt.isTrue(this._matrix[Qt.EXTERIOR][Qt.INTERIOR]):t===Z.L&&e===Z.L&&(1===this._matrix[Qt.INTERIOR][Qt.INTERIOR]&&Jt.isTrue(this._matrix[Qt.INTERIOR][Qt.EXTERIOR])&&Jt.isTrue(this._matrix[Qt.EXTERIOR][Qt.INTERIOR]))}isEquals(t,e){return t===e&&(Jt.isTrue(this._matrix[Qt.INTERIOR][Qt.INTERIOR])&&this._matrix[Qt.INTERIOR][Qt.EXTERIOR]===Z.FALSE&&this._matrix[Qt.BOUNDARY][Qt.EXTERIOR]===Z.FALSE&&this._matrix[Qt.EXTERIOR][Qt.INTERIOR]===Z.FALSE&&this._matrix[Qt.EXTERIOR][Qt.BOUNDARY]===Z.FALSE)}matches(t){if(9!==t.length)throw new n("Should be length 9: "+t);for(let e=0;e<3;e++)for(let s=0;s<3;s++)if(!Jt.matches(this._matrix[e][s],t.charAt(3*e+s)))return!1;return!0}add(t){for(let e=0;e<3;e++)for(let s=0;s<3;s++)this.setAtLeast(e,s,t.get(e,s))}isDisjoint(){return this._matrix[Qt.INTERIOR][Qt.INTERIOR]===Z.FALSE&&this._matrix[Qt.INTERIOR][Qt.BOUNDARY]===Z.FALSE&&this._matrix[Qt.BOUNDARY][Qt.INTERIOR]===Z.FALSE&&this._matrix[Qt.BOUNDARY][Qt.BOUNDARY]===Z.FALSE}isCrosses(t,e){return t===Z.P&&e===Z.L||t===Z.P&&e===Z.A||t===Z.L&&e===Z.A?Jt.isTrue(this._matrix[Qt.INTERIOR][Qt.INTERIOR])&&Jt.isTrue(this._matrix[Qt.INTERIOR][Qt.EXTERIOR]):t===Z.L&&e===Z.P||t===Z.A&&e===Z.P||t===Z.A&&e===Z.L?Jt.isTrue(this._matrix[Qt.INTERIOR][Qt.INTERIOR])&&Jt.isTrue(this._matrix[Qt.EXTERIOR][Qt.INTERIOR]):t===Z.L&&e===Z.L&&0===this._matrix[Qt.INTERIOR][Qt.INTERIOR]}isCovers(){return(Jt.isTrue(this._matrix[Qt.INTERIOR][Qt.INTERIOR])||Jt.isTrue(this._matrix[Qt.INTERIOR][Qt.BOUNDARY])||Jt.isTrue(this._matrix[Qt.BOUNDARY][Qt.INTERIOR])||Jt.isTrue(this._matrix[Qt.BOUNDARY][Qt.BOUNDARY]))&&this._matrix[Qt.EXTERIOR][Qt.INTERIOR]===Z.FALSE&&this._matrix[Qt.EXTERIOR][Qt.BOUNDARY]===Z.FALSE}isCoveredBy(){return(Jt.isTrue(this._matrix[Qt.INTERIOR][Qt.INTERIOR])||Jt.isTrue(this._matrix[Qt.INTERIOR][Qt.BOUNDARY])||Jt.isTrue(this._matrix[Qt.BOUNDARY][Qt.INTERIOR])||Jt.isTrue(this._matrix[Qt.BOUNDARY][Qt.BOUNDARY]))&&this._matrix[Qt.INTERIOR][Qt.EXTERIOR]===Z.FALSE&&this._matrix[Qt.BOUNDARY][Qt.EXTERIOR]===Z.FALSE}setAtLeast(){if(1===arguments.length){const t=arguments[0];for(let e=0;e<t.length;e++){const s=Math.trunc(e/3),n=e%3;this.setAtLeast(s,n,Z.toDimensionValue(t.charAt(e)))}}else if(3===arguments.length){const t=arguments[0],e=arguments[1],s=arguments[2];this._matrix[t][e]<s&&(this._matrix[t][e]=s)}}setAtLeastIfValid(t,e,s){t>=0&&e>=0&&this.setAtLeast(t,e,s)}toString(){const t=new nt("123456789");for(let e=0;e<3;e++)for(let s=0;s<3;s++)t.setCharAt(3*e+s,Z.toDimensionSymbol(this._matrix[e][s]));return t.toString()}setAll(t){for(let e=0;e<3;e++)for(let s=0;s<3;s++)this._matrix[e][s]=t}get(t,e){return this._matrix[t][e]}transpose(){let t=this._matrix[1][0];return this._matrix[1][0]=this._matrix[0][1],this._matrix[0][1]=t,t=this._matrix[2][0],this._matrix[2][0]=this._matrix[0][2],this._matrix[0][2]=t,t=this._matrix[2][1],this._matrix[2][1]=this._matrix[1][2],this._matrix[1][2]=t,this}get interfaces_(){return[u]}}class $t{static toDegrees(t){return 180*t/Math.PI}static isAcute(t,e,s){const n=t.x-e.x,i=t.y-e.y;return n*(s.x-e.x)+i*(s.y-e.y)>0}static isObtuse(t,e,s){const n=t.x-e.x,i=t.y-e.y;return n*(s.x-e.x)+i*(s.y-e.y)<0}static interiorAngle(t,e,s){const n=$t.angle(e,t),i=$t.angle(e,s);return Math.abs(i-n)}static normalizePositive(t){if(t<0){for(;t<0;)t+=$t.PI_TIMES_2;t>=$t.PI_TIMES_2&&(t=0)}else{for(;t>=$t.PI_TIMES_2;)t-=$t.PI_TIMES_2;t<0&&(t=0)}return t}static angleBetween(t,e,s){const n=$t.angle(e,t),i=$t.angle(e,s);return $t.diff(n,i)}static diff(t,e){let s=null;return s=t<e?e-t:t-e,s>Math.PI&&(s=2*Math.PI-s),s}static toRadians(t){return t*Math.PI/180}static normalize(t){for(;t>Math.PI;)t-=$t.PI_TIMES_2;for(;t<=-Math.PI;)t+=$t.PI_TIMES_2;return t}static angle(){if(1===arguments.length){const t=arguments[0];return Math.atan2(t.y,t.x)}if(2===arguments.length){const t=arguments[0],e=arguments[1],s=e.x-t.x,n=e.y-t.y;return Math.atan2(n,s)}}static getTurn(t,e){const s=Math.sin(e-t);return s>0?$t.COUNTERCLOCKWISE:s<0?$t.CLOCKWISE:$t.NONE}static angleBetweenOriented(t,e,s){const n=$t.angle(e,t),i=$t.angle(e,s)-n;return i<=-Math.PI?i+$t.PI_TIMES_2:i>Math.PI?i-$t.PI_TIMES_2:i}}$t.PI_TIMES_2=2*Math.PI,$t.PI_OVER_2=Math.PI/2,$t.PI_OVER_4=Math.PI/4,$t.COUNTERCLOCKWISE=q.COUNTERCLOCKWISE,$t.CLOCKWISE=q.CLOCKWISE,$t.NONE=q.COLLINEAR;class te extends s{constructor(){super(),te.constructor_.apply(this,arguments)}static constructor_(){s.constructor_.call(this,"Projective point not representable on the Cartesian plane.")}}class ee{constructor(){ee.constructor_.apply(this,arguments)}static constructor_(){if(this.x=null,this.y=null,this.w=null,0===arguments.length)this.x=0,this.y=0,this.w=1;else if(1===arguments.length){const t=arguments[0];this.x=t.x,this.y=t.y,this.w=1}else if(2===arguments.length){if("number"==typeof arguments[0]&&"number"==typeof arguments[1]){const t=arguments[0],e=arguments[1];this.x=t,this.y=e,this.w=1}else if(arguments[0]instanceof ee&&arguments[1]instanceof ee){const t=arguments[0],e=arguments[1];this.x=t.y*e.w-e.y*t.w,this.y=e.x*t.w-t.x*e.w,this.w=t.x*e.y-e.x*t.y}else if(arguments[0]instanceof m&&arguments[1]instanceof m){const t=arguments[0],e=arguments[1];this.x=t.y-e.y,this.y=e.x-t.x,this.w=t.x*e.y-e.x*t.y}}else if(3===arguments.length){const t=arguments[0],e=arguments[1],s=arguments[2];this.x=t,this.y=e,this.w=s}else if(4===arguments.length){const t=arguments[0],e=arguments[1],s=arguments[2],n=arguments[3],i=t.y-e.y,r=e.x-t.x,o=t.x*e.y-e.x*t.y,l=s.y-n.y,a=n.x-s.x,c=s.x*n.y-n.x*s.y;this.x=r*c-a*o,this.y=l*o-i*c,this.w=i*a-l*r}}getCoordinate(){const t=new m;return t.x=this.getX(),t.y=this.getY(),t}getX(){const t=this.x/this.w;if(r.isNaN(t)||r.isInfinite(t))throw new te;return t}getY(){const t=this.y/this.w;if(r.isNaN(t)||r.isInfinite(t))throw new te;return t}}class se{constructor(){se.constructor_.apply(this,arguments)}static constructor_(){this.p0=null,this.p1=null,this.p2=null;const t=arguments[0],e=arguments[1],s=arguments[2];this.p0=t,this.p1=e,this.p2=s}static isAcute(t,e,s){return!!$t.isAcute(t,e,s)&&(!!$t.isAcute(e,s,t)&&!!$t.isAcute(s,t,e))}static circumcentre(t,e,s){const n=s.x,i=s.y,r=t.x-n,o=t.y-i,l=e.x-n,a=e.y-i,c=2*se.det(r,o,l,a),h=se.det(o,r*r+o*o,a,l*l+a*a),u=se.det(r,r*r+o*o,l,l*l+a*a);return new m(n-h/c,i+u/c)}static perpendicularBisector(t,e){const s=e.x-t.x,n=e.y-t.y,i=new ee(t.x+s/2,t.y+n/2,1),r=new ee(t.x-n+s/2,t.y+s+n/2,1);return new ee(i,r)}static angleBisector(t,e,s){const n=e.distance(t),i=n/(n+e.distance(s)),r=s.x-t.x,o=s.y-t.y;return new m(t.x+i*r,t.y+i*o)}static inCentre(t,e,s){const n=e.distance(s),i=t.distance(s),r=t.distance(e),o=n+i+r,l=(n*t.x+i*e.x+r*s.x)/o,a=(n*t.y+i*e.y+r*s.y)/o;return new m(l,a)}static area(t,e,s){return Math.abs(((s.x-t.x)*(e.y-t.y)-(e.x-t.x)*(s.y-t.y))/2)}static signedArea(t,e,s){return((s.x-t.x)*(e.y-t.y)-(e.x-t.x)*(s.y-t.y))/2}static det(t,e,s,n){return t*n-e*s}static interpolateZ(t,e,s,n){const i=e.x,r=e.y,o=s.x-i,l=n.x-i,a=s.y-r,c=n.y-r,h=o*c-l*a,u=t.x-i,g=t.y-r,d=(c*u-l*g)/h,_=(-a*u+o*g)/h;return e.getZ()+d*(s.getZ()-e.getZ())+_*(n.getZ()-e.getZ())}static longestSideLength(t,e,s){const n=t.distance(e),i=e.distance(s),r=s.distance(t);let o=n;return i>o&&(o=i),r>o&&(o=r),o}static circumcentreDD(t,e,s){const n=A.valueOf(t.x).subtract(s.x),i=A.valueOf(t.y).subtract(s.y),r=A.valueOf(e.x).subtract(s.x),o=A.valueOf(e.y).subtract(s.y),l=A.determinant(n,i,r,o).multiply(2),a=n.sqr().add(i.sqr()),c=r.sqr().add(o.sqr()),h=A.determinant(i,a,o,c),u=A.determinant(n,a,r,c),g=A.valueOf(s.x).subtract(h.divide(l)).doubleValue(),d=A.valueOf(s.y).add(u.divide(l)).doubleValue();return new m(g,d)}static area3D(t,e,s){const n=e.x-t.x,i=e.y-t.y,r=e.getZ()-t.getZ(),o=s.x-t.x,l=s.y-t.y,a=s.getZ()-t.getZ(),c=i*a-r*l,h=r*o-n*a,u=n*l-i*o,g=c*c+h*h+u*u;return Math.sqrt(g)/2}static centroid(t,e,s){const n=(t.x+e.x+s.x)/3,i=(t.y+e.y+s.y)/3;return new m(n,i)}interpolateZ(t){if(null===t)throw new n("Supplied point is null.");return se.interpolateZ(t,this.p0,this.p1,this.p2)}longestSideLength(){return se.longestSideLength(this.p0,this.p1,this.p2)}isAcute(){return se.isAcute(this.p0,this.p1,this.p2)}circumcentre(){return se.circumcentre(this.p0,this.p1,this.p2)}inCentre(){return se.inCentre(this.p0,this.p1,this.p2)}area(){return se.area(this.p0,this.p1,this.p2)}signedArea(){return se.signedArea(this.p0,this.p1,this.p2)}area3D(){return se.area3D(this.p0,this.p1,this.p2)}centroid(){return se.centroid(this.p0,this.p1,this.p2)}}class ne extends s{constructor(){super(),ne.constructor_.apply(this,arguments)}static constructor_(){if(0===arguments.length)s.constructor_.call(this);else if(1===arguments.length){const t=arguments[0];s.constructor_.call(this,t)}}}class ie{constructor(){ie.constructor_.apply(this,arguments)}static constructor_(){if(this._m00=null,this._m01=null,this._m02=null,this._m10=null,this._m11=null,this._m12=null,0===arguments.length)this.setToIdentity();else if(1===arguments.length){if(arguments[0]instanceof Array){const t=arguments[0];this._m00=t[0],this._m01=t[1],this._m02=t[2],this._m10=t[3],this._m11=t[4],this._m12=t[5]}else if(arguments[0]instanceof ie){const t=arguments[0];this.setTransformation(t)}}else if(6===arguments.length&&"number"==typeof arguments[5]&&"number"==typeof arguments[4]&&"number"==typeof arguments[3]&&"number"==typeof arguments[2]&&"number"==typeof arguments[0]&&"number"==typeof arguments[1]){const t=arguments[0],e=arguments[1],s=arguments[2],n=arguments[3],i=arguments[4],r=arguments[5];this.setTransformation(t,e,s,n,i,r)}}static translationInstance(t,e){const s=new ie;return s.setToTranslation(t,e),s}static shearInstance(t,e){const s=new ie;return s.setToShear(t,e),s}static reflectionInstance(){if(2===arguments.length){const t=arguments[0],e=arguments[1],s=new ie;return s.setToReflection(t,e),s}if(4===arguments.length){const t=arguments[0],e=arguments[1],s=arguments[2],n=arguments[3],i=new ie;return i.setToReflection(t,e,s,n),i}}static rotationInstance(){if(1===arguments.length){const t=arguments[0];return ie.rotationInstance(Math.sin(t),Math.cos(t))}if(2===arguments.length){const t=arguments[0],e=arguments[1],s=new ie;return s.setToRotation(t,e),s}if(3===arguments.length){const t=arguments[0],e=arguments[1],s=arguments[2];return ie.rotationInstance(Math.sin(t),Math.cos(t),e,s)}if(4===arguments.length){const t=arguments[0],e=arguments[1],s=arguments[2],n=arguments[3],i=new ie;return i.setToRotation(t,e,s,n),i}}static scaleInstance(){if(2===arguments.length){const t=arguments[0],e=arguments[1],s=new ie;return s.setToScale(t,e),s}if(4===arguments.length){const t=arguments[0],e=arguments[1],s=arguments[2],n=arguments[3],i=new ie;return i.translate(-s,-n),i.scale(t,e),i.translate(s,n),i}}setToReflectionBasic(t,e,s,i){if(t===s&&e===i)throw new n("Reflection line points must be distinct");const r=s-t,o=i-e,l=Math.sqrt(r*r+o*o),a=o/l,c=r/l,h=2*a*c,u=c*c-a*a;return this._m00=u,this._m01=h,this._m02=0,this._m10=h,this._m11=-u,this._m12=0,this}setToRotation(){if(1===arguments.length){const t=arguments[0];return this.setToRotation(Math.sin(t),Math.cos(t)),this}if(2===arguments.length){const t=arguments[0],e=arguments[1];return this._m00=e,this._m01=-t,this._m02=0,this._m10=t,this._m11=e,this._m12=0,this}if(3===arguments.length){const t=arguments[0],e=arguments[1],s=arguments[2];return this.setToRotation(Math.sin(t),Math.cos(t),e,s),this}if(4===arguments.length){const t=arguments[0],e=arguments[1],s=arguments[2],n=arguments[3];return this._m00=e,this._m01=-t,this._m02=s-s*e+n*t,this._m10=t,this._m11=e,this._m12=n-s*t-n*e,this}}getMatrixEntries(){return[this._m00,this._m01,this._m02,this._m10,this._m11,this._m12]}filter(t,e){this.transform(t,e)}composeBefore(t){const e=this._m00*t._m00+this._m01*t._m10,s=this._m00*t._m01+this._m01*t._m11,n=this._m00*t._m02+this._m01*t._m12+this._m02,i=this._m10*t._m00+this._m11*t._m10,r=this._m10*t._m01+this._m11*t._m11,o=this._m10*t._m02+this._m11*t._m12+this._m12;return this._m00=e,this._m01=s,this._m02=n,this._m10=i,this._m11=r,this._m12=o,this}clone(){try{return null}catch(t){if(!(t instanceof s))throw t;h.shouldNeverReachHere()}return null}translate(t,e){return this.compose(ie.translationInstance(t,e)),this}setToReflection(){if(2===arguments.length){const t=arguments[0],e=arguments[1];if(0===t&&0===e)throw new n("Reflection vector must be non-zero");if(t===e)return this._m00=0,this._m01=1,this._m02=0,this._m10=1,this._m11=0,this._m12=0,this;const s=Math.sqrt(t*t+e*e),i=e/s,r=t/s;return this.rotate(-i,r),this.scale(1,-1),this.rotate(i,r),this}if(4===arguments.length){const t=arguments[0],e=arguments[1],s=arguments[2],i=arguments[3];if(t===s&&e===i)throw new n("Reflection line points must be distinct");this.setToTranslation(-t,-e);const r=s-t,o=i-e,l=Math.sqrt(r*r+o*o),a=o/l,c=r/l;return this.rotate(-a,c),this.scale(1,-1),this.rotate(a,c),this.translate(t,e),this}}shear(t,e){return this.compose(ie.shearInstance(t,e)),this}getInverse(){const t=this.getDeterminant();if(0===t)throw new ne("Transformation is non-invertible");const e=this._m11/t,s=-this._m10/t,n=-this._m01/t,i=this._m00/t,r=(this._m01*this._m12-this._m02*this._m11)/t,o=(-this._m00*this._m12+this._m10*this._m02)/t;return new ie(e,n,r,s,i,o)}compose(t){const e=t._m00*this._m00+t._m01*this._m10,s=t._m00*this._m01+t._m01*this._m11,n=t._m00*this._m02+t._m01*this._m12+t._m02,i=t._m10*this._m00+t._m11*this._m10,r=t._m10*this._m01+t._m11*this._m11,o=t._m10*this._m02+t._m11*this._m12+t._m12;return this._m00=e,this._m01=s,this._m02=n,this._m10=i,this._m11=r,this._m12=o,this}equals(t){if(null===t)return!1;if(!(t instanceof ie))return!1;const e=t;return this._m00===e._m00&&this._m01===e._m01&&this._m02===e._m02&&this._m10===e._m10&&this._m11===e._m11&&this._m12===e._m12}setToScale(t,e){return this._m00=t,this._m01=0,this._m02=0,this._m10=0,this._m11=e,this._m12=0,this}isIdentity(){return 1===this._m00&&0===this._m01&&0===this._m02&&0===this._m10&&1===this._m11&&0===this._m12}scale(t,e){return this.compose(ie.scaleInstance(t,e)),this}setToIdentity(){return this._m00=1,this._m01=0,this._m02=0,this._m10=0,this._m11=1,this._m12=0,this}isGeometryChanged(){return!0}setTransformation(){if(1===arguments.length){const t=arguments[0];return this._m00=t._m00,this._m01=t._m01,this._m02=t._m02,this._m10=t._m10,this._m11=t._m11,this._m12=t._m12,this}if(6===arguments.length){const t=arguments[0],e=arguments[1],s=arguments[2],n=arguments[3],i=arguments[4],r=arguments[5];return this._m00=t,this._m01=e,this._m02=s,this._m10=n,this._m11=i,this._m12=r,this}}rotate(){if(1===arguments.length){const t=arguments[0];return this.compose(ie.rotationInstance(t)),this}if(2===arguments.length){const t=arguments[0],e=arguments[1];return this.compose(ie.rotationInstance(t,e)),this}if(3===arguments.length){const t=arguments[0],e=arguments[1],s=arguments[2];return this.compose(ie.rotationInstance(t,e,s)),this}if(4===arguments.length){const t=arguments[0],e=arguments[1],s=arguments[2],n=arguments[3];return this.compose(ie.rotationInstance(t,e,s,n)),this}}getDeterminant(){return this._m00*this._m11-this._m01*this._m10}setToShear(t,e){return this._m00=1,this._m01=t,this._m02=0,this._m10=e,this._m11=1,this._m12=0,this}isDone(){return!1}toString(){return"AffineTransformation[["+this._m00+", "+this._m01+", "+this._m02+"], ["+this._m10+", "+this._m11+", "+this._m12+"]]"}setToTranslation(t,e){return this._m00=1,this._m01=0,this._m02=t,this._m10=0,this._m11=1,this._m12=e,this}transform(){if(1===arguments.length){const t=arguments[0].copy();return t.apply(this),t}if(2===arguments.length){if(arguments[0]instanceof m&&arguments[1]instanceof m){const t=arguments[0],e=arguments[1],s=this._m00*t.x+this._m01*t.y+this._m02,n=this._m10*t.x+this._m11*t.y+this._m12;return e.x=s,e.y=n,e}if(I(arguments[0],G)&&Number.isInteger(arguments[1])){const t=arguments[0],e=arguments[1],s=this._m00*t.getOrdinate(e,0)+this._m01*t.getOrdinate(e,1)+this._m02,n=this._m10*t.getOrdinate(e,0)+this._m11*t.getOrdinate(e,1)+this._m12;t.setOrdinate(e,0,s),t.setOrdinate(e,1,n)}}}reflect(){if(2===arguments.length){const t=arguments[0],e=arguments[1];return this.compose(ie.reflectionInstance(t,e)),this}if(4===arguments.length){const t=arguments[0],e=arguments[1],s=arguments[2],n=arguments[3];return this.compose(ie.reflectionInstance(t,e,s,n)),this}}get interfaces_(){return[u,P]}}class re{static solve(t,e){const s=e.length;if(t.length!==s||t[0].length!==s)throw new n("Matrix A is incorrectly sized");for(let n=0;n<s;n++){let i=n;for(let e=n+1;e<s;e++)Math.abs(t[e][n])>Math.abs(t[i][n])&&(i=e);if(0===t[i][n])return null;re.swapRows(t,n,i),re.swapRows(e,n,i);for(let i=n+1;i<s;i++){const r=t[i][n]/t[n][n];for(let e=s-1;e>=n;e--)t[i][e]-=t[n][e]*r;e[i]-=e[n]*r}}const i=new Array(s).fill(null);for(let n=s-1;n>=0;n--){let r=0;for(let e=n+1;e<s;e++)r+=t[n][e]*i[e];i[n]=(e[n]-r)/t[n][n]}return i}static swapRows(){if(Number.isInteger(arguments[2])&&arguments[0]instanceof Array&&Number.isInteger(arguments[1])){const t=arguments[0],e=arguments[1],s=arguments[2];if(e===s)return null;for(let n=0;n<t[0].length;n++){const i=t[e][n];t[e][n]=t[s][n],t[s][n]=i}}else if(Number.isInteger(arguments[2])&&arguments[0]instanceof Array&&Number.isInteger(arguments[1])){const t=arguments[0],e=arguments[1],s=arguments[2];if(e===s)return null;const n=t[e];t[e]=t[s],t[s]=n}}}class oe{constructor(){oe.constructor_.apply(this,arguments)}static constructor_(){this._src0=null,this._src1=null,this._src2=null,this._dest0=null,this._dest1=null,this._dest2=null,this._m00=null,this._m01=null,this._m02=null,this._m10=null,this._m11=null,this._m12=null;const t=arguments[0],e=arguments[1],s=arguments[2],n=arguments[3],i=arguments[4],r=arguments[5];this._src0=t,this._src1=e,this._src2=s,this._dest0=n,this._dest1=i,this._dest2=r}compute(){const t=[this._dest0.x,this._dest1.x,this._dest2.x],e=this.solve(t);if(null===e)return!1;this._m00=e[0],this._m01=e[1],this._m02=e[2];const s=[this._dest0.y,this._dest1.y,this._dest2.y],n=this.solve(s);return null!==n&&(this._m10=n[0],this._m11=n[1],this._m12=n[2],!0)}getTransformation(){return this.compute()?new ie(this._m00,this._m01,this._m02,this._m10,this._m11,this._m12):null}solve(t){const e=[[this._src0.x,this._src0.y,1],[this._src1.x,this._src1.y,1],[this._src2.x,this._src2.y,1]];return re.solve(e,t)}}class le{static createFromBaseLines(t,e,s,n){const i=new m(t.x+n.x-s.x,t.y+n.y-s.y),r=$t.angleBetweenOriented(e,t,i),o=e.distance(t),l=n.distance(s);if(0===o)return new ie;const a=l/o,c=ie.translationInstance(-t.x,-t.y);return c.rotate(r),c.scale(a,a),c.translate(s.x,s.y),c}static createFromControlVectors(){if(2===arguments.length){if(arguments[0]instanceof m&&arguments[1]instanceof m){const t=arguments[0],e=arguments[1],s=e.x-t.x,n=e.y-t.y;return ie.translationInstance(s,n)}if(arguments[0]instanceof Array&&arguments[1]instanceof Array){const t=arguments[0],e=arguments[1];if(t.length!==e.length)throw new n("Src and Dest arrays are not the same length");if(t.length<=0)throw new n("Too few control points");if(t.length>3)throw new n("Too many control points");return 1===t.length?le.createFromControlVectors(t[0],e[0]):2===t.length?le.createFromControlVectors(t[0],t[1],e[0],e[1]):le.createFromControlVectors(t[0],t[1],t[2],e[0],e[1],e[2])}}else{if(4===arguments.length){const t=arguments[0],e=arguments[1],s=arguments[2],n=arguments[3],i=new m(n.x-s.x,n.y-s.y),r=$t.angleBetweenOriented(e,t,i),o=e.distance(t),l=n.distance(s);if(0===o)return null;const a=l/o,c=ie.translationInstance(-t.x,-t.y);return c.rotate(r),c.scale(a,a),c.translate(s.x,s.y),c}if(6===arguments.length){return new oe(arguments[0],arguments[1],arguments[2],arguments[3],arguments[4],arguments[5]).getTransformation()}}}}class ae{constructor(){ae.constructor_.apply(this,arguments)}static constructor_(){this._coords=null;const t=arguments[0];this._coords=t}static getCoordinates(t){const e=new L;return t.apply(new ae(e)),e}filter(t){(t instanceof tt||t instanceof Nt)&&this._coords.add(t.getCoordinate())}get interfaces_(){return[X]}}class ce{constructor(){ce.constructor_.apply(this,arguments)}static constructor_(){this._mapOp=null;const t=arguments[0];this._mapOp=t}static map(t,e){return new ce(e).map(t)}map(t){const e=new L;for(let s=0;s<t.getNumGeometries();s++){const n=this._mapOp.map(t.getGeometryN(s));n.isEmpty()||e.add(n)}return t.getFactory().createGeometryCollection(Lt.toGeometryArray(e))}}class he{constructor(){he.constructor_.apply(this,arguments)}static constructor_(){this._geomFactory=null,this._skipEmpty=!1,this._inputGeoms=null;const t=arguments[0];this._geomFactory=he.extractFactory(t),this._inputGeoms=t}static extractFactory(t){return t.isEmpty()?null:t.iterator().next().getFactory()}static createList(){if(2===arguments.length){const t=arguments[0],e=arguments[1],s=new L;return s.add(t),s.add(e),s}if(3===arguments.length){const t=arguments[0],e=arguments[1],s=arguments[2],n=new L;return n.add(t),n.add(e),n.add(s),n}}static combine(){if(1===arguments.length){return new he(arguments[0]).combine()}if(2===arguments.length){const t=arguments[0],e=arguments[1];return new he(he.createList(t,e)).combine()}if(3===arguments.length){const t=arguments[0],e=arguments[1],s=arguments[2];return new he(he.createList(t,e,s)).combine()}}extractElements(t,e){if(null===t)return null;for(let s=0;s<t.getNumGeometries();s++){const n=t.getGeometryN(s);this._skipEmpty&&n.isEmpty()||e.add(n)}}combine(){const t=new L;for(let e=this._inputGeoms.iterator();e.hasNext();){const s=e.next();this.extractElements(s,t)}return 0===t.size()?null!==this._geomFactory?this._geomFactory.createGeometryCollection():null:this._geomFactory.buildGeometry(t)}}class ue{constructor(){ue.constructor_.apply(this,arguments)}static constructor_(){if(this._factory=null,this._isUserDataCopied=!1,0===arguments.length);else if(1===arguments.length){const t=arguments[0];this._factory=t}}setCopyUserData(t){this._isUserDataCopied=t}edit(t,e){if(null===t)return null;const s=this.editInternal(t,e);return this._isUserDataCopied&&s.setUserData(t.getUserData()),s}editInternal(t,e){return null===this._factory&&(this._factory=t.getFactory()),t instanceof ut?this.editGeometryCollection(t,e):t instanceof Ct?this.editPolygon(t,e):t instanceof Nt||t instanceof tt?e.edit(t,this._factory):(h.shouldNeverReachHere("Unsupported Geometry type: "+t.getGeometryType()),null)}editGeometryCollection(t,e){const s=e.edit(t,this._factory),n=new L;for(let t=0;t<s.getNumGeometries();t++){const i=this.edit(s.getGeometryN(t),e);null===i||i.isEmpty()||n.add(i)}return s.getGeometryType()===j.TYPENAME_MULTIPOINT?this._factory.createMultiPoint(n.toArray([])):s.getGeometryType()===j.TYPENAME_MULTILINESTRING?this._factory.createMultiLineString(n.toArray([])):s.getGeometryType()===j.TYPENAME_MULTIPOLYGON?this._factory.createMultiPolygon(n.toArray([])):this._factory.createGeometryCollection(n.toArray([]))}editPolygon(t,e){let s=e.edit(t,this._factory);if(null===s&&(s=this._factory.createPolygon()),s.isEmpty())return s;const n=this.edit(s.getExteriorRing(),e);if(null===n||n.isEmpty())return this._factory.createPolygon();const i=new L;for(let t=0;t<s.getNumInteriorRing();t++){const n=this.edit(s.getInteriorRingN(t),e);null===n||n.isEmpty()||i.add(n)}return this._factory.createPolygon(n,i.toArray([]))}}function ge(){}ue.GeometryEditorOperation=ge;ue.NoOpGeometryOperation=class{edit(t,e){return t}get interfaces_(){return[ge]}},ue.CoordinateOperation=class{edit(t,e){const s=this.edit(t.getCoordinates(),t);return t instanceof et?null===s?e.createLinearRing():e.createLinearRing(s):t instanceof tt?null===s?e.createLineString():e.createLineString(s):t instanceof Nt?null===s||0===s.length?e.createPoint():e.createPoint(s[0]):t}get interfaces_(){return[ge]}},ue.CoordinateSequenceOperation=class{edit(t,e){return t instanceof et?e.createLinearRing(this.edit(t.getCoordinateSequence(),t)):t instanceof tt?e.createLineString(this.edit(t.getCoordinateSequence(),t)):t instanceof Nt?e.createPoint(this.edit(t.getCoordinateSequence(),t)):t}get interfaces_(){return[ge]}};class de{constructor(){de.constructor_.apply(this,arguments)}static constructor_(){this._geometryType=null,this._comps=null;const t=arguments[0],e=arguments[1];this._geometryType=t,this._comps=e}static extract(){if(2===arguments.length){const t=arguments[0],e=arguments[1];return de.extract(t,e,new L)}if(3===arguments.length){const t=arguments[0],e=arguments[1],s=arguments[2];return t.getGeometryType()===e?s.add(t):t instanceof ut&&t.apply(new de(e,s)),s}}static isOfType(t,e){return t.getGeometryType()===e||e===j.TYPENAME_LINESTRING&&t.getGeometryType()===j.TYPENAME_LINEARRING}filter(t){(null===this._geometryType||de.isOfType(t,this._geometryType))&&this._comps.add(t)}get interfaces_(){return[$]}}class _e{static map(){if(arguments[0]instanceof j&&I(arguments[1],pe)){const t=arguments[0],e=arguments[1],s=new L;for(let n=0;n<t.getNumGeometries();n++){const i=e.map(t.getGeometryN(n));null!==i&&s.add(i)}return t.getFactory().buildGeometry(s)}if(I(arguments[0],N)&&I(arguments[1],pe)){const t=arguments[0],e=arguments[1],s=new L;for(let n=t.iterator();n.hasNext();){const t=n.next(),i=e.map(t);null!==i&&s.add(i)}return s}}}function pe(){}_e.MapOp=pe;class me{constructor(){me.constructor_.apply(this,arguments)}static constructor_(){this._inputGeom=null,this._factory=null,this._pruneEmptyGeometry=!0,this._preserveGeometryCollectionType=!0,this._preserveCollections=!1,this._preserveType=!1}transformPoint(t,e){return this._factory.createPoint(this.transformCoordinates(t.getCoordinateSequence(),t))}transformPolygon(t,e){let s=!0;const n=this.transformLinearRing(t.getExteriorRing(),t);null!==n&&n instanceof et&&!n.isEmpty()||(s=!1);const i=new L;for(let e=0;e<t.getNumInteriorRing();e++){const n=this.transformLinearRing(t.getInteriorRingN(e),t);null===n||n.isEmpty()||(n instanceof et||(s=!1),i.add(n))}if(s)return this._factory.createPolygon(n,i.toArray([]));{const t=new L;return null!==n&&t.add(n),t.addAll(i),this._factory.buildGeometry(t)}}createCoordinateSequence(t){return this._factory.getCoordinateSequenceFactory().create(t)}getInputGeometry(){return this._inputGeom}transformMultiLineString(t,e){const s=new L;for(let e=0;e<t.getNumGeometries();e++){const n=this.transformLineString(t.getGeometryN(e),t);null!==n&&(n.isEmpty()||s.add(n))}return this._factory.buildGeometry(s)}transformCoordinates(t,e){return this.copy(t)}transformLineString(t,e){return this._factory.createLineString(this.transformCoordinates(t.getCoordinateSequence(),t))}transformMultiPoint(t,e){const s=new L;for(let e=0;e<t.getNumGeometries();e++){const n=this.transformPoint(t.getGeometryN(e),t);null!==n&&(n.isEmpty()||s.add(n))}return this._factory.buildGeometry(s)}transformMultiPolygon(t,e){const s=new L;for(let e=0;e<t.getNumGeometries();e++){const n=this.transformPolygon(t.getGeometryN(e),t);null!==n&&(n.isEmpty()||s.add(n))}return this._factory.buildGeometry(s)}copy(t){return t.copy()}transformLinearRing(t,e){const s=this.transformCoordinates(t.getCoordinateSequence(),t);if(null===s)return this._factory.createLinearRing(null);const n=s.size();return n>0&&n<4&&!this._preserveType?this._factory.createLineString(s):this._factory.createLinearRing(s)}transformGeometryCollection(t,e){const s=new L;for(let e=0;e<t.getNumGeometries();e++){const n=this.transform(t.getGeometryN(e));null!==n&&(this._pruneEmptyGeometry&&n.isEmpty()||s.add(n))}return this._preserveGeometryCollectionType?this._factory.createGeometryCollection(Lt.toGeometryArray(s)):this._factory.buildGeometry(s)}transform(t){if(this._inputGeom=t,this._factory=t.getFactory(),t instanceof Nt)return this.transformPoint(t,null);if(t instanceof St)return this.transformMultiPoint(t,null);if(t instanceof et)return this.transformLinearRing(t,null);if(t instanceof tt)return this.transformLineString(t,null);if(t instanceof Et)return this.transformMultiLineString(t,null);if(t instanceof Ct)return this.transformPolygon(t,null);if(t instanceof dt)return this.transformMultiPolygon(t,null);if(t instanceof ut)return this.transformGeometryCollection(t,null);throw new n("Unknown Geometry subtype: "+t.getGeometryType())}}class fe{constructor(){fe.constructor_.apply(this,arguments)}static constructor_(){this._comps=null;const t=arguments[0];this._comps=t}static getLines(){if(1===arguments.length){const t=arguments[0];return fe.getLines(t,new L)}if(2===arguments.length){const t=arguments[0],e=arguments[1];return t instanceof tt?e.add(t):t instanceof ut&&t.apply(new fe(e)),e}}static getGeometry(t){return t.getFactory().buildGeometry(fe.getLines(t))}filter(t){t instanceof tt&&this._comps.add(t)}get interfaces_(){return[$]}}class ye{constructor(){ye.constructor_.apply(this,arguments)}static constructor_(){if(this._lines=null,this._isForcedToLineString=!1,1===arguments.length){const t=arguments[0];this._lines=t}else if(2===arguments.length){const t=arguments[0],e=arguments[1];this._lines=t,this._isForcedToLineString=e}}static getLines(){if(1===arguments.length){const t=arguments[0];return ye.getLines(t,!1)}if(2===arguments.length){if(I(arguments[0],N)&&I(arguments[1],N)){const t=arguments[1];for(let e=arguments[0].iterator();e.hasNext();){const s=e.next();ye.getLines(s,t)}return t}if(arguments[0]instanceof j&&"boolean"==typeof arguments[1]){const t=arguments[0],e=arguments[1],s=new L;return t.apply(new ye(s,e)),s}if(arguments[0]instanceof j&&I(arguments[1],N)){const t=arguments[0],e=arguments[1];return t instanceof tt?e.add(t):t.apply(new ye(e)),e}}else if(3===arguments.length){if("boolean"==typeof arguments[2]&&I(arguments[0],N)&&I(arguments[1],N)){const t=arguments[1],e=arguments[2];for(let s=arguments[0].iterator();s.hasNext();){const n=s.next();ye.getLines(n,t,e)}return t}if("boolean"==typeof arguments[2]&&arguments[0]instanceof j&&I(arguments[1],N)){const t=arguments[1],e=arguments[2];return arguments[0].apply(new ye(t,e)),t}}}static getGeometry(){if(1===arguments.length){const t=arguments[0];return t.getFactory().buildGeometry(ye.getLines(t))}if(2===arguments.length){const t=arguments[0],e=arguments[1];return t.getFactory().buildGeometry(ye.getLines(t,e))}}filter(t){if(this._isForcedToLineString&&t instanceof et){const e=t.getFactory().createLineString(t.getCoordinateSequence());return this._lines.add(e),null}t instanceof tt&&this._lines.add(t)}setForceToLineString(t){this._isForcedToLineString=t}get interfaces_(){return[X]}}const xe={reverseOrder:function(){return{compare:(t,e)=>e.compareTo(t)}},min:function(t){return xe.sort(t),t.get(0)},sort:function(t,e){const s=t.toArray();e?ht.sort(s,e):ht.sort(s);const n=t.iterator();for(let t=0,e=s.length;t<e;t++)n.next(),n.set(s[t])},singletonList:function(t){const e=new L;return e.add(t),e}};class Ee{constructor(){Ee.constructor_.apply(this,arguments)}static constructor_(){this._pts=null;const t=arguments[0];this._pts=t}static getPoints(){if(1===arguments.length){const t=arguments[0];return t instanceof Nt?xe.singletonList(t):Ee.getPoints(t,new L)}if(2===arguments.length){const t=arguments[0],e=arguments[1];return t instanceof Nt?e.add(t):t instanceof ut&&t.apply(new Ee(e)),e}}filter(t){t instanceof Nt&&this._pts.add(t)}get interfaces_(){return[$]}}class Ie{constructor(){Ie.constructor_.apply(this,arguments)}static constructor_(){this._comps=null;const t=arguments[0];this._comps=t}static getPolygons(){if(1===arguments.length){const t=arguments[0];return Ie.getPolygons(t,new L)}if(2===arguments.length){const t=arguments[0],e=arguments[1];return t instanceof Ct?e.add(t):t instanceof ut&&t.apply(new Ie(e)),e}}filter(t){t instanceof Ct&&this._comps.add(t)}get interfaces_(){return[$]}}class Ne{constructor(){Ne.constructor_.apply(this,arguments)}static constructor_(){this._isDone=!1}applyTo(t){for(let e=0;e<t.getNumGeometries()&&!this._isDone;e++){const s=t.getGeometryN(e);if(s instanceof ut)this.applyTo(s);else if(this.visit(s),this.isDone())return this._isDone=!0,null}}}class we{constructor(){we.constructor_.apply(this,arguments)}static constructor_(){if(this._geomFact=null,this._precModel=null,this._dim=new Ce,this._nPts=100,this._rotationAngle=0,0===arguments.length)we.constructor_.call(this,new Lt);else if(1===arguments.length){const t=arguments[0];this._geomFact=t,this._precModel=t.getPrecisionModel()}}setBase(t){this._dim.setBase(t)}setRotation(t){this._rotationAngle=t}setWidth(t){this._dim.setWidth(t)}createEllipse(){const t=this._dim.getEnvelope(),e=t.getWidth()/2,s=t.getHeight()/2,n=t.getMinX()+e,i=t.getMinY()+s,r=new Array(this._nPts+1).fill(null);let o=0;for(let t=0;t<this._nPts;t++){const l=t*(2*Math.PI/this._nPts),a=e*Math.cos(l)+n,c=s*Math.sin(l)+i;r[o++]=this.coord(a,c)}r[o]=new m(r[0]);const l=this._geomFact.createLinearRing(r),a=this._geomFact.createPolygon(l);return this.rotate(a)}createArc(t,e){const s=this._dim.getEnvelope(),n=s.getWidth()/2,i=s.getHeight()/2,r=s.getMinX()+n,o=s.getMinY()+i;let l=e;(l<=0||l>2*Math.PI)&&(l=2*Math.PI);const a=l/(this._nPts-1),c=new Array(this._nPts).fill(null);let h=0;for(let e=0;e<this._nPts;e++){const s=t+e*a,l=n*Math.cos(s)+r,u=i*Math.sin(s)+o;c[h++]=this.coord(l,u)}const u=this._geomFact.createLineString(c);return this.rotate(u)}rotate(t){if(0!==this._rotationAngle){const e=ie.rotationInstance(this._rotationAngle,this._dim.getCentre().x,this._dim.getCentre().y);t.apply(e)}return t}coord(t,e){const s=new m(t,e);return this._precModel.makePrecise(s),s}createArcPolygon(t,e){const s=this._dim.getEnvelope(),n=s.getWidth()/2,i=s.getHeight()/2,r=s.getMinX()+n,o=s.getMinY()+i;let l=e;(l<=0||l>2*Math.PI)&&(l=2*Math.PI);const a=l/(this._nPts-1),c=new Array(this._nPts+2).fill(null);let h=0;c[h++]=this.coord(r,o);for(let e=0;e<this._nPts;e++){const s=t+a*e,l=n*Math.cos(s)+r,u=i*Math.sin(s)+o;c[h++]=this.coord(l,u)}c[h++]=this.coord(r,o);const u=this._geomFact.createLinearRing(c),g=this._geomFact.createPolygon(u);return this.rotate(g)}createRectangle(){let t=null,e=0,s=Math.trunc(this._nPts/4);s<1&&(s=1);const n=this._dim.getEnvelope().getWidth()/s,i=this._dim.getEnvelope().getHeight()/s,r=new Array(4*s+1).fill(null),o=this._dim.getEnvelope();for(t=0;t<s;t++){const s=o.getMinX()+t*n,i=o.getMinY();r[e++]=this.coord(s,i)}for(t=0;t<s;t++){const s=o.getMaxX(),n=o.getMinY()+t*i;r[e++]=this.coord(s,n)}for(t=0;t<s;t++){const s=o.getMaxX()-t*n,i=o.getMaxY();r[e++]=this.coord(s,i)}for(t=0;t<s;t++){const s=o.getMinX(),n=o.getMaxY()-t*i;r[e++]=this.coord(s,n)}r[e++]=new m(r[0]);const l=this._geomFact.createLinearRing(r),a=this._geomFact.createPolygon(l);return this.rotate(a)}createCircle(){return this.createEllipse()}setHeight(t){this._dim.setHeight(t)}setSize(t){this._dim.setSize(t)}createSupercircle(t){const e=1/t,s=this._dim.getMinSize()/2,n=this._dim.getCentre(),i=Math.pow(s,t),r=s,o=Math.pow(i/2,e),l=Math.trunc(this._nPts/8),a=new Array(8*l+1).fill(null),c=o/l;for(let s=0;s<=l;s++){let o=0,h=r;if(0!==s){o=c*s;const n=Math.pow(o,t);h=Math.pow(i-n,e)}a[s]=this.coordTrans(o,h,n),a[2*l-s]=this.coordTrans(h,o,n),a[2*l+s]=this.coordTrans(h,-o,n),a[4*l-s]=this.coordTrans(o,-h,n),a[4*l+s]=this.coordTrans(-o,-h,n),a[6*l-s]=this.coordTrans(-h,-o,n),a[6*l+s]=this.coordTrans(-h,o,n),a[8*l-s]=this.coordTrans(-o,h,n)}a[a.length-1]=new m(a[0]);const h=this._geomFact.createLinearRing(a),u=this._geomFact.createPolygon(h);return this.rotate(u)}setNumPoints(t){this._nPts=t}coordTrans(t,e,s){return this.coord(t+s.x,e+s.y)}createSquircle(){return this.createSupercircle(4)}setEnvelope(t){this._dim.setEnvelope(t)}setCentre(t){this._dim.setCentre(t)}}class Ce{constructor(){Ce.constructor_.apply(this,arguments)}static constructor_(){this.base=null,this.centre=null,this.width=null,this.height=null}setBase(t){this.base=t}setWidth(t){this.width=t}getBase(){return this.base}getWidth(){return this.width}getEnvelope(){return null!==this.base?new O(this.base.x,this.base.x+this.width,this.base.y,this.base.y+this.height):null!==this.centre?new O(this.centre.x-this.width/2,this.centre.x+this.width/2,this.centre.y-this.height/2,this.centre.y+this.height/2):new O(0,this.width,0,this.height)}getCentre(){return null===this.centre&&(this.centre=new m(this.base.x+this.width/2,this.base.y+this.height/2)),this.centre}getHeight(){return this.height}setHeight(t){this.height=t}setSize(t){this.height=t,this.width=t}setEnvelope(t){this.width=t.getWidth(),this.height=t.getHeight(),this.base=new m(t.getMinX(),t.getMinY()),this.centre=new m(t.centre())}setCentre(t){this.centre=t}getMinSize(){return Math.min(this.width,this.height)}}we.Dimensions=Ce;class Se extends we{constructor(){super(),Se.constructor_.apply(this,arguments)}static constructor_(){if(this._numArms=8,this._armLengthRatio=.5,0===arguments.length)we.constructor_.call(this);else if(1===arguments.length){const t=arguments[0];we.constructor_.call(this,t)}}static create(t,e,s,n,i){const r=new Se;r.setCentre(t),r.setSize(e),r.setNumPoints(s),r.setArmLengthRatio(i),r.setNumArms(n);return r.createSineStar()}setArmLengthRatio(t){this._armLengthRatio=t}createSineStar(){const t=this._dim.getEnvelope(),e=t.getWidth()/2;let s=this._armLengthRatio;s<0&&(s=0),s>1&&(s=1);const n=s*e,i=(1-s)*e,r=t.getMinX()+e,o=t.getMinY()+e,l=new Array(this._nPts+1).fill(null);let a=0;for(let t=0;t<this._nPts;t++){const e=t/this._nPts*this._numArms,s=e-Math.floor(e),c=2*Math.PI*s,h=i+n*((Math.cos(c)+1)/2),u=t*(2*Math.PI/this._nPts),g=h*Math.cos(u)+r,d=h*Math.sin(u)+o;l[a++]=this.coord(g,d)}l[a]=new m(l[0]);const c=this._geomFact.createLinearRing(l);return this._geomFact.createPolygon(c)}setNumArms(t){this._numArms=t}}var Le=Object.freeze({__proto__:null,AffineTransformation:ie,AffineTransformationBuilder:oe,AffineTransformationFactory:le,ComponentCoordinateExtracter:ae,GeometryCollectionMapper:ce,GeometryCombiner:he,GeometryEditor:ue,GeometryExtracter:de,GeometryMapper:_e,GeometryTransformer:me,LineStringExtracter:fe,LinearComponentExtracter:ye,PointExtracter:Ee,PolygonExtracter:Ie,ShortCircuitedGeometryVisitor:Ne,SineStarFactory:Se}),Te=Object.freeze({__proto__:null,Coordinate:m,CoordinateList:R,CoordinateSequenceFilter:P,CoordinateXY:y,CoordinateXYM:x,CoordinateXYZM:E,Dimension:Z,Envelope:O,Geometry:j,GeometryCollection:ut,GeometryFactory:Lt,IntersectionMatrix:Jt,LineSegment:Kt,LineString:tt,LinearRing:et,Location:Qt,MultiLineString:Et,MultiPoint:St,MultiPolygon:dt,Point:Nt,Polygon:Ct,PrecisionModel:yt,Triangle:se,util:Le});class Re{constructor(){Re.constructor_.apply(this,arguments)}static constructor_(){this._pt=[new m,new m],this._distance=r.NaN,this._isNull=!0}getCoordinates(){return this._pt}getCoordinate(t){return this._pt[t]}setMinimum(){if(1===arguments.length){const t=arguments[0];this.setMinimum(t._pt[0],t._pt[1])}else if(2===arguments.length){const t=arguments[0],e=arguments[1];if(this._isNull)return this.initialize(t,e),null;const s=t.distance(e);s<this._distance&&this.initialize(t,e,s)}}initialize(){if(0===arguments.length)this._isNull=!0;else if(2===arguments.length){const t=arguments[0],e=arguments[1];this._pt[0].setCoordinate(t),this._pt[1].setCoordinate(e),this._distance=t.distance(e),this._isNull=!1}else if(3===arguments.length){const t=arguments[0],e=arguments[1],s=arguments[2];this._pt[0].setCoordinate(t),this._pt[1].setCoordinate(e),this._distance=s,this._isNull=!1}}toString(){return Wt.toLineString(this._pt[0],this._pt[1])}getDistance(){return this._distance}setMaximum(){if(1===arguments.length){const t=arguments[0];this.setMaximum(t._pt[0],t._pt[1])}else if(2===arguments.length){const t=arguments[0],e=arguments[1];if(this._isNull)return this.initialize(t,e),null;const s=t.distance(e);s>this._distance&&this.initialize(t,e,s)}}}class Pe{static computeDistance(){if(arguments[2]instanceof Re&&arguments[0]instanceof tt&&arguments[1]instanceof m){const t=arguments[0],e=arguments[1],s=arguments[2],n=new Kt,i=t.getCoordinates();for(let t=0;t<i.length-1;t++){n.setCoordinates(i[t],i[t+1]);const r=n.closestPoint(e);s.setMinimum(r,e)}}else if(arguments[2]instanceof Re&&arguments[0]instanceof Ct&&arguments[1]instanceof m){const t=arguments[0],e=arguments[1],s=arguments[2];Pe.computeDistance(t.getExteriorRing(),e,s);for(let n=0;n<t.getNumInteriorRing();n++)Pe.computeDistance(t.getInteriorRingN(n),e,s)}else if(arguments[2]instanceof Re&&arguments[0]instanceof j&&arguments[1]instanceof m){const t=arguments[0],e=arguments[1],s=arguments[2];if(t instanceof tt)Pe.computeDistance(t,e,s);else if(t instanceof Ct)Pe.computeDistance(t,e,s);else if(t instanceof ut){const n=t;for(let t=0;t<n.getNumGeometries();t++){const i=n.getGeometryN(t);Pe.computeDistance(i,e,s)}}else s.setMinimum(t.getCoordinate(),e)}else if(arguments[2]instanceof Re&&arguments[0]instanceof Kt&&arguments[1]instanceof m){const t=arguments[1],e=arguments[2],s=arguments[0].closestPoint(t);e.setMinimum(s,t)}}}class Oe{constructor(){Oe.constructor_.apply(this,arguments)}static constructor_(){this._g0=null,this._g1=null,this._ptDist=new Re,this._densifyFrac=0;const t=arguments[0],e=arguments[1];this._g0=t,this._g1=e}static distance(){if(2===arguments.length){return new Oe(arguments[0],arguments[1]).distance()}if(3===arguments.length){const t=arguments[2],e=new Oe(arguments[0],arguments[1]);return e.setDensifyFraction(t),e.distance()}}getCoordinates(){return this._ptDist.getCoordinates()}setDensifyFraction(t){if(t>1||t<=0)throw new n("Fraction is not in range (0.0 - 1.0]");this._densifyFrac=t}compute(t,e){this.computeOrientedDistance(t,e,this._ptDist),this.computeOrientedDistance(e,t,this._ptDist)}distance(){return this.compute(this._g0,this._g1),this._ptDist.getDistance()}computeOrientedDistance(t,e,s){const n=new ve(e);if(t.apply(n),s.setMaximum(n.getMaxPointDistance()),this._densifyFrac>0){const n=new Me(e,this._densifyFrac);t.apply(n),s.setMaximum(n.getMaxPointDistance())}}orientedDistance(){return this.computeOrientedDistance(this._g0,this._g1,this._ptDist),this._ptDist.getDistance()}}class ve{constructor(){ve.constructor_.apply(this,arguments)}static constructor_(){this._maxPtDist=new Re,this._minPtDist=new Re,this._euclideanDist=new Pe,this._geom=null;const t=arguments[0];this._geom=t}filter(t){this._minPtDist.initialize(),Pe.computeDistance(this._geom,t,this._minPtDist),this._maxPtDist.setMaximum(this._minPtDist)}getMaxPointDistance(){return this._maxPtDist}get interfaces_(){return[K]}}class Me{constructor(){Me.constructor_.apply(this,arguments)}static constructor_(){this._maxPtDist=new Re,this._minPtDist=new Re,this._geom=null,this._numSubSegs=0;const t=arguments[0],e=arguments[1];this._geom=t,this._numSubSegs=Math.trunc(Math.round(1/e))}filter(t,e){if(0===e)return null;const s=t.getCoordinate(e-1),n=t.getCoordinate(e),i=(n.x-s.x)/this._numSubSegs,r=(n.y-s.y)/this._numSubSegs;for(let t=0;t<this._numSubSegs;t++){const e=s.x+t*i,n=s.y+t*r,o=new m(e,n);this._minPtDist.initialize(),Pe.computeDistance(this._geom,o,this._minPtDist),this._maxPtDist.setMaximum(this._minPtDist)}}isGeometryChanged(){return!1}getMaxPointDistance(){return this._maxPtDist}isDone(){return!1}get interfaces_(){return[P]}}Oe.MaxPointDistanceFilter=ve,Oe.MaxDensifiedByFractionDistanceFilter=Me;var be=Object.freeze({__proto__:null,DiscreteHausdorffDistance:Oe,DistanceToPoint:Pe,PointPairDistance:Re});class De{visitItem(t){}}class Ae{locate(t){}}class Fe{constructor(){Fe.constructor_.apply(this,arguments)}static constructor_(){this._min=r.POSITIVE_INFINITY,this._max=r.NEGATIVE_INFINITY}getMin(){return this._min}intersects(t,e){return!(this._min>e||this._max<t)}getMax(){return this._max}toString(){return Wt.toLineString(new m(this._min,0),new m(this._max,0))}}Fe.NodeComparator=class{compare(t,e){const s=t,n=e,i=(s._min+s._max)/2,r=(n._min+n._max)/2;return i<r?-1:i>r?1:0}get interfaces_(){return[g]}};class Ge extends Fe{constructor(){super(),Ge.constructor_.apply(this,arguments)}static constructor_(){this._item=null;const t=arguments[0],e=arguments[1],s=arguments[2];this._min=t,this._max=e,this._item=s}query(t,e,s){if(!this.intersects(t,e))return null;s.visitItem(this._item)}}class qe extends Fe{constructor(){super(),qe.constructor_.apply(this,arguments)}static constructor_(){this._node1=null,this._node2=null;const t=arguments[0],e=arguments[1];this._node1=t,this._node2=e,this.buildExtent(this._node1,this._node2)}buildExtent(t,e){this._min=Math.min(t._min,e._min),this._max=Math.max(t._max,e._max)}query(t,e,s){if(!this.intersects(t,e))return null;null!==this._node1&&this._node1.query(t,e,s),null!==this._node2&&this._node2.query(t,e,s)}}class Be{constructor(){Be.constructor_.apply(this,arguments)}static constructor_(){this._leaves=new L,this._root=null,this._level=0}buildTree(){xe.sort(this._leaves,new Fe.NodeComparator);let t=this._leaves,e=null,s=new L;for(;;){if(this.buildLevel(t,s),1===s.size())return s.get(0);e=t,t=s,s=e}}insert(t,e,s){if(null!==this._root)throw new D("Index cannot be added to once it has been queried");this._leaves.add(new Ge(t,e,s))}query(t,e,s){if(this.init(),null===this._root)return null;this._root.query(t,e,s)}buildRoot(){if(null!==this._root)return null;this._root=this.buildTree()}printNode(t){Y.out.println(Wt.toLineString(new m(t._min,this._level),new m(t._max,this._level)))}init(){return null!==this._root||0===this._leaves.size()?null:void this.buildRoot()}buildLevel(t,e){this._level++,e.clear();for(let s=0;s<t.size();s+=2){const n=t.get(s);if(null===(s+1<t.size()?t.get(s):null))e.add(n);else{const n=new qe(t.get(s),t.get(s+1));e.add(n)}}}}class Ye{constructor(){Ye.constructor_.apply(this,arguments)}static constructor_(){this._items=new L}getItems(){return this._items}visitItem(t){this._items.add(t)}get interfaces_(){return[De]}}class ze{constructor(){ze.constructor_.apply(this,arguments)}static constructor_(){this._p=null,this._crossingCount=0,this._isPointOnSegment=!1;const t=arguments[0];this._p=t}static locatePointInRing(){if(arguments[0]instanceof m&&I(arguments[1],G)){const t=arguments[1],e=new ze(arguments[0]),s=new m,n=new m;for(let i=1;i<t.size();i++)if(t.getCoordinate(i,s),t.getCoordinate(i-1,n),e.countSegment(s,n),e.isOnSegment())return e.getLocation();return e.getLocation()}if(arguments[0]instanceof m&&arguments[1]instanceof Array){const t=arguments[1],e=new ze(arguments[0]);for(let s=1;s<t.length;s++){const n=t[s],i=t[s-1];if(e.countSegment(n,i),e.isOnSegment())return e.getLocation()}return e.getLocation()}}getLocation(){return this._isPointOnSegment?Qt.BOUNDARY:this._crossingCount%2==1?Qt.INTERIOR:Qt.EXTERIOR}isPointInPolygon(){return this.getLocation()!==Qt.EXTERIOR}isOnSegment(){return this._isPointOnSegment}countSegment(t,e){if(t.x<this._p.x&&e.x<this._p.x)return null;if(this._p.x===e.x&&this._p.y===e.y)return this._isPointOnSegment=!0,null;if(t.y===this._p.y&&e.y===this._p.y){let s=t.x,n=e.x;return s>n&&(s=e.x,n=t.x),this._p.x>=s&&this._p.x<=n&&(this._isPointOnSegment=!0),null}if(t.y>this._p.y&&e.y<=this._p.y||e.y>this._p.y&&t.y<=this._p.y){let s=q.index(t,e,this._p);if(s===q.COLLINEAR)return this._isPointOnSegment=!0,null;e.y<t.y&&(s=-s),s===q.LEFT&&this._crossingCount++}}}class Ve{constructor(){Ve.constructor_.apply(this,arguments)}static constructor_(){this._geom=null,this._index=null;const t=arguments[0];if(!(I(t,gt)||t instanceof et))throw new n("Argument must be Polygonal or LinearRing");this._geom=t}locate(t){null===this._index&&(this._index=new Xe(this._geom),this._geom=null);const e=new ze(t),s=new ke(e);return this._index.query(t.y,t.y,s),e.getLocation()}get interfaces_(){return[Ae]}}class ke{constructor(){ke.constructor_.apply(this,arguments)}static constructor_(){this._counter=null;const t=arguments[0];this._counter=t}visitItem(t){const e=t;this._counter.countSegment(e.getCoordinate(0),e.getCoordinate(1))}get interfaces_(){return[De]}}class Xe{constructor(){Xe.constructor_.apply(this,arguments)}static constructor_(){this._isEmpty=!1,this._index=new Be;const t=arguments[0];t.isEmpty()?this._isEmpty=!0:this.init(t)}init(t){for(let e=ye.getLines(t).iterator();e.hasNext();){const t=e.next().getCoordinates();this.addLine(t)}}addLine(t){for(let e=1;e<t.length;e++){const s=new Kt(t[e-1],t[e]),n=Math.min(s.p0.y,s.p1.y),i=Math.max(s.p0.y,s.p1.y);this._index.insert(n,i,s)}}query(){if(2===arguments.length){const t=arguments[0],e=arguments[1];if(this._isEmpty)return new L;const s=new Ye;return this._index.query(t,e,s),s.getItems()}if(3===arguments.length){const t=arguments[0],e=arguments[1],s=arguments[2];if(this._isEmpty)return null;this._index.query(t,e,s)}}}Ve.SegmentVisitor=ke,Ve.IntervalIndexedGeometry=Xe;class Ue{static isInRing(t,e){return Ue.locateInRing(t,e)!==Qt.EXTERIOR}static locateInRing(t,e){return ze.locatePointInRing(t,e)}static isOnLine(){if(arguments[0]instanceof m&&I(arguments[1],G)){const t=arguments[0],e=arguments[1],s=new jt,n=new m,i=new m,r=e.size();for(let o=1;o<r;o++)if(e.getCoordinate(o-1,n),e.getCoordinate(o,i),s.computeIntersection(t,n,i),s.hasIntersection())return!0;return!1}if(arguments[0]instanceof m&&arguments[1]instanceof Array){const t=arguments[0],e=arguments[1],s=new jt;for(let n=1;n<e.length;n++){const i=e[n-1],r=e[n];if(s.computeIntersection(t,i,r),s.hasIntersection())return!0}return!1}}}class He{hasNext(){}next(){}remove(){}}class We{constructor(){We.constructor_.apply(this,arguments)}static constructor_(){this._parent=null,this._atStart=null,this._max=null,this._index=null,this._subcollectionIterator=null;const t=arguments[0];this._parent=t,this._atStart=!0,this._index=0,this._max=t.getNumGeometries()}static isAtomic(t){return!(t instanceof ut)}next(){if(this._atStart)return this._atStart=!1,We.isAtomic(this._parent)&&this._index++,this._parent;if(null!==this._subcollectionIterator){if(this._subcollectionIterator.hasNext())return this._subcollectionIterator.next();this._subcollectionIterator=null}if(this._index>=this._max)throw new S;const t=this._parent.getGeometryN(this._index++);return t instanceof ut?(this._subcollectionIterator=new We(t),this._subcollectionIterator.next()):t}hasNext(){if(this._atStart)return!0;if(null!==this._subcollectionIterator){if(this._subcollectionIterator.hasNext())return!0;this._subcollectionIterator=null}return!(this._index>=this._max)}remove(){throw new U(this.getClass().getName())}get interfaces_(){return[He]}}class Ze{constructor(){Ze.constructor_.apply(this,arguments)}static constructor_(){this._geom=null;const t=arguments[0];this._geom=t}static locatePointInPolygon(t,e){if(e.isEmpty())return Qt.EXTERIOR;const s=e.getExteriorRing(),n=Ze.locatePointInRing(t,s);if(n!==Qt.INTERIOR)return n;for(let s=0;s<e.getNumInteriorRing();s++){const n=e.getInteriorRingN(s),i=Ze.locatePointInRing(t,n);if(i===Qt.BOUNDARY)return Qt.BOUNDARY;if(i===Qt.INTERIOR)return Qt.EXTERIOR}return Qt.INTERIOR}static locatePointInRing(t,e){return e.getEnvelopeInternal().intersects(t)?Ue.locateInRing(t,e.getCoordinates()):Qt.EXTERIOR}static isContained(t,e){return Qt.EXTERIOR!==Ze.locate(t,e)}static locate(t,e){return e.isEmpty()?Qt.EXTERIOR:e.getEnvelopeInternal().intersects(t)?Ze.locateInGeometry(t,e):Qt.EXTERIOR}static containsPointInPolygon(t,e){return Qt.EXTERIOR!==Ze.locatePointInPolygon(t,e)}static locateInGeometry(t,e){if(e instanceof Ct)return Ze.locatePointInPolygon(t,e);if(e instanceof ut){const s=new We(e);for(;s.hasNext();){const n=s.next();if(n!==e){const e=Ze.locateInGeometry(t,n);if(e!==Qt.EXTERIOR)return e}}}return Qt.EXTERIOR}locate(t){return Ze.locate(t,this._geom)}get interfaces_(){return[Ae]}}var je=Object.freeze({__proto__:null,IndexedPointInAreaLocator:Ve,PointOnGeometryLocator:Ae,SimplePointInAreaLocator:Ze});class Ke{measure(t,e){}}class Qe{constructor(){Qe.constructor_.apply(this,arguments)}static constructor_(){if(this._quadrantSegments=Qe.DEFAULT_QUADRANT_SEGMENTS,this._endCapStyle=Qe.CAP_ROUND,this._joinStyle=Qe.JOIN_ROUND,this._mitreLimit=Qe.DEFAULT_MITRE_LIMIT,this._isSingleSided=!1,this._simplifyFactor=Qe.DEFAULT_SIMPLIFY_FACTOR,0===arguments.length);else if(1===arguments.length){const t=arguments[0];this.setQuadrantSegments(t)}else if(2===arguments.length){const t=arguments[0],e=arguments[1];this.setQuadrantSegments(t),this.setEndCapStyle(e)}else if(4===arguments.length){const t=arguments[0],e=arguments[1],s=arguments[2],n=arguments[3];this.setQuadrantSegments(t),this.setEndCapStyle(e),this.setJoinStyle(s),this.setMitreLimit(n)}}static bufferDistanceError(t){const e=Math.PI/2/t;return 1-Math.cos(e/2)}getEndCapStyle(){return this._endCapStyle}isSingleSided(){return this._isSingleSided}setQuadrantSegments(t){this._quadrantSegments=t,0===this._quadrantSegments&&(this._joinStyle=Qe.JOIN_BEVEL),this._quadrantSegments<0&&(this._joinStyle=Qe.JOIN_MITRE,this._mitreLimit=Math.abs(this._quadrantSegments)),t<=0&&(this._quadrantSegments=1),this._joinStyle!==Qe.JOIN_ROUND&&(this._quadrantSegments=Qe.DEFAULT_QUADRANT_SEGMENTS)}getJoinStyle(){return this._joinStyle}setJoinStyle(t){this._joinStyle=t}setSimplifyFactor(t){this._simplifyFactor=t<0?0:t}getSimplifyFactor(){return this._simplifyFactor}getQuadrantSegments(){return this._quadrantSegments}setEndCapStyle(t){this._endCapStyle=t}getMitreLimit(){return this._mitreLimit}setMitreLimit(t){this._mitreLimit=t}setSingleSided(t){this._isSingleSided=t}}Qe.CAP_ROUND=1,Qe.CAP_FLAT=2,Qe.CAP_SQUARE=3,Qe.JOIN_ROUND=1,Qe.JOIN_MITRE=2,Qe.JOIN_BEVEL=3,Qe.DEFAULT_QUADRANT_SEGMENTS=8,Qe.DEFAULT_MITRE_LIMIT=5,Qe.DEFAULT_SIMPLIFY_FACTOR=.01;class Je{static relativeSign(t,e){return t<e?-1:t>e?1:0}static compareValue(t,e){return t<0?-1:t>0?1:e<0?-1:e>0?1:0}static compare(t,e,s){if(e.equals2D(s))return 0;const n=Je.relativeSign(e.x,s.x),i=Je.relativeSign(e.y,s.y);switch(t){case 0:return Je.compareValue(n,i);case 1:return Je.compareValue(i,n);case 2:return Je.compareValue(i,-n);case 3:return Je.compareValue(-n,i);case 4:return Je.compareValue(-n,-i);case 5:return Je.compareValue(-i,-n);case 6:return Je.compareValue(-i,n);case 7:return Je.compareValue(n,-i)}return h.shouldNeverReachHere("invalid octant value"),0}}class $e{constructor(){$e.constructor_.apply(this,arguments)}static constructor_(){this._segString=null,this.coord=null,this.segmentIndex=null,this._segmentOctant=null,this._isInterior=null;const t=arguments[0],e=arguments[1],s=arguments[2],n=arguments[3];this._segString=t,this.coord=new m(e),this.segmentIndex=s,this._segmentOctant=n,this._isInterior=!e.equals2D(t.getCoordinate(s))}getCoordinate(){return this.coord}print(t){t.print(this.coord),t.print(" seg # = "+this.segmentIndex)}compareTo(t){const e=t;return this.segmentIndex<e.segmentIndex?-1:this.segmentIndex>e.segmentIndex?1:this.coord.equals2D(e.coord)?0:this._isInterior?e._isInterior?Je.compare(this._segmentOctant,this.coord,e.coord):1:-1}isEndPoint(t){return 0===this.segmentIndex&&!this._isInterior||this.segmentIndex===t}toString(){return this.segmentIndex+":"+this.coord.toString()}isInterior(){return this._isInterior}get interfaces_(){return[o]}}class ts extends _t{}function es(t){return null==t?0:t.color}function ss(t){return null==t?null:t.parent}function ns(t,e){null!==t&&(t.color=e)}function is(t){return null==t?null:t.left}function rs(t){return null==t?null:t.right}class os extends ts{constructor(){super(),this.root_=null,this.size_=0}get(t){let e=this.root_;for(;null!==e;){const s=t.compareTo(e.key);if(s<0)e=e.left;else{if(!(s>0))return e.value;e=e.right}}return null}put(t,e){if(null===this.root_)return this.root_={key:t,value:e,left:null,right:null,parent:null,color:0,getValue(){return this.value},getKey(){return this.key}},this.size_=1,null;let s,n,i=this.root_;do{if(s=i,n=t.compareTo(i.key),n<0)i=i.left;else{if(!(n>0)){const t=i.value;return i.value=e,t}i=i.right}}while(null!==i);const r={key:t,left:null,right:null,value:e,parent:s,color:0,getValue(){return this.value},getKey(){return this.key}};return n<0?s.left=r:s.right=r,this.fixAfterInsertion(r),this.size_++,null}fixAfterInsertion(t){let e;for(t.color=1;null!=t&&t!==this.root_&&1===t.parent.color;)ss(t)===is(ss(ss(t)))?(e=rs(ss(ss(t))),1===es(e)?(ns(ss(t),0),ns(e,0),ns(ss(ss(t)),1),t=ss(ss(t))):(t===rs(ss(t))&&(t=ss(t),this.rotateLeft(t)),ns(ss(t),0),ns(ss(ss(t)),1),this.rotateRight(ss(ss(t))))):(e=is(ss(ss(t))),1===es(e)?(ns(ss(t),0),ns(e,0),ns(ss(ss(t)),1),t=ss(ss(t))):(t===is(ss(t))&&(t=ss(t),this.rotateRight(t)),ns(ss(t),0),ns(ss(ss(t)),1),this.rotateLeft(ss(ss(t)))));this.root_.color=0}values(){const t=new L;let e=this.getFirstEntry();if(null!==e)for(t.add(e.value);null!==(e=os.successor(e));)t.add(e.value);return t}entrySet(){const t=new pt;let e=this.getFirstEntry();if(null!==e)for(t.add(e);null!==(e=os.successor(e));)t.add(e);return t}rotateLeft(t){if(null!=t){const e=t.right;t.right=e.left,null!=e.left&&(e.left.parent=t),e.parent=t.parent,null==t.parent?this.root_=e:t.parent.left===t?t.parent.left=e:t.parent.right=e,e.left=t,t.parent=e}}rotateRight(t){if(null!=t){const e=t.left;t.left=e.right,null!=e.right&&(e.right.parent=t),e.parent=t.parent,null==t.parent?this.root_=e:t.parent.right===t?t.parent.right=e:t.parent.left=e,e.right=t,t.parent=e}}getFirstEntry(){let t=this.root_;if(null!=t)for(;null!=t.left;)t=t.left;return t}static successor(t){let e;if(null===t)return null;if(null!==t.right){for(e=t.right;null!==e.left;)e=e.left;return e}{e=t.parent;let s=t;for(;null!==e&&s===e.right;)s=e,e=e.parent;return e}}size(){return this.size_}containsKey(t){let e=this.root_;for(;null!==e;){const s=t.compareTo(e.key);if(s<0)e=e.left;else{if(!(s>0))return!0;e=e.right}}return!1}}class ls{constructor(){ls.constructor_.apply(this,arguments)}static constructor_(){this._nodeMap=new os,this._edge=null;const t=arguments[0];this._edge=t}getSplitCoordinates(){const t=new R;this.addEndpoints();const e=this.iterator();let s=e.next();for(;e.hasNext();){const n=e.next();this.addEdgeCoordinates(s,n,t),s=n}return t.toCoordinateArray()}print(t){t.println("Intersections:");for(let e=this.iterator();e.hasNext();){e.next().print(t)}}findCollapsesFromExistingVertices(t){for(let e=0;e<this._edge.size()-2;e++){const s=this._edge.getCoordinate(e);this._edge.getCoordinate(e+1);const n=this._edge.getCoordinate(e+2);s.equals2D(n)&&t.add(M.valueOf(e+1))}}addEdgeCoordinates(t,e,s){const n=this.createSplitEdgePts(t,e);s.add(n,!1)}findCollapseIndex(t,e,s){if(!t.coord.equals2D(e.coord))return!1;let n=e.segmentIndex-t.segmentIndex;return e.isInterior()||n--,1===n&&(s[0]=t.segmentIndex+1,!0)}findCollapsesFromInsertedNodes(t){const e=new Array(1).fill(null),s=this.iterator();let n=s.next();for(;s.hasNext();){const i=s.next();this.findCollapseIndex(n,i,e)&&t.add(M.valueOf(e[0])),n=i}}getEdge(){return this._edge}addEndpoints(){const t=this._edge.size()-1;this.add(this._edge.getCoordinate(0),0),this.add(this._edge.getCoordinate(t),t)}createSplitEdge(t,e){const s=this.createSplitEdgePts(t,e);return new us(s,this._edge.getData())}add(t,e){const s=new $e(this._edge,t,e,this._edge.getSegmentOctant(e)),n=this._nodeMap.get(s);return null!==n?(h.isTrue(n.coord.equals2D(t),"Found equal nodes with different coordinates"),n):(this._nodeMap.put(s,s),s)}checkSplitEdgesCorrectness(t){const e=this._edge.getCoordinates(),s=t.get(0).getCoordinate(0);if(!s.equals2D(e[0]))throw new a("bad split edge start point at "+s);const n=t.get(t.size()-1).getCoordinates(),i=n[n.length-1];if(!i.equals2D(e[e.length-1]))throw new a("bad split edge end point at "+i)}addCollapsedNodes(){const t=new L;this.findCollapsesFromInsertedNodes(t),this.findCollapsesFromExistingVertices(t);for(let e=t.iterator();e.hasNext();){const t=e.next().intValue();this.add(this._edge.getCoordinate(t),t)}}createSplitEdgePts(t,e){let s=e.segmentIndex-t.segmentIndex+2;if(2===s)return[new m(t.coord),new m(e.coord)];const n=this._edge.getCoordinate(e.segmentIndex),i=e.isInterior()||!e.coord.equals2D(n);i||s--;const r=new Array(s).fill(null);let o=0;r[o++]=new m(t.coord);for(let s=t.segmentIndex+1;s<=e.segmentIndex;s++)r[o++]=this._edge.getCoordinate(s);return i&&(r[o]=new m(e.coord)),r}iterator(){return this._nodeMap.values().iterator()}addSplitEdges(t){this.addEndpoints(),this.addCollapsedNodes();const e=this.iterator();let s=e.next();for(;e.hasNext();){const n=e.next(),i=this.createSplitEdge(s,n);t.add(i),s=n}}}class as{static octant(){if("number"==typeof arguments[0]&&"number"==typeof arguments[1]){const t=arguments[0],e=arguments[1];if(0===t&&0===e)throw new n("Cannot compute the octant for point ( "+t+", "+e+" )");const s=Math.abs(t),i=Math.abs(e);return t>=0?e>=0?s>=i?0:1:s>=i?7:6:e>=0?s>=i?3:2:s>=i?4:5}if(arguments[0]instanceof m&&arguments[1]instanceof m){const t=arguments[0],e=arguments[1],s=e.x-t.x,i=e.y-t.y;if(0===s&&0===i)throw new n("Cannot compute the octant for two identical points "+t);return as.octant(s,i)}}}class cs{getCoordinates(){}size(){}getCoordinate(t){}isClosed(){}setData(t){}getData(){}}class hs{addIntersection(t,e){}get interfaces_(){return[cs]}}class us{constructor(){us.constructor_.apply(this,arguments)}static constructor_(){this._nodeList=new ls(this),this._pts=null,this._data=null;const t=arguments[0],e=arguments[1];this._pts=t,this._data=e}static getNodedSubstrings(){if(1===arguments.length){const t=arguments[0],e=new L;return us.getNodedSubstrings(t,e),e}if(2===arguments.length){const t=arguments[1];for(let e=arguments[0].iterator();e.hasNext();){e.next().getNodeList().addSplitEdges(t)}}}getCoordinates(){return this._pts}size(){return this._pts.length}getCoordinate(t){return this._pts[t]}isClosed(){return this._pts[0].equals(this._pts[this._pts.length-1])}getSegmentOctant(t){return t===this._pts.length-1?-1:this.safeOctant(this.getCoordinate(t),this.getCoordinate(t+1))}toString(){return Wt.toLineString(new it(this._pts))}getNodeList(){return this._nodeList}addIntersectionNode(t,e){let s=e;const n=s+1;if(n<this._pts.length){const e=this._pts[n];t.equals2D(e)&&(s=n)}return this._nodeList.add(t,s)}addIntersections(t,e,s){for(let n=0;n<t.getIntersectionNum();n++)this.addIntersection(t,e,s,n)}setData(t){this._data=t}safeOctant(t,e){return t.equals2D(e)?0:as.octant(t,e)}getData(){return this._data}addIntersection(){if(2===arguments.length){const t=arguments[0],e=arguments[1];this.addIntersectionNode(t,e)}else if(4===arguments.length){const t=arguments[1],e=arguments[3],s=new m(arguments[0].getIntersection(e));this.addIntersection(s,t)}}get interfaces_(){return[hs]}}class gs{getNodedSubstrings(){}computeNodes(t){}}class ds{constructor(){ds.constructor_.apply(this,arguments)}static constructor_(){if(this._noder=null,this._scaleFactor=null,this._offsetX=null,this._offsetY=null,this._isScaled=!1,2===arguments.length){const t=arguments[0],e=arguments[1];ds.constructor_.call(this,t,e,0,0)}else if(4===arguments.length){const t=arguments[0],e=arguments[1];this._noder=t,this._scaleFactor=e,this._isScaled=!this.isIntegerPrecision()}}rescale(){if(I(arguments[0],N)){for(let t=arguments[0].iterator();t.hasNext();){const e=t.next();this.rescale(e.getCoordinates())}}else if(arguments[0]instanceof Array){const t=arguments[0];for(let e=0;e<t.length;e++)t[e].x=t[e].x/this._scaleFactor+this._offsetX,t[e].y=t[e].y/this._scaleFactor+this._offsetY;2===t.length&&t[0].equals2D(t[1])&&Y.out.println(t)}}scale(){if(I(arguments[0],N)){const t=arguments[0],e=new L(t.size());for(let s=t.iterator();s.hasNext();){const t=s.next();e.add(new us(this.scale(t.getCoordinates()),t.getData()))}return e}if(arguments[0]instanceof Array){const t=arguments[0],e=new Array(t.length).fill(null);for(let s=0;s<t.length;s++)e[s]=new m(Math.round((t[s].x-this._offsetX)*this._scaleFactor),Math.round((t[s].y-this._offsetY)*this._scaleFactor),t[s].getZ());return W.removeRepeatedPoints(e)}}isIntegerPrecision(){return 1===this._scaleFactor}getNodedSubstrings(){const t=this._noder.getNodedSubstrings();return this._isScaled&&this.rescale(t),t}computeNodes(t){let e=t;this._isScaled&&(e=this.scale(t)),this._noder.computeNodes(e)}get interfaces_(){return[gs]}}class _s extends a{constructor(t,e){super(e?t+" [ "+e+" ]":t),this.pt=e?new m(e):void 0,this.name=Object.keys({TopologyException:_s})[0]}getCoordinate(){return this.pt}}class ps{constructor(){ps.constructor_.apply(this,arguments)}static constructor_(){this._li=new jt,this._segStrings=null;const t=arguments[0];this._segStrings=t}checkEndPtVertexIntersections(){if(0===arguments.length)for(let t=this._segStrings.iterator();t.hasNext();){const e=t.next().getCoordinates();this.checkEndPtVertexIntersections(e[0],this._segStrings),this.checkEndPtVertexIntersections(e[e.length-1],this._segStrings)}else if(2===arguments.length){const t=arguments[0];for(let e=arguments[1].iterator();e.hasNext();){const s=e.next().getCoordinates();for(let e=1;e<s.length-1;e++)if(s[e].equals(t))throw new a("found endpt/interior pt intersection at index "+e+" :pt "+t)}}}checkInteriorIntersections(){if(0===arguments.length)for(let t=this._segStrings.iterator();t.hasNext();){const e=t.next();for(let t=this._segStrings.iterator();t.hasNext();){const s=t.next();this.checkInteriorIntersections(e,s)}}else if(2===arguments.length){const t=arguments[0],e=arguments[1],s=t.getCoordinates(),n=e.getCoordinates();for(let i=0;i<s.length-1;i++)for(let s=0;s<n.length-1;s++)this.checkInteriorIntersections(t,i,e,s)}else if(4===arguments.length){const t=arguments[0],e=arguments[1],s=arguments[2],n=arguments[3];if(t===s&&e===n)return null;const i=t.getCoordinates()[e],r=t.getCoordinates()[e+1],o=s.getCoordinates()[n],l=s.getCoordinates()[n+1];if(this._li.computeIntersection(i,r,o,l),this._li.hasIntersection()&&(this._li.isProper()||this.hasInteriorIntersection(this._li,i,r)||this.hasInteriorIntersection(this._li,o,l)))throw new a("found non-noded intersection at "+i+"-"+r+" and "+o+"-"+l)}}checkValid(){this.checkEndPtVertexIntersections(),this.checkInteriorIntersections(),this.checkCollapses()}checkCollapses(){if(0===arguments.length)for(let t=this._segStrings.iterator();t.hasNext();){const e=t.next();this.checkCollapses(e)}else if(1===arguments.length){const t=arguments[0].getCoordinates();for(let e=0;e<t.length-2;e++)this.checkCollapse(t[e],t[e+1],t[e+2])}}hasInteriorIntersection(t,e,s){for(let n=0;n<t.getIntersectionNum();n++){const i=t.getIntersection(n);if(!i.equals(e)&&!i.equals(s))return!0}return!1}checkCollapse(t,e,s){if(t.equals(s))throw new a("found non-noded collapse at "+ps.fact.createLineString([t,e,s]))}}ps.fact=new Lt;class ms{getBounds(){}}class fs{constructor(){fs.constructor_.apply(this,arguments)}static constructor_(){this._bounds=null,this._item=null;const t=arguments[0],e=arguments[1];this._bounds=t,this._item=e}getItem(){return this._item}getBounds(){return this._bounds}get interfaces_(){return[ms,l]}}function ys(t){return t&&t.__esModule&&Object.prototype.hasOwnProperty.call(t,"default")?t.default:t}var xs,Es;var Is=function(){if(Es)return xs;Es=1;var t=function(t,e){return t<e};function e(s){if(!(this instanceof e))return new e(s);this.array=[],this.size=0,this.compare=s||t}return e.prototype.clone=function(){var t=new e(this.compare);return t.size=this.size,t.array=this.array.slice(0,this.size),t},e.prototype.add=function(t){var e,s,n=this.size;for(this.array[this.size]=t,this.size+=1;n>0&&(e=n-1>>1,s=this.array[e],this.compare(t,s));)this.array[n]=s,n=e;this.array[n]=t},e.prototype.heapify=function(t){var e;for(this.array=t,this.size=t.length,e=this.size>>1;e>=0;e--)this._percolateDown(e)},e.prototype._percolateUp=function(t,e){for(var s,n,i=this.array[t];t>0&&(s=t-1>>1,n=this.array[s],e||this.compare(i,n));)this.array[t]=n,t=s;this.array[t]=i},e.prototype._percolateDown=function(t){for(var e,s,n,i=this.size,r=this.size>>>1,o=this.array[t];t<r&&(s=(e=1+(t<<1))+1,n=this.array[e],s<i&&this.compare(this.array[s],n)&&(e=s,n=this.array[s]),this.compare(n,o));)this.array[t]=n,t=e;this.array[t]=o},e.prototype._removeAt=function(t){if(!(t>this.size-1||t<0))return this._percolateUp(t,!0),this.poll()},e.prototype.remove=function(t){for(var e=0;e<this.size;e++)if(!this.compare(this.array[e],t)&&!this.compare(t,this.array[e]))return this._removeAt(e),!0;return!1},e.prototype.removeOne=function(t){if("function"==typeof t)for(var e=0;e<this.size;e++)if(t(this.array[e]))return this._removeAt(e)},e.prototype.removeMany=function(t,e){if("function"!=typeof t||this.size<1)return[];e=e?Math.min(e,this.size):this.size;for(var s=0,n=new Array(e),i=0,r=new Array(this.size);s<e&&!this.isEmpty();){var o=this.poll();t(o)?n[s++]=o:r[i++]=o}n.length=s;for(var l=0;l<i;)this.add(r[l++]);return n},e.prototype.peek=function(){if(0!=this.size)return this.array[0]},e.prototype.poll=function(){if(0!=this.size){var t=this.array[0];return this.size>1?(this.array[0]=this.array[--this.size],this._percolateDown(0)):this.size-=1,t}},e.prototype.replaceTop=function(t){if(0!=this.size){var e=this.array[0];return this.array[0]=t,this._percolateDown(0),e}},e.prototype.trim=function(){this.array=this.array.slice(0,this.size)},e.prototype.isEmpty=function(){return 0===this.size},e.prototype.forEach=function(t){if(!this.isEmpty()&&"function"==typeof t)for(var e=0,s=this.clone();!s.isEmpty();)t(s.poll(),e++)},e.prototype.kSmallest=function(t){if(0==this.size||t<=0)return[];t=Math.min(this.size,t);const s=Math.min(this.size,2**(t-1)+1);if(s<2)return[this.peek()];const n=new e(this.compare);n.size=s,n.array=this.array.slice(0,s);const i=new Array(t);for(let e=0;e<t;e++)i[e]=n.poll();return i},xs=e}(),Ns=ys(Is);let ws=class{constructor(){this._fpQueue=new Ns(((t,e)=>t.compareTo(e)<0))}poll(){return this._fpQueue.poll()}size(){return this._fpQueue.size}clear(){this._fpQueue=new Ns}peek(){return this._fpQueue.peek()}remove(){return this._fpQueue.poll()}isEmpty(){return this._fpQueue.isEmpty()}add(t){this._fpQueue.add(t)}};class Cs{query(){}insert(t,e){}remove(t,e){}}class Ss{constructor(){Ss.constructor_.apply(this,arguments)}static constructor_(){if(this._childBoundables=new L,this._bounds=null,this._level=null,0===arguments.length);else if(1===arguments.length){const t=arguments[0];this._level=t}}getLevel(){return this._level}addChildBoundable(t){h.isTrue(null===this._bounds),this._childBoundables.add(t)}isEmpty(){return this._childBoundables.isEmpty()}getBounds(){return null===this._bounds&&(this._bounds=this.computeBounds()),this._bounds}size(){return this._childBoundables.size()}getChildBoundables(){return this._childBoundables}get interfaces_(){return[ms,l]}}class Ls{static distance(t,e,s,n){const i=s-t,r=n-e;return Math.sqrt(i*i+r*r)}static maximumDistance(t,e){const s=Math.min(t.getMinX(),e.getMinX()),n=Math.min(t.getMinY(),e.getMinY()),i=Math.max(t.getMaxX(),e.getMaxX()),r=Math.max(t.getMaxY(),e.getMaxY());return Ls.distance(s,n,i,r)}static minMaxDistance(t,e){const s=t.getMinX(),n=t.getMinY(),i=t.getMaxX(),r=t.getMaxY(),o=e.getMinX(),l=e.getMinY(),a=e.getMaxX(),c=e.getMaxY();let h=Ls.maxDistance(s,n,s,r,o,l,o,c);return h=Math.min(h,Ls.maxDistance(s,n,s,r,o,l,a,l)),h=Math.min(h,Ls.maxDistance(s,n,s,r,a,c,o,c)),h=Math.min(h,Ls.maxDistance(s,n,s,r,a,c,a,l)),h=Math.min(h,Ls.maxDistance(s,n,i,n,o,l,o,c)),h=Math.min(h,Ls.maxDistance(s,n,i,n,o,l,a,l)),h=Math.min(h,Ls.maxDistance(s,n,i,n,a,c,o,c)),h=Math.min(h,Ls.maxDistance(s,n,i,n,a,c,a,l)),h=Math.min(h,Ls.maxDistance(i,r,s,r,o,l,o,c)),h=Math.min(h,Ls.maxDistance(i,r,s,r,o,l,a,l)),h=Math.min(h,Ls.maxDistance(i,r,s,r,a,c,o,c)),h=Math.min(h,Ls.maxDistance(i,r,s,r,a,c,a,l)),h=Math.min(h,Ls.maxDistance(i,r,i,n,o,l,o,c)),h=Math.min(h,Ls.maxDistance(i,r,i,n,o,l,a,l)),h=Math.min(h,Ls.maxDistance(i,r,i,n,a,c,o,c)),h=Math.min(h,Ls.maxDistance(i,r,i,n,a,c,a,l)),h}static maxDistance(t,e,s,n,i,r,o,l){let a=Ls.distance(t,e,i,r);return a=Math.max(a,Ls.distance(t,e,o,l)),a=Math.max(a,Ls.distance(s,n,i,r)),a=Math.max(a,Ls.distance(s,n,o,l)),a}}class Ts{constructor(){Ts.constructor_.apply(this,arguments)}static constructor_(){this._boundable1=null,this._boundable2=null,this._distance=null,this._itemDistance=null;const t=arguments[0],e=arguments[1],s=arguments[2];this._boundable1=t,this._boundable2=e,this._itemDistance=s,this._distance=this.distance()}static area(t){return t.getBounds().getArea()}static isComposite(t){return t instanceof Ss}maximumDistance(){return Ls.maximumDistance(this._boundable1.getBounds(),this._boundable2.getBounds())}expandToQueue(t,e){const s=Ts.isComposite(this._boundable1),i=Ts.isComposite(this._boundable2);if(s&&i)return Ts.area(this._boundable1)>Ts.area(this._boundable2)?(this.expand(this._boundable1,this._boundable2,!1,t,e),null):(this.expand(this._boundable2,this._boundable1,!0,t,e),null);if(s)return this.expand(this._boundable1,this._boundable2,!1,t,e),null;if(i)return this.expand(this._boundable2,this._boundable1,!0,t,e),null;throw new n("neither boundable is composite")}isLeaves(){return!(Ts.isComposite(this._boundable1)||Ts.isComposite(this._boundable2))}getBoundable(t){return 0===t?this._boundable1:this._boundable2}getDistance(){return this._distance}distance(){return this.isLeaves()?this._itemDistance.distance(this._boundable1,this._boundable2):this._boundable1.getBounds().distance(this._boundable2.getBounds())}compareTo(t){const e=t;return this._distance<e._distance?-1:this._distance>e._distance?1:0}expand(t,e,s,n,i){for(let r=t.getChildBoundables().iterator();r.hasNext();){const t=r.next();let o=null;o=s?new Ts(e,t,this._itemDistance):new Ts(t,e,this._itemDistance),o.getDistance()<i&&n.add(o)}}get interfaces_(){return[o]}}class Rs{constructor(){Rs.constructor_.apply(this,arguments)}static constructor_(){if(this._root=null,this._built=!1,this._itemBoundables=new L,this._nodeCapacity=null,0===arguments.length)Rs.constructor_.call(this,Rs.DEFAULT_NODE_CAPACITY);else if(1===arguments.length){const t=arguments[0];h.isTrue(t>1,"Node capacity must be greater than 1"),this._nodeCapacity=t}}static compareDoubles(t,e){return t>e?1:t<e?-1:0}queryInternal(){if(I(arguments[2],De)&&arguments[0]instanceof Object&&arguments[1]instanceof Ss){const t=arguments[0],e=arguments[2],s=arguments[1].getChildBoundables();for(let n=0;n<s.size();n++){const i=s.get(n);this.getIntersectsOp().intersects(i.getBounds(),t)&&(i instanceof Ss?this.queryInternal(t,i,e):i instanceof fs?e.visitItem(i.getItem()):h.shouldNeverReachHere())}}else if(I(arguments[2],C)&&arguments[0]instanceof Object&&arguments[1]instanceof Ss){const t=arguments[0],e=arguments[2],s=arguments[1].getChildBoundables();for(let n=0;n<s.size();n++){const i=s.get(n);this.getIntersectsOp().intersects(i.getBounds(),t)&&(i instanceof Ss?this.queryInternal(t,i,e):i instanceof fs?e.add(i.getItem()):h.shouldNeverReachHere())}}}insert(t,e){h.isTrue(!this._built,"Cannot insert items into an STR packed R-tree after it has been built."),this._itemBoundables.add(new fs(t,e))}boundablesAtLevel(){if(1===arguments.length){const t=arguments[0],e=new L;return this.boundablesAtLevel(t,this._root,e),e}if(3===arguments.length){const t=arguments[0],e=arguments[1],s=arguments[2];if(h.isTrue(t>-2),e.getLevel()===t)return s.add(e),null;for(let n=e.getChildBoundables().iterator();n.hasNext();){const e=n.next();e instanceof Ss?this.boundablesAtLevel(t,e,s):(h.isTrue(e instanceof fs),-1===t&&s.add(e))}return null}}getRoot(){return this.build(),this._root}remove(){if(2===arguments.length){const t=arguments[0],e=arguments[1];return this.build(),!!this.getIntersectsOp().intersects(this._root.getBounds(),t)&&this.remove(t,this._root,e)}if(3===arguments.length){const t=arguments[0],e=arguments[1],s=arguments[2];let n=this.removeItem(e,s);if(n)return!0;let i=null;for(let r=e.getChildBoundables().iterator();r.hasNext();){const e=r.next();if(this.getIntersectsOp().intersects(e.getBounds(),t)&&(e instanceof Ss&&(n=this.remove(t,e,s),n))){i=e;break}}return null!==i&&i.getChildBoundables().isEmpty()&&e.getChildBoundables().remove(i),n}}createHigherLevels(t,e){h.isTrue(!t.isEmpty());const s=this.createParentBoundables(t,e+1);return 1===s.size()?s.get(0):this.createHigherLevels(s,e+1)}depth(){if(0===arguments.length)return this.isEmpty()?0:(this.build(),this.depth(this._root));if(1===arguments.length){let t=0;for(let e=arguments[0].getChildBoundables().iterator();e.hasNext();){const s=e.next();if(s instanceof Ss){const e=this.depth(s);e>t&&(t=e)}}return t+1}}createParentBoundables(t,e){h.isTrue(!t.isEmpty());const s=new L;s.add(this.createNode(e));const n=new L(t);xe.sort(n,this.getComparator());for(let t=n.iterator();t.hasNext();){const n=t.next();this.lastNode(s).getChildBoundables().size()===this.getNodeCapacity()&&s.add(this.createNode(e)),this.lastNode(s).addChildBoundable(n)}return s}isEmpty(){return this._built?this._root.isEmpty():this._itemBoundables.isEmpty()}getNodeCapacity(){return this._nodeCapacity}lastNode(t){return t.get(t.size()-1)}size(){if(0===arguments.length)return this.isEmpty()?0:(this.build(),this.size(this._root));if(1===arguments.length){let t=0;for(let e=arguments[0].getChildBoundables().iterator();e.hasNext();){const s=e.next();s instanceof Ss?t+=this.size(s):s instanceof fs&&(t+=1)}return t}}removeItem(t,e){let s=null;for(let n=t.getChildBoundables().iterator();n.hasNext();){const t=n.next();t instanceof fs&&t.getItem()===e&&(s=t)}return null!==s&&(t.getChildBoundables().remove(s),!0)}itemsTree(){if(0===arguments.length){this.build();const t=this.itemsTree(this._root);return null===t?new L:t}if(1===arguments.length){const t=arguments[0],e=new L;for(let s=t.getChildBoundables().iterator();s.hasNext();){const t=s.next();if(t instanceof Ss){const s=this.itemsTree(t);null!==s&&e.add(s)}else t instanceof fs?e.add(t.getItem()):h.shouldNeverReachHere()}return e.size()<=0?null:e}}query(){if(1===arguments.length){const t=arguments[0];this.build();const e=new L;return this.isEmpty()||this.getIntersectsOp().intersects(this._root.getBounds(),t)&&this.queryInternal(t,this._root,e),e}if(2===arguments.length){const t=arguments[0],e=arguments[1];if(this.build(),this.isEmpty())return null;this.getIntersectsOp().intersects(this._root.getBounds(),t)&&this.queryInternal(t,this._root,e)}}build(){if(this._built)return null;this._root=this._itemBoundables.isEmpty()?this.createNode(0):this.createHigherLevels(this._itemBoundables,-1),this._itemBoundables=null,this._built=!0}get interfaces_(){return[l]}}Rs.IntersectsOp=function(){},Rs.DEFAULT_NODE_CAPACITY=10;class Ps{distance(t,e){}}class Os extends Rs{constructor(){super(),Os.constructor_.apply(this,arguments)}static constructor_(){if(0===arguments.length)Os.constructor_.call(this,Os.DEFAULT_NODE_CAPACITY);else if(1===arguments.length){const t=arguments[0];Rs.constructor_.call(this,t)}}static getItems(t){const e=new Array(t.size()).fill(null);let s=0;for(;!t.isEmpty();){const n=t.poll();e[s]=n.getBoundable(0).getItem(),s++}return e}static avg(t,e){return(t+e)/2}static centreY(t){return Os.avg(t.getMinY(),t.getMaxY())}static centreX(t){return Os.avg(t.getMinX(),t.getMaxX())}size(){return 0===arguments.length?super.size.call(this):super.size.apply(this,arguments)}insert(){if(!(2===arguments.length&&arguments[1]instanceof Object&&arguments[0]instanceof O))return super.insert.apply(this,arguments);{const t=arguments[0],e=arguments[1];if(t.isNull())return null;super.insert.call(this,t,e)}}getIntersectsOp(){return Os.intersectsOp}verticalSlices(t,e){const s=Math.trunc(Math.ceil(t.size()/e)),n=new Array(e).fill(null),i=t.iterator();for(let t=0;t<e;t++){n[t]=new L;let e=0;for(;i.hasNext()&&e<s;){const s=i.next();n[t].add(s),e++}}return n}query(){if(1===arguments.length){const t=arguments[0];return super.query.call(this,t)}if(2===arguments.length){const t=arguments[0],e=arguments[1];super.query.call(this,t,e)}}getComparator(){return Os.yComparator}createParentBoundablesFromVerticalSlice(t,e){return super.createParentBoundables.call(this,t,e)}remove(){if(2===arguments.length&&arguments[1]instanceof Object&&arguments[0]instanceof O){const t=arguments[0],e=arguments[1];return super.remove.call(this,t,e)}return super.remove.apply(this,arguments)}depth(){return 0===arguments.length?super.depth.call(this):super.depth.apply(this,arguments)}createParentBoundables(t,e){h.isTrue(!t.isEmpty());const s=Math.trunc(Math.ceil(t.size()/this.getNodeCapacity())),n=new L(t);xe.sort(n,Os.xComparator);const i=this.verticalSlices(n,Math.trunc(Math.ceil(Math.sqrt(s))));return this.createParentBoundablesFromVerticalSlices(i,e)}nearestNeighbour(){if(1===arguments.length){if(I(arguments[0],Ps)){const t=arguments[0];if(this.isEmpty())return null;const e=new Ts(this.getRoot(),this.getRoot(),t);return this.nearestNeighbour(e)}if(arguments[0]instanceof Ts){const t=arguments[0];let e=r.POSITIVE_INFINITY,s=null;const n=new ws;for(n.add(t);!n.isEmpty()&&e>0;){const t=n.poll(),i=t.getDistance();if(i>=e)break;t.isLeaves()?(e=i,s=t):t.expandToQueue(n,e)}return null===s?null:[s.getBoundable(0).getItem(),s.getBoundable(1).getItem()]}}else{if(2===arguments.length){const t=arguments[0],e=arguments[1];if(this.isEmpty()||t.isEmpty())return null;const s=new Ts(this.getRoot(),t.getRoot(),e);return this.nearestNeighbour(s)}if(3===arguments.length){const t=arguments[2],e=new fs(arguments[0],arguments[1]),s=new Ts(this.getRoot(),e,t);return this.nearestNeighbour(s)[0]}if(4===arguments.length){const t=arguments[2],e=arguments[3],s=new fs(arguments[0],arguments[1]),n=new Ts(this.getRoot(),s,t);return this.nearestNeighbourK(n,e)}}}isWithinDistance(){if(2===arguments.length){const t=arguments[0],e=arguments[1];let s=r.POSITIVE_INFINITY;const n=new ws;for(n.add(t);!n.isEmpty();){const t=n.poll(),i=t.getDistance();if(i>e)return!1;if(t.maximumDistance()<=e)return!0;if(t.isLeaves()){if(s=i,s<=e)return!0}else t.expandToQueue(n,s)}return!1}if(3===arguments.length){const t=arguments[0],e=arguments[1],s=arguments[2],n=new Ts(this.getRoot(),t.getRoot(),e);return this.isWithinDistance(n,s)}}createParentBoundablesFromVerticalSlices(t,e){h.isTrue(t.length>0);const s=new L;for(let n=0;n<t.length;n++)s.addAll(this.createParentBoundablesFromVerticalSlice(t[n],e));return s}nearestNeighbourK(){if(2===arguments.length){const t=arguments[0],e=arguments[1];return this.nearestNeighbourK(t,r.POSITIVE_INFINITY,e)}if(3===arguments.length){const t=arguments[0],e=arguments[2];let s=arguments[1];const n=new ws;n.add(t);const i=new ws;for(;!n.isEmpty()&&s>=0;){const t=n.poll(),r=t.getDistance();if(r>=s)break;if(t.isLeaves())if(i.size()<e)i.add(t);else{i.peek().getDistance()>r&&(i.poll(),i.add(t));s=i.peek().getDistance()}else t.expandToQueue(n,s)}return Os.getItems(i)}}createNode(t){return new vs(t)}get interfaces_(){return[Cs,l]}}class vs extends Ss{constructor(){super(),vs.constructor_.apply(this,arguments)}static constructor_(){const t=arguments[0];Ss.constructor_.call(this,t)}computeBounds(){let t=null;for(let e=this.getChildBoundables().iterator();e.hasNext();){const s=e.next();null===t?t=new O(s.getBounds()):t.expandToInclude(s.getBounds())}return t}}Os.STRtreeNode=vs,Os.xComparator=new class{get interfaces_(){return[g]}compare(t,e){return Rs.compareDoubles(Os.centreX(t.getBounds()),Os.centreX(e.getBounds()))}},Os.yComparator=new class{get interfaces_(){return[g]}compare(t,e){return Rs.compareDoubles(Os.centreY(t.getBounds()),Os.centreY(e.getBounds()))}},Os.intersectsOp=new class{get interfaces_(){return[IntersectsOp]}intersects(t,e){return t.intersects(e)}},Os.DEFAULT_NODE_CAPACITY=10;class Ms{constructor(){Ms.constructor_.apply(this,arguments)}static constructor_(){this._overlapSeg1=new Kt,this._overlapSeg2=new Kt}overlap(){if(2===arguments.length);else if(4===arguments.length){const t=arguments[1],e=arguments[2],s=arguments[3];arguments[0].getLineSegment(t,this._overlapSeg1),e.getLineSegment(s,this._overlapSeg2),this.overlap(this._overlapSeg1,this._overlapSeg2)}}}let bs=class t{constructor(){t.constructor_.apply(this,arguments)}static constructor_(){this._pts=null,this._start=null,this._end=null,this._env=null,this._context=null,this._id=null;const t=arguments[0],e=arguments[1],s=arguments[2],n=arguments[3];this._pts=t,this._start=e,this._end=s,this._context=n}computeOverlaps(){if(2===arguments.length){const t=arguments[0],e=arguments[1];this.computeOverlaps(this._start,this._end,t,t._start,t._end,e)}else if(6===arguments.length){const t=arguments[0],e=arguments[1],s=arguments[2],n=arguments[3],i=arguments[4],r=arguments[5];if(e-t==1&&i-n==1)return r.overlap(this,t,s,n),null;if(!this.overlaps(t,e,s,n,i))return null;const o=Math.trunc((t+e)/2),l=Math.trunc((n+i)/2);t<o&&(n<l&&this.computeOverlaps(t,o,s,n,l,r),l<i&&this.computeOverlaps(t,o,s,l,i,r)),o<e&&(n<l&&this.computeOverlaps(o,e,s,n,l,r),l<i&&this.computeOverlaps(o,e,s,l,i,r))}}setId(t){this._id=t}select(t,e){this.computeSelect(t,this._start,this._end,e)}getEnvelope(){if(null===this._env){const t=this._pts[this._start],e=this._pts[this._end];this._env=new O(t,e)}return this._env}overlaps(t,e,s,n,i){return O.intersects(this._pts[t],this._pts[e],s._pts[n],s._pts[i])}getEndIndex(){return this._end}getStartIndex(){return this._start}getContext(){return this._context}getId(){return this._id}getLineSegment(t,e){e.p0=this._pts[t],e.p1=this._pts[t+1]}computeSelect(t,e,s,n){const i=this._pts[e],r=this._pts[s];if(s-e==1)return n.select(this,e),null;if(!t.intersects(i,r))return null;const o=Math.trunc((e+s)/2);e<o&&this.computeSelect(t,e,o,n),o<s&&this.computeSelect(t,o,s,n)}getCoordinates(){const t=new Array(this._end-this._start+1).fill(null);let e=0;for(let s=this._start;s<=this._end;s++)t[e++]=this._pts[s];return t}};class Ds{static isNorthern(t){return t===Ds.NE||t===Ds.NW}static isOpposite(t,e){if(t===e)return!1;return 2===(t-e+4)%4}static commonHalfPlane(t,e){if(t===e)return t;if(2===(t-e+4)%4)return-1;const s=t<e?t:e;return 0===s&&3===(t>e?t:e)?3:s}static isInHalfPlane(t,e){return e===Ds.SE?t===Ds.SE||t===Ds.SW:t===e||t===e+1}static quadrant(){if("number"==typeof arguments[0]&&"number"==typeof arguments[1]){const t=arguments[0],e=arguments[1];if(0===t&&0===e)throw new n("Cannot compute the quadrant for point ( "+t+", "+e+" )");return t>=0?e>=0?Ds.NE:Ds.SE:e>=0?Ds.NW:Ds.SW}if(arguments[0]instanceof m&&arguments[1]instanceof m){const t=arguments[0],e=arguments[1];if(e.x===t.x&&e.y===t.y)throw new n("Cannot compute the quadrant for two identical points "+t);return e.x>=t.x?e.y>=t.y?Ds.NE:Ds.SE:e.y>=t.y?Ds.NW:Ds.SW}}}Ds.NE=0,Ds.NW=1,Ds.SW=2,Ds.SE=3;class As{static findChainEnd(t,e){let s=e;for(;s<t.length-1&&t[s].equals2D(t[s+1]);)s++;if(s>=t.length-1)return t.length-1;const n=Ds.quadrant(t[s],t[s+1]);let i=e+1;for(;i<t.length;){if(!t[i-1].equals2D(t[i])){if(Ds.quadrant(t[i-1],t[i])!==n)break}i++}return i-1}static getChains(){if(1===arguments.length){const t=arguments[0];return As.getChains(t,null)}if(2===arguments.length){const t=arguments[0],e=arguments[1],s=new L;let n=0;do{const i=As.findChainEnd(t,n),r=new bs(t,n,i,e);s.add(r),n=i}while(n<t.length-1);return s}}}class Fs{constructor(){Fs.constructor_.apply(this,arguments)}static constructor_(){if(this._segInt=null,0===arguments.length);else if(1===arguments.length){const t=arguments[0];this.setSegmentIntersector(t)}}setSegmentIntersector(t){this._segInt=t}get interfaces_(){return[gs]}}class Gs extends Fs{constructor(){super(),Gs.constructor_.apply(this,arguments)}static constructor_(){if(this._monoChains=new L,this._index=new Os,this._idCounter=0,this._nodedSegStrings=null,this._nOverlaps=0,0===arguments.length);else if(1===arguments.length){const t=arguments[0];Fs.constructor_.call(this,t)}}getMonotoneChains(){return this._monoChains}getNodedSubstrings(){return us.getNodedSubstrings(this._nodedSegStrings)}getIndex(){return this._index}add(t){for(let e=As.getChains(t.getCoordinates(),t).iterator();e.hasNext();){const t=e.next();t.setId(this._idCounter++),this._index.insert(t.getEnvelope(),t),this._monoChains.add(t)}}computeNodes(t){this._nodedSegStrings=t;for(let e=t.iterator();e.hasNext();)this.add(e.next());this.intersectChains()}intersectChains(){const t=new qs(this._segInt);for(let e=this._monoChains.iterator();e.hasNext();){const s=e.next();for(let e=this._index.query(s.getEnvelope()).iterator();e.hasNext();){const n=e.next();if(n.getId()>s.getId()&&(s.computeOverlaps(n,t),this._nOverlaps++),this._segInt.isDone())return null}}}}class qs extends Ms{constructor(){super(),qs.constructor_.apply(this,arguments)}static constructor_(){this._si=null;const t=arguments[0];this._si=t}overlap(){if(4!==arguments.length)return super.overlap.apply(this,arguments);{const t=arguments[1],e=arguments[2],s=arguments[3],n=arguments[0].getContext(),i=e.getContext();this._si.processIntersections(n,t,i,s)}}}Gs.SegmentOverlapAction=qs;class Bs{constructor(){Bs.constructor_.apply(this,arguments)}static constructor_(){this._li=null,this._pt=null,this._originalPt=null,this._ptScaled=null,this._p0Scaled=null,this._p1Scaled=null,this._scaleFactor=null,this._minx=null,this._maxx=null,this._miny=null,this._maxy=null,this._corner=new Array(4).fill(null),this._safeEnv=null;const t=arguments[0],e=arguments[1],s=arguments[2];if(this._originalPt=t,this._pt=t,this._scaleFactor=e,this._li=s,e<=0)throw new n("Scale factor must be non-zero");1!==e&&(this._pt=new m(this.scale(t.x),this.scale(t.y)),this._p0Scaled=new m,this._p1Scaled=new m),this.initCorners(this._pt)}intersectsScaled(t,e){const s=Math.min(t.x,e.x),n=Math.max(t.x,e.x),i=Math.min(t.y,e.y),r=Math.max(t.y,e.y),o=this._maxx<s||this._minx>n||this._maxy<i||this._miny>r;if(o)return!1;const l=this.intersectsToleranceSquare(t,e);return h.isTrue(!(o&&l),"Found bad envelope test"),l}copyScaled(t,e){e.x=this.scale(t.x),e.y=this.scale(t.y)}getSafeEnvelope(){if(null===this._safeEnv){const t=Bs.SAFE_ENV_EXPANSION_FACTOR/this._scaleFactor;this._safeEnv=new O(this._originalPt.x-t,this._originalPt.x+t,this._originalPt.y-t,this._originalPt.y+t)}return this._safeEnv}intersectsPixelClosure(t,e){return this._li.computeIntersection(t,e,this._corner[0],this._corner[1]),!!this._li.hasIntersection()||(this._li.computeIntersection(t,e,this._corner[1],this._corner[2]),!!this._li.hasIntersection()||(this._li.computeIntersection(t,e,this._corner[2],this._corner[3]),!!this._li.hasIntersection()||(this._li.computeIntersection(t,e,this._corner[3],this._corner[0]),!!this._li.hasIntersection())))}intersectsToleranceSquare(t,e){let s=!1,n=!1;return this._li.computeIntersection(t,e,this._corner[0],this._corner[1]),!!this._li.isProper()||(this._li.computeIntersection(t,e,this._corner[1],this._corner[2]),!!this._li.isProper()||(this._li.hasIntersection()&&(s=!0),this._li.computeIntersection(t,e,this._corner[2],this._corner[3]),!!this._li.isProper()||(this._li.hasIntersection()&&(n=!0),this._li.computeIntersection(t,e,this._corner[3],this._corner[0]),!!this._li.isProper()||(!(!s||!n)||(!!t.equals(this._pt)||!!e.equals(this._pt))))))}addSnappedNode(t,e){const s=t.getCoordinate(e),n=t.getCoordinate(e+1);return!!this.intersects(s,n)&&(t.addIntersection(this.getCoordinate(),e),!0)}initCorners(t){const e=.5;this._minx=t.x-e,this._maxx=t.x+e,this._miny=t.y-e,this._maxy=t.y+e,this._corner[0]=new m(this._maxx,this._maxy),this._corner[1]=new m(this._minx,this._maxy),this._corner[2]=new m(this._minx,this._miny),this._corner[3]=new m(this._maxx,this._miny)}intersects(t,e){return 1===this._scaleFactor?this.intersectsScaled(t,e):(this.copyScaled(t,this._p0Scaled),this.copyScaled(e,this._p1Scaled),this.intersectsScaled(this._p0Scaled,this._p1Scaled))}scale(t){return Math.round(t*this._scaleFactor)}getCoordinate(){return this._originalPt}}Bs.SAFE_ENV_EXPANSION_FACTOR=.75;class Ys{constructor(){Ys.constructor_.apply(this,arguments)}static constructor_(){this.selectedSegment=new Kt}select(){if(1===arguments.length);else if(2===arguments.length){const t=arguments[1];arguments[0].getLineSegment(t,this.selectedSegment),this.select(this.selectedSegment)}}}class zs{constructor(){zs.constructor_.apply(this,arguments)}static constructor_(){this._index=null;const t=arguments[0];this._index=t}snap(){if(1===arguments.length){const t=arguments[0];return this.snap(t,null,-1)}if(3===arguments.length){const t=arguments[0],e=arguments[1],s=arguments[2],n=t.getSafeEnvelope(),i=new Vs(t,e,s);return this._index.query(n,new class{get interfaces_(){return[De]}visitItem(t){t.select(n,i)}}),i.isNodeAdded()}}}class Vs extends Ys{constructor(){super(),Vs.constructor_.apply(this,arguments)}static constructor_(){this._hotPixel=null,this._parentEdge=null,this._hotPixelVertexIndex=null,this._isNodeAdded=!1;const t=arguments[0],e=arguments[1],s=arguments[2];this._hotPixel=t,this._parentEdge=e,this._hotPixelVertexIndex=s}select(){if(!(2===arguments.length&&Number.isInteger(arguments[1])&&arguments[0]instanceof bs))return super.select.apply(this,arguments);{const t=arguments[1],e=arguments[0].getContext();if(this._parentEdge===e&&(t===this._hotPixelVertexIndex||t+1===this._hotPixelVertexIndex))return null;this._isNodeAdded|=this._hotPixel.addSnappedNode(e,t)}}isNodeAdded(){return this._isNodeAdded}}zs.HotPixelSnapAction=Vs;let ks=class{isDone(){}processIntersections(t,e,s,n){}};class Xs{constructor(){Xs.constructor_.apply(this,arguments)}static constructor_(){this._li=null,this._interiorIntersections=null;const t=arguments[0];this._li=t,this._interiorIntersections=new L}isDone(){return!1}processIntersections(t,e,s,n){if(t===s&&e===n)return null;const i=t.getCoordinates()[e],r=t.getCoordinates()[e+1],o=s.getCoordinates()[n],l=s.getCoordinates()[n+1];if(this._li.computeIntersection(i,r,o,l),this._li.hasIntersection()&&this._li.isInteriorIntersection()){for(let t=0;t<this._li.getIntersectionNum();t++)this._interiorIntersections.add(this._li.getIntersection(t));t.addIntersections(this._li,e,0),s.addIntersections(this._li,n,1)}}getInteriorIntersections(){return this._interiorIntersections}get interfaces_(){return[ks]}}class Us{constructor(){Us.constructor_.apply(this,arguments)}static constructor_(){this._pm=null,this._li=null,this._scaleFactor=null,this._noder=null,this._pointSnapper=null,this._nodedSegStrings=null;const t=arguments[0];this._pm=t,this._li=new jt,this._li.setPrecisionModel(t),this._scaleFactor=t.getScale()}checkCorrectness(t){const e=us.getNodedSubstrings(t),n=new ps(e);try{n.checkValid()}catch(t){if(!(t instanceof s))throw t;t.printStackTrace()}}getNodedSubstrings(){return us.getNodedSubstrings(this._nodedSegStrings)}snapRound(t,e){const s=this.findInteriorIntersections(t,e);this.computeIntersectionSnaps(s),this.computeVertexSnaps(t)}findInteriorIntersections(t,e){const s=new Xs(e);return this._noder.setSegmentIntersector(s),this._noder.computeNodes(t),s.getInteriorIntersections()}computeVertexSnaps(){if(I(arguments[0],N)){for(let t=arguments[0].iterator();t.hasNext();){const e=t.next();this.computeVertexSnaps(e)}}else if(arguments[0]instanceof us){const t=arguments[0],e=t.getCoordinates();for(let s=0;s<e.length;s++){const n=new Bs(e[s],this._scaleFactor,this._li);this._pointSnapper.snap(n,t,s)&&t.addIntersection(e[s],s)}}}computeNodes(t){this._nodedSegStrings=t,this._noder=new Gs,this._pointSnapper=new zs(this._noder.getIndex()),this.snapRound(t,this._li)}computeIntersectionSnaps(t){for(let e=t.iterator();e.hasNext();){const t=e.next(),s=new Bs(t,this._scaleFactor,this._li);this._pointSnapper.snap(s)}}get interfaces_(){return[gs]}}class Hs{static opposite(t){return t===Hs.LEFT?Hs.RIGHT:t===Hs.RIGHT?Hs.LEFT:t}}Hs.ON=0,Hs.LEFT=1,Hs.RIGHT=2;class Ws extends s{constructor(t){super(t),this.name=Object.keys({EmptyStackException:Ws})[0]}}class Zs extends C{constructor(){super(),this.array=[]}add(t){return this.array.push(t),!0}get(t){if(t<0||t>=this.size())throw new w;return this.array[t]}push(t){return this.array.push(t),t}pop(){if(0===this.array.length)throw new Ws;return this.array.pop()}peek(){if(0===this.array.length)throw new Ws;return this.array[this.array.length-1]}empty(){return 0===this.array.length}isEmpty(){return this.empty()}search(t){return this.array.indexOf(t)}size(){return this.array.length}toArray(){return this.array.slice()}}class js{constructor(){js.constructor_.apply(this,arguments)}static constructor_(){this._minIndex=-1,this._minCoord=null,this._minDe=null,this._orientedDe=null}getCoordinate(){return this._minCoord}getRightmostSide(t,e){let s=this.getRightmostSideOfSegment(t,e);return s<0&&(s=this.getRightmostSideOfSegment(t,e-1)),s<0&&(this._minCoord=null,this.checkForRightmostCoordinate(t)),s}findRightmostEdgeAtVertex(){const t=this._minDe.getEdge().getCoordinates();h.isTrue(this._minIndex>0&&this._minIndex<t.length,"rightmost point expected to be interior vertex of edge");const e=t[this._minIndex-1],s=t[this._minIndex+1],n=q.index(this._minCoord,s,e);let i=!1;(e.y<this._minCoord.y&&s.y<this._minCoord.y&&n===q.COUNTERCLOCKWISE||e.y>this._minCoord.y&&s.y>this._minCoord.y&&n===q.CLOCKWISE)&&(i=!0),i&&(this._minIndex=this._minIndex-1)}getRightmostSideOfSegment(t,e){const s=t.getEdge().getCoordinates();if(e<0||e+1>=s.length)return-1;if(s[e].y===s[e+1].y)return-1;let n=Hs.LEFT;return s[e].y<s[e+1].y&&(n=Hs.RIGHT),n}getEdge(){return this._orientedDe}checkForRightmostCoordinate(t){const e=t.getEdge().getCoordinates();for(let s=0;s<e.length-1;s++)(null===this._minCoord||e[s].x>this._minCoord.x)&&(this._minDe=t,this._minIndex=s,this._minCoord=e[s])}findRightmostEdgeAtNode(){const t=this._minDe.getNode().getEdges();this._minDe=t.getRightmostEdge(),this._minDe.isForward()||(this._minDe=this._minDe.getSym(),this._minIndex=this._minDe.getEdge().getCoordinates().length-1)}findEdge(t){for(let e=t.iterator();e.hasNext();){const t=e.next();t.isForward()&&this.checkForRightmostCoordinate(t)}h.isTrue(0!==this._minIndex||this._minCoord.equals(this._minDe.getCoordinate()),"inconsistency in rightmost processing"),0===this._minIndex?this.findRightmostEdgeAtNode():this.findRightmostEdgeAtVertex(),this._orientedDe=this._minDe;this.getRightmostSide(this._minDe,this._minIndex)===Hs.LEFT&&(this._orientedDe=this._minDe.getSym())}}class Ks{constructor(){this.array=[]}addLast(t){this.array.push(t)}removeFirst(){return this.array.shift()}isEmpty(){return 0===this.array.length}}class Qs{constructor(){Qs.constructor_.apply(this,arguments)}static constructor_(){this._finder=null,this._dirEdgeList=new L,this._nodes=new L,this._rightMostCoord=null,this._env=null,this._finder=new js}clearVisitedEdges(){for(let t=this._dirEdgeList.iterator();t.hasNext();){t.next().setVisited(!1)}}compareTo(t){const e=t;return this._rightMostCoord.x<e._rightMostCoord.x?-1:this._rightMostCoord.x>e._rightMostCoord.x?1:0}getEnvelope(){if(null===this._env){const t=new O;for(let e=this._dirEdgeList.iterator();e.hasNext();){const s=e.next().getEdge().getCoordinates();for(let e=0;e<s.length-1;e++)t.expandToInclude(s[e])}this._env=t}return this._env}addReachable(t){const e=new Zs;for(e.add(t);!e.empty();){const t=e.pop();this.add(t,e)}}copySymDepths(t){const e=t.getSym();e.setDepth(Hs.LEFT,t.getDepth(Hs.RIGHT)),e.setDepth(Hs.RIGHT,t.getDepth(Hs.LEFT))}add(t,e){t.setVisited(!0),this._nodes.add(t);for(let s=t.getEdges().iterator();s.hasNext();){const t=s.next();this._dirEdgeList.add(t);const n=t.getSym().getNode();n.isVisited()||e.push(n)}}getRightmostCoordinate(){return this._rightMostCoord}computeNodeDepth(t){let e=null;for(let s=t.getEdges().iterator();s.hasNext();){const t=s.next();if(t.isVisited()||t.getSym().isVisited()){e=t;break}}if(null===e)throw new _s("unable to find edge to compute depths at "+t.getCoordinate());t.getEdges().computeDepths(e);for(let e=t.getEdges().iterator();e.hasNext();){const t=e.next();t.setVisited(!0),this.copySymDepths(t)}}computeDepth(t){this.clearVisitedEdges();const e=this._finder.getEdge();e.getNode(),e.getLabel(),e.setEdgeDepths(Hs.RIGHT,t),this.copySymDepths(e),this.computeDepths(e)}create(t){this.addReachable(t),this._finder.findEdge(this._dirEdgeList),this._rightMostCoord=this._finder.getCoordinate()}findResultEdges(){for(let t=this._dirEdgeList.iterator();t.hasNext();){const e=t.next();e.getDepth(Hs.RIGHT)>=1&&e.getDepth(Hs.LEFT)<=0&&!e.isInteriorAreaEdge()&&e.setInResult(!0)}}computeDepths(t){const e=new pt,s=new Ks,n=t.getNode();for(s.addLast(n),e.add(n),t.setVisited(!0);!s.isEmpty();){const t=s.removeFirst();e.add(t),this.computeNodeDepth(t);for(let n=t.getEdges().iterator();n.hasNext();){const t=n.next().getSym();if(t.isVisited())continue;const i=t.getNode();e.contains(i)||(s.addLast(i),e.add(i))}}}getNodes(){return this._nodes}getDirectedEdges(){return this._dirEdgeList}get interfaces_(){return[o]}}class Js{constructor(){Js.constructor_.apply(this,arguments)}static constructor_(){this._inputLine=null,this._distanceTol=null,this._isDeleted=null,this._angleOrientation=q.COUNTERCLOCKWISE;const t=arguments[0];this._inputLine=t}static simplify(t,e){return new Js(t).simplify(e)}isDeletable(t,e,s,n){const i=this._inputLine[t],r=this._inputLine[e],o=this._inputLine[s];return!!this.isConcave(i,r,o)&&(!!this.isShallow(i,r,o,n)&&this.isShallowSampled(i,r,t,s,n))}deleteShallowConcavities(){let t=1,e=this.findNextNonDeletedIndex(t),s=this.findNextNonDeletedIndex(e),n=!1;for(;s<this._inputLine.length;){let i=!1;this.isDeletable(t,e,s,this._distanceTol)&&(this._isDeleted[e]=Js.DELETE,i=!0,n=!0),t=i?s:e,e=this.findNextNonDeletedIndex(t),s=this.findNextNonDeletedIndex(e)}return n}isShallowConcavity(t,e,s,n){if(!(q.index(t,e,s)===this._angleOrientation))return!1;return V.pointToSegment(e,t,s)<n}isShallowSampled(t,e,s,n,i){let r=Math.trunc((n-s)/Js.NUM_PTS_TO_CHECK);r<=0&&(r=1);for(let o=s;o<n;o+=r)if(!this.isShallow(t,e,this._inputLine[o],i))return!1;return!0}isConcave(t,e,s){return q.index(t,e,s)===this._angleOrientation}simplify(t){this._distanceTol=Math.abs(t),t<0&&(this._angleOrientation=q.CLOCKWISE),this._isDeleted=new Array(this._inputLine.length).fill(null);let e=!1;do{e=this.deleteShallowConcavities()}while(e);return this.collapseLine()}findNextNonDeletedIndex(t){let e=t+1;for(;e<this._inputLine.length&&this._isDeleted[e]===Js.DELETE;)e++;return e}isShallow(t,e,s,n){return V.pointToSegment(e,t,s)<n}collapseLine(){const t=new R;for(let e=0;e<this._inputLine.length;e++)this._isDeleted[e]!==Js.DELETE&&t.add(this._inputLine[e]);return t.toCoordinateArray()}}Js.INIT=0,Js.DELETE=1,Js.KEEP=1,Js.NUM_PTS_TO_CHECK=10;class $s{constructor(){$s.constructor_.apply(this,arguments)}static constructor_(){this._ptList=null,this._precisionModel=null,this._minimimVertexDistance=0,this._ptList=new L}getCoordinates(){return this._ptList.toArray($s.COORDINATE_ARRAY_TYPE)}setPrecisionModel(t){this._precisionModel=t}addPt(t){const e=new m(t);if(this._precisionModel.makePrecise(e),this.isRedundant(e))return null;this._ptList.add(e)}reverse(){}addPts(t,e){if(e)for(let e=0;e<t.length;e++)this.addPt(t[e]);else for(let e=t.length-1;e>=0;e--)this.addPt(t[e])}isRedundant(t){if(this._ptList.size()<1)return!1;const e=this._ptList.get(this._ptList.size()-1);return t.distance(e)<this._minimimVertexDistance}toString(){return(new Lt).createLineString(this.getCoordinates()).toString()}closeRing(){if(this._ptList.size()<1)return null;const t=new m(this._ptList.get(0)),e=this._ptList.get(this._ptList.size()-1);if(t.equals(e))return null;this._ptList.add(t)}setMinimumVertexDistance(t){this._minimimVertexDistance=t}}$s.COORDINATE_ARRAY_TYPE=new Array(0).fill(null);class tn{constructor(){tn.constructor_.apply(this,arguments)}static constructor_(){this._maxCurveSegmentError=0,this._filletAngleQuantum=null,this._closingSegLengthFactor=1,this._segList=null,this._distance=0,this._precisionModel=null,this._bufParams=null,this._li=null,this._s0=null,this._s1=null,this._s2=null,this._seg0=new Kt,this._seg1=new Kt,this._offset0=new Kt,this._offset1=new Kt,this._side=0,this._hasNarrowConcaveAngle=!1;const t=arguments[0],e=arguments[1],s=arguments[2];this._precisionModel=t,this._bufParams=e,this._li=new jt,this._filletAngleQuantum=Math.PI/2/e.getQuadrantSegments(),e.getQuadrantSegments()>=8&&e.getJoinStyle()===Qe.JOIN_ROUND&&(this._closingSegLengthFactor=tn.MAX_CLOSING_SEG_LEN_FACTOR),this.init(s)}getCoordinates(){return this._segList.getCoordinates()}addMitreJoin(t,e,s,n){const i=B.intersection(e.p0,e.p1,s.p0,s.p1);if(null!==i){if((n<=0?1:i.distance(t)/Math.abs(n))<=this._bufParams.getMitreLimit())return this._segList.addPt(i),null}this.addLimitedMitreJoin(e,s,n,this._bufParams.getMitreLimit())}addLastSegment(){this._segList.addPt(this._offset1.p1)}initSideSegments(t,e,s){this._s1=t,this._s2=e,this._side=s,this._seg1.setCoordinates(t,e),this.computeOffsetSegment(this._seg1,s,this._distance,this._offset1)}addLimitedMitreJoin(t,e,s,n){const i=this._seg0.p1,r=$t.angle(i,this._seg0.p0),o=$t.angleBetweenOriented(this._seg0.p0,i,this._seg1.p1)/2,l=$t.normalize(r+o),a=$t.normalize(l+Math.PI),c=n*s,h=s-c*Math.abs(Math.sin(o)),u=i.x+c*Math.cos(a),g=i.y+c*Math.sin(a),d=new m(u,g),_=new Kt(i,d),p=_.pointAlongOffset(1,h),f=_.pointAlongOffset(1,-h);this._side===Hs.LEFT?(this._segList.addPt(p),this._segList.addPt(f)):(this._segList.addPt(f),this._segList.addPt(p))}addDirectedFillet(t,e,s,n,i){const r=n===q.CLOCKWISE?-1:1,o=Math.abs(e-s),l=Math.trunc(o/this._filletAngleQuantum+.5);if(l<1)return null;const a=o/l,c=new m;for(let s=0;s<l;s++){const n=e+r*s*a;c.x=t.x+i*Math.cos(n),c.y=t.y+i*Math.sin(n),this._segList.addPt(c)}}computeOffsetSegment(t,e,s,n){const i=e===Hs.LEFT?1:-1,r=t.p1.x-t.p0.x,o=t.p1.y-t.p0.y,l=Math.sqrt(r*r+o*o),a=i*s*r/l,c=i*s*o/l;n.p0.x=t.p0.x-c,n.p0.y=t.p0.y+a,n.p1.x=t.p1.x-c,n.p1.y=t.p1.y+a}addInsideTurn(t,e){if(this._li.computeIntersection(this._offset0.p0,this._offset0.p1,this._offset1.p0,this._offset1.p1),this._li.hasIntersection())this._segList.addPt(this._li.getIntersection(0));else if(this._hasNarrowConcaveAngle=!0,this._offset0.p1.distance(this._offset1.p0)<this._distance*tn.INSIDE_TURN_VERTEX_SNAP_DISTANCE_FACTOR)this._segList.addPt(this._offset0.p1);else{if(this._segList.addPt(this._offset0.p1),this._closingSegLengthFactor>0){const t=new m((this._closingSegLengthFactor*this._offset0.p1.x+this._s1.x)/(this._closingSegLengthFactor+1),(this._closingSegLengthFactor*this._offset0.p1.y+this._s1.y)/(this._closingSegLengthFactor+1));this._segList.addPt(t);const e=new m((this._closingSegLengthFactor*this._offset1.p0.x+this._s1.x)/(this._closingSegLengthFactor+1),(this._closingSegLengthFactor*this._offset1.p0.y+this._s1.y)/(this._closingSegLengthFactor+1));this._segList.addPt(e)}else this._segList.addPt(this._s1);this._segList.addPt(this._offset1.p0)}}createCircle(t){const e=new m(t.x+this._distance,t.y);this._segList.addPt(e),this.addDirectedFillet(t,0,2*Math.PI,-1,this._distance),this._segList.closeRing()}addBevelJoin(t,e){this._segList.addPt(t.p1),this._segList.addPt(e.p0)}init(t){this._distance=t,this._maxCurveSegmentError=t*(1-Math.cos(this._filletAngleQuantum/2)),this._segList=new $s,this._segList.setPrecisionModel(this._precisionModel),this._segList.setMinimumVertexDistance(t*tn.CURVE_VERTEX_SNAP_DISTANCE_FACTOR)}addCollinear(t){this._li.computeIntersection(this._s0,this._s1,this._s1,this._s2);this._li.getIntersectionNum()>=2&&(this._bufParams.getJoinStyle()===Qe.JOIN_BEVEL||this._bufParams.getJoinStyle()===Qe.JOIN_MITRE?(t&&this._segList.addPt(this._offset0.p1),this._segList.addPt(this._offset1.p0)):this.addCornerFillet(this._s1,this._offset0.p1,this._offset1.p0,q.CLOCKWISE,this._distance))}addNextSegment(t,e){if(this._s0=this._s1,this._s1=this._s2,this._s2=t,this._seg0.setCoordinates(this._s0,this._s1),this.computeOffsetSegment(this._seg0,this._side,this._distance,this._offset0),this._seg1.setCoordinates(this._s1,this._s2),this.computeOffsetSegment(this._seg1,this._side,this._distance,this._offset1),this._s1.equals(this._s2))return null;const s=q.index(this._s0,this._s1,this._s2),n=s===q.CLOCKWISE&&this._side===Hs.LEFT||s===q.COUNTERCLOCKWISE&&this._side===Hs.RIGHT;0===s?this.addCollinear(e):n?this.addOutsideTurn(s,e):this.addInsideTurn(s,e)}addLineEndCap(t,e){const s=new Kt(t,e),n=new Kt;this.computeOffsetSegment(s,Hs.LEFT,this._distance,n);const i=new Kt;this.computeOffsetSegment(s,Hs.RIGHT,this._distance,i);const r=e.x-t.x,o=e.y-t.y,l=Math.atan2(o,r);switch(this._bufParams.getEndCapStyle()){case Qe.CAP_ROUND:this._segList.addPt(n.p1),this.addDirectedFillet(e,l+Math.PI/2,l-Math.PI/2,q.CLOCKWISE,this._distance),this._segList.addPt(i.p1);break;case Qe.CAP_FLAT:this._segList.addPt(n.p1),this._segList.addPt(i.p1);break;case Qe.CAP_SQUARE:const t=new m;t.x=Math.abs(this._distance)*Math.cos(l),t.y=Math.abs(this._distance)*Math.sin(l);const s=new m(n.p1.x+t.x,n.p1.y+t.y),r=new m(i.p1.x+t.x,i.p1.y+t.y);this._segList.addPt(s),this._segList.addPt(r)}}addOutsideTurn(t,e){if(this._offset0.p1.distance(this._offset1.p0)<this._distance*tn.OFFSET_SEGMENT_SEPARATION_FACTOR)return this._segList.addPt(this._offset0.p1),null;this._bufParams.getJoinStyle()===Qe.JOIN_MITRE?this.addMitreJoin(this._s1,this._offset0,this._offset1,this._distance):this._bufParams.getJoinStyle()===Qe.JOIN_BEVEL?this.addBevelJoin(this._offset0,this._offset1):(e&&this._segList.addPt(this._offset0.p1),this.addCornerFillet(this._s1,this._offset0.p1,this._offset1.p0,t,this._distance),this._segList.addPt(this._offset1.p0))}createSquare(t){this._segList.addPt(new m(t.x+this._distance,t.y+this._distance)),this._segList.addPt(new m(t.x+this._distance,t.y-this._distance)),this._segList.addPt(new m(t.x-this._distance,t.y-this._distance)),this._segList.addPt(new m(t.x-this._distance,t.y+this._distance)),this._segList.closeRing()}addSegments(t,e){this._segList.addPts(t,e)}addFirstSegment(){this._segList.addPt(this._offset1.p0)}addCornerFillet(t,e,s,n,i){const r=e.x-t.x,o=e.y-t.y;let l=Math.atan2(o,r);const a=s.x-t.x,c=s.y-t.y,h=Math.atan2(c,a);n===q.CLOCKWISE?l<=h&&(l+=2*Math.PI):l>=h&&(l-=2*Math.PI),this._segList.addPt(e),this.addDirectedFillet(t,l,h,n,i),this._segList.addPt(s)}closeRing(){this._segList.closeRing()}hasNarrowConcaveAngle(){return this._hasNarrowConcaveAngle}}tn.OFFSET_SEGMENT_SEPARATION_FACTOR=.001,tn.INSIDE_TURN_VERTEX_SNAP_DISTANCE_FACTOR=.001,tn.CURVE_VERTEX_SNAP_DISTANCE_FACTOR=1e-6,tn.MAX_CLOSING_SEG_LEN_FACTOR=80;class en{constructor(){en.constructor_.apply(this,arguments)}static constructor_(){this._distance=0,this._precisionModel=null,this._bufParams=null;const t=arguments[0],e=arguments[1];this._precisionModel=t,this._bufParams=e}static copyCoordinates(t){const e=new Array(t.length).fill(null);for(let s=0;s<e.length;s++)e[s]=new m(t[s]);return e}getOffsetCurve(t,e){if(this._distance=e,0===e)return null;const s=e<0,n=Math.abs(e),i=this.getSegGen(n);t.length<=1?this.computePointCurve(t[0],i):this.computeOffsetCurve(t,s,i);const r=i.getCoordinates();return s&&W.reverse(r),r}computeSingleSidedBufferCurve(t,e,s){const n=this.simplifyTolerance(this._distance);if(e){s.addSegments(t,!0);const e=Js.simplify(t,-n),i=e.length-1;s.initSideSegments(e[i],e[i-1],Hs.LEFT),s.addFirstSegment();for(let t=i-2;t>=0;t--)s.addNextSegment(e[t],!0)}else{s.addSegments(t,!1);const e=Js.simplify(t,n),i=e.length-1;s.initSideSegments(e[0],e[1],Hs.LEFT),s.addFirstSegment();for(let t=2;t<=i;t++)s.addNextSegment(e[t],!0)}s.addLastSegment(),s.closeRing()}computeRingBufferCurve(t,e,s){let n=this.simplifyTolerance(this._distance);e===Hs.RIGHT&&(n=-n);const i=Js.simplify(t,n),r=i.length-1;s.initSideSegments(i[r-1],i[0],e);for(let t=1;t<=r;t++){const e=1!==t;s.addNextSegment(i[t],e)}s.closeRing()}computeLineBufferCurve(t,e){const s=this.simplifyTolerance(this._distance),n=Js.simplify(t,s),i=n.length-1;e.initSideSegments(n[0],n[1],Hs.LEFT);for(let t=2;t<=i;t++)e.addNextSegment(n[t],!0);e.addLastSegment(),e.addLineEndCap(n[i-1],n[i]);const r=Js.simplify(t,-s),o=r.length-1;e.initSideSegments(r[o],r[o-1],Hs.LEFT);for(let t=o-2;t>=0;t--)e.addNextSegment(r[t],!0);e.addLastSegment(),e.addLineEndCap(r[1],r[0]),e.closeRing()}computePointCurve(t,e){switch(this._bufParams.getEndCapStyle()){case Qe.CAP_ROUND:e.createCircle(t);break;case Qe.CAP_SQUARE:e.createSquare(t)}}getLineCurve(t,e){if(this._distance=e,this.isLineOffsetEmpty(e))return null;const s=Math.abs(e),n=this.getSegGen(s);if(t.length<=1)this.computePointCurve(t[0],n);else if(this._bufParams.isSingleSided()){const s=e<0;this.computeSingleSidedBufferCurve(t,s,n)}else this.computeLineBufferCurve(t,n);return n.getCoordinates()}getBufferParameters(){return this._bufParams}simplifyTolerance(t){return t*this._bufParams.getSimplifyFactor()}getRingCurve(t,e,s){if(this._distance=s,t.length<=2)return this.getLineCurve(t,s);if(0===s)return en.copyCoordinates(t);const n=this.getSegGen(s);return this.computeRingBufferCurve(t,e,n),n.getCoordinates()}computeOffsetCurve(t,e,s){const n=this.simplifyTolerance(this._distance);if(e){const e=Js.simplify(t,-n),i=e.length-1;s.initSideSegments(e[i],e[i-1],Hs.LEFT),s.addFirstSegment();for(let t=i-2;t>=0;t--)s.addNextSegment(e[t],!0)}else{const e=Js.simplify(t,n),i=e.length-1;s.initSideSegments(e[0],e[1],Hs.LEFT),s.addFirstSegment();for(let t=2;t<=i;t++)s.addNextSegment(e[t],!0)}s.addLastSegment()}isLineOffsetEmpty(t){return 0===t||t<0&&!this._bufParams.isSingleSided()}getSegGen(t){return new tn(this._precisionModel,this._bufParams,t)}}class sn{constructor(){sn.constructor_.apply(this,arguments)}static constructor_(){if(this.location=null,1===arguments.length){if(arguments[0]instanceof Array){const t=arguments[0];this.init(t.length)}else if(Number.isInteger(arguments[0])){const t=arguments[0];this.init(1),this.location[Hs.ON]=t}else if(arguments[0]instanceof sn){const t=arguments[0];if(this.init(t.location.length),null!==t)for(let e=0;e<this.location.length;e++)this.location[e]=t.location[e]}}else if(3===arguments.length){const t=arguments[0],e=arguments[1],s=arguments[2];this.init(3),this.location[Hs.ON]=t,this.location[Hs.LEFT]=e,this.location[Hs.RIGHT]=s}}setAllLocations(t){for(let e=0;e<this.location.length;e++)this.location[e]=t}isNull(){for(let t=0;t<this.location.length;t++)if(this.location[t]!==Qt.NONE)return!1;return!0}setAllLocationsIfNull(t){for(let e=0;e<this.location.length;e++)this.location[e]===Qt.NONE&&(this.location[e]=t)}isLine(){return 1===this.location.length}merge(t){if(t.location.length>this.location.length){const t=new Array(3).fill(null);t[Hs.ON]=this.location[Hs.ON],t[Hs.LEFT]=Qt.NONE,t[Hs.RIGHT]=Qt.NONE,this.location=t}for(let e=0;e<this.location.length;e++)this.location[e]===Qt.NONE&&e<t.location.length&&(this.location[e]=t.location[e])}getLocations(){return this.location}flip(){if(this.location.length<=1)return null;const t=this.location[Hs.LEFT];this.location[Hs.LEFT]=this.location[Hs.RIGHT],this.location[Hs.RIGHT]=t}get(t){return t<this.location.length?this.location[t]:Qt.NONE}isEqualOnSide(t,e){return this.location[e]===t.location[e]}allPositionsEqual(t){for(let e=0;e<this.location.length;e++)if(this.location[e]!==t)return!1;return!0}toString(){const t=new v;return this.location.length>1&&t.append(Qt.toLocationSymbol(this.location[Hs.LEFT])),t.append(Qt.toLocationSymbol(this.location[Hs.ON])),this.location.length>1&&t.append(Qt.toLocationSymbol(this.location[Hs.RIGHT])),t.toString()}setLocations(t,e,s){this.location[Hs.ON]=t,this.location[Hs.LEFT]=e,this.location[Hs.RIGHT]=s}isArea(){return this.location.length>1}isAnyNull(){for(let t=0;t<this.location.length;t++)if(this.location[t]===Qt.NONE)return!0;return!1}setLocation(){if(1===arguments.length){const t=arguments[0];this.setLocation(Hs.ON,t)}else if(2===arguments.length){const t=arguments[0],e=arguments[1];this.location[t]=e}}init(t){this.location=new Array(t).fill(null),this.setAllLocations(Qt.NONE)}}class nn{constructor(){nn.constructor_.apply(this,arguments)}static constructor_(){if(this.elt=new Array(2).fill(null),1===arguments.length){if(Number.isInteger(arguments[0])){const t=arguments[0];this.elt[0]=new sn(t),this.elt[1]=new sn(t)}else if(arguments[0]instanceof nn){const t=arguments[0];this.elt[0]=new sn(t.elt[0]),this.elt[1]=new sn(t.elt[1])}}else if(2===arguments.length){const t=arguments[0],e=arguments[1];this.elt[0]=new sn(Qt.NONE),this.elt[1]=new sn(Qt.NONE),this.elt[t].setLocation(e)}else if(3===arguments.length){const t=arguments[0],e=arguments[1],s=arguments[2];this.elt[0]=new sn(t,e,s),this.elt[1]=new sn(t,e,s)}else if(4===arguments.length){const t=arguments[0],e=arguments[1],s=arguments[2],n=arguments[3];this.elt[0]=new sn(Qt.NONE,Qt.NONE,Qt.NONE),this.elt[1]=new sn(Qt.NONE,Qt.NONE,Qt.NONE),this.elt[t].setLocations(e,s,n)}}static toLineLabel(t){const e=new nn(Qt.NONE);for(let s=0;s<2;s++)e.setLocation(s,t.getLocation(s));return e}getGeometryCount(){let t=0;return this.elt[0].isNull()||t++,this.elt[1].isNull()||t++,t}setAllLocations(t,e){this.elt[t].setAllLocations(e)}isNull(t){return this.elt[t].isNull()}setAllLocationsIfNull(){if(1===arguments.length){const t=arguments[0];this.setAllLocationsIfNull(0,t),this.setAllLocationsIfNull(1,t)}else if(2===arguments.length){const t=arguments[0],e=arguments[1];this.elt[t].setAllLocationsIfNull(e)}}isLine(t){return this.elt[t].isLine()}merge(t){for(let e=0;e<2;e++)null===this.elt[e]&&null!==t.elt[e]?this.elt[e]=new sn(t.elt[e]):this.elt[e].merge(t.elt[e])}flip(){this.elt[0].flip(),this.elt[1].flip()}getLocation(){if(1===arguments.length){const t=arguments[0];return this.elt[t].get(Hs.ON)}if(2===arguments.length){const t=arguments[0],e=arguments[1];return this.elt[t].get(e)}}toString(){const t=new v;return null!==this.elt[0]&&(t.append("A:"),t.append(this.elt[0].toString())),null!==this.elt[1]&&(t.append(" B:"),t.append(this.elt[1].toString())),t.toString()}setLocation(){if(2===arguments.length){const t=arguments[0],e=arguments[1];this.elt[t].setLocation(Hs.ON,e)}else if(3===arguments.length){const t=arguments[0],e=arguments[1],s=arguments[2];this.elt[t].setLocation(e,s)}}isEqualOnSide(t,e){return this.elt[0].isEqualOnSide(t.elt[0],e)&&this.elt[1].isEqualOnSide(t.elt[1],e)}allPositionsEqual(t,e){return this.elt[t].allPositionsEqual(e)}toLine(t){this.elt[t].isArea()&&(this.elt[t]=new sn(this.elt[t].location[0]))}isArea(){if(0===arguments.length)return this.elt[0].isArea()||this.elt[1].isArea();if(1===arguments.length){const t=arguments[0];return this.elt[t].isArea()}}isAnyNull(t){return this.elt[t].isAnyNull()}}let rn=class t{constructor(){t.constructor_.apply(this,arguments)}static constructor_(){if(this._label=null,this._isInResult=!1,this._isCovered=!1,this._isCoveredSet=!1,this._isVisited=!1,0===arguments.length);else if(1===arguments.length){const t=arguments[0];this._label=t}}setVisited(t){this._isVisited=t}setInResult(t){this._isInResult=t}setLabel(t){this._label=t}getLabel(){return this._label}setCovered(t){this._isCovered=t,this._isCoveredSet=!0}updateIM(t){h.isTrue(this._label.getGeometryCount()>=2,"found partial label"),this.computeIM(t)}isCovered(){return this._isCovered}isCoveredSet(){return this._isCoveredSet}isInResult(){return this._isInResult}isVisited(){return this._isVisited}},on=class t extends rn{constructor(){super(),t.constructor_.apply(this,arguments)}static constructor_(){this._coord=null,this._edges=null;const t=arguments[0],e=arguments[1];this._coord=t,this._edges=e,this._label=new nn(0,Qt.NONE)}isIncidentEdgeInResult(){for(let t=this.getEdges().getEdges().iterator();t.hasNext();){if(t.next().getEdge().isInResult())return!0}return!1}isIsolated(){return 1===this._label.getGeometryCount()}getCoordinate(){return this._coord}computeMergedLocation(t,e){let s=Qt.NONE;if(s=this._label.getLocation(e),!t.isNull(e)){const n=t.getLocation(e);s!==Qt.BOUNDARY&&(s=n)}return s}setLabel(){if(2!==arguments.length||!Number.isInteger(arguments[1])||!Number.isInteger(arguments[0]))return super.setLabel.apply(this,arguments);{const t=arguments[0],e=arguments[1];null===this._label?this._label=new nn(t,e):this._label.setLocation(t,e)}}getEdges(){return this._edges}mergeLabel(){if(arguments[0]instanceof t){const t=arguments[0];this.mergeLabel(t._label)}else if(arguments[0]instanceof nn){const t=arguments[0];for(let e=0;e<2;e++){const s=this.computeMergedLocation(t,e);this._label.getLocation(e)===Qt.NONE&&this._label.setLocation(e,s)}}}add(t){this._edges.insert(t),t.setNode(this)}setLabelBoundary(t){if(null===this._label)return null;let e=Qt.NONE;null!==this._label&&(e=this._label.getLocation(t));let s=null;switch(e){case Qt.BOUNDARY:s=Qt.INTERIOR;break;case Qt.INTERIOR:default:s=Qt.BOUNDARY}this._label.setLocation(t,s)}print(t){t.println("node "+this._coord+" lbl: "+this._label)}computeIM(t){}},ln=class t{constructor(){t.constructor_.apply(this,arguments)}static constructor_(){this.nodeMap=new os,this.nodeFact=null;const t=arguments[0];this.nodeFact=t}print(t){for(let e=this.iterator();e.hasNext();){e.next().print(t)}}iterator(){return this.nodeMap.values().iterator()}values(){return this.nodeMap.values()}getBoundaryNodes(t){const e=new L;for(let s=this.iterator();s.hasNext();){const n=s.next();n.getLabel().getLocation(t)===Qt.BOUNDARY&&e.add(n)}return e}add(t){const e=t.getCoordinate();this.addNode(e).add(t)}find(t){return this.nodeMap.get(t)}addNode(){if(arguments[0]instanceof m){const t=arguments[0];let e=this.nodeMap.get(t);return null===e&&(e=this.nodeFact.createNode(t),this.nodeMap.put(t,e)),e}if(arguments[0]instanceof on){const t=arguments[0],e=this.nodeMap.get(t.getCoordinate());return null===e?(this.nodeMap.put(t.getCoordinate(),t),t):(e.mergeLabel(t),e)}}};class an{createNode(t){return new on(t,null)}}class cn{constructor(){cn.constructor_.apply(this,arguments)}static constructor_(){if(this._edge=null,this._label=null,this._node=null,this._p0=null,this._p1=null,this._dx=null,this._dy=null,this._quadrant=null,1===arguments.length){const t=arguments[0];this._edge=t}else if(3===arguments.length){const t=arguments[0],e=arguments[1],s=arguments[2];cn.constructor_.call(this,t,e,s,null)}else if(4===arguments.length){const t=arguments[0],e=arguments[1],s=arguments[2],n=arguments[3];cn.constructor_.call(this,t),this.init(e,s),this._label=n}}compareDirection(t){return this._dx===t._dx&&this._dy===t._dy?0:this._quadrant>t._quadrant?1:this._quadrant<t._quadrant?-1:q.index(t._p0,t._p1,this._p1)}getDy(){return this._dy}print(t){const e=Math.atan2(this._dy,this._dx),s=this.getClass().getName(),n=s.lastIndexOf("."),i=s.substring(n+1);t.print("  "+i+": "+this._p0+" - "+this._p1+" "+this._quadrant+":"+e+"   "+this._label)}getLabel(){return this._label}getEdge(){return this._edge}toString(){const t=Math.atan2(this._dy,this._dx),e=this.getClass().getName(),s=e.lastIndexOf(".");return"  "+e.substring(s+1)+": "+this._p0+" - "+this._p1+" "+this._quadrant+":"+t+"   "+this._label}computeLabel(t){}init(t,e){this._p0=t,this._p1=e,this._dx=e.x-t.x,this._dy=e.y-t.y,this._quadrant=Ds.quadrant(this._dx,this._dy),h.isTrue(!(0===this._dx&&0===this._dy),"EdgeEnd with identical endpoints found")}getCoordinate(){return this._p0}setNode(t){this._node=t}compareTo(t){const e=t;return this.compareDirection(e)}getDirectedCoordinate(){return this._p1}getDx(){return this._dx}getQuadrant(){return this._quadrant}getNode(){return this._node}get interfaces_(){return[o]}}let hn=class t extends cn{constructor(){super(),t.constructor_.apply(this,arguments)}static constructor_(){this._isForward=null,this._isInResult=!1,this._isVisited=!1,this._sym=null,this._next=null,this._nextMin=null,this._edgeRing=null,this._minEdgeRing=null,this._depth=[0,-999,-999];const t=arguments[0],e=arguments[1];if(cn.constructor_.call(this,t),this._isForward=e,e)this.init(t.getCoordinate(0),t.getCoordinate(1));else{const e=t.getNumPoints()-1;this.init(t.getCoordinate(e),t.getCoordinate(e-1))}this.computeDirectedLabel()}static depthFactor(t,e){return t===Qt.EXTERIOR&&e===Qt.INTERIOR?1:t===Qt.INTERIOR&&e===Qt.EXTERIOR?-1:0}setVisited(t){this._isVisited=t}setDepth(t,e){if(-999!==this._depth[t]&&this._depth[t]!==e)throw new _s("assigned depths do not match",this.getCoordinate());this._depth[t]=e}isInteriorAreaEdge(){let t=!0;for(let e=0;e<2;e++)this._label.isArea(e)&&this._label.getLocation(e,Hs.LEFT)===Qt.INTERIOR&&this._label.getLocation(e,Hs.RIGHT)===Qt.INTERIOR||(t=!1);return t}setNextMin(t){this._nextMin=t}print(t){super.print.call(this,t),t.print(" "+this._depth[Hs.LEFT]+"/"+this._depth[Hs.RIGHT]),t.print(" ("+this.getDepthDelta()+")"),this._isInResult&&t.print(" inResult")}setMinEdgeRing(t){this._minEdgeRing=t}getSym(){return this._sym}isForward(){return this._isForward}setSym(t){this._sym=t}setVisitedEdge(t){this.setVisited(t),this._sym.setVisited(t)}getNextMin(){return this._nextMin}getDepth(t){return this._depth[t]}computeDirectedLabel(){this._label=new nn(this._edge.getLabel()),this._isForward||this._label.flip()}getNext(){return this._next}isLineEdge(){const t=this._label.isLine(0)||this._label.isLine(1),e=!this._label.isArea(0)||this._label.allPositionsEqual(0,Qt.EXTERIOR),s=!this._label.isArea(1)||this._label.allPositionsEqual(1,Qt.EXTERIOR);return t&&e&&s}setEdgeRing(t){this._edgeRing=t}getMinEdgeRing(){return this._minEdgeRing}getDepthDelta(){let t=this._edge.getDepthDelta();return this._isForward||(t=-t),t}setInResult(t){this._isInResult=t}getEdge(){return this._edge}printEdge(t){this.print(t),t.print(" "),this._isForward?this._edge.print(t):this._edge.printReverse(t)}setEdgeDepths(t,e){let s=this.getEdge().getDepthDelta();this._isForward||(s=-s);let n=1;t===Hs.LEFT&&(n=-1);const i=Hs.opposite(t),r=e+s*n;this.setDepth(t,e),this.setDepth(i,r)}getEdgeRing(){return this._edgeRing}isInResult(){return this._isInResult}setNext(t){this._next=t}isVisited(){return this._isVisited}},un=class t{constructor(){t.constructor_.apply(this,arguments)}static constructor_(){if(this._edges=new L,this._nodes=null,this._edgeEndList=new L,0===arguments.length)this._nodes=new ln(new an);else if(1===arguments.length){const t=arguments[0];this._nodes=new ln(t)}}static linkResultDirectedEdges(t){for(let e=t.iterator();e.hasNext();){e.next().getEdges().linkResultDirectedEdges()}}printEdges(t){t.println("Edges:");for(let e=0;e<this._edges.size();e++){t.println("edge "+e+":");const s=this._edges.get(e);s.print(t),s.eiList.print(t)}}debugPrintln(t){Y.out.println(t)}isBoundaryNode(t,e){const s=this._nodes.find(e);if(null===s)return!1;const n=s.getLabel();return null!==n&&n.getLocation(t)===Qt.BOUNDARY}linkAllDirectedEdges(){for(let t=this._nodes.iterator();t.hasNext();){t.next().getEdges().linkAllDirectedEdges()}}debugPrint(t){Y.out.print(t)}findEdgeEnd(t){for(let e=this.getEdgeEnds().iterator();e.hasNext();){const s=e.next();if(s.getEdge()===t)return s}return null}getNodes(){return this._nodes.values()}findEdge(t,e){for(let s=0;s<this._edges.size();s++){const n=this._edges.get(s),i=n.getCoordinates();if(t.equals(i[0])&&e.equals(i[1]))return n}return null}find(t){return this._nodes.find(t)}addNode(){if(arguments[0]instanceof on){const t=arguments[0];return this._nodes.addNode(t)}if(arguments[0]instanceof m){const t=arguments[0];return this._nodes.addNode(t)}}getNodeIterator(){return this._nodes.iterator()}linkResultDirectedEdges(){for(let t=this._nodes.iterator();t.hasNext();){t.next().getEdges().linkResultDirectedEdges()}}matchInSameDirection(t,e,s,n){return!!t.equals(s)&&(q.index(t,e,n)===q.COLLINEAR&&Ds.quadrant(t,e)===Ds.quadrant(s,n))}getEdgeEnds(){return this._edgeEndList}getEdgeIterator(){return this._edges.iterator()}findEdgeInSameDirection(t,e){for(let s=0;s<this._edges.size();s++){const n=this._edges.get(s),i=n.getCoordinates();if(this.matchInSameDirection(t,e,i[0],i[1]))return n;if(this.matchInSameDirection(t,e,i[i.length-1],i[i.length-2]))return n}return null}insertEdge(t){this._edges.add(t)}addEdges(t){for(let e=t.iterator();e.hasNext();){const t=e.next();this._edges.add(t);const s=new hn(t,!0),n=new hn(t,!1);s.setSym(n),n.setSym(s),this.add(s),this.add(n)}}add(t){this._nodes.add(t),this._edgeEndList.add(t)}},gn=class t{constructor(){t.constructor_.apply(this,arguments)}static constructor_(){if(this._startDe=null,this._maxNodeDegree=-1,this._edges=new L,this._pts=new L,this._label=new nn(Qt.NONE),this._ring=null,this._isHole=null,this._shell=null,this._holes=new L,this._geometryFactory=null,0===arguments.length);else if(2===arguments.length){const t=arguments[0],e=arguments[1];this._geometryFactory=e,this.computePoints(t),this.computeRing()}}computeRing(){if(null!==this._ring)return null;const t=new Array(this._pts.size()).fill(null);for(let e=0;e<this._pts.size();e++)t[e]=this._pts.get(e);this._ring=this._geometryFactory.createLinearRing(t),this._isHole=q.isCCW(this._ring.getCoordinates())}isIsolated(){return 1===this._label.getGeometryCount()}computePoints(t){this._startDe=t;let e=t,s=!0;do{if(null===e)throw new _s("Found null DirectedEdge");if(e.getEdgeRing()===this)throw new _s("Directed Edge visited twice during ring-building at "+e.getCoordinate());this._edges.add(e);const t=e.getLabel();h.isTrue(t.isArea()),this.mergeLabel(t),this.addPoints(e.getEdge(),e.isForward(),s),s=!1,this.setEdgeRing(e,this),e=this.getNext(e)}while(e!==this._startDe)}getLinearRing(){return this._ring}getCoordinate(t){return this._pts.get(t)}computeMaxNodeDegree(){this._maxNodeDegree=0;let t=this._startDe;do{const e=t.getNode().getEdges().getOutgoingDegree(this);e>this._maxNodeDegree&&(this._maxNodeDegree=e),t=this.getNext(t)}while(t!==this._startDe);this._maxNodeDegree*=2}addPoints(t,e,s){const n=t.getCoordinates();if(e){let t=1;s&&(t=0);for(let e=t;e<n.length;e++)this._pts.add(n[e])}else{let t=n.length-2;s&&(t=n.length-1);for(let e=t;e>=0;e--)this._pts.add(n[e])}}containsPoint(t){const e=this.getLinearRing();if(!e.getEnvelopeInternal().contains(t))return!1;if(!Ue.isInRing(t,e.getCoordinates()))return!1;for(let e=this._holes.iterator();e.hasNext();){if(e.next().containsPoint(t))return!1}return!0}getMaxNodeDegree(){return this._maxNodeDegree<0&&this.computeMaxNodeDegree(),this._maxNodeDegree}setShell(t){this._shell=t,null!==t&&t.addHole(this)}toPolygon(t){const e=new Array(this._holes.size()).fill(null);for(let t=0;t<this._holes.size();t++)e[t]=this._holes.get(t).getLinearRing();return t.createPolygon(this.getLinearRing(),e)}isHole(){return this._isHole}setInResult(){let t=this._startDe;do{t.getEdge().setInResult(!0),t=t.getNext()}while(t!==this._startDe)}addHole(t){this._holes.add(t)}isShell(){return null===this._shell}getLabel(){return this._label}getEdges(){return this._edges}getShell(){return this._shell}mergeLabel(){if(1===arguments.length){const t=arguments[0];this.mergeLabel(t,0),this.mergeLabel(t,1)}else if(2===arguments.length){const t=arguments[1],e=arguments[0].getLocation(t,Hs.RIGHT);if(e===Qt.NONE)return null;if(this._label.getLocation(t)===Qt.NONE)return this._label.setLocation(t,e),null}}};class dn extends gn{constructor(){super(),dn.constructor_.apply(this,arguments)}static constructor_(){const t=arguments[0],e=arguments[1];gn.constructor_.call(this,t,e)}getNext(t){return t.getNextMin()}setEdgeRing(t,e){t.setMinEdgeRing(e)}}class _n extends gn{constructor(){super(),_n.constructor_.apply(this,arguments)}static constructor_(){const t=arguments[0],e=arguments[1];gn.constructor_.call(this,t,e)}linkDirectedEdgesForMinimalEdgeRings(){let t=this._startDe;do{t.getNode().getEdges().linkMinimalDirectedEdges(this),t=t.getNext()}while(t!==this._startDe)}buildMinimalRings(){const t=new L;let e=this._startDe;do{if(null===e.getMinEdgeRing()){const s=new dn(e,this._geometryFactory);t.add(s)}e=e.getNext()}while(e!==this._startDe);return t}getNext(t){return t.getNext()}setEdgeRing(t,e){t.setEdgeRing(e)}}class pn{constructor(){pn.constructor_.apply(this,arguments)}static constructor_(){this._geometryFactory=null,this._shellList=new L;const t=arguments[0];this._geometryFactory=t}static findEdgeRingContaining(t,e){const s=t.getLinearRing(),n=s.getEnvelopeInternal();let i=s.getCoordinateN(0),r=null,o=null;for(let t=e.iterator();t.hasNext();){const e=t.next(),l=e.getLinearRing(),a=l.getEnvelopeInternal();if(a.equals(n))continue;if(!a.contains(n))continue;i=W.ptNotInList(s.getCoordinates(),l.getCoordinates());let c=!1;Ue.isInRing(i,l.getCoordinates())&&(c=!0),c&&(null===r||o.contains(a))&&(r=e,o=r.getLinearRing().getEnvelopeInternal())}return r}sortShellsAndHoles(t,e,s){for(let n=t.iterator();n.hasNext();){const t=n.next();t.isHole()?s.add(t):e.add(t)}}computePolygons(t){const e=new L;for(let s=t.iterator();s.hasNext();){const t=s.next().toPolygon(this._geometryFactory);e.add(t)}return e}placeFreeHoles(t,e){for(let s=e.iterator();s.hasNext();){const e=s.next();if(null===e.getShell()){const s=pn.findEdgeRingContaining(e,t);if(null===s)throw new _s("unable to assign hole to a shell",e.getCoordinate(0));e.setShell(s)}}}buildMinimalEdgeRings(t,e,s){const n=new L;for(let i=t.iterator();i.hasNext();){const t=i.next();if(t.getMaxNodeDegree()>2){t.linkDirectedEdgesForMinimalEdgeRings();const n=t.buildMinimalRings(),i=this.findShell(n);null!==i?(this.placePolygonHoles(i,n),e.add(i)):s.addAll(n)}else n.add(t)}return n}buildMaximalEdgeRings(t){const e=new L;for(let s=t.iterator();s.hasNext();){const t=s.next();if(t.isInResult()&&t.getLabel().isArea()&&null===t.getEdgeRing()){const s=new _n(t,this._geometryFactory);e.add(s),s.setInResult()}}return e}placePolygonHoles(t,e){for(let s=e.iterator();s.hasNext();){const e=s.next();e.isHole()&&e.setShell(t)}}getPolygons(){return this.computePolygons(this._shellList)}findShell(t){let e=0,s=null;for(let n=t.iterator();n.hasNext();){const t=n.next();t.isHole()||(s=t,e++)}return h.isTrue(e<=1,"found two shells in MinimalEdgeRing list"),s}add(){if(1===arguments.length){const t=arguments[0];this.add(t.getEdgeEnds(),t.getNodes())}else if(2===arguments.length){const t=arguments[0],e=arguments[1];un.linkResultDirectedEdges(e);const s=this.buildMaximalEdgeRings(t),n=new L,i=this.buildMinimalEdgeRings(s,this._shellList,n);this.sortShellsAndHoles(i,this._shellList,n),this.placeFreeHoles(this._shellList,n)}}}class mn{constructor(){mn.constructor_.apply(this,arguments)}static constructor_(){this._subgraphs=null,this._seg=new Kt;const t=arguments[0];this._subgraphs=t}findStabbedSegments(){if(1===arguments.length){const t=arguments[0],e=new L;for(let s=this._subgraphs.iterator();s.hasNext();){const n=s.next(),i=n.getEnvelope();t.y<i.getMinY()||t.y>i.getMaxY()||this.findStabbedSegments(t,n.getDirectedEdges(),e)}return e}if(3===arguments.length)if(I(arguments[2],C)&&arguments[0]instanceof m&&arguments[1]instanceof hn){const t=arguments[0],e=arguments[1],s=arguments[2],n=e.getEdge().getCoordinates();for(let i=0;i<n.length-1;i++){this._seg.p0=n[i],this._seg.p1=n[i+1],this._seg.p0.y>this._seg.p1.y&&this._seg.reverse();if(Math.max(this._seg.p0.x,this._seg.p1.x)<t.x)continue;if(this._seg.isHorizontal())continue;if(t.y<this._seg.p0.y||t.y>this._seg.p1.y)continue;if(q.index(this._seg.p0,this._seg.p1,t)===q.RIGHT)continue;let r=e.getDepth(Hs.LEFT);this._seg.p0.equals(n[i])||(r=e.getDepth(Hs.RIGHT));const o=new fn(this._seg,r);s.add(o)}}else if(I(arguments[2],C)&&arguments[0]instanceof m&&I(arguments[1],C)){const t=arguments[0],e=arguments[2];for(let s=arguments[1].iterator();s.hasNext();){const n=s.next();n.isForward()&&this.findStabbedSegments(t,n,e)}}}getDepth(t){const e=this.findStabbedSegments(t);if(0===e.size())return 0;return xe.min(e)._leftDepth}}class fn{constructor(){fn.constructor_.apply(this,arguments)}static constructor_(){this._upwardSeg=null,this._leftDepth=null;const t=arguments[0],e=arguments[1];this._upwardSeg=new Kt(t),this._leftDepth=e}compareX(t,e){const s=t.p0.compareTo(e.p0);return 0!==s?s:t.p1.compareTo(e.p1)}toString(){return this._upwardSeg.toString()}compareTo(t){const e=t;if(this._upwardSeg.minX()>=e._upwardSeg.maxX())return 1;if(this._upwardSeg.maxX()<=e._upwardSeg.minX())return-1;let s=this._upwardSeg.orientationIndex(e._upwardSeg);return 0!==s?s:(s=-1*e._upwardSeg.orientationIndex(this._upwardSeg),0!==s?s:this._upwardSeg.compareTo(e._upwardSeg))}get interfaces_(){return[o]}}mn.DepthSegment=fn;class yn{constructor(){yn.constructor_.apply(this,arguments)}static constructor_(){this._inputGeom=null,this._distance=null,this._curveBuilder=null,this._curveList=new L;const t=arguments[0],e=arguments[1],s=arguments[2];this._inputGeom=t,this._distance=e,this._curveBuilder=s}addRingSide(t,e,s,n,i){if(0===e&&t.length<et.MINIMUM_VALID_SIZE)return null;let r=n,o=i;t.length>=et.MINIMUM_VALID_SIZE&&q.isCCW(t)&&(r=i,o=n,s=Hs.opposite(s));const l=this._curveBuilder.getRingCurve(t,s,e);this.addCurve(l,r,o)}addRingBothSides(t,e){this.addRingSide(t,e,Hs.LEFT,Qt.EXTERIOR,Qt.INTERIOR),this.addRingSide(t,e,Hs.RIGHT,Qt.INTERIOR,Qt.EXTERIOR)}addPoint(t){if(this._distance<=0)return null;const e=t.getCoordinates(),s=this._curveBuilder.getLineCurve(e,this._distance);this.addCurve(s,Qt.EXTERIOR,Qt.INTERIOR)}addPolygon(t){let e=this._distance,s=Hs.LEFT;this._distance<0&&(e=-this._distance,s=Hs.RIGHT);const n=t.getExteriorRing(),i=W.removeRepeatedPoints(n.getCoordinates());if(this._distance<0&&this.isErodedCompletely(n,this._distance))return null;if(this._distance<=0&&i.length<3)return null;this.addRingSide(i,e,s,Qt.EXTERIOR,Qt.INTERIOR);for(let n=0;n<t.getNumInteriorRing();n++){const i=t.getInteriorRingN(n),r=W.removeRepeatedPoints(i.getCoordinates());this._distance>0&&this.isErodedCompletely(i,-this._distance)||this.addRingSide(r,e,Hs.opposite(s),Qt.INTERIOR,Qt.EXTERIOR)}}isTriangleErodedCompletely(t,e){const s=new se(t[0],t[1],t[2]),n=s.inCentre();return V.pointToSegment(n,s.p0,s.p1)<Math.abs(e)}addLineString(t){if(this._curveBuilder.isLineOffsetEmpty(this._distance))return null;const e=W.removeRepeatedPoints(t.getCoordinates());if(W.isRing(e)&&!this._curveBuilder.getBufferParameters().isSingleSided())this.addRingBothSides(e,this._distance);else{const t=this._curveBuilder.getLineCurve(e,this._distance);this.addCurve(t,Qt.EXTERIOR,Qt.INTERIOR)}}add(t){if(t.isEmpty())return null;if(t instanceof Ct)this.addPolygon(t);else if(t instanceof tt)this.addLineString(t);else if(t instanceof Nt)this.addPoint(t);else if(t instanceof St)this.addCollection(t);else if(t instanceof Et)this.addCollection(t);else if(t instanceof dt)this.addCollection(t);else{if(!(t instanceof ut))throw new U(t.getGeometryType());this.addCollection(t)}}addCurve(t,e,s){if(null===t||t.length<2)return null;const n=new us(t,new nn(0,Qt.BOUNDARY,e,s));this._curveList.add(n)}getCurves(){return this.add(this._inputGeom),this._curveList}isErodedCompletely(t,e){const s=t.getCoordinates();if(s.length<4)return e<0;if(4===s.length)return this.isTriangleErodedCompletely(s,e);const n=t.getEnvelopeInternal(),i=Math.min(n.getHeight(),n.getWidth());return e<0&&2*Math.abs(e)>i}addCollection(t){for(let e=0;e<t.getNumGeometries();e++){const s=t.getGeometryN(e);this.add(s)}}}class xn{constructor(){xn.constructor_.apply(this,arguments)}static constructor_(){this._edgeMap=new os,this._edgeList=null,this._ptInAreaLocation=[Qt.NONE,Qt.NONE]}getNextCW(t){this.getEdges();const e=this._edgeList.indexOf(t);let s=e-1;return 0===e&&(s=this._edgeList.size()-1),this._edgeList.get(s)}propagateSideLabels(t){let e=Qt.NONE;for(let s=this.iterator();s.hasNext();){const n=s.next().getLabel();n.isArea(t)&&n.getLocation(t,Hs.LEFT)!==Qt.NONE&&(e=n.getLocation(t,Hs.LEFT))}if(e===Qt.NONE)return null;let s=e;for(let e=this.iterator();e.hasNext();){const n=e.next(),i=n.getLabel();if(i.getLocation(t,Hs.ON)===Qt.NONE&&i.setLocation(t,Hs.ON,s),i.isArea(t)){const e=i.getLocation(t,Hs.LEFT),r=i.getLocation(t,Hs.RIGHT);if(r!==Qt.NONE){if(r!==s)throw new _s("side location conflict",n.getCoordinate());e===Qt.NONE&&h.shouldNeverReachHere("found single null side (at "+n.getCoordinate()+")"),s=e}else h.isTrue(i.getLocation(t,Hs.LEFT)===Qt.NONE,"found single null side"),i.setLocation(t,Hs.RIGHT,s),i.setLocation(t,Hs.LEFT,s)}}}getCoordinate(){const t=this.iterator();if(!t.hasNext())return null;return t.next().getCoordinate()}checkAreaLabelsConsistent(t){const e=this.getEdges();if(e.size()<=0)return!0;const s=e.size()-1,n=e.get(s).getLabel().getLocation(t,Hs.LEFT);h.isTrue(n!==Qt.NONE,"Found unlabelled area edge");let i=n;for(let e=this.iterator();e.hasNext();){const s=e.next().getLabel();h.isTrue(s.isArea(t),"Found non-area edge");const n=s.getLocation(t,Hs.LEFT),r=s.getLocation(t,Hs.RIGHT);if(n===r)return!1;if(r!==i)return!1;i=n}return!0}findIndex(t){this.iterator();for(let e=0;e<this._edgeList.size();e++){if(this._edgeList.get(e)===t)return e}return-1}iterator(){return this.getEdges().iterator()}getEdges(){return null===this._edgeList&&(this._edgeList=new L(this._edgeMap.values())),this._edgeList}getLocation(t,e,s){return this._ptInAreaLocation[t]===Qt.NONE&&(this._ptInAreaLocation[t]=Ze.locate(e,s[t].getGeometry())),this._ptInAreaLocation[t]}toString(){const t=new v;t.append("EdgeEndStar:   "+this.getCoordinate()),t.append("\n");for(let e=this.iterator();e.hasNext();){const s=e.next();t.append(s),t.append("\n")}return t.toString()}computeEdgeEndLabels(t){for(let e=this.iterator();e.hasNext();){e.next().computeLabel(t)}}computeLabelling(t){this.computeEdgeEndLabels(t[0].getBoundaryNodeRule()),this.propagateSideLabels(0),this.propagateSideLabels(1);const e=[!1,!1];for(let t=this.iterator();t.hasNext();){const s=t.next().getLabel();for(let t=0;t<2;t++)s.isLine(t)&&s.getLocation(t)===Qt.BOUNDARY&&(e[t]=!0)}for(let s=this.iterator();s.hasNext();){const n=s.next(),i=n.getLabel();for(let s=0;s<2;s++)if(i.isAnyNull(s)){let r=Qt.NONE;if(e[s])r=Qt.EXTERIOR;else{const e=n.getCoordinate();r=this.getLocation(s,e,t)}i.setAllLocationsIfNull(s,r)}}}getDegree(){return this._edgeMap.size()}insertEdgeEnd(t,e){this._edgeMap.put(t,e),this._edgeList=null}print(t){Y.out.println("EdgeEndStar:   "+this.getCoordinate());for(let e=this.iterator();e.hasNext();){e.next().print(t)}}isAreaLabelsConsistent(t){return this.computeEdgeEndLabels(t.getBoundaryNodeRule()),this.checkAreaLabelsConsistent(0)}}let En=class t extends xn{constructor(){super(),t.constructor_.apply(this,arguments)}static constructor_(){this._resultAreaEdgeList=null,this._label=null,this._SCANNING_FOR_INCOMING=1,this._LINKING_TO_OUTGOING=2}linkResultDirectedEdges(){this.getResultAreaEdges();let t=null,e=null,s=this._SCANNING_FOR_INCOMING;for(let n=0;n<this._resultAreaEdgeList.size();n++){const i=this._resultAreaEdgeList.get(n),r=i.getSym();if(i.getLabel().isArea())switch(null===t&&i.isInResult()&&(t=i),s){case this._SCANNING_FOR_INCOMING:if(!r.isInResult())continue;e=r,s=this._LINKING_TO_OUTGOING;break;case this._LINKING_TO_OUTGOING:if(!i.isInResult())continue;e.setNext(i),s=this._SCANNING_FOR_INCOMING}}if(s===this._LINKING_TO_OUTGOING){if(null===t)throw new _s("no outgoing dirEdge found",this.getCoordinate());h.isTrue(t.isInResult(),"unable to link last incoming dirEdge"),e.setNext(t)}}insert(t){const e=t;this.insertEdgeEnd(e,e)}getRightmostEdge(){const t=this.getEdges(),e=t.size();if(e<1)return null;const s=t.get(0);if(1===e)return s;const n=t.get(e-1),i=s.getQuadrant(),r=n.getQuadrant();return Ds.isNorthern(i)&&Ds.isNorthern(r)?s:Ds.isNorthern(i)||Ds.isNorthern(r)?0!==s.getDy()?s:0!==n.getDy()?n:(h.shouldNeverReachHere("found two horizontal edges incident on node"),null):n}updateLabelling(t){for(let e=this.iterator();e.hasNext();){const s=e.next().getLabel();s.setAllLocationsIfNull(0,t.getLocation(0)),s.setAllLocationsIfNull(1,t.getLocation(1))}}linkAllDirectedEdges(){this.getEdges();let t=null,e=null;for(let s=this._edgeList.size()-1;s>=0;s--){const n=this._edgeList.get(s),i=n.getSym();null===e&&(e=i),null!==t&&i.setNext(t),t=n}e.setNext(t)}computeDepths(){if(1===arguments.length){const t=arguments[0],e=this.findIndex(t),s=t.getDepth(Hs.LEFT),n=t.getDepth(Hs.RIGHT),i=this.computeDepths(e+1,this._edgeList.size(),s);if(this.computeDepths(0,e,i)!==n)throw new _s("depth mismatch at "+t.getCoordinate())}else if(3===arguments.length){const t=arguments[1];let e=arguments[2];for(let s=arguments[0];s<t;s++){const t=this._edgeList.get(s);t.setEdgeDepths(Hs.RIGHT,e),e=t.getDepth(Hs.LEFT)}return e}}mergeSymLabels(){for(let t=this.iterator();t.hasNext();){const e=t.next();e.getLabel().merge(e.getSym().getLabel())}}linkMinimalDirectedEdges(t){let e=null,s=null,n=this._SCANNING_FOR_INCOMING;for(let i=this._resultAreaEdgeList.size()-1;i>=0;i--){const r=this._resultAreaEdgeList.get(i),o=r.getSym();switch(null===e&&r.getEdgeRing()===t&&(e=r),n){case this._SCANNING_FOR_INCOMING:if(o.getEdgeRing()!==t)continue;s=o,n=this._LINKING_TO_OUTGOING;break;case this._LINKING_TO_OUTGOING:if(r.getEdgeRing()!==t)continue;s.setNextMin(r),n=this._SCANNING_FOR_INCOMING}}n===this._LINKING_TO_OUTGOING&&(h.isTrue(null!==e,"found null for first outgoing dirEdge"),h.isTrue(e.getEdgeRing()===t,"unable to link last incoming dirEdge"),s.setNextMin(e))}getOutgoingDegree(){if(0===arguments.length){let t=0;for(let e=this.iterator();e.hasNext();){e.next().isInResult()&&t++}return t}if(1===arguments.length){const t=arguments[0];let e=0;for(let s=this.iterator();s.hasNext();){s.next().getEdgeRing()===t&&e++}return e}}getLabel(){return this._label}findCoveredLineEdges(){let t=Qt.NONE;for(let e=this.iterator();e.hasNext();){const s=e.next(),n=s.getSym();if(!s.isLineEdge()){if(s.isInResult()){t=Qt.INTERIOR;break}if(n.isInResult()){t=Qt.EXTERIOR;break}}}if(t===Qt.NONE)return null;let e=t;for(let t=this.iterator();t.hasNext();){const s=t.next(),n=s.getSym();s.isLineEdge()?s.getEdge().setCovered(e===Qt.INTERIOR):(s.isInResult()&&(e=Qt.EXTERIOR),n.isInResult()&&(e=Qt.INTERIOR))}}computeLabelling(t){super.computeLabelling.call(this,t),this._label=new nn(Qt.NONE);for(let t=this.iterator();t.hasNext();){const e=t.next().getEdge().getLabel();for(let t=0;t<2;t++){const s=e.getLocation(t);s!==Qt.INTERIOR&&s!==Qt.BOUNDARY||this._label.setLocation(t,Qt.INTERIOR)}}}print(t){Y.out.println("DirectedEdgeStar: "+this.getCoordinate());for(let e=this.iterator();e.hasNext();){const s=e.next();t.print("out "),s.print(t),t.println(),t.print("in "),s.getSym().print(t),t.println()}}getResultAreaEdges(){if(null!==this._resultAreaEdgeList)return this._resultAreaEdgeList;this._resultAreaEdgeList=new L;for(let t=this.iterator();t.hasNext();){const e=t.next();(e.isInResult()||e.getSym().isInResult())&&this._resultAreaEdgeList.add(e)}return this._resultAreaEdgeList}};class In extends an{constructor(){super()}createNode(t){return new on(t,new En)}}class Nn{constructor(){Nn.constructor_.apply(this,arguments)}static constructor_(){this._pts=null,this._orientation=null;const t=arguments[0];this._pts=t,this._orientation=Nn.orientation(t)}static orientation(t){return 1===W.increasingDirection(t)}static compareOriented(t,e,s,n){const i=e?1:-1,r=n?1:-1,o=e?t.length:-1,l=n?s.length:-1;let a=e?0:t.length-1,c=n?0:s.length-1;for(;;){const e=t[a].compareTo(s[c]);if(0!==e)return e;a+=i,c+=r;const n=a===o,h=c===l;if(n&&!h)return-1;if(!n&&h)return 1;if(n&&h)return 0}}compareTo(t){const e=t;return Nn.compareOriented(this._pts,this._orientation,e._pts,e._orientation)}get interfaces_(){return[o]}}class wn{constructor(){wn.constructor_.apply(this,arguments)}static constructor_(){this._edges=new L,this._ocaMap=new os}print(t){t.print("MULTILINESTRING ( ");for(let e=0;e<this._edges.size();e++){const s=this._edges.get(e);e>0&&t.print(","),t.print("(");const n=s.getCoordinates();for(let e=0;e<n.length;e++)e>0&&t.print(","),t.print(n[e].x+" "+n[e].y);t.println(")")}t.print(")  ")}addAll(t){for(let e=t.iterator();e.hasNext();)this.add(e.next())}findEdgeIndex(t){for(let e=0;e<this._edges.size();e++)if(this._edges.get(e).equals(t))return e;return-1}iterator(){return this._edges.iterator()}getEdges(){return this._edges}get(t){return this._edges.get(t)}findEqualEdge(t){const e=new Nn(t.getCoordinates());return this._ocaMap.get(e)}add(t){this._edges.add(t);const e=new Nn(t.getCoordinates());this._ocaMap.put(e,t)}}class Cn{constructor(){Cn.constructor_.apply(this,arguments)}static constructor_(){this._hasIntersection=!1,this._hasProper=!1,this._hasProperInterior=!1,this._hasInterior=!1,this._properIntersectionPoint=null,this._li=null,this._isSelfIntersection=null,this.numIntersections=0,this.numInteriorIntersections=0,this.numProperIntersections=0,this.numTests=0;const t=arguments[0];this._li=t}static isAdjacentSegments(t,e){return 1===Math.abs(t-e)}isTrivialIntersection(t,e,s,n){if(t===s&&1===this._li.getIntersectionNum()){if(Cn.isAdjacentSegments(e,n))return!0;if(t.isClosed()){const s=t.size()-1;if(0===e&&n===s||0===n&&e===s)return!0}}return!1}getProperIntersectionPoint(){return this._properIntersectionPoint}hasProperInteriorIntersection(){return this._hasProperInterior}getLineIntersector(){return this._li}hasProperIntersection(){return this._hasProper}processIntersections(t,e,s,n){if(t===s&&e===n)return null;this.numTests++;const i=t.getCoordinates()[e],r=t.getCoordinates()[e+1],o=s.getCoordinates()[n],l=s.getCoordinates()[n+1];this._li.computeIntersection(i,r,o,l),this._li.hasIntersection()&&(this.numIntersections++,this._li.isInteriorIntersection()&&(this.numInteriorIntersections++,this._hasInterior=!0),this.isTrivialIntersection(t,e,s,n)||(this._hasIntersection=!0,t.addIntersections(this._li,e,0),s.addIntersections(this._li,n,1),this._li.isProper()&&(this.numProperIntersections++,this._hasProper=!0,this._hasProperInterior=!0)))}hasIntersection(){return this._hasIntersection}isDone(){return!1}hasInteriorIntersection(){return this._hasInterior}get interfaces_(){return[ks]}}class Sn{constructor(){Sn.constructor_.apply(this,arguments)}static constructor_(){this.coord=null,this.segmentIndex=null,this.dist=null;const t=arguments[0],e=arguments[1],s=arguments[2];this.coord=new m(t),this.segmentIndex=e,this.dist=s}getSegmentIndex(){return this.segmentIndex}getCoordinate(){return this.coord}print(t){t.print(this.coord),t.print(" seg # = "+this.segmentIndex),t.println(" dist = "+this.dist)}compareTo(t){const e=t;return this.compare(e.segmentIndex,e.dist)}isEndPoint(t){return 0===this.segmentIndex&&0===this.dist||this.segmentIndex===t}toString(){return this.coord+" seg # = "+this.segmentIndex+" dist = "+this.dist}getDistance(){return this.dist}compare(t,e){return this.segmentIndex<t?-1:this.segmentIndex>t?1:this.dist<e?-1:this.dist>e?1:0}get interfaces_(){return[o]}}class Ln{constructor(){Ln.constructor_.apply(this,arguments)}static constructor_(){this._nodeMap=new os,this.edge=null;const t=arguments[0];this.edge=t}print(t){t.println("Intersections:");for(let e=this.iterator();e.hasNext();){e.next().print(t)}}addEndpoints(){const t=this.edge.pts.length-1;this.add(this.edge.pts[0],0,0),this.add(this.edge.pts[t],t,0)}createSplitEdge(t,e){let s=e.segmentIndex-t.segmentIndex+2;const n=this.edge.pts[e.segmentIndex],i=e.dist>0||!e.coord.equals2D(n);i||s--;const r=new Array(s).fill(null);let o=0;r[o++]=new m(t.coord);for(let s=t.segmentIndex+1;s<=e.segmentIndex;s++)r[o++]=this.edge.pts[s];return i&&(r[o]=e.coord),new vn(r,new nn(this.edge._label))}add(t,e,s){const n=new Sn(t,e,s),i=this._nodeMap.get(n);return null!==i?i:(this._nodeMap.put(n,n),n)}isIntersection(t){for(let e=this.iterator();e.hasNext();){if(e.next().coord.equals(t))return!0}return!1}iterator(){return this._nodeMap.values().iterator()}addSplitEdges(t){this.addEndpoints();const e=this.iterator();let s=e.next();for(;e.hasNext();){const n=e.next(),i=this.createSplitEdge(s,n);t.add(i),s=n}}}class Tn{constructor(){Tn.constructor_.apply(this,arguments)}static constructor_(){this._depth=Array(2).fill().map((()=>Array(3)));for(let t=0;t<2;t++)for(let e=0;e<3;e++)this._depth[t][e]=Tn.NULL_VALUE}static depthAtLocation(t){return t===Qt.EXTERIOR?0:t===Qt.INTERIOR?1:Tn.NULL_VALUE}getDepth(t,e){return this._depth[t][e]}setDepth(t,e,s){this._depth[t][e]=s}isNull(){if(0===arguments.length){for(let t=0;t<2;t++)for(let e=0;e<3;e++)if(this._depth[t][e]!==Tn.NULL_VALUE)return!1;return!0}if(1===arguments.length){const t=arguments[0];return this._depth[t][1]===Tn.NULL_VALUE}if(2===arguments.length){const t=arguments[0],e=arguments[1];return this._depth[t][e]===Tn.NULL_VALUE}}normalize(){for(let t=0;t<2;t++)if(!this.isNull(t)){let e=this._depth[t][1];this._depth[t][2]<e&&(e=this._depth[t][2]),e<0&&(e=0);for(let s=1;s<3;s++){let n=0;this._depth[t][s]>e&&(n=1),this._depth[t][s]=n}}}getDelta(t){return this._depth[t][Hs.RIGHT]-this._depth[t][Hs.LEFT]}getLocation(t,e){return this._depth[t][e]<=0?Qt.EXTERIOR:Qt.INTERIOR}toString(){return"A: "+this._depth[0][1]+","+this._depth[0][2]+" B: "+this._depth[1][1]+","+this._depth[1][2]}add(){if(1===arguments.length){const t=arguments[0];for(let e=0;e<2;e++)for(let s=1;s<3;s++){const n=t.getLocation(e,s);n!==Qt.EXTERIOR&&n!==Qt.INTERIOR||(this.isNull(e,s)?this._depth[e][s]=Tn.depthAtLocation(n):this._depth[e][s]+=Tn.depthAtLocation(n))}}else if(3===arguments.length){const t=arguments[0],e=arguments[1];arguments[2]===Qt.INTERIOR&&this._depth[t][e]++}}}Tn.NULL_VALUE=-1;class Rn{constructor(){Rn.constructor_.apply(this,arguments)}static constructor_(){if(this._data=null,this._size=0,0===arguments.length)Rn.constructor_.call(this,10);else if(1===arguments.length){const t=arguments[0];this._data=new Array(t).fill(null)}}size(){return this._size}addAll(t){return null===t||0===t.length?null:(this.ensureCapacity(this._size+t.length),Y.arraycopy(t,0,this._data,this._size,t.length),void(this._size+=t.length))}ensureCapacity(t){if(t<=this._data.length)return null;const e=Math.max(t,2*this._data.length);this._data=ht.copyOf(this._data,e)}toArray(){const t=new Array(this._size).fill(null);return Y.arraycopy(this._data,0,t,0,this._size),t}add(t){this.ensureCapacity(this._size+1),this._data[this._size]=t,++this._size}}class Pn{static toIntArray(t){const e=new Array(t.size()).fill(null);for(let s=0;s<e.length;s++)e[s]=t.get(s).intValue();return e}findChainEnd(t,e){const s=Ds.quadrant(t[e],t[e+1]);let n=e+1;for(;n<t.length;){if(Ds.quadrant(t[n-1],t[n])!==s)break;n++}return n-1}OLDgetChainStartIndices(t){let e=0;const s=new L;s.add(e);do{const n=this.findChainEnd(t,e);s.add(n),e=n}while(e<t.length-1);return Pn.toIntArray(s)}getChainStartIndices(t){let e=0;const s=new Rn(Math.trunc(t.length/2));s.add(e);do{const n=this.findChainEnd(t,e);s.add(n),e=n}while(e<t.length-1);return s.toArray()}}class On{constructor(){On.constructor_.apply(this,arguments)}static constructor_(){this.e=null,this.pts=null,this.startIndex=null;const t=arguments[0];this.e=t,this.pts=t.getCoordinates();const e=new Pn;this.startIndex=e.getChainStartIndices(this.pts)}getCoordinates(){return this.pts}getMaxX(t){const e=this.pts[this.startIndex[t]].x,s=this.pts[this.startIndex[t+1]].x;return e>s?e:s}getMinX(t){const e=this.pts[this.startIndex[t]].x,s=this.pts[this.startIndex[t+1]].x;return e<s?e:s}computeIntersectsForChain(){if(4===arguments.length){const t=arguments[0],e=arguments[1],s=arguments[2],n=arguments[3];this.computeIntersectsForChain(this.startIndex[t],this.startIndex[t+1],e,e.startIndex[s],e.startIndex[s+1],n)}else if(6===arguments.length){const t=arguments[0],e=arguments[1],s=arguments[2],n=arguments[3],i=arguments[4],r=arguments[5];if(e-t==1&&i-n==1)return r.addIntersections(this.e,t,s.e,n),null;if(!this.overlaps(t,e,s,n,i))return null;const o=Math.trunc((t+e)/2),l=Math.trunc((n+i)/2);t<o&&(n<l&&this.computeIntersectsForChain(t,o,s,n,l,r),l<i&&this.computeIntersectsForChain(t,o,s,l,i,r)),o<e&&(n<l&&this.computeIntersectsForChain(o,e,s,n,l,r),l<i&&this.computeIntersectsForChain(o,e,s,l,i,r))}}overlaps(t,e,s,n,i){return O.intersects(this.pts[t],this.pts[e],s.pts[n],s.pts[i])}getStartIndexes(){return this.startIndex}computeIntersects(t,e){for(let s=0;s<this.startIndex.length-1;s++)for(let n=0;n<t.startIndex.length-1;n++)this.computeIntersectsForChain(s,t,n,e)}}let vn=class t extends rn{constructor(){super(),t.constructor_.apply(this,arguments)}static constructor_(){if(this.pts=null,this._env=null,this.eiList=new Ln(this),this._name=null,this._mce=null,this._isIsolated=!0,this._depth=new Tn,this._depthDelta=0,1===arguments.length){const e=arguments[0];t.constructor_.call(this,e,null)}else if(2===arguments.length){const t=arguments[0],e=arguments[1];this.pts=t,this._label=e}}static updateIM(){if(!(2===arguments.length&&arguments[1]instanceof Jt&&arguments[0]instanceof nn))return super.updateIM.apply(this,arguments);{const t=arguments[0],e=arguments[1];e.setAtLeastIfValid(t.getLocation(0,Hs.ON),t.getLocation(1,Hs.ON),1),t.isArea()&&(e.setAtLeastIfValid(t.getLocation(0,Hs.LEFT),t.getLocation(1,Hs.LEFT),2),e.setAtLeastIfValid(t.getLocation(0,Hs.RIGHT),t.getLocation(1,Hs.RIGHT),2))}}getDepth(){return this._depth}getCollapsedEdge(){const e=new Array(2).fill(null);e[0]=this.pts[0],e[1]=this.pts[1];return new t(e,nn.toLineLabel(this._label))}setIsolated(t){this._isIsolated=t}setName(t){this._name=t}equals(e){if(!(e instanceof t))return!1;const s=e;if(this.pts.length!==s.pts.length)return!1;let n=!0,i=!0,r=this.pts.length;for(let t=0;t<this.pts.length;t++)if(this.pts[t].equals2D(s.pts[t])||(n=!1),this.pts[t].equals2D(s.pts[--r])||(i=!1),!n&&!i)return!1;return!0}getCoordinate(){if(0===arguments.length)return this.pts.length>0?this.pts[0]:null;if(1===arguments.length){const t=arguments[0];return this.pts[t]}}isClosed(){return this.pts[0].equals(this.pts[this.pts.length-1])}getMaximumSegmentIndex(){return this.pts.length-1}setDepthDelta(t){this._depthDelta=t}getEdgeIntersectionList(){return this.eiList}addIntersections(t,e,s){for(let n=0;n<t.getIntersectionNum();n++)this.addIntersection(t,e,s,n)}isIsolated(){return this._isIsolated}getCoordinates(){return this.pts}print(t){t.print("edge "+this._name+": "),t.print("LINESTRING (");for(let e=0;e<this.pts.length;e++)e>0&&t.print(","),t.print(this.pts[e].x+" "+this.pts[e].y);t.print(")  "+this._label+" "+this._depthDelta)}computeIM(e){t.updateIM(this._label,e)}isCollapsed(){return!!this._label.isArea()&&(3===this.pts.length&&!!this.pts[0].equals(this.pts[2]))}getDepthDelta(){return this._depthDelta}getNumPoints(){return this.pts.length}printReverse(t){t.print("edge "+this._name+": ");for(let e=this.pts.length-1;e>=0;e--)t.print(this.pts[e]+" ");t.println("")}getMonotoneChainEdge(){return null===this._mce&&(this._mce=new On(this)),this._mce}getEnvelope(){if(null===this._env){this._env=new O;for(let t=0;t<this.pts.length;t++)this._env.expandToInclude(this.pts[t])}return this._env}addIntersection(t,e,s,n){const i=new m(t.getIntersection(n));let r=e,o=t.getEdgeDistance(s,n);const l=r+1;if(l<this.pts.length){const t=this.pts[l];i.equals2D(t)&&(r=l,o=0)}this.eiList.add(i,r,o)}toString(){const t=new nt;t.append("edge "+this._name+": "),t.append("LINESTRING (");for(let e=0;e<this.pts.length;e++)e>0&&t.append(","),t.append(this.pts[e].x+" "+this.pts[e].y);return t.append(")  "+this._label+" "+this._depthDelta),t.toString()}isPointwiseEqual(t){if(this.pts.length!==t.pts.length)return!1;for(let e=0;e<this.pts.length;e++)if(!this.pts[e].equals2D(t.pts[e]))return!1;return!0}};class Mn{constructor(){Mn.constructor_.apply(this,arguments)}static constructor_(){this._bufParams=null,this._workingPrecisionModel=null,this._workingNoder=null,this._geomFact=null,this._graph=null,this._edgeList=new wn;const t=arguments[0];this._bufParams=t}static convertSegStrings(t){const e=new Lt,s=new L;for(;t.hasNext();){const n=t.next(),i=e.createLineString(n.getCoordinates());s.add(i)}return e.buildGeometry(s)}static depthDelta(t){const e=t.getLocation(0,Hs.LEFT),s=t.getLocation(0,Hs.RIGHT);return e===Qt.INTERIOR&&s===Qt.EXTERIOR?1:e===Qt.EXTERIOR&&s===Qt.INTERIOR?-1:0}createEmptyResultGeometry(){return this._geomFact.createPolygon()}getNoder(t){if(null!==this._workingNoder)return this._workingNoder;const e=new Gs,s=new jt;return s.setPrecisionModel(t),e.setSegmentIntersector(new Cn(s)),e}buffer(t,e){let s=this._workingPrecisionModel;null===s&&(s=t.getPrecisionModel()),this._geomFact=t.getFactory();const n=new en(s,this._bufParams),i=new yn(t,e,n).getCurves();if(i.size()<=0)return this.createEmptyResultGeometry();this.computeNodedEdges(i,s),this._graph=new un(new In),this._graph.addEdges(this._edgeList.getEdges());const r=this.createSubgraphs(this._graph),o=new pn(this._geomFact);this.buildSubgraphs(r,o);const l=o.getPolygons();if(l.size()<=0)return this.createEmptyResultGeometry();return this._geomFact.buildGeometry(l)}computeNodedEdges(t,e){const s=this.getNoder(e);s.computeNodes(t);for(let t=s.getNodedSubstrings().iterator();t.hasNext();){const e=t.next(),s=e.getCoordinates();if(2===s.length&&s[0].equals2D(s[1]))continue;const n=e.getData(),i=new vn(e.getCoordinates(),new nn(n));this.insertUniqueEdge(i)}}setNoder(t){this._workingNoder=t}setWorkingPrecisionModel(t){this._workingPrecisionModel=t}insertUniqueEdge(t){const e=this._edgeList.findEqualEdge(t);if(null!==e){const s=e.getLabel();let n=t.getLabel();e.isPointwiseEqual(t)||(n=new nn(t.getLabel()),n.flip()),s.merge(n);const i=Mn.depthDelta(n),r=e.getDepthDelta()+i;e.setDepthDelta(r)}else this._edgeList.add(t),t.setDepthDelta(Mn.depthDelta(t.getLabel()))}buildSubgraphs(t,e){const s=new L;for(let n=t.iterator();n.hasNext();){const t=n.next(),i=t.getRightmostCoordinate(),r=new mn(s).getDepth(i);t.computeDepth(r),t.findResultEdges(),s.add(t),e.add(t.getDirectedEdges(),t.getNodes())}}createSubgraphs(t){const e=new L;for(let s=t.getNodes().iterator();s.hasNext();){const t=s.next();if(!t.isVisited()){const s=new Qs;s.create(t),e.add(s)}}return xe.sort(e,xe.reverseOrder()),e}}class bn{constructor(){bn.constructor_.apply(this,arguments)}static constructor_(){if(this._argGeom=null,this._distance=null,this._bufParams=new Qe,this._resultGeometry=null,this._saveException=null,1===arguments.length){const t=arguments[0];this._argGeom=t}else if(2===arguments.length){const t=arguments[0],e=arguments[1];this._argGeom=t,this._bufParams=e}}static bufferOp(){if(2===arguments.length){const t=arguments[1];return new bn(arguments[0]).getResultGeometry(t)}if(3===arguments.length){if(Number.isInteger(arguments[2])&&arguments[0]instanceof j&&"number"==typeof arguments[1]){const t=arguments[1],e=arguments[2],s=new bn(arguments[0]);s.setQuadrantSegments(e);return s.getResultGeometry(t)}if(arguments[2]instanceof Qe&&arguments[0]instanceof j&&"number"==typeof arguments[1]){const t=arguments[1];return new bn(arguments[0],arguments[2]).getResultGeometry(t)}}else if(4===arguments.length){const t=arguments[1],e=arguments[2],s=arguments[3],n=new bn(arguments[0]);n.setQuadrantSegments(e),n.setEndCapStyle(s);return n.getResultGeometry(t)}}static precisionScaleFactor(t,e,s){const n=t.getEnvelopeInternal(),i=z.max(Math.abs(n.getMaxX()),Math.abs(n.getMaxY()),Math.abs(n.getMinX()),Math.abs(n.getMinY()))+2*(e>0?e:0),r=s-Math.trunc(Math.log(i)/Math.log(10)+1);return Math.pow(10,r)}bufferFixedPrecision(t){const e=new ds(new Us(new yt(1)),t.getScale()),s=new Mn(this._bufParams);s.setWorkingPrecisionModel(t),s.setNoder(e),this._resultGeometry=s.buffer(this._argGeom,this._distance)}bufferReducedPrecision(){if(0===arguments.length){for(let t=bn.MAX_PRECISION_DIGITS;t>=0;t--){try{this.bufferReducedPrecision(t)}catch(t){if(!(t instanceof _s))throw t;this._saveException=t}if(null!==this._resultGeometry)return null}throw this._saveException}if(1===arguments.length){const t=arguments[0],e=bn.precisionScaleFactor(this._argGeom,this._distance,t),s=new yt(e);this.bufferFixedPrecision(s)}}bufferOriginalPrecision(){try{const t=new Mn(this._bufParams);this._resultGeometry=t.buffer(this._argGeom,this._distance)}catch(t){if(!(t instanceof a))throw t;this._saveException=t}}getResultGeometry(t){return this._distance=t,this.computeGeometry(),this._resultGeometry}setEndCapStyle(t){this._bufParams.setEndCapStyle(t)}computeGeometry(){if(this.bufferOriginalPrecision(),null!==this._resultGeometry)return null;const t=this._argGeom.getFactory().getPrecisionModel();t.getType()===yt.FIXED?this.bufferFixedPrecision(t):this.bufferReducedPrecision()}setQuadrantSegments(t){this._bufParams.setQuadrantSegments(t)}}bn.CAP_ROUND=Qe.CAP_ROUND,bn.CAP_BUTT=Qe.CAP_FLAT,bn.CAP_FLAT=Qe.CAP_FLAT,bn.CAP_SQUARE=Qe.CAP_SQUARE,bn.MAX_PRECISION_DIGITS=12;class Dn{constructor(){Dn.constructor_.apply(this,arguments)}static constructor_(){if(this._snapTolerance=0,this._srcPts=null,this._seg=new Kt,this._allowSnappingToSourceVertices=!1,this._isClosed=!1,arguments[0]instanceof tt&&"number"==typeof arguments[1]){const t=arguments[0],e=arguments[1];Dn.constructor_.call(this,t.getCoordinates(),e)}else if(arguments[0]instanceof Array&&"number"==typeof arguments[1]){const t=arguments[0],e=arguments[1];this._srcPts=t,this._isClosed=Dn.isClosed(t),this._snapTolerance=e}}static isClosed(t){return!(t.length<=1)&&t[0].equals2D(t[t.length-1])}snapVertices(t,e){const s=this._isClosed?t.size()-1:t.size();for(let n=0;n<s;n++){const s=t.get(n),i=this.findSnapForVertex(s,e);null!==i&&(t.set(n,new m(i)),0===n&&this._isClosed&&t.set(t.size()-1,new m(i)))}}findSnapForVertex(t,e){for(let s=0;s<e.length;s++){if(t.equals2D(e[s]))return null;if(t.distance(e[s])<this._snapTolerance)return e[s]}return null}snapTo(t){const e=new R(this._srcPts);this.snapVertices(e,t),this.snapSegments(e,t);return e.toCoordinateArray()}snapSegments(t,e){if(0===e.length)return null;let s=e.length;e[0].equals2D(e[e.length-1])&&(s=e.length-1);for(let n=0;n<s;n++){const s=e[n],i=this.findSegmentIndexToSnap(s,t);i>=0&&t.add(i+1,new m(s),!1)}}findSegmentIndexToSnap(t,e){let s=r.MAX_VALUE,n=-1;for(let i=0;i<e.size()-1;i++){if(this._seg.p0=e.get(i),this._seg.p1=e.get(i+1),this._seg.p0.equals2D(t)||this._seg.p1.equals2D(t)){if(this._allowSnappingToSourceVertices)continue;return-1}const r=this._seg.distance(t);r<this._snapTolerance&&r<s&&(s=r,n=i)}return n}setAllowSnappingToSourceVertices(t){this._allowSnappingToSourceVertices=t}}class An{constructor(){An.constructor_.apply(this,arguments)}static constructor_(){this._srcGeom=null;const t=arguments[0];this._srcGeom=t}static computeSizeBasedSnapTolerance(t){const e=t.getEnvelopeInternal();return Math.min(e.getHeight(),e.getWidth())*An.SNAP_PRECISION_FACTOR}static computeOverlaySnapTolerance(){if(1===arguments.length){const t=arguments[0];let e=An.computeSizeBasedSnapTolerance(t);const s=t.getPrecisionModel();if(s.getType()===yt.FIXED){const t=1/s.getScale()*2/1.415;t>e&&(e=t)}return e}if(2===arguments.length){const t=arguments[0],e=arguments[1];return Math.min(An.computeOverlaySnapTolerance(t),An.computeOverlaySnapTolerance(e))}}static snapToSelf(t,e,s){return new An(t).snapToSelf(e,s)}static snap(t,e,s){const n=new Array(2).fill(null),i=new An(t);n[0]=i.snapTo(e,s);const r=new An(e);return n[1]=r.snapTo(n[0],s),n}computeSnapTolerance(t){return this.computeMinimumSegmentLength(t)/10}snapTo(t,e){const s=this.extractTargetCoordinates(t);return new Fn(e,s).transform(this._srcGeom)}snapToSelf(t,e){const s=this.extractTargetCoordinates(this._srcGeom),n=new Fn(t,s,!0).transform(this._srcGeom);let i=n;return e&&I(i,gt)&&(i=bn.bufferOp(n,0)),i}extractTargetCoordinates(t){const e=new at,s=t.getCoordinates();for(let t=0;t<s.length;t++)e.add(s[t]);return e.toArray(new Array(0).fill(null))}computeMinimumSegmentLength(t){let e=r.MAX_VALUE;for(let s=0;s<t.length-1;s++){const n=t[s].distance(t[s+1]);n<e&&(e=n)}return e}}An.SNAP_PRECISION_FACTOR=1e-9;class Fn extends me{constructor(){super(),Fn.constructor_.apply(this,arguments)}static constructor_(){if(this._snapTolerance=null,this._snapPts=null,this._isSelfSnap=!1,2===arguments.length){const t=arguments[0],e=arguments[1];this._snapTolerance=t,this._snapPts=e}else if(3===arguments.length){const t=arguments[0],e=arguments[1],s=arguments[2];this._snapTolerance=t,this._snapPts=e,this._isSelfSnap=s}}transformCoordinates(t,e){const s=t.toCoordinateArray(),n=this.snapLine(s,this._snapPts);return this._factory.getCoordinateSequenceFactory().create(n)}snapLine(t,e){const s=new Dn(t,this._snapTolerance);return s.setAllowSnappingToSourceVertices(this._isSelfSnap),s.snapTo(e)}}class Gn{constructor(){this._isFirst=!0,this._commonMantissaBitsCount=53,this._commonBits=new i,this._commonSignExp=null}getCommon(){return r.longBitsToDouble(this._commonBits)}add(t){const e=r.doubleToLongBits(t);if(this._isFirst)return this._commonBits=e,this._commonSignExp=Gn.signExpBits(this._commonBits),this._isFirst=!1,null;if(Gn.signExpBits(e)!==this._commonSignExp)return this._commonBits.high=0,this._commonBits.low=0,null;this._commonMantissaBitsCount=Gn.numCommonMostSigMantissaBits(this._commonBits,e),this._commonBits=Gn.zeroLowerBits(this._commonBits,64-(12+this._commonMantissaBitsCount))}toString(){if(1===arguments.length){const t=arguments[0],e=r.longBitsToDouble(t),s="0000000000000000000000000000000000000000000000000000000000000000"+i.toBinaryString(t),n=s.substring(s.length-64);return n.substring(0,1)+"  "+n.substring(1,12)+"(exp) "+n.substring(12)+" [ "+e+" ]"}}getClass(){return Gn}get interfaces_(){return[]}static getBit(t,e){const s=1<<e%32;return e<32?t.low&s?1:0:t.high&s?1:0}static signExpBits(t){return t.high>>>20}static zeroLowerBits(t,e){let s="low";if(e>32&&(t.low=0,e%=32,s="high"),e>0){const n=e<32?~((1<<e)-1):0;t[s]&=n}return t}static numCommonMostSigMantissaBits(t,e){let s=0;for(let n=52;n>=0;n--){if(Gn.getBit(t,n)!==Gn.getBit(e,n))return s;s++}return 52}}class qn{constructor(){qn.constructor_.apply(this,arguments)}static constructor_(){this._commonCoord=null,this._ccFilter=new Bn}add(t){t.apply(this._ccFilter),this._commonCoord=this._ccFilter.getCommonCoordinate()}removeCommonBits(t){if(0===this._commonCoord.x&&0===this._commonCoord.y)return t;const e=new m(this._commonCoord);e.x=-e.x,e.y=-e.y;const s=new Yn(e);return t.apply(s),t.geometryChanged(),t}addCommonBits(t){const e=new Yn(this._commonCoord);t.apply(e),t.geometryChanged()}getCommonCoordinate(){return this._commonCoord}}class Bn{constructor(){Bn.constructor_.apply(this,arguments)}static constructor_(){this._commonBitsX=new Gn,this._commonBitsY=new Gn}filter(t){this._commonBitsX.add(t.x),this._commonBitsY.add(t.y)}getCommonCoordinate(){return new m(this._commonBitsX.getCommon(),this._commonBitsY.getCommon())}get interfaces_(){return[K]}}class Yn{constructor(){Yn.constructor_.apply(this,arguments)}static constructor_(){this.trans=null;const t=arguments[0];this.trans=t}filter(t,e){const s=t.getOrdinate(e,0)+this.trans.x,n=t.getOrdinate(e,1)+this.trans.y;t.setOrdinate(e,0,s),t.setOrdinate(e,1,n)}isGeometryChanged(){return!0}isDone(){return!1}get interfaces_(){return[P]}}qn.CommonCoordinateFilter=Bn,qn.Translater=Yn;class zn{constructor(){zn.constructor_.apply(this,arguments)}static constructor_(){this._op=null,this._geometryFactory=null,this._ptLocator=null,this._lineEdgesList=new L,this._resultLineList=new L;const t=arguments[0],e=arguments[1],s=arguments[2];this._op=t,this._geometryFactory=e,this._ptLocator=s}collectLines(t){for(let e=this._op.getGraph().getEdgeEnds().iterator();e.hasNext();){const s=e.next();this.collectLineEdge(s,t,this._lineEdgesList),this.collectBoundaryTouchEdge(s,t,this._lineEdgesList)}}labelIsolatedLine(t,e){const s=this._ptLocator.locate(t.getCoordinate(),this._op.getArgGeometry(e));t.getLabel().setLocation(e,s)}build(t){return this.findCoveredLineEdges(),this.collectLines(t),this.buildLines(t),this._resultLineList}collectLineEdge(t,e,s){const n=t.getLabel(),i=t.getEdge();t.isLineEdge()&&(t.isVisited()||!oi.isResultOfOp(n,e)||i.isCovered()||(s.add(i),t.setVisitedEdge(!0)))}findCoveredLineEdges(){for(let t=this._op.getGraph().getNodes().iterator();t.hasNext();){t.next().getEdges().findCoveredLineEdges()}for(let t=this._op.getGraph().getEdgeEnds().iterator();t.hasNext();){const e=t.next(),s=e.getEdge();if(e.isLineEdge()&&!s.isCoveredSet()){const t=this._op.isCoveredByA(e.getCoordinate());s.setCovered(t)}}}labelIsolatedLines(t){for(let e=t.iterator();e.hasNext();){const t=e.next(),s=t.getLabel();t.isIsolated()&&(s.isNull(0)?this.labelIsolatedLine(t,0):this.labelIsolatedLine(t,1))}}buildLines(t){for(let t=this._lineEdgesList.iterator();t.hasNext();){const e=t.next(),s=this._geometryFactory.createLineString(e.getCoordinates());this._resultLineList.add(s),e.setInResult(!0)}}collectBoundaryTouchEdge(t,e,s){const n=t.getLabel();return t.isLineEdge()||t.isVisited()||t.isInteriorAreaEdge()||t.getEdge().isInResult()?null:(h.isTrue(!(t.isInResult()||t.getSym().isInResult())||!t.getEdge().isInResult()),void(oi.isResultOfOp(n,e)&&e===oi.INTERSECTION&&(s.add(t.getEdge()),t.setVisitedEdge(!0))))}}class Vn{constructor(){Vn.constructor_.apply(this,arguments)}static constructor_(){this._op=null,this._geometryFactory=null,this._resultPointList=new L;const t=arguments[0],e=arguments[1];this._op=t,this._geometryFactory=e}build(t){return this.extractNonCoveredResultNodes(t),this._resultPointList}extractNonCoveredResultNodes(t){for(let e=this._op.getGraph().getNodes().iterator();e.hasNext();){const s=e.next();if(!s.isInResult()&&(!s.isIncidentEdgeInResult()&&(0===s.getEdges().getDegree()||t===oi.INTERSECTION))){const e=s.getLabel();oi.isResultOfOp(e,t)&&this.filterCoveredNodeToPoint(s)}}}filterCoveredNodeToPoint(t){const e=t.getCoordinate();if(!this._op.isCoveredByLA(e)){const t=this._geometryFactory.createPoint(e);this._resultPointList.add(t)}}}class kn{isInBoundary(t){}}class Xn{isInBoundary(t){return t%2==1}get interfaces_(){return[kn]}}class Un{isInBoundary(t){return t>0}get interfaces_(){return[kn]}}class Hn{isInBoundary(t){return t>1}get interfaces_(){return[kn]}}class Wn{isInBoundary(t){return 1===t}get interfaces_(){return[kn]}}kn.Mod2BoundaryNodeRule=Xn,kn.EndPointBoundaryNodeRule=Un,kn.MultiValentEndPointBoundaryNodeRule=Hn,kn.MonoValentEndPointBoundaryNodeRule=Wn,kn.MOD2_BOUNDARY_RULE=new Xn,kn.ENDPOINT_BOUNDARY_RULE=new Un,kn.MULTIVALENT_ENDPOINT_BOUNDARY_RULE=new Hn,kn.MONOVALENT_ENDPOINT_BOUNDARY_RULE=new Wn,kn.OGC_SFS_BOUNDARY_RULE=kn.MOD2_BOUNDARY_RULE;class Zn{constructor(){Zn.constructor_.apply(this,arguments)}static constructor_(){if(this._boundaryRule=kn.OGC_SFS_BOUNDARY_RULE,this._isIn=null,this._numBoundaries=null,0===arguments.length);else if(1===arguments.length){const t=arguments[0];if(null===t)throw new n("Rule must be non-null");this._boundaryRule=t}}locateInPolygonRing(t,e){return e.getEnvelopeInternal().intersects(t)?Ue.locateInRing(t,e.getCoordinates()):Qt.EXTERIOR}intersects(t,e){return this.locate(t,e)!==Qt.EXTERIOR}updateLocationInfo(t){t===Qt.INTERIOR&&(this._isIn=!0),t===Qt.BOUNDARY&&this._numBoundaries++}computeLocation(t,e){if(e instanceof Nt&&this.updateLocationInfo(this.locateOnPoint(t,e)),e instanceof tt)this.updateLocationInfo(this.locateOnLineString(t,e));else if(e instanceof Ct)this.updateLocationInfo(this.locateInPolygon(t,e));else if(e instanceof Et){const s=e;for(let e=0;e<s.getNumGeometries();e++){const n=s.getGeometryN(e);this.updateLocationInfo(this.locateOnLineString(t,n))}}else if(e instanceof dt){const s=e;for(let e=0;e<s.getNumGeometries();e++){const n=s.getGeometryN(e);this.updateLocationInfo(this.locateInPolygon(t,n))}}else if(e instanceof ut){const s=new We(e);for(;s.hasNext();){const n=s.next();n!==e&&this.computeLocation(t,n)}}}locateOnPoint(t,e){return e.getCoordinate().equals2D(t)?Qt.INTERIOR:Qt.EXTERIOR}locateOnLineString(t,e){if(!e.getEnvelopeInternal().intersects(t))return Qt.EXTERIOR;const s=e.getCoordinateSequence();return e.isClosed()||!t.equals(s.getCoordinate(0))&&!t.equals(s.getCoordinate(s.size()-1))?Ue.isOnLine(t,s)?Qt.INTERIOR:Qt.EXTERIOR:Qt.BOUNDARY}locateInPolygon(t,e){if(e.isEmpty())return Qt.EXTERIOR;const s=e.getExteriorRing(),n=this.locateInPolygonRing(t,s);if(n===Qt.EXTERIOR)return Qt.EXTERIOR;if(n===Qt.BOUNDARY)return Qt.BOUNDARY;for(let s=0;s<e.getNumInteriorRing();s++){const n=e.getInteriorRingN(s),i=this.locateInPolygonRing(t,n);if(i===Qt.INTERIOR)return Qt.EXTERIOR;if(i===Qt.BOUNDARY)return Qt.BOUNDARY}return Qt.INTERIOR}locate(t,e){return e.isEmpty()?Qt.EXTERIOR:e instanceof tt?this.locateOnLineString(t,e):e instanceof Ct?this.locateInPolygon(t,e):(this._isIn=!1,this._numBoundaries=0,this.computeLocation(t,e),this._boundaryRule.isInBoundary(this._numBoundaries)?Qt.BOUNDARY:this._numBoundaries>0||this._isIn?Qt.INTERIOR:Qt.EXTERIOR)}}class jn{constructor(){jn.constructor_.apply(this,arguments)}static constructor_(){this._pts=null,this._data=null;const t=arguments[0],e=arguments[1];this._pts=t,this._data=e}getCoordinates(){return this._pts}size(){return this._pts.length}getCoordinate(t){return this._pts[t]}isClosed(){return this._pts[0].equals(this._pts[this._pts.length-1])}getSegmentOctant(t){return t===this._pts.length-1?-1:as.octant(this.getCoordinate(t),this.getCoordinate(t+1))}setData(t){this._data=t}getData(){return this._data}toString(){return Wt.toLineString(new it(this._pts))}get interfaces_(){return[cs]}}class Kn{constructor(){Kn.constructor_.apply(this,arguments)}static constructor_(){this._findAllIntersections=!1,this._isCheckEndSegmentsOnly=!1,this._keepIntersections=!0,this._isInteriorIntersectionsOnly=!1,this._li=null,this._interiorIntersection=null,this._intSegments=null,this._intersections=new L,this._intersectionCount=0;const t=arguments[0];this._li=t,this._interiorIntersection=null}static createAllIntersectionsFinder(t){const e=new Kn(t);return e.setFindAllIntersections(!0),e}static isInteriorVertexIntersection(){if(4===arguments.length){const t=arguments[1];return(!arguments[2]||!arguments[3])&&!!arguments[0].equals2D(t)}if(8===arguments.length){const t=arguments[0],e=arguments[1],s=arguments[2],n=arguments[3],i=arguments[4],r=arguments[5],o=arguments[6],l=arguments[7];return!!Kn.isInteriorVertexIntersection(t,s,i,o)||(!!Kn.isInteriorVertexIntersection(t,n,i,l)||(!!Kn.isInteriorVertexIntersection(e,s,r,o)||!!Kn.isInteriorVertexIntersection(e,n,r,l)))}}static createInteriorIntersectionCounter(t){const e=new Kn(t);return e.setInteriorIntersectionsOnly(!0),e.setFindAllIntersections(!0),e.setKeepIntersections(!1),e}static createIntersectionCounter(t){const e=new Kn(t);return e.setFindAllIntersections(!0),e.setKeepIntersections(!1),e}static isEndSegment(t,e){return 0===e||e>=t.size()-2}static createAnyIntersectionFinder(t){return new Kn(t)}static createInteriorIntersectionsFinder(t){const e=new Kn(t);return e.setFindAllIntersections(!0),e.setInteriorIntersectionsOnly(!0),e}count(){return this._intersectionCount}getIntersections(){return this._intersections}setFindAllIntersections(t){this._findAllIntersections=t}setKeepIntersections(t){this._keepIntersections=t}getIntersection(){return this._interiorIntersection}processIntersections(t,e,s,n){if(!this._findAllIntersections&&this.hasIntersection())return null;const i=t===s;if(i&&e===n)return null;if(this._isCheckEndSegmentsOnly){if(!(Kn.isEndSegment(t,e)||Kn.isEndSegment(s,n)))return null}const r=t.getCoordinate(e),o=t.getCoordinate(e+1),l=s.getCoordinate(n),a=s.getCoordinate(n+1),c=0===e,h=e+2===t.size(),u=0===n,g=n+2===s.size();this._li.computeIntersection(r,o,l,a);const d=this._li.hasIntersection()&&this._li.isInteriorIntersection();let _=!1;if(!this._isInteriorIntersectionsOnly){_=!(i&&Math.abs(n-e)<=1)&&Kn.isInteriorVertexIntersection(r,o,l,a,c,h,u,g)}(d||_)&&(this._intSegments=new Array(4).fill(null),this._intSegments[0]=r,this._intSegments[1]=o,this._intSegments[2]=l,this._intSegments[3]=a,this._interiorIntersection=this._li.getIntersection(0),this._keepIntersections&&this._intersections.add(this._interiorIntersection),this._intersectionCount++)}hasIntersection(){return null!==this._interiorIntersection}isDone(){return!this._findAllIntersections&&null!==this._interiorIntersection}setInteriorIntersectionsOnly(t){this._isInteriorIntersectionsOnly=t}setCheckEndSegmentsOnly(t){this._isCheckEndSegmentsOnly=t}getIntersectionSegments(){return this._intSegments}get interfaces_(){return[ks]}}class Qn{constructor(){Qn.constructor_.apply(this,arguments)}static constructor_(){this._li=new jt,this._segStrings=null,this._findAllIntersections=!1,this._segInt=null,this._isValid=!0;const t=arguments[0];this._segStrings=t}static computeIntersections(t){const e=new Qn(t);return e.setFindAllIntersections(!0),e.isValid(),e.getIntersections()}isValid(){return this.execute(),this._isValid}setFindAllIntersections(t){this._findAllIntersections=t}checkInteriorIntersections(){this._isValid=!0,this._segInt=new Kn(this._li),this._segInt.setFindAllIntersections(this._findAllIntersections);const t=new Gs;if(t.setSegmentIntersector(this._segInt),t.computeNodes(this._segStrings),this._segInt.hasIntersection())return this._isValid=!1,null}checkValid(){if(this.execute(),!this._isValid)throw new _s(this.getErrorMessage(),this._segInt.getIntersection())}getErrorMessage(){if(this._isValid)return"no intersections found";const t=this._segInt.getIntersectionSegments();return"found non-noded intersection between "+Wt.toLineString(t[0],t[1])+" and "+Wt.toLineString(t[2],t[3])}execute(){if(null!==this._segInt)return null;this.checkInteriorIntersections()}getIntersections(){return this._segInt.getIntersections()}}class Jn{constructor(){Jn.constructor_.apply(this,arguments)}static constructor_(){this._nv=null;const t=arguments[0];this._nv=new Qn(Jn.toSegmentStrings(t))}static toSegmentStrings(t){const e=new L;for(let s=t.iterator();s.hasNext();){const t=s.next();e.add(new jn(t.getCoordinates(),t))}return e}static checkValid(t){new Jn(t).checkValid()}checkValid(){this._nv.checkValid()}}class $n{}class ti{constructor(){ti.constructor_.apply(this,arguments)}static constructor_(){this._hasIntersection=!1,this._hasProper=!1,this._hasProperInterior=!1,this._properIntersectionPoint=null,this._li=null,this._includeProper=null,this._recordIsolated=null,this._isSelfIntersection=null,this._numIntersections=0,this.numTests=0,this._bdyNodes=null,this._isDone=!1,this._isDoneWhenProperInt=!1;const t=arguments[0],e=arguments[1],s=arguments[2];this._li=t,this._includeProper=e,this._recordIsolated=s}static isAdjacentSegments(t,e){return 1===Math.abs(t-e)}isTrivialIntersection(t,e,s,n){if(t===s&&1===this._li.getIntersectionNum()){if(ti.isAdjacentSegments(e,n))return!0;if(t.isClosed()){const s=t.getNumPoints()-1;if(0===e&&n===s||0===n&&e===s)return!0}}return!1}hasProperInteriorIntersection(){return this._hasProperInterior}isBoundaryPointInternal(t,e){for(let s=e.iterator();s.hasNext();){const e=s.next().getCoordinate();if(t.isIntersection(e))return!0}return!1}hasProperIntersection(){return this._hasProper}hasIntersection(){return this._hasIntersection}isDone(){return this._isDone}isBoundaryPoint(t,e){return null!==e&&(!!this.isBoundaryPointInternal(t,e[0])||!!this.isBoundaryPointInternal(t,e[1]))}setBoundaryNodes(t,e){this._bdyNodes=new Array(2).fill(null),this._bdyNodes[0]=t,this._bdyNodes[1]=e}addIntersections(t,e,s,n){if(t===s&&e===n)return null;this.numTests++;const i=t.getCoordinates()[e],r=t.getCoordinates()[e+1],o=s.getCoordinates()[n],l=s.getCoordinates()[n+1];this._li.computeIntersection(i,r,o,l),this._li.hasIntersection()&&(this._recordIsolated&&(t.setIsolated(!1),s.setIsolated(!1)),this._numIntersections++,this.isTrivialIntersection(t,e,s,n)||(this._hasIntersection=!0,!this._includeProper&&this._li.isProper()||(t.addIntersections(this._li,e,0),s.addIntersections(this._li,n,1)),this._li.isProper()&&(this._properIntersectionPoint=this._li.getIntersection(0).copy(),this._hasProper=!0,this._isDoneWhenProperInt&&(this._isDone=!0),this.isBoundaryPoint(this._li,this._bdyNodes)||(this._hasProperInterior=!0))))}getProperIntersectionPoint(){return this._properIntersectionPoint}setIsDoneIfProperInt(t){this._isDoneWhenProperInt=t}}class ei{constructor(){ei.constructor_.apply(this,arguments)}static constructor_(){this.mce=null,this.chainIndex=null;const t=arguments[0],e=arguments[1];this.mce=t,this.chainIndex=e}computeIntersections(t,e){this.mce.computeIntersectsForChain(this.chainIndex,t.mce,t.chainIndex,e)}}class si{constructor(){si.constructor_.apply(this,arguments)}static constructor_(){if(this._label=null,this._xValue=null,this._eventType=null,this._insertEvent=null,this._deleteEventIndex=null,this._obj=null,2===arguments.length){const t=arguments[0],e=arguments[1];this._eventType=si.DELETE,this._xValue=t,this._insertEvent=e}else if(3===arguments.length){const t=arguments[0],e=arguments[1],s=arguments[2];this._eventType=si.INSERT,this._label=t,this._xValue=e,this._obj=s}}getObject(){return this._obj}getDeleteEventIndex(){return this._deleteEventIndex}isDelete(){return this._eventType===si.DELETE}setDeleteEventIndex(t){this._deleteEventIndex=t}compareTo(t){const e=t;return this._xValue<e._xValue?-1:this._xValue>e._xValue?1:this._eventType<e._eventType?-1:this._eventType>e._eventType?1:0}getInsertEvent(){return this._insertEvent}isInsert(){return this._eventType===si.INSERT}isSameLabel(t){return null!==this._label&&this._label===t._label}get interfaces_(){return[o]}}si.INSERT=1,si.DELETE=2;class ni extends $n{constructor(){super(),ni.constructor_.apply(this,arguments)}static constructor_(){this.events=new L,this.nOverlaps=null}prepareEvents(){xe.sort(this.events);for(let t=0;t<this.events.size();t++){const e=this.events.get(t);e.isDelete()&&e.getInsertEvent().setDeleteEventIndex(t)}}computeIntersections(){if(1===arguments.length){const t=arguments[0];this.nOverlaps=0,this.prepareEvents();for(let e=0;e<this.events.size();e++){const s=this.events.get(e);if(s.isInsert()&&this.processOverlaps(e,s.getDeleteEventIndex(),s,t),t.isDone())break}}else if(3===arguments.length)if(arguments[2]instanceof ti&&I(arguments[0],C)&&I(arguments[1],C)){const t=arguments[0],e=arguments[1],s=arguments[2];this.addEdges(t,t),this.addEdges(e,e),this.computeIntersections(s)}else if("boolean"==typeof arguments[2]&&I(arguments[0],C)&&arguments[1]instanceof ti){const t=arguments[0],e=arguments[1];arguments[2]?this.addEdges(t,null):this.addEdges(t),this.computeIntersections(e)}}addEdge(t,e){const s=t.getMonotoneChainEdge(),n=s.getStartIndexes();for(let t=0;t<n.length-1;t++){const n=new ei(s,t),i=new si(e,s.getMinX(t),n);this.events.add(i),this.events.add(new si(s.getMaxX(t),i))}}processOverlaps(t,e,s,n){const i=s.getObject();for(let r=t;r<e;r++){const t=this.events.get(r);if(t.isInsert()){const e=t.getObject();s.isSameLabel(t)||(i.computeIntersections(e,n),this.nOverlaps++)}}}addEdges(){if(1===arguments.length){for(let t=arguments[0].iterator();t.hasNext();){const e=t.next();this.addEdge(e,e)}}else if(2===arguments.length){const t=arguments[1];for(let e=arguments[0].iterator();e.hasNext();){const s=e.next();this.addEdge(s,t)}}}}class ii extends un{constructor(){super(),ii.constructor_.apply(this,arguments)}static constructor_(){if(this._parentGeom=null,this._lineEdgeMap=new ft,this._boundaryNodeRule=null,this._useBoundaryDeterminationRule=!0,this._argIndex=null,this._boundaryNodes=null,this._hasTooFewPoints=!1,this._invalidPoint=null,this._areaPtLocator=null,this._ptLocator=new Zn,2===arguments.length){const t=arguments[0],e=arguments[1];ii.constructor_.call(this,t,e,kn.OGC_SFS_BOUNDARY_RULE)}else if(3===arguments.length){const t=arguments[0],e=arguments[1],s=arguments[2];this._argIndex=t,this._parentGeom=e,this._boundaryNodeRule=s,null!==e&&this.add(e)}}static determineBoundary(t,e){return t.isInBoundary(e)?Qt.BOUNDARY:Qt.INTERIOR}insertBoundaryPoint(t,e){const s=this._nodes.addNode(e).getLabel();let n=1,i=Qt.NONE;i=s.getLocation(t,Hs.ON),i===Qt.BOUNDARY&&n++;const r=ii.determineBoundary(this._boundaryNodeRule,n);s.setLocation(t,r)}computeSelfNodes(){if(2===arguments.length){const t=arguments[0],e=arguments[1];return this.computeSelfNodes(t,e,!1)}if(3===arguments.length){const t=arguments[1],e=arguments[2],s=new ti(arguments[0],!0,!1);s.setIsDoneIfProperInt(e);const n=this.createEdgeSetIntersector(),i=this._parentGeom instanceof et||this._parentGeom instanceof Ct||this._parentGeom instanceof dt,r=t||!i;return n.computeIntersections(this._edges,s,r),this.addSelfIntersectionNodes(this._argIndex),s}}addPolygon(t){this.addPolygonRing(t.getExteriorRing(),Qt.EXTERIOR,Qt.INTERIOR);for(let e=0;e<t.getNumInteriorRing();e++){const s=t.getInteriorRingN(e);this.addPolygonRing(s,Qt.INTERIOR,Qt.EXTERIOR)}}addEdge(t){this.insertEdge(t);const e=t.getCoordinates();this.insertPoint(this._argIndex,e[0],Qt.BOUNDARY),this.insertPoint(this._argIndex,e[e.length-1],Qt.BOUNDARY)}addLineString(t){const e=W.removeRepeatedPoints(t.getCoordinates());if(e.length<2)return this._hasTooFewPoints=!0,this._invalidPoint=e[0],null;const s=new vn(e,new nn(this._argIndex,Qt.INTERIOR));this._lineEdgeMap.put(t,s),this.insertEdge(s),h.isTrue(e.length>=2,"found LineString with single point"),this.insertBoundaryPoint(this._argIndex,e[0]),this.insertBoundaryPoint(this._argIndex,e[e.length-1])}getInvalidPoint(){return this._invalidPoint}getBoundaryPoints(){const t=this.getBoundaryNodes(),e=new Array(t.size()).fill(null);let s=0;for(let n=t.iterator();n.hasNext();){const t=n.next();e[s++]=t.getCoordinate().copy()}return e}addSelfIntersectionNodes(t){for(let e=this._edges.iterator();e.hasNext();){const s=e.next(),n=s.getLabel().getLocation(t);for(let e=s.eiList.iterator();e.hasNext();){const s=e.next();this.addSelfIntersectionNode(t,s.coord,n)}}}add(){if(!(1===arguments.length&&arguments[0]instanceof j))return super.add.apply(this,arguments);{const t=arguments[0];if(t.isEmpty())return null;if(t instanceof dt&&(this._useBoundaryDeterminationRule=!1),t instanceof Ct)this.addPolygon(t);else if(t instanceof tt)this.addLineString(t);else if(t instanceof Nt)this.addPoint(t);else if(t instanceof St)this.addCollection(t);else if(t instanceof Et)this.addCollection(t);else if(t instanceof dt)this.addCollection(t);else{if(!(t instanceof ut))throw new U(t.getGeometryType());this.addCollection(t)}}}addCollection(t){for(let e=0;e<t.getNumGeometries();e++){const s=t.getGeometryN(e);this.add(s)}}locate(t){return I(this._parentGeom,gt)&&this._parentGeom.getNumGeometries()>50?(null===this._areaPtLocator&&(this._areaPtLocator=new Ve(this._parentGeom)),this._areaPtLocator.locate(t)):this._ptLocator.locate(t,this._parentGeom)}findEdge(){if(1===arguments.length&&arguments[0]instanceof tt){const t=arguments[0];return this._lineEdgeMap.get(t)}return super.findEdge.apply(this,arguments)}computeSplitEdges(t){for(let e=this._edges.iterator();e.hasNext();){e.next().eiList.addSplitEdges(t)}}computeEdgeIntersections(t,e,s){const n=new ti(e,s,!0);n.setBoundaryNodes(this.getBoundaryNodes(),t.getBoundaryNodes());return this.createEdgeSetIntersector().computeIntersections(this._edges,t._edges,n),n}getGeometry(){return this._parentGeom}getBoundaryNodeRule(){return this._boundaryNodeRule}hasTooFewPoints(){return this._hasTooFewPoints}addPoint(){if(arguments[0]instanceof Nt){const t=arguments[0].getCoordinate();this.insertPoint(this._argIndex,t,Qt.INTERIOR)}else if(arguments[0]instanceof m){const t=arguments[0];this.insertPoint(this._argIndex,t,Qt.INTERIOR)}}getBoundaryNodes(){return null===this._boundaryNodes&&(this._boundaryNodes=this._nodes.getBoundaryNodes(this._argIndex)),this._boundaryNodes}addSelfIntersectionNode(t,e,s){if(this.isBoundaryNode(t,e))return null;s===Qt.BOUNDARY&&this._useBoundaryDeterminationRule?this.insertBoundaryPoint(t,e):this.insertPoint(t,e,s)}addPolygonRing(t,e,s){if(t.isEmpty())return null;const n=W.removeRepeatedPoints(t.getCoordinates());if(n.length<4)return this._hasTooFewPoints=!0,this._invalidPoint=n[0],null;let i=e,r=s;q.isCCW(n)&&(i=s,r=e);const o=new vn(n,new nn(this._argIndex,Qt.BOUNDARY,i,r));this._lineEdgeMap.put(t,o),this.insertEdge(o),this.insertPoint(this._argIndex,n[0],Qt.BOUNDARY)}insertPoint(t,e,s){const n=this._nodes.addNode(e),i=n.getLabel();null===i?n._label=new nn(t,s):i.setLocation(t,s)}createEdgeSetIntersector(){return new ni}}class ri{constructor(){ri.constructor_.apply(this,arguments)}static constructor_(){if(this._li=new jt,this._resultPrecisionModel=null,this._arg=null,1===arguments.length){const t=arguments[0];this.setComputationPrecision(t.getPrecisionModel()),this._arg=new Array(1).fill(null),this._arg[0]=new ii(0,t)}else if(2===arguments.length){const t=arguments[0],e=arguments[1];ri.constructor_.call(this,t,e,kn.OGC_SFS_BOUNDARY_RULE)}else if(3===arguments.length){const t=arguments[0],e=arguments[1],s=arguments[2];t.getPrecisionModel().compareTo(e.getPrecisionModel())>=0?this.setComputationPrecision(t.getPrecisionModel()):this.setComputationPrecision(e.getPrecisionModel()),this._arg=new Array(2).fill(null),this._arg[0]=new ii(0,t,s),this._arg[1]=new ii(1,e,s)}}setComputationPrecision(t){this._resultPrecisionModel=t,this._li.setPrecisionModel(this._resultPrecisionModel)}getArgGeometry(t){return this._arg[t].getGeometry()}}class oi extends ri{constructor(){super(),oi.constructor_.apply(this,arguments)}static constructor_(){this._ptLocator=new Zn,this._geomFact=null,this._resultGeom=null,this._graph=null,this._edgeList=new wn,this._resultPolyList=new L,this._resultLineList=new L,this._resultPointList=new L;const t=arguments[0],e=arguments[1];ri.constructor_.call(this,t,e),this._graph=new un(new In),this._geomFact=t.getFactory()}static overlayOp(t,e,s){return new oi(t,e).getResultGeometry(s)}static union(t,e){if(t.isEmpty()||e.isEmpty()){if(t.isEmpty()&&e.isEmpty())return oi.createEmptyResult(oi.UNION,t,e,t.getFactory());if(t.isEmpty())return e.copy();if(e.isEmpty())return t.copy()}if(t.isGeometryCollection()||e.isGeometryCollection())throw new n("This method does not support GeometryCollection arguments");return ai.overlayOp(t,e,oi.UNION)}static intersection(t,e){if(t.isEmpty()||e.isEmpty())return oi.createEmptyResult(oi.INTERSECTION,t,e,t.getFactory());if(t.isGeometryCollection()){const s=e;return ce.map(t,new class{get interfaces_(){return[MapOp]}map(t){return oi.intersection(t,s)}})}return ai.overlayOp(t,e,oi.INTERSECTION)}static symDifference(t,e){if(t.isEmpty()||e.isEmpty()){if(t.isEmpty()&&e.isEmpty())return oi.createEmptyResult(oi.SYMDIFFERENCE,t,e,t.getFactory());if(t.isEmpty())return e.copy();if(e.isEmpty())return t.copy()}if(t.isGeometryCollection()||e.isGeometryCollection())throw new n("This method does not support GeometryCollection arguments");return ai.overlayOp(t,e,oi.SYMDIFFERENCE)}static resultDimension(t,e,s){const n=e.getDimension(),i=s.getDimension();let r=-1;switch(t){case oi.INTERSECTION:r=Math.min(n,i);break;case oi.UNION:r=Math.max(n,i);break;case oi.DIFFERENCE:r=n;break;case oi.SYMDIFFERENCE:r=Math.max(n,i)}return r}static createEmptyResult(t,e,s,n){const i=oi.resultDimension(t,e,s);return n.createEmpty(i)}static difference(t,e){if(t.isEmpty())return oi.createEmptyResult(oi.DIFFERENCE,t,e,t.getFactory());if(e.isEmpty())return t.copy();if(t.isGeometryCollection()||e.isGeometryCollection())throw new n("This method does not support GeometryCollection arguments");return ai.overlayOp(t,e,oi.DIFFERENCE)}static isResultOfOp(){if(2===arguments.length){const t=arguments[0],e=arguments[1],s=t.getLocation(0),n=t.getLocation(1);return oi.isResultOfOp(s,n,e)}if(3===arguments.length){let t=arguments[0],e=arguments[1],s=arguments[2];switch(t===Qt.BOUNDARY&&(t=Qt.INTERIOR),e===Qt.BOUNDARY&&(e=Qt.INTERIOR),s){case oi.INTERSECTION:return t===Qt.INTERIOR&&e===Qt.INTERIOR;case oi.UNION:return t===Qt.INTERIOR||e===Qt.INTERIOR;case oi.DIFFERENCE:return t===Qt.INTERIOR&&e!==Qt.INTERIOR;case oi.SYMDIFFERENCE:return t===Qt.INTERIOR&&e!==Qt.INTERIOR||t!==Qt.INTERIOR&&e===Qt.INTERIOR}return!1}}insertUniqueEdge(t){const e=this._edgeList.findEqualEdge(t);if(null!==e){const s=e.getLabel();let n=t.getLabel();e.isPointwiseEqual(t)||(n=new nn(t.getLabel()),n.flip());const i=e.getDepth();i.isNull()&&i.add(s),i.add(n),s.merge(n)}else this._edgeList.add(t)}getGraph(){return this._graph}cancelDuplicateResultEdges(){for(let t=this._graph.getEdgeEnds().iterator();t.hasNext();){const e=t.next(),s=e.getSym();e.isInResult()&&s.isInResult()&&(e.setInResult(!1),s.setInResult(!1))}}mergeSymLabels(){for(let t=this._graph.getNodes().iterator();t.hasNext();){t.next().getEdges().mergeSymLabels()}}computeOverlay(t){this.copyPoints(0),this.copyPoints(1),this._arg[0].computeSelfNodes(this._li,!1),this._arg[1].computeSelfNodes(this._li,!1),this._arg[0].computeEdgeIntersections(this._arg[1],this._li,!0);const e=new L;this._arg[0].computeSplitEdges(e),this._arg[1].computeSplitEdges(e),this.insertUniqueEdges(e),this.computeLabelsFromDepths(),this.replaceCollapsedEdges(),Jn.checkValid(this._edgeList.getEdges()),this._graph.addEdges(this._edgeList.getEdges()),this.computeLabelling(),this.labelIncompleteNodes(),this.findResultAreaEdges(t),this.cancelDuplicateResultEdges();const s=new pn(this._geomFact);s.add(this._graph),this._resultPolyList=s.getPolygons();const n=new zn(this,this._geomFact,this._ptLocator);this._resultLineList=n.build(t);const i=new Vn(this,this._geomFact,this._ptLocator);this._resultPointList=i.build(t),this._resultGeom=this.computeGeometry(this._resultPointList,this._resultLineList,this._resultPolyList,t)}findResultAreaEdges(t){for(let e=this._graph.getEdgeEnds().iterator();e.hasNext();){const s=e.next(),n=s.getLabel();n.isArea()&&!s.isInteriorAreaEdge()&&oi.isResultOfOp(n.getLocation(0,Hs.RIGHT),n.getLocation(1,Hs.RIGHT),t)&&s.setInResult(!0)}}computeLabelsFromDepths(){for(let t=this._edgeList.iterator();t.hasNext();){const e=t.next(),s=e.getLabel(),n=e.getDepth();if(!n.isNull()){n.normalize();for(let t=0;t<2;t++)s.isNull(t)||!s.isArea()||n.isNull(t)||(0===n.getDelta(t)?s.toLine(t):(h.isTrue(!n.isNull(t,Hs.LEFT),"depth of LEFT side has not been initialized"),s.setLocation(t,Hs.LEFT,n.getLocation(t,Hs.LEFT)),h.isTrue(!n.isNull(t,Hs.RIGHT),"depth of RIGHT side has not been initialized"),s.setLocation(t,Hs.RIGHT,n.getLocation(t,Hs.RIGHT))))}}}isCoveredByA(t){return!!this.isCovered(t,this._resultPolyList)}isCoveredByLA(t){return!!this.isCovered(t,this._resultLineList)||!!this.isCovered(t,this._resultPolyList)}computeGeometry(t,e,s,n){const i=new L;return i.addAll(t),i.addAll(e),i.addAll(s),i.isEmpty()?oi.createEmptyResult(n,this._arg[0].getGeometry(),this._arg[1].getGeometry(),this._geomFact):this._geomFact.buildGeometry(i)}isCovered(t,e){for(let s=e.iterator();s.hasNext();){const e=s.next();if(this._ptLocator.locate(t,e)!==Qt.EXTERIOR)return!0}return!1}replaceCollapsedEdges(){const t=new L;for(let e=this._edgeList.iterator();e.hasNext();){const s=e.next();s.isCollapsed()&&(e.remove(),t.add(s.getCollapsedEdge()))}this._edgeList.addAll(t)}updateNodeLabelling(){for(let t=this._graph.getNodes().iterator();t.hasNext();){const e=t.next(),s=e.getEdges().getLabel();e.getLabel().merge(s)}}getResultGeometry(t){return this.computeOverlay(t),this._resultGeom}insertUniqueEdges(t){for(let e=t.iterator();e.hasNext();){const t=e.next();this.insertUniqueEdge(t)}}labelIncompleteNode(t,e){const s=this._ptLocator.locate(t.getCoordinate(),this._arg[e].getGeometry());t.getLabel().setLocation(e,s)}copyPoints(t){for(let e=this._arg[t].getNodeIterator();e.hasNext();){const s=e.next();this._graph.addNode(s.getCoordinate()).setLabel(t,s.getLabel().getLocation(t))}}computeLabelling(){for(let t=this._graph.getNodes().iterator();t.hasNext();){t.next().getEdges().computeLabelling(this._arg)}this.mergeSymLabels(),this.updateNodeLabelling()}labelIncompleteNodes(){for(let t=this._graph.getNodes().iterator();t.hasNext();){const e=t.next(),s=e.getLabel();e.isIsolated()&&(s.isNull(0)?this.labelIncompleteNode(e,0):this.labelIncompleteNode(e,1)),e.getEdges().updateLabelling(s)}}}oi.INTERSECTION=1,oi.UNION=2,oi.DIFFERENCE=3,oi.SYMDIFFERENCE=4;class li{constructor(){li.constructor_.apply(this,arguments)}static constructor_(){this._geom=new Array(2).fill(null),this._snapTolerance=null,this._cbr=null;const t=arguments[0],e=arguments[1];this._geom[0]=t,this._geom[1]=e,this.computeSnapTolerance()}static overlayOp(t,e,s){return new li(t,e).getResultGeometry(s)}static union(t,e){return li.overlayOp(t,e,oi.UNION)}static intersection(t,e){return li.overlayOp(t,e,oi.INTERSECTION)}static symDifference(t,e){return li.overlayOp(t,e,oi.SYMDIFFERENCE)}static difference(t,e){return li.overlayOp(t,e,oi.DIFFERENCE)}selfSnap(t){return new An(t).snapTo(t,this._snapTolerance)}removeCommonBits(t){this._cbr=new qn,this._cbr.add(t[0]),this._cbr.add(t[1]);const e=new Array(2).fill(null);return e[0]=this._cbr.removeCommonBits(t[0].copy()),e[1]=this._cbr.removeCommonBits(t[1].copy()),e}prepareResult(t){return this._cbr.addCommonBits(t),t}getResultGeometry(t){const e=this.snap(this._geom),s=oi.overlayOp(e[0],e[1],t);return this.prepareResult(s)}checkValid(t){t.isValid()||Y.out.println("Snapped geometry is invalid")}computeSnapTolerance(){this._snapTolerance=An.computeOverlaySnapTolerance(this._geom[0],this._geom[1])}snap(t){const e=this.removeCommonBits(t);return An.snap(e[0],e[1],this._snapTolerance)}}class ai{constructor(){ai.constructor_.apply(this,arguments)}static constructor_(){this._geom=new Array(2).fill(null);const t=arguments[0],e=arguments[1];this._geom[0]=t,this._geom[1]=e}static overlayOp(t,e,s){return new ai(t,e).getResultGeometry(s)}static union(t,e){return ai.overlayOp(t,e,oi.UNION)}static intersection(t,e){return ai.overlayOp(t,e,oi.INTERSECTION)}static symDifference(t,e){return ai.overlayOp(t,e,oi.SYMDIFFERENCE)}static difference(t,e){return ai.overlayOp(t,e,oi.DIFFERENCE)}getResultGeometry(t){let e=null,s=!1,n=null;try{e=oi.overlayOp(this._geom[0],this._geom[1],t);!0&&(s=!0)}catch(t){if(!(t instanceof a))throw t;n=t}if(!s)try{e=li.overlayOp(this._geom[0],this._geom[1],t)}catch(t){throw t instanceof a?n:t}return e}}class ci{static union(t,e){if(t.isEmpty()||e.isEmpty()){if(t.isEmpty()&&e.isEmpty())return oi.createEmptyResult(oi.UNION,t,e,t.getFactory());if(t.isEmpty())return e.copy();if(e.isEmpty())return t.copy()}return j.checkNotGeometryCollection(t),j.checkNotGeometryCollection(e),ai.overlayOp(t,e,oi.UNION)}}class hi{static diagonalSize(t){if(t.isNull())return 0;const e=t.getWidth(),s=t.getHeight();return Math.sqrt(e*e+s*s)}measure(t,e){const s=Oe.distance(t,e,hi.DENSIFY_FRACTION),n=new O(t.getEnvelopeInternal());n.expandToInclude(e.getEnvelopeInternal());return 1-s/hi.diagonalSize(n)}get interfaces_(){return[Ke]}}hi.DENSIFY_FRACTION=.25;var ui=Object.freeze({__proto__:null,AreaSimilarityMeasure:class{measure(t,e){return oi.intersection(t,e).getArea()/ci.union(t,e).getArea()}get interfaces_(){return[Ke]}},HausdorffSimilarityMeasure:hi,SimilarityMeasure:Ke,SimilarityMeasureCombiner:class{static combine(t,e){return Math.min(t,e)}}});class gi{constructor(){gi.constructor_.apply(this,arguments)}static constructor_(){this._areaBasePt=null,this._triangleCent3=new m,this._areasum2=0,this._cg3=new m,this._lineCentSum=new m,this._totalLength=0,this._ptCount=0,this._ptCentSum=new m;const t=arguments[0];this._areaBasePt=null,this.add(t)}static centroid3(t,e,s,n){return n.x=t.x+e.x+s.x,n.y=t.y+e.y+s.y,null}static getCentroid(t){return new gi(t).getCentroid()}static area2(t,e,s){return(e.x-t.x)*(s.y-t.y)-(s.x-t.x)*(e.y-t.y)}setAreaBasePoint(t){this._areaBasePt=t}addPoint(t){this._ptCount+=1,this._ptCentSum.x+=t.x,this._ptCentSum.y+=t.y}addLineSegments(t){let e=0;for(let s=0;s<t.length-1;s++){const n=t[s].distance(t[s+1]);if(0===n)continue;e+=n;const i=(t[s].x+t[s+1].x)/2;this._lineCentSum.x+=n*i;const r=(t[s].y+t[s+1].y)/2;this._lineCentSum.y+=n*r}this._totalLength+=e,0===e&&t.length>0&&this.addPoint(t[0])}addHole(t){const e=q.isCCW(t);for(let s=0;s<t.length-1;s++)this.addTriangle(this._areaBasePt,t[s],t[s+1],e);this.addLineSegments(t)}getCentroid(){const t=new m;if(Math.abs(this._areasum2)>0)t.x=this._cg3.x/3/this._areasum2,t.y=this._cg3.y/3/this._areasum2;else if(this._totalLength>0)t.x=this._lineCentSum.x/this._totalLength,t.y=this._lineCentSum.y/this._totalLength;else{if(!(this._ptCount>0))return null;t.x=this._ptCentSum.x/this._ptCount,t.y=this._ptCentSum.y/this._ptCount}return t}add(){if(arguments[0]instanceof Ct){const t=arguments[0];this.addShell(t.getExteriorRing().getCoordinates());for(let e=0;e<t.getNumInteriorRing();e++)this.addHole(t.getInteriorRingN(e).getCoordinates())}else if(arguments[0]instanceof j){const t=arguments[0];if(t.isEmpty())return null;if(t instanceof Nt)this.addPoint(t.getCoordinate());else if(t instanceof tt)this.addLineSegments(t.getCoordinates());else if(t instanceof Ct){const e=t;this.add(e)}else if(t instanceof ut){const e=t;for(let t=0;t<e.getNumGeometries();t++)this.add(e.getGeometryN(t))}}}addShell(t){t.length>0&&this.setAreaBasePoint(t[0]);const e=!q.isCCW(t);for(let s=0;s<t.length-1;s++)this.addTriangle(this._areaBasePt,t[s],t[s+1],e);this.addLineSegments(t)}addTriangle(t,e,s,n){const i=n?1:-1;gi.centroid3(t,e,s,this._triangleCent3);const r=gi.area2(t,e,s);this._cg3.x+=i*r*this._triangleCent3.x,this._cg3.y+=i*r*this._triangleCent3.y,this._areasum2+=i*r}}class di{constructor(){di.constructor_.apply(this,arguments)}static constructor_(){this._coordSet=new pt,this._list=new L}static filterCoordinates(t){const e=new di;for(let s=0;s<t.length;s++)e.filter(t[s]);return e.getCoordinates()}filter(t){this._coordSet.add(t)&&this._list.add(t)}getCoordinates(){const t=new Array(this._list.size()).fill(null);return this._list.toArray(t)}get interfaces_(){return[K]}}class _i{constructor(){_i.constructor_.apply(this,arguments)}static constructor_(){if(this._geomFactory=null,this._inputPts=null,1===arguments.length){const t=arguments[0];_i.constructor_.call(this,_i.extractCoordinates(t),t.getFactory())}else if(2===arguments.length){const t=arguments[0],e=arguments[1];this._inputPts=di.filterCoordinates(t),this._geomFactory=e}}static extractCoordinates(t){const e=new di;return t.apply(e),e.getCoordinates()}lineOrPolygon(t){if(3===(t=this.cleanRing(t)).length)return this._geomFactory.createLineString([t[0],t[1]]);const e=this._geomFactory.createLinearRing(t);return this._geomFactory.createPolygon(e)}cleanRing(t){h.equals(t[0],t[t.length-1]);const e=new L;let s=null;for(let n=0;n<=t.length-2;n++){const i=t[n],r=t[n+1];i.equals(r)||(null!==s&&this.isBetween(s,i,r)||(e.add(i),s=i))}e.add(t[t.length-1]);const n=new Array(e.size()).fill(null);return e.toArray(n)}isBetween(t,e,s){if(0!==q.index(t,e,s))return!1;if(t.x!==s.x){if(t.x<=e.x&&e.x<=s.x)return!0;if(s.x<=e.x&&e.x<=t.x)return!0}if(t.y!==s.y){if(t.y<=e.y&&e.y<=s.y)return!0;if(s.y<=e.y&&e.y<=t.y)return!0}return!1}reduce(t){const e=this.computeOctRing(t);if(null===e)return t;const s=new at;for(let t=0;t<e.length;t++)s.add(e[t]);for(let n=0;n<t.length;n++)Ue.isInRing(t[n],e)||s.add(t[n]);const n=W.toCoordinateArray(s);return n.length<3?this.padArray3(n):n}getConvexHull(){if(0===this._inputPts.length)return this._geomFactory.createGeometryCollection();if(1===this._inputPts.length)return this._geomFactory.createPoint(this._inputPts[0]);if(2===this._inputPts.length)return this._geomFactory.createLineString(this._inputPts);let t=this._inputPts;this._inputPts.length>50&&(t=this.reduce(this._inputPts));const e=this.preSort(t),s=this.grahamScan(e),n=this.toCoordinateArray(s);return this.lineOrPolygon(n)}padArray3(t){const e=new Array(3).fill(null);for(let s=0;s<e.length;s++)s<t.length?e[s]=t[s]:e[s]=t[0];return e}computeOctPts(t){const e=new Array(8).fill(null);for(let s=0;s<e.length;s++)e[s]=t[0];for(let s=1;s<t.length;s++)t[s].x<e[0].x&&(e[0]=t[s]),t[s].x-t[s].y<e[1].x-e[1].y&&(e[1]=t[s]),t[s].y>e[2].y&&(e[2]=t[s]),t[s].x+t[s].y>e[3].x+e[3].y&&(e[3]=t[s]),t[s].x>e[4].x&&(e[4]=t[s]),t[s].x-t[s].y>e[5].x-e[5].y&&(e[5]=t[s]),t[s].y<e[6].y&&(e[6]=t[s]),t[s].x+t[s].y<e[7].x+e[7].y&&(e[7]=t[s]);return e}toCoordinateArray(t){const e=new Array(t.size()).fill(null);for(let s=0;s<t.size();s++){const n=t.get(s);e[s]=n}return e}grahamScan(t){let e=null;const s=new Zs;s.push(t[0]),s.push(t[1]),s.push(t[2]);for(let n=3;n<t.length;n++){for(e=s.pop();!s.empty()&&q.index(s.peek(),e,t[n])>0;)e=s.pop();s.push(e),s.push(t[n])}return s.push(t[0]),s}preSort(t){let e=null;for(let s=1;s<t.length;s++)(t[s].y<t[0].y||t[s].y===t[0].y&&t[s].x<t[0].x)&&(e=t[0],t[0]=t[s],t[s]=e);return ht.sort(t,1,t.length,new pi(t[0])),t}computeOctRing(t){const e=this.computeOctPts(t),s=new R;return s.add(e,!1),s.size()<3?null:(s.closeRing(),s.toCoordinateArray())}}class pi{constructor(){pi.constructor_.apply(this,arguments)}static constructor_(){this._origin=null;const t=arguments[0];this._origin=t}static polarCompare(t,e,s){const n=e.x-t.x,i=e.y-t.y,r=s.x-t.x,o=s.y-t.y,l=q.index(t,e,s);if(l===q.COUNTERCLOCKWISE)return 1;if(l===q.CLOCKWISE)return-1;const a=n*n+i*i,c=r*r+o*o;return a<c?-1:a>c?1:0}compare(t,e){const s=t,n=e;return pi.polarCompare(this._origin,s,n)}get interfaces_(){return[g]}}_i.RadialComparator=pi;class mi{constructor(){mi.constructor_.apply(this,arguments)}static constructor_(){this._interiorPoint=null,this._maxWidth=-1;const t=arguments[0];this.process(t)}static avg(t,e){return(t+e)/2}static getInteriorPoint(t){return new mi(t).getInteriorPoint()}process(t){if(t.isEmpty())return null;if(t instanceof Ct)this.processPolygon(t);else if(t instanceof ut){const e=t;for(let t=0;t<e.getNumGeometries();t++)this.process(e.getGeometryN(t))}}getInteriorPoint(){return this._interiorPoint}processPolygon(t){const e=new fi(t);e.process();const s=e.getWidth();s>this._maxWidth&&(this._maxWidth=s,this._interiorPoint=e.getInteriorPoint())}}class fi{constructor(){fi.constructor_.apply(this,arguments)}static constructor_(){this._polygon=null,this._interiorPointY=null,this._interiorSectionWidth=0,this._interiorPoint=null;const t=arguments[0];this._polygon=t,this._interiorPointY=xi.getScanLineY(t)}static isEdgeCrossingCounted(t,e,s){const n=t.getY(),i=e.getY();return n!==i&&(!(n===s&&i<s)&&!(i===s&&n<s))}static intersectsHorizontalLine(){if(2===arguments.length){const t=arguments[0],e=arguments[1];return!(e<t.getMinY())&&!(e>t.getMaxY())}if(3===arguments.length){const t=arguments[0],e=arguments[1],s=arguments[2];return!(t.getY()>s&&e.getY()>s)&&!(t.getY()<s&&e.getY()<s)}}static intersection(t,e,s){const n=t.getX(),i=e.getX();if(n===i)return n;const r=i-n,o=(e.getY()-t.getY())/r;return n+(s-t.getY())/o}findBestMidpoint(t){if(0===t.size())return null;h.isTrue(0==t.size()%2,"Interior Point robustness failure: odd number of scanline crossings"),t.sort(new yi);for(let e=0;e<t.size();e+=2){const s=t.get(e),n=t.get(e+1),i=n-s;if(i>this._interiorSectionWidth){this._interiorSectionWidth=i;const t=mi.avg(s,n);this._interiorPoint=new m(t,this._interiorPointY)}}}getWidth(){return this._interiorSectionWidth}getInteriorPoint(){return this._interiorPoint}addEdgeCrossing(t,e,s,n){if(!fi.intersectsHorizontalLine(t,e,s))return null;if(!fi.isEdgeCrossingCounted(t,e,s))return null;const i=fi.intersection(t,e,s);n.add(i)}process(){if(this._polygon.isEmpty())return null;this._interiorPoint=new m(this._polygon.getCoordinate());const t=new L;this.scanRing(this._polygon.getExteriorRing(),t);for(let e=0;e<this._polygon.getNumInteriorRing();e++)this.scanRing(this._polygon.getInteriorRingN(e),t);this.findBestMidpoint(t)}scanRing(t,e){if(!fi.intersectsHorizontalLine(t.getEnvelopeInternal(),this._interiorPointY))return null;const s=t.getCoordinateSequence();for(let t=1;t<s.size();t++){const n=s.getCoordinate(t-1),i=s.getCoordinate(t);this.addEdgeCrossing(n,i,this._interiorPointY,e)}}}class yi{compare(t,e){return t<e?-1:t>e?1:0}get interfaces_(){return[g]}}fi.DoubleComparator=yi;class xi{constructor(){xi.constructor_.apply(this,arguments)}static constructor_(){this._poly=null,this._centreY=null,this._hiY=r.MAX_VALUE,this._loY=-r.MAX_VALUE;const t=arguments[0];this._poly=t,this._hiY=t.getEnvelopeInternal().getMaxY(),this._loY=t.getEnvelopeInternal().getMinY(),this._centreY=mi.avg(this._loY,this._hiY)}static getScanLineY(t){return new xi(t).getScanLineY()}process(t){const e=t.getCoordinateSequence();for(let t=0;t<e.size();t++){const s=e.getY(t);this.updateInterval(s)}}getScanLineY(){this.process(this._poly.getExteriorRing());for(let t=0;t<this._poly.getNumInteriorRing();t++)this.process(this._poly.getInteriorRingN(t));return mi.avg(this._hiY,this._loY)}updateInterval(t){t<=this._centreY?t>this._loY&&(this._loY=t):t>this._centreY&&t<this._hiY&&(this._hiY=t)}}mi.InteriorPointPolygon=fi,mi.ScanLineYOrdinateFinder=xi;class Ei{constructor(){Ei.constructor_.apply(this,arguments)}static constructor_(){this._centroid=null,this._minDistance=r.MAX_VALUE,this._interiorPoint=null;const t=arguments[0];t.isEmpty()?this._centroid=null:(this._centroid=gi.getCentroid(t),t.getPrecisionModel().makePrecise(this._centroid)),this.addInterior(t),null===this._interiorPoint&&this.addEndpoints(t)}static getInteriorPoint(t){return new Ei(t).getInteriorPoint()}add(t){const e=t.distance(this._centroid);e<this._minDistance&&(this._interiorPoint=new m(t),this._minDistance=e)}getInteriorPoint(){return this._interiorPoint}addEndpoints(){if(arguments[0]instanceof j){const t=arguments[0];if(t instanceof tt)this.addEndpoints(t.getCoordinates());else if(t instanceof ut){const e=t;for(let t=0;t<e.getNumGeometries();t++)this.addEndpoints(e.getGeometryN(t))}}else if(arguments[0]instanceof Array){const t=arguments[0];this.add(t[0]),this.add(t[t.length-1])}}addInterior(){if(arguments[0]instanceof j){const t=arguments[0];if(t instanceof tt)this.addInterior(t.getCoordinates());else if(t instanceof ut){const e=t;for(let t=0;t<e.getNumGeometries();t++)this.addInterior(e.getGeometryN(t))}}else if(arguments[0]instanceof Array){const t=arguments[0];for(let e=1;e<t.length-1;e++)this.add(t[e])}}}class Ii{constructor(){Ii.constructor_.apply(this,arguments)}static constructor_(){this._centroid=null,this._minDistance=r.MAX_VALUE,this._interiorPoint=null;const t=arguments[0];this._centroid=gi.getCentroid(t),this.add(t)}static getInteriorPoint(t){return new Ii(t).getInteriorPoint()}add(){if(arguments[0]instanceof j){const t=arguments[0];if(t instanceof Nt)this.add(t.getCoordinate());else if(t instanceof ut){const e=t;for(let t=0;t<e.getNumGeometries();t++)this.add(e.getGeometryN(t))}}else if(arguments[0]instanceof m){const t=arguments[0],e=t.distance(this._centroid);e<this._minDistance&&(this._interiorPoint=new m(t),this._minDistance=e)}}getInteriorPoint(){return this._interiorPoint}}class Ni{constructor(){Ni.constructor_.apply(this,arguments)}static constructor_(){this._input=null,this._extremalPts=null,this._centre=null,this._radius=0;const t=arguments[0];this._input=t}static pointWithMinAngleWithSegment(t,e,s){let n=r.MAX_VALUE,i=null;for(let r=0;r<t.length;r++){const o=t[r];if(o===e)continue;if(o===s)continue;const l=$t.angleBetween(e,o,s);l<n&&(n=l,i=o)}return i}static pointWitMinAngleWithX(t,e){let s=r.MAX_VALUE,n=null;for(let i=0;i<t.length;i++){const r=t[i];if(r===e)continue;const o=r.x-e.x;let l=r.y-e.y;l<0&&(l=-l);const a=l/Math.sqrt(o*o+l*l);a<s&&(s=a,n=r)}return n}static lowestPoint(t){let e=t[0];for(let s=1;s<t.length;s++)t[s].y<e.y&&(e=t[s]);return e}static farthestPoints(t){const e=t[0].distance(t[1]),s=t[1].distance(t[2]),n=t[2].distance(t[0]);return e>=s&&e>=n?[t[0],t[1]]:s>=e&&s>=n?[t[1],t[2]]:[t[2],t[0]]}getRadius(){return this.compute(),this._radius}getDiameter(){switch(this.compute(),this._extremalPts.length){case 0:return this._input.getFactory().createLineString();case 1:return this._input.getFactory().createPoint(this._centre)}const t=this._extremalPts[0],e=this._extremalPts[1];return this._input.getFactory().createLineString([t,e])}getExtremalPoints(){return this.compute(),this._extremalPts}computeCirclePoints(){if(this._input.isEmpty())return this._extremalPts=new Array(0).fill(null),null;if(1===this._input.getNumPoints()){const t=this._input.getCoordinates();return this._extremalPts=[new m(t[0])],null}const t=this._input.convexHull().getCoordinates();let e=t;if(t[0].equals2D(t[t.length-1])&&(e=new Array(t.length-1).fill(null),W.copyDeep(t,0,e,0,t.length-1)),e.length<=2)return this._extremalPts=W.copyDeep(e),null;let s=Ni.lowestPoint(e),n=Ni.pointWitMinAngleWithX(e,s);for(let t=0;t<e.length;t++){const t=Ni.pointWithMinAngleWithSegment(e,s,n);if($t.isObtuse(s,t,n))return this._extremalPts=[new m(s),new m(n)],null;if($t.isObtuse(t,s,n))s=t;else{if(!$t.isObtuse(t,n,s))return this._extremalPts=[new m(s),new m(n),new m(t)],null;n=t}}h.shouldNeverReachHere("Logic failure in Minimum Bounding Circle algorithm!")}compute(){if(null!==this._extremalPts)return null;this.computeCirclePoints(),this.computeCentre(),null!==this._centre&&(this._radius=this._centre.distance(this._extremalPts[0]))}getCircle(){if(this.compute(),null===this._centre)return this._input.getFactory().createPolygon();const t=this._input.getFactory().createPoint(this._centre);return 0===this._radius?t:bn.bufferOp(t,this._radius)}getCentre(){return this.compute(),this._centre}getMaximumDiameter(){switch(this.compute(),this._extremalPts.length){case 0:return this._input.getFactory().createLineString();case 1:return this._input.getFactory().createPoint(this._centre);case 2:return this._input.getFactory().createLineString([this._extremalPts[0],this._extremalPts[1]]);default:const t=Ni.farthestPoints(this._extremalPts);return this._input.getFactory().createLineString(t)}}computeCentre(){switch(this._extremalPts.length){case 0:this._centre=null;break;case 1:this._centre=this._extremalPts[0];break;case 2:this._centre=new m((this._extremalPts[0].x+this._extremalPts[1].x)/2,(this._extremalPts[0].y+this._extremalPts[1].y)/2);break;case 3:this._centre=se.circumcentre(this._extremalPts[0],this._extremalPts[1],this._extremalPts[2])}}}class wi{constructor(){wi.constructor_.apply(this,arguments)}static constructor_(){if(this._inputGeom=null,this._isConvex=null,this._convexHullPts=null,this._minBaseSeg=new Kt,this._minWidthPt=null,this._minPtIndex=null,this._minWidth=0,1===arguments.length){const t=arguments[0];wi.constructor_.call(this,t,!1)}else if(2===arguments.length){const t=arguments[0],e=arguments[1];this._inputGeom=t,this._isConvex=e}}static nextIndex(t,e){return++e>=t.length&&(e=0),e}static computeC(t,e,s){return t*s.y-e*s.x}static getMinimumDiameter(t){return new wi(t).getDiameter()}static getMinimumRectangle(t){return new wi(t).getMinimumRectangle()}static computeSegmentForLine(t,e,s){let n=null,i=null;return Math.abs(e)>Math.abs(t)?(n=new m(0,s/e),i=new m(1,s/e-t/e)):(n=new m(s/t,0),i=new m(s/t-e/t,1)),new Kt(n,i)}getWidthCoordinate(){return this.computeMinimumDiameter(),this._minWidthPt}getSupportingSegment(){return this.computeMinimumDiameter(),this._inputGeom.getFactory().createLineString([this._minBaseSeg.p0,this._minBaseSeg.p1])}getDiameter(){if(this.computeMinimumDiameter(),null===this._minWidthPt)return this._inputGeom.getFactory().createLineString();const t=this._minBaseSeg.project(this._minWidthPt);return this._inputGeom.getFactory().createLineString([t,this._minWidthPt])}computeWidthConvex(t){this._convexHullPts=t instanceof Ct?t.getExteriorRing().getCoordinates():t.getCoordinates(),0===this._convexHullPts.length?(this._minWidth=0,this._minWidthPt=null,this._minBaseSeg=null):1===this._convexHullPts.length?(this._minWidth=0,this._minWidthPt=this._convexHullPts[0],this._minBaseSeg.p0=this._convexHullPts[0],this._minBaseSeg.p1=this._convexHullPts[0]):2===this._convexHullPts.length||3===this._convexHullPts.length?(this._minWidth=0,this._minWidthPt=this._convexHullPts[0],this._minBaseSeg.p0=this._convexHullPts[0],this._minBaseSeg.p1=this._convexHullPts[1]):this.computeConvexRingMinDiameter(this._convexHullPts)}computeConvexRingMinDiameter(t){this._minWidth=r.MAX_VALUE;let e=1;const s=new Kt;for(let n=0;n<t.length-1;n++)s.p0=t[n],s.p1=t[n+1],e=this.findMaxPerpDistance(t,s,e)}findMaxPerpDistance(t,e,s){let n=e.distancePerpendicular(t[s]),i=n,r=s,o=r;for(;i>=n;)n=i,r=o,o=wi.nextIndex(t,r),i=e.distancePerpendicular(t[o]);return n<this._minWidth&&(this._minPtIndex=r,this._minWidth=n,this._minWidthPt=t[this._minPtIndex],this._minBaseSeg=new Kt(e)),r}getMinimumRectangle(){if(this.computeMinimumDiameter(),0===this._minWidth)return this._minBaseSeg.p0.equals2D(this._minBaseSeg.p1)?this._inputGeom.getFactory().createPoint(this._minBaseSeg.p0):this._minBaseSeg.toGeometry(this._inputGeom.getFactory());const t=this._minBaseSeg.p1.x-this._minBaseSeg.p0.x,e=this._minBaseSeg.p1.y-this._minBaseSeg.p0.y;let s=r.MAX_VALUE,n=-r.MAX_VALUE,i=r.MAX_VALUE,o=-r.MAX_VALUE;for(let r=0;r<this._convexHullPts.length;r++){const l=wi.computeC(t,e,this._convexHullPts[r]);l>n&&(n=l),l<s&&(s=l);const a=wi.computeC(-e,t,this._convexHullPts[r]);a>o&&(o=a),a<i&&(i=a)}const l=wi.computeSegmentForLine(-t,-e,o),a=wi.computeSegmentForLine(-t,-e,i),c=wi.computeSegmentForLine(-e,t,n),h=wi.computeSegmentForLine(-e,t,s),u=c.lineIntersection(l),g=h.lineIntersection(l),d=h.lineIntersection(a),_=c.lineIntersection(a),p=this._inputGeom.getFactory().createLinearRing([u,g,d,_,u]);return this._inputGeom.getFactory().createPolygon(p)}computeMinimumDiameter(){if(null!==this._minWidthPt)return null;if(this._isConvex)this.computeWidthConvex(this._inputGeom);else{const t=new _i(this._inputGeom).getConvexHull();this.computeWidthConvex(t)}}getLength(){return this.computeMinimumDiameter(),this._minWidth}}var Ci=Object.freeze({__proto__:null,Angle:$t,Area:wt,Centroid:gi,ConvexHull:_i,Distance:V,InteriorPointArea:mi,InteriorPointLine:Ei,InteriorPointPoint:Ii,Length:k,MinimumBoundingCircle:Ni,MinimumDiameter:wi,Orientation:q,PointLocation:Ue,PointLocator:Zn,RobustLineIntersector:jt,distance:be,locate:je,match:ui});class Si{constructor(){Si.constructor_.apply(this,arguments)}static constructor_(){this._inputGeom=null,this._distanceTolerance=null;const t=arguments[0];this._inputGeom=t}static densify(t,e){const s=new Si(t);return s.setDistanceTolerance(e),s.getResultGeometry()}static densifyPoints(t,e,s){const n=new Kt,i=new R;for(let r=0;r<t.length-1;r++){n.p0=t[r],n.p1=t[r+1],i.add(n.p0,!1);const o=n.getLength(),l=Math.trunc(o/e)+1;if(l>1){const t=o/l;for(let e=1;e<l;e++){const r=e*t/o,l=n.pointAlong(r);s.makePrecise(l),i.add(l,!1)}}}return i.add(t[t.length-1],!1),i.toCoordinateArray()}setDistanceTolerance(t){if(t<=0)throw new n("Tolerance must be positive");this._distanceTolerance=t}getResultGeometry(){return new Li(this._distanceTolerance).transform(this._inputGeom)}}class Li extends me{constructor(){super(),Li.constructor_.apply(this,arguments)}static constructor_(){this.distanceTolerance=null;const t=arguments[0];this.distanceTolerance=t}transformCoordinates(t,e){const s=t.toCoordinateArray();let n=Si.densifyPoints(s,this.distanceTolerance,e.getPrecisionModel());return e instanceof tt&&1===n.length&&(n=new Array(0).fill(null)),this._factory.getCoordinateSequenceFactory().create(n)}transformPolygon(t,e){const s=super.transformPolygon.call(this,t,e);return e instanceof dt?s:this.createValidArea(s)}createValidArea(t){return bn.bufferOp(t,0)}transformMultiPolygon(t,e){const s=super.transformMultiPolygon.call(this,t,e);return this.createValidArea(s)}}Si.DensifyTransformer=Li;var Ti=Object.freeze({__proto__:null,Densifier:Si});class Ri{constructor(){Ri.constructor_.apply(this,arguments)}static constructor_(){this._orig=null,this._sym=null,this._next=null;const t=arguments[0];this._orig=t}static create(t,e){const s=new Ri(t),n=new Ri(e);return s.link(n),s}oNext(){return this._sym._next}directionY(){return this.directionPt().getY()-this._orig.getY()}equals(){if(2===arguments.length&&arguments[1]instanceof m&&arguments[0]instanceof m){const t=arguments[0],e=arguments[1];return this._orig.equals2D(t)&&this._sym._orig.equals(e)}}findLowest(){let t=this,e=this.oNext();do{e.compareTo(t)<0&&(t=e),e=e.oNext()}while(e!==this);return t}compareTo(t){const e=t;return this.compareAngularDirection(e)}toStringNode(){const t=this.orig();this.dest();const e=new nt;e.append("Node( "+Wt.format(t)+" )\n");let s=this;do{e.append("  -> "+s),e.append("\n"),s=s.oNext()}while(s!==this);return e.toString()}link(t){this.setSym(t),t.setSym(this),this.setNext(t),t.setNext(this)}orig(){return this._orig}setNext(t){this._next=t}find(t){let e=this;do{if(null===e)return null;if(e.dest().equals2D(t))return e;e=e.oNext()}while(e!==this);return null}dest(){return this._sym._orig}isEdgesSorted(){const t=this.findLowest();let e=t;do{const s=e.oNext();if(s===t)break;if(!(s.compareTo(e)>0))return!1;e=s}while(e!==t);return!0}insert(t){if(this.oNext()===this)return this.insertAfter(t),null;this.insertionEdge(t).insertAfter(t)}insertAfter(t){h.equals(this._orig,t.orig());const e=this.oNext();this._sym.setNext(t),t.sym().setNext(e)}degree(){let t=0,e=this;do{t++,e=e.oNext()}while(e!==this);return t}directionPt(){return this.dest()}sym(){return this._sym}prev(){return this._sym.next()._sym}compareAngularDirection(t){const e=this.directionX(),s=this.directionY(),n=t.directionX(),i=t.directionY();if(e===n&&s===i)return 0;const r=Ds.quadrant(e,s),o=Ds.quadrant(n,i);if(r>o)return 1;if(r<o)return-1;const l=this.directionPt(),a=t.directionPt();return q.index(t._orig,a,l)}prevNode(){let t=this;for(;2===t.degree();)if(t=t.prev(),t===this)return null;return t}directionX(){return this.directionPt().getX()-this._orig.getX()}insertionEdge(t){let e=this;do{const s=e.oNext();if(s.compareTo(e)>0&&t.compareTo(e)>=0&&t.compareTo(s)<=0)return e;if(s.compareTo(e)<=0&&(t.compareTo(s)<=0||t.compareTo(e)>=0))return e;e=s}while(e!==this);return h.shouldNeverReachHere(),null}next(){return this._next}setSym(t){this._sym=t}toString(){return"HE("+this._orig.x+" "+this._orig.y+", "+this._sym._orig.x+" "+this._sym._orig.y+")"}toStringNodeEdge(){return"  -> ("+Wt.format(this.dest())}}class Pi extends Ri{constructor(){super(),Pi.constructor_.apply(this,arguments)}static constructor_(){this._isMarked=!1;const t=arguments[0];Ri.constructor_.call(this,t)}static setMarkBoth(t,e){t.setMark(e),t.sym().setMark(e)}static isMarked(t){return t.isMarked()}static setMark(t,e){t.setMark(e)}static markBoth(t){t.mark(),t.sym().mark()}static mark(t){t.mark()}setMark(t){this._isMarked=t}mark(){this._isMarked=!0}isMarked(){return this._isMarked}}class Oi{constructor(){Oi.constructor_.apply(this,arguments)}static constructor_(){this._vertexMap=new ft}static isValidEdge(t,e){return 0!==e.compareTo(t)}insert(t,e,s){const n=this.create(t,e);null!==s?s.insert(n):this._vertexMap.put(t,n);const i=this._vertexMap.get(e);return null!==i?i.insert(n.sym()):this._vertexMap.put(e,n.sym()),n}create(t,e){const s=this.createEdge(t),n=this.createEdge(e);return s.link(n),s}createEdge(t){return new Ri(t)}addEdge(t,e){if(!Oi.isValidEdge(t,e))return null;const s=this._vertexMap.get(t);let n=null;if(null!==s&&(n=s.find(e)),null!==n)return n;return this.insert(t,e,s)}getVertexEdges(){return this._vertexMap.values()}findEdge(t,e){const s=this._vertexMap.get(t);return null===s?null:s.find(e)}}class vi extends Pi{constructor(){super(),vi.constructor_.apply(this,arguments)}static constructor_(){this._isStart=!1;const t=arguments[0];Pi.constructor_.call(this,t)}setStart(){this._isStart=!0}isStart(){return this._isStart}}class Mi extends Oi{constructor(){super()}createEdge(t){return new vi(t)}}class bi{constructor(){bi.constructor_.apply(this,arguments)}static constructor_(){this._result=null,this._factory=null,this._graph=null,this._lines=new L,this._nodeEdgeStack=new Zs,this._ringStartEdge=null,this._graph=new Mi}static dissolve(t){const e=new bi;return e.add(t),e.getResult()}addLine(t){this._lines.add(this._factory.createLineString(t.toCoordinateArray()))}updateRingStartEdge(t){return t.isStart()||(t=t.sym()).isStart()?null===this._ringStartEdge?(this._ringStartEdge=t,null):void(t.orig().compareTo(this._ringStartEdge.orig())<0&&(this._ringStartEdge=t)):null}getResult(){return null===this._result&&this.computeResult(),this._result}process(t){let e=t.prevNode();null===e&&(e=t),this.stackEdges(e),this.buildLines()}stackEdges(t){let e=t;do{Pi.isMarked(e)||this._nodeEdgeStack.add(e),e=e.oNext()}while(e!==t)}computeResult(){for(let t=this._graph.getVertexEdges().iterator();t.hasNext();){const e=t.next();Pi.isMarked(e)||this.process(e)}this._result=this._factory.buildGeometry(this._lines)}buildLines(){for(;!this._nodeEdgeStack.empty();){const t=this._nodeEdgeStack.pop();Pi.isMarked(t)||this.buildLine(t)}}add(){if(arguments[0]instanceof j){arguments[0].apply(new class{get interfaces_(){return[X]}filter(t){t instanceof tt&&this.add(t)}})}else if(I(arguments[0],N)){for(let t=arguments[0].iterator();t.hasNext();){const e=t.next();this.add(e)}}else if(arguments[0]instanceof tt){const t=arguments[0];null===this._factory&&(this._factory=t.getFactory());const e=t.getCoordinateSequence();let s=!1;for(let t=1;t<e.size();t++){const n=this._graph.addEdge(e.getCoordinate(t-1),e.getCoordinate(t));null!==n&&(s||(n.setStart(),s=!0))}}}buildRing(t){const e=new R;let s=t;for(e.add(s.orig().copy(),!1);2===s.sym().degree();){const n=s.next();if(n===t)break;e.add(n.orig().copy(),!1),s=n}e.add(s.dest().copy(),!1),this.addLine(e)}buildLine(t){const e=new R;let s=t;for(this._ringStartEdge=null,Pi.markBoth(s),e.add(s.orig().copy(),!1);2===s.sym().degree();){this.updateRingStartEdge(s);const n=s.next();if(n===t)return this.buildRing(this._ringStartEdge),null;e.add(n.orig().copy(),!1),s=n,Pi.markBoth(s)}e.add(s.dest().clone(),!1),this.stackEdges(s.sym()),this.addLine(e)}}var Di=Object.freeze({__proto__:null,LineDissolver:bi}),Ai=Object.freeze({__proto__:null,GeometryGraph:ii});class Fi{visit(t){}}class Gi{constructor(){Gi.constructor_.apply(this,arguments)}static constructor_(){if(this._p=null,this._data=null,this._left=null,this._right=null,this._count=null,2===arguments.length){const t=arguments[0],e=arguments[1];this._p=new m(t),this._left=null,this._right=null,this._count=1,this._data=e}else if(3===arguments.length){const t=arguments[0],e=arguments[1],s=arguments[2];this._p=new m(t,e),this._left=null,this._right=null,this._count=1,this._data=s}}isRepeated(){return this._count>1}getRight(){return this._right}getCoordinate(){return this._p}setLeft(t){this._left=t}getX(){return this._p.x}getData(){return this._data}getCount(){return this._count}increment(){this._count=this._count+1}setRight(t){this._right=t}getLeft(){return this._left}getY(){return this._p.y}}class qi{constructor(){qi.constructor_.apply(this,arguments)}static constructor_(){if(this._root=null,this._numberOfNodes=null,this._tolerance=null,0===arguments.length)qi.constructor_.call(this,0);else if(1===arguments.length){const t=arguments[0];this._tolerance=t}}static toCoordinates(){if(1===arguments.length){const t=arguments[0];return qi.toCoordinates(t,!1)}if(2===arguments.length){const t=arguments[0],e=arguments[1],s=new R;for(let n=t.iterator();n.hasNext();){const t=n.next(),i=e?t.getCount():1;for(let e=0;e<i;e++)s.add(t.getCoordinate(),!0)}return s.toCoordinateArray()}}insert(){if(1===arguments.length){const t=arguments[0];return this.insert(t,null)}if(2===arguments.length){const t=arguments[0],e=arguments[1];if(null===this._root)return this._root=new Gi(t,e),this._root;if(this._tolerance>0){const e=this.findBestMatchNode(t);if(null!==e)return e.increment(),e}return this.insertExact(t,e)}}query(){if(1===arguments.length){const t=arguments[0],e=new L;return this.query(t,e),e}if(2===arguments.length)if(arguments[0]instanceof O&&I(arguments[1],C)){const t=arguments[0],e=arguments[1];this.queryNode(this._root,t,!0,new class{get interfaces_(){return[Fi]}visit(t){e.add(t)}})}else if(arguments[0]instanceof O&&I(arguments[1],Fi)){const t=arguments[0],e=arguments[1];this.queryNode(this._root,t,!0,e)}}queryNode(t,e,s,n){if(null===t)return null;let i=null,r=null,o=null;s?(i=e.getMinX(),r=e.getMaxX(),o=t.getX()):(i=e.getMinY(),r=e.getMaxY(),o=t.getY());const l=o<=r;i<o&&this.queryNode(t.getLeft(),e,!s,n),e.contains(t.getCoordinate())&&n.visit(t),l&&this.queryNode(t.getRight(),e,!s,n)}findBestMatchNode(t){const e=new Bi(t,this._tolerance);return this.query(e.queryEnvelope(),e),e.getNode()}isEmpty(){return null===this._root}insertExact(t,e){let s=this._root,n=this._root,i=!0,r=!0;for(;null!==s;){if(null!==s){if(t.distance(s.getCoordinate())<=this._tolerance)return s.increment(),s}r=i?t.x<s.getX():t.y<s.getY(),n=s,s=r?s.getLeft():s.getRight(),i=!i}this._numberOfNodes=this._numberOfNodes+1;const o=new Gi(t,e);return r?n.setLeft(o):n.setRight(o),o}}class Bi{constructor(){Bi.constructor_.apply(this,arguments)}static constructor_(){this._tolerance=null,this._matchNode=null,this._matchDist=0,this._p=null;const t=arguments[0],e=arguments[1];this._p=t,this._tolerance=e}queryEnvelope(){const t=new O(this._p);return t.expandBy(this._tolerance),t}getNode(){return this._matchNode}visit(t){const e=this._p.distance(t.getCoordinate());if(!(e<=this._tolerance))return null;let s=!1;(null===this._matchNode||e<this._matchDist||null!==this._matchNode&&e===this._matchDist&&t.getCoordinate().compareTo(this._matchNode.getCoordinate())<1)&&(s=!0),s&&(this._matchNode=t,this._matchDist=e)}get interfaces_(){return[Fi]}}qi.BestMatchVisitor=Bi;var Yi=Object.freeze({__proto__:null,KdTree:qi});class zi{constructor(){zi.constructor_.apply(this,arguments)}static constructor_(){this._items=new L,this._subnode=new Array(4).fill(null)}static getSubnodeIndex(t,e,s){let n=-1;return t.getMinX()>=e&&(t.getMinY()>=s&&(n=3),t.getMaxY()<=s&&(n=1)),t.getMaxX()<=e&&(t.getMinY()>=s&&(n=2),t.getMaxY()<=s&&(n=0)),n}size(){let t=0;for(let e=0;e<4;e++)null!==this._subnode[e]&&(t+=this._subnode[e].size());return t+this._items.size()}addAllItemsFromOverlapping(t,e){if(!this.isSearchMatch(t))return null;e.addAll(this._items);for(let s=0;s<4;s++)null!==this._subnode[s]&&this._subnode[s].addAllItemsFromOverlapping(t,e)}visitItems(t,e){for(let t=this._items.iterator();t.hasNext();)e.visitItem(t.next())}hasItems(){return!this._items.isEmpty()}remove(t,e){if(!this.isSearchMatch(t))return!1;let s=!1;for(let n=0;n<4;n++)if(null!==this._subnode[n]&&(s=this._subnode[n].remove(t,e),s)){this._subnode[n].isPrunable()&&(this._subnode[n]=null);break}return s||(s=this._items.remove(e),s)}visit(t,e){if(!this.isSearchMatch(t))return null;this.visitItems(t,e);for(let s=0;s<4;s++)null!==this._subnode[s]&&this._subnode[s].visit(t,e)}getItems(){return this._items}depth(){let t=0;for(let e=0;e<4;e++)if(null!==this._subnode[e]){const s=this._subnode[e].depth();s>t&&(t=s)}return t+1}hasChildren(){for(let t=0;t<4;t++)if(null!==this._subnode[t])return!0;return!1}isPrunable(){return!(this.hasChildren()||this.hasItems())}addAllItems(t){t.addAll(this._items);for(let e=0;e<4;e++)null!==this._subnode[e]&&this._subnode[e].addAllItems(t);return t}getNodeCount(){let t=0;for(let e=0;e<4;e++)null!==this._subnode[e]&&(t+=this._subnode[e].size());return t+1}isEmpty(){let t=!0;if(this._items.isEmpty()){for(let e=0;e<4;e++)if(null!==this._subnode[e]&&!this._subnode[e].isEmpty()){t=!1;break}}else t=!1;return t}add(t){this._items.add(t)}get interfaces_(){return[l]}}function Vi(){}Vi.exponent=function(t){return function(t,e){let s,n,i,r;const o={64:{d:32752,c:0,b:0,a:0}},l={64:11}[t];r||(s=e<0||1/e<0,isFinite(e)||(r=o[t],s&&(r.d+=1<<t/4-1),n=Math.pow(2,l)-1,i=0));if(!r){for(n={64:1023}[t],i=Math.abs(e);i>=2;)n++,i/=2;for(;i<1&&n>0;)n--,i*=2;n<=0&&(i/=2)}return n}(64,t)-1023},Vi.powerOf2=function(t){return Math.pow(2,t)};class ki{constructor(){ki.constructor_.apply(this,arguments)}static constructor_(){this._pt=new m,this._level=0,this._env=null;const t=arguments[0];this.computeKey(t)}static computeQuadLevel(t){const e=t.getWidth(),s=t.getHeight(),n=e>s?e:s;return Vi.exponent(n)+1}getLevel(){return this._level}computeKey(){if(1===arguments.length){const t=arguments[0];for(this._level=ki.computeQuadLevel(t),this._env=new O,this.computeKey(this._level,t);!this._env.contains(t);)this._level+=1,this.computeKey(this._level,t)}else if(2===arguments.length){const t=arguments[0],e=arguments[1],s=Vi.powerOf2(t);this._pt.x=Math.floor(e.getMinX()/s)*s,this._pt.y=Math.floor(e.getMinY()/s)*s,this._env.init(this._pt.x,this._pt.x+s,this._pt.y,this._pt.y+s)}}getEnvelope(){return this._env}getCentre(){return new m((this._env.getMinX()+this._env.getMaxX())/2,(this._env.getMinY()+this._env.getMaxY())/2)}getPoint(){return this._pt}}let Xi=class t extends zi{constructor(){super(),t.constructor_.apply(this,arguments)}static constructor_(){this._env=null,this._centrex=null,this._centrey=null,this._level=null;const t=arguments[0],e=arguments[1];this._env=t,this._level=e,this._centrex=(t.getMinX()+t.getMaxX())/2,this._centrey=(t.getMinY()+t.getMaxY())/2}static createNode(e){const s=new ki(e);return new t(s.getEnvelope(),s.getLevel())}static createExpanded(e,s){const n=new O(s);null!==e&&n.expandToInclude(e._env);const i=t.createNode(n);return null!==e&&i.insertNode(e),i}find(t){const e=zi.getSubnodeIndex(t,this._centrex,this._centrey);if(-1===e)return this;if(null!==this._subnode[e]){return this._subnode[e].find(t)}return this}isSearchMatch(t){return null!==t&&this._env.intersects(t)}getSubnode(t){return null===this._subnode[t]&&(this._subnode[t]=this.createSubnode(t)),this._subnode[t]}getEnvelope(){return this._env}getNode(t){const e=zi.getSubnodeIndex(t,this._centrex,this._centrey);if(-1!==e){return this.getSubnode(e).getNode(t)}return this}createSubnode(e){let s=0,n=0,i=0,r=0;switch(e){case 0:s=this._env.getMinX(),n=this._centrex,i=this._env.getMinY(),r=this._centrey;break;case 1:s=this._centrex,n=this._env.getMaxX(),i=this._env.getMinY(),r=this._centrey;break;case 2:s=this._env.getMinX(),n=this._centrex,i=this._centrey,r=this._env.getMaxY();break;case 3:s=this._centrex,n=this._env.getMaxX(),i=this._centrey,r=this._env.getMaxY()}const o=new O(s,n,i,r);return new t(o,this._level-1)}insertNode(t){h.isTrue(null===this._env||this._env.contains(t._env));const e=zi.getSubnodeIndex(t._env,this._centrex,this._centrey);if(t._level===this._level-1)this._subnode[e]=t;else{const s=this.createSubnode(e);s.insertNode(t),this._subnode[e]=s}}};class Ui{static isZeroWidth(t,e){const s=e-t;if(0===s)return!0;const n=s/Math.max(Math.abs(t),Math.abs(e));return Vi.exponent(n)<=Ui.MIN_BINARY_EXPONENT}}Ui.MIN_BINARY_EXPONENT=-50;class Hi extends zi{constructor(){super()}insertContained(t,e,s){h.isTrue(t.getEnvelope().contains(e));const n=Ui.isZeroWidth(e.getMinX(),e.getMaxX()),i=Ui.isZeroWidth(e.getMinY(),e.getMaxY());let r=null;r=n||i?t.find(e):t.getNode(e),r.add(s)}isSearchMatch(t){return!0}insert(t,e){const s=zi.getSubnodeIndex(t,Hi.origin.x,Hi.origin.y);if(-1===s)return this.add(e),null;const n=this._subnode[s];if(null===n||!n.getEnvelope().contains(t)){const e=Xi.createExpanded(n,t);this._subnode[s]=e}this.insertContained(this._subnode[s],t,e)}}Hi.origin=new m(0,0);class Wi{constructor(){Wi.constructor_.apply(this,arguments)}static constructor_(){this._root=null,this._minExtent=1,this._root=new Hi}static ensureExtent(t,e){let s=t.getMinX(),n=t.getMaxX(),i=t.getMinY(),r=t.getMaxY();return s!==n&&i!==r?t:(s===n&&(s-=e/2,n+=e/2),i===r&&(i-=e/2,r+=e/2),new O(s,n,i,r))}size(){return null!==this._root?this._root.size():0}insert(t,e){this.collectStats(t);const s=Wi.ensureExtent(t,this._minExtent);this._root.insert(s,e)}query(){if(1===arguments.length){const t=arguments[0],e=new Ye;return this.query(t,e),e.getItems()}if(2===arguments.length){const t=arguments[0],e=arguments[1];this._root.visit(t,e)}}queryAll(){const t=new L;return this._root.addAllItems(t),t}remove(t,e){const s=Wi.ensureExtent(t,this._minExtent);return this._root.remove(s,e)}collectStats(t){const e=t.getWidth();e<this._minExtent&&e>0&&(this._minExtent=e);const s=t.getHeight();s<this._minExtent&&s>0&&(this._minExtent=s)}depth(){return null!==this._root?this._root.depth():0}isEmpty(){return null===this._root||this._root.isEmpty()}get interfaces_(){return[Cs,l]}}var Zi=Object.freeze({__proto__:null,Quadtree:Wi}),ji=Object.freeze({__proto__:null,STRtree:Os}),Ki=Object.freeze({__proto__:null,kdtree:Yi,quadtree:Zi,strtree:ji});const Qi=["Point","MultiPoint","LineString","MultiLineString","Polygon","MultiPolygon"];class Ji{constructor(t){this.geometryFactory=t||new Lt}read(t){let e;e="string"==typeof t?JSON.parse(t):t;const s=e.type;if(!$i[s])throw new Error("Unknown GeoJSON type: "+e.type);return-1!==Qi.indexOf(s)?$i[s].call(this,e.coordinates):"GeometryCollection"===s?$i[s].call(this,e.geometries):$i[s].call(this,e)}write(t){const e=t.getGeometryType();if(!tr[e])throw new Error("Geometry is not supported");return tr[e].call(this,t)}}const $i={Feature:function(t){const e={};for(const s in t)e[s]=t[s];if(t.geometry){const s=t.geometry.type;if(!$i[s])throw new Error("Unknown GeoJSON type: "+t.type);e.geometry=this.read(t.geometry)}return t.bbox&&(e.bbox=$i.bbox.call(this,t.bbox)),e},FeatureCollection:function(t){const e={};if(t.features){e.features=[];for(let s=0;s<t.features.length;++s)e.features.push(this.read(t.features[s]))}return t.bbox&&(e.bbox=this.parse.bbox.call(this,t.bbox)),e},coordinates:function(t){const e=[];for(let s=0;s<t.length;++s){const n=t[s];e.push(new m(...n))}return e},bbox:function(t){return this.geometryFactory.createLinearRing([new m(t[0],t[1]),new m(t[2],t[1]),new m(t[2],t[3]),new m(t[0],t[3]),new m(t[0],t[1])])},Point:function(t){const e=new m(...t);return this.geometryFactory.createPoint(e)},MultiPoint:function(t){const e=[];for(let s=0;s<t.length;++s)e.push($i.Point.call(this,t[s]));return this.geometryFactory.createMultiPoint(e)},LineString:function(t){const e=$i.coordinates.call(this,t);return this.geometryFactory.createLineString(e)},MultiLineString:function(t){const e=[];for(let s=0;s<t.length;++s)e.push($i.LineString.call(this,t[s]));return this.geometryFactory.createMultiLineString(e)},Polygon:function(t){const e=$i.coordinates.call(this,t[0]),s=this.geometryFactory.createLinearRing(e),n=[];for(let e=1;e<t.length;++e){const s=t[e],i=$i.coordinates.call(this,s),r=this.geometryFactory.createLinearRing(i);n.push(r)}return this.geometryFactory.createPolygon(s,n)},MultiPolygon:function(t){const e=[];for(let s=0;s<t.length;++s){const n=t[s];e.push($i.Polygon.call(this,n))}return this.geometryFactory.createMultiPolygon(e)},GeometryCollection:function(t){const e=[];for(let s=0;s<t.length;++s){const n=t[s];e.push(this.read(n))}return this.geometryFactory.createGeometryCollection(e)}},tr={coordinate:function(t){const e=[t.x,t.y];return t.z&&e.push(t.z),t.m&&e.push(t.m),e},Point:function(t){return{type:"Point",coordinates:tr.coordinate.call(this,t.getCoordinate())}},MultiPoint:function(t){const e=[];for(let s=0;s<t._geometries.length;++s){const n=t._geometries[s],i=tr.Point.call(this,n);e.push(i.coordinates)}return{type:"MultiPoint",coordinates:e}},LineString:function(t){const e=[],s=t.getCoordinates();for(let t=0;t<s.length;++t){const n=s[t];e.push(tr.coordinate.call(this,n))}return{type:"LineString",coordinates:e}},MultiLineString:function(t){const e=[];for(let s=0;s<t._geometries.length;++s){const n=t._geometries[s],i=tr.LineString.call(this,n);e.push(i.coordinates)}return{type:"MultiLineString",coordinates:e}},Polygon:function(t){const e=[],s=tr.LineString.call(this,t._shell);e.push(s.coordinates);for(let s=0;s<t._holes.length;++s){const n=t._holes[s],i=tr.LineString.call(this,n);e.push(i.coordinates)}return{type:"Polygon",coordinates:e}},MultiPolygon:function(t){const e=[];for(let s=0;s<t._geometries.length;++s){const n=t._geometries[s],i=tr.Polygon.call(this,n);e.push(i.coordinates)}return{type:"MultiPolygon",coordinates:e}},GeometryCollection:function(t){const e=[];for(let s=0;s<t._geometries.length;++s){const n=t._geometries[s],i=n.getGeometryType();e.push(tr[i].call(this,n))}return{type:"GeometryCollection",geometries:e}}};function er(t){return[t.x,t.y]}var sr=Object.freeze({__proto__:null,GeoJSONReader:class{constructor(t){this.parser=new Ji(t||new Lt)}read(t){return this.parser.read(t)}},GeoJSONWriter:class{constructor(){this.parser=new Ji(this.geometryFactory)}write(t){return this.parser.write(t)}},OL3Parser:class{constructor(t,e){this.geometryFactory=t||new Lt,this.ol=e||"undefined"!=typeof ol&&ol}inject(t,e,s,n,i,r,o,l){this.ol={geom:{Point:t,LineString:e,LinearRing:s,Polygon:n,MultiPoint:i,MultiLineString:r,MultiPolygon:o,GeometryCollection:l}}}read(t){const e=this.ol;return t instanceof e.geom.Point?this.convertFromPoint(t):t instanceof e.geom.LineString?this.convertFromLineString(t):t instanceof e.geom.LinearRing?this.convertFromLinearRing(t):t instanceof e.geom.Polygon?this.convertFromPolygon(t):t instanceof e.geom.MultiPoint?this.convertFromMultiPoint(t):t instanceof e.geom.MultiLineString?this.convertFromMultiLineString(t):t instanceof e.geom.MultiPolygon?this.convertFromMultiPolygon(t):t instanceof e.geom.GeometryCollection?this.convertFromCollection(t):void 0}convertFromPoint(t){const e=t.getCoordinates();return this.geometryFactory.createPoint(new m(e[0],e[1]))}convertFromLineString(t){return this.geometryFactory.createLineString(t.getCoordinates().map((function(t){return new m(t[0],t[1])})))}convertFromLinearRing(t){return this.geometryFactory.createLinearRing(t.getCoordinates().map((function(t){return new m(t[0],t[1])})))}convertFromPolygon(t){const e=t.getLinearRings();let s=null;const n=[];for(let t=0;t<e.length;t++){const i=this.convertFromLinearRing(e[t]);0===t?s=i:n.push(i)}return this.geometryFactory.createPolygon(s,n)}convertFromMultiPoint(t){const e=t.getPoints().map((function(t){return this.convertFromPoint(t)}),this);return this.geometryFactory.createMultiPoint(e)}convertFromMultiLineString(t){const e=t.getLineStrings().map((function(t){return this.convertFromLineString(t)}),this);return this.geometryFactory.createMultiLineString(e)}convertFromMultiPolygon(t){const e=t.getPolygons().map((function(t){return this.convertFromPolygon(t)}),this);return this.geometryFactory.createMultiPolygon(e)}convertFromCollection(t){const e=t.getGeometries().map((function(t){return this.read(t)}),this);return this.geometryFactory.createGeometryCollection(e)}write(t){return"Point"===t.getGeometryType()?this.convertToPoint(t.getCoordinate()):"LineString"===t.getGeometryType()?this.convertToLineString(t):"LinearRing"===t.getGeometryType()?this.convertToLinearRing(t):"Polygon"===t.getGeometryType()?this.convertToPolygon(t):"MultiPoint"===t.getGeometryType()?this.convertToMultiPoint(t):"MultiLineString"===t.getGeometryType()?this.convertToMultiLineString(t):"MultiPolygon"===t.getGeometryType()?this.convertToMultiPolygon(t):"GeometryCollection"===t.getGeometryType()?this.convertToCollection(t):void 0}convertToPoint(t){return new this.ol.geom.Point([t.x,t.y])}convertToLineString(t){const e=t._points._coordinates.map(er);return new this.ol.geom.LineString(e)}convertToLinearRing(t){const e=t._points._coordinates.map(er);return new this.ol.geom.LinearRing(e)}convertToPolygon(t){const e=[t._shell._points._coordinates.map(er)];for(let s=0;s<t._holes.length;s++)e.push(t._holes[s]._points._coordinates.map(er));return new this.ol.geom.Polygon(e)}convertToMultiPoint(t){return new this.ol.geom.MultiPoint(t.getCoordinates().map(er))}convertToMultiLineString(t){const e=[];for(let s=0;s<t._geometries.length;s++)e.push(this.convertToLineString(t._geometries[s]).getCoordinates());return new this.ol.geom.MultiLineString(e)}convertToMultiPolygon(t){const e=[];for(let s=0;s<t._geometries.length;s++)e.push(this.convertToPolygon(t._geometries[s]).getCoordinates());return new this.ol.geom.MultiPolygon(e)}convertToCollection(t){const e=[];for(let s=0;s<t._geometries.length;s++){const n=t._geometries[s];e.push(this.write(n))}return new this.ol.geom.GeometryCollection(e)}},WKTReader:class{constructor(t){this.parser=new Ht(t||new Lt)}read(t){return this.parser.read(t)}},WKTWriter:Wt}),nr=Object.freeze({__proto__:null,MCIndexNoder:Gs,ScaledNoder:ds,SegmentString:cs});class ir{constructor(){ir.constructor_.apply(this,arguments)}static constructor_(){if(this._geom=null,this._geomFact=null,this._bnRule=null,this._endpointMap=null,1===arguments.length){const t=arguments[0];ir.constructor_.call(this,t,kn.MOD2_BOUNDARY_RULE)}else if(2===arguments.length){const t=arguments[0],e=arguments[1];this._geom=t,this._geomFact=t.getFactory(),this._bnRule=e}}static getBoundary(){if(1===arguments.length){return new ir(arguments[0]).getBoundary()}if(2===arguments.length){return new ir(arguments[0],arguments[1]).getBoundary()}}boundaryMultiLineString(t){if(this._geom.isEmpty())return this.getEmptyMultiPoint();const e=this.computeBoundaryCoordinates(t);return 1===e.length?this._geomFact.createPoint(e[0]):this._geomFact.createMultiPointFromCoords(e)}getBoundary(){return this._geom instanceof tt?this.boundaryLineString(this._geom):this._geom instanceof Et?this.boundaryMultiLineString(this._geom):this._geom.getBoundary()}boundaryLineString(t){if(this._geom.isEmpty())return this.getEmptyMultiPoint();if(t.isClosed()){return this._bnRule.isInBoundary(2)?t.getStartPoint():this._geomFact.createMultiPoint()}return this._geomFact.createMultiPoint([t.getStartPoint(),t.getEndPoint()])}getEmptyMultiPoint(){return this._geomFact.createMultiPoint()}computeBoundaryCoordinates(t){const e=new L;this._endpointMap=new os;for(let e=0;e<t.getNumGeometries();e++){const s=t.getGeometryN(e);0!==s.getNumPoints()&&(this.addEndpoint(s.getCoordinateN(0)),this.addEndpoint(s.getCoordinateN(s.getNumPoints()-1)))}for(let t=this._endpointMap.entrySet().iterator();t.hasNext();){const s=t.next(),n=s.getValue().count;this._bnRule.isInBoundary(n)&&e.add(s.getKey())}return W.toCoordinateArray(e)}addEndpoint(t){let e=this._endpointMap.get(t);null===e&&(e=new rr,this._endpointMap.put(t,e)),e.count++}}let rr=class t{constructor(){t.constructor_.apply(this,arguments)}static constructor_(){this.count=null}};class or{constructor(){or.constructor_.apply(this,arguments)}static constructor_(){if(this._inputGeom=null,this._isClosedEndpointsInInterior=!0,this._nonSimpleLocation=null,1===arguments.length){const t=arguments[0];this._inputGeom=t}else if(2===arguments.length){const t=arguments[0],e=arguments[1];this._inputGeom=t,this._isClosedEndpointsInInterior=!e.isInBoundary(2)}}static isSimple(){if(1===arguments.length){return new or(arguments[0]).isSimple()}if(2===arguments.length){return new or(arguments[0],arguments[1]).isSimple()}}isSimpleMultiPoint(t){if(t.isEmpty())return!0;const e=new at;for(let s=0;s<t.getNumGeometries();s++){const n=t.getGeometryN(s).getCoordinate();if(e.contains(n))return this._nonSimpleLocation=n,!1;e.add(n)}return!0}isSimplePolygonal(t){for(let e=ye.getLines(t).iterator();e.hasNext();){const t=e.next();if(!this.isSimpleLinearGeometry(t))return!1}return!0}hasClosedEndpointIntersection(t){const e=new os;for(let s=t.getEdgeIterator();s.hasNext();){const t=s.next(),n=t.isClosed(),i=t.getCoordinate(0);this.addEndpoint(e,i,n);const r=t.getCoordinate(t.getNumPoints()-1);this.addEndpoint(e,r,n)}for(let t=e.values().iterator();t.hasNext();){const e=t.next();if(e.isClosed&&2!==e.degree)return this._nonSimpleLocation=e.getCoordinate(),!0}return!1}getNonSimpleLocation(){return this._nonSimpleLocation}isSimpleLinearGeometry(t){if(t.isEmpty())return!0;const e=new ii(0,t),s=new jt,n=e.computeSelfNodes(s,!0);return!n.hasIntersection()||(n.hasProperIntersection()?(this._nonSimpleLocation=n.getProperIntersectionPoint(),!1):!this.hasNonEndpointIntersection(e)&&(!this._isClosedEndpointsInInterior||!this.hasClosedEndpointIntersection(e)))}hasNonEndpointIntersection(t){for(let e=t.getEdgeIterator();e.hasNext();){const t=e.next(),s=t.getMaximumSegmentIndex();for(let e=t.getEdgeIntersectionList().iterator();e.hasNext();){const t=e.next();if(!t.isEndPoint(s))return this._nonSimpleLocation=t.getCoordinate(),!0}}return!1}addEndpoint(t,e,s){let n=t.get(e);null===n&&(n=new lr(e),t.put(e,n)),n.addEndpoint(s)}computeSimple(t){return this._nonSimpleLocation=null,!!t.isEmpty()||(t instanceof tt||t instanceof Et?this.isSimpleLinearGeometry(t):t instanceof St?this.isSimpleMultiPoint(t):I(t,gt)?this.isSimplePolygonal(t):!(t instanceof ut)||this.isSimpleGeometryCollection(t))}isSimple(){return this._nonSimpleLocation=null,this.computeSimple(this._inputGeom)}isSimpleGeometryCollection(t){for(let e=0;e<t.getNumGeometries();e++){const s=t.getGeometryN(e);if(!this.computeSimple(s))return!1}return!0}}class lr{constructor(){lr.constructor_.apply(this,arguments)}static constructor_(){this.pt=null,this.isClosed=null,this.degree=null;const t=arguments[0];this.pt=t,this.isClosed=!1,this.degree=0}getCoordinate(){return this.pt}addEndpoint(t){this.degree++,this.isClosed|=t}}or.EndpointInfo=lr;var ar=Object.freeze({__proto__:null,BufferOp:bn,BufferParameters:Qe});class cr{constructor(){cr.constructor_.apply(this,arguments)}static constructor_(){if(this._component=null,this._segIndex=null,this._pt=null,2===arguments.length){const t=arguments[0],e=arguments[1];cr.constructor_.call(this,t,cr.INSIDE_AREA,e)}else if(3===arguments.length){const t=arguments[0],e=arguments[1],s=arguments[2];this._component=t,this._segIndex=e,this._pt=s}}getSegmentIndex(){return this._segIndex}getCoordinate(){return this._pt}isInsideArea(){return this._segIndex===cr.INSIDE_AREA}toString(){return this._component.getGeometryType()+"["+this._segIndex+"]-"+Wt.toPoint(this._pt)}getGeometryComponent(){return this._component}}cr.INSIDE_AREA=-1;class hr{constructor(){hr.constructor_.apply(this,arguments)}static constructor_(){this._locations=null;const t=arguments[0];this._locations=t}static getLocations(t){const e=new L;return t.apply(new hr(e)),e}filter(t){if(t.isEmpty())return null;(t instanceof Nt||t instanceof tt||t instanceof Ct)&&this._locations.add(new cr(t,0,t.getCoordinate()))}get interfaces_(){return[$]}}class ur{constructor(){ur.constructor_.apply(this,arguments)}static constructor_(){if(this._geom=null,this._terminateDistance=0,this._ptLocator=new Zn,this._minDistanceLocation=null,this._minDistance=r.MAX_VALUE,2===arguments.length){const t=arguments[0],e=arguments[1];ur.constructor_.call(this,t,e,0)}else if(3===arguments.length){const t=arguments[0],e=arguments[1],s=arguments[2];this._geom=new Array(2).fill(null),this._geom[0]=t,this._geom[1]=e,this._terminateDistance=s}}static distance(t,e){return new ur(t,e).distance()}static isWithinDistance(t,e,s){if(t.getEnvelopeInternal().distance(e.getEnvelopeInternal())>s)return!1;return new ur(t,e,s).distance()<=s}static nearestPoints(t,e){return new ur(t,e).nearestPoints()}computeContainmentDistance(){if(0===arguments.length){const t=new Array(2).fill(null);if(this.computeContainmentDistance(0,t),this._minDistance<=this._terminateDistance)return null;this.computeContainmentDistance(1,t)}else if(2===arguments.length){const t=arguments[0],e=arguments[1],s=this._geom[t];if(s.getDimension()<2)return null;const n=1-t,i=Ie.getPolygons(s);if(i.size()>0){const s=hr.getLocations(this._geom[n]);if(this.computeContainmentDistance(s,i,e),this._minDistance<=this._terminateDistance)return this._minDistanceLocation[n]=e[0],this._minDistanceLocation[t]=e[1],null}}else if(3===arguments.length)if(arguments[2]instanceof Array&&I(arguments[0],C)&&I(arguments[1],C)){const t=arguments[0],e=arguments[1],s=arguments[2];for(let n=0;n<t.size();n++){const i=t.get(n);for(let t=0;t<e.size();t++)if(this.computeContainmentDistance(i,e.get(t),s),this._minDistance<=this._terminateDistance)return null}}else if(arguments[2]instanceof Array&&arguments[0]instanceof cr&&arguments[1]instanceof Ct){const t=arguments[0],e=arguments[1],s=arguments[2],n=t.getCoordinate();if(Qt.EXTERIOR!==this._ptLocator.locate(n,e))return this._minDistance=0,s[0]=t,s[1]=new cr(e,n),null}}computeMinDistanceLinesPoints(t,e,s){for(let n=0;n<t.size();n++){const i=t.get(n);for(let t=0;t<e.size();t++){const n=e.get(t);if(this.computeMinDistance(i,n,s),this._minDistance<=this._terminateDistance)return null}}}computeFacetDistance(){const t=new Array(2).fill(null),e=ye.getLines(this._geom[0]),s=ye.getLines(this._geom[1]),n=Ee.getPoints(this._geom[0]),i=Ee.getPoints(this._geom[1]);return this.computeMinDistanceLines(e,s,t),this.updateMinDistance(t,!1),this._minDistance<=this._terminateDistance?null:(t[0]=null,t[1]=null,this.computeMinDistanceLinesPoints(e,i,t),this.updateMinDistance(t,!1),this._minDistance<=this._terminateDistance?null:(t[0]=null,t[1]=null,this.computeMinDistanceLinesPoints(s,n,t),this.updateMinDistance(t,!0),this._minDistance<=this._terminateDistance?null:(t[0]=null,t[1]=null,this.computeMinDistancePoints(n,i,t),void this.updateMinDistance(t,!1))))}nearestLocations(){return this.computeMinDistance(),this._minDistanceLocation}updateMinDistance(t,e){if(null===t[0])return null;e?(this._minDistanceLocation[0]=t[1],this._minDistanceLocation[1]=t[0]):(this._minDistanceLocation[0]=t[0],this._minDistanceLocation[1]=t[1])}nearestPoints(){this.computeMinDistance();return[this._minDistanceLocation[0].getCoordinate(),this._minDistanceLocation[1].getCoordinate()]}computeMinDistance(){if(0===arguments.length){if(null!==this._minDistanceLocation)return null;if(this._minDistanceLocation=new Array(2).fill(null),this.computeContainmentDistance(),this._minDistance<=this._terminateDistance)return null;this.computeFacetDistance()}else if(3===arguments.length)if(arguments[2]instanceof Array&&arguments[0]instanceof tt&&arguments[1]instanceof Nt){const t=arguments[0],e=arguments[1],s=arguments[2];if(t.getEnvelopeInternal().distance(e.getEnvelopeInternal())>this._minDistance)return null;const n=t.getCoordinates(),i=e.getCoordinate();for(let r=0;r<n.length-1;r++){const o=V.pointToSegment(i,n[r],n[r+1]);if(o<this._minDistance){this._minDistance=o;const l=new Kt(n[r],n[r+1]).closestPoint(i);s[0]=new cr(t,r,l),s[1]=new cr(e,0,i)}if(this._minDistance<=this._terminateDistance)return null}}else if(arguments[2]instanceof Array&&arguments[0]instanceof tt&&arguments[1]instanceof tt){const t=arguments[0],e=arguments[1],s=arguments[2];if(t.getEnvelopeInternal().distance(e.getEnvelopeInternal())>this._minDistance)return null;const n=t.getCoordinates(),i=e.getCoordinates();for(let r=0;r<n.length-1;r++){const o=new O(n[r],n[r+1]);if(!(o.distance(e.getEnvelopeInternal())>this._minDistance))for(let l=0;l<i.length-1;l++){const a=new O(i[l],i[l+1]);if(o.distance(a)>this._minDistance)continue;const c=V.segmentToSegment(n[r],n[r+1],i[l],i[l+1]);if(c<this._minDistance){this._minDistance=c;const o=new Kt(n[r],n[r+1]),a=new Kt(i[l],i[l+1]),h=o.closestPoints(a);s[0]=new cr(t,r,h[0]),s[1]=new cr(e,l,h[1])}if(this._minDistance<=this._terminateDistance)return null}}}}computeMinDistancePoints(t,e,s){for(let n=0;n<t.size();n++){const i=t.get(n);for(let t=0;t<e.size();t++){const n=e.get(t),r=i.getCoordinate().distance(n.getCoordinate());if(r<this._minDistance&&(this._minDistance=r,s[0]=new cr(i,0,i.getCoordinate()),s[1]=new cr(n,0,n.getCoordinate())),this._minDistance<=this._terminateDistance)return null}}}distance(){if(null===this._geom[0]||null===this._geom[1])throw new n("null geometries are not supported");return this._geom[0].isEmpty()||this._geom[1].isEmpty()?0:(this.computeMinDistance(),this._minDistance)}computeMinDistanceLines(t,e,s){for(let n=0;n<t.size();n++){const i=t.get(n);for(let t=0;t<e.size();t++){const n=e.get(t);if(this.computeMinDistance(i,n,s),this._minDistance<=this._terminateDistance)return null}}}}var gr=Object.freeze({__proto__:null,DistanceOp:ur});class dr{constructor(){dr.constructor_.apply(this,arguments)}static constructor_(){this._factory=null,this._directedEdges=new L,this._coordinates=null;const t=arguments[0];this._factory=t}add(t){this._directedEdges.add(t)}toLineString(){return this._factory.createLineString(this.getCoordinates())}getCoordinates(){if(null===this._coordinates){let t=0,e=0;const s=new R;for(let n=this._directedEdges.iterator();n.hasNext();){const i=n.next();i.getEdgeDirection()?t++:e++,s.add(i.getEdge().getLine().getCoordinates(),!1,i.getEdgeDirection())}this._coordinates=s.toCoordinateArray(),e>t&&W.reverse(this._coordinates)}return this._coordinates}}class _r{constructor(){_r.constructor_.apply(this,arguments)}static constructor_(){this._isMarked=!1,this._isVisited=!1,this._data=null}static setMarked(t,e){for(;t.hasNext();){t.next().setMarked(e)}}static setVisited(t,e){for(;t.hasNext();){t.next().setVisited(e)}}static getComponentWithVisitedState(t,e){for(;t.hasNext();){const s=t.next();if(s.isVisited()===e)return s}return null}setVisited(t){this._isVisited=t}isMarked(){return this._isMarked}setData(t){this._data=t}getData(){return this._data}setMarked(t){this._isMarked=t}getContext(){return this._data}isVisited(){return this._isVisited}setContext(t){this._data=t}}class pr extends _r{constructor(){super(),pr.constructor_.apply(this,arguments)}static constructor_(){if(this._parentEdge=null,this._from=null,this._to=null,this._p0=null,this._p1=null,this._sym=null,this._edgeDirection=null,this._quadrant=null,this._angle=null,0===arguments.length);else if(4===arguments.length){const t=arguments[0],e=arguments[1],s=arguments[2],n=arguments[3];this._from=t,this._to=e,this._edgeDirection=n,this._p0=t.getCoordinate(),this._p1=s;const i=this._p1.x-this._p0.x,r=this._p1.y-this._p0.y;this._quadrant=Ds.quadrant(i,r),this._angle=Math.atan2(r,i)}}static toEdges(t){const e=new L;for(let s=t.iterator();s.hasNext();)e.add(s.next()._parentEdge);return e}isRemoved(){return null===this._parentEdge}compareDirection(t){return this._quadrant>t._quadrant?1:this._quadrant<t._quadrant?-1:q.index(t._p0,t._p1,this._p1)}getCoordinate(){return this._from.getCoordinate()}print(t){const e=this.getClass().getName(),s=e.lastIndexOf("."),n=e.substring(s+1);t.print("  "+n+": "+this._p0+" - "+this._p1+" "+this._quadrant+":"+this._angle)}getDirectionPt(){return this._p1}getAngle(){return this._angle}getSym(){return this._sym}getEdge(){return this._parentEdge}getToNode(){return this._to}getEdgeDirection(){return this._edgeDirection}compareTo(t){const e=t;return this.compareDirection(e)}getFromNode(){return this._from}setEdge(t){this._parentEdge=t}remove(){this._sym=null,this._parentEdge=null}getQuadrant(){return this._quadrant}setSym(t){this._sym=t}get interfaces_(){return[o]}}class mr extends pr{constructor(){super(),mr.constructor_.apply(this,arguments)}static constructor_(){const t=arguments[0],e=arguments[1],s=arguments[2],n=arguments[3];pr.constructor_.call(this,t,e,s,n)}getNext(){return 2!==this.getToNode().getDegree()?null:this.getToNode().getOutEdges().getEdges().get(0)===this.getSym()?this.getToNode().getOutEdges().getEdges().get(1):(h.isTrue(this.getToNode().getOutEdges().getEdges().get(1)===this.getSym()),this.getToNode().getOutEdges().getEdges().get(0))}}class fr extends _r{constructor(){super(),fr.constructor_.apply(this,arguments)}static constructor_(){if(this._dirEdge=null,0===arguments.length);else if(2===arguments.length){const t=arguments[0],e=arguments[1];this.setDirectedEdges(t,e)}}isRemoved(){return null===this._dirEdge}setDirectedEdges(t,e){this._dirEdge=[t,e],t.setEdge(this),e.setEdge(this),t.setSym(e),e.setSym(t),t.getFromNode().addOutEdge(t),e.getFromNode().addOutEdge(e)}getDirEdge(){if(Number.isInteger(arguments[0])){const t=arguments[0];return this._dirEdge[t]}if(arguments[0]instanceof xr){const t=arguments[0];return this._dirEdge[0].getFromNode()===t?this._dirEdge[0]:this._dirEdge[1].getFromNode()===t?this._dirEdge[1]:null}}remove(){this._dirEdge=null}getOppositeNode(t){return this._dirEdge[0].getFromNode()===t?this._dirEdge[0].getToNode():this._dirEdge[1].getFromNode()===t?this._dirEdge[1].getToNode():null}}class yr{constructor(){yr.constructor_.apply(this,arguments)}static constructor_(){this._outEdges=new L,this._sorted=!1}getNextEdge(t){const e=this.getIndex(t);return this._outEdges.get(this.getIndex(e+1))}getCoordinate(){const t=this.iterator();if(!t.hasNext())return null;return t.next().getCoordinate()}iterator(){return this.sortEdges(),this._outEdges.iterator()}sortEdges(){this._sorted||(xe.sort(this._outEdges),this._sorted=!0)}remove(t){this._outEdges.remove(t)}getEdges(){return this.sortEdges(),this._outEdges}getNextCWEdge(t){const e=this.getIndex(t);return this._outEdges.get(this.getIndex(e-1))}getIndex(){if(arguments[0]instanceof fr){const t=arguments[0];this.sortEdges();for(let e=0;e<this._outEdges.size();e++){if(this._outEdges.get(e).getEdge()===t)return e}return-1}if(arguments[0]instanceof pr){const t=arguments[0];this.sortEdges();for(let e=0;e<this._outEdges.size();e++){if(this._outEdges.get(e)===t)return e}return-1}if(Number.isInteger(arguments[0])){let t=arguments[0]%this._outEdges.size();return t<0&&(t+=this._outEdges.size()),t}}add(t){this._outEdges.add(t),this._sorted=!1}getDegree(){return this._outEdges.size()}}class xr extends _r{constructor(){super(),xr.constructor_.apply(this,arguments)}static constructor_(){if(this._pt=null,this._deStar=null,1===arguments.length){const t=arguments[0];xr.constructor_.call(this,t,new yr)}else if(2===arguments.length){const t=arguments[0],e=arguments[1];this._pt=t,this._deStar=e}}static getEdgesBetween(t,e){const s=pr.toEdges(t.getOutEdges().getEdges()),n=new pt(s),i=pr.toEdges(e.getOutEdges().getEdges());return n.retainAll(i),n}isRemoved(){return null===this._pt}addOutEdge(t){this._deStar.add(t)}getCoordinate(){return this._pt}getOutEdges(){return this._deStar}remove(){if(0===arguments.length)this._pt=null;else if(1===arguments.length){const t=arguments[0];this._deStar.remove(t)}}getIndex(t){return this._deStar.getIndex(t)}getDegree(){return this._deStar.getDegree()}}class Er extends fr{constructor(){super(),Er.constructor_.apply(this,arguments)}static constructor_(){this._line=null;const t=arguments[0];this._line=t}getLine(){return this._line}}class Ir{constructor(){Ir.constructor_.apply(this,arguments)}static constructor_(){this._nodeMap=new os}find(t){return this._nodeMap.get(t)}iterator(){return this._nodeMap.values().iterator()}remove(t){return this._nodeMap.remove(t)}values(){return this._nodeMap.values()}add(t){return this._nodeMap.put(t.getCoordinate(),t),t}}class Nr{constructor(){Nr.constructor_.apply(this,arguments)}static constructor_(){this._edges=new pt,this._dirEdges=new pt,this._nodeMap=new Ir}findNodesOfDegree(t){const e=new L;for(let s=this.nodeIterator();s.hasNext();){const n=s.next();n.getDegree()===t&&e.add(n)}return e}dirEdgeIterator(){return this._dirEdges.iterator()}edgeIterator(){return this._edges.iterator()}getEdges(){return this._edges}nodeIterator(){return this._nodeMap.iterator()}contains(){if(arguments[0]instanceof fr){const t=arguments[0];return this._edges.contains(t)}if(arguments[0]instanceof pr){const t=arguments[0];return this._dirEdges.contains(t)}}add(){if(arguments[0]instanceof xr){const t=arguments[0];this._nodeMap.add(t)}else if(arguments[0]instanceof fr){const t=arguments[0];this._edges.add(t),this.add(t.getDirEdge(0)),this.add(t.getDirEdge(1))}else if(arguments[0]instanceof pr){const t=arguments[0];this._dirEdges.add(t)}}getNodes(){return this._nodeMap.values()}remove(){if(arguments[0]instanceof fr){const t=arguments[0];this.remove(t.getDirEdge(0)),this.remove(t.getDirEdge(1)),this._edges.remove(t),t.remove()}else if(arguments[0]instanceof pr){const t=arguments[0],e=t.getSym();null!==e&&e.setSym(null),t.getFromNode().remove(t),t.remove(),this._dirEdges.remove(t)}else if(arguments[0]instanceof xr){const t=arguments[0];for(let e=t.getOutEdges().getEdges().iterator();e.hasNext();){const t=e.next(),s=t.getSym();null!==s&&this.remove(s),this._dirEdges.remove(t);const n=t.getEdge();null!==n&&this._edges.remove(n)}this._nodeMap.remove(t.getCoordinate()),t.remove()}}findNode(t){return this._nodeMap.find(t)}}class wr extends Nr{constructor(){super()}getNode(t){let e=this.findNode(t);return null===e&&(e=new xr(t),this.add(e)),e}addEdge(t){if(t.isEmpty())return null;const e=W.removeRepeatedPoints(t.getCoordinates());if(e.length<=1)return null;const s=e[0],n=e[e.length-1],i=this.getNode(s),r=this.getNode(n),o=new mr(i,r,e[1],!0),l=new mr(r,i,e[e.length-2],!1),a=new Er(t);a.setDirectedEdges(o,l),this.add(a)}}class Cr{constructor(){Cr.constructor_.apply(this,arguments)}static constructor_(){this._graph=new wr,this._mergedLineStrings=null,this._factory=null,this._edgeStrings=null}buildEdgeStringsForUnprocessedNodes(){for(let t=this._graph.getNodes().iterator();t.hasNext();){const e=t.next();e.isMarked()||(h.isTrue(2===e.getDegree()),this.buildEdgeStringsStartingAt(e),e.setMarked(!0))}}buildEdgeStringsForNonDegree2Nodes(){for(let t=this._graph.getNodes().iterator();t.hasNext();){const e=t.next();2!==e.getDegree()&&(this.buildEdgeStringsStartingAt(e),e.setMarked(!0))}}buildEdgeStringsStartingAt(t){for(let e=t.getOutEdges().iterator();e.hasNext();){const t=e.next();t.getEdge().isMarked()||this._edgeStrings.add(this.buildEdgeStringStartingWith(t))}}merge(){if(null!==this._mergedLineStrings)return null;_r.setMarked(this._graph.nodeIterator(),!1),_r.setMarked(this._graph.edgeIterator(),!1),this._edgeStrings=new L,this.buildEdgeStringsForObviousStartNodes(),this.buildEdgeStringsForIsolatedLoops(),this._mergedLineStrings=new L;for(let t=this._edgeStrings.iterator();t.hasNext();){const e=t.next();this._mergedLineStrings.add(e.toLineString())}}addLineString(t){null===this._factory&&(this._factory=t.getFactory()),this._graph.addEdge(t)}buildEdgeStringStartingWith(t){const e=new dr(this._factory);let s=t;do{e.add(s),s.getEdge().setMarked(!0),s=s.getNext()}while(null!==s&&s!==t);return e}add(){if(arguments[0]instanceof j){const t=arguments[0];for(let e=0;e<t.getNumGeometries();e++){const s=t.getGeometryN(e);s instanceof tt&&this.addLineString(s)}}else if(I(arguments[0],N)){const t=arguments[0];this._mergedLineStrings=null;for(let e=t.iterator();e.hasNext();){const t=e.next();this.add(t)}}}buildEdgeStringsForIsolatedLoops(){this.buildEdgeStringsForUnprocessedNodes()}buildEdgeStringsForObviousStartNodes(){this.buildEdgeStringsForNonDegree2Nodes()}getMergedLineStrings(){return this.merge(),this._mergedLineStrings}}class Sr{constructor(){Sr.constructor_.apply(this,arguments)}static constructor_(){this._parentGraph=null,this._edges=new pt,this._dirEdges=new L,this._nodeMap=new Ir;const t=arguments[0];this._parentGraph=t}dirEdgeIterator(){return this._dirEdges.iterator()}edgeIterator(){return this._edges.iterator()}getParent(){return this._parentGraph}nodeIterator(){return this._nodeMap.iterator()}contains(t){return this._edges.contains(t)}add(t){if(this._edges.contains(t))return null;this._edges.add(t),this._dirEdges.add(t.getDirEdge(0)),this._dirEdges.add(t.getDirEdge(1)),this._nodeMap.add(t.getDirEdge(0).getFromNode()),this._nodeMap.add(t.getDirEdge(1).getFromNode())}}class Lr{constructor(){Lr.constructor_.apply(this,arguments)}static constructor_(){this._graph=null;const t=arguments[0];this._graph=t}findSubgraph(t){const e=new Sr(this._graph);return this.addReachable(t,e),e}addEdges(t,e,s){t.setVisited(!0);for(let n=t.getOutEdges().iterator();n.hasNext();){const t=n.next();s.add(t.getEdge());const i=t.getToNode();i.isVisited()||e.push(i)}}addReachable(t,e){const s=new Zs;for(s.add(t);!s.empty();){const t=s.pop();this.addEdges(t,s,e)}}getConnectedSubgraphs(){const t=new L;_r.setVisited(this._graph.nodeIterator(),!1);for(let e=this._graph.edgeIterator();e.hasNext();){const s=e.next().getDirEdge(0).getFromNode();s.isVisited()||t.add(this.findSubgraph(s))}return t}}class Tr{constructor(){Tr.constructor_.apply(this,arguments)}static constructor_(){this._graph=new wr,this._factory=new Lt,this._lineCount=0,this._isRun=!1,this._sequencedGeometry=null,this._isSequenceable=!1}static findUnvisitedBestOrientedDE(t){let e=null,s=null;for(let n=t.getOutEdges().iterator();n.hasNext();){const t=n.next();t.getEdge().isVisited()||(s=t,t.getEdgeDirection()&&(e=t))}return null!==e?e:s}static findLowestDegreeNode(t){let e=M.MAX_VALUE,s=null;for(let n=t.nodeIterator();n.hasNext();){const t=n.next();(null===s||t.getDegree()<e)&&(e=t.getDegree(),s=t)}return s}static isSequenced(t){if(!(t instanceof Et))return!0;const e=t,s=new at;let n=null;const i=new L;for(let t=0;t<e.getNumGeometries();t++){const r=e.getGeometryN(t),o=r.getCoordinateN(0),l=r.getCoordinateN(r.getNumPoints()-1);if(s.contains(o))return!1;if(s.contains(l))return!1;null!==n&&(o.equals(n)||(s.addAll(i),i.clear())),i.add(o),i.add(l),n=l}return!0}static reverse(t){const e=t.getCoordinates(),s=new Array(e.length).fill(null),n=e.length;for(let t=0;t<n;t++)s[n-1-t]=new m(e[t]);return t.getFactory().createLineString(s)}static sequence(t){const e=new Tr;return e.add(t),e.getSequencedLineStrings()}computeSequence(){if(this._isRun)return null;this._isRun=!0;const t=this.findSequences();if(null===t)return null;this._sequencedGeometry=this.buildSequencedGeometry(t),this._isSequenceable=!0;const e=this._sequencedGeometry.getNumGeometries();h.isTrue(this._lineCount===e,"Lines were missing from result"),h.isTrue(this._sequencedGeometry instanceof tt||this._sequencedGeometry instanceof Et,"Result is not lineal")}findSequences(){const t=new L;for(let e=new Lr(this._graph).getConnectedSubgraphs().iterator();e.hasNext();){const s=e.next();if(!this.hasSequence(s))return null;{const e=this.findSequence(s);t.add(e)}}return t}addReverseSubpath(t,e,s){const n=t.getToNode();let i=null;for(;;){e.add(t.getSym()),t.getEdge().setVisited(!0),i=t.getFromNode();const s=Tr.findUnvisitedBestOrientedDE(i);if(null===s)break;t=s.getSym()}s&&h.isTrue(i===n,"path not contiguous")}findSequence(t){_r.setVisited(t.edgeIterator(),!1);const e=Tr.findLowestDegreeNode(t).getOutEdges().iterator().next().getSym(),s=new Ks,n=s.listIterator();for(this.addReverseSubpath(e,n,!1);n.hasPrevious();){const t=n.previous(),e=Tr.findUnvisitedBestOrientedDE(t.getFromNode());null!==e&&this.addReverseSubpath(e.getSym(),n,!0)}return this.orient(s)}reverse(t){const e=new Ks;for(let s=t.iterator();s.hasNext();){const t=s.next();e.addFirst(t.getSym())}return e}add(){if(I(arguments[0],N)){for(let t=arguments[0].iterator();t.hasNext();){const e=t.next();this.add(e)}}else if(arguments[0]instanceof j){arguments[0].apply(new class{get interfaces_(){return[X]}filter(t){t instanceof tt&&this.addLine(t)}})}}addLine(t){null===this._factory&&(this._factory=t.getFactory()),this._graph.addEdge(t),this._lineCount++}hasSequence(t){let e=0;for(let s=t.nodeIterator();s.hasNext();){s.next().getDegree()%2==1&&e++}return e<=2}orient(t){const e=t.get(0),s=t.get(t.size()-1),n=e.getFromNode(),i=s.getToNode();let r=!1;if(1===n.getDegree()||1===i.getDegree()){let t=!1;1===s.getToNode().getDegree()&&!1===s.getEdgeDirection()&&(t=!0,r=!0),1===e.getFromNode().getDegree()&&!0===e.getEdgeDirection()&&(t=!0,r=!1),t||1===e.getFromNode().getDegree()&&(r=!0)}return r?this.reverse(t):t}buildSequencedGeometry(t){const e=new L;for(let s=t.iterator();s.hasNext();){for(let t=s.next().iterator();t.hasNext();){const s=t.next(),n=s.getEdge().getLine();let i=n;s.getEdgeDirection()||n.isClosed()||(i=Tr.reverse(n)),e.add(i)}}return 0===e.size()?this._factory.createMultiLineString(new Array(0).fill(null)):this._factory.buildGeometry(e)}getSequencedLineStrings(){return this.computeSequence(),this._sequencedGeometry}isSequenceable(){return this.computeSequence(),this._isSequenceable}}var Rr=Object.freeze({__proto__:null,LineMerger:Cr,LineSequencer:Tr}),Pr=Object.freeze({__proto__:null,GeometrySnapper:An,LineStringSnapper:Dn}),Or=Object.freeze({__proto__:null,OverlayOp:oi,snap:Pr});class vr{constructor(){vr.constructor_.apply(this,arguments)}static constructor_(){this._geometryFactory=new Lt,this._geomGraph=null,this._disconnectedRingcoord=null;const t=arguments[0];this._geomGraph=t}static findDifferentPoint(t,e){for(let s=0;s<t.length;s++)if(!t[s].equals(e))return t[s];return null}visitInteriorRing(t,e){if(t.isEmpty())return null;const s=t.getCoordinates(),n=s[0],i=vr.findDifferentPoint(s,n),r=e.findEdgeInSameDirection(n,i),o=e.findEdgeEnd(r);let l=null;o.getLabel().getLocation(0,Hs.RIGHT)===Qt.INTERIOR?l=o:o.getSym().getLabel().getLocation(0,Hs.RIGHT)===Qt.INTERIOR&&(l=o.getSym()),h.isTrue(null!==l,"unable to find dirEdge with Interior on RHS"),this.visitLinkedDirectedEdges(l)}visitShellInteriors(t,e){if(t instanceof Ct){const s=t;this.visitInteriorRing(s.getExteriorRing(),e)}if(t instanceof dt){const s=t;for(let t=0;t<s.getNumGeometries();t++){const n=s.getGeometryN(t);this.visitInteriorRing(n.getExteriorRing(),e)}}}getCoordinate(){return this._disconnectedRingcoord}setInteriorEdgesInResult(t){for(let e=t.getEdgeEnds().iterator();e.hasNext();){const t=e.next();t.getLabel().getLocation(0,Hs.RIGHT)===Qt.INTERIOR&&t.setInResult(!0)}}visitLinkedDirectedEdges(t){const e=t;let s=t;do{h.isTrue(null!==s,"found null Directed Edge"),s.setVisited(!0),s=s.getNext()}while(s!==e)}buildEdgeRings(t){const e=new L;for(let s=t.iterator();s.hasNext();){const t=s.next();if(t.isInResult()&&null===t.getEdgeRing()){const s=new _n(t,this._geometryFactory);s.linkDirectedEdgesForMinimalEdgeRings();const n=s.buildMinimalRings();e.addAll(n)}}return e}hasUnvisitedShellEdge(t){for(let e=0;e<t.size();e++){const s=t.get(e);if(s.isHole())continue;const n=s.getEdges();let i=n.get(0);if(i.getLabel().getLocation(0,Hs.RIGHT)===Qt.INTERIOR)for(let t=0;t<n.size();t++)if(i=n.get(t),!i.isVisited())return this._disconnectedRingcoord=i.getCoordinate(),!0}return!1}isInteriorsConnected(){const t=new L;this._geomGraph.computeSplitEdges(t);const e=new un(new In);e.addEdges(t),this.setInteriorEdgesInResult(e),e.linkResultDirectedEdges();const s=this.buildEdgeRings(e.getEdgeEnds());return this.visitShellInteriors(this._geomGraph.getGeometry(),e),!this.hasUnvisitedShellEdge(s)}}class Mr{computeEdgeEnds(){if(1===arguments.length){const t=arguments[0],e=new L;for(let s=t;s.hasNext();){const t=s.next();this.computeEdgeEnds(t,e)}return e}if(2===arguments.length){const t=arguments[0],e=arguments[1],s=t.getEdgeIntersectionList();s.addEndpoints();const n=s.iterator();let i=null,r=null;if(!n.hasNext())return null;let o=n.next();do{i=r,r=o,o=null,n.hasNext()&&(o=n.next()),null!==r&&(this.createEdgeEndForPrev(t,e,r,i),this.createEdgeEndForNext(t,e,r,o))}while(null!==r)}}createEdgeEndForNext(t,e,s,n){const i=s.segmentIndex+1;if(i>=t.getNumPoints()&&null===n)return null;let r=t.getCoordinate(i);null!==n&&n.segmentIndex===s.segmentIndex&&(r=n.coord);const o=new cn(t,s.coord,r,new nn(t.getLabel()));e.add(o)}createEdgeEndForPrev(t,e,s,n){let i=s.segmentIndex;if(0===s.dist){if(0===i)return null;i--}let r=t.getCoordinate(i);null!==n&&n.segmentIndex>=i&&(r=n.coord);const o=new nn(t.getLabel());o.flip();const l=new cn(t,s.coord,r,o);e.add(l)}}class br extends cn{constructor(){super(),br.constructor_.apply(this,arguments)}static constructor_(){if(this._edgeEnds=new L,1===arguments.length){const t=arguments[0];br.constructor_.call(this,null,t)}else if(2===arguments.length){const t=arguments[1];cn.constructor_.call(this,t.getEdge(),t.getCoordinate(),t.getDirectedCoordinate(),new nn(t.getLabel())),this.insert(t)}}insert(t){this._edgeEnds.add(t)}print(t){t.println("EdgeEndBundle--\x3e Label: "+this._label);for(let e=this.iterator();e.hasNext();){e.next().print(t),t.println()}}iterator(){return this._edgeEnds.iterator()}getEdgeEnds(){return this._edgeEnds}computeLabelOn(t,e){let s=0,n=!1;for(let e=this.iterator();e.hasNext();){const i=e.next().getLabel().getLocation(t);i===Qt.BOUNDARY&&s++,i===Qt.INTERIOR&&(n=!0)}let i=Qt.NONE;n&&(i=Qt.INTERIOR),s>0&&(i=ii.determineBoundary(e,s)),this._label.setLocation(t,i)}computeLabelSide(t,e){for(let s=this.iterator();s.hasNext();){const n=s.next();if(n.getLabel().isArea()){const s=n.getLabel().getLocation(t,e);if(s===Qt.INTERIOR)return this._label.setLocation(t,e,Qt.INTERIOR),null;s===Qt.EXTERIOR&&this._label.setLocation(t,e,Qt.EXTERIOR)}}}getLabel(){return this._label}computeLabelSides(t){this.computeLabelSide(t,Hs.LEFT),this.computeLabelSide(t,Hs.RIGHT)}updateIM(t){vn.updateIM(this._label,t)}computeLabel(t){let e=!1;for(let t=this.iterator();t.hasNext();){t.next().getLabel().isArea()&&(e=!0)}this._label=e?new nn(Qt.NONE,Qt.NONE,Qt.NONE):new nn(Qt.NONE);for(let s=0;s<2;s++)this.computeLabelOn(s,t),e&&this.computeLabelSides(s)}}class Dr extends xn{constructor(){super()}updateIM(t){for(let e=this.iterator();e.hasNext();){e.next().updateIM(t)}}insert(t){let e=this._edgeMap.get(t);null===e?(e=new br(t),this.insertEdgeEnd(t,e)):e.insert(t)}}class Ar extends on{constructor(){super(),Ar.constructor_.apply(this,arguments)}static constructor_(){const t=arguments[0],e=arguments[1];on.constructor_.call(this,t,e)}computeIM(t){t.setAtLeastIfValid(this._label.getLocation(0),this._label.getLocation(1),0)}updateIMFromEdges(t){this._edges.updateIM(t)}}class Fr extends an{constructor(){super()}createNode(t){return new Ar(t,new Dr)}}class Gr{constructor(){Gr.constructor_.apply(this,arguments)}static constructor_(){this._nodes=new ln(new Fr)}insertEdgeEnds(t){for(let e=t.iterator();e.hasNext();){const t=e.next();this._nodes.add(t)}}getNodeIterator(){return this._nodes.iterator()}copyNodesAndLabels(t,e){for(let s=t.getNodeIterator();s.hasNext();){const t=s.next();this._nodes.addNode(t.getCoordinate()).setLabel(e,t.getLabel().getLocation(e))}}build(t){this.computeIntersectionNodes(t,0),this.copyNodesAndLabels(t,0);const e=(new Mr).computeEdgeEnds(t.getEdgeIterator());this.insertEdgeEnds(e)}computeIntersectionNodes(t,e){for(let s=t.getEdgeIterator();s.hasNext();){const t=s.next(),n=t.getLabel().getLocation(e);for(let s=t.getEdgeIntersectionList().iterator();s.hasNext();){const t=s.next(),i=this._nodes.addNode(t.coord);n===Qt.BOUNDARY?i.setLabelBoundary(e):i.getLabel().isNull(e)&&i.setLabel(e,Qt.INTERIOR)}}}}class qr{constructor(){qr.constructor_.apply(this,arguments)}static constructor_(){this._li=new jt,this._geomGraph=null,this._nodeGraph=new Gr,this._invalidPoint=null;const t=arguments[0];this._geomGraph=t}isNodeEdgeAreaLabelsConsistent(){for(let t=this._nodeGraph.getNodeIterator();t.hasNext();){const e=t.next();if(!e.getEdges().isAreaLabelsConsistent(this._geomGraph))return this._invalidPoint=e.getCoordinate().copy(),!1}return!0}hasDuplicateRings(){for(let t=this._nodeGraph.getNodeIterator();t.hasNext();){for(let e=t.next().getEdges().iterator();e.hasNext();){const t=e.next();if(t.getEdgeEnds().size()>1)return this._invalidPoint=t.getEdge().getCoordinate(0),!0}}return!1}isNodeConsistentArea(){const t=this._geomGraph.computeSelfNodes(this._li,!0,!0);return t.hasProperIntersection()?(this._invalidPoint=t.getProperIntersectionPoint(),!1):(this._nodeGraph.build(this._geomGraph),this.isNodeEdgeAreaLabelsConsistent())}getInvalidPoint(){return this._invalidPoint}}class Br{constructor(){Br.constructor_.apply(this,arguments)}static constructor_(){this._graph=null,this._rings=new L,this._totalEnv=new O,this._index=null,this._nestedPt=null;const t=arguments[0];this._graph=t}add(t){this._rings.add(t),this._totalEnv.expandToInclude(t.getEnvelopeInternal())}getNestedPoint(){return this._nestedPt}buildIndex(){this._index=new Os;for(let t=0;t<this._rings.size();t++){const e=this._rings.get(t),s=e.getEnvelopeInternal();this._index.insert(s,e)}}isNonNested(){this.buildIndex();for(let t=0;t<this._rings.size();t++){const e=this._rings.get(t),s=e.getCoordinates(),n=this._index.query(e.getEnvelopeInternal());for(let t=0;t<n.size();t++){const i=n.get(t),r=i.getCoordinates();if(e===i)continue;if(!e.getEnvelopeInternal().intersects(i.getEnvelopeInternal()))continue;const o=zr.findPtNotNode(s,i,this._graph);if(null===o)continue;if(Ue.isInRing(o,r))return this._nestedPt=o,!1}}return!0}}class Yr{constructor(){Yr.constructor_.apply(this,arguments)}static constructor_(){if(this._errorType=null,this._pt=null,1===arguments.length){const t=arguments[0];Yr.constructor_.call(this,t,null)}else if(2===arguments.length){const t=arguments[0],e=arguments[1];this._errorType=t,null!==e&&(this._pt=e.copy())}}getCoordinate(){return this._pt}getMessage(){return Yr.errMsg[this._errorType]}toString(){let t="";return null!==this._pt&&(t=" at or near point "+this._pt),this.getMessage()+t}getErrorType(){return this._errorType}}Yr.ERROR=0,Yr.REPEATED_POINT=1,Yr.HOLE_OUTSIDE_SHELL=2,Yr.NESTED_HOLES=3,Yr.DISCONNECTED_INTERIOR=4,Yr.SELF_INTERSECTION=5,Yr.RING_SELF_INTERSECTION=6,Yr.NESTED_SHELLS=7,Yr.DUPLICATE_RINGS=8,Yr.TOO_FEW_POINTS=9,Yr.INVALID_COORDINATE=10,Yr.RING_NOT_CLOSED=11,Yr.errMsg=["Topology Validation Error","Repeated Point","Hole lies outside shell","Holes are nested","Interior is disconnected","Self-intersection","Ring Self-intersection","Nested shells","Duplicate Rings","Too few distinct points in geometry component","Invalid Coordinate","Ring is not closed"];class zr{constructor(){zr.constructor_.apply(this,arguments)}static constructor_(){this._parentGeometry=null,this._isSelfTouchingRingFormingHoleValid=!1,this._validErr=null;const t=arguments[0];this._parentGeometry=t}static findPtNotNode(t,e,s){const n=s.findEdge(e).getEdgeIntersectionList();for(let e=0;e<t.length;e++){const s=t[e];if(!n.isIntersection(s))return s}return null}static isValid(){if(arguments[0]instanceof j){return new zr(arguments[0]).isValid()}if(arguments[0]instanceof m){const t=arguments[0];return!r.isNaN(t.x)&&(!r.isInfinite(t.x)&&(!r.isNaN(t.y)&&!r.isInfinite(t.y)))}}checkInvalidCoordinates(){if(arguments[0]instanceof Array){const t=arguments[0];for(let e=0;e<t.length;e++)if(!zr.isValid(t[e]))return this._validErr=new Yr(Yr.INVALID_COORDINATE,t[e]),null}else if(arguments[0]instanceof Ct){const t=arguments[0];if(this.checkInvalidCoordinates(t.getExteriorRing().getCoordinates()),null!==this._validErr)return null;for(let e=0;e<t.getNumInteriorRing();e++)if(this.checkInvalidCoordinates(t.getInteriorRingN(e).getCoordinates()),null!==this._validErr)return null}}checkHolesNotNested(t,e){if(t.getNumInteriorRing()<=0)return null;const s=new Br(e);for(let e=0;e<t.getNumInteriorRing();e++){const n=t.getInteriorRingN(e);n.isEmpty()||s.add(n)}s.isNonNested()||(this._validErr=new Yr(Yr.NESTED_HOLES,s.getNestedPoint()))}checkConsistentArea(t){const e=new qr(t);if(!e.isNodeConsistentArea())return this._validErr=new Yr(Yr.SELF_INTERSECTION,e.getInvalidPoint()),null;e.hasDuplicateRings()&&(this._validErr=new Yr(Yr.DUPLICATE_RINGS,e.getInvalidPoint()))}isValid(){return this.checkValid(this._parentGeometry),null===this._validErr}checkShellInsideHole(t,e,s){const n=t.getCoordinates(),i=e.getCoordinates(),r=zr.findPtNotNode(n,e,s);if(null!==r){if(!Ue.isInRing(r,i))return r}const o=zr.findPtNotNode(i,t,s);if(null!==o){return Ue.isInRing(o,n)?o:null}return h.shouldNeverReachHere("points in shell and hole appear to be equal"),null}checkNoSelfIntersectingRings(t){for(let e=t.getEdgeIterator();e.hasNext();){const t=e.next();if(this.checkNoSelfIntersectingRing(t.getEdgeIntersectionList()),null!==this._validErr)return null}}checkHolesInShell(t,e){if(t.getNumInteriorRing()<=0)return null;const s=t.getExteriorRing(),n=s.isEmpty(),i=new Ve(s);for(let r=0;r<t.getNumInteriorRing();r++){const o=t.getInteriorRingN(r);let l=null;if(o.isEmpty())continue;if(l=zr.findPtNotNode(o.getCoordinates(),s,e),null===l)return null;if(n||Qt.EXTERIOR===i.locate(l))return this._validErr=new Yr(Yr.HOLE_OUTSIDE_SHELL,l),null}}checkShellNotNested(t,e,s){const n=t.getCoordinates(),i=e.getExteriorRing();if(i.isEmpty())return null;const r=i.getCoordinates(),o=zr.findPtNotNode(n,i,s);if(null===o)return null;if(!Ue.isInRing(o,r))return null;if(e.getNumInteriorRing()<=0)return this._validErr=new Yr(Yr.NESTED_SHELLS,o),null;let l=null;for(let n=0;n<e.getNumInteriorRing();n++){const i=e.getInteriorRingN(n);if(l=this.checkShellInsideHole(t,i,s),null===l)return null}this._validErr=new Yr(Yr.NESTED_SHELLS,l)}checkClosedRings(t){if(this.checkClosedRing(t.getExteriorRing()),null!==this._validErr)return null;for(let e=0;e<t.getNumInteriorRing();e++)if(this.checkClosedRing(t.getInteriorRingN(e)),null!==this._validErr)return null}checkConnectedInteriors(t){const e=new vr(t);e.isInteriorsConnected()||(this._validErr=new Yr(Yr.DISCONNECTED_INTERIOR,e.getCoordinate()))}checkNoSelfIntersectingRing(t){const e=new at;let s=!0;for(let n=t.iterator();n.hasNext();){const t=n.next();if(s)s=!1;else{if(e.contains(t.coord))return this._validErr=new Yr(Yr.RING_SELF_INTERSECTION,t.coord),null;e.add(t.coord)}}}checkTooFewPoints(t){if(t.hasTooFewPoints())return this._validErr=new Yr(Yr.TOO_FEW_POINTS,t.getInvalidPoint()),null}getValidationError(){return this.checkValid(this._parentGeometry),this._validErr}checkValid(){if(arguments[0]instanceof Nt){const t=arguments[0];this.checkInvalidCoordinates(t.getCoordinates())}else if(arguments[0]instanceof St){const t=arguments[0];this.checkInvalidCoordinates(t.getCoordinates())}else if(arguments[0]instanceof et){const t=arguments[0];if(this.checkInvalidCoordinates(t.getCoordinates()),null!==this._validErr)return null;if(this.checkClosedRing(t),null!==this._validErr)return null;const e=new ii(0,t);if(this.checkTooFewPoints(e),null!==this._validErr)return null;const s=new jt;e.computeSelfNodes(s,!0,!0),this.checkNoSelfIntersectingRings(e)}else if(arguments[0]instanceof tt){const t=arguments[0];if(this.checkInvalidCoordinates(t.getCoordinates()),null!==this._validErr)return null;const e=new ii(0,t);this.checkTooFewPoints(e)}else if(arguments[0]instanceof Ct){const t=arguments[0];if(this.checkInvalidCoordinates(t),null!==this._validErr)return null;if(this.checkClosedRings(t),null!==this._validErr)return null;const e=new ii(0,t);if(this.checkTooFewPoints(e),null!==this._validErr)return null;if(this.checkConsistentArea(e),null!==this._validErr)return null;if(!this._isSelfTouchingRingFormingHoleValid&&(this.checkNoSelfIntersectingRings(e),null!==this._validErr))return null;if(this.checkHolesInShell(t,e),null!==this._validErr)return null;if(this.checkHolesNotNested(t,e),null!==this._validErr)return null;this.checkConnectedInteriors(e)}else if(arguments[0]instanceof dt){const t=arguments[0];for(let e=0;e<t.getNumGeometries();e++){const s=t.getGeometryN(e);if(this.checkInvalidCoordinates(s),null!==this._validErr)return null;if(this.checkClosedRings(s),null!==this._validErr)return null}const e=new ii(0,t);if(this.checkTooFewPoints(e),null!==this._validErr)return null;if(this.checkConsistentArea(e),null!==this._validErr)return null;if(!this._isSelfTouchingRingFormingHoleValid&&(this.checkNoSelfIntersectingRings(e),null!==this._validErr))return null;for(let s=0;s<t.getNumGeometries();s++){const n=t.getGeometryN(s);if(this.checkHolesInShell(n,e),null!==this._validErr)return null}for(let s=0;s<t.getNumGeometries();s++){const n=t.getGeometryN(s);if(this.checkHolesNotNested(n,e),null!==this._validErr)return null}if(this.checkShellsNotNested(t,e),null!==this._validErr)return null;this.checkConnectedInteriors(e)}else if(arguments[0]instanceof ut){const t=arguments[0];for(let e=0;e<t.getNumGeometries();e++){const s=t.getGeometryN(e);if(this.checkValid(s),null!==this._validErr)return null}}else if(arguments[0]instanceof j){const t=arguments[0];if(this._validErr=null,t.isEmpty())return null;if(t instanceof Nt)this.checkValid(t);else if(t instanceof St)this.checkValid(t);else if(t instanceof et)this.checkValid(t);else if(t instanceof tt)this.checkValid(t);else if(t instanceof Ct)this.checkValid(t);else if(t instanceof dt)this.checkValid(t);else{if(!(t instanceof ut))throw new U(t.getGeometryType());this.checkValid(t)}}}setSelfTouchingRingFormingHoleValid(t){this._isSelfTouchingRingFormingHoleValid=t}checkClosedRing(t){if(t.isEmpty())return null;if(!t.isClosed()){let e=null;t.getNumPoints()>=1&&(e=t.getCoordinateN(0)),this._validErr=new Yr(Yr.RING_NOT_CLOSED,e)}}checkShellsNotNested(t,e){for(let s=0;s<t.getNumGeometries();s++){const n=t.getGeometryN(s).getExteriorRing();for(let i=0;i<t.getNumGeometries();i++){if(s===i)continue;const r=t.getGeometryN(i);if(this.checkShellNotNested(n,r,e),null!==this._validErr)return null}}}}class Vr{constructor(){Vr.constructor_.apply(this,arguments)}static constructor_(){this._factory=null,this._deList=new L,this._lowestEdge=null,this._ring=null,this._locator=null,this._ringPts=null,this._holes=null,this._shell=null,this._isHole=null,this._isProcessed=!1,this._isIncludedSet=!1,this._isIncluded=!1;const t=arguments[0];this._factory=t}static findEdgeRingContaining(t,e){const s=t.getRing(),n=s.getEnvelopeInternal();let i=s.getCoordinateN(0),r=null,o=null;for(let t=e.iterator();t.hasNext();){const e=t.next(),l=e.getRing().getEnvelopeInternal();if(l.equals(n))continue;if(!l.contains(n))continue;i=W.ptNotInList(s.getCoordinates(),e.getCoordinates());e.isInRing(i)&&(null===r||o.contains(l))&&(r=e,o=r.getRing().getEnvelopeInternal())}return r}static addEdge(t,e,s){if(e)for(let e=0;e<t.length;e++)s.add(t[e],!1);else for(let e=t.length-1;e>=0;e--)s.add(t[e],!1)}static findDirEdgesInRing(t){let e=t;const s=new L;do{s.add(e),e=e.getNext(),h.isTrue(null!==e,"found null DE in ring"),h.isTrue(e===t||!e.isInRing(),"found DE already in ring")}while(e!==t);return s}isIncluded(){return this._isIncluded}getCoordinates(){if(null===this._ringPts){const t=new R;for(let e=this._deList.iterator();e.hasNext();){const s=e.next(),n=s.getEdge();Vr.addEdge(n.getLine().getCoordinates(),s.getEdgeDirection(),t)}this._ringPts=t.toCoordinateArray()}return this._ringPts}build(t){let e=t;do{this.add(e),e.setRing(this),e=e.getNext(),h.isTrue(null!==e,"found null DE in ring"),h.isTrue(e===t||!e.isInRing(),"found DE already in ring")}while(e!==t)}isInRing(t){return Qt.EXTERIOR!==this.getLocator().locate(t)}addHole(){if(arguments[0]instanceof et){const t=arguments[0];null===this._holes&&(this._holes=new L),this._holes.add(t)}else if(arguments[0]instanceof Vr){const t=arguments[0];t.setShell(this);const e=t.getRing();null===this._holes&&(this._holes=new L),this._holes.add(e)}}computeHole(){const t=this.getRing();this._isHole=q.isCCW(t.getCoordinates())}getLocator(){return null===this._locator&&(this._locator=new Ve(this.getRing())),this._locator}getShell(){return this.isHole()?this._shell:this}updateIncluded(){if(this.isHole())return null;for(let t=0;t<this._deList.size();t++){const e=this._deList.get(t).getSym().getRing().getShell();if(null!==e&&e.isIncludedSet())return this.setIncluded(!e.isIncluded()),null}}setShell(t){this._shell=t}setProcessed(t){this._isProcessed=t}isIncludedSet(){return this._isIncludedSet}isValid(){return this.getCoordinates(),!(this._ringPts.length<=3)&&(this.getRing(),zr.isValid(this._ring))}isOuterHole(){return!!this._isHole&&!this.hasShell()}getPolygon(){let t=null;if(null!==this._holes){t=new Array(this._holes.size()).fill(null);for(let e=0;e<this._holes.size();e++)t[e]=this._holes.get(e)}return this._factory.createPolygon(this._ring,t)}isHole(){return this._isHole}isProcessed(){return this._isProcessed}setIncluded(t){this._isIncluded=t,this._isIncludedSet=!0}getOuterHole(){if(this.isHole())return null;for(let t=0;t<this._deList.size();t++){const e=this._deList.get(t).getSym().getRing();if(e.isOuterHole())return e}return null}hasShell(){return null!==this._shell}isOuterShell(){return null!==this.getOuterHole()}getLineString(){return this.getCoordinates(),this._factory.createLineString(this._ringPts)}toString(){return Wt.toLineString(new it(this.getCoordinates()))}add(t){this._deList.add(t)}getRing(){if(null!==this._ring)return this._ring;this.getCoordinates(),this._ringPts.length<3&&Y.out.println(this._ringPts);try{this._ring=this._factory.createLinearRing(this._ringPts)}catch(t){if(!(t instanceof s))throw t;Y.out.println(this._ringPts)}return this._ring}}Vr.EnvelopeComparator=class{compare(t,e){const s=e;return t.getRing().getEnvelope().compareTo(s.getRing().getEnvelope())}get interfaces_(){return[g]}};class kr{constructor(){kr.constructor_.apply(this,arguments)}static constructor_(){this._shells=null,this._shellIndex=null;const t=arguments[0];this._shells=t,this.buildIndex()}static assignHolesToShells(t,e){new kr(e).assignHolesToShells(t)}assignHolesToShells(t){for(let e=t.iterator();e.hasNext();){const t=e.next();this.assignHoleToShell(t)}}buildIndex(){this._shellIndex=new Os;for(const t of this._shells)this._shellIndex.insert(t.getRing().getEnvelopeInternal(),t)}queryOverlappingShells(t){return this._shellIndex.query(t)}findShellContaining(t){const e=t.getRing().getEnvelopeInternal(),s=this.queryOverlappingShells(e);return Vr.findEdgeRingContaining(t,s)}assignHoleToShell(t){const e=this.findShellContaining(t);null!==e&&e.addHole(t)}}class Xr extends pr{constructor(){super(),Xr.constructor_.apply(this,arguments)}static constructor_(){this._edgeRing=null,this._next=null,this._label=-1;const t=arguments[0],e=arguments[1],s=arguments[2],n=arguments[3];pr.constructor_.call(this,t,e,s,n)}getNext(){return this._next}isInRing(){return null!==this._edgeRing}setRing(t){this._edgeRing=t}setLabel(t){this._label=t}getLabel(){return this._label}setNext(t){this._next=t}getRing(){return this._edgeRing}}class Ur extends fr{constructor(){super(),Ur.constructor_.apply(this,arguments)}static constructor_(){this._line=null;const t=arguments[0];this._line=t}getLine(){return this._line}}class Hr extends Nr{constructor(){super(),Hr.constructor_.apply(this,arguments)}static constructor_(){this._factory=null;const t=arguments[0];this._factory=t}static findLabeledEdgeRings(t){const e=new L;let s=1;for(let n=t.iterator();n.hasNext();){const t=n.next();if(t.isMarked())continue;if(t.getLabel()>=0)continue;e.add(t);const i=Vr.findDirEdgesInRing(t);Hr.label(i,s),s++}return e}static getDegreeNonDeleted(t){let e=0;for(let s=t.getOutEdges().getEdges().iterator();s.hasNext();){s.next().isMarked()||e++}return e}static deleteAllEdges(t){for(let e=t.getOutEdges().getEdges().iterator();e.hasNext();){const t=e.next();t.setMarked(!0);const s=t.getSym();null!==s&&s.setMarked(!0)}}static label(t,e){for(let s=t.iterator();s.hasNext();){s.next().setLabel(e)}}static computeNextCWEdges(t){let e=null,s=null;for(let n=t.getOutEdges().getEdges().iterator();n.hasNext();){const t=n.next();if(!t.isMarked()){if(null===e&&(e=t),null!==s){s.getSym().setNext(t)}s=t}}if(null!==s){s.getSym().setNext(e)}}static computeNextCCWEdges(t,e){let s=null,n=null;const i=t.getOutEdges().getEdges();for(let t=i.size()-1;t>=0;t--){const r=i.get(t),o=r.getSym();let l=null;r.getLabel()===e&&(l=r);let a=null;o.getLabel()===e&&(a=o),null===l&&null===a||(null!==a&&(n=a),null!==l&&(null!==n&&(n.setNext(l),n=null),null===s&&(s=l)))}null!==n&&(h.isTrue(null!==s),n.setNext(s))}static getDegree(t,e){let s=0;for(let n=t.getOutEdges().getEdges().iterator();n.hasNext();){n.next().getLabel()===e&&s++}return s}static findIntersectionNodes(t,e){let s=t,n=null;do{const i=s.getFromNode();Hr.getDegree(i,e)>1&&(null===n&&(n=new L),n.add(i)),s=s.getNext(),h.isTrue(null!==s,"found null DE in ring"),h.isTrue(s===t||!s.isInRing(),"found DE already in ring")}while(s!==t);return n}findEdgeRing(t){const e=new Vr(this._factory);return e.build(t),e}computeDepthParity(){if(0===arguments.length)for(;;)return null}computeNextCWEdges(){for(let t=this.nodeIterator();t.hasNext();){const e=t.next();Hr.computeNextCWEdges(e)}}addEdge(t){if(t.isEmpty())return null;const e=W.removeRepeatedPoints(t.getCoordinates());if(e.length<2)return null;const s=e[0],n=e[e.length-1],i=this.getNode(s),r=this.getNode(n),o=new Xr(i,r,e[1],!0),l=new Xr(r,i,e[e.length-2],!1),a=new Ur(t);a.setDirectedEdges(o,l),this.add(a)}deleteCutEdges(){this.computeNextCWEdges(),Hr.findLabeledEdgeRings(this._dirEdges);const t=new L;for(let e=this._dirEdges.iterator();e.hasNext();){const s=e.next();if(s.isMarked())continue;const n=s.getSym();if(s.getLabel()===n.getLabel()){s.setMarked(!0),n.setMarked(!0);const e=s.getEdge();t.add(e.getLine())}}return t}getEdgeRings(){this.computeNextCWEdges(),Hr.label(this._dirEdges,-1);const t=Hr.findLabeledEdgeRings(this._dirEdges);this.convertMaximalToMinimalEdgeRings(t);const e=new L;for(let t=this._dirEdges.iterator();t.hasNext();){const s=t.next();if(s.isMarked())continue;if(s.isInRing())continue;const n=this.findEdgeRing(s);e.add(n)}return e}getNode(t){let e=this.findNode(t);return null===e&&(e=new xr(t),this.add(e)),e}convertMaximalToMinimalEdgeRings(t){for(let e=t.iterator();e.hasNext();){const t=e.next(),s=t.getLabel(),n=Hr.findIntersectionNodes(t,s);if(null!==n)for(let t=n.iterator();t.hasNext();){const e=t.next();Hr.computeNextCCWEdges(e,s)}}}deleteDangles(){const t=this.findNodesOfDegree(1),e=new pt,s=new Zs;for(let e=t.iterator();e.hasNext();)s.push(e.next());for(;!s.isEmpty();){const t=s.pop();Hr.deleteAllEdges(t);for(let n=t.getOutEdges().getEdges().iterator();n.hasNext();){const t=n.next();t.setMarked(!0);const i=t.getSym();null!==i&&i.setMarked(!0);const r=t.getEdge();e.add(r.getLine());const o=t.getToNode();1===Hr.getDegreeNonDeleted(o)&&s.push(o)}}return e}}class Wr{constructor(){Wr.constructor_.apply(this,arguments)}static constructor_(){if(this._lineStringAdder=new Zr(this),this._graph=null,this._dangles=new L,this._cutEdges=new L,this._invalidRingLines=new L,this._holeList=null,this._shellList=null,this._polyList=null,this._isCheckingRingsValid=!0,this._extractOnlyPolygonal=null,this._geomFactory=null,0===arguments.length)Wr.constructor_.call(this,!1);else if(1===arguments.length){const t=arguments[0];this._extractOnlyPolygonal=t}}static findOuterShells(t){for(let e=t.iterator();e.hasNext();){const t=e.next(),s=t.getOuterHole();null===s||s.isProcessed()||(t.setIncluded(!0),s.setProcessed(!0))}}static extractPolygons(t,e){const s=new L;for(let n=t.iterator();n.hasNext();){const t=n.next();(e||t.isIncluded())&&s.add(t.getPolygon())}return s}static findDisjointShells(t){Wr.findOuterShells(t);let e=null;do{e=!1;for(let s=t.iterator();s.hasNext();){const t=s.next();t.isIncludedSet()||(t.updateIncluded(),t.isIncludedSet()||(e=!0))}}while(e)}getGeometry(){return null===this._geomFactory&&(this._geomFactory=new Lt),this.polygonize(),this._extractOnlyPolygonal?this._geomFactory.buildGeometry(this._polyList):this._geomFactory.createGeometryCollection(Lt.toGeometryArray(this._polyList))}getInvalidRingLines(){return this.polygonize(),this._invalidRingLines}findValidRings(t,e,s){for(let n=t.iterator();n.hasNext();){const t=n.next();t.isValid()?e.add(t):s.add(t.getLineString())}}polygonize(){if(null!==this._polyList)return null;if(this._polyList=new L,null===this._graph)return null;this._dangles=this._graph.deleteDangles(),this._cutEdges=this._graph.deleteCutEdges();const t=this._graph.getEdgeRings();let e=new L;this._invalidRingLines=new L,this._isCheckingRingsValid?this.findValidRings(t,e,this._invalidRingLines):e=t,this.findShellsAndHoles(e),kr.assignHolesToShells(this._holeList,this._shellList),xe.sort(this._shellList,new Vr.EnvelopeComparator);let s=!0;this._extractOnlyPolygonal&&(Wr.findDisjointShells(this._shellList),s=!1),this._polyList=Wr.extractPolygons(this._shellList,s)}getDangles(){return this.polygonize(),this._dangles}add(){if(I(arguments[0],N)){for(let t=arguments[0].iterator();t.hasNext();){const e=t.next();this.add(e)}}else if(arguments[0]instanceof tt){const t=arguments[0];this._geomFactory=t.getFactory(),null===this._graph&&(this._graph=new Hr(this._geomFactory)),this._graph.addEdge(t)}else if(arguments[0]instanceof j){arguments[0].apply(this._lineStringAdder)}}setCheckRingsValid(t){this._isCheckingRingsValid=t}findShellsAndHoles(t){this._holeList=new L,this._shellList=new L;for(let e=t.iterator();e.hasNext();){const t=e.next();t.computeHole(),t.isHole()?this._holeList.add(t):this._shellList.add(t)}}getCutEdges(){return this.polygonize(),this._cutEdges}getPolygons(){return this.polygonize(),this._polyList}}class Zr{constructor(){Zr.constructor_.apply(this,arguments)}static constructor_(){this.p=null;const t=arguments[0];this.p=t}filter(t){t instanceof tt&&this.p.add(t)}get interfaces_(){return[X]}}Wr.LineStringAdder=Zr;var jr=Object.freeze({__proto__:null,Polygonizer:Wr});class Kr{constructor(){Kr.constructor_.apply(this,arguments)}static constructor_(){this._li=new jt,this._ptLocator=new Zn,this._arg=null,this._nodes=new ln(new Fr),this._im=null,this._isolatedEdges=new L,this._invalidPoint=null;const t=arguments[0];this._arg=t}insertEdgeEnds(t){for(let e=t.iterator();e.hasNext();){const t=e.next();this._nodes.add(t)}}computeProperIntersectionIM(t,e){const s=this._arg[0].getGeometry().getDimension(),n=this._arg[1].getGeometry().getDimension(),i=t.hasProperIntersection(),r=t.hasProperInteriorIntersection();2===s&&2===n?i&&e.setAtLeast("212101212"):2===s&&1===n?(i&&e.setAtLeast("FFF0FFFF2"),r&&e.setAtLeast("1FFFFF1FF")):1===s&&2===n?(i&&e.setAtLeast("F0FFFFFF2"),r&&e.setAtLeast("1F1FFFFFF")):1===s&&1===n&&r&&e.setAtLeast("0FFFFFFFF")}labelIsolatedEdges(t,e){for(let s=this._arg[t].getEdgeIterator();s.hasNext();){const t=s.next();t.isIsolated()&&(this.labelIsolatedEdge(t,e,this._arg[e].getGeometry()),this._isolatedEdges.add(t))}}labelIsolatedEdge(t,e,s){if(s.getDimension()>0){const n=this._ptLocator.locate(t.getCoordinate(),s);t.getLabel().setAllLocations(e,n)}else t.getLabel().setAllLocations(e,Qt.EXTERIOR)}computeIM(){const t=new Jt;if(t.set(Qt.EXTERIOR,Qt.EXTERIOR,2),!this._arg[0].getGeometry().getEnvelopeInternal().intersects(this._arg[1].getGeometry().getEnvelopeInternal()))return this.computeDisjointIM(t),t;this._arg[0].computeSelfNodes(this._li,!1),this._arg[1].computeSelfNodes(this._li,!1);const e=this._arg[0].computeEdgeIntersections(this._arg[1],this._li,!1);this.computeIntersectionNodes(0),this.computeIntersectionNodes(1),this.copyNodesAndLabels(0),this.copyNodesAndLabels(1),this.labelIsolatedNodes(),this.computeProperIntersectionIM(e,t);const s=new Mr,n=s.computeEdgeEnds(this._arg[0].getEdgeIterator());this.insertEdgeEnds(n);const i=s.computeEdgeEnds(this._arg[1].getEdgeIterator());return this.insertEdgeEnds(i),this.labelNodeEdges(),this.labelIsolatedEdges(0,1),this.labelIsolatedEdges(1,0),this.updateIM(t),t}labelNodeEdges(){for(let t=this._nodes.iterator();t.hasNext();){t.next().getEdges().computeLabelling(this._arg)}}copyNodesAndLabels(t){for(let e=this._arg[t].getNodeIterator();e.hasNext();){const s=e.next();this._nodes.addNode(s.getCoordinate()).setLabel(t,s.getLabel().getLocation(t))}}labelIntersectionNodes(t){for(let e=this._arg[t].getEdgeIterator();e.hasNext();){const s=e.next(),n=s.getLabel().getLocation(t);for(let e=s.getEdgeIntersectionList().iterator();e.hasNext();){const s=e.next(),i=this._nodes.find(s.coord);i.getLabel().isNull(t)&&(n===Qt.BOUNDARY?i.setLabelBoundary(t):i.setLabel(t,Qt.INTERIOR))}}}labelIsolatedNode(t,e){const s=this._ptLocator.locate(t.getCoordinate(),this._arg[e].getGeometry());t.getLabel().setAllLocations(e,s)}computeIntersectionNodes(t){for(let e=this._arg[t].getEdgeIterator();e.hasNext();){const s=e.next(),n=s.getLabel().getLocation(t);for(let e=s.getEdgeIntersectionList().iterator();e.hasNext();){const s=e.next(),i=this._nodes.addNode(s.coord);n===Qt.BOUNDARY?i.setLabelBoundary(t):i.getLabel().isNull(t)&&i.setLabel(t,Qt.INTERIOR)}}}labelIsolatedNodes(){for(let t=this._nodes.iterator();t.hasNext();){const e=t.next(),s=e.getLabel();h.isTrue(s.getGeometryCount()>0,"node with empty label found"),e.isIsolated()&&(s.isNull(0)?this.labelIsolatedNode(e,0):this.labelIsolatedNode(e,1))}}updateIM(t){for(let e=this._isolatedEdges.iterator();e.hasNext();){e.next().updateIM(t)}for(let e=this._nodes.iterator();e.hasNext();){const s=e.next();s.updateIM(t),s.updateIMFromEdges(t)}}computeDisjointIM(t){const e=this._arg[0].getGeometry();e.isEmpty()||(t.set(Qt.INTERIOR,Qt.EXTERIOR,e.getDimension()),t.set(Qt.BOUNDARY,Qt.EXTERIOR,e.getBoundaryDimension()));const s=this._arg[1].getGeometry();s.isEmpty()||(t.set(Qt.EXTERIOR,Qt.INTERIOR,s.getDimension()),t.set(Qt.EXTERIOR,Qt.BOUNDARY,s.getBoundaryDimension()))}}class Qr{constructor(){Qr.constructor_.apply(this,arguments)}static constructor_(){this._rectEnv=null;const t=arguments[0];this._rectEnv=t.getEnvelopeInternal()}static contains(t,e){return new Qr(t).contains(e)}isContainedInBoundary(t){if(t instanceof Ct)return!1;if(t instanceof Nt)return this.isPointContainedInBoundary(t);if(t instanceof tt)return this.isLineStringContainedInBoundary(t);for(let e=0;e<t.getNumGeometries();e++){const s=t.getGeometryN(e);if(!this.isContainedInBoundary(s))return!1}return!0}isLineSegmentContainedInBoundary(t,e){if(t.equals(e))return this.isPointContainedInBoundary(t);if(t.x===e.x){if(t.x===this._rectEnv.getMinX()||t.x===this._rectEnv.getMaxX())return!0}else if(t.y===e.y&&(t.y===this._rectEnv.getMinY()||t.y===this._rectEnv.getMaxY()))return!0;return!1}isLineStringContainedInBoundary(t){const e=t.getCoordinateSequence(),s=new m,n=new m;for(let t=0;t<e.size()-1;t++)if(e.getCoordinate(t,s),e.getCoordinate(t+1,n),!this.isLineSegmentContainedInBoundary(s,n))return!1;return!0}isPointContainedInBoundary(){if(arguments[0]instanceof Nt){const t=arguments[0];return this.isPointContainedInBoundary(t.getCoordinate())}if(arguments[0]instanceof m){const t=arguments[0];return t.x===this._rectEnv.getMinX()||t.x===this._rectEnv.getMaxX()||t.y===this._rectEnv.getMinY()||t.y===this._rectEnv.getMaxY()}}contains(t){return!!this._rectEnv.contains(t.getEnvelopeInternal())&&!this.isContainedInBoundary(t)}}class Jr{constructor(){Jr.constructor_.apply(this,arguments)}static constructor_(){this._li=new jt,this._rectEnv=null,this._diagUp0=null,this._diagUp1=null,this._diagDown0=null,this._diagDown1=null;const t=arguments[0];this._rectEnv=t,this._diagUp0=new m(t.getMinX(),t.getMinY()),this._diagUp1=new m(t.getMaxX(),t.getMaxY()),this._diagDown0=new m(t.getMinX(),t.getMaxY()),this._diagDown1=new m(t.getMaxX(),t.getMinY())}intersects(t,e){const s=new O(t,e);if(!this._rectEnv.intersects(s))return!1;if(this._rectEnv.intersects(t))return!0;if(this._rectEnv.intersects(e))return!0;if(t.compareTo(e)>0){const s=t;t=e,e=s}let n=!1;return e.y>t.y&&(n=!0),n?this._li.computeIntersection(t,e,this._diagDown0,this._diagDown1):this._li.computeIntersection(t,e,this._diagUp0,this._diagUp1),!!this._li.hasIntersection()}}class $r{constructor(){$r.constructor_.apply(this,arguments)}static constructor_(){this._rectangle=null,this._rectEnv=null;const t=arguments[0];this._rectangle=t,this._rectEnv=t.getEnvelopeInternal()}static intersects(t,e){return new $r(t).intersects(e)}intersects(t){if(!this._rectEnv.intersects(t.getEnvelopeInternal()))return!1;const e=new to(this._rectEnv);if(e.applyTo(t),e.intersects())return!0;const s=new eo(this._rectangle);if(s.applyTo(t),s.containsPoint())return!0;const n=new so(this._rectangle);return n.applyTo(t),!!n.intersects()}}class to extends Ne{constructor(){super(),to.constructor_.apply(this,arguments)}static constructor_(){this._rectEnv=null,this._intersects=!1;const t=arguments[0];this._rectEnv=t}intersects(){return this._intersects}visit(t){const e=t.getEnvelopeInternal();return this._rectEnv.intersects(e)?this._rectEnv.contains(e)||e.getMinX()>=this._rectEnv.getMinX()&&e.getMaxX()<=this._rectEnv.getMaxX()||e.getMinY()>=this._rectEnv.getMinY()&&e.getMaxY()<=this._rectEnv.getMaxY()?(this._intersects=!0,null):void 0:null}isDone(){return!0===this._intersects}}class eo extends Ne{constructor(){super(),eo.constructor_.apply(this,arguments)}static constructor_(){this._rectSeq=null,this._rectEnv=null,this._containsPoint=!1;const t=arguments[0];this._rectSeq=t.getExteriorRing().getCoordinateSequence(),this._rectEnv=t.getEnvelopeInternal()}visit(t){if(!(t instanceof Ct))return null;const e=t.getEnvelopeInternal();if(!this._rectEnv.intersects(e))return null;const s=new m;for(let n=0;n<4;n++)if(this._rectSeq.getCoordinate(n,s),e.contains(s)&&Ze.containsPointInPolygon(s,t))return this._containsPoint=!0,null}containsPoint(){return this._containsPoint}isDone(){return!0===this._containsPoint}}class so extends Ne{constructor(){super(),so.constructor_.apply(this,arguments)}static constructor_(){this._rectEnv=null,this._rectIntersector=null,this._hasIntersection=!1,this._p0=new m,this._p1=new m;const t=arguments[0];this._rectEnv=t.getEnvelopeInternal(),this._rectIntersector=new Jr(this._rectEnv)}intersects(){return this._hasIntersection}isDone(){return!0===this._hasIntersection}visit(t){const e=t.getEnvelopeInternal();if(!this._rectEnv.intersects(e))return null;const s=ye.getLines(t);this.checkIntersectionWithLineStrings(s)}checkIntersectionWithLineStrings(t){for(let e=t.iterator();e.hasNext();){const t=e.next();if(this.checkIntersectionWithSegments(t),this._hasIntersection)return null}}checkIntersectionWithSegments(t){const e=t.getCoordinateSequence();for(let t=1;t<e.size();t++)if(e.getCoordinate(t-1,this._p0),e.getCoordinate(t,this._p1),this._rectIntersector.intersects(this._p0,this._p1))return this._hasIntersection=!0,null}}class no extends ri{constructor(){super(),no.constructor_.apply(this,arguments)}static constructor_(){if(this._relate=null,2===arguments.length){const t=arguments[0],e=arguments[1];ri.constructor_.call(this,t,e),this._relate=new Kr(this._arg)}else if(3===arguments.length){const t=arguments[0],e=arguments[1],s=arguments[2];ri.constructor_.call(this,t,e,s),this._relate=new Kr(this._arg)}}static equalsTopo(t,e){return!!t.getEnvelopeInternal().equals(e.getEnvelopeInternal())&&no.relate(t,e).isEquals(t.getDimension(),e.getDimension())}static relate(){if(2===arguments.length){return new no(arguments[0],arguments[1]).getIntersectionMatrix()}if(3===arguments.length){return new no(arguments[0],arguments[1],arguments[2]).getIntersectionMatrix()}}static overlaps(t,e){return!!t.getEnvelopeInternal().intersects(e.getEnvelopeInternal())&&new no(t,e).getIntersectionMatrix().isOverlaps(t.getDimension(),e.getDimension())}static disjoint(t,e){return!no.intersects(t,e)}static covers(t,e){return!(2===e.getDimension()&&t.getDimension()<2)&&(!(1===e.getDimension()&&t.getDimension()<1&&e.getLength()>0)&&(!!t.getEnvelopeInternal().covers(e.getEnvelopeInternal())&&(!!t.isRectangle()||new no(t,e).getIntersectionMatrix().isCovers())))}static intersects(t,e){if(!t.getEnvelopeInternal().intersects(e.getEnvelopeInternal()))return!1;if(t.isRectangle())return $r.intersects(t,e);if(e.isRectangle())return $r.intersects(e,t);if(t.isGeometryCollection()||e.isGeometryCollection()){for(let s=0;s<t.getNumGeometries();s++)for(let n=0;n<e.getNumGeometries();n++)if(no.intersects(t.getGeometryN(s),e.getGeometryN(n)))return!0;return!1}return new no(t,e).getIntersectionMatrix().isIntersects()}static touches(t,e){return!!t.getEnvelopeInternal().intersects(e.getEnvelopeInternal())&&new no(t,e).getIntersectionMatrix().isTouches(t.getDimension(),e.getDimension())}static crosses(t,e){return!!t.getEnvelopeInternal().intersects(e.getEnvelopeInternal())&&new no(t,e).getIntersectionMatrix().isCrosses(t.getDimension(),e.getDimension())}static contains(t,e){return!(2===e.getDimension()&&t.getDimension()<2)&&(!(1===e.getDimension()&&t.getDimension()<1&&e.getLength()>0)&&(!!t.getEnvelopeInternal().contains(e.getEnvelopeInternal())&&(t.isRectangle()?Qr.contains(t,e):new no(t,e).getIntersectionMatrix().isContains())))}getIntersectionMatrix(){return this._relate.computeIM()}}var io=Object.freeze({__proto__:null,RelateOp:no});class ro{constructor(){ro.constructor_.apply(this,arguments)}static constructor_(){this._geomFactory=null,this._polygons=new L,this._lines=new L,this._points=new L,this._dimension=Z.FALSE}static extract(){if(I(arguments[0],N)){const t=arguments[0],e=new ro;return e.add(t),e}if(arguments[0]instanceof j){const t=arguments[0],e=new ro;return e.add(t),e}}getFactory(){return this._geomFactory}filter(t){return this.recordDimension(t.getDimension()),t instanceof ut||t.isEmpty()?null:t instanceof Ct?(this._polygons.add(t),null):t instanceof tt?(this._lines.add(t),null):t instanceof Nt?(this._points.add(t),null):void h.shouldNeverReachHere("Unhandled geometry type: "+t.getGeometryType())}getExtract(t){switch(t){case 0:return this._points;case 1:return this._lines;case 2:return this._polygons}return h.shouldNeverReachHere("Invalid dimension: "+t),null}recordDimension(t){t>this._dimension&&(this._dimension=t)}getDimension(){return this._dimension}isEmpty(){return this._polygons.isEmpty()&&this._lines.isEmpty()&&this._points.isEmpty()}add(){if(I(arguments[0],N)){const t=arguments[0];for(const e of t)this.add(e)}else if(arguments[0]instanceof j){const t=arguments[0];null===this._geomFactory&&(this._geomFactory=t.getFactory()),t.apply(this)}}get interfaces_(){return[$]}}class oo{constructor(){oo.constructor_.apply(this,arguments)}static constructor_(){this._pointGeom=null,this._otherGeom=null,this._geomFact=null;const t=arguments[0],e=arguments[1];this._pointGeom=t,this._otherGeom=e,this._geomFact=e.getFactory()}static union(t,e){return new oo(t,e).union()}union(){const t=new Zn,e=new at;for(let s=0;s<this._pointGeom.getNumGeometries();s++){const n=this._pointGeom.getGeometryN(s).getCoordinate();t.locate(n,this._otherGeom)===Qt.EXTERIOR&&e.add(n)}if(0===e.size())return this._otherGeom;let s=null;const n=W.toCoordinateArray(e);return s=1===n.length?this._geomFact.createPoint(n[0]):this._geomFact.createMultiPointFromCoords(n),he.combine(s,this._otherGeom)}}class lo{constructor(){lo.constructor_.apply(this,arguments)}static constructor_(){this._geomFactory=null,this._g0=null,this._g1=null,this._isUnionSafe=null;const t=arguments[0],e=arguments[1];this._g0=t,this._g1=e,this._geomFactory=t.getFactory()}static containsProperly(){if(2===arguments.length){const t=arguments[0],e=arguments[1];return!t.isNull()&&(e.getX()>t.getMinX()&&e.getX()<t.getMaxX()&&e.getY()>t.getMinY()&&e.getY()<t.getMaxY())}if(3===arguments.length){const t=arguments[0],e=arguments[1],s=arguments[2];return lo.containsProperly(t,e)&&lo.containsProperly(t,s)}}static union(t,e){return new lo(t,e).union()}static intersects(t,e,s){return t.intersects(e)||t.intersects(s)}static overlapEnvelope(t,e){const s=t.getEnvelopeInternal(),n=e.getEnvelopeInternal();return s.intersection(n)}static extractBorderSegments(t,e,s){t.apply(new class{get interfaces_(){return[P]}filter(t,n){if(n<=0)return null;const i=t.getCoordinate(n-1),r=t.getCoordinate(n);if(lo.intersects(e,i,r)&&!lo.containsProperly(e,i,r)){const t=new Kt(i,r);s.add(t)}}isDone(){return!1}isGeometryChanged(){return!1}})}static unionBuffer(t,e){const s=t.getFactory().createGeometryCollection([t,e]);return bn.bufferOp(s,0)}isBorderSegmentsSame(t,e){const s=this.extractBorderSegments(this._g0,this._g1,e),n=new L;return lo.extractBorderSegments(t,e,n),this.isEqual(s,n)}union(){const t=lo.overlapEnvelope(this._g0,this._g1);if(t.isNull()){const t=this._g0.copy(),e=this._g1.copy();return he.combine(t,e)}const e=new L,s=this.extractByEnvelope(t,this._g0,e),n=this.extractByEnvelope(t,this._g1,e),i=this.unionFull(s,n);let r=null;return this._isUnionSafe=this.isBorderSegmentsSame(i,t),r=this._isUnionSafe?this.combine(i,e):this.unionFull(this._g0,this._g1),r}extractBorderSegments(t,e,s){const n=new L;return lo.extractBorderSegments(t,s,n),null!==e&&lo.extractBorderSegments(e,s,n),n}isUnionOptimized(){return this._isUnionSafe}extractByEnvelope(t,e,s){const n=new L;for(let i=0;i<e.getNumGeometries();i++){const r=e.getGeometryN(i);if(r.getEnvelopeInternal().intersects(t))n.add(r);else{const t=r.copy();s.add(t)}}return this._geomFactory.buildGeometry(n)}isEqual(t,e){if(t.size()!==e.size())return!1;const s=new pt(t);for(const t of e)if(!s.contains(t))return!1;return!0}combine(t,e){if(e.size()<=0)return t;e.add(t);return he.combine(e)}unionFull(t,e){try{return ci.union(t,e)}catch(s){if(s instanceof _s)return lo.unionBuffer(t,e);throw s}}}class ao{constructor(){ao.constructor_.apply(this,arguments)}static constructor_(){this._inputPolys=null,this._geomFactory=null;const t=arguments[0];this._inputPolys=t,null===this._inputPolys&&(this._inputPolys=new L)}static getGeometry(t,e){return e>=t.size()?null:t.get(e)}static union(t){return new ao(t).union()}static restrictToPolygons(t){if(I(t,gt))return t;const e=Ie.getPolygons(t);return 1===e.size()?e.get(0):t.getFactory().createMultiPolygon(Lt.toPolygonArray(e))}reduceToGeometries(t){const e=new L;for(let s=t.iterator();s.hasNext();){const t=s.next();let n=null;I(t,C)?n=this.unionTree(t):t instanceof j&&(n=t),e.add(n)}return e}union(){if(null===this._inputPolys)throw new D("union() method cannot be called twice");if(this._inputPolys.isEmpty())return null;this._geomFactory=this._inputPolys.iterator().next().getFactory();const t=new Os(ao.STRTREE_NODE_CAPACITY);for(let e=this._inputPolys.iterator();e.hasNext();){const s=e.next();t.insert(s.getEnvelopeInternal(),s)}this._inputPolys=null;const e=t.itemsTree();return this.unionTree(e)}binaryUnion(){if(1===arguments.length){const t=arguments[0];return this.binaryUnion(t,0,t.size())}if(3===arguments.length){const t=arguments[0],e=arguments[1],s=arguments[2];if(s-e<=1){const s=ao.getGeometry(t,e);return this.unionSafe(s,null)}if(s-e==2)return this.unionSafe(ao.getGeometry(t,e),ao.getGeometry(t,e+1));{const n=Math.trunc((s+e)/2),i=this.binaryUnion(t,e,n),r=this.binaryUnion(t,n,s);return this.unionSafe(i,r)}}}unionSafe(t,e){return null===t&&null===e?null:null===t?e.copy():null===e?t.copy():this.unionActual(t,e)}unionActual(t,e){const s=lo.union(t,e);return ao.restrictToPolygons(s)}unionTree(t){const e=this.reduceToGeometries(t);return this.binaryUnion(e)}}ao.STRTREE_NODE_CAPACITY=4;class co{constructor(){co.constructor_.apply(this,arguments)}static constructor_(){if(this._geomFact=null,this._extracter=null,1===arguments.length){if(I(arguments[0],N)){const t=arguments[0];this.extract(t)}else if(arguments[0]instanceof j){const t=arguments[0];this.extract(t)}}else if(2===arguments.length){const t=arguments[0],e=arguments[1];this._geomFact=e,this.extract(t)}}static union(){if(1===arguments.length){if(I(arguments[0],N)){return new co(arguments[0]).union()}if(arguments[0]instanceof j){return new co(arguments[0]).union()}}else if(2===arguments.length){return new co(arguments[0],arguments[1]).union()}}extract(){if(I(arguments[0],N)){const t=arguments[0];this._extracter=ro.extract(t)}else if(arguments[0]instanceof j){const t=arguments[0];this._extracter=ro.extract(t)}}unionWithNull(t,e){return null===t&&null===e?null:null===e?t:null===t?e:oi.union(t,e)}unionNoOpt(t){const e=this._geomFact.createPoint();return ai.overlayOp(t,e,oi.UNION)}union(){if(null===this._geomFact&&(this._geomFact=this._extracter.getFactory()),null===this._geomFact)return null;if(this._extracter.isEmpty())return this._geomFact.createEmpty(this._extracter.getDimension());const t=this._extracter.getExtract(0),e=this._extracter.getExtract(1),s=this._extracter.getExtract(2);let n=null;if(t.size()>0){const e=this._geomFact.buildGeometry(t);n=this.unionNoOpt(e)}let i=null;if(e.size()>0){const t=this._geomFact.buildGeometry(e);i=this.unionNoOpt(t)}let r=null;s.size()>0&&(r=ao.union(s));const o=this.unionWithNull(i,r);let l=null;return l=null===n?o:null===o?n:oo.union(n,o),null===l?this._geomFact.createGeometryCollection():l}}var ho=Object.freeze({__proto__:null,UnaryUnionOp:co}),uo=Object.freeze({__proto__:null,ConsistentAreaTester:qr,IsValidOp:zr}),go=Object.freeze({__proto__:null,BoundaryOp:ir,IsSimpleOp:or,buffer:ar,distance:gr,linemerge:Rr,overlay:Or,polygonize:jr,relate:io,union:ho,valid:uo});class _o{constructor(){_o.constructor_.apply(this,arguments)}static constructor_(){if(this._returnToOriginalPrecision=!0,this._cbr=null,0===arguments.length)_o.constructor_.call(this,!0);else if(1===arguments.length){const t=arguments[0];this._returnToOriginalPrecision=t}}computeResultPrecision(t){return this._returnToOriginalPrecision&&this._cbr.addCommonBits(t),t}union(t,e){const s=this.removeCommonBits(t,e);return this.computeResultPrecision(ci.union(s[0],s[1]))}intersection(t,e){const s=this.removeCommonBits(t,e);return this.computeResultPrecision(oi.intersection(s[0],s[1]))}removeCommonBits(){if(1===arguments.length){const t=arguments[0];this._cbr=new qn,this._cbr.add(t);return this._cbr.removeCommonBits(t.copy())}if(2===arguments.length){const t=arguments[0],e=arguments[1];this._cbr=new qn,this._cbr.add(t),this._cbr.add(e);const s=new Array(2).fill(null);return s[0]=this._cbr.removeCommonBits(t.copy()),s[1]=this._cbr.removeCommonBits(e.copy()),s}}buffer(t,e){const s=this.removeCommonBits(t);return this.computeResultPrecision(bn.bufferOp(s,e))}symDifference(t,e){const s=this.removeCommonBits(t,e);return this.computeResultPrecision(oi.symDifference(s[0],s[1]))}difference(t,e){const s=this.removeCommonBits(t,e);return this.computeResultPrecision(oi.difference(s[0],s[1]))}}class po extends ue.CoordinateOperation{constructor(){super(),po.constructor_.apply(this,arguments)}static constructor_(){this._targetPM=null,this._removeCollapsed=!0;const t=arguments[0],e=arguments[1];this._targetPM=t,this._removeCollapsed=e}edit(){if(2===arguments.length&&arguments[1]instanceof j&&arguments[0]instanceof Array){const t=arguments[0],e=arguments[1];if(0===t.length)return null;const s=new Array(t.length).fill(null);for(let e=0;e<t.length;e++){const n=new m(t[e]);this._targetPM.makePrecise(n),s[e]=n}const n=new R(s,!1).toCoordinateArray();let i=0;e instanceof tt&&(i=2),e instanceof et&&(i=4);let r=s;return this._removeCollapsed&&(r=null),n.length<i?r:n}return super.edit.apply(this,arguments)}}class mo{constructor(){mo.constructor_.apply(this,arguments)}static constructor_(){this._targetPM=null,this._removeCollapsed=!0,this._changePrecisionModel=!1,this._isPointwise=!1;const t=arguments[0];this._targetPM=t}static reduce(t,e){return new mo(e).reduce(t)}static reducePointwise(t,e){const s=new mo(e);return s.setPointwise(!0),s.reduce(t)}fixPolygonalTopology(t){let e=t;this._changePrecisionModel||(e=this.changePM(t,this._targetPM));return bn.bufferOp(e,0)}reducePointwise(t){let e=null;if(this._changePrecisionModel){const s=this.createFactory(t.getFactory(),this._targetPM);e=new ue(s)}else e=new ue;let s=this._removeCollapsed;t.getDimension()>=2&&(s=!0);return e.edit(t,new po(this._targetPM,s))}changePM(t,e){return this.createEditor(t.getFactory(),e).edit(t,new ue.NoOpGeometryOperation)}setRemoveCollapsedComponents(t){this._removeCollapsed=t}createFactory(t,e){return new Lt(e,t.getSRID(),t.getCoordinateSequenceFactory())}setChangePrecisionModel(t){this._changePrecisionModel=t}reduce(t){const e=this.reducePointwise(t);return this._isPointwise?e:I(e,gt)?zr.isValid(e)?e:this.fixPolygonalTopology(e):e}setPointwise(t){this._isPointwise=t}createEditor(t,e){if(t.getPrecisionModel()===e)return new ue;const s=this.createFactory(t,e);return new ue(s)}}class fo{constructor(){fo.constructor_.apply(this,arguments)}static constructor_(){if(this._geom=null,this._pts=null,this._start=null,this._end=null,2===arguments.length){const t=arguments[0],e=arguments[1];this._pts=t,this._start=e,this._end=e+1}else if(3===arguments.length){const t=arguments[0],e=arguments[1],s=arguments[2];this._pts=t,this._start=e,this._end=s}else if(4===arguments.length){const t=arguments[0],e=arguments[1],s=arguments[2],n=arguments[3];this._geom=t,this._pts=e,this._start=s,this._end=n}}size(){return this._end-this._start}getCoordinate(t){return this._pts.getCoordinate(this._start+t)}updateNearestLocationsLineLine(t,e,s,n,i,r,o,l){const a=new Kt(e,s),c=new Kt(r,o),h=a.closestPoints(c);l[0]=new cr(this._geom,t,new m(h[0])),l[1]=new cr(n._geom,i,new m(h[1]))}toString(){const t=new v;t.append("LINESTRING ( ");const e=new m;for(let s=this._start;s<this._end;s++)s>this._start&&t.append(", "),this._pts.getCoordinate(s,e),t.append(e.x+" "+e.y);return t.append(" )"),t.toString()}computeDistancePointLine(t,e,s){let n=r.MAX_VALUE;for(let i=e._start;i<e._end-1;i++){const r=e._pts.getCoordinate(i),o=e._pts.getCoordinate(i+1),l=V.pointToSegment(t,r,o);if(l<n&&(n=l,null!==s&&this.updateNearestLocationsPointLine(t,e,i,r,o,s),n<=0))return n}return n}isPoint(){return this._end-this._start==1}distance(t){const e=this.isPoint(),s=t.isPoint();let n=null;if(e&&s){const e=this._pts.getCoordinate(this._start),s=t._pts.getCoordinate(t._start);n=e.distance(s)}else if(e){const e=this._pts.getCoordinate(this._start);n=this.computeDistancePointLine(e,t,null)}else if(s){const e=t._pts.getCoordinate(t._start);n=this.computeDistancePointLine(e,this,null)}else n=this.computeDistanceLineLine(t,null);return n}computeDistanceLineLine(t,e){let s=r.MAX_VALUE;for(let n=this._start;n<this._end-1;n++){const i=this._pts.getCoordinate(n),r=this._pts.getCoordinate(n+1);for(let o=t._start;o<t._end-1;o++){const l=t._pts.getCoordinate(o),a=t._pts.getCoordinate(o+1),c=V.segmentToSegment(i,r,l,a);if(c<s&&(s=c,null!==e&&this.updateNearestLocationsLineLine(n,i,r,t,o,l,a,e),s<=0))return s}}return s}updateNearestLocationsPointLine(t,e,s,n,i,r){r[0]=new cr(this._geom,this._start,new m(t));const o=new Kt(n,i).closestPoint(t);r[1]=new cr(e._geom,s,new m(o))}nearestLocations(t){const e=this.isPoint(),s=t.isPoint(),n=new Array(2).fill(null);if(e&&s){const e=this._pts.getCoordinate(this._start),s=t._pts.getCoordinate(t._start);n[0]=new cr(this._geom,this._start,new m(e)),n[1]=new cr(t._geom,t._start,new m(s))}else if(e){const e=this._pts.getCoordinate(this._start);this.computeDistancePointLine(e,t,n)}else if(s){const e=t._pts.getCoordinate(t._start);this.computeDistancePointLine(e,this,n);const s=n[0];n[0]=n[1],n[1]=s}else this.computeDistanceLineLine(t,n);return n}getEnvelope(){const t=new O;for(let e=this._start;e<this._end;e++)t.expandToInclude(this._pts.getX(e),this._pts.getY(e));return t}}class yo{static addFacetSequences(t,e,s){let n=0;const i=e.size();for(;n<=i-1;){let r=n+yo.FACET_SEQUENCE_SIZE+1;r>=i-1&&(r=i);const o=new fo(t,e,n,r);s.add(o),n+=yo.FACET_SEQUENCE_SIZE}}static build(t){const e=new Os(yo.STR_TREE_NODE_CAPACITY);for(let s=yo.computeFacetSequences(t).iterator();s.hasNext();){const t=s.next();e.insert(t.getEnvelope(),t)}return e.build(),e}static computeFacetSequences(t){const e=new L;return t.apply(new class{get interfaces_(){return[X]}filter(t){let s=null;(t instanceof tt||t instanceof Nt)&&(s=t.getCoordinateSequence(),yo.addFacetSequences(t,s,e))}}),e}}yo.FACET_SEQUENCE_SIZE=6,yo.STR_TREE_NODE_CAPACITY=4;class xo{constructor(){xo.constructor_.apply(this,arguments)}static constructor_(){this._inputGeom=null,this._minClearance=null,this._minClearancePts=null;const t=arguments[0];this._inputGeom=t}static getDistance(t){return new xo(t).getDistance()}static getLine(t){return new xo(t).getLine()}getDistance(){return this.compute(),this._minClearance}compute(){if(null!==this._minClearancePts)return null;if(this._minClearancePts=new Array(2).fill(null),this._minClearance=r.MAX_VALUE,this._inputGeom.isEmpty())return null;const t=yo.build(this._inputGeom).nearestNeighbour(new Eo),e=new Eo;this._minClearance=e.distance(t[0],t[1]),this._minClearancePts=e.getCoordinates()}getLine(){return this.compute(),null===this._minClearancePts||null===this._minClearancePts[0]?this._inputGeom.getFactory().createLineString():this._inputGeom.getFactory().createLineString(this._minClearancePts)}}class Eo{constructor(){Eo.constructor_.apply(this,arguments)}static constructor_(){this._minDist=r.MAX_VALUE,this._minPts=new Array(2).fill(null)}vertexDistance(t,e){for(let s=0;s<t.size();s++)for(let n=0;n<e.size();n++){const i=t.getCoordinate(s),r=e.getCoordinate(n);if(!i.equals2D(r)){const t=i.distance(r);if(t<this._minDist&&(this._minDist=t,this._minPts[0]=i,this._minPts[1]=r,0===t))return t}}return this._minDist}getCoordinates(){return this._minPts}segmentDistance(t,e){for(let s=0;s<t.size();s++)for(let n=1;n<e.size();n++){const i=t.getCoordinate(s),r=e.getCoordinate(n-1),o=e.getCoordinate(n);if(!i.equals2D(r)&&!i.equals2D(o)){const t=V.pointToSegment(i,r,o);if(t<this._minDist&&(this._minDist=t,this.updatePts(i,r,o),0===t))return t}}return this._minDist}distance(){if(arguments[0]instanceof fs&&arguments[1]instanceof fs){const t=arguments[1],e=arguments[0].getItem(),s=t.getItem();return this._minDist=r.MAX_VALUE,this.distance(e,s)}if(arguments[0]instanceof fo&&arguments[1]instanceof fo){const t=arguments[0],e=arguments[1];return this.vertexDistance(t,e),1===t.size()&&1===e.size()?this._minDist:this._minDist<=0?this._minDist:(this.segmentDistance(t,e),this._minDist<=0||this.segmentDistance(e,t),this._minDist)}}updatePts(t,e,s){this._minPts[0]=t;const n=new Kt(e,s);this._minPts[1]=new m(n.closestPoint(t))}get interfaces_(){return[Ps]}}xo.MinClearanceDistance=Eo;class Io{constructor(){Io.constructor_.apply(this,arguments)}static constructor_(){this._inputGeom=null,this._minClearance=null,this._minClearancePts=null;const t=arguments[0];this._inputGeom=t}static getDistance(t){return new Io(t).getDistance()}static getLine(t){return new Io(t).getLine()}getDistance(){return this.compute(),this._minClearance}compute(){if(null!==this._minClearancePts)return null;this._minClearancePts=new Array(2).fill(null),this._minClearance=r.MAX_VALUE,this._inputGeom.apply(new No(this))}updateClearance(){if(3===arguments.length){const t=arguments[0],e=arguments[1],s=arguments[2];t<this._minClearance&&(this._minClearance=t,this._minClearancePts[0]=new m(e),this._minClearancePts[1]=new m(s))}else if(4===arguments.length){const t=arguments[0],e=arguments[1],s=arguments[2],n=arguments[3];if(t<this._minClearance){this._minClearance=t,this._minClearancePts[0]=new m(e);const i=new Kt(s,n);this._minClearancePts[1]=new m(i.closestPoint(e))}}}getLine(){return this.compute(),this._inputGeom.getFactory().createLineString(this._minClearancePts)}}class No{constructor(){No.constructor_.apply(this,arguments)}static constructor_(){this.smc=null;const t=arguments[0];this.smc=t}filter(t){this.smc._inputGeom.apply(new wo(this.smc,t))}get interfaces_(){return[K]}}class wo{constructor(){wo.constructor_.apply(this,arguments)}static constructor_(){this.smc=null,this._queryPt=null;const t=arguments[0],e=arguments[1];this.smc=t,this._queryPt=e}filter(t,e){this.checkVertexDistance(t.getCoordinate(e)),e>0&&this.checkSegmentDistance(t.getCoordinate(e-1),t.getCoordinate(e))}checkSegmentDistance(t,e){if(this._queryPt.equals2D(t)||this._queryPt.equals2D(e))return null;const s=V.pointToSegment(this._queryPt,e,t);s>0&&this.smc.updateClearance(s,this._queryPt,e,t)}isDone(){return!1}isGeometryChanged(){return!1}checkVertexDistance(t){const e=t.distance(this._queryPt);e>0&&this.smc.updateClearance(e,this._queryPt,t)}get interfaces_(){return[P]}}Io.VertexCoordinateFilter=No,Io.ComputeMCCoordinateSequenceFilter=wo;var Co=Object.freeze({__proto__:null,CommonBits:Gn,CommonBitsOp:_o,CommonBitsRemover:qn,EnhancedPrecisionOp:class{static union(t,e){let s=null;try{return ci.union(t,e)}catch(t){if(!(t instanceof a))throw t;s=t}try{const n=new _o(!0).union(t,e);if(!n.isValid())throw s;return n}catch(t){throw t instanceof a?s:t}}static intersection(t,e){let s=null;try{return oi.intersection(t,e)}catch(t){if(!(t instanceof a))throw t;s=t}try{const n=new _o(!0).intersection(t,e);if(!n.isValid())throw s;return n}catch(t){throw t instanceof a?s:t}}static buffer(t,e){let s=null;try{return bn.bufferOp(t,e)}catch(t){if(!(t instanceof a))throw t;s=t}try{const n=new _o(!0).buffer(t,e);if(!n.isValid())throw s;return n}catch(t){throw t instanceof a?s:t}}static symDifference(t,e){let s=null;try{return oi.symDifference(t,e)}catch(t){if(!(t instanceof a))throw t;s=t}try{const n=new _o(!0).symDifference(t,e);if(!n.isValid())throw s;return n}catch(t){throw t instanceof a?s:t}}static difference(t,e){let s=null;try{return oi.difference(t,e)}catch(t){if(!(t instanceof a))throw t;s=t}try{const n=new _o(!0).difference(t,e);if(!n.isValid())throw s;return n}catch(t){throw t instanceof a?s:t}}},GeometryPrecisionReducer:mo,MinimumClearance:xo,SimpleMinimumClearance:Io});class So{constructor(){So.constructor_.apply(this,arguments)}static constructor_(){this._pts=null,this._usePt=null,this._distanceTolerance=null,this._seg=new Kt;const t=arguments[0];this._pts=t}static simplify(t,e){const s=new So(t);return s.setDistanceTolerance(e),s.simplify()}setDistanceTolerance(t){this._distanceTolerance=t}simplifySection(t,e){if(t+1===e)return null;this._seg.p0=this._pts[t],this._seg.p1=this._pts[e];let s=-1,n=t;for(let i=t+1;i<e;i++){const t=this._seg.distance(this._pts[i]);t>s&&(s=t,n=i)}if(s<=this._distanceTolerance)for(let s=t+1;s<e;s++)this._usePt[s]=!1;else this.simplifySection(t,n),this.simplifySection(n,e)}simplify(){this._usePt=new Array(this._pts.length).fill(null);for(let t=0;t<this._pts.length;t++)this._usePt[t]=!0;this.simplifySection(0,this._pts.length-1);const t=new R;for(let e=0;e<this._pts.length;e++)this._usePt[e]&&t.add(new m(this._pts[e]));return t.toCoordinateArray()}}class Lo{constructor(){Lo.constructor_.apply(this,arguments)}static constructor_(){this._inputGeom=null,this._distanceTolerance=null,this._isEnsureValidTopology=!0;const t=arguments[0];this._inputGeom=t}static simplify(t,e){const s=new Lo(t);return s.setDistanceTolerance(e),s.getResultGeometry()}setDistanceTolerance(t){if(t<0)throw new n("Tolerance must be non-negative");this._distanceTolerance=t}getResultGeometry(){return this._inputGeom.isEmpty()?this._inputGeom.copy():new To(this._isEnsureValidTopology,this._distanceTolerance).transform(this._inputGeom)}setEnsureValid(t){this._isEnsureValidTopology=t}}class To extends me{constructor(){super(),To.constructor_.apply(this,arguments)}static constructor_(){this._isEnsureValidTopology=!0,this._distanceTolerance=null;const t=arguments[0],e=arguments[1];this._isEnsureValidTopology=t,this._distanceTolerance=e}transformPolygon(t,e){if(t.isEmpty())return null;const s=super.transformPolygon.call(this,t,e);return e instanceof dt?s:this.createValidArea(s)}createValidArea(t){return this._isEnsureValidTopology?bn.bufferOp(t,0):t}transformCoordinates(t,e){const s=t.toCoordinateArray();let n=null;return n=0===s.length?new Array(0).fill(null):So.simplify(s,this._distanceTolerance),this._factory.getCoordinateSequenceFactory().create(n)}transformMultiPolygon(t,e){const s=super.transformMultiPolygon.call(this,t,e);return this.createValidArea(s)}transformLinearRing(t,e){const s=e instanceof Ct,n=super.transformLinearRing.call(this,t,e);return!s||n instanceof et?n:null}}Lo.DPTransformer=To;class Ro extends Kt{constructor(){super(),Ro.constructor_.apply(this,arguments)}static constructor_(){if(this._parent=null,this._index=null,2===arguments.length){const t=arguments[0],e=arguments[1];Ro.constructor_.call(this,t,e,null,-1)}else if(4===arguments.length){const t=arguments[0],e=arguments[1],s=arguments[2],n=arguments[3];Kt.constructor_.call(this,t,e),this._parent=s,this._index=n}}getParent(){return this._parent}getIndex(){return this._index}}class Po{constructor(){Po.constructor_.apply(this,arguments)}static constructor_(){if(this._parentLine=null,this._segs=null,this._resultSegs=new L,this._minimumSize=null,1===arguments.length){const t=arguments[0];Po.constructor_.call(this,t,2)}else if(2===arguments.length){const t=arguments[0],e=arguments[1];this._parentLine=t,this._minimumSize=e,this.init()}}static extractCoordinates(t){const e=new Array(t.size()+1).fill(null);let s=null;for(let n=0;n<t.size();n++)s=t.get(n),e[n]=s.p0;return e[e.length-1]=s.p1,e}addToResult(t){this._resultSegs.add(t)}asLineString(){return this._parentLine.getFactory().createLineString(Po.extractCoordinates(this._resultSegs))}getResultSize(){const t=this._resultSegs.size();return 0===t?0:t+1}getParentCoordinates(){return this._parentLine.getCoordinates()}getMinimumSize(){return this._minimumSize}asLinearRing(){return this._parentLine.getFactory().createLinearRing(Po.extractCoordinates(this._resultSegs))}getSegments(){return this._segs}init(){const t=this._parentLine.getCoordinates();this._segs=new Array(t.length-1).fill(null);for(let e=0;e<t.length-1;e++){const s=new Ro(t[e],t[e+1],this._parentLine,e);this._segs[e]=s}}getResultCoordinates(){return Po.extractCoordinates(this._resultSegs)}getParent(){return this._parentLine}getSegment(t){return this._segs[t]}}class Oo{constructor(){Oo.constructor_.apply(this,arguments)}static constructor_(){this._index=new Wi}add(){if(arguments[0]instanceof Po){const t=arguments[0].getSegments();for(let e=0;e<t.length;e++){const s=t[e];this.add(s)}}else if(arguments[0]instanceof Kt){const t=arguments[0];this._index.insert(new O(t.p0,t.p1),t)}}query(t){const e=new O(t.p0,t.p1),s=new vo(t);this._index.query(e,s);return s.getItems()}remove(t){this._index.remove(new O(t.p0,t.p1),t)}}class vo{constructor(){vo.constructor_.apply(this,arguments)}static constructor_(){this._querySeg=null,this._items=new L;const t=arguments[0];this._querySeg=t}getItems(){return this._items}visitItem(t){const e=t;O.intersects(e.p0,e.p1,this._querySeg.p0,this._querySeg.p1)&&this._items.add(t)}get interfaces_(){return[De]}}class Mo{constructor(){Mo.constructor_.apply(this,arguments)}static constructor_(){this._li=new jt,this._inputIndex=new Oo,this._outputIndex=new Oo,this._line=null,this._linePts=null,this._distanceTolerance=0;const t=arguments[0],e=arguments[1];this._inputIndex=t,this._outputIndex=e}static isInLineSection(t,e,s){if(s.getParent()!==t.getParent())return!1;const n=s.getIndex();return n>=e[0]&&n<e[1]}flatten(t,e){const s=this._linePts[t],n=this._linePts[e],i=new Kt(s,n);return this.remove(this._line,t,e),this._outputIndex.add(i),i}hasBadIntersection(t,e,s){return!!this.hasBadOutputIntersection(s)||!!this.hasBadInputIntersection(t,e,s)}setDistanceTolerance(t){this._distanceTolerance=t}simplifySection(t,e,s){s+=1;const n=new Array(2).fill(null);if(t+1===e){const e=this._line.getSegment(t);return this._line.addToResult(e),null}let i=!0;if(this._line.getResultSize()<this._line.getMinimumSize()){s+1<this._line.getMinimumSize()&&(i=!1)}const r=new Array(1).fill(null),o=this.findFurthestPoint(this._linePts,t,e,r);r[0]>this._distanceTolerance&&(i=!1);const l=new Kt;if(l.p0=this._linePts[t],l.p1=this._linePts[e],n[0]=t,n[1]=e,this.hasBadIntersection(this._line,n,l)&&(i=!1),i){const s=this.flatten(t,e);return this._line.addToResult(s),null}this.simplifySection(t,o,s),this.simplifySection(o,e,s)}hasBadOutputIntersection(t){for(let e=this._outputIndex.query(t).iterator();e.hasNext();){const s=e.next();if(this.hasInteriorIntersection(s,t))return!0}return!1}hasInteriorIntersection(t,e){return this._li.computeIntersection(t.p0,t.p1,e.p0,e.p1),this._li.isInteriorIntersection()}hasBadInputIntersection(t,e,s){for(let n=this._inputIndex.query(s).iterator();n.hasNext();){const i=n.next();if(this.hasInteriorIntersection(i,s)){if(Mo.isInLineSection(t,e,i))continue;return!0}}return!1}findFurthestPoint(t,e,s,n){const i=new Kt;i.p0=t[e],i.p1=t[s];let r=-1,o=e;for(let n=e+1;n<s;n++){const e=t[n],s=i.distance(e);s>r&&(r=s,o=n)}return n[0]=r,o}simplify(t){this._line=t,this._linePts=t.getParentCoordinates(),this.simplifySection(0,this._linePts.length-1,0)}remove(t,e,s){for(let n=e;n<s;n++){const e=t.getSegment(n);this._inputIndex.remove(e)}}}class bo{constructor(){bo.constructor_.apply(this,arguments)}static constructor_(){this._inputIndex=new Oo,this._outputIndex=new Oo,this._distanceTolerance=0}setDistanceTolerance(t){this._distanceTolerance=t}simplify(t){for(let e=t.iterator();e.hasNext();)this._inputIndex.add(e.next());for(let e=t.iterator();e.hasNext();){const t=new Mo(this._inputIndex,this._outputIndex);t.setDistanceTolerance(this._distanceTolerance),t.simplify(e.next())}}}class Do{constructor(){Do.constructor_.apply(this,arguments)}static constructor_(){this._inputGeom=null,this._lineSimplifier=new bo,this._linestringMap=null;const t=arguments[0];this._inputGeom=t}static simplify(t,e){const s=new Do(t);return s.setDistanceTolerance(e),s.getResultGeometry()}setDistanceTolerance(t){if(t<0)throw new n("Tolerance must be non-negative");this._lineSimplifier.setDistanceTolerance(t)}getResultGeometry(){if(this._inputGeom.isEmpty())return this._inputGeom.copy();this._linestringMap=new ft,this._inputGeom.apply(new Fo(this)),this._lineSimplifier.simplify(this._linestringMap.values());return new Ao(this._linestringMap).transform(this._inputGeom)}}class Ao extends me{constructor(){super(),Ao.constructor_.apply(this,arguments)}static constructor_(){this._linestringMap=null;const t=arguments[0];this._linestringMap=t}transformCoordinates(t,e){if(0===t.size())return null;if(e instanceof tt){const t=this._linestringMap.get(e);return this.createCoordinateSequence(t.getResultCoordinates())}return super.transformCoordinates.call(this,t,e)}}class Fo{constructor(){Fo.constructor_.apply(this,arguments)}static constructor_(){this.tps=null;const t=arguments[0];this.tps=t}filter(t){if(t instanceof tt){const e=t;if(e.isEmpty())return null;const s=e.isClosed()?4:2,n=new Po(e,s);this.tps._linestringMap.put(e,n)}}get interfaces_(){return[X]}}Do.LineStringTransformer=Ao,Do.LineStringMapBuilderFilter=Fo;class Go{constructor(){Go.constructor_.apply(this,arguments)}static constructor_(){this._pts=null,this._tolerance=null;const t=arguments[0],e=arguments[1];this._pts=t,this._tolerance=e*e}static simplify(t,e){return new Go(t,e).simplify()}simplifyVertex(t){let e=t,s=e.getArea(),n=null;for(;null!==e;){const t=e.getArea();t<s&&(s=t,n=e),e=e._next}return null!==n&&s<this._tolerance&&n.remove(),t.isLive()?s:-1}simplify(){const t=qo.buildLine(this._pts);let e=this._tolerance;do{e=this.simplifyVertex(t)}while(e<this._tolerance);const s=t.getCoordinates();return s.length<2?[s[0],new m(s[0])]:s}}class qo{constructor(){qo.constructor_.apply(this,arguments)}static constructor_(){this._pt=null,this._prev=null,this._next=null,this._area=qo.MAX_AREA,this._isLive=!0;const t=arguments[0];this._pt=t}static buildLine(t){let e=null,s=null;for(let n=0;n<t.length;n++){const i=new qo(t[n]);null===e&&(e=i),i.setPrev(s),null!==s&&(s.setNext(i),s.updateArea()),s=i}return e}getCoordinates(){const t=new R;let e=this;do{t.add(e._pt,!1),e=e._next}while(null!==e);return t.toCoordinateArray()}getArea(){return this._area}updateArea(){if(null===this._prev||null===this._next)return this._area=qo.MAX_AREA,null;this._area=Math.abs(se.area(this._prev._pt,this._pt,this._next._pt))}remove(){const t=this._prev,e=this._next;let s=null;return null!==this._prev&&(this._prev.setNext(e),this._prev.updateArea(),s=this._prev),null!==this._next&&(this._next.setPrev(t),this._next.updateArea(),null===s&&(s=this._next)),this._isLive=!1,s}isLive(){return this._isLive}setPrev(t){this._prev=t}setNext(t){this._next=t}}qo.MAX_AREA=r.MAX_VALUE,Go.VWVertex=qo;class Bo{constructor(){Bo.constructor_.apply(this,arguments)}static constructor_(){this._inputGeom=null,this._distanceTolerance=null,this._isEnsureValidTopology=!0;const t=arguments[0];this._inputGeom=t}static simplify(t,e){const s=new Bo(t);return s.setDistanceTolerance(e),s.getResultGeometry()}setDistanceTolerance(t){if(t<0)throw new n("Tolerance must be non-negative");this._distanceTolerance=t}getResultGeometry(){return this._inputGeom.isEmpty()?this._inputGeom.copy():new Yo(this._isEnsureValidTopology,this._distanceTolerance).transform(this._inputGeom)}setEnsureValid(t){this._isEnsureValidTopology=t}}class Yo extends me{constructor(){super(),Yo.constructor_.apply(this,arguments)}static constructor_(){this._isEnsureValidTopology=!0,this._distanceTolerance=null;const t=arguments[0],e=arguments[1];this._isEnsureValidTopology=t,this._distanceTolerance=e}transformPolygon(t,e){if(t.isEmpty())return null;const s=super.transformPolygon.call(this,t,e);return e instanceof dt?s:this.createValidArea(s)}createValidArea(t){return this._isEnsureValidTopology?bn.bufferOp(t,0):t}transformCoordinates(t,e){const s=t.toCoordinateArray();let n=null;return n=0===s.length?new Array(0).fill(null):Go.simplify(s,this._distanceTolerance),this._factory.getCoordinateSequenceFactory().create(n)}transformMultiPolygon(t,e){const s=super.transformMultiPolygon.call(this,t,e);return this.createValidArea(s)}transformLinearRing(t,e){const s=e instanceof Ct,n=super.transformLinearRing.call(this,t,e);return!s||n instanceof et?n:null}}Bo.VWTransformer=Yo;var zo=Object.freeze({__proto__:null,DouglasPeuckerSimplifier:Lo,TopologyPreservingSimplifier:Do,VWSimplifier:Bo});class Vo{locate(t){}}class ko{constructor(){ko.constructor_.apply(this,arguments)}static constructor_(){this._subdiv=null,this._lastEdge=null;const t=arguments[0];this._subdiv=t,this.init()}init(){this._lastEdge=this.findEdge()}locate(t){this._lastEdge.isLive()||this.init();const e=this._subdiv.locateFromEdge(t,this._lastEdge);return this._lastEdge=e,e}findEdge(){return this._subdiv.getEdges().iterator().next()}get interfaces_(){return[Vo]}}class Xo{constructor(){Xo.constructor_.apply(this,arguments)}static constructor_(){if(this._ls=null,this._data=null,2===arguments.length){const t=arguments[0],e=arguments[1];this._ls=new Kt(t,e)}else if(3===arguments.length){const t=arguments[0],e=arguments[1],s=arguments[2];this._ls=new Kt(t,e),this._data=s}else if(6===arguments.length){const t=arguments[0],e=arguments[1],s=arguments[2],n=arguments[3],i=arguments[4],r=arguments[5];Xo.constructor_.call(this,new m(t,e,s),new m(n,i,r))}else if(7===arguments.length){const t=arguments[0],e=arguments[1],s=arguments[2],n=arguments[3],i=arguments[4],r=arguments[5],o=arguments[6];Xo.constructor_.call(this,new m(t,e,s),new m(n,i,r),o)}}getStartZ(){return this._ls.getCoordinate(0).getZ()}intersection(t){return this._ls.intersection(t.getLineSegment())}getStart(){return this._ls.getCoordinate(0)}getEnd(){return this._ls.getCoordinate(1)}getEndY(){return this._ls.getCoordinate(1).y}getStartX(){return this._ls.getCoordinate(0).x}setData(t){this._data=t}getData(){return this._data}getEndX(){return this._ls.getCoordinate(1).x}toString(){return this._ls.toString()}getLineSegment(){return this._ls}getEndZ(){return this._ls.getCoordinate(1).getZ()}equalsTopo(t){return this._ls.equalsTopo(t.getLineSegment())}getStartY(){return this._ls.getCoordinate(0).y}}class Uo{constructor(){Uo.constructor_.apply(this,arguments)}static constructor_(){this._seg=null,this._segLen=null,this._splitPt=null,this._minimumLen=0;const t=arguments[0];this._seg=t,this._segLen=t.getLength()}static pointAlongReverse(t,e){const s=new m;return s.x=t.p1.x-e*(t.p1.x-t.p0.x),s.y=t.p1.y-e*(t.p1.y-t.p0.y),s}splitAt(){if(1===arguments.length){const t=arguments[0],e=this._minimumLen/this._segLen;if(t.distance(this._seg.p0)<this._minimumLen)return this._splitPt=this._seg.pointAlong(e),null;if(t.distance(this._seg.p1)<this._minimumLen)return this._splitPt=Uo.pointAlongReverse(this._seg,e),null;this._splitPt=t}else if(2===arguments.length){const t=arguments[0],e=arguments[1],s=this.getConstrainedLength(t)/this._segLen;e.equals2D(this._seg.p0)?this._splitPt=this._seg.pointAlong(s):this._splitPt=Uo.pointAlongReverse(this._seg,s)}}getSplitPoint(){return this._splitPt}getConstrainedLength(t){return t<this._minimumLen?this._minimumLen:t}setMinimumLength(t){this._minimumLen=t}}class Ho{findSplitPoint(t,e){}}class Wo{static projectedSplitPoint(t,e){return t.getLineSegment().project(e)}findSplitPoint(t,e){const s=t.getLineSegment(),n=s.getLength()/2,i=new Uo(s),r=Wo.projectedSplitPoint(t,e);let o=2*r.distance(e)*.8;return o>n&&(o=n),i.setMinimumLength(o),i.splitAt(r),i.getSplitPoint()}get interfaces_(){return[Ho]}}class Zo{static checkRobustInCircle(t,e,s,n){const i=Zo.isInCircleNonRobust(t,e,s,n),r=Zo.isInCircleDDSlow(t,e,s,n),o=Zo.isInCircleCC(t,e,s,n),l=se.circumcentre(t,e,s);Y.out.println("p radius diff a = "+Math.abs(n.distance(l)-t.distance(l))/t.distance(l)),i===r&&i===o||(Y.out.println("inCircle robustness failure (double result = "+i+", DD result = "+r+", CC result = "+o+")"),Y.out.println(Wt.toLineString(new it([t,e,s,n]))),Y.out.println("Circumcentre = "+Wt.toPoint(l)+" radius = "+t.distance(l)),Y.out.println("p radius diff a = "+Math.abs(n.distance(l)/t.distance(l)-1)),Y.out.println("p radius diff b = "+Math.abs(n.distance(l)/e.distance(l)-1)),Y.out.println("p radius diff c = "+Math.abs(n.distance(l)/s.distance(l)-1)),Y.out.println())}static isInCircleDDFast(t,e,s,n){const i=A.sqr(t.x).selfAdd(A.sqr(t.y)).selfMultiply(Zo.triAreaDDFast(e,s,n)),r=A.sqr(e.x).selfAdd(A.sqr(e.y)).selfMultiply(Zo.triAreaDDFast(t,s,n)),o=A.sqr(s.x).selfAdd(A.sqr(s.y)).selfMultiply(Zo.triAreaDDFast(t,e,n)),l=A.sqr(n.x).selfAdd(A.sqr(n.y)).selfMultiply(Zo.triAreaDDFast(t,e,s));return i.selfSubtract(r).selfAdd(o).selfSubtract(l).doubleValue()>0}static isInCircleCC(t,e,s,n){const i=se.circumcentre(t,e,s),r=t.distance(i);return n.distance(i)-r<=0}static isInCircleNormalized(t,e,s,n){const i=t.x-n.x,r=t.y-n.y,o=e.x-n.x,l=e.y-n.y,a=s.x-n.x,c=s.y-n.y;return(i*i+r*r)*(o*c-a*l)+(o*o+l*l)*(a*r-i*c)+(a*a+c*c)*(i*l-o*r)>0}static isInCircleDDSlow(t,e,s,n){const i=A.valueOf(n.x),r=A.valueOf(n.y),o=A.valueOf(t.x),l=A.valueOf(t.y),a=A.valueOf(e.x),c=A.valueOf(e.y),h=A.valueOf(s.x),u=A.valueOf(s.y),g=o.multiply(o).add(l.multiply(l)).multiply(Zo.triAreaDDSlow(a,c,h,u,i,r)),d=a.multiply(a).add(c.multiply(c)).multiply(Zo.triAreaDDSlow(o,l,h,u,i,r)),_=h.multiply(h).add(u.multiply(u)).multiply(Zo.triAreaDDSlow(o,l,a,c,i,r)),p=i.multiply(i).add(r.multiply(r)).multiply(Zo.triAreaDDSlow(o,l,a,c,h,u));return g.subtract(d).add(_).subtract(p).doubleValue()>0}static isInCircleNonRobust(t,e,s,n){return(t.x*t.x+t.y*t.y)*Zo.triArea(e,s,n)-(e.x*e.x+e.y*e.y)*Zo.triArea(t,s,n)+(s.x*s.x+s.y*s.y)*Zo.triArea(t,e,n)-(n.x*n.x+n.y*n.y)*Zo.triArea(t,e,s)>0}static isInCircleRobust(t,e,s,n){return Zo.isInCircleNormalized(t,e,s,n)}static triAreaDDSlow(t,e,s,n,i,r){return s.subtract(t).multiply(r.subtract(e)).subtract(n.subtract(e).multiply(i.subtract(t)))}static triAreaDDFast(t,e,s){const n=A.valueOf(e.x).selfSubtract(t.x).selfMultiply(A.valueOf(s.y).selfSubtract(t.y)),i=A.valueOf(e.y).selfSubtract(t.y).selfMultiply(A.valueOf(s.x).selfSubtract(t.x));return n.selfSubtract(i)}static triArea(t,e,s){return(e.x-t.x)*(s.y-t.y)-(e.y-t.y)*(s.x-t.x)}static isInCircleDDNormalized(t,e,s,n){const i=A.valueOf(t.x).selfSubtract(n.x),r=A.valueOf(t.y).selfSubtract(n.y),o=A.valueOf(e.x).selfSubtract(n.x),l=A.valueOf(e.y).selfSubtract(n.y),a=A.valueOf(s.x).selfSubtract(n.x),c=A.valueOf(s.y).selfSubtract(n.y),h=i.multiply(l).selfSubtract(o.multiply(r)),u=o.multiply(c).selfSubtract(a.multiply(l)),g=a.multiply(r).selfSubtract(i.multiply(c)),d=i.multiply(i).selfAdd(r.multiply(r)),_=o.multiply(o).selfAdd(l.multiply(l)),p=a.multiply(a).selfAdd(c.multiply(c));return d.selfMultiply(u).selfAdd(_.selfMultiply(g)).selfAdd(p.selfMultiply(h)).doubleValue()>0}}class jo{constructor(){jo.constructor_.apply(this,arguments)}static constructor_(){if(this._p=null,1===arguments.length){const t=arguments[0];this._p=new m(t)}else if(2===arguments.length){const t=arguments[0],e=arguments[1];this._p=new m(t,e)}else if(3===arguments.length){const t=arguments[0],e=arguments[1],s=arguments[2];this._p=new m(t,e,s)}}static interpolateZ(){if(3===arguments.length){const t=arguments[0],e=arguments[1],s=arguments[2],n=e.distance(s),i=t.distance(e),r=s.getZ()-e.getZ();return e.getZ()+r*(i/n)}if(4===arguments.length){const t=arguments[0],e=arguments[1],s=arguments[2],n=arguments[3],i=e.x,r=e.y,o=s.x-i,l=n.x-i,a=s.y-r,c=n.y-r,h=o*c-l*a,u=t.x-i,g=t.y-r,d=(c*u-l*g)/h,_=(-a*u+o*g)/h;return e.getZ()+d*(s.getZ()-e.getZ())+_*(n.getZ()-e.getZ())}}magn(){return Math.sqrt(this._p.x*this._p.x+this._p.y*this._p.y)}equals(){if(1===arguments.length){const t=arguments[0];return this._p.x===t.getX()&&this._p.y===t.getY()}if(2===arguments.length){const t=arguments[0],e=arguments[1];return this._p.distance(t.getCoordinate())<e}}rightOf(t){return this.isCCW(t.dest(),t.orig())}isCCW(t,e){return(t._p.x-this._p.x)*(e._p.y-this._p.y)-(t._p.y-this._p.y)*(e._p.x-this._p.x)>0}getX(){return this._p.x}crossProduct(t){return this._p.x*t.getY()-this._p.y*t.getX()}setZ(t){this._p.setZ(t)}times(t){return new jo(t*this._p.x,t*this._p.y)}cross(){return new jo(this._p.y,-this._p.x)}leftOf(t){return this.isCCW(t.orig(),t.dest())}getY(){return this._p.y}classify(t,e){const s=this,n=e.sub(t),i=s.sub(t),r=n.crossProduct(i);return r>0?jo.LEFT:r<0?jo.RIGHT:n.getX()*i.getX()<0||n.getY()*i.getY()<0?jo.BEHIND:n.magn()<i.magn()?jo.BEYOND:t.equals(s)?jo.ORIGIN:e.equals(s)?jo.DESTINATION:jo.BETWEEN}circumRadiusRatio(t,e){const s=this.circleCenter(t,e),n=this.distance(s,t);let i=this.distance(this,t),r=this.distance(t,e);return r<i&&(i=r),r=this.distance(e,this),r<i&&(i=r),n/i}circleCenter(t,e){const s=new jo(this.getX(),this.getY()),n=this.bisector(s,t),i=this.bisector(t,e),r=new ee(n,i);let o=null;try{o=new jo(r.getX(),r.getY())}catch(n){if(!(n instanceof te))throw n;Y.err.println("a: "+s+"  b: "+t+"  c: "+e),Y.err.println(n)}return o}dot(t){return this._p.x*t.getX()+this._p.y*t.getY()}getZ(){return this._p.getZ()}bisector(t,e){const s=e.getX()-t.getX(),n=e.getY()-t.getY(),i=new ee(t.getX()+s/2,t.getY()+n/2,1),r=new ee(t.getX()-n+s/2,t.getY()+s+n/2,1);return new ee(i,r)}getCoordinate(){return this._p}isInCircle(t,e,s){return Zo.isInCircleRobust(t._p,e._p,s._p,this._p)}interpolateZValue(t,e,s){const n=t.getX(),i=t.getY(),r=e.getX()-n,o=s.getX()-n,l=e.getY()-i,a=s.getY()-i,c=r*a-o*l,h=this.getX()-n,u=this.getY()-i,g=(a*h-o*u)/c,d=(-l*h+r*u)/c;return t.getZ()+g*(e.getZ()-t.getZ())+d*(s.getZ()-t.getZ())}midPoint(t){const e=(this._p.x+t.getX())/2,s=(this._p.y+t.getY())/2,n=(this._p.getZ()+t.getZ())/2;return new jo(e,s,n)}toString(){return"POINT ("+this._p.x+" "+this._p.y+")"}sub(t){return new jo(this._p.x-t.getX(),this._p.y-t.getY())}sum(t){return new jo(this._p.x+t.getX(),this._p.y+t.getY())}distance(t,e){return Math.sqrt(Math.pow(e.getX()-t.getX(),2)+Math.pow(e.getY()-t.getY(),2))}}jo.LEFT=0,jo.RIGHT=1,jo.BEYOND=2,jo.BEHIND=3,jo.BETWEEN=4,jo.ORIGIN=5,jo.DESTINATION=6;class Ko extends jo{constructor(){super(),Ko.constructor_.apply(this,arguments)}static constructor_(){this._isOnConstraint=null,this._constraint=null;const t=arguments[0];jo.constructor_.call(this,t)}getConstraint(){return this._constraint}setOnConstraint(t){this._isOnConstraint=t}setConstraint(t){this._isOnConstraint=!0,this._constraint=t}merge(t){t._isOnConstraint&&(this._isOnConstraint=!0,this._constraint=t._constraint)}isOnConstraint(){return this._isOnConstraint}}class Qo{constructor(){Qo.constructor_.apply(this,arguments)}static constructor_(){this._rot=null,this._vertex=null,this._next=null,this._data=null}static swap(t){const e=t.oPrev(),s=t.sym().oPrev();Qo.splice(t,e),Qo.splice(t.sym(),s),Qo.splice(t,e.lNext()),Qo.splice(t.sym(),s.lNext()),t.setOrig(e.dest()),t.setDest(s.dest())}static splice(t,e){const s=t.oNext().rot(),n=e.oNext().rot(),i=e.oNext(),r=t.oNext(),o=n.oNext(),l=s.oNext();t.setNext(i),e.setNext(r),s.setNext(o),n.setNext(l)}static makeEdge(t,e){const s=new Qo,n=new Qo,i=new Qo,r=new Qo;s._rot=n,n._rot=i,i._rot=r,r._rot=s,s.setNext(s),n.setNext(r),i.setNext(i),r.setNext(n);const o=s;return o.setOrig(t),o.setDest(e),o}static connect(t,e){const s=Qo.makeEdge(t.dest(),e.orig());return Qo.splice(s,t.lNext()),Qo.splice(s.sym(),e),s}equalsNonOriented(t){return!!this.equalsOriented(t)||!!this.equalsOriented(t.sym())}oNext(){return this._next}equalsOriented(t){return!(!this.orig().getCoordinate().equals2D(t.orig().getCoordinate())||!this.dest().getCoordinate().equals2D(t.dest().getCoordinate()))}dNext(){return this.sym().oNext().sym()}lPrev(){return this._next.sym()}rPrev(){return this.sym().oNext()}rot(){return this._rot}oPrev(){return this._rot._next._rot}sym(){return this._rot._rot}setOrig(t){this._vertex=t}lNext(){return this.invRot().oNext().rot()}getLength(){return this.orig().getCoordinate().distance(this.dest().getCoordinate())}setData(t){this._data=t}getData(){return this._data}delete(){this._rot=null}toString(){const t=this._vertex.getCoordinate(),e=this.dest().getCoordinate();return Wt.toLineString(t,e)}isLive(){return null!==this._rot}getPrimary(){return this.orig().getCoordinate().compareTo(this.dest().getCoordinate())<=0?this:this.sym()}toLineSegment(){return new Kt(this._vertex.getCoordinate(),this.dest().getCoordinate())}dest(){return this.sym().orig()}invRot(){return this._rot.sym()}setDest(t){this.sym().setOrig(t)}orig(){return this._vertex}rNext(){return this._rot._next.invRot()}dPrev(){return this.invRot().oNext().invRot()}setNext(t){this._next=t}}class Jo{constructor(){Jo.constructor_.apply(this,arguments)}static constructor_(){this._subdiv=null,this._isUsingTolerance=!1;const t=arguments[0];this._subdiv=t,this._isUsingTolerance=t.getTolerance()>0}insertSite(t){let e=this._subdiv.locate(t);if(this._subdiv.isVertexOfEdge(e,t))return e;this._subdiv.isOnEdge(e,t.getCoordinate())&&(e=e.oPrev(),this._subdiv.delete(e.oNext()));let s=this._subdiv.makeEdge(e.orig(),t);Qo.splice(s,e);const n=s;do{s=this._subdiv.connect(e,s.sym()),e=s.oPrev()}while(e.lNext()!==n);for(;;){const i=e.oPrev();if(i.dest().rightOf(e)&&t.isInCircle(e.orig(),i.dest(),e.dest()))Qo.swap(e),e=e.oPrev();else{if(e.oNext()===n)return s;e=e.oNext().lPrev()}}}insertSites(t){for(let e=t.iterator();e.hasNext();){const t=e.next();this.insertSite(t)}}}class $o extends a{constructor(){super(),$o.constructor_.apply(this,arguments)}static constructor_(){if(this._seg=null,1===arguments.length){if("string"==typeof arguments[0]){const t=arguments[0];a.constructor_.call(this,t)}else if(arguments[0]instanceof Kt){const t=arguments[0];a.constructor_.call(this,"Locate failed to converge (at edge: "+t+").  Possible causes include invalid Subdivision topology or very close sites"),this._seg=new Kt(t)}}else if(2===arguments.length){const t=arguments[0],e=arguments[1];a.constructor_.call(this,$o.msgWithSpatial(t,e)),this._seg=new Kt(e)}}static msgWithSpatial(t,e){return null!==e?t+" [ "+e+" ]":t}getSegment(){return this._seg}}class tl{visit(t){}}class el{constructor(){el.constructor_.apply(this,arguments)}static constructor_(){this._visitedKey=0,this._quadEdges=new L,this._startingEdge=null,this._tolerance=null,this._edgeCoincidenceTolerance=null,this._frameVertex=new Array(3).fill(null),this._frameEnv=null,this._locator=null,this._seg=new Kt,this._triEdges=new Array(3).fill(null);const t=arguments[0],e=arguments[1];this._tolerance=e,this._edgeCoincidenceTolerance=e/el.EDGE_COINCIDENCE_TOL_FACTOR,this.createFrame(t),this._startingEdge=this.initSubdiv(),this._locator=new ko(this)}static getTriangleEdges(t,e){if(e[0]=t,e[1]=e[0].lNext(),e[2]=e[1].lNext(),e[2].lNext()!==e[0])throw new n("Edges do not form a triangle")}getTriangleVertices(t){const e=new il;return this.visitTriangles(e,t),e.getTriangleVertices()}isFrameVertex(t){return!!t.equals(this._frameVertex[0])||(!!t.equals(this._frameVertex[1])||!!t.equals(this._frameVertex[2]))}isVertexOfEdge(t,e){return!(!e.equals(t.orig(),this._tolerance)&&!e.equals(t.dest(),this._tolerance))}connect(t,e){const s=Qo.connect(t,e);return this._quadEdges.add(s),s}visitTriangles(t,e){this._visitedKey++;const s=new Zs;s.push(this._startingEdge);const n=new pt;for(;!s.empty();){const i=s.pop();if(!n.contains(i)){const r=this.fetchTriangleToVisit(i,s,e,n);null!==r&&t.visit(r)}}}isFrameEdge(t){return!(!this.isFrameVertex(t.orig())&&!this.isFrameVertex(t.dest()))}isOnEdge(t,e){this._seg.setCoordinates(t.orig().getCoordinate(),t.dest().getCoordinate());return this._seg.distance(e)<this._edgeCoincidenceTolerance}getEnvelope(){return new O(this._frameEnv)}getVertexUniqueEdges(t){const e=new L,s=new pt;for(let n=this._quadEdges.iterator();n.hasNext();){const i=n.next(),r=i.orig();s.contains(r)||(s.add(r),!t&&this.isFrameVertex(r)||e.add(i));const o=i.sym(),l=o.orig();s.contains(l)||(s.add(l),!t&&this.isFrameVertex(l)||e.add(o))}return e}locateFromEdge(t,e){let s=0;const n=this._quadEdges.size();let i=e;for(;;){if(s++,s>n)throw new $o(i.toLineSegment());if(t.equals(i.orig())||t.equals(i.dest()))break;if(t.rightOf(i))i=i.sym();else if(t.rightOf(i.oNext())){if(t.rightOf(i.dPrev()))break;i=i.dPrev()}else i=i.oNext()}return i}getVoronoiDiagram(t){const e=this.getVoronoiCellPolygons(t);return t.createGeometryCollection(Lt.toGeometryArray(e))}getTriangles(t){const e=this.getTriangleCoordinates(!1),s=new Array(e.size()).fill(null);let n=0;for(let i=e.iterator();i.hasNext();){const e=i.next();s[n++]=t.createPolygon(t.createLinearRing(e))}return t.createGeometryCollection(s)}getVoronoiCellPolygon(t,e){const s=new L,n=t;do{const e=t.rot().orig().getCoordinate();s.add(e),t=t.oPrev()}while(t!==n);const i=new R;i.addAll(s,!1),i.closeRing(),i.size()<4&&(Y.out.println(i),i.add(i.get(i.size()-1),!0));const r=i.toCoordinateArray(),o=e.createPolygon(e.createLinearRing(r)),l=n.orig();return o.setUserData(l.getCoordinate()),o}setLocator(t){this._locator=t}initSubdiv(){const t=this.makeEdge(this._frameVertex[0],this._frameVertex[1]),e=this.makeEdge(this._frameVertex[1],this._frameVertex[2]);Qo.splice(t.sym(),e);const s=this.makeEdge(this._frameVertex[2],this._frameVertex[0]);return Qo.splice(e.sym(),s),Qo.splice(s.sym(),t),t}isFrameBorderEdge(t){const e=new Array(3).fill(null);el.getTriangleEdges(t,e);const s=new Array(3).fill(null);el.getTriangleEdges(t.sym(),s);const n=t.lNext().dest();if(this.isFrameVertex(n))return!0;const i=t.sym().lNext().dest();return!!this.isFrameVertex(i)}makeEdge(t,e){const s=Qo.makeEdge(t,e);return this._quadEdges.add(s),s}createFrame(t){const e=t.getWidth(),s=t.getHeight();let n=0;n=e>s?10*e:10*s,this._frameVertex[0]=new jo((t.getMaxX()+t.getMinX())/2,t.getMaxY()+n),this._frameVertex[1]=new jo(t.getMinX()-n,t.getMinY()-n),this._frameVertex[2]=new jo(t.getMaxX()+n,t.getMinY()-n),this._frameEnv=new O(this._frameVertex[0].getCoordinate(),this._frameVertex[1].getCoordinate()),this._frameEnv.expandToInclude(this._frameVertex[2].getCoordinate())}getTriangleCoordinates(t){const e=new rl;return this.visitTriangles(e,t),e.getTriangles()}getVertices(t){const e=new pt;for(let s=this._quadEdges.iterator();s.hasNext();){const n=s.next(),i=n.orig();!t&&this.isFrameVertex(i)||e.add(i);const r=n.dest();!t&&this.isFrameVertex(r)||e.add(r)}return e}fetchTriangleToVisit(t,e,s,n){let i=t,r=0,o=!1;do{this._triEdges[r]=i,this.isFrameEdge(i)&&(o=!0);const t=i.sym();n.contains(t)||e.push(t),n.add(i),r++,i=i.lNext()}while(i!==t);return o&&!s?null:this._triEdges}getEdges(){if(0===arguments.length)return this._quadEdges;if(1===arguments.length){const t=arguments[0],e=this.getPrimaryEdges(!1),s=new Array(e.size()).fill(null);let n=0;for(let i=e.iterator();i.hasNext();){const e=i.next();s[n++]=t.createLineString([e.orig().getCoordinate(),e.dest().getCoordinate()])}return t.createMultiLineString(s)}}getTriangleEdges(t){const e=new nl;return this.visitTriangles(e,t),e.getTriangleEdges()}getPrimaryEdges(t){this._visitedKey++;const e=new L,s=new Zs;s.push(this._startingEdge);const n=new pt;for(;!s.empty();){const i=s.pop();if(!n.contains(i)){const r=i.getPrimary();!t&&this.isFrameEdge(r)||e.add(r),s.push(i.oNext()),s.push(i.sym().oNext()),n.add(i),n.add(i.sym())}}return e}delete(t){Qo.splice(t,t.oPrev()),Qo.splice(t.sym(),t.sym().oPrev());const e=t.sym(),s=t.rot(),n=t.rot().sym();this._quadEdges.remove(t),this._quadEdges.remove(e),this._quadEdges.remove(s),this._quadEdges.remove(n),t.delete(),e.delete(),s.delete(),n.delete()}getTolerance(){return this._tolerance}getVoronoiCellPolygons(t){this.visitTriangles(new sl,!0);const e=new L;for(let s=this.getVertexUniqueEdges(!1).iterator();s.hasNext();){const n=s.next();e.add(this.getVoronoiCellPolygon(n,t))}return e}insertSite(t){let e=this.locate(t);if(t.equals(e.orig(),this._tolerance)||t.equals(e.dest(),this._tolerance))return e;let s=this.makeEdge(e.orig(),t);Qo.splice(s,e);const n=s;do{s=this.connect(e,s.sym()),e=s.oPrev()}while(e.lNext()!==n);return n}locate(){if(1===arguments.length){if(arguments[0]instanceof jo){const t=arguments[0];return this._locator.locate(t)}if(arguments[0]instanceof m){const t=arguments[0];return this._locator.locate(new jo(t))}}else if(2===arguments.length){const t=arguments[0],e=arguments[1],s=this._locator.locate(new jo(t));if(null===s)return null;let n=s;s.dest().getCoordinate().equals2D(t)&&(n=s.sym());let i=n;do{if(i.dest().getCoordinate().equals2D(e))return i;i=i.oNext()}while(i!==n);return null}}}class sl{visit(t){const e=t[0].orig().getCoordinate(),s=t[1].orig().getCoordinate(),n=t[2].orig().getCoordinate(),i=se.circumcentreDD(e,s,n),r=new jo(i);for(let e=0;e<3;e++)t[e].rot().setOrig(r)}get interfaces_(){return[tl]}}class nl{constructor(){nl.constructor_.apply(this,arguments)}static constructor_(){this._triList=new L}getTriangleEdges(){return this._triList}visit(t){this._triList.add(t)}get interfaces_(){return[tl]}}class il{constructor(){il.constructor_.apply(this,arguments)}static constructor_(){this._triList=new L}getTriangleVertices(){return this._triList}visit(t){this._triList.add([t[0].orig(),t[1].orig(),t[2].orig()])}get interfaces_(){return[tl]}}class rl{constructor(){rl.constructor_.apply(this,arguments)}static constructor_(){this._coordList=new R,this._triCoords=new L}checkTriangleSize(t){t.length>=2?Wt.toLineString(t[0],t[1]):t.length>=1&&Wt.toPoint(t[0])}visit(t){this._coordList.clear();for(let e=0;e<3;e++){const s=t[e].orig();this._coordList.add(s.getCoordinate())}if(this._coordList.size()>0){this._coordList.closeRing();const t=this._coordList.toCoordinateArray();if(4!==t.length)return null;this._triCoords.add(t)}}getTriangles(){return this._triCoords}get interfaces_(){return[tl]}}el.TriangleCircumcentreVisitor=sl,el.TriangleEdgesListVisitor=nl,el.TriangleVertexListVisitor=il,el.TriangleCoordinatesVisitor=rl,el.EDGE_COINCIDENCE_TOL_FACTOR=1e3;class ll extends a{constructor(){super(),ll.constructor_.apply(this,arguments)}static constructor_(){if(this._pt=null,1===arguments.length){const t=arguments[0];a.constructor_.call(this,t)}else if(2===arguments.length){const t=arguments[0],e=arguments[1];a.constructor_.call(this,ll.msgWithCoord(t,e)),this._pt=new m(e)}}static msgWithCoord(t,e){return null!==e?t+" [ "+Wt.toPoint(e)+" ]":t}getCoordinate(){return this._pt}}class al{constructor(){al.constructor_.apply(this,arguments)}static constructor_(){this._initialVertices=null,this._segVertices=null,this._segments=new L,this._subdiv=null,this._incDel=null,this._convexHull=null,this._splitFinder=new Wo,this._kdt=null,this._vertexFactory=null,this._computeAreaEnv=null,this._splitPt=null,this._tolerance=null;const t=arguments[0],e=arguments[1];this._initialVertices=new L(t),this._tolerance=e,this._kdt=new qi(e)}static computeVertexEnvelope(t){const e=new O;for(let s=t.iterator();s.hasNext();){const t=s.next();e.expandToInclude(t.getCoordinate())}return e}getInitialVertices(){return this._initialVertices}getKDT(){return this._kdt}setConstraints(t,e){this._segments=t,this._segVertices=e}computeConvexHull(){const t=new Lt,e=this.getPointArray(),s=new _i(e,t);this._convexHull=s.getConvexHull()}addConstraintVertices(){this.computeConvexHull(),this.insertSites(this._segVertices)}getTolerance(){return this._tolerance}setVertexFactory(t){this._vertexFactory=t}formInitialDelaunay(){this.computeBoundingBox(),this._subdiv=new el(this._computeAreaEnv,this._tolerance),this._subdiv.setLocator(new ko(this._subdiv)),this._incDel=new Jo(this._subdiv),this.insertSites(this._initialVertices)}insertSite(){if(arguments[0]instanceof Ko){const t=arguments[0],e=this._kdt.insert(t.getCoordinate(),t);if(e.isRepeated()){const s=e.getData();return s.merge(t),s}return this._incDel.insertSite(t),t}if(arguments[0]instanceof m){const t=arguments[0];this.insertSite(this.createVertex(t))}}enforceConstraints(){this.addConstraintVertices();let t=0,e=0;do{e=this.enforceGabriel(this._segments),t++}while(e>0&&t<al.MAX_SPLIT_ITER);if(t===al.MAX_SPLIT_ITER)throw new ll("Too many splitting iterations while enforcing constraints.  Last split point was at: ",this._splitPt)}insertSites(t){for(let e=t.iterator();e.hasNext();){const t=e.next();this.insertSite(t)}}getVertexFactory(){return this._vertexFactory}getPointArray(){const t=new Array(this._initialVertices.size()+this._segVertices.size()).fill(null);let e=0;for(let s=this._initialVertices.iterator();s.hasNext();){const n=s.next();t[e++]=n.getCoordinate()}for(let s=this._segVertices.iterator();s.hasNext();){const n=s.next();t[e++]=n.getCoordinate()}return t}findNonGabrielPoint(t){const e=t.getStart(),s=t.getEnd(),n=new m((e.x+s.x)/2,(e.y+s.y)/2),i=e.distance(n),o=new O(n);o.expandBy(i);const l=this._kdt.query(o);let a=null,c=r.MAX_VALUE;for(let t=l.iterator();t.hasNext();){const r=t.next().getCoordinate();if(r.equals2D(e)||r.equals2D(s))continue;const o=n.distance(r);if(o<i){(null===a||o<c)&&(a=r,c=o)}}return a}getConstraintSegments(){return this._segments}setSplitPointFinder(t){this._splitFinder=t}getConvexHull(){return this._convexHull}enforceGabriel(t){const e=new L;let s=0;const n=new L;for(let i=t.iterator();i.hasNext();){const t=i.next(),r=this.findNonGabrielPoint(t);if(null===r)continue;this._splitPt=this._splitFinder.findSplitPoint(t,r);const o=this.createVertex(this._splitPt,t);this.insertSite(o).getCoordinate().equals2D(this._splitPt);const l=new Xo(t.getStartX(),t.getStartY(),t.getStartZ(),o.getX(),o.getY(),o.getZ(),t.getData()),a=new Xo(o.getX(),o.getY(),o.getZ(),t.getEndX(),t.getEndY(),t.getEndZ(),t.getData());e.add(l),e.add(a),n.add(t),s+=1}return t.removeAll(n),t.addAll(e),s}createVertex(){if(1===arguments.length){const t=arguments[0];let e=null;return e=null!==this._vertexFactory?this._vertexFactory.createVertex(t,null):new Ko(t),e}if(2===arguments.length){const t=arguments[0],e=arguments[1];let s=null;return s=null!==this._vertexFactory?this._vertexFactory.createVertex(t,e):new Ko(t),s.setOnConstraint(!0),s}}getSubdivision(){return this._subdiv}computeBoundingBox(){const t=al.computeVertexEnvelope(this._initialVertices),e=al.computeVertexEnvelope(this._segVertices),s=new O(t);s.expandToInclude(e);const n=.2*s.getWidth(),i=.2*s.getHeight(),r=Math.max(n,i);this._computeAreaEnv=new O(s),this._computeAreaEnv.expandBy(r)}}al.MAX_SPLIT_ITER=99;class cl{constructor(){cl.constructor_.apply(this,arguments)}static constructor_(){this._siteCoords=null,this._tolerance=0,this._subdiv=null}static envelope(t){const e=new O;for(let s=t.iterator();s.hasNext();){const t=s.next();e.expandToInclude(t)}return e}static unique(t){const e=W.copyDeep(t);ht.sort(e);return new R(e,!1)}static extractUniqueCoordinates(t){if(null===t)return new R;const e=t.getCoordinates();return cl.unique(e)}static toVertices(t){const e=new L;for(let s=t.iterator();s.hasNext();){const t=s.next();e.add(new jo(t))}return e}create(){if(null!==this._subdiv)return null;const t=cl.envelope(this._siteCoords),e=cl.toVertices(this._siteCoords);this._subdiv=new el(t,this._tolerance);new Jo(this._subdiv).insertSites(e)}setTolerance(t){this._tolerance=t}setSites(){if(arguments[0]instanceof j){const t=arguments[0];this._siteCoords=cl.extractUniqueCoordinates(t)}else if(I(arguments[0],N)){const t=arguments[0];this._siteCoords=cl.unique(W.toCoordinateArray(t))}}getEdges(t){return this.create(),this._subdiv.getEdges(t)}getSubdivision(){return this.create(),this._subdiv}getTriangles(t){return this.create(),this._subdiv.getTriangles(t)}}class hl{constructor(){hl.constructor_.apply(this,arguments)}static constructor_(){this._siteCoords=null,this._constraintLines=null,this._tolerance=0,this._subdiv=null,this._constraintVertexMap=new os}static createConstraintSegments(){if(1===arguments.length){const t=arguments[0],e=ye.getLines(t),s=new L;for(let t=e.iterator();t.hasNext();){const e=t.next();hl.createConstraintSegments(e,s)}return s}if(2===arguments.length){const t=arguments[1],e=arguments[0].getCoordinates();for(let s=1;s<e.length;s++)t.add(new Xo(e[s-1],e[s]))}}createSiteVertices(t){const e=new L;for(let s=t.iterator();s.hasNext();){const t=s.next();this._constraintVertexMap.containsKey(t)||e.add(new Ko(t))}return e}create(){if(null!==this._subdiv)return null;const t=cl.envelope(this._siteCoords);let e=new L;null!==this._constraintLines&&(t.expandToInclude(this._constraintLines.getEnvelopeInternal()),this.createVertices(this._constraintLines),e=hl.createConstraintSegments(this._constraintLines));const s=this.createSiteVertices(this._siteCoords),n=new al(s,this._tolerance);n.setConstraints(e,new L(this._constraintVertexMap.values())),n.formInitialDelaunay(),n.enforceConstraints(),this._subdiv=n.getSubdivision()}setTolerance(t){this._tolerance=t}setConstraints(t){this._constraintLines=t}setSites(t){this._siteCoords=cl.extractUniqueCoordinates(t)}getEdges(t){return this.create(),this._subdiv.getEdges(t)}getSubdivision(){return this.create(),this._subdiv}getTriangles(t){return this.create(),this._subdiv.getTriangles(t)}createVertices(t){const e=t.getCoordinates();for(let t=0;t<e.length;t++){const s=new Ko(e[t]);this._constraintVertexMap.put(e[t],s)}}}class ul{constructor(){ul.constructor_.apply(this,arguments)}static constructor_(){this._siteCoords=null,this._tolerance=0,this._subdiv=null,this._clipEnv=null,this._diagramEnv=null}static clipGeometryCollection(t,e){const s=t.getFactory().toGeometry(e),n=new L;for(let i=0;i<t.getNumGeometries();i++){const r=t.getGeometryN(i);let o=null;e.contains(r.getEnvelopeInternal())?o=r:e.intersects(r.getEnvelopeInternal())&&(o=oi.intersection(s,r),o.setUserData(r.getUserData())),null===o||o.isEmpty()||n.add(o)}return t.getFactory().createGeometryCollection(Lt.toGeometryArray(n))}create(){if(null!==this._subdiv)return null;const t=cl.envelope(this._siteCoords);if(this._diagramEnv=this._clipEnv,null===this._diagramEnv){this._diagramEnv=t;const e=this._diagramEnv.getDiameter();this._diagramEnv.expandBy(e)}const e=cl.toVertices(this._siteCoords);this._subdiv=new el(t,this._tolerance);new Jo(this._subdiv).insertSites(e)}setSites(){if(arguments[0]instanceof j){const t=arguments[0];this._siteCoords=cl.extractUniqueCoordinates(t)}else if(I(arguments[0],N)){const t=arguments[0];this._siteCoords=cl.unique(W.toCoordinateArray(t))}}setClipEnvelope(t){this._clipEnv=t}getSubdivision(){return this.create(),this._subdiv}getDiagram(t){this.create();const e=this._subdiv.getVoronoiDiagram(t);return ul.clipGeometryCollection(e,this._diagramEnv)}setTolerance(t){this._tolerance=t}}var gl=Object.freeze({__proto__:null,Vertex:jo}),dl=Object.freeze({__proto__:null,ConformingDelaunayTriangulationBuilder:hl,DelaunayTriangulationBuilder:cl,VoronoiDiagramBuilder:ul,quadedge:gl});class _l{constructor(){_l.constructor_.apply(this,arguments)}static constructor_(){if(this._linearGeom=null,this._numLines=null,this._currentLine=null,this._componentIndex=0,this._vertexIndex=0,1===arguments.length){const t=arguments[0];_l.constructor_.call(this,t,0,0)}else if(2===arguments.length){const t=arguments[0],e=arguments[1];_l.constructor_.call(this,t,e.getComponentIndex(),_l.segmentEndVertexIndex(e))}else if(3===arguments.length){const t=arguments[0],e=arguments[1],s=arguments[2];if(!I(t,Q))throw new n("Lineal geometry is required");this._linearGeom=t,this._numLines=t.getNumGeometries(),this._componentIndex=e,this._vertexIndex=s,this.loadCurrentLine()}}static segmentEndVertexIndex(t){return t.getSegmentFraction()>0?t.getSegmentIndex()+1:t.getSegmentIndex()}getComponentIndex(){return this._componentIndex}getLine(){return this._currentLine}getVertexIndex(){return this._vertexIndex}getSegmentEnd(){return this._vertexIndex<this.getLine().getNumPoints()-1?this._currentLine.getCoordinateN(this._vertexIndex+1):null}next(){if(!this.hasNext())return null;this._vertexIndex++,this._vertexIndex>=this._currentLine.getNumPoints()&&(this._componentIndex++,this.loadCurrentLine(),this._vertexIndex=0)}loadCurrentLine(){if(this._componentIndex>=this._numLines)return this._currentLine=null,null;this._currentLine=this._linearGeom.getGeometryN(this._componentIndex)}getSegmentStart(){return this._currentLine.getCoordinateN(this._vertexIndex)}isEndOfLine(){return!(this._componentIndex>=this._numLines)&&!(this._vertexIndex<this._currentLine.getNumPoints()-1)}hasNext(){return!(this._componentIndex>=this._numLines)&&!(this._componentIndex===this._numLines-1&&this._vertexIndex>=this._currentLine.getNumPoints())}}class pl{constructor(){pl.constructor_.apply(this,arguments)}static constructor_(){this._linearGeom=null;const t=arguments[0];this._linearGeom=t}static indexOf(t,e){return new pl(t).indexOf(e)}static indexOfAfter(t,e,s){return new pl(t).indexOfAfter(e,s)}segmentNearestMeasure(t,e,s){const n=t.projectionFactor(e);return n<=0?s:n<=1?s+n*t.getLength():s+t.getLength()}indexOfFromStart(t,e){let s=r.MAX_VALUE,n=e,i=0;const o=new Kt,l=new _l(this._linearGeom);for(;l.hasNext();){if(!l.isEndOfLine()){o.p0=l.getSegmentStart(),o.p1=l.getSegmentEnd();const r=o.distance(t),a=this.segmentNearestMeasure(o,t,i);r<s&&a>e&&(n=a,s=r),i+=o.getLength()}l.next()}return n}indexOf(t){return this.indexOfFromStart(t,-1)}indexOfAfter(t,e){if(e<0)return this.indexOf(t);const s=this._linearGeom.getLength();if(s<e)return s;const n=this.indexOfFromStart(t,e);return h.isTrue(n>=e,"computed index is before specified minimum index"),n}}class ml{constructor(){ml.constructor_.apply(this,arguments)}static constructor_(){this._geomFact=null,this._lines=new L,this._coordList=null,this._ignoreInvalidLines=!1,this._fixInvalidLines=!1,this._lastPt=null;const t=arguments[0];this._geomFact=t}getGeometry(){return this.endLine(),this._geomFact.buildGeometry(this._lines)}getLastCoordinate(){return this._lastPt}endLine(){if(null===this._coordList)return null;if(this._ignoreInvalidLines&&this._coordList.size()<2)return this._coordList=null,null;const t=this._coordList.toCoordinateArray();let e=t;this._fixInvalidLines&&(e=this.validCoordinateSequence(t)),this._coordList=null;let s=null;try{s=this._geomFact.createLineString(e)}catch(t){if(!(t instanceof n))throw t;if(!this._ignoreInvalidLines)throw t}null!==s&&this._lines.add(s)}setFixInvalidLines(t){this._fixInvalidLines=t}add(){if(1===arguments.length){const t=arguments[0];this.add(t,!0)}else if(2===arguments.length){const t=arguments[0],e=arguments[1];null===this._coordList&&(this._coordList=new R),this._coordList.add(t,e),this._lastPt=t}}setIgnoreInvalidLines(t){this._ignoreInvalidLines=t}validCoordinateSequence(t){if(t.length>=2)return t;return[t[0],t[0]]}}class fl{constructor(){fl.constructor_.apply(this,arguments)}static constructor_(){this._line=null;const t=arguments[0];this._line=t}static extract(t,e,s){return new fl(t).extract(e,s)}extract(t,e){return e.compareTo(t)<0?this.reverse(this.computeLinear(e,t)):this.computeLinear(t,e)}computeLine(t,e){const s=this._line.getCoordinates(),n=new R;let i=t.getSegmentIndex();t.getSegmentFraction()>0&&(i+=1);let r=e.getSegmentIndex();1===e.getSegmentFraction()&&(r+=1),r>=s.length&&(r=s.length-1),t.isVertex()||n.add(t.getCoordinate(this._line));for(let t=i;t<=r;t++)n.add(s[t]);e.isVertex()||n.add(e.getCoordinate(this._line)),n.size()<=0&&n.add(t.getCoordinate(this._line));let o=n.toCoordinateArray();return o.length<=1&&(o=[o[0],o[0]]),this._line.getFactory().createLineString(o)}reverse(t){return I(t,Q)?t.reverse():(h.shouldNeverReachHere("non-linear geometry encountered"),null)}computeLinear(t,e){const s=new ml(this._line.getFactory());s.setFixInvalidLines(!0),t.isVertex()||s.add(t.getCoordinate(this._line));for(let n=new _l(this._line,t);n.hasNext()&&!(e.compareLocationValues(n.getComponentIndex(),n.getVertexIndex(),0)<0);n.next()){const t=n.getSegmentStart();s.add(t),n.isEndOfLine()&&s.endLine()}return e.isVertex()||s.add(e.getCoordinate(this._line)),s.getGeometry()}}class yl{constructor(){yl.constructor_.apply(this,arguments)}static constructor_(){if(this._componentIndex=0,this._segmentIndex=0,this._segmentFraction=0,0===arguments.length);else if(1===arguments.length){const t=arguments[0];this._componentIndex=t._componentIndex,this._segmentIndex=t._segmentIndex,this._segmentFraction=t._segmentFraction}else if(2===arguments.length){const t=arguments[0],e=arguments[1];yl.constructor_.call(this,0,t,e)}else if(3===arguments.length){const t=arguments[0],e=arguments[1],s=arguments[2];this._componentIndex=t,this._segmentIndex=e,this._segmentFraction=s,this.normalize()}else if(4===arguments.length){const t=arguments[0],e=arguments[1],s=arguments[2],n=arguments[3];this._componentIndex=t,this._segmentIndex=e,this._segmentFraction=s,n&&this.normalize()}}static numSegments(t){const e=t.getNumPoints();return e<=1?0:e-1}static compareLocationValues(t,e,s,n,i,r){return t<n?-1:t>n?1:e<i?-1:e>i?1:s<r?-1:s>r?1:0}static pointAlongSegmentByFraction(t,e,s){if(s<=0)return t;if(s>=1)return e;const n=(e.x-t.x)*s+t.x,i=(e.y-t.y)*s+t.y,r=(e.getZ()-t.getZ())*s+t.getZ();return new m(n,i,r)}static getEndLocation(t){const e=new yl;return e.setToEnd(t),e}getSegmentIndex(){return this._segmentIndex}getComponentIndex(){return this._componentIndex}getSegmentFraction(){return this._segmentFraction}setToEnd(t){this._componentIndex=t.getNumGeometries()-1;const e=t.getGeometryN(this._componentIndex);this._segmentIndex=yl.numSegments(e),this._segmentFraction=0}compareTo(t){const e=t;return this._componentIndex<e._componentIndex?-1:this._componentIndex>e._componentIndex?1:this._segmentIndex<e._segmentIndex?-1:this._segmentIndex>e._segmentIndex?1:this._segmentFraction<e._segmentFraction?-1:this._segmentFraction>e._segmentFraction?1:0}copy(){return new yl(this._componentIndex,this._segmentIndex,this._segmentFraction)}toString(){return"LinearLoc["+this._componentIndex+", "+this._segmentIndex+", "+this._segmentFraction+"]"}compareLocationValues(t,e,s){return this._componentIndex<t?-1:this._componentIndex>t?1:this._segmentIndex<e?-1:this._segmentIndex>e?1:this._segmentFraction<s?-1:this._segmentFraction>s?1:0}getSegmentLength(t){const e=t.getGeometryN(this._componentIndex);let s=this._segmentIndex;this._segmentIndex>=yl.numSegments(e)&&(s=e.getNumPoints()-2);const n=e.getCoordinateN(s),i=e.getCoordinateN(s+1);return n.distance(i)}isVertex(){return this._segmentFraction<=0||this._segmentFraction>=1}isEndpoint(t){const e=t.getGeometryN(this._componentIndex),s=yl.numSegments(e);return this._segmentIndex>=s||this._segmentIndex===s-1&&this._segmentFraction>=1}isValid(t){if(this._componentIndex<0||this._componentIndex>=t.getNumGeometries())return!1;const e=t.getGeometryN(this._componentIndex);return!(this._segmentIndex<0||this._segmentIndex>e.getNumPoints())&&((this._segmentIndex!==e.getNumPoints()||0===this._segmentFraction)&&!(this._segmentFraction<0||this._segmentFraction>1))}normalize(){this._segmentFraction<0&&(this._segmentFraction=0),this._segmentFraction>1&&(this._segmentFraction=1),this._componentIndex<0&&(this._componentIndex=0,this._segmentIndex=0,this._segmentFraction=0),this._segmentIndex<0&&(this._segmentIndex=0,this._segmentFraction=0),1===this._segmentFraction&&(this._segmentFraction=0,this._segmentIndex+=1)}toLowest(t){const e=t.getGeometryN(this._componentIndex),s=yl.numSegments(e);return this._segmentIndex<s?this:new yl(this._componentIndex,s-1,1,!1)}getCoordinate(t){const e=t.getGeometryN(this._componentIndex),s=e.getCoordinateN(this._segmentIndex);if(this._segmentIndex>=yl.numSegments(e))return s;const n=e.getCoordinateN(this._segmentIndex+1);return yl.pointAlongSegmentByFraction(s,n,this._segmentFraction)}getSegment(t){const e=t.getGeometryN(this._componentIndex),s=e.getCoordinateN(this._segmentIndex);if(this._segmentIndex>=yl.numSegments(e)){const t=e.getCoordinateN(e.getNumPoints()-2);return new Kt(t,s)}const n=e.getCoordinateN(this._segmentIndex+1);return new Kt(s,n)}clamp(t){if(this._componentIndex>=t.getNumGeometries())return this.setToEnd(t),null;if(this._segmentIndex>=t.getNumPoints()){const e=t.getGeometryN(this._componentIndex);this._segmentIndex=yl.numSegments(e),this._segmentFraction=1}}isOnSameSegment(t){return this._componentIndex===t._componentIndex&&(this._segmentIndex===t._segmentIndex||(t._segmentIndex-this._segmentIndex==1&&0===t._segmentFraction||this._segmentIndex-t._segmentIndex==1&&0===this._segmentFraction))}snapToVertex(t,e){if(this._segmentFraction<=0||this._segmentFraction>=1)return null;const s=this.getSegmentLength(t),n=this._segmentFraction*s,i=s-n;n<=i&&n<e?this._segmentFraction=0:i<=n&&i<e&&(this._segmentFraction=1)}get interfaces_(){return[o]}}class xl{constructor(){xl.constructor_.apply(this,arguments)}static constructor_(){this._linearGeom=null;const t=arguments[0];this._linearGeom=t}static indexOf(t,e){return new xl(t).indexOf(e)}static indexOfAfter(t,e,s){return new xl(t).indexOfAfter(e,s)}indexOfFromStart(t,e){let s=r.MAX_VALUE,n=0,i=0,o=-1;const l=new Kt;for(let r=new _l(this._linearGeom);r.hasNext();r.next())if(!r.isEndOfLine()){l.p0=r.getSegmentStart(),l.p1=r.getSegmentEnd();const a=l.distance(t),c=l.segmentFraction(t),h=r.getComponentIndex(),u=r.getVertexIndex();a<s&&(null===e||e.compareLocationValues(h,u,c)<0)&&(n=h,i=u,o=c,s=a)}if(s===r.MAX_VALUE)return new yl(e);return new yl(n,i,o)}indexOf(t){return this.indexOfFromStart(t,null)}indexOfAfter(t,e){if(null===e)return this.indexOf(t);const s=yl.getEndLocation(this._linearGeom);if(s.compareTo(e)<=0)return s;const n=this.indexOfFromStart(t,e);return h.isTrue(n.compareTo(e)>=0,"computed location is before specified minimum location"),n}}class El{constructor(){El.constructor_.apply(this,arguments)}static constructor_(){this._linearGeom=null;const t=arguments[0];this._linearGeom=t}static indicesOf(t,e){return new El(t).indicesOf(e)}indicesOf(t){const e=t.getGeometryN(0).getCoordinateN(0),s=t.getGeometryN(t.getNumGeometries()-1),n=s.getCoordinateN(s.getNumPoints()-1),i=new xl(this._linearGeom),r=new Array(2).fill(null);return r[0]=i.indexOf(e),0===t.getLength()?r[1]=r[0].copy():r[1]=i.indexOfAfter(n,r[0]),r}}class Il{constructor(){Il.constructor_.apply(this,arguments)}static constructor_(){this._linearGeom=null;const t=arguments[0];this._linearGeom=t}static getLocation(){if(2===arguments.length){const t=arguments[1];return new Il(arguments[0]).getLocation(t)}if(3===arguments.length){const t=arguments[1],e=arguments[2];return new Il(arguments[0]).getLocation(t,e)}}static getLength(t,e){return new Il(t).getLength(e)}getLocation(){if(1===arguments.length){const t=arguments[0];return this.getLocation(t,!0)}if(2===arguments.length){const t=arguments[0],e=arguments[1];let s=t;if(t<0){s=this._linearGeom.getLength()+t}const n=this.getLocationForward(s);return e?n:this.resolveHigher(n)}}getLocationForward(t){if(t<=0)return new yl;let e=0;const s=new _l(this._linearGeom);for(;s.hasNext();){if(s.isEndOfLine()){if(e===t){const t=s.getComponentIndex(),e=s.getVertexIndex();return new yl(t,e,0)}}else{const n=s.getSegmentStart(),i=s.getSegmentEnd().distance(n);if(e+i>t){const n=(t-e)/i,r=s.getComponentIndex(),o=s.getVertexIndex();return new yl(r,o,n)}e+=i}s.next()}return yl.getEndLocation(this._linearGeom)}getLength(t){let e=0;const s=new _l(this._linearGeom);for(;s.hasNext();){if(!s.isEndOfLine()){const n=s.getSegmentStart(),i=s.getSegmentEnd().distance(n);if(t.getComponentIndex()===s.getComponentIndex()&&t.getSegmentIndex()===s.getVertexIndex())return e+i*t.getSegmentFraction();e+=i}s.next()}return e}resolveHigher(t){if(!t.isEndpoint(this._linearGeom))return t;let e=t.getComponentIndex();if(e>=this._linearGeom.getNumGeometries()-1)return t;do{e++}while(e<this._linearGeom.getNumGeometries()-1&&0===this._linearGeom.getGeometryN(e).getLength());return new yl(e,0,0)}}class Nl{constructor(){Nl.constructor_.apply(this,arguments)}static constructor_(){this._linearGeom=null;const t=arguments[0];this._linearGeom=t}clampIndex(t){const e=this.positiveIndex(t),s=this.getStartIndex();if(e<s)return s;const n=this.getEndIndex();return e>n?n:e}locationOf(){if(1===arguments.length){const t=arguments[0];return Il.getLocation(this._linearGeom,t)}if(2===arguments.length){const t=arguments[0],e=arguments[1];return Il.getLocation(this._linearGeom,t,e)}}project(t){return pl.indexOf(this._linearGeom,t)}positiveIndex(t){return t>=0?t:this._linearGeom.getLength()+t}extractPoint(){if(1===arguments.length){const t=arguments[0];return Il.getLocation(this._linearGeom,t).getCoordinate(this._linearGeom)}if(2===arguments.length){const t=arguments[0],e=arguments[1],s=Il.getLocation(this._linearGeom,t).toLowest(this._linearGeom);return s.getSegment(this._linearGeom).pointAlongOffset(s.getSegmentFraction(),e)}}getStartIndex(){return 0}indexOfAfter(t,e){return pl.indexOfAfter(this._linearGeom,t,e)}extractLine(t,e){const s=this.clampIndex(t),n=this.clampIndex(e),i=s===n,r=this.locationOf(s,i),o=this.locationOf(n);return fl.extract(this._linearGeom,r,o)}isValidIndex(t){return t>=this.getStartIndex()&&t<=this.getEndIndex()}getEndIndex(){return this._linearGeom.getLength()}indexOf(t){return pl.indexOf(this._linearGeom,t)}indicesOf(t){const e=El.indicesOf(this._linearGeom,t);return[Il.getLength(this._linearGeom,e[0]),Il.getLength(this._linearGeom,e[1])]}}class wl{constructor(){wl.constructor_.apply(this,arguments)}static constructor_(){this._linearGeom=null;const t=arguments[0];this._linearGeom=t,this.checkGeometryType()}clampIndex(t){const e=t.copy();return e.clamp(this._linearGeom),e}project(t){return xl.indexOf(this._linearGeom,t)}checkGeometryType(){if(!(this._linearGeom instanceof tt||this._linearGeom instanceof Et))throw new n("Input geometry must be linear")}extractPoint(){if(1===arguments.length){return arguments[0].getCoordinate(this._linearGeom)}if(2===arguments.length){const t=arguments[1],e=arguments[0].toLowest(this._linearGeom);return e.getSegment(this._linearGeom).pointAlongOffset(e.getSegmentFraction(),t)}}getStartIndex(){return new yl}indexOfAfter(t,e){return xl.indexOfAfter(this._linearGeom,t,e)}extractLine(t,e){return fl.extract(this._linearGeom,t,e)}isValidIndex(t){return t.isValid(this._linearGeom)}getEndIndex(){return yl.getEndLocation(this._linearGeom)}indexOf(t){return xl.indexOf(this._linearGeom,t)}indicesOf(t){return El.indicesOf(this._linearGeom,t)}}var Cl=Object.freeze({__proto__:null,LengthIndexedLine:Nl,LengthLocationMap:Il,LinearGeometryBuilder:ml,LinearIterator:_l,LinearLocation:yl,LocationIndexedLine:wl});class Sl{static transform(t,e){const s=new L;for(let n=t.iterator();n.hasNext();)s.add(e.execute(n.next()));return s}static select(t,e){const s=new L;for(let n=t.iterator();n.hasNext();){const t=n.next();Boolean.TRUE.equals(e.execute(t))&&s.add(t)}return s}static apply(t,e){for(let s=t.iterator();s.hasNext();)e.execute(s.next())}}Sl.Function=function(){};class Ll{constructor(){Ll.constructor_.apply(this,arguments)}static constructor_(){this.pts=null,this.n=0;const t=arguments[0];this.pts=new Array(t).fill(null)}filter(t){this.pts[this.n++]=t}getCoordinates(){return this.pts}get interfaces_(){return[K]}}class Tl{constructor(){Tl.constructor_.apply(this,arguments)}static constructor_(){this._n=0}filter(t){this._n++}getCount(){return this._n}get interfaces_(){return[K]}}class Rl{constructor(){Rl.constructor_.apply(this,arguments)}static constructor_(){this._counts=new ft}add(t){const e=this._counts.get(t);null===e?this._counts.put(t,new Pl(1)):e.increment()}count(t){const e=this._counts.get(t);return null===e?0:e.count()}}class Pl{constructor(){Pl.constructor_.apply(this,arguments)}static constructor_(){if(this.count=0,0===arguments.length);else if(1===arguments.length){const t=arguments[0];this.count=t}}count(){return this.count}increment(){this.count++}}Rl.Counter=Pl;class Ol{constructor(){Ol.constructor_.apply(this,arguments)}static constructor_(){this._size=null,this._items=null,this._size=0,this._items=new L,this._items.add(null)}poll(){if(this.isEmpty())return null;const t=this._items.get(1);return this._items.set(1,this._items.get(this._size)),this._size-=1,this.reorder(1),t}size(){return this._size}reorder(t){let e=null;const s=this._items.get(t);for(;2*t<=this._size&&(e=2*t,e!==this._size&&this._items.get(e+1).compareTo(this._items.get(e))<0&&e++,this._items.get(e).compareTo(s)<0);t=e)this._items.set(t,this._items.get(e));this._items.set(t,s)}clear(){this._size=0,this._items.clear()}peek(){if(this.isEmpty())return null;return this._items.get(1)}isEmpty(){return 0===this._size}add(t){this._items.add(null),this._size+=1;let e=this._size;for(this._items.set(0,t);t.compareTo(this._items.get(Math.trunc(e/2)))<0;e/=2)this._items.set(e,this._items.get(Math.trunc(e/2)));this._items.set(e,t)}}function vl(){}function Ml(){}function bl(){}function Dl(){}class Al extends s{}class Fl{static split(t,e){const s=e.length,n=new L;let i=""+t,r=i.indexOf(e);for(;r>=0;){const t=i.substring(0,r);n.add(t),i=i.substring(r+s),r=i.indexOf(e)}i.length>0&&n.add(i);const o=new Array(n.size()).fill(null);for(let t=0;t<o.length;t++)o[t]=n.get(t);return o}static getStackTrace(){if(1===arguments.length){const t=arguments[0],e=new Dl,s=new vl;return t.printStackTrace(s),e.toString()}if(2===arguments.length){const t=arguments[0],e=arguments[1];let s="";new Ml(Fl.getStackTrace(t));const n=new bl;for(let t=0;t<e;t++)try{s+=n.readLine()+Fl.NEWLINE}catch(t){if(!(t instanceof Al))throw t;h.shouldNeverReachHere()}return s}}static spaces(t){return Fl.chars(" ",t)}static chars(t,e){const s=new Array(e).fill(null);for(let n=0;n<e;n++)s[n]=t;return new String(s)}}Fl.NEWLINE=Y.getProperty("line.separator");var Gl=Object.freeze({__proto__:null,CollectionUtil:Sl,CoordinateArrayFilter:Ll,CoordinateCountFilter:Tl,GeometricShapeFactory:we,NumberUtil:e,ObjectCounter:Rl,PriorityQueue:Ol,StringUtil:Fl,UniqueCoordinateArrayFilter:di});tt.prototype.getBoundary=function(){return ir.getBoundary(this)},Et.prototype.getBoundary=function(){return ir.getBoundary(this)},j.prototype.equalsTopo=function(t){return no.equalsTopo(this,t)},j.prototype.equals=function(t){return null!==t&&no.equalsTopo(this,t)},j.prototype.union=function(){if(0===arguments.length)return co.union(this);if(1===arguments.length){const t=arguments[0];return ci.union(this,t)}},j.prototype.isValid=function(){return zr.isValid(this)},j.prototype.intersection=function(t){return oi.intersection(this,t)},j.prototype.covers=function(t){return no.covers(this,t)},j.prototype.coveredBy=function(t){return no.covers(t,this)},j.prototype.touches=function(t){return no.touches(this,t)},j.prototype.intersects=function(t){return no.intersects(this,t)},j.prototype.within=function(t){return no.contains(t,this)},j.prototype.overlaps=function(t){return no.overlaps(this,t)},j.prototype.disjoint=function(t){return no.disjoint(this,t)},j.prototype.crosses=function(t){return no.crosses(this,t)},j.prototype.buffer=function(){if(1===arguments.length){const t=arguments[0];return bn.bufferOp(this,t)}if(2===arguments.length){const t=arguments[0],e=arguments[1];return bn.bufferOp(this,t,e)}if(3===arguments.length){const t=arguments[0],e=arguments[1],s=arguments[2];return bn.bufferOp(this,t,e,s)}},j.prototype.convexHull=function(){return new _i(this).getConvexHull()},j.prototype.relate=function(){if(1===arguments.length){const t=arguments[0];return no.relate(this,t)}if(2===arguments.length){const t=arguments[0],e=arguments[1];return no.relate(this,t).matches(e)}},j.prototype.getCentroid=function(){if(this.isEmpty())return this._factory.createPoint();const t=gi.getCentroid(this);return this.createPointFromInternalCoord(t,this)},j.prototype.getInteriorPoint=function(){if(this.isEmpty())return this._factory.createPoint();let t=null;const e=this.getDimension();t=0===e?new Ii(this):1===e?new Ei(this):new mi(this);const s=t.getInteriorPoint();return this.createPointFromInternalCoord(s,this)},j.prototype.symDifference=function(t){return oi.symDifference(this,t)},j.prototype.createPointFromInternalCoord=function(t,e){return e.getPrecisionModel().makePrecise(t),e.getFactory().createPoint(t)},j.prototype.toText=function(){return(new Wt).write(this)},j.prototype.toString=function(){return this.toText()},j.prototype.contains=function(t){return no.contains(this,t)},j.prototype.difference=function(t){return oi.difference(this,t)},j.prototype.isSimple=function(){return new or(this).isSimple()},j.prototype.isWithinDistance=function(t,e){return!(this.getEnvelopeInternal().distance(t.getEnvelopeInternal())>e)&&ur.isWithinDistance(this,t,e)},j.prototype.distance=function(t){return ur.distance(this,t)};t.algorithm=Ci,t.densify=Ti,t.dissolve=Di,t.geom=Te,t.geomgraph=Ai,t.index=Ki,t.io=sr,t.linearref=Cl,t.noding=nr,t.operation=go,t.precision=Co,t.simplify=zo,t.triangulate=dl,t.util=Gl,t.version="2.12.1"}));


},{}],22:[function(require,module,exports){
(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,setImmediate){(function (){
/*!

JSZip v3.10.1 - A JavaScript class for generating and reading zip files
<http://stuartk.com/jszip>

(c) 2009-2016 Stuart Knightley <stuart [at] stuartk.com>
Dual licenced under the MIT license or GPLv3. See https://raw.github.com/Stuk/jszip/main/LICENSE.markdown.

JSZip uses the library pako released under the MIT license :
https://github.com/nodeca/pako/blob/main/LICENSE
*/

!function(e){if("object"==typeof exports&&"undefined"!=typeof module)module.exports=e();else if("function"==typeof define&&define.amd)define([],e);else{("undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:this).JSZip=e()}}(function(){return function s(a,o,h){function u(r,e){if(!o[r]){if(!a[r]){var t="function"==typeof require&&require;if(!e&&t)return t(r,!0);if(l)return l(r,!0);var n=new Error("Cannot find module '"+r+"'");throw n.code="MODULE_NOT_FOUND",n}var i=o[r]={exports:{}};a[r][0].call(i.exports,function(e){var t=a[r][1][e];return u(t||e)},i,i.exports,s,a,o,h)}return o[r].exports}for(var l="function"==typeof require&&require,e=0;e<h.length;e++)u(h[e]);return u}({1:[function(e,t,r){"use strict";var d=e("./utils"),c=e("./support"),p="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";r.encode=function(e){for(var t,r,n,i,s,a,o,h=[],u=0,l=e.length,f=l,c="string"!==d.getTypeOf(e);u<e.length;)f=l-u,n=c?(t=e[u++],r=u<l?e[u++]:0,u<l?e[u++]:0):(t=e.charCodeAt(u++),r=u<l?e.charCodeAt(u++):0,u<l?e.charCodeAt(u++):0),i=t>>2,s=(3&t)<<4|r>>4,a=1<f?(15&r)<<2|n>>6:64,o=2<f?63&n:64,h.push(p.charAt(i)+p.charAt(s)+p.charAt(a)+p.charAt(o));return h.join("")},r.decode=function(e){var t,r,n,i,s,a,o=0,h=0,u="data:";if(e.substr(0,u.length)===u)throw new Error("Invalid base64 input, it looks like a data url.");var l,f=3*(e=e.replace(/[^A-Za-z0-9+/=]/g,"")).length/4;if(e.charAt(e.length-1)===p.charAt(64)&&f--,e.charAt(e.length-2)===p.charAt(64)&&f--,f%1!=0)throw new Error("Invalid base64 input, bad content length.");for(l=c.uint8array?new Uint8Array(0|f):new Array(0|f);o<e.length;)t=p.indexOf(e.charAt(o++))<<2|(i=p.indexOf(e.charAt(o++)))>>4,r=(15&i)<<4|(s=p.indexOf(e.charAt(o++)))>>2,n=(3&s)<<6|(a=p.indexOf(e.charAt(o++))),l[h++]=t,64!==s&&(l[h++]=r),64!==a&&(l[h++]=n);return l}},{"./support":30,"./utils":32}],2:[function(e,t,r){"use strict";var n=e("./external"),i=e("./stream/DataWorker"),s=e("./stream/Crc32Probe"),a=e("./stream/DataLengthProbe");function o(e,t,r,n,i){this.compressedSize=e,this.uncompressedSize=t,this.crc32=r,this.compression=n,this.compressedContent=i}o.prototype={getContentWorker:function(){var e=new i(n.Promise.resolve(this.compressedContent)).pipe(this.compression.uncompressWorker()).pipe(new a("data_length")),t=this;return e.on("end",function(){if(this.streamInfo.data_length!==t.uncompressedSize)throw new Error("Bug : uncompressed data size mismatch")}),e},getCompressedWorker:function(){return new i(n.Promise.resolve(this.compressedContent)).withStreamInfo("compressedSize",this.compressedSize).withStreamInfo("uncompressedSize",this.uncompressedSize).withStreamInfo("crc32",this.crc32).withStreamInfo("compression",this.compression)}},o.createWorkerFrom=function(e,t,r){return e.pipe(new s).pipe(new a("uncompressedSize")).pipe(t.compressWorker(r)).pipe(new a("compressedSize")).withStreamInfo("compression",t)},t.exports=o},{"./external":6,"./stream/Crc32Probe":25,"./stream/DataLengthProbe":26,"./stream/DataWorker":27}],3:[function(e,t,r){"use strict";var n=e("./stream/GenericWorker");r.STORE={magic:"\0\0",compressWorker:function(){return new n("STORE compression")},uncompressWorker:function(){return new n("STORE decompression")}},r.DEFLATE=e("./flate")},{"./flate":7,"./stream/GenericWorker":28}],4:[function(e,t,r){"use strict";var n=e("./utils");var o=function(){for(var e,t=[],r=0;r<256;r++){e=r;for(var n=0;n<8;n++)e=1&e?3988292384^e>>>1:e>>>1;t[r]=e}return t}();t.exports=function(e,t){return void 0!==e&&e.length?"string"!==n.getTypeOf(e)?function(e,t,r,n){var i=o,s=n+r;e^=-1;for(var a=n;a<s;a++)e=e>>>8^i[255&(e^t[a])];return-1^e}(0|t,e,e.length,0):function(e,t,r,n){var i=o,s=n+r;e^=-1;for(var a=n;a<s;a++)e=e>>>8^i[255&(e^t.charCodeAt(a))];return-1^e}(0|t,e,e.length,0):0}},{"./utils":32}],5:[function(e,t,r){"use strict";r.base64=!1,r.binary=!1,r.dir=!1,r.createFolders=!0,r.date=null,r.compression=null,r.compressionOptions=null,r.comment=null,r.unixPermissions=null,r.dosPermissions=null},{}],6:[function(e,t,r){"use strict";var n=null;n="undefined"!=typeof Promise?Promise:e("lie"),t.exports={Promise:n}},{lie:37}],7:[function(e,t,r){"use strict";var n="undefined"!=typeof Uint8Array&&"undefined"!=typeof Uint16Array&&"undefined"!=typeof Uint32Array,i=e("pako"),s=e("./utils"),a=e("./stream/GenericWorker"),o=n?"uint8array":"array";function h(e,t){a.call(this,"FlateWorker/"+e),this._pako=null,this._pakoAction=e,this._pakoOptions=t,this.meta={}}r.magic="\b\0",s.inherits(h,a),h.prototype.processChunk=function(e){this.meta=e.meta,null===this._pako&&this._createPako(),this._pako.push(s.transformTo(o,e.data),!1)},h.prototype.flush=function(){a.prototype.flush.call(this),null===this._pako&&this._createPako(),this._pako.push([],!0)},h.prototype.cleanUp=function(){a.prototype.cleanUp.call(this),this._pako=null},h.prototype._createPako=function(){this._pako=new i[this._pakoAction]({raw:!0,level:this._pakoOptions.level||-1});var t=this;this._pako.onData=function(e){t.push({data:e,meta:t.meta})}},r.compressWorker=function(e){return new h("Deflate",e)},r.uncompressWorker=function(){return new h("Inflate",{})}},{"./stream/GenericWorker":28,"./utils":32,pako:38}],8:[function(e,t,r){"use strict";function A(e,t){var r,n="";for(r=0;r<t;r++)n+=String.fromCharCode(255&e),e>>>=8;return n}function n(e,t,r,n,i,s){var a,o,h=e.file,u=e.compression,l=s!==O.utf8encode,f=I.transformTo("string",s(h.name)),c=I.transformTo("string",O.utf8encode(h.name)),d=h.comment,p=I.transformTo("string",s(d)),m=I.transformTo("string",O.utf8encode(d)),_=c.length!==h.name.length,g=m.length!==d.length,b="",v="",y="",w=h.dir,k=h.date,x={crc32:0,compressedSize:0,uncompressedSize:0};t&&!r||(x.crc32=e.crc32,x.compressedSize=e.compressedSize,x.uncompressedSize=e.uncompressedSize);var S=0;t&&(S|=8),l||!_&&!g||(S|=2048);var z=0,C=0;w&&(z|=16),"UNIX"===i?(C=798,z|=function(e,t){var r=e;return e||(r=t?16893:33204),(65535&r)<<16}(h.unixPermissions,w)):(C=20,z|=function(e){return 63&(e||0)}(h.dosPermissions)),a=k.getUTCHours(),a<<=6,a|=k.getUTCMinutes(),a<<=5,a|=k.getUTCSeconds()/2,o=k.getUTCFullYear()-1980,o<<=4,o|=k.getUTCMonth()+1,o<<=5,o|=k.getUTCDate(),_&&(v=A(1,1)+A(B(f),4)+c,b+="up"+A(v.length,2)+v),g&&(y=A(1,1)+A(B(p),4)+m,b+="uc"+A(y.length,2)+y);var E="";return E+="\n\0",E+=A(S,2),E+=u.magic,E+=A(a,2),E+=A(o,2),E+=A(x.crc32,4),E+=A(x.compressedSize,4),E+=A(x.uncompressedSize,4),E+=A(f.length,2),E+=A(b.length,2),{fileRecord:R.LOCAL_FILE_HEADER+E+f+b,dirRecord:R.CENTRAL_FILE_HEADER+A(C,2)+E+A(p.length,2)+"\0\0\0\0"+A(z,4)+A(n,4)+f+b+p}}var I=e("../utils"),i=e("../stream/GenericWorker"),O=e("../utf8"),B=e("../crc32"),R=e("../signature");function s(e,t,r,n){i.call(this,"ZipFileWorker"),this.bytesWritten=0,this.zipComment=t,this.zipPlatform=r,this.encodeFileName=n,this.streamFiles=e,this.accumulate=!1,this.contentBuffer=[],this.dirRecords=[],this.currentSourceOffset=0,this.entriesCount=0,this.currentFile=null,this._sources=[]}I.inherits(s,i),s.prototype.push=function(e){var t=e.meta.percent||0,r=this.entriesCount,n=this._sources.length;this.accumulate?this.contentBuffer.push(e):(this.bytesWritten+=e.data.length,i.prototype.push.call(this,{data:e.data,meta:{currentFile:this.currentFile,percent:r?(t+100*(r-n-1))/r:100}}))},s.prototype.openedSource=function(e){this.currentSourceOffset=this.bytesWritten,this.currentFile=e.file.name;var t=this.streamFiles&&!e.file.dir;if(t){var r=n(e,t,!1,this.currentSourceOffset,this.zipPlatform,this.encodeFileName);this.push({data:r.fileRecord,meta:{percent:0}})}else this.accumulate=!0},s.prototype.closedSource=function(e){this.accumulate=!1;var t=this.streamFiles&&!e.file.dir,r=n(e,t,!0,this.currentSourceOffset,this.zipPlatform,this.encodeFileName);if(this.dirRecords.push(r.dirRecord),t)this.push({data:function(e){return R.DATA_DESCRIPTOR+A(e.crc32,4)+A(e.compressedSize,4)+A(e.uncompressedSize,4)}(e),meta:{percent:100}});else for(this.push({data:r.fileRecord,meta:{percent:0}});this.contentBuffer.length;)this.push(this.contentBuffer.shift());this.currentFile=null},s.prototype.flush=function(){for(var e=this.bytesWritten,t=0;t<this.dirRecords.length;t++)this.push({data:this.dirRecords[t],meta:{percent:100}});var r=this.bytesWritten-e,n=function(e,t,r,n,i){var s=I.transformTo("string",i(n));return R.CENTRAL_DIRECTORY_END+"\0\0\0\0"+A(e,2)+A(e,2)+A(t,4)+A(r,4)+A(s.length,2)+s}(this.dirRecords.length,r,e,this.zipComment,this.encodeFileName);this.push({data:n,meta:{percent:100}})},s.prototype.prepareNextSource=function(){this.previous=this._sources.shift(),this.openedSource(this.previous.streamInfo),this.isPaused?this.previous.pause():this.previous.resume()},s.prototype.registerPrevious=function(e){this._sources.push(e);var t=this;return e.on("data",function(e){t.processChunk(e)}),e.on("end",function(){t.closedSource(t.previous.streamInfo),t._sources.length?t.prepareNextSource():t.end()}),e.on("error",function(e){t.error(e)}),this},s.prototype.resume=function(){return!!i.prototype.resume.call(this)&&(!this.previous&&this._sources.length?(this.prepareNextSource(),!0):this.previous||this._sources.length||this.generatedError?void 0:(this.end(),!0))},s.prototype.error=function(e){var t=this._sources;if(!i.prototype.error.call(this,e))return!1;for(var r=0;r<t.length;r++)try{t[r].error(e)}catch(e){}return!0},s.prototype.lock=function(){i.prototype.lock.call(this);for(var e=this._sources,t=0;t<e.length;t++)e[t].lock()},t.exports=s},{"../crc32":4,"../signature":23,"../stream/GenericWorker":28,"../utf8":31,"../utils":32}],9:[function(e,t,r){"use strict";var u=e("../compressions"),n=e("./ZipFileWorker");r.generateWorker=function(e,a,t){var o=new n(a.streamFiles,t,a.platform,a.encodeFileName),h=0;try{e.forEach(function(e,t){h++;var r=function(e,t){var r=e||t,n=u[r];if(!n)throw new Error(r+" is not a valid compression method !");return n}(t.options.compression,a.compression),n=t.options.compressionOptions||a.compressionOptions||{},i=t.dir,s=t.date;t._compressWorker(r,n).withStreamInfo("file",{name:e,dir:i,date:s,comment:t.comment||"",unixPermissions:t.unixPermissions,dosPermissions:t.dosPermissions}).pipe(o)}),o.entriesCount=h}catch(e){o.error(e)}return o}},{"../compressions":3,"./ZipFileWorker":8}],10:[function(e,t,r){"use strict";function n(){if(!(this instanceof n))return new n;if(arguments.length)throw new Error("The constructor with parameters has been removed in JSZip 3.0, please check the upgrade guide.");this.files=Object.create(null),this.comment=null,this.root="",this.clone=function(){var e=new n;for(var t in this)"function"!=typeof this[t]&&(e[t]=this[t]);return e}}(n.prototype=e("./object")).loadAsync=e("./load"),n.support=e("./support"),n.defaults=e("./defaults"),n.version="3.10.1",n.loadAsync=function(e,t){return(new n).loadAsync(e,t)},n.external=e("./external"),t.exports=n},{"./defaults":5,"./external":6,"./load":11,"./object":15,"./support":30}],11:[function(e,t,r){"use strict";var u=e("./utils"),i=e("./external"),n=e("./utf8"),s=e("./zipEntries"),a=e("./stream/Crc32Probe"),l=e("./nodejsUtils");function f(n){return new i.Promise(function(e,t){var r=n.decompressed.getContentWorker().pipe(new a);r.on("error",function(e){t(e)}).on("end",function(){r.streamInfo.crc32!==n.decompressed.crc32?t(new Error("Corrupted zip : CRC32 mismatch")):e()}).resume()})}t.exports=function(e,o){var h=this;return o=u.extend(o||{},{base64:!1,checkCRC32:!1,optimizedBinaryString:!1,createFolders:!1,decodeFileName:n.utf8decode}),l.isNode&&l.isStream(e)?i.Promise.reject(new Error("JSZip can't accept a stream when loading a zip file.")):u.prepareContent("the loaded zip file",e,!0,o.optimizedBinaryString,o.base64).then(function(e){var t=new s(o);return t.load(e),t}).then(function(e){var t=[i.Promise.resolve(e)],r=e.files;if(o.checkCRC32)for(var n=0;n<r.length;n++)t.push(f(r[n]));return i.Promise.all(t)}).then(function(e){for(var t=e.shift(),r=t.files,n=0;n<r.length;n++){var i=r[n],s=i.fileNameStr,a=u.resolve(i.fileNameStr);h.file(a,i.decompressed,{binary:!0,optimizedBinaryString:!0,date:i.date,dir:i.dir,comment:i.fileCommentStr.length?i.fileCommentStr:null,unixPermissions:i.unixPermissions,dosPermissions:i.dosPermissions,createFolders:o.createFolders}),i.dir||(h.file(a).unsafeOriginalName=s)}return t.zipComment.length&&(h.comment=t.zipComment),h})}},{"./external":6,"./nodejsUtils":14,"./stream/Crc32Probe":25,"./utf8":31,"./utils":32,"./zipEntries":33}],12:[function(e,t,r){"use strict";var n=e("../utils"),i=e("../stream/GenericWorker");function s(e,t){i.call(this,"Nodejs stream input adapter for "+e),this._upstreamEnded=!1,this._bindStream(t)}n.inherits(s,i),s.prototype._bindStream=function(e){var t=this;(this._stream=e).pause(),e.on("data",function(e){t.push({data:e,meta:{percent:0}})}).on("error",function(e){t.isPaused?this.generatedError=e:t.error(e)}).on("end",function(){t.isPaused?t._upstreamEnded=!0:t.end()})},s.prototype.pause=function(){return!!i.prototype.pause.call(this)&&(this._stream.pause(),!0)},s.prototype.resume=function(){return!!i.prototype.resume.call(this)&&(this._upstreamEnded?this.end():this._stream.resume(),!0)},t.exports=s},{"../stream/GenericWorker":28,"../utils":32}],13:[function(e,t,r){"use strict";var i=e("readable-stream").Readable;function n(e,t,r){i.call(this,t),this._helper=e;var n=this;e.on("data",function(e,t){n.push(e)||n._helper.pause(),r&&r(t)}).on("error",function(e){n.emit("error",e)}).on("end",function(){n.push(null)})}e("../utils").inherits(n,i),n.prototype._read=function(){this._helper.resume()},t.exports=n},{"../utils":32,"readable-stream":16}],14:[function(e,t,r){"use strict";t.exports={isNode:"undefined"!=typeof Buffer,newBufferFrom:function(e,t){if(Buffer.from&&Buffer.from!==Uint8Array.from)return Buffer.from(e,t);if("number"==typeof e)throw new Error('The "data" argument must not be a number');return new Buffer(e,t)},allocBuffer:function(e){if(Buffer.alloc)return Buffer.alloc(e);var t=new Buffer(e);return t.fill(0),t},isBuffer:function(e){return Buffer.isBuffer(e)},isStream:function(e){return e&&"function"==typeof e.on&&"function"==typeof e.pause&&"function"==typeof e.resume}}},{}],15:[function(e,t,r){"use strict";function s(e,t,r){var n,i=u.getTypeOf(t),s=u.extend(r||{},f);s.date=s.date||new Date,null!==s.compression&&(s.compression=s.compression.toUpperCase()),"string"==typeof s.unixPermissions&&(s.unixPermissions=parseInt(s.unixPermissions,8)),s.unixPermissions&&16384&s.unixPermissions&&(s.dir=!0),s.dosPermissions&&16&s.dosPermissions&&(s.dir=!0),s.dir&&(e=g(e)),s.createFolders&&(n=_(e))&&b.call(this,n,!0);var a="string"===i&&!1===s.binary&&!1===s.base64;r&&void 0!==r.binary||(s.binary=!a),(t instanceof c&&0===t.uncompressedSize||s.dir||!t||0===t.length)&&(s.base64=!1,s.binary=!0,t="",s.compression="STORE",i="string");var o=null;o=t instanceof c||t instanceof l?t:p.isNode&&p.isStream(t)?new m(e,t):u.prepareContent(e,t,s.binary,s.optimizedBinaryString,s.base64);var h=new d(e,o,s);this.files[e]=h}var i=e("./utf8"),u=e("./utils"),l=e("./stream/GenericWorker"),a=e("./stream/StreamHelper"),f=e("./defaults"),c=e("./compressedObject"),d=e("./zipObject"),o=e("./generate"),p=e("./nodejsUtils"),m=e("./nodejs/NodejsStreamInputAdapter"),_=function(e){"/"===e.slice(-1)&&(e=e.substring(0,e.length-1));var t=e.lastIndexOf("/");return 0<t?e.substring(0,t):""},g=function(e){return"/"!==e.slice(-1)&&(e+="/"),e},b=function(e,t){return t=void 0!==t?t:f.createFolders,e=g(e),this.files[e]||s.call(this,e,null,{dir:!0,createFolders:t}),this.files[e]};function h(e){return"[object RegExp]"===Object.prototype.toString.call(e)}var n={load:function(){throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.")},forEach:function(e){var t,r,n;for(t in this.files)n=this.files[t],(r=t.slice(this.root.length,t.length))&&t.slice(0,this.root.length)===this.root&&e(r,n)},filter:function(r){var n=[];return this.forEach(function(e,t){r(e,t)&&n.push(t)}),n},file:function(e,t,r){if(1!==arguments.length)return e=this.root+e,s.call(this,e,t,r),this;if(h(e)){var n=e;return this.filter(function(e,t){return!t.dir&&n.test(e)})}var i=this.files[this.root+e];return i&&!i.dir?i:null},folder:function(r){if(!r)return this;if(h(r))return this.filter(function(e,t){return t.dir&&r.test(e)});var e=this.root+r,t=b.call(this,e),n=this.clone();return n.root=t.name,n},remove:function(r){r=this.root+r;var e=this.files[r];if(e||("/"!==r.slice(-1)&&(r+="/"),e=this.files[r]),e&&!e.dir)delete this.files[r];else for(var t=this.filter(function(e,t){return t.name.slice(0,r.length)===r}),n=0;n<t.length;n++)delete this.files[t[n].name];return this},generate:function(){throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.")},generateInternalStream:function(e){var t,r={};try{if((r=u.extend(e||{},{streamFiles:!1,compression:"STORE",compressionOptions:null,type:"",platform:"DOS",comment:null,mimeType:"application/zip",encodeFileName:i.utf8encode})).type=r.type.toLowerCase(),r.compression=r.compression.toUpperCase(),"binarystring"===r.type&&(r.type="string"),!r.type)throw new Error("No output type specified.");u.checkSupport(r.type),"darwin"!==r.platform&&"freebsd"!==r.platform&&"linux"!==r.platform&&"sunos"!==r.platform||(r.platform="UNIX"),"win32"===r.platform&&(r.platform="DOS");var n=r.comment||this.comment||"";t=o.generateWorker(this,r,n)}catch(e){(t=new l("error")).error(e)}return new a(t,r.type||"string",r.mimeType)},generateAsync:function(e,t){return this.generateInternalStream(e).accumulate(t)},generateNodeStream:function(e,t){return(e=e||{}).type||(e.type="nodebuffer"),this.generateInternalStream(e).toNodejsStream(t)}};t.exports=n},{"./compressedObject":2,"./defaults":5,"./generate":9,"./nodejs/NodejsStreamInputAdapter":12,"./nodejsUtils":14,"./stream/GenericWorker":28,"./stream/StreamHelper":29,"./utf8":31,"./utils":32,"./zipObject":35}],16:[function(e,t,r){"use strict";t.exports=e("stream")},{stream:void 0}],17:[function(e,t,r){"use strict";var n=e("./DataReader");function i(e){n.call(this,e);for(var t=0;t<this.data.length;t++)e[t]=255&e[t]}e("../utils").inherits(i,n),i.prototype.byteAt=function(e){return this.data[this.zero+e]},i.prototype.lastIndexOfSignature=function(e){for(var t=e.charCodeAt(0),r=e.charCodeAt(1),n=e.charCodeAt(2),i=e.charCodeAt(3),s=this.length-4;0<=s;--s)if(this.data[s]===t&&this.data[s+1]===r&&this.data[s+2]===n&&this.data[s+3]===i)return s-this.zero;return-1},i.prototype.readAndCheckSignature=function(e){var t=e.charCodeAt(0),r=e.charCodeAt(1),n=e.charCodeAt(2),i=e.charCodeAt(3),s=this.readData(4);return t===s[0]&&r===s[1]&&n===s[2]&&i===s[3]},i.prototype.readData=function(e){if(this.checkOffset(e),0===e)return[];var t=this.data.slice(this.zero+this.index,this.zero+this.index+e);return this.index+=e,t},t.exports=i},{"../utils":32,"./DataReader":18}],18:[function(e,t,r){"use strict";var n=e("../utils");function i(e){this.data=e,this.length=e.length,this.index=0,this.zero=0}i.prototype={checkOffset:function(e){this.checkIndex(this.index+e)},checkIndex:function(e){if(this.length<this.zero+e||e<0)throw new Error("End of data reached (data length = "+this.length+", asked index = "+e+"). Corrupted zip ?")},setIndex:function(e){this.checkIndex(e),this.index=e},skip:function(e){this.setIndex(this.index+e)},byteAt:function(){},readInt:function(e){var t,r=0;for(this.checkOffset(e),t=this.index+e-1;t>=this.index;t--)r=(r<<8)+this.byteAt(t);return this.index+=e,r},readString:function(e){return n.transformTo("string",this.readData(e))},readData:function(){},lastIndexOfSignature:function(){},readAndCheckSignature:function(){},readDate:function(){var e=this.readInt(4);return new Date(Date.UTC(1980+(e>>25&127),(e>>21&15)-1,e>>16&31,e>>11&31,e>>5&63,(31&e)<<1))}},t.exports=i},{"../utils":32}],19:[function(e,t,r){"use strict";var n=e("./Uint8ArrayReader");function i(e){n.call(this,e)}e("../utils").inherits(i,n),i.prototype.readData=function(e){this.checkOffset(e);var t=this.data.slice(this.zero+this.index,this.zero+this.index+e);return this.index+=e,t},t.exports=i},{"../utils":32,"./Uint8ArrayReader":21}],20:[function(e,t,r){"use strict";var n=e("./DataReader");function i(e){n.call(this,e)}e("../utils").inherits(i,n),i.prototype.byteAt=function(e){return this.data.charCodeAt(this.zero+e)},i.prototype.lastIndexOfSignature=function(e){return this.data.lastIndexOf(e)-this.zero},i.prototype.readAndCheckSignature=function(e){return e===this.readData(4)},i.prototype.readData=function(e){this.checkOffset(e);var t=this.data.slice(this.zero+this.index,this.zero+this.index+e);return this.index+=e,t},t.exports=i},{"../utils":32,"./DataReader":18}],21:[function(e,t,r){"use strict";var n=e("./ArrayReader");function i(e){n.call(this,e)}e("../utils").inherits(i,n),i.prototype.readData=function(e){if(this.checkOffset(e),0===e)return new Uint8Array(0);var t=this.data.subarray(this.zero+this.index,this.zero+this.index+e);return this.index+=e,t},t.exports=i},{"../utils":32,"./ArrayReader":17}],22:[function(e,t,r){"use strict";var n=e("../utils"),i=e("../support"),s=e("./ArrayReader"),a=e("./StringReader"),o=e("./NodeBufferReader"),h=e("./Uint8ArrayReader");t.exports=function(e){var t=n.getTypeOf(e);return n.checkSupport(t),"string"!==t||i.uint8array?"nodebuffer"===t?new o(e):i.uint8array?new h(n.transformTo("uint8array",e)):new s(n.transformTo("array",e)):new a(e)}},{"../support":30,"../utils":32,"./ArrayReader":17,"./NodeBufferReader":19,"./StringReader":20,"./Uint8ArrayReader":21}],23:[function(e,t,r){"use strict";r.LOCAL_FILE_HEADER="PK",r.CENTRAL_FILE_HEADER="PK",r.CENTRAL_DIRECTORY_END="PK",r.ZIP64_CENTRAL_DIRECTORY_LOCATOR="PK",r.ZIP64_CENTRAL_DIRECTORY_END="PK",r.DATA_DESCRIPTOR="PK\b"},{}],24:[function(e,t,r){"use strict";var n=e("./GenericWorker"),i=e("../utils");function s(e){n.call(this,"ConvertWorker to "+e),this.destType=e}i.inherits(s,n),s.prototype.processChunk=function(e){this.push({data:i.transformTo(this.destType,e.data),meta:e.meta})},t.exports=s},{"../utils":32,"./GenericWorker":28}],25:[function(e,t,r){"use strict";var n=e("./GenericWorker"),i=e("../crc32");function s(){n.call(this,"Crc32Probe"),this.withStreamInfo("crc32",0)}e("../utils").inherits(s,n),s.prototype.processChunk=function(e){this.streamInfo.crc32=i(e.data,this.streamInfo.crc32||0),this.push(e)},t.exports=s},{"../crc32":4,"../utils":32,"./GenericWorker":28}],26:[function(e,t,r){"use strict";var n=e("../utils"),i=e("./GenericWorker");function s(e){i.call(this,"DataLengthProbe for "+e),this.propName=e,this.withStreamInfo(e,0)}n.inherits(s,i),s.prototype.processChunk=function(e){if(e){var t=this.streamInfo[this.propName]||0;this.streamInfo[this.propName]=t+e.data.length}i.prototype.processChunk.call(this,e)},t.exports=s},{"../utils":32,"./GenericWorker":28}],27:[function(e,t,r){"use strict";var n=e("../utils"),i=e("./GenericWorker");function s(e){i.call(this,"DataWorker");var t=this;this.dataIsReady=!1,this.index=0,this.max=0,this.data=null,this.type="",this._tickScheduled=!1,e.then(function(e){t.dataIsReady=!0,t.data=e,t.max=e&&e.length||0,t.type=n.getTypeOf(e),t.isPaused||t._tickAndRepeat()},function(e){t.error(e)})}n.inherits(s,i),s.prototype.cleanUp=function(){i.prototype.cleanUp.call(this),this.data=null},s.prototype.resume=function(){return!!i.prototype.resume.call(this)&&(!this._tickScheduled&&this.dataIsReady&&(this._tickScheduled=!0,n.delay(this._tickAndRepeat,[],this)),!0)},s.prototype._tickAndRepeat=function(){this._tickScheduled=!1,this.isPaused||this.isFinished||(this._tick(),this.isFinished||(n.delay(this._tickAndRepeat,[],this),this._tickScheduled=!0))},s.prototype._tick=function(){if(this.isPaused||this.isFinished)return!1;var e=null,t=Math.min(this.max,this.index+16384);if(this.index>=this.max)return this.end();switch(this.type){case"string":e=this.data.substring(this.index,t);break;case"uint8array":e=this.data.subarray(this.index,t);break;case"array":case"nodebuffer":e=this.data.slice(this.index,t)}return this.index=t,this.push({data:e,meta:{percent:this.max?this.index/this.max*100:0}})},t.exports=s},{"../utils":32,"./GenericWorker":28}],28:[function(e,t,r){"use strict";function n(e){this.name=e||"default",this.streamInfo={},this.generatedError=null,this.extraStreamInfo={},this.isPaused=!0,this.isFinished=!1,this.isLocked=!1,this._listeners={data:[],end:[],error:[]},this.previous=null}n.prototype={push:function(e){this.emit("data",e)},end:function(){if(this.isFinished)return!1;this.flush();try{this.emit("end"),this.cleanUp(),this.isFinished=!0}catch(e){this.emit("error",e)}return!0},error:function(e){return!this.isFinished&&(this.isPaused?this.generatedError=e:(this.isFinished=!0,this.emit("error",e),this.previous&&this.previous.error(e),this.cleanUp()),!0)},on:function(e,t){return this._listeners[e].push(t),this},cleanUp:function(){this.streamInfo=this.generatedError=this.extraStreamInfo=null,this._listeners=[]},emit:function(e,t){if(this._listeners[e])for(var r=0;r<this._listeners[e].length;r++)this._listeners[e][r].call(this,t)},pipe:function(e){return e.registerPrevious(this)},registerPrevious:function(e){if(this.isLocked)throw new Error("The stream '"+this+"' has already been used.");this.streamInfo=e.streamInfo,this.mergeStreamInfo(),this.previous=e;var t=this;return e.on("data",function(e){t.processChunk(e)}),e.on("end",function(){t.end()}),e.on("error",function(e){t.error(e)}),this},pause:function(){return!this.isPaused&&!this.isFinished&&(this.isPaused=!0,this.previous&&this.previous.pause(),!0)},resume:function(){if(!this.isPaused||this.isFinished)return!1;var e=this.isPaused=!1;return this.generatedError&&(this.error(this.generatedError),e=!0),this.previous&&this.previous.resume(),!e},flush:function(){},processChunk:function(e){this.push(e)},withStreamInfo:function(e,t){return this.extraStreamInfo[e]=t,this.mergeStreamInfo(),this},mergeStreamInfo:function(){for(var e in this.extraStreamInfo)Object.prototype.hasOwnProperty.call(this.extraStreamInfo,e)&&(this.streamInfo[e]=this.extraStreamInfo[e])},lock:function(){if(this.isLocked)throw new Error("The stream '"+this+"' has already been used.");this.isLocked=!0,this.previous&&this.previous.lock()},toString:function(){var e="Worker "+this.name;return this.previous?this.previous+" -> "+e:e}},t.exports=n},{}],29:[function(e,t,r){"use strict";var h=e("../utils"),i=e("./ConvertWorker"),s=e("./GenericWorker"),u=e("../base64"),n=e("../support"),a=e("../external"),o=null;if(n.nodestream)try{o=e("../nodejs/NodejsStreamOutputAdapter")}catch(e){}function l(e,o){return new a.Promise(function(t,r){var n=[],i=e._internalType,s=e._outputType,a=e._mimeType;e.on("data",function(e,t){n.push(e),o&&o(t)}).on("error",function(e){n=[],r(e)}).on("end",function(){try{var e=function(e,t,r){switch(e){case"blob":return h.newBlob(h.transformTo("arraybuffer",t),r);case"base64":return u.encode(t);default:return h.transformTo(e,t)}}(s,function(e,t){var r,n=0,i=null,s=0;for(r=0;r<t.length;r++)s+=t[r].length;switch(e){case"string":return t.join("");case"array":return Array.prototype.concat.apply([],t);case"uint8array":for(i=new Uint8Array(s),r=0;r<t.length;r++)i.set(t[r],n),n+=t[r].length;return i;case"nodebuffer":return Buffer.concat(t);default:throw new Error("concat : unsupported type '"+e+"'")}}(i,n),a);t(e)}catch(e){r(e)}n=[]}).resume()})}function f(e,t,r){var n=t;switch(t){case"blob":case"arraybuffer":n="uint8array";break;case"base64":n="string"}try{this._internalType=n,this._outputType=t,this._mimeType=r,h.checkSupport(n),this._worker=e.pipe(new i(n)),e.lock()}catch(e){this._worker=new s("error"),this._worker.error(e)}}f.prototype={accumulate:function(e){return l(this,e)},on:function(e,t){var r=this;return"data"===e?this._worker.on(e,function(e){t.call(r,e.data,e.meta)}):this._worker.on(e,function(){h.delay(t,arguments,r)}),this},resume:function(){return h.delay(this._worker.resume,[],this._worker),this},pause:function(){return this._worker.pause(),this},toNodejsStream:function(e){if(h.checkSupport("nodestream"),"nodebuffer"!==this._outputType)throw new Error(this._outputType+" is not supported by this method");return new o(this,{objectMode:"nodebuffer"!==this._outputType},e)}},t.exports=f},{"../base64":1,"../external":6,"../nodejs/NodejsStreamOutputAdapter":13,"../support":30,"../utils":32,"./ConvertWorker":24,"./GenericWorker":28}],30:[function(e,t,r){"use strict";if(r.base64=!0,r.array=!0,r.string=!0,r.arraybuffer="undefined"!=typeof ArrayBuffer&&"undefined"!=typeof Uint8Array,r.nodebuffer="undefined"!=typeof Buffer,r.uint8array="undefined"!=typeof Uint8Array,"undefined"==typeof ArrayBuffer)r.blob=!1;else{var n=new ArrayBuffer(0);try{r.blob=0===new Blob([n],{type:"application/zip"}).size}catch(e){try{var i=new(self.BlobBuilder||self.WebKitBlobBuilder||self.MozBlobBuilder||self.MSBlobBuilder);i.append(n),r.blob=0===i.getBlob("application/zip").size}catch(e){r.blob=!1}}}try{r.nodestream=!!e("readable-stream").Readable}catch(e){r.nodestream=!1}},{"readable-stream":16}],31:[function(e,t,s){"use strict";for(var o=e("./utils"),h=e("./support"),r=e("./nodejsUtils"),n=e("./stream/GenericWorker"),u=new Array(256),i=0;i<256;i++)u[i]=252<=i?6:248<=i?5:240<=i?4:224<=i?3:192<=i?2:1;u[254]=u[254]=1;function a(){n.call(this,"utf-8 decode"),this.leftOver=null}function l(){n.call(this,"utf-8 encode")}s.utf8encode=function(e){return h.nodebuffer?r.newBufferFrom(e,"utf-8"):function(e){var t,r,n,i,s,a=e.length,o=0;for(i=0;i<a;i++)55296==(64512&(r=e.charCodeAt(i)))&&i+1<a&&56320==(64512&(n=e.charCodeAt(i+1)))&&(r=65536+(r-55296<<10)+(n-56320),i++),o+=r<128?1:r<2048?2:r<65536?3:4;for(t=h.uint8array?new Uint8Array(o):new Array(o),i=s=0;s<o;i++)55296==(64512&(r=e.charCodeAt(i)))&&i+1<a&&56320==(64512&(n=e.charCodeAt(i+1)))&&(r=65536+(r-55296<<10)+(n-56320),i++),r<128?t[s++]=r:(r<2048?t[s++]=192|r>>>6:(r<65536?t[s++]=224|r>>>12:(t[s++]=240|r>>>18,t[s++]=128|r>>>12&63),t[s++]=128|r>>>6&63),t[s++]=128|63&r);return t}(e)},s.utf8decode=function(e){return h.nodebuffer?o.transformTo("nodebuffer",e).toString("utf-8"):function(e){var t,r,n,i,s=e.length,a=new Array(2*s);for(t=r=0;t<s;)if((n=e[t++])<128)a[r++]=n;else if(4<(i=u[n]))a[r++]=65533,t+=i-1;else{for(n&=2===i?31:3===i?15:7;1<i&&t<s;)n=n<<6|63&e[t++],i--;1<i?a[r++]=65533:n<65536?a[r++]=n:(n-=65536,a[r++]=55296|n>>10&1023,a[r++]=56320|1023&n)}return a.length!==r&&(a.subarray?a=a.subarray(0,r):a.length=r),o.applyFromCharCode(a)}(e=o.transformTo(h.uint8array?"uint8array":"array",e))},o.inherits(a,n),a.prototype.processChunk=function(e){var t=o.transformTo(h.uint8array?"uint8array":"array",e.data);if(this.leftOver&&this.leftOver.length){if(h.uint8array){var r=t;(t=new Uint8Array(r.length+this.leftOver.length)).set(this.leftOver,0),t.set(r,this.leftOver.length)}else t=this.leftOver.concat(t);this.leftOver=null}var n=function(e,t){var r;for((t=t||e.length)>e.length&&(t=e.length),r=t-1;0<=r&&128==(192&e[r]);)r--;return r<0?t:0===r?t:r+u[e[r]]>t?r:t}(t),i=t;n!==t.length&&(h.uint8array?(i=t.subarray(0,n),this.leftOver=t.subarray(n,t.length)):(i=t.slice(0,n),this.leftOver=t.slice(n,t.length))),this.push({data:s.utf8decode(i),meta:e.meta})},a.prototype.flush=function(){this.leftOver&&this.leftOver.length&&(this.push({data:s.utf8decode(this.leftOver),meta:{}}),this.leftOver=null)},s.Utf8DecodeWorker=a,o.inherits(l,n),l.prototype.processChunk=function(e){this.push({data:s.utf8encode(e.data),meta:e.meta})},s.Utf8EncodeWorker=l},{"./nodejsUtils":14,"./stream/GenericWorker":28,"./support":30,"./utils":32}],32:[function(e,t,a){"use strict";var o=e("./support"),h=e("./base64"),r=e("./nodejsUtils"),u=e("./external");function n(e){return e}function l(e,t){for(var r=0;r<e.length;++r)t[r]=255&e.charCodeAt(r);return t}e("setimmediate"),a.newBlob=function(t,r){a.checkSupport("blob");try{return new Blob([t],{type:r})}catch(e){try{var n=new(self.BlobBuilder||self.WebKitBlobBuilder||self.MozBlobBuilder||self.MSBlobBuilder);return n.append(t),n.getBlob(r)}catch(e){throw new Error("Bug : can't construct the Blob.")}}};var i={stringifyByChunk:function(e,t,r){var n=[],i=0,s=e.length;if(s<=r)return String.fromCharCode.apply(null,e);for(;i<s;)"array"===t||"nodebuffer"===t?n.push(String.fromCharCode.apply(null,e.slice(i,Math.min(i+r,s)))):n.push(String.fromCharCode.apply(null,e.subarray(i,Math.min(i+r,s)))),i+=r;return n.join("")},stringifyByChar:function(e){for(var t="",r=0;r<e.length;r++)t+=String.fromCharCode(e[r]);return t},applyCanBeUsed:{uint8array:function(){try{return o.uint8array&&1===String.fromCharCode.apply(null,new Uint8Array(1)).length}catch(e){return!1}}(),nodebuffer:function(){try{return o.nodebuffer&&1===String.fromCharCode.apply(null,r.allocBuffer(1)).length}catch(e){return!1}}()}};function s(e){var t=65536,r=a.getTypeOf(e),n=!0;if("uint8array"===r?n=i.applyCanBeUsed.uint8array:"nodebuffer"===r&&(n=i.applyCanBeUsed.nodebuffer),n)for(;1<t;)try{return i.stringifyByChunk(e,r,t)}catch(e){t=Math.floor(t/2)}return i.stringifyByChar(e)}function f(e,t){for(var r=0;r<e.length;r++)t[r]=e[r];return t}a.applyFromCharCode=s;var c={};c.string={string:n,array:function(e){return l(e,new Array(e.length))},arraybuffer:function(e){return c.string.uint8array(e).buffer},uint8array:function(e){return l(e,new Uint8Array(e.length))},nodebuffer:function(e){return l(e,r.allocBuffer(e.length))}},c.array={string:s,array:n,arraybuffer:function(e){return new Uint8Array(e).buffer},uint8array:function(e){return new Uint8Array(e)},nodebuffer:function(e){return r.newBufferFrom(e)}},c.arraybuffer={string:function(e){return s(new Uint8Array(e))},array:function(e){return f(new Uint8Array(e),new Array(e.byteLength))},arraybuffer:n,uint8array:function(e){return new Uint8Array(e)},nodebuffer:function(e){return r.newBufferFrom(new Uint8Array(e))}},c.uint8array={string:s,array:function(e){return f(e,new Array(e.length))},arraybuffer:function(e){return e.buffer},uint8array:n,nodebuffer:function(e){return r.newBufferFrom(e)}},c.nodebuffer={string:s,array:function(e){return f(e,new Array(e.length))},arraybuffer:function(e){return c.nodebuffer.uint8array(e).buffer},uint8array:function(e){return f(e,new Uint8Array(e.length))},nodebuffer:n},a.transformTo=function(e,t){if(t=t||"",!e)return t;a.checkSupport(e);var r=a.getTypeOf(t);return c[r][e](t)},a.resolve=function(e){for(var t=e.split("/"),r=[],n=0;n<t.length;n++){var i=t[n];"."===i||""===i&&0!==n&&n!==t.length-1||(".."===i?r.pop():r.push(i))}return r.join("/")},a.getTypeOf=function(e){return"string"==typeof e?"string":"[object Array]"===Object.prototype.toString.call(e)?"array":o.nodebuffer&&r.isBuffer(e)?"nodebuffer":o.uint8array&&e instanceof Uint8Array?"uint8array":o.arraybuffer&&e instanceof ArrayBuffer?"arraybuffer":void 0},a.checkSupport=function(e){if(!o[e.toLowerCase()])throw new Error(e+" is not supported by this platform")},a.MAX_VALUE_16BITS=65535,a.MAX_VALUE_32BITS=-1,a.pretty=function(e){var t,r,n="";for(r=0;r<(e||"").length;r++)n+="\\x"+((t=e.charCodeAt(r))<16?"0":"")+t.toString(16).toUpperCase();return n},a.delay=function(e,t,r){setImmediate(function(){e.apply(r||null,t||[])})},a.inherits=function(e,t){function r(){}r.prototype=t.prototype,e.prototype=new r},a.extend=function(){var e,t,r={};for(e=0;e<arguments.length;e++)for(t in arguments[e])Object.prototype.hasOwnProperty.call(arguments[e],t)&&void 0===r[t]&&(r[t]=arguments[e][t]);return r},a.prepareContent=function(r,e,n,i,s){return u.Promise.resolve(e).then(function(n){return o.blob&&(n instanceof Blob||-1!==["[object File]","[object Blob]"].indexOf(Object.prototype.toString.call(n)))&&"undefined"!=typeof FileReader?new u.Promise(function(t,r){var e=new FileReader;e.onload=function(e){t(e.target.result)},e.onerror=function(e){r(e.target.error)},e.readAsArrayBuffer(n)}):n}).then(function(e){var t=a.getTypeOf(e);return t?("arraybuffer"===t?e=a.transformTo("uint8array",e):"string"===t&&(s?e=h.decode(e):n&&!0!==i&&(e=function(e){return l(e,o.uint8array?new Uint8Array(e.length):new Array(e.length))}(e))),e):u.Promise.reject(new Error("Can't read the data of '"+r+"'. Is it in a supported JavaScript type (String, Blob, ArrayBuffer, etc) ?"))})}},{"./base64":1,"./external":6,"./nodejsUtils":14,"./support":30,setimmediate:54}],33:[function(e,t,r){"use strict";var n=e("./reader/readerFor"),i=e("./utils"),s=e("./signature"),a=e("./zipEntry"),o=e("./support");function h(e){this.files=[],this.loadOptions=e}h.prototype={checkSignature:function(e){if(!this.reader.readAndCheckSignature(e)){this.reader.index-=4;var t=this.reader.readString(4);throw new Error("Corrupted zip or bug: unexpected signature ("+i.pretty(t)+", expected "+i.pretty(e)+")")}},isSignature:function(e,t){var r=this.reader.index;this.reader.setIndex(e);var n=this.reader.readString(4)===t;return this.reader.setIndex(r),n},readBlockEndOfCentral:function(){this.diskNumber=this.reader.readInt(2),this.diskWithCentralDirStart=this.reader.readInt(2),this.centralDirRecordsOnThisDisk=this.reader.readInt(2),this.centralDirRecords=this.reader.readInt(2),this.centralDirSize=this.reader.readInt(4),this.centralDirOffset=this.reader.readInt(4),this.zipCommentLength=this.reader.readInt(2);var e=this.reader.readData(this.zipCommentLength),t=o.uint8array?"uint8array":"array",r=i.transformTo(t,e);this.zipComment=this.loadOptions.decodeFileName(r)},readBlockZip64EndOfCentral:function(){this.zip64EndOfCentralSize=this.reader.readInt(8),this.reader.skip(4),this.diskNumber=this.reader.readInt(4),this.diskWithCentralDirStart=this.reader.readInt(4),this.centralDirRecordsOnThisDisk=this.reader.readInt(8),this.centralDirRecords=this.reader.readInt(8),this.centralDirSize=this.reader.readInt(8),this.centralDirOffset=this.reader.readInt(8),this.zip64ExtensibleData={};for(var e,t,r,n=this.zip64EndOfCentralSize-44;0<n;)e=this.reader.readInt(2),t=this.reader.readInt(4),r=this.reader.readData(t),this.zip64ExtensibleData[e]={id:e,length:t,value:r}},readBlockZip64EndOfCentralLocator:function(){if(this.diskWithZip64CentralDirStart=this.reader.readInt(4),this.relativeOffsetEndOfZip64CentralDir=this.reader.readInt(8),this.disksCount=this.reader.readInt(4),1<this.disksCount)throw new Error("Multi-volumes zip are not supported")},readLocalFiles:function(){var e,t;for(e=0;e<this.files.length;e++)t=this.files[e],this.reader.setIndex(t.localHeaderOffset),this.checkSignature(s.LOCAL_FILE_HEADER),t.readLocalPart(this.reader),t.handleUTF8(),t.processAttributes()},readCentralDir:function(){var e;for(this.reader.setIndex(this.centralDirOffset);this.reader.readAndCheckSignature(s.CENTRAL_FILE_HEADER);)(e=new a({zip64:this.zip64},this.loadOptions)).readCentralPart(this.reader),this.files.push(e);if(this.centralDirRecords!==this.files.length&&0!==this.centralDirRecords&&0===this.files.length)throw new Error("Corrupted zip or bug: expected "+this.centralDirRecords+" records in central dir, got "+this.files.length)},readEndOfCentral:function(){var e=this.reader.lastIndexOfSignature(s.CENTRAL_DIRECTORY_END);if(e<0)throw!this.isSignature(0,s.LOCAL_FILE_HEADER)?new Error("Can't find end of central directory : is this a zip file ? If it is, see https://stuk.github.io/jszip/documentation/howto/read_zip.html"):new Error("Corrupted zip: can't find end of central directory");this.reader.setIndex(e);var t=e;if(this.checkSignature(s.CENTRAL_DIRECTORY_END),this.readBlockEndOfCentral(),this.diskNumber===i.MAX_VALUE_16BITS||this.diskWithCentralDirStart===i.MAX_VALUE_16BITS||this.centralDirRecordsOnThisDisk===i.MAX_VALUE_16BITS||this.centralDirRecords===i.MAX_VALUE_16BITS||this.centralDirSize===i.MAX_VALUE_32BITS||this.centralDirOffset===i.MAX_VALUE_32BITS){if(this.zip64=!0,(e=this.reader.lastIndexOfSignature(s.ZIP64_CENTRAL_DIRECTORY_LOCATOR))<0)throw new Error("Corrupted zip: can't find the ZIP64 end of central directory locator");if(this.reader.setIndex(e),this.checkSignature(s.ZIP64_CENTRAL_DIRECTORY_LOCATOR),this.readBlockZip64EndOfCentralLocator(),!this.isSignature(this.relativeOffsetEndOfZip64CentralDir,s.ZIP64_CENTRAL_DIRECTORY_END)&&(this.relativeOffsetEndOfZip64CentralDir=this.reader.lastIndexOfSignature(s.ZIP64_CENTRAL_DIRECTORY_END),this.relativeOffsetEndOfZip64CentralDir<0))throw new Error("Corrupted zip: can't find the ZIP64 end of central directory");this.reader.setIndex(this.relativeOffsetEndOfZip64CentralDir),this.checkSignature(s.ZIP64_CENTRAL_DIRECTORY_END),this.readBlockZip64EndOfCentral()}var r=this.centralDirOffset+this.centralDirSize;this.zip64&&(r+=20,r+=12+this.zip64EndOfCentralSize);var n=t-r;if(0<n)this.isSignature(t,s.CENTRAL_FILE_HEADER)||(this.reader.zero=n);else if(n<0)throw new Error("Corrupted zip: missing "+Math.abs(n)+" bytes.")},prepareReader:function(e){this.reader=n(e)},load:function(e){this.prepareReader(e),this.readEndOfCentral(),this.readCentralDir(),this.readLocalFiles()}},t.exports=h},{"./reader/readerFor":22,"./signature":23,"./support":30,"./utils":32,"./zipEntry":34}],34:[function(e,t,r){"use strict";var n=e("./reader/readerFor"),s=e("./utils"),i=e("./compressedObject"),a=e("./crc32"),o=e("./utf8"),h=e("./compressions"),u=e("./support");function l(e,t){this.options=e,this.loadOptions=t}l.prototype={isEncrypted:function(){return 1==(1&this.bitFlag)},useUTF8:function(){return 2048==(2048&this.bitFlag)},readLocalPart:function(e){var t,r;if(e.skip(22),this.fileNameLength=e.readInt(2),r=e.readInt(2),this.fileName=e.readData(this.fileNameLength),e.skip(r),-1===this.compressedSize||-1===this.uncompressedSize)throw new Error("Bug or corrupted zip : didn't get enough information from the central directory (compressedSize === -1 || uncompressedSize === -1)");if(null===(t=function(e){for(var t in h)if(Object.prototype.hasOwnProperty.call(h,t)&&h[t].magic===e)return h[t];return null}(this.compressionMethod)))throw new Error("Corrupted zip : compression "+s.pretty(this.compressionMethod)+" unknown (inner file : "+s.transformTo("string",this.fileName)+")");this.decompressed=new i(this.compressedSize,this.uncompressedSize,this.crc32,t,e.readData(this.compressedSize))},readCentralPart:function(e){this.versionMadeBy=e.readInt(2),e.skip(2),this.bitFlag=e.readInt(2),this.compressionMethod=e.readString(2),this.date=e.readDate(),this.crc32=e.readInt(4),this.compressedSize=e.readInt(4),this.uncompressedSize=e.readInt(4);var t=e.readInt(2);if(this.extraFieldsLength=e.readInt(2),this.fileCommentLength=e.readInt(2),this.diskNumberStart=e.readInt(2),this.internalFileAttributes=e.readInt(2),this.externalFileAttributes=e.readInt(4),this.localHeaderOffset=e.readInt(4),this.isEncrypted())throw new Error("Encrypted zip are not supported");e.skip(t),this.readExtraFields(e),this.parseZIP64ExtraField(e),this.fileComment=e.readData(this.fileCommentLength)},processAttributes:function(){this.unixPermissions=null,this.dosPermissions=null;var e=this.versionMadeBy>>8;this.dir=!!(16&this.externalFileAttributes),0==e&&(this.dosPermissions=63&this.externalFileAttributes),3==e&&(this.unixPermissions=this.externalFileAttributes>>16&65535),this.dir||"/"!==this.fileNameStr.slice(-1)||(this.dir=!0)},parseZIP64ExtraField:function(){if(this.extraFields[1]){var e=n(this.extraFields[1].value);this.uncompressedSize===s.MAX_VALUE_32BITS&&(this.uncompressedSize=e.readInt(8)),this.compressedSize===s.MAX_VALUE_32BITS&&(this.compressedSize=e.readInt(8)),this.localHeaderOffset===s.MAX_VALUE_32BITS&&(this.localHeaderOffset=e.readInt(8)),this.diskNumberStart===s.MAX_VALUE_32BITS&&(this.diskNumberStart=e.readInt(4))}},readExtraFields:function(e){var t,r,n,i=e.index+this.extraFieldsLength;for(this.extraFields||(this.extraFields={});e.index+4<i;)t=e.readInt(2),r=e.readInt(2),n=e.readData(r),this.extraFields[t]={id:t,length:r,value:n};e.setIndex(i)},handleUTF8:function(){var e=u.uint8array?"uint8array":"array";if(this.useUTF8())this.fileNameStr=o.utf8decode(this.fileName),this.fileCommentStr=o.utf8decode(this.fileComment);else{var t=this.findExtraFieldUnicodePath();if(null!==t)this.fileNameStr=t;else{var r=s.transformTo(e,this.fileName);this.fileNameStr=this.loadOptions.decodeFileName(r)}var n=this.findExtraFieldUnicodeComment();if(null!==n)this.fileCommentStr=n;else{var i=s.transformTo(e,this.fileComment);this.fileCommentStr=this.loadOptions.decodeFileName(i)}}},findExtraFieldUnicodePath:function(){var e=this.extraFields[28789];if(e){var t=n(e.value);return 1!==t.readInt(1)?null:a(this.fileName)!==t.readInt(4)?null:o.utf8decode(t.readData(e.length-5))}return null},findExtraFieldUnicodeComment:function(){var e=this.extraFields[25461];if(e){var t=n(e.value);return 1!==t.readInt(1)?null:a(this.fileComment)!==t.readInt(4)?null:o.utf8decode(t.readData(e.length-5))}return null}},t.exports=l},{"./compressedObject":2,"./compressions":3,"./crc32":4,"./reader/readerFor":22,"./support":30,"./utf8":31,"./utils":32}],35:[function(e,t,r){"use strict";function n(e,t,r){this.name=e,this.dir=r.dir,this.date=r.date,this.comment=r.comment,this.unixPermissions=r.unixPermissions,this.dosPermissions=r.dosPermissions,this._data=t,this._dataBinary=r.binary,this.options={compression:r.compression,compressionOptions:r.compressionOptions}}var s=e("./stream/StreamHelper"),i=e("./stream/DataWorker"),a=e("./utf8"),o=e("./compressedObject"),h=e("./stream/GenericWorker");n.prototype={internalStream:function(e){var t=null,r="string";try{if(!e)throw new Error("No output type specified.");var n="string"===(r=e.toLowerCase())||"text"===r;"binarystring"!==r&&"text"!==r||(r="string"),t=this._decompressWorker();var i=!this._dataBinary;i&&!n&&(t=t.pipe(new a.Utf8EncodeWorker)),!i&&n&&(t=t.pipe(new a.Utf8DecodeWorker))}catch(e){(t=new h("error")).error(e)}return new s(t,r,"")},async:function(e,t){return this.internalStream(e).accumulate(t)},nodeStream:function(e,t){return this.internalStream(e||"nodebuffer").toNodejsStream(t)},_compressWorker:function(e,t){if(this._data instanceof o&&this._data.compression.magic===e.magic)return this._data.getCompressedWorker();var r=this._decompressWorker();return this._dataBinary||(r=r.pipe(new a.Utf8EncodeWorker)),o.createWorkerFrom(r,e,t)},_decompressWorker:function(){return this._data instanceof o?this._data.getContentWorker():this._data instanceof h?this._data:new i(this._data)}};for(var u=["asText","asBinary","asNodeBuffer","asUint8Array","asArrayBuffer"],l=function(){throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.")},f=0;f<u.length;f++)n.prototype[u[f]]=l;t.exports=n},{"./compressedObject":2,"./stream/DataWorker":27,"./stream/GenericWorker":28,"./stream/StreamHelper":29,"./utf8":31}],36:[function(e,l,t){(function(t){"use strict";var r,n,e=t.MutationObserver||t.WebKitMutationObserver;if(e){var i=0,s=new e(u),a=t.document.createTextNode("");s.observe(a,{characterData:!0}),r=function(){a.data=i=++i%2}}else if(t.setImmediate||void 0===t.MessageChannel)r="document"in t&&"onreadystatechange"in t.document.createElement("script")?function(){var e=t.document.createElement("script");e.onreadystatechange=function(){u(),e.onreadystatechange=null,e.parentNode.removeChild(e),e=null},t.document.documentElement.appendChild(e)}:function(){setTimeout(u,0)};else{var o=new t.MessageChannel;o.port1.onmessage=u,r=function(){o.port2.postMessage(0)}}var h=[];function u(){var e,t;n=!0;for(var r=h.length;r;){for(t=h,h=[],e=-1;++e<r;)t[e]();r=h.length}n=!1}l.exports=function(e){1!==h.push(e)||n||r()}}).call(this,"undefined"!=typeof global?global:"undefined"!=typeof self?self:"undefined"!=typeof window?window:{})},{}],37:[function(e,t,r){"use strict";var i=e("immediate");function u(){}var l={},s=["REJECTED"],a=["FULFILLED"],n=["PENDING"];function o(e){if("function"!=typeof e)throw new TypeError("resolver must be a function");this.state=n,this.queue=[],this.outcome=void 0,e!==u&&d(this,e)}function h(e,t,r){this.promise=e,"function"==typeof t&&(this.onFulfilled=t,this.callFulfilled=this.otherCallFulfilled),"function"==typeof r&&(this.onRejected=r,this.callRejected=this.otherCallRejected)}function f(t,r,n){i(function(){var e;try{e=r(n)}catch(e){return l.reject(t,e)}e===t?l.reject(t,new TypeError("Cannot resolve promise with itself")):l.resolve(t,e)})}function c(e){var t=e&&e.then;if(e&&("object"==typeof e||"function"==typeof e)&&"function"==typeof t)return function(){t.apply(e,arguments)}}function d(t,e){var r=!1;function n(e){r||(r=!0,l.reject(t,e))}function i(e){r||(r=!0,l.resolve(t,e))}var s=p(function(){e(i,n)});"error"===s.status&&n(s.value)}function p(e,t){var r={};try{r.value=e(t),r.status="success"}catch(e){r.status="error",r.value=e}return r}(t.exports=o).prototype.finally=function(t){if("function"!=typeof t)return this;var r=this.constructor;return this.then(function(e){return r.resolve(t()).then(function(){return e})},function(e){return r.resolve(t()).then(function(){throw e})})},o.prototype.catch=function(e){return this.then(null,e)},o.prototype.then=function(e,t){if("function"!=typeof e&&this.state===a||"function"!=typeof t&&this.state===s)return this;var r=new this.constructor(u);this.state!==n?f(r,this.state===a?e:t,this.outcome):this.queue.push(new h(r,e,t));return r},h.prototype.callFulfilled=function(e){l.resolve(this.promise,e)},h.prototype.otherCallFulfilled=function(e){f(this.promise,this.onFulfilled,e)},h.prototype.callRejected=function(e){l.reject(this.promise,e)},h.prototype.otherCallRejected=function(e){f(this.promise,this.onRejected,e)},l.resolve=function(e,t){var r=p(c,t);if("error"===r.status)return l.reject(e,r.value);var n=r.value;if(n)d(e,n);else{e.state=a,e.outcome=t;for(var i=-1,s=e.queue.length;++i<s;)e.queue[i].callFulfilled(t)}return e},l.reject=function(e,t){e.state=s,e.outcome=t;for(var r=-1,n=e.queue.length;++r<n;)e.queue[r].callRejected(t);return e},o.resolve=function(e){if(e instanceof this)return e;return l.resolve(new this(u),e)},o.reject=function(e){var t=new this(u);return l.reject(t,e)},o.all=function(e){var r=this;if("[object Array]"!==Object.prototype.toString.call(e))return this.reject(new TypeError("must be an array"));var n=e.length,i=!1;if(!n)return this.resolve([]);var s=new Array(n),a=0,t=-1,o=new this(u);for(;++t<n;)h(e[t],t);return o;function h(e,t){r.resolve(e).then(function(e){s[t]=e,++a!==n||i||(i=!0,l.resolve(o,s))},function(e){i||(i=!0,l.reject(o,e))})}},o.race=function(e){var t=this;if("[object Array]"!==Object.prototype.toString.call(e))return this.reject(new TypeError("must be an array"));var r=e.length,n=!1;if(!r)return this.resolve([]);var i=-1,s=new this(u);for(;++i<r;)a=e[i],t.resolve(a).then(function(e){n||(n=!0,l.resolve(s,e))},function(e){n||(n=!0,l.reject(s,e))});var a;return s}},{immediate:36}],38:[function(e,t,r){"use strict";var n={};(0,e("./lib/utils/common").assign)(n,e("./lib/deflate"),e("./lib/inflate"),e("./lib/zlib/constants")),t.exports=n},{"./lib/deflate":39,"./lib/inflate":40,"./lib/utils/common":41,"./lib/zlib/constants":44}],39:[function(e,t,r){"use strict";var a=e("./zlib/deflate"),o=e("./utils/common"),h=e("./utils/strings"),i=e("./zlib/messages"),s=e("./zlib/zstream"),u=Object.prototype.toString,l=0,f=-1,c=0,d=8;function p(e){if(!(this instanceof p))return new p(e);this.options=o.assign({level:f,method:d,chunkSize:16384,windowBits:15,memLevel:8,strategy:c,to:""},e||{});var t=this.options;t.raw&&0<t.windowBits?t.windowBits=-t.windowBits:t.gzip&&0<t.windowBits&&t.windowBits<16&&(t.windowBits+=16),this.err=0,this.msg="",this.ended=!1,this.chunks=[],this.strm=new s,this.strm.avail_out=0;var r=a.deflateInit2(this.strm,t.level,t.method,t.windowBits,t.memLevel,t.strategy);if(r!==l)throw new Error(i[r]);if(t.header&&a.deflateSetHeader(this.strm,t.header),t.dictionary){var n;if(n="string"==typeof t.dictionary?h.string2buf(t.dictionary):"[object ArrayBuffer]"===u.call(t.dictionary)?new Uint8Array(t.dictionary):t.dictionary,(r=a.deflateSetDictionary(this.strm,n))!==l)throw new Error(i[r]);this._dict_set=!0}}function n(e,t){var r=new p(t);if(r.push(e,!0),r.err)throw r.msg||i[r.err];return r.result}p.prototype.push=function(e,t){var r,n,i=this.strm,s=this.options.chunkSize;if(this.ended)return!1;n=t===~~t?t:!0===t?4:0,"string"==typeof e?i.input=h.string2buf(e):"[object ArrayBuffer]"===u.call(e)?i.input=new Uint8Array(e):i.input=e,i.next_in=0,i.avail_in=i.input.length;do{if(0===i.avail_out&&(i.output=new o.Buf8(s),i.next_out=0,i.avail_out=s),1!==(r=a.deflate(i,n))&&r!==l)return this.onEnd(r),!(this.ended=!0);0!==i.avail_out&&(0!==i.avail_in||4!==n&&2!==n)||("string"===this.options.to?this.onData(h.buf2binstring(o.shrinkBuf(i.output,i.next_out))):this.onData(o.shrinkBuf(i.output,i.next_out)))}while((0<i.avail_in||0===i.avail_out)&&1!==r);return 4===n?(r=a.deflateEnd(this.strm),this.onEnd(r),this.ended=!0,r===l):2!==n||(this.onEnd(l),!(i.avail_out=0))},p.prototype.onData=function(e){this.chunks.push(e)},p.prototype.onEnd=function(e){e===l&&("string"===this.options.to?this.result=this.chunks.join(""):this.result=o.flattenChunks(this.chunks)),this.chunks=[],this.err=e,this.msg=this.strm.msg},r.Deflate=p,r.deflate=n,r.deflateRaw=function(e,t){return(t=t||{}).raw=!0,n(e,t)},r.gzip=function(e,t){return(t=t||{}).gzip=!0,n(e,t)}},{"./utils/common":41,"./utils/strings":42,"./zlib/deflate":46,"./zlib/messages":51,"./zlib/zstream":53}],40:[function(e,t,r){"use strict";var c=e("./zlib/inflate"),d=e("./utils/common"),p=e("./utils/strings"),m=e("./zlib/constants"),n=e("./zlib/messages"),i=e("./zlib/zstream"),s=e("./zlib/gzheader"),_=Object.prototype.toString;function a(e){if(!(this instanceof a))return new a(e);this.options=d.assign({chunkSize:16384,windowBits:0,to:""},e||{});var t=this.options;t.raw&&0<=t.windowBits&&t.windowBits<16&&(t.windowBits=-t.windowBits,0===t.windowBits&&(t.windowBits=-15)),!(0<=t.windowBits&&t.windowBits<16)||e&&e.windowBits||(t.windowBits+=32),15<t.windowBits&&t.windowBits<48&&0==(15&t.windowBits)&&(t.windowBits|=15),this.err=0,this.msg="",this.ended=!1,this.chunks=[],this.strm=new i,this.strm.avail_out=0;var r=c.inflateInit2(this.strm,t.windowBits);if(r!==m.Z_OK)throw new Error(n[r]);this.header=new s,c.inflateGetHeader(this.strm,this.header)}function o(e,t){var r=new a(t);if(r.push(e,!0),r.err)throw r.msg||n[r.err];return r.result}a.prototype.push=function(e,t){var r,n,i,s,a,o,h=this.strm,u=this.options.chunkSize,l=this.options.dictionary,f=!1;if(this.ended)return!1;n=t===~~t?t:!0===t?m.Z_FINISH:m.Z_NO_FLUSH,"string"==typeof e?h.input=p.binstring2buf(e):"[object ArrayBuffer]"===_.call(e)?h.input=new Uint8Array(e):h.input=e,h.next_in=0,h.avail_in=h.input.length;do{if(0===h.avail_out&&(h.output=new d.Buf8(u),h.next_out=0,h.avail_out=u),(r=c.inflate(h,m.Z_NO_FLUSH))===m.Z_NEED_DICT&&l&&(o="string"==typeof l?p.string2buf(l):"[object ArrayBuffer]"===_.call(l)?new Uint8Array(l):l,r=c.inflateSetDictionary(this.strm,o)),r===m.Z_BUF_ERROR&&!0===f&&(r=m.Z_OK,f=!1),r!==m.Z_STREAM_END&&r!==m.Z_OK)return this.onEnd(r),!(this.ended=!0);h.next_out&&(0!==h.avail_out&&r!==m.Z_STREAM_END&&(0!==h.avail_in||n!==m.Z_FINISH&&n!==m.Z_SYNC_FLUSH)||("string"===this.options.to?(i=p.utf8border(h.output,h.next_out),s=h.next_out-i,a=p.buf2string(h.output,i),h.next_out=s,h.avail_out=u-s,s&&d.arraySet(h.output,h.output,i,s,0),this.onData(a)):this.onData(d.shrinkBuf(h.output,h.next_out)))),0===h.avail_in&&0===h.avail_out&&(f=!0)}while((0<h.avail_in||0===h.avail_out)&&r!==m.Z_STREAM_END);return r===m.Z_STREAM_END&&(n=m.Z_FINISH),n===m.Z_FINISH?(r=c.inflateEnd(this.strm),this.onEnd(r),this.ended=!0,r===m.Z_OK):n!==m.Z_SYNC_FLUSH||(this.onEnd(m.Z_OK),!(h.avail_out=0))},a.prototype.onData=function(e){this.chunks.push(e)},a.prototype.onEnd=function(e){e===m.Z_OK&&("string"===this.options.to?this.result=this.chunks.join(""):this.result=d.flattenChunks(this.chunks)),this.chunks=[],this.err=e,this.msg=this.strm.msg},r.Inflate=a,r.inflate=o,r.inflateRaw=function(e,t){return(t=t||{}).raw=!0,o(e,t)},r.ungzip=o},{"./utils/common":41,"./utils/strings":42,"./zlib/constants":44,"./zlib/gzheader":47,"./zlib/inflate":49,"./zlib/messages":51,"./zlib/zstream":53}],41:[function(e,t,r){"use strict";var n="undefined"!=typeof Uint8Array&&"undefined"!=typeof Uint16Array&&"undefined"!=typeof Int32Array;r.assign=function(e){for(var t=Array.prototype.slice.call(arguments,1);t.length;){var r=t.shift();if(r){if("object"!=typeof r)throw new TypeError(r+"must be non-object");for(var n in r)r.hasOwnProperty(n)&&(e[n]=r[n])}}return e},r.shrinkBuf=function(e,t){return e.length===t?e:e.subarray?e.subarray(0,t):(e.length=t,e)};var i={arraySet:function(e,t,r,n,i){if(t.subarray&&e.subarray)e.set(t.subarray(r,r+n),i);else for(var s=0;s<n;s++)e[i+s]=t[r+s]},flattenChunks:function(e){var t,r,n,i,s,a;for(t=n=0,r=e.length;t<r;t++)n+=e[t].length;for(a=new Uint8Array(n),t=i=0,r=e.length;t<r;t++)s=e[t],a.set(s,i),i+=s.length;return a}},s={arraySet:function(e,t,r,n,i){for(var s=0;s<n;s++)e[i+s]=t[r+s]},flattenChunks:function(e){return[].concat.apply([],e)}};r.setTyped=function(e){e?(r.Buf8=Uint8Array,r.Buf16=Uint16Array,r.Buf32=Int32Array,r.assign(r,i)):(r.Buf8=Array,r.Buf16=Array,r.Buf32=Array,r.assign(r,s))},r.setTyped(n)},{}],42:[function(e,t,r){"use strict";var h=e("./common"),i=!0,s=!0;try{String.fromCharCode.apply(null,[0])}catch(e){i=!1}try{String.fromCharCode.apply(null,new Uint8Array(1))}catch(e){s=!1}for(var u=new h.Buf8(256),n=0;n<256;n++)u[n]=252<=n?6:248<=n?5:240<=n?4:224<=n?3:192<=n?2:1;function l(e,t){if(t<65537&&(e.subarray&&s||!e.subarray&&i))return String.fromCharCode.apply(null,h.shrinkBuf(e,t));for(var r="",n=0;n<t;n++)r+=String.fromCharCode(e[n]);return r}u[254]=u[254]=1,r.string2buf=function(e){var t,r,n,i,s,a=e.length,o=0;for(i=0;i<a;i++)55296==(64512&(r=e.charCodeAt(i)))&&i+1<a&&56320==(64512&(n=e.charCodeAt(i+1)))&&(r=65536+(r-55296<<10)+(n-56320),i++),o+=r<128?1:r<2048?2:r<65536?3:4;for(t=new h.Buf8(o),i=s=0;s<o;i++)55296==(64512&(r=e.charCodeAt(i)))&&i+1<a&&56320==(64512&(n=e.charCodeAt(i+1)))&&(r=65536+(r-55296<<10)+(n-56320),i++),r<128?t[s++]=r:(r<2048?t[s++]=192|r>>>6:(r<65536?t[s++]=224|r>>>12:(t[s++]=240|r>>>18,t[s++]=128|r>>>12&63),t[s++]=128|r>>>6&63),t[s++]=128|63&r);return t},r.buf2binstring=function(e){return l(e,e.length)},r.binstring2buf=function(e){for(var t=new h.Buf8(e.length),r=0,n=t.length;r<n;r++)t[r]=e.charCodeAt(r);return t},r.buf2string=function(e,t){var r,n,i,s,a=t||e.length,o=new Array(2*a);for(r=n=0;r<a;)if((i=e[r++])<128)o[n++]=i;else if(4<(s=u[i]))o[n++]=65533,r+=s-1;else{for(i&=2===s?31:3===s?15:7;1<s&&r<a;)i=i<<6|63&e[r++],s--;1<s?o[n++]=65533:i<65536?o[n++]=i:(i-=65536,o[n++]=55296|i>>10&1023,o[n++]=56320|1023&i)}return l(o,n)},r.utf8border=function(e,t){var r;for((t=t||e.length)>e.length&&(t=e.length),r=t-1;0<=r&&128==(192&e[r]);)r--;return r<0?t:0===r?t:r+u[e[r]]>t?r:t}},{"./common":41}],43:[function(e,t,r){"use strict";t.exports=function(e,t,r,n){for(var i=65535&e|0,s=e>>>16&65535|0,a=0;0!==r;){for(r-=a=2e3<r?2e3:r;s=s+(i=i+t[n++]|0)|0,--a;);i%=65521,s%=65521}return i|s<<16|0}},{}],44:[function(e,t,r){"use strict";t.exports={Z_NO_FLUSH:0,Z_PARTIAL_FLUSH:1,Z_SYNC_FLUSH:2,Z_FULL_FLUSH:3,Z_FINISH:4,Z_BLOCK:5,Z_TREES:6,Z_OK:0,Z_STREAM_END:1,Z_NEED_DICT:2,Z_ERRNO:-1,Z_STREAM_ERROR:-2,Z_DATA_ERROR:-3,Z_BUF_ERROR:-5,Z_NO_COMPRESSION:0,Z_BEST_SPEED:1,Z_BEST_COMPRESSION:9,Z_DEFAULT_COMPRESSION:-1,Z_FILTERED:1,Z_HUFFMAN_ONLY:2,Z_RLE:3,Z_FIXED:4,Z_DEFAULT_STRATEGY:0,Z_BINARY:0,Z_TEXT:1,Z_UNKNOWN:2,Z_DEFLATED:8}},{}],45:[function(e,t,r){"use strict";var o=function(){for(var e,t=[],r=0;r<256;r++){e=r;for(var n=0;n<8;n++)e=1&e?3988292384^e>>>1:e>>>1;t[r]=e}return t}();t.exports=function(e,t,r,n){var i=o,s=n+r;e^=-1;for(var a=n;a<s;a++)e=e>>>8^i[255&(e^t[a])];return-1^e}},{}],46:[function(e,t,r){"use strict";var h,c=e("../utils/common"),u=e("./trees"),d=e("./adler32"),p=e("./crc32"),n=e("./messages"),l=0,f=4,m=0,_=-2,g=-1,b=4,i=2,v=8,y=9,s=286,a=30,o=19,w=2*s+1,k=15,x=3,S=258,z=S+x+1,C=42,E=113,A=1,I=2,O=3,B=4;function R(e,t){return e.msg=n[t],t}function T(e){return(e<<1)-(4<e?9:0)}function D(e){for(var t=e.length;0<=--t;)e[t]=0}function F(e){var t=e.state,r=t.pending;r>e.avail_out&&(r=e.avail_out),0!==r&&(c.arraySet(e.output,t.pending_buf,t.pending_out,r,e.next_out),e.next_out+=r,t.pending_out+=r,e.total_out+=r,e.avail_out-=r,t.pending-=r,0===t.pending&&(t.pending_out=0))}function N(e,t){u._tr_flush_block(e,0<=e.block_start?e.block_start:-1,e.strstart-e.block_start,t),e.block_start=e.strstart,F(e.strm)}function U(e,t){e.pending_buf[e.pending++]=t}function P(e,t){e.pending_buf[e.pending++]=t>>>8&255,e.pending_buf[e.pending++]=255&t}function L(e,t){var r,n,i=e.max_chain_length,s=e.strstart,a=e.prev_length,o=e.nice_match,h=e.strstart>e.w_size-z?e.strstart-(e.w_size-z):0,u=e.window,l=e.w_mask,f=e.prev,c=e.strstart+S,d=u[s+a-1],p=u[s+a];e.prev_length>=e.good_match&&(i>>=2),o>e.lookahead&&(o=e.lookahead);do{if(u[(r=t)+a]===p&&u[r+a-1]===d&&u[r]===u[s]&&u[++r]===u[s+1]){s+=2,r++;do{}while(u[++s]===u[++r]&&u[++s]===u[++r]&&u[++s]===u[++r]&&u[++s]===u[++r]&&u[++s]===u[++r]&&u[++s]===u[++r]&&u[++s]===u[++r]&&u[++s]===u[++r]&&s<c);if(n=S-(c-s),s=c-S,a<n){if(e.match_start=t,o<=(a=n))break;d=u[s+a-1],p=u[s+a]}}}while((t=f[t&l])>h&&0!=--i);return a<=e.lookahead?a:e.lookahead}function j(e){var t,r,n,i,s,a,o,h,u,l,f=e.w_size;do{if(i=e.window_size-e.lookahead-e.strstart,e.strstart>=f+(f-z)){for(c.arraySet(e.window,e.window,f,f,0),e.match_start-=f,e.strstart-=f,e.block_start-=f,t=r=e.hash_size;n=e.head[--t],e.head[t]=f<=n?n-f:0,--r;);for(t=r=f;n=e.prev[--t],e.prev[t]=f<=n?n-f:0,--r;);i+=f}if(0===e.strm.avail_in)break;if(a=e.strm,o=e.window,h=e.strstart+e.lookahead,u=i,l=void 0,l=a.avail_in,u<l&&(l=u),r=0===l?0:(a.avail_in-=l,c.arraySet(o,a.input,a.next_in,l,h),1===a.state.wrap?a.adler=d(a.adler,o,l,h):2===a.state.wrap&&(a.adler=p(a.adler,o,l,h)),a.next_in+=l,a.total_in+=l,l),e.lookahead+=r,e.lookahead+e.insert>=x)for(s=e.strstart-e.insert,e.ins_h=e.window[s],e.ins_h=(e.ins_h<<e.hash_shift^e.window[s+1])&e.hash_mask;e.insert&&(e.ins_h=(e.ins_h<<e.hash_shift^e.window[s+x-1])&e.hash_mask,e.prev[s&e.w_mask]=e.head[e.ins_h],e.head[e.ins_h]=s,s++,e.insert--,!(e.lookahead+e.insert<x)););}while(e.lookahead<z&&0!==e.strm.avail_in)}function Z(e,t){for(var r,n;;){if(e.lookahead<z){if(j(e),e.lookahead<z&&t===l)return A;if(0===e.lookahead)break}if(r=0,e.lookahead>=x&&(e.ins_h=(e.ins_h<<e.hash_shift^e.window[e.strstart+x-1])&e.hash_mask,r=e.prev[e.strstart&e.w_mask]=e.head[e.ins_h],e.head[e.ins_h]=e.strstart),0!==r&&e.strstart-r<=e.w_size-z&&(e.match_length=L(e,r)),e.match_length>=x)if(n=u._tr_tally(e,e.strstart-e.match_start,e.match_length-x),e.lookahead-=e.match_length,e.match_length<=e.max_lazy_match&&e.lookahead>=x){for(e.match_length--;e.strstart++,e.ins_h=(e.ins_h<<e.hash_shift^e.window[e.strstart+x-1])&e.hash_mask,r=e.prev[e.strstart&e.w_mask]=e.head[e.ins_h],e.head[e.ins_h]=e.strstart,0!=--e.match_length;);e.strstart++}else e.strstart+=e.match_length,e.match_length=0,e.ins_h=e.window[e.strstart],e.ins_h=(e.ins_h<<e.hash_shift^e.window[e.strstart+1])&e.hash_mask;else n=u._tr_tally(e,0,e.window[e.strstart]),e.lookahead--,e.strstart++;if(n&&(N(e,!1),0===e.strm.avail_out))return A}return e.insert=e.strstart<x-1?e.strstart:x-1,t===f?(N(e,!0),0===e.strm.avail_out?O:B):e.last_lit&&(N(e,!1),0===e.strm.avail_out)?A:I}function W(e,t){for(var r,n,i;;){if(e.lookahead<z){if(j(e),e.lookahead<z&&t===l)return A;if(0===e.lookahead)break}if(r=0,e.lookahead>=x&&(e.ins_h=(e.ins_h<<e.hash_shift^e.window[e.strstart+x-1])&e.hash_mask,r=e.prev[e.strstart&e.w_mask]=e.head[e.ins_h],e.head[e.ins_h]=e.strstart),e.prev_length=e.match_length,e.prev_match=e.match_start,e.match_length=x-1,0!==r&&e.prev_length<e.max_lazy_match&&e.strstart-r<=e.w_size-z&&(e.match_length=L(e,r),e.match_length<=5&&(1===e.strategy||e.match_length===x&&4096<e.strstart-e.match_start)&&(e.match_length=x-1)),e.prev_length>=x&&e.match_length<=e.prev_length){for(i=e.strstart+e.lookahead-x,n=u._tr_tally(e,e.strstart-1-e.prev_match,e.prev_length-x),e.lookahead-=e.prev_length-1,e.prev_length-=2;++e.strstart<=i&&(e.ins_h=(e.ins_h<<e.hash_shift^e.window[e.strstart+x-1])&e.hash_mask,r=e.prev[e.strstart&e.w_mask]=e.head[e.ins_h],e.head[e.ins_h]=e.strstart),0!=--e.prev_length;);if(e.match_available=0,e.match_length=x-1,e.strstart++,n&&(N(e,!1),0===e.strm.avail_out))return A}else if(e.match_available){if((n=u._tr_tally(e,0,e.window[e.strstart-1]))&&N(e,!1),e.strstart++,e.lookahead--,0===e.strm.avail_out)return A}else e.match_available=1,e.strstart++,e.lookahead--}return e.match_available&&(n=u._tr_tally(e,0,e.window[e.strstart-1]),e.match_available=0),e.insert=e.strstart<x-1?e.strstart:x-1,t===f?(N(e,!0),0===e.strm.avail_out?O:B):e.last_lit&&(N(e,!1),0===e.strm.avail_out)?A:I}function M(e,t,r,n,i){this.good_length=e,this.max_lazy=t,this.nice_length=r,this.max_chain=n,this.func=i}function H(){this.strm=null,this.status=0,this.pending_buf=null,this.pending_buf_size=0,this.pending_out=0,this.pending=0,this.wrap=0,this.gzhead=null,this.gzindex=0,this.method=v,this.last_flush=-1,this.w_size=0,this.w_bits=0,this.w_mask=0,this.window=null,this.window_size=0,this.prev=null,this.head=null,this.ins_h=0,this.hash_size=0,this.hash_bits=0,this.hash_mask=0,this.hash_shift=0,this.block_start=0,this.match_length=0,this.prev_match=0,this.match_available=0,this.strstart=0,this.match_start=0,this.lookahead=0,this.prev_length=0,this.max_chain_length=0,this.max_lazy_match=0,this.level=0,this.strategy=0,this.good_match=0,this.nice_match=0,this.dyn_ltree=new c.Buf16(2*w),this.dyn_dtree=new c.Buf16(2*(2*a+1)),this.bl_tree=new c.Buf16(2*(2*o+1)),D(this.dyn_ltree),D(this.dyn_dtree),D(this.bl_tree),this.l_desc=null,this.d_desc=null,this.bl_desc=null,this.bl_count=new c.Buf16(k+1),this.heap=new c.Buf16(2*s+1),D(this.heap),this.heap_len=0,this.heap_max=0,this.depth=new c.Buf16(2*s+1),D(this.depth),this.l_buf=0,this.lit_bufsize=0,this.last_lit=0,this.d_buf=0,this.opt_len=0,this.static_len=0,this.matches=0,this.insert=0,this.bi_buf=0,this.bi_valid=0}function G(e){var t;return e&&e.state?(e.total_in=e.total_out=0,e.data_type=i,(t=e.state).pending=0,t.pending_out=0,t.wrap<0&&(t.wrap=-t.wrap),t.status=t.wrap?C:E,e.adler=2===t.wrap?0:1,t.last_flush=l,u._tr_init(t),m):R(e,_)}function K(e){var t=G(e);return t===m&&function(e){e.window_size=2*e.w_size,D(e.head),e.max_lazy_match=h[e.level].max_lazy,e.good_match=h[e.level].good_length,e.nice_match=h[e.level].nice_length,e.max_chain_length=h[e.level].max_chain,e.strstart=0,e.block_start=0,e.lookahead=0,e.insert=0,e.match_length=e.prev_length=x-1,e.match_available=0,e.ins_h=0}(e.state),t}function Y(e,t,r,n,i,s){if(!e)return _;var a=1;if(t===g&&(t=6),n<0?(a=0,n=-n):15<n&&(a=2,n-=16),i<1||y<i||r!==v||n<8||15<n||t<0||9<t||s<0||b<s)return R(e,_);8===n&&(n=9);var o=new H;return(e.state=o).strm=e,o.wrap=a,o.gzhead=null,o.w_bits=n,o.w_size=1<<o.w_bits,o.w_mask=o.w_size-1,o.hash_bits=i+7,o.hash_size=1<<o.hash_bits,o.hash_mask=o.hash_size-1,o.hash_shift=~~((o.hash_bits+x-1)/x),o.window=new c.Buf8(2*o.w_size),o.head=new c.Buf16(o.hash_size),o.prev=new c.Buf16(o.w_size),o.lit_bufsize=1<<i+6,o.pending_buf_size=4*o.lit_bufsize,o.pending_buf=new c.Buf8(o.pending_buf_size),o.d_buf=1*o.lit_bufsize,o.l_buf=3*o.lit_bufsize,o.level=t,o.strategy=s,o.method=r,K(e)}h=[new M(0,0,0,0,function(e,t){var r=65535;for(r>e.pending_buf_size-5&&(r=e.pending_buf_size-5);;){if(e.lookahead<=1){if(j(e),0===e.lookahead&&t===l)return A;if(0===e.lookahead)break}e.strstart+=e.lookahead,e.lookahead=0;var n=e.block_start+r;if((0===e.strstart||e.strstart>=n)&&(e.lookahead=e.strstart-n,e.strstart=n,N(e,!1),0===e.strm.avail_out))return A;if(e.strstart-e.block_start>=e.w_size-z&&(N(e,!1),0===e.strm.avail_out))return A}return e.insert=0,t===f?(N(e,!0),0===e.strm.avail_out?O:B):(e.strstart>e.block_start&&(N(e,!1),e.strm.avail_out),A)}),new M(4,4,8,4,Z),new M(4,5,16,8,Z),new M(4,6,32,32,Z),new M(4,4,16,16,W),new M(8,16,32,32,W),new M(8,16,128,128,W),new M(8,32,128,256,W),new M(32,128,258,1024,W),new M(32,258,258,4096,W)],r.deflateInit=function(e,t){return Y(e,t,v,15,8,0)},r.deflateInit2=Y,r.deflateReset=K,r.deflateResetKeep=G,r.deflateSetHeader=function(e,t){return e&&e.state?2!==e.state.wrap?_:(e.state.gzhead=t,m):_},r.deflate=function(e,t){var r,n,i,s;if(!e||!e.state||5<t||t<0)return e?R(e,_):_;if(n=e.state,!e.output||!e.input&&0!==e.avail_in||666===n.status&&t!==f)return R(e,0===e.avail_out?-5:_);if(n.strm=e,r=n.last_flush,n.last_flush=t,n.status===C)if(2===n.wrap)e.adler=0,U(n,31),U(n,139),U(n,8),n.gzhead?(U(n,(n.gzhead.text?1:0)+(n.gzhead.hcrc?2:0)+(n.gzhead.extra?4:0)+(n.gzhead.name?8:0)+(n.gzhead.comment?16:0)),U(n,255&n.gzhead.time),U(n,n.gzhead.time>>8&255),U(n,n.gzhead.time>>16&255),U(n,n.gzhead.time>>24&255),U(n,9===n.level?2:2<=n.strategy||n.level<2?4:0),U(n,255&n.gzhead.os),n.gzhead.extra&&n.gzhead.extra.length&&(U(n,255&n.gzhead.extra.length),U(n,n.gzhead.extra.length>>8&255)),n.gzhead.hcrc&&(e.adler=p(e.adler,n.pending_buf,n.pending,0)),n.gzindex=0,n.status=69):(U(n,0),U(n,0),U(n,0),U(n,0),U(n,0),U(n,9===n.level?2:2<=n.strategy||n.level<2?4:0),U(n,3),n.status=E);else{var a=v+(n.w_bits-8<<4)<<8;a|=(2<=n.strategy||n.level<2?0:n.level<6?1:6===n.level?2:3)<<6,0!==n.strstart&&(a|=32),a+=31-a%31,n.status=E,P(n,a),0!==n.strstart&&(P(n,e.adler>>>16),P(n,65535&e.adler)),e.adler=1}if(69===n.status)if(n.gzhead.extra){for(i=n.pending;n.gzindex<(65535&n.gzhead.extra.length)&&(n.pending!==n.pending_buf_size||(n.gzhead.hcrc&&n.pending>i&&(e.adler=p(e.adler,n.pending_buf,n.pending-i,i)),F(e),i=n.pending,n.pending!==n.pending_buf_size));)U(n,255&n.gzhead.extra[n.gzindex]),n.gzindex++;n.gzhead.hcrc&&n.pending>i&&(e.adler=p(e.adler,n.pending_buf,n.pending-i,i)),n.gzindex===n.gzhead.extra.length&&(n.gzindex=0,n.status=73)}else n.status=73;if(73===n.status)if(n.gzhead.name){i=n.pending;do{if(n.pending===n.pending_buf_size&&(n.gzhead.hcrc&&n.pending>i&&(e.adler=p(e.adler,n.pending_buf,n.pending-i,i)),F(e),i=n.pending,n.pending===n.pending_buf_size)){s=1;break}s=n.gzindex<n.gzhead.name.length?255&n.gzhead.name.charCodeAt(n.gzindex++):0,U(n,s)}while(0!==s);n.gzhead.hcrc&&n.pending>i&&(e.adler=p(e.adler,n.pending_buf,n.pending-i,i)),0===s&&(n.gzindex=0,n.status=91)}else n.status=91;if(91===n.status)if(n.gzhead.comment){i=n.pending;do{if(n.pending===n.pending_buf_size&&(n.gzhead.hcrc&&n.pending>i&&(e.adler=p(e.adler,n.pending_buf,n.pending-i,i)),F(e),i=n.pending,n.pending===n.pending_buf_size)){s=1;break}s=n.gzindex<n.gzhead.comment.length?255&n.gzhead.comment.charCodeAt(n.gzindex++):0,U(n,s)}while(0!==s);n.gzhead.hcrc&&n.pending>i&&(e.adler=p(e.adler,n.pending_buf,n.pending-i,i)),0===s&&(n.status=103)}else n.status=103;if(103===n.status&&(n.gzhead.hcrc?(n.pending+2>n.pending_buf_size&&F(e),n.pending+2<=n.pending_buf_size&&(U(n,255&e.adler),U(n,e.adler>>8&255),e.adler=0,n.status=E)):n.status=E),0!==n.pending){if(F(e),0===e.avail_out)return n.last_flush=-1,m}else if(0===e.avail_in&&T(t)<=T(r)&&t!==f)return R(e,-5);if(666===n.status&&0!==e.avail_in)return R(e,-5);if(0!==e.avail_in||0!==n.lookahead||t!==l&&666!==n.status){var o=2===n.strategy?function(e,t){for(var r;;){if(0===e.lookahead&&(j(e),0===e.lookahead)){if(t===l)return A;break}if(e.match_length=0,r=u._tr_tally(e,0,e.window[e.strstart]),e.lookahead--,e.strstart++,r&&(N(e,!1),0===e.strm.avail_out))return A}return e.insert=0,t===f?(N(e,!0),0===e.strm.avail_out?O:B):e.last_lit&&(N(e,!1),0===e.strm.avail_out)?A:I}(n,t):3===n.strategy?function(e,t){for(var r,n,i,s,a=e.window;;){if(e.lookahead<=S){if(j(e),e.lookahead<=S&&t===l)return A;if(0===e.lookahead)break}if(e.match_length=0,e.lookahead>=x&&0<e.strstart&&(n=a[i=e.strstart-1])===a[++i]&&n===a[++i]&&n===a[++i]){s=e.strstart+S;do{}while(n===a[++i]&&n===a[++i]&&n===a[++i]&&n===a[++i]&&n===a[++i]&&n===a[++i]&&n===a[++i]&&n===a[++i]&&i<s);e.match_length=S-(s-i),e.match_length>e.lookahead&&(e.match_length=e.lookahead)}if(e.match_length>=x?(r=u._tr_tally(e,1,e.match_length-x),e.lookahead-=e.match_length,e.strstart+=e.match_length,e.match_length=0):(r=u._tr_tally(e,0,e.window[e.strstart]),e.lookahead--,e.strstart++),r&&(N(e,!1),0===e.strm.avail_out))return A}return e.insert=0,t===f?(N(e,!0),0===e.strm.avail_out?O:B):e.last_lit&&(N(e,!1),0===e.strm.avail_out)?A:I}(n,t):h[n.level].func(n,t);if(o!==O&&o!==B||(n.status=666),o===A||o===O)return 0===e.avail_out&&(n.last_flush=-1),m;if(o===I&&(1===t?u._tr_align(n):5!==t&&(u._tr_stored_block(n,0,0,!1),3===t&&(D(n.head),0===n.lookahead&&(n.strstart=0,n.block_start=0,n.insert=0))),F(e),0===e.avail_out))return n.last_flush=-1,m}return t!==f?m:n.wrap<=0?1:(2===n.wrap?(U(n,255&e.adler),U(n,e.adler>>8&255),U(n,e.adler>>16&255),U(n,e.adler>>24&255),U(n,255&e.total_in),U(n,e.total_in>>8&255),U(n,e.total_in>>16&255),U(n,e.total_in>>24&255)):(P(n,e.adler>>>16),P(n,65535&e.adler)),F(e),0<n.wrap&&(n.wrap=-n.wrap),0!==n.pending?m:1)},r.deflateEnd=function(e){var t;return e&&e.state?(t=e.state.status)!==C&&69!==t&&73!==t&&91!==t&&103!==t&&t!==E&&666!==t?R(e,_):(e.state=null,t===E?R(e,-3):m):_},r.deflateSetDictionary=function(e,t){var r,n,i,s,a,o,h,u,l=t.length;if(!e||!e.state)return _;if(2===(s=(r=e.state).wrap)||1===s&&r.status!==C||r.lookahead)return _;for(1===s&&(e.adler=d(e.adler,t,l,0)),r.wrap=0,l>=r.w_size&&(0===s&&(D(r.head),r.strstart=0,r.block_start=0,r.insert=0),u=new c.Buf8(r.w_size),c.arraySet(u,t,l-r.w_size,r.w_size,0),t=u,l=r.w_size),a=e.avail_in,o=e.next_in,h=e.input,e.avail_in=l,e.next_in=0,e.input=t,j(r);r.lookahead>=x;){for(n=r.strstart,i=r.lookahead-(x-1);r.ins_h=(r.ins_h<<r.hash_shift^r.window[n+x-1])&r.hash_mask,r.prev[n&r.w_mask]=r.head[r.ins_h],r.head[r.ins_h]=n,n++,--i;);r.strstart=n,r.lookahead=x-1,j(r)}return r.strstart+=r.lookahead,r.block_start=r.strstart,r.insert=r.lookahead,r.lookahead=0,r.match_length=r.prev_length=x-1,r.match_available=0,e.next_in=o,e.input=h,e.avail_in=a,r.wrap=s,m},r.deflateInfo="pako deflate (from Nodeca project)"},{"../utils/common":41,"./adler32":43,"./crc32":45,"./messages":51,"./trees":52}],47:[function(e,t,r){"use strict";t.exports=function(){this.text=0,this.time=0,this.xflags=0,this.os=0,this.extra=null,this.extra_len=0,this.name="",this.comment="",this.hcrc=0,this.done=!1}},{}],48:[function(e,t,r){"use strict";t.exports=function(e,t){var r,n,i,s,a,o,h,u,l,f,c,d,p,m,_,g,b,v,y,w,k,x,S,z,C;r=e.state,n=e.next_in,z=e.input,i=n+(e.avail_in-5),s=e.next_out,C=e.output,a=s-(t-e.avail_out),o=s+(e.avail_out-257),h=r.dmax,u=r.wsize,l=r.whave,f=r.wnext,c=r.window,d=r.hold,p=r.bits,m=r.lencode,_=r.distcode,g=(1<<r.lenbits)-1,b=(1<<r.distbits)-1;e:do{p<15&&(d+=z[n++]<<p,p+=8,d+=z[n++]<<p,p+=8),v=m[d&g];t:for(;;){if(d>>>=y=v>>>24,p-=y,0===(y=v>>>16&255))C[s++]=65535&v;else{if(!(16&y)){if(0==(64&y)){v=m[(65535&v)+(d&(1<<y)-1)];continue t}if(32&y){r.mode=12;break e}e.msg="invalid literal/length code",r.mode=30;break e}w=65535&v,(y&=15)&&(p<y&&(d+=z[n++]<<p,p+=8),w+=d&(1<<y)-1,d>>>=y,p-=y),p<15&&(d+=z[n++]<<p,p+=8,d+=z[n++]<<p,p+=8),v=_[d&b];r:for(;;){if(d>>>=y=v>>>24,p-=y,!(16&(y=v>>>16&255))){if(0==(64&y)){v=_[(65535&v)+(d&(1<<y)-1)];continue r}e.msg="invalid distance code",r.mode=30;break e}if(k=65535&v,p<(y&=15)&&(d+=z[n++]<<p,(p+=8)<y&&(d+=z[n++]<<p,p+=8)),h<(k+=d&(1<<y)-1)){e.msg="invalid distance too far back",r.mode=30;break e}if(d>>>=y,p-=y,(y=s-a)<k){if(l<(y=k-y)&&r.sane){e.msg="invalid distance too far back",r.mode=30;break e}if(S=c,(x=0)===f){if(x+=u-y,y<w){for(w-=y;C[s++]=c[x++],--y;);x=s-k,S=C}}else if(f<y){if(x+=u+f-y,(y-=f)<w){for(w-=y;C[s++]=c[x++],--y;);if(x=0,f<w){for(w-=y=f;C[s++]=c[x++],--y;);x=s-k,S=C}}}else if(x+=f-y,y<w){for(w-=y;C[s++]=c[x++],--y;);x=s-k,S=C}for(;2<w;)C[s++]=S[x++],C[s++]=S[x++],C[s++]=S[x++],w-=3;w&&(C[s++]=S[x++],1<w&&(C[s++]=S[x++]))}else{for(x=s-k;C[s++]=C[x++],C[s++]=C[x++],C[s++]=C[x++],2<(w-=3););w&&(C[s++]=C[x++],1<w&&(C[s++]=C[x++]))}break}}break}}while(n<i&&s<o);n-=w=p>>3,d&=(1<<(p-=w<<3))-1,e.next_in=n,e.next_out=s,e.avail_in=n<i?i-n+5:5-(n-i),e.avail_out=s<o?o-s+257:257-(s-o),r.hold=d,r.bits=p}},{}],49:[function(e,t,r){"use strict";var I=e("../utils/common"),O=e("./adler32"),B=e("./crc32"),R=e("./inffast"),T=e("./inftrees"),D=1,F=2,N=0,U=-2,P=1,n=852,i=592;function L(e){return(e>>>24&255)+(e>>>8&65280)+((65280&e)<<8)+((255&e)<<24)}function s(){this.mode=0,this.last=!1,this.wrap=0,this.havedict=!1,this.flags=0,this.dmax=0,this.check=0,this.total=0,this.head=null,this.wbits=0,this.wsize=0,this.whave=0,this.wnext=0,this.window=null,this.hold=0,this.bits=0,this.length=0,this.offset=0,this.extra=0,this.lencode=null,this.distcode=null,this.lenbits=0,this.distbits=0,this.ncode=0,this.nlen=0,this.ndist=0,this.have=0,this.next=null,this.lens=new I.Buf16(320),this.work=new I.Buf16(288),this.lendyn=null,this.distdyn=null,this.sane=0,this.back=0,this.was=0}function a(e){var t;return e&&e.state?(t=e.state,e.total_in=e.total_out=t.total=0,e.msg="",t.wrap&&(e.adler=1&t.wrap),t.mode=P,t.last=0,t.havedict=0,t.dmax=32768,t.head=null,t.hold=0,t.bits=0,t.lencode=t.lendyn=new I.Buf32(n),t.distcode=t.distdyn=new I.Buf32(i),t.sane=1,t.back=-1,N):U}function o(e){var t;return e&&e.state?((t=e.state).wsize=0,t.whave=0,t.wnext=0,a(e)):U}function h(e,t){var r,n;return e&&e.state?(n=e.state,t<0?(r=0,t=-t):(r=1+(t>>4),t<48&&(t&=15)),t&&(t<8||15<t)?U:(null!==n.window&&n.wbits!==t&&(n.window=null),n.wrap=r,n.wbits=t,o(e))):U}function u(e,t){var r,n;return e?(n=new s,(e.state=n).window=null,(r=h(e,t))!==N&&(e.state=null),r):U}var l,f,c=!0;function j(e){if(c){var t;for(l=new I.Buf32(512),f=new I.Buf32(32),t=0;t<144;)e.lens[t++]=8;for(;t<256;)e.lens[t++]=9;for(;t<280;)e.lens[t++]=7;for(;t<288;)e.lens[t++]=8;for(T(D,e.lens,0,288,l,0,e.work,{bits:9}),t=0;t<32;)e.lens[t++]=5;T(F,e.lens,0,32,f,0,e.work,{bits:5}),c=!1}e.lencode=l,e.lenbits=9,e.distcode=f,e.distbits=5}function Z(e,t,r,n){var i,s=e.state;return null===s.window&&(s.wsize=1<<s.wbits,s.wnext=0,s.whave=0,s.window=new I.Buf8(s.wsize)),n>=s.wsize?(I.arraySet(s.window,t,r-s.wsize,s.wsize,0),s.wnext=0,s.whave=s.wsize):(n<(i=s.wsize-s.wnext)&&(i=n),I.arraySet(s.window,t,r-n,i,s.wnext),(n-=i)?(I.arraySet(s.window,t,r-n,n,0),s.wnext=n,s.whave=s.wsize):(s.wnext+=i,s.wnext===s.wsize&&(s.wnext=0),s.whave<s.wsize&&(s.whave+=i))),0}r.inflateReset=o,r.inflateReset2=h,r.inflateResetKeep=a,r.inflateInit=function(e){return u(e,15)},r.inflateInit2=u,r.inflate=function(e,t){var r,n,i,s,a,o,h,u,l,f,c,d,p,m,_,g,b,v,y,w,k,x,S,z,C=0,E=new I.Buf8(4),A=[16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15];if(!e||!e.state||!e.output||!e.input&&0!==e.avail_in)return U;12===(r=e.state).mode&&(r.mode=13),a=e.next_out,i=e.output,h=e.avail_out,s=e.next_in,n=e.input,o=e.avail_in,u=r.hold,l=r.bits,f=o,c=h,x=N;e:for(;;)switch(r.mode){case P:if(0===r.wrap){r.mode=13;break}for(;l<16;){if(0===o)break e;o--,u+=n[s++]<<l,l+=8}if(2&r.wrap&&35615===u){E[r.check=0]=255&u,E[1]=u>>>8&255,r.check=B(r.check,E,2,0),l=u=0,r.mode=2;break}if(r.flags=0,r.head&&(r.head.done=!1),!(1&r.wrap)||(((255&u)<<8)+(u>>8))%31){e.msg="incorrect header check",r.mode=30;break}if(8!=(15&u)){e.msg="unknown compression method",r.mode=30;break}if(l-=4,k=8+(15&(u>>>=4)),0===r.wbits)r.wbits=k;else if(k>r.wbits){e.msg="invalid window size",r.mode=30;break}r.dmax=1<<k,e.adler=r.check=1,r.mode=512&u?10:12,l=u=0;break;case 2:for(;l<16;){if(0===o)break e;o--,u+=n[s++]<<l,l+=8}if(r.flags=u,8!=(255&r.flags)){e.msg="unknown compression method",r.mode=30;break}if(57344&r.flags){e.msg="unknown header flags set",r.mode=30;break}r.head&&(r.head.text=u>>8&1),512&r.flags&&(E[0]=255&u,E[1]=u>>>8&255,r.check=B(r.check,E,2,0)),l=u=0,r.mode=3;case 3:for(;l<32;){if(0===o)break e;o--,u+=n[s++]<<l,l+=8}r.head&&(r.head.time=u),512&r.flags&&(E[0]=255&u,E[1]=u>>>8&255,E[2]=u>>>16&255,E[3]=u>>>24&255,r.check=B(r.check,E,4,0)),l=u=0,r.mode=4;case 4:for(;l<16;){if(0===o)break e;o--,u+=n[s++]<<l,l+=8}r.head&&(r.head.xflags=255&u,r.head.os=u>>8),512&r.flags&&(E[0]=255&u,E[1]=u>>>8&255,r.check=B(r.check,E,2,0)),l=u=0,r.mode=5;case 5:if(1024&r.flags){for(;l<16;){if(0===o)break e;o--,u+=n[s++]<<l,l+=8}r.length=u,r.head&&(r.head.extra_len=u),512&r.flags&&(E[0]=255&u,E[1]=u>>>8&255,r.check=B(r.check,E,2,0)),l=u=0}else r.head&&(r.head.extra=null);r.mode=6;case 6:if(1024&r.flags&&(o<(d=r.length)&&(d=o),d&&(r.head&&(k=r.head.extra_len-r.length,r.head.extra||(r.head.extra=new Array(r.head.extra_len)),I.arraySet(r.head.extra,n,s,d,k)),512&r.flags&&(r.check=B(r.check,n,d,s)),o-=d,s+=d,r.length-=d),r.length))break e;r.length=0,r.mode=7;case 7:if(2048&r.flags){if(0===o)break e;for(d=0;k=n[s+d++],r.head&&k&&r.length<65536&&(r.head.name+=String.fromCharCode(k)),k&&d<o;);if(512&r.flags&&(r.check=B(r.check,n,d,s)),o-=d,s+=d,k)break e}else r.head&&(r.head.name=null);r.length=0,r.mode=8;case 8:if(4096&r.flags){if(0===o)break e;for(d=0;k=n[s+d++],r.head&&k&&r.length<65536&&(r.head.comment+=String.fromCharCode(k)),k&&d<o;);if(512&r.flags&&(r.check=B(r.check,n,d,s)),o-=d,s+=d,k)break e}else r.head&&(r.head.comment=null);r.mode=9;case 9:if(512&r.flags){for(;l<16;){if(0===o)break e;o--,u+=n[s++]<<l,l+=8}if(u!==(65535&r.check)){e.msg="header crc mismatch",r.mode=30;break}l=u=0}r.head&&(r.head.hcrc=r.flags>>9&1,r.head.done=!0),e.adler=r.check=0,r.mode=12;break;case 10:for(;l<32;){if(0===o)break e;o--,u+=n[s++]<<l,l+=8}e.adler=r.check=L(u),l=u=0,r.mode=11;case 11:if(0===r.havedict)return e.next_out=a,e.avail_out=h,e.next_in=s,e.avail_in=o,r.hold=u,r.bits=l,2;e.adler=r.check=1,r.mode=12;case 12:if(5===t||6===t)break e;case 13:if(r.last){u>>>=7&l,l-=7&l,r.mode=27;break}for(;l<3;){if(0===o)break e;o--,u+=n[s++]<<l,l+=8}switch(r.last=1&u,l-=1,3&(u>>>=1)){case 0:r.mode=14;break;case 1:if(j(r),r.mode=20,6!==t)break;u>>>=2,l-=2;break e;case 2:r.mode=17;break;case 3:e.msg="invalid block type",r.mode=30}u>>>=2,l-=2;break;case 14:for(u>>>=7&l,l-=7&l;l<32;){if(0===o)break e;o--,u+=n[s++]<<l,l+=8}if((65535&u)!=(u>>>16^65535)){e.msg="invalid stored block lengths",r.mode=30;break}if(r.length=65535&u,l=u=0,r.mode=15,6===t)break e;case 15:r.mode=16;case 16:if(d=r.length){if(o<d&&(d=o),h<d&&(d=h),0===d)break e;I.arraySet(i,n,s,d,a),o-=d,s+=d,h-=d,a+=d,r.length-=d;break}r.mode=12;break;case 17:for(;l<14;){if(0===o)break e;o--,u+=n[s++]<<l,l+=8}if(r.nlen=257+(31&u),u>>>=5,l-=5,r.ndist=1+(31&u),u>>>=5,l-=5,r.ncode=4+(15&u),u>>>=4,l-=4,286<r.nlen||30<r.ndist){e.msg="too many length or distance symbols",r.mode=30;break}r.have=0,r.mode=18;case 18:for(;r.have<r.ncode;){for(;l<3;){if(0===o)break e;o--,u+=n[s++]<<l,l+=8}r.lens[A[r.have++]]=7&u,u>>>=3,l-=3}for(;r.have<19;)r.lens[A[r.have++]]=0;if(r.lencode=r.lendyn,r.lenbits=7,S={bits:r.lenbits},x=T(0,r.lens,0,19,r.lencode,0,r.work,S),r.lenbits=S.bits,x){e.msg="invalid code lengths set",r.mode=30;break}r.have=0,r.mode=19;case 19:for(;r.have<r.nlen+r.ndist;){for(;g=(C=r.lencode[u&(1<<r.lenbits)-1])>>>16&255,b=65535&C,!((_=C>>>24)<=l);){if(0===o)break e;o--,u+=n[s++]<<l,l+=8}if(b<16)u>>>=_,l-=_,r.lens[r.have++]=b;else{if(16===b){for(z=_+2;l<z;){if(0===o)break e;o--,u+=n[s++]<<l,l+=8}if(u>>>=_,l-=_,0===r.have){e.msg="invalid bit length repeat",r.mode=30;break}k=r.lens[r.have-1],d=3+(3&u),u>>>=2,l-=2}else if(17===b){for(z=_+3;l<z;){if(0===o)break e;o--,u+=n[s++]<<l,l+=8}l-=_,k=0,d=3+(7&(u>>>=_)),u>>>=3,l-=3}else{for(z=_+7;l<z;){if(0===o)break e;o--,u+=n[s++]<<l,l+=8}l-=_,k=0,d=11+(127&(u>>>=_)),u>>>=7,l-=7}if(r.have+d>r.nlen+r.ndist){e.msg="invalid bit length repeat",r.mode=30;break}for(;d--;)r.lens[r.have++]=k}}if(30===r.mode)break;if(0===r.lens[256]){e.msg="invalid code -- missing end-of-block",r.mode=30;break}if(r.lenbits=9,S={bits:r.lenbits},x=T(D,r.lens,0,r.nlen,r.lencode,0,r.work,S),r.lenbits=S.bits,x){e.msg="invalid literal/lengths set",r.mode=30;break}if(r.distbits=6,r.distcode=r.distdyn,S={bits:r.distbits},x=T(F,r.lens,r.nlen,r.ndist,r.distcode,0,r.work,S),r.distbits=S.bits,x){e.msg="invalid distances set",r.mode=30;break}if(r.mode=20,6===t)break e;case 20:r.mode=21;case 21:if(6<=o&&258<=h){e.next_out=a,e.avail_out=h,e.next_in=s,e.avail_in=o,r.hold=u,r.bits=l,R(e,c),a=e.next_out,i=e.output,h=e.avail_out,s=e.next_in,n=e.input,o=e.avail_in,u=r.hold,l=r.bits,12===r.mode&&(r.back=-1);break}for(r.back=0;g=(C=r.lencode[u&(1<<r.lenbits)-1])>>>16&255,b=65535&C,!((_=C>>>24)<=l);){if(0===o)break e;o--,u+=n[s++]<<l,l+=8}if(g&&0==(240&g)){for(v=_,y=g,w=b;g=(C=r.lencode[w+((u&(1<<v+y)-1)>>v)])>>>16&255,b=65535&C,!(v+(_=C>>>24)<=l);){if(0===o)break e;o--,u+=n[s++]<<l,l+=8}u>>>=v,l-=v,r.back+=v}if(u>>>=_,l-=_,r.back+=_,r.length=b,0===g){r.mode=26;break}if(32&g){r.back=-1,r.mode=12;break}if(64&g){e.msg="invalid literal/length code",r.mode=30;break}r.extra=15&g,r.mode=22;case 22:if(r.extra){for(z=r.extra;l<z;){if(0===o)break e;o--,u+=n[s++]<<l,l+=8}r.length+=u&(1<<r.extra)-1,u>>>=r.extra,l-=r.extra,r.back+=r.extra}r.was=r.length,r.mode=23;case 23:for(;g=(C=r.distcode[u&(1<<r.distbits)-1])>>>16&255,b=65535&C,!((_=C>>>24)<=l);){if(0===o)break e;o--,u+=n[s++]<<l,l+=8}if(0==(240&g)){for(v=_,y=g,w=b;g=(C=r.distcode[w+((u&(1<<v+y)-1)>>v)])>>>16&255,b=65535&C,!(v+(_=C>>>24)<=l);){if(0===o)break e;o--,u+=n[s++]<<l,l+=8}u>>>=v,l-=v,r.back+=v}if(u>>>=_,l-=_,r.back+=_,64&g){e.msg="invalid distance code",r.mode=30;break}r.offset=b,r.extra=15&g,r.mode=24;case 24:if(r.extra){for(z=r.extra;l<z;){if(0===o)break e;o--,u+=n[s++]<<l,l+=8}r.offset+=u&(1<<r.extra)-1,u>>>=r.extra,l-=r.extra,r.back+=r.extra}if(r.offset>r.dmax){e.msg="invalid distance too far back",r.mode=30;break}r.mode=25;case 25:if(0===h)break e;if(d=c-h,r.offset>d){if((d=r.offset-d)>r.whave&&r.sane){e.msg="invalid distance too far back",r.mode=30;break}p=d>r.wnext?(d-=r.wnext,r.wsize-d):r.wnext-d,d>r.length&&(d=r.length),m=r.window}else m=i,p=a-r.offset,d=r.length;for(h<d&&(d=h),h-=d,r.length-=d;i[a++]=m[p++],--d;);0===r.length&&(r.mode=21);break;case 26:if(0===h)break e;i[a++]=r.length,h--,r.mode=21;break;case 27:if(r.wrap){for(;l<32;){if(0===o)break e;o--,u|=n[s++]<<l,l+=8}if(c-=h,e.total_out+=c,r.total+=c,c&&(e.adler=r.check=r.flags?B(r.check,i,c,a-c):O(r.check,i,c,a-c)),c=h,(r.flags?u:L(u))!==r.check){e.msg="incorrect data check",r.mode=30;break}l=u=0}r.mode=28;case 28:if(r.wrap&&r.flags){for(;l<32;){if(0===o)break e;o--,u+=n[s++]<<l,l+=8}if(u!==(4294967295&r.total)){e.msg="incorrect length check",r.mode=30;break}l=u=0}r.mode=29;case 29:x=1;break e;case 30:x=-3;break e;case 31:return-4;case 32:default:return U}return e.next_out=a,e.avail_out=h,e.next_in=s,e.avail_in=o,r.hold=u,r.bits=l,(r.wsize||c!==e.avail_out&&r.mode<30&&(r.mode<27||4!==t))&&Z(e,e.output,e.next_out,c-e.avail_out)?(r.mode=31,-4):(f-=e.avail_in,c-=e.avail_out,e.total_in+=f,e.total_out+=c,r.total+=c,r.wrap&&c&&(e.adler=r.check=r.flags?B(r.check,i,c,e.next_out-c):O(r.check,i,c,e.next_out-c)),e.data_type=r.bits+(r.last?64:0)+(12===r.mode?128:0)+(20===r.mode||15===r.mode?256:0),(0==f&&0===c||4===t)&&x===N&&(x=-5),x)},r.inflateEnd=function(e){if(!e||!e.state)return U;var t=e.state;return t.window&&(t.window=null),e.state=null,N},r.inflateGetHeader=function(e,t){var r;return e&&e.state?0==(2&(r=e.state).wrap)?U:((r.head=t).done=!1,N):U},r.inflateSetDictionary=function(e,t){var r,n=t.length;return e&&e.state?0!==(r=e.state).wrap&&11!==r.mode?U:11===r.mode&&O(1,t,n,0)!==r.check?-3:Z(e,t,n,n)?(r.mode=31,-4):(r.havedict=1,N):U},r.inflateInfo="pako inflate (from Nodeca project)"},{"../utils/common":41,"./adler32":43,"./crc32":45,"./inffast":48,"./inftrees":50}],50:[function(e,t,r){"use strict";var D=e("../utils/common"),F=[3,4,5,6,7,8,9,10,11,13,15,17,19,23,27,31,35,43,51,59,67,83,99,115,131,163,195,227,258,0,0],N=[16,16,16,16,16,16,16,16,17,17,17,17,18,18,18,18,19,19,19,19,20,20,20,20,21,21,21,21,16,72,78],U=[1,2,3,4,5,7,9,13,17,25,33,49,65,97,129,193,257,385,513,769,1025,1537,2049,3073,4097,6145,8193,12289,16385,24577,0,0],P=[16,16,16,16,17,17,18,18,19,19,20,20,21,21,22,22,23,23,24,24,25,25,26,26,27,27,28,28,29,29,64,64];t.exports=function(e,t,r,n,i,s,a,o){var h,u,l,f,c,d,p,m,_,g=o.bits,b=0,v=0,y=0,w=0,k=0,x=0,S=0,z=0,C=0,E=0,A=null,I=0,O=new D.Buf16(16),B=new D.Buf16(16),R=null,T=0;for(b=0;b<=15;b++)O[b]=0;for(v=0;v<n;v++)O[t[r+v]]++;for(k=g,w=15;1<=w&&0===O[w];w--);if(w<k&&(k=w),0===w)return i[s++]=20971520,i[s++]=20971520,o.bits=1,0;for(y=1;y<w&&0===O[y];y++);for(k<y&&(k=y),b=z=1;b<=15;b++)if(z<<=1,(z-=O[b])<0)return-1;if(0<z&&(0===e||1!==w))return-1;for(B[1]=0,b=1;b<15;b++)B[b+1]=B[b]+O[b];for(v=0;v<n;v++)0!==t[r+v]&&(a[B[t[r+v]]++]=v);if(d=0===e?(A=R=a,19):1===e?(A=F,I-=257,R=N,T-=257,256):(A=U,R=P,-1),b=y,c=s,S=v=E=0,l=-1,f=(C=1<<(x=k))-1,1===e&&852<C||2===e&&592<C)return 1;for(;;){for(p=b-S,_=a[v]<d?(m=0,a[v]):a[v]>d?(m=R[T+a[v]],A[I+a[v]]):(m=96,0),h=1<<b-S,y=u=1<<x;i[c+(E>>S)+(u-=h)]=p<<24|m<<16|_|0,0!==u;);for(h=1<<b-1;E&h;)h>>=1;if(0!==h?(E&=h-1,E+=h):E=0,v++,0==--O[b]){if(b===w)break;b=t[r+a[v]]}if(k<b&&(E&f)!==l){for(0===S&&(S=k),c+=y,z=1<<(x=b-S);x+S<w&&!((z-=O[x+S])<=0);)x++,z<<=1;if(C+=1<<x,1===e&&852<C||2===e&&592<C)return 1;i[l=E&f]=k<<24|x<<16|c-s|0}}return 0!==E&&(i[c+E]=b-S<<24|64<<16|0),o.bits=k,0}},{"../utils/common":41}],51:[function(e,t,r){"use strict";t.exports={2:"need dictionary",1:"stream end",0:"","-1":"file error","-2":"stream error","-3":"data error","-4":"insufficient memory","-5":"buffer error","-6":"incompatible version"}},{}],52:[function(e,t,r){"use strict";var i=e("../utils/common"),o=0,h=1;function n(e){for(var t=e.length;0<=--t;)e[t]=0}var s=0,a=29,u=256,l=u+1+a,f=30,c=19,_=2*l+1,g=15,d=16,p=7,m=256,b=16,v=17,y=18,w=[0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0],k=[0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13],x=[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2,3,7],S=[16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15],z=new Array(2*(l+2));n(z);var C=new Array(2*f);n(C);var E=new Array(512);n(E);var A=new Array(256);n(A);var I=new Array(a);n(I);var O,B,R,T=new Array(f);function D(e,t,r,n,i){this.static_tree=e,this.extra_bits=t,this.extra_base=r,this.elems=n,this.max_length=i,this.has_stree=e&&e.length}function F(e,t){this.dyn_tree=e,this.max_code=0,this.stat_desc=t}function N(e){return e<256?E[e]:E[256+(e>>>7)]}function U(e,t){e.pending_buf[e.pending++]=255&t,e.pending_buf[e.pending++]=t>>>8&255}function P(e,t,r){e.bi_valid>d-r?(e.bi_buf|=t<<e.bi_valid&65535,U(e,e.bi_buf),e.bi_buf=t>>d-e.bi_valid,e.bi_valid+=r-d):(e.bi_buf|=t<<e.bi_valid&65535,e.bi_valid+=r)}function L(e,t,r){P(e,r[2*t],r[2*t+1])}function j(e,t){for(var r=0;r|=1&e,e>>>=1,r<<=1,0<--t;);return r>>>1}function Z(e,t,r){var n,i,s=new Array(g+1),a=0;for(n=1;n<=g;n++)s[n]=a=a+r[n-1]<<1;for(i=0;i<=t;i++){var o=e[2*i+1];0!==o&&(e[2*i]=j(s[o]++,o))}}function W(e){var t;for(t=0;t<l;t++)e.dyn_ltree[2*t]=0;for(t=0;t<f;t++)e.dyn_dtree[2*t]=0;for(t=0;t<c;t++)e.bl_tree[2*t]=0;e.dyn_ltree[2*m]=1,e.opt_len=e.static_len=0,e.last_lit=e.matches=0}function M(e){8<e.bi_valid?U(e,e.bi_buf):0<e.bi_valid&&(e.pending_buf[e.pending++]=e.bi_buf),e.bi_buf=0,e.bi_valid=0}function H(e,t,r,n){var i=2*t,s=2*r;return e[i]<e[s]||e[i]===e[s]&&n[t]<=n[r]}function G(e,t,r){for(var n=e.heap[r],i=r<<1;i<=e.heap_len&&(i<e.heap_len&&H(t,e.heap[i+1],e.heap[i],e.depth)&&i++,!H(t,n,e.heap[i],e.depth));)e.heap[r]=e.heap[i],r=i,i<<=1;e.heap[r]=n}function K(e,t,r){var n,i,s,a,o=0;if(0!==e.last_lit)for(;n=e.pending_buf[e.d_buf+2*o]<<8|e.pending_buf[e.d_buf+2*o+1],i=e.pending_buf[e.l_buf+o],o++,0===n?L(e,i,t):(L(e,(s=A[i])+u+1,t),0!==(a=w[s])&&P(e,i-=I[s],a),L(e,s=N(--n),r),0!==(a=k[s])&&P(e,n-=T[s],a)),o<e.last_lit;);L(e,m,t)}function Y(e,t){var r,n,i,s=t.dyn_tree,a=t.stat_desc.static_tree,o=t.stat_desc.has_stree,h=t.stat_desc.elems,u=-1;for(e.heap_len=0,e.heap_max=_,r=0;r<h;r++)0!==s[2*r]?(e.heap[++e.heap_len]=u=r,e.depth[r]=0):s[2*r+1]=0;for(;e.heap_len<2;)s[2*(i=e.heap[++e.heap_len]=u<2?++u:0)]=1,e.depth[i]=0,e.opt_len--,o&&(e.static_len-=a[2*i+1]);for(t.max_code=u,r=e.heap_len>>1;1<=r;r--)G(e,s,r);for(i=h;r=e.heap[1],e.heap[1]=e.heap[e.heap_len--],G(e,s,1),n=e.heap[1],e.heap[--e.heap_max]=r,e.heap[--e.heap_max]=n,s[2*i]=s[2*r]+s[2*n],e.depth[i]=(e.depth[r]>=e.depth[n]?e.depth[r]:e.depth[n])+1,s[2*r+1]=s[2*n+1]=i,e.heap[1]=i++,G(e,s,1),2<=e.heap_len;);e.heap[--e.heap_max]=e.heap[1],function(e,t){var r,n,i,s,a,o,h=t.dyn_tree,u=t.max_code,l=t.stat_desc.static_tree,f=t.stat_desc.has_stree,c=t.stat_desc.extra_bits,d=t.stat_desc.extra_base,p=t.stat_desc.max_length,m=0;for(s=0;s<=g;s++)e.bl_count[s]=0;for(h[2*e.heap[e.heap_max]+1]=0,r=e.heap_max+1;r<_;r++)p<(s=h[2*h[2*(n=e.heap[r])+1]+1]+1)&&(s=p,m++),h[2*n+1]=s,u<n||(e.bl_count[s]++,a=0,d<=n&&(a=c[n-d]),o=h[2*n],e.opt_len+=o*(s+a),f&&(e.static_len+=o*(l[2*n+1]+a)));if(0!==m){do{for(s=p-1;0===e.bl_count[s];)s--;e.bl_count[s]--,e.bl_count[s+1]+=2,e.bl_count[p]--,m-=2}while(0<m);for(s=p;0!==s;s--)for(n=e.bl_count[s];0!==n;)u<(i=e.heap[--r])||(h[2*i+1]!==s&&(e.opt_len+=(s-h[2*i+1])*h[2*i],h[2*i+1]=s),n--)}}(e,t),Z(s,u,e.bl_count)}function X(e,t,r){var n,i,s=-1,a=t[1],o=0,h=7,u=4;for(0===a&&(h=138,u=3),t[2*(r+1)+1]=65535,n=0;n<=r;n++)i=a,a=t[2*(n+1)+1],++o<h&&i===a||(o<u?e.bl_tree[2*i]+=o:0!==i?(i!==s&&e.bl_tree[2*i]++,e.bl_tree[2*b]++):o<=10?e.bl_tree[2*v]++:e.bl_tree[2*y]++,s=i,u=(o=0)===a?(h=138,3):i===a?(h=6,3):(h=7,4))}function V(e,t,r){var n,i,s=-1,a=t[1],o=0,h=7,u=4;for(0===a&&(h=138,u=3),n=0;n<=r;n++)if(i=a,a=t[2*(n+1)+1],!(++o<h&&i===a)){if(o<u)for(;L(e,i,e.bl_tree),0!=--o;);else 0!==i?(i!==s&&(L(e,i,e.bl_tree),o--),L(e,b,e.bl_tree),P(e,o-3,2)):o<=10?(L(e,v,e.bl_tree),P(e,o-3,3)):(L(e,y,e.bl_tree),P(e,o-11,7));s=i,u=(o=0)===a?(h=138,3):i===a?(h=6,3):(h=7,4)}}n(T);var q=!1;function J(e,t,r,n){P(e,(s<<1)+(n?1:0),3),function(e,t,r,n){M(e),n&&(U(e,r),U(e,~r)),i.arraySet(e.pending_buf,e.window,t,r,e.pending),e.pending+=r}(e,t,r,!0)}r._tr_init=function(e){q||(function(){var e,t,r,n,i,s=new Array(g+1);for(n=r=0;n<a-1;n++)for(I[n]=r,e=0;e<1<<w[n];e++)A[r++]=n;for(A[r-1]=n,n=i=0;n<16;n++)for(T[n]=i,e=0;e<1<<k[n];e++)E[i++]=n;for(i>>=7;n<f;n++)for(T[n]=i<<7,e=0;e<1<<k[n]-7;e++)E[256+i++]=n;for(t=0;t<=g;t++)s[t]=0;for(e=0;e<=143;)z[2*e+1]=8,e++,s[8]++;for(;e<=255;)z[2*e+1]=9,e++,s[9]++;for(;e<=279;)z[2*e+1]=7,e++,s[7]++;for(;e<=287;)z[2*e+1]=8,e++,s[8]++;for(Z(z,l+1,s),e=0;e<f;e++)C[2*e+1]=5,C[2*e]=j(e,5);O=new D(z,w,u+1,l,g),B=new D(C,k,0,f,g),R=new D(new Array(0),x,0,c,p)}(),q=!0),e.l_desc=new F(e.dyn_ltree,O),e.d_desc=new F(e.dyn_dtree,B),e.bl_desc=new F(e.bl_tree,R),e.bi_buf=0,e.bi_valid=0,W(e)},r._tr_stored_block=J,r._tr_flush_block=function(e,t,r,n){var i,s,a=0;0<e.level?(2===e.strm.data_type&&(e.strm.data_type=function(e){var t,r=4093624447;for(t=0;t<=31;t++,r>>>=1)if(1&r&&0!==e.dyn_ltree[2*t])return o;if(0!==e.dyn_ltree[18]||0!==e.dyn_ltree[20]||0!==e.dyn_ltree[26])return h;for(t=32;t<u;t++)if(0!==e.dyn_ltree[2*t])return h;return o}(e)),Y(e,e.l_desc),Y(e,e.d_desc),a=function(e){var t;for(X(e,e.dyn_ltree,e.l_desc.max_code),X(e,e.dyn_dtree,e.d_desc.max_code),Y(e,e.bl_desc),t=c-1;3<=t&&0===e.bl_tree[2*S[t]+1];t--);return e.opt_len+=3*(t+1)+5+5+4,t}(e),i=e.opt_len+3+7>>>3,(s=e.static_len+3+7>>>3)<=i&&(i=s)):i=s=r+5,r+4<=i&&-1!==t?J(e,t,r,n):4===e.strategy||s===i?(P(e,2+(n?1:0),3),K(e,z,C)):(P(e,4+(n?1:0),3),function(e,t,r,n){var i;for(P(e,t-257,5),P(e,r-1,5),P(e,n-4,4),i=0;i<n;i++)P(e,e.bl_tree[2*S[i]+1],3);V(e,e.dyn_ltree,t-1),V(e,e.dyn_dtree,r-1)}(e,e.l_desc.max_code+1,e.d_desc.max_code+1,a+1),K(e,e.dyn_ltree,e.dyn_dtree)),W(e),n&&M(e)},r._tr_tally=function(e,t,r){return e.pending_buf[e.d_buf+2*e.last_lit]=t>>>8&255,e.pending_buf[e.d_buf+2*e.last_lit+1]=255&t,e.pending_buf[e.l_buf+e.last_lit]=255&r,e.last_lit++,0===t?e.dyn_ltree[2*r]++:(e.matches++,t--,e.dyn_ltree[2*(A[r]+u+1)]++,e.dyn_dtree[2*N(t)]++),e.last_lit===e.lit_bufsize-1},r._tr_align=function(e){P(e,2,3),L(e,m,z),function(e){16===e.bi_valid?(U(e,e.bi_buf),e.bi_buf=0,e.bi_valid=0):8<=e.bi_valid&&(e.pending_buf[e.pending++]=255&e.bi_buf,e.bi_buf>>=8,e.bi_valid-=8)}(e)}},{"../utils/common":41}],53:[function(e,t,r){"use strict";t.exports=function(){this.input=null,this.next_in=0,this.avail_in=0,this.total_in=0,this.output=null,this.next_out=0,this.avail_out=0,this.total_out=0,this.msg="",this.state=null,this.data_type=2,this.adler=0}},{}],54:[function(e,t,r){(function(e){!function(r,n){"use strict";if(!r.setImmediate){var i,s,t,a,o=1,h={},u=!1,l=r.document,e=Object.getPrototypeOf&&Object.getPrototypeOf(r);e=e&&e.setTimeout?e:r,i="[object process]"==={}.toString.call(r.process)?function(e){process.nextTick(function(){c(e)})}:function(){if(r.postMessage&&!r.importScripts){var e=!0,t=r.onmessage;return r.onmessage=function(){e=!1},r.postMessage("","*"),r.onmessage=t,e}}()?(a="setImmediate$"+Math.random()+"$",r.addEventListener?r.addEventListener("message",d,!1):r.attachEvent("onmessage",d),function(e){r.postMessage(a+e,"*")}):r.MessageChannel?((t=new MessageChannel).port1.onmessage=function(e){c(e.data)},function(e){t.port2.postMessage(e)}):l&&"onreadystatechange"in l.createElement("script")?(s=l.documentElement,function(e){var t=l.createElement("script");t.onreadystatechange=function(){c(e),t.onreadystatechange=null,s.removeChild(t),t=null},s.appendChild(t)}):function(e){setTimeout(c,0,e)},e.setImmediate=function(e){"function"!=typeof e&&(e=new Function(""+e));for(var t=new Array(arguments.length-1),r=0;r<t.length;r++)t[r]=arguments[r+1];var n={callback:e,args:t};return h[o]=n,i(o),o++},e.clearImmediate=f}function f(e){delete h[e]}function c(e){if(u)setTimeout(c,0,e);else{var t=h[e];if(t){u=!0;try{!function(e){var t=e.callback,r=e.args;switch(r.length){case 0:t();break;case 1:t(r[0]);break;case 2:t(r[0],r[1]);break;case 3:t(r[0],r[1],r[2]);break;default:t.apply(n,r)}}(t)}finally{f(e),u=!1}}}}function d(e){e.source===r&&"string"==typeof e.data&&0===e.data.indexOf(a)&&c(+e.data.slice(a.length))}}("undefined"==typeof self?void 0===e?this:e:self)}).call(this,"undefined"!=typeof global?global:"undefined"!=typeof self?self:"undefined"!=typeof window?window:{})},{}]},{},[10])(10)});
}).call(this)}).call(this,require('_process'),typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],require("timers").setImmediate)
},{"_process":25,"buffer":12,"timers":28}],23:[function(require,module,exports){
(function (global){(function (){
/*!
    localForage -- Offline Storage, Improved
    Version 1.10.0
    https://localforage.github.io/localForage
    (c) 2013-2017 Mozilla, Apache License 2.0
*/
(function(f){if(typeof exports==="object"&&typeof module!=="undefined"){module.exports=f()}else if(typeof define==="function"&&define.amd){define([],f)}else{var g;if(typeof window!=="undefined"){g=window}else if(typeof global!=="undefined"){g=global}else if(typeof self!=="undefined"){g=self}else{g=this}g.localforage = f()}})(function(){var define,module,exports;return (function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw (f.code="MODULE_NOT_FOUND", f)}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(_dereq_,module,exports){
(function (global){
'use strict';
var Mutation = global.MutationObserver || global.WebKitMutationObserver;

var scheduleDrain;

{
  if (Mutation) {
    var called = 0;
    var observer = new Mutation(nextTick);
    var element = global.document.createTextNode('');
    observer.observe(element, {
      characterData: true
    });
    scheduleDrain = function () {
      element.data = (called = ++called % 2);
    };
  } else if (!global.setImmediate && typeof global.MessageChannel !== 'undefined') {
    var channel = new global.MessageChannel();
    channel.port1.onmessage = nextTick;
    scheduleDrain = function () {
      channel.port2.postMessage(0);
    };
  } else if ('document' in global && 'onreadystatechange' in global.document.createElement('script')) {
    scheduleDrain = function () {

      // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
      // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
      var scriptEl = global.document.createElement('script');
      scriptEl.onreadystatechange = function () {
        nextTick();

        scriptEl.onreadystatechange = null;
        scriptEl.parentNode.removeChild(scriptEl);
        scriptEl = null;
      };
      global.document.documentElement.appendChild(scriptEl);
    };
  } else {
    scheduleDrain = function () {
      setTimeout(nextTick, 0);
    };
  }
}

var draining;
var queue = [];
//named nextTick for less confusing stack traces
function nextTick() {
  draining = true;
  var i, oldQueue;
  var len = queue.length;
  while (len) {
    oldQueue = queue;
    queue = [];
    i = -1;
    while (++i < len) {
      oldQueue[i]();
    }
    len = queue.length;
  }
  draining = false;
}

module.exports = immediate;
function immediate(task) {
  if (queue.push(task) === 1 && !draining) {
    scheduleDrain();
  }
}

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],2:[function(_dereq_,module,exports){
'use strict';
var immediate = _dereq_(1);

/* istanbul ignore next */
function INTERNAL() {}

var handlers = {};

var REJECTED = ['REJECTED'];
var FULFILLED = ['FULFILLED'];
var PENDING = ['PENDING'];

module.exports = Promise;

function Promise(resolver) {
  if (typeof resolver !== 'function') {
    throw new TypeError('resolver must be a function');
  }
  this.state = PENDING;
  this.queue = [];
  this.outcome = void 0;
  if (resolver !== INTERNAL) {
    safelyResolveThenable(this, resolver);
  }
}

Promise.prototype["catch"] = function (onRejected) {
  return this.then(null, onRejected);
};
Promise.prototype.then = function (onFulfilled, onRejected) {
  if (typeof onFulfilled !== 'function' && this.state === FULFILLED ||
    typeof onRejected !== 'function' && this.state === REJECTED) {
    return this;
  }
  var promise = new this.constructor(INTERNAL);
  if (this.state !== PENDING) {
    var resolver = this.state === FULFILLED ? onFulfilled : onRejected;
    unwrap(promise, resolver, this.outcome);
  } else {
    this.queue.push(new QueueItem(promise, onFulfilled, onRejected));
  }

  return promise;
};
function QueueItem(promise, onFulfilled, onRejected) {
  this.promise = promise;
  if (typeof onFulfilled === 'function') {
    this.onFulfilled = onFulfilled;
    this.callFulfilled = this.otherCallFulfilled;
  }
  if (typeof onRejected === 'function') {
    this.onRejected = onRejected;
    this.callRejected = this.otherCallRejected;
  }
}
QueueItem.prototype.callFulfilled = function (value) {
  handlers.resolve(this.promise, value);
};
QueueItem.prototype.otherCallFulfilled = function (value) {
  unwrap(this.promise, this.onFulfilled, value);
};
QueueItem.prototype.callRejected = function (value) {
  handlers.reject(this.promise, value);
};
QueueItem.prototype.otherCallRejected = function (value) {
  unwrap(this.promise, this.onRejected, value);
};

function unwrap(promise, func, value) {
  immediate(function () {
    var returnValue;
    try {
      returnValue = func(value);
    } catch (e) {
      return handlers.reject(promise, e);
    }
    if (returnValue === promise) {
      handlers.reject(promise, new TypeError('Cannot resolve promise with itself'));
    } else {
      handlers.resolve(promise, returnValue);
    }
  });
}

handlers.resolve = function (self, value) {
  var result = tryCatch(getThen, value);
  if (result.status === 'error') {
    return handlers.reject(self, result.value);
  }
  var thenable = result.value;

  if (thenable) {
    safelyResolveThenable(self, thenable);
  } else {
    self.state = FULFILLED;
    self.outcome = value;
    var i = -1;
    var len = self.queue.length;
    while (++i < len) {
      self.queue[i].callFulfilled(value);
    }
  }
  return self;
};
handlers.reject = function (self, error) {
  self.state = REJECTED;
  self.outcome = error;
  var i = -1;
  var len = self.queue.length;
  while (++i < len) {
    self.queue[i].callRejected(error);
  }
  return self;
};

function getThen(obj) {
  // Make sure we only access the accessor once as required by the spec
  var then = obj && obj.then;
  if (obj && (typeof obj === 'object' || typeof obj === 'function') && typeof then === 'function') {
    return function appyThen() {
      then.apply(obj, arguments);
    };
  }
}

function safelyResolveThenable(self, thenable) {
  // Either fulfill, reject or reject with error
  var called = false;
  function onError(value) {
    if (called) {
      return;
    }
    called = true;
    handlers.reject(self, value);
  }

  function onSuccess(value) {
    if (called) {
      return;
    }
    called = true;
    handlers.resolve(self, value);
  }

  function tryToUnwrap() {
    thenable(onSuccess, onError);
  }

  var result = tryCatch(tryToUnwrap);
  if (result.status === 'error') {
    onError(result.value);
  }
}

function tryCatch(func, value) {
  var out = {};
  try {
    out.value = func(value);
    out.status = 'success';
  } catch (e) {
    out.status = 'error';
    out.value = e;
  }
  return out;
}

Promise.resolve = resolve;
function resolve(value) {
  if (value instanceof this) {
    return value;
  }
  return handlers.resolve(new this(INTERNAL), value);
}

Promise.reject = reject;
function reject(reason) {
  var promise = new this(INTERNAL);
  return handlers.reject(promise, reason);
}

Promise.all = all;
function all(iterable) {
  var self = this;
  if (Object.prototype.toString.call(iterable) !== '[object Array]') {
    return this.reject(new TypeError('must be an array'));
  }

  var len = iterable.length;
  var called = false;
  if (!len) {
    return this.resolve([]);
  }

  var values = new Array(len);
  var resolved = 0;
  var i = -1;
  var promise = new this(INTERNAL);

  while (++i < len) {
    allResolver(iterable[i], i);
  }
  return promise;
  function allResolver(value, i) {
    self.resolve(value).then(resolveFromAll, function (error) {
      if (!called) {
        called = true;
        handlers.reject(promise, error);
      }
    });
    function resolveFromAll(outValue) {
      values[i] = outValue;
      if (++resolved === len && !called) {
        called = true;
        handlers.resolve(promise, values);
      }
    }
  }
}

Promise.race = race;
function race(iterable) {
  var self = this;
  if (Object.prototype.toString.call(iterable) !== '[object Array]') {
    return this.reject(new TypeError('must be an array'));
  }

  var len = iterable.length;
  var called = false;
  if (!len) {
    return this.resolve([]);
  }

  var i = -1;
  var promise = new this(INTERNAL);

  while (++i < len) {
    resolver(iterable[i]);
  }
  return promise;
  function resolver(value) {
    self.resolve(value).then(function (response) {
      if (!called) {
        called = true;
        handlers.resolve(promise, response);
      }
    }, function (error) {
      if (!called) {
        called = true;
        handlers.reject(promise, error);
      }
    });
  }
}

},{"1":1}],3:[function(_dereq_,module,exports){
(function (global){
'use strict';
if (typeof global.Promise !== 'function') {
  global.Promise = _dereq_(2);
}

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"2":2}],4:[function(_dereq_,module,exports){
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function getIDB() {
    /* global indexedDB,webkitIndexedDB,mozIndexedDB,OIndexedDB,msIndexedDB */
    try {
        if (typeof indexedDB !== 'undefined') {
            return indexedDB;
        }
        if (typeof webkitIndexedDB !== 'undefined') {
            return webkitIndexedDB;
        }
        if (typeof mozIndexedDB !== 'undefined') {
            return mozIndexedDB;
        }
        if (typeof OIndexedDB !== 'undefined') {
            return OIndexedDB;
        }
        if (typeof msIndexedDB !== 'undefined') {
            return msIndexedDB;
        }
    } catch (e) {
        return;
    }
}

var idb = getIDB();

function isIndexedDBValid() {
    try {
        // Initialize IndexedDB; fall back to vendor-prefixed versions
        // if needed.
        if (!idb || !idb.open) {
            return false;
        }
        // We mimic PouchDB here;
        //
        // We test for openDatabase because IE Mobile identifies itself
        // as Safari. Oh the lulz...
        var isSafari = typeof openDatabase !== 'undefined' && /(Safari|iPhone|iPad|iPod)/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent) && !/BlackBerry/.test(navigator.platform);

        var hasFetch = typeof fetch === 'function' && fetch.toString().indexOf('[native code') !== -1;

        // Safari <10.1 does not meet our requirements for IDB support
        // (see: https://github.com/pouchdb/pouchdb/issues/5572).
        // Safari 10.1 shipped with fetch, we can use that to detect it.
        // Note: this creates issues with `window.fetch` polyfills and
        // overrides; see:
        // https://github.com/localForage/localForage/issues/856
        return (!isSafari || hasFetch) && typeof indexedDB !== 'undefined' &&
        // some outdated implementations of IDB that appear on Samsung
        // and HTC Android devices <4.4 are missing IDBKeyRange
        // See: https://github.com/mozilla/localForage/issues/128
        // See: https://github.com/mozilla/localForage/issues/272
        typeof IDBKeyRange !== 'undefined';
    } catch (e) {
        return false;
    }
}

// Abstracts constructing a Blob object, so it also works in older
// browsers that don't support the native Blob constructor. (i.e.
// old QtWebKit versions, at least).
// Abstracts constructing a Blob object, so it also works in older
// browsers that don't support the native Blob constructor. (i.e.
// old QtWebKit versions, at least).
function createBlob(parts, properties) {
    /* global BlobBuilder,MSBlobBuilder,MozBlobBuilder,WebKitBlobBuilder */
    parts = parts || [];
    properties = properties || {};
    try {
        return new Blob(parts, properties);
    } catch (e) {
        if (e.name !== 'TypeError') {
            throw e;
        }
        var Builder = typeof BlobBuilder !== 'undefined' ? BlobBuilder : typeof MSBlobBuilder !== 'undefined' ? MSBlobBuilder : typeof MozBlobBuilder !== 'undefined' ? MozBlobBuilder : WebKitBlobBuilder;
        var builder = new Builder();
        for (var i = 0; i < parts.length; i += 1) {
            builder.append(parts[i]);
        }
        return builder.getBlob(properties.type);
    }
}

// This is CommonJS because lie is an external dependency, so Rollup
// can just ignore it.
if (typeof Promise === 'undefined') {
    // In the "nopromises" build this will just throw if you don't have
    // a global promise object, but it would throw anyway later.
    _dereq_(3);
}
var Promise$1 = Promise;

function executeCallback(promise, callback) {
    if (callback) {
        promise.then(function (result) {
            callback(null, result);
        }, function (error) {
            callback(error);
        });
    }
}

function executeTwoCallbacks(promise, callback, errorCallback) {
    if (typeof callback === 'function') {
        promise.then(callback);
    }

    if (typeof errorCallback === 'function') {
        promise["catch"](errorCallback);
    }
}

function normalizeKey(key) {
    // Cast the key to a string, as that's all we can set as a key.
    if (typeof key !== 'string') {
        console.warn(key + ' used as a key, but it is not a string.');
        key = String(key);
    }

    return key;
}

function getCallback() {
    if (arguments.length && typeof arguments[arguments.length - 1] === 'function') {
        return arguments[arguments.length - 1];
    }
}

// Some code originally from async_storage.js in
// [Gaia](https://github.com/mozilla-b2g/gaia).

var DETECT_BLOB_SUPPORT_STORE = 'local-forage-detect-blob-support';
var supportsBlobs = void 0;
var dbContexts = {};
var toString = Object.prototype.toString;

// Transaction Modes
var READ_ONLY = 'readonly';
var READ_WRITE = 'readwrite';

// Transform a binary string to an array buffer, because otherwise
// weird stuff happens when you try to work with the binary string directly.
// It is known.
// From http://stackoverflow.com/questions/14967647/ (continues on next line)
// encode-decode-image-with-base64-breaks-image (2013-04-21)
function _binStringToArrayBuffer(bin) {
    var length = bin.length;
    var buf = new ArrayBuffer(length);
    var arr = new Uint8Array(buf);
    for (var i = 0; i < length; i++) {
        arr[i] = bin.charCodeAt(i);
    }
    return buf;
}

//
// Blobs are not supported in all versions of IndexedDB, notably
// Chrome <37 and Android <5. In those versions, storing a blob will throw.
//
// Various other blob bugs exist in Chrome v37-42 (inclusive).
// Detecting them is expensive and confusing to users, and Chrome 37-42
// is at very low usage worldwide, so we do a hacky userAgent check instead.
//
// content-type bug: https://code.google.com/p/chromium/issues/detail?id=408120
// 404 bug: https://code.google.com/p/chromium/issues/detail?id=447916
// FileReader bug: https://code.google.com/p/chromium/issues/detail?id=447836
//
// Code borrowed from PouchDB. See:
// https://github.com/pouchdb/pouchdb/blob/master/packages/node_modules/pouchdb-adapter-idb/src/blobSupport.js
//
function _checkBlobSupportWithoutCaching(idb) {
    return new Promise$1(function (resolve) {
        var txn = idb.transaction(DETECT_BLOB_SUPPORT_STORE, READ_WRITE);
        var blob = createBlob(['']);
        txn.objectStore(DETECT_BLOB_SUPPORT_STORE).put(blob, 'key');

        txn.onabort = function (e) {
            // If the transaction aborts now its due to not being able to
            // write to the database, likely due to the disk being full
            e.preventDefault();
            e.stopPropagation();
            resolve(false);
        };

        txn.oncomplete = function () {
            var matchedChrome = navigator.userAgent.match(/Chrome\/(\d+)/);
            var matchedEdge = navigator.userAgent.match(/Edge\//);
            // MS Edge pretends to be Chrome 42:
            // https://msdn.microsoft.com/en-us/library/hh869301%28v=vs.85%29.aspx
            resolve(matchedEdge || !matchedChrome || parseInt(matchedChrome[1], 10) >= 43);
        };
    })["catch"](function () {
        return false; // error, so assume unsupported
    });
}

function _checkBlobSupport(idb) {
    if (typeof supportsBlobs === 'boolean') {
        return Promise$1.resolve(supportsBlobs);
    }
    return _checkBlobSupportWithoutCaching(idb).then(function (value) {
        supportsBlobs = value;
        return supportsBlobs;
    });
}

function _deferReadiness(dbInfo) {
    var dbContext = dbContexts[dbInfo.name];

    // Create a deferred object representing the current database operation.
    var deferredOperation = {};

    deferredOperation.promise = new Promise$1(function (resolve, reject) {
        deferredOperation.resolve = resolve;
        deferredOperation.reject = reject;
    });

    // Enqueue the deferred operation.
    dbContext.deferredOperations.push(deferredOperation);

    // Chain its promise to the database readiness.
    if (!dbContext.dbReady) {
        dbContext.dbReady = deferredOperation.promise;
    } else {
        dbContext.dbReady = dbContext.dbReady.then(function () {
            return deferredOperation.promise;
        });
    }
}

function _advanceReadiness(dbInfo) {
    var dbContext = dbContexts[dbInfo.name];

    // Dequeue a deferred operation.
    var deferredOperation = dbContext.deferredOperations.pop();

    // Resolve its promise (which is part of the database readiness
    // chain of promises).
    if (deferredOperation) {
        deferredOperation.resolve();
        return deferredOperation.promise;
    }
}

function _rejectReadiness(dbInfo, err) {
    var dbContext = dbContexts[dbInfo.name];

    // Dequeue a deferred operation.
    var deferredOperation = dbContext.deferredOperations.pop();

    // Reject its promise (which is part of the database readiness
    // chain of promises).
    if (deferredOperation) {
        deferredOperation.reject(err);
        return deferredOperation.promise;
    }
}

function _getConnection(dbInfo, upgradeNeeded) {
    return new Promise$1(function (resolve, reject) {
        dbContexts[dbInfo.name] = dbContexts[dbInfo.name] || createDbContext();

        if (dbInfo.db) {
            if (upgradeNeeded) {
                _deferReadiness(dbInfo);
                dbInfo.db.close();
            } else {
                return resolve(dbInfo.db);
            }
        }

        var dbArgs = [dbInfo.name];

        if (upgradeNeeded) {
            dbArgs.push(dbInfo.version);
        }

        var openreq = idb.open.apply(idb, dbArgs);

        if (upgradeNeeded) {
            openreq.onupgradeneeded = function (e) {
                var db = openreq.result;
                try {
                    db.createObjectStore(dbInfo.storeName);
                    if (e.oldVersion <= 1) {
                        // Added when support for blob shims was added
                        db.createObjectStore(DETECT_BLOB_SUPPORT_STORE);
                    }
                } catch (ex) {
                    if (ex.name === 'ConstraintError') {
                        console.warn('The database "' + dbInfo.name + '"' + ' has been upgraded from version ' + e.oldVersion + ' to version ' + e.newVersion + ', but the storage "' + dbInfo.storeName + '" already exists.');
                    } else {
                        throw ex;
                    }
                }
            };
        }

        openreq.onerror = function (e) {
            e.preventDefault();
            reject(openreq.error);
        };

        openreq.onsuccess = function () {
            var db = openreq.result;
            db.onversionchange = function (e) {
                // Triggered when the database is modified (e.g. adding an objectStore) or
                // deleted (even when initiated by other sessions in different tabs).
                // Closing the connection here prevents those operations from being blocked.
                // If the database is accessed again later by this instance, the connection
                // will be reopened or the database recreated as needed.
                e.target.close();
            };
            resolve(db);
            _advanceReadiness(dbInfo);
        };
    });
}

function _getOriginalConnection(dbInfo) {
    return _getConnection(dbInfo, false);
}

function _getUpgradedConnection(dbInfo) {
    return _getConnection(dbInfo, true);
}

function _isUpgradeNeeded(dbInfo, defaultVersion) {
    if (!dbInfo.db) {
        return true;
    }

    var isNewStore = !dbInfo.db.objectStoreNames.contains(dbInfo.storeName);
    var isDowngrade = dbInfo.version < dbInfo.db.version;
    var isUpgrade = dbInfo.version > dbInfo.db.version;

    if (isDowngrade) {
        // If the version is not the default one
        // then warn for impossible downgrade.
        if (dbInfo.version !== defaultVersion) {
            console.warn('The database "' + dbInfo.name + '"' + " can't be downgraded from version " + dbInfo.db.version + ' to version ' + dbInfo.version + '.');
        }
        // Align the versions to prevent errors.
        dbInfo.version = dbInfo.db.version;
    }

    if (isUpgrade || isNewStore) {
        // If the store is new then increment the version (if needed).
        // This will trigger an "upgradeneeded" event which is required
        // for creating a store.
        if (isNewStore) {
            var incVersion = dbInfo.db.version + 1;
            if (incVersion > dbInfo.version) {
                dbInfo.version = incVersion;
            }
        }

        return true;
    }

    return false;
}

// encode a blob for indexeddb engines that don't support blobs
function _encodeBlob(blob) {
    return new Promise$1(function (resolve, reject) {
        var reader = new FileReader();
        reader.onerror = reject;
        reader.onloadend = function (e) {
            var base64 = btoa(e.target.result || '');
            resolve({
                __local_forage_encoded_blob: true,
                data: base64,
                type: blob.type
            });
        };
        reader.readAsBinaryString(blob);
    });
}

// decode an encoded blob
function _decodeBlob(encodedBlob) {
    var arrayBuff = _binStringToArrayBuffer(atob(encodedBlob.data));
    return createBlob([arrayBuff], { type: encodedBlob.type });
}

// is this one of our fancy encoded blobs?
function _isEncodedBlob(value) {
    return value && value.__local_forage_encoded_blob;
}

// Specialize the default `ready()` function by making it dependent
// on the current database operations. Thus, the driver will be actually
// ready when it's been initialized (default) *and* there are no pending
// operations on the database (initiated by some other instances).
function _fullyReady(callback) {
    var self = this;

    var promise = self._initReady().then(function () {
        var dbContext = dbContexts[self._dbInfo.name];

        if (dbContext && dbContext.dbReady) {
            return dbContext.dbReady;
        }
    });

    executeTwoCallbacks(promise, callback, callback);
    return promise;
}

// Try to establish a new db connection to replace the
// current one which is broken (i.e. experiencing
// InvalidStateError while creating a transaction).
function _tryReconnect(dbInfo) {
    _deferReadiness(dbInfo);

    var dbContext = dbContexts[dbInfo.name];
    var forages = dbContext.forages;

    for (var i = 0; i < forages.length; i++) {
        var forage = forages[i];
        if (forage._dbInfo.db) {
            forage._dbInfo.db.close();
            forage._dbInfo.db = null;
        }
    }
    dbInfo.db = null;

    return _getOriginalConnection(dbInfo).then(function (db) {
        dbInfo.db = db;
        if (_isUpgradeNeeded(dbInfo)) {
            // Reopen the database for upgrading.
            return _getUpgradedConnection(dbInfo);
        }
        return db;
    }).then(function (db) {
        // store the latest db reference
        // in case the db was upgraded
        dbInfo.db = dbContext.db = db;
        for (var i = 0; i < forages.length; i++) {
            forages[i]._dbInfo.db = db;
        }
    })["catch"](function (err) {
        _rejectReadiness(dbInfo, err);
        throw err;
    });
}

// FF doesn't like Promises (micro-tasks) and IDDB store operations,
// so we have to do it with callbacks
function createTransaction(dbInfo, mode, callback, retries) {
    if (retries === undefined) {
        retries = 1;
    }

    try {
        var tx = dbInfo.db.transaction(dbInfo.storeName, mode);
        callback(null, tx);
    } catch (err) {
        if (retries > 0 && (!dbInfo.db || err.name === 'InvalidStateError' || err.name === 'NotFoundError')) {
            return Promise$1.resolve().then(function () {
                if (!dbInfo.db || err.name === 'NotFoundError' && !dbInfo.db.objectStoreNames.contains(dbInfo.storeName) && dbInfo.version <= dbInfo.db.version) {
                    // increase the db version, to create the new ObjectStore
                    if (dbInfo.db) {
                        dbInfo.version = dbInfo.db.version + 1;
                    }
                    // Reopen the database for upgrading.
                    return _getUpgradedConnection(dbInfo);
                }
            }).then(function () {
                return _tryReconnect(dbInfo).then(function () {
                    createTransaction(dbInfo, mode, callback, retries - 1);
                });
            })["catch"](callback);
        }

        callback(err);
    }
}

function createDbContext() {
    return {
        // Running localForages sharing a database.
        forages: [],
        // Shared database.
        db: null,
        // Database readiness (promise).
        dbReady: null,
        // Deferred operations on the database.
        deferredOperations: []
    };
}

// Open the IndexedDB database (automatically creates one if one didn't
// previously exist), using any options set in the config.
function _initStorage(options) {
    var self = this;
    var dbInfo = {
        db: null
    };

    if (options) {
        for (var i in options) {
            dbInfo[i] = options[i];
        }
    }

    // Get the current context of the database;
    var dbContext = dbContexts[dbInfo.name];

    // ...or create a new context.
    if (!dbContext) {
        dbContext = createDbContext();
        // Register the new context in the global container.
        dbContexts[dbInfo.name] = dbContext;
    }

    // Register itself as a running localForage in the current context.
    dbContext.forages.push(self);

    // Replace the default `ready()` function with the specialized one.
    if (!self._initReady) {
        self._initReady = self.ready;
        self.ready = _fullyReady;
    }

    // Create an array of initialization states of the related localForages.
    var initPromises = [];

    function ignoreErrors() {
        // Don't handle errors here,
        // just makes sure related localForages aren't pending.
        return Promise$1.resolve();
    }

    for (var j = 0; j < dbContext.forages.length; j++) {
        var forage = dbContext.forages[j];
        if (forage !== self) {
            // Don't wait for itself...
            initPromises.push(forage._initReady()["catch"](ignoreErrors));
        }
    }

    // Take a snapshot of the related localForages.
    var forages = dbContext.forages.slice(0);

    // Initialize the connection process only when
    // all the related localForages aren't pending.
    return Promise$1.all(initPromises).then(function () {
        dbInfo.db = dbContext.db;
        // Get the connection or open a new one without upgrade.
        return _getOriginalConnection(dbInfo);
    }).then(function (db) {
        dbInfo.db = db;
        if (_isUpgradeNeeded(dbInfo, self._defaultConfig.version)) {
            // Reopen the database for upgrading.
            return _getUpgradedConnection(dbInfo);
        }
        return db;
    }).then(function (db) {
        dbInfo.db = dbContext.db = db;
        self._dbInfo = dbInfo;
        // Share the final connection amongst related localForages.
        for (var k = 0; k < forages.length; k++) {
            var forage = forages[k];
            if (forage !== self) {
                // Self is already up-to-date.
                forage._dbInfo.db = dbInfo.db;
                forage._dbInfo.version = dbInfo.version;
            }
        }
    });
}

function getItem(key, callback) {
    var self = this;

    key = normalizeKey(key);

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            createTransaction(self._dbInfo, READ_ONLY, function (err, transaction) {
                if (err) {
                    return reject(err);
                }

                try {
                    var store = transaction.objectStore(self._dbInfo.storeName);
                    var req = store.get(key);

                    req.onsuccess = function () {
                        var value = req.result;
                        if (value === undefined) {
                            value = null;
                        }
                        if (_isEncodedBlob(value)) {
                            value = _decodeBlob(value);
                        }
                        resolve(value);
                    };

                    req.onerror = function () {
                        reject(req.error);
                    };
                } catch (e) {
                    reject(e);
                }
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

// Iterate over all items stored in database.
function iterate(iterator, callback) {
    var self = this;

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            createTransaction(self._dbInfo, READ_ONLY, function (err, transaction) {
                if (err) {
                    return reject(err);
                }

                try {
                    var store = transaction.objectStore(self._dbInfo.storeName);
                    var req = store.openCursor();
                    var iterationNumber = 1;

                    req.onsuccess = function () {
                        var cursor = req.result;

                        if (cursor) {
                            var value = cursor.value;
                            if (_isEncodedBlob(value)) {
                                value = _decodeBlob(value);
                            }
                            var result = iterator(value, cursor.key, iterationNumber++);

                            // when the iterator callback returns any
                            // (non-`undefined`) value, then we stop
                            // the iteration immediately
                            if (result !== void 0) {
                                resolve(result);
                            } else {
                                cursor["continue"]();
                            }
                        } else {
                            resolve();
                        }
                    };

                    req.onerror = function () {
                        reject(req.error);
                    };
                } catch (e) {
                    reject(e);
                }
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);

    return promise;
}

function setItem(key, value, callback) {
    var self = this;

    key = normalizeKey(key);

    var promise = new Promise$1(function (resolve, reject) {
        var dbInfo;
        self.ready().then(function () {
            dbInfo = self._dbInfo;
            if (toString.call(value) === '[object Blob]') {
                return _checkBlobSupport(dbInfo.db).then(function (blobSupport) {
                    if (blobSupport) {
                        return value;
                    }
                    return _encodeBlob(value);
                });
            }
            return value;
        }).then(function (value) {
            createTransaction(self._dbInfo, READ_WRITE, function (err, transaction) {
                if (err) {
                    return reject(err);
                }

                try {
                    var store = transaction.objectStore(self._dbInfo.storeName);

                    // The reason we don't _save_ null is because IE 10 does
                    // not support saving the `null` type in IndexedDB. How
                    // ironic, given the bug below!
                    // See: https://github.com/mozilla/localForage/issues/161
                    if (value === null) {
                        value = undefined;
                    }

                    var req = store.put(value, key);

                    transaction.oncomplete = function () {
                        // Cast to undefined so the value passed to
                        // callback/promise is the same as what one would get out
                        // of `getItem()` later. This leads to some weirdness
                        // (setItem('foo', undefined) will return `null`), but
                        // it's not my fault localStorage is our baseline and that
                        // it's weird.
                        if (value === undefined) {
                            value = null;
                        }

                        resolve(value);
                    };
                    transaction.onabort = transaction.onerror = function () {
                        var err = req.error ? req.error : req.transaction.error;
                        reject(err);
                    };
                } catch (e) {
                    reject(e);
                }
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

function removeItem(key, callback) {
    var self = this;

    key = normalizeKey(key);

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            createTransaction(self._dbInfo, READ_WRITE, function (err, transaction) {
                if (err) {
                    return reject(err);
                }

                try {
                    var store = transaction.objectStore(self._dbInfo.storeName);
                    // We use a Grunt task to make this safe for IE and some
                    // versions of Android (including those used by Cordova).
                    // Normally IE won't like `.delete()` and will insist on
                    // using `['delete']()`, but we have a build step that
                    // fixes this for us now.
                    var req = store["delete"](key);
                    transaction.oncomplete = function () {
                        resolve();
                    };

                    transaction.onerror = function () {
                        reject(req.error);
                    };

                    // The request will be also be aborted if we've exceeded our storage
                    // space.
                    transaction.onabort = function () {
                        var err = req.error ? req.error : req.transaction.error;
                        reject(err);
                    };
                } catch (e) {
                    reject(e);
                }
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

function clear(callback) {
    var self = this;

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            createTransaction(self._dbInfo, READ_WRITE, function (err, transaction) {
                if (err) {
                    return reject(err);
                }

                try {
                    var store = transaction.objectStore(self._dbInfo.storeName);
                    var req = store.clear();

                    transaction.oncomplete = function () {
                        resolve();
                    };

                    transaction.onabort = transaction.onerror = function () {
                        var err = req.error ? req.error : req.transaction.error;
                        reject(err);
                    };
                } catch (e) {
                    reject(e);
                }
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

function length(callback) {
    var self = this;

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            createTransaction(self._dbInfo, READ_ONLY, function (err, transaction) {
                if (err) {
                    return reject(err);
                }

                try {
                    var store = transaction.objectStore(self._dbInfo.storeName);
                    var req = store.count();

                    req.onsuccess = function () {
                        resolve(req.result);
                    };

                    req.onerror = function () {
                        reject(req.error);
                    };
                } catch (e) {
                    reject(e);
                }
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

function key(n, callback) {
    var self = this;

    var promise = new Promise$1(function (resolve, reject) {
        if (n < 0) {
            resolve(null);

            return;
        }

        self.ready().then(function () {
            createTransaction(self._dbInfo, READ_ONLY, function (err, transaction) {
                if (err) {
                    return reject(err);
                }

                try {
                    var store = transaction.objectStore(self._dbInfo.storeName);
                    var advanced = false;
                    var req = store.openKeyCursor();

                    req.onsuccess = function () {
                        var cursor = req.result;
                        if (!cursor) {
                            // this means there weren't enough keys
                            resolve(null);

                            return;
                        }

                        if (n === 0) {
                            // We have the first key, return it if that's what they
                            // wanted.
                            resolve(cursor.key);
                        } else {
                            if (!advanced) {
                                // Otherwise, ask the cursor to skip ahead n
                                // records.
                                advanced = true;
                                cursor.advance(n);
                            } else {
                                // When we get here, we've got the nth key.
                                resolve(cursor.key);
                            }
                        }
                    };

                    req.onerror = function () {
                        reject(req.error);
                    };
                } catch (e) {
                    reject(e);
                }
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

function keys(callback) {
    var self = this;

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            createTransaction(self._dbInfo, READ_ONLY, function (err, transaction) {
                if (err) {
                    return reject(err);
                }

                try {
                    var store = transaction.objectStore(self._dbInfo.storeName);
                    var req = store.openKeyCursor();
                    var keys = [];

                    req.onsuccess = function () {
                        var cursor = req.result;

                        if (!cursor) {
                            resolve(keys);
                            return;
                        }

                        keys.push(cursor.key);
                        cursor["continue"]();
                    };

                    req.onerror = function () {
                        reject(req.error);
                    };
                } catch (e) {
                    reject(e);
                }
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

function dropInstance(options, callback) {
    callback = getCallback.apply(this, arguments);

    var currentConfig = this.config();
    options = typeof options !== 'function' && options || {};
    if (!options.name) {
        options.name = options.name || currentConfig.name;
        options.storeName = options.storeName || currentConfig.storeName;
    }

    var self = this;
    var promise;
    if (!options.name) {
        promise = Promise$1.reject('Invalid arguments');
    } else {
        var isCurrentDb = options.name === currentConfig.name && self._dbInfo.db;

        var dbPromise = isCurrentDb ? Promise$1.resolve(self._dbInfo.db) : _getOriginalConnection(options).then(function (db) {
            var dbContext = dbContexts[options.name];
            var forages = dbContext.forages;
            dbContext.db = db;
            for (var i = 0; i < forages.length; i++) {
                forages[i]._dbInfo.db = db;
            }
            return db;
        });

        if (!options.storeName) {
            promise = dbPromise.then(function (db) {
                _deferReadiness(options);

                var dbContext = dbContexts[options.name];
                var forages = dbContext.forages;

                db.close();
                for (var i = 0; i < forages.length; i++) {
                    var forage = forages[i];
                    forage._dbInfo.db = null;
                }

                var dropDBPromise = new Promise$1(function (resolve, reject) {
                    var req = idb.deleteDatabase(options.name);

                    req.onerror = function () {
                        var db = req.result;
                        if (db) {
                            db.close();
                        }
                        reject(req.error);
                    };

                    req.onblocked = function () {
                        // Closing all open connections in onversionchange handler should prevent this situation, but if
                        // we do get here, it just means the request remains pending - eventually it will succeed or error
                        console.warn('dropInstance blocked for database "' + options.name + '" until all open connections are closed');
                    };

                    req.onsuccess = function () {
                        var db = req.result;
                        if (db) {
                            db.close();
                        }
                        resolve(db);
                    };
                });

                return dropDBPromise.then(function (db) {
                    dbContext.db = db;
                    for (var i = 0; i < forages.length; i++) {
                        var _forage = forages[i];
                        _advanceReadiness(_forage._dbInfo);
                    }
                })["catch"](function (err) {
                    (_rejectReadiness(options, err) || Promise$1.resolve())["catch"](function () {});
                    throw err;
                });
            });
        } else {
            promise = dbPromise.then(function (db) {
                if (!db.objectStoreNames.contains(options.storeName)) {
                    return;
                }

                var newVersion = db.version + 1;

                _deferReadiness(options);

                var dbContext = dbContexts[options.name];
                var forages = dbContext.forages;

                db.close();
                for (var i = 0; i < forages.length; i++) {
                    var forage = forages[i];
                    forage._dbInfo.db = null;
                    forage._dbInfo.version = newVersion;
                }

                var dropObjectPromise = new Promise$1(function (resolve, reject) {
                    var req = idb.open(options.name, newVersion);

                    req.onerror = function (err) {
                        var db = req.result;
                        db.close();
                        reject(err);
                    };

                    req.onupgradeneeded = function () {
                        var db = req.result;
                        db.deleteObjectStore(options.storeName);
                    };

                    req.onsuccess = function () {
                        var db = req.result;
                        db.close();
                        resolve(db);
                    };
                });

                return dropObjectPromise.then(function (db) {
                    dbContext.db = db;
                    for (var j = 0; j < forages.length; j++) {
                        var _forage2 = forages[j];
                        _forage2._dbInfo.db = db;
                        _advanceReadiness(_forage2._dbInfo);
                    }
                })["catch"](function (err) {
                    (_rejectReadiness(options, err) || Promise$1.resolve())["catch"](function () {});
                    throw err;
                });
            });
        }
    }

    executeCallback(promise, callback);
    return promise;
}

var asyncStorage = {
    _driver: 'asyncStorage',
    _initStorage: _initStorage,
    _support: isIndexedDBValid(),
    iterate: iterate,
    getItem: getItem,
    setItem: setItem,
    removeItem: removeItem,
    clear: clear,
    length: length,
    key: key,
    keys: keys,
    dropInstance: dropInstance
};

function isWebSQLValid() {
    return typeof openDatabase === 'function';
}

// Sadly, the best way to save binary data in WebSQL/localStorage is serializing
// it to Base64, so this is how we store it to prevent very strange errors with less
// verbose ways of binary <-> string data storage.
var BASE_CHARS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';

var BLOB_TYPE_PREFIX = '~~local_forage_type~';
var BLOB_TYPE_PREFIX_REGEX = /^~~local_forage_type~([^~]+)~/;

var SERIALIZED_MARKER = '__lfsc__:';
var SERIALIZED_MARKER_LENGTH = SERIALIZED_MARKER.length;

// OMG the serializations!
var TYPE_ARRAYBUFFER = 'arbf';
var TYPE_BLOB = 'blob';
var TYPE_INT8ARRAY = 'si08';
var TYPE_UINT8ARRAY = 'ui08';
var TYPE_UINT8CLAMPEDARRAY = 'uic8';
var TYPE_INT16ARRAY = 'si16';
var TYPE_INT32ARRAY = 'si32';
var TYPE_UINT16ARRAY = 'ur16';
var TYPE_UINT32ARRAY = 'ui32';
var TYPE_FLOAT32ARRAY = 'fl32';
var TYPE_FLOAT64ARRAY = 'fl64';
var TYPE_SERIALIZED_MARKER_LENGTH = SERIALIZED_MARKER_LENGTH + TYPE_ARRAYBUFFER.length;

var toString$1 = Object.prototype.toString;

function stringToBuffer(serializedString) {
    // Fill the string into a ArrayBuffer.
    var bufferLength = serializedString.length * 0.75;
    var len = serializedString.length;
    var i;
    var p = 0;
    var encoded1, encoded2, encoded3, encoded4;

    if (serializedString[serializedString.length - 1] === '=') {
        bufferLength--;
        if (serializedString[serializedString.length - 2] === '=') {
            bufferLength--;
        }
    }

    var buffer = new ArrayBuffer(bufferLength);
    var bytes = new Uint8Array(buffer);

    for (i = 0; i < len; i += 4) {
        encoded1 = BASE_CHARS.indexOf(serializedString[i]);
        encoded2 = BASE_CHARS.indexOf(serializedString[i + 1]);
        encoded3 = BASE_CHARS.indexOf(serializedString[i + 2]);
        encoded4 = BASE_CHARS.indexOf(serializedString[i + 3]);

        /*jslint bitwise: true */
        bytes[p++] = encoded1 << 2 | encoded2 >> 4;
        bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
        bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
    }
    return buffer;
}

// Converts a buffer to a string to store, serialized, in the backend
// storage library.
function bufferToString(buffer) {
    // base64-arraybuffer
    var bytes = new Uint8Array(buffer);
    var base64String = '';
    var i;

    for (i = 0; i < bytes.length; i += 3) {
        /*jslint bitwise: true */
        base64String += BASE_CHARS[bytes[i] >> 2];
        base64String += BASE_CHARS[(bytes[i] & 3) << 4 | bytes[i + 1] >> 4];
        base64String += BASE_CHARS[(bytes[i + 1] & 15) << 2 | bytes[i + 2] >> 6];
        base64String += BASE_CHARS[bytes[i + 2] & 63];
    }

    if (bytes.length % 3 === 2) {
        base64String = base64String.substring(0, base64String.length - 1) + '=';
    } else if (bytes.length % 3 === 1) {
        base64String = base64String.substring(0, base64String.length - 2) + '==';
    }

    return base64String;
}

// Serialize a value, afterwards executing a callback (which usually
// instructs the `setItem()` callback/promise to be executed). This is how
// we store binary data with localStorage.
function serialize(value, callback) {
    var valueType = '';
    if (value) {
        valueType = toString$1.call(value);
    }

    // Cannot use `value instanceof ArrayBuffer` or such here, as these
    // checks fail when running the tests using casper.js...
    //
    // TODO: See why those tests fail and use a better solution.
    if (value && (valueType === '[object ArrayBuffer]' || value.buffer && toString$1.call(value.buffer) === '[object ArrayBuffer]')) {
        // Convert binary arrays to a string and prefix the string with
        // a special marker.
        var buffer;
        var marker = SERIALIZED_MARKER;

        if (value instanceof ArrayBuffer) {
            buffer = value;
            marker += TYPE_ARRAYBUFFER;
        } else {
            buffer = value.buffer;

            if (valueType === '[object Int8Array]') {
                marker += TYPE_INT8ARRAY;
            } else if (valueType === '[object Uint8Array]') {
                marker += TYPE_UINT8ARRAY;
            } else if (valueType === '[object Uint8ClampedArray]') {
                marker += TYPE_UINT8CLAMPEDARRAY;
            } else if (valueType === '[object Int16Array]') {
                marker += TYPE_INT16ARRAY;
            } else if (valueType === '[object Uint16Array]') {
                marker += TYPE_UINT16ARRAY;
            } else if (valueType === '[object Int32Array]') {
                marker += TYPE_INT32ARRAY;
            } else if (valueType === '[object Uint32Array]') {
                marker += TYPE_UINT32ARRAY;
            } else if (valueType === '[object Float32Array]') {
                marker += TYPE_FLOAT32ARRAY;
            } else if (valueType === '[object Float64Array]') {
                marker += TYPE_FLOAT64ARRAY;
            } else {
                callback(new Error('Failed to get type for BinaryArray'));
            }
        }

        callback(marker + bufferToString(buffer));
    } else if (valueType === '[object Blob]') {
        // Conver the blob to a binaryArray and then to a string.
        var fileReader = new FileReader();

        fileReader.onload = function () {
            // Backwards-compatible prefix for the blob type.
            var str = BLOB_TYPE_PREFIX + value.type + '~' + bufferToString(this.result);

            callback(SERIALIZED_MARKER + TYPE_BLOB + str);
        };

        fileReader.readAsArrayBuffer(value);
    } else {
        try {
            callback(JSON.stringify(value));
        } catch (e) {
            console.error("Couldn't convert value into a JSON string: ", value);

            callback(null, e);
        }
    }
}

// Deserialize data we've inserted into a value column/field. We place
// special markers into our strings to mark them as encoded; this isn't
// as nice as a meta field, but it's the only sane thing we can do whilst
// keeping localStorage support intact.
//
// Oftentimes this will just deserialize JSON content, but if we have a
// special marker (SERIALIZED_MARKER, defined above), we will extract
// some kind of arraybuffer/binary data/typed array out of the string.
function deserialize(value) {
    // If we haven't marked this string as being specially serialized (i.e.
    // something other than serialized JSON), we can just return it and be
    // done with it.
    if (value.substring(0, SERIALIZED_MARKER_LENGTH) !== SERIALIZED_MARKER) {
        return JSON.parse(value);
    }

    // The following code deals with deserializing some kind of Blob or
    // TypedArray. First we separate out the type of data we're dealing
    // with from the data itself.
    var serializedString = value.substring(TYPE_SERIALIZED_MARKER_LENGTH);
    var type = value.substring(SERIALIZED_MARKER_LENGTH, TYPE_SERIALIZED_MARKER_LENGTH);

    var blobType;
    // Backwards-compatible blob type serialization strategy.
    // DBs created with older versions of localForage will simply not have the blob type.
    if (type === TYPE_BLOB && BLOB_TYPE_PREFIX_REGEX.test(serializedString)) {
        var matcher = serializedString.match(BLOB_TYPE_PREFIX_REGEX);
        blobType = matcher[1];
        serializedString = serializedString.substring(matcher[0].length);
    }
    var buffer = stringToBuffer(serializedString);

    // Return the right type based on the code/type set during
    // serialization.
    switch (type) {
        case TYPE_ARRAYBUFFER:
            return buffer;
        case TYPE_BLOB:
            return createBlob([buffer], { type: blobType });
        case TYPE_INT8ARRAY:
            return new Int8Array(buffer);
        case TYPE_UINT8ARRAY:
            return new Uint8Array(buffer);
        case TYPE_UINT8CLAMPEDARRAY:
            return new Uint8ClampedArray(buffer);
        case TYPE_INT16ARRAY:
            return new Int16Array(buffer);
        case TYPE_UINT16ARRAY:
            return new Uint16Array(buffer);
        case TYPE_INT32ARRAY:
            return new Int32Array(buffer);
        case TYPE_UINT32ARRAY:
            return new Uint32Array(buffer);
        case TYPE_FLOAT32ARRAY:
            return new Float32Array(buffer);
        case TYPE_FLOAT64ARRAY:
            return new Float64Array(buffer);
        default:
            throw new Error('Unkown type: ' + type);
    }
}

var localforageSerializer = {
    serialize: serialize,
    deserialize: deserialize,
    stringToBuffer: stringToBuffer,
    bufferToString: bufferToString
};

/*
 * Includes code from:
 *
 * base64-arraybuffer
 * https://github.com/niklasvh/base64-arraybuffer
 *
 * Copyright (c) 2012 Niklas von Hertzen
 * Licensed under the MIT license.
 */

function createDbTable(t, dbInfo, callback, errorCallback) {
    t.executeSql('CREATE TABLE IF NOT EXISTS ' + dbInfo.storeName + ' ' + '(id INTEGER PRIMARY KEY, key unique, value)', [], callback, errorCallback);
}

// Open the WebSQL database (automatically creates one if one didn't
// previously exist), using any options set in the config.
function _initStorage$1(options) {
    var self = this;
    var dbInfo = {
        db: null
    };

    if (options) {
        for (var i in options) {
            dbInfo[i] = typeof options[i] !== 'string' ? options[i].toString() : options[i];
        }
    }

    var dbInfoPromise = new Promise$1(function (resolve, reject) {
        // Open the database; the openDatabase API will automatically
        // create it for us if it doesn't exist.
        try {
            dbInfo.db = openDatabase(dbInfo.name, String(dbInfo.version), dbInfo.description, dbInfo.size);
        } catch (e) {
            return reject(e);
        }

        // Create our key/value table if it doesn't exist.
        dbInfo.db.transaction(function (t) {
            createDbTable(t, dbInfo, function () {
                self._dbInfo = dbInfo;
                resolve();
            }, function (t, error) {
                reject(error);
            });
        }, reject);
    });

    dbInfo.serializer = localforageSerializer;
    return dbInfoPromise;
}

function tryExecuteSql(t, dbInfo, sqlStatement, args, callback, errorCallback) {
    t.executeSql(sqlStatement, args, callback, function (t, error) {
        if (error.code === error.SYNTAX_ERR) {
            t.executeSql('SELECT name FROM sqlite_master ' + "WHERE type='table' AND name = ?", [dbInfo.storeName], function (t, results) {
                if (!results.rows.length) {
                    // if the table is missing (was deleted)
                    // re-create it table and retry
                    createDbTable(t, dbInfo, function () {
                        t.executeSql(sqlStatement, args, callback, errorCallback);
                    }, errorCallback);
                } else {
                    errorCallback(t, error);
                }
            }, errorCallback);
        } else {
            errorCallback(t, error);
        }
    }, errorCallback);
}

function getItem$1(key, callback) {
    var self = this;

    key = normalizeKey(key);

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            var dbInfo = self._dbInfo;
            dbInfo.db.transaction(function (t) {
                tryExecuteSql(t, dbInfo, 'SELECT * FROM ' + dbInfo.storeName + ' WHERE key = ? LIMIT 1', [key], function (t, results) {
                    var result = results.rows.length ? results.rows.item(0).value : null;

                    // Check to see if this is serialized content we need to
                    // unpack.
                    if (result) {
                        result = dbInfo.serializer.deserialize(result);
                    }

                    resolve(result);
                }, function (t, error) {
                    reject(error);
                });
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

function iterate$1(iterator, callback) {
    var self = this;

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            var dbInfo = self._dbInfo;

            dbInfo.db.transaction(function (t) {
                tryExecuteSql(t, dbInfo, 'SELECT * FROM ' + dbInfo.storeName, [], function (t, results) {
                    var rows = results.rows;
                    var length = rows.length;

                    for (var i = 0; i < length; i++) {
                        var item = rows.item(i);
                        var result = item.value;

                        // Check to see if this is serialized content
                        // we need to unpack.
                        if (result) {
                            result = dbInfo.serializer.deserialize(result);
                        }

                        result = iterator(result, item.key, i + 1);

                        // void(0) prevents problems with redefinition
                        // of `undefined`.
                        if (result !== void 0) {
                            resolve(result);
                            return;
                        }
                    }

                    resolve();
                }, function (t, error) {
                    reject(error);
                });
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

function _setItem(key, value, callback, retriesLeft) {
    var self = this;

    key = normalizeKey(key);

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            // The localStorage API doesn't return undefined values in an
            // "expected" way, so undefined is always cast to null in all
            // drivers. See: https://github.com/mozilla/localForage/pull/42
            if (value === undefined) {
                value = null;
            }

            // Save the original value to pass to the callback.
            var originalValue = value;

            var dbInfo = self._dbInfo;
            dbInfo.serializer.serialize(value, function (value, error) {
                if (error) {
                    reject(error);
                } else {
                    dbInfo.db.transaction(function (t) {
                        tryExecuteSql(t, dbInfo, 'INSERT OR REPLACE INTO ' + dbInfo.storeName + ' ' + '(key, value) VALUES (?, ?)', [key, value], function () {
                            resolve(originalValue);
                        }, function (t, error) {
                            reject(error);
                        });
                    }, function (sqlError) {
                        // The transaction failed; check
                        // to see if it's a quota error.
                        if (sqlError.code === sqlError.QUOTA_ERR) {
                            // We reject the callback outright for now, but
                            // it's worth trying to re-run the transaction.
                            // Even if the user accepts the prompt to use
                            // more storage on Safari, this error will
                            // be called.
                            //
                            // Try to re-run the transaction.
                            if (retriesLeft > 0) {
                                resolve(_setItem.apply(self, [key, originalValue, callback, retriesLeft - 1]));
                                return;
                            }
                            reject(sqlError);
                        }
                    });
                }
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

function setItem$1(key, value, callback) {
    return _setItem.apply(this, [key, value, callback, 1]);
}

function removeItem$1(key, callback) {
    var self = this;

    key = normalizeKey(key);

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            var dbInfo = self._dbInfo;
            dbInfo.db.transaction(function (t) {
                tryExecuteSql(t, dbInfo, 'DELETE FROM ' + dbInfo.storeName + ' WHERE key = ?', [key], function () {
                    resolve();
                }, function (t, error) {
                    reject(error);
                });
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

// Deletes every item in the table.
// TODO: Find out if this resets the AUTO_INCREMENT number.
function clear$1(callback) {
    var self = this;

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            var dbInfo = self._dbInfo;
            dbInfo.db.transaction(function (t) {
                tryExecuteSql(t, dbInfo, 'DELETE FROM ' + dbInfo.storeName, [], function () {
                    resolve();
                }, function (t, error) {
                    reject(error);
                });
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

// Does a simple `COUNT(key)` to get the number of items stored in
// localForage.
function length$1(callback) {
    var self = this;

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            var dbInfo = self._dbInfo;
            dbInfo.db.transaction(function (t) {
                // Ahhh, SQL makes this one soooooo easy.
                tryExecuteSql(t, dbInfo, 'SELECT COUNT(key) as c FROM ' + dbInfo.storeName, [], function (t, results) {
                    var result = results.rows.item(0).c;
                    resolve(result);
                }, function (t, error) {
                    reject(error);
                });
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

// Return the key located at key index X; essentially gets the key from a
// `WHERE id = ?`. This is the most efficient way I can think to implement
// this rarely-used (in my experience) part of the API, but it can seem
// inconsistent, because we do `INSERT OR REPLACE INTO` on `setItem()`, so
// the ID of each key will change every time it's updated. Perhaps a stored
// procedure for the `setItem()` SQL would solve this problem?
// TODO: Don't change ID on `setItem()`.
function key$1(n, callback) {
    var self = this;

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            var dbInfo = self._dbInfo;
            dbInfo.db.transaction(function (t) {
                tryExecuteSql(t, dbInfo, 'SELECT key FROM ' + dbInfo.storeName + ' WHERE id = ? LIMIT 1', [n + 1], function (t, results) {
                    var result = results.rows.length ? results.rows.item(0).key : null;
                    resolve(result);
                }, function (t, error) {
                    reject(error);
                });
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

function keys$1(callback) {
    var self = this;

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            var dbInfo = self._dbInfo;
            dbInfo.db.transaction(function (t) {
                tryExecuteSql(t, dbInfo, 'SELECT key FROM ' + dbInfo.storeName, [], function (t, results) {
                    var keys = [];

                    for (var i = 0; i < results.rows.length; i++) {
                        keys.push(results.rows.item(i).key);
                    }

                    resolve(keys);
                }, function (t, error) {
                    reject(error);
                });
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

// https://www.w3.org/TR/webdatabase/#databases
// > There is no way to enumerate or delete the databases available for an origin from this API.
function getAllStoreNames(db) {
    return new Promise$1(function (resolve, reject) {
        db.transaction(function (t) {
            t.executeSql('SELECT name FROM sqlite_master ' + "WHERE type='table' AND name <> '__WebKitDatabaseInfoTable__'", [], function (t, results) {
                var storeNames = [];

                for (var i = 0; i < results.rows.length; i++) {
                    storeNames.push(results.rows.item(i).name);
                }

                resolve({
                    db: db,
                    storeNames: storeNames
                });
            }, function (t, error) {
                reject(error);
            });
        }, function (sqlError) {
            reject(sqlError);
        });
    });
}

function dropInstance$1(options, callback) {
    callback = getCallback.apply(this, arguments);

    var currentConfig = this.config();
    options = typeof options !== 'function' && options || {};
    if (!options.name) {
        options.name = options.name || currentConfig.name;
        options.storeName = options.storeName || currentConfig.storeName;
    }

    var self = this;
    var promise;
    if (!options.name) {
        promise = Promise$1.reject('Invalid arguments');
    } else {
        promise = new Promise$1(function (resolve) {
            var db;
            if (options.name === currentConfig.name) {
                // use the db reference of the current instance
                db = self._dbInfo.db;
            } else {
                db = openDatabase(options.name, '', '', 0);
            }

            if (!options.storeName) {
                // drop all database tables
                resolve(getAllStoreNames(db));
            } else {
                resolve({
                    db: db,
                    storeNames: [options.storeName]
                });
            }
        }).then(function (operationInfo) {
            return new Promise$1(function (resolve, reject) {
                operationInfo.db.transaction(function (t) {
                    function dropTable(storeName) {
                        return new Promise$1(function (resolve, reject) {
                            t.executeSql('DROP TABLE IF EXISTS ' + storeName, [], function () {
                                resolve();
                            }, function (t, error) {
                                reject(error);
                            });
                        });
                    }

                    var operations = [];
                    for (var i = 0, len = operationInfo.storeNames.length; i < len; i++) {
                        operations.push(dropTable(operationInfo.storeNames[i]));
                    }

                    Promise$1.all(operations).then(function () {
                        resolve();
                    })["catch"](function (e) {
                        reject(e);
                    });
                }, function (sqlError) {
                    reject(sqlError);
                });
            });
        });
    }

    executeCallback(promise, callback);
    return promise;
}

var webSQLStorage = {
    _driver: 'webSQLStorage',
    _initStorage: _initStorage$1,
    _support: isWebSQLValid(),
    iterate: iterate$1,
    getItem: getItem$1,
    setItem: setItem$1,
    removeItem: removeItem$1,
    clear: clear$1,
    length: length$1,
    key: key$1,
    keys: keys$1,
    dropInstance: dropInstance$1
};

function isLocalStorageValid() {
    try {
        return typeof localStorage !== 'undefined' && 'setItem' in localStorage &&
        // in IE8 typeof localStorage.setItem === 'object'
        !!localStorage.setItem;
    } catch (e) {
        return false;
    }
}

function _getKeyPrefix(options, defaultConfig) {
    var keyPrefix = options.name + '/';

    if (options.storeName !== defaultConfig.storeName) {
        keyPrefix += options.storeName + '/';
    }
    return keyPrefix;
}

// Check if localStorage throws when saving an item
function checkIfLocalStorageThrows() {
    var localStorageTestKey = '_localforage_support_test';

    try {
        localStorage.setItem(localStorageTestKey, true);
        localStorage.removeItem(localStorageTestKey);

        return false;
    } catch (e) {
        return true;
    }
}

// Check if localStorage is usable and allows to save an item
// This method checks if localStorage is usable in Safari Private Browsing
// mode, or in any other case where the available quota for localStorage
// is 0 and there wasn't any saved items yet.
function _isLocalStorageUsable() {
    return !checkIfLocalStorageThrows() || localStorage.length > 0;
}

// Config the localStorage backend, using options set in the config.
function _initStorage$2(options) {
    var self = this;
    var dbInfo = {};
    if (options) {
        for (var i in options) {
            dbInfo[i] = options[i];
        }
    }

    dbInfo.keyPrefix = _getKeyPrefix(options, self._defaultConfig);

    if (!_isLocalStorageUsable()) {
        return Promise$1.reject();
    }

    self._dbInfo = dbInfo;
    dbInfo.serializer = localforageSerializer;

    return Promise$1.resolve();
}

// Remove all keys from the datastore, effectively destroying all data in
// the app's key/value store!
function clear$2(callback) {
    var self = this;
    var promise = self.ready().then(function () {
        var keyPrefix = self._dbInfo.keyPrefix;

        for (var i = localStorage.length - 1; i >= 0; i--) {
            var key = localStorage.key(i);

            if (key.indexOf(keyPrefix) === 0) {
                localStorage.removeItem(key);
            }
        }
    });

    executeCallback(promise, callback);
    return promise;
}

// Retrieve an item from the store. Unlike the original async_storage
// library in Gaia, we don't modify return values at all. If a key's value
// is `undefined`, we pass that value to the callback function.
function getItem$2(key, callback) {
    var self = this;

    key = normalizeKey(key);

    var promise = self.ready().then(function () {
        var dbInfo = self._dbInfo;
        var result = localStorage.getItem(dbInfo.keyPrefix + key);

        // If a result was found, parse it from the serialized
        // string into a JS object. If result isn't truthy, the key
        // is likely undefined and we'll pass it straight to the
        // callback.
        if (result) {
            result = dbInfo.serializer.deserialize(result);
        }

        return result;
    });

    executeCallback(promise, callback);
    return promise;
}

// Iterate over all items in the store.
function iterate$2(iterator, callback) {
    var self = this;

    var promise = self.ready().then(function () {
        var dbInfo = self._dbInfo;
        var keyPrefix = dbInfo.keyPrefix;
        var keyPrefixLength = keyPrefix.length;
        var length = localStorage.length;

        // We use a dedicated iterator instead of the `i` variable below
        // so other keys we fetch in localStorage aren't counted in
        // the `iterationNumber` argument passed to the `iterate()`
        // callback.
        //
        // See: github.com/mozilla/localForage/pull/435#discussion_r38061530
        var iterationNumber = 1;

        for (var i = 0; i < length; i++) {
            var key = localStorage.key(i);
            if (key.indexOf(keyPrefix) !== 0) {
                continue;
            }
            var value = localStorage.getItem(key);

            // If a result was found, parse it from the serialized
            // string into a JS object. If result isn't truthy, the
            // key is likely undefined and we'll pass it straight
            // to the iterator.
            if (value) {
                value = dbInfo.serializer.deserialize(value);
            }

            value = iterator(value, key.substring(keyPrefixLength), iterationNumber++);

            if (value !== void 0) {
                return value;
            }
        }
    });

    executeCallback(promise, callback);
    return promise;
}

// Same as localStorage's key() method, except takes a callback.
function key$2(n, callback) {
    var self = this;
    var promise = self.ready().then(function () {
        var dbInfo = self._dbInfo;
        var result;
        try {
            result = localStorage.key(n);
        } catch (error) {
            result = null;
        }

        // Remove the prefix from the key, if a key is found.
        if (result) {
            result = result.substring(dbInfo.keyPrefix.length);
        }

        return result;
    });

    executeCallback(promise, callback);
    return promise;
}

function keys$2(callback) {
    var self = this;
    var promise = self.ready().then(function () {
        var dbInfo = self._dbInfo;
        var length = localStorage.length;
        var keys = [];

        for (var i = 0; i < length; i++) {
            var itemKey = localStorage.key(i);
            if (itemKey.indexOf(dbInfo.keyPrefix) === 0) {
                keys.push(itemKey.substring(dbInfo.keyPrefix.length));
            }
        }

        return keys;
    });

    executeCallback(promise, callback);
    return promise;
}

// Supply the number of keys in the datastore to the callback function.
function length$2(callback) {
    var self = this;
    var promise = self.keys().then(function (keys) {
        return keys.length;
    });

    executeCallback(promise, callback);
    return promise;
}

// Remove an item from the store, nice and simple.
function removeItem$2(key, callback) {
    var self = this;

    key = normalizeKey(key);

    var promise = self.ready().then(function () {
        var dbInfo = self._dbInfo;
        localStorage.removeItem(dbInfo.keyPrefix + key);
    });

    executeCallback(promise, callback);
    return promise;
}

// Set a key's value and run an optional callback once the value is set.
// Unlike Gaia's implementation, the callback function is passed the value,
// in case you want to operate on that value only after you're sure it
// saved, or something like that.
function setItem$2(key, value, callback) {
    var self = this;

    key = normalizeKey(key);

    var promise = self.ready().then(function () {
        // Convert undefined values to null.
        // https://github.com/mozilla/localForage/pull/42
        if (value === undefined) {
            value = null;
        }

        // Save the original value to pass to the callback.
        var originalValue = value;

        return new Promise$1(function (resolve, reject) {
            var dbInfo = self._dbInfo;
            dbInfo.serializer.serialize(value, function (value, error) {
                if (error) {
                    reject(error);
                } else {
                    try {
                        localStorage.setItem(dbInfo.keyPrefix + key, value);
                        resolve(originalValue);
                    } catch (e) {
                        // localStorage capacity exceeded.
                        // TODO: Make this a specific error/event.
                        if (e.name === 'QuotaExceededError' || e.name === 'NS_ERROR_DOM_QUOTA_REACHED') {
                            reject(e);
                        }
                        reject(e);
                    }
                }
            });
        });
    });

    executeCallback(promise, callback);
    return promise;
}

function dropInstance$2(options, callback) {
    callback = getCallback.apply(this, arguments);

    options = typeof options !== 'function' && options || {};
    if (!options.name) {
        var currentConfig = this.config();
        options.name = options.name || currentConfig.name;
        options.storeName = options.storeName || currentConfig.storeName;
    }

    var self = this;
    var promise;
    if (!options.name) {
        promise = Promise$1.reject('Invalid arguments');
    } else {
        promise = new Promise$1(function (resolve) {
            if (!options.storeName) {
                resolve(options.name + '/');
            } else {
                resolve(_getKeyPrefix(options, self._defaultConfig));
            }
        }).then(function (keyPrefix) {
            for (var i = localStorage.length - 1; i >= 0; i--) {
                var key = localStorage.key(i);

                if (key.indexOf(keyPrefix) === 0) {
                    localStorage.removeItem(key);
                }
            }
        });
    }

    executeCallback(promise, callback);
    return promise;
}

var localStorageWrapper = {
    _driver: 'localStorageWrapper',
    _initStorage: _initStorage$2,
    _support: isLocalStorageValid(),
    iterate: iterate$2,
    getItem: getItem$2,
    setItem: setItem$2,
    removeItem: removeItem$2,
    clear: clear$2,
    length: length$2,
    key: key$2,
    keys: keys$2,
    dropInstance: dropInstance$2
};

var sameValue = function sameValue(x, y) {
    return x === y || typeof x === 'number' && typeof y === 'number' && isNaN(x) && isNaN(y);
};

var includes = function includes(array, searchElement) {
    var len = array.length;
    var i = 0;
    while (i < len) {
        if (sameValue(array[i], searchElement)) {
            return true;
        }
        i++;
    }

    return false;
};

var isArray = Array.isArray || function (arg) {
    return Object.prototype.toString.call(arg) === '[object Array]';
};

// Drivers are stored here when `defineDriver()` is called.
// They are shared across all instances of localForage.
var DefinedDrivers = {};

var DriverSupport = {};

var DefaultDrivers = {
    INDEXEDDB: asyncStorage,
    WEBSQL: webSQLStorage,
    LOCALSTORAGE: localStorageWrapper
};

var DefaultDriverOrder = [DefaultDrivers.INDEXEDDB._driver, DefaultDrivers.WEBSQL._driver, DefaultDrivers.LOCALSTORAGE._driver];

var OptionalDriverMethods = ['dropInstance'];

var LibraryMethods = ['clear', 'getItem', 'iterate', 'key', 'keys', 'length', 'removeItem', 'setItem'].concat(OptionalDriverMethods);

var DefaultConfig = {
    description: '',
    driver: DefaultDriverOrder.slice(),
    name: 'localforage',
    // Default DB size is _JUST UNDER_ 5MB, as it's the highest size
    // we can use without a prompt.
    size: 4980736,
    storeName: 'keyvaluepairs',
    version: 1.0
};

function callWhenReady(localForageInstance, libraryMethod) {
    localForageInstance[libraryMethod] = function () {
        var _args = arguments;
        return localForageInstance.ready().then(function () {
            return localForageInstance[libraryMethod].apply(localForageInstance, _args);
        });
    };
}

function extend() {
    for (var i = 1; i < arguments.length; i++) {
        var arg = arguments[i];

        if (arg) {
            for (var _key in arg) {
                if (arg.hasOwnProperty(_key)) {
                    if (isArray(arg[_key])) {
                        arguments[0][_key] = arg[_key].slice();
                    } else {
                        arguments[0][_key] = arg[_key];
                    }
                }
            }
        }
    }

    return arguments[0];
}

var LocalForage = function () {
    function LocalForage(options) {
        _classCallCheck(this, LocalForage);

        for (var driverTypeKey in DefaultDrivers) {
            if (DefaultDrivers.hasOwnProperty(driverTypeKey)) {
                var driver = DefaultDrivers[driverTypeKey];
                var driverName = driver._driver;
                this[driverTypeKey] = driverName;

                if (!DefinedDrivers[driverName]) {
                    // we don't need to wait for the promise,
                    // since the default drivers can be defined
                    // in a blocking manner
                    this.defineDriver(driver);
                }
            }
        }

        this._defaultConfig = extend({}, DefaultConfig);
        this._config = extend({}, this._defaultConfig, options);
        this._driverSet = null;
        this._initDriver = null;
        this._ready = false;
        this._dbInfo = null;

        this._wrapLibraryMethodsWithReady();
        this.setDriver(this._config.driver)["catch"](function () {});
    }

    // Set any config values for localForage; can be called anytime before
    // the first API call (e.g. `getItem`, `setItem`).
    // We loop through options so we don't overwrite existing config
    // values.


    LocalForage.prototype.config = function config(options) {
        // If the options argument is an object, we use it to set values.
        // Otherwise, we return either a specified config value or all
        // config values.
        if ((typeof options === 'undefined' ? 'undefined' : _typeof(options)) === 'object') {
            // If localforage is ready and fully initialized, we can't set
            // any new configuration values. Instead, we return an error.
            if (this._ready) {
                return new Error("Can't call config() after localforage " + 'has been used.');
            }

            for (var i in options) {
                if (i === 'storeName') {
                    options[i] = options[i].replace(/\W/g, '_');
                }

                if (i === 'version' && typeof options[i] !== 'number') {
                    return new Error('Database version must be a number.');
                }

                this._config[i] = options[i];
            }

            // after all config options are set and
            // the driver option is used, try setting it
            if ('driver' in options && options.driver) {
                return this.setDriver(this._config.driver);
            }

            return true;
        } else if (typeof options === 'string') {
            return this._config[options];
        } else {
            return this._config;
        }
    };

    // Used to define a custom driver, shared across all instances of
    // localForage.


    LocalForage.prototype.defineDriver = function defineDriver(driverObject, callback, errorCallback) {
        var promise = new Promise$1(function (resolve, reject) {
            try {
                var driverName = driverObject._driver;
                var complianceError = new Error('Custom driver not compliant; see ' + 'https://mozilla.github.io/localForage/#definedriver');

                // A driver name should be defined and not overlap with the
                // library-defined, default drivers.
                if (!driverObject._driver) {
                    reject(complianceError);
                    return;
                }

                var driverMethods = LibraryMethods.concat('_initStorage');
                for (var i = 0, len = driverMethods.length; i < len; i++) {
                    var driverMethodName = driverMethods[i];

                    // when the property is there,
                    // it should be a method even when optional
                    var isRequired = !includes(OptionalDriverMethods, driverMethodName);
                    if ((isRequired || driverObject[driverMethodName]) && typeof driverObject[driverMethodName] !== 'function') {
                        reject(complianceError);
                        return;
                    }
                }

                var configureMissingMethods = function configureMissingMethods() {
                    var methodNotImplementedFactory = function methodNotImplementedFactory(methodName) {
                        return function () {
                            var error = new Error('Method ' + methodName + ' is not implemented by the current driver');
                            var promise = Promise$1.reject(error);
                            executeCallback(promise, arguments[arguments.length - 1]);
                            return promise;
                        };
                    };

                    for (var _i = 0, _len = OptionalDriverMethods.length; _i < _len; _i++) {
                        var optionalDriverMethod = OptionalDriverMethods[_i];
                        if (!driverObject[optionalDriverMethod]) {
                            driverObject[optionalDriverMethod] = methodNotImplementedFactory(optionalDriverMethod);
                        }
                    }
                };

                configureMissingMethods();

                var setDriverSupport = function setDriverSupport(support) {
                    if (DefinedDrivers[driverName]) {
                        console.info('Redefining LocalForage driver: ' + driverName);
                    }
                    DefinedDrivers[driverName] = driverObject;
                    DriverSupport[driverName] = support;
                    // don't use a then, so that we can define
                    // drivers that have simple _support methods
                    // in a blocking manner
                    resolve();
                };

                if ('_support' in driverObject) {
                    if (driverObject._support && typeof driverObject._support === 'function') {
                        driverObject._support().then(setDriverSupport, reject);
                    } else {
                        setDriverSupport(!!driverObject._support);
                    }
                } else {
                    setDriverSupport(true);
                }
            } catch (e) {
                reject(e);
            }
        });

        executeTwoCallbacks(promise, callback, errorCallback);
        return promise;
    };

    LocalForage.prototype.driver = function driver() {
        return this._driver || null;
    };

    LocalForage.prototype.getDriver = function getDriver(driverName, callback, errorCallback) {
        var getDriverPromise = DefinedDrivers[driverName] ? Promise$1.resolve(DefinedDrivers[driverName]) : Promise$1.reject(new Error('Driver not found.'));

        executeTwoCallbacks(getDriverPromise, callback, errorCallback);
        return getDriverPromise;
    };

    LocalForage.prototype.getSerializer = function getSerializer(callback) {
        var serializerPromise = Promise$1.resolve(localforageSerializer);
        executeTwoCallbacks(serializerPromise, callback);
        return serializerPromise;
    };

    LocalForage.prototype.ready = function ready(callback) {
        var self = this;

        var promise = self._driverSet.then(function () {
            if (self._ready === null) {
                self._ready = self._initDriver();
            }

            return self._ready;
        });

        executeTwoCallbacks(promise, callback, callback);
        return promise;
    };

    LocalForage.prototype.setDriver = function setDriver(drivers, callback, errorCallback) {
        var self = this;

        if (!isArray(drivers)) {
            drivers = [drivers];
        }

        var supportedDrivers = this._getSupportedDrivers(drivers);

        function setDriverToConfig() {
            self._config.driver = self.driver();
        }

        function extendSelfWithDriver(driver) {
            self._extend(driver);
            setDriverToConfig();

            self._ready = self._initStorage(self._config);
            return self._ready;
        }

        function initDriver(supportedDrivers) {
            return function () {
                var currentDriverIndex = 0;

                function driverPromiseLoop() {
                    while (currentDriverIndex < supportedDrivers.length) {
                        var driverName = supportedDrivers[currentDriverIndex];
                        currentDriverIndex++;

                        self._dbInfo = null;
                        self._ready = null;

                        return self.getDriver(driverName).then(extendSelfWithDriver)["catch"](driverPromiseLoop);
                    }

                    setDriverToConfig();
                    var error = new Error('No available storage method found.');
                    self._driverSet = Promise$1.reject(error);
                    return self._driverSet;
                }

                return driverPromiseLoop();
            };
        }

        // There might be a driver initialization in progress
        // so wait for it to finish in order to avoid a possible
        // race condition to set _dbInfo
        var oldDriverSetDone = this._driverSet !== null ? this._driverSet["catch"](function () {
            return Promise$1.resolve();
        }) : Promise$1.resolve();

        this._driverSet = oldDriverSetDone.then(function () {
            var driverName = supportedDrivers[0];
            self._dbInfo = null;
            self._ready = null;

            return self.getDriver(driverName).then(function (driver) {
                self._driver = driver._driver;
                setDriverToConfig();
                self._wrapLibraryMethodsWithReady();
                self._initDriver = initDriver(supportedDrivers);
            });
        })["catch"](function () {
            setDriverToConfig();
            var error = new Error('No available storage method found.');
            self._driverSet = Promise$1.reject(error);
            return self._driverSet;
        });

        executeTwoCallbacks(this._driverSet, callback, errorCallback);
        return this._driverSet;
    };

    LocalForage.prototype.supports = function supports(driverName) {
        return !!DriverSupport[driverName];
    };

    LocalForage.prototype._extend = function _extend(libraryMethodsAndProperties) {
        extend(this, libraryMethodsAndProperties);
    };

    LocalForage.prototype._getSupportedDrivers = function _getSupportedDrivers(drivers) {
        var supportedDrivers = [];
        for (var i = 0, len = drivers.length; i < len; i++) {
            var driverName = drivers[i];
            if (this.supports(driverName)) {
                supportedDrivers.push(driverName);
            }
        }
        return supportedDrivers;
    };

    LocalForage.prototype._wrapLibraryMethodsWithReady = function _wrapLibraryMethodsWithReady() {
        // Add a stub for each driver API method that delays the call to the
        // corresponding driver method until localForage is ready. These stubs
        // will be replaced by the driver methods as soon as the driver is
        // loaded, so there is no performance impact.
        for (var i = 0, len = LibraryMethods.length; i < len; i++) {
            callWhenReady(this, LibraryMethods[i]);
        }
    };

    LocalForage.prototype.createInstance = function createInstance(options) {
        return new LocalForage(options);
    };

    return LocalForage;
}();

// The actual localForage object that we expose as a module or via a
// global. It's extended by pulling in one of our other libraries.


var localforage_js = new LocalForage();

module.exports = localforage_js;

},{"3":3}]},{},[4])(4)
});

}).call(this)}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],24:[function(require,module,exports){
(function (global){(function (){
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] =
cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
cloneableTags[boolTag] = cloneableTags[dateTag] =
cloneableTags[float32Tag] = cloneableTags[float64Tag] =
cloneableTags[int8Tag] = cloneableTags[int16Tag] =
cloneableTags[int32Tag] = cloneableTags[mapTag] =
cloneableTags[numberTag] = cloneableTags[objectTag] =
cloneableTags[regexpTag] = cloneableTags[setTag] =
cloneableTags[stringTag] = cloneableTags[symbolTag] =
cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] =
cloneableTags[weakMapTag] = false;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/**
 * Adds the key-value `pair` to `map`.
 *
 * @private
 * @param {Object} map The map to modify.
 * @param {Array} pair The key-value pair to add.
 * @returns {Object} Returns `map`.
 */
function addMapEntry(map, pair) {
  // Don't return `map.set` because it's not chainable in IE 11.
  map.set(pair[0], pair[1]);
  return map;
}

/**
 * Adds `value` to `set`.
 *
 * @private
 * @param {Object} set The set to modify.
 * @param {*} value The value to add.
 * @returns {Object} Returns `set`.
 */
function addSetEntry(set, value) {
  // Don't return `set.add` because it's not chainable in IE 11.
  set.add(value);
  return set;
}

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array ? array.length : 0;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */
function arrayReduce(array, iteratee, accumulator, initAccum) {
  var index = -1,
      length = array ? array.length : 0;

  if (initAccum && length) {
    accumulator = array[++index];
  }
  while (++index < length) {
    accumulator = iteratee(accumulator, array[index], index, array);
  }
  return accumulator;
}

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    Symbol = root.Symbol,
    Uint8Array = root.Uint8Array,
    getPrototype = overArg(Object.getPrototypeOf, Object),
    objectCreate = Object.create,
    propertyIsEnumerable = objectProto.propertyIsEnumerable,
    splice = arrayProto.splice;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols,
    nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
    nativeKeys = overArg(Object.keys, Object);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView'),
    Map = getNative(root, 'Map'),
    Promise = getNative(root, 'Promise'),
    Set = getNative(root, 'Set'),
    WeakMap = getNative(root, 'WeakMap'),
    nativeCreate = getNative(Object, 'create');

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  return this.has(key) && delete this.__data__[key];
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  return getMapData(this, key)['delete'](key);
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  getMapData(this, key).set(key, value);
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  this.__data__ = new ListCache(entries);
}

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
}

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  return this.__data__['delete'](key);
}

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var cache = this.__data__;
  if (cache instanceof ListCache) {
    var pairs = cache.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      return this;
    }
    cache = this.__data__ = new MapCache(pairs);
  }
  cache.set(key, value);
  return this;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  // Safari 9 makes `arguments.length` enumerable in strict mode.
  var result = (isArray(value) || isArguments(value))
    ? baseTimes(value.length, String)
    : [];

  var length = result.length,
      skipIndexes = !!length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    object[key] = value;
  }
}

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return object && copyObject(source, keys(source), object);
}

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @param {boolean} [isFull] Specify a clone including symbols.
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone(value, isDeep, isFull, customizer, key, object, stack) {
  var result;
  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!isObject(value)) {
    return value;
  }
  var isArr = isArray(value);
  if (isArr) {
    result = initCloneArray(value);
    if (!isDeep) {
      return copyArray(value, result);
    }
  } else {
    var tag = getTag(value),
        isFunc = tag == funcTag || tag == genTag;

    if (isBuffer(value)) {
      return cloneBuffer(value, isDeep);
    }
    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
      if (isHostObject(value)) {
        return object ? value : {};
      }
      result = initCloneObject(isFunc ? {} : value);
      if (!isDeep) {
        return copySymbols(value, baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = initCloneByTag(value, tag, baseClone, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new Stack);
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);

  if (!isArr) {
    var props = isFull ? getAllKeys(value) : keys(value);
  }
  arrayEach(props || value, function(subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    assignValue(result, key, baseClone(subValue, isDeep, isFull, customizer, key, value, stack));
  });
  return result;
}

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} prototype The object to inherit from.
 * @returns {Object} Returns the new object.
 */
function baseCreate(proto) {
  return isObject(proto) ? objectCreate(proto) : {};
}

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

/**
 * The base implementation of `getTag`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  return objectToString.call(value);
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var result = new buffer.constructor(buffer.length);
  buffer.copy(result);
  return result;
}

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

/**
 * Creates a clone of `map`.
 *
 * @private
 * @param {Object} map The map to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned map.
 */
function cloneMap(map, isDeep, cloneFunc) {
  var array = isDeep ? cloneFunc(mapToArray(map), true) : mapToArray(map);
  return arrayReduce(array, addMapEntry, new map.constructor);
}

/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

/**
 * Creates a clone of `set`.
 *
 * @private
 * @param {Object} set The set to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned set.
 */
function cloneSet(set, isDeep, cloneFunc) {
  var array = isDeep ? cloneFunc(setToArray(set), true) : setToArray(set);
  return arrayReduce(array, addSetEntry, new set.constructor);
}

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    assignValue(object, key, newValue === undefined ? source[key] : newValue);
  }
  return object;
}

/**
 * Copies own symbol properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
  return copyObject(source, getSymbols(source), object);
}

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * Creates an array of the own enumerable symbol properties of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = nativeGetSymbols ? overArg(nativeGetSymbols, Object) : stubArray;

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11,
// for data views in Edge < 14, and promises in Node.js.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = objectToString.call(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : undefined;

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray(array) {
  var length = array.length,
      result = array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag(object, tag, cloneFunc, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag:
      return cloneArrayBuffer(object);

    case boolTag:
    case dateTag:
      return new Ctor(+object);

    case dataViewTag:
      return cloneDataView(object, isDeep);

    case float32Tag: case float64Tag:
    case int8Tag: case int16Tag: case int32Tag:
    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
      return cloneTypedArray(object, isDeep);

    case mapTag:
      return cloneMap(object, isDeep, cloneFunc);

    case numberTag:
    case stringTag:
      return new Ctor(object);

    case regexpTag:
      return cloneRegExp(object);

    case setTag:
      return cloneSet(object, isDeep, cloneFunc);

    case symbolTag:
      return cloneSymbol(object);
  }
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */
function cloneDeep(value) {
  return baseClone(value, true, true);
}

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = cloneDeep;

}).call(this)}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],25:[function(require,module,exports){
// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };

},{}],26:[function(require,module,exports){
(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    (global.proj4 = factory());
}(this, (function () { 'use strict';

    var globals = function(defs) {
      defs('EPSG:4326', "+title=WGS 84 (long/lat) +proj=longlat +ellps=WGS84 +datum=WGS84 +units=degrees");
      defs('EPSG:4269', "+title=NAD83 (long/lat) +proj=longlat +a=6378137.0 +b=6356752.31414036 +ellps=GRS80 +datum=NAD83 +units=degrees");
      defs('EPSG:3857', "+title=WGS 84 / Pseudo-Mercator +proj=merc +a=6378137 +b=6378137 +lat_ts=0.0 +lon_0=0.0 +x_0=0.0 +y_0=0 +k=1.0 +units=m +nadgrids=@null +no_defs");
      // UTM WGS84
      for (var i = 1; i <= 60; ++i) {
        defs('EPSG:' + (32600 + i), "+proj=utm +zone=" + i + " +datum=WGS84 +units=m");
        defs('EPSG:' + (32700 + i), "+proj=utm +zone=" + i + " +south +datum=WGS84 +units=m");
      }

      defs.WGS84 = defs['EPSG:4326'];
      defs['EPSG:3785'] = defs['EPSG:3857']; // maintain backward compat, official code is 3857
      defs.GOOGLE = defs['EPSG:3857'];
      defs['EPSG:900913'] = defs['EPSG:3857'];
      defs['EPSG:102113'] = defs['EPSG:3857'];
    };

    var PJD_3PARAM = 1;
    var PJD_7PARAM = 2;
    var PJD_GRIDSHIFT = 3;
    var PJD_WGS84 = 4; // WGS84 or equivalent
    var PJD_NODATUM = 5; // WGS84 or equivalent
    var SRS_WGS84_SEMIMAJOR = 6378137.0;  // only used in grid shift transforms
    var SRS_WGS84_SEMIMINOR = 6356752.314;  // only used in grid shift transforms
    var SRS_WGS84_ESQUARED = 0.0066943799901413165; // only used in grid shift transforms
    var SEC_TO_RAD = 4.84813681109535993589914102357e-6;
    var HALF_PI = Math.PI/2;
    // ellipoid pj_set_ell.c
    var SIXTH = 0.1666666666666666667;
    /* 1/6 */
    var RA4 = 0.04722222222222222222;
    /* 17/360 */
    var RA6 = 0.02215608465608465608;
    var EPSLN = 1.0e-10;
    // you'd think you could use Number.EPSILON above but that makes
    // Mollweide get into an infinate loop.

    var D2R = 0.01745329251994329577;
    var R2D = 57.29577951308232088;
    var FORTPI = Math.PI/4;
    var TWO_PI = Math.PI * 2;
    // SPI is slightly greater than Math.PI, so values that exceed the -180..180
    // degree range by a tiny amount don't get wrapped. This prevents points that
    // have drifted from their original location along the 180th meridian (due to
    // floating point error) from changing their sign.
    var SPI = 3.14159265359;

    var exports$1 = {};
    exports$1.greenwich = 0.0; //"0dE",
    exports$1.lisbon = -9.131906111111; //"9d07'54.862\"W",
    exports$1.paris = 2.337229166667; //"2d20'14.025\"E",
    exports$1.bogota = -74.080916666667; //"74d04'51.3\"W",
    exports$1.madrid = -3.687938888889; //"3d41'16.58\"W",
    exports$1.rome = 12.452333333333; //"12d27'8.4\"E",
    exports$1.bern = 7.439583333333; //"7d26'22.5\"E",
    exports$1.jakarta = 106.807719444444; //"106d48'27.79\"E",
    exports$1.ferro = -17.666666666667; //"17d40'W",
    exports$1.brussels = 4.367975; //"4d22'4.71\"E",
    exports$1.stockholm = 18.058277777778; //"18d3'29.8\"E",
    exports$1.athens = 23.7163375; //"23d42'58.815\"E",
    exports$1.oslo = 10.722916666667; //"10d43'22.5\"E"

    var units = {
      'mm': {to_meter: 0.001},
      'cm': {to_meter: 0.01},
      'ft': {to_meter: 0.3048},
      'us-ft': {to_meter: 1200 / 3937},
      'fath': {to_meter: 1.8288},
      'kmi': {to_meter: 1852},
      'us-ch': {to_meter: 20.1168402336805},
      'us-mi': {to_meter: 1609.34721869444},
      'km': {to_meter: 1000},
      'ind-ft': {to_meter: 0.30479841},
      'ind-yd': {to_meter: 0.91439523},
      'mi': {to_meter: 1609.344},
      'yd': {to_meter: 0.9144},
      'ch': {to_meter: 20.1168},
      'link': {to_meter: 0.201168},
      'dm': {to_meter: 0.01},
      'in': {to_meter: 0.0254},
      'ind-ch': {to_meter: 20.11669506},
      'us-in': {to_meter: 0.025400050800101},
      'us-yd': {to_meter: 0.914401828803658}
    };

    var ignoredChar = /[\s_\-\/\(\)]/g;
    function match(obj, key) {
      if (obj[key]) {
        return obj[key];
      }
      var keys = Object.keys(obj);
      var lkey = key.toLowerCase().replace(ignoredChar, '');
      var i = -1;
      var testkey, processedKey;
      while (++i < keys.length) {
        testkey = keys[i];
        processedKey = testkey.toLowerCase().replace(ignoredChar, '');
        if (processedKey === lkey) {
          return obj[testkey];
        }
      }
    }

    var parseProj = function(defData) {
      var self = {};
      var paramObj = defData.split('+').map(function(v) {
        return v.trim();
      }).filter(function(a) {
        return a;
      }).reduce(function(p, a) {
        var split = a.split('=');
        split.push(true);
        p[split[0].toLowerCase()] = split[1];
        return p;
      }, {});
      var paramName, paramVal, paramOutname;
      var params = {
        proj: 'projName',
        datum: 'datumCode',
        rf: function(v) {
          self.rf = parseFloat(v);
        },
        lat_0: function(v) {
          self.lat0 = v * D2R;
        },
        lat_1: function(v) {
          self.lat1 = v * D2R;
        },
        lat_2: function(v) {
          self.lat2 = v * D2R;
        },
        lat_ts: function(v) {
          self.lat_ts = v * D2R;
        },
        lon_0: function(v) {
          self.long0 = v * D2R;
        },
        lon_1: function(v) {
          self.long1 = v * D2R;
        },
        lon_2: function(v) {
          self.long2 = v * D2R;
        },
        alpha: function(v) {
          self.alpha = parseFloat(v) * D2R;
        },
        gamma: function(v) {
          self.rectified_grid_angle = parseFloat(v);
        },
        lonc: function(v) {
          self.longc = v * D2R;
        },
        x_0: function(v) {
          self.x0 = parseFloat(v);
        },
        y_0: function(v) {
          self.y0 = parseFloat(v);
        },
        k_0: function(v) {
          self.k0 = parseFloat(v);
        },
        k: function(v) {
          self.k0 = parseFloat(v);
        },
        a: function(v) {
          self.a = parseFloat(v);
        },
        b: function(v) {
          self.b = parseFloat(v);
        },
        r: function(v) {
          self.a = self.b = parseFloat(v);
        },
        r_a: function() {
          self.R_A = true;
        },
        zone: function(v) {
          self.zone = parseInt(v, 10);
        },
        south: function() {
          self.utmSouth = true;
        },
        towgs84: function(v) {
          self.datum_params = v.split(",").map(function(a) {
            return parseFloat(a);
          });
        },
        to_meter: function(v) {
          self.to_meter = parseFloat(v);
        },
        units: function(v) {
          self.units = v;
          var unit = match(units, v);
          if (unit) {
            self.to_meter = unit.to_meter;
          }
        },
        from_greenwich: function(v) {
          self.from_greenwich = v * D2R;
        },
        pm: function(v) {
          var pm = match(exports$1, v);
          self.from_greenwich = (pm ? pm : parseFloat(v)) * D2R;
        },
        nadgrids: function(v) {
          if (v === '@null') {
            self.datumCode = 'none';
          }
          else {
            self.nadgrids = v;
          }
        },
        axis: function(v) {
          var legalAxis = "ewnsud";
          if (v.length === 3 && legalAxis.indexOf(v.substr(0, 1)) !== -1 && legalAxis.indexOf(v.substr(1, 1)) !== -1 && legalAxis.indexOf(v.substr(2, 1)) !== -1) {
            self.axis = v;
          }
        },
        approx: function() {
          self.approx = true;
        }
      };
      for (paramName in paramObj) {
        paramVal = paramObj[paramName];
        if (paramName in params) {
          paramOutname = params[paramName];
          if (typeof paramOutname === 'function') {
            paramOutname(paramVal);
          }
          else {
            self[paramOutname] = paramVal;
          }
        }
        else {
          self[paramName] = paramVal;
        }
      }
      if(typeof self.datumCode === 'string' && self.datumCode !== "WGS84"){
        self.datumCode = self.datumCode.toLowerCase();
      }
      return self;
    };

    var NEUTRAL = 1;
    var KEYWORD = 2;
    var NUMBER = 3;
    var QUOTED = 4;
    var AFTERQUOTE = 5;
    var ENDED = -1;
    var whitespace = /\s/;
    var latin = /[A-Za-z]/;
    var keyword = /[A-Za-z84_]/;
    var endThings = /[,\]]/;
    var digets = /[\d\.E\-\+]/;
    // const ignoredChar = /[\s_\-\/\(\)]/g;
    function Parser(text) {
      if (typeof text !== 'string') {
        throw new Error('not a string');
      }
      this.text = text.trim();
      this.level = 0;
      this.place = 0;
      this.root = null;
      this.stack = [];
      this.currentObject = null;
      this.state = NEUTRAL;
    }
    Parser.prototype.readCharicter = function() {
      var char = this.text[this.place++];
      if (this.state !== QUOTED) {
        while (whitespace.test(char)) {
          if (this.place >= this.text.length) {
            return;
          }
          char = this.text[this.place++];
        }
      }
      switch (this.state) {
        case NEUTRAL:
          return this.neutral(char);
        case KEYWORD:
          return this.keyword(char)
        case QUOTED:
          return this.quoted(char);
        case AFTERQUOTE:
          return this.afterquote(char);
        case NUMBER:
          return this.number(char);
        case ENDED:
          return;
      }
    };
    Parser.prototype.afterquote = function(char) {
      if (char === '"') {
        this.word += '"';
        this.state = QUOTED;
        return;
      }
      if (endThings.test(char)) {
        this.word = this.word.trim();
        this.afterItem(char);
        return;
      }
      throw new Error('havn\'t handled "' +char + '" in afterquote yet, index ' + this.place);
    };
    Parser.prototype.afterItem = function(char) {
      if (char === ',') {
        if (this.word !== null) {
          this.currentObject.push(this.word);
        }
        this.word = null;
        this.state = NEUTRAL;
        return;
      }
      if (char === ']') {
        this.level--;
        if (this.word !== null) {
          this.currentObject.push(this.word);
          this.word = null;
        }
        this.state = NEUTRAL;
        this.currentObject = this.stack.pop();
        if (!this.currentObject) {
          this.state = ENDED;
        }

        return;
      }
    };
    Parser.prototype.number = function(char) {
      if (digets.test(char)) {
        this.word += char;
        return;
      }
      if (endThings.test(char)) {
        this.word = parseFloat(this.word);
        this.afterItem(char);
        return;
      }
      throw new Error('havn\'t handled "' +char + '" in number yet, index ' + this.place);
    };
    Parser.prototype.quoted = function(char) {
      if (char === '"') {
        this.state = AFTERQUOTE;
        return;
      }
      this.word += char;
      return;
    };
    Parser.prototype.keyword = function(char) {
      if (keyword.test(char)) {
        this.word += char;
        return;
      }
      if (char === '[') {
        var newObjects = [];
        newObjects.push(this.word);
        this.level++;
        if (this.root === null) {
          this.root = newObjects;
        } else {
          this.currentObject.push(newObjects);
        }
        this.stack.push(this.currentObject);
        this.currentObject = newObjects;
        this.state = NEUTRAL;
        return;
      }
      if (endThings.test(char)) {
        this.afterItem(char);
        return;
      }
      throw new Error('havn\'t handled "' +char + '" in keyword yet, index ' + this.place);
    };
    Parser.prototype.neutral = function(char) {
      if (latin.test(char)) {
        this.word = char;
        this.state = KEYWORD;
        return;
      }
      if (char === '"') {
        this.word = '';
        this.state = QUOTED;
        return;
      }
      if (digets.test(char)) {
        this.word = char;
        this.state = NUMBER;
        return;
      }
      if (endThings.test(char)) {
        this.afterItem(char);
        return;
      }
      throw new Error('havn\'t handled "' +char + '" in neutral yet, index ' + this.place);
    };
    Parser.prototype.output = function() {
      while (this.place < this.text.length) {
        this.readCharicter();
      }
      if (this.state === ENDED) {
        return this.root;
      }
      throw new Error('unable to parse string "' +this.text + '". State is ' + this.state);
    };

    function parseString(txt) {
      var parser = new Parser(txt);
      return parser.output();
    }

    function mapit(obj, key, value) {
      if (Array.isArray(key)) {
        value.unshift(key);
        key = null;
      }
      var thing = key ? {} : obj;

      var out = value.reduce(function(newObj, item) {
        sExpr(item, newObj);
        return newObj
      }, thing);
      if (key) {
        obj[key] = out;
      }
    }

    function sExpr(v, obj) {
      if (!Array.isArray(v)) {
        obj[v] = true;
        return;
      }
      var key = v.shift();
      if (key === 'PARAMETER') {
        key = v.shift();
      }
      if (v.length === 1) {
        if (Array.isArray(v[0])) {
          obj[key] = {};
          sExpr(v[0], obj[key]);
          return;
        }
        obj[key] = v[0];
        return;
      }
      if (!v.length) {
        obj[key] = true;
        return;
      }
      if (key === 'TOWGS84') {
        obj[key] = v;
        return;
      }
      if (key === 'AXIS') {
        if (!(key in obj)) {
          obj[key] = [];
        }
        obj[key].push(v);
        return;
      }
      if (!Array.isArray(key)) {
        obj[key] = {};
      }

      var i;
      switch (key) {
        case 'UNIT':
        case 'PRIMEM':
        case 'VERT_DATUM':
          obj[key] = {
            name: v[0].toLowerCase(),
            convert: v[1]
          };
          if (v.length === 3) {
            sExpr(v[2], obj[key]);
          }
          return;
        case 'SPHEROID':
        case 'ELLIPSOID':
          obj[key] = {
            name: v[0],
            a: v[1],
            rf: v[2]
          };
          if (v.length === 4) {
            sExpr(v[3], obj[key]);
          }
          return;
        case 'EDATUM':
        case 'ENGINEERINGDATUM':
        case 'LOCAL_DATUM':
        case 'DATUM':
        case 'VERT_CS':
        case 'VERTCRS':
        case 'VERTICALCRS':
          v[0] = ['name', v[0]];
          mapit(obj, key, v);
          return;
        case 'COMPD_CS':
        case 'COMPOUNDCRS':
        case 'FITTED_CS':
        // the followings are the crs defined in
        // https://github.com/proj4js/proj4js/blob/1da4ed0b865d0fcb51c136090569210cdcc9019e/lib/parseCode.js#L11
        case 'PROJECTEDCRS':
        case 'PROJCRS':
        case 'GEOGCS':
        case 'GEOCCS':
        case 'PROJCS':
        case 'LOCAL_CS':
        case 'GEODCRS':
        case 'GEODETICCRS':
        case 'GEODETICDATUM':
        case 'ENGCRS':
        case 'ENGINEERINGCRS':
          v[0] = ['name', v[0]];
          mapit(obj, key, v);
          obj[key].type = key;
          return;
        default:
          i = -1;
          while (++i < v.length) {
            if (!Array.isArray(v[i])) {
              return sExpr(v, obj[key]);
            }
          }
          return mapit(obj, key, v);
      }
    }

    var D2R$1 = 0.01745329251994329577;
    var knownTypes = ['PROJECTEDCRS', 'PROJCRS', 'GEOGCS', 'GEOCCS', 'PROJCS', 'LOCAL_CS', 'GEODCRS',
      'GEODETICCRS', 'GEODETICDATUM', 'ENGCRS', 'ENGINEERINGCRS'];

    function rename(obj, params) {
      var outName = params[0];
      var inName = params[1];
      if (!(outName in obj) && (inName in obj)) {
        obj[outName] = obj[inName];
        if (params.length === 3) {
          obj[outName] = params[2](obj[outName]);
        }
      }
    }

    function d2r(input) {
      return input * D2R$1;
    }

    function cleanWKT(wkt) {
      var keys = Object.keys(wkt);
      for (var i = 0, ii = keys.length; i <ii; ++i) {
        var key = keys[i];
        // the followings are the crs defined in
        // https://github.com/proj4js/proj4js/blob/1da4ed0b865d0fcb51c136090569210cdcc9019e/lib/parseCode.js#L11
        if (knownTypes.indexOf(key) !== -1) {
          setPropertiesFromWkt(wkt[key]);
        }
        if (typeof wkt[key] === 'object') {
          cleanWKT(wkt[key]);
        }
      }
    }

    function setPropertiesFromWkt(wkt) {
      if (wkt.AUTHORITY) {
        var authority = Object.keys(wkt.AUTHORITY)[0];
        if (authority && authority in wkt.AUTHORITY) {
          wkt.title = authority + ':' + wkt.AUTHORITY[authority];
        }
      }
      if (wkt.type === 'GEOGCS') {
        wkt.projName = 'longlat';
      } else if (wkt.type === 'LOCAL_CS') {
        wkt.projName = 'identity';
        wkt.local = true;
      } else {
        if (typeof wkt.PROJECTION === 'object') {
          wkt.projName = Object.keys(wkt.PROJECTION)[0];
        } else {
          wkt.projName = wkt.PROJECTION;
        }
      }
      if (wkt.AXIS) {
        var axisOrder = '';
        for (var i = 0, ii = wkt.AXIS.length; i < ii; ++i) {
          var axis = [wkt.AXIS[i][0].toLowerCase(), wkt.AXIS[i][1].toLowerCase()];
          if (axis[0].indexOf('north') !== -1 || ((axis[0] === 'y' || axis[0] === 'lat') && axis[1] === 'north')) {
            axisOrder += 'n';
          } else if (axis[0].indexOf('south') !== -1 || ((axis[0] === 'y' || axis[0] === 'lat') && axis[1] === 'south')) {
            axisOrder += 's';
          } else if (axis[0].indexOf('east') !== -1 || ((axis[0] === 'x' || axis[0] === 'lon') && axis[1] === 'east')) {
            axisOrder += 'e';
          } else if (axis[0].indexOf('west') !== -1 || ((axis[0] === 'x' || axis[0] === 'lon') && axis[1] === 'west')) {
            axisOrder += 'w';
          }
        }
        if (axisOrder.length === 2) {
          axisOrder += 'u';
        }
        if (axisOrder.length === 3) {
          wkt.axis = axisOrder;
        }
      }
      if (wkt.UNIT) {
        wkt.units = wkt.UNIT.name.toLowerCase();
        if (wkt.units === 'metre') {
          wkt.units = 'meter';
        }
        if (wkt.UNIT.convert) {
          if (wkt.type === 'GEOGCS') {
            if (wkt.DATUM && wkt.DATUM.SPHEROID) {
              wkt.to_meter = wkt.UNIT.convert*wkt.DATUM.SPHEROID.a;
            }
          } else {
            wkt.to_meter = wkt.UNIT.convert;
          }
        }
      }
      var geogcs = wkt.GEOGCS;
      if (wkt.type === 'GEOGCS') {
        geogcs = wkt;
      }
      if (geogcs) {
        //if(wkt.GEOGCS.PRIMEM&&wkt.GEOGCS.PRIMEM.convert){
        //  wkt.from_greenwich=wkt.GEOGCS.PRIMEM.convert*D2R;
        //}
        if (geogcs.DATUM) {
          wkt.datumCode = geogcs.DATUM.name.toLowerCase();
        } else {
          wkt.datumCode = geogcs.name.toLowerCase();
        }
        if (wkt.datumCode.slice(0, 2) === 'd_') {
          wkt.datumCode = wkt.datumCode.slice(2);
        }
        if (wkt.datumCode === 'new_zealand_1949') {
          wkt.datumCode = 'nzgd49';
        }
        if (wkt.datumCode === 'wgs_1984' || wkt.datumCode === 'world_geodetic_system_1984') {
          if (wkt.PROJECTION === 'Mercator_Auxiliary_Sphere') {
            wkt.sphere = true;
          }
          wkt.datumCode = 'wgs84';
        }
        if (wkt.datumCode === 'belge_1972') {
          wkt.datumCode = 'rnb72';
        }
        if (geogcs.DATUM && geogcs.DATUM.SPHEROID) {
          wkt.ellps = geogcs.DATUM.SPHEROID.name.replace('_19', '').replace(/[Cc]larke\_18/, 'clrk');
          if (wkt.ellps.toLowerCase().slice(0, 13) === 'international') {
            wkt.ellps = 'intl';
          }

          wkt.a = geogcs.DATUM.SPHEROID.a;
          wkt.rf = parseFloat(geogcs.DATUM.SPHEROID.rf, 10);
        }

        if (geogcs.DATUM && geogcs.DATUM.TOWGS84) {
          wkt.datum_params = geogcs.DATUM.TOWGS84;
        }
        if (~wkt.datumCode.indexOf('osgb_1936')) {
          wkt.datumCode = 'osgb36';
        }
        if (~wkt.datumCode.indexOf('osni_1952')) {
          wkt.datumCode = 'osni52';
        }
        if (~wkt.datumCode.indexOf('tm65')
          || ~wkt.datumCode.indexOf('geodetic_datum_of_1965')) {
          wkt.datumCode = 'ire65';
        }
        if (wkt.datumCode === 'ch1903+') {
          wkt.datumCode = 'ch1903';
        }
        if (~wkt.datumCode.indexOf('israel')) {
          wkt.datumCode = 'isr93';
        }
      }
      if (wkt.b && !isFinite(wkt.b)) {
        wkt.b = wkt.a;
      }

      function toMeter(input) {
        var ratio = wkt.to_meter || 1;
        return input * ratio;
      }
      var renamer = function(a) {
        return rename(wkt, a);
      };
      var list = [
        ['standard_parallel_1', 'Standard_Parallel_1'],
        ['standard_parallel_1', 'Latitude of 1st standard parallel'],
        ['standard_parallel_2', 'Standard_Parallel_2'],
        ['standard_parallel_2', 'Latitude of 2nd standard parallel'],
        ['false_easting', 'False_Easting'],
        ['false_easting', 'False easting'],
        ['false-easting', 'Easting at false origin'],
        ['false_northing', 'False_Northing'],
        ['false_northing', 'False northing'],
        ['false_northing', 'Northing at false origin'],
        ['central_meridian', 'Central_Meridian'],
        ['central_meridian', 'Longitude of natural origin'],
        ['central_meridian', 'Longitude of false origin'],
        ['latitude_of_origin', 'Latitude_Of_Origin'],
        ['latitude_of_origin', 'Central_Parallel'],
        ['latitude_of_origin', 'Latitude of natural origin'],
        ['latitude_of_origin', 'Latitude of false origin'],
        ['scale_factor', 'Scale_Factor'],
        ['k0', 'scale_factor'],
        ['latitude_of_center', 'Latitude_Of_Center'],
        ['latitude_of_center', 'Latitude_of_center'],
        ['lat0', 'latitude_of_center', d2r],
        ['longitude_of_center', 'Longitude_Of_Center'],
        ['longitude_of_center', 'Longitude_of_center'],
        ['longc', 'longitude_of_center', d2r],
        ['x0', 'false_easting', toMeter],
        ['y0', 'false_northing', toMeter],
        ['long0', 'central_meridian', d2r],
        ['lat0', 'latitude_of_origin', d2r],
        ['lat0', 'standard_parallel_1', d2r],
        ['lat1', 'standard_parallel_1', d2r],
        ['lat2', 'standard_parallel_2', d2r],
        ['azimuth', 'Azimuth'],
        ['alpha', 'azimuth', d2r],
        ['srsCode', 'name']
      ];
      list.forEach(renamer);
      if (!wkt.long0 && wkt.longc && (wkt.projName === 'Albers_Conic_Equal_Area' || wkt.projName === 'Lambert_Azimuthal_Equal_Area')) {
        wkt.long0 = wkt.longc;
      }
      if (!wkt.lat_ts && wkt.lat1 && (wkt.projName === 'Stereographic_South_Pole' || wkt.projName === 'Polar Stereographic (variant B)')) {
        wkt.lat0 = d2r(wkt.lat1 > 0 ? 90 : -90);
        wkt.lat_ts = wkt.lat1;
      } else if (!wkt.lat_ts && wkt.lat0 && wkt.projName === 'Polar_Stereographic') {
        wkt.lat_ts = wkt.lat0;
        wkt.lat0 = d2r(wkt.lat0 > 0 ? 90 : -90);
      }
    }
    var wkt = function(wkt) {
      var lisp = parseString(wkt);
      var type = lisp[0];
      var obj = {};
      sExpr(lisp, obj);
      cleanWKT(obj);
      return obj[type];
    };

    function defs(name) {
      /*global console*/
      var that = this;
      if (arguments.length === 2) {
        var def = arguments[1];
        if (typeof def === 'string') {
          if (def.charAt(0) === '+') {
            defs[name] = parseProj(arguments[1]);
          }
          else {
            defs[name] = wkt(arguments[1]);
          }
        } else {
          defs[name] = def;
        }
      }
      else if (arguments.length === 1) {
        if (Array.isArray(name)) {
          return name.map(function(v) {
            if (Array.isArray(v)) {
              defs.apply(that, v);
            }
            else {
              defs(v);
            }
          });
        }
        else if (typeof name === 'string') {
          if (name in defs) {
            return defs[name];
          }
        }
        else if ('EPSG' in name) {
          defs['EPSG:' + name.EPSG] = name;
        }
        else if ('ESRI' in name) {
          defs['ESRI:' + name.ESRI] = name;
        }
        else if ('IAU2000' in name) {
          defs['IAU2000:' + name.IAU2000] = name;
        }
        else {
          console.log(name);
        }
        return;
      }


    }
    globals(defs);

    function testObj(code){
      return typeof code === 'string';
    }
    function testDef(code){
      return code in defs;
    }
    var codeWords = ['PROJECTEDCRS', 'PROJCRS', 'GEOGCS','GEOCCS','PROJCS','LOCAL_CS', 'GEODCRS', 'GEODETICCRS', 'GEODETICDATUM', 'ENGCRS', 'ENGINEERINGCRS'];
    function testWKT(code){
      return codeWords.some(function (word) {
        return code.indexOf(word) > -1;
      });
    }
    var codes = ['3857', '900913', '3785', '102113'];
    function checkMercator(item) {
      var auth = match(item, 'authority');
      if (!auth) {
        return;
      }
      var code = match(auth, 'epsg');
      return code && codes.indexOf(code) > -1;
    }
    function checkProjStr(item) {
      var ext = match(item, 'extension');
      if (!ext) {
        return;
      }
      return match(ext, 'proj4');
    }
    function testProj(code){
      return code[0] === '+';
    }
    function parse(code){
      if (testObj(code)) {
        //check to see if this is a WKT string
        if (testDef(code)) {
          return defs[code];
        }
        if (testWKT(code)) {
          var out = wkt(code);
          // test of spetial case, due to this being a very common and often malformed
          if (checkMercator(out)) {
            return defs['EPSG:3857'];
          }
          var maybeProjStr = checkProjStr(out);
          if (maybeProjStr) {
            return parseProj(maybeProjStr);
          }
          return out;
        }
        if (testProj(code)) {
          return parseProj(code);
        }
      }else{
        return code;
      }
    }

    var extend = function(destination, source) {
      destination = destination || {};
      var value, property;
      if (!source) {
        return destination;
      }
      for (property in source) {
        value = source[property];
        if (value !== undefined) {
          destination[property] = value;
        }
      }
      return destination;
    };

    var msfnz = function(eccent, sinphi, cosphi) {
      var con = eccent * sinphi;
      return cosphi / (Math.sqrt(1 - con * con));
    };

    var sign = function(x) {
      return x<0 ? -1 : 1;
    };

    var adjust_lon = function(x) {
      return (Math.abs(x) <= SPI) ? x : (x - (sign(x) * TWO_PI));
    };

    var tsfnz = function(eccent, phi, sinphi) {
      var con = eccent * sinphi;
      var com = 0.5 * eccent;
      con = Math.pow(((1 - con) / (1 + con)), com);
      return (Math.tan(0.5 * (HALF_PI - phi)) / con);
    };

    var phi2z = function(eccent, ts) {
      var eccnth = 0.5 * eccent;
      var con, dphi;
      var phi = HALF_PI - 2 * Math.atan(ts);
      for (var i = 0; i <= 15; i++) {
        con = eccent * Math.sin(phi);
        dphi = HALF_PI - 2 * Math.atan(ts * (Math.pow(((1 - con) / (1 + con)), eccnth))) - phi;
        phi += dphi;
        if (Math.abs(dphi) <= 0.0000000001) {
          return phi;
        }
      }
      //console.log("phi2z has NoConvergence");
      return -9999;
    };

    function init() {
      var con = this.b / this.a;
      this.es = 1 - con * con;
      if(!('x0' in this)){
        this.x0 = 0;
      }
      if(!('y0' in this)){
        this.y0 = 0;
      }
      this.e = Math.sqrt(this.es);
      if (this.lat_ts) {
        if (this.sphere) {
          this.k0 = Math.cos(this.lat_ts);
        }
        else {
          this.k0 = msfnz(this.e, Math.sin(this.lat_ts), Math.cos(this.lat_ts));
        }
      }
      else {
        if (!this.k0) {
          if (this.k) {
            this.k0 = this.k;
          }
          else {
            this.k0 = 1;
          }
        }
      }
    }

    /* Mercator forward equations--mapping lat,long to x,y
      --------------------------------------------------*/

    function forward(p) {
      var lon = p.x;
      var lat = p.y;
      // convert to radians
      if (lat * R2D > 90 && lat * R2D < -90 && lon * R2D > 180 && lon * R2D < -180) {
        return null;
      }

      var x, y;
      if (Math.abs(Math.abs(lat) - HALF_PI) <= EPSLN) {
        return null;
      }
      else {
        if (this.sphere) {
          x = this.x0 + this.a * this.k0 * adjust_lon(lon - this.long0);
          y = this.y0 + this.a * this.k0 * Math.log(Math.tan(FORTPI + 0.5 * lat));
        }
        else {
          var sinphi = Math.sin(lat);
          var ts = tsfnz(this.e, lat, sinphi);
          x = this.x0 + this.a * this.k0 * adjust_lon(lon - this.long0);
          y = this.y0 - this.a * this.k0 * Math.log(ts);
        }
        p.x = x;
        p.y = y;
        return p;
      }
    }

    /* Mercator inverse equations--mapping x,y to lat/long
      --------------------------------------------------*/
    function inverse(p) {

      var x = p.x - this.x0;
      var y = p.y - this.y0;
      var lon, lat;

      if (this.sphere) {
        lat = HALF_PI - 2 * Math.atan(Math.exp(-y / (this.a * this.k0)));
      }
      else {
        var ts = Math.exp(-y / (this.a * this.k0));
        lat = phi2z(this.e, ts);
        if (lat === -9999) {
          return null;
        }
      }
      lon = adjust_lon(this.long0 + x / (this.a * this.k0));

      p.x = lon;
      p.y = lat;
      return p;
    }

    var names$1 = ["Mercator", "Popular Visualisation Pseudo Mercator", "Mercator_1SP", "Mercator_Auxiliary_Sphere", "merc"];
    var merc = {
      init: init,
      forward: forward,
      inverse: inverse,
      names: names$1
    };

    function init$1() {
      //no-op for longlat
    }

    function identity(pt) {
      return pt;
    }
    var names$2 = ["longlat", "identity"];
    var longlat = {
      init: init$1,
      forward: identity,
      inverse: identity,
      names: names$2
    };

    var projs = [merc, longlat];
    var names = {};
    var projStore = [];

    function add(proj, i) {
      var len = projStore.length;
      if (!proj.names) {
        console.log(i);
        return true;
      }
      projStore[len] = proj;
      proj.names.forEach(function(n) {
        names[n.toLowerCase()] = len;
      });
      return this;
    }

    function get(name) {
      if (!name) {
        return false;
      }
      var n = name.toLowerCase();
      if (typeof names[n] !== 'undefined' && projStore[names[n]]) {
        return projStore[names[n]];
      }
    }

    function start() {
      projs.forEach(add);
    }
    var projections = {
      start: start,
      add: add,
      get: get
    };

    var exports$2 = {};
    exports$2.MERIT = {
      a: 6378137.0,
      rf: 298.257,
      ellipseName: "MERIT 1983"
    };

    exports$2.SGS85 = {
      a: 6378136.0,
      rf: 298.257,
      ellipseName: "Soviet Geodetic System 85"
    };

    exports$2.GRS80 = {
      a: 6378137.0,
      rf: 298.257222101,
      ellipseName: "GRS 1980(IUGG, 1980)"
    };

    exports$2.IAU76 = {
      a: 6378140.0,
      rf: 298.257,
      ellipseName: "IAU 1976"
    };

    exports$2.airy = {
      a: 6377563.396,
      b: 6356256.910,
      ellipseName: "Airy 1830"
    };

    exports$2.APL4 = {
      a: 6378137,
      rf: 298.25,
      ellipseName: "Appl. Physics. 1965"
    };

    exports$2.NWL9D = {
      a: 6378145.0,
      rf: 298.25,
      ellipseName: "Naval Weapons Lab., 1965"
    };

    exports$2.mod_airy = {
      a: 6377340.189,
      b: 6356034.446,
      ellipseName: "Modified Airy"
    };

    exports$2.andrae = {
      a: 6377104.43,
      rf: 300.0,
      ellipseName: "Andrae 1876 (Den., Iclnd.)"
    };

    exports$2.aust_SA = {
      a: 6378160.0,
      rf: 298.25,
      ellipseName: "Australian Natl & S. Amer. 1969"
    };

    exports$2.GRS67 = {
      a: 6378160.0,
      rf: 298.2471674270,
      ellipseName: "GRS 67(IUGG 1967)"
    };

    exports$2.bessel = {
      a: 6377397.155,
      rf: 299.1528128,
      ellipseName: "Bessel 1841"
    };

    exports$2.bess_nam = {
      a: 6377483.865,
      rf: 299.1528128,
      ellipseName: "Bessel 1841 (Namibia)"
    };

    exports$2.clrk66 = {
      a: 6378206.4,
      b: 6356583.8,
      ellipseName: "Clarke 1866"
    };

    exports$2.clrk80 = {
      a: 6378249.145,
      rf: 293.4663,
      ellipseName: "Clarke 1880 mod."
    };

    exports$2.clrk80ign = {
      a: 6378249.2,
      b: 6356515,
      rf: 293.4660213,
      ellipseName: "Clarke 1880 (IGN)"
    };

    exports$2.clrk58 = {
      a: 6378293.645208759,
      rf: 294.2606763692654,
      ellipseName: "Clarke 1858"
    };

    exports$2.CPM = {
      a: 6375738.7,
      rf: 334.29,
      ellipseName: "Comm. des Poids et Mesures 1799"
    };

    exports$2.delmbr = {
      a: 6376428.0,
      rf: 311.5,
      ellipseName: "Delambre 1810 (Belgium)"
    };

    exports$2.engelis = {
      a: 6378136.05,
      rf: 298.2566,
      ellipseName: "Engelis 1985"
    };

    exports$2.evrst30 = {
      a: 6377276.345,
      rf: 300.8017,
      ellipseName: "Everest 1830"
    };

    exports$2.evrst48 = {
      a: 6377304.063,
      rf: 300.8017,
      ellipseName: "Everest 1948"
    };

    exports$2.evrst56 = {
      a: 6377301.243,
      rf: 300.8017,
      ellipseName: "Everest 1956"
    };

    exports$2.evrst69 = {
      a: 6377295.664,
      rf: 300.8017,
      ellipseName: "Everest 1969"
    };

    exports$2.evrstSS = {
      a: 6377298.556,
      rf: 300.8017,
      ellipseName: "Everest (Sabah & Sarawak)"
    };

    exports$2.fschr60 = {
      a: 6378166.0,
      rf: 298.3,
      ellipseName: "Fischer (Mercury Datum) 1960"
    };

    exports$2.fschr60m = {
      a: 6378155.0,
      rf: 298.3,
      ellipseName: "Fischer 1960"
    };

    exports$2.fschr68 = {
      a: 6378150.0,
      rf: 298.3,
      ellipseName: "Fischer 1968"
    };

    exports$2.helmert = {
      a: 6378200.0,
      rf: 298.3,
      ellipseName: "Helmert 1906"
    };

    exports$2.hough = {
      a: 6378270.0,
      rf: 297.0,
      ellipseName: "Hough"
    };

    exports$2.intl = {
      a: 6378388.0,
      rf: 297.0,
      ellipseName: "International 1909 (Hayford)"
    };

    exports$2.kaula = {
      a: 6378163.0,
      rf: 298.24,
      ellipseName: "Kaula 1961"
    };

    exports$2.lerch = {
      a: 6378139.0,
      rf: 298.257,
      ellipseName: "Lerch 1979"
    };

    exports$2.mprts = {
      a: 6397300.0,
      rf: 191.0,
      ellipseName: "Maupertius 1738"
    };

    exports$2.new_intl = {
      a: 6378157.5,
      b: 6356772.2,
      ellipseName: "New International 1967"
    };

    exports$2.plessis = {
      a: 6376523.0,
      rf: 6355863.0,
      ellipseName: "Plessis 1817 (France)"
    };

    exports$2.krass = {
      a: 6378245.0,
      rf: 298.3,
      ellipseName: "Krassovsky, 1942"
    };

    exports$2.SEasia = {
      a: 6378155.0,
      b: 6356773.3205,
      ellipseName: "Southeast Asia"
    };

    exports$2.walbeck = {
      a: 6376896.0,
      b: 6355834.8467,
      ellipseName: "Walbeck"
    };

    exports$2.WGS60 = {
      a: 6378165.0,
      rf: 298.3,
      ellipseName: "WGS 60"
    };

    exports$2.WGS66 = {
      a: 6378145.0,
      rf: 298.25,
      ellipseName: "WGS 66"
    };

    exports$2.WGS7 = {
      a: 6378135.0,
      rf: 298.26,
      ellipseName: "WGS 72"
    };

    var WGS84 = exports$2.WGS84 = {
      a: 6378137.0,
      rf: 298.257223563,
      ellipseName: "WGS 84"
    };

    exports$2.sphere = {
      a: 6370997.0,
      b: 6370997.0,
      ellipseName: "Normal Sphere (r=6370997)"
    };

    function eccentricity(a, b, rf, R_A) {
      var a2 = a * a; // used in geocentric
      var b2 = b * b; // used in geocentric
      var es = (a2 - b2) / a2; // e ^ 2
      var e = 0;
      if (R_A) {
        a *= 1 - es * (SIXTH + es * (RA4 + es * RA6));
        a2 = a * a;
        es = 0;
      } else {
        e = Math.sqrt(es); // eccentricity
      }
      var ep2 = (a2 - b2) / b2; // used in geocentric
      return {
        es: es,
        e: e,
        ep2: ep2
      };
    }
    function sphere(a, b, rf, ellps, sphere) {
      if (!a) { // do we have an ellipsoid?
        var ellipse = match(exports$2, ellps);
        if (!ellipse) {
          ellipse = WGS84;
        }
        a = ellipse.a;
        b = ellipse.b;
        rf = ellipse.rf;
      }

      if (rf && !b) {
        b = (1.0 - 1.0 / rf) * a;
      }
      if (rf === 0 || Math.abs(a - b) < EPSLN) {
        sphere = true;
        b = a;
      }
      return {
        a: a,
        b: b,
        rf: rf,
        sphere: sphere
      };
    }

    var datums = {
      wgs84: {
        towgs84: "0,0,0",
        ellipse: "WGS84",
        datumName: "WGS84"
      },
      ch1903: {
        towgs84: "674.374,15.056,405.346",
        ellipse: "bessel",
        datumName: "swiss"
      },
      ggrs87: {
        towgs84: "-199.87,74.79,246.62",
        ellipse: "GRS80",
        datumName: "Greek_Geodetic_Reference_System_1987"
      },
      nad83: {
        towgs84: "0,0,0",
        ellipse: "GRS80",
        datumName: "North_American_Datum_1983"
      },
      nad27: {
        nadgrids: "@conus,@alaska,@ntv2_0.gsb,@ntv1_can.dat",
        ellipse: "clrk66",
        datumName: "North_American_Datum_1927"
      },
      potsdam: {
        towgs84: "598.1,73.7,418.2,0.202,0.045,-2.455,6.7",
        ellipse: "bessel",
        datumName: "Potsdam Rauenberg 1950 DHDN"
      },
      carthage: {
        towgs84: "-263.0,6.0,431.0",
        ellipse: "clark80",
        datumName: "Carthage 1934 Tunisia"
      },
      hermannskogel: {
        towgs84: "577.326,90.129,463.919,5.137,1.474,5.297,2.4232",
        ellipse: "bessel",
        datumName: "Hermannskogel"
      },
      mgi: {
        towgs84: "577.326,90.129,463.919,5.137,1.474,5.297,2.4232",
        ellipse: "bessel",
        datumName: "Militar-Geographische Institut",
      },
      osni52: {
        towgs84: "482.530,-130.596,564.557,-1.042,-0.214,-0.631,8.15",
        ellipse: "airy",
        datumName: "Irish National"
      },
      ire65: {
        towgs84: "482.530,-130.596,564.557,-1.042,-0.214,-0.631,8.15",
        ellipse: "mod_airy",
        datumName: "Ireland 1965"
      },
      rassadiran: {
        towgs84: "-133.63,-157.5,-158.62",
        ellipse: "intl",
        datumName: "Rassadiran"
      },
      nzgd49: {
        towgs84: "59.47,-5.04,187.44,0.47,-0.1,1.024,-4.5993",
        ellipse: "intl",
        datumName: "New Zealand Geodetic Datum 1949"
      },
      osgb36: {
        towgs84: "446.448,-125.157,542.060,0.1502,0.2470,0.8421,-20.4894",
        ellipse: "airy",
        datumName: "Ordnance Survey of Great Britain 1936"
      },
      s_jtsk: {
        towgs84: "589,76,480",
        ellipse: 'bessel',
        datumName: 'S-JTSK (Ferro)'
      },
      beduaram: {
        towgs84: '-106,-87,188',
        ellipse: 'clrk80',
        datumName: 'Beduaram'
      },
      gunung_segara: {
        towgs84: '-403,684,41',
        ellipse: 'bessel',
        datumName: 'Gunung Segara Jakarta'
      },
      rnb72: {
        towgs84: "106.869,-52.2978,103.724,-0.33657,0.456955,-1.84218,1",
        ellipse: "intl",
        datumName: "Reseau National Belge 1972"
      }
    };

    for (var key in datums) {
      var datum = datums[key];
      datums[datum.datumName] = datum;
    }

    function datum$1(datumCode, datum_params, a, b, es, ep2, nadgrids) {
      var out = {};

      if (datumCode === undefined || datumCode === 'none') {
        out.datum_type = PJD_NODATUM;
      } else {
        out.datum_type = PJD_WGS84;
      }

      if (datum_params) {
        out.datum_params = datum_params.map(parseFloat);
        if (out.datum_params[0] !== 0 || out.datum_params[1] !== 0 || out.datum_params[2] !== 0) {
          out.datum_type = PJD_3PARAM;
        }
        if (out.datum_params.length > 3) {
          if (out.datum_params[3] !== 0 || out.datum_params[4] !== 0 || out.datum_params[5] !== 0 || out.datum_params[6] !== 0) {
            out.datum_type = PJD_7PARAM;
            out.datum_params[3] *= SEC_TO_RAD;
            out.datum_params[4] *= SEC_TO_RAD;
            out.datum_params[5] *= SEC_TO_RAD;
            out.datum_params[6] = (out.datum_params[6] / 1000000.0) + 1.0;
          }
        }
      }

      if (nadgrids) {
        out.datum_type = PJD_GRIDSHIFT;
        out.grids = nadgrids;
      }
      out.a = a; //datum object also uses these values
      out.b = b;
      out.es = es;
      out.ep2 = ep2;
      return out;
    }

    /**
     * Resources for details of NTv2 file formats:
     * - https://web.archive.org/web/20140127204822if_/http://www.mgs.gov.on.ca:80/stdprodconsume/groups/content/@mgs/@iandit/documents/resourcelist/stel02_047447.pdf
     * - http://mimaka.com/help/gs/html/004_NTV2%20Data%20Format.htm
     */

    var loadedNadgrids = {};

    /**
     * Load a binary NTv2 file (.gsb) to a key that can be used in a proj string like +nadgrids=<key>. Pass the NTv2 file
     * as an ArrayBuffer.
     */
    function nadgrid(key, data) {
      var view = new DataView(data);
      var isLittleEndian = detectLittleEndian(view);
      var header = readHeader(view, isLittleEndian);
      var subgrids = readSubgrids(view, header, isLittleEndian);
      var nadgrid = {header: header, subgrids: subgrids};
      loadedNadgrids[key] = nadgrid;
      return nadgrid;
    }

    /**
     * Given a proj4 value for nadgrids, return an array of loaded grids
     */
    function getNadgrids(nadgrids) {
      // Format details: http://proj.maptools.org/gen_parms.html
      if (nadgrids === undefined) { return null; }
      var grids = nadgrids.split(',');
      return grids.map(parseNadgridString);
    }

    function parseNadgridString(value) {
      if (value.length === 0) {
        return null;
      }
      var optional = value[0] === '@';
      if (optional) {
        value = value.slice(1);
      }
      if (value === 'null') {
        return {name: 'null', mandatory: !optional, grid: null, isNull: true};
      }
      return {
        name: value,
        mandatory: !optional,
        grid: loadedNadgrids[value] || null,
        isNull: false
      };
    }

    function secondsToRadians(seconds) {
      return (seconds / 3600) * Math.PI / 180;
    }

    function detectLittleEndian(view) {
      var nFields = view.getInt32(8, false);
      if (nFields === 11) {
        return false;
      }
      nFields = view.getInt32(8, true);
      if (nFields !== 11) {
        console.warn('Failed to detect nadgrid endian-ness, defaulting to little-endian');
      }
      return true;
    }

    function readHeader(view, isLittleEndian) {
      return {
        nFields: view.getInt32(8, isLittleEndian),
        nSubgridFields: view.getInt32(24, isLittleEndian),
        nSubgrids: view.getInt32(40, isLittleEndian),
        shiftType: decodeString(view, 56, 56 + 8).trim(),
        fromSemiMajorAxis: view.getFloat64(120, isLittleEndian),
        fromSemiMinorAxis: view.getFloat64(136, isLittleEndian),
        toSemiMajorAxis: view.getFloat64(152, isLittleEndian),
        toSemiMinorAxis: view.getFloat64(168, isLittleEndian),
      };
    }

    function decodeString(view, start, end) {
      return String.fromCharCode.apply(null, new Uint8Array(view.buffer.slice(start, end)));
    }

    function readSubgrids(view, header, isLittleEndian) {
      var gridOffset = 176;
      var grids = [];
      for (var i = 0; i < header.nSubgrids; i++) {
        var subHeader = readGridHeader(view, gridOffset, isLittleEndian);
        var nodes = readGridNodes(view, gridOffset, subHeader, isLittleEndian);
        var lngColumnCount = Math.round(
          1 + (subHeader.upperLongitude - subHeader.lowerLongitude) / subHeader.longitudeInterval);
        var latColumnCount = Math.round(
          1 + (subHeader.upperLatitude - subHeader.lowerLatitude) / subHeader.latitudeInterval);
        // Proj4 operates on radians whereas the coordinates are in seconds in the grid
        grids.push({
          ll: [secondsToRadians(subHeader.lowerLongitude), secondsToRadians(subHeader.lowerLatitude)],
          del: [secondsToRadians(subHeader.longitudeInterval), secondsToRadians(subHeader.latitudeInterval)],
          lim: [lngColumnCount, latColumnCount],
          count: subHeader.gridNodeCount,
          cvs: mapNodes(nodes)
        });
        gridOffset += 176 + subHeader.gridNodeCount * 16;
      }
      return grids;
    }

    function mapNodes(nodes) {
      return nodes.map(function (r) {return [secondsToRadians(r.longitudeShift), secondsToRadians(r.latitudeShift)];});
    }

    function readGridHeader(view, offset, isLittleEndian) {
      return {
        name: decodeString(view, offset + 8, offset + 16).trim(),
        parent: decodeString(view, offset + 24, offset + 24 + 8).trim(),
        lowerLatitude: view.getFloat64(offset + 72, isLittleEndian),
        upperLatitude: view.getFloat64(offset + 88, isLittleEndian),
        lowerLongitude: view.getFloat64(offset + 104, isLittleEndian),
        upperLongitude: view.getFloat64(offset + 120, isLittleEndian),
        latitudeInterval: view.getFloat64(offset + 136, isLittleEndian),
        longitudeInterval: view.getFloat64(offset + 152, isLittleEndian),
        gridNodeCount: view.getInt32(offset + 168, isLittleEndian)
      };
    }

    function readGridNodes(view, offset, gridHeader, isLittleEndian) {
      var nodesOffset = offset + 176;
      var gridRecordLength = 16;
      var gridShiftRecords = [];
      for (var i = 0; i < gridHeader.gridNodeCount; i++) {
        var record = {
          latitudeShift: view.getFloat32(nodesOffset + i * gridRecordLength, isLittleEndian),
          longitudeShift: view.getFloat32(nodesOffset + i * gridRecordLength + 4, isLittleEndian),
          latitudeAccuracy: view.getFloat32(nodesOffset + i * gridRecordLength + 8, isLittleEndian),
          longitudeAccuracy: view.getFloat32(nodesOffset + i * gridRecordLength + 12, isLittleEndian),
        };
        gridShiftRecords.push(record);
      }
      return gridShiftRecords;
    }

    function Projection(srsCode,callback) {
      if (!(this instanceof Projection)) {
        return new Projection(srsCode);
      }
      callback = callback || function(error){
        if(error){
          throw error;
        }
      };
      var json = parse(srsCode);
      if(typeof json !== 'object'){
        callback('Could not parse to valid json: ' + srsCode);
        return;
      }
      var ourProj = Projection.projections.get(json.projName);
      if(!ourProj){
        callback('Could not get projection name from: ' + srsCode);
        return;
      }
      if (json.datumCode && json.datumCode !== 'none') {
        var datumDef = match(datums, json.datumCode);
        if (datumDef) {
          json.datum_params = json.datum_params || (datumDef.towgs84 ? datumDef.towgs84.split(',') : null);
          json.ellps = datumDef.ellipse;
          json.datumName = datumDef.datumName ? datumDef.datumName : json.datumCode;
        }
      }
      json.k0 = json.k0 || 1.0;
      json.axis = json.axis || 'enu';
      json.ellps = json.ellps || 'wgs84';
      json.lat1 = json.lat1 || json.lat0; // Lambert_Conformal_Conic_1SP, for example, needs this

      var sphere_ = sphere(json.a, json.b, json.rf, json.ellps, json.sphere);
      var ecc = eccentricity(sphere_.a, sphere_.b, sphere_.rf, json.R_A);
      var nadgrids = getNadgrids(json.nadgrids);
      var datumObj = json.datum || datum$1(json.datumCode, json.datum_params, sphere_.a, sphere_.b, ecc.es, ecc.ep2,
        nadgrids);

      extend(this, json); // transfer everything over from the projection because we don't know what we'll need
      extend(this, ourProj); // transfer all the methods from the projection

      // copy the 4 things over we calculated in deriveConstants.sphere
      this.a = sphere_.a;
      this.b = sphere_.b;
      this.rf = sphere_.rf;
      this.sphere = sphere_.sphere;

      // copy the 3 things we calculated in deriveConstants.eccentricity
      this.es = ecc.es;
      this.e = ecc.e;
      this.ep2 = ecc.ep2;

      // add in the datum object
      this.datum = datumObj;

      // init the projection
      this.init();

      // legecy callback from back in the day when it went to spatialreference.org
      callback(null, this);

    }
    Projection.projections = projections;
    Projection.projections.start();

    'use strict';
    function compareDatums(source, dest) {
      if (source.datum_type !== dest.datum_type) {
        return false; // false, datums are not equal
      } else if (source.a !== dest.a || Math.abs(source.es - dest.es) > 0.000000000050) {
        // the tolerance for es is to ensure that GRS80 and WGS84
        // are considered identical
        return false;
      } else if (source.datum_type === PJD_3PARAM) {
        return (source.datum_params[0] === dest.datum_params[0] && source.datum_params[1] === dest.datum_params[1] && source.datum_params[2] === dest.datum_params[2]);
      } else if (source.datum_type === PJD_7PARAM) {
        return (source.datum_params[0] === dest.datum_params[0] && source.datum_params[1] === dest.datum_params[1] && source.datum_params[2] === dest.datum_params[2] && source.datum_params[3] === dest.datum_params[3] && source.datum_params[4] === dest.datum_params[4] && source.datum_params[5] === dest.datum_params[5] && source.datum_params[6] === dest.datum_params[6]);
      } else {
        return true; // datums are equal
      }
    } // cs_compare_datums()

    /*
     * The function Convert_Geodetic_To_Geocentric converts geodetic coordinates
     * (latitude, longitude, and height) to geocentric coordinates (X, Y, Z),
     * according to the current ellipsoid parameters.
     *
     *    Latitude  : Geodetic latitude in radians                     (input)
     *    Longitude : Geodetic longitude in radians                    (input)
     *    Height    : Geodetic height, in meters                       (input)
     *    X         : Calculated Geocentric X coordinate, in meters    (output)
     *    Y         : Calculated Geocentric Y coordinate, in meters    (output)
     *    Z         : Calculated Geocentric Z coordinate, in meters    (output)
     *
     */
    function geodeticToGeocentric(p, es, a) {
      var Longitude = p.x;
      var Latitude = p.y;
      var Height = p.z ? p.z : 0; //Z value not always supplied

      var Rn; /*  Earth radius at location  */
      var Sin_Lat; /*  Math.sin(Latitude)  */
      var Sin2_Lat; /*  Square of Math.sin(Latitude)  */
      var Cos_Lat; /*  Math.cos(Latitude)  */

      /*
       ** Don't blow up if Latitude is just a little out of the value
       ** range as it may just be a rounding issue.  Also removed longitude
       ** test, it should be wrapped by Math.cos() and Math.sin().  NFW for PROJ.4, Sep/2001.
       */
      if (Latitude < -HALF_PI && Latitude > -1.001 * HALF_PI) {
        Latitude = -HALF_PI;
      } else if (Latitude > HALF_PI && Latitude < 1.001 * HALF_PI) {
        Latitude = HALF_PI;
      } else if (Latitude < -HALF_PI) {
        /* Latitude out of range */
        //..reportError('geocent:lat out of range:' + Latitude);
        return { x: -Infinity, y: -Infinity, z: p.z };
      } else if (Latitude > HALF_PI) {
        /* Latitude out of range */
        return { x: Infinity, y: Infinity, z: p.z };
      }

      if (Longitude > Math.PI) {
        Longitude -= (2 * Math.PI);
      }
      Sin_Lat = Math.sin(Latitude);
      Cos_Lat = Math.cos(Latitude);
      Sin2_Lat = Sin_Lat * Sin_Lat;
      Rn = a / (Math.sqrt(1.0e0 - es * Sin2_Lat));
      return {
        x: (Rn + Height) * Cos_Lat * Math.cos(Longitude),
        y: (Rn + Height) * Cos_Lat * Math.sin(Longitude),
        z: ((Rn * (1 - es)) + Height) * Sin_Lat
      };
    } // cs_geodetic_to_geocentric()

    function geocentricToGeodetic(p, es, a, b) {
      /* local defintions and variables */
      /* end-criterium of loop, accuracy of sin(Latitude) */
      var genau = 1e-12;
      var genau2 = (genau * genau);
      var maxiter = 30;

      var P; /* distance between semi-minor axis and location */
      var RR; /* distance between center and location */
      var CT; /* sin of geocentric latitude */
      var ST; /* cos of geocentric latitude */
      var RX;
      var RK;
      var RN; /* Earth radius at location */
      var CPHI0; /* cos of start or old geodetic latitude in iterations */
      var SPHI0; /* sin of start or old geodetic latitude in iterations */
      var CPHI; /* cos of searched geodetic latitude */
      var SPHI; /* sin of searched geodetic latitude */
      var SDPHI; /* end-criterium: addition-theorem of sin(Latitude(iter)-Latitude(iter-1)) */
      var iter; /* # of continous iteration, max. 30 is always enough (s.a.) */

      var X = p.x;
      var Y = p.y;
      var Z = p.z ? p.z : 0.0; //Z value not always supplied
      var Longitude;
      var Latitude;
      var Height;

      P = Math.sqrt(X * X + Y * Y);
      RR = Math.sqrt(X * X + Y * Y + Z * Z);

      /*      special cases for latitude and longitude */
      if (P / a < genau) {

        /*  special case, if P=0. (X=0., Y=0.) */
        Longitude = 0.0;

        /*  if (X,Y,Z)=(0.,0.,0.) then Height becomes semi-minor axis
         *  of ellipsoid (=center of mass), Latitude becomes PI/2 */
        if (RR / a < genau) {
          Latitude = HALF_PI;
          Height = -b;
          return {
            x: p.x,
            y: p.y,
            z: p.z
          };
        }
      } else {
        /*  ellipsoidal (geodetic) longitude
         *  interval: -PI < Longitude <= +PI */
        Longitude = Math.atan2(Y, X);
      }

      /* --------------------------------------------------------------
       * Following iterative algorithm was developped by
       * "Institut for Erdmessung", University of Hannover, July 1988.
       * Internet: www.ife.uni-hannover.de
       * Iterative computation of CPHI,SPHI and Height.
       * Iteration of CPHI and SPHI to 10**-12 radian resp.
       * 2*10**-7 arcsec.
       * --------------------------------------------------------------
       */
      CT = Z / RR;
      ST = P / RR;
      RX = 1.0 / Math.sqrt(1.0 - es * (2.0 - es) * ST * ST);
      CPHI0 = ST * (1.0 - es) * RX;
      SPHI0 = CT * RX;
      iter = 0;

      /* loop to find sin(Latitude) resp. Latitude
       * until |sin(Latitude(iter)-Latitude(iter-1))| < genau */
      do {
        iter++;
        RN = a / Math.sqrt(1.0 - es * SPHI0 * SPHI0);

        /*  ellipsoidal (geodetic) height */
        Height = P * CPHI0 + Z * SPHI0 - RN * (1.0 - es * SPHI0 * SPHI0);

        RK = es * RN / (RN + Height);
        RX = 1.0 / Math.sqrt(1.0 - RK * (2.0 - RK) * ST * ST);
        CPHI = ST * (1.0 - RK) * RX;
        SPHI = CT * RX;
        SDPHI = SPHI * CPHI0 - CPHI * SPHI0;
        CPHI0 = CPHI;
        SPHI0 = SPHI;
      }
      while (SDPHI * SDPHI > genau2 && iter < maxiter);

      /*      ellipsoidal (geodetic) latitude */
      Latitude = Math.atan(SPHI / Math.abs(CPHI));
      return {
        x: Longitude,
        y: Latitude,
        z: Height
      };
    } // cs_geocentric_to_geodetic()

    /****************************************************************/
    // pj_geocentic_to_wgs84( p )
    //  p = point to transform in geocentric coordinates (x,y,z)


    /** point object, nothing fancy, just allows values to be
        passed back and forth by reference rather than by value.
        Other point classes may be used as long as they have
        x and y properties, which will get modified in the transform method.
    */
    function geocentricToWgs84(p, datum_type, datum_params) {

      if (datum_type === PJD_3PARAM) {
        // if( x[io] === HUGE_VAL )
        //    continue;
        return {
          x: p.x + datum_params[0],
          y: p.y + datum_params[1],
          z: p.z + datum_params[2],
        };
      } else if (datum_type === PJD_7PARAM) {
        var Dx_BF = datum_params[0];
        var Dy_BF = datum_params[1];
        var Dz_BF = datum_params[2];
        var Rx_BF = datum_params[3];
        var Ry_BF = datum_params[4];
        var Rz_BF = datum_params[5];
        var M_BF = datum_params[6];
        // if( x[io] === HUGE_VAL )
        //    continue;
        return {
          x: M_BF * (p.x - Rz_BF * p.y + Ry_BF * p.z) + Dx_BF,
          y: M_BF * (Rz_BF * p.x + p.y - Rx_BF * p.z) + Dy_BF,
          z: M_BF * (-Ry_BF * p.x + Rx_BF * p.y + p.z) + Dz_BF
        };
      }
    } // cs_geocentric_to_wgs84

    /****************************************************************/
    // pj_geocentic_from_wgs84()
    //  coordinate system definition,
    //  point to transform in geocentric coordinates (x,y,z)
    function geocentricFromWgs84(p, datum_type, datum_params) {

      if (datum_type === PJD_3PARAM) {
        //if( x[io] === HUGE_VAL )
        //    continue;
        return {
          x: p.x - datum_params[0],
          y: p.y - datum_params[1],
          z: p.z - datum_params[2],
        };

      } else if (datum_type === PJD_7PARAM) {
        var Dx_BF = datum_params[0];
        var Dy_BF = datum_params[1];
        var Dz_BF = datum_params[2];
        var Rx_BF = datum_params[3];
        var Ry_BF = datum_params[4];
        var Rz_BF = datum_params[5];
        var M_BF = datum_params[6];
        var x_tmp = (p.x - Dx_BF) / M_BF;
        var y_tmp = (p.y - Dy_BF) / M_BF;
        var z_tmp = (p.z - Dz_BF) / M_BF;
        //if( x[io] === HUGE_VAL )
        //    continue;

        return {
          x: x_tmp + Rz_BF * y_tmp - Ry_BF * z_tmp,
          y: -Rz_BF * x_tmp + y_tmp + Rx_BF * z_tmp,
          z: Ry_BF * x_tmp - Rx_BF * y_tmp + z_tmp
        };
      } //cs_geocentric_from_wgs84()
    }

    function checkParams(type) {
      return (type === PJD_3PARAM || type === PJD_7PARAM);
    }

    var datum_transform = function(source, dest, point) {
      // Short cut if the datums are identical.
      if (compareDatums(source, dest)) {
        return point; // in this case, zero is sucess,
        // whereas cs_compare_datums returns 1 to indicate TRUE
        // confusing, should fix this
      }

      // Explicitly skip datum transform by setting 'datum=none' as parameter for either source or dest
      if (source.datum_type === PJD_NODATUM || dest.datum_type === PJD_NODATUM) {
        return point;
      }

      // If this datum requires grid shifts, then apply it to geodetic coordinates.
      var source_a = source.a;
      var source_es = source.es;
      if (source.datum_type === PJD_GRIDSHIFT) {
        var gridShiftCode = applyGridShift(source, false, point);
        if (gridShiftCode !== 0) {
          return undefined;
        }
        source_a = SRS_WGS84_SEMIMAJOR;
        source_es = SRS_WGS84_ESQUARED;
      }

      var dest_a = dest.a;
      var dest_b = dest.b;
      var dest_es = dest.es;
      if (dest.datum_type === PJD_GRIDSHIFT) {
        dest_a = SRS_WGS84_SEMIMAJOR;
        dest_b = SRS_WGS84_SEMIMINOR;
        dest_es = SRS_WGS84_ESQUARED;
      }

      // Do we need to go through geocentric coordinates?
      if (source_es === dest_es && source_a === dest_a && !checkParams(source.datum_type) &&  !checkParams(dest.datum_type)) {
        return point;
      }

      // Convert to geocentric coordinates.
      point = geodeticToGeocentric(point, source_es, source_a);
      // Convert between datums
      if (checkParams(source.datum_type)) {
        point = geocentricToWgs84(point, source.datum_type, source.datum_params);
      }
      if (checkParams(dest.datum_type)) {
        point = geocentricFromWgs84(point, dest.datum_type, dest.datum_params);
      }
      point = geocentricToGeodetic(point, dest_es, dest_a, dest_b);

      if (dest.datum_type === PJD_GRIDSHIFT) {
        var destGridShiftResult = applyGridShift(dest, true, point);
        if (destGridShiftResult !== 0) {
          return undefined;
        }
      }

      return point;
    };

    function applyGridShift(source, inverse, point) {
      if (source.grids === null || source.grids.length === 0) {
        console.log('Grid shift grids not found');
        return -1;
      }
      var input = {x: -point.x, y: point.y};
      var output = {x: Number.NaN, y: Number.NaN};
      var attemptedGrids = [];
      outer:
      for (var i = 0; i < source.grids.length; i++) {
        var grid = source.grids[i];
        attemptedGrids.push(grid.name);
        if (grid.isNull) {
          output = input;
          break;
        }
        if (grid.grid === null) {
          if (grid.mandatory) {
            console.log("Unable to find mandatory grid '" + grid.name + "'");
            return -1;
          }
          continue;
        }
        var subgrids = grid.grid.subgrids;
        for (var j = 0, jj = subgrids.length; j < jj; j++) {
          var subgrid = subgrids[j];
          // skip tables that don't match our point at all
          var epsilon = (Math.abs(subgrid.del[1]) + Math.abs(subgrid.del[0])) / 10000.0;
          var minX = subgrid.ll[0] - epsilon;
          var minY = subgrid.ll[1] - epsilon;
          var maxX = subgrid.ll[0] + (subgrid.lim[0] - 1) * subgrid.del[0] + epsilon;
          var maxY = subgrid.ll[1] + (subgrid.lim[1] - 1) * subgrid.del[1] + epsilon;
          if (minY > input.y || minX > input.x || maxY < input.y || maxX < input.x ) {
            continue;
          }
          output = applySubgridShift(input, inverse, subgrid);
          if (!isNaN(output.x)) {
            break outer;
          }
        }
      }
      if (isNaN(output.x)) {
        console.log("Failed to find a grid shift table for location '"+
          -input.x * R2D + " " + input.y * R2D + " tried: '" + attemptedGrids + "'");
        return -1;
      }
      point.x = -output.x;
      point.y = output.y;
      return 0;
    }

    function applySubgridShift(pin, inverse, ct) {
      var val = {x: Number.NaN, y: Number.NaN};
      if (isNaN(pin.x)) { return val; }
      var tb = {x: pin.x, y: pin.y};
      tb.x -= ct.ll[0];
      tb.y -= ct.ll[1];
      tb.x = adjust_lon(tb.x - Math.PI) + Math.PI;
      var t = nadInterpolate(tb, ct);
      if (inverse) {
        if (isNaN(t.x)) {
          return val;
        }
        t.x = tb.x - t.x;
        t.y = tb.y - t.y;
        var i = 9, tol = 1e-12;
        var dif, del;
        do {
          del = nadInterpolate(t, ct);
          if (isNaN(del.x)) {
            console.log("Inverse grid shift iteration failed, presumably at grid edge.  Using first approximation.");
            break;
          }
          dif = {x: tb.x - (del.x + t.x), y: tb.y - (del.y + t.y)};
          t.x += dif.x;
          t.y += dif.y;
        } while (i-- && Math.abs(dif.x) > tol && Math.abs(dif.y) > tol);
        if (i < 0) {
          console.log("Inverse grid shift iterator failed to converge.");
          return val;
        }
        val.x = adjust_lon(t.x + ct.ll[0]);
        val.y = t.y + ct.ll[1];
      } else {
        if (!isNaN(t.x)) {
          val.x = pin.x + t.x;
          val.y = pin.y + t.y;
        }
      }
      return val;
    }

    function nadInterpolate(pin, ct) {
      var t = {x: pin.x / ct.del[0], y: pin.y / ct.del[1]};
      var indx = {x: Math.floor(t.x), y: Math.floor(t.y)};
      var frct = {x: t.x - 1.0 * indx.x, y: t.y - 1.0 * indx.y};
      var val= {x: Number.NaN, y: Number.NaN};
      var inx;
      if (indx.x < 0 || indx.x >= ct.lim[0]) {
        return val;
      }
      if (indx.y < 0 || indx.y >= ct.lim[1]) {
        return val;
      }
      inx = (indx.y * ct.lim[0]) + indx.x;
      var f00 = {x: ct.cvs[inx][0], y: ct.cvs[inx][1]};
      inx++;
      var f10= {x: ct.cvs[inx][0], y: ct.cvs[inx][1]};
      inx += ct.lim[0];
      var f11 = {x: ct.cvs[inx][0], y: ct.cvs[inx][1]};
      inx--;
      var f01 = {x: ct.cvs[inx][0], y: ct.cvs[inx][1]};
      var m11 = frct.x * frct.y, m10 = frct.x * (1.0 - frct.y),
        m00 = (1.0 - frct.x) * (1.0 - frct.y), m01 = (1.0 - frct.x) * frct.y;
      val.x = (m00 * f00.x + m10 * f10.x + m01 * f01.x + m11 * f11.x);
      val.y = (m00 * f00.y + m10 * f10.y + m01 * f01.y + m11 * f11.y);
      return val;
    }

    var adjust_axis = function(crs, denorm, point) {
      var xin = point.x,
        yin = point.y,
        zin = point.z || 0.0;
      var v, t, i;
      var out = {};
      for (i = 0; i < 3; i++) {
        if (denorm && i === 2 && point.z === undefined) {
          continue;
        }
        if (i === 0) {
          v = xin;
          if ("ew".indexOf(crs.axis[i]) !== -1) {
            t = 'x';
          } else {
            t = 'y';
          }

        }
        else if (i === 1) {
          v = yin;
          if ("ns".indexOf(crs.axis[i]) !== -1) {
            t = 'y';
          } else {
            t = 'x';
          }
        }
        else {
          v = zin;
          t = 'z';
        }
        switch (crs.axis[i]) {
        case 'e':
          out[t] = v;
          break;
        case 'w':
          out[t] = -v;
          break;
        case 'n':
          out[t] = v;
          break;
        case 's':
          out[t] = -v;
          break;
        case 'u':
          if (point[t] !== undefined) {
            out.z = v;
          }
          break;
        case 'd':
          if (point[t] !== undefined) {
            out.z = -v;
          }
          break;
        default:
          //console.log("ERROR: unknow axis ("+crs.axis[i]+") - check definition of "+crs.projName);
          return null;
        }
      }
      return out;
    };

    var toPoint = function (array){
      var out = {
        x: array[0],
        y: array[1]
      };
      if (array.length>2) {
        out.z = array[2];
      }
      if (array.length>3) {
        out.m = array[3];
      }
      return out;
    };

    var checkSanity = function (point) {
      checkCoord(point.x);
      checkCoord(point.y);
    };
    function checkCoord(num) {
      if (typeof Number.isFinite === 'function') {
        if (Number.isFinite(num)) {
          return;
        }
        throw new TypeError('coordinates must be finite numbers');
      }
      if (typeof num !== 'number' || num !== num || !isFinite(num)) {
        throw new TypeError('coordinates must be finite numbers');
      }
    }

    function checkNotWGS(source, dest) {
      return (
        (source.datum.datum_type === PJD_3PARAM || source.datum.datum_type === PJD_7PARAM || source.datum.datum_type === PJD_GRIDSHIFT) && dest.datumCode !== 'WGS84') ||
        ((dest.datum.datum_type === PJD_3PARAM || dest.datum.datum_type === PJD_7PARAM || dest.datum.datum_type === PJD_GRIDSHIFT) && source.datumCode !== 'WGS84');
    }

    function transform(source, dest, point, enforceAxis) {
      var wgs84;
      if (Array.isArray(point)) {
        point = toPoint(point);
      } else {
        // Clone the point object so inputs don't get modified
        point = {
          x: point.x,
          y: point.y,
          z: point.z,
          m: point.m
        };
      }
      var hasZ = point.z !== undefined;
      checkSanity(point);
      // Workaround for datum shifts towgs84, if either source or destination projection is not wgs84
      if (source.datum && dest.datum && checkNotWGS(source, dest)) {
        wgs84 = new Projection('WGS84');
        point = transform(source, wgs84, point, enforceAxis);
        source = wgs84;
      }
      // DGR, 2010/11/12
      if (enforceAxis && source.axis !== 'enu') {
        point = adjust_axis(source, false, point);
      }
      // Transform source points to long/lat, if they aren't already.
      if (source.projName === 'longlat') {
        point = {
          x: point.x * D2R,
          y: point.y * D2R,
          z: point.z || 0
        };
      } else {
        if (source.to_meter) {
          point = {
            x: point.x * source.to_meter,
            y: point.y * source.to_meter,
            z: point.z || 0
          };
        }
        point = source.inverse(point); // Convert Cartesian to longlat
        if (!point) {
          return;
        }
      }
      // Adjust for the prime meridian if necessary
      if (source.from_greenwich) {
        point.x += source.from_greenwich;
      }

      // Convert datums if needed, and if possible.
      point = datum_transform(source.datum, dest.datum, point);
      if (!point) {
        return;
      }

      // Adjust for the prime meridian if necessary
      if (dest.from_greenwich) {
        point = {
          x: point.x - dest.from_greenwich,
          y: point.y,
          z: point.z || 0
        };
      }

      if (dest.projName === 'longlat') {
        // convert radians to decimal degrees
        point = {
          x: point.x * R2D,
          y: point.y * R2D,
          z: point.z || 0
        };
      } else { // else project
        point = dest.forward(point);
        if (dest.to_meter) {
          point = {
            x: point.x / dest.to_meter,
            y: point.y / dest.to_meter,
            z: point.z || 0
          };
        }
      }

      // DGR, 2010/11/12
      if (enforceAxis && dest.axis !== 'enu') {
        return adjust_axis(dest, true, point);
      }

      if (point && !hasZ) {
        delete point.z;
      }
      return point;
    }

    var wgs84 = Projection('WGS84');

    function transformer(from, to, coords, enforceAxis) {
      var transformedArray, out, keys;
      if (Array.isArray(coords)) {
        transformedArray = transform(from, to, coords, enforceAxis) || {x: NaN, y: NaN};
        if (coords.length > 2) {
          if ((typeof from.name !== 'undefined' && from.name === 'geocent') || (typeof to.name !== 'undefined' && to.name === 'geocent')) {
            if (typeof transformedArray.z === 'number') {
              return [transformedArray.x, transformedArray.y, transformedArray.z].concat(coords.slice(3));
            } else {
              return [transformedArray.x, transformedArray.y, coords[2]].concat(coords.slice(3));
            }
          } else {
            return [transformedArray.x, transformedArray.y].concat(coords.slice(2));
          }
        } else {
          return [transformedArray.x, transformedArray.y];
        }
      } else {
        out = transform(from, to, coords, enforceAxis);
        keys = Object.keys(coords);
        if (keys.length === 2) {
          return out;
        }
        keys.forEach(function (key) {
          if ((typeof from.name !== 'undefined' && from.name === 'geocent') || (typeof to.name !== 'undefined' && to.name === 'geocent')) {
            if (key === 'x' || key === 'y' || key === 'z') {
              return;
            }
          } else {
            if (key === 'x' || key === 'y') {
              return;
            }
          }
          out[key] = coords[key];
        });
        return out;
      }
    }

    function checkProj(item) {
      if (item instanceof Projection) {
        return item;
      }
      if (item.oProj) {
        return item.oProj;
      }
      return Projection(item);
    }

    function proj4$1(fromProj, toProj, coord) {
      fromProj = checkProj(fromProj);
      var single = false;
      var obj;
      if (typeof toProj === 'undefined') {
        toProj = fromProj;
        fromProj = wgs84;
        single = true;
      } else if (typeof toProj.x !== 'undefined' || Array.isArray(toProj)) {
        coord = toProj;
        toProj = fromProj;
        fromProj = wgs84;
        single = true;
      }
      toProj = checkProj(toProj);
      if (coord) {
        return transformer(fromProj, toProj, coord);
      } else {
        obj = {
          forward: function (coords, enforceAxis) {
            return transformer(fromProj, toProj, coords, enforceAxis);
          },
          inverse: function (coords, enforceAxis) {
            return transformer(toProj, fromProj, coords, enforceAxis);
          }
        };
        if (single) {
          obj.oProj = toProj;
        }
        return obj;
      }
    }

    /**
     * UTM zones are grouped, and assigned to one of a group of 6
     * sets.
     *
     * {int} @private
     */
    var NUM_100K_SETS = 6;

    /**
     * The column letters (for easting) of the lower left value, per
     * set.
     *
     * {string} @private
     */
    var SET_ORIGIN_COLUMN_LETTERS = 'AJSAJS';

    /**
     * The row letters (for northing) of the lower left value, per
     * set.
     *
     * {string} @private
     */
    var SET_ORIGIN_ROW_LETTERS = 'AFAFAF';

    var A = 65; // A
    var I = 73; // I
    var O = 79; // O
    var V = 86; // V
    var Z = 90; // Z
    var mgrs = {
      forward: forward$1,
      inverse: inverse$1,
      toPoint: toPoint$1
    };
    /**
     * Conversion of lat/lon to MGRS.
     *
     * @param {object} ll Object literal with lat and lon properties on a
     *     WGS84 ellipsoid.
     * @param {int} accuracy Accuracy in digits (5 for 1 m, 4 for 10 m, 3 for
     *      100 m, 2 for 1000 m or 1 for 10000 m). Optional, default is 5.
     * @return {string} the MGRS string for the given location and accuracy.
     */
    function forward$1(ll, accuracy) {
      accuracy = accuracy || 5; // default accuracy 1m
      return encode(LLtoUTM({
        lat: ll[1],
        lon: ll[0]
      }), accuracy);
    }

    /**
     * Conversion of MGRS to lat/lon.
     *
     * @param {string} mgrs MGRS string.
     * @return {array} An array with left (longitude), bottom (latitude), right
     *     (longitude) and top (latitude) values in WGS84, representing the
     *     bounding box for the provided MGRS reference.
     */
    function inverse$1(mgrs) {
      var bbox = UTMtoLL(decode(mgrs.toUpperCase()));
      if (bbox.lat && bbox.lon) {
        return [bbox.lon, bbox.lat, bbox.lon, bbox.lat];
      }
      return [bbox.left, bbox.bottom, bbox.right, bbox.top];
    }

    function toPoint$1(mgrs) {
      var bbox = UTMtoLL(decode(mgrs.toUpperCase()));
      if (bbox.lat && bbox.lon) {
        return [bbox.lon, bbox.lat];
      }
      return [(bbox.left + bbox.right) / 2, (bbox.top + bbox.bottom) / 2];
    }
    /**
     * Conversion from degrees to radians.
     *
     * @private
     * @param {number} deg the angle in degrees.
     * @return {number} the angle in radians.
     */
    function degToRad(deg) {
      return (deg * (Math.PI / 180.0));
    }

    /**
     * Conversion from radians to degrees.
     *
     * @private
     * @param {number} rad the angle in radians.
     * @return {number} the angle in degrees.
     */
    function radToDeg(rad) {
      return (180.0 * (rad / Math.PI));
    }

    /**
     * Converts a set of Longitude and Latitude co-ordinates to UTM
     * using the WGS84 ellipsoid.
     *
     * @private
     * @param {object} ll Object literal with lat and lon properties
     *     representing the WGS84 coordinate to be converted.
     * @return {object} Object literal containing the UTM value with easting,
     *     northing, zoneNumber and zoneLetter properties, and an optional
     *     accuracy property in digits. Returns null if the conversion failed.
     */
    function LLtoUTM(ll) {
      var Lat = ll.lat;
      var Long = ll.lon;
      var a = 6378137.0; //ellip.radius;
      var eccSquared = 0.00669438; //ellip.eccsq;
      var k0 = 0.9996;
      var LongOrigin;
      var eccPrimeSquared;
      var N, T, C, A, M;
      var LatRad = degToRad(Lat);
      var LongRad = degToRad(Long);
      var LongOriginRad;
      var ZoneNumber;
      // (int)
      ZoneNumber = Math.floor((Long + 180) / 6) + 1;

      //Make sure the longitude 180.00 is in Zone 60
      if (Long === 180) {
        ZoneNumber = 60;
      }

      // Special zone for Norway
      if (Lat >= 56.0 && Lat < 64.0 && Long >= 3.0 && Long < 12.0) {
        ZoneNumber = 32;
      }

      // Special zones for Svalbard
      if (Lat >= 72.0 && Lat < 84.0) {
        if (Long >= 0.0 && Long < 9.0) {
          ZoneNumber = 31;
        }
        else if (Long >= 9.0 && Long < 21.0) {
          ZoneNumber = 33;
        }
        else if (Long >= 21.0 && Long < 33.0) {
          ZoneNumber = 35;
        }
        else if (Long >= 33.0 && Long < 42.0) {
          ZoneNumber = 37;
        }
      }

      LongOrigin = (ZoneNumber - 1) * 6 - 180 + 3; //+3 puts origin
      // in middle of
      // zone
      LongOriginRad = degToRad(LongOrigin);

      eccPrimeSquared = (eccSquared) / (1 - eccSquared);

      N = a / Math.sqrt(1 - eccSquared * Math.sin(LatRad) * Math.sin(LatRad));
      T = Math.tan(LatRad) * Math.tan(LatRad);
      C = eccPrimeSquared * Math.cos(LatRad) * Math.cos(LatRad);
      A = Math.cos(LatRad) * (LongRad - LongOriginRad);

      M = a * ((1 - eccSquared / 4 - 3 * eccSquared * eccSquared / 64 - 5 * eccSquared * eccSquared * eccSquared / 256) * LatRad - (3 * eccSquared / 8 + 3 * eccSquared * eccSquared / 32 + 45 * eccSquared * eccSquared * eccSquared / 1024) * Math.sin(2 * LatRad) + (15 * eccSquared * eccSquared / 256 + 45 * eccSquared * eccSquared * eccSquared / 1024) * Math.sin(4 * LatRad) - (35 * eccSquared * eccSquared * eccSquared / 3072) * Math.sin(6 * LatRad));

      var UTMEasting = (k0 * N * (A + (1 - T + C) * A * A * A / 6.0 + (5 - 18 * T + T * T + 72 * C - 58 * eccPrimeSquared) * A * A * A * A * A / 120.0) + 500000.0);

      var UTMNorthing = (k0 * (M + N * Math.tan(LatRad) * (A * A / 2 + (5 - T + 9 * C + 4 * C * C) * A * A * A * A / 24.0 + (61 - 58 * T + T * T + 600 * C - 330 * eccPrimeSquared) * A * A * A * A * A * A / 720.0)));
      if (Lat < 0.0) {
        UTMNorthing += 10000000.0; //10000000 meter offset for
        // southern hemisphere
      }

      return {
        northing: Math.round(UTMNorthing),
        easting: Math.round(UTMEasting),
        zoneNumber: ZoneNumber,
        zoneLetter: getLetterDesignator(Lat)
      };
    }

    /**
     * Converts UTM coords to lat/long, using the WGS84 ellipsoid. This is a convenience
     * class where the Zone can be specified as a single string eg."60N" which
     * is then broken down into the ZoneNumber and ZoneLetter.
     *
     * @private
     * @param {object} utm An object literal with northing, easting, zoneNumber
     *     and zoneLetter properties. If an optional accuracy property is
     *     provided (in meters), a bounding box will be returned instead of
     *     latitude and longitude.
     * @return {object} An object literal containing either lat and lon values
     *     (if no accuracy was provided), or top, right, bottom and left values
     *     for the bounding box calculated according to the provided accuracy.
     *     Returns null if the conversion failed.
     */
    function UTMtoLL(utm) {

      var UTMNorthing = utm.northing;
      var UTMEasting = utm.easting;
      var zoneLetter = utm.zoneLetter;
      var zoneNumber = utm.zoneNumber;
      // check the ZoneNummber is valid
      if (zoneNumber < 0 || zoneNumber > 60) {
        return null;
      }

      var k0 = 0.9996;
      var a = 6378137.0; //ellip.radius;
      var eccSquared = 0.00669438; //ellip.eccsq;
      var eccPrimeSquared;
      var e1 = (1 - Math.sqrt(1 - eccSquared)) / (1 + Math.sqrt(1 - eccSquared));
      var N1, T1, C1, R1, D, M;
      var LongOrigin;
      var mu, phi1Rad;

      // remove 500,000 meter offset for longitude
      var x = UTMEasting - 500000.0;
      var y = UTMNorthing;

      // We must know somehow if we are in the Northern or Southern
      // hemisphere, this is the only time we use the letter So even
      // if the Zone letter isn't exactly correct it should indicate
      // the hemisphere correctly
      if (zoneLetter < 'N') {
        y -= 10000000.0; // remove 10,000,000 meter offset used
        // for southern hemisphere
      }

      // There are 60 zones with zone 1 being at West -180 to -174
      LongOrigin = (zoneNumber - 1) * 6 - 180 + 3; // +3 puts origin
      // in middle of
      // zone

      eccPrimeSquared = (eccSquared) / (1 - eccSquared);

      M = y / k0;
      mu = M / (a * (1 - eccSquared / 4 - 3 * eccSquared * eccSquared / 64 - 5 * eccSquared * eccSquared * eccSquared / 256));

      phi1Rad = mu + (3 * e1 / 2 - 27 * e1 * e1 * e1 / 32) * Math.sin(2 * mu) + (21 * e1 * e1 / 16 - 55 * e1 * e1 * e1 * e1 / 32) * Math.sin(4 * mu) + (151 * e1 * e1 * e1 / 96) * Math.sin(6 * mu);
      // double phi1 = ProjMath.radToDeg(phi1Rad);

      N1 = a / Math.sqrt(1 - eccSquared * Math.sin(phi1Rad) * Math.sin(phi1Rad));
      T1 = Math.tan(phi1Rad) * Math.tan(phi1Rad);
      C1 = eccPrimeSquared * Math.cos(phi1Rad) * Math.cos(phi1Rad);
      R1 = a * (1 - eccSquared) / Math.pow(1 - eccSquared * Math.sin(phi1Rad) * Math.sin(phi1Rad), 1.5);
      D = x / (N1 * k0);

      var lat = phi1Rad - (N1 * Math.tan(phi1Rad) / R1) * (D * D / 2 - (5 + 3 * T1 + 10 * C1 - 4 * C1 * C1 - 9 * eccPrimeSquared) * D * D * D * D / 24 + (61 + 90 * T1 + 298 * C1 + 45 * T1 * T1 - 252 * eccPrimeSquared - 3 * C1 * C1) * D * D * D * D * D * D / 720);
      lat = radToDeg(lat);

      var lon = (D - (1 + 2 * T1 + C1) * D * D * D / 6 + (5 - 2 * C1 + 28 * T1 - 3 * C1 * C1 + 8 * eccPrimeSquared + 24 * T1 * T1) * D * D * D * D * D / 120) / Math.cos(phi1Rad);
      lon = LongOrigin + radToDeg(lon);

      var result;
      if (utm.accuracy) {
        var topRight = UTMtoLL({
          northing: utm.northing + utm.accuracy,
          easting: utm.easting + utm.accuracy,
          zoneLetter: utm.zoneLetter,
          zoneNumber: utm.zoneNumber
        });
        result = {
          top: topRight.lat,
          right: topRight.lon,
          bottom: lat,
          left: lon
        };
      }
      else {
        result = {
          lat: lat,
          lon: lon
        };
      }
      return result;
    }

    /**
     * Calculates the MGRS letter designator for the given latitude.
     *
     * @private
     * @param {number} lat The latitude in WGS84 to get the letter designator
     *     for.
     * @return {char} The letter designator.
     */
    function getLetterDesignator(lat) {
      //This is here as an error flag to show that the Latitude is
      //outside MGRS limits
      var LetterDesignator = 'Z';

      if ((84 >= lat) && (lat >= 72)) {
        LetterDesignator = 'X';
      }
      else if ((72 > lat) && (lat >= 64)) {
        LetterDesignator = 'W';
      }
      else if ((64 > lat) && (lat >= 56)) {
        LetterDesignator = 'V';
      }
      else if ((56 > lat) && (lat >= 48)) {
        LetterDesignator = 'U';
      }
      else if ((48 > lat) && (lat >= 40)) {
        LetterDesignator = 'T';
      }
      else if ((40 > lat) && (lat >= 32)) {
        LetterDesignator = 'S';
      }
      else if ((32 > lat) && (lat >= 24)) {
        LetterDesignator = 'R';
      }
      else if ((24 > lat) && (lat >= 16)) {
        LetterDesignator = 'Q';
      }
      else if ((16 > lat) && (lat >= 8)) {
        LetterDesignator = 'P';
      }
      else if ((8 > lat) && (lat >= 0)) {
        LetterDesignator = 'N';
      }
      else if ((0 > lat) && (lat >= -8)) {
        LetterDesignator = 'M';
      }
      else if ((-8 > lat) && (lat >= -16)) {
        LetterDesignator = 'L';
      }
      else if ((-16 > lat) && (lat >= -24)) {
        LetterDesignator = 'K';
      }
      else if ((-24 > lat) && (lat >= -32)) {
        LetterDesignator = 'J';
      }
      else if ((-32 > lat) && (lat >= -40)) {
        LetterDesignator = 'H';
      }
      else if ((-40 > lat) && (lat >= -48)) {
        LetterDesignator = 'G';
      }
      else if ((-48 > lat) && (lat >= -56)) {
        LetterDesignator = 'F';
      }
      else if ((-56 > lat) && (lat >= -64)) {
        LetterDesignator = 'E';
      }
      else if ((-64 > lat) && (lat >= -72)) {
        LetterDesignator = 'D';
      }
      else if ((-72 > lat) && (lat >= -80)) {
        LetterDesignator = 'C';
      }
      return LetterDesignator;
    }

    /**
     * Encodes a UTM location as MGRS string.
     *
     * @private
     * @param {object} utm An object literal with easting, northing,
     *     zoneLetter, zoneNumber
     * @param {number} accuracy Accuracy in digits (1-5).
     * @return {string} MGRS string for the given UTM location.
     */
    function encode(utm, accuracy) {
      // prepend with leading zeroes
      var seasting = "00000" + utm.easting,
        snorthing = "00000" + utm.northing;

      return utm.zoneNumber + utm.zoneLetter + get100kID(utm.easting, utm.northing, utm.zoneNumber) + seasting.substr(seasting.length - 5, accuracy) + snorthing.substr(snorthing.length - 5, accuracy);
    }

    /**
     * Get the two letter 100k designator for a given UTM easting,
     * northing and zone number value.
     *
     * @private
     * @param {number} easting
     * @param {number} northing
     * @param {number} zoneNumber
     * @return the two letter 100k designator for the given UTM location.
     */
    function get100kID(easting, northing, zoneNumber) {
      var setParm = get100kSetForZone(zoneNumber);
      var setColumn = Math.floor(easting / 100000);
      var setRow = Math.floor(northing / 100000) % 20;
      return getLetter100kID(setColumn, setRow, setParm);
    }

    /**
     * Given a UTM zone number, figure out the MGRS 100K set it is in.
     *
     * @private
     * @param {number} i An UTM zone number.
     * @return {number} the 100k set the UTM zone is in.
     */
    function get100kSetForZone(i) {
      var setParm = i % NUM_100K_SETS;
      if (setParm === 0) {
        setParm = NUM_100K_SETS;
      }

      return setParm;
    }

    /**
     * Get the two-letter MGRS 100k designator given information
     * translated from the UTM northing, easting and zone number.
     *
     * @private
     * @param {number} column the column index as it relates to the MGRS
     *        100k set spreadsheet, created from the UTM easting.
     *        Values are 1-8.
     * @param {number} row the row index as it relates to the MGRS 100k set
     *        spreadsheet, created from the UTM northing value. Values
     *        are from 0-19.
     * @param {number} parm the set block, as it relates to the MGRS 100k set
     *        spreadsheet, created from the UTM zone. Values are from
     *        1-60.
     * @return two letter MGRS 100k code.
     */
    function getLetter100kID(column, row, parm) {
      // colOrigin and rowOrigin are the letters at the origin of the set
      var index = parm - 1;
      var colOrigin = SET_ORIGIN_COLUMN_LETTERS.charCodeAt(index);
      var rowOrigin = SET_ORIGIN_ROW_LETTERS.charCodeAt(index);

      // colInt and rowInt are the letters to build to return
      var colInt = colOrigin + column - 1;
      var rowInt = rowOrigin + row;
      var rollover = false;

      if (colInt > Z) {
        colInt = colInt - Z + A - 1;
        rollover = true;
      }

      if (colInt === I || (colOrigin < I && colInt > I) || ((colInt > I || colOrigin < I) && rollover)) {
        colInt++;
      }

      if (colInt === O || (colOrigin < O && colInt > O) || ((colInt > O || colOrigin < O) && rollover)) {
        colInt++;

        if (colInt === I) {
          colInt++;
        }
      }

      if (colInt > Z) {
        colInt = colInt - Z + A - 1;
      }

      if (rowInt > V) {
        rowInt = rowInt - V + A - 1;
        rollover = true;
      }
      else {
        rollover = false;
      }

      if (((rowInt === I) || ((rowOrigin < I) && (rowInt > I))) || (((rowInt > I) || (rowOrigin < I)) && rollover)) {
        rowInt++;
      }

      if (((rowInt === O) || ((rowOrigin < O) && (rowInt > O))) || (((rowInt > O) || (rowOrigin < O)) && rollover)) {
        rowInt++;

        if (rowInt === I) {
          rowInt++;
        }
      }

      if (rowInt > V) {
        rowInt = rowInt - V + A - 1;
      }

      var twoLetter = String.fromCharCode(colInt) + String.fromCharCode(rowInt);
      return twoLetter;
    }

    /**
     * Decode the UTM parameters from a MGRS string.
     *
     * @private
     * @param {string} mgrsString an UPPERCASE coordinate string is expected.
     * @return {object} An object literal with easting, northing, zoneLetter,
     *     zoneNumber and accuracy (in meters) properties.
     */
    function decode(mgrsString) {

      if (mgrsString && mgrsString.length === 0) {
        throw ("MGRSPoint coverting from nothing");
      }

      var length = mgrsString.length;

      var hunK = null;
      var sb = "";
      var testChar;
      var i = 0;

      // get Zone number
      while (!(/[A-Z]/).test(testChar = mgrsString.charAt(i))) {
        if (i >= 2) {
          throw ("MGRSPoint bad conversion from: " + mgrsString);
        }
        sb += testChar;
        i++;
      }

      var zoneNumber = parseInt(sb, 10);

      if (i === 0 || i + 3 > length) {
        // A good MGRS string has to be 4-5 digits long,
        // ##AAA/#AAA at least.
        throw ("MGRSPoint bad conversion from: " + mgrsString);
      }

      var zoneLetter = mgrsString.charAt(i++);

      // Should we check the zone letter here? Why not.
      if (zoneLetter <= 'A' || zoneLetter === 'B' || zoneLetter === 'Y' || zoneLetter >= 'Z' || zoneLetter === 'I' || zoneLetter === 'O') {
        throw ("MGRSPoint zone letter " + zoneLetter + " not handled: " + mgrsString);
      }

      hunK = mgrsString.substring(i, i += 2);

      var set = get100kSetForZone(zoneNumber);

      var east100k = getEastingFromChar(hunK.charAt(0), set);
      var north100k = getNorthingFromChar(hunK.charAt(1), set);

      // We have a bug where the northing may be 2000000 too low.
      // How
      // do we know when to roll over?

      while (north100k < getMinNorthing(zoneLetter)) {
        north100k += 2000000;
      }

      // calculate the char index for easting/northing separator
      var remainder = length - i;

      if (remainder % 2 !== 0) {
        throw ("MGRSPoint has to have an even number \nof digits after the zone letter and two 100km letters - front \nhalf for easting meters, second half for \nnorthing meters" + mgrsString);
      }

      var sep = remainder / 2;

      var sepEasting = 0.0;
      var sepNorthing = 0.0;
      var accuracyBonus, sepEastingString, sepNorthingString, easting, northing;
      if (sep > 0) {
        accuracyBonus = 100000.0 / Math.pow(10, sep);
        sepEastingString = mgrsString.substring(i, i + sep);
        sepEasting = parseFloat(sepEastingString) * accuracyBonus;
        sepNorthingString = mgrsString.substring(i + sep);
        sepNorthing = parseFloat(sepNorthingString) * accuracyBonus;
      }

      easting = sepEasting + east100k;
      northing = sepNorthing + north100k;

      return {
        easting: easting,
        northing: northing,
        zoneLetter: zoneLetter,
        zoneNumber: zoneNumber,
        accuracy: accuracyBonus
      };
    }

    /**
     * Given the first letter from a two-letter MGRS 100k zone, and given the
     * MGRS table set for the zone number, figure out the easting value that
     * should be added to the other, secondary easting value.
     *
     * @private
     * @param {char} e The first letter from a two-letter MGRS 100´k zone.
     * @param {number} set The MGRS table set for the zone number.
     * @return {number} The easting value for the given letter and set.
     */
    function getEastingFromChar(e, set) {
      // colOrigin is the letter at the origin of the set for the
      // column
      var curCol = SET_ORIGIN_COLUMN_LETTERS.charCodeAt(set - 1);
      var eastingValue = 100000.0;
      var rewindMarker = false;

      while (curCol !== e.charCodeAt(0)) {
        curCol++;
        if (curCol === I) {
          curCol++;
        }
        if (curCol === O) {
          curCol++;
        }
        if (curCol > Z) {
          if (rewindMarker) {
            throw ("Bad character: " + e);
          }
          curCol = A;
          rewindMarker = true;
        }
        eastingValue += 100000.0;
      }

      return eastingValue;
    }

    /**
     * Given the second letter from a two-letter MGRS 100k zone, and given the
     * MGRS table set for the zone number, figure out the northing value that
     * should be added to the other, secondary northing value. You have to
     * remember that Northings are determined from the equator, and the vertical
     * cycle of letters mean a 2000000 additional northing meters. This happens
     * approx. every 18 degrees of latitude. This method does *NOT* count any
     * additional northings. You have to figure out how many 2000000 meters need
     * to be added for the zone letter of the MGRS coordinate.
     *
     * @private
     * @param {char} n Second letter of the MGRS 100k zone
     * @param {number} set The MGRS table set number, which is dependent on the
     *     UTM zone number.
     * @return {number} The northing value for the given letter and set.
     */
    function getNorthingFromChar(n, set) {

      if (n > 'V') {
        throw ("MGRSPoint given invalid Northing " + n);
      }

      // rowOrigin is the letter at the origin of the set for the
      // column
      var curRow = SET_ORIGIN_ROW_LETTERS.charCodeAt(set - 1);
      var northingValue = 0.0;
      var rewindMarker = false;

      while (curRow !== n.charCodeAt(0)) {
        curRow++;
        if (curRow === I) {
          curRow++;
        }
        if (curRow === O) {
          curRow++;
        }
        // fixing a bug making whole application hang in this loop
        // when 'n' is a wrong character
        if (curRow > V) {
          if (rewindMarker) { // making sure that this loop ends
            throw ("Bad character: " + n);
          }
          curRow = A;
          rewindMarker = true;
        }
        northingValue += 100000.0;
      }

      return northingValue;
    }

    /**
     * The function getMinNorthing returns the minimum northing value of a MGRS
     * zone.
     *
     * Ported from Geotrans' c Lattitude_Band_Value structure table.
     *
     * @private
     * @param {char} zoneLetter The MGRS zone to get the min northing for.
     * @return {number}
     */
    function getMinNorthing(zoneLetter) {
      var northing;
      switch (zoneLetter) {
      case 'C':
        northing = 1100000.0;
        break;
      case 'D':
        northing = 2000000.0;
        break;
      case 'E':
        northing = 2800000.0;
        break;
      case 'F':
        northing = 3700000.0;
        break;
      case 'G':
        northing = 4600000.0;
        break;
      case 'H':
        northing = 5500000.0;
        break;
      case 'J':
        northing = 6400000.0;
        break;
      case 'K':
        northing = 7300000.0;
        break;
      case 'L':
        northing = 8200000.0;
        break;
      case 'M':
        northing = 9100000.0;
        break;
      case 'N':
        northing = 0.0;
        break;
      case 'P':
        northing = 800000.0;
        break;
      case 'Q':
        northing = 1700000.0;
        break;
      case 'R':
        northing = 2600000.0;
        break;
      case 'S':
        northing = 3500000.0;
        break;
      case 'T':
        northing = 4400000.0;
        break;
      case 'U':
        northing = 5300000.0;
        break;
      case 'V':
        northing = 6200000.0;
        break;
      case 'W':
        northing = 7000000.0;
        break;
      case 'X':
        northing = 7900000.0;
        break;
      default:
        northing = -1.0;
      }
      if (northing >= 0.0) {
        return northing;
      }
      else {
        throw ("Invalid zone letter: " + zoneLetter);
      }

    }

    function Point(x, y, z) {
      if (!(this instanceof Point)) {
        return new Point(x, y, z);
      }
      if (Array.isArray(x)) {
        this.x = x[0];
        this.y = x[1];
        this.z = x[2] || 0.0;
      } else if(typeof x === 'object') {
        this.x = x.x;
        this.y = x.y;
        this.z = x.z || 0.0;
      } else if (typeof x === 'string' && typeof y === 'undefined') {
        var coords = x.split(',');
        this.x = parseFloat(coords[0], 10);
        this.y = parseFloat(coords[1], 10);
        this.z = parseFloat(coords[2], 10) || 0.0;
      } else {
        this.x = x;
        this.y = y;
        this.z = z || 0.0;
      }
      console.warn('proj4.Point will be removed in version 3, use proj4.toPoint');
    }

    Point.fromMGRS = function(mgrsStr) {
      return new Point(toPoint$1(mgrsStr));
    };
    Point.prototype.toMGRS = function(accuracy) {
      return forward$1([this.x, this.y], accuracy);
    };

    var C00 = 1;
    var C02 = 0.25;
    var C04 = 0.046875;
    var C06 = 0.01953125;
    var C08 = 0.01068115234375;
    var C22 = 0.75;
    var C44 = 0.46875;
    var C46 = 0.01302083333333333333;
    var C48 = 0.00712076822916666666;
    var C66 = 0.36458333333333333333;
    var C68 = 0.00569661458333333333;
    var C88 = 0.3076171875;

    var pj_enfn = function(es) {
      var en = [];
      en[0] = C00 - es * (C02 + es * (C04 + es * (C06 + es * C08)));
      en[1] = es * (C22 - es * (C04 + es * (C06 + es * C08)));
      var t = es * es;
      en[2] = t * (C44 - es * (C46 + es * C48));
      t *= es;
      en[3] = t * (C66 - es * C68);
      en[4] = t * es * C88;
      return en;
    };

    var pj_mlfn = function(phi, sphi, cphi, en) {
      cphi *= sphi;
      sphi *= sphi;
      return (en[0] * phi - cphi * (en[1] + sphi * (en[2] + sphi * (en[3] + sphi * en[4]))));
    };

    var MAX_ITER = 20;

    var pj_inv_mlfn = function(arg, es, en) {
      var k = 1 / (1 - es);
      var phi = arg;
      for (var i = MAX_ITER; i; --i) { /* rarely goes over 2 iterations */
        var s = Math.sin(phi);
        var t = 1 - es * s * s;
        //t = this.pj_mlfn(phi, s, Math.cos(phi), en) - arg;
        //phi -= t * (t * Math.sqrt(t)) * k;
        t = (pj_mlfn(phi, s, Math.cos(phi), en) - arg) * (t * Math.sqrt(t)) * k;
        phi -= t;
        if (Math.abs(t) < EPSLN) {
          return phi;
        }
      }
      //..reportError("cass:pj_inv_mlfn: Convergence error");
      return phi;
    };

    // Heavily based on this tmerc projection implementation
    // https://github.com/mbloch/mapshaper-proj/blob/master/src/projections/tmerc.js

    function init$2() {
      this.x0 = this.x0 !== undefined ? this.x0 : 0;
      this.y0 = this.y0 !== undefined ? this.y0 : 0;
      this.long0 = this.long0 !== undefined ? this.long0 : 0;
      this.lat0 = this.lat0 !== undefined ? this.lat0 : 0;

      if (this.es) {
        this.en = pj_enfn(this.es);
        this.ml0 = pj_mlfn(this.lat0, Math.sin(this.lat0), Math.cos(this.lat0), this.en);
      }
    }

    /**
        Transverse Mercator Forward  - long/lat to x/y
        long/lat in radians
      */
    function forward$2(p) {
      var lon = p.x;
      var lat = p.y;

      var delta_lon = adjust_lon(lon - this.long0);
      var con;
      var x, y;
      var sin_phi = Math.sin(lat);
      var cos_phi = Math.cos(lat);

      if (!this.es) {
        var b = cos_phi * Math.sin(delta_lon);

        if ((Math.abs(Math.abs(b) - 1)) < EPSLN) {
          return (93);
        }
        else {
          x = 0.5 * this.a * this.k0 * Math.log((1 + b) / (1 - b)) + this.x0;
          y = cos_phi * Math.cos(delta_lon) / Math.sqrt(1 - Math.pow(b, 2));
          b = Math.abs(y);

          if (b >= 1) {
            if ((b - 1) > EPSLN) {
              return (93);
            }
            else {
              y = 0;
            }
          }
          else {
            y = Math.acos(y);
          }

          if (lat < 0) {
            y = -y;
          }

          y = this.a * this.k0 * (y - this.lat0) + this.y0;
        }
      }
      else {
        var al = cos_phi * delta_lon;
        var als = Math.pow(al, 2);
        var c = this.ep2 * Math.pow(cos_phi, 2);
        var cs = Math.pow(c, 2);
        var tq = Math.abs(cos_phi) > EPSLN ? Math.tan(lat) : 0;
        var t = Math.pow(tq, 2);
        var ts = Math.pow(t, 2);
        con = 1 - this.es * Math.pow(sin_phi, 2);
        al = al / Math.sqrt(con);
        var ml = pj_mlfn(lat, sin_phi, cos_phi, this.en);

        x = this.a * (this.k0 * al * (1 +
          als / 6 * (1 - t + c +
          als / 20 * (5 - 18 * t + ts + 14 * c - 58 * t * c +
          als / 42 * (61 + 179 * ts - ts * t - 479 * t))))) +
          this.x0;

        y = this.a * (this.k0 * (ml - this.ml0 +
          sin_phi * delta_lon * al / 2 * (1 +
          als / 12 * (5 - t + 9 * c + 4 * cs +
          als / 30 * (61 + ts - 58 * t + 270 * c - 330 * t * c +
          als / 56 * (1385 + 543 * ts - ts * t - 3111 * t)))))) +
          this.y0;
      }

      p.x = x;
      p.y = y;

      return p;
    }

    /**
        Transverse Mercator Inverse  -  x/y to long/lat
      */
    function inverse$2(p) {
      var con, phi;
      var lat, lon;
      var x = (p.x - this.x0) * (1 / this.a);
      var y = (p.y - this.y0) * (1 / this.a);

      if (!this.es) {
        var f = Math.exp(x / this.k0);
        var g = 0.5 * (f - 1 / f);
        var temp = this.lat0 + y / this.k0;
        var h = Math.cos(temp);
        con = Math.sqrt((1 - Math.pow(h, 2)) / (1 + Math.pow(g, 2)));
        lat = Math.asin(con);

        if (y < 0) {
          lat = -lat;
        }

        if ((g === 0) && (h === 0)) {
          lon = 0;
        }
        else {
          lon = adjust_lon(Math.atan2(g, h) + this.long0);
        }
      }
      else { // ellipsoidal form
        con = this.ml0 + y / this.k0;
        phi = pj_inv_mlfn(con, this.es, this.en);

        if (Math.abs(phi) < HALF_PI) {
          var sin_phi = Math.sin(phi);
          var cos_phi = Math.cos(phi);
          var tan_phi = Math.abs(cos_phi) > EPSLN ? Math.tan(phi) : 0;
          var c = this.ep2 * Math.pow(cos_phi, 2);
          var cs = Math.pow(c, 2);
          var t = Math.pow(tan_phi, 2);
          var ts = Math.pow(t, 2);
          con = 1 - this.es * Math.pow(sin_phi, 2);
          var d = x * Math.sqrt(con) / this.k0;
          var ds = Math.pow(d, 2);
          con = con * tan_phi;

          lat = phi - (con * ds / (1 - this.es)) * 0.5 * (1 -
            ds / 12 * (5 + 3 * t - 9 * c * t + c - 4 * cs -
            ds / 30 * (61 + 90 * t - 252 * c * t + 45 * ts + 46 * c -
            ds / 56 * (1385 + 3633 * t + 4095 * ts + 1574 * ts * t))));

          lon = adjust_lon(this.long0 + (d * (1 -
            ds / 6 * (1 + 2 * t + c -
            ds / 20 * (5 + 28 * t + 24 * ts + 8 * c * t + 6 * c -
            ds / 42 * (61 + 662 * t + 1320 * ts + 720 * ts * t)))) / cos_phi));
        }
        else {
          lat = HALF_PI * sign(y);
          lon = 0;
        }
      }

      p.x = lon;
      p.y = lat;

      return p;
    }

    var names$3 = ["Fast_Transverse_Mercator", "Fast Transverse Mercator"];
    var tmerc = {
      init: init$2,
      forward: forward$2,
      inverse: inverse$2,
      names: names$3
    };

    var sinh = function(x) {
      var r = Math.exp(x);
      r = (r - 1 / r) / 2;
      return r;
    };

    var hypot = function(x, y) {
      x = Math.abs(x);
      y = Math.abs(y);
      var a = Math.max(x, y);
      var b = Math.min(x, y) / (a ? a : 1);

      return a * Math.sqrt(1 + Math.pow(b, 2));
    };

    var log1py = function(x) {
      var y = 1 + x;
      var z = y - 1;

      return z === 0 ? x : x * Math.log(y) / z;
    };

    var asinhy = function(x) {
      var y = Math.abs(x);
      y = log1py(y * (1 + y / (hypot(1, y) + 1)));

      return x < 0 ? -y : y;
    };

    var gatg = function(pp, B) {
      var cos_2B = 2 * Math.cos(2 * B);
      var i = pp.length - 1;
      var h1 = pp[i];
      var h2 = 0;
      var h;

      while (--i >= 0) {
        h = -h2 + cos_2B * h1 + pp[i];
        h2 = h1;
        h1 = h;
      }

      return (B + h * Math.sin(2 * B));
    };

    var clens = function(pp, arg_r) {
      var r = 2 * Math.cos(arg_r);
      var i = pp.length - 1;
      var hr1 = pp[i];
      var hr2 = 0;
      var hr;

      while (--i >= 0) {
        hr = -hr2 + r * hr1 + pp[i];
        hr2 = hr1;
        hr1 = hr;
      }

      return Math.sin(arg_r) * hr;
    };

    var cosh = function(x) {
      var r = Math.exp(x);
      r = (r + 1 / r) / 2;
      return r;
    };

    var clens_cmplx = function(pp, arg_r, arg_i) {
      var sin_arg_r = Math.sin(arg_r);
      var cos_arg_r = Math.cos(arg_r);
      var sinh_arg_i = sinh(arg_i);
      var cosh_arg_i = cosh(arg_i);
      var r = 2 * cos_arg_r * cosh_arg_i;
      var i = -2 * sin_arg_r * sinh_arg_i;
      var j = pp.length - 1;
      var hr = pp[j];
      var hi1 = 0;
      var hr1 = 0;
      var hi = 0;
      var hr2;
      var hi2;

      while (--j >= 0) {
        hr2 = hr1;
        hi2 = hi1;
        hr1 = hr;
        hi1 = hi;
        hr = -hr2 + r * hr1 - i * hi1 + pp[j];
        hi = -hi2 + i * hr1 + r * hi1;
      }

      r = sin_arg_r * cosh_arg_i;
      i = cos_arg_r * sinh_arg_i;

      return [r * hr - i * hi, r * hi + i * hr];
    };

    // Heavily based on this etmerc projection implementation
    // https://github.com/mbloch/mapshaper-proj/blob/master/src/projections/etmerc.js

    function init$3() {
      if (!this.approx && (isNaN(this.es) || this.es <= 0)) {
        throw new Error('Incorrect elliptical usage. Try using the +approx option in the proj string, or PROJECTION["Fast_Transverse_Mercator"] in the WKT.');
      }
      if (this.approx) {
        // When '+approx' is set, use tmerc instead
        tmerc.init.apply(this);
        this.forward = tmerc.forward;
        this.inverse = tmerc.inverse;
      }

      this.x0 = this.x0 !== undefined ? this.x0 : 0;
      this.y0 = this.y0 !== undefined ? this.y0 : 0;
      this.long0 = this.long0 !== undefined ? this.long0 : 0;
      this.lat0 = this.lat0 !== undefined ? this.lat0 : 0;

      this.cgb = [];
      this.cbg = [];
      this.utg = [];
      this.gtu = [];

      var f = this.es / (1 + Math.sqrt(1 - this.es));
      var n = f / (2 - f);
      var np = n;

      this.cgb[0] = n * (2 + n * (-2 / 3 + n * (-2 + n * (116 / 45 + n * (26 / 45 + n * (-2854 / 675 ))))));
      this.cbg[0] = n * (-2 + n * ( 2 / 3 + n * ( 4 / 3 + n * (-82 / 45 + n * (32 / 45 + n * (4642 / 4725))))));

      np = np * n;
      this.cgb[1] = np * (7 / 3 + n * (-8 / 5 + n * (-227 / 45 + n * (2704 / 315 + n * (2323 / 945)))));
      this.cbg[1] = np * (5 / 3 + n * (-16 / 15 + n * ( -13 / 9 + n * (904 / 315 + n * (-1522 / 945)))));

      np = np * n;
      this.cgb[2] = np * (56 / 15 + n * (-136 / 35 + n * (-1262 / 105 + n * (73814 / 2835))));
      this.cbg[2] = np * (-26 / 15 + n * (34 / 21 + n * (8 / 5 + n * (-12686 / 2835))));

      np = np * n;
      this.cgb[3] = np * (4279 / 630 + n * (-332 / 35 + n * (-399572 / 14175)));
      this.cbg[3] = np * (1237 / 630 + n * (-12 / 5 + n * ( -24832 / 14175)));

      np = np * n;
      this.cgb[4] = np * (4174 / 315 + n * (-144838 / 6237));
      this.cbg[4] = np * (-734 / 315 + n * (109598 / 31185));

      np = np * n;
      this.cgb[5] = np * (601676 / 22275);
      this.cbg[5] = np * (444337 / 155925);

      np = Math.pow(n, 2);
      this.Qn = this.k0 / (1 + n) * (1 + np * (1 / 4 + np * (1 / 64 + np / 256)));

      this.utg[0] = n * (-0.5 + n * ( 2 / 3 + n * (-37 / 96 + n * ( 1 / 360 + n * (81 / 512 + n * (-96199 / 604800))))));
      this.gtu[0] = n * (0.5 + n * (-2 / 3 + n * (5 / 16 + n * (41 / 180 + n * (-127 / 288 + n * (7891 / 37800))))));

      this.utg[1] = np * (-1 / 48 + n * (-1 / 15 + n * (437 / 1440 + n * (-46 / 105 + n * (1118711 / 3870720)))));
      this.gtu[1] = np * (13 / 48 + n * (-3 / 5 + n * (557 / 1440 + n * (281 / 630 + n * (-1983433 / 1935360)))));

      np = np * n;
      this.utg[2] = np * (-17 / 480 + n * (37 / 840 + n * (209 / 4480 + n * (-5569 / 90720 ))));
      this.gtu[2] = np * (61 / 240 + n * (-103 / 140 + n * (15061 / 26880 + n * (167603 / 181440))));

      np = np * n;
      this.utg[3] = np * (-4397 / 161280 + n * (11 / 504 + n * (830251 / 7257600)));
      this.gtu[3] = np * (49561 / 161280 + n * (-179 / 168 + n * (6601661 / 7257600)));

      np = np * n;
      this.utg[4] = np * (-4583 / 161280 + n * (108847 / 3991680));
      this.gtu[4] = np * (34729 / 80640 + n * (-3418889 / 1995840));

      np = np * n;
      this.utg[5] = np * (-20648693 / 638668800);
      this.gtu[5] = np * (212378941 / 319334400);

      var Z = gatg(this.cbg, this.lat0);
      this.Zb = -this.Qn * (Z + clens(this.gtu, 2 * Z));
    }

    function forward$3(p) {
      var Ce = adjust_lon(p.x - this.long0);
      var Cn = p.y;

      Cn = gatg(this.cbg, Cn);
      var sin_Cn = Math.sin(Cn);
      var cos_Cn = Math.cos(Cn);
      var sin_Ce = Math.sin(Ce);
      var cos_Ce = Math.cos(Ce);

      Cn = Math.atan2(sin_Cn, cos_Ce * cos_Cn);
      Ce = Math.atan2(sin_Ce * cos_Cn, hypot(sin_Cn, cos_Cn * cos_Ce));
      Ce = asinhy(Math.tan(Ce));

      var tmp = clens_cmplx(this.gtu, 2 * Cn, 2 * Ce);

      Cn = Cn + tmp[0];
      Ce = Ce + tmp[1];

      var x;
      var y;

      if (Math.abs(Ce) <= 2.623395162778) {
        x = this.a * (this.Qn * Ce) + this.x0;
        y = this.a * (this.Qn * Cn + this.Zb) + this.y0;
      }
      else {
        x = Infinity;
        y = Infinity;
      }

      p.x = x;
      p.y = y;

      return p;
    }

    function inverse$3(p) {
      var Ce = (p.x - this.x0) * (1 / this.a);
      var Cn = (p.y - this.y0) * (1 / this.a);

      Cn = (Cn - this.Zb) / this.Qn;
      Ce = Ce / this.Qn;

      var lon;
      var lat;

      if (Math.abs(Ce) <= 2.623395162778) {
        var tmp = clens_cmplx(this.utg, 2 * Cn, 2 * Ce);

        Cn = Cn + tmp[0];
        Ce = Ce + tmp[1];
        Ce = Math.atan(sinh(Ce));

        var sin_Cn = Math.sin(Cn);
        var cos_Cn = Math.cos(Cn);
        var sin_Ce = Math.sin(Ce);
        var cos_Ce = Math.cos(Ce);

        Cn = Math.atan2(sin_Cn * cos_Ce, hypot(sin_Ce, cos_Ce * cos_Cn));
        Ce = Math.atan2(sin_Ce, cos_Ce * cos_Cn);

        lon = adjust_lon(Ce + this.long0);
        lat = gatg(this.cgb, Cn);
      }
      else {
        lon = Infinity;
        lat = Infinity;
      }

      p.x = lon;
      p.y = lat;

      return p;
    }

    var names$4 = ["Extended_Transverse_Mercator", "Extended Transverse Mercator", "etmerc", "Transverse_Mercator", "Transverse Mercator", "Gauss Kruger", "Gauss_Kruger", "tmerc"];
    var etmerc = {
      init: init$3,
      forward: forward$3,
      inverse: inverse$3,
      names: names$4
    };

    var adjust_zone = function(zone, lon) {
      if (zone === undefined) {
        zone = Math.floor((adjust_lon(lon) + Math.PI) * 30 / Math.PI) + 1;

        if (zone < 0) {
          return 0;
        } else if (zone > 60) {
          return 60;
        }
      }
      return zone;
    };

    var dependsOn = 'etmerc';
    function init$4() {
      var zone = adjust_zone(this.zone, this.long0);
      if (zone === undefined) {
        throw new Error('unknown utm zone');
      }
      this.lat0 = 0;
      this.long0 =  ((6 * Math.abs(zone)) - 183) * D2R;
      this.x0 = 500000;
      this.y0 = this.utmSouth ? 10000000 : 0;
      this.k0 = 0.9996;

      etmerc.init.apply(this);
      this.forward = etmerc.forward;
      this.inverse = etmerc.inverse;
    }

    var names$5 = ["Universal Transverse Mercator System", "utm"];
    var utm = {
      init: init$4,
      names: names$5,
      dependsOn: dependsOn
    };

    var srat = function(esinp, exp) {
      return (Math.pow((1 - esinp) / (1 + esinp), exp));
    };

    var MAX_ITER$1 = 20;
    function init$6() {
      var sphi = Math.sin(this.lat0);
      var cphi = Math.cos(this.lat0);
      cphi *= cphi;
      this.rc = Math.sqrt(1 - this.es) / (1 - this.es * sphi * sphi);
      this.C = Math.sqrt(1 + this.es * cphi * cphi / (1 - this.es));
      this.phic0 = Math.asin(sphi / this.C);
      this.ratexp = 0.5 * this.C * this.e;
      this.K = Math.tan(0.5 * this.phic0 + FORTPI) / (Math.pow(Math.tan(0.5 * this.lat0 + FORTPI), this.C) * srat(this.e * sphi, this.ratexp));
    }

    function forward$5(p) {
      var lon = p.x;
      var lat = p.y;

      p.y = 2 * Math.atan(this.K * Math.pow(Math.tan(0.5 * lat + FORTPI), this.C) * srat(this.e * Math.sin(lat), this.ratexp)) - HALF_PI;
      p.x = this.C * lon;
      return p;
    }

    function inverse$5(p) {
      var DEL_TOL = 1e-14;
      var lon = p.x / this.C;
      var lat = p.y;
      var num = Math.pow(Math.tan(0.5 * lat + FORTPI) / this.K, 1 / this.C);
      for (var i = MAX_ITER$1; i > 0; --i) {
        lat = 2 * Math.atan(num * srat(this.e * Math.sin(p.y), - 0.5 * this.e)) - HALF_PI;
        if (Math.abs(lat - p.y) < DEL_TOL) {
          break;
        }
        p.y = lat;
      }
      /* convergence failed */
      if (!i) {
        return null;
      }
      p.x = lon;
      p.y = lat;
      return p;
    }

    var names$7 = ["gauss"];
    var gauss = {
      init: init$6,
      forward: forward$5,
      inverse: inverse$5,
      names: names$7
    };

    function init$5() {
      gauss.init.apply(this);
      if (!this.rc) {
        return;
      }
      this.sinc0 = Math.sin(this.phic0);
      this.cosc0 = Math.cos(this.phic0);
      this.R2 = 2 * this.rc;
      if (!this.title) {
        this.title = "Oblique Stereographic Alternative";
      }
    }

    function forward$4(p) {
      var sinc, cosc, cosl, k;
      p.x = adjust_lon(p.x - this.long0);
      gauss.forward.apply(this, [p]);
      sinc = Math.sin(p.y);
      cosc = Math.cos(p.y);
      cosl = Math.cos(p.x);
      k = this.k0 * this.R2 / (1 + this.sinc0 * sinc + this.cosc0 * cosc * cosl);
      p.x = k * cosc * Math.sin(p.x);
      p.y = k * (this.cosc0 * sinc - this.sinc0 * cosc * cosl);
      p.x = this.a * p.x + this.x0;
      p.y = this.a * p.y + this.y0;
      return p;
    }

    function inverse$4(p) {
      var sinc, cosc, lon, lat, rho;
      p.x = (p.x - this.x0) / this.a;
      p.y = (p.y - this.y0) / this.a;

      p.x /= this.k0;
      p.y /= this.k0;
      if ((rho = hypot(p.x, p.y))) {
        var c = 2 * Math.atan2(rho, this.R2);
        sinc = Math.sin(c);
        cosc = Math.cos(c);
        lat = Math.asin(cosc * this.sinc0 + p.y * sinc * this.cosc0 / rho);
        lon = Math.atan2(p.x * sinc, rho * this.cosc0 * cosc - p.y * this.sinc0 * sinc);
      }
      else {
        lat = this.phic0;
        lon = 0;
      }

      p.x = lon;
      p.y = lat;
      gauss.inverse.apply(this, [p]);
      p.x = adjust_lon(p.x + this.long0);
      return p;
    }

    var names$6 = ["Stereographic_North_Pole", "Oblique_Stereographic", "sterea","Oblique Stereographic Alternative","Double_Stereographic"];
    var sterea = {
      init: init$5,
      forward: forward$4,
      inverse: inverse$4,
      names: names$6
    };

    function ssfn_(phit, sinphi, eccen) {
      sinphi *= eccen;
      return (Math.tan(0.5 * (HALF_PI + phit)) * Math.pow((1 - sinphi) / (1 + sinphi), 0.5 * eccen));
    }

    function init$7() {

      // setting default parameters
      this.x0 = this.x0 || 0;
      this.y0 = this.y0 || 0;
      this.lat0 = this.lat0 || 0;
      this.long0 = this.long0 || 0;

      this.coslat0 = Math.cos(this.lat0);
      this.sinlat0 = Math.sin(this.lat0);
      if (this.sphere) {
        if (this.k0 === 1 && !isNaN(this.lat_ts) && Math.abs(this.coslat0) <= EPSLN) {
          this.k0 = 0.5 * (1 + sign(this.lat0) * Math.sin(this.lat_ts));
        }
      }
      else {
        if (Math.abs(this.coslat0) <= EPSLN) {
          if (this.lat0 > 0) {
            //North pole
            //trace('stere:north pole');
            this.con = 1;
          }
          else {
            //South pole
            //trace('stere:south pole');
            this.con = -1;
          }
        }
        this.cons = Math.sqrt(Math.pow(1 + this.e, 1 + this.e) * Math.pow(1 - this.e, 1 - this.e));
        if (this.k0 === 1 && !isNaN(this.lat_ts) && Math.abs(this.coslat0) <= EPSLN && Math.abs(Math.cos(this.lat_ts)) > EPSLN) {
          // When k0 is 1 (default value) and lat_ts is a vaild number and lat0 is at a pole and lat_ts is not at a pole
          // Recalculate k0 using formula 21-35 from p161 of Snyder, 1987
          this.k0 = 0.5 * this.cons * msfnz(this.e, Math.sin(this.lat_ts), Math.cos(this.lat_ts)) / tsfnz(this.e, this.con * this.lat_ts, this.con * Math.sin(this.lat_ts));
        }
        this.ms1 = msfnz(this.e, this.sinlat0, this.coslat0);
        this.X0 = 2 * Math.atan(this.ssfn_(this.lat0, this.sinlat0, this.e)) - HALF_PI;
        this.cosX0 = Math.cos(this.X0);
        this.sinX0 = Math.sin(this.X0);
      }
    }

    // Stereographic forward equations--mapping lat,long to x,y
    function forward$6(p) {
      var lon = p.x;
      var lat = p.y;
      var sinlat = Math.sin(lat);
      var coslat = Math.cos(lat);
      var A, X, sinX, cosX, ts, rh;
      var dlon = adjust_lon(lon - this.long0);

      if (Math.abs(Math.abs(lon - this.long0) - Math.PI) <= EPSLN && Math.abs(lat + this.lat0) <= EPSLN) {
        //case of the origine point
        //trace('stere:this is the origin point');
        p.x = NaN;
        p.y = NaN;
        return p;
      }
      if (this.sphere) {
        //trace('stere:sphere case');
        A = 2 * this.k0 / (1 + this.sinlat0 * sinlat + this.coslat0 * coslat * Math.cos(dlon));
        p.x = this.a * A * coslat * Math.sin(dlon) + this.x0;
        p.y = this.a * A * (this.coslat0 * sinlat - this.sinlat0 * coslat * Math.cos(dlon)) + this.y0;
        return p;
      }
      else {
        X = 2 * Math.atan(this.ssfn_(lat, sinlat, this.e)) - HALF_PI;
        cosX = Math.cos(X);
        sinX = Math.sin(X);
        if (Math.abs(this.coslat0) <= EPSLN) {
          ts = tsfnz(this.e, lat * this.con, this.con * sinlat);
          rh = 2 * this.a * this.k0 * ts / this.cons;
          p.x = this.x0 + rh * Math.sin(lon - this.long0);
          p.y = this.y0 - this.con * rh * Math.cos(lon - this.long0);
          //trace(p.toString());
          return p;
        }
        else if (Math.abs(this.sinlat0) < EPSLN) {
          //Eq
          //trace('stere:equateur');
          A = 2 * this.a * this.k0 / (1 + cosX * Math.cos(dlon));
          p.y = A * sinX;
        }
        else {
          //other case
          //trace('stere:normal case');
          A = 2 * this.a * this.k0 * this.ms1 / (this.cosX0 * (1 + this.sinX0 * sinX + this.cosX0 * cosX * Math.cos(dlon)));
          p.y = A * (this.cosX0 * sinX - this.sinX0 * cosX * Math.cos(dlon)) + this.y0;
        }
        p.x = A * cosX * Math.sin(dlon) + this.x0;
      }
      //trace(p.toString());
      return p;
    }

    //* Stereographic inverse equations--mapping x,y to lat/long
    function inverse$6(p) {
      p.x -= this.x0;
      p.y -= this.y0;
      var lon, lat, ts, ce, Chi;
      var rh = Math.sqrt(p.x * p.x + p.y * p.y);
      if (this.sphere) {
        var c = 2 * Math.atan(rh / (2 * this.a * this.k0));
        lon = this.long0;
        lat = this.lat0;
        if (rh <= EPSLN) {
          p.x = lon;
          p.y = lat;
          return p;
        }
        lat = Math.asin(Math.cos(c) * this.sinlat0 + p.y * Math.sin(c) * this.coslat0 / rh);
        if (Math.abs(this.coslat0) < EPSLN) {
          if (this.lat0 > 0) {
            lon = adjust_lon(this.long0 + Math.atan2(p.x, - 1 * p.y));
          }
          else {
            lon = adjust_lon(this.long0 + Math.atan2(p.x, p.y));
          }
        }
        else {
          lon = adjust_lon(this.long0 + Math.atan2(p.x * Math.sin(c), rh * this.coslat0 * Math.cos(c) - p.y * this.sinlat0 * Math.sin(c)));
        }
        p.x = lon;
        p.y = lat;
        return p;
      }
      else {
        if (Math.abs(this.coslat0) <= EPSLN) {
          if (rh <= EPSLN) {
            lat = this.lat0;
            lon = this.long0;
            p.x = lon;
            p.y = lat;
            //trace(p.toString());
            return p;
          }
          p.x *= this.con;
          p.y *= this.con;
          ts = rh * this.cons / (2 * this.a * this.k0);
          lat = this.con * phi2z(this.e, ts);
          lon = this.con * adjust_lon(this.con * this.long0 + Math.atan2(p.x, - 1 * p.y));
        }
        else {
          ce = 2 * Math.atan(rh * this.cosX0 / (2 * this.a * this.k0 * this.ms1));
          lon = this.long0;
          if (rh <= EPSLN) {
            Chi = this.X0;
          }
          else {
            Chi = Math.asin(Math.cos(ce) * this.sinX0 + p.y * Math.sin(ce) * this.cosX0 / rh);
            lon = adjust_lon(this.long0 + Math.atan2(p.x * Math.sin(ce), rh * this.cosX0 * Math.cos(ce) - p.y * this.sinX0 * Math.sin(ce)));
          }
          lat = -1 * phi2z(this.e, Math.tan(0.5 * (HALF_PI + Chi)));
        }
      }
      p.x = lon;
      p.y = lat;

      //trace(p.toString());
      return p;

    }

    var names$8 = ["stere", "Stereographic_South_Pole", "Polar Stereographic (variant B)", "Polar_Stereographic"];
    var stere = {
      init: init$7,
      forward: forward$6,
      inverse: inverse$6,
      names: names$8,
      ssfn_: ssfn_
    };

    /*
      references:
        Formules et constantes pour le Calcul pour la
        projection cylindrique conforme à axe oblique et pour la transformation entre
        des systèmes de référence.
        http://www.swisstopo.admin.ch/internet/swisstopo/fr/home/topics/survey/sys/refsys/switzerland.parsysrelated1.31216.downloadList.77004.DownloadFile.tmp/swissprojectionfr.pdf
      */

    function init$8() {
      var phy0 = this.lat0;
      this.lambda0 = this.long0;
      var sinPhy0 = Math.sin(phy0);
      var semiMajorAxis = this.a;
      var invF = this.rf;
      var flattening = 1 / invF;
      var e2 = 2 * flattening - Math.pow(flattening, 2);
      var e = this.e = Math.sqrt(e2);
      this.R = this.k0 * semiMajorAxis * Math.sqrt(1 - e2) / (1 - e2 * Math.pow(sinPhy0, 2));
      this.alpha = Math.sqrt(1 + e2 / (1 - e2) * Math.pow(Math.cos(phy0), 4));
      this.b0 = Math.asin(sinPhy0 / this.alpha);
      var k1 = Math.log(Math.tan(Math.PI / 4 + this.b0 / 2));
      var k2 = Math.log(Math.tan(Math.PI / 4 + phy0 / 2));
      var k3 = Math.log((1 + e * sinPhy0) / (1 - e * sinPhy0));
      this.K = k1 - this.alpha * k2 + this.alpha * e / 2 * k3;
    }

    function forward$7(p) {
      var Sa1 = Math.log(Math.tan(Math.PI / 4 - p.y / 2));
      var Sa2 = this.e / 2 * Math.log((1 + this.e * Math.sin(p.y)) / (1 - this.e * Math.sin(p.y)));
      var S = -this.alpha * (Sa1 + Sa2) + this.K;

      // spheric latitude
      var b = 2 * (Math.atan(Math.exp(S)) - Math.PI / 4);

      // spheric longitude
      var I = this.alpha * (p.x - this.lambda0);

      // psoeudo equatorial rotation
      var rotI = Math.atan(Math.sin(I) / (Math.sin(this.b0) * Math.tan(b) + Math.cos(this.b0) * Math.cos(I)));

      var rotB = Math.asin(Math.cos(this.b0) * Math.sin(b) - Math.sin(this.b0) * Math.cos(b) * Math.cos(I));

      p.y = this.R / 2 * Math.log((1 + Math.sin(rotB)) / (1 - Math.sin(rotB))) + this.y0;
      p.x = this.R * rotI + this.x0;
      return p;
    }

    function inverse$7(p) {
      var Y = p.x - this.x0;
      var X = p.y - this.y0;

      var rotI = Y / this.R;
      var rotB = 2 * (Math.atan(Math.exp(X / this.R)) - Math.PI / 4);

      var b = Math.asin(Math.cos(this.b0) * Math.sin(rotB) + Math.sin(this.b0) * Math.cos(rotB) * Math.cos(rotI));
      var I = Math.atan(Math.sin(rotI) / (Math.cos(this.b0) * Math.cos(rotI) - Math.sin(this.b0) * Math.tan(rotB)));

      var lambda = this.lambda0 + I / this.alpha;

      var S = 0;
      var phy = b;
      var prevPhy = -1000;
      var iteration = 0;
      while (Math.abs(phy - prevPhy) > 0.0000001) {
        if (++iteration > 20) {
          //...reportError("omercFwdInfinity");
          return;
        }
        //S = Math.log(Math.tan(Math.PI / 4 + phy / 2));
        S = 1 / this.alpha * (Math.log(Math.tan(Math.PI / 4 + b / 2)) - this.K) + this.e * Math.log(Math.tan(Math.PI / 4 + Math.asin(this.e * Math.sin(phy)) / 2));
        prevPhy = phy;
        phy = 2 * Math.atan(Math.exp(S)) - Math.PI / 2;
      }

      p.x = lambda;
      p.y = phy;
      return p;
    }

    var names$9 = ["somerc"];
    var somerc = {
      init: init$8,
      forward: forward$7,
      inverse: inverse$7,
      names: names$9
    };

    var TOL = 1e-7;

    function isTypeA(P) {
      var typeAProjections = ['Hotine_Oblique_Mercator','Hotine_Oblique_Mercator_Azimuth_Natural_Origin'];
      var projectionName = typeof P.PROJECTION === "object" ? Object.keys(P.PROJECTION)[0] : P.PROJECTION;
      
      return 'no_uoff' in P || 'no_off' in P || typeAProjections.indexOf(projectionName) !== -1;
    }


    /* Initialize the Oblique Mercator  projection
        ------------------------------------------*/
    function init$9() {  
      var con, com, cosph0, D, F, H, L, sinph0, p, J, gamma = 0,
        gamma0, lamc = 0, lam1 = 0, lam2 = 0, phi1 = 0, phi2 = 0, alpha_c = 0;
      
      // only Type A uses the no_off or no_uoff property
      // https://github.com/OSGeo/proj.4/issues/104
      this.no_off = isTypeA(this);
      this.no_rot = 'no_rot' in this;
      
      var alp = false;
      if ("alpha" in this) {
        alp = true;
      }

      var gam = false;
      if ("rectified_grid_angle" in this) {
        gam = true;
      }

      if (alp) {
        alpha_c = this.alpha;
      }
      
      if (gam) {
        gamma = (this.rectified_grid_angle * D2R);
      }
      
      if (alp || gam) {
        lamc = this.longc;
      } else {
        lam1 = this.long1;
        phi1 = this.lat1;
        lam2 = this.long2;
        phi2 = this.lat2;
        
        if (Math.abs(phi1 - phi2) <= TOL || (con = Math.abs(phi1)) <= TOL ||
            Math.abs(con - HALF_PI) <= TOL || Math.abs(Math.abs(this.lat0) - HALF_PI) <= TOL ||
            Math.abs(Math.abs(phi2) - HALF_PI) <= TOL) {
          throw new Error();
        }
      }
      
      var one_es = 1.0 - this.es;
      com = Math.sqrt(one_es);
      
      if (Math.abs(this.lat0) > EPSLN) {
        sinph0 = Math.sin(this.lat0);
        cosph0 = Math.cos(this.lat0);
        con = 1 - this.es * sinph0 * sinph0;
        this.B = cosph0 * cosph0;
        this.B = Math.sqrt(1 + this.es * this.B * this.B / one_es);
        this.A = this.B * this.k0 * com / con;
        D = this.B * com / (cosph0 * Math.sqrt(con));
        F = D * D -1;
        
        if (F <= 0) {
          F = 0;
        } else {
          F = Math.sqrt(F);
          if (this.lat0 < 0) {
            F = -F;
          }
        }
        
        this.E = F += D;
        this.E *= Math.pow(tsfnz(this.e, this.lat0, sinph0), this.B);
      } else {
        this.B = 1 / com;
        this.A = this.k0;
        this.E = D = F = 1;
      }
      
      if (alp || gam) {
        if (alp) {
          gamma0 = Math.asin(Math.sin(alpha_c) / D);
          if (!gam) {
            gamma = alpha_c;
          }
        } else {
          gamma0 = gamma;
          alpha_c = Math.asin(D * Math.sin(gamma0));
        }
        this.lam0 = lamc - Math.asin(0.5 * (F - 1 / F) * Math.tan(gamma0)) / this.B;
      } else {
        H = Math.pow(tsfnz(this.e, phi1, Math.sin(phi1)), this.B);
        L = Math.pow(tsfnz(this.e, phi2, Math.sin(phi2)), this.B);
        F = this.E / H;
        p = (L - H) / (L + H);
        J = this.E * this.E;
        J = (J - L * H) / (J + L * H);
        con = lam1 - lam2;
        
        if (con < -Math.pi) {
          lam2 -=TWO_PI;
        } else if (con > Math.pi) {
          lam2 += TWO_PI;
        }
        
        this.lam0 = adjust_lon(0.5 * (lam1 + lam2) - Math.atan(J * Math.tan(0.5 * this.B * (lam1 - lam2)) / p) / this.B);
        gamma0 = Math.atan(2 * Math.sin(this.B * adjust_lon(lam1 - this.lam0)) / (F - 1 / F));
        gamma = alpha_c = Math.asin(D * Math.sin(gamma0));
      }
      
      this.singam = Math.sin(gamma0);
      this.cosgam = Math.cos(gamma0);
      this.sinrot = Math.sin(gamma);
      this.cosrot = Math.cos(gamma);
      
      this.rB = 1 / this.B;
      this.ArB = this.A * this.rB;
      this.BrA = 1 / this.ArB;
      if (this.no_off) {
        this.u_0 = 0;
      } else {
        this.u_0 = Math.abs(this.ArB * Math.atan(Math.sqrt(D * D - 1) / Math.cos(alpha_c)));
        
        if (this.lat0 < 0) {
          this.u_0 = - this.u_0;
        }  
      }
        
      F = 0.5 * gamma0;
      this.v_pole_n = this.ArB * Math.log(Math.tan(FORTPI - F));
      this.v_pole_s = this.ArB * Math.log(Math.tan(FORTPI + F));
    }


    /* Oblique Mercator forward equations--mapping lat,long to x,y
        ----------------------------------------------------------*/
    function forward$8(p) {
      var coords = {};
      var S, T, U, V, W, temp, u, v;
      p.x = p.x - this.lam0;
      
      if (Math.abs(Math.abs(p.y) - HALF_PI) > EPSLN) {
        W = this.E / Math.pow(tsfnz(this.e, p.y, Math.sin(p.y)), this.B);
        
        temp = 1 / W;
        S = 0.5 * (W - temp);
        T = 0.5 * (W + temp);
        V = Math.sin(this.B * p.x);
        U = (S * this.singam - V * this.cosgam) / T;
            
        if (Math.abs(Math.abs(U) - 1.0) < EPSLN) {
          throw new Error();
        }
        
        v = 0.5 * this.ArB * Math.log((1 - U)/(1 + U));
        temp = Math.cos(this.B * p.x);
        
        if (Math.abs(temp) < TOL) {
          u = this.A * p.x;
        } else {
          u = this.ArB * Math.atan2((S * this.cosgam + V * this.singam), temp);
        }    
      } else {
        v = p.y > 0 ? this.v_pole_n : this.v_pole_s;
        u = this.ArB * p.y;
      }
         
      if (this.no_rot) {
        coords.x = u;
        coords.y = v;
      } else {
        u -= this.u_0;
        coords.x = v * this.cosrot + u * this.sinrot;
        coords.y = u * this.cosrot - v * this.sinrot;
      }
      
      coords.x = (this.a * coords.x + this.x0);
      coords.y = (this.a * coords.y + this.y0);
      
      return coords;
    }

    function inverse$8(p) {
      var u, v, Qp, Sp, Tp, Vp, Up;
      var coords = {};
      
      p.x = (p.x - this.x0) * (1.0 / this.a);
      p.y = (p.y - this.y0) * (1.0 / this.a);

      if (this.no_rot) {
        v = p.y;
        u = p.x;
      } else {
        v = p.x * this.cosrot - p.y * this.sinrot;
        u = p.y * this.cosrot + p.x * this.sinrot + this.u_0;
      }
      
      Qp = Math.exp(-this.BrA * v);
      Sp = 0.5 * (Qp - 1 / Qp);
      Tp = 0.5 * (Qp + 1 / Qp);
      Vp = Math.sin(this.BrA * u);
      Up = (Vp * this.cosgam + Sp * this.singam) / Tp;
      
      if (Math.abs(Math.abs(Up) - 1) < EPSLN) {
        coords.x = 0;
        coords.y = Up < 0 ? -HALF_PI : HALF_PI;
      } else {
        coords.y = this.E / Math.sqrt((1 + Up) / (1 - Up));
        coords.y = phi2z(this.e, Math.pow(coords.y, 1 / this.B));
        
        if (coords.y === Infinity) {
          throw new Error();
        }
            
        coords.x = -this.rB * Math.atan2((Sp * this.cosgam - Vp * this.singam), Math.cos(this.BrA * u));
      }
      
      coords.x += this.lam0;
      
      return coords;
    }

    var names$10 = ["Hotine_Oblique_Mercator", "Hotine Oblique Mercator", "Hotine_Oblique_Mercator_Azimuth_Natural_Origin", "Hotine_Oblique_Mercator_Two_Point_Natural_Origin", "Hotine_Oblique_Mercator_Azimuth_Center", "Oblique_Mercator", "omerc"];
    var omerc = {
      init: init$9,
      forward: forward$8,
      inverse: inverse$8,
      names: names$10
    };

    function init$10() {
      
      //double lat0;                    /* the reference latitude               */
      //double long0;                   /* the reference longitude              */
      //double lat1;                    /* first standard parallel              */
      //double lat2;                    /* second standard parallel             */
      //double r_maj;                   /* major axis                           */
      //double r_min;                   /* minor axis                           */
      //double false_east;              /* x offset in meters                   */
      //double false_north;             /* y offset in meters                   */
      
      //the above value can be set with proj4.defs
      //example: proj4.defs("EPSG:2154","+proj=lcc +lat_1=49 +lat_2=44 +lat_0=46.5 +lon_0=3 +x_0=700000 +y_0=6600000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs");

      if (!this.lat2) {
        this.lat2 = this.lat1;
      } //if lat2 is not defined
      if (!this.k0) {
        this.k0 = 1;
      }
      this.x0 = this.x0 || 0;
      this.y0 = this.y0 || 0;
      // Standard Parallels cannot be equal and on opposite sides of the equator
      if (Math.abs(this.lat1 + this.lat2) < EPSLN) {
        return;
      }

      var temp = this.b / this.a;
      this.e = Math.sqrt(1 - temp * temp);

      var sin1 = Math.sin(this.lat1);
      var cos1 = Math.cos(this.lat1);
      var ms1 = msfnz(this.e, sin1, cos1);
      var ts1 = tsfnz(this.e, this.lat1, sin1);

      var sin2 = Math.sin(this.lat2);
      var cos2 = Math.cos(this.lat2);
      var ms2 = msfnz(this.e, sin2, cos2);
      var ts2 = tsfnz(this.e, this.lat2, sin2);

      var ts0 = tsfnz(this.e, this.lat0, Math.sin(this.lat0));

      if (Math.abs(this.lat1 - this.lat2) > EPSLN) {
        this.ns = Math.log(ms1 / ms2) / Math.log(ts1 / ts2);
      }
      else {
        this.ns = sin1;
      }
      if (isNaN(this.ns)) {
        this.ns = sin1;
      }
      this.f0 = ms1 / (this.ns * Math.pow(ts1, this.ns));
      this.rh = this.a * this.f0 * Math.pow(ts0, this.ns);
      if (!this.title) {
        this.title = "Lambert Conformal Conic";
      }
    }

    // Lambert Conformal conic forward equations--mapping lat,long to x,y
    // -----------------------------------------------------------------
    function forward$9(p) {

      var lon = p.x;
      var lat = p.y;

      // singular cases :
      if (Math.abs(2 * Math.abs(lat) - Math.PI) <= EPSLN) {
        lat = sign(lat) * (HALF_PI - 2 * EPSLN);
      }

      var con = Math.abs(Math.abs(lat) - HALF_PI);
      var ts, rh1;
      if (con > EPSLN) {
        ts = tsfnz(this.e, lat, Math.sin(lat));
        rh1 = this.a * this.f0 * Math.pow(ts, this.ns);
      }
      else {
        con = lat * this.ns;
        if (con <= 0) {
          return null;
        }
        rh1 = 0;
      }
      var theta = this.ns * adjust_lon(lon - this.long0);
      p.x = this.k0 * (rh1 * Math.sin(theta)) + this.x0;
      p.y = this.k0 * (this.rh - rh1 * Math.cos(theta)) + this.y0;

      return p;
    }

    // Lambert Conformal Conic inverse equations--mapping x,y to lat/long
    // -----------------------------------------------------------------
    function inverse$9(p) {

      var rh1, con, ts;
      var lat, lon;
      var x = (p.x - this.x0) / this.k0;
      var y = (this.rh - (p.y - this.y0) / this.k0);
      if (this.ns > 0) {
        rh1 = Math.sqrt(x * x + y * y);
        con = 1;
      }
      else {
        rh1 = -Math.sqrt(x * x + y * y);
        con = -1;
      }
      var theta = 0;
      if (rh1 !== 0) {
        theta = Math.atan2((con * x), (con * y));
      }
      if ((rh1 !== 0) || (this.ns > 0)) {
        con = 1 / this.ns;
        ts = Math.pow((rh1 / (this.a * this.f0)), con);
        lat = phi2z(this.e, ts);
        if (lat === -9999) {
          return null;
        }
      }
      else {
        lat = -HALF_PI;
      }
      lon = adjust_lon(theta / this.ns + this.long0);

      p.x = lon;
      p.y = lat;
      return p;
    }

    var names$11 = [
      "Lambert Tangential Conformal Conic Projection",
      "Lambert_Conformal_Conic",
      "Lambert_Conformal_Conic_1SP",
      "Lambert_Conformal_Conic_2SP",
      "lcc",
      "Lambert Conic Conformal (1SP)",
      "Lambert Conic Conformal (2SP)"
    ];

    var lcc = {
      init: init$10,
      forward: forward$9,
      inverse: inverse$9,
      names: names$11
    };

    function init$11() {
      this.a = 6377397.155;
      this.es = 0.006674372230614;
      this.e = Math.sqrt(this.es);
      if (!this.lat0) {
        this.lat0 = 0.863937979737193;
      }
      if (!this.long0) {
        this.long0 = 0.7417649320975901 - 0.308341501185665;
      }
      /* if scale not set default to 0.9999 */
      if (!this.k0) {
        this.k0 = 0.9999;
      }
      this.s45 = 0.785398163397448; /* 45 */
      this.s90 = 2 * this.s45;
      this.fi0 = this.lat0;
      this.e2 = this.es;
      this.e = Math.sqrt(this.e2);
      this.alfa = Math.sqrt(1 + (this.e2 * Math.pow(Math.cos(this.fi0), 4)) / (1 - this.e2));
      this.uq = 1.04216856380474;
      this.u0 = Math.asin(Math.sin(this.fi0) / this.alfa);
      this.g = Math.pow((1 + this.e * Math.sin(this.fi0)) / (1 - this.e * Math.sin(this.fi0)), this.alfa * this.e / 2);
      this.k = Math.tan(this.u0 / 2 + this.s45) / Math.pow(Math.tan(this.fi0 / 2 + this.s45), this.alfa) * this.g;
      this.k1 = this.k0;
      this.n0 = this.a * Math.sqrt(1 - this.e2) / (1 - this.e2 * Math.pow(Math.sin(this.fi0), 2));
      this.s0 = 1.37008346281555;
      this.n = Math.sin(this.s0);
      this.ro0 = this.k1 * this.n0 / Math.tan(this.s0);
      this.ad = this.s90 - this.uq;
    }

    /* ellipsoid */
    /* calculate xy from lat/lon */
    /* Constants, identical to inverse transform function */
    function forward$10(p) {
      var gfi, u, deltav, s, d, eps, ro;
      var lon = p.x;
      var lat = p.y;
      var delta_lon = adjust_lon(lon - this.long0);
      /* Transformation */
      gfi = Math.pow(((1 + this.e * Math.sin(lat)) / (1 - this.e * Math.sin(lat))), (this.alfa * this.e / 2));
      u = 2 * (Math.atan(this.k * Math.pow(Math.tan(lat / 2 + this.s45), this.alfa) / gfi) - this.s45);
      deltav = -delta_lon * this.alfa;
      s = Math.asin(Math.cos(this.ad) * Math.sin(u) + Math.sin(this.ad) * Math.cos(u) * Math.cos(deltav));
      d = Math.asin(Math.cos(u) * Math.sin(deltav) / Math.cos(s));
      eps = this.n * d;
      ro = this.ro0 * Math.pow(Math.tan(this.s0 / 2 + this.s45), this.n) / Math.pow(Math.tan(s / 2 + this.s45), this.n);
      p.y = ro * Math.cos(eps) / 1;
      p.x = ro * Math.sin(eps) / 1;

      if (!this.czech) {
        p.y *= -1;
        p.x *= -1;
      }
      return (p);
    }

    /* calculate lat/lon from xy */
    function inverse$10(p) {
      var u, deltav, s, d, eps, ro, fi1;
      var ok;

      /* Transformation */
      /* revert y, x*/
      var tmp = p.x;
      p.x = p.y;
      p.y = tmp;
      if (!this.czech) {
        p.y *= -1;
        p.x *= -1;
      }
      ro = Math.sqrt(p.x * p.x + p.y * p.y);
      eps = Math.atan2(p.y, p.x);
      d = eps / Math.sin(this.s0);
      s = 2 * (Math.atan(Math.pow(this.ro0 / ro, 1 / this.n) * Math.tan(this.s0 / 2 + this.s45)) - this.s45);
      u = Math.asin(Math.cos(this.ad) * Math.sin(s) - Math.sin(this.ad) * Math.cos(s) * Math.cos(d));
      deltav = Math.asin(Math.cos(s) * Math.sin(d) / Math.cos(u));
      p.x = this.long0 - deltav / this.alfa;
      fi1 = u;
      ok = 0;
      var iter = 0;
      do {
        p.y = 2 * (Math.atan(Math.pow(this.k, - 1 / this.alfa) * Math.pow(Math.tan(u / 2 + this.s45), 1 / this.alfa) * Math.pow((1 + this.e * Math.sin(fi1)) / (1 - this.e * Math.sin(fi1)), this.e / 2)) - this.s45);
        if (Math.abs(fi1 - p.y) < 0.0000000001) {
          ok = 1;
        }
        fi1 = p.y;
        iter += 1;
      } while (ok === 0 && iter < 15);
      if (iter >= 15) {
        return null;
      }

      return (p);
    }

    var names$12 = ["Krovak", "krovak"];
    var krovak = {
      init: init$11,
      forward: forward$10,
      inverse: inverse$10,
      names: names$12
    };

    var mlfn = function(e0, e1, e2, e3, phi) {
      return (e0 * phi - e1 * Math.sin(2 * phi) + e2 * Math.sin(4 * phi) - e3 * Math.sin(6 * phi));
    };

    var e0fn = function(x) {
      return (1 - 0.25 * x * (1 + x / 16 * (3 + 1.25 * x)));
    };

    var e1fn = function(x) {
      return (0.375 * x * (1 + 0.25 * x * (1 + 0.46875 * x)));
    };

    var e2fn = function(x) {
      return (0.05859375 * x * x * (1 + 0.75 * x));
    };

    var e3fn = function(x) {
      return (x * x * x * (35 / 3072));
    };

    var gN = function(a, e, sinphi) {
      var temp = e * sinphi;
      return a / Math.sqrt(1 - temp * temp);
    };

    var adjust_lat = function(x) {
      return (Math.abs(x) < HALF_PI) ? x : (x - (sign(x) * Math.PI));
    };

    var imlfn = function(ml, e0, e1, e2, e3) {
      var phi;
      var dphi;

      phi = ml / e0;
      for (var i = 0; i < 15; i++) {
        dphi = (ml - (e0 * phi - e1 * Math.sin(2 * phi) + e2 * Math.sin(4 * phi) - e3 * Math.sin(6 * phi))) / (e0 - 2 * e1 * Math.cos(2 * phi) + 4 * e2 * Math.cos(4 * phi) - 6 * e3 * Math.cos(6 * phi));
        phi += dphi;
        if (Math.abs(dphi) <= 0.0000000001) {
          return phi;
        }
      }

      //..reportError("IMLFN-CONV:Latitude failed to converge after 15 iterations");
      return NaN;
    };

    function init$12() {
      if (!this.sphere) {
        this.e0 = e0fn(this.es);
        this.e1 = e1fn(this.es);
        this.e2 = e2fn(this.es);
        this.e3 = e3fn(this.es);
        this.ml0 = this.a * mlfn(this.e0, this.e1, this.e2, this.e3, this.lat0);
      }
    }

    /* Cassini forward equations--mapping lat,long to x,y
      -----------------------------------------------------------------------*/
    function forward$11(p) {

      /* Forward equations
          -----------------*/
      var x, y;
      var lam = p.x;
      var phi = p.y;
      lam = adjust_lon(lam - this.long0);

      if (this.sphere) {
        x = this.a * Math.asin(Math.cos(phi) * Math.sin(lam));
        y = this.a * (Math.atan2(Math.tan(phi), Math.cos(lam)) - this.lat0);
      }
      else {
        //ellipsoid
        var sinphi = Math.sin(phi);
        var cosphi = Math.cos(phi);
        var nl = gN(this.a, this.e, sinphi);
        var tl = Math.tan(phi) * Math.tan(phi);
        var al = lam * Math.cos(phi);
        var asq = al * al;
        var cl = this.es * cosphi * cosphi / (1 - this.es);
        var ml = this.a * mlfn(this.e0, this.e1, this.e2, this.e3, phi);

        x = nl * al * (1 - asq * tl * (1 / 6 - (8 - tl + 8 * cl) * asq / 120));
        y = ml - this.ml0 + nl * sinphi / cosphi * asq * (0.5 + (5 - tl + 6 * cl) * asq / 24);


      }

      p.x = x + this.x0;
      p.y = y + this.y0;
      return p;
    }

    /* Inverse equations
      -----------------*/
    function inverse$11(p) {
      p.x -= this.x0;
      p.y -= this.y0;
      var x = p.x / this.a;
      var y = p.y / this.a;
      var phi, lam;

      if (this.sphere) {
        var dd = y + this.lat0;
        phi = Math.asin(Math.sin(dd) * Math.cos(x));
        lam = Math.atan2(Math.tan(x), Math.cos(dd));
      }
      else {
        /* ellipsoid */
        var ml1 = this.ml0 / this.a + y;
        var phi1 = imlfn(ml1, this.e0, this.e1, this.e2, this.e3);
        if (Math.abs(Math.abs(phi1) - HALF_PI) <= EPSLN) {
          p.x = this.long0;
          p.y = HALF_PI;
          if (y < 0) {
            p.y *= -1;
          }
          return p;
        }
        var nl1 = gN(this.a, this.e, Math.sin(phi1));

        var rl1 = nl1 * nl1 * nl1 / this.a / this.a * (1 - this.es);
        var tl1 = Math.pow(Math.tan(phi1), 2);
        var dl = x * this.a / nl1;
        var dsq = dl * dl;
        phi = phi1 - nl1 * Math.tan(phi1) / rl1 * dl * dl * (0.5 - (1 + 3 * tl1) * dl * dl / 24);
        lam = dl * (1 - dsq * (tl1 / 3 + (1 + 3 * tl1) * tl1 * dsq / 15)) / Math.cos(phi1);

      }

      p.x = adjust_lon(lam + this.long0);
      p.y = adjust_lat(phi);
      return p;

    }

    var names$13 = ["Cassini", "Cassini_Soldner", "cass"];
    var cass = {
      init: init$12,
      forward: forward$11,
      inverse: inverse$11,
      names: names$13
    };

    var qsfnz = function(eccent, sinphi) {
      var con;
      if (eccent > 1.0e-7) {
        con = eccent * sinphi;
        return ((1 - eccent * eccent) * (sinphi / (1 - con * con) - (0.5 / eccent) * Math.log((1 - con) / (1 + con))));
      }
      else {
        return (2 * sinphi);
      }
    };

    /*
      reference
        "New Equal-Area Map Projections for Noncircular Regions", John P. Snyder,
        The American Cartographer, Vol 15, No. 4, October 1988, pp. 341-355.
      */

    var S_POLE = 1;

    var N_POLE = 2;
    var EQUIT = 3;
    var OBLIQ = 4;

    /* Initialize the Lambert Azimuthal Equal Area projection
      ------------------------------------------------------*/
    function init$13() {
      var t = Math.abs(this.lat0);
      if (Math.abs(t - HALF_PI) < EPSLN) {
        this.mode = this.lat0 < 0 ? this.S_POLE : this.N_POLE;
      }
      else if (Math.abs(t) < EPSLN) {
        this.mode = this.EQUIT;
      }
      else {
        this.mode = this.OBLIQ;
      }
      if (this.es > 0) {
        var sinphi;

        this.qp = qsfnz(this.e, 1);
        this.mmf = 0.5 / (1 - this.es);
        this.apa = authset(this.es);
        switch (this.mode) {
        case this.N_POLE:
          this.dd = 1;
          break;
        case this.S_POLE:
          this.dd = 1;
          break;
        case this.EQUIT:
          this.rq = Math.sqrt(0.5 * this.qp);
          this.dd = 1 / this.rq;
          this.xmf = 1;
          this.ymf = 0.5 * this.qp;
          break;
        case this.OBLIQ:
          this.rq = Math.sqrt(0.5 * this.qp);
          sinphi = Math.sin(this.lat0);
          this.sinb1 = qsfnz(this.e, sinphi) / this.qp;
          this.cosb1 = Math.sqrt(1 - this.sinb1 * this.sinb1);
          this.dd = Math.cos(this.lat0) / (Math.sqrt(1 - this.es * sinphi * sinphi) * this.rq * this.cosb1);
          this.ymf = (this.xmf = this.rq) / this.dd;
          this.xmf *= this.dd;
          break;
        }
      }
      else {
        if (this.mode === this.OBLIQ) {
          this.sinph0 = Math.sin(this.lat0);
          this.cosph0 = Math.cos(this.lat0);
        }
      }
    }

    /* Lambert Azimuthal Equal Area forward equations--mapping lat,long to x,y
      -----------------------------------------------------------------------*/
    function forward$12(p) {

      /* Forward equations
          -----------------*/
      var x, y, coslam, sinlam, sinphi, q, sinb, cosb, b, cosphi;
      var lam = p.x;
      var phi = p.y;

      lam = adjust_lon(lam - this.long0);
      if (this.sphere) {
        sinphi = Math.sin(phi);
        cosphi = Math.cos(phi);
        coslam = Math.cos(lam);
        if (this.mode === this.OBLIQ || this.mode === this.EQUIT) {
          y = (this.mode === this.EQUIT) ? 1 + cosphi * coslam : 1 + this.sinph0 * sinphi + this.cosph0 * cosphi * coslam;
          if (y <= EPSLN) {
            return null;
          }
          y = Math.sqrt(2 / y);
          x = y * cosphi * Math.sin(lam);
          y *= (this.mode === this.EQUIT) ? sinphi : this.cosph0 * sinphi - this.sinph0 * cosphi * coslam;
        }
        else if (this.mode === this.N_POLE || this.mode === this.S_POLE) {
          if (this.mode === this.N_POLE) {
            coslam = -coslam;
          }
          if (Math.abs(phi + this.lat0) < EPSLN) {
            return null;
          }
          y = FORTPI - phi * 0.5;
          y = 2 * ((this.mode === this.S_POLE) ? Math.cos(y) : Math.sin(y));
          x = y * Math.sin(lam);
          y *= coslam;
        }
      }
      else {
        sinb = 0;
        cosb = 0;
        b = 0;
        coslam = Math.cos(lam);
        sinlam = Math.sin(lam);
        sinphi = Math.sin(phi);
        q = qsfnz(this.e, sinphi);
        if (this.mode === this.OBLIQ || this.mode === this.EQUIT) {
          sinb = q / this.qp;
          cosb = Math.sqrt(1 - sinb * sinb);
        }
        switch (this.mode) {
        case this.OBLIQ:
          b = 1 + this.sinb1 * sinb + this.cosb1 * cosb * coslam;
          break;
        case this.EQUIT:
          b = 1 + cosb * coslam;
          break;
        case this.N_POLE:
          b = HALF_PI + phi;
          q = this.qp - q;
          break;
        case this.S_POLE:
          b = phi - HALF_PI;
          q = this.qp + q;
          break;
        }
        if (Math.abs(b) < EPSLN) {
          return null;
        }
        switch (this.mode) {
        case this.OBLIQ:
        case this.EQUIT:
          b = Math.sqrt(2 / b);
          if (this.mode === this.OBLIQ) {
            y = this.ymf * b * (this.cosb1 * sinb - this.sinb1 * cosb * coslam);
          }
          else {
            y = (b = Math.sqrt(2 / (1 + cosb * coslam))) * sinb * this.ymf;
          }
          x = this.xmf * b * cosb * sinlam;
          break;
        case this.N_POLE:
        case this.S_POLE:
          if (q >= 0) {
            x = (b = Math.sqrt(q)) * sinlam;
            y = coslam * ((this.mode === this.S_POLE) ? b : -b);
          }
          else {
            x = y = 0;
          }
          break;
        }
      }

      p.x = this.a * x + this.x0;
      p.y = this.a * y + this.y0;
      return p;
    }

    /* Inverse equations
      -----------------*/
    function inverse$12(p) {
      p.x -= this.x0;
      p.y -= this.y0;
      var x = p.x / this.a;
      var y = p.y / this.a;
      var lam, phi, cCe, sCe, q, rho, ab;
      if (this.sphere) {
        var cosz = 0,
          rh, sinz = 0;

        rh = Math.sqrt(x * x + y * y);
        phi = rh * 0.5;
        if (phi > 1) {
          return null;
        }
        phi = 2 * Math.asin(phi);
        if (this.mode === this.OBLIQ || this.mode === this.EQUIT) {
          sinz = Math.sin(phi);
          cosz = Math.cos(phi);
        }
        switch (this.mode) {
        case this.EQUIT:
          phi = (Math.abs(rh) <= EPSLN) ? 0 : Math.asin(y * sinz / rh);
          x *= sinz;
          y = cosz * rh;
          break;
        case this.OBLIQ:
          phi = (Math.abs(rh) <= EPSLN) ? this.lat0 : Math.asin(cosz * this.sinph0 + y * sinz * this.cosph0 / rh);
          x *= sinz * this.cosph0;
          y = (cosz - Math.sin(phi) * this.sinph0) * rh;
          break;
        case this.N_POLE:
          y = -y;
          phi = HALF_PI - phi;
          break;
        case this.S_POLE:
          phi -= HALF_PI;
          break;
        }
        lam = (y === 0 && (this.mode === this.EQUIT || this.mode === this.OBLIQ)) ? 0 : Math.atan2(x, y);
      }
      else {
        ab = 0;
        if (this.mode === this.OBLIQ || this.mode === this.EQUIT) {
          x /= this.dd;
          y *= this.dd;
          rho = Math.sqrt(x * x + y * y);
          if (rho < EPSLN) {
            p.x = this.long0;
            p.y = this.lat0;
            return p;
          }
          sCe = 2 * Math.asin(0.5 * rho / this.rq);
          cCe = Math.cos(sCe);
          x *= (sCe = Math.sin(sCe));
          if (this.mode === this.OBLIQ) {
            ab = cCe * this.sinb1 + y * sCe * this.cosb1 / rho;
            q = this.qp * ab;
            y = rho * this.cosb1 * cCe - y * this.sinb1 * sCe;
          }
          else {
            ab = y * sCe / rho;
            q = this.qp * ab;
            y = rho * cCe;
          }
        }
        else if (this.mode === this.N_POLE || this.mode === this.S_POLE) {
          if (this.mode === this.N_POLE) {
            y = -y;
          }
          q = (x * x + y * y);
          if (!q) {
            p.x = this.long0;
            p.y = this.lat0;
            return p;
          }
          ab = 1 - q / this.qp;
          if (this.mode === this.S_POLE) {
            ab = -ab;
          }
        }
        lam = Math.atan2(x, y);
        phi = authlat(Math.asin(ab), this.apa);
      }

      p.x = adjust_lon(this.long0 + lam);
      p.y = phi;
      return p;
    }

    /* determine latitude from authalic latitude */
    var P00 = 0.33333333333333333333;

    var P01 = 0.17222222222222222222;
    var P02 = 0.10257936507936507936;
    var P10 = 0.06388888888888888888;
    var P11 = 0.06640211640211640211;
    var P20 = 0.01641501294219154443;

    function authset(es) {
      var t;
      var APA = [];
      APA[0] = es * P00;
      t = es * es;
      APA[0] += t * P01;
      APA[1] = t * P10;
      t *= es;
      APA[0] += t * P02;
      APA[1] += t * P11;
      APA[2] = t * P20;
      return APA;
    }

    function authlat(beta, APA) {
      var t = beta + beta;
      return (beta + APA[0] * Math.sin(t) + APA[1] * Math.sin(t + t) + APA[2] * Math.sin(t + t + t));
    }

    var names$14 = ["Lambert Azimuthal Equal Area", "Lambert_Azimuthal_Equal_Area", "laea"];
    var laea = {
      init: init$13,
      forward: forward$12,
      inverse: inverse$12,
      names: names$14,
      S_POLE: S_POLE,
      N_POLE: N_POLE,
      EQUIT: EQUIT,
      OBLIQ: OBLIQ
    };

    var asinz = function(x) {
      if (Math.abs(x) > 1) {
        x = (x > 1) ? 1 : -1;
      }
      return Math.asin(x);
    };

    function init$14() {

      if (Math.abs(this.lat1 + this.lat2) < EPSLN) {
        return;
      }
      this.temp = this.b / this.a;
      this.es = 1 - Math.pow(this.temp, 2);
      this.e3 = Math.sqrt(this.es);

      this.sin_po = Math.sin(this.lat1);
      this.cos_po = Math.cos(this.lat1);
      this.t1 = this.sin_po;
      this.con = this.sin_po;
      this.ms1 = msfnz(this.e3, this.sin_po, this.cos_po);
      this.qs1 = qsfnz(this.e3, this.sin_po);

      this.sin_po = Math.sin(this.lat2);
      this.cos_po = Math.cos(this.lat2);
      this.t2 = this.sin_po;
      this.ms2 = msfnz(this.e3, this.sin_po, this.cos_po);
      this.qs2 = qsfnz(this.e3, this.sin_po);

      this.sin_po = Math.sin(this.lat0);
      this.cos_po = Math.cos(this.lat0);
      this.t3 = this.sin_po;
      this.qs0 = qsfnz(this.e3, this.sin_po);

      if (Math.abs(this.lat1 - this.lat2) > EPSLN) {
        this.ns0 = (this.ms1 * this.ms1 - this.ms2 * this.ms2) / (this.qs2 - this.qs1);
      }
      else {
        this.ns0 = this.con;
      }
      this.c = this.ms1 * this.ms1 + this.ns0 * this.qs1;
      this.rh = this.a * Math.sqrt(this.c - this.ns0 * this.qs0) / this.ns0;
    }

    /* Albers Conical Equal Area forward equations--mapping lat,long to x,y
      -------------------------------------------------------------------*/
    function forward$13(p) {

      var lon = p.x;
      var lat = p.y;

      this.sin_phi = Math.sin(lat);
      this.cos_phi = Math.cos(lat);

      var qs = qsfnz(this.e3, this.sin_phi);
      var rh1 = this.a * Math.sqrt(this.c - this.ns0 * qs) / this.ns0;
      var theta = this.ns0 * adjust_lon(lon - this.long0);
      var x = rh1 * Math.sin(theta) + this.x0;
      var y = this.rh - rh1 * Math.cos(theta) + this.y0;

      p.x = x;
      p.y = y;
      return p;
    }

    function inverse$13(p) {
      var rh1, qs, con, theta, lon, lat;

      p.x -= this.x0;
      p.y = this.rh - p.y + this.y0;
      if (this.ns0 >= 0) {
        rh1 = Math.sqrt(p.x * p.x + p.y * p.y);
        con = 1;
      }
      else {
        rh1 = -Math.sqrt(p.x * p.x + p.y * p.y);
        con = -1;
      }
      theta = 0;
      if (rh1 !== 0) {
        theta = Math.atan2(con * p.x, con * p.y);
      }
      con = rh1 * this.ns0 / this.a;
      if (this.sphere) {
        lat = Math.asin((this.c - con * con) / (2 * this.ns0));
      }
      else {
        qs = (this.c - con * con) / this.ns0;
        lat = this.phi1z(this.e3, qs);
      }

      lon = adjust_lon(theta / this.ns0 + this.long0);
      p.x = lon;
      p.y = lat;
      return p;
    }

    /* Function to compute phi1, the latitude for the inverse of the
       Albers Conical Equal-Area projection.
    -------------------------------------------*/
    function phi1z(eccent, qs) {
      var sinphi, cosphi, con, com, dphi;
      var phi = asinz(0.5 * qs);
      if (eccent < EPSLN) {
        return phi;
      }

      var eccnts = eccent * eccent;
      for (var i = 1; i <= 25; i++) {
        sinphi = Math.sin(phi);
        cosphi = Math.cos(phi);
        con = eccent * sinphi;
        com = 1 - con * con;
        dphi = 0.5 * com * com / cosphi * (qs / (1 - eccnts) - sinphi / com + 0.5 / eccent * Math.log((1 - con) / (1 + con)));
        phi = phi + dphi;
        if (Math.abs(dphi) <= 1e-7) {
          return phi;
        }
      }
      return null;
    }

    var names$15 = ["Albers_Conic_Equal_Area", "Albers", "aea"];
    var aea = {
      init: init$14,
      forward: forward$13,
      inverse: inverse$13,
      names: names$15,
      phi1z: phi1z
    };

    /*
      reference:
        Wolfram Mathworld "Gnomonic Projection"
        http://mathworld.wolfram.com/GnomonicProjection.html
        Accessed: 12th November 2009
      */
    function init$15() {

      /* Place parameters in static storage for common use
          -------------------------------------------------*/
      this.sin_p14 = Math.sin(this.lat0);
      this.cos_p14 = Math.cos(this.lat0);
      // Approximation for projecting points to the horizon (infinity)
      this.infinity_dist = 1000 * this.a;
      this.rc = 1;
    }

    /* Gnomonic forward equations--mapping lat,long to x,y
        ---------------------------------------------------*/
    function forward$14(p) {
      var sinphi, cosphi; /* sin and cos value        */
      var dlon; /* delta longitude value      */
      var coslon; /* cos of longitude        */
      var ksp; /* scale factor          */
      var g;
      var x, y;
      var lon = p.x;
      var lat = p.y;
      /* Forward equations
          -----------------*/
      dlon = adjust_lon(lon - this.long0);

      sinphi = Math.sin(lat);
      cosphi = Math.cos(lat);

      coslon = Math.cos(dlon);
      g = this.sin_p14 * sinphi + this.cos_p14 * cosphi * coslon;
      ksp = 1;
      if ((g > 0) || (Math.abs(g) <= EPSLN)) {
        x = this.x0 + this.a * ksp * cosphi * Math.sin(dlon) / g;
        y = this.y0 + this.a * ksp * (this.cos_p14 * sinphi - this.sin_p14 * cosphi * coslon) / g;
      }
      else {

        // Point is in the opposing hemisphere and is unprojectable
        // We still need to return a reasonable point, so we project
        // to infinity, on a bearing
        // equivalent to the northern hemisphere equivalent
        // This is a reasonable approximation for short shapes and lines that
        // straddle the horizon.

        x = this.x0 + this.infinity_dist * cosphi * Math.sin(dlon);
        y = this.y0 + this.infinity_dist * (this.cos_p14 * sinphi - this.sin_p14 * cosphi * coslon);

      }
      p.x = x;
      p.y = y;
      return p;
    }

    function inverse$14(p) {
      var rh; /* Rho */
      var sinc, cosc;
      var c;
      var lon, lat;

      /* Inverse equations
          -----------------*/
      p.x = (p.x - this.x0) / this.a;
      p.y = (p.y - this.y0) / this.a;

      p.x /= this.k0;
      p.y /= this.k0;

      if ((rh = Math.sqrt(p.x * p.x + p.y * p.y))) {
        c = Math.atan2(rh, this.rc);
        sinc = Math.sin(c);
        cosc = Math.cos(c);

        lat = asinz(cosc * this.sin_p14 + (p.y * sinc * this.cos_p14) / rh);
        lon = Math.atan2(p.x * sinc, rh * this.cos_p14 * cosc - p.y * this.sin_p14 * sinc);
        lon = adjust_lon(this.long0 + lon);
      }
      else {
        lat = this.phic0;
        lon = 0;
      }

      p.x = lon;
      p.y = lat;
      return p;
    }

    var names$16 = ["gnom"];
    var gnom = {
      init: init$15,
      forward: forward$14,
      inverse: inverse$14,
      names: names$16
    };

    var iqsfnz = function(eccent, q) {
      var temp = 1 - (1 - eccent * eccent) / (2 * eccent) * Math.log((1 - eccent) / (1 + eccent));
      if (Math.abs(Math.abs(q) - temp) < 1.0E-6) {
        if (q < 0) {
          return (-1 * HALF_PI);
        }
        else {
          return HALF_PI;
        }
      }
      //var phi = 0.5* q/(1-eccent*eccent);
      var phi = Math.asin(0.5 * q);
      var dphi;
      var sin_phi;
      var cos_phi;
      var con;
      for (var i = 0; i < 30; i++) {
        sin_phi = Math.sin(phi);
        cos_phi = Math.cos(phi);
        con = eccent * sin_phi;
        dphi = Math.pow(1 - con * con, 2) / (2 * cos_phi) * (q / (1 - eccent * eccent) - sin_phi / (1 - con * con) + 0.5 / eccent * Math.log((1 - con) / (1 + con)));
        phi += dphi;
        if (Math.abs(dphi) <= 0.0000000001) {
          return phi;
        }
      }

      //console.log("IQSFN-CONV:Latitude failed to converge after 30 iterations");
      return NaN;
    };

    /*
      reference:
        "Cartographic Projection Procedures for the UNIX Environment-
        A User's Manual" by Gerald I. Evenden,
        USGS Open File Report 90-284and Release 4 Interim Reports (2003)
    */
    function init$16() {
      //no-op
      if (!this.sphere) {
        this.k0 = msfnz(this.e, Math.sin(this.lat_ts), Math.cos(this.lat_ts));
      }
    }

    /* Cylindrical Equal Area forward equations--mapping lat,long to x,y
        ------------------------------------------------------------*/
    function forward$15(p) {
      var lon = p.x;
      var lat = p.y;
      var x, y;
      /* Forward equations
          -----------------*/
      var dlon = adjust_lon(lon - this.long0);
      if (this.sphere) {
        x = this.x0 + this.a * dlon * Math.cos(this.lat_ts);
        y = this.y0 + this.a * Math.sin(lat) / Math.cos(this.lat_ts);
      }
      else {
        var qs = qsfnz(this.e, Math.sin(lat));
        x = this.x0 + this.a * this.k0 * dlon;
        y = this.y0 + this.a * qs * 0.5 / this.k0;
      }

      p.x = x;
      p.y = y;
      return p;
    }

    /* Cylindrical Equal Area inverse equations--mapping x,y to lat/long
        ------------------------------------------------------------*/
    function inverse$15(p) {
      p.x -= this.x0;
      p.y -= this.y0;
      var lon, lat;

      if (this.sphere) {
        lon = adjust_lon(this.long0 + (p.x / this.a) / Math.cos(this.lat_ts));
        lat = Math.asin((p.y / this.a) * Math.cos(this.lat_ts));
      }
      else {
        lat = iqsfnz(this.e, 2 * p.y * this.k0 / this.a);
        lon = adjust_lon(this.long0 + p.x / (this.a * this.k0));
      }

      p.x = lon;
      p.y = lat;
      return p;
    }

    var names$17 = ["cea"];
    var cea = {
      init: init$16,
      forward: forward$15,
      inverse: inverse$15,
      names: names$17
    };

    function init$17() {

      this.x0 = this.x0 || 0;
      this.y0 = this.y0 || 0;
      this.lat0 = this.lat0 || 0;
      this.long0 = this.long0 || 0;
      this.lat_ts = this.lat_ts || 0;
      this.title = this.title || "Equidistant Cylindrical (Plate Carre)";

      this.rc = Math.cos(this.lat_ts);
    }

    // forward equations--mapping lat,long to x,y
    // -----------------------------------------------------------------
    function forward$16(p) {

      var lon = p.x;
      var lat = p.y;

      var dlon = adjust_lon(lon - this.long0);
      var dlat = adjust_lat(lat - this.lat0);
      p.x = this.x0 + (this.a * dlon * this.rc);
      p.y = this.y0 + (this.a * dlat);
      return p;
    }

    // inverse equations--mapping x,y to lat/long
    // -----------------------------------------------------------------
    function inverse$16(p) {

      var x = p.x;
      var y = p.y;

      p.x = adjust_lon(this.long0 + ((x - this.x0) / (this.a * this.rc)));
      p.y = adjust_lat(this.lat0 + ((y - this.y0) / (this.a)));
      return p;
    }

    var names$18 = ["Equirectangular", "Equidistant_Cylindrical", "eqc"];
    var eqc = {
      init: init$17,
      forward: forward$16,
      inverse: inverse$16,
      names: names$18
    };

    var MAX_ITER$2 = 20;

    function init$18() {
      /* Place parameters in static storage for common use
          -------------------------------------------------*/
      this.temp = this.b / this.a;
      this.es = 1 - Math.pow(this.temp, 2); // devait etre dans tmerc.js mais n y est pas donc je commente sinon retour de valeurs nulles
      this.e = Math.sqrt(this.es);
      this.e0 = e0fn(this.es);
      this.e1 = e1fn(this.es);
      this.e2 = e2fn(this.es);
      this.e3 = e3fn(this.es);
      this.ml0 = this.a * mlfn(this.e0, this.e1, this.e2, this.e3, this.lat0); //si que des zeros le calcul ne se fait pas
    }

    /* Polyconic forward equations--mapping lat,long to x,y
        ---------------------------------------------------*/
    function forward$17(p) {
      var lon = p.x;
      var lat = p.y;
      var x, y, el;
      var dlon = adjust_lon(lon - this.long0);
      el = dlon * Math.sin(lat);
      if (this.sphere) {
        if (Math.abs(lat) <= EPSLN) {
          x = this.a * dlon;
          y = -1 * this.a * this.lat0;
        }
        else {
          x = this.a * Math.sin(el) / Math.tan(lat);
          y = this.a * (adjust_lat(lat - this.lat0) + (1 - Math.cos(el)) / Math.tan(lat));
        }
      }
      else {
        if (Math.abs(lat) <= EPSLN) {
          x = this.a * dlon;
          y = -1 * this.ml0;
        }
        else {
          var nl = gN(this.a, this.e, Math.sin(lat)) / Math.tan(lat);
          x = nl * Math.sin(el);
          y = this.a * mlfn(this.e0, this.e1, this.e2, this.e3, lat) - this.ml0 + nl * (1 - Math.cos(el));
        }

      }
      p.x = x + this.x0;
      p.y = y + this.y0;
      return p;
    }

    /* Inverse equations
      -----------------*/
    function inverse$17(p) {
      var lon, lat, x, y, i;
      var al, bl;
      var phi, dphi;
      x = p.x - this.x0;
      y = p.y - this.y0;

      if (this.sphere) {
        if (Math.abs(y + this.a * this.lat0) <= EPSLN) {
          lon = adjust_lon(x / this.a + this.long0);
          lat = 0;
        }
        else {
          al = this.lat0 + y / this.a;
          bl = x * x / this.a / this.a + al * al;
          phi = al;
          var tanphi;
          for (i = MAX_ITER$2; i; --i) {
            tanphi = Math.tan(phi);
            dphi = -1 * (al * (phi * tanphi + 1) - phi - 0.5 * (phi * phi + bl) * tanphi) / ((phi - al) / tanphi - 1);
            phi += dphi;
            if (Math.abs(dphi) <= EPSLN) {
              lat = phi;
              break;
            }
          }
          lon = adjust_lon(this.long0 + (Math.asin(x * Math.tan(phi) / this.a)) / Math.sin(lat));
        }
      }
      else {
        if (Math.abs(y + this.ml0) <= EPSLN) {
          lat = 0;
          lon = adjust_lon(this.long0 + x / this.a);
        }
        else {

          al = (this.ml0 + y) / this.a;
          bl = x * x / this.a / this.a + al * al;
          phi = al;
          var cl, mln, mlnp, ma;
          var con;
          for (i = MAX_ITER$2; i; --i) {
            con = this.e * Math.sin(phi);
            cl = Math.sqrt(1 - con * con) * Math.tan(phi);
            mln = this.a * mlfn(this.e0, this.e1, this.e2, this.e3, phi);
            mlnp = this.e0 - 2 * this.e1 * Math.cos(2 * phi) + 4 * this.e2 * Math.cos(4 * phi) - 6 * this.e3 * Math.cos(6 * phi);
            ma = mln / this.a;
            dphi = (al * (cl * ma + 1) - ma - 0.5 * cl * (ma * ma + bl)) / (this.es * Math.sin(2 * phi) * (ma * ma + bl - 2 * al * ma) / (4 * cl) + (al - ma) * (cl * mlnp - 2 / Math.sin(2 * phi)) - mlnp);
            phi -= dphi;
            if (Math.abs(dphi) <= EPSLN) {
              lat = phi;
              break;
            }
          }

          //lat=phi4z(this.e,this.e0,this.e1,this.e2,this.e3,al,bl,0,0);
          cl = Math.sqrt(1 - this.es * Math.pow(Math.sin(lat), 2)) * Math.tan(lat);
          lon = adjust_lon(this.long0 + Math.asin(x * cl / this.a) / Math.sin(lat));
        }
      }

      p.x = lon;
      p.y = lat;
      return p;
    }

    var names$19 = ["Polyconic", "poly"];
    var poly = {
      init: init$18,
      forward: forward$17,
      inverse: inverse$17,
      names: names$19
    };

    /*
      reference
        Department of Land and Survey Technical Circular 1973/32
          http://www.linz.govt.nz/docs/miscellaneous/nz-map-definition.pdf
        OSG Technical Report 4.1
          http://www.linz.govt.nz/docs/miscellaneous/nzmg.pdf
      */

    /**
     * iterations: Number of iterations to refine inverse transform.
     *     0 -> km accuracy
     *     1 -> m accuracy -- suitable for most mapping applications
     *     2 -> mm accuracy
     */


    function init$19() {
      this.A = [];
      this.A[1] = 0.6399175073;
      this.A[2] = -0.1358797613;
      this.A[3] = 0.063294409;
      this.A[4] = -0.02526853;
      this.A[5] = 0.0117879;
      this.A[6] = -0.0055161;
      this.A[7] = 0.0026906;
      this.A[8] = -0.001333;
      this.A[9] = 0.00067;
      this.A[10] = -0.00034;

      this.B_re = [];
      this.B_im = [];
      this.B_re[1] = 0.7557853228;
      this.B_im[1] = 0;
      this.B_re[2] = 0.249204646;
      this.B_im[2] = 0.003371507;
      this.B_re[3] = -0.001541739;
      this.B_im[3] = 0.041058560;
      this.B_re[4] = -0.10162907;
      this.B_im[4] = 0.01727609;
      this.B_re[5] = -0.26623489;
      this.B_im[5] = -0.36249218;
      this.B_re[6] = -0.6870983;
      this.B_im[6] = -1.1651967;

      this.C_re = [];
      this.C_im = [];
      this.C_re[1] = 1.3231270439;
      this.C_im[1] = 0;
      this.C_re[2] = -0.577245789;
      this.C_im[2] = -0.007809598;
      this.C_re[3] = 0.508307513;
      this.C_im[3] = -0.112208952;
      this.C_re[4] = -0.15094762;
      this.C_im[4] = 0.18200602;
      this.C_re[5] = 1.01418179;
      this.C_im[5] = 1.64497696;
      this.C_re[6] = 1.9660549;
      this.C_im[6] = 2.5127645;

      this.D = [];
      this.D[1] = 1.5627014243;
      this.D[2] = 0.5185406398;
      this.D[3] = -0.03333098;
      this.D[4] = -0.1052906;
      this.D[5] = -0.0368594;
      this.D[6] = 0.007317;
      this.D[7] = 0.01220;
      this.D[8] = 0.00394;
      this.D[9] = -0.0013;
    }

    /**
        New Zealand Map Grid Forward  - long/lat to x/y
        long/lat in radians
      */
    function forward$18(p) {
      var n;
      var lon = p.x;
      var lat = p.y;

      var delta_lat = lat - this.lat0;
      var delta_lon = lon - this.long0;

      // 1. Calculate d_phi and d_psi    ...                          // and d_lambda
      // For this algorithm, delta_latitude is in seconds of arc x 10-5, so we need to scale to those units. Longitude is radians.
      var d_phi = delta_lat / SEC_TO_RAD * 1E-5;
      var d_lambda = delta_lon;
      var d_phi_n = 1; // d_phi^0

      var d_psi = 0;
      for (n = 1; n <= 10; n++) {
        d_phi_n = d_phi_n * d_phi;
        d_psi = d_psi + this.A[n] * d_phi_n;
      }

      // 2. Calculate theta
      var th_re = d_psi;
      var th_im = d_lambda;

      // 3. Calculate z
      var th_n_re = 1;
      var th_n_im = 0; // theta^0
      var th_n_re1;
      var th_n_im1;

      var z_re = 0;
      var z_im = 0;
      for (n = 1; n <= 6; n++) {
        th_n_re1 = th_n_re * th_re - th_n_im * th_im;
        th_n_im1 = th_n_im * th_re + th_n_re * th_im;
        th_n_re = th_n_re1;
        th_n_im = th_n_im1;
        z_re = z_re + this.B_re[n] * th_n_re - this.B_im[n] * th_n_im;
        z_im = z_im + this.B_im[n] * th_n_re + this.B_re[n] * th_n_im;
      }

      // 4. Calculate easting and northing
      p.x = (z_im * this.a) + this.x0;
      p.y = (z_re * this.a) + this.y0;

      return p;
    }

    /**
        New Zealand Map Grid Inverse  -  x/y to long/lat
      */
    function inverse$18(p) {
      var n;
      var x = p.x;
      var y = p.y;

      var delta_x = x - this.x0;
      var delta_y = y - this.y0;

      // 1. Calculate z
      var z_re = delta_y / this.a;
      var z_im = delta_x / this.a;

      // 2a. Calculate theta - first approximation gives km accuracy
      var z_n_re = 1;
      var z_n_im = 0; // z^0
      var z_n_re1;
      var z_n_im1;

      var th_re = 0;
      var th_im = 0;
      for (n = 1; n <= 6; n++) {
        z_n_re1 = z_n_re * z_re - z_n_im * z_im;
        z_n_im1 = z_n_im * z_re + z_n_re * z_im;
        z_n_re = z_n_re1;
        z_n_im = z_n_im1;
        th_re = th_re + this.C_re[n] * z_n_re - this.C_im[n] * z_n_im;
        th_im = th_im + this.C_im[n] * z_n_re + this.C_re[n] * z_n_im;
      }

      // 2b. Iterate to refine the accuracy of the calculation
      //        0 iterations gives km accuracy
      //        1 iteration gives m accuracy -- good enough for most mapping applications
      //        2 iterations bives mm accuracy
      for (var i = 0; i < this.iterations; i++) {
        var th_n_re = th_re;
        var th_n_im = th_im;
        var th_n_re1;
        var th_n_im1;

        var num_re = z_re;
        var num_im = z_im;
        for (n = 2; n <= 6; n++) {
          th_n_re1 = th_n_re * th_re - th_n_im * th_im;
          th_n_im1 = th_n_im * th_re + th_n_re * th_im;
          th_n_re = th_n_re1;
          th_n_im = th_n_im1;
          num_re = num_re + (n - 1) * (this.B_re[n] * th_n_re - this.B_im[n] * th_n_im);
          num_im = num_im + (n - 1) * (this.B_im[n] * th_n_re + this.B_re[n] * th_n_im);
        }

        th_n_re = 1;
        th_n_im = 0;
        var den_re = this.B_re[1];
        var den_im = this.B_im[1];
        for (n = 2; n <= 6; n++) {
          th_n_re1 = th_n_re * th_re - th_n_im * th_im;
          th_n_im1 = th_n_im * th_re + th_n_re * th_im;
          th_n_re = th_n_re1;
          th_n_im = th_n_im1;
          den_re = den_re + n * (this.B_re[n] * th_n_re - this.B_im[n] * th_n_im);
          den_im = den_im + n * (this.B_im[n] * th_n_re + this.B_re[n] * th_n_im);
        }

        // Complex division
        var den2 = den_re * den_re + den_im * den_im;
        th_re = (num_re * den_re + num_im * den_im) / den2;
        th_im = (num_im * den_re - num_re * den_im) / den2;
      }

      // 3. Calculate d_phi              ...                                    // and d_lambda
      var d_psi = th_re;
      var d_lambda = th_im;
      var d_psi_n = 1; // d_psi^0

      var d_phi = 0;
      for (n = 1; n <= 9; n++) {
        d_psi_n = d_psi_n * d_psi;
        d_phi = d_phi + this.D[n] * d_psi_n;
      }

      // 4. Calculate latitude and longitude
      // d_phi is calcuated in second of arc * 10^-5, so we need to scale back to radians. d_lambda is in radians.
      var lat = this.lat0 + (d_phi * SEC_TO_RAD * 1E5);
      var lon = this.long0 + d_lambda;

      p.x = lon;
      p.y = lat;

      return p;
    }

    var names$20 = ["New_Zealand_Map_Grid", "nzmg"];
    var nzmg = {
      init: init$19,
      forward: forward$18,
      inverse: inverse$18,
      names: names$20
    };

    /*
      reference
        "New Equal-Area Map Projections for Noncircular Regions", John P. Snyder,
        The American Cartographer, Vol 15, No. 4, October 1988, pp. 341-355.
      */


    /* Initialize the Miller Cylindrical projection
      -------------------------------------------*/
    function init$20() {
      //no-op
    }

    /* Miller Cylindrical forward equations--mapping lat,long to x,y
        ------------------------------------------------------------*/
    function forward$19(p) {
      var lon = p.x;
      var lat = p.y;
      /* Forward equations
          -----------------*/
      var dlon = adjust_lon(lon - this.long0);
      var x = this.x0 + this.a * dlon;
      var y = this.y0 + this.a * Math.log(Math.tan((Math.PI / 4) + (lat / 2.5))) * 1.25;

      p.x = x;
      p.y = y;
      return p;
    }

    /* Miller Cylindrical inverse equations--mapping x,y to lat/long
        ------------------------------------------------------------*/
    function inverse$19(p) {
      p.x -= this.x0;
      p.y -= this.y0;

      var lon = adjust_lon(this.long0 + p.x / this.a);
      var lat = 2.5 * (Math.atan(Math.exp(0.8 * p.y / this.a)) - Math.PI / 4);

      p.x = lon;
      p.y = lat;
      return p;
    }

    var names$21 = ["Miller_Cylindrical", "mill"];
    var mill = {
      init: init$20,
      forward: forward$19,
      inverse: inverse$19,
      names: names$21
    };

    var MAX_ITER$3 = 20;
    function init$21() {
      /* Place parameters in static storage for common use
        -------------------------------------------------*/


      if (!this.sphere) {
        this.en = pj_enfn(this.es);
      }
      else {
        this.n = 1;
        this.m = 0;
        this.es = 0;
        this.C_y = Math.sqrt((this.m + 1) / this.n);
        this.C_x = this.C_y / (this.m + 1);
      }

    }

    /* Sinusoidal forward equations--mapping lat,long to x,y
      -----------------------------------------------------*/
    function forward$20(p) {
      var x, y;
      var lon = p.x;
      var lat = p.y;
      /* Forward equations
        -----------------*/
      lon = adjust_lon(lon - this.long0);

      if (this.sphere) {
        if (!this.m) {
          lat = this.n !== 1 ? Math.asin(this.n * Math.sin(lat)) : lat;
        }
        else {
          var k = this.n * Math.sin(lat);
          for (var i = MAX_ITER$3; i; --i) {
            var V = (this.m * lat + Math.sin(lat) - k) / (this.m + Math.cos(lat));
            lat -= V;
            if (Math.abs(V) < EPSLN) {
              break;
            }
          }
        }
        x = this.a * this.C_x * lon * (this.m + Math.cos(lat));
        y = this.a * this.C_y * lat;

      }
      else {

        var s = Math.sin(lat);
        var c = Math.cos(lat);
        y = this.a * pj_mlfn(lat, s, c, this.en);
        x = this.a * lon * c / Math.sqrt(1 - this.es * s * s);
      }

      p.x = x;
      p.y = y;
      return p;
    }

    function inverse$20(p) {
      var lat, temp, lon, s;

      p.x -= this.x0;
      lon = p.x / this.a;
      p.y -= this.y0;
      lat = p.y / this.a;

      if (this.sphere) {
        lat /= this.C_y;
        lon = lon / (this.C_x * (this.m + Math.cos(lat)));
        if (this.m) {
          lat = asinz((this.m * lat + Math.sin(lat)) / this.n);
        }
        else if (this.n !== 1) {
          lat = asinz(Math.sin(lat) / this.n);
        }
        lon = adjust_lon(lon + this.long0);
        lat = adjust_lat(lat);
      }
      else {
        lat = pj_inv_mlfn(p.y / this.a, this.es, this.en);
        s = Math.abs(lat);
        if (s < HALF_PI) {
          s = Math.sin(lat);
          temp = this.long0 + p.x * Math.sqrt(1 - this.es * s * s) / (this.a * Math.cos(lat));
          //temp = this.long0 + p.x / (this.a * Math.cos(lat));
          lon = adjust_lon(temp);
        }
        else if ((s - EPSLN) < HALF_PI) {
          lon = this.long0;
        }
      }
      p.x = lon;
      p.y = lat;
      return p;
    }

    var names$22 = ["Sinusoidal", "sinu"];
    var sinu = {
      init: init$21,
      forward: forward$20,
      inverse: inverse$20,
      names: names$22
    };

    function init$22() {}
    /* Mollweide forward equations--mapping lat,long to x,y
        ----------------------------------------------------*/
    function forward$21(p) {

      /* Forward equations
          -----------------*/
      var lon = p.x;
      var lat = p.y;

      var delta_lon = adjust_lon(lon - this.long0);
      var theta = lat;
      var con = Math.PI * Math.sin(lat);

      /* Iterate using the Newton-Raphson method to find theta
          -----------------------------------------------------*/
      while (true) {
        var delta_theta = -(theta + Math.sin(theta) - con) / (1 + Math.cos(theta));
        theta += delta_theta;
        if (Math.abs(delta_theta) < EPSLN) {
          break;
        }
      }
      theta /= 2;

      /* If the latitude is 90 deg, force the x coordinate to be "0 + false easting"
           this is done here because of precision problems with "cos(theta)"
           --------------------------------------------------------------------------*/
      if (Math.PI / 2 - Math.abs(lat) < EPSLN) {
        delta_lon = 0;
      }
      var x = 0.900316316158 * this.a * delta_lon * Math.cos(theta) + this.x0;
      var y = 1.4142135623731 * this.a * Math.sin(theta) + this.y0;

      p.x = x;
      p.y = y;
      return p;
    }

    function inverse$21(p) {
      var theta;
      var arg;

      /* Inverse equations
          -----------------*/
      p.x -= this.x0;
      p.y -= this.y0;
      arg = p.y / (1.4142135623731 * this.a);

      /* Because of division by zero problems, 'arg' can not be 1.  Therefore
           a number very close to one is used instead.
           -------------------------------------------------------------------*/
      if (Math.abs(arg) > 0.999999999999) {
        arg = 0.999999999999;
      }
      theta = Math.asin(arg);
      var lon = adjust_lon(this.long0 + (p.x / (0.900316316158 * this.a * Math.cos(theta))));
      if (lon < (-Math.PI)) {
        lon = -Math.PI;
      }
      if (lon > Math.PI) {
        lon = Math.PI;
      }
      arg = (2 * theta + Math.sin(2 * theta)) / Math.PI;
      if (Math.abs(arg) > 1) {
        arg = 1;
      }
      var lat = Math.asin(arg);

      p.x = lon;
      p.y = lat;
      return p;
    }

    var names$23 = ["Mollweide", "moll"];
    var moll = {
      init: init$22,
      forward: forward$21,
      inverse: inverse$21,
      names: names$23
    };

    function init$23() {

      /* Place parameters in static storage for common use
          -------------------------------------------------*/
      // Standard Parallels cannot be equal and on opposite sides of the equator
      if (Math.abs(this.lat1 + this.lat2) < EPSLN) {
        return;
      }
      this.lat2 = this.lat2 || this.lat1;
      this.temp = this.b / this.a;
      this.es = 1 - Math.pow(this.temp, 2);
      this.e = Math.sqrt(this.es);
      this.e0 = e0fn(this.es);
      this.e1 = e1fn(this.es);
      this.e2 = e2fn(this.es);
      this.e3 = e3fn(this.es);

      this.sinphi = Math.sin(this.lat1);
      this.cosphi = Math.cos(this.lat1);

      this.ms1 = msfnz(this.e, this.sinphi, this.cosphi);
      this.ml1 = mlfn(this.e0, this.e1, this.e2, this.e3, this.lat1);

      if (Math.abs(this.lat1 - this.lat2) < EPSLN) {
        this.ns = this.sinphi;
      }
      else {
        this.sinphi = Math.sin(this.lat2);
        this.cosphi = Math.cos(this.lat2);
        this.ms2 = msfnz(this.e, this.sinphi, this.cosphi);
        this.ml2 = mlfn(this.e0, this.e1, this.e2, this.e3, this.lat2);
        this.ns = (this.ms1 - this.ms2) / (this.ml2 - this.ml1);
      }
      this.g = this.ml1 + this.ms1 / this.ns;
      this.ml0 = mlfn(this.e0, this.e1, this.e2, this.e3, this.lat0);
      this.rh = this.a * (this.g - this.ml0);
    }

    /* Equidistant Conic forward equations--mapping lat,long to x,y
      -----------------------------------------------------------*/
    function forward$22(p) {
      var lon = p.x;
      var lat = p.y;
      var rh1;

      /* Forward equations
          -----------------*/
      if (this.sphere) {
        rh1 = this.a * (this.g - lat);
      }
      else {
        var ml = mlfn(this.e0, this.e1, this.e2, this.e3, lat);
        rh1 = this.a * (this.g - ml);
      }
      var theta = this.ns * adjust_lon(lon - this.long0);
      var x = this.x0 + rh1 * Math.sin(theta);
      var y = this.y0 + this.rh - rh1 * Math.cos(theta);
      p.x = x;
      p.y = y;
      return p;
    }

    /* Inverse equations
      -----------------*/
    function inverse$22(p) {
      p.x -= this.x0;
      p.y = this.rh - p.y + this.y0;
      var con, rh1, lat, lon;
      if (this.ns >= 0) {
        rh1 = Math.sqrt(p.x * p.x + p.y * p.y);
        con = 1;
      }
      else {
        rh1 = -Math.sqrt(p.x * p.x + p.y * p.y);
        con = -1;
      }
      var theta = 0;
      if (rh1 !== 0) {
        theta = Math.atan2(con * p.x, con * p.y);
      }

      if (this.sphere) {
        lon = adjust_lon(this.long0 + theta / this.ns);
        lat = adjust_lat(this.g - rh1 / this.a);
        p.x = lon;
        p.y = lat;
        return p;
      }
      else {
        var ml = this.g - rh1 / this.a;
        lat = imlfn(ml, this.e0, this.e1, this.e2, this.e3);
        lon = adjust_lon(this.long0 + theta / this.ns);
        p.x = lon;
        p.y = lat;
        return p;
      }

    }

    var names$24 = ["Equidistant_Conic", "eqdc"];
    var eqdc = {
      init: init$23,
      forward: forward$22,
      inverse: inverse$22,
      names: names$24
    };

    /* Initialize the Van Der Grinten projection
      ----------------------------------------*/
    function init$24() {
      //this.R = 6370997; //Radius of earth
      this.R = this.a;
    }

    function forward$23(p) {

      var lon = p.x;
      var lat = p.y;

      /* Forward equations
        -----------------*/
      var dlon = adjust_lon(lon - this.long0);
      var x, y;

      if (Math.abs(lat) <= EPSLN) {
        x = this.x0 + this.R * dlon;
        y = this.y0;
      }
      var theta = asinz(2 * Math.abs(lat / Math.PI));
      if ((Math.abs(dlon) <= EPSLN) || (Math.abs(Math.abs(lat) - HALF_PI) <= EPSLN)) {
        x = this.x0;
        if (lat >= 0) {
          y = this.y0 + Math.PI * this.R * Math.tan(0.5 * theta);
        }
        else {
          y = this.y0 + Math.PI * this.R * -Math.tan(0.5 * theta);
        }
        //  return(OK);
      }
      var al = 0.5 * Math.abs((Math.PI / dlon) - (dlon / Math.PI));
      var asq = al * al;
      var sinth = Math.sin(theta);
      var costh = Math.cos(theta);

      var g = costh / (sinth + costh - 1);
      var gsq = g * g;
      var m = g * (2 / sinth - 1);
      var msq = m * m;
      var con = Math.PI * this.R * (al * (g - msq) + Math.sqrt(asq * (g - msq) * (g - msq) - (msq + asq) * (gsq - msq))) / (msq + asq);
      if (dlon < 0) {
        con = -con;
      }
      x = this.x0 + con;
      //con = Math.abs(con / (Math.PI * this.R));
      var q = asq + g;
      con = Math.PI * this.R * (m * q - al * Math.sqrt((msq + asq) * (asq + 1) - q * q)) / (msq + asq);
      if (lat >= 0) {
        //y = this.y0 + Math.PI * this.R * Math.sqrt(1 - con * con - 2 * al * con);
        y = this.y0 + con;
      }
      else {
        //y = this.y0 - Math.PI * this.R * Math.sqrt(1 - con * con - 2 * al * con);
        y = this.y0 - con;
      }
      p.x = x;
      p.y = y;
      return p;
    }

    /* Van Der Grinten inverse equations--mapping x,y to lat/long
      ---------------------------------------------------------*/
    function inverse$23(p) {
      var lon, lat;
      var xx, yy, xys, c1, c2, c3;
      var a1;
      var m1;
      var con;
      var th1;
      var d;

      /* inverse equations
        -----------------*/
      p.x -= this.x0;
      p.y -= this.y0;
      con = Math.PI * this.R;
      xx = p.x / con;
      yy = p.y / con;
      xys = xx * xx + yy * yy;
      c1 = -Math.abs(yy) * (1 + xys);
      c2 = c1 - 2 * yy * yy + xx * xx;
      c3 = -2 * c1 + 1 + 2 * yy * yy + xys * xys;
      d = yy * yy / c3 + (2 * c2 * c2 * c2 / c3 / c3 / c3 - 9 * c1 * c2 / c3 / c3) / 27;
      a1 = (c1 - c2 * c2 / 3 / c3) / c3;
      m1 = 2 * Math.sqrt(-a1 / 3);
      con = ((3 * d) / a1) / m1;
      if (Math.abs(con) > 1) {
        if (con >= 0) {
          con = 1;
        }
        else {
          con = -1;
        }
      }
      th1 = Math.acos(con) / 3;
      if (p.y >= 0) {
        lat = (-m1 * Math.cos(th1 + Math.PI / 3) - c2 / 3 / c3) * Math.PI;
      }
      else {
        lat = -(-m1 * Math.cos(th1 + Math.PI / 3) - c2 / 3 / c3) * Math.PI;
      }

      if (Math.abs(xx) < EPSLN) {
        lon = this.long0;
      }
      else {
        lon = adjust_lon(this.long0 + Math.PI * (xys - 1 + Math.sqrt(1 + 2 * (xx * xx - yy * yy) + xys * xys)) / 2 / xx);
      }

      p.x = lon;
      p.y = lat;
      return p;
    }

    var names$25 = ["Van_der_Grinten_I", "VanDerGrinten", "vandg"];
    var vandg = {
      init: init$24,
      forward: forward$23,
      inverse: inverse$23,
      names: names$25
    };

    function init$25() {
      this.sin_p12 = Math.sin(this.lat0);
      this.cos_p12 = Math.cos(this.lat0);
    }

    function forward$24(p) {
      var lon = p.x;
      var lat = p.y;
      var sinphi = Math.sin(p.y);
      var cosphi = Math.cos(p.y);
      var dlon = adjust_lon(lon - this.long0);
      var e0, e1, e2, e3, Mlp, Ml, tanphi, Nl1, Nl, psi, Az, G, H, GH, Hs, c, kp, cos_c, s, s2, s3, s4, s5;
      if (this.sphere) {
        if (Math.abs(this.sin_p12 - 1) <= EPSLN) {
          //North Pole case
          p.x = this.x0 + this.a * (HALF_PI - lat) * Math.sin(dlon);
          p.y = this.y0 - this.a * (HALF_PI - lat) * Math.cos(dlon);
          return p;
        }
        else if (Math.abs(this.sin_p12 + 1) <= EPSLN) {
          //South Pole case
          p.x = this.x0 + this.a * (HALF_PI + lat) * Math.sin(dlon);
          p.y = this.y0 + this.a * (HALF_PI + lat) * Math.cos(dlon);
          return p;
        }
        else {
          //default case
          cos_c = this.sin_p12 * sinphi + this.cos_p12 * cosphi * Math.cos(dlon);
          c = Math.acos(cos_c);
          kp = c ? c / Math.sin(c) : 1;
          p.x = this.x0 + this.a * kp * cosphi * Math.sin(dlon);
          p.y = this.y0 + this.a * kp * (this.cos_p12 * sinphi - this.sin_p12 * cosphi * Math.cos(dlon));
          return p;
        }
      }
      else {
        e0 = e0fn(this.es);
        e1 = e1fn(this.es);
        e2 = e2fn(this.es);
        e3 = e3fn(this.es);
        if (Math.abs(this.sin_p12 - 1) <= EPSLN) {
          //North Pole case
          Mlp = this.a * mlfn(e0, e1, e2, e3, HALF_PI);
          Ml = this.a * mlfn(e0, e1, e2, e3, lat);
          p.x = this.x0 + (Mlp - Ml) * Math.sin(dlon);
          p.y = this.y0 - (Mlp - Ml) * Math.cos(dlon);
          return p;
        }
        else if (Math.abs(this.sin_p12 + 1) <= EPSLN) {
          //South Pole case
          Mlp = this.a * mlfn(e0, e1, e2, e3, HALF_PI);
          Ml = this.a * mlfn(e0, e1, e2, e3, lat);
          p.x = this.x0 + (Mlp + Ml) * Math.sin(dlon);
          p.y = this.y0 + (Mlp + Ml) * Math.cos(dlon);
          return p;
        }
        else {
          //Default case
          tanphi = sinphi / cosphi;
          Nl1 = gN(this.a, this.e, this.sin_p12);
          Nl = gN(this.a, this.e, sinphi);
          psi = Math.atan((1 - this.es) * tanphi + this.es * Nl1 * this.sin_p12 / (Nl * cosphi));
          Az = Math.atan2(Math.sin(dlon), this.cos_p12 * Math.tan(psi) - this.sin_p12 * Math.cos(dlon));
          if (Az === 0) {
            s = Math.asin(this.cos_p12 * Math.sin(psi) - this.sin_p12 * Math.cos(psi));
          }
          else if (Math.abs(Math.abs(Az) - Math.PI) <= EPSLN) {
            s = -Math.asin(this.cos_p12 * Math.sin(psi) - this.sin_p12 * Math.cos(psi));
          }
          else {
            s = Math.asin(Math.sin(dlon) * Math.cos(psi) / Math.sin(Az));
          }
          G = this.e * this.sin_p12 / Math.sqrt(1 - this.es);
          H = this.e * this.cos_p12 * Math.cos(Az) / Math.sqrt(1 - this.es);
          GH = G * H;
          Hs = H * H;
          s2 = s * s;
          s3 = s2 * s;
          s4 = s3 * s;
          s5 = s4 * s;
          c = Nl1 * s * (1 - s2 * Hs * (1 - Hs) / 6 + s3 / 8 * GH * (1 - 2 * Hs) + s4 / 120 * (Hs * (4 - 7 * Hs) - 3 * G * G * (1 - 7 * Hs)) - s5 / 48 * GH);
          p.x = this.x0 + c * Math.sin(Az);
          p.y = this.y0 + c * Math.cos(Az);
          return p;
        }
      }


    }

    function inverse$24(p) {
      p.x -= this.x0;
      p.y -= this.y0;
      var rh, z, sinz, cosz, lon, lat, con, e0, e1, e2, e3, Mlp, M, N1, psi, Az, cosAz, tmp, A, B, D, Ee, F, sinpsi;
      if (this.sphere) {
        rh = Math.sqrt(p.x * p.x + p.y * p.y);
        if (rh > (2 * HALF_PI * this.a)) {
          return;
        }
        z = rh / this.a;

        sinz = Math.sin(z);
        cosz = Math.cos(z);

        lon = this.long0;
        if (Math.abs(rh) <= EPSLN) {
          lat = this.lat0;
        }
        else {
          lat = asinz(cosz * this.sin_p12 + (p.y * sinz * this.cos_p12) / rh);
          con = Math.abs(this.lat0) - HALF_PI;
          if (Math.abs(con) <= EPSLN) {
            if (this.lat0 >= 0) {
              lon = adjust_lon(this.long0 + Math.atan2(p.x, - p.y));
            }
            else {
              lon = adjust_lon(this.long0 - Math.atan2(-p.x, p.y));
            }
          }
          else {
            /*con = cosz - this.sin_p12 * Math.sin(lat);
            if ((Math.abs(con) < EPSLN) && (Math.abs(p.x) < EPSLN)) {
              //no-op, just keep the lon value as is
            } else {
              var temp = Math.atan2((p.x * sinz * this.cos_p12), (con * rh));
              lon = adjust_lon(this.long0 + Math.atan2((p.x * sinz * this.cos_p12), (con * rh)));
            }*/
            lon = adjust_lon(this.long0 + Math.atan2(p.x * sinz, rh * this.cos_p12 * cosz - p.y * this.sin_p12 * sinz));
          }
        }

        p.x = lon;
        p.y = lat;
        return p;
      }
      else {
        e0 = e0fn(this.es);
        e1 = e1fn(this.es);
        e2 = e2fn(this.es);
        e3 = e3fn(this.es);
        if (Math.abs(this.sin_p12 - 1) <= EPSLN) {
          //North pole case
          Mlp = this.a * mlfn(e0, e1, e2, e3, HALF_PI);
          rh = Math.sqrt(p.x * p.x + p.y * p.y);
          M = Mlp - rh;
          lat = imlfn(M / this.a, e0, e1, e2, e3);
          lon = adjust_lon(this.long0 + Math.atan2(p.x, - 1 * p.y));
          p.x = lon;
          p.y = lat;
          return p;
        }
        else if (Math.abs(this.sin_p12 + 1) <= EPSLN) {
          //South pole case
          Mlp = this.a * mlfn(e0, e1, e2, e3, HALF_PI);
          rh = Math.sqrt(p.x * p.x + p.y * p.y);
          M = rh - Mlp;

          lat = imlfn(M / this.a, e0, e1, e2, e3);
          lon = adjust_lon(this.long0 + Math.atan2(p.x, p.y));
          p.x = lon;
          p.y = lat;
          return p;
        }
        else {
          //default case
          rh = Math.sqrt(p.x * p.x + p.y * p.y);
          Az = Math.atan2(p.x, p.y);
          N1 = gN(this.a, this.e, this.sin_p12);
          cosAz = Math.cos(Az);
          tmp = this.e * this.cos_p12 * cosAz;
          A = -tmp * tmp / (1 - this.es);
          B = 3 * this.es * (1 - A) * this.sin_p12 * this.cos_p12 * cosAz / (1 - this.es);
          D = rh / N1;
          Ee = D - A * (1 + A) * Math.pow(D, 3) / 6 - B * (1 + 3 * A) * Math.pow(D, 4) / 24;
          F = 1 - A * Ee * Ee / 2 - D * Ee * Ee * Ee / 6;
          psi = Math.asin(this.sin_p12 * Math.cos(Ee) + this.cos_p12 * Math.sin(Ee) * cosAz);
          lon = adjust_lon(this.long0 + Math.asin(Math.sin(Az) * Math.sin(Ee) / Math.cos(psi)));
          sinpsi = Math.sin(psi);
          lat = Math.atan2((sinpsi - this.es * F * this.sin_p12) * Math.tan(psi), sinpsi * (1 - this.es));
          p.x = lon;
          p.y = lat;
          return p;
        }
      }

    }

    var names$26 = ["Azimuthal_Equidistant", "aeqd"];
    var aeqd = {
      init: init$25,
      forward: forward$24,
      inverse: inverse$24,
      names: names$26
    };

    function init$26() {
      //double temp;      /* temporary variable    */

      /* Place parameters in static storage for common use
          -------------------------------------------------*/
      this.sin_p14 = Math.sin(this.lat0);
      this.cos_p14 = Math.cos(this.lat0);
    }

    /* Orthographic forward equations--mapping lat,long to x,y
        ---------------------------------------------------*/
    function forward$25(p) {
      var sinphi, cosphi; /* sin and cos value        */
      var dlon; /* delta longitude value      */
      var coslon; /* cos of longitude        */
      var ksp; /* scale factor          */
      var g, x, y;
      var lon = p.x;
      var lat = p.y;
      /* Forward equations
          -----------------*/
      dlon = adjust_lon(lon - this.long0);

      sinphi = Math.sin(lat);
      cosphi = Math.cos(lat);

      coslon = Math.cos(dlon);
      g = this.sin_p14 * sinphi + this.cos_p14 * cosphi * coslon;
      ksp = 1;
      if ((g > 0) || (Math.abs(g) <= EPSLN)) {
        x = this.a * ksp * cosphi * Math.sin(dlon);
        y = this.y0 + this.a * ksp * (this.cos_p14 * sinphi - this.sin_p14 * cosphi * coslon);
      }
      p.x = x;
      p.y = y;
      return p;
    }

    function inverse$25(p) {
      var rh; /* height above ellipsoid      */
      var z; /* angle          */
      var sinz, cosz; /* sin of z and cos of z      */
      var con;
      var lon, lat;
      /* Inverse equations
          -----------------*/
      p.x -= this.x0;
      p.y -= this.y0;
      rh = Math.sqrt(p.x * p.x + p.y * p.y);
      z = asinz(rh / this.a);

      sinz = Math.sin(z);
      cosz = Math.cos(z);

      lon = this.long0;
      if (Math.abs(rh) <= EPSLN) {
        lat = this.lat0;
        p.x = lon;
        p.y = lat;
        return p;
      }
      lat = asinz(cosz * this.sin_p14 + (p.y * sinz * this.cos_p14) / rh);
      con = Math.abs(this.lat0) - HALF_PI;
      if (Math.abs(con) <= EPSLN) {
        if (this.lat0 >= 0) {
          lon = adjust_lon(this.long0 + Math.atan2(p.x, - p.y));
        }
        else {
          lon = adjust_lon(this.long0 - Math.atan2(-p.x, p.y));
        }
        p.x = lon;
        p.y = lat;
        return p;
      }
      lon = adjust_lon(this.long0 + Math.atan2((p.x * sinz), rh * this.cos_p14 * cosz - p.y * this.sin_p14 * sinz));
      p.x = lon;
      p.y = lat;
      return p;
    }

    var names$27 = ["ortho"];
    var ortho = {
      init: init$26,
      forward: forward$25,
      inverse: inverse$25,
      names: names$27
    };

    // QSC projection rewritten from the original PROJ4
    // https://github.com/OSGeo/proj.4/blob/master/src/PJ_qsc.c

    /* constants */
    var FACE_ENUM = {
        FRONT: 1,
        RIGHT: 2,
        BACK: 3,
        LEFT: 4,
        TOP: 5,
        BOTTOM: 6
    };

    var AREA_ENUM = {
        AREA_0: 1,
        AREA_1: 2,
        AREA_2: 3,
        AREA_3: 4
    };

    function init$27() {

      this.x0 = this.x0 || 0;
      this.y0 = this.y0 || 0;
      this.lat0 = this.lat0 || 0;
      this.long0 = this.long0 || 0;
      this.lat_ts = this.lat_ts || 0;
      this.title = this.title || "Quadrilateralized Spherical Cube";

      /* Determine the cube face from the center of projection. */
      if (this.lat0 >= HALF_PI - FORTPI / 2.0) {
        this.face = FACE_ENUM.TOP;
      } else if (this.lat0 <= -(HALF_PI - FORTPI / 2.0)) {
        this.face = FACE_ENUM.BOTTOM;
      } else if (Math.abs(this.long0) <= FORTPI) {
        this.face = FACE_ENUM.FRONT;
      } else if (Math.abs(this.long0) <= HALF_PI + FORTPI) {
        this.face = this.long0 > 0.0 ? FACE_ENUM.RIGHT : FACE_ENUM.LEFT;
      } else {
        this.face = FACE_ENUM.BACK;
      }

      /* Fill in useful values for the ellipsoid <-> sphere shift
       * described in [LK12]. */
      if (this.es !== 0) {
        this.one_minus_f = 1 - (this.a - this.b) / this.a;
        this.one_minus_f_squared = this.one_minus_f * this.one_minus_f;
      }
    }

    // QSC forward equations--mapping lat,long to x,y
    // -----------------------------------------------------------------
    function forward$26(p) {
      var xy = {x: 0, y: 0};
      var lat, lon;
      var theta, phi;
      var t, mu;
      /* nu; */
      var area = {value: 0};

      // move lon according to projection's lon
      p.x -= this.long0;

      /* Convert the geodetic latitude to a geocentric latitude.
       * This corresponds to the shift from the ellipsoid to the sphere
       * described in [LK12]. */
      if (this.es !== 0) {//if (P->es != 0) {
        lat = Math.atan(this.one_minus_f_squared * Math.tan(p.y));
      } else {
        lat = p.y;
      }

      /* Convert the input lat, lon into theta, phi as used by QSC.
       * This depends on the cube face and the area on it.
       * For the top and bottom face, we can compute theta and phi
       * directly from phi, lam. For the other faces, we must use
       * unit sphere cartesian coordinates as an intermediate step. */
      lon = p.x; //lon = lp.lam;
      if (this.face === FACE_ENUM.TOP) {
        phi = HALF_PI - lat;
        if (lon >= FORTPI && lon <= HALF_PI + FORTPI) {
          area.value = AREA_ENUM.AREA_0;
          theta = lon - HALF_PI;
        } else if (lon > HALF_PI + FORTPI || lon <= -(HALF_PI + FORTPI)) {
          area.value = AREA_ENUM.AREA_1;
          theta = (lon > 0.0 ? lon - SPI : lon + SPI);
        } else if (lon > -(HALF_PI + FORTPI) && lon <= -FORTPI) {
          area.value = AREA_ENUM.AREA_2;
          theta = lon + HALF_PI;
        } else {
          area.value = AREA_ENUM.AREA_3;
          theta = lon;
        }
      } else if (this.face === FACE_ENUM.BOTTOM) {
        phi = HALF_PI + lat;
        if (lon >= FORTPI && lon <= HALF_PI + FORTPI) {
          area.value = AREA_ENUM.AREA_0;
          theta = -lon + HALF_PI;
        } else if (lon < FORTPI && lon >= -FORTPI) {
          area.value = AREA_ENUM.AREA_1;
          theta = -lon;
        } else if (lon < -FORTPI && lon >= -(HALF_PI + FORTPI)) {
          area.value = AREA_ENUM.AREA_2;
          theta = -lon - HALF_PI;
        } else {
          area.value = AREA_ENUM.AREA_3;
          theta = (lon > 0.0 ? -lon + SPI : -lon - SPI);
        }
      } else {
        var q, r, s;
        var sinlat, coslat;
        var sinlon, coslon;

        if (this.face === FACE_ENUM.RIGHT) {
          lon = qsc_shift_lon_origin(lon, +HALF_PI);
        } else if (this.face === FACE_ENUM.BACK) {
          lon = qsc_shift_lon_origin(lon, +SPI);
        } else if (this.face === FACE_ENUM.LEFT) {
          lon = qsc_shift_lon_origin(lon, -HALF_PI);
        }
        sinlat = Math.sin(lat);
        coslat = Math.cos(lat);
        sinlon = Math.sin(lon);
        coslon = Math.cos(lon);
        q = coslat * coslon;
        r = coslat * sinlon;
        s = sinlat;

        if (this.face === FACE_ENUM.FRONT) {
          phi = Math.acos(q);
          theta = qsc_fwd_equat_face_theta(phi, s, r, area);
        } else if (this.face === FACE_ENUM.RIGHT) {
          phi = Math.acos(r);
          theta = qsc_fwd_equat_face_theta(phi, s, -q, area);
        } else if (this.face === FACE_ENUM.BACK) {
          phi = Math.acos(-q);
          theta = qsc_fwd_equat_face_theta(phi, s, -r, area);
        } else if (this.face === FACE_ENUM.LEFT) {
          phi = Math.acos(-r);
          theta = qsc_fwd_equat_face_theta(phi, s, q, area);
        } else {
          /* Impossible */
          phi = theta = 0;
          area.value = AREA_ENUM.AREA_0;
        }
      }

      /* Compute mu and nu for the area of definition.
       * For mu, see Eq. (3-21) in [OL76], but note the typos:
       * compare with Eq. (3-14). For nu, see Eq. (3-38). */
      mu = Math.atan((12 / SPI) * (theta + Math.acos(Math.sin(theta) * Math.cos(FORTPI)) - HALF_PI));
      t = Math.sqrt((1 - Math.cos(phi)) / (Math.cos(mu) * Math.cos(mu)) / (1 - Math.cos(Math.atan(1 / Math.cos(theta)))));

      /* Apply the result to the real area. */
      if (area.value === AREA_ENUM.AREA_1) {
        mu += HALF_PI;
      } else if (area.value === AREA_ENUM.AREA_2) {
        mu += SPI;
      } else if (area.value === AREA_ENUM.AREA_3) {
        mu += 1.5 * SPI;
      }

      /* Now compute x, y from mu and nu */
      xy.x = t * Math.cos(mu);
      xy.y = t * Math.sin(mu);
      xy.x = xy.x * this.a + this.x0;
      xy.y = xy.y * this.a + this.y0;

      p.x = xy.x;
      p.y = xy.y;
      return p;
    }

    // QSC inverse equations--mapping x,y to lat/long
    // -----------------------------------------------------------------
    function inverse$26(p) {
      var lp = {lam: 0, phi: 0};
      var mu, nu, cosmu, tannu;
      var tantheta, theta, cosphi, phi;
      var t;
      var area = {value: 0};

      /* de-offset */
      p.x = (p.x - this.x0) / this.a;
      p.y = (p.y - this.y0) / this.a;

      /* Convert the input x, y to the mu and nu angles as used by QSC.
       * This depends on the area of the cube face. */
      nu = Math.atan(Math.sqrt(p.x * p.x + p.y * p.y));
      mu = Math.atan2(p.y, p.x);
      if (p.x >= 0.0 && p.x >= Math.abs(p.y)) {
        area.value = AREA_ENUM.AREA_0;
      } else if (p.y >= 0.0 && p.y >= Math.abs(p.x)) {
        area.value = AREA_ENUM.AREA_1;
        mu -= HALF_PI;
      } else if (p.x < 0.0 && -p.x >= Math.abs(p.y)) {
        area.value = AREA_ENUM.AREA_2;
        mu = (mu < 0.0 ? mu + SPI : mu - SPI);
      } else {
        area.value = AREA_ENUM.AREA_3;
        mu += HALF_PI;
      }

      /* Compute phi and theta for the area of definition.
       * The inverse projection is not described in the original paper, but some
       * good hints can be found here (as of 2011-12-14):
       * http://fits.gsfc.nasa.gov/fitsbits/saf.93/saf.9302
       * (search for "Message-Id: <9302181759.AA25477 at fits.cv.nrao.edu>") */
      t = (SPI / 12) * Math.tan(mu);
      tantheta = Math.sin(t) / (Math.cos(t) - (1 / Math.sqrt(2)));
      theta = Math.atan(tantheta);
      cosmu = Math.cos(mu);
      tannu = Math.tan(nu);
      cosphi = 1 - cosmu * cosmu * tannu * tannu * (1 - Math.cos(Math.atan(1 / Math.cos(theta))));
      if (cosphi < -1) {
        cosphi = -1;
      } else if (cosphi > +1) {
        cosphi = +1;
      }

      /* Apply the result to the real area on the cube face.
       * For the top and bottom face, we can compute phi and lam directly.
       * For the other faces, we must use unit sphere cartesian coordinates
       * as an intermediate step. */
      if (this.face === FACE_ENUM.TOP) {
        phi = Math.acos(cosphi);
        lp.phi = HALF_PI - phi;
        if (area.value === AREA_ENUM.AREA_0) {
          lp.lam = theta + HALF_PI;
        } else if (area.value === AREA_ENUM.AREA_1) {
          lp.lam = (theta < 0.0 ? theta + SPI : theta - SPI);
        } else if (area.value === AREA_ENUM.AREA_2) {
          lp.lam = theta - HALF_PI;
        } else /* area.value == AREA_ENUM.AREA_3 */ {
          lp.lam = theta;
        }
      } else if (this.face === FACE_ENUM.BOTTOM) {
        phi = Math.acos(cosphi);
        lp.phi = phi - HALF_PI;
        if (area.value === AREA_ENUM.AREA_0) {
          lp.lam = -theta + HALF_PI;
        } else if (area.value === AREA_ENUM.AREA_1) {
          lp.lam = -theta;
        } else if (area.value === AREA_ENUM.AREA_2) {
          lp.lam = -theta - HALF_PI;
        } else /* area.value == AREA_ENUM.AREA_3 */ {
          lp.lam = (theta < 0.0 ? -theta - SPI : -theta + SPI);
        }
      } else {
        /* Compute phi and lam via cartesian unit sphere coordinates. */
        var q, r, s;
        q = cosphi;
        t = q * q;
        if (t >= 1) {
          s = 0;
        } else {
          s = Math.sqrt(1 - t) * Math.sin(theta);
        }
        t += s * s;
        if (t >= 1) {
          r = 0;
        } else {
          r = Math.sqrt(1 - t);
        }
        /* Rotate q,r,s into the correct area. */
        if (area.value === AREA_ENUM.AREA_1) {
          t = r;
          r = -s;
          s = t;
        } else if (area.value === AREA_ENUM.AREA_2) {
          r = -r;
          s = -s;
        } else if (area.value === AREA_ENUM.AREA_3) {
          t = r;
          r = s;
          s = -t;
        }
        /* Rotate q,r,s into the correct cube face. */
        if (this.face === FACE_ENUM.RIGHT) {
          t = q;
          q = -r;
          r = t;
        } else if (this.face === FACE_ENUM.BACK) {
          q = -q;
          r = -r;
        } else if (this.face === FACE_ENUM.LEFT) {
          t = q;
          q = r;
          r = -t;
        }
        /* Now compute phi and lam from the unit sphere coordinates. */
        lp.phi = Math.acos(-s) - HALF_PI;
        lp.lam = Math.atan2(r, q);
        if (this.face === FACE_ENUM.RIGHT) {
          lp.lam = qsc_shift_lon_origin(lp.lam, -HALF_PI);
        } else if (this.face === FACE_ENUM.BACK) {
          lp.lam = qsc_shift_lon_origin(lp.lam, -SPI);
        } else if (this.face === FACE_ENUM.LEFT) {
          lp.lam = qsc_shift_lon_origin(lp.lam, +HALF_PI);
        }
      }

      /* Apply the shift from the sphere to the ellipsoid as described
       * in [LK12]. */
      if (this.es !== 0) {
        var invert_sign;
        var tanphi, xa;
        invert_sign = (lp.phi < 0 ? 1 : 0);
        tanphi = Math.tan(lp.phi);
        xa = this.b / Math.sqrt(tanphi * tanphi + this.one_minus_f_squared);
        lp.phi = Math.atan(Math.sqrt(this.a * this.a - xa * xa) / (this.one_minus_f * xa));
        if (invert_sign) {
          lp.phi = -lp.phi;
        }
      }

      lp.lam += this.long0;
      p.x = lp.lam;
      p.y = lp.phi;
      return p;
    }

    /* Helper function for forward projection: compute the theta angle
     * and determine the area number. */
    function qsc_fwd_equat_face_theta(phi, y, x, area) {
      var theta;
      if (phi < EPSLN) {
        area.value = AREA_ENUM.AREA_0;
        theta = 0.0;
      } else {
        theta = Math.atan2(y, x);
        if (Math.abs(theta) <= FORTPI) {
          area.value = AREA_ENUM.AREA_0;
        } else if (theta > FORTPI && theta <= HALF_PI + FORTPI) {
          area.value = AREA_ENUM.AREA_1;
          theta -= HALF_PI;
        } else if (theta > HALF_PI + FORTPI || theta <= -(HALF_PI + FORTPI)) {
          area.value = AREA_ENUM.AREA_2;
          theta = (theta >= 0.0 ? theta - SPI : theta + SPI);
        } else {
          area.value = AREA_ENUM.AREA_3;
          theta += HALF_PI;
        }
      }
      return theta;
    }

    /* Helper function: shift the longitude. */
    function qsc_shift_lon_origin(lon, offset) {
      var slon = lon + offset;
      if (slon < -SPI) {
        slon += TWO_PI;
      } else if (slon > +SPI) {
        slon -= TWO_PI;
      }
      return slon;
    }

    var names$28 = ["Quadrilateralized Spherical Cube", "Quadrilateralized_Spherical_Cube", "qsc"];
    var qsc = {
      init: init$27,
      forward: forward$26,
      inverse: inverse$26,
      names: names$28
    };

    // Robinson projection
    // Based on https://github.com/OSGeo/proj.4/blob/master/src/PJ_robin.c
    // Polynomial coeficients from http://article.gmane.org/gmane.comp.gis.proj-4.devel/6039

    var COEFS_X = [
        [1.0000, 2.2199e-17, -7.15515e-05, 3.1103e-06],
        [0.9986, -0.000482243, -2.4897e-05, -1.3309e-06],
        [0.9954, -0.00083103, -4.48605e-05, -9.86701e-07],
        [0.9900, -0.00135364, -5.9661e-05, 3.6777e-06],
        [0.9822, -0.00167442, -4.49547e-06, -5.72411e-06],
        [0.9730, -0.00214868, -9.03571e-05, 1.8736e-08],
        [0.9600, -0.00305085, -9.00761e-05, 1.64917e-06],
        [0.9427, -0.00382792, -6.53386e-05, -2.6154e-06],
        [0.9216, -0.00467746, -0.00010457, 4.81243e-06],
        [0.8962, -0.00536223, -3.23831e-05, -5.43432e-06],
        [0.8679, -0.00609363, -0.000113898, 3.32484e-06],
        [0.8350, -0.00698325, -6.40253e-05, 9.34959e-07],
        [0.7986, -0.00755338, -5.00009e-05, 9.35324e-07],
        [0.7597, -0.00798324, -3.5971e-05, -2.27626e-06],
        [0.7186, -0.00851367, -7.01149e-05, -8.6303e-06],
        [0.6732, -0.00986209, -0.000199569, 1.91974e-05],
        [0.6213, -0.010418, 8.83923e-05, 6.24051e-06],
        [0.5722, -0.00906601, 0.000182, 6.24051e-06],
        [0.5322, -0.00677797, 0.000275608, 6.24051e-06]
    ];

    var COEFS_Y = [
        [-5.20417e-18, 0.0124, 1.21431e-18, -8.45284e-11],
        [0.0620, 0.0124, -1.26793e-09, 4.22642e-10],
        [0.1240, 0.0124, 5.07171e-09, -1.60604e-09],
        [0.1860, 0.0123999, -1.90189e-08, 6.00152e-09],
        [0.2480, 0.0124002, 7.10039e-08, -2.24e-08],
        [0.3100, 0.0123992, -2.64997e-07, 8.35986e-08],
        [0.3720, 0.0124029, 9.88983e-07, -3.11994e-07],
        [0.4340, 0.0123893, -3.69093e-06, -4.35621e-07],
        [0.4958, 0.0123198, -1.02252e-05, -3.45523e-07],
        [0.5571, 0.0121916, -1.54081e-05, -5.82288e-07],
        [0.6176, 0.0119938, -2.41424e-05, -5.25327e-07],
        [0.6769, 0.011713, -3.20223e-05, -5.16405e-07],
        [0.7346, 0.0113541, -3.97684e-05, -6.09052e-07],
        [0.7903, 0.0109107, -4.89042e-05, -1.04739e-06],
        [0.8435, 0.0103431, -6.4615e-05, -1.40374e-09],
        [0.8936, 0.00969686, -6.4636e-05, -8.547e-06],
        [0.9394, 0.00840947, -0.000192841, -4.2106e-06],
        [0.9761, 0.00616527, -0.000256, -4.2106e-06],
        [1.0000, 0.00328947, -0.000319159, -4.2106e-06]
    ];

    var FXC = 0.8487;
    var FYC = 1.3523;
    var C1 = R2D/5; // rad to 5-degree interval
    var RC1 = 1/C1;
    var NODES = 18;

    var poly3_val = function(coefs, x) {
        return coefs[0] + x * (coefs[1] + x * (coefs[2] + x * coefs[3]));
    };

    var poly3_der = function(coefs, x) {
        return coefs[1] + x * (2 * coefs[2] + x * 3 * coefs[3]);
    };

    function newton_rapshon(f_df, start, max_err, iters) {
        var x = start;
        for (; iters; --iters) {
            var upd = f_df(x);
            x -= upd;
            if (Math.abs(upd) < max_err) {
                break;
            }
        }
        return x;
    }

    function init$28() {
        this.x0 = this.x0 || 0;
        this.y0 = this.y0 || 0;
        this.long0 = this.long0 || 0;
        this.es = 0;
        this.title = this.title || "Robinson";
    }

    function forward$27(ll) {
        var lon = adjust_lon(ll.x - this.long0);

        var dphi = Math.abs(ll.y);
        var i = Math.floor(dphi * C1);
        if (i < 0) {
            i = 0;
        } else if (i >= NODES) {
            i = NODES - 1;
        }
        dphi = R2D * (dphi - RC1 * i);
        var xy = {
            x: poly3_val(COEFS_X[i], dphi) * lon,
            y: poly3_val(COEFS_Y[i], dphi)
        };
        if (ll.y < 0) {
            xy.y = -xy.y;
        }

        xy.x = xy.x * this.a * FXC + this.x0;
        xy.y = xy.y * this.a * FYC + this.y0;
        return xy;
    }

    function inverse$27(xy) {
        var ll = {
            x: (xy.x - this.x0) / (this.a * FXC),
            y: Math.abs(xy.y - this.y0) / (this.a * FYC)
        };

        if (ll.y >= 1) { // pathologic case
            ll.x /= COEFS_X[NODES][0];
            ll.y = xy.y < 0 ? -HALF_PI : HALF_PI;
        } else {
            // find table interval
            var i = Math.floor(ll.y * NODES);
            if (i < 0) {
                i = 0;
            } else if (i >= NODES) {
                i = NODES - 1;
            }
            for (;;) {
                if (COEFS_Y[i][0] > ll.y) {
                    --i;
                } else if (COEFS_Y[i+1][0] <= ll.y) {
                    ++i;
                } else {
                    break;
                }
            }
            // linear interpolation in 5 degree interval
            var coefs = COEFS_Y[i];
            var t = 5 * (ll.y - coefs[0]) / (COEFS_Y[i+1][0] - coefs[0]);
            // find t so that poly3_val(coefs, t) = ll.y
            t = newton_rapshon(function(x) {
                return (poly3_val(coefs, x) - ll.y) / poly3_der(coefs, x);
            }, t, EPSLN, 100);

            ll.x /= poly3_val(COEFS_X[i], t);
            ll.y = (5 * i + t) * D2R;
            if (xy.y < 0) {
                ll.y = -ll.y;
            }
        }

        ll.x = adjust_lon(ll.x + this.long0);
        return ll;
    }

    var names$29 = ["Robinson", "robin"];
    var robin = {
      init: init$28,
      forward: forward$27,
      inverse: inverse$27,
      names: names$29
    };

    function init$29() {
        this.name = 'geocent';

    }

    function forward$28(p) {
        var point = geodeticToGeocentric(p, this.es, this.a);
        return point;
    }

    function inverse$28(p) {
        var point = geocentricToGeodetic(p, this.es, this.a, this.b);
        return point;
    }

    var names$30 = ["Geocentric", 'geocentric', "geocent", "Geocent"];
    var geocent = {
        init: init$29,
        forward: forward$28,
        inverse: inverse$28,
        names: names$30
    };

    var mode = {
      N_POLE: 0,
      S_POLE: 1,
      EQUIT: 2,
      OBLIQ: 3
    };

    var params = {
      h:     { def: 100000, num: true },           // default is Karman line, no default in PROJ.7
      azi:   { def: 0, num: true, degrees: true }, // default is North
      tilt:  { def: 0, num: true, degrees: true }, // default is Nadir
      long0: { def: 0, num: true },                // default is Greenwich, conversion to rad is automatic
      lat0:  { def: 0, num: true }                 // default is Equator, conversion to rad is automatic
    };

    function init$30() {
      Object.keys(params).forEach(function (p) {
        if (typeof this[p] === "undefined") {
          this[p] = params[p].def;
        } else if (params[p].num && isNaN(this[p])) {
          throw new Error("Invalid parameter value, must be numeric " + p + " = " + this[p]);
        } else if (params[p].num) {
          this[p] = parseFloat(this[p]);
        }
        if (params[p].degrees) {
          this[p] = this[p] * D2R;
        }
      }.bind(this));

      if (Math.abs((Math.abs(this.lat0) - HALF_PI)) < EPSLN) {
        this.mode = this.lat0 < 0 ? mode.S_POLE : mode.N_POLE;
      } else if (Math.abs(this.lat0) < EPSLN) {
        this.mode = mode.EQUIT;
      } else {
        this.mode = mode.OBLIQ;
        this.sinph0 = Math.sin(this.lat0);
        this.cosph0 = Math.cos(this.lat0);
      }

      this.pn1 = this.h / this.a;  // Normalize relative to the Earth's radius

      if (this.pn1 <= 0 || this.pn1 > 1e10) {
        throw new Error("Invalid height");
      }
      
      this.p = 1 + this.pn1;
      this.rp = 1 / this.p;
      this.h1 = 1 / this.pn1;
      this.pfact = (this.p + 1) * this.h1;
      this.es = 0;

      var omega = this.tilt;
      var gamma = this.azi;
      this.cg = Math.cos(gamma);
      this.sg = Math.sin(gamma);
      this.cw = Math.cos(omega);
      this.sw = Math.sin(omega);
    }

    function forward$29(p) {
      p.x -= this.long0;
      var sinphi = Math.sin(p.y);
      var cosphi = Math.cos(p.y);
      var coslam = Math.cos(p.x);
      var x, y;
      switch (this.mode) {
        case mode.OBLIQ:
          y = this.sinph0 * sinphi + this.cosph0 * cosphi * coslam;
          break;
        case mode.EQUIT:
          y = cosphi * coslam;
          break;
        case mode.S_POLE:
          y = -sinphi;
          break;
        case mode.N_POLE:
          y = sinphi;
          break;
      }
      y = this.pn1 / (this.p - y);
      x = y * cosphi * Math.sin(p.x);

      switch (this.mode) {
        case mode.OBLIQ:
          y *= this.cosph0 * sinphi - this.sinph0 * cosphi * coslam;
          break;
        case mode.EQUIT:
          y *= sinphi;
          break;
        case mode.N_POLE:
          y *= -(cosphi * coslam);
          break;
        case mode.S_POLE:
          y *= cosphi * coslam;
          break;
      }

      // Tilt 
      var yt, ba;
      yt = y * this.cg + x * this.sg;
      ba = 1 / (yt * this.sw * this.h1 + this.cw);
      x = (x * this.cg - y * this.sg) * this.cw * ba;
      y = yt * ba;

      p.x = x * this.a;
      p.y = y * this.a;
      return p;
    }

    function inverse$29(p) {
      p.x /= this.a;
      p.y /= this.a;
      var r = { x: p.x, y: p.y };

      // Un-Tilt
      var bm, bq, yt;
      yt = 1 / (this.pn1 - p.y * this.sw);
      bm = this.pn1 * p.x * yt;
      bq = this.pn1 * p.y * this.cw * yt;
      p.x = bm * this.cg + bq * this.sg;
      p.y = bq * this.cg - bm * this.sg;

      var rh = hypot(p.x, p.y);
      if (Math.abs(rh) < EPSLN) {
        r.x = 0;
        r.y = p.y;
      } else {
        var cosz, sinz;
        sinz = 1 - rh * rh * this.pfact;
        sinz = (this.p - Math.sqrt(sinz)) / (this.pn1 / rh + rh / this.pn1);
        cosz = Math.sqrt(1 - sinz * sinz);
        switch (this.mode) {
          case mode.OBLIQ:
            r.y = Math.asin(cosz * this.sinph0 + p.y * sinz * this.cosph0 / rh);
            p.y = (cosz - this.sinph0 * Math.sin(r.y)) * rh;
            p.x *= sinz * this.cosph0;
            break;
          case mode.EQUIT:
            r.y = Math.asin(p.y * sinz / rh);
            p.y = cosz * rh;
            p.x *= sinz;
            break;
          case mode.N_POLE:
            r.y = Math.asin(cosz);
            p.y = -p.y;
            break;
          case mode.S_POLE:
            r.y = -Math.asin(cosz);
            break;
        }
        r.x = Math.atan2(p.x, p.y);
      }

      p.x = r.x + this.long0;
      p.y = r.y;
      return p;
    }

    var names$31 = ["Tilted_Perspective", "tpers"];
    var tpers = {
      init: init$30,
      forward: forward$29,
      inverse: inverse$29,
      names: names$31
    };

    function init$31() {
        this.flip_axis = (this.sweep === 'x' ? 1 : 0);
        this.h = Number(this.h);
        this.radius_g_1 = this.h / this.a;

        if (this.radius_g_1 <= 0 || this.radius_g_1 > 1e10) {
            throw new Error();
        }

        this.radius_g = 1.0 + this.radius_g_1;
        this.C = this.radius_g * this.radius_g - 1.0;

        if (this.es !== 0.0) {
            var one_es = 1.0 - this.es;
            var rone_es = 1 / one_es;

            this.radius_p = Math.sqrt(one_es);
            this.radius_p2 = one_es;
            this.radius_p_inv2 = rone_es;

            this.shape = 'ellipse'; // Use as a condition in the forward and inverse functions.
        } else {
            this.radius_p = 1.0;
            this.radius_p2 = 1.0;
            this.radius_p_inv2 = 1.0;

            this.shape = 'sphere';  // Use as a condition in the forward and inverse functions.
        }

        if (!this.title) {
            this.title = "Geostationary Satellite View";
        }
    }

    function forward$30(p) {
        var lon = p.x;
        var lat = p.y;
        var tmp, v_x, v_y, v_z;
        lon = lon - this.long0;

        if (this.shape === 'ellipse') {
            lat = Math.atan(this.radius_p2 * Math.tan(lat));
            var r = this.radius_p / hypot(this.radius_p * Math.cos(lat), Math.sin(lat));

            v_x = r * Math.cos(lon) * Math.cos(lat);
            v_y = r * Math.sin(lon) * Math.cos(lat);
            v_z = r * Math.sin(lat);

            if (((this.radius_g - v_x) * v_x - v_y * v_y - v_z * v_z * this.radius_p_inv2) < 0.0) {
                p.x = Number.NaN;
                p.y = Number.NaN;
                return p;
            }

            tmp = this.radius_g - v_x;
            if (this.flip_axis) {
                p.x = this.radius_g_1 * Math.atan(v_y / hypot(v_z, tmp));
                p.y = this.radius_g_1 * Math.atan(v_z / tmp);
            } else {
                p.x = this.radius_g_1 * Math.atan(v_y / tmp);
                p.y = this.radius_g_1 * Math.atan(v_z / hypot(v_y, tmp));
            }
        } else if (this.shape === 'sphere') {
            tmp = Math.cos(lat);
            v_x = Math.cos(lon) * tmp;
            v_y = Math.sin(lon) * tmp;
            v_z = Math.sin(lat);
            tmp = this.radius_g - v_x;

            if (this.flip_axis) {
                p.x = this.radius_g_1 * Math.atan(v_y / hypot(v_z, tmp));
                p.y = this.radius_g_1 * Math.atan(v_z / tmp);
            } else {
                p.x = this.radius_g_1 * Math.atan(v_y / tmp);
                p.y = this.radius_g_1 * Math.atan(v_z / hypot(v_y, tmp));
            }
        }
        p.x = p.x * this.a;
        p.y = p.y * this.a;
        return p;
    }

    function inverse$30(p) {
        var v_x = -1.0;
        var v_y = 0.0;
        var v_z = 0.0;
        var a, b, det, k;

        p.x = p.x / this.a;
        p.y = p.y / this.a;

        if (this.shape === 'ellipse') {
            if (this.flip_axis) {
                v_z = Math.tan(p.y / this.radius_g_1);
                v_y = Math.tan(p.x / this.radius_g_1) * hypot(1.0, v_z);
            } else {
                v_y = Math.tan(p.x / this.radius_g_1);
                v_z = Math.tan(p.y / this.radius_g_1) * hypot(1.0, v_y);
            }

            var v_zp = v_z / this.radius_p;
            a = v_y * v_y + v_zp * v_zp + v_x * v_x;
            b = 2 * this.radius_g * v_x;
            det = (b * b) - 4 * a * this.C;

            if (det < 0.0) {
                p.x = Number.NaN;
                p.y = Number.NaN;
                return p;
            }

            k = (-b - Math.sqrt(det)) / (2.0 * a);
            v_x = this.radius_g + k * v_x;
            v_y *= k;
            v_z *= k;

            p.x = Math.atan2(v_y, v_x);
            p.y = Math.atan(v_z * Math.cos(p.x) / v_x);
            p.y = Math.atan(this.radius_p_inv2 * Math.tan(p.y));
        } else if (this.shape === 'sphere') {
            if (this.flip_axis) {
                v_z = Math.tan(p.y / this.radius_g_1);
                v_y = Math.tan(p.x / this.radius_g_1) * Math.sqrt(1.0 + v_z * v_z);
            } else {
                v_y = Math.tan(p.x / this.radius_g_1);
                v_z = Math.tan(p.y / this.radius_g_1) * Math.sqrt(1.0 + v_y * v_y);
            }

            a = v_y * v_y + v_z * v_z + v_x * v_x;
            b = 2 * this.radius_g * v_x;
            det = (b * b) - 4 * a * this.C;
            if (det < 0.0) {
                p.x = Number.NaN;
                p.y = Number.NaN;
                return p;
            }

            k = (-b - Math.sqrt(det)) / (2.0 * a);
            v_x = this.radius_g + k * v_x;
            v_y *= k;
            v_z *= k;

            p.x = Math.atan2(v_y, v_x);
            p.y = Math.atan(v_z * Math.cos(p.x) / v_x);
        }
        p.x = p.x + this.long0;
        return p;
    }

    var names$32 = ["Geostationary Satellite View", "Geostationary_Satellite", "geos"];
    var geos = {
        init: init$31,
        forward: forward$30,
        inverse: inverse$30,
        names: names$32,
    };

    /**
     * Copyright 2018 Bernie Jenny, Monash University, Melbourne, Australia.
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     *
     * Equal Earth is a projection inspired by the Robinson projection, but unlike
     * the Robinson projection retains the relative size of areas. The projection
     * was designed in 2018 by Bojan Savric, Tom Patterson and Bernhard Jenny.
     *
     * Publication:
     * Bojan Savric, Tom Patterson & Bernhard Jenny (2018). The Equal Earth map
     * projection, International Journal of Geographical Information Science,
     * DOI: 10.1080/13658816.2018.1504949
     *
     * Code released August 2018
     * Ported to JavaScript and adapted for mapshaper-proj by Matthew Bloch August 2018
     * Modified for proj4js by Andreas Hocevar by Andreas Hocevar March 2024
     */

    var A1 = 1.340264;
    var A2 = -0.081106;
    var A3 = 0.000893;
    var A4 = 0.003796;
    var M = Math.sqrt(3) / 2.0;

    function init$32() {
      this.es = 0;
      this.long0 = this.long0 !== undefined ? this.long0 : 0;
    }

    function forward$31(p) {
      var lam = adjust_lon(p.x - this.long0);
      var phi = p.y;
      var paramLat = Math.asin(M * Math.sin(phi)),
      paramLatSq = paramLat * paramLat,
      paramLatPow6 = paramLatSq * paramLatSq * paramLatSq;
      p.x = lam * Math.cos(paramLat) /
      (M * (A1 + 3 * A2 * paramLatSq + paramLatPow6 * (7 * A3 + 9 * A4 * paramLatSq)));
      p.y = paramLat * (A1 + A2 * paramLatSq + paramLatPow6 * (A3 + A4 * paramLatSq));

      p.x = this.a * p.x + this.x0;
      p.y = this.a * p.y + this.y0;
      return p;
    }

    function inverse$31(p) {
      p.x = (p.x - this.x0) / this.a;
      p.y = (p.y - this.y0) / this.a;

      var EPS = 1e-9,
          NITER = 12,
          paramLat = p.y,
          paramLatSq, paramLatPow6, fy, fpy, dlat, i;

      for (i = 0; i < NITER; ++i) {
        paramLatSq = paramLat * paramLat;
        paramLatPow6 = paramLatSq * paramLatSq * paramLatSq;
        fy = paramLat * (A1 + A2 * paramLatSq + paramLatPow6 * (A3 + A4 * paramLatSq)) - p.y;
        fpy = A1 + 3 * A2 * paramLatSq + paramLatPow6 * (7 * A3 + 9 * A4 * paramLatSq);
        paramLat -= dlat = fy / fpy;
        if (Math.abs(dlat) < EPS) {
            break;
        }
      }
      paramLatSq = paramLat * paramLat;
      paramLatPow6 = paramLatSq * paramLatSq * paramLatSq;
      p.x = M * p.x * (A1 + 3 * A2 * paramLatSq + paramLatPow6 * (7 * A3 + 9 * A4 * paramLatSq)) /
              Math.cos(paramLat);
      p.y = Math.asin(Math.sin(paramLat) / M);

      p.x = adjust_lon(p.x + this.long0);
      return p;
    }

    var names$33 = ["eqearth", "Equal Earth", "Equal_Earth"];
    var eqearth = {
      init: init$32,
      forward: forward$31,
      inverse: inverse$31,
      names: names$33
    };

    var EPS10 = 1e-10;

    function init$33() {
      var c;

      this.phi1 = this.lat1;
      if (Math.abs(this.phi1) < EPS10) {
        throw new Error();
      }
      if (this.es) {
        this.en = pj_enfn(this.es);
        this.m1 = pj_mlfn(this.phi1, this.am1 = Math.sin(this.phi1),
          c = Math.cos(this.phi1), this.en);
        this.am1 = c / (Math.sqrt(1 - this.es * this.am1 * this.am1) * this.am1);
        this.inverse = e_inv;
        this.forward = e_fwd;
      } else {
        if (Math.abs(this.phi1) + EPS10 >= HALF_PI) {
          this.cphi1 = 0;
        }
        else {
          this.cphi1 = 1 / Math.tan(this.phi1);
        }
        this.inverse = s_inv;
        this.forward = s_fwd;
      }
    }

    function e_fwd(p) {
      var lam = adjust_lon(p.x - (this.long0 || 0));
      var phi = p.y;
      var rh, E, c;
      rh = this.am1 + this.m1 - pj_mlfn(phi, E = Math.sin(phi), c = Math.cos(phi), this.en);
      E = c * lam / (rh * Math.sqrt(1 - this.es * E * E));
      p.x = rh * Math.sin(E);
      p.y = this.am1 - rh * Math.cos(E);

      p.x = this.a * p.x + (this.x0 || 0);
      p.y = this.a * p.y + (this.y0 || 0);
      return p;
    }

    function e_inv(p) {
      p.x = (p.x - (this.x0 || 0)) / this.a;
      p.y = (p.y - (this.y0 || 0)) / this.a;

      var s, rh, lam, phi;
      rh = hypot(p.x, p.y = this.am1 - p.y);
      phi = pj_inv_mlfn(this.am1 + this.m1 - rh, this.es, this.en);
      if ((s = Math.abs(phi)) < HALF_PI) {
        s = Math.sin(phi);
        lam = rh * Math.atan2(p.x, p.y) * Math.sqrt(1 - this.es * s * s) / Math.cos(phi);
      } else if (Math.abs(s - HALF_PI) <= EPS10) {
        lam = 0;
      }
      else {
        throw new Error();
      }
      p.x = adjust_lon(lam + (this.long0 || 0));
      p.y = adjust_lat(phi);
      return p;
    }

    function s_fwd(p) {
      var lam = adjust_lon(p.x - (this.long0 || 0));
      var phi = p.y;
      var E, rh;
      rh = this.cphi1 + this.phi1 - phi;
      if (Math.abs(rh) > EPS10) {
        p.x = rh * Math.sin(E = lam * Math.cos(phi) / rh);
        p.y = this.cphi1 - rh * Math.cos(E);
      } else {
        p.x = p.y = 0;
      }

      p.x = this.a * p.x + (this.x0 || 0);
      p.y = this.a * p.y + (this.y0 || 0);
      return p;
    }

    function s_inv(p) {
      p.x = (p.x - (this.x0 || 0)) / this.a;
      p.y = (p.y - (this.y0 || 0)) / this.a;

      var lam, phi;
      var rh = hypot(p.x, p.y = this.cphi1 - p.y);
      phi = this.cphi1 + this.phi1 - rh;
      if (Math.abs(phi) > HALF_PI) {
        throw new Error();
      }
      if (Math.abs(Math.abs(phi) - HALF_PI) <= EPS10) {
        lam = 0;
      } else {
        lam = rh * Math.atan2(p.x, p.y) / Math.cos(phi);
      }
      p.x = adjust_lon(lam + (this.long0 || 0));
      p.y = adjust_lat(phi);
      return p;
    }

    var names$34 = ["bonne", "Bonne (Werner lat_1=90)"];
    var bonne = {
      init: init$33,
      names: names$34
    };

    var includedProjections = function(proj4){
      proj4.Proj.projections.add(tmerc);
      proj4.Proj.projections.add(etmerc);
      proj4.Proj.projections.add(utm);
      proj4.Proj.projections.add(sterea);
      proj4.Proj.projections.add(stere);
      proj4.Proj.projections.add(somerc);
      proj4.Proj.projections.add(omerc);
      proj4.Proj.projections.add(lcc);
      proj4.Proj.projections.add(krovak);
      proj4.Proj.projections.add(cass);
      proj4.Proj.projections.add(laea);
      proj4.Proj.projections.add(aea);
      proj4.Proj.projections.add(gnom);
      proj4.Proj.projections.add(cea);
      proj4.Proj.projections.add(eqc);
      proj4.Proj.projections.add(poly);
      proj4.Proj.projections.add(nzmg);
      proj4.Proj.projections.add(mill);
      proj4.Proj.projections.add(sinu);
      proj4.Proj.projections.add(moll);
      proj4.Proj.projections.add(eqdc);
      proj4.Proj.projections.add(vandg);
      proj4.Proj.projections.add(aeqd);
      proj4.Proj.projections.add(ortho);
      proj4.Proj.projections.add(qsc);
      proj4.Proj.projections.add(robin);
      proj4.Proj.projections.add(geocent);
      proj4.Proj.projections.add(tpers);
      proj4.Proj.projections.add(geos);
      proj4.Proj.projections.add(eqearth);
      proj4.Proj.projections.add(bonne);
    };

    proj4$1.defaultDatum = 'WGS84'; //default datum
    proj4$1.Proj = Projection;
    proj4$1.WGS84 = new proj4$1.Proj('WGS84');
    proj4$1.Point = Point;
    proj4$1.toPoint = toPoint;
    proj4$1.defs = defs;
    proj4$1.nadgrid = nadgrid;
    proj4$1.transform = transform;
    proj4$1.mgrs = mgrs;
    proj4$1.version = '2.15.0';
    includedProjections(proj4$1);

    return proj4$1;

})));

},{}],27:[function(require,module,exports){
(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
  typeof define === 'function' && define.amd ? define(factory) :
  (global = typeof globalThis !== 'undefined' ? globalThis : global || self, global.shp = factory());
})(this, (function () { 'use strict';

  function globals(defs) {
    defs('EPSG:4326', "+title=WGS 84 (long/lat) +proj=longlat +ellps=WGS84 +datum=WGS84 +units=degrees");
    defs('EPSG:4269', "+title=NAD83 (long/lat) +proj=longlat +a=6378137.0 +b=6356752.31414036 +ellps=GRS80 +datum=NAD83 +units=degrees");
    defs('EPSG:3857', "+title=WGS 84 / Pseudo-Mercator +proj=merc +a=6378137 +b=6378137 +lat_ts=0.0 +lon_0=0.0 +x_0=0.0 +y_0=0 +k=1.0 +units=m +nadgrids=@null +no_defs");

    defs.WGS84 = defs['EPSG:4326'];
    defs['EPSG:3785'] = defs['EPSG:3857']; // maintain backward compat, official code is 3857
    defs.GOOGLE = defs['EPSG:3857'];
    defs['EPSG:900913'] = defs['EPSG:3857'];
    defs['EPSG:102113'] = defs['EPSG:3857'];
  }

  var PJD_3PARAM = 1;
  var PJD_7PARAM = 2;
  var PJD_GRIDSHIFT = 3;
  var PJD_WGS84 = 4; // WGS84 or equivalent
  var PJD_NODATUM = 5; // WGS84 or equivalent
  var SRS_WGS84_SEMIMAJOR = 6378137.0;  // only used in grid shift transforms
  var SRS_WGS84_SEMIMINOR = 6356752.314;  // only used in grid shift transforms
  var SRS_WGS84_ESQUARED = 0.0066943799901413165; // only used in grid shift transforms
  var SEC_TO_RAD = 4.84813681109535993589914102357e-6;
  var HALF_PI = Math.PI/2;
  // ellipoid pj_set_ell.c
  var SIXTH = 0.1666666666666666667;
  /* 1/6 */
  var RA4 = 0.04722222222222222222;
  /* 17/360 */
  var RA6 = 0.02215608465608465608;
  var EPSLN = 1.0e-10;
  // you'd think you could use Number.EPSILON above but that makes
  // Mollweide get into an infinate loop.

  var D2R$1 = 0.01745329251994329577;
  var R2D = 57.29577951308232088;
  var FORTPI = Math.PI/4;
  var TWO_PI = Math.PI * 2;
  // SPI is slightly greater than Math.PI, so values that exceed the -180..180
  // degree range by a tiny amount don't get wrapped. This prevents points that
  // have drifted from their original location along the 180th meridian (due to
  // floating point error) from changing their sign.
  var SPI = 3.14159265359;

  var exports$3 = {};

  exports$3.greenwich = 0.0; //"0dE",
  exports$3.lisbon = -9.131906111111; //"9d07'54.862\"W",
  exports$3.paris = 2.337229166667; //"2d20'14.025\"E",
  exports$3.bogota = -74.080916666667; //"74d04'51.3\"W",
  exports$3.madrid = -3.687938888889; //"3d41'16.58\"W",
  exports$3.rome = 12.452333333333; //"12d27'8.4\"E",
  exports$3.bern = 7.439583333333; //"7d26'22.5\"E",
  exports$3.jakarta = 106.807719444444; //"106d48'27.79\"E",
  exports$3.ferro = -17.666666666667; //"17d40'W",
  exports$3.brussels = 4.367975; //"4d22'4.71\"E",
  exports$3.stockholm = 18.058277777778; //"18d3'29.8\"E",
  exports$3.athens = 23.7163375; //"23d42'58.815\"E",
  exports$3.oslo = 10.722916666667; //"10d43'22.5\"E"

  var units = {
    ft: {to_meter: 0.3048},
    'us-ft': {to_meter: 1200 / 3937}
  };

  var ignoredChar = /[\s_\-\/\(\)]/g;
  function match(obj, key) {
    if (obj[key]) {
      return obj[key];
    }
    var keys = Object.keys(obj);
    var lkey = key.toLowerCase().replace(ignoredChar, '');
    var i = -1;
    var testkey, processedKey;
    while (++i < keys.length) {
      testkey = keys[i];
      processedKey = testkey.toLowerCase().replace(ignoredChar, '');
      if (processedKey === lkey) {
        return obj[testkey];
      }
    }
  }

  function projStr(defData) {
    var self = {};
    var paramObj = defData.split('+').map(function(v) {
      return v.trim();
    }).filter(function(a) {
      return a;
    }).reduce(function(p, a) {
      var split = a.split('=');
      split.push(true);
      p[split[0].toLowerCase()] = split[1];
      return p;
    }, {});
    var paramName, paramVal, paramOutname;
    var params = {
      proj: 'projName',
      datum: 'datumCode',
      rf: function(v) {
        self.rf = parseFloat(v);
      },
      lat_0: function(v) {
        self.lat0 = v * D2R$1;
      },
      lat_1: function(v) {
        self.lat1 = v * D2R$1;
      },
      lat_2: function(v) {
        self.lat2 = v * D2R$1;
      },
      lat_ts: function(v) {
        self.lat_ts = v * D2R$1;
      },
      lon_0: function(v) {
        self.long0 = v * D2R$1;
      },
      lon_1: function(v) {
        self.long1 = v * D2R$1;
      },
      lon_2: function(v) {
        self.long2 = v * D2R$1;
      },
      alpha: function(v) {
        self.alpha = parseFloat(v) * D2R$1;
      },
      gamma: function(v) {
        self.rectified_grid_angle = parseFloat(v);
      },
      lonc: function(v) {
        self.longc = v * D2R$1;
      },
      x_0: function(v) {
        self.x0 = parseFloat(v);
      },
      y_0: function(v) {
        self.y0 = parseFloat(v);
      },
      k_0: function(v) {
        self.k0 = parseFloat(v);
      },
      k: function(v) {
        self.k0 = parseFloat(v);
      },
      a: function(v) {
        self.a = parseFloat(v);
      },
      b: function(v) {
        self.b = parseFloat(v);
      },
      r_a: function() {
        self.R_A = true;
      },
      zone: function(v) {
        self.zone = parseInt(v, 10);
      },
      south: function() {
        self.utmSouth = true;
      },
      towgs84: function(v) {
        self.datum_params = v.split(",").map(function(a) {
          return parseFloat(a);
        });
      },
      to_meter: function(v) {
        self.to_meter = parseFloat(v);
      },
      units: function(v) {
        self.units = v;
        var unit = match(units, v);
        if (unit) {
          self.to_meter = unit.to_meter;
        }
      },
      from_greenwich: function(v) {
        self.from_greenwich = v * D2R$1;
      },
      pm: function(v) {
        var pm = match(exports$3, v);
        self.from_greenwich = (pm ? pm : parseFloat(v)) * D2R$1;
      },
      nadgrids: function(v) {
        if (v === '@null') {
          self.datumCode = 'none';
        }
        else {
          self.nadgrids = v;
        }
      },
      axis: function(v) {
        var legalAxis = "ewnsud";
        if (v.length === 3 && legalAxis.indexOf(v.substr(0, 1)) !== -1 && legalAxis.indexOf(v.substr(1, 1)) !== -1 && legalAxis.indexOf(v.substr(2, 1)) !== -1) {
          self.axis = v;
        }
      },
      approx: function() {
        self.approx = true;
      }
    };
    for (paramName in paramObj) {
      paramVal = paramObj[paramName];
      if (paramName in params) {
        paramOutname = params[paramName];
        if (typeof paramOutname === 'function') {
          paramOutname(paramVal);
        }
        else {
          self[paramOutname] = paramVal;
        }
      }
      else {
        self[paramName] = paramVal;
      }
    }
    if(typeof self.datumCode === 'string' && self.datumCode !== "WGS84"){
      self.datumCode = self.datumCode.toLowerCase();
    }
    return self;
  }

  var NEUTRAL = 1;
  var KEYWORD = 2;
  var NUMBER = 3;
  var QUOTED = 4;
  var AFTERQUOTE = 5;
  var ENDED = -1;
  var whitespace = /\s/;
  var latin = /[A-Za-z]/;
  var keyword = /[A-Za-z84_]/;
  var endThings = /[,\]]/;
  var digets = /[\d\.E\-\+]/;
  // const ignoredChar = /[\s_\-\/\(\)]/g;
  function Parser(text) {
    if (typeof text !== 'string') {
      throw new Error('not a string');
    }
    this.text = text.trim();
    this.level = 0;
    this.place = 0;
    this.root = null;
    this.stack = [];
    this.currentObject = null;
    this.state = NEUTRAL;
  }
  Parser.prototype.readCharicter = function() {
    var char = this.text[this.place++];
    if (this.state !== QUOTED) {
      while (whitespace.test(char)) {
        if (this.place >= this.text.length) {
          return;
        }
        char = this.text[this.place++];
      }
    }
    switch (this.state) {
      case NEUTRAL:
        return this.neutral(char);
      case KEYWORD:
        return this.keyword(char)
      case QUOTED:
        return this.quoted(char);
      case AFTERQUOTE:
        return this.afterquote(char);
      case NUMBER:
        return this.number(char);
      case ENDED:
        return;
    }
  };
  Parser.prototype.afterquote = function(char) {
    if (char === '"') {
      this.word += '"';
      this.state = QUOTED;
      return;
    }
    if (endThings.test(char)) {
      this.word = this.word.trim();
      this.afterItem(char);
      return;
    }
    throw new Error('havn\'t handled "' +char + '" in afterquote yet, index ' + this.place);
  };
  Parser.prototype.afterItem = function(char) {
    if (char === ',') {
      if (this.word !== null) {
        this.currentObject.push(this.word);
      }
      this.word = null;
      this.state = NEUTRAL;
      return;
    }
    if (char === ']') {
      this.level--;
      if (this.word !== null) {
        this.currentObject.push(this.word);
        this.word = null;
      }
      this.state = NEUTRAL;
      this.currentObject = this.stack.pop();
      if (!this.currentObject) {
        this.state = ENDED;
      }

      return;
    }
  };
  Parser.prototype.number = function(char) {
    if (digets.test(char)) {
      this.word += char;
      return;
    }
    if (endThings.test(char)) {
      this.word = parseFloat(this.word);
      this.afterItem(char);
      return;
    }
    throw new Error('havn\'t handled "' +char + '" in number yet, index ' + this.place);
  };
  Parser.prototype.quoted = function(char) {
    if (char === '"') {
      this.state = AFTERQUOTE;
      return;
    }
    this.word += char;
    return;
  };
  Parser.prototype.keyword = function(char) {
    if (keyword.test(char)) {
      this.word += char;
      return;
    }
    if (char === '[') {
      var newObjects = [];
      newObjects.push(this.word);
      this.level++;
      if (this.root === null) {
        this.root = newObjects;
      } else {
        this.currentObject.push(newObjects);
      }
      this.stack.push(this.currentObject);
      this.currentObject = newObjects;
      this.state = NEUTRAL;
      return;
    }
    if (endThings.test(char)) {
      this.afterItem(char);
      return;
    }
    throw new Error('havn\'t handled "' +char + '" in keyword yet, index ' + this.place);
  };
  Parser.prototype.neutral = function(char) {
    if (latin.test(char)) {
      this.word = char;
      this.state = KEYWORD;
      return;
    }
    if (char === '"') {
      this.word = '';
      this.state = QUOTED;
      return;
    }
    if (digets.test(char)) {
      this.word = char;
      this.state = NUMBER;
      return;
    }
    if (endThings.test(char)) {
      this.afterItem(char);
      return;
    }
    throw new Error('havn\'t handled "' +char + '" in neutral yet, index ' + this.place);
  };
  Parser.prototype.output = function() {
    while (this.place < this.text.length) {
      this.readCharicter();
    }
    if (this.state === ENDED) {
      return this.root;
    }
    throw new Error('unable to parse string "' +this.text + '". State is ' + this.state);
  };

  function parseString(txt) {
    var parser = new Parser(txt);
    return parser.output();
  }

  function mapit(obj, key, value) {
    if (Array.isArray(key)) {
      value.unshift(key);
      key = null;
    }
    var thing = key ? {} : obj;

    var out = value.reduce(function(newObj, item) {
      sExpr(item, newObj);
      return newObj
    }, thing);
    if (key) {
      obj[key] = out;
    }
  }

  function sExpr(v, obj) {
    if (!Array.isArray(v)) {
      obj[v] = true;
      return;
    }
    var key = v.shift();
    if (key === 'PARAMETER') {
      key = v.shift();
    }
    if (v.length === 1) {
      if (Array.isArray(v[0])) {
        obj[key] = {};
        sExpr(v[0], obj[key]);
        return;
      }
      obj[key] = v[0];
      return;
    }
    if (!v.length) {
      obj[key] = true;
      return;
    }
    if (key === 'TOWGS84') {
      obj[key] = v;
      return;
    }
    if (key === 'AXIS') {
      if (!(key in obj)) {
        obj[key] = [];
      }
      obj[key].push(v);
      return;
    }
    if (!Array.isArray(key)) {
      obj[key] = {};
    }

    var i;
    switch (key) {
      case 'UNIT':
      case 'PRIMEM':
      case 'VERT_DATUM':
        obj[key] = {
          name: v[0].toLowerCase(),
          convert: v[1]
        };
        if (v.length === 3) {
          sExpr(v[2], obj[key]);
        }
        return;
      case 'SPHEROID':
      case 'ELLIPSOID':
        obj[key] = {
          name: v[0],
          a: v[1],
          rf: v[2]
        };
        if (v.length === 4) {
          sExpr(v[3], obj[key]);
        }
        return;
      case 'PROJECTEDCRS':
      case 'PROJCRS':
      case 'GEOGCS':
      case 'GEOCCS':
      case 'PROJCS':
      case 'LOCAL_CS':
      case 'GEODCRS':
      case 'GEODETICCRS':
      case 'GEODETICDATUM':
      case 'EDATUM':
      case 'ENGINEERINGDATUM':
      case 'VERT_CS':
      case 'VERTCRS':
      case 'VERTICALCRS':
      case 'COMPD_CS':
      case 'COMPOUNDCRS':
      case 'ENGINEERINGCRS':
      case 'ENGCRS':
      case 'FITTED_CS':
      case 'LOCAL_DATUM':
      case 'DATUM':
        v[0] = ['name', v[0]];
        mapit(obj, key, v);
        return;
      default:
        i = -1;
        while (++i < v.length) {
          if (!Array.isArray(v[i])) {
            return sExpr(v, obj[key]);
          }
        }
        return mapit(obj, key, v);
    }
  }

  var D2R = 0.01745329251994329577;



  function rename(obj, params) {
    var outName = params[0];
    var inName = params[1];
    if (!(outName in obj) && (inName in obj)) {
      obj[outName] = obj[inName];
      if (params.length === 3) {
        obj[outName] = params[2](obj[outName]);
      }
    }
  }

  function d2r(input) {
    return input * D2R;
  }

  function cleanWKT(wkt) {
    if (wkt.type === 'GEOGCS') {
      wkt.projName = 'longlat';
    } else if (wkt.type === 'LOCAL_CS') {
      wkt.projName = 'identity';
      wkt.local = true;
    } else {
      if (typeof wkt.PROJECTION === 'object') {
        wkt.projName = Object.keys(wkt.PROJECTION)[0];
      } else {
        wkt.projName = wkt.PROJECTION;
      }
    }
    if (wkt.AXIS) {
      var axisOrder = '';
      for (var i = 0, ii = wkt.AXIS.length; i < ii; ++i) {
        var axis = [wkt.AXIS[i][0].toLowerCase(), wkt.AXIS[i][1].toLowerCase()];
        if (axis[0].indexOf('north') !== -1 || ((axis[0] === 'y' || axis[0] === 'lat') && axis[1] === 'north')) {
          axisOrder += 'n';
        } else if (axis[0].indexOf('south') !== -1 || ((axis[0] === 'y' || axis[0] === 'lat') && axis[1] === 'south')) {
          axisOrder += 's';
        } else if (axis[0].indexOf('east') !== -1 || ((axis[0] === 'x' || axis[0] === 'lon') && axis[1] === 'east')) {
          axisOrder += 'e';
        } else if (axis[0].indexOf('west') !== -1 || ((axis[0] === 'x' || axis[0] === 'lon') && axis[1] === 'west')) {
          axisOrder += 'w';
        }
      }
      if (axisOrder.length === 2) {
        axisOrder += 'u';
      }
      if (axisOrder.length === 3) {
        wkt.axis = axisOrder;
      }
    }
    if (wkt.UNIT) {
      wkt.units = wkt.UNIT.name.toLowerCase();
      if (wkt.units === 'metre') {
        wkt.units = 'meter';
      }
      if (wkt.UNIT.convert) {
        if (wkt.type === 'GEOGCS') {
          if (wkt.DATUM && wkt.DATUM.SPHEROID) {
            wkt.to_meter = wkt.UNIT.convert*wkt.DATUM.SPHEROID.a;
          }
        } else {
          wkt.to_meter = wkt.UNIT.convert;
        }
      }
    }
    var geogcs = wkt.GEOGCS;
    if (wkt.type === 'GEOGCS') {
      geogcs = wkt;
    }
    if (geogcs) {
      //if(wkt.GEOGCS.PRIMEM&&wkt.GEOGCS.PRIMEM.convert){
      //  wkt.from_greenwich=wkt.GEOGCS.PRIMEM.convert*D2R;
      //}
      if (geogcs.DATUM) {
        wkt.datumCode = geogcs.DATUM.name.toLowerCase();
      } else {
        wkt.datumCode = geogcs.name.toLowerCase();
      }
      if (wkt.datumCode.slice(0, 2) === 'd_') {
        wkt.datumCode = wkt.datumCode.slice(2);
      }
      if (wkt.datumCode === 'new_zealand_geodetic_datum_1949' || wkt.datumCode === 'new_zealand_1949') {
        wkt.datumCode = 'nzgd49';
      }
      if (wkt.datumCode === 'wgs_1984' || wkt.datumCode === 'world_geodetic_system_1984') {
        if (wkt.PROJECTION === 'Mercator_Auxiliary_Sphere') {
          wkt.sphere = true;
        }
        wkt.datumCode = 'wgs84';
      }
      if (wkt.datumCode.slice(-6) === '_ferro') {
        wkt.datumCode = wkt.datumCode.slice(0, - 6);
      }
      if (wkt.datumCode.slice(-8) === '_jakarta') {
        wkt.datumCode = wkt.datumCode.slice(0, - 8);
      }
      if (~wkt.datumCode.indexOf('belge')) {
        wkt.datumCode = 'rnb72';
      }
      if (geogcs.DATUM && geogcs.DATUM.SPHEROID) {
        wkt.ellps = geogcs.DATUM.SPHEROID.name.replace('_19', '').replace(/[Cc]larke\_18/, 'clrk');
        if (wkt.ellps.toLowerCase().slice(0, 13) === 'international') {
          wkt.ellps = 'intl';
        }

        wkt.a = geogcs.DATUM.SPHEROID.a;
        wkt.rf = parseFloat(geogcs.DATUM.SPHEROID.rf, 10);
      }

      if (geogcs.DATUM && geogcs.DATUM.TOWGS84) {
        wkt.datum_params = geogcs.DATUM.TOWGS84;
      }
      if (~wkt.datumCode.indexOf('osgb_1936')) {
        wkt.datumCode = 'osgb36';
      }
      if (~wkt.datumCode.indexOf('osni_1952')) {
        wkt.datumCode = 'osni52';
      }
      if (~wkt.datumCode.indexOf('tm65')
        || ~wkt.datumCode.indexOf('geodetic_datum_of_1965')) {
        wkt.datumCode = 'ire65';
      }
      if (wkt.datumCode === 'ch1903+') {
        wkt.datumCode = 'ch1903';
      }
      if (~wkt.datumCode.indexOf('israel')) {
        wkt.datumCode = 'isr93';
      }
    }
    if (wkt.b && !isFinite(wkt.b)) {
      wkt.b = wkt.a;
    }

    function toMeter(input) {
      var ratio = wkt.to_meter || 1;
      return input * ratio;
    }
    var renamer = function(a) {
      return rename(wkt, a);
    };
    var list = [
      ['standard_parallel_1', 'Standard_Parallel_1'],
      ['standard_parallel_1', 'Latitude of 1st standard parallel'],
      ['standard_parallel_2', 'Standard_Parallel_2'],
      ['standard_parallel_2', 'Latitude of 2nd standard parallel'],
      ['false_easting', 'False_Easting'],
      ['false_easting', 'False easting'],
      ['false-easting', 'Easting at false origin'],
      ['false_northing', 'False_Northing'],
      ['false_northing', 'False northing'],
      ['false_northing', 'Northing at false origin'],
      ['central_meridian', 'Central_Meridian'],
      ['central_meridian', 'Longitude of natural origin'],
      ['central_meridian', 'Longitude of false origin'],
      ['latitude_of_origin', 'Latitude_Of_Origin'],
      ['latitude_of_origin', 'Central_Parallel'],
      ['latitude_of_origin', 'Latitude of natural origin'],
      ['latitude_of_origin', 'Latitude of false origin'],
      ['scale_factor', 'Scale_Factor'],
      ['k0', 'scale_factor'],
      ['latitude_of_center', 'Latitude_Of_Center'],
      ['latitude_of_center', 'Latitude_of_center'],
      ['lat0', 'latitude_of_center', d2r],
      ['longitude_of_center', 'Longitude_Of_Center'],
      ['longitude_of_center', 'Longitude_of_center'],
      ['longc', 'longitude_of_center', d2r],
      ['x0', 'false_easting', toMeter],
      ['y0', 'false_northing', toMeter],
      ['long0', 'central_meridian', d2r],
      ['lat0', 'latitude_of_origin', d2r],
      ['lat0', 'standard_parallel_1', d2r],
      ['lat1', 'standard_parallel_1', d2r],
      ['lat2', 'standard_parallel_2', d2r],
      ['azimuth', 'Azimuth'],
      ['alpha', 'azimuth', d2r],
      ['srsCode', 'name']
    ];
    list.forEach(renamer);
    if (!wkt.long0 && wkt.longc && (wkt.projName === 'Albers_Conic_Equal_Area' || wkt.projName === 'Lambert_Azimuthal_Equal_Area')) {
      wkt.long0 = wkt.longc;
    }
    if (!wkt.lat_ts && wkt.lat1 && (wkt.projName === 'Stereographic_South_Pole' || wkt.projName === 'Polar Stereographic (variant B)')) {
      wkt.lat0 = d2r(wkt.lat1 > 0 ? 90 : -90);
      wkt.lat_ts = wkt.lat1;
    } else if (!wkt.lat_ts && wkt.lat0 && wkt.projName === 'Polar_Stereographic') {
      wkt.lat_ts = wkt.lat0;
      wkt.lat0 = d2r(wkt.lat0 > 0 ? 90 : -90);
    }
  }
  function wkt(wkt) {
    var lisp = parseString(wkt);
    var type = lisp.shift();
    var name = lisp.shift();
    lisp.unshift(['name', name]);
    lisp.unshift(['type', type]);
    var obj = {};
    sExpr(lisp, obj);
    cleanWKT(obj);
    return obj;
  }

  function defs(name) {
    /*global console*/
    var that = this;
    if (arguments.length === 2) {
      var def = arguments[1];
      if (typeof def === 'string') {
        if (def.charAt(0) === '+') {
          defs[name] = projStr(arguments[1]);
        }
        else {
          defs[name] = wkt(arguments[1]);
        }
      } else {
        defs[name] = def;
      }
    }
    else if (arguments.length === 1) {
      if (Array.isArray(name)) {
        return name.map(function(v) {
          if (Array.isArray(v)) {
            defs.apply(that, v);
          }
          else {
            defs(v);
          }
        });
      }
      else if (typeof name === 'string') {
        if (name in defs) {
          return defs[name];
        }
      }
      else if ('EPSG' in name) {
        defs['EPSG:' + name.EPSG] = name;
      }
      else if ('ESRI' in name) {
        defs['ESRI:' + name.ESRI] = name;
      }
      else if ('IAU2000' in name) {
        defs['IAU2000:' + name.IAU2000] = name;
      }
      else {
        console.log(name);
      }
      return;
    }


  }
  globals(defs);

  function testObj(code){
    return typeof code === 'string';
  }
  function testDef(code){
    return code in defs;
  }
  var codeWords = ['PROJECTEDCRS', 'PROJCRS', 'GEOGCS','GEOCCS','PROJCS','LOCAL_CS', 'GEODCRS', 'GEODETICCRS', 'GEODETICDATUM', 'ENGCRS', 'ENGINEERINGCRS'];
  function testWKT(code){
    return codeWords.some(function (word) {
      return code.indexOf(word) > -1;
    });
  }
  var codes = ['3857', '900913', '3785', '102113'];
  function checkMercator(item) {
    var auth = match(item, 'authority');
    if (!auth) {
      return;
    }
    var code = match(auth, 'epsg');
    return code && codes.indexOf(code) > -1;
  }
  function checkProjStr(item) {
    var ext = match(item, 'extension');
    if (!ext) {
      return;
    }
    return match(ext, 'proj4');
  }
  function testProj(code){
    return code[0] === '+';
  }
  function parse(code){
    if (testObj(code)) {
      //check to see if this is a WKT string
      if (testDef(code)) {
        return defs[code];
      }
      if (testWKT(code)) {
        var out = wkt(code);
        // test of spetial case, due to this being a very common and often malformed
        if (checkMercator(out)) {
          return defs['EPSG:3857'];
        }
        var maybeProjStr = checkProjStr(out);
        if (maybeProjStr) {
          return projStr(maybeProjStr);
        }
        return out;
      }
      if (testProj(code)) {
        return projStr(code);
      }
    }else {
      return code;
    }
  }

  function extend(destination, source) {
    destination = destination || {};
    var value, property;
    if (!source) {
      return destination;
    }
    for (property in source) {
      value = source[property];
      if (value !== undefined) {
        destination[property] = value;
      }
    }
    return destination;
  }

  function msfnz(eccent, sinphi, cosphi) {
    var con = eccent * sinphi;
    return cosphi / (Math.sqrt(1 - con * con));
  }

  function sign(x) {
    return x<0 ? -1 : 1;
  }

  function adjust_lon(x) {
    return (Math.abs(x) <= SPI) ? x : (x - (sign(x) * TWO_PI));
  }

  function tsfnz(eccent, phi, sinphi) {
    var con = eccent * sinphi;
    var com = 0.5 * eccent;
    con = Math.pow(((1 - con) / (1 + con)), com);
    return (Math.tan(0.5 * (HALF_PI - phi)) / con);
  }

  function phi2z(eccent, ts) {
    var eccnth = 0.5 * eccent;
    var con, dphi;
    var phi = HALF_PI - 2 * Math.atan(ts);
    for (var i = 0; i <= 15; i++) {
      con = eccent * Math.sin(phi);
      dphi = HALF_PI - 2 * Math.atan(ts * (Math.pow(((1 - con) / (1 + con)), eccnth))) - phi;
      phi += dphi;
      if (Math.abs(dphi) <= 0.0000000001) {
        return phi;
      }
    }
    //console.log("phi2z has NoConvergence");
    return -9999;
  }

  function init$v() {
    var con = this.b / this.a;
    this.es = 1 - con * con;
    if(!('x0' in this)){
      this.x0 = 0;
    }
    if(!('y0' in this)){
      this.y0 = 0;
    }
    this.e = Math.sqrt(this.es);
    if (this.lat_ts) {
      if (this.sphere) {
        this.k0 = Math.cos(this.lat_ts);
      }
      else {
        this.k0 = msfnz(this.e, Math.sin(this.lat_ts), Math.cos(this.lat_ts));
      }
    }
    else {
      if (!this.k0) {
        if (this.k) {
          this.k0 = this.k;
        }
        else {
          this.k0 = 1;
        }
      }
    }
  }

  /* Mercator forward equations--mapping lat,long to x,y
    --------------------------------------------------*/

  function forward$u(p) {
    var lon = p.x;
    var lat = p.y;
    // convert to radians
    if (lat * R2D > 90 && lat * R2D < -90 && lon * R2D > 180 && lon * R2D < -180) {
      return null;
    }

    var x, y;
    if (Math.abs(Math.abs(lat) - HALF_PI) <= EPSLN) {
      return null;
    }
    else {
      if (this.sphere) {
        x = this.x0 + this.a * this.k0 * adjust_lon(lon - this.long0);
        y = this.y0 + this.a * this.k0 * Math.log(Math.tan(FORTPI + 0.5 * lat));
      }
      else {
        var sinphi = Math.sin(lat);
        var ts = tsfnz(this.e, lat, sinphi);
        x = this.x0 + this.a * this.k0 * adjust_lon(lon - this.long0);
        y = this.y0 - this.a * this.k0 * Math.log(ts);
      }
      p.x = x;
      p.y = y;
      return p;
    }
  }

  /* Mercator inverse equations--mapping x,y to lat/long
    --------------------------------------------------*/
  function inverse$u(p) {

    var x = p.x - this.x0;
    var y = p.y - this.y0;
    var lon, lat;

    if (this.sphere) {
      lat = HALF_PI - 2 * Math.atan(Math.exp(-y / (this.a * this.k0)));
    }
    else {
      var ts = Math.exp(-y / (this.a * this.k0));
      lat = phi2z(this.e, ts);
      if (lat === -9999) {
        return null;
      }
    }
    lon = adjust_lon(this.long0 + x / (this.a * this.k0));

    p.x = lon;
    p.y = lat;
    return p;
  }

  var names$w = ["Mercator", "Popular Visualisation Pseudo Mercator", "Mercator_1SP", "Mercator_Auxiliary_Sphere", "merc"];
  var merc = {
    init: init$v,
    forward: forward$u,
    inverse: inverse$u,
    names: names$w
  };

  function init$u() {
    //no-op for longlat
  }

  function identity(pt) {
    return pt;
  }
  var names$v = ["longlat", "identity"];
  var longlat = {
    init: init$u,
    forward: identity,
    inverse: identity,
    names: names$v
  };

  var projs = [merc, longlat];
  var names$u = {};
  var projStore = [];

  function add(proj, i) {
    var len = projStore.length;
    if (!proj.names) {
      console.log(i);
      return true;
    }
    projStore[len] = proj;
    proj.names.forEach(function(n) {
      names$u[n.toLowerCase()] = len;
    });
    return this;
  }

  function get(name) {
    if (!name) {
      return false;
    }
    var n = name.toLowerCase();
    if (typeof names$u[n] !== 'undefined' && projStore[names$u[n]]) {
      return projStore[names$u[n]];
    }
  }

  function start() {
    projs.forEach(add);
  }
  var projections = {
    start: start,
    add: add,
    get: get
  };

  var exports$2 = {};
  exports$2.MERIT = {
    a: 6378137.0,
    rf: 298.257,
    ellipseName: "MERIT 1983"
  };

  exports$2.SGS85 = {
    a: 6378136.0,
    rf: 298.257,
    ellipseName: "Soviet Geodetic System 85"
  };

  exports$2.GRS80 = {
    a: 6378137.0,
    rf: 298.257222101,
    ellipseName: "GRS 1980(IUGG, 1980)"
  };

  exports$2.IAU76 = {
    a: 6378140.0,
    rf: 298.257,
    ellipseName: "IAU 1976"
  };

  exports$2.airy = {
    a: 6377563.396,
    b: 6356256.910,
    ellipseName: "Airy 1830"
  };

  exports$2.APL4 = {
    a: 6378137,
    rf: 298.25,
    ellipseName: "Appl. Physics. 1965"
  };

  exports$2.NWL9D = {
    a: 6378145.0,
    rf: 298.25,
    ellipseName: "Naval Weapons Lab., 1965"
  };

  exports$2.mod_airy = {
    a: 6377340.189,
    b: 6356034.446,
    ellipseName: "Modified Airy"
  };

  exports$2.andrae = {
    a: 6377104.43,
    rf: 300.0,
    ellipseName: "Andrae 1876 (Den., Iclnd.)"
  };

  exports$2.aust_SA = {
    a: 6378160.0,
    rf: 298.25,
    ellipseName: "Australian Natl & S. Amer. 1969"
  };

  exports$2.GRS67 = {
    a: 6378160.0,
    rf: 298.2471674270,
    ellipseName: "GRS 67(IUGG 1967)"
  };

  exports$2.bessel = {
    a: 6377397.155,
    rf: 299.1528128,
    ellipseName: "Bessel 1841"
  };

  exports$2.bess_nam = {
    a: 6377483.865,
    rf: 299.1528128,
    ellipseName: "Bessel 1841 (Namibia)"
  };

  exports$2.clrk66 = {
    a: 6378206.4,
    b: 6356583.8,
    ellipseName: "Clarke 1866"
  };

  exports$2.clrk80 = {
    a: 6378249.145,
    rf: 293.4663,
    ellipseName: "Clarke 1880 mod."
  };

  exports$2.clrk80ign = {
    a: 6378249.2,
    b: 6356515,
    rf: 293.4660213,
    ellipseName: "Clarke 1880 (IGN)"
  };

  exports$2.clrk58 = {
    a: 6378293.645208759,
    rf: 294.2606763692654,
    ellipseName: "Clarke 1858"
  };

  exports$2.CPM = {
    a: 6375738.7,
    rf: 334.29,
    ellipseName: "Comm. des Poids et Mesures 1799"
  };

  exports$2.delmbr = {
    a: 6376428.0,
    rf: 311.5,
    ellipseName: "Delambre 1810 (Belgium)"
  };

  exports$2.engelis = {
    a: 6378136.05,
    rf: 298.2566,
    ellipseName: "Engelis 1985"
  };

  exports$2.evrst30 = {
    a: 6377276.345,
    rf: 300.8017,
    ellipseName: "Everest 1830"
  };

  exports$2.evrst48 = {
    a: 6377304.063,
    rf: 300.8017,
    ellipseName: "Everest 1948"
  };

  exports$2.evrst56 = {
    a: 6377301.243,
    rf: 300.8017,
    ellipseName: "Everest 1956"
  };

  exports$2.evrst69 = {
    a: 6377295.664,
    rf: 300.8017,
    ellipseName: "Everest 1969"
  };

  exports$2.evrstSS = {
    a: 6377298.556,
    rf: 300.8017,
    ellipseName: "Everest (Sabah & Sarawak)"
  };

  exports$2.fschr60 = {
    a: 6378166.0,
    rf: 298.3,
    ellipseName: "Fischer (Mercury Datum) 1960"
  };

  exports$2.fschr60m = {
    a: 6378155.0,
    rf: 298.3,
    ellipseName: "Fischer 1960"
  };

  exports$2.fschr68 = {
    a: 6378150.0,
    rf: 298.3,
    ellipseName: "Fischer 1968"
  };

  exports$2.helmert = {
    a: 6378200.0,
    rf: 298.3,
    ellipseName: "Helmert 1906"
  };

  exports$2.hough = {
    a: 6378270.0,
    rf: 297.0,
    ellipseName: "Hough"
  };

  exports$2.intl = {
    a: 6378388.0,
    rf: 297.0,
    ellipseName: "International 1909 (Hayford)"
  };

  exports$2.kaula = {
    a: 6378163.0,
    rf: 298.24,
    ellipseName: "Kaula 1961"
  };

  exports$2.lerch = {
    a: 6378139.0,
    rf: 298.257,
    ellipseName: "Lerch 1979"
  };

  exports$2.mprts = {
    a: 6397300.0,
    rf: 191.0,
    ellipseName: "Maupertius 1738"
  };

  exports$2.new_intl = {
    a: 6378157.5,
    b: 6356772.2,
    ellipseName: "New International 1967"
  };

  exports$2.plessis = {
    a: 6376523.0,
    rf: 6355863.0,
    ellipseName: "Plessis 1817 (France)"
  };

  exports$2.krass = {
    a: 6378245.0,
    rf: 298.3,
    ellipseName: "Krassovsky, 1942"
  };

  exports$2.SEasia = {
    a: 6378155.0,
    b: 6356773.3205,
    ellipseName: "Southeast Asia"
  };

  exports$2.walbeck = {
    a: 6376896.0,
    b: 6355834.8467,
    ellipseName: "Walbeck"
  };

  exports$2.WGS60 = {
    a: 6378165.0,
    rf: 298.3,
    ellipseName: "WGS 60"
  };

  exports$2.WGS66 = {
    a: 6378145.0,
    rf: 298.25,
    ellipseName: "WGS 66"
  };

  exports$2.WGS7 = {
    a: 6378135.0,
    rf: 298.26,
    ellipseName: "WGS 72"
  };

  var WGS84 = exports$2.WGS84 = {
    a: 6378137.0,
    rf: 298.257223563,
    ellipseName: "WGS 84"
  };

  exports$2.sphere = {
    a: 6370997.0,
    b: 6370997.0,
    ellipseName: "Normal Sphere (r=6370997)"
  };

  function eccentricity(a, b, rf, R_A) {
    var a2 = a * a; // used in geocentric
    var b2 = b * b; // used in geocentric
    var es = (a2 - b2) / a2; // e ^ 2
    var e = 0;
    if (R_A) {
      a *= 1 - es * (SIXTH + es * (RA4 + es * RA6));
      a2 = a * a;
      es = 0;
    } else {
      e = Math.sqrt(es); // eccentricity
    }
    var ep2 = (a2 - b2) / b2; // used in geocentric
    return {
      es: es,
      e: e,
      ep2: ep2
    };
  }
  function sphere(a, b, rf, ellps, sphere) {
    if (!a) { // do we have an ellipsoid?
      var ellipse = match(exports$2, ellps);
      if (!ellipse) {
        ellipse = WGS84;
      }
      a = ellipse.a;
      b = ellipse.b;
      rf = ellipse.rf;
    }

    if (rf && !b) {
      b = (1.0 - 1.0 / rf) * a;
    }
    if (rf === 0 || Math.abs(a - b) < EPSLN) {
      sphere = true;
      b = a;
    }
    return {
      a: a,
      b: b,
      rf: rf,
      sphere: sphere
    };
  }

  var exports$1 = {};
  exports$1.wgs84 = {
    towgs84: "0,0,0",
    ellipse: "WGS84",
    datumName: "WGS84"
  };

  exports$1.ch1903 = {
    towgs84: "674.374,15.056,405.346",
    ellipse: "bessel",
    datumName: "swiss"
  };

  exports$1.ggrs87 = {
    towgs84: "-199.87,74.79,246.62",
    ellipse: "GRS80",
    datumName: "Greek_Geodetic_Reference_System_1987"
  };

  exports$1.nad83 = {
    towgs84: "0,0,0",
    ellipse: "GRS80",
    datumName: "North_American_Datum_1983"
  };

  exports$1.nad27 = {
    nadgrids: "@conus,@alaska,@ntv2_0.gsb,@ntv1_can.dat",
    ellipse: "clrk66",
    datumName: "North_American_Datum_1927"
  };

  exports$1.potsdam = {
    towgs84: "598.1,73.7,418.2,0.202,0.045,-2.455,6.7",
    ellipse: "bessel",
    datumName: "Potsdam Rauenberg 1950 DHDN"
  };

  exports$1.carthage = {
    towgs84: "-263.0,6.0,431.0",
    ellipse: "clark80",
    datumName: "Carthage 1934 Tunisia"
  };

  exports$1.hermannskogel = {
    towgs84: "577.326,90.129,463.919,5.137,1.474,5.297,2.4232",
    ellipse: "bessel",
    datumName: "Hermannskogel"
  };

  exports$1.militargeographische_institut = {
    towgs84: "577.326,90.129,463.919,5.137,1.474,5.297,2.4232",
    ellipse: "bessel",
    datumName: "Militar-Geographische Institut"
  };

  exports$1.osni52 = {
    towgs84: "482.530,-130.596,564.557,-1.042,-0.214,-0.631,8.15",
    ellipse: "airy",
    datumName: "Irish National"
  };

  exports$1.ire65 = {
    towgs84: "482.530,-130.596,564.557,-1.042,-0.214,-0.631,8.15",
    ellipse: "mod_airy",
    datumName: "Ireland 1965"
  };

  exports$1.rassadiran = {
    towgs84: "-133.63,-157.5,-158.62",
    ellipse: "intl",
    datumName: "Rassadiran"
  };

  exports$1.nzgd49 = {
    towgs84: "59.47,-5.04,187.44,0.47,-0.1,1.024,-4.5993",
    ellipse: "intl",
    datumName: "New Zealand Geodetic Datum 1949"
  };

  exports$1.osgb36 = {
    towgs84: "446.448,-125.157,542.060,0.1502,0.2470,0.8421,-20.4894",
    ellipse: "airy",
    datumName: "Airy 1830"
  };

  exports$1.s_jtsk = {
    towgs84: "589,76,480",
    ellipse: 'bessel',
    datumName: 'S-JTSK (Ferro)'
  };

  exports$1.beduaram = {
    towgs84: '-106,-87,188',
    ellipse: 'clrk80',
    datumName: 'Beduaram'
  };

  exports$1.gunung_segara = {
    towgs84: '-403,684,41',
    ellipse: 'bessel',
    datumName: 'Gunung Segara Jakarta'
  };

  exports$1.rnb72 = {
    towgs84: "106.869,-52.2978,103.724,-0.33657,0.456955,-1.84218,1",
    ellipse: "intl",
    datumName: "Reseau National Belge 1972"
  };

  function datum(datumCode, datum_params, a, b, es, ep2, nadgrids) {
    var out = {};

    if (datumCode === undefined || datumCode === 'none') {
      out.datum_type = PJD_NODATUM;
    } else {
      out.datum_type = PJD_WGS84;
    }

    if (datum_params) {
      out.datum_params = datum_params.map(parseFloat);
      if (out.datum_params[0] !== 0 || out.datum_params[1] !== 0 || out.datum_params[2] !== 0) {
        out.datum_type = PJD_3PARAM;
      }
      if (out.datum_params.length > 3) {
        if (out.datum_params[3] !== 0 || out.datum_params[4] !== 0 || out.datum_params[5] !== 0 || out.datum_params[6] !== 0) {
          out.datum_type = PJD_7PARAM;
          out.datum_params[3] *= SEC_TO_RAD;
          out.datum_params[4] *= SEC_TO_RAD;
          out.datum_params[5] *= SEC_TO_RAD;
          out.datum_params[6] = (out.datum_params[6] / 1000000.0) + 1.0;
        }
      }
    }

    if (nadgrids) {
      out.datum_type = PJD_GRIDSHIFT;
      out.grids = nadgrids;
    }
    out.a = a; //datum object also uses these values
    out.b = b;
    out.es = es;
    out.ep2 = ep2;
    return out;
  }

  /**
   * Resources for details of NTv2 file formats:
   * - https://web.archive.org/web/20140127204822if_/http://www.mgs.gov.on.ca:80/stdprodconsume/groups/content/@mgs/@iandit/documents/resourcelist/stel02_047447.pdf
   * - http://mimaka.com/help/gs/html/004_NTV2%20Data%20Format.htm
   */

  var loadedNadgrids = {};

  /**
   * Load a binary NTv2 file (.gsb) to a key that can be used in a proj string like +nadgrids=<key>. Pass the NTv2 file
   * as an ArrayBuffer.
   */
  function nadgrid(key, data) {
    var view = new DataView(data);
    var isLittleEndian = detectLittleEndian(view);
    var header = readHeader(view, isLittleEndian);
    var subgrids = readSubgrids(view, header, isLittleEndian);
    var nadgrid = {header: header, subgrids: subgrids};
    loadedNadgrids[key] = nadgrid;
    return nadgrid;
  }

  /**
   * Given a proj4 value for nadgrids, return an array of loaded grids
   */
  function getNadgrids(nadgrids) {
    // Format details: http://proj.maptools.org/gen_parms.html
    if (nadgrids === undefined) { return null; }
    var grids = nadgrids.split(',');
    return grids.map(parseNadgridString);
  }

  function parseNadgridString(value) {
    if (value.length === 0) {
      return null;
    }
    var optional = value[0] === '@';
    if (optional) {
      value = value.slice(1);
    }
    if (value === 'null') {
      return {name: 'null', mandatory: !optional, grid: null, isNull: true};
    }
    return {
      name: value,
      mandatory: !optional,
      grid: loadedNadgrids[value] || null,
      isNull: false
    };
  }

  function secondsToRadians(seconds) {
    return (seconds / 3600) * Math.PI / 180;
  }

  function detectLittleEndian(view) {
    var nFields = view.getInt32(8, false);
    if (nFields === 11) {
      return false;
    }
    nFields = view.getInt32(8, true);
    if (nFields !== 11) {
      console.warn('Failed to detect nadgrid endian-ness, defaulting to little-endian');
    }
    return true;
  }

  function readHeader(view, isLittleEndian) {
    return {
      nFields: view.getInt32(8, isLittleEndian),
      nSubgridFields: view.getInt32(24, isLittleEndian),
      nSubgrids: view.getInt32(40, isLittleEndian),
      shiftType: decodeString(view, 56, 56 + 8).trim(),
      fromSemiMajorAxis: view.getFloat64(120, isLittleEndian),
      fromSemiMinorAxis: view.getFloat64(136, isLittleEndian),
      toSemiMajorAxis: view.getFloat64(152, isLittleEndian),
      toSemiMinorAxis: view.getFloat64(168, isLittleEndian),
    };
  }

  function decodeString(view, start, end) {
    return String.fromCharCode.apply(null, new Uint8Array(view.buffer.slice(start, end)));
  }

  function readSubgrids(view, header, isLittleEndian) {
    var gridOffset = 176;
    var grids = [];
    for (var i = 0; i < header.nSubgrids; i++) {
      var subHeader = readGridHeader(view, gridOffset, isLittleEndian);
      var nodes = readGridNodes(view, gridOffset, subHeader, isLittleEndian);
      var lngColumnCount = Math.round(
        1 + (subHeader.upperLongitude - subHeader.lowerLongitude) / subHeader.longitudeInterval);
      var latColumnCount = Math.round(
        1 + (subHeader.upperLatitude - subHeader.lowerLatitude) / subHeader.latitudeInterval);
      // Proj4 operates on radians whereas the coordinates are in seconds in the grid
      grids.push({
        ll: [secondsToRadians(subHeader.lowerLongitude), secondsToRadians(subHeader.lowerLatitude)],
        del: [secondsToRadians(subHeader.longitudeInterval), secondsToRadians(subHeader.latitudeInterval)],
        lim: [lngColumnCount, latColumnCount],
        count: subHeader.gridNodeCount,
        cvs: mapNodes(nodes)
      });
      gridOffset += 176 + subHeader.gridNodeCount * 16;
    }
    return grids;
  }

  function mapNodes(nodes) {
    return nodes.map(function (r) {return [secondsToRadians(r.longitudeShift), secondsToRadians(r.latitudeShift)];});
  }

  function readGridHeader(view, offset, isLittleEndian) {
    return {
      name: decodeString(view, offset + 8, offset + 16).trim(),
      parent: decodeString(view, offset + 24, offset + 24 + 8).trim(),
      lowerLatitude: view.getFloat64(offset + 72, isLittleEndian),
      upperLatitude: view.getFloat64(offset + 88, isLittleEndian),
      lowerLongitude: view.getFloat64(offset + 104, isLittleEndian),
      upperLongitude: view.getFloat64(offset + 120, isLittleEndian),
      latitudeInterval: view.getFloat64(offset + 136, isLittleEndian),
      longitudeInterval: view.getFloat64(offset + 152, isLittleEndian),
      gridNodeCount: view.getInt32(offset + 168, isLittleEndian)
    };
  }

  function readGridNodes(view, offset, gridHeader, isLittleEndian) {
    var nodesOffset = offset + 176;
    var gridRecordLength = 16;
    var gridShiftRecords = [];
    for (var i = 0; i < gridHeader.gridNodeCount; i++) {
      var record = {
        latitudeShift: view.getFloat32(nodesOffset + i * gridRecordLength, isLittleEndian),
        longitudeShift: view.getFloat32(nodesOffset + i * gridRecordLength + 4, isLittleEndian),
        latitudeAccuracy: view.getFloat32(nodesOffset + i * gridRecordLength + 8, isLittleEndian),
        longitudeAccuracy: view.getFloat32(nodesOffset + i * gridRecordLength + 12, isLittleEndian),
      };
      gridShiftRecords.push(record);
    }
    return gridShiftRecords;
  }

  function Projection(srsCode,callback) {
    if (!(this instanceof Projection)) {
      return new Projection(srsCode);
    }
    callback = callback || function(error){
      if(error){
        throw error;
      }
    };
    var json = parse(srsCode);
    if(typeof json !== 'object'){
      callback(srsCode);
      return;
    }
    var ourProj = Projection.projections.get(json.projName);
    if(!ourProj){
      callback(srsCode);
      return;
    }
    if (json.datumCode && json.datumCode !== 'none') {
      var datumDef = match(exports$1, json.datumCode);
      if (datumDef) {
        json.datum_params = json.datum_params || (datumDef.towgs84 ? datumDef.towgs84.split(',') : null);
        json.ellps = datumDef.ellipse;
        json.datumName = datumDef.datumName ? datumDef.datumName : json.datumCode;
      }
    }
    json.k0 = json.k0 || 1.0;
    json.axis = json.axis || 'enu';
    json.ellps = json.ellps || 'wgs84';
    json.lat1 = json.lat1 || json.lat0; // Lambert_Conformal_Conic_1SP, for example, needs this

    var sphere_ = sphere(json.a, json.b, json.rf, json.ellps, json.sphere);
    var ecc = eccentricity(sphere_.a, sphere_.b, sphere_.rf, json.R_A);
    var nadgrids = getNadgrids(json.nadgrids);
    var datumObj = json.datum || datum(json.datumCode, json.datum_params, sphere_.a, sphere_.b, ecc.es, ecc.ep2,
      nadgrids);

    extend(this, json); // transfer everything over from the projection because we don't know what we'll need
    extend(this, ourProj); // transfer all the methods from the projection

    // copy the 4 things over we calculated in deriveConstants.sphere
    this.a = sphere_.a;
    this.b = sphere_.b;
    this.rf = sphere_.rf;
    this.sphere = sphere_.sphere;

    // copy the 3 things we calculated in deriveConstants.eccentricity
    this.es = ecc.es;
    this.e = ecc.e;
    this.ep2 = ecc.ep2;

    // add in the datum object
    this.datum = datumObj;

    // init the projection
    this.init();

    // legecy callback from back in the day when it went to spatialreference.org
    callback(null, this);

  }
  Projection.projections = projections;
  Projection.projections.start();

  function compareDatums(source, dest) {
    if (source.datum_type !== dest.datum_type) {
      return false; // false, datums are not equal
    } else if (source.a !== dest.a || Math.abs(source.es - dest.es) > 0.000000000050) {
      // the tolerance for es is to ensure that GRS80 and WGS84
      // are considered identical
      return false;
    } else if (source.datum_type === PJD_3PARAM) {
      return (source.datum_params[0] === dest.datum_params[0] && source.datum_params[1] === dest.datum_params[1] && source.datum_params[2] === dest.datum_params[2]);
    } else if (source.datum_type === PJD_7PARAM) {
      return (source.datum_params[0] === dest.datum_params[0] && source.datum_params[1] === dest.datum_params[1] && source.datum_params[2] === dest.datum_params[2] && source.datum_params[3] === dest.datum_params[3] && source.datum_params[4] === dest.datum_params[4] && source.datum_params[5] === dest.datum_params[5] && source.datum_params[6] === dest.datum_params[6]);
    } else {
      return true; // datums are equal
    }
  } // cs_compare_datums()

  /*
   * The function Convert_Geodetic_To_Geocentric converts geodetic coordinates
   * (latitude, longitude, and height) to geocentric coordinates (X, Y, Z),
   * according to the current ellipsoid parameters.
   *
   *    Latitude  : Geodetic latitude in radians                     (input)
   *    Longitude : Geodetic longitude in radians                    (input)
   *    Height    : Geodetic height, in meters                       (input)
   *    X         : Calculated Geocentric X coordinate, in meters    (output)
   *    Y         : Calculated Geocentric Y coordinate, in meters    (output)
   *    Z         : Calculated Geocentric Z coordinate, in meters    (output)
   *
   */
  function geodeticToGeocentric(p, es, a) {
    var Longitude = p.x;
    var Latitude = p.y;
    var Height = p.z ? p.z : 0; //Z value not always supplied

    var Rn; /*  Earth radius at location  */
    var Sin_Lat; /*  Math.sin(Latitude)  */
    var Sin2_Lat; /*  Square of Math.sin(Latitude)  */
    var Cos_Lat; /*  Math.cos(Latitude)  */

    /*
     ** Don't blow up if Latitude is just a little out of the value
     ** range as it may just be a rounding issue.  Also removed longitude
     ** test, it should be wrapped by Math.cos() and Math.sin().  NFW for PROJ.4, Sep/2001.
     */
    if (Latitude < -HALF_PI && Latitude > -1.001 * HALF_PI) {
      Latitude = -HALF_PI;
    } else if (Latitude > HALF_PI && Latitude < 1.001 * HALF_PI) {
      Latitude = HALF_PI;
    } else if (Latitude < -HALF_PI) {
      /* Latitude out of range */
      //..reportError('geocent:lat out of range:' + Latitude);
      return { x: -Infinity, y: -Infinity, z: p.z };
    } else if (Latitude > HALF_PI) {
      /* Latitude out of range */
      return { x: Infinity, y: Infinity, z: p.z };
    }

    if (Longitude > Math.PI) {
      Longitude -= (2 * Math.PI);
    }
    Sin_Lat = Math.sin(Latitude);
    Cos_Lat = Math.cos(Latitude);
    Sin2_Lat = Sin_Lat * Sin_Lat;
    Rn = a / (Math.sqrt(1.0e0 - es * Sin2_Lat));
    return {
      x: (Rn + Height) * Cos_Lat * Math.cos(Longitude),
      y: (Rn + Height) * Cos_Lat * Math.sin(Longitude),
      z: ((Rn * (1 - es)) + Height) * Sin_Lat
    };
  } // cs_geodetic_to_geocentric()

  function geocentricToGeodetic(p, es, a, b) {
    /* local defintions and variables */
    /* end-criterium of loop, accuracy of sin(Latitude) */
    var genau = 1e-12;
    var genau2 = (genau * genau);
    var maxiter = 30;

    var P; /* distance between semi-minor axis and location */
    var RR; /* distance between center and location */
    var CT; /* sin of geocentric latitude */
    var ST; /* cos of geocentric latitude */
    var RX;
    var RK;
    var RN; /* Earth radius at location */
    var CPHI0; /* cos of start or old geodetic latitude in iterations */
    var SPHI0; /* sin of start or old geodetic latitude in iterations */
    var CPHI; /* cos of searched geodetic latitude */
    var SPHI; /* sin of searched geodetic latitude */
    var SDPHI; /* end-criterium: addition-theorem of sin(Latitude(iter)-Latitude(iter-1)) */
    var iter; /* # of continous iteration, max. 30 is always enough (s.a.) */

    var X = p.x;
    var Y = p.y;
    var Z = p.z ? p.z : 0.0; //Z value not always supplied
    var Longitude;
    var Latitude;
    var Height;

    P = Math.sqrt(X * X + Y * Y);
    RR = Math.sqrt(X * X + Y * Y + Z * Z);

    /*      special cases for latitude and longitude */
    if (P / a < genau) {

      /*  special case, if P=0. (X=0., Y=0.) */
      Longitude = 0.0;

      /*  if (X,Y,Z)=(0.,0.,0.) then Height becomes semi-minor axis
       *  of ellipsoid (=center of mass), Latitude becomes PI/2 */
      if (RR / a < genau) {
        Latitude = HALF_PI;
        Height = -b;
        return {
          x: p.x,
          y: p.y,
          z: p.z
        };
      }
    } else {
      /*  ellipsoidal (geodetic) longitude
       *  interval: -PI < Longitude <= +PI */
      Longitude = Math.atan2(Y, X);
    }

    /* --------------------------------------------------------------
     * Following iterative algorithm was developped by
     * "Institut for Erdmessung", University of Hannover, July 1988.
     * Internet: www.ife.uni-hannover.de
     * Iterative computation of CPHI,SPHI and Height.
     * Iteration of CPHI and SPHI to 10**-12 radian resp.
     * 2*10**-7 arcsec.
     * --------------------------------------------------------------
     */
    CT = Z / RR;
    ST = P / RR;
    RX = 1.0 / Math.sqrt(1.0 - es * (2.0 - es) * ST * ST);
    CPHI0 = ST * (1.0 - es) * RX;
    SPHI0 = CT * RX;
    iter = 0;

    /* loop to find sin(Latitude) resp. Latitude
     * until |sin(Latitude(iter)-Latitude(iter-1))| < genau */
    do {
      iter++;
      RN = a / Math.sqrt(1.0 - es * SPHI0 * SPHI0);

      /*  ellipsoidal (geodetic) height */
      Height = P * CPHI0 + Z * SPHI0 - RN * (1.0 - es * SPHI0 * SPHI0);

      RK = es * RN / (RN + Height);
      RX = 1.0 / Math.sqrt(1.0 - RK * (2.0 - RK) * ST * ST);
      CPHI = ST * (1.0 - RK) * RX;
      SPHI = CT * RX;
      SDPHI = SPHI * CPHI0 - CPHI * SPHI0;
      CPHI0 = CPHI;
      SPHI0 = SPHI;
    }
    while (SDPHI * SDPHI > genau2 && iter < maxiter);

    /*      ellipsoidal (geodetic) latitude */
    Latitude = Math.atan(SPHI / Math.abs(CPHI));
    return {
      x: Longitude,
      y: Latitude,
      z: Height
    };
  } // cs_geocentric_to_geodetic()

  /****************************************************************/
  // pj_geocentic_to_wgs84( p )
  //  p = point to transform in geocentric coordinates (x,y,z)


  /** point object, nothing fancy, just allows values to be
      passed back and forth by reference rather than by value.
      Other point classes may be used as long as they have
      x and y properties, which will get modified in the transform method.
  */
  function geocentricToWgs84(p, datum_type, datum_params) {

    if (datum_type === PJD_3PARAM) {
      // if( x[io] === HUGE_VAL )
      //    continue;
      return {
        x: p.x + datum_params[0],
        y: p.y + datum_params[1],
        z: p.z + datum_params[2],
      };
    } else if (datum_type === PJD_7PARAM) {
      var Dx_BF = datum_params[0];
      var Dy_BF = datum_params[1];
      var Dz_BF = datum_params[2];
      var Rx_BF = datum_params[3];
      var Ry_BF = datum_params[4];
      var Rz_BF = datum_params[5];
      var M_BF = datum_params[6];
      // if( x[io] === HUGE_VAL )
      //    continue;
      return {
        x: M_BF * (p.x - Rz_BF * p.y + Ry_BF * p.z) + Dx_BF,
        y: M_BF * (Rz_BF * p.x + p.y - Rx_BF * p.z) + Dy_BF,
        z: M_BF * (-Ry_BF * p.x + Rx_BF * p.y + p.z) + Dz_BF
      };
    }
  } // cs_geocentric_to_wgs84

  /****************************************************************/
  // pj_geocentic_from_wgs84()
  //  coordinate system definition,
  //  point to transform in geocentric coordinates (x,y,z)
  function geocentricFromWgs84(p, datum_type, datum_params) {

    if (datum_type === PJD_3PARAM) {
      //if( x[io] === HUGE_VAL )
      //    continue;
      return {
        x: p.x - datum_params[0],
        y: p.y - datum_params[1],
        z: p.z - datum_params[2],
      };

    } else if (datum_type === PJD_7PARAM) {
      var Dx_BF = datum_params[0];
      var Dy_BF = datum_params[1];
      var Dz_BF = datum_params[2];
      var Rx_BF = datum_params[3];
      var Ry_BF = datum_params[4];
      var Rz_BF = datum_params[5];
      var M_BF = datum_params[6];
      var x_tmp = (p.x - Dx_BF) / M_BF;
      var y_tmp = (p.y - Dy_BF) / M_BF;
      var z_tmp = (p.z - Dz_BF) / M_BF;
      //if( x[io] === HUGE_VAL )
      //    continue;

      return {
        x: x_tmp + Rz_BF * y_tmp - Ry_BF * z_tmp,
        y: -Rz_BF * x_tmp + y_tmp + Rx_BF * z_tmp,
        z: Ry_BF * x_tmp - Rx_BF * y_tmp + z_tmp
      };
    } //cs_geocentric_from_wgs84()
  }

  function checkParams(type) {
    return (type === PJD_3PARAM || type === PJD_7PARAM);
  }

  function datum_transform(source, dest, point) {
    // Short cut if the datums are identical.
    if (compareDatums(source, dest)) {
      return point; // in this case, zero is sucess,
      // whereas cs_compare_datums returns 1 to indicate TRUE
      // confusing, should fix this
    }

    // Explicitly skip datum transform by setting 'datum=none' as parameter for either source or dest
    if (source.datum_type === PJD_NODATUM || dest.datum_type === PJD_NODATUM) {
      return point;
    }

    // If this datum requires grid shifts, then apply it to geodetic coordinates.
    var source_a = source.a;
    var source_es = source.es;
    if (source.datum_type === PJD_GRIDSHIFT) {
      var gridShiftCode = applyGridShift(source, false, point);
      if (gridShiftCode !== 0) {
        return undefined;
      }
      source_a = SRS_WGS84_SEMIMAJOR;
      source_es = SRS_WGS84_ESQUARED;
    }

    var dest_a = dest.a;
    var dest_b = dest.b;
    var dest_es = dest.es;
    if (dest.datum_type === PJD_GRIDSHIFT) {
      dest_a = SRS_WGS84_SEMIMAJOR;
      dest_b = SRS_WGS84_SEMIMINOR;
      dest_es = SRS_WGS84_ESQUARED;
    }

    // Do we need to go through geocentric coordinates?
    if (source_es === dest_es && source_a === dest_a && !checkParams(source.datum_type) &&  !checkParams(dest.datum_type)) {
      return point;
    }

    // Convert to geocentric coordinates.
    point = geodeticToGeocentric(point, source_es, source_a);
    // Convert between datums
    if (checkParams(source.datum_type)) {
      point = geocentricToWgs84(point, source.datum_type, source.datum_params);
    }
    if (checkParams(dest.datum_type)) {
      point = geocentricFromWgs84(point, dest.datum_type, dest.datum_params);
    }
    point = geocentricToGeodetic(point, dest_es, dest_a, dest_b);

    if (dest.datum_type === PJD_GRIDSHIFT) {
      var destGridShiftResult = applyGridShift(dest, true, point);
      if (destGridShiftResult !== 0) {
        return undefined;
      }
    }

    return point;
  }

  function applyGridShift(source, inverse, point) {
    if (source.grids === null || source.grids.length === 0) {
      console.log('Grid shift grids not found');
      return -1;
    }
    var input = {x: -point.x, y: point.y};
    var output = {x: Number.NaN, y: Number.NaN};
    var attemptedGrids = [];
    outer:
    for (var i = 0; i < source.grids.length; i++) {
      var grid = source.grids[i];
      attemptedGrids.push(grid.name);
      if (grid.isNull) {
        output = input;
        break;
      }
      grid.mandatory;
      if (grid.grid === null) {
        if (grid.mandatory) {
          console.log("Unable to find mandatory grid '" + grid.name + "'");
          return -1;
        }
        continue;
      }
      var subgrids = grid.grid.subgrids;
      for (var j = 0, jj = subgrids.length; j < jj; j++) {
        var subgrid = subgrids[j];
        // skip tables that don't match our point at all
        var epsilon = (Math.abs(subgrid.del[1]) + Math.abs(subgrid.del[0])) / 10000.0;
        var minX = subgrid.ll[0] - epsilon;
        var minY = subgrid.ll[1] - epsilon;
        var maxX = subgrid.ll[0] + (subgrid.lim[0] - 1) * subgrid.del[0] + epsilon;
        var maxY = subgrid.ll[1] + (subgrid.lim[1] - 1) * subgrid.del[1] + epsilon;
        if (minY > input.y || minX > input.x || maxY < input.y || maxX < input.x ) {
          continue;
        }
        output = applySubgridShift(input, inverse, subgrid);
        if (!isNaN(output.x)) {
          break outer;
        }
      }
    }
    if (isNaN(output.x)) {
      console.log("Failed to find a grid shift table for location '"+
        -input.x * R2D + " " + input.y * R2D + " tried: '" + attemptedGrids + "'");
      return -1;
    }
    point.x = -output.x;
    point.y = output.y;
    return 0;
  }

  function applySubgridShift(pin, inverse, ct) {
    var val = {x: Number.NaN, y: Number.NaN};
    if (isNaN(pin.x)) { return val; }
    var tb = {x: pin.x, y: pin.y};
    tb.x -= ct.ll[0];
    tb.y -= ct.ll[1];
    tb.x = adjust_lon(tb.x - Math.PI) + Math.PI;
    var t = nadInterpolate(tb, ct);
    if (inverse) {
      if (isNaN(t.x)) {
        return val;
      }
      t.x = tb.x - t.x;
      t.y = tb.y - t.y;
      var i = 9, tol = 1e-12;
      var dif, del;
      do {
        del = nadInterpolate(t, ct);
        if (isNaN(del.x)) {
          console.log("Inverse grid shift iteration failed, presumably at grid edge.  Using first approximation.");
          break;
        }
        dif = {x: tb.x - (del.x + t.x), y: tb.y - (del.y + t.y)};
        t.x += dif.x;
        t.y += dif.y;
      } while (i-- && Math.abs(dif.x) > tol && Math.abs(dif.y) > tol);
      if (i < 0) {
        console.log("Inverse grid shift iterator failed to converge.");
        return val;
      }
      val.x = adjust_lon(t.x + ct.ll[0]);
      val.y = t.y + ct.ll[1];
    } else {
      if (!isNaN(t.x)) {
        val.x = pin.x + t.x;
        val.y = pin.y + t.y;
      }
    }
    return val;
  }

  function nadInterpolate(pin, ct) {
    var t = {x: pin.x / ct.del[0], y: pin.y / ct.del[1]};
    var indx = {x: Math.floor(t.x), y: Math.floor(t.y)};
    var frct = {x: t.x - 1.0 * indx.x, y: t.y - 1.0 * indx.y};
    var val= {x: Number.NaN, y: Number.NaN};
    var inx;
    if (indx.x < 0 || indx.x >= ct.lim[0]) {
      return val;
    }
    if (indx.y < 0 || indx.y >= ct.lim[1]) {
      return val;
    }
    inx = (indx.y * ct.lim[0]) + indx.x;
    var f00 = {x: ct.cvs[inx][0], y: ct.cvs[inx][1]};
    inx++;
    var f10= {x: ct.cvs[inx][0], y: ct.cvs[inx][1]};
    inx += ct.lim[0];
    var f11 = {x: ct.cvs[inx][0], y: ct.cvs[inx][1]};
    inx--;
    var f01 = {x: ct.cvs[inx][0], y: ct.cvs[inx][1]};
    var m11 = frct.x * frct.y, m10 = frct.x * (1.0 - frct.y),
      m00 = (1.0 - frct.x) * (1.0 - frct.y), m01 = (1.0 - frct.x) * frct.y;
    val.x = (m00 * f00.x + m10 * f10.x + m01 * f01.x + m11 * f11.x);
    val.y = (m00 * f00.y + m10 * f10.y + m01 * f01.y + m11 * f11.y);
    return val;
  }

  function adjust_axis(crs, denorm, point) {
    var xin = point.x,
      yin = point.y,
      zin = point.z || 0.0;
    var v, t, i;
    var out = {};
    for (i = 0; i < 3; i++) {
      if (denorm && i === 2 && point.z === undefined) {
        continue;
      }
      if (i === 0) {
        v = xin;
        if ("ew".indexOf(crs.axis[i]) !== -1) {
          t = 'x';
        } else {
          t = 'y';
        }

      }
      else if (i === 1) {
        v = yin;
        if ("ns".indexOf(crs.axis[i]) !== -1) {
          t = 'y';
        } else {
          t = 'x';
        }
      }
      else {
        v = zin;
        t = 'z';
      }
      switch (crs.axis[i]) {
      case 'e':
        out[t] = v;
        break;
      case 'w':
        out[t] = -v;
        break;
      case 'n':
        out[t] = v;
        break;
      case 's':
        out[t] = -v;
        break;
      case 'u':
        if (point[t] !== undefined) {
          out.z = v;
        }
        break;
      case 'd':
        if (point[t] !== undefined) {
          out.z = -v;
        }
        break;
      default:
        //console.log("ERROR: unknow axis ("+crs.axis[i]+") - check definition of "+crs.projName);
        return null;
      }
    }
    return out;
  }

  function common (array){
    var out = {
      x: array[0],
      y: array[1]
    };
    if (array.length>2) {
      out.z = array[2];
    }
    if (array.length>3) {
      out.m = array[3];
    }
    return out;
  }

  function checkSanity (point) {
    checkCoord(point.x);
    checkCoord(point.y);
  }
  function checkCoord(num) {
    if (typeof Number.isFinite === 'function') {
      if (Number.isFinite(num)) {
        return;
      }
      throw new TypeError('coordinates must be finite numbers');
    }
    if (typeof num !== 'number' || num !== num || !isFinite(num)) {
      throw new TypeError('coordinates must be finite numbers');
    }
  }

  function checkNotWGS(source, dest) {
    return (
      (source.datum.datum_type === PJD_3PARAM || source.datum.datum_type === PJD_7PARAM || source.datum.datum_type === PJD_GRIDSHIFT) && dest.datumCode !== 'WGS84') ||
      ((dest.datum.datum_type === PJD_3PARAM || dest.datum.datum_type === PJD_7PARAM || dest.datum.datum_type === PJD_GRIDSHIFT) && source.datumCode !== 'WGS84');
  }

  function transform(source, dest, point, enforceAxis) {
    var wgs84;
    if (Array.isArray(point)) {
      point = common(point);
    } else {
      // Clone the point object so inputs don't get modified
      point = {
        x: point.x,
        y: point.y,
        z: point.z,
        m: point.m
      };
    }
    var hasZ = point.z !== undefined;
    checkSanity(point);
    // Workaround for datum shifts towgs84, if either source or destination projection is not wgs84
    if (source.datum && dest.datum && checkNotWGS(source, dest)) {
      wgs84 = new Projection('WGS84');
      point = transform(source, wgs84, point, enforceAxis);
      source = wgs84;
    }
    // DGR, 2010/11/12
    if (enforceAxis && source.axis !== 'enu') {
      point = adjust_axis(source, false, point);
    }
    // Transform source points to long/lat, if they aren't already.
    if (source.projName === 'longlat') {
      point = {
        x: point.x * D2R$1,
        y: point.y * D2R$1,
        z: point.z || 0
      };
    } else {
      if (source.to_meter) {
        point = {
          x: point.x * source.to_meter,
          y: point.y * source.to_meter,
          z: point.z || 0
        };
      }
      point = source.inverse(point); // Convert Cartesian to longlat
      if (!point) {
        return;
      }
    }
    // Adjust for the prime meridian if necessary
    if (source.from_greenwich) {
      point.x += source.from_greenwich;
    }

    // Convert datums if needed, and if possible.
    point = datum_transform(source.datum, dest.datum, point);
    if (!point) {
      return;
    }

    // Adjust for the prime meridian if necessary
    if (dest.from_greenwich) {
      point = {
        x: point.x - dest.from_greenwich,
        y: point.y,
        z: point.z || 0
      };
    }

    if (dest.projName === 'longlat') {
      // convert radians to decimal degrees
      point = {
        x: point.x * R2D,
        y: point.y * R2D,
        z: point.z || 0
      };
    } else { // else project
      point = dest.forward(point);
      if (dest.to_meter) {
        point = {
          x: point.x / dest.to_meter,
          y: point.y / dest.to_meter,
          z: point.z || 0
        };
      }
    }

    // DGR, 2010/11/12
    if (enforceAxis && dest.axis !== 'enu') {
      return adjust_axis(dest, true, point);
    }

    if (point && !hasZ) {
      delete point.z;
    }
    return point;
  }

  var wgs84 = Projection('WGS84');

  function transformer(from, to, coords, enforceAxis) {
    var transformedArray, out, keys;
    if (Array.isArray(coords)) {
      transformedArray = transform(from, to, coords, enforceAxis) || {x: NaN, y: NaN};
      if (coords.length > 2) {
        if ((typeof from.name !== 'undefined' && from.name === 'geocent') || (typeof to.name !== 'undefined' && to.name === 'geocent')) {
          if (typeof transformedArray.z === 'number') {
            return [transformedArray.x, transformedArray.y, transformedArray.z].concat(coords.splice(3));
          } else {
            return [transformedArray.x, transformedArray.y, coords[2]].concat(coords.splice(3));
          }
        } else {
          return [transformedArray.x, transformedArray.y].concat(coords.splice(2));
        }
      } else {
        return [transformedArray.x, transformedArray.y];
      }
    } else {
      out = transform(from, to, coords, enforceAxis);
      keys = Object.keys(coords);
      if (keys.length === 2) {
        return out;
      }
      keys.forEach(function (key) {
        if ((typeof from.name !== 'undefined' && from.name === 'geocent') || (typeof to.name !== 'undefined' && to.name === 'geocent')) {
          if (key === 'x' || key === 'y' || key === 'z') {
            return;
          }
        } else {
          if (key === 'x' || key === 'y') {
            return;
          }
        }
        out[key] = coords[key];
      });
      return out;
    }
  }

  function checkProj(item) {
    if (item instanceof Projection) {
      return item;
    }
    if (item.oProj) {
      return item.oProj;
    }
    return Projection(item);
  }

  function proj4(fromProj, toProj, coord) {
    fromProj = checkProj(fromProj);
    var single = false;
    var obj;
    if (typeof toProj === 'undefined') {
      toProj = fromProj;
      fromProj = wgs84;
      single = true;
    } else if (typeof toProj.x !== 'undefined' || Array.isArray(toProj)) {
      coord = toProj;
      toProj = fromProj;
      fromProj = wgs84;
      single = true;
    }
    toProj = checkProj(toProj);
    if (coord) {
      return transformer(fromProj, toProj, coord);
    } else {
      obj = {
        forward: function (coords, enforceAxis) {
          return transformer(fromProj, toProj, coords, enforceAxis);
        },
        inverse: function (coords, enforceAxis) {
          return transformer(toProj, fromProj, coords, enforceAxis);
        }
      };
      if (single) {
        obj.oProj = toProj;
      }
      return obj;
    }
  }

  /**
   * UTM zones are grouped, and assigned to one of a group of 6
   * sets.
   *
   * {int} @private
   */
  var NUM_100K_SETS = 6;

  /**
   * The column letters (for easting) of the lower left value, per
   * set.
   *
   * {string} @private
   */
  var SET_ORIGIN_COLUMN_LETTERS = 'AJSAJS';

  /**
   * The row letters (for northing) of the lower left value, per
   * set.
   *
   * {string} @private
   */
  var SET_ORIGIN_ROW_LETTERS = 'AFAFAF';

  var A$1 = 65; // A
  var I = 73; // I
  var O = 79; // O
  var V = 86; // V
  var Z = 90; // Z
  var mgrs = {
    forward: forward$t,
    inverse: inverse$t,
    toPoint: toPoint
  };
  /**
   * Conversion of lat/lon to MGRS.
   *
   * @param {object} ll Object literal with lat and lon properties on a
   *     WGS84 ellipsoid.
   * @param {int} accuracy Accuracy in digits (5 for 1 m, 4 for 10 m, 3 for
   *      100 m, 2 for 1000 m or 1 for 10000 m). Optional, default is 5.
   * @return {string} the MGRS string for the given location and accuracy.
   */
  function forward$t(ll, accuracy) {
    accuracy = accuracy || 5; // default accuracy 1m
    return encode(LLtoUTM({
      lat: ll[1],
      lon: ll[0]
    }), accuracy);
  }
  /**
   * Conversion of MGRS to lat/lon.
   *
   * @param {string} mgrs MGRS string.
   * @return {array} An array with left (longitude), bottom (latitude), right
   *     (longitude) and top (latitude) values in WGS84, representing the
   *     bounding box for the provided MGRS reference.
   */
  function inverse$t(mgrs) {
    var bbox = UTMtoLL(decode(mgrs.toUpperCase()));
    if (bbox.lat && bbox.lon) {
      return [bbox.lon, bbox.lat, bbox.lon, bbox.lat];
    }
    return [bbox.left, bbox.bottom, bbox.right, bbox.top];
  }
  function toPoint(mgrs) {
    var bbox = UTMtoLL(decode(mgrs.toUpperCase()));
    if (bbox.lat && bbox.lon) {
      return [bbox.lon, bbox.lat];
    }
    return [(bbox.left + bbox.right) / 2, (bbox.top + bbox.bottom) / 2];
  }/**
   * Conversion from degrees to radians.
   *
   * @private
   * @param {number} deg the angle in degrees.
   * @return {number} the angle in radians.
   */
  function degToRad(deg) {
    return (deg * (Math.PI / 180.0));
  }

  /**
   * Conversion from radians to degrees.
   *
   * @private
   * @param {number} rad the angle in radians.
   * @return {number} the angle in degrees.
   */
  function radToDeg(rad) {
    return (180.0 * (rad / Math.PI));
  }

  /**
   * Converts a set of Longitude and Latitude co-ordinates to UTM
   * using the WGS84 ellipsoid.
   *
   * @private
   * @param {object} ll Object literal with lat and lon properties
   *     representing the WGS84 coordinate to be converted.
   * @return {object} Object literal containing the UTM value with easting,
   *     northing, zoneNumber and zoneLetter properties, and an optional
   *     accuracy property in digits. Returns null if the conversion failed.
   */
  function LLtoUTM(ll) {
    var Lat = ll.lat;
    var Long = ll.lon;
    var a = 6378137.0; //ellip.radius;
    var eccSquared = 0.00669438; //ellip.eccsq;
    var k0 = 0.9996;
    var LongOrigin;
    var eccPrimeSquared;
    var N, T, C, A, M;
    var LatRad = degToRad(Lat);
    var LongRad = degToRad(Long);
    var LongOriginRad;
    var ZoneNumber;
    // (int)
    ZoneNumber = Math.floor((Long + 180) / 6) + 1;

    //Make sure the longitude 180.00 is in Zone 60
    if (Long === 180) {
      ZoneNumber = 60;
    }

    // Special zone for Norway
    if (Lat >= 56.0 && Lat < 64.0 && Long >= 3.0 && Long < 12.0) {
      ZoneNumber = 32;
    }

    // Special zones for Svalbard
    if (Lat >= 72.0 && Lat < 84.0) {
      if (Long >= 0.0 && Long < 9.0) {
        ZoneNumber = 31;
      }
      else if (Long >= 9.0 && Long < 21.0) {
        ZoneNumber = 33;
      }
      else if (Long >= 21.0 && Long < 33.0) {
        ZoneNumber = 35;
      }
      else if (Long >= 33.0 && Long < 42.0) {
        ZoneNumber = 37;
      }
    }

    LongOrigin = (ZoneNumber - 1) * 6 - 180 + 3; //+3 puts origin
    // in middle of
    // zone
    LongOriginRad = degToRad(LongOrigin);

    eccPrimeSquared = (eccSquared) / (1 - eccSquared);

    N = a / Math.sqrt(1 - eccSquared * Math.sin(LatRad) * Math.sin(LatRad));
    T = Math.tan(LatRad) * Math.tan(LatRad);
    C = eccPrimeSquared * Math.cos(LatRad) * Math.cos(LatRad);
    A = Math.cos(LatRad) * (LongRad - LongOriginRad);

    M = a * ((1 - eccSquared / 4 - 3 * eccSquared * eccSquared / 64 - 5 * eccSquared * eccSquared * eccSquared / 256) * LatRad - (3 * eccSquared / 8 + 3 * eccSquared * eccSquared / 32 + 45 * eccSquared * eccSquared * eccSquared / 1024) * Math.sin(2 * LatRad) + (15 * eccSquared * eccSquared / 256 + 45 * eccSquared * eccSquared * eccSquared / 1024) * Math.sin(4 * LatRad) - (35 * eccSquared * eccSquared * eccSquared / 3072) * Math.sin(6 * LatRad));

    var UTMEasting = (k0 * N * (A + (1 - T + C) * A * A * A / 6.0 + (5 - 18 * T + T * T + 72 * C - 58 * eccPrimeSquared) * A * A * A * A * A / 120.0) + 500000.0);

    var UTMNorthing = (k0 * (M + N * Math.tan(LatRad) * (A * A / 2 + (5 - T + 9 * C + 4 * C * C) * A * A * A * A / 24.0 + (61 - 58 * T + T * T + 600 * C - 330 * eccPrimeSquared) * A * A * A * A * A * A / 720.0)));
    if (Lat < 0.0) {
      UTMNorthing += 10000000.0; //10000000 meter offset for
      // southern hemisphere
    }

    return {
      northing: Math.round(UTMNorthing),
      easting: Math.round(UTMEasting),
      zoneNumber: ZoneNumber,
      zoneLetter: getLetterDesignator(Lat)
    };
  }

  /**
   * Converts UTM coords to lat/long, using the WGS84 ellipsoid. This is a convenience
   * class where the Zone can be specified as a single string eg."60N" which
   * is then broken down into the ZoneNumber and ZoneLetter.
   *
   * @private
   * @param {object} utm An object literal with northing, easting, zoneNumber
   *     and zoneLetter properties. If an optional accuracy property is
   *     provided (in meters), a bounding box will be returned instead of
   *     latitude and longitude.
   * @return {object} An object literal containing either lat and lon values
   *     (if no accuracy was provided), or top, right, bottom and left values
   *     for the bounding box calculated according to the provided accuracy.
   *     Returns null if the conversion failed.
   */
  function UTMtoLL(utm) {

    var UTMNorthing = utm.northing;
    var UTMEasting = utm.easting;
    var zoneLetter = utm.zoneLetter;
    var zoneNumber = utm.zoneNumber;
    // check the ZoneNummber is valid
    if (zoneNumber < 0 || zoneNumber > 60) {
      return null;
    }

    var k0 = 0.9996;
    var a = 6378137.0; //ellip.radius;
    var eccSquared = 0.00669438; //ellip.eccsq;
    var eccPrimeSquared;
    var e1 = (1 - Math.sqrt(1 - eccSquared)) / (1 + Math.sqrt(1 - eccSquared));
    var N1, T1, C1, R1, D, M;
    var LongOrigin;
    var mu, phi1Rad;

    // remove 500,000 meter offset for longitude
    var x = UTMEasting - 500000.0;
    var y = UTMNorthing;

    // We must know somehow if we are in the Northern or Southern
    // hemisphere, this is the only time we use the letter So even
    // if the Zone letter isn't exactly correct it should indicate
    // the hemisphere correctly
    if (zoneLetter < 'N') {
      y -= 10000000.0; // remove 10,000,000 meter offset used
      // for southern hemisphere
    }

    // There are 60 zones with zone 1 being at West -180 to -174
    LongOrigin = (zoneNumber - 1) * 6 - 180 + 3; // +3 puts origin
    // in middle of
    // zone

    eccPrimeSquared = (eccSquared) / (1 - eccSquared);

    M = y / k0;
    mu = M / (a * (1 - eccSquared / 4 - 3 * eccSquared * eccSquared / 64 - 5 * eccSquared * eccSquared * eccSquared / 256));

    phi1Rad = mu + (3 * e1 / 2 - 27 * e1 * e1 * e1 / 32) * Math.sin(2 * mu) + (21 * e1 * e1 / 16 - 55 * e1 * e1 * e1 * e1 / 32) * Math.sin(4 * mu) + (151 * e1 * e1 * e1 / 96) * Math.sin(6 * mu);
    // double phi1 = ProjMath.radToDeg(phi1Rad);

    N1 = a / Math.sqrt(1 - eccSquared * Math.sin(phi1Rad) * Math.sin(phi1Rad));
    T1 = Math.tan(phi1Rad) * Math.tan(phi1Rad);
    C1 = eccPrimeSquared * Math.cos(phi1Rad) * Math.cos(phi1Rad);
    R1 = a * (1 - eccSquared) / Math.pow(1 - eccSquared * Math.sin(phi1Rad) * Math.sin(phi1Rad), 1.5);
    D = x / (N1 * k0);

    var lat = phi1Rad - (N1 * Math.tan(phi1Rad) / R1) * (D * D / 2 - (5 + 3 * T1 + 10 * C1 - 4 * C1 * C1 - 9 * eccPrimeSquared) * D * D * D * D / 24 + (61 + 90 * T1 + 298 * C1 + 45 * T1 * T1 - 252 * eccPrimeSquared - 3 * C1 * C1) * D * D * D * D * D * D / 720);
    lat = radToDeg(lat);

    var lon = (D - (1 + 2 * T1 + C1) * D * D * D / 6 + (5 - 2 * C1 + 28 * T1 - 3 * C1 * C1 + 8 * eccPrimeSquared + 24 * T1 * T1) * D * D * D * D * D / 120) / Math.cos(phi1Rad);
    lon = LongOrigin + radToDeg(lon);

    var result;
    if (utm.accuracy) {
      var topRight = UTMtoLL({
        northing: utm.northing + utm.accuracy,
        easting: utm.easting + utm.accuracy,
        zoneLetter: utm.zoneLetter,
        zoneNumber: utm.zoneNumber
      });
      result = {
        top: topRight.lat,
        right: topRight.lon,
        bottom: lat,
        left: lon
      };
    }
    else {
      result = {
        lat: lat,
        lon: lon
      };
    }
    return result;
  }

  /**
   * Calculates the MGRS letter designator for the given latitude.
   *
   * @private
   * @param {number} lat The latitude in WGS84 to get the letter designator
   *     for.
   * @return {char} The letter designator.
   */
  function getLetterDesignator(lat) {
    //This is here as an error flag to show that the Latitude is
    //outside MGRS limits
    var LetterDesignator = 'Z';

    if ((84 >= lat) && (lat >= 72)) {
      LetterDesignator = 'X';
    }
    else if ((72 > lat) && (lat >= 64)) {
      LetterDesignator = 'W';
    }
    else if ((64 > lat) && (lat >= 56)) {
      LetterDesignator = 'V';
    }
    else if ((56 > lat) && (lat >= 48)) {
      LetterDesignator = 'U';
    }
    else if ((48 > lat) && (lat >= 40)) {
      LetterDesignator = 'T';
    }
    else if ((40 > lat) && (lat >= 32)) {
      LetterDesignator = 'S';
    }
    else if ((32 > lat) && (lat >= 24)) {
      LetterDesignator = 'R';
    }
    else if ((24 > lat) && (lat >= 16)) {
      LetterDesignator = 'Q';
    }
    else if ((16 > lat) && (lat >= 8)) {
      LetterDesignator = 'P';
    }
    else if ((8 > lat) && (lat >= 0)) {
      LetterDesignator = 'N';
    }
    else if ((0 > lat) && (lat >= -8)) {
      LetterDesignator = 'M';
    }
    else if ((-8 > lat) && (lat >= -16)) {
      LetterDesignator = 'L';
    }
    else if ((-16 > lat) && (lat >= -24)) {
      LetterDesignator = 'K';
    }
    else if ((-24 > lat) && (lat >= -32)) {
      LetterDesignator = 'J';
    }
    else if ((-32 > lat) && (lat >= -40)) {
      LetterDesignator = 'H';
    }
    else if ((-40 > lat) && (lat >= -48)) {
      LetterDesignator = 'G';
    }
    else if ((-48 > lat) && (lat >= -56)) {
      LetterDesignator = 'F';
    }
    else if ((-56 > lat) && (lat >= -64)) {
      LetterDesignator = 'E';
    }
    else if ((-64 > lat) && (lat >= -72)) {
      LetterDesignator = 'D';
    }
    else if ((-72 > lat) && (lat >= -80)) {
      LetterDesignator = 'C';
    }
    return LetterDesignator;
  }

  /**
   * Encodes a UTM location as MGRS string.
   *
   * @private
   * @param {object} utm An object literal with easting, northing,
   *     zoneLetter, zoneNumber
   * @param {number} accuracy Accuracy in digits (1-5).
   * @return {string} MGRS string for the given UTM location.
   */
  function encode(utm, accuracy) {
    // prepend with leading zeroes
    var seasting = "00000" + utm.easting,
      snorthing = "00000" + utm.northing;

    return utm.zoneNumber + utm.zoneLetter + get100kID(utm.easting, utm.northing, utm.zoneNumber) + seasting.substr(seasting.length - 5, accuracy) + snorthing.substr(snorthing.length - 5, accuracy);
  }

  /**
   * Get the two letter 100k designator for a given UTM easting,
   * northing and zone number value.
   *
   * @private
   * @param {number} easting
   * @param {number} northing
   * @param {number} zoneNumber
   * @return the two letter 100k designator for the given UTM location.
   */
  function get100kID(easting, northing, zoneNumber) {
    var setParm = get100kSetForZone(zoneNumber);
    var setColumn = Math.floor(easting / 100000);
    var setRow = Math.floor(northing / 100000) % 20;
    return getLetter100kID(setColumn, setRow, setParm);
  }

  /**
   * Given a UTM zone number, figure out the MGRS 100K set it is in.
   *
   * @private
   * @param {number} i An UTM zone number.
   * @return {number} the 100k set the UTM zone is in.
   */
  function get100kSetForZone(i) {
    var setParm = i % NUM_100K_SETS;
    if (setParm === 0) {
      setParm = NUM_100K_SETS;
    }

    return setParm;
  }

  /**
   * Get the two-letter MGRS 100k designator given information
   * translated from the UTM northing, easting and zone number.
   *
   * @private
   * @param {number} column the column index as it relates to the MGRS
   *        100k set spreadsheet, created from the UTM easting.
   *        Values are 1-8.
   * @param {number} row the row index as it relates to the MGRS 100k set
   *        spreadsheet, created from the UTM northing value. Values
   *        are from 0-19.
   * @param {number} parm the set block, as it relates to the MGRS 100k set
   *        spreadsheet, created from the UTM zone. Values are from
   *        1-60.
   * @return two letter MGRS 100k code.
   */
  function getLetter100kID(column, row, parm) {
    // colOrigin and rowOrigin are the letters at the origin of the set
    var index = parm - 1;
    var colOrigin = SET_ORIGIN_COLUMN_LETTERS.charCodeAt(index);
    var rowOrigin = SET_ORIGIN_ROW_LETTERS.charCodeAt(index);

    // colInt and rowInt are the letters to build to return
    var colInt = colOrigin + column - 1;
    var rowInt = rowOrigin + row;
    var rollover = false;

    if (colInt > Z) {
      colInt = colInt - Z + A$1 - 1;
      rollover = true;
    }

    if (colInt === I || (colOrigin < I && colInt > I) || ((colInt > I || colOrigin < I) && rollover)) {
      colInt++;
    }

    if (colInt === O || (colOrigin < O && colInt > O) || ((colInt > O || colOrigin < O) && rollover)) {
      colInt++;

      if (colInt === I) {
        colInt++;
      }
    }

    if (colInt > Z) {
      colInt = colInt - Z + A$1 - 1;
    }

    if (rowInt > V) {
      rowInt = rowInt - V + A$1 - 1;
      rollover = true;
    }
    else {
      rollover = false;
    }

    if (((rowInt === I) || ((rowOrigin < I) && (rowInt > I))) || (((rowInt > I) || (rowOrigin < I)) && rollover)) {
      rowInt++;
    }

    if (((rowInt === O) || ((rowOrigin < O) && (rowInt > O))) || (((rowInt > O) || (rowOrigin < O)) && rollover)) {
      rowInt++;

      if (rowInt === I) {
        rowInt++;
      }
    }

    if (rowInt > V) {
      rowInt = rowInt - V + A$1 - 1;
    }

    var twoLetter = String.fromCharCode(colInt) + String.fromCharCode(rowInt);
    return twoLetter;
  }

  /**
   * Decode the UTM parameters from a MGRS string.
   *
   * @private
   * @param {string} mgrsString an UPPERCASE coordinate string is expected.
   * @return {object} An object literal with easting, northing, zoneLetter,
   *     zoneNumber and accuracy (in meters) properties.
   */
  function decode(mgrsString) {

    if (mgrsString && mgrsString.length === 0) {
      throw ("MGRSPoint coverting from nothing");
    }

    var length = mgrsString.length;

    var hunK = null;
    var sb = "";
    var testChar;
    var i = 0;

    // get Zone number
    while (!(/[A-Z]/).test(testChar = mgrsString.charAt(i))) {
      if (i >= 2) {
        throw ("MGRSPoint bad conversion from: " + mgrsString);
      }
      sb += testChar;
      i++;
    }

    var zoneNumber = parseInt(sb, 10);

    if (i === 0 || i + 3 > length) {
      // A good MGRS string has to be 4-5 digits long,
      // ##AAA/#AAA at least.
      throw ("MGRSPoint bad conversion from: " + mgrsString);
    }

    var zoneLetter = mgrsString.charAt(i++);

    // Should we check the zone letter here? Why not.
    if (zoneLetter <= 'A' || zoneLetter === 'B' || zoneLetter === 'Y' || zoneLetter >= 'Z' || zoneLetter === 'I' || zoneLetter === 'O') {
      throw ("MGRSPoint zone letter " + zoneLetter + " not handled: " + mgrsString);
    }

    hunK = mgrsString.substring(i, i += 2);

    var set = get100kSetForZone(zoneNumber);

    var east100k = getEastingFromChar(hunK.charAt(0), set);
    var north100k = getNorthingFromChar(hunK.charAt(1), set);

    // We have a bug where the northing may be 2000000 too low.
    // How
    // do we know when to roll over?

    while (north100k < getMinNorthing(zoneLetter)) {
      north100k += 2000000;
    }

    // calculate the char index for easting/northing separator
    var remainder = length - i;

    if (remainder % 2 !== 0) {
      throw ("MGRSPoint has to have an even number \nof digits after the zone letter and two 100km letters - front \nhalf for easting meters, second half for \nnorthing meters" + mgrsString);
    }

    var sep = remainder / 2;

    var sepEasting = 0.0;
    var sepNorthing = 0.0;
    var accuracyBonus, sepEastingString, sepNorthingString, easting, northing;
    if (sep > 0) {
      accuracyBonus = 100000.0 / Math.pow(10, sep);
      sepEastingString = mgrsString.substring(i, i + sep);
      sepEasting = parseFloat(sepEastingString) * accuracyBonus;
      sepNorthingString = mgrsString.substring(i + sep);
      sepNorthing = parseFloat(sepNorthingString) * accuracyBonus;
    }

    easting = sepEasting + east100k;
    northing = sepNorthing + north100k;

    return {
      easting: easting,
      northing: northing,
      zoneLetter: zoneLetter,
      zoneNumber: zoneNumber,
      accuracy: accuracyBonus
    };
  }

  /**
   * Given the first letter from a two-letter MGRS 100k zone, and given the
   * MGRS table set for the zone number, figure out the easting value that
   * should be added to the other, secondary easting value.
   *
   * @private
   * @param {char} e The first letter from a two-letter MGRS 100´k zone.
   * @param {number} set The MGRS table set for the zone number.
   * @return {number} The easting value for the given letter and set.
   */
  function getEastingFromChar(e, set) {
    // colOrigin is the letter at the origin of the set for the
    // column
    var curCol = SET_ORIGIN_COLUMN_LETTERS.charCodeAt(set - 1);
    var eastingValue = 100000.0;
    var rewindMarker = false;

    while (curCol !== e.charCodeAt(0)) {
      curCol++;
      if (curCol === I) {
        curCol++;
      }
      if (curCol === O) {
        curCol++;
      }
      if (curCol > Z) {
        if (rewindMarker) {
          throw ("Bad character: " + e);
        }
        curCol = A$1;
        rewindMarker = true;
      }
      eastingValue += 100000.0;
    }

    return eastingValue;
  }

  /**
   * Given the second letter from a two-letter MGRS 100k zone, and given the
   * MGRS table set for the zone number, figure out the northing value that
   * should be added to the other, secondary northing value. You have to
   * remember that Northings are determined from the equator, and the vertical
   * cycle of letters mean a 2000000 additional northing meters. This happens
   * approx. every 18 degrees of latitude. This method does *NOT* count any
   * additional northings. You have to figure out how many 2000000 meters need
   * to be added for the zone letter of the MGRS coordinate.
   *
   * @private
   * @param {char} n Second letter of the MGRS 100k zone
   * @param {number} set The MGRS table set number, which is dependent on the
   *     UTM zone number.
   * @return {number} The northing value for the given letter and set.
   */
  function getNorthingFromChar(n, set) {

    if (n > 'V') {
      throw ("MGRSPoint given invalid Northing " + n);
    }

    // rowOrigin is the letter at the origin of the set for the
    // column
    var curRow = SET_ORIGIN_ROW_LETTERS.charCodeAt(set - 1);
    var northingValue = 0.0;
    var rewindMarker = false;

    while (curRow !== n.charCodeAt(0)) {
      curRow++;
      if (curRow === I) {
        curRow++;
      }
      if (curRow === O) {
        curRow++;
      }
      // fixing a bug making whole application hang in this loop
      // when 'n' is a wrong character
      if (curRow > V) {
        if (rewindMarker) { // making sure that this loop ends
          throw ("Bad character: " + n);
        }
        curRow = A$1;
        rewindMarker = true;
      }
      northingValue += 100000.0;
    }

    return northingValue;
  }

  /**
   * The function getMinNorthing returns the minimum northing value of a MGRS
   * zone.
   *
   * Ported from Geotrans' c Lattitude_Band_Value structure table.
   *
   * @private
   * @param {char} zoneLetter The MGRS zone to get the min northing for.
   * @return {number}
   */
  function getMinNorthing(zoneLetter) {
    var northing;
    switch (zoneLetter) {
    case 'C':
      northing = 1100000.0;
      break;
    case 'D':
      northing = 2000000.0;
      break;
    case 'E':
      northing = 2800000.0;
      break;
    case 'F':
      northing = 3700000.0;
      break;
    case 'G':
      northing = 4600000.0;
      break;
    case 'H':
      northing = 5500000.0;
      break;
    case 'J':
      northing = 6400000.0;
      break;
    case 'K':
      northing = 7300000.0;
      break;
    case 'L':
      northing = 8200000.0;
      break;
    case 'M':
      northing = 9100000.0;
      break;
    case 'N':
      northing = 0.0;
      break;
    case 'P':
      northing = 800000.0;
      break;
    case 'Q':
      northing = 1700000.0;
      break;
    case 'R':
      northing = 2600000.0;
      break;
    case 'S':
      northing = 3500000.0;
      break;
    case 'T':
      northing = 4400000.0;
      break;
    case 'U':
      northing = 5300000.0;
      break;
    case 'V':
      northing = 6200000.0;
      break;
    case 'W':
      northing = 7000000.0;
      break;
    case 'X':
      northing = 7900000.0;
      break;
    default:
      northing = -1.0;
    }
    if (northing >= 0.0) {
      return northing;
    }
    else {
      throw ("Invalid zone letter: " + zoneLetter);
    }

  }

  function Point(x, y, z) {
    if (!(this instanceof Point)) {
      return new Point(x, y, z);
    }
    if (Array.isArray(x)) {
      this.x = x[0];
      this.y = x[1];
      this.z = x[2] || 0.0;
    } else if(typeof x === 'object') {
      this.x = x.x;
      this.y = x.y;
      this.z = x.z || 0.0;
    } else if (typeof x === 'string' && typeof y === 'undefined') {
      var coords = x.split(',');
      this.x = parseFloat(coords[0], 10);
      this.y = parseFloat(coords[1], 10);
      this.z = parseFloat(coords[2], 10) || 0.0;
    } else {
      this.x = x;
      this.y = y;
      this.z = z || 0.0;
    }
    console.warn('proj4.Point will be removed in version 3, use proj4.toPoint');
  }

  Point.fromMGRS = function(mgrsStr) {
    return new Point(toPoint(mgrsStr));
  };
  Point.prototype.toMGRS = function(accuracy) {
    return forward$t([this.x, this.y], accuracy);
  };

  var C00 = 1;
  var C02 = 0.25;
  var C04 = 0.046875;
  var C06 = 0.01953125;
  var C08 = 0.01068115234375;
  var C22 = 0.75;
  var C44 = 0.46875;
  var C46 = 0.01302083333333333333;
  var C48 = 0.00712076822916666666;
  var C66 = 0.36458333333333333333;
  var C68 = 0.00569661458333333333;
  var C88 = 0.3076171875;

  function pj_enfn(es) {
    var en = [];
    en[0] = C00 - es * (C02 + es * (C04 + es * (C06 + es * C08)));
    en[1] = es * (C22 - es * (C04 + es * (C06 + es * C08)));
    var t = es * es;
    en[2] = t * (C44 - es * (C46 + es * C48));
    t *= es;
    en[3] = t * (C66 - es * C68);
    en[4] = t * es * C88;
    return en;
  }

  function pj_mlfn(phi, sphi, cphi, en) {
    cphi *= sphi;
    sphi *= sphi;
    return (en[0] * phi - cphi * (en[1] + sphi * (en[2] + sphi * (en[3] + sphi * en[4]))));
  }

  var MAX_ITER$3 = 20;

  function pj_inv_mlfn(arg, es, en) {
    var k = 1 / (1 - es);
    var phi = arg;
    for (var i = MAX_ITER$3; i; --i) { /* rarely goes over 2 iterations */
      var s = Math.sin(phi);
      var t = 1 - es * s * s;
      //t = this.pj_mlfn(phi, s, Math.cos(phi), en) - arg;
      //phi -= t * (t * Math.sqrt(t)) * k;
      t = (pj_mlfn(phi, s, Math.cos(phi), en) - arg) * (t * Math.sqrt(t)) * k;
      phi -= t;
      if (Math.abs(t) < EPSLN) {
        return phi;
      }
    }
    //..reportError("cass:pj_inv_mlfn: Convergence error");
    return phi;
  }

  // Heavily based on this tmerc projection implementation
  // https://github.com/mbloch/mapshaper-proj/blob/master/src/projections/tmerc.js


  function init$t() {
    this.x0 = this.x0 !== undefined ? this.x0 : 0;
    this.y0 = this.y0 !== undefined ? this.y0 : 0;
    this.long0 = this.long0 !== undefined ? this.long0 : 0;
    this.lat0 = this.lat0 !== undefined ? this.lat0 : 0;

    if (this.es) {
      this.en = pj_enfn(this.es);
      this.ml0 = pj_mlfn(this.lat0, Math.sin(this.lat0), Math.cos(this.lat0), this.en);
    }
  }

  /**
      Transverse Mercator Forward  - long/lat to x/y
      long/lat in radians
    */
  function forward$s(p) {
    var lon = p.x;
    var lat = p.y;

    var delta_lon = adjust_lon(lon - this.long0);
    var con;
    var x, y;
    var sin_phi = Math.sin(lat);
    var cos_phi = Math.cos(lat);

    if (!this.es) {
      var b = cos_phi * Math.sin(delta_lon);

      if ((Math.abs(Math.abs(b) - 1)) < EPSLN) {
        return (93);
      }
      else {
        x = 0.5 * this.a * this.k0 * Math.log((1 + b) / (1 - b)) + this.x0;
        y = cos_phi * Math.cos(delta_lon) / Math.sqrt(1 - Math.pow(b, 2));
        b = Math.abs(y);

        if (b >= 1) {
          if ((b - 1) > EPSLN) {
            return (93);
          }
          else {
            y = 0;
          }
        }
        else {
          y = Math.acos(y);
        }

        if (lat < 0) {
          y = -y;
        }

        y = this.a * this.k0 * (y - this.lat0) + this.y0;
      }
    }
    else {
      var al = cos_phi * delta_lon;
      var als = Math.pow(al, 2);
      var c = this.ep2 * Math.pow(cos_phi, 2);
      var cs = Math.pow(c, 2);
      var tq = Math.abs(cos_phi) > EPSLN ? Math.tan(lat) : 0;
      var t = Math.pow(tq, 2);
      var ts = Math.pow(t, 2);
      con = 1 - this.es * Math.pow(sin_phi, 2);
      al = al / Math.sqrt(con);
      var ml = pj_mlfn(lat, sin_phi, cos_phi, this.en);

      x = this.a * (this.k0 * al * (1 +
        als / 6 * (1 - t + c +
        als / 20 * (5 - 18 * t + ts + 14 * c - 58 * t * c +
        als / 42 * (61 + 179 * ts - ts * t - 479 * t))))) +
        this.x0;

      y = this.a * (this.k0 * (ml - this.ml0 +
        sin_phi * delta_lon * al / 2 * (1 +
        als / 12 * (5 - t + 9 * c + 4 * cs +
        als / 30 * (61 + ts - 58 * t + 270 * c - 330 * t * c +
        als / 56 * (1385 + 543 * ts - ts * t - 3111 * t)))))) +
        this.y0;
    }

    p.x = x;
    p.y = y;

    return p;
  }

  /**
      Transverse Mercator Inverse  -  x/y to long/lat
    */
  function inverse$s(p) {
    var con, phi;
    var lat, lon;
    var x = (p.x - this.x0) * (1 / this.a);
    var y = (p.y - this.y0) * (1 / this.a);

    if (!this.es) {
      var f = Math.exp(x / this.k0);
      var g = 0.5 * (f - 1 / f);
      var temp = this.lat0 + y / this.k0;
      var h = Math.cos(temp);
      con = Math.sqrt((1 - Math.pow(h, 2)) / (1 + Math.pow(g, 2)));
      lat = Math.asin(con);

      if (y < 0) {
        lat = -lat;
      }

      if ((g === 0) && (h === 0)) {
        lon = 0;
      }
      else {
        lon = adjust_lon(Math.atan2(g, h) + this.long0);
      }
    }
    else { // ellipsoidal form
      con = this.ml0 + y / this.k0;
      phi = pj_inv_mlfn(con, this.es, this.en);

      if (Math.abs(phi) < HALF_PI) {
        var sin_phi = Math.sin(phi);
        var cos_phi = Math.cos(phi);
        var tan_phi = Math.abs(cos_phi) > EPSLN ? Math.tan(phi) : 0;
        var c = this.ep2 * Math.pow(cos_phi, 2);
        var cs = Math.pow(c, 2);
        var t = Math.pow(tan_phi, 2);
        var ts = Math.pow(t, 2);
        con = 1 - this.es * Math.pow(sin_phi, 2);
        var d = x * Math.sqrt(con) / this.k0;
        var ds = Math.pow(d, 2);
        con = con * tan_phi;

        lat = phi - (con * ds / (1 - this.es)) * 0.5 * (1 -
          ds / 12 * (5 + 3 * t - 9 * c * t + c - 4 * cs -
          ds / 30 * (61 + 90 * t - 252 * c * t + 45 * ts + 46 * c -
          ds / 56 * (1385 + 3633 * t + 4095 * ts + 1574 * ts * t))));

        lon = adjust_lon(this.long0 + (d * (1 -
          ds / 6 * (1 + 2 * t + c -
          ds / 20 * (5 + 28 * t + 24 * ts + 8 * c * t + 6 * c -
          ds / 42 * (61 + 662 * t + 1320 * ts + 720 * ts * t)))) / cos_phi));
      }
      else {
        lat = HALF_PI * sign(y);
        lon = 0;
      }
    }

    p.x = lon;
    p.y = lat;

    return p;
  }

  var names$t = ["Fast_Transverse_Mercator", "Fast Transverse Mercator"];
  var tmerc = {
    init: init$t,
    forward: forward$s,
    inverse: inverse$s,
    names: names$t
  };

  function sinh(x) {
    var r = Math.exp(x);
    r = (r - 1 / r) / 2;
    return r;
  }

  function hypot(x, y) {
    x = Math.abs(x);
    y = Math.abs(y);
    var a = Math.max(x, y);
    var b = Math.min(x, y) / (a ? a : 1);

    return a * Math.sqrt(1 + Math.pow(b, 2));
  }

  function log1py(x) {
    var y = 1 + x;
    var z = y - 1;

    return z === 0 ? x : x * Math.log(y) / z;
  }

  function asinhy(x) {
    var y = Math.abs(x);
    y = log1py(y * (1 + y / (hypot(1, y) + 1)));

    return x < 0 ? -y : y;
  }

  function gatg(pp, B) {
    var cos_2B = 2 * Math.cos(2 * B);
    var i = pp.length - 1;
    var h1 = pp[i];
    var h2 = 0;
    var h;

    while (--i >= 0) {
      h = -h2 + cos_2B * h1 + pp[i];
      h2 = h1;
      h1 = h;
    }

    return (B + h * Math.sin(2 * B));
  }

  function clens(pp, arg_r) {
    var r = 2 * Math.cos(arg_r);
    var i = pp.length - 1;
    var hr1 = pp[i];
    var hr2 = 0;
    var hr;

    while (--i >= 0) {
      hr = -hr2 + r * hr1 + pp[i];
      hr2 = hr1;
      hr1 = hr;
    }

    return Math.sin(arg_r) * hr;
  }

  function cosh(x) {
    var r = Math.exp(x);
    r = (r + 1 / r) / 2;
    return r;
  }

  function clens_cmplx(pp, arg_r, arg_i) {
    var sin_arg_r = Math.sin(arg_r);
    var cos_arg_r = Math.cos(arg_r);
    var sinh_arg_i = sinh(arg_i);
    var cosh_arg_i = cosh(arg_i);
    var r = 2 * cos_arg_r * cosh_arg_i;
    var i = -2 * sin_arg_r * sinh_arg_i;
    var j = pp.length - 1;
    var hr = pp[j];
    var hi1 = 0;
    var hr1 = 0;
    var hi = 0;
    var hr2;
    var hi2;

    while (--j >= 0) {
      hr2 = hr1;
      hi2 = hi1;
      hr1 = hr;
      hi1 = hi;
      hr = -hr2 + r * hr1 - i * hi1 + pp[j];
      hi = -hi2 + i * hr1 + r * hi1;
    }

    r = sin_arg_r * cosh_arg_i;
    i = cos_arg_r * sinh_arg_i;

    return [r * hr - i * hi, r * hi + i * hr];
  }

  // Heavily based on this etmerc projection implementation
  // https://github.com/mbloch/mapshaper-proj/blob/master/src/projections/etmerc.js


  function init$s() {
    if (!this.approx && (isNaN(this.es) || this.es <= 0)) {
      throw new Error('Incorrect elliptical usage. Try using the +approx option in the proj string, or PROJECTION["Fast_Transverse_Mercator"] in the WKT.');
    }
    if (this.approx) {
      // When '+approx' is set, use tmerc instead
      tmerc.init.apply(this);
      this.forward = tmerc.forward;
      this.inverse = tmerc.inverse;
    }

    this.x0 = this.x0 !== undefined ? this.x0 : 0;
    this.y0 = this.y0 !== undefined ? this.y0 : 0;
    this.long0 = this.long0 !== undefined ? this.long0 : 0;
    this.lat0 = this.lat0 !== undefined ? this.lat0 : 0;

    this.cgb = [];
    this.cbg = [];
    this.utg = [];
    this.gtu = [];

    var f = this.es / (1 + Math.sqrt(1 - this.es));
    var n = f / (2 - f);
    var np = n;

    this.cgb[0] = n * (2 + n * (-2 / 3 + n * (-2 + n * (116 / 45 + n * (26 / 45 + n * (-2854 / 675 ))))));
    this.cbg[0] = n * (-2 + n * ( 2 / 3 + n * ( 4 / 3 + n * (-82 / 45 + n * (32 / 45 + n * (4642 / 4725))))));

    np = np * n;
    this.cgb[1] = np * (7 / 3 + n * (-8 / 5 + n * (-227 / 45 + n * (2704 / 315 + n * (2323 / 945)))));
    this.cbg[1] = np * (5 / 3 + n * (-16 / 15 + n * ( -13 / 9 + n * (904 / 315 + n * (-1522 / 945)))));

    np = np * n;
    this.cgb[2] = np * (56 / 15 + n * (-136 / 35 + n * (-1262 / 105 + n * (73814 / 2835))));
    this.cbg[2] = np * (-26 / 15 + n * (34 / 21 + n * (8 / 5 + n * (-12686 / 2835))));

    np = np * n;
    this.cgb[3] = np * (4279 / 630 + n * (-332 / 35 + n * (-399572 / 14175)));
    this.cbg[3] = np * (1237 / 630 + n * (-12 / 5 + n * ( -24832 / 14175)));

    np = np * n;
    this.cgb[4] = np * (4174 / 315 + n * (-144838 / 6237));
    this.cbg[4] = np * (-734 / 315 + n * (109598 / 31185));

    np = np * n;
    this.cgb[5] = np * (601676 / 22275);
    this.cbg[5] = np * (444337 / 155925);

    np = Math.pow(n, 2);
    this.Qn = this.k0 / (1 + n) * (1 + np * (1 / 4 + np * (1 / 64 + np / 256)));

    this.utg[0] = n * (-0.5 + n * ( 2 / 3 + n * (-37 / 96 + n * ( 1 / 360 + n * (81 / 512 + n * (-96199 / 604800))))));
    this.gtu[0] = n * (0.5 + n * (-2 / 3 + n * (5 / 16 + n * (41 / 180 + n * (-127 / 288 + n * (7891 / 37800))))));

    this.utg[1] = np * (-1 / 48 + n * (-1 / 15 + n * (437 / 1440 + n * (-46 / 105 + n * (1118711 / 3870720)))));
    this.gtu[1] = np * (13 / 48 + n * (-3 / 5 + n * (557 / 1440 + n * (281 / 630 + n * (-1983433 / 1935360)))));

    np = np * n;
    this.utg[2] = np * (-17 / 480 + n * (37 / 840 + n * (209 / 4480 + n * (-5569 / 90720 ))));
    this.gtu[2] = np * (61 / 240 + n * (-103 / 140 + n * (15061 / 26880 + n * (167603 / 181440))));

    np = np * n;
    this.utg[3] = np * (-4397 / 161280 + n * (11 / 504 + n * (830251 / 7257600)));
    this.gtu[3] = np * (49561 / 161280 + n * (-179 / 168 + n * (6601661 / 7257600)));

    np = np * n;
    this.utg[4] = np * (-4583 / 161280 + n * (108847 / 3991680));
    this.gtu[4] = np * (34729 / 80640 + n * (-3418889 / 1995840));

    np = np * n;
    this.utg[5] = np * (-20648693 / 638668800);
    this.gtu[5] = np * (212378941 / 319334400);

    var Z = gatg(this.cbg, this.lat0);
    this.Zb = -this.Qn * (Z + clens(this.gtu, 2 * Z));
  }

  function forward$r(p) {
    var Ce = adjust_lon(p.x - this.long0);
    var Cn = p.y;

    Cn = gatg(this.cbg, Cn);
    var sin_Cn = Math.sin(Cn);
    var cos_Cn = Math.cos(Cn);
    var sin_Ce = Math.sin(Ce);
    var cos_Ce = Math.cos(Ce);

    Cn = Math.atan2(sin_Cn, cos_Ce * cos_Cn);
    Ce = Math.atan2(sin_Ce * cos_Cn, hypot(sin_Cn, cos_Cn * cos_Ce));
    Ce = asinhy(Math.tan(Ce));

    var tmp = clens_cmplx(this.gtu, 2 * Cn, 2 * Ce);

    Cn = Cn + tmp[0];
    Ce = Ce + tmp[1];

    var x;
    var y;

    if (Math.abs(Ce) <= 2.623395162778) {
      x = this.a * (this.Qn * Ce) + this.x0;
      y = this.a * (this.Qn * Cn + this.Zb) + this.y0;
    }
    else {
      x = Infinity;
      y = Infinity;
    }

    p.x = x;
    p.y = y;

    return p;
  }

  function inverse$r(p) {
    var Ce = (p.x - this.x0) * (1 / this.a);
    var Cn = (p.y - this.y0) * (1 / this.a);

    Cn = (Cn - this.Zb) / this.Qn;
    Ce = Ce / this.Qn;

    var lon;
    var lat;

    if (Math.abs(Ce) <= 2.623395162778) {
      var tmp = clens_cmplx(this.utg, 2 * Cn, 2 * Ce);

      Cn = Cn + tmp[0];
      Ce = Ce + tmp[1];
      Ce = Math.atan(sinh(Ce));

      var sin_Cn = Math.sin(Cn);
      var cos_Cn = Math.cos(Cn);
      var sin_Ce = Math.sin(Ce);
      var cos_Ce = Math.cos(Ce);

      Cn = Math.atan2(sin_Cn * cos_Ce, hypot(sin_Ce, cos_Ce * cos_Cn));
      Ce = Math.atan2(sin_Ce, cos_Ce * cos_Cn);

      lon = adjust_lon(Ce + this.long0);
      lat = gatg(this.cgb, Cn);
    }
    else {
      lon = Infinity;
      lat = Infinity;
    }

    p.x = lon;
    p.y = lat;

    return p;
  }

  var names$s = ["Extended_Transverse_Mercator", "Extended Transverse Mercator", "etmerc", "Transverse_Mercator", "Transverse Mercator", "Gauss Kruger", "Gauss_Kruger", "tmerc"];
  var etmerc = {
    init: init$s,
    forward: forward$r,
    inverse: inverse$r,
    names: names$s
  };

  function adjust_zone(zone, lon) {
    if (zone === undefined) {
      zone = Math.floor((adjust_lon(lon) + Math.PI) * 30 / Math.PI) + 1;

      if (zone < 0) {
        return 0;
      } else if (zone > 60) {
        return 60;
      }
    }
    return zone;
  }

  var dependsOn = 'etmerc';


  function init$r() {
    var zone = adjust_zone(this.zone, this.long0);
    if (zone === undefined) {
      throw new Error('unknown utm zone');
    }
    this.lat0 = 0;
    this.long0 =  ((6 * Math.abs(zone)) - 183) * D2R$1;
    this.x0 = 500000;
    this.y0 = this.utmSouth ? 10000000 : 0;
    this.k0 = 0.9996;

    etmerc.init.apply(this);
    this.forward = etmerc.forward;
    this.inverse = etmerc.inverse;
  }

  var names$r = ["Universal Transverse Mercator System", "utm"];
  var utm = {
    init: init$r,
    names: names$r,
    dependsOn: dependsOn
  };

  function srat(esinp, exp) {
    return (Math.pow((1 - esinp) / (1 + esinp), exp));
  }

  var MAX_ITER$2 = 20;

  function init$q() {
    var sphi = Math.sin(this.lat0);
    var cphi = Math.cos(this.lat0);
    cphi *= cphi;
    this.rc = Math.sqrt(1 - this.es) / (1 - this.es * sphi * sphi);
    this.C = Math.sqrt(1 + this.es * cphi * cphi / (1 - this.es));
    this.phic0 = Math.asin(sphi / this.C);
    this.ratexp = 0.5 * this.C * this.e;
    this.K = Math.tan(0.5 * this.phic0 + FORTPI) / (Math.pow(Math.tan(0.5 * this.lat0 + FORTPI), this.C) * srat(this.e * sphi, this.ratexp));
  }

  function forward$q(p) {
    var lon = p.x;
    var lat = p.y;

    p.y = 2 * Math.atan(this.K * Math.pow(Math.tan(0.5 * lat + FORTPI), this.C) * srat(this.e * Math.sin(lat), this.ratexp)) - HALF_PI;
    p.x = this.C * lon;
    return p;
  }

  function inverse$q(p) {
    var DEL_TOL = 1e-14;
    var lon = p.x / this.C;
    var lat = p.y;
    var num = Math.pow(Math.tan(0.5 * lat + FORTPI) / this.K, 1 / this.C);
    for (var i = MAX_ITER$2; i > 0; --i) {
      lat = 2 * Math.atan(num * srat(this.e * Math.sin(p.y), - 0.5 * this.e)) - HALF_PI;
      if (Math.abs(lat - p.y) < DEL_TOL) {
        break;
      }
      p.y = lat;
    }
    /* convergence failed */
    if (!i) {
      return null;
    }
    p.x = lon;
    p.y = lat;
    return p;
  }

  var names$q = ["gauss"];
  var gauss = {
    init: init$q,
    forward: forward$q,
    inverse: inverse$q,
    names: names$q
  };

  function init$p() {
    gauss.init.apply(this);
    if (!this.rc) {
      return;
    }
    this.sinc0 = Math.sin(this.phic0);
    this.cosc0 = Math.cos(this.phic0);
    this.R2 = 2 * this.rc;
    if (!this.title) {
      this.title = "Oblique Stereographic Alternative";
    }
  }

  function forward$p(p) {
    var sinc, cosc, cosl, k;
    p.x = adjust_lon(p.x - this.long0);
    gauss.forward.apply(this, [p]);
    sinc = Math.sin(p.y);
    cosc = Math.cos(p.y);
    cosl = Math.cos(p.x);
    k = this.k0 * this.R2 / (1 + this.sinc0 * sinc + this.cosc0 * cosc * cosl);
    p.x = k * cosc * Math.sin(p.x);
    p.y = k * (this.cosc0 * sinc - this.sinc0 * cosc * cosl);
    p.x = this.a * p.x + this.x0;
    p.y = this.a * p.y + this.y0;
    return p;
  }

  function inverse$p(p) {
    var sinc, cosc, lon, lat, rho;
    p.x = (p.x - this.x0) / this.a;
    p.y = (p.y - this.y0) / this.a;

    p.x /= this.k0;
    p.y /= this.k0;
    if ((rho = hypot(p.x, p.y))) {
      var c = 2 * Math.atan2(rho, this.R2);
      sinc = Math.sin(c);
      cosc = Math.cos(c);
      lat = Math.asin(cosc * this.sinc0 + p.y * sinc * this.cosc0 / rho);
      lon = Math.atan2(p.x * sinc, rho * this.cosc0 * cosc - p.y * this.sinc0 * sinc);
    }
    else {
      lat = this.phic0;
      lon = 0;
    }

    p.x = lon;
    p.y = lat;
    gauss.inverse.apply(this, [p]);
    p.x = adjust_lon(p.x + this.long0);
    return p;
  }

  var names$p = ["Stereographic_North_Pole", "Oblique_Stereographic", "sterea","Oblique Stereographic Alternative","Double_Stereographic"];
  var sterea = {
    init: init$p,
    forward: forward$p,
    inverse: inverse$p,
    names: names$p
  };

  function ssfn_(phit, sinphi, eccen) {
    sinphi *= eccen;
    return (Math.tan(0.5 * (HALF_PI + phit)) * Math.pow((1 - sinphi) / (1 + sinphi), 0.5 * eccen));
  }

  function init$o() {

    // setting default parameters
    this.x0 = this.x0 || 0;
    this.y0 = this.y0 || 0;
    this.lat0 = this.lat0 || 0;
    this.long0 = this.long0 || 0;

    this.coslat0 = Math.cos(this.lat0);
    this.sinlat0 = Math.sin(this.lat0);
    if (this.sphere) {
      if (this.k0 === 1 && !isNaN(this.lat_ts) && Math.abs(this.coslat0) <= EPSLN) {
        this.k0 = 0.5 * (1 + sign(this.lat0) * Math.sin(this.lat_ts));
      }
    }
    else {
      if (Math.abs(this.coslat0) <= EPSLN) {
        if (this.lat0 > 0) {
          //North pole
          //trace('stere:north pole');
          this.con = 1;
        }
        else {
          //South pole
          //trace('stere:south pole');
          this.con = -1;
        }
      }
      this.cons = Math.sqrt(Math.pow(1 + this.e, 1 + this.e) * Math.pow(1 - this.e, 1 - this.e));
      if (this.k0 === 1 && !isNaN(this.lat_ts) && Math.abs(this.coslat0) <= EPSLN && Math.abs(Math.cos(this.lat_ts)) > EPSLN) {
        // When k0 is 1 (default value) and lat_ts is a vaild number and lat0 is at a pole and lat_ts is not at a pole
        // Recalculate k0 using formula 21-35 from p161 of Snyder, 1987
        this.k0 = 0.5 * this.cons * msfnz(this.e, Math.sin(this.lat_ts), Math.cos(this.lat_ts)) / tsfnz(this.e, this.con * this.lat_ts, this.con * Math.sin(this.lat_ts));
      }
      this.ms1 = msfnz(this.e, this.sinlat0, this.coslat0);
      this.X0 = 2 * Math.atan(this.ssfn_(this.lat0, this.sinlat0, this.e)) - HALF_PI;
      this.cosX0 = Math.cos(this.X0);
      this.sinX0 = Math.sin(this.X0);
    }
  }

  // Stereographic forward equations--mapping lat,long to x,y
  function forward$o(p) {
    var lon = p.x;
    var lat = p.y;
    var sinlat = Math.sin(lat);
    var coslat = Math.cos(lat);
    var A, X, sinX, cosX, ts, rh;
    var dlon = adjust_lon(lon - this.long0);

    if (Math.abs(Math.abs(lon - this.long0) - Math.PI) <= EPSLN && Math.abs(lat + this.lat0) <= EPSLN) {
      //case of the origine point
      //trace('stere:this is the origin point');
      p.x = NaN;
      p.y = NaN;
      return p;
    }
    if (this.sphere) {
      //trace('stere:sphere case');
      A = 2 * this.k0 / (1 + this.sinlat0 * sinlat + this.coslat0 * coslat * Math.cos(dlon));
      p.x = this.a * A * coslat * Math.sin(dlon) + this.x0;
      p.y = this.a * A * (this.coslat0 * sinlat - this.sinlat0 * coslat * Math.cos(dlon)) + this.y0;
      return p;
    }
    else {
      X = 2 * Math.atan(this.ssfn_(lat, sinlat, this.e)) - HALF_PI;
      cosX = Math.cos(X);
      sinX = Math.sin(X);
      if (Math.abs(this.coslat0) <= EPSLN) {
        ts = tsfnz(this.e, lat * this.con, this.con * sinlat);
        rh = 2 * this.a * this.k0 * ts / this.cons;
        p.x = this.x0 + rh * Math.sin(lon - this.long0);
        p.y = this.y0 - this.con * rh * Math.cos(lon - this.long0);
        //trace(p.toString());
        return p;
      }
      else if (Math.abs(this.sinlat0) < EPSLN) {
        //Eq
        //trace('stere:equateur');
        A = 2 * this.a * this.k0 / (1 + cosX * Math.cos(dlon));
        p.y = A * sinX;
      }
      else {
        //other case
        //trace('stere:normal case');
        A = 2 * this.a * this.k0 * this.ms1 / (this.cosX0 * (1 + this.sinX0 * sinX + this.cosX0 * cosX * Math.cos(dlon)));
        p.y = A * (this.cosX0 * sinX - this.sinX0 * cosX * Math.cos(dlon)) + this.y0;
      }
      p.x = A * cosX * Math.sin(dlon) + this.x0;
    }
    //trace(p.toString());
    return p;
  }

  //* Stereographic inverse equations--mapping x,y to lat/long
  function inverse$o(p) {
    p.x -= this.x0;
    p.y -= this.y0;
    var lon, lat, ts, ce, Chi;
    var rh = Math.sqrt(p.x * p.x + p.y * p.y);
    if (this.sphere) {
      var c = 2 * Math.atan(rh / (2 * this.a * this.k0));
      lon = this.long0;
      lat = this.lat0;
      if (rh <= EPSLN) {
        p.x = lon;
        p.y = lat;
        return p;
      }
      lat = Math.asin(Math.cos(c) * this.sinlat0 + p.y * Math.sin(c) * this.coslat0 / rh);
      if (Math.abs(this.coslat0) < EPSLN) {
        if (this.lat0 > 0) {
          lon = adjust_lon(this.long0 + Math.atan2(p.x, - 1 * p.y));
        }
        else {
          lon = adjust_lon(this.long0 + Math.atan2(p.x, p.y));
        }
      }
      else {
        lon = adjust_lon(this.long0 + Math.atan2(p.x * Math.sin(c), rh * this.coslat0 * Math.cos(c) - p.y * this.sinlat0 * Math.sin(c)));
      }
      p.x = lon;
      p.y = lat;
      return p;
    }
    else {
      if (Math.abs(this.coslat0) <= EPSLN) {
        if (rh <= EPSLN) {
          lat = this.lat0;
          lon = this.long0;
          p.x = lon;
          p.y = lat;
          //trace(p.toString());
          return p;
        }
        p.x *= this.con;
        p.y *= this.con;
        ts = rh * this.cons / (2 * this.a * this.k0);
        lat = this.con * phi2z(this.e, ts);
        lon = this.con * adjust_lon(this.con * this.long0 + Math.atan2(p.x, - 1 * p.y));
      }
      else {
        ce = 2 * Math.atan(rh * this.cosX0 / (2 * this.a * this.k0 * this.ms1));
        lon = this.long0;
        if (rh <= EPSLN) {
          Chi = this.X0;
        }
        else {
          Chi = Math.asin(Math.cos(ce) * this.sinX0 + p.y * Math.sin(ce) * this.cosX0 / rh);
          lon = adjust_lon(this.long0 + Math.atan2(p.x * Math.sin(ce), rh * this.cosX0 * Math.cos(ce) - p.y * this.sinX0 * Math.sin(ce)));
        }
        lat = -1 * phi2z(this.e, Math.tan(0.5 * (HALF_PI + Chi)));
      }
    }
    p.x = lon;
    p.y = lat;

    //trace(p.toString());
    return p;

  }

  var names$o = ["stere", "Stereographic_South_Pole", "Polar Stereographic (variant B)", "Polar_Stereographic"];
  var stere = {
    init: init$o,
    forward: forward$o,
    inverse: inverse$o,
    names: names$o,
    ssfn_: ssfn_
  };

  /*
    references:
      Formules et constantes pour le Calcul pour la
      projection cylindrique conforme à axe oblique et pour la transformation entre
      des systèmes de référence.
      http://www.swisstopo.admin.ch/internet/swisstopo/fr/home/topics/survey/sys/refsys/switzerland.parsysrelated1.31216.downloadList.77004.DownloadFile.tmp/swissprojectionfr.pdf
    */

  function init$n() {
    var phy0 = this.lat0;
    this.lambda0 = this.long0;
    var sinPhy0 = Math.sin(phy0);
    var semiMajorAxis = this.a;
    var invF = this.rf;
    var flattening = 1 / invF;
    var e2 = 2 * flattening - Math.pow(flattening, 2);
    var e = this.e = Math.sqrt(e2);
    this.R = this.k0 * semiMajorAxis * Math.sqrt(1 - e2) / (1 - e2 * Math.pow(sinPhy0, 2));
    this.alpha = Math.sqrt(1 + e2 / (1 - e2) * Math.pow(Math.cos(phy0), 4));
    this.b0 = Math.asin(sinPhy0 / this.alpha);
    var k1 = Math.log(Math.tan(Math.PI / 4 + this.b0 / 2));
    var k2 = Math.log(Math.tan(Math.PI / 4 + phy0 / 2));
    var k3 = Math.log((1 + e * sinPhy0) / (1 - e * sinPhy0));
    this.K = k1 - this.alpha * k2 + this.alpha * e / 2 * k3;
  }

  function forward$n(p) {
    var Sa1 = Math.log(Math.tan(Math.PI / 4 - p.y / 2));
    var Sa2 = this.e / 2 * Math.log((1 + this.e * Math.sin(p.y)) / (1 - this.e * Math.sin(p.y)));
    var S = -this.alpha * (Sa1 + Sa2) + this.K;

    // spheric latitude
    var b = 2 * (Math.atan(Math.exp(S)) - Math.PI / 4);

    // spheric longitude
    var I = this.alpha * (p.x - this.lambda0);

    // psoeudo equatorial rotation
    var rotI = Math.atan(Math.sin(I) / (Math.sin(this.b0) * Math.tan(b) + Math.cos(this.b0) * Math.cos(I)));

    var rotB = Math.asin(Math.cos(this.b0) * Math.sin(b) - Math.sin(this.b0) * Math.cos(b) * Math.cos(I));

    p.y = this.R / 2 * Math.log((1 + Math.sin(rotB)) / (1 - Math.sin(rotB))) + this.y0;
    p.x = this.R * rotI + this.x0;
    return p;
  }

  function inverse$n(p) {
    var Y = p.x - this.x0;
    var X = p.y - this.y0;

    var rotI = Y / this.R;
    var rotB = 2 * (Math.atan(Math.exp(X / this.R)) - Math.PI / 4);

    var b = Math.asin(Math.cos(this.b0) * Math.sin(rotB) + Math.sin(this.b0) * Math.cos(rotB) * Math.cos(rotI));
    var I = Math.atan(Math.sin(rotI) / (Math.cos(this.b0) * Math.cos(rotI) - Math.sin(this.b0) * Math.tan(rotB)));

    var lambda = this.lambda0 + I / this.alpha;

    var S = 0;
    var phy = b;
    var prevPhy = -1000;
    var iteration = 0;
    while (Math.abs(phy - prevPhy) > 0.0000001) {
      if (++iteration > 20) {
        //...reportError("omercFwdInfinity");
        return;
      }
      //S = Math.log(Math.tan(Math.PI / 4 + phy / 2));
      S = 1 / this.alpha * (Math.log(Math.tan(Math.PI / 4 + b / 2)) - this.K) + this.e * Math.log(Math.tan(Math.PI / 4 + Math.asin(this.e * Math.sin(phy)) / 2));
      prevPhy = phy;
      phy = 2 * Math.atan(Math.exp(S)) - Math.PI / 2;
    }

    p.x = lambda;
    p.y = phy;
    return p;
  }

  var names$n = ["somerc"];
  var somerc = {
    init: init$n,
    forward: forward$n,
    inverse: inverse$n,
    names: names$n
  };

  var TOL = 1e-7;

  function isTypeA(P) {
    var typeAProjections = ['Hotine_Oblique_Mercator','Hotine_Oblique_Mercator_Azimuth_Natural_Origin'];
    var projectionName = typeof P.PROJECTION === "object" ? Object.keys(P.PROJECTION)[0] : P.PROJECTION;
    
    return 'no_uoff' in P || 'no_off' in P || typeAProjections.indexOf(projectionName) !== -1;
  }


  /* Initialize the Oblique Mercator  projection
      ------------------------------------------*/
  function init$m() {  
    var con, com, cosph0, D, F, H, L, sinph0, p, J, gamma = 0,
      gamma0, lamc = 0, lam1 = 0, lam2 = 0, phi1 = 0, phi2 = 0, alpha_c = 0;
    
    // only Type A uses the no_off or no_uoff property
    // https://github.com/OSGeo/proj.4/issues/104
    this.no_off = isTypeA(this);
    this.no_rot = 'no_rot' in this;
    
    var alp = false;
    if ("alpha" in this) {
      alp = true;
    }

    var gam = false;
    if ("rectified_grid_angle" in this) {
      gam = true;
    }

    if (alp) {
      alpha_c = this.alpha;
    }
    
    if (gam) {
      gamma = (this.rectified_grid_angle * D2R$1);
    }
    
    if (alp || gam) {
      lamc = this.longc;
    } else {
      lam1 = this.long1;
      phi1 = this.lat1;
      lam2 = this.long2;
      phi2 = this.lat2;
      
      if (Math.abs(phi1 - phi2) <= TOL || (con = Math.abs(phi1)) <= TOL ||
          Math.abs(con - HALF_PI) <= TOL || Math.abs(Math.abs(this.lat0) - HALF_PI) <= TOL ||
          Math.abs(Math.abs(phi2) - HALF_PI) <= TOL) {
        throw new Error();
      }
    }
    
    var one_es = 1.0 - this.es;
    com = Math.sqrt(one_es);
    
    if (Math.abs(this.lat0) > EPSLN) {
      sinph0 = Math.sin(this.lat0);
      cosph0 = Math.cos(this.lat0);
      con = 1 - this.es * sinph0 * sinph0;
      this.B = cosph0 * cosph0;
      this.B = Math.sqrt(1 + this.es * this.B * this.B / one_es);
      this.A = this.B * this.k0 * com / con;
      D = this.B * com / (cosph0 * Math.sqrt(con));
      F = D * D -1;
      
      if (F <= 0) {
        F = 0;
      } else {
        F = Math.sqrt(F);
        if (this.lat0 < 0) {
          F = -F;
        }
      }
      
      this.E = F += D;
      this.E *= Math.pow(tsfnz(this.e, this.lat0, sinph0), this.B);
    } else {
      this.B = 1 / com;
      this.A = this.k0;
      this.E = D = F = 1;
    }
    
    if (alp || gam) {
      if (alp) {
        gamma0 = Math.asin(Math.sin(alpha_c) / D);
        if (!gam) {
          gamma = alpha_c;
        }
      } else {
        gamma0 = gamma;
        alpha_c = Math.asin(D * Math.sin(gamma0));
      }
      this.lam0 = lamc - Math.asin(0.5 * (F - 1 / F) * Math.tan(gamma0)) / this.B;
    } else {
      H = Math.pow(tsfnz(this.e, phi1, Math.sin(phi1)), this.B);
      L = Math.pow(tsfnz(this.e, phi2, Math.sin(phi2)), this.B);
      F = this.E / H;
      p = (L - H) / (L + H);
      J = this.E * this.E;
      J = (J - L * H) / (J + L * H);
      con = lam1 - lam2;
      
      if (con < -Math.pi) {
        lam2 -=TWO_PI;
      } else if (con > Math.pi) {
        lam2 += TWO_PI;
      }
      
      this.lam0 = adjust_lon(0.5 * (lam1 + lam2) - Math.atan(J * Math.tan(0.5 * this.B * (lam1 - lam2)) / p) / this.B);
      gamma0 = Math.atan(2 * Math.sin(this.B * adjust_lon(lam1 - this.lam0)) / (F - 1 / F));
      gamma = alpha_c = Math.asin(D * Math.sin(gamma0));
    }
    
    this.singam = Math.sin(gamma0);
    this.cosgam = Math.cos(gamma0);
    this.sinrot = Math.sin(gamma);
    this.cosrot = Math.cos(gamma);
    
    this.rB = 1 / this.B;
    this.ArB = this.A * this.rB;
    this.BrA = 1 / this.ArB;
    this.A * this.B;
    
    if (this.no_off) {
      this.u_0 = 0;
    } else {
      this.u_0 = Math.abs(this.ArB * Math.atan(Math.sqrt(D * D - 1) / Math.cos(alpha_c)));
      
      if (this.lat0 < 0) {
        this.u_0 = - this.u_0;
      }  
    }
      
    F = 0.5 * gamma0;
    this.v_pole_n = this.ArB * Math.log(Math.tan(FORTPI - F));
    this.v_pole_s = this.ArB * Math.log(Math.tan(FORTPI + F));
  }


  /* Oblique Mercator forward equations--mapping lat,long to x,y
      ----------------------------------------------------------*/
  function forward$m(p) {
    var coords = {};
    var S, T, U, V, W, temp, u, v;
    p.x = p.x - this.lam0;
    
    if (Math.abs(Math.abs(p.y) - HALF_PI) > EPSLN) {
      W = this.E / Math.pow(tsfnz(this.e, p.y, Math.sin(p.y)), this.B);
      
      temp = 1 / W;
      S = 0.5 * (W - temp);
      T = 0.5 * (W + temp);
      V = Math.sin(this.B * p.x);
      U = (S * this.singam - V * this.cosgam) / T;
          
      if (Math.abs(Math.abs(U) - 1.0) < EPSLN) {
        throw new Error();
      }
      
      v = 0.5 * this.ArB * Math.log((1 - U)/(1 + U));
      temp = Math.cos(this.B * p.x);
      
      if (Math.abs(temp) < TOL) {
        u = this.A * p.x;
      } else {
        u = this.ArB * Math.atan2((S * this.cosgam + V * this.singam), temp);
      }    
    } else {
      v = p.y > 0 ? this.v_pole_n : this.v_pole_s;
      u = this.ArB * p.y;
    }
       
    if (this.no_rot) {
      coords.x = u;
      coords.y = v;
    } else {
      u -= this.u_0;
      coords.x = v * this.cosrot + u * this.sinrot;
      coords.y = u * this.cosrot - v * this.sinrot;
    }
    
    coords.x = (this.a * coords.x + this.x0);
    coords.y = (this.a * coords.y + this.y0);
    
    return coords;
  }

  function inverse$m(p) {
    var u, v, Qp, Sp, Tp, Vp, Up;
    var coords = {};
    
    p.x = (p.x - this.x0) * (1.0 / this.a);
    p.y = (p.y - this.y0) * (1.0 / this.a);

    if (this.no_rot) {
      v = p.y;
      u = p.x;
    } else {
      v = p.x * this.cosrot - p.y * this.sinrot;
      u = p.y * this.cosrot + p.x * this.sinrot + this.u_0;
    }
    
    Qp = Math.exp(-this.BrA * v);
    Sp = 0.5 * (Qp - 1 / Qp);
    Tp = 0.5 * (Qp + 1 / Qp);
    Vp = Math.sin(this.BrA * u);
    Up = (Vp * this.cosgam + Sp * this.singam) / Tp;
    
    if (Math.abs(Math.abs(Up) - 1) < EPSLN) {
      coords.x = 0;
      coords.y = Up < 0 ? -HALF_PI : HALF_PI;
    } else {
      coords.y = this.E / Math.sqrt((1 + Up) / (1 - Up));
      coords.y = phi2z(this.e, Math.pow(coords.y, 1 / this.B));
      
      if (coords.y === Infinity) {
        throw new Error();
      }
          
      coords.x = -this.rB * Math.atan2((Sp * this.cosgam - Vp * this.singam), Math.cos(this.BrA * u));
    }
    
    coords.x += this.lam0;
    
    return coords;
  }

  var names$m = ["Hotine_Oblique_Mercator", "Hotine Oblique Mercator", "Hotine_Oblique_Mercator_Azimuth_Natural_Origin", "Hotine_Oblique_Mercator_Two_Point_Natural_Origin", "Hotine_Oblique_Mercator_Azimuth_Center", "Oblique_Mercator", "omerc"];
  var omerc = {
    init: init$m,
    forward: forward$m,
    inverse: inverse$m,
    names: names$m
  };

  function init$l() {
    
    //double lat0;                    /* the reference latitude               */
    //double long0;                   /* the reference longitude              */
    //double lat1;                    /* first standard parallel              */
    //double lat2;                    /* second standard parallel             */
    //double r_maj;                   /* major axis                           */
    //double r_min;                   /* minor axis                           */
    //double false_east;              /* x offset in meters                   */
    //double false_north;             /* y offset in meters                   */
    
    //the above value can be set with proj4.defs
    //example: proj4.defs("EPSG:2154","+proj=lcc +lat_1=49 +lat_2=44 +lat_0=46.5 +lon_0=3 +x_0=700000 +y_0=6600000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs");

    if (!this.lat2) {
      this.lat2 = this.lat1;
    } //if lat2 is not defined
    if (!this.k0) {
      this.k0 = 1;
    }
    this.x0 = this.x0 || 0;
    this.y0 = this.y0 || 0;
    // Standard Parallels cannot be equal and on opposite sides of the equator
    if (Math.abs(this.lat1 + this.lat2) < EPSLN) {
      return;
    }

    var temp = this.b / this.a;
    this.e = Math.sqrt(1 - temp * temp);

    var sin1 = Math.sin(this.lat1);
    var cos1 = Math.cos(this.lat1);
    var ms1 = msfnz(this.e, sin1, cos1);
    var ts1 = tsfnz(this.e, this.lat1, sin1);

    var sin2 = Math.sin(this.lat2);
    var cos2 = Math.cos(this.lat2);
    var ms2 = msfnz(this.e, sin2, cos2);
    var ts2 = tsfnz(this.e, this.lat2, sin2);

    var ts0 = tsfnz(this.e, this.lat0, Math.sin(this.lat0));

    if (Math.abs(this.lat1 - this.lat2) > EPSLN) {
      this.ns = Math.log(ms1 / ms2) / Math.log(ts1 / ts2);
    }
    else {
      this.ns = sin1;
    }
    if (isNaN(this.ns)) {
      this.ns = sin1;
    }
    this.f0 = ms1 / (this.ns * Math.pow(ts1, this.ns));
    this.rh = this.a * this.f0 * Math.pow(ts0, this.ns);
    if (!this.title) {
      this.title = "Lambert Conformal Conic";
    }
  }

  // Lambert Conformal conic forward equations--mapping lat,long to x,y
  // -----------------------------------------------------------------
  function forward$l(p) {

    var lon = p.x;
    var lat = p.y;

    // singular cases :
    if (Math.abs(2 * Math.abs(lat) - Math.PI) <= EPSLN) {
      lat = sign(lat) * (HALF_PI - 2 * EPSLN);
    }

    var con = Math.abs(Math.abs(lat) - HALF_PI);
    var ts, rh1;
    if (con > EPSLN) {
      ts = tsfnz(this.e, lat, Math.sin(lat));
      rh1 = this.a * this.f0 * Math.pow(ts, this.ns);
    }
    else {
      con = lat * this.ns;
      if (con <= 0) {
        return null;
      }
      rh1 = 0;
    }
    var theta = this.ns * adjust_lon(lon - this.long0);
    p.x = this.k0 * (rh1 * Math.sin(theta)) + this.x0;
    p.y = this.k0 * (this.rh - rh1 * Math.cos(theta)) + this.y0;

    return p;
  }

  // Lambert Conformal Conic inverse equations--mapping x,y to lat/long
  // -----------------------------------------------------------------
  function inverse$l(p) {

    var rh1, con, ts;
    var lat, lon;
    var x = (p.x - this.x0) / this.k0;
    var y = (this.rh - (p.y - this.y0) / this.k0);
    if (this.ns > 0) {
      rh1 = Math.sqrt(x * x + y * y);
      con = 1;
    }
    else {
      rh1 = -Math.sqrt(x * x + y * y);
      con = -1;
    }
    var theta = 0;
    if (rh1 !== 0) {
      theta = Math.atan2((con * x), (con * y));
    }
    if ((rh1 !== 0) || (this.ns > 0)) {
      con = 1 / this.ns;
      ts = Math.pow((rh1 / (this.a * this.f0)), con);
      lat = phi2z(this.e, ts);
      if (lat === -9999) {
        return null;
      }
    }
    else {
      lat = -HALF_PI;
    }
    lon = adjust_lon(theta / this.ns + this.long0);

    p.x = lon;
    p.y = lat;
    return p;
  }

  var names$l = [
    "Lambert Tangential Conformal Conic Projection",
    "Lambert_Conformal_Conic",
    "Lambert_Conformal_Conic_1SP",
    "Lambert_Conformal_Conic_2SP",
    "lcc",
    "Lambert Conic Conformal (1SP)",
    "Lambert Conic Conformal (2SP)"
  ];

  var lcc = {
    init: init$l,
    forward: forward$l,
    inverse: inverse$l,
    names: names$l
  };

  function init$k() {
    this.a = 6377397.155;
    this.es = 0.006674372230614;
    this.e = Math.sqrt(this.es);
    if (!this.lat0) {
      this.lat0 = 0.863937979737193;
    }
    if (!this.long0) {
      this.long0 = 0.7417649320975901 - 0.308341501185665;
    }
    /* if scale not set default to 0.9999 */
    if (!this.k0) {
      this.k0 = 0.9999;
    }
    this.s45 = 0.785398163397448; /* 45 */
    this.s90 = 2 * this.s45;
    this.fi0 = this.lat0;
    this.e2 = this.es;
    this.e = Math.sqrt(this.e2);
    this.alfa = Math.sqrt(1 + (this.e2 * Math.pow(Math.cos(this.fi0), 4)) / (1 - this.e2));
    this.uq = 1.04216856380474;
    this.u0 = Math.asin(Math.sin(this.fi0) / this.alfa);
    this.g = Math.pow((1 + this.e * Math.sin(this.fi0)) / (1 - this.e * Math.sin(this.fi0)), this.alfa * this.e / 2);
    this.k = Math.tan(this.u0 / 2 + this.s45) / Math.pow(Math.tan(this.fi0 / 2 + this.s45), this.alfa) * this.g;
    this.k1 = this.k0;
    this.n0 = this.a * Math.sqrt(1 - this.e2) / (1 - this.e2 * Math.pow(Math.sin(this.fi0), 2));
    this.s0 = 1.37008346281555;
    this.n = Math.sin(this.s0);
    this.ro0 = this.k1 * this.n0 / Math.tan(this.s0);
    this.ad = this.s90 - this.uq;
  }

  /* ellipsoid */
  /* calculate xy from lat/lon */
  /* Constants, identical to inverse transform function */
  function forward$k(p) {
    var gfi, u, deltav, s, d, eps, ro;
    var lon = p.x;
    var lat = p.y;
    var delta_lon = adjust_lon(lon - this.long0);
    /* Transformation */
    gfi = Math.pow(((1 + this.e * Math.sin(lat)) / (1 - this.e * Math.sin(lat))), (this.alfa * this.e / 2));
    u = 2 * (Math.atan(this.k * Math.pow(Math.tan(lat / 2 + this.s45), this.alfa) / gfi) - this.s45);
    deltav = -delta_lon * this.alfa;
    s = Math.asin(Math.cos(this.ad) * Math.sin(u) + Math.sin(this.ad) * Math.cos(u) * Math.cos(deltav));
    d = Math.asin(Math.cos(u) * Math.sin(deltav) / Math.cos(s));
    eps = this.n * d;
    ro = this.ro0 * Math.pow(Math.tan(this.s0 / 2 + this.s45), this.n) / Math.pow(Math.tan(s / 2 + this.s45), this.n);
    p.y = ro * Math.cos(eps) / 1;
    p.x = ro * Math.sin(eps) / 1;

    if (!this.czech) {
      p.y *= -1;
      p.x *= -1;
    }
    return (p);
  }

  /* calculate lat/lon from xy */
  function inverse$k(p) {
    var u, deltav, s, d, eps, ro, fi1;
    var ok;

    /* Transformation */
    /* revert y, x*/
    var tmp = p.x;
    p.x = p.y;
    p.y = tmp;
    if (!this.czech) {
      p.y *= -1;
      p.x *= -1;
    }
    ro = Math.sqrt(p.x * p.x + p.y * p.y);
    eps = Math.atan2(p.y, p.x);
    d = eps / Math.sin(this.s0);
    s = 2 * (Math.atan(Math.pow(this.ro0 / ro, 1 / this.n) * Math.tan(this.s0 / 2 + this.s45)) - this.s45);
    u = Math.asin(Math.cos(this.ad) * Math.sin(s) - Math.sin(this.ad) * Math.cos(s) * Math.cos(d));
    deltav = Math.asin(Math.cos(s) * Math.sin(d) / Math.cos(u));
    p.x = this.long0 - deltav / this.alfa;
    fi1 = u;
    ok = 0;
    var iter = 0;
    do {
      p.y = 2 * (Math.atan(Math.pow(this.k, - 1 / this.alfa) * Math.pow(Math.tan(u / 2 + this.s45), 1 / this.alfa) * Math.pow((1 + this.e * Math.sin(fi1)) / (1 - this.e * Math.sin(fi1)), this.e / 2)) - this.s45);
      if (Math.abs(fi1 - p.y) < 0.0000000001) {
        ok = 1;
      }
      fi1 = p.y;
      iter += 1;
    } while (ok === 0 && iter < 15);
    if (iter >= 15) {
      return null;
    }

    return (p);
  }

  var names$k = ["Krovak", "krovak"];
  var krovak = {
    init: init$k,
    forward: forward$k,
    inverse: inverse$k,
    names: names$k
  };

  function mlfn(e0, e1, e2, e3, phi) {
    return (e0 * phi - e1 * Math.sin(2 * phi) + e2 * Math.sin(4 * phi) - e3 * Math.sin(6 * phi));
  }

  function e0fn(x) {
    return (1 - 0.25 * x * (1 + x / 16 * (3 + 1.25 * x)));
  }

  function e1fn(x) {
    return (0.375 * x * (1 + 0.25 * x * (1 + 0.46875 * x)));
  }

  function e2fn(x) {
    return (0.05859375 * x * x * (1 + 0.75 * x));
  }

  function e3fn(x) {
    return (x * x * x * (35 / 3072));
  }

  function gN(a, e, sinphi) {
    var temp = e * sinphi;
    return a / Math.sqrt(1 - temp * temp);
  }

  function adjust_lat(x) {
    return (Math.abs(x) < HALF_PI) ? x : (x - (sign(x) * Math.PI));
  }

  function imlfn(ml, e0, e1, e2, e3) {
    var phi;
    var dphi;

    phi = ml / e0;
    for (var i = 0; i < 15; i++) {
      dphi = (ml - (e0 * phi - e1 * Math.sin(2 * phi) + e2 * Math.sin(4 * phi) - e3 * Math.sin(6 * phi))) / (e0 - 2 * e1 * Math.cos(2 * phi) + 4 * e2 * Math.cos(4 * phi) - 6 * e3 * Math.cos(6 * phi));
      phi += dphi;
      if (Math.abs(dphi) <= 0.0000000001) {
        return phi;
      }
    }

    //..reportError("IMLFN-CONV:Latitude failed to converge after 15 iterations");
    return NaN;
  }

  function init$j() {
    if (!this.sphere) {
      this.e0 = e0fn(this.es);
      this.e1 = e1fn(this.es);
      this.e2 = e2fn(this.es);
      this.e3 = e3fn(this.es);
      this.ml0 = this.a * mlfn(this.e0, this.e1, this.e2, this.e3, this.lat0);
    }
  }

  /* Cassini forward equations--mapping lat,long to x,y
    -----------------------------------------------------------------------*/
  function forward$j(p) {

    /* Forward equations
        -----------------*/
    var x, y;
    var lam = p.x;
    var phi = p.y;
    lam = adjust_lon(lam - this.long0);

    if (this.sphere) {
      x = this.a * Math.asin(Math.cos(phi) * Math.sin(lam));
      y = this.a * (Math.atan2(Math.tan(phi), Math.cos(lam)) - this.lat0);
    }
    else {
      //ellipsoid
      var sinphi = Math.sin(phi);
      var cosphi = Math.cos(phi);
      var nl = gN(this.a, this.e, sinphi);
      var tl = Math.tan(phi) * Math.tan(phi);
      var al = lam * Math.cos(phi);
      var asq = al * al;
      var cl = this.es * cosphi * cosphi / (1 - this.es);
      var ml = this.a * mlfn(this.e0, this.e1, this.e2, this.e3, phi);

      x = nl * al * (1 - asq * tl * (1 / 6 - (8 - tl + 8 * cl) * asq / 120));
      y = ml - this.ml0 + nl * sinphi / cosphi * asq * (0.5 + (5 - tl + 6 * cl) * asq / 24);


    }

    p.x = x + this.x0;
    p.y = y + this.y0;
    return p;
  }

  /* Inverse equations
    -----------------*/
  function inverse$j(p) {
    p.x -= this.x0;
    p.y -= this.y0;
    var x = p.x / this.a;
    var y = p.y / this.a;
    var phi, lam;

    if (this.sphere) {
      var dd = y + this.lat0;
      phi = Math.asin(Math.sin(dd) * Math.cos(x));
      lam = Math.atan2(Math.tan(x), Math.cos(dd));
    }
    else {
      /* ellipsoid */
      var ml1 = this.ml0 / this.a + y;
      var phi1 = imlfn(ml1, this.e0, this.e1, this.e2, this.e3);
      if (Math.abs(Math.abs(phi1) - HALF_PI) <= EPSLN) {
        p.x = this.long0;
        p.y = HALF_PI;
        if (y < 0) {
          p.y *= -1;
        }
        return p;
      }
      var nl1 = gN(this.a, this.e, Math.sin(phi1));

      var rl1 = nl1 * nl1 * nl1 / this.a / this.a * (1 - this.es);
      var tl1 = Math.pow(Math.tan(phi1), 2);
      var dl = x * this.a / nl1;
      var dsq = dl * dl;
      phi = phi1 - nl1 * Math.tan(phi1) / rl1 * dl * dl * (0.5 - (1 + 3 * tl1) * dl * dl / 24);
      lam = dl * (1 - dsq * (tl1 / 3 + (1 + 3 * tl1) * tl1 * dsq / 15)) / Math.cos(phi1);

    }

    p.x = adjust_lon(lam + this.long0);
    p.y = adjust_lat(phi);
    return p;

  }

  var names$j = ["Cassini", "Cassini_Soldner", "cass"];
  var cass = {
    init: init$j,
    forward: forward$j,
    inverse: inverse$j,
    names: names$j
  };

  function qsfnz(eccent, sinphi) {
    var con;
    if (eccent > 1.0e-7) {
      con = eccent * sinphi;
      return ((1 - eccent * eccent) * (sinphi / (1 - con * con) - (0.5 / eccent) * Math.log((1 - con) / (1 + con))));
    }
    else {
      return (2 * sinphi);
    }
  }

  /*
    reference
      "New Equal-Area Map Projections for Noncircular Regions", John P. Snyder,
      The American Cartographer, Vol 15, No. 4, October 1988, pp. 341-355.
    */

  var S_POLE = 1;

  var N_POLE = 2;
  var EQUIT = 3;
  var OBLIQ = 4;

  /* Initialize the Lambert Azimuthal Equal Area projection
    ------------------------------------------------------*/
  function init$i() {
    var t = Math.abs(this.lat0);
    if (Math.abs(t - HALF_PI) < EPSLN) {
      this.mode = this.lat0 < 0 ? this.S_POLE : this.N_POLE;
    }
    else if (Math.abs(t) < EPSLN) {
      this.mode = this.EQUIT;
    }
    else {
      this.mode = this.OBLIQ;
    }
    if (this.es > 0) {
      var sinphi;

      this.qp = qsfnz(this.e, 1);
      this.mmf = 0.5 / (1 - this.es);
      this.apa = authset(this.es);
      switch (this.mode) {
      case this.N_POLE:
        this.dd = 1;
        break;
      case this.S_POLE:
        this.dd = 1;
        break;
      case this.EQUIT:
        this.rq = Math.sqrt(0.5 * this.qp);
        this.dd = 1 / this.rq;
        this.xmf = 1;
        this.ymf = 0.5 * this.qp;
        break;
      case this.OBLIQ:
        this.rq = Math.sqrt(0.5 * this.qp);
        sinphi = Math.sin(this.lat0);
        this.sinb1 = qsfnz(this.e, sinphi) / this.qp;
        this.cosb1 = Math.sqrt(1 - this.sinb1 * this.sinb1);
        this.dd = Math.cos(this.lat0) / (Math.sqrt(1 - this.es * sinphi * sinphi) * this.rq * this.cosb1);
        this.ymf = (this.xmf = this.rq) / this.dd;
        this.xmf *= this.dd;
        break;
      }
    }
    else {
      if (this.mode === this.OBLIQ) {
        this.sinph0 = Math.sin(this.lat0);
        this.cosph0 = Math.cos(this.lat0);
      }
    }
  }

  /* Lambert Azimuthal Equal Area forward equations--mapping lat,long to x,y
    -----------------------------------------------------------------------*/
  function forward$i(p) {

    /* Forward equations
        -----------------*/
    var x, y, coslam, sinlam, sinphi, q, sinb, cosb, b, cosphi;
    var lam = p.x;
    var phi = p.y;

    lam = adjust_lon(lam - this.long0);
    if (this.sphere) {
      sinphi = Math.sin(phi);
      cosphi = Math.cos(phi);
      coslam = Math.cos(lam);
      if (this.mode === this.OBLIQ || this.mode === this.EQUIT) {
        y = (this.mode === this.EQUIT) ? 1 + cosphi * coslam : 1 + this.sinph0 * sinphi + this.cosph0 * cosphi * coslam;
        if (y <= EPSLN) {
          return null;
        }
        y = Math.sqrt(2 / y);
        x = y * cosphi * Math.sin(lam);
        y *= (this.mode === this.EQUIT) ? sinphi : this.cosph0 * sinphi - this.sinph0 * cosphi * coslam;
      }
      else if (this.mode === this.N_POLE || this.mode === this.S_POLE) {
        if (this.mode === this.N_POLE) {
          coslam = -coslam;
        }
        if (Math.abs(phi + this.lat0) < EPSLN) {
          return null;
        }
        y = FORTPI - phi * 0.5;
        y = 2 * ((this.mode === this.S_POLE) ? Math.cos(y) : Math.sin(y));
        x = y * Math.sin(lam);
        y *= coslam;
      }
    }
    else {
      sinb = 0;
      cosb = 0;
      b = 0;
      coslam = Math.cos(lam);
      sinlam = Math.sin(lam);
      sinphi = Math.sin(phi);
      q = qsfnz(this.e, sinphi);
      if (this.mode === this.OBLIQ || this.mode === this.EQUIT) {
        sinb = q / this.qp;
        cosb = Math.sqrt(1 - sinb * sinb);
      }
      switch (this.mode) {
      case this.OBLIQ:
        b = 1 + this.sinb1 * sinb + this.cosb1 * cosb * coslam;
        break;
      case this.EQUIT:
        b = 1 + cosb * coslam;
        break;
      case this.N_POLE:
        b = HALF_PI + phi;
        q = this.qp - q;
        break;
      case this.S_POLE:
        b = phi - HALF_PI;
        q = this.qp + q;
        break;
      }
      if (Math.abs(b) < EPSLN) {
        return null;
      }
      switch (this.mode) {
      case this.OBLIQ:
      case this.EQUIT:
        b = Math.sqrt(2 / b);
        if (this.mode === this.OBLIQ) {
          y = this.ymf * b * (this.cosb1 * sinb - this.sinb1 * cosb * coslam);
        }
        else {
          y = (b = Math.sqrt(2 / (1 + cosb * coslam))) * sinb * this.ymf;
        }
        x = this.xmf * b * cosb * sinlam;
        break;
      case this.N_POLE:
      case this.S_POLE:
        if (q >= 0) {
          x = (b = Math.sqrt(q)) * sinlam;
          y = coslam * ((this.mode === this.S_POLE) ? b : -b);
        }
        else {
          x = y = 0;
        }
        break;
      }
    }

    p.x = this.a * x + this.x0;
    p.y = this.a * y + this.y0;
    return p;
  }

  /* Inverse equations
    -----------------*/
  function inverse$i(p) {
    p.x -= this.x0;
    p.y -= this.y0;
    var x = p.x / this.a;
    var y = p.y / this.a;
    var lam, phi, cCe, sCe, q, rho, ab;
    if (this.sphere) {
      var cosz = 0,
        rh, sinz = 0;

      rh = Math.sqrt(x * x + y * y);
      phi = rh * 0.5;
      if (phi > 1) {
        return null;
      }
      phi = 2 * Math.asin(phi);
      if (this.mode === this.OBLIQ || this.mode === this.EQUIT) {
        sinz = Math.sin(phi);
        cosz = Math.cos(phi);
      }
      switch (this.mode) {
      case this.EQUIT:
        phi = (Math.abs(rh) <= EPSLN) ? 0 : Math.asin(y * sinz / rh);
        x *= sinz;
        y = cosz * rh;
        break;
      case this.OBLIQ:
        phi = (Math.abs(rh) <= EPSLN) ? this.lat0 : Math.asin(cosz * this.sinph0 + y * sinz * this.cosph0 / rh);
        x *= sinz * this.cosph0;
        y = (cosz - Math.sin(phi) * this.sinph0) * rh;
        break;
      case this.N_POLE:
        y = -y;
        phi = HALF_PI - phi;
        break;
      case this.S_POLE:
        phi -= HALF_PI;
        break;
      }
      lam = (y === 0 && (this.mode === this.EQUIT || this.mode === this.OBLIQ)) ? 0 : Math.atan2(x, y);
    }
    else {
      ab = 0;
      if (this.mode === this.OBLIQ || this.mode === this.EQUIT) {
        x /= this.dd;
        y *= this.dd;
        rho = Math.sqrt(x * x + y * y);
        if (rho < EPSLN) {
          p.x = this.long0;
          p.y = this.lat0;
          return p;
        }
        sCe = 2 * Math.asin(0.5 * rho / this.rq);
        cCe = Math.cos(sCe);
        x *= (sCe = Math.sin(sCe));
        if (this.mode === this.OBLIQ) {
          ab = cCe * this.sinb1 + y * sCe * this.cosb1 / rho;
          q = this.qp * ab;
          y = rho * this.cosb1 * cCe - y * this.sinb1 * sCe;
        }
        else {
          ab = y * sCe / rho;
          q = this.qp * ab;
          y = rho * cCe;
        }
      }
      else if (this.mode === this.N_POLE || this.mode === this.S_POLE) {
        if (this.mode === this.N_POLE) {
          y = -y;
        }
        q = (x * x + y * y);
        if (!q) {
          p.x = this.long0;
          p.y = this.lat0;
          return p;
        }
        ab = 1 - q / this.qp;
        if (this.mode === this.S_POLE) {
          ab = -ab;
        }
      }
      lam = Math.atan2(x, y);
      phi = authlat(Math.asin(ab), this.apa);
    }

    p.x = adjust_lon(this.long0 + lam);
    p.y = phi;
    return p;
  }

  /* determine latitude from authalic latitude */
  var P00 = 0.33333333333333333333;

  var P01 = 0.17222222222222222222;
  var P02 = 0.10257936507936507936;
  var P10 = 0.06388888888888888888;
  var P11 = 0.06640211640211640211;
  var P20 = 0.01641501294219154443;

  function authset(es) {
    var t;
    var APA = [];
    APA[0] = es * P00;
    t = es * es;
    APA[0] += t * P01;
    APA[1] = t * P10;
    t *= es;
    APA[0] += t * P02;
    APA[1] += t * P11;
    APA[2] = t * P20;
    return APA;
  }

  function authlat(beta, APA) {
    var t = beta + beta;
    return (beta + APA[0] * Math.sin(t) + APA[1] * Math.sin(t + t) + APA[2] * Math.sin(t + t + t));
  }

  var names$i = ["Lambert Azimuthal Equal Area", "Lambert_Azimuthal_Equal_Area", "laea"];
  var laea = {
    init: init$i,
    forward: forward$i,
    inverse: inverse$i,
    names: names$i,
    S_POLE: S_POLE,
    N_POLE: N_POLE,
    EQUIT: EQUIT,
    OBLIQ: OBLIQ
  };

  function asinz(x) {
    if (Math.abs(x) > 1) {
      x = (x > 1) ? 1 : -1;
    }
    return Math.asin(x);
  }

  function init$h() {

    if (Math.abs(this.lat1 + this.lat2) < EPSLN) {
      return;
    }
    this.temp = this.b / this.a;
    this.es = 1 - Math.pow(this.temp, 2);
    this.e3 = Math.sqrt(this.es);

    this.sin_po = Math.sin(this.lat1);
    this.cos_po = Math.cos(this.lat1);
    this.t1 = this.sin_po;
    this.con = this.sin_po;
    this.ms1 = msfnz(this.e3, this.sin_po, this.cos_po);
    this.qs1 = qsfnz(this.e3, this.sin_po);

    this.sin_po = Math.sin(this.lat2);
    this.cos_po = Math.cos(this.lat2);
    this.t2 = this.sin_po;
    this.ms2 = msfnz(this.e3, this.sin_po, this.cos_po);
    this.qs2 = qsfnz(this.e3, this.sin_po);

    this.sin_po = Math.sin(this.lat0);
    this.cos_po = Math.cos(this.lat0);
    this.t3 = this.sin_po;
    this.qs0 = qsfnz(this.e3, this.sin_po);

    if (Math.abs(this.lat1 - this.lat2) > EPSLN) {
      this.ns0 = (this.ms1 * this.ms1 - this.ms2 * this.ms2) / (this.qs2 - this.qs1);
    }
    else {
      this.ns0 = this.con;
    }
    this.c = this.ms1 * this.ms1 + this.ns0 * this.qs1;
    this.rh = this.a * Math.sqrt(this.c - this.ns0 * this.qs0) / this.ns0;
  }

  /* Albers Conical Equal Area forward equations--mapping lat,long to x,y
    -------------------------------------------------------------------*/
  function forward$h(p) {

    var lon = p.x;
    var lat = p.y;

    this.sin_phi = Math.sin(lat);
    this.cos_phi = Math.cos(lat);

    var qs = qsfnz(this.e3, this.sin_phi);
    var rh1 = this.a * Math.sqrt(this.c - this.ns0 * qs) / this.ns0;
    var theta = this.ns0 * adjust_lon(lon - this.long0);
    var x = rh1 * Math.sin(theta) + this.x0;
    var y = this.rh - rh1 * Math.cos(theta) + this.y0;

    p.x = x;
    p.y = y;
    return p;
  }

  function inverse$h(p) {
    var rh1, qs, con, theta, lon, lat;

    p.x -= this.x0;
    p.y = this.rh - p.y + this.y0;
    if (this.ns0 >= 0) {
      rh1 = Math.sqrt(p.x * p.x + p.y * p.y);
      con = 1;
    }
    else {
      rh1 = -Math.sqrt(p.x * p.x + p.y * p.y);
      con = -1;
    }
    theta = 0;
    if (rh1 !== 0) {
      theta = Math.atan2(con * p.x, con * p.y);
    }
    con = rh1 * this.ns0 / this.a;
    if (this.sphere) {
      lat = Math.asin((this.c - con * con) / (2 * this.ns0));
    }
    else {
      qs = (this.c - con * con) / this.ns0;
      lat = this.phi1z(this.e3, qs);
    }

    lon = adjust_lon(theta / this.ns0 + this.long0);
    p.x = lon;
    p.y = lat;
    return p;
  }

  /* Function to compute phi1, the latitude for the inverse of the
     Albers Conical Equal-Area projection.
  -------------------------------------------*/
  function phi1z(eccent, qs) {
    var sinphi, cosphi, con, com, dphi;
    var phi = asinz(0.5 * qs);
    if (eccent < EPSLN) {
      return phi;
    }

    var eccnts = eccent * eccent;
    for (var i = 1; i <= 25; i++) {
      sinphi = Math.sin(phi);
      cosphi = Math.cos(phi);
      con = eccent * sinphi;
      com = 1 - con * con;
      dphi = 0.5 * com * com / cosphi * (qs / (1 - eccnts) - sinphi / com + 0.5 / eccent * Math.log((1 - con) / (1 + con)));
      phi = phi + dphi;
      if (Math.abs(dphi) <= 1e-7) {
        return phi;
      }
    }
    return null;
  }

  var names$h = ["Albers_Conic_Equal_Area", "Albers", "aea"];
  var aea = {
    init: init$h,
    forward: forward$h,
    inverse: inverse$h,
    names: names$h,
    phi1z: phi1z
  };

  /*
    reference:
      Wolfram Mathworld "Gnomonic Projection"
      http://mathworld.wolfram.com/GnomonicProjection.html
      Accessed: 12th November 2009
    */
  function init$g() {

    /* Place parameters in static storage for common use
        -------------------------------------------------*/
    this.sin_p14 = Math.sin(this.lat0);
    this.cos_p14 = Math.cos(this.lat0);
    // Approximation for projecting points to the horizon (infinity)
    this.infinity_dist = 1000 * this.a;
    this.rc = 1;
  }

  /* Gnomonic forward equations--mapping lat,long to x,y
      ---------------------------------------------------*/
  function forward$g(p) {
    var sinphi, cosphi; /* sin and cos value        */
    var dlon; /* delta longitude value      */
    var coslon; /* cos of longitude        */
    var ksp; /* scale factor          */
    var g;
    var x, y;
    var lon = p.x;
    var lat = p.y;
    /* Forward equations
        -----------------*/
    dlon = adjust_lon(lon - this.long0);

    sinphi = Math.sin(lat);
    cosphi = Math.cos(lat);

    coslon = Math.cos(dlon);
    g = this.sin_p14 * sinphi + this.cos_p14 * cosphi * coslon;
    ksp = 1;
    if ((g > 0) || (Math.abs(g) <= EPSLN)) {
      x = this.x0 + this.a * ksp * cosphi * Math.sin(dlon) / g;
      y = this.y0 + this.a * ksp * (this.cos_p14 * sinphi - this.sin_p14 * cosphi * coslon) / g;
    }
    else {

      // Point is in the opposing hemisphere and is unprojectable
      // We still need to return a reasonable point, so we project
      // to infinity, on a bearing
      // equivalent to the northern hemisphere equivalent
      // This is a reasonable approximation for short shapes and lines that
      // straddle the horizon.

      x = this.x0 + this.infinity_dist * cosphi * Math.sin(dlon);
      y = this.y0 + this.infinity_dist * (this.cos_p14 * sinphi - this.sin_p14 * cosphi * coslon);

    }
    p.x = x;
    p.y = y;
    return p;
  }

  function inverse$g(p) {
    var rh; /* Rho */
    var sinc, cosc;
    var c;
    var lon, lat;

    /* Inverse equations
        -----------------*/
    p.x = (p.x - this.x0) / this.a;
    p.y = (p.y - this.y0) / this.a;

    p.x /= this.k0;
    p.y /= this.k0;

    if ((rh = Math.sqrt(p.x * p.x + p.y * p.y))) {
      c = Math.atan2(rh, this.rc);
      sinc = Math.sin(c);
      cosc = Math.cos(c);

      lat = asinz(cosc * this.sin_p14 + (p.y * sinc * this.cos_p14) / rh);
      lon = Math.atan2(p.x * sinc, rh * this.cos_p14 * cosc - p.y * this.sin_p14 * sinc);
      lon = adjust_lon(this.long0 + lon);
    }
    else {
      lat = this.phic0;
      lon = 0;
    }

    p.x = lon;
    p.y = lat;
    return p;
  }

  var names$g = ["gnom"];
  var gnom = {
    init: init$g,
    forward: forward$g,
    inverse: inverse$g,
    names: names$g
  };

  function iqsfnz(eccent, q) {
    var temp = 1 - (1 - eccent * eccent) / (2 * eccent) * Math.log((1 - eccent) / (1 + eccent));
    if (Math.abs(Math.abs(q) - temp) < 1.0E-6) {
      if (q < 0) {
        return (-1 * HALF_PI);
      }
      else {
        return HALF_PI;
      }
    }
    //var phi = 0.5* q/(1-eccent*eccent);
    var phi = Math.asin(0.5 * q);
    var dphi;
    var sin_phi;
    var cos_phi;
    var con;
    for (var i = 0; i < 30; i++) {
      sin_phi = Math.sin(phi);
      cos_phi = Math.cos(phi);
      con = eccent * sin_phi;
      dphi = Math.pow(1 - con * con, 2) / (2 * cos_phi) * (q / (1 - eccent * eccent) - sin_phi / (1 - con * con) + 0.5 / eccent * Math.log((1 - con) / (1 + con)));
      phi += dphi;
      if (Math.abs(dphi) <= 0.0000000001) {
        return phi;
      }
    }

    //console.log("IQSFN-CONV:Latitude failed to converge after 30 iterations");
    return NaN;
  }

  /*
    reference:
      "Cartographic Projection Procedures for the UNIX Environment-
      A User's Manual" by Gerald I. Evenden,
      USGS Open File Report 90-284and Release 4 Interim Reports (2003)
  */
  function init$f() {
    //no-op
    if (!this.sphere) {
      this.k0 = msfnz(this.e, Math.sin(this.lat_ts), Math.cos(this.lat_ts));
    }
  }

  /* Cylindrical Equal Area forward equations--mapping lat,long to x,y
      ------------------------------------------------------------*/
  function forward$f(p) {
    var lon = p.x;
    var lat = p.y;
    var x, y;
    /* Forward equations
        -----------------*/
    var dlon = adjust_lon(lon - this.long0);
    if (this.sphere) {
      x = this.x0 + this.a * dlon * Math.cos(this.lat_ts);
      y = this.y0 + this.a * Math.sin(lat) / Math.cos(this.lat_ts);
    }
    else {
      var qs = qsfnz(this.e, Math.sin(lat));
      x = this.x0 + this.a * this.k0 * dlon;
      y = this.y0 + this.a * qs * 0.5 / this.k0;
    }

    p.x = x;
    p.y = y;
    return p;
  }

  /* Cylindrical Equal Area inverse equations--mapping x,y to lat/long
      ------------------------------------------------------------*/
  function inverse$f(p) {
    p.x -= this.x0;
    p.y -= this.y0;
    var lon, lat;

    if (this.sphere) {
      lon = adjust_lon(this.long0 + (p.x / this.a) / Math.cos(this.lat_ts));
      lat = Math.asin((p.y / this.a) * Math.cos(this.lat_ts));
    }
    else {
      lat = iqsfnz(this.e, 2 * p.y * this.k0 / this.a);
      lon = adjust_lon(this.long0 + p.x / (this.a * this.k0));
    }

    p.x = lon;
    p.y = lat;
    return p;
  }

  var names$f = ["cea"];
  var cea = {
    init: init$f,
    forward: forward$f,
    inverse: inverse$f,
    names: names$f
  };

  function init$e() {

    this.x0 = this.x0 || 0;
    this.y0 = this.y0 || 0;
    this.lat0 = this.lat0 || 0;
    this.long0 = this.long0 || 0;
    this.lat_ts = this.lat_ts || 0;
    this.title = this.title || "Equidistant Cylindrical (Plate Carre)";

    this.rc = Math.cos(this.lat_ts);
  }

  // forward equations--mapping lat,long to x,y
  // -----------------------------------------------------------------
  function forward$e(p) {

    var lon = p.x;
    var lat = p.y;

    var dlon = adjust_lon(lon - this.long0);
    var dlat = adjust_lat(lat - this.lat0);
    p.x = this.x0 + (this.a * dlon * this.rc);
    p.y = this.y0 + (this.a * dlat);
    return p;
  }

  // inverse equations--mapping x,y to lat/long
  // -----------------------------------------------------------------
  function inverse$e(p) {

    var x = p.x;
    var y = p.y;

    p.x = adjust_lon(this.long0 + ((x - this.x0) / (this.a * this.rc)));
    p.y = adjust_lat(this.lat0 + ((y - this.y0) / (this.a)));
    return p;
  }

  var names$e = ["Equirectangular", "Equidistant_Cylindrical", "eqc"];
  var eqc = {
    init: init$e,
    forward: forward$e,
    inverse: inverse$e,
    names: names$e
  };

  var MAX_ITER$1 = 20;

  function init$d() {
    /* Place parameters in static storage for common use
        -------------------------------------------------*/
    this.temp = this.b / this.a;
    this.es = 1 - Math.pow(this.temp, 2); // devait etre dans tmerc.js mais n y est pas donc je commente sinon retour de valeurs nulles
    this.e = Math.sqrt(this.es);
    this.e0 = e0fn(this.es);
    this.e1 = e1fn(this.es);
    this.e2 = e2fn(this.es);
    this.e3 = e3fn(this.es);
    this.ml0 = this.a * mlfn(this.e0, this.e1, this.e2, this.e3, this.lat0); //si que des zeros le calcul ne se fait pas
  }

  /* Polyconic forward equations--mapping lat,long to x,y
      ---------------------------------------------------*/
  function forward$d(p) {
    var lon = p.x;
    var lat = p.y;
    var x, y, el;
    var dlon = adjust_lon(lon - this.long0);
    el = dlon * Math.sin(lat);
    if (this.sphere) {
      if (Math.abs(lat) <= EPSLN) {
        x = this.a * dlon;
        y = -1 * this.a * this.lat0;
      }
      else {
        x = this.a * Math.sin(el) / Math.tan(lat);
        y = this.a * (adjust_lat(lat - this.lat0) + (1 - Math.cos(el)) / Math.tan(lat));
      }
    }
    else {
      if (Math.abs(lat) <= EPSLN) {
        x = this.a * dlon;
        y = -1 * this.ml0;
      }
      else {
        var nl = gN(this.a, this.e, Math.sin(lat)) / Math.tan(lat);
        x = nl * Math.sin(el);
        y = this.a * mlfn(this.e0, this.e1, this.e2, this.e3, lat) - this.ml0 + nl * (1 - Math.cos(el));
      }

    }
    p.x = x + this.x0;
    p.y = y + this.y0;
    return p;
  }

  /* Inverse equations
    -----------------*/
  function inverse$d(p) {
    var lon, lat, x, y, i;
    var al, bl;
    var phi, dphi;
    x = p.x - this.x0;
    y = p.y - this.y0;

    if (this.sphere) {
      if (Math.abs(y + this.a * this.lat0) <= EPSLN) {
        lon = adjust_lon(x / this.a + this.long0);
        lat = 0;
      }
      else {
        al = this.lat0 + y / this.a;
        bl = x * x / this.a / this.a + al * al;
        phi = al;
        var tanphi;
        for (i = MAX_ITER$1; i; --i) {
          tanphi = Math.tan(phi);
          dphi = -1 * (al * (phi * tanphi + 1) - phi - 0.5 * (phi * phi + bl) * tanphi) / ((phi - al) / tanphi - 1);
          phi += dphi;
          if (Math.abs(dphi) <= EPSLN) {
            lat = phi;
            break;
          }
        }
        lon = adjust_lon(this.long0 + (Math.asin(x * Math.tan(phi) / this.a)) / Math.sin(lat));
      }
    }
    else {
      if (Math.abs(y + this.ml0) <= EPSLN) {
        lat = 0;
        lon = adjust_lon(this.long0 + x / this.a);
      }
      else {

        al = (this.ml0 + y) / this.a;
        bl = x * x / this.a / this.a + al * al;
        phi = al;
        var cl, mln, mlnp, ma;
        var con;
        for (i = MAX_ITER$1; i; --i) {
          con = this.e * Math.sin(phi);
          cl = Math.sqrt(1 - con * con) * Math.tan(phi);
          mln = this.a * mlfn(this.e0, this.e1, this.e2, this.e3, phi);
          mlnp = this.e0 - 2 * this.e1 * Math.cos(2 * phi) + 4 * this.e2 * Math.cos(4 * phi) - 6 * this.e3 * Math.cos(6 * phi);
          ma = mln / this.a;
          dphi = (al * (cl * ma + 1) - ma - 0.5 * cl * (ma * ma + bl)) / (this.es * Math.sin(2 * phi) * (ma * ma + bl - 2 * al * ma) / (4 * cl) + (al - ma) * (cl * mlnp - 2 / Math.sin(2 * phi)) - mlnp);
          phi -= dphi;
          if (Math.abs(dphi) <= EPSLN) {
            lat = phi;
            break;
          }
        }

        //lat=phi4z(this.e,this.e0,this.e1,this.e2,this.e3,al,bl,0,0);
        cl = Math.sqrt(1 - this.es * Math.pow(Math.sin(lat), 2)) * Math.tan(lat);
        lon = adjust_lon(this.long0 + Math.asin(x * cl / this.a) / Math.sin(lat));
      }
    }

    p.x = lon;
    p.y = lat;
    return p;
  }

  var names$d = ["Polyconic", "poly"];
  var poly = {
    init: init$d,
    forward: forward$d,
    inverse: inverse$d,
    names: names$d
  };

  function init$c() {
    this.A = [];
    this.A[1] = 0.6399175073;
    this.A[2] = -0.1358797613;
    this.A[3] = 0.063294409;
    this.A[4] = -0.02526853;
    this.A[5] = 0.0117879;
    this.A[6] = -0.0055161;
    this.A[7] = 0.0026906;
    this.A[8] = -0.001333;
    this.A[9] = 0.00067;
    this.A[10] = -0.00034;

    this.B_re = [];
    this.B_im = [];
    this.B_re[1] = 0.7557853228;
    this.B_im[1] = 0;
    this.B_re[2] = 0.249204646;
    this.B_im[2] = 0.003371507;
    this.B_re[3] = -0.001541739;
    this.B_im[3] = 0.041058560;
    this.B_re[4] = -0.10162907;
    this.B_im[4] = 0.01727609;
    this.B_re[5] = -0.26623489;
    this.B_im[5] = -0.36249218;
    this.B_re[6] = -0.6870983;
    this.B_im[6] = -1.1651967;

    this.C_re = [];
    this.C_im = [];
    this.C_re[1] = 1.3231270439;
    this.C_im[1] = 0;
    this.C_re[2] = -0.577245789;
    this.C_im[2] = -0.007809598;
    this.C_re[3] = 0.508307513;
    this.C_im[3] = -0.112208952;
    this.C_re[4] = -0.15094762;
    this.C_im[4] = 0.18200602;
    this.C_re[5] = 1.01418179;
    this.C_im[5] = 1.64497696;
    this.C_re[6] = 1.9660549;
    this.C_im[6] = 2.5127645;

    this.D = [];
    this.D[1] = 1.5627014243;
    this.D[2] = 0.5185406398;
    this.D[3] = -0.03333098;
    this.D[4] = -0.1052906;
    this.D[5] = -0.0368594;
    this.D[6] = 0.007317;
    this.D[7] = 0.01220;
    this.D[8] = 0.00394;
    this.D[9] = -0.0013;
  }

  /**
      New Zealand Map Grid Forward  - long/lat to x/y
      long/lat in radians
    */
  function forward$c(p) {
    var n;
    var lon = p.x;
    var lat = p.y;

    var delta_lat = lat - this.lat0;
    var delta_lon = lon - this.long0;

    // 1. Calculate d_phi and d_psi    ...                          // and d_lambda
    // For this algorithm, delta_latitude is in seconds of arc x 10-5, so we need to scale to those units. Longitude is radians.
    var d_phi = delta_lat / SEC_TO_RAD * 1E-5;
    var d_lambda = delta_lon;
    var d_phi_n = 1; // d_phi^0

    var d_psi = 0;
    for (n = 1; n <= 10; n++) {
      d_phi_n = d_phi_n * d_phi;
      d_psi = d_psi + this.A[n] * d_phi_n;
    }

    // 2. Calculate theta
    var th_re = d_psi;
    var th_im = d_lambda;

    // 3. Calculate z
    var th_n_re = 1;
    var th_n_im = 0; // theta^0
    var th_n_re1;
    var th_n_im1;

    var z_re = 0;
    var z_im = 0;
    for (n = 1; n <= 6; n++) {
      th_n_re1 = th_n_re * th_re - th_n_im * th_im;
      th_n_im1 = th_n_im * th_re + th_n_re * th_im;
      th_n_re = th_n_re1;
      th_n_im = th_n_im1;
      z_re = z_re + this.B_re[n] * th_n_re - this.B_im[n] * th_n_im;
      z_im = z_im + this.B_im[n] * th_n_re + this.B_re[n] * th_n_im;
    }

    // 4. Calculate easting and northing
    p.x = (z_im * this.a) + this.x0;
    p.y = (z_re * this.a) + this.y0;

    return p;
  }

  /**
      New Zealand Map Grid Inverse  -  x/y to long/lat
    */
  function inverse$c(p) {
    var n;
    var x = p.x;
    var y = p.y;

    var delta_x = x - this.x0;
    var delta_y = y - this.y0;

    // 1. Calculate z
    var z_re = delta_y / this.a;
    var z_im = delta_x / this.a;

    // 2a. Calculate theta - first approximation gives km accuracy
    var z_n_re = 1;
    var z_n_im = 0; // z^0
    var z_n_re1;
    var z_n_im1;

    var th_re = 0;
    var th_im = 0;
    for (n = 1; n <= 6; n++) {
      z_n_re1 = z_n_re * z_re - z_n_im * z_im;
      z_n_im1 = z_n_im * z_re + z_n_re * z_im;
      z_n_re = z_n_re1;
      z_n_im = z_n_im1;
      th_re = th_re + this.C_re[n] * z_n_re - this.C_im[n] * z_n_im;
      th_im = th_im + this.C_im[n] * z_n_re + this.C_re[n] * z_n_im;
    }

    // 2b. Iterate to refine the accuracy of the calculation
    //        0 iterations gives km accuracy
    //        1 iteration gives m accuracy -- good enough for most mapping applications
    //        2 iterations bives mm accuracy
    for (var i = 0; i < this.iterations; i++) {
      var th_n_re = th_re;
      var th_n_im = th_im;
      var th_n_re1;
      var th_n_im1;

      var num_re = z_re;
      var num_im = z_im;
      for (n = 2; n <= 6; n++) {
        th_n_re1 = th_n_re * th_re - th_n_im * th_im;
        th_n_im1 = th_n_im * th_re + th_n_re * th_im;
        th_n_re = th_n_re1;
        th_n_im = th_n_im1;
        num_re = num_re + (n - 1) * (this.B_re[n] * th_n_re - this.B_im[n] * th_n_im);
        num_im = num_im + (n - 1) * (this.B_im[n] * th_n_re + this.B_re[n] * th_n_im);
      }

      th_n_re = 1;
      th_n_im = 0;
      var den_re = this.B_re[1];
      var den_im = this.B_im[1];
      for (n = 2; n <= 6; n++) {
        th_n_re1 = th_n_re * th_re - th_n_im * th_im;
        th_n_im1 = th_n_im * th_re + th_n_re * th_im;
        th_n_re = th_n_re1;
        th_n_im = th_n_im1;
        den_re = den_re + n * (this.B_re[n] * th_n_re - this.B_im[n] * th_n_im);
        den_im = den_im + n * (this.B_im[n] * th_n_re + this.B_re[n] * th_n_im);
      }

      // Complex division
      var den2 = den_re * den_re + den_im * den_im;
      th_re = (num_re * den_re + num_im * den_im) / den2;
      th_im = (num_im * den_re - num_re * den_im) / den2;
    }

    // 3. Calculate d_phi              ...                                    // and d_lambda
    var d_psi = th_re;
    var d_lambda = th_im;
    var d_psi_n = 1; // d_psi^0

    var d_phi = 0;
    for (n = 1; n <= 9; n++) {
      d_psi_n = d_psi_n * d_psi;
      d_phi = d_phi + this.D[n] * d_psi_n;
    }

    // 4. Calculate latitude and longitude
    // d_phi is calcuated in second of arc * 10^-5, so we need to scale back to radians. d_lambda is in radians.
    var lat = this.lat0 + (d_phi * SEC_TO_RAD * 1E5);
    var lon = this.long0 + d_lambda;

    p.x = lon;
    p.y = lat;

    return p;
  }

  var names$c = ["New_Zealand_Map_Grid", "nzmg"];
  var nzmg = {
    init: init$c,
    forward: forward$c,
    inverse: inverse$c,
    names: names$c
  };

  /*
    reference
      "New Equal-Area Map Projections for Noncircular Regions", John P. Snyder,
      The American Cartographer, Vol 15, No. 4, October 1988, pp. 341-355.
    */


  /* Initialize the Miller Cylindrical projection
    -------------------------------------------*/
  function init$b() {
    //no-op
  }

  /* Miller Cylindrical forward equations--mapping lat,long to x,y
      ------------------------------------------------------------*/
  function forward$b(p) {
    var lon = p.x;
    var lat = p.y;
    /* Forward equations
        -----------------*/
    var dlon = adjust_lon(lon - this.long0);
    var x = this.x0 + this.a * dlon;
    var y = this.y0 + this.a * Math.log(Math.tan((Math.PI / 4) + (lat / 2.5))) * 1.25;

    p.x = x;
    p.y = y;
    return p;
  }

  /* Miller Cylindrical inverse equations--mapping x,y to lat/long
      ------------------------------------------------------------*/
  function inverse$b(p) {
    p.x -= this.x0;
    p.y -= this.y0;

    var lon = adjust_lon(this.long0 + p.x / this.a);
    var lat = 2.5 * (Math.atan(Math.exp(0.8 * p.y / this.a)) - Math.PI / 4);

    p.x = lon;
    p.y = lat;
    return p;
  }

  var names$b = ["Miller_Cylindrical", "mill"];
  var mill = {
    init: init$b,
    forward: forward$b,
    inverse: inverse$b,
    names: names$b
  };

  var MAX_ITER = 20;


  function init$a() {
    /* Place parameters in static storage for common use
      -------------------------------------------------*/


    if (!this.sphere) {
      this.en = pj_enfn(this.es);
    }
    else {
      this.n = 1;
      this.m = 0;
      this.es = 0;
      this.C_y = Math.sqrt((this.m + 1) / this.n);
      this.C_x = this.C_y / (this.m + 1);
    }

  }

  /* Sinusoidal forward equations--mapping lat,long to x,y
    -----------------------------------------------------*/
  function forward$a(p) {
    var x, y;
    var lon = p.x;
    var lat = p.y;
    /* Forward equations
      -----------------*/
    lon = adjust_lon(lon - this.long0);

    if (this.sphere) {
      if (!this.m) {
        lat = this.n !== 1 ? Math.asin(this.n * Math.sin(lat)) : lat;
      }
      else {
        var k = this.n * Math.sin(lat);
        for (var i = MAX_ITER; i; --i) {
          var V = (this.m * lat + Math.sin(lat) - k) / (this.m + Math.cos(lat));
          lat -= V;
          if (Math.abs(V) < EPSLN) {
            break;
          }
        }
      }
      x = this.a * this.C_x * lon * (this.m + Math.cos(lat));
      y = this.a * this.C_y * lat;

    }
    else {

      var s = Math.sin(lat);
      var c = Math.cos(lat);
      y = this.a * pj_mlfn(lat, s, c, this.en);
      x = this.a * lon * c / Math.sqrt(1 - this.es * s * s);
    }

    p.x = x;
    p.y = y;
    return p;
  }

  function inverse$a(p) {
    var lat, temp, lon, s;

    p.x -= this.x0;
    lon = p.x / this.a;
    p.y -= this.y0;
    lat = p.y / this.a;

    if (this.sphere) {
      lat /= this.C_y;
      lon = lon / (this.C_x * (this.m + Math.cos(lat)));
      if (this.m) {
        lat = asinz((this.m * lat + Math.sin(lat)) / this.n);
      }
      else if (this.n !== 1) {
        lat = asinz(Math.sin(lat) / this.n);
      }
      lon = adjust_lon(lon + this.long0);
      lat = adjust_lat(lat);
    }
    else {
      lat = pj_inv_mlfn(p.y / this.a, this.es, this.en);
      s = Math.abs(lat);
      if (s < HALF_PI) {
        s = Math.sin(lat);
        temp = this.long0 + p.x * Math.sqrt(1 - this.es * s * s) / (this.a * Math.cos(lat));
        //temp = this.long0 + p.x / (this.a * Math.cos(lat));
        lon = adjust_lon(temp);
      }
      else if ((s - EPSLN) < HALF_PI) {
        lon = this.long0;
      }
    }
    p.x = lon;
    p.y = lat;
    return p;
  }

  var names$a = ["Sinusoidal", "sinu"];
  var sinu = {
    init: init$a,
    forward: forward$a,
    inverse: inverse$a,
    names: names$a
  };

  function init$9() {}
  /* Mollweide forward equations--mapping lat,long to x,y
      ----------------------------------------------------*/
  function forward$9(p) {

    /* Forward equations
        -----------------*/
    var lon = p.x;
    var lat = p.y;

    var delta_lon = adjust_lon(lon - this.long0);
    var theta = lat;
    var con = Math.PI * Math.sin(lat);

    /* Iterate using the Newton-Raphson method to find theta
        -----------------------------------------------------*/
    while (true) {
      var delta_theta = -(theta + Math.sin(theta) - con) / (1 + Math.cos(theta));
      theta += delta_theta;
      if (Math.abs(delta_theta) < EPSLN) {
        break;
      }
    }
    theta /= 2;

    /* If the latitude is 90 deg, force the x coordinate to be "0 + false easting"
         this is done here because of precision problems with "cos(theta)"
         --------------------------------------------------------------------------*/
    if (Math.PI / 2 - Math.abs(lat) < EPSLN) {
      delta_lon = 0;
    }
    var x = 0.900316316158 * this.a * delta_lon * Math.cos(theta) + this.x0;
    var y = 1.4142135623731 * this.a * Math.sin(theta) + this.y0;

    p.x = x;
    p.y = y;
    return p;
  }

  function inverse$9(p) {
    var theta;
    var arg;

    /* Inverse equations
        -----------------*/
    p.x -= this.x0;
    p.y -= this.y0;
    arg = p.y / (1.4142135623731 * this.a);

    /* Because of division by zero problems, 'arg' can not be 1.  Therefore
         a number very close to one is used instead.
         -------------------------------------------------------------------*/
    if (Math.abs(arg) > 0.999999999999) {
      arg = 0.999999999999;
    }
    theta = Math.asin(arg);
    var lon = adjust_lon(this.long0 + (p.x / (0.900316316158 * this.a * Math.cos(theta))));
    if (lon < (-Math.PI)) {
      lon = -Math.PI;
    }
    if (lon > Math.PI) {
      lon = Math.PI;
    }
    arg = (2 * theta + Math.sin(2 * theta)) / Math.PI;
    if (Math.abs(arg) > 1) {
      arg = 1;
    }
    var lat = Math.asin(arg);

    p.x = lon;
    p.y = lat;
    return p;
  }

  var names$9 = ["Mollweide", "moll"];
  var moll = {
    init: init$9,
    forward: forward$9,
    inverse: inverse$9,
    names: names$9
  };

  function init$8() {

    /* Place parameters in static storage for common use
        -------------------------------------------------*/
    // Standard Parallels cannot be equal and on opposite sides of the equator
    if (Math.abs(this.lat1 + this.lat2) < EPSLN) {
      return;
    }
    this.lat2 = this.lat2 || this.lat1;
    this.temp = this.b / this.a;
    this.es = 1 - Math.pow(this.temp, 2);
    this.e = Math.sqrt(this.es);
    this.e0 = e0fn(this.es);
    this.e1 = e1fn(this.es);
    this.e2 = e2fn(this.es);
    this.e3 = e3fn(this.es);

    this.sinphi = Math.sin(this.lat1);
    this.cosphi = Math.cos(this.lat1);

    this.ms1 = msfnz(this.e, this.sinphi, this.cosphi);
    this.ml1 = mlfn(this.e0, this.e1, this.e2, this.e3, this.lat1);

    if (Math.abs(this.lat1 - this.lat2) < EPSLN) {
      this.ns = this.sinphi;
    }
    else {
      this.sinphi = Math.sin(this.lat2);
      this.cosphi = Math.cos(this.lat2);
      this.ms2 = msfnz(this.e, this.sinphi, this.cosphi);
      this.ml2 = mlfn(this.e0, this.e1, this.e2, this.e3, this.lat2);
      this.ns = (this.ms1 - this.ms2) / (this.ml2 - this.ml1);
    }
    this.g = this.ml1 + this.ms1 / this.ns;
    this.ml0 = mlfn(this.e0, this.e1, this.e2, this.e3, this.lat0);
    this.rh = this.a * (this.g - this.ml0);
  }

  /* Equidistant Conic forward equations--mapping lat,long to x,y
    -----------------------------------------------------------*/
  function forward$8(p) {
    var lon = p.x;
    var lat = p.y;
    var rh1;

    /* Forward equations
        -----------------*/
    if (this.sphere) {
      rh1 = this.a * (this.g - lat);
    }
    else {
      var ml = mlfn(this.e0, this.e1, this.e2, this.e3, lat);
      rh1 = this.a * (this.g - ml);
    }
    var theta = this.ns * adjust_lon(lon - this.long0);
    var x = this.x0 + rh1 * Math.sin(theta);
    var y = this.y0 + this.rh - rh1 * Math.cos(theta);
    p.x = x;
    p.y = y;
    return p;
  }

  /* Inverse equations
    -----------------*/
  function inverse$8(p) {
    p.x -= this.x0;
    p.y = this.rh - p.y + this.y0;
    var con, rh1, lat, lon;
    if (this.ns >= 0) {
      rh1 = Math.sqrt(p.x * p.x + p.y * p.y);
      con = 1;
    }
    else {
      rh1 = -Math.sqrt(p.x * p.x + p.y * p.y);
      con = -1;
    }
    var theta = 0;
    if (rh1 !== 0) {
      theta = Math.atan2(con * p.x, con * p.y);
    }

    if (this.sphere) {
      lon = adjust_lon(this.long0 + theta / this.ns);
      lat = adjust_lat(this.g - rh1 / this.a);
      p.x = lon;
      p.y = lat;
      return p;
    }
    else {
      var ml = this.g - rh1 / this.a;
      lat = imlfn(ml, this.e0, this.e1, this.e2, this.e3);
      lon = adjust_lon(this.long0 + theta / this.ns);
      p.x = lon;
      p.y = lat;
      return p;
    }

  }

  var names$8 = ["Equidistant_Conic", "eqdc"];
  var eqdc = {
    init: init$8,
    forward: forward$8,
    inverse: inverse$8,
    names: names$8
  };

  /* Initialize the Van Der Grinten projection
    ----------------------------------------*/
  function init$7() {
    //this.R = 6370997; //Radius of earth
    this.R = this.a;
  }

  function forward$7(p) {

    var lon = p.x;
    var lat = p.y;

    /* Forward equations
      -----------------*/
    var dlon = adjust_lon(lon - this.long0);
    var x, y;

    if (Math.abs(lat) <= EPSLN) {
      x = this.x0 + this.R * dlon;
      y = this.y0;
    }
    var theta = asinz(2 * Math.abs(lat / Math.PI));
    if ((Math.abs(dlon) <= EPSLN) || (Math.abs(Math.abs(lat) - HALF_PI) <= EPSLN)) {
      x = this.x0;
      if (lat >= 0) {
        y = this.y0 + Math.PI * this.R * Math.tan(0.5 * theta);
      }
      else {
        y = this.y0 + Math.PI * this.R * -Math.tan(0.5 * theta);
      }
      //  return(OK);
    }
    var al = 0.5 * Math.abs((Math.PI / dlon) - (dlon / Math.PI));
    var asq = al * al;
    var sinth = Math.sin(theta);
    var costh = Math.cos(theta);

    var g = costh / (sinth + costh - 1);
    var gsq = g * g;
    var m = g * (2 / sinth - 1);
    var msq = m * m;
    var con = Math.PI * this.R * (al * (g - msq) + Math.sqrt(asq * (g - msq) * (g - msq) - (msq + asq) * (gsq - msq))) / (msq + asq);
    if (dlon < 0) {
      con = -con;
    }
    x = this.x0 + con;
    //con = Math.abs(con / (Math.PI * this.R));
    var q = asq + g;
    con = Math.PI * this.R * (m * q - al * Math.sqrt((msq + asq) * (asq + 1) - q * q)) / (msq + asq);
    if (lat >= 0) {
      //y = this.y0 + Math.PI * this.R * Math.sqrt(1 - con * con - 2 * al * con);
      y = this.y0 + con;
    }
    else {
      //y = this.y0 - Math.PI * this.R * Math.sqrt(1 - con * con - 2 * al * con);
      y = this.y0 - con;
    }
    p.x = x;
    p.y = y;
    return p;
  }

  /* Van Der Grinten inverse equations--mapping x,y to lat/long
    ---------------------------------------------------------*/
  function inverse$7(p) {
    var lon, lat;
    var xx, yy, xys, c1, c2, c3;
    var a1;
    var m1;
    var con;
    var th1;
    var d;

    /* inverse equations
      -----------------*/
    p.x -= this.x0;
    p.y -= this.y0;
    con = Math.PI * this.R;
    xx = p.x / con;
    yy = p.y / con;
    xys = xx * xx + yy * yy;
    c1 = -Math.abs(yy) * (1 + xys);
    c2 = c1 - 2 * yy * yy + xx * xx;
    c3 = -2 * c1 + 1 + 2 * yy * yy + xys * xys;
    d = yy * yy / c3 + (2 * c2 * c2 * c2 / c3 / c3 / c3 - 9 * c1 * c2 / c3 / c3) / 27;
    a1 = (c1 - c2 * c2 / 3 / c3) / c3;
    m1 = 2 * Math.sqrt(-a1 / 3);
    con = ((3 * d) / a1) / m1;
    if (Math.abs(con) > 1) {
      if (con >= 0) {
        con = 1;
      }
      else {
        con = -1;
      }
    }
    th1 = Math.acos(con) / 3;
    if (p.y >= 0) {
      lat = (-m1 * Math.cos(th1 + Math.PI / 3) - c2 / 3 / c3) * Math.PI;
    }
    else {
      lat = -(-m1 * Math.cos(th1 + Math.PI / 3) - c2 / 3 / c3) * Math.PI;
    }

    if (Math.abs(xx) < EPSLN) {
      lon = this.long0;
    }
    else {
      lon = adjust_lon(this.long0 + Math.PI * (xys - 1 + Math.sqrt(1 + 2 * (xx * xx - yy * yy) + xys * xys)) / 2 / xx);
    }

    p.x = lon;
    p.y = lat;
    return p;
  }

  var names$7 = ["Van_der_Grinten_I", "VanDerGrinten", "vandg"];
  var vandg = {
    init: init$7,
    forward: forward$7,
    inverse: inverse$7,
    names: names$7
  };

  function init$6() {
    this.sin_p12 = Math.sin(this.lat0);
    this.cos_p12 = Math.cos(this.lat0);
  }

  function forward$6(p) {
    var lon = p.x;
    var lat = p.y;
    var sinphi = Math.sin(p.y);
    var cosphi = Math.cos(p.y);
    var dlon = adjust_lon(lon - this.long0);
    var e0, e1, e2, e3, Mlp, Ml, tanphi, Nl1, Nl, psi, Az, G, H, GH, Hs, c, kp, cos_c, s, s2, s3, s4, s5;
    if (this.sphere) {
      if (Math.abs(this.sin_p12 - 1) <= EPSLN) {
        //North Pole case
        p.x = this.x0 + this.a * (HALF_PI - lat) * Math.sin(dlon);
        p.y = this.y0 - this.a * (HALF_PI - lat) * Math.cos(dlon);
        return p;
      }
      else if (Math.abs(this.sin_p12 + 1) <= EPSLN) {
        //South Pole case
        p.x = this.x0 + this.a * (HALF_PI + lat) * Math.sin(dlon);
        p.y = this.y0 + this.a * (HALF_PI + lat) * Math.cos(dlon);
        return p;
      }
      else {
        //default case
        cos_c = this.sin_p12 * sinphi + this.cos_p12 * cosphi * Math.cos(dlon);
        c = Math.acos(cos_c);
        kp = c ? c / Math.sin(c) : 1;
        p.x = this.x0 + this.a * kp * cosphi * Math.sin(dlon);
        p.y = this.y0 + this.a * kp * (this.cos_p12 * sinphi - this.sin_p12 * cosphi * Math.cos(dlon));
        return p;
      }
    }
    else {
      e0 = e0fn(this.es);
      e1 = e1fn(this.es);
      e2 = e2fn(this.es);
      e3 = e3fn(this.es);
      if (Math.abs(this.sin_p12 - 1) <= EPSLN) {
        //North Pole case
        Mlp = this.a * mlfn(e0, e1, e2, e3, HALF_PI);
        Ml = this.a * mlfn(e0, e1, e2, e3, lat);
        p.x = this.x0 + (Mlp - Ml) * Math.sin(dlon);
        p.y = this.y0 - (Mlp - Ml) * Math.cos(dlon);
        return p;
      }
      else if (Math.abs(this.sin_p12 + 1) <= EPSLN) {
        //South Pole case
        Mlp = this.a * mlfn(e0, e1, e2, e3, HALF_PI);
        Ml = this.a * mlfn(e0, e1, e2, e3, lat);
        p.x = this.x0 + (Mlp + Ml) * Math.sin(dlon);
        p.y = this.y0 + (Mlp + Ml) * Math.cos(dlon);
        return p;
      }
      else {
        //Default case
        tanphi = sinphi / cosphi;
        Nl1 = gN(this.a, this.e, this.sin_p12);
        Nl = gN(this.a, this.e, sinphi);
        psi = Math.atan((1 - this.es) * tanphi + this.es * Nl1 * this.sin_p12 / (Nl * cosphi));
        Az = Math.atan2(Math.sin(dlon), this.cos_p12 * Math.tan(psi) - this.sin_p12 * Math.cos(dlon));
        if (Az === 0) {
          s = Math.asin(this.cos_p12 * Math.sin(psi) - this.sin_p12 * Math.cos(psi));
        }
        else if (Math.abs(Math.abs(Az) - Math.PI) <= EPSLN) {
          s = -Math.asin(this.cos_p12 * Math.sin(psi) - this.sin_p12 * Math.cos(psi));
        }
        else {
          s = Math.asin(Math.sin(dlon) * Math.cos(psi) / Math.sin(Az));
        }
        G = this.e * this.sin_p12 / Math.sqrt(1 - this.es);
        H = this.e * this.cos_p12 * Math.cos(Az) / Math.sqrt(1 - this.es);
        GH = G * H;
        Hs = H * H;
        s2 = s * s;
        s3 = s2 * s;
        s4 = s3 * s;
        s5 = s4 * s;
        c = Nl1 * s * (1 - s2 * Hs * (1 - Hs) / 6 + s3 / 8 * GH * (1 - 2 * Hs) + s4 / 120 * (Hs * (4 - 7 * Hs) - 3 * G * G * (1 - 7 * Hs)) - s5 / 48 * GH);
        p.x = this.x0 + c * Math.sin(Az);
        p.y = this.y0 + c * Math.cos(Az);
        return p;
      }
    }


  }

  function inverse$6(p) {
    p.x -= this.x0;
    p.y -= this.y0;
    var rh, z, sinz, cosz, lon, lat, con, e0, e1, e2, e3, Mlp, M, N1, psi, Az, cosAz, tmp, A, B, D, Ee, F, sinpsi;
    if (this.sphere) {
      rh = Math.sqrt(p.x * p.x + p.y * p.y);
      if (rh > (2 * HALF_PI * this.a)) {
        return;
      }
      z = rh / this.a;

      sinz = Math.sin(z);
      cosz = Math.cos(z);

      lon = this.long0;
      if (Math.abs(rh) <= EPSLN) {
        lat = this.lat0;
      }
      else {
        lat = asinz(cosz * this.sin_p12 + (p.y * sinz * this.cos_p12) / rh);
        con = Math.abs(this.lat0) - HALF_PI;
        if (Math.abs(con) <= EPSLN) {
          if (this.lat0 >= 0) {
            lon = adjust_lon(this.long0 + Math.atan2(p.x, - p.y));
          }
          else {
            lon = adjust_lon(this.long0 - Math.atan2(-p.x, p.y));
          }
        }
        else {
          /*con = cosz - this.sin_p12 * Math.sin(lat);
          if ((Math.abs(con) < EPSLN) && (Math.abs(p.x) < EPSLN)) {
            //no-op, just keep the lon value as is
          } else {
            var temp = Math.atan2((p.x * sinz * this.cos_p12), (con * rh));
            lon = adjust_lon(this.long0 + Math.atan2((p.x * sinz * this.cos_p12), (con * rh)));
          }*/
          lon = adjust_lon(this.long0 + Math.atan2(p.x * sinz, rh * this.cos_p12 * cosz - p.y * this.sin_p12 * sinz));
        }
      }

      p.x = lon;
      p.y = lat;
      return p;
    }
    else {
      e0 = e0fn(this.es);
      e1 = e1fn(this.es);
      e2 = e2fn(this.es);
      e3 = e3fn(this.es);
      if (Math.abs(this.sin_p12 - 1) <= EPSLN) {
        //North pole case
        Mlp = this.a * mlfn(e0, e1, e2, e3, HALF_PI);
        rh = Math.sqrt(p.x * p.x + p.y * p.y);
        M = Mlp - rh;
        lat = imlfn(M / this.a, e0, e1, e2, e3);
        lon = adjust_lon(this.long0 + Math.atan2(p.x, - 1 * p.y));
        p.x = lon;
        p.y = lat;
        return p;
      }
      else if (Math.abs(this.sin_p12 + 1) <= EPSLN) {
        //South pole case
        Mlp = this.a * mlfn(e0, e1, e2, e3, HALF_PI);
        rh = Math.sqrt(p.x * p.x + p.y * p.y);
        M = rh - Mlp;

        lat = imlfn(M / this.a, e0, e1, e2, e3);
        lon = adjust_lon(this.long0 + Math.atan2(p.x, p.y));
        p.x = lon;
        p.y = lat;
        return p;
      }
      else {
        //default case
        rh = Math.sqrt(p.x * p.x + p.y * p.y);
        Az = Math.atan2(p.x, p.y);
        N1 = gN(this.a, this.e, this.sin_p12);
        cosAz = Math.cos(Az);
        tmp = this.e * this.cos_p12 * cosAz;
        A = -tmp * tmp / (1 - this.es);
        B = 3 * this.es * (1 - A) * this.sin_p12 * this.cos_p12 * cosAz / (1 - this.es);
        D = rh / N1;
        Ee = D - A * (1 + A) * Math.pow(D, 3) / 6 - B * (1 + 3 * A) * Math.pow(D, 4) / 24;
        F = 1 - A * Ee * Ee / 2 - D * Ee * Ee * Ee / 6;
        psi = Math.asin(this.sin_p12 * Math.cos(Ee) + this.cos_p12 * Math.sin(Ee) * cosAz);
        lon = adjust_lon(this.long0 + Math.asin(Math.sin(Az) * Math.sin(Ee) / Math.cos(psi)));
        sinpsi = Math.sin(psi);
        lat = Math.atan2((sinpsi - this.es * F * this.sin_p12) * Math.tan(psi), sinpsi * (1 - this.es));
        p.x = lon;
        p.y = lat;
        return p;
      }
    }

  }

  var names$6 = ["Azimuthal_Equidistant", "aeqd"];
  var aeqd = {
    init: init$6,
    forward: forward$6,
    inverse: inverse$6,
    names: names$6
  };

  function init$5() {
    //double temp;      /* temporary variable    */

    /* Place parameters in static storage for common use
        -------------------------------------------------*/
    this.sin_p14 = Math.sin(this.lat0);
    this.cos_p14 = Math.cos(this.lat0);
  }

  /* Orthographic forward equations--mapping lat,long to x,y
      ---------------------------------------------------*/
  function forward$5(p) {
    var sinphi, cosphi; /* sin and cos value        */
    var dlon; /* delta longitude value      */
    var coslon; /* cos of longitude        */
    var ksp; /* scale factor          */
    var g, x, y;
    var lon = p.x;
    var lat = p.y;
    /* Forward equations
        -----------------*/
    dlon = adjust_lon(lon - this.long0);

    sinphi = Math.sin(lat);
    cosphi = Math.cos(lat);

    coslon = Math.cos(dlon);
    g = this.sin_p14 * sinphi + this.cos_p14 * cosphi * coslon;
    ksp = 1;
    if ((g > 0) || (Math.abs(g) <= EPSLN)) {
      x = this.a * ksp * cosphi * Math.sin(dlon);
      y = this.y0 + this.a * ksp * (this.cos_p14 * sinphi - this.sin_p14 * cosphi * coslon);
    }
    p.x = x;
    p.y = y;
    return p;
  }

  function inverse$5(p) {
    var rh; /* height above ellipsoid      */
    var z; /* angle          */
    var sinz, cosz; /* sin of z and cos of z      */
    var con;
    var lon, lat;
    /* Inverse equations
        -----------------*/
    p.x -= this.x0;
    p.y -= this.y0;
    rh = Math.sqrt(p.x * p.x + p.y * p.y);
    z = asinz(rh / this.a);

    sinz = Math.sin(z);
    cosz = Math.cos(z);

    lon = this.long0;
    if (Math.abs(rh) <= EPSLN) {
      lat = this.lat0;
      p.x = lon;
      p.y = lat;
      return p;
    }
    lat = asinz(cosz * this.sin_p14 + (p.y * sinz * this.cos_p14) / rh);
    con = Math.abs(this.lat0) - HALF_PI;
    if (Math.abs(con) <= EPSLN) {
      if (this.lat0 >= 0) {
        lon = adjust_lon(this.long0 + Math.atan2(p.x, - p.y));
      }
      else {
        lon = adjust_lon(this.long0 - Math.atan2(-p.x, p.y));
      }
      p.x = lon;
      p.y = lat;
      return p;
    }
    lon = adjust_lon(this.long0 + Math.atan2((p.x * sinz), rh * this.cos_p14 * cosz - p.y * this.sin_p14 * sinz));
    p.x = lon;
    p.y = lat;
    return p;
  }

  var names$5 = ["ortho"];
  var ortho = {
    init: init$5,
    forward: forward$5,
    inverse: inverse$5,
    names: names$5
  };

  // QSC projection rewritten from the original PROJ4
  // https://github.com/OSGeo/proj.4/blob/master/src/PJ_qsc.c


  /* constants */
  var FACE_ENUM = {
      FRONT: 1,
      RIGHT: 2,
      BACK: 3,
      LEFT: 4,
      TOP: 5,
      BOTTOM: 6
  };

  var AREA_ENUM = {
      AREA_0: 1,
      AREA_1: 2,
      AREA_2: 3,
      AREA_3: 4
  };

  function init$4() {

    this.x0 = this.x0 || 0;
    this.y0 = this.y0 || 0;
    this.lat0 = this.lat0 || 0;
    this.long0 = this.long0 || 0;
    this.lat_ts = this.lat_ts || 0;
    this.title = this.title || "Quadrilateralized Spherical Cube";

    /* Determine the cube face from the center of projection. */
    if (this.lat0 >= HALF_PI - FORTPI / 2.0) {
      this.face = FACE_ENUM.TOP;
    } else if (this.lat0 <= -(HALF_PI - FORTPI / 2.0)) {
      this.face = FACE_ENUM.BOTTOM;
    } else if (Math.abs(this.long0) <= FORTPI) {
      this.face = FACE_ENUM.FRONT;
    } else if (Math.abs(this.long0) <= HALF_PI + FORTPI) {
      this.face = this.long0 > 0.0 ? FACE_ENUM.RIGHT : FACE_ENUM.LEFT;
    } else {
      this.face = FACE_ENUM.BACK;
    }

    /* Fill in useful values for the ellipsoid <-> sphere shift
     * described in [LK12]. */
    if (this.es !== 0) {
      this.one_minus_f = 1 - (this.a - this.b) / this.a;
      this.one_minus_f_squared = this.one_minus_f * this.one_minus_f;
    }
  }

  // QSC forward equations--mapping lat,long to x,y
  // -----------------------------------------------------------------
  function forward$4(p) {
    var xy = {x: 0, y: 0};
    var lat, lon;
    var theta, phi;
    var t, mu;
    /* nu; */
    var area = {value: 0};

    // move lon according to projection's lon
    p.x -= this.long0;

    /* Convert the geodetic latitude to a geocentric latitude.
     * This corresponds to the shift from the ellipsoid to the sphere
     * described in [LK12]. */
    if (this.es !== 0) {//if (P->es != 0) {
      lat = Math.atan(this.one_minus_f_squared * Math.tan(p.y));
    } else {
      lat = p.y;
    }

    /* Convert the input lat, lon into theta, phi as used by QSC.
     * This depends on the cube face and the area on it.
     * For the top and bottom face, we can compute theta and phi
     * directly from phi, lam. For the other faces, we must use
     * unit sphere cartesian coordinates as an intermediate step. */
    lon = p.x; //lon = lp.lam;
    if (this.face === FACE_ENUM.TOP) {
      phi = HALF_PI - lat;
      if (lon >= FORTPI && lon <= HALF_PI + FORTPI) {
        area.value = AREA_ENUM.AREA_0;
        theta = lon - HALF_PI;
      } else if (lon > HALF_PI + FORTPI || lon <= -(HALF_PI + FORTPI)) {
        area.value = AREA_ENUM.AREA_1;
        theta = (lon > 0.0 ? lon - SPI : lon + SPI);
      } else if (lon > -(HALF_PI + FORTPI) && lon <= -FORTPI) {
        area.value = AREA_ENUM.AREA_2;
        theta = lon + HALF_PI;
      } else {
        area.value = AREA_ENUM.AREA_3;
        theta = lon;
      }
    } else if (this.face === FACE_ENUM.BOTTOM) {
      phi = HALF_PI + lat;
      if (lon >= FORTPI && lon <= HALF_PI + FORTPI) {
        area.value = AREA_ENUM.AREA_0;
        theta = -lon + HALF_PI;
      } else if (lon < FORTPI && lon >= -FORTPI) {
        area.value = AREA_ENUM.AREA_1;
        theta = -lon;
      } else if (lon < -FORTPI && lon >= -(HALF_PI + FORTPI)) {
        area.value = AREA_ENUM.AREA_2;
        theta = -lon - HALF_PI;
      } else {
        area.value = AREA_ENUM.AREA_3;
        theta = (lon > 0.0 ? -lon + SPI : -lon - SPI);
      }
    } else {
      var q, r, s;
      var sinlat, coslat;
      var sinlon, coslon;

      if (this.face === FACE_ENUM.RIGHT) {
        lon = qsc_shift_lon_origin(lon, +HALF_PI);
      } else if (this.face === FACE_ENUM.BACK) {
        lon = qsc_shift_lon_origin(lon, +SPI);
      } else if (this.face === FACE_ENUM.LEFT) {
        lon = qsc_shift_lon_origin(lon, -HALF_PI);
      }
      sinlat = Math.sin(lat);
      coslat = Math.cos(lat);
      sinlon = Math.sin(lon);
      coslon = Math.cos(lon);
      q = coslat * coslon;
      r = coslat * sinlon;
      s = sinlat;

      if (this.face === FACE_ENUM.FRONT) {
        phi = Math.acos(q);
        theta = qsc_fwd_equat_face_theta(phi, s, r, area);
      } else if (this.face === FACE_ENUM.RIGHT) {
        phi = Math.acos(r);
        theta = qsc_fwd_equat_face_theta(phi, s, -q, area);
      } else if (this.face === FACE_ENUM.BACK) {
        phi = Math.acos(-q);
        theta = qsc_fwd_equat_face_theta(phi, s, -r, area);
      } else if (this.face === FACE_ENUM.LEFT) {
        phi = Math.acos(-r);
        theta = qsc_fwd_equat_face_theta(phi, s, q, area);
      } else {
        /* Impossible */
        phi = theta = 0;
        area.value = AREA_ENUM.AREA_0;
      }
    }

    /* Compute mu and nu for the area of definition.
     * For mu, see Eq. (3-21) in [OL76], but note the typos:
     * compare with Eq. (3-14). For nu, see Eq. (3-38). */
    mu = Math.atan((12 / SPI) * (theta + Math.acos(Math.sin(theta) * Math.cos(FORTPI)) - HALF_PI));
    t = Math.sqrt((1 - Math.cos(phi)) / (Math.cos(mu) * Math.cos(mu)) / (1 - Math.cos(Math.atan(1 / Math.cos(theta)))));

    /* Apply the result to the real area. */
    if (area.value === AREA_ENUM.AREA_1) {
      mu += HALF_PI;
    } else if (area.value === AREA_ENUM.AREA_2) {
      mu += SPI;
    } else if (area.value === AREA_ENUM.AREA_3) {
      mu += 1.5 * SPI;
    }

    /* Now compute x, y from mu and nu */
    xy.x = t * Math.cos(mu);
    xy.y = t * Math.sin(mu);
    xy.x = xy.x * this.a + this.x0;
    xy.y = xy.y * this.a + this.y0;

    p.x = xy.x;
    p.y = xy.y;
    return p;
  }

  // QSC inverse equations--mapping x,y to lat/long
  // -----------------------------------------------------------------
  function inverse$4(p) {
    var lp = {lam: 0, phi: 0};
    var mu, nu, cosmu, tannu;
    var tantheta, theta, cosphi, phi;
    var t;
    var area = {value: 0};

    /* de-offset */
    p.x = (p.x - this.x0) / this.a;
    p.y = (p.y - this.y0) / this.a;

    /* Convert the input x, y to the mu and nu angles as used by QSC.
     * This depends on the area of the cube face. */
    nu = Math.atan(Math.sqrt(p.x * p.x + p.y * p.y));
    mu = Math.atan2(p.y, p.x);
    if (p.x >= 0.0 && p.x >= Math.abs(p.y)) {
      area.value = AREA_ENUM.AREA_0;
    } else if (p.y >= 0.0 && p.y >= Math.abs(p.x)) {
      area.value = AREA_ENUM.AREA_1;
      mu -= HALF_PI;
    } else if (p.x < 0.0 && -p.x >= Math.abs(p.y)) {
      area.value = AREA_ENUM.AREA_2;
      mu = (mu < 0.0 ? mu + SPI : mu - SPI);
    } else {
      area.value = AREA_ENUM.AREA_3;
      mu += HALF_PI;
    }

    /* Compute phi and theta for the area of definition.
     * The inverse projection is not described in the original paper, but some
     * good hints can be found here (as of 2011-12-14):
     * http://fits.gsfc.nasa.gov/fitsbits/saf.93/saf.9302
     * (search for "Message-Id: <9302181759.AA25477 at fits.cv.nrao.edu>") */
    t = (SPI / 12) * Math.tan(mu);
    tantheta = Math.sin(t) / (Math.cos(t) - (1 / Math.sqrt(2)));
    theta = Math.atan(tantheta);
    cosmu = Math.cos(mu);
    tannu = Math.tan(nu);
    cosphi = 1 - cosmu * cosmu * tannu * tannu * (1 - Math.cos(Math.atan(1 / Math.cos(theta))));
    if (cosphi < -1) {
      cosphi = -1;
    } else if (cosphi > +1) {
      cosphi = +1;
    }

    /* Apply the result to the real area on the cube face.
     * For the top and bottom face, we can compute phi and lam directly.
     * For the other faces, we must use unit sphere cartesian coordinates
     * as an intermediate step. */
    if (this.face === FACE_ENUM.TOP) {
      phi = Math.acos(cosphi);
      lp.phi = HALF_PI - phi;
      if (area.value === AREA_ENUM.AREA_0) {
        lp.lam = theta + HALF_PI;
      } else if (area.value === AREA_ENUM.AREA_1) {
        lp.lam = (theta < 0.0 ? theta + SPI : theta - SPI);
      } else if (area.value === AREA_ENUM.AREA_2) {
        lp.lam = theta - HALF_PI;
      } else /* area.value == AREA_ENUM.AREA_3 */ {
        lp.lam = theta;
      }
    } else if (this.face === FACE_ENUM.BOTTOM) {
      phi = Math.acos(cosphi);
      lp.phi = phi - HALF_PI;
      if (area.value === AREA_ENUM.AREA_0) {
        lp.lam = -theta + HALF_PI;
      } else if (area.value === AREA_ENUM.AREA_1) {
        lp.lam = -theta;
      } else if (area.value === AREA_ENUM.AREA_2) {
        lp.lam = -theta - HALF_PI;
      } else /* area.value == AREA_ENUM.AREA_3 */ {
        lp.lam = (theta < 0.0 ? -theta - SPI : -theta + SPI);
      }
    } else {
      /* Compute phi and lam via cartesian unit sphere coordinates. */
      var q, r, s;
      q = cosphi;
      t = q * q;
      if (t >= 1) {
        s = 0;
      } else {
        s = Math.sqrt(1 - t) * Math.sin(theta);
      }
      t += s * s;
      if (t >= 1) {
        r = 0;
      } else {
        r = Math.sqrt(1 - t);
      }
      /* Rotate q,r,s into the correct area. */
      if (area.value === AREA_ENUM.AREA_1) {
        t = r;
        r = -s;
        s = t;
      } else if (area.value === AREA_ENUM.AREA_2) {
        r = -r;
        s = -s;
      } else if (area.value === AREA_ENUM.AREA_3) {
        t = r;
        r = s;
        s = -t;
      }
      /* Rotate q,r,s into the correct cube face. */
      if (this.face === FACE_ENUM.RIGHT) {
        t = q;
        q = -r;
        r = t;
      } else if (this.face === FACE_ENUM.BACK) {
        q = -q;
        r = -r;
      } else if (this.face === FACE_ENUM.LEFT) {
        t = q;
        q = r;
        r = -t;
      }
      /* Now compute phi and lam from the unit sphere coordinates. */
      lp.phi = Math.acos(-s) - HALF_PI;
      lp.lam = Math.atan2(r, q);
      if (this.face === FACE_ENUM.RIGHT) {
        lp.lam = qsc_shift_lon_origin(lp.lam, -HALF_PI);
      } else if (this.face === FACE_ENUM.BACK) {
        lp.lam = qsc_shift_lon_origin(lp.lam, -SPI);
      } else if (this.face === FACE_ENUM.LEFT) {
        lp.lam = qsc_shift_lon_origin(lp.lam, +HALF_PI);
      }
    }

    /* Apply the shift from the sphere to the ellipsoid as described
     * in [LK12]. */
    if (this.es !== 0) {
      var invert_sign;
      var tanphi, xa;
      invert_sign = (lp.phi < 0 ? 1 : 0);
      tanphi = Math.tan(lp.phi);
      xa = this.b / Math.sqrt(tanphi * tanphi + this.one_minus_f_squared);
      lp.phi = Math.atan(Math.sqrt(this.a * this.a - xa * xa) / (this.one_minus_f * xa));
      if (invert_sign) {
        lp.phi = -lp.phi;
      }
    }

    lp.lam += this.long0;
    p.x = lp.lam;
    p.y = lp.phi;
    return p;
  }

  /* Helper function for forward projection: compute the theta angle
   * and determine the area number. */
  function qsc_fwd_equat_face_theta(phi, y, x, area) {
    var theta;
    if (phi < EPSLN) {
      area.value = AREA_ENUM.AREA_0;
      theta = 0.0;
    } else {
      theta = Math.atan2(y, x);
      if (Math.abs(theta) <= FORTPI) {
        area.value = AREA_ENUM.AREA_0;
      } else if (theta > FORTPI && theta <= HALF_PI + FORTPI) {
        area.value = AREA_ENUM.AREA_1;
        theta -= HALF_PI;
      } else if (theta > HALF_PI + FORTPI || theta <= -(HALF_PI + FORTPI)) {
        area.value = AREA_ENUM.AREA_2;
        theta = (theta >= 0.0 ? theta - SPI : theta + SPI);
      } else {
        area.value = AREA_ENUM.AREA_3;
        theta += HALF_PI;
      }
    }
    return theta;
  }

  /* Helper function: shift the longitude. */
  function qsc_shift_lon_origin(lon, offset) {
    var slon = lon + offset;
    if (slon < -SPI) {
      slon += TWO_PI;
    } else if (slon > +SPI) {
      slon -= TWO_PI;
    }
    return slon;
  }

  var names$4 = ["Quadrilateralized Spherical Cube", "Quadrilateralized_Spherical_Cube", "qsc"];
  var qsc = {
    init: init$4,
    forward: forward$4,
    inverse: inverse$4,
    names: names$4
  };

  // Robinson projection
  // Based on https://github.com/OSGeo/proj.4/blob/master/src/PJ_robin.c
  // Polynomial coeficients from http://article.gmane.org/gmane.comp.gis.proj-4.devel/6039


  var COEFS_X = [
      [1.0000, 2.2199e-17, -7.15515e-05, 3.1103e-06],
      [0.9986, -0.000482243, -2.4897e-05, -1.3309e-06],
      [0.9954, -0.00083103, -4.48605e-05, -9.86701e-07],
      [0.9900, -0.00135364, -5.9661e-05, 3.6777e-06],
      [0.9822, -0.00167442, -4.49547e-06, -5.72411e-06],
      [0.9730, -0.00214868, -9.03571e-05, 1.8736e-08],
      [0.9600, -0.00305085, -9.00761e-05, 1.64917e-06],
      [0.9427, -0.00382792, -6.53386e-05, -2.6154e-06],
      [0.9216, -0.00467746, -0.00010457, 4.81243e-06],
      [0.8962, -0.00536223, -3.23831e-05, -5.43432e-06],
      [0.8679, -0.00609363, -0.000113898, 3.32484e-06],
      [0.8350, -0.00698325, -6.40253e-05, 9.34959e-07],
      [0.7986, -0.00755338, -5.00009e-05, 9.35324e-07],
      [0.7597, -0.00798324, -3.5971e-05, -2.27626e-06],
      [0.7186, -0.00851367, -7.01149e-05, -8.6303e-06],
      [0.6732, -0.00986209, -0.000199569, 1.91974e-05],
      [0.6213, -0.010418, 8.83923e-05, 6.24051e-06],
      [0.5722, -0.00906601, 0.000182, 6.24051e-06],
      [0.5322, -0.00677797, 0.000275608, 6.24051e-06]
  ];

  var COEFS_Y = [
      [-5.20417e-18, 0.0124, 1.21431e-18, -8.45284e-11],
      [0.0620, 0.0124, -1.26793e-09, 4.22642e-10],
      [0.1240, 0.0124, 5.07171e-09, -1.60604e-09],
      [0.1860, 0.0123999, -1.90189e-08, 6.00152e-09],
      [0.2480, 0.0124002, 7.10039e-08, -2.24e-08],
      [0.3100, 0.0123992, -2.64997e-07, 8.35986e-08],
      [0.3720, 0.0124029, 9.88983e-07, -3.11994e-07],
      [0.4340, 0.0123893, -3.69093e-06, -4.35621e-07],
      [0.4958, 0.0123198, -1.02252e-05, -3.45523e-07],
      [0.5571, 0.0121916, -1.54081e-05, -5.82288e-07],
      [0.6176, 0.0119938, -2.41424e-05, -5.25327e-07],
      [0.6769, 0.011713, -3.20223e-05, -5.16405e-07],
      [0.7346, 0.0113541, -3.97684e-05, -6.09052e-07],
      [0.7903, 0.0109107, -4.89042e-05, -1.04739e-06],
      [0.8435, 0.0103431, -6.4615e-05, -1.40374e-09],
      [0.8936, 0.00969686, -6.4636e-05, -8.547e-06],
      [0.9394, 0.00840947, -0.000192841, -4.2106e-06],
      [0.9761, 0.00616527, -0.000256, -4.2106e-06],
      [1.0000, 0.00328947, -0.000319159, -4.2106e-06]
  ];

  var FXC = 0.8487;
  var FYC = 1.3523;
  var C1 = R2D/5; // rad to 5-degree interval
  var RC1 = 1/C1;
  var NODES = 18;

  var poly3_val = function(coefs, x) {
      return coefs[0] + x * (coefs[1] + x * (coefs[2] + x * coefs[3]));
  };

  var poly3_der = function(coefs, x) {
      return coefs[1] + x * (2 * coefs[2] + x * 3 * coefs[3]);
  };

  function newton_rapshon(f_df, start, max_err, iters) {
      var x = start;
      for (; iters; --iters) {
          var upd = f_df(x);
          x -= upd;
          if (Math.abs(upd) < max_err) {
              break;
          }
      }
      return x;
  }

  function init$3() {
      this.x0 = this.x0 || 0;
      this.y0 = this.y0 || 0;
      this.long0 = this.long0 || 0;
      this.es = 0;
      this.title = this.title || "Robinson";
  }

  function forward$3(ll) {
      var lon = adjust_lon(ll.x - this.long0);

      var dphi = Math.abs(ll.y);
      var i = Math.floor(dphi * C1);
      if (i < 0) {
          i = 0;
      } else if (i >= NODES) {
          i = NODES - 1;
      }
      dphi = R2D * (dphi - RC1 * i);
      var xy = {
          x: poly3_val(COEFS_X[i], dphi) * lon,
          y: poly3_val(COEFS_Y[i], dphi)
      };
      if (ll.y < 0) {
          xy.y = -xy.y;
      }

      xy.x = xy.x * this.a * FXC + this.x0;
      xy.y = xy.y * this.a * FYC + this.y0;
      return xy;
  }

  function inverse$3(xy) {
      var ll = {
          x: (xy.x - this.x0) / (this.a * FXC),
          y: Math.abs(xy.y - this.y0) / (this.a * FYC)
      };

      if (ll.y >= 1) { // pathologic case
          ll.x /= COEFS_X[NODES][0];
          ll.y = xy.y < 0 ? -HALF_PI : HALF_PI;
      } else {
          // find table interval
          var i = Math.floor(ll.y * NODES);
          if (i < 0) {
              i = 0;
          } else if (i >= NODES) {
              i = NODES - 1;
          }
          for (;;) {
              if (COEFS_Y[i][0] > ll.y) {
                  --i;
              } else if (COEFS_Y[i+1][0] <= ll.y) {
                  ++i;
              } else {
                  break;
              }
          }
          // linear interpolation in 5 degree interval
          var coefs = COEFS_Y[i];
          var t = 5 * (ll.y - coefs[0]) / (COEFS_Y[i+1][0] - coefs[0]);
          // find t so that poly3_val(coefs, t) = ll.y
          t = newton_rapshon(function(x) {
              return (poly3_val(coefs, x) - ll.y) / poly3_der(coefs, x);
          }, t, EPSLN, 100);

          ll.x /= poly3_val(COEFS_X[i], t);
          ll.y = (5 * i + t) * D2R$1;
          if (xy.y < 0) {
              ll.y = -ll.y;
          }
      }

      ll.x = adjust_lon(ll.x + this.long0);
      return ll;
  }

  var names$3 = ["Robinson", "robin"];
  var robin = {
    init: init$3,
    forward: forward$3,
    inverse: inverse$3,
    names: names$3
  };

  function init$2() {
      this.name = 'geocent';

  }

  function forward$2(p) {
      var point = geodeticToGeocentric(p, this.es, this.a);
      return point;
  }

  function inverse$2(p) {
      var point = geocentricToGeodetic(p, this.es, this.a, this.b);
      return point;
  }

  var names$2 = ["Geocentric", 'geocentric', "geocent", "Geocent"];
  var geocent = {
      init: init$2,
      forward: forward$2,
      inverse: inverse$2,
      names: names$2
  };

  var mode = {
    N_POLE: 0,
    S_POLE: 1,
    EQUIT: 2,
    OBLIQ: 3
  };

  var params = {
    h:     { def: 100000, num: true },           // default is Karman line, no default in PROJ.7
    azi:   { def: 0, num: true, degrees: true }, // default is North
    tilt:  { def: 0, num: true, degrees: true }, // default is Nadir
    long0: { def: 0, num: true },                // default is Greenwich, conversion to rad is automatic
    lat0:  { def: 0, num: true }                 // default is Equator, conversion to rad is automatic
  };

  function init$1() {
    Object.keys(params).forEach(function (p) {
      if (typeof this[p] === "undefined") {
        this[p] = params[p].def;
      } else if (params[p].num && isNaN(this[p])) {
        throw new Error("Invalid parameter value, must be numeric " + p + " = " + this[p]);
      } else if (params[p].num) {
        this[p] = parseFloat(this[p]);
      }
      if (params[p].degrees) {
        this[p] = this[p] * D2R$1;
      }
    }.bind(this));

    if (Math.abs((Math.abs(this.lat0) - HALF_PI)) < EPSLN) {
      this.mode = this.lat0 < 0 ? mode.S_POLE : mode.N_POLE;
    } else if (Math.abs(this.lat0) < EPSLN) {
      this.mode = mode.EQUIT;
    } else {
      this.mode = mode.OBLIQ;
      this.sinph0 = Math.sin(this.lat0);
      this.cosph0 = Math.cos(this.lat0);
    }

    this.pn1 = this.h / this.a;  // Normalize relative to the Earth's radius

    if (this.pn1 <= 0 || this.pn1 > 1e10) {
      throw new Error("Invalid height");
    }
    
    this.p = 1 + this.pn1;
    this.rp = 1 / this.p;
    this.h1 = 1 / this.pn1;
    this.pfact = (this.p + 1) * this.h1;
    this.es = 0;

    var omega = this.tilt;
    var gamma = this.azi;
    this.cg = Math.cos(gamma);
    this.sg = Math.sin(gamma);
    this.cw = Math.cos(omega);
    this.sw = Math.sin(omega);
  }

  function forward$1(p) {
    p.x -= this.long0;
    var sinphi = Math.sin(p.y);
    var cosphi = Math.cos(p.y);
    var coslam = Math.cos(p.x);
    var x, y;
    switch (this.mode) {
      case mode.OBLIQ:
        y = this.sinph0 * sinphi + this.cosph0 * cosphi * coslam;
        break;
      case mode.EQUIT:
        y = cosphi * coslam;
        break;
      case mode.S_POLE:
        y = -sinphi;
        break;
      case mode.N_POLE:
        y = sinphi;
        break;
    }
    y = this.pn1 / (this.p - y);
    x = y * cosphi * Math.sin(p.x);

    switch (this.mode) {
      case mode.OBLIQ:
        y *= this.cosph0 * sinphi - this.sinph0 * cosphi * coslam;
        break;
      case mode.EQUIT:
        y *= sinphi;
        break;
      case mode.N_POLE:
        y *= -(cosphi * coslam);
        break;
      case mode.S_POLE:
        y *= cosphi * coslam;
        break;
    }

    // Tilt 
    var yt, ba;
    yt = y * this.cg + x * this.sg;
    ba = 1 / (yt * this.sw * this.h1 + this.cw);
    x = (x * this.cg - y * this.sg) * this.cw * ba;
    y = yt * ba;

    p.x = x * this.a;
    p.y = y * this.a;
    return p;
  }

  function inverse$1(p) {
    p.x /= this.a;
    p.y /= this.a;
    var r = { x: p.x, y: p.y };

    // Un-Tilt
    var bm, bq, yt;
    yt = 1 / (this.pn1 - p.y * this.sw);
    bm = this.pn1 * p.x * yt;
    bq = this.pn1 * p.y * this.cw * yt;
    p.x = bm * this.cg + bq * this.sg;
    p.y = bq * this.cg - bm * this.sg;

    var rh = hypot(p.x, p.y);
    if (Math.abs(rh) < EPSLN) {
      r.x = 0;
      r.y = p.y;
    } else {
      var cosz, sinz;
      sinz = 1 - rh * rh * this.pfact;
      sinz = (this.p - Math.sqrt(sinz)) / (this.pn1 / rh + rh / this.pn1);
      cosz = Math.sqrt(1 - sinz * sinz);
      switch (this.mode) {
        case mode.OBLIQ:
          r.y = Math.asin(cosz * this.sinph0 + p.y * sinz * this.cosph0 / rh);
          p.y = (cosz - this.sinph0 * Math.sin(r.y)) * rh;
          p.x *= sinz * this.cosph0;
          break;
        case mode.EQUIT:
          r.y = Math.asin(p.y * sinz / rh);
          p.y = cosz * rh;
          p.x *= sinz;
          break;
        case mode.N_POLE:
          r.y = Math.asin(cosz);
          p.y = -p.y;
          break;
        case mode.S_POLE:
          r.y = -Math.asin(cosz);
          break;
      }
      r.x = Math.atan2(p.x, p.y);
    }

    p.x = r.x + this.long0;
    p.y = r.y;
    return p;
  }

  var names$1 = ["Tilted_Perspective", "tpers"];
  var tpers = {
    init: init$1,
    forward: forward$1,
    inverse: inverse$1,
    names: names$1
  };

  function init() {
      this.flip_axis = (this.sweep === 'x' ? 1 : 0);
      this.h = Number(this.h);
      this.radius_g_1 = this.h / this.a;

      if (this.radius_g_1 <= 0 || this.radius_g_1 > 1e10) {
          throw new Error();
      }

      this.radius_g = 1.0 + this.radius_g_1;
      this.C = this.radius_g * this.radius_g - 1.0;

      if (this.es !== 0.0) {
          var one_es = 1.0 - this.es;
          var rone_es = 1 / one_es;

          this.radius_p = Math.sqrt(one_es);
          this.radius_p2 = one_es;
          this.radius_p_inv2 = rone_es;

          this.shape = 'ellipse'; // Use as a condition in the forward and inverse functions.
      } else {
          this.radius_p = 1.0;
          this.radius_p2 = 1.0;
          this.radius_p_inv2 = 1.0;

          this.shape = 'sphere';  // Use as a condition in the forward and inverse functions.
      }

      if (!this.title) {
          this.title = "Geostationary Satellite View";
      }
  }

  function forward(p) {
      var lon = p.x;
      var lat = p.y;
      var tmp, v_x, v_y, v_z;
      lon = lon - this.long0;

      if (this.shape === 'ellipse') {
          lat = Math.atan(this.radius_p2 * Math.tan(lat));
          var r = this.radius_p / hypot(this.radius_p * Math.cos(lat), Math.sin(lat));

          v_x = r * Math.cos(lon) * Math.cos(lat);
          v_y = r * Math.sin(lon) * Math.cos(lat);
          v_z = r * Math.sin(lat);

          if (((this.radius_g - v_x) * v_x - v_y * v_y - v_z * v_z * this.radius_p_inv2) < 0.0) {
              p.x = Number.NaN;
              p.y = Number.NaN;
              return p;
          }

          tmp = this.radius_g - v_x;
          if (this.flip_axis) {
              p.x = this.radius_g_1 * Math.atan(v_y / hypot(v_z, tmp));
              p.y = this.radius_g_1 * Math.atan(v_z / tmp);
          } else {
              p.x = this.radius_g_1 * Math.atan(v_y / tmp);
              p.y = this.radius_g_1 * Math.atan(v_z / hypot(v_y, tmp));
          }
      } else if (this.shape === 'sphere') {
          tmp = Math.cos(lat);
          v_x = Math.cos(lon) * tmp;
          v_y = Math.sin(lon) * tmp;
          v_z = Math.sin(lat);
          tmp = this.radius_g - v_x;

          if (this.flip_axis) {
              p.x = this.radius_g_1 * Math.atan(v_y / hypot(v_z, tmp));
              p.y = this.radius_g_1 * Math.atan(v_z / tmp);
          } else {
              p.x = this.radius_g_1 * Math.atan(v_y / tmp);
              p.y = this.radius_g_1 * Math.atan(v_z / hypot(v_y, tmp));
          }
      }
      p.x = p.x * this.a;
      p.y = p.y * this.a;
      return p;
  }

  function inverse(p) {
      var v_x = -1.0;
      var v_y = 0.0;
      var v_z = 0.0;
      var a, b, det, k;

      p.x = p.x / this.a;
      p.y = p.y / this.a;

      if (this.shape === 'ellipse') {
          if (this.flip_axis) {
              v_z = Math.tan(p.y / this.radius_g_1);
              v_y = Math.tan(p.x / this.radius_g_1) * hypot(1.0, v_z);
          } else {
              v_y = Math.tan(p.x / this.radius_g_1);
              v_z = Math.tan(p.y / this.radius_g_1) * hypot(1.0, v_y);
          }

          var v_zp = v_z / this.radius_p;
          a = v_y * v_y + v_zp * v_zp + v_x * v_x;
          b = 2 * this.radius_g * v_x;
          det = (b * b) - 4 * a * this.C;

          if (det < 0.0) {
              p.x = Number.NaN;
              p.y = Number.NaN;
              return p;
          }

          k = (-b - Math.sqrt(det)) / (2.0 * a);
          v_x = this.radius_g + k * v_x;
          v_y *= k;
          v_z *= k;

          p.x = Math.atan2(v_y, v_x);
          p.y = Math.atan(v_z * Math.cos(p.x) / v_x);
          p.y = Math.atan(this.radius_p_inv2 * Math.tan(p.y));
      } else if (this.shape === 'sphere') {
          if (this.flip_axis) {
              v_z = Math.tan(p.y / this.radius_g_1);
              v_y = Math.tan(p.x / this.radius_g_1) * Math.sqrt(1.0 + v_z * v_z);
          } else {
              v_y = Math.tan(p.x / this.radius_g_1);
              v_z = Math.tan(p.y / this.radius_g_1) * Math.sqrt(1.0 + v_y * v_y);
          }

          a = v_y * v_y + v_z * v_z + v_x * v_x;
          b = 2 * this.radius_g * v_x;
          det = (b * b) - 4 * a * this.C;
          if (det < 0.0) {
              p.x = Number.NaN;
              p.y = Number.NaN;
              return p;
          }

          k = (-b - Math.sqrt(det)) / (2.0 * a);
          v_x = this.radius_g + k * v_x;
          v_y *= k;
          v_z *= k;

          p.x = Math.atan2(v_y, v_x);
          p.y = Math.atan(v_z * Math.cos(p.x) / v_x);
      }
      p.x = p.x + this.long0;
      return p;
  }

  var names = ["Geostationary Satellite View", "Geostationary_Satellite", "geos"];
  var geos = {
      init: init,
      forward: forward,
      inverse: inverse,
      names: names,
  };

  function includedProjections(proj4){
    proj4.Proj.projections.add(tmerc);
    proj4.Proj.projections.add(etmerc);
    proj4.Proj.projections.add(utm);
    proj4.Proj.projections.add(sterea);
    proj4.Proj.projections.add(stere);
    proj4.Proj.projections.add(somerc);
    proj4.Proj.projections.add(omerc);
    proj4.Proj.projections.add(lcc);
    proj4.Proj.projections.add(krovak);
    proj4.Proj.projections.add(cass);
    proj4.Proj.projections.add(laea);
    proj4.Proj.projections.add(aea);
    proj4.Proj.projections.add(gnom);
    proj4.Proj.projections.add(cea);
    proj4.Proj.projections.add(eqc);
    proj4.Proj.projections.add(poly);
    proj4.Proj.projections.add(nzmg);
    proj4.Proj.projections.add(mill);
    proj4.Proj.projections.add(sinu);
    proj4.Proj.projections.add(moll);
    proj4.Proj.projections.add(eqdc);
    proj4.Proj.projections.add(vandg);
    proj4.Proj.projections.add(aeqd);
    proj4.Proj.projections.add(ortho);
    proj4.Proj.projections.add(qsc);
    proj4.Proj.projections.add(robin);
    proj4.Proj.projections.add(geocent);
    proj4.Proj.projections.add(tpers);
    proj4.Proj.projections.add(geos);
  }

  proj4.defaultDatum = 'WGS84'; //default datum
  proj4.Proj = Projection;
  proj4.WGS84 = new proj4.Proj('WGS84');
  proj4.Point = Point;
  proj4.toPoint = common;
  proj4.defs = defs;
  proj4.nadgrid = nadgrid;
  proj4.transform = transform;
  proj4.mgrs = mgrs;
  proj4.version = '__VERSION__';
  includedProjections(proj4);

  var f,m="deflate-raw",x=self.DecompressionStream;try{new x(m),f=async t=>{let n=new x(m),e=n.writable.getWriter(),i=n.readable.getReader();e.write(t),e.close();let c,o=[],s=0,a=0,l;for(;!(l=await i.read()).done;)c=l.value,o.push(c),s+=c.length;return o.length-1?(c=new Uint8Array(s),o.map(r=>{c.set(r,a),a+=r.length;}),c):o[0]};}catch{}var _=new TextDecoder,h=t=>{throw new Error("but-unzip~"+t)},E=t=>_.decode(t),A=t=>{let n=t.length-20,e=Math.max(n-65516,2);for(;(n=t.lastIndexOf(80,n-1))!==-1&&!(t[n+1]===75&&t[n+2]===5&&t[n+3]===6)&&n>e;);return n};function*C(t,n=f){let e=A(t);e===-1&&h(2);let i=(r,d)=>t.subarray(e+=r,e+=d),c=new DataView(t.buffer,t.byteOffset),o=r=>c.getUint16(r+e,!0),s=r=>c.getUint32(r+e,!0),a=o(10);for(a!==o(8)&&h(3),e=s(16);a--;){let r=o(10),d=o(28),g=o(30),y=o(32),b=s(20),w=s(42),p=E(i(46,d)),D=E(i(g,y)),L=e,u;e=w,u=i(30+o(26)+o(28),b),yield {filename:p,comment:D,read:()=>r&8?n(u):r?h(1):u},e=L;}}

  const regex$1 = /.+\.(shp|dbf|json|prj|cpg)$/i;
  var unzip = async (buffer) => {
    const files = {};
    const proms = [];
    for (const entry of C(buffer)) {
      if (!regex$1.test(entry.filename)) {
        continue;
      }
      proms.push(Promise.resolve(entry.read()).then(bytes => files[entry.filename] = bytes));
    }
    await Promise.all(proms);
    const out = {};
    const decoder = new TextDecoder();
    for (const [key, value] of Object.entries(files)) {
      if (key.slice(-3).toLowerCase() === 'shp' || key.slice(-3).toLowerCase() === 'dbf') {
        out[key] = new DataView(value.buffer, value.byteOffset, value.byteLength);
      } else {
        out[key] = decoder.decode(value);
      }
    }
    return out;
  };

  const URL$1 = globalThis.URL;

  var combine$1 = (base, type) => {
    if (!type) {
      return base;
    }
    const url = new URL$1(base);
    url.pathname = `${url.pathname}.${type}`;
    return url.href;
  };

  async function binaryAjax(_url, type) {

    const url = combine$1(_url, type);
    const isOptionalTxt = type === 'prj' || type === 'cpg';
    try {
      const resp = await fetch(url);
      if (resp.status > 399) {
        throw new Error(resp.statusText);
      }
      if (isOptionalTxt) {
        return resp.text();
      }
      const parsed = await resp.arrayBuffer();
      return new DataView(parsed)
    } catch (e) {
      if (isOptionalTxt || type === 'dbf') {
        return false;
      }
      throw e;
    }
  }

  function isClockWise(array) {
    let sum = 0;
    let i = 1;
    const len = array.length;
    let prev, cur;
    const bbox = [array[0][0], array[0][1], array[0][0], array[0][1]];
    while (i < len) {
      prev = cur || array[0];
      cur = array[i];
      sum += ((cur[0] - prev[0]) * (cur[1] + prev[1]));
      i++;
      if (cur[0] < bbox[0]) {
        bbox[0] = cur[0];
      }
      if (cur[1] < bbox[1]) {
        bbox[1] = cur[1];
      }
      if (cur[0] > bbox[2]) {
        bbox[2] = cur[0];
      }
      if (cur[1] > bbox[3]) {
        bbox[3] = cur[1];
      }
    }
    return {
      ring: array,
      clockWise: sum > 0,
      bbox,
      children: []
    }

  }

  function contains(outer, inner) {
    if (outer.bbox[0] > inner.bbox[0]) {
      return false;
    }
    if (outer.bbox[1] > inner.bbox[1]) {
      return false;
    }
    if (outer.bbox[2] < inner.bbox[2]) {
      return false;
    }
    if (outer.bbox[3] < inner.bbox[3]) {
      return false;
    }
    return true;
  }

  function handleRings(rings) {
    const outers = [];
    const inners = [];
    for (const ring of rings) {
      const proccessed = isClockWise(ring);
      if (proccessed.clockWise) {
        outers.push(proccessed);
      } else {
        inners.push(proccessed);
      }
    }
    // this is an optimization, 
    // but it would also put in weird bad rings that would otherwise get left out
    // if (outers.length === 1) {
    //   const out = [outers[0].ring]
    //   for (const inner of inners) {
    //     out.push(inner.ring);

    //   }
    //   return [out];
    // }
    for (const inner of inners) {
      for (const outer of outers) {
        if (contains(outer, inner)) {
          outer.children.push(inner.ring);
          break;
        }
      }
    }
    const out = [];
    for (const outer of outers) {
      out.push([outer.ring].concat(outer.children));
    }
    return out;
  }
  ParseShp.prototype.parsePoint = function (data) {
    return {
      type: 'Point',
      coordinates: this.parseCoord(data, 0)
    };
  };
  ParseShp.prototype.parseZPoint = function (data) {
    const pointXY = this.parsePoint(data);
    pointXY.coordinates.push(data.getFloat64(16, true));
    return pointXY;
  };
  ParseShp.prototype.parsePointArray = function (data, offset, num) {
    const out = [];
    let done = 0;
    while (done < num) {
      out.push(this.parseCoord(data, offset));
      offset += 16;
      done++;
    }
    return out;
  };
  ParseShp.prototype.parseZPointArray = function (data, zOffset, num, coordinates) {
    let i = 0;
    while (i < num) {
      coordinates[i].push(data.getFloat64(zOffset, true));
      i++;
      zOffset += 8;
    }
    return coordinates;
  };
  ParseShp.prototype.parseArrayGroup = function (data, offset, partOffset, num, tot) {
    const out = [];
    let done = 0;
    let curNum; let nextNum = 0;
    let pointNumber;
    while (done < num) {
      done++;
      partOffset += 4;
      curNum = nextNum;
      if (done === num) {
        nextNum = tot;
      } else {
        nextNum = data.getInt32(partOffset, true);
      }
      pointNumber = nextNum - curNum;
      if (!pointNumber) {
        continue;
      }
      out.push(this.parsePointArray(data, offset, pointNumber));
      offset += (pointNumber << 4);
    }
    return out;
  };
  ParseShp.prototype.parseZArrayGroup = function (data, zOffset, num, coordinates) {
    let i = 0;
    while (i < num) {
      coordinates[i] = this.parseZPointArray(data, zOffset, coordinates[i].length, coordinates[i]);
      zOffset += (coordinates[i].length << 3);
      i++;
    }
    return coordinates;
  };
  ParseShp.prototype.parseMultiPoint = function (data) {
    const out = {};
    const num = data.getInt32(32, true);
    if (!num) {
      return null;
    }
    const mins = this.parseCoord(data, 0);
    const maxs = this.parseCoord(data, 16);
    out.bbox = [
      mins[0],
      mins[1],
      maxs[0],
      maxs[1]
    ];
    const offset = 36;
    if (num === 1) {
      out.type = 'Point';
      out.coordinates = this.parseCoord(data, offset);
    } else {
      out.type = 'MultiPoint';
      out.coordinates = this.parsePointArray(data, offset, num);
    }
    return out;
  };
  ParseShp.prototype.parseZMultiPoint = function (data) {
    const geoJson = this.parseMultiPoint(data);
    if (!geoJson) {
      return null;
    }
    let num;
    if (geoJson.type === 'Point') {
      geoJson.coordinates.push(data.getFloat64(72, true));
      return geoJson;
    } else {
      num = geoJson.coordinates.length;
    }
    const zOffset = 52 + (num << 4);
    geoJson.coordinates = this.parseZPointArray(data, zOffset, num, geoJson.coordinates);
    return geoJson;
  };
  ParseShp.prototype.parsePolyline = function (data) {
    const out = {};
    const numParts = data.getInt32(32, true);
    if (!numParts) {
      return null;
    }
    const mins = this.parseCoord(data, 0);
    const maxs = this.parseCoord(data, 16);
    out.bbox = [
      mins[0],
      mins[1],
      maxs[0],
      maxs[1]
    ];
    const num = data.getInt32(36, true);
    let offset, partOffset;
    if (numParts === 1) {
      out.type = 'LineString';
      offset = 44;
      out.coordinates = this.parsePointArray(data, offset, num);
    } else {
      out.type = 'MultiLineString';
      offset = 40 + (numParts << 2);
      partOffset = 40;
      out.coordinates = this.parseArrayGroup(data, offset, partOffset, numParts, num);
    }
    return out;
  };
  ParseShp.prototype.parseZPolyline = function (data) {
    const geoJson = this.parsePolyline(data);
    if (!geoJson) {
      return null;
    }
    const num = geoJson.coordinates.length;
    let zOffset;
    if (geoJson.type === 'LineString') {
      zOffset = 60 + (num << 4);
      geoJson.coordinates = this.parseZPointArray(data, zOffset, num, geoJson.coordinates);
      return geoJson;
    } else {
      const totalPoints = geoJson.coordinates.reduce(function (a, v) {
        return a + v.length;
      }, 0);
      zOffset = 56 + (totalPoints << 4) + (num << 2);
      geoJson.coordinates = this.parseZArrayGroup(data, zOffset, num, geoJson.coordinates);
      return geoJson;
    }
  };
  ParseShp.prototype.polyFuncs = function (out) {
    if (!out) {
      return out;
    }
    if (out.type === 'LineString') {
      out.type = 'Polygon';
      out.coordinates = [out.coordinates];
      return out;
    } else {
      out.coordinates = handleRings(out.coordinates);
      if (out.coordinates.length === 1) {
        out.type = 'Polygon';
        out.coordinates = out.coordinates[0];
        return out;
      } else {
        out.type = 'MultiPolygon';
        return out;
      }
    }
  };
  ParseShp.prototype.parsePolygon = function (data) {
    return this.polyFuncs(this.parsePolyline(data));
  };
  ParseShp.prototype.parseZPolygon = function (data) {
    return this.polyFuncs(this.parseZPolyline(data));
  };
  const shpFuncObj = {
    1: 'parsePoint',
    3: 'parsePolyline',
    5: 'parsePolygon',
    8: 'parseMultiPoint',
    11: 'parseZPoint',
    13: 'parseZPolyline',
    15: 'parseZPolygon',
    18: 'parseZMultiPoint'
  };

  function makeParseCoord(trans) {
    if (trans) {
      return function (data, offset) {
        const args = [data.getFloat64(offset, true), data.getFloat64(offset + 8, true)];
        return trans.inverse(args);
      };
    } else {
      return function (data, offset) {
        return [data.getFloat64(offset, true), data.getFloat64(offset + 8, true)];
      };
    }
  }

  function ParseShp(buffer, trans) {
    if (!(this instanceof ParseShp)) {
      return new ParseShp(buffer, trans);
    }
    this.buffer = buffer;
    this.headers = this.parseHeader();
    this.shpFuncs(trans);
    this.rows = this.getRows();
  }
  ParseShp.prototype.shpFuncs = function (tran) {
    let num = this.headers.shpCode;
    if (num > 20) {
      num -= 20;
    }
    if (!(num in shpFuncObj)) {
      throw new Error(`I don't know shp type "${num}"`);
    }
    this.parseFunc = this[shpFuncObj[num]];
    this.parseCoord = makeParseCoord(tran);
  };
  ParseShp.prototype.getShpCode = function () {
    return this.parseHeader().shpCode;
  };
  ParseShp.prototype.parseHeader = function () {
    const view = this.buffer;
    return {
      length: view.getInt32(6 << 2) << 1,
      version: view.getInt32(7 << 2, true),
      shpCode: view.getInt32(8 << 2, true),
      bbox: [
        view.getFloat64(9 << 2, true),
        view.getFloat64(11 << 2, true),
        view.getFloat64(13 << 2, true),
        view.getFloat64(15 << 2, true)
      ]
    };
  };
  ParseShp.prototype.getRows = function () {
    let offset = 100;
    const len = this.buffer.byteLength - 8;
    const out = [];
    let current;
    while (offset <= len) {
      current = this.getRow(offset);
      if (!current) {
        break;
      }
      offset += 8;
      offset += current.len;
      if (current.type) {
        out.push(this.parseFunc(current.data));
      } else {
        out.push(null);
      }
    }
    return out;
  };
  ParseShp.prototype.getRow = function (offset) {
    const id = this.buffer.getInt32(offset);
    const len = this.buffer.getInt32(offset + 4) << 1;
    if (len === 0) {
      return {
        id: id,
        len: len,
        type: 0
      };
    }

    if (offset + len + 8 > this.buffer.byteLength) {
      return;
    }
    return {
      id: id,
      len: len,
      data: new DataView(this.buffer.buffer, this.buffer.byteOffset + offset + 12, len - 4),
      type: this.buffer.getInt32(offset + 8, true)
    };
  };
  function parseShp (buffer, trans) {
    return new ParseShp(buffer, trans).rows;
  }

  var regex = /^(?:ANSI\s)?(\d+)$/m;
  function createDecoder(encoding, second) {
    if (!encoding) {
      return browserDecoder;
    }
    try {
      new TextDecoder(encoding.trim());
    } catch (e) {
      var match = regex.exec(encoding);
      if (match && !second) {
        return createDecoder('windows-' + match[1], true);
      } else {
        encoding = undefined;
        return browserDecoder;
      }
    }
    return browserDecoder;
    function browserDecoder(buffer) {
      var decoder = new TextDecoder(encoding ? encoding : undefined);
      var out = decoder.decode(buffer, {
        stream: true
      }) + decoder.decode();
      return out.replace(/\0/g, '').trim();
    }
  }

  function dbfHeader(data) {
    var out = {};
    out.lastUpdated = new Date(data.getUint8(1) + 1900, data.getUint8(2), data.getUint8(3));
    out.records = data.getUint32(4, true);
    out.headerLen = data.getUint16(8, true);
    out.recLen = data.getUint16(10, true);
    return out;
  }

  function dbfRowHeader(data, headerLen, decoder) {
    var out = [];
    var offset = 32;
    while (offset < headerLen) {
      out.push({
        name: decoder(new Uint8Array(data.buffer.slice(data.byteOffset + offset, data.byteOffset + offset + 11))),
        dataType: String.fromCharCode(data.getUint8(offset + 11)),
        len: data.getUint8(offset + 16),
        decimal: data.getUint8(offset + 17)
      });
      if (data.getUint8(offset + 32) === 13) {
        break;
      } else {
        offset += 32;
      }
    }
    return out;
  }

  function rowFuncs(buffer, offset, len, type, decoder) {
    const data = new Uint8Array(buffer.buffer.slice(buffer.byteOffset + offset, buffer.byteOffset + offset + len));

    var textData = decoder(data);
    switch (type) {
      case 'N':
      case 'F':
      case 'O':
        return parseFloat(textData, 10);
      case 'D':
        return new Date(textData.slice(0, 4), parseInt(textData.slice(4, 6), 10) - 1, textData.slice(6, 8));
      case 'L':
        return textData.toLowerCase() === 'y' || textData.toLowerCase() === 't';
      default:
        return textData;
    }
  }

  function parseRow(buffer, offset, rowHeaders, decoder) {
    var out = {};
    var i = 0;
    var len = rowHeaders.length;
    var field;
    var header;
    while (i < len) {
      header = rowHeaders[i];
      field = rowFuncs(buffer, offset, header.len, header.dataType, decoder);
      offset += header.len;
      if (typeof field !== 'undefined') {
        out[header.name] = field;
      }
      i++;
    }
    return out;
  }

  function parseDbf (buffer, encoding) {
    var decoder = createDecoder(encoding);
    var header = dbfHeader(buffer);
    var rowHeaders = dbfRowHeader(buffer, header.headerLen - 1, decoder);

    var offset = ((rowHeaders.length + 1) << 5) + 2;
    var recLen = header.recLen;
    var records = header.records;
    var out = [];
    while (records) {
      out.push(parseRow(buffer, offset, rowHeaders, decoder));
      offset += recLen;
      records--;
    }
    return out;
  }

  const URL = globalThis.URL;
  const toUitn8Arr = b => {
    if (!b) {
      throw new Error('forgot to pass buffer');
    }
    if (isArrayBuffer(b)) {
      return new Uint8Array(b);
    }
    if (isArrayBuffer(b.buffer)) {
      if (b.BYTES_PER_ELEMENT === 1) {
        return b;
      }
      return new Uint8Array(b.buffer, b.byteOffset, b.byteLength);
    }
    throw new Error('invalid buffer like object')
  };
  const txtDecoder = new TextDecoder();
  const toString = (possibleString) => {
    if (!possibleString) {
      return;
    }
    if (typeof possibleString === 'string') {
      return possibleString;
    }
    if (isArrayBuffer(possibleString) || ArrayBuffer.isView(possibleString) || isDataView(possibleString)) {
      return txtDecoder.decode(possibleString);
    }
  };
  const toDataView = b => {
    if (!b) {
      throw new Error('forgot to pass buffer');
    }
    if (isDataView(b)) {
      return b;
    }
    if (isArrayBuffer(b)) {
      return new DataView(b);
    }
    if (isArrayBuffer(b.buffer)) {
      return new DataView(b.buffer, b.byteOffset, b.byteLength);
    }
    throw new Error('invalid buffer like object')
  };

  function isArrayBuffer(subject) {
    return subject instanceof globalThis.ArrayBuffer || Object.prototype.toString.call(subject) === '[object ArrayBuffer]';
  }
  function isDataView(subject) {
    return subject instanceof globalThis.DataView || Object.prototype.toString.call(subject) === '[object DataView]'
  }

  const combine = function ([shp, dbf]) {
    const out = {};
    out.type = 'FeatureCollection';
    out.features = [];
    let i = 0;
    const len = shp.length;
    if (!dbf) {
      dbf = [];
    }
    while (i < len) {
      out.features.push({
        type: 'Feature',
        geometry: shp[i],
        properties: dbf[i] || {}
      });
      i++;
    }
    return out;
  };
  const parseZip = async function (buffer, whiteList) {
    let key;
    buffer = toUitn8Arr(buffer);
    const zip = await unzip(buffer);
    const names = [];
    whiteList = whiteList || [];
    for (key in zip) {
      if (key.indexOf('__MACOSX') !== -1) {
        continue;
      }
      if (key.slice(-4).toLowerCase() === '.shp') {
        names.push(key.slice(0, -4));
        zip[key.slice(0, -3) + key.slice(-3).toLowerCase()] = zip[key];
      } else if (key.slice(-4).toLowerCase() === '.prj') {
        zip[key.slice(0, -3) + key.slice(-3).toLowerCase()] = proj4(zip[key]);
      } else if (key.slice(-5).toLowerCase() === '.json' || whiteList.indexOf(key.split('.').pop()) > -1) {
        names.push(key.slice(0, -3) + key.slice(-3).toLowerCase());
      } else if (key.slice(-4).toLowerCase() === '.dbf' || key.slice(-4).toLowerCase() === '.cpg') {
        zip[key.slice(0, -3) + key.slice(-3).toLowerCase()] = zip[key];
      }
    }
    if (!names.length) {
      throw new Error('no layers founds');
    }
    const geojson = names.map(function (name) {
      let parsed, dbf;
      const lastDotIdx = name.lastIndexOf('.');
      if (lastDotIdx > -1 && name.slice(lastDotIdx).indexOf('json') > -1) {
        parsed = JSON.parse(zip[name]);
        parsed.fileName = name.slice(0, lastDotIdx);
      } else if (whiteList.indexOf(name.slice(lastDotIdx + 1)) > -1) {
        parsed = zip[name];
        parsed.fileName = name;
      } else {
        if (zip[name + '.dbf']) {
          dbf = parseDbf(zip[name + '.dbf'], zip[name + '.cpg']);
        }
        parsed = combine([parseShp(zip[name + '.shp'], zip[name + '.prj']), dbf]);
        parsed.fileName = name;
      }
      return parsed;
    });
    if (geojson.length === 1) {
      return geojson[0];
    } else {
      return geojson;
    }
  };
  async function getZip(base, whiteList) {
    const a = await binaryAjax(base);
    return parseZip(a, whiteList);
  }
  const handleShp = async (base) => {
    const args = await Promise.all([
      binaryAjax(base, 'shp'),
      binaryAjax(base, 'prj')
    ]);
    let prj = false;
    try {
      if (args[1]) {
        prj = proj4(args[1]);
      }
    } catch (e) {
      prj = false;
    }
    return parseShp(args[0], prj);
  };
  const handleDbf = async (base) => {
    const [dbf, cpg] = await Promise.all([
      binaryAjax(base, 'dbf'),
      binaryAjax(base, 'cpg')
    ]);
    if (!dbf) {
      return;
    }
    return parseDbf(dbf, cpg);
  };
  const checkSuffix = (base, suffix) => {
    const url = new URL(base, globalThis?.document?.location);
    return url.pathname.slice(-4).toLowerCase() === suffix;
  };
  const fromObject = ({ shp, dbf, cpg, prj }) => {
    const things = [
      _parseShp(shp, prj)
    ];
    if (dbf) {
      things.push(_parseDbf(dbf, cpg));
    }
    return combine(things);
  };
  const getShapefile = async function (base, whiteList) {
    if (typeof base !== 'string') {
      if (isArrayBuffer(base) || ArrayBuffer.isView(base) || isDataView(base)) {
        return parseZip(base);
      }
      if (base.shp) {
        return fromObject(base);
      }
      throw new TypeError('must be a string, some sort of Buffer, or an object with at least a .shp property')
    }
    if (checkSuffix(base, '.zip')) {
      return getZip(base, whiteList);
    }
    if (checkSuffix(base, '.shp')) {
      base = base.slice(0, -4);
    }
    const results = await Promise.all([
      handleShp(base),
      handleDbf(base)
    ]);
    return combine(results);
  };
  const _parseShp = function (shp, prj) {
    shp = toDataView(shp);
    prj = toString(prj);
    if (typeof prj === 'string') {
      try {
        prj = proj4(prj);
      } catch (e) {
        prj = false;
      }
    }
    return parseShp(shp, prj);
  };
  const _parseDbf = function (dbf, cpg) {
    dbf = toDataView(dbf);
    cpg = toString(cpg);
    return parseDbf(dbf, cpg);
  };

  getShapefile.combine = combine;
  getShapefile.parseDbf = _parseDbf;
  getShapefile.parseZip = parseZip;
  getShapefile.parseShp = _parseShp;

  return getShapefile;

}));

},{}],28:[function(require,module,exports){
(function (setImmediate,clearImmediate){(function (){
var nextTick = require('process/browser.js').nextTick;
var apply = Function.prototype.apply;
var slice = Array.prototype.slice;
var immediateIds = {};
var nextImmediateId = 0;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, window, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, window, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) { timeout.close(); };

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(window, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// That's not how node.js implements it but the exposed api is the same.
exports.setImmediate = typeof setImmediate === "function" ? setImmediate : function(fn) {
  var id = nextImmediateId++;
  var args = arguments.length < 2 ? false : slice.call(arguments, 1);

  immediateIds[id] = true;

  nextTick(function onNextTick() {
    if (immediateIds[id]) {
      // fn.call() is faster so we optimize for the common use-case
      // @see http://jsperf.com/call-apply-segu
      if (args) {
        fn.apply(null, args);
      } else {
        fn.call(null);
      }
      // Prevent ids from leaking
      exports.clearImmediate(id);
    }
  });

  return id;
};

exports.clearImmediate = typeof clearImmediate === "function" ? clearImmediate : function(id) {
  delete immediateIds[id];
};
}).call(this)}).call(this,require("timers").setImmediate,require("timers").clearImmediate)
},{"process/browser.js":25,"timers":28}],29:[function(require,module,exports){
/*!
 * tiny-cookie - A tiny cookie manipulation plugin
 * https://github.com/Alex1990/tiny-cookie
 * Under the MIT license | (c) Alex Chao
 */

!(function(root, factory) {

  // Uses CommonJS, AMD or browser global to create a jQuery plugin.
  // See: https://github.com/umdjs/umd
  if (typeof define === 'function' && define.amd) {
    // Expose this plugin as an AMD module. Register an anonymous module.
    define(factory);
  } else if (typeof exports === 'object') {
    // Node/CommonJS module
    module.exports = factory();
  } else {
    // Browser globals 
    root.Cookie = factory();
  }

}(this, function() {

  'use strict';

  // The public function which can get/set/remove cookie.
  function Cookie(key, value, opts) {
    if (value === void 0) {
      return Cookie.get(key);
    } else if (value === null) {
      Cookie.remove(key);
    } else {
      Cookie.set(key, value, opts);
    }
  }

  // Check if the cookie is enabled.
  Cookie.enabled = function() {
    var key = '__test_key';
    var enabled;

    document.cookie = key + '=1';
    enabled = !!document.cookie;

    if (enabled) Cookie.remove(key);

    return enabled;
  };

  // Get the cookie value by the key.
  Cookie.get = function(key, raw) {
    if (typeof key !== 'string' || !key) return null;

    key = '(?:^|; )' + escapeRe(key) + '(?:=([^;]*?))?(?:;|$)';

    var reKey = new RegExp(key);
    var res = reKey.exec(document.cookie);

    return res !== null ? (raw ? res[1] : decodeURIComponent(res[1])) : null;
  };

  // Get the cookie's value without decoding.
  Cookie.getRaw = function(key) {
    return Cookie.get(key, true);
  };

  // Set a cookie.
  Cookie.set = function(key, value, raw, opts) {
    if (raw !== true) {
      opts = raw;
      raw = false;
    }
    opts = opts ? convert(opts) : convert({});
    var cookie = key + '=' + (raw ? value : encodeURIComponent(value)) + opts;
    document.cookie = cookie;
  };

  // Set a cookie without encoding the value.
  Cookie.setRaw = function(key, value, opts) {
    Cookie.set(key, value, true, opts);
  };

  // Remove a cookie by the specified key.
  Cookie.remove = function(key) {
    Cookie.set(key, 'a', { expires: new Date() });
  };

  // Helper function
  // ---------------

  // Escape special characters.
  function escapeRe(str) {
    return str.replace(/[.*+?^$|[\](){}\\-]/g, '\\$&');
  }

  // Convert an object to a cookie option string.
  function convert(opts) {
    var res = '';

    for (var p in opts) {
      if (opts.hasOwnProperty(p)) {

        if (p === 'expires') {
          var expires = opts[p];
          if (typeof expires !== 'object') {
            expires += typeof expires === 'number' ? 'D' : '';
            expires = computeExpires(expires);
          }
          opts[p] = expires.toUTCString();
        }

        if (p === 'secure') {
          if (opts[p]) {
            res += ';' + p;
          }

          continue;
        }

        res += ';' + p + '=' + opts[p];
      }
    }

    if (!opts.hasOwnProperty('path')) {
      res += ';path=/';
    }

    return res;
  }

  // Return a future date by the given string.
  function computeExpires(str) {
    var expires = new Date();
    var lastCh = str.charAt(str.length - 1);
    var value = parseInt(str, 10);

    switch (lastCh) {
      case 'Y': expires.setFullYear(expires.getFullYear() + value); break;
      case 'M': expires.setMonth(expires.getMonth() + value); break;
      case 'D': expires.setDate(expires.getDate() + value); break;
      case 'h': expires.setHours(expires.getHours() + value); break;
      case 'm': expires.setMinutes(expires.getMinutes() + value); break;
      case 's': expires.setSeconds(expires.getSeconds() + value); break;
      default: expires = new Date(str);
    }

    return expires;
  }

  return Cookie;

}));

},{}],30:[function(require,module,exports){
(function (global){(function (){

/**
 * Module exports.
 */

module.exports = deprecate;

/**
 * Mark that a method should not be used.
 * Returns a modified function which warns once by default.
 *
 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
 *
 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
 * will throw an Error when invoked.
 *
 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
 * will invoke `console.trace()` instead of `console.error()`.
 *
 * @param {Function} fn - the function to deprecate
 * @param {String} msg - the string to print to the console when `fn` is invoked
 * @returns {Function} a new "deprecated" version of `fn`
 * @api public
 */

function deprecate (fn, msg) {
  if (config('noDeprecation')) {
    return fn;
  }

  var warned = false;
  function deprecated() {
    if (!warned) {
      if (config('throwDeprecation')) {
        throw new Error(msg);
      } else if (config('traceDeprecation')) {
        console.trace(msg);
      } else {
        console.warn(msg);
      }
      warned = true;
    }
    return fn.apply(this, arguments);
  }

  return deprecated;
}

/**
 * Checks `localStorage` for boolean values for the given `name`.
 *
 * @param {String} name
 * @returns {Boolean}
 * @api private
 */

function config (name) {
  // accessing global.localStorage can trigger a DOMException in sandboxed iframes
  try {
    if (!global.localStorage) return false;
  } catch (_) {
    return false;
  }
  var val = global.localStorage[name];
  if (null == val) return false;
  return String(val).toLowerCase() === 'true';
}

}).call(this)}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],31:[function(require,module,exports){
(function (global){(function (){
!function(e,t){"object"==typeof exports&&"object"==typeof module?module.exports=t():"function"==typeof define&&define.amd?define([],t):"object"==typeof exports?exports.VueColor=t():e.VueColor=t()}("undefined"!=typeof self?self:this,function(){return function(e){function t(r){if(n[r])return n[r].exports;var i=n[r]={i:r,l:!1,exports:{}};return e[r].call(i.exports,i,i.exports,t),i.l=!0,i.exports}var n={};return t.m=e,t.c=n,t.d=function(e,n,r){t.o(e,n)||Object.defineProperty(e,n,{configurable:!1,enumerable:!0,get:r})},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},t.p="",t(t.s=60)}([function(e,t){function n(e,t){var n=e[1]||"",i=e[3];if(!i)return n;if(t&&"function"==typeof btoa){var o=r(i);return[n].concat(i.sources.map(function(e){return"/*# sourceURL="+i.sourceRoot+e+" */"})).concat([o]).join("\n")}return[n].join("\n")}function r(e){return"/*# sourceMappingURL=data:application/json;charset=utf-8;base64,"+btoa(unescape(encodeURIComponent(JSON.stringify(e))))+" */"}e.exports=function(e){var t=[];return t.toString=function(){return this.map(function(t){var r=n(t,e);return t[2]?"@media "+t[2]+"{"+r+"}":r}).join("")},t.i=function(e,n){"string"==typeof e&&(e=[[null,e,""]]);for(var r={},i=0;i<this.length;i++){var o=this[i][0];"number"==typeof o&&(r[o]=!0)}for(i=0;i<e.length;i++){var a=e[i];"number"==typeof a[0]&&r[a[0]]||(n&&!a[2]?a[2]=n:n&&(a[2]="("+a[2]+") and ("+n+")"),t.push(a))}},t}},function(e,t,n){function r(e){for(var t=0;t<e.length;t++){var n=e[t],r=u[n.id];if(r){r.refs++;for(var i=0;i<r.parts.length;i++)r.parts[i](n.parts[i]);for(;i<n.parts.length;i++)r.parts.push(o(n.parts[i]));r.parts.length>n.parts.length&&(r.parts.length=n.parts.length)}else{for(var a=[],i=0;i<n.parts.length;i++)a.push(o(n.parts[i]));u[n.id]={id:n.id,refs:1,parts:a}}}}function i(){var e=document.createElement("style");return e.type="text/css",f.appendChild(e),e}function o(e){var t,n,r=document.querySelector("style["+b+'~="'+e.id+'"]');if(r){if(p)return v;r.parentNode.removeChild(r)}if(x){var o=h++;r=d||(d=i()),t=a.bind(null,r,o,!1),n=a.bind(null,r,o,!0)}else r=i(),t=s.bind(null,r),n=function(){r.parentNode.removeChild(r)};return t(e),function(r){if(r){if(r.css===e.css&&r.media===e.media&&r.sourceMap===e.sourceMap)return;t(e=r)}else n()}}function a(e,t,n,r){var i=n?"":r.css;if(e.styleSheet)e.styleSheet.cssText=m(t,i);else{var o=document.createTextNode(i),a=e.childNodes;a[t]&&e.removeChild(a[t]),a.length?e.insertBefore(o,a[t]):e.appendChild(o)}}function s(e,t){var n=t.css,r=t.media,i=t.sourceMap;if(r&&e.setAttribute("media",r),g.ssrId&&e.setAttribute(b,t.id),i&&(n+="\n/*# sourceURL="+i.sources[0]+" */",n+="\n/*# sourceMappingURL=data:application/json;base64,"+btoa(unescape(encodeURIComponent(JSON.stringify(i))))+" */"),e.styleSheet)e.styleSheet.cssText=n;else{for(;e.firstChild;)e.removeChild(e.firstChild);e.appendChild(document.createTextNode(n))}}var c="undefined"!=typeof document;if("undefined"!=typeof DEBUG&&DEBUG&&!c)throw new Error("vue-style-loader cannot be used in a non-browser environment. Use { target: 'node' } in your Webpack config to indicate a server-rendering environment.");var l=n(64),u={},f=c&&(document.head||document.getElementsByTagName("head")[0]),d=null,h=0,p=!1,v=function(){},g=null,b="data-vue-ssr-id",x="undefined"!=typeof navigator&&/msie [6-9]\b/.test(navigator.userAgent.toLowerCase());e.exports=function(e,t,n,i){p=n,g=i||{};var o=l(e,t);return r(o),function(t){for(var n=[],i=0;i<o.length;i++){var a=o[i],s=u[a.id];s.refs--,n.push(s)}t?(o=l(e,t),r(o)):o=[];for(var i=0;i<n.length;i++){var s=n[i];if(0===s.refs){for(var c=0;c<s.parts.length;c++)s.parts[c]();delete u[s.id]}}}};var m=function(){var e=[];return function(t,n){return e[t]=n,e.filter(Boolean).join("\n")}}()},function(e,t){e.exports=function(e,t,n,r,i,o){var a,s=e=e||{},c=typeof e.default;"object"!==c&&"function"!==c||(a=e,s=e.default);var l="function"==typeof s?s.options:s;t&&(l.render=t.render,l.staticRenderFns=t.staticRenderFns,l._compiled=!0),n&&(l.functional=!0),i&&(l._scopeId=i);var u;if(o?(u=function(e){e=e||this.$vnode&&this.$vnode.ssrContext||this.parent&&this.parent.$vnode&&this.parent.$vnode.ssrContext,e||"undefined"==typeof __VUE_SSR_CONTEXT__||(e=__VUE_SSR_CONTEXT__),r&&r.call(this,e),e&&e._registeredComponents&&e._registeredComponents.add(o)},l._ssrRegister=u):r&&(u=r),u){var f=l.functional,d=f?l.render:l.beforeCreate;f?(l._injectStyles=u,l.render=function(e,t){return u.call(t),d(e,t)}):l.beforeCreate=d?[].concat(d,u):[u]}return{esModule:a,exports:s,options:l}}},function(e,t,n){"use strict";function r(e,t){var n,r=e&&e.a;!(n=e&&e.hsl?(0,o.default)(e.hsl):e&&e.hex&&e.hex.length>0?(0,o.default)(e.hex):e&&e.hsv?(0,o.default)(e.hsv):e&&e.rgba?(0,o.default)(e.rgba):e&&e.rgb?(0,o.default)(e.rgb):(0,o.default)(e))||void 0!==n._a&&null!==n._a||n.setAlpha(r||1);var i=n.toHsl(),a=n.toHsv();return 0===i.s&&(a.h=i.h=e.h||e.hsl&&e.hsl.h||t||0),{hsl:i,hex:n.toHexString().toUpperCase(),hex8:n.toHex8String().toUpperCase(),rgba:n.toRgb(),hsv:a,oldHue:e.h||t||i.h,source:e.source,a:e.a||n.getAlpha()}}Object.defineProperty(t,"__esModule",{value:!0});var i=n(65),o=function(e){return e&&e.__esModule?e:{default:e}}(i);t.default={props:["value"],data:function(){return{val:r(this.value)}},computed:{colors:{get:function(){return this.val},set:function(e){this.val=e,this.$emit("input",e)}}},watch:{value:function(e){this.val=r(e)}},methods:{colorChange:function(e,t){this.oldHue=this.colors.hsl.h,this.colors=r(e,t||this.oldHue)},isValidHex:function(e){return(0,o.default)(e).isValid()},simpleCheckForValidColor:function(e){for(var t=["r","g","b","a","h","s","l","v"],n=0,r=0,i=0;i<t.length;i++){var o=t[i];e[o]&&(n++,isNaN(e[o])||r++)}if(n===r)return e},paletteUpperCase:function(e){return e.map(function(e){return e.toUpperCase()})},isTransparent:function(e){return 0===(0,o.default)(e).getAlpha()}}}},function(e,t){var n=e.exports="undefined"!=typeof window&&window.Math==Math?window:"undefined"!=typeof self&&self.Math==Math?self:Function("return this")();"number"==typeof __g&&(__g=n)},function(e,t,n){"use strict";function r(e){c||n(66)}Object.defineProperty(t,"__esModule",{value:!0});var i=n(36),o=n.n(i);for(var a in i)"default"!==a&&function(e){n.d(t,e,function(){return i[e]})}(a);var s=n(68),c=!1,l=n(2),u=r,f=l(o.a,s.a,!1,u,null,null);f.options.__file="src/components/common/EditableInput.vue",t.default=f.exports},function(e,t){var n={}.hasOwnProperty;e.exports=function(e,t){return n.call(e,t)}},function(e,t,n){var r=n(8),i=n(18);e.exports=n(9)?function(e,t,n){return r.f(e,t,i(1,n))}:function(e,t,n){return e[t]=n,e}},function(e,t,n){var r=n(16),i=n(42),o=n(25),a=Object.defineProperty;t.f=n(9)?Object.defineProperty:function(e,t,n){if(r(e),t=o(t,!0),r(n),i)try{return a(e,t,n)}catch(e){}if("get"in n||"set"in n)throw TypeError("Accessors not supported!");return"value"in n&&(e[t]=n.value),e}},function(e,t,n){e.exports=!n(17)(function(){return 7!=Object.defineProperty({},"a",{get:function(){return 7}}).a})},function(e,t,n){var r=n(90),i=n(24);e.exports=function(e){return r(i(e))}},function(e,t,n){var r=n(29)("wks"),i=n(19),o=n(4).Symbol,a="function"==typeof o;(e.exports=function(e){return r[e]||(r[e]=a&&o[e]||(a?o:i)("Symbol."+e))}).store=r},function(e,t){e.exports=function(e){return"object"==typeof e?null!==e:"function"==typeof e}},function(e,t,n){"use strict";function r(e){c||n(111)}Object.defineProperty(t,"__esModule",{value:!0});var i=n(51),o=n.n(i);for(var a in i)"default"!==a&&function(e){n.d(t,e,function(){return i[e]})}(a);var s=n(113),c=!1,l=n(2),u=r,f=l(o.a,s.a,!1,u,null,null);f.options.__file="src/components/common/Hue.vue",t.default=f.exports},function(e,t){e.exports=!0},function(e,t){var n=e.exports={version:"2.6.11"};"number"==typeof __e&&(__e=n)},function(e,t,n){var r=n(12);e.exports=function(e){if(!r(e))throw TypeError(e+" is not an object!");return e}},function(e,t){e.exports=function(e){try{return!!e()}catch(e){return!0}}},function(e,t){e.exports=function(e,t){return{enumerable:!(1&e),configurable:!(2&e),writable:!(4&e),value:t}}},function(e,t){var n=0,r=Math.random();e.exports=function(e){return"Symbol(".concat(void 0===e?"":e,")_",(++n+r).toString(36))}},function(e,t,n){"use strict";function r(e){c||n(123)}Object.defineProperty(t,"__esModule",{value:!0});var i=n(54),o=n.n(i);for(var a in i)"default"!==a&&function(e){n.d(t,e,function(){return i[e]})}(a);var s=n(127),c=!1,l=n(2),u=r,f=l(o.a,s.a,!1,u,null,null);f.options.__file="src/components/common/Saturation.vue",t.default=f.exports},function(e,t,n){"use strict";function r(e){c||n(128)}Object.defineProperty(t,"__esModule",{value:!0});var i=n(55),o=n.n(i);for(var a in i)"default"!==a&&function(e){n.d(t,e,function(){return i[e]})}(a);var s=n(133),c=!1,l=n(2),u=r,f=l(o.a,s.a,!1,u,null,null);f.options.__file="src/components/common/Alpha.vue",t.default=f.exports},function(e,t,n){"use strict";function r(e){c||n(130)}Object.defineProperty(t,"__esModule",{value:!0});var i=n(56),o=n.n(i);for(var a in i)"default"!==a&&function(e){n.d(t,e,function(){return i[e]})}(a);var s=n(132),c=!1,l=n(2),u=r,f=l(o.a,s.a,!1,u,null,null);f.options.__file="src/components/common/Checkboard.vue",t.default=f.exports},function(e,t){var n=Math.ceil,r=Math.floor;e.exports=function(e){return isNaN(e=+e)?0:(e>0?r:n)(e)}},function(e,t){e.exports=function(e){if(void 0==e)throw TypeError("Can't call method on  "+e);return e}},function(e,t,n){var r=n(12);e.exports=function(e,t){if(!r(e))return e;var n,i;if(t&&"function"==typeof(n=e.toString)&&!r(i=n.call(e)))return i;if("function"==typeof(n=e.valueOf)&&!r(i=n.call(e)))return i;if(!t&&"function"==typeof(n=e.toString)&&!r(i=n.call(e)))return i;throw TypeError("Can't convert object to primitive value")}},function(e,t){e.exports={}},function(e,t,n){var r=n(46),i=n(30);e.exports=Object.keys||function(e){return r(e,i)}},function(e,t,n){var r=n(29)("keys"),i=n(19);e.exports=function(e){return r[e]||(r[e]=i(e))}},function(e,t,n){var r=n(15),i=n(4),o=i["__core-js_shared__"]||(i["__core-js_shared__"]={});(e.exports=function(e,t){return o[e]||(o[e]=void 0!==t?t:{})})("versions",[]).push({version:r.version,mode:n(14)?"pure":"global",copyright:"© 2019 Denis Pushkarev (zloirock.ru)"})},function(e,t){e.exports="constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf".split(",")},function(e,t,n){var r=n(8).f,i=n(6),o=n(11)("toStringTag");e.exports=function(e,t,n){e&&!i(e=n?e:e.prototype,o)&&r(e,o,{configurable:!0,value:t})}},function(e,t,n){t.f=n(11)},function(e,t,n){var r=n(4),i=n(15),o=n(14),a=n(32),s=n(8).f;e.exports=function(e){var t=i.Symbol||(i.Symbol=o?{}:r.Symbol||{});"_"==e.charAt(0)||e in t||s(t,e,{value:a.f(e)})}},function(e,t){t.f={}.propertyIsEnumerable},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var i=n(3),o=r(i),a=n(5),s=r(a),c=["#4D4D4D","#999999","#FFFFFF","#F44E3B","#FE9200","#FCDC00","#DBDF00","#A4DD00","#68CCCA","#73D8FF","#AEA1FF","#FDA1FF","#333333","#808080","#CCCCCC","#D33115","#E27300","#FCC400","#B0BC00","#68BC00","#16A5A5","#009CE0","#7B64FF","#FA28FF","#000000","#666666","#B3B3B3","#9F0500","#C45100","#FB9E00","#808900","#194D33","#0C797D","#0062B1","#653294","#AB149E"];t.default={name:"Compact",mixins:[o.default],props:{palette:{type:Array,default:function(){return c}}},components:{"ed-in":s.default},computed:{pick:function(){return this.colors.hex.toUpperCase()}},methods:{handlerClick:function(e){this.colorChange({hex:e,source:"hex"})}}}},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.default={name:"editableInput",props:{label:String,labelText:String,desc:String,value:[String,Number],max:Number,min:Number,arrowOffset:{type:Number,default:1}},computed:{val:{get:function(){return this.value},set:function(e){if(!(void 0!==this.max&&+e>this.max))return e;this.$refs.input.value=this.max}},labelId:function(){return"input__label__"+this.label+"__"+Math.random().toString().slice(2,5)},labelSpanText:function(){return this.labelText||this.label}},methods:{update:function(e){this.handleChange(e.target.value)},handleChange:function(e){var t={};t[this.label]=e,void 0===t.hex&&void 0===t["#"]?this.$emit("change",t):e.length>5&&this.$emit("change",t)},handleKeyDown:function(e){var t=this.val,n=Number(t);if(n){var r=this.arrowOffset||1;38===e.keyCode&&(t=n+r,this.handleChange(t),e.preventDefault()),40===e.keyCode&&(t=n-r,this.handleChange(t),e.preventDefault())}}}}},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var r=n(3),i=function(e){return e&&e.__esModule?e:{default:e}}(r),o=["#FFFFFF","#F2F2F2","#E6E6E6","#D9D9D9","#CCCCCC","#BFBFBF","#B3B3B3","#A6A6A6","#999999","#8C8C8C","#808080","#737373","#666666","#595959","#4D4D4D","#404040","#333333","#262626","#0D0D0D","#000000"];t.default={name:"Grayscale",mixins:[i.default],props:{palette:{type:Array,default:function(){return o}}},components:{},computed:{pick:function(){return this.colors.hex.toUpperCase()}},methods:{handlerClick:function(e){this.colorChange({hex:e,source:"hex"})}}}},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var i=n(5),o=r(i),a=n(3),s=r(a);t.default={name:"Material",mixins:[s.default],components:{"ed-in":o.default},methods:{onChange:function(e){e&&(e.hex?this.isValidHex(e.hex)&&this.colorChange({hex:e.hex,source:"hex"}):(e.r||e.g||e.b)&&this.colorChange({r:e.r||this.colors.rgba.r,g:e.g||this.colors.rgba.g,b:e.b||this.colors.rgba.b,a:e.a||this.colors.rgba.a,source:"rgba"}))}}}},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var i=n(81),o=r(i),a=n(3),s=r(a),c=n(13),l=r(c);t.default={name:"Slider",mixins:[s.default],props:{swatches:{type:Array,default:function(){return[{s:.5,l:.8},{s:.5,l:.65},{s:.5,l:.5},{s:.5,l:.35},{s:.5,l:.2}]}}},components:{hue:l.default},computed:{normalizedSwatches:function(){return this.swatches.map(function(e){return"object"!==(void 0===e?"undefined":(0,o.default)(e))?{s:.5,l:e}:e})}},methods:{isActive:function(e,t){var n=this.colors.hsl;return 1===n.l&&1===e.l||(0===n.l&&0===e.l||Math.abs(n.l-e.l)<.01&&Math.abs(n.s-e.s)<.01)},hueChange:function(e){this.colorChange(e)},handleSwClick:function(e,t){this.colorChange({h:this.colors.hsl.h,s:t.s,l:t.l,source:"hsl"})}}}},function(e,t,n){"use strict";var r=n(14),i=n(41),o=n(44),a=n(7),s=n(26),c=n(88),l=n(31),u=n(95),f=n(11)("iterator"),d=!([].keys&&"next"in[].keys()),h=function(){return this};e.exports=function(e,t,n,p,v,g,b){c(n,t,p);var x,m,_,w=function(e){if(!d&&e in F)return F[e];switch(e){case"keys":case"values":return function(){return new n(this,e)}}return function(){return new n(this,e)}},y=t+" Iterator",C="values"==v,k=!1,F=e.prototype,S=F[f]||F["@@iterator"]||v&&F[v],A=S||w(v),O=v?C?w("entries"):A:void 0,E="Array"==t?F.entries||S:S;if(E&&(_=u(E.call(new e)))!==Object.prototype&&_.next&&(l(_,y,!0),r||"function"==typeof _[f]||a(_,f,h)),C&&S&&"values"!==S.name&&(k=!0,A=function(){return S.call(this)}),r&&!b||!d&&!k&&F[f]||a(F,f,A),s[t]=A,s[y]=h,v)if(x={values:C?A:w("values"),keys:g?A:w("keys"),entries:O},b)for(m in x)m in F||o(F,m,x[m]);else i(i.P+i.F*(d||k),t,x);return x}},function(e,t,n){var r=n(4),i=n(15),o=n(86),a=n(7),s=n(6),c=function(e,t,n){var l,u,f,d=e&c.F,h=e&c.G,p=e&c.S,v=e&c.P,g=e&c.B,b=e&c.W,x=h?i:i[t]||(i[t]={}),m=x.prototype,_=h?r:p?r[t]:(r[t]||{}).prototype;h&&(n=t);for(l in n)(u=!d&&_&&void 0!==_[l])&&s(x,l)||(f=u?_[l]:n[l],x[l]=h&&"function"!=typeof _[l]?n[l]:g&&u?o(f,r):b&&_[l]==f?function(e){var t=function(t,n,r){if(this instanceof e){switch(arguments.length){case 0:return new e;case 1:return new e(t);case 2:return new e(t,n)}return new e(t,n,r)}return e.apply(this,arguments)};return t.prototype=e.prototype,t}(f):v&&"function"==typeof f?o(Function.call,f):f,v&&((x.virtual||(x.virtual={}))[l]=f,e&c.R&&m&&!m[l]&&a(m,l,f)))};c.F=1,c.G=2,c.S=4,c.P=8,c.B=16,c.W=32,c.U=64,c.R=128,e.exports=c},function(e,t,n){e.exports=!n(9)&&!n(17)(function(){return 7!=Object.defineProperty(n(43)("div"),"a",{get:function(){return 7}}).a})},function(e,t,n){var r=n(12),i=n(4).document,o=r(i)&&r(i.createElement);e.exports=function(e){return o?i.createElement(e):{}}},function(e,t,n){e.exports=n(7)},function(e,t,n){var r=n(16),i=n(89),o=n(30),a=n(28)("IE_PROTO"),s=function(){},c=function(){var e,t=n(43)("iframe"),r=o.length;for(t.style.display="none",n(94).appendChild(t),t.src="javascript:",e=t.contentWindow.document,e.open(),e.write("<script>document.F=Object<\/script>"),e.close(),c=e.F;r--;)delete c.prototype[o[r]];return c()};e.exports=Object.create||function(e,t){var n;return null!==e?(s.prototype=r(e),n=new s,s.prototype=null,n[a]=e):n=c(),void 0===t?n:i(n,t)}},function(e,t,n){var r=n(6),i=n(10),o=n(91)(!1),a=n(28)("IE_PROTO");e.exports=function(e,t){var n,s=i(e),c=0,l=[];for(n in s)n!=a&&r(s,n)&&l.push(n);for(;t.length>c;)r(s,n=t[c++])&&(~o(l,n)||l.push(n));return l}},function(e,t){var n={}.toString;e.exports=function(e){return n.call(e).slice(8,-1)}},function(e,t,n){var r=n(24);e.exports=function(e){return Object(r(e))}},function(e,t){t.f=Object.getOwnPropertySymbols},function(e,t,n){var r=n(46),i=n(30).concat("length","prototype");t.f=Object.getOwnPropertyNames||function(e){return r(e,i)}},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.default={name:"Hue",props:{value:Object,direction:{type:String,default:"horizontal"}},data:function(){return{oldHue:0,pullDirection:""}},computed:{colors:function(){var e=this.value.hsl.h;return 0!==e&&e-this.oldHue>0&&(this.pullDirection="right"),0!==e&&e-this.oldHue<0&&(this.pullDirection="left"),this.oldHue=e,this.value},directionClass:function(){return{"vc-hue--horizontal":"horizontal"===this.direction,"vc-hue--vertical":"vertical"===this.direction}},pointerTop:function(){return"vertical"===this.direction?0===this.colors.hsl.h&&"right"===this.pullDirection?0:-100*this.colors.hsl.h/360+100+"%":0},pointerLeft:function(){return"vertical"===this.direction?0:0===this.colors.hsl.h&&"right"===this.pullDirection?"100%":100*this.colors.hsl.h/360+"%"}},methods:{handleChange:function(e,t){!t&&e.preventDefault();var n=this.$refs.container;if(n){var r,i,o=n.clientWidth,a=n.clientHeight,s=n.getBoundingClientRect().left+window.pageXOffset,c=n.getBoundingClientRect().top+window.pageYOffset,l=e.pageX||(e.touches?e.touches[0].pageX:0),u=e.pageY||(e.touches?e.touches[0].pageY:0),f=l-s,d=u-c;"vertical"===this.direction?(d<0?r=360:d>a?r=0:(i=-100*d/a+100,r=360*i/100),this.colors.hsl.h!==r&&this.$emit("change",{h:r,s:this.colors.hsl.s,l:this.colors.hsl.l,a:this.colors.hsl.a,source:"hsl"})):(f<0?r=0:f>o?r=360:(i=100*f/o,r=360*i/100),this.colors.hsl.h!==r&&this.$emit("change",{h:r,s:this.colors.hsl.s,l:this.colors.hsl.l,a:this.colors.hsl.a,source:"hsl"}))}},handleMouseDown:function(e){this.handleChange(e,!0),window.addEventListener("mousemove",this.handleChange),window.addEventListener("mouseup",this.handleMouseUp)},handleMouseUp:function(e){this.unbindEventListeners()},unbindEventListeners:function(){window.removeEventListener("mousemove",this.handleChange),window.removeEventListener("mouseup",this.handleMouseUp)}}}},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var i=n(118),o=r(i),a=n(3),s=r(a),c=["red","pink","purple","deepPurple","indigo","blue","lightBlue","cyan","teal","green","lightGreen","lime","yellow","amber","orange","deepOrange","brown","blueGrey","black"],l=["900","700","500","300","100"],u=function(){var e=[];return c.forEach(function(t){var n=[];"black"===t.toLowerCase()||"white"===t.toLowerCase()?n=n.concat(["#000000","#FFFFFF"]):l.forEach(function(e){var r=o.default[t][e];n.push(r.toUpperCase())}),e.push(n)}),e}();t.default={name:"Swatches",mixins:[s.default],props:{palette:{type:Array,default:function(){return u}}},computed:{pick:function(){return this.colors.hex}},methods:{equal:function(e){return e.toLowerCase()===this.colors.hex.toLowerCase()},handlerClick:function(e){this.colorChange({hex:e,source:"hex"})}}}},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var i=n(3),o=r(i),a=n(5),s=r(a),c=n(20),l=r(c),u=n(13),f=r(u),d=n(21),h=r(d);t.default={name:"Photoshop",mixins:[o.default],props:{head:{type:String,default:"Color Picker"},disableFields:{type:Boolean,default:!1},hasResetButton:{type:Boolean,default:!1},acceptLabel:{type:String,default:"OK"},cancelLabel:{type:String,default:"Cancel"},resetLabel:{type:String,default:"Reset"},newLabel:{type:String,default:"new"},currentLabel:{type:String,default:"current"}},components:{saturation:l.default,hue:f.default,alpha:h.default,"ed-in":s.default},data:function(){return{currentColor:"#FFF"}},computed:{hsv:function(){var e=this.colors.hsv;return{h:e.h.toFixed(),s:(100*e.s).toFixed(),v:(100*e.v).toFixed()}},hex:function(){var e=this.colors.hex;return e&&e.replace("#","")}},created:function(){this.currentColor=this.colors.hex},methods:{childChange:function(e){this.colorChange(e)},inputChange:function(e){e&&(e["#"]?this.isValidHex(e["#"])&&this.colorChange({hex:e["#"],source:"hex"}):e.r||e.g||e.b||e.a?this.colorChange({r:e.r||this.colors.rgba.r,g:e.g||this.colors.rgba.g,b:e.b||this.colors.rgba.b,a:e.a||this.colors.rgba.a,source:"rgba"}):(e.h||e.s||e.v)&&this.colorChange({h:e.h||this.colors.hsv.h,s:e.s/100||this.colors.hsv.s,v:e.v/100||this.colors.hsv.v,source:"hsv"}))},clickCurrentColor:function(){this.colorChange({hex:this.currentColor,source:"hex"})},handleAccept:function(){this.$emit("ok")},handleCancel:function(){this.$emit("cancel")},handleReset:function(){this.$emit("reset")}}}},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var i=n(125),o=r(i),a=n(126),s=r(a);t.default={name:"Saturation",props:{value:Object},computed:{colors:function(){return this.value},bgColor:function(){return"hsl("+this.colors.hsv.h+", 100%, 50%)"},pointerTop:function(){return-100*this.colors.hsv.v+1+100+"%"},pointerLeft:function(){return 100*this.colors.hsv.s+"%"}},methods:{throttle:(0,s.default)(function(e,t){e(t)},20,{leading:!0,trailing:!1}),handleChange:function(e,t){!t&&e.preventDefault();var n=this.$refs.container;if(n){var r=n.clientWidth,i=n.clientHeight,a=n.getBoundingClientRect().left+window.pageXOffset,s=n.getBoundingClientRect().top+window.pageYOffset,c=e.pageX||(e.touches?e.touches[0].pageX:0),l=e.pageY||(e.touches?e.touches[0].pageY:0),u=(0,o.default)(c-a,0,r),f=(0,o.default)(l-s,0,i),d=u/r,h=(0,o.default)(-f/i+1,0,1);this.throttle(this.onChange,{h:this.colors.hsv.h,s:d,v:h,a:this.colors.hsv.a,source:"hsva"})}},onChange:function(e){this.$emit("change",e)},handleMouseDown:function(e){window.addEventListener("mousemove",this.handleChange),window.addEventListener("mouseup",this.handleChange),window.addEventListener("mouseup",this.handleMouseUp)},handleMouseUp:function(e){this.unbindEventListeners()},unbindEventListeners:function(){window.removeEventListener("mousemove",this.handleChange),window.removeEventListener("mouseup",this.handleChange),window.removeEventListener("mouseup",this.handleMouseUp)}}}},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var r=n(22),i=function(e){return e&&e.__esModule?e:{default:e}}(r);t.default={name:"Alpha",props:{value:Object,onChange:Function},components:{checkboard:i.default},computed:{colors:function(){return this.value},gradientColor:function(){var e=this.colors.rgba,t=[e.r,e.g,e.b].join(",");return"linear-gradient(to right, rgba("+t+", 0) 0%, rgba("+t+", 1) 100%)"}},methods:{handleChange:function(e,t){!t&&e.preventDefault();var n=this.$refs.container;if(n){var r,i=n.clientWidth,o=n.getBoundingClientRect().left+window.pageXOffset,a=e.pageX||(e.touches?e.touches[0].pageX:0),s=a-o;r=s<0?0:s>i?1:Math.round(100*s/i)/100,this.colors.a!==r&&this.$emit("change",{h:this.colors.hsl.h,s:this.colors.hsl.s,l:this.colors.hsl.l,a:r,source:"rgba"})}},handleMouseDown:function(e){this.handleChange(e,!0),window.addEventListener("mousemove",this.handleChange),window.addEventListener("mouseup",this.handleMouseUp)},handleMouseUp:function(){this.unbindEventListeners()},unbindEventListeners:function(){window.removeEventListener("mousemove",this.handleChange),window.removeEventListener("mouseup",this.handleMouseUp)}}}},function(e,t,n){"use strict";function r(e,t,n){if("undefined"==typeof document)return null;var r=document.createElement("canvas");r.width=r.height=2*n;var i=r.getContext("2d");return i?(i.fillStyle=e,i.fillRect(0,0,r.width,r.height),i.fillStyle=t,i.fillRect(0,0,n,n),i.translate(n,n),i.fillRect(0,0,n,n),r.toDataURL()):null}function i(e,t,n){var i=e+","+t+","+n;if(o[i])return o[i];var a=r(e,t,n);return o[i]=a,a}Object.defineProperty(t,"__esModule",{value:!0});var o={};t.default={name:"Checkboard",props:{size:{type:[Number,String],default:8},white:{type:String,default:"#fff"},grey:{type:String,default:"#e6e6e6"}},computed:{bgStyle:function(){return{"background-image":"url("+i(this.white,this.grey,this.size)+")"}}}}},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var i=n(3),o=r(i),a=n(5),s=r(a),c=n(20),l=r(c),u=n(13),f=r(u),d=n(21),h=r(d),p=n(22),v=r(p),g=["#D0021B","#F5A623","#F8E71C","#8B572A","#7ED321","#417505","#BD10E0","#9013FE","#4A90E2","#50E3C2","#B8E986","#000000","#4A4A4A","#9B9B9B","#FFFFFF","rgba(0,0,0,0)"];t.default={name:"Sketch",mixins:[o.default],components:{saturation:l.default,hue:f.default,alpha:h.default,"ed-in":s.default,checkboard:v.default},props:{presetColors:{type:Array,default:function(){return g}},disableAlpha:{type:Boolean,default:!1},disableFields:{type:Boolean,default:!1}},computed:{hex:function(){var e=void 0;return e=this.colors.a<1?this.colors.hex8:this.colors.hex,e.replace("#","")},activeColor:function(){var e=this.colors.rgba;return"rgba("+[e.r,e.g,e.b,e.a].join(",")+")"}},methods:{handlePreset:function(e){this.colorChange({hex:e,source:"hex"})},childChange:function(e){this.colorChange(e)},inputChange:function(e){e&&(e.hex?this.isValidHex(e.hex)&&this.colorChange({hex:e.hex,source:"hex"}):(e.r||e.g||e.b||e.a)&&this.colorChange({r:e.r||this.colors.rgba.r,g:e.g||this.colors.rgba.g,b:e.b||this.colors.rgba.b,a:e.a||this.colors.rgba.a,source:"rgba"}))}}}},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var i=n(3),o=r(i),a=n(5),s=r(a),c=n(20),l=r(c),u=n(13),f=r(u),d=n(21),h=r(d),p=n(22),v=r(p);t.default={name:"Chrome",mixins:[o.default],props:{disableAlpha:{type:Boolean,default:!1},disableFields:{type:Boolean,default:!1}},components:{saturation:l.default,hue:f.default,alpha:h.default,"ed-in":s.default,checkboard:v.default},data:function(){return{fieldsIndex:0,highlight:!1}},computed:{hsl:function(){var e=this.colors.hsl,t=e.h,n=e.s,r=e.l;return{h:t.toFixed(),s:(100*n).toFixed()+"%",l:(100*r).toFixed()+"%"}},activeColor:function(){var e=this.colors.rgba;return"rgba("+[e.r,e.g,e.b,e.a].join(",")+")"},hasAlpha:function(){return this.colors.a<1}},methods:{childChange:function(e){this.colorChange(e)},inputChange:function(e){if(e)if(e.hex)this.isValidHex(e.hex)&&this.colorChange({hex:e.hex,source:"hex"});else if(e.r||e.g||e.b||e.a)this.colorChange({r:e.r||this.colors.rgba.r,g:e.g||this.colors.rgba.g,b:e.b||this.colors.rgba.b,a:e.a||this.colors.rgba.a,source:"rgba"});else if(e.h||e.s||e.l){var t=e.s?e.s.replace("%","")/100:this.colors.hsl.s,n=e.l?e.l.replace("%","")/100:this.colors.hsl.l;this.colorChange({h:e.h||this.colors.hsl.h,s:t,l:n,source:"hsl"})}},toggleViews:function(){if(this.fieldsIndex>=2)return void(this.fieldsIndex=0);this.fieldsIndex++},showHighlight:function(){this.highlight=!0},hideHighlight:function(){this.highlight=!1}}}},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var i=n(5),o=r(i),a=n(3),s=r(a),c=["#FF6900","#FCB900","#7BDCB5","#00D084","#8ED1FC","#0693E3","#ABB8C3","#EB144C","#F78DA7","#9900EF"];t.default={name:"Twitter",mixins:[s.default],components:{editableInput:o.default},props:{width:{type:[String,Number],default:276},defaultColors:{type:Array,default:function(){return c}},triangle:{default:"top-left",validator:function(e){return["hide","top-left","top-right"].includes(e)}}},computed:{hsv:function(){var e=this.colors.hsv;return{h:e.h.toFixed(),s:(100*e.s).toFixed(),v:(100*e.v).toFixed()}},hex:function(){var e=this.colors.hex;return e&&e.replace("#","")}},methods:{equal:function(e){return e.toLowerCase()===this.colors.hex.toLowerCase()},handlerClick:function(e){this.colorChange({hex:e,source:"hex"})},inputChange:function(e){e&&(e["#"]?this.isValidHex(e["#"])&&this.colorChange({hex:e["#"],source:"hex"}):e.r||e.g||e.b||e.a?this.colorChange({r:e.r||this.colors.rgba.r,g:e.g||this.colors.rgba.g,b:e.b||this.colors.rgba.b,a:e.a||this.colors.rgba.a,source:"rgba"}):(e.h||e.s||e.v)&&this.colorChange({h:e.h||this.colors.hsv.h,s:e.s/100||this.colors.hsv.s,v:e.v/100||this.colors.hsv.v,source:"hsv"}))}}}},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}var i=n(61),o=r(i),a=n(70),s=r(a),c=n(74),l=r(c),u=n(78),f=r(u),d=n(115),h=r(d),p=n(120),v=r(p),g=n(135),b=r(g),x=n(139),m=r(x),_=n(143),w=r(_),y=n(21),C=r(y),k=n(22),F=r(k),S=n(5),A=r(S),O=n(13),E=r(O),M=n(20),j=r(M),L=n(3),P=r(L),R={version:"2.8.1",Compact:o.default,Grayscale:s.default,Twitter:w.default,Material:l.default,Slider:f.default,Swatches:h.default,Photoshop:v.default,Sketch:b.default,Chrome:m.default,Alpha:C.default,Checkboard:F.default,EditableInput:A.default,Hue:E.default,Saturation:j.default,ColorMixin:P.default};e.exports=R},function(e,t,n){"use strict";function r(e){c||n(62)}Object.defineProperty(t,"__esModule",{value:!0});var i=n(35),o=n.n(i);for(var a in i)"default"!==a&&function(e){n.d(t,e,function(){return i[e]})}(a);var s=n(69),c=!1,l=n(2),u=r,f=l(o.a,s.a,!1,u,null,null);f.options.__file="src/components/Compact.vue",t.default=f.exports},function(e,t,n){var r=n(63);"string"==typeof r&&(r=[[e.i,r,""]]),r.locals&&(e.exports=r.locals);n(1)("6ce8a5a8",r,!1,{})},function(e,t,n){t=e.exports=n(0)(!1),t.push([e.i,"\n.vc-compact {\n  padding-top: 5px;\n  padding-left: 5px;\n  width: 245px;\n  border-radius: 2px;\n  box-sizing: border-box;\n  box-shadow: 0 2px 10px rgba(0,0,0,.12), 0 2px 5px rgba(0,0,0,.16);\n  background-color: #fff;\n}\n.vc-compact-colors {\n  overflow: hidden;\n  padding: 0;\n  margin: 0;\n}\n.vc-compact-color-item {\n  list-style: none;\n  width: 15px;\n  height: 15px;\n  float: left;\n  margin-right: 5px;\n  margin-bottom: 5px;\n  position: relative;\n  cursor: pointer;\n}\n.vc-compact-color-item--white {\n  box-shadow: inset 0 0 0 1px #ddd;\n}\n.vc-compact-color-item--white .vc-compact-dot {\n  background: #000;\n}\n.vc-compact-dot {\n  position: absolute;\n  top: 5px;\n  right: 5px;\n  bottom: 5px;\n  left: 5px;\n  border-radius: 50%;\n  opacity: 1;\n  background: #fff;\n}\n",""])},function(e,t){e.exports=function(e,t){for(var n=[],r={},i=0;i<t.length;i++){var o=t[i],a=o[0],s=o[1],c=o[2],l=o[3],u={id:e+":"+i,css:s,media:c,sourceMap:l};r[a]?r[a].parts.push(u):n.push(r[a]={id:a,parts:[u]})}return n}},function(e,t,n){var r;!function(i){function o(e,t){if(e=e||"",t=t||{},e instanceof o)return e;if(!(this instanceof o))return new o(e,t);var n=a(e);this._originalInput=e,this._r=n.r,this._g=n.g,this._b=n.b,this._a=n.a,this._roundA=G(100*this._a)/100,this._format=t.format||n.format,this._gradientType=t.gradientType,this._r<1&&(this._r=G(this._r)),this._g<1&&(this._g=G(this._g)),this._b<1&&(this._b=G(this._b)),this._ok=n.ok,this._tc_id=U++}function a(e){var t={r:0,g:0,b:0},n=1,r=null,i=null,o=null,a=!1,c=!1;return"string"==typeof e&&(e=N(e)),"object"==typeof e&&(H(e.r)&&H(e.g)&&H(e.b)?(t=s(e.r,e.g,e.b),a=!0,c="%"===String(e.r).substr(-1)?"prgb":"rgb"):H(e.h)&&H(e.s)&&H(e.v)?(r=D(e.s),i=D(e.v),t=f(e.h,r,i),a=!0,c="hsv"):H(e.h)&&H(e.s)&&H(e.l)&&(r=D(e.s),o=D(e.l),t=l(e.h,r,o),a=!0,c="hsl"),e.hasOwnProperty("a")&&(n=e.a)),n=O(n),{ok:a,format:e.format||c,r:V(255,q(t.r,0)),g:V(255,q(t.g,0)),b:V(255,q(t.b,0)),a:n}}function s(e,t,n){return{r:255*E(e,255),g:255*E(t,255),b:255*E(n,255)}}function c(e,t,n){e=E(e,255),t=E(t,255),n=E(n,255);var r,i,o=q(e,t,n),a=V(e,t,n),s=(o+a)/2;if(o==a)r=i=0;else{var c=o-a;switch(i=s>.5?c/(2-o-a):c/(o+a),o){case e:r=(t-n)/c+(t<n?6:0);break;case t:r=(n-e)/c+2;break;case n:r=(e-t)/c+4}r/=6}return{h:r,s:i,l:s}}function l(e,t,n){function r(e,t,n){return n<0&&(n+=1),n>1&&(n-=1),n<1/6?e+6*(t-e)*n:n<.5?t:n<2/3?e+(t-e)*(2/3-n)*6:e}var i,o,a;if(e=E(e,360),t=E(t,100),n=E(n,100),0===t)i=o=a=n;else{var s=n<.5?n*(1+t):n+t-n*t,c=2*n-s;i=r(c,s,e+1/3),o=r(c,s,e),a=r(c,s,e-1/3)}return{r:255*i,g:255*o,b:255*a}}function u(e,t,n){e=E(e,255),t=E(t,255),n=E(n,255);var r,i,o=q(e,t,n),a=V(e,t,n),s=o,c=o-a;if(i=0===o?0:c/o,o==a)r=0;else{switch(o){case e:r=(t-n)/c+(t<n?6:0);break;case t:r=(n-e)/c+2;break;case n:r=(e-t)/c+4}r/=6}return{h:r,s:i,v:s}}function f(e,t,n){e=6*E(e,360),t=E(t,100),n=E(n,100);var r=i.floor(e),o=e-r,a=n*(1-t),s=n*(1-o*t),c=n*(1-(1-o)*t),l=r%6;return{r:255*[n,s,a,a,c,n][l],g:255*[c,n,n,s,a,a][l],b:255*[a,a,c,n,n,s][l]}}function d(e,t,n,r){var i=[R(G(e).toString(16)),R(G(t).toString(16)),R(G(n).toString(16))];return r&&i[0].charAt(0)==i[0].charAt(1)&&i[1].charAt(0)==i[1].charAt(1)&&i[2].charAt(0)==i[2].charAt(1)?i[0].charAt(0)+i[1].charAt(0)+i[2].charAt(0):i.join("")}function h(e,t,n,r,i){var o=[R(G(e).toString(16)),R(G(t).toString(16)),R(G(n).toString(16)),R(B(r))];return i&&o[0].charAt(0)==o[0].charAt(1)&&o[1].charAt(0)==o[1].charAt(1)&&o[2].charAt(0)==o[2].charAt(1)&&o[3].charAt(0)==o[3].charAt(1)?o[0].charAt(0)+o[1].charAt(0)+o[2].charAt(0)+o[3].charAt(0):o.join("")}function p(e,t,n,r){return[R(B(r)),R(G(e).toString(16)),R(G(t).toString(16)),R(G(n).toString(16))].join("")}function v(e,t){t=0===t?0:t||10;var n=o(e).toHsl();return n.s-=t/100,n.s=M(n.s),o(n)}function g(e,t){t=0===t?0:t||10;var n=o(e).toHsl();return n.s+=t/100,n.s=M(n.s),o(n)}function b(e){return o(e).desaturate(100)}function x(e,t){t=0===t?0:t||10;var n=o(e).toHsl();return n.l+=t/100,n.l=M(n.l),o(n)}function m(e,t){t=0===t?0:t||10;var n=o(e).toRgb();return n.r=q(0,V(255,n.r-G(-t/100*255))),n.g=q(0,V(255,n.g-G(-t/100*255))),n.b=q(0,V(255,n.b-G(-t/100*255))),o(n)}function _(e,t){t=0===t?0:t||10;var n=o(e).toHsl();return n.l-=t/100,n.l=M(n.l),o(n)}function w(e,t){var n=o(e).toHsl(),r=(n.h+t)%360;return n.h=r<0?360+r:r,o(n)}function y(e){var t=o(e).toHsl();return t.h=(t.h+180)%360,o(t)}function C(e){var t=o(e).toHsl(),n=t.h;return[o(e),o({h:(n+120)%360,s:t.s,l:t.l}),o({h:(n+240)%360,s:t.s,l:t.l})]}function k(e){var t=o(e).toHsl(),n=t.h;return[o(e),o({h:(n+90)%360,s:t.s,l:t.l}),o({h:(n+180)%360,s:t.s,l:t.l}),o({h:(n+270)%360,s:t.s,l:t.l})]}function F(e){var t=o(e).toHsl(),n=t.h;return[o(e),o({h:(n+72)%360,s:t.s,l:t.l}),o({h:(n+216)%360,s:t.s,l:t.l})]}function S(e,t,n){t=t||6,n=n||30;var r=o(e).toHsl(),i=360/n,a=[o(e)];for(r.h=(r.h-(i*t>>1)+720)%360;--t;)r.h=(r.h+i)%360,a.push(o(r));return a}function A(e,t){t=t||6;for(var n=o(e).toHsv(),r=n.h,i=n.s,a=n.v,s=[],c=1/t;t--;)s.push(o({h:r,s:i,v:a})),a=(a+c)%1;return s}function O(e){return e=parseFloat(e),(isNaN(e)||e<0||e>1)&&(e=1),e}function E(e,t){L(e)&&(e="100%");var n=P(e);return e=V(t,q(0,parseFloat(e))),n&&(e=parseInt(e*t,10)/100),i.abs(e-t)<1e-6?1:e%t/parseFloat(t)}function M(e){return V(1,q(0,e))}function j(e){return parseInt(e,16)}function L(e){return"string"==typeof e&&-1!=e.indexOf(".")&&1===parseFloat(e)}function P(e){return"string"==typeof e&&-1!=e.indexOf("%")}function R(e){return 1==e.length?"0"+e:""+e}function D(e){return e<=1&&(e=100*e+"%"),e}function B(e){return i.round(255*parseFloat(e)).toString(16)}function T(e){return j(e)/255}function H(e){return!!J.CSS_UNIT.exec(e)}function N(e){e=e.replace(I,"").replace($,"").toLowerCase();var t=!1;if(W[e])e=W[e],t=!0;else if("transparent"==e)return{r:0,g:0,b:0,a:0,format:"name"};var n;return(n=J.rgb.exec(e))?{r:n[1],g:n[2],b:n[3]}:(n=J.rgba.exec(e))?{r:n[1],g:n[2],b:n[3],a:n[4]}:(n=J.hsl.exec(e))?{h:n[1],s:n[2],l:n[3]}:(n=J.hsla.exec(e))?{h:n[1],s:n[2],l:n[3],a:n[4]}:(n=J.hsv.exec(e))?{h:n[1],s:n[2],v:n[3]}:(n=J.hsva.exec(e))?{h:n[1],s:n[2],v:n[3],a:n[4]}:(n=J.hex8.exec(e))?{r:j(n[1]),g:j(n[2]),b:j(n[3]),a:T(n[4]),format:t?"name":"hex8"}:(n=J.hex6.exec(e))?{r:j(n[1]),g:j(n[2]),b:j(n[3]),format:t?"name":"hex"}:(n=J.hex4.exec(e))?{r:j(n[1]+""+n[1]),g:j(n[2]+""+n[2]),b:j(n[3]+""+n[3]),a:T(n[4]+""+n[4]),format:t?"name":"hex8"}:!!(n=J.hex3.exec(e))&&{r:j(n[1]+""+n[1]),g:j(n[2]+""+n[2]),b:j(n[3]+""+n[3]),format:t?"name":"hex"}}function z(e){var t,n;return e=e||{level:"AA",size:"small"},t=(e.level||"AA").toUpperCase(),n=(e.size||"small").toLowerCase(),"AA"!==t&&"AAA"!==t&&(t="AA"),"small"!==n&&"large"!==n&&(n="small"),{level:t,size:n}}var I=/^\s+/,$=/\s+$/,U=0,G=i.round,V=i.min,q=i.max,X=i.random;o.prototype={isDark:function(){return this.getBrightness()<128},isLight:function(){return!this.isDark()},isValid:function(){return this._ok},getOriginalInput:function(){return this._originalInput},getFormat:function(){return this._format},getAlpha:function(){return this._a},getBrightness:function(){var e=this.toRgb();return(299*e.r+587*e.g+114*e.b)/1e3},getLuminance:function(){var e,t,n,r,o,a,s=this.toRgb();return e=s.r/255,t=s.g/255,n=s.b/255,r=e<=.03928?e/12.92:i.pow((e+.055)/1.055,2.4),o=t<=.03928?t/12.92:i.pow((t+.055)/1.055,2.4),a=n<=.03928?n/12.92:i.pow((n+.055)/1.055,2.4),.2126*r+.7152*o+.0722*a},setAlpha:function(e){return this._a=O(e),this._roundA=G(100*this._a)/100,this},toHsv:function(){var e=u(this._r,this._g,this._b);return{h:360*e.h,s:e.s,v:e.v,a:this._a}},toHsvString:function(){var e=u(this._r,this._g,this._b),t=G(360*e.h),n=G(100*e.s),r=G(100*e.v);return 1==this._a?"hsv("+t+", "+n+"%, "+r+"%)":"hsva("+t+", "+n+"%, "+r+"%, "+this._roundA+")"},toHsl:function(){var e=c(this._r,this._g,this._b);return{h:360*e.h,s:e.s,l:e.l,a:this._a}},toHslString:function(){var e=c(this._r,this._g,this._b),t=G(360*e.h),n=G(100*e.s),r=G(100*e.l);return 1==this._a?"hsl("+t+", "+n+"%, "+r+"%)":"hsla("+t+", "+n+"%, "+r+"%, "+this._roundA+")"},toHex:function(e){return d(this._r,this._g,this._b,e)},toHexString:function(e){return"#"+this.toHex(e)},toHex8:function(e){return h(this._r,this._g,this._b,this._a,e)},toHex8String:function(e){return"#"+this.toHex8(e)},toRgb:function(){return{r:G(this._r),g:G(this._g),b:G(this._b),a:this._a}},toRgbString:function(){return 1==this._a?"rgb("+G(this._r)+", "+G(this._g)+", "+G(this._b)+")":"rgba("+G(this._r)+", "+G(this._g)+", "+G(this._b)+", "+this._roundA+")"},toPercentageRgb:function(){return{r:G(100*E(this._r,255))+"%",g:G(100*E(this._g,255))+"%",b:G(100*E(this._b,255))+"%",a:this._a}},toPercentageRgbString:function(){return 1==this._a?"rgb("+G(100*E(this._r,255))+"%, "+G(100*E(this._g,255))+"%, "+G(100*E(this._b,255))+"%)":"rgba("+G(100*E(this._r,255))+"%, "+G(100*E(this._g,255))+"%, "+G(100*E(this._b,255))+"%, "+this._roundA+")"},toName:function(){return 0===this._a?"transparent":!(this._a<1)&&(Y[d(this._r,this._g,this._b,!0)]||!1)},toFilter:function(e){var t="#"+p(this._r,this._g,this._b,this._a),n=t,r=this._gradientType?"GradientType = 1, ":"";if(e){var i=o(e);n="#"+p(i._r,i._g,i._b,i._a)}return"progid:DXImageTransform.Microsoft.gradient("+r+"startColorstr="+t+",endColorstr="+n+")"},toString:function(e){var t=!!e;e=e||this._format;var n=!1,r=this._a<1&&this._a>=0;return t||!r||"hex"!==e&&"hex6"!==e&&"hex3"!==e&&"hex4"!==e&&"hex8"!==e&&"name"!==e?("rgb"===e&&(n=this.toRgbString()),"prgb"===e&&(n=this.toPercentageRgbString()),"hex"!==e&&"hex6"!==e||(n=this.toHexString()),"hex3"===e&&(n=this.toHexString(!0)),"hex4"===e&&(n=this.toHex8String(!0)),"hex8"===e&&(n=this.toHex8String()),"name"===e&&(n=this.toName()),"hsl"===e&&(n=this.toHslString()),"hsv"===e&&(n=this.toHsvString()),n||this.toHexString()):"name"===e&&0===this._a?this.toName():this.toRgbString()},clone:function(){return o(this.toString())},_applyModification:function(e,t){var n=e.apply(null,[this].concat([].slice.call(t)));return this._r=n._r,this._g=n._g,this._b=n._b,this.setAlpha(n._a),this},lighten:function(){return this._applyModification(x,arguments)},brighten:function(){return this._applyModification(m,arguments)},darken:function(){return this._applyModification(_,arguments)},desaturate:function(){return this._applyModification(v,arguments)},saturate:function(){return this._applyModification(g,arguments)},greyscale:function(){return this._applyModification(b,arguments)},spin:function(){return this._applyModification(w,arguments)},_applyCombination:function(e,t){return e.apply(null,[this].concat([].slice.call(t)))},analogous:function(){return this._applyCombination(S,arguments)},complement:function(){return this._applyCombination(y,arguments)},monochromatic:function(){return this._applyCombination(A,arguments)},splitcomplement:function(){return this._applyCombination(F,arguments)},triad:function(){return this._applyCombination(C,arguments)},tetrad:function(){return this._applyCombination(k,arguments)}},o.fromRatio=function(e,t){if("object"==typeof e){var n={};for(var r in e)e.hasOwnProperty(r)&&(n[r]="a"===r?e[r]:D(e[r]));e=n}return o(e,t)},o.equals=function(e,t){return!(!e||!t)&&o(e).toRgbString()==o(t).toRgbString()},o.random=function(){return o.fromRatio({r:X(),g:X(),b:X()})},o.mix=function(e,t,n){n=0===n?0:n||50;var r=o(e).toRgb(),i=o(t).toRgb(),a=n/100;return o({r:(i.r-r.r)*a+r.r,g:(i.g-r.g)*a+r.g,b:(i.b-r.b)*a+r.b,a:(i.a-r.a)*a+r.a})},o.readability=function(e,t){var n=o(e),r=o(t);return(i.max(n.getLuminance(),r.getLuminance())+.05)/(i.min(n.getLuminance(),r.getLuminance())+.05)},o.isReadable=function(e,t,n){var r,i,a=o.readability(e,t);switch(i=!1,r=z(n),r.level+r.size){case"AAsmall":case"AAAlarge":i=a>=4.5;break;case"AAlarge":i=a>=3;break;case"AAAsmall":i=a>=7}return i},o.mostReadable=function(e,t,n){var r,i,a,s,c=null,l=0;n=n||{},i=n.includeFallbackColors,a=n.level,s=n.size;for(var u=0;u<t.length;u++)(r=o.readability(e,t[u]))>l&&(l=r,c=o(t[u]));return o.isReadable(e,c,{level:a,size:s})||!i?c:(n.includeFallbackColors=!1,o.mostReadable(e,["#fff","#000"],n))};var W=o.names={aliceblue:"f0f8ff",antiquewhite:"faebd7",aqua:"0ff",aquamarine:"7fffd4",azure:"f0ffff",beige:"f5f5dc",bisque:"ffe4c4",black:"000",blanchedalmond:"ffebcd",blue:"00f",blueviolet:"8a2be2",brown:"a52a2a",burlywood:"deb887",burntsienna:"ea7e5d",cadetblue:"5f9ea0",chartreuse:"7fff00",chocolate:"d2691e",coral:"ff7f50",cornflowerblue:"6495ed",cornsilk:"fff8dc",crimson:"dc143c",cyan:"0ff",darkblue:"00008b",darkcyan:"008b8b",darkgoldenrod:"b8860b",darkgray:"a9a9a9",darkgreen:"006400",darkgrey:"a9a9a9",darkkhaki:"bdb76b",darkmagenta:"8b008b",darkolivegreen:"556b2f",darkorange:"ff8c00",darkorchid:"9932cc",darkred:"8b0000",darksalmon:"e9967a",darkseagreen:"8fbc8f",darkslateblue:"483d8b",darkslategray:"2f4f4f",darkslategrey:"2f4f4f",darkturquoise:"00ced1",darkviolet:"9400d3",deeppink:"ff1493",deepskyblue:"00bfff",dimgray:"696969",dimgrey:"696969",dodgerblue:"1e90ff",firebrick:"b22222",floralwhite:"fffaf0",forestgreen:"228b22",fuchsia:"f0f",gainsboro:"dcdcdc",ghostwhite:"f8f8ff",gold:"ffd700",goldenrod:"daa520",gray:"808080",green:"008000",greenyellow:"adff2f",grey:"808080",honeydew:"f0fff0",hotpink:"ff69b4",indianred:"cd5c5c",indigo:"4b0082",ivory:"fffff0",khaki:"f0e68c",lavender:"e6e6fa",lavenderblush:"fff0f5",lawngreen:"7cfc00",lemonchiffon:"fffacd",lightblue:"add8e6",lightcoral:"f08080",lightcyan:"e0ffff",lightgoldenrodyellow:"fafad2",lightgray:"d3d3d3",lightgreen:"90ee90",lightgrey:"d3d3d3",lightpink:"ffb6c1",lightsalmon:"ffa07a",lightseagreen:"20b2aa",lightskyblue:"87cefa",lightslategray:"789",lightslategrey:"789",lightsteelblue:"b0c4de",lightyellow:"ffffe0",lime:"0f0",limegreen:"32cd32",linen:"faf0e6",magenta:"f0f",maroon:"800000",mediumaquamarine:"66cdaa",mediumblue:"0000cd",mediumorchid:"ba55d3",mediumpurple:"9370db",mediumseagreen:"3cb371",mediumslateblue:"7b68ee",mediumspringgreen:"00fa9a",mediumturquoise:"48d1cc",mediumvioletred:"c71585",midnightblue:"191970",mintcream:"f5fffa",mistyrose:"ffe4e1",moccasin:"ffe4b5",navajowhite:"ffdead",navy:"000080",oldlace:"fdf5e6",olive:"808000",olivedrab:"6b8e23",orange:"ffa500",orangered:"ff4500",orchid:"da70d6",palegoldenrod:"eee8aa",palegreen:"98fb98",paleturquoise:"afeeee",palevioletred:"db7093",papayawhip:"ffefd5",peachpuff:"ffdab9",peru:"cd853f",pink:"ffc0cb",plum:"dda0dd",powderblue:"b0e0e6",purple:"800080",rebeccapurple:"663399",red:"f00",rosybrown:"bc8f8f",royalblue:"4169e1",saddlebrown:"8b4513",salmon:"fa8072",sandybrown:"f4a460",seagreen:"2e8b57",seashell:"fff5ee",sienna:"a0522d",silver:"c0c0c0",skyblue:"87ceeb",slateblue:"6a5acd",slategray:"708090",slategrey:"708090",snow:"fffafa",springgreen:"00ff7f",steelblue:"4682b4",tan:"d2b48c",teal:"008080",thistle:"d8bfd8",tomato:"ff6347",turquoise:"40e0d0",violet:"ee82ee",wheat:"f5deb3",white:"fff",whitesmoke:"f5f5f5",yellow:"ff0",yellowgreen:"9acd32"},Y=o.hexNames=function(e){var t={};for(var n in e)e.hasOwnProperty(n)&&(t[e[n]]=n);return t}(W),J=function(){var e="(?:[-\\+]?\\d*\\.\\d+%?)|(?:[-\\+]?\\d+%?)",t="[\\s|\\(]+("+e+")[,|\\s]+("+e+")[,|\\s]+("+e+")\\s*\\)?",n="[\\s|\\(]+("+e+")[,|\\s]+("+e+")[,|\\s]+("+e+")[,|\\s]+("+e+")\\s*\\)?";return{CSS_UNIT:new RegExp(e),rgb:new RegExp("rgb"+t),rgba:new RegExp("rgba"+n),hsl:new RegExp("hsl"+t),hsla:new RegExp("hsla"+n),hsv:new RegExp("hsv"+t),hsva:new RegExp("hsva"+n),hex3:/^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,hex6:/^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,hex4:/^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,hex8:/^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/}}();void 0!==e&&e.exports?e.exports=o:void 0!==(r=function(){return o}.call(t,n,t,e))&&(e.exports=r)}(Math)},function(e,t,n){var r=n(67);"string"==typeof r&&(r=[[e.i,r,""]]),r.locals&&(e.exports=r.locals);n(1)("0f73e73c",r,!1,{})},function(e,t,n){t=e.exports=n(0)(!1),t.push([e.i,"\n.vc-editable-input {\n  position: relative;\n}\n.vc-input__input {\n  padding: 0;\n  border: 0;\n  outline: none;\n}\n.vc-input__label {\n  text-transform: capitalize;\n}\n",""])},function(e,t,n){"use strict";var r=function(){var e=this,t=e.$createElement,n=e._self._c||t;return n("div",{staticClass:"vc-editable-input"},[n("input",{directives:[{name:"model",rawName:"v-model",value:e.val,expression:"val"}],ref:"input",staticClass:"vc-input__input",attrs:{"aria-labelledby":e.labelId},domProps:{value:e.val},on:{keydown:e.handleKeyDown,input:[function(t){t.target.composing||(e.val=t.target.value)},e.update]}}),e._v(" "),n("span",{staticClass:"vc-input__label",attrs:{for:e.label,id:e.labelId}},[e._v(e._s(e.labelSpanText))]),e._v(" "),n("span",{staticClass:"vc-input__desc"},[e._v(e._s(e.desc))])])},i=[];r._withStripped=!0;var o={render:r,staticRenderFns:i};t.a=o},function(e,t,n){"use strict";var r=function(){var e=this,t=e.$createElement,n=e._self._c||t;return n("div",{staticClass:"vc-compact",attrs:{role:"application","aria-label":"Compact color picker"}},[n("ul",{staticClass:"vc-compact-colors",attrs:{role:"listbox"}},e._l(e.paletteUpperCase(e.palette),function(t){return n("li",{key:t,staticClass:"vc-compact-color-item",class:{"vc-compact-color-item--white":"#FFFFFF"===t},style:{background:t},attrs:{role:"option","aria-label":"color:"+t,"aria-selected":t===e.pick},on:{click:function(n){return e.handlerClick(t)}}},[n("div",{directives:[{name:"show",rawName:"v-show",value:t===e.pick,expression:"c === pick"}],staticClass:"vc-compact-dot"})])}),0)])},i=[];r._withStripped=!0;var o={render:r,staticRenderFns:i};t.a=o},function(e,t,n){"use strict";function r(e){c||n(71)}Object.defineProperty(t,"__esModule",{value:!0});var i=n(37),o=n.n(i);for(var a in i)"default"!==a&&function(e){n.d(t,e,function(){return i[e]})}(a);var s=n(73),c=!1,l=n(2),u=r,f=l(o.a,s.a,!1,u,null,null);f.options.__file="src/components/Grayscale.vue",t.default=f.exports},function(e,t,n){var r=n(72);"string"==typeof r&&(r=[[e.i,r,""]]),r.locals&&(e.exports=r.locals);n(1)("21ddbb74",r,!1,{})},function(e,t,n){t=e.exports=n(0)(!1),t.push([e.i,"\n.vc-grayscale {\n  width: 125px;\n  border-radius: 2px;\n  box-shadow: 0 2px 15px rgba(0,0,0,.12), 0 2px 10px rgba(0,0,0,.16);\n  background-color: #fff;\n}\n.vc-grayscale-colors {\n  border-radius: 2px;\n  overflow: hidden;\n  padding: 0;\n  margin: 0;\n}\n.vc-grayscale-color-item {\n  list-style: none;\n  width: 25px;\n  height: 25px;\n  float: left;\n  position: relative;\n  cursor: pointer;\n}\n.vc-grayscale-color-item--white .vc-grayscale-dot {\n  background: #000;\n}\n.vc-grayscale-dot {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  width: 6px;\n  height: 6px;\n  margin: -3px 0 0 -2px;\n  border-radius: 50%;\n  opacity: 1;\n  background: #fff;\n}\n",""])},function(e,t,n){"use strict";var r=function(){var e=this,t=e.$createElement,n=e._self._c||t;return n("div",{staticClass:"vc-grayscale",attrs:{role:"application","aria-label":"Grayscale color picker"}},[n("ul",{staticClass:"vc-grayscale-colors",attrs:{role:"listbox"}},e._l(e.paletteUpperCase(e.palette),function(t){return n("li",{key:t,staticClass:"vc-grayscale-color-item",class:{"vc-grayscale-color-item--white":"#FFFFFF"==t},style:{background:t},attrs:{role:"option","aria-label":"Color:"+t,"aria-selected":t===e.pick},on:{click:function(n){return e.handlerClick(t)}}},[n("div",{directives:[{name:"show",rawName:"v-show",value:t===e.pick,expression:"c === pick"}],staticClass:"vc-grayscale-dot"})])}),0)])},i=[];r._withStripped=!0;var o={render:r,staticRenderFns:i};t.a=o},function(e,t,n){"use strict";function r(e){c||n(75)}Object.defineProperty(t,"__esModule",{value:!0});var i=n(38),o=n.n(i);for(var a in i)"default"!==a&&function(e){n.d(t,e,function(){return i[e]})}(a);var s=n(77),c=!1,l=n(2),u=r,f=l(o.a,s.a,!1,u,null,null);f.options.__file="src/components/Material.vue",t.default=f.exports},function(e,t,n){var r=n(76);"string"==typeof r&&(r=[[e.i,r,""]]),r.locals&&(e.exports=r.locals);n(1)("1ff3af73",r,!1,{})},function(e,t,n){t=e.exports=n(0)(!1),t.push([e.i,'\n.vc-material {\n  width: 98px;\n  height: 98px;\n  padding: 16px;\n  font-family: "Roboto";\n  position: relative;\n  border-radius: 2px;\n  box-shadow: 0 2px 10px rgba(0,0,0,.12), 0 2px 5px rgba(0,0,0,.16);\n  background-color: #fff;\n}\n.vc-material .vc-input__input {\n  width: 100%;\n  margin-top: 12px;\n  font-size: 15px;\n  color: #333;\n  height: 30px;\n}\n.vc-material .vc-input__label {\n  position: absolute;\n  top: 0;\n  left: 0;\n  font-size: 11px;\n  color: #999;\n  text-transform: capitalize;\n}\n.vc-material-hex {\n  border-bottom-width: 2px;\n  border-bottom-style: solid;\n}\n.vc-material-split {\n  display: flex;\n  margin-right: -10px;\n  padding-top: 11px;\n}\n.vc-material-third {\n  flex: 1;\n  padding-right: 10px;\n}\n',""])},function(e,t,n){"use strict";var r=function(){var e=this,t=e.$createElement,n=e._self._c||t;return n("div",{staticClass:"vc-material",attrs:{role:"application","aria-label":"Material color picker"}},[n("ed-in",{staticClass:"vc-material-hex",style:{borderColor:e.colors.hex},attrs:{label:"hex"},on:{change:e.onChange},model:{value:e.colors.hex,callback:function(t){e.$set(e.colors,"hex",t)},expression:"colors.hex"}}),e._v(" "),n("div",{staticClass:"vc-material-split"},[n("div",{staticClass:"vc-material-third"},[n("ed-in",{attrs:{label:"r"},on:{change:e.onChange},model:{value:e.colors.rgba.r,callback:function(t){e.$set(e.colors.rgba,"r",t)},expression:"colors.rgba.r"}})],1),e._v(" "),n("div",{staticClass:"vc-material-third"},[n("ed-in",{attrs:{label:"g"},on:{change:e.onChange},model:{value:e.colors.rgba.g,callback:function(t){e.$set(e.colors.rgba,"g",t)},expression:"colors.rgba.g"}})],1),e._v(" "),n("div",{staticClass:"vc-material-third"},[n("ed-in",{attrs:{label:"b"},on:{change:e.onChange},model:{value:e.colors.rgba.b,callback:function(t){e.$set(e.colors.rgba,"b",t)},expression:"colors.rgba.b"}})],1)])],1)},i=[];r._withStripped=!0;var o={render:r,staticRenderFns:i};t.a=o},function(e,t,n){"use strict";function r(e){c||n(79)}Object.defineProperty(t,"__esModule",{value:!0});var i=n(39),o=n.n(i);for(var a in i)"default"!==a&&function(e){n.d(t,e,function(){return i[e]})}(a);var s=n(114),c=!1,l=n(2),u=r,f=l(o.a,s.a,!1,u,null,null);f.options.__file="src/components/Slider.vue",t.default=f.exports},function(e,t,n){var r=n(80);"string"==typeof r&&(r=[[e.i,r,""]]),r.locals&&(e.exports=r.locals);n(1)("7982aa43",r,!1,{})},function(e,t,n){t=e.exports=n(0)(!1),t.push([e.i,"\n.vc-slider {\n  position: relative;\n  width: 410px;\n}\n.vc-slider-hue-warp {\n  height: 12px;\n  position: relative;\n}\n.vc-slider-hue-warp .vc-hue-picker {\n  width: 14px;\n  height: 14px;\n  border-radius: 6px;\n  transform: translate(-7px, -2px);\n  background-color: rgb(248, 248, 248);\n  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.37);\n}\n.vc-slider-swatches {\n  display: flex;\n  margin-top: 20px;\n}\n.vc-slider-swatch {\n  margin-right: 1px;\n  flex: 1;\n  width: 20%;\n}\n.vc-slider-swatch:first-child {\n  margin-right: 1px;\n}\n.vc-slider-swatch:first-child .vc-slider-swatch-picker {\n  border-radius: 2px 0px 0px 2px;\n}\n.vc-slider-swatch:last-child {\n  margin-right: 0;\n}\n.vc-slider-swatch:last-child .vc-slider-swatch-picker {\n  border-radius: 0px 2px 2px 0px;\n}\n.vc-slider-swatch-picker {\n  cursor: pointer;\n  height: 12px;\n}\n.vc-slider-swatch:nth-child(n) .vc-slider-swatch-picker.vc-slider-swatch-picker--active {\n  transform: scaleY(1.8);\n  border-radius: 3.6px/2px;\n}\n.vc-slider-swatch-picker--white {\n  box-shadow: inset 0 0 0 1px #ddd;\n}\n.vc-slider-swatch-picker--active.vc-slider-swatch-picker--white {\n  box-shadow: inset 0 0 0 0.6px #ddd;\n}\n",""])},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}t.__esModule=!0;var i=n(82),o=r(i),a=n(100),s=r(a),c="function"==typeof s.default&&"symbol"==typeof o.default?function(e){return typeof e}:function(e){return e&&"function"==typeof s.default&&e.constructor===s.default&&e!==s.default.prototype?"symbol":typeof e};t.default="function"==typeof s.default&&"symbol"===c(o.default)?function(e){return void 0===e?"undefined":c(e)}:function(e){return e&&"function"==typeof s.default&&e.constructor===s.default&&e!==s.default.prototype?"symbol":void 0===e?"undefined":c(e)}},function(e,t,n){e.exports={default:n(83),__esModule:!0}},function(e,t,n){n(84),n(96),e.exports=n(32).f("iterator")},function(e,t,n){"use strict";var r=n(85)(!0);n(40)(String,"String",function(e){this._t=String(e),this._i=0},function(){var e,t=this._t,n=this._i;return n>=t.length?{value:void 0,done:!0}:(e=r(t,n),this._i+=e.length,{value:e,done:!1})})},function(e,t,n){var r=n(23),i=n(24);e.exports=function(e){return function(t,n){var o,a,s=String(i(t)),c=r(n),l=s.length;return c<0||c>=l?e?"":void 0:(o=s.charCodeAt(c),o<55296||o>56319||c+1===l||(a=s.charCodeAt(c+1))<56320||a>57343?e?s.charAt(c):o:e?s.slice(c,c+2):a-56320+(o-55296<<10)+65536)}}},function(e,t,n){var r=n(87);e.exports=function(e,t,n){if(r(e),void 0===t)return e;switch(n){case 1:return function(n){return e.call(t,n)};case 2:return function(n,r){return e.call(t,n,r)};case 3:return function(n,r,i){return e.call(t,n,r,i)}}return function(){return e.apply(t,arguments)}}},function(e,t){e.exports=function(e){if("function"!=typeof e)throw TypeError(e+" is not a function!");return e}},function(e,t,n){"use strict";var r=n(45),i=n(18),o=n(31),a={};n(7)(a,n(11)("iterator"),function(){return this}),e.exports=function(e,t,n){e.prototype=r(a,{next:i(1,n)}),o(e,t+" Iterator")}},function(e,t,n){var r=n(8),i=n(16),o=n(27);e.exports=n(9)?Object.defineProperties:function(e,t){i(e);for(var n,a=o(t),s=a.length,c=0;s>c;)r.f(e,n=a[c++],t[n]);return e}},function(e,t,n){var r=n(47);e.exports=Object("z").propertyIsEnumerable(0)?Object:function(e){return"String"==r(e)?e.split(""):Object(e)}},function(e,t,n){var r=n(10),i=n(92),o=n(93);e.exports=function(e){return function(t,n,a){var s,c=r(t),l=i(c.length),u=o(a,l);if(e&&n!=n){for(;l>u;)if((s=c[u++])!=s)return!0}else for(;l>u;u++)if((e||u in c)&&c[u]===n)return e||u||0;return!e&&-1}}},function(e,t,n){var r=n(23),i=Math.min;e.exports=function(e){return e>0?i(r(e),9007199254740991):0}},function(e,t,n){var r=n(23),i=Math.max,o=Math.min;e.exports=function(e,t){return e=r(e),e<0?i(e+t,0):o(e,t)}},function(e,t,n){var r=n(4).document;e.exports=r&&r.documentElement},function(e,t,n){var r=n(6),i=n(48),o=n(28)("IE_PROTO"),a=Object.prototype;e.exports=Object.getPrototypeOf||function(e){return e=i(e),r(e,o)?e[o]:"function"==typeof e.constructor&&e instanceof e.constructor?e.constructor.prototype:e instanceof Object?a:null}},function(e,t,n){n(97);for(var r=n(4),i=n(7),o=n(26),a=n(11)("toStringTag"),s="CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,TextTrackList,TouchList".split(","),c=0;c<s.length;c++){var l=s[c],u=r[l],f=u&&u.prototype;f&&!f[a]&&i(f,a,l),o[l]=o.Array}},function(e,t,n){"use strict";var r=n(98),i=n(99),o=n(26),a=n(10);e.exports=n(40)(Array,"Array",function(e,t){this._t=a(e),this._i=0,this._k=t},function(){var e=this._t,t=this._k,n=this._i++;return!e||n>=e.length?(this._t=void 0,i(1)):"keys"==t?i(0,n):"values"==t?i(0,e[n]):i(0,[n,e[n]])},"values"),o.Arguments=o.Array,r("keys"),r("values"),r("entries")},function(e,t){e.exports=function(){}},function(e,t){e.exports=function(e,t){return{value:t,done:!!e}}},function(e,t,n){e.exports={default:n(101),__esModule:!0}},function(e,t,n){n(102),n(108),n(109),n(110),e.exports=n(15).Symbol},function(e,t,n){"use strict";var r=n(4),i=n(6),o=n(9),a=n(41),s=n(44),c=n(103).KEY,l=n(17),u=n(29),f=n(31),d=n(19),h=n(11),p=n(32),v=n(33),g=n(104),b=n(105),x=n(16),m=n(12),_=n(48),w=n(10),y=n(25),C=n(18),k=n(45),F=n(106),S=n(107),A=n(49),O=n(8),E=n(27),M=S.f,j=O.f,L=F.f,P=r.Symbol,R=r.JSON,D=R&&R.stringify,B=h("_hidden"),T=h("toPrimitive"),H={}.propertyIsEnumerable,N=u("symbol-registry"),z=u("symbols"),I=u("op-symbols"),$=Object.prototype,U="function"==typeof P&&!!A.f,G=r.QObject,V=!G||!G.prototype||!G.prototype.findChild,q=o&&l(function(){return 7!=k(j({},"a",{get:function(){return j(this,"a",{value:7}).a}})).a})?function(e,t,n){var r=M($,t);r&&delete $[t],j(e,t,n),r&&e!==$&&j($,t,r)}:j,X=function(e){var t=z[e]=k(P.prototype);return t._k=e,t},W=U&&"symbol"==typeof P.iterator?function(e){return"symbol"==typeof e}:function(e){return e instanceof P},Y=function(e,t,n){return e===$&&Y(I,t,n),x(e),t=y(t,!0),x(n),i(z,t)?(n.enumerable?(i(e,B)&&e[B][t]&&(e[B][t]=!1),n=k(n,{enumerable:C(0,!1)})):(i(e,B)||j(e,B,C(1,{})),e[B][t]=!0),q(e,t,n)):j(e,t,n)},J=function(e,t){x(e);for(var n,r=g(t=w(t)),i=0,o=r.length;o>i;)Y(e,n=r[i++],t[n]);return e},K=function(e,t){return void 0===t?k(e):J(k(e),t)},Z=function(e){var t=H.call(this,e=y(e,!0));return!(this===$&&i(z,e)&&!i(I,e))&&(!(t||!i(this,e)||!i(z,e)||i(this,B)&&this[B][e])||t)},Q=function(e,t){if(e=w(e),t=y(t,!0),e!==$||!i(z,t)||i(I,t)){var n=M(e,t);return!n||!i(z,t)||i(e,B)&&e[B][t]||(n.enumerable=!0),n}},ee=function(e){for(var t,n=L(w(e)),r=[],o=0;n.length>o;)i(z,t=n[o++])||t==B||t==c||r.push(t);return r},te=function(e){for(var t,n=e===$,r=L(n?I:w(e)),o=[],a=0;r.length>a;)!i(z,t=r[a++])||n&&!i($,t)||o.push(z[t]);return o};U||(P=function(){if(this instanceof P)throw TypeError("Symbol is not a constructor!");var e=d(arguments.length>0?arguments[0]:void 0),t=function(n){this===$&&t.call(I,n),i(this,B)&&i(this[B],e)&&(this[B][e]=!1),q(this,e,C(1,n))};return o&&V&&q($,e,{configurable:!0,set:t}),X(e)},s(P.prototype,"toString",function(){return this._k}),S.f=Q,O.f=Y,n(50).f=F.f=ee,n(34).f=Z,A.f=te,o&&!n(14)&&s($,"propertyIsEnumerable",Z,!0),p.f=function(e){return X(h(e))}),a(a.G+a.W+a.F*!U,{Symbol:P});for(var ne="hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables".split(","),re=0;ne.length>re;)h(ne[re++]);for(var ie=E(h.store),oe=0;ie.length>oe;)v(ie[oe++]);a(a.S+a.F*!U,"Symbol",{for:function(e){return i(N,e+="")?N[e]:N[e]=P(e)},keyFor:function(e){if(!W(e))throw TypeError(e+" is not a symbol!");for(var t in N)if(N[t]===e)return t},useSetter:function(){V=!0},useSimple:function(){V=!1}}),a(a.S+a.F*!U,"Object",{create:K,defineProperty:Y,defineProperties:J,getOwnPropertyDescriptor:Q,getOwnPropertyNames:ee,getOwnPropertySymbols:te});var ae=l(function(){A.f(1)});a(a.S+a.F*ae,"Object",{getOwnPropertySymbols:function(e){return A.f(_(e))}}),R&&a(a.S+a.F*(!U||l(function(){var e=P();return"[null]"!=D([e])||"{}"!=D({a:e})||"{}"!=D(Object(e))})),"JSON",{stringify:function(e){for(var t,n,r=[e],i=1;arguments.length>i;)r.push(arguments[i++]);if(n=t=r[1],(m(t)||void 0!==e)&&!W(e))return b(t)||(t=function(e,t){if("function"==typeof n&&(t=n.call(this,e,t)),!W(t))return t}),r[1]=t,D.apply(R,r)}}),P.prototype[T]||n(7)(P.prototype,T,P.prototype.valueOf),f(P,"Symbol"),f(Math,"Math",!0),f(r.JSON,"JSON",!0)},function(e,t,n){var r=n(19)("meta"),i=n(12),o=n(6),a=n(8).f,s=0,c=Object.isExtensible||function(){return!0},l=!n(17)(function(){return c(Object.preventExtensions({}))}),u=function(e){a(e,r,{value:{i:"O"+ ++s,w:{}}})},f=function(e,t){if(!i(e))return"symbol"==typeof e?e:("string"==typeof e?"S":"P")+e;if(!o(e,r)){if(!c(e))return"F";if(!t)return"E";u(e)}return e[r].i},d=function(e,t){if(!o(e,r)){if(!c(e))return!0;if(!t)return!1;u(e)}return e[r].w},h=function(e){return l&&p.NEED&&c(e)&&!o(e,r)&&u(e),e},p=e.exports={KEY:r,NEED:!1,fastKey:f,getWeak:d,onFreeze:h}},function(e,t,n){var r=n(27),i=n(49),o=n(34);e.exports=function(e){var t=r(e),n=i.f;if(n)for(var a,s=n(e),c=o.f,l=0;s.length>l;)c.call(e,a=s[l++])&&t.push(a);return t}},function(e,t,n){var r=n(47);e.exports=Array.isArray||function(e){return"Array"==r(e)}},function(e,t,n){var r=n(10),i=n(50).f,o={}.toString,a="object"==typeof window&&window&&Object.getOwnPropertyNames?Object.getOwnPropertyNames(window):[],s=function(e){try{return i(e)}catch(e){return a.slice()}};e.exports.f=function(e){return a&&"[object Window]"==o.call(e)?s(e):i(r(e))}},function(e,t,n){var r=n(34),i=n(18),o=n(10),a=n(25),s=n(6),c=n(42),l=Object.getOwnPropertyDescriptor;t.f=n(9)?l:function(e,t){if(e=o(e),t=a(t,!0),c)try{return l(e,t)}catch(e){}if(s(e,t))return i(!r.f.call(e,t),e[t])}},function(e,t){},function(e,t,n){n(33)("asyncIterator")},function(e,t,n){n(33)("observable")},function(e,t,n){var r=n(112);"string"==typeof r&&(r=[[e.i,r,""]]),r.locals&&(e.exports=r.locals);n(1)("7c5f1a1c",r,!1,{})},function(e,t,n){t=e.exports=n(0)(!1),t.push([e.i,"\n.vc-hue {\n  position: absolute;\n  top: 0px;\n  right: 0px;\n  bottom: 0px;\n  left: 0px;\n  border-radius: 2px;\n}\n.vc-hue--horizontal {\n  background: linear-gradient(to right, #f00 0%, #ff0 17%, #0f0 33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n}\n.vc-hue--vertical {\n  background: linear-gradient(to top, #f00 0%, #ff0 17%, #0f0 33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n}\n.vc-hue-container {\n  cursor: pointer;\n  margin: 0 2px;\n  position: relative;\n  height: 100%;\n}\n.vc-hue-pointer {\n  z-index: 2;\n  position: absolute;\n}\n.vc-hue-picker {\n  cursor: pointer;\n  margin-top: 1px;\n  width: 4px;\n  border-radius: 1px;\n  height: 8px;\n  box-shadow: 0 0 2px rgba(0, 0, 0, .6);\n  background: #fff;\n  transform: translateX(-2px) ;\n}\n",""])},function(e,t,n){"use strict";var r=function(){var e=this,t=e.$createElement,n=e._self._c||t;return n("div",{class:["vc-hue",e.directionClass]},[n("div",{ref:"container",staticClass:"vc-hue-container",attrs:{role:"slider","aria-valuenow":e.colors.hsl.h,"aria-valuemin":"0","aria-valuemax":"360"},on:{mousedown:e.handleMouseDown,touchmove:e.handleChange,touchstart:e.handleChange}},[n("div",{staticClass:"vc-hue-pointer",style:{top:e.pointerTop,left:e.pointerLeft},attrs:{role:"presentation"}},[n("div",{staticClass:"vc-hue-picker"})])])])},i=[];r._withStripped=!0;var o={render:r,staticRenderFns:i};t.a=o},function(e,t,n){"use strict";var r=function(){var e=this,t=e.$createElement,n=e._self._c||t;return n("div",{staticClass:"vc-slider",attrs:{role:"application","aria-label":"Slider color picker"}},[n("div",{staticClass:"vc-slider-hue-warp"},[n("hue",{on:{change:e.hueChange},model:{value:e.colors,callback:function(t){e.colors=t},expression:"colors"}})],1),e._v(" "),n("div",{staticClass:"vc-slider-swatches",attrs:{role:"group"}},e._l(e.normalizedSwatches,function(t,r){return n("div",{key:r,staticClass:"vc-slider-swatch",attrs:{"data-index":r,"aria-label":"color:"+e.colors.hex,role:"button"},on:{click:function(n){return e.handleSwClick(r,t)}}},[n("div",{staticClass:"vc-slider-swatch-picker",class:{"vc-slider-swatch-picker--active":e.isActive(t,r),"vc-slider-swatch-picker--white":1===t.l},style:{background:"hsl("+e.colors.hsl.h+", "+100*t.s+"%, "+100*t.l+"%)"}})])}),0)])},i=[];r._withStripped=!0;var o={render:r,staticRenderFns:i};t.a=o},function(e,t,n){"use strict";function r(e){c||n(116)}Object.defineProperty(t,"__esModule",{value:!0});var i=n(52),o=n.n(i);for(var a in i)"default"!==a&&function(e){n.d(t,e,function(){return i[e]})}(a);var s=n(119),c=!1,l=n(2),u=r,f=l(o.a,s.a,!1,u,null,null);f.options.__file="src/components/Swatches.vue",t.default=f.exports},function(e,t,n){var r=n(117);"string"==typeof r&&(r=[[e.i,r,""]]),r.locals&&(e.exports=r.locals);n(1)("10f839a2",r,!1,{})},function(e,t,n){t=e.exports=n(0)(!1),t.push([e.i,"\n.vc-swatches {\n  width: 320px;\n  height: 240px;\n  overflow-y: scroll;\n  background-color: #fff;\n  box-shadow: 0 2px 10px rgba(0,0,0,.12), 0 2px 5px rgba(0,0,0,.16);\n}\n.vc-swatches-box {\n  padding: 16px 0 6px 16px;\n  overflow: hidden;\n}\n.vc-swatches-color-group {\n  padding-bottom: 10px;\n  width: 40px;\n  float: left;\n  margin-right: 10px;\n}\n.vc-swatches-color-it {\n  box-sizing: border-box;\n  width: 40px;\n  height: 24px;\n  cursor: pointer;\n  background: #880e4f;\n  margin-bottom: 1px;\n  overflow: hidden;\n  -ms-border-radius: 2px 2px 0 0;\n  -moz-border-radius: 2px 2px 0 0;\n  -o-border-radius: 2px 2px 0 0;\n  -webkit-border-radius: 2px 2px 0 0;\n  border-radius: 2px 2px 0 0;\n}\n.vc-swatches-color--white {\n  border: 1px solid #DDD;\n}\n.vc-swatches-pick {\n  fill: rgb(255, 255, 255);\n  margin-left: 8px;\n  display: block;\n}\n.vc-swatches-color--white .vc-swatches-pick {\n  fill: rgb(51, 51, 51);\n}\n",""])},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),n.d(t,"red",function(){return r}),n.d(t,"pink",function(){return i}),n.d(t,"purple",function(){return o}),n.d(t,"deepPurple",function(){return a}),n.d(t,"indigo",function(){return s}),n.d(t,"blue",function(){return c}),n.d(t,"lightBlue",function(){return l}),n.d(t,"cyan",function(){return u}),n.d(t,"teal",function(){return f}),n.d(t,"green",function(){return d}),n.d(t,"lightGreen",function(){return h}),n.d(t,"lime",function(){return p}),n.d(t,"yellow",function(){return v}),n.d(t,"amber",function(){return g}),n.d(t,"orange",function(){return b}),n.d(t,"deepOrange",function(){return x}),n.d(t,"brown",function(){return m}),n.d(t,"grey",function(){return _}),n.d(t,"blueGrey",function(){return w}),n.d(t,"darkText",function(){return y}),n.d(t,"lightText",function(){return C}),n.d(t,"darkIcons",function(){return k}),n.d(t,"lightIcons",function(){return F}),n.d(t,"white",function(){return S}),n.d(t,"black",function(){return A});var r={50:"#ffebee",100:"#ffcdd2",200:"#ef9a9a",300:"#e57373",400:"#ef5350",500:"#f44336",600:"#e53935",700:"#d32f2f",800:"#c62828",900:"#b71c1c",a100:"#ff8a80",a200:"#ff5252",a400:"#ff1744",a700:"#d50000"},i={50:"#fce4ec",100:"#f8bbd0",200:"#f48fb1",300:"#f06292",400:"#ec407a",500:"#e91e63",600:"#d81b60",700:"#c2185b",800:"#ad1457",900:"#880e4f",a100:"#ff80ab",a200:"#ff4081",a400:"#f50057",a700:"#c51162"},o={50:"#f3e5f5",100:"#e1bee7",200:"#ce93d8",300:"#ba68c8",400:"#ab47bc",500:"#9c27b0",600:"#8e24aa",700:"#7b1fa2",800:"#6a1b9a",900:"#4a148c",a100:"#ea80fc",a200:"#e040fb",a400:"#d500f9",a700:"#aa00ff"},a={50:"#ede7f6",100:"#d1c4e9",200:"#b39ddb",300:"#9575cd",400:"#7e57c2",500:"#673ab7",600:"#5e35b1",700:"#512da8",800:"#4527a0",900:"#311b92",a100:"#b388ff",a200:"#7c4dff",a400:"#651fff",a700:"#6200ea"},s={50:"#e8eaf6",100:"#c5cae9",200:"#9fa8da",300:"#7986cb",400:"#5c6bc0",500:"#3f51b5",600:"#3949ab",700:"#303f9f",800:"#283593",900:"#1a237e",a100:"#8c9eff",a200:"#536dfe",a400:"#3d5afe",a700:"#304ffe"},c={50:"#e3f2fd",100:"#bbdefb",200:"#90caf9",300:"#64b5f6",400:"#42a5f5",500:"#2196f3",600:"#1e88e5",700:"#1976d2",800:"#1565c0",900:"#0d47a1",a100:"#82b1ff",a200:"#448aff",a400:"#2979ff",a700:"#2962ff"},l={50:"#e1f5fe",100:"#b3e5fc",200:"#81d4fa",300:"#4fc3f7",400:"#29b6f6",500:"#03a9f4",600:"#039be5",700:"#0288d1",800:"#0277bd",900:"#01579b",a100:"#80d8ff",a200:"#40c4ff",a400:"#00b0ff",a700:"#0091ea"},u={50:"#e0f7fa",100:"#b2ebf2",200:"#80deea",300:"#4dd0e1",400:"#26c6da",500:"#00bcd4",600:"#00acc1",700:"#0097a7",800:"#00838f",900:"#006064",a100:"#84ffff",a200:"#18ffff",a400:"#00e5ff",a700:"#00b8d4"},f={50:"#e0f2f1",100:"#b2dfdb",200:"#80cbc4",300:"#4db6ac",400:"#26a69a",500:"#009688",600:"#00897b",700:"#00796b",800:"#00695c",900:"#004d40",a100:"#a7ffeb",a200:"#64ffda",a400:"#1de9b6",a700:"#00bfa5"},d={50:"#e8f5e9",100:"#c8e6c9",200:"#a5d6a7",300:"#81c784",400:"#66bb6a",500:"#4caf50",600:"#43a047",700:"#388e3c",800:"#2e7d32",900:"#1b5e20",a100:"#b9f6ca",a200:"#69f0ae",a400:"#00e676",a700:"#00c853"},h={50:"#f1f8e9",100:"#dcedc8",200:"#c5e1a5",300:"#aed581",400:"#9ccc65",500:"#8bc34a",600:"#7cb342",700:"#689f38",800:"#558b2f",900:"#33691e",a100:"#ccff90",a200:"#b2ff59",a400:"#76ff03",a700:"#64dd17"},p={50:"#f9fbe7",100:"#f0f4c3",200:"#e6ee9c",300:"#dce775",400:"#d4e157",500:"#cddc39",600:"#c0ca33",700:"#afb42b",800:"#9e9d24",900:"#827717",a100:"#f4ff81",a200:"#eeff41",a400:"#c6ff00",a700:"#aeea00"},v={50:"#fffde7",100:"#fff9c4",200:"#fff59d",300:"#fff176",400:"#ffee58",500:"#ffeb3b",600:"#fdd835",700:"#fbc02d",800:"#f9a825",900:"#f57f17",a100:"#ffff8d",a200:"#ffff00",a400:"#ffea00",a700:"#ffd600"},g={50:"#fff8e1",100:"#ffecb3",200:"#ffe082",300:"#ffd54f",400:"#ffca28",500:"#ffc107",600:"#ffb300",700:"#ffa000",800:"#ff8f00",900:"#ff6f00",a100:"#ffe57f",a200:"#ffd740",a400:"#ffc400",a700:"#ffab00"},b={50:"#fff3e0",100:"#ffe0b2",200:"#ffcc80",300:"#ffb74d",400:"#ffa726",500:"#ff9800",600:"#fb8c00",700:"#f57c00",800:"#ef6c00",900:"#e65100",a100:"#ffd180",a200:"#ffab40",a400:"#ff9100",a700:"#ff6d00"},x={50:"#fbe9e7",100:"#ffccbc",200:"#ffab91",300:"#ff8a65",400:"#ff7043",500:"#ff5722",600:"#f4511e",700:"#e64a19",800:"#d84315",900:"#bf360c",a100:"#ff9e80",a200:"#ff6e40",a400:"#ff3d00",a700:"#dd2c00"},m={50:"#efebe9",100:"#d7ccc8",200:"#bcaaa4",300:"#a1887f",400:"#8d6e63",500:"#795548",600:"#6d4c41",700:"#5d4037",800:"#4e342e",900:"#3e2723"},_={50:"#fafafa",100:"#f5f5f5",200:"#eeeeee",300:"#e0e0e0",400:"#bdbdbd",500:"#9e9e9e",600:"#757575",700:"#616161",800:"#424242",900:"#212121"},w={50:"#eceff1",100:"#cfd8dc",200:"#b0bec5",300:"#90a4ae",400:"#78909c",500:"#607d8b",600:"#546e7a",700:"#455a64",800:"#37474f",900:"#263238"},y={primary:"rgba(0, 0, 0, 0.87)",secondary:"rgba(0, 0, 0, 0.54)",disabled:"rgba(0, 0, 0, 0.38)",dividers:"rgba(0, 0, 0, 0.12)"},C={primary:"rgba(255, 255, 255, 1)",secondary:"rgba(255, 255, 255, 0.7)",disabled:"rgba(255, 255, 255, 0.5)",dividers:"rgba(255, 255, 255, 0.12)"},k={active:"rgba(0, 0, 0, 0.54)",inactive:"rgba(0, 0, 0, 0.38)"},F={active:"rgba(255, 255, 255, 1)",inactive:"rgba(255, 255, 255, 0.5)"},S="#ffffff",A="#000000";t.default={red:r,pink:i,purple:o,deepPurple:a,indigo:s,blue:c,lightBlue:l,cyan:u,teal:f,green:d,lightGreen:h,lime:p,yellow:v,amber:g,orange:b,deepOrange:x,brown:m,grey:_,blueGrey:w,darkText:y,lightText:C,darkIcons:k,lightIcons:F,white:S,black:A}},function(e,t,n){"use strict";var r=function(){var e=this,t=e.$createElement,n=e._self._c||t;return n("div",{staticClass:"vc-swatches",attrs:{role:"application","aria-label":"Swatches color picker","data-pick":e.pick}},[n("div",{staticClass:"vc-swatches-box",attrs:{role:"listbox"}},e._l(e.palette,function(t,r){return n("div",{key:r,staticClass:"vc-swatches-color-group"},e._l(t,function(t){return n("div",{key:t,class:["vc-swatches-color-it",{"vc-swatches-color--white":"#FFFFFF"===t}],style:{background:t},attrs:{role:"option","aria-label":"Color:"+t,"aria-selected":e.equal(t),"data-color":t},on:{click:function(n){return e.handlerClick(t)}}},[n("div",{directives:[{name:"show",rawName:"v-show",value:e.equal(t),expression:"equal(c)"}],staticClass:"vc-swatches-pick"},[n("svg",{staticStyle:{width:"24px",height:"24px"},attrs:{viewBox:"0 0 24 24"}},[n("path",{attrs:{d:"M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z"}})])])])}),0)}),0)])},i=[];r._withStripped=!0;var o={render:r,staticRenderFns:i};t.a=o},function(e,t,n){"use strict";function r(e){c||n(121)}Object.defineProperty(t,"__esModule",{value:!0});var i=n(53),o=n.n(i);for(var a in i)"default"!==a&&function(e){n.d(t,e,function(){return i[e]})}(a);var s=n(134),c=!1,l=n(2),u=r,f=l(o.a,s.a,!1,u,null,null);f.options.__file="src/components/Photoshop.vue",t.default=f.exports},function(e,t,n){var r=n(122);"string"==typeof r&&(r=[[e.i,r,""]]),r.locals&&(e.exports=r.locals);n(1)("080365d4",r,!1,{})},function(e,t,n){t=e.exports=n(0)(!1),t.push([e.i,'\n.vc-photoshop {\n  background: #DCDCDC;\n  border-radius: 4px;\n  box-shadow: 0 0 0 1px rgba(0,0,0,.25), 0 8px 16px rgba(0,0,0,.15);\n  box-sizing: initial;\n  width: 513px;\n  font-family: Roboto;\n}\n.vc-photoshop__disable-fields {\n  width: 390px;\n}\n.vc-ps-head {\n  background-image: linear-gradient(-180deg, #F0F0F0 0%, #D4D4D4 100%);\n  border-bottom: 1px solid #B1B1B1;\n  box-shadow: inset 0 1px 0 0 rgba(255,255,255,.2), inset 0 -1px 0 0 rgba(0,0,0,.02);\n  height: 23px;\n  line-height: 24px;\n  border-radius: 4px 4px 0 0;\n  font-size: 13px;\n  color: #4D4D4D;\n  text-align: center;\n}\n.vc-ps-body {\n  padding: 15px;\n  display: flex;\n}\n.vc-ps-saturation-wrap {\n  width: 256px;\n  height: 256px;\n  position: relative;\n  border: 2px solid #B3B3B3;\n  border-bottom: 2px solid #F0F0F0;\n  overflow: hidden;\n}\n.vc-ps-saturation-wrap .vc-saturation-circle {\n  width: 12px;\n  height: 12px;\n}\n.vc-ps-hue-wrap {\n  position: relative;\n  height: 256px;\n  width: 19px;\n  margin-left: 10px;\n  border: 2px solid #B3B3B3;\n  border-bottom: 2px solid #F0F0F0;\n}\n.vc-ps-hue-pointer {\n  position: relative;\n}\n.vc-ps-hue-pointer--left,\n.vc-ps-hue-pointer--right {\n  position: absolute;\n  width: 0;\n  height: 0;\n  border-style: solid;\n  border-width: 5px 0 5px 8px;\n  border-color: transparent transparent transparent #555;\n}\n.vc-ps-hue-pointer--left:after,\n.vc-ps-hue-pointer--right:after {\n  content: "";\n  width: 0;\n  height: 0;\n  border-style: solid;\n  border-width: 4px 0 4px 6px;\n  border-color: transparent transparent transparent #fff;\n  position: absolute;\n  top: 1px;\n  left: 1px;\n  transform: translate(-8px, -5px);\n}\n.vc-ps-hue-pointer--left {\n  transform: translate(-13px, -4px);\n}\n.vc-ps-hue-pointer--right {\n  transform: translate(20px, -4px) rotate(180deg);\n}\n.vc-ps-controls {\n  width: 180px;\n  margin-left: 10px;\n  display: flex;\n}\n.vc-ps-controls__disable-fields {\n  width: auto;\n}\n.vc-ps-actions {\n  margin-left: 20px;\n  flex: 1;\n}\n.vc-ps-ac-btn {\n  cursor: pointer;\n  background-image: linear-gradient(-180deg, #FFFFFF 0%, #E6E6E6 100%);\n  border: 1px solid #878787;\n  border-radius: 2px;\n  height: 20px;\n  box-shadow: 0 1px 0 0 #EAEAEA;\n  font-size: 14px;\n  color: #000;\n  line-height: 20px;\n  text-align: center;\n  margin-bottom: 10px;\n}\n.vc-ps-previews {\n  width: 60px;\n}\n.vc-ps-previews__swatches {\n  border: 1px solid #B3B3B3;\n  border-bottom: 1px solid #F0F0F0;\n  margin-bottom: 2px;\n  margin-top: 1px;\n}\n.vc-ps-previews__pr-color {\n  height: 34px;\n  box-shadow: inset 1px 0 0 #000, inset -1px 0 0 #000, inset 0 1px 0 #000;\n}\n.vc-ps-previews__label {\n  font-size: 14px;\n  color: #000;\n  text-align: center;\n}\n.vc-ps-fields {\n  padding-top: 5px;\n  padding-bottom: 9px;\n  width: 80px;\n  position: relative;\n}\n.vc-ps-fields .vc-input__input {\n  margin-left: 40%;\n  width: 40%;\n  height: 18px;\n  border: 1px solid #888888;\n  box-shadow: inset 0 1px 1px rgba(0,0,0,.1), 0 1px 0 0 #ECECEC;\n  margin-bottom: 5px;\n  font-size: 13px;\n  padding-left: 3px;\n  margin-right: 10px;\n}\n.vc-ps-fields .vc-input__label, .vc-ps-fields .vc-input__desc {\n  top: 0;\n  text-transform: uppercase;\n  font-size: 13px;\n  height: 18px;\n  line-height: 22px;\n  position: absolute;\n}\n.vc-ps-fields .vc-input__label {\n  left: 0;\n  width: 34px;\n}\n.vc-ps-fields .vc-input__desc {\n  right: 0;\n  width: 0;\n}\n.vc-ps-fields__divider {\n  height: 5px;\n}\n.vc-ps-fields__hex .vc-input__input {\n  margin-left: 20%;\n  width: 80%;\n  height: 18px;\n  border: 1px solid #888888;\n  box-shadow: inset 0 1px 1px rgba(0,0,0,.1), 0 1px 0 0 #ECECEC;\n  margin-bottom: 6px;\n  font-size: 13px;\n  padding-left: 3px;\n}\n.vc-ps-fields__hex .vc-input__label {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 14px;\n  text-transform: uppercase;\n  font-size: 13px;\n  height: 18px;\n  line-height: 22px;\n}\n',""])},function(e,t,n){var r=n(124);"string"==typeof r&&(r=[[e.i,r,""]]),r.locals&&(e.exports=r.locals);n(1)("b5380e52",r,!1,{})},function(e,t,n){t=e.exports=n(0)(!1),t.push([e.i,"\n.vc-saturation,\n.vc-saturation--white,\n.vc-saturation--black {\n  cursor: pointer;\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n}\n.vc-saturation--white {\n  background: linear-gradient(to right, #fff, rgba(255,255,255,0));\n}\n.vc-saturation--black {\n  background: linear-gradient(to top, #000, rgba(0,0,0,0));\n}\n.vc-saturation-pointer {\n  cursor: pointer;\n  position: absolute;\n}\n.vc-saturation-circle {\n  cursor: head;\n  width: 4px;\n  height: 4px;\n  box-shadow: 0 0 0 1.5px #fff, inset 0 0 1px 1px rgba(0,0,0,.3), 0 0 1px 2px rgba(0,0,0,.4);\n  border-radius: 50%;\n  transform: translate(-2px, -2px);\n}\n",""])},function(e,t){function n(e,t,n){return t<n?e<t?t:e>n?n:e:e<n?n:e>t?t:e}e.exports=n},function(e,t){function n(e,t,n){function r(t){var n=v,r=g;return v=g=void 0,k=t,x=e.apply(r,n)}function o(e){return k=e,m=setTimeout(u,t),F?r(e):x}function a(e){var n=e-_,r=e-k,i=t-n;return S?y(i,b-r):i}function l(e){var n=e-_,r=e-k;return void 0===_||n>=t||n<0||S&&r>=b}function u(){var e=C();if(l(e))return f(e);m=setTimeout(u,a(e))}function f(e){return m=void 0,A&&v?r(e):(v=g=void 0,x)}function d(){void 0!==m&&clearTimeout(m),k=0,v=_=g=m=void 0}function h(){return void 0===m?x:f(C())}function p(){var e=C(),n=l(e);if(v=arguments,g=this,_=e,n){if(void 0===m)return o(_);if(S)return m=setTimeout(u,t),r(_)}return void 0===m&&(m=setTimeout(u,t)),x}var v,g,b,x,m,_,k=0,F=!1,S=!1,A=!0;if("function"!=typeof e)throw new TypeError(c);return t=s(t)||0,i(n)&&(F=!!n.leading,S="maxWait"in n,b=S?w(s(n.maxWait)||0,t):b,A="trailing"in n?!!n.trailing:A),p.cancel=d,p.flush=h,p}function r(e,t,r){var o=!0,a=!0;if("function"!=typeof e)throw new TypeError(c);return i(r)&&(o="leading"in r?!!r.leading:o,a="trailing"in r?!!r.trailing:a),n(e,t,{leading:o,maxWait:t,trailing:a})}function i(e){var t=typeof e;return!!e&&("object"==t||"function"==t)}function o(e){return!!e&&"object"==typeof e}function a(e){return"symbol"==typeof e||o(e)&&_.call(e)==u}function s(e){if("number"==typeof e)return e;if(a(e))return l;if(i(e)){var t="function"==typeof e.valueOf?e.valueOf():e;e=i(t)?t+"":t}if("string"!=typeof e)return 0===e?e:+e;e=e.replace(f,"");var n=h.test(e);return n||p.test(e)?v(e.slice(2),n?2:8):d.test(e)?l:+e}var c="Expected a function",l=NaN,u="[object Symbol]",f=/^\s+|\s+$/g,d=/^[-+]0x[0-9a-f]+$/i,h=/^0b[01]+$/i,p=/^0o[0-7]+$/i,v=parseInt,g="object"==typeof global&&global&&global.Object===Object&&global,b="object"==typeof self&&self&&self.Object===Object&&self,x=g||b||Function("return this")(),m=Object.prototype,_=m.toString,w=Math.max,y=Math.min,C=function(){return x.Date.now()};e.exports=r},function(e,t,n){"use strict";var r=function(){var e=this,t=e.$createElement,n=e._self._c||t;return n("div",{ref:"container",staticClass:"vc-saturation",style:{background:e.bgColor},on:{mousedown:e.handleMouseDown,touchmove:e.handleChange,touchstart:e.handleChange}},[n("div",{staticClass:"vc-saturation--white"}),e._v(" "),n("div",{staticClass:"vc-saturation--black"}),e._v(" "),n("div",{staticClass:"vc-saturation-pointer",style:{top:e.pointerTop,left:e.pointerLeft}},[n("div",{staticClass:"vc-saturation-circle"})])])},i=[];r._withStripped=!0;var o={render:r,staticRenderFns:i};t.a=o},function(e,t,n){var r=n(129);"string"==typeof r&&(r=[[e.i,r,""]]),r.locals&&(e.exports=r.locals);n(1)("4dc1b086",r,!1,{})},function(e,t,n){t=e.exports=n(0)(!1),t.push([e.i,"\n.vc-alpha {\n  position: absolute;\n  top: 0px;\n  right: 0px;\n  bottom: 0px;\n  left: 0px;\n}\n.vc-alpha-checkboard-wrap {\n  position: absolute;\n  top: 0px;\n  right: 0px;\n  bottom: 0px;\n  left: 0px;\n  overflow: hidden;\n}\n.vc-alpha-gradient {\n  position: absolute;\n  top: 0px;\n  right: 0px;\n  bottom: 0px;\n  left: 0px;\n}\n.vc-alpha-container {\n  cursor: pointer;\n  position: relative;\n  z-index: 2;\n  height: 100%;\n  margin: 0 3px;\n}\n.vc-alpha-pointer {\n  z-index: 2;\n  position: absolute;\n}\n.vc-alpha-picker {\n  cursor: pointer;\n  width: 4px;\n  border-radius: 1px;\n  height: 8px;\n  box-shadow: 0 0 2px rgba(0, 0, 0, .6);\n  background: #fff;\n  margin-top: 1px;\n  transform: translateX(-2px);\n}\n",""])},function(e,t,n){var r=n(131);"string"==typeof r&&(r=[[e.i,r,""]]),r.locals&&(e.exports=r.locals);n(1)("7e15c05b",r,!1,{})},function(e,t,n){t=e.exports=n(0)(!1),t.push([e.i,"\n.vc-checkerboard {\n  position: absolute;\n  top: 0px;\n  right: 0px;\n  bottom: 0px;\n  left: 0px;\n  background-size: contain;\n}\n",""])},function(e,t,n){"use strict";var r=function(){var e=this,t=e.$createElement;return(e._self._c||t)("div",{staticClass:"vc-checkerboard",style:e.bgStyle})},i=[];r._withStripped=!0;var o={render:r,staticRenderFns:i};t.a=o},function(e,t,n){"use strict";var r=function(){var e=this,t=e.$createElement,n=e._self._c||t;return n("div",{staticClass:"vc-alpha"},[n("div",{staticClass:"vc-alpha-checkboard-wrap"},[n("checkboard")],1),e._v(" "),n("div",{staticClass:"vc-alpha-gradient",style:{background:e.gradientColor}}),e._v(" "),n("div",{ref:"container",staticClass:"vc-alpha-container",on:{mousedown:e.handleMouseDown,touchmove:e.handleChange,touchstart:e.handleChange}},[n("div",{staticClass:"vc-alpha-pointer",style:{left:100*e.colors.a+"%"}},[n("div",{staticClass:"vc-alpha-picker"})])])])},i=[];r._withStripped=!0;var o={render:r,staticRenderFns:i};t.a=o},function(e,t,n){"use strict";var r=function(){var e=this,t=e.$createElement,n=e._self._c||t;return n("div",{class:["vc-photoshop",e.disableFields?"vc-photoshop__disable-fields":""],attrs:{role:"application","aria-label":"PhotoShop color picker"}},[n("div",{staticClass:"vc-ps-head",attrs:{role:"heading"}},[e._v(e._s(e.head))]),e._v(" "),n("div",{staticClass:"vc-ps-body"},[n("div",{staticClass:"vc-ps-saturation-wrap"},[n("saturation",{on:{change:e.childChange},model:{value:e.colors,callback:function(t){e.colors=t},expression:"colors"}})],1),e._v(" "),n("div",{staticClass:"vc-ps-hue-wrap"},[n("hue",{attrs:{direction:"vertical"},on:{change:e.childChange},model:{value:e.colors,callback:function(t){e.colors=t},expression:"colors"}},[n("div",{staticClass:"vc-ps-hue-pointer"},[n("i",{staticClass:"vc-ps-hue-pointer--left"}),n("i",{staticClass:"vc-ps-hue-pointer--right"})])])],1),e._v(" "),n("div",{class:["vc-ps-controls",e.disableFields?"vc-ps-controls__disable-fields":""]},[n("div",{staticClass:"vc-ps-previews"},[n("div",{staticClass:"vc-ps-previews__label"},[e._v(e._s(e.newLabel))]),e._v(" "),n("div",{staticClass:"vc-ps-previews__swatches"},[n("div",{staticClass:"vc-ps-previews__pr-color",style:{background:e.colors.hex},attrs:{"aria-label":"New color is "+e.colors.hex}}),e._v(" "),n("div",{staticClass:"vc-ps-previews__pr-color",style:{background:e.currentColor},attrs:{"aria-label":"Current color is "+e.currentColor},on:{click:e.clickCurrentColor}})]),e._v(" "),n("div",{staticClass:"vc-ps-previews__label"},[e._v(e._s(e.currentLabel))])]),e._v(" "),e.disableFields?e._e():n("div",{staticClass:"vc-ps-actions"},[n("div",{staticClass:"vc-ps-ac-btn",attrs:{role:"button","aria-label":e.acceptLabel},on:{click:e.handleAccept}},[e._v(e._s(e.acceptLabel))]),e._v(" "),n("div",{staticClass:"vc-ps-ac-btn",attrs:{role:"button","aria-label":e.cancelLabel},on:{click:e.handleCancel}},[e._v(e._s(e.cancelLabel))]),e._v(" "),n("div",{staticClass:"vc-ps-fields"},[n("ed-in",{attrs:{label:"h",desc:"°",value:e.hsv.h},on:{change:e.inputChange}}),e._v(" "),n("ed-in",{attrs:{label:"s",desc:"%",value:e.hsv.s,max:100},on:{change:e.inputChange}}),e._v(" "),n("ed-in",{attrs:{label:"v",desc:"%",value:e.hsv.v,max:100},on:{change:e.inputChange}}),e._v(" "),n("div",{staticClass:"vc-ps-fields__divider"}),e._v(" "),n("ed-in",{attrs:{label:"r",value:e.colors.rgba.r},on:{change:e.inputChange}}),e._v(" "),n("ed-in",{attrs:{label:"g",value:e.colors.rgba.g},on:{change:e.inputChange}}),e._v(" "),n("ed-in",{attrs:{label:"b",value:e.colors.rgba.b},on:{change:e.inputChange}}),e._v(" "),n("div",{staticClass:"vc-ps-fields__divider"}),e._v(" "),n("ed-in",{staticClass:"vc-ps-fields__hex",attrs:{label:"#",value:e.hex},on:{change:e.inputChange}})],1),e._v(" "),e.hasResetButton?n("div",{staticClass:"vc-ps-ac-btn",attrs:{"aria-label":"reset"},on:{click:e.handleReset}},[e._v(e._s(e.resetLabel))]):e._e()])])])])},i=[];r._withStripped=!0;var o={render:r,staticRenderFns:i};t.a=o},function(e,t,n){"use strict";function r(e){c||n(136)}Object.defineProperty(t,"__esModule",{value:!0});var i=n(57),o=n.n(i);for(var a in i)"default"!==a&&function(e){n.d(t,e,function(){return i[e]})}(a);var s=n(138),c=!1,l=n(2),u=r,f=l(o.a,s.a,!1,u,null,null);f.options.__file="src/components/Sketch.vue",t.default=f.exports},function(e,t,n){var r=n(137);"string"==typeof r&&(r=[[e.i,r,""]]),r.locals&&(e.exports=r.locals);n(1)("612c6604",r,!1,{})},function(e,t,n){t=e.exports=n(0)(!1),t.push([e.i,"\n.vc-sketch {\n  position: relative;\n  width: 200px;\n  padding: 10px 10px 0;\n  box-sizing: initial;\n  background: #fff;\n  border-radius: 4px;\n  box-shadow: 0 0 0 1px rgba(0, 0, 0, .15), 0 8px 16px rgba(0, 0, 0, .15);\n}\n.vc-sketch-saturation-wrap {\n  width: 100%;\n  padding-bottom: 75%;\n  position: relative;\n  overflow: hidden;\n}\n.vc-sketch-controls {\n  display: flex;\n}\n.vc-sketch-sliders {\n  padding: 4px 0;\n  flex: 1;\n}\n.vc-sketch-sliders .vc-hue,\n.vc-sketch-sliders .vc-alpha-gradient {\n  border-radius: 2px;\n}\n.vc-sketch-hue-wrap {\n  position: relative;\n  height: 10px;\n}\n.vc-sketch-alpha-wrap {\n  position: relative;\n  height: 10px;\n  margin-top: 4px;\n  overflow: hidden;\n}\n.vc-sketch-color-wrap {\n  width: 24px;\n  height: 24px;\n  position: relative;\n  margin-top: 4px;\n  margin-left: 4px;\n  border-radius: 3px;\n}\n.vc-sketch-active-color {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  border-radius: 2px;\n  box-shadow: inset 0 0 0 1px rgba(0, 0, 0, .15), inset 0 0 4px rgba(0, 0, 0, .25);\n  z-index: 2;\n}\n.vc-sketch-color-wrap .vc-checkerboard {\n  background-size: auto;\n}\n.vc-sketch-field {\n  display: flex;\n  padding-top: 4px;\n}\n.vc-sketch-field .vc-input__input {\n  width: 90%;\n  padding: 4px 0 3px 10%;\n  border: none;\n  box-shadow: inset 0 0 0 1px #ccc;\n  font-size: 10px;\n}\n.vc-sketch-field .vc-input__label {\n  display: block;\n  text-align: center;\n  font-size: 11px;\n  color: #222;\n  padding-top: 3px;\n  padding-bottom: 4px;\n  text-transform: capitalize;\n}\n.vc-sketch-field--single {\n  flex: 1;\n  padding-left: 6px;\n}\n.vc-sketch-field--double {\n  flex: 2;\n}\n.vc-sketch-presets {\n  margin-right: -10px;\n  margin-left: -10px;\n  padding-left: 10px;\n  padding-top: 10px;\n  border-top: 1px solid #eee;\n}\n.vc-sketch-presets-color {\n  border-radius: 3px;\n  overflow: hidden;\n  position: relative;\n  display: inline-block;\n  margin: 0 10px 10px 0;\n  vertical-align: top;\n  cursor: pointer;\n  width: 16px;\n  height: 16px;\n  box-shadow: inset 0 0 0 1px rgba(0, 0, 0, .15);\n}\n.vc-sketch-presets-color .vc-checkerboard {\n  box-shadow: inset 0 0 0 1px rgba(0, 0, 0, .15);\n  border-radius: 3px;\n}\n.vc-sketch__disable-alpha .vc-sketch-color-wrap {\n  height: 10px;\n}\n",""])},function(e,t,n){"use strict";var r=function(){var e=this,t=e.$createElement,n=e._self._c||t;return n("div",{class:["vc-sketch",e.disableAlpha?"vc-sketch__disable-alpha":""],attrs:{role:"application","aria-label":"Sketch color picker"}},[n("div",{staticClass:"vc-sketch-saturation-wrap"},[n("saturation",{on:{change:e.childChange},model:{value:e.colors,callback:function(t){e.colors=t},expression:"colors"}})],1),e._v(" "),n("div",{staticClass:"vc-sketch-controls"},[n("div",{staticClass:"vc-sketch-sliders"},[n("div",{staticClass:"vc-sketch-hue-wrap"},[n("hue",{on:{change:e.childChange},model:{value:e.colors,callback:function(t){e.colors=t},expression:"colors"}})],1),e._v(" "),e.disableAlpha?e._e():n("div",{staticClass:"vc-sketch-alpha-wrap"},[n("alpha",{on:{change:e.childChange},model:{value:e.colors,callback:function(t){e.colors=t},expression:"colors"}})],1)]),e._v(" "),n("div",{staticClass:"vc-sketch-color-wrap"},[n("div",{staticClass:"vc-sketch-active-color",style:{background:e.activeColor},attrs:{"aria-label":"Current color is "+e.activeColor}}),e._v(" "),n("checkboard")],1)]),e._v(" "),e.disableFields?e._e():n("div",{staticClass:"vc-sketch-field"},[n("div",{staticClass:"vc-sketch-field--double"},[n("ed-in",{attrs:{label:"hex",value:e.hex},on:{change:e.inputChange}})],1),e._v(" "),n("div",{staticClass:"vc-sketch-field--single"},[n("ed-in",{attrs:{label:"r",value:e.colors.rgba.r},on:{change:e.inputChange}})],1),e._v(" "),n("div",{staticClass:"vc-sketch-field--single"},[n("ed-in",{attrs:{label:"g",value:e.colors.rgba.g},on:{change:e.inputChange}})],1),e._v(" "),n("div",{staticClass:"vc-sketch-field--single"},[n("ed-in",{attrs:{label:"b",value:e.colors.rgba.b},on:{change:e.inputChange}})],1),e._v(" "),e.disableAlpha?e._e():n("div",{staticClass:"vc-sketch-field--single"},[n("ed-in",{attrs:{label:"a",value:e.colors.a,"arrow-offset":.01,max:1},on:{change:e.inputChange}})],1)]),e._v(" "),n("div",{staticClass:"vc-sketch-presets",attrs:{role:"group","aria-label":"A color preset, pick one to set as current color"}},[e._l(e.presetColors,function(t){return[e.isTransparent(t)?n("div",{key:t,staticClass:"vc-sketch-presets-color",attrs:{"aria-label":"Color:"+t},on:{click:function(n){return e.handlePreset(t)}}},[n("checkboard")],1):n("div",{key:t,staticClass:"vc-sketch-presets-color",style:{background:t},attrs:{"aria-label":"Color:"+t},on:{click:function(n){return e.handlePreset(t)}}})]})],2)])},i=[];r._withStripped=!0;var o={render:r,staticRenderFns:i};t.a=o},function(e,t,n){"use strict";function r(e){c||n(140)}Object.defineProperty(t,"__esModule",{value:!0});var i=n(58),o=n.n(i);for(var a in i)"default"!==a&&function(e){n.d(t,e,function(){return i[e]})}(a);var s=n(142),c=!1,l=n(2),u=r,f=l(o.a,s.a,!1,u,null,null);f.options.__file="src/components/Chrome.vue",t.default=f.exports},function(e,t,n){var r=n(141);"string"==typeof r&&(r=[[e.i,r,""]]),r.locals&&(e.exports=r.locals);n(1)("1cd16048",r,!1,{})},function(e,t,n){t=e.exports=n(0)(!1),t.push([e.i,"\n.vc-chrome {\n  background: #fff;\n  border-radius: 2px;\n  box-shadow: 0 0 2px rgba(0,0,0,.3), 0 4px 8px rgba(0,0,0,.3);\n  box-sizing: initial;\n  width: 225px;\n  font-family: Menlo;\n  background-color: #fff;\n}\n.vc-chrome-controls {\n  display: flex;\n}\n.vc-chrome-color-wrap {\n  position: relative;\n  width: 36px;\n}\n.vc-chrome-active-color {\n  position: relative;\n  width: 30px;\n  height: 30px;\n  border-radius: 15px;\n  overflow: hidden;\n  z-index: 1;\n}\n.vc-chrome-color-wrap .vc-checkerboard {\n  width: 30px;\n  height: 30px;\n  border-radius: 15px;\n  background-size: auto;\n}\n.vc-chrome-sliders {\n  flex: 1;\n}\n.vc-chrome-fields-wrap {\n  display: flex;\n  padding-top: 16px;\n}\n.vc-chrome-fields {\n  display: flex;\n  margin-left: -6px;\n  flex: 1;\n}\n.vc-chrome-field {\n  padding-left: 6px;\n  width: 100%;\n}\n.vc-chrome-toggle-btn {\n  width: 32px;\n  text-align: right;\n  position: relative;\n}\n.vc-chrome-toggle-icon {\n  margin-right: -4px;\n  margin-top: 12px;\n  cursor: pointer;\n  position: relative;\n  z-index: 2;\n}\n.vc-chrome-toggle-icon-highlight {\n  position: absolute;\n  width: 24px;\n  height: 28px;\n  background: #eee;\n  border-radius: 4px;\n  top: 10px;\n  left: 12px;\n}\n.vc-chrome-hue-wrap {\n  position: relative;\n  height: 10px;\n  margin-bottom: 8px;\n}\n.vc-chrome-alpha-wrap {\n  position: relative;\n  height: 10px;\n}\n.vc-chrome-hue-wrap .vc-hue {\n  border-radius: 2px;\n}\n.vc-chrome-alpha-wrap .vc-alpha-gradient {\n  border-radius: 2px;\n}\n.vc-chrome-hue-wrap .vc-hue-picker, .vc-chrome-alpha-wrap .vc-alpha-picker {\n  width: 12px;\n  height: 12px;\n  border-radius: 6px;\n  transform: translate(-6px, -2px);\n  background-color: rgb(248, 248, 248);\n  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.37);\n}\n.vc-chrome-body {\n  padding: 16px 16px 12px;\n  background-color: #fff;\n}\n.vc-chrome-saturation-wrap {\n  width: 100%;\n  padding-bottom: 55%;\n  position: relative;\n  border-radius: 2px 2px 0 0;\n  overflow: hidden;\n}\n.vc-chrome-saturation-wrap .vc-saturation-circle {\n  width: 12px;\n  height: 12px;\n}\n.vc-chrome-fields .vc-input__input {\n  font-size: 11px;\n  color: #333;\n  width: 100%;\n  border-radius: 2px;\n  border: none;\n  box-shadow: inset 0 0 0 1px #dadada;\n  height: 21px;\n  text-align: center;\n}\n.vc-chrome-fields .vc-input__label {\n  text-transform: uppercase;\n  font-size: 11px;\n  line-height: 11px;\n  color: #969696;\n  text-align: center;\n  display: block;\n  margin-top: 12px;\n}\n.vc-chrome__disable-alpha .vc-chrome-active-color {\n  width: 18px;\n  height: 18px;\n}\n.vc-chrome__disable-alpha .vc-chrome-color-wrap {\n  width: 30px;\n}\n.vc-chrome__disable-alpha .vc-chrome-hue-wrap {\n  margin-top: 4px;\n  margin-bottom: 4px;\n}\n",""])},function(e,t,n){"use strict";var r=function(){var e=this,t=e.$createElement,n=e._self._c||t;return n("div",{class:["vc-chrome",e.disableAlpha?"vc-chrome__disable-alpha":""],attrs:{role:"application","aria-label":"Chrome color picker"}},[n("div",{staticClass:"vc-chrome-saturation-wrap"},[n("saturation",{on:{change:e.childChange},model:{value:e.colors,callback:function(t){e.colors=t},expression:"colors"}})],1),e._v(" "),n("div",{staticClass:"vc-chrome-body"},[n("div",{staticClass:"vc-chrome-controls"},[n("div",{staticClass:"vc-chrome-color-wrap"},[n("div",{staticClass:"vc-chrome-active-color",style:{background:e.activeColor},attrs:{"aria-label":"current color is "+e.colors.hex}}),e._v(" "),e.disableAlpha?e._e():n("checkboard")],1),e._v(" "),n("div",{staticClass:"vc-chrome-sliders"},[n("div",{staticClass:"vc-chrome-hue-wrap"},[n("hue",{on:{change:e.childChange},model:{value:e.colors,callback:function(t){e.colors=t},expression:"colors"}})],1),e._v(" "),e.disableAlpha?e._e():n("div",{staticClass:"vc-chrome-alpha-wrap"},[n("alpha",{on:{change:e.childChange},model:{value:e.colors,callback:function(t){e.colors=t},expression:"colors"}})],1)])]),e._v(" "),e.disableFields?e._e():n("div",{staticClass:"vc-chrome-fields-wrap"},[n("div",{directives:[{name:"show",rawName:"v-show",value:0===e.fieldsIndex,expression:"fieldsIndex === 0"}],staticClass:"vc-chrome-fields"},[n("div",{staticClass:"vc-chrome-field"},[e.hasAlpha?e._e():n("ed-in",{attrs:{label:"hex",value:e.colors.hex},on:{change:e.inputChange}}),e._v(" "),e.hasAlpha?n("ed-in",{attrs:{label:"hex",value:e.colors.hex8},on:{change:e.inputChange}}):e._e()],1)]),e._v(" "),n("div",{directives:[{name:"show",rawName:"v-show",value:1===e.fieldsIndex,expression:"fieldsIndex === 1"}],staticClass:"vc-chrome-fields"},[n("div",{staticClass:"vc-chrome-field"},[n("ed-in",{attrs:{label:"r",value:e.colors.rgba.r},on:{change:e.inputChange}})],1),e._v(" "),n("div",{staticClass:"vc-chrome-field"},[n("ed-in",{attrs:{label:"g",value:e.colors.rgba.g},on:{change:e.inputChange}})],1),e._v(" "),n("div",{staticClass:"vc-chrome-field"},[n("ed-in",{attrs:{label:"b",value:e.colors.rgba.b},on:{change:e.inputChange}})],1),e._v(" "),e.disableAlpha?e._e():n("div",{staticClass:"vc-chrome-field"},[n("ed-in",{attrs:{label:"a",value:e.colors.a,"arrow-offset":.01,max:1},on:{change:e.inputChange}})],1)]),e._v(" "),n("div",{directives:[{name:"show",rawName:"v-show",value:2===e.fieldsIndex,expression:"fieldsIndex === 2"}],staticClass:"vc-chrome-fields"},[n("div",{staticClass:"vc-chrome-field"},[n("ed-in",{attrs:{label:"h",value:e.hsl.h},on:{change:e.inputChange}})],1),e._v(" "),n("div",{staticClass:"vc-chrome-field"},[n("ed-in",{attrs:{label:"s",value:e.hsl.s},on:{change:e.inputChange}})],1),e._v(" "),n("div",{staticClass:"vc-chrome-field"},[n("ed-in",{attrs:{label:"l",value:e.hsl.l},on:{change:e.inputChange}})],1),e._v(" "),e.disableAlpha?e._e():n("div",{staticClass:"vc-chrome-field"},[n("ed-in",{attrs:{label:"a",value:e.colors.a,"arrow-offset":.01,max:1},on:{change:e.inputChange}})],1)]),e._v(" "),n("div",{staticClass:"vc-chrome-toggle-btn",attrs:{role:"button","aria-label":"Change another color definition"},on:{click:e.toggleViews}},[n("div",{staticClass:"vc-chrome-toggle-icon"},[n("svg",{staticStyle:{width:"24px",height:"24px"},attrs:{viewBox:"0 0 24 24"},on:{mouseover:e.showHighlight,mouseenter:e.showHighlight,mouseout:e.hideHighlight}},[n("path",{attrs:{fill:"#333",d:"M12,18.17L8.83,15L7.42,16.41L12,21L16.59,16.41L15.17,15M12,5.83L15.17,9L16.58,7.59L12,3L7.41,7.59L8.83,9L12,5.83Z"}})])]),e._v(" "),n("div",{directives:[{name:"show",rawName:"v-show",value:e.highlight,expression:"highlight"}],staticClass:"vc-chrome-toggle-icon-highlight"})])])])])},i=[];r._withStripped=!0;var o={render:r,staticRenderFns:i};t.a=o},function(e,t,n){"use strict";function r(e){c||n(144)}Object.defineProperty(t,"__esModule",{value:!0});var i=n(59),o=n.n(i);for(var a in i)"default"!==a&&function(e){n.d(t,e,function(){return i[e]})}(a);var s=n(146),c=!1,l=n(2),u=r,f=l(o.a,s.a,!1,u,null,null);f.options.__file="src/components/Twitter.vue",t.default=f.exports},function(e,t,n){var r=n(145);"string"==typeof r&&(r=[[e.i,r,""]]),r.locals&&(e.exports=r.locals);n(1)("669a48a5",r,!1,{})},function(e,t,n){t=e.exports=n(0)(!1),t.push([e.i,"\n.vc-twitter {\n  background: #fff;\n  border: 0 solid rgba(0,0,0,0.25);\n  box-shadow: 0 1px 4px rgba(0,0,0,0.25);\n  border-radius: 4px;\n  position: relative;\n}\n.vc-twitter-triangle {\n  width: 0px;\n  height: 0px;\n  border-style: solid;\n  border-width: 0 9px 10px 9px;\n  border-color: transparent transparent #fff transparent;\n  position: absolute;\n}\n.vc-twitter-triangle-shadow {\n  width: 0px;\n  height: 0px;\n  border-style: solid;\n  border-width: 0 9px 10px 9px;\n  border-color: transparent transparent rgba(0, 0, 0, .1) transparent;\n  position: absolute;\n}\n.vc-twitter-body {\n  padding: 15px 9px 9px 15px;\n}\n.vc-twitter .vc-editable-input {\n  position: relative;\n}\n.vc-twitter .vc-editable-input input {\n  width: 100px;\n  font-size: 14px;\n  color: #666;\n  border: 0px;\n  outline: none;\n  height: 28px;\n  box-shadow: inset 0 0 0 1px #F0F0F0;\n  box-sizing: content-box;\n  border-radius: 0 4px 4px 0;\n  float: left;\n  padding: 1px;\n  padding-left: 8px;\n}\n.vc-twitter .vc-editable-input span {\n  display: none;\n}\n.vc-twitter-hash {\n  background: #F0F0F0;\n  height: 30px;\n  width: 30px;\n  border-radius: 4px 0 0 4px;\n  float: left;\n  color: #98A1A4;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.vc-twitter-swatch {\n  width: 30px;\n  height: 30px;\n  float: left;\n  border-radius: 4px;\n  margin: 0 6px 6px 0;\n  cursor: pointer;\n  position: relative;\n  outline: none;\n}\n.vc-twitter-clear {\n  clear: both;\n}\n.vc-twitter-hide-triangle .vc-twitter-triangle {\n  display: none;\n}\n.vc-twitter-hide-triangle .vc-twitter-triangle-shadow {\n  display: none;\n}\n.vc-twitter-top-left-triangle .vc-twitter-triangle{\n  top: -10px;\n  left: 12px;\n}\n.vc-twitter-top-left-triangle .vc-twitter-triangle-shadow{\n  top: -11px;\n  left: 12px;\n}\n.vc-twitter-top-right-triangle .vc-twitter-triangle{\n  top: -10px;\n  right: 12px;\n}\n.vc-twitter-top-right-triangle .vc-twitter-triangle-shadow{\n  top: -11px;\n  right: 12px;\n}\n",""])},function(e,t,n){"use strict";var r=function(){var e=this,t=e.$createElement,n=e._self._c||t;return n("div",{staticClass:"vc-twitter",class:{"vc-twitter-hide-triangle ":"hide"===e.triangle,"vc-twitter-top-left-triangle ":"top-left"===e.triangle,"vc-twitter-top-right-triangle ":"top-right"===e.triangle},style:{width:"number"==typeof e.width?e.width+"px":e.width}},[n("div",{staticClass:"vc-twitter-triangle-shadow"}),e._v(" "),n("div",{staticClass:"vc-twitter-triangle"}),e._v(" "),n("div",{staticClass:"vc-twitter-body"},[e._l(e.defaultColors,function(t,r){return n("span",{key:r,staticClass:"vc-twitter-swatch",style:{background:t,boxShadow:"0 0 4px "+(e.equal(t)?t:"transparent")},on:{click:function(n){return e.handlerClick(t)}}})}),e._v(" "),n("div",{staticClass:"vc-twitter-hash"},[e._v("#")]),e._v(" "),n("editable-input",{attrs:{label:"#",value:e.hex},on:{change:e.inputChange}}),e._v(" "),n("div",{staticClass:"vc-twitter-clear"})],2)])},i=[];r._withStripped=!0;var o={render:r,staticRenderFns:i};t.a=o}])});
}).call(this)}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],32:[function(require,module,exports){
/*!
 * vue-cookie-law v1.13.3
 * (c) 2020 Jakub Juszczak <jakub@posteo.de>
 * 
 */
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("CookieLaw", [], factory);
	else if(typeof exports === 'object')
		exports["CookieLaw"] = factory();
	else
		root["CookieLaw"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 4);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(5).default
var update = add("624a20fb", content, true, {});

/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_node_modules_css_loader_dist_cjs_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_node_modules_vue_loader_lib_index_js_vue_loader_options_CookieLaw_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(0);
/* harmony import */ var _node_modules_vue_style_loader_index_js_node_modules_css_loader_dist_cjs_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_node_modules_vue_loader_lib_index_js_vue_loader_options_CookieLaw_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_node_modules_css_loader_dist_cjs_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_node_modules_vue_loader_lib_index_js_vue_loader_options_CookieLaw_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_vue_style_loader_index_js_node_modules_css_loader_dist_cjs_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_node_modules_vue_loader_lib_index_js_vue_loader_options_CookieLaw_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__(3);
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".Cookie{position:fixed;overflow:hidden;box-sizing:border-box;z-index:9999;width:100%;display:flex;justify-content:space-between;align-items:baseline;flex-direction:column}.Cookie>*{margin:.9375rem 0;align-self:center}@media screen and (min-width: 48rem){.Cookie{flex-flow:row}.Cookie>*{margin:0}}.Cookie--top{top:0;left:0;right:0}.Cookie--bottom{bottom:0;left:0;right:0}.Cookie__buttons{display:flex;flex-direction:column}.Cookie__buttons>*{margin:.3125rem 0}@media screen and (min-width: 48rem){.Cookie__buttons{flex-direction:row}.Cookie__buttons>*{margin:0 .9375rem}}.Cookie__button{cursor:pointer;align-self:center;white-space:nowrap}.Cookie__declineButton{cursor:pointer;align-self:center;white-space:nowrap}.Cookie--base{background:#F1F1F1;color:#232323;padding:1.250em}.Cookie--base .Cookie__button{background:#97D058;padding:0.625em 3.125em;color:#fff;border-radius:0;border:0;font-size:1em}.Cookie--base .Cookie__button:hover{background:#7ebf36}.Cookie--base .Cookie__button--decline{background:transparent;padding:0.625em 3.125em;color:#727272;border-radius:0;border:0;font-size:1em}.Cookie--base .Cookie__button--decline:hover{background:#cbcbcb}.Cookie--base--rounded{background:#F1F1F1;color:#232323;padding:1.250em}.Cookie--base--rounded .Cookie__button{background:#97D058;padding:0.625em 3.125em;color:#fff;border-radius:20px;border:0;font-size:1em}.Cookie--base--rounded .Cookie__button:hover{background:#7ebf36}.Cookie--base--rounded .Cookie__button--decline{background:transparent;padding:0.625em 3.125em;color:#727272;border-radius:20px;border:0;font-size:1em}.Cookie--base--rounded .Cookie__button--decline:hover{background:#cbcbcb}.Cookie--blood-orange{background:#424851;color:#fff;padding:1.250em}.Cookie--blood-orange .Cookie__button{background:#E76A68;padding:0.625em 3.125em;color:#fff;border-radius:0;border:0;font-size:1em}.Cookie--blood-orange .Cookie__button:hover{background:#e03f3c}.Cookie--blood-orange .Cookie__button--decline{background:transparent;padding:0.625em 3.125em;color:#000;border-radius:0;border:0;font-size:1em}.Cookie--blood-orange .Cookie__button--decline:hover{background:#202327}.Cookie--blood-orange--rounded{background:#424851;color:#fff;padding:1.250em}.Cookie--blood-orange--rounded .Cookie__button{background:#E76A68;padding:0.625em 3.125em;color:#fff;border-radius:20px;border:0;font-size:1em}.Cookie--blood-orange--rounded .Cookie__button:hover{background:#e03f3c}.Cookie--blood-orange--rounded .Cookie__button--decline{background:transparent;padding:0.625em 3.125em;color:#000;border-radius:20px;border:0;font-size:1em}.Cookie--blood-orange--rounded .Cookie__button--decline:hover{background:#202327}.Cookie--dark-lime{background:#424851;color:#fff;padding:1.250em}.Cookie--dark-lime .Cookie__button{background:#97D058;padding:0.625em 3.125em;color:#fff;border-radius:0;border:0;font-size:1em}.Cookie--dark-lime .Cookie__button:hover{background:#7ebf36}.Cookie--dark-lime .Cookie__button--decline{background:transparent;padding:0.625em 3.125em;color:#000;border-radius:0;border:0;font-size:1em}.Cookie--dark-lime .Cookie__button--decline:hover{background:#202327}.Cookie--dark-lime--rounded{background:#424851;color:#fff;padding:1.250em}.Cookie--dark-lime--rounded .Cookie__button{background:#97D058;padding:0.625em 3.125em;color:#fff;border-radius:20px;border:0;font-size:1em}.Cookie--dark-lime--rounded .Cookie__button:hover{background:#7ebf36}.Cookie--dark-lime--rounded .Cookie__button--decline{background:transparent;padding:0.625em 3.125em;color:#000;border-radius:20px;border:0;font-size:1em}.Cookie--dark-lime--rounded .Cookie__button--decline:hover{background:#202327}.Cookie--royal{background:#FBC227;color:#232323;padding:1.250em}.Cookie--royal .Cookie__button{background:#726CEA;padding:0.625em 3.125em;color:#fff;border-radius:0;border:0;font-size:1em}.Cookie--royal .Cookie__button:hover{background:#473fe4}.Cookie--royal .Cookie__button--decline{background:transparent;padding:0.625em 3.125em;color:#221901;border-radius:0;border:0;font-size:1em}.Cookie--royal .Cookie__button--decline:hover{background:#d29a04}.Cookie--royal--rounded{background:#FBC227;color:#232323;padding:1.250em}.Cookie--royal--rounded .Cookie__button{background:#726CEA;padding:0.625em 3.125em;color:#fff;border-radius:20px;border:0;font-size:1em}.Cookie--royal--rounded .Cookie__button:hover{background:#473fe4}.Cookie--royal--rounded .Cookie__button--decline{background:transparent;padding:0.625em 3.125em;color:#221901;border-radius:20px;border:0;font-size:1em}.Cookie--royal--rounded .Cookie__button--decline:hover{background:#d29a04}.slideFromTop-enter,.slideFromTop-leave-to{transform:translate(0px, -12.5em)}.slideFromTop-enter-to,.slideFromTop-leave{transform:translate(0px, 0px)}.slideFromBottom-enter,.slideFromBottom-leave-to{transform:translate(0px, 12.5em)}.slideFromBottom-enter-to,.slideFromBottom-leave{transform:translate(0px, 0px)}.slideFromBottom-enter-active,.slideFromBottom-leave-active,.slideFromTop-enter-active,.slideFromTop-leave-active{transition:transform .4s ease-in}.fade-enter-active,.fade-leave-active{transition:opacity .5s}.fade-enter,.fade-leave-to{opacity:0}\n", ""]);
// Exports
module.exports = exports;


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
// eslint-disable-next-line func-names
module.exports = function (useSourceMap) {
  var list = []; // return the list of modules as css string

  list.toString = function toString() {
    return this.map(function (item) {
      var content = cssWithMappingToString(item, useSourceMap);

      if (item[2]) {
        return "@media ".concat(item[2], " {").concat(content, "}");
      }

      return content;
    }).join('');
  }; // import a list of modules into the list
  // eslint-disable-next-line func-names


  list.i = function (modules, mediaQuery, dedupe) {
    if (typeof modules === 'string') {
      // eslint-disable-next-line no-param-reassign
      modules = [[null, modules, '']];
    }

    var alreadyImportedModules = {};

    if (dedupe) {
      for (var i = 0; i < this.length; i++) {
        // eslint-disable-next-line prefer-destructuring
        var id = this[i][0];

        if (id != null) {
          alreadyImportedModules[id] = true;
        }
      }
    }

    for (var _i = 0; _i < modules.length; _i++) {
      var item = [].concat(modules[_i]);

      if (dedupe && alreadyImportedModules[item[0]]) {
        // eslint-disable-next-line no-continue
        continue;
      }

      if (mediaQuery) {
        if (!item[2]) {
          item[2] = mediaQuery;
        } else {
          item[2] = "".concat(mediaQuery, " and ").concat(item[2]);
        }
      }

      list.push(item);
    }
  };

  return list;
};

function cssWithMappingToString(item, useSourceMap) {
  var content = item[1] || ''; // eslint-disable-next-line prefer-destructuring

  var cssMapping = item[3];

  if (!cssMapping) {
    return content;
  }

  if (useSourceMap && typeof btoa === 'function') {
    var sourceMapping = toComment(cssMapping);
    var sourceURLs = cssMapping.sources.map(function (source) {
      return "/*# sourceURL=".concat(cssMapping.sourceRoot || '').concat(source, " */");
    });
    return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
  }

  return [content].join('\n');
} // Adapted from convert-source-map (MIT)


function toComment(sourceMap) {
  // eslint-disable-next-line no-undef
  var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
  var data = "sourceMappingURL=data:application/json;charset=utf-8;base64,".concat(base64);
  return "/*# ".concat(data, " */");
}

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/CookieLaw.vue?vue&type=template&id=e565edd6&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"appear":"","name":_vm.transitionName}},[(_vm.isOpen)?_c('div',{staticClass:"Cookie",class:[_vm.containerPosition, _vm.cookieTheme]},[_vm._t("default",[_c('div',{staticClass:"Cookie__content"},[_vm._t("message",[_vm._v(_vm._s(_vm.message))])],2),_vm._v(" "),_c('div',{staticClass:"Cookie__buttons"},[(_vm.externalButtonLink)?_c('a',{class:_vm.buttonClass,attrs:{"target":_vm.target,"href":_vm.buttonLink}},[_vm._v(_vm._s(_vm.buttonLinkText))]):_vm._e(),_vm._v(" "),(_vm.internalButtonLink)?_c('router-link',{class:_vm.buttonClass,attrs:{"to":_vm.buttonLink}},[_vm._v(_vm._s(_vm.buttonLinkText))]):_vm._e(),_vm._v(" "),(_vm.buttonDecline)?_c('button',{class:_vm.buttonDeclineClass,on:{"click":_vm.decline}},[_vm._v(_vm._s(_vm.buttonDeclineText))]):_vm._e(),_vm._v(" "),_c('button',{class:_vm.buttonClass,on:{"click":_vm.accept}},[_vm._v(_vm._s(_vm.buttonText))])],1)],{"accept":_vm.accept,"close":_vm.close,"decline":_vm.decline,"open":_vm.open})],2):_vm._e()])}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/CookieLaw.vue?vue&type=template&id=e565edd6&

// CONCATENATED MODULE: ./node_modules/tiny-cookie/es/util.js
function hasOwn(obj, key) {
  return Object.prototype.hasOwnProperty.call(obj, key);
} // Escape special characters.


function escapeRe(str) {
  return str.replace(/[.*+?^$|[\](){}\\-]/g, '\\$&');
} // Return a future date by the given string.


function computeExpires(str) {
  var lastCh = str.charAt(str.length - 1);
  var value = parseInt(str, 10);
  var expires = new Date();

  switch (lastCh) {
    case 'Y':
      expires.setFullYear(expires.getFullYear() + value);
      break;

    case 'M':
      expires.setMonth(expires.getMonth() + value);
      break;

    case 'D':
      expires.setDate(expires.getDate() + value);
      break;

    case 'h':
      expires.setHours(expires.getHours() + value);
      break;

    case 'm':
      expires.setMinutes(expires.getMinutes() + value);
      break;

    case 's':
      expires.setSeconds(expires.getSeconds() + value);
      break;

    default:
      expires = new Date(str);
  }

  return expires;
} // Convert an object to a cookie option string.


function convert(opts) {
  var res = ''; // eslint-disable-next-line

  for (var key in opts) {
    if (hasOwn(opts, key)) {
      if (/^expires$/i.test(key)) {
        var expires = opts[key];

        if (typeof expires !== 'object') {
          expires += typeof expires === 'number' ? 'D' : '';
          expires = computeExpires(expires);
        }

        res += ";" + key + "=" + expires.toUTCString();
      } else if (/^secure$/.test(key)) {
        if (opts[key]) {
          res += ";" + key;
        }
      } else {
        res += ";" + key + "=" + opts[key];
      }
    }
  }

  if (!hasOwn(opts, 'path')) {
    res += ';path=/';
  }

  return res;
}


// CONCATENATED MODULE: ./node_modules/tiny-cookie/es/index.js
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

 // Check if the browser cookie is enabled.

function isEnabled() {
  var key = '@key@';
  var value = '1';
  var re = new RegExp("(?:^|; )" + key + "=" + value + "(?:;|$)");
  document.cookie = key + "=" + value;
  var enabled = re.test(document.cookie);

  if (enabled) {
    // eslint-disable-next-line
    remove(key);
  }

  return enabled;
} // Get the cookie value by key.


function get(key, decoder) {
  if (decoder === void 0) {
    decoder = decodeURIComponent;
  }

  if (typeof key !== 'string' || !key) {
    return null;
  }

  var reKey = new RegExp("(?:^|; )" + escapeRe(key) + "(?:=([^;]*))?(?:;|$)");
  var match = reKey.exec(document.cookie);

  if (match === null) {
    return null;
  }

  return typeof decoder === 'function' ? decoder(match[1]) : match[1];
} // The all cookies


function getAll(decoder) {
  if (decoder === void 0) {
    decoder = decodeURIComponent;
  }

  var reKey = /(?:^|; )([^=]+?)(?:=([^;]*))?(?:;|$)/g;
  var cookies = {};
  var match;
  /* eslint-disable no-cond-assign */

  while (match = reKey.exec(document.cookie)) {
    reKey.lastIndex = match.index + match.length - 1;
    cookies[match[1]] = typeof decoder === 'function' ? decoder(match[2]) : match[2];
  }

  return cookies;
} // Set a cookie.


function set(key, value, encoder, options) {
  if (encoder === void 0) {
    encoder = encodeURIComponent;
  }

  if (typeof encoder === 'object' && encoder !== null) {
    /* eslint-disable no-param-reassign */
    options = encoder;
    encoder = encodeURIComponent;
    /* eslint-enable no-param-reassign */
  }

  var attrsStr = convert(options || {});
  var valueStr = typeof encoder === 'function' ? encoder(value) : value;
  var newCookie = key + "=" + valueStr + attrsStr;
  document.cookie = newCookie;
} // Remove a cookie by the specified key.


function remove(key, options) {
  var opts = {
    expires: -1
  };

  if (options) {
    opts = _extends({}, options, opts);
  }

  return set(key, 'a', opts);
} // Get the cookie's value without decoding.


function getRaw(key) {
  return get(key, null);
} // Set a cookie without encoding the value.


function setRaw(key, value, options) {
  return set(key, value, null, options);
}


// CONCATENATED MODULE: ./node_modules/babel-loader/lib??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/CookieLaw.vue?vue&type=script&lang=js&
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var STORAGE_TYPES = {
  local: 'localStorage',
  cookies: 'cookies'
};
/* harmony default export */ var CookieLawvue_type_script_lang_js_ = ({
  name: 'VueCookieLaw',
  props: {
    buttonText: {
      type: String,
      default: 'Got it!'
    },
    buttonDecline: {
      type: Boolean,
      default: false
    },
    buttonDeclineText: {
      type: String,
      default: 'Decline'
    },
    buttonLink: {
      type: [String, Object],
      required: false
    },
    buttonLinkText: {
      type: String,
      default: 'More info'
    },
    buttonLinkNewTab: {
      type: Boolean,
      default: false
    },
    message: {
      type: String,
      default: 'This website uses cookies to ensure you get the best experience on our website.'
    },
    theme: {
      type: String,
      default: 'base'
    },

    /**
     * Cookie Container position
     * bottom, top
     * @type {Object}
     */
    position: {
      type: String,
      default: 'bottom'
    },

    /**
     * Transition name has following possibilities
     * slideFromBottom
     * slideFromTop
     * fade
     * @type {Object}
     */
    transitionName: {
      type: String,
      default: 'slideFromBottom'
    },
    buttonClass: {
      type: String,
      default: 'Cookie__button'
    },
    buttonDeclineClass: {
      type: String,
      default: 'Cookie__button--decline'
    },
    storageName: {
      type: String,
      default: 'cookie:accepted'
    },
    storageType: {
      type: String,
      default: STORAGE_TYPES.local
    },
    cookieOptions: {
      type: Object,
      default: function _default() {},
      required: false
    }
  },
  data: function data() {
    return {
      supportsLocalStorage: true,
      isOpen: false
    };
  },
  computed: {
    containerPosition: function containerPosition() {
      return "Cookie--".concat(this.position);
    },
    cookieTheme: function cookieTheme() {
      return "Cookie--".concat(this.theme);
    },
    externalButtonLink: function externalButtonLink() {
      return typeof this.buttonLink === 'string' && this.buttonLink.length;
    },
    internalButtonLink: function internalButtonLink() {
      return _typeof(this.buttonLink) === 'object' && this.buttonLink != null && Object.keys(this.buttonLink).length;
    },
    target: function target() {
      return this.buttonLinkNewTab ? '_blank' : '_self';
    },
    canUseLocalStorage: function canUseLocalStorage() {
      return this.storageType === STORAGE_TYPES.local && this.supportsLocalStorage;
    }
  },
  created: function created() {
    if (this.storageType === STORAGE_TYPES.local) {
      // Check for availability of localStorage
      try {
        var test = '__vue-cookielaw-check-localStorage';

        if (typeof window !== 'undefined') {
          window.localStorage.setItem(test, test);
          window.localStorage.removeItem(test);
        }
      } catch (e) {
        console.info('Local storage is not supported, falling back to cookie use');
        this.supportsLocalStorage = false;
      }
    }

    if (!this.getVisited()) {
      this.isOpen = true;
    }
  },
  mounted: function mounted() {
    if (this.isAccepted()) {
      this.$emit('accept');
    }
  },
  methods: {
    setVisited: function setVisited() {
      if (this.canUseLocalStorage) {
        localStorage.setItem(this.storageName, true);
      } else {
        set(this.storageName, true, _objectSpread({}, this.cookieOptions, {
          expires: '1Y'
        }));
      }
    },
    setAccepted: function setAccepted() {
      if (this.canUseLocalStorage) {
        localStorage.setItem(this.storageName, true);
      } else {
        set(this.storageName, true, _objectSpread({}, this.cookieOptions, {
          expires: '1Y'
        }));
      }
    },
    setDeclined: function setDeclined() {
      if (this.canUseLocalStorage) {
        localStorage.setItem(this.storageName, false);
      } else {
        set(this.storageName, false, _objectSpread({}, this.cookieOptions, {
          expires: '1Y'
        }));
      }
    },
    getVisited: function getVisited() {
      var visited = false;

      if (this.canUseLocalStorage) {
        visited = localStorage.getItem(this.storageName);
      } else {
        visited = get(this.storageName);
      }

      if (typeof visited === 'string') {
        visited = JSON.parse(visited);
      }

      return !(visited === null || visited === undefined);
    },
    isAccepted: function isAccepted() {
      var accepted = false;

      if (this.canUseLocalStorage) {
        accepted = localStorage.getItem(this.storageName);
      } else {
        accepted = get(this.storageName);
      }

      if (typeof accepted === 'string') {
        accepted = JSON.parse(accepted);
      }

      return accepted;
    },
    accept: function accept() {
      this.setVisited();
      this.setAccepted();
      this.isOpen = false;
      this.$emit('accept');
    },
    close: function close() {
      this.isOpen = false;
      this.$emit('close');
    },
    decline: function decline() {
      this.setVisited();
      this.setDeclined();
      this.isOpen = false;
      this.$emit('decline');
    },
    revoke: function revoke() {
      if (this.canUseLocalStorage) {
        localStorage.removeItem(this.storageName);
      } else {
        remove(this.storageName);
      }

      this.isOpen = true;
      this.$emit('revoke');
    },
    open: function open() {
      if (!this.getVisited()) {
        this.isOpen = true;
      }
    }
  }
});
// CONCATENATED MODULE: ./src/components/CookieLaw.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_CookieLawvue_type_script_lang_js_ = (CookieLawvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/CookieLaw.vue?vue&type=style&index=0&lang=scss&
var CookieLawvue_type_style_index_0_lang_scss_ = __webpack_require__(1);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent (
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier, /* server only */
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () { injectStyles.call(this, this.$root.$options.shadowRoot) }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functional component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}

// CONCATENATED MODULE: ./src/components/CookieLaw.vue






/* normalize component */

var component = normalizeComponent(
  components_CookieLawvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var CookieLaw = __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, "default", function() { return /* binding */ addStylesClient; });

// CONCATENATED MODULE: ./node_modules/vue-style-loader/lib/listToStyles.js
/**
 * Translates the list format produced by css-loader into something
 * easier to manipulate.
 */
function listToStyles (parentId, list) {
  var styles = []
  var newStyles = {}
  for (var i = 0; i < list.length; i++) {
    var item = list[i]
    var id = item[0]
    var css = item[1]
    var media = item[2]
    var sourceMap = item[3]
    var part = {
      id: parentId + ':' + i,
      css: css,
      media: media,
      sourceMap: sourceMap
    }
    if (!newStyles[id]) {
      styles.push(newStyles[id] = { id: id, parts: [part] })
    } else {
      newStyles[id].parts.push(part)
    }
  }
  return styles
}

// CONCATENATED MODULE: ./node_modules/vue-style-loader/lib/addStylesClient.js
/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
  Modified by Evan You @yyx990803
*/



var hasDocument = typeof document !== 'undefined'

if (typeof DEBUG !== 'undefined' && DEBUG) {
  if (!hasDocument) {
    throw new Error(
    'vue-style-loader cannot be used in a non-browser environment. ' +
    "Use { target: 'node' } in your Webpack config to indicate a server-rendering environment."
  ) }
}

/*
type StyleObject = {
  id: number;
  parts: Array<StyleObjectPart>
}

type StyleObjectPart = {
  css: string;
  media: string;
  sourceMap: ?string
}
*/

var stylesInDom = {/*
  [id: number]: {
    id: number,
    refs: number,
    parts: Array<(obj?: StyleObjectPart) => void>
  }
*/}

var head = hasDocument && (document.head || document.getElementsByTagName('head')[0])
var singletonElement = null
var singletonCounter = 0
var isProduction = false
var noop = function () {}
var options = null
var ssrIdKey = 'data-vue-ssr-id'

// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
// tags it will allow on a page
var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\b/.test(navigator.userAgent.toLowerCase())

function addStylesClient (parentId, list, _isProduction, _options) {
  isProduction = _isProduction

  options = _options || {}

  var styles = listToStyles(parentId, list)
  addStylesToDom(styles)

  return function update (newList) {
    var mayRemove = []
    for (var i = 0; i < styles.length; i++) {
      var item = styles[i]
      var domStyle = stylesInDom[item.id]
      domStyle.refs--
      mayRemove.push(domStyle)
    }
    if (newList) {
      styles = listToStyles(parentId, newList)
      addStylesToDom(styles)
    } else {
      styles = []
    }
    for (var i = 0; i < mayRemove.length; i++) {
      var domStyle = mayRemove[i]
      if (domStyle.refs === 0) {
        for (var j = 0; j < domStyle.parts.length; j++) {
          domStyle.parts[j]()
        }
        delete stylesInDom[domStyle.id]
      }
    }
  }
}

function addStylesToDom (styles /* Array<StyleObject> */) {
  for (var i = 0; i < styles.length; i++) {
    var item = styles[i]
    var domStyle = stylesInDom[item.id]
    if (domStyle) {
      domStyle.refs++
      for (var j = 0; j < domStyle.parts.length; j++) {
        domStyle.parts[j](item.parts[j])
      }
      for (; j < item.parts.length; j++) {
        domStyle.parts.push(addStyle(item.parts[j]))
      }
      if (domStyle.parts.length > item.parts.length) {
        domStyle.parts.length = item.parts.length
      }
    } else {
      var parts = []
      for (var j = 0; j < item.parts.length; j++) {
        parts.push(addStyle(item.parts[j]))
      }
      stylesInDom[item.id] = { id: item.id, refs: 1, parts: parts }
    }
  }
}

function createStyleElement () {
  var styleElement = document.createElement('style')
  styleElement.type = 'text/css'
  head.appendChild(styleElement)
  return styleElement
}

function addStyle (obj /* StyleObjectPart */) {
  var update, remove
  var styleElement = document.querySelector('style[' + ssrIdKey + '~="' + obj.id + '"]')

  if (styleElement) {
    if (isProduction) {
      // has SSR styles and in production mode.
      // simply do nothing.
      return noop
    } else {
      // has SSR styles but in dev mode.
      // for some reason Chrome can't handle source map in server-rendered
      // style tags - source maps in <style> only works if the style tag is
      // created and inserted dynamically. So we remove the server rendered
      // styles and inject new ones.
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  if (isOldIE) {
    // use singleton mode for IE9.
    var styleIndex = singletonCounter++
    styleElement = singletonElement || (singletonElement = createStyleElement())
    update = applyToSingletonTag.bind(null, styleElement, styleIndex, false)
    remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true)
  } else {
    // use multi-style-tag mode in all other cases
    styleElement = createStyleElement()
    update = applyToTag.bind(null, styleElement)
    remove = function () {
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  update(obj)

  return function updateStyle (newObj /* StyleObjectPart */) {
    if (newObj) {
      if (newObj.css === obj.css &&
          newObj.media === obj.media &&
          newObj.sourceMap === obj.sourceMap) {
        return
      }
      update(obj = newObj)
    } else {
      remove()
    }
  }
}

var replaceText = (function () {
  var textStore = []

  return function (index, replacement) {
    textStore[index] = replacement
    return textStore.filter(Boolean).join('\n')
  }
})()

function applyToSingletonTag (styleElement, index, remove, obj) {
  var css = remove ? '' : obj.css

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = replaceText(index, css)
  } else {
    var cssNode = document.createTextNode(css)
    var childNodes = styleElement.childNodes
    if (childNodes[index]) styleElement.removeChild(childNodes[index])
    if (childNodes.length) {
      styleElement.insertBefore(cssNode, childNodes[index])
    } else {
      styleElement.appendChild(cssNode)
    }
  }
}

function applyToTag (styleElement, obj) {
  var css = obj.css
  var media = obj.media
  var sourceMap = obj.sourceMap

  if (media) {
    styleElement.setAttribute('media', media)
  }
  if (options.ssrId) {
    styleElement.setAttribute(ssrIdKey, obj.id)
  }

  if (sourceMap) {
    // https://developer.chrome.com/devtools/docs/javascript-debugging
    // this makes source maps inside style tags work properly in Chrome
    css += '\n/*# sourceURL=' + sourceMap.sources[0] + ' */'
    // http://stackoverflow.com/a/26603875
    css += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + ' */'
  }

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = css
  } else {
    while (styleElement.firstChild) {
      styleElement.removeChild(styleElement.firstChild)
    }
    styleElement.appendChild(document.createTextNode(css))
  }
}


/***/ })
/******/ ]);
});
},{}],33:[function(require,module,exports){
(function () {
    Number.isInteger = Number.isInteger || function (value) {
        return typeof value === 'number' &&
            isFinite(value) &&
            Math.floor(value) === value;
    };
    var Cookie = require('tiny-cookie');

    var VueCookie = {

        install: function (Vue) {
            Vue.prototype.$cookie = this;
            Vue.cookie = this;
        },
        set: function (name, value, daysOrOptions) {
            var opts = daysOrOptions;
            if(Number.isInteger(daysOrOptions)) {
                opts = {expires: daysOrOptions};
            }
            return Cookie.set(name, value, opts);
        },

        get: function (name) {
            return Cookie.get(name);
        },

        delete: function (name, options) {
            var opts = {expires: -1};
            if(options !== undefined) {
                opts = Object.assign(options, opts);
            }
            this.set(name, '', opts);
        }
    };

    if (typeof exports == "object") {
        module.exports = VueCookie;
    } else if (typeof define == "function" && define.amd) {
        define([], function(){ return VueCookie; })
    } else if (window.Vue) {
        window.VueCookie = VueCookie;
        Vue.use(VueCookie);
    }

})();

},{"tiny-cookie":29}],34:[function(require,module,exports){
(function (global){(function (){
(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) :
  typeof define === 'function' && define.amd ? define(['exports'], factory) :
  (global = global || self, factory(global.Teleport = {}));
}(this, (function (exports) { 'use strict';

  //
  //
  //
  //
  //
  //

  var script = {
    name: 'teleport',
    props: {
      to: {
        type: String,
        required: true,
      },
      where: {
        type: String,
        default: 'after',
      },
      disabled: Boolean,
    },
    data: function data() {
      return {
        nodes: [],
        waiting: false,
        observer: null,
        parent: null,
      };
    },
    watch: {
      to: 'maybeMove',
      where: 'maybeMove',
      disabled: function disabled(value) {
        var this$1 = this;

        if (value) {
          this.disable();
          // Ensure all event done.
          this.$nextTick(function () {
            this$1.teardownObserver();
          });
        } else {
          this.bootObserver();
          this.move();
        }
      },
    },
    mounted: function mounted() {
      // Store a reference to the nodes
      this.nodes = Array.from(this.$el.childNodes);

      if (!this.disabled) {
        this.bootObserver();
      }

      // Move slot content to target
      this.maybeMove();
    },
    beforeDestroy: function beforeDestroy() {
      // Fix nodes reference
      this.nodes = this.getComponentChildrenNode();

      // Move back
      this.disable();

      // Stop observing
      this.teardownObserver();
    },
    computed: {
      classes: function classes() {
        if (this.disabled) {
          return ['teleporter'];
        }

        return ['teleporter', 'hidden'];
      },
    },
    methods: {
      maybeMove: function maybeMove() {
        if (!this.disabled) {
          this.move();
        }
      },
      move: function move() {
        this.waiting = false;

        this.parent = document.querySelector(this.to);

        if (!this.parent) {
          this.disable();

          this.waiting = true;

          return;
        }

        if (this.where === 'before') {
          this.parent.prepend(this.getFragment());
        } else {
          this.parent.appendChild(this.getFragment());
        }
      },
      disable: function disable() {
        this.$el.appendChild(this.getFragment());
        this.parent = null;
      },
      // Using a fragment is faster because it'll trigger only a single reflow
      // See https://developer.mozilla.org/en-US/docs/Web/API/DocumentFragment
      getFragment: function getFragment() {
        var fragment = document.createDocumentFragment();

        this.nodes.forEach(function (node) { return fragment.appendChild(node); });

        return fragment;
      },
      onMutations: function onMutations(mutations) {
        var this$1 = this;

        // Makes sure the move operation is only done once
        var shouldMove = false;

        for (var i = 0; i < mutations.length; i++) {
          var mutation = mutations[i];
          var filteredAddedNodes = Array.from(mutation.addedNodes).filter(function (node) { return !this$1.nodes.includes(node); });

          if (Array.from(mutation.removedNodes).includes(this.parent)) {
            this.disable();
            this.waiting = !this.disabled;
          } else if (this.waiting && filteredAddedNodes.length > 0) {
            shouldMove = true;
          }
        }

        if (shouldMove) {
          this.move();
        }
      },
      bootObserver: function bootObserver() {
        var this$1 = this;

        if (this.observer) {
          return;
        }

        this.observer = new MutationObserver(function (mutations) { return this$1.onMutations(mutations); });

        this.observer.observe(document.body, {
          childList: true,
          subtree: true,
          attributes: false,
          characterData: false,
        });

        if (this.childObserver) {
          return;
        }
        // watch childNodes change
        this.childObserver = new MutationObserver(function (mutations) {
          var childChangeRecord = mutations.find(function (i) { return i.target === this$1.$el; });
          if (childChangeRecord) {
            // Remove old nodes before update position.
            this$1.nodes.forEach(function (node) { return node.parentNode && node.parentNode.removeChild(node); });
            this$1.nodes = this$1.getComponentChildrenNode();
            this$1.maybeMove();
          }
        });

        this.childObserver.observe(this.$el, {
          childList: true,
          subtree: false,
          attributes: false,
          characterData: false,
        });
      },
      teardownObserver: function teardownObserver() {
        if (this.observer) {
          this.observer.disconnect();
          this.observer = null;
        }
        if (this.childObserver) {
          this.childObserver.disconnect();
          this.childObserver = null;
        }
      },
      getComponentChildrenNode: function getComponentChildrenNode() {
        return this.$vnode.componentOptions.children
          .map(function (i) { return i.elm; })
          .filter(function (i) { return i; });
      },
    },
  };

  function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier /* server only */, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
      if (typeof shadowMode !== 'boolean') {
          createInjectorSSR = createInjector;
          createInjector = shadowMode;
          shadowMode = false;
      }
      // Vue.extend constructor export interop.
      var options = typeof script === 'function' ? script.options : script;
      // render functions
      if (template && template.render) {
          options.render = template.render;
          options.staticRenderFns = template.staticRenderFns;
          options._compiled = true;
          // functional template
          if (isFunctionalTemplate) {
              options.functional = true;
          }
      }
      // scopedId
      if (scopeId) {
          options._scopeId = scopeId;
      }
      var hook;
      if (moduleIdentifier) {
          // server build
          hook = function (context) {
              // 2.3 injection
              context =
                  context || // cached call
                      (this.$vnode && this.$vnode.ssrContext) || // stateful
                      (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext); // functional
              // 2.2 with runInNewContext: true
              if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
                  context = __VUE_SSR_CONTEXT__;
              }
              // inject component styles
              if (style) {
                  style.call(this, createInjectorSSR(context));
              }
              // register component module identifier for async chunk inference
              if (context && context._registeredComponents) {
                  context._registeredComponents.add(moduleIdentifier);
              }
          };
          // used by ssr in case component is cached and beforeCreate
          // never gets called
          options._ssrRegister = hook;
      }
      else if (style) {
          hook = shadowMode
              ? function (context) {
                  style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
              }
              : function (context) {
                  style.call(this, createInjector(context));
              };
      }
      if (hook) {
          if (options.functional) {
              // register for functional component in vue file
              var originalRender = options.render;
              options.render = function renderWithStyleInjection(h, context) {
                  hook.call(context);
                  return originalRender(h, context);
              };
          }
          else {
              // inject component registration as beforeCreate hook
              var existing = options.beforeCreate;
              options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
          }
      }
      return script;
  }

  var isOldIE = typeof navigator !== 'undefined' &&
      /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase());
  function createInjector(context) {
      return function (id, style) { return addStyle(id, style); };
  }
  var HEAD;
  var styles = {};
  function addStyle(id, css) {
      var group = isOldIE ? css.media || 'default' : id;
      var style = styles[group] || (styles[group] = { ids: new Set(), styles: [] });
      if (!style.ids.has(id)) {
          style.ids.add(id);
          var code = css.source;
          if (css.map) {
              // https://developer.chrome.com/devtools/docs/javascript-debugging
              // this makes source maps inside style tags work properly in Chrome
              code += '\n/*# sourceURL=' + css.map.sources[0] + ' */';
              // http://stackoverflow.com/a/26603875
              code +=
                  '\n/*# sourceMappingURL=data:application/json;base64,' +
                      btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
                      ' */';
          }
          if (!style.element) {
              style.element = document.createElement('style');
              style.element.type = 'text/css';
              if (css.media)
                  { style.element.setAttribute('media', css.media); }
              if (HEAD === undefined) {
                  HEAD = document.head || document.getElementsByTagName('head')[0];
              }
              HEAD.appendChild(style.element);
          }
          if ('styleSheet' in style.element) {
              style.styles.push(code);
              style.element.styleSheet.cssText = style.styles
                  .filter(Boolean)
                  .join('\n');
          }
          else {
              var index = style.ids.size - 1;
              var textNode = document.createTextNode(code);
              var nodes = style.element.childNodes;
              if (nodes[index])
                  { style.element.removeChild(nodes[index]); }
              if (nodes.length)
                  { style.element.insertBefore(textNode, nodes[index]); }
              else
                  { style.element.appendChild(textNode); }
          }
      }
  }

  /* script */
  var __vue_script__ = script;

  /* template */
  var __vue_render__ = function() {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c("div", { class: _vm.classes }, [_vm._t("default")], 2)
  };
  var __vue_staticRenderFns__ = [];
  __vue_render__._withStripped = true;

    /* style */
    var __vue_inject_styles__ = function (inject) {
      if (!inject) { return }
      inject("data-v-50f4b45b_0", { source: ".hidden[data-v-50f4b45b] {\n  visibility: hidden;\n  display: none;\n}\n\n/*# sourceMappingURL=Teleport.vue.map */", map: {"version":3,"sources":["/home/shodan/Projects/vue2-teleport/src/Teleport.vue","Teleport.vue"],"names":[],"mappings":"AA2LA;EACA,kBAAA;EACA,aAAA;AC1LA;;AAEA,uCAAuC","file":"Teleport.vue","sourcesContent":["<template>\n  <div :class=\"classes\">\n    <slot/>\n  </div>\n</template>\n\n<script>\nexport default {\n  name: 'teleport',\n  props: {\n    to: {\n      type: String,\n      required: true,\n    },\n    where: {\n      type: String,\n      default: 'after',\n    },\n    disabled: Boolean,\n  },\n  data() {\n    return {\n      nodes: [],\n      waiting: false,\n      observer: null,\n      parent: null,\n    };\n  },\n  watch: {\n    to: 'maybeMove',\n    where: 'maybeMove',\n    disabled(value) {\n      if (value) {\n        this.disable();\n        // Ensure all event done.\n        this.$nextTick(() => {\n          this.teardownObserver();\n        });\n      } else {\n        this.bootObserver();\n        this.move();\n      }\n    },\n  },\n  mounted() {\n    // Store a reference to the nodes\n    this.nodes = Array.from(this.$el.childNodes);\n\n    if (!this.disabled) {\n      this.bootObserver();\n    }\n\n    // Move slot content to target\n    this.maybeMove();\n  },\n  beforeDestroy() {\n    // Fix nodes reference\n    this.nodes = this.getComponentChildrenNode();\n\n    // Move back\n    this.disable();\n\n    // Stop observing\n    this.teardownObserver();\n  },\n  computed: {\n    classes() {\n      if (this.disabled) {\n        return ['teleporter'];\n      }\n\n      return ['teleporter', 'hidden'];\n    },\n  },\n  methods: {\n    maybeMove() {\n      if (!this.disabled) {\n        this.move();\n      }\n    },\n    move() {\n      this.waiting = false;\n\n      this.parent = document.querySelector(this.to);\n\n      if (!this.parent) {\n        this.disable();\n\n        this.waiting = true;\n\n        return;\n      }\n\n      if (this.where === 'before') {\n        this.parent.prepend(this.getFragment());\n      } else {\n        this.parent.appendChild(this.getFragment());\n      }\n    },\n    disable() {\n      this.$el.appendChild(this.getFragment());\n      this.parent = null;\n    },\n    // Using a fragment is faster because it'll trigger only a single reflow\n    // See https://developer.mozilla.org/en-US/docs/Web/API/DocumentFragment\n    getFragment() {\n      const fragment = document.createDocumentFragment();\n\n      this.nodes.forEach(node => fragment.appendChild(node));\n\n      return fragment;\n    },\n    onMutations(mutations) {\n      // Makes sure the move operation is only done once\n      let shouldMove = false;\n\n      for (let i = 0; i < mutations.length; i++) {\n        const mutation = mutations[i];\n        const filteredAddedNodes = Array.from(mutation.addedNodes).filter(node => !this.nodes.includes(node));\n\n        if (Array.from(mutation.removedNodes).includes(this.parent)) {\n          this.disable();\n          this.waiting = !this.disabled;\n        } else if (this.waiting && filteredAddedNodes.length > 0) {\n          shouldMove = true;\n        }\n      }\n\n      if (shouldMove) {\n        this.move();\n      }\n    },\n    bootObserver() {\n      if (this.observer) {\n        return;\n      }\n\n      this.observer = new MutationObserver(mutations => this.onMutations(mutations));\n\n      this.observer.observe(document.body, {\n        childList: true,\n        subtree: true,\n        attributes: false,\n        characterData: false,\n      });\n\n      if (this.childObserver) {\n        return;\n      }\n      // watch childNodes change\n      this.childObserver = new MutationObserver(mutations => {\n        const childChangeRecord = mutations.find(i => i.target === this.$el);\n        if (childChangeRecord) {\n          // Remove old nodes before update position.\n          this.nodes.forEach((node) => node.parentNode && node.parentNode.removeChild(node));\n          this.nodes = this.getComponentChildrenNode();\n          this.maybeMove();\n        }\n      });\n\n      this.childObserver.observe(this.$el, {\n        childList: true,\n        subtree: false,\n        attributes: false,\n        characterData: false,\n      });\n    },\n    teardownObserver() {\n      if (this.observer) {\n        this.observer.disconnect();\n        this.observer = null;\n      }\n      if (this.childObserver) {\n        this.childObserver.disconnect();\n        this.childObserver = null;\n      }\n    },\n    getComponentChildrenNode() {\n      return this.$vnode.componentOptions.children\n        .map((i) => i.elm)\n        .filter((i) => i);\n    },\n  },\n};\n</script>\n\n<style scoped lang=\"scss\">\n.hidden {\n  visibility: hidden;\n  display: none;\n}\n</style>\n",".hidden {\n  visibility: hidden;\n  display: none;\n}\n\n/*# sourceMappingURL=Teleport.vue.map */"]}, media: undefined });

    };
    /* scoped */
    var __vue_scope_id__ = "data-v-50f4b45b";
    /* module identifier */
    var __vue_module_identifier__ = undefined;
    /* functional template */
    var __vue_is_functional_template__ = false;
    /* style inject SSR */
    
    /* style inject shadow dom */
    

    
    var __vue_component__ = /*#__PURE__*/normalizeComponent(
      { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
      __vue_inject_styles__,
      __vue_script__,
      __vue_scope_id__,
      __vue_is_functional_template__,
      __vue_module_identifier__,
      false,
      createInjector,
      undefined,
      undefined
    );

  // Taken from https://vuejs.org/v2/cookbook/packaging-sfc-for-npm.html

  // Declare install function executed by Vue.use()
  function install (Vue) {
    if (install.installed) { return; }

    install.installed = true;
    Vue.component('Teleport', __vue_component__);
  }

  // Create module definition for Vue.use()
  var plugin = {
    install: install,
  };

  // Auto-install when vue is found (eg. in browser via <script> tag)
  var GlobalVue = null;

  if (typeof window !== 'undefined') {
    GlobalVue = window.Vue;
  } else if (typeof global !== 'undefined') {
    GlobalVue = global.Vue;
  }

  if (GlobalVue) {
    GlobalVue.use(plugin);
  }

  exports.default = __vue_component__;
  exports.install = install;

  Object.defineProperty(exports, '__esModule', { value: true });

})));

}).call(this)}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],35:[function(require,module,exports){
var inserted = exports.cache = {}

function noop () {}

exports.insert = function (css) {
  if (inserted[css]) return noop
  inserted[css] = true

  var elem = document.createElement('style')
  elem.setAttribute('type', 'text/css')

  if ('textContent' in elem) {
    elem.textContent = css
  } else {
    elem.styleSheet.cssText = css
  }

  document.getElementsByTagName('head')[0].appendChild(elem)
  return function () {
    document.getElementsByTagName('head')[0].removeChild(elem)
    inserted[css] = false
  }
}

},{}],36:[function(require,module,exports){
/*!
 * EventEmitter v5.2.9 - git.io/ee
 * Unlicense - http://unlicense.org/
 * Oliver Caldwell - https://oli.me.uk/
 * @preserve
 */

;(function (exports) {
    'use strict';

    /**
     * Class for managing events.
     * Can be extended to provide event functionality in other classes.
     *
     * @class EventEmitter Manages event registering and emitting.
     */
    function EventEmitter() {}

    // Shortcuts to improve speed and size
    var proto = EventEmitter.prototype;
    var originalGlobalValue = exports.EventEmitter;

    /**
     * Finds the index of the listener for the event in its storage array.
     *
     * @param {Function[]} listeners Array of listeners to search through.
     * @param {Function} listener Method to look for.
     * @return {Number} Index of the specified listener, -1 if not found
     * @api private
     */
    function indexOfListener(listeners, listener) {
        var i = listeners.length;
        while (i--) {
            if (listeners[i].listener === listener) {
                return i;
            }
        }

        return -1;
    }

    /**
     * Alias a method while keeping the context correct, to allow for overwriting of target method.
     *
     * @param {String} name The name of the target method.
     * @return {Function} The aliased method
     * @api private
     */
    function alias(name) {
        return function aliasClosure() {
            return this[name].apply(this, arguments);
        };
    }

    /**
     * Returns the listener array for the specified event.
     * Will initialise the event object and listener arrays if required.
     * Will return an object if you use a regex search. The object contains keys for each matched event. So /ba[rz]/ might return an object containing bar and baz. But only if you have either defined them with defineEvent or added some listeners to them.
     * Each property in the object response is an array of listener functions.
     *
     * @param {String|RegExp} evt Name of the event to return the listeners from.
     * @return {Function[]|Object} All listener functions for the event.
     */
    proto.getListeners = function getListeners(evt) {
        var events = this._getEvents();
        var response;
        var key;

        // Return a concatenated array of all matching events if
        // the selector is a regular expression.
        if (evt instanceof RegExp) {
            response = {};
            for (key in events) {
                if (events.hasOwnProperty(key) && evt.test(key)) {
                    response[key] = events[key];
                }
            }
        }
        else {
            response = events[evt] || (events[evt] = []);
        }

        return response;
    };

    /**
     * Takes a list of listener objects and flattens it into a list of listener functions.
     *
     * @param {Object[]} listeners Raw listener objects.
     * @return {Function[]} Just the listener functions.
     */
    proto.flattenListeners = function flattenListeners(listeners) {
        var flatListeners = [];
        var i;

        for (i = 0; i < listeners.length; i += 1) {
            flatListeners.push(listeners[i].listener);
        }

        return flatListeners;
    };

    /**
     * Fetches the requested listeners via getListeners but will always return the results inside an object. This is mainly for internal use but others may find it useful.
     *
     * @param {String|RegExp} evt Name of the event to return the listeners from.
     * @return {Object} All listener functions for an event in an object.
     */
    proto.getListenersAsObject = function getListenersAsObject(evt) {
        var listeners = this.getListeners(evt);
        var response;

        if (listeners instanceof Array) {
            response = {};
            response[evt] = listeners;
        }

        return response || listeners;
    };

    function isValidListener (listener) {
        if (typeof listener === 'function' || listener instanceof RegExp) {
            return true
        } else if (listener && typeof listener === 'object') {
            return isValidListener(listener.listener)
        } else {
            return false
        }
    }

    /**
     * Adds a listener function to the specified event.
     * The listener will not be added if it is a duplicate.
     * If the listener returns true then it will be removed after it is called.
     * If you pass a regular expression as the event name then the listener will be added to all events that match it.
     *
     * @param {String|RegExp} evt Name of the event to attach the listener to.
     * @param {Function} listener Method to be called when the event is emitted. If the function returns true then it will be removed after calling.
     * @return {Object} Current instance of EventEmitter for chaining.
     */
    proto.addListener = function addListener(evt, listener) {
        if (!isValidListener(listener)) {
            throw new TypeError('listener must be a function');
        }

        var listeners = this.getListenersAsObject(evt);
        var listenerIsWrapped = typeof listener === 'object';
        var key;

        for (key in listeners) {
            if (listeners.hasOwnProperty(key) && indexOfListener(listeners[key], listener) === -1) {
                listeners[key].push(listenerIsWrapped ? listener : {
                    listener: listener,
                    once: false
                });
            }
        }

        return this;
    };

    /**
     * Alias of addListener
     */
    proto.on = alias('addListener');

    /**
     * Semi-alias of addListener. It will add a listener that will be
     * automatically removed after its first execution.
     *
     * @param {String|RegExp} evt Name of the event to attach the listener to.
     * @param {Function} listener Method to be called when the event is emitted. If the function returns true then it will be removed after calling.
     * @return {Object} Current instance of EventEmitter for chaining.
     */
    proto.addOnceListener = function addOnceListener(evt, listener) {
        return this.addListener(evt, {
            listener: listener,
            once: true
        });
    };

    /**
     * Alias of addOnceListener.
     */
    proto.once = alias('addOnceListener');

    /**
     * Defines an event name. This is required if you want to use a regex to add a listener to multiple events at once. If you don't do this then how do you expect it to know what event to add to? Should it just add to every possible match for a regex? No. That is scary and bad.
     * You need to tell it what event names should be matched by a regex.
     *
     * @param {String} evt Name of the event to create.
     * @return {Object} Current instance of EventEmitter for chaining.
     */
    proto.defineEvent = function defineEvent(evt) {
        this.getListeners(evt);
        return this;
    };

    /**
     * Uses defineEvent to define multiple events.
     *
     * @param {String[]} evts An array of event names to define.
     * @return {Object} Current instance of EventEmitter for chaining.
     */
    proto.defineEvents = function defineEvents(evts) {
        for (var i = 0; i < evts.length; i += 1) {
            this.defineEvent(evts[i]);
        }
        return this;
    };

    /**
     * Removes a listener function from the specified event.
     * When passed a regular expression as the event name, it will remove the listener from all events that match it.
     *
     * @param {String|RegExp} evt Name of the event to remove the listener from.
     * @param {Function} listener Method to remove from the event.
     * @return {Object} Current instance of EventEmitter for chaining.
     */
    proto.removeListener = function removeListener(evt, listener) {
        var listeners = this.getListenersAsObject(evt);
        var index;
        var key;

        for (key in listeners) {
            if (listeners.hasOwnProperty(key)) {
                index = indexOfListener(listeners[key], listener);

                if (index !== -1) {
                    listeners[key].splice(index, 1);
                }
            }
        }

        return this;
    };

    /**
     * Alias of removeListener
     */
    proto.off = alias('removeListener');

    /**
     * Adds listeners in bulk using the manipulateListeners method.
     * If you pass an object as the first argument you can add to multiple events at once. The object should contain key value pairs of events and listeners or listener arrays. You can also pass it an event name and an array of listeners to be added.
     * You can also pass it a regular expression to add the array of listeners to all events that match it.
     * Yeah, this function does quite a bit. That's probably a bad thing.
     *
     * @param {String|Object|RegExp} evt An event name if you will pass an array of listeners next. An object if you wish to add to multiple events at once.
     * @param {Function[]} [listeners] An optional array of listener functions to add.
     * @return {Object} Current instance of EventEmitter for chaining.
     */
    proto.addListeners = function addListeners(evt, listeners) {
        // Pass through to manipulateListeners
        return this.manipulateListeners(false, evt, listeners);
    };

    /**
     * Removes listeners in bulk using the manipulateListeners method.
     * If you pass an object as the first argument you can remove from multiple events at once. The object should contain key value pairs of events and listeners or listener arrays.
     * You can also pass it an event name and an array of listeners to be removed.
     * You can also pass it a regular expression to remove the listeners from all events that match it.
     *
     * @param {String|Object|RegExp} evt An event name if you will pass an array of listeners next. An object if you wish to remove from multiple events at once.
     * @param {Function[]} [listeners] An optional array of listener functions to remove.
     * @return {Object} Current instance of EventEmitter for chaining.
     */
    proto.removeListeners = function removeListeners(evt, listeners) {
        // Pass through to manipulateListeners
        return this.manipulateListeners(true, evt, listeners);
    };

    /**
     * Edits listeners in bulk. The addListeners and removeListeners methods both use this to do their job. You should really use those instead, this is a little lower level.
     * The first argument will determine if the listeners are removed (true) or added (false).
     * If you pass an object as the second argument you can add/remove from multiple events at once. The object should contain key value pairs of events and listeners or listener arrays.
     * You can also pass it an event name and an array of listeners to be added/removed.
     * You can also pass it a regular expression to manipulate the listeners of all events that match it.
     *
     * @param {Boolean} remove True if you want to remove listeners, false if you want to add.
     * @param {String|Object|RegExp} evt An event name if you will pass an array of listeners next. An object if you wish to add/remove from multiple events at once.
     * @param {Function[]} [listeners] An optional array of listener functions to add/remove.
     * @return {Object} Current instance of EventEmitter for chaining.
     */
    proto.manipulateListeners = function manipulateListeners(remove, evt, listeners) {
        var i;
        var value;
        var single = remove ? this.removeListener : this.addListener;
        var multiple = remove ? this.removeListeners : this.addListeners;

        // If evt is an object then pass each of its properties to this method
        if (typeof evt === 'object' && !(evt instanceof RegExp)) {
            for (i in evt) {
                if (evt.hasOwnProperty(i) && (value = evt[i])) {
                    // Pass the single listener straight through to the singular method
                    if (typeof value === 'function') {
                        single.call(this, i, value);
                    }
                    else {
                        // Otherwise pass back to the multiple function
                        multiple.call(this, i, value);
                    }
                }
            }
        }
        else {
            // So evt must be a string
            // And listeners must be an array of listeners
            // Loop over it and pass each one to the multiple method
            i = listeners.length;
            while (i--) {
                single.call(this, evt, listeners[i]);
            }
        }

        return this;
    };

    /**
     * Removes all listeners from a specified event.
     * If you do not specify an event then all listeners will be removed.
     * That means every event will be emptied.
     * You can also pass a regex to remove all events that match it.
     *
     * @param {String|RegExp} [evt] Optional name of the event to remove all listeners for. Will remove from every event if not passed.
     * @return {Object} Current instance of EventEmitter for chaining.
     */
    proto.removeEvent = function removeEvent(evt) {
        var type = typeof evt;
        var events = this._getEvents();
        var key;

        // Remove different things depending on the state of evt
        if (type === 'string') {
            // Remove all listeners for the specified event
            delete events[evt];
        }
        else if (evt instanceof RegExp) {
            // Remove all events matching the regex.
            for (key in events) {
                if (events.hasOwnProperty(key) && evt.test(key)) {
                    delete events[key];
                }
            }
        }
        else {
            // Remove all listeners in all events
            delete this._events;
        }

        return this;
    };

    /**
     * Alias of removeEvent.
     *
     * Added to mirror the node API.
     */
    proto.removeAllListeners = alias('removeEvent');

    /**
     * Emits an event of your choice.
     * When emitted, every listener attached to that event will be executed.
     * If you pass the optional argument array then those arguments will be passed to every listener upon execution.
     * Because it uses `apply`, your array of arguments will be passed as if you wrote them out separately.
     * So they will not arrive within the array on the other side, they will be separate.
     * You can also pass a regular expression to emit to all events that match it.
     *
     * @param {String|RegExp} evt Name of the event to emit and execute listeners for.
     * @param {Array} [args] Optional array of arguments to be passed to each listener.
     * @return {Object} Current instance of EventEmitter for chaining.
     */
    proto.emitEvent = function emitEvent(evt, args) {
        var listenersMap = this.getListenersAsObject(evt);
        var listeners;
        var listener;
        var i;
        var key;
        var response;

        for (key in listenersMap) {
            if (listenersMap.hasOwnProperty(key)) {
                listeners = listenersMap[key].slice(0);

                for (i = 0; i < listeners.length; i++) {
                    // If the listener returns true then it shall be removed from the event
                    // The function is executed either with a basic call or an apply if there is an args array
                    listener = listeners[i];

                    if (listener.once === true) {
                        this.removeListener(evt, listener.listener);
                    }

                    response = listener.listener.apply(this, args || []);

                    if (response === this._getOnceReturnValue()) {
                        this.removeListener(evt, listener.listener);
                    }
                }
            }
        }

        return this;
    };

    /**
     * Alias of emitEvent
     */
    proto.trigger = alias('emitEvent');

    /**
     * Subtly different from emitEvent in that it will pass its arguments on to the listeners, as opposed to taking a single array of arguments to pass on.
     * As with emitEvent, you can pass a regex in place of the event name to emit to all events that match it.
     *
     * @param {String|RegExp} evt Name of the event to emit and execute listeners for.
     * @param {...*} Optional additional arguments to be passed to each listener.
     * @return {Object} Current instance of EventEmitter for chaining.
     */
    proto.emit = function emit(evt) {
        var args = Array.prototype.slice.call(arguments, 1);
        return this.emitEvent(evt, args);
    };

    /**
     * Sets the current value to check against when executing listeners. If a
     * listeners return value matches the one set here then it will be removed
     * after execution. This value defaults to true.
     *
     * @param {*} value The new value to check for when executing listeners.
     * @return {Object} Current instance of EventEmitter for chaining.
     */
    proto.setOnceReturnValue = function setOnceReturnValue(value) {
        this._onceReturnValue = value;
        return this;
    };

    /**
     * Fetches the current value to check against when executing listeners. If
     * the listeners return value matches this one then it should be removed
     * automatically. It will return true by default.
     *
     * @return {*|Boolean} The current value to check for or the default, true.
     * @api private
     */
    proto._getOnceReturnValue = function _getOnceReturnValue() {
        if (this.hasOwnProperty('_onceReturnValue')) {
            return this._onceReturnValue;
        }
        else {
            return true;
        }
    };

    /**
     * Fetches the events object and creates one if required.
     *
     * @return {Object} The events storage object.
     * @api private
     */
    proto._getEvents = function _getEvents() {
        return this._events || (this._events = {});
    };

    /**
     * Reverts the global {@link EventEmitter} to its previous value and returns a reference to this version.
     *
     * @return {Function} Non conflicting EventEmitter class.
     */
    EventEmitter.noConflict = function noConflict() {
        exports.EventEmitter = originalGlobalValue;
        return EventEmitter;
    };

    // Expose the class either via AMD, CommonJS or the global object
    if (typeof define === 'function' && define.amd) {
        define(function () {
            return EventEmitter;
        });
    }
    else if (typeof module === 'object' && module.exports){
        module.exports = EventEmitter;
    }
    else {
        exports.EventEmitter = EventEmitter;
    }
}(typeof window !== 'undefined' ? window : this || {}));

},{}],37:[function(require,module,exports){
var _FieldText = require('components/FieldText.vue');

var _FieldText2 = _interopRequireDefault(_FieldText);

var _FieldLink = require('components/FieldLink.vue');

var _FieldLink2 = _interopRequireDefault(_FieldLink);

var _FieldImage = require('components/FieldImage.vue');

var _FieldImage2 = _interopRequireDefault(_FieldImage);

var _FieldGeo = require('components/FieldGeo.vue');

var _FieldGeo2 = _interopRequireDefault(_FieldGeo);

var _FieldMedia = require('components/FieldMedia.vue');

var _FieldMedia2 = _interopRequireDefault(_FieldMedia);

var _FieldVue = require('components/FieldVue.vue');

var _FieldVue2 = _interopRequireDefault(_FieldVue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = {
  simple_field: _FieldText2.default,
  text_field: _FieldText2.default,
  link_field: _FieldLink2.default,
  image_field: _FieldImage2.default,
  geo_field: _FieldGeo2.default,
  photo_field: _FieldImage2.default,
  media_field: _FieldMedia2.default,
  vue_field: _FieldVue2.default
};

},{"components/FieldGeo.vue":78,"components/FieldImage.vue":79,"components/FieldLink.vue":80,"components/FieldMedia.vue":81,"components/FieldText.vue":82,"components/FieldVue.vue":83}],38:[function(require,module,exports){
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _toRawType = require('utils/toRawType');

var Fields = require('./fields');

module.exports = {
  /**
   * Get Type field from field value
   * field: Object contains the value of the field
   * @param field
   * @returns {string}
   */
  getType: function getType(field) {
    var type = field.type;
    if ('vue' !== type) {
      var fieldValue = field.value;
      var value = fieldValue && 'Object' === (0, _toRawType.toRawType)(fieldValue) && !fieldValue.coordinates && !fieldValue.vue ? fieldValue.value : fieldValue;
      if (!value) {
        type = 'simple';
      } else if (value && 'object' === (typeof value === 'undefined' ? 'undefined' : _typeof(value))) {
        if (value.coordinates) {
          type = 'geo';
        } else if (value.vue) {
          type = 'vue';
        }
      } else if (value && Array.isArray(value)) {
        if (value.length && value[0].photo) {
          type = 'photo';
        } else {
          type = 'simple';
        }
      } else if (value.toString().toLowerCase().match(/[^\s]+.(png|jpg|jpeg|gif)$/g)) {
        type = 'photo';
      } else if (value.toString().match(/^(https?:\/\/[^\s]+)/g)) {
        type = 'link';
      } else {
        type = 'simple';
      }
    }
    return type + '_field';
  },
  isSimple: function isSimple(field) {
    return 'simple_field' === this.getType(field);
  },
  isLink: function isLink(field) {
    return 'link_field' === this.getType(field);
  },
  isImage: function isImage(field) {
    return 'image_field' === this.getType(field);
  },
  isPhoto: function isPhoto(field) {
    return 'photo_field' === this.getType(field);
  },
  isVue: function isVue(field) {
    return 'vue_field' === this.getType(field);
  },

  /**
   * Method to add a new field type to Fields
   * @param type
   * @param field
   */
  add: function add(_ref) {
    var type = _ref.type,
        field = _ref.field;

    Fields[type] = field;
  },

  /**
   * Remove field from a Fields list
   * @param type
   */
  remove: function remove(type) {
    delete Fields[type];
  }
};

},{"./fields":37,"utils/toRawType":277}],39:[function(require,module,exports){
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Service = require('gui/inputs/service');
module.exports = function (_Service) {
  _inherits(CheckBoxService, _Service);

  function CheckBoxService() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, CheckBoxService);

    opts.validatorOptions = {
      values: opts.state.input.options.values.map(function (v) {
        return v;
      })
    };
    return _possibleConstructorReturn(this, (CheckBoxService.__proto__ || Object.getPrototypeOf(CheckBoxService)).call(this, opts));
  }

  return CheckBoxService;
}(Service);

},{"gui/inputs/service":61}],40:[function(require,module,exports){
var _InputCheckbox = require('components/InputCheckbox.vue');

var vueComponentOptions = _interopRequireWildcard(_InputCheckbox);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var CheckBoxInput = Vue.extend(vueComponentOptions);

module.exports = CheckBoxInput;

},{"components/InputCheckbox.vue":97}],41:[function(require,module,exports){
var _InputColor = require('components/InputColor.vue');

var vueComponentOptions = _interopRequireWildcard(_InputColor);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var TextInput = Vue.extend(vueComponentOptions);

module.exports = TextInput;

},{"components/InputColor.vue":98}],42:[function(require,module,exports){
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _convertQGISDateTimeFormatToMoment2 = require('utils/convertQGISDateTimeFormatToMoment');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Service = require('gui/inputs/service');

module.exports = function (_Service) {
  _inherits(DateTimePickerService, _Service);

  function DateTimePickerService() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, DateTimePickerService);

    var _this = _possibleConstructorReturn(this, (DateTimePickerService.__proto__ || Object.getPrototypeOf(DateTimePickerService)).call(this, opts));

    _this.validatorOptions = {};
    return _this;
  }

  _createClass(DateTimePickerService, [{
    key: 'getLocale',
    value: function getLocale() {
      return window.initConfig.user.i18n ? window.initConfig.user.i18n : 'en';
    }
  }, {
    key: 'convertQGISDateTimeFormatToMoment',
    value: function convertQGISDateTimeFormatToMoment(datetimeformat) {
      return (0, _convertQGISDateTimeFormatToMoment2.convertQGISDateTimeFormatToMoment)(datetimeformat);
    }
  }, {
    key: 'setValidatorOptions',
    value: function setValidatorOptions() {
      var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      this.validatorOptions = opts;
    }
  }]);

  return DateTimePickerService;
}(Service);

},{"gui/inputs/service":61,"utils/convertQGISDateTimeFormatToMoment":221}],43:[function(require,module,exports){
var _InputDateTimePicker = require('components/InputDateTimePicker.vue');

var vueComponentOptions = _interopRequireWildcard(_InputDateTimePicker);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var DateTimePickerInput = Vue.extend(vueComponentOptions);

module.exports = DateTimePickerInput;

},{"components/InputDateTimePicker.vue":99}],44:[function(require,module,exports){
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Service = require('gui/inputs/service');
module.exports = function (_Service) {
  _inherits(FloatService, _Service);

  function FloatService() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, FloatService);

    return _possibleConstructorReturn(this, (FloatService.__proto__ || Object.getPrototypeOf(FloatService)).call(this, opts));
  }

  return FloatService;
}(Service);

},{"gui/inputs/service":61}],45:[function(require,module,exports){
var _InputFloat = require('components/InputFloat.vue');

var vueComponentOptions = _interopRequireWildcard(_InputFloat);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var FloatInput = Vue.extend(vueComponentOptions);

module.exports = FloatInput;

},{"components/InputFloat.vue":100}],46:[function(require,module,exports){
var _application = require('store/application');

var _application2 = _interopRequireDefault(_application);

var _InputBase = require('components/InputBase.vue');

var _InputBase2 = _interopRequireDefault(_InputBase);

var _mixins = require('mixins');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var InputServices = require('./services');

var Input = {
  props: ['state'],
  mixins: [_mixins.baseInputMixin],
  components: {
    'baseinput': _InputBase2.default
  },
  watch: {
    'notvalid': function notvalid(_notvalid) {
      if (_notvalid) {
        this.service.setErrorMessage();
      }
    },
    'state.value': function stateValue() {
      var _this = this;

      if (undefined !== this.state.input.options.default_expression) {
        // need to postpone state.value watch parent that use mixin
        setTimeout(function () {
          return _this.change();
        });
      }
    }
  },
  created: function created() {
    var _this2 = this;

    this.service = new InputServices[this.state.input.type]({ state: this.state });

    this.$watch(function () {
      return _application2.default.language;
    }, _asyncToGenerator(function* () {
      if (_this2.state.visible) {
        _this2.state.visible = false;
        _this2.service.setErrorMessage();
        yield _this2.$nextTick();
        _this2.state.visible = true;
      }
    }));

    if (this.state.editable && this.state.validate.required) {
      this.service.validate();
    }

    this.$emit('addinput', this.state);
    /**
     * in case of input value is fill with default value option we need to emit changeinput event
     * without check validation. Example:
     * {
        "name": "id",
        "type": "integer",
        "label": "id",
        "editable": false,
        "validate": {
            "required": true,
            "unique": true
        },
        "pk": true,
        "default": "nextval('g3wsuite.zone_id_seq'::regclass)",
        "input": {
            "type": "text",
            "options": {}
        }
      }
     in this case if we start a validation, it fail because default value is a string while input is interger
     */
    if (this.state.value_from_default_value) {
      this.$emit('changeinput', this.state);
    }
  },
  destroyed: function destroyed() {
    // emit remove input to form (in case for example tab visibility condition)
    this.$emit('removeinput', this.state);
  }
};

module.exports = Input;

},{"./services":62,"components/InputBase.vue":96,"mixins":200,"store/application":212}],47:[function(require,module,exports){
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Service = require('gui/inputs/service');

module.exports = function (_Service) {
  _inherits(IntegerService, _Service);

  function IntegerService() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, IntegerService);

    return _possibleConstructorReturn(this, (IntegerService.__proto__ || Object.getPrototypeOf(IntegerService)).call(this, opts));
  }

  return IntegerService;
}(Service);

},{"gui/inputs/service":61}],48:[function(require,module,exports){
var _InputInteger = require('components/InputInteger.vue');

var vueComponentOptions = _interopRequireWildcard(_InputInteger);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var IntegerInput = Vue.extend(vueComponentOptions);

module.exports = IntegerInput;

},{"components/InputInteger.vue":103}],49:[function(require,module,exports){
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _gui = require('services/gui');

var _gui2 = _interopRequireDefault(_gui);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Service = require('gui/inputs/service');
module.exports = function (_Service) {
  _inherits(LonLatService, _Service);

  function LonLatService() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, LonLatService);

    var _this = _possibleConstructorReturn(this, (LonLatService.__proto__ || Object.getPrototypeOf(LonLatService)).call(this, opts));

    _this.coordinatebutton;
    _this.mapService = _gui2.default.getService('map');
    _this.mapEpsg = _this.mapService.getCrs();

    _this.mapControlToggleEventHandler = function (evt) {
      if (evt.target.isToggled() && evt.target.isClickMap()) {
        _this.coordinatebutton.active && _this.toggleGetCoordinate();
      }
    };
    _this.map = _this.mapService.getMap();
    _this.outputEpsg = _this.state.epsg || _this.mapEpsg;
    //Store event map key
    _this.eventMapKey;
    return _this;
  }

  _createClass(LonLatService, [{
    key: 'setCoordinateButtonReactiveObject',
    value: function setCoordinateButtonReactiveObject(coordinatebutton) {
      this.coordinatebutton = coordinatebutton;
    }
  }, {
    key: 'validate',
    value: function validate() {
      if (this.state.values.lon < -180) {
        this.state.values.lon = -180;
      } else if (this.state.values.lon > 180) {
        this.state.values.lon = 180;
      }
      if (this.state.values.lat < -90) {
        this.state.values.lon = -90;
      } else if (this.state.values.lat > 90) {
        this.state.values.lon = 90;
      }

      this.state.validate.valid = !Number.isNaN(1 * this.state.values.lon);
    }
  }, {
    key: 'toggleGetCoordinate',
    value: function toggleGetCoordinate() {
      this.coordinatebutton.active = !this.coordinatebutton.active;
      this.coordinatebutton.active ? this.startToGetCoordinates() : this.stopToGetCoordinates();
    }
  }, {
    key: 'startToGetCoordinates',
    value: function startToGetCoordinates() {
      var _this2 = this;

      this.mapService.deactiveMapControls();
      this.mapService.on('mapcontrol:toggled', this.mapControlToggleEventHandler);
      this.eventMapKey = this.map.on('click', function (evt) {
        evt.originalEvent.stopPropagation();
        evt.preventDefault();
        var coordinate = _this2.mapEpsg !== _this2.outputEpsg ? ol.proj.transform(evt.coordinate, _this2.mapEpsg, _this2.outputEpsg) : evt.coordinate;
        _this2.state.value = [coordinate];

        var _coordinate = _slicedToArray(coordinate, 2),
            lon = _coordinate[0],
            lat = _coordinate[1];

        _this2.state.values.lon = lon;
        _this2.state.values.lat = lat;
      });
    }
  }, {
    key: 'stopToGetCoordinates',
    value: function stopToGetCoordinates() {
      ol.Observable.unByKey(this.eventMapKey);
      this.mapService.off('mapcontrol:toggled', this.mapControlToggleEventHandler);
    }
  }, {
    key: 'clear',
    value: function clear() {
      this.stopToGetCoordinates();
    }
  }]);

  return LonLatService;
}(Service);

},{"gui/inputs/service":61,"services/gui":207}],50:[function(require,module,exports){
var _InputLonLat = require('components/InputLonLat.vue');

var vueComponentOptions = _interopRequireWildcard(_InputLonLat);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var LatLontInput = Vue.extend(vueComponentOptions);

module.exports = LatLontInput;

},{"components/InputLonLat.vue":104}],51:[function(require,module,exports){
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Service = require('gui/inputs/service');
module.exports = function (_Service) {
  _inherits(MediaService, _Service);

  function MediaService() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, MediaService);

    return _possibleConstructorReturn(this, (MediaService.__proto__ || Object.getPrototypeOf(MediaService)).call(this, opts));
  }

  return MediaService;
}(Service);

},{"gui/inputs/service":61}],52:[function(require,module,exports){
var _InputMedia = require('components/InputMedia.vue');

var vueComponentOptions = _interopRequireWildcard(_InputMedia);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var MediaInput = Vue.extend(vueComponentOptions);

module.exports = MediaInput;

},{"components/InputMedia.vue":105}],53:[function(require,module,exports){
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _gui = require('services/gui');

var _gui2 = _interopRequireDefault(_gui);

var _data = require('services/data');

var _data2 = _interopRequireDefault(_data);

var _pickfeatureinteraction = require('map/interactions/pickfeatureinteraction');

var _pickfeatureinteraction2 = _interopRequireDefault(_pickfeatureinteraction);

var _pickcoordinatesinteraction = require('map/interactions/pickcoordinatesinteraction');

var _pickcoordinatesinteraction2 = _interopRequireDefault(_pickcoordinatesinteraction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

module.exports = function () {
  function PickLayerService() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, PickLayerService);

    this.pick_type = opts.pick_type || 'wms';
    this.ispicked = false;
    this.fields = opts.fields || [opts.value];
    this.layerId = opts.layer_id;
    this.mapService = _gui2.default.getService('map');
    this.interaction = 'map' === this.pick_type ? new _pickfeatureinteraction2.default({
      layers: [this.mapService.getLayerById(this.layerId)]
    }) : new _pickcoordinatesinteraction2.default();
  }

  /**
   *
   * @return {boolean|*}
   */


  _createClass(PickLayerService, [{
    key: 'isPicked',
    value: function isPicked() {
      return this.ispicked;
    }
  }, {
    key: 'escKeyUpHandler',


    /**
     *  bind interrupt event
     */
    value: function escKeyUpHandler(_ref) {
      var keyCode = _ref.keyCode,
          owner = _ref.data.owner;

      if (27 === keyCode) {
        owner.unpick();
      }
    }
  }, {
    key: 'unbindEscKeyUp',
    value: function unbindEscKeyUp() {
      $(document).unbind('keyup', this.escKeyUpHandler);
    }
  }, {
    key: 'bindEscKeyUp',
    value: function bindEscKeyUp() {
      $(document).on('keyup', { owner: this }, this.escKeyUpHandler);
    }
  }, {
    key: 'pick',


    /**
     *
     * @return {Promise<unknown>}
     */
    value: function pick() {
      var _this = this;

      return new Promise(function (resolve, reject) {
        _this.bindEscKeyUp();
        var values = {};
        _this.ispicked = true;
        var afterPick = function afterPick(feature) {
          if (feature) {
            var attributes = feature.getProperties();
            //filter eventually null or undefined field
            _this.fields.filter(function (f) {
              return f;
            }).forEach(function (field) {
              return values[field] = attributes[field];
            });
            resolve(values);
          } else {
            reject();
          }
          _this.ispicked = false;
          _this.unpick();
        };
        _gui2.default.setModal(false);
        _this.mapService.addInteraction(_this.interaction);

        _this.interaction.once('picked', function (e) {
          if ('map' === _this.pick_type) {
            var feature = e.feature;
            afterPick(feature);
          } else if ('wms' === _this.pick_type) {
            var layer = _gui2.default.getService('map').getProjectLayer(_this.layerId);
            if (layer) {
              _data2.default.getQueryLayersPromisesByCoordinates([layer], {
                map: _this.mapService.getMap(),
                feature_count: 1,
                coordinates: e.coordinate
              }).then(function (response) {
                var _response$0$data = response[0].data,
                    data = _response$0$data === undefined ? [] : _response$0$data;

                var feature = data.length && data[0].features[0] || null;
                afterPick(feature);
              }).fail(function (e) {
                return console.warn(e);
              });
            }
          }
        });
      });
    }
  }, {
    key: 'unpick',


    /**
     *
     */
    value: function unpick() {
      this.mapService.removeInteraction(this.interaction);
      _gui2.default.setModal(true);
      this.unbindEscKeyUp();
      this.ispicked = false;
    }
  }, {
    key: 'clear',


    /**
     *
     */
    value: function clear() {
      if (this.isPicked()) {
        this.unpick();
      }
      this.mapService = this.interaction = this.field = null;
    }
  }]);

  return PickLayerService;
}();

},{"map/interactions/pickcoordinatesinteraction":184,"map/interactions/pickfeatureinteraction":185,"services/data":206,"services/gui":207}],54:[function(require,module,exports){
var _InputPickLayer = require('components/InputPickLayer.vue');

var vueComponentOptions = _interopRequireWildcard(_InputPickLayer);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var PickLayerInput = Vue.extend(vueComponentOptions);

module.exports = PickLayerInput;

},{"components/InputPickLayer.vue":106}],55:[function(require,module,exports){
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Service = require('gui/inputs/service');

module.exports = function (_Service) {
  _inherits(RadioService, _Service);

  function RadioService() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, RadioService);

    return _possibleConstructorReturn(this, (RadioService.__proto__ || Object.getPrototypeOf(RadioService)).call(this, opts));
  }

  return RadioService;
}(Service);

},{"gui/inputs/service":61}],56:[function(require,module,exports){
var _InputRadio = require('components/InputRadio.vue');

var vueComponentOptions = _interopRequireWildcard(_InputRadio);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var RadioInput = Vue.extend(vueComponentOptions);

module.exports = RadioInput;

},{"components/InputRadio.vue":107}],57:[function(require,module,exports){
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Service = require('gui/inputs/service');

module.exports = function (_Service) {
  _inherits(RangeService, _Service);

  function RangeService() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, RangeService);

    var _opts$state$input$opt = opts.state.input.options.values[0],
        min = _opts$state$input$opt.min,
        max = _opts$state$input$opt.max;

    opts.state.info = '[MIN: ' + min + ' - MAX: ' + max + ']';

    var _this = _possibleConstructorReturn(this, (RangeService.__proto__ || Object.getPrototypeOf(RangeService)).call(this, opts));

    _this.setValidator({
      validate: function validate(value) {
        value = 1 * value;
        return value >= 1 * min && value <= 1 * max;
      }
    });
    return _this;
  }

  _createClass(RangeService, [{
    key: 'isValueInRange',
    value: function isValueInRange(value, min, max) {
      return value <= max && value >= min;
    }
  }]);

  return RangeService;
}(Service);

},{"gui/inputs/service":61}],58:[function(require,module,exports){
var _InputRange = require('components/InputRange.vue');

var vueComponentOptions = _interopRequireWildcard(_InputRange);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var RangeInput = Vue.extend(vueComponentOptions);

module.exports = RangeInput;

},{"components/InputRange.vue":108}],59:[function(require,module,exports){
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _getCatalogLayerById = require('utils/getCatalogLayerById');

var _createSingleFieldParameter = require('utils/createSingleFieldParameter');

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Service = require('gui/inputs/service');

module.exports = function (_Service) {
  _inherits(SelectService, _Service);

  function SelectService() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, SelectService);

    var _this = _possibleConstructorReturn(this, (SelectService.__proto__ || Object.getPrototypeOf(SelectService)).call(this, opts));

    _this.layer = null;
    return _this;
  }

  _createClass(SelectService, [{
    key: '_getLayerById',
    value: function _getLayerById(layer_id) {
      return (0, _getCatalogLayerById.getCatalogLayerById)(layer_id);
    }
  }, {
    key: 'addValue',
    value: function addValue(value) {
      this.state.input.options.values.push(value);
    }
  }, {
    key: 'sortValues',
    value: function sortValues() {
      var orderbyvalue = this.state.input.options.orderbyvalue;

      this.state.input.options.values.sort(function (a, b) {
        var val1 = a[orderbyvalue ? 'value' : 'key'];
        var val2 = b[orderbyvalue ? 'value' : 'key'];
        if (val1 < val2) {
          return -1;
        }
        if (val1 > val2) {
          return 1;
        }
        return 0;
      });
    }
  }, {
    key: 'getKeyByValue',
    value: function getKeyByValue() {
      var _this2 = this;

      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          search = _ref.search;

      var _state$input$options = this.state.input.options,
          value = _state$input$options.value,
          key = _state$input$options.key;

      return new Promise(function (resolve, reject) {
        _this2.getData({
          key: key,
          value: value,
          search: search
        }).then(function (values) {
          values.forEach(function (_ref2) {
            var key = _ref2.$value,
                value = _ref2.text;

            _this2.addValue({
              key: key,
              value: value
            });
          });
          _this2.sortValues();
          resolve(_this2.state.input.options.values);
        }).catch(function (e) {
          console.warn(e);reject(e);
        });
      });
    }
  }, {
    key: 'getData',


    /**
     *
     * @param layer_id
     * @param key
     * @param value
     * @param search
     * @return {Promise<unknown>}
     */
    value: function getData() {
      var _this3 = this;

      var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref3$layer_id = _ref3.layer_id,
          layer_id = _ref3$layer_id === undefined ? this.state.input.options.layer_id : _ref3$layer_id,
          _ref3$key = _ref3.key,
          key = _ref3$key === undefined ? this.state.input.options.key : _ref3$key,
          _ref3$value = _ref3.value,
          value = _ref3$value === undefined ? this.state.input.options.value : _ref3$value,
          search = _ref3.search;

      return new Promise(function (resolve, reject) {
        var _this3$_layer$getData;

        if (!_this3._layer) {
          _this3._layer = _this3._getLayerById(layer_id);
        }
        _this3._layer.getDataTable((_this3$_layer$getData = {}, _defineProperty(_this3$_layer$getData, Array.isArray(search) ? 'field' : 'suggest', Array.isArray(search) //take in account multiselect value
        ? search.map(function (_, j) {
          return (0, _createSingleFieldParameter.createSingleFieldParameter)({ field: key, value: search[j], operator: "eq", logicop: null });
        }).join('|OR,') || '' : (key + '|' + search).trim()), _defineProperty(_this3$_layer$getData, 'ordering', _this3.state.input.options.orderbyvalue ? value : key), _this3$_layer$getData)).then(function (response) {
          var values = response.features.map(function (f) {
            return {
              text: f.properties[key],
              id: f.properties[value],
              $value: f.properties[value]
            };
          });
          resolve(values);
        }).fail(function (e) {
          console.warn(e);reject(e);
        });
      });
    }
  }]);

  return SelectService;
}(Service);

},{"gui/inputs/service":61,"utils/createSingleFieldParameter":230,"utils/getCatalogLayerById":238}],60:[function(require,module,exports){
var _InputSelect = require('components/InputSelect.vue');

var vueComponentOptions = _interopRequireWildcard(_InputSelect);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var SelectInput = Vue.extend(vueComponentOptions);

module.exports = SelectInput;

},{"components/InputSelect.vue":109}],61:[function(require,module,exports){
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _toRawType = require('utils/toRawType');

var _g3wI18n = require('g3w-i18n');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Validators = {

  validators: {
    float: function float() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      this.options = options;
      this.validate = function (value) {
        return !Number.isNaN(Number(1 * value));
      };
    },


    /**
     * @since v3.10.0
     * @param options
     */
    bigint: function bigint() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      this.options = options;
      this.validate = function (value) {
        value = 1 * value;
        return !Number.isNaN(value) ? value <= Number.MAX_SAFE_INTEGER : false;
      };
    },
    integer: function integer() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      this.options = options;
      this.validate = function (value) {
        var integer = 1 * value;
        return !Number.isNaN(integer) ? Number.isSafeInteger(integer) && integer <= 2147483647 : false;
      };
    },
    checkbox: function checkbox() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      this.options = options;
      this.validate = function (value) {
        return (this.options.values || []).includes(value);
      };
    },
    datetimepicker: function datetimepicker() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      this.options = options;
      this.validate = function (value, options) {
        return moment(value, options.fielddatetimeformat, true).isValid();
      };
    },


    /**
     * @since 3.10.0
     * @param options
     */
    char: function char(options) {
      this.options = options;
      this.validate = function (value) {
        return value && 1 === ('' + value).length;
      };
    },


    /**
     * @since 3.10.0
     * @param options
     */
    varchar: function varchar() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      this.options = options;
      this.validate = function () {
        return true;
      };
    },
    text: function text() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      this.options = options;
      this.validate = function () {
        return true;
      };
    },
    string: function string() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      this.options = options;
      this.validate = function () {
        return true;
      };
    },
    radio: function radio() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      this.options = options;
      this.validate = function () {
        return true;
      };
    },
    default: function _default() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      this.options = options;
      this.validate = function () {
        return true;
      };
    },
    range: function range() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var min = options.min,
          max = options.max;

      this.validate = function (value) {
        value = 1 * value;
        return value >= min && value <= max;
      };
    }
  },

  get: function get(type) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    return new (this.validators[type] || this.validators.default)(options);
  }
};

module.exports = function () {
  function Service() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, Service);

    // set state of input
    this.state = options.state || {};
    // type of input
    //this.state.validate.required && this.setValue(this.state.value);
    /*
    * set starting value of input based on value or default value on options
     */
    this.setValue(this.state.value);
    this.setEmpty(this.state.value);
    var type = this.state.type;
    var validatorOptions = options.validatorOptions || this.state.input.options || {};
    // useful for the validator to validate input
    this._validator = Validators.get(type, validatorOptions);
    this.setErrorMessage();
  }

  _createClass(Service, [{
    key: 'getState',
    value: function getState() {
      return this.state;
    }
  }, {
    key: 'getValue',
    value: function getValue() {
      return this.state.value;
    }
  }, {
    key: 'setValue',


    /**
     * @param value
     *
     * @returns {void}
     */
    value: function setValue(value) {
      if (![null, undefined].includes(value)) {
        return;
      }

      var options = this.state.input.options;

      var default_value = options.default;

      /** @TODO (maybe need to removed in v3.9.0) double check G3W-ADMIN server configuration. */
      if (Array.isArray(options)) {
        if (options[0].default) {
          default_value = options[0].default;
        } else if (Array.isArray(options.values) && options.values.length > 0) {
          default_value = options.values[0] && (options.values[0].value || options.values[0]);
        }
      }

      // check if the default value is set
      var get_default_value = this.state.get_default_value && // ref: core/layers/tablelayer.js::getFieldsWithValues()
      undefined !== default_value && null !== default_value;

      // check if we can state.check get_default_value from input.options.default is set
      if (get_default_value && undefined === options.default_expression) {
        this.state.value = default_value;
      }

      this.state.value_from_default_value = get_default_value;
    }
  }, {
    key: 'addValueToValues',
    value: function addValueToValues(value) {
      this.state.input.options.values.unshift(value);
    }
  }, {
    key: '_getValidatorType',
    value: function _getValidatorType() {
      return this.state.type;
    }
  }, {
    key: 'setState',
    value: function setState() {
      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      this.state = 'Object' === (0, _toRawType.toRawType)(state) ? state : {};
    }
  }, {
    key: 'getValidator',


    // return validator
    value: function getValidator() {
      return this._validator;
    }
  }, {
    key: 'setValidator',
    value: function setValidator(validator) {
      this._validator = validator;
    }
  }, {
    key: 'setEmpty',


    /**
     * set input empty '', null, undefined or []
     */
    value: function setEmpty() {
      this.state.validate.empty = null === this.state.value //value is null
      || !(Array.isArray(this.state.value) && this.state.value.length > 0 || //or empty array
      !_.isEmpty(('' + this.state.value).trim())) // or empty string
      ;
    }
  }, {
    key: 'validate',


    // the general method to check the value of the state is valid or not
    value: function validate() {
      if (this.state.validate.empty) {
        this.state.value = null; //force to null
        // check if you require or check validation
        this.state.validate.valid = !this.state.validate.required;
      } else {
        if (['integer', 'float', 'bigint'].includes(this.state.input.type)) {
          if (+this.state.value < 0) {
            this.state.value = null;
            this.state.validate.empty = true;
            this.state.validate.valid = !this.state.validate.required;
          } else {
            this.state.validate.valid = this._validator.validate(this.state.value);
          }
        }
        //check exclude_values state.validate.unique (QGIS field property [x] Enforce unique constraint)
        if (this.state.validate.unique && this.state.validate.exclude_values && this.state.validate.exclude_values.size) {
          //need to convert this.state.value to string because editing store exclude_values items as string
          this.state.validate.valid = !this.state.validate.exclude_values.has('' + this.state.value);
        } else {
          this.state.validate.valid = this._validator.validate(this.state.value);
        }
      }

      return this.state.validate.valid;
    }
  }, {
    key: 'setErrorMessage',
    value: function setErrorMessage() {
      //in vase of
      if (this.state.validate.error) {
        this.state.validate.message = (0, _g3wI18n.t)(this.state.validate.error);
        return;
      }
      var message = void 0;
      if (this.state.validate.mutually && !this.state.validate.mutually_valid) {
        this.state.validate.message = (0, _g3wI18n.t)("sdk.form.inputs.input_validation_mutually_exclusive") + ' ( ' + this.state.validate.mutually.join(',') + ' )';
      } else if (this.state.validate.max_field) {
        this.state.validate.message = (0, _g3wI18n.t)("sdk.form.inputs.input_validation_max_field") + ' (' + this.state.validate.max_field + ')';
      } else if (this.state.validate.min_field) {
        this.state.validate.message = (0, _g3wI18n.t)("sdk.form.inputs.input_validation_min_field") + ' (' + this.state.validate.min_field + ')';
      } else if (('unique' === this.state.input.type || this.state.validate.unique) && this.state.validate.exclude_values && this.state.validate.exclude_values.size) {
        this.state.validate.message = '' + (0, _g3wI18n.t)("sdk.form.inputs.input_validation_exclude_values");
      } else if (this.state.validate.required) {
        message = (0, _g3wI18n.t)("sdk.form.inputs.input_validation_error") + ' ( ' + (0, _g3wI18n.t)("sdk.form.inputs." + this.state.type) + ' )';
        if (this.state.info) {
          message = message + '\n                 <div>\n                  <b>' + this.state.info + '</b>\n                 </div>         \n      ';
        }
        this.state.validate.message = this.state.info || message;
      } else {
        //@since 3.11.0
        // in case of state.validate.valid false and not required need to show a right message (info or type)
        this.state.validate.message = this.state.info || (0, _g3wI18n.t)("sdk.form.inputs.input_validation_error_type") + ' ( ' + (0, _g3wI18n.t)("sdk.form.inputs." + this.state.type) + ' )';
      }
    }
  }, {
    key: 'setUpdate',

    /**
     * Method to set update
     */
    value: function setUpdate() {
      var _state = this.state,
          value = _state.value,
          _value = _state._value;

      if ('media' === this.state.input.type && 'Object' !== (0, _toRawType.toRawType)(value) && 'Object' !== (0, _toRawType.toRawType)(_value)) {
        this.state.update = value.value != _value.value;
      } else if ("datetimepicker" === this.state.input.type) {
        //check
        this.state.update = (null !== value ? value.toUpperCase() : value) != (_value ? _value.toUpperCase() : _value);
      } else {
        this.state.update = value != _value;
      }
    }
  }]);

  return Service;
}();

},{"g3w-i18n":162,"utils/toRawType":277}],62:[function(require,module,exports){
var InputsServices = {
  'text': require('./service'),
  'textarea': require('./service'),
  'texthtml': require('./service'),
  'integer': require('./integer/service'),
  'string': require('./service'),
  'float': require('./float/service'),
  'radio': require('./radio/service'),
  'check': require('./checkbox/service'),
  'range': require('./range/service'),
  'datetimepicker': require('./datetimepicker/service'),
  'unique': require('./unique/service'),
  'select': require('./select/service'),
  'media': require('./media/service'),
  'select_autocomplete': require('./select/service'),
  'picklayer': require('./service'),
  'color': require('./service'),
  'slider': require('./sliderrange/service'),
  'lonlat': require('./lonlat/service')
};

module.exports = InputsServices;

},{"./checkbox/service":39,"./datetimepicker/service":42,"./float/service":44,"./integer/service":47,"./lonlat/service":49,"./media/service":51,"./radio/service":55,"./range/service":57,"./select/service":59,"./service":61,"./sliderrange/service":63,"./unique/service":68}],63:[function(require,module,exports){
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Service = require('gui/inputs/service');

var SliderRangeService = function (_Service) {
  _inherits(SliderRangeService, _Service);

  function SliderRangeService() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, SliderRangeService);

    var state = opts.state;

    opts.state.info = '[MIN: ' + state.input.options.min + ' - MAX: ' + state.input.options.max + ']';

    var _this = _possibleConstructorReturn(this, (SliderRangeService.__proto__ || Object.getPrototypeOf(SliderRangeService)).call(this, opts));

    _this.setValidator({
      validate: function validate(value) {
        value = 1 * value;
        return value >= 1 * opts.state.input.options.min && value <= 1 * opts.state.input.options.max;
      }
    });
    return _this;
  }

  _createClass(SliderRangeService, [{
    key: 'validate',
    value: function validate() {
      this.state.value = 1 * this.state.value;
      this.state.validate.valid = this.state.value >= this.state.input.options.min || this.state.value <= this.state.input.options.max;
    }
  }, {
    key: 'changeInfoMessage',
    value: function changeInfoMessage() {
      this.state.info = '[MIN: ' + this.state.input.options.min + ' - MAX: ' + this.state.input.options.max + ']';
    }
  }]);

  return SliderRangeService;
}(Service);

module.exports = SliderRangeService;

},{"gui/inputs/service":61}],64:[function(require,module,exports){
var _InputSliderRange = require('components/InputSliderRange.vue');

var vueComponentOptions = _interopRequireWildcard(_InputSliderRange);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var RangeInput = Vue.extend(vueComponentOptions);

module.exports = RangeInput;

},{"components/InputSliderRange.vue":110}],65:[function(require,module,exports){
var _InputText = require('components/InputText.vue');

var vueComponentOptions = _interopRequireWildcard(_InputText);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var TextInput = Vue.extend(vueComponentOptions);

module.exports = TextInput;

},{"components/InputText.vue":111}],66:[function(require,module,exports){
var _InputTextArea = require('components/InputTextArea.vue');

var vueComponentOptions = _interopRequireWildcard(_InputTextArea);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var TextAreaInput = Vue.extend(vueComponentOptions);

module.exports = TextAreaInput;

},{"components/InputTextArea.vue":112}],67:[function(require,module,exports){
var _InputTextHtml = require('components/InputTextHtml.vue');

var vueComponentOptions = _interopRequireWildcard(_InputTextHtml);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var TextHtmlInput = Vue.extend(vueComponentOptions);

module.exports = TextHtmlInput;

},{"components/InputTextHtml.vue":113}],68:[function(require,module,exports){
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Service = require('gui/inputs/service');
module.exports = function (_Service) {
  _inherits(UniqueService, _Service);

  function UniqueService() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, UniqueService);

    return _possibleConstructorReturn(this, (UniqueService.__proto__ || Object.getPrototypeOf(UniqueService)).call(this, opts));
  }

  return UniqueService;
}(Service);

},{"gui/inputs/service":61}],69:[function(require,module,exports){
var _InputUnique = require('components/InputUnique.vue');

var vueComponentOptions = _interopRequireWildcard(_InputUnique);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var UniqueInput = Vue.extend(vueComponentOptions);

module.exports = UniqueInput;

},{"components/InputUnique.vue":114}],70:[function(require,module,exports){
var __vueify_style_dispose__ = require("vueify/lib/insert-css").insert("@keyframes sk-bounce{0%,to{transform:scale(0)}50%{transform:scale(1)}}#startingspinner{position:fixed;z-index:100000;height:10em;width:10em;overflow:show;margin:auto;inset:0}#startingspinner .double-bounce1,#startingspinner .double-bounce2{width:100%;height:100%;border-radius:50%;background-color:var(--skin-color);opacity:.6;position:absolute;top:0;left:0;animation:sk-bounce 2s infinite ease-in-out}#startingspinner .double-bounce2{animation-delay:-1s}.g3w-modal-project-message.Info .modal-header{background-color:#0073b7}.g3w-modal-project-message.Warning .modal-header{background-color:#e99611}.g3w-modal-project-message.Error .modal-header{background-color:#dd4b39}.g3w-modal-project-message.Critical .modal-header{background-color:#605ca8}.g3w-modal-project-message h4.modal-title{color:#fff!important}.nav-lang .select2-container--default .select2-selection--single{background:none;border:none}.nav-lang .select2-container--default .select2-selection--single .select2-selection__arrow b{border-color:#fff transparent transparent}.nav-lang .select2-container--default.select2-container--open .select2-selection--single .select2-selection__arrow b{border-color:transparent transparent #fff}.nav-lang .select2-container--default .select2-selection--single .select2-selection__rendered{color:#fff!important}@media (min-width:768px){.nav-lang .select2-container{right:0;left:auto!important}}\n.project_title[data-v-7718180d]{display:inline-flex;flex-direction:column;justify-content:center;height:100%;font-weight:700;color:#fff;max-height:50px;overflow:hidden;max-width:calc(100% - 150px)}.project_title>[data-v-7718180d]{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;font-weight:700;margin:0}.project_title .h2[data-v-7718180d]{font-size:1.6em}.project_title h1[data-v-7718180d]{font-size:1.3em}#g3w-sidebarpanel-header-placeholder[data-v-7718180d]{overflow:hidden;line-height:14px;font-size:1.5em;min-height:35px;border-bottom:1px solid #fff;margin-bottom:5px}#disable-sidebar[data-v-7718180d]{display:none;position:absolute;background-color:rgba(0,0,0,.3);height:100%;width:100%;z-index:10}.content_breadcrumb[data-v-7718180d]{font-size:1.2em;padding:0 3px;border-radius:3px}.close-panel-block[data-v-7718180d]{overflow:hidden;margin-top:2px;margin-bottom:2px;font-size:1.4em}.g3w_contents_back[data-v-7718180d]{font-size:.8em}.g3w_contents_back [data-v-7718180d]:is(.backto,.back){display:inline-block;font-weight:700}.g3w_contents_back .backto[data-v-7718180d]{margin-top:5px;cursor:pointer}.user-header[data-v-7718180d]{padding:10px;text-align:center;border-bottom:1px solid rgba(0,0,0,.3)}.user-footer[data-v-7718180d]{padding:8px;display:flex;justify-content:space-between;flex-direction:column;gap:8px}.user-footer .btn-default[data-v-7718180d]{color:rgba(0,0,0,.75);border-color:currentColor;display:flex;flex-direction:row-reverse;justify-content:left;align-items:center;gap:8px}.user-footer .btn-default[data-v-7718180d]:not(:hover){background-color:transparent}.nav-user>.dropdown-menu[data-v-7718180d]{padding:1px 0 0;border:1px solid #aaa;border-top-width:0;border-radius:0;margin-top:0}.nav-user .triangle[data-v-7718180d]{border-color:#fff transparent transparent;border-style:solid;border-width:5px 4px 0;display:inline-block;margin:3px}.nav-user.open .triangle[data-v-7718180d]{border-color:transparent transparent #fff;border-width:0 4px 5px}#menu-toggler[data-v-7718180d]{display:none}.navbar-toggler[data-v-7718180d]{color:#fff;margin:12px;font-size:1.3em;position:absolute;z-index:101;right:0}@media (min-width:767px){.user-footer :is(.nav-sidebar,.nav-addlayer).btn-default[data-v-7718180d]{display:none}}@media (max-width:767px){.navbar-toggler[data-v-7718180d]{display:block;cursor:pointer;user-select:none}#menu-toggler:checked~hgroup[data-v-7718180d]{position:fixed;top:0;background:var(--skin-color);padding-left:8px}#menu-toggler:checked~ul[data-v-7718180d]{position:fixed;inset:50px 0 0 0;background:var(--skin-color);z-index:100;flex-direction:column;border-top:1px solid #fff}#menu-toggler:not(:checked)~[data-v-7718180d]:not(.navbar-toggler),.nav-user>.dropdown-toggle[data-v-7718180d],.user-header[data-v-7718180d]{display:none!important}.navbar-nav[data-v-7718180d]{flex-direction:column}.user-footer .btn-default[data-v-7718180d]{padding:10px}.nav-user>ul[data-v-7718180d],.user-footer[data-v-7718180d]{background-color:transparent;border:none}.nav-user>ul[data-v-7718180d]{display:block;position:static;float:none}.nav-user .btn[data-v-7718180d]{color:#fff!important}.nav-user>.dropdown-menu[data-v-7718180d]{border:none}}")
;(function(){
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _vueCookieLaw = require('vue-cookie-law');

var _vueCookieLaw2 = _interopRequireDefault(_vueCookieLaw);

var _vue2Teleport = require('vue2-teleport');

var _vue2Teleport2 = _interopRequireDefault(_vue2Teleport);

var _g3wConstants = require('g3w-constants');

var _application = require('store/application');

var _application2 = _interopRequireDefault(_application);

var _g3wPanel = require('g3w-panel');

var _g3wPanel2 = _interopRequireDefault(_g3wPanel);

var _g3wComponent = require('g3w-component');

var _g3wComponent2 = _interopRequireDefault(_g3wComponent);

var _gui = require('services/gui');

var _gui2 = _interopRequireDefault(_gui);

var _getUniqueDomId = require('utils/getUniqueDomId');

var _promisify = require('utils/promisify');

var _sameOrigin = require('utils/sameOrigin');

var _UserMessage = require('components/UserMessage.vue');

var _UserMessage2 = _interopRequireDefault(_UserMessage);

var _CatalogContextMenu = require('components/CatalogContextMenu.vue');

var _CatalogContextMenu2 = _interopRequireDefault(_CatalogContextMenu);

var _ModalLogin = require('components/ModalLogin.vue');

var _ModalLogin2 = _interopRequireDefault(_ModalLogin);

var _ModalAddLayer = require('components/ModalAddLayer.vue');

var _ModalAddLayer2 = _interopRequireDefault(_ModalAddLayer);

var _ModalChangeMap = require('components/ModalChangeMap.vue');

var _ModalChangeMap2 = _interopRequireDefault(_ModalChangeMap);

var _ModalMetadata = require('components/ModalMetadata.vue');

var _ModalMetadata2 = _interopRequireDefault(_ModalMetadata);

var _g3wI18n = require('g3w-i18n');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

exports.default = {
  name: 'app',

  data: function data() {
    var custom_links = (window.initConfig.header_custom_links || []).concat(_application2.default.navbaritems).filter(Boolean);

    custom_links.unshift({
      id: 'credits',
      type: 'metadata',
      target: '#metadata_credits',
      icon: 'far fa-question-circle',
      title: 'Credits'
    });

    custom_links.forEach(function (l) {
      return !l.id && (l.id = (0, _getUniqueDomId.getUniqueDomId)());
    });

    return {
      language: null,
      cookie_law_buttonText: (0, _g3wI18n.t)('cookie_law.buttonText'),
      app: _application2.default,
      state: _application2.default.viewport,
      updatePreviousTitle: false,
      header: (0, _g3wI18n.t)('main navigation'),
      custom_links: custom_links
    };
  },


  components: {
    CookieLaw: _vueCookieLaw2.default,
    userMessage: _UserMessage2.default,
    CatalogContextMenu: _CatalogContextMenu2.default,
    ModalLogin: _ModalLogin2.default,
    ModalAddlayer: _ModalAddLayer2.default,
    ModalChangemap: _ModalChangeMap2.default,
    ModalMetadata: _ModalMetadata2.default,
    Teleport: _vue2Teleport2.default
  },

  computed: {
    languages: function languages() {
      var languages = Array.isArray(this.appconfig.i18n) && this.appconfig.i18n || [];
      return languages.length > 1 && languages;
    },
    dropdownParent: function dropdownParent() {
      return window.innerWidth >= 768;
    },
    appconfig: function appconfig() {
      return window.initConfig;
    },
    isIframe: function isIframe() {
      return window.top !== window.self;
    },
    urls: function urls() {
      return this.appconfig.urls;
    },
    logo_url: function logo_url() {
      return _application2.default.project.state.thumbnail || '' + this.appconfig.mediaurl + window.initConfig.header_logo_img;
    },
    project_title: function project_title() {
      return _application2.default.project.getState().name;
    },
    user: function user() {
      return this.appconfig.user && this.appconfig.user.username ? this.appconfig.user : null;
    },
    login_url: function login_url() {
      return this.appconfig.user.login_url;
    },
    has_iframe_login: function has_iframe_login() {
      return this.login_url && ('/' === this.login_url[0] || (0, _sameOrigin.sameOrigin)(this.login_url, window.location.href));
    },
    hasRelatedMaps: function hasRelatedMaps() {
      return this.appconfig.macrogroups.length + this.appconfig.groups.length + this.appconfig.projects.length > 1;
    },
    main_title: function main_title() {
      var main_title = this.appconfig.main_map_title;
      var group_name = this.appconfig.title || this.appconfig.slug;
      return main_title ? main_title + ' - ' + group_name : group_name;
    },
    breadcrumb: function breadcrumb() {
      return this.state.content.contentsdata.filter(function (c) {
        return c.options.crumb;
      }).map(function (c) {
        return c.options.crumb;
      });
    },
    showresize: function showresize() {
      var layout = _application2.default.gui.layout[_application2.default.gui.layout.__current].rightpanel;
      var currentPerc = layout[this.state.split === 'h' ? 'width' : 'height'];
      return this.state.secondaryPerc > 0 && this.state.secondaryPerc < 100 && currentPerc < 100 && currentPerc > 0;
    },
    showresizeicon: function showresizeicon() {
      return 100 !== this.state.secondaryPerc;
    },
    usermessage: function usermessage() {
      return this.state.usermessage;
    },
    showtitle: function showtitle() {
      if (this.state.content.contentsdata.length > 0) {
        var options = this.state.content.contentsdata[this.state.content.contentsdata.length - 1].options;
        if ([true, false].includes(options.showtitle)) {
          return options.showtitle;
        }
      }
      return true;
    },
    styles: function styles() {
      return {
        map: {
          width: this.state.map.sizes.width + 'px',
          height: this.state.map.sizes.height + 'px'
        },
        content: {
          width: this.state.content.sizes.width + 'px',
          height: this.state.content.sizes.height + 'px',
          zIndex: 1,
          minHeight: 'v' === this.state.split ? _g3wConstants.VIEWPORT.resize.content.min + 'px' : null,
          paddingTop: '8px',
          paddingBottom: '8px'
        }
      };
    },
    contentTitle: function contentTitle() {
      if (this.state.content.contentsdata.length) {
        var _state$content$conten = this.state.content.contentsdata[this.state.content.contentsdata.length - 1].options,
            title = _state$content$conten.title,
            post_title = _state$content$conten.post_title,
            _state$content$conten2 = _state$content$conten.text,
            text = _state$content$conten2 === undefined ? false : _state$content$conten2;

        return { title: title, post_title: post_title, text: text };
      }
    },
    backOrBackTo: function backOrBackTo() {
      return this.state.content.contentsdata.length > 1 && this.state.content.showgoback ? !this.state.content.contentsdata[this.state.content.contentsdata.length - 2].options.title ? 'back' : 'backto' : false;
    },
    previousTitle: function previousTitle() {
      var _this = this;

      var title = this.state.content.contentsdata.length > 1 && this.state.content.showgoback ? this.state.content.contentsdata[this.state.content.contentsdata.length - 2].options.title : null;
      this.updatePreviousTitle = true;
      this.$nextTick(function () {
        return _this.updatePreviousTitle = false;
      });
      return title;
    },
    title: function title() {
      return _application2.default.sidebar.title;
    },
    disabled: function disabled() {
      return _application2.default.gui.sidebar.disabled;
    },
    panels: function panels() {
      return _application2.default.sidebar.contentsdata;
    },
    showmainpanel: function showmainpanel() {
      return _application2.default.sidebar.components.length > 0 && !this.panels.length;
    },
    componentname: function componentname() {
      return _application2.default.sidebar.components.length ? _application2.default.sidebar.components.slice(-1)[0].getTitle() : '';
    },
    panelname: function panelname() {
      return this.panels.length ? this.panels.slice(-1)[0].content.getTitle() : '';
    }
  },

  methods: {
    templateResultLanguages: function templateResultLanguages(state) {
      if (!state.id) {
        return state.text;
      }
      return $('\n        <div style="font-weight: bold; display:flex; align-items: center; justify-content: space-around;">\n          <img src="' + this.urls.staticurl + 'img/flags/' + state.element.value.toLowerCase() + '.png" />\n          <span style="margin-left: 5px;">' + state.text + '</span> \n        </span>');
    },
    oncCustomItemClick: function oncCustomItemClick(e, item) {
      if (!['modal', 'metadata'].includes(item.type)) {
        return;
      }
      e.preventDefault();
      if (item.target && 'modal' === item.type && document.querySelector(item.target)) {
        return $(item.target).modal('show');
      }
      if (item.target && 'metadata' === item.type && document.querySelector('#modal-metadata')) {
        $('#modal-metadata').modal('show');
        document.querySelector('#modal-metadata a[href="' + item.target + '"]').click();
        return;
      }
      $('body').append('\n        <div id = "custom_modal" class = "modal fade" tabindex="-1">\n          <div class = "modal-dialog">\n            <div class  = "modal-content">' + item.content + '</div>\n          </div>\n        </div>\n      ');
      $('#custom_modal').modal('show');
      $('#custom_modal').on('hidden.bs.modal', function () {
        return $('#custom_modal').remove();
      });
    },
    showEmbedModal: function showEmbedModal() {
      var url = new URL(location.href);
      url.searchParams.set('map_extent', _gui2.default.getService('map').getMapExtent().toString());

      $('body').append('\n        <div id = "share_modal" class = "modal fade" tabindex="-1">\n          <div class = "modal-dialog">\n            <div class  = "modal-content">\n              <div class = "modal-header">\n                <h4 style = "font-weight: bold" class = "modal-title">' + this.$t('sdk.mapcontrols.query.actions.copy_zoom_to_fid_url.hint') + '</h4>\n              </div>\n              <div class="form-group modal-body">\n                <input readonly value="' + url.toString() + '" onfocus="event.target.select()" class="form-control" />\n                <button onclick="event.target.previousElementSibling.focus() || document.execCommand(\'copy\') && $(\'#share_modal\').modal(\'hide\')" class="form-control btn btn-success">' + this.$t('sdk.tooltips.copy_map_extent_url') + '</button>\n              </div>\n          </div>\n        </div>\n      ');
      $('#share_modal').modal('show');
      $('#share_modal').on('hidden.bs.modal', function () {
        return $('#share_modal').remove();
      });
    },
    initDialogMessages: function () {
      var _ref = _asyncToGenerator(function* () {
        var messages = _application2.default.project.state.messages;

        if (!messages) {
          return;
        }

        var pid = _application2.default.project.getId();

        var _loop = function* _loop(i) {
          var message = messages.items[i];
          var item = window.localStorage.getItem(_g3wConstants.LOCAL_ITEM_IDS.MESSAGES.id);
          var data = (item ? JSON.parse(item) : undefined) || _g3wConstants.LOCAL_ITEM_IDS.MESSAGES.value;
          data[pid] = data[pid] || [];

          if (undefined !== data[pid].find(function (id) {
            return id === message.id;
          })) {
            return 'continue';
          }

          var doNotShowAgainVueComponent = new (Vue.extend({
            data: function data() {
              return { id: (0, _getUniqueDomId.getUniqueDomId)(), checked: false };
            },
            template: '\n            <div style="display: flex; margin-top: 10px;">\n              <input :id="id"  v-model="checked" class="magic-checkbox" type="checkbox" />\n              <label :for="id" v-t="\'dont_show_again\'"/>\n            </div>'
          }))();

          var content = document.createElement('div');

          content.append.apply(content, _toConsumableArray(new DOMParser().parseFromString(message.body, 'text/html').body.childNodes));

          content.append(doNotShowAgainVueComponent.$mount().$el);

          yield new Promise(function (resolve) {
            _gui2.default.showModalDialog({
              title: message.title,
              message: content,
              size: 'large',
              closeButton: false,
              className: 'g3w-modal-project-message ' + Object.entries(messages.levels).find(function (_ref2) {
                var _ref3 = _slicedToArray(_ref2, 2),
                    key = _ref3[0],
                    value = _ref3[1];

                return value === message.level;
              })[0],
              buttons: {
                close: {
                  label: (0, _g3wI18n.t)('close'),
                  className: 'btn-secondary',
                  callback: function callback() {
                    try {
                      if (doNotShowAgainVueComponent.checked) {
                        data[pid].push(message.id);
                        window.localStorage.setItem(_g3wConstants.LOCAL_ITEM_IDS.MESSAGES.id, JSON.stringify(data));
                      }
                    } catch (e) {
                      console.warn(e);
                    }
                    resolve();
                  }
                }
              }
            });
          });
        };

        for (var i = 0; i < messages.items.length; i++) {
          var _ret = yield* _loop(i);

          if (_ret === 'continue') continue;
        }
      });

      function initDialogMessages() {
        return _ref.apply(this, arguments);
      }

      return initDialogMessages;
    }(),
    showaddLayerModal: function showaddLayerModal() {
      if (this.$refs['menu-toggler']) {
        this.$refs['menu-toggler'].checked = false;
      }
      $('#modal-addlayer').modal('show');
    },
    openChangeMapMenu: function openChangeMapMenu() {
      if (this.$refs['menu-toggler']) {
        this.$refs['menu-toggler'].checked = false;
      }
      $('#modal-changemap').modal('show');
    },
    isNotLastCrumb: function isNotLastCrumb(index) {
      return index < this.breadcrumb.length - 1;
    },
    closeContent: function closeContent() {
      _gui2.default.closeContent();
    },
    gotoPreviousContent: function gotoPreviousContent() {
      _gui2.default.popContent();
    },
    closeUserMessage: function closeUserMessage() {
      _gui2.default.closeUserMessage();
    },
    wrapMoveFnc: function wrapMoveFnc(e) {
      this.moveFnc(e);
    },
    resizeStart: function resizeStart() {
      document.addEventListener('mousemove', this.wrapMoveFnc);
      document.addEventListener('mouseup', this.resizeStop, { once: true });
    },
    resizeStop: function () {
      var _ref4 = _asyncToGenerator(function* () {
        document.removeEventListener('mousemove', this.wrapMoveFnc);
        yield this.$nextTick();
        _gui2.default.emit('resize');
      });

      function resizeStop() {
        return _ref4.apply(this, arguments);
      }

      return resizeStop;
    }(),
    resizeFull: function resizeFull() {
      _gui2.default.toggleFullViewContent();
      _gui2.default.emit('resize');
    },
    moveFnc: function moveFnc(e) {
      e.preventDefault();
      var size = 'h' === this.state.split ? 'width' : 'height';
      var sidebarSize = size === 'width' ? $('.sidebar-collapse').length ? 0 : _application2.default.viewport.SIDEBARWIDTH : $('.navbar').height();
      var viewPortSize = $(this.$el)[size]();
      var mapSize = ('width' === size ? e.pageX + 2 : e.pageY + 2) - sidebarSize;
      var _VIEWPORT$resize = _g3wConstants.VIEWPORT.resize,
          content = _VIEWPORT$resize.content,
          map = _VIEWPORT$resize.map;

      if (mapSize > viewPortSize - content.min) {
        mapSize = viewPortSize - content.min;
      } else if (mapSize < map.min) {
        mapSize = map.min;
      }
      _application2.default.viewport.resized[this.state.split] = true;
      _application2.default.gui.layout[_application2.default.gui.layout.__current].rightpanel['h' === this.state.split ? 'width' : 'height'] = 100 - Math.round(mapSize / viewPortSize * 100);
      _gui2.default._layout('resize');
    },
    closePanel: function closePanel() {
      _gui2.default.closePanel();
    },
    closeAllPanels: function () {
      var _ref5 = _asyncToGenerator(function* () {
        _application2.default.sidebar.title = null;
        var data = _application2.default.sidebar.contentsdata;
        if (data.length) {
          yield Promise.allSettled(data.map(function () {
            var _ref6 = _asyncToGenerator(function* (d) {
              if (d.content instanceof _g3wComponent2.default || d.content instanceof _g3wPanel2.default) {
                yield (0, _promisify.promisify)(d.content.unmount());
              } else {
                $(_application2.default.sidebar.parent).empty();
              }
            });

            return function (_x) {
              return _ref6.apply(this, arguments);
            };
          }()));
          data.splice(0, data.length);
        }
      });

      function closeAllPanels() {
        return _ref5.apply(this, arguments);
      }

      return closeAllPanels;
    }(),
    toggleSidebar: function toggleSidebar() {
      if (this.$refs['menu-toggler']) {
        this.$refs['menu-toggler'].checked = false;
      }
      _gui2.default.toggleSidebar();
    },
    toggleSidebarItem: function toggleSidebarItem(e) {
      var mini = document.body.classList.contains('sidebar-mini');
      var collapsed = document.body.classList.contains('sidebar-collapse');

      if (mini && collapsed) {
        _gui2.default.showSidebar();
      }

      var li = e.target.closest('.sidebaritem');
      var component = _application2.default.sidebar.components.find(function (comp) {
        return comp.id === li.id;
      });
      var open = component && component.getOpen();
      var menu = li.querySelector('.treeview-menu');

      if (!component || open && collapsed || menu && menu.contains(e.target)) {
        return;
      }

      if (!component.collapsible && window.innerWidth <= 767) {
        _gui2.default.toggleSidebar();
      }

      component.click({ open: !open });
    }
  },

  watch: {
    'language': function language(_language, cl) {
      if (cl) {
        i18next.changeLanguage(_language);

        _application2.default.lng = _language;
        _application2.default.language = _language;
        var pathArray = window.location.pathname.split('/');
        pathArray[1] = _language;
        history.replaceState(null, null, pathArray.join('/'));
        this.cookie_law_buttonText = (0, _g3wI18n.t)('cookie_law.buttonText');
      }
    }
  },

  created: function created() {
    this.language = this.appconfig.user.i18n;
  },
  mounted: function () {
    var _ref7 = _asyncToGenerator(function* () {
      this.initDialogMessages();

      yield this.$nextTick();

      this.language = this.appconfig.user.i18n;

      yield this.$nextTick();

      $('#startingspinner').remove();

      var resize = function resize() {
        $(".main-sidebar").css('height', $(window).height() - $(".navbar").height());
        $('.g3w-sidebarpanel').css('height', $(window).height() - $(".navbar").height());
      };

      resize();
      $(window, ".wrapper").resize(resize);

      this.iframe = _application2.default.iframe;

      if (!this.iframe) {
        document.body.classList.add('sidebar-mini');
      }

      document.body.classList.toggle('is-mobile', this.isMobile());
      document.body.classList.toggle('is-iframe', this.iframe);
    });

    function mounted() {
      return _ref7.apply(this, arguments);
    }

    return mounted;
  }()
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"disabled",rawName:"v-disabled",value:(_vm.app.gui.app.disabled),expression:"app.gui.app.disabled"}],staticClass:"wrapper",attrs:{"id":"app"}},[(!_vm.isIframe)?_c('nav',{ref:"navbar",staticClass:"navbar no-print",staticStyle:{"display":"flex","justify-content":"start","height":"50px"},attrs:{"role":"navigation"}},[(_vm.logo_url)?_c('a',{staticStyle:{"padding":"4px","display":"inline-block","height":"50px"},attrs:{"href":_vm.appconfig.header_logo_link || _vm.urls.frontendurl || '#',"target":_vm.appconfig.header_logo_link ? '_blank' : ''}},[_c('img',{staticStyle:{"height":"100%"},attrs:{"alt":"","src":_vm.logo_url}})]):_vm._e(),_vm._v(" "),_c('input',{ref:"menu-toggler",attrs:{"id":"menu-toggler","type":"checkbox","autocomplete":"off","hidden":""}}),_vm._v(" "),_c('label',{staticClass:"navbar-toggler",attrs:{"for":"menu-toggler","hidden":""}},[_c('i',{class:_vm.$fa('bars')}),_c('span',{staticStyle:{"margin-left":"8px"}},[_vm._v("MENU")])]),_vm._v(" "),_c('hgroup',{staticClass:"project_title"},[_c('p',{staticClass:"h2"},[_vm._v(_vm._s(_vm.main_title))]),_vm._v(" "),_c('h1',[_vm._v(_vm._s(_vm.project_title))])]),_vm._v(" "),_c('ul',{staticClass:"nav-links",staticStyle:{"display":"flex","text-align":"center","white-space":"nowrap","list-style":"none","padding":"0","margin":"0"}},[_vm._l((_vm.custom_links),function(item){return _c('li',{key:item.id,class:("nav-" + (item.id)),style:({ order: item.position })},[_c('a',{directives:[{name:"t-tooltip",rawName:"v-t-tooltip.create",value:(item.i18n ? item.title : ('&nbsp;' + item.title + '&nbsp;')),expression:"item.i18n ? item.title : ('&nbsp;' + item.title + '&nbsp;')",modifiers:{"create":true}}],attrs:{"href":item.url || '#',"target":item.target,"data-placement":"bottom","data-toggle":"tooltip","data-container":"body"},on:{"click":function($event){return _vm.oncCustomItemClick($event, item)}}},[(item.icon)?_c('i',{class:item.icon}):_vm._e(),_vm._v(" "),(item.img)?_c('img',{attrs:{"height":"20","src":item.img,"title":item.img_title,"alt":item.img_title}}):_vm._e(),_vm._v(" "),(item.i18n)?_c('span',{directives:[{name:"t-html",rawName:"v-t-html",value:(item.text || item.title || item.img_title),expression:"item.text || item.title || item.img_title"}],attrs:{"hidden":item.text ? undefined : ''}}):_vm._e(),_vm._v(" "),(!item.i18n)?_c('span',{attrs:{"hidden":item.text ? undefined : ''},domProps:{"innerHTML":_vm._s(item.text || item.title || item.img_title)}}):_vm._e()])])}),_vm._v(" "),_c('li',{staticClass:"nav-user dropdown"},[_c('a',{staticClass:"dropdown-toggle",attrs:{"href":"#","data-toggle":"dropdown"}},[_c('i',{class:_vm.$fa('user')}),_vm._v(" "),(_vm.user)?_c('span',[_vm._v(_vm._s(_vm.user.username))]):_c('span',{directives:[{name:"t",rawName:"v-t",value:('sign_in'),expression:"'sign_in'"}]}),_vm._v(" "),_c('i',{staticClass:"triangle"})]),_vm._v(" "),_c('ul',{staticClass:"dropdown-menu"},[(_vm.user)?_c('li',{staticClass:"user-header"},[_vm._v("\n            👋\n            "),(!_vm.user.first_name && !_vm.user.last_name)?_c('span',[_vm._v(_vm._s(_vm.user.username))]):_c('span',[_vm._v(_vm._s(_vm.user.first_name)+" "+_vm._s(_vm.user.last_name))])]):_vm._e(),_vm._v(" "),_c('li',{staticClass:"user-footer"},[(!_vm.user)?_c('a',{staticClass:"nav-login btn btn-default btn-flat skin-color",attrs:{"src":_vm.login_url,"data-toggle":_vm.has_iframe_login ? 'modal'        : undefined,"data-target":_vm.has_iframe_login ? '#modal-login' : undefined}},[_c('b',{directives:[{name:"t",rawName:"v-t",value:('sign_in'),expression:"'sign_in'"}]}),_c('i',{class:_vm.$fa('sign-in')})]):_vm._e(),_vm._v(" "),(_vm.user && _vm.user.admin_url)?_c('a',{staticClass:"nav-admin btn btn-default btn-flat skin-color",attrs:{"href":_vm.user.admin_url}},[_c('b',[_vm._v("Admin")]),_c('i',{class:_vm.$fa('tool')})]):_vm._e(),_vm._v(" "),(_vm.urls.frontendurl)?_c('a',{staticClass:"nav-home btn btn-default btn-flat skin-color",attrs:{"href":_vm.urls.frontendurl}},[_c('b',{directives:[{name:"t",rawName:"v-t",value:('homepage'),expression:"'homepage'"}]}),_c('i',{class:_vm.$fa('home')})]):_vm._e(),_vm._v(" "),(_vm.user && _vm.user.logout_url)?_c('a',{staticClass:"nav-logout btn btn-default btn-flat skin-color",attrs:{"href":_vm.user.logout_url}},[_c('b',{directives:[{name:"t",rawName:"v-t",value:('logout'),expression:"'logout'"}]}),_c('i',{class:_vm.$fa('sign-out')})]):_vm._e(),_vm._v(" "),_c('a',{staticClass:"nav-embedmap btn btn-default btn-flat skin-color",attrs:{"href":"#"},on:{"click":_vm.showEmbedModal}},[_c('b',{directives:[{name:"t",rawName:"v-t",value:('embed_map'),expression:"'embed_map'"}]}),_c('i',{class:_vm.$fa('link')})]),_vm._v(" "),(_vm.hasRelatedMaps)?_c('a',{staticClass:"nav-changemap btn btn-default btn-flat",attrs:{"href":"#"},on:{"click":_vm.openChangeMapMenu}},[_c('b',{directives:[{name:"t",rawName:"v-t",value:('changemap'),expression:"'changemap'"}]}),_c('i',{class:_vm.$fa('refresh')})]):_vm._e(),_vm._v(" "),('legend' !== _vm.activeTab)?_c('a',{staticClass:"nav-addlayer btn btn-default btn-flat",attrs:{"href":"#"},on:{"click":_vm.showaddLayerModal}},[_c('b',{directives:[{name:"t",rawName:"v-t",value:('mapcontrols.add_layer_control.header'),expression:"'mapcontrols.add_layer_control.header'"}]}),_c('i',{class:_vm.$fa('layers')})]):_vm._e(),_vm._v(" "),_c('a',{staticClass:"nav-sidebar btn btn-default btn-flat",attrs:{"href":"#"},on:{"click":_vm.toggleSidebar}},[_c('b',{directives:[{name:"t",rawName:"v-t",value:('sidebar_menu'),expression:"'sidebar_menu'"}]}),_c('i',{staticClass:"fa fa-toggle-on"})])])])]),_vm._v(" "),(_vm.languages)?_c('li',{staticClass:"nav-lang"},[_c('select',{directives:[{name:"select2",rawName:"v-select2",value:('language'),expression:"'language'"},{name:"model",rawName:"v-model",value:(_vm.language),expression:"language"}],staticClass:"form-control",staticStyle:{"cursor":"pointer","width":"130px"},attrs:{"templateSelection":_vm.templateResultLanguages,"templateResult":_vm.templateResultLanguages,"dropdownAutoWidth":true,"dropdownParent":_vm.dropdownParent},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.language=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.languages),function(lang){return _c('option',{key:lang[0],domProps:{"value":lang[0],"selected":lang[0] === _vm.language && 'selected'}},[_vm._v("\n            "+_vm._s(lang[1])+"\n          ")])}),0)]):_vm._e()],2)]):_vm._e(),_vm._v(" "),_c('aside',[_c('div',{staticClass:"main-sidebar no-print",class:{ iframe: _vm.iframe, 'g3w-disabled': _vm.disabled }},[_c('div',{attrs:{"id":"disable-sidebar"}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.panels.length > 0),expression:"panels.length > 0"}],staticClass:"g3w-sidebarpanel"},[_c('div',{attrs:{"id":"g3w-sidebarpanel-header-placeholder"}},[_c('div',{staticStyle:{"display":"flex","margin-bottom":"5px"},style:({ justifyContent: _vm.app.sidebar.title ? 'space-between' : 'flex-end' })},[(_vm.title)?_c('h4',{directives:[{name:"t",rawName:"v-t",value:(_vm.title),expression:"title"}],staticStyle:{"display":"inline-block","font-weight":"bold"}}):_vm._e(),_vm._v(" "),_c('div',[(_vm.panels.length > 1)?_c('span',{directives:[{name:"t-tooltip",rawName:"v-t-tooltip.create",value:('back'),expression:"'back'",modifiers:{"create":true}}],staticClass:"skin-tooltip-left g3w-span-button close-pane-button fa-stack",attrs:{"data-placement":"left","data-toggle":"tooltip","data-container":"body"},on:{"click":function($event){$event.stopPropagation();return _vm.closePanel($event)}}},[_c('i',{staticClass:"fa-stack-1x panel-button",class:_vm.$fa('circle')}),_vm._v(" "),_c('i',{staticClass:"fa-stack-1x panel-icon",class:_vm.$fa('arrow-left')})]):_vm._e(),_vm._v(" "),_c('span',{directives:[{name:"t-tooltip",rawName:"v-t-tooltip:right.create",value:(_vm.app.sidebar.tooltip_close || 'close'),expression:"app.sidebar.tooltip_close || 'close'",arg:"right",modifiers:{"create":true}}],staticClass:"skin-tooltip-left g3w-span-button close-pane-button fa-stack",attrs:{"data-toggle":"tooltip","data-container":"body","current-tooltip":_vm.app.sidebar.tooltip_close || 'close'},on:{"click":function($event){$event.stopPropagation();_vm.app.sidebar.btn_close && _vm.closeAllPanels()}}},[_c('i',{staticClass:"fa-stack-1x panel-button",class:_vm.$fa('circle')}),_vm._v(" "),_c('i',{staticClass:"fa-stack-1x panel-icon",class:_vm.$fa('close'),style:({ opacity: _vm.app.sidebar.btn_close ? '1' : '0.7', cursor: _vm.app.sidebar.btn_close ? 'pointer' : 'not-allowed' })})])])])]),_vm._v(" "),_c('div',{staticClass:"g3w-sidebarpanel-placeholder",attrs:{"id":"g3w-sidebarpanel-placeholder"}})]),_vm._v(" "),_c('ul',{directives:[{name:"show",rawName:"v-show",value:(_vm.showmainpanel),expression:"showmainpanel"}],staticClass:"sidebar-menu",class:{ 'g3w-disabled': _vm.disabled },attrs:{"id":"g3w-sidebarcomponents"},on:{"click":_vm.toggleSidebarItem}},[_c('li',{staticClass:"treeview sidebaritem",attrs:{"id":"metadata"}},[_c('a',{directives:[{name:"t-tooltip",rawName:"v-t-tooltip",value:('sdk.metadata.title'),expression:"'sdk.metadata.title'"}],staticClass:"skin-tooltip-right",staticStyle:{"display":"flex","justify-content":"space-between","align-items":"center"},attrs:{"href":"#","data-placement":"right","data-container":"body","data-toggle":"modal","data-target":"#modal-metadata"}},[_c('div',[_c('i',{class:_vm.$fa('file'),staticStyle:{"color":"#fff"}}),_vm._v(" "),_c('span',{directives:[{name:"t",rawName:"v-t",value:('sdk.metadata.title'),expression:"'sdk.metadata.title'"}],staticClass:"treeview-label"})])])])])]),_vm._v(" "),_c('a',{directives:[{name:"t-tooltip",rawName:"v-t-tooltip.create",value:('sidebar_menu'),expression:"'sidebar_menu'",modifiers:{"create":true}}],staticClass:"sidebar-aside-toggle",class:{ 'g3w-disabled': _vm.disabled, 'iframe': _vm.iframe},staticStyle:{"z-index":"2"},attrs:{"href":"#","role":"button","data-placement":"right"},on:{"click":function($event){$event.preventDefault();return _vm.toggleSidebar($event)}}})]),_vm._v(" "),_c('div',{staticClass:"content-wrapper",style:({ paddingTop: _vm.isIframe ? 0 : null })},[_c('transition',{attrs:{"name":"fade","duration":{ enter: 500, leave: 500 }}},[(_vm.usermessage.show)?_c('user-message',{attrs:{"title":_vm.usermessage.title,"subtitle":_vm.usermessage.subtitle,"id":_vm.usermessage.id,"message":_vm.usermessage.message,"draggable":_vm.usermessage.draggable,"closable":_vm.usermessage.closable,"duration":_vm.usermessage.duration,"position":_vm.usermessage.position,"autoclose":_vm.usermessage.autoclose,"textMessage":_vm.usermessage.textMessage,"size":_vm.usermessage.size,"type":_vm.usermessage.type,"icon-class":_vm.usermessage.iconClass},on:{"close-usermessage":_vm.closeUserMessage}},[(_vm.usermessage.hooks.header)?_c('template',{slot:"header"},[_c(_vm.usermessage.hooks.header,{tag:"component"})],1):_vm._e(),_vm._v(" "),(_vm.usermessage.hooks.body)?_c('template',{slot:"body"},[_c(_vm.usermessage.hooks.body,{tag:"component"})],1):_vm._e(),_vm._v(" "),(_vm.usermessage.hooks.footer)?_c('template',{slot:"footer"},[_c(_vm.usermessage.hooks.footer,{tag:"component"})],1):_vm._e()],2):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"g3w-view map",class:("split-" + (_vm.state.split)),style:(_vm.styles.map),attrs:{"id":"g3w-view-map"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showresize),expression:"showresize"}],class:("split-" + (_vm.state.split)),style:({ cursor: 'v' === _vm.state.split ? 'ns-resize' : 'col-resize' }),attrs:{"id":"resize-map-and-content"},on:{"mousedown":function($event){$event.stopPropagation();return _vm.resizeStart($event)}}}),_vm._v(" "),_c('div',{attrs:{"id":"application-notifications"}},[_c('div',{class:{ 'g3w-hide': _vm.app.online },staticStyle:{"color":"#999"},attrs:{"id":"offline_notification"}},[_c('i',{class:_vm.$fa('wifi')}),_vm._v(" "),_c('div',{staticStyle:{"font-weight":"bold","font-size":"0.4em"}},[_vm._v("offline")])]),_vm._v(" "),_c('div',{directives:[{name:"download",rawName:"v-download.show",modifiers:{"show":true}}],staticClass:"skin-color",attrs:{"id":"download_notification","title":"DOWNLOAD"}},[_c('bar-loader',{attrs:{"loading":true}}),_vm._v(" "),_c('i',{class:_vm.$fa('download'),staticStyle:{"padding":"3px"}})],1),_vm._v(" "),_c('div',{class:{ 'g3w-hide': 0 === _vm.app.plugins.length },staticStyle:{"color":"#994b10"},attrs:{"id":"plugins_notification"}},[_c('bar-loader',{attrs:{"loading":true}}),_vm._v(" "),_c('i',{class:_vm.$fa('plugin')})],1)])]),_vm._v(" "),_c('div',{directives:[{name:"disabled",rawName:"v-disabled",value:(_vm.state.content.disabled),expression:"state.content.disabled"}],staticClass:"g3w-view content",class:("split-" + (_vm.state.split)),style:(_vm.styles.content),attrs:{"id":"g3w-view-content"}},[(_vm.breadcrumb.length > 1)?_c('section',{ref:_vm.breadcrumb,staticClass:"content_breadcrumb"},_vm._l((_vm.breadcrumb),function(crumb,index){return _c('span',{key:crumb.title},[_c('span',{directives:[{name:"t",rawName:"v-t",value:(crumb.text ? null : crumb.title),expression:"crumb.text ? null : crumb.title"}],staticClass:"skin-color-dark",style:({fontWeight: _vm.isNotLastCrumb(index) ? 'bold' : 'normal'})},[(crumb.text)?_c('span',[_vm._v(" "+_vm._s(crumb.title)+" ")]):_vm._e()]),_vm._v(" "),(_vm.isNotLastCrumb(index))?_c('span',{staticStyle:{"font-weight":"bold","margin":"3px 0"}},[_vm._v("/")]):_vm._e()])}),0):_vm._e(),_vm._v(" "),((_vm.showtitle && _vm.contentTitle) || _vm.previousTitle || (_vm.state.content.closable && _vm.state.content.aside))?_c('div',{staticClass:"close-panel-block",staticStyle:{"display":"flex","justify-content":"space-between"}},[(_vm.previousTitle)?_c('div',{staticClass:"g3w_contents_back g3w-long-text"},[('back' === _vm.backOrBackTo )?_c('div',{class:_vm.backOrBackTo},[_c('span',{staticClass:"action-button",class:_vm.$fa('back')}),_vm._v(" "),_c('span',{directives:[{name:"t",rawName:"v-t",value:('back'),expression:"'back'"}]})]):_c('div',{class:_vm.backOrBackTo,on:{"click":function($event){$event.stopPropagation();return _vm.gotoPreviousContent()}}},[_c('span',{staticClass:"action-button",class:_vm.$fa('back')}),_vm._v(" "),_c('span',{directives:[{name:"t",rawName:"v-t",value:('backto'),expression:"'backto'"}]}),_vm._v(" "),(!_vm.updatePreviousTitle)?_c('span',{directives:[{name:"t",rawName:"v-t",value:(_vm.previousTitle),expression:"previousTitle"}]}):_vm._e()])]):_vm._e(),_vm._v(" "),(!_vm.previousTitle && _vm.showtitle && _vm.contentTitle)?_c('div',{staticClass:"panel-title",class:{'mobile': _vm.isMobile()},style:([_vm.state.content.style.title])},[_c('b',{attrs:{"id":"contenttitle"}},[_c('span',{directives:[{name:"t",rawName:"v-t",value:(_vm.contentTitle.text ? null : _vm.contentTitle.title),expression:"contentTitle.text ? null : contentTitle.title"}]},[(_vm.contentTitle.text )?_c('span',[_vm._v(_vm._s(_vm.contentTitle.title))]):_vm._e()]),_vm._v(" "),_c('span',{directives:[{name:"t",rawName:"v-t",value:(_vm.contentTitle.post_title),expression:"contentTitle.post_title"}]})])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"g3-content-header-action-tools",staticStyle:{"display":"flex","align-items":"center"}},[_vm._l((_vm.state.content.headertools),function(tool){return _c(tool,{tag:"component"})}),_vm._v(" "),(_vm.showresizeicon)?_c('div',{staticStyle:{"display":"flex","justify-content":"space-between","font-size":"1em","padding":"0","align-self":"center","margin-left":"auto","cursor":"pointer"},style:({ marginRight: _vm.state.content.closable ? '5px': '0px' })},[(undefined !== _vm.state.split)?_c('i',{directives:[{name:"t-tooltip",rawName:"v-t-tooltip:bottom.create",value:('enlange_reduce'),expression:"'enlange_reduce'",arg:"bottom",modifiers:{"create":true}}],staticClass:"action-button skin-color-dark",class:_vm.$fa(("resize-" + (_vm.state.split))),staticStyle:{"margin-right":"3px"},on:{"click":_vm.resizeFull}}):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.state.content.closable && _vm.state.content.aside)?_c('span',{staticClass:"action-button",class:{'mobile': _vm.isMobile()},staticStyle:{"display":"flex","justify-content":"center"},on:{"click":_vm.closeContent}},[_c('i',{staticClass:"skin-color-dark",class:_vm.$fa('close')})]):_vm._e()],2)]):_vm._e(),_vm._v(" "),_c('bar-loader',{attrs:{"loading":_vm.state.content.loading}})],1)],1),_vm._v(" "),_c('catalog-context-menu'),_vm._v(" "),_c('cookie-law',{attrs:{"theme":"dark-lime","buttonText":_vm.cookie_law_buttonText}},[_c('div',{directives:[{name:"t",rawName:"v-t",value:('cookie_law.message'),expression:"'cookie_law.message'"}],attrs:{"slot":"message"},slot:"message"})]),_vm._v(" "),_c('Teleport',{attrs:{"to":"body"}},[_c('div',{staticClass:"modal fade modal-fullscreen",attrs:{"id":"modal-fullscreen","tabindex":"-1","role":"dialog","data-backdrop":"static","data-keyboard":"false","aria-labelledby":"modal-fullscreen","aria-hidden":"true"}}),_vm._v(" "),(!_vm.user && _vm.has_iframe_login)?_c('modal-login'):_vm._e(),_vm._v(" "),_c('modal-addlayer'),_vm._v(" "),_c('modal-changemap'),_vm._v(" "),_c('modal-metadata')],1)],1)}
__vue__options__.staticRenderFns = []
__vue__options__._scopeId = "data-v-7718180d"

},{"components/CatalogContextMenu.vue":73,"components/ModalAddLayer.vue":118,"components/ModalChangeMap.vue":119,"components/ModalLogin.vue":120,"components/ModalMetadata.vue":121,"components/UserMessage.vue":145,"g3w-component":158,"g3w-constants":159,"g3w-i18n":162,"g3w-panel":164,"services/gui":207,"store/application":212,"utils/getUniqueDomId":252,"utils/promisify":267,"utils/sameOrigin":272,"vue-cookie-law":32,"vue2-teleport":34,"vueify/lib/insert-css":35}],71:[function(require,module,exports){
var __vueify_style_dispose__ = require("vueify/lib/insert-css").insert(".tabbable-line>.nav-tabs>li.active{border-bottom:4px solid var(--skin-color)}.catalog #legend div.selected,.catalog .tree-item.selected{background-color:var(--skin-color)}.catalog-context-menu li.title{border-bottom-color:var(--skin-color)!important}.skin-blue .tabbable-line>.nav-tabs>li:is(.open,:hover){border-bottom:4px solid #6abbea}.skin-blue .tabbable-line.tabs-below>.nav-tabs>li:hover{border-top:4px solid #6abbea}.skin-blue .tabbable-line.tabs-below>.nav-tabs>li.active{border-top:4px solid #f3565d}.skin-green .tabbable-line>.nav-tabs>li:is(.open,:hover){border-bottom:4px solid #00ff8e}.skin-green .tabbable-line.tabs-below>.nav-tabs>li:hover{border-top:4px solid #00ff8e}.skin-green .tabbable-line.tabs-below>.nav-tabs>li.active{border-top:4px solid #f3565d}.skin-purple .tabbable-line>.nav-tabs>li:is(.open,:hover){border-bottom:4px solid #a19dff}.skin-purple .tabbable-line.tabs-below>.nav-tabs>li:hover{border-top:4px solid #a19dff}.skin-purple .tabbable-line.tabs-below>.nav-tabs>li.active{border-top:4px solid #f3565d}.skin-red .tabbable-line>.nav-tabs>li:is(.open,:hover){border-bottom:4px solid #ff5542}.skin-red .tabbable-line.tabs-below>.nav-tabs>li.active,.skin-red .tabbable-line.tabs-below>.nav-tabs>li:hover{border-top:4px solid #ff5542}.skin-yellow .tabbable-line>.nav-tabs>li:is(.open,:hover){border-bottom:4px solid #ffde0d}.skin-yellow .tabbable-line.tabs-below>.nav-tabs>li:hover{border-top:4px solid #ffde0d}.skin-yellow .tabbable-line.tabs-below>.nav-tabs>li.active{border-top:4px solid #ffdf12}.tabbable-panel{padding:10px}.tabbable-line>.nav-tabs{border:none;margin:0}.tabbable-line .nav-tabs ul li{color:#fff}.tabbable-line>.nav-tabs>li{margin-right:2px;border-bottom:4px solid #21292d}.tabbable-line>.nav-tabs>li>a{border:0;margin-right:0;color:#fff}.tabbable-line>.nav-tabs>li>a>i{color:#a6a6a6}.tabbable-line>.nav-tabs>li:is(.open,:hover)>a{border:0;background:none!important}.tabbable-line>.nav-tabs>li:is(.open,:hover)>a>i{color:#a6a6a6}.tabbable-line>.nav-tabs>li:is(.open,:hover) .dropdown-menu{margin-top:0}.tabbable-line>.nav-tabs>li.active{position:relative;font-weight:700}.tabbable-line>.nav-tabs>li.active>a{border:0;color:#fff;background-color:#2c3b41}.tabbable-line>.nav-tabs>li.active>a>i{color:#fff}.tabbable-line>.tab-content.catalog-tab-content{margin-top:-3px;border:0;color:#fff;padding:5px 0 0}.portlet .tabbable-line>.tab-content{padding-bottom:0}.tabbable-line.tabs-below>.nav-tabs>li{border-top:4px solid transparent}.tabbable-line.tabs-below>.nav-tabs>li>a{margin-top:0}.tabbable-line.tabs-below>.nav-tabs>li:hover{border-bottom:0;color:#fff}.tabbable-line.tabs-below>.nav-tabs>li.active{margin-bottom:-2px;border-bottom:0}.tabbable-line.tabs-below>.tab-content{margin-top:-10px;border-top:0;border-bottom:1px solid #eee;padding-bottom:15px}.nav-tabs>li.active>a,.nav-tabs>li.active>a:is(:focus,:hover){color:#fff}.catalog>.title{padding:10px;font-weight:700}.catalog ul{line-height:1.75em;list-style-type:none}.catalog .list-group-item{color:#fff;background-color:#2c3b41}.catalog #legend div.selected ul.layer-categories,.catalog .tree-item.selected ul.layer-categories{background-color:#222d32}.catalog #legend div div.tree-node-title,.catalog .tree-item div.tree-node-title{padding-left:3px;cursor:pointer;width:80%;display:inline-flex;justify-content:space-between;user-select:none}.catalog #legend div div.tree-node-title.disabled,.catalog .tree-item div.tree-node-title.disabled{color:#999}.catalog #legend div div.tree-node-title .selection-filter-icon,.catalog .tree-item div.tree-node-title .selection-filter-icon{box-shadow:0 2px 5px rgba(0,0,0,.3);padding:5px;border-radius:3px;margin:0 3px;font-weight:700;color:#fff!important}.catalog #legend div div.tree-node-title .selection-filter-icon.active,.catalog .tree-item div.tree-node-title .selection-filter-icon.active{box-shadow:none;background-color:#384247}.catalog .tree-item{cursor:pointer;margin-bottom:3px}.catalog .tree-item.disabled>span{color:#999}.catalog .root{padding:2px 1px 1px 5px}.catalog .root .tree-item.group{padding-left:1px}.catalog .root.fa-chevron-right{padding-right:5px;padding-left:0}.catalog .root-categories.fa-chevron-right{padding-right:7px}.catalog .root-categories.fa-chevron-down{padding-right:3px}.bold{font-weight:700;color:#fff}.highlightlayer{border-bottom:2px dashed;border-color:#ffb516}.catalog{padding:3px}.catalog .tree-root{padding-left:0}.catalog .tree-root li>.root{padding-left:5px}.catalog .tree-root li.tree-item ul.tree-content-items.root{padding-left:18px}.catalog .tree-root li.tree-item ul.tree-content-items.root>.tree-item.group{padding-left:1px!important}.catalog .tree-root li.tree-item ul.tree-content-items{padding-left:17px;padding-top:2px}.g3w-lendplace-toc{padding-left:23px}.g3w-lendplace-toc.group{padding-left:17px}.g3w-lendplace-toc.root{padding-left:18px}.g3w-lendplace-toc.root>li.itemmarginbottom{margin-left:-13px}.g3w-lendplace-toc.root>li.itemmarginbottom div.layer-legend{padding-left:56px}.g3w-lendplace-toc.root>li.itemmarginbottom>span.child{padding-left:18px!important}.catalog .tree-root span.root.collapse-expande-collapse-icon{width:19px}.catalog .tree-root span.root.collapse-expande-collapse-icon.project-root{width:17px}.catalog .tree-root span.collapse-expande-collapse-icon{width:10px}.catalog span.legend-collapse-expande-collapse-icon{font-size:1.2em}.catalog .child-categories{padding:5px 3px 1px 12px}.catalog .layer-legend{padding:3px 0 0 35px;background-color:#222d32}.catalog .catalalog-nav-tabs{display:flex;flex:1 1 0}.catalog .catalalog-nav-tabs>li{font-size:1em;white-space:normal;display:flex;flex:1 1 0;align-items:stretch}.catalog .catalalog-nav-tabs>li a{padding:10px 0;text-align:center;height:100%;width:100%}.catalog .tree{color:#fff}.catalog .tree.disabled{color:#999;cursor:not-allowed}.catalog .g3w-external_wms_layers-group{padding:5px}.catalog .baselayers .radio{margin:0}#baselayers-content{display:grid;justify-content:center;grid-gap:5px;padding:0;margin:5px}#baselayers-content.mobile{grid-template-columns:repeat(auto-fill,minmax(80px,110px))}#baselayers-content .baseselayer-text{white-space:pre-line;font-weight:700}#baselayers-content .baselayer{cursor:pointer}#baselayers-content .baselayer .baselayer-name{font-weight:700;white-space:pre-line;text-align:center}#catalog #layers ul.g3w-external_layers-group{padding-left:0!important}#catalog #layers ul.g3w-external_layers-group li{padding-left:2px!important}#catalog #layers .sidebar-menu>li>a{border:0}#catalog>a{display:none!important}#catalog .tree-item>.toggle-context-menu{opacity:0;position:absolute;inset:0 4px auto auto;color:#fff;padding:4px 8px;border:1px solid;border-radius:3px}#catalog .tree-item:not(.group):hover>.toggle-context-menu{opacity:1}\n#legend .divider[data-v-3f643805]{display:block;position:relative;padding:0;margin:8px auto;height:0;width:100%;max-height:0;font-size:1px;line-height:0;clear:both;border:none}.legend-item[data-v-3f643805]{width:100%;position:relative}.g3w-catalog-layers-group>div[data-v-3f643805]{border:1px solid #ffffff33;margin:5px}.g3w-catalog-layers-group>div>h4[data-v-3f643805]{margin:5px;font-weight:700}")
;(function(){
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _g3wEventbus = require('g3w-eventbus');

var _application = require('store/application');

var _application2 = _interopRequireDefault(_application);

var _gui = require('services/gui');

var _gui2 = _interopRequireDefault(_gui);

var _XHR = require('utils/XHR');

var _getCatalogLayerById = require('utils/getCatalogLayerById');

var _CatalogChangeMapThemes = require('components/CatalogChangeMapThemes.vue');

var _CatalogChangeMapThemes2 = _interopRequireDefault(_CatalogChangeMapThemes);

var _CatalogTristateTree = require('components/CatalogTristateTree.vue');

var _CatalogTristateTree2 = _interopRequireDefault(_CatalogTristateTree);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function __(name, value) {
  return value || 0 === value ? '' + name + value : null;
}

exports.default = {
  name: 'catalog',

  data: function data() {
    return {
      state: this.$options.service.state || {},
      legend_position: _application2.default.project.state.legend_position || 'tab',
      iframe: _application2.default.iframe,
      showlegend: false,
      backgroundLegend: _application2.default.gui.layout.app.legend && _application2.default.gui.layout.app.legend.transparent ? 'transparent' : '#FFFFFF',
      currentBaseLayer: null,
      activeTab: 'layers',
      loading: false
    };
  },


  components: {
    CatalogChangeMapThemes: _CatalogChangeMapThemes2.default,
    CatalogTristateTree: _CatalogTristateTree2.default
  },

  computed: {
    project: function project() {
      return _application2.default.project;
    },
    title: function title() {
      return this.project.state.name;
    },
    baselayers: function baselayers() {
      return this.project.state.baselayers;
    },
    hasBaseLayers: function hasBaseLayers() {
      return this.project.state.baselayers.length > 0;
    },
    hasLayers: function hasLayers() {
      return this.state.external.vector.length > 0 || this.state.layerstrees.reduce(function (a, l) {
        return l.tree.length + a;
      }, 0) > 0 || this.state.layersgroups.length > 0;
    },
    hasRelatedMaps: function hasRelatedMaps() {
      return window.initConfig.macrogroups.length + window.initConfig.groups.length + window.initConfig.projects.length > 1;
    }
  },

  methods: {
    onLegendError: function onLegendError(url) {
      url.error = true;
      url.loading = false;
    },
    onLegendLoad: function onLegendLoad(url) {
      url.loading = false;
    },
    getLegendSrc: function getLegendSrc() {
      var _this = this;

      var change = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if ('tab' !== this.legend_position) {
        return;
      }

      this.state.layerstrees.forEach(function (t) {
        var layers = _this._traverseVisibleLayers(t.tree);
        _this.showlegend = _this.showlegend || layers.length > 0;
        t.tree.forEach(function () {
          var _ref = _asyncToGenerator(function* (tree) {
            try {
              if (change && (tree.legendurls && 0 === tree.legendurls.length || layers.some(function (l) {
                return l.legend.change;
              }) || _application2.default.project.state.context_base_legend)) {
                layers.filter(function (l) {
                  return l.legend.change;
                }).forEach(function (l) {
                  return l.legend.change = false;
                });
              }
              tree.legendurls = yield _this._getLegendSrc(layers);
            } catch (e) {
              console.warn(e);
            }
          });

          return function (_x2) {
            return _ref.apply(this, arguments);
          };
        }());
      });
    },
    _traverseVisibleLayers: function _traverseVisibleLayers(obj) {
      var _layers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = obj[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var layer = _step.value;

          if (null !== layer.id && undefined !== layer.id && layer.visible && layer.geolayer && !layer.exclude_from_legend) {
            _layers.push(layer);
          }
          if (null !== layer.nodes && undefined !== layer.nodes) {
            this._traverseVisibleLayers(layer.nodes, _layers);
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return _layers;
    },
    _getLegendSrc: function () {
      var _ref2 = _asyncToGenerator(function* (visiblelayers) {
        var legendurls = [];

        var layers = visiblelayers.filter(function (l) {
          return l.geolayer;
        });

        var http = { GET: {}, POST: {} };

        layers.forEach(function (layer) {
          var name = http[layer.source && layer.source.url || layer.external ? 'GET' : layer.ows_method];
          var catalogLayer = (0, _getCatalogLayerById.getCatalogLayerById)(layer.id);

          var url = catalogLayer ? catalogLayer.getLegendUrl((window.initConfig.layout || {}).legend, {
            all: !_application2.default.project.state.context_base_legend,
            format: 'image/png',
            categories: layer.categories
          }) : undefined;

          if (undefined === catalogLayer) {
            return;
          }

          if (layer.source && layer.source.url) {
            name[url] = [];
            return;
          }

          var prefix = url.split('LAYER=')[0].split('LEGEND_ON=')[0].split('LEGEND_OFF=')[0];

          if (!name[prefix]) {
            name[prefix] = [];
          }

          name[prefix].unshift({
            layerName: url.split('LAYER=')[1],
            style: (Array.isArray(layer.styles) && layer.styles.find(function (style) {
              return style.current;
            }) || { name: false }).name,
            legend_on: (url.split('LAYER=')[0].split('LEGEND_ON=')[1] || '').replace('&', ''),
            legend_off: (url.split('LAYER=')[0].split('LEGEND_ON=')[0].split('LEGEND_OFF=')[1] || '').replace('&', '') });
        });

        for (var method in http) {
          var _loop = function* _loop(url) {
            var obj = {
              loading: true,
              url: null,
              error: false
            };

            legendurls.push(obj);

            var params = {
              LAYERS: [],
              STYLES: [],
              LEGEND_ON: [],
              LEGEND_OFF: []
            };

            (http[method][url] || []).reduce(function (_, layer) {
              params.LAYERS.push(layer.layerName);
              params.STYLES.push(layer.style);
              if (layer.legend_on) {
                params.LEGEND_ON.push(layer.legend_on);
              }
              if (layer.legend_off) {
                params.LEGEND_OFF.push(layer.legend_off);
              }
              return params;
            }, params);

            var url_params = [__('LAYERS=', params.LAYERS.join(',')), __('STYLES=', params.STYLES.join(',')), __('LEGEND_ON=', params.LEGEND_ON.join(',')), __('LEGEND_OFF=', params.LEGEND_OFF.join(',')), __('filtertoken=', _application2.default.tokens.filtertoken)].filter(function (p) {
              return p;
            }).join('&');

            try {
              obj.url = 'GET' === method ? url + (http[method][url].length ? url_params : '') : URL.createObjectURL((yield (yield fetch(url.split('?')[0], {
                method: 'POST',
                headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },

                body: url.split('?')[1].split('&').filter(function (p) {
                  return p.split('=')[0];
                }).map(function (p) {
                  return p.split('=')[0] + '=' + encodeURIComponent(p.split('=')[1]);
                }).join('&') + '&' + url_params
              })).blob()));
            } catch (e) {
              console.warn(e);
            }
          };

          for (var url in http[method]) {
            yield* _loop(url);
          }
        }
        return legendurls;
      });

      function _getLegendSrc(_x4) {
        return _ref2.apply(this, arguments);
      }

      return _getLegendSrc;
    }(),
    getMapThemeFromThemeName: function () {
      var _ref3 = _asyncToGenerator(function* (theme) {
        var project = _application2.default.project;

        var config = Object.values(project.state.map_themes).flat().find(function (c) {
          return theme === c.theme;
        });
        if (config && undefined === config.layerstree) {
          try {
            var response = yield _XHR.XHR.get({ url: '' + project.urls.map_themes + theme + '/' });
            if (response.result) {
              config.layerstree = response.data;
            }
          } catch (e) {
            console.warn('Error while retreiving map theme configuration', e);
          }
        }
        return config;
      });

      function getMapThemeFromThemeName(_x5) {
        return _ref3.apply(this, arguments);
      }

      return getMapThemeFromThemeName;
    }(),
    setLayersTreePropertiesFromMapTheme: function () {
      var _ref5 = _asyncToGenerator(function* (_ref4) {
        var map_theme = _ref4.map_theme,
            layerstree = _ref4.layerstree;

        var project = _application2.default.project;
        layerstree = undefined !== layerstree ? layerstree : project.state.layerstree;

        var theme = yield this.getMapThemeFromThemeName(map_theme);

        var changes = { layers: {} };
        var promises = [];

        var groups = [];
        var traverse = function traverse(mapThemeLayersTree, layerstree, checked) {
          mapThemeLayersTree.forEach(function (node, index) {
            if (node.nodes) {
              groups.push({
                node: node,
                group: layerstree[index]
              });
              traverse(node.nodes, layerstree[index].nodes, checked && node.checked);
            } else {
              node.style = theme.styles[node.id];
              if (layerstree[index].checked !== node.visible) {
                changes.layers[node.id] = {
                  visibility: true,
                  style: false
                };
              }
              layerstree[index].checked = node.visible;

              if (node.style) {
                var promise = new Promise(function (resolve) {
                  var setCurrentStyleAndResolvePromise = function setCurrentStyleAndResolvePromise(node) {
                    if (changes.layers[node.id] === undefined) changes.layers[node.id] = {
                      visibility: false,
                      style: false
                    };
                    changes.layers[node.id].style = project.getLayerById(node.id).setCurrentStyle(node.style);
                    resolve();
                  };
                  if (project.getLayersStore()) {
                    setCurrentStyleAndResolvePromise(node);
                  } else {
                    (function (node) {
                      return setTimeout(function () {
                        return setCurrentStyleAndResolvePromise(node);
                      });
                    })(node);
                  }
                });
                promises.push(promise);
              }
            }
          });
        };
        traverse(theme.layerstree, layerstree);

        yield Promise.allSettled(promises);

        groups.forEach(function (_ref6) {
          var group = _ref6.group,
              _ref6$node = _ref6.node,
              checked = _ref6$node.checked,
              expanded = _ref6$node.expanded;

          group.checked = checked;
          group.expanded = expanded;
        });

        return changes;
      });

      function setLayersTreePropertiesFromMapTheme(_x6) {
        return _ref5.apply(this, arguments);
      }

      return setLayersTreePropertiesFromMapTheme;
    }(),
    changeMapTheme: function () {
      var _ref7 = _asyncToGenerator(function* (map_theme) {
        _gui2.default.closeContent();

        this.state.layerstrees[0].checked = true;

        var changes = (yield this.setLayersTreePropertiesFromMapTheme({
          map_theme: map_theme,
          rootNode: this.state.layerstrees[0],
          layerstree: this.state.layerstrees[0].tree[0].nodes
        })).layers;

        var layers = Object.keys(changes).filter(function (id) {
          return changes[id].style;
        });
        var styles = (yield this.getMapThemeFromThemeName(map_theme)).styles;

        layers.forEach(function (id) {
          if (!changes[id].visible) {
            var layer = (0, _getCatalogLayerById.getCatalogLayerById)(id);
            layer.clearCategories();
            layer.change();
          }
        });

        layers.forEach(function (id) {
          return _g3wEventbus.VM.$emit('layer-change-style', { layerId: id, style: styles[id] });
        });
      });

      function changeMapTheme(_x7) {
        return _ref7.apply(this, arguments);
      }

      return changeMapTheme;
    }(),
    onTabClick: function onTabClick(e) {
      if (e.target.attributes['aria-controls']) {
        this.activeTab = e.target.attributes['aria-controls'].value;
      }
    },
    setBaseLayer: function setBaseLayer(id) {
      this.currentBaseLayer = id;
      this.project.setBaseLayer(id);
      _application2.default.baseLayerId = id;
    },
    getSrcBaseLayerImage: function getSrcBaseLayerImage(baseLayer) {
      var image = 'nobaselayer.png';
      switch (baseLayer && baseLayer.servertype || baseLayer) {
        case 'OSM':
          image = 'osm.png';break;
        case 'Bing':
          image = 'bing' + baseLayer.source.subtype + '.png';break;
        case 'TMS':
          image = baseLayer.icon ? baseLayer.icon : image;break;
        case 'WMTS':
          image = baseLayer.icon ? baseLayer.icon : image;break;
      }
      return (baseLayer || {}).icon ? image : _gui2.default.getResourcesUrl() + 'images/' + image;
    },
    onUnSelectionLayer: function onUnSelectionLayer(storeid, layer) {
      if (!layer) {
        return console.warn('undefined layer');;
      }

      var service = _gui2.default.getService('queryresults');
      var action = layer.external && service.getActionLayerById({ layer: layer, id: 'selection' });

      if (!layer.external && storeid) {
        _application2.default.catalog[storeid].getLayerById(layer.id).clearSelectionFids();
      }

      if (layer.external) {
        layer.selection.active = false;
        layer.selection.features.forEach(function (feature, i) {
          if (!feature.selection.selected) {
            return;
          }
          feature.selection.selected = false;
          if (action) {
            action.state.toggled[i] = false;
          }
          _gui2.default.getService('map').setSelectionFeatures('remove', { feature: feature });
        });
      }
    },
    onActiveFilterTokenLayer: function () {
      var _ref8 = _asyncToGenerator(function* (storeid, layerstree) {
        layerstree.filter.active = yield _application2.default.catalog[storeid].getLayerById(layerstree.id).toggleFilterToken();
      });

      function onActiveFilterTokenLayer(_x8, _x9) {
        return _ref8.apply(this, arguments);
      }

      return onActiveFilterTokenLayer;
    }(),
    onTreeNodeVisible: function onTreeNodeVisible(layer) {
      _gui2.default.getService('map').emit('cataloglayervisible', layer);
    },
    onTreeNodeSelected: function onTreeNodeSelected(node) {
      _gui2.default.getService('map').selectLayer(node.id);
    },
    showaddLayerModal: function showaddLayerModal() {
      $('#modal-addlayer').modal('show');
    },
    openChangeMapMenu: function openChangeMapMenu() {
      $('#modal-changemap').modal('show');
    }
  },

  watch: {
    'state.external.wms': function stateExternalWms(newlayers, oldlayers) {
      if (oldlayers && 0 === newlayers.length) {
        this.activeTab = this.project.state.catalog_tab || 'layers';
      }
    },


    project: {
      handler: function () {
        var _ref9 = _asyncToGenerator(function* (project) {
          var _this2 = this;

          var activeTab = project.state.catalog_tab || 'layers';
          this.loading = 'baselayers' === activeTab;
          yield this.$nextTick();
          setTimeout(function () {
            _this2.loading = false;
            _this2.activeTab = activeTab;
          }, 'baselayers' === activeTab ? 500 : 0);
        });

        function handler(_x10) {
          return _ref9.apply(this, arguments);
        }

        return handler;
      }(),

      immediate: false
    },

    activeTab: function activeTab(_activeTab, oldTab) {
      if ('legend' === _activeTab) {
        this.getLegendSrc(true);
      }
      if (this.$el) {
        this.$el.parentElement.classList.remove('tab-' + oldTab);
        this.$el.parentElement.classList.add('tab-' + _activeTab);
      }
    }
  },

  created: function created() {
    _g3wEventbus.VM.$on('unselectionlayer', this.onUnSelectionLayer);
    _g3wEventbus.VM.$on('activefiltertokenlayer', this.onActiveFilterTokenLayer);
    _g3wEventbus.VM.$on('treenodevisible', this.onTreeNodeVisible);
    _g3wEventbus.VM.$on('treenodeselected', this.onTreeNodeSelected);
    _g3wEventbus.VM.$on('layer-change-style', this.getLegendSrc);
  },
  beforeMount: function beforeMount() {
    this.currentBaseLayer = this.project.state.initbaselayer;
  },
  mounted: function () {
    var _ref10 = _asyncToGenerator(function* () {
      var _this3 = this;

      yield this.$nextTick();

      if (_application2.default.project.state.context_base_legend) {
        _gui2.default.getService('map').on('change-map-legend-params', function () {
          _this3.getLegendSrc();
        });
      } else {
        this.getLegendSrc();
      }
    });

    function mounted() {
      return _ref10.apply(this, arguments);
    }

    return mounted;
  }()
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tabbable-panel catalog"},[_c('div',{staticClass:"tabbable-line"},[_c('ul',{staticClass:"nav nav-tabs catalalog-nav-tabs",attrs:{"role":"tablist"},on:{"!click":function($event){return _vm.onTabClick($event)}}},[(_vm.hasLayers)?_c('li',{class:{ active: ('layers' === _vm.activeTab) },attrs:{"role":"presentation"}},[_c('a',{directives:[{name:"t",rawName:"v-t",value:('data'),expression:"'data'"}],attrs:{"href":"#layers","aria-controls":"layers","role":"tab","data-toggle":"tab","data-i18n":"tree"}})]):_vm._e(),_vm._v(" "),(_vm.state.external.wms.length)?_c('li',{class:{ active: ('externalwms' === _vm.activeTab) },attrs:{"role":"presentation"}},[_c('a',{directives:[{name:"t",rawName:"v-t",value:('externalwms'),expression:"'externalwms'"}],attrs:{"href":"#externalwms","aria-controls":"externalwms","role":"tab","data-toggle":"tab","data-i18n":"externalwms"}})]):_vm._e(),_vm._v(" "),(_vm.hasBaseLayers)?_c('li',{class:{ active: ('baselayers' === _vm.activeTab) },attrs:{"role":"presentation"}},[_c('a',{directives:[{name:"t",rawName:"v-t",value:('baselayers'),expression:"'baselayers'"}],attrs:{"href":"#baselayers","aria-controls":"baselayers","role":"tab","data-toggle":"tab","data-i18n":"baselayers"}})]):_vm._e(),_vm._v(" "),('tab' === _vm.legend_position && _vm.showlegend)?_c('li',{class:{ active: ('legend' === _vm.activeTab) },attrs:{"role":"presentation"}},[_c('a',{directives:[{name:"t",rawName:"v-t",value:('legend'),expression:"'legend'"}],attrs:{"href":"#legend","aria-controls":"legend","role":"tab","data-toggle":"tab","data-i18n":"legend"}})]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"tab-content catalog-tab-content"},[_c('bar-loader',{attrs:{"loading":_vm.loading}}),_vm._v(" "),_c('div',{staticClass:"tab-pane",class:{ active: ('layers' === _vm.activeTab) },attrs:{"id":"layers","role":"tabpanel"}},[_c('div',{staticStyle:{"margin":"2px"},attrs:{"id":"g3w-catalog-toc-layers-toolbar"}},[_c('catalog-change-map-themes',{key:_vm.project.state.gid,attrs:{"map_themes":_vm.project.state.map_themes,"layerstrees":_vm.state.layerstrees},on:{"change-map-theme":_vm.changeMapTheme}})],1),_vm._v(" "),_vm._l((_vm.state.layerstrees),function(root){return _c('ul',{key:root.storeid,staticClass:"tree-root root project-root"},_vm._l((root.tree),function(tree){return _c('catalog-tristate-tree',{key:tree.id,staticClass:"item",attrs:{"layerstree":tree,"parentFolder":false,"root":true,"legendplace":_vm.legend_position,"parent_mutually_exclusive":false,"storeid":root.storeid}})}),1)}),_vm._v(" "),(_vm.state.external.vector.length)?_c('ul',{staticClass:"g3w-external_layers-group"},_vm._l((_vm.state.external.vector),function(vector){return _c('catalog-tristate-tree',{key:vector.id,staticClass:"item",attrs:{"externallayers":_vm.state.external.vector,"layerstree":vector}})}),1):_vm._e(),_vm._v(" "),_vm._l((_vm.state.layersgroups),function(group){return _c('ul',{staticClass:"g3w-catalog-layers-group"},[_c('div',[_c('h4',[_vm._v(_vm._s(group.title))]),_vm._v(" "),_vm._l((group.nodes),function(node){return _c('catalog-tristate-tree',{staticClass:"item",attrs:{"layerstree":node}})})],2)])})],2),_vm._v(" "),(_vm.state.external.wms.length)?_c('div',{staticClass:"tab-pane",class:{ active: ('externalwms' === _vm.activeTab) },attrs:{"id":"externalwms","role":"tabpanel"}},[_c('ul',{staticClass:"g3w-external_wms_layers-group"},_vm._l((_vm.state.external.wms),function(wms){return _c('catalog-tristate-tree',{key:wms.id,staticClass:"item",attrs:{"externallayers":_vm.state.external.wms,"layerstree":wms}})}),1)]):_vm._e(),_vm._v(" "),(_vm.hasBaseLayers)?_c('div',{staticClass:"tab-pane baselayers",class:{ active: ('baselayers' === _vm.activeTab || !_vm.hasLayers) },attrs:{"id":"baselayers","role":"tabpanel"}},[_c('ul',{class:{'mobile': _vm.isMobile()},style:({ gridTemplateColumns: ("repeat(auto-fill, minmax(" + (_vm.baselayers.length > 4 ? 80 : 120) + "px, 1fr))") }),attrs:{"id":"baselayers-content"}},[_vm._l((_vm.baselayers),function(base){return (!base.fixed)?_c('li',{key:base.title},[_c('img',{staticClass:"img-responsive img-thumbnail baselayer",style:({ opacity: _vm.currentBaseLayer === base.id ? 1 : 0.5, height: _vm.baselayers.length > 4 ? '108px' : null  }),attrs:{"src":_vm.getSrcBaseLayerImage(base)},on:{"click":function($event){$event.stopPropagation();return _vm.setBaseLayer(base.id)}}}),_vm._v(" "),_c('div',{staticClass:"baseselayer-text text-center g3w-long-text"},[_vm._v(_vm._s(base.title))])]):_vm._e()}),_vm._v(" "),_c('li',{on:{"click":function($event){$event.stopPropagation();return _vm.setBaseLayer(null)}}},[_c('img',{staticClass:"img-responsive img-thumbnail baselayer",style:({ opacity: _vm.currentBaseLayer === null ? 1 : 0.5 }),attrs:{"src":_vm.getSrcBaseLayerImage(null)}}),_vm._v(" "),_c('div',{directives:[{name:"t",rawName:"v-t",value:('nobaselayer'),expression:"'nobaselayer'"}],staticClass:"baseselayer-text text-center g3w-long-text"})])],2)]):_vm._e(),_vm._v(" "),_vm._l((_vm.state.layerstrees),function(tree){return ('tab' === _vm.legend_position && 'legend' === _vm.activeTab)?_c('div',{key:tree.id,staticClass:"tab-pane",class:{ active: 'legend' === _vm.activeTab },style:({ backgroundColor: _vm.backgroundLegend }),attrs:{"role":"tabpanel","id":"legend"}},_vm._l((tree.tree),function(t){return _c('div',{staticClass:"legend-item"},_vm._l((t.legendurls),function(url){return _c('figure',{key:url.url},[_c('bar-loader',{attrs:{"loading":url.loading}}),_vm._v(" "),_c('img',{directives:[{name:"show",rawName:"v-show",value:(!url.loading && !url.error),expression:"!url.loading && !url.error"}],attrs:{"src":url.url,"alt":""},on:{"error":function($event){return _vm.onLegendError(url)},"load":function($event){return _vm.onLegendLoad(url)}}}),_vm._v(" "),_c('divider')],1)}),0)}),0):_vm._e()})],2)]),_vm._v(" "),(_vm.hasRelatedMaps || 'legend' !== _vm.activeTab)?_c('div',{staticStyle:{"position":"sticky","bottom":"0","background-color":"#222d32","display":"flex","text-align":"center","line-height":"48px","color":"#fff","border-top":"2px solid var(--skin-color)","margin-top":"12px","justify-content":"space-around"}},[('legend' !== _vm.activeTab)?_c('a',{attrs:{"href":"#"},on:{"click":_vm.showaddLayerModal}},[_c('i',{class:_vm.$fa('layers')}),_vm._v(" "),_c('b',{directives:[{name:"t",rawName:"v-t",value:('mapcontrols.add_layer_control.header'),expression:"'mapcontrols.add_layer_control.header'"}]})]):_vm._e(),_vm._v(" "),(_vm.hasRelatedMaps && 'legend' !== _vm.activeTab && !_vm.iframe)?_c('a',{attrs:{"href":"#"},on:{"click":_vm.openChangeMapMenu}},[_c('i',{class:_vm.$fa('refresh')}),_vm._v(" "),_c('b',{directives:[{name:"t",rawName:"v-t",value:('changemap'),expression:"'changemap'"}]})]):_vm._e()]):_vm._e()])}
__vue__options__.staticRenderFns = []
__vue__options__._scopeId = "data-v-3f643805"

},{"components/CatalogChangeMapThemes.vue":72,"components/CatalogTristateTree.vue":75,"g3w-eventbus":160,"services/gui":207,"store/application":212,"utils/XHR":215,"utils/getCatalogLayerById":238,"vueify/lib/insert-css":35}],72:[function(require,module,exports){
var __vueify_style_dispose__ = require("vueify/lib/insert-css").insert("#g3w-catalog-toc-views[data-v-447134e1]{margin-bottom:5px;border-bottom:2px solid}.g3w-map-theme-anchor[data-v-447134e1]{padding:0;margin-bottom:5px}.g3w-map-theme-anchor>section[data-v-447134e1]{display:flex;flex-wrap:wrap;align-items:center;padding:5px}.add-map-theme[data-v-447134e1]{border-top:2px solid;margin:5px 0}.add-map-theme-input[data-v-447134e1]{width:100%}#g3w-catalog-views[data-v-447134e1]{display:none;padding:0}#g3w-catalog-views.menu-open[data-v-447134e1]{display:block}.current_map_theme[data-v-447134e1]{overflow:hidden;white-space:normal;text-overflow:ellipsis}.choose_map_theme[data-v-447134e1]{color:#ccc!important;font-weight:700}.project_map_theme[data-v-447134e1]{font-weight:700;padding:3px;border-bottom:1px solid #fff}.user_map_theme[data-v-447134e1]{font-weight:700;padding:5px 3px;display:flex;justify-content:space-between;align-self:baseline;border-bottom:1px solid #fff}")
;(function(){
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _InputText = require("./InputText.vue");

var _InputText2 = _interopRequireDefault(_InputText);

var _gui = require("services/gui");

var _gui2 = _interopRequireDefault(_gui);

var _application = require("store/application");

var _application2 = _interopRequireDefault(_application);

var _XHR = require("utils/XHR");

var _g3wI18n = require("g3w-i18n");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var LAYERSTREES_ATTRIBUTES = {
  node: ['id', 'name', 'visible', 'expanded'],
  group: ['name', 'checked', 'expanded', 'mutually-exclusive']
};

exports.default = {

  name: "changemapthemes",

  components: {
    InputText: _InputText2.default
  },

  props: {

    map_themes: {
      type: Object,
      default: { project: [], custom: [] }
    },

    layerstrees: {
      type: Array
    }

  },

  data: function data() {
    var theme = Object.values(this.map_themes).flat().find(function (mt) {
      return mt.default;
    });
    return {
      active_theme: theme && theme.theme || null,
      collapsed: 'collapsed' === _application2.default.project.state.toc_themes_init_status,

      custom_theme: {
        name: 'add-user-theme',
        label: 'sdk.catalog.choose_map_theme_input_label',
        i18nLabel: true,
        value: null,
        editable: true,
        type: 'varchar',
        input: { type: 'text', options: {} },
        visible: true,

        validate: {
          valid: false,
          required: true,
          error: 'sdk.catalog.invalid_map_theme_name'
        }
      },

      show_form: false
    };
  },


  methods: {
    toggle: function toggle() {
      if (!this.show_form) {
        document.getElementById('g3w-catalog-views').classList.toggle('menu-open');
        this.collapsed = !this.collapsed;
      }
    },
    _getMapThemeParams: function _getMapThemeParams() {
      var params = { layerstree: [], styles: {} };
      var treeItem = function treeItem(type, node) {
        return LAYERSTREES_ATTRIBUTES[type].reduce(function (acc, attr) {
          acc[attr] = node[attr];return acc;
        }, {});
      };
      var traverse = function traverse(nodes, tree) {
        nodes.forEach(function (node) {
          if (undefined !== node.id) {
            params.styles[node.id] = node.styles.find(function (s) {
              return s.current;
            }).name;
            tree.push(treeItem('node', node));
          }

          if (Array.isArray(node.nodes)) {
            var group = treeItem('group', node);
            group.nodes = [];
            tree.push(group);
            traverse(node.nodes, group.nodes);
          }
        });
      };

      traverse(this.layerstrees[0].tree[0].nodes, params.layerstree);

      return params;
    },
    saveTheme: function () {
      var _ref = _asyncToGenerator(function* () {
        var theme = this.custom_theme.value;

        if (!theme) {
          return;
        }
        try {
          var params = this._getMapThemeParams();
          var saved = yield _XHR.XHR.post({
            url: "" + _application2.default.project.urls.map_themes + encodeURIComponent(theme) + "/",
            contentType: 'application/json',
            data: JSON.stringify(params)
          });
          if (saved.result) {
            this.map_themes.custom.push({ theme: this.custom_theme.value, styles: params.styles });

            _gui2.default.showUserMessage({ type: 'success', message: 'sdk.catalog.saved_map_theme', autoclose: true });

            this.show_form = false;

            this.active_theme = this.custom_theme.value;

            yield this.$nextTick();

            this.custom_theme.value = null;
          }
        } catch (e) {
          console.warn(e);
        }
      });

      function saveTheme() {
        return _ref.apply(this, arguments);
      }

      return saveTheme;
    }(),
    updateTheme: function () {
      var _ref2 = _asyncToGenerator(function* (theme) {
        if (!theme) {
          return;
        }
        try {
          var params = this._getMapThemeParams();
          yield _XHR.XHR.post({
            url: "" + _application2.default.project.urls.map_themes + encodeURIComponent(theme) + "/",
            contentType: 'application/json',
            data: JSON.stringify(params)
          });

          var c_theme = this.map_themes.custom.find(function (mt) {
            return theme === mt.theme;
          });
          c_theme.styles = params.styles;
          c_theme.layerstree = params.layerstree;

          _gui2.default.showUserMessage({ type: 'success', message: 'sdk.catalog.updated_map_theme', autoclose: true });
        } catch (e) {
          console.warn(e);
        }
      });

      function updateTheme(_x) {
        return _ref2.apply(this, arguments);
      }

      return updateTheme;
    }(),
    deleteTheme: function deleteTheme(theme) {
      var _this = this;

      _gui2.default.dialog.confirm((0, _g3wI18n.t)('sdk.catalog.question_delete_map_theme'), function () {
        var _ref3 = _asyncToGenerator(function* (bool) {
          if (!bool || !theme) {
            return;
          }
          try {
            var deleted = yield _XHR.XHR.delete({ url: "" + _application2.default.project.urls.map_themes + encodeURIComponent(theme) + "/" });
            if (deleted.result) {
              _this.map_themes.custom = _this.map_themes.custom.filter(function (_ref4) {
                var t = _ref4.theme;
                return t !== theme;
              });

              _gui2.default.showUserMessage({ type: 'success', message: 'sdk.catalog.delete_map_theme', autoclose: true });

              if (theme === _this.active_theme) {
                _this.active_theme = null;
              }
            }
          } catch (e) {
            console.warn(e);
          }
        });

        return function (_x2) {
          return _ref3.apply(this, arguments);
        };
      }());
    }
  },

  watch: {

    'active_theme': {
      immediate: false,
      handler: function handler(map_theme) {
        if (null === map_theme || map_theme === this.custom_theme.value) {
          return;
        }
        this.$emit('change-map-theme', map_theme);
      }
    },

    'custom_theme.value': function custom_themeValue(name) {
      var _this2 = this;

      setTimeout(function () {
        _this2.custom_theme.validate.valid = name ? !_this2.map_themes.custom.find(function (_ref5) {
          var theme = _ref5.theme;
          return theme === name.trim();
        }) : false;
      }, 200);
    },
    show_form: function () {
      var _ref6 = _asyncToGenerator(function* (bool) {
        this.custom_theme.value = null;

        if (bool) {
          yield this.$nextTick();
          Array.from(this.$refs.add_map_theme_input.$el.children).forEach(function (child) {
            return child.classList.remove('col-sm-12');
          });
        }
      });

      function show_form(_x3) {
        return _ref6.apply(this, arguments);
      }

      return show_form;
    }()
  },

  created: function created() {
    this.logged = undefined !== _application2.default.user.id;
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"sidebar-menu"},[_c('li',{staticClass:"treeview sidebaritem skin-border-color",attrs:{"id":"g3w-catalog-toc-views"}},[_c('a',{staticClass:"g3w-map-theme-anchor",attrs:{"href":"#"}},[_c('section',{on:{"click":function($event){$event.stopPropagation();return _vm.toggle($event)}}},[_c('i',{class:_vm.$fa(_vm.collapsed ? 'caret-down' : 'caret-up'),staticStyle:{"padding":"3px"}}),_vm._v(" "),_c('i',{class:_vm.$fa(_vm.collapsed ? 'eye-close' : 'eye'),staticStyle:{"padding":"0 0 0 4px"}}),_vm._v(" "),(_vm.active_theme)?_c('span',{staticClass:"current_map_theme treeview-label g3w-long-text"},[_c('span',{directives:[{name:"t",rawName:"v-t:pre",value:('sdk.catalog.current_map_theme_prefix'),expression:"'sdk.catalog.current_map_theme_prefix'",arg:"pre"}],staticStyle:{"color":"#ccc !important"}},[_vm._v(":")]),_vm._v(" "),_c('span',{staticClass:"skin-color",staticStyle:{"font-size":"1.1em"}},[_vm._v(_vm._s(_vm.active_theme))])]):_c('div',{directives:[{name:"t",rawName:"v-t",value:('sdk.catalog.choose_map_theme'),expression:"'sdk.catalog.choose_map_theme'"}],staticClass:"choose_map_theme treeview-label"})])]),_vm._v(" "),(_vm.show_form)?_c('div',{staticClass:"add-map-theme skin-border-color"},[_c('div',{staticStyle:{"display":"flex","justify-content":"end","padding-top":"5px"}},[_c('span',{directives:[{name:"t-tooltip",rawName:"v-t-tooltip:left.create",value:('close'),expression:"'close'",arg:"left",modifiers:{"create":true}}],staticClass:"sidebar-button sidebar-button-icon",class:_vm.$fa('close'),staticStyle:{"padding":"2px","margin":"2px"},on:{"click":function($event){$event.stopPropagation();_vm.show_form = false}}})]),_vm._v(" "),_c('div',{staticClass:"container add-map-theme-input"},[_c('input-text',{ref:"add_map_theme_input",attrs:{"state":_vm.custom_theme}})],1),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"5px"}},[_c('button',{directives:[{name:"t",rawName:"v-t",value:('add'),expression:"'add'"},{name:"disabled",rawName:"v-disabled",value:(!_vm.custom_theme.validate.valid),expression:"!custom_theme.validate.valid"}],staticClass:"sidebar-button-run btn btn-block",on:{"click":function($event){$event.stopPropagation();return _vm.saveTheme($event)}}})])]):_c('ul',{class:{'menu-open': !_vm.collapsed},attrs:{"id":"g3w-catalog-views"}},[((_vm.map_themes.project || []).length > 0)?_c('li',{attrs:{"id":"g3w-catalog-views-project"}},[_c('ul',{staticStyle:{"padding":"0"}},[_c('li',[_c('div',{directives:[{name:"t",rawName:"v-t",value:('sdk.catalog.project_map_theme'),expression:"'sdk.catalog.project_map_theme'"}],staticClass:"project_map_theme"})]),_vm._v(" "),_c('li',{staticStyle:{"padding":"5px 5px 5px 17px"}},_vm._l((_vm.map_themes.project),function(map_theme,i){return _c('div',{key:map_theme.theme},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.active_theme),expression:"active_theme"}],staticClass:"magic-radio",attrs:{"type":"radio","name":"radio","id":("g3w-map_theme-" + i)},domProps:{"value":map_theme.theme,"checked":map_theme.default,"checked":_vm._q(_vm.active_theme,map_theme.theme)},on:{"change":function($event){_vm.active_theme=map_theme.theme}}}),_vm._v(" "),_c('label',{staticStyle:{"display":"flex","justify-content":"space-between"},attrs:{"for":("g3w-map_theme-" + i)}},[_c('span',{staticClass:"g3w-long-text"},[_vm._v(_vm._s(map_theme.theme))])])])}),0)])]):_vm._e(),_vm._v(" "),(_vm.logged)?_c('li',{attrs:{"id":"g3w-catalog-views-user"}},[_c('ul',{staticStyle:{"padding":"0"}},[_c('li',[_c('div',{staticClass:"user_map_theme"},[_c('span',{directives:[{name:"t",rawName:"v-t",value:('sdk.catalog.user_map_theme'),expression:"'sdk.catalog.user_map_theme'"}]}),_vm._v(" "),_c('span',{directives:[{name:"t-tooltip",rawName:"v-t-tooltip:left.create",value:('add'),expression:"'add'",arg:"left",modifiers:{"create":true}}],staticClass:"action sidebar-button sidebar-button-icon",class:_vm.$fa('plus'),staticStyle:{"margin-left":"auto","padding":"5px"},on:{"click":function($event){$event.stopPropagation();_vm.show_form = !_vm.show_form}}})])]),_vm._v(" "),_c('li',{staticStyle:{"padding":"5px 5px 5px 17px"}},_vm._l((_vm.map_themes.custom),function(map_theme,i){return _c('div',{key:map_theme.theme,staticStyle:{"display":"flex","justify-content":"space-between"}},[_c('span',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.active_theme),expression:"active_theme"}],staticClass:"magic-radio",attrs:{"type":"radio","name":"radio","id":("g3w-map_theme-" + i + "-user")},domProps:{"value":map_theme.theme,"checked":map_theme.default,"checked":_vm._q(_vm.active_theme,map_theme.theme)},on:{"change":function($event){_vm.active_theme=map_theme.theme}}}),_vm._v(" "),_c('label',{attrs:{"for":("g3w-map_theme-" + i + "-user")}},[_c('span',{staticClass:"g3w-long-text"},[_vm._v(_vm._s(map_theme.theme))])])]),_vm._v(" "),_c('span',{staticClass:"g3w-custom-map-theme-tools"},[_c('span',{directives:[{name:"t-tooltip",rawName:"v-t-tooltip:top.create",value:('update'),expression:"'update'",arg:"top",modifiers:{"create":true}},{name:"disabled",rawName:"v-disabled",value:(_vm.active_theme !== map_theme.theme),expression:"active_theme !== map_theme.theme"}],staticClass:"action sidebar-button sidebar-button-icon",staticStyle:{"padding":"5px"},on:{"click":function($event){$event.stopPropagation();return _vm.updateTheme(map_theme.theme)}}},[_c('i',{staticClass:"skin-color",class:_vm.$fa('save')})]),_vm._v(" "),_c('span',{directives:[{name:"t-tooltip",rawName:"v-t-tooltip:top.create",value:('cancel'),expression:"'cancel'",arg:"top",modifiers:{"create":true}}],staticClass:"action sidebar-button sidebar-button-icon",staticStyle:{"padding":"5px"},on:{"click":function($event){$event.stopPropagation();return _vm.deleteTheme(map_theme.theme)}}},[_c('i',{class:_vm.$fa('trash'),staticStyle:{"color":"red"}})])])])}),0)])]):_vm._e()])])])}
__vue__options__.staticRenderFns = []
__vue__options__._scopeId = "data-v-447134e1"

},{"./InputText.vue":111,"g3w-i18n":162,"services/gui":207,"store/application":212,"utils/XHR":215,"vueify/lib/insert-css":35}],73:[function(require,module,exports){
var __vueify_style_dispose__ = require("vueify/lib/insert-css").insert(".catalog-context-menu{background:#fafafa;border:1px solid #bdbdbd;border-radius:3px;display:block;list-style:none;margin:0;padding:0;position:fixed;min-width:150px;z-index:2;color:#000;outline:none;display:flex;flex-direction:column}.catalog-context-menu li ul{position:absolute;width:max-content;order:1;padding-left:0;background-color:#fff;color:#000}.catalog-context-menu li:not(:hover) ul{display:none}.catalog-context-menu li{border-bottom:1px solid #e0e0e0;margin:0;padding:8px 25px 8px 15px;display:flex;flex-direction:row}.catalog-context-menu li:not(.title){align-items:center}.catalog-context-menu li i{padding-right:3px;margin-right:6px;color:var(--skin-d20)!important}.catalog-context-menu li .click-to-copy{color:#000;opacity:1;margin-left:1ch;margin-right:-15px;margin-top:8px}.catalog-context-menu li .click-to-copy:hover{color:#fff!important;transform:scale(1.1)}.catalog-context-menu .click-to-copy .tooltip-inner{min-width:200px}.catalog-context-menu li.title{background:transparent!important;font-size:1.1em;font-weight:700;border-bottom-width:3px!important;flex-direction:column;max-width:250px;cursor:move!important;color:#000!important}.catalog-context-menu li:last-child{border-bottom:none}.catalog-context-menu li:hover{color:#fafafa;cursor:pointer}.catalog-context-menu li .layer-menu-metadata-info{background-color:#fff;color:#000;padding:5px;max-width:200px;white-space:normal;overflow-y:auto;max-height:150px}.catalog-context-menu .tooltip-inner{word-break:break-all;font-weight:700}.catalog-context-menu .item-text{margin-left:3px}.catalog-context-menu :is(ul,li){list-style-type:none}.catalog-context-menu li.inline-submenu{display:list-item;padding:0;text-indent:100%;line-height:0;overflow:hidden}.catalog-context-menu li.inline-submenu>*{display:none}.catalog-context-menu li.inline-submenu>ul{display:block;position:relative;left:0!important;width:100%;text-indent:0;line-height:normal}.catalog-context-menu li,.catalog-context-menu li.inline-submenu>ul>li{font-weight:700}.catalog-context-menu li li{font-weight:400}")
;(function(){
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vueColor = require('vue-color');

var _FileSaver = require('file-saver/dist/FileSaver');

var _FileSaver2 = _interopRequireDefault(_FileSaver);

var _g3wEventbus = require('g3w-eventbus');

var _application = require('store/application');

var _application2 = _interopRequireDefault(_application);

var _gui = require('services/gui');

var _gui2 = _interopRequireDefault(_gui);

var _downloadFile = require('utils/downloadFile');

var _getCatalogLayerById = require('utils/getCatalogLayerById');

var _g3wI18n = require('g3w-i18n');

var _shpWrite = require('@mapbox/shp-write');

var _shpWrite2 = _interopRequireDefault(_shpWrite);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function dragElement(menu) {
  var el = menu.querySelector('li.title');
  if (!el || menu._drag) {
    return;
  } else {
    menu._drag = true;
  }
  var x2 = 0,
      y2 = 0,
      x1 = 0,
      y1 = 0;
  el.addEventListener('mousedown', function (e) {
    if (['.select2-container', 'button', 'select', 'input', 'textarea'].some(function (i) {
      return e.target.closest(i);
    })) {
      return;
    }
    e.preventDefault();
    x1 = e.clientX;
    y1 = e.clientY;
    document.addEventListener('mouseup', mouseUp);
    document.addEventListener('mousemove', mouseMove);
  });
  function mouseUp() {
    document.removeEventListener('mouseup', mouseUp);
    document.removeEventListener('mousemove', mouseMove);
  }
  function mouseMove(e) {
    e.preventDefault();
    x2 = x1 - e.clientX;
    y2 = y1 - e.clientY;
    x1 = e.clientX;
    y1 = e.clientY;
    if (menu.style.marginLeft) {
      x2 -= parseInt(menu.style.marginLeft);menu.style.marginLeft = null;
    }
    if (menu.style.marginTop) {
      y2 -= parseInt(menu.style.marginTop);menu.style.marginTop = null;
    }
    menu.style.top = menu.offsetTop - y2 + "px";
    menu.style.left = menu.offsetLeft - x2 + "px";
  }
}

exports.default = {
  name: 'catalog-context-menu',

  props: {
    external: {
      type: Object
    }
  },

  data: function data() {
    return {
      ApplicationState: _application2.default,
      layer: null,
      layer_style: null,
      top: 0,
      left: 0,
      project_menu: false,
      layer_menu: false
    };
  },


  computed: {
    edit_url: function edit_url() {
      return _application2.default.project.getState().edit_url;
    },
    layers_url: function layers_url() {
      return _application2.default.project.getState().layers_url;
    }
  },

  components: {
    'chrome-picker': _vueColor.Chrome
  },

  directives: {
    'click-outside': {
      bind: function bind(el, binding, vnode) {
        this.event = function (e) {
          if (el === e.target || el.contains(e.target)) {
            return;
          }
          e.stopPropagation();
          vnode.context[binding.expression](e);
        };
        document.body.addEventListener('click', this.event, true);
      },
      unbind: function unbind() {
        document.body.removeEventListener('click', this.event, true);
      }
    }
  },

  methods: {
    onShowContextMenu: function () {
      var _ref = _asyncToGenerator(function* (e, layerstree) {
        this.closeMenu();
        yield this.$nextTick();
        this.left = e.x;
        var layer = !(layerstree || {}).nodes && layerstree;
        this.layer = layer || null;
        this.layer_menu = !!layer;
        this.project_menu = !layer;
        yield this.$nextTick();
        this.top = e.target.getBoundingClientRect().top - this.$refs['menu'].clientHeight + e.target.clientHeight / 2;
        $('.click-to-copy[data-toggle="tooltip"]').tooltip();

        [this.$refs.download_menu, this.$refs.ogc_menu].forEach(function (li) {
          return li && li.classList.toggle('inline-submenu', 1 === li.querySelector('ul').children.length);
        });
        dragElement(this.$refs.menu);
      });

      function onShowContextMenu(_x, _x2) {
        return _ref.apply(this, arguments);
      }

      return onShowContextMenu;
    }(),
    closeMenu: function closeMenu() {
      this.layer_menu = false;
      this.project_menu = false;
    },
    onChangeColor: function onChangeColor(val) {
      this.layer.color = val;
      this.$refs.layer_color.style.backgroundColor = val.hex;
      var layer = _gui2.default.getService('map').getLayerByName(this.layer.name || '');
      var style = layer.getStyle();
      style._g3w_options.color = val;
      layer.setStyle(style);
    },
    canShowWmsUrl: function canShowWmsUrl(layerId) {
      var layer = (0, _getCatalogLayerById.getCatalogLayerById)(layerId);
      return layer && !layer.isType('table') && !!layer.getFullWmsUrl();
    },
    canShowWfsUrl: function canShowWfsUrl(layerId) {
      var layer = (0, _getCatalogLayerById.getCatalogLayerById)(layerId);
      return layer && !layer.isType('table') && layer.isWfsActive();
    },
    canDownload: function canDownload(format, layerId) {
      var layer = (0, _getCatalogLayerById.getCatalogLayerById)(layerId);
      return layer && layer['is' + format + 'Downloadable']();
    },
    getWmsUrl: function getWmsUrl(layerId) {
      return (0, _getCatalogLayerById.getCatalogLayerById)(layerId).getCatalogWmsUrl();
    },
    getWfsUrl: function getWfsUrl(layerId) {
      return (0, _getCatalogLayerById.getCatalogLayerById)(layerId).getCatalogWfsUrl();
    },
    getWfs3Url: function getWfs3Url(layerId) {
      return (0, _getCatalogLayerById.getCatalogLayerById)(layerId).getCatalogWfs3Url();
    },
    copyUrl: function copyUrl(format, el) {
      var _this = this;

      var url = this['get' + format + 'Url'](this.layer.id);
      var a = document.createElement('a');
      var input = document.createElement('input');
      a.href = url;
      input.value = a.href;
      document.body.appendChild(input);
      input.select();
      document.execCommand("copy");
      $(el).attr('data-original-title', (0, _g3wI18n.t)('sdk.catalog.menu.wms.copied')).tooltip('show');
      $(el).attr('title', this.copywmsurltooltip).tooltip('fixTitle');
      input.remove();
      a.remove();
      setTimeout(function () {
        $('[data-toggle="tooltip"]').tooltip("destroy");
        _this.closeMenu();
      }, 600);
    },
    download: function () {
      var _ref2 = _asyncToGenerator(function* (format, layerId) {
        var map_extent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

        _application2.default.download = true;
        try {
          yield (0, _getCatalogLayerById.getCatalogLayerById)(layerId)['get' + format]({
            data: map_extent ? { map_extent: _gui2.default.getService('map').getMapExtent().toString() } : undefined
          });
        } catch (e) {
          _gui2.default.notify.error((0, _g3wI18n.t)("info.server_error"));
        }
        _application2.default.download = false;
        this.closeMenu();
      });

      function download(_x4, _x5) {
        return _ref2.apply(this, arguments);
      }

      return download;
    }(),
    downloadExternal: function downloadExternal(url) {
      _application2.default.download = true;
      (0, _downloadFile.downloadFile)({ url: url });
      _application2.default.download = false;
    },
    setLayerPosition: function setLayerPosition(position) {
      if (position !== this.layer.position) {
        this.layer.position = position;
        var map = _gui2.default.getService('map');
        map.getLayerById(this.layer.id).setZIndex({ top: map.layersCount, bottom: 0 }[position]);
        map.emit('change-layer-position-map', { id: this.layer.id, position: position });
        this.closeMenu();
      }
    },
    zoomToLayer: function zoomToLayer(layer) {
      try {
        _gui2.default.getService('map').goToBBox([layer.bbox.minx, layer.bbox.miny, layer.bbox.maxx, layer.bbox.maxy], layer.epsg);
      } catch (e) {
        console.warn(e);
        _gui2.default.showUserMessage({
          type: 'alert',
          message: '' + e.message,
          textMessage: true
        });
      }
      this.closeMenu();
    },
    canEdit: function canEdit(layer) {
      return layer ? !layer.external && (0, _getCatalogLayerById.getCatalogLayerById)(layer.id).isEditable() && (0, _getCatalogLayerById.getCatalogLayerById)(layer.id).config.editing.visible : g3wsdk.core.plugin.PluginsRegistry.getPlugin('editing');
    },
    startEditing: function startEditing(layer) {
      this.closeMenu();
      var editing = g3wsdk.core.plugin.PluginsRegistry.getPlugin('editing');
      editing.showPanel(layer ? { toolboxes: [layer.id] } : undefined);
      if (layer) {
        editing.startEditing(layer.id);
      }
    },
    canZoom: function canZoom(layer) {
      return layer.bbox && [layer.bbox.minx, layer.bbox.miny, layer.bbox.maxx, layer.bbox.maxy].find(function (coord) {
        return coord > 0;
      });
    },
    getGeometryType: function getGeometryType(layerId) {
      var external = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      var layer = external ? _gui2.default.getService('catalog').state.external.vector.find(function (l) {
        return l.id === layerId;
      }) : (0, _getCatalogLayerById.getCatalogLayerById)(layerId);
      if (layer) {
        var type = external ? layer.geometryType : layer.config.geometrytype;
        return layer && 'NoGeometry' !== type && type || '';
      }
      return '';
    },
    downloadExternalShapefile: function () {
      var _ref3 = _asyncToGenerator(function* (layer) {
        _application2.default.download = true;
        var features = _gui2.default.getService('map').getLayerByName(layer.name).getSource().getFeatures();
        var name = layer.name.split('.' + layer.type)[0];
        var blob = yield _shpWrite2.default.zip(new ol.format.GeoJSON().writeFeaturesObject(features, { dataProjection: layer.crs, featureProjection: _gui2.default.getService('map').getEpsg() || layer.crs }), {
          outputType: "blob",
          prj: layer.crs,
          folder: name,
          types: {
            point: name,
            mulipoint: name,
            polygon: name,
            multipolygon: name,
            line: name,
            polyline: name,
            multiline: name
          }
        });

        (0, _FileSaver2.default)(blob, name + '.zip');

        yield this.$nextTick();
        _application2.default.download = false;
        this.closeMenu();
      });

      function downloadExternalShapefile(_x7) {
        return _ref3.apply(this, arguments);
      }

      return downloadExternalShapefile;
    }(),
    showAttributeTable: function showAttributeTable(layerId) {
      (0, _getCatalogLayerById.getCatalogLayerById)(layerId).openAttributeTable();
      this.closeMenu();
    },
    showMetadata: function () {
      var _ref4 = _asyncToGenerator(function* (layerId) {
        this.closeMenu();
        $('#modal-metadata').modal('show');
        if (layerId) {
          setTimeout(function () {
            document.querySelector('#project-catalog [href="#metadata_layers"]').click();
            document.querySelector('#metadata_layers [data-target="#' + layerId + '"]').click();
          });
        }
      });

      function showMetadata(_x8) {
        return _ref4.apply(this, arguments);
      }

      return showMetadata;
    }(),
    setLayerStyle: function setLayerStyle(index) {
      var _this2 = this;

      var changed = false;
      this.layer.styles.forEach(function (style, i) {
        if (i === index) {
          _this2.layer_style = style.name;
          changed = !style.current;
          style.current = true;
        } else {
          style.current = false;
        }
      });
      var layer = changed && (0, _getCatalogLayerById.getCatalogLayerById)(this.layer.id);
      if (layer) {
        _g3wEventbus.VM.$emit('layer-change-style', { layerId: this.layer.id, style: this.layer_style });
        layer.change();
      }
      this.closeMenu();
    },
    setLayerFilter: function () {
      var _ref5 = _asyncToGenerator(function* (filter) {
        var changed = null === this.layer.filter.current || this.layer.filter.current.fid !== filter.fid;
        var layer = (0, _getCatalogLayerById.getCatalogLayerById)(this.layer.id);
        if (changed) {
          yield layer.applyFilter(filter);
        } else {
          yield layer.deleteFilterToken();
        }
        layer.change();
        this.closeMenu();
      });

      function setLayerFilter(_x9) {
        return _ref5.apply(this, arguments);
      }

      return setLayerFilter;
    }(),
    deleteFilter: function () {
      var _ref6 = _asyncToGenerator(function* (fid) {
        var layer = (0, _getCatalogLayerById.getCatalogLayerById)(this.layer.id);
        var change = fid === this.layer.fid;

        if (!layer) {
          return;
        }
        yield layer.deleteFilterToken(fid);
        if (change) {
          layer.change();
        }

        this.closeMenu();
      });

      function deleteFilter(_x10) {
        return _ref6.apply(this, arguments);
      }

      return deleteFilter;
    }(),
    showMenu: function () {
      var _ref7 = _asyncToGenerator(function* (e) {
        var li = e.target.closest('li');
        var ul = li && li.querySelector('ul');
        if (ul) {
          var overflowY = ul.offsetHeight + ul.getBoundingClientRect().top >= this.$refs['menu'].offsetHeight + this.$refs['menu'].getBoundingClientRect().top;
          ul.style.top = ul.offsetHeight > this.$refs['menu'].offsetHeight ? 0 : undefined;
          ul.style.left = this.$refs['menu'].offsetWidth - 2 + 'px';
          ul.style.maxHeight = this.$refs['menu'].offsetHeight + 'px';
          ul.style.bottom = overflowY ? 0 : undefined;
          ul.style.marginTop = overflowY ? undefined : '-5px';
          ul.style.overflowY = 'auto';
        }
      });

      function showMenu(_x11) {
        return _ref7.apply(this, arguments);
      }

      return showMenu;
    }(),
    canOpenAttributeTable: function canOpenAttributeTable(layer) {
      return layer.openattributetable;
    },
    isExternalLayer: function isExternalLayer(layer) {
      return !layer.projectLayer;
    },
    isExternalWMSLayer: function isExternalWMSLayer(layer) {
      return !layer.projectLayer && 'wms' === layer._type;
    },
    isExternalVectorLayer: function isExternalVectorLayer(layer) {
      return !layer.projectLayer && 'wms' !== layer._type;
    },
    canShowStylesMenu: function canShowStylesMenu(layer) {
      return layer.geolayer && layer.styles && layer.styles.length > 1;
    },
    canShowFiltersMenu: function canShowFiltersMenu(layer) {
      return layer.filters && layer.filters.length > 0;
    },
    hasMetadata: function hasMetadata(layer) {
      return layer.metadata;
    },
    canShowOpacityPicker: function canShowOpacityPicker(layer) {
      return layer.geolayer && layer.visible;
    },
    onLayerOpacity: function onLayerOpacity() {
      if (this.isExternalWMSLayer(this.layer)) {
        var layer = _gui2.default.getService('map').getLayerById(this.layer.id);
        if (layer) {
          layer.setOpacity(this.layer.opacity);
          _gui2.default.getService('map').emit('change-layer-opacity', { id: this.layer.id, opacity: this.layer.opacity });
        }
      } else {
        var _layer = (0, _getCatalogLayerById.getCatalogLayerById)(this.layer.id);
        if (_layer) {
          _g3wEventbus.VM.$emit('layer-change-opacity', { layerId: this.layer.id });
          _layer.change();
        }
      }
    }
  },

  created: function created() {
    var _this3 = this;

    _g3wEventbus.VM.$on('context-menu', this.onShowContextMenu);
    document.addEventListener('keyup', function (e) {
      return 'Escape' === e.key && _this3.closeMenu();
    });
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.layer_menu || _vm.project_menu)?_c('ul',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.closeMenu),expression:"closeMenu"}],ref:"menu",staticClass:"catalog-context-menu",style:({
    top:  _vm.top + 'px',
    left: _vm.left + 'px',
  }),attrs:{"id":"layer-context-menu","tabindex":"-1"},on:{"mouseover":_vm.showMenu}},[_c('li',{staticClass:"title"},[(_vm.project_menu)?_c('div',[_vm._v("G3W-ADMIN "+_vm._s(_vm.ApplicationState.project.getName()))]):_c('div',[_vm._v("\n      "+_vm._s(_vm.layer.title)+"\n      "),_c('div',{staticStyle:{"font-weight":"normal","font-size":"0.8em"}},[_vm._v("\n        "+_vm._s(_vm.getGeometryType(_vm.layer.id, _vm.layer.external))+"\n      ")])])]),_vm._v(" "),(_vm.project_menu || _vm.hasMetadata(_vm.layer))?_c('li',{on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.showMetadata(_vm.layer && _vm.layer.id)}}},[_c('i',{class:_vm.$fa('info')}),_vm._v(" "+_vm._s(_vm.$t('sdk.metadata.title'))+"\n    "),(_vm.layer && _vm.layer.metadata && _vm.layer.metadata.abstract)?_c('ul',{staticStyle:{"border-radius":"0 3px 3px 0"}},[_c('li',{staticClass:"layer-menu-metadata-info",domProps:{"innerHTML":_vm._s(_vm.layer.metadata.abstract)}})]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.canEdit(_vm.layer))?_c('li',{on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.startEditing(_vm.layer)}}},[_c('i',{class:_vm.$fa('pencil')}),_vm._v(" "+_vm._s(_vm.$t('catalog_items.contextmenu.edit'))+"\n  ")]):_vm._e(),_vm._v(" "),(_vm.layer_menu)?[(_vm.canZoom(_vm.layer))?_c('li',{on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.zoomToLayer(_vm.layer)}}},[_c('i',{class:_vm.$fa('search')}),_vm._v(" "+_vm._s(_vm.$t('catalog_items.contextmenu.zoomtolayer'))+"\n    ")]):_vm._e(),_vm._v(" "),(_vm.canOpenAttributeTable(_vm.layer))?_c('li',{on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.showAttributeTable(_vm.layer.id)}}},[_c('i',{class:_vm.$fa('list')}),_vm._v(" "+_vm._s(_vm.$t('catalog_items.contextmenu.open_attribute_table'))+"\n    ")]):_vm._e(),_vm._v(" "),(_vm.isExternalLayer(_vm.layer))?_c('li',[_c('i',{class:_vm.$fa('sort')}),_vm._v("\n      "+_vm._s(_vm.$t('layer_position.message'))+" ("+_vm._s(_vm.$t('layer_position.' + _vm.layer.position))+")\n      "),_c('i',{class:_vm.$fa('arrow-right'),staticStyle:{"position":"absolute","right":"0","margin-top":"3px"}}),_vm._v(" "),_c('ul',_vm._l((['top', 'bottom']),function(position){return _c('li',{staticStyle:{"display":"list-item"},on:{"click":function($event){return _vm.setLayerPosition(position)}}},[(position === _vm.layer.position)?_c('span',{class:_vm.$fa('circle'),staticStyle:{"font-size":"0.5em","margin-right":"3px"}}):_vm._e(),_vm._v(" "),_c('span',{directives:[{name:"t",rawName:"v-t",value:('layer_position.' + position),expression:"'layer_position.' + position"}]})])}),0)]):_vm._e(),_vm._v(" "),(_vm.canShowStylesMenu(_vm.layer))?_c('li',[_c('i',{class:_vm.$fa('palette')}),_vm._v("\n      "+_vm._s(_vm.$t('catalog_items.contextmenu.styles'))+" ("+_vm._s(_vm.layer.styles.find(function (s) { return s.current; }).name.toLowerCase())+")\n      "),_c('i',{class:_vm.$fa('arrow-right'),staticStyle:{"position":"absolute","right":"0","margin-top":"3px"}}),_vm._v(" "),_c('ul',_vm._l((_vm.layer.styles),function(style,i){return _c('li',{key:style.name,staticStyle:{"display":"list-item"},on:{"click":function($event){$event.stopPropagation();return _vm.setLayerStyle(i)}}},[(style.current)?_c('span',{class:_vm.$fa('circle'),staticStyle:{"font-size":"0.8em"}}):_vm._e(),_vm._v("\n          "+_vm._s(style.name + (_vm.layer.styles.length > 1 && style.name === _vm.layer.defaultstyle ? (" (" + (_vm.$t('default')) + ")") : ''))+"\n        ")])}),0)]):_vm._e(),_vm._v(" "),(_vm.canShowOpacityPicker(_vm.layer))?_c('li',[_c('i',{class:_vm.$fa('slider')}),_vm._v("\n      "+_vm._s(_vm.$t('catalog_items.contextmenu.layer_opacity'))+" ("+_vm._s((_vm.layer.opacity / 100))+")\n      "),_c('i',{class:_vm.$fa('arrow-right'),staticStyle:{"position":"absolute","right":"0","margin-top":"3px"}}),_vm._v(" "),_c('ul',[_c('li',{staticStyle:{"display":"list-item"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.layer.opacity),expression:"layer.opacity"}],attrs:{"type":"range","min":"0","max":"100","step":"1","list":"opacity-markers"},domProps:{"value":(_vm.layer.opacity)},on:{"change":_vm.onLayerOpacity,"__r":function($event){return _vm.$set(_vm.layer, "opacity", $event.target.value)}}}),_vm._v(" "),_vm._m(0)])])]):_vm._e(),_vm._v(" "),(_vm.isExternalWMSLayer(_vm.layer))?_c('li',[_c('i',{class:_vm.$fa('slider')}),_vm._v("\n      "+_vm._s(_vm.$t('catalog_items.contextmenu.layer_opacity'))+" ("+_vm._s(_vm.layer.opacity)+")\n      "),_c('span',{class:_vm.$fa('arrow-right'),staticStyle:{"position":"absolute","right":"0","margin-top":"3px"}}),_vm._v(" "),_c('ul',[_c('li',{staticStyle:{"display":"list-item"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.layer.opacity),expression:"layer.opacity"}],attrs:{"type":"range","min":"0","max":"1","step":"0.01","list":"opacity-markers"},domProps:{"value":(_vm.layer.opacity)},on:{"change":_vm.onLayerOpacity,"__r":function($event){return _vm.$set(_vm.layer, "opacity", $event.target.value)}}}),_vm._v(" "),_vm._m(1)])])]):_vm._e(),_vm._v(" "),(_vm.isExternalVectorLayer(_vm.layer))?_c('li',[_c('i',{class:_vm.$fa('tint')}),_vm._v("\n      "+_vm._s(_vm.$t('catalog_items.contextmenu.vector_color_menu'))+"\n      "),_c('i',{ref:"layer_color",staticStyle:{"width":"10px","height":"10px","border-radius":"10px","position":"absolute","right":"20px","margin-top":"4px"},style:({ backgroundColor: _vm.layer.color })}),_vm._v(" "),_c('i',{class:_vm.$fa('arrow-right'),staticStyle:{"position":"absolute","right":"0","margin-top":"3px"}}),_vm._v(" "),_c('ul',[_c('li',{staticStyle:{"padding":"14px","background-color":"#E0E0E0"}},[_c('chrome-picker',{ref:"color_picker",staticStyle:{"width":"100%"},on:{"click":function($event){$event.preventDefault();$event.stopPropagation();},"hook:beforeDestroy":function () { return _vm.$refs.color_picker.$off(); },"input":_vm.onChangeColor},model:{value:(_vm.layer.color),callback:function ($$v) {_vm.$set(_vm.layer, "color", $$v)},expression:"layer.color"}})],1)])]):_vm._e(),_vm._v(" "),(_vm.canShowFiltersMenu(_vm.layer))?_c('li',[_c('i',{class:_vm.$fa('filter')}),_vm._v("\n      "+_vm._s(_vm.$t('catalog_items.contextmenu.filters'))+"\n      "),_c('i',{class:_vm.$fa('arrow-right'),staticStyle:{"position":"absolute","right":"0","margin-top":"3px"}}),_vm._v(" "),_c('ul',_vm._l((_vm.layer.filters),function(filter){return _c('li',{key:filter.fid,staticStyle:{"display":"flex","justify-content":"space-between","align-items":"baseline"},on:{"click":function($event){$event.stopPropagation();return _vm.setLayerFilter(filter)}}},[(_vm.layer.filter.current && _vm.layer.filter.current.fid === filter.fid)?_c('span',{class:_vm.$fa('circle'),staticStyle:{"font-size":"0.5em","margin-right":"3px","justify-self":"flex-start"}}):_vm._e(),_vm._v(" "),_c('span',{staticStyle:{"margin-right":"5px"}},[_vm._v(_vm._s(filter.name))]),_vm._v(" "),_c('span',{staticClass:"skin-border-color",class:_vm.$fa('trash'),staticStyle:{"color":"red","right":"0","padding-left":"10px","border-left":"2px solid"},on:{"click":function($event){$event.stopPropagation();return _vm.deleteFilter(filter.fid)}}})])}),0)]):_vm._e(),_vm._v(" "),(_vm.canDownload('', _vm.layer.id) || _vm.isExternalVectorLayer(_vm.layer))?_c('li',{ref:"download_menu",attrs:{"disabled":_vm.ApplicationState.download}},[_c('i',{class:_vm.$fa('download')}),_vm._v("\n      "+_vm._s(_vm.$t('catalog_items.contextmenu.download'))+"\n      "),_c('i',{class:_vm.$fa('arrow-right'),staticStyle:{"position":"absolute","right":"0","margin-top":"3px"}}),_vm._v(" "),_c('bar-loader',{attrs:{"loading":_vm.ApplicationState.download}}),_vm._v(" "),_c('ul',[(_vm.canDownload('GeoTIFF', _vm.layer.id))?_c('li',{directives:[{name:"download",rawName:"v-download"}],on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.download('GeoTIFF', _vm.layer.id)}}},[_c('i',{class:_vm.$fa('geotiff')}),_vm._v(" "+_vm._s(_vm.$t('GeoTiff'))+"\n        ")]):_vm._e(),_vm._v(" "),(_vm.canDownload('GeoTIFF', _vm.layer.id))?_c('li',{directives:[{name:"download",rawName:"v-download"}],on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.download('GeoTIFF', _vm.layer.id, true)}}},[_c('i',{class:_vm.$fa('geotiff'),staticStyle:{"color":"#777"}}),_vm._v(" "),_c('i',{class:_vm.$fa('crop'),staticStyle:{"position":"absolute","left":"-7px","bottom":"8px","font-size":"1.2em"}}),_vm._v("\n          "+_vm._s(_vm.$t('sdk.catalog.menu.download.geotiff_map_extent'))+"\n        ")]):_vm._e(),_vm._v(" "),(_vm.canDownload('Shp', _vm.layer.id))?_c('li',{directives:[{name:"download",rawName:"v-download"}],on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.download('Shp', _vm.layer.id)}}},[_c('i',{class:_vm.$fa('shapefile')}),_vm._v(" "+_vm._s(_vm.$t('Shapefile'))+"\n        ")]):_vm._e(),_vm._v(" "),(_vm.canDownload('Gpx', _vm.layer.id))?_c('li',{directives:[{name:"download",rawName:"v-download"}],on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.download('Gpx', _vm.layer.id)}}},[_c('i',{class:_vm.$fa('gpx')}),_vm._v(" "+_vm._s(_vm.$t('GPX'))+"\n        ")]):_vm._e(),_vm._v(" "),(_vm.canDownload('Gpkg', _vm.layer.id))?_c('li',{directives:[{name:"download",rawName:"v-download"}],on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.download('Gpkg', _vm.layer.id)}}},[_c('i',{class:_vm.$fa('gpkg')}),_vm._v(" "+_vm._s(_vm.$t('GeoPackage'))+"\n        ")]):_vm._e(),_vm._v(" "),(_vm.canDownload('Csv', _vm.layer.id))?_c('li',{directives:[{name:"download",rawName:"v-download"}],on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.download('Csv', _vm.layer.id)}}},[_c('i',{class:_vm.$fa('csv')}),_vm._v(" "+_vm._s(_vm.$t('CSV'))+"\n        ")]):_vm._e(),_vm._v(" "),(_vm.canDownload('Xls', _vm.layer.id))?_c('li',{directives:[{name:"download",rawName:"v-download"}],on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.download('Xls', _vm.layer.id)}}},[_c('i',{class:_vm.$fa('xls')}),_vm._v(" "+_vm._s(_vm.$t('Excel'))+"\n        ")]):_vm._e(),_vm._v(" "),(_vm.isExternalVectorLayer(_vm.layer) && _vm.layer.downloadUrl)?_c('li',{directives:[{name:"download",rawName:"v-download"}],on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.downloadExternal(_vm.layer.downloadUrl)}}},[_c('i',{class:_vm.$fa('download')}),_vm._v(" "+_vm._s(_vm.$t('sdk.catalog.menu.download.unknow'))+"\n        ")]):_vm._e(),_vm._v(" "),(_vm.isExternalVectorLayer(_vm.layer) && !_vm.layer.downloadUrl)?_c('li',{directives:[{name:"download",rawName:"v-download"}],on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.downloadExternalShapefile(_vm.layer)}}},[_c('i',{class:_vm.$fa('shapefile')}),_vm._v(" "+_vm._s(_vm.$t('Shapefile'))+"\n        ")]):_vm._e()])],1):_vm._e(),_vm._v(" "),([
        this.canShowWmsUrl(this.layer.id),
        this.canShowWfsUrl(this.layer.id),
        this.canShowWfsUrl(this.layer.id)
      ].filter(Boolean).length)?_c('li',{ref:"ogc_menu"},[_c('i',{class:_vm.$fa('map')}),_vm._v(" "+_vm._s(_vm.$t('catalog_items.contextmenu.ogc_services'))+"\n      "),_c('i',{class:_vm.$fa('arrow-right'),staticStyle:{"position":"absolute","right":"0","margin-top":"3px"}}),_vm._v(" "),_c('ul',[(_vm.canShowWmsUrl(_vm.layer.id))?_c('li',{staticStyle:{"display":"flex","justify-content":"space-between","align-items":"baseline"},on:{"click":function($event){return _vm.copyUrl('Wms', $event.target)}}},[_c('a',{staticStyle:{"color":"#000"},attrs:{"href":_vm.getWmsUrl(_vm.layer.id),"target":"_blank"}},[_c('i',{class:_vm.$fa('map')}),_vm._v(" WMS\n          ")]),_vm._v(" "),_c('b',{staticClass:"click-to-copy skin-tooltip-top skin-color-dark",class:_vm.$fa('eye'),attrs:{"data-placement":"top","data-toggle":"tooltip","data-container":"body","title":_vm.getWmsUrl(_vm.layer.id)}})]):_vm._e(),_vm._v(" "),(_vm.canShowWfsUrl(_vm.layer.id))?_c('li',{staticStyle:{"display":"flex","justify-content":"space-between","align-items":"baseline"},on:{"click":function($event){return _vm.copyUrl('Wfs', $event.target)}}},[_c('a',{staticStyle:{"color":"#000"},attrs:{"href":_vm.getWfsUrl(_vm.layer.id),"target":"_blank"}},[_c('i',{class:_vm.$fa('map')}),_vm._v(" WFS\n          ")]),_vm._v(" "),_c('b',{staticClass:"click-to-copy skin-tooltip-top skin-color-dark",class:_vm.$fa('eye'),attrs:{"data-placement":"top","data-toggle":"tooltip","data-container":"body","title":_vm.getWfsUrl(_vm.layer.id)}})]):_vm._e(),_vm._v(" "),(_vm.canShowWfsUrl(_vm.layer.id))?_c('li',{staticStyle:{"display":"flex","justify-content":"space-between","align-items":"baseline"},on:{"click":function($event){return _vm.copyUrl('Wfs3', $event.target)}}},[_c('a',{staticStyle:{"color":"#000"},attrs:{"href":_vm.getWfs3Url(_vm.layer.id),"target":"_blank"}},[_c('i',{class:_vm.$fa('map')}),_vm._v(" WFS 3\n          ")]),_vm._v(" "),_c('b',{staticClass:"click-to-copy skin-tooltip-top skin-color-dark",class:_vm.$fa('eye'),attrs:{"data-placement":"top","data-toggle":"tooltip","data-container":"body","title":_vm.getWfs3Url(_vm.layer.id)}})]):_vm._e()])]):_vm._e()]:_vm._e(),_vm._v(" "),(_vm.layers_url && _vm.layer_menu && !_vm.isExternalLayer(_vm.layer))?_c('li',[_c('a',{staticStyle:{"color":"initial"},attrs:{"href":_vm.layers_url,"target":"_blank"}},[_c('i',[_c('svg',{staticStyle:{"height":"14px","vertical-align":"-1.5px","fill":"currentColor"},attrs:{"xmlns":"http://www.w3.org/2000/svg","xml:space":"preserve","viewBox":"0 0 32 32"}},[_c('path',{attrs:{"d":"m17.61 17.63 4.36-.02-4-3.98h-4.36v4l4 4.45z"}}),_vm._v(" "),_c('path',{attrs:{"d":"m31.61 27.22-7.62-7.6-4.38.01v4.33l7.24 7.67h4.76z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M18 25.18c-.68.16-1.17.2-1.9.2a9.77 9.77 0 0 1-9.68-9.88c0-5.57 4.4-9.78 9.68-9.78s9.48 4.2 9.48 9.78c0 .91-.15 1.96-.36 2.8l4.88 4.65a15 15 0 0 0 1.95-7.48C32.05 6.87 25.19.44 16 .44 6.86.44 0 6.84 0 15.47c0 8.68 6.86 15.2 16 15.2 2.36 0 4.23-.3 6.2-1.1L18 25.18z"}})])]),_vm._v("\n      Layers settings\n      "),_c('i',{class:_vm.$fa('external-link'),staticStyle:{"position":"absolute","right":"0","margin-top":"3px"}})])]):_vm._e(),_vm._v(" "),(_vm.edit_url && _vm.project_menu)?_c('li',[_c('a',{staticStyle:{"color":"initial"},attrs:{"href":_vm.edit_url,"target":"_blank"},on:{"click":function($event){$event.stopPropagation();return _vm.closeMenu($event)}}},[_c('i',[_c('svg',{staticStyle:{"height":"14px","vertical-align":"-1.5px","fill":"currentColor"},attrs:{"xmlns":"http://www.w3.org/2000/svg","xml:space":"preserve","viewBox":"0 0 32 32"}},[_c('path',{attrs:{"d":"m17.61 17.63 4.36-.02-4-3.98h-4.36v4l4 4.45z"}}),_vm._v(" "),_c('path',{attrs:{"d":"m31.61 27.22-7.62-7.6-4.38.01v4.33l7.24 7.67h4.76z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M18 25.18c-.68.16-1.17.2-1.9.2a9.77 9.77 0 0 1-9.68-9.88c0-5.57 4.4-9.78 9.68-9.78s9.48 4.2 9.48 9.78c0 .91-.15 1.96-.36 2.8l4.88 4.65a15 15 0 0 0 1.95-7.48C32.05 6.87 25.19.44 16 .44 6.86.44 0 6.84 0 15.47c0 8.68 6.86 15.2 16 15.2 2.36 0 4.23-.3 6.2-1.1L18 25.18z"}})])]),_vm._v("\n      Project settings\n      "),_c('i',{class:_vm.$fa('external-link'),staticStyle:{"position":"absolute","right":"0","margin-top":"3px"}})])]):_vm._e()],2):_vm._e()}
__vue__options__.staticRenderFns = [function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('datalist',{staticStyle:{"display":"flex","justify-content":"space-between"},attrs:{"id":"opacity-markers"}},[_c('option',{attrs:{"value":"0"}},[_vm._v("0")]),_vm._v(" "),_c('option',{attrs:{"value":"25"}},[_vm._v("0.25")]),_vm._v(" "),_c('option',{attrs:{"value":"50"}},[_vm._v("0.50")]),_vm._v(" "),_c('option',{attrs:{"value":"75"}},[_vm._v("0.75")]),_vm._v(" "),_c('option',{attrs:{"value":"100"}},[_vm._v("1")])])},function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('datalist',{staticStyle:{"display":"flex","justify-content":"space-between"},attrs:{"id":"opacity-markers"}},[_c('option',[_vm._v("0")]),_vm._v(" "),_c('option',[_vm._v("0.25")]),_vm._v(" "),_c('option',[_vm._v("0.50")]),_vm._v(" "),_c('option',[_vm._v("0.75")]),_vm._v(" "),_c('option',[_vm._v("1")])])}]

},{"@mapbox/shp-write":1,"file-saver/dist/FileSaver":18,"g3w-eventbus":160,"g3w-i18n":162,"services/gui":207,"store/application":212,"utils/downloadFile":235,"utils/getCatalogLayerById":238,"vue-color":31,"vueify/lib/insert-css":35}],74:[function(require,module,exports){
var __vueify_style_dispose__ = require("vueify/lib/insert-css").insert(".layer-legend[data-v-75b264a9]{padding-left:36px}")
;(function(){
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _gui = require('services/gui');

var _gui2 = _interopRequireDefault(_gui);

var _g3wEventbus = require('g3w-eventbus');

var _application = require('store/application');

var _application2 = _interopRequireDefault(_application);

var _click = require('mixins/click');

var _click2 = _interopRequireDefault(_click);

var _getCatalogLayerById = require('utils/getCatalogLayerById');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

exports.default = {
  name: "catalog-layer-legend",
  props: {
    legendplace: {
      type: String
    },
    layer: {
      type: Object
    }
  },
  data: function data() {
    return {
      loading: false,

      categories: [],

      currentstyle: this.layer.styles.find(function (style) {
        return true === style.current;
      }).name

    };
  },

  mixins: [_click2.default],
  computed: {
    showfeaturecount: function showfeaturecount() {
      return undefined !== this.layer.featurecount;
    },
    externallegend: function externallegend() {
      return 'wms' === this.layer.source.type;
    },
    legend: function legend() {
      return this.layer.legend;
    },
    show: function show() {
      return this.layer.expanded && this.layer.visible && ('toc' === this.legendplace || 'tab' === this.legendplace && this.layer.categories);
    }
  },

  methods: {
    onCategoryClick: function onCategoryClick() {
      this.handleClick({
        '1': function _() {
          console.info('TODO: select category (single click)');
        },
        '2': function _() {
          console.info('TODO: zoom to category (double click)');
        }
      }, this);
    },
    showCategoryMenu: function showCategoryMenu() {
      this.$emit('showmenucategory');
    },
    getWmsSourceLayerLegendUrl: function getWmsSourceLayerLegendUrl() {
      return this.getProjectLayer().getLegendUrl({
        width: 16,
        height: 16
      });
    },
    getProjectLayer: function getProjectLayer() {
      return (0, _getCatalogLayerById.getCatalogLayerById)(this.layer.id);
    },
    isDisabled: function isDisabled(index) {
      return this.categories[index].disabled;
    },
    showHideLayerCategory: function showHideLayerCategory(index) {
      this.categories[index].checked = !this.categories[index].checked;
      this.getProjectLayer().change();
      if ('tab' === this.legendplace) {
        this.layer.legend.change = true;
      } else if (this.categories[index].checked && this.mapReady) {
        this.setLayerCategories(false);
      }
    },
    setError: function setError() {
      this.legend.error = true;
      this.legend.loading = false;
    },
    urlLoaded: function () {
      var _ref = _asyncToGenerator(function* () {
        this.legend.loading = false;
      });

      function urlLoaded() {
        return _ref.apply(this, arguments);
      }

      return urlLoaded;
    }(),
    onChangeLayerLegendStyle: function () {
      var _ref2 = _asyncToGenerator(function* () {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        this.loading = true;

        if (this.externallegend) {
          return;
        }

        try {
          if (undefined !== options.style && options.layerId === this.layer.id) {
            yield this.setLayerCategories(true);
            yield this.getProjectLayer().getStyleFeatureCount(options.style);
            this.currentstyle = options.style;
            if (this.dynamic) {
              yield this.setLayerCategories(false);
            }
          }
        } catch (e) {
          console.warn('Error while changing layer style', e);
        }

        this.loading = false;
      });

      function onChangeLayerLegendStyle() {
        return _ref2.apply(this, arguments);
      }

      return onChangeLayerLegendStyle;
    }(),
    setLayerCategories: function () {
      var _ref3 = _asyncToGenerator(function* () {
        var all = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

        try {
          var projectLayer = this.getProjectLayer();
          var categories = projectLayer.getCategories();

          if (all && categories) {
            this.categories = categories;
          } else {
            var _ref4 = yield projectLayer.getLegendGraphic({ all: all }),
                _ref4$nodes = _ref4.nodes,
                nodes = _ref4$nodes === undefined ? [] : _ref4$nodes;

            if (all) {
              this._setAllLayerCategories(nodes);
            } else {
              this._updateLayerCategories(nodes, categories);
            }
          }
        } catch (err) {
          this.setError();
        }
      });

      function setLayerCategories() {
        return _ref3.apply(this, arguments);
      }

      return setLayerCategories;
    }(),
    _setAllLayerCategories: function _setAllLayerCategories(nodes) {
      var projectLayer = this.getProjectLayer();

      var categories = [];
      nodes.forEach(function (_ref5) {
        var icon = _ref5.icon,
            title = _ref5.title,
            ruleKey = _ref5.ruleKey,
            checked = _ref5.checked,
            _ref5$symbols = _ref5.symbols,
            symbols = _ref5$symbols === undefined ? [] : _ref5$symbols;

        if (icon) {
          categories.push({ icon: icon, title: title, ruleKey: ruleKey, checked: checked, disabled: false });
        } else {
          symbols.forEach(function (symbol) {
            symbol._checked = symbol.checked;
            symbol.disabled = false;
            categories.push(symbol);
          });
        }
      });
      projectLayer.setCategories(categories);
      this.categories = categories;
    },
    _updateLayerCategories: function _updateLayerCategories(nodes, categories) {
      var projectLayer = this.getProjectLayer();

      projectLayer.setCategories(categories);
      this.categories = categories;

      if (nodes.length) {
        nodes.forEach(function (_ref6) {
          var icon = _ref6.icon,
              title = _ref6.title,
              _ref6$symbols = _ref6.symbols,
              symbols = _ref6$symbols === undefined ? [] : _ref6$symbols;

          if (icon) {
            symbols = [{ icon: icon, title: title }];
          }
          categories.forEach(function (category) {
            var findSymbol = symbols.find(function (symbol) {
              return symbol.icon === category.icon && symbol.title === category.title;
            });
            var disabled = undefined !== category.checked ? category.checked : true;
            category.disabled = disabled && undefined === findSymbol;
          });
        });
      } else {
        categories.forEach(function (category) {
          return category.disabled = undefined !== category.checked ? category.checked : true;
        });
      }
    },
    onChangeMapLegendParams: function () {
      var _ref7 = _asyncToGenerator(function* () {
        this.mapReady = true;
        if (this.layer.visible && false === this.externallegend && ('toc' === this.legendplace || this.layer.categories)) {
          this.setLayerCategories(false);
        }
      });

      function onChangeMapLegendParams() {
        return _ref7.apply(this, arguments);
      }

      return onChangeMapLegendParams;
    }(),
    runInitLayerVisibleAction: function () {
      var _ref8 = _asyncToGenerator(function* () {
        yield this.setLayerCategories(true);
        if (this.dynamic) {
          yield this.setLayerCategories(false);
          _gui2.default.getService('map').on('change-map-legend-params', this.onChangeMapLegendParams);
        }
        this.initialize = true;
      });

      function runInitLayerVisibleAction() {
        return _ref8.apply(this, arguments);
      }

      return runInitLayerVisibleAction;
    }()
  },

  watch: {
    'layer.visible': function () {
      var _ref9 = _asyncToGenerator(function* (visible) {
        var enabled = visible && false === this.externallegend;

        if (enabled && false === this.initialize) {
          yield this.runInitLayerVisibleAction();
        }

        if (enabled && false !== this.initialize) {
          yield this.setLayerCategories(!this.dynamic);
        }
      });

      function layerVisible(_x3) {
        return _ref9.apply(this, arguments);
      }

      return layerVisible;
    }()
  },

  created: function () {
    var _ref10 = _asyncToGenerator(function* () {
      this.initialize = false;

      this.dynamic = _application2.default.project.state.context_base_legend;

      this.mapReady = false;

      _g3wEventbus.VM.$on('layer-change-style', this.onChangeLayerLegendStyle);

      if (false === this.externallegend && true === this.layer.visible) {
        yield this.runInitLayerVisibleAction();
      }
    });

    function created() {
      return _ref10.apply(this, arguments);
    }

    return created;
  }(),
  beforeDestroy: function beforeDestroy() {
    _g3wEventbus.VM.$off('layer-change-style', this.onChangeLayerLegendStyle);
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',{staticClass:"layer-legend",on:{"click":function($event){$event.stopPropagation();$event.preventDefault();}}},[(_vm.legend)?_c('bar-loader',{attrs:{"loading":_vm.legend.loading}}):_vm._e(),_vm._v(" "),(_vm.externallegend)?_c('figure',[_c('img',{attrs:{"src":_vm.getWmsSourceLayerLegendUrl()}})]):_c('figure',{directives:[{name:"disabled",rawName:"v-disabled",value:(_vm.loading),expression:"loading"}]},[_c('bar-loader',{attrs:{"loading":_vm.loading}}),_vm._v(" "),_vm._l((_vm.categories),function(category,index){return _c('div',{directives:[{name:"disabled",rawName:"v-disabled",value:(category.disabled),expression:"category.disabled"}],staticStyle:{"display":"flex","align-items":"center","width":"100%"},on:{"contextmenu":function($event){$event.preventDefault();$event.stopPropagation();return _vm.showCategoryMenu($event)}}},[(category.ruleKey)?_c('span',{class:_vm.$fa(category.checked ? 'check': 'uncheck'),staticStyle:{"padding-right":"3px"},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.showHideLayerCategory(index)}}}):_vm._e(),_vm._v(" "),(('toc' === _vm.legendplace))?_c('img',{attrs:{"src":category.icon && ("data:image/png;base64," + (category.icon))},on:{"error":function($event){return _vm.setError()},"load":function($event){return _vm.urlLoaded()}}}):_vm._e(),_vm._v(" "),(('tab' === _vm.legendplace && category.ruleKey) || ('toc' === _vm.legendplace))?_c('span',{staticClass:"g3w-long-text",staticStyle:{"padding-left":"3px"},on:{"click":function($event){$event.stopPropagation();return _vm.onCategoryClick($event)}}},[_c('span',[_vm._v(_vm._s(category.title))]),_vm._v(" "),(_vm.showfeaturecount && 'undefined' !== typeof category.ruleKey)?_c('span',{staticStyle:{"font-weight":"bold"}},[_vm._v("\n          ["+_vm._s(_vm.layer.stylesfeaturecount[_vm.currentstyle][category.ruleKey])+"]\n        ")]):_vm._e()]):_vm._e()])})],2)],1):_vm._e()}
__vue__options__.staticRenderFns = []
__vue__options__._scopeId = "data-v-75b264a9"

},{"g3w-eventbus":160,"mixins/click":196,"services/gui":207,"store/application":212,"utils/getCatalogLayerById":238,"vueify/lib/insert-css":35}],75:[function(require,module,exports){
;(function(){
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _g3wEventbus = require('g3w-eventbus');

var _application = require('store/application');

var _application2 = _interopRequireDefault(_application);

var _gui = require('services/gui');

var _gui2 = _interopRequireDefault(_gui);

var _click = require('mixins/click');

var _click2 = _interopRequireDefault(_click);

var _CatalogLayerLegend = require('components/CatalogLayerLegend.vue');

var _CatalogLayerLegend2 = _interopRequireDefault(_CatalogLayerLegend);

var _downloadFile = require('utils/downloadFile');

var _getCatalogLayerById = require('utils/getCatalogLayerById');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _setAllLayersVisible(layers) {
  layers.nodes.forEach(function (n) {
    if (undefined === n.id) {
      _setAllLayersVisible({ nodes: n.nodes, visible: layers.visible && n.checked });
    } else if (n.parentGroup.checked && n.checked) {
      (0, _getCatalogLayerById.getCatalogLayerById)(n.id).setVisible(layers.visible);
    }
  });
};

exports.default = {
  name: 'catalog-tristate-tree',

  props: ['layerstree', 'storeid', 'legend', 'legendplace', 'parent_mutually_exclusive', 'parentFolder', 'externallayers', 'root', 'parent'],

  components: {
    CatalogLayerLegend: _CatalogLayerLegend2.default
  },

  mixins: [_click2.default],

  data: function data() {
    return {
      expanded: this.layerstree.expanded,
      isGroupChecked: true,
      controltoggled: false,
      n_childs: null,
      filtered: false,
      logged: undefined !== _application2.default.user.id };
  },


  computed: {
    showfeaturecount: function showfeaturecount() {
      return undefined !== this.layerstree.featurecount;
    },
    showLegendLayer: function showLegendLayer() {
      return !this.layerstree.exclude_from_legend;
    },
    showLayerTocLegend: function showLayerTocLegend() {
      return !this.isGroup && this.showLegendLayer && this.layerstree.geolayer;
    },
    isGroup: function isGroup() {
      return !!this.layerstree.nodes;
    },
    legendlayerposition: function legendlayerposition() {
      return this.showLegendLayer && this.layerstree.legend ? this.legendplace : 'tab';
    },
    showscalevisibilityclass: function showscalevisibilityclass() {
      return !this.isGroup && this.layerstree.scalebasedvisibility;
    },
    showScaleVisibilityToolip: function showScaleVisibilityToolip() {
      return this.showscalevisibilityclass && this.layerstree.disabled && this.layerstree.checked;
    },
    isTable: function isTable() {
      return !this.isGroup && !this.layerstree.geolayer && !this.layerstree.external;
    },
    isHidden: function isHidden() {
      return this.layerstree.hidden && true === this.layerstree.hidden;
    },
    selected: function selected() {
      this.layerstree.selected = this.layerstree.disabled && this.layerstree.selected ? false : this.layerstree.selected;
    },
    isHighLight: function isHighLight() {
      var layer = (0, _getCatalogLayerById.getCatalogLayerById)(this.layerstree.id) || this.layerstree;
      return !this.isGroup && _application2.default.highlightlayers && layer && layer.isVisible() && layer.getTocHighlightable();
    },
    isInGrey: function isInGrey() {
      return !this.isGroup && !this.isTable && !this.layerstree.external && (!this.layerstree.visible || this.layerstree.disabled);
    },
    getFeatureCount: function getFeatureCount() {
      return Object.values(this.layerstree.featurecount).reduce(function (total, categoryFeatureCount) {
        return total + 1 * categoryFeatureCount;
      }, 0);
    }
  },

  watch: {
    'layerstree.checked': function layerstreeChecked() {
      if (this.isGroup) {
        this.handleGroupChecked(this.layerstree);
      } else {
        this.handleLayerChecked(this.layerstree);
      }
    }
  },

  methods: {
    removeCurrentFilter: function removeCurrentFilter() {
      return (0, _getCatalogLayerById.getCatalogLayerById)(this.layerstree.id).deleteFilterToken();
    },
    handleGroupChecked: function handleGroupChecked(group) {

      if (!group.checked) {
        group.nodes.forEach(function (n) {
          if (undefined === n.id) {
            _setAllLayersVisible({ nodes: n.nodes, visible: false });
          } else if (n.checked) {
            (0, _getCatalogLayerById.getCatalogLayerById)(n.id).setVisible(false);
          }
        });
        return;
      }

      var visible = group.parentGroup ? group.parentGroup.checked : true;
      var mutually_exclusive = group.parentGroup && group.parentGroup.mutually_exclusive;

      if (!mutually_exclusive) {
        _setAllLayersVisible({ nodes: group.nodes, visible: visible });
      }

      if (mutually_exclusive) {
        group.parentGroup.nodes.forEach(function (n) {
          n.checked = n.groupId === group.groupId;
          if (n.checked) {
            _setAllLayersVisible({ nodes: n.nodes, visible: visible });
          }
        });
      }

      var g = group.parentGroup;
      while (g) {
        g.checked = g.root || g.checked;
        g = g.parentGroup;
      }
    },
    handleLayerChecked: function handleLayerChecked(layer) {

      var map = _gui2.default.getService('map');

      if (!layer.projectLayer) {
        layer.visible = layer.checked;
        layer.setVisible(layer.checked);
        map.emit('change-layer-visibility', { id: layer.id, visible: layer.checked });
        return;
      }

      var qlayer = (0, _getCatalogLayerById.getCatalogLayerById)(layer.id);
      var checked = layer.checked;

      qlayer.setVisible(checked ? !layer.disabled : false);

      if (checked && layer.parentGroup.mutually_exclusive) {
        layer.parentGroup.nodes.forEach(function (n) {
          return n.checked = n.id === layer.id;
        });
      }

      var g = layer.parentGroup;
      while (checked && g) {
        g.checked = true;
        g = g.parentGroup;
      }

      _g3wEventbus.VM.$emit('treenodevisible', qlayer);
    },
    saveFilter: function saveFilter(layerstree) {
      (0, _getCatalogLayerById.getCatalogLayerById)(layerstree.id).saveFilter();
    },
    toggleFilterLayer: function toggleFilterLayer() {
      _g3wEventbus.VM.$emit('activefiltertokenlayer', this.storeid, this.layerstree);
    },
    clearSelection: function clearSelection() {
      _g3wEventbus.VM.$emit('unselectionlayer', this.storeid, this.layerstree);
    },
    toggle: function toggle() {
      this.layerstree.checked = !this.layerstree.checked;
    },
    expandCollapse: function expandCollapse() {
      this.layerstree.expanded = !this.layerstree.expanded;
    },
    select: function select() {
      if (undefined !== this.layerstree.selected && (!this.isGroup && !this.isTable || this.layerstree.external && false === this.layerstree.projectLayer)) {
        _g3wEventbus.VM.$emit('treenodeselected', this.layerstree);
      }
    },
    maybeZoomToLayer: function maybeZoomToLayer(layer) {
      if (this.canZoom(this.layerstree)) {
        _gui2.default.getService('map').goToBBox([layer.bbox.minx, layer.bbox.miny, layer.bbox.maxx, layer.bbox.maxy], layer.epsg);
      }
    },
    canZoom: function canZoom(layer) {
      return layer.bbox && [layer.bbox.minx, layer.bbox.miny, layer.bbox.maxx, layer.bbox.maxy].find(function (coordinate) {
        return coordinate > 0;
      });
    },
    onTreeItemClick: function onTreeItemClick() {
      var _this = this;

      this.handleClick({
        '1': function _() {
          return !_this.isTable && !_this.isGroup && _this.select();
        },
        '2': function _() {
          return !_this.isTable && _this.maybeZoomToLayer(_this.layerstree);
        }
      }, this);
    },
    triClass: function triClass() {
      return this.g3wtemplate.getFontClass(this.layerstree.checked ? 'check' : 'uncheck');
    },
    downloadExternalLayer: function downloadExternalLayer(download) {
      if (download.file) {
        (0, _downloadFile.downloadFile)(download.file);
      } else if (download.url) {}
    },
    removeExternalLayer: function removeExternalLayer(name) {
      _gui2.default.getService('map').removeExternalLayer(name);
    },
    showContextMenu: function showContextMenu(evt) {
      _g3wEventbus.VM.$emit('context-menu', evt, this.layerstree);
    }
  },

  created: function created() {
    if (this.isGroup && !this.layerstree.checked) {
      this.handleGroupChecked(this.layerstree);
    }
    if (this.isGroup && !this.root && this.parent_mutually_exclusive && !this.layerstree.mutually_exclusive) {
      this.layerstree.nodes.forEach(function (node) {
        node.id && (node.uncheckable = true);
      });
    }
  },
  mounted: function () {
    var _ref = _asyncToGenerator(function* () {
      yield this.$nextTick();
      $('span.scalevisibility, a.toggle-context-menu').tooltip();
    });

    function mounted() {
      return _ref.apply(this, arguments);
    }

    return mounted;
  }()
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isGroup || !_vm.layerstree.projectLayer || _vm.layerstree.toc)?_c('li',{staticClass:"tree-item",class:{
    selected:         !_vm.isGroup || !_vm.isTable ? _vm.layerstree.selected : false,
    itemmarginbottom: !_vm.isGroup,
    disabled:         _vm.isInGrey,
    group:            _vm.isGroup
  },style:({
    marginLeft: !_vm.isGroup ? '5px' : '0',
    position: 'relative',
  }),on:{"contextmenu":function($event){$event.preventDefault();$event.stopPropagation();return _vm.showContextMenu($event)},"click":function($event){$event.stopPropagation();return _vm.onTreeItemClick($event)}}},[(_vm.isGroup)?_c('span',{staticClass:"root collapse-expande-collapse-icon",class:[
      { bold : _vm.isGroup },
      _vm.g3wtemplate.getFontClass(_vm.layerstree.expanded ? 'caret-down' : 'caret-right')
    ],staticStyle:{"padding-right":"2px"},on:{"click":function($event){$event.stopPropagation();return _vm.expandCollapse($event)}}}):_vm._e(),_vm._v(" "),(_vm.isGroup)?_c('span',{class:[_vm.triClass()],staticStyle:{"color":"#ffffff"},on:{"click":function($event){$event.stopPropagation();return _vm.toggle()}}}):(_vm.isTable)?_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.layerstree.hidden),expression:"!layerstree.hidden"}],class:[
      _vm.parentFolder ? 'child' : 'root',
      _vm.g3wtemplate.getFontClass('table')
    ],staticStyle:{"padding-left":"18px"}}):[(_vm.layerstree.external && _vm.layerstree.removable)?_c('span',{class:_vm.g3wtemplate.getFontClass('trash'),staticStyle:{"color":"red","padding-left":"1px"},on:{"click":function($event){$event.stopPropagation();return _vm.removeExternalLayer(_vm.layerstree.name, _vm.layerstree._type)}}}):_vm._e(),_vm._v(" "),(_vm.layerstree.external && _vm.layerstree.download)?_c('span',{class:_vm.g3wtemplate.getFontClass('download'),staticStyle:{"color":"#ffffff","margin-left":"5px"},on:{"click":function($event){return _vm.downloadExternalLayer(_vm.layerstree.download)}}}):_vm._e(),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.layerstree.hidden),expression:"!layerstree.hidden"}],staticClass:"checkbox-layer",class:_vm.parentFolder ? 'child' : 'root'},[('toc' === _vm.legendlayerposition || !_vm.isGroup && _vm.layerstree.categories)?_c('span',{staticClass:"collapse-expande-collapse-icon",class:_vm.g3wtemplate.getFontClass(_vm.layerstree.visible && _vm.layerstree.expanded ? 'caret-down' : 'caret-right'),on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }$event.stopPropagation();return _vm.expandCollapse($event)}}}):_vm._e(),_vm._v(" "),_c('span',{class:[
          _vm.g3wtemplate.getFontClass(_vm.layerstree.checked ? 'check': 'uncheck'),
          { 'toc-added-external-layer': (!_vm.layerstree.legend && _vm.layerstree.external) }
        ],style:({
          paddingLeft: ('toc' === _vm.legendlayerposition)
            ? '5px'
            : !_vm.isGroup && _vm.layerstree.categories
              ? '5px'
              : (!_vm.layerstree.legend && _vm.layerstree.external)
                ? '1px'
                : '18px'
        }),on:{"click":function($event){$event.stopPropagation();return _vm.toggle()}}})])],_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.layerstree.hidden || _vm.isGroup),expression:"!layerstree.hidden || isGroup"}],staticClass:"tree-node-title",class:{
      disabled: !_vm.layerstree.external && (_vm.layerstree.disabled || (_vm.layerstree.id && !_vm.layerstree.visible)),
      bold: _vm.isGroup
    }},[_c('span',{directives:[{name:"t-tooltip",rawName:"v-t-tooltip.text",value:(_vm.showScaleVisibilityToolip ? ("minscale:" + (_vm.layerstree.minscale) + " - maxscale:" + (_vm.layerstree.maxscale)) : ''),expression:"showScaleVisibilityToolip ? `minscale:${layerstree.minscale} - maxscale:${layerstree.maxscale}` : ''",modifiers:{"text":true}}],staticClass:"skin-tooltip-top g3w-long-text",class:{
        highlightlayer:  _vm.isHighLight,
        scalevisibility: _vm.showscalevisibilityclass
      },attrs:{"data-placement":"top","current-tooltip":_vm.showScaleVisibilityToolip ? ("minscale:" + (_vm.layerstree.minscale) + " - maxscale: " + (_vm.layerstree.maxscale)) : ''}},[(!_vm.isGroup && !_vm.layerstree.external && null !== _vm.layerstree.filter.current)?_c('span',{directives:[{name:"t-tooltip",rawName:"v-t-tooltip:top.create.text",value:(_vm.layerstree.filter.current.name),expression:"layerstree.filter.current.name",arg:"top",modifiers:{"create":true,"text":true}}],staticStyle:{"cursor":"pointer"},attrs:{"current-tooltip":_vm.layerstree.filter.current.name},on:{"click":function($event){$event.stopPropagation();return _vm.removeCurrentFilter($event)}}},[_c('span',{class:_vm.g3wtemplate.getFontClass('filter'),staticStyle:{"color":"red"}})]):_vm._e(),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.layerstree.title))]),_vm._v(" "),(!_vm.isGroup && _vm.showfeaturecount)?_c('span',{staticStyle:{"font-weight":"bold"}},[_vm._v("\n        ["+_vm._s(_vm.getFeatureCount)+"]\n      ")]):_vm._e()]),_vm._v(" "),((!_vm.isGroup && _vm.layerstree.selection))?_c('div',[(_vm.layerstree.selection.active)?_c('span',{directives:[{name:"t-tooltip",rawName:"v-t-tooltip.create",value:('layer_selection_filter.tools.clear'),expression:"'layer_selection_filter.tools.clear'",modifiers:{"create":true}}],staticClass:"action-button skin-tooltip-left selection-filter-icon",class:_vm.g3wtemplate.getFontClass('clear'),attrs:{"data-placement":"left","data-toggle":"tooltip","data-container":"body"},on:{"click":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"caputure",undefined,$event.key,undefined)){ return null; }$event.preventDefault();$event.stopPropagation();return _vm.clearSelection($event)}}}):_vm._e(),_vm._v(" "),(!_vm.layerstree.external && (_vm.layerstree.selection.active || _vm.layerstree.filter.active) && !_vm.layerstree.filter.pagination)?_c('span',{directives:[{name:"t-tooltip",rawName:"v-t-tooltip.create",value:('layer_selection_filter.tools.filter'),expression:"'layer_selection_filter.tools.filter'",modifiers:{"create":true}}],staticClass:"action-button skin-tooltip-left selection-filter-icon",class:[
          _vm.g3wtemplate.getFontClass('filter'),
          _vm.layerstree.filter.active  ? 'active' : '' ],attrs:{"data-placement":"left","data-toggle":"tooltip","data-container":"body"},on:{"click":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"caputure",undefined,$event.key,undefined)){ return null; }$event.preventDefault();$event.stopPropagation();return _vm.toggleFilterLayer($event)}}}):_vm._e(),_vm._v(" "),(_vm.logged && !_vm.layerstree.external && (_vm.layerstree.selection.active && _vm.layerstree.filter.active))?_c('span',{directives:[{name:"t-tooltip",rawName:"v-t-tooltip.create",value:('layer_selection_filter.tools.savefilter'),expression:"'layer_selection_filter.tools.savefilter'",modifiers:{"create":true}}],staticClass:"action-button skin-tooltip-left selection-filter-icon",class:_vm.g3wtemplate.getFontClass('save'),attrs:{"data-placement":"left","data-toggle":"tooltip"},on:{"click":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"caputure",undefined,$event.key,undefined)){ return null; }$event.preventDefault();$event.stopPropagation();return _vm.saveFilter(_vm.layerstree)}}}):_vm._e()]):_vm._e()]),_vm._v(" "),(_vm.showLayerTocLegend)?_c('catalog-layer-legend',{attrs:{"legendplace":_vm.legendplace,"layer":_vm.layerstree}}):_vm._e(),_vm._v(" "),(_vm.isGroup)?_c('ul',{directives:[{name:"show",rawName:"v-show",value:(_vm.layerstree.expanded),expression:"layerstree.expanded"}],staticClass:"tree-content-items group",class:[("g3w-lendplace-" + _vm.legendplace)]},_vm._l((_vm.layerstree.nodes),function(_layerstree){return _c('span',{key:_layerstree.id || _layerstree.groupId},[_c('catalog-tristate-tree',{attrs:{"root":false,"legendConfig":_vm.legend,"legendplace":_vm.legendplace,"parentFolder":_vm.isGroup,"layerstree":_layerstree,"storeid":_vm.storeid,"parent":_vm.layerstree,"parent_mutually_exclusive":!!_vm.layerstree.mutually_exclusive}})],1)}),0):_vm._e(),_vm._v(" "),(!_vm.isGroup)?_c('a',{directives:[{name:"t-tooltip",rawName:"v-t-tooltip:left.create",value:('catalog_items.helptext'),expression:"'catalog_items.helptext'",arg:"left",modifiers:{"create":true}}],class:'toggle-context-menu ' + _vm.$fa('ellips-v'),attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.showContextMenu($event)}}}):_vm._e()],2):_vm._e()}
__vue__options__.staticRenderFns = []

},{"components/CatalogLayerLegend.vue":74,"g3w-eventbus":160,"mixins/click":196,"services/gui":207,"store/application":212,"utils/downloadFile":235,"utils/getCatalogLayerById":238}],76:[function(require,module,exports){
var __vueify_style_dispose__ = require("vueify/lib/insert-css").insert(".field[data-v-426a8566]{background-color:transparent!important;padding-top:3px;padding-bottom:3px;display:flex;align-items:center}.value[data-v-426a8566]{position:relative}.field div[data-v-426a8566]{padding-left:3px}.field_value button[data-v-426a8566]{margin-right:5px}.field_value[data-v-426a8566]{padding-left:0!important;padding-right:8px;text-align:right}")
;(function(){
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: "field",
  props: ['state']
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"field"},[(_vm.state.label)?_c('div',{staticClass:"col-sm-6  field_label"},[_vm._t("label",[_vm._v(_vm._s(_vm.state.label))])],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"field_value",class:[_vm.state.label ? 'col-sm-6' : null ]},[_vm._t("field",[_c('span',{staticStyle:{"word-wrap":"break-word"},domProps:{"innerHTML":_vm._s(_vm.state.value)}})])],2)])}
__vue__options__.staticRenderFns = []
__vue__options__._scopeId = "data-v-426a8566"

},{"vueify/lib/insert-css":35}],77:[function(require,module,exports){
;(function(){
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var fieldsService = require('gui/fields/fieldsservice');
var Fields = require('gui/fields/fields');

exports.default = {
  name: "g3w-field",
  props: {
    state: {
      required: true
    },
    feature: {
      type: Object
    }
  },
  components: _extends({}, Fields),
  created: function created() {
    this.type = fieldsService.getType(this.state);
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.type,{tag:"component",attrs:{"feature":_vm.feature,"state":_vm.state}})}
__vue__options__.staticRenderFns = []

},{"gui/fields/fields":37,"gui/fields/fieldsservice":38}],78:[function(require,module,exports){
var __vueify_style_dispose__ = require("vueify/lib/insert-css").insert(".show-hide-geo[data-v-11f1488a]{color:#3c8dbc;cursor:pointer;font-size:1.2em}")
;(function(){
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _mixins = require("mixins");

exports.default = {
  name: "g3w-geospatial",
  props: {
    data: {}
  },
  mixins: [_mixins.geoMixin],
  data: function data() {
    return {
      layerId: "table_layer_" + Date.now(),
      visible: false,
      id: "geo_table_" + Date.now()
    };
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"geo-content"},[_c('span',{staticClass:"show-hide-geo",class:[_vm.visible ? _vm.g3wtemplate.font['eye-close'] : _vm.g3wtemplate.font['eye']],on:{"click":function($event){$event.stopPropagation();return _vm.showLayer()}}})])}
__vue__options__.staticRenderFns = []
__vue__options__._scopeId = "data-v-11f1488a"

},{"mixins":200,"vueify/lib/insert-css":35}],79:[function(require,module,exports){
var __vueify_style_dispose__ = require("vueify/lib/insert-css").insert(".img-responsive[data-v-35cf1445]{cursor:pointer}.modal-content[data-v-35cf1445]{background:hsla(0,0%,100%,.6);border-radius:3px}.modal-dialog[data-v-35cf1445]{display:inline-block;text-align:left;vertical-align:middle}.modal[data-v-35cf1445]{text-align:center;padding:0!important}.modal[data-v-35cf1445]:before{content:\"\";display:inline-block;height:100%;vertical-align:middle;margin-right:-4px}.carousel .carousel-control span[data-v-35cf1445]{color:#3c8dbc}")
;(function(){
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue2Teleport = require('vue2-teleport');

var _vue2Teleport2 = _interopRequireDefault(_vue2Teleport);

var _Field = require('components/Field.vue');

var _Field2 = _interopRequireDefault(_Field);

var _toRawType = require('utils/toRawType');

var _getUniqueDomId = require('utils/getUniqueDomId');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

exports.default = {
  name: "field-image",

  props: ['state'],
  data: function data() {
    return {
      id: (0, _getUniqueDomId.getUniqueDomId)(),
      active: null,
      value: undefined !== this.state.value.mime_type ? this.state.value.value : this.state.value
    };
  },

  components: {
    Field: _Field2.default,
    Teleport: _vue2Teleport2.default
  },
  computed: {
    images: function images() {
      return [].concat(this.value).map(function (img) {
        return { src: (img || {}).photo || img };
      });
    }
  },
  methods: {
    showGallery: function () {
      var _ref = _asyncToGenerator(function* (index) {
        this.active = index;
        if ((0, _toRawType.toRawType)(this.value) === 'Object') {
          this.value.active = true;
        }
        $('#gallery_' + this.id).modal('show');
      });

      function showGallery(_x) {
        return _ref.apply(this, arguments);
      }

      return showGallery;
    }(),
    isRelativePath: function isRelativePath(url) {
      if (!url.startsWith('/') && !url.startsWith('http')) {
        return '' + window.initConfig.mediaurl + url;
      }
      return url;
    }
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('field',{attrs:{"state":_vm.state}},[_c('div',{staticStyle:{"text-align":"left","display":"inline-block"},attrs:{"slot":"field"},slot:"field"},[_vm._l((_vm.images),function(img,i){return _c('img',{staticClass:"img-responsive",staticStyle:{"max-height":"50px"},attrs:{"alt":"","src":img.src},on:{"click":function($event){$event.stopPropagation();return _vm.showGallery(i)}}})}),_vm._v(" "),_c('Teleport',{attrs:{"to":"body"}},[_c('div',{staticClass:"modal fade modal-fullscreen",attrs:{"id":("gallery_" + _vm.id),"tabindex":"-1","role":"dialog","aria-labelledby":"","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"carousel slide",attrs:{"id":("carousel_" + _vm.id),"data-interval":"false"}},[_c('div',{staticClass:"carousel-inner"},_vm._l((_vm.images),function(image,i){return _c('div',{staticClass:"item",class:_vm.active == i ? 'active' : ''},[_c('img',{staticStyle:{"margin":"auto"},attrs:{"src":_vm.isRelativePath(image.src),"alt":""}})])}),0),_vm._v(" "),(_vm.images.length > 1)?_c('a',{staticClass:"left carousel-control",attrs:{"href":("#carousel_" + _vm.id),"role":"button","data-slide":"prev"}},[_c('span',{class:_vm.$fa('arrow-left')})]):_vm._e(),_vm._v(" "),(_vm.images.length > 1)?_c('a',{staticClass:"right carousel-control",attrs:{"href":("#carousel_" + _vm.id),"role":"button","data-slide":"next"}},[_c('span',{class:_vm.$fa('arrow-right')})]):_vm._e()])])])])])])],2)])}
__vue__options__.staticRenderFns = []
__vue__options__._scopeId = "data-v-35cf1445"

},{"components/Field.vue":76,"utils/getUniqueDomId":252,"utils/toRawType":277,"vue2-teleport":34,"vueify/lib/insert-css":35}],80:[function(require,module,exports){
var __vueify_style_dispose__ = require("vueify/lib/insert-css").insert(".field_link[data-v-732e1500]{max-width:100%}")
;(function(){
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _Field = require('components/Field.vue');

var _Field2 = _interopRequireDefault(_Field);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: "field-link",

  props: ['state'],
  data: function data() {
    return {
      value: null
    };
  },

  components: {
    Field: _Field2.default
  },
  methods: {
    openLink: function openLink(link_url) {
      window.open(link_url, '_blank');
    }
  },
  created: function created() {
    this.value = this.state.value && _typeof(this.state.value) === 'object' ? this.state.value.value : this.state.value;
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('field',{attrs:{"state":_vm.state}},[_c('button',{directives:[{name:"t",rawName:"v-t",value:('info.link_button'),expression:"'info.link_button'"}],staticClass:"btn skin-button field_link",attrs:{"slot":"field","title":_vm.value},on:{"click":function($event){$event.stopPropagation();return _vm.openLink(_vm.value)}},slot:"field"})])}
__vue__options__.staticRenderFns = []
__vue__options__._scopeId = "data-v-732e1500"

},{"components/Field.vue":76,"vueify/lib/insert-css":35}],81:[function(require,module,exports){
;(function(){
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _mixins = require('mixins');

exports.default = {
  name: "g3w-media",
  mixins: [_mixins.mediaMixin],
  props: ['state'],
  computed: {
    type: function type() {
      return this.getMediaType(this.state.mime_type).type;
    },
    value: function value() {
      return this.state.value;
    }
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.value)?_c('div',{staticClass:"preview"},[_c('a',{attrs:{"href":_vm.value,"target":"_blank"}},[_c('div',{staticClass:"previewtype",class:_vm.type},[_c('i',{staticClass:"fa-2x",class:_vm.g3wtemplate.font[_vm.type]})])]),_vm._v(" "),_c('div',{staticClass:"filename"},[_vm._v(_vm._s(_vm.filename))]),_vm._v(" "),_vm._t("default")],2):_vm._e()}
__vue__options__.staticRenderFns = []
__vue__options__._scopeId = "data-v-2c892364"

},{"mixins":200}],82:[function(require,module,exports){
var __vueify_style_dispose__ = require("vueify/lib/insert-css").insert(".field_text_table[data-v-4368b933]{background-color:transparent!important}.field_text_table .field_label[data-v-4368b933]{font-weight:700}")
;(function(){
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Field = require('components/Field.vue');

var _Field2 = _interopRequireDefault(_Field);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: "field-text",

  props: ['state'],

  components: {
    Field: _Field2.default
  },

  created: function created() {}
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('field',{attrs:{"state":_vm.state}})}
__vue__options__.staticRenderFns = []
__vue__options__._scopeId = "data-v-4368b933"

},{"components/Field.vue":76,"vueify/lib/insert-css":35}],83:[function(require,module,exports){
;(function(){
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Field = require("components/Field.vue");

var _Field2 = _interopRequireDefault(_Field);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: "vuefield",
  props: {
    feature: {
      type: Object
    },
    state: {
      type: Object,
      default: {
        value: null,
        vueoptions: {
          component: {}
        }
      }
    }
  },
  components: {
    Field: _Field2.default
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('field',{attrs:{"state":_vm.state}},[_c('div',{attrs:{"slot":"field"},slot:"field"},[_c(_vm.state.vueoptions.component,{tag:"component",attrs:{"feature":_vm.feature,"value":_vm.state.value}})],1)])}
__vue__options__.staticRenderFns = []

},{"components/Field.vue":76}],84:[function(require,module,exports){
;(function(){
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _FormHeader = require('components/FormHeader.vue');

var _FormHeader2 = _interopRequireDefault(_FormHeader);

var _FormFooter = require('components/FormFooter.vue');

var _FormFooter2 = _interopRequireDefault(_FormFooter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

exports.default = {
  name: 'g3w-form',

  data: function data() {
    return {
      state: {},
      switchcomponent: false,
      body: {
        components: {
          before: [],
          after: []
        }
      }
    };
  },

  components: {
    g3wformheader: _FormHeader2.default,
    G3wFormFooter: _FormFooter2.default
  },
  transitions: { 'addremovetransition': 'showhide' },
  methods: {
    isRootComponent: function isRootComponent(component) {
      return this.$options.service.isRootComponent(component);
    },
    backToRoot: function backToRoot() {
      this.$options.service.setRootComponent();
    },
    handleRelation: function handleRelation(relationId) {
      this.$options.service.handleRelation(relationId);
    },
    disableComponent: function disableComponent(_ref) {
      var id = _ref.id,
          _ref$disabled = _ref.disabled,
          disabled = _ref$disabled === undefined ? false : _ref$disabled;

      this.$options.service.disableComponent({
        id: id,
        disabled: disabled
      });
    },
    resizeForm: function resizeForm(perc) {
      this.$options.service.setCurrentFormPercentage(perc);
    },
    switchComponent: function switchComponent(id) {
      this.switchcomponent = true;
      this.$options.service.setCurrentComponentById(id);
    },
    changeInput: function changeInput(input) {
      return this.$options.service.changeInput(input);
    },
    addToValidate: function addToValidate(input) {
      this.$options.service.addToValidate(input);
    },
    removeToValidate: function removeToValidate(input) {
      this.$options.service.removeToValidate(input);
    },
    reloadLayout: function reloadLayout() {
      var height = $(this.$el).height();
      if (!height) {
        return;
      };
      var footerDOM = $(this.$refs.g3w_form_footer.$el);
      var bodyFromDOM = $(this.$refs.g3wform_body);
      var footerHeight = footerDOM.height() ? footerDOM.height() + 50 : 50;
      var bodyHeight = height - ($(this.$refs.g3wformheader.$el).height() + footerHeight);
      bodyFromDOM.height(bodyHeight);
    }
  },
  updated: function () {
    var _ref2 = _asyncToGenerator(function* () {
      var _this = this;

      yield this.$nextTick();
      if (this.switchcomponent) {
        setTimeout(function () {
          return _this.switchcomponent = false;
        }, 0);
      }
    });

    function updated() {
      return _ref2.apply(this, arguments);
    }

    return updated;
  }(),
  created: function created() {
    var _this2 = this;

    this.$options.service.getEventBus().$on('set-main-component', function () {
      _this2.switchComponent(0);
    });
    this.$options.service.getEventBus().$on('component-validation', function (_ref3) {
      var id = _ref3.id,
          valid = _ref3.valid;

      _this2.$options.service.setValidComponent({ id: id, valid: valid });
    });
    this.$options.service.getEventBus().$on('addtovalidate', this.addToValidate);
    this.$options.service.getEventBus().$on('disable-component', this.disableComponent);
  },
  mounted: function mounted() {
    this.$options.service.isValid();
    this.$options.service.setReady(true);
  },
  beforeDestroy: function beforeDestroy() {
    this.$options.service.clearAll();
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"g3wform_content",staticStyle:{"position":"relative"}},[_c('bar-loader',{attrs:{"loading":_vm.state.loading}}),_vm._v(" "),_c('g3wformheader',{ref:"g3wformheader",attrs:{"currentid":_vm.state.currentheaderid,"headers":_vm.state.headers,"update":_vm.state.update,"valid":_vm.state.valid},on:{"resize-form":_vm.resizeForm,"clickheader":_vm.switchComponent}}),_vm._v(" "),_c('div',{ref:"g3wform_body",staticClass:"g3wform_body"},[_vm._l((_vm.body.components.before),function(component){return _c(component,{tag:"component",attrs:{"fields":_vm.state.fields}})}),_vm._v(" "),_c('keep-alive',[_c(_vm.state.component,{tag:"component",attrs:{"handleRelation":_vm.handleRelation,"state":_vm.state},on:{"hook:activated":_vm.reloadLayout,"addtovalidate":_vm.addToValidate,"removetovalidate":_vm.removeToValidate,"changeinput":_vm.changeInput}})],1),_vm._v(" "),_vm._l((_vm.body.components.after),function(component){return _c(component,{tag:"component",attrs:{"fields":_vm.state.fields}})})],2),_vm._v(" "),_c('g3w-form-footer',{ref:"g3w_form_footer",attrs:{"isRootComponent":_vm.isRootComponent,"backToRoot":_vm.backToRoot,"state":_vm.state}})],1)}
__vue__options__.staticRenderFns = []

},{"components/FormFooter.vue":86,"components/FormHeader.vue":87}],85:[function(require,module,exports){
;(function(){
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _InputG3WFormInputs = require('components/InputG3WFormInputs.vue');

var _InputG3WFormInputs2 = _interopRequireDefault(_InputG3WFormInputs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = Vue.extend({
  name: 'form-body',

  props: ['state', 'handleRelation'],
  data: function data() {
    return {
      show: true
    };
  },

  components: {
    G3wFormInputs: _InputG3WFormInputs2.default
  },
  methods: {
    addToValidate: function addToValidate(input) {
      this.$emit('addtovalidate', input);
    },
    removeToValidate: function removeToValidate(input) {
      this.$emit('removetovalidate', input);
    },
    changeInput: function changeInput(input) {
      this.$emit('changeinput', input);
    }
  },
  computed: {
    hasFormStructure: function hasFormStructure() {
      return !!this.state.formstructure;
    }
  }
});
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('form',{staticClass:"form-horizontal g3w-form"},[_c('div',{staticClass:"box-primary"},[_c('div',{staticClass:"box-body"},[(_vm.hasFormStructure)?[_c('tabs',{attrs:{"layerid":_vm.state.layerid,"feature":_vm.state.feature,"handleRelation":_vm.handleRelation,"contenttype":'editing',"addToValidate":_vm.addToValidate,"changeInput":_vm.changeInput,"removeToValidate":_vm.removeToValidate,"tabs":_vm.state.formstructure,"fields":_vm.state.fields}})]:[_c('g3w-form-inputs',{attrs:{"state":_vm.state,"addToValidate":_vm.addToValidate,"removeToValidate":_vm.removeToValidate,"changeInput":_vm.changeInput},on:{"changeinput":_vm.changeInput,"addinput":_vm.addToValidate,"removeinput":_vm.removeToValidate}})]],2)])])])}
__vue__options__.staticRenderFns = []

},{"components/InputG3WFormInputs.vue":102}],86:[function(require,module,exports){
;(function(){
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = Vue.extend({
  name: 'form-footer',

  props: {
    state: {
      type: Object
    },
    backToRoot: {
      type: Function,
      default: function _default() {}
    },
    isRootComponent: {
      type: Function
    }
  },
  data: function data() {
    this.originalbuttons = this.state.buttons.map(function (button) {
      return _extends({}, button);
    });
    return {
      id: "footer",
      active: true,
      show: true
    };
  },

  computed: {
    enableSave: function enableSave() {
      return this.state.valid && this.state.update;
    }
  },
  methods: {
    exec: function exec(cbk) {
      cbk instanceof Function ? cbk(this.state.fields) : function () {
        return this.state.fields;
      }();
    },
    btnEnabled: function btnEnabled(button) {
      var _button$enabled = button.enabled,
          enabled = _button$enabled === undefined ? true : _button$enabled,
          type = button.type;

      return enabled && (type !== 'save' || type === 'save' && this.enableSave);
    },
    isValid: function isValid() {
      return this.state.valid;
    }
  },
  watch: {
    'state.component': function stateComponent(component) {
      this.show = this.isRootComponent(component);
    },

    'state.update': {
      immediate: true,
      handler: function handler(value) {
        var _this = this;

        this.state.buttons.find(function (button, index) {
          if (button.eventButtons && button.eventButtons.update) {
            if (button.eventButtons.update[value]) {
              _this.state.buttons.splice(index, 1, _extends({}, button, button.eventButtons.update[value]));
            } else {
              _this.state.buttons.splice(index, 1, _this.originalbuttons[index]);
            }
          }
        });
      }
    }
  },
  activated: function activated() {
    this.active = true;
  },
  deactivated: function deactivated() {
    this.active = false;
  }
});
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group g3wform_footer"},[(_vm.show)?[_vm._t("default",[_c('div',{staticStyle:{"margin":"3px","font-weight":"bold"}},[_vm._v("\n        * "),_c('span',{directives:[{name:"t",rawName:"v-t",value:('sdk.form.footer.required_fields'),expression:"'sdk.form.footer.required_fields'"}]}),_vm._v(" "),(_vm.state.footer.message)?_c('div',{style:([_vm.state.footer.style])},[_vm._v("\n          "+_vm._s(_vm.state.footer.message)+"\n        ")]):_vm._e()]),_vm._v(" "),_vm._l((_vm.state.buttons),function(button){return _c('button',{directives:[{name:"disabled",rawName:"v-disabled",value:(!_vm.btnEnabled(button)),expression:"!btnEnabled(button)"},{name:"t",rawName:"v-t",value:(button.title),expression:"button.title"}],key:button.id,staticClass:"btn ",class:[button.class],attrs:{"update":_vm.state.update,"valid":_vm.state.valid},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.exec(button.cbk)}}})})])]:[_c('button',{directives:[{name:"t",rawName:"v-t",value:('back'),expression:"'back'"}],staticClass:"btn skin-button",on:{"click":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"prevet",undefined,$event.key,undefined)){ return null; }$event.stopPropagation();return _vm.backToRoot($event)}}})]],2)}
__vue__options__.staticRenderFns = []

},{}],87:[function(require,module,exports){
;(function(){
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Vue.extend({
  name: 'form-header',

  props: {
    headers: {
      type: Array,
      default: []
    },
    currentid: {
      type: String
    },
    update: {
      type: Boolean
    },
    valid: {
      type: Boolean
    }
  },
  methods: {
    click: function click(id) {
      if (id !== this.currentid && this.headers.length > 1) {
        this.$emit('clickheader', id);
      }
    },
    resizeForm: function resizeForm(perc) {
      this.$emit('resize-form', perc);
    }
  }
});
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"g3wform_header box-header with-border",staticStyle:{"display":"flex","flex-direction":"column"}},[_c('section',{staticClass:"g3wform_header_content"},_vm._l((_vm.headers),function(header){return _c('span',{key:header.id,staticClass:"title",class:[{item_selected: _vm.currentid === header.id && _vm.headers.length > 1},[_vm.headers.length > 1 ? 'tabs' : 'one' ]],staticStyle:{"display":"flex","justify-content":"space-between","align-items":"center"},style:({fontSize: _vm.isMobile() && '1em !important'}),on:{"click":function($event){$event.stopPropagation();return _vm.click(header.id)}}},[(header.icon)?_c('span',{staticStyle:{"margin-right":"5px"}},[_c('i',{class:header.icon})]):_vm._e(),_vm._v(" "),_c('span',{directives:[{name:"t",rawName:"v-t:pre",value:(header.title),expression:"header.title",arg:"pre"}],staticClass:"g3w-long-text"},[_vm._v(_vm._s(header.name))]),_vm._v(" "),_c(header.component,{tag:"component",attrs:{"valid":_vm.valid,"update":_vm.update}})],1)}),0)])}
__vue__options__.staticRenderFns = []

},{}],88:[function(require,module,exports){
;(function(){
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: "bar-loader",
  props: {
    loading: {
      type: Boolean | String,
      default: false
    },
    color: {
      type: String,
      default: '#FFFFFF'
    }
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loading)?_c('div',{staticClass:"bar-loader",staticStyle:{"border":"0"},style:({ backgroundColor: _vm.color })}):_vm._e()}
__vue__options__.staticRenderFns = []

},{}],89:[function(require,module,exports){
;(function(){
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _application = require('store/application');

var _application2 = _interopRequireDefault(_application);

var _getUniqueDomId = require('utils/getUniqueDomId');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

exports.default = {
  name: "datetime",
  props: {
    type: {
      type: String,
      default: 'date' },
    format: {
      type: String,
      default: 'YYYY-MM-DD'
    },
    minDate: {
      default: false
    },
    maxDate: {
      default: false
    },
    enabledDates: {
      default: false
    },
    value: {},
    label: {
      default: 'Date'
    }
  },
  data: function data() {
    return {
      datetimevalue: this.value
    };
  },

  methods: {
    changeInput: function changeInput(e) {},
    change: function change(value) {
      var date = moment(value).format(this.format);
      this.$emit('change', date);
    }
  },
  mounted: function () {
    var _ref = _asyncToGenerator(function* () {
      var _this = this;

      yield this.$nextTick();
      this.datetimeinputelement = $(this.$refs.iddatetimepicker);
      this.datetimeinputelement.datetimepicker({
        minDate: this.minDate,
        maxDate: this.maxDate,
        defaultDate: this.datetimevalue,
        useCurrent: false,
        allowInputToggle: true,
        enabledDates: this.enabledDates,
        showClose: true,
        format: this.format,
        locale: _application2.default.language,
        toolbarPlacement: 'top',
        widgetPositioning: { horizontal: 'right' }
      });
      this.datetimeinputelement.on("dp.change", function (_ref2) {
        var date = _ref2.date;

        _this.change(date);
      });
      this.datetimeinputelement.on("dp.hide", function (evt) {});
      if (_application2.default.ismobile) {
        setTimeout(function () {
          return datetimeinputelement.blur();
        });
      }
    });

    function mounted() {
      return _ref.apply(this, arguments);
    }

    return mounted;
  }(),

  watch: {
    value: function value(datetime) {
      this.datetimevalue = datetime;
      this.datetimeinputelement.data("DateTimePicker").date(datetime);
    },
    minDate: function () {
      var _ref3 = _asyncToGenerator(function* (mindatetime) {
        this.datetimeinputelement.data("DateTimePicker").minDate(mindatetime);
      });

      function minDate(_x) {
        return _ref3.apply(this, arguments);
      }

      return minDate;
    }(),
    maxDate: function () {
      var _ref4 = _asyncToGenerator(function* (maxdatetime) {
        this.datetimeinputelement.data("DateTimePicker").maxDate(maxdatetime);
      });

      function maxDate(_x2) {
        return _ref4.apply(this, arguments);
      }

      return maxDate;
    }(),
    enabledDates: function enabledDates(dates) {
      this.datetimeinputelement.data("DateTimePicker").enabledDates(dates);
    }
  },
  created: function created() {
    this.id = (0, _getUniqueDomId.getUniqueDomId)();
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"datimecontainer"},[_c('label',{directives:[{name:"t",rawName:"v-t",value:(_vm.label),expression:"label"}],staticStyle:{"display":"block"},attrs:{"for":_vm.id}}),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('div',{ref:"iddatetimepicker",staticClass:"input-group date"},[_c('input',{ref:"idinputdatetimepiker",staticClass:"form-control",attrs:{"id":_vm.id,"type":"text"},on:{"change":_vm.changeInput}}),_vm._v(" "),_c('span',{staticClass:"input-group-addon caret"},[_c('span',{staticClass:"datetimeinput",class:_vm.g3wtemplate.getFontClass('time' === _vm.type ? 'time': 'calendar')})])])])])}
__vue__options__.staticRenderFns = []
__vue__options__._scopeId = "data-v-af3670bc"

},{"store/application":212,"utils/getUniqueDomId":252}],90:[function(require,module,exports){
var __vueify_style_dispose__ = require("vueify/lib/insert-css").insert(".divider[data-v-4ee2673c]{display:block;position:relative;padding:0;margin-bottom:5px;height:0;width:100%;max-height:0;font-size:1px;line-height:0;clear:both;border:none;border-bottom:2px solid #eee}")
;(function(){
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: "divider"
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"divider"})}
__vue__options__.staticRenderFns = []
__vue__options__._scopeId = "data-v-4ee2673c"

},{"vueify/lib/insert-css":35}],91:[function(require,module,exports){
var __vueify_style_dispose__ = require("vueify/lib/insert-css").insert(".help_div_container[data-v-5c87e14e]{color:#fff;text-align:justify;position:relative;border-radius:3px;margin:5px 2px;white-space:pre-line;background-color:#384246!important}.help_icon[data-v-5c87e14e]{text-align:center;font-size:.7em;margin-top:-4px;margin-left:-4px;background-color:#222d32;font-weight:700;color:#fff;position:absolute;top:0;left:0;width:15px;height:15px;border:1px solid #fff;border-radius:50%}.g3w-help-message-content[data-v-5c87e14e]{max-height:200px;padding:10px;overflow-y:auto}")
;(function(){
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: "helpdiv",
  props: {
    message: {
      type: String,
      required: true
    },
    type: {
      type: String,
      default: 'info' }
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"help_div_container"},[_c('span',{staticClass:"help_icon"},[_vm._v("i")]),_vm._v(" "),_c('div',{directives:[{name:"t",rawName:"v-t",value:(_vm.message),expression:"message"}],staticClass:"g3w-help-message-content"})])}
__vue__options__.staticRenderFns = []
__vue__options__._scopeId = "data-v-5c87e14e"

},{"vueify/lib/insert-css":35}],92:[function(require,module,exports){
;(function(){
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: "progressbar",
  props: ['progress']
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return ((null !== _vm.progress && undefined !== _vm.progress))?_c('div',{staticStyle:{"margin":"5px 0 5px 0","width":"100%","backgroundColor":"#FFFFFF","border":"0","borderRadius":"3px"}},[_c('div',{staticClass:"skin-background-color",staticStyle:{"display":"flex","justifyContent":"center","fontWeight":"bold"},style:({ width: (_vm.progress < 10 ? 10 : _vm.progress) })},[_c('span',[_vm._v(_vm._s(_vm.progress))])])]):_vm._e()}
__vue__options__.staticRenderFns = []

},{}],93:[function(require,module,exports){
var __vueify_style_dispose__ = require("vueify/lib/insert-css").insert(".min-max-label[data-v-047658c6]{align-self:end;font-weight:700}")
;(function(){
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _debounce = require('utils/debounce');

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

exports.default = {
  name: "range",
  props: {
    id: {
      default: undefined
    },

    label: {
      type: String,
      default: ''
    },

    min: {
      type: Number,
      default: 0
    },

    max: {
      type: Number,
      default: 10
    },

    step: {
      type: Number,
      default: 1
    },

    labelValue: {},

    value: {
      default: 0
    },

    sync: {
      type: Boolean,
      default: false
    },

    showValue: {
      type: Boolean,
      default: false
    },

    unit: {
      type: String,
      default: ''
    }

  },
  data: function data() {
    return {
      state: { value: this.value }
    };
  },

  methods: {
    changeBackGround: function changeBackGround(value) {
      this.$refs['range-input'].style.backgroundSize = (value ? (value - this.min) * 100 / (this.max - this.min) : 0) + '% 100%';
    },
    setValue: function setValue(value) {
      this.changedValue(value);
    },
    change: function change(e) {
      this.changedValue(1 * e.target.value);
    },
    emitChangeValue: function emitChangeValue(value) {
      this.state.value = value;
      this.$emit('change-range', {
        id: this.id,
        value: value
      });
    }
  },
  watch: {
    'value': function value(_value) {
      this.state.value = _value;
    },
    'state.value': function stateValue(value) {
      this.changeBackGround(value);
      if (this.sync) {
        this.emitChangeValue(value);
      }
    }
  },
  created: function created() {
    var _this = this;

    this.changedValue = this.sync ? function () {
      return _this.$emit('changed');
    } : (0, _debounce.debounce)(function (value) {
      _this.emitChangeValue(value);
    });
  },
  mounted: function () {
    var _ref = _asyncToGenerator(function* () {
      yield this.$nextTick();
      this.changeBackGround(this.value);
    });

    function mounted() {
      return _ref.apply(this, arguments);
    }

    return mounted;
  }()
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',{staticStyle:{"display":"flex","justify-content":"space-between","font-weight":"bold"}},[_c('section',{staticStyle:{"align-self":"flex-end"}},[_c('span',{staticClass:"min-max-label"},[_vm._v(_vm._s(_vm.min))]),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold"}},[_vm._v(_vm._s(_vm.unit))])]),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","flex-direction":"column","margin":"0 3px"}},[_c('label',{directives:[{name:"t",rawName:"v-t",value:(_vm.label),expression:"label"}],staticClass:"skin-color",staticStyle:{"display":"block"},attrs:{"for":_vm.id}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.state.value),expression:"state.value"}],ref:"range-input",attrs:{"type":"range","id":_vm.id,"min":_vm.min,"max":_vm.max,"step":_vm.step},domProps:{"value":(_vm.state.value)},on:{"change":_vm.change,"__r":function($event){return _vm.$set(_vm.state, "value", $event.target.value)}}})]),_vm._v(" "),_c('section',{staticStyle:{"align-self":"flex-end"}},[_c('span',{staticClass:"min-max-label"},[_vm._v(_vm._s(_vm.max))]),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold"}},[_vm._v(_vm._s(_vm.unit))])])]),_vm._v(" "),(_vm.showValue)?[_c('span',[_vm._v(_vm._s(_vm.state.value))]),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold"}},[_vm._v(_vm._s(_vm.unit))])]:_vm._e()],2)}
__vue__options__.staticRenderFns = []
__vue__options__._scopeId = "data-v-047658c6"

},{"utils/debounce":232,"vueify/lib/insert-css":35}],94:[function(require,module,exports){
var __vueify_style_dispose__ = require("vueify/lib/insert-css").insert(".formquerytabs[data-v-ca141cf6]{overflow:hidden!important;display:flex;flex-wrap:wrap}.formquerytabs>li[data-v-ca141cf6]{flex:1;display:flex}.formquerytabs>li>a[data-v-ca141cf6]{font-weight:700;flex:1}.nav-tabs>li>a.mobile[data-v-ca141cf6]{padding:5px 10px}.tab_a[data-v-ca141cf6]{padding:5px;margin-right:0!important;border-bottom:0;margin-bottom:3px;border-radius:3px 3px 0 0}.formquerytabs li a.tab_a.group-title[data-v-ca141cf6]{color:inherit!important;font-weight:500;font-size:1em!important;padding:.25em;cursor:pointer}.tabs-wrapper>.formquerytabs li a.tab_a.group-title[data-v-ca141cf6]:before{content:\"▾\"}.tabs-wrapper.collapsed>.formquerytabs li a.tab_a.group-title[data-v-ca141cf6]:before{content:\"▸\"}.tabs-wrapper.collapsed>.formquerytabs+.tab-content[data-v-ca141cf6]{display:none}")
;(function(){
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _data = require('services/data');

var _data2 = _interopRequireDefault(_data);

var _GlobalTabsNode = require('components/GlobalTabsNode.vue');

var _GlobalTabsNode2 = _interopRequireDefault(_GlobalTabsNode);

var _gui = require('services/gui');

var _gui2 = _interopRequireDefault(_gui);

var _getFormDataExpressionRequestFromFeature = require('utils/getFormDataExpressionRequestFromFeature');

var _convertFeatureToGEOJSON = require('utils/convertFeatureToGEOJSON');

var _getUniqueDomId = require('utils/getUniqueDomId');

var _noop = require('utils/noop');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

exports.default = {
  name: "tabs",
  props: {
    group: {
      type: Boolean,
      default: false
    },
    contenttype: {
      default: 'query' },
    layerid: {
      required: true
    },
    tabs: {
      required: true
    },
    feature: {
      required: true
    },
    fields: {
      required: true
    },
    addToValidate: {
      type: Function,
      default: _noop.noop
    },
    removeToValidate: {
      type: Function,
      default: _noop.noop
    },
    changeInput: {
      type: Function,
      default: _noop.noop
    },
    showRelationByField: {
      type: Boolean,
      default: true
    },
    handleRelation: {
      type: Function,
      default: function _default() {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            relation = _ref.relation,
            layerId = _ref.layerId,
            feature = _ref.feature;

        return _gui2.default.getService('queryresults').showRelation({ relation: relation, layerId: layerId, feature: feature });
      }
    }
  },
  data: function data() {
    return {
      ids: []
    };
  },

  computed: {
    required_fields: function required_fields() {
      return 'editing' === this.contenttype && this.fields.filter(function (f) {
        return f.validate.required;
      }).map(function (f) {
        return f.name;
      });
    },
    show: function show() {
      return this.tabs.reduce(function (a, t) {
        return a || t.visible === undefined || !!t.visible;
      }, false);
    }
  },
  methods: {
    setVisibility: function () {
      var _ref2 = _asyncToGenerator(function* (tab) {
        tab.visible = yield _data2.default.getData('expression:expression_eval', {
          inputs: {
            qgs_layer_id: this.layerid,
            form_data: ('editing' === this.contenttype ? _convertFeatureToGEOJSON.convertFeatureToGEOJSON : _getFormDataExpressionRequestFromFeature.getFormDataExpressionRequestFromFeature)(this.feature || {}),
            expression: tab.visibility_expression.expression,
            formatter: 'query' === this.contenttype ? 1 : 0
          },
          outputs: false
        });
      });

      function setVisibility(_x2) {
        return _ref2.apply(this, arguments);
      }

      return setVisibility;
    }(),
    setEditingRequireTab: function setEditingRequireTab(obj) {
      var _this = this;

      if (undefined === obj.nodes) {
        return this.required_fields.includes(obj.field_name);
      } else {
        return !!obj.nodes.find(function (n) {
          return _this.setEditingRequireTab(n);
        });
      }
    },
    getField: function getField(fieldName) {
      return this.fields.find(function (f) {
        return fieldName === f.name;
      });
    },
    toggleGroup: function toggleGroup(e) {
      var wrapper = e.target.closest('.tabs-wrapper');
      wrapper.classList.toggle('collapsed');
    }
  },
  components: {
    Node: _GlobalTabsNode2.default
  },
  created: function () {
    var _ref3 = _asyncToGenerator(function* () {
      var _this2 = this;

      this.unwatch = [];
      this.tabs.forEach(function () {
        var _ref4 = _asyncToGenerator(function* (tab, i) {
          if (tab.visibility_expression) {
            if (undefined === tab.visible) {
              _this2.$set(tab, 'visible', 0);
            }
            yield _this2.setVisibility(tab);
          }
          if ('editing' === _this2.contenttype) {
            if (undefined === tab.required) {
              tab.required = _this2.setEditingRequireTab(tab);
            }
            if (tab.visibility_expression) {
              tab.visibility_expression.referenced_columns.forEach(function (c) {
                var field = _this2.fields.find(function (f) {
                  return c === f.name;
                });
                _this2.unwatch.push(_this2.$watch(function () {
                  return field.value;
                }, _asyncToGenerator(function* () {
                  yield _this2.$nextTick();
                  yield _this2.setVisibility(tab);
                })));
              });
            }
          }
          _this2.ids.push('tab_' + (0, _getUniqueDomId.getUniqueDomId)());
        });

        return function (_x3, _x4) {
          return _ref4.apply(this, arguments);
        };
      }());

      this.root_tabs = [];
      if (!this.group) {
        var nodes = [];
        this.tabs.forEach(function (tab_node) {
          if (tab_node.nodes) {
            nodes.push(tab_node);
          } else {
            if (nodes.length) {
              _this2.root_tabs.push([].concat(nodes));
              nodes.splice(0);
            }
            _this2.root_tabs.push({ nodes: [tab_node] });
          }
        });
        if (nodes.length) {
          this.root_tabs.push(nodes);
        }
      } else {
        this.root_tabs = [this.tabs];
      }
    });

    function created() {
      return _ref3.apply(this, arguments);
    }

    return created;
  }(),
  beforeDestroy: function beforeDestroy() {
    this.unwatch.forEach(function (unwatch) {
      return unwatch();
    });
    this.unwatch = null;
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',{staticClass:"tabs-wrapper"},[_vm._l((_vm.root_tabs),function(root_tab,i){return [(Array.isArray(root_tab))?[_c('ul',{staticClass:"formquerytabs nav nav-tabs"},[_vm._l((root_tab),function(tab,index){return [(tab.visible === undefined || tab.visible)?_c('li',{class:{active: index === 0}},[_c('a',{staticClass:"tab_a",class:{'mobile': _vm.isMobile(), 'group-title': _vm.group},style:({fontSize: _vm.isMobile() ? '1.0em': ((_vm.group ? '1.1': '1.2') + "em")}),attrs:{"data-toggle":"tab","href":("#" + (_vm.ids[index]))},on:{"click":function($event){_vm.group && _vm.toggleGroup($event)}}},[_vm._v("\n               "+_vm._s(tab.name)+" "),(_vm.contenttype === 'editing' && tab.required)?_c('span',{staticStyle:{"padding-left":"3px","font-size":"1.1em"}},[_vm._v("*")]):_vm._e()])]):_vm._e()]})],2),_vm._v(" "),_c('div',{staticClass:"tab-content",class:{editing: 'editing' === _vm.contenttype }},[_vm._l((root_tab),function(tab,index){return [(undefined === tab.visible || tab.visible)?_c('div',{staticClass:"tab-pane fade",class:{'in active': index === 0},attrs:{"id":_vm.ids[index]}},[_c('node',{attrs:{"showRelationByField":_vm.showRelationByField,"handleRelation":_vm.handleRelation,"feature":_vm.feature,"layerid":_vm.layerid,"contenttype":_vm.contenttype,"addToValidate":_vm.addToValidate,"removeToValidate":_vm.removeToValidate,"changeInput":_vm.changeInput,"fields":_vm.fields,"showTitle":false,"node":tab}})],1):_vm._e()]})],2)]:_c('node',{class:[(i % 2 ) ? 'odd': 'even'],attrs:{"showRelationByField":_vm.showRelationByField,"handleRelation":_vm.handleRelation,"feature":_vm.feature,"layerid":_vm.layerid,"contenttype":_vm.contenttype,"addToValidate":_vm.addToValidate,"removeToValidate":_vm.removeToValidate,"changeInput":_vm.changeInput,"fields":_vm.fields,"showTitle":false,"node":root_tab}})]})],2):_vm._e()}
__vue__options__.staticRenderFns = []
__vue__options__._scopeId = "data-v-ca141cf6"

},{"components/GlobalTabsNode.vue":95,"services/data":206,"services/gui":207,"utils/convertFeatureToGEOJSON":220,"utils/getFormDataExpressionRequestFromFeature":243,"utils/getUniqueDomId":252,"utils/noop":262,"vueify/lib/insert-css":35}],95:[function(require,module,exports){
var __vueify_style_dispose__ = require("vueify/lib/insert-css").insert(".tab-node[data-v-5e5417b2]{min-width:0;overflow:hidden}.tab-node.odd[data-v-5e5417b2]{background-color:var(--skin-f10)}.title[data-v-5e5417b2]{font-weight:700;width:100%;color:#fff;padding:3px;margin-top:5px;margin-bottom:5px;border-radius:2px}.node-row[data-v-5e5417b2]{margin-bottom:0;column-gap:2px;margin-top:0;display:grid;grid-auto-columns:minmax(0,1fr);grid-auto-flow:column}.row.mobile[data-v-5e5417b2]{margin-bottom:0!important}")
;(function(){
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _InputG3W = require('components/InputG3W.vue');

var _InputG3W2 = _interopRequireDefault(_InputG3W);

var _application = require('store/application');

var _application2 = _interopRequireDefault(_application);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Fields = require('gui/fields/fields');

exports.default = {
  name: "node",
  props: ['contenttype', 'node', 'fields', 'showTitle', 'addToValidate', 'removeToValidate', 'changeInput', 'layerid', 'feature', 'showRelationByField', 'handleRelation'],
  components: _extends({
    G3wInput: _InputG3W2.default
  }, Fields),
  data: function data() {
    return {
      context: this.contenttype,
      editing_required: false
    };
  },

  computed: {
    filterNodes: function filterNodes() {
      var _this = this;

      var filterNodes = this.node.nodes && this.node.nodes.filter(function (node) {
        if ('group' === _this.getNodeType(node)) {
          return true;
        } else if (!node.nodes && node.name && 'group' != _this.getNodeType(node)) {
          node.relation = true;
          return true;
        } else {
          return !!_this.fields.find(function (field) {
            return (node.field_name ? node.field_name.replace(/ /g, "_") : node.field_name) === field.name || node.relation;
          });
        }
      });
      return filterNodes || [];
    },
    nodesLength: function nodesLength() {
      return this.filterNodes.length;
    },
    rows: function rows() {
      var rowCount = 1;
      if (0 === this.nodesLength) {
        rowCount = 0;
      } else if (this.columnNumber <= this.nodesLength) {
        rowCount = Math.floor(this.nodesLength / this.columnNumber) + this.nodesLength % this.columnNumber;
      }
      return rowCount;
    },
    columnNumber: function columnNumber() {
      var columnCount = parseInt(this.node.columncount) ? parseInt(this.node.columncount) : 1;
      return columnCount > this.nodesLength ? this.nodesLength : columnCount;
    },
    showGroupTile: function showGroupTile() {
      return this.showTitle && this.node.showlabel && this.node.groupbox;
    }
  },
  methods: {
    loadingRelation: function loadingRelation(relation) {
      var layer = _application2.default.project.getLayerById(this.layerid);

      return (layer.getRelationById(relation.name) || { state: { loading: false } }).state;
    },
    isRelationDisabled: function isRelationDisabled(relation) {
      return undefined === this.getRelationName(relation.name) || 'editing' === this.contenttype && this.isRelationChildLayerNotEditable(relation);
    },
    getRelationName: function getRelationName(relationId) {
      return (_application2.default.project.getRelationById(relationId) || {}).name;
    },
    isRelationChildLayerNotEditable: function isRelationChildLayerNotEditable(relation) {
      var projectRelation = _application2.default.project.getRelationById(relation.name);
      var relationLayer = _application2.default.project.getLayerById(projectRelation.referencingLayer);

      return !(relationLayer && relationLayer.isEditable());
    },
    getNodes: function getNodes(row) {
      var startIndex = (row - 1) * this.columnNumber;
      return this.filterNodes.slice(startIndex, this.columnNumber + startIndex);
    },
    getNode: function getNode(row, column) {
      return this.getNodes(row)[column - 1];
    },
    getField: function getField(node) {
      if (node.relation) {
        return node;
      }
      return this.fields.find(function (f) {
        return (node.field_name ? node.field_name.replace(/ /g, "_") : node.field_name) === f.name;
      });
    },
    getNodeType: function getNodeType(node) {
      var type = node.groupbox || node.nodes ? 'group' : node.relation ? 'relation' : 'field';
      if ('field' === type && [undefined, ''].includes(node.alias)) {
        node.alias = node.field_name;
      }
      return type;
    },
    getComponent: function getComponent(field) {
      if (field.relation) {
        return;
      } else if (field.query) {
        return field.input.type;
      } else {
        return 'g3w-input';
      }
    }
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tab-node group"},[(_vm.showGroupTile)?_c('h5',{staticClass:"title group-title",class:{'mobile': _vm.isMobile()},style:({fontSize: _vm.isMobile() ? '1em' : '1.1em'})},[_vm._v(_vm._s(_vm.node.name)+"\n  ")]):_vm._e(),_vm._v(" "),_vm._l((_vm.rows),function(row){return _c('div',{staticClass:"node-row",class:{'mobile': _vm.isMobile()}},[_vm._l((_vm.columnNumber),function(column){return [(_vm.getNode(row, column))?[('field' === _vm.getNodeType(_vm.getNode(row, column)))?_c(_vm.getComponent(_vm.getField(_vm.getNode(row, column))),{tag:"component",staticStyle:{"padding":"5px 3px 5px 3px"},attrs:{"state":_vm.getField(_vm.getNode(row, column)),"changeInput":_vm.changeInput,"addToValidate":_vm.addToValidate,"removeToValidate":_vm.removeToValidate,"feature":_vm.feature},on:{"changeinput":_vm.changeInput,"addinput":_vm.addToValidate,"removeinput":_vm.removeToValidate}}):[('group' === _vm.getNodeType(_vm.getNode(row, column)))?_c('tabs',_vm._b({staticClass:"sub-group",staticStyle:{"width":"100% !important"},attrs:{"group":true,"tabs":[_vm.getNode(row, column)]}},'tabs',_vm.$props,false)):[(_vm.showRelationByField)?_c('div',{directives:[{name:"disabled",rawName:"v-disabled",value:(_vm.isRelationDisabled(_vm.getNode(row, column)) || _vm.loadingRelation(_vm.getNode(row, column)).loading),expression:"isRelationDisabled(getNode(row, column)) || loadingRelation(getNode(row, column)).loading"}],style:({cursor: _vm.showRelationByField && 'pointer'}),on:{"click":function($event){$event.stopPropagation();_vm.handleRelation({ relation: _vm.getNode(row, column), feature:_vm.feature, layerId: _vm.layerid })}}},[_c('bar-loader',{attrs:{"loading":_vm.loadingRelation(_vm.getNode(row, column)).loading}}),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","align-items":"center"}},[_c('div',{staticClass:"query_relation_field"},[_c('i',{class:_vm.g3wtemplate.font[("" + (_vm.context === 'query' ? 'relation' : 'pencil'))]})]),_vm._v(" "),_c('span',{staticClass:"query_relation_field_message g3w-long-text"},[_c('span',{staticStyle:{"text-transform":"uppercase"}},[_vm._v(" "+_vm._s(_vm.getRelationName(_vm.getNode(row, column).name)))])])])],1):_vm._e()]]]:_vm._e()]})],2)})],2)}
__vue__options__.staticRenderFns = []
__vue__options__._scopeId = "data-v-5e5417b2"

},{"components/InputG3W.vue":101,"gui/fields/fields":37,"store/application":212,"vueify/lib/insert-css":35}],96:[function(require,module,exports){
var __vueify_style_dispose__ = require("vueify/lib/insert-css").insert(".control-label[data-v-4b4fefa7]{text-align:left!important;padding-top:0!important;margin-bottom:3px}")
;(function(){
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _mixins = require('mixins');

exports.default = _extends({
  name: "InputBase",
  props: ['state']
}, _mixins.baseInputMixin);
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.state.visible)?_c('div',{staticClass:"form-group"},[_vm._t("label",[_c('label',{directives:[{name:"disabled",rawName:"v-disabled",value:(!_vm.editable),expression:"!editable"}],staticClass:"col-sm-12 control-label",attrs:{"for":_vm.state.name}},[(_vm.state.i18nLabel)?_c('span',{directives:[{name:"t",rawName:"v-t",value:(_vm.state.label),expression:"state.label"}]}):_c('span',[_vm._v(_vm._s(_vm.state.label))]),_vm._v(" "),(_vm.state.validate && _vm.state.validate.required)?_c('span',[_vm._v("*")]):_vm._e(),_vm._v(" "),(_vm.showhelpicon)?_c('i',{staticClass:"skin-color",class:_vm.g3wtemplate.font['info'],staticStyle:{"margin-left":"3px","cursor":"pointer"},on:{"click":function($event){$event.stopPropagation();return _vm.showHideHelp($event)}}}):_vm._e(),_vm._v(" "),_vm._t("label-action")],2)]),_vm._v(" "),(_vm.state.relationField)?_c('div',{staticStyle:{"color":"var(--skin-warning)","padding":"3px 0 3px 15px"}},[_c('span',{class:_vm.g3wtemplate.getFontClass('warning')}),_vm._v(" "),_c('span',{directives:[{name:"t",rawName:"v-t",value:('sdk.relations.field'),expression:"'sdk.relations.field'"}]})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-sm-12"},[_vm._t("loading",[(_vm.loadingState === 'loading')?_c('div',{staticStyle:{"position":"relative","width":"100%"},attrs:{"slot":"loading"},slot:"loading"},[_c('bar-loader',{attrs:{"loading":true}})],1):_vm._e()]),_vm._v(" "),_vm._t("body"),_vm._v(" "),_vm._t("message",[(_vm.notvalid)?_c('p',{staticClass:"g3w-long-text error-input-message",staticStyle:{"margin":"0"},domProps:{"innerHTML":_vm._s(_vm.state.validate.message)}}):(_vm.state.info)?_c('p',{staticStyle:{"margin":"0"},domProps:{"innerHTML":_vm._s(_vm.state.info)}}):_vm._e()]),_vm._v(" "),(_vm.state.help && this.state.help.visible)?_c('div',{staticClass:"g3w_input_help skin-background-color extralighten",domProps:{"innerHTML":_vm._s(_vm.state.help.message)}}):_vm._e()],2)],2):_vm._e()}
__vue__options__.staticRenderFns = []
__vue__options__._scopeId = "data-v-4b4fefa7"

},{"mixins":200,"vueify/lib/insert-css":35}],97:[function(require,module,exports){
;(function(){
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getUniqueDomId = require('utils/getUniqueDomId');

var Input = require('gui/inputs/input');

exports.default = {
  name: 'input-checkbox',

  mixins: [Input],

  data: function data() {
    return {
      value: null,
      label: null,
      id: (0, _getUniqueDomId.getUniqueDomId)(),
      changed: false
    };
  },


  watch: {
    'state.value': function stateValue(value) {
      if (this.changed) {
        this.changed = false;
      } else {
        this.stateValueChanged(value);
      }
    }
  },

  methods: {
    getValuesItem: function getValuesItem() {
      var checked = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      return this.service.state.input.options.values.find(function (v) {
        return !!checked === v.checked;
      }) || {};
    },
    convertValueToChecked: function convertValueToChecked() {
      var _this = this;

      if ([null, undefined].includes(this.service.state.value)) {
        return false;
      }
      var option = this.service.state.input.options.values.find(function (v) {
        return _this.service.state.value == v.value;
      });
      if (undefined === option) {
        option = this.service.state.input.options.values.find(function (v) {
          return false === v.checked;
        });
        this.service.state.value = option.value;
      }
      return option.checked;
    },
    changeCheckBox: function changeCheckBox() {
      var _getValuesItem = this.getValuesItem(this.value),
          value = _getValuesItem.value,
          label = _getValuesItem.label;

      this.label = label;
      this.state.value = value;
      this.changed = true;
      this.change();
    },
    stateValueChanged: function stateValueChanged() {
      this.value = this.convertValueToChecked();

      var _getValuesItem2 = this.getValuesItem(this.value),
          value = _getValuesItem2.value,
          label = _getValuesItem2.label;

      this.label = label;
      this.state.value = value;
    }
  },

  mounted: function mounted() {
    this.stateValueChanged();
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('baseinput',{attrs:{"state":_vm.state}},[_c('div',{directives:[{name:"disabled",rawName:"v-disabled",value:(!_vm.editable),expression:"!editable"}],staticStyle:{"height":"20px","margin-top":"8px"},attrs:{"slot":"body"},slot:"body"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.value),expression:"value"}],staticClass:"magic-checkbox",class:{'input-error-validation' : _vm.notvalid},staticStyle:{"width":"100%"},attrs:{"tabIndex":_vm.tabIndex,"type":"checkbox","id":_vm.id},domProps:{"checked":Array.isArray(_vm.value)?_vm._i(_vm.value,null)>-1:(_vm.value)},on:{"change":[function($event){var $$a=_vm.value,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.value=$$a.concat([$$v]))}else{$$i>-1&&(_vm.value=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.value=$$c}},_vm.changeCheckBox]}}),_vm._v(" "),_c('label',{attrs:{"for":_vm.id}},[_vm._v(_vm._s(_vm.label))])])])}
__vue__options__.staticRenderFns = []

},{"gui/inputs/input":46,"utils/getUniqueDomId":252}],98:[function(require,module,exports){
;(function(){
Object.defineProperty(exports, "__esModule", {
  value: true
});


var Input = require('gui/inputs/input');

exports.default = {
  name: 'input-color',

  mixins: [Input]
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('baseinput',{attrs:{"state":_vm.state}},[_c('input',{directives:[{name:"disabled",rawName:"v-disabled",value:(!_vm.editable),expression:"!editable"},{name:"model",rawName:"v-model",value:(_vm.state.value),expression:"state.value"}],staticClass:"form-control",class:{'input-error-validation' : _vm.notvalid},staticStyle:{"cursor":"pointer"},attrs:{"slot":"body","placeholder":_vm.state.default,"type":"color","tabIndex":_vm.tabIndex,"field":_vm.state.name,"id":_vm.state.name},domProps:{"value":(_vm.state.value)},on:{"change":_vm.change,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.state, "value", $event.target.value)}},slot:"body"})])}
__vue__options__.staticRenderFns = []

},{"gui/inputs/input":46}],99:[function(require,module,exports){
;(function(){
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _application = require('store/application');

var _application2 = _interopRequireDefault(_application);

var _mixins = require('mixins');

var _getUniqueDomId = require('utils/getUniqueDomId');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var Input = require('gui/inputs/input');

exports.default = {
  name: 'input-datetime-picker',

  mixins: [Input, _mixins.resizeMixin],

  data: function data() {
    var uniqueValue = (0, _getUniqueDomId.getUniqueDomId)();
    return {
      widget_container: {
        top: 0,
        left: 0
      },
      iddatetimepicker: 'datetimepicker_' + uniqueValue,
      idinputdatetimepiker: 'inputdatetimepicker_' + uniqueValue
    };
  },


  methods: {
    resize: function resize() {
      var domeDataPicker = $('#' + this.iddatetimepicker);
      if (domeDataPicker && domeDataPicker.data("DateTimePicker")) {
        domeDataPicker.data("DateTimePicker").hide();
      }
    },
    timeOnly: function timeOnly() {
      return !this.state.input.options.formats[0].date;
    },
    onDatePickerChange: function onDatePickerChange() {
      var newDate = $('#' + this.idinputdatetimepiker).val();
      this.state.value = _.isEmpty(newDate.trim()) ? null : moment(newDate, this.datetimedisplayformat).format(this.datetimefieldformat);
      this.change();
    },
    onDatePickerShow: function onDatePickerShow(evt) {
      var _this = this;

      this.widget_container.top = 0;
      this.widget_container.left = 0;

      setTimeout(function () {
        var container = _this.$refs.datetimepicker_body.getBoundingClientRect();
        var modal = _this.$refs.datimewidget_container.querySelector('.bootstrap-datetimepicker-widget').getBoundingClientRect();
        _this.widget_container.top = container.top + (container.top < modal.height ? container.height + Math.abs(container.top - modal.height) + 20 : 0);
        _this.widget_container.left = container.left - Math.max(container.width, modal.width);
        _this.$emit('datetimepickershow');
      });
    },
    onDatePickerHide: function onDatePickerHide(evt) {
      this.$emit('datetimepickershow');
    }
  },
  watch: {
    'state.value': function () {
      var _ref = _asyncToGenerator(function* (value) {
        if (value !== $('#' + this.idinputdatetimepiker).val()) {
          var date = null !== value ? moment(value, this.datetimefieldformat).format(this.datetimedisplayformat) : value;
          yield this.$nextTick();
          $('#' + this.idinputdatetimepiker).val(date);
        }
      });

      function stateValue(_x) {
        return _ref.apply(this, arguments);
      }

      return stateValue;
    }()
  },

  mounted: function () {
    var _ref2 = _asyncToGenerator(function* () {
      var _this2 = this;

      var _state$input$options = this.state.input.options,
          _state$input$options$ = _state$input$options.formats,
          formats = _state$input$options$ === undefined ? [] : _state$input$options$,
          _state$input$options$2 = _state$input$options.layout,
          layout = _state$input$options$2 === undefined ? {
        vertical: "top",
        horizontal: "left"
      } : _state$input$options$2;
      var _formats$ = formats[0],
          minDate = _formats$.minDate,
          maxDate = _formats$.maxDate,
          fieldformat = _formats$.fieldformat,
          enabledDates = _formats$.enabledDates,
          disabledDates = _formats$.disabledDates,
          displayformat = _formats$.displayformat,
          useCurrent = _formats$.useCurrent;


      yield this.$nextTick();

      this.datetimedisplayformat = this.service.convertQGISDateTimeFormatToMoment(displayformat);
      this.datetimefieldformat = this.service.convertQGISDateTimeFormatToMoment(fieldformat);

      this.service.setValidatorOptions({ fielddatetimeformat: this.datetimefieldformat });

      var date = moment(this.state.value, this.datetimefieldformat, true).isValid() ? moment(this.state.value, this.datetimefieldformat).toDate() : null;

      $('#' + this.iddatetimepicker).datetimepicker({
        defaultDate: date,
        format: this.datetimedisplayformat,
        ignoreReadonly: true,
        allowInputToggle: true,
        enabledDates: enabledDates,
        disabledDates: disabledDates,
        useCurrent: useCurrent,
        toolbarPlacement: 'top',
        minDate: minDate,
        maxDate: maxDate,
        widgetParent: $(this.$refs.datimewidget_container),
        widgetPositioning: {
          vertical: layout.vertical || 'top',
          horizontal: layout.horizontal || 'left'
        },
        showClose: true,
        locale: this.service.getLocale()
      });

      $('#' + this.iddatetimepicker).on("dp.change", this.onDatePickerChange);
      $('#' + this.iddatetimepicker).on("dp.show", this.onDatePickerShow);
      $('#' + this.iddatetimepicker).on("dp.hide", this.onDatePickerHide);

      if (_application2.default.ismobile) {
        setTimeout(function () {
          $('#' + _this2.idinputdatetimepiker).blur();
        });
      }
    });

    function mounted() {
      return _ref2.apply(this, arguments);
    }

    return mounted;
  }()
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('baseinput',{attrs:{"state":_vm.state}},[_c('div',{ref:"datetimepicker_body",attrs:{"slot":"body"},slot:"body"},[_c('div',{ref:"datimewidget_container",style:({
        top: _vm.widget_container.top + 'px',
        left: _vm.widget_container.left + 'px',
        position: 'fixed',
        zIndex: 10000,
      })}),_vm._v(" "),_c('div',{directives:[{name:"disabled",rawName:"v-disabled",value:(!_vm.editable),expression:"!editable"}],staticClass:"input-group date",attrs:{"id":_vm.iddatetimepicker}},[_c('input',{staticClass:"form-control",class:{'input-error-validation' : _vm.notvalid},attrs:{"type":"text","id":_vm.idinputdatetimepiker,"tabIndex":_vm.tabIndex,"readonly":!_vm.editable || _vm.isMobile() ? 'readonly' : null}}),_vm._v(" "),_c('span',{staticClass:"input-group-addon caret"},[_c('span',{class:[ _vm.g3wtemplate.getFontClass(_vm.timeOnly() ? 'time' : 'calendar') ]})])])])])}
__vue__options__.staticRenderFns = []

},{"gui/inputs/input":46,"mixins":200,"store/application":212,"utils/getUniqueDomId":252}],100:[function(require,module,exports){
;(function(){
Object.defineProperty(exports, "__esModule", {
  value: true
});


var Input = require('gui/inputs/input');

exports.default = {
  name: 'input-float',

  mixins: [Input]
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('baseinput',{attrs:{"state":_vm.state}},[_c('input',{directives:[{name:"disabled",rawName:"v-disabled",value:(!_vm.editable),expression:"!editable"},{name:"model",rawName:"v-model",value:(_vm.state.value),expression:"state.value"}],staticClass:"form-control",class:{'input-error-validation' : _vm.notvalid},staticStyle:{"width":"100%"},attrs:{"slot":"body","tabIndex":_vm.tabIndex,"type":"number","step":_vm.state.step || 1,"placeholder":_vm.state.default},domProps:{"value":(_vm.state.value)},on:{"change":_vm.change,"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.state, "value", $event.target.value)},_vm.change]},slot:"body"})])}
__vue__options__.staticRenderFns = []

},{"gui/inputs/input":46}],101:[function(require,module,exports){
;(function(){
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var Inputs = {
  'text_input': require('gui/inputs/text/vue/text'),
  'texthtml_input': require('gui/inputs/texthtml/vue/texthtml'),
  'textarea_input': require('gui/inputs/textarea/vue/textarea'),
  'integer_input': require('gui/inputs/integer/vue/integer'),
  'string_input': require('gui/inputs/text/vue/text'),
  'float_input': require('gui/inputs/float/vue/float'),
  'radio_input': require('gui/inputs/radio/vue/radio'),
  'check_input': require('gui/inputs/checkbox/vue/checkbox'),
  'range_input': require('gui/inputs/range/vue/range'),
  'datetimepicker_input': require('gui/inputs/datetimepicker/vue/datetimepicker'),
  'unique_input': require('gui/inputs/unique/vue/unique'),
  'select_input': require('gui/inputs/select/vue/select'),
  'media_input': require('gui/inputs/media/vue/media'),
  'select_autocomplete_input': require('gui/inputs/select/vue/select'),
  'picklayer_input': require('gui/inputs/picklayer/vue/picklayer'),
  'color_input': require('gui/inputs/color/vue/color'),
  'slider_input': require('gui/inputs/sliderrange/vue/sliderrange'),
  'lonlat_input': require('gui/inputs/lonlat/vue/lonlat')
};

exports.default = {
  name: "g3w-input",
  props: {
    state: {
      required: true
    },
    addToValidate: {
      type: Function,
      required: true
    },
    removeToValidate: {
      type: Function,
      required: true
    },
    changeInput: {
      type: Function,
      required: true
    }
  },
  components: _extends({}, Inputs),
  computed: {
    type: function type() {
      if (this.state.type !== 'child') return this.state.input.type ? this.state.input.type + '_input' : this.state.type + '_input';
    }
  },
  created: function created() {
    if (this.state.type !== 'child' && !this.state.input.options) this.state.input.options = {};
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.state.visible)?_c('div',[(_vm.state.type !== 'child')?_c('div',[_c(_vm.type,{tag:"component",attrs:{"changeInput":_vm.changeInput,"addToValidate":_vm.addToValidate,"removeToValidate":_vm.removeToValidate,"state":_vm.state},on:{"changeinput":_vm.changeInput,"addinput":_vm.addToValidate,"removeinput":_vm.removeToValidate}}),_vm._v(" "),_c('divider')],1):_c('div',{staticClass:"skin-border-color field-child",staticStyle:{"border-top":"2px solid"}},[_c('h4',{staticStyle:{"font-weight":"bold"}},[_vm._v(_vm._s(_vm.state.label))]),_vm._v(" "),_c('div',[_vm._v(" "+_vm._s(_vm.state.description)+" ")]),_vm._v(" "),_vm._l((_vm.state.fields),function(field){return _c('g3w-input',{key:field.name,attrs:{"state":field,"changeInput":_vm.changeInput,"addToValidate":_vm.addToValidate,"removeToValidate":_vm.removeToValidate},on:{"changeinput":_vm.changeInput,"addinput":_vm.addToValidate,"removeinput":_vm.removeToValidate}})})],2)]):_vm._e()}
__vue__options__.staticRenderFns = []

},{"gui/inputs/checkbox/vue/checkbox":40,"gui/inputs/color/vue/color":41,"gui/inputs/datetimepicker/vue/datetimepicker":43,"gui/inputs/float/vue/float":45,"gui/inputs/integer/vue/integer":48,"gui/inputs/lonlat/vue/lonlat":50,"gui/inputs/media/vue/media":52,"gui/inputs/picklayer/vue/picklayer":54,"gui/inputs/radio/vue/radio":56,"gui/inputs/range/vue/range":58,"gui/inputs/select/vue/select":60,"gui/inputs/sliderrange/vue/sliderrange":64,"gui/inputs/text/vue/text":65,"gui/inputs/textarea/vue/textarea":66,"gui/inputs/texthtml/vue/texthtml":67,"gui/inputs/unique/vue/unique":69}],102:[function(require,module,exports){
var __vueify_style_dispose__ = require("vueify/lib/insert-css").insert("#g3w-for-inputs-required-inputs-message[data-v-0bafce1c]{margin-bottom:5px;font-weight:700;text-align:center;display:flex;align-items:center;justify-content:center}.box-body[data-v-0bafce1c]{padding:5px}")
;(function(){
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _InputG3W = require("components/InputG3W.vue");

var _InputG3W2 = _interopRequireDefault(_InputG3W);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: "g3w-form-inputs",
  props: {
    state: {
      type: Object,
      default: {
        fields: []
      }
    },
    addToValidate: {
      type: Function
    },
    changeInput: {
      type: Function
    },
    show_required_field_message: {
      type: Boolean,
      default: false
    },
    removeToValidate: {
      type: Function
    }

  },
  components: {
    G3wInput: _InputG3W2.default
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{staticClass:"form-horizontal g3w-form"},[_c('div',{staticClass:"box-primary"},[_c('div',{staticClass:"box-body"},[_vm._l((_vm.state.fields),function(field){return [_c('g3w-input',{attrs:{"state":field,"removeToValidate":_vm.removeToValidate,"addToValidate":_vm.addToValidate,"changeInput":_vm.changeInput},on:{"addToValidate":_vm.addToValidate,"changeInput":_vm.changeInput}})]})],2),_vm._v(" "),(_vm.show_required_field_message)?_c('div',{attrs:{"id":"g3w-for-inputs-required-inputs-message"}},[_c('span',{staticClass:"hide-cursor-caret-color"},[_vm._v("*")]),_vm._v(" "),_c('span',{directives:[{name:"t",rawName:"v-t",value:('sdk.form.footer.required_fields'),expression:"'sdk.form.footer.required_fields'"}],staticClass:"hide-cursor-caret-color"})]):_vm._e()])])}
__vue__options__.staticRenderFns = []
__vue__options__._scopeId = "data-v-0bafce1c"

},{"components/InputG3W.vue":101,"vueify/lib/insert-css":35}],103:[function(require,module,exports){
;(function(){
Object.defineProperty(exports, "__esModule", {
  value: true
});


var Input = require('gui/inputs/input');

exports.default = {
  name: 'input-integer',

  mixins: [Input]
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('baseinput',{attrs:{"state":_vm.state}},[_c('input',{directives:[{name:"disabled",rawName:"v-disabled",value:(!_vm.editable),expression:"!editable"},{name:"model",rawName:"v-model",value:(_vm.state.value),expression:"state.value"}],staticClass:"form-control",class:{'input-error-validation' : _vm.notvalid},staticStyle:{"width":"100%"},attrs:{"slot":"body","placeholder":_vm.state.default,"tabIndex":_vm.tabIndex,"type":"number"},domProps:{"value":(_vm.state.value)},on:{"change":_vm.change,"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.state, "value", $event.target.value)},_vm.change]},slot:"body"})])}
__vue__options__.staticRenderFns = []

},{"gui/inputs/input":46}],104:[function(require,module,exports){
;(function(){
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getUniqueDomId = require('utils/getUniqueDomId');

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var Input = require('gui/inputs/input');

exports.default = {
  name: 'input-lonlat',

  mixins: [Input],
  data: function data() {
    return {
      lonId: (0, _getUniqueDomId.getUniqueDomId)(),
      latId: (0, _getUniqueDomId.getUniqueDomId)(),
      coordinatebutton: {
        active: false
      }
    };
  },

  computed: {
    getCoordinateActive: function getCoordinateActive() {
      return this.service.state.getCoordinateActive;
    }
  },
  methods: {
    toggleGetCoordinate: function toggleGetCoordinate() {
      this.service.toggleGetCoordinate();
    },
    changeLonLat: function changeLonLat() {
      this.change();
      this.setValue();
    },
    setValue: function setValue() {
      this.state.value = [[1 * this.state.values.lon, 1 * this.state.values.lat]];
    }
  },
  created: function created() {
    this.state.values = this.state.values || { lon: 0, lat: 0 };
    this.setValue();
    this.service.setCoordinateButtonReactiveObject(this.coordinatebutton);
  },
  mounted: function () {
    var _ref = _asyncToGenerator(function* () {
      yield this.$nextTick();
      $(this.$refs['g3w-input-lat-lon']).tooltip({ trigger: 'hover' });
    });

    function mounted() {
      return _ref.apply(this, arguments);
    }

    return mounted;
  }(),
  destroyed: function destroyed() {
    this.service.clear();
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"position":"relative"}},[_c('div',{staticStyle:{"display":"flex","justify-content":"flex-end","height":"35px","margin-right":"12px","margin-bottom":"5px"}},[_c('button',{directives:[{name:"t-tooltip",rawName:"v-t-tooltip",value:('sdk.form.inputs.tooltips.lonlat'),expression:"'sdk.form.inputs.tooltips.lonlat'"}],ref:"g3w-input-lat-lon",staticClass:"action skin-tooltip-left skin-color skin-border-color",class:_vm.g3wtemplate.font['crosshairs'],staticStyle:{"border-radius":"5px","font-weight":"bold","font-size":"20px","cursor":"pointer"},style:({border: _vm.coordinatebutton.active ? '2px solid' : 0}),attrs:{"data-placement":"left","data-container":"body","data-toggle":"tooltip"},on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.toggleGetCoordinate($event)}}})]),_vm._v(" "),_c('baseinput',{attrs:{"state":_vm.state}},[_c('label',{staticClass:"col-sm-4 control-label",attrs:{"slot":"label","for":_vm.lonId},slot:"label"},[_vm._v(_vm._s(_vm.state.labels.lon)+"\n      "),(_vm.state.validate && _vm.state.validate.required)?_c('span',[_vm._v("*")]):_vm._e()]),_vm._v(" "),_c('div',{attrs:{"slot":"body"},slot:"body"},[_c('input',{directives:[{name:"disabled",rawName:"v-disabled",value:(!_vm.editable),expression:"!editable"},{name:"model",rawName:"v-model",value:(_vm.state.values.lon),expression:"state.values.lon"}],staticClass:"form-control",class:{'input-error-validation' : _vm.notvalid},staticStyle:{"width":"100%","margin-bottom":"5px"},attrs:{"id":_vm.lonId,"tabIndex":_vm.tabIndex,"type":"number","min":"-180","max":"180","placeholder":"Lon"},domProps:{"value":(_vm.state.values.lon)},on:{"change":_vm.changeLonLat,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.state.values, "lon", $event.target.value)}}})])]),_vm._v(" "),_c('baseinput',{attrs:{"state":_vm.state}},[_c('label',{staticClass:"col-sm-4 control-label",attrs:{"slot":"label","for":_vm.latId},slot:"label"},[_vm._v(_vm._s(_vm.state.labels.lat)+"\n      "),(_vm.state.validate && _vm.state.validate.required)?_c('span',[_vm._v("*")]):_vm._e()]),_vm._v(" "),_c('div',{attrs:{"slot":"body"},slot:"body"},[_c('input',{directives:[{name:"disabled",rawName:"v-disabled",value:(!_vm.editable),expression:"!editable"},{name:"model",rawName:"v-model",value:(_vm.state.values.lat),expression:"state.values.lat"}],staticClass:"form-control",class:{'input-error-validation' : _vm.notvalid},staticStyle:{"width":"100%","margin-bottom":"5px"},attrs:{"id":_vm.latId,"tabIndex":_vm.tabIndex,"type":"number","min":"-90","max":"90","placeholder":"Lon"},domProps:{"value":(_vm.state.values.lat)},on:{"change":_vm.changeLonLat,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.state.values, "lat", $event.target.value)}}})])])],1)}
__vue__options__.staticRenderFns = []

},{"gui/inputs/input":46,"utils/getUniqueDomId":252}],105:[function(require,module,exports){
;(function(){
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _gui = require('services/gui');

var _gui2 = _interopRequireDefault(_gui);

var _getUniqueDomId = require('utils/getUniqueDomId');

var _g3wI18n = require('g3w-i18n');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var InputMixins = require('gui/inputs/input');

var _require = require('gui/fields/fields'),
    MediaField = _require.media_field;

exports.default = {
  name: 'input-media',

  mixins: [InputMixins],
  components: {
    'g3w-media': MediaField
  },
  data: function data() {
    return {
      data: {
        value: null,
        mime_type: null
      },
      mediaid: 'media_' + (0, _getUniqueDomId.getUniqueDomId)(),
      loading: false
    };
  },

  methods: {
    onClick: function onClick() {
      document.getElementById(this.mediaid).click();
    },
    clearMedia: function clearMedia() {
      this.data.value = this.data.mime_type = this.state.value = null;
      this.change();
    },
    setMedia: function setMedia() {
      if (this.state.value) {
        this.data.value = this.state.value.value;
        this.data.mime_type = this.state.value.mime_type;
      }
    }
  },
  created: function created() {
    this.setMedia();
  },

  watch: {
    'state.value': function stateValue() {
      this.setMedia();
    }
  },
  mounted: function () {
    var _ref = _asyncToGenerator(function* () {
      var _this = this;

      var fieldName = this.state.name;
      var formData = {
        name: fieldName,
        csrfmiddlewaretoken: this.$cookie.get('csrftoken')
      };

      yield this.$nextTick();

      $('#' + this.mediaid).fileupload({
        dataType: 'json',
        formData: formData,
        start: function start() {
          return _this.loading = true;
        },
        done: function done(e, data) {
          var response = data.result[fieldName];
          if (response) {
            _this.data.value = response.value;
            _this.data.mime_type = response.mime_type;
            _this.state.value = _this.data;
            _this.change();
          }
        },
        fail: function fail(e) {
          console.warn(e);_gui2.default.notify.error((0, _g3wI18n.t)("info.server_error"));
        },
        always: function always() {
          return _this.loading = false;
        }
      });
    });

    function mounted() {
      return _ref.apply(this, arguments);
    }

    return mounted;
  }(),
  beforeDestroy: function beforeDestroy() {
    $('#' + this.mediaid).fileupload('destroy');
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('baseinput',{attrs:{"state":_vm.state}},[_c('div',{directives:[{name:"disabled",rawName:"v-disabled",value:(!_vm.editable),expression:"!editable"}],attrs:{"slot":"body"},slot:"body"},[_c('div',{staticClass:"g3w_input_button skin-border-color",staticStyle:{"border-style":"solid","border-width":"2px","width":"100%","cursor":"pointer","text-align":"center"},on:{"click":_vm.onClick}},[_c('i',{staticClass:"fa-2x skin-color",class:_vm.g3wtemplate.getFontClass('file-upload'),staticStyle:{"padding":"5px"}},[_c('input',{class:{'input-error-validation' : _vm.notvalid},staticStyle:{"display":"none"},attrs:{"id":_vm.mediaid,"name":_vm.state.name,"tabIndex":_vm.tabIndex,"data-url":_vm.state.input.options.uploadurl,"type":"file"}})])]),_vm._v(" "),_c('bar-loader',{attrs:{"loading":_vm.loading}}),_vm._v(" "),_c('g3w-media',{attrs:{"state":_vm.data}},[_c('div',{staticClass:"clearmedia",on:{"click":function($event){$event.stopPropagation();return _vm.clearMedia($event)}}},[_c('i',{staticClass:"g3w-icon",class:_vm.g3wtemplate.font['trash-o']})])])],1)])}
__vue__options__.staticRenderFns = []

},{"g3w-i18n":162,"gui/fields/fields":37,"gui/inputs/input":46,"services/gui":207,"utils/getUniqueDomId":252}],106:[function(require,module,exports){
;(function(){
Object.defineProperty(exports, "__esModule", {
  value: true
});


var Input = require('gui/inputs/input');
var Service = require('gui/inputs/picklayer/service');

exports.default = {
  name: 'input-picklayer',

  mixins: [Input],
  methods: {
    pickLayer: function pickLayer() {
      var _this = this;

      this.pickservice.pick().then(function (value) {
        return _this.state.value = value;
      }).catch(function () {});
    },
    unpick: function unpick() {
      var _this2 = this;

      setTimeout(function () {
        return !_this2.pickservice.isPicked() && _this2.pickservice.unpick();
      }, 200);
    }
  },
  created: function created() {
    this.pickservice = new Service(this.state.input.options);
  },
  beforeDestroy: function beforeDestroy() {
    this.pickservice.clear();
    this.pickservice = null;
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('baseinput',{attrs:{"state":_vm.state}},[_c('div',{attrs:{"slot":"body"},slot:"body"},[_c('span',{staticClass:"skin-color",class:_vm.g3wtemplate.font['crosshairs'],staticStyle:{"left":"0","top":"7px","position":"absolute"}}),_vm._v(" "),_c('input',{directives:[{name:"disabled",rawName:"v-disabled",value:(!_vm.editable),expression:"!editable"},{name:"model",rawName:"v-model",value:(_vm.state.value),expression:"state.value"}],staticClass:"form-control",class:{'input-error-validation' : _vm.notvalid},staticStyle:{"width":"100%"},style:({cursor: _vm.editable ? 'pointer': null}),attrs:{"readonly":"readonly","tabIndex":_vm.tabIndex},domProps:{"value":(_vm.state.value)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.state, "value", $event.target.value)},_vm.change],"click":_vm.pickLayer,"blur":_vm.unpick}})])])}
__vue__options__.staticRenderFns = []

},{"gui/inputs/input":46,"gui/inputs/picklayer/service":53}],107:[function(require,module,exports){
;(function(){
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getUniqueDomId = require('utils/getUniqueDomId');

var Input = require('gui/inputs/input');

exports.default = {
  name: 'input-radio',

  mixins: [Input],
  data: function data() {
    return {
      ids: [(0, _getUniqueDomId.getUniqueDomId)(), (0, _getUniqueDomId.getUniqueDomId)()],
      name: 'name_' + (0, _getUniqueDomId.getUniqueDomId)(),
      radio_value: this.state.value
    };
  },

  watch: {
    'radio_value': function radio_value() {
      this.state.value = this.radio_value;
      this.change();
    }
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('baseinput',{attrs:{"state":_vm.state}},[_c('div',{attrs:{"slot":"body"},slot:"body"},_vm._l((_vm.state.input.options.values),function(value,index){return _c('span',{key:value.key},[_c('input',{directives:[{name:"disabled",rawName:"v-disabled",value:(!_vm.editable),expression:"!editable"},{name:"model",rawName:"v-model",value:(_vm.radio_value),expression:"radio_value"}],staticClass:"magic-radio",class:{'input-error-validation' : _vm.notvalid},staticStyle:{"width":"100%"},attrs:{"id":_vm.ids[index],"name":_vm.name,"tabIndex":_vm.tabIndex,"type":"radio"},domProps:{"value":value.value,"checked":_vm._q(_vm.radio_value,value.value)},on:{"change":function($event){_vm.radio_value=value.value}}}),_vm._v(" "),_c('label',{attrs:{"for":_vm.ids[index]}},[_vm._v(_vm._s(value.key))])])}),0)])}
__vue__options__.staticRenderFns = []

},{"gui/inputs/input":46,"utils/getUniqueDomId":252}],108:[function(require,module,exports){
;(function(){
Object.defineProperty(exports, "__esModule", {
  value: true
});


var Input = require('gui/inputs/input');

exports.default = {
  name: 'input-range',

  mixins: [Input],
  data: function data() {
    var _state$input$options$ = this.state.input.options.values[0],
        min = _state$input$options$.min,
        max = _state$input$options$.max,
        step = _state$input$options$.Step;

    return {
      min: min,
      max: max,
      step: step
    };
  },

  methods: {
    checkValue: function checkValue() {
      var isEmpty = null === this.state.value || _.isEmpty(('' + this.state.value).trim());

      if (isEmpty && !this.state.validate.required) {
        this.state.value = this.state.input.options.values[0].default;
      }

      this.state.validate.valid = !this.state.validate.required;

      if (!isEmpty) {
        this.state.validate.valid = this.service.getValidator().validate(this.state.value);
      }

      this.change();
    }
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('baseinput',{attrs:{"state":_vm.state}},[_c('input',{directives:[{name:"disabled",rawName:"v-disabled",value:(!_vm.editable),expression:"!editable"},{name:"model",rawName:"v-model",value:(_vm.state.value),expression:"state.value"}],staticClass:"form-control",class:{'input-error-validation' : _vm.notvalid},staticStyle:{"width":"100%","padding-right":"5px"},attrs:{"slot":"body","tabIndex":_vm.tabIndex,"type":"number","step":_vm.step},domProps:{"value":(_vm.state.value)},on:{"keydown":[function($event){if(!$event.type.indexOf('key')&&$event.keyCode!==69){ return null; }$event.preventDefault();},function($event){if(!$event.type.indexOf('key')&&$event.keyCode!==13){ return null; }$event.stopPropagation();}],"change":_vm.checkValue,"blur":_vm.checkValue,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.state, "value", $event.target.value)}},slot:"body"})])}
__vue__options__.staticRenderFns = []

},{"gui/inputs/input":46}],109:[function(require,module,exports){
var __vueify_style_dispose__ = require("vueify/lib/insert-css").insert(".g3w-input-pick-layer[data-v-77dd4e5c]{cursor:pointer;position:relative;top:2px;font-size:1.2em}")
;(function(){
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _gui = require('services/gui');

var _gui2 = _interopRequireDefault(_gui);

var _application = require('store/application');

var _application2 = _interopRequireDefault(_application);

var _mixins = require('mixins');

var _createSingleFieldParameter = require('utils/createSingleFieldParameter');

var _getCatalogLayerById = require('utils/getCatalogLayerById');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var PickLayerInputService = require('gui/inputs/picklayer/service');

var _require = require('map/layers/layer'),
    Layer = _require.Layer;

var InputMixin = require('gui/inputs/input');

var G3W_SELECT2_NULL_VALUE = null;exports.default = {
  name: 'input-select',

  mixins: [InputMixin, _mixins.selectMixin, _mixins.select2Mixin],
  data: function data() {
    return {
      showPickLayer: false,
      picked: false,
      filterFields: [],
      isFilterFieldsReady: false };
  },

  computed: {
    showNullOption: function showNullOption() {
      return false === this.multiple && [undefined, true].includes(this.state.nullOption);
    },
    select2NullValue: function select2NullValue() {
      return this.showNullOption && G3W_SELECT2_NULL_VALUE;
    }
  },
  methods: {
    pickLayerValue: function () {
      var _ref = _asyncToGenerator(function* () {
        try {
          if (this.picked) {
            this.pickLayerInputService.unpick();
            this.picked = false;
          } else {
            this.picked = true;
            var values = yield this.pickLayerInputService.pick();

            var value = values[this.state.input.options.key];

            if (this.multiple) {
              value = undefined === this.getMultiValues().find(function (v) {
                return value == v;
              }) ? '{' + [].concat(_toConsumableArray(this.getMultiValues()), [value]).join() + '}' : this.state.value;
            }

            if (value != this.state.value) {
              if (this.autocomplete) {
                if (!this.multiple) {
                  this.state.input.options.values.splice(0);
                }
                this.state.input.options.values.push({
                  key: values[this.state.input.options.value],
                  value: values[this.state.input.options.key]
                });
              }

              this.service.sortValues();

              yield this.changeSelect(value);

              this.select2.val(this.multiple ? this.getMultiValues() : value).trigger('change');
            }

            _gui2.default.showUserMessage({ type: 'success', autoclose: true });

            this.picked = false;
          }
        } catch (e) {
          console.warn(e);
          _gui2.default.showUserMessage({
            type: "warning",
            message: 'sdk.form.inputs.messages.errors.picklayer',
            autoclose: true
          });
          this.picked = false;
        }
      });

      function pickLayerValue() {
        return _ref.apply(this, arguments);
      }

      return pickLayerValue;
    }(),
    getMultiValues: function getMultiValues() {
      var _this = this;

      return [undefined, null, ''].includes(this.state.value) ? [] : Array.from(new Set(('' + this.state.value).replace(/^{|}$/g, '').replace(/"/g, "").split(','))).filter(function (v) {
        return _this.autocomplete || _this.state.input.options.values.map(function (_ref2) {
          var value = _ref2.value;
          return '' + value;
        }).includes('' + v);
      });
    },
    setAndListenSelect2Change: function setAndListenSelect2Change() {
      var _this2 = this;

      this.select2.on('select2:unselect', function (e) {
        var value = e.params.data.$value ? e.params.data.$value : e.params.data.id;
        if (_this2.multiple) {
          var values = _this2.getMultiValues().filter(function (v) {
            return v != value;
          });

          if (_this2.autocomplete) {
            _this2.state.input.options.values = _this2.state.input.options.values.filter(function (v) {
              return value != v.value;
            });
          }
          _this2.changeSelect(0 === values.length ? null : '{' + values.join() + '}');
        }

        if (_this2.showNullOption && !_this2.multiple) {
          _this2.changeSelect(null);
        }
      });

      this.select2.on('select2:select', function (e) {
        var value = e.params.data.$value ? e.params.data.$value : e.params.data.id;

        value = _this2.showNullOption ? value === G3W_SELECT2_NULL_VALUE ? null : value.toString() : value.toString();

        if (_this2.multiple) {
          value = _this2.getMultiValues().length > 0 ? '{' + [].concat(_toConsumableArray(_this2.getMultiValues()), [value]).join() + '}' : '{' + value + '}';
        }

        _this2.changeSelect(value);
      });
    }
  },

  watch: {
    'state.input.options.values': function () {
      var _ref3 = _asyncToGenerator(function* () {
        var _this3 = this;

        var values = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

        yield this.$nextTick();
        if (this.autocomplete) {
          return;
        }
        var value = void 0;

        var is_empty = 0 === values.length;

        if (is_empty || this.multiple && 0 === this.getMultiValues().length) {
          value = G3W_SELECT2_NULL_VALUE;
        }

        if (!is_empty && this.multiple && this.getMultiValues().length > 0) {
          value = '{' + this.getMultiValues().join() + '}';
        }

        if (!is_empty && !this.multiple) {
          value = (values.find(function (_ref4) {
            var value = _ref4.value;
            return value == _this3.state.value;
          }) || { value: G3W_SELECT2_NULL_VALUE }).value;
        }

        var changed = value != this.state.value;

        this.state.value = value;

        this.select2.val(this.multiple ? this.getMultiValues() : this.state.value).trigger('change');

        if (changed) {
          this.change();
        }
      });

      function stateInputOptionsValues() {
        return _ref3.apply(this, arguments);
      }

      return stateInputOptionsValues;
    }()
  },

  created: function () {
    var _ref5 = _asyncToGenerator(function* () {
      var _this4 = this;

      this.unwatch;
      this.filterFieldsUnwatches;

      var _state$input$options = this.state.input.options,
          relation_id = _state$input$options.relation_id,
          _state$input$options$ = _state$input$options.filter_fields,
          filter_fields = _state$input$options$ === undefined ? [] : _state$input$options$,
          _state$input$options$2 = _state$input$options.relation_reference,
          relation_reference = _state$input$options$2 === undefined ? false : _state$input$options$2,
          _state$input$options$3 = _state$input$options.chain_filters,
          chain_filters = _state$input$options$3 === undefined ? false : _state$input$options$3,
          _state$input$options$4 = _state$input$options.allowmulti,
          allowmulti = _state$input$options$4 === undefined ? false : _state$input$options$4;

      this.multiple = allowmulti;

      if (relation_reference && Array.isArray(filter_fields) && filter_fields.length > 0) {
        this.setLoading(true);

        this.isFilterFieldsReady = false;

        var _ApplicationState$pro = _application2.default.project.getRelationById(relation_id),
            referencedLayer = _ApplicationState$pro.referencedLayer,
            referencingLayer = _ApplicationState$pro.referencingLayer,
            _ApplicationState$pro2 = _ApplicationState$pro.fieldRef,
            referencingField = _ApplicationState$pro2.referencingField,
            referencedField = _ApplicationState$pro2.referencedField;

        var layer = (0, _getCatalogLayerById.getCatalogLayerById)(referencingLayer);

        var relationLayer = (0, _getCatalogLayerById.getCatalogLayerById)(referencedLayer);

        var relationLayerFields = relationLayer.getFields();

        if (null !== this.state.value) {
          try {
            var _ref6 = yield relationLayer.getFilterData({
              formatter: 0,
              field: (0, _createSingleFieldParameter.createSingleFieldParameter)({
                field: referencedField[0],
                value: this.state.value })
            }),
                _ref6$data = _ref6.data,
                data = _ref6$data === undefined ? [] : _ref6$data;

            this.state.input.options.values = ((yield layer.getFilterData({
              fformatter: referencingField[0],
              order: referencingField[0],
              ffield: filter_fields.map(function (f, i) {
                var value = undefined === data[0].features[0].get(f) ? '' + G3W_SELECT2_NULL_VALUE : data[0].features[0].get(f);

                _this4.filterFields.push({
                  id: f,
                  values: [{
                    key: '[' + relationLayerFields.find(function (_f) {
                      return _f.name === f;
                    }).label + ']',
                    value: '' + G3W_SELECT2_NULL_VALUE }],
                  value: value,
                  disabled: chain_filters && i > 0 && '' + G3W_SELECT2_NULL_VALUE === _this4.filterFields[filter_fields[i - 1]]
                });
                return (0, _createSingleFieldParameter.createSingleFieldParameter)({
                  field: f,
                  value: value
                });
              }).join('|AND,')
            })).data || []).map(function (_ref7) {
              var _ref8 = _slicedToArray(_ref7, 2),
                  value = _ref8[0],
                  key = _ref8[1];

              return { key: key, value: value };
            });

            if (chain_filters) {
              (yield relationLayer.getFilterData({
                unique: filter_fields[0],
                ordering: filter_fields[0],
                formatter: 0
              })).forEach(function (v) {
                return _this4.filterFields[0].values.push({ key: v, value: v });
              });

              (yield Promise.allSettled(filter_fields.slice(1).map(function (f, i) {
                return relationLayer.getFilterData({
                  unique: filter_fields[i + 1],
                  ordering: filter_fields[i + 1],
                  formatter: 0,
                  field: _this4.filterFields.slice(0, i + 1).filter(function (f) {
                    return 'null' !== f.value;
                  }).map(function (f) {
                    return (0, _createSingleFieldParameter.createSingleFieldParameter)({
                      field: f.id,
                      value: f.value
                    });
                  }).join('|AND,')
                });
              }))).forEach(function (_ref9, i) {
                var status = _ref9.status,
                    data = _ref9.value;

                if ('fulfilled' === status) {
                  data.forEach(function (v) {
                    return _this4.filterFields[i + 1].values.push({ key: v, value: v });
                  });
                }
              });
            } else {
              (yield Promise.allSettled(filter_fields.map(function (f) {
                return relationLayer.getFilterData({ unique: f, ordering: f, formatter: 0 });
              }))).forEach(function (_ref10, index) {
                var status = _ref10.status,
                    data = _ref10.value;

                if ('fulfilled' === status) {
                  data.forEach(function (v) {
                    return _this4.filterFields[index].values.push({ key: v, value: v });
                  });
                }
              });
            }
          } catch (e) {
            console.warn(e);
          }
        } else {
          (yield Promise.allSettled(filter_fields.map(function (f, i) {
            _this4.filterFields.push({
              id: f,
              values: [{
                key: '[' + relationLayerFields.find(function (_f) {
                  return _f.name === f;
                }).label + ']',
                value: '' + G3W_SELECT2_NULL_VALUE }],
              value: '' + G3W_SELECT2_NULL_VALUE,
              disabled: chain_filters && i > 0
            });
            return relationLayer.getFilterData({
              unique: f,
              formatter: 0,
              ordering: f
            });
          }))).forEach(function (_ref11, i) {
            var status = _ref11.status,
                data = _ref11.value;

            if ('fulfilled' === status) {
              data.forEach(function (v) {
                return _this4.filterFields[i].values.push({ key: v, value: v });
              });
            }
          });
        }

        this.filterFieldsUnwatches = this.filterFields.map(function (f, index) {
          return _this4.$watch(function () {
            return f.value;
          }, function () {
            var _ref12 = _asyncToGenerator(function* (value) {
              _this4.setLoading(true);

              if (chain_filters) {
                for (var i = index + 1; i < _this4.filterFields.length; i++) {
                  _this4.filterFields[i].value = '' + G3W_SELECT2_NULL_VALUE;
                  _this4.filterFields[i].values = [_this4.filterFields[i].values[0]];
                  _this4.filterFields[i].disabled = '' + G3W_SELECT2_NULL_VALUE === value;
                }
                try {
                  var filter = _this4.filterFields.slice(0, index + 1).filter(function (f) {
                    return '' + G3W_SELECT2_NULL_VALUE !== f.value;
                  }).map(function (f) {
                    return (0, _createSingleFieldParameter.createSingleFieldParameter)({
                      field: f.id,
                      value: f.value
                    });
                  }).join('|AND,');

                  var _ref13 = yield relationLayer.getFilterData({ field: filter }),
                      _ref13$data = _ref13.data,
                      rdata = _ref13$data === undefined ? [] : _ref13$data;

                  if (rdata[0] && rdata[0].features) {
                    var filterReferencedFieldValues = [];
                    rdata[0].features.forEach(function (f) {
                      filterReferencedFieldValues.push(f.get(referencedField));
                      if (index < _this4.filterFields.length - 1) {
                        var _value = f.get(_this4.filterFields[index + 1].id);
                        _this4.filterFields[index + 1].values.push({ key: _value, value: _value });
                      }
                    });
                  }
                } catch (e) {
                  console.warn(e);
                }
              }
              _this4.state.input.options.values = ((yield layer.getFilterData({
                fformatter: referencingField[0],
                ordering: referencingField[0],
                ffield: _this4.filterFields.filter(function (f) {
                  return '' + G3W_SELECT2_NULL_VALUE !== f.value;
                }).map(function (f) {
                  return (0, _createSingleFieldParameter.createSingleFieldParameter)({ field: f.id, value: f.value });
                }).join('|AND,')
              })).data || []).map(function (_ref14) {
                var _ref15 = _slicedToArray(_ref14, 2),
                    value = _ref15[0],
                    key = _ref15[1];

                return { key: key, value: value };
              });

              if (_this4.state.input.options.values.length > 0) {
                _this4.state.value = _this4.state.input.options.values[0].value;
                _this4.select2.val(_this4.state.value).trigger('change');
                yield _this4.changeSelect(_this4.state.value);
              }

              _this4.setLoading(false);
            });

            return function (_x2) {
              return _ref12.apply(this, arguments);
            };
          }());
        });

        this.setLoading(false);

        this.isFilterFieldsReady = true;
      }

      if ('select_autocomplete' === this.state.input.type) {
        var dependencyLayerId = this.state.input.options.layer_id;
        if (dependencyLayerId) {
          try {
            var dependencyLayer = _gui2.default.getService('map').getProjectLayer(dependencyLayerId).getEditingLayer() || (0, _getCatalogLayerById.getCatalogLayerById)(dependencyLayerId);

            this.showPickLayer = dependencyLayer && Layer.LayerTypes.TABLE !== dependencyLayer.getType();
            if (this.showPickLayer) {
              var _state$input$options2 = this.state.input.options,
                  key = _state$input$options2.key,
                  value = _state$input$options2.value,
                  layer_id = _state$input$options2.layer_id;

              this.pickLayerInputService = new PickLayerInputService({
                layer_id: layer_id,
                fields: [value, key],
                pick_type: dependencyLayer.isStarted && dependencyLayer.isStarted() ? 'map' : null
              });
            }
          } catch (e) {
            console.warn(e);
          }
        }
      }
    });

    function created() {
      return _ref5.apply(this, arguments);
    }

    return created;
  }(),
  mounted: function () {
    var _ref16 = _asyncToGenerator(function* () {
      var _this5 = this;

      yield this.$nextTick();

      var selectElement = $(this.$refs.select);
      var language = this.getLanguage();
      var dropdownParent = undefined === this.state.dropdownParent && $('#g3w-view-content');
      if (this.autocomplete) {
        this.select2 = selectElement.select2({
          minimumInputLength: 1,
          dropdownParent: dropdownParent,
          multiple: this.multiple,
          allowClear: this.showNullOption,
          placeholder: '',
          language: language,
          ajax: {
            delay: 250,
            transport: function transport(params, success, failure) {
              var search = params.data.term;

              $('.select2-results__option.loading-results').siblings().hide();
              _this5.service.getData({
                key: _this5.state.input.options.value,
                value: _this5.state.input.options.key,
                search: search
              }).then(function (values) {
                return success(values);
              }).catch(function (e) {
                console.warn(e);failure(e);
              });
            },
            processResults: function processResults(data, params) {
              params.page = params.page || 1;
              return {
                results: data,
                pagination: {
                  more: false
                }
              };
            } }
        });

        if (this.state.value) {
          this.state.input.options.values.splice(0);
          yield this.service.getKeyByValue({
            search: this.multiple ? this.getMultiValues() : this.state.value
          });
        }
      } else {
        this.select2 = selectElement.select2({
          language: language,
          dropdownParent: dropdownParent,
          multiple: this.multiple,
          minimumResultsForSearch: this.isMobile() ? -1 : null
        });
      }
      this.setAndListenSelect2Change();

      if (this.multiple && this.getMultiValues().length > 0) {
        this.select2.val(this.getMultiValues()).trigger('change');
      } else {
        this.setValue();
      }
    });

    function mounted() {
      return _ref16.apply(this, arguments);
    }

    return mounted;
  }(),
  beforeDestroy: function beforeDestroy() {
    if (this.pickLayerInputService) {
      this.pickLayerInputService.clear();
      this.pickLayerInputService = null;
    }
    if (this.unwatch) {
      this.unwatch();
      this.unwatch = null;
    }

    if (this.filterFieldsUnwatches) {
      this.filterFieldsUnwatches.forEach(function (uw) {
        return uw();
      });
      this.filterFieldsUnwatches = null;
    }
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('baseinput',{attrs:{"state":_vm.state}},[(_vm.showPickLayer)?_c('span',{directives:[{name:"t-tooltip",rawName:"v-t-tooltip:top.create",value:('sdk.form.inputs.tooltips.picklayer'),expression:"'sdk.form.inputs.tooltips.picklayer'",arg:"top",modifiers:{"create":true}},{name:"disabled",rawName:"v-disabled",value:(_vm.disabled),expression:"disabled"}],staticClass:"g3w-input-pick-layer skin-color",attrs:{"slot":"label-action"},on:{"click":function($event){$event.stopPropagation();return _vm.pickLayerValue($event)}},slot:"label-action"},[_c('i',{class:_vm.g3wtemplate.font['crosshairs']})]):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"disabled",rawName:"v-disabled",value:(_vm.disabled),expression:"disabled"}],attrs:{"slot":"body","tabIndex":_vm.tabIndex},slot:"body"},[(_vm.filterFields.length > 0 && _vm.isFilterFieldsReady)?_c('div',{staticClass:"g3w-relation-reference-fields-content"},[_vm._l((_vm.filterFields),function(rf,index){return [_c('select',{directives:[{name:"select2",rawName:"v-select2",value:('filterFields'),expression:"'filterFields'"}],ref:("filterField_" + (rf.id)),refInFor:true,staticClass:"form-control",staticStyle:{"width":"100%"},attrs:{"select2_value":rf.value,"indexItem":index,"id":rf.id,"disabled":rf.disabled}},_vm._l((rf.values),function(ref){
var key = ref.key;
var value = ref.value;
return _c('option',{domProps:{"value":_vm.getValue(value)}},[_vm._v("\n            "+_vm._s(key)+"\n          ")])}),0)]}),_vm._v(" "),_c('divider')],2):_vm._e(),_vm._v(" "),_c('select',{ref:"select",staticClass:"form-control",staticStyle:{"width":"100%"}},[(_vm.showNullOption)?_c('option',{domProps:{"value":_vm.select2NullValue}}):_vm._e(),_vm._v(" "),_vm._l((_vm.state.input.options.values),function(ref){
var key = ref.key;
var value = ref.value;
return _c('option',{key:_vm.getValue(value),domProps:{"value":_vm.getValue(value)}},[_vm._v("\n          "+_vm._s(key)+"\n      ")])})],2)]),_vm._v(" "),('error' === _vm.loadingState )?_c('p',{directives:[{name:"t",rawName:"v-t",value:('server_error'),expression:"'server_error'"}],staticClass:"error-input-message",attrs:{"slot":"message"},slot:"message"}):_vm._e()])}
__vue__options__.staticRenderFns = []
__vue__options__._scopeId = "data-v-77dd4e5c"

},{"gui/inputs/input":46,"gui/inputs/picklayer/service":53,"map/layers/layer":190,"mixins":200,"services/gui":207,"store/application":212,"utils/createSingleFieldParameter":230,"utils/getCatalogLayerById":238,"vueify/lib/insert-css":35}],110:[function(require,module,exports){
;(function(){
Object.defineProperty(exports, "__esModule", {
  value: true
});


var Input = require('gui/inputs/input');

exports.default = {
  name: 'input-slider-range',

  mixins: [Input],
  watch: {
    'state.input.options.min': function stateInputOptionsMin() {
      this.service.changeInfoMessage();
    },
    'state.input.options.max': function stateInputOptionsMax() {
      this.service.changeInfoMessage();
    }
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('baseinput',{attrs:{"state":_vm.state}},[_c('div',{attrs:{"slot":"body"},slot:"body"},[_c('span',{staticStyle:{"font-weight":"bold"}},[_vm._v(_vm._s(_vm.state.value))]),_vm._v(" "),_c('input',{directives:[{name:"disabled",rawName:"v-disabled",value:(!_vm.editable),expression:"!editable"},{name:"model",rawName:"v-model",value:(_vm.state.value),expression:"state.value"}],class:{'input-error-validation' : _vm.notvalid},staticStyle:{"width":"100%","padding-right":"5px"},attrs:{"slot":"body","tabIndex":_vm.tabIndex,"min":_vm.state.input.options.min,"max":_vm.state.input.options.max,"type":"range","step":_vm.state.input.options.step},domProps:{"value":(_vm.state.value)},on:{"change":_vm.change,"__r":function($event){return _vm.$set(_vm.state, "value", $event.target.value)}},slot:"body"})])])}
__vue__options__.staticRenderFns = []

},{"gui/inputs/input":46}],111:[function(require,module,exports){
;(function(){
Object.defineProperty(exports, "__esModule", {
  value: true
});


var Input = require('gui/inputs/input');

exports.default = {
  name: "input-text",

  mixins: [Input]
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('baseinput',{attrs:{"state":_vm.state}},[_c('input',{directives:[{name:"disabled",rawName:"v-disabled",value:(!_vm.editable),expression:"!editable"},{name:"model",rawName:"v-model",value:(_vm.state.value),expression:"state.value"}],staticClass:"form-control",class:{'input-error-validation' : _vm.notvalid},attrs:{"slot":"body","placeholder":_vm.state.default,"tabIndex":_vm.tabIndex,"field":_vm.state.name,"id":_vm.state.name},domProps:{"value":(_vm.state.value)},on:{"keyup":function($event){_vm.isMobile() ? _vm.mobileChange($event) : _vm.change()},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.state, "value", $event.target.value)}},slot:"body"})])}
__vue__options__.staticRenderFns = []

},{"gui/inputs/input":46}],112:[function(require,module,exports){
var __vueify_style_dispose__ = require("vueify/lib/insert-css").insert("textarea[data-v-572218b0]{resize:none;border:1px solid #ccc}")
;(function(){
Object.defineProperty(exports, "__esModule", {
  value: true
});


var Input = require('gui/inputs/input');

exports.default = {
  name: "input-textarea",

  mixins: [Input]
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('baseinput',{attrs:{"state":_vm.state}},[_c('textarea',{directives:[{name:"disabled",rawName:"v-disabled",value:(!_vm.editable),expression:"!editable"},{name:"model",rawName:"v-model",value:(_vm.state.value),expression:"state.value"}],class:{'input-error-validation' : _vm.notvalid},staticStyle:{"max-width":"100%","min-width":"100%"},attrs:{"slot":"body","placeholder":_vm.state.default,"rows":"3","tabIndex":_vm.tabIndex},domProps:{"value":(_vm.state.value)},on:{"keydown":function($event){$event.stopPropagation();},"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.state, "value", $event.target.value)},_vm.change],"change":_vm.change},slot:"body"})])}
__vue__options__.staticRenderFns = []
__vue__options__._scopeId = "data-v-572218b0"

},{"gui/inputs/input":46,"vueify/lib/insert-css":35}],113:[function(require,module,exports){
var __vueify_style_dispose__ = require("vueify/lib/insert-css").insert("button.ql-html{width:40px!important}button.ql-html:after{content:\"html\"}")
;(function(){
Object.defineProperty(exports, "__esModule", {
  value: true
});

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var Input = require('gui/inputs/input');

exports.default = {
  name: "input-html",

  mixins: [Input],
  methods: {
    setupTableCustomTools: function setupTableCustomTools() {
      var buttonColumnLeft = this.$el.querySelector('.ql-column-left');
      buttonColumnLeft.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-caret-left-square" viewBox="0 0 16 16"><path d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z"/><path d="M10.205 12.456A.5.5 0 0 0 10.5 12V4a.5.5 0 0 0-.832-.374l-4.5 4a.5.5 0 0 0 0 .748l4.5 4a.5.5 0 0 0 .537.082z"/></svg>';
      buttonColumnLeft.title = "Add column left";

      var buttonColumnRight = this.$el.querySelector('.ql-column-right');
      buttonColumnRight.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-caret-right-square" viewBox="0 0 16 16"><path d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z"/><path d="M5.795 12.456A.5.5 0 0 1 5.5 12V4a.5.5 0 0 1 .832-.374l4.5 4a.5.5 0 0 1 0 .748l-4.5 4a.5.5 0 0 1-.537.082z"/></svg>';
      buttonColumnRight.title = "Add column right";

      var buttonColumnRemove = this.$el.querySelector('.ql-column-remove');
      buttonColumnRemove.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-square" viewBox="0 0 16 16"><path d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z"/><path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/></svg>';
      buttonColumnRemove.title = "Remove column";

      var buttonRowAbove = this.$el.querySelector('.ql-row-above');
      buttonRowAbove.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-caret-up-square" viewBox="0 0 16 16"><path d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z"/><path d="M3.544 10.705A.5.5 0 0 0 4 11h8a.5.5 0 0 0 .374-.832l-4-4.5a.5.5 0 0 0-.748 0l-4 4.5a.5.5 0 0 0-.082.537z"/></svg>';
      buttonRowAbove.title = "Add row above";


      var buttonRowBelow = this.$el.querySelector('.ql-row-below');
      buttonRowBelow.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-caret-down-square" viewBox="0 0 16 16"><path d="M3.626 6.832A.5.5 0 0 1 4 6h8a.5.5 0 0 1 .374.832l-4 4.5a.5.5 0 0 1-.748 0l-4-4.5z"/><path d="M0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2zm15 0a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V2z"/></svg>';
      buttonRowBelow.title = "Add row below";

      var buttonRowRemove = this.$el.querySelector('.ql-row-remove');
      buttonRowRemove.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-dash-square" viewBox="0 0 16 16"><path d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z"/><path d="M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8z"/></svg>';
      buttonRowRemove.title = "Remove row";
    }
  },
  created: function created() {
    this.edit_state = {
      edit: false,
      show_html: false
    };

    if (!this.state.edit_states) {
      this.state.edit_states = [];
    }
    this.state.edit_states.push(this.edit_state);
  },
  mounted: function () {
    var _ref = _asyncToGenerator(function* () {
      var _this = this;

      var toolbarOptions = [[{ header: [1, 2, 3, 4, 5, 6, false] }], [{ 'align': '' }, { 'align': 'center' }, { 'align': 'right' }, { 'align': 'justify' }], [{ 'color': [] }, { 'background': [] }], ['bold', 'italic', 'underline', { 'list': 'ordered' }, { 'list': 'bullet' }, 'link', 'clean', 'html'], ['table', 'column-left', 'column-right', 'column-remove', 'row-above', 'row-below', 'row-remove']];
      yield this.$nextTick();
      this.quill = new Quill(this.$refs.quill_editor, {
        modules: {
          table: true,
          toolbar: {
            container: toolbarOptions,
            handlers: {
              html: function html() {
                _this.edit_state.show_html = !_this.edit_state.show_html;
                if (_this.edit_state.show_html) {
                  _this.quill.container.firstChild.innerText = _this.quill.container.firstChild.innerHTML;
                } else {
                  _this.quill.container.firstChild.innerHTML = _this.quill.container.firstChild.innerText;
                }
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                  for (var _iterator = _this.$el.querySelectorAll('.ql-formats')[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var qlformat = _step.value;
                    var _iteratorNormalCompletion2 = true;
                    var _didIteratorError2 = false;
                    var _iteratorError2 = undefined;

                    try {
                      for (var _iterator2 = qlformat.children[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                        var child = _step2.value;

                        if (!child.classList.contains('ql-html')) {
                          child.classList.toggle('g3w-disabled');
                        } else {
                          child.classList.toggle('skin-color');
                        }
                      }
                    } catch (err) {
                      _didIteratorError2 = true;
                      _iteratorError2 = err;
                    } finally {
                      try {
                        if (!_iteratorNormalCompletion2 && _iterator2.return) {
                          _iterator2.return();
                        }
                      } finally {
                        if (_didIteratorError2) {
                          throw _iteratorError2;
                        }
                      }
                    }
                  }
                } catch (err) {
                  _didIteratorError = true;
                  _iteratorError = err;
                } finally {
                  try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                      _iterator.return();
                    }
                  } finally {
                    if (_didIteratorError) {
                      throw _iteratorError;
                    }
                  }
                }
              },
              'column-left': function columnLeft() {
                return _this.table.insertColumnLeft();
              },
              'column-right': function columnRight() {
                return _this.table.insertColumnRight();
              },
              'column-remove': function columnRemove() {
                return _this.table.deleteColumn();
              },
              'row-above': function rowAbove() {
                return _this.table.insertRowAbove();
              },
              'row-below': function rowBelow() {
                return _this.table.insertRowBelow();
              },
              'row-remove': function rowRemove() {
                return _this.table.deleteRow();
              }
            }

          }
        },
        theme: 'snow'
      });
      this.quill.container.firstChild.innerHTML = this.state.value;

      this.table = this.quill.getModule('table');
      this.setupTableCustomTools();

      this.handler = function () {
        _this.state.value = _this.edit_state.show_html ? _this.quill.container.firstChild.innerText : _this.quill.container.firstChild.innerHTML;
        _this.edit_state.edit = true;
        _this.change();
        setTimeout(function () {
          return _this.edit_state.edit = false;
        });
      };

      this.quill.on('text-change', this.handler);
    });

    function mounted() {
      return _ref.apply(this, arguments);
    }

    return mounted;
  }(),

  watch: {
    'state.value': function stateValue(value) {
      if (!this.edit_state.edit) {
        if (this.edit_state.show_html) {
          this.quill.container.firstChild.innerText = value;
        } else {
          this.quill.container.firstChild.innerHTML = value;
        }
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.quill.off('text-change', this.handler);
    this.handler = null;
    this.quill = null;
    this.edit_state.edit = false;
    this.edit_state.show_html = false;
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('baseinput',{directives:[{name:"disabled",rawName:"v-disabled",value:(!_vm.editable),expression:"!editable"}],attrs:{"state":_vm.state}},[_c('div',{ref:"quill_editor",staticClass:"form-control",style:({border: _vm.novalid ? '1px solid reed' : '1px solid #ccc'}),attrs:{"slot":"body"},on:{"keydown":function($event){$event.stopPropagation();}},slot:"body"})])}
__vue__options__.staticRenderFns = []

},{"gui/inputs/input":46,"vueify/lib/insert-css":35}],114:[function(require,module,exports){
;(function(){
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _mixins = require('mixins');

var _getUniqueDomId = require('utils/getUniqueDomId');

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var Input = require('gui/inputs/input');

exports.default = {
  name: "input-unique",

  mixins: [Input, _mixins.selectMixin],
  data: function data() {
    return { id: 'unique_' + (0, _getUniqueDomId.getUniqueDomId)() };
  },
  mounted: function () {
    var _ref = _asyncToGenerator(function* () {
      var _this = this;

      yield this.$nextTick();
      this.select2 = $('#' + this.id).select2({
        dropdownParent: $('#g3w-view-content'),
        tags: this.state.input.options.editable,
        language: this.getLanguage()
      });
      if (null !== this.state.value) {
        this.select2.val(this.state.value).trigger('change');
      }
      this.select2.on('select2:select', function () {
        var _ref2 = _asyncToGenerator(function* (e) {
          var value = e.params.data.$value ? e.params.data.$value : e.params.data.id;
          _this.state.value = 'null' === value ? null : ['integer', 'float', 'bigint'].includes(_this.state.type) ? Number(value) : value;

          _this.changeSelect(_this.state.value);
          yield _this.$nextTick();
        });

        return function (_x) {
          return _ref2.apply(this, arguments);
        };
      }());
    });

    function mounted() {
      return _ref.apply(this, arguments);
    }

    return mounted;
  }()
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('baseinput',{directives:[{name:"disabled",rawName:"v-disabled",value:(!_vm.editable),expression:"!editable"}],attrs:{"state":_vm.state}},[_c('select',{staticClass:"form-control",staticStyle:{"width":"100%"},attrs:{"slot":"body","id":_vm.id,"tabIndex":_vm.tabIndex},slot:"body"},[_c('option',{attrs:{"value":"null"}}),_vm._v(" "),_vm._l((_vm.state.input.options.values),function(value){return _c('option',{key:value,domProps:{"value":_vm.getValue(value)}},[_vm._v(_vm._s(_vm.getValue(value)))])})],2)])}
__vue__options__.staticRenderFns = []

},{"gui/inputs/input":46,"mixins":200,"utils/getUniqueDomId":252}],115:[function(require,module,exports){
var __vueify_style_dispose__ = require("vueify/lib/insert-css").insert("#marker[data-v-4f6ba470]{width:15px;height:15px;border:2px solid #ff0;border-radius:10px;background-color:#ff0;opacity:.8}.g3w-map-controls-left-bottom[data-v-4f6ba470]{position:absolute;bottom:75px;left:10px;z-index:1}#g3w-map-info[data-v-4f6ba470]{position:absolute;top:60px;left:5px;font-weight:700;z-index:100;background:hsla(0,0%,100%,.6);padding:5px;border-radius:3px}#g3w-maps[data-v-4f6ba470]{position:relative;width:100%;height:100%}.g3w-map[data-v-4f6ba470]{position:absolute;width:100%;height:100%}.g3w-map.show[data-v-4f6ba470]{display:block}.g3w-map.hide[data-v-4f6ba470]{display:none}#map_footer[data-v-4f6ba470]{position:absolute;bottom:0;height:30px;width:100%;display:flex;justify-content:space-between;background-color:hsla(0,0%,100%,.7)}#permalink[data-v-4f6ba470]{font-weight:700;font-size:1.2em;padding:5px;cursor:pointer;background-color:#eee}#switch-mouse-coordinate[data-v-4f6ba470]{display:flex;height:100%;margin-left:8px;align-items:center;cursor:pointer}#switch-mouse-coordinate span[data-v-4f6ba470]{padding:3px}#map_footer_right[data-v-4f6ba470]{flex-shrink:0}.drop-area[data-v-4f6ba470]:not([hidden]){display:flex}.drop-area[data-v-4f6ba470]{justify-content:center;align-items:center;width:100%;height:100%;color:#fff;font-size:4em;position:absolute;z-index:100;background-color:#222d32;pointer-events:none}.drop-area[data-v-4f6ba470]:before{border:5px dashed #fff;content:\"\";bottom:60px;left:60px;position:absolute;right:60px;top:60px}")
;(function(){
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _application = require('store/application');

var _application2 = _interopRequireDefault(_application);

var _copyUrl = require('utils/copyUrl');

var _waitFor = require('utils/waitFor');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

exports.default = {
  name: 'g3w-map',

  data: function data() {
    var service = this.$options.service;

    return {
      target: this.$options.service.target,
      hidemaps: service.state.hidemaps,
      map_info: service.state.map_info,
      service: service,
      mouse: {
        visible: true,
        switch_icon: false,
        epsg_4326: false,
        tooltip: null
      },
      urlCopied: false,
      mapunit: _application2.default.map.unit
    };
  },


  computed: {
    version: function version() {
      return 'Powered by G3W-SUITE ' + initConfig.version;
    },
    showmapunits: function showmapunits() {
      return this.service.state.mapunits.length > 1;
    }
  },

  methods: {
    onDrop: function onDrop(e) {
      document.querySelector('.drop-area').toggleAttribute('hidden', 'dragenter' !== e.type);
      if (e.dataTransfer.files && 'drop' === e.type) {
        var map = GUI.getService('map');
        var q = document.querySelector.bind(document);

        var setOption = function () {
          var _ref = _asyncToGenerator(function* (el, value) {
            el = '#modal-addlayer ' + el;
            yield (0, _waitFor.waitFor)(function () {
              return q(el);
            }, 1000);
            q(el).value = value;
            q(el).dispatchEvent(new Event('input'));
            q(el).dispatchEvent(new Event('change'));
          });

          return function setOption(_x, _x2) {
            return _ref.apply(this, arguments);
          };
        }();
        var setFile = function () {
          var _ref2 = _asyncToGenerator(function* (file) {
            yield (0, _waitFor.waitFor)(function () {
              return !q('#add-layer-type').value;
            }, 5000);
            if (map.getLayerByName(file.name)) {
              return console.assert(!map.getLayerByName(file.name), 'Unable to add layer: ' + file.name);
            }
            setTimeout(function () {
              return console.assert(map.getLayerByName(file.name), 'Unable to add layer: ' + file.name);
            }, 2500);
            yield setOption('#add-layer-type', 'file');
            yield (0, _waitFor.waitFor)(function () {
              return q('#addcustomlayer input[type="file"]');
            }, 1000);
            var data = new DataTransfer();
            data.items.add(file);
            q('#addcustomlayer input[type="file"]').files = data.files;
            q('#addcustomlayer input[type="file"]').dispatchEvent(new Event('change'));
            $('#modal-addlayer').modal('show');
          });

          return function setFile(_x3) {
            return _ref2.apply(this, arguments);
          };
        }();
        setFile(e.dataTransfer.files[0]);
      }
    },
    showHideControls: function showHideControls() {
      this.service.getMapControls().forEach(function (c) {
        return "scaleline" !== c.type && c.control.showHide();
      });
    },
    createCopyMapExtentUrl: function createCopyMapExtentUrl() {
      var _this = this;

      var url = new URL(location.href);
      url.searchParams.set('map_extent', this.service.getMapExtent().toString());
      (0, _copyUrl.copyUrl)(url.toString());
      this.urlCopied = !this.urlCopied;
      setTimeout(function () {
        return _this.urlCopied = false;
      }, 5000);
    },
    switchMapsCoordinateTo4326: function switchMapsCoordinateTo4326() {
      this.mouse.epsg_4326 = !this.mouse.epsg_4326;
      this.service.getMapControlByType({ type: 'mouseposition' }).dispatchEvent({
        type: 'change:epsg',
        epsg: this.mouse.epsg_4326 ? 'EPSG:4326' : this.service.getEpsg()
      });
    }
  },

  watch: {
    'mapunit': function mapunit(unit) {
      _application2.default.map.unit = unit;
      this.service.changeScaleLineUnit(unit);
    }
  },

  mounted: function () {
    var _ref3 = _asyncToGenerator(function* () {
      var _this2 = this;

      this.crs = this.service.getCrs();

      yield this.$nextTick();

      this.service.onafter('addHideMap', _asyncToGenerator(function* () {
        var _ref5 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            ratio = _ref5.ratio,
            _ref5$layers = _ref5.layers,
            layers = _ref5$layers === undefined ? [] : _ref5$layers,
            _ref5$mainview = _ref5.mainview,
            mainview = _ref5$mainview === undefined ? false : _ref5$mainview,
            _ref5$switchable = _ref5.switchable,
            switchable = _ref5$switchable === undefined ? false : _ref5$switchable;

        yield _this2.$nextTick();
        _this2.service._addHideMap({ ratio: ratio, layers: layers, mainview: mainview, switchable: switchable });
      }));

      this.service.once('ready', function () {
        if (_this2.service.getMapControlByType({ type: 'mouseposition' })) {
          _this2.mouse.switch_icon = _this2.service.getMapControlByType({ type: 'mouseposition' }) && 'EPSG:4326' !== _this2.service.getEpsg();
          _this2.mouse.tooltip = 'ESPG ' + _this2.service.getCrs().split(':')[1] + ' \u2194 WGS84';
        } else {
          _this2.mouse.visible = false;
        }
      });
    });

    function mounted() {
      return _ref3.apply(this, arguments);
    }

    return mounted;
  }(),
  destroyed: function destroyed() {
    this.service.clear();
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
__vue__options__.render = function render () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"g3w-maps"}},[_vm._l((_vm.hidemaps),function(hidemap){return _c('div',{key:hidemap.id,staticClass:"g3w-map hidemap",attrs:{"id":hidemap.id}})}),_vm._v(" "),_c('div',{staticClass:"g3w-map",attrs:{"id":_vm.target},on:{"drop":function($event){$event.preventDefault();return _vm.onDrop($event)},"dragenter":function($event){$event.preventDefault();return _vm.onDrop($event)},"dragleave":function($event){$event.preventDefault();return _vm.onDrop($event)},"dragover":function($event){$event.preventDefault();}}},[_c('div',{staticClass:"drop-area",attrs:{"hidden":""}},[_vm._v("\n      Upload Files\n    ")]),_vm._v(" "),_c('div',{ref:"g3w-map-controls",staticClass:"g3w-map-controls rv",staticStyle:{"display":"flex"}}),_vm._v(" "),(_vm.map_info.info)?_c('div',{ref:"g3w-map-info",style:(_vm.map_info.style),attrs:{"id":"g3w-map-info"}},[_vm._v("\n      "+_vm._s(_vm.map_info.info)+"\n    ")]):_vm._e(),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"g3w-map-controls-left-bottom"})]),_vm._v(" "),_c('div',{staticClass:"skin-border-color",attrs:{"id":"map_footer"}},[_c('div',{staticStyle:{"display":"flex"},attrs:{"id":"map_footer_left"}},[_c('a',{staticStyle:{"margin-left":"5px","align-self":"center"},attrs:{"href":"https://g3wsuite.it/","target":"_blank","title":_vm.version}},[_c('img',{attrs:{"height":"15","src":"/static/client/images/g3wsuite_logo.png","alt":""}})])]),_vm._v(" "),_c('div',{staticStyle:{"display":"flex"},attrs:{"id":"map_footer_right"}},[(_vm.mouse.visible && _vm.mouse.switch_icon && !_vm.isMobile())?_c('div',{directives:[{name:"t-tooltip",rawName:"v-t-tooltip:top.create",value:(_vm.mouse.tooltip),expression:"mouse.tooltip",arg:"top",modifiers:{"create":true}}],attrs:{"id":"switch-mouse-coordinate"},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.switchMapsCoordinateTo4326($event)}}},[_c('span',{staticClass:"skin-color-dark hide-cursor-caret-color",class:_vm.$fa('mouse')})]):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.mouse.visible),expression:"mouse.visible"}],attrs:{"id":"mouse-position-control"}}),_vm._v(" "),_c('div',{directives:[{name:"t-tooltip",rawName:"v-t-tooltip:top.create",value:('sdk.tooltips.copy_map_extent_url'),expression:"'sdk.tooltips.copy_map_extent_url'",arg:"top",modifiers:{"create":true}}],staticClass:"skin-color-dark",class:( _obj = {}, _obj[_vm.$fa('link')] = !_vm.urlCopied, _obj[_vm.$fa('success')] = _vm.urlCopied, _obj ),attrs:{"id":"permalink"},on:{"click":function($event){$event.stopPropagation();return _vm.createCopyMapExtentUrl($event)}}}),_vm._v(" "),_c('div',{attrs:{"id":"scale-control"}}),_vm._v(" "),(_vm.showmapunits)?_c('div',{attrs:{"id":"scale-line-units"}},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.mapunit),expression:"mapunit"}],staticClass:"skin-color-dark",staticStyle:{"padding":"5px 2px","font-weight":"bold","border":"0","cursor":"pointer"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.mapunit=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.service.state.mapunits),function(unit){return _c('option',{directives:[{name:"t",rawName:"v-t",value:(("sdk.mapcontrols.scaleline.units." + unit)),expression:"`sdk.mapcontrols.scaleline.units.${unit}`"}],staticStyle:{"font-weight":"bold"},domProps:{"value":unit,"selected":_vm.mapunit === unit}})}),0)]):_vm._e()])])],2)}
__vue__options__.staticRenderFns = [function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"display":"none"}},[_c('div',{attrs:{"id":"marker"}})])}]
__vue__options__._scopeId = "data-v-4f6ba470"

},{"store/application":212,"utils/copyUrl":224,"utils/waitFor":278,"vueify/lib/insert-css":35}],116:[function(require,module,exports){
var __vueify_style_dispose__ = require("vueify/lib/insert-css").insert("li[data-v-4a706ff4]:not(.skin-background-color){display:flex;align-items:center;gap:10px}li.gcd-icon-poi .gcd-city[data-v-4a706ff4],li.gcd-icon-poi .gcd-country[data-v-4a706ff4],li.gcd-icon-poi .gcd-road[data-v-4a706ff4],li.gcd-icon-road .gcd-icon[data-v-4a706ff4],li.gcd-icon-road .gcd-name[data-v-4a706ff4],li.gcd-icon-road .gcd-type[data-v-4a706ff4]{display:none}#gcd-search[data-v-4a706ff4]{z-index:1;width:2.5em;height:100%;border-radius:0;background-color:var(--skin-color,#fff)}#gcd-trash[data-v-4a706ff4],#markers-visibility-layer[data-v-4a706ff4],#show-markers-results[data-v-4a706ff4]{z-index:1;border-radius:0!important;color:#fff;border-left:1px solid #fff}#gcd-trash[data-v-4a706ff4]{color:red}#gcd-input-query[data-v-4a706ff4]{font-weight:700}.gcd-txt-reset[data-v-4a706ff4]:after{content:\"\\d7\";display:inline-block;font-weight:700;font-size:2em;cursor:pointer;color:var(--skin-color)}.gcd-txt-reset[data-v-4a706ff4]{z-index:1;width:2.5em;height:100%;line-height:100%;border:none;background-color:transparent;display:inline-block;vertical-align:middle;outline:0;cursor:pointer}.gcd-txt-input[data-v-4a706ff4]:focus{outline:none}.gcd-txt-input[data-v-4a706ff4]{z-index:1;border:0;width:100%;height:100%;padding:5px;text-indent:6px;background-color:transparent;font-family:inherit;font-size:1em}.gcd-txt-control[data-v-4a706ff4]{position:relative;display:flex;justify-content:flex-end;height:41px;background-color:#fff;overflow:hidden;border-radius:2px;width:100%;border:2px solid var(--skin-color)}@keyframes spin{0%{transform:rotate(0deg)}to{transform:rotate(1turn)}}.gcd-road[data-v-4a706ff4]{font-size:.875em;font-weight:500}.gcd-city[data-v-4a706ff4]{font-size:1em;font-weight:700}.gcd-country[data-v-4a706ff4]{font-size:.75em}.gcd-spin[data-v-4a706ff4]:after{animation:spin .7s linear infinite}.gcd-hidden[data-v-4a706ff4]{display:none!important}li.skin-background-color[data-v-4a706ff4]{position:sticky;top:0}li.selected[data-v-4a706ff4]{background-color:#f7fabf!important}li.gcd-noresult[data-v-4a706ff4]:hover{background-color:transparent!important}li.gcd-noresult[data-v-4a706ff4]{font-weight:700;color:#384247;margin:10px;border-bottom:0!important}\n.ol-geocoder{box-sizing:border-box;position:absolute;max-width:300px;top:3px;left:45px;width:50%;height:6px;font-size:1.1em}@media (max-width:767px){.ol-geocoder{left:10px}}.ol-geocoder>ul>li:hover{background-color:#eee}.ol-geocoder>ul>li{width:100%;overflow:hidden;padding:0;min-height:30px;padding-left:3px;border-bottom:2px solid var(--skin-color);min-height:20px;padding:10px}.ol-geocoder>ul{border-radius:3px!important;width:100%;max-height:200px;padding:0;margin-top:3px;background-color:#fff;border-top:none;overflow-x:hidden;overflow-y:auto;transition:max-height .3s ease-in;margin-bottom:0}.ol-geocoder>ul>li>a{display:block;text-decoration:none;padding:3px 5px;color:#000}.ol-geocoder>ul>li:last-child{border-bottom:0!important}")
;(function(){
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _gui = require('services/gui');

var _gui2 = _interopRequireDefault(_gui);

var _application = require('store/application');

var _application2 = _interopRequireDefault(_application);

var _QueryResultsActionChooseLayer = require('components/QueryResultsActionChooseLayer.vue');

var _QueryResultsActionChooseLayer2 = _interopRequireDefault(_QueryResultsActionChooseLayer);

var _plugins = require('store/plugins');

var _plugins2 = _interopRequireDefault(_plugins);

var _projections = require('store/projections');

var _projections2 = _interopRequireDefault(_projections);

var _getUniqueDomId = require('utils/getUniqueDomId');

var _flattenObject = require('utils/flattenObject');

var _addZValue = require('utils/addZValue');

var _isPointGeometryType = require('utils/isPointGeometryType');

var _convertSingleMultiGeometry = require('utils/convertSingleMultiGeometry');

var _getCatalogLayerById = require('utils/getCatalogLayerById');

var _getCatalogLayers = require('utils/getCatalogLayers');

var _g3wI18n = require('g3w-i18n');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var PROVIDERS = window.initConfig.mapcontrols.geocoding ? window.initConfig.mapcontrols.geocoding.providers : {};
Object.keys(PROVIDERS).forEach(function (p) {
  var script = document.createElement('script');
  script.src = window.initConfig.staticurl + 'client/geocoding-providers/' + p + '.js';
  script.async = true;
  document.head.appendChild(script);
});

var LAYER = new ol.layer.Vector({
  id: '__g3w_marker',
  name: 'Geocoding',
  source: new ol.source.Vector(),
  style: function style(feature) {
    if ('__g3w_marker_coordinates' === feature.getId()) {
      return new ol.style.Style({
        text: new ol.style.Text({
          offsetY: -15,
          text: '\uF3C5',
          font: '900 3em "Font Awesome 5 Free"',
          stroke: new ol.style.Stroke({
            color: 'red',
            width: 3
          }),
          fill: new ol.style.Fill({
            color: 'rgba(255, 0,0, 0.7)'
          })
        })
      });
    } else {
      return [new ol.style.Style({
        image: new ol.style.Icon({
          opacity: 1,
          src: '/static/client/images/pushpin.svg',
          scale: 0.8
        })
      }), new ol.style.Style({
        image: new ol.style.RegularShape({
          stroke: new ol.style.Stroke({ color: [0, 0, 0, 0] }),
          points: 4,
          radius: 50,
          angle: Math.PI / 4
        })
      })];
    }
  }
});

var is_clearing = false;

exports.default = {
  data: function data() {
    return {
      results: [],

      disabled: false,
      results_panel_open: false };
  },


  props: {
    providers: {
      type: Object,
      default: {}
    }

  },

  computed: {
    is_layer_visible: function is_layer_visible() {
      return LAYER.getVisible();
    },
    features: function features() {
      return LAYER.getSource().getFeatures();
    },
    has_providers: function has_providers() {
      return Object.keys(this.providers).length > 0;
    },
    extent: function extent() {
      var map = _gui2.default.getService('map');
      var project = map.getProject().state;
      return ol.proj.transformExtent(Object.keys(this.providers).filter(function (p) {
        return 'nominatim' != p;
      }).length > 0 ? map.getMapExtent() : project.initextent || project.extent, project.crs.epsg, 'EPSG:4326');
    },
    placeholder: function placeholder() {
      return _application2.default.language && (0, _g3wI18n.t)('mapcontrols.geocoding.placeholder');
    }
  },

  methods: {
    _hideMarker: function _hideMarker() {
      LAYER.getSource().clear();

      if (false === this.is_layer_visible) {
        this.toggleLayerVisibility();
      }
    },
    toggleLayerVisibility: function toggleLayerVisibility() {
      LAYER.setVisible(!this.is_layer_visible);
    },
    clearResults: function clearResults() {
      this.results.splice(0);

      if (LAYER.getSource().getFeatureById('__g3w_marker_coordinates')) {
        LAYER.getSource().removeFeature(LAYER.getSource().getFeatureById('__g3w_marker_coordinates'));
      }
    },
    clearMarkers: function clearMarkers() {
      is_clearing = true;
      this._hideMarker();

      this.results.forEach(function (i) {
        return i.__selected = false;
      });
      var layer = _gui2.default.getService('queryresults').getState().layers.find(function (l) {
        return l.id === LAYER.get('id');
      });

      if (layer) {
        layer.features.forEach(function (f) {
          return _gui2.default.getService('queryresults').removeFeatureLayerFromResult(layer, f);
        });
      }
      is_clearing = false;
    },
    clear: function clear() {
      this.clearResults();
      this.clearMarkers();
    },
    query: function () {
      var _ref = _asyncToGenerator(function* (q) {
        var _this = this;

        var map = _gui2.default.getService('map');

        var isNumber = function isNumber(value) {
          return 'number' === typeof value && !Number.isNaN(value);
        };
        var coordinates = null;
        var transform = false;

        var _split = (q || '').split(','),
            _split2 = _slicedToArray(_split, 3),
            x = _split2[0],
            y = _split2[1],
            epsg = _split2[2];

        var projection = epsg && (yield _projections2.default.registerProjection('EPSG:' + epsg.trim()));

        if (isNumber(1 * x) && isNumber(1 * y)) {
          coordinates = [1 * x, 1 * y];
        }

        try {
          if (projection) {
            coordinates = ol.proj.transform(coordinates, projection.getCode(), 'EPSG:4326');
            transform = true;
          }
        } catch (e) {
          console.warn(e);
        }

        if (coordinates) {
          var source = LAYER.getSource();

          if (source.getFeatureById('__g3w_marker_coordinates')) {
            source.removeFeature(source.getFeatureById('__g3w_marker_coordinates'));
          }

          var feature = new ol.Feature({
            geometry: new ol.geom.Point(transform ? ol.proj.transform(coordinates, 'EPSG:4326', map.getEpsg()) : coordinates),

            lon: coordinates[0],
            lat: coordinates[1]
          });

          feature.setId('__g3w_marker_coordinates');

          LAYER.getSource().addFeature(feature);

          map.zoomToGeometry(new ol.geom.Point(transform ? ol.proj.transform(coordinates, 'EPSG:4326', map.getEpsg()) : coordinates));
          return coordinates;
        }

        if (!coordinates) {
          this.clearResults();
          this.$refs.reset.classList.add("gcd-spin");

          (yield Promise.allSettled(Object.entries(this.providers).map(function (_ref2) {
            var _ref3 = _slicedToArray(_ref2, 2),
                p = _ref3[0],
                _ref3$ = _ref3[1],
                config = _ref3$ === undefined ? {} : _ref3$;

            return PROVIDERS[p].fetch({
              url: config.url,
              icon: config.icon,
              query: q,
              lang: _application2.default.language || 'it-IT',

              limit: 5,
              extent: _this.extent
            });
          }))).filter(function (p) {
            return 'fulfilled' === p.status;
          }).forEach(function (p) {
            _this.results.push({
              __heading: true,
              provider: p.value.provider,
              label: _this.providers[p.value.provider].label || p.value.label
            });

            if (!(p.value.results && p.value.results.length)) {
              _this.results.push({
                __no_results: !(p.value.results && p.value.results.length)
              });
              return;
            }

            p.value.results.forEach(function (item) {
              _this.results.push((0, _flattenObject.flattenObject)(_extends({}, item, {
                provider: p.value.provider,
                __uid: (0, _getUniqueDomId.getUniqueDomId)(),
                __icon: _this.providers[p.value.provider].icon || p.value.icon,
                __selected: false
              })));
            });
          });

          this.$refs.reset.classList.remove("gcd-spin");
        }
      });

      function query(_x) {
        return _ref.apply(this, arguments);
      }

      return query;
    }(),
    onQuery: function onQuery(evt) {
      if ('Enter' === evt.key || 13 === evt.which || 13 === evt.keyCode) {
        evt.preventDefault();
        this.query(evt.target.value.trim());
      }
    },
    onValue: function onValue(e) {
      this.$refs.reset.classList.toggle("gcd-hidden", 0 === e.target.value.trim().length);
    },
    onReset: function onReset() {
      this.$refs.input.focus();
      this.$refs.input.value = '';
      this.$refs.reset.classList.add("gcd-hidden");
      this.clearResults();
    },
    _removeItem: function _removeItem(uid) {
      var item = (this.results || []).find(function (r) {
        return uid === r.__uid;
      });

      if (this.features.length) {
        var source = LAYER.getSource();
        source.removeFeature(source.getFeatureById(uid));
      }

      if (item) {
        item.__selected = false;
      }

      if (0 === this.features.length) {
        this._hideMarker();
      }

      if (!is_clearing) {
        this.showMarkerResults(undefined, 0 === this.features.length);
      }
    },
    onItemClick: function onItemClick(evt, item) {
      if (!item.lat || !item.lon) {
        return;
      }
      evt.preventDefault();
      try {
        var source = LAYER.getSource();

        if (source.getFeatureById(item.__uid)) {
          this._removeItem(item.__uid);
        } else {
          var __uid = item.__uid,
              __icon = item.__icon,
              __selected = item.__selected,
              _item = _objectWithoutProperties(item, ['__uid', '__icon', '__selected']);

          var feature = new ol.Feature(_extends({
            geometry: new ol.geom.Point(ol.proj.transform([parseFloat(item.lon), parseFloat(item.lat)], 'EPSG:4326', _gui2.default.getService('map').getEpsg()))
          }, _item));

          feature.setId(__uid);
          source.addFeature(feature);
          _gui2.default.getService('map').zoomToFeatures([feature]);
          item.__selected = true;
          this.showMarkerResults([feature]);
        }
      } catch (e) {
        console.warn(e);
      }
    },
    showMarkerResults: function () {
      var _ref4 = _asyncToGenerator(function* (features) {
        var toggle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

        if (this.results_panel_open && toggle) {
          _gui2.default.closeContent();
          return;
        }

        if (_gui2.default.getCurrentContent()) {
          yield _gui2.default.closeContent();
        }
        _gui2.default.showQueryResults('Geocoding', { data: [{ layer: LAYER, features: features || LAYER.getSource().getFeatures() }] });
        this.results_panel_open = true;
      });

      function showMarkerResults(_x3) {
        return _ref4.apply(this, arguments);
      }

      return showMarkerResults;
    }(),
    _editItem: function () {
      var _ref5 = _asyncToGenerator(function* (layerId, feature) {
        var editing = _plugins2.default.getPlugin('editing');

        if (!editing) {
          return;
        }

        this.disabled = true;
        try {
          var type = (0, _getCatalogLayerById.getCatalogLayerById)(layerId).getGeometryType();

          var _feature = (0, _addZValue.addZValue)({
            geometryType: type,
            feature: new ol.Feature(_extends({}, Object.entries(feature.attributes).reduce(function (acc, attr) {
              return _extends({}, acc, _defineProperty({}, attr[0].replace(feature.attributes.provider + '_', '').toLowerCase(), attr[1]));
            }, {}), feature.attributes, {
              geometry: (0, _convertSingleMultiGeometry.convertSingleMultiGeometry)(feature.geometry, type)
            }))
          });

          yield editing.addLayerFeature({ layerId: layerId, feature: _feature });
        } catch (e) {
          console.warn(e);
        }
        this.disabled = false;
      });

      function _editItem(_x4, _x5) {
        return _ref5.apply(this, arguments);
      }

      return _editItem;
    }()
  },

  created: function created() {
    var _this2 = this;

    var queryresults = _gui2.default.getService('queryresults');
    var mapService = _gui2.default.getService('map');
    var map = mapService.getMap();

    map.addLayer(LAYER);

    mapService.on('set-layer-zindex', function (_ref6) {
      var layer = _ref6.layer,
          zindex = _ref6.zindex;

      if (layer.get('id') !== LAYER.get('id')) {
        LAYER.setZIndex(zindex + 1);
      }
    });

    queryresults.registerVectorLayer(LAYER);

    _gui2.default.on('closecontent', function () {
      _this2.results_panel_open = false;
    });
    _gui2.default.onafter('setContent', function () {
      if (_this2.results_panel_open) _this2.results_panel_open = false;
    });

    queryresults.onafter('removeFeatureLayerFromResult', function (layer, feature) {
      if (LAYER.get('id') === layer.id) {
        _this2._removeItem(feature.id);
      }
    });

    queryresults.onafter('addActionsForLayers', function (actions, layers) {

      var layer = layers.find(function (l) {
        return LAYER.get('id') === l.id;
      });

      if (!layer) {
        return;
      }

      var editablePointLayers = (0, _getCatalogLayers.getCatalogLayers)({ EDITABLE: true, GEOLAYER: true }).filter(function (l) {
        return (0, _isPointGeometryType.isPointGeometryType)(l.getGeometryType());
      }).map(function (l) {
        return { id: l.getId(), name: l.getName(), inediting: l.isInEditing() };
      });

      if (editablePointLayers.find(function (l) {
        return l.inediting;
      })) {
        return;
      }

      queryresults.addCurrentActionToolsLayer({
        id: _QueryResultsActionChooseLayer2.default.name,
        layer: layer,
        action: {
          id: 'choose_layer',
          class: _gui2.default.getFontClass('pencil'),
          state: Vue.observable({ toggled: Array(layer.features.length).fill(null) }),
          toggleable: true,
          hint: 'Choose a layer',
          cbk: function cbk(layer, feature, action, index) {
            if (1 === editablePointLayers.length) {
              _this2._editItem(editablePointLayers[0].id, feature);
              return;
            }

            action.state.toggled[index] = !action.state.toggled[index];
            queryresults.setCurrentActionLayerFeatureTool({
              layer: layer,
              index: index,
              action: action,
              component: action.state.toggled[index] ? _QueryResultsActionChooseLayer2.default : null
            });
          }
        },
        config: {
          layers: editablePointLayers,
          icon: 'pencil',
          label: 'mapcontrols.geocoding.choose_layer',
          nolayers: 'mapcontrols.geocoding.nolayers',
          cbk: _this2._editItem
        }
      });
    });
  },
  destroyed: function destroyed() {
    _gui2.default.getService('queryresults').unregisterVectorLayer(LAYER);
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.has_providers)?_c('div',{class:[ 'ol-geocoder', { 'g3w-disabled': _vm.disabled }]},[_c('div',{staticClass:"gcd-txt-control"},[_c('input',{ref:"input",staticClass:"gcd-txt-input",attrs:{"type":"text","id":"gcd-input-query","autocomplete":"off","placeholder":_vm.placeholder},on:{"keyup":_vm.onQuery,"input":_vm.onValue}}),_vm._v(" "),_c('button',{ref:"reset",staticClass:"gcd-txt-reset gcd-hidden",attrs:{"type":"button","id":"gcd-input-reset","title":"Reset search"},on:{"click":function($event){$event.stopPropagation();return _vm.onReset($event)}}}),_vm._v(" "),_c('button',{staticClass:"btn",attrs:{"type":"button","id":"gcd-search","title":"Submit search"},on:{"click":function($event){$event.stopPropagation();return (function () { return _vm.query(_vm.$refs.input.value); })($event)}}},[_c('i',{class:_vm.$fa('search'),staticStyle:{"color":"#fff"},attrs:{"aria-hidden":"true"}})]),_vm._v(" "),(_vm.features.length > 0)?_c('button',{staticClass:"btn skin-background-color",attrs:{"type":"button","id":"gcd-trash","title":"Clear markers selection"},on:{"click":function($event){$event.stopPropagation();return _vm.clearMarkers($event)}}},[_c('i',{class:_vm.$fa('trash'),attrs:{"aria-hidden":"true"}})]):_vm._e(),_vm._v(" "),(_vm.features.length > 0)?_c('button',{staticClass:"btn skin-background-color",attrs:{"type":"button","id":"markers-visibility-layer","title":"Toggle markers visibility"},on:{"click":function($event){$event.stopPropagation();return _vm.toggleLayerVisibility($event)}}},[_c('i',{class:_vm.$fa(_vm.is_layer_visible ? 'eye-close': 'eye'),attrs:{"aria-hidden":"true"}})]):_vm._e(),_vm._v(" "),(_vm.features.length > 0)?_c('button',{staticClass:"btn skin-background-color",attrs:{"type":"button","id":"show-markers-results","title":"Toggle sidebar panel"},on:{"click":function($event){$event.stopPropagation();return (function () { return _vm.showMarkerResults(undefined, true); })($event)}}},[_c('code',{style:({ opacity: _vm.results_panel_open ? 0.5 : undefined })},[_vm._v("\n      "+_vm._s(_vm.features.length > 99 ? '99+' : _vm.features.length)+"\n    ")])]):_vm._e()]),_vm._v(" "),_c('ul',{ref:"result",staticClass:"gcd-txt-result"},_vm._l((_vm.results),function(item,i){return _c('li',{key:item.__uid,class:[
        item.provider,
        item.__icon       ? 'gcd-icon-' + item.__icon : '',
        item.__heading    ? 'skin-background-color' : '',
        item.__no_results ? 'gcd-noresult' : '',
        item.__selected   ? 'selected' : '' ],on:{"click":function($event){$event.stopPropagation();return _vm.onItemClick($event, item)}}},[(item.__heading)?_c('div',{staticStyle:{"display":"flex","justify-content":"space-between","padding":"5px"}},[_c('span',{staticStyle:{"color":"#FFF","font-weight":"bold"}},[_vm._v(_vm._s(item.label))])]):(item.__no_results)?_c('span',{directives:[{name:"t",rawName:"v-t",value:('mapcontrols.geocoding.noresults'),expression:"'mapcontrols.geocoding.noresults'"}]}):[_c('span',{class:_vm.$fa(item.__selected ? 'check' : 'uncheck'),staticStyle:{"color":"#000","padding":"5px"}}),_vm._v(" "),('road' === item.__icon)?_c('i',{staticClass:"fa fa-road",staticStyle:{"color":"black"},attrs:{"aria-hidden":"true"}}):('poi' === item.__icon)?_c('img',{staticClass:"gcd-icon",attrs:{"src":"/static/client/images/pushpin.svg","width":"24","height":"24"}}):_vm._e(),_vm._v(" "),_c('a',{attrs:{"href":"","draggable":"false"}},[(item.type)?_c('div',{staticClass:"gcd-type"},[_vm._v(_vm._s(item.type))]):_vm._e(),_vm._v(" "),(item.name)?_c('div',{staticClass:"gcd-name"},[_vm._v(_vm._s(item.name))]):_vm._e(),_vm._v(" "),(item.address_name)?_c('div',{staticClass:"gcd-road"},[_vm._v(_vm._s(item.address_name))]):_vm._e(),_vm._v(" "),(item.address_road || item.address_building || item.address_house_number)?_c('div',{staticClass:"gcd-road"},[_vm._v(_vm._s(item.address_building)+" "+_vm._s(item.address_road)+" "+_vm._s(item.address_house_number))]):_vm._e(),_vm._v(" "),(item.address_city || item.address_town || item.address_village)?_c('div',{staticClass:"gcd-city"},[_vm._v(_vm._s(item.address_postcode)+" "+_vm._s(item.address_city)+" "+_vm._s(item.address_town)+" "+_vm._s(item.address_village))]):_vm._e(),_vm._v(" "),(item.address_state || item.address_country)?_c('div',{staticClass:"gcd-country"},[_vm._v(_vm._s(item.address_state)+" "+_vm._s(item.address_country))]):_vm._e()])]],2)}),0)]):_vm._e()}
__vue__options__.staticRenderFns = []
__vue__options__._scopeId = "data-v-4a706ff4"

},{"components/QueryResultsActionChooseLayer.vue":128,"g3w-i18n":162,"services/gui":207,"store/application":212,"store/plugins":213,"store/projections":214,"utils/addZValue":216,"utils/convertSingleMultiGeometry":222,"utils/flattenObject":236,"utils/getCatalogLayerById":238,"utils/getCatalogLayers":239,"utils/getUniqueDomId":252,"utils/isPointGeometryType":260,"vueify/lib/insert-css":35}],117:[function(require,module,exports){
var __vueify_style_dispose__ = require("vueify/lib/insert-css").insert(".ol-zoom-history[data-v-7eaa278c]{display:flex!important;gap:5px}")
;(function(){
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _gui = require('services/gui');

var _gui2 = _interopRequireDefault(_gui);

var _debounce = require('utils/debounce');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: "MapControlZoomHistory",
  data: function data() {
    return {
      history: {
        index: 0,
        items: []
      }
    };
  },

  methods: {
    last: function last() {
      this.history.index--;
      this.setMapExtent();
    },
    next: function next() {
      this.history.index++;
      this.setMapExtent();
    },
    setMapExtent: function setMapExtent() {
      _gui2.default.getService('map').getMap().getView().fit(this.history.items[this.history.index]);
    }
  },
  computed: {
    hasEmptyHistory: function hasEmptyHistory() {
      return 0 === this.history.index && 1 === this.history.items.length || this.history.items.length - 1 === this.history.index;
    }
  },

  created: function created() {
    var _this = this;

    var map = _gui2.default.getService('map').getMap();
    var view = map.getView();

    this.history.items.push(view.calculateExtent(map.getSize()));

    this.changeKeyEvent = view.on('change', (0, _debounce.debounce)(function (evt) {
      if (_this.history.index !== _this.history.items.length - 1) {
        _this.history.items.splice(_this.history.index - _this.history.items.length + 1);
      }
      _this.history.items.push(evt.target.calculateExtent(map.getSize()));
      _this.history.index++;
    }, 600));
  },
  beforeDestroy: function beforeDestroy() {
    ol.Observable.unByKey(this.changeKeyEvent);
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ol-zoom-history ol-unselectable ol-control"},[_c('div',{directives:[{name:"t-tooltip",rawName:"v-t-tooltip:top.create",value:('sdk.mapcontrols.zoomhistory.zoom_last'),expression:"'sdk.mapcontrols.zoomhistory.zoom_last'",arg:"top",modifiers:{"create":true}}]},[_c('button',{directives:[{name:"disabled",rawName:"v-disabled",value:(0 === _vm.history.index),expression:"0 === history.index"}],attrs:{"type":"button"},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.last($event)}}},[_c('i',{class:_vm.$fa('reply')})])]),_vm._v(" "),_c('div',{directives:[{name:"t-tooltip",rawName:"v-t-tooltip:top.create",value:('sdk.mapcontrols.zoomhistory.zoom_next'),expression:"'sdk.mapcontrols.zoomhistory.zoom_next'",arg:"top",modifiers:{"create":true}}]},[_c('button',{directives:[{name:"disabled",rawName:"v-disabled",value:(_vm.hasEmptyHistory),expression:"hasEmptyHistory"}],attrs:{"type":"button"},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.next($event)}}},[_c('i',{class:_vm.$fa('share')})])])])}
__vue__options__.staticRenderFns = []
__vue__options__._scopeId = "data-v-7eaa278c"

},{"services/gui":207,"utils/debounce":232,"vueify/lib/insert-css":35}],118:[function(require,module,exports){
var __vueify_style_dispose__ = require("vueify/lib/insert-css").insert("#addcustomlayer[data-v-338521e9]{margin:10px 0;position:relative;border:2px dashed #97a1a8;display:flex;flex-direction:column;text-align:center;gap:8px;opacity:.8}#addcustomlayer input[data-v-338521e9]{position:absolute;outline:none;opacity:0;cursor:pointer;inset:0}#add_wms_url[data-v-338521e9]::placeholder{font-size:85%;opacity:.5}.g3w-wms-panel-title[data-v-338521e9]{font-size:1.2em;font-weight:700;margin-bottom:10px}")
;(function(){
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _vueColor = require('vue-color');

var _jszip = require('jszip/dist/jszip.min');

var _jszip2 = _interopRequireDefault(_jszip);

var _shp = require('shpjs/dist/shp');

var _shp2 = _interopRequireDefault(_shp);

var _g3wConstants = require('g3w-constants');

var _application = require('store/application');

var _application2 = _interopRequireDefault(_application);

var _projections = require('store/projections');

var _projections2 = _interopRequireDefault(_projections);

var _gui = require('services/gui');

var _gui2 = _interopRequireDefault(_gui);

var _getUniqueDomId = require('utils/getUniqueDomId');

var _XHR = require('utils/XHR');

var _imagelayer = require('map/layers/imagelayer');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

Object.entries({
  RasterLayer: _imagelayer.RasterLayer
}).forEach(function (_ref) {
  var _ref2 = _slicedToArray(_ref, 2),
      k = _ref2[0],
      v = _ref2[1];

  return console.assert(undefined !== v, k + ' is undefined');
});

function _CSVToArray(text) {
  var separator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ',';

  var pattern = new RegExp('(' + separator + '|\r?\n|\r|^)' + '(?:"([^"]*(?:""[^"]*)*)"|' + '([^"' + separator + "\r\n]*))", "gi");

  var data = [[]];
  var matches = null;

  while (matches = pattern.exec(text)) {
    if (matches[0] === '\r\n') {
      break;
    }

    if (matches[1].length && matches[1] !== separator) {
      data.push([]);
    }

    data.at(-1).push(matches[2] ? matches[2].replace(new RegExp('""', 'g'), '"') : matches[3]);
  }

  return data;
}

exports.default = {
  name: 'modal-addlayer',

  data: function data() {

    return {
      layer_type: undefined,
      file_type: null,
      layer_name: null,
      layer_crs: _application2.default.project.getProjection().getCode(),
      layer_color: {
        hex: '#194d33',
        rgba: { r: 25, g: 77, b: 51, a: 1 },
        a: 1
      },
      wms_config: null,
      wms_urls: [],
      wms_projection: null,
      wms_styles: [],
      wms_layers: [],
      wms_visible: true,
      wms_opacity: 1,
      url: null,
      id: null,
      olLayer: null,
      map_crs: _application2.default.project.getProjection().getCode(),
      position: 'top',
      persistent: false,
      loading: false,
      fields: [],
      field: null,
      csv_x: null,
      csv_y: null,
      csv_wkt: null,
      csv_separator: ',',
      csv_loading: false,
      name: undefined,
      title: null,
      layers: [],
      projections: [],
      error_message: '',
      parse_errors: []
    };
  },


  components: {
    'chrome-picker': _vueColor.Chrome
  },

  computed: {
    feature_count: function feature_count() {
      return this.olLayer && this.olLayer.getSource().getFeatures().length || 0;
    }
  },

  watch: {
    wms_styles: function wms_styles() {
      var wms_styles = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      var config = this.wms_config || {};
      var layers = (config.layers || []).filter(function (l, i) {
        return wms_styles.includes(i.toString());
      });
      var last = (config.layers || []).findLastIndex(function (l) {
        return l == layers.at(-1);
      });
      var projections = (config.layers || []).map(function (_ref3) {
        var crss = _ref3.crss;
        return crss.map(function (crs) {
          return 'EPSG:' + crs.epsg;
        }).sort();
      })[last];

      if (0 === layers.length) {
        this.wms_projection = null;
        this.projections = [];
      } else if (1 === layers.length) {
        this.wms_projection = projections[0];
        this.projections = projections;
      } else {
        this.projections = this.projections.filter(function (p) {
          return projections.includes(p);
        });
      }

      if (layers.length) {
        var i = 0;
        var styles = ' (' + layers.map(function (l) {
          return l.title;
        }).join(' + ') + ')';
        var suffix = styles;
        while (_gui2.default.getService('map').getLayerByName(config.title + suffix)) {
          suffix = ' ' + styles + ' (' + ++i + ')';
        }
        this.name = config.title + suffix;
      }

      this.wms_layers = layers;
    },
    wms_projection: function () {
      var _ref4 = _asyncToGenerator(function* () {
        var _this = this;

        yield this.$nextTick();
        var config = this.wms_config || {};
        var projections = (config.layers || []).map(function (_ref5) {
          var crss = _ref5.crss;
          return crss.map(function (crs) {
            return 'EPSG:' + crs.epsg;
          }).sort();
        });

        this.layers = null === this.wms_projection ? config.layers : config.layers.filter(function (l, i) {
          return projections[i].includes(_this.wms_projection);
        });
      });

      function wms_projection() {
        return _ref4.apply(this, arguments);
      }

      return wms_projection;
    }(),
    layer_type: function () {
      var _ref6 = _asyncToGenerator(function* (type, oldtype) {
        if (type && oldtype) {
          this.layer_type = undefined;
          yield this.$nextTick();
          this.layer_type = type;
        }
        if ('file' === oldtype) {
          this.unloadFile();
        }
        if ('wms' === oldtype) {
          this.unloadWMS();
        }
      });

      function layer_type(_x3, _x4) {
        return _ref6.apply(this, arguments);
      }

      return layer_type;
    }(),
    url: function url() {
      var _this2 = this;

      if (this.url && !this.wms_config && this.wms_urls.some(function (l) {
        return l.url == _this2.url;
      })) {
        this.id = this.wms_urls.find(function (l) {
          return l.url == _this2.url;
        }).id;
      } else if (!this.url) {
        this.id = '';
      }
    }
  },

  methods: {
    onChangeColor: function onChangeColor(val) {
      this.layer_color = val;
    },
    parseFile: function () {
      var _ref7 = _asyncToGenerator(function* () {
        var _this3 = this;

        var input = this.$refs.input_file;

        if (!input.accept.split(',').includes('.' + input.files[0].name.split('.').at(-1).toLowerCase())) {
          this.error_message = 'sdk.errors.unsupported_format';
          return;
        }

        if (_gui2.default.getService('map').getLayerByName(input.files[0].name)) {
          this.error_message = 'layer_is_added';
          return;
        }

        try {

          this.error_message = '';
          this.parse_errors = [];
          this.layer_name = input.files[0].name;
          this.file_type = input.files[0].name.split('.').at(-1).toLowerCase();
          this.layer_data = null;

          var features = [];
          var data = void 0;

          (this.fields || []).splice(0);
          if ('kmz' === this.file_type) {
            var zip = new _jszip2.default();
            zip.load((yield input.files[0].arrayBuffer(input.files[0])));
            data = zip.file(/.kml$/i).at(-1).asText();
          }

          if ('zip' === this.file_type) {
            var _zip = yield input.files[0].arrayBuffer();
            var out = {};
            var unzipped = yield _jszip2.default.loadAsync(input.files[0]);
            for (var f in unzipped.files) {
              if (/.+\.(shp|dbf|json|prj|cpg)$/i.test(f)) {
                var ext = (f.split('.').at(-1) || '').toLowerCase();
                out[ext] = yield unzipped.files[f].async(['shp', 'dbf'].includes(ext) ? 'arraybuffer' : 'text');
              }
            }
            data = JSON.stringify((yield (0, _shp2.default)(out)));
          }

          if ('csv' === this.file_type) {
            this.csv_loading = true;

            data = _CSVToArray((yield input.files[0].text()), this.csv_separator);
            var X = ['x', 'lng', 'longitude', 'longitudine'];
            var Y = ['y', 'lat', 'latitude', 'latitudine'];
            this.fields = data.shift();
            var wkt = this.fields.findIndex(function (f) {
              return 'wkt' === f.toLowerCase();
            });
            var x = this.fields.findIndex(function (f) {
              return X.includes(f.toLowerCase());
            });
            var y = this.fields.findIndex(function (f) {
              return Y.includes(f.toLowerCase());
            });
            this.csv_wkt = this.csv_wkt || this.fields[wkt];
            this.csv_x = this.csv_wkt || this.csv_x || this.fields[x] || this.fields[0];
            this.csv_y = this.csv_wkt || this.csv_y || this.fields[y] || this.fields[1];

            data.forEach(function (row, i) {
              var X = Number(row[x]);
              var Y = Number(row[y]);

              if (!_this3.csv_wkt && (Number.isNaN(X) || Number.isNaN(Y))) {
                return _this3.parse_errors.push({ row: i + 1, value: data[i] });
              }
              try {
                var feat = new ol.Feature(_extends({
                  geometry: new ol.format.WKT().readGeometry(_this3.csv_wkt ? row[wkt] : 'POINT (' + X + ' ' + Y + ')', {
                    dataProjection: _this3.layer_crs,
                    featureProjection: _gui2.default.getService('map').getEpsg()
                  })
                }, row.reduce(function (props, value, i) {
                  props[_this3.fields[i]] = value;return props;
                }, {})));
                feat.setId(i);
                features.push(feat);
              } catch (e) {
                console.warn(e);
              }
            });

            this.csv_loading = false;
          }

          if (!data) {
            data = (yield input.files[0].text()) || {};
          }

          this.layer_crs = ['kml', 'kmz'].includes(this.file_type) ? 'EPSG:4326' : this.layer_crs;
          this.layer_data = data;

          if ('csv' !== this.file_type) {
            features = {
              'gpx': new ol.format.GPX(),
              'gml': new ol.format.WMSGetFeatureInfo(),
              'geojson': new ol.format.GeoJSON(),
              'zip': new ol.format.GeoJSON(),
              'kml': new ol.format.KML({ extractStyles: false }),
              'kmz': new ol.format.KML({ extractStyles: false })
            }[this.file_type].readFeatures(data, {
              dataProjection: this.layer_crs,
              featureProjection: _gui2.default.getService('map').getEpsg() || this.layer_crs
            });
          }

          if ('zip' === this.file_type && this.layer_crs !== 'EPSG:4326') {
            features.forEach(function (f) {
              return f.getGeometry().transform('EPSG:4326', _this3.layer_crs);
            });
          }

          if (['kml', 'kmz'].includes(this.file_type)) {
            features.forEach(function (f) {
              return f.unset('styleUrl');
            });
          }

          if (features.length > 0) {
            this.olLayer = new ol.layer.Vector({
              source: new ol.source.Vector({ features: features }),
              name: this.layer_name,
              id: (0, _getUniqueDomId.getUniqueDomId)()
            });
            this.fields = 'csv' === this.file_type ? this.fields : Object.keys(features[0].getProperties()).filter(function (prop) {
              return _g3wConstants.GEOMETRY_FIELDS.indexOf(prop) < 0;
            });
          }
        } catch (e) {
          console.warn(e);
          this.error_message = 'sdk.errors.add_external_layer';
        }
      });

      function parseFile() {
        return _ref7.apply(this, arguments);
      }

      return parseFile;
    }(),
    addLayer: function () {
      var _ref8 = _asyncToGenerator(function* () {
        var _this4 = this;

        this.loading = true;

        if ('wms' === this.layer_type) {
          var name = (this.name || 'wms_' + (0, _getUniqueDomId.getUniqueDomId)()).trim();

          try {
            var data = this.getLocalWMSData();

            var found = this.wms_config && (data.wms[this.url] || []).some(function (wms) {
              return wms.layers.length === _this4.wms_layers.length && _this4.wms_layers.every(function (l) {
                return wms.layers.includes(l.name);
              });
            });

            if (found) {
              yield this.fetchWMS(this.url);
            }

            var config = {
              url: this.url,
              name: name,
              layers: this.wms_layers.map(function (l) {
                return l.name;
              }),
              epsg: this.wms_projection,
              position: this.position,
              visible: this.wms_visible,
              opacity: +this.wms_opacity
            };

            data.wms[this.url] = data.wms[this.url] || [];
            data.wms[this.url].push(config);

            this.updateLocalWMSData(data);

            try {
              yield this._addExternalWMSLayer(config);
            } catch (e) {
              console.warn(e);
              _gui2.default.getService('map').removeExternalLayer(name);
              this.deleteWMS(name);
              setTimeout(function () {
                _gui2.default.showUserMessage({ type: 'warning', message: 'sidebar.wms.layer_add_error' });
              });
            }
          } catch (e) {
            console.warn(e);
          }
          if (this.wms_config) {
            this.unloadWMS();
            $('#modal-addlayer').modal('hide');
          }
        }

        if ('file' === this.layer_type) {
          try {
            yield _projections2.default.registerProjection(this.layer_crs);
          } catch (e) {
            console.warn(e);
            this.error_message = 'sdk.errors.' + e;
            return;
          }
          try {
            yield _gui2.default.getService('map').addExternalLayer(this.olLayer, {
              crs: this.layer_crs,
              position: this.position,
              color: this.layer_color,
              field: this.field,
              persistent: !!this.persistent,
              type: this.file_type
            });
            $(this.$refs.modal_addlayer).modal('hide');
            this.unloadFile();
          } catch (e) {
            console.warn(e);
            this.error_message = 'sdk.errors.add_external_layer';
          }
        }
        this.loading = false;
      });

      function addLayer() {
        return _ref8.apply(this, arguments);
      }

      return addLayer;
    }(),
    unloadFile: function unloadFile() {
      this.error_message = '';
      this.parse_errors = [];
      this.loading = false;
      this.layer_name = null;
      this.file_type = null;
      this.layer_crs = _gui2.default.getService('map').getCrs();
      this.layer_color = { hex: '#194d33', rgba: { r: 25, g: 77, b: 51, a: 1 }, a: 1 };
      this.layer_data = null;
      this.olLayer = null;
      this.fields = [];
      this.field = null;
      this.csv_x = null;
      this.csv_y = null;
      this.csv_wkt = null;

      if (this.$refs.input_file) {
        this.$refs.input_file.value = null;
      }
    },
    unloadWMS: function unloadWMS() {
      var _this5 = this;

      var url = this.url;
      this.url = '';
      this.error_message = '';
      this.wms_config = null;
      this.wms_layers = [];
      this.wms_opacity = 1;
      this.wms_visible = true;
      this.wms_styles = [];
      this.name = null;
      this.loading = false;

      setTimeout(function () {
        return _this5.url = url;
      });
    },
    addWmsURL: function () {
      var _ref9 = _asyncToGenerator(function* () {
        var _this6 = this;

        this.loading = true;
        var wms = { url: this.url, id: this.id, show: true };
        var found = this.wms_urls.find(function (l) {
          return l.url === _this6.url;
        });
        try {
          yield this.fetchWMS(this.url);
          if (!found) {
            var data = this.getLocalWMSData();
            this.wms_urls.push(wms);
            data.urls = this.wms_urls;
            this.updateLocalWMSData(data);
          }
        } catch (e) {
          console.warn(e);
        }
        this.loading = false;
      });

      function addWmsURL() {
        return _ref9.apply(this, arguments);
      }

      return addWmsURL;
    }(),
    deleteWmsUrl: function deleteWmsUrl(id) {
      this.wms_urls = this.wms_urls.filter(function (l) {
        return id !== l.id;
      });
      var data = this.getLocalWMSData();
      data.urls = this.wms_urls;
      this.updateLocalWMSData(data);
    },
    _addExternalWMSLayer: function _addExternalWMSLayer() {
      var _this7 = this;

      var _ref10 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          url = _ref10.url,
          layers = _ref10.layers,
          name = _ref10.name,
          _ref10$epsg = _ref10.epsg,
          epsg = _ref10$epsg === undefined ? _gui2.default.getService('map').getEpsg() : _ref10$epsg,
          _ref10$position = _ref10.position,
          position = _ref10$position === undefined ? 'top' : _ref10$position,
          opacity = _ref10.opacity,
          _ref10$visible = _ref10.visible,
          visible = _ref10$visible === undefined ? true : _ref10$visible;

      return new Promise(function (res, rej) {
        var wmslayer = new _imagelayer.RasterLayer({ id: name || (0, _getUniqueDomId.getUniqueDomId)(), layers: layers, projection: ol.proj.get(epsg), url: url });
        var olLayer = wmslayer.getOLLayer();
        olLayer.getSource().once('imageloadend', res);
        olLayer.getSource().once('imageloaderror', rej);

        olLayer.getSource().on('imageloadend', function () {
          return wmslayer.emit('loadstart');
        });
        olLayer.getSource().on('imageloadend', function () {
          return wmslayer.emit('loadend');
        });
        olLayer.getSource().on('imageloaderror', function () {
          return wmslayer.emit('loaderror');
        });


        _gui2.default.getService('map').addExternalLayer(wmslayer, { position: position, opacity: opacity, visible: visible });

        if (!_this7.wms_visible || !_this7.wms_opacity) {
          setTimeout(res, 1000);
        }
      });
    },
    fetchWMS: function () {
      var _ref11 = _asyncToGenerator(function* (url) {
        this.loading = true;
        try {
          var config = yield _XHR.XHR.post({
            url: '' + window.initConfig.interfaceowsurl,
            contentType: 'application/json',
            data: JSON.stringify({ url: url || this.url, service: "wms" })
          });

          if (!config.result) {
            throw 'invalid response';
          }

          config.wmsurl = url || this.url;

          if (config.methods && config.methods.GetMap) {
            this.url = (config.methods.GetMap.urls || []).find(function (u) {
              return 'Get' === u.type;
            }).url;
          } else {
            this.url = config.wmsurl;
          }

          this.title = config.title;

          var i = 0;
          var suffix = '';
          while (_gui2.default.getService('map').getLayerByName(config.title + suffix)) {
            suffix = ' (' + ++i + ')';
          }
          this.name = config.title + suffix;

          config.layers.forEach(function (_ref12) {
            var crss = _ref12.crss;
            return crss.forEach(function (crs) {
              return _projections2.default.get(crs);
            });
          });

          this.layers = config.layers;

          this.wms_config = config;
          this.error_message = null;
        } catch (e) {
          console.warn(e);
          this.error_message = e;
        }
        this.loading = false;
      });

      function fetchWMS(_x6) {
        return _ref11.apply(this, arguments);
      }

      return fetchWMS;
    }(),
    deleteWMS: function deleteWMS(name) {
      var data = this.getLocalWMSData();
      Object.keys(data.wms || {}).forEach(function (url) {
        var i = data.wms[url].findIndex(function (w) {
          return w.name == name;
        });

        if (i >= 0) {
          data.wms[url].splice(i, 1);
        }

        if (!data.wms[url].length) {
          delete data.wms[url];
        }
      });
      this.updateLocalWMSData(data);
    },
    changeLayerData: function changeLayerData(name) {
      var attr = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var data = this.getLocalWMSData();
      Object.keys(data.wms).find(function (url) {
        var i = data.wms[url].findIndex(function (l) {
          return l.name == name;
        });
        if (-1 !== i) {
          data.wms[url][i][attr.key] = attr.value;
          return true;
        }
      });
      this.updateLocalWMSData(data);
    },
    getLocalWMSData: function getLocalWMSData() {
      var item = window.localStorage.getItem('externalwms');
      return ((item ? JSON.parse(item) : undefined) || {})[_application2.default.project.getId()];
    },
    updateLocalWMSData: function updateLocalWMSData(data) {
      var item = window.localStorage.getItem('externalwms');
      var alldata = (item ? JSON.parse(item) : undefined) || {};
      alldata[_application2.default.project.getId()] = data;
      try {
        window.localStorage.setItem('externalwms', JSON.stringify(alldata));
      } catch (e) {
        console.warn(e);
      }
    },
    templateResultLayers: function templateResultLayers(state) {
      var layer = this.layers[state.id];
      if (!layer) {
        return state.text;
      }
      return $('\n        <sub>' + layer.name + '</sub><br>\n        <b>' + layer.title + '</b><br>\n        <i>' + (layer.abstract || '') + '</i>\n      ');
    },
    templateSelectionLayers: function templateSelectionLayers(state) {
      var layer = this.layers[state.id];
      if (!layer) {
        return state.text;
      }
      return $('\n        <sub>' + layer.name + '</sub><br>\n        <b>' + layer.title + '</b>\n      ');
    }
  },

  mounted: function () {
    var _ref13 = _asyncToGenerator(function* () {
      var _this8 = this;

      $('#modal-addlayer').modal('hide');
      $('#modal-addlayer').on('hide.bs.modal', function () {
        _this8.layer_type = undefined;
        _this8.unloadFile();
        _this8.unloadWMS();
      });

      yield _gui2.default.isReady();
      yield _gui2.default.getService('map').isReady();

      this.deleteWMS = this.deleteWMS.bind(this);

      _gui2.default.getService('map').on('remove-external-layer', this.deleteWMS);

      var data = this.getLocalWMSData();

      if (undefined === data) {
        data = {
          urls: [],
          wms: {} };
        this.updateLocalWMSData(data);
      }

      setTimeout(function () {
        var map = _gui2.default.getService('map');
        map.on('change-layer-position-map', function () {
          var _ref14 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
              name = _ref14.id,
              position = _ref14.position;

          return _this8.changeLayerData(name, { key: 'position', value: position });
        });
        map.on('change-layer-opacity', function () {
          var _ref15 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
              name = _ref15.id,
              opacity = _ref15.opacity;

          return _this8.changeLayerData(name, { key: 'opacity', value: opacity });
        });
        map.on('change-layer-visibility', function () {
          var _ref16 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
              name = _ref16.id,
              visible = _ref16.visible;

          return _this8.changeLayerData(name, { key: 'visible', value: visible });
        });

        Object.keys(data.wms).forEach(function (url) {
          data.wms[url].forEach(function (d) {
            return _this8._addExternalWMSLayer(_extends({ url: url }, d));
          });
        });
      });

      this.wms_urls = data.urls;
    });

    function mounted() {
      return _ref13.apply(this, arguments);
    }

    return mounted;
  }(),
  beforeDestroy: function beforeDestroy() {
    this.unloadFile();
    this.unloadWMS();
    $('#modal-addlayer').modal('hide');
    $('#modal-addlayer').remove();

    _gui2.default.getService('map').off('remove-external-layer', this.deleteWMS);
    this.$data = null;
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"modal_addlayer",staticClass:"modal fade",attrs:{"id":"modal-addlayer","role":"dialog","tabindex":"-1"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal"}},[_vm._v("×")]),_vm._v(" "),_c('h4',{directives:[{name:"t",rawName:"v-t",value:('mapcontrols.add_layer_control.header'),expression:"'mapcontrols.add_layer_control.header'"}],staticClass:"modal-title",staticStyle:{"font-weight":"bold"}})]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"form-group"},[_c('label',{directives:[{name:"t",rawName:"v-t",value:('layer_type'),expression:"'layer_type'"}]}),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.layer_type),expression:"layer_type"}],staticClass:"form-control",attrs:{"id":"add-layer-type"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.layer_type=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{directives:[{name:"t",rawName:"v-t",value:('choose_type'),expression:"'choose_type'"}],attrs:{"disabled":""},domProps:{"value":undefined}}),_vm._v(" "),_c('option',{directives:[{name:"t",rawName:"v-t",value:('remote_wms_url'),expression:"'remote_wms_url'"}],attrs:{"value":"wms"}}),_vm._v(" "),_c('option',{directives:[{name:"t",rawName:"v-t",value:('local_file'),expression:"'local_file'"}],attrs:{"value":"file"}})])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('bar-loader',{attrs:{"loading":_vm.loading}}),_vm._v(" "),('wms' === _vm.layer_type)?_c('div',{staticClass:"form-group"},[_c('a',{staticStyle:{"float":"right"},attrs:{"href":"https://g3w-suite.readthedocs.io/en/v3.7.x/g3wsuite_client.html#wms","target":"_blank","title":"Docs"}},[_c('i',{class:_vm.$fa('external-link')})]),_vm._v(" "),_c('fieldset',{staticClass:"form-group",attrs:{"disabled":_vm.wms_config}},[_c('label',{attrs:{"for":"add_wms_url"}},[_vm._v("URL")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.url),expression:"url",modifiers:{"trim":true}}],staticClass:"form-control",attrs:{"id":"add_wms_url","placeholder":"http://example.org/?&service=WMS&request=GetCapabilities","type":"url","list":"wms_urls","required":""},domProps:{"value":(_vm.url)},on:{"input":function($event){if($event.target.composing){ return; }_vm.url=$event.target.value.trim()},"blur":function($event){return _vm.$forceUpdate()}}}),_vm._v(" "),(!_vm.wms_config)?_c('small',{directives:[{name:"t",rawName:"v-t",value:('add_new_wms_url_help'),expression:"'add_new_wms_url_help'"}]}):_vm._e(),_vm._v(" "),_c('datalist',{attrs:{"id":"wms_urls"}},_vm._l((_vm.wms_urls),function(wms){return _c('option',{key:wms.id,domProps:{"value":wms.url}},[_vm._v(_vm._s(wms.id))])}),0)]),_vm._v(" "),(_vm.url && !_vm.wms_config && !_vm.loading)?_c('fieldset',{staticClass:"form-group",attrs:{"disabled":_vm.wms_config || _vm.wms_urls.some(function (l) { return l.url == _vm.url; })}},[_c('label',{attrs:{"for":"add_wms_name","title":"required"}},[_c('span',{directives:[{name:"t",rawName:"v-t",value:('sidebar.wms.panel.label.name'),expression:"'sidebar.wms.panel.label.name'"}]}),_vm._v(" "),_c('i',{staticStyle:{"font-family":"Monospace","color":"var(--skin-color)"}},[_vm._v("*")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.id),expression:"id",modifiers:{"trim":true}}],staticClass:"form-control",attrs:{"id":"add_wms_name","required":""},domProps:{"value":(_vm.id)},on:{"input":function($event){if($event.target.composing){ return; }_vm.id=$event.target.value.trim()},"blur":function($event){return _vm.$forceUpdate()}}}),_vm._v(" "),(null !== _vm.id && _vm.wms_urls.some(function (l) { return l.id === _vm.id; }) && _vm.wms_urls.every(function (l) { return l.url !== _vm.url; }))?_c('p',{staticStyle:{"color":"red","margin":"10px 0"}},[_vm._v("\n              ⚠️ "),_c('b',{directives:[{name:"t",rawName:"v-t",value:('sidebar.wms.layer_id_already_added'),expression:"'sidebar.wms.layer_id_already_added'"}]})]):_vm._e()]):_vm._e(),_vm._v(" "),(!_vm.wms_config)?_c('button',{staticClass:"btn btn-block btn-success",attrs:{"disabled":!(_vm.id || '').trim() || _vm.wms_urls.some(function (l) { return l.id === _vm.id && l.url !== _vm.url; }) || !(_vm.url || '').trim().match(/(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g)},on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.addWmsURL($event)}}},[_c('i',{class:_vm.$fa('plus-square')}),_vm._v(" "),_c('span',{directives:[{name:"t",rawName:"v-t",value:('connect_to_wms'),expression:"'connect_to_wms'"}]})]):_vm._e(),_vm._v(" "),(!_vm.wms_config)?_c('div',{staticClass:"form-group"},[_c('hr'),_vm._v(" "),(_vm.wms_urls.length)?_c('p',{directives:[{name:"t",rawName:"v-t",value:('saved_connections'),expression:"'saved_connections'"}],staticStyle:{"text-align":"center","font-weight":"bold"}}):_vm._e(),_vm._v(" "),_vm._l((_vm.wms_urls),function(wms){return _c('div',{key:wms.id,staticStyle:{"border-bottom":"1px solid #ccc","padding-bottom":"3px"}},[_c('div',{staticStyle:{"display":"flex","justify-content":"space-between","align-items":"center","padding-top":"3px"}},[_c('b',{staticStyle:{"flex-grow":"1","cursor":"pointer"},attrs:{"title":_vm.$t('connect_to_wms')},on:{"click":function($event){return _vm.fetchWMS(wms.url)}}},[_vm._v(_vm._s(wms.id))]),_vm._v(" "),_c('i',{directives:[{name:"t-tooltip",rawName:"v-t-tooltip:top.create",value:('connect_to_wms'),expression:"'connect_to_wms'",arg:"top",modifiers:{"create":true}}],class:_vm.$fa('eye'),staticStyle:{"color":"var(--skin-color)","padding":"3px","margin":"2px","font-size":"1.3em","cursor":"pointer"},on:{"click":function($event){return _vm.fetchWMS(wms.url)}}}),_vm._v(" "),_c('i',{directives:[{name:"t-tooltip",rawName:"v-t-tooltip:top.create",value:('sidebar.wms.delete_wms_url'),expression:"'sidebar.wms.delete_wms_url'",arg:"top",modifiers:{"create":true}}],class:_vm.$fa('trash'),staticStyle:{"color":"red","padding":"3px","margin":"2px","font-size":"1.3em","cursor":"pointer"},on:{"click":function($event){return _vm.deleteWmsUrl(wms.id)}}})]),_vm._v(" "),_c('small',{staticStyle:{"cursor":"pointer"},attrs:{"title":_vm.$t('connect_to_wms')},on:{"click":function($event){return _vm.fetchWMS(wms.url)}}},[_vm._v(_vm._s(wms.url))])])})],2):_vm._e(),_vm._v(" "),(_vm.wms_config)?_c('fieldset',{attrs:{"disabled":_vm.loading}},[_c('button',{directives:[{name:"t-tooltip",rawName:"v-t-tooltip:left.create",value:('disconnect_from_wms'),expression:"'disconnect_from_wms'",arg:"left",modifiers:{"create":true}}],staticClass:"close",staticStyle:{"float":"right","padding":"5px 10px","margin-top":"15px","outline":"1px solid","color":"red","opacity":"1"},attrs:{"type":"button"},on:{"click":_vm.unloadWMS}},[_vm._v("×")]),_vm._v(" "),_c('h3',{staticClass:"skin-color g3w-wms-panel-title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),(_vm.wms_config.abstract)?_c('fieldset',{staticClass:"form-group",staticStyle:{"border":"1px solid #c0c0c0","padding":"4.9px 8.75px 8.75px 10.5px","border-radius":"3px"}},[_c('legend',{staticStyle:{"width":"15px","height":"15px","border":"1px solid","border-radius":"50%","background-color":"#222d32","font-weight":"bold","color":"#fff","font-size":"0.7em","text-align":"center","margin":"0 -14px","user-select":"none"}},[_vm._v("i")]),_vm._v("\n              "+_vm._s(_vm.wms_config.abstract)+"\n            ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"g3w-wms-layers"}},[_c('span',{directives:[{name:"t",rawName:"v-t",value:('sidebar.wms.panel.label.layers'),expression:"'sidebar.wms.panel.label.layers'"}]})]),_vm._v(" "),_c('select',{directives:[{name:"select2",rawName:"v-select2",value:('wms_styles'),expression:"'wms_styles'"}],attrs:{"id":"g3w-wms-layers","multiple":true,"clear":true,"templateResult":_vm.templateResultLayers,"templateSelection":_vm.templateSelectionLayers}},_vm._l((_vm.layers),function(l,i){return _c('option',{domProps:{"value":i}},[_vm._v(_vm._s(l.title))])}),0)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{directives:[{name:"t",rawName:"v-t",value:('sidebar.wms.panel.label.projections'),expression:"'sidebar.wms.panel.label.projections'"}],attrs:{"for":"g3w-wms-projections"}}),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.wms_projection),expression:"wms_projection"}],staticClass:"form-control",attrs:{"id":"g3w-wms-projections"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.wms_projection=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.projections),function(p){return _c('option',[_vm._v(_vm._s(p))])}),0)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{directives:[{name:"t",rawName:"v-t",value:('layer_position.message'),expression:"'layer_position.message'"}],attrs:{"for":"position-layer"}}),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.position),expression:"position"}],staticClass:"form-control",attrs:{"id":"position-layer"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.position=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{directives:[{name:"t",rawName:"v-t",value:('layer_position.top'),expression:"'layer_position.top'"}],domProps:{"value":'top'}}),_vm._v(" "),_c('option',{directives:[{name:"t",rawName:"v-t",value:('layer_position.bottom'),expression:"'layer_position.bottom'"}],domProps:{"value":'bottom'}})])]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.wms_visible),expression:"wms_visible"}],attrs:{"id":"g3w-wms-visible","hidden":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.wms_visible=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{domProps:{"value":false}}),_vm._v(" "),_c('option',{domProps:{"value":true}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{directives:[{name:"t",rawName:"v-t",value:('catalog_items.contextmenu.layer_opacity'),expression:"'catalog_items.contextmenu.layer_opacity'"}],attrs:{"for":"g3w-wms-opacity"}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.wms_opacity),expression:"wms_opacity"}],attrs:{"id":"g3w-wms-opacity","type":"range","min":"0","max":"1","step":"0.01","list":"wms-opacity-markers"},domProps:{"value":(_vm.wms_opacity)},on:{"__r":function($event){_vm.wms_opacity=$event.target.value}}}),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{directives:[{name:"t",rawName:"v-t",value:('sidebar.wms.panel.label.name'),expression:"'sidebar.wms.panel.label.name'"}],attrs:{"for":"g3w-wms-layer-name"}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.name),expression:"name"}],staticClass:"form-control",attrs:{"id":"g3w-wms-layer-name"},domProps:{"value":(_vm.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.name=$event.target.value}}})])]):_vm._e()]):_vm._e(),_vm._v(" "),('file' === _vm.layer_type)?_c('div',{staticClass:"form-group"},[(_vm.layer_data)?_c('button',{directives:[{name:"t-tooltip",rawName:"v-t-tooltip:left.create",value:('sidebar.wms.delete_wms_url'),expression:"'sidebar.wms.delete_wms_url'",arg:"left",modifiers:{"create":true}}],staticClass:"close",staticStyle:{"float":"right","padding":"5px 10px","margin":"5px 0 0 8px","outline":"1px solid","color":"red","opacity":"1"},attrs:{"type":"button"},on:{"click":_vm.unloadFile}},[_vm._v("×")]):_vm._e(),_vm._v(" "),_c('form',{style:({ padding: _vm.layer_data ? '0' : '20px 0' }),attrs:{"id":"addcustomlayer"}},[_c('input',{ref:"input_file",attrs:{"type":"file","accept":".zip,.geojson,.GEOJSON,.kml,.kmz,.KMZ,.KML,.json,.gpx,.gml,.csv"},on:{"change":_vm.parseFile}}),_vm._v(" "),_c('h4',{staticClass:"skin-color"},[(!_vm.layer_data)?_c('b',{directives:[{name:"t",rawName:"v-t",value:('mapcontrols.add_layer_control.drag_layer'),expression:"'mapcontrols.add_layer_control.drag_layer'"}]}):(_vm.layer_name)?_c('b',[_vm._v(_vm._s(_vm.layer_name))]):_vm._e()]),_vm._v(" "),(!_vm.layer_data)?_c('i',{staticClass:"fa-5x",class:_vm.g3wtemplate.getFontClass('cloud-upload'),attrs:{"aria-hidden":"true"}}):_vm._e(),_vm._v(" "),(!_vm.layer_data)?_c('span',{staticStyle:{"font-family":"Monospace"}},[_vm._v(".gml, .geojson, .kml, .kmz, .gpx, .csv, .zip (shapefile)")]):_vm._e()]),_vm._v(" "),('csv' === _vm.file_type)?_c('div',{staticClass:"form-group",staticStyle:{"padding":"15px","border":"1px solid grey","border-radius":"3px"}},[_c('bar-loader',{attrs:{"loading":_vm.csv_loading}}),_vm._v(" "),_c('label',{directives:[{name:"t",rawName:"v-t",value:('mapcontrols.add_layer_control.select_csv_separator'),expression:"'mapcontrols.add_layer_control.select_csv_separator'"}],attrs:{"for":"g3w-select-field-layer"}}),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.csv_separator),expression:"csv_separator"}],staticClass:"form-control",attrs:{"id":"g3w-select-separator"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.csv_separator=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.parseFile]}},[_c('option',[_vm._v(",")]),_vm._v(" "),_c('option',[_vm._v(";")])]),_vm._v(" "),(_vm.fields.length > 1 && !_vm.csv_wkt)?[_c('label',{directives:[{name:"t",rawName:"v-t",value:('mapcontrols.add_layer_control.select_csv_x_field'),expression:"'mapcontrols.add_layer_control.select_csv_x_field'"}],attrs:{"for":"g3w-select-x-field"}}),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.csv_x),expression:"csv_x"}],staticClass:"form-control",attrs:{"id":"g3w-select-x-field","disabled":!(_vm.fields || []).length},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.csv_x=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.parseFile]}},_vm._l((_vm.fields),function(h){return _c('option',[_vm._v(_vm._s(h))])}),0),_vm._v(" "),_c('label',{directives:[{name:"t",rawName:"v-t",value:('mapcontrols.add_layer_control.select_csv_y_field'),expression:"'mapcontrols.add_layer_control.select_csv_y_field'"}],attrs:{"for":"g3w-select-y-field"}}),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.csv_y),expression:"csv_y"}],staticClass:"form-control",attrs:{"id":"g3w-select-y-field","disabled":!(_vm.fields || []).length},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.csv_y=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.parseFile]}},_vm._l((_vm.fields),function(h){return _c('option',[_vm._v(_vm._s(h))])}),0)]:_vm._e(),_vm._v(" "),(_vm.csv_wkt)?[_c('label',{attrs:{"for":"g3w-select-wkt-field"}},[_vm._v("WKT")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.csv_wkt),expression:"csv_wkt"}],staticClass:"form-control",attrs:{"id":"g3w-select-y-field"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.csv_wkt=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.fields),function(h){return _c('option',[_vm._v(_vm._s(h))])}),0)]:_vm._e(),_vm._v(" "),(0 === _vm.fields.length)?_c('div',{directives:[{name:"t",rawName:"v-t",value:('no_csv_fields'),expression:"'no_csv_fields'"}]}):_vm._e(),_vm._v(" "),(_vm.olLayer)?_c('small',{staticStyle:{"color":"red","display":"inline-block","margin-top":"1em"}},[_c('span',{directives:[{name:"t",rawName:"v-t",value:('sdk.querybuilder.messages.number_of_features'),expression:"'sdk.querybuilder.messages.number_of_features'"}]}),_vm._v(" "+_vm._s(_vm.feature_count))]):_vm._e()],2):_vm._e(),_vm._v(" "),_c('a',{staticStyle:{"float":"right"},attrs:{"href":("https://epsg.io/" + ((_vm.layer_crs || '').toLowerCase().replace('epsg:', ''))),"target":"_blank","title":"Docs"}},[_c('i',{class:_vm.$fa('external-link')})]),_vm._v(" "),_c('fieldset',{staticClass:"form-group",attrs:{"disabled":_vm.layer_data || ['kml','kmz'].includes(_vm.file_type)}},[_c('label',{directives:[{name:"t",rawName:"v-t",value:('mapcontrols.add_layer_control.select_projection'),expression:"'mapcontrols.add_layer_control.select_projection'"}],attrs:{"for":"projection-layer"}}),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.layer_crs),expression:"layer_crs"}],staticClass:"form-control",attrs:{"id":"projection-layer"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.layer_crs=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((new Set([_vm.map_crs, 'EPSG:3003','EPSG:3004', 'EPSG:3045', 'EPSG:3857', 'EPSG:4326', 'EPSG:6708', 'EPSG:23032', 'EPSG:23033', 'EPSG:25833', 'EPSG:32632', 'EPSG:32633'])),function(crs){return _c('option',[_vm._v(_vm._s(crs))])}),0)]),_vm._v(" "),(_vm.parse_errors.length)?_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"csv_parse_errors"}},[_vm._v("⚠️ Parse errors:")]),_vm._v(" "),_c('select',{staticClass:"form-control",staticStyle:{"background-color":"gold","font-family":"Monospace"},attrs:{"id":"csv_parse_errors"}},_vm._l((_vm.parse_errors),function(ref){
var value = ref.value;
var row = ref.row;
return _c('option',[_vm._v("["+_vm._s(row)+"] "+_vm._s(value))])}),0)]):_vm._e(),_vm._v(" "),(_vm.layer_data)?_c('div',{staticClass:"form-group"},[_c('label',{directives:[{name:"t",rawName:"v-t",value:('layer_position.message'),expression:"'layer_position.message'"}],attrs:{"for":"position-layer"}}),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.position),expression:"position"}],staticClass:"form-control",attrs:{"id":"position-layer"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.position=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{directives:[{name:"t",rawName:"v-t",value:('layer_position.top'),expression:"'layer_position.top'"}],domProps:{"value":'top'}}),_vm._v(" "),_c('option',{directives:[{name:"t",rawName:"v-t",value:('layer_position.bottom'),expression:"'layer_position.bottom'"}],domProps:{"value":'bottom'}})])]):_vm._e(),_vm._v(" "),(_vm.layer_data)?_c('div',{staticClass:"form-group"},[_c('label',{directives:[{name:"t",rawName:"v-t",value:('mapcontrols.add_layer_control.persistent_data'),expression:"'mapcontrols.add_layer_control.persistent_data'"}],attrs:{"for":"persistent-layer"}}),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.persistent),expression:"persistent"}],staticClass:"form-control",attrs:{"id":"persistent-layer"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.persistent=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{directives:[{name:"t",rawName:"v-t",value:('no'),expression:"'no'"}],domProps:{"value":false}}),_vm._v(" "),_c('option',{directives:[{name:"t",rawName:"v-t",value:('yes'),expression:"'yes'"}],domProps:{"value":true}})]),_vm._v(" "),_c('small',{directives:[{name:"t",rawName:"v-t",value:('mapcontrols.add_layer_control.persistent_help'),expression:"'mapcontrols.add_layer_control.persistent_help'"}]})]):_vm._e(),_vm._v(" "),((_vm.fields || []).length)?_c('div',{staticClass:"form-group"},[_c('label',{directives:[{name:"t",rawName:"v-t",value:('label'),expression:"'label'"}],attrs:{"for":"g3w-select-field-layer"}}),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.field),expression:"field"}],staticClass:"form-control",attrs:{"id":"g3w-select-field-layer"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.field=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{domProps:{"value":null}},[_vm._v("---")]),_vm._v(" "),_vm._l((_vm.fields),function(f){return _c('option',{key:f,domProps:{"value":f}},[_vm._v(_vm._s(f))])})],2),_vm._v(" "),_c('small',{directives:[{name:"t",rawName:"v-t",value:('mapcontrols.add_layer_control.select_field_to_show'),expression:"'mapcontrols.add_layer_control.select_field_to_show'"}]})]):_vm._e(),_vm._v(" "),(_vm.layer_data)?_c('div',[_c('p',{directives:[{name:"t",rawName:"v-t",value:('mapcontrols.add_layer_control.select_color'),expression:"'mapcontrols.add_layer_control.select_color'"}],staticStyle:{"font-weight":"700"}}),_vm._v(" "),_c('chrome-picker',{staticStyle:{"width":"100%"},on:{"input":_vm.onChangeColor},model:{value:(_vm.layer_color),callback:function ($$v) {_vm.layer_color=$$v},expression:"layer_color"}})],1):_vm._e()]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[(_vm.error_message)?_c('div',{directives:[{name:"t",rawName:"v-t",value:(_vm.error_message),expression:"error_message"}],staticStyle:{"font-weight":"bold","font-size":"1.2em","background-color":"orange","padding":"10px","text-align":"center","margin-bottom":"5px"}}):_vm._e(),_vm._v(" "),_c('button',{directives:[{name:"t",rawName:"v-t",value:('close'),expression:"'close'"}],staticClass:"btn btn-default",attrs:{"type":"button","data-dismiss":"modal"}}),_vm._v(" "),_c('button',{directives:[{name:"t",rawName:"v-t",value:('add'),expression:"'add'"}],staticClass:"btn btn-success",attrs:{"type":"button","disabled":'wms' === _vm.layer_type ? !_vm.wms_layers.length : !_vm.layer_data},on:{"click":function($event){$event.stopPropagation();return _vm.addLayer($event)}}})])])])])}
__vue__options__.staticRenderFns = [function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('datalist',{staticStyle:{"display":"flex","justify-content":"space-between"},attrs:{"id":"wms-opacity-markers"}},[_c('option',{attrs:{"value":"0"}},[_vm._v("0")]),_vm._v(" "),_c('option',{attrs:{"value":"0.25"}},[_vm._v("0.25")]),_vm._v(" "),_c('option',{attrs:{"value":"0.50"}},[_vm._v("0.50")]),_vm._v(" "),_c('option',{attrs:{"value":"0.75"}},[_vm._v("0.75")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("1")])])}]
__vue__options__._scopeId = "data-v-338521e9"

},{"g3w-constants":159,"jszip/dist/jszip.min":22,"map/layers/imagelayer":189,"services/gui":207,"shpjs/dist/shp":27,"store/application":212,"store/projections":214,"utils/XHR":215,"utils/getUniqueDomId":252,"vue-color":31,"vueify/lib/insert-css":35}],119:[function(require,module,exports){
var __vueify_style_dispose__ = require("vueify/lib/insert-css").insert(".g3w-change-map-menu-container[data-v-38eb2e23]{height:100%;display:grid;grid-template-columns:repeat(auto-fill,minmax(30%,1fr));grid-gap:1em;overflow-y:auto}.menu-item[data-v-38eb2e23]{margin-bottom:20px;margin-top:20px}.menu-item-image[data-v-38eb2e23]{cursor:pointer;position:relative;overflow:hidden;padding-bottom:50%;opacity:.7}.menu-item-image[data-v-38eb2e23]:hover{opacity:1}.menu-item-image img[data-v-38eb2e23]{position:absolute;top:0;bottom:0;left:0;right:0;margin:auto}.menu-item-content[data-v-38eb2e23]{padding:15px;background:hsla(0,0%,100%,.3)}.menu-item-text[data-v-38eb2e23]{position:relative;overflow:hidden;height:100%;text-align:justify}.menu-item-title[data-v-38eb2e23]{text-align:center;font-weight:700;background:hsla(0,0%,100%,.5);padding:5px}")
;(function(){
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var get_macro = function () {
  var _ref = _asyncToGenerator(function* (id) {
    get_macro[id] = get_macro[id] || (yield _XHR.XHR.get({ url: encodeURI('/' + _application2.default.user.i18n + '/about/api/group/' + id + '/') }));
    return get_macro[id];
  });

  return function get_macro(_x) {
    return _ref.apply(this, arguments);
  };
}();

var get_group = function () {
  var _ref2 = _asyncToGenerator(function* (id) {
    get_group[id] = get_group[id] || (yield _XHR.XHR.get({ url: encodeURI('/' + _application2.default.user.i18n + '/about/api/group/' + id + '/projects/') }));
    return get_group[id];
  });

  return function get_group(_x2) {
    return _ref2.apply(this, arguments);
  };
}();

var _application = require('store/application');

var _application2 = _interopRequireDefault(_application);

var _projections = require('store/projections');

var _projections2 = _interopRequireDefault(_projections);

var _XHR = require('utils/XHR');

var _getListableProjects = require('utils/getListableProjects');

var _gui = require('services/gui');

var _gui2 = _interopRequireDefault(_gui);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var LOGO_GIS3W = 'images/logo_gis3w_156_85.png';

exports.default = {
  name: 'modal-changemap',

  data: function data() {
    return {
      state: null,

      loading: false,

      current: 'projects',

      items: [],

      parent: null,

      steps: [],

      curr_group: null

    };
  },


  methods: {
    back: function () {
      var _ref3 = _asyncToGenerator(function* () {
        var last_step = this.steps.pop();
        var has_steps = this.steps.length > 0;
        var item = has_steps && this.steps[this.steps.length - 1];
        if (has_steps && undefined !== item.macrogroup_id || !has_steps && undefined === last_step && Array.isArray(this.parent.macrogroup_id) && this.parent.macrogroup_id.length > 0) {
            var macrogroup_id = has_steps ? item.macrogroup_id : this.parent.macrogroup_id;
            var add = !has_steps;
            return this.showMacroGroups(macrogroup_id, add);
          }

        if (has_steps && undefined === item.macrogroup_id) {
          return this.showGroups(item, false);
        }

        if (!has_steps) {
          return this.showRoot();
        }
      });

      function back() {
        return _ref3.apply(this, arguments);
      }

      return back;
    }(),
    showMacroGroups: function () {
      var _ref4 = _asyncToGenerator(function* () {
        var macrogroup_id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        var addStep = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

        if (1 === macrogroup_id.length) {
          this.parent = this.macrogroups.find(function (mg) {
            return mg.id === macrogroup_id[0];
          });
          return yield this.showGroups(this.parent);
        }

        this.items = this.macrogroups.filter(function (m) {
          return macrogroup_id.includes(m.id);
        });
        this.current = 'macrogroups';
        this.parent = {
          macrogroup_id: macrogroup_id,
          title: null,
          name: null };

        if (addStep) {
          this.steps.push(this.parent);
        }
      });

      function showMacroGroups() {
        return _ref4.apply(this, arguments);
      }

      return showMacroGroups;
    }(),
    showGroups: function () {
      var _ref5 = _asyncToGenerator(function* (item) {
        var addStep = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

        try {
          this.loading = true;
          this.parent = item;
          this.items = yield get_macro(item.id);
          this.current = 'groups';
        } catch (e) {
          console.warn(e);
          this.items = [];
        } finally {
          if (addStep) {
            this.steps.push(this.parent);
          }
          this.loading = false;
        }
      });

      function showGroups(_x6) {
        return _ref5.apply(this, arguments);
      }

      return showGroups;
    }(),
    showProjects: function () {
      var _ref6 = _asyncToGenerator(function* (item) {
        var _this = this;

        try {
          this.loading = true;
          this.parent = item;
          this.items = this.parent.id === this.curr_group ? (0, _getListableProjects.getListableProjects)() : yield get_group(item.id, function (item) {
            return _this.setItemImageSrc({ item: item, type: 'project' });
          });
          this.current = 'projects';
        } catch (e) {
          console.warn(e);
          this.items = [];
        } finally {
          this.steps.push(this.parent);
          this.loading = false;
        }
      });

      function showProjects(_x7) {
        return _ref6.apply(this, arguments);
      }

      return showProjects;
    }(),
    showRoot: function showRoot() {
      this.current = 'root';
      this.items = [].concat(_toConsumableArray(this.macrogroups), _toConsumableArray(this.groups));
      this.steps = [];
    },
    changeMapProject: function () {
      var _ref7 = _asyncToGenerator(function* (item) {
        var url = void 0;
        var base_url = window.initConfig.urls.baseurl;
        var epsg = this.parent.srid ? 'EPSG:' + this.parent.srid : this.parent.crs.epsg;
        yield _projections2.default.registerProjection(epsg);
        try {
          new URL(base_url);
          url = '' + base_url + (item.url || item.map_url.replace(/^\//, ""));
        } catch (e) {
          url = '' + location.origin + base_url + (item.url || item.map_url.replace(/^\//, ""));
        }
        url = yield _gui2.default.getService('map').addMapExtentUrlParameterToUrl(url, epsg);
        history.replaceState(null, null, url);
        location.replace(url);
      });

      function changeMapProject(_x8) {
        return _ref7.apply(this, arguments);
      }

      return changeMapProject;
    }(),
    trigger: function () {
      var _ref8 = _asyncToGenerator(function* (item) {
        switch (this.current) {
          case 'root':
            return undefined === item.srid ? this.showGroups(item) : this.showProjects(item);
          case 'macrogroups':
            return this.showGroups(item);
          case 'groups':
            return yield this.showProjects(item);
          case 'projects':
            return yield this.changeMapProject(item);
        }
      });

      function trigger(_x9) {
        return _ref8.apply(this, arguments);
      }

      return trigger;
    }(),
    setItemImageSrc: function setItemImageSrc() {
      var _ref9 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          item = _ref9.item,
          type = _ref9.type;

      switch (type) {
        case 'project':
          item.thumbnail = this._setSrc(item.thumbnail);break;
        case 'group':
          item.header_logo_img = this._setSrc(item.header_logo_img);break;
        case 'macrogroup':
          item.logo_img = this._setSrc(item.logo_img);break;

        case 'net_error':
          if (item.thumbnail || item.logo_img) {
            item.thumbnail = '' + window.initConfig.urls.clienturl + LOGO_GIS3W;
          } else if (item.header_logo_img) {
            item.header_logo_img = '' + window.initConfig.urls.clienturl + LOGO_GIS3W;
          }
          break;
      }
    },
    _setSrc: function _setSrc(src) {
      var imageSrc = void 0;
      var host = this.$options.host || '';
      var mediaurl = window.initConfig.mediaurl;
      var clienturl = window.initConfig.urls.clienturl;
      var has_media = src && src.includes(mediaurl);
      var not_static = src && !src.includes('static') && !src.includes('media');

      if (!src) {
        imageSrc = '' + clienturl + LOGO_GIS3W;
      } else if (has_media) {
        imageSrc = src;
      } else if (not_static) {
        imageSrc = '' + mediaurl + src;
      } else {
        imageSrc = '' + clienturl + LOGO_GIS3W;
      }

      return '' + host + imageSrc;
    }
  },

  created: function () {
    var _ref10 = _asyncToGenerator(function* () {
      var _this2 = this;

      var config = window.initConfig;

      this.items = (0, _getListableProjects.getListableProjects)();
      this.parent = window.initConfig;
      this.curr_group = this.parent.id;
      this.macrogroups = config.macrogroups;
      this.groups = config.groups;

      Object.entries({ 'project': this.items, 'magrocroup': this.macrogroups, 'group': this.groups }).forEach(function (_ref11) {
        var _ref12 = _slicedToArray(_ref11, 2),
            type = _ref12[0],
            d = _ref12[1];

        return d.forEach(function (item) {
          return _this2.setItemImageSrc({ item: item, type: type });
        });
      });
    });

    function created() {
      return _ref10.apply(this, arguments);
    }

    return created;
  }()
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal fade",attrs:{"id":"modal-changemap","tabindex":"-1"}},[_c('div',{staticClass:"modal-dialog",staticStyle:{"min-width":"80vw"}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-body",staticStyle:{"height":"80vh"}},[('root' !== this.current)?_c('div',{staticClass:"skin-background-color",staticStyle:{"display":"flex","align-items":"center","color":"#fff"}},[_c('span',{directives:[{name:"t-tooltip",rawName:"v-t-tooltip:bottom.create",value:('change_session'),expression:"'change_session'",arg:"bottom",modifiers:{"create":true}},{name:"disabled",rawName:"v-disabled",value:(_vm.loading),expression:"loading"}],staticStyle:{"font-size":"2em","margin":"5px","cursor":"pointer","padding":"3px","border":"2px solid #fff","border-radius":"3px"},on:{"click":function($event){$event.stopPropagation();return _vm.back($event)}}},[_c('i',{class:_vm.$fa('reply'),staticStyle:{"color":"#FFF"}})]),_vm._v(" "),(_vm.parent)?_c('div',{staticStyle:{"margin":"auto"}},[_c('h3',{staticStyle:{"font-weight":"bold"}},[_vm._v(_vm._s(_vm.parent.title || _vm.parent.name))])]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.items.length)?_c('div',{staticClass:"g3w-change-map-menu-container"},_vm._l((_vm.items),function(item){return _c('div',{key:item.name,staticClass:"menu-item"},[_c('div',{staticClass:"menu-item-image",on:{"click":function($event){$event.stopPropagation();return _vm.trigger(item)}}},[_c('img',{staticClass:"img-responsive",attrs:{"src":item.thumbnail || item.header_logo_img || item.logo_img,"alt":"logo"},on:{"error":function($event){return _vm.setItemImageSrc({ item: item, type: 'net_error' })}}})]),_vm._v(" "),_c('div',{staticClass:"menu-item-content"},[_c('div',{staticClass:"menu-item-text"},[_c('h4',{staticClass:"menu-item-title"},[_vm._v(_vm._s(item.title))]),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(item.description)}})])])])}),0):_c('h3',{directives:[{name:"t",rawName:"v-t",value:(("no_other_" + _vm.current)),expression:"`no_other_${current}`"}],staticStyle:{"font-weight":"bold"}})]),_vm._v(" "),_c('div',{staticClass:"modal-footer",staticStyle:{"position":"relative","background":"#fff"}},[_c('button',{directives:[{name:"t",rawName:"v-t",value:('close'),expression:"'close'"}],staticClass:"btn btn-default",attrs:{"type":"button","data-dismiss":"modal"}})])])])])}
__vue__options__.staticRenderFns = []
__vue__options__._scopeId = "data-v-38eb2e23"

},{"services/gui":207,"store/application":212,"store/projections":214,"utils/XHR":215,"utils/getListableProjects":244,"vueify/lib/insert-css":35}],120:[function(require,module,exports){
;(function(){
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'modal-login',
  data: function data() {
    return {
      show: true
    };
  },


  computed: {
    login_url: function login_url() {
      return window.initConfig.user.login_url;
    }
  },

  methods: {
    onIframeLoaded: function onIframeLoaded(e) {
      var iframe = this.$refs.login_iframe.contentWindow.g3wsdk && this.$refs.login_iframe.contentWindow.g3wsdk.core.ApplicationState;
      if (iframe && iframe.user && iframe.user.logout_url) {
        this.show = false;
        window.location.reload();
      }
    }
  }

};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',{staticClass:"modal fade",attrs:{"id":"modal-login","tabindex":"-1","role":"document"}},[_c('div',{staticClass:"modal-dialog",staticStyle:{"height":"60%","width":"60%"}},[_c('div',{staticClass:"modal-content",staticStyle:{"height":"100%","background":"#d2d6de","display":"grid","grid-template-areas":"'iframe'","place-items":"center"}},[_c('button',{staticClass:"close",staticStyle:{"position":"absolute","inset":"0 0 auto auto","padding":"10px 15px"},attrs:{"type":"button","data-dismiss":"modal"}},[_vm._v("×")]),_vm._v(" "),_c('span',{staticStyle:{"grid-area":"iframe"}},[_vm._v("Loading..")]),_vm._v(" "),_c('iframe',{ref:"login_iframe",staticStyle:{"border":"0","width":"100%","height":"100%","grid-area":"iframe"},attrs:{"loading":"lazy","src":_vm.login_url},on:{"load":_vm.onIframeLoaded}})])])]):_vm._e()}
__vue__options__.staticRenderFns = []

},{}],121:[function(require,module,exports){
(function (process){(function (){
var __vueify_style_dispose__ = require("vueify/lib/insert-css").insert(".metadata-item-tab.general[data-v-24ae4730]{color:var(--skin-primary)}.metadata-item-tab.layers[data-v-24ae4730]{color:var(--skin-warning)}.metadata-item-tab.spatial[data-v-24ae4730]{color:var(--skin-success)}#project-catalog[data-v-24ae4730]{background:transparent}.modal-header.nav[data-v-24ae4730]{display:flex;gap:1px;justify-content:space-between}.modal-header.nav li[data-v-24ae4730]{background-color:#e4e4e4;width:100%}.modal-header.nav li.active[data-v-24ae4730]{background-color:#fff}.modal-header.nav li.active a.metadata-item-tab[data-v-24ae4730]{border-bottom-color:#222d32!important;border-bottom-width:4px;background-color:transparent!important;color:#2c3b41!important}.modal-header.nav li a.metadata-item-tab[data-v-24ae4730]{height:100%;margin:0;font-size:1.1em;border-top:0;border-right:0;border-left:0;border-bottom:4px solid #e2e2e2}.modal-header.nav li a[data-v-24ae4730]{text-align:center}.modal-header.nav li a i[data-v-24ae4730]{margin-right:5px}.metadata-item-tab[data-v-24ae4730]{margin-right:10px;border-radius:3px;margin-bottom:10px}.tab-title[data-v-24ae4730]{position:absolute;bottom:10px;right:auto}.row-info[data-v-24ae4730]{margin:0!important;padding-top:10px;padding-bottom:10px;border-bottom:1px solid #eee}.row-info .label[data-v-24ae4730]{font-weight:700}.h_100[data-v-24ae4730]{height:100%}#project-catalog[data-v-24ae4730]{position:relative;overflow:auto}.nav-tabs[data-v-24ae4730]{border-bottom:0 none}.metadata-label[data-v-24ae4730]{font-weight:700;font-size:1.1em}.bbox-labels[data-v-24ae4730],.metadata-contact-label[data-v-24ae4730]{font-weight:700}.contact-icon[data-v-24ae4730]{margin-right:3px}.metadata-contact-row[data-v-24ae4730]{margin-bottom:5px}.layer_header[data-v-24ae4730]{padding:5px;margin-bottom:0;margin-top:0;cursor:pointer}.layer-name[data-v-24ae4730]{font-weight:700}.layer-header-icon[data-v-24ae4730]{margin-right:10px;color:#999}.layer_header span.open-close[data-v-24ae4730]{position:absolute;right:5px;color:#999}.layer-row[data-v-24ae4730]{padding:10px;border-bottom:1px solid #e2e2e2}.layer-nav-tabs[data-v-24ae4730]{border-bottom:0 solid #ddd}.layer-nav-tabs>li.active>a[data-v-24ae4730],.layer-nav-tabs>li.active>a[data-v-24ae4730]:focus,.layer-nav-tabs>li.active>a[data-v-24ae4730]:hover{border-width:0}.layer-nav-tabs>li>a[data-v-24ae4730]{border:none;color:#aeaeae}.layer-nav-tabs>li.active>a[data-v-24ae4730],.layer-nav-tabs>li>a[data-v-24ae4730]:hover{border:none;background:transparent}.layer-nav-tabs>li>a[data-v-24ae4730]:after{content:\"\";height:2px;position:absolute;width:100%;left:0;bottom:-1px;transition:all .25s ease 0s;transform:scale(0)}.layer-nav-tabs>li.active>a[data-v-24ae4730]:after,.layer-nav-tabs>li:hover>a[data-v-24ae4730]:after{transform:scale(1)}.layer-tab-content[data-v-24ae4730]{margin:10px;background-color:#eee;overflow:auto}.spatial-tab[data-v-24ae4730]{font-weight:700}.metadata-nav-tabs>li.active>a[data-v-24ae4730],.metadata-nav-tabs>li>a[data-v-24ae4730]:hover{color:var(--skin-color)!important}.metadata-nav-tabs>li>a[data-v-24ae4730]:after{background:var(--skin-color)}.modal-header.nav .action-button[data-v-24ae4730]:hover{background-color:transparent}.credit-title-logo[data-v-24ae4730]{font-weight:700;font-size:1.2em;margin-bottom:15px}.g3w-credits-block[data-v-24ae4730]{text-align:center!important;margin-bottom:20px}.g3w-suite-logo[data-v-24ae4730]{width:50%!important}.customcredits[data-v-24ae4730]{margin-bottom:10px;margin-top:5px;text-align:center}")
;(function(){
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _application = require('store/application');

var _application2 = _interopRequireDefault(_application);

var _application3 = require('services/application');

var _application4 = _interopRequireDefault(_application3);

var _XHR = require('utils/XHR');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

exports.default = {

  name: "modal-metadata",

  data: function data() {
    var project = _application2.default.project.getState();
    var version = window.initConfig.version.split('-')[0].split('.');

    return {
      customcredits: false,
      powered_by: window.initConfig.powered_by,
      urls: window.initConfig.urls,
      docs_url: 'https://g3w-suite.readthedocs.io/en/v' + version[0].replace('v', '') + '.' + version[1] + '.x/',
      groups: Object.entries({
        general: ['title', 'name', 'description', 'abstract', 'keywords', 'fees', 'accessconstraints', 'contactinformation', 'wms_url'],
        spatial: ['crs', 'extent'],
        layers: ['layers']
      }).reduce(function (g, _ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            name = _ref2[0],
            fields = _ref2[1];

        g[name] = fields.reduce(function (f, field) {
          var value = project.metadata && project.metadata[field] ? project.metadata[field] : project[field];
          if (value) {
            f[field] = { value: value, label: 'sdk.metadata.groups.' + name + '.fields.' + field };
          }
          return f;
        }, {});
        return g;
      }, {}),
      g3wsdk_info: ''
    };
  },


  methods: {
    showHideInfo: function showHideInfo(e) {
      var box = e.target.closest(".layer_header");
      box.querySelector(".open-close").classList.toggle('fa-plus');
      box.querySelector(".open-close").classList.toggle('fa-minus');
    },
    sanitizeValue: function sanitizeValue(value) {
      if (Array.isArray(value) || 'object' === (typeof value === 'undefined' ? 'undefined' : _typeof(value)) && null !== value) {
        value = Object.values(value).length ? value : '';
      }
      return value;
    },
    copy_g3wsdk_info: function copy_g3wsdk_info(e) {
      var range = document.createRange();
      range.selectNode(e.target);
      window.getSelection().removeAllRanges();
      window.getSelection().addRange(range);
      document.execCommand('copy');
      window.getSelection().removeAllRanges();
      alert('Copied to clipboard!');
    }
  },

  created: function () {
    var _ref3 = _asyncToGenerator(function* () {
      if (!!window.initConfig.credits) {
        try {
          var credits = yield _XHR.XHR.get({ url: window.initConfig.credits });
          this.customcredits = 'None' !== credits && credits;
        } catch (e) {
          console.warn(e);
        }
      }
    });

    function created() {
      return _ref3.apply(this, arguments);
    }

    return created;
  }(),
  mounted: function mounted() {
    var _this = this;

    $('#modal-metadata').on('show.bs.modal', _asyncToGenerator(function* () {
      yield Promise.allSettled([new Promise(function (resolve) {
        return $script('https://unpkg.com/platform@1.3.6/platform.js', resolve);
      }), new Promise(function (resolve) {
        return _application4.default.complete ? resolve() : _application4.default.on('complete', resolve);
      })]);

      var platform = window.platform || {};

      _this.g3wsdk_info = ('\n[g3wsdk.info]\n\n- g3w-admin: __' + initConfig.version + '__\n- g3w-client: __' + "3.11.3-HEAD" + '__\n' + Object.entries(_application2.default.pluginsConfigs).map(function (p) {
        return '    - ' + p[0] + ': __' + p[1].version + '__';
      }).join('\n') + '\n- browser: __' + platform.name + ' ' + platform.version + '__\n- operating system: __' + platform.os.toString() + '__\n').trim();
    }));
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal fade",attrs:{"id":"modal-metadata","tabindex":"-1"}},[_c('div',{staticClass:"modal-dialog",staticStyle:{"min-width":"80vw"}},[_c('div',{staticClass:"modal-content"},[_c('ul',{staticClass:"modal-header nav nav-tabs",attrs:{"role":"tablist"}},_vm._l((['general', 'spatial', 'layers', 'credits']),function(tab){return _c('li',{class:{ active: 'general' === tab }},[_c('a',{class:'metadata-item-tab '+ tab,attrs:{"data-toggle":"tab","href":'#metadata_' + tab}},[_c('i',{staticClass:"action-button",class:_vm.$fa(({ general: 'info', spatial: 'globe', layers: 'bars', credits: 'copyright' })[tab]),attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('b',{directives:[{name:"t",rawName:"v-t",value:('sdk.metadata.groups.'+ tab +'.title'),expression:"'sdk.metadata.groups.'+ tab +'.title'"}]})])])}),0),_vm._v(" "),_c('div',{staticClass:"modal-body",staticStyle:{"min-height":"65vh","max-height":"70vh"},attrs:{"id":"project-catalog"}},[_c('div',{staticClass:"tab-content"},[_vm._l((['general', 'spatial']),function(item){return _c('div',{staticClass:"tab-pane fade",class:{ in: 'general' === item, active: 'general' === item },attrs:{"id":'metadata_' + item}},_vm._l((_vm.groups[item]),function(data,field){return _c('div',{staticClass:"row row-info"},[_c('div',{staticClass:"wrap-content-tab"},[_c('div',{directives:[{name:"t",rawName:"v-t",value:(data.label),expression:"data.label"}],staticClass:"col-sm-2 metadata-label"}),_vm._v(" "),('keywords' === field || 'wms_url'=== field)?_c('div',{staticClass:"col-sm-10 value"},[_c('span',[_vm._v(_vm._s([].concat(data.value).join(', ')))])]):('abstract' === field || (!Array.isArray(data.value) && typeof data.value !== 'object'))?_c('div',{staticClass:"col-sm-10 value"},[_c('span',{domProps:{"innerHTML":_vm._s(data.value)}})]):('contactinformation' !== field)?_c('div',{staticClass:"col-sm-10 value"},_vm._l((data.value),function(value,index){return _c('div',[('extent' === field)?_c('span',{staticClass:"bbox-labels"},[_vm._v(_vm._s((['MINX', 'MINY', 'MAXX', 'MAXY'])[index]))]):_vm._e(),_vm._v(" "),_c('span',[_vm._v(_vm._s(value))])])}),0):_c('div',{staticClass:"col-sm-10 value"},_vm._l((data.value),function(value,info){return _c('div',[_c('div',{staticClass:"row metadata-contact-row"},[_c('div',{staticClass:"col-sm-2 metadata-contact-label"},[_c('i',{staticClass:"contact-icon",class:_vm.$fa(({ contactelectronicmailaddress: 'mail', personprimary: 'user', contactvoicetelephone: 'mobile' })[info]),attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('span',{directives:[{name:"t",rawName:"v-t",value:(("sdk.metadata.groups.general.fields.subfields.contactinformation." + info)),expression:"`sdk.metadata.groups.general.fields.subfields.contactinformation.${info}`"}]})]),_vm._v(" "),('personprimary' === info)?_c('div',{staticClass:"col-sm-10"},_vm._l((value),function(subvalue,key){return _c('div',[_c('span',{directives:[{name:"t",rawName:"v-t",value:(("sdk.metadata.groups.general.fields.subfields.contactinformation." + key)),expression:"`sdk.metadata.groups.general.fields.subfields.contactinformation.${key}`"}],staticClass:"metadata-contact-label"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(subvalue))])])}),0):('contactelectronicmailaddress' === info )?_c('div',{staticClass:"col-sm-10"},[_c('a',{attrs:{"href":("mailto: " + (_vm.sanitizeValue(value)))}},[_c('b',[_vm._v(_vm._s(_vm.sanitizeValue(value)))])])]):_c('div',{staticClass:"col-sm-10"},[_vm._v(_vm._s(_vm.sanitizeValue(value)))])])])}),0)])])}),0)}),_vm._v(" "),_c('div',{staticClass:"tab-pane fade",attrs:{"id":"metadata_layers"}},_vm._l((_vm.groups.layers.layers.value),function(layer){return _c('div',{staticClass:"row-info"},[_c('h4',{staticClass:"layer_header",attrs:{"data-toggle":"collapse","data-target":("#" + (layer.id))},on:{"click":_vm.showHideInfo}},[_c('i',{class:'layer-header-icon action-button ' + _vm.g3wtemplate.font['NoGeometry' === layer.geometrytype ? 'table' : 'map'],attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('span',{staticClass:"layer-name"},[_vm._v(_vm._s(layer.name))]),_vm._v(" "),_c('span',{staticClass:"action-button open-close",class:_vm.$fa('plus')})]),_vm._v(" "),_c('div',{staticClass:"collapse",attrs:{"id":layer.id}},[_c('ul',{staticClass:"metadata-nav-tabs nav nav-tabs layer-nav-tabs",attrs:{"role":"tablist"}},[_c('li',{staticClass:"active spatial-tab",attrs:{"role":"presentation"}},[_c('a',{directives:[{name:"t",rawName:"v-t",value:('sdk.metadata.groups.layers.groups.general'),expression:"'sdk.metadata.groups.layers.groups.general'"}],attrs:{"href":("#layer_general_" + (layer.id)),"aria-controls":"general","role":"tab","data-toggle":"tab"}})]),_vm._v(" "),('NoGeometry' !== layer.geometrytype)?_c('li',{staticClass:"spatial-tab",attrs:{"role":"presentation"}},[_c('a',{directives:[{name:"t",rawName:"v-t",value:('sdk.metadata.groups.layers.groups.spatial'),expression:"'sdk.metadata.groups.layers.groups.spatial'"}],attrs:{"href":("#layer_spatial_" + (layer.id)),"aria-controls":"profile","role":"tab","data-toggle":"tab"}})]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"tab-content layer-tab-content"},[_c('div',{staticClass:"tab-pane active",attrs:{"role":"tabpanel","id":("layer_general_" + (layer.id))}},[_c('div',{staticClass:"container-fluid"},[_vm._l((['metadata.title', 'name', 'source', 'metadata.abstract', 'metadata.keywords', 'metadata.metadataurl.onlineresource', 'metadata.dataurl.onlineresources', 'metadata.attributes']),function(attr){return [(undefined !== attr.split('.').reduce(function (a, b) { return a[b]; }, layer))?_c('div',{staticClass:"row layer-row"},[_c('div',{directives:[{name:"t",rawName:"v-t",value:('sdk.metadata.groups.layers.fields.subfields.' + attr.replace('metadata.', '').split('.')[0]),expression:"'sdk.metadata.groups.layers.fields.subfields.' + attr.replace('metadata.', '').split('.')[0]"}],staticClass:"col-md-2 col-sm-12 metadata-label"}),_vm._v(" "),('metadata.title' === attr)?_c('div',{staticClass:"col-md-10 col-sm-12 value"},[_vm._v(_vm._s(layer.metadata.title))]):_vm._e(),_vm._v(" "),('name' === attr)?_c('div',{staticClass:"col-md-10 col-sm-12 value"},[_vm._v(_vm._s(layer.name))]):_vm._e(),_vm._v(" "),('source' === attr)?_c('div',{staticClass:"col-md-10 col-sm-12 value"},[_vm._v(_vm._s(layer.source.type))]):_vm._e(),_vm._v(" "),('metadata.abstract' === attr)?_c('div',{staticClass:"col-md-10 col-sm-12 value",domProps:{"innerHTML":_vm._s(layer.metadata.abstract)}}):('metadata.keywords' === attr)?_c('div',{staticClass:"col-md-10 col-sm-12 value"},[_vm._v(_vm._s(layer.metadata.keywords.join(', ')))]):('metadata.metadataurl.onlineresource' === attr)?_c('div',{staticClass:"col-md-10 col-sm-12 value"},[_c('a',{attrs:{"href":layer.metadata.metadataurl.onlineresources}},[_vm._v(_vm._s(layer.metadata.metadataurl.onlineresources))])]):('metadata.dataurl.onlineresources' === attr)?_c('div',{staticClass:"col-md-10 col-sm-12 value"},[_c('a',{attrs:{"href":layer.metadata.dataurl.onlineresources}},[_vm._v(_vm._s(layer.metadata.dataurl.onlineresources))])]):('metadata.attributes' === attr)?_c('div',{staticClass:"col-md-10 col-sm-12 value",staticStyle:{"overflow":"auto"}},[_c('table',{staticClass:"table table-striped",staticStyle:{"background-color":"#eee !important"}},[_c('thead',[_c('tr',_vm._l((layer.metadata.attributes[0]),function(value,header){return _c('th',[_vm._v(_vm._s(header))])}),0)]),_vm._v(" "),_c('tbody',_vm._l((layer.metadata.attributes),function(a){return _c('tr',_vm._l((a),function(value,header){return _c('td',[_vm._v(_vm._s(value))])}),0)}),0)])]):_vm._e()]):_vm._e()]})],2)]),_vm._v(" "),_c('div',{staticClass:"tab-pane",attrs:{"role":"tabpanel","id":("layer_spatial_" + (layer.id))}},[_c('div',{staticClass:"container-fluid"},[_vm._l((['crs', 'geometrytype', 'bbox', 'metadata.crs']),function(attr){return [(undefined !== attr.split('.').reduce(function (a, b) { return a[b]; }, layer))?_c('div',{staticClass:"row layer-row"},[('metadata.crs' === attr)?_c('div',{staticClass:"col-md-2 col-sm-12 metadata-label"},[_vm._v("CRS")]):_c('div',{directives:[{name:"t",rawName:"v-t",value:('sdk.metadata.groups.layers.fields.subfields.' + attr.replace('metadata.', '').split('.')[0]),expression:"'sdk.metadata.groups.layers.fields.subfields.' + attr.replace('metadata.', '').split('.')[0]"}],staticClass:"col-md-2 col-sm-12 metadata-label"}),_vm._v(" "),('crs' === attr)?_c('div',{staticClass:"col-sm-10 value"},[_vm._v(_vm._s(layer.crs.epsg))]):('geometrytype' === attr)?_c('div',{staticClass:"col-sm-10 value"},[_vm._v(_vm._s(layer.geometrytype))]):('bbox' === attr)?_c('div',{staticClass:"col-sm-10 value"},_vm._l((layer.bbox),function(value,key){return _c('p',[_c('span',{staticStyle:{"font-weight":"bold","margin-right":"5px"}},[_vm._v(_vm._s(key))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(value))])])}),0):('metadata.crs' === attr)?_c('div',{staticClass:"col-sm-10 value"},_vm._l((layer.metadata.crs),function(crs){return _c('div',[_c('span',[_vm._v(_vm._s(crs))])])}),0):_vm._e()]):_vm._e()]})],2)])])])])}),0),_vm._v(" "),_c('div',{staticClass:"tab-pane fade",attrs:{"id":"metadata_credits"}},[(!!_vm.customcredits)?_c('div',{staticClass:"customcredits",domProps:{"innerHTML":_vm._s(_vm.customcredits)}}):_vm._e(),_vm._v(" "),(_vm.powered_by)?_c('div',{staticClass:"g3w-credits-block"},[_c('div',{directives:[{name:"t",rawName:"v-t",value:('credits.g3wSuiteFramework'),expression:"'credits.g3wSuiteFramework'"}],staticClass:"credit-title-logo",staticStyle:{"padding":"5px"}}),_vm._v(" "),_c('a',{attrs:{"target":"_blank","href":"https://g3wsuite.it/"}},[_c('img',{staticClass:"g3w-suite-logo",attrs:{"src":((_vm.urls.clienturl) + "images/g3wsuite_logo.png"),"alt":""}})]),_vm._v(" "),_c('div',{directives:[{name:"t",rawName:"v-t",value:('credits.g3wSuiteDescription'),expression:"'credits.g3wSuiteDescription'"}],staticStyle:{"margin-top":"10px"}})]):_vm._e(),_vm._v(" "),(_vm.powered_by)?_c('div',{directives:[{name:"t",rawName:"v-t:pre",value:('credits.productOf'),expression:"'credits.productOf'",arg:"pre"}],staticClass:"credit-title-logo g3w-credits-block",staticStyle:{"font-size":"1em","display":"flex","justify-content":"center"}},[_c('a',{staticStyle:{"text-align":"center!important"},attrs:{"href":"http://www.gis3w.it","target":"_blank"}},[_c('img',{staticClass:"img-responsive center-block",staticStyle:{"margin-left":"5px"},attrs:{"width":"60","src":((_vm.urls.clienturl) + "images/logo_gis3w_156_85.png"),"alt":""}})])]):_vm._e(),_vm._v(" "),(_vm.powered_by)?_c('address',{staticStyle:{"line-height":"1.3","text-align":"center","margin-top":"5px","display":"flex","justify-content":"center","gap":"5px"},attrs:{"id":"address-credits"}},[_c('span',[_vm._v("📍 Montecatini Terme - Italy")]),_vm._v(" "),_c('a',{staticStyle:{"color":"#000"},attrs:{"href":"tel:+393938534336"}},[_vm._v("📱 +39 393 8534336")]),_vm._v(" "),_c('a',{staticStyle:{"color":"#000"},attrs:{"href":"mailto:info@gis3w.it"}},[_vm._v("✉️ info@gis3w.it")])]):_vm._e(),_vm._v(" "),(_vm.powered_by)?_c('div',{staticStyle:{"display":"flex","justify-content":"center","gap":"20px"}},[_c('a',{attrs:{"href":_vm.docs_url,"rel":"nofollow","target":"_blank"}},[_vm._v("📖 Docs")]),_vm._v(" "),_c('a',{attrs:{"href":"mailto:info@gis3w.it?subject=Sponsoring%20G3W-SUITE%20development&body=Hi%20there,%20I'd%20like%20to%20fund%20some%20code%20changes:"}},[_vm._v("❤️ Sponsor")]),_vm._v(" "),_c('a',{attrs:{"href":"https://github.com/g3w-suite","target":"_blank"}},[_vm._v("🐞 Report a bug")])]):_vm._e(),_vm._v(" "),_c('hr'),_vm._v(" "),(_vm.powered_by && _vm.g3wsdk_info)?_c('pre',{staticStyle:{"cursor":"pointer"},attrs:{"title":"click to copy"},on:{"click":_vm.copy_g3wsdk_info}},[_vm._v(_vm._s(_vm.g3wsdk_info))]):_vm._e()])],2)]),_vm._v(" "),_c('div',{staticClass:"modal-footer",staticStyle:{"position":"relative","background":"#fff"}},[_c('button',{directives:[{name:"t",rawName:"v-t",value:('close'),expression:"'close'"}],staticClass:"btn btn-default",attrs:{"type":"button","data-dismiss":"modal"}})])])])])}
__vue__options__.staticRenderFns = []
__vue__options__._scopeId = "data-v-24ae4730"

}).call(this)}).call(this,require('_process'))
},{"_process":25,"services/application":205,"store/application":212,"utils/XHR":215,"vueify/lib/insert-css":35}],122:[function(require,module,exports){
var __vueify_style_dispose__ = require("vueify/lib/insert-css").insert("#print .select2-container--open{width:100%}#print .select2-container--open input.select2-search__field{color:#555;width:100%}#print.treeview-menu .select2.select2-container{display:block}\n.print-labels-content[data-v-e834f4ce]{margin:15px 0;color:#fff}.print-labels-content>span.skin-color[data-v-e834f4ce]{font-size:1.1em;display:block;border-bottom:2px solid #fff;margin-bottom:5px}.print-labels-content>.labels-input-content[data-v-e834f4ce]{max-height:120px;overflow-y:auto}label[data-v-e834f4ce]{color:#fff}#printbutton[data-v-e834f4ce]{width:100%;font-weight:700;background-color:var(--skin-color);margin:15px 0}#fid-print-atals-instruction[data-v-e834f4ce]{margin-top:5px;color:#fff}#fids_intruction[data-v-e834f4ce]{white-space:pre-line}#fids_examples_values[data-v-e834f4ce]{margin-top:3px;font-weight:700}.g3w-search-form>label[data-v-e834f4ce]:not(:first-child){margin-top:15px}details[open] .fa-eye[data-v-e834f4ce]{display:none}details[open] summary>span[data-v-e834f4ce]{overflow:visible!important}")
;(function(){
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _g3wConstants = require('g3w-constants');

var _g3wComponent = require('g3w-component');

var _g3wComponent2 = _interopRequireDefault(_g3wComponent);

var _application = require('store/application');

var _application2 = _interopRequireDefault(_application);

var _gui = require('services/gui');

var _gui2 = _interopRequireDefault(_gui);

var _getScaleFromResolution = require('utils/getScaleFromResolution');

var _getResolutionFromScale = require('utils/getResolutionFromScale');

var _downloadFile = require('utils/downloadFile');

var _printAtlas = require('utils/printAtlas');

var _promisify = require('utils/promisify');

var _getCatalogLayerById = require('utils/getCatalogLayerById');

var _resize = require('mixins/resize');

var _resize2 = _interopRequireDefault(_resize);

var _PrintPage = require('components/PrintPage.vue');

var vueComp = _interopRequireWildcard(_PrintPage);

var _g3wI18n = require('g3w-i18n');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

exports.default = {
  name: 'print',

  mixins: [_resize2.default],

  data: function data() {
    this.init();
    return {
      state: this.state || {},
      disabled: false,

      atlas_values: []
    };
  },


  computed: {
    has_maps: function has_maps() {
      return (this.state.maps || []).length > 0;
    },
    has_autocomplete: function has_autocomplete() {
      return !!(this.state.atlas && this.state.atlas.field_name);
    },
    lang: function lang() {
      return _application2.default.language;
    }
  },

  methods: {
    init: function init() {
      this._init = undefined !== this._init ? this._init : false;
      this._moveKey = this._moveKey || null;
      this._page = this._page || null;
      this._resolutions = this._resolutions || {};

      var print = _application2.default.project.getPrint() || [];
      var visible = print.length > 0;

      var PRINT_FORMATS = [{ value: 'png', label: 'PNG' }, { value: 'jpg', label: 'JPG' }, { value: 'svg', label: 'SVG' }, { value: 'pdf', label: 'PDF' }, { value: 'geopdf', label: 'GEOPDF' }];

      this.state = Object.assign(this.state || {}, {
        visible: visible,
        print: print,
        loading: false,
        downloading: false,
        url: null,
        layers: true,
        maps: visible ? print[0].maps : undefined,
        labels: visible ? print[0].labels : undefined,
        template: visible ? print[0].name : undefined,
        atlas: visible ? print[0].atlas : undefined,
        rotation: visible ? 0 : undefined,
        inner: [0, 0, 0, 0],
        scales: [],
        scale: visible ? null : undefined,
        dpis: [150, 300],
        dpi: 150,
        formats: PRINT_FORMATS,
        format: PRINT_FORMATS[0].value
      });

      this.print_extent = null;
    },
    resize: function resize() {
      if (this.select2 && !_application2.default.ismobile) {
        this.select2.select2('close');
      }
    },
    changeTemplate: function () {
      var _ref = _asyncToGenerator(function* () {
        var _this = this;

        if (!this.state.template) {
          return;
        }

        yield this.$nextTick();

        if (this.select2) {
          this.select2.select2('destroy');
          this.select2.off();
          this.select2 = null;
        }

        this.disabled = false;

        var has_previous = this.state.atlas || 0 === this.state.maps.length;
        var print = this.state.print.find(function (p) {
          return p.name === _this.state.template;
        });

        Object.assign(this.state, {
          maps: print.maps,
          atlas: print.atlas,
          labels: print.labels
        });

        this.atlas_values = [];

        if (this.state.atlas) {
          this._clearPrint();
          this.initSelect2Field();
        } else if (has_previous) {
          this.showPrintArea(true);
        } else {
          this._setPrintArea();
        }

        yield this.$nextTick();
      });

      function changeTemplate() {
        return _ref.apply(this, arguments);
      }

      return changeTemplate;
    }(),
    changeScale: function changeScale() {

      try {
        if (this.state.scale.includes(':')) {
          var scale = Number(this.state.scale.split(':')[1].trim());

          this.$refs.scales.children[this.$refs.scales.children.length - 1].value = scale;

          this.state.scale = scale;
        }
      } catch (e) {
        console.warn(e);
        this.state.scale = this.state.scales[0].value;
      }

      if (Number.isNaN(Number(this.state.scale)) || this.state.scale > this.state.scales[0].value) {
        this.state.scale = this.state.scales[0].value;
      }

      if (this.state.scale < 0) {
        this.state.scale = this.state.scales[this.state.scales.length - 1].value;
      }

      $(this.$refs.scales).val(this.state.scale).trigger('change');

      if (this.state.scale) {
        this._setPrintArea();
      }
    },
    changeDpi: function changeDpi() {
      if (Number.isNaN(Number(this.state.dpi))) {
        this.state.dpi = this.state.dpis[0];

        $(this.$refs.dpi).val(this.state.dpi).trigger('change');
      }
    },
    changeRotation: function changeRotation() {
      this.state.rotation = this.state.rotation >= 0 ? Math.min(this.state.rotation || 0, 360) : Math.max(this.state.rotation || 0, -360);
      _gui2.default.getService('map').setInnerGreyCoverBBox({ rotation: this.state.rotation });
    },
    isAxisOrientationInverted: function isAxisOrientationInverted() {
      return 'neu' === _gui2.default.getService('map').getProjection().getAxisOrientation();
    },
    getOverviewExtent: function getOverviewExtent() {
      var extent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var xmin = extent.xmin,
          xmax = extent.xmax,
          ymin = extent.ymin,
          ymax = extent.ymax;

      return (this.isAxisOrientationInverted() ? [ymin, xmin, ymax, xmax] : [xmin, ymin, xmax, ymax]).join();
    },
    getPrintExtent: function getPrintExtent() {
      var map = _gui2.default.getService('map').viewer.map;

      try {
        var _map$getCoordinateFro = map.getCoordinateFromPixel([this.state.inner[0], this.state.inner[1]]),
            _map$getCoordinateFro2 = _slicedToArray(_map$getCoordinateFro, 2),
            xmin = _map$getCoordinateFro2[0],
            ymin = _map$getCoordinateFro2[1];

        var _map$getCoordinateFro3 = map.getCoordinateFromPixel([this.state.inner[2], this.state.inner[3]]),
            _map$getCoordinateFro4 = _slicedToArray(_map$getCoordinateFro3, 2),
            xmax = _map$getCoordinateFro4[0],
            ymax = _map$getCoordinateFro4[1];

        this.print_extent = (this.isAxisOrientationInverted() ? [ymin, xmin, ymax, xmax] : [xmin, ymin, xmax, ymax]).join();
      } catch (e) {
        console.warn(e);
      }

      return this.print_extent;
    },
    print: function () {
      var _ref2 = _asyncToGenerator(function* () {
        var _this2 = this;

        var has_atlas = !!this.state.atlas;
        var err = void 0;
        var response = void 0;

        this.state.loading = true;

        try {
          _gui2.default.disableSideBar(true);

          if (this._page) {
            yield (0, _promisify.promisify)(_gui2.default.closeContent());
          }

          if (has_atlas) {
            _application2.default.download = true;
            yield (0, _downloadFile.downloadFile)({
              url: (yield (0, _printAtlas.printAtlas)({
                template: this.state.template,
                field: this.state.atlas.field_name || '$id',
                values: this.atlas_values,
                download: true
              })).url,
              filename: this.state.template,
              mime_type: 'application/pdf'
            });
          }

          if (!has_atlas) {
            this.state.url = null;
            this.state.layers = true;

            this._page = new _g3wComponent2.default({ service: { state: this.state }, vueComponentObject: vueComp });

            _gui2.default.setContent({
              content: this._page,
              title: 'print',
              perc: 100
            });

            var has_theme = this.state.maps.some(function (m) {
              return undefined !== m.preset_theme;
            });
            var store = _application2.default.project.getLayersStore();
            var layers = store.getLayers({ PRINTABLE: { scale: this.state.scale }, SERVERTYPE: 'QGIS' }).reverse();
            var LAYERS = (layers || []).map(function (l) {
              return l.getPrintLayerName();
            }).join();
            var url = store.getWmsUrl();
            var params = layers.length && new URLSearchParams(_extends({
              SERVICE: 'WMS',
              VERSION: '1.3.0',
              REQUEST: 'GetPrint',
              TEMPLATE: this.state.template,
              DPI: this.state.dpi,
              STYLES: layers.map(function (l) {
                return l.getStyle();
              }).join(',')
            }, has_theme ? {} : { LAYERS: LAYERS }, {
              FORMAT: { png: 'png', pdf: 'application/pdf', geopdf: 'application/pdf' }[this.state.format] || this.state.format
            }, 'geopdf' === this.state.format ? { FORMAT_OPTIONS: 'WRITE_GEO_PDF:TRUE' } : {}, {
              CRS: store.getProjection().getCode(),
              filtertoken: _application2.default.tokens.filtertoken
            }, this.state.maps.map(function (m) {
              return {
                name: m.name,
                preset_theme: m.preset_theme,
                scale: m.overview ? m.scale : _this2.state.scale,
                extent: m.overview ? _this2.getOverviewExtent(m.extent) : _this2.getPrintExtent()
              };
            }).reduce(function (params, map) {
              var _extends2;

              return Object.assign(params, _extends((_extends2 = {}, _defineProperty(_extends2, map.name + ':SCALE', map.scale), _defineProperty(_extends2, map.name + ':EXTENT', map.extent), _defineProperty(_extends2, map.name + ':ROTATION', _this2.state.rotation), _extends2), has_theme && undefined === map.preset_theme ? _defineProperty({}, map.name + ':LAYERS', LAYERS) : {}));
            }, {}), (this.state.labels || []).reduce(function (params, label) {
              return Object.assign(params, _defineProperty({}, label.id, label.text));
            }, {}))).toString();

            var method = layers.length && ('geopdf' === this.state.format ? 'GET' : _application2.default.project.state.ows_method);

            response = yield 'GET' === method ? Promise.resolve({ ok: true }) : fetch(url, {
              method: 'POST',
              headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
              body: params
            });

            this.state.url = 'GET' === method ? url + '?' + params : URL.createObjectURL((yield response.blob()));
            this.state.layers = !!response.ok;

            this._page.getInternalComponent().$on('hook:mounted', function () {
              return _this2.state.loading = false;
            });

            this._page.unmount = function () {
              _gui2.default.getService('map').viewer.map.once('postrender', _this2._setPrintArea.bind(_this2));
              var promise = _g3wComponent2.default.prototype.unmount.call(_this2._page);
              _this2._page = null;
              return promise;
            };
          }
        } catch (e) {
          if (response && !response.ok && 500 === response.status) {
            err = 500 === response.status ? 'Internal Server Error' : 'Request Failed';
          } else {
            err = e;
          }
          this.state.loading = false;

          _gui2.default.disableSideBar(false);
          console.warn(e);
        }

        this.state.loading = false;

        _application2.default.download = false;

        if (has_atlas || !this.state.layers) {
          _gui2.default.disableSideBar(false);
        }

        if (err) {
          console.warn(err);
          _gui2.default.notify.error(err || (0, _g3wI18n.t)("info.server_error"));
          _gui2.default.closeContent();
        }
      });

      function print() {
        return _ref2.apply(this, arguments);
      }

      return print;
    }(),
    showPrintArea: function showPrintArea(show) {
      var _this3 = this;

      var reset = !show;
      if (reset && this.select2) {
        this.select2.val(null).trigger('change');
      }
      if (reset) {
        this.atlas_values = [];this.print_extent = null;
      }

      if (0 === this.state.print.length) {
        return;
      }
      _gui2.default.closeContent().then(function (component) {
        setTimeout(function () {
          var map = component.getService();
          map.getMap().once('postrender', function () {
            if (!show) {
              return _this3._clearPrint();
            }
            _this3._moveKey = map.viewer.map.on('moveend', _this3._setPrintArea.bind(_this3));
            _this3._initPrintConfig();

            if (undefined === _this3.state.atlas && _this3._setPrintArea()) {
              map.startDrawGreyCover();
            }
          });
          map.getMap().renderSync();
        });
      });
    },
    _setPrintArea: function _setPrintArea() {
      if (!this.has_maps) {
        this._clearPrint();
        return false;
      }
      var map = _gui2.default.getService('map').viewer.map;
      var size = map.getSize();
      var resolution = map.getView().getResolution();

      var _state$maps$find = this.state.maps.find(function (m) {
        return !m.overview;
      }),
          h = _state$maps$find.h,
          w = _state$maps$find.w;

      var res = resolution * ('m' === _gui2.default.getService('map').getMapUnits() ? 1 : ol.proj.Units.METERS_PER_UNIT.degrees);
      var w2 = w / 1000.0 * parseFloat(this.state.scale) / res / 2;
      var h2 = h / 1000.0 * parseFloat(this.state.scale) / res / 2;
      var x = size[0] / 2,
          y = size[1] / 2;

      this.state.inner = [x - w2, y + h2, x + w2, y - h2];
      _gui2.default.getService('map').setInnerGreyCoverBBox({
        type: 'pixel',
        inner: this.state.inner,
        rotation: this.state.rotation
      });
      return true;
    },
    _clearPrint: function _clearPrint() {
      ol.Observable.unByKey(this._moveKey);
      this._moveKey = null;
      _gui2.default.getService('map').stopDrawGreyCover();
    },
    _setScales: function _setScales(maxRes) {
      var _this4 = this;

      var units = _gui2.default.getService('map').getMapUnits();
      var mapScale = (0, _getScaleFromResolution.getScaleFromResolution)(maxRes, units);
      var scales = _g3wConstants.PRINT_SCALES.sort(function (a, b) {
        return b.value - a.value;
      });
      var below = scales.filter(function (s) {
        return s.value < mapScale;
      });
      var above = scales.findLast(function (s) {
        return s.value >= mapScale;
      });
      this.state.scales = (above ? [above] : []).concat(below);
      this.state.scales.forEach(function (s) {
        return _this4._resolutions[s.value] = (0, _getResolutionFromScale.getResolutionFromScale)(s.value, units);
      });
    },
    _initPrintConfig: function _initPrintConfig() {
      var _this5 = this;

      var view = _gui2.default.getService('map').viewer.map.getView();
      if (!this._initialized) {
        this._setScales(view.getMaxResolution());
        this._initialized = true;
      }
      var resolution = view.getResolution();

      Object.entries(this._resolutions).find(function (_ref4) {
        var _ref5 = _slicedToArray(_ref4, 2),
            scala = _ref5[0],
            res = _ref5[1];

        if (resolution <= res) {
          _this5.state.scale = scala;
          return true;
        }
      });
    },
    reload: function reload() {
      var _this6 = this;

      this.state.print = _application2.default.project.state.print || [];
      var visible = this.state.print.length > 0;
      var init = this._initialized;
      this.state.template = visible ? this.state.print[0].name : this.state.template;
      if (visible && !init) {
        this.init();
      }
      if (visible) {
        this._initPrintConfig();
        var map = _gui2.default.getService('map');
        map.on('changeviewaftercurrentproject', function () {
          _this6.state.scales = _g3wConstants.PRINT_SCALES;
          _this6._setScales(map.viewer.map.getView().getMaxResolution());
        });
      } else {
        this._clearPrint();
      }
    },
    initSelect2Field: function initSelect2Field() {
      var _this7 = this;

      this.select2 = $('#print_atlas_autocomplete').select2({
        width: '100%',
        multiple: true,
        dropdownParent: $(this.$refs.print_atlas),
        minimumInputLength: 1,
        ajax: {
          delay: 500,
          transport: function () {
            var _ref6 = _asyncToGenerator(function* (d, ok, ko) {
              try {
                ok({
                  results: (yield (0, _getCatalogLayerById.getCatalogLayerById)(_this7.state.atlas.qgs_layer_id).getFilterData({
                    suggest: _this7.state.atlas.field_name + '|' + d.data.q,
                    unique: _this7.state.atlas.field_name
                  })).map(function (v) {
                    return { id: v, text: v };
                  })
                });
              } catch (e) {
                console.warn(e);
                ko(e);
              }
            });

            function transport(_x2, _x3, _x4) {
              return _ref6.apply(this, arguments);
            }

            return transport;
          }()
        },

        matcher: function matcher(params, data) {
          var search = params.term ? params.term.toLowerCase() : params.term;
          if ('' === (search || '').toString().trim()) {
            return data;
          }
          if (data.text.toLowerCase().includes(search) && undefined !== data.text) {
            return _extends({}, data);
          }
          return null;
        },
        language: {
          noResults: function noResults() {
            return (0, _g3wI18n.t)("sdk.search.no_results");
          },
          errorLoading: function errorLoading() {
            return (0, _g3wI18n.t)("sdk.search.error_loading");
          },
          searching: function searching() {
            return (0, _g3wI18n.t)("sdk.search.searching");
          },
          inputTooShort: function inputTooShort(d) {
            return (0, _g3wI18n.t)("sdk.search.autocomplete.inputshort.pre") + ' ' + (d.minimum - d.input.length) + ' ' + (0, _g3wI18n.t)("sdk.search.autocomplete.inputshort.post");
          }
        }
      });
      this.select2.on('select2:select', function (e) {
        _this7.atlas_values.push(e.params.data.id);
      });
      this.select2.on('select2:unselect', function (e) {
        _this7.atlas_values = _this7.atlas_values.filter(function (v) {
          return v != e.params.data.id;
        });
      });
    }
  },

  watch: {
    has_autocomplete: function () {
      var _ref7 = _asyncToGenerator(function* (b) {
        if (!b) {
          return;
        }
        yield this.$nextTick();
        this.initSelect2Field();
      });

      function has_autocomplete(_x5) {
        return _ref7.apply(this, arguments);
      }

      return has_autocomplete;
    }(),


    atlas_values: {
      immediate: true,
      handler: function () {
        var _ref8 = _asyncToGenerator(function* (vals) {
          var _this8 = this;

          if (this._skip_atlas_check || !this.state.atlas) {
            return;
          }
          if (this.has_autocomplete) {
            this.disabled = 0 === vals.length;
            return;
          }
          var validate = function validate(n) {
            return n && Number.isInteger(1 * n) && 1 * n >= 0 && 1 * n < _this8.state.atlas.feature_count || null;
          };
          var values = new Set();
          var value = (vals ? vals[0] : '') || '';
          value.split(',').filter(function (v) {
            return v;
          }).forEach(function (value) {
            if (!value.includes('-') && null !== validate(value)) {
              values.add(value);
              return;
            }
            var _values = value.split('-');
            var range = _values.filter(function (v) {
              return validate(v) !== null;
            });
            if (range.length === _values.length && range.reduce(function (bool, value, i) {
              return bool && (0 === i || range[i - 1] <= value);
            }, true)) {
              for (var i = 1; i < range.length; i++) {
                for (var j = range[i - 1]; j < range[i]; j++) {
                  values.add(j + '');
                }
              }
              values.add(range[range.length - 1]);
            }
          });
          this._skip_atlas_check = true;
          this.atlas_values = Array.from(values);
          yield this.$nextTick();
          this._skip_atlas_check = false;
          this.disabled = '' === value.trim();
        });

        function handler(_x6) {
          return _ref8.apply(this, arguments);
        }

        return handler;
      }()
    },

    'state.url': function () {
      var _ref9 = _asyncToGenerator(function* (url) {
        var _this9 = this;

        if (!url) {
          return;
        }
        var timeout = void 0;

        try {

          yield this.$nextTick();

          timeout = setTimeout(function () {
            _gui2.default.disableSideBar(false);
            _this9.state.downloading = false;
            _gui2.default.showUserMessage({ type: 'alert', message: 'timeout' });
          }, _g3wConstants.TIMEOUT);

          var response = yield fetch(url);

          if (!response.ok) {
            throw response.statusText;
          }
        } catch (e) {
          console.warn(e);
          _gui2.default.notify.error(e || (0, _g3wI18n.t)("info.server_error"));
          _gui2.default.closeContent();
        } finally {
          clearTimeout(timeout);
          _gui2.default.disableSideBar(false);
          this.state.downloading = false;
        }
      });

      function stateUrl(_x7) {
        return _ref9.apply(this, arguments);
      }

      return stateUrl;
    }()

  },

  mounted: function () {
    var _ref10 = _asyncToGenerator(function* () {
      yield this.$nextTick();

      if (this.state.atlas) {
        this.initSelect2Field();
      }
    });

    function mounted() {
      return _ref10.apply(this, arguments);
    }

    return mounted;
  }()
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"treeview-menu",attrs:{"id":"print"}},[_c('li',[(_vm.state.print.length)?_c('form',{staticClass:"g3w-search-form form-horizonal",staticStyle:{"border-radius":"0 0 3px 3px","padding":"10px"}},[_c('bar-loader',{attrs:{"loading":_vm.state.loading}}),_vm._v(" "),_c('fieldset',{staticStyle:{"border":"1px solid","padding":"4.9px 8.75px 8.75px 10.5px","border-radius":"3px","background-color":"rgb(56, 66, 70)","color":"rgb(255, 255, 255)","user-select":"none"}},[_c('legend',{staticStyle:{"width":"15px","height":"15px","border":"1px solid","border-radius":"50%","background-color":"rgb(34, 45, 50)","font-weight":"bold","color":"rgb(255, 255, 255)","font-size":"0.7em","text-align":"center","margin":"0px -14px","user-select":"none"}},[_vm._v("i")]),_vm._v(" "),_c('details',[_c('summary',{directives:[{name:"t-tooltip",rawName:"v-t-tooltip:right.create",value:('show_more'),expression:"'show_more'",arg:"right",modifiers:{"create":true}}],staticStyle:{"cursor":"pointer","display":"flex","justify-content":"space-between","align-items":"center","width":"100%"}},[_c('span',{directives:[{name:"t",rawName:"v-t",value:('sdk.print.help'),expression:"'sdk.print.help'"}],staticStyle:{"text-overflow":"ellipsis","overflow":"hidden"}}),_vm._v(" "),_c('i',{staticClass:"far fa-eye"})]),_vm._v(" "),_c('hr',{staticStyle:{"margin":"10px 0","border-style":"dotted"}}),_vm._v(" "),_c('div',{directives:[{name:"t-html",rawName:"v-t-html",value:('sdk.print.help_details'),expression:"'sdk.print.help_details'"}],staticStyle:{"white-space":"wrap","line-height":"25px"}})])]),_vm._v(" "),_c('label',{directives:[{name:"t",rawName:"v-t",value:('sdk.print.template'),expression:"'sdk.print.template'"}],attrs:{"for":"templates"}}),_vm._v(" "),_c('select',{directives:[{name:"select2",rawName:"v-select2",value:('state.template'),expression:"'state.template'"}],staticClass:"form-control",style:({ marginBottom: this.state.atlas && '10px' }),attrs:{"id":"templates","select2_value":_vm.state.template},on:{"change":_vm.changeTemplate}},_vm._l((_vm.state.print),function(print){return _c('option',{domProps:{"value":print.name}},[_vm._v(_vm._s(print.name))])}),0),_vm._v(" "),(!_vm.state.atlas)?[_c('label',{directives:[{name:"t",rawName:"v-t",value:('sdk.print.scale'),expression:"'sdk.print.scale'"}],attrs:{"for":"scale"}}),_vm._v(" "),_c('select',{directives:[{name:"disabled",rawName:"v-disabled",value:(!_vm.has_maps),expression:"!has_maps"},{name:"select2",rawName:"v-select2",value:('state.scale'),expression:"'state.scale'"}],ref:"scales",staticClass:"form-control",attrs:{"id":"scale","select2_value":_vm.state.scale,"createTag":true},on:{"change":_vm.changeScale}},_vm._l((_vm.state.scales),function(scale){return _c('option',{domProps:{"value":scale.value}},[_vm._v(_vm._s(scale.label))])}),0),_vm._v(" "),_c('label',{attrs:{"for":"dpi"}},[_vm._v("dpi")]),_vm._v(" "),_c('select',{directives:[{name:"select2",rawName:"v-select2",value:('state.dpi'),expression:"'state.dpi'"}],ref:"dpi",staticClass:"form-control",attrs:{"id":"dpi","select2_value":_vm.state.dpi,"createTag":true},on:{"change":_vm.changeDpi}},_vm._l((_vm.state.dpis),function(dpi){return _c('option',[_vm._v(_vm._s(dpi))])}),0),_vm._v(" "),_c('label',{directives:[{name:"t",rawName:"v-t",value:('sdk.print.rotation'),expression:"'sdk.print.rotation'"}],attrs:{"for":"rotation"}}),_vm._v(" "),_c('input',{directives:[{name:"disabled",rawName:"v-disabled",value:(!_vm.has_maps),expression:"!has_maps"},{name:"model",rawName:"v-model",value:(_vm.state.rotation),expression:"state.rotation"}],staticClass:"form-control",attrs:{"id":"rotation","min":"-360","max":"360","type":"number"},domProps:{"value":(_vm.state.rotation)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.state, "rotation", $event.target.value)},_vm.changeRotation]}}),_vm._v(" "),_c('label',{directives:[{name:"t",rawName:"v-t",value:('sdk.print.format'),expression:"'sdk.print.format'"}],attrs:{"for":"format"}}),_vm._v(" "),_c('select',{directives:[{name:"select2",rawName:"v-select2",value:('state.format'),expression:"'state.format'"}],staticClass:"form-control",attrs:{"id":"format","select2_value":_vm.state.format}},_vm._l((_vm.state.formats),function(format){return _c('option',{domProps:{"value":format.value}},[_vm._v(_vm._s(format.label))])}),0)]:_vm._e(),_vm._v(" "),(_vm.state.atlas)?_c('div',{ref:"print_atlas",staticClass:"form-group",staticStyle:{"width":"100%"}},[(_vm.has_autocomplete)?[_c('label',{attrs:{"for":"print_atlas_autocomplete"}},[_c('span',[_vm._v(_vm._s(_vm.state.atlas.field_name))])]),_vm._v(" "),_c('select',{staticClass:"form-control",attrs:{"id":"print_atlas_autocomplete","name":_vm.state.atlas.field_name}})]:[_c('label',[_c('span',[_vm._v("fids [max: "+_vm._s(_vm.state.atlas.feature_count - 1)+"]")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.atlas_values),expression:"atlas_values"}],staticClass:"form-control",domProps:{"value":(_vm.atlas_values)},on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"space",32,$event.key,[" ","Spacebar"])){ return null; }$event.preventDefault();},"input":function($event){if($event.target.composing){ return; }_vm.atlas_values=$event.target.value}}}),_vm._v(" "),_c('div',{attrs:{"id":"fid-print-atals-instruction"}},[_c('div',{directives:[{name:"t",rawName:"v-t",value:('sdk.print.fids_instruction'),expression:"'sdk.print.fids_instruction'"}],attrs:{"id":"fids_intruction"}}),_vm._v(" "),_c('div',{directives:[{name:"t",rawName:"v-t",value:('sdk.print.fids_example'),expression:"'sdk.print.fids_example'"}],attrs:{"id":"fids_examples_values"}})])]],2):_vm._e(),_vm._v(" "),(_vm.state.labels && _vm.state.labels.length > 0)?_c('div',{staticClass:"print-labels-content"},[_c('b',{directives:[{name:"t",rawName:"v-t",value:('sdk.print.labels'),expression:"'sdk.print.labels'"}],staticClass:"skin-color"}),_vm._v(" "),_c('div',{staticClass:"labels-input-content"},_vm._l((_vm.state.labels),function(label){return _c('span',{key:label.id},[_c('label',{attrs:{"for":("g3w_label_id_input_" + (label.id))}},[_vm._v(" "+_vm._s(label.id))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(label.text),expression:"label.text"}],staticClass:"form-control",attrs:{"id":("g3w_label_id_input_" + (label.id))},domProps:{"value":(label.text)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(label, "text", $event.target.value)}}})])}),0)]):_vm._e(),_vm._v(" "),_c('button',{directives:[{name:"disabled",rawName:"v-disabled",value:(_vm.disabled),expression:"disabled"},{name:"download",rawName:"v-download"},{name:"t",rawName:"v-t",value:('create_print'),expression:"'create_print'"}],staticClass:"sidebar-button-run btn",attrs:{"id":"printbutton"},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.print($event)}}})],2):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"padding":"1em","text-align":"center"}},[_c('b',[_c('a',{attrs:{"href":("https://docs.qgis.org/3.34/" + _vm.lang + "/docs/training_manual/map_composer/map_composer.html"),"target":"_blank","title":"QGIS Docs"}},[_c('i',{class:_vm.$fa('external-link')}),_vm._v(" Edit in QGIS\n      ")])])])])])}
__vue__options__.staticRenderFns = []
__vue__options__._scopeId = "data-v-e834f4ce"

},{"components/PrintPage.vue":123,"g3w-component":158,"g3w-constants":159,"g3w-i18n":162,"mixins/resize":202,"services/gui":207,"store/application":212,"utils/downloadFile":235,"utils/getCatalogLayerById":238,"utils/getResolutionFromScale":250,"utils/getScaleFromResolution":251,"utils/printAtlas":266,"utils/promisify":267,"vueify/lib/insert-css":35}],123:[function(require,module,exports){
var __vueify_style_dispose__ = require("vueify/lib/insert-css").insert("#print-output[data-v-6d81f770]{height:100%;position:relative}#print-output>iframe[data-v-6d81f770]{border:0;width:100%;height:100%}.g3w-print-image-output[data-v-6d81f770]{display:flex;flex-direction:column;position:relative;height:100%}#g3w-print-header[data-v-6d81f770]{display:flex;justify-content:flex-end;align-items:flex-end;margin-top:5px;margin-bottom:5px}#g3w-print-header button[data-v-6d81f770]{font-weight:700}.g3w-print-url[data-v-6d81f770]{height:100%;width:100%;position:relative;overflow-y:auto}.g3w-print-url>img[data-v-6d81f770]{height:auto;max-width:100%}#print-output>h4[data-v-6d81f770]{font-weight:700}")
;(function(){
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _application = require('store/application');

var _application2 = _interopRequireDefault(_application);

var _gui = require('services/gui');

var _gui2 = _interopRequireDefault(_gui);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

exports.default = {
  name: 'print-page',

  data: function data() {
    var state = this.$options.service.state || {};
    return {
      state: state,

      format: state.format,
      ready: false
    };
  },


  methods: {
    downloadImage: function () {
      var _ref = _asyncToGenerator(function* () {
        var _this = this;

        try {
          _gui2.default.disableSideBar(true);
          this.state.downloading = true;
          if (['jpg', 'png', 'svg'].includes(this.format)) {
            yield this.imageToDataURL({ src: this.state.url, type: 'image/' + this.format });
            setTimeout(function () {
              _gui2.default.disableSideBar(false);
              _this.state.downloading = false;
            });
          }
        } catch (e) {
          console.warn(e);
        }
      });

      function downloadImage() {
        return _ref.apply(this, arguments);
      }

      return downloadImage;
    }(),
    imageToDataURL: function imageToDataURL(_ref2) {
      var src = _ref2.src,
          _ref2$type = _ref2.type,
          type = _ref2$type === undefined ? 'image/jpeg' : _ref2$type,
          _ref2$callback = _ref2.callback,
          callback = _ref2$callback === undefined ? function () {} : _ref2$callback;

      return new Promise(function (resolve, reject) {
        var image = new Image();
        image.onload = function () {
          var canvas = document.createElement('canvas');
          var context = canvas.getContext('2d');
          canvas.height = this.naturalHeight;
          canvas.width = this.naturalWidth;
          context.drawImage(this, 0, 0);
          var dataURL = canvas.toDataURL(type);
          callback(dataURL);
          resolve(dataURL);
        };
        image.onerror = reject;
        image.src = src;
      });
    }
  },

  watch: {
    ready: {
      handler: function handler(bool) {
        _gui2.default.setLoadingContent(!bool);
      },

      immediate: true
    }
  },

  beforeDestroy: function beforeDestroy() {
    if (this.state.url && 'POST' === _application2.default.project.state.ows_method) {
      window.URL.revokeObjectURL(this.state.url);
    }
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"print-output"}},[_c('transition',{attrs:{"duration":500,"name":"fade"}},[_c('bar-loader',{attrs:{"loading":_vm.state.loading && _vm.state.layers}})],1),_vm._v(" "),(_vm.state.layers)?[(['pdf', 'geopdf'].includes(_vm.format))?_c('iframe',{ref:"out",attrs:{"src":_vm.state.url},on:{"load":function($event){_vm.ready = true},"error":function($event){_vm.ready = true}}}):_c('div',{staticClass:"g3w-print-image-output"},[_c('div',{attrs:{"id":"g3w-print-header"}},[_c('div',{class:{ 'g3w-disabled': !!(_vm.state.downloading && _vm.state.layers) }},[_c('a',{attrs:{"href":_vm.state.url,"download":("download." + _vm.format)}},[_c('button',{directives:[{name:"t-tooltip",rawName:"v-t-tooltip.create",value:('sdk.print.download_image'),expression:"'sdk.print.download_image'",modifiers:{"create":true}}],staticClass:"btn skin-button skin-tooltip-left",class:_vm.$fa('download'),attrs:{"data-placement":"left","data-toggle":"tooltip","data-container":"body","role":"button"},on:{"click":function($event){$event.stopPropagation();return _vm.downloadImage($event)}}})])])]),_vm._v(" "),(_vm.state.url)?_c('div',{staticClass:"g3w-print-url"},[_c('img',{ref:"out",attrs:{"src":_vm.state.url},on:{"load":function($event){_vm.ready = true},"error":function($event){_vm.ready = true}}})]):_vm._e()])]:_c('h4',{directives:[{name:"t",rawName:"v-t",value:('sdk.print.no_layers'),expression:"'sdk.print.no_layers'"}]})],2)}
__vue__options__.staticRenderFns = []
__vue__options__._scopeId = "data-v-6d81f770"

},{"services/gui":207,"store/application":212,"vueify/lib/insert-css":35}],124:[function(require,module,exports){
var __vueify_style_dispose__ = require("vueify/lib/insert-css").insert(".project-menu[data-v-0e4f8dbd]{cursor:pointer;margin-bottom:20px;margin-top:20px}.project-menu-item-image[data-v-0e4f8dbd]{position:relative;overflow:hidden;padding-bottom:50%}.project-menu-item-image img[data-v-0e4f8dbd]{position:absolute;top:0;bottom:0;left:0;right:0;margin:auto}.project-menu-item-content[data-v-0e4f8dbd]{padding:15px;background:hsla(0,0%,100%,.3)}.project-menu-item-text[data-v-0e4f8dbd]{position:relative;overflow:hidden;height:100%;text-align:justify}.project-menu-item-title[data-v-0e4f8dbd]{text-align:center;font-weight:700;background:hsla(0,0%,100%,.5);padding:5px}#menu-projects[data-v-0e4f8dbd]{width:100%;overflow-y:auto}#menu-projects .row-equal[data-v-0e4f8dbd]{display:flex;flex-wrap:wrap}")
;(function(){
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _gui = require('services/gui');

var _gui2 = _interopRequireDefault(_gui);

var _g3wI18n = require('g3w-i18n');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'projects-menu',

  data: function data() {
    return {
      state: null,
      loading: false
    };
  },


  methods: {
    trigger: function trigger(item) {
      if (item.cbk) this._initCallback(item);else if (item.href) window.open(item.href, '_blank');else if (item.route) _gui2.default.goto(item.route);else console.log("No action for " + item.title);
    },
    _initCallback: function _initCallback(item) {
      var _this = this;

      this._toggleModal(true);
      item.cbk.call(item, { gid: item.gid }).then(function (promise) {
        promise.then(function (project) {
          if (project) document.title = project.state.html_page_title;
        }).fail(function () {
          _gui2.default.notify.error("<h4>" + (0, _g3wI18n.t)("error_map_loading") + "</h4>" + "<h5>" + (0, _g3wI18n.t)("check_internet_connection_or_server_admin") + "</h5>");
        }).always(function () {
          _this._toggleModal(false);
        });
      });
    },
    _toggleModal: function _toggleModal(state) {
      _gui2.default.showFullModal({ show: state });
      _gui2.default.setLoadingContent(state);
    },
    logoSrc: function logoSrc(src) {
      var imageSrc = void 0;
      var host = this.$options.host || '';
      var has_media = src && src.includes(window.initConfig.mediaurl);
      var not_static = src && !src.includes('static') && !src.includes('media');

      if (!src) {
        imageSrc = '/static/client/images/FakeProjectThumb.png';
      } else if (has_media) {
        imageSrc = src;
      } else if (not_static) {
        imageSrc = '' + window.initConfig.mediaurl + src;
      } else {
        imageSrc = '/static/client/images/FakeProjectThumb.png';
      }

      return '' + host + imageSrc;
    }
  }

};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container",attrs:{"id":"menu-projects"}},[_c('div',{staticClass:"row row-equal"},[_vm._l((_vm.state.menuitems),function(menuitem){return _c('div',{key:menuitem.title,staticClass:"col-xs-12 col-sm-4 project-menu",on:{"click":function($event){return _vm.trigger(menuitem)}}},[_c('div',{staticClass:"project-menu-item-image"},[_c('img',{staticClass:"img-responsive",attrs:{"src":_vm.logoSrc(menuitem.thumbnail)}})]),_vm._v(" "),_c('div',{staticClass:"project-menu-item-content"},[_c('div',{staticClass:"project-menu-item-text"},[_c('h4',{staticClass:"project-menu-item-title"},[_vm._v(_vm._s(menuitem.title))]),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(menuitem.description)}})])])])}),_vm._v(" "),(!_vm.state.menuitems.length)?_c('div',{staticStyle:{"margin-left":"15px"}},[_c('h2',{directives:[{name:"t",rawName:"v-t",value:('no_other_projects'),expression:"'no_other_projects'"}]})]):_vm._e()],2)])}
__vue__options__.staticRenderFns = []
__vue__options__._scopeId = "data-v-0e4f8dbd"

},{"g3w-i18n":162,"services/gui":207,"vueify/lib/insert-css":35}],125:[function(require,module,exports){
var __vueify_style_dispose__ = require("vueify/lib/insert-css").insert("#query_builder[data-v-fe856d12]{margin-bottom:0;height:100%;display:flex;flex-wrap:nowrap;flex-direction:column}#query_builder .select2.select2-container[data-v-fe856d12]{font-weight:700}.querybuilder-title[data-v-fe856d12]{color:#fff;font-weight:700}select[data-v-fe856d12]{background-color:#fff;color:#000;border:none}option[data-v-fe856d12]{padding:8px;cursor:pointer}option[data-v-fe856d12]:checked{background:var(--skin-color) linear-gradient(0deg,var(--skin-color),var(--skin-color));color:#fff}option[data-v-fe856d12]:nth-of-type(odd){background-color:#f9f9f9}.query_builder_button[data-v-fe856d12]{margin:1px;flex-basis:78px;flex-grow:1;color:#000}.content-wrap[data-v-fe856d12]{display:flex;flex-wrap:wrap}.content-end[data-v-fe856d12]{display:flex;flex-wrap:wrap;justify-content:flex-end;margin-top:5px}.margin-between-element[data-v-fe856d12]{margin-bottom:5px}#query_builder_expression_content[data-v-fe856d12]{width:100%;resize:none;height:100px;color:#000}")
;(function(){
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _g3wConstants = require('g3w-constants');

var _application = require('store/application');

var _application2 = _interopRequireDefault(_application);

var _data = require('services/data');

var _data2 = _interopRequireDefault(_data);

var _gui = require('services/gui');

var _gui2 = _interopRequireDefault(_gui);

var _getUniqueDomId = require('utils/getUniqueDomId');

var _createFilterFromString = require('utils/createFilterFromString');

var _XHR = require('utils/XHR');

var _getCatalogLayerById = require('utils/getCatalogLayerById');

var _g3wI18n = require('g3w-i18n');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

exports.default = {
  name: 'query-builder',

  data: function data() {
    return {
      edit: undefined !== this.$options.options,
      currentlayer: null,
      message: '',
      filter: undefined !== this.$options.options ? this.$options.options.filter : '',
      loading: {
        test: false,
        values: false
      },
      values: [],
      manual: true,
      manualvalue: null,
      select: {
        field: null,
        value: null
      }
    };
  },


  computed: {
    fields: function fields() {
      return this.currentlayer ? this.currentlayer.fields : [];
    },
    disabled: function disabled() {
      return !this.filter;
    }
  },

  watch: {
    'select.field': function selectField() {
      this.values = [];
      this.manual = true;
    }
  },

  methods: {
    addToExpression: function addToExpression() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          value = _ref.value,
          type = _ref.type;

      switch (type) {
        case 'operator':
          value = ' ' + value + ' ';break;
        case 'field':
          value = '"' + value + '"';break;
        case 'value':
          value = '\'' + value + '\'';break;
      }
      if (value) this.filter = '' + this.filter + value;
    },
    all: function () {
      var _ref2 = _asyncToGenerator(function* () {
        this.loading.values = true;
        try {
          var layerId = this.currentlayer.id;
          var field = this.select.field;
          var CACHE = _application2.default.querybuilder.cache;
          CACHE[layerId] = CACHE[layerId] || {};
          if (undefined !== CACHE[layerId][field]) {
            this.values = CACHE[layerId][field];
          } else {
            var response = yield _XHR.XHR.get({
              url: (0, _getCatalogLayerById.getCatalogLayerById)(layerId).getUrl('data'),
              params: { ordering: field, formatter: 1, fformatter: field }
            });
            if (response.result) {
              CACHE[layerId][field] = CACHE[layerId][field] || response.data;
            }
            this.values = CACHE[layerId][field] || [];
          }
        } catch (e) {
          console.warn(e);
        }
        this.loading.values = false;
        yield this.$nextTick();
        this.manualvalue = null;
        this.manual = false;
      });

      function all() {
        return _ref2.apply(this, arguments);
      }

      return all;
    }(),
    reset: function reset() {
      this.filter = '';
      this.message = '';
      this.filterElement.previous = null;
      this.filterElement.current = null;
      this.filterElement.operator = null;
      this.select.field = null;
      if (this.$refs.search_fields) {
        this.$refs.search_fields.selectedIndex = -1;
      }
      if (this.$refs.search_values) {
        this.$refs.search_values.selectedIndex = -1;
      }
    },
    run: function () {
      var _ref3 = _asyncToGenerator(function* () {
        try {
          this.loading.test = true;
          var layer = (0, _getCatalogLayerById.getCatalogLayerById)(this.currentlayer.id);

          var _ref4 = yield _data2.default.getData('search:features', {
            inputs: {
              layer: layer,
              filter: (0, _createFilterFromString.createFilterFromString)({ layer: layer, filter: this.filter }),
              feature_count: 100
            },
            outputs: true
          }),
              data = _ref4.data;

          var n = data.length && data[0].features.length;
          this.message = undefined === n ? '' : ' ' + n;
          return data;
        } catch (e) {
          console.warn(e);
        } finally {
          this.loading.test = false;
        }
      });

      function run() {
        return _ref3.apply(this, arguments);
      }

      return run;
    }(),
    save: function () {
      var _ref5 = _asyncToGenerator(function* () {
        var id = this.projectId || _application2.default.project.getId();
        var edit_id = this.edit && this.$options.options.id;
        var item = window.localStorage.getItem('QUERYBUILDERSEARCHES');
        var searches = item ? JSON.parse(item) : undefined;

        var query = void 0;

        try {
          query = {
            layerId: this.currentlayer.id,
            filter: this.filter,
            layerName: (0, _getCatalogLayerById.getCatalogLayerById)(this.currentlayer.id).getName(),
            name: edit_id ? this.edit && this.$options.options.name : yield new Promise(function (res, rej) {
              _gui2.default.dialog.prompt((0, _g3wI18n.t)('sdk.querybuilder.additem'), function (d) {
                return d ? res(d) : rej();
              });
            }),
            id: edit_id || (0, _getUniqueDomId.getUniqueDomId)()
          };

          if (edit_id) {
            var i = searches[id].findIndex(function (s) {
              return s.id === query.id;
            });
            if (-1 !== i) {
              searches[id][i] = query;
            }
          } else {
              _gui2.default.getService('search').state.querybuildersearches.push(query);
              if (undefined === searches) {
                searches = _defineProperty({}, id, [query]);
              } else {
                searches[id] = [].concat(_toConsumableArray(searches[id] || []), [query]);
              }
            }
        } catch (e) {
          console.warn(e);
          return;
        }

        var ITEMS = _application2.default.querybuilder.searches;

        try {
          window.localStorage.setItem('QUERYBUILDERSEARCHES', JSON.stringify(searches));
        } catch (e) {
          console.warn(e);
        }

        setTimeout(function () {
          searches[id].forEach(function (q) {
            return ITEMS[id].push(q);
          });
        }, 0);
        ITEMS[id].splice(0);
        _gui2.default.showUserMessage({ type: 'success', message: (0, _g3wI18n.t)("sdk.querybuilder.messages.changed"), autoclose: true });
      });

      function save() {
        return _ref5.apply(this, arguments);
      }

      return save;
    }()
  },

  created: function created() {
    var _this = this;

    this.filterElement = {
      current: null,
      previous: null,
      operator: null
    };

    var project = _application2.default.project;

    this.layers = project.getLayers().filter(function (l) {
      return !l.baselayer && Array.isArray(l.fields);
    }).map(function (layer) {
      var exclude = [];
      project.state.relations.filter(function (r) {
        return layer.id === r.referencedLayer && 'ONE' === r.type;
      }).forEach(function (r) {
        var l = project.getLayerById(r.referencingLayer);
        r.customPrefix = r.customPrefix === undefined ? l.getName() + '_' : r.customPrefix;
        exclude = [].concat(_toConsumableArray(exclude), _toConsumableArray(l.getFields().map(function (field) {
          return '' + r.customPrefix + field.name;
        })));
      });
      return {
        id: layer.id,
        label: layer.title,
        fields: layer.fields.filter(function (f) {
          return f.show;
        }).map(function (f) {
          return { label: f.label, name: f.name };
        }).filter(function (f) {
          return !exclude.includes(f);
        })
      };
    });

    this.operators = Object.values(_g3wConstants.FILTER_OPERATORS);

    this.currentlayer = this.edit ? this.layers.find(function (l) {
      return l.id === _this.$options.options.layerId;
    }) : this.layers[0];
  },
  mounted: function () {
    var _ref6 = _asyncToGenerator(function* () {
      var _this2 = this;

      yield this.$nextTick();

      this.select2 = $('#query_builder_layers_select').select2({ width: '100%' });

      if (this.edit) {
        this.select2.val(this.layers.indexOf(this.currentlayer));
        this.select2.trigger('change');
      }

      this.select2.on('select2:select', function (e) {
        _this2.currentlayer = _this2.layers[e.params.data.id];
        _this2.select.field = null;
        _this2.select.value = null;
        _this2.reset();
      });
    });

    function mounted() {
      return _ref6.apply(this, arguments);
    }

    return mounted;
  }(),
  beforeDestroy: function beforeDestroy() {
    this.select2.select2('destroy');
    this.select2 = null;
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group",attrs:{"id":"query_builder"}},[_c('div',{staticClass:"margin-between-element",attrs:{"id":"query_builder_layers"}},[_c('label',{directives:[{name:"t",rawName:"v-t",value:('sdk.querybuilder.panel.expression'),expression:"'sdk.querybuilder.panel.expression'"}],staticClass:"querybuilder-title"}),_vm._v(" "),_c('a',{staticStyle:{"float":"right"},attrs:{"href":"https://g3w-suite.readthedocs.io/en/v3.7.x/g3wsuite_client.html#search-and-query-builder","target":"_blank","title":"Docs"}},[_c('i',{class:_vm.$fa('external-link')})]),_vm._v(" "),_c('select',{staticClass:"form-control",attrs:{"id":"query_builder_layers_select"}},_vm._l((_vm.layers),function(layer,i){return _c('option',{key:layer.label,staticClass:"bold",domProps:{"value":i}},[_vm._v(_vm._s(layer.label))])}),0)]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.filter),expression:"filter"}],attrs:{"id":"query_builder_expression_content"},domProps:{"value":(_vm.filter)},on:{"input":function($event){if($event.target.composing){ return; }_vm.filter=$event.target.value}}}),_vm._v(" "),_c('bar-loader',{attrs:{"loading":_vm.loading.test}}),_vm._v(" "),_c('b',{directives:[{name:"show",rawName:"v-show",value:(_vm.message),expression:"message"}],staticClass:"skin-color"},[_c('span',{directives:[{name:"t",rawName:"v-t",value:('sdk.querybuilder.messages.number_of_features'),expression:"'sdk.querybuilder.messages.number_of_features'"}]}),_vm._v(_vm._s(_vm.message))]),_vm._v(" "),_c('div',{staticClass:"content-end"},[_c('button',{directives:[{name:"t",rawName:"v-t",value:('sdk.querybuilder.panel.button.run'),expression:"'sdk.querybuilder.panel.button.run'"}],staticClass:"query_builder_button btn btn-secondary bold",attrs:{"disabled":_vm.disabled},on:{"click":_vm.run}},[_c('i',{class:_vm.$fa('run'),staticStyle:{"color":"green"}})]),_vm._v(" "),_c('button',{directives:[{name:"t",rawName:"v-t",value:('sdk.querybuilder.panel.button.clear'),expression:"'sdk.querybuilder.panel.button.clear'"}],staticClass:"query_builder_button btn btn-secondary bold",on:{"click":_vm.reset}},[_c('i',{class:_vm.$fa('clear')})]),_vm._v(" "),_c('button',{directives:[{name:"t",rawName:"v-t",value:('sdk.querybuilder.panel.button.save'),expression:"'sdk.querybuilder.panel.button.save'"}],staticClass:"query_builder_button btn btn-secondary bold",attrs:{"disabled":_vm.disabled},on:{"click":_vm.save}},[_c('i',{class:_vm.$fa('save')})])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('label',{directives:[{name:"t",rawName:"v-t",value:('sdk.querybuilder.panel.fields'),expression:"'sdk.querybuilder.panel.fields'"}]}),_vm._v(" "),_c('select',{ref:"search_fields",staticClass:"margin-between-element",attrs:{"size":"4"}},[_c('option',{attrs:{"selected":"","hidden":""}}),_vm._v(" "),_vm._l((_vm.fields),function(field){return _c('option',{key:field.name,on:{"click":function($event){_vm.select.field = field.name; _vm.addToExpression({ value: field.name, type: 'field' })}}},[_vm._v(_vm._s(field.label))])})],2),_vm._v(" "),_c('div',{staticClass:"content-wrap margin-between-element"},_vm._l((_vm.operators),function(operator){return _c('button',{key:operator,staticClass:"query_builder_button btn btn-secondary bold",on:{"click":function($event){return _vm.addToExpression({ value: operator, type: 'operator' })}}},[_vm._v(_vm._s(operator))])}),0),_vm._v(" "),_c('bar-loader',{attrs:{"loading":_vm.loading.values}}),_vm._v(" "),(!_vm.manual)?_c('select',{ref:"search_values",staticClass:"margin-between-element",attrs:{"size":"4"}},[_c('option',{attrs:{"selected":"","hidden":""}}),_vm._v(" "),_vm._l((_vm.values),function(ref){
var key = ref[0];
var value = ref[1];
return _c('option',{key:key,on:{"click":function($event){_vm.select.value = key; _vm.addToExpression({ value: key, type: 'value' })}}},[_vm._v(_vm._s(value))])})],2):_vm._e(),_vm._v(" "),(_vm.select.field !== null && !_vm.values.length)?_c('button',{staticClass:"btn btn-secondary bold",class:{'skin-border-color' : !_vm.manual },staticStyle:{"color":"#000"},on:{"click":_vm.all}},[_c('i',{class:_vm.g3wtemplate.getFontClass('search')}),_vm._v(" "),_c('span',{directives:[{name:"t",rawName:"v-t",value:('sdk.querybuilder.panel.button.all'),expression:"'sdk.querybuilder.panel.button.all'"}]})]):_vm._e()],1)}
__vue__options__.staticRenderFns = []
__vue__options__._scopeId = "data-v-fe856d12"

},{"g3w-constants":159,"g3w-i18n":162,"services/data":206,"services/gui":207,"store/application":212,"utils/XHR":215,"utils/createFilterFromString":226,"utils/getCatalogLayerById":238,"utils/getUniqueDomId":252,"vueify/lib/insert-css":35}],126:[function(require,module,exports){
var __vueify_style_dispose__ = require("vueify/lib/insert-css").insert(".feature_attributes tr[data-v-863e1f5c]{line-height:1.8em}.featurebox-body+tr[data-v-863e1f5c]{border-top:2px groove #000}#g3w-queryresults-pagination[data-v-863e1f5c]{display:flex;justify-content:space-between;align-items:baseline;margin-top:15px;flex-wrap:wrap}#g3w-queryresults-pagination button[data-v-863e1f5c],#g3w-queryresults-pagination span[data-v-863e1f5c]{background-color:transparent;margin:2px;font-weight:700;font-size:.8em}#g3w-queryresults-pagination button[data-v-863e1f5c],#g3w-queryresults-pagination select[data-v-863e1f5c]{min-width:0}#pagination-pages[data-v-863e1f5c]{display:flex;align-items:baseline}#pagination-pages label[data-v-863e1f5c]{margin-left:3px;font-size:1.2em}")
;(function(){
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _mixins = require('mixins');

var _QueryResultsTableAttributeFieldValue = require('components/QueryResultsTableAttributeFieldValue.vue');

var _QueryResultsTableAttributeFieldValue2 = _interopRequireDefault(_QueryResultsTableAttributeFieldValue);

var _QueryResultsActionInfoFormats = require('components/QueryResultsActionInfoFormats.vue');

var _QueryResultsActionInfoFormats2 = _interopRequireDefault(_QueryResultsActionInfoFormats);

var _QueryResultsHeaderFeatureBody = require('components/QueryResultsHeaderFeatureBody.vue');

var _QueryResultsHeaderFeatureBody2 = _interopRequireDefault(_QueryResultsHeaderFeatureBody);

var _QueryResultsHeaderFeatureActionsBody = require('components/QueryResultsHeaderFeatureActionsBody.vue');

var _QueryResultsHeaderFeatureActionsBody2 = _interopRequireDefault(_QueryResultsHeaderFeatureActionsBody);

var _toRawType = require('utils/toRawType');

var _throttle = require('utils/throttle');

var _getCatalogLayerById = require('utils/getCatalogLayerById');

var _getMapLayersByFilter = require('utils/getMapLayersByFilter');

var _gui = require('services/gui');

var _gui2 = _interopRequireDefault(_gui);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var MAX_SUBSET_LENGTH = 3;
var headerExpandActionCellWidth = 10;
var headerActionsCellWidth = 10;
var HEADERTYPESFIELD = ['varchar', 'integer', 'float', 'bigint', 'date'];

exports.default = {
  name: 'queryresults',

  data: function data() {
    return {
      state: this.$options.service.state,
      headerExpandActionCellWidth: headerExpandActionCellWidth,
      headerActionsCellWidth: headerActionsCellWidth
    };
  },

  mixins: [_mixins.fieldsMixin],
  components: {
    TableAttributeFieldValue: _QueryResultsTableAttributeFieldValue2.default,
    'infoformats': _QueryResultsActionInfoFormats2.default,
    'header-feature-body': _QueryResultsHeaderFeatureBody2.default,
    HeaderFeatureActionsBody: _QueryResultsHeaderFeatureActionsBody2.default
  },
  computed: {
    onelayerresult: function onelayerresult() {
      return 1 === this.state.layers.length;
    },
    hasLayers: function hasLayers() {
      return this.hasResults || !!this.state.components.length;
    },
    hasResults: function hasResults() {
      return this.state.layers.length > 0;
    },
    info: function info() {
      if (this.state.query) {
        var query = this.state.query;

        var decimalNumber = 'degrees' === _gui2.default.getService('map').getMapUnits() ? 4 : 2;
        switch (query.type) {
          case 'coordinates':
            return {
              icon: 'marker',
              message: '  ' + query.coordinates[0].toFixed(decimalNumber) + ', ' + query.coordinates[1].toFixed(decimalNumber)
            };
          case 'bbox':
            return {
              icon: 'square',
              message: '  [' + query.bbox.map(function (c) {
                return c.toFixed(decimalNumber);
              }).join(' , ') + ']'
            };
          case 'polygon':
          case 'drawpolygon':
            return {
              icon: 'draw',
              message: query.layerName ? query.layerName + ' ' + (undefined !== query.fid ? ' - Feature Id: ' + query.fid : '') : ' ' };
          case 'circle':
            return {
              icon: 'empty-circle',
              message: ' ' };
          default:
            console.warn('Unsupported query type:  ' + query.type);
            break;
        }
      } else if (this.state.search) {}

      return { icon: null, message: null };
    },
    queryableLayers: function queryableLayers() {
      return (0, _getMapLayersByFilter.getMapLayersByFilter)({ QUERYABLE: true });
    },
    selectedLayer: function selectedLayer() {
      return _gui2.default.getService('map').getSelectedLayer();
    }
  },
  methods: {
    showInPagination: function showInPagination(layer) {
      return !layer.filter.pagination;
    },
    getLayerDownloads: function getLayerDownloads() {
      var downloads = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      return downloads.filter(function (d) {
        return 'pdf' !== d;
      });
    },
    showLayer: function showLayer(layer) {
      return layer.show && (this.layerHasFeatures(layer) || layer.rawdata || Array.isArray(layer.infoformats) && layer.infoformats.length > 0);
    },
    getLayerCustomComponents: function getLayerCustomComponents(layerId) {
      var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'feature';
      var position = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'after';

      return this.state.layerscustomcomponents[layerId] && this.state.layerscustomcomponents[layerId][type] && this.state.layerscustomcomponents[layerId][type][position] || [];
    },
    getLayerField: function getLayerField(_ref) {
      var layer = _ref.layer,
          feature = _ref.feature,
          fieldName = _ref.fieldName;

      var layerField = layer.attributes.find(function (a) {
        return fieldName === a.name;
      });
      return _extends({}, layerField, {
        label: null,
        value: feature.attributes[fieldName]
      });
    },
    getQueryFields: function getQueryFields(layer, feature) {
      var fields = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = layer.formStructure.fields[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var field = _step.value;

          var _field = _extends({}, field);
          _field.query = true;
          _field.value = feature.attributes[field.name];
          _field.input = {
            type: '' + this.getFieldType(_field)
          };
          fields.push(_field);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return fields;
    },
    getColSpan: function getColSpan(layer) {
      return this.attributesSubsetLength(layer) + !this.hasLayerOneFeature(layer) * 1;
    },
    addLayerFeaturesToResults: function addLayerFeaturesToResults(layer) {
      this.$options.service.addLayerFeaturesToResultsAction(layer);
    },
    printAtlas: function printAtlas(layer) {
      this.$options.service.printAtlas(layer);
    },
    showLayerDownloadFormats: function showLayerDownloadFormats(layer) {
      this.$options.service.showLayerDownloadFormats(layer);
    },
    saveLayerResult: function saveLayerResult(layer) {
      var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "csv";

      this.$options.service.downloadFeatures(type, layer, layer.features);
    },
    hasLayerOneFeature: function hasLayerOneFeature(layer) {
      return 1 === layer.features.length;
    },
    saveFilter: function saveFilter(layer) {
      (0, _getCatalogLayerById.getCatalogLayerById)(layer.id).saveFilter();
    },
    addRemoveFilter: function () {
      var _ref2 = _asyncToGenerator(function* (layer) {
        var _this = this;

        yield (0, _getCatalogLayerById.getCatalogLayerById)(layer.id).toggleFilterToken();

        if (layer.filter.active) {
          layer.features.filter(function (f) {
            return !f.selection.selected;
          }).forEach(function (f) {
            return _this.$options.service.removeFeatureLayerFromResult(layer, f);
          });
        }
      });

      function addRemoveFilter(_x5) {
        return _ref2.apply(this, arguments);
      }

      return addRemoveFilter;
    }(),
    getContainerFromFeatureLayer: function getContainerFromFeatureLayer() {
      var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          layer = _ref3.layer,
          index = _ref3.index;

      return $('#' + layer.id + '_' + index + ' > td');
    },
    hasOneLayerAndOneFeature: function hasOneLayerAndOneFeature(layer) {
      return this.hasLayerOneFeature(layer);
    },
    hasFormStructure: function hasFormStructure(layer) {
      return !!layer.formStructure;
    },
    layerHasFeatures: function layerHasFeatures(layer) {
      return Array.isArray(layer.features) && layer.features.length > 0;
    },
    addToSelection: function addToSelection(layer) {
      this.$options.service.addToSelection(layer);
    },
    extractAttributesFromFirstTabOfFormStructureLayers: function extractAttributesFromFirstTabOfFormStructureLayers(layer) {
      var _this2 = this;

      var attributes = new Set();
      var traverseStructure = function traverseStructure(item) {
        if (item.nodes) {
          item.nodes.forEach(function (node) {
            return traverseStructure(node);
          });
        } else {
          var field = layer.formStructure.fields.find(function (f) {
            return item.field_name === f.name;
          });
          if (field) {
            if (_this2.state.type === 'ows') {
              field = _extends({}, field);
              field.name = field.name.replace(/ /g, '_');
            }
            attributes.add(field);
          }
        }
      };
      if (layer.formStructure.structure.length) {
        layer.formStructure.structure.forEach(function (structure) {
          return traverseStructure(structure);
        });
      }
      return Array.from(attributes);
    },
    attributesSubset: function attributesSubset(layer) {
      var attributes = this.hasFormStructure(layer) ? this.extractAttributesFromFirstTabOfFormStructureLayers(layer) : layer.attributes;
      var _attributes = attributes.filter(function (attribute) {
        return attribute.show && HEADERTYPESFIELD.includes(attribute.type);
      });

      var end = Math.min(MAX_SUBSET_LENGTH, attributes.length);
      return _attributes.slice(0, end);
    },
    attributesSubsetLength: function attributesSubsetLength(layer) {
      return this.attributesSubset(layer).length;
    },
    getLayerFormStructure: function getLayerFormStructure(layer) {
      return layer.formStructure.structure.map(function (n) {
        return Vue.observable(structuredClone(n));
      });
    },
    getLayerFeatureBox: function getLayerFeatureBox(layer, feature, relation_index) {
      var _this3 = this;

      var boxid = this.getBoxId(layer, feature, relation_index);
      if (undefined === this.state.layersFeaturesBoxes[boxid]) {
        this.state.layersFeaturesBoxes[boxid] = Vue.observable({
          collapsed: true
        });
        this.$watch(function () {
          return _this3.state.layersFeaturesBoxes[boxid].collapsed;
        }, function (collapsed) {
          var index = layer.features.findIndex(function (_feature) {
            return feature.id === _feature.id;
          });
          var container = _this3.getContainerFromFeatureLayer({ layer: layer, index: index });
          _this3.$options.service.openCloseFeatureResult({ open: !collapsed, layer: layer, feature: feature, container: container });
        });
        this.state.layersFeaturesBoxes[boxid].collapsed = layer.features.length > 1;
      }
      return this.state.layersFeaturesBoxes[boxid];
    },
    collapsedFeatureBox: function collapsedFeatureBox(layer, feature, relation_index) {
      var box = this.state.layersFeaturesBoxes[this.getBoxId(layer, feature, relation_index)];
      return box ? box.collapsed : true;
    },
    showFeatureInfo: function showFeatureInfo(layer, boxid) {
      var box = this.state.layersFeaturesBoxes[boxid];
      this.$options.service.emit('show-query-feature-info', {
        layer: layer,
        tabs: this.hasFormStructure(layer),
        show: box ? !box.collapsed : false
      });
    },
    getBoxId: function getBoxId(layer, feature, relation_index) {
      return this.$options.service.getBoxId(layer, feature, relation_index);
    },
    toggleFeatureBox: function () {
      var _ref4 = _asyncToGenerator(function* (layer, feature, relation_index) {
        var boxid = this.getBoxId(layer, feature, relation_index);
        this.state.layersFeaturesBoxes[boxid].collapsed = !this.state.layersFeaturesBoxes[boxid].collapsed;
        yield this.$nextTick();
        this.showFeatureInfo(layer, boxid);
      });

      function toggleFeatureBox(_x7, _x8, _x9) {
        return _ref4.apply(this, arguments);
      }

      return toggleFeatureBox;
    }(),
    toggleFeatureBoxAndZoom: function toggleFeatureBoxAndZoom(layer, feature, relation_index) {
      if (!this.hasLayerOneFeature(layer)) {
        this.toggleFeatureBox(layer, feature, relation_index);
      }
    },
    trigger: function () {
      var _ref5 = _asyncToGenerator(function* (action, layer, feature, index) {
        if (action.opened && 'none' === $('#' + layer.id + '_' + index).css('display')) {
          this.toggleFeatureBox(layer, feature);
          yield this.$nextTick();
        }
        yield this.$options.service.trigger(action.id, layer, feature, index, this.getContainerFromFeatureLayer({ layer: layer, index: index }));
      });

      function trigger(_x10, _x11, _x12, _x13) {
        return _ref5.apply(this, arguments);
      }

      return trigger;
    }(),
    openLink: function openLink(link_url) {
      window.open(link_url, '_blank');
    },
    isJSON: function isJSON(field) {
      return !this.isVue(field) && this.isSimple(field) && 'Object' === (0, _toRawType.toRawType)(field.value);
    },
    openAttributeTable: function openAttributeTable(layer) {
      (0, _getCatalogLayerById.getCatalogLayerById)(layer.id).openAttributeTable({ perc: 100 });
    },
    highLightLayerFeatures: function highLightLayerFeatures(layer) {
      var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { highlight: true };

      if (layer.hasgeometry) {
        this.$options.service.highLightLayerFeatures(layer, opts);
      }
    },
    collapseSidebar: function collapseSidebar(e) {
      var box = e.target.closest(".box");
      var collapsed = box.classList.contains('collapsed-box');
      box.classList.toggle('collapsed-box');
      box.querySelector(".btn-collapser").classList.toggle('fa-plus', !collapsed);
      box.querySelector(".btn-collapser").classList.add('fa-minus', collapsed);
    },
    showPagination: function showPagination(index) {
      return this.state.query.pagination && this.state.layers[index].features.length < this.state.query.pagination.counts[index];
    },
    loadPaginationData: function () {
      var _ref6 = _asyncToGenerator(function* (index, page, page_size) {
        this.state.layers[index].loading = true;
        try {
          yield this.$options.service.loadPaginationData(index, page, page_size, this.state.query);
        } catch (e) {
          console.warn(e);
        }
        this.state.layers[index].loading = false;
      });

      function loadPaginationData(_x15, _x16, _x17) {
        return _ref6.apply(this, arguments);
      }

      return loadPaginationData;
    }(),
    getCurrentPagSize: function getCurrentPagSize(index) {
      return this.state.query.pagination.getData.params[index].page_size;
    }
  },

  watch: {
    'state.layers': function () {
      var _ref7 = _asyncToGenerator(function* () {
        var _this4 = this;

        var layers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

        layers.forEach(function (layer) {
          if (layer.attributes.length <= MAX_SUBSET_LENGTH && !layer.hasImageField) {
            layer.expandable = false;
          }
          layer.features.forEach(function (feature) {
            _this4.getLayerFeatureBox(layer, feature);
            if (feature.attributes.relations) {
              feature.attributes.relations.forEach(function (relation) {
                relation.elements.forEach(function (element, index) {
                  return _this4.state.layersFeaturesBoxes[layer.id + '_' + feature.id + '_' + relation.name + index] = { collapsed: true };
                });
              });
            }
          });
        });

        if (this.onelayerresult && this.hasLayerOneFeature(layers[0])) {
          var layer = layers[0];
          var feature = layer.features[0];
          var boxid = this.getBoxId(layer, feature);
          this.$options.service.onceafter('postRender', function () {
            _this4.showFeatureInfo(layer, boxid);
          });
        }
        requestAnimationFrame(function () {
          return _this4.$options.service.postRender(_this4.$el);
        });
        yield this.$nextTick();
      });

      function stateLayers() {
        return _ref7.apply(this, arguments);
      }

      return stateLayers;
    }(),
    onelayerresult: function onelayerresult(bool) {
      if (bool && !this.state.query.pagination) {
        _gui2.default.getService('map').highlightFeatures(this.state.layers[0].features, { duration: Infinity });
      }
    }
  },
  created: function created() {
    var _this5 = this;

    this.zoomToLayerFeaturesExtent = (0, _throttle.throttle)(function (layer) {
      _this5.$options.service.zoomToLayerFeaturesExtent(layer);
    });
  },
  destroyed: function destroyed() {
    this.$options.service.clear();
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"queryresults-wrapper",attrs:{"id":"search-results"}},[(_vm.info.message)?_c('div',{staticClass:"skin-color",staticStyle:{"font-weight":"bold","margin-bottom":"3px","font-size":"1.1em"}},[(_vm.info.icon)?_c('span',{class:_vm.g3wtemplate.getFontClass(_vm.info.icon)}):_vm._e(),_vm._v(" "),_c('span',[_vm._v(" "+_vm._s(_vm.info.message)+" ")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"queryresults-container"},[(_vm.state.layers.length)?[(_vm.hasLayers)?_c('ul',{staticClass:"queryresults",staticStyle:{"position":"relative"},attrs:{"id":"queryresults"}},[_vm._l((_vm.state.layers),function(layer,index){return _c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.showLayer(layer)),expression:"showLayer(layer)"}]},[_c('bar-loader',{attrs:{"loading":layer.loading}}),_vm._v(" "),_c('div',{staticClass:"box box-primary"},[_c('div',{staticClass:"box-header with-border",class:{'mobile': _vm.isMobile()},on:{"mouseover":function($event){$event.stopPropagation();return _vm.highLightLayerFeatures(layer, { highlight: true, duration: Infinity })},"mouseout":function($event){$event.stopPropagation();return _vm.highLightLayerFeatures(layer, { highlight: false })},"click":function($event){$event.stopPropagation();return _vm.collapseSidebar($event)}}},[_c('div',{staticClass:"box-title query-layer-title",style:({fontSize: _vm.isMobile() && '1em !important'})},[(!layer.external)?_c('span',{directives:[{name:"t-tooltip",rawName:"v-t-tooltip:left.create",value:('catalog_items.contextmenu.open_attribute_table'),expression:"'catalog_items.contextmenu.open_attribute_table'",arg:"left",modifiers:{"create":true}}],staticClass:"action-button",on:{"click":function($event){$event.stopPropagation();return _vm.openAttributeTable(layer)}}},[_c('span',{staticClass:"action-button-icon",class:_vm.g3wtemplate.getFontClass('list')})]):_vm._e(),_vm._v("\n                "+_vm._s(layer.title)+"\n                "),[(_vm.state.query.pagination)?_c('span',{staticClass:"query-layer-feature-count"},[_vm._v("("+_vm._s(layer.features.length + ((_vm.state.query.pagination.current[index] - 1) * _vm.getCurrentPagSize(index)))+" - "+_vm._s(_vm.state.query.pagination.counts[index])+")\n                  ")]):_c('span',{staticClass:"query-layer-feature-count"},[_vm._v("("+_vm._s(layer.features.length)+")\n                  ")])]],2),_vm._v(" "),_c('div',{staticClass:"box-features-action",on:{"click":function($event){$event.stopPropagation();}}},[_c('infoformats',{attrs:{"layer":layer}}),_vm._v(" "),(layer.features.length > 1)?[(layer.hasgeometry)?_c('span',{directives:[{name:"t-tooltip",rawName:"v-t-tooltip:left.create",value:('sdk.mapcontrols.query.actions.zoom_to_features_extent.hint'),expression:"'sdk.mapcontrols.query.actions.zoom_to_features_extent.hint'",arg:"left",modifiers:{"create":true}}],staticClass:"action-button",on:{"click":function($event){$event.stopPropagation();return _vm.zoomToLayerFeaturesExtent(layer)}}},[_c('span',{staticClass:"action-button-icon",class:_vm.g3wtemplate.getFontClass('marker')})]):_vm._e(),_vm._v(" "),(layer.atlas.length)?_c('span',{directives:[{name:"t-tooltip",rawName:"v-t-tooltip:left.create",value:('sdk.mapcontrols.query.actions.atlas.hint'),expression:"'sdk.mapcontrols.query.actions.atlas.hint'",arg:"left",modifiers:{"create":true}},{name:"download",rawName:"v-download"}],staticClass:"action-button",on:{"click":function($event){$event.stopPropagation();return _vm.printAtlas(layer)}}},[_c('span',{staticClass:"action-button-icon",class:_vm.g3wtemplate.getFontClass('print')})]):_vm._e(),_vm._v(" "),(1 === _vm.getLayerDownloads(layer.downloads).length )?[_c('span',{directives:[{name:"t-tooltip",rawName:"v-t-tooltip:left.create",value:(("sdk.mapcontrols.query.actions.download_features_" + (layer.downloads[0]) + ".hint")),expression:"`sdk.mapcontrols.query.actions.download_features_${layer.downloads[0]}.hint`",arg:"left",modifiers:{"create":true}},{name:"download",rawName:"v-download"}],staticClass:"action-button",class:{'toggled': layer.downloadformats.active}},[_c('span',{staticClass:"action-button-icon",class:_vm.g3wtemplate.getFontClass('download'),on:{"click":function($event){$event.stopPropagation();_vm.saveLayerResult(layer, _vm.getLayerDownloads(layer.downloads)[0])}}})])]:(_vm.getLayerDownloads(layer.downloads).length > 1)?[_c('span',{directives:[{name:"t-tooltip",rawName:"v-t-tooltip:left.create",value:('Downloads'),expression:"'Downloads'",arg:"left",modifiers:{"create":true}},{name:"download",rawName:"v-download"}],staticClass:"action-button",class:{'toggled': layer.downloadformats.active}},[_c('span',{staticClass:"action-button-icon",class:_vm.g3wtemplate.getFontClass('download'),on:{"click":function($event){$event.stopPropagation();return _vm.showLayerDownloadFormats(layer)}}})])]:_vm._e()]:_vm._e(),_vm._v(" "),(layer.external || (layer.source && 'wms' !== layer.source.type && !_vm.state.query.pagination))?_c('span',{directives:[{name:"t-tooltip",rawName:"v-t-tooltip:left.create",value:('sdk.mapcontrols.query.actions.add_features_to_results.hint'),expression:"'sdk.mapcontrols.query.actions.add_features_to_results.hint'",arg:"left",modifiers:{"create":true}}],staticClass:"action-button",class:{'toggled': layer.addfeaturesresults.active},on:{"click":function($event){$event.stopPropagation();return _vm.addLayerFeaturesToResults(layer)}}},[_c('span',{staticClass:"action-button-icon",class:_vm.g3wtemplate.getFontClass('plus-square')})]):_vm._e(),_vm._v(" "),(
                    layer.toc &&
                    layer.id !== '__g3w_marker' &&
                    layer.features.length > 1 &&
                    (layer.external
                      || (
                          layer.source
                          && layer.source.type !== 'wms'
                          && (layer.selection.active || _vm.showInPagination(layer, index))
                         )
                    )
                  )?_c('span',{directives:[{name:"t-tooltip",rawName:"v-t-tooltip:left.create",value:('sdk.mapcontrols.query.actions.add_selection.hint'),expression:"'sdk.mapcontrols.query.actions.add_selection.hint'",arg:"left",modifiers:{"create":true}}],staticClass:"action-button skin-tooltip-left",class:{'toggled': layer.selection.active},on:{"click":function($event){$event.stopPropagation();return _vm.addToSelection(layer)}}},[_c('span',{staticClass:"action-button-icon",class:_vm.g3wtemplate.getFontClass('success')})]):_vm._e(),_vm._v(" "),(!layer.external && layer.selection.active && _vm.showInPagination(layer, index))?[_c('span',{directives:[{name:"t-tooltip",rawName:"v-t-tooltip:left.create",value:('layer_selection_filter.tools.filter'),expression:"'layer_selection_filter.tools.filter'",arg:"left",modifiers:{"create":true}}],staticClass:"action-button skin-tooltip-left",class:{'toggled': layer.filter.active},on:{"click":function($event){$event.stopPropagation();return _vm.addRemoveFilter(layer)}}},[_c('span',{staticClass:"action-button-icon",class:_vm.g3wtemplate.getFontClass('filter')})]),_vm._v(" "),(
                      _vm.state.logged
                      && layer.filter.active
                      && (null === layer.filter.current || layer.selection.active)
                    )?_c('span',{directives:[{name:"t-tooltip",rawName:"v-t-tooltip:left.create",value:('layer_selection_filter.tools.savefilter'),expression:"'layer_selection_filter.tools.savefilter'",arg:"left",modifiers:{"create":true}}],staticClass:"action-button skin-tooltip-left",on:{"click":function($event){$event.stopPropagation();return _vm.saveFilter(layer)}}},[_c('span',{staticClass:"action-button-icon",class:_vm.g3wtemplate.getFontClass('save')})]):_vm._e()]:_vm._e()],2),_vm._v(" "),_c('button',{staticClass:"btn btn-box-tool",staticStyle:{"pointer-events":"none"}},[_c('i',{staticClass:"btn-collapser skin-color",class:_vm.g3wtemplate.font['minus']})])]),_vm._v(" "),(_vm.state.layeractiontool[layer.id].component)?[_c('div',{staticClass:"g3w-layer-action-tools with-border",class:{'mobile': _vm.isMobile()},staticStyle:{"padding":"5px"}},[_c(_vm.state.layeractiontool[layer.id].component,{tag:"component",attrs:{"layer":layer,"config":_vm.state.layeractiontool[layer.id].config}})],1)]:_vm._e(),_vm._v(" "),_vm._l((_vm.getLayerCustomComponents(layer.id, 'layer', 'before')),function(ref){
                    var component = ref.component;
return _c(component,{tag:"component",attrs:{"layer":layer}})}),_vm._v(" "),(_vm.state.query.pagination && _vm.state.query.pagination.page_sizes[index].length > 1)?_c('section',{directives:[{name:"disabled",rawName:"v-disabled",value:(layer.loading),expression:"layer.loading"}],attrs:{"id":"g3w-queryresults-pagination"}},[_c('section',{staticStyle:{"margin-left":"10px"},attrs:{"id":"pagination-pages"}},[_c('select',{staticClass:"form-control",on:{"change":function($event){_vm.loadPaginationData(index, 1, Number($event.target.value))}}},_vm._l((_vm.state.query.pagination.page_sizes[index]),function(p){return _c('option',{key:p,domProps:{"value":p}},[_vm._v(_vm._s(p))])}),0)]),_vm._v(" "),(!layer.loading)?_c('section',{attrs:{"id":"pagination-buttons"}},[(_vm.state.query.pagination.counts[index] > layer.features.length)?_c('button',{staticClass:"btn",attrs:{"disabled":1 === _vm.state.query.pagination.current[index]},on:{"click":function($event){$event.stopPropagation();return _vm.loadPaginationData(index, _vm.state.query.pagination.current[index] - 1)}}},[_c('i',{class:_vm.g3wtemplate.font['backward']})]):_vm._e(),_vm._v(" "),_c('button',{directives:[{name:"disabled",rawName:"v-disabled",value:(layer.features.length === _vm.state.query.pagination.counts[index]),expression:"layer.features.length === state.query.pagination.counts[index]"}],staticClass:"btn",class:{ 'skin-background-color': 1 === _vm.state.query.pagination.current[index] },on:{"click":function($event){$event.stopPropagation();return _vm.loadPaginationData(index, 1)}}},[_vm._v(_vm._s(1)+"\n                ")]),_vm._v(" "),(_vm.state.query.pagination.counts[index] > layer.features.length)?[(_vm.state.query.pagination.pages[index] > 4 && _vm.state.query.pagination.current[index] > 2 )?_c('span',{staticStyle:{"font-weight":"bold","align-self":"baseline"}},[_vm._v("...")]):_vm._e(),_vm._v(" "),_vm._l(((
                  (_vm.state.query.pagination.pages[index] < 4 || _vm.state.query.pagination.current[index] < 3)
                    ? Array.from(Array(_vm.state.query.pagination.pages[index] - 2).keys()).slice(0, 2).map(function (i) { return i + 2; })
                    : (_vm.state.query.pagination.pages[index] - _vm.state.query.pagination.current[index]) > 2
                    ? [_vm.state.query.pagination.current[index], _vm.state.query.pagination.current[index] + 1 ]
                    : [_vm.state.query.pagination.pages[index] - 2, _vm.state.query.pagination.pages[index] - 1 ]
                  )),function(page){return _c('button',{staticClass:"btn",class:{ 'skin-background-color': page === _vm.state.query.pagination.current[index]  },on:{"click":function($event){$event.stopPropagation();return _vm.loadPaginationData(index, page)}}},[_vm._v(_vm._s(page)+"\n                ")])}),_vm._v(" "),(_vm.state.query.pagination.pages[index] > 4 && (_vm.state.query.pagination.current[index] < _vm.state.query.pagination.pages[index] - 2))?_c('span',{staticStyle:{"align-self":"baseline"}},[_vm._v("...")]):_vm._e(),_vm._v(" "),(_vm.state.query.pagination.pages[index] > 1)?_c('button',{staticClass:"btn",class:{ 'skin-background-color': _vm.state.query.pagination.pages[index] === _vm.state.query.pagination.current[index]  },on:{"click":function($event){$event.stopPropagation();return _vm.loadPaginationData(index, _vm.state.query.pagination.pages[index])}}},[_vm._v(_vm._s(_vm.state.query.pagination.pages[index])+"\n                ")]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn",attrs:{"disabled":_vm.state.query.pagination.pages[index] === _vm.state.query.pagination.current[index]},on:{"click":function($event){$event.stopPropagation();return _vm.loadPaginationData(index, _vm.state.query.pagination.current[index] + 1)}}},[_c('i',{class:_vm.g3wtemplate.font['forward']})])]:_vm._e()],2):_vm._e()]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"box-body",class:{'mobile': _vm.isMobile()}},[(layer.rawdata)?[_c('div',{staticClass:"queryresults-text-html",class:{text: layer.infoformat === 'text/plain'},domProps:{"innerHTML":_vm._s(layer.rawdata)}})]:(_vm.hasFormStructure(layer))?[_c('table',{staticClass:"table",class:{'mobile': _vm.isMobile()}},[_c('tbody',[_vm._l((layer.features),function(feature,index){return (feature.show)?[_c('header-feature-actions-body',{attrs:{"colspan":_vm.getColSpan(layer),"actions":_vm.state.layersactions[layer.id],"layer":layer,"feature":feature,"index":index,"onelayerresult":_vm.onelayerresult,"trigger":_vm.trigger,"toggleFeatureBoxAndZoom":_vm.toggleFeatureBoxAndZoom,"hasLayerOneFeature":_vm.hasLayerOneFeature,"boxLayerFeature":_vm.getLayerFeatureBox(layer, feature),"attributesSubset":_vm.attributesSubset,"getLayerField":_vm.getLayerField}}),_vm._v(" "),_c('tr',{staticClass:"g3w-feature-result-action-tools"},[(_vm.state.currentactiontools[layer.id][index])?[_c('td',{attrs:{"colspan":_vm.getColSpan(layer)}},[_c(_vm.state.currentactiontools[layer.id][index],{tag:"component",attrs:{"colspan":_vm.getColSpan(layer),"layer":layer,"feature":feature,"featureIndex":index,"config":_vm.state.actiontools[_vm.state.currentactiontools[layer.id][index].name][layer.id]}})],1)]:_vm._e()],2),_vm._v(" "),(!_vm.hasLayerOneFeature(layer))?_c('tr',{staticStyle:{"font-weight":"bold","text-align":"center"}},[_vm._l((_vm.attributesSubset(layer)),function(attribute,index){return _c('td',{staticClass:"centered"},[_vm._v("\n                            "+_vm._s(_vm.getLayerFeatureBox(layer, feature).collapsed ? attribute.label : '')+"\n                          ")])}),_vm._v(" "),_c('td',{staticClass:"collapsed",class:{noAttributes: _vm.attributesSubset(layer).length === 0},staticStyle:{"text-align":"end"},on:{"click":function($event){$event.stopPropagation();return _vm.toggleFeatureBoxAndZoom(layer,feature)}}},[_c('span',{staticClass:"fa link morelink skin-color",class:_vm.g3wtemplate.font[_vm.getLayerFeatureBox(layer, feature).collapsed  ? 'plus': 'minus']})])],2):_vm._e(),_vm._v(" "),(!_vm.hasLayerOneFeature(layer) && _vm.getLayerFeatureBox(layer, feature).collapsed)?_c('header-feature-body',{attrs:{"actions":_vm.state.layersactions[layer.id],"layer":layer,"feature":feature,"index":index,"onelayerresult":_vm.onelayerresult,"trigger":_vm.trigger,"toggleFeatureBoxAndZoom":_vm.toggleFeatureBoxAndZoom,"hasLayerOneFeature":_vm.hasLayerOneFeature,"boxLayerFeature":_vm.getLayerFeatureBox(layer, feature),"attributesSubset":_vm.attributesSubset,"getLayerField":_vm.getLayerField}}):_vm._e(),_vm._v(" "),_vm._l((_vm.getLayerCustomComponents(layer.id, 'feature', 'before')),function(ref){
                  var component = ref.component;
return _c('tr',[_c('td',{attrs:{"colspan":_vm.getColSpan(layer)}},[_c(component,{tag:"component",attrs:{"layer":layer,"feature":feature}})],1)])}),_vm._v(" "),_c('tr',{directives:[{name:"show",rawName:"v-show",value:(!_vm.collapsedFeatureBox(layer,feature) || _vm.hasOneLayerAndOneFeature(layer)),expression:"!collapsedFeatureBox(layer,feature) || hasOneLayerAndOneFeature(layer)"}],staticClass:"featurebox-body",attrs:{"id":((layer.id) + "_" + index)}},[_c('td',{attrs:{"colspan":_vm.getColSpan(layer),"feature-html-content":((layer.id) + "_" + index)}},[_c('tabs',{attrs:{"fields":_vm.getQueryFields(layer, feature),"layerid":layer.id,"feature":feature,"tabs":_vm.getLayerFormStructure(layer)}})],1)]),_vm._v(" "),_vm._l((_vm.getLayerCustomComponents(layer.id, 'feature', 'after')),function(ref){
                  var component = ref.component;
return _c('tr',[_c('td',{attrs:{"colspan":_vm.getColSpan(layer)}},[_c(component,{tag:"component",attrs:{"layer":layer,"feature":feature}})],1)])})]:_vm._e()})],2)])]:[_c('table',{staticClass:"table",class:{'mobile': _vm.isMobile()}},_vm._l((layer.features),function(feature,index){return (feature.show)?_c('tbody',{key:feature.id},[_c('header-feature-actions-body',{attrs:{"colspan":_vm.getColSpan(layer),"actions":_vm.state.layersactions[layer.id],"layer":layer,"feature":feature,"index":index,"onelayerresult":_vm.onelayerresult,"trigger":_vm.trigger,"toggleFeatureBoxAndZoom":_vm.toggleFeatureBoxAndZoom,"hasLayerOneFeature":_vm.hasLayerOneFeature,"boxLayerFeature":_vm.getLayerFeatureBox(layer, feature),"attributesSubset":_vm.attributesSubset,"getLayerField":_vm.getLayerField}}),_vm._v(" "),_c('tr',{staticClass:"g3w-feature-result-action-tools"},[(_vm.state.currentactiontools[layer.id][index])?[_c('td',{attrs:{"colspan":_vm.getColSpan(layer)}},[_c(_vm.state.currentactiontools[layer.id][index],{tag:"component",attrs:{"colspan":_vm.getColSpan(layer),"layer":layer,"feature":feature,"featureIndex":index,"config":_vm.state.actiontools[_vm.state.currentactiontools[layer.id][index].name][layer.id]}})],1)]:_vm._e()],2),_vm._v(" "),(!_vm.hasLayerOneFeature(layer))?_c('tr',{staticStyle:{"font-weight":"bold","text-align":"center"}},[_vm._l((_vm.attributesSubset(layer)),function(attribute,index){return _c('td',{staticClass:"centered"},[_vm._v("\n                        "+_vm._s(_vm.getLayerFeatureBox(layer, feature).collapsed ? attribute.label : '')+"\n                      ")])}),_vm._v(" "),_c('td',{staticClass:"collapsed",class:{ noAttributes: 0 === _vm.attributesSubset(layer).length },staticStyle:{"text-align":"end"},on:{"click":function($event){$event.stopPropagation();return _vm.toggleFeatureBoxAndZoom(layer,feature)}}},[_c('span',{staticClass:"fa link morelink skin-color",class:_vm.g3wtemplate.font[_vm.getLayerFeatureBox(layer, feature).collapsed ? 'plus': 'minus']})])],2):_vm._e(),_vm._v(" "),(!_vm.hasLayerOneFeature(layer) && _vm.getLayerFeatureBox(layer, feature).collapsed)?_c('header-feature-body',{attrs:{"actions":_vm.state.layersactions[layer.id],"layer":layer,"feature":feature,"index":index,"onelayerresult":_vm.onelayerresult,"trigger":_vm.trigger,"toggleFeatureBoxAndZoom":_vm.toggleFeatureBoxAndZoom,"hasLayerOneFeature":_vm.hasLayerOneFeature,"boxLayerFeature":_vm.getLayerFeatureBox(layer, feature),"attributesSubset":_vm.attributesSubset,"getLayerField":_vm.getLayerField}}):_vm._e(),_vm._v(" "),_vm._l((_vm.getLayerCustomComponents(layer.id, 'feature', 'before')),function(ref){
                  var component = ref.component;
return _c('tr',[_c('td',{attrs:{"colspan":_vm.getColSpan(layer)}},[_c(component,{tag:"component",staticClass:"box-body",attrs:{"layer":layer,"feature":feature}})],1)])}),_vm._v(" "),_c('tr',{directives:[{name:"show",rawName:"v-show",value:(!_vm.collapsedFeatureBox(layer,feature) || _vm.hasOneLayerAndOneFeature(layer)),expression:"!collapsedFeatureBox(layer,feature) || hasOneLayerAndOneFeature(layer)"}],staticClass:"featurebox-body",attrs:{"id":((layer.id) + "_" + index)}},[_c('td',{attrs:{"colspan":_vm.getColSpan(layer),"feature-html-content":((layer.id) + "_" + index)}},[_c('table',{staticClass:"feature_attributes"},[_vm._l((layer.attributes.filter(function (attribute) { return attribute.show; })),function(attribute){return [(_vm.isJSON(_vm.getLayerField({layer: layer, feature: feature, fieldName: attribute.name})))?[_vm._l((_vm.getLayerField({layer: layer, feature: feature, fieldName: attribute.name}).value),function(v,k){
                  var _obj;
return _vm._l((('object' === typeof v ? v : ( _obj = {}, _obj[k] = v, _obj ))),function(v2,k2){return _c('tr',{staticStyle:{"padding-top":"10px","padding-bottom":"10px"}},[_c('td',{staticClass:"attr-label"},[_vm._v(_vm._s(attribute.label)+"."),(('object' === typeof v))?[_vm._v(_vm._s(k)+".")]:_vm._e(),_vm._v(_vm._s(k2))],2),_vm._v(" "),_c('td',{staticClass:"attr-value"},[_vm._v(_vm._s(v2))])])})})]:_c('tr',[_c('td',{staticClass:"attr-label"},[_vm._v(_vm._s(attribute.label))]),_vm._v(" "),_c('td',{staticClass:"attr-value",attrs:{"attribute":attribute.name}},[_c('table-attribute-field-value',{attrs:{"feature":feature,"field":_vm.getLayerField({layer: layer, feature: feature, fieldName: attribute.name})}})],1)])]})],2)])]),_vm._v(" "),_vm._l((_vm.getLayerCustomComponents(layer.id, 'feature', 'after')),function(ref){
                  var component = ref.component;
return _c('tr',[_c('td',{attrs:{"colspan":"getColSpan(layer)"}},[_c(component,{tag:"component",staticClass:"box-body",attrs:{"layer":layer,"feature":feature}})],1)])})],2):_c('tbody')}),0)]],2),_vm._v(" "),_vm._l((_vm.getLayerCustomComponents(layer.id, 'layer', 'after')),function(ref){
                  var component = ref.component;
return _c('div',{staticClass:"box-body",class:{'mobile': _vm.isMobile()}},[_c(component,{tag:"component",attrs:{"layer":layer}})],1)})],2)],1)}),_vm._v(" "),_vm._l((_vm.state.components),function(component){return _c('li',[_c(component,{tag:"component",on:{"showresults":function($event){return _vm.showResults()}}})],1)})],2):_vm._e()]:[(_vm.state.changed)?_c('div',{staticClass:"query-results-not-found"},[_c('h4',{directives:[{name:"t",rawName:"v-t",value:('info.no_results'),expression:"'info.no_results'"}],staticClass:"skin-color",staticStyle:{"font-weight":"bold","text-align":"center"}})]):_vm._e()]],2),_vm._v(" "),(_vm.state.query)?_c('div',{staticStyle:{"visibility":"hidden","position":"sticky","bottom":"-8px","background":"#eee","padding":"8px 0","display":"flex","gap":"1em"}},[_c('label',{staticStyle:{"margin-top":"5px"}},[_vm._v(_vm._s(_vm.$t('query_filter')))]),_vm._v(" "),_c('select',{staticStyle:{"flex":"1"}},[_vm._l((_vm.queryableLayers),function(layer){return _c('option',{domProps:{"selected":layer === _vm.selectedLayer}},[_vm._v(_vm._s(layer.getName()))])}),_vm._v(" "),_c('option',{domProps:{"selected":!_vm.selectedLayer}},[_vm._v(_vm._s(_vm.$t('sdk.mapcontrols.queryby.all')))])],2)]):_vm._e()])}
__vue__options__.staticRenderFns = []
__vue__options__._scopeId = "data-v-863e1f5c"

},{"components/QueryResultsActionInfoFormats.vue":130,"components/QueryResultsHeaderFeatureActionsBody.vue":133,"components/QueryResultsHeaderFeatureBody.vue":134,"components/QueryResultsTableAttributeFieldValue.vue":135,"mixins":200,"services/gui":207,"utils/getCatalogLayerById":238,"utils/getMapLayersByFilter":245,"utils/throttle":276,"utils/toRawType":277,"vueify/lib/insert-css":35}],127:[function(require,module,exports){
;(function(){
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _g3wI18n = require('g3w-i18n');

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

exports.default = {
  name: "action",
  data: function data() {
    return {
      show: true
    };
  },

  props: {
    featureIndex: {
      type: Number
    },
    feature: {
      type: Object
    },
    layer: {
      type: Object
    },
    trigger: {
      type: Function
    },
    action: {
      type: Object,
      required: true
    }
  },
  methods: {
    clickAction: function () {
      var _ref = _asyncToGenerator(function* (action, layer, feature, featureIndex, event) {
        yield this.trigger(action, layer, feature, featureIndex);
        if (action.hint_change) {
          var element = $(event.target).parent();
          var originalDataTitle = element.attr('data-original-title');
          element.attr('data-original-title', (0, _g3wI18n.t)(action.hint_change.hint));
          element.tooltip('show');
          setTimeout(function () {
            element.attr('data-original-title', originalDataTitle);
            element.tooltip('show');
          }, action.hint_change.duration || 600);
        }
        this.$emit('action-clicked', action);
      });

      function clickAction(_x, _x2, _x3, _x4, _x5) {
        return _ref.apply(this, arguments);
      }

      return clickAction;
    }()
  },
  created: function () {
    var _ref2 = _asyncToGenerator(function* () {
      if (this.action.init) {
        this.action.init({ layer: this.layer, feature: this.feature, index: this.featureIndex, action: this.action });
      }
      if (typeof this.action.condition === 'function') {
        var show = this.action.condition({ layer: this.layer, feature: this.feature });
        this.show = show instanceof Promise ? yield show : show;
      }
    });

    function created() {
      return _ref2.apply(this, arguments);
    }

    return created;
  }(),
  beforeDestroy: function beforeDestroy() {
    if (typeof this.action.clear === 'function') {
      this.action.clear({ layer: this.layer, feature: this.feature });
    }
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show && (undefined === (_vm.action.state || {}).show ? _vm.show : _vm.action.state.show))?_c('span',{directives:[{name:"download",rawName:"v-download",value:(_vm.action.download),expression:"action.download"},{name:"disabled",rawName:"v-disabled",value:(!!(_vm.action.state || {}).disabled),expression:"!!(action.state || {}).disabled"},{name:"t-tooltip",rawName:"v-t-tooltip:top.create",value:(_vm.action.hint),expression:"action.hint",arg:"top",modifiers:{"create":true}}],staticClass:"action-button",class:{'toggled': (_vm.action.state || {}).toggled && _vm.action.state.toggled[_vm.featureIndex] },on:{"contextmenu":function($event){$event.preventDefault();$event.stopPropagation();},"click":function($event){$event.stopPropagation();return _vm.clickAction(_vm.action, _vm.layer, _vm.feature, _vm.featureIndex, $event)}}},[_c('span',{class:("action-button-icon " + (_vm.action.class)),staticStyle:{"padding":"2px"},style:(_vm.action.style)})]):_vm._e()}
__vue__options__.staticRenderFns = []

},{"g3w-i18n":162}],128:[function(require,module,exports){
;(function(){
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'choose_layer',

  props: {
    featureIndex: {
      type: Number
    },
    feature: {
      type: Object
    },
    layer: {
      type: Object
    },
    config: {
      type: Object,
      default: {
        icon: 'pencil',
        label: 'Choose a Layer',
        nolayers: 'No layers found',
        layers: [],
        cbk: function cbk() {}
      }
    }
  },

  data: function data() {
    return {
      layerId: null
    };
  },


  computed: {
    has_layers: function has_layers() {
      return this.config.layers && this.config.layers.length > 0;
    }
  },

  created: function created() {
    if (this.has_layers) {
      this.layerId = this.config.layers[0].id;
    }
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"action-choose-layer"},[_c('label',{directives:[{name:"t",rawName:"v-t",value:(_vm.config.label),expression:"config.label"}]}),_vm._v(" "),_c('div',{staticStyle:{"width":"100%","display":"flex"},on:{"click":function($event){$event.preventDefault();$event.stopPropagation();}}},[_c('select',{directives:[{name:"select2",rawName:"v-select2",value:('layerId'),expression:"'layerId'"}],staticClass:"form-control",staticStyle:{"flex-grow":"1"},attrs:{"search":false,"disabled":!_vm.has_layers}},[_vm._l((_vm.config.layers),function(layer){return _c('option',{key:layer.id,domProps:{"value":layer.id}},[_c('b',[_vm._v(_vm._s(layer.name))])])}),_vm._v(" "),(!_vm.has_layers)?_c('option',{directives:[{name:"t",rawName:"v-t",value:(_vm.config.nolayers),expression:"config.nolayers"}]}):_vm._e()],2),_vm._v(" "),(_vm.has_layers)?_c('button',{staticClass:"btn skin-button",staticStyle:{"border-radius":"0 3px 3px 0"},on:{"click":function($event){$event.stopPropagation();return (function () { return _vm.config.cbk(_vm.layerId, _vm.feature); })($event)}}},[_c('span',{class:_vm.g3wtemplate.getFontClass(_vm.config.icon)})]):_vm._e()])])}
__vue__options__.staticRenderFns = []

},{}],129:[function(require,module,exports){
;(function(){
Object.defineProperty(exports, "__esModule", {
  value: true
});

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

exports.default = {
  name: "downloadformats",

  data: function data() {
    return {
      download_format: this.config.downloads[0].format
    };
  },

  props: {
    featureIndex: {
      type: Number
    },
    feature: {
      type: Object
    },
    layer: {
      type: Object
    },
    config: {
      type: Object,
      default: null
    }
  },
  methods: {
    download: function () {
      var _ref = _asyncToGenerator(function* () {
        var _this = this;

        try {
          var _download = this.config.downloads.find(function (action) {
            return action.format === _this.download_format;
          });
          yield _download.cbk(this.layer, this.feature ? this.feature : this.layer.features, _download, this.featureIndex, 'pdf' === _download.format ? document.querySelector("[feature-html-content=\"" + this.layer.id + "_" + this.featureIndex + "\"]").innerHTML : null);
        } catch (e) {
          console.warn(e);
        }
      });

      function download() {
        return _ref.apply(this, arguments);
      }

      return download;
    }()
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"g3w-download-formats-content",staticStyle:{"width":"100%","display":"flex"},on:{"click":function($event){$event.preventDefault();$event.stopPropagation();}}},[_c('select',{directives:[{name:"select2",rawName:"v-select2",value:('download_format'),expression:"'download_format'"}],staticClass:"form-control",staticStyle:{"flex-grow":"1"},attrs:{"search":false}},_vm._l((_vm.config.downloads),function(download){return _c('option',{directives:[{name:"download",rawName:"v-download"}],key:download.id,domProps:{"value":download.format}},[_c('span',{staticStyle:{"font-weight":"bold"}},[_vm._v(_vm._s(download.format))])])}),0),_vm._v(" "),_c('button',{directives:[{name:"download",rawName:"v-download"}],staticClass:"btn skin-button",staticStyle:{"border-radius":"0 3px 3px 0"},on:{"click":function($event){$event.stopPropagation();return _vm.download($event)}}},[_c('span',{class:_vm.g3wtemplate.getFontClass('download')})])])}
__vue__options__.staticRenderFns = []

},{}],130:[function(require,module,exports){
;(function(){
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _gui = require('services/gui');

var _gui2 = _interopRequireDefault(_gui);

var _parsers = require('utils/parsers');

var _getAlphanumericPropertiesFromFeature = require('utils/getAlphanumericPropertiesFromFeature');

var _getCatalogLayerById = require('utils/getCatalogLayerById');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

exports.default = {
  name: 'Infoformats',

  props: {
    layer: {
      type: Object,
      required: true
    }
  },

  data: function data() {
    return {
      infoformat: this.layer.infoformat
    };
  },


  computed: {
    infoformats: function infoformats() {
      return this.layer.infoformats || [];
    },
    hasInfo: function hasInfo() {
      return this.infoformats.length;
    }
  },

  methods: {
    reloadLayerDataWithChangedContentType: function () {
      var _ref = _asyncToGenerator(function* (contenttype) {
        this.layer.loading = true;

        this.$el.disabled = true;
        try {
          var response = yield this.projectLayer.changeProxyDataAndReloadFromServer('wms', {
            headers: { 'Content-Type': contenttype },
            params: { INFO_FORMAT: contenttype }
          });
          this.layer.infoformat = contenttype;
          this.projectLayer.setInfoFormat(this.layer.infoformat);

          var _ResponseParser$get = _parsers.ResponseParser.get(contenttype)({ layers: [this.projectLayer], response: response }),
              _ResponseParser$get2 = _slicedToArray(_ResponseParser$get, 1),
              data = _ResponseParser$get2[0];

          if (data.features) {
            this.__parsedata(data);
          } else {
            this.__parserawdata(data);
          }
        } catch (e) {
          console.warn(e);
        }
        this.layer.loading = false;

        this.$el.disabled = false;
      });

      function reloadLayerDataWithChangedContentType(_x) {
        return _ref.apply(this, arguments);
      }

      return reloadLayerDataWithChangedContentType;
    }(),
    __parsedata: function __parsedata(data) {
      var _this = this;

      var queryService = _gui2.default.getService('queryresults');
      this.layer.rawdata = null;

      data.features.forEach(function (feature) {
        var _properties$geometry$ = {
          properties: feature instanceof ol.Feature ? feature.getProperties() : feature.properties,
          geometry: feature instanceof ol.Feature ? feature.getGeometry() : feature.geometry,
          id: feature instanceof ol.Feature ? feature.getId() : feature.id
        },
            fid = _properties$geometry$.id,
            geometry = _properties$geometry$.geometry,
            attributes = _properties$geometry$.properties;

        if (0 === _this.layer.attributes.length) {
          _this.layer.hasgeometry = !!geometry;

          queryService.setActionsForLayers([_this.layer]);
          (0, _getAlphanumericPropertiesFromFeature.getAlphanumericPropertiesFromFeature)(attributes).forEach(function (name) {
            _this.layer.attributes.push({
              name: name,
              label: name,
              show: true
            });
          });
        }

        _this.layer.features.push({ id: fid, attributes: attributes, geometry: geometry, show: true });
      });
    },
    __parserawdata: function () {
      var _ref2 = _asyncToGenerator(function* (data) {
        this.layer.features.splice(0);
        yield this.$nextTick();
        this.layer.rawdata = data.rawdata;
      });

      function __parserawdata(_x2) {
        return _ref2.apply(this, arguments);
      }

      return __parserawdata;
    }()
  },

  watch: {
    'infoformat': function infoformat(value) {
      this.reloadLayerDataWithChangedContentType(value);
    }
  },

  created: function created() {
    this.projectLayer = (0, _getCatalogLayerById.getCatalogLayerById)(this.layer.id);
  },
  beforeDestroy: function beforeDestroy() {
    if (this.projectLayer) {
      this.projectLayer.clearProxyData('wms');
    }
    this.projectLayer = null;
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasInfo)?_c('select',{directives:[{name:"select2",rawName:"v-select2",value:('infoformat'),expression:"'infoformat'"}],staticClass:"skin-color",attrs:{"select2_value":_vm.infoformat,"search":false}},_vm._l((_vm.infoformats),function(infoformat){return _c('option',{key:infoformat,domProps:{"value":infoformat}},[_vm._v("\n    "+_vm._s(infoformat)+"\n  ")])}),0):_vm._e()}
__vue__options__.staticRenderFns = []

},{"services/gui":207,"utils/getAlphanumericPropertiesFromFeature":237,"utils/getCatalogLayerById":238,"utils/parsers":265}],131:[function(require,module,exports){
var __vueify_style_dispose__ = require("vueify/lib/insert-css").insert(".g3w-polygonattributes-types-title[data-v-4a5e799a]{font-weight:700;padding:3px;color:#fff;margin:0 0 5px}.g3w-polygonattributes-types-content[data-v-4a5e799a]{display:flex;justify-content:space-between;padding:3px;border-radius:3px;border:1px solid #f4f4f4}")
;(function(){
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _application = require('store/application');

var _application2 = _interopRequireDefault(_application);

var _g3wI18n = require('g3w-i18n');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: "queryresults-querypolygonaddattributes",

  props: {
    layer: {
      type: Object
    },
    config: {
      type: Object,
      default: null
    }
  },
  data: function data() {
    return {
      type: this.config.choices[0].type
    };
  },
  created: function created() {
    var _this = this;

    this.unwatch = this.$watch(function () {
      return _application2.default.language;
    }, function () {
      _this.config.choices.forEach(function (c) {
        return $(_this.$refs[c.type]).text((0, _g3wI18n.t)(c.label));
      });
      $(_this.$refs.g3w_select_feature_featurepolygon).select2().trigger('change');
    });
  },
  beforeDestroy: function beforeDestroy() {
    this.unwatch && this.unwatch();
    this.unwatch = null;
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"100%"}},[_c('h5',{directives:[{name:"t",rawName:"v-t",value:('sdk.mapcontrols.querybypolygon.download.title'),expression:"'sdk.mapcontrols.querybypolygon.download.title'"}],staticClass:"skin-background-color g3w-polygonattributes-types-title"}),_vm._v(" "),_c('div',{staticClass:"g3w-polygonattributes-types-content"},[_c('select',{directives:[{name:"select2",rawName:"v-select2",value:('type'),expression:"'type'"}],ref:"g3w_select_feature_featurepolygon",staticClass:"form-control",staticStyle:{"width":"100%"},attrs:{"search":false}},_vm._l((_vm.config.choices),function(choice){return _c('option',{directives:[{name:"t",rawName:"v-t",value:(choice.label),expression:"choice.label"}],key:choice.type,ref:choice.type,refInFor:true,domProps:{"value":choice.type}})}),0),_vm._v(" "),_c('button',{staticClass:"btn skin-button",staticStyle:{"border-radius":"0 3px 3px 0"},on:{"click":function($event){$event.stopPropagation();return _vm.config.download(_vm.type)}}},[_c('span',{class:_vm.g3wtemplate.getFontClass('download')})])])])}
__vue__options__.staticRenderFns = []
__vue__options__._scopeId = "data-v-4a5e799a"

},{"g3w-i18n":162,"store/application":212,"vueify/lib/insert-css":35}],132:[function(require,module,exports){
var __vueify_style_dispose__ = require("vueify/lib/insert-css").insert(".g3w-feature-actions[data-v-100b99fb]{padding:3px;background-color:rgba(34,45,50,.1)!important}")
;(function(){
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _QueryResultsAction = require("components/QueryResultsAction.vue");

var _QueryResultsAction2 = _interopRequireDefault(_QueryResultsAction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: "actions",
  props: {
    featureIndex: {
      type: Number
    },
    feature: {
      type: Object
    },
    layer: {
      type: Object
    },
    trigger: {
      type: Function
    },
    actions: {
      type: Array,
      default: []
    },
    colspan: {
      type: Number
    }
  },
  components: {
    action: _QueryResultsAction2.default
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.actions.length)?_c('td',{staticClass:"g3w-feature-actions",staticStyle:{"padding":"3px"},attrs:{"colspan":_vm.colspan}},_vm._l((_vm.actions),function(action){return _c('action',_vm._b({key:action.id,attrs:{"action":action}},'action',_vm.$props,false))}),1):_vm._e()}
__vue__options__.staticRenderFns = []
__vue__options__._scopeId = "data-v-100b99fb"

},{"components/QueryResultsAction.vue":127,"vueify/lib/insert-css":35}],133:[function(require,module,exports){
var __vueify_style_dispose__ = require("vueify/lib/insert-css").insert(".noAttributes[data-v-d0a8cf70]{display:flex;justify-content:flex-end}")
;(function(){
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _QueryResultsActions = require('components/QueryResultsActions.vue');

var _QueryResultsActions2 = _interopRequireDefault(_QueryResultsActions);

var _mixins = require('mixins');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: "headerfeaturebody",
  mixins: [_mixins.fieldsMixin],
  props: {
    toggleFeatureBoxAndZoom: {
      type: Function
    },
    trigger: {
      type: Function
    },
    hasLayerOneFeature: {
      type: Function
    },
    boxLayerFeature: {
      type: Object
    },
    getLayerField: {
      type: Function
    },
    attributesSubset: {
      type: Function
    },
    layer: {
      type: Object
    },
    feature: {
      type: Object
    },
    index: {
      type: Number
    },
    actions: {
      type: Array
    },
    colspan: {
      type: Number
    }
  },
  components: {
    actions: _QueryResultsActions2.default
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',{staticClass:"featurebox-header",on:{"mouseover":function($event){$event.stopPropagation();return _vm.trigger({ id: 'highlightgeometry'}, _vm.layer, _vm.feature, _vm.index)},"mouseout":function($event){$event.stopPropagation();return _vm.trigger({ id: 'clearHighlightGeometry'}, _vm.layer, _vm.feature, _vm.index)}}},[_c('actions',{attrs:{"colspan":_vm.colspan,"layer":_vm.layer,"featureIndex":_vm.index,"trigger":_vm.trigger,"feature":_vm.feature,"actions":_vm.actions}})],1)}
__vue__options__.staticRenderFns = []
__vue__options__._scopeId = "data-v-d0a8cf70"

},{"components/QueryResultsActions.vue":132,"mixins":200,"vueify/lib/insert-css":35}],134:[function(require,module,exports){
var __vueify_style_dispose__ = require("vueify/lib/insert-css").insert(".noAttributes[data-v-1046c92e]{display:flex;justify-content:flex-end}")
;(function(){
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _QueryResultsActions = require('components/QueryResultsActions.vue');

var _QueryResultsActions2 = _interopRequireDefault(_QueryResultsActions);

var _mixins = require('mixins');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: "headerfeaturebody",
  mixins: [_mixins.fieldsMixin],
  props: {
    toggleFeatureBoxAndZoom: {
      type: Function
    },
    trigger: {
      type: Function
    },
    hasLayerOneFeature: {
      type: Function
    },
    boxLayerFeature: {
      type: Object
    },
    getLayerField: {
      type: Function
    },
    attributesSubset: {
      type: Function
    },
    layer: {
      type: Object
    },
    feature: {
      type: Object
    }

  },
  components: {
    actions: _QueryResultsActions2.default
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_vm._l((_vm.attributesSubset(_vm.layer)),function(attribute){return _c('td',{staticClass:"attribute"},[(_vm.isLink(_vm.getLayerField({layer: _vm.layer, feature: _vm.feature, fieldName: attribute.name})))?_c('span',{staticClass:"skin-color",class:_vm.g3wtemplate.getFontClass('link')}):(_vm.isPhoto(_vm.getLayerField({layer: _vm.layer, feature: _vm.feature, fieldName: attribute.name})))?_c('span',{staticClass:"skin-color",class:_vm.g3wtemplate.getFontClass('image')}):(_vm.isImage(_vm.getLayerField({layer: _vm.layer, feature: _vm.feature, fieldName: attribute.name})))?_c('span',{staticClass:"skin-color",class:_vm.g3wtemplate.getFontClass('image')}):_c('span',[_vm._v(_vm._s(_vm.feature.attributes[attribute.name]))])])}),_vm._v(" "),(!_vm.hasLayerOneFeature(_vm.layer))?_c('td'):_vm._e()],2)}
__vue__options__.staticRenderFns = []
__vue__options__._scopeId = "data-v-1046c92e"

},{"components/QueryResultsActions.vue":132,"mixins":200,"vueify/lib/insert-css":35}],135:[function(require,module,exports){
;(function(){
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _FieldLink = require('components/FieldLink.vue');

var _FieldLink2 = _interopRequireDefault(_FieldLink);

var _FieldVue = require('components/FieldVue.vue');

var _FieldVue2 = _interopRequireDefault(_FieldVue);

var _FieldImage = require('components/FieldImage.vue');

var _FieldImage2 = _interopRequireDefault(_FieldImage);

var _mixins = require('mixins');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: "tableattributefieldvalue",
  props: {
    field: {
      type: Object
    },
    feature: {
      type: Object
    }
  },
  mixins: [_mixins.fieldsMixin],
  components: {
    'g3w-link': _FieldLink2.default,
    'g3w-vue': _FieldVue2.default,
    'g3w-image': _FieldImage2.default
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isVue(_vm.field))?_c('g3w-vue',{attrs:{"feature":_vm.feature,"state":_vm.field}}):(_vm.isSimple(_vm.field))?_c('span',{domProps:{"innerHTML":_vm._s(_vm.field.value)}}):(_vm.isPhoto(_vm.field))?_c('g3w-image',{attrs:{"state":_vm.field}}):(_vm.isImage(_vm.field))?_c('g3w-image',{attrs:{"state":_vm.field}}):(_vm.isLink(_vm.field))?_c('g3w-link',{attrs:{"state":{value: _vm.field.value}}}):_vm._e()}
__vue__options__.staticRenderFns = []
__vue__options__._scopeId = "data-v-c49b6cd2"

},{"components/FieldImage.vue":79,"components/FieldLink.vue":80,"components/FieldVue.vue":83,"mixins":200}],136:[function(require,module,exports){
var __vueify_style_dispose__ = require("vueify/lib/insert-css").insert(".query-relation[data-v-36faa180]{margin-top:3px}.query-relation>.header[data-v-36faa180]{padding:3px;display:flex;justify-content:space-between;align-items:center;width:100%;margin:0!important}.query-relation>.header>.g3w-long-text[data-v-36faa180]{border-radius:3px;font-size:1.3em}.query-relation.mobile>.header>.g3w-long-text[data-v-36faa180]{font-size:1em}.relations-table-tools[data-v-36faa180]{font-size:1.1em;margin-bottom:3px}.relations-table-tools>.action-button[data-v-36faa180]{padding:5px}.relation-wrapper[data-v-36faa180]{display:flex;justify-content:space-between;margin-bottom:5px;margin-top:3px;height:95%}.back-button[data-v-36faa180]{font-size:.8em}.header-component[data-v-36faa180]{width:100%;display:flex;margin-left:auto;margin-bottom:5px;margin-right:4px}.relationtable .table-tools .action-button[data-v-36faa180]:hover{background-color:transparent}.relationtable.dataTable tbody tr.selected[data-v-36faa180]{background-color:#e4e4e4!important}.relationtable.dataTable tbody tr.selected .row-wrap-tabs .tabs-wrapper[data-v-36faa180]{background-color:#fff!important}#chart_content[data-v-36faa180]{padding-bottom:5px;margin-bottom:5px;margin-left:8px}.dataTables_scrollBody[data-v-36faa180]{font-weight:700;margin-top:10px;font-size:1.1em;display:flex;justify-content:space-between}\n.relation-wrapper .dataTables_length select{border:1px solid #ccc;background:#fff;height:27px}.relation-wrapper .paginate_button{background:transparent!important;color:currentColor!important;box-shadow:none!important}.relation-wrapper .paginate_button.disabled{opacity:.25!important}.relation-wrapper .dataTables_scroll{background:#fff}")
;(function(){
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _g3wConstants = require('g3w-constants');

var _application = require('store/application');

var _application2 = _interopRequireDefault(_application);

var _g3wComponent = require('g3w-component');

var _g3wComponent2 = _interopRequireDefault(_g3wComponent);

var _FieldG3W = require('components/FieldG3W.vue');

var _FieldG3W2 = _interopRequireDefault(_FieldG3W);

var _QueryResultsActionDownloadFormats = require('components/QueryResultsActionDownloadFormats.vue');

var _QueryResultsActionDownloadFormats2 = _interopRequireDefault(_QueryResultsActionDownloadFormats);

var _gui = require('services/gui');

var _gui2 = _interopRequireDefault(_gui);

var _mixins = require('mixins');

var _g3wEventbus = require('g3w-eventbus');

var _data = require('services/data');

var _data2 = _interopRequireDefault(_data);

var _throttle = require('utils/throttle');

var _getCatalogLayerById = require('utils/getCatalogLayerById');

var _XHR = require('utils/XHR');

var _createRelationsUrl = require('utils/createRelationsUrl');

var _getAlphanumericPropertiesFromFeature = require('utils/getAlphanumericPropertiesFromFeature');

var _saveBlob = require('utils/saveBlob');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var SIDEBARWIDTH = void 0;

function _buildRelationTable() {
  var features = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var id = arguments[1];

  var layer = _application2.default.project.getLayerById(id);
  var attrs = Object.keys(features[0] ? features[0].attributes : {});
  var cols = layer.getTableHeaders().filter(function (h) {
    return attrs.includes(h.name);
  });
  return {
    columns: cols.map(function (c) {
      return c.label;
    }),
    rows: features.map(function (r) {
      return cols.map(function (c) {
        return r.attributes[c.name];
      });
    }),
    rows_fid: features.map(function (r) {
      return r.attributes[_g3wConstants.G3W_FID];
    }),
    features: features,
    fields: cols.length ? cols : null,
    formStructure: layer.getLayerEditingFormStructure(),
    rowFormStructure: null,
    layerId: layer.getId(),
    title: layer.getName() || layer.getTitle() };
}

exports.default = {
  name: 'relation',

  props: {
    feature: { default: null },
    relation: {},
    previousview: {},
    cardinality: {},
    layer: {},
    showrelationslist: { default: false },
    chartRelationIds: { default: [] }
  },

  mixins: [_mixins.fieldsMixin, _mixins.resizeMixin],

  components: {
    Field: _FieldG3W2.default
  },

  data: function data() {
    var _this = this;

    return {
      fields: null,
      chart: false,
      headercomponent: null,
      downloadButton: null,
      downloadLayer: {
        state: null,
        config: { downloads: [] }
      },

      page: 1,

      page_size: _g3wConstants.PAGELENGTHS[0],

      start: 0,

      table: {
        rows: []
      },

      ordering: null,

      sort: 'asc',

      sort_column: 0,

      nmRelation: _application2.default.project.getRelationById(this.relation.nmRelationId),

      showChartButton: !!this.chartRelationIds.find(function (id) {
        return id === _this.relation.referencingLayer;
      })
    };
  },


  computed: {
    showTools: function showTools() {
      return [!!this.isEditable, !!this.table.formStructure, !!this.isGeoLayer].filter(Boolean).length;
    },
    one: function one() {
      return 'ONE' === this.relation.type;
    }
  },

  methods: {
    zoomToGeometry: function zoomToGeometry(geometry) {
      if (geometry) {
        _gui2.default.getService('map').zoomToGeometry(new ol.geom[geometry.type](geometry.coordinates), { highlight: true });
      }
    },
    getRelationsNM: function () {
      var _ref = _asyncToGenerator(function* () {
        var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            nmRelation = _ref2.nmRelation,
            _ref2$features = _ref2.features,
            features = _ref2$features === undefined ? [] : _ref2$features;

        var referencedLayer = nmRelation.referencedLayer,
            _nmRelation$fieldRef = nmRelation.fieldRef,
            referencingField = _nmRelation$fieldRef.referencingField,
            referencedField = _nmRelation$fieldRef.referencedField;

        var relationsNM = [];
        if (features.length) {
          var values = features.map(function (f) {
            return f.attributes[referencingField];
          });

          var _ref3 = yield _data2.default.getData('search:features', {
            inputs: {
              layer: (0, _getCatalogLayerById.getCatalogLayerById)(referencedLayer),
              filter: values.map(function (v) {
                return referencedField + '|eq|' + encodeURIComponent(v);
              }).join('|OR,'),
              formatter: 1 },
            outputs: null
          }),
              data = _ref3.data;

          if (data && data[0] && Array.isArray(data[0].features)) {
            relationsNM = data[0].features.map(function (f) {
              return {
                id: f.getId(),
                geometry: f.getGeometry(),
                attributes: (0, _getAlphanumericPropertiesFromFeature.getAlphanumericPropertiesFromFeature)(f.getProperties()).reduce(function (accumulator, property) {
                  accumulator[property] = f.get(property);
                  return accumulator;
                }, {})
              };
            });
          }
        }
        return relationsNM;
      });

      function getRelationsNM() {
        return _ref.apply(this, arguments);
      }

      return getRelationsNM;
    }(),
    getRelationDataTable: function () {
      var _ref4 = _asyncToGenerator(function* () {
        var _ref5 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            page = _ref5.page,
            page_size = _ref5.page_size,
            ordering = _ref5.ordering;

        _gui2.default.setLoadingContent(true);
        var table = { rows: [] };
        try {
          var relationLayerId = this.relation.referencingLayer;
          var features = void 0;
          var response = yield _XHR.XHR.get({
            url: (0, _createRelationsUrl.createRelationsUrl)({
              layer: this.layer,
              fid: this.feature.attributes[_g3wConstants.G3W_FID],
              relation: this.relation,
              page: page,
              page_size: page_size,
              ordering: ordering
            })
          });
          features = response.result ? (response.vector.data.features || []).map(function (f) {
            f.properties[_g3wConstants.G3W_FID] = f.id;
            return {
              geometry: f.geometry,
              attributes: f.properties,
              id: f.id
            };
          }) : null;
          var count = features && response.vector.count;
          if (this.nmRelation) {
            relationLayerId = this.nmRelation.referencedLayer;
            features = yield this.getRelationsNM({
              nmRelation: this.nmRelation,
              features: features
            });
          }

          table = _buildRelationTable(features, relationLayerId);
          table.count = count;
        } catch (e) {
          console.warn(e);
        }

        _gui2.default.setLoadingContent(false);
        return table;
      });

      function getRelationDataTable() {
        return _ref4.apply(this, arguments);
      }

      return getRelationDataTable;
    }(),
    createTable: function () {
      var _ref6 = _asyncToGenerator(function* () {
        var _this2 = this;

        var layer = (0, _getCatalogLayerById.getCatalogLayerById)(this.table.layerId);

        this.isEditable = layer.isEditable() && !layer.isInEditing();

        this.isGeoLayer = undefined !== this.table.features.find(function (f) {
          return f.geometry;
        });

        var downloadformats = layer.getDownloadableFormats().filter(function (f) {
          return 'pdf' !== f;
        });

        if (downloadformats.length > 0) {
          this.downloadButton = {
            toggled: false,
            tooltip: downloadformats.length > 1 ? 'Downloads' : 'sdk.tooltips.download_' + downloadformats[0],
            handler: downloadformats.length > 1 ? _asyncToGenerator(function* () {
              _this2.downloadButton.toggled = !_this2.downloadButton.toggled;
              _this2.downloadLayer.state = _this2.downloadLayer.state || layer.state;
              _this2.downloadLayer.config.downloads = _this2.downloadLayer.config.downloads.length ? _this2.downloadLayer.config.downloads : downloadformats.map(function (format) {
                return {
                  id: format,
                  format: format,
                  cbk: function cbk() {
                    _this2.saveRelation(layer.getDownloadUrl(format));
                    _this2.headercomponent = null;
                  },
                  download: true
                };
              });
              _this2.headercomponent = _this2.downloadButton.toggled ? _QueryResultsActionDownloadFormats2.default : null;
            }) : function () {
              return _this2.saveRelation(layer.getDownloadUrl(downloadformats[0]));
            }
          };
        }

        _g3wEventbus.VM.$on('reload-relations', function () {
          _this2.reloadLayout();
        });

        this.showChart = (0, _throttle.throttle)(_asyncToGenerator(function* () {
          _this2.chart = !_this2.chart;
          yield _this2.$nextTick();
          _this2.chartContainer = _this2.chartContainer || $('#chart_content');
          _this2.$emit(_this2.chart ? 'show-chart' : 'hide-chart', _this2.chartContainer, { relations: [_this2.relation], fid: _this2.feature.attributes[_g3wConstants.G3W_FID] });
        }));

        yield this.$nextTick();

        SIDEBARWIDTH = _gui2.default.getSize({ element: 'sidebar', what: 'width' });

        this.relation.title = this.relation.name;

        if (!this.one) {
          var data_from_server = this.table.rows.length < this.table.count;
          this.relationDataTable = $(this.$refs.relationtable).DataTable({
            autoWidth: false,
            bLengthChange: true,
            dom: 'ltip',
            columnDefs: [this.showTools ? { orderable: false, targets: 0, width: '1%' } : { orderable: true, targets: 0 }],
            order: [this.sort_column + !!this.showTools, this.sort],
            lengthMenu: _g3wConstants.PAGELENGTHS,
            pageLength: this.page_size,
            displayStart: this.start,
            responsive: true,
            scrollResize: true,
            scrollCollapse: true,
            scrollX: true,
            deferLoading: data_from_server && this.table.count,
            ajax: data_from_server ? function () {
              var _ref9 = _asyncToGenerator(function* (opts) {
                try {
                  _this2.relationDataTable.destroy(true);
                  _this2.relationDataTable = null;
                  _this2.table.rows = [];
                  yield _this2.$nextTick();

                  var changed = opts.length !== _this2.page_size || opts.start !== _this2.start;

                  _this2.page_size = opts.length;
                  _this2.start = opts.start;
                  var column = opts.order[0].column - !!_this2.showTools;
                  var sort = column === _this2.sort_column ? changed ? _this2.sort : 'desc' === _this2.sort ? 'asc' : 'desc' : 'asc';
                  _this2.sort_column = column;
                  _this2.sort = sort;

                  _this2.ordering = '' + ('desc' === sort ? '-' : '') + _this2.table.fields[opts.order[0].column - !!_this2.showTools].name;
                  _this2.table = yield _this2.getRelationDataTable({
                    page: 1 + (0 !== opts.start ? opts.start / opts.length : 0),
                    page_size: opts.length,
                    ordering: _this2.ordering
                  });
                } catch (e) {
                  console.warn(e);
                }
                _gui2.default.setLoadingContent(false);
              });

              return function (_x4) {
                return _ref9.apply(this, arguments);
              };
            }() : null,
            serverSide: data_from_server
          });
          this.tableHeaderHeight = $('.query-relation  div.dataTables_scrollHeadInner').height();
        }

        _gui2.default.on('pop-content', function () {
          return setTimeout(function () {
            return _this2.resize();
          });
        });

        this.resize();
      });

      function createTable() {
        return _ref6.apply(this, arguments);
      }

      return createTable;
    }(),
    resize: function () {
      var _ref10 = _asyncToGenerator(function* () {
        if (!this.$refs.query_relation || 'none' === this.$refs.query_relation.parentNode.style.display) {
          return;
        }

        var table = $(this.$refs.query_relation).find('div.dataTables_scrollBody');
        table.height($(".content").height() - this.tableHeaderHeight - $('.content_breadcrumb').outerHeight() - $('.navbar').outerHeight() - $('.close-panel-block').outerHeight() - $(this.$refs['relation-header']).outerHeight() - $('.dataTables_filter').last().outerHeight() - $('.dataTables_paginate.paging_simple_numbers').outerHeight() - $('.dataTables_scrollHead').last().outerHeight());

        this.reloadLayout();
      });

      function resize() {
        return _ref10.apply(this, arguments);
      }

      return resize;
    }(),
    saveRelation: function () {
      var _ref11 = _asyncToGenerator(function* (type) {
        _application2.default.download = true;
        try {
          var response = yield fetch((0, _createRelationsUrl.createRelationsUrl)(Object.assign({
            layer: this.layer,
            fid: this.feature.attributes[_g3wConstants.G3W_FID],
            relation: this.relation
          }, { type: type })), {
            headers: { 'Access-Control-Expose-Headers': 'Content-Disposition' },
            signal: AbortSignal.timeout(_g3wConstants.TIMEOUT)
          });

          if (!(response && response.ok)) {
            throw (yield response.json()).message;
          }

          (0, _saveBlob.saveBlob)((yield response.blob()), response.headers.get('content-disposition').split('filename=').at(-1));
        } catch (e) {
          console.warn(e);
          _gui2.default.showUserMessage({
            type: 'alert',
            message: e || 'info.server_error',
            closable: true
          });
        }

        _application2.default.download = false;
        this.downloadButton.toggled = false;
      });

      function saveRelation(_x5) {
        return _ref11.apply(this, arguments);
      }

      return saveRelation;
    }(),
    showFormStructureRow: function () {
      var _ref12 = _asyncToGenerator(function* () {
        var _ref13 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            title = _ref13.title,
            layerid = _ref13.layerid,
            feature = _ref13.feature,
            fields = _ref13.fields,
            tabs = _ref13.tabs;

        _gui2.default.showContent({
          content: new _g3wComponent2.default({
            internalComponent: new (Vue.extend({
              data: function data() {
                return {
                  layerid: layerid,
                  feature: feature,
                  fields: fields,
                  formStructure: tabs
                };
              },

              template: '\n              <div class="queryresults-wrapper">\n                <div class ="queryresults-container">\n                  <table ref="table" class="table">\n                    <tbody>\n                    <tr class="featurebox-body">\n                      <td>\n                        <tabs\n                          :layerid = "layerid"\n                          :feature = "feature"\n                          :fields  = "fields"\n                          :tabs    = "formStructure" />\n                      </td>\n                    </tr>\n                    </tbody>\n                  </table>\n                </div>\n              </div>\n            ',
              mounted: function () {
                var _ref14 = _asyncToGenerator(function* () {
                  yield this.$nextTick();
                  this.$refs.table.click();
                });

                function mounted() {
                  return _ref14.apply(this, arguments);
                }

                return mounted;
              }()
            }))()
          }),
          push: true,
          showgoback: true,
          closable: false,
          title: title });
      });

      function showFormStructureRow() {
        return _ref12.apply(this, arguments);
      }

      return showFormStructureRow;
    }(),
    editFeature: function editFeature(index) {
      _gui2.default.getService('queryresults').editFeature({
        layer: {
          id: this.table.layerId,
          attributes: this.table.fields
        },
        feature: this.table.features[index]
      });
    },
    getRowFields: function getRowFields(row) {
      var _this3 = this;

      return this.table.fields.map(function (field, index) {
        field.value = row[index];
        field.query = true;
        field.input = { type: '' + _this3.getFieldType(field) };
        return field;
      });
    },
    reloadLayout: function reloadLayout() {
      if (this.relationDataTable) {
        this.relationDataTable.columns.adjust();
      }
    },
    back: function back() {
      this.$parent.setRelationsList();
    },
    fieldIs: function fieldIs(type, value) {
      return this.getFieldType(value) === type;
    },
    is: function is(type, value) {
      return this.fieldIs(type, value);
    },
    wrapMoveFnc: function wrapMoveFnc(e) {
      this.moveFnc(e);
    },
    resizeStart: function resizeStart() {
      document.getElementById('g3w-view-content').addEventListener('mousemove', this.wrapMoveFnc);
      document.getElementById('g3w-view-content').addEventListener('mouseup', this.resizeStop, { once: true });
    },
    resizeStop: function () {
      var _ref15 = _asyncToGenerator(function* () {
        document.getElementById('g3w-view-content').removeEventListener('mousemove', this.wrapMoveFnc);
        yield this.$nextTick();
        _gui2.default.emit('resize');
      });

      function resizeStop() {
        return _ref15.apply(this, arguments);
      }

      return resizeStop;
    }(),
    moveFnc: function moveFnc(evt) {
      var sidebarHeaderSize = $('.sidebar-collapse').length ? 0 : SIDEBARWIDTH;
      var size = evt.pageX + 2 - sidebarHeaderSize;
      this.$refs.tablecontent.style.width = size + 'px';
      this.$refs.chartcontent.style.width = $(this.$refs.relationwrapper).width() - size - 10 + 'px';
    }
  },

  watch: {
    table: function table(_table) {
      if (_table && _table.rows.length) {
        this.createTable();
      }
    },
    chart: function () {
      var _ref16 = _asyncToGenerator(function* () {
        yield this.$nextTick();
        this.resize();
      });

      function chart() {
        return _ref16.apply(this, arguments);
      }

      return chart;
    }(),
    headercomponent: function () {
      var _ref17 = _asyncToGenerator(function* () {
        yield this.$nextTick();
        this.resize();
      });

      function headercomponent() {
        return _ref17.apply(this, arguments);
      }

      return headercomponent;
    }()
  },

  beforeCreate: function beforeCreate() {
    this.delayType = 'debounce';
  },
  created: function () {
    var _ref18 = _asyncToGenerator(function* () {
      try {
        this.table = yield this.getRelationDataTable({
          page: this.page,
          page_size: this.page_size,
          ordering: this.ordering
        });
      } catch (e) {
        console.warn(e);
      }
    });

    function created() {
      return _ref18.apply(this, arguments);
    }

    return created;
  }(),
  beforeDestroy: function () {
    var _ref19 = _asyncToGenerator(function* () {
      if (!this.relationDataTable) {
        return;
      }
      this.relationDataTable.destroy();
      this.relationDataTable = null;
      if (this.chartContainer) {
        this.$emit('hide-chart', this.chartContainer);
      }
      this.chartContainer = null;
      this.tableHeaderHeight = null;
      _gui2.default.off('pop-content', this.resize);
    });

    function beforeDestroy() {
      return _ref19.apply(this, arguments);
    }

    return beforeDestroy;
  }()
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.table)?_c('div',{ref:"query_relation",staticClass:"query-relation",class:_vm.isMobile() ? 'mobile' : null},[_c('div',{ref:"relation-header",staticClass:"header skin-background-color lighten"},[_c('div',{staticClass:"g3w-long-text"},[(_vm.showrelationslist)?_c('span',{directives:[{name:"t-tooltip",rawName:"v-t-tooltip:right.create",value:('sdk.relations.back_to_relations'),expression:"'sdk.relations.back_to_relations'",arg:"right",modifiers:{"create":true}}],staticClass:"action-button-icon action-button back-button",class:_vm.$fa('exit'),on:{"click":function($event){$event.stopPropagation();return _vm.back($event)}}}):_vm._e(),_vm._v(" "),_c('b',{staticClass:"relation-tile skin-color"},[_vm._v(" "+_vm._s(_vm.relation.name)+" ")])]),_vm._v(" "),(_vm.table.rows.length)?_c('div',{staticClass:"relations-table-tools"},[(_vm.downloadButton)?_c('span',{directives:[{name:"download",rawName:"v-download"},{name:"t-tooltip",rawName:"v-t-tooltip:left.create",value:(_vm.downloadButton.tooltip),expression:"downloadButton.tooltip",arg:"left",modifiers:{"create":true}}],staticClass:"action-button-icon action-button",class:[
          _vm.$fa('download'),
          { 'toggled-white': _vm.downloadButton.toggled } ],on:{"click":function($event){$event.stopPropagation();return _vm.downloadButton.handler($event)}}}):_vm._e(),_vm._v(" "),(_vm.showChartButton)?_c('span',{directives:[{name:"t-tooltip",rawName:"v-t-tooltip:bottom.create",value:('sdk.tooltips.show_chart'),expression:"'sdk.tooltips.show_chart'",arg:"bottom",modifiers:{"create":true}}],staticClass:"action-button-icon action-button",class:[
          _vm.$fa('chart'),
          _vm.chart ? 'toggled-white' : '' ],on:{"click":function($event){$event.stopPropagation();return _vm.showChart($event)}}}):_vm._e()]):_vm._e()]),_vm._v(" "),(_vm.table.rows.length)?_c('div',{ref:"relationwrapper",staticClass:"relation-wrapper"},[_c('div',{ref:"tablecontent",style:({
        width:       _vm.chart ? '70%' : '100%',
        marginRight: _vm.chart ? '8px' : '3px',
        position:    'relative',
      }),attrs:{"id":"table_content"}},[(_vm.headercomponent)?_c('div',{staticClass:"header-component"},[_c(_vm.headercomponent,{tag:"component",attrs:{"layer":_vm.downloadLayer.state,"config":_vm.downloadLayer.config}})],1):_vm._e(),_vm._v(" "),_c('table',{ref:"relationtable",staticClass:"hover relationtable table table-striped row-border compact nowrap"},[_c('thead',[_c('tr',{staticStyle:{"height":"0! important"}},[(_vm.showTools)?_c('th',{style:({
                minWidth: this.showTools * 30 + 'px',
                padding:  '0 !important',
              })}):_vm._e(),_vm._v(" "),_vm._l((_vm.table.columns),function(column){return _c('th',[_vm._v(_vm._s(column))])})],2)]),_vm._v(" "),_c('tbody',_vm._l((_vm.table.rows),function(row,index){return _c('tr',{key:_vm.table.rows_fid[index],class:{
            'selected': _vm.table.rowFormStructure === row,
          }},[(_vm.showTools)?_c('td',{staticClass:"table-tools"},[(_vm.table.features[index].geometry)?_c('span',{directives:[{name:"t-tooltip",rawName:"v-t-tooltip:right.create",value:('sdk.tooltips.relations.zoomtogeometry'),expression:"'sdk.tooltips.relations.zoomtogeometry'",arg:"right",modifiers:{"create":true}}],staticClass:"action-button row-form skin-color",class:_vm.$fa('marker'),on:{"click":function($event){$event.stopPropagation();return _vm.zoomToGeometry(_vm.table.features[index].geometry)}}}):_vm._e(),_vm._v(" "),(_vm.table.formStructure)?_c('span',{directives:[{name:"t-tooltip",rawName:"v-t-tooltip:right.create",value:("sdk.tooltips.relations.row_to_form"),expression:"`sdk.tooltips.relations.row_to_form`",arg:"right",modifiers:{"create":true}}],staticClass:"action-button row-form skin-color",class:_vm.$fa('table'),on:{"click":function($event){$event.stopPropagation();_vm.showFormStructureRow({ title: _vm.table.title, layerid: _vm.table.layerId, feature: _vm.table.features[index], fields: _vm.getRowFields(row), tabs: _vm.table.formStructure })}}}):_vm._e(),_vm._v(" "),(_vm.isEditable)?_c('span',{directives:[{name:"t-tooltip",rawName:"v-t-tooltip:right.create",value:('Edit'),expression:"'Edit'",arg:"right",modifiers:{"create":true}}],staticClass:"action-button row-form skin-color",class:_vm.$fa('pencil'),on:{"click":function($event){$event.stopPropagation();return _vm.editFeature(index)}}}):_vm._e()]):_vm._e(),_vm._v(" "),_vm._l((row),function(value){return _c('td',[_c('field',{attrs:{"state":{value:value}}})],1)})],2)}),0)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.chart),expression:"chart"}],staticClass:"skin-border-color lighten",staticStyle:{"border-style":"solid","border-width":"0 1px 0 1px"},style:({
        minWidth:        '5px',
        backgroundColor: '#dddddd',
        cursor:          'col-resize',
      }),on:{"mousedown":function($event){$event.stopPropagation();return _vm.resizeStart($event)}}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.chart),expression:"chart"}],ref:"chartcontent",style:({ width: _vm.chart ? '30%' : '0' }),attrs:{"id":"chart_content"}})]):_c('div',{staticClass:"dataTables_scrollBody"},[_c('span',{directives:[{name:"t",rawName:"v-t",value:('sdk.relations.no_relations_found'),expression:"'sdk.relations.no_relations_found'"}]})])]):_vm._e()}
__vue__options__.staticRenderFns = []
__vue__options__._scopeId = "data-v-36faa180"

},{"components/FieldG3W.vue":77,"components/QueryResultsActionDownloadFormats.vue":129,"g3w-component":158,"g3w-constants":159,"g3w-eventbus":160,"mixins":200,"services/data":206,"services/gui":207,"store/application":212,"utils/XHR":215,"utils/createRelationsUrl":228,"utils/getAlphanumericPropertiesFromFeature":237,"utils/getCatalogLayerById":238,"utils/saveBlob":274,"utils/throttle":276,"vueify/lib/insert-css":35}],137:[function(require,module,exports){
var __vueify_style_dispose__ = require("vueify/lib/insert-css").insert(".relation-grid-item[data-v-a1024c3a]{min-width:0;min-height:80px;border:2px solid;cursor:pointer;border-radius:4px;background-color:#fff;display:flex;align-items:center}.relation-grid-item[data-v-a1024c3a]:hover{background-color:transparent}.query-relations[data-v-a1024c3a]{overflow-y:auto}.query-relations>.header[data-v-a1024c3a]{margin-bottom:10px;border-radius:4px;padding:5px}.query-relations>.query-relations-content[data-v-a1024c3a]{display:grid;grid-template-columns:repeat(2,auto);grid-column-gap:5px;grid-row-gap:5px}.relation-grid-item>.g3w-long-text[data-v-a1024c3a]{font-weight:700;padding:5px}")
;(function(){
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

exports.default = {
  name: 'relations',

  props: ['relations', 'feature', 'loading'],

  methods: {
    showRelation: function () {
      var _ref = _asyncToGenerator(function* (relation) {
        yield this.$parent.showRelation(relation);
      });

      function showRelation(_x) {
        return _ref.apply(this, arguments);
      }

      return showRelation;
    }(),
    featureInfo: function featureInfo() {
      return Object.entries(this.feature.attributes).filter(function (_ref2) {
        var _ref3 = _slicedToArray(_ref2, 2),
            _ = _ref3[0],
            value = _ref3[1];

        return value && 'string' === typeof value && !value.includes('/');
      }).map(function (_ref4) {
        var _ref5 = _slicedToArray(_ref4, 2),
            key = _ref5[0],
            value = _ref5[1];

        return { key: key, value: value };
      }).slice(0, 3);
    }
  },

  mounted: function () {
    var _ref6 = _asyncToGenerator(function* () {
      if (1 === this.relations.length) {
        this.relations[0].noback = true;
        yield this.showRelation(this.relations[0]);
      }
    });

    function mounted() {
      return _ref6.apply(this, arguments);
    }

    return mounted;
  }(),
  beforeDestroy: function beforeDestroy() {
    if (1 === this.relations.length) {
      delete this.relations[0].noback;
    }
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"query-relations"},[_c('div',{staticClass:"header skin-background-color lighten"},[_c('div',{staticClass:"skin-color-dark"},[_c('span',{directives:[{name:"t",rawName:"v-t:pre",value:('sdk.relations.list_of_relations_feature'),expression:"'sdk.relations.list_of_relations_feature'",arg:"pre"}],staticStyle:{"font-size":"1.1em"}}),_vm._v(" "),_vm._l((_vm.featureInfo()),function(info){return _c('div',[_vm._v(" - "),_c('b',[_vm._v(_vm._s(info.key))]),_vm._v(": "+_vm._s(info.value))])})],2)]),_vm._v(" "),_c('div',{staticClass:"query-relations-content"},_vm._l((_vm.relations),function(relation){return _c('div',{staticClass:"skin-border-color relation-grid-item",on:{"click":function($event){$event.stopPropagation();return _vm.showRelation(relation)}}},[_c('span',{staticClass:"skin-color g3w-long-text"},[_vm._v(_vm._s(relation.name))])])}),0)])}
__vue__options__.staticRenderFns = []
__vue__options__._scopeId = "data-v-a1024c3a"

},{"vueify/lib/insert-css":35}],138:[function(require,module,exports){
;(function(){
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _g3wEventbus = require('g3w-eventbus');

var _gui = require('services/gui');

var _gui2 = _interopRequireDefault(_gui);

var _Relations = require('components/Relations.vue');

var _Relations2 = _interopRequireDefault(_Relations);

var _Relation = require('components/Relation.vue');

var _Relation2 = _interopRequireDefault(_Relation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

exports.default = {
  name: 'relation-page',

  data: function data() {
    var _$options = this.$options,
        _$options$relation = _$options.relation,
        relation = _$options$relation === undefined ? null : _$options$relation,
        _$options$relations = _$options.relations,
        relations = _$options$relations === undefined ? [] : _$options$relations,
        nmRelation = _$options.nmRelation,
        _$options$feature = _$options.feature,
        feature = _$options$feature === undefined ? null : _$options$feature,
        _$options$currentview = _$options.currentview,
        currentview = _$options$currentview === undefined ? 'relations' : _$options$currentview,
        _$options$chartRelati = _$options.chartRelationIds,
        chartRelationIds = _$options$chartRelati === undefined ? [] : _$options$chartRelati,
        layer = _$options.layer;

    return {
      loading: false,
      state: null,
      error: false,
      previousview: currentview,
      feature: feature,
      currentview: currentview,
      relation: relation,
      relations: relations,
      nmRelation: nmRelation,
      chartRelationIds: chartRelationIds,
      layer: layer
    };
  },

  components: {
    'relations': _Relations2.default,
    'relation': _Relation2.default
  },
  computed: {
    showrelationslist: function showrelationslist() {
      return 'relations' === this.previousview && this.relations.length > 1;
    }
  },
  methods: {
    reloadLayout: function reloadLayout() {
      _g3wEventbus.VM.$emit('reload-relations');
    },
    showChart: function showChart(container, relationData) {
      _gui2.default.getService('queryresults').showChart([this.relation.referencingLayer], container, relationData);
    },
    hideChart: function hideChart(container) {
      _gui2.default.getService('queryresults').hideChart(container);
    },
    showRelation: function () {
      var _ref = _asyncToGenerator(function* (relation) {
        this.loading = true;
        this.relation = relation;
        try {
          _gui2.default.setCurrentContentOptions({
            title: relation.name,
            crumb: { title: relation.name, text: true } });
          yield this.$nextTick();
          this.previousview = this.currentview;
          this.currentview = 'relation';
        } catch (e) {
          console.warn(e);
        }

        this.loading = true;
      });

      function showRelation(_x) {
        return _ref.apply(this, arguments);
      }

      return showRelation;
    }(),
    setRelationsList: function setRelationsList() {
      this.previousview = 'relation';
      this.currentview = 'relations';
      _gui2.default.setCurrentContentOptions({ crumb: { title: 'info.list_of_relations' } });
      this.loading = false;
    }
  },
  beforeMount: function beforeMount() {
    if ('relation' === this.currentview || 1 === this.relations.length && 'ONE' === this.relations[0].type) {
      this.showRelation(this.relations[0]);
    }
  },
  mounted: function () {
    var _ref2 = _asyncToGenerator(function* () {
      this.relations.sort(function (_ref3, _ref4) {
        var relationName1 = _ref3.name;
        var relationName2 = _ref4.name;

        if (relationName1 < relationName2) return -1;
        if (relationName1 > relationName2) return 1;
        return 0;
      });
      yield this.$nextTick();
      if (this.error) {
        requestAnimationFrame(function () {
          return _gui2.default.popContent();
        });
      }
      this.error = false;
    });

    function mounted() {
      return _ref2.apply(this, arguments);
    }

    return mounted;
  }(),
  created: function created() {
    this.$on('resize-component', this.reloadLayout);
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"query-relations-page"},[_c(_vm.currentview,{ref:_vm.currentview,tag:"component",attrs:{"loading":_vm.loading,"previousview":_vm.previousview,"relations":_vm.relations,"relation":_vm.relation,"feature":_vm.feature,"layer":_vm.layer,"chartRelationIds":_vm.chartRelationIds,"showrelationslist":_vm.showrelationslist},on:{"show-chart":_vm.showChart,"hide-chart":_vm.hideChart}})],1)}
__vue__options__.staticRenderFns = []

},{"components/Relation.vue":136,"components/Relations.vue":137,"g3w-eventbus":160,"services/gui":207}],139:[function(require,module,exports){
var __vueify_style_dispose__ = require("vueify/lib/insert-css").insert("li.menu-item[data-v-7e68c028]{padding-right:20px!important}li.menu-item span[data-v-7e68c028]{display:inline-flex;white-space:pre-wrap}.search-action[data-v-7e68c028]{text-shadow:0 2px 5px rgba(0,0,0,.3);padding:0 4px}#g3w-search li i[data-v-7e68c028]{width:20px}.search-tools[data-v-7e68c028]{display:flex;align-items:baseline}.search-tools>span[data-v-7e68c028]{white-space:pre-wrap}.search-tools>div[data-v-7e68c028]{margin-left:auto}")
;(function(){
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _g3wPanel = require('g3w-panel');

var _g3wPanel2 = _interopRequireDefault(_g3wPanel);

var _application = require('store/application');

var _application2 = _interopRequireDefault(_application);

var _data = require('services/data');

var _data2 = _interopRequireDefault(_data);

var _gui = require('services/gui');

var _gui2 = _interopRequireDefault(_gui);

var _createFilterFromString = require('utils/createFilterFromString');

var _getCatalogLayerById = require('utils/getCatalogLayerById');

var _Tool = require('components/Tool.vue');

var _Tool2 = _interopRequireDefault(_Tool);

var _QueryBuilder = require('components/QueryBuilder.vue');

var vueComp = _interopRequireWildcard(_QueryBuilder);

var _g3wI18n = require('g3w-i18n');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

exports.default = {
  name: 'search',

  data: function data() {
    return {
      state: this.state || {}
    };
  },


  components: {
    'g3w-tool': _Tool2.default
  },

  computed: {
    show: function show() {
      return this.state.searches.length + this.state.tools.length + this.state.querybuildersearches.length > 0;
    }
  },

  methods: {
    showPanel: function showPanel() {
      var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      this.$options.service.showPanel(config);
    },
    remove: function () {
      var _ref = _asyncToGenerator(function* (search, index) {
        try {
          yield new Promise(function (res, rej) {
            _gui2.default.dialog.confirm((0, _g3wI18n.t)('sdk.querybuilder.delete'), function (d) {
              return d ? res() : rej();
            });
          });
          var item = window.localStorage.getItem('QUERYBUILDERSEARCHES');
          var items = item ? JSON.parse(item) : undefined;
          var projectId = _application2.default.project.getId();
          var searches = (items ? items[projectId] || [] : []).filter(function (item) {
            return item.id !== search.id;
          });

          if (searches.length) {
            items[projectId] = searches;
          } else {
            delete items[projectId];
          }

          try {
            if (Object.keys(items).length) {
              window.localStorage.setItem('QUERYBUILDERSEARCHES', JSON.stringify(items));
            } else {
              window.localStorage.removeItem('QUERYBUILDERSEARCHES');
            }
          } catch (e) {
            console.warn(e);
          }

          this.state.querybuildersearches.splice(index, 1);
        } catch (e) {
          console.warn(e);
        }
      });

      function remove(_x2, _x3) {
        return _ref.apply(this, arguments);
      }

      return remove;
    }(),
    edit: function edit(search) {
      var opts = {
        id: search.id,
        name: search.name,
        layerId: search.layerId,
        filter: search.filter,
        title: (0, _g3wI18n.t)('sdk.querybuilder.title'),
        show: true
      };
      opts.internalPanel = new (Vue.extend(vueComp))({ options: opts });
      new _g3wPanel2.default(opts);
    },
    run: function () {
      var _ref2 = _asyncToGenerator(function* (search) {
        search.qbloading = true;
        try {
          var layer = (0, _getCatalogLayerById.getCatalogLayerById)(search.layerId);
          yield _data2.default.getData('search:features', {
            inputs: {
              layer: layer,
              filter: (0, _createFilterFromString.createFilterFromString)({ layer: layer, filter: search.filter }),
              feature_count: 100
            },
            outputs: true
          });
        } catch (e) {
          console.warn(e);
          _gui2.default.showUserMessage({ type: 'alert', message: 'sdk.querybuilder.error_run', autoclose: true });
        }
        search.qbloading = false;
      });

      function run(_x4) {
        return _ref2.apply(this, arguments);
      }

      return run;
    }()
  }

};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('ul',{staticClass:"treeview-menu g3w-search g3w-tools menu-items",attrs:{"id":"g3w-search"}},[_vm._l((_vm.state.searches),function(search){return _c('li',{staticClass:"menu-item",on:{"click":function($event){$event.stopPropagation();return _vm.showPanel(search)}}},[_c('i',{class:_vm.$fa('empty-circle')}),_vm._v(" "),_c('span',[_vm._v(_vm._s(search.name))])])}),_vm._v(" "),_vm._l((_vm.state.tools),function(searchtool){return _c('li',[_c('g3w-tool',{attrs:{"tool":searchtool}})],1)}),_vm._v(" "),_vm._l((_vm.state.querybuildersearches),function(search,i){return _c('li',{key:search.id},[_c('div',{staticStyle:{"position":"relative"},on:{"click":function($event){return _vm.edit(search)}}},[_c('bar-loader',{attrs:{"loading":search.qbloading}}),_vm._v(" "),_c('div',{staticClass:"search-tools"},[_c('span',{directives:[{name:"t-tooltip",rawName:"v-t-tooltip",value:('sdk.querybuilder.search.delete'),expression:"'sdk.querybuilder.search.delete'"}],staticClass:"search-action skin-tooltip-bottom",class:_vm.$fa('trash'),staticStyle:{"color":"red","margin-right":"5px"},attrs:{"data-placement":"bottom","data-toggle":"tooltip","data-container":"body"},on:{"click":function($event){$event.stopPropagation();return _vm.remove(search, i)}}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(search.name))]),_vm._v(" "),_c('div',[_c('span',{directives:[{name:"t-tooltip",rawName:"v-t-tooltip:bottom.create",value:('sdk.querybuilder.search.run'),expression:"'sdk.querybuilder.search.run'",arg:"bottom",modifiers:{"create":true}}],staticClass:"search-action",class:_vm.$fa('run'),staticStyle:{"color":"green"},on:{"click":function($event){$event.stopPropagation();return _vm.run(search)}}})])])],1)])})],2):_vm._e()}
__vue__options__.staticRenderFns = []
__vue__options__._scopeId = "data-v-7e68c028"

},{"components/QueryBuilder.vue":125,"components/Tool.vue":144,"g3w-i18n":162,"g3w-panel":164,"services/data":206,"services/gui":207,"store/application":212,"utils/createFilterFromString":226,"utils/getCatalogLayerById":238,"vueify/lib/insert-css":35}],140:[function(require,module,exports){
var __vueify_style_dispose__ = require("vueify/lib/insert-css").insert(".g3w-search-form label[data-v-aa9afcb0]{color:#fff}.g3w-search-form .search-logicop[data-v-aa9afcb0]{width:100%;position:relative;display:flex;justify-content:center;margin-bottom:15px;margin-top:30px;border-bottom:1px solid}.g3w-search-form .search-logicop h4[data-v-aa9afcb0]{font-weight:700;position:absolute;padding:5px;top:-24px;background:#222d32}#dosearch[data-v-aa9afcb0]{color:#fff;font-weight:700;margin-top:15px;background-color:var(--skin-color)}#dosearch[data-v-aa9afcb0]:hover{color:#fff}.search-label[data-v-aa9afcb0]{width:100%;display:flex;justify-content:space-between}")
;(function(){
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _g3wConstants = require('g3w-constants');

var _application = require('store/application');

var _application2 = _interopRequireDefault(_application);

var _convertQGISDateTimeFormatToMoment = require('utils/convertQGISDateTimeFormatToMoment');

var _createSingleFieldParameter = require('utils/createSingleFieldParameter');

var _getDataForSearchInput = require('utils/getDataForSearchInput');

var _resize = require('mixins/resize');

var _resize2 = _interopRequireDefault(_resize);

var _g3wI18n = require('g3w-i18n');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var SELECTS = [];

exports.default = {

  mixins: [_resize2.default],

  data: function data() {
    return {
      state: this.$options.service.state,
      autofilter: false,
      allvalue: _g3wConstants.SEARCH_ALLVALUE,
      reload: false
    };
  },


  computed: {
    layers_url: function layers_url() {
      return _application2.default.project.getState().layers_url;
    },
    is_staff: function is_staff() {
      return window.initConfig.user.is_staff;
    },
    loading: function loading() {
      return this.state.forminputs.reduce(function (bool, i) {
        return bool || i.loading;
      }, false);
    },
    filterlayers: function filterlayers() {
      return _application2.default.tokens.filtertoken && this.state.search_layers.filter(function (l) {
        return l.getFilterToken();
      }) || [];
    }
  },

  methods: {
    clearFilters: function clearFilters() {
      var _this = this;

      this.filterlayers.forEach(function (l) {
        if (_this.state.paginate) {
          l.clearSelectionFids();
        } else {
          l.toggleFilterToken();
        }
      });
    },
    resize: function resize() {
      SELECTS.forEach(function (select2) {
        return !_application2.default.ismobile && select2.select2('close');
      });
    },
    getLabelOperator: function getLabelOperator(operator) {
      return '[ ' + _g3wConstants.FILTER_EXPRESSION_OPERATORS[operator] + ' ]';
    },
    onFocus: function () {
      var _ref = _asyncToGenerator(function* (e) {
        if (this.isMobile()) {
          var top = $(e.target).position().top - 10;
          yield this.$nextTick();
          setTimeout(function () {
            return $('.main-sidebar').scrollTop(top);
          }, 500);
        }
      });

      function onFocus(_x) {
        return _ref.apply(this, arguments);
      }

      return onFocus;
    }(),
    changeInput: function () {
      var _ref2 = _asyncToGenerator(function* (input) {
        var _this2 = this;

        var field = input.attribute;
        var deps = this.state.forminputs.filter(function (i) {
          return field === i.dependance;
        });
        var state = this.state;
        var value = input.value;

        var is_empty = function is_empty(v) {
          return [_g3wConstants.SEARCH_ALLVALUE, null, undefined].includes(v) || '' === v.toString().trim();
        };
        var has_autocomplete = function has_autocomplete(i) {
          return 'autocompletefield' === i.type;
        };

        try {
          this.state.searching = true;

          if ('numberfield' === input.type) {
            value = value || 0 === value ? value : null;
          }

          if (undefined === value) {
            value = _g3wConstants.SEARCH_ALLVALUE;
          }

          if (!['textfield', 'textField'].includes(input.type)) {
            value = value.trim();
          }

          input.value = value;

          yield Promise.allSettled(deps.map(function () {
            var _ref3 = _asyncToGenerator(function* (d) {
              var filter = _getDataForSearchInput.getDataForSearchInput.field({
                state: state,
                field: field,
                fields: [_g3wConstants.SEARCH_ALLVALUE, undefined].includes(value) ? [] : [(0, _createSingleFieldParameter.createSingleFieldParameter)({ field: field, value: value, operator: input.operator })]
              });

              var cached = d.dvalues[filter];

              d.value = 'selectfield' === d.type ? _g3wConstants.SEARCH_ALLVALUE : null;
              d.values = Array.from(new Set([].concat(_toConsumableArray(!has_autocomplete(d) && !is_empty(value) ? [d.values[0]] : []), _toConsumableArray(!has_autocomplete(d) && is_empty(value) ? d._values : []), _toConsumableArray(cached || []))));

              d.disabled = is_empty(value) ? d.dependance_strict : false;

              if (_this2.state.forminputs.find(function (i) {
                return i.dependance === d.attribute;
              })) {
                _this2.changeInput(d);
              }

              if (has_autocomplete(d) || is_empty(value) || cached) {
                return;
              }

              state.loading[d.attribute] = true;

              try {
                var data = yield state.search_layers[0].getFilterData({
                  fformatter: d.attribute,
                  ordering: d.attribute,
                  field: filter
                });

                data.data = (data.data || []).map(function (_ref4) {
                  var _ref5 = _slicedToArray(_ref4, 2),
                      value = _ref5[0],
                      key = _ref5[1];

                  return { key: key, value: value };
                });

                if (!d.dependance_strict && 'selectfield' === d.type) {
                  var _d$_values;

                  (_d$_values = d._values).push.apply(_d$_values, _toConsumableArray(d.values));
                }

                if (1 === d.values.length) {
                  var _d$values;

                  (_d$values = d.values).push.apply(_d$values, _toConsumableArray(data.data));
                }

                d.dvalues[filter] = d.values.slice(1);
              } catch (e) {
                console.warn(e);
              } finally {
                d.disabled = false;
                _this2.state.loading[d.attribute] = false;
              }
            });

            return function (_x3) {
              return _ref3.apply(this, arguments);
            };
          }()));
        } catch (e) {
          console.warn(e);
        } finally {
          this.state.searching = false;
        }
      });

      function changeInput(_x2) {
        return _ref2.apply(this, arguments);
      }

      return changeInput;
    }(),
    doSearch: function doSearch(e) {
      e.preventDefault();
      this.$options.service.run();
    },
    initDateTimeField: function () {
      var _ref6 = _asyncToGenerator(function* (input) {
        var _this3 = this;

        if ('datetimefield' !== input.type) {
          return;
        }

        yield this.$nextTick();

        input.options.format.fieldformat = (0, _convertQGISDateTimeFormatToMoment.convertQGISDateTimeFormatToMoment)(input.options.format.fieldformat);
        input.options.format.displayformat = (0, _convertQGISDateTimeFormatToMoment.convertQGISDateTimeFormatToMoment)(input.options.format.displayformat);

        $(this.$refs['date_' + input.id]).datetimepicker({
          defaultDate: null,
          format: input.options.format.displayformat,
          ignoreReadonly: true,
          allowInputToggle: true,
          toolbarPlacement: 'top',
          widgetPositioning: { vertical: 'bottom', horizontal: 'left' },
          showClose: true,
          locale: _application2.default.language || 'en'
        });

        $(this.$refs['date_' + input.id]).on("dp.change", function () {
          var newDate = $('#' + input.id).val();
          input.value = newDate.trim() ? moment(newDate, input.options.format.displayformat).format(input.options.format.fieldformat) : null;
          _this3.changeInput(input);
        });

        if (_application2.default.ismobile) {
          setTimeout(function () {
            $('#' + input.id).blur();
          });
        }
      });

      function initDateTimeField(_x4) {
        return _ref6.apply(this, arguments);
      }

      return initDateTimeField;
    }(),
    initSelect2Field: function () {
      var _ref7 = _asyncToGenerator(function* (input) {
        var _this4 = this;

        if (!['selectfield', 'autocompletefield'].includes(input.type)) {
          return;
        }

        yield this.$nextTick();

        var numdigaut = input.options.numdigaut;
        var has_autocomplete = 'autocompletefield' === input.type;
        var ajax = has_autocomplete ? {
          delay: 500,
          transport: function () {
            var _ref8 = _asyncToGenerator(function* (d, ok, ko) {
              try {
                ok({
                  results: (yield (0, _getDataForSearchInput.getDataForSearchInput)({
                    state: _this4.state,
                    field: input.attribute,
                    suggest: input.attribute + '|' + d.data.q
                  })).map(function (d) {
                    return { id: d.value, text: d.key };
                  })
                });
              } catch (e) {
                ko(e);
              }
            });

            function transport(_x6, _x7, _x8) {
              return _ref8.apply(this, arguments);
            }

            return transport;
          }()
        } : null;

        var select2 = $('#' + input.id).select2({
          ajax: ajax,
          width: '100%',
          dropdownParent: $('.g3w-search-form:visible'),
          minimumInputLength: has_autocomplete && (numdigaut && !Number.isNaN(1 * numdigaut) && 1 * numdigaut > 0 && 1 * numdigaut || 2) || 0,
          allowClear: has_autocomplete,
          placeholder: has_autocomplete ? '' : null,

          matcher: function matcher(params, data) {
            var search = params.term ? params.term.toLowerCase() : params.term;
            if ('' === (search || '').toString().trim()) {
              return data;
            }
            if (data.text.toLowerCase().includes(search) && undefined !== data.text) {
              return _extends({}, data);
            }
            return null;
          },
          language: {
            noResults: function noResults() {
              return (0, _g3wI18n.t)("sdk.search.no_results");
            },
            errorLoading: function errorLoading() {
              return (0, _g3wI18n.t)("sdk.search.error_loading");
            },
            searching: function searching() {
              return (0, _g3wI18n.t)("sdk.search.searching");
            },
            inputTooShort: function inputTooShort(d) {
              return (0, _g3wI18n.t)("sdk.search.autocomplete.inputshort.pre") + ' ' + (d.minimum - d.input.length) + ' ' + (0, _g3wI18n.t)("sdk.search.autocomplete.inputshort.post");
            }
          }
        });

        SELECTS.push(select2);

        select2.on('select2:select select2:unselecting', function (e) {
          if ('select2:select' === e.type || has_autocomplete) {
            input.value = e.params.data ? '' + e.params.data.id : _g3wConstants.SEARCH_ALLVALUE;
            _this4.changeInput(input);
          }
        });

        this.$watch(function () {
          return input.value;
        }, function () {
          var _ref9 = _asyncToGenerator(function* (value, oldVal) {
            if (value !== oldVal && _g3wConstants.SEARCH_ALLVALUE === value) {
              select2.val(value).trigger('change');
            }
          });

          return function (_x9, _x10) {
            return _ref9.apply(this, arguments);
          };
        }());

        var unwatch = this.$watch(function () {
          return _application2.default.language;
        }, function () {
          unwatch();
          _this4.clearSelect2();
          _this4.initSelect2Field(input);
        });

        select2.val(input.value).trigger('change');
      });

      function initSelect2Field(_x5) {
        return _ref7.apply(this, arguments);
      }

      return initSelect2Field;
    }(),
    clearSelect2: function clearSelect2() {
      SELECTS.forEach(function (select2) {
        select2.select2('destroy');
        select2.off();
        select2 = null;
      });

      SELECTS.splice(0);
    },
    reloadSelect2Inputs: function () {
      var _ref10 = _asyncToGenerator(function* () {
        var _this5 = this;

        if (this.reload) {
          return;
        }

        this.reload = true;

        yield this.$nextTick();

        try {
          yield this.$options.service.setInputs();
        } catch (e) {
          console.warn(e);
        }

        this.clearSelect2();
        try {
          yield Promise.allSettled(this.state.forminputs.map(function (input) {
            return _this5.initSelect2Field(input);
          }));
        } catch (e) {
          console.warn(e);
        }

        this.reload = false;
      });

      function reloadSelect2Inputs() {
        return _ref10.apply(this, arguments);
      }

      return reloadSelect2Inputs;
    }()
  },
  watch: {
    autofilter: function autofilter() {
      var bool = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      this.state.autofilter.value = Number(bool);
    }
  },

  created: function () {
    var _ref11 = _asyncToGenerator(function* () {
      var _this6 = this;

      this.state.search_layers.forEach(function (l) {
        return l.on('filtertokenchange', _this6.reloadSelect2Inputs);
      });
    });

    function created() {
      return _ref11.apply(this, arguments);
    }

    return created;
  }(),
  mounted: function () {
    var _ref12 = _asyncToGenerator(function* () {
      yield Promise.allSettled([this.$nextTick(), this.state.mounted]);
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = this.state.forminputs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var input = _step.value;

          yield this.initSelect2Field(input);
          yield this.initDateTimeField(input);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    });

    function mounted() {
      return _ref12.apply(this, arguments);
    }

    return mounted;
  }(),
  beforeDestroy: function beforeDestroy() {
    var _this7 = this;

    this.state.search_layers.forEach(function (l) {
      return l.off('filtertokenchange', _this7.reloadSelect2Inputs);
    });
    this.clearSelect2();
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"disabled",rawName:"v-disabled",value:(_vm.state.searching || _vm.loading || _vm.reload),expression:"state.searching || loading || reload"}],staticClass:"g3w-search-panel form-group"},[_c('bar-loader',{attrs:{"loading":_vm.state.searching || _vm.loading || _vm.reload}}),_vm._v(" "),_c('h4',[_c('b',[_vm._v(_vm._s(_vm.state.title))])]),_vm._v(" "),(_vm.filterlayers.length > 0)?_c('section',{staticStyle:{"display":"flex","justify-content":"space-between"},attrs:{"id":"g3w-search-filter-layers"}},[_c('helpdiv',{attrs:{"message":"sdk.search.help_filter"}}),_vm._v(" "),_c('button',{directives:[{name:"t-tooltip",rawName:"v-t-tooltip:left.create",value:('layer_selection_filter.tools.nofilter'),expression:"'layer_selection_filter.tools.nofilter'",arg:"left",modifiers:{"create":true}}],staticClass:"btn skin-border-color",staticStyle:{"background-color":"transparent","margin":"5px 0"},on:{"click":function($event){$event.stopPropagation();return _vm.clearFilters($event)}}},[_c('i',{staticClass:"skin-color",class:_vm.$fa('clear')})])],1):_vm._e(),_vm._v(" "),_vm._t("tools"),_vm._v(" "),_vm._t("form",[_c('form',{staticClass:" g3w-search-form"},[_vm._l((_vm.state.forminputs),function(input){return _c('div',{key:input.id,staticClass:"form-group"},[('numberfield' === input.type || ('textfield' === input.type && 'Range' === input.widget_type))?_c('div',{staticClass:"numeric"},[_c('label',{staticClass:"search-label",attrs:{"for":input.id}},[_c('span',[_vm._v(_vm._s(input.label || input.attribute))]),_vm._v(" "),_c('span',{staticClass:"skin-color"},[_vm._v(_vm._s(_vm.getLabelOperator(input.operator)))])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(input.value),expression:"input.value"}],staticClass:"form-control",attrs:{"type":"number","min":"0","id":input.id},domProps:{"value":(input.value)},on:{"change":function($event){return _vm.changeInput(input)},"input":[function($event){if($event.target.composing){ return; }_vm.$set(input, "value", $event.target.value)},function($event){return _vm.changeInput(input)}]}})]):(['textfield', 'textField'].includes(input.type))?_c('div',{staticClass:"form-item-search text"},[_c('label',{staticClass:"search-label",attrs:{"for":input.id}},[_c('span',[_vm._v(_vm._s(input.label || input.attribute))]),_vm._v(" "),_c('span',{staticClass:"skin-color"},[_vm._v(_vm._s(_vm.getLabelOperator(input.operator)))])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(input.value),expression:"input.value"}],staticClass:"form-control",attrs:{"type":"text","id":input.id},domProps:{"value":(input.value)},on:{"focus":_vm.onFocus,"change":function($event){return _vm.changeInput(input)},"input":function($event){if($event.target.composing){ return; }_vm.$set(input, "value", $event.target.value)}}})]):(['selectfield', 'autocompletefield'].includes(input.type))?_c('div',{directives:[{name:"disabled",rawName:"v-disabled",value:(_vm.state.loading[input.dependance] || input.loading || input.disabled),expression:"state.loading[input.dependance] || input.loading || input.disabled"}],staticClass:"text"},[_c('label',{staticClass:"search-label",attrs:{"for":input.id}},[_c('span',[_vm._v(_vm._s(input.label || input.attribute))]),_vm._v(" "),_c('span',{staticClass:"skin-color"},[_vm._v(_vm._s(_vm.getLabelOperator(input.operator)))])]),_vm._v(" "),(input.dependance)?_c('bar-loader',{attrs:{"loading":_vm.state.loading[input.dependance] || input.loading}}):_vm._e(),_vm._v(" "),_c('select',{directives:[{name:"disabled",rawName:"v-disabled",value:(input.disabled || input.loading),expression:"input.disabled || input.loading"}],staticClass:"form-control",attrs:{"name":input.attribute,"id":input.id}},_vm._l((input.values),function(opt){return _c('option',{key:opt.value,domProps:{"value":opt.value}},[(_vm.allvalue === opt.value)?_c('span',{directives:[{name:"t",rawName:"v-t",value:('sdk.search.all'),expression:"'sdk.search.all'"}]}):_c('span',[_vm._v(_vm._s(opt.key))])])}),0)],1):('datetimefield' === input.type)?_c('div',{directives:[{name:"disabled",rawName:"v-disabled",value:(_vm.state.loading[input.dependance] || false),expression:"state.loading[input.dependance] || false"}],staticClass:"text"},[_c('label',{staticClass:"search-label",attrs:{"for":input.id}},[_c('span',[_vm._v(_vm._s(input.label || input.attribute))]),_vm._v(" "),_c('span',{staticClass:"skin-color"},[_vm._v(_vm._s(_vm.getLabelOperator(input.operator)))])]),_vm._v(" "),_c('div',{ref:'date_' + input.id,refInFor:true,staticClass:"input-group date"},[_c('input',{staticClass:"form-control",attrs:{"id":input.id,"type":"text"}}),_vm._v(" "),_c('span',{staticClass:"input-group-addon skin-color"},[_c('span',{class:_vm.$fa(input.options.format.time ? 'time': 'calendar')})])])]):_vm._e(),_vm._v(" "),_c('sub',[_vm._v(_vm._s(input.options.description))]),_vm._v(" "),(_vm.is_staff)?_c('details',{staticStyle:{"cursor":"pointer","user-select":"none","margin-top":".5em"}},[_c('ul',{staticStyle:{"font-size":"80%","padding-left":"15px","font-family":"monospace","white-space":"nowrap","overflow-x":"auto","scrollbar-width":"thin"}},[_c('li',[_c('b',{staticClass:"skin-color"},[_vm._v(_vm._s(input.type))])]),_vm._v(" "),_c('li',[_c('b',{staticClass:"skin-color"},[_vm._v(_vm._s(input.widget_type))]),(input.options.value)?_c('span',[_vm._v(": {"),_c('br'),_vm._v("  key: \""+_vm._s(input.options.key)+"\","),_c('br'),_vm._v("  value: \""+_vm._s(input.options.value)+"\""),_c('br'),_vm._v("}")]):_vm._e()]),_vm._v(" "),(input.options.layer_id)?_c('li',[_c('b',{staticClass:"skin-color"},[_vm._v("layer_id:")]),_vm._v(" \""+_vm._s(input.options.layer_id)+"\"")]):_vm._e(),_vm._v(" "),(input.dependance)?_c('li',[_c('b',{staticClass:"skin-color"},[_vm._v("depends_on:")]),_vm._v(" \""+_vm._s(input.dependance)+"\"")]):_vm._e(),_vm._v(" "),(input.dependance)?_c('li',[_c('b',{staticClass:"skin-color"},[_vm._v("strict:")]),_vm._v(" "+_vm._s(input.dependance_strict))]):_vm._e()])]):_vm._e(),_vm._v(" "),(input.logicop)?_c('div',{staticClass:"search-logicop skin-border-color"},[_c('h4',[_vm._v(_vm._s(input.logicop))])]):_vm._e()])}),_vm._v(" "),_c('div',{directives:[{name:"disabled",rawName:"v-disabled",value:('data' !== _vm.state.return),expression:"'data' !== state.return"}],staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.autofilter),expression:"autofilter"}],staticClass:"magic-checkbox",attrs:{"id":"g3w-search-filter","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.autofilter)?_vm._i(_vm.autofilter,null)>-1:(_vm.autofilter)},on:{"change":function($event){var $$a=_vm.autofilter,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.autofilter=$$a.concat([$$v]))}else{$$i>-1&&(_vm.autofilter=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.autofilter=$$c}}}}),_vm._v(" "),_c('label',{directives:[{name:"t",rawName:"v-t",value:('sdk.search.autofilter'),expression:"'sdk.search.autofilter'"}],attrs:{"for":"g3w-search-filter"}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('button',{directives:[{name:"t",rawName:"v-t",value:('dosearch'),expression:"'dosearch'"}],staticClass:"sidebar-button-run btn btn-block pull-right",attrs:{"id":"dosearch","data-i18n":"dosearch"},on:{"click":function($event){$event.stopPropagation();return _vm.doSearch($event)}}})])],2)]),_vm._v(" "),_vm._t("footer"),_vm._v(" "),(_vm.layers_url)?_c('div',{staticStyle:{"padding-top":"5em"}},[_c('b',[_c('a',{attrs:{"href":_vm.layers_url,"target":"_blank"}},[_vm._v("Edit in admin")])])]):_vm._e()],2)}
__vue__options__.staticRenderFns = []
__vue__options__._scopeId = "data-v-aa9afcb0"

},{"g3w-constants":159,"g3w-i18n":162,"mixins/resize":202,"store/application":212,"utils/convertQGISDateTimeFormatToMoment":221,"utils/createSingleFieldParameter":230,"utils/getDataForSearchInput":240,"vueify/lib/insert-css":35}],141:[function(require,module,exports){
;(function(){
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _application = require("store/application");

var _application2 = _interopRequireDefault(_application);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: "SidebarItem",
  data: function data() {
    var component = this.$options.component;

    return {
      info: component.info || { state: null, style: null, class: null },
      main: true,
      component: component,
      active: false,
      title: component.title || '',
      open: !!component.state.open,
      icon: component.icon,
      iconColor: component.iconColor,
      collapsible: false !== component.collapsible,
      actions: component.actions,
      sidebar: _application2.default.gui.sidebar
    };
  },

  methods: {
    triggerAction: function triggerAction(action, component) {
      action.fnc(component);
    }
  },

  mounted: function mounted() {
    var _this = this;

    var opts = this.$options.opts || {};
    var sidebar = document.getElementById('g3w-sidebarcomponents');

    if ([null, undefined].includes(opts.position) || opts.position < 0 || opts.position >= sidebar.children.length) {
      $(sidebar).append(this.$el);
    } else {
        Array.from(sidebar.children).forEach(function (child, i) {
          if (i === opts.position || child.id === opts.position) {
            child.insertAdjacentElement(!!opts.before || undefined === opts.before ? 'beforebegin' : 'afterend', _this.$el);
          }
        });
      }

    this.component.mount(this.$refs['component-placeholder']);

    this.component.click = function () {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref$open = _ref.open,
          open = _ref$open === undefined ? false : _ref$open;

      if (open) {
        _application2.default.sidebar.components.forEach(function (comp) {
          if (comp !== _this.component && comp.getOpen()) {
            comp.click({ open: false });
          }
        });
      }
      var node = _this.component.getInternalComponent().$el;

      if (node.classList) {
        node.classList.toggle('menu-open', open);
      }

      node.parentNode.classList.toggle('active', open);

      _this.component.setOpen(open);
    };
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.component.state.visible),expression:"component.state.visible"},{name:"disabled",rawName:"v-disabled",value:(_vm.component.state.disabled),expression:"component.state.disabled"}],staticClass:"treeview sidebaritem",class:{'active': _vm.open },attrs:{"id":_vm.component.id}},[_c('bar-loader',{attrs:{"loading":_vm.component.state.loading}}),_vm._v(" "),_c('a',{directives:[{name:"t-tooltip",rawName:"v-t-tooltip:right.create",value:(_vm.sidebar.open ? '' : _vm.title),expression:"sidebar.open ? '' : title",arg:"right",modifiers:{"create":true}}],staticStyle:{"display":"flex","justify-content":"space-between","align-items":"center"},attrs:{"href":"#","current-tooltip":_vm.sidebar.open ? '' : _vm.title}},[_c('div',[(!_vm.sidebar.open)?_c('span',[_c('i',{class:_vm.icon,style:({ color: _vm.iconColor })})]):_c('i',{class:_vm.icon,style:({ color: _vm.iconColor })}),_vm._v(" "),_c('span',{directives:[{name:"t",rawName:"v-t",value:(_vm.title),expression:"title"}],staticClass:"treeview-label"})]),_vm._v(" "),_c('div',[(_vm.info.state)?_c('span',{class:_vm.info.class,staticStyle:{"position":"absolute","right":"5px","font-weight":"bold"},style:(_vm.info.style),attrs:{"title":_vm.info.tooltip}},[_vm._v(_vm._s(_vm.info.state))]):_vm._e(),_vm._v(" "),_vm._l((_vm.actions),function(action){return _c('span',{directives:[{name:"t-tooltip",rawName:"v-t-tooltip:left.create",value:(action.tooltip),expression:"action.tooltip",arg:"left",modifiers:{"create":true}}],key:action.id,staticClass:"action skin-tooltip-left",class:action.class,staticStyle:{"font-weight":"bold","padding":"3px"},style:(action.style),on:{"click":function($event){$event.stopPropagation();return _vm.triggerAction(action, _vm.component.internalComponent)}}})})],2),_vm._v(" "),(_vm.collapsible)?_c('i',{staticClass:"pull-right",class:_vm.$fa('angle-left')}):_vm._e()]),_vm._v(" "),_c('div',{ref:"component-placeholder"})],1)}
__vue__options__.staticRenderFns = []

},{"store/application":212}],142:[function(require,module,exports){
var __vueify_style_dispose__ = require("vueify/lib/insert-css").insert(".content-bookmarks{font-weight:700;color:#fff;padding:5px;border-bottom:1px solid #fff;margin-bottom:2px}.spatial-bookmark{display:flex;align-items:baseline;justify-content:space-between;padding:5px!important}")
;(function(){
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _g3wConstants = require('g3w-constants');

var _application = require('store/application');

var _application2 = _interopRequireDefault(_application);

var _gui = require('services/gui');

var _gui2 = _interopRequireDefault(_gui);

var _projections = require('store/projections');

var _projections2 = _interopRequireDefault(_projections);

var _InputText = require('components/InputText.vue');

var _InputText2 = _interopRequireDefault(_InputText);

var _getUniqueDomId = require('utils/getUniqueDomId');

var _g3wI18n = require('g3w-i18n');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var item = window.localStorage.getItem(_g3wConstants.LOCAL_ITEM_IDS.SPATIALBOOKMARKS.id);
var SPATIAL_BOOKMARKS_LOCALITEMS = item ? JSON.parse(item) : undefined;

exports.default = {
  name: 'spatial-bookmarks',

  components: {
    InputText: _InputText2.default
  },

  data: function data() {
    var project = _application2.default.project;

    if (undefined === SPATIAL_BOOKMARKS_LOCALITEMS[project.getId()]) {
      SPATIAL_BOOKMARKS_LOCALITEMS[project.getId()] = [];
    }

    return {
      showaddform: false,

      project: {
        bookmarks: project.state.bookmarks || []
      },

      user: {
        bookmarks: SPATIAL_BOOKMARKS_LOCALITEMS[project.getId()]
      },

      addbookmarkinput: {
        name: 'add-bookmark',
        label: (0, _g3wI18n.t)('sdk.spatialbookmarks.input.name'),
        i18nLabel: true,
        value: null,
        editable: true,
        type: 'varchar',
        input: { type: 'text', options: {} },
        visible: true,
        validate: { valid: false, required: true }
      }
    };
  },


  computed: {
    is_staff: function is_staff() {
      return window.initConfig.user.is_staff;
    },
    lang: function lang() {
      return _application2.default.language;
    }
  },

  methods: {
    addBookMark: function addBookMark() {
      this.user.bookmarks.push({
        id: (0, _getUniqueDomId.getUniqueDomId)(),
        name: this.addbookmarkinput.value,
        extent: _gui2.default.getService('map').getMapExtent(),
        removable: true,
        crs: { epsg: 1 * _gui2.default.getService('map').getCrs().split('EPSG:')[1] }
      });

      this.saveUserBookMarks();
      this.showaddform = false;
    },
    removeBookMark: function removeBookMark(id) {
      this.user.bookmarks = this.user.bookmarks.filter(function (b) {
        return id !== b.id;
      });
      this.saveUserBookMarks();
    },
    saveUserBookMarks: function saveUserBookMarks() {
      SPATIAL_BOOKMARKS_LOCALITEMS[_application2.default.project.getId()] = this.user.bookmarks;
      try {
        window.localStorage.setItem(_g3wConstants.LOCAL_ITEM_IDS.SPATIALBOOKMARKS.id, JSON.stringify(SPATIAL_BOOKMARKS_LOCALITEMS));
      } catch (e) {
        console.warn(e);
      }
    },
    showAddForm: function showAddForm() {
      this.addbookmarkinput.value = null;
      this.showaddform = true;
    },
    gotoSpatialBookmark: function () {
      var _ref2 = _asyncToGenerator(function* (_ref) {
        var extent = _ref.extent,
            crs = _ref.crs;

        if (crs.epsg !== _gui2.default.getService('map').getEpsg().split('EPSG:')[1]) {
          var projection = yield _projections2.default.registerProjection('EPSG:' + crs.epsg);
          extent = ol.proj.transformExtent(extent, projection, _gui2.default.getService('map').getProjection());
        }

        _gui2.default.getService('map').zoomToExtent(extent, { force: true });
      });

      function gotoSpatialBookmark(_x) {
        return _ref2.apply(this, arguments);
      }

      return gotoSpatialBookmark;
    }()
  },

  watch: {
    showaddform: function () {
      var _ref3 = _asyncToGenerator(function* (bool) {
        if (bool) {
          yield this.$nextTick();

          for (var i = 0; i < this.$refs.add_bookmark_input.$el.children.length; i++) {
            this.$refs.add_bookmark_input.$el.children[i].classList.remove('col-sm-12');
          }
        }
      });

      function showaddform(_x2) {
        return _ref3.apply(this, arguments);
      }

      return showaddform;
    }()
  },

  created: function created() {
    var _this = this;

    this.$on('close', function () {
      return _this.showaddform = false;
    });
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"treeview-menu g3w-spatial-bookmarks menu-items",class:{'g3w-tools': !_vm.showaddform},attrs:{"id":"g3w-spatial-bookmarks"}},[(_vm.showaddform)?_c('li',[_c('div',{staticStyle:{"display":"flex","justify-content":"end"}},[_c('span',{directives:[{name:"t-tooltip",rawName:"v-t-tooltip:left.create",value:('close'),expression:"'close'",arg:"left",modifiers:{"create":true}}],staticClass:"sidebar-button sidebar-button-icon",class:_vm.$fa('close'),staticStyle:{"padding":"5px","margin":"3px"},on:{"click":function($event){$event.stopPropagation();_vm.showaddform = false}}})]),_vm._v(" "),_c('helpdiv',{attrs:{"message":"sdk.spatialbookmarks.helptext"}}),_vm._v(" "),_c('div',{staticClass:"container add-bookmark-input",staticStyle:{"padding":"5px","width":"100%"}},[_c('input-text',{ref:"add_bookmark_input",attrs:{"state":_vm.addbookmarkinput}})],1),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"5px"}},[_c('button',{directives:[{name:"t",rawName:"v-t",value:('add'),expression:"'add'"},{name:"disabled",rawName:"v-disabled",value:(!_vm.addbookmarkinput.validate.valid),expression:"!addbookmarkinput.validate.valid"}],staticClass:"sidebar-button-run btn btn-block",on:{"click":function($event){$event.stopPropagation();return _vm.addBookMark($event)}}})])],1):[(_vm.is_staff)?_c('div',{staticClass:"content-bookmarks"},[_c('span',{directives:[{name:"t",rawName:"v-t",value:('sdk.spatialbookmarks.sections.project.title'),expression:"'sdk.spatialbookmarks.sections.project.title'"}]}),_vm._v(" "),_c('a',{staticStyle:{"float":"right"},attrs:{"href":("https://docs.qgis.org/3.34/" + _vm.lang + "/docs/user_manual/map_views/map_view.html#bookmarking-extents-on-the-map"),"target":"_blank","title":"QGIS Docs"}},[_c('i',{class:_vm.$fa('external-link')})])]):_vm._e(),_vm._v(" "),_vm._l((_vm.project.bookmarks),function(bookmark){return [(bookmark.nodes)?_c('li',[_c('div',{staticStyle:{"font-weight":"bold","width":"100%"},style:({ borderBottom: bookmark.expanded ? '2px solid #2c3b41' : 'none' }),on:{"click":function($event){$event.stopPropagation();bookmark.expanded = !bookmark.expanded}}},[_c('span',{class:_vm.$fa(bookmark.expanded ? 'caret-down' : 'caret-right'),staticStyle:{"margin-right":"5px"}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(bookmark.name))])]),_vm._v(" "),_c('ul',{directives:[{name:"show",rawName:"v-show",value:(bookmark.expanded),expression:"bookmark.expanded"}],staticStyle:{"margin-left":"10px"}},_vm._l((bookmark.nodes),function(node){return _c('li',{staticClass:"spatial-bookmark",on:{"click":function($event){$event.stopPropagation();return _vm.gotoSpatialBookmark(node)}}},[_c('div',[_c('span',{class:_vm.$fa('bookmark'),staticStyle:{"margin-right":"5px","font-size":"0.7em"}}),_vm._v(" "),_c('span',{staticClass:"g3w-long-text"},[_vm._v(_vm._s(node.name))])])])}),0)]):_c('li',{staticClass:"spatial-bookmark",on:{"click":function($event){$event.stopPropagation();return _vm.gotoSpatialBookmark(bookmark)}}},[_c('div',[_c('span',{class:_vm.$fa('bookmark'),staticStyle:{"margin-right":"5px","font-size":"0.7em"}}),_vm._v(" "),_c('span',{staticClass:"g3w-long-text"},[_vm._v(_vm._s(bookmark.name))])])])]}),_vm._v(" "),_c('div',{staticClass:"content-bookmarks",staticStyle:{"display":"flex","justify-content":"space-between","align-items":"center","margin-top":"10px"}},[_c('span',{directives:[{name:"t",rawName:"v-t",value:('sdk.spatialbookmarks.sections.user.title'),expression:"'sdk.spatialbookmarks.sections.user.title'"}]}),_vm._v(" "),_c('span',{directives:[{name:"t-tooltip",rawName:"v-t-tooltip:left.create",value:('add'),expression:"'add'",arg:"left",modifiers:{"create":true}}],staticClass:"sidebar-button sidebar-button-icon",class:_vm.$fa('plus'),staticStyle:{"padding":"5px","cursor":"pointer"},on:{"click":function($event){$event.stopPropagation();return _vm.showAddForm($event)}}})]),_vm._v(" "),_vm._l((_vm.user.bookmarks),function(bookmark){return _c('li',{staticClass:"spatial-bookmark",on:{"click":function($event){$event.stopPropagation();return _vm.gotoSpatialBookmark(bookmark)}}},[_c('div',[_c('span',{class:_vm.$fa('bookmark'),staticStyle:{"margin-right":"5px","font-size":"0.7em"}}),_vm._v(" "),_c('span',{staticClass:"g3w-long-text"},[_vm._v(_vm._s(bookmark.name))])]),_vm._v(" "),_c('span',{staticClass:"sidebar-button sidebar-button-icon",staticStyle:{"color":"red","margin":"5px","cursor":"pointer"},on:{"click":function($event){$event.stopPropagation();return _vm.removeBookMark(bookmark.id)}}},[_c('i',{class:_vm.$fa('trash')})])])})]],2)}
__vue__options__.staticRenderFns = []

},{"components/InputText.vue":111,"g3w-constants":159,"g3w-i18n":162,"services/gui":207,"store/application":212,"store/projections":214,"utils/getUniqueDomId":252,"vueify/lib/insert-css":35}],143:[function(require,module,exports){
var __vueify_style_dispose__ = require("vueify/lib/insert-css").insert("#open_attribute_table{margin-top:5px}#g3w-table-toolbar{margin:.755em 1ch 0 0;position:relative;bottom:3px;display:inline-flex;border:1px solid #d2d6de;background-color:#fff;float:left}\n.geometry[data-v-ff0ad38c]{cursor:pointer}#noheaders[data-v-ff0ad38c]{background-color:#fff;font-weight:700;margin-top:10px}input.form-control.column-search[data-v-ff0ad38c]::placeholder{font-weight:400;font-style:italic}input.form-control.column-search[data-v-ff0ad38c]{height:25px;min-width:40px;padding:2px}#open_attribute_table .action-button[data-v-ff0ad38c]{padding:5px}#g3w-table-toolbar .action-button[data-v-ff0ad38c]{padding:4px}#g3w-table-toolbar .action-button.toggled[data-v-ff0ad38c]{color:#fff!important;background-color:var(--skin-color)}#layer_attribute_table[data-v-ff0ad38c]{width:100%;user-select:none}#layer_attribute_table>tbody>tr[data-v-ff0ad38c]:not(.selected):hover{background-color:rgba(255,255,0,.15)}label[for=attribute_table_select_all_rows][data-v-ff0ad38c]{margin-bottom:0!important}\n#g3w-view-content .dataTables_filter{margin-left:auto;margin-right:1ch}#g3w-view-content .dataTables_info{padding-left:.5ch;font-weight:lighter}#open_attribute_table .paginate_button{background:transparent;color:currentColor!important;box-shadow:none}#open_attribute_table .paginate_button.disabled{opacity:.25}#open_attribute_table #layer_attribute_table_length{padding-top:.755em}")
;(function(){
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _g3wConstants = require('g3w-constants');

var _g3wComponent = require('g3w-component');

var _g3wComponent2 = _interopRequireDefault(_g3wComponent);

var _application = require('store/application');

var _application2 = _interopRequireDefault(_application);

var _FieldG3W = require('components/FieldG3W.vue');

var _FieldG3W2 = _interopRequireDefault(_FieldG3W);

var _gui = require('services/gui');

var _gui2 = _interopRequireDefault(_gui);

var _data = require('services/data');

var _data2 = _interopRequireDefault(_data);

var _mixins = require('mixins');

var _debounce = require('utils/debounce');

var _coordinatesToGeometry = require('utils/coordinatesToGeometry');

var _getUniqueDomId = require('utils/getUniqueDomId');

var _promisify = require('utils/promisify');

var _getCatalogLayerById = require('utils/getCatalogLayerById');

var _g3wI18n = require('g3w-i18n');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _createFeatureForSelection(f) {
  return {
    id: f.id,
    feature: {
      attributes: f.attributes || f.properties,
      geometry: f.geometry ? (0, _coordinatesToGeometry.coordinatesToGeometry)(f.geometry.type, f.geometry.coordinates) : f.geometry
    }
  };
}

exports.default = {

  name: "G3WTable",

  mixins: [_mixins.resizeMixin],

  components: {
    Field: _FieldG3W2.default
  },

  data: function data() {
    var layer = (0, _getCatalogLayerById.getCatalogLayerById)(this.$options.layerId);

    return {
      layer: layer,
      state: {
        features: [],
        headers: [null].concat(_toConsumableArray(layer.getTableHeaders())),
        geometry: true,
        allfeatures: 0,
        selectAll: false,
        nofilteredrow: false,
        show_tools: false,
        geolayer: {
          active: false,
          in_bbox: undefined
        }
      },

      relations: (layer.isGeoLayer() ? [] : layer.getRelations().getArray()).map(function (relation) {
        return [relation, (0, _getCatalogLayerById.getCatalogLayerById)(relation.getFather())];
      }).filter(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            relation = _ref2[0],
            father = _ref2[1];

        return layer.getId() !== relation.getFather() && father.isGeoLayer();
      }).map(function (_ref3) {
        var _ref4 = _slicedToArray(_ref3, 2),
            relation = _ref4[0],
            father = _ref4[1];

        return {
          layer: father,
          father_fields: relation.getFatherField(),
          fields: relation.getChildField(),
          features: {}
        };
      }),
      filter: [],
      has_map: true,
      async_highlight: function async_highlight() {},
      getAll: false,
      search: {},
      firstCall: true,
      map_bbox: { key: null, cb: null },
      disableSelectAll: false
    };
  },


  computed: {
    has_features: function has_features() {
      return !!this.state.features.length;
    },
    current_layout: function current_layout() {
      return _application2.default.gui.layout[_application2.default.gui.layout.__current];
    }
  },

  methods: {
    toggleFilterToken: function toggleFilterToken(layer) {
      if (layer.state.filter.active && !layer.selectionFids.has('__ALL__')) {
        this.state.selectAll = false;
        this.selectAllRows();
      }
      layer.toggleFilterToken();
    },
    editFeature: function editFeature(feature) {
      $('.tooltip').remove();
      _gui2.default.getService('queryresults').editFeature({ layer: { id: this.layer.getId() }, feature: feature });
    },
    openForm: function () {
      var _ref5 = _asyncToGenerator(function* (feature) {
        $('.tooltip').remove();
        try {
          yield (0, _promisify.promisify)(_data2.default.getData('search:fids', {
            inputs: {
              layer: this.layer,
              fids: [feature.id],
              formatter: 1
            }
          }));

          if (feature.geometry) {
            _gui2.default.getService('map').zoomToGeometry((0, _coordinatesToGeometry.coordinatesToGeometry)(feature.geometry.type, feature.geometry.coordinates));
          }
        } catch (e) {
          console.warn(e);
        }
      });

      function openForm(_x) {
        return _ref5.apply(this, arguments);
      }

      return openForm;
    }(),
    get_check_id: function get_check_id(cache) {
      if (cache) {
        this.get_check_id.cached_id = (0, _getUniqueDomId.getUniqueDomId)();
      }
      return this.get_check_id.cached_id;
    },
    getDataFromBBOX: function () {
      var _ref6 = _asyncToGenerator(function* () {
        var _this = this;

        var map = _gui2.default.getService('map');

        this.state.geolayer.active = !this.state.geolayer.active;

        var is_active = this.state.geolayer.active;

        if (is_active) {
          this.map_bbox.cb = function () {
            _this.state.geolayer.in_bbox = _this.state.geolayer.active ? map.getMapBBOX().join(',') : undefined;
            $(_this.$refs.attribute_table).DataTable().ajax.reload();
          };
        }

        if (is_active) {
          this.map_bbox.key = map.getMap().on('moveend', this.map_bbox.cb);
        }

        if (this.map_bbox.cb) {
          this.map_bbox.cb();
        }

        if (!is_active) {
          ol.Observable.unByKey(this.map_bbox.key);
          this.map_bbox.key = null;
          this.map_bbox.cb = null;
        }
      });

      function getDataFromBBOX() {
        return _ref6.apply(this, arguments);
      }

      return getDataFromBBOX;
    }(),
    checkSelectAll: function checkSelectAll() {
      this.state.selectAll = this.layer.getSelectionFids().has(_g3wConstants.SELECTION.ALL) || this.state.features.every(function (f) {
        return f.selected;
      });
    },
    inverseSelection: function () {
      var _ref7 = _asyncToGenerator(function* () {
        if (!this.getAll) {
          yield this.getFeatures();
        }
        this.state.features.forEach(function (f) {
          return f.selected = !f.selected;
        });
        this.layer.invertSelectionFids();

        this.checkSelectAll();
      });

      function inverseSelection() {
        return _ref7.apply(this, arguments);
      }

      return inverseSelection;
    }(),
    selectAllRows: function () {
      var _ref8 = _asyncToGenerator(function* () {
        var _this2 = this;

        this.state.selectAll = !this.state.selectAll;

        var filter = this.filter.length > 0;

        if (!filter) {
          if (!this.getAll) {
            yield this.getFeatures();
          }
          this.state.features.forEach(function (f) {
            return f.selected = _this2.state.selectAll;
          });
          yield this.layer[this.state.selectAll ? 'setSelectionFidsAll' : 'clearSelectionFids']();
        }

        if (filter) {
          if (this.state.selectAll) {
            this.state.features.filter(function (f) {
              return _this2.filter.includes(f.id);
            }).forEach(function (f) {
              f.selected = true;
              _this2.layer.includeSelectionFid(f.id);
            });
          } else {
            this.state.features.forEach(function (f) {
              return f.selected = false;
            });
            this.layer.clearSelectionFids();
          }
        }

        this.state.show_tools = this.state.features.some(function (f) {
          return f.selected;
        });
      });

      function selectAllRows() {
        return _ref8.apply(this, arguments);
      }

      return selectAllRows;
    }(),
    highlight: function () {
      var _ref9 = _asyncToGenerator(function* (feature) {
        var _this3 = this;

        var zoom = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

        var map = _gui2.default.getService('map');

        if (!feature || !feature.geometry) {
          return map.clearHighlightGeometry();
        }

        this.async_highlight = function () {
          map.clearHighlightGeometry();
          map.highlightGeometry(feature.geometry, { zoom: zoom, duration: Infinity });
        };

        if (feature.geometry && this.has_map) {
          return this.async_highlight();
        }

        if (feature.geometry || !feature.geometry && !this.relations.length > 0) {
          return;
        }

        var features = [];
        var field_values = [];

        (yield Promise.allSettled(this.relations.flatMap(function (_ref10) {
          var layer = _ref10.layer,
              father_fields = _ref10.father_fields,
              fields = _ref10.fields;

          var values = fields.map(function (f) {
            return feature.attributes[f];
          });
          field_values.push(values);
          return zoom ? _data2.default.getData('search:features', {
            inputs: {
              layer: layer,
              formatter: 1,
              filter: father_fields.map(function (field, i) {
                return field + '|eq|' + encodeURIComponent(values[i]);
              }).join('|AND,')
            },
            outputs: false }) : [];
        }))).forEach(function (response, index) {
          if ('fulfilled' === response.status) {
            var relation = _this3.relations[index];
            var k = field_values[index].join('__');
            var data = response.value && response.value.data[0];
            if (undefined === relation.features[k]) {
              relation.features[k] = data && data.features || [];
            }
            features.push.apply(features, _toConsumableArray(relation.features[k]));
          }
          if (zoom) {
            map.zoomToFeatures(features, { highlight: true });
          } else {
            map.highlightFeatures(features);
          }
        });
      });

      function highlight(_x3) {
        return _ref9.apply(this, arguments);
      }

      return highlight;
    }(),
    select: function select(feature) {
      feature.selected = !feature.selected;

      this.state.selectAll = this.state.features.every(function (f) {
        return f.selected;
      });

      this.layer[feature.selected ? 'includeSelectionFid' : 'excludeSelectionFid'](feature.id);

      this.state.show_tools = this.layer.getSelectionFids().size > 0;
    },
    resize: function () {
      var _ref11 = _asyncToGenerator(function* () {
        yield this.$nextTick();
        var table = this.$el.querySelector('div.dataTables_scrollBody');
        if (table) {
          table.style.height = _gui2.default.isMobile() ? '100%' : ((document.querySelector('.content') || {}).clientHeight || 0) - ((this.$el.querySelector('div.dataTables_scrollHeadInner') || {}).clientHeight || 0) - 100 + 'px';
        }

        $(this.$refs.attribute_table).DataTable().columns.adjust();
      });

      function resize() {
        return _ref11.apply(this, arguments);
      }

      return resize;
    }(),
    getFeatures: function () {
      var _ref12 = _asyncToGenerator(function* (params) {
        var _this4 = this;

        try {
          _gui2.default.setLoadingContent(true);

          var data = yield (0, _promisify.promisify)(this.layer.getDataTable(params || {}));
          var is_valid = this.layer.isGeoLayer() && data.features;

          if (is_valid && !params) {
            var loaded_features = this.state.features.map(function (f) {
              return f.id;
            });
            data.features.filter(function (f) {
              return f.geometry && !loaded_features.includes(f.id);
            }).forEach(function (f) {
              return _this4.layer.addOlSelectionFeature(_createFeatureForSelection(f));
            });
            this.getAll = true;
          }

          if (is_valid) {
            return data.features;
          }
        } catch (e) {
          console.warn(e);
          return Promise.reject();
        } finally {
          _gui2.default.setLoadingContent(false);
        }
      });

      function getFeatures(_x4) {
        return _ref12.apply(this, arguments);
      }

      return getFeatures;
    }(),
    getData: function () {
      var _ref13 = _asyncToGenerator(function* () {
        var _this5 = this;

        var _ref14 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            _ref14$start = _ref14.start,
            start = _ref14$start === undefined ? 0 : _ref14$start,
            _ref14$order = _ref14.order,
            order = _ref14$order === undefined ? [] : _ref14$order,
            _ref14$length = _ref14.length,
            length = _ref14$length === undefined ? this.layer.getAttributeTablePageLength() || _g3wConstants.PAGELENGTHS[1] : _ref14$length,
            _ref14$columns = _ref14.columns,
            columns = _ref14$columns === undefined ? [] : _ref14$columns,
            _ref14$search = _ref14.search,
            search = _ref14$search === undefined ? { value: null } : _ref14$search;

        _gui2.default.setLoadingContent(true);

        this.layer.setAttributeTablePageLength(length);

        if (0 === this.state.headers.length) {
          return {
            data: [],
            recordsTotal: 0,
            recordsFiltered: 0
          };
        }

        this.state.features.splice(0);

        if (0 === order.length) {
          order.push({ column: 1, dir: 'asc' });
        }

        this.search = {
          field: columns.filter(function (c) {
            return c.search && c.search.value;
          }).map(function (c) {
            return c.name + '|ilike|' + c.search.value + '|and';
          }).join(',') || undefined,
          page: start === 0 || this.layer.state.filter.active ? 1 : start / length + 1,
          page_size: length,
          search: search.value && search.value.length > 0 ? search.value : null,
          in_bbox: this.state.geolayer.in_bbox,
          ordering: ('asc' === order[0].dir ? '' : '-') + this.state.headers[order[0].column].name,
          formatter: 1
        };

        try {
          var _state$features;

          var data = yield (0, _promisify.promisify)(this.layer.getDataTable(this.search));

          this.state.allfeatures = data.count;
          this.state.featurescount = (data.features || []).length;

          (_state$features = this.state.features).push.apply(_state$features, _toConsumableArray((data.features || []).map(function (f) {
            if (_this5.layer.isGeoLayer() && f.geometry && !_this5.layer.getOlSelectionFeature(f.id)) {
              _this5.layer.addOlSelectionFeature(_createFeatureForSelection(f));
            }
            return {
              id: f.id,
              selected: _this5.layer.getFilterToken() || _this5.layer.hasSelectionFid(f.id),
              attributes: f.attributes || f.properties,
              geometry: _this5.layer.isGeoLayer() && f.geometry || undefined
            };
          })));

          this.state.show_tools = this.layer.state.filter.active || this.layer.getSelectionFids().size > 0;
          this.state.selectAll = this.layer.state.filter.active || this.state.features.every(function (f) {
            return f.selected;
          });
          return {
            data: this.state.features.map(function (f) {
              return [null].concat(_this5.state.headers.filter(function (h) {
                return h;
              }).map(function (h) {
                h.value = (f.attributes || f.properties)[h.name];return h.value;
              }));
            }),
            recordsFiltered: data.count,
            recordsTotal: data.count,
            filter: this.state.features.map(function (f) {
              return f.id;
            })

          };
        } catch (e) {
          console.warn(e);
          _gui2.default.notify.error((0, _g3wI18n.t)("info.server_error"));
          return Promise.reject(e);
        } finally {
          _gui2.default.setLoadingContent(false);
        }
      });

      function getData() {
        return _ref13.apply(this, arguments);
      }

      return getData;
    }(),
    unSelectAll: function unSelectAll() {
      this.state.features.forEach(function (f) {
        return f.selected = false;
      });
      this.state.show_tools = false;
      this.state.selectAll = false;
    },
    onGUIContent: function onGUIContent() {
      var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      this.has_map = 100 !== opts.perc;
    },
    filterChangeHandler: function filterChangeHandler() {
      $(this.$refs.attribute_table).DataTable().ajax.reload();
    }
  },

  beforeCreate: function beforeCreate() {
    this.delayType = 'debounce';
  },
  created: function () {
    var _ref15 = _asyncToGenerator(function* () {
      this.unSelectAll = this.unSelectAll.bind(this);

      this.onGUIContent = this.onGUIContent.bind(this);

      _gui2.default.onbefore('setContent', this.onGUIContent);
      this.layer.on('unselectionall', this.unSelectAll);
      this.layer.on('filtertokenchange', this.filterChangeHandler);

      _gui2.default.closeSideBar();
      this.current_layout.rightpanel.height = 55;

      _gui2.default.showContent({
        content: new _g3wComponent2.default({
          id: 'openattributetable',
          service: { state: this.state },
          internalComponent: this
        }),

        split: _gui2.default.isMobile() ? 'h' : 'v',
        push: false,
        title: this.layer.getTitle(),
        text: true });

      if (this.isMobile()) {
        _gui2.default.hideSidebar();
      }
    });

    function created() {
      return _ref15.apply(this, arguments);
    }

    return created;
  }(),
  mounted: function () {
    var _ref16 = _asyncToGenerator(function* () {
      var _this6 = this;

      this.last_map_control = _gui2.default.getService('map').getMapControls().find(function (c) {
        return c.control.isToggled && c.control.isToggled();
      });
      if (this.last_map_control) {
        this.last_map_control.control.toggle();
      }
      this.setContentKey = _gui2.default.onafter('setContent', this.resize);

      yield this.$nextTick();

      var pResolve = void 0;

      var filterColumns = {};

      var table = $(this.$refs.attribute_table).DataTable({
        ajax: (0, _debounce.debounce)(function () {
          var _ref17 = _asyncToGenerator(function* (opts, cb) {
            try {
              _gui2.default.disableContent(true);
              var data = yield _this6.getData(opts);
              cb(data);
              _this6.disableSelectAll = 0 === _this6.state.features.length;
              if (pResolve) {
                pResolve(data.filter);
              }
              yield _this6.$nextTick();
              table.columns.adjust();
            } catch (e) {
              console.warn(e);
            }

            _gui2.default.disableContent(false);
          });

          return function (_x7, _x8) {
            return _ref17.apply(this, arguments);
          };
        }(), 800),
        bSortCellsTop: true,
        columns: this.state.headers,
        columnDefs: [{ orderable: false, searchable: false, targets: 0, width: '1%' }],
        deferLoading: this.state.allfeatures,
        dom: 'frt<"#g3w-table-toolbar">lip',
        lengthMenu: _g3wConstants.PAGELENGTHS,
        order: [1, 'asc'],
        pageLength: this.layer.getAttributeTablePageLength() || _g3wConstants.PAGELENGTHS[1],
        processing: false,
        responsive: true,
        scrollCollapse: true,
        scrollX: true,
        serverSide: true,
        sSearch: false
      });

      this.changeColumn = (0, _debounce.debounce)(function () {
        var _ref18 = _asyncToGenerator(function* (e, i) {
          var value = e.target.value.trim();
          table.one('draw', _asyncToGenerator(function* () {
            filterColumns[i] = value;
            _this6.disableSelectAll = 0 === _this6.state.features.length;
            _this6.filter = Object.values(filterColumns).find(function (f) {
              return f;
            }) ? yield new Promise(function (resolve) {
              return pResolve = resolve;
            }) : [];
          }));
          table.columns(i).search(value).draw();
        });

        return function (_x9, _x10) {
          return _ref18.apply(this, arguments);
        };
      }());

      var fragment = document.createDocumentFragment();
      fragment.appendChild(this.$refs.table_toolbar);
      document.getElementById('g3w-table-toolbar').appendChild(fragment);

      document.querySelector('#g3w-view-content .g3-content-header-action-tools').insertAdjacentElement('beforebegin', document.querySelector('.dataTables_info'));
      document.querySelector('#g3w-view-content .g3-content-header-action-tools').insertAdjacentElement('beforebegin', document.querySelector('.dataTables_filter'));

      document.getElementById('table_body_attributes').remove();

      table.ajax.reload();
    });

    function mounted() {
      return _ref16.apply(this, arguments);
    }

    return mounted;
  }(),
  beforeDestroy: function () {
    var _ref20 = _asyncToGenerator(function* () {
      var _this7 = this;

      if (this.last_map_control && !this.last_map_control.control.isToggled()) {
        this.last_map_control.control.toggle();
      }

      this.last_map_control = null;

      this.layer.off('unselectionall', this.unSelectAll);
      this.layer.off('filtertokenchange', this.filterChangeHandler);

      ol.Observable.unByKey(this.map_bbox.key);
      this.map_bbox.key = null;
      this.map_bbox.cb = null;

      this.highlight();

      if (!this.has_map) {
        setTimeout(function () {
          _this7.async_highlight();
          _this7.has_map = true;
          _this7.async_highlight = function () {};
        });
      }

      _gui2.default.un('setContent', this.setContentKey);

      document.querySelector('#g3w-view-content .dataTables_info').remove();
      document.querySelector('#g3w-view-content .dataTables_filter').remove();
      $(this.$refs.attribute_table).DataTable().destroy(true);
    });

    function beforeDestroy() {
      return _ref20.apply(this, arguments);
    }

    return beforeDestroy;
  }()
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"open_attribute_table"}},[_c('div',{ref:"table_toolbar",staticStyle:{"display":"flex","justify-content":"space-between","padding":"1px"}},[(_vm.layer.isGeoLayer())?_c('div',{directives:[{name:"disabled",rawName:"v-disabled",value:(_vm.state.geolayer.active && _vm.current_layout.rightpanel.height_100),expression:"state.geolayer.active && current_layout.rightpanel.height_100"},{name:"t-tooltip",rawName:"v-t-tooltip.create",value:('layer_selection_filter.tools.show_features_on_map'),expression:"'layer_selection_filter.tools.show_features_on_map'",modifiers:{"create":true}}],staticClass:"skin-color action-button skin-tooltip-right",class:[ _vm.$fa('map'), _vm.state.geolayer.active ? 'toggled' : '' ],attrs:{"data-placement":"right"},on:{"click":function($event){$event.stopPropagation();return _vm.getDataFromBBOX($event)}}}):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.state.show_tools),expression:"state.show_tools"},{name:"t-tooltip",rawName:"v-t-tooltip.create",value:('layer_selection_filter.tools.clear'),expression:"'layer_selection_filter.tools.clear'",modifiers:{"create":true}}],staticClass:"skin-color action-button skin-tooltip-right",class:_vm.$fa('clear'),attrs:{"data-placement":"right"},on:{"click":function($event){$event.stopPropagation();return _vm.layer.clearSelectionFids()}}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.state.show_tools),expression:"state.show_tools"},{name:"t-tooltip",rawName:"v-t-tooltip.create",value:('layer_selection_filter.tools.invert'),expression:"'layer_selection_filter.tools.invert'",modifiers:{"create":true}}],staticClass:"skin-color action-button skin-tooltip-right",class:[ _vm.$fa('invert'), _vm.layer.state.filter.active ? 'g3w-disabled': '' ],attrs:{"data-placement":"right"},on:{"click":function($event){$event.stopPropagation();return _vm.inverseSelection($event)}}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.state.show_tools),expression:"state.show_tools"},{name:"t-tooltip",rawName:"v-t-tooltip.create",value:('layer_selection_filter.tools.filter'),expression:"'layer_selection_filter.tools.filter'",modifiers:{"create":true}}],staticClass:"skin-color action-button skin-tooltip-right",class:[ _vm.$fa('filter'), _vm.layer.state.filter.active ? 'toggled' : '' ],attrs:{"data-placement":"right"},on:{"click":function($event){$event.stopPropagation();return _vm.toggleFilterToken(_vm.layer)}}})]),_vm._v(" "),(_vm.state.headers.length)?_c('table',{ref:"attribute_table",staticClass:"table table-striped row-border compact nowrap",attrs:{"id":"layer_attribute_table"}},[_c('thead',[_c('tr',[_c('th'),_vm._v(" "),_vm._l((_vm.state.headers),function(header,i){return (i > 0)?_c('th',[_vm._v(_vm._s(header.label))]):_vm._e()})],2),_vm._v(" "),_c('tr',[_c('th',{directives:[{name:"disabled",rawName:"v-disabled",value:(_vm.disableSelectAll),expression:"disableSelectAll"}]},[_c('input',{staticClass:"magic-checkbox",attrs:{"type":"checkbox","id":"attribute_table_select_all_rows"},domProps:{"checked":_vm.state.selectAll}}),_vm._v(" "),_c('label',{attrs:{"for":"attribute_table_select_all_rows"},on:{"!click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.selectAllRows($event)}}},[_vm._v(" ")])]),_vm._v(" "),_vm._l((_vm.state.headers),function(header,i){return (i > 0)?_c('th',[_c('input',{staticClass:"form-control column-search",attrs:{"type":"text","placeholder":header.name,"title":'search by ' + header.name},on:{"keyup":function($event){return _vm.changeColumn($event, i)}}})]):_vm._e()})],2)]),_vm._v(" "),_c('tbody',{attrs:{"id":"table_body_attributes","hidden":""}}),_vm._v(" "),_c('tbody',{ref:"table_body",on:{"mouseleave":function($event){return _vm.highlight()}}},_vm._l((_vm.state.features),function(feature,i){return _c('tr',{key:feature.id,class:[
          i % 2 == 1 ? 'odd' : 'pair',
          'feature_attribute',
          { geometry: !!feature.geometry },
          { 'selected': feature.selected }
        ],attrs:{"role":"row"},on:{"mouseover":function($event){return _vm.highlight(feature, false)},"click":function($event){$event.stopPropagation();return _vm.highlight(feature, true)}}},[_c('td',[_c('div',{staticStyle:{"display":"flex"}},[_c('input',{staticClass:"magic-checkbox",attrs:{"type":"checkbox","id":_vm.get_check_id(true)},domProps:{"checked":feature.selected}}),_vm._v(" "),_c('label',{attrs:{"for":_vm.get_check_id(false)},on:{"!click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.select(feature)}}}),_vm._v(" "),_c('i',{directives:[{name:"t-tooltip",rawName:"v-t-tooltip:top.create",value:('sdk.tooltips.relations.row_to_form'),expression:"'sdk.tooltips.relations.row_to_form'",arg:"top",modifiers:{"create":true}}],class:'action-button skin-color ' + _vm.$fa('table'),on:{"click":function($event){$event.stopPropagation();return _vm.openForm(feature)}}}),_vm._v(" "),(_vm.layer.state.geolayer && !feature.geometry)?_c('i',{directives:[{name:"t-tooltip",rawName:"v-t-tooltip:top.create",value:('no_geometry'),expression:"'no_geometry'",arg:"top",modifiers:{"create":true}}],class:'action-button ' + _vm.$fa('alert'),staticStyle:{"color":"currentColor !important"}}):_vm._e(),_vm._v(" "),(_vm.layer.isEditable() && _vm.layer.config.editing.visible)?_c('i',{directives:[{name:"t-tooltip",rawName:"v-t-tooltip:top.create",value:('sdk.tooltips.editing'),expression:"'sdk.tooltips.editing'",arg:"top",modifiers:{"create":true}}],class:'action-button skin-color ' + _vm.$fa('pencil'),on:{"click":function($event){$event.stopPropagation();return _vm.editFeature(feature)}}}):_vm._e()])]),_vm._v(" "),_vm._l((_vm.state.headers),function(header,j){return (j > 0)?_c('td',[_c('field',{attrs:{"feature":feature,"state":({ label: undefined, value: feature.attributes[header.name] })}})],1):_vm._e()})],2)}),0)]):_c('div',{directives:[{name:"t",rawName:"v-t",value:('dataTable.no_data'),expression:"'dataTable.no_data'"}],attrs:{"id":"noheaders"}})])}
__vue__options__.staticRenderFns = []
__vue__options__._scopeId = "data-v-ff0ad38c"

},{"components/FieldG3W.vue":77,"g3w-component":158,"g3w-constants":159,"g3w-i18n":162,"mixins":200,"services/data":206,"services/gui":207,"store/application":212,"utils/coordinatesToGeometry":223,"utils/debounce":232,"utils/getCatalogLayerById":238,"utils/getUniqueDomId":252,"utils/promisify":267,"vueify/lib/insert-css":35}],144:[function(require,module,exports){
var __vueify_style_dispose__ = require("vueify/lib/insert-css").insert(".tool_disabled[data-v-2361b248]{cursor:not-allowed}.tool_disabled>span[data-v-2361b248]{color:#777}.tool_type[data-v-2361b248]{cursor:pointer;vertical-align:center;position:absolute;right:0;top:0;padding:5px}")
;(function(){
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _application = require('store/application');

var _application2 = _interopRequireDefault(_application);

var _gui = require('services/gui');

var _gui2 = _interopRequireDefault(_gui);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: "g3w-tool",
  props: ['tool'],
  methods: {
    showToolStateMessage: function showToolStateMessage() {
      _gui2.default.showModalDialog({ title: this.tool.state.type.toUpperCase(), message: this.tool.state.message });
    }
  },
  computed: {
    disabled: function disabled() {
      return !this.tool.offline && !_application2.default.online || this.tool.loading || this.tool.disabled;
    },
    sidebarOpen: function sidebarOpen() {
      return _application2.default.gui.sidebar.open;
    }
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[('checkbox' === _vm.tool.type)?_c('div',{staticClass:"checkbox"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.tool.isCheck),expression:"tool.isCheck"}],staticStyle:{"cursor":"pointer"},attrs:{"id":_vm.tool.layerName,"type":"checkbox"},domProps:{"value":_vm.tool.layerName,"checked":Array.isArray(_vm.tool.isCheck)?_vm._i(_vm.tool.isCheck,_vm.tool.layerName)>-1:(_vm.tool.isCheck)},on:{"click":function($event){return _vm.tool.action(_vm.tool)},"change":function($event){var $$a=_vm.tool.isCheck,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=_vm.tool.layerName,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.tool, "isCheck", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.tool, "isCheck", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.tool, "isCheck", $$c)}}}}),_vm._v("\n      "+_vm._s(_vm.tool.name)+"\n    ")])]):_c('div',{directives:[{name:"t-tooltip",rawName:"v-t-tooltip:right.create",value:(_vm.sidebarOpen ? null : _vm.tool.html ?  _vm.tool.html.text || _vm.tool.name : _vm.tool.name),expression:"sidebarOpen ? null : tool.html ?  tool.html.text || tool.name : tool.name",arg:"right",modifiers:{"create":true}}],staticClass:"tool",class:{ tool_disabled: _vm.disabled },staticStyle:{"position":"relative"},attrs:{"current-tooltip":_vm.sidebarOpen ? null : _vm.tool.html ?  _vm.tool.html.text || _vm.tool.name : _vm.tool.name},on:{"click":function($event){!_vm.disabled ? _vm.tool.action(_vm.tool) : null}}},[_c('bar-loader',{attrs:{"loading":_vm.tool.loading}}),_vm._v(" "),_c('i',{class:_vm.$fa(_vm.tool.icon || 'caret-right')}),_vm._v(" "),(_vm.tool.html)?_c('span',{staticClass:"tool-label"},[_c('i',{class:_vm.tool.html.icon}),_vm._v("\n    "+_vm._s(_vm.tool.html.text || _vm.tool.name)+"\n    ")]):_c('span',{directives:[{name:"t",rawName:"v-t",value:(_vm.tool.name),expression:"tool.name"}],staticClass:"tool-label"}),_vm._v(" "),(_vm.tool.state.type)?_c('span',{staticClass:"tool_type",style:({ color: ({ alert: 'red', info: 'blue', warning: 'orange'})[_vm.tool.state.type] }),on:{"click":function($event){$event.stopPropagation();return _vm.showToolStateMessage($event)}}},[_c('i',{class:_vm.$fa(_vm.tool.state.type)})]):_vm._e()],1)])}
__vue__options__.staticRenderFns = []
__vue__options__._scopeId = "data-v-2361b248"

},{"services/gui":207,"store/application":212,"vueify/lib/insert-css":35}],145:[function(require,module,exports){
var __vueify_style_dispose__ = require("vueify/lib/insert-css").insert(".usermessage-content[data-v-9ecdb3b0]{color:#fff;z-index:1000;position:absolute;line-height:normal;padding:3px;min-width:250px;box-shadow:0 3px 5px rgba(0,0,0,.3);border-radius:0 0 3px 3px}.usermessage-tool[data-v-9ecdb3b0]{cursor:move;position:fixed}.usermessage-content.mobile[data-v-9ecdb3b0]{padding:0;min-width:100%}.usermessage-header-content[data-v-9ecdb3b0]{display:flex;align-items:baseline;justify-content:space-between;width:100%;border-bottom:2px solid #eee}.usermessage-header-icontype[data-v-9ecdb3b0]{padding:10px 0 0 5px;font-weight:700;font-size:1.3em}.usermessage-content.mobile .usermessage-header-icontype[data-v-9ecdb3b0]{padding:0 0 0 5px;font-size:1.1em}.usermessage-header-title[data-v-9ecdb3b0],.usermessage-header-title h4[data-v-9ecdb3b0]{font-weight:700;text-align:center}.usermessage-content.mobile .usermessage-header-title h4[data-v-9ecdb3b0]{margin:0}.usermessage-header-subtitle[data-v-9ecdb3b0]{font-weight:700;margin:5px}.usermessage-header-right[data-v-9ecdb3b0]{padding:5px}.usermessage-header-right-item[data-v-9ecdb3b0]{font-weight:700!important;font-size:1.2em;cursor:pointer}.usermessage-message[data-v-9ecdb3b0]{width:100%;padding:10px;max-height:100px;font-size:1.1em;align-self:flex-start;overflow-y:auto}")
;(function(){
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _gui = require('services/gui');

var _gui2 = _interopRequireDefault(_gui);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function dragElement(el) {
  var x2 = 0,
      y2 = 0,
      x1 = 0,
      y1 = 0;
  el.addEventListener('mousedown', function (e) {
    if (['.select2-container', 'button', 'select', 'input', 'textarea'].some(function (i) {
      return e.target.closest(i);
    })) {
      return;
    }
    e.preventDefault();
    x1 = e.clientX;
    y1 = e.clientY;
    document.addEventListener('mouseup', mouseUp);
    document.addEventListener('mousemove', mouseMove);
  });
  function mouseUp() {
    document.removeEventListener('mouseup', mouseUp);
    document.removeEventListener('mousemove', mouseMove);
  }
  function mouseMove(e) {
    e.preventDefault();
    x2 = x1 - e.clientX;
    y2 = y1 - e.clientY;
    x1 = e.clientX;
    y1 = e.clientY;
    if (el.style.marginLeft) {
      x2 -= parseInt(el.style.marginLeft);el.style.marginLeft = null;
    }
    if (el.style.marginTop) {
      y2 -= parseInt(el.style.marginTop);el.style.marginTop = null;
    }
    el.style.top = el.offsetTop - y2 + "px";
    el.style.left = el.offsetLeft - x2 + "px";
  }
}

exports.default = {
  name: "usermessage",
  props: {
    id: {},
    type: {
      type: String,
      default: "info" },
    title: {
      type: String,
      default: null
    },
    subtitle: {
      type: String,
      default: null
    },
    position: {
      type: String,
      default: "top"
    },
    size: {
      type: String,
      default: "fullpage"
    },
    message: {
      type: String,
      default: ''
    },
    textMessage: {
      type: Boolean,
      default: false
    },
    autoclose: {
      type: Boolean,
      default: false
    },
    draggable: {
      type: Boolean,
      default: false
    },
    duration: {
      type: Number,
      default: 2000
    },
    closable: {
      type: Boolean,
      default: true
    },

    iconClass: {
      type: String,
      default: null
    }
  },
  data: function data() {
    var _position$split = this.position.split('-'),
        _position$split2 = _slicedToArray(_position$split, 2),
        where = _position$split2[0],
        alignement = _position$split2[1];

    return {
      style: _extends({}, 'center' === where ? { top: 0, bottom: 0, maxHeight: '20%' } : _defineProperty({}, where, 50), {
        'center': { left: 0, right: 0, margin: 'auto' },
        'right': { right: 0 }
      }[alignement] || {}, {
        width: {
          'small': '325px',
          'medium': '50%',
          'fullpage': '100%'
        }[alignement ? 'small' : this.size] || '100%'
      }, {
        success: { backgroundColor: "#62ac62", color: "#FFF" },
        info: { backgroundColor: "#44a0bb", color: "#FFF" },
        warning: { backgroundColor: "#f29e1d", color: "#FFF" },
        alert: { backgroundColor: "#c34943", color: "#FFF" },
        tool: {
          backgroundColor: "#FFF",
          color: "#222d32",
          "z-index": 100,
          marginLeft: document.body.classList.contains('sidebar-collapse') ? '5px' : '40px'
        },
        loading: {
          backgroundColor: "#FFF",
          color: "#222d32",
          fontWeight: "bold"
        }
      }[this.type])
    };
  },

  computed: {
    showheader: function showheader() {
      return 'loading' !== this.type;
    }
  },
  methods: {
    addClassMobile: function addClassMobile() {
      return this.isMobile() && !_gui2.default.isSidebarVisible();
    },
    closeUserMessage: function closeUserMessage() {
      this.$emit('close-usermessage');
    },
    hideShow: function hideShow() {}
  },
  created: function created() {
    this.observe = null;
  },
  mounted: function () {
    var _ref2 = _asyncToGenerator(function* () {
      var _this = this;

      if ('tool' === this.type) {
        dragElement(this.$refs.user_message);
        this.observer = new MutationObserver(function (mutations) {
          mutations.forEach(function (mutation) {
            if ("class" === mutation.attributeName) {
              _this.style.marginLeft = mutation.target.classList.contains('sidebar-collapse') ? '5px' : '40px';
            }
          });
        });
        this.observer.observe(document.body, { attributes: true });
      }
      if (this.autoclose) {
        yield this.$nextTick();
        var timeout = setTimeout(function () {
          _this.closeUserMessage();
          clearTimeout(timeout);
        }, this.duration);
      }
    });

    function mounted() {
      return _ref2.apply(this, arguments);
    }

    return mounted;
  }(),
  beforeDestroy: function beforeDestroy() {
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
__vue__options__.render = function render () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"user_message",staticClass:"usermessage-content",class:( _obj = {'mobile': _vm.addClassMobile()}, _obj['usermessage-' + _vm.type] = true, _obj ),style:(_vm.style),attrs:{"id":_vm.id}},[(_vm.showheader)?_c('div',{staticClass:"usermessage-header-content"},[_c('i',{staticClass:"usermessage-header-icontype",class:_vm.$fa(_vm.iconClass || _vm.type)}),_vm._v(" "),_c('div',{staticClass:"usermessage-header-title"},[_vm._t("header",[(_vm.title)?_c('h4',{directives:[{name:"t",rawName:"v-t",value:(_vm.title),expression:"title"}]}):_c('h4',[_vm._v(" "+_vm._s(_vm.type.toUpperCase()))]),_vm._v(" "),(_vm.subtitle)?_c('h5',{directives:[{name:"t",rawName:"v-t",value:(_vm.subtitle),expression:"subtitle"}],staticClass:"usermessage-header-subtitle"}):_vm._e()])],2),_vm._v(" "),_c('div',{staticClass:"usermessage-header-right"},[(!_vm.autoclose && _vm.closable)?_c('div',{on:{"click":_vm.closeUserMessage}},[_c('i',{staticClass:"usermessage-header-right-item",class:_vm.$fa('close')})]):_vm._e()])]):_vm._e(),_vm._v(" "),_vm._t("body",[(_vm.textMessage)?_c('div',{staticClass:"usermessage-message"},[_vm._v(_vm._s(_vm.message))]):_c('div',{directives:[{name:"t",rawName:"v-t",value:(_vm.message),expression:"message"}],staticClass:"usermessage-message"})]),_vm._v(" "),_vm._t("footer")],2)}
__vue__options__.staticRenderFns = []
__vue__options__._scopeId = "data-v-9ecdb3b0"

},{"services/gui":207,"vueify/lib/insert-css":35}],146:[function(require,module,exports){
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FormService = exports.FormComponent = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _g3wObject = require('g3w-object');

var _g3wObject2 = _interopRequireDefault(_g3wObject);

var _g3wComponent = require('g3w-component');

var _g3wComponent2 = _interopRequireDefault(_g3wComponent);

var _gui = require('services/gui');

var _gui2 = _interopRequireDefault(_gui);

var _Form = require('components/Form.vue');

var vueComp = _interopRequireWildcard(_Form);

var _FormBody = require('components/FormBody.vue');

var _FormBody2 = _interopRequireDefault(_FormBody);

var _getDefaultExpression = require('utils/getDefaultExpression');

var _getFilterExpression = require('utils/getFilterExpression');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @file
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @since 3.10.0
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

/**
 * ORIGINAL SOURCE: src/app/gui/form/vue/form.js@v3.9.3 
 * 
 * Used by the following plugins: "editing", "cadastre", "geonotes", "iternet"  
 */
var FormComponent = exports.FormComponent = function (_Component) {
  _inherits(FormComponent, _Component);

  function FormComponent() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, FormComponent);

    // set element of the form
    var _this = _possibleConstructorReturn(this, (FormComponent.__proto__ || Object.getPrototypeOf(FormComponent)).call(this, _extends({}, opts, {
      id: opts.id || 'form',
      perc: null !== opts.layer.getFormPercentage() ? opts.layer.getFormPercentage() : opts.perc,
      service: new (opts.service || FormService)(),
      vueComponentObject: opts.vueComponentObject || vueComp
    })));

    var components = opts.components || [{
      id: opts.id,
      title: opts.title,
      name: opts.name,
      root: true,
      component: _FormBody2.default,
      headerComponent: opts.headerComponent
    }];

    _this.getService().addComponents(components);
    _this.getService().setComponent(components[0].component);

    _this.onafter('mount', function () {
      return _gui2.default.setModal(true);
    });
    return _this;
  }

  _createClass(FormComponent, [{
    key: 'addFormComponents',
    value: function addFormComponents() {
      var c = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      this.getService().addComponents(c);
    }
  }, {
    key: 'addFormComponent',
    value: function addFormComponent(c) {
      c && this.getService().addComponent(c);
    }
  }, {
    key: 'layout',
    value: function layout() {
      this.getInternalComponent().reloadLayout();
    }

    /** @TODO check if superflous */

  }, {
    key: 'mount',
    value: function mount(parent, append) {
      return _get(FormComponent.prototype.__proto__ || Object.getPrototypeOf(FormComponent.prototype), 'mount', this).call(this, parent, append).then(function () {
        _gui2.default.setModal(true);
      });
    }
  }]);

  return FormComponent;
}(_g3wComponent2.default);

/**
 * @file ORIGINAL SOURCE: src/app/gui/form/formservice.js@v3.10.2
 * @since 3.11.0
 */


var FormService = exports.FormService = function (_G3WObject) {
  _inherits(FormService, _G3WObject);

  function FormService() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, FormService);

    var _this2 = _possibleConstructorReturn(this, (FormService.__proto__ || Object.getPrototypeOf(FormService)).call(this, opts));

    _this2.state = null;

    _this2.eventBus = new Vue();

    _this2.eventBus.$on('set-loading-form', function () {
      var bool = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      return _this2.state.loading = bool;
    });

    /**
     * Whether to force some state property to have a certain value.
     * (e.g., set on a child to parent form service relation)
     *
     * @type {{ valid: boolean, update: boolean }}
     */
    _this2.force = {
      update: false,
      valid: false // NOT USED FOR THE MOMENT
    };

    _this2.layer;

    _this2.setters = {
      setInitForm: function setInitForm() {
        var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        this._setInitForm(opts);
      },
      setFormStructure: function setFormStructure(formStructure) {
        this.state.formstructure = formStructure;
      },
      setFormFields: function setFormFields() {
        var fields = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

        this.state.fields = fields;
        this.handleFieldsWithExpression(fields);
      },
      setupFields: function setupFields() {},
      setFormData: function setFormData() {
        var fields = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

        this.setFormFields(fields);
      },
      setField: function setField(field) {},
      setState: function setState(state) {
        this._setState(state);
      },
      addActionsForForm: function addActionsForForm(actions) {},
      postRender: function postRender(element) {
        // hook for listener to change DOM
      }
    };

    return _this2;
  }

  _createClass(FormService, [{
    key: 'init',
    value: function init() {
      var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      this._setInitForm(opts);
    }

    /**
     * Init form options passed, for example, by editor
     */

  }, {
    key: '_setInitForm',
    value: function _setInitForm() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var fields = options.fields,
          feature = options.feature,
          parentData = options.parentData,
          layer = options.layer,
          _options$title = options.title,
          title = _options$title === undefined ? 'Form' : _options$title,
          formId = options.formId,
          name = options.name,
          _options$buttons = options.buttons,
          buttons = _options$buttons === undefined ? {} : _options$buttons,
          context_inputs = options.context_inputs,
          isnew = options.isnew,
          _options$footer = options.footer,
          footer = _options$footer === undefined ? {} : _options$footer,
          headerComponent = options.headerComponent;


      this.layer = layer;

      /**
       * Cloned feature
       */
      this.feature = feature.clone();

      this.title = title;

      this.formId = formId;

      this.name = name;

      this.buttons = buttons;

      this.context_inputs = context_inputs;

      this.parentData = parentData;

      this.headerComponent = headerComponent;

      /**
       * Force update state of the service
       * (e.g., setted on a child to parent form service relation)
       */
      this.state = {
        layerid: layer.getId(),
        loading: false,
        components: [],
        disabledcomponents: [],
        component: null,
        headers: [],
        currentheaderid: null,
        fields: null,
        buttons: this.buttons,
        disabled: false,
        isnew: isnew,
        valid: true, // global form validation state. True at beginning
        update: feature.isNew(), // set update in case or not is a new feature
        // when input change will be updated
        tovalidate: {},
        feature: this.feature, //need to get feature cloned
        componentstovalidate: {},
        footer: footer,
        ready: false
      };

      this.force.update = feature.isNew();

      /**
       * Expression fields dependencies from filter_expression
       */
      this.filter_expression_fields_dependencies = {}; //

      /**
       * Expression fields dependencies from default_expression
       */
      this.default_expression_fields_dependencies = {};

      /**
       * @since 3.8.0
       */
      this.default_expression_fields_on_update = [];

      this.setFormFields(fields);

      if (this.layer && options.formStructure) {
        this.setFormStructure(this.layer.getLayerEditingFormStructure());
      }
    }
  }, {
    key: 'setReady',
    value: function setReady() {
      var bool = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      this.state.ready = bool;
    }
  }, {
    key: 'changeInput',


    /**
     * Called when an input change value
     *
     * @param input
     */
    value: function () {
      var _ref = _asyncToGenerator(function* (input) {
        try {
          //need to set property
          this.feature.set(input.name, input.value);
          yield this.evaluateFilterExpressionFields(input);
          yield this.evaluateDefaultExpressionFields(input);
          this.isValid(input);
          this.isUpdated(input);
        } catch (e) {
          console.warn(e);
        }
        //emit event changeInput
        this.emit('changeInput', input);
      });

      function changeInput(_x11) {
        return _ref.apply(this, arguments);
      }

      return changeInput;
    }()
  }, {
    key: 'isUpdated',


    /**
     * Check if the form is updated base on change on input
     *
     * @param input
     */
    value: function isUpdated(input) {
      this.state.update = this.force.update || (!this.state.update ? input.update : !!this.state.fields.find(function (f) {
        return f.update;
      }));
    }
  }, {
    key: 'setUpdate',


    /**
     *
     */
    value: function setUpdate() {
      var bool = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var _options$force = options.force,
          force = _options$force === undefined ? false : _options$force;

      this.force.update = force;
      this.state.update = this.force.update || bool;
      if (false === this.state.update) {
        // set original `field._value` equal to current value to get changes
        this.state.fields.forEach(function (f) {
          return f._value = f.value;
        });
      }
    }
  }, {
    key: 'evaluateDefaultExpressionFields',


    /**
     * Evaluate filter expression
     *
     * @param input
     * @return Promise
     */
    value: function evaluateDefaultExpressionFields() {
      var _this3 = this;

      var input = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var filter = this.default_expression_fields_dependencies[input.name];
      if (filter) {
        return Promise.allSettled(filter.map(function (dependency_field) {
          return (0, _getDefaultExpression.getDefaultExpression)({
            parentData: _this3.parentData,
            qgs_layer_id: _this3.layer.getId(),
            field: _this3._getField(dependency_field),
            feature: _this3.feature
          });
        }));
      }
    }
  }, {
    key: 'evaluateFilterExpressionFields',


    /**
     * Evaluate filter expression fields
     *
     * @param input
     * @return Promise
     */
    value: function evaluateFilterExpressionFields() {
      var _this4 = this;

      var input = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var filter = this.filter_expression_fields_dependencies[input.name];
      if (filter) {
        // on form service initialization `filter_expression` option has
        // `referencing_fields` or `referenced_columns` from another layer
        return Promise.allSettled(filter.map(function (dependency_field) {
          return (0, _getFilterExpression.getFilterExpression)({
            parentData: _this4.parentData,
            qgs_layer_id: _this4.layer.getId(),
            field: _this4._getField(dependency_field),
            feature: _this4.feature
          });
        }));
      }
    }
  }, {
    key: '_handleFieldWithFilterExpression',


    /**
     * Handle a field that has a `filter_expression` value object
     *
     * @since 3.8.0
     */
    value: function _handleFieldWithFilterExpression(field, filter_expression) {
      var _this5 = this;

      if (!filter_expression) {
        return;
      }

      var _filter_expression$re = filter_expression.referencing_fields,
          referencing_fields = _filter_expression$re === undefined ? [] : _filter_expression$re,
          _filter_expression$re2 = filter_expression.referenced_columns,
          referenced_columns = _filter_expression$re2 === undefined ? [] : _filter_expression$re2;


      var dependency_fields = new Set();

      // TODO: add description
      [].concat(_toConsumableArray(referenced_columns), _toConsumableArray(referencing_fields)).forEach(function (f) {
        return dependency_fields.add(f);
      });

      dependency_fields.forEach(function (f) {
        if (undefined === _this5.filter_expression_fields_dependencies[f]) {
          _this5.filter_expression_fields_dependencies[f] = [];
        }
        _this5.filter_expression_fields_dependencies[f].push(field.name);
      });

      // Call input service if a field has a `filter_expression` every time we open a form
      (0, _getFilterExpression.getFilterExpression)({
        parentData: this.parentData,
        qgs_layer_id: this.layer.getId(),
        feature: this.feature,
        field: field
      });
    }
  }, {
    key: '_handleFieldWithDefaultExpression',


    /**
     * Handle a field that has a `default_value` object and check if `apply_on_update` only
     *
     * @since 3.8.0
     */
    value: function _handleFieldWithDefaultExpression(field, default_expression) {
      var _this6 = this;

      if (default_expression) {
        var _default_expression$r = default_expression.referencing_fields,
            referencing_fields = _default_expression$r === undefined ? [] : _default_expression$r,
            _default_expression$r2 = default_expression.referenced_columns,
            referenced_columns = _default_expression$r2 === undefined ? [] : _default_expression$r2,
            _default_expression$a = default_expression.apply_on_update,
            apply_on_update = _default_expression$a === undefined ? false : _default_expression$a;

        // Skip if not apply_on_update (listen dependency change only for new Feature)

        if (!apply_on_update && !this.state.isnew) {
          return;
        }

        var dependency_fields = new Set();

        // Get array of dependency fields on default expression if exist
        // add each of it in a Set (unique array items)
        [].concat(_toConsumableArray(referenced_columns), _toConsumableArray(referencing_fields)).forEach(function (f) {
          return dependency_fields.add(f);
        });

        // Only in apply update listen changeInput
        if (apply_on_update) {

          this.default_expression_fields_on_update.push(field);

          dependency_fields.forEach(function (f) {
            if (undefined === _this6.default_expression_fields_dependencies[f]) {
              _this6.default_expression_fields_dependencies[f] = [];
            }
            _this6.default_expression_fields_dependencies[f].push(field.name);
          });
        }

        // Call input service if a field has a default_expression and is a new feature
        if (this.state.isnew) {
          (0, _getDefaultExpression.getDefaultExpression)({
            field: field,
            feature: this.feature,
            qgs_layer_id: this.layer.getId(),
            parentData: this.parentData
          });
        }
      }
    }
  }, {
    key: 'handleFieldsWithExpression',


    /**
     * Handle fields with associated expression
     *
     * @param {Array} [fields = []]
     */
    value: function handleFieldsWithExpression() {
      var _this7 = this;

      var fields = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      // TODO: add description
      fields.forEach(function (field) {
        var _field$input$options = field.input.options,
            options = _field$input$options === undefined ? {} : _field$input$options;

        _this7._handleFieldWithFilterExpression(field, options.filter_expression);
        _this7._handleFieldWithDefaultExpression(field, options.default_expression);
      });
      // start to evaluate filter expression field
      Object.keys(this.filter_expression_fields_dependencies).forEach(function (name) {
        return _this7.evaluateFilterExpressionFields({ name: name });
      });
    }
  }, {
    key: 'setCurrentFormPercentage',
    value: function setCurrentFormPercentage(perc) {
      this.layer.setFormPercentage(perc);
    }
  }, {
    key: 'setLoading',
    value: function setLoading() {
      var bool = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      this.state.loading = bool;
    }
  }, {
    key: 'setValidComponent',
    value: function setValidComponent(_ref2) {
      var id = _ref2.id,
          valid = _ref2.valid;

      this.state.componentstovalidate[id] = valid;
      this.isValid();
    }
  }, {
    key: 'getValidComponent',
    value: function getValidComponent(id) {
      return this.state.componentstovalidate[id];
    }
  }, {
    key: 'isValid',


    /**
     * Every input sends to form its valid value that will change the general state of form
     */
    value: function isValid(input) {
      var _this8 = this;

      if (input) {
        // check mutually
        if (input.validate.mutually && !input.validate.required && !input.validate.empty) {
          input.validate._valid = input.validate.valid;
          input.validate.mutually_valid = input.validate.mutually.reduce(function (previous, inputname) {
            return previous && _this8.state.tovalidate[inputname].validate.empty;
          }, true);
          input.validate.valid = input.validate.mutually_valid && input.validate.valid;
        }
        if (input.validate.mutually && !input.validate.required && input.validate.empty) {
          input.value = null;
          input.validate.mutually_valid = true;
          input.validate.valid = true;
          input.validate._valid = true;
          // count not empty input_name
          var filled = [];
          for (var i = input.validate.mutually.length; i--;) {
            var input_name = input.validate.mutually[i];

            if (!this.state.tovalidate[input_name].validate.empty) {
              filled.push(input_name);
            }
          }
          if (filled.length < 2) {
            filled.forEach(function (input_name) {
              _this8.state.tovalidate[input_name].validate.mutually_valid = true;
              _this8.state.tovalidate[input_name].validate.valid = true;
              setTimeout(function () {
                _this8.state.tovalidate[input_name].validate.valid = _this8.state.tovalidate[input_name].validate._valid;
                _this8.state.valid = _this8.state.valid && _this8.state.tovalidate[input_name].validate.valid;
              });
            });
          }
        }
        // check if min_field or max_field is set
        if (!input.validate.mutually && !input.validate.empty && (input.validate.min_field || input.validate.max_field)) {
          var _input_name = input.validate.min_field || input.validate.max_field;
          input.validate.valid = input.validate.min_field ? this.state.tovalidate[input.validate.min_field].validate.empty || 1 * input.value > 1 * this.state.tovalidate[input.validate.min_field].value : this.state.tovalidate[input.validate.max_field].validate.empty || 1 * input.value < 1 * this.state.tovalidate[input.validate.max_field].value;

          if (input.validate.valid) {
            this.state.tovalidate[_input_name].validate.valid = true;
          }
        }
      }
      this.state.valid = Object.values(this.state.tovalidate).reduce(function (previous, input) {
        return previous && input.validate.valid;
      }, true) && Object.values(this.state.componentstovalidate).reduce(function (previous, valid) {
        return previous && valid;
      }, true);
    }
  }, {
    key: 'addComponents',
    value: function addComponents() {
      var components = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = components[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var component = _step.value;

          this.addComponent(component);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    }
  }, {
    key: 'addComponent',
    value: function addComponent(component) {
      if (!component) {
        return;
      }
      var id = component.id,
          title = component.title,
          name = component.name,
          icon = component.icon,
          valid = component.valid,
          headerComponent = component.headerComponent,
          _component$header = component.header,
          header = _component$header === undefined ? true : _component$header;

      if (undefined !== valid) {
        this.state.componentstovalidate[id] = valid;
        this.state.valid = this.state.valid && valid;
        this.eventBus.$emit('add-component-validate', {
          id: id,
          valid: valid
        });
      }
      // Set a component that can be part of headers (tabs or not)
      if (header) {
        this.state.headers.push({ title: title, name: name, id: id, icon: icon, component: headerComponent });
        this.state.currentheaderid = this.state.currentheaderid || id;
      }

      this.state.components.push(component);
    }
  }, {
    key: 'replaceComponent',
    value: function replaceComponent() {
      var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          id = _ref3.id,
          component = _ref3.component;

      this.state.components.splice(this.state.components.findIndex(function (c) {
        return id === c.id;
      }), 1, component);
    }
  }, {
    key: 'disableComponent',
    value: function disableComponent() {
      var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          id = _ref4.id,
          disabled = _ref4.disabled;

      if (disabled) {
        this.state.disabledcomponents.push(id);
      } else {
        this.state.disabledcomponents = this.state.disabledcomponents.filter(function (disableId) {
          return id !== disableId;
        });
      }
    }
  }, {
    key: 'setCurrentComponentById',
    value: function setCurrentComponentById(id) {
      if (!this.state.disabledcomponents.includes(id)) {
        this.setIdHeader(id);
        this.state.component = this.state.components.find(function (c) {
          return id === c.id;
        }).component;
        return this.state.component;
      }
    }
  }, {
    key: 'setRootComponent',


    /**
     * setRootComponent (is form)
     */
    value: function setRootComponent() {
      this.state.component = this.state.components.find(function (c) {
        return c.root;
      }).component;
    }
  }, {
    key: 'getRootComponent',
    value: function getRootComponent() {
      return this.state.components.find(function (c) {
        return c.root;
      }).component;
    }
  }, {
    key: 'isRootComponent',
    value: function isRootComponent(component) {
      return component === this.getRootComponent();
    }
  }, {
    key: 'getComponentById',
    value: function getComponentById(id) {
      return this.state.components.find(function (c) {
        return id === c.id;
      });
    }
  }, {
    key: 'setComponent',
    value: function setComponent(component) {
      this.state.component = component;
    }
  }, {
    key: 'addedComponentTo',
    value: function addedComponentTo() {
      var formcomponent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'body';

      this.state.addedcomponentto[formcomponent] = true;
    }
  }, {
    key: 'addToValidate',
    value: function addToValidate(input) {
      this.state.tovalidate[input.name] = input;
      // check if is mounted on form gui an otherwise leave form component to run is Valid when form is mounted on dom
      if (this.state.ready) {
        this.isValid(input);
      }
    }
  }, {
    key: 'removeToValidate',
    value: function removeToValidate(input) {
      delete this.state.tovalidate[input.name];
      this.isValid();
    }
  }, {
    key: 'getState',
    value: function getState() {
      return this.state;
    }
  }, {
    key: '_setState',
    value: function _setState(state) {
      this.state = state;
    }
  }, {
    key: 'getFields',
    value: function getFields() {
      return this.state.fields;
    }
  }, {
    key: '_getField',
    value: function _getField(name) {
      return this.state.fields.find(function (f) {
        return name === f.name;
      });
    }
  }, {
    key: 'getEventBus',
    value: function getEventBus() {
      return this.eventBus;
    }
  }, {
    key: 'setIdHeader',
    value: function setIdHeader(id) {
      this.state.currentheaderid = id;
    }
  }, {
    key: 'getContext',
    value: function getContext() {
      return this.context_inputs.context;
    }
  }, {
    key: 'getSession',
    value: function getSession() {
      return this.getContext().session;
    }
  }, {
    key: 'getInputs',
    value: function getInputs() {
      return this.context_inputs.inputs;
    }
  }, {
    key: 'handleRelation',


    /**
     * handleRelation
     */

    value: function handleRelation(_ref5) {
      //OVERWRITE BY  PLUGIN EDITING PLUGIN

      var relationId = _ref5.relationId,
          feature = _ref5.feature;
    }
  }, {
    key: 'clearAll',


    /**
     * Clear all the open things opened by service
     */
    value: function clearAll() {
      this.eventBus.$off('addtovalidate');
      this.eventBus.$off('set-main-component');
      this.eventBus.$off('set-loading-form');
      this.eventBus.$off('component-validation');
      this.eventBus.$off('disable-component');
    }
  }, {
    key: 'saveDefaultExpressionFieldsNotDependencies',


    /**
     * Method to get default expression of field that has no dependencies fields listen when save form
     * @returns {Promise<void>}
     *
     * @since 3.8.0
     */
    value: function () {
      var _ref6 = _asyncToGenerator(function* () {
        var _this9 = this;

        if (0 === this.default_expression_fields_on_update.length) {
          return;
        }

        try {
          //@since 3.11.0 get unique field names that has dependencies from another fields
          var fields_with_dependencies = new Set(Object.values(this.default_expression_fields_dependencies).flat());
          //get all fields with default expression without dependencies
          var fields_without_dependencies = this.default_expression_fields_on_update.filter(function (_ref7) {
            var name = _ref7.name;
            return !fields_with_dependencies.has(name);
          });
          //set property value of field by default expression result from server
          yield Promise.allSettled(fields_without_dependencies.map(function (field) {
            return new Promise(function () {
              var _ref8 = _asyncToGenerator(function* (resolve, reject) {
                try {
                  //get current value of field
                  var cvalue = field.value;
                  //get value after calculate default expression from server
                  var value = yield (0, _getDefaultExpression.getDefaultExpression)({
                    field: field,
                    feature: _this9.feature,
                    qgs_layer_id: _this9.layer.getId(),
                    parentData: _this9.parentData
                  });
                  //check if changed
                  if (cvalue !== value) {
                    //wait until changeInput method is resolved
                    yield new Promise(function (resolve) {
                      return _this9.once('changeInput', resolve);
                    });
                  }
                  resolve();
                } catch (e) {
                  console.warn(e);
                  reject();
                }
              });

              return function (_x22, _x23) {
                return _ref8.apply(this, arguments);
              };
            }());
          }));
        } catch (e) {
          console.warn(e);
        }
      });

      function saveDefaultExpressionFieldsNotDependencies() {
        return _ref6.apply(this, arguments);
      }

      return saveDefaultExpressionFieldsNotDependencies;
    }()
  }]);

  return FormService;
}(_g3wObject2.default);

},{"components/Form.vue":84,"components/FormBody.vue":85,"g3w-component":158,"g3w-object":163,"services/gui":207,"utils/getDefaultExpression":241,"utils/getFilterExpression":242}],147:[function(require,module,exports){
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

/**
 * Perform search
 * 
 * @param { Object } opts
 * @param opts.filter
 * @param opts.queryUrl
 * @param opts.feature_count
 * @param opts.show            - false = internal request (No output data)
 * 
 * @returns { Promise<void|unknown> }
 */
var doSearch = function () {
  var _ref2 = _asyncToGenerator(function* () {
    var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        filter = _ref3.filter,
        queryUrl = _ref3.queryUrl,
        show = _ref3.show,
        _ref3$feature_count = _ref3.feature_count,
        feature_count = _ref3$feature_count === undefined ? 10000 : _ref3$feature_count,
        state = _ref3.state;

    queryUrl = undefined === queryUrl ? state.queryurl : queryUrl;
    //show take in account type or return
    show = undefined === show ? 'search' === state.type && 'data' === state.return : show;

    state.searching = true;

    var data = void 0,
        parsed = void 0;
    //For pagination purpose
    var page_sizes = _g3wConstants.PAGELENGTHS;

    try {
      data = yield _data2.default.getData('search:features', {
        inputs: _extends({
          layer: state.search_layers,
          filter: filter || (0, _createFilterFormInputs.createFilterFormInputs)({
            layer: state.search_layers,
            inputs: state.forminputs.filter(function (input) {
              return -1 === [null, undefined, _g3wConstants.SEARCH_ALLVALUE].indexOf(input.value) && '' !== input.value.toString().trim();
            }) // Filter input by NONVALIDVALUES
          }),
          queryUrl: queryUrl,
          formatter: 1,
          feature_count: feature_count,
          raw: 'search' === state.return, // in order to get a raw response
          autofilter: Number(show && state.autofilter.value) }, state.paginate ? { page: 1, page_sizes: page_sizes } : {}),
        outputs: show && { title: state.title }
      });

      // @since 3.11.0.
      // In case of search return == 'search' options.return = 'search', it means that a new search panel needs to show
      if ('search' === state.return) {
        // in case of return, a structure of search
        if (Object.keys((data.data[0] || {}).data || {}).length > 0) {
          //need to eventually close an open result
          yield _gui2.default.closeContent();
          var opts = (data.data[0] || {}).data;
          opts.child = true; //set child true
          //and open a new Search panel
          new SearchPanel(opts, true);
        } else {
          //otherwise, mean the return of search has no values, so we can show an empty results
          _gui2.default.outputDataPlace(Promise.resolve({ data: [] }));
          data = [];
        }
      }

      // auto zoom to query (not pagination)
      if (show && !state.paginate && _application2.default.project.state.autozoom_query && data && data.data && 1 === data.data.length) {
        _gui2.default.getService('map').zoomToFeatures(data.data[0].features);
      }

      var search_1n = !show && 'search_1n' === state.type;
      var features = search_1n && (data.data[0] || {}).features || [];
      var relation = features.length && _application2.default.project.getRelationById(state.search_1n_relationid); // child and father relation fields (search father layer id based on result of child layer)
      var layer = relation && _application2.default.project.getLayerById(relation.referencedLayer); // father layer id

      // no features on result or no relation found (@since 3.11.0) → show an empty message
      if (search_1n && (0 === features.length || !relation)) {
        _gui2.default.outputDataPlace(Promise.resolve({ data: [] }));
        parsed = [];
      }

      // parse search_1n
      if (relation) {
        var _relation$fieldRef = relation.fieldRef,
            referencedField = _relation$fieldRef.referencedField,
            referencingField = _relation$fieldRef.referencingField;
        //@since 3.11.0 Backport old relation with relation fields not array (no multiple field)

        referencedField = [].concat(referencedField);
        referencingField = [].concat(referencingField);
        parsed = yield _data2.default.getData('search:features', {
          inputs: _extends({
            layer: layer,
            filter: (0, _createFilterFormInputs.createFilterFormInputs)({
              layer: layer,
              inputs: features.map(function (f) {
                return {
                  attribute: 1 === referencedField.length ? referencedField[0] : referencedField,
                  logicop: 'OR',
                  operator: 'eq',
                  value: [].concat(_toConsumableArray(new Set(1 === referencingField.length // get unique values
                  ? features.map(function (f) {
                    return f.get(referencingField[0]);
                  }) // → single field relation
                  : referencingField.map(function (rf) {
                    return f.get(rf);
                  }) // → multi field relation
                  )))
                };
              })
            }),
            formatter: 1,
            feature_count: feature_count,
            autofilter: state.autofilter.value }, state.paginate ? { page: 1, page_sizes: page_sizes } : {}),
          outputs: {
            title: state.title
          }
        });
      }
    } catch (e) {
      console.warn(e);
    }

    state.searching = false;

    return parsed ? parsed : data;
  });

  return function doSearch() {
    return _ref2.apply(this, arguments);
  };
}();

exports.SearchPanel = SearchPanel;

var _g3wConstants = require('g3w-constants');

var _g3wObject = require('g3w-object');

var _g3wObject2 = _interopRequireDefault(_g3wObject);

var _g3wPanel = require('g3w-panel');

var _g3wPanel2 = _interopRequireDefault(_g3wPanel);

var _application = require('store/application');

var _application2 = _interopRequireDefault(_application);

var _gui = require('services/gui');

var _gui2 = _interopRequireDefault(_gui);

var _data = require('services/data');

var _data2 = _interopRequireDefault(_data);

var _getUniqueDomId = require('utils/getUniqueDomId');

var _createFilterFormInputs = require('utils/createFilterFormInputs');

var _toRawType = require('utils/toRawType');

var _getDataForSearchInput = require('utils/getDataForSearchInput');

var _debounce = require('utils/debounce');

var _getCatalogLayerById = require('utils/getCatalogLayerById');

var _SearchPanel = require('components/SearchPanel.vue');

var vueSearchComp = _interopRequireWildcard(_SearchPanel);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } } /**
                                                                                                                                                                                                     * @file
                                                                                                                                                                                                     * @since 3.10.0
                                                                                                                                                                                                     */

/**
 * ORIGINAL SOURCE: src/app/gui/search/vue/panel/searchpanel.js@v3.9.3
 * ORIGINAL SOURCE: src/app/gui/search/vue/panel/searchservice.js@v3.9.3
 */
function SearchPanel() {
  var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var show = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var state = {
    loading: {}, // store loading state of each input and each dependency
    searching: false, //Boolean. If true, search request from server is starts. False no search
    title: opts.name,
    /** @type { 'search' | 'search_1n' } */
    type: opts.type || 'search',
    /** @TODO check if deprecated */
    queryurl: (opts.options || {}).queryurl,
    /** @deprecated will be removed in v4.x */
    search_endpoint: 'api',
    search_1n_relationid: opts.options.search_1n_relationid, //relations
    /** Layers that will be searchable for that search form. The First one is a layer owner of the search set on admin. */
    search_layers: [(opts.options || {}).querylayerid || (opts.options || {}).layerid || null].concat(_toConsumableArray((opts.options || {}).otherquerylayerids || [])).map(function (id) {
      return (0, _getCatalogLayerById.getCatalogLayerById)(id);
    }),
    /** Array of inputs that belongs to search form  */
    forminputs: ((opts.options || {}).filter || []).map(function (d, i) {
      return {
        id: d.id || (0, _getUniqueDomId.getUniqueDomId)(),
        type: d.input.type || 'textfield',
        widget_type: d.input.widget_type,
        label: d.label,
        attribute: d.attribute,
        values: d.input.options.values || [],
        /** group values by parent value */
        dvalues: {},
        /**
         * true → initially it is disabled (values = [], ALL value)
         *        as in the case in which the dependent field will
         *        return to having ALL value. When a value is set to
         *        the dependent field, the select will be enabled and
         *        will contain the filtered values consistent with the
         *        value of the dependent parent field
         */
        dependance_strict: d.input.options.dependance_strict || false,
        /**
         * true → the select is not disabled and will contain all possible values
         *        (since at the beginning the parent will have the value ALL).
         *        When the value of the dependent field changes, the values in the
         *        select list will be filtered in a manner consistent with the value
         *        of the parent
         */
        dependance: d.input.options.dependance || false,
        value: 'selectfield' === d.input.type ? _g3wConstants.SEARCH_ALLVALUE : null,
        operator: d.op,
        logicop: i === opts.options.filter.length - 1 ? null : d.logicop,
        loading: true,
        disabled: d.input.options.disabled || false,
        /** keep a reference to initial search options (you shouldn't mutate them..) */
        options: d.input.options
      };
    }),
    //@since v3.11.0. Used to set already feature layers filtered https://github.com/g3w-suite/g3w-client/issues/676
    autofilter: { value: 0 }, //value 0 no set, 1
    paginate: !!opts.options.paginate, //@since 3.11.0 paginate or not
    return: (opts.options || {}).return || 'data', //@since 3.11.0 considere type of search return. Can be another search or data
    child: !!opts.child //@since 3.11.0 Need to know if search is coming from another search
  };

  var setInputs = function () {
    var _ref = _asyncToGenerator(function* () {

      for (var i = 0; i <= state.forminputs.length - 1; i++) {

        var input = state.forminputs[i];
        // set key-values for select
        input.values = [].concat(_toConsumableArray('selectfield' === input.type ? [_g3wConstants.SEARCH_ALLVALUE] : []), _toConsumableArray(input.dependance_strict || 'selectfield' !== input.type || 'selectfield' === input.type && state.child //@in the case of parent, values are stored
        ? input.values : yield (0, _getDataForSearchInput.getDataForSearchInput)({ state: state, field: input.attribute }) // retrieve input values from server
        )).map(function (value) {
          return 'Object' === (0, _toRawType.toRawType)(value) ? value : { key: value, value: value };
        });
        // there is a dependence
        if (input.dependance) {
          state.loading[input.dependance] = false;
          input.disabled = input.dependance_strict; // disabled for BACKCOMP
        }

        // save a copy of original values
        input._values = [].concat(_toConsumableArray(input.values));

        input.loading = false;
      }
    });

    return function setInputs() {
      return _ref.apply(this, arguments);
    };
  }();
  // create search form structure 
  state.mounted = setInputs();

  var service = opts.service || Object.assign(new _g3wObject2.default(), {
    state: state,
    doSearch: doSearch,
    setInputs: setInputs,
    run: (0, _debounce.debounce)(function () {
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      var _GUI$getService$getMa = _gui2.default.getService('map').getMap().getSize(),
          _GUI$getService$getMa2 = _slicedToArray(_GUI$getService$getMa, 2),
          w = _GUI$getService$getMa2[0],
          h = _GUI$getService$getMa2[1];

      var hide = _gui2.default.isMobile() && (0 === w || 0 === h);
      setTimeout(function () {
        if (hide) {
          _gui2.default.hideSidebar();
        }
        panel.getService().doSearch(_extends({}, args, { state: state }));
      }, hide ? 0 : 600);
    }),
    clear: function clear() {
      panel.getService().state = null;
    },

    createFilter: function createFilter() {
      return (0, _createFilterFormInputs.createFilterFormInputs)({
        layer: state.search_layers,
        inputs: state.forminputs.filter(function (i) {
          return ![null, undefined, _g3wConstants.SEARCH_ALLVALUE].includes(i.value) && '' !== i.value.toString().trim();
        }) // Filter input by NONVALIDVALUES
      });
    }
  });

  var panel = new _g3wPanel2.default(_extends({}, opts, {
    show: show,
    id: opts.id || (0, _getUniqueDomId.getUniqueDomId)(),
    title: opts.title || 'search',
    vueComponentObject: opts.component || vueSearchComp,
    service: service
  }));

  return panel;
}

},{"components/SearchPanel.vue":140,"g3w-constants":159,"g3w-object":163,"g3w-panel":164,"services/data":206,"services/gui":207,"store/application":212,"utils/createFilterFormInputs":225,"utils/debounce":232,"utils/getCatalogLayerById":238,"utils/getDataForSearchInput":240,"utils/getUniqueDomId":252,"utils/toRawType":277}],148:[function(require,module,exports){
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.trigger = exports.unwatch = exports.watch = undefined;

var _getUniqueDomId = require('utils/getUniqueDomId');

/**
 * Internal state
 */
var vm = new Vue(); /**
                     * @TODO refactor stateful directives (eg. "v-t") in order to delete this file: "src/directives/utils.js"
                     */

var directives = {};

var watch = exports.watch = function watch() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      el = _ref.el,
      attr = _ref.attr,
      watcher = _ref.watcher,
      _ref$immediate = _ref.immediate,
      immediate = _ref$immediate === undefined ? true : _ref$immediate;

  var unique_attr_id = (0, _getUniqueDomId.getUniqueDomId)();
  el.setAttribute(attr, unique_attr_id);
  var dir = directives[unique_attr_id] = {};
  if (watcher) {
    dir.unwatch = vm.$watch(watcher[0], watcher[1], watcher[2] || { immediate: immediate });
    dir.handler = watcher[1];
  }
  return unique_attr_id;
};

var unwatch = exports.unwatch = function unwatch() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      el = _ref2.el,
      attr = _ref2.attr;

  var unique_attr_id = el.getAttribute(attr);
  if (unique_attr_id) {
    directives[unique_attr_id].unwatch();
    delete directives[unique_attr_id];
  }
};

var trigger = exports.trigger = function trigger(_ref3) {
  var el = _ref3.el,
      attr = _ref3.attr,
      data = _ref3.data;
  return directives[el.getAttribute(attr)].handler(data);
};

},{"utils/getUniqueDomId":252}],149:[function(require,module,exports){
Object.defineProperty(exports, "__esModule", {
  value: true
});

/**
 * @file
 * @since v3.7
 */

exports.default = function (el, binding) {
  binding.value ? el.setAttribute('checked', 'checked') : el.removeAttribute('checked');
};

},{}],150:[function(require,module,exports){
Object.defineProperty(exports, "__esModule", {
  value: true
});

/**
 * @file
 * @since v3.7
 */

exports.default = function (el, binding) {
  el.classList.toggle('g3w-disabled', binding.value);
};

},{}],151:[function(require,module,exports){
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _application = require('store/application');

var _application2 = _interopRequireDefault(_application);

var _utils = require('directives/utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @file
 * @since v3.7
 */

var attr = 'g3w-v-download-id';

exports.default = {
  bind: function bind(el, binding) {
    if ('boolean' === typeof binding.value ? binding.value : true) {
      (0, _utils.watch)({
        el: el,
        attr: attr,
        watcher: [function () {
          return _application2.default.download;
        }, function (bool) {
          var className = binding.modifiers && binding.modifiers.show && 'hide' || 'disabled';
          el.classList.toggle('g3w-' + className, className === 'hide' ? !bool : bool);
        }]
      });
    }
  },

  unbind: function unbind(el) {
    return (0, _utils.unwatch)({ el: el, attr: attr });
  }
};

},{"directives/utils":148,"store/application":212}],152:[function(require,module,exports){
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _application = require('store/application');

var _application2 = _interopRequireDefault(_application);

var _utils = require('directives/utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @file
 * @since v3.7
 */

var attr = 'g3w-v-select2-id';

exports.default = {
  inserted: function inserted(el, binding, vnode) {
    var _ref = vnode.data.attrs || {},
        templateResult = _ref.templateResult,
        templateSelection = _ref.templateSelection,
        _ref$multiple = _ref.multiple,
        multiple = _ref$multiple === undefined ? false : _ref$multiple,
        _ref$search = _ref.search,
        search = _ref$search === undefined ? true : _ref$search,
        select2_value = _ref.select2_value,
        indexItem = _ref.indexItem,
        _ref$createTag = _ref.createTag,
        createTag = _ref$createTag === undefined ? false : _ref$createTag,
        _ref$dropdownAutoWidt = _ref.dropdownAutoWidth,
        dropdownAutoWidth = _ref$dropdownAutoWidt === undefined ? false : _ref$dropdownAutoWidt,
        _ref$dropdownParent = _ref.dropdownParent,
        dropdownParent = _ref$dropdownParent === undefined ? false : _ref$dropdownParent,
        _ref$placeholder = _ref.placeholder,
        placeholder = _ref$placeholder === undefined ? '' : _ref$placeholder,
        _ref$clear = _ref.clear,
        clear = _ref$clear === undefined ? false : _ref$clear;

    var isArray = binding.value && Array.isArray(vnode.context[binding.value]) // check if is an array
    && undefined !== indexItem; // check if indexItem is defined
    //Need in case of change
    var createSelect2 = function createSelect2() {
      $(el).select2({
        tags: createTag,
        width: '100%',
        // dropdownCssClass: 'skin-color',
        dropdownAutoWidth: dropdownAutoWidth,
        dropdownParent: true === dropdownParent ? $(el.parentNode) : undefined,
        templateResult: templateResult,
        templateSelection: templateSelection,
        minimumResultsForSearch: search ? undefined : -1,
        placeholder: placeholder,
        allowClear: clear,
        createTag: function createTag(params) {
          var value = params.term.trim();
          return value ? {
            id: value,
            text: value,
            newTag: true // add additional value
          } : null;
        }
      }).on('select2:select select2:unselect', function (e) {
        if (!binding.value) {
          return;
        }

        var value = binding.value;
        var selected = 'select2:select' === e.type;
        var id = e.params.data.id;
        var ctx = vnode.context;
        var arr = selected && (isArray ? ctx[value][indexItem].value : ctx[value]);

        // selected
        // check is can have multiple value
        if (selected && multiple && arr.every(function (d) {
          return id !== d;
        })) {
          arr.push(id);
        } else if (selected && isArray) {
          ctx[value][indexItem].value = id;
        } else if (selected) {
          // take in an account text binding value single world or object (eg. state.name)
          var attrs = ('' + value).split('.');
          var last = attrs.pop();
          attrs.reduce(function (acc, a) {
            acc = acc[a];return acc;
          }, vnode.context)[last] = id;
        }

        // unselected
        if (!selected && multiple && isArray) {
          ctx[value][indexItem].value = ctx[value][indexItem].value.filter(function (d) {
            return id !== d;
          });
        } else if (!selected && multiple) {
          ctx[value] = ctx[value].filter(function (d) {
            return id !== d;
          });
        }

        // dispatch "change" event to native <select> element
        if (selected || multiple) {
          el.dispatchEvent(new Event("change"));
        }
      });
    };

    createSelect2();
    // listen `select2_value` attribute changes to reflect select2 current value
    if (binding.value && undefined !== select2_value) {
      $(el).val(select2_value).trigger('change');
      vnode.g3w_observer = new MutationObserver(function (mutations) {
        var target = (mutations.find(function (m) {
          return "select2_value" === m.attributeName;
        }) || {}).target;
        if (target) {
          $(el).val(target.getAttribute("select2_value")).trigger('change');
        }
      });
      vnode.g3w_observer.observe(el, { attributes: true });
    }
    //@since 3.11.0
    (0, _utils.watch)({
      el: el,
      attr: attr,
      watcher: [function () {
        return _application2.default.language;
      }, function () {
        return createSelect2();
      }],
      immediate: false
    });
  },

  unbind: function unbind(el, vnode) {
    if (vnode.g3w_observer) {
      vnode.g3w_observer.disconnect();
    }
    $(el).select2('destroy');
    (0, _utils.unwatch)({ el: el, attr: attr });
  }
};

},{"directives/utils":148,"store/application":212}],153:[function(require,module,exports){
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _application = require('store/application');

var _application2 = _interopRequireDefault(_application);

var _utils = require('directives/utils');

var _g3wI18n = require('g3w-i18n');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var attr = 'g3w-v-t-html-id'; /**
                               * @file
                               * @since v3.7
                               */

exports.default = {
  bind: function bind(el, binding) {
    (0, _utils.watch)({
      el: el,
      attr: attr,
      watcher: [function () {
        return _application2.default.language;
      }, function () {
        el.innerHTML = '' + (0, _g3wI18n.t)(binding.value);
      }]
    });
  },
  update: function update(el, binding) {
    if (binding.value !== binding.oldValue) {
      el.innerHTML = '' + (0, _g3wI18n.t)(binding.value);
    }
  },

  unbind: function unbind(el) {
    return (0, _utils.unwatch)({ el: el, attr: attr });
  }
};

},{"directives/utils":148,"g3w-i18n":162,"store/application":212}],154:[function(require,module,exports){
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _application = require('store/application');

var _application2 = _interopRequireDefault(_application);

var _utils = require('directives/utils');

var _g3wI18n = require('g3w-i18n');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var attr = 'g3w-v-t-plugin-id'; /**
                                 * @file
                                 * @since v3.7
                                 */

exports.default = {
  bind: function bind(el, binding) {
    var innerHTML = el.innerHTML;
    (0, _utils.watch)({
      el: el,
      attr: attr,
      watcher: [function () {
        return _application2.default.language;
      }, function () {
        var value = null !== binding.value ? (0, _g3wI18n.tPlugin)(binding.value) : '';
        switch (binding.arg ? binding.arg : 'post') {
          case 'pre':
            el.innerHTML = value + ' ' + innerHTML;break;
          case 'post':
            el.innerHTML = innerHTML + ' ' + value;break;
        }
      }]
    });
  },

  unbind: function unbind(el) {
    return (0, _utils.unwatch)({ el: el, attr: attr });
  }
};

},{"directives/utils":148,"g3w-i18n":162,"store/application":212}],155:[function(require,module,exports){
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _application = require('store/application');

var _application2 = _interopRequireDefault(_application);

var _utils = require('directives/utils');

var _g3wI18n = require('g3w-i18n');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var attr = 'g3w-v-t-title-id'; /**
                                * @file
                                * @since v3.7
                                */

exports.default = {
  bind: function bind(el, binding) {
    (0, _utils.watch)({
      el: el,
      attr: attr,
      watcher: [function () {
        return _application2.default.language;
      }, function () {
        var title = ('plugin' === binding.arg ? _g3wI18n.tPlugin : _g3wI18n.t)(binding.value);
        el.setAttribute('title', title);
        el.setAttribute('data-original-title', title);
      }] });
  },

  unbind: function unbind(el) {
    return (0, _utils.unwatch)({ el: el, attr: attr });
  }
};

},{"directives/utils":148,"g3w-i18n":162,"store/application":212}],156:[function(require,module,exports){
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _application = require('store/application');

var _application2 = _interopRequireDefault(_application);

var _utils = require('directives/utils');

var _g3wI18n = require('g3w-i18n');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var attr = 'g3w-v-t-tooltip-id'; /**
                                  * @file
                                  * @since v3.7
                                  */

exports.default = {
  bind: function bind(_el, binding) {
    // Automatically create tooltip
    if (binding.modifiers.create) {
      if (binding.arg) {
        _el.setAttribute('data-placement', binding.arg);
        _el.classList.add('skin-tooltip-' + binding.arg);
      }
      _el.setAttribute('data-container', "body");
      $(_el).tooltip({ trigger: _application2.default.ismobile ? 'click' : 'hover', html: true })
      // hide tooltip on mobile after click
      .on('shown.bs.tooltip', function () {
        _application2.default.ismobile && setTimeout(function () {
          return $(_el).tooltip('hide');
        }, 600);
      });
    }
    (0, _utils.watch)({
      el: _el,
      attr: attr,
      watcher: [function () {
        return _application2.default.language;
      }, function (_ref) {
        var _ref$el = _ref.el,
            el = _ref$el === undefined ? _el : _ref$el;

        var value = el.getAttribute('current-tooltip');
        if (null === value) {
          value = binding.value;
        }
        el.setAttribute('data-original-title', binding.modifiers.text ? value : ('plugin' === binding.arg ? _g3wI18n.tPlugin : _g3wI18n.t)(value));
      }]
    });
  },
  componentUpdated: function componentUpdated(el, oldVnode) {
    var value = el.getAttribute('current-tooltip');
    //in case of null or empty value, need to hide tooltip
    if ([null, ''].includes(value)) {
      $(el).tooltip('hide');
    }
    if (null != value && value !== oldVnode.oldValue) {
      (0, _utils.trigger)({ el: el, attr: attr, data: { el: el } });
    }
  },

  unbind: function unbind(el) {
    $(el).tooltip('hide');(0, _utils.unwatch)({ el: el, attr: attr });
  }
};

},{"directives/utils":148,"g3w-i18n":162,"store/application":212}],157:[function(require,module,exports){
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _application = require('store/application');

var _application2 = _interopRequireDefault(_application);

var _utils = require('directives/utils');

var _g3wI18n = require('g3w-i18n');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var attr = 'g3w-v-t-id';

/**
 * @since 3.8.7
 */
/**
 * @file
 * @since v3.7
 */

var handleInnerHTML = function handleInnerHTML() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      el = _ref.el;

  var value = null === el.__currentBinding.value ? '' : (0, _g3wI18n.t)(el.__currentBinding.value);
  switch (el.__currentBinding.arg ? el.__currentBinding.arg : 'post') {
    case 'pre':
      el.innerHTML = value + ' ' + el.__innerHTML;break;
    case 'post':
      el.innerHTML = el.__innerHTML + ' ' + value;break;
  }
};

exports.default = {
  bind: function bind(el, binding) {
    /**
     * @since 3.8.7
     */
    // set init innerHTML value of element
    el.__innerHTML = el.innerHTML;
    //set current binging
    el.__currentBinding = binding;
    (0, _utils.watch)({
      el: el,
      attr: attr,
      watcher: [function () {
        return _application2.default.language;
      }, function () {
        return handleInnerHTML({ el: el });
      }]
    });
  },

  /**
   * @since 3.8.7
   */
  componentUpdated: function componentUpdated(el, binding) {
    if (el.__currentBinding.value !== binding.value) {
      // reset currentBinding to get last value;
      el.__currentBinding = binding;
      handleInnerHTML({ el: el });
    }
  },


  unbind: function unbind(el) {
    return (0, _utils.unwatch)({ el: el, attr: attr });
  }
};

},{"directives/utils":148,"g3w-i18n":162,"store/application":212}],158:[function(require,module,exports){
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _g3wObject = require('g3w-object');

var _g3wObject2 = _interopRequireDefault(_g3wObject);

var _noop = require('utils/noop');

var _promisify = require('utils/promisify');

var _gui = require('services/gui');

var _gui2 = _interopRequireDefault(_gui);

var _lodash = require('lodash.clonedeep');

var _lodash2 = _interopRequireDefault(_lodash);

var _utilDeprecate = require('util-deprecate');

var _utilDeprecate2 = _interopRequireDefault(_utilDeprecate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @file ORIGINAL SOURCE: src/app/core/g3w-component.js@v3.10.2
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @since 3.11.0
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

/** @deprecated */


var çç = function çç(a, b) {
  return undefined !== a ? a : b;
}; // like a ?? (coalesce operator)

function merge(destination, source) {
  for (var key in source) {
    if (Object.prototype.hasOwnProperty.call(source, key)) {
      destination[key] = source[key];
    }
  }
}

/**
 * Component class
 * 
 * ORIGINAL SOURCE src/app/gui/component/component.js@v3.9.3
 * 
 * @param { Object} opts
 * @param { number } opts.id 
 * @param { string } opts.title
 * @param { boolean } opts.visible
 * @param { boolean } opts.open
 * @param { boolean } opts.resizable
 * @param { null | unknown } opts.info
 * @param { boolean } opts.loading
 * @param { boolean } opts.disabled
 * @param { boolean } opts.closewhenshowviewportcontent
 * @param opts.events
 * @param opts.internalComponent since 3.10.0
 * @param opts.service since 3.10.0
 */

var Component = function (_G3WObject) {
  _inherits(Component, _G3WObject);

  function Component() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, Component);

    // BACKOMP v3.x
    if (opts.iconConfig) {
      opts.iconColor = opts.iconConfig.color;
      opts.icon = opts.iconConfig.icon;
      delete opts.iconConfig;
    }

    // TODO: check why `GUI.getFontClass` is undefined
    opts.icon = _gui2.default.getFontClass(opts.icon) || opts.icon;

    opts.open = çç(opts.open, false);
    opts.mobile = çç(opts.mobile, true);
    opts.collapsible = çç(opts.collapsible, true);

    var _this = _possibleConstructorReturn(this, (Component.__proto__ || Object.getPrototypeOf(Component)).call(this, {
      setters: {
        setOpen: function setOpen(bool) {
          this.state.open = bool;
          if (this._setOpen) {
            this._setOpen(bool);
          }
        },
        setVisible: function setVisible(bool) {
          this.state.visible = bool;
          if (this._setVisible) {
            this._setVisible(bool);
          }
        },
        setLoading: function setLoading() {
          var bool = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

          this.state.loading = bool;
        },
        setDisabled: function setDisabled() {
          var bool = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

          this.state.disabled = bool;
        },
        reload: function reload() {
          console.warn('[G3W-CLIENT] reloading of components will be discontinued, please update your code as soon as possible', this.getId());
          if (this._reload) {
            this._reload();
          }
        }
      }

    }));

    _this._firstLayout = true;

    /** internal VUE component */
    _this.internalComponent = çç(opts.internalComponent, null);

    /** @type { Array } */
    _this._components = [];

    /** @type { string } */
    _this.id = çç(opts.id, Math.random() * 1000);

    /** @type { string } */
    _this.title = çç(opts.title, '');

    _this.state = {
      sizes: { width: 0, height: 0 },
      info: çç(opts.info, null),
      open: çç(opts.open, false),
      visible: çç(opts.visible, true),
      loading: çç(opts.loading, false),
      disabled: çç(opts.disabled, false),
      resizable: çç(opts.resizable, false),
      closewhenshowviewportcontent: çç(opts.closewhenshowviewportcontent, true)
    };

    _this.setService(opts.service || _this);

    if (opts.internalComponent) {
      _this.setInternalComponent(opts.internalComponent);
    }

    merge(_this, opts);

    // add events options
    _this.events = çç(opts.events, {});

    if (_this.events.open) {
      var _this$events$open = _this.events.open,
          _this$events$open$whe = _this$events$open.when,
          when = _this$events$open$whe === undefined ? "after" : _this$events$open$whe,
          _this$events$open$cb = _this$events$open.cb,
          cb = _this$events$open$cb === undefined ? function () {} : _this$events$open$cb;

      _this['on' + when]('setOpen', function (bool) {
        return cb(bool);
      });
    }

    if (opts.vueComponentObject) {
      _this.init(opts);
    }
    return _this;
  }

  /**
   * @param { Object } opts
   * @param { Array } opts.components
   * @param { Object } opts.service
   * @param { Function } opts.service.init
   * @param opts.vueComponentObject
   * @param opts.template
   * @param opts.propsData
   */


  _createClass(Component, [{
    key: 'init',
    value: function init() {
      var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      this.vueComponent = (0, _lodash2.default)(opts.vueComponentObject);
      this._components = opts.components || [];

      this.setService(opts.service || this._service || _noop.noop);

      if (this._service.init && this.init !== this._service.init) {
        this._service.init(opts);
      }

      if (opts.template) {
        this.vueComponent.template = opts.template;
      }

      this.setInternalComponent = function () {
        this.internalComponent = new (Vue.extend(this.vueComponent))({
          service: this._service,
          template: opts.template,
          propsData: opts.propsData
        });
        this.internalComponent.state = this.getService().state;
      };

      this.setInternalComponent();

      return this;
    }
  }, {
    key: 'getId',
    value: function getId() {
      return this.id;
    }
  }, {
    key: 'setId',
    value: function setId(id) {
      this.id = id;
    }
  }, {
    key: 'getOpen',
    value: function getOpen() {
      return this.state.open;
    }
  }, {
    key: 'getVisible',
    value: function getVisible() {
      return this.state.visible;
    }
  }, {
    key: 'getTitle',
    value: function getTitle() {
      return this.state.title;
    }
  }, {
    key: 'setTitle',
    value: function setTitle(title) {
      this.state.title = title;
    }
  }, {
    key: 'getService',
    value: function getService() {
      return this._service;
    }
  }, {
    key: 'setService',
    value: function setService(service) {
      this._service = service;
    }
  }, {
    key: 'addComponent',
    value: function addComponent(Component) {
      this._components.push(Component);
    }
  }, {
    key: 'removeComponent',
    value: function removeComponent(Component) {
      var _this2 = this;

      this._components.find(function (c, i) {
        if (c === Component) {
          _this2.splice(i, 1);
          return true;
        }
      });
    }
  }, {
    key: 'getInternalComponent',
    value: function getInternalComponent() {
      return this.internalComponent;
    }
  }, {
    key: 'setInternalComponent',
    value: function setInternalComponent(internalComponent) {
      var _this3 = this;

      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      this.internalComponent = undefined === internalComponent && this.internalComponentClass ? new this.internalComponentClass() : internalComponent;
      (options.events || []).forEach(function (e) {
        return _this3.internalComponent.$on(e.name, function (data) {
          return e.handler && e.handler(data) || _this3['set' + e.name[0].toUpperCase() + e.name.slice(1)](data);
        });
      });
      if (this._service && this._service.state) {
        this.internalComponent.state = this._service.state;
      }
    }

    /**
     * @param { Element | 'string' } parent DOM element
     * @param { boolean } append
     *  
     * @returns jquery promise
     * 
     * @fires internalComponent~ready
     * @fires mount event
     */

  }, {
    key: 'mount',
    value: function mount(parent, append) {
      var _this4 = this;

      return (0, _promisify.$promisify)(new Promise(function (resolve) {
        if (!_this4.internalComponent) {
          _this4.setInternalComponent();
        }

        if (append) {
          $(parent).append(_this4.internalComponent.$mount().$el);
        }

        if (!append) {
          _this4.internalComponent.$mount(parent);
        }

        _this4.internalComponent.$nextTick(function () {
          $(parent).localize();
          _this4.emit('ready');
          resolve(true);
        });

        // emit mount event
        _this4.emit('mount');
      }));
    }

    /**
     * @returns jquery promise
     * 
     * @fires unmount
     */

  }, {
    key: 'unmount',
    value: function unmount() {
      var _this5 = this;

      return (0, _promisify.$promisify)(_asyncToGenerator(function* () {
        if (!_this5.internalComponent) {
          return;
        }
        if (_this5.state.resizable) {
          _this5.internalComponent.$off('resize-component', _this5.internalComponent.layout);
        }
        _this5.state.open = false;
        _this5.internalComponent.$destroy(true); // destroy vue component
        $(_this5.internalComponent.$el).remove(); // remove dom element
        _this5.internalComponent = null; // set internal componet to null (for GC)
        _this5.emit('unmount'); // emit unmount event
      }));
    }

    /**
     * @returns { Element } DOM element
     */

  }, {
    key: 'ismount',
    value: function ismount() {
      return this.internalComponent && this.internalComponent.$el;
    }

    /**
     * @param { number } width 
     * @param { number } height 
     * 
     * @listens internalComponent~resize-component
     * @fires internalComponent~resize-component
     * @fires layout
     */

  }, {
    key: 'layout',
    value: function layout(width, height) {
      var _this6 = this;

      if (this.state.resizable && this._firstLayout) {
        this.internalComponent.$on('resize-component', this.internalComponent.layout);
        this._firstLayout = false;
      }
      this.internalComponent.$nextTick(function () {
        _this6.internalComponent.$emit('resize-component', { width: width, height: height });
      });
      this.emit('layout');
    }
  }]);

  return Component;
}(_g3wObject2.default);

/**
 * @deprecated since 3.10.0 Will be deleted in 4.x.
 */


exports.default = Component;
Object.assign(Component.prototype, {
  destroy: _noop.noop,
  click: _noop.noop,
  show: _noop.noop,
  /** used by the following plugins: "cadastre", "iternet" */
  overwriteServiceMethods: (0, _utilDeprecate2.default)(function (o) {
    var _this7 = this;

    Object.entries(o).forEach(function (_ref2) {
      var _ref3 = _slicedToArray(_ref2, 2),
          n = _ref3[0],
          m = _ref3[1];

      return _this7._service[n] = m;
    });
  }, '[G3W-CLIENT] Component::overwriteServiceMethods(methodsOptions) is deprecated'),
  /** used by the following plugins: "cadastre" */
  extendInternalComponent: (0, _utilDeprecate2.default)(function (o) {
    var _this8 = this;

    this.vueComponent ? Object.entries(o).forEach(function (_ref4) {
      var _ref5 = _slicedToArray(_ref4, 2),
          k = _ref5[0],
          v = _ref5[1];

      switch (k) {case 'methods':
          _this8.extendInternalComponentMethods(v);break;case 'components':
          _this8.extendInternalComponentComponents(v);break;case 'computed':
          merge(_this8.vueComponent[k], v);break;case 'data':
          merge(_this8.vueComponent[k], v);break;}
    }) : this.vueComponent = o;
  }, '[G3W-CLIENT] Component::extendInternalComponent(internalComponentOptions) is deprecated')
});

},{"g3w-object":163,"lodash.clonedeep":24,"services/gui":207,"util-deprecate":30,"utils/noop":262,"utils/promisify":267}],159:[function(require,module,exports){
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PAGELENGTHS = exports.SELECTION = exports.INCHES_PER_UNIT = exports.DOTS_PER_INCH = exports.SPATIAL_METHODS = exports.LOCAL_ITEM_IDS = exports.FONT_AWESOME_ICONS = exports.VIEWPORT = exports.TIMEOUT = exports.SEARCH_ALLVALUE = exports.QUERY_POINT_TOLERANCE = exports.PRINT_SCALES = exports.GEOMETRY_TYPES = exports.GEOMETRY_FIELDS = exports.FILTER_EXPRESSION_OPERATORS = exports.FILTER_OPERATORS = exports.G3W_FID = exports.DEFAULT_EDITING_CAPABILITIES = exports.APP_VERSION = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /**
                                                                                                                                                                                                                                                                   * @file all contants values used on application
                                                                                                                                                                                                                                                                   * @since 3.11.0
                                                                                                                                                                                                                                                                   */

//@ts-check

/**
 * @TODO we can safely import "version" from "package.json" when we will use native ES Modules
 */
// import { version } from '../package.json';


var _version = require('./version');

var _version2 = _interopRequireDefault(_version);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Same as "package.json" version
 * 
 * @type {string}
 */
var APP_VERSION = exports.APP_VERSION = _version2.default;

/**
 * Default editing capabilities
 * @deprecated  Will be removed in 4.x. Moved to g3w-client-plugin-editing
 * 
 * @type {string[]}
 */
var DEFAULT_EDITING_CAPABILITIES = exports.DEFAULT_EDITING_CAPABILITIES = ['add_feature', 'change_feature', 'change_attr_feature', 'delete_feature'];

/**
 * fid name field referred to fid feature
 * 
 * @type {string}
 */
var G3W_FID = exports.G3W_FID = 'g3w_fid';

/**
 * @type {Object<string, string>}
 * @since v3.5
 */
var FILTER_OPERATORS = exports.FILTER_OPERATORS = {
  gte: '>=',
  lte: '<=',
  NOT: '!=',
  eq: '=',
  gt: '>',
  lt: '<',
  IN: 'IN',
  LIKE: 'LIKE',
  ILIKE: 'ILIKE',
  AND: 'AND',
  OR: 'OR'
};

/**
 * @type {Object<string, string>}
 * @since v3.5
 */
var FILTER_EXPRESSION_OPERATORS = exports.FILTER_EXPRESSION_OPERATORS = _extends({
  lte: '<=',
  ltgt: '!=',
  ilike: 'ILIKE',
  like: 'LIKE'
}, FILTER_OPERATORS);

/**
 * Geometry fields used to exclude or get geometry information from server request
 * 
 * @type {string[]}
 */
var GEOMETRY_FIELDS = exports.GEOMETRY_FIELDS = ['geometryProperty', 'boundedBy', 'geom', 'the_geom', 'geometry', 'bbox', 'GEOMETRY', 'geoemtria', 'geometria'];

/**
 * @type {Object<string, string>}
 */
var GEOMETRY_TYPES = exports.GEOMETRY_TYPES = {
  POINT: "Point",
  POINTZ: "PointZ",
  POINTM: "PointM",
  POINTZM: "PointZM",
  POINT25D: "Point25D",
  MULTIPOINT: "MultiPoint",
  MULTIPOINTZ: "MultiPointZ",
  MULTIPOINTM: "MutliPointM",
  MULTIPOINTZM: "MultiPointZM",
  MULTIPOINT25D: "MultiPoint25D",
  LINESTRING: "LineString", // QGis definition .GeometryType, Line intead di Linestring.
  LINESTRINGZ: "LineStringZ",
  LINESTRINGM: "LineStringM",
  LINESTRINGZM: "LineStringZM",
  LINESTRING25D: "LineString25D",
  LINE: "Line",
  LINEZ: "LineZ",
  LINEM: "LineM",
  LINEZM: "LineZM",
  LINE25D: "Line25D",
  MULTILINESTRING: "MultiLineString",
  MULTILINESTRINGZ: "MultiLineStringZ",
  MULTILINESTRINGM: "MultiLineStringM",
  MULTILINESTRINGZM: "MultiLineStringZM",
  MULTILINESTRING25D: "MultiLineString25D",
  MULTILINE: "MultiLine",
  MULTILINEZ: "MultiLineZ",
  MULTILINEM: "MultiLineM",
  MULTILINEZM: "MultiLineZM",
  MULTILINE25D: "MultiLine25D",
  POLYGON: "Polygon",
  POLYGONZ: "PolygonZ",
  POLYGONM: "PolygonM",
  POLYGONZM: "PolygonZM",
  POLYGON25D: "Polygon25D",
  MULTIPOLYGON: "MultiPolygon",
  MULTIPOLYGONZ: "MultiPolygonZ",
  MULTIPOLYGONM: "MultiPolygonM",
  MULTIPOLYGONZM: "MultiPolygonZM",
  MULTIPOLYGON25D: "MultiPolygon25D",
  GEOMETRYCOLLECTION: "GeometryCollection",
  GEOMETRYCOLLECTIONZ: "GeometryCollectionZ",
  GEOMETRYCOLLECTIONM: "GeometryCollectionM",
  GEOMETRYCOLLECTIONZM: "GeometryCollectionZM",
  GEOMETRYCOLLECTION25D: "GeometryCollection25D"
};

/**
 * @type {Array<{ value: number, label: string }>}
 * @since v3.5
 */
var PRINT_SCALES = exports.PRINT_SCALES = [{ value: 100, label: '1:100' }, { value: 200, label: '1:200' }, { value: 500, label: '1:500' }, { value: 1000, label: '1:1.000' }, { value: 2000, label: '1:2.000' }, { value: 2500, label: '1:2.500' }, { value: 5000, label: '1:5.000' }, { value: 10000, label: '1:10.000' }, { value: 20000, label: '1:20.000' }, { value: 25000, label: '1:25.000' }, { value: 50000, label: '1:50.000' }, { value: 100000, label: '1:100.000' }, { value: 250000, label: '1:250.000' }, { value: 500000, label: '1:500.000' }, { value: 1000000, label: '1:1.000.000' }, { value: 2500000, label: '1:2.500.000' }, { value: 5000000, label: '1:5.000.000' }, { value: 10000000, label: '1:10.000.000' }, { value: 20000000, label: '1:20.000.000' }, { value: 50000000, label: '1:50.000.000' }, { value: 100000000, label: '1:100.000.000' }, { value: 250000000, label: '1:250.000.000' }, { value: 500000000, label: '1:500.000.000' }];

/**
 * Point tolerance when clicking on map
 * 
 * @type {{unit: string, value: number}}
 */
var QUERY_POINT_TOLERANCE = exports.QUERY_POINT_TOLERANCE = {
  unit: 'pixel',
  value: 10
};

/**
 * @type {string}
 * @since v3.5
 */
var SEARCH_ALLVALUE = exports.SEARCH_ALLVALUE = '__G3W_ALL__';

/**
 * TIMEOUT (1 minute = 60000)
 * 
 * @type {number}
 */
var TIMEOUT = exports.TIMEOUT = 60000;

/**
 * @type {{resize: Object<string, { min: number }>}}
 * @since v3.5
 */
var VIEWPORT = exports.VIEWPORT = {
  resize: {
    map: { min: 200 },
    content: { min: 200 }
  }
};

/**
 * List of default Font Awesome classes for current project
 * 
 * @type {Object<string, string>}
 * @since v3.8
 */
var FONT_AWESOME_ICONS = exports.FONT_AWESOME_ICONS = {
  'change-map': "fas fa-map-signs",
  map: "far fa-map",
  file: "fas fa-file-code",
  marker: "fas fa-map-marker-alt",
  relation: "fas fa-sitemap",
  tools: "fas fa-cogs",
  tool: "fas fa-cog",
  search: "fas fa-search",
  print: "fas fa-print",
  info: "fas fa-info-circle",
  'info-circle': "fas fa-info-circle",
  globe: "fas fa-globe",
  mail: "fas fa-envelope",
  mobile: "fas fa-mobile",
  fax: "fas fa-fax",
  user: "fas fa-user",
  bars: "fas fa-bars",
  uncheck: "far fa-square",
  check: "far fa-check-square",
  /** @since 3.10.0 */
  checkmark: "fa fa-check",
  filluncheck: "fas fa-square",
  table: "fas fa-table",
  trash: "fas fa-trash",
  'trash-o': "far fa-trash-alt",
  pencil: "fas fa-pencil-alt",
  'ellips-h': "fas fa-ellipsis-h",
  'ellips-v': "fas fa-ellipsis-v",
  'arrow-up': "fas fa-chevron-up",
  'arrow-down': "fas fa-chevron-down",
  'arrow-left': "fas fa-chevron-left",
  'arrow-right': "fas fa-chevron-right",
  'resize-h': "fas fa-arrows-alt-h",
  'resize-v': "fas fa-arrows-alt-v",
  'resize-default': "fas fa-compress",
  'caret-up': "fas fa-caret-up",
  'caret-down': "fas fa-caret-down",
  'caret-left': "fas fa-caret-left",
  'caret-right': "fas fa-caret-right",
  'empty-circle': "far fa-circle",
  'cloud-upload': "fas fa-cloud-upload-alt",
  spinner: "fas fa-spinner",
  minus: "fas fa-minus",
  "minus-square": "far fa-minus-square",
  plus: "fas fa-plus",
  'plus-circle': "fas fa-plus-circle",
  'plus-square': "far fa-plus-square",
  grid: "fas fa-th",
  home: "fas fa-home",
  folder: "fas fa-folder",
  'sign-out': "fas fa-sign-out-alt",
  close: "fas fa-times",
  time: "far fa-clock",
  calendar: "fas fa-calendar-alt",
  list: "fas fa-list-alt",
  link: "fas fa-link",
  unlink: "fas fa-unlink",
  eye: "far fa-eye",
  'eye-close': "far fa-eye-slash",
  save: "far fa-save",
  pdf: "fas fa-file-pdf",
  image: "far fa-image",
  video: "far fa-file-video",
  unknow: "far fa-question-circle",
  zip: "far fa-file-archive",
  text: "far fa-file-alt",
  excel: "far fa-file-excel",
  xls: "far fa-file-excel",
  gpx: "fas fa-location-arrow",
  gpkg: "fas fa-box-open",
  shapefile: "fas fa-file-archive",
  csv: "fas fa-file-csv",
  geotiff: "fas fa-th",
  ppt: "far fa-file-powerpoint",
  circle: "fas fa-circle",
  calculator: "fas fa-calculator",
  picture: "far fa-image",
  keyboard: "far fa-keyboard",
  'file-download': "fas fa-file-download",
  copy: "far fa-copy",
  draw: "fas fa-draw-polygon",
  chart: "fas fa-chart-bar",
  'chart-line': "fas fa-chart-line",
  'chart-area': "fas fa-chart-area",
  'chart-pie': "fas fa-chart-pie",
  run: "fas fa-play",
  warning: "fas fa-exclamation-circle",
  alert: "fas fa-exclamation-triangle",
  crosshairs: "fas fa-crosshairs",
  success: "far fa-check-circle",
  back: "fas fa-chevron-circle-left",
  'file-upload': "fas fa-file-upload",
  wifi: "fas fa-wifi",
  mouse: "fas fa-mouse",
  'copy-paste': "far fa-copy",
  'vector-square': "fas fa-vector-square",
  download: "fas fa-download",
  credits: "fas fa-euro-sign",
  filter: "fas fa-filter",
  plugin: "fas fa-plug",
  invert: "fas fa-exchange-alt",
  clear: "fas fa-broom",
  palette: "fas fa-palette",
  layers: "fas fa-layer-group",
  'sign-in': "fas fa-sign-in-alt",
  language: "fas fa-language",
  target: "fas fa-bullseye",
  pin: "fas fa-map-pin",
  square: "far fa-square",
  move: "fas fa-arrows-alt",
  moon: "fas fa-moon",
  sun: "fas fa-sun",
  refresh: "fas fa-sync-alt",
  pause: "fas fa-pause",
  'step-backward': "fas fa-step-backward",
  'fast-backward': "fas fa-fast-backward",
  'step-forward': "fas fa-step-forward",
  'fast-forward': "fas fa-fast-forward",
  crop: "fas fa-crop-alt",
  exit: "fas fa-door-open",
  slider: "fas fa-sliders-h",
  /** @since 3.8.0 */
  bookmark: "fas fa-bookmark",
  /** @since 3.8.0 */
  reply: "fas fa-reply",
  /** @since 3.8.0 */
  share: "fas fa-share",
  /** @since 3.10.0 */
  'share-alt': 'fa fa-share-alt',
  /**@since 3.10.0 */
  'external-link': "fa fa-external-link-alt",
  /** @since 3.11.0 */
  pointer: 'fa fa-hand-pointer',
  /** @since 3.11.0 */
  camera: 'fas fa-camera-retro',
  /** @since 3.11.0 */
  measure: 'fas fa-ruler-horizontal',
  /** @since 3.11.0 */
  tint: 'fa fa-tint',
  /** @since 3.11.0 */
  sort: 'fa fa-sort',
  /** @since 3.11.0 */
  copyright: 'fa fa-copyright',
  /** @since 3.11.0 **/
  "forward": 'fas fa-angle-double-right',
  "backward": 'fas fa-angle-double-left'
};

/**
 * @typedef LocalItem
 * @property {string} id unique identifier
 * @property {any} value initial value
 */

/**
 * LOCAL ITEM IDS - used to store id used by application
 * 
 * @type {Object<string, LocalItem>}
 * 
 * @since v3.8
 */
var LOCAL_ITEM_IDS = exports.LOCAL_ITEM_IDS = {

  MESSAGES: {
    id: 'MESSAGES',
    value: {}
  },

  SPATIALBOOKMARKS: {
    id: 'SPATIALBOOKMARKS',
    value: {}
  }

};

/**
 * List of Open Layers spatial methods used to find features
 * 
 * @since 3.9.0
 */
var SPATIAL_METHODS = exports.SPATIAL_METHODS = ['intersects', 'within'];

/**
 * DPI96
 * 
 * DOTS_PER_INCH = ol.has.DEVICE_PIXEL_RATIO * 96;
 * 
 * @since 3.10.0
 */
var DOTS_PER_INCH = exports.DOTS_PER_INCH = 96;

/**
 * @since 3.10.0
 */
var INCHES_PER_UNIT = exports.INCHES_PER_UNIT = {
  m: 39.37,
  degrees: 4374754
};

/**
 * Selection state 
 * 
 * @since 3.11.0
 */
var SELECTION = exports.SELECTION = {
  ALL: '__ALL__',
  EXCLUDE: '__EXCLUDE__'
};

/**
 * @since 3.11.0
 * Page length for pagination
 * @type {number[]}
 */
var PAGELENGTHS = exports.PAGELENGTHS = [10, 25, 50, 100];

exports.default = {
  APP_VERSION: APP_VERSION,
  DEFAULT_EDITING_CAPABILITIES: DEFAULT_EDITING_CAPABILITIES,
  DOTS_PER_INCH: DOTS_PER_INCH,
  FILTER_OPERATORS: FILTER_OPERATORS,
  FILTER_EXPRESSION_OPERATORS: FILTER_EXPRESSION_OPERATORS,
  FONT_AWESOME_ICONS: FONT_AWESOME_ICONS,
  G3W_FID: G3W_FID,
  GEOMETRY_FIELDS: GEOMETRY_FIELDS,
  GEOMETRY_TYPES: GEOMETRY_TYPES,
  INCHES_PER_UNIT: INCHES_PER_UNIT,
  LOCAL_ITEM_IDS: LOCAL_ITEM_IDS,
  PRINT_SCALES: PRINT_SCALES,
  QUERY_POINT_TOLERANCE: QUERY_POINT_TOLERANCE,
  SEARCH_ALLVALUE: SEARCH_ALLVALUE,
  SPATIAL_METHODS: SPATIAL_METHODS,
  TIMEOUT: TIMEOUT,
  VIEWPORT: VIEWPORT,
  PAGELENGTHS: PAGELENGTHS
};

},{"./version":280}],160:[function(require,module,exports){
Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * @file common vue instances used to watch object changes or to emit events
 * 
 * NB: node.js modules are singletons by default.
 * 
 * @see https://medium.com/@lazlojuly/are-node-js-modules-singletons-764ae97519af
 * 
 * @since 3.11.0
 */

/**
 * ORIGINAL SOURCE: src/app/g3w-ol/constants.js@3.8.6
 */
var VM = exports.VM = new Vue();

},{}],161:[function(require,module,exports){
(function (process){(function (){
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /**
                                                                                                                                                                                                                                                                   * @file Expose `window.g3wsdk` variable (API interface for external plugins)
                                                                                                                                                                                                                                                                   * @since 3.11.0
                                                                                                                                                                                                                                                                   */

/**
 * @file ORIGINAL SOURCE: src/app/core/utils/geo.js@3.8
 */

//used by editing plugin


/**
 * Single File Components
 */


/**
 * CORE modules
 */


//MIXINS


var _g3wConstants = require('g3w-constants');

var _g3wConstants2 = _interopRequireDefault(_g3wConstants);

var _application = require('store/application');

var _application2 = _interopRequireDefault(_application);

var _application3 = require('services/application');

var _application4 = _interopRequireDefault(_application3);

var _addZValue = require('utils/addZValue');

var _is3DGeometry = require('utils/is3DGeometry');

var _removeZValue = require('utils/removeZValue');

var _getOLGeometry = require('utils/getOLGeometry');

var _isMultiGeometry = require('utils/isMultiGeometry');

var _isPointGeometryType = require('utils/isPointGeometryType');

var _isLineGeometryType = require('utils/isLineGeometryType');

var _isPolygonGeometryType = require('utils/isPolygonGeometryType');

var _createVectorLayerFromFile = require('utils/createVectorLayerFromFile');

var _createSelectedStyle = require('utils/createSelectedStyle');

var _getAlphanumericPropertiesFromFeature = require('utils/getAlphanumericPropertiesFromFeature');

var _getMapLayersByFilter = require('utils/getMapLayersByFilter');

var _areCoordinatesEqual = require('utils/areCoordinatesEqual');

var _splitFeature = require('utils/splitFeature');

var _convertSingleMultiGeometry = require('utils/convertSingleMultiGeometry');

var _within = require('utils/within');

var _intersects = require('utils/intersects');

var _dissolve = require('utils/dissolve');

var _distance = require('utils/distance');

var _getDefaultExpression = require('utils/getDefaultExpression');

var _getFilterExpression = require('utils/getFilterExpression');

var _getProjectUrl = require('utils/getProjectUrl');

var _getProjectConfigByGid = require('utils/getProjectConfigByGid');

var _getListableProjects = require('utils/getListableProjects');

var _getProject = require('utils/getProject');

var _InputG3W = require('components/InputG3W.vue');

var _InputG3W2 = _interopRequireDefault(_InputG3W);

var _InputG3WFormInputs = require('components/InputG3WFormInputs.vue');

var _InputG3WFormInputs2 = _interopRequireDefault(_InputG3WFormInputs);

var _data = require('services/data');

var _data2 = _interopRequireDefault(_data);

var _plugins = require('store/plugins');

var _plugins2 = _interopRequireDefault(_plugins);

var _tasks = require('services/tasks');

var _tasks2 = _interopRequireDefault(_tasks);

var _gui = require('services/gui');

var _gui2 = _interopRequireDefault(_gui);

var _measurecontrol = require('map/controls/measurecontrol');

var _mixins = require('mixins');

var _mixins2 = _interopRequireDefault(_mixins);

var _createMeasureTooltip = require('utils/createMeasureTooltip');

var _removeMeasureTooltip = require('utils/removeMeasureTooltip');

var _getResolutionFromScale = require('utils/getResolutionFromScale');

var _getScaleFromResolution = require('utils/getScaleFromResolution');

var _parsers = require('utils/parsers');

var _promisify = require('utils/promisify');

var _g3wObject = require('g3w-object');

var _g3wObject2 = _interopRequireDefault(_g3wObject);

var _g3wPanel = require('g3w-panel');

var _g3wPanel2 = _interopRequireDefault(_g3wPanel);

var _g3wComponent = require('g3w-component');

var _g3wComponent2 = _interopRequireDefault(_g3wComponent);

var _pickfeatureinteraction = require('map/interactions/pickfeatureinteraction');

var _pickfeatureinteraction2 = _interopRequireDefault(_pickfeatureinteraction);

var _pickcoordinatesinteraction = require('map/interactions/pickcoordinatesinteraction');

var _pickcoordinatesinteraction2 = _interopRequireDefault(_pickcoordinatesinteraction);

var _layersstore = require('map/layers/layersstore');

var _layer = require('map/layers/layer');

var _tablelayer = require('map/layers/tablelayer');

var _vectorlayer = require('map/layers/vectorlayer');

var _feature = require('map/layers/feature');

var _featuresstore = require('map/layers/featuresstore');

var _getUniqueDomId = require('utils/getUniqueDomId');

var _inherit = require('utils/inherit');

var _base = require('utils/base');

var _noop = require('utils/noop');

var _toRawType = require('utils/toRawType');

var _throttle = require('utils/throttle');

var _debounce = require('utils/debounce');

var _XHR = require('utils/XHR');

var _createFilterFormInputs = require('utils/createFilterFormInputs');

var _colorHEXToRGB = require('utils/colorHEXToRGB');

var _getCatalogLayerById = require('utils/getCatalogLayerById');

var _getCatalogLayers = require('utils/getCatalogLayers');

var _g3wI18n = require('g3w-i18n');

var _g3wI18n2 = _interopRequireDefault(_g3wI18n);

var _g3wPlugin = require('g3w-plugin');

var _map = require('services/map');

var _g3wSearch = require('components/g3w-search');

var _g3wForm = require('components/g3w-form');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var deprecate = require('util-deprecate');

/**
 * GUI modules
 */
var FieldsService = require('gui/fields/fieldsservice');
var Fields = require('gui/fields/fields');

var g3wsdk = {

  // APP CONSTANTS
  constant: _g3wConstants2.default, // TODO: rename to "constants" which is more appropriate (in version 4.0)

  // CORE API METHODS AND OBJECTS
  core: {
    G3WObject: _g3wObject2.default,
    utils: {
      base: _base.base,
      inherit: _inherit.inherit,
      XHR: _XHR.XHR,
      getUniqueDomId: _getUniqueDomId.getUniqueDomId,
      uniqueId: _getUniqueDomId.getUniqueDomId,
      throttle: _throttle.throttle,
      debounce: _debounce.debounce,
      toRawType: _toRawType.toRawType,
      colorHEXToRGB: _colorHEXToRGB.colorHEXToRGB,
      createFilterFormInputs: _createFilterFormInputs.createFilterFormInputs,
      noop: _noop.noop
    },
    geoutils: {
      createVectorLayerFromFile: deprecate(_createVectorLayerFromFile.createVectorLayerFromFile, '[G3W-CLIENT] g3wsdk.core.geoutils.createVectorLayerFromFile is deprecated'),
      createSelectedStyle: _createSelectedStyle.createSelectedStyle,
      getAlphanumericPropertiesFromFeature: _getAlphanumericPropertiesFromFeature.getAlphanumericPropertiesFromFeature,
      getQueryLayersPromisesByCoordinates: _data2.default.getQueryLayersPromisesByCoordinates,
      getMapLayersByFilter: _getMapLayersByFilter.getMapLayersByFilter,
      areCoordinatesEqual: _areCoordinatesEqual.areCoordinatesEqual,
      splitFeature: _splitFeature.splitFeature,
      convertSingleMultiGeometry: _convertSingleMultiGeometry.convertSingleMultiGeometry,
      within: _within.within,
      intersects: _intersects.intersects,
      dissolve: _dissolve.dissolve,
      distance: _distance.distance,
      Geometry: {
        GeometryTypes: _g3wConstants2.default.GEOMETRY_TYPES,
        removeZValueToOLFeatureGeometry: _removeZValue.removeZValue,
        addZValueToOLFeatureGeometry: _addZValue.addZValue,
        getOLGeometry: _getOLGeometry.getOLGeometry,
        isMultiGeometry: _isMultiGeometry.isMultiGeometry,
        isPointGeometryType: _isPointGeometryType.isPointGeometryType,
        isLineGeometryType: _isLineGeometryType.isLineGeometryType,
        isPolygonGeometryType: _isPolygonGeometryType.isPolygonGeometryType,
        is3DGeometry: _is3DGeometry.is3DGeometry
      }
    },
    ApplicationService: _application4.default,
    ApplicationState: _application2.default,
    i18n: _g3wI18n2.default,
    task: {
      TaskService: _tasks2.default
    },
    data: {
      DataRouterService: _data2.default
    },
    errors: {
      parsers: {
        Server: _parsers.ResponseParser.get('g3w-error')
      }
    },
    project: {
      ProjectsRegistry: Object.assign(new _g3wObject2.default(), {
        setters: {
          setCurrentProject: function setCurrentProject(project) {}
        },
        getProjectUrl: _getProjectUrl.getProjectUrl,
        getProjectConfigByGid: _getProjectConfigByGid.getProjectConfigByGid,
        getListableProjects: _getListableProjects.getListableProjects,
        getProject: _getProject.getProject,
        getCurrentProject: function getCurrentProject() {
          return _application2.default.project;
        }
      })
    },
    map: {
      MapLayersStoreRegistry: _map.MapLayersStoresRegistry
    },
    catalog: {
      CatalogLayersStoresRegistry: {
        getLayerById: _getCatalogLayerById.getCatalogLayerById,
        getLayers: _getCatalogLayers.getCatalogLayers
      }
    },
    layer: {
      LayersStore: _layersstore.LayersStore,
      Layer: _layer.Layer,
      TableLayer: _tablelayer.TableLayer,
      VectorLayer: _vectorlayer.VectorLayer,
      features: {
        Feature: _feature.Feature,
        FeaturesStore: _featuresstore.FeaturesStore
      }
    },
    interaction: {
      PickCoordinatesInteraction: _pickcoordinatesinteraction2.default,
      PickFeatureInteraction: _pickfeatureinteraction2.default
    },
    plugin: {
      Plugin: _g3wPlugin.Plugin,
      PluginsRegistry: _plugins2.default,
      PluginService: _g3wPlugin.PluginService
    },
    input: {
      inputService: {
        handleFilterExpressionFormInput: _getFilterExpression.getFilterExpression,
        handleDefaultExpressionFormInput: _getDefaultExpression.getDefaultExpression
      }
    }
  },

  // APPLICATION INTERFACE (vue)
  gui: {
    GUI: _gui2.default,
    Panel: _g3wPanel2.default,
    ComponentsFactory: {
      build: function build(_ref) {
        var vueComponentObject = _ref.vueComponentObject,
            service = _ref.service,
            propsData = _ref.propsData;
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return new _g3wComponent2.default(options).init({ vueComponentObject: vueComponentObject, service: service, propsData: propsData });
      }
    },
    FieldsService: FieldsService,
    vue: {
      Component: _g3wComponent2.default,
      Panel: _g3wPanel2.default,
      SearchPanel: _g3wSearch.SearchPanel,
      FormComponent: _g3wForm.FormComponent,
      Inputs: {
        G3wFormInputs: _InputG3WFormInputs2.default,
        G3WInput: _InputG3W2.default,
        InputsComponents: {
          'text_input': require('gui/inputs/text/vue/text'),
          'texthtml_input': require('gui/inputs/texthtml/vue/texthtml'),
          'textarea_input': require('gui/inputs/textarea/vue/textarea'),
          'integer_input': require('gui/inputs/integer/vue/integer'),
          'string_input': require('gui/inputs/text/vue/text'), //temporary
          'float_input': require('gui/inputs/float/vue/float'),
          'radio_input': require('gui/inputs/radio/vue/radio'),
          'check_input': require('gui/inputs/checkbox/vue/checkbox'),
          'range_input': require('gui/inputs/range/vue/range'),
          'datetimepicker_input': require('gui/inputs/datetimepicker/vue/datetimepicker'),
          'unique_input': require('gui/inputs/unique/vue/unique'),
          'select_input': require('gui/inputs/select/vue/select'),
          'media_input': require('gui/inputs/media/vue/media'),
          'select_autocomplete_input': require('gui/inputs/select/vue/select'),
          'picklayer_input': require('gui/inputs/picklayer/vue/picklayer'),
          'color_input': require('gui/inputs/color/vue/color'),
          'slider_input': require('gui/inputs/sliderrange/vue/sliderrange'),
          'lonlat_input': require('gui/inputs/lonlat/vue/lonlat')
        }
      },
      Fields: Fields,
      Mixins: _mixins2.default,
      services: {
        FormService: _g3wForm.FormService
      }
    }
  },

  // OPEN LAYERS COMPONENTS (g3w-ol)
  ol: {
    interactions: {
      PickFeatureInteraction: _pickfeatureinteraction2.default,
      PickCoordinatesInteraction: _pickcoordinatesinteraction2.default
    },
    controls: {},
    utils: {
      merge: function merge(a, b) {
        return _extends({}, a, b);
      },
      getScaleFromResolution: _getScaleFromResolution.getScaleFromResolution,
      getResolutionFromScale: _getResolutionFromScale.getResolutionFromScale,
      createMeasureTooltip: _createMeasureTooltip.createMeasureTooltip,
      removeMeasureTooltip: _removeMeasureTooltip.removeMeasureTooltip
    }
  },

  // G3W-SUITE debug info
  info: function info() {
    Promise.allSettled([new Promise(function (resolve) {
      return $script('https://unpkg.com/platform@1.3.6/platform.js', resolve);
    }), new Promise(function (resolve) {
      return _application4.default.complete ? resolve() : _application4.default.on('complete', resolve);
    })]).finally(_asyncToGenerator(function* () {
      /** @since 3.8.0 */
      var platform = window.platform || {};

      window.console.info(('\n[g3wsdk.info]\n\n- g3w-admin: __' + initConfig.version + '__\n- g3w-client: __' + "3.11.3-HEAD" + '__\n' + Object.entries(_application2.default.pluginsConfigs).map(function (p) {
        return '    - ' + p[0] + ': __' + p[1].version + '__';
      }).join('\n') + '\n- browser: __' + platform.name + ' ' + platform.version + '__\n- operating system: __' + platform.os.toString() + '__\n').trim());
    }));
  },

  // G3W-CLIENT version
  version: _g3wConstants2.default.APP_VERSION
};

// BACKOMP v3.x
g3wsdk.core.geometry = { Geom: g3wsdk.core.geoutils, Geometry: g3wsdk.core.geoutils.Geometry };
g3wsdk.ol.interactions.measure = {};
g3wsdk.ol.interactions.measure.AreaInteraction = function (_MeasureInteraction) {
  _inherits(_class, _MeasureInteraction);

  function _class() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, _class);

    opts.geometryType = "Polygon";return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).call(this, opts));
  }

  return _class;
}(_measurecontrol.MeasureInteraction), g3wsdk.ol.interactions.measure.LengthInteraction = function (_MeasureInteraction2) {
  _inherits(_class2, _MeasureInteraction2);

  function _class2() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, _class2);

    opts.geometryType = "LineString";return _possibleConstructorReturn(this, (_class2.__proto__ || Object.getPrototypeOf(_class2)).call(this, opts));
  }

  return _class2;
}(_measurecontrol.MeasureInteraction),

/** used by the following plugins: "qprocessing" */
g3wsdk.core.geoutils.isSameBaseGeometryType = function (a, b) {
  return a.replace('Multi', '') === b.replace('Multi', '');
};

/** used by the following plugins: "billboards" */
g3wsdk.core.ApplicationService.setLocalItem = function () {
  var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      id = _ref3.id,
      data = _ref3.data;

  try {
    window.localStorage.setItem(id, JSON.stringify(data));
  } catch (e) {
    console.warn(e);return e;
  }
};
/** used by the following plugins: "billboards" */
g3wsdk.core.ApplicationService.removeLocalItem = function (id) {
  return window.localStorage.removeItem(id);
};
/** used by the following plugins: "billboards" */
g3wsdk.core.ApplicationService.getLocalItem = function (id) {
  return window.localStorage.getItem(id) ? JSON.parse(window.localStorage.getItem(id)) : undefined;
};
/** used by the following plugins: "bforest" */
g3wsdk.core.ApplicationService.getApplicationUser = function () {
  return _application2.default.user;
};
/** used by the following plugins: "archiweb", "iframe" */
g3wsdk.core.ApplicationService.changeProject = function () {
  var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      gid = _ref4.gid;

  return (0, _promisify.$promisify)(_asyncToGenerator(function* () {
    var url = yield _gui2.default.getService('map').addMapExtentUrlParameterToUrl((0, _getProjectUrl.getProjectUrl)(gid), crs);try {
      history.replaceState(null, null, url);
    } catch (e) {
      console.warn(e);
    }location.replace(url);
  }));
};
/** used by the following plugins: "openrouteservice" */
g3wsdk.core.ApplicationService.reloadCurrentProject = function () {
  return g3wsdk.core.ApplicationService.changeProject({ gid: _application2.default.project.getGid() });
};
/** used by the following plugins: "editing" */
g3wsdk.core.ApplicationService.setCurrentLayout = function () {
  var who = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'app';
  return _application2.default.gui.layout.__current = who;
};
/** used by the following plugins: "editing", "openrouteservice" */
g3wsdk.core.ApplicationService.getCurrentLayoutName = function () {
  return _application2.default.gui.layout.__current;
};
/** used by the following plugins: "archiweb" */
g3wsdk.core.ApplicationService.isIframe = function () {
  return _application2.default.iframe;
};

/** used by the following plugins: "archiweb" */
g3wsdk.core.project.ProjectsRegistry.setProjectAliasUrl = function (alias) {
  var p = window.initConfig.projects.find(function (p) {
    return alias.gid === p.gid;
  });if (p) {
    p.url = '' + (alias.host || '') + alias.url;
  }
};

/**
 * Expose "g3wsdk" variable globally used by plugins to load sdk class and instances
 * 
 * @type {object}
 */
window.g3wsdk = g3wsdk;

/**
 * @TODO not yet implemented
 *
 * @see https://github.com/g3w-suite/g3w-client/issues/71
 * @see https://github.com/g3w-suite/g3w-client/issues/46
 */
// window.g3w = window.g3wsdk;

}).call(this)}).call(this,require('_process'))
},{"_process":25,"components/InputG3W.vue":101,"components/InputG3WFormInputs.vue":102,"components/g3w-form":146,"components/g3w-search":147,"g3w-component":158,"g3w-constants":159,"g3w-i18n":162,"g3w-object":163,"g3w-panel":164,"g3w-plugin":165,"gui/fields/fields":37,"gui/fields/fieldsservice":38,"gui/inputs/checkbox/vue/checkbox":40,"gui/inputs/color/vue/color":41,"gui/inputs/datetimepicker/vue/datetimepicker":43,"gui/inputs/float/vue/float":45,"gui/inputs/integer/vue/integer":48,"gui/inputs/lonlat/vue/lonlat":50,"gui/inputs/media/vue/media":52,"gui/inputs/picklayer/vue/picklayer":54,"gui/inputs/radio/vue/radio":56,"gui/inputs/range/vue/range":58,"gui/inputs/select/vue/select":60,"gui/inputs/sliderrange/vue/sliderrange":64,"gui/inputs/text/vue/text":65,"gui/inputs/textarea/vue/textarea":66,"gui/inputs/texthtml/vue/texthtml":67,"gui/inputs/unique/vue/unique":69,"map/controls/measurecontrol":179,"map/interactions/pickcoordinatesinteraction":184,"map/interactions/pickfeatureinteraction":185,"map/layers/feature":186,"map/layers/featuresstore":187,"map/layers/layer":190,"map/layers/layersstore":191,"map/layers/tablelayer":192,"map/layers/vectorlayer":193,"mixins":200,"services/application":205,"services/data":206,"services/gui":207,"services/map":209,"services/tasks":211,"store/application":212,"store/plugins":213,"util-deprecate":30,"utils/XHR":215,"utils/addZValue":216,"utils/areCoordinatesEqual":217,"utils/base":218,"utils/colorHEXToRGB":219,"utils/convertSingleMultiGeometry":222,"utils/createFilterFormInputs":225,"utils/createMeasureTooltip":227,"utils/createSelectedStyle":229,"utils/createVectorLayerFromFile":231,"utils/debounce":232,"utils/dissolve":233,"utils/distance":234,"utils/getAlphanumericPropertiesFromFeature":237,"utils/getCatalogLayerById":238,"utils/getCatalogLayers":239,"utils/getDefaultExpression":241,"utils/getFilterExpression":242,"utils/getListableProjects":244,"utils/getMapLayersByFilter":245,"utils/getOLGeometry":246,"utils/getProject":247,"utils/getProjectConfigByGid":248,"utils/getProjectUrl":249,"utils/getResolutionFromScale":250,"utils/getScaleFromResolution":251,"utils/getUniqueDomId":252,"utils/inherit":255,"utils/intersects":256,"utils/is3DGeometry":257,"utils/isLineGeometryType":258,"utils/isMultiGeometry":259,"utils/isPointGeometryType":260,"utils/isPolygonGeometryType":261,"utils/noop":262,"utils/parsers":265,"utils/promisify":267,"utils/removeMeasureTooltip":269,"utils/removeZValue":270,"utils/splitFeature":275,"utils/throttle":276,"utils/toRawType":277,"utils/within":279}],162:[function(require,module,exports){
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addI18nPlugin = exports.addI18n = exports.tPlugin = exports.t = exports.getAppLanguage = undefined;

var _application = require('store/application');

var _application2 = _interopRequireDefault(_application);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getAppLanguage = exports.getAppLanguage = function getAppLanguage() {
  return window.initConfig.user.i18n || "en";
};
/* function to translate */
var t = exports.t = function t(text) {
  return i18next.t(text);
};

/* function to translate plugins */
var tPlugin = exports.tPlugin = function tPlugin(text) {
  return i18next.t('plugins.' + text);
};

var addI18n = exports.addI18n = function addI18n(i18nObject) {
  for (var lang in i18nObject) {
    for (var key in i18nObject[lang]) {
      i18next.addResource(lang, 'translation', key, i18nObject[lang][key]);
    }
  }
};

var addI18nPlugin = exports.addI18nPlugin = function addI18nPlugin(_ref) {
  var name = _ref.name,
      config = _ref.config;

  for (var lang in config) {
    if (_application2.default.i18n.plugins[lang]) {
      _application2.default.i18n.plugins[lang].plugins[name] = config[lang];
    }
  }
  for (var _lang in _application2.default.i18n.plugins) {
    for (var key in _application2.default.i18n.plugins[_lang]) {
      i18next.addResource(_lang, 'translation', key, _application2.default.i18n.plugins[_lang][key]);
    }
  }
};

exports.default = {
  getAppLanguage: getAppLanguage,
  t: t,
  tPlugin: tPlugin,
  addI18n: addI18n,
  addI18nPlugin: addI18nPlugin
};

},{"store/application":212}],163:[function(require,module,exports){
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _noop = require('utils/noop');

var _debounce = require('utils/debounce');

var _throttle = require('utils/throttle');

var _wolfy87Eventemitter = require('wolfy87-eventemitter');

var _wolfy87Eventemitter2 = _interopRequireDefault(_wolfy87Eventemitter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @file ORIGINAL SOURCE: src/app/core/g3w-object.js@v3.10.2
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @since 3.11.0
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

/**
 * Mimics the behavior of child class fields in parent class,
 * which is the only way to define a property (eg `this.setters = { ... }`)
 * before invoking the `super()` constructor.
 * 
 * @TODO upgrade babel version in order to declare `setters`, `throttles` `debounces` as class fields
 * 
 * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Classes/Public_class_fields
 */
function defineClassField(obj, key, cb, initVal) {
  // The Field is already available within parent constructor
  // in case of ES5 inheritance (i.e. `inherit(ChildClass, G3WObject);`)
  if (initVal) {
    return cb.call(obj, initVal);
  }
  // The Field is not available within parent constructor
  // in case ES6 inheritance (i.e. `class ChildClass extends G3WObject { };`);
  // I.e
  // class A extends G3WObject {
  //   constructor() {
  //     super();
  //     this.setters = {
  //       foo() {},
  //       bar() {},
  //     };
  //   }
  // }
  var currVal = initVal;
  return Object.defineProperty(obj, key, {
    get: function get() {
      return currVal;
    },
    set: function set(value) {
      currVal = value;
      if (value) {
        cb.call(obj, value);
      }
    }
  });
}

/**
 * Base object to handle a setter and its listeners.
 */

var G3WObject = function (_EventEmitter) {
  _inherits(G3WObject, _EventEmitter);

  function G3WObject(opts) {
    _classCallCheck(this, G3WObject);

    var _this = _possibleConstructorReturn(this, (G3WObject.__proto__ || Object.getPrototypeOf(G3WObject)).call(this, opts));

    opts = opts || {};

    // Register the chain of events

    defineClassField(_this, 'setters', _this._setupListenersChain, opts.setters || _this.setters);
    defineClassField(_this, 'throttles', _this._setupThrottles, opts.throttles || _this.throttles);
    defineClassField(_this, 'debounces', _this._setupDebounces, opts.debounces || _this.debounces);
    return _this;
  }

  /**
   * Attach an event listener after executing a setter method
   * 
   * @param {string}   setter   - function name to listen for 
   * @param {function} listener - event listener (sync)
   * @param {number}   priority - priority (lowest value executes first)
   */


  _createClass(G3WObject, [{
    key: 'onafter',
    value: function onafter(setter, listener, priority) {
      return this._onsetter('after', setter, listener, false, priority);
    }

    /**
     * Attach an event listener after executing a setter method (once)
     * 
     * @param {string}   setter   - function name to listen for 
     * @param {function} listener - event listener (sync)
     * @param {number}   priority - priority (lowest value executes first)
     */

  }, {
    key: 'onceafter',
    value: function onceafter(setter, listener, priority) {
      return this._onsetter('after', setter, listener, false, priority, true);
    }

    /**
     * Attach an event listener before executing a setter method
     * 
     * @param {string}   setter   - function name to listen for
     * @param {function} listener - event listener (sync)
     * @param {number}   priority - priority (lowest value executes first)
     */

  }, {
    key: 'onbefore',
    value: function onbefore(setter, listener, priority) {
      return this._onsetter('before', setter, listener, false, priority);
    }

    /**
     * Attach an event listener before executing a setter method (once)
     * 
     * @param {string}   setter   - function name to listen for
     * @param {function} listener - event listener (sync)
     * @param {number}   priority - priority (lowest value executes first)
     */

  }, {
    key: 'oncebefore',
    value: function oncebefore(setter, listener, priority) {
      return this._onsetter('before', setter, listener, false, priority, true);
    }

    /**
     * Attatch an event listener before executing a setter method (once)
     * 
     * @param {string}   setter   - function name to listen for
     * @param {function} listener - event listener (async)
     * @param {number}   priority - priority (lowest value executes first)
     */

  }, {
    key: 'onbeforeasync',
    value: function onbeforeasync(setter, listener, priority) {
      return this._onsetter('before', setter, listener, true, priority);
    }

    /**
     *  Loop each settersListeners (array) and find a setter key (before/after) to be removed
     */

  }, {
    key: 'un',
    value: function un(setter, key) {
      Object.entries(this.settersListeners).forEach(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            _key = _ref2[0],
            setters = _ref2[1];

        if (undefined === key) {
          setters[setter].splice(0);
        } else {
          setters[setter].forEach(function (listener, idx) {
            listener.key === key && setters[setter].splice(idx, 1);
          });
        }
      });
    }
  }, {
    key: '_onsetter',


    /**
      * Register and handle <before/after> listeners
      * 
      * @param { 'before' | 'after' } when
      * @param { Function } setter
      * @param { Object } listener
      * @param { Boolean } async
      * @param { Number } priority
      * @param { Boolean }   once
      */
    value: function _onsetter(when, setter, listener, async) {
      var priority = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
      var once = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;

      // unique listenerKey
      var key = void 0;
      // check if setter function is registered
      // and then add an info object to setter listeners
      // (sorted based on priority)
      if (this.settersListeners && undefined !== this.settersListeners[when][setter]) {
        key = '' + (Math.floor(Math.random() * 1000000) + Date.now());
        this.settersListeners[when][setter].push({ key: key, fnc: listener, async: async, priority: priority, once: once });
        this.settersListeners[when][setter] = this.settersListeners[when][setter].sort(function (l1, l2) {
          return l2.priority - l1.priority;
        });
      }
      return key; // in case of no setter register return undefined listenerKey
    }

    /**
     * @returns {Promise}
     */

  }, {
    key: '_setupListenersChain',
    value: function _setupListenersChain(setters) {
      var _this2 = this;

      // all methods inside object "setters" of child class.
      this.settersListeners = {
        after: {},
        before: {}
      };

      var _loop = function _loop(setter) {

        // Array to push before and after subscribers
        _this2.settersListeners.after[setter] = [];
        _this2.settersListeners.before[setter] = [];

        // assign the property setter name to the object as own method
        _this2[setter] = function () {
          var _this3 = this;

          for (var _len = arguments.length, args = Array(_len), _key2 = 0; _key2 < _len; _key2++) {
            args[_key2] = arguments[_key2];
          }

          //Return a Deferred object
          // When then method of defferred object is called, a new promise is return
          // and not the deferred.resolve value directly.
          // This is the reason why when we call setter methods return a promise and not the value
          return $.Deferred(function (deferred) {
            // listener count
            var count = 0;
            /**
             *
             * @param {undefined | Boolean} bool
             */
            var next = function next(bool) {
              //check if it needs to skip (exit)
              var skip = true === bool || false === bool ? !bool : false;
              //get count of before subscribers on setter function
              var len = _this3.settersListeners.before[setter].length;

              // abort in case of error bool false,
              // or we reached the end of onbefore subscriber
              if (skip) {
                (setters[setter] instanceof Function ? _noop.noop : setters[setter].fallback || _noop.noop).apply(_this3, args);
                deferred.reject();
                return;
              }

              // call complete method methods and check what returns
              if (count === len) {
                // run setter function (resolve promise)
                deferred.resolve((setters[setter] instanceof Function ? setters[setter] : setters[setter].fnc).apply(_this3, args));
                // call all subscribed methods after setter
                var onceListeners = [];
                _this3.settersListeners.after[setter].forEach(function (listener) {
                  listener.fnc.apply(_this3, args);
                  if (listener.once) {
                    onceListeners.push(listener.key);
                  }
                });
                onceListeners.forEach(function (key) {
                  return _this3.un(setter, key);
                });
                _this3.emitEvent('set:' + setter, args);
              }
              // still call an onbefore listener subscribers
              if (count < len) {
                //get on before listener subscribes and increment count to 1
                var listener = _this3.settersListeners.before[setter][count++];
                //check if it is async
                if (listener.async) {
                  // add function next to argument of listener function
                  args.push(next);
                  listener.fnc.apply(_this3, args);
                } else {
                  // return or undefined or a boolean to tell if ok(true) can continue or not (false)
                  next(listener.fnc.apply(_this3, args));
                }
                //in case of listener subscribe function need to run just one time
                // after call remove it from listeners
                if (listener.once) {
                  _this3.settersListeners.before[setter].splice(count - 1, 1);
                }
              }
            };

            // run all the subscribers and setters
            next(true);
          });
        };
      };

      for (var setter in setters) {
        _loop(setter);
      }
      return this.settersListeners;
    }
  }, {
    key: '_setupDebounces',
    value: function _setupDebounces(debounces) {
      for (var name in debounces) {
        this[name] = (0, _debounce.debounce)(debounces[name].fnc, debounces[name].delay);
      }
    }
  }, {
    key: '_setupThrottles',
    value: function _setupThrottles(throttles) {
      for (var name in throttles) {
        this[name] = (0, _throttle.throttle)(throttles[name].fnc, throttles[name].delay);
      }
    }
  }, {
    key: 'get',
    value: function get(key) {
      return this[key] && !(this[key] instanceof Function) ? this[key] : null;
    }
  }, {
    key: 'set',
    value: function set(key, value) {
      this[key] = value;
    }
  }]);

  return G3WObject;
}(_wolfy87Eventemitter2.default);

exports.default = G3WObject;
;

},{"utils/debounce":232,"utils/noop":262,"utils/throttle":276,"wolfy87-eventemitter":36}],164:[function(require,module,exports){
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _gui = require('services/gui');

var _gui2 = _interopRequireDefault(_gui);

var _g3wObject = require('g3w-object');

var _g3wObject2 = _interopRequireDefault(_g3wObject);

var _promisify = require('utils/promisify');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @file ORIGINAL SOURCE: src/app/core/g3w-panel.js@v3.10.2
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @since 3.11.0
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

/**
 * ORIGINAL SOURCE: src/app/gui/panel.js@v3.9.3 
 */
var Panel = function (_G3WObject) {
  _inherits(Panel, _G3WObject);

  function Panel() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, Panel);

    var _this = _possibleConstructorReturn(this, (Panel.__proto__ || Object.getPrototypeOf(Panel)).call(this));

    _this.id = opts.id || null;

    _this.title = opts.title || '';

    _this.service = opts.service;

    if (opts.vueComponentObject) {
      _this.internalPanel = new (Vue.extend(opts.vueComponentObject))({ service: _this.service });
    } else {
      _this.internalPanel = opts.panel || opts.internalPanel || null;
    }

    if (true === opts.show && _this.internalPanel) {
      _this.show();
    }
    return _this;
  }

  _createClass(Panel, [{
    key: 'getId',
    value: function getId() {
      return this.id;
    }
  }, {
    key: 'getTitle',
    value: function getTitle() {
      return this.title;
    }
  }, {
    key: 'getService',
    value: function getService() {
      return this.service;
    }
  }, {
    key: 'setService',
    value: function setService(service) {
      this.service = service;
    }
  }, {
    key: 'getInternalPanel',
    value: function getInternalPanel() {
      return this.internalPanel;
    }
  }, {
    key: 'setInternalPanel',
    value: function setInternalPanel(internalPanel) {
      this.internalPanel = internalPanel;
    }
  }, {
    key: 'show',
    value: function show() {
      _gui2.default.showPanel(this);
    }
  }, {
    key: 'close',
    value: function close() {
      _gui2.default.closePanel();
    }
  }, {
    key: 'mount',
    value: function mount(parent) {
      var panel = this.internalPanel;
      var vueComp = panel.$mount();
      $(parent).append(vueComp.$el);
      vueComp.$nextTick(function () {
        $(parent).localize();
        if (panel.onShow) {
          panel.onShow();
        }
      });
      return (0, _promisify.$promisify)(Promise.resolve(true));
    }
  }, {
    key: 'unmount',
    value: function unmount() {
      var panel = this.internalPanel;
      panel.$destroy(true);
      $(panel.$el).remove();
      if (panel.onClose) {
        panel.onClose();
      }
      this.internalComponent = null;
      if (this.service && this.service.clear) {
        this.service.clear();
      }
      return (0, _promisify.$promisify)(Promise.resolve());
    }
  }]);

  return Panel;
}(_g3wObject2.default);

exports.default = Panel;

},{"g3w-object":163,"services/gui":207,"utils/promisify":267}],165:[function(require,module,exports){
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PluginService = exports.Plugin = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _g3wObject = require('g3w-object');

var _g3wObject2 = _interopRequireDefault(_g3wObject);

var _g3wComponent = require('g3w-component');

var _g3wComponent2 = _interopRequireDefault(_g3wComponent);

var _application = require('store/application');

var _application2 = _interopRequireDefault(_application);

var _plugins = require('store/plugins');

var _plugins2 = _interopRequireDefault(_plugins);

var _gui = require('services/gui');

var _gui2 = _interopRequireDefault(_gui);

var _toRawType = require('utils/toRawType');

var _g3wI18n = require('g3w-i18n');

var _lodash = require('lodash.clonedeep');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @file
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @since 3.11.0
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

/** @deprecated */


var TIMEOUT = 10000;

/**
 * ORIGINAL SOURCE: src/app/core/plugin/plugin.js@v3.10.2
 */

var Plugin = exports.Plugin = function (_G3WObject) {
  _inherits(Plugin, _G3WObject);

  function Plugin() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref$name = _ref.name,
        name = _ref$name === undefined ? null : _ref$name,
        _ref$config = _ref.config,
        config = _ref$config === undefined ? _application2.default.pluginsConfigs[name] : _ref$config,
        _ref$service = _ref.service,
        service = _ref$service === undefined ? null : _ref$service,
        _ref$dependencies = _ref.dependencies,
        dependencies = _ref$dependencies === undefined ? [] : _ref$dependencies,
        _ref$i18n = _ref.i18n,
        i18n = _ref$i18n === undefined ? null : _ref$i18n,
        _ref$fontClasses = _ref.fontClasses,
        fontClasses = _ref$fontClasses === undefined ? [] : _ref$fontClasses,
        _ref$api = _ref.api,
        api = _ref$api === undefined ? {} : _ref$api;

    _classCallCheck(this, Plugin);

    var _this = _possibleConstructorReturn(this, (Plugin.__proto__ || Object.getPrototypeOf(Plugin)).call(this));

    _this.setName(name);
    _this.setConfig(config);
    _this.setLocale(i18n);
    _this.setService(service);
    _this.setDependencies(dependencies);
    _this.addFontClasses(fontClasses);
    _this.setApi(api);
    _this.setHookService(null);

    _this._ready = false;

    // List of sidebar services that usually plugin need to interact with (hook = place/name of component)
    _this.hookservices = {
      'search': _gui2.default.getService('search'),
      'tools': _gui2.default.getService('tools')
    };

    // Automatically remove the loading plugin indicator after timeout
    _this._timeout = setTimeout(function () {
      _application2.default.plugins = _application2.default.plugins.filter(function (p) {
        return _this.name !== p;
      }); // remove loading plugin
      // remove layout
      if (_this.name) {
        delete _application2.default.gui.layout[_this.name];
      }
    }, TIMEOUT);

    return _this;
  }

  /**
   * @FIXME add description
   */


  _createClass(Plugin, [{
    key: 'setName',
    value: function setName(name) {
      this.name = name;
    }

    /**
     * @FIXME add description
     */

  }, {
    key: 'getName',
    value: function getName() {
      return this.name;
    }

    /**
     * Set plugin configuration
     * @param { Object } config
     */

  }, {
    key: 'setConfig',
    value: function setConfig(config) {
      this.config = 'Object' === (0, _toRawType.toRawType)(config) ? config : null;
    }

    /**
     * Get plugin configuration
     * @param { String } name
     */

  }, {
    key: 'getConfig',
    value: function getConfig(name) {
      return this.config || _application2.default.pluginsConfigs[name || this.name];
    }

    /**
     * @FIXME add description
     */

  }, {
    key: 'setLocale',
    value: function setLocale(i18n) {
      if (i18n && this.name) {
        (0, _g3wI18n.addI18nPlugin)({ name: this.name, config: i18n });
      }
    }

    /**
     * @FIXME add description
     */

  }, {
    key: 'setService',
    value: function setService(service) {
      this.service = service;
      if (service) {
        service.setPlugin(this);
      }
    }

    /**
     * @FIXME add description
     */

  }, {
    key: 'getService',
    value: function getService() {
      return this.service;
    }

    /**
     * @FIXME add description
     * @param { Array } dependencies
     */

  }, {
    key: 'setDependencies',
    value: function setDependencies() {
      var dependencies = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      this.dependencies = dependencies;
    }

    /**
     * @FIXME add description
     */

  }, {
    key: 'setApi',
    value: function setApi() {
      var api = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      this._api = api;
      /**
       * @FIXME useless assignment ?
       */
      api.getConfig = this._api.getConfig; // add alias for "api.getConfig()" method
    }

    /**
     * @FIXME add description
     */

  }, {
    key: 'getApi',
    value: function getApi() {
      return this._api;
    }

    /**
     * @FIXME add description
     */

  }, {
    key: 'setHookService',
    value: function setHookService(hook) {
      this._hook = hook;
    }

    /**
     * @FIXME add description
     */

  }, {
    key: 'getHookService',
    value: function getHookService() {
      var hook = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "tools";

      return this.hookservices[hook];
    }

    /**
     * Override plugin's content default layout (eg. default panel width, height, ...)
     * 
     * @see g3wsdk.core.ApplicationState.gui.layout
     */

  }, {
    key: 'setLayout',
    value: function setLayout(config) {
      config = undefined !== config ? config : (0, _lodash2.default)(_application2.default.gui.layout.app);

      var default_config = config.rightpanel || {
        width: 50, // ie. width == 50%
        height: 50, // ie. height == 50%
        width_100: false,
        height_100: false
      };

      config.rightpanel = Object.assign(default_config, {
        width: config.rightpanel.width || default_config.width,
        height: config.rightpanel.height || default_config.width,
        width_100: false,
        height_100: false
      });

      _application2.default.gui.layout[this.name] = config;
    }

    /**
     * @FIXME add description
     * 
     * @see g3wsdk.core.ApplicationState.gui.layout.__current
     */

  }, {
    key: 'setCurrentLayout',
    value: function setCurrentLayout() {
      _application2.default.gui.layout.__current = this.name;
    }

    /**
     * @FIXME add description
     */

  }, {
    key: 'setReady',
    value: function setReady(isReady) {
      var _this2 = this;

      this._ready = isReady;
      if (this._ready) {
        this.setLayout();
      }
      this.emit('set-ready', isReady, this.name);
      setTimeout(function () {
        clearTimeout(_this2._timeout);
        _application2.default.plugins = _application2.default.plugins.filter(function (p) {
          return _this2.name !== p;
        }); // remove loading plugin
      }, 0 /* 0 = allow any previously "setTimeout" to execute */);
    }

    /**
     * @FIXME add description
     */

  }, {
    key: 'isReady',
    value: function isReady() {
      var _this3 = this;

      return new Promise(function (resolve) {
        _this3._ready ? resolve(_this3._ready) : _this3.once('set-ready', function (isReady) {
          _this3._ready = isReady;resolve(_this3._ready);
        });
      });
    }

    /**
     * @returns whether plugin is compatible with current projectId
     */

  }, {
    key: 'isCurrentProjectCompatible',
    value: function isCurrentProjectCompatible(gid) {
      return gid === _application2.default.project.getGid();
    }

    /**
     * Check and register plugin only when compatible with current projectId (eg: qdjango:1)
     */

  }, {
    key: 'registerPlugin',
    value: function registerPlugin(gid) {
      var _this4 = this;

      var iscompatible = this.isCurrentProjectCompatible(gid);
      if (iscompatible) {
        _plugins2.default.registerPlugin(this);
      } else {
        _application2.default.plugins = _application2.default.plugins.filter(function (p) {
          return _this4.name !== p;
        }); // remove loading plugin
        clearTimeout(this._timeout);
      }
      return iscompatible;
    }

    /**
     * @FIXME explain better what it does
     * 
     * Get plugin dependencies
     */

  }, {
    key: 'getDependencyPlugins',
    value: function getDependencyPlugins(pluginsName) {
      var _this5 = this;

      this.dependencies = pluginsName || this.dependencies;
      return Promise.all(this.dependencies.map(function (name) {
        return _this5.getDependencyPlugin(name);
      }));
    }

    /**
     * @FIXME explain better what it does
     * 
     * Create to not replace above plugin method used by non changed old plugin
     */

  }, {
    key: 'getDependencyPluginsObject',
    value: function () {
      var _ref2 = _asyncToGenerator(function* (pluginsName) {
        var api = {};
        var promises = yield this.getDependencyPlugins(pluginsName);
        this.dependencies.forEach(function (name, index) {
          return api[name] = promises[index];
        });
        return api;
      });

      function getDependencyPluginsObject(_x5) {
        return _ref2.apply(this, arguments);
      }

      return getDependencyPluginsObject;
    }()

    /**
     * @FIXME explain better what it does
     * 
     * Get plugin dependency
     */

  }, {
    key: 'getDependencyPlugin',
    value: function getDependencyPlugin(pluginName) {
      // is there a plugin
      if (_application2.default.pluginsConfigs[pluginName]) {
        return new Promise(function (resolve) {
          var plugin = _plugins2.default.getPlugin(pluginName);
          /**
           * @TODO refactor weird shortcircuiting logic
           */
          plugin && plugin.isReady().then(function () {
            return resolve(plugin.getApi());
          }) || _plugins2.default.onafter('registerPlugin', function (plugin) {
            pluginName === plugin.name && plugin.isReady().then(function () {
              return resolve(plugin.getApi());
            });
          });
        });
      }
      return Promise.reject({ error: 'no plugin' });
    }

    /**
     * Handle a loading process of a specific hook service (e.g. "tools" interface on the left sidebar)
     */

  }, {
    key: 'setHookLoading',
    value: function setHookLoading() {
      var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref3$hook = _ref3.hook,
          hook = _ref3$hook === undefined ? "tools" : _ref3$hook,
          _ref3$loading = _ref3.loading,
          loading = _ref3$loading === undefined ? false : _ref3$loading;

      this.getHookService(hook).setLoading(loading);
    }

    /**
     * @FIXME add description
     */

  }, {
    key: 'addToolGroup',
    value: function addToolGroup() {
      var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref4$hook = _ref4.hook,
          hook = _ref4$hook === undefined ? "tools" : _ref4$hook,
          order = _ref4.position,
          group = _ref4.title;

      this.getHookService(hook).addToolGroup(order, group);
    }

    /**
     * @FIXME add description
     */

  }, {
    key: 'removeToolGroup',
    value: function removeToolGroup() {
      var _ref5 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          hook = _ref5.hook,
          group = _ref5.group;

      this.getHookService(hook).removeToolGroup(group.title);
    }

    /**
     * @param tool
     * @param group tools group
     */

  }, {
    key: 'addTools',
    value: function addTools(tool, group) {
      var _this6 = this;

      var hook = tool.hook || 'tools';
      var tools = [];

      if (!tool.action && !tool.type) {
        this.removeToolGroup({ hook: hook, group: group });
      } else {
        this.setHookService(hook);
        tools = (this.config.configs || [this.config]).map(function (config) {
          return {
            icon: tool.icon,
            type: tool.type,
            name: config.name || tool.name,
            html: tool.html,
            options: tool.options || {},
            action: tool.action && tool.action.bind(_this6, config),
            loading: undefined !== tool.loading ? tool.loading : false,
            disabled: undefined !== tool.disabled ? tool.disabled : false,
            offline: undefined !== tool.offline ? tool.offline : true,
            state: undefined !== tool.state ? tool.state : { type: null, message: null }
          };
        });
        this.getHookService(hook).addTools(tools, group);
      }

      return tools;
    }

    /**
     * @FIXME add description
     */

  }, {
    key: 'setToolState',
    value: function setToolState() {
      var _ref6 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          id = _ref6.id,
          _ref6$state = _ref6.state,
          state = _ref6$state === undefined ? { type: null, message: null } : _ref6$state;

      this.hookservices[this._hook].state.toolsGroups.find(function (g) {
        var tool = g.tools.find(function (t) {
          return t.name === id;
        });
        if (tool) {
          tool.state.type = state.type;
          tool.state.message = state.message;
          return true;
        }
      });
    }

    /**
     * @FIXME add description
     */

  }, {
    key: 'removeTools',
    value: function removeTools() {
      this.hookservices[this._hook].removeTools();
    }

    /**
     * Helper method to create and add a custom component item on the left sidebar
     * 
     * @param                      vue                               vue component object (SFC)
     * @param { Object }           opts
     * @param { string }           opts.id
     * @param { string }           opts.title                        textual description on left sidebar (eg. "metadata")
     * @param { boolean }          opts.open                         true = collapsible button; false = button
     * @param { boolean }          opts.collapsible                  whether expand the button when plugin is loaded
     * @param { boolean }          opts.closewhenshowviewportcontent
     * @param { Object }           opts.iconConfig
     * @param { string }           opts.iconConfig.color             color of icon
     * @param { string }           opts.iconConfig.icon              see gui\vue\vueappplugin.js font list
     * @param { Object }           opts.events                       eg. events = { open: { when: 'before', cb: () => { } }
     * @param { Object }           opts.sidebarOptions
     * @param { number | string }  opts.sidebarOptions.position
     * 
     * @returns component
     * 
     * @listens unload
     * 
     */

  }, {
    key: 'createSideBarComponent',
    value: function createSideBarComponent(vue) {
      var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};


      var çç = function çç(a, b) {
        return undefined !== a ? a : b;
      }; // like a ?? (coalesce operator)

      opts.vueComponentObject = vue;
      opts.collapsible = çç(opts.collapsible, true);
      opts.mobile = çç(opts.mobile, true);
      opts.sidebarOptions = çç(opts.sidebarOptions, { position: 1 });

      _gui2.default.addComponent(new _g3wComponent2.default(opts), 'sidebar', opts.sidebarOptions);

      this.once('unload', function () {
        return _gui2.default.removeComponent(opts.id, 'sidebar', opts.sidebarOptions);
      });

      return _gui2.default.getComponent(opts.id);
    }

    /**
     * @deprecated since v3.4.
     * 
     * @virtual method need to be implemented by subclasses
     */

  }, {
    key: 'unload',
    value: function unload() {
      if (this.service) {
        this.service.clearAllEvents();
      }
      this.emit('unload');
    }

    /**
     * @deprecated since v3.4.
     * 
     * @virtual method need to be implemented by subclasses
     */

  }, {
    key: 'load',
    value: function load() {}

    /**
     * @TODO it could be depecrated after v3.4 ?
     */

  }, {
    key: 'getProject',
    value: function getProject() {
      return _application2.default.project;
    }

    /**
     * @TODO it could be depecrated after v3.4 ?
     */

  }, {
    key: 'addDependency',
    value: function addDependency(dependency) {
      this.dependencies.push(dependency);
    }
  }, {
    key: 'addFontClass',


    /**
     * @TODO it could be depecrated after v3.4 ?
     */
    value: function addFontClass(_ref7) {
      var name = _ref7.name,
          className = _ref7.className;

      Vue.prototype.g3wtemplate.addFontClass({ name: name, className: className });
    }

    /**
     * @TODO it could be depecrated after v3.4 ?
     */

  }, {
    key: 'addFontClasses',
    value: function addFontClasses() {
      var _this7 = this;

      var fontClasses = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      fontClasses.forEach(function (fc) {
        return _this7.addFontClass(fc);
      });
    }
  }]);

  return Plugin;
}(_g3wObject2.default);

/**
 * ORIGINAL SOURCE: src/app/core/plugin/pluginservice.js@v3.10.2
 */


var PluginService = exports.PluginService = function (_G3WObject2) {
  _inherits(PluginService, _G3WObject2);

  function PluginService() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, PluginService);

    var _this8 = _possibleConstructorReturn(this, (PluginService.__proto__ || Object.getPrototypeOf(PluginService)).call(this, opts));

    _this8.plugin;
    _this8._api = {
      own: null,
      dependencies: {}
    };
    _this8._pluginEvents = {};
    _this8._appEvents = [];
    _this8.currentLayout = _application2.default.gui.layout.__current;
    _this8.vm = new Vue();
    _this8.unwatch = _this8.vm.$watch(function () {
      return _application2.default.gui.layout.__current;
    }, function (layoutName) {
      return _this8.currentLayout = layoutName === _this8.name ? _this8.currentLayout : layoutName;
    });
    return _this8;
  }

  /**
   * @param config: plugin configuration object
   * 
   * @virtual method need to be implemented by subclasses
   */


  _createClass(PluginService, [{
    key: 'init',
    value: function init() {
      var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      this.config = config;
    }
  }, {
    key: 'resetCurrentLayout',
    value: function resetCurrentLayout() {
      _application2.default.gui.layout.__current = this.currentLayout;
    }

    // set owner plugin of the service

  }, {
    key: 'setPlugin',
    value: function setPlugin(plugin) {
      this.plugin = plugin;
    }

    // return the instance of the plugin owner of the service

  }, {
    key: 'getPlugin',
    value: function getPlugin() {
      return this.plugin;
    }
  }, {
    key: 'isIframe',
    value: function isIframe() {
      return _application2.default.iframe;
    }
  }, {
    key: 'getCurrentProject',
    value: function getCurrentProject() {
      return _application2.default.project;
    }
  }, {
    key: 'getGid',
    value: function getGid() {
      return this.config.gid && this.config.gid.split(':')[1];
    }
  }, {
    key: 'getConfig',
    value: function getConfig() {
      return this.config;
    }
  }, {
    key: 'setConfig',
    value: function setConfig(config) {
      this.config = config;
    }
  }, {
    key: 'setApi',
    value: function setApi() {
      var _ref8 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          dependency = _ref8.dependency,
          api = _ref8.api;

      if (!dependency) {
        this._api.own = api;
      } else {
        this._api.dependencies[dependency] = api;
      }
    }
  }, {
    key: 'getApi',
    value: function getApi() {
      var _ref9 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          dependency = _ref9.dependency;

      return dependency && this._api.dependencies[dependency] || this._api.own;
    }
  }, {
    key: 'initEvents',
    value: function initEvents() {
      var events = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      for (var i in events) {
        this._pluginEvents[events[i]] = {};
      }
    }
  }, {
    key: 'subscribeEvent',
    value: function subscribeEvent() {
      var _ref10 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          name = _ref10.name,
          _ref10$once = _ref10.once,
          once = _ref10$once === undefined ? false : _ref10$once,
          owner = _ref10.owner,
          listener = _ref10.listener;

      this._pluginEvents[name] = this._pluginEvents[name] ? this._pluginEvents[name] : {};
      this._pluginEvents[name][owner] = listener;
      if (once) {
        this.once(name, listener);
      } else {
        this.on(name, listener);
      }
    }
  }, {
    key: 'triggerEvent',
    value: function triggerEvent(_ref11) {
      var name = _ref11.name,
          _ref11$params = _ref11.params,
          params = _ref11$params === undefined ? {} : _ref11$params;

      this.emit(name, params);
    }
  }, {
    key: 'unsubscribeEvent',
    value: function unsubscribeEvent(_ref12) {
      var name = _ref12.name,
          owner = _ref12.owner;

      this.removeEvent(name, this._pluginEvents[name][owner]);
      delete this._pluginEvents[name][owner];
    }
  }, {
    key: 'unsubscribeAllEvents',
    value: function unsubscribeAllEvents() {
      for (var name in this._pluginEvents) {
        this.removeEvent(name);
        delete this._pluginEvents[name];
      }
    }
  }, {
    key: 'clearAllEvents',
    value: function clearAllEvents() {
      this.unsubscribeAllEvents();
      this.unwatch();
      this.vm = null;
      this._pluginEvents = null;
    }

    /**
     * @returns need to load or not the plugin
     * 
     * @virtual method need to be implemented by subclasses 
     */

  }, {
    key: 'loadPlugin',
    value: function loadPlugin() {
      return true;
    }

    /**
     * Called when plugin is removed to clear events and memory
     * 
     * @virtual method need to be implemented by subclasses
     */

  }, {
    key: 'clear',
    value: function clear() {}
  }]);

  return PluginService;
}(_g3wObject2.default);

},{"g3w-component":158,"g3w-i18n":162,"g3w-object":163,"lodash.clonedeep":24,"services/gui":207,"store/application":212,"store/plugins":213,"utils/toRawType":277}],166:[function(require,module,exports){
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          * @file Production entry point (app.min.js)
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          * @since v3.8
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          */

// expose global variables


// constants


// core


// services


// components


// directives


// utils


// Internationalization


require('./g3w-globals');

var _g3wConstants = require('g3w-constants');

var _locales = require('locales');

var _locales2 = _interopRequireDefault(_locales);

var _application = require('store/application');

var _application2 = _interopRequireDefault(_application);

var _g3wObject = require('g3w-object');

var _g3wObject2 = _interopRequireDefault(_g3wObject);

var _g3wPanel = require('g3w-panel');

var _g3wPanel2 = _interopRequireDefault(_g3wPanel);

var _g3wComponent = require('g3w-component');

var _g3wComponent2 = _interopRequireDefault(_g3wComponent);

var _application3 = require('services/application');

var _application4 = _interopRequireDefault(_application3);

var _gui = require('services/gui');

var _gui2 = _interopRequireDefault(_gui);

var _map = require('services/map');

var _iframe = require('services/iframe');

var _iframe2 = _interopRequireDefault(_iframe);

var _App = require('components/App.vue');

var _App2 = _interopRequireDefault(_App);

var _GlobalBarLoader = require('components/GlobalBarLoader.vue');

var _GlobalBarLoader2 = _interopRequireDefault(_GlobalBarLoader);

var _GlobalProgressBar = require('components/GlobalProgressBar.vue');

var _GlobalProgressBar2 = _interopRequireDefault(_GlobalProgressBar);

var _GlobalHelpDiv = require('components/GlobalHelpDiv.vue');

var _GlobalHelpDiv2 = _interopRequireDefault(_GlobalHelpDiv);

var _GlobalDateTime = require('components/GlobalDateTime.vue');

var _GlobalDateTime2 = _interopRequireDefault(_GlobalDateTime);

var _GlobalRange = require('components/GlobalRange.vue');

var _GlobalRange2 = _interopRequireDefault(_GlobalRange);

var _GlobalTabs = require('components/GlobalTabs.vue');

var _GlobalTabs2 = _interopRequireDefault(_GlobalTabs);

var _GlobalDivider = require('components/GlobalDivider.vue');

var _GlobalDivider2 = _interopRequireDefault(_GlobalDivider);

var _vDisabled = require('directives/v-disabled');

var _vDisabled2 = _interopRequireDefault(_vDisabled);

var _vChecked = require('directives/v-checked');

var _vChecked2 = _interopRequireDefault(_vChecked);

var _vSelect = require('directives/v-select2');

var _vSelect2 = _interopRequireDefault(_vSelect);

var _vTTooltip = require('directives/v-t-tooltip');

var _vTTooltip2 = _interopRequireDefault(_vTTooltip);

var _vTHtml = require('directives/v-t-html');

var _vTHtml2 = _interopRequireDefault(_vTHtml);

var _vTTitle = require('directives/v-t-title');

var _vTTitle2 = _interopRequireDefault(_vTTitle);

var _vT = require('directives/v-t');

var _vT2 = _interopRequireDefault(_vT);

var _vTPlugin = require('directives/v-t-plugin');

var _vTPlugin2 = _interopRequireDefault(_vTPlugin);

var _vDownload = require('directives/v-download');

var _vDownload2 = _interopRequireDefault(_vDownload);

var _noop = require('utils/noop');

var _XHR = require('utils/XHR');

var _promisify = require('utils/promisify');

var _getProject = require('utils/getProject');

var _g3wI18n = require('g3w-i18n');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

Object.entries({
  ApplicationState: _application2.default,
  G3WObject: _g3wObject2.default,
  Panel: _g3wPanel2.default,
  Component: _g3wComponent2.default,
  ApplicationService: _application4.default,
  GUI: _gui2.default,
  MapLayersStoresRegistry: _map.MapLayersStoresRegistry,
  IframePluginService: _iframe2.default,
  App: _App2.default,
  BarLoader: _GlobalBarLoader2.default,
  Progressbar: _GlobalProgressBar2.default,
  HelpDiv: _GlobalHelpDiv2.default,
  DateTime: _GlobalDateTime2.default,
  Range: _GlobalRange2.default,
  Tabs: _GlobalTabs2.default,
  Divider: _GlobalDivider2.default,
  getProject: _getProject.getProject
}).forEach(function (_ref) {
  var _ref2 = _slicedToArray(_ref, 2),
      k = _ref2[0],
      v = _ref2[1];

  return console.assert(undefined !== v, k + ' is undefined');
});

/**
 * Install global components
 *
 * ORIGINAL SOURCE: src/app/gui/vue/vue.globalcomponents.js@3.6
 */
Vue.component(_GlobalBarLoader2.default.name, _GlobalBarLoader2.default);
Vue.component(_GlobalProgressBar2.default.name, _GlobalProgressBar2.default);
Vue.component(_GlobalHelpDiv2.default.name, _GlobalHelpDiv2.default);
Vue.component(_GlobalDateTime2.default.name, _GlobalDateTime2.default);
Vue.component(_GlobalRange2.default.name, _GlobalRange2.default);
Vue.component(_GlobalTabs2.default.name, _GlobalTabs2.default);
Vue.component(_GlobalDivider2.default.name, _GlobalDivider2.default);

/**
 * Install application filters
 *
 * ORIGINAL SOURCE: src/app/gui/vue/vue.filter.js@3.6
 */
Vue.filter('t', function (value) {
  return (0, _g3wI18n.t)(value);
});
Vue.filter('tPlugin', function (value) {
  return value !== null ? (0, _g3wI18n.tPlugin)(value) : '';
});

/**
 * Install global directives
 *
 * ORIGINAL SOURCE: src/app/gui/vue/vue.directives.js@v3.6
 */
Vue.directive("disabled", _vDisabled2.default);
Vue.directive("checked", _vChecked2.default);
Vue.directive('select2', _vSelect2.default);
Vue.directive('t-tooltip', _vTTooltip2.default);
Vue.directive('t-html', _vTHtml2.default);
Vue.directive('t-title', _vTTitle2.default);
Vue.directive("t", _vT2.default);
Vue.directive("t-plugin", _vTPlugin2.default);
Vue.directive("download", _vDownload2.default);

/**
 * Install global plugins
 */
Vue.use(require('vue-cookie'));

/**
 * Vue 2 Plugin used to add global-level functionality to Vue
 *
 * @link https://v2.vuejs.org/v2/guide/plugins.html
 *
 * ORIGINAL SOURCE: src/app/gui/vue/vueappplugin.js@3.6
 */
Vue.use({
  install: function install(Vue) {
    /** @since 3.11.0 */
    Vue.prototype.$t = _g3wI18n.t;
    // hold a list of registered fontawsome classes for current project
    Vue.prototype.g3wtemplate = {
      font: _g3wConstants.FONT_AWESOME_ICONS,
      addFontClass: function addFontClass() {
        var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            name = _ref3.name,
            className = _ref3.className;

        var added = undefined === this.font[name];
        if (added) {
          this.font[name] = className;
        }
        return added;
      },
      getFontClass: function getFontClass(type) {
        return this.font[type] || '';
      }
    };
    /** @since 3.11.0 */
    Vue.prototype.$fa = Vue.prototype.g3wtemplate.getFontClass.bind(Vue.prototype.g3wtemplate);
    // include isMobile() method within all Vue instances
    Vue.mixin({
      methods: {
        isMobile: function (_isMobile) {
          function isMobile() {
            return _isMobile.apply(this, arguments);
          }

          isMobile.toString = function () {
            return _isMobile.toString();
          };

          return isMobile;
        }(function () {
          return isMobile.any;
        })
      }
    });
  }
}, {});

Vue.mixin({ inheritAttrs: false }); // set mixins inheriAttrs to avoid tha unused props are setted as attrs

// loading spinner at beginning
$('body').append('<div id="startingspinner"><div class="double-bounce1"></div><div class="double-bounce2"></div></div>');

/** @TODO check if deprecated */
var ACTIONS = {};

var CONFIG = {};

// dataTable Translations and custom extentions
function _setDataTableLanguage() {
  //set form control class to filter
  $.extend($.fn.dataTableExt.oStdClasses, {
    "sFilterInput": "form-control search"
  });
  $.extend(true, $.fn.dataTable.defaults, {
    "language": {
      "sSearch": '',
      "searchPlaceholder": (0, _g3wI18n.t)("dosearch"),
      "sLengthMenu": (0, _g3wI18n.t)("dataTable.lengthMenu"),
      "paginate": {
        "previous": '«',
        "next": '»'
      },
      "info": (0, _g3wI18n.t)("dataTable.info"),
      "zeroRecords": (0, _g3wI18n.t)("dataTable.nodatafilterd"),
      "infoFiltered": ''
    }
  });
}

/**
 * Retrieve from local storage
 */
function _getSavedSearches() {
  var ITEMS = _application2.default.querybuilder.searches;
  var id = _application2.default.project.getId();
  ITEMS[id] = ITEMS[id] || [];
  return ITEMS[id];
}

/**
 * Load an external script
 */
function _loadScript(url) {
  return new Promise(function (resolve, reject) {
    var s = document.createElement('script');
    s.onload = resolve;
    s.onerror = function (e) {
      console.warn(e);reject(new Error('Failed to load script: ' + url));
    };
    s.src = url;
    document.head.appendChild(s);
  });
}

/**
 * Bootstrap application
 *
 * 1 - load translations (i18n languages)
 * 2 - initialize ProjectsRegistry
 * 3 - attach DOM events ('online' and 'offline')
 * 4 - trigger 'ready' event
 * 5 - set current project `gid` (group id)
 * 6 - set current project EPSG (coordinate system)
 * 7 - check if application is loaded within an <IFRAME>
 */

var initConfig = window.initConfig;

// set application user
_application2.default.user = initConfig.user;

_application4.default.emit('initconfig', initConfig);

var vendorkeys = initConfig.vendorkeys || {};
initConfig.baselayers.forEach(function (l) {
  if (l.apikey) {
    vendorkeys[l.servertype ? l.servertype.toLowerCase() : null] = l.apikey;
  }
});
Object.keys(vendorkeys).forEach(function (k) {
  return _application2.default.keys.vendorkeys[k] = vendorkeys[k];
});

/**
 * create application configuration
 */
Object.assign(initConfig, {
  urls: Object.assign(initConfig.urls || {}, {
    ows: 'ows',
    api: 'api',
    initconfig: 'api/initconfig',
    config: 'api/config',
    baseurl: initConfig.baseurl,
    frontendurl: initConfig.frontendurl,
    staticurl: initConfig.staticurl,
    clienturl: initConfig.staticurl + initConfig.client,
    mediaurl: initConfig.mediaurl,
    vectorurl: initConfig.vectorurl,
    proxyurl: initConfig.proxyurl,
    rasterurl: initConfig.rasterurl,
    interfaceowsurl: initConfig.interfaceowsurl
  }),
  layout: initConfig.layout || {},
  plugins: initConfig.plugins || {},
  tools: initConfig.tools || { tools: [] },
  views: initConfig.views || {},
  user: initConfig.user || null
});

initConfig.layout.iframe = window.top !== window.self;

/** * @deprecated Since v3.8. Will be deleted in v4.x. Use ApplicationState.language instead */
_application2.default.lng = initConfig.user.i18n || 'en';
_application2.default.language = initConfig.user.i18n || 'en';

// setup i18n
(initConfig.i18n || []).map(function (l) {
  return l[0];
}).forEach(function (l) {
  return _application2.default.i18n.plugins[l] = { plugins: {} };
});

i18next.use(i18nextXHRBackend).init({
  lng: initConfig.user.i18n,
  ns: 'app',
  fallbackLng: 'en',
  resources: _locales2.default
});

jqueryI18next.init(i18next, $, {
  tName: 't', // --> appends $.t = i18next.t
  i18nName: 'i18n', // --> appends $.i18n = i18next
  handleName: 'localize', // --> appends $(selector).localize(opts);
  selectorAttr: 'data-i18n', // selector for translating elements
  targetAttr: 'data-i18n-target', // element attribute to grab target element to translate (if diffrent then itself)
  optionsAttr: 'data-i18n-options', // element attribute that contains options, will load/set if useOptionsAttr = true
  useOptionsAttr: false, // see optionsAttr
  parseDefaultValueFromContent: true // parses default values from content ele.val or ele.text
});

(0, _g3wI18n.addI18n)(_application2.default.i18n.plugins);

// set Accept-Language request header based on config language
$.ajaxSetup({
  beforeSend: function beforeSend(xhr) {
    xhr.setRequestHeader('Accept-Language', initConfig.user.i18n || 'en');
  }
});

/**
 * Application starting point
 *
 * create the ApplicationTemplate instance passing template interface configuration
 * and the applicationService instance that is useful to work with project API
 */
new Promise(function () {
  var _ref4 = _asyncToGenerator(function* (resolve, reject) {

    /** @since 3.8.0 */
    try {
      initConfig.macrogroups = yield _XHR.XHR.get({ url: '/' + _application2.default.user.i18n + '/about/api/macrogroup/' });
    } catch (e) {
      console.warn(e);
    }

    /** @since 3.8.0 */
    try {
      initConfig.groups = yield _XHR.XHR.get({ url: '/' + _application2.default.user.i18n + '/about/api/group/nomacrogroup/' });
    } catch (e) {
      console.warn(e);
    }

    // Updates panels sizes when showing content (eg. bottom "Attribute Table" panel, right "Query Results" table)
    initConfig.layout.rightpanel = Object.assign(initConfig.layout.rightpanel || {}, {
      width: initConfig.layout.rightpanel.width || 50, // ie. width == 50%
      height: initConfig.layout.rightpanel.height || 50, // ie. height == 50%
      width_100: false,
      height_100: false
    });

    _application2.default.gui.layout.app = initConfig.layout;

    // setup projects
    initConfig.projects.forEach(function (project) {
      return Object.assign(project, {
        baselayers: initConfig.baselayers,
        minscale: initConfig.minscale,
        maxscale: initConfig.maxscale,
        crs: initConfig.crs,
        vectorurl: initConfig.vectorurl,
        rasterurl: initConfig.rasterurl
      });
    });

    var timeout = setTimeout(function () {
      reject('Timeout');
    }, _g3wConstants.TIMEOUT);

    // get current project configuration
    (0, _getProject.getProject)(initConfig.initproject, { map_theme: new URLSearchParams(location.search).get('map_theme') }).then(function (project) {
      clearTimeout(timeout);

      Object.assign(_application2.default.project, project);

      // set in first position (map and catalog)
      var store = project.getLayersStore();
      _application2.default.catalog[store.getId()] = store;

      _map.MapLayersStoresRegistry.addLayersStore(store);

      // BACKOMP v3.x
      g3wsdk.core.project.ProjectsRegistry.setCurrentProject(project);

      window.addEventListener('online', function () {
        _application2.default.online = true;
        _application4.default.online();
      });

      window.addEventListener('offline', function () {
        _application2.default.online = false;
        _application4.default.offline();
      });

      _application4.default.emit('ready');

      _application2.default.map.epsg = project.state.crs.epsg;

      if (_application2.default.iframe) {
        _iframe2.default.init({ project: project });
      }

      // init local items
      Object.keys(_g3wConstants.LOCAL_ITEM_IDS).forEach(function (id) {
        try {
          var item = window.localStorage.getItem(id) ? JSON.parse(window.localStorage.getItem(id)) : undefined;
          if (undefined === item) {
            window.localStorage.setItem(id, JSON.stringify(_g3wConstants.LOCAL_ITEM_IDS[id].value));
          }
        } catch (e) {
          console.warn(e);
        }
      });
      resolve(true);
    }).catch(function (e) {
      console.warn(e);
      reject(e);
    });
  });

  return function (_x2, _x3) {
    return _ref4.apply(this, arguments);
  };
}()).then(function () {
  // create Vue App
  _setDataTableLanguage();

  if (isMobile.any || (window.initConfig.layout || {}).iframe) {
    $('body').addClass('sidebar-collapse');
  }

  new Vue({
    el: '#app',
    created: function created() {

      Vue.component('app', _App2.default);

      // update CONFIG
      Object.assign(CONFIG, {
        sidebar: [

        /**
         * ORIGINAL SOURCE: src/components/g3w-spatialbookmarks.js@v3.10.2
         */
        new function () {
          var comp = new _g3wComponent2.default({
            id: 'spatialbookmarks',
            icon: _gui2.default.getFontClass('bookmark'),
            iconColor: '#00bcd4',
            title: 'sdk.spatialbookmarks.title',
            vueComponentObject: require('components/SpatialBookMarks.vue')
          });

          _gui2.default.on('closecontent', function () {
            comp.state.open = false;
          });

          return comp;
        }(),

        /**
         * ORIGINAL SOURCE: src/components/g3w-print.js@v3.10.2 
         */
        Object.assign(new _g3wComponent2.default({
          id: 'print',
          visible: window.initConfig.user.is_staff || (_application2.default.project.getPrint() || []).length > 0, /** @since 3.10.0 Check if the project has print layout*/
          icon: _gui2.default.getFontClass('print'),
          iconColor: '#FF9B21',
          title: 'print',
          service: {},
          internalComponent: new (Vue.extend(require('components/Print.vue')))()
        }), {
          //@since 3.11.0 use internal methods called by component setters if declared
          _setOpen: function _setOpen(bool) {
            this.getInternalComponent().showPrintArea(bool);
          }
        }),

        /**
         * ORIGINAL SOURCE: src/components/g3w-search.js@v3.10.2 
         */
        new _g3wComponent2.default({
          id: 'search',
          visible: true,
          icon: _gui2.default.getFontClass('search'),
          iconColor: '#8dc3e3',
          title: _application2.default.project.state.search_title || 'search',
          service: Object.assign(new _g3wObject2.default(), {
            state: {
              searches: (_application2.default.project.state.search || []).sort(function (a, b) {
                return ('' + a.name).localeCompare(b.name);
              }),
              tools: [],
              querybuildersearches: _getSavedSearches()
            },
            title: _application2.default.project.state.search_title || "search",
            addTool: function addTool(t) {
              this.state.tools.push(t);
            },
            addTools: function addTools(tt) {
              var _iteratorNormalCompletion = true;
              var _didIteratorError = false;
              var _iteratorError = undefined;

              try {
                for (var _iterator = tt[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                  var _t = _step.value;
                  this.addTool(_t);
                }
              } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                  }
                } finally {
                  if (_didIteratorError) {
                    throw _iteratorError;
                  }
                }
              }
            },
            showPanel: function showPanel(o) {
              return new (require('components/g3w-search').SearchPanel)(o, true);
            },
            getTitle: function getTitle() {
              return this.title;
            },
            removeTools: function removeTools() {
              this.state.tools.splice(0);
            },
            stop: function stop(d) {
              return (0, _promisify.$promisify)(Promise.resolve(d));
            },
            removeTool: function removeTool() {}
          }),
          actions: [{
            id: "querybuilder",
            class: _gui2.default.getFontClass('calculator') + ' sidebar-button sidebar-button-icon',
            tooltip: (0, _g3wI18n.t)('sdk.querybuilder.title'),
            fnc: function fnc() {
              _gui2.default.closeContent();
              _gui2.default.closeSideBar();
              return new _g3wPanel2.default({
                title: (0, _g3wI18n.t)('sdk.querybuilder.title'),
                show: true,
                vueComponentObject: require('components/QueryBuilder.vue')
              });
            },
            style: {
              color: '#8DC3E3',
              padding: '6px',
              fontSize: '1.2em',
              borderRadius: '3px',
              marginRight: '5px'
            }
          }],
          vueComponentObject: require('components/Search.vue')
        }),

        /**
         * ORIGINAL SOURCE: src/components/g3w-tools.js@v3.10.2 
         */
        new function () {

          var state = {
            id: 'tools',
            icon: _gui2.default.getFontClass('tools'),
            iconColor: '#FFE721',
            toolsGroups: [],
            visible: false,
            loading: false
          };

          var service = new _g3wObject2.default({ setters: {
              addTool: function addTool(tool, _ref5) {
                var title = _ref5.title,
                    position = _ref5.position;

                var group = state.toolsGroups.find(function (g) {
                  return g.name === title;
                });
                if (!group) {
                  group = { name: title, tools: [] };state.toolsGroups.splice(position, 0, group);
                }
                return group.tools.push(Object.assign(tool, {
                  state: tool.state || { type: null, message: null },
                  action: tool.action || (ACTIONS[tool.type] || _noop.noop).bind(null, tool.options)
                }));
              },
              addToolGroup: function addToolGroup(position, name) {
                var group = state.toolsGroups.find(function (g) {
                  return g.name === name;
                });
                if (!group) {
                  group = { name: name, tools: [] };state.toolsGroups.splice(position, 0, group);
                }
                return group;
              },
              addTools: function addTools(tools, groupName) {
                var _this = this;

                tools.forEach(function (t) {
                  return _this.addTool(t, groupName);
                });
              },
              removeToolGroup: function removeToolGroup(name) {
                state.toolsGroups = state.toolsGroups.filter(function (g) {
                  return g.name !== name;
                });
              },
              removeTools: function removeTools() {
                state.toolsGroups.splice(0);
              }
            } });

          service.state = state;
          service.config = null;
          service.getState = function () {
            return state;
          };
          service.reload = function () {
            service.removeTools();
          };
          service.setLoading = function () {
            var bool = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
            state.loading = bool;
          };

          // static class field
          service.ACTIONS = ACTIONS;

          var tools = _application2.default.project.getState().tools || {};

          var _loop = function _loop(_t2) {
            service.addToolGroup(0, _t2.toUpperCase());
            service.addTools(tools[_t2].map(function (tool) {
              return { name: tool.name, action: ACTIONS[_t2].bind(null, tool) };
            }), { position: 0, title: _t2.toUpperCase() });
          };

          for (var _t2 in tools) {
            _loop(_t2);
          }

          var comp = new _g3wComponent2.default({
            id: 'tools',
            icon: _gui2.default.getFontClass('tools'),
            iconColor: '#FFE721',
            title: "tools",
            service: service,
            internalComponent: new (Vue.extend({
              template: /* html */'\n                    <ul class="g3w-tools treeview-menu">\n                      <bar-loader :loading="state.loading"/>\n                      <li v-for="g in state.toolsGroups" :key="g.name">\n                        <div class="tool-header"><i :class="g3wtemplate.getFontClass(\'tool\')"></i><span>{{ g.name }}</span></div>\n                        <div :id="g.name + \'-tools\'" class="tool-box"><g3w-tool v-for="t in g.tools" :key="t.name" :tool="t" /></div>\n                      </li>\n                    </ul>',
              components: { G3wTool: require('components/Tool.vue') },
              data: function data() {
                return { state: null };
              },
              watch: {
                'state.toolsGroups': function () {
                  var _ref6 = _asyncToGenerator(function* (g) {
                    comp.setVisible(g.length > 0);
                    this.$emit('visible', g.length > 0);
                    yield _gui2.default.isReady();
                    document.querySelector('#g3w-sidebarcomponents #tools').classList.toggle('single', 1 === g.length && 'EDITING' === g[0].name);
                  });

                  function stateToolsGroups(_x5) {
                    return _ref6.apply(this, arguments);
                  }

                  return stateToolsGroups;
                }()
              }
            }))()
          });

          comp._setOpen = function () {
            var b = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

            comp.internalComponent.state.open = b;
            if (b) {
              _gui2.default.closeContent();
            }
          };

          return comp;
        }(),

        /**
         * ORIGINAL SOURCE: src/components/g3w-catalog.js@v3.10.2 
         */
        new function () {

          var state = {
            external: { // external layers
              wms: [], // added by wms sidebar component
              vector: [] // added to map controls for the moment
            },
            layerstrees: Object.values(_application2.default.catalog).map(function (s) {
              return { tree: s.getLayersTree(), storeid: s.getId() };
            }),
            layersgroups: []
          };

          var service = new _g3wObject2.default({
            setters: {
              /**
               * @param {{ layer: unknown, type: 'vector' }}
               *
               * @fires CatalogService~addExternalLayer
               *
               * @since 3.8.0
               */
              addExternalLayer: function addExternalLayer() {
                var _ref7 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                    layer = _ref7.layer,
                    _ref7$type = _ref7.type,
                    type = _ref7$type === undefined ? 'vector' : _ref7$type;

                layer.removable = true;
                state.external[type].push(layer);
              },

              /**
               * @param {{ name: string, type: 'vector' }}
               *
               * @fires CatalogService~removeExternalLayer
               *
               * @since 3.8.0
               */
              removeExternalLayer: function removeExternalLayer() {
                var _ref8 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                    name = _ref8.name,
                    _ref8$type = _ref8.type,
                    type = _ref8$type === undefined ? 'vector' : _ref8$type;

                state.external[type].filter(function (l, i) {
                  if (name === l.name) {
                    state.external[type].splice(i, 1);
                    return true;
                  }
                });
              }
            }
          });

          service.state = state;

          /** used by the following plugins: "stress" */
          service.createLayersGroup = function () {
            var _ref9 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref9$title = _ref9.title,
                title = _ref9$title === undefined ? 'Layers Group' : _ref9$title,
                _ref9$layers = _ref9.layers,
                layers = _ref9$layers === undefined ? [] : _ref9$layers;

            return { title: title, nodes: layers.map(function (l) {
                return l;
              }) };
          };
          /** used by the following plugins: "stress" */
          service.addLayersGroup = function (g) {
            state.layersgroups.push(g);
          };
          /** used by the following plugins: "processing" */
          service.getExternalLayers = function (_ref10) {
            var _ref10$type = _ref10.type,
                type = _ref10$type === undefined ? 'vector' : _ref10$type;
            return state.external[type];
          };

          var comp = new _g3wComponent2.default({
            id: 'catalog',
            icon: _gui2.default.getFontClass('map'),
            iconColor: '#019A4C',
            title: 'catalog',
            resizable: true,
            vueComponentObject: require('components/Catalog.vue'),
            service: service
          });

          return comp;
        }()],

        /**
         * ORIGINAL SOURCE: src/components/g3w-queryresults.js@v3.10.2 
         */
        queryresults: new _g3wComponent2.default({
          id: 'queryresults',
          title: 'Query Results',
          service: require('services/queryresults').default,
          vueComponentObject: require('components/QueryResults.vue')
        }),

        /**
         * ORIGINAL SOURCE: src/components/g3w-map.js@v3.10.2 
         */
        map: new _g3wComponent2.default({
          id: 'map',
          title: 'Map Component',
          service: new (require('services/map').default.MapService)(),
          vueComponentObject: require('components/Map.vue')
        }),

        /**
         * ORIGINAL SOURCE: src/components/g3w-contentsviewer.js@v3.10.2 
         */
        content: Object.assign(new _g3wComponent2.default({
          id: 'contents',
          title: 'contents',
          vueComponentObject: { template: '<div id="contents" class="contents"></div>' }
        }), {
          /** DOM element where insert the component/panel  */
          parent: null,
          contentsdata: _application2.default.contentsdata,
          getComponentById: function getComponentById(id) {
            return (_application2.default.contentsdata.find(function (d) {
              return id == d.content.id;
            }) || {}).content;
          }
        })

      });

      // listen lng change and reset datatable language
      this.$watch(function () {
        return _application2.default.language;
      }, function () {
        return _setDataTableLanguage();
      });
    },
    mounted: function () {
      var _ref11 = _asyncToGenerator(function* () {
        yield this.$nextTick();

        // add component to the sidebar and set position inside the sidebar
        CONFIG.sidebar.forEach(function (comp) {
          if (!isMobile.any || false !== comp.mobile) {
            _application2.default.sidebar.components.push(comp);
            new (Vue.extend(require('components/SidebarItem.vue')))({ component: comp }).$mount();
          }
        });

        CONFIG.sidebar.forEach(function (comp) {
          return _gui2.default.addComponent(comp);
        });

        // register other components
        _gui2.default.addComponent(CONFIG.queryresults);

        // setup Font, Css class methods
        $(document).localize();

        CONFIG.map.mount('#g3w-view-map', true);
        CONFIG.content.mount('#g3w-view-content', true);

        _gui2.default.addComponent(CONFIG.map);
        _gui2.default.addComponent(CONFIG.content);

        yield this.$nextTick();

        _application2.default.sizes.sidebar.width = $('.main-sidebar').width();

        _gui2.default.ready();

        // init plugins
        try {
          var gidProject = _application2.default.project.getGid(); // current project

          // set plugin config filtered by gid
          var enabledPlugins = {};
          Object.entries(window.initConfig.plugins).filter(function (_ref12) {
            var _ref13 = _slicedToArray(_ref12, 2),
                p = _ref13[1];

            return p.gid === gidProject;
          }).forEach(function (_ref14) {
            var _ref15 = _slicedToArray(_ref14, 2),
                name = _ref15[0],
                config = _ref15[1];

            return enabledPlugins[name] = config;
          });
          Object.assign(_application2.default.pluginsConfigs, enabledPlugins);

          Object.keys(_application2.default.pluginsConfigs).forEach(function (p) {
            return _application2.default.configurationPlugins.push(p);
          }); // filter
          Object.keys(_application2.default.pluginsConfigs).forEach(function (p) {
            return _application2.default.plugins.push(p);
          });

          // set plugins that aren't within server configuration  but in project (law for example)
          var otherPluginsConfig = _application2.default.project.getState() || {};
          if (otherPluginsConfig && otherPluginsConfig.law && otherPluginsConfig.law.length) {
            // law plugin
            _application2.default.pluginsConfigs.law = otherPluginsConfig.law;
            _application2.default.pluginsConfigs.law.gid = otherPluginsConfig.gid;
          } else {
            delete _application2.default.pluginsConfigs.law;
          }

          /** @TODO check if deprecated */
          for (var p in _application2.default.pluginsConfigs) {
            Object.entries(_application2.default.pluginsConfigs[p].plugins || {}).forEach(function (_ref16) {
              var _ref17 = _slicedToArray(_ref16, 2),
                  name = _ref17[0],
                  config = _ref17[1];

              return _application2.default.pluginsConfigs[name] = _extends({}, _application2.default.pluginsConfigs[name], config);
            });
          }

          // load plugins
          yield Promise.allSettled(Object.entries(_application2.default.pluginsConfigs).map(function () {
            var _ref19 = _asyncToGenerator(function* (_ref18) {
              var _ref20 = _slicedToArray(_ref18, 2),
                  name = _ref20[0],
                  config = _ref20[1];

              if (!config) {
                return;
              }
              config.baseUrl = window.initConfig.urls.staticurl;
              try {
                // wait plugin dependencies before loading plugin
                yield Promise.all((config.jsscripts || []).map(function (s) {
                  return _loadScript(s, false);
                }));
                yield _loadScript('' + window.initConfig.urls.staticurl + name + '/js/plugin.js?' + Date.now(), false);
              } catch (e) {
                console.warn('[G3W-PLUGIN]', e);
                // remove loading plugin in case of error of dependencies
                _application2.default.plugins = _application2.default.plugins.filter(function (p) {
                  return name !== p;
                });
                return Promise.reject();
              }
            });

            return function (_x10) {
              return _ref19.apply(this, arguments);
            };
          }()));
        } catch (e) {
          console.warn(e);
        }

        // trigger 'complete' event
        _application4.default.complete = true;
        _application4.default.emit('complete');
      });

      function mounted() {
        return _ref11.apply(this, arguments);
      }

      return mounted;
    }()
  });
}).catch(function (error) {
  console.warn(error);
  if (error) {
    if (error.responseJSON && error.responseJSON.error.data) {
      error = error.responseJSON.error.data;
    } else if (error.statusText) {
      error = error.statusText;
    }
  }
  $('#startingspinner').remove();
  new Vue(_extends({
    el: '#app'
  }, Vue.compile('<div class="error-initial-page skin-background-color">\n          <template v-if="isMobile()">\n            <h3 class="oops">Oops!</h3>\n            <h5 class="cause">' + (error || (0, _g3wI18n.t)('error_page.error')) + '</h5>\n            <h6 class="at-moment">' + (0, _g3wI18n.t)('error_page.at_moment') + '</h6>\n            <h4 class="f5">' + (0, _g3wI18n.t)('error_page.f5') + '</h4>\n          </template>\n          <template v-else>\n            <h1 class="oops">Oops!</h1>\n            <h1 class="cause">' + (error || (0, _g3wI18n.t)('error_page.error')) + '</h1>\n            <h3 class="at-moment">' + (0, _g3wI18n.t)('error_page.at_moment') + '</h3>\n            <h2 class="f5">' + (0, _g3wI18n.t)('error_page.error') + '</h2>\n          </template>\n        </div>')));
});

},{"./g3w-globals":161,"components/App.vue":70,"components/Catalog.vue":71,"components/GlobalBarLoader.vue":88,"components/GlobalDateTime.vue":89,"components/GlobalDivider.vue":90,"components/GlobalHelpDiv.vue":91,"components/GlobalProgressBar.vue":92,"components/GlobalRange.vue":93,"components/GlobalTabs.vue":94,"components/Map.vue":115,"components/Print.vue":122,"components/QueryBuilder.vue":125,"components/QueryResults.vue":126,"components/Search.vue":139,"components/SidebarItem.vue":141,"components/SpatialBookMarks.vue":142,"components/Tool.vue":144,"components/g3w-search":147,"directives/v-checked":149,"directives/v-disabled":150,"directives/v-download":151,"directives/v-select2":152,"directives/v-t":157,"directives/v-t-html":153,"directives/v-t-plugin":154,"directives/v-t-title":155,"directives/v-t-tooltip":156,"g3w-component":158,"g3w-constants":159,"g3w-i18n":162,"g3w-object":163,"g3w-panel":164,"locales":171,"services/application":205,"services/gui":207,"services/iframe":208,"services/map":209,"services/queryresults":210,"store/application":212,"utils/XHR":215,"utils/getProject":247,"utils/noop":262,"utils/promisify":267,"vue-cookie":33}],167:[function(require,module,exports){
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  translation: {
    error_page: {
      error: "Verbindungsfehler",
      at_moment: "Karte anzeigen ist im Moment nicht möglich",
      f5: "Drücken Sie Strg+F5"
    },
    cookie_law: {
      message: "Diese Website verwendet Cookies, um Ihnen die bestmögliche Erfahrung auf unserer Website zu bieten.",
      buttonText: "Verstanden!"
    },
    default: "default",
    sign_in: "Anmelden",
    layer_selection_filter: {
      tools: {
        filter: "Filter aktivieren/deaktivieren",
        nofilter: "Filter entfernen",
        invert: "Auswahl umkehren",
        clear: "Auswahl löschen",
        show_features_on_map: "Aktualisieren Sie die Ergebnisse beim Verschieben der Karte",
        savefilter: "Filter speichern",
        filterName: "Filtername"
      }
    },
    warning: {
      not_supported_format: "Nicht unterstütztes Format"
    },
    layer_position: {
      top: 'OBEN',
      bottom: 'UNTEN',
      message: "Position relativ zu den Layern im TOC"
    },
    sdk: {
      atlas: {
        template_dialog: {
          title: "Template auswählen"
        }
      },
      spatialbookmarks: {
        title: "Räumliche Lesezeichen",
        helptext: "Bewegen Sie sich auf der Kartenausdehnung, fügen Sie den Namen ein und klicken Sie auf Hinzufügen",
        input: {
          name: "Name"
        },
        sections: {
          project: {
            title: "Projekt-Lesezeichen"
          },
          user: {
            title: "Benutzer-Lesezeichen"
          }
        }
      },
      search: {
        all: 'ALLE',
        no_results: "Keine Ergebnisse",
        searching: "Suchen ...",
        error_loading: "Fehler beim Datenladen",
        layer_not_searchable: "Layer ist nicht durchsuchbar",
        layer_not_querable: "Layer ist nicht abfragbar",
        autocomplete: {
          inputshort: {
            pre: "Bitte",
            post: "oder mehrere Zeichen eingeben"
          }
        },
        help_filter: "Suchwerte werden basierend auf dem aktiven Filter begrenzt. Entfernen Sie den Filter, um nach allen Daten zu suchen.",
        autofilter: "Filtern Sie die Ergebnisse"
      },
      print: {
        no_layers: 'Kein Layer zu drucken',
        template: "Template",
        labels: "Labels",
        scale: "Skala",
        format: "Format",
        rotation: "Drehung",
        download_image: "Bild herunterladen",
        fids_instruction: "Akzeptierte Werte: von 1 bis [max]. Es ist möglich, ein Intervall einzugeben, z. B. 4-6",
        fids_example: "Bsp. 1,4-6 druckt id 1,4,5,6",
        help: "Die im Druck angezeigten Layer können die im Projekt definierten sein und nicht die auf der Karte angezeigten"
      },
      querybuilder: {
        search: {
          run: "Ausführen",
          info: "Information",
          delete: "Löschen",
          edit: "Bearbeiten"
        },
        messages: {
          changed: 'Gespeichert',
          number_of_features: "Anzahl der Features"
        },
        panel: {
          button: {
            all: 'ALLE',
            save: 'SPEICHERN',
            test: 'TEST',
            clear: 'LÖSCHEN',
            run: 'AUSFÜHREN',
            manual: 'MANUELL'
          },
          layers: 'LAYERS',
          fields: 'FELDER',
          values: 'WERTE',
          operators: 'OPERATOREN',
          expression: 'AUSDRUCK'
        },
        error_run: 'Es ist ein Fehler aufgetreten. Bitte überprüfen Sie die Abfrage',
        error_test: "Während der Ausführung der Abfrage ist ein Fehler aufgetreten",
        delete: 'Soll es gelöscht werden?',
        additem: 'Geben Sie den Namen der neuen Suche ein'
      },
      errors: {
        layers: {
          load: "Einige Layer sind nicht verfügbar"
        },
        unsupported_format: 'Nicht unterstütztes Format',
        add_external_layer: 'Fehler im Ladevorgang des Layers'
      },
      metadata: {
        title: 'Metadaten',
        groups: {
          general: {
            title: 'ALLGEMEIN',
            fields: {
              title: 'TITEL',
              name: 'NAME',
              description: "BESCHREIBUNG",
              abstract: "ABASTRACT",
              keywords: 'SCHLÜSSELWÖRTER',
              fees: "GEBÜHREN",
              accessconstraints: "ZUGRIFFSBESCHRÄNKUNG",
              contactinformation: "KONTAKTE",
              subfields: {
                contactinformation: {
                  contactelectronicmailaddress: "Email",
                  personprimary: 'Referenzen',
                  contactvoicetelephone: 'Telefon',
                  contactorganization: 'Firma',
                  ContactOrganization: 'Firma',
                  contactposition: 'Position',
                  ContactPosition: 'Position',
                  contactperson: 'Person',
                  ContactPerson: 'Person'
                }
              },
              wms_url: "WMS"
            }
          },
          spatial: {
            title: 'SPATIAL',
            fields: {
              crs: 'EPSG',
              extent: 'BBOX'
            }
          },
          layers: {
            title: 'LAYERS',
            fields: {
              layers: 'LAYERS',
              subfields: {
                crs: 'EPSG',
                bbox: 'BBOX',
                title: "TITEL",
                name: 'NAME',
                geometrytype: 'GEOMETRIE',
                source: 'QUELLE',
                attributes: 'ATTRIBUTE',
                abstract: 'ABSTRACT',
                attribution: 'ATRIBUTION',
                keywords: "SCHLÜSSELWÖRTER",
                metadataurl: 'METADATEN URL',
                dataurl: "DATEN URL"
              }
            },
            groups: {
              general: 'ALLGEMEIN',
              spatial: 'SPATIAL'
            }
          }
        }
      },
      tooltips: {
        relations: {
          form_to_row: "Zeilenansicht",
          row_to_form: "Formularansicht",
          zoomtogeometry: "Auf Geometrie zoomen"
        },
        copy_map_extent_url: 'Link zur Kartenansicht kopieren',
        download_shapefile: "Shapefile herunterladen",
        download_gpx: "DGPX herunterladen",
        download_gpkg: "GPKG herunterladen",
        download_csv: "CSV herunterladen",
        download_xls: "XLS herunterladen",
        download_pdf: "PDF herunterladen",
        show_chart: "Diagramm anzeigen",
        atlas: "Atlas drucken",
        editing: "Editing"
      },
      mapcontrols: {
        query: {
          tooltip: 'Query layer',
          actions: {
            add_selection: {
              hint: "Auswahl hinzufügen/entfernen"
            },
            zoom_to_features_extent: {
              hint: "Zoom auf Feature-Ausdehnung"
            },
            add_features_to_results: {
              hint: "Hinzufügen/Entfernen von Features zu den Ergebnissen"
            },
            remove_feature_from_results: {
              hint: "Feature aus den Ergebnissen entfernen"
            },
            zoom_to_feature: {
              hint: "Zum Feature zoomen"
            },
            relations: {
              hint: "Relationen anzeigen"
            },
            relations_charts: {
              hint: "Relationship-Diagramm anzeigen"
            },
            download_features_shapefile: {
              hint: 'Features Shapefile herunterladen'
            },
            download_shapefile: {
              hint: 'Feature Shapefile herunterladen'
            },
            download_features_gpx: {
              hint: "Feature GPX herunterladen"
            },
            download_features_gpkg: {
              hint: "Feature GPKG herunterladen"
            },
            download_gpx: {
              hint: "Feature GPX herunterladen"
            },
            download_gpkg: {
              hint: "Feature GPKG herunterladen"
            },
            download_features_csv: {
              hint: "Features CSV herunterladen"
            },
            download_csv: {
              hint: "Feature CSV herunterladen"
            },
            download_features_xls: {
              hint: "Features XLS herunterladen"
            },
            download_xls: {
              hint: "Feature XLS herunterladen"
            },
            download_pdf: {
              hint: "Feature PDF herunterladen"
            },
            atlas: {
              hint: "Atlas drucken"
            },
            copy_zoom_to_fid_url: {
              hint: "Kopieren der Karten-URL mit dieser Geometrie-Feature-Erweiterung",
              hint_change: "Kopiert"
            }
          }
        },
        queryby: {
          title: 'Query area',
          layer: 'Selected layer:',
          none: 'NONE',
          new: 'TEMPORARY LAYER',
          all: 'ALL',
          methods: {
            intersects: 'intersects',
            within: 'within'
          },
          querybypolygon: {
            tooltip: 'select a polygon'
          },
          querybydrawpolygon: {
            tooltip: 'draw a polygon'
          },
          querybbox: {
            tooltip: 'draw a rectangle'
          },
          querybycircle: {
            tooltip: 'draw a circle'
          }
        },

        querybypolygon: {
          download: {
            title: "Attribute herunterladen",
            choiches: {
              feature: {
                label: "Nur Features"
              },
              feature_polygon: {
                label: "Features+Query Polygon"
              }
            }
          },
          tooltip: 'Query nach Polygon',
          no_geometry: 'Keine Geometrie in der Antwort',
          help: {
            message: "<ul><li>Wählen Sie einen Polygon Layer auf TOC.</li><li>Stellen Sie sicher, dass der Layer sichtbar ist.</li><li>Klicken Sie auf ein Feature des ausgewählten Layers.</li></ul>"
          }
        },
        querybydrawpolygon: {
          tooltip: "Abfrage durch Polygon zeichnen"
        },
        querybbox: {
          tooltip: 'BBox Layer abfragen',
          nolayers_visible: 'Es sind keine abfragbaren Layer sichtbar. Bitte setzen Sie mindestens einen sichtbaren wfs Layer, um die Abfrage zu starten',
          help: {
            message: "<ul><li>Ein Quadrat auf der Karte ziehen, um unterstrichene Layer im TOC abzufragen</li></ul>"
          }
        },
        addlayer: {
          messages: {
            csv: {
              warning: "Das Ergebnis in der Karte ist unvollständig, da die unten stehende Liste fehlerhafter Einträge enthält:"
            }
          },
          tooltip: 'Layer hinzufügen'
        },
        geolocation: {
          tooltip: 'Geolokalisierung'
        },
        measures: {
          length: {
            tooltip: "Länge",
            help: "Klicken Sie auf die Karte, um die Linie zu zeichnen. Drücken Sie <br>CANC, wenn Sie den letzten Eckpunkt löschen möchten."
          },
          area: {
            tooltip: "Fläche",
            help: "Drücken Sie <br>CANC, wenn Sie den letzten Eckpunkt löschen wollen."
          }
        },
        scale: {
          no_valid_scale: "Ungültige Skala"
        },
        scaleline: {
          units: {
            metric: 'Meter',
            nautical: 'Nautische Meile'
          }
        },
        zoomhistory: {
          zoom_last: "Zoom Vorheriger",
          zoom_next: "Zoom Nächster"
        }
      },
      relations: {
        relation_data: 'Daten zur Relation',
        no_relations_found: 'Keine Relationen gefunden',
        back_to_relations: 'Zurück zu den Relationen',
        list_of_relations_feature: 'Liste der Relationen des Features',
        error_missing_father_field: "Ein Feld fehlt",
        field: "Relation key field"
      },
      form: {
        loading: 'Laden ...',
        inputs: {
          messages: {
            errors: {
              picklayer: "Kein Feature ausgewählt. Prüfen, ob der Layer in Bearbeitung oder im aktuellen Maßstab sichtbar ist"
            }
          },
          tooltips: {
            picklayer: "Wert aus dem Layer abrufen",
            lonlat: "Zum Abrufen der Koordinaten auf die Karte klicken"
          },
          input_validation_mutually_exclusive: "Feld schließt sich gegenseitig aus mit ",
          input_validation_error: "Obligatorisches Feld oder falscher Datentyp",
          input_validation_error_type: "Falscher Datentyp",
          input_validation_min_field: "Der Wert muss größer/gleich sein als der Feldwert  ",
          input_validation_max_field: "Der Wert muss kleiner/gleich sein als der Feldwert ",
          input_validation_exclude_values: "Wert muss einmalig sein",
          integer: "integer",
          bigint: "integer",
          text: "text",
          varchar: "text",
          textarea: "text",
          string: "string",
          date: "date",
          datetime: "date",
          float: "float",
          table: "table"
        },
        footer: {
          "required_fields": "Erforderliche Felder"
        },
        messages: {
          qgis_input_widget_relation: "Spezifisches Relations-Formular verwenden, um mit Relationen zu arbeiten"
        }
      },
      catalog: {
        current_map_theme_prefix: "THEMA",
        choose_map_theme: "THEMA AUSWÄHLEN",
        choose_map_theme_input_label: 'Name des neuen Themes',
        project_map_theme: 'Projekt Themes',
        user_map_theme: 'Benutzer Themes',
        question_delete_map_theme: "Möchten Sie das Thema löschen??",
        delete_map_theme: "Theme erfolgreich gelöscht",
        saved_map_theme: "Thema erfolgreich gespeichert",
        updated_map_theme: "Thema aktualisieren gespeichert",
        invalid_map_theme_name: "Der Name ist bereits vorhanden oder falsch",
        menu: {
          layerposition: 'Position der Ebenen',
          setwmsopacity: "Opazität einstellen",
          wms: {
            title: "",
            copy: "Klicken Sie hier, um die Url zu kopieren",
            copied: "Kopiert"
          },
          download: {
            unknow: "Herunterladen",
            shp: 'Shapefile herunterladen',
            gpx: 'GPX herunterladen',
            gpkg: 'GPKG herunterladen',
            csv: 'CSV herunterladen',
            xls: 'XLS herunterladen',
            geotiff: "GEOTIFF herunterladen",
            geotiff_map_extent: "GEOTIFF herunterladen (aktueller Ansichtsumfang)"
          }
        }
      },
      wps: {
        list_process: "Liste der Prozesse",
        tooltip: 'Karte anklicken'
      }
    },
    credits: {
      g3wSuiteFramework: "Applikation basiert auf OS-Framework",
      g3wSuiteDescription: "Veröffentlichen und verwalten Sie Ihre QGIS-Projekte im Internet",
      productOf: "Framework entwickelt von"
    },
    toggle_color_scheme: "Farbschema umschalten",
    logout: "Logout",
    no_other_projects: "Kein weiteres Projekt für diese Gruppe",
    no_other_groups: "Keine weiteren Gruppen für diese Makrogruppe",
    yes: "Ja",
    no: "No",
    back: "Zurück",
    backto: "Zurück zu ",
    changemap: "Karte ändern",
    change_session: "Sitzung ändern",
    component: "Allgemeine Komponente",
    search: "Suche",
    no_results: "Keine Ergebnisse gefunden",
    print: "Drucken",
    create_print: "Drucken erstellen",
    dosearch: "Suche",
    catalog: "Karte",
    data: "Daten",
    externalwms: "WMS",
    baselayers: "Base",
    tools: "Tools",
    tree: "Layers",
    legend: "Legende",
    nobaselayer: "Keine Basemap",
    street_search: "Adresse finden",
    show: "Anzeigen",
    hide: "Ausblenden",
    copy_form_data: "Daten kopieren",
    paste_form_data: "Einfügen",
    copy_form_data_from_feature: "Daten von der Karte kopieren",
    error_map_loading: "Fehler beim Laden der Karte",
    check_internet_connection_or_server_admin: "Internetverbindung prüfen oder Admin kontaktieren",
    could_not_load_vector_layers: "Verbindungsfehler: Layers können geladen werden",
    server_saver_error: "Fehler beim Speichern auf dem Server",
    server_error: "Server-Verbindungsfehler",
    save: "Speichern",
    cancel: "Abbrechen",
    update: "Aktualisieren",
    close: "Schließen",
    /** @since 3.8.0 */
    dont_show_again: "Diese Meldung nicht mehr anzeigen",
    enlange_reduce: "Vergrößern / Verkleinern",
    add: "Hinzufügen",
    exitnosave: "Beenden ohne Speichern",
    annul: "Abbrechen",
    layer_is_added: "Layer mit gleichem Namen bereits hinzugefügt",
    sidebar: {
      wms: {
        panel: {
          title: 'WMS Layer hinzufügen',
          label: {
            position: "Kartenposition",
            name: "Name",
            projections: 'Projektion',
            layers: 'Layers'
          }
        },
        add_wms_layer: "WMS Layer hinzufügen",
        delete_wms_url: "WMS Url löschen",
        layer_id_already_added: "WMS Layer bereits hinzugefügt",
        url_already_added: "WMS URL/Name bereits hinzugefügt",
        layer_add_error: "WMS Layer nicht hinzugefügt. Bitte überprüfen Sie alle WMS-Parameter oder Url"
      }
    },
    info: {
      title: "Ergebnisse",
      list_of_relations: "List of Relations",
      open_link: "Beigefügtes Dokument öffnen",
      server_error: "Auf dem Server ist ein Fehler aufgetreten",
      no_results: "Keine Ergebnisse für diese Anfrage/Suche gefunden",
      link_button: "Öffnen"
    },
    mapcontrols: {
      geolocation: {
        error: "Position kann nicht bestimmt werden"
      },
      geocoding: {
        choose_layer: "Wählen Sie eine Ebene aus, auf der Sie diese Funktion hinzufügen möchten",
        placeholder: "Addresse ...",
        nolayers: "Für dieses Projekt wurden keine bearbeitbaren Punktebenen gefunden",
        noresults: "Keine Ergebnisse",
        notresponseserver: "Keine Antwort vom Server"
      },
      add_layer_control: {
        header: "Layer hinzufügen",
        select_projection: "Layer Projektion auswählen",
        select_field_to_show: "Feld auswählen, das auf der Karte angezeigt werden soll",
        select_csv_separator: "Begrenzer auswählen",
        select_csv_x_field: "X-Feld auswählen",
        select_csv_y_field: "Y-Feld auswählen",
        select_color: "Layer Farbe auswählen",
        drag_layer: "Layer hierher ziehen und ablegen"
      },
      query: {
        input_relation: "Klicken, um Relationen anzuzeigen"
      },
      length: {
        tooltip: "Länge"
      },
      area: {
        tooltip: "Area"
      },
      screenshot: {
        error: "Screenshot Fehlererstellung",
        securityError: "  \n        <p><b>Sicherheitsfehler</b>: Eine externe Ebene verhindert, dass die Karte gedruckt wird. Gehen Sie zur \xDCberpr\xFCfung wie folgt vor:</p>\n        <ol>\n          <li>Entfernen Sie alle manuell hinzugef\xFCgten externen Ebenen (z. B. WMS-Ebenen)</li>\n          <li>Neuladen der Seite erzwingen: <code>STRG + F5</code></li>\n          <li>Drucken Sie die Karte erneut</li>\n        </ol>\n        <p>F\xFCr weitere Informationen wenden Sie sich bitte an den Serveradministrator zu: <a href=\"https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_enabled_image\" style=\"color: #000 !important;font -weight: fett;\">&#x2139;&#xFE0F; Sicherheit und befleckte Leinw\xE4nde</a></p>\n        "
      }
    },
    catalog_items: {
      helptext: "Klicken Sie mit der rechten Maustaste auf einen einzelnen Layer, um auf zusätzliche Funktionen zuzugreifen",
      contextmenu: {
        zoomtolayer: "Zoom auf Layer",
        open_attribute_table: "Attributtabelle öffnen",
        show_metadata: "Metadaten",
        styles: 'Stile',
        vector_color_menu: "Farbe einstellen/ändern",
        layer_opacity: "Opazität",
        filters: "Filters"
      }
    },
    dataTable: {
      previous: "Vorherige",
      next: "Weiter",
      lengthMenu: "Zeigen Sie _MENU_ Werte pro Seite an",
      info: "_TOTAL_ Ergebnissen",
      no_data: "Keine Daten",
      nodatafilterd: "Keine passenden Datensätze gefunden",
      infoFiltered: "(gefiltert aus _MAX_ Gesamtsätzen)"
    }
  }
};

},{}],168:[function(require,module,exports){
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  translation: {
    error_page: {
      error: "Connection error",
      at_moment: "At the moment is not possible show map",
      f5: "Press Ctrl+F5"
    },
    cookie_law: {
      message: "This website uses cookies to ensure you get the best experience on our website.",
      buttonText: "Got It!"
    },
    default: "default",
    sign_in: "Sign in",
    layer_selection_filter: {
      tools: {
        filter: "Enable/Disable filter",
        nofilter: "Remove Filter",
        invert: "Invert Selection",
        clear: "Clear Selection",
        show_features_on_map: "Update results when map moves",
        savefilter: "Save Filter",
        filterName: "Filter Name"
      }
    },
    warning: {
      not_supported_format: "Not supported format"
    },
    layer_position: {
      top: 'top',
      bottom: 'bottom',
      message: "Position"
    },
    sdk: {
      atlas: {
        template_dialog: {
          title: "Select Template"
        }
      },
      spatialbookmarks: {
        title: "Bookmarks",
        helptext: "Move on map extent, insert name and click Add",
        input: {
          name: "Name"
        },
        sections: {
          project: {
            title: "Project Bookmarks"
          },
          user: {
            title: "User Bookmarks"
          }
        }
      },
      search: {
        all: 'ALL',
        no_results: "No results",
        searching: "Searching ...",
        error_loading: "Error Loading Data",
        layer_not_searchable: "Layer is not searchable",
        layer_not_querable: "Layer is not querable",
        autocomplete: {
          inputshort: {
            pre: "Please enter",
            post: "or more characters"
          }
        },
        help_filter: "Search values are limited based on the active filter. Remove the filter to search all data.",
        autofilter: "Filter results"

      },
      print: {
        no_layers: 'No Layer to print',
        template: "Template",
        labels: "Labels",
        scale: "Scale",
        format: "Format",
        rotation: "Rotation",
        download_image: "Download Image",
        fids_instruction: "Values accepted: from 1 to value of [max]. Is possible to insert a range ex. 4-6",
        fids_example: "Ex. 1,4-6 will be printed id 1,4,5,6",
        help: "Exportable layers are defined by the administrator",
        help_details: "<p>If you don't see some layer in your print file:</p>\n          <ol style=\"padding-left: 25px\">\n            <li>try again by selecting a different template</li>\n            <li>try changing the zoom level</li>\n            <li>check the origin (eg. third-party WMS server)</li>\n            <li>make sure the item is actually checked within layers list</li>\n          </ol>"
      },
      querybuilder: {
        title: 'Advanced search',
        search: {
          run: "Run",
          info: "Information",
          delete: "Delete",
          edit: "Edit"
        },
        messages: {
          changed: 'Saved',
          number_of_features: "Features found:"
        },
        panel: {
          button: {
            all: 'SEARCH A VALUE',
            save: 'SAVE',
            test: 'TEST',
            clear: 'CLEAR',
            run: 'RUN',
            manual: 'MANUAL'
          },
          layers: 'LAYERS',
          fields: 'FIELDS',
          values: 'VALUES',
          operators: 'OPERATORS',
          expression: 'EXPRESSION'
        },
        error_run: 'An error occurs. Please check the query',
        error_test: "An error occur during query execution",
        delete: 'Do you want delete it?',
        additem: 'Insert the name of the new search'
      },
      errors: {
        layers: {
          load: "Some layers are not available"
        },
        unsupported_format: 'Not supported format',
        add_external_layer: 'Load layer error'
      },
      metadata: {
        title: 'Metadata',
        groups: {
          general: {
            title: 'GENERAL',
            fields: {
              title: 'TITLE',
              name: 'NAME',
              description: "DESCRIPTION",
              abstract: "ABSTRACT",
              keywords: 'KEYWORDS',
              fees: "FEES",
              accessconstraints: "ACCESS CONSTRAINT",
              contactinformation: "CONTACTS",
              subfields: {
                contactinformation: {
                  contactelectronicmailaddress: "Email",
                  personprimary: 'References',
                  contactvoicetelephone: 'Phone',
                  contactorganization: 'Organization',
                  ContactOrganization: 'Organization',
                  contactposition: 'Position',
                  ContactPosition: 'Position',
                  contactperson: 'Person',
                  ContactPerson: 'Person'
                }
              },
              wms_url: "WMS"
            }
          },
          spatial: {
            title: 'SPATIAL',
            fields: {
              crs: 'EPSG',
              extent: 'BBOX'
            }
          },
          layers: {
            title: 'LAYERS',
            fields: {
              layers: 'LAYERS',
              subfields: {
                crs: 'EPSG',
                bbox: 'BBOX',
                title: "TITLE",
                name: 'NAME',
                geometrytype: 'GEOMETRY',
                source: 'SOURCE',
                attributes: 'ATTRIBUTES',
                abstract: 'ABSTRACT',
                attribution: 'ATTRIBUTION',
                keywords: "PAROLE CHIAVE",
                metadataurl: 'METADATA URL',
                dataurl: "DATA URL"
              }
            },
            groups: {
              general: 'GENERAL',
              spatial: 'SPATIAL'
            }
          },
          credits: {
            title: 'Credits'
          }
        }
      },
      tooltips: {
        relations: {
          form_to_row: "Row View",
          row_to_form: "Form View",
          zoomtogeometry: "Zoom to Geometry"
        },
        copy_map_extent_url: 'Copy share URL',
        download_shapefile: "Download Shapefile",
        download_gpx: "Download GPX",
        download_gpkg: "Download GPKG",
        download_csv: "Download CSV",
        download_xls: "Download XLS",
        download_pdf: "Download PDF",
        show_chart: "Show Chart",
        atlas: "Print Atlas",
        editing: "Editing"
      },
      mapcontrols: {
        query: {
          tooltip: 'Query layer',
          actions: {
            add_selection: {
              hint: "Add/Remove Selection"
            },
            zoom_to_features_extent: {
              hint: "Zoom to features extent"
            },
            add_features_to_results: {
              hint: "Add/Remove features to results"
            },
            remove_feature_from_results: {
              hint: "Remove feature from results"
            },
            zoom_to_feature: {
              hint: "Zoom to feature"
            },
            relations: {
              hint: "Show Relations"
            },
            relations_charts: {
              hint: "Show relations chart"
            },
            download_features_shapefile: {
              hint: 'Download features Shapefile'
            },
            download_shapefile: {
              hint: 'Download feature Shapefile'
            },
            download_features_gpx: {
              hint: "Download feature GPX"
            },
            download_features_gpkg: {
              hint: "Download features GPKG"
            },
            download_gpx: {
              hint: "Download feature GPX"
            },
            download_gpkg: {
              hint: "Download feature GPKG"
            },
            download_features_csv: {
              hint: "Download features CSV"
            },
            download_csv: {
              hint: "Download feature CSV"
            },
            download_features_xls: {
              hint: "Download features XLS"
            },
            download_xls: {
              hint: "Download feature XLS"
            },
            download_pdf: {
              hint: "Download feature PDF"
            },
            atlas: {
              hint: "Print Atlas"
            },
            copy_zoom_to_fid_url: {
              hint: "Share via link",
              hint_change: "Copied"
            }
          }
        },
        queryby: {
          title: 'Query area',
          layer: 'Selected layer:',
          none: 'NONE',
          new: 'TEMPORARY LAYER',
          all: 'ALL',
          methods: {
            intersects: 'intersects',
            within: 'within'
          },
          querybypolygon: {
            tooltip: 'select a polygon'
          },
          querybydrawpolygon: {
            tooltip: 'draw a polygon'
          },
          querybbox: {
            tooltip: 'draw a rectangle'
          },
          querybycircle: {
            tooltip: 'draw a circle'
          }
        },
        querybypolygon: {
          download: {
            title: "Attributes download",
            choiches: {
              feature: {
                label: "Features only"
              },
              feature_polygon: {
                label: "Features+Query Polygon"
              }
            }
          },
          tooltip: 'Query By Polygon',
          no_geometry: 'No geometry on response',
          help: {
            message: "<ul><li>Select a (visible) layer.</li><li>Click on a geometry within map.</li></ul>"
          }
        },
        querybydrawpolygon: {
          tooltip: "Query by Draw Polygon ",
          help: {
            message: "<ul><li>Click on map to add a new vertex</li><li>Double click to finish and query layers (underlined in yellow in legend)</li></ul>"
          }
        },
        querybbox: {
          tooltip: 'Query BBox layer',
          nolayers_visible: 'No querable layers are visible. Please set at least one visible wfs layer to run query',
          help: {
            message: "<ul><li>Drag the mouse to draw a rectangle and query layers (underlined in yellow in legend)</li></ul>"
          }
        },
        querybycircle: {
          tooltip: "Query by Draw Circle ",
          label: 'Radius',
          help: {
            message: "<ul><li>Click on map to draw circle</li></ul>"
          }
        },
        addlayer: {
          messages: {
            csv: {
              warning: "The result in the map is partial due to the presence of the below incorrect records list:"
            }
          },
          tooltip: 'Add Layer'
        },
        geolocation: {
          tooltip: 'Geolocation'
        },
        measures: {
          title: 'Measure',
          length: {
            tooltip: "Length",
            help: "Click on map to draw the line. Press <br>CANC if you want delete last vertex"
          },
          area: {
            tooltip: "Area",
            help: "Click to draw poligon.Press <br>CANC if you want delete last vertex"
          }
        },
        screenshot: {
          title: 'Screen capture',
          screenshot: "PNG",
          geoscreenshot: "GeoTIFF",
          download: 'Generate'
        },
        scale: {
          no_valid_scale: "Invalid Scale"
        },
        scaleline: {
          units: {
            metric: 'Meters',
            nautical: 'Nautical Mile'
          }
        },
        zoomhistory: {
          zoom_last: "Zoom Last",
          zoom_next: "Zoom Next"
        }
      },
      relations: {
        relation_data: 'Relation data',
        no_relations_found: 'No relations found',
        back_to_relations: 'Back to relations',
        list_of_relations_feature: 'List of relations of feature',
        error_missing_father_field: "Field is missing",
        field: "Relation key field"
      },
      form: {
        loading: 'Loading ...',
        inputs: {
          messages: {
            errors: {
              picklayer: "No feature selected. Check if layer is on editing or visible at current scale"
            }
          },
          tooltips: {
            picklayer: "Get value from ma layer",
            lonlat: "Click on map to get coordinates"
          },
          input_validation_mutually_exclusive: "Field mutually exclusive with ",
          input_validation_error: "Mandatory Field or wrong data type",
          input_validation_error_type: "Wrong data type",
          input_validation_min_field: "Value has to be more/equal to field value  ",
          input_validation_max_field: "Value has to be less/equal to field value ",
          input_validation_exclude_values: "Value has to be unique",
          integer: "integer",
          bigint: "integer",
          text: "text",
          varchar: "text",
          textarea: "text",
          string: "string",
          date: "date",
          datetime: "date",
          float: "float",
          table: "table"
        },
        footer: {
          "required_fields": "Required fields"
        },
        messages: {
          qgis_input_widget_relation: "Use relation specific form to work with relation"
        }
      },
      catalog: {
        current_map_theme_prefix: "THEME",
        choose_map_theme: "CHOOSE THEME",
        choose_map_theme_input_label: 'Name of new map theme',
        project_map_theme: 'Project Themes',
        user_map_theme: 'User Themes',
        question_delete_map_theme: "Do you want delete the theme?",
        delete_map_theme: "Theme deleted successfully",
        saved_map_theme: "Theme saved successfully",
        updated_map_theme: "Theme updated successfully",
        invalid_map_theme_name: "Invalid or exiting name",
        menu: {
          layerposition: 'Layer Position',
          setwmsopacity: "Set Opacity",
          wms: {
            title: "",
            copy: "Click here to copy url",
            copied: "Copied"
          },
          download: {
            unknow: 'Download',
            geotiff_map_extent: "GeoTiff (current view)"
          }
        }
      },
      wps: {
        list_process: "List of process",
        tooltip: 'Click on map'
      }
    },
    credits: {
      g3wSuiteFramework: "Application based on OS framework",
      g3wSuiteDescription: "Publish and manage your QGIS projects on the web",
      productOf: "Framework developed by"
    },
    toggle_color_scheme: "Toggle color scheme",
    logout: "Logout",
    no_other_projects: "No more project for this group",
    no_other_groups: "No more groups for this Macrogroup",
    yes: "Yes",
    no: "No",
    back: "Back",
    backto: "Back to ",
    changemap: "Change map",
    change_session: "Change Session",
    component: "Generic Component",
    search: "Search",
    no_results: "No results found",
    print: "Print",
    create_print: "Create Print",
    dosearch: "Search",
    catalog: "Map",
    data: "Data",
    externalwms: "WMS",
    baselayers: "Base",
    tools: "Tools",
    tree: "Layers",
    legend: "Legend",
    nobaselayer: "No basemap",
    street_search: "Find Address",
    show: "Show",
    hide: "Hide",
    copy_form_data: "Copy data",
    paste_form_data: "Paste",
    copy_form_data_from_feature: "Copy data from map",
    error_map_loading: "Error occurs loading map",
    check_internet_connection_or_server_admin: "Check internet connection or contact admin",
    could_not_load_vector_layers: "Connection error: Layers can be loaded",
    server_saver_error: "Error in server saving",
    server_error: "Server connection error",
    save: "Save",
    cancel: "Cancel",
    update: "Update",
    close: "Close",
    /** @since 3.8.0 */
    dont_show_again: "Don't show again",
    enlange_reduce: "Enlarge / Reduce",
    add: "Add",
    exitnosave: "Exit without save",
    annul: "Cancel",
    layer_is_added: "Layer with same name already added",
    sidebar: {
      wms: {
        panel: {
          title: 'Add WMS Layer',
          label: {
            position: "Map Position",
            name: "Name",
            projections: 'Projection',
            layers: 'Layers'
          }
        },
        add_wms_layer: "Add WMS layer",
        delete_wms_url: "Remove",
        layer_id_already_added: "A WMS connection with this name already exists",
        url_already_added: "WMS URL/Name already added",
        layer_add_error: "WMS Layer not added. Please check all wms parameter or url"
      }
    },
    info: {
      title: "Results",
      list_of_relations: "List of Relations",
      open_link: "Open attached document",
      server_error: "An error occurred from server",
      no_results: "No results found for this query/search",
      link_button: "Open"
    },
    mapcontrols: {
      geolocation: {
        error: "Can't get your position"
      },
      geocoding: {
        choose_layer: "Choose a layer where to add this feature",
        placeholder: "Address ...",
        nolayers: "No editable point layers found on this project",
        noresults: "No results",
        notresponseserver: "No response from server"
      },
      add_layer_control: {
        header: "Add Layer",
        select_projection: "Projection",
        select_field_to_show: "field shown on map",
        select_csv_separator: "Delimiter",
        select_csv_x_field: "X field",
        select_csv_y_field: "Y field",
        select_color: "Layer Color",
        drag_layer: "Add your file here",
        persistent_data: "Persistent data",
        persistent_help: "save layer into browser storage"
      },
      query: {
        input_relation: "Click to show relations"
      },
      length: {
        tooltip: "Length"
      },
      area: {
        tooltip: "Area"
      },
      screenshot: {
        error: "Screenshot error creation",
        securityError: "  \n        <p><b>Security Error</b>: an external layer is preventing map from being printed. To check, proceed as follows:</p>\n        <ol>\n          <li>remove any manually added external layers (eg. WMS layers)</li>\n          <li>force page reload: <code>CTRL + F5</code></li>\n          <li>print again the map</li>\n        </ol>\n        <p>For more info please contact server administrator about: <a href=\"https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_enabled_image\" style=\"color: #000 !important;font-weight: bold;\">&#x2139;&#xFE0F; security and tainted canvases</a></p>\n        "
      }
    },
    catalog_items: {
      helptext: "Open menu",
      contextmenu: {
        zoomtolayer: "Zoom to Layer",
        open_attribute_table: "Open Attribute Table",
        show_metadata: "Metadata",
        styles: 'Style',
        vector_color_menu: "Color",
        layer_opacity: "Opacity",
        filters: "Filters",
        download: 'Save as',
        ogc_services: 'OGC Services',
        edit: "Edit Layer"
      }
    },
    dataTable: {
      previous: "Previous",
      next: "Next",
      lengthMenu: "Show _MENU_ values per page",
      info: "_TOTAL_ entries",
      no_data: "No data",
      nodatafilterd: "No matching records found",
      infoFiltered: "(filtered from _MAX_ total records)"
    },
    /**@since 3.10.0 */
    no_geometry: 'This item has no geometry',
    /**@since 3.11.0 */
    query_filter: 'Filter by:',
    /**@since 3.11.0 */
    sidebar_menu: 'Sidebar menu',
    /**@since 3.11.0 */
    layer_type: 'Layer type',
    /** @since 3.11.0 */
    choose_type: 'Choose type',
    /**@since 3.11.0 */
    remote_wms_url: 'WMS (URL)',
    /**@since 3.11.0 */
    local_file: 'Local file',
    /**@since 3.11.0 */
    embed_map: 'Embed map',
    /** @since 3.11.0 */
    homepage: 'Home',
    /** @since 3.11.0 */
    wms_server: 'WMS Server',
    /** @since 3.11.0 */
    connect_to_wms: 'Connect',
    /** @since 3.11.0 */
    disconnect_from_wms: 'Disconnect',
    /** @since 3.11.0 */
    add_new_wms_url_help: 'Search through saved connections or add a new server',
    /** @since 3.11.0 */
    saved_connections: 'Saved connections:',
    /** @since 3.11.0 */
    label: "Label",
    /** @since 3.11.0 */
    no_csv_field: 'No valid fields',
    /** @since 3.11.0 */
    show_more: 'Show more'
  }
};

},{}],169:[function(require,module,exports){
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  translation: {
    error_page: {
      error: "Yhteysvirhe",
      at_moment: "Tällä hetkellä ei ole mahdollista näyttää karttaa",
      f5: "Paina Ctrl+F5"
    },
    cookie_law: {
      message: "This website uses cookies to ensure you get the best experience on our website.",
      buttonText: "Got It!"
    },
    default: "oletuksena",
    sign_in: "Kirjaudu sisään",
    layer_selection_filter: {
      tools: {
        filter: "Ota suodatin käyttöön/poista käytöstä",
        nofilter: "Poista Suodattaa",
        invert: "Käänteinen Valinta",
        clear: "Peruuttaa Valinta",
        show_features_on_map: "Päivitä tulokset karttaa siirtäessäsi",
        savefilter: "Tallenna suodatin",
        filterName: "Suodattimen Nimi"
      }
    },
    warning: {
      not_supported_format: "Not supported format"
    },
    layer_position: {
      top: 'TOP',
      bottom: 'BOTTOM',
      message: "Position relative to layers on TOC"
    },
    sdk: {
      atlas: {
        template_dialog: {
          title: "Valitse Template"
        }
      },
      spatialbookmarks: {
        title: "Tilalliset kirjanmerkit",
        helptext: "Siirry kartan laajuuteen, lisää nimi ja napsauta Lisää",
        input: {
          name: "Nimi"
        },
        sections: {
          project: {
            title: "Projektin kirjanmerkit"
          },
          user: {
            title: "Käyttäjän kirjanmerkit"
          }
        }
      },
      search: {
        all: 'KAIKKI',
        no_results: "Ei tuloksia",
        searching: "Haetaan ...",
        error_loading: "Virhe ladattaessa tietoja.",
        layer_not_searchable: "Taso ei ole haettavissa.",
        layer_not_querable: "Tasolle ei voi suorittaa kyselyitä.",
        autocomplete: {
          inputshort: {
            pre: "Syötä",
            post: "tai useampi merkki"
          }
        },
        help_filter: "Hakuarvot ovat rajoitettuja aktiivisen suodattimen perusteella. Poista suodatin etsiäksesi kaikista tiedoista.",
        autofilter: "Suodata tulokset"
      },
      print: {
        no_layers: 'Ei tulostettavia tasoja',
        template: "Template",
        labels: "Labels",
        scale: "Mittakaava",
        format: "Formaatti",
        rotation: "Kierto",
        download_image: "Lataa kuva",
        fids_instruction: "Hyväksytyt arvot: yhdestä arvoon [max]. Salittua syöttää myös väli, esim. 4-6.",
        fids_example: "Esimerkiksi 1,4-6 tulostuu id 1,4,5,6.",
        help: "Tulosteessa esiintyvät tasot voivat olla projektissa määriteltyjä ei kartalla esiintyviä."
      },
      querybuilder: {
        search: {
          run: "Suorita",
          info: "Informaatio",
          delete: "Poista",
          edit: "Muokkaa"
        },
        messages: {
          changed: 'Tallennettu',
          number_of_features: "Ominaisuuksien lukumäärä"
        },
        panel: {
          button: {
            all: 'KAIKKI',
            save: 'TALLENNA',
            test: 'TESTI',
            clear: 'TYHJENNÄ',
            run: 'SUORITA',
            manual: 'MANUAALINEN'
          },
          layers: 'TASOT',
          fields: 'KENTÄT',
          values: 'ARVOT',
          operators: 'OPERAATTORIT',
          expression: 'LAUSEKE'
        },
        error_run: 'Tapahtui virhe. Tarkista kysely.',
        error_test: "Kyselyä suorittaessa tapahtui virhe.",
        delete: 'Haluatko poistaa sen?',
        additem: 'Anna nimi uudelle haulle.'
      },
      errors: {
        layers: {
          load: "Jotkin tasot eivät ole saatavilla."
        },
        unsupported_format: 'Ei tuettu formaatti',
        add_external_layer: 'Tason latausvirhe'
      },
      metadata: {
        title: 'Metatiedot',
        groups: {
          general: {
            title: 'YLEINEN',
            fields: {
              title: 'OTSIKKO',
              name: 'NIMI',
              description: "KUVAUS",
              abstract: "TIIVISTELMÄ",
              keywords: 'AVAINSANAT',
              fees: "MAKSUT",
              accessconstraints: "PÄÄSYRAJOITUKSET",
              contactinformation: "YHTEYSTIEDOT",
              subfields: {
                contactinformation: {
                  contactelectronicmailaddress: "Sähköposti",
                  personprimary: 'Viitteet',
                  contactvoicetelephone: 'Puhelin',
                  contactorganization: 'Organisaatio',
                  ContactOrganization: 'Organisaatio',
                  contactposition: 'Asema',
                  ContactPosition: 'Asema',
                  contactperson: 'Yhteyshenkilö',
                  ContactPerson: 'Yhteyshenkilö'
                }
              },
              wms_url: "WMS"
            }
          },
          spatial: {
            title: 'SPATIAL',
            fields: {
              crs: 'EPSG',
              extent: 'BBOX'
            }
          },
          layers: {
            title: 'TASOT',
            fields: {
              layers: 'TASOT',
              subfields: {
                crs: 'EPSG',
                bbox: 'BBOX',
                title: "OTSIKKO",
                name: 'NIMI',
                geometrytype: 'GEOMETRIA',
                source: 'LÄHDE',
                attributes: 'ATTRIBUUTIT',
                abstract: 'TIIVISTELMÄ',
                attribution: 'ATTRIBUUTIO',
                keywords: "AVAINSANAT",
                metadataurl: 'METATIEDON URL',
                dataurl: "DATA URL"
              }
            },
            groups: {
              general: 'YLEINEN',
              spatial: 'SPATIAL'
            }
          }
        }
      },
      tooltips: {
        relations: {
          form_to_row: "Rivinäkymä",
          row_to_form: "Taulukkonäkymä",
          zoomtogeometry: "Zoomaa geometriaan"
        },
        copy_map_extent_url: 'Kopioi kartan katselulinkki',
        download_shapefile: "Lataa SHP-tiedosto",
        download_gpx: "Lataa GPX-tiedosto",
        download_gpkg: "Lataa GPKG-tiedosto",
        download_csv: "Lataa CSV-tiedosto",
        download_xls: "Lataa XLS-tiedosto",
        download_pdf: "Lataa PDF-tiedosto",
        show_chart: "Näytä kaavio",
        atlas: "Tulosta Atlas",
        editing: "Editing"
      },
      mapcontrols: {
        query: {
          tooltip: 'Kyselytaso',
          actions: {
            add_selection: {
              hint: 'Lisää/Poista valinta'
            },
            zoom_to_features_extent: {
              hint: "Tarkenna ominaisuuden laajuuteen"
            },
            add_features_to_results: {
              hint: "Add/Remove features to results"
            },
            remove_feature_from_results: {
              hint: "Remove feature from results"
            },
            zoom_to_feature: {
              hint: "Tarkenna ominaisuuteen"
            },
            relations: {
              hint: "Näytä relaatiot"
            },
            relations_charts: {
              hint: "Näytä relaatiokaavio"
            },
            download_features_shapefile: {
              hint: 'Lataa ominaisuuden SHP-tiedosto'
            },
            download_shapefile: {
              hint: 'Lataa ominaisuuden SHP-tiedosto'
            },
            download_features_gpx: {
              hint: "Lataa ominaisuuden GPX-tiedosto"
            },
            download_features_gpkg: {
              hint: "Lataa ominaisuuden GPKG-tiedosto"
            },
            download_gpx: {
              hint: "Lataa ominaisuuden GPX-tiedosto"
            },
            download_gpkg: {
              hint: "Lataa ominaisuuden GPKG-tiedosto"
            },
            download_features_csv: {
              hint: "Lataa ominaisuuden CSV-tiedosto"
            },
            download_csv: {
              hint: "Lataa ominaisuuden CSV-tiedosto"
            },
            download_features_xls: {
              hint: "Lataa ominaisuuden XLS-tiedosto"
            },
            download_xls: {
              hint: "Lataa ominaisuuden XLS-tiedosto"
            },
            download_pdf: {
              hint: "Lataa ominaisuuden PDF-tiedosto"
            },
            atlas: {
              hint: "Tulosta Atlas"
            },
            copy_zoom_to_fid_url: {
              hint: "Copy map URL with this geometry feature extension",
              hint_change: "Copied"
            }
          }
        },
        queryby: {
          title: 'Query area',
          layer: 'Selected layer:',
          none: 'NONE',
          new: 'TEMPORARY LAYER',
          all: 'ALL',
          methods: {
            intersects: 'intersects',
            within: 'within'
          },
          querybypolygon: {
            tooltip: 'select a polygon'
          },
          querybydrawpolygon: {
            tooltip: 'draw a polygon'
          },
          querybbox: {
            tooltip: 'draw a rectangle'
          },
          querybycircle: {
            tooltip: 'draw a circle'
          }
        },
        querybypolygon: {
          download: {
            title: "Attributes download",
            choiches: {
              feature: {
                label: "Features only"
              },
              feature_polygon: {
                label: "Features+Query Polygon"
              }
            }
          },
          tooltip: 'Kysely monikulmiolla',
          no_geometry: 'No geometry on response',
          help: {
            message: "<ul><li>Valitse monikulmiotaso luettelosta.</li><li>Tarkista, että taso on näkyvillä.</li><li>Valitse ominaisuus valitulla tasolla.</li></ul>"
          }
        },
        querybydrawpolygon: {
          tooltip: "Kysely piirtopolygonin mukaan"
        },
        querybbox: {
          tooltip: 'Tasoon kohdituva BBox-kysely',
          nolayers_visible: 'Ei kyseltäviä tasoja näkyvillä. Aseta vähintään yksi WFS-taso näkyväksi suorittaaksesi haun.',
          help: {
            message: "<ul><li>Piirrä suorakulmio kartalle suorittaaksesi kyselyn luettelossa alleviivatuille tasoille.</li></ul>"
          }
        },
        querybycircle: {
          tooltip: "Query by Draw Circle ",
          label: 'Radius',
          help: {
            message: "<ul><li>Click on map to draw circle</li></ul>"
          }
        },
        addlayer: {
          messages: {
            csv: {
              warning: "The result in the map is partial due to the presence of the below incorrect records list:"
            }
          },
          tooltip: 'Lisää taso'
        },
        geolocation: {
          tooltip: 'Maantieteellinen sijainti'
        },
        measures: {
          length: {
            tooltip: "Pituus",
            help: "Piirrä murtoviiva kartalle. Paina <br>CANC, mikäli haluat poistaa edellisen pisteen."
          },
          area: {
            tooltip: "Alue",
            help: "Piirrä monikulmio kartalle. Paina <br>CANC, mikäli haluat poistaa edellisen pisteen."
          }
        },
        scale: {
          no_valid_scale: "Väärä mittakaava"
        },
        scaleline: {
          units: {
            metric: 'Meters',
            nautical: 'Nautical Mile'
          }
        },
        zoomhistory: {
          zoom_last: "Zoom Edellinen",
          zoom_next: "Zoom Seurata"
        }
      },
      relations: {
        relation_data: 'Relaation tiedot',
        no_relations_found: 'Relaatiota ei löytynyt.',
        back_to_relations: 'Takaisin relaatioihin',
        list_of_relations_feature: 'Lista ominaisuuden relaatioista',
        error_missing_father_field: "Kenttä puuttu",
        field: "Relation key field"
      },
      form: {
        loading: 'Ladataan...',
        inputs: {
          messages: {
            errors: {
              picklayer: "Ominaisuuksia ei valiitu. Tarkista, että taso on muokattavissa tai näkyvissä nykyisellä mittakaavalla."
            }
          },
          tooltips: {
            picklayer: "Valitse arvo karttatasolta",
            lonlat: "Click on map to get coordinates"
          },
          input_validation_mutually_exclusive: "Kenttä toisensa poissulkeva.",
          input_validation_error: "Pakollinen kenttä tai väärä tietotyyppi.",
          input_validation_error_type: "Väärä tietotyyppi.",
          input_validation_min_field: "Arvon tulee olla suurempi tai yhtäsuuri kuin kentän arvo.",
          input_validation_max_field: "Arvon tulee olla pienempi tai yhtäsuuri kuin kentän arvo.",
          input_validation_exclude_values: "Arvon tulee olla uniikki.",
          integer: "kokonaisluku",
          bigint: "kokonaisluku",
          text: "teksti",
          varchar: "teksti",
          textarea: "teksti",
          string: "merkkijono",
          date: "päiväys",
          datetime: "päiväys",
          float: "liukuluku",
          table: "taulukko"
        },
        footer: {
          "required_fields": "Vaaditut kentät"
        },
        messages: {
          qgis_input_widget_relation: "Käytä relaatioiden määrittämiseen tähän tarkoitettua toimintoa"
        }
      },
      catalog: {
        current_map_theme_prefix: "THEME",
        choose_map_theme: "CHOOSE THEME",
        choose_map_theme_input_label: 'Uuden teeman nimi',
        project_map_theme: 'Projektin Themes',
        user_map_theme: 'Käyttäjä Themes',
        question_delete_map_theme: "Haluatko poistaa teeman?",
        delete_map_theme: "Teeman poistaminen onnistui",
        saved_map_theme: "Teeman tallennus onnistui",
        updated_map_theme: "Teeman päivittää onnistui",
        invalid_map_theme_name: "Nimi on jo olemassa tai se on virheellinen",
        menu: {
          layerposition: 'Kerroksen sijainti',
          setwmsopacity: "Aseta Opacity",
          wms: {
            title: "",
            copy: "Paina tästä kopioidaksesi url:n.",
            copied: "Kopioitu."
          },
          download: {
            unknow: "Lataa",
            shp: 'Lataa SHP-tiedosto',
            gpx: 'Lataa GPX-tiedosto',
            gpkg: 'Lataa GPKG-tiedosto',
            csv: 'Lataa CSV-tiedosto',
            xls: 'Lataa XLS-tiedosto',
            geotiff: 'Lataa GEOTIFF-tiedosto',
            geotiff_map_extent: "Lataa GEOTIFF-tiedosto(current view extent)"
          }
        }
      },
      wps: {
        list_process: "Lista prosesseista",
        tooltip: 'Valitse kartalta'
      }
    },
    credits: {
      g3wSuiteFramework: "Sovellus perustuu OS framework",
      g3wSuiteDescription: "Julkaise ja hallinnoi QGIS-projekteja verkossa.",
      productOf: "Frameworkin on kehittänyt"
    },
    toggle_color_scheme: "Toggle color scheme",
    logout: "Kirjaudu ulos",
    no_other_projects: "Ei projekteja tälle ryhmälle",
    no_other_groups: "Ei enää ryhmiä tälle makroryhmälle",
    yes: "Kyllä",
    no: "Ei",
    back: "Palaa",
    backto: "Takaisin ",
    changemap: "Vaihda karttaa",
    change_session: "Vaihda istuntoa",
    component: "Yleinen komponentti",
    search: "Hae",
    no_results: "Ei hakutuloksia",
    print: "Tulosta",
    create_print: "Luo tuloste",
    dosearch: "Hae",
    catalog: "Kartta",
    data: "Data",
    externalwms: "WMS",
    baselayers: "Taustakartta",
    tools: "Työkalut",
    tree: "Tasot",
    legend: "Merkintöjen selite",
    nobaselayer: "Ei taustakarttaa",
    street_search: "Hae osoite",
    show: "Näytä",
    hide: "Piilota",
    copy_form_data: "Kopioi tiedot",
    paste_form_data: "Liitä",
    copy_form_data_from_feature: "Kopioi tiedot kartalta",
    error_map_loading: "Virhe ladattessa karttaa",
    check_internet_connection_or_server_admin: "Tarkista internetyhteys tai ota yhteyttä ylläpitäjään.",
    could_not_load_vector_layers: "Yhteysvirhe, tasoja ei voida ladata.",
    server_saver_error: "Virhe tallentaessa palvelimelle.",
    server_error: "Yhteysvirhe palvelimeen",
    save: "Tallenna",
    cancel: "Peruuta",
    update: "Päivittää",
    close: "Sulje",
    /** @since 3.8.0 */
    dont_show_again: "Älä näytä viestiä uudelleen",
    enlange_reduce: "Suurenna / Pienennä",
    add: "Lisää",
    exitnosave: "Poistu tallentamatta",
    annul: "Peruuta",
    layer_is_added: "Samanniminen taso on jo lisätty.",
    sidebar: {
      wms: {
        panel: {
          title: 'Add WMS Layer',
          label: {
            position: "Map Position",
            name: "Name",
            projections: 'Projection',
            layers: 'Layers'
          }
        },
        add_wms_layer: "Aggiungi WMS layer",
        delete_wms_url: "Delete WMS url",
        layer_id_already_added: "WMS Taso on jo lisätty.",
        url_already_added: "WMS URL/Nimi on jo lisätty.",
        layer_add_error: "WMS Layer not added. Please check all wms parameter or url"
      }
    },
    info: {
      title: "Tulokset",
      list_of_relations: "List of Relations",
      open_link: "Avaa liitetiedosto",
      server_error: "Palvelimella tapahtui virhe.",
      no_results: "Ei tuloksia haulle/kyselylle.",
      link_button: "Avaa"
    },
    mapcontrols: {
      geolocation: {
        error: "Sijaintiasi ei saada"
      },
      geocoding: {
        choose_layer: "Valitse kerros, johon tämä ominaisuus lisätään",
        placeholder: "Osoite ...",
        nolayers: "Tästä projektista ei löytynyt muokattavia pistetasoja",
        noresults: "Ei tuloksia",
        notresponseserver: "Ei vastausta palvelimelta"
      },
      add_layer_control: {
        header: "Lisää taso",
        select_projection: "Valitse tason projektio",
        select_field_to_show: "Select Field to show on map",
        select_csv_separator: "Select delimiter",
        select_csv_x_field: "Select X field",
        select_csv_y_field: "Select Y field",
        select_color: "Valitse tason väri",
        drag_layer: "Vedä ja pudota taso tähän"
      },
      query: {
        input_relation: "Paina näyttääksesi relaatiot"
      },
      length: {
        tooltip: "Pituus"
      },
      area: {
        tooltip: "Pinta-ala"
      },
      screenshot: {
        error: "Screenshot error creation",
        securityError: "  \n        <p><b>Turvallisuusvirhe</b>: ulkoinen kerros est\xE4\xE4 karttaa tulostamasta. Tarkistaaksesi, toimi seuraavasti:</p>\n        <ol>\n          <li>poista manuaalisesti lis\xE4tyt ulkoiset tasot (esim. WMS-tasot)</li>\n          <li>Pakota sivun uudelleenlataus: <code>CTRL + F5</code></li>\n          <li>tulosta kartta uudelleen</li>\n        </ol>\n        <p>Saat lis\xE4tietoja palvelimen j\xE4rjestelm\xE4nvalvojalta seuraavista aiheista: <a href=\"https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_enabled_image\" style=\"color: #000 !important;font -paino: lihavoitu;\">&#x2139;&#xFE0F; turvallisuus ja likaiset kankaat</a></p>\n        "
      }
    },
    catalog_items: {
      helptext: "Napsauta hiiren kakkospainikkeella yksittäistä tasoa päästäksesi lisäominaisuuksiin.",
      contextmenu: {
        zoomtolayer: "Tarkenna tasoon",
        open_attribute_table: "Avaa attribuuttitaulu",
        show_metadata: "Metatiedot",
        styles: "Tyylejä",
        vector_color_menu: "Aseta/muuta väriä",
        layer_opacity: "Peittävyys",
        filters: "Filters"
      }
    },
    dataTable: {
      previous: "Edellinen",
      next: "Seuraava",
      lengthMenu: "Näytä _MENU_ arvoa sivulla",
      info: "tulosta _TOTA_:stä",
      no_data: "Ei tietoja",
      nodatafilterd: "Vastaavia tietueita ei löytynyt",
      infoFiltered: "(filtered from _MAX_ total records)"
    }
  }
};

},{}],170:[function(require,module,exports){
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  translation: {
    error_page: {
      error: "Erreur de connexion",
      at_moment: "Pour le moment, il n'est pas possible d'afficher la carte",
      f5: "Appuyez sur Ctrl+F5"
    },
    cookie_law: {
      message: "Ce site utilise des cookies pour assurer une bonne convivialité pour l'utilisateur final.",
      buttonText: "J’ai compris !"
    },
    default: "par défaut ",
    sign_in: "Se connecter ",
    layer_selection_filter: {
      tools: {
        filter: "Activer/Désactiver le filtre",
        nofilter: "Supprimer le filtre ",
        invert: "Sélection inversée ",
        clear: "Effacer la sélection ",
        show_features_on_map: "Mettre à jour les résultats lors du déplacement de la carte",
        savefilter: "Sauver le Filtre",
        filterName: "Nom du Filtre"
      }
    },
    warning: {
      not_supported_format: "Format non supporté"
    },
    layer_position: {
      top: 'HAUT',
      bottom: 'BAS',
      message: "Position relative des couches dans la table des matières"
    },
    sdk: {
      atlas: {
        template_dialog: {
          title: "Sélectionnez un modèle"
        }
      },
      spatialbookmarks: {
        title: "Signets spatiaux",
        helptext: "Déplacez-vous sur l'étendue de la carte, insérez le nom et cliquez sur Ajouter",
        input: {
          name: "Nom"
        },
        sections: {
          project: {
            title: "Signets du projet"
          },
          user: {
            title: "Signets de l'utilisateur"
          }
        }
      },
      search: {
        all: 'TOUTES',
        no_results: "Aucune valeur trouvée",
        searching: "Je cherche...",
        error_loading: "Erreur de chargement des valeurs",
        layer_not_searchable: "La couche n’est pas recherchable",
        layer_not_querable: "La couche n'est pas interrogeable",
        autocomplete: {
          inputshort: {
            pre: "Tapez au moins",
            post: "caractères"
          }
        },
        help_filter: "Les valeurs de recherche sont limitées en fonction du filtre actif. Supprimez le filtre pour rechercher toutes les données.",
        autofilter: "Filtrer les résultats"
      },
      print: {
        no_layers: 'Aucune layer visible',
        scale: "Échelle",
        format: "Format",
        rotation: "Rotation",
        download_image: "Télécharger l'image",
        fids_instruction: "Valeurs acceptées : de 1 à la valeur maximale indiquée par [max]. Il est également possible d'indiquer une fourchette de valeurs, par exemple 4-6",
        fids_example: "Par exemple 1,4-6 les ids 1,4,5,6 seront imprimés",
        help: "Les couches montrées dans l'impression peuvent être celles définies dans le projet et non celles montrées sur la carte"
      },
      querybuilder: {
        search: {
          run: "Lancer la recherche",
          info: "Information",
          delete: "Supprimer",
          edit: "Modifier"
        },
        messages: {
          changed: 'Enregistré correctement',
          number_of_features: "Nombre d'entités"
        },
        panel: {
          button: {
            all: 'TOUTES',
            save: 'SAUVEGARDER',
            test: 'TESTER',
            clear: 'NETTOYER',
            run: 'EXECUTER',
            manual: 'MANUEL'
          },
          layers: 'COUCHES',
          fields: 'CHAMPS',
          values: 'VALEURS',
          operators: 'OPERATEURS',
          expression: 'EXPRESSION'
        },
        error_run: "Une erreur s'est produite. Vérifiez si la requête est correcte",
        error_test: "Erreur d'exécution de la requête",
        delete: 'Voulez-vous confirmer la suppression ?',
        additem: 'Entrer le nom de la requête'
      },
      errors: {
        layers: {
          load: "Certaines couches du projet ne sont pas disponibles actuellement et n'apparaissent donc pas dans la vue actuelle"
        },
        unsupported_format: 'Format non supporté',
        add_external_layer: 'Erreur lors du chargement de la couche'
      },
      metadata: {
        title: "Métadonnées",
        groups: {
          general: {
            title: 'GÉNÉRAL',
            fields: {
              title: 'TITRE',
              name: 'NOM',
              description: "DESCRIPTION",
              abstract: "ABREGE",
              keywords: 'LISTE DE MOTS-CLÉS',
              fees: "DROITS D'INSCRIPTION",
              accessconstraints: "CONTRAINTES D'ACCÈS",
              contactinformation: "CONTACTS",
              subfields: {
                contactinformation: {
                  contactelectronicmailaddress: "E-mail",
                  personprimary: 'Références',
                  contactvoicetelephone: 'Téléphone',
                  contactorganization: 'Organisation',
                  ContactOrganization: 'Organisation',
                  contactposition: 'Localisation',
                  ContactPosition: 'Localisation',
                  contactperson: 'Personne',
                  ContactPerson: 'Personne'
                }
              },
              wms_url: "WMS"
            }
          },
          spatial: {
            title: 'INFO SPATIALE',
            fields: {
              crs: 'EPSG',
              extent: 'BBOX'
            }
          },
          layers: {
            title: 'COUCHES',
            groups: {
              general: 'GENERALE',
              spatial: 'INFO SPATIALE'
            },
            fields: {
              layers: 'COUCHES',
              subfields: {
                crs: 'EPSG',
                bbox: 'BBOX',
                title: "TITRE",
                name: 'NOM',
                geometrytype: 'GÉOMÉTRIE',
                source: 'SOURCE',
                attributes: 'ATTRIBUTS',
                abstract: 'ABRÉGÉ',
                attribution: 'ATTRIBUTION',
                keywords: "MOTS- CLÉS",
                metadataurl: 'URL DE MÉTADONNÉES',
                dataurl: "URL DES DONNÉES"
              }
            }
          }
        }
      },
      tooltips: {
        relations: {
          form_to_row: "Afficher le format de la ligne",
          row_to_form: "Format du formulaire d'affichage",
          zoomtogeometry: "Zoom sur la géométrie"
        },
        zoom_to_features_extent: "Zoom sur les entités",
        copy_map_extent_url: 'Copier le lien de visualisation de la carte',
        download_shapefile: "Télécharger le fichier Shapefile",
        download_gpx: "Télécharger GPX",
        download_gpkg: "Télécharger GPKG",
        download_csv: "Télécharger CSV",
        download_xls: "Télécharger XLS",
        download_pdf: "Télécharger PDF",
        show_chart: "Montrer le graphique",
        atlas: "Imprimer l'Atlas",
        editing: "Modifier"
      },
      mapcontrols: {
        query: {
          tooltip: 'Couche Interrogée',
          actions: {
            add_selection: {
              hint: "Ajouter/supprimer une sélection"
            },
            zoom_to_features_extent: {
              hint: "Zoom sur les entités"
            },
            add_features_to_results: {
              hint: "Ajouter des fonctionnalités aux résultats"
            },
            remove_feature_from_results: {
              hint: "Supprimer l'entité des résultats"
            },
            zoom_to_feature: {
              hint: "Zoom sur les entités"
            },
            relations: {
              hint: "Voir les relations"
            },
            relations_charts: {
              hint: "Voir les graphiques de relations"
            },
            download_features_shapefile: {
              hint: 'Télécharger les entités vers Shapefile'
            },
            download_shapefile: {
              hint: 'Télécharger le Shapefile'
            },
            download_features_gpx: {
              hint: "Télécharger les entités vers GPX"
            },
            download_features_gpkg: {
              hint: "Télécharger les entités vers GPKG"
            },
            download_gpx: {
              hint: "Télécharger le GPX"
            },
            download_gpkg: {
              hint: "Télécharger le GPKG"
            },
            download_features_csv: {
              hint: "Télécharger les entités vers CSV"
            },
            download_csv: {
              hint: "Télécharger le CSV"
            },
            download_features_xls: {
              hint: "Télécharger les entités vers XLS"
            },
            download_xls: {
              hint: "Télécharger le XLS"
            },
            download_pdf: {
              hint: "Télécharger le PDF"
            },
            atlas: {
              hint: "Imprimer l'Atlas"
            },
            copy_zoom_to_fid_url: {
              hint: "Copier l'URL de la carte avec l'extension vers cette géométrie",
              hint_change: "Copié"
            }
          }
        },
        queryby: {
          title: 'Query area',
          layer: 'Selected layer:',
          none: 'NONE',
          new: 'TEMPORARY LAYER',
          all: 'ALL',
          methods: {
            intersects: 'intersects',
            within: 'within'
          },
          querybypolygon: {
            tooltip: 'select a polygon'
          },
          querybydrawpolygon: {
            tooltip: 'draw a polygon'
          },
          querybbox: {
            tooltip: 'draw a rectangle'
          },
          querybycircle: {
            tooltip: 'draw a circle'
          }
        },
        querybypolygon: {
          download: {
            title: "Téléchargement des attributs",
            choiches: {
              feature: {
                label: "Entités seulement"
              },
              feature_polygon: {
                label: "Entités+Requête Polygon "
              }
            }
          },
          tooltip: 'Requête par polygone',
          no_geometry: 'La réponse ne contient pas de géométrie',
          help: {
            message: "<ul><li>Sélectionnez une couche de polygone dans la légende.</li><li>Vérifiez que la couche est visible dans la carte.</li><li>Cliquez sur une géométrie de la couche sélectionnée.</li></ul>"
          }
        },
        querybydrawpolygon: {
          tooltip: "Requête par polygone de dessin"
        },
        querybbox: {
          tooltip: 'Requête pour BBOX',
          nolayers_visible: "Aucune couche requêtable n'est visible. Assurez-vous qu'au moins une couche wfs est visible pour exécuter la requête",
          help: {
            message: "<ul><li>Dessinez un rectangle pour interroger les couches surlignées en jaune</li></ul>"
          }
        },
        querybycircle: {
          tooltip: "Query by Draw Circle ",
          label: 'Radius',
          help: {
            message: "<ul><li>Click on map to draw circle</li></ul>"
          }
        },
        addlayer: {
          messages: {
            csv: {
              warning: "Le résultat de la carte est partiel en raison de la présence des enregistrements incorrects suivants :"
            }
          },
          tooltip: 'Ajouter un layer'
        },
        geolocation: {
          tooltip: 'Géolocalisation'
        },
        measures: {
          length: {
            tooltip: "Longueur",
            help: "Cliquez sur la carte pour continuer à dessiner la ligne.<br>CANC si vous voulez supprimer le dernier vertex inséré"
          },
          area: {
            tooltip: "Zone",
            help: "Cliquez pour continuer à dessiner le polygone.<br>CANC si vous voulez supprimer le dernier vertex inséré"
          }
        },
        scale: {
          no_valid_scale: "Échelle invalide"
        },
        scaleline: {
          units: {
            metric: 'Mètre',
            nautical: 'Mile Nautique'
          }
        },
        zoomhistory: {
          zoom_last: "Zoom Précédent",
          zoom_next: "Zoom Suivant"
        }
      },
      relations: {
        relation_data: 'Données relationnelles',
        no_relations_found: 'Aucune relation trouvée',
        back_to_relations: 'Retour aux relations',
        list_of_relations_feature: 'Liste des relations entre les entités',
        error_missing_father_field: "Le champ concerné n'existe pas",
        field: "Relation key field"
      },
      form: {
        loading: 'Chargement...',
        inputs: {
          messages: {
            errors: {
              picklayer: "Aucune entité sélectionnée. Vérifier si la couche est en édition ou non visible à l'échelle actuelle"
            }
          },
          tooltips: {
            picklayer: "Obtenir la valeur de la carte",
            lonlat: "Cliquez sur la carte pour obtenir les coordonnées"
          },
          input_validation_mutually_exclusive: "Champ mutuellement exclusif avec ",
          input_validation_error: "Champ obligatoire ou type de valeur incorrect",
          input_validation_error_type: "Type de valeur incorrect",
          input_validation_min_field: "La valeur doit être supérieure ou égale au camp ",
          input_validation_max_field: "La valeur doit être inférieure ou égale au champ ",
          input_validation_exclude_values: "Le champ doit contenir une valeur différente",
          integer: "entier",
          bigint: "entier",
          text: "textuel",
          varchar: "textuel",
          textarea: "textuel",
          string: "chaîne",
          date: "date",
          datetime: "date",
          float: "décimal",
          table: "table"
        },
        footer: {
          required_fields: "Champs obligatoires"
        },
        messages: {
          qgis_input_widget_relation: "Gérer les relations via un formulaire dédié"
        }
      },
      catalog: {
        current_map_theme_prefix: "THEME",
        choose_map_theme: "SÉLECTIONNEZ LE THÈME",
        choose_map_theme_input_label: 'Nom du nouveau thème',
        project_map_theme: 'Thème du projet',
        user_map_theme: "Thème de l'utilisateur",
        question_delete_map_theme: "Voulez-vous supprimer le thème ?",
        delete_map_theme: "Thème supprimé avec succès",
        saved_map_theme: "Thème enregistré avec succès",
        updated_map_theme: "Thème mise à jour avec succès",
        invalid_map_theme_name: "Le nom existe déjà ou est incorrect",
        menu: {
          layerposition: 'Position du calque',
          setwmsopacity: "Définir l'opacité",
          wms: {
            title: "",
            copy: "Cliquez ici pour copier l'url",
            copied: "Copié"
          },
          download: {
            unknow: 'Télécharger',
            shp: 'Télécharger Shapefile',
            gpx: 'Télécharger GPX',
            gpkg: 'Télécharger GPKG',
            csv: 'Télécharger CSV',
            xls: 'Télécharger XLS',
            geotiff: 'Télécharger GEOTIFF',
            geotiff_map_extent: "Télécharger GEOTIFF(vue courante)"
          }
        }
      },
      wps: {
        list_process: "Liste des processus",
        tooltip: 'Cliquez sur la carte'
      }
    },
    credits: {
      g3wSuiteFramework: "Application construite avec le framework OS",
      g3wSuiteDescription: "Publiez et gérez vos projets QGIS sur le Web",
      productOf: "Framework développé par"
    },
    logout: "Quitter",
    no_other_projects: "Il n'y a pas d'autres projets dans ce groupe de cartes",
    no_other_groups: "Il n'y a pas d'autres groupes dans ce macrogroupe",
    yes: "Oui",
    no: "No",
    back: "Retour",
    backto: "Retour à ",
    changemap: "Changer de carte",
    change_session: "Changer de sessuib",
    component: "Composant générique",
    search: "Recherches",
    no_results: "Aucun résultat trouvé",
    print: "Imprimer",
    create_print: "Créer une impression",
    dosearch: "Recherche",
    catalog: "Carte",
    data: "Données",
    externalwms: "WMS",
    baselayers: "Bases",
    tools: "Outils",
    tree: "Strates",
    legend: "Légende",
    nobaselayer: "Pas de carte de base",
    street_search: "Adresse de recherche",
    show: "Afficher",
    hide: "Cacher",
    copy_form_data: "Copier les données du formulaire",
    paste_form_data: "Coller",
    copy_form_data_from_feature: "Copier les données de la carte",
    error_map_loading: "Erreur de chargement de la nouvelle carte",
    check_internet_connection_or_server_admin: "Vérifiez la connexion internet ou contactez l'administrateur",
    could_not_load_vector_layers: "Erreur de connexion au serveur : il n'a pas été possible de charger les vecteurs demandés",
    server_saver_error: "Erreur de sauvegarde sur le serveur",
    server_error: "Une erreur s'est produite dans la requête au serveur",
    save: "Sauvegarder",
    cancel: "Supprimer",
    update: "Mise à jour",
    close: "Fermer",
    /** @since 3.8.0 */
    dont_show_again: "Ne plus afficher ce message",
    enlange_reduce: "Agrandir / Réduire",
    add: "Ajouter",
    exitnosave: "Quitter sans sauvegarder",
    annul: "Annuler",
    layer_is_added: "Couche avec le même nom déjà ajoutée",
    wms_layer_id_already_added: "Couche WMS déjà ajoutée",
    wms_url_already_added: "URL WMS déjà ajouté",
    sidebar: {
      wms: {
        panel: {
          title: 'Ajouter une couche WMS',
          label: {
            position: "Position sur la carte",
            name: "Nom",
            projections: 'Projection',
            layers: 'Couches'
          }
        },
        add_wms_layer: "Ajouter une couche WMS",
        delete_wms_url: "Supprimer une url WMS",
        layer_id_already_added: "La couche est déjà présente.",
        url_already_added: "L'URL WMS est déjà présent.",
        layer_add_error: "Couche WMS non ajoutée. Veuillez vérifier tous les paramètres de l'URL"
      }
    },
    info: {
      title: "Résultats",
      list_of_relations: "Liste des relations",
      open_link: "Ouvrir le document joint",
      server_error: "Une erreur s'est produite dans la requête au serveur",
      no_results: "Aucun résultat pour cette requête/recherche",
      link_button: "Ouvrir"
    },
    mapcontrols: {
      geolocation: {
        error: "Votre position ne peut être calculée."
      },
      geocoding: {
        choose_layer: "Choisissez un calque où ajouter cette entité",
        placeholder: "Adresse ...",
        nolayers: "Aucune couche de points modifiable trouvée sur ce projet",
        noresults: "Aucun résultat",
        notresponseserver: "Le serveur ne répond pas"
      },
      add_layer_control: {
        header: "Ajouter une couche",
        select_projection: "Sélectionnez le système de projection de couches",
        select_field_to_show: "Sélectionnez le champ à afficher sur la carte",
        select_csv_separator: "Sélectionner le séparateur",
        select_csv_x_field: "Sélectionnez le champ X",
        select_csv_y_field: "Sélectionnez le champ Y",
        select_color: "Sélectionnez la couleur du layer",
        drag_layer: "Faire glisser le layer vers cette zone"
      },
      query: {
        input_relation: "Cliquez pour voir les relations"
      },
      length: {
        tooltip: "Longueur"
      },
      area: {
        tooltip: "Zone"
      },
      screenshot: {
        error: "Erreur de création de la capture d'écran",
        securityError: "  \n        <p><b>Erreur de s\xE9curit\xE9</b> : une couche externe emp\xEAche l'impression de la carte. Pour v\xE9rifier, proc\xE9dez comme suit :</p>\n        <ol>\n          <li>supprimer toutes les couches externes ajout\xE9es manuellement (par exemple, les couches WMS)</li>\n          <li>forcer le rechargement de la page : <code>CTRL + F5</code></li>\n          <li>imprimer \xE0 nouveau la carte</li>\n        </ol>\n        <p>Pour plus d'informations, veuillez contacter l'administrateur du serveur \xE0 propos de : <a href=\"https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_enabled_image\" style=\"color: #000 !important;font -poids : gras ;\">&#x2139;&#xFE0F; s\xE9curit\xE9 et toiles souill\xE9es</a></p>\n        "
      }
    },
    catalog_items: {
      helptext: "Cliquez avec le bouton droit de la souris sur les différentes couches pour accéder à des fonctionnalités supplémentaires",
      contextmenu: {
        zoomtolayer: "Zoom sur le layer",
        open_attribute_table: "Ouvrir la table attributaire",
        show_metadata: "Métadonnées",
        styles: "Styles",
        vector_color_menu: "Définir/changer la couleur",
        layer_opacity: "Opacité",
        filters: "Filters"
      }
    },
    dataTable: {
      previous: "Précédent",
      next: "Suivant",
      lengthMenu: "Afficher _MENU_ valeurs par page",
      info: "_TOTAL_ résultats",
      nodatafilterd: "Aucun résultat trouvé",
      infoFiltered: "(Filtré par _MAX_ rangs totaux)"
    }
  }
};

},{}],171:[function(require,module,exports){
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _it = require('./it');

var _it2 = _interopRequireDefault(_it);

var _en = require('./en');

var _en2 = _interopRequireDefault(_en);

var _fi = require('./fi');

var _fi2 = _interopRequireDefault(_fi);

var _se = require('./se');

var _se2 = _interopRequireDefault(_se);

var _fr = require('./fr');

var _fr2 = _interopRequireDefault(_fr);

var _de = require('./de');

var _de2 = _interopRequireDefault(_de);

var _ro = require('./ro');

var _ro2 = _interopRequireDefault(_ro);

var _pl = require('./pl');

var _pl2 = _interopRequireDefault(_pl);

var _pt = require('./pt');

var _pt2 = _interopRequireDefault(_pt);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var translations = {
  it: _it2.default,
  en: _en2.default,
  fi: _fi2.default,
  se: _se2.default,
  fr: _fr2.default,
  de: _de2.default,
  ro: _ro2.default,
  pl: _pl2.default,
  pt: _pt2.default
};

exports.default = translations;

},{"./de":167,"./en":168,"./fi":169,"./fr":170,"./it":172,"./pl":173,"./pt":174,"./ro":175,"./se":176}],172:[function(require,module,exports){
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  translation: {
    error_page: {
      error: "Errore di connessione",
      at_moment: "Al momento non è possibile caricare la mappa",
      f5: "Premi Ctrl+F5"
    },
    cookie_law: {
      message: "Questo sito utilizza i cookie per garantire una buona usabilità all'utilizzatore finale.",
      buttonText: "Ho capito!"
    },
    default: "predefinito",
    sign_in: "Accedi",
    layer_selection_filter: {
      tools: {
        filter: "Attiva/Disattiva Filtro",
        nofilter: "Rimuovi filtro",
        invert: "Inverti Selezione",
        clear: "Annulla selezione",
        show_features_on_map: "Aggiorna i risultati quando si sposta la mappa",
        savefilter: "Salva Filtro",
        filterName: 'Nome Filtro'
      }
    },
    warning: {
      not_supported_format: "Formato non supportato"
    },
    layer_position: {
      top: 'in cima',
      bottom: 'in fondo',
      message: "Posizione"
    },
    sdk: {
      atlas: {
        template_dialog: {
          title: "Seleziona Template"
        }
      },
      spatialbookmarks: {
        title: "Segnalibri",
        helptext: "Posizionati all'estensione del tuo nuovo segnalibro, definisci il nome e clicca Aggiungi",
        input: {
          name: "Nome"
        },
        sections: {
          project: {
            title: "Segnalibri Progetto"
          },
          user: {
            title: "Segnalibri Utente"
          }
        }
      },
      search: {
        all: 'TUTTE',
        no_results: "Nessun valore trovato",
        searching: "Sto cercando ..",
        error_loading: "Errore nel caricamento valori",
        layer_not_searchable: "Il layer non è ricercabile",
        layer_not_querable: "Il layer non è interrogabile",
        autocomplete: {
          inputshort: {
            pre: "Digita almeno",
            post: "caratteri"
          }
        },
        help_filter: "I valori di ricerca sono limitati sulla base del filtro attivo. Rimuovere il filtro per ricercare su tutti i dati.",
        autofilter: "Filtro sui risultati"
      },
      print: {
        no_layers: 'Nessun Layer visibile',
        template: "Template",
        labels: "Etichette",
        scale: "Scala",
        format: "Formato",
        rotation: "Rotazione",
        download_image: "Scarica Immagine",
        fids_instruction: "Valori accettati: da 1 al valore massimo indicato da [max]. Possibile indicare anche range di valori es. 4-6",
        fids_example: "Es. 1,4-6 verranno stampati gli id 1,4,5,6",
        help: "I livelli esportabili sono definiti dall'amministratore",
        help_details: "<p>Se non vedi qualche livello nel file di stampa:</p>\n          <ol style=\"padding-left: 25px\">\n            <li>prova ancora usando un template diverso</li>\n            <li>prova a cambiare lo zoom della mappa</li>\n            <li>controlla l'origine (es. server WMS esterno)</li>\n            <li>verifica che la sua voce sia effettivamente spuntata nella lista dei livelli</li>\n          </ol>"
      },
      querybuilder: {
        title: 'Ricerca avanzata',
        search: {
          run: "Esegui",
          info: "Informazioni",
          delete: "Rimuovi",
          edit: "Modifica"
        },
        messages: {
          changed: 'Salvato correttamente',
          number_of_features: "Elementi trovati:"
        },
        panel: {
          button: {
            all: 'TROVA UN VALORE',
            save: 'SALVA',
            test: 'VERIFICA',
            clear: 'PULISCI',
            run: 'ESEGUI',
            manual: 'MANUALE'
          },
          layers: 'LAYERS',
          fields: 'CAMPI',
          values: 'VALORI',
          operators: 'OPERATORI',
          expression: 'ESPRESSIONE'
        },
        error_run: 'Si è verificato un errore. Verificare se la query è corretta',
        error_test: "Errore nell'esecuzione della query",
        delete: 'Vuoi confermare la cancellazione?',
        additem: 'Inserisci nome della ricerca'
      },
      errors: {
        layers: {
          load: "Alcuni livelli presenti nel progetto non sono attualmente disponibili e quindi non compaiono nell'attuale visualizzazione"
        },
        unsupported_format: 'Formato non supportato',
        add_external_layer: 'Errore nel caricamento del layer'
      },
      metadata: {
        title: "Metadati",
        groups: {
          general: {
            title: 'GENERALE',
            fields: {
              title: 'TITOLO',
              name: 'NOME',
              description: "DESCRIZIONE",
              abstract: "ABSTRACT",
              keywords: 'LISTA DELLE PAROLE CHIAVE',
              fees: "CANONI",
              accessconstraints: "VINCOLI DI ACCESSO",
              contactinformation: "CONTATTI",
              subfields: {
                contactinformation: {
                  contactelectronicmailaddress: "E-mail",
                  personprimary: 'Riferimenti',
                  contactvoicetelephone: 'Telefono',
                  contactorganization: 'Organizzazione',
                  ContactOrganization: 'Organizzazione',
                  contactposition: 'Posizione',
                  ContactPosition: 'Posizione',
                  contactperson: 'Persona',
                  ContactPerson: 'Persona'
                }
              },
              wms_url: "WMS"
            }
          },
          spatial: {
            title: 'INFO SPAZIALI',
            fields: {
              crs: 'EPSG',
              extent: 'BBOX'
            }
          },
          layers: {
            title: 'STRATI',
            groups: {
              general: 'GENERALE',
              spatial: 'INFO SPAZIALI'
            },
            fields: {
              layers: 'STRATI',
              subfields: {
                crs: 'EPSG',
                bbox: 'BBOX',
                title: "TITOLO",
                name: 'NOME',
                geometrytype: 'GEOMETRIA',
                source: 'SORGENTE',
                attributes: 'ATTRIBUTI',
                abstract: 'ABSTRACT',
                attribution: 'ATTRIBUTION',
                keywords: "PAROLE CHIAVE",
                metadataurl: 'METADATA URL',
                dataurl: "DATA URL"
              }
            }
          }
        }
      },
      tooltips: {
        relations: {
          form_to_row: "Visualizza riga",
          row_to_form: "Visualizza modulo",
          zoomtogeometry: "Zoom sulla geometria"
        },
        zoom_to_features_extent: "Zoom sulle features",
        copy_map_extent_url: 'Copia URL di condivisione',
        download_shapefile: "Scarica Shapefile",
        download_gpx: "Scarica GPX",
        download_gpkg: "Scarica GPKG",
        download_csv: "Scarica CSV",
        download_xls: "Scarica XLS",
        download_pdf: "Scarica PDF",
        show_chart: "Mostra Grafico",
        atlas: "Stampa Atlas",
        editing: "Modifica"
      },
      mapcontrols: {
        query: {
          tooltip: 'Interroga Layer',
          actions: {
            add_selection: {
              hint: "Aggiungi/Rimuovi Selezione"
            },
            zoom_to_features_extent: {
              hint: "Zoom sulle geometrie"
            },
            add_features_to_results: {
              hint: "Aggiungi elementi ai risultati"
            },
            remove_feature_from_results: {
              hint: "Rimuovi elemento dai risultati"
            },
            zoom_to_feature: {
              hint: "Zoom sulla geometria"
            },
            relations: {
              hint: "Visualizza Relazioni"
            },
            relations_charts: {
              hint: "Visualizza grafici relazioni"
            },
            download_features_shapefile: {
              hint: 'Scarica come Shapefile'
            },
            download_shapefile: {
              hint: 'Scarica come Shapefile'
            },
            download_features_gpx: {
              hint: "Scarica come GPX"
            },
            download_features_gpkg: {
              hint: "Scarica come GPKG"
            },
            download_gpx: {
              hint: "Scarica come GPX"
            },
            download_gpkg: {
              hint: "Scarica come GPKG"
            },
            download_features_csv: {
              hint: "Scarica come CSV"
            },
            download_csv: {
              hint: "Scarica come CSV"
            },
            download_features_xls: {
              hint: "Scarica come XLS"
            },
            download_xls: {
              hint: "Scarica come XLS"
            },
            download_pdf: {
              hint: "Scarica come PDF"
            },
            atlas: {
              hint: "Stampa Atlas"
            },
            copy_zoom_to_fid_url: {
              hint: "Condividi tramite link",
              hint_change: "URL copiato negli appunti"
            }
          }
        },
        queryby: {
          title: 'Interroga un area',
          layer: 'Livello selezionato:',
          none: 'NESSUNO',
          new: 'LIVELLO TEMPORANEO',
          all: 'TUTTI',
          methods: {
            intersects: 'interseca',
            within: 'all\'interno'
          },
          querybypolygon: {
            tooltip: 'seleziona un poligono'
          },
          querybydrawpolygon: {
            tooltip: 'disegna un poligono'
          },
          querybbox: {
            tooltip: 'disegna un rettangolo'
          },
          querybycircle: {
            tooltip: 'disegna un cerchio'
          }
        },
        querybypolygon: {
          download: {
            title: "Download attributi",
            choiches: {
              feature: {
                label: "Solo features"
              },
              feature_polygon: {
                label: "Features+Poligono Interrogazione"
              }
            }
          },
          tooltip: 'Interroga per poligono',
          no_geometry: 'Non contiene la geometria nella risposta',
          help: {
            message: "<ul><li>Seleziona un livello (visibile).</li><li>Clicca su una geometria nella mappa.</li></ul>"
          }
        },
        querybydrawpolygon: {
          tooltip: "Disegna un poligono per interrogare",
          help: {
            message: "<ul><li>Clicca sulla mappa per aggiungere un nuovo vertice</li><li>Doppio click per terminare ed interrogare i livelli (sottolineati in giallo nella legenda)</li></ul>"
          }
        },
        querybbox: {
          tooltip: 'Interroga per BBOX',
          nolayers_visible: "Nessun layer interrogabile è visibile. Assicurarsi che almeno un layer wfs sia visibile per eseguire l'interrogazione",
          help: {
            message: "<ul><li>Trascina il mouse per disegnare un rettangolo ed interrogare i livelli (sottolineati in giallo nella legenda)</li></ul>"
          }
        },
        querybycircle: {
          tooltip: "Disegna un cerchio per interrogare",
          label: 'Raggio',
          help: {
            message: "<ul><li>Clicca sulla mappa per disegnare il cerchio</li></ul>"
          }
        },
        addlayer: {
          messages: {
            csv: {
              warning: "Il risultato in mappa è parziale a causa della presenza dei seguenti records non corretti:"
            }
          },
          tooltip: 'Aggiungi livello'
        },
        geolocation: {
          tooltip: 'Mostra la mia posizione'
        },
        measures: {
          title: 'Misura',
          length: {
            tooltip: "Lunghezza",
            help: "Clicca sulla mappa per continuare a disegnare la linea.<br>CANC se si vuole cancellare l'ultimo vertice inserito"
          },
          area: {
            tooltip: "Area",
            help: "Clicca per continuare a disegnare il poligono.<br>CANC se si vuole cancellare l'ultimo vertice inserito"
          }
        },
        screenshot: {
          title: 'Cattura schermata',
          screenshot: "PNG",
          geoscreenshot: "GeoTIFF",
          download: 'Genera'
        },
        scale: {
          no_valid_scale: "Scala non valida"
        },
        scaleline: {
          units: {
            metric: 'Metri',
            nautical: 'Miglio Nautico'
          }
        },
        zoomhistory: {
          zoom_last: "Zoom Precedente",
          zoom_next: "Zoom Successivo"
        }
      },
      relations: {
        relation_data: 'Dati Relazione',
        no_relations_found: 'Nessuna relazione trovata',
        back_to_relations: 'Ritorna alle relazioni',
        list_of_relations_feature: 'Lista delle relazioni della feature',
        error_missing_father_field: "Il campo relazionato non esiste",
        field: "Campo chiave relazione"
      },
      form: {
        loading: 'Caricamento ...',
        inputs: {
          messages: {
            errors: {
              picklayer: "Nessuna feature selezionata. Verificare se il layer è in editing o non visibile alla scala attuale"
            }
          },
          tooltips: {
            picklayer: "Prendi valore dalla mappa",
            lonlat: "Clicca sulla mappa per prendere le coordinate"
          },
          input_validation_mutually_exclusive: "Campo mutualmente esclusivo con ",
          input_validation_error: "Campo obbligatorio o tipo valore non corretto",
          input_validation_error_type: "Tipo valore non corretto",
          input_validation_min_field: "Valore deve essere magiore uguale a quello del camp ",
          input_validation_max_field: "Valore deve essere minore uguale a quello del campo ",
          input_validation_exclude_values: "Campo deve contenere un valore diverso",
          integer: "intero",
          bigint: "intero",
          text: "testuale",
          varchar: "testuale",
          textarea: "testuale",
          string: "stringa",
          date: "data",
          datetime: "data",
          float: "float",
          table: "table"
        },
        footer: {
          required_fields: "Campi obbligatori"
        },
        messages: {
          qgis_input_widget_relation: "Gestisci le relazioni tramite form dedicato"
        }
      },
      catalog: {
        current_map_theme_prefix: "TEMA",
        choose_map_theme: "SCEGLI TEMA",
        choose_map_theme_input_label: 'Nome del nuovo tema',
        project_map_theme: 'Temi Progetto',
        user_map_theme: 'Temi Utente',
        question_delete_map_theme: "Vuoi cancellare il tema ?",
        delete_map_theme: "Tema cancellato con successo",
        saved_map_theme: "Tema salvato con successo",
        updated_map_theme: "Tema aggiornato con successo",
        invalid_map_theme_name: "Nome già esistente o non corretto",
        menu: {
          layerposition: 'Posizione Layer',
          setwmsopacity: "Cambia opacità",
          wms: {
            title: "",
            copy: "Clicca qui per copiare url",
            copied: "Copiato"
          },
          download: {
            unknow: "Scarica",
            geotiff_map_extent: "GeoTiff (vista attuale)"
          }
        }
      },
      wps: {
        list_process: "Lista dei processi",
        tooltip: 'Clicca sulla mappa'
      }
    },
    credits: {
      g3wSuiteFramework: "Applicativo realizzato con il framework OS",
      g3wSuiteDescription: "Pubblica e gestisci i tuoi progetti QGIS sul Web",
      productOf: "Framework sviluppato da"
    },
    toggle_color_scheme: "Cambia colore",
    logout: "Esci",
    no_other_projects: "Non ci sono altri progetti in questo gruppo cartografico",
    /**
     * @since 3.8.0
     */
    no_other_groups: "Non ci sono altri gruppi in questo Macrogruppo",
    yes: "Si",
    no: "No",
    back: "Indietro",
    backto: "Torna a ",
    changemap: "Cambia mappa",
    change_session: "Cambia Sessione",
    component: "Componente Generico",
    search: "Ricerche",
    no_results: "Nessun risultato trovato",
    print: "Stampa",
    create_print: "Crea Stampa",
    dosearch: "Cerca",
    catalog: "Mappa",
    data: "Dati",
    externalwms: "WMS",
    baselayers: "Basi",
    tools: "Strumenti",
    tree: "Strati",
    legend: "Legenda",
    nobaselayer: "Nessuna mappa di base",
    street_search: "Cerca indirizzo",
    show: "Mostra",
    hide: "Nascondi",
    copy_form_data: "Copia i dati del modulo",
    paste_form_data: "Incolla",
    copy_form_data_from_feature: "Copia i dati dalla mappa",
    error_map_loading: "Errore di caricamento della nuova mappa",
    check_internet_connection_or_server_admin: "Controllare la connessione internet o contattare l'amministratore",
    could_not_load_vector_layers: "Errore di connessione al server: non è stato possibile caricare i vettoriali richiesti",
    server_saver_error: "Errore nel salvataggio sul server",
    server_error: "Si è verificato un errore nella richiesta al server",
    save: "Salva",
    cancel: "Cancella",
    update: "Aggiorna",
    close: "Chiudi",
    /** @since 3.8.0 */
    dont_show_again: "Non mostrare più",
    enlange_reduce: "Allarga / Riduci",
    add: "Aggiungi",
    exitnosave: "Esci senza salvare",
    annul: "Annulla",
    layer_is_added: "Esiste già un livello con lo stesso nome",
    sidebar: {
      wms: {
        panel: {
          title: 'Aggiunta livello WMS',
          label: {
            position: "Posizione su Mappa",
            name: "Nome",
            projections: 'Sistema di riferimento',
            layers: 'Livelli'
          }
        },
        add_wms_layer: "Aggiungi livello WMS",
        delete_wms_url: "Rimuovi",
        layer_id_already_added: "Esiste già una connessione WMS con questo nome",
        url_already_added: "URL/Nome WMS già aggiunto",
        layer_add_error: "WMS Layer non aggiunto. Verificare i parametri o l'url"
      }
    },
    info: {
      title: "Risultati",
      list_of_relations: "Lista delle relazioni",
      open_link: "Apri documento allegato",
      server_error: "Si è verificato un errore nella richiesta al server",
      no_results: "Nessun risultato per questa interrogazione/ricerca ",
      link_button: "Apri"
    },
    mapcontrols: {
      geolocation: {
        error: "Non è possibile ottenere la tua posizione."
      },
      geocoding: {
        choose_layer: "Scegli un livello in cui aggiungere questa funzionalità",
        placeholder: "Indirizzo ...",
        nolayers: "Nessun layer di punti modificabile trovato in questo progetto",
        noresults: "Nessun risultato",
        notresponseserver: "Il server non risponde"
      },
      add_layer_control: {
        header: "Aggiungi livello",
        select_projection: "Sistema di riferimento",
        select_field_to_show: "valore mostrato sulla mappa",
        select_csv_separator: "Separatore",
        select_csv_x_field: "Campo X",
        select_csv_y_field: "Campo Y",
        select_color: "Colore",
        drag_layer: "Aggiungi qui il tuo file",
        persistent_data: "Persistenza",
        persistent_help: "salva il livello nella memoria del browser"
      },
      query: {
        input_relation: "Clicca per consultare le relazioni"
      },
      length: {
        tooltip: "Lunghezza"
      },
      area: {
        tooltip: "Area"
      },
      screenshot: {
        error: "Errore nella creazione dello screenshot",
        securityError: "  \n        <p><b>Errore di sicurezza</b>: uno strato esterno impedisce la stampa della mappa. Per verificare, procedere come segue:</p>\n        <ol>\n          <li>rimuovi eventuali layer esterni aggiunti manualmente (es. layer WMS)</li>\n          <li>forza il ricaricamento della pagina: <code>CTRL + F5</code></li>\n          <li>stampa nuovamente la mappa</li>\n        </ol>\n        <p>Per maggiori informazioni contattare l'amministratore del server in merito a: <a href=\"https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_enabled_image\" style=\"color: #000 !important;font-weight: bold;\">&#x2139;&#xFE0F; security and tainted canvases</a></p>\n        "
      }
    },
    catalog_items: {
      helptext: "Apri menu",
      contextmenu: {
        zoomtolayer: "Zoom sul livello",
        open_attribute_table: "Apri tabella attributi",
        show_metadata: "Metadati",
        styles: "Stile",
        vector_color_menu: "Colore",
        layer_opacity: "Opacità",
        filters: "Filtri",
        download: 'Esporta come',
        ogc_services: 'Servizi OGC',
        edit: "Modifica dati"
      }
    },
    dataTable: {
      previous: "Precedente",
      next: "Successivo",
      lengthMenu: "Mostra _MENU_ valori per pagina",
      info: "_TOTAL_ elementi",
      nodatafilterd: "Nessun risultato trovato",
      infoFiltered: "(Filtrati da _MAX_ total righe)"
    },
    /**@since 3.10.0 */
    no_geometry: 'Questo elemento non ha geometria',
    /**@since 3.11.0 */
    query_filter: 'Filtra per:',
    /**@since 3.11.0 */
    sidebar_menu: 'Menu laterale',
    /**@since 3.11.0 */
    layer_type: 'Tipologia livello',
    /**@since 3.11.0 */
    choose_type: 'Scegli un tipo',
    /**@since 3.11.0 */
    remote_wms_url: 'WMS (URL)',
    /**@since 3.11.0 */
    local_file: 'File locale',
    /**@since 3.11.0 */
    embed_map: 'Incorpora mappa',
    /** @since 3.11.0 */
    homepage: 'Pagina iniziale',
    /** @since 3.11.0 */
    wms_server: 'Server WMS',
    /** @since 3.11.0 */
    connect_to_wms: 'Connetti',
    /** @since 3.11.0 */
    disconnect_from_wms: 'Disconnetti',
    /** @since 3.11.0 */
    add_new_wms_url_help: 'Cerca tra le connessioni salvate o aggiungi un nuovo server',
    /** @since 3.11.0 */
    saved_connections: 'Connessioni salvate:',
    /** @since 3.11.0 */
    label: "Etichetta",
    /** @since 3.11.0 */
    no_csv_field: 'Nessun campo valido',
    /** @since 3.11.0 */
    show_more: 'Mostra di più'
  }
};

},{}],173:[function(require,module,exports){
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  translation: {
    error_page: {
      error: "Błąd połączenia",
      at_moment: "W tej chwili nie jest możliwe mapa pokazująca",
      f5: "Naciśnij Ctrl+F5"
    },
    cookie_law: {
      message: "Ta strona internetowa korzysta z plików cookie, aby uzyskać najlepsze wrażenia na naszej stronie internetowej.",
      buttonText: "Rozumiem!"
    },
    default: "domyślny",
    sign_in: "Zalogować się",
    layer_selection_filter: {
      tools: {
        filter: "Włącz/wyłącz filtr",
        nofilter: "Usuń filtr",
        invert: "Odwróć wybór",
        clear: "Jasny wybór",
        show_features_on_map: "Pokaż funkcje widoczne na mapie",
        savefilter: "Zapisz filtr",
        filterName: "Nazwa filtru"
      }
    },
    warning: {
      not_supported_format: "Nie obsługiwany format"
    },
    layer_position: {
      top: "SZCZYT",
      bottom: "SPÓD",
      message: "Pozycja względem warstw na TOC"
    },
    sdk: {
      atlas: {
        template_dialog: {
          title: "Wybierz szablon"
        }
      },
      spatialbookmarks: {
        title: "Zakładki przestrzenne",
        helptext: "Poruszaj zasięg mapy, wstaw nazwę i kliknij Dodaj",
        input: {
          name: "Nazwa"
        },
        sections: {
          project: {
            title: "Zakładki projektu"
          },
          user: {
            title: "Zakładki użytkowników"
          }
        }
      },
      search: {
        all: "WSZYSTKO",
        no_results: "Brak wyników",
        searching: "Poszukiwanie ...",
        error_loading: "Błąd Dane dotyczące ładowania",
        layer_not_searchable: "Warstwa nie można przeszukiwać",
        layer_not_querable: "Warstwa nie jest zapytana",
        autocomplete: {
          inputshort: {
            pre: "Podaj",
            post: "lub więcej znaków"
          }
        },
        help_filter: "Wartości wyszukiwania są ograniczone w zależności od aktywnego filtra. Usuń filtr, aby przeszukać wszystkie dane.",
        autofilter: "Filtruj wyniki"
      },
      print: {
        no_layers: "Brak warstwy do wydrukowania",
        template: "Szablon",
        labels: "Etykiety",
        scale: "Skala",
        format: "Format",
        rotation: "Obrót",
        download_image: "Pobierz obraz",
        fids_instruction: "Zaakceptowane wartości: od 1 do wartości [maks.]. Możliwe jest wstawienie zasięgu ex. 4-6",
        fids_example: "Były. 1,4-6 zostanie wydrukowany 1,4,5,6",
        help: "Warstwy pokazane w druku mogą być warstwy zdefiniowane w projekcie, a nie wyświetlane na mapie"
      },
      querybuilder: {
        search: {
          run: "Uruchomić",
          info: "Informacja",
          delete: "Usuwać",
          edit: "Edytować"
        },
        messages: {
          changed: "Uratowany",
          number_of_features: "Liczba funkcji"
        },
        panel: {
          button: {
            all: "WSZYSTKO",
            save: "RATOWAĆ",
            test: "TEST",
            clear: "JASNE",
            run: "URUCHOMIĆ",
            manual: "PODRĘCZNIK"
          },
          layers: "Warstwy",
          fields: "Pola",
          values: "Wartości",
          operators: "Operatorzy",
          expression: "WYRAŻENIE"
        },
        error_run: "Występuje błąd. Sprawdź zapytanie",
        error_test: "Błąd wystąpił podczas wykonywania zapytania",
        delete: "Chcesz to usunąć?",
        additem: "Włóż nazwę nowego wyszukiwania"
      },
      errors: {
        layers: {
          load: "Niektóre warstwy nie są dostępne"
        },
        unsupported_format: "Nie obsługiwany format",
        add_external_layer: "Błąd warstwy ładowania"
      },
      metadata: {
        title: "Metadane",
        groups: {
          general: {
            title: "OGÓLNY",
            fields: {
              title: "TYTUŁ",
              name: "NAZWA",
              description: "OPIS",
              abstract: "ABSTRAKCYJNY",
              keywords: "SŁOWA KLUCZOWE",
              fees: "OPŁATY",
              accessconstraints: "Ograniczenie dostępu",
              contactinformation: "ŁĄCZNOŚĆ",
              subfields: {
                contactinformation: {
                  contactelectronicmailaddress: "E-mail",
                  personprimary: "Bibliografia",
                  contactvoicetelephone: "Telefon",
                  contactorganization: "Organizacja",
                  ContactOrganization: "Organizacja",
                  contactposition: "Pozycja",
                  ContactPosition: "Pozycja",
                  contactperson: "Osoba",
                  ContactPerson: "Osoba"
                }
              },
              wms_url: "WMS"
            }
          },
          spatial: {
            title: "PRZESTRZENNY",
            fields: {
              crs: "EPSG",
              extent: "Bbox"
            }
          },
          layers: {
            title: "Warstwy",
            fields: {
              layers: "Warstwy",
              subfields: {
                crs: "EPSG",
                bbox: "Bbox",
                title: "TYTUŁ",
                name: "NAZWA",
                geometrytype: "GEOMETRIA",
                source: "ŹRÓDŁO",
                attributes: "Atrybuty",
                abstract: "ABSTRAKCYJNY",
                attribution: "ATRYBUCJA",
                keywords: "Chiave zwolnienia warunkowego",
                metadataurl: "URL METADATA",
                dataurl: "URL danych"
              }
            },
            groups: {
              general: "OGÓLNY",
              spatial: "PRZESTRZENNY"
            }
          }
        }
      },
      tooltips: {
        relations: {
          form_to_row: "Widok wiersza",
          row_to_form: "Widok formularza",
          zoomtogeometry: "Powiększ geometrię"
        },
        copy_map_extent_url: "Kopiuj link Widok Mapa",
        download_shapefile: "Pobierz ShapeFile",
        download_gpx: "Pobierz GPX",
        download_gpkg: "Pobierz GPKG",
        download_csv: "Pobierz CSV",
        download_xls: "Pobierz XLS",
        show_chart: "Wykres pokazowy",
        atlas: "Wydrukuj atlas"
      },
      mapcontrols: {
        query: {
          tooltip: "Warstwa zapytania",
          actions: {
            add_selection: {
              hint: "Dodaj/usuń wybór"
            },
            zoom_to_features_extent: {
              hint: "Zoom w zakresie funkcji"
            },
            add_features_to_results: {
              hint: "Dodaj/usuń funkcje do wyników"
            },
            remove_feature_from_results: {
              hint: "Usuń funkcję z wyników"
            },
            zoom_to_feature: {
              hint: "Zoom do funkcji"
            },
            relations: {
              hint: "Pokaż relacje"
            },
            relations_charts: {
              hint: "Pokaż wykres relacji"
            },
            download_features_shapefile: {
              hint: "Pobierz funkcje ShapeFile"
            },
            download_shapefile: {
              hint: "Pobierz funkcję kształtu plik"
            },
            download_features_gpx: {
              hint: "Pobierz funkcję GPX"
            },
            download_features_gpkg: {
              hint: "Pobierz funkcje GPKG"
            },
            download_gpx: {
              hint: "Pobierz funkcję GPX"
            },
            download_gpkg: {
              hint: "Pobierz funkcję gpkg"
            },
            download_features_csv: {
              hint: "Pobierz funkcje CSV"
            },
            download_csv: {
              hint: "Pobierz funkcję CSV"
            },
            download_features_xls: {
              hint: "Pobierz funkcje XLS"
            },
            download_xls: {
              hint: "Pobierz funkcję XLS"
            },
            atlas: {
              hint: "Wydrukuj atlas"
            },
            copy_zoom_to_fid_url: {
              hint: "Skopiuj adres URL map z tym rozszerzeniem funkcji geometrii",
              hint_change: "Skopiowane"
            }
          }
        },
        queryby: {
          title: 'Query area',
          layer: 'Selected layer:',
          none: 'NONE',
          new: 'TEMPORARY LAYER',
          all: 'ALL',
          methods: {
            intersects: 'intersects',
            within: 'within'
          },
          querybypolygon: {
            tooltip: 'select a polygon'
          },
          querybydrawpolygon: {
            tooltip: 'draw a polygon'
          },
          querybbox: {
            tooltip: 'draw a rectangle'
          },
          querybycircle: {
            tooltip: 'draw a circle'
          }
        },
        querybypolygon: {
          download: {
            title: "Pobieranie atrybutów",
            choiches: {
              feature: {
                label: "Tylko funkcje"
              },
              feature_polygon: {
                label: "Funkcje+Polygon zapytania"
              }
            }
          },
          tooltip: "Zapytanie według wielokąta",
          no_geometry: "Brak geometrii w odpowiedzi",
          help: {
            message: "<ul><li>Wybierz warstwę wielokąta na Toc.</li><li>upewnij się, że warstwa jest widoczna.</li><li>Kliknij funkcję wybranej warstwy.</li></ul>"
          }
        },
        querybydrawpolygon: {
          tooltip: "Zapytanie przez Polygon Draw"
        },
        querybbox: {
          tooltip: "Zapytanie warstwa Bbox",
          nolayers_visible: "Nie widać zapytaniach warstw. Ustaw co najmniej jedną widoczną warstwę WFS, aby uruchomić zapytanie",
          help: {
            message: "<ul><li>Narysuj kwadrat na mapie, aby zapytają podkreślone warstwy na Toc</li></ul>"
          }
        },
        querybycircle: {
          tooltip: "Query by Draw Circle ",
          label: 'Radius',
          help: {
            message: "<ul><li>Click on map to draw circle</li></ul>"
          }
        },
        addlayer: {
          messages: {
            csv: {
              warning: "Wynik na mapie jest częściowy ze względu na obecność poniższej listy błędnych rekordów:"
            }
          },
          tooltip: "Dodaj warstwę"
        },
        geolocation: {
          tooltip: "Geolokalizację"
        },
        measures: {
          length: {
            tooltip: "Długość",
            help: "Kliknij mapę, aby narysować linię. Naciśnij <br> Canc, jeśli chcesz usunąć ostatni wierzchołek"
          },
          area: {
            tooltip: "Obszar",
            help: "Kliknij, aby narysować Poligon.press <br> Canc Jeśli chcesz usunąć ostatni wierzchołek"
          }
        },
        scale: {
          no_valid_scale: "Nieprawidłowa skala"
        },
        scaleline: {
          units: {
            metric: "Metry",
            nautical: "Mila morska"
          }
        },
        zoomhistory: {
          zoom_last: "Zoom ostatni",
          zoom_next: "Zoom Dalej"
        }
      },
      relations: {
        relation_data: "Dane dotyczące relacji",
        no_relations_found: "Nie znaleziono żadnych relacji",
        back_to_relations: "Powrót do relacji",
        list_of_relations_feature: "Lista relacji funkcji",
        error_missing_father_field: "Brakuje pola",
        field: "Relation key field"
      },
      form: {
        loading: "Ładowanie ...",
        inputs: {
          messages: {
            errors: {
              picklayer: "Brak wybranej funkcji. Sprawdź, czy warstwa jest w edycji lub widoczna w bieżącej skali"
            }
          },
          tooltips: {
            picklayer: "Uzyskaj wartość z warstwy MA",
            lonlat: "Kliknij mapę, aby uzyskać współrzędne"
          },
          input_validation_mutually_exclusive: "Pole wzajemnie wykluczające się z",
          input_validation_error: "Obowiązkowe pole lub niewłaściwy typ danych",
          input_validation_error_type: "Niewłaściwy typ danych",
          input_validation_min_field: "Wartość musi być większa/równa wartości pola",
          input_validation_max_field: "Wartość musi być mniej/równa wartości pola",
          input_validation_exclude_values: "Wartość musi być wyjątkowa",
          integer: "liczba całkowita",
          bigint: "liczba całkowita",
          text: "tekst",
          varchar: "tekst",
          textarea: "tekst",
          string: "strunowy",
          date: "data",
          datetime: "data",
          float: "platforma",
          table: "tabela"
        },
        footer: {
          required_fields: "Wymagane pola"
        },
        messages: {
          qgis_input_widget_relation: "Użyj relacji konkretna forma do pracy w związku z relacją"
        }
      },
      catalog: {
        current_map_theme_prefix: "TEMAT",
        choose_map_theme: "Wybierz motyw",
        menu: {
          layerposition: "Pozycja warstwy",
          setwmsopacity: "Ustaw krycie",
          wms: {
            title: "--",
            copy: "Kliknij tutaj, aby skopiować adres URL",
            copied: "Skopiowane"
          },
          download: {
            unknow: "Pobierać",
            shp: "Pobierz ShapeFile",
            gpx: "Pobierz GPX",
            gpkg: "Pobierz GPKG",
            csv: "Pobierz CSV",
            xls: "Pobierz XLS",
            geotiff: "Pobierz Geotiff",
            geotiff_map_extent: "Pobierz Geotiff (Obecny zasięg View)"
          }
        }
      },
      wps: {
        list_process: "Lista procesu",
        tooltip: "Kliknij mapę"
      }
    },
    credits: {
      g3wSuiteFramework: "Aplikacja oparta na strukturze systemu operacyjnego",
      g3wSuiteDescription: "Publikuj i zarządzaj projektami QGIS w Internecie",
      productOf: "Ramy opracowane przez"
    },
    toggle_color_scheme: "Przełącz kolorystykę",
    logout: "Wyloguj",
    no_other_projects: "Nigdy więcej projektu dla tej grupy",
    no_other_groups: "Nigdy więcej grup dla tej makrogrupy",
    yes: "Tak",
    no: "NIE",
    back: "Z powrotem",
    backto: "Wrócić do",
    changemap: "Zmień mapę",
    change_session: "Zmień sesję",
    component: "Komponent ogólny",
    search: "Szukaj",
    no_results: "Nie znaleziono wyników",
    print: "Wydrukować",
    create_print: "Utwórz druk",
    dosearch: "Szukaj",
    catalog: "Mapa",
    data: "Dane",
    externalwms: "WMS",
    baselayers: "Baza",
    tools: "Narzędzia",
    tree: "Warstwy",
    legend: "Legenda",
    nobaselayer: "Brak mapy bazowej",
    street_search: "Znajdź adres",
    show: "Pokazywać",
    hide: "Ukrywać",
    copy_form_data: "Skopiuj dane",
    paste_form_data: "Pasta",
    copy_form_data_from_feature: "Skopiuj dane z mapy",
    error_map_loading: "Występuje błąd mapy ładowania",
    check_internet_connection_or_server_admin: "Sprawdź połączenie internetowe lub skontaktuj się z administratorem",
    could_not_load_vector_layers: "Błąd połączenia: Warstwy można załadować",
    server_saver_error: "Błąd zapisywania serwera",
    server_error: "Błąd połączenia serwera",
    save: "Ratować",
    cancel: "Anulować",
    close: "Zamknąć",
    dont_show_again: "Nie pokazuj ponownie",
    enlange_reduce: "Powiększ / zmniejsz",
    add: "Dodać",
    exitnosave: "Wyjdź bez zapisu",
    annul: "Anulować",
    layer_is_added: "Warstwa o tej samej nazwie już dodanej",
    sidebar: {
      wms: {
        panel: {
          title: "Dodaj warstwę WMS",
          label: {
            position: "Pozycja mapy",
            name: "Nazwa",
            projections: "Występ",
            layers: "Warstwy"
          }
        },
        add_wms_layer: "Dodaj warstwę WMS",
        delete_wms_url: "Usuń adres URL WMS",
        layer_id_already_added: "Już dodana warstwa WMS",
        url_already_added: "WMS URL/Nazwa już dodana",
        layer_add_error: "Warstwa WMS nie dodano. Sprawdź wszystkich parametrów lub adresu URL WMS"
      }
    },
    info: {
      title: "Wyniki",
      list_of_relations: "Lista relacji",
      open_link: "Otwarty załączony dokument",
      server_error: "Wystąpił błąd z serwera",
      no_results: "Nie znaleziono wyników dla tego zapytania/wyszukiwania",
      link_button: "otwarty"
    },
    mapcontrols: {
      geolocations: {
        error: "Nie mogę zdobyć swojej pozycji"
      },
      geocoding: {
        choose_layer: "Wybierz warstwę, gdzie dodać tę funkcję",
        placeholder: "Adres ...",
        nolayers: "Brak edytowalnych warstw punktowych w tym projekcie",
        noresults: "Brak wyników",
        notresponseserver: "Brak odpowiedzi z serwera"
      },
      add_layer_control: {
        header: "Dodaj warstwę",
        select_projection: "Wybierz projekcję warstwy",
        select_field_to_show: "Wybierz pole, aby pokazać na mapie",
        select_csv_separator: "Wybierz Selimiter",
        select_csv_x_field: "Wybierz pole x",
        select_csv_y_field: "Wybierz pole Y.",
        select_color: "Wybierz kolor warstwy",
        drag_layer: "Przeciągnij i upuść warstwę tutaj"
      },
      query: {
        input_relation: "Kliknij, aby pokazać relacje"
      },
      length: {
        tooltip: "Długość"
      },
      area: {
        tooltip: "Obszar"
      },
      screenshot: {
        error: "Tworzenie błędów z ekranu",
        securityError: "  \n        <p><b>B\u0142\u0105d bezpiecze\u0144stwa</b>: Warstwa zewn\u0119trzna zapobiega wydrukowaniu mapy. Aby sprawdzi\u0107, post\u0119puj w nast\u0119puj\u0105cy spos\xF3b:</p>\n        <ol>\n          <li>Usu\u0144 wszelkie r\u0119cznie dodane warstwy zewn\u0119trzne (np. WMORY WMS)</li>\n          <li>Prze\u0142adowanie strony Si\u0142y: <code> CTRL + F5</code></li>\n          <li>Wydrukuj ponownie map\u0119</li>\n        </ol>\n        <p>Aby uzyska\u0107 wi\u0119cej informacji, skontaktuj si\u0119 z administratorem serwera o: <a href=\"https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_enabled_image\" style=\"color: #000 !important;font-weight: bold;\">&#x2139;&#xFE0F; security and tainted canvases</a></p>\n        "
      }
    },
    catalog_items: {
      helptext: "Kliknij indywidualną warstwę prawym przyciskiem myszy, aby uzyskać dostęp do dodatkowych funkcji",
      contextmenu: {
        zoomtolayer: "Zoom do warstwy",
        open_attribute_table: "Otwórz tabelę atrybutów",
        show_metadata: "Metadane",
        styles: "Style",
        vector_color_menu: "Ustaw/zmiana kolor",
        layer_opacity: "Nieprzezroczystość",
        filters: "Filtry"
      }
    },
    dataTable: {
      previous: "Poprzedni",
      next: "Następny",
      lengthMenu: "Pokaż menu_",
      info: "Pokazanie _start_ do _end_ wpisów _total_",
      no_data: "Brak danych",
      nodatafilterd: "nie znaleziono pasujacego wyniku",
      infoFiltered: "(Filtrowane z _max_ całkowitych rekordów)"
    }
  }
};

},{}],174:[function(require,module,exports){
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _print;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

exports.default = {
  translation: {
    error_page: {
      error: "Erro de conexão",
      at_moment: "De momento não é possível apresentar o mapa",
      f5: "Pressione Ctrl+F5"
    },
    cookie_law: {
      message: "Esta página utiliza cookies para garantir que obtenha a melhor experiência de uso.",
      buttonText: "OK!"
    },
    default: "predefinido",
    sign_in: "Aceder",
    layer_selection_filter: {
      tools: {
        filter: "Ativar/desativar filtro",
        nofilter: "Remover filtro",
        invert: "Inverter Seleção",
        clear: "Limpar Seleção",
        show_features_on_map: "Atualizar resultados ao mover o mapa",
        savefilter: "Salvar Filtro",
        filterName: "Nome do Filtro"
      }
    },
    warning: {
      not_supported_format: "Formato não suportado"
    },
    layer_position: {
      top: 'cima',
      bottom: 'baixo',
      message: "Posição"
    },
    sdk: {
      atlas: {
        template_dialog: {
          title: "Selecione o Modelo"
        }
      },
      spatialbookmarks: {
        title: "Marcadores",
        helptext: "Altere a extensão do mapa, insira um nome e clique Adicionar",
        input: {
          name: "Nome"
        },
        sections: {
          project: {
            title: "Marcadores do projeto"
          },
          user: {
            title: "Marcadores do Utilizador"
          }
        }
      },
      search: {
        all: 'Todos',
        no_results: "Sem resultados",
        searching: "A pesquisar ...",
        error_loading: "Erro ao Carregar os Dados",
        layer_not_searchable: "Camada não é pesquisável",
        layer_not_querable: "Camada não é consultável (query)",
        autocomplete: {
          inputshort: {
            pre: "Inserir",
            post: "ou mais carateres"
          }
        },
        help_filter: "Os valores de pesquisa são limitados com base no filtro ativo. Remova o filtro para pesquisar todos os dados.",
        autofilter: "Filtrar resultados"

      },
      print: (_print = {
        no_layers: 'Sem camada para imprimir',
        template: "Modelo",
        labels: "Etiquetas",
        scale: "Escala"
      }, _defineProperty(_print, "scale", "Escala"), _defineProperty(_print, "format", "Formato"), _defineProperty(_print, "rotation", "Rotação"), _defineProperty(_print, "download_image", "Descarregar Imagem"), _defineProperty(_print, "fids_instruction", "Valores permitidos: de 1 até [max]. Pode inserir um intervalo ex. 4-6"), _defineProperty(_print, "fids_example", "Ex. 1,4-6 irá imprimir id 1,4,5,6"), _defineProperty(_print, "help", "Camadas a exportar serão definidas pelo administrador"), _defineProperty(_print, "help_details", "<p>Se n\xE3o visualizar alguma camada no ficheiro de impress\xE3o</p>\n          <ol style=\"padding-left: 25px\">\n            <li>tente novamente selecionando outro modelo</li>\n            <li>tente mudar o n\xEDvel de zoom</li>\n            <li>verifique a origem (ex. Servidor WMS externos)</li>\n            <li>garanta que a camada est\xE1 ativada na lista de camadas.</li>\n          </ol>"), _print),
      querybuilder: {
        title: 'Pesquisa avançada',
        search: {
          run: "Executar",
          info: "Informação",
          delete: "Eliminar",
          edit: "Editar"
        },
        messages: {
          changed: 'Guardado',
          number_of_features: "Entidades encontradas:"
        },
        panel: {
          button: {
            all: 'PESQUISE UM VALOR',
            save: 'GUARDAR',
            test: 'TESTAR',
            clear: 'LIMPAR',
            run: 'EXECUTAR',
            manual: 'MANUAL'
          },
          layers: 'CAMADAS',
          fields: 'CAMPOS',
          values: 'VALORES',
          operators: 'OPERADORES',
          expression: 'EXPRESSÃO'
        },
        error_run: 'Ocorreu um erro. Verifique a consulta',
        error_test: "Oorreu um erro durante a execução da consulta",
        delete: 'Pretende eliminar?',
        additem: 'Insira o nome da nova pesquisa'
      },
      errors: {
        layers: {
          load: "Algumas camadas não estão disponíveis"
        },
        unsupported_format: 'Formato não suportado',
        add_external_layer: 'Erro de carregamento de camada'
      },
      metadata: {
        title: 'Metadados',
        groups: {
          general: {
            title: 'GERAL',
            fields: {
              title: 'TÍTULO',
              name: 'NOME',
              description: "DESCRIÇÃO",
              abstract: "RESUMO",
              keywords: 'PALAVRAS CHAVE',
              fees: "TAXAS",
              accessconstraints: "RESTRIÇÃO DE ACESSO",
              contactinformation: "CONTATOS",
              subfields: {
                contactinformation: {
                  contactelectronicmailaddress: "Email",
                  personprimary: 'Referencias',
                  contactvoicetelephone: 'Telefone',
                  contactorganization: 'Organização',
                  ContactOrganization: 'Organização',
                  contactposition: 'Cargo',
                  ContactPosition: 'Cargo',
                  contactperson: 'Pessoa',
                  ContactPerson: 'Pessoa'
                }
              },
              wms_url: "WMS"
            }
          },
          spatial: {
            title: 'ESPACIAL',
            fields: {
              crs: 'EPSG',
              extent: 'BBOX'
            }
          },
          layers: {
            title: 'CAMADAS',
            fields: {
              layers: 'LAYERS',
              subfields: {
                crs: 'EPSG',
                bbox: 'BBOX',
                title: "TÍTULO",
                name: 'NOME',
                geometrytype: 'GEOMETRIA',
                source: 'FONTE',
                attributes: 'ATRIBUTOS',
                abstract: 'RESUMO',
                attribution: 'ATRIBUIÇÃO',
                keywords: "PALAVRA CHAVE",
                metadataurl: 'ENDEREÇO METADADOS',
                dataurl: "ENDEREÇO DADOS"
              }
            },
            groups: {
              general: 'GERAL',
              spatial: 'ESPACIAL'
            }
          },
          credits: {
            title: 'Créditos'
          }
        }
      },
      tooltips: {
        relations: {
          form_to_row: "Vista de tabela",
          row_to_form: "Vista de Formulário",
          zoomtogeometry: "Aproximar à Geometria"
        },
        copy_map_extent_url: 'Copiar URL partilhável',
        download_shapefile: "Descarregar Shapefile",
        download_gpx: "Descarregar GPX",
        download_gpkg: "Descarregar GPKG",
        download_csv: "Descarregar CSV",
        download_xls: "Descarregar XLS",
        download_pdf: "Descarregar PDF",
        show_chart: "Mostrar Gráfico",
        atlas: "Imprimir Atlas",
        editing: "Edição"
      },
      mapcontrols: {
        query: {
          tooltip: 'Consultar camada',
          actions: {
            add_selection: {
              hint: "Adicionar/Remover Seleção"
            },
            zoom_to_features_extent: {
              hint: "Aproximar à extensão da camada"
            },
            add_features_to_results: {
              hint: "Adicionar/Remover camadas aos resultados"
            },
            remove_feature_from_results: {
              hint: "Remover camada dos resultados"
            },
            zoom_to_feature: {
              hint: "Ampliar para a camada"
            },
            relations: {
              hint: "Mostrar Relações"
            },
            relations_charts: {
              hint: "Mostrar gráfico das relações"
            },
            download_features_shapefile: {
              hint: 'Descarregar camadas para Shapefile'
            },
            download_shapefile: {
              hint: 'Descarregar camada para Shapefile'
            },
            download_features_gpx: {
              hint: "Descarregar camadas para GPX"
            },
            download_features_gpkg: {
              hint: "Descarregar camadas para GPKG"
            },
            download_gpx: {
              hint: "Descarregar camada para GPX"
            },
            download_gpkg: {
              hint: "Descarregar camada para GPKG"
            },
            download_features_csv: {
              hint: "Descarregar camadas para CSV"
            },
            download_csv: {
              hint: "Descarregar camada para CSV"
            },
            download_features_xls: {
              hint: "Descarregar camadas para para XLS"
            },
            download_xls: {
              hint: "Descarregar camada para XLS"
            },
            download_pdf: {
              hint: "Descarregar camada para PDF"
            },
            atlas: {
              hint: "Imprimir Atlas"
            },
            copy_zoom_to_fid_url: {
              hint: "Compartilhar link",
              hint_change: "Copiado"
            }
          }
        },
        queryby: {
          title: 'Consultar área',
          layer: 'Selecionar camadas:',
          none: 'NENHUM',
          new: 'CAMADA TEMPORÁRIA',
          all: 'TODOS',
          methods: {
            intersects: 'interseção',
            within: 'dentro de'
          },
          querybypolygon: {
            tooltip: 'selecione um polígono'
          },
          querybydrawpolygon: {
            tooltip: 'desenhe um polígono'
          },
          querybbox: {
            tooltip: 'desenhe um retangulo'
          },
          querybycircle: {
            tooltip: 'desenhe um círculo'
          }
        },
        querybypolygon: {
          download: {
            title: "Descarregar atributos",
            choiches: {
              feature: {
                label: "Apenas geometrias"
              },
              feature_polygon: {
                label: "Consultar Camadas+Polígono"
              }
            }
          },
          tooltip: 'Consultar por Polígono',
          no_geometry: 'Resposta sem geometrias',
          help: {
            message: "<ul><li>Selecione uma camada (ativa).</li><li>Clique sobre uma geometria no mapa.</li></ul>"
          }
        },
        querybydrawpolygon: {
          tooltip: "Desenhe um polígono para consultar ",
          help: {
            message: "<ul><li>Clique sobre o mapa para adicionar um novo vértice </li><li>Duplo clique para finalizar e inquirir camadas (sublinhado a amarelo na legenda)</li></ul>"
          }
        },
        querybbox: {
          tooltip: 'Consultar camada com retangulo',
          nolayers_visible: 'Nenhuma camada consultável visivel. Defina pelo menos uma camada wfs visivel para executar a consulta',
          help: {
            message: "<ul><li>Arraste o rato para desenhar um retangulo e consultar as camadas. (sublinhado a amarelo na legenda)</li></ul>"
          }
        },
        querybycircle: {
          tooltip: "Consultar camada com circulo ",
          label: 'Raio',
          help: {
            message: "<ul><li>Clique no mapa para desenhar o círculo</li></ul>"
          }
        },
        addlayer: {
          messages: {
            csv: {
              warning: "O resulto no mapa é parcial, dada a presença dos seguintes registos incorretos:"
            }
          },
          tooltip: 'Adicionar camada'
        },
        geolocation: {
          tooltip: 'Geolocalização'
        },
        measures: {
          title: 'Medir',
          length: {
            tooltip: "Comprimento",
            help: "Clique no mapa  para desenhar uma linha. Prima <br>CANC se pretender eliminar o ultimo vértice"
          },
          area: {
            tooltip: "Área",
            help: "Clique para desenhar o polígono.Prima <br>CANC se pretender eliminar o ultimo vértice"
          }
        },
        screenshot: {
          title: 'Captura de ecran',
          screenshot: "PNG",
          geoscreenshot: "GeoTIFF",
          download: 'Gerar'
        },
        scale: {
          no_valid_scale: "Escala inválida"
        },
        scaleline: {
          units: {
            metric: 'Metros',
            nautical: 'Milhas náuticas'
          }
        },
        zoomhistory: {
          zoom_last: "Zoom anterior",
          zoom_next: "Zoom seguinte"
        }
      },
      relations: {
        relation_data: 'Dados da Relação',
        no_relations_found: 'Relações não encontradas',
        back_to_relations: 'Voltar para as relações',
        list_of_relations_feature: 'Lista de relações da camada',
        error_missing_father_field: "Atributo em falta",
        field: "Campo chave da relação"
      },
      form: {
        loading: 'A carregar ...',
        inputs: {
          messages: {
            errors: {
              picklayer: "Sem camadas selecionadas. Verifique se a camada está em edição ou visível na escala atual."
            }
          },
          tooltips: {
            picklayer: "Obter atributo da camada",
            lonlat: "Clique no mapa para obter as coordenadas"
          },
          input_validation_mutually_exclusive: "Atributo mutuamente exclusivo com ",
          input_validation_error: "Atributo obrigatório ou tipo de dados incorreto",
          input_validation_error_type: "Tipo de dados incorreto",
          input_validation_min_field: "Valor deve ser maior/igual ao valor do campo ",
          input_validation_max_field: "Valor deve ser menor/igual ao valor do campo ",
          input_validation_exclude_values: "Valor deverá ser unico",
          integer: "inteiro",
          bigint: "inteiro",
          text: "texto",
          varchar: "texto",
          textarea: "texto",
          string: "string",
          date: "data",
          datetime: "data",
          float: "float",
          table: "tabela"
        },
        footer: {
          "required_fields": "Atributos necessários"
        },
        messages: {
          qgis_input_widget_relation: "Utilize o formulário específico para trabalhar com relações"
        }
      },
      catalog: {
        current_map_theme_prefix: "TEMA",
        choose_map_theme: "ESCOLHA O TEMA",
        choose_map_theme_input_label: 'Nome do novo tema do mapa',
        project_map_theme: 'Tema do Projeto',
        user_map_theme: 'Temas do utilizador',
        question_delete_map_theme: "Pretende eliminar o tema?",
        delete_map_theme: "Tema apagado com sucesso",
        saved_map_theme: "Tema guardado com sucesso",
        updated_map_theme: "Tema alterado com sucesso",
        invalid_map_theme_name: "Nome inválido",
        menu: {
          layerposition: 'Posição da camada',
          setwmsopacity: "Definir transparência",
          wms: {
            title: "",
            copy: "Clique para copiar o endereço",
            copied: "Copiado"
          },
          download: {
            unknow: 'Descarregar',
            geotiff_map_extent: "GeoTiff (vista atual)"
          }
        }
      },
      wps: {
        list_process: "Listar processo",
        tooltip: 'Clique no mapa'
      }
    },
    credits: {
      g3wSuiteFramework: "Aplicativo baseado na framework OS",
      g3wSuiteDescription: "Permite publicar e gerir os seus projetos QGIS na web",
      productOf: "Framework desenvolvida por"
    },
    toggle_color_scheme: "Altere o esquema de cores",
    logout: "Sair",
    no_other_projects: "Não existem mais projetos para este grupo",
    no_other_groups: "Não existem outros Grupos para este Macrogrupo",
    yes: "Sim",
    no: "Não",
    back: "Voltar",
    backto: "Voltar para ",
    changemap: "Alterar mapa",
    change_session: "Alterar Sessão",
    component: "Componente Genérico",
    search: "Pesquisar",
    no_results: "Não foram encontrados resultados",
    print: "Imprimir",
    create_print: "Criar impressão",
    dosearch: "Pesquisar",
    catalog: "Mapa",
    data: "Dados",
    externalwms: "WMS",
    baselayers: "Base",
    tools: "Ferramentas",
    tree: "Camadas",
    legend: "Legenda",
    nobaselayer: "Sem mapa base",
    street_search: "Encontrar endereço",
    show: "Mostrar",
    hide: "Esconder",
    copy_form_data: "Copiar dados",
    paste_form_data: "Colar",
    copy_form_data_from_feature: "Copia dados do mapa",
    error_map_loading: "Ocorreu um erro ao carregar o mapa",
    check_internet_connection_or_server_admin: "Verifique a ligação internet ou contacte o administrador",
    could_not_load_vector_layers: "Erro de ligação: Camadas não podem ser carregadas",
    server_saver_error: "Erro no servidor ao guardar",
    server_error: "Erro de ligação ao servidor",
    save: "Guardar",
    cancel: "Cancelar",
    update: "Atualizar",
    close: "Fechar",
    /** @since 3.8.0 */
    dont_show_again: "Não mostrar novamente",
    enlange_reduce: "Aumentar / Reduzir",
    add: "Adicionar",
    exitnosave: "Sair sem guardar",
    annul: "Cancelar",
    layer_is_added: "Camada com o mesmo nome já adicionada",
    sidebar: {
      wms: {
        panel: {
          title: 'Adicionar Camada WMS',
          label: {
            position: "Posição do Mapa",
            name: "Nome",
            projections: 'Projeção',
            layers: 'Camadas'
          }
        },
        add_wms_layer: "Adicionar camada WMS",
        delete_wms_url: "Remover",
        layer_id_already_added: "Já existe uma ligação WMS com o mesmo nome",
        url_already_added: "Endereço/Nome do WMS já adicionado",
        layer_add_error: "Camada WMS não adicionada. Verifique o parametro do endereço do wms"
      }
    },
    info: {
      title: "Resultados",
      list_of_relations: "Lista de Relações",
      open_link: "Abrir documento anexo",
      server_error: "Ocorreu um erro no servidor",
      no_results: "Não foram encontrados resultados para a consulta/pesquisa",
      link_button: "Abrir"
    },
    mapcontrols: {
      geolocation: {
        error: "Não é possivel obter a sua posição"
      },
      geocoding: {
        choose_layer: "Escolher uma camada para adicionar a entidade",
        placeholder: "Endereço ...",
        nolayers: "Sem camadas de pontos editáveis no projeto",
        noresults: "Sem resultados",
        notresponseserver: "Sem resposta do servidor"
      },
      add_layer_control: {
        header: "Adicionar camada",
        select_projection: "Projeção",
        select_field_to_show: "campo a mostrar no mapa",
        select_csv_separator: "Delimitador",
        select_csv_x_field: "Campo X",
        select_csv_y_field: "Campo Y",
        select_color: "Cor da camada",
        drag_layer: "Adicione o seu ficheiro aqui",
        persistent_data: "Dados persistentes",
        persistent_help: "guardar camada no armazenamento do navegador"
      },
      query: {
        input_relation: "Clique para mostrar as relações"
      },
      length: {
        tooltip: "Comprimento"
      },
      area: {
        tooltip: "Área"
      },
      screenshot: {
        error: "Erro na criação da captura de ecra",
        securityError: "  \n        <p><b>Erro de seguran\xE7a</b>: uma camada externa est\xE1 a impedir a impress\xE3o do mapa. Para verificar proceda da seguinte forma:</p>\n        <ol>\n          <li>remova as camadas externas (ex. camadas WMS)</li>\n          <li>recarregue a p\xE1gina: <code>CTRL + F5</code></li>\n          <li>imprima o mapa de novo</li>\n        </ol>\n        <p>Para mais informa\xE7\xF5es contacte o administrador do sistema: <a href=\"https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_enabled_image\" style=\"color: #000 !important;font-weight: bold;\">&#x2139;&#xFE0F; security and tainted canvases</a></p>\n        "
      }
    },
    catalog_items: {
      helptext: "Abrir o menu",
      contextmenu: {
        zoomtolayer: "Aproximar à Camada",
        open_attribute_table: "Abrir tabela de atributos",
        show_metadata: "Metadados",
        styles: 'Estilos',
        vector_color_menu: "Cor",
        layer_opacity: "Opacidade",
        filters: "Filtros",
        download: 'Guardar como',
        ogc_services: 'Serviços OGC',
        edit: "Editar Camada"
      }
    },
    dataTable: {
      previous: "Anterior",
      next: "Próximo",
      lengthMenu: "Mostrar valores _MENU_ por página",
      info: "_TOTAL_ entradas",
      no_data: "Sem dados",
      nodatafilterd: "Não foram encontrados registos correspondentes",
      infoFiltered: "(filtrados de _MAX_ registos totais)"
    },
    /**@since 3.10.0 */
    no_geometry: 'Elemento sem geometria',
    /**@since 3.11.0 */
    query_filter: 'Filtrar por:',
    /**@since 3.11.0 */
    sidebar_menu: 'Menu barra lateral',
    /**@since 3.11.0 */
    layer_type: 'Tipo de camada',
    /** @since 3.11.0 */
    choose_type: 'Escolha tipo',
    /**@since 3.11.0 */
    remote_wms_url: 'WMS (Endereço)',
    /**@since 3.11.0 */
    local_file: 'Ficheiro Local',
    /**@since 3.11.0 */
    embed_map: 'Incorporar Mapa',
    /** @since 3.11.0 */
    homepage: 'Início',
    /** @since 3.11.0 */
    wms_server: 'Servidor WMS',
    /** @since 3.11.0 */
    connect_to_wms: 'Conectar',
    /** @since 3.11.0 */
    disconnect_from_wms: 'Desconectar',
    /** @since 3.11.0 */
    add_new_wms_url_help: 'procurar nas ligações guardadas ou adicionar um novo servidor',
    /** @since 3.11.0 */
    saved_connections: 'Ligações guardadas:',
    /** @since 3.11.0 */
    label: "Etiqueta",
    /** @since 3.11.0 */
    no_csv_field: 'Nenhum campo válido',
    /** @since 3.11.0 */
    show_more: 'Mostrar mais'
  }
};

},{}],175:[function(require,module,exports){
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  translation: {
    error_page: {
      error: "Eroare de conexiune",
      at_moment: "Momentan nu este posibil să afișați harta",
      f5: "Apăsați Ctrl+F5"
    },
    cookie_law: {
      message: "Acest website foloseste cookie-uri pentru a furniza vizitatorilor o experiență mult mai bună de navigare",
      buttonText: "Am înțeles!"
    },
    default: "Implicit",
    sign_in: "Logare",
    layer_selection_filter: {
      tools: {
        filter: "Activați/Dezactivați filtrul",
        nofilter: "Eliminare Filtrare",
        invert: "Inversare Selecție",
        clear: "Elimină Selecția",
        show_features_on_map: "Rezultatele se actualizează când harta este deplasată",
        savefilter: "Salvează Filtrul",
        filterName: "Nume Filtru"
      }
    },
    warning: {
      not_supported_format: "Formatul nu este acceptat"
    },
    layer_position: {
      top: 'SUS',
      bottom: 'JOS',
      message: "Poziție relativă la straturile din TOC"
    },
    sdk: {
      atlas: {
        template_dialog: {
          title: "Selectați Template"
        }
      },
      spatialbookmarks: {
        title: "Marcaje spațiale",
        helptext: "Deplasați-vă pe întinderea hărții, introduceți numele și faceți clic pe Adăugați",
        input: {
          name: "Nume"
        },
        sections: {
          project: {
            title: "Marcaje de proiect"
          },
          user: {
            title: "Marcaje utilizator"
          }
        }
      },
      search: {
        all: 'Toate',
        no_results: "Fără rezultat",
        searching: "Căutare ...",
        error_loading: "Încărcarea a eșuat",
        layer_not_searchable: "Nu se poate căuta pe strat",
        layer_not_querable: "Stratul nu se poate interoga",
        autocomplete: {
          inputshort: {
            pre: "Te rog introdu",
            post: "sau mai multe caractere"
          }
        },
        help_filter: "Valorile de căutare sunt limitate în funcție de filtrul activ. Eliminați filtrul pentru a căuta toate datele.",
        autofilter: "Filtrați rezultatele"
      },
      print: {
        no_layers: 'Nu avem straturi de print',
        template: "Șablon",
        labels: "Etichete",
        scale: "Scară",
        format: "Format",
        rotation: "Rotație",
        download_image: "Descarcă Imaginea",
        fids_instruction: "Valori acceptate: de la 1 la valoarea [max]. Este posibilă inserarea de interval, de ex. 4-6",
        fids_example: "Ex. 1,4-6 vor fi tipărite id 1,4,5,6",
        help: "Straturile prezentate în print pot fi acelea definite în proiect și nu acelea prezentate în cadrul hărții"
      },
      querybuilder: {
        search: {
          run: "Execută",
          info: "Info",
          delete: "Elimină",
          edit: "Modifică"
        },
        messages: {
          changed: 'Salvat',
          number_of_features: "Număr de entități"
        },
        panel: {
          button: {
            all: 'TOATE',
            save: 'SALVEAZĂ',
            test: 'TEST',
            clear: 'ȘTERGE',
            run: 'RUN',
            manual: 'MANUAL'
          },
          layers: 'STRATURI',
          fields: 'CÂMPURI',
          values: 'VALORI',
          operators: 'OPERATORI',
          expression: 'EXPRESII'
        },
        error_run: 'A survenit o eroare. De verificat interogarea',
        error_test: "A survenit o eroare în timp ce se executa interogarea",
        delete: 'Vrei să o ștergi?',
        additem: 'Introdu numele noii căutări'
      },
      errors: {
        layers: {
          load: "Câteva straturi nu sunt disponibile"
        },
        unsupported_format: 'Formatul nu este acceptat',
        add_external_layer: 'Eroare încărcare strat'
      },
      metadata: {
        title: 'Metadate',
        groups: {
          general: {
            title: 'GENERALITĂȚI',
            fields: {
              title: 'TITLU',
              name: 'NUME',
              description: "DESCRIERE",
              abstract: "ABSTRACT",
              keywords: 'CUVINTE CHEIE',
              fees: "TAXE",
              accessconstraints: "CONSTRÂNGERI DE ACCES",
              contactinformation: "CONTACTE",
              subfields: {
                contactinformation: {
                  contactelectronicmailaddress: "Email",
                  personprimary: 'Referințe',
                  contactvoicetelephone: 'Telefon',
                  contactorganization: 'Organizație',
                  ContactOrganization: 'Organizație',
                  contactposition: 'Poziție',
                  ContactPosition: 'Poziție',
                  contactperson: 'Persoana',
                  ContactPerson: 'Persoana'
                }
              },
              wms_url: "WMS"
            }
          },
          spatial: {
            title: 'SPAȚIAL',
            fields: {
              crs: 'EPSG',
              extent: 'BBOX'
            }
          },
          layers: {
            title: 'STRATURI',
            fields: {
              layers: 'STRATURI',
              subfields: {
                crs: 'EPSG',
                bbox: 'BBOX',
                title: "TITLU",
                name: 'NUME',
                geometrytype: 'GEOMETRIE',
                source: 'SURSA',
                attributes: 'ATRIBUTE',
                abstract: 'ABSTRACT',
                attribution: 'ATRIBUIRE',
                keywords: "CUVINTE CHEIE",
                metadataurl: 'URL METADATE',
                dataurl: "URL DATE"
              }
            },
            groups: {
              general: 'GENERALITĂȚI',
              spatial: 'SPAȚIAL'
            }
          }
        }
      },
      tooltips: {
        relations: {
          form_to_row: "Vizualizare pe rânduri",
          row_to_form: "Vizualizare formular",
          zoomtogeometry: "Măriți la geometrie"
        },
        copy_map_extent_url: 'Copiază linkul de vizualizare hartă',
        download_shapefile: "Descarcă Shapefile",
        download_gpx: "Descarcă GPX",
        download_gpkg: "Descarcă GPKG",
        download_csv: "Descarcă CSV",
        download_xls: "Descarcă XLS",
        download_pdf: "Descarcă PDF",
        show_chart: "Arată Diagrama",
        atlas: "Tipărire Atlas",
        editing: "Editing"
      },
      mapcontrols: {
        query: {
          tooltip: 'Interogare strat',
          actions: {
            add_selection: {
              hint: "Adaugă/Elimină Selecția"
            },
            zoom_to_features_extent: {
              hint: "Zoom la încadrarea entităților"
            },
            add_features_to_results: {
              hint: "Adaugă/Elimină entități rezultat"
            },
            remove_feature_from_results: {
              hint: "Elimină entitate din rezultat"
            },
            zoom_to_feature: {
              hint: "Zoom la entitate"
            },
            relations: {
              hint: "Arată Relațiile"
            },
            relations_charts: {
              hint: "Arată diagrama de relații"
            },
            download_features_shapefile: {
              hint: 'Descarcă entități în Shapefile'
            },
            download_shapefile: {
              hint: 'Descarcă entitate în Shapefile'
            },
            download_features_gpx: {
              hint: "Descarcă entități în GPX"
            },
            download_features_gpkg: {
              hint: "Descarcă entități în GPKG"
            },
            download_gpx: {
              hint: "Descarcă entitate în GPX"
            },
            download_gpkg: {
              hint: "Descarcă entitate în GPKG"
            },
            download_features_csv: {
              hint: "Descarcă entități în CSV"
            },
            download_csv: {
              hint: "Descarcă entitate în CSV"
            },
            download_features_xls: {
              hint: "Descarcă entități în XLS"
            },
            download_xls: {
              hint: "Descarcă entitate în XLS"
            },
            download_pdf: {
              hint: "Descarcă entitate în PDF"
            },
            atlas: {
              hint: "Tipărire Atlas"
            },
            copy_zoom_to_fid_url: {
              hint: "Copiază URL hartă cu întinderea geometriei entității",
              hint_change: "Copiat"
            }
          }
        },
        queryby: {
          title: 'Query area',
          layer: 'Selected layer:',
          none: 'NONE',
          new: 'TEMPORARY LAYER',
          all: 'ALL',
          methods: {
            intersects: 'intersects',
            within: 'within'
          },
          querybypolygon: {
            tooltip: 'select a polygon'
          },
          querybydrawpolygon: {
            tooltip: 'draw a polygon'
          },
          querybbox: {
            tooltip: 'draw a rectangle'
          },
          querybycircle: {
            tooltip: 'draw a circle'
          }
        },
        querybypolygon: {
          download: {
            title: "Descărcare atribute",
            choiches: {
              feature: {
                label: "Doar entități"
              },
              feature_polygon: {
                label: "Entități+Poligon Interogare"
              }
            }
          },
          tooltip: 'Interogare După Poligon',
          no_geometry: 'Nu avem geometrii în răspuns',
          help: {
            message: "<ul><li>Selectează un strat poligon din TOC.</li><li>Asigură-te că stratul este vizibil.</li><li>Click pe o entitate a stratului selectat.</li></ul>"
          }
        },
        querybydrawpolygon: {
          tooltip: "Interogare prin poligon de desen"
        },
        querybbox: {
          tooltip: 'Interogare BBox strat',
          nolayers_visible: 'Nu este vizibil niciun strat de interogare. Trebuie setat cel puțin un strat WFS vizibil pentru a efectua interogarea',
          help: {
            message: "<ul><li>Desenează un pătrat pe hartă pentru a interoga straturile din TOC de sub </li></ul>"
          }
        },
        querybycircle: {
          tooltip: "Query by Draw Circle ",
          label: 'Radius',
          help: {
            message: "<ul><li>Click on map to draw circle</li></ul>"
          }
        },
        addlayer: {
          messages: {
            csv: {
              warning: "Rezultateul pe hartă este parțial datorită prezenței următoarei liste de rezultate incorecte:"
            }
          },
          tooltip: 'Adaugă Strat'
        },
        geolocation: {
          tooltip: 'Geolocalizare'
        },
        measures: {
          length: {
            tooltip: "Lungime",
            help: "Click pe hartă pentru a desena linia. Apasă <br>CANC dacă dorești să ștergi ultimul vertex"
          },
          area: {
            tooltip: "Aria",
            help: "Click pentru desen poligon. Apasă <br>CANC dacă dorești să ștergi ultimul vertex"
          }
        },
        scale: {
          no_valid_scale: "Scară Invalidă"
        },
        scaleline: {
          units: {
            metric: 'Metri',
            nautical: 'Mile Nautice'
          }
        },
        zoomhistory: {
          zoom_last: "Zoom Anterior",
          zoom_next: "Zoom Urmatorul"
        }
      },
      relations: {
        relation_data: 'Date Relații',
        no_relations_found: 'Nu am găsit nicio relație',
        back_to_relations: 'Înapoi la relații',
        list_of_relations_feature: 'Lista de relații a entității',
        error_missing_father_field: "Câmpul de legătură lipsește",
        field: "Relation key field"
      },
      form: {
        loading: 'Se încarcă ...',
        inputs: {
          messages: {
            errors: {
              picklayer: "Nu avem entitate selectată. Verifică dacă stratul este în editare sau vizibil la scara curentă if layer is on editing or visible at current scale"
            }
          },
          tooltips: {
            picklayer: "Ia valoare din strat",
            lonlat: "Click pe hartă pentru a prelua coordonate"
          },
          input_validation_mutually_exclusive: "Câmp ce se exclude mutual cu ",
          input_validation_error: "Câmp mandatoriu sau tip de date greșit",
          input_validation_error_type: "Tip de date greșit",
          input_validation_min_field: "Valoarea trebuie să fie mai mare/egală cu valoare câmpului ",
          input_validation_max_field: "Valoarea trebuie să fie mai mică/egală cu valoare câmpului ",
          input_validation_exclude_values: "Valoarea trebuie să fie unică",
          integer: "integer - nr. întreg",
          bigint: "integer - nr. întreg",
          text: "text",
          varchar: "text",
          textarea: "text",
          string: "string - text",
          date: "data",
          datetime: "data",
          float: "float - nr. cu zecimale",
          table: "tabelă"
        },
        footer: {
          "required_fields": "Câmpuri necesare"
        },
        messages: {
          qgis_input_widget_relation: "Folosește formular specific de relații pentru a lucra cu relația"
        }
      },
      catalog: {
        current_map_theme_prefix: "TEMA",
        choose_map_theme: "ALEGE TEMA",
        choose_map_theme_input_label: 'Numele noii tema',
        project_map_theme: 'Tema de proiect',
        user_map_theme: "Tema utilizator",
        question_delete_map_theme: "Doriți să ștergeți tema?",
        delete_map_theme: "Tema a fost ștearsă cu succes",
        saved_map_theme: "Tema a fost salvată cu succes",
        updated_map_theme: "Tema a fost actualizată cu succes",
        invalid_map_theme_name: "Numele există deja sau este incorect",
        menu: {
          layerposition: 'Poziție Strat',
          setwmsopacity: "Alege Opacitatea",
          wms: {
            title: "Titlu",
            copy: "Click pentru copiere URL",
            copied: "Copiat"
          },
          download: {
            unknow: 'Descarcă',
            shp: 'Descarcă Shapefile',
            gpx: 'Descarcă GPX',
            gpkg: 'Descarcă GPKG',
            csv: 'Descarcă CSV',
            xls: 'Descarcă XLS',
            geotiff: "Descarcă GEOTIFF",
            geotiff_map_extent: "Descarcă GEOTIFF(ce se vede în cadrul hărții)"
          }
        }
      },
      wps: {
        list_process: "Lista de procese",
        tooltip: 'Click pe hartă'
      }
    },
    credits: {
      g3wSuiteFramework: "Aplicație bazată pe frameworkul",
      g3wSuiteDescription: "Publică și administrează proiectele de QGIS pe WEB",
      productOf: "Framework dezvoltat de"
    },
    toggle_color_scheme: "Comutare schemă de culori",
    logout: "Deconectare",
    no_other_projects: "No more project for this group",
    no_other_groups: "Nu mai sunt grupuri pentru acest macrogrup",
    yes: "Da",
    no: "Nu",
    back: "Înapoi",
    backto: "Înapoi la ",
    changemap: "Schimbare Hartă",
    change_session: "Schimbați sesiunea",
    component: "Componentă Generică",
    search: "Căutare",
    no_results: "Niciun rezultat găsit",
    print: "Tipărire",
    create_print: "Tipărește",
    dosearch: "Caută",
    catalog: "Hartă",
    data: "Data",
    externalwms: "WMS",
    baselayers: "Straturi Bază",
    tools: "Instrumente",
    tree: "Straturi",
    legend: "Legendă",
    nobaselayer: "Fără strat de bază",
    street_search: "Caută Adresă",
    show: "Arată",
    hide: "Ascunde",
    copy_form_data: "Copiază data",
    paste_form_data: "Lipește",
    copy_form_data_from_feature: "Copiază data din hartă",
    error_map_loading: "Sunt erori la încărcarea hărții",
    check_internet_connection_or_server_admin: "Verificați conexiune de internet sau contactați administratorul de sistem",
    could_not_load_vector_layers: "Eroare de conexiune: Straturile nu pot fi încărcate",
    server_saver_error: "Eroare la salvarea pe server",
    server_error: "Eroare de conexiune la server",
    save: "Salvează",
    cancel: "Anulează",
    update: "Actualizați",
    close: "Închide",
    /** @since 3.8.0 */
    dont_show_again: "Nu mai afișa mesajul",
    enlange_reduce: "Mărește / Micșorează",
    add: "Adaugă",
    exitnosave: "Ieșire fără salvare",
    annul: "Anulează",
    layer_is_added: "Există un strat cu același nume deja adăugat",
    sidebar: {
      wms: {
        panel: {
          title: 'Adaugă strat WMS',
          label: {
            position: "Poziție Hartă",
            name: "Nume",
            projections: 'Proiecție',
            layers: 'Straturi'
          }
        },
        add_wms_layer: "Adaugă strat WMS",
        delete_wms_url: "Șterge URL WMS",
        layer_id_already_added: "Strat WMS deja adăugat",
        url_already_added: "URL WMS/Nume deja adăugat",
        layer_add_error: "Stratul WMS nu s-a adăugat. Verificați URL-ul sau parametrii WMS"
      }
    },
    info: {
      title: "Rezultate",
      list_of_relations: "List of Relations",
      open_link: "Deschide document atașat",
      server_error: "Serverul a întâmpinat o eroare",
      no_results: "Niciun rezultat",
      link_button: "Deschide"
    },
    mapcontrols: {
      geolocation: {
        error: "Nu te-am putut localiza"
      },
      geocoding: {
        choose_layer: "Alegeți un strat unde să adăugați această caracteristică",
        placeholder: "Adresa ...",
        nolayers: "Nu s-au găsit straturi de puncte editabile în acest proiect",
        noresults: "Niciun rezultat",
        notresponseserver: "Niciun răspuns de la server"
      },
      add_layer_control: {
        header: "Adăugare Strat",
        select_projection: "Selectează proiecția strat",
        select_field_to_show: "Selectează câmpul de arătat pe hartă",
        select_csv_separator: "Selectează delimitatorul",
        select_csv_x_field: "Selectează câmpul X - Est",
        select_csv_y_field: "Selectează câmpul Y - Nord",
        select_color: "Selectează culoare strat",
        drag_layer: "Trageți stratul aici (Drag&Drop)"
      },
      query: {
        input_relation: "Click pentru a arăta relațiile"
      },
      length: {
        tooltip: "Lungime"
      },
      area: {
        tooltip: "Arie"
      },
      screenshot: {
        error: "Eroare captură ecran",
        securityError: "  \n        <p><b>Eroare de securitate</b>: un strat extern \xEEmpiedic\u0103 imprimarea h\u0103r\u021Bii. Pentru a verifica, proceda\u021Bi dup\u0103 cum urmeaz\u0103:</p>\n        <ol>\n          <li>elimina\u021Bi orice straturi externe ad\u0103ugate manual (de exemplu, straturi WMS)</li>\n          <li>for\u021Ba\u021Bi re\xEEnc\u0103rcarea paginii: <code>CTRL + F5</code></li>\n          <li>tip\u0103re\u0219te din nou harta</li>\n        </ol>\n        <p>Pentru mai multe informa\u021Bii, v\u0103 rug\u0103m s\u0103 contacta\u021Bi administratorul serverului despre: <a href=\"https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_enabled_image\" style=\"color: #000 !important;font -greutate: bold;\">&#x2139;&#xFE0F; securitate \u0219i p\xE2nze contaminate</a></p>\n        "
      }
    },
    catalog_items: {
      helptext: "Click dreapta pe strat pentru a accesa opțiuni",
      contextmenu: {
        zoomtolayer: "Zoom pe Strat",
        open_attribute_table: "Deschide Tabela Atribute",
        show_metadata: "Metadate",
        styles: 'Stiluri',
        vector_color_menu: "Setează/Schimbă Culoare",
        layer_opacity: "Opacitate",
        filters: "Filters"
      }
    },
    dataTable: {
      previous: "Anteriorul",
      next: "Următorul",
      lengthMenu: "Afișați _MENU_ valori pe pagină",
      info: "_TOTAL_ rezultate",
      no_data: "Fără date",
      nodatafilterd: "Niciun rezultat",
      infoFiltered: "(filtrat din _MAX_ de rezultate totale)"
    }
  }
};

},{}],176:[function(require,module,exports){
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  translation: {
    error_page: {
      error: "Anslutningsfel",
      at_moment: "För närvarande är det inte möjligt att visa kartan",
      f5: "Tryck på Ctrl+F5"
    },
    cookie_law: {
      message: "Denna applikation använder cookies för att den ska fungera så bra som möjligt för dig.",
      buttonText: "Jag accepterar"
    },
    default: "standard",
    sign_in: "Logga in",
    layer_selection_filter: {
      tools: {
        filter: "Aktivera/inaktivera filter",
        nofilter: "Avlägsna Filtrera",
        invert: "Invertera Urval",
        clear: "Annullera Urval",
        show_features_on_map: "Rezultatele se actualizează când harta este deplasată",
        savefilter: "Spara Filter",
        filterName: "Filternamn"
      }
    },
    warning: {
      not_supported_format: "Formatet stöds inte"
    },
    layer_position: {
      top: 'Överst',
      bottom: 'Underst',
      message: "Position relativt till lager i lagerlistan"
    },
    sdk: {
      atlas: {
        template_dialog: {
          title: "Välj Template"
        }
      },
      spatialbookmarks: {
        title: "Rumsliga bokmärken",
        helptext: "Flytta på kartans omfattning, ange namn och klicka på Lägg till",
        input: {
          name: "Namn"
        },
        sections: {
          project: {
            title: "Projektbokmärken"
          },
          user: {
            title: "Användarbokmärken"
          }
        }
      },
      search: {
        all: 'ALLA',
        no_results: "Inga resultat",
        searching: "Sökning ...",
        error_loading: "Fel vid laddning av uppgifter.",
        layer_not_searchable: "Nivån kan inte sökas.",
        layer_not_querable: "Förfrågningar kan inte göras på nivån.",
        autocomplete: {
          inputshort: {
            pre: "Mata in",
            post: "eller flera tecken"
          }
        },
        help_filter: "Sökvärdena är begränsade baserat på det aktiva filtret. Ta bort filtret för att söka på all data.",
        autofilter: "Filtrera resultaten"
      },
      print: {
        no_layers: 'Inga nivåer att skriva ut',
        template: "Template",
        labels: "Labels",
        scale: "Skala",
        format: "Format",
        rotation: "Rotation",
        download_image: "Ladda ner bild",
        fids_instruction: "Godkända värden: Från ett till värdet [max]. Mellanslag tillåts, t.ex. 4-6.",
        fids_example: "Exempelvis 1,4-6 skriver ut id 1,4,5,6.",
        help: "Nivåerna på utskriften kan vara specificerade i ett projekt inte sådana som visas på karta."
      },
      querybuilder: {
        search: {
          run: "Utför",
          info: "Information",
          delete: "Ta bort",
          edit: "Redigera"
        },
        messages: {
          changed: 'Sparat',
          number_of_features: "Antal funktione"
        },
        panel: {
          button: {
            all: 'ALLA',
            save: 'SPARA',
            test: 'TEST',
            clear: 'TÖM',
            run: 'UTFÖR',
            manual: 'MANUELL'
          },
          layers: 'NIVÅER',
          fields: 'FÄLT',
          values: 'VÄRDEN',
          operators: 'OPERATÖRER',
          expression: 'KLAUSUL'
        },
        error_run: 'Ett fel inträffade. Kontrollera förfrågan.',
        error_test: "Ett fel inträffade när förfrågan utfördes.",
        delete: 'Vill du ta bort den?',
        additem: 'Ge den nya sökningen ett namn.'
      },
      errors: {
        layers: {
          load: "Vissa nivåer är inte tillgängliga."
        },
        unsupported_format: 'Formatet stöds inte',
        add_external_layer: 'Fel vid laddning av nivån'
      },
      metadata: {
        title: 'Metadata',
        groups: {
          general: {
            title: 'ALLMÄN',
            fields: {
              title: 'RUBRIK',
              name: 'NAMN',
              description: "BESKRIVNING",
              abstract: "SAMMANDRAG",
              keywords: 'NYCKELORD',
              fees: "AVGIFTER",
              accessconstraints: "ÅTKOMSTBEGRÄNSNINGAR",
              contactinformation: "KONTAKTUPPGIFTER",
              subfields: {
                contactinformation: {
                  contactelectronicmailaddress: "E-post",
                  personprimary: 'Referenser',
                  contactvoicetelephone: 'Telefon',
                  contactorganization: 'Organisation',
                  ContactOrganization: 'Organisation',
                  contactposition: 'Ställning',
                  ContactPosition: 'Ställning',
                  contactperson: 'Kontaktperson',
                  ContactPerson: 'Kontaktperson'
                }
              },
              wms_url: "WMS"
            }
          },
          spatial: {
            title: 'SPATIAL',
            fields: {
              crs: 'EPSG',
              extent: 'BBOX'
            }
          },
          layers: {
            title: 'NIVÅER',
            fields: {
              layers: 'NIVÅER',
              subfields: {
                crs: 'EPSG',
                bbox: 'BBOX',
                title: "RUBRIK",
                name: 'NAMN',
                geometrytype: 'GEOMETRI',
                source: 'KÄLLA',
                attributes: 'ATTRIBUT',
                abstract: 'SAMMANDRAG',
                attribution: 'TILLSKRIVNING',
                keywords: "NYCKELORD",
                metadataurl: 'METADATA URL',
                dataurl: "DATA URL"
              }
            },
            groups: {
              general: 'ALLMÄN',
              spatial: 'SPATIAL'
            }
          }
        }
      },
      tooltips: {
        relations: {
          form_to_row: "Radvy",
          row_to_form: "Tabellvy",
          zoomtogeometry: "Zooma till geometri"
        },
        copy_map_extent_url: 'Kopiera länk till karta',
        download_shapefile: "Ladda SHP-fil",
        download_gpx: "Ladda GPX-fil",
        download_gpkg: "Ladda GPKG-fil",
        download_csv: "Ladda CSV-fil",
        download_xls: "Ladda XLS-fil",
        download_pdf: "Ladda PDF-fil",
        show_chart: "Visa diagram", //Tero 9.12.2020
        atlas: "Skriv ut Atlas",
        editing: "Editing"
      },
      mapcontrols: {
        query: {
          tooltip: 'Förfrågningsnivå',
          actions: {
            add_selection: {
              hint: "Lägg till/Avlägsna Urval"
            },
            zoom_to_features_extent: {
              hint: "Zooma till egenskapens omfattning"
            },
            add_features_to_results: {
              hint: "Add/Remove features to results"
            },
            remove_feature_from_results: {
              hint: "Remove feature from results"
            },
            zoom_to_feature: {
              hint: "Zooma till egenskapen"
            },
            relations: {
              hint: "Visa relationerna"
            },
            relations_charts: {
              hint: "Visa relationsdiagrammet" //Tero 9.12.2020
            },
            download_features_shapefile: {
              hint: 'Ladda egenskapens SHP-fil'
            },
            download_shapefile: {
              hint: 'Ladda egenskapens SHP-fil'
            },
            download_features_gpx: {
              hint: "Ladda egenskapens GPX-fil"
            },
            download_features_gpkg: {
              hint: "Ladda egenskapens GPKG-fil"
            },
            download_gpx: {
              hint: "Ladda egenskapens GPX-fil"
            },
            download_gpkg: {
              hint: "Ladda egenskapens GPKG-fil"
            },
            download_features_csv: {
              hint: "Ladda egenskapens CSV-fil"
            },
            download_csv: {
              hint: "Ladda egenskapens CSV-fil"
            },
            download_features_xls: {
              hint: "Ladda egenskapens XLS-fil"
            },
            download_xls: {
              hint: "Ladda egenskapens XLS-fil"
            },
            download_pdf: {
              hint: "Ladda egenskapens PDF-fil"
            },
            atlas: {
              hint: "Skriv ut Atlas"
            },
            copy_zoom_to_fid_url: {
              hint: "Copy map URL with this geometry feature extension",
              hint_change: "Copied"
            }
          }
        },
        queryby: {
          title: 'Query area',
          layer: 'Selected layer:',
          none: 'NONE',
          new: 'TEMPORARY LAYER',
          all: 'ALL',
          methods: {
            intersects: 'intersects',
            within: 'within'
          },
          querybypolygon: {
            tooltip: 'select a polygon'
          },
          querybydrawpolygon: {
            tooltip: 'draw a polygon'
          },
          querybbox: {
            tooltip: 'draw a rectangle'
          },
          querybycircle: {
            tooltip: 'draw a circle'
          }
        },
        querybypolygon: {
          download: {
            title: "Attributes download",
            choiches: {
              feature: {
                label: "Features only"
              },
              feature_polygon: {
                label: "Features+Query Polygon"
              }
            }
          },
          tooltip: 'Förfrågan med polygon',
          no_geometry: 'No geometry on response',
          help: {
            message: "<ul><li>Välj polygonnivå i listan.</li><li>Kontrollera att nivån är synlig.</li><li>Välj egenskap på önskad nivå.</li></ul>"
          }
        },
        querybydrawpolygon: {
          tooltip: "Fråga efter ritpolygon"
        },
        querybbox: {
          tooltip: 'BBox-förfrågan som riktar sig till en nivå',
          nolayers_visible: 'Inga nivåer som förfrågningar kan riktas till. Gör minst en WFS-nivå synlig för att kunna utföra sökningen.',
          help: {
            message: "<ul><li>Rita upp en rektangel på kartan för att utföra förfrågan på de i listan understreckade nivåerna.</li></ul>"
          }
        },
        querybycircle: {
          tooltip: "Query by Draw Circle ",
          label: 'Radius',
          help: {
            message: "<ul><li>Click on map to draw circle</li></ul>"
          }
        },
        addlayer: {
          messages: {
            csv: {
              warning: "The result in the map is partial due to the presence of the below incorrect records list:"
            }
          },
          tooltip: 'Lägg till nivå'
        },
        geolocation: {
          tooltip: 'Geografiskt läge'
        },
        measures: {
          length: {
            tooltip: "Längd",
            help: "Rita upp en bruten linje på kartan. Tryck <br>CANC, om du vill ta bort föregående punkt."
          },
          area: {
            tooltip: "Område",
            help: "Rita upp en polygon på kartan. Tryck <br>CANC, om du vill ta bort föregående punkt."
          }
        },
        scale: {
          no_valid_scale: "Fel skala"
        },
        scaleline: {
          units: {
            metric: 'Meters',
            nautical: 'Nautical Mile'
          }
        },
        zoomhistory: {
          zoom_last: "Zoom Föregående",
          zoom_next: "Zoom Nästa"
        }
      },
      relations: {
        relation_data: 'Relationsuppgifter',
        no_relations_found: 'Inga relationer hittades.',
        back_to_relations: 'Tillbaka till relationerna',
        list_of_relations_feature: 'Lista på egenskapens relationer',
        error_missing_father_field: "Fält saknas",
        field: "Relation key field"
      },
      form: {
        loading: 'Laddning...',
        inputs: {
          messages: {
            errors: {
              picklayer: "Inga egenskaper har valts. Kontroller att nivån kan redigeras eller att den syns med nuvarande skala."
            }
          },
          tooltips: {
            picklayer: "Välj värde på kartnivå",
            lonlat: "Click on map to get coordinates"
          },
          input_validation_mutually_exclusive: "Fälten utesluter varandra.",
          input_validation_error: "Obligatoriskt fält eller fel datatyp.",
          input_validation_error_type: "Fel datatyp.",
          input_validation_min_field: "Värdet ska vara större eller lika stort som värdet i fältet.",
          input_validation_max_field: "Värdet ska vara mindre eller lika stort som värdet i fältet.",
          input_validation_exclude_values: "Värdet ska vara unikt.",
          integer: "heltal",
          bigint: "heltal",
          text: "text",
          varchar: "text",
          textarea: "text",
          string: "teckensträng",
          date: "datum",
          datetime: "datum",
          float: "flyttal",
          table: "tabell"
        },
        footer: {
          "required_fields": "Obligatoriska fält"
        },
        messages: {
          qgis_input_widget_relation: "Använd den specifika funktinen för att bestämma relationer"
        }
      },
      catalog: {
        current_map_theme_prefix: "THEME",
        choose_map_theme: "CHOOSE THEME",
        choose_map_theme_input_label: 'Namn på det nya temat',
        project_map_theme: 'Temat de proiect',
        user_map_theme: "Temat utilizator",
        question_delete_map_theme: "Vill du ta bort temat?",
        delete_map_theme: "Temat har tagits bort",
        saved_map_theme: "Temat har sparats",
        updated_map_theme: "Temat har uppdaterats",
        invalid_map_theme_name: "Namnet finns redan eller är felaktigt",
        menu: {
          layerposition: 'Lagerposition',
          setwmsopacity: "Ställ in Opacitet",
          wms: {
            title: "",
            copy: "Tryck här för att kopiera url.",
            copied: "Kopierad."
          },
          download: {
            unknow: 'Ladda',
            shp: 'Ladda SHP-fil',
            gpx: 'Ladda GPX-fil',
            gpkg: 'Ladda GPKG-fil',
            csv: 'Ladda CSV-fil',
            xls: 'Ladda XLS-fil',
            geotiff: 'Ladda GEOTIFF-fil',
            geotiff_map_extent: "Ladda GEOTIFF-fil(current view extent)"
          }
        }
      },
      wps: {
        list_process: "Lista på processer",
        tooltip: 'Välj på kartan'
      }
    },
    credits: {
      g3wSuiteFramework: "Tillämpningen baserar på OS framework",
      g3wSuiteDescription: "Publicera och hantera QGIS-projekt på nätet.",
      productOf: "Framework har utvecklats av"
    },
    toggle_color_scheme: "Toggle color scheme",
    logout: "Logga ut",
    no_other_projects: "Inga projekt för denna grupp",
    no_other_groups: "Inga fler grupper för denna makrogrupp",
    yes: "Ja",
    no: "Nej",
    back: "Gå tillbaka",
    backto: "Tillbaka ",
    changemap: "Byt karta",
    change_session: "Ändra session",
    component: "Allmän komponent",
    search: "Sök",
    no_results: "Inga sökresultat",
    print: "Skriv ut",
    create_print: "Skapa utskrift",
    dosearch: "Sök",
    catalog: "Karta",
    data: "Data",
    externalwms: "WMS",
    baselayers: "Bakgrundskarta",
    tools: "Verktyg",
    tree: "Nivåer",
    legend: "Förklaring till beteckningarna",
    nobaselayer: "Ingen bakgrundskarta",
    street_search: "Sök adress",
    show: "Visa",
    hide: "Dölj",
    copy_form_data: "Kopiera uppgifterna",
    paste_form_data: "Infoga",
    copy_form_data_from_feature: "Kopiera uppgifter från kartan",
    error_map_loading: "Fel vid laddning av kartan",
    check_internet_connection_or_server_admin: "Kontrollera internetanslutningen eller kontakta administratören.",
    could_not_load_vector_layers: "Fel i anslutningen, nivåer kan inte laddas.",
    server_saver_error: "Fel vid lagring på servern.",
    server_error: "Fel på anslutningen till servern",
    save: "Spara",
    cancel: "Ånga",
    update: "Uppdatering",
    close: "Stäng",
    /** @since 3.8.0 */
    dont_show_again: "Visa inte det här meddelandet igen",
    enlange_reduce: "Förstora / Förminska",
    add: "Lägg till",
    exitnosave: "Lämna programmet utan att spara",
    annul: "Ångra",
    layer_is_added: "Lagret med samma namn har redan lagts till.",
    sidebar: {
      wms: {
        panel: {
          title: 'Add WMS Layer',
          label: {
            position: "Map Position",
            name: "Name",
            projections: 'Projection',
            layers: 'Layers'
          }
        },
        add_wms_layer: "Aggiungi WMS layer",
        delete_wms_url: "Delete WMS url",
        layer_id_already_added: "WMS Nivån har redan lagts till.",
        url_already_added: "WMS URL/Namn har redan lagts till.",
        layer_add_error: "WMS Layer not added. Please check all wms parameter or url"
      }
    },
    info: {
      title: "Resultat",
      list_of_relations: "List of Relations",
      open_link: "Öppna filbilaga",
      server_error: "Ett fel uppstod på servern.",
      no_results: "Inga resultat för sökningen/förfrågan.",
      link_button: "Öppna"
    },
    mapcontrols: {
      geolocation: {
        error: "Du kan inte lokaliseras"
      },
      geocoding: {
        choose_layer: "Välj ett lager där du vill lägga till denna funktion",
        placeholder: "Adress ...",
        nolayers: "Inga redigerbara punktlager hittades i det här projektet",
        noresults: "Inga resultat",
        notresponseserver: "Inget svar från servern"
      },
      add_layer_control: {
        header: "Lägg till nivå",
        select_projection: "Välj projektion för nivån",
        select_field_to_show: "Select Field to show on map",
        select_csv_separator: "Select delimiter",
        select_csv_x_field: "Select X field",
        select_csv_y_field: "Select Y field",
        select_color: "Välj färg på nivån",
        drag_layer: "Dra och släpp nivån hit"
      },
      query: {
        input_relation: "Tryck för att visa relationerna"
      },
      length: {
        tooltip: "Längd"
      },
      area: {
        tooltip: "Areal"
      },
      screenshot: {
        error: "Screenshot error creation",
        securityError: "  \n        <p><b>S\xE4kerhetsfel</b>: ett externt lager hindrar kartan fr\xE5n att skrivas ut. G\xF6r s\xE5 h\xE4r f\xF6r att kontrollera:</p>\n        <ol>\n          <li>ta bort alla manuellt tillagda externa lager (t.ex. WMS-lager)</li>\n          <li>tvinga om inl\xE4sning av sidan: <code>CTRL + F5</code></li>\n          <li>skriv ut kartan igen</li>\n        </ol>\n        <p>F\xF6r mer information kontakta serveradministrat\xF6ren om: <a href=\"https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_enabled_image\" style=\"color: #000 !important;font -vikt: fet;\">&#x2139;&#xFE0F; s\xE4kerhet och nedsmutsade dukar</a></p>\n        "
      }
    },
    catalog_items: {
      helptext: "Högerklicka på en enskild nivå för att komma till tilläggsegenskaperna.",
      contextmenu: {
        zoomtolayer: "Zooma till nivå",
        open_attribute_table: "Öppna attributtabellen",
        show_metadata: "Metadata",
        styles: "Stilar",
        vector_color_menu: "Ställ in/ändra färg",
        layer_opacity: "Opacitet",
        filters: "Filters"
      }
    },
    dataTable: {
      previous: "Föregående",
      next: "Nästa",
      lengthMenu: "Visa _MENU_ värden per sida",
      info: "_TOTAL_ resultat",
      no_data: "Inga uppgifter",
      nodatafilterd: "Inga motsvarande poster hittades",
      infoFiltered: "(filtered from _MAX_ total records)"
    }
  }
};

},{}],177:[function(require,module,exports){
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GeolocationControl = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _gui = require('services/gui');

var _gui2 = _interopRequireDefault(_gui);

var _interactioncontrol = require('map/controls/interactioncontrol');

var _interactioncontrol2 = _interopRequireDefault(_interactioncontrol);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @file ORIGINAL SOURCE: src/app/g3w-ol/controls/geolocationcontrol.js@v3.10.2
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @since 3.11.0
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

var GeolocationControl = exports.GeolocationControl = function (_InteractionControl) {
  _inherits(GeolocationControl, _InteractionControl);

  function GeolocationControl() {
    _classCallCheck(this, GeolocationControl);

    /**
     * @type { ol.layer.Vector }
     */
    var _this = _possibleConstructorReturn(this, (GeolocationControl.__proto__ || Object.getPrototypeOf(GeolocationControl)).call(this, {
      visible: true,
      offline: false,
      enabled: true, // set initial to false. Is set enabled if is autorized
      name: "geolocation",
      tipLabel: "sdk.mapcontrols.geolocation.tooltip",
      label: '\uE904'
    }));

    _this._layer = new ol.layer.Vector({
      source: new ol.source.Vector(),
      style: new ol.style.Style({
        text: new ol.style.Text({
          text: '\uF3C5',
          font: '900 3em "Font Awesome 5 Free"',
          fill: new ol.style.Fill({ color: 'red' }),
          offsetY: -15 // move marker icon on base point coordinate and not center
        })
      })
    });

    /**
     * @type { ol.Geolocation }
     */
    _this._geolocation = new ol.Geolocation({
      trackingOptions: { enableHighAccuracy: true }
    });

    _this.on('controlclick', function (e) {
      if (_this._geolocation.getTracking()) {
        _this._geolocation.setTracking(false);
      } else {
        _this.geolocate();
      }
    });

    return _this;
  }

  /**
   * Add marker position layer and feature point always on top of map
   * 
   * @param {{ map: ol.Map, coordinates: ol.coordinate, show?: boolean }}
   */


  _createClass(GeolocationControl, [{
    key: '_showMarker',
    value: function _showMarker(_ref) {
      var map = _ref.map,
          coordinates = _ref.coordinates,
          _ref$show = _ref.show,
          show = _ref$show === undefined ? true : _ref$show;


      if (!this._layer) {
        return;
      }

      // reset layer
      this._layer.getSource().clear();

      if (show) {
        map.getView().setCenter(coordinates);
        this._layer.getSource().addFeature(new ol.Feature({ geometry: new ol.geom.Point(coordinates) }));
        map.addLayer(this._layer);
      } else {
        map.removeLayer(this._layer);
      }
    }

    /**
     * @since 3.10.0
     */

  }, {
    key: 'geolocate',
    value: function geolocate() {
      var _this2 = this;

      var map = this.getMap();

      if (!map) {
        return;
      }

      var toggledKeyEvent = void 0; // key toggled event handler

      this._geolocation.on('change:position', function () {
        var coordinates = _this2._geolocation.getPosition();
        if (coordinates) {
          toggledKeyEvent = _this2.on('toggled', function () {
            _this2._showMarker({ map: map, coordinates: _this2._geolocation.getPosition(), show: _this2.isToggled() });
          });
          $(_this2.element).removeClass('g3w-ol-disabled');
          _this2._showMarker({ map: map, coordinates: coordinates, show: _this2.isToggled() });
        }
      });

      this._geolocation.on('error', function (e) {

        _this2._layer = null;

        _gui2.default.showUserMessage({
          type: 'warning',
          title: "mapcontrols.geolocation.error",
          message: e.message,
          autoclose: false
        });

        _this2.toggle(false);

        ol.Observable.unByKey(toggledKeyEvent);

        toggledKeyEvent = null;
      });

      this._geolocation.setProjection(map.getView().getProjection());
      this._geolocation.setTracking(true);
    }
  }]);

  return GeolocationControl;
}(_interactioncontrol2.default);

},{"map/controls/interactioncontrol":178,"services/gui":207}],178:[function(require,module,exports){
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _g3wConstants = require('g3w-constants');

var _gui = require('services/gui');

var _gui2 = _interopRequireDefault(_gui);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @file 
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @since 3.11.0
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

/**
 * ORIGINAL SOURCE: src/app/g3w-ol/controls/interactioncontrol.js@v3.10.2
 */
var InteractionControl = function (_ol$control$Control) {
  _inherits(InteractionControl, _ol$control$Control);

  /**
   * @param {Object}  options 
   * @param {string}  options.name
   * @param {boolean} options.enabled 
   */
  function InteractionControl() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, InteractionControl);

    // wrapper for native ol controls
    if (options.ol) {
      var _ret;

      var _this = _possibleConstructorReturn(this, (InteractionControl.__proto__ || Object.getPrototypeOf(InteractionControl)).call(this, { element: options.ol.element }));

      _this._options = options;
      _this._control = options.ol;
      _this.positionCode = options.position || 'tl';
      _this.offline = true;
      $(_this._control.element).addClass("ol-control-" + _this.positionCode);
      return _ret = _this, _possibleConstructorReturn(_this, _ret);
    }

    /** @TODO simplify */
    options.enabled = undefined === options.enabled ? !!options.interactionClass : options.enabled;

    options.visible = undefined === options.visible ? true : options.visible;

    var name = (options.name || '').split(' ').join('-').toLowerCase();

    /** ORIGINAL SOURCE: src/components/MapControlButton.js@v3.10.0 */
    if (!options.element) {
      options.element = new (Vue.extend({
        template: /* html */'<div class="ol-' + name + ' ol-unselectable ol-control">\n          <button type="button" v-t-tooltip="\'' + (options.tipLabel || name) + '\'">\n            ' + (options.label || '') + (options.customClass ? '<i class="' + options.customClass + '"></i>' : '') + '\n          </button>\n        </div>'
      }))().$mount().$el;
    }

    var _this = _possibleConstructorReturn(this, (InteractionControl.__proto__ || Object.getPrototypeOf(InteractionControl)).call(this, options));

    _this._options = options;

    //@since v3.11.0
    _this.cursorClass = options.cursorClass;

    /**
     * ORIGINAL SOURCE: src/app/g3w-ol/controls/onclickcontrol.js@v3.10.0
     */
    _this._originalonlick = null;

    /**
     * ORIGINAL SOURCE: src/app/g3w-ol/controls/control.js@v3.10.0
     *
     * custom "onclick" handler
     */
    _this._onclick = options.onclick; // a method trigger when click on map control button

    /**
     * ORIGINAL SOURCE: src/app/g3w-ol/controls/control.js@v3.10.0
     *
     * @FIXME add description
     */
    _this._enabled = options.enabled;

    /**
     * ORIGINAL SOURCE: src/app/g3w-ol/controls/control.js@v3.10.0
     *
     * @FIXME add description
     */
    _this.offline = undefined === options.offline ? true : options.offline;

    /**
     * ORIGINAL SOURCE: src/app/g3w-ol/controls/control.js@v3.10.0
     *
     * @FIXME add description
     */
    _this.name = name;

    /**
     * ORIGINAL SOURCE: src/app/g3w-ol/controls/control.js@v3.10.0
     *
     * @FIXME add description
     */
    _this.id = _this.name + '_' + Math.floor(Math.random() * 1000000);

    /**
     * ORIGINAL SOURCE: src/app/g3w-ol/controls/control.js@v3.10.0
     *
     * store eventKey and original havenHandler
     */
    _this.eventKeys = {};

    /**
     * ORIGINAL SOURCE: src/app/g3w-ol/controls/control.js@v3.10.0
     *
     * tl: top-left
     * tr: top-right
     * bl: bottom-left
     * bt: bottom-right
     */
    _this.positionCode = options.position || 'tl';

    /**
     * ORIGINAL SOURCE: src/app/g3w-ol/controls/control.js@v3.10.0
     *
     * @FIXME add description
     */
    _this.priority = options.priority || 0;

    /**
     * ORIGINAL SOURCE: src/app/g3w-ol/controls/control.js@v3.10.0
     *
     * button click handler
     */
    $(options.element).on('click', function (e) {
      return _this._handleClick(e);
    });

    _this.setVisible(options.visible);

    /**
     * ORIGINAL SOURCE: src/app/g3w-ol/controls/control.js@v3.10.0
     *
     * @since 3.11.0
     */
    if (_this._options.postRender) {
      _this._options.postRender.call(_this);
    }

    _this._toggled = false;

    _this._toggled = false;

    _this._interactionClassOptions = options.interactionClassOptions;

    /** @since 3.11.0 */
    if (options.interactionClass) {
      _this.initInteraction(options);
    }
    return _possibleConstructorReturn(_this);
  }

  /**
   * @param toggled
   *
   * @since 3.11.0
   */


  _createClass(InteractionControl, [{
    key: 'setMouseCursor',
    value: function setMouseCursor(toggled) {
      var className = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.cursorClass;

      var viewport = this.getMap().getViewport();
      if (toggled) {
        setTimeout(function () {
          return viewport.classList.add(className);
        });
      } else {
        viewport.classList.remove(className);
      }
    }
  }, {
    key: 'initInteraction',
    value: function initInteraction() {
      var _this2 = this;

      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var _options$visible = options.visible,
          visible = _options$visible === undefined ? true : _options$visible,
          _options$enabled = options.enabled,
          enabled = _options$enabled === undefined ? true : _options$enabled,
          _options$toggled = options.toggled,
          toggled = _options$toggled === undefined ? false : _options$toggled,
          _options$clickmap = options.clickmap,
          clickmap = _options$clickmap === undefined ? false : _options$clickmap,
          _options$interactionC = options.interactionClass,
          interactionClass = _options$interactionC === undefined ? null : _options$interactionC,
          _options$autountoggle = options.autountoggle,
          autountoggle = _options$autountoggle === undefined ? false : _options$autountoggle,
          _options$geometryType = options.geometryTypes,
          geometryTypes = _options$geometryType === undefined ? [] : _options$geometryType,
          _options$onhover = options.onhover,
          onhover = _options$onhover === undefined ? false : _options$onhover,
          _options$help = options.help,
          help = _options$help === undefined ? null : _options$help,
          toggledTool = options.toggledTool,
          _options$interactionC2 = options.interactionClassOptions,
          interactionClassOptions = _options$interactionC2 === undefined ? {} : _options$interactionC2,
          _options$layers = options.layers,
          layers = _options$layers === undefined ? [] : _options$layers,
          spatialMethod = options.spatialMethod;

      /**
       * Project layers dependencies
       * 
       * @since 3.8.0
       */

      this.layers = layers;

      /**
       * @since 3.8.0
       */
      this.unwatches = [];

      this._visible = visible;
      /**
       * Check if interact with a map
       */
      this.clickmap = clickmap;

      this._interactionClass = interactionClass;

      this._interaction = null;

      this._autountoggle = autountoggle;

      /**
       * Array of types geometries
       */
      this._geometryTypes = geometryTypes;

      this._onhover = onhover;

      this._help = help;

      /**
       * Used to show help info button
       */
      this._helpButton;

      /**
       * Used to show toolbutton
       */
      this._toolButton;

      this.toggledTool;

      /**
       * @type { 'intersect' | 'within' }
       */
      this.spatialMethod = spatialMethod;

      this._interactionClassOptions = interactionClassOptions;

      // in case of toggled true, then ... ?
      if (true === toggled) {
        this.on('setMap', function () {
          return _this2.toggle(toggled);
        });
      }

      // create a help message
      if (this._help) {
        this._createModalHelp();
      }

      // create tool
      if (toggledTool) {
        this.createControlTool(toggledTool);
      }

      // set enabled
      this.setEnable(enabled);

      // handle change of spatial method
      if (this.spatialMethod) {
        var _spatialMethod = this.spatialMethod;
        var eventKey = null;
        this.on('toggled', function (_ref) {
          var toggled = _ref.toggled;

          if (true === toggled) {
            eventKey = _this2.on('change-spatial-method', _this2.runSpatialQuery);
          } else if (null !== eventKey) {
            ol.Observable.unByKey(eventKey);
            eventKey = null;
            // reset to default
            _this2.setSpatialMethod(_spatialMethod);
            _this2.clear();
          }
        });
      }
    }

    /**
     * ORIGINAL SOURCE: src/app/g3w-ol/controls/control.js@v3.10.0
     *
     * @returns { boolean } whether is clickmap
     *
     * @since 3.11.0
     */

  }, {
    key: 'isClickMap',
    value: function isClickMap() {
      return this.clickmap;
    }

    /**
     * ORIGINAL SOURCE: src/app/g3w-ol/controls/control.js@v3.10.0
     *
     * @FIXME add description
     *
     * @since 3.11.0
     */

  }, {
    key: 'isToggled',
    value: function isToggled() {
      return this._toggled;
    }

    /**
     * ORIGINAL SOURCE: src/app/g3w-ol/controls/control.js@v3.10.0
     *
     * @FIXME add description
     *
     * @since 3.11.0
     */

  }, {
    key: 'setEventKey',
    value: function setEventKey(_ref2) {
      var eventType = _ref2.eventType,
          eventKey = _ref2.eventKey;

      this.eventKeys[eventType] = {
        eventKey: eventKey,
        originalHandler: eventKey.listener
      };
    }

    /**
     * ORIGINAL SOURCE: src/app/g3w-ol/controls/control.js@v3.10.0
     *
     * Reset the original handler method of control event.
     * 
     * @param { string } type
     *
     * @since 3.11.0
     */

  }, {
    key: 'resetOriginalHandlerEvent',
    value: function resetOriginalHandlerEvent(type) {
      if (this.eventKeys[type] && this.eventKeys[type].eventKey) {
        ol.Observable.unByKey(this.eventKeys[type].eventKey);
        this.eventKeys[type].eventKey = this.on(type, this.eventKeys[type].originalHandler);
      }
    }

    /**
     * ORIGINAL SOURCE: src/app/g3w-ol/controls/control.js@v3.10.0
     *
     * Override the original handler method of control event.
     * 
     * @param {string} eventType
     * @param {() => {}} handler
     *
     * @since 3.11.0
     */

  }, {
    key: 'overwriteEventHandler',
    value: function overwriteEventHandler(_ref3) {
      var eventType = _ref3.eventType,
          handler = _ref3.handler;

      if (this.eventKeys[eventType] && this.eventKeys[eventType].eventKey) {
        ol.Observable.unByKey(this.eventKeys[eventType].eventKey);
        this.eventKeys[eventType].eventKey = this.on(eventType, handler);
      }
    }

    /**
     * ORIGINAL SOURCE: src/app/g3w-ol/controls/control.js@v3.10.0
     *
     * @param pos position code
     *
     * @since 3.11.0
     */

  }, {
    key: 'getPosition',
    value: function getPosition(pos) {
      pos = pos || this.positionCode;
      return {
        top: pos.includes('t'),
        left: pos.includes('l'),
        bottom: pos.includes('b'),
        right: pos.includes('r')
      };
    }

    /**
     * ORIGINAL SOURCE: src/app/g3w-ol/controls/control.js@v3.10.0
     *
     * Handle toggle of map controls
     * 
     * @param event
     *
     * @since 3.11.0
     */

  }, {
    key: '_handleClick',
    value: function _handleClick(event) {
      if (this._enabled) {
        this.toggle();
        event.preventDefault();
        this.dispatchEvent('controlclick');
      }
    }

    /**
     * ORIGINAL SOURCE: src/app/gui/map/mapservice.js#3152@v3.10.0
     *
     * layout handler
     *
     * @since 3.11.0
     */

  }, {
    key: 'layout',
    value: function layout(map) {
      var previusControls = $(map.getViewport()).find('.ol-control-' + this.positionCode);
      if (previusControls.length) {
        var position = this.getPosition();
        var previusControl = previusControls.last();
        var offset = position.left ? previusControl.position().left : previusControl.position().right;
        var hWhere = position.left ? 'left' : 'right';
        var hOffset = $(this.element).position()[hWhere] + offset + previusControl[0].offsetWidth + 2;
        $(this.element).css(hWhere, hOffset + 'px');
      }
    }

    /**
     * ORIGINAL SOURCE: src/app/g3w-ol/controls/control.js@v3.10.0
     *
     * Called when a control is added ore removed to map
     * 
     * @param {ol.Map | null} map instace to be added (null = remove from map)
     * 
     * @fires setMap event
     *
     * @since 3.11.0
     */

  }, {
    key: 'setMap',
    value: function setMap(map) {
      var _this3 = this;

      /** @since 3.11.0 */
      if (this._options.onSetMap) {
        this._options.onSetMap.call(this, { setter: 'before', map: map });
      }

      // update GUI
      this.layout(map);

      if (this._control) {
        this._control.setMap(map);
      } else {
        _get(InteractionControl.prototype.__proto__ || Object.getPrototypeOf(InteractionControl.prototype), 'setMap', this).call(this, map);
      }

      if (!this._interaction && this._interactionClass) {
        this._interaction = new this._interactionClass(this._interactionClassOptions);
        map.addInteraction(this._interaction);
        this._interaction.setActive(false);
      }

      if (this._interaction && this.cursorClass) {
        this._interaction.on('change:active', function (e) {
          return _this3.setMouseCursor(e.target.get(e.key));
        });
      }

      /** ORIGINAL SOURCE: src/app/g3w-ol/controls/onclickcontrol.js@v3.10.0 */
      if (this._onclick) {
        var btn = $(this.element).children('button');
        var loading = false; // whether already clicked (waiting for async "_onclick" method)
        $(this.element).on('click', _asyncToGenerator(function* () {
          if (!loading) {
            loading = true;
            btn.addClass('g3w-ol-disabled');
            yield _this3._onclick();
            btn.removeClass('g3w-ol-disabled');
            loading = false;
          }
        }));
      }

      /** @since 3.8.0 */
      this.dispatchEvent({ type: 'setMap', map: map });

      /** @since 3.11.0 */
      if (this._options.onSetMap) {
        this._options.onSetMap.call(this, { setter: 'after', map: map });
      }
    }

    /**
     * ORIGINAL SOURCE: src/app/g3w-ol/controls/control.js@v3.10.0
     *
     * Hide control and move all controls that sit on his right position
     *
     * @since 3.11.0
     */

  }, {
    key: 'hideControl',
    value: function hideControl() {
      var position = $(this.element).position().left;
      var controlWidth = $(this.element).outerWidth();
      var newPosition = position;
      var controls = $(this.element).siblings('.ol-control-tl');
      controls.each(function () {
        if ($(this).position().left > position) {
          newPosition = $(this).position().left;
          if (controlWidth > $(this).outerWidth()) {
            position = position + (controlWidth - $(this).outerWidth());
          }
          $(this).css('left', position + 'px');
          position = newPosition;
          controlWidth = $(this).outerWidth();
        }
      });
      $(this.element).hide();
    }

    /**
     * ORIGINAL SOURCE: src/app/g3w-ol/controls/control.js@v3.10.0
     *
     * Toggle pointer events and `g3w-ol-disabled` class on map control button
     * 
     * @param { Boolean } bool whether the map control button is clickable
     *
     * @since 3.11.0
     */

  }, {
    key: 'setEnable',
    value: function setEnable(bool) {
      $(this.element).find('button').first().toggleClass('g3w-ol-disabled', !bool);
      if (!bool && this._interaction) {
        this._interaction.setActive(false);
      }
      this._enabled = bool;
    }

    /**
     * ORIGINAL SOURCE: src/app/g3w-ol/controls/control.js@v3.10.0
     *
     * @FIXME add description
     *
     * @since 3.11.0
     */

  }, {
    key: 'getEnable',
    value: function getEnable() {
      return this._enabled;
    }

    /**
     * ORIGINAL SOURCE: src/app/g3w-ol/controls/control.js@v3.10.0
     *
     * @FIXME add description
     *
     * @since 3.11.0
     */

  }, {
    key: 'setVisible',
    value: function setVisible() {
      var visible = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      this._visible = visible;
      $(this.element)[visible ? 'show' : 'hide']();
    }

    /**
     * ORIGINAL SOURCE: src/app/g3w-ol/controls/control.js@v3.10.0
     *
     * @FIXME add description
     *
     * @since 3.11.0
     */

  }, {
    key: 'isVisible',
    value: function isVisible() {
      return this._visible;
    }

    /**
     * ORIGINAL SOURCE: src/app/g3w-ol/controls/onclickcontrol.js@v3.10.0
     *
     * @since 3.11.0
     */

  }, {
    key: 'overwriteOnClickEvent',
    value: function overwriteOnClickEvent(handler) {
      this._originalonlick = this._originalonlick || this._onclick;
      this._onclick = handler;
    }
  }, {
    key: 'resetOriginalOnClickEvent',


    /**
     * ORIGINAL SOURCE: src/app/g3w-ol/controls/onclickcontrol.js@v3.10.0
     *
     * @since 3.11.0
     */
    value: function resetOriginalOnClickEvent() {
      this._onclick = this._originalonlick || this._onclick;
      this._originalonlick = null;
    }

    /**
     * @virtual method need to be implemented by subclasses
     *
     * @since 3.8.0
     */

  }, {
    key: 'onSelectLayer',
    value: function onSelectLayer() {}

    /**
     * @virtual method need to be implemented by subclasses
     *
     * @since 3.8.0
     */

  }, {
    key: 'runSpatialQuery',
    value: function runSpatialQuery() {}

    /**
     * @virtual method need to be implemented by subclasses
     *
     * @since 3.8.0
     */

  }, {
    key: 'clear',
    value: function clear() {}

    /**
     * @virtual method need to be implemented by subclasses
     *
     * @since 3.8.0
     */

  }, {
    key: 'onAddExternalLayer',
    value: function onAddExternalLayer() {
      var _ref5 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          layer = _ref5.layer,
          unWatches = _ref5.unWatches;
    }

    /**
     * @virtual method need to be implemented by subclasses
     *
     * @since 3.8.0
     */

  }, {
    key: 'onRemoveExternalLayer',
    value: function onRemoveExternalLayer(layer) {}

    /**
     * @virtual method need to be implemented by subclasses
     *
     * @param layers
     * @returns {boolean}
     *
     * @since 3.8.0
     */

  }, {
    key: 'checkVisibile',
    value: function checkVisibile(layers) {
      return true;
    }

    /**
     * Enable map control dom
     */

  }, {
    key: 'enable',
    value: function enable() {
      $(this.element).removeClass('g3w-disabled');
    }
  }, {
    key: 'disable',
    value: function disable() {
      $(this.element).addClass('g3w-disabled');
    }

    /**
     * @param { Object }                     toggledTool
     * @param { 'spatialMethod' | 'custom' } toggledTool.type
     * @param { 'toggled' | 'hover' }        toggledTool.how      "toggled" => (show tools when control is toggled); "hover" => (show button tool as info help)
     * @param                                toggledTool.component vue component
     */

  }, {
    key: 'createControlTool',
    value: function createControlTool() {
      var _this4 = this;

      var toggledTool = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};


      switch (toggledTool.type) {

        case 'spatialMethod':
          this.toggledTool = {
            template: /*html */'\n            <div style="width: 100%; padding: 5px;">\n              <select ref="select" style="width: 100%" :search="false" v-select2="\'method\'">\n                <option v-for="method in methods">{{ method }}</option>\n              </select>\n            </div>',
            data: function data() {
              return { methods: _g3wConstants.SPATIAL_METHODS, method: _this4.getSpatialMethod() };
            },
            watch: { method: function method(m) {
                return _this4.setSpatialMethod(m);
              } },
            created: function created() {
              _gui2.default.toggleUserMessage(false);
            },
            beforeDestroy: function beforeDestroy() {
              _gui2.default.toggleUserMessage(true);
            }
          };
          break;

        case 'custom':
          this.toggledTool = toggledTool.component;
          break;

      }

      /**
       * @TODO check if it is deprecated. It used to show help message for map control
       */
      if ('how' === toggledTool.how && this._onhover) {
        this._toolButton = $('<span style="display:none" class="tool_mapcontrol_button"><i class="' + _gui2.default.getFontClass('tool') + '"></i></span>');
        $(this.element).prepend(this._toolButton);
        this._toolButton.on('click', function (e) {
          e.stopPropagation();
          _this4.showToggledTool(true);
        });
        $(this.element).hover(function () {
          return _this4._toggled && _this4._toolButton.show();
        });
        $(this.element).mouseleave(function () {
          return _this4._toolButton.hide();
        });
      }
    }
  }, {
    key: 'showToggledTool',
    value: function showToggledTool() {
      var show = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      if (show) {
        _gui2.default.showUserMessage({
          title: this.toggledTool.__title,
          type: 'tool',
          size: 'small',
          iconClass: this.toggledTool.__iconClass,
          closable: this._toolButton ? true : false,
          hooks: { body: this.toggledTool }
        });
      } else {
        _gui2.default.closeUserMessage();
      }
    }

    /**
     * Set button status (pressed / not pressed)
     * 
     * @param { Boolean } toggled
     * @param { Object } opts
     */

  }, {
    key: 'toggle',
    value: function toggle() {
      var _this5 = this;

      var toggled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !this._toggled;
      var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};


      opts.parent = undefined === opts.parent ? false : opts.parent;

      // skip if button is already toggled or un-toggled
      if (toggled === this._toggled) {
        return;
      }

      this._toggled = toggled;

      if (this.cursorClass) {
        this.setMouseCursor(toggled);
      }

      // toggle other toggleable control
      if (toggled) {
        this.getMap().getControls().forEach(function (c) {
          if (c.id && c.toggle && c.id !== _this5.id && c.id !== opts.parent) {
            c.toggle(false);
          }
        });
      }

      if (this._interaction) {
        this._interaction.setActive(toggled);
      }

      /** Add or remove g3w-ol-toggled class to control button */
      $(this.element).find('button').first()[toggled ? 'addClass' : 'removeClass']('g3w-ol-toggled');

      /** @TODO Deprecated */
      if (toggled && this._toolButton) {
        this._toolButton.show();
      } else if (!toggled && this._toolButton) {
        this._toolButton.hide();
      }

      //** if not toggled and has a toggle tool (e.g., measure map control) close user message tool  */
      if (this.toggledTool) {
        this.showToggledTool(this._toggled);
      }

      this.dispatchEvent({ type: 'toggled', toggled: toggled });

      if (this._options.onToggled) {
        this._options.onToggled.call(this, toggled);
      }
    }
  }, {
    key: 'getGeometryTypes',
    value: function getGeometryTypes() {
      return this._geometryTypes;
    }
  }, {
    key: 'setGeometryTypes',
    value: function setGeometryTypes(types) {
      this._geometryTypes = types;
    }
  }, {
    key: 'getInteraction',
    value: function getInteraction() {
      return this._interaction;
    }

    /**
     * Method to set filter operation intersect or Contains
     */

  }, {
    key: 'setSpatialMethod',
    value: function setSpatialMethod() {
      var method = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'intersects';

      this.spatialMethod = method;
      this.dispatchEvent({
        type: 'change-spatial-method',
        spatialMethod: this.spatialMethod
      });
    }
  }, {
    key: 'getSpatialMethod',
    value: function getSpatialMethod() {
      return this.spatialMethod;
    }
  }, {
    key: 'setLayers',
    value: function setLayers() {
      var layers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      this.layers = layers;
    }

    /**
     * @returns { ol.control }
     * 
     * @since 3.11.0
     */

  }, {
    key: 'getOlControl',
    value: function getOlControl() {
      return this._control;
    }

    /**
     * @since 3.11.0
     */

  }, {
    key: 'showHide',
    value: function showHide() {
      if (this.element) {
        $(this.element).toggle();
      }
    }
  }]);

  return InteractionControl;
}(ol.control.Control);

exports.default = InteractionControl;

},{"g3w-constants":159,"services/gui":207}],179:[function(require,module,exports){
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MeasureControl = exports.MeasureInteraction = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _gui = require('services/gui');

var _gui2 = _interopRequireDefault(_gui);

var _interactioncontrol = require('map/controls/interactioncontrol');

var _interactioncontrol2 = _interopRequireDefault(_interactioncontrol);

var _createMeasureTooltip = require('utils/createMeasureTooltip');

var _removeMeasureTooltip = require('utils/removeMeasureTooltip');

var _g3wI18n = require('g3w-i18n');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @file ORIGINAL SOURCE: src/app/g3w-ol/controls/measuercontrol.js@v3.10.2
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @since 3.11.0
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */


var MeasureInteraction = exports.MeasureInteraction = function (_ol$interaction$Draw) {
  _inherits(MeasureInteraction, _ol$interaction$Draw);

  function MeasureInteraction(opts) {
    _classCallCheck(this, MeasureInteraction);

    var measureStyle = new ol.style.Style({
      fill: new ol.style.Fill({ color: 'rgba(255, 255, 255, 0.2)' }),
      stroke: new ol.style.Stroke({ color: opts.drawColor || 'rgba(0, 0, 0, 0.5)', lineDash: [10, 10], width: 3 }),
      image: new ol.style.Circle({
        radius: 5,
        stroke: new ol.style.Stroke({ color: 'rgba(0, 0, 0, 0.7)' }),
        fill: new ol.style.Fill({ color: 'rgba(255, 255, 255, 0.2)' })
      })
    });
    var source = new ol.source.Vector();

    var _this = _possibleConstructorReturn(this, (MeasureInteraction.__proto__ || Object.getPrototypeOf(MeasureInteraction)).call(this, {
      source: source,
      type: opts.geometryType || 'LineString',
      style: measureStyle
    }));

    _this._helpTooltip;
    _this._measureTooltipElement;
    _this._measureTooltip;
    _this._featureGeometryChangelistener;
    _this._poinOnMapMoveListener;
    _this._helpTooltipElement;

    _this._helpMsg = opts.help;
    _this._projection = opts.projection;
    _this.feature = opts.feature;
    _this._map = null;
    _this._feature = null;
    _this._layer = new ol.layer.Vector({
      source: source,
      style: function style() {
        return [new ol.style.Style({
          stroke: new ol.style.Stroke({ lineDash: [10, 10], width: 3 }),
          fill: new ol.style.Fill({ color: 'rgba(255, 255, 255, 0.2)' })
        })];
      }
    });

    _this.set('beforeRemove', _this.clear);
    _this.set('layer', _this._layer);
    // register event on two action
    _this.on('drawstart', _this._drawStart);
    _this.on('drawend', _this._drawEnd);
    return _this;
  }

  _createClass(MeasureInteraction, [{
    key: 'clear',
    value: function clear() {
      this._layer.getSource().clear();
      this._clearMessagesAndListeners();
      if (this._map) {
        (0, _removeMeasureTooltip.removeMeasureTooltip)(_extends({
          map: this._map
        }, this.measureTooltip));
        this.measureTooltip = null;
        this._map.removeLayer(this._layer);
      }
    }
  }, {
    key: '_clearMessagesAndListeners',
    value: function _clearMessagesAndListeners() {
      this._feature = null;
      // unset tooltip so that a new one can be created
      if (this._map) {
        this._measureTooltipElement = null;
        this._helpTooltipElement.innerHTML = '';

        this._helpTooltipElement.classList.add('hidden');

        ol.Observable.unByKey(this._featureGeometryChangelistener);
        ol.Observable.unByKey(this._poinOnMapMoveListener);

        $(document).off('keydown', this._keyDownEventHandler);
      }
    }

    //drawStart function

  }, {
    key: '_drawStart',
    value: function _drawStart(e) {
      var _this2 = this;

      this._map = this.getMap();
      this._map.removeLayer(this._layer);
      this._feature = e.feature;
      if (this.feature) {
        this._feature.setGeometry(this.feature.getGeometry());
      }
      // removed last point
      this._keyDownEventHandler = function (e) {
        var geom = _this2._feature.getGeometry();
        if (46 === e.keyCode) {
          if (geom instanceof ol.geom.Polygon && geom.getCoordinates()[0].length > 2) {
            _this2.removeLastPoint();
          } else if (geom instanceof ol.geom.LineString && geom.getCoordinates().length > 1) {
            _this2.removeLastPoint();
          }
        }
      };
      $(document).on('keydown', this._keyDownEventHandler);
      this._layer.getSource().clear();
      this._poinOnMapMoveListener = this._map.on('pointermove', function (e) {
        if (e.dragging) {
          return;
        }
        if (_this2._feature && _this2._helpMsg) {
          _this2._helpTooltipElement.innerHTML = (0, _g3wI18n.t)(_this2._helpMsg);
          _this2._helpTooltip.setPosition(e.coordinate);
          _this2._helpTooltipElement.classList.remove('hidden');
        }
      });
      // create help tooltip
      if (this._helpTooltipElement) {
        this._helpTooltipElement.parentNode.removeChild(this._helpTooltipElement);
      }
      if (this._helpTooltip) {
        this._map.removeOverlay(this._helpTooltip);
      }
      this._helpTooltipElement = document.createElement('div');
      this._helpTooltipElement.className = 'mtooltip hidden';
      this._helpTooltip = new ol.Overlay({
        element: this._helpTooltipElement,
        offset: [15, 0],
        positioning: 'center-left'
      });

      this._map.addOverlay(this._helpTooltip);

      // create measure tooltip
      if (this.measureTooltip) {
        (0, _removeMeasureTooltip.removeMeasureTooltip)(_extends({}, this.measureTooltip, { map: this._map }));
      }

      this.measureTooltip = (0, _createMeasureTooltip.createMeasureTooltip)({ map: this._map, feature: this._feature });
    }
  }, {
    key: '_drawEnd',
    value: function _drawEnd() {
      this.measureTooltip.tooltip.getElement().className = 'mtooltip mtooltip-static';
      this.measureTooltip.tooltip.setOffset([0, -7]);
      this._clearMessagesAndListeners();
      this._map.addLayer(this._layer);
    }
  }]);

  return MeasureInteraction;
}(ol.interaction.Draw);

var MeasureControl = exports.MeasureControl = function (_InteractionControl) {
  _inherits(MeasureControl, _InteractionControl);

  function MeasureControl() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, MeasureControl);

    var _this3 = _possibleConstructorReturn(this, (MeasureControl.__proto__ || Object.getPrototypeOf(MeasureControl)).call(this, _extends({}, opts, {
      clickmap: true,
      enabled: true,
      onToggled: function onToggled(toggled) {
        // toggle current interaction
        this._interaction.setActive(this.isToggled());
        // when not toggled
        if (!toggled) {
          this._interaction.clear();
        }
        // check if first interaction is current interaction
        if (!toggled && this.interactions[this.types[0]] !== this._interaction) {
          //remove current interaction from the map
          this.getMap().removeInteraction(this._interaction);
          this._interaction = this.interactions[this.types[0]];
          //add first interaction
          this.getMap().addInteraction(this._interaction);
        }
      }
    })));

    _this3.types = [];

    _this3.interactions = {};

    (opts.types || []).forEach(function (t) {
      return _this3.addType(t);
    });

    // no type set, hide control
    if (0 === _this3.types.length) {
      _this3.setVisible(false);
    }

    _this3.on('setMap', function (e) {
      return e.map.addInteraction(_this3._interaction);
    });
    return _this3;
  }

  /**
   * @param { 'area' | 'length' } type 
   *
   * @since 3.11.0
   */


  _createClass(MeasureControl, [{
    key: 'addType',
    value: function addType(type) {
      var _this4 = this;

      this.types.push(type);

      this._interactionClassOptions.geometryType = { area: 'Polygon', length: 'LineString' }[type];

      this.interactions[type] = new MeasureInteraction(this._interactionClassOptions);

      this.interactions[type].setActive(false);

      if (!this._interaction) {
        this._interaction = this.interactions[type];
      }

      if (this.types.length > 1) {
        this.toggledTool = this.toggledTool || {
          __title: 'sdk.mapcontrols.measures.title',
          __iconClass: 'measure', //@since v3.11.0
          data: function data() {
            return { types: _this4.types, type: _this4.types[0] };
          },
          template: /* html */'\n          <div style="width: 100%; padding: 5px;">\n            <select ref="select" style="width: 100%" :search="false" v-select2="\'type\'">\n              <option v-for="type in types" :value="type" v-t="\'sdk.mapcontrols.measures.\' + type + \'.tooltip\'"></option>\n            </select>\n          </div>',
          watch: {
            // change measure interaction
            type: function type(ntype, otype) {
              // deactivate previous interaction
              _this4.interactions[otype].setActive(false);
              _this4.interactions[otype].clear();
              _this4.getMap().removeInteraction(_this4.interactions[otype]);
              // activate new interacion
              _this4.getMap().addInteraction(_this4.interactions[ntype]);
              _this4.interactions[ntype].setActive(true);
              _this4._interaction = _this4.interactions[ntype];
            }
          },
          created: function created() {
            _gui2.default.toggleUserMessage(false);
          },
          beforeDestroy: function beforeDestroy() {
            _gui2.default.toggleUserMessage(true);
          }
        };
      }
    }
  }]);

  return MeasureControl;
}(_interactioncontrol2.default);

},{"g3w-i18n":162,"map/controls/interactioncontrol":178,"services/gui":207,"utils/createMeasureTooltip":227,"utils/removeMeasureTooltip":269}],180:[function(require,module,exports){
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.QueryBy = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _g3wConstants = require('g3w-constants');

var _g3wEventbus = require('g3w-eventbus');

var _gui = require('services/gui');

var _gui2 = _interopRequireDefault(_gui);

var _data = require('services/data');

var _data2 = _interopRequireDefault(_data);

var _application = require('store/application');

var _application2 = _interopRequireDefault(_application);

var _interactioncontrol = require('map/controls/interactioncontrol');

var _interactioncontrol2 = _interopRequireDefault(_interactioncontrol);

var _pickcoordinatesinteraction = require('map/interactions/pickcoordinatesinteraction');

var _pickcoordinatesinteraction2 = _interopRequireDefault(_pickcoordinatesinteraction);

var _throttle = require('utils/throttle');

var _getCatalogLayerById = require('utils/getCatalogLayerById');

var _g3wI18n = require('g3w-i18n');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @file
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @since 3.11.0
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */


var POLYGON_TYPES = [_g3wConstants.GEOMETRY_TYPES.POLYGON, _g3wConstants.GEOMETRY_TYPES.POLYGONZ, _g3wConstants.GEOMETRY_TYPES.POLYGONM, _g3wConstants.GEOMETRY_TYPES.POLYGONZM, _g3wConstants.GEOMETRY_TYPES.POLYGON25D, _g3wConstants.GEOMETRY_TYPES.MULTIPOLYGON, _g3wConstants.GEOMETRY_TYPES.MULTIPOLYGONZ, _g3wConstants.GEOMETRY_TYPES.MULTIPOLYGONM, _g3wConstants.GEOMETRY_TYPES.MULTIPOLYGONZM, _g3wConstants.GEOMETRY_TYPES.MULTIPOLYGON25D];

/**
 * Child interaction controls
 */
var CONTROLS = {};

/**
 * Spatial query options
 */
var QUERY = Vue.observable({
  /** @type {ol.coordinate} bbox coordinates */
  bbox: null,
  /** @type { ol.Feature } drawed feature */
  dfeature: null,
  layer: null,
  feature: null,
  coordinates: null,
  radius: 0
});

/**
 * Return current layer id selected or __ALL__ (no layer selected)
 * @return {string}
 */
function getSelectedLayerId() {
  return (_gui2.default.getService('map').getSelectedLayer() || {
    getId: function getId() {
      return '__ALL__';
    }
  }).getId();
}

/**
 * ORIGINAL SOURCE: src/app/g3w-ol/controls/querybybboxcontrol.js@v3.9.10
 * ORIGINAL SOURCE: src/app/g3w-ol/controls/querybypolygoncontrol.js@v3.9.10
 * ORIGINAL SOURCE: src/app/g3w-ol/controls/querybydrawpolygoncontrol.js@v3.9.10
 */

var QueryBy = exports.QueryBy = function (_InteractionControl) {
  _inherits(QueryBy, _InteractionControl);

  function QueryBy() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, QueryBy);

    var _this = _possibleConstructorReturn(this, (QueryBy.__proto__ || Object.getPrototypeOf(QueryBy)).call(this, _extends({}, opts, {
      name: 'queryby',
      label: '\uE903',
      tipLabel: "sdk.mapcontrols.queryby.title",
      enabled: true,
      cursorClass: null //store cursorClass of a current sub control enabled (querybbox, etc..)
    })));

    _this.types = [];

    (opts.types || []).forEach(function (type) {
      return _this.addType(type);
    });

    // no type set, hide control
    if (0 === _this.types.length) {
      _this.setVisible(false);
    } else {
      _this.element.classList.add('ol-' + _this.types[0]);
    }

    CONTROLS['queryby'] = _this;

    _this.selectedLayer = '__ALL__';

    // toolbox (options)
    _this.on('toggled', function (_ref) {
      var toggled = _ref.toggled;

      if (!toggled) {
        return _gui2.default.closeUserMessage();
      }
      _gui2.default.showUserMessage({
        title: 'sdk.mapcontrols.queryby.title',
        type: 'tool',
        size: 'small',
        iconClass: 'info',
        closable: false,
        hooks: {
          body: {
            data: function data() {
              return {
                types: _this.types,
                type: _this.types[0],
                methods: _g3wConstants.SPATIAL_METHODS,
                method: _this.getSpatialMethod(),
                layers: [],
                selectedLayer: getSelectedLayerId()
              };
            },
            template: /* html */'\n              <div style="width: 100%;">\n                <!-- DOCS URL -->\n                <a\n                  :href  = "\'https://g3w-suite.readthedocs.io/en/v3.8.x/g3wsuite_client.html#map-controls\'"\n                  target = "_blank"\n                  style  = "position: absolute;inset: 1em 1em auto auto;"\n                  title  = "Docs"\n                >\n                  <i :class = "$fa(\'external-link\')"></i>\n                </a>\n                <!-- SPATIAL METHOD -->\n                <div style="padding: 5px;">\n                  <select :search="false" v-select2="\'method\'">\n                    <option v-for="method in methods" :value="method" v-t="\'sdk.mapcontrols.queryby.methods.\' + method"></option>\n                  </select>\n                </div>\n                <!-- QUERY TYPE -->\n                <div style="padding: 5px;">\n                  <select :search="false" v-select2="\'type\'" :templateSelection="templateType" :templateResult="templateType">\n                    <option v-for="type in types" :value="type" v-t="\'sdk.mapcontrols.queryby.\' + type + \'.tooltip\'"></option>\n                  </select>\n                </div>\n                <!-- RADIUS TYPE IN METERS-->\n                <div v-if="\'querybycircle\' === type" style="padding: 5px;">\n                  <label for="g3w_querybycircle_radius" v-t:pre="\'sdk.mapcontrols.querybycircle.label\'">[m]</label>\n                  <div style = "display: flex">\n                    <input\n                      id      = "g3w_querybycircle_radius"\n                      v-model = "radius"\n                      class   =  "form-control"\n                      step    = \'1\'\n                      min     = \'0\'\n                      type    = "number"/>\n                    <!-- CLEAR RADIUS -->\n                    <button \n                      type        = "button" \n                      @click.stop = "radius = 0" \n                      class       = "btn btn-default"\n                    >\n                      <i :class="$fa(\'clear\')"></i>\n                    </button>\n                  </div>\n                </div>\n                <!-- SELECTED LAYER -->\n                <div style = "padding: 5px;">\n                  <label v-t="\'sdk.mapcontrols.queryby.layer\'"></label>\n                  <select ref="layer" :select2_value = "selectedLayer" v-select2="\'selectedLayer\'" :templateSelection="templateLayer" :templateResult="templateLayer">\n                    <option v-t="all" :value ="\'__ALL__\'"></option>\n                    <option v-for="layer in layers" :value="layer.getId()" :selected="selectedLayer === layer.getId()">{{ layer.get(\'name\') }}</option>\n                    <option :value="\'__NEW__\'" v-t="\'sdk.mapcontrols.queryby.new\'"></option>\n                  </select>\n                </div>\n                <!-- HELP TEXT -->\n                <div ref="help" v-t-html="help"></div>\n                <!-- CLEAR SELECTION -->\n                <button v-if = "![\'__ALL__\', \'__NEW__\'].includes(selectedLayer)" class="clear-selected-layer btn btn-block btn-warning"  @click.stop="selectedLayer = \'__ALL__\'"><i :class = "$fa(\'clear\')"></i> <span v-t="\'layer_selection_filter.tools.clear\'"></span></button>\n              </div>',
            computed: {
              control: function control() {
                return CONTROLS[this.type];
              },
              queryable: function queryable() {
                var _this2 = this;

                return (this.control.layers || []).filter(function (l) {
                  return 'querybypolygon' === _this2.type ? POLYGON_TYPES.includes(l.getGeometryType()) : true;
                });
              },
              no_layers: function no_layers() {
                return !this.queryable || !_hasVisible(this.control);
              },
              help: function help() {
                return 'sdk.mapcontrols.' + this.type + '.help.message';
              },
              all: function all() {
                return this.no_layers ? 'sdk.mapcontrols.queryby.none' : 'sdk.mapcontrols.queryby.all';
              },

              radius: {
                get: function get() {
                  return QUERY.radius;
                },
                set: function set(v) {
                  if (Number.isNaN(v) || v < 0) {
                    this.radius = QUERY.radius;
                    return;
                  }
                  //need to convert degree in meter
                  QUERY.radius = Math.floor(v * ('m' === _gui2.default.getService('map').getMapUnits() ? 1 : ol.proj.Units.METERS_PER_UNIT.degrees));
                  //already circle drawed but not clear (0) value
                  if (QUERY.dfeature && QUERY.radius > 0) {
                    QUERY.dfeature.getGeometry().setRadius(QUERY.radius);
                    CONTROLS['queryby'].runSpatialQuery(this.type);
                  }
                }
              }
            },
            watch: {
              method: function method() {
                this.reset();
              },
              type: function type() {
                var _this3 = this;

                //after a change type needs to check, is all being updated to change select2 option text
                this.reset().then(function () {
                  return _this3.update__ALL__Text();
                });
              },
              control: function control() {
                var _this4 = this;

                this.types.forEach(function (t) {
                  return CONTROLS['queryby'].element.classList.toggle('ol-' + t, t === _this4.type);
                });
              },
              layers: function layers() {
                this.selectedLayerNotQuerable();
              },

              // see: https://forums.select2.org/t/cannot-rename-selected-option/154/2
              all: function all() {
                this.update__ALL__Text();
              },

              selectedLayer: {
                immediate: true,
                handler: function handler(value, oldValue) {
                  var _this5 = this;

                  this.selectedLayerNotQuerable();
                  //It means that it is mounted. No value before
                  if (undefined === oldValue) {
                    return;
                  }
                  var map = _gui2.default.getService('map');
                  // auto selects added layer
                  if ('__NEW__' === value) {
                    var listener = map.onafter('loadExternalLayer', function (l) {
                      map.selectLayer(l.get('id'));
                      _this5.reset();
                    });
                    var select = document.querySelector('#add-layer-type');
                    select.value = 'file';
                    select.dispatchEvent(new Event('change'));
                    $('#modal-addlayer').one('hidden.bs.modal', function () {
                      return map.un('loadExternalLayer', listener);
                    });
                    map.showAddLayerModal();
                  }

                  if (!['__ALL__', '__NEW__'].includes(value) && value !== getSelectedLayerId()) {
                    map.selectLayer(value);
                  }
                  //reset selection if a selection is done by TOC catalog
                  if (['__ALL__', '__NEW__'].includes(value) && '__ALL__' !== getSelectedLayerId()) {
                    map.selectLayer();
                  }
                }
              }
            },
            methods: {
              /**
               * Update selects2 the __ALL__ option text as to select all change text
               */
              update__ALL__Text: function update__ALL__Text() {
                $(this.$refs.layer).select2('close');
                $(this.$refs.layer).find('option[value="__ALL__"]').text((0, _g3wI18n.t)(this.all));
                $(this.$refs.layer).select2('data')[0].text = (0, _g3wI18n.t)(this.all);
                $(this.$refs.layer).trigger('change');
              },
              selectedLayerNotQuerable: function selectedLayerNotQuerable() {
                //In the case of selection of layer (by TOC) that not belong to a layer list,
                // set the value of selectedLayer __ALL__
                if (!['__ALL__', '__NEW__'].includes(this.selectedLayer) && this.layers.length && !this.layers.map(function (l) {
                  return l.getId();
                }).includes(this.selectedLayer)) {
                  this.selectedLayer = '__ALL__';
                }
              },
              reset: function () {
                var _ref2 = _asyncToGenerator(function* () {
                  var _this6 = this,
                      _layers;

                  this.layers.splice(0);
                  // reset autorun options
                  this.types.filter(function (t) {
                    return t !== _this6.type;
                  }).forEach(function (t) {
                    if ('querybycircle' === t) {
                      QUERY.radius = 0;
                    }
                    if ('querybbox' === t) {
                      QUERY.bbox = null;
                    }
                    if ('querybypolygon' === t) {
                      QUERY.layer = null;QUERY.feature = null;QUERY.coordinates = null;
                    }
                    if (!['querybydrawpolygon', 'querybycircle'].includes(_this6.type)) {
                      QUERY.dfeature = null;
                    }
                    CONTROLS[t].autorun = false;
                  });
                  //set spatial method
                  this.control.spatialMethod = this.method;
                  this.control.toggle(true, { parent: CONTROLS['queryby'].id });
                  // show highlight class only if 'querybbox' or 'querybydrawpolygon' or 'querybycircle' type control
                  this.control.layers.forEach(function (l) {
                    return l.setTocHighlightable(['querybbox', 'querybydrawpolygon', 'querybycircle'].includes(_this6.type));
                  });
                  yield this.$nextTick();
                  // set queryable layers (select2)
                  (_layers = this.layers).push.apply(_layers, _toConsumableArray(this.queryable));

                  if ('querybypolygon' === this.type) {
                    this.control.setEnable(false);
                  }
                  // re-run query when changing spatial method
                  if (this.control.autorun) {
                    CONTROLS['queryby'].runSpatialQuery(this.type);
                  }
                });

                function reset() {
                  return _ref2.apply(this, arguments);
                }

                return reset;
              }(),
              templateType: function templateType(state) {
                if (!state.id) {
                  return state.text;
                }
                return $( /*html*/'<span><i class="' + _gui2.default.getFontClass({
                  'querybbox': 'square',
                  'querybycircle': 'empty-circle',
                  'querybydrawpolygon': 'draw',
                  'querybypolygon': 'pointer'
                }[state.id]) + '"></i>&nbsp;&nbsp;' + state.text + '</span>');
              },
              templateLayer: function templateLayer(state) {
                if (!state.id || '__NEW__' === state.id) {
                  return state.text;
                }
                var externalLayers = _gui2.default.getService('map').getLegacyExternalLayers();
                var layer = (0, _getCatalogLayerById.getCatalogLayerById)(state.id) || externalLayers.find(function (l) {
                  return l.get('id') === state.id;
                });
                /** @FIXME layer is undefined when removing an external layer */
                var icon = '__ALL__' === state.id || !layer ? '' : /*html */'<i class="' + _gui2.default.getFontClass(layer.isVisible() ? 'eye' : 'eye-close') + '"></i>&nbsp;&nbsp;';
                return $( /*html*/'<span>' + icon + state.text + '</span>');
              }
            },
            mounted: function mounted() {
              CONTROLS['queryby'].usermessage = this;
              _gui2.default.toggleUserMessage(false);
              this.reset();
            },

            beforeDestroy: function beforeDestroy() {
              _gui2.default.toggleUserMessage(true);
              _this.types.forEach(function (t) {
                CONTROLS[t].toggle(false);
                CONTROLS[t].autorun = false;
                CONTROLS['queryby'].element.classList.toggle('ol-' + t, t === _this.types[0]);
                CONTROLS[t].layers.forEach(function (l) {
                  return l.setTocHighlightable(false);
                });
              });
            }
          }
        }
      });
    });
    return _this;
  }

  /**
   * @param { 'area' | 'length' } type 
   *
   * @since 3.11.0
   */


  _createClass(QueryBy, [{
    key: 'addType',
    value: function addType(type) {
      var _this8 = this,
          _unwatches;

      // skip when already added
      if (this.types.includes(type)) {
        return;
      }

      // keep "querybypolygon" at last position
      this.types.splice(this.types.includes('querybypolygon') ? this.types.indexOf('querybypoyling') : this.types.length, 0, type);

      /**
       * @TODO remove `InteractionControl` and use a standard `ol.interaction`
       */
      var control = CONTROLS[type] = new _interactioncontrol2.default({
        name: type,
        offline: false,
        visible: false,
        geometryTypes: ['querybypolygon', 'querybydrawpolygon'].includes(type) ? POLYGON_TYPES : [],
        cursorClass: 'querybypolygon' !== type ? 'ol-crosshair' : 'ol-pointer',
        interactionClass: {
          'querybbox': ol.interaction.DragBox,
          'querybycircle': ol.interaction.Draw,
          'querybydrawpolygon': ol.interaction.Draw,
          'querybypolygon': _pickcoordinatesinteraction2.default
        }[type],
        interactionClassOptions: ['querybydrawpolygon', 'querybycircle'].includes(type) ? { type: 'querybydrawpolygon' === type ? 'Polygon' : 'Circle' } : {},
        layers: _getAvailableLayers(type),
        onSetMap: function onSetMap(_ref3) {
          var _this7 = this;

          var setter = _ref3.setter,
              map = _ref3.map;

          if ('after' !== setter) {
            return;
          }

          if ('querybbox' === type) {
            var startCoord = null;
            this._interaction.on('boxstart', function (e) {
              return startCoord = e.coordinate;
            });
            this._interaction.on('boxend', (0, _throttle.throttle)(function (e) {
              QUERY.bbox = ol.extent.boundingExtent([startCoord, e.coordinate]);
              _this7.dispatchEvent({ type: 'bboxend', extent: QUERY.bbox });
              startCoord = null;
              if (_this7._autountoggle) {
                _this7.toggle();
              }
            }));
            this.setEventKey({
              eventType: 'bboxend',
              eventKey: this.on('bboxend', function () {
                return CONTROLS['queryby'].runSpatialQuery('querybbox');
              })
            });
          }

          if ('querybycircle' === type) {
            this._interaction.on('drawstart', function (e) {
              var geometry = e.feature.getGeometry();
              geometry.setRadius(QUERY.radius);
              geometry.on('change', function () {
                return QUERY.radius = geometry.getRadius();
              });
              if (QUERY.radius > 0) {
                _this7._interaction.finishDrawing();
              }
            });
          }

          if (['querybydrawpolygon', 'querybycircle'].includes(type)) {
            this._interaction.on('drawend', (0, _throttle.throttle)(function (e) {
              //convert circle geometry to polygon
              if ('querybycircle' === type) {
                var radius = e.feature.getGeometry().getRadius();
                //in the case of map unit degrees, convert it to meter
                QUERY.radius = radius * ('m' === _gui2.default.getService('map').getMapUnits() ? 1 : ol.proj.Units.METERS_PER_UNIT.degrees);
              }
              QUERY.dfeature = e.feature;
              _this7.dispatchEvent({ type: 'drawend', feature: QUERY.dfeature });
              if (_this7._autountoggle) {
                _this7.toggle();
              }
            }));

            this.setEventKey({
              eventType: 'drawend',
              eventKey: this.on('drawend', function () {
                return CONTROLS['queryby'].runSpatialQuery(type);
              })
            });
          }

          if ('querybypolygon' === type) {

            this._interaction.on('picked', (0, _throttle.throttle)(function () {
              var _ref4 = _asyncToGenerator(function* (e) {
                QUERY.coordinates = e.coordinate;
                _this7.dispatchEvent({ type: 'picked', coordinates: QUERY.coordinates });
                if (_this7._autountoggle) {
                  _this7.toggle();
                }
              });

              return function (_x2) {
                return _ref4.apply(this, arguments);
              };
            }()));

            // get polygon feature from coordinates
            this.setEventKey({
              eventType: 'picked',
              eventKey: this.on('picked', _asyncToGenerator(function* () {

                _gui2.default.closeSideBar();

                // ask for coordinates
                try {
                  var _ref6 = yield _data2.default.getData('query:coordinates', {
                    inputs: {
                      feature_count: _application2.default.project.state.feature_count || 5,
                      coordinates: QUERY.coordinates
                    },
                    outputs: {
                      // whether to show picked coordinates on map
                      show: function show(_ref7) {
                        var _ref7$data = _ref7.data,
                            data = _ref7$data === undefined ? [] : _ref7$data,
                            query = _ref7.query;

                        var show = data.length === 0;
                        // set query coordinates to null in case to avoid `externalvector` added to query response
                        query.coordinates = show ? query.coordinates : null;
                        return show;
                      }
                    }
                  }),
                      _ref6$data = _ref6.data,
                      data = _ref6$data === undefined ? [] : _ref6$data;

                  if (data.length && data[0].features.length) {
                    QUERY.feature = data[0].features[0];
                    QUERY.layer = data[0].layer;
                    CONTROLS['queryby'].runSpatialQuery('querybypolygon');
                  }
                } catch (e) {
                  console.warn('Error running spatial query:', e);
                }
              }))
            });

            this.setEnable(false);
          }
        },

        clickmap: true
      });

      _gui2.default.getService('map').addControl(type, type, control, false, false);

      control._interaction.on('change:active', function (e) {
        //set current cursor class on map
        _this8.setMouseCursor(e.target.get(e.key), control.cursorClass); // set mouse cursor
        //set same cursor class to parent queryby control
        _this8.cursorClass = control.cursorClass;

        if (['querybbox', 'querybydrawpolygon', 'querybycircle'].includes(type)) {
          _application2.default.highlightlayers = e.target.get(e.key); // highlight layers in legend
        }
      });

      // listen for layers visibility change
      this.unwatches = this.unwatches || [];
      this.unwatches.forEach(function (unwatch) {
        return unwatch();
      });
      this.unwatches.splice(0);
      (_unwatches = this.unwatches).push.apply(_unwatches, _toConsumableArray(this.types.flatMap(function (t) {
        var control = CONTROLS[t];
        return (control.layers || []).map(function (layer) {
          return _g3wEventbus.VM.$watch(function () {
            return layer.state.visible;
          }, function () {
            // toggle "eye" / "eye-close" icon
            if (_this8.usermessage) {
              $(_this8.usermessage.$refs.layer).trigger('change');
            }
            // toggle control interaction
            control.setEnable(control.isToggled() && _hasVisible(control));
            control._interaction.setActive(control.getEnable());
          });
        });
      })));
    }

    /**
     * @param layer 
     */

  }, {
    key: 'onSelectLayer',
    value: function onSelectLayer(layer) {

      var btn = document.querySelector('.usermessage-content .clear-selected-layer');
      if (btn) {
        btn.classList.toggle('hidden', !layer);
      }

      if (this.usermessage) {
        this.usermessage.selectedLayer = layer ? layer.getId() : '__ALL__';
      }

      this.types.forEach(function (t) {
        var control = CONTROLS[t];

        var selected = layer && control.layers.find(function (l) {
          return l === layer;
        });
        var queryable = layer && layer.isQueryable() && (control.getGeometryTypes() || []).includes(layer.getGeometryType());

        if (['querybbox', 'querybydrawpolygon', 'querybycircle'].includes(t)) {
          control.setEnable(control.isToggled() && (layer ? selected && selected.isVisible() : _hasVisible(control)));
        }

        if ('querybypolygon' === t) {
          control.setEnable(control.isToggled() && queryable && _hasVisible(control));
        }

        control._interaction.setActive(control.getEnable());
      });
    }

    /**
     * @param {{ layer, unWatches }}
     */

  }, {
    key: 'onAddExternalLayer',
    value: function onAddExternalLayer(_ref8) {
      var layer = _ref8.layer,
          unWatches = _ref8.unWatches;

      this.types.forEach(function (t) {
        var control = CONTROLS[t];

        control.layers = _getAvailableLayers(t);

        // set layer property
        if ('querybbox' === t) {
          layer.setTocHighlightable(control.isToggled() && control.getEnable());
        }

        // watch `layer.selected` and `layer.visible` properties
        unWatches.push(_g3wEventbus.VM.$watch(function () {
          return [layer.selected, layer.visible];
        }, function () {
          control.setEnable(control.isToggled() && (layer.selected ? layer.visible : _hasVisible(control)));
          control._interaction.setActive(control.getEnable());
        }, { immediate: true }));
      });
    }

    /**
     * @since 3.8.0
     */

  }, {
    key: 'onRemoveExternalLayer',
    value: function onRemoveExternalLayer(layer) {
      var _this9 = this;

      this.types.forEach(function (t) {
        var control = CONTROLS[t];
        control.layers = _getAvailableLayers(t).filter(function (l) {
          return l.getId() !== layer.getId();
        });
        control.setEnable(control.isToggled() && _hasVisible(CONTROLS[t]));
        control._interaction.setActive(control.getEnable());
      });
      /** @TODO find a better way to update "layers" list (select2) within vue component */
      setTimeout(function () {
        if (_this9.usermessage) {
          _this9.usermessage.reset();
        }
      });
    }
  }, {
    key: 'runSpatialQuery',
    value: function () {
      var _ref9 = _asyncToGenerator(function* (type) {
        var _this10 = this;

        //@since 3.11.0 In case of error error-output-data set to true and not autorun is set
        var error = false;
        var setError = function setError() {
          error = true;_this10.toggle();
        };

        _gui2.default.once('error-output-data', setError);

        try {

          var control = CONTROLS[type];

          _gui2.default.closeSideBar();

          if (
          // skip if bbox is not set
          'querybbox' === type && null === QUERY.bbox ||
          // skip when .. ?
          'querybypolygon' === type && [QUERY.coordinates, QUERY.feature, QUERY.layer].includes(null)) {
            return;
          }

          //Check if some layer is selected
          var selected = _gui2.default.getService('map').getSelectedLayer();
          var externalLayers = _gui2.default.getService('map').getLegacyExternalLayers();
          var project = _application2.default.project;

          if ('querybbox' === type) {
            yield _data2.default.getData('query:bbox', {
              inputs: {
                bbox: QUERY.bbox,
                feature_count: project.state.feature_count || 5,
                addExternal: !selected || externalLayers.some(function (l) {
                  return l === selected;
                }),
                // Catalog layers (TOC) properties that need to be satisfied
                layersFilterObject: {
                  SELECTED_OR_ALL: true, // selected or all
                  FILTERABLE: true, // see: src/app/core/layers/layer.js#L925
                  VISIBLE: true // need to be visible
                },
                condition: { filtrable: { ows: 'WFS' } },
                multilayers: [].concat(project.state.querymultilayers).includes(control.name),
                filterConfig: { spatialMethod: control.getSpatialMethod() } // added spatial method to polygon filter
              }
            });
          }

          if (['querybypolygon', 'querybydrawpolygon', 'querybycircle'].includes(type)) {
            yield _data2.default.getData('query:polygon', {
              inputs: {
                layerName: 'querybypolygon' === type ? QUERY.layer.getName ? QUERY.layer.getName() : QUERY.layer.get('name') : '',
                excludeSelected: 'querybypolygon' === type || !selected,
                feature: function () {
                  switch (type) {
                    case 'querybypolygon':
                      return QUERY.feature;
                    case 'querybydrawpolygon':
                      return QUERY.dfeature;
                    case 'querybycircle':
                      var feat = QUERY.dfeature.clone();
                      feat.setGeometry(ol.geom.Polygon.fromCircle(QUERY.dfeature.getGeometry(), 64));
                      return feat;
                  }
                }(),
                external: {
                  add: 'querybypolygon' === type || !selected || externalLayers.some(function (l) {
                    return l === selected;
                  }),
                  filter: {
                    SELECTED: ['querybydrawpolygon', 'querybycircle'].includes(type) && !!selected //true if some layer on TOC is selected
                  }
                },
                type: (type || '').replace('queryby', '') || undefined,
                multilayers: [].concat(project.state.querymultilayers).includes('querybypolygon'), //hardcoded using querymultilayers server config
                filterConfig: { spatialMethod: control.getSpatialMethod() } // added spatial method to polygon filter
              },
              outputs: {
                show: function show(_ref10) {
                  var _ref10$error = _ref10.error,
                      error = _ref10$error === undefined ? false : _ref10$error;
                  return !error;
                }
              }
            });
          }

          //set autorun to true if no error happensd
          control.autorun = !error;
        } catch (e) {
          console.warn('Error running spatial query: ', e);
        }

        //remove handler to error-output-data event
        _gui2.default.off('error-output-data', setError);
      });

      function runSpatialQuery(_x3) {
        return _ref9.apply(this, arguments);
      }

      return runSpatialQuery;
    }()
  }]);

  return QueryBy;
}(_interactioncontrol2.default);

/**
 * @returns {boolean} whether control has a visible layer 
 */


function _hasVisible(control) {

  var selected = _gui2.default.getService('map').getSelectedLayer();

  // whether one layer is visible (and not selected)
  if ('querybypolygon' === control.name) {
    return !!(
    // check if the current selected layer is visible
    selected && selected.isVisible() && (
    // check if at least one layer is visible (project or external layer)
    control.layers.some(function (l) {
      return l !== selected && l.isVisible() && l.isFilterable({ ows: 'WFS' });
    }) || _gui2.default.getService('map').getLegacyExternalLayers().find(function (l) {
      return l !== selected && true === l.visible;
    })));
  }

  // whether one layer is visible
  return !!((control.layers || []).some(function (l) {
    return l.isVisible();
  }) || _gui2.default.getService('map').getLegacyExternalLayers().some(function (l) {
    return l.visible;
  }));
}

/**
 * @TODO get rid of `s.getLayers` call
 */
function _getAvailableLayers(type) {
  var MapLayersStoresRegistry = require('services/map').default.MapLayersStoresRegistry;

  var queryable = MapLayersStoresRegistry.getQuerableLayersStores();
  return [].concat(_toConsumableArray(new Set([].concat(_toConsumableArray(queryable.flatMap(function (s) {
    return s.getLayers({ GEOLAYER: true, FILTERABLE: true, SELECTED_OR_ALL: true }, { filtrable: { ows: 'WFS' } });
  }).filter(function (l) {
    return 'wfs' === l.getProvider('filter').getName();
  })), _toConsumableArray((_gui2.default.getService('map').getLegacyExternalLayers() || []).filter(function (l) {
    return 'querybypolygon' === type ? POLYGON_TYPES.includes(l.getGeometryType()) : true;
  })), _toConsumableArray('querybypolygon' === type ? queryable.flatMap(function (s) {
    return s.getLayers({ GEOLAYER: true, QUERYABLE: true, SELECTED_OR_ALL: true }, {});
  }) : [])))));
}

},{"g3w-constants":159,"g3w-eventbus":160,"g3w-i18n":162,"map/controls/interactioncontrol":178,"map/interactions/pickcoordinatesinteraction":184,"services/data":206,"services/gui":207,"services/map":209,"store/application":212,"utils/getCatalogLayerById":238,"utils/throttle":276}],181:[function(require,module,exports){
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ScaleControl = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _g3wConstants = require('g3w-constants');

var _getResolutionFromScale = require('utils/getResolutionFromScale');

var _getScaleFromResolution = require('utils/getScaleFromResolution');

var _g3wI18n = require('g3w-i18n');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @file ORIGINAL SOURCE: src/app/g3w-ol/controls/scalecontrol.js@v3.10.2
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @since 3.11.0
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */


var ScaleControl = exports.ScaleControl = function (_ol$control$Control) {
  _inherits(ScaleControl, _ol$control$Control);

  function ScaleControl() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, ScaleControl);

    opts.target = 'scale-control';
    opts.offline = true;

    var _this = _possibleConstructorReturn(this, (ScaleControl.__proto__ || Object.getPrototypeOf(ScaleControl)).call(this, opts));

    _this.isMobile = opts.isMobile || false;
    return _this;
  }

  _createClass(ScaleControl, [{
    key: 'layout',
    value: function layout(map) {
      var self = this;
      var isMapResolutionChanged = false;
      var selectedOnClick = false;
      var select2 = $(this.element).children('select').select2({
        tags: true,
        dropdownParent: $(map.getTargetElement()),
        width: '120px',
        height: '20px',
        language: { noResults: function noResults() {
            return (0, _g3wI18n.t)("sdk.mapcontrols.scale.no_valid_scale");
          } },
        minimumResultsForSearch: this.isMobile ? -1 : 0,
        createTag: function createTag() {
          var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

          var newTag = null;
          var scale = void 0;
          // Don't offset to create a tag if there is no @ symbol
          if (params.term.includes('1:')) {
            // Return null to disable tag creation
            scale = params.term.split('1:')[1];
          } else if (Number.isInteger(Number(params.term)) && Number(params.term) > 0) {
            scale = Number(params.term);
            if (scale <= self.scales[0]) {
              newTag = {
                id: scale,
                text: '1:' + params.term,
                new: true
              };
              deleteLastCustomScale();
            }
          }
          return newTag;
        }
      });
      //get change mapsize to close
      map.on('change:size', function () {
        return select2.select2('close');
      });

      function deleteLastCustomScale() {
        select2.find('option').each(function (index, option) {
          return !self.scales.includes(1 * option.value) && $(option).remove();
        });
      }

      function addCustomTag(data) {
        if (select2.find("option[value='" + data.id + "']").length) {
          select2.val(data.id).trigger('change');
        } else {
          deleteLastCustomScale();
          select2.append(new Option(data.text, data.id, true, true)).trigger('change');
        }
      }

      map.on('moveend', function () {
        if (isMapResolutionChanged) {
          var scale = parseInt((0, _getScaleFromResolution.getScaleFromResolution)(this.getView().getResolution(), this.getView().getProjection().getUnits()));
          addCustomTag({
            id: scale,
            text: '1:' + scale,
            new: true
          });
          isMapResolutionChanged = false;
        } else {
          selectedOnClick = false;
        }
      });

      var setChangeResolutionHandler = function setChangeResolutionHandler() {
        map.getView().on('change:resolution', function () {
          return isMapResolutionChanged = !selectedOnClick;
        });
      };

      setChangeResolutionHandler();

      map.on('change:view', function () {
        return setChangeResolutionHandler();
      });

      select2.on('select2:select', function (e) {
        selectedOnClick = true;
        var data = e.params.data;
        if (data.new) {
          deleteLastCustomScale();
          addCustomTag(data);
        }
        map.getView().setResolution((0, _getResolutionFromScale.getResolutionFromScale)(1 * data.id, map.getView().getProjection().getUnits()));
      });
    }
  }, {
    key: 'setMap',
    value: function setMap(map) {
      if (!map) {
        return;
      }

      // set scales
      var currentScale = parseInt((0, _getScaleFromResolution.getScaleFromResolution)(map.getView().getResolution(), map.getView().getProjection().getUnits()));
      this.scales = _g3wConstants.PRINT_SCALES.map(function (s) {
        return s.value;
      }).filter(function (s) {
        return s < currentScale;
      });
      this.scales.unshift(currentScale);

      // create control
      var div = document.createElement('div');
      var select = document.createElement('select');
      var optgroup = Object.assign(document.createElement('optgroup'), { label: '' });

      this.scales.forEach(function (scale, index) {
        optgroup.appendChild(Object.assign(document.createElement('option'), {
          value: scale,
          text: '1:' + scale,
          selected: 0 === index
        }));
      });

      select.appendChild(optgroup);

      if (!this.isMobile) {
        var _optgroup = document.createElement('optgroup');
        _optgroup.label = 'Custom';
        select.appendChild(_optgroup);
      }

      div.appendChild(select);

      // set element of control (it is necessary to visualize it)
      this.element = div;
      $(this.element).css('height', '20px');

      this.layout(map);
      _get(ScaleControl.prototype.__proto__ || Object.getPrototypeOf(ScaleControl.prototype), 'setMap', this).call(this, map);
    }
  }]);

  return ScaleControl;
}(ol.control.Control);

},{"g3w-constants":159,"g3w-i18n":162,"utils/getResolutionFromScale":250,"utils/getScaleFromResolution":251}],182:[function(require,module,exports){
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ScreenshotControl = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _application = require('store/application');

var _application2 = _interopRequireDefault(_application);

var _gui = require('services/gui');

var _gui2 = _interopRequireDefault(_gui);

var _saveBlob = require('utils/saveBlob');

var _sameOrigin = require('utils/sameOrigin');

var _interactioncontrol = require('map/controls/interactioncontrol');

var _interactioncontrol2 = _interopRequireDefault(_interactioncontrol);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @file ORIGINAL SOURCE: src/app/g3w-ol/controls/screenshotcontrol.js@v3.10.2
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @since 3.11.0
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

/**
 * @FIXME prevent tainted canvas error
 * 
 * Because the pixels in a canvas's bitmap can come from a variety of sources,
 * including images or videos retrieved from other hosts, it's inevitable that
 * security problems may arise. As soon as you draw into a canvas any data that
 * was loaded from another origin without CORS approval, the canvas becomes
 * tainted.
 * 
 * A tainted canvas is one which is no longer considered secure, and any attempts
 * to retrieve image data back from the canvas will cause an exception to be thrown.
 * 
 * @see https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_enabled_image
 */
var ScreenshotControl = exports.ScreenshotControl = function (_InteractionControl) {
  _inherits(ScreenshotControl, _InteractionControl);

  function ScreenshotControl() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, ScreenshotControl);

    opts.layers = undefined === opts.layers ? [] : opts.layers;

    var _this = _possibleConstructorReturn(this, (ScreenshotControl.__proto__ || Object.getPrototypeOf(ScreenshotControl)).call(this, _extends({
      name: "maptoimage",
      tipLabel: "Screenshot",
      label: '\uE90F',
      clickmap: true,
      enabled: true,
      layers: []
    }, opts)));

    _this.types = [];

    (opts.types || []).forEach(function (t) {
      return _this.addType(t);
    });

    _this.layers = opts.layers;

    //set visibility based on layers
    _this.setVisible(_this.checkVisible(_this.layers));

    //only if is visible (no CORS issue) need to listen to add/remove layer
    if (_this.isVisible()) {
      //listen to add/remove External Layer event to check visibility of the control
      _gui2.default.getService('map').onafter('loadExternalLayer', _this._addLayer.bind(_this));
      _gui2.default.getService('map').onafter('unloadExternalLayer', _this._removeLayer.bind(_this));
    }
    return _this;
  }

  /**
   * @param { 'screenshot' | 'geoscreenshot' } type
   *
   * @since 3.11.0
   */


  _createClass(ScreenshotControl, [{
    key: 'addType',
    value: function addType(type) {
      var _this2 = this;

      this.types.push(type);

      this.toggledTool = this.toggledTool || {
        __title: 'sdk.mapcontrols.screenshot.title',
        __iconClass: 'camera',
        data: function data() {
          return { types: _this2.types, type: _this2.types[0] };
        },
        template: /* html */'\n        <div style="width: 100%; padding: 5px;">\n          <select ref="select" style="width: 100%;" :search="false" v-select2="\'type\'">\n            <option v-for="type in types" :value="type" v-t="\'sdk.mapcontrols.screenshot.\' + type"></option>\n          </select>\n          <button v-disabled = "loading" style="margin-top: 5px" class="btn btn-block btn-success" @click.stop="download(type)" v-t="\'sdk.mapcontrols.screenshot.download\'"></button>\n        </div>',
        computed: {
          loading: function loading() {
            return _application2.default.download;
          }
        },
        methods: {
          download: function () {
            var _ref = _asyncToGenerator(function* (type) {
              var map = _gui2.default.getService('map');
              // Start download
              _application2.default.download = true;
              try {
                var blob = 'screenshot' === type ? yield map.createMapImage() // PNG
                : yield (yield fetch('/' + map.project.getType() + '/api/asgeotiff/' + map.project.getId() + '/', { // GeoTIFF
                  method: 'POST',
                  body: Object.entries({
                    image: yield map.createMapImage(),
                    csrfmiddlewaretoken: map.getCookie('csrftoken'),
                    bbox: map.getMapBBOX().toString()
                  }).reduce(function (a, k) {
                    a.append(k[0], k[1]);return a;
                  }, new FormData())
                })).blob();
                // handle click when app is within iframe (ref: "IframePluginService" → overwriteOnClickEvent)
                (_this2._onclick || _saveBlob.saveBlob)(blob, 'map_' + Date.now());
              } catch (e) {
                _gui2.default.showUserMessage({
                  type: 'SecurityError' === e.name ? 'warning' : 'alert',
                  message: 'SecurityError' === e.name ? 'mapcontrols.screenshot.securityError' : 'mapcontrols.screenshot.error',
                  autoclose: false
                });
                console.warn(e);
              }
              // End download
              _application2.default.download = false;
              return true;
            });

            function download(_x2) {
              return _ref.apply(this, arguments);
            }

            return download;
          }()
        },
        created: function created() {
          _gui2.default.toggleUserMessage(false);
        },
        beforeDestroy: function beforeDestroy() {
          _gui2.default.toggleUserMessage(true);
        }
      };
    }

    /**
     * Called when a new layer is added to Project (eg. wms or vector layer)
     * 
     * @since 3.8.3
     *
     */

  }, {
    key: '_addLayer',
    value: function _addLayer(layer) {
      var _this3 = this;

      this.layers.push(layer);
      this.change(this.layers);
      layer.on('change:visible', function () {
        return _this3.change(_this3.layers);
      });
    }

    /**
     * Called when a layer is removed from Project
     * 
     * @since 3.8.3 
     */

  }, {
    key: '_removeLayer',
    value: function _removeLayer(layer) {
      this.layers = this.layers.filter(function (l) {
        return l !== layer;
      });
      this.change(this.layers);
    }

    /**
     * Called when a layer is added or removed
     * 
     * @param layers
     */

  }, {
    key: 'change',
    value: function change() {
      var layers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      this.setVisible(this.checkVisible(layers));
    }

    /**
     * Check visibility for map control based on layers URLs.
     * 
     * Allow printing external WMS layers only when they have
     * the same origin URL of the current application in order to avoid
     * CORS issue while getting map image.
     * 
     * Layers that don't have a source URL are excluded (eg. base layers)
     * 
     * @param {array} layers
     * 
     * @returns {boolean}
     */

  }, {
    key: 'checkVisible',
    value: function checkVisible() {
      var layers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      // Need to be visible.
      // If it was not visible, the CORS issue was raised.
      // Need to reload and remove layer
      return this.isVisible() && !layers.some(isCrossOrigin);
    }
  }]);

  return ScreenshotControl;
}(_interactioncontrol2.default);

/**
 * Check if a layer has a Cross Origin source URI
 * 
 * @param layer
 * 
 * @returns {boolean} `true` whether the given layer could cause CORS issues (eg. while printing raster layers). 
 */


function isCrossOrigin(layer) {
  var source_url = void 0;

  // vector or hidden layers can't cause CORS issues
  if (layer.getVisible && !layer.getVisible() || layer instanceof ol.layer.Vector) {
    return false;
  }

  // image layer (OpenLayers)
  if (layer instanceof ol.layer.Tile || layer instanceof ol.layer.Image) {
    source_url = layer.getSource().getUrl();
    return source_url && !(0, _sameOrigin.sameOrigin)(source_url, location);
  }

  // external image layer (eg: "core/layers/imagelayer.js")
  if ((layer.getConfig().source || {}).external) {
    source_url = layer.getConfig().source.url;
    return source_url && !(0, _sameOrigin.sameOrigin)(source_url, location);
  }

  return false;
}

},{"map/controls/interactioncontrol":178,"services/gui":207,"store/application":212,"utils/sameOrigin":272,"utils/saveBlob":274}],183:[function(require,module,exports){
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StreetViewControl = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _application = require('store/application');

var _application2 = _interopRequireDefault(_application);

var _gui = require('services/gui');

var _gui2 = _interopRequireDefault(_gui);

var _XHR = require('utils/XHR');

var _interactioncontrol = require('map/controls/interactioncontrol');

var _interactioncontrol2 = _interopRequireDefault(_interactioncontrol);

var _pickcoordinatesinteraction = require('map/interactions/pickcoordinatesinteraction');

var _pickcoordinatesinteraction2 = _interopRequireDefault(_pickcoordinatesinteraction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @file ORIGINAL SOURCE: src/app/g3w-ol/controls/streetviewcontrol.js@v3.10.2
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @since 3.11.0
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

var GoogleStreetViewApiUrl = 'https://maps.googleapis.com/maps/api/';

var StreetViewControl = function (_InteractionControl) {
  _inherits(StreetViewControl, _InteractionControl);

  function StreetViewControl() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, StreetViewControl);

    /**
     * Check Google Key
     */
    var _this = _possibleConstructorReturn(this, (StreetViewControl.__proto__ || Object.getPrototypeOf(StreetViewControl)).call(this, _extends({}, opts, {
      offline: false,
      visible: true, // always visible. Only change behavior if exist or not
      name: "streetview",
      tipLabel: "StreetView",
      clickmap: true,
      label: '\uE905',
      interactionClass: _pickcoordinatesinteraction2.default,
      interactionClassOptions: { cursor: 'ol-streetview' },
      cursorClass: 'ol-streetview'
    })));

    _this.key = _application2.default.keys.vendorkeys.google;

    if (_this.key) {
      _XHR.XHR.get({
        url: GoogleStreetViewApiUrl + 'streetview',
        params: {
          location: 0,
          size: '456x456',
          key: _this.key
        }
      }).catch(function (e) {
        console.warn(e);_this.keyError = e.responseText;
      });
    }

    // get script
    $script(GoogleStreetViewApiUrl + 'js?' + (_this.key ? 'key=' + _this.key : ''));

    /***/

    _this._sv = null;
    _this._panorama = null;
    _this._map = null;
    _this._projection = null;
    _this._lastposition = null;
    _this._streetViewFeature = new ol.Feature();
    _this.active = false;

    _this._layer = new ol.layer.Vector({
      source: new ol.source.Vector({ features: [] }),
      style: function style(feature) {
        var coordinates = feature.getGeometry().getCoordinates();
        this._lastposition = this._lastposition ? this._lastposition : coordinates;
        var dx = coordinates[0] - this._lastposition[0];
        var dy = coordinates[1] - this._lastposition[1];
        var rotation = -Math.atan2(dy, dx);
        var styles = [new ol.style.Style({
          text: new ol.style.Text({
            text: '\uE905',
            font: 'bold 18px icomoon',
            fill: new ol.style.Fill({
              color: '#ffffff'
            })
          })
        }), new ol.style.Style({
          image: new ol.style.Icon({
            src: '/static/client/images/streetviewarrow.png',
            rotation: rotation
          })
        })];
        this._lastposition = coordinates;
        return styles;
      }
    });

    //@since 3.11.0.
    // In the case of key provided and open content with streetview images,
    // on close content need to remove point (icon street view on a map)
    if (_this.key) {
      _gui2.default.on('closecontent', function () {
        if (_this.isToggled()) {
          _this._layer.getSource().clear();
        }
      });
    }

    return _this;
  }

  _createClass(StreetViewControl, [{
    key: 'setProjection',
    value: function setProjection(projection) {
      this._projection = projection;
    }
  }, {
    key: 'setPosition',
    value: function setPosition(position) {
      var _this2 = this;

      var pixel = void 0;
      var self = this;
      this.active = true;
      if (!this._sv) {
        this._sv = new google.maps.StreetViewService();
      }
      this._sv.getPanorama({ location: position }, function (data) {
        self._panorama = new google.maps.StreetViewPanorama(document.getElementById('streetview'), { imageDateControl: true });
        /**
         * Listen on position change
        */
        self._panorama.addListener('position_changed', function () {
          if (self.isToggled()) {
            var lnglat = ol.proj.transform([this.getPosition().lng(), this.getPosition().lat()], 'EPSG:4326', self._projection.getCode());
            self._streetViewFeature.setGeometry(new ol.geom.Point(lnglat));
            pixel = self._map.getPixelFromCoordinate(lnglat);
            if (pixel[0] + 15 > self._map.getSize()[0] || pixel[1] + 15 > self._map.getSize()[1] || pixel[0] < 15 || pixel[1] < 15) {
              self._map.getView().setCenter(lnglat);
            }
          }
        });
        if (data && data.location) {
          self._panorama.setPov({
            pitch: 0,
            heading: 0
          });

          self._panorama.setPosition(data.location.latLng);
        }
      }).then(function (response) {
        if (undefined === response) {
          _gui2.default.closeContent();
        }
      }).catch(function (e) {
        console.warn(e);_this2.toggle();
      });
    }
  }, {
    key: 'setMap',
    value: function setMap(map) {
      var _this3 = this;

      this._map = map;
      _get(StreetViewControl.prototype.__proto__ || Object.getPrototypeOf(StreetViewControl.prototype), 'setMap', this).call(this, map);

      this.setProjection(this._map.getView().getProjection());
      this._map.addLayer(this._layer);

      this._interaction.on('picked', function (_ref) {
        var coordinate = _ref.coordinate;

        _this3.showStreetView(coordinate);
        if (_this3._autountoggle) {
          _this3.toggle();
        }
      });
    }

    /**
     * Method to show StreetView depending on a key and keyError
     * @param coordinate
     */

  }, {
    key: 'showStreetView',
    value: function showStreetView(coordinate) {
      var _ol$proj$transform = ol.proj.transform(coordinate, this._map.getView().getProjection().getCode(), 'EPSG:4326'),
          _ol$proj$transform2 = _slicedToArray(_ol$proj$transform, 2),
          lng = _ol$proj$transform2[0],
          lat = _ol$proj$transform2[1];

      if (this.key) {
        _gui2.default.setContent({
          title: 'StreetView',
          content: '<div id="streetview" style="height:100%; width:100%;">' + (this.keyError ? '<div\n          style = "display: flex;justify-content: center;align-items: center;font-weight: bold;height: 100%;padding: 10px;background-color: #FFF;"\n          class = "skin-color"\n        >' + this.keyError + '</div>' : '') + '</div>'
        });
        if (!this.keyError) {
          this.setPosition({ lng: lng, lat: lat });
        }
      } else {
        this._streetViewFeature.setGeometry(new ol.geom.Point(coordinate));
        window.open('https://www.google.com/maps/@?api=1&map_action=pano&viewpoint=' + lat + ',' + lng);
      }
    }
  }, {
    key: 'clearMarker',
    value: function clearMarker() {
      this._streetViewFeature.setGeometry(null);
    }
  }, {
    key: 'clear',
    value: function clear() {
      this._layer.getSource().clear();
      this._streetViewFeature.setGeometry(null);
      this.clearMarker();
      this._panorama = null;
      if (this.active) {
        _gui2.default.closeContent();
      }
      this.active = false;
    }
  }, {
    key: 'toggle',
    value: function toggle(_toggle) {
      _get(StreetViewControl.prototype.__proto__ || Object.getPrototypeOf(StreetViewControl.prototype), 'toggle', this).call(this, _toggle);
      if (this.isToggled()) {
        this._layer.getSource().addFeatures([this._streetViewFeature]);
      } else {
        this.clear();
      }
    }
  }]);

  return StreetViewControl;
}(_interactioncontrol2.default);

exports.StreetViewControl = StreetViewControl;

},{"map/controls/interactioncontrol":178,"map/interactions/pickcoordinatesinteraction":184,"services/gui":207,"store/application":212,"utils/XHR":215}],184:[function(require,module,exports){
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @file ORIGINAL SOURCE: src/app/g3w-ol/interactions/pickcoordinatesinteraction.js@v3.10.2
 * @since 3.11.0
 */

var PickCoordinatesInteraction = function (_ol$interaction$Point) {
  _inherits(PickCoordinatesInteraction, _ol$interaction$Point);

  function PickCoordinatesInteraction() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, PickCoordinatesInteraction);

    var _this = _possibleConstructorReturn(this, (PickCoordinatesInteraction.__proto__ || Object.getPrototypeOf(PickCoordinatesInteraction)).call(this, _extends({
      handleDownEvent: function handleDownEvent(e) {
        var _this2 = this;

        this._centerMap = e.map.getView().getCenter();
        // set timeout to avoid blocking pan
        setTimeout(function () {
          if (_this2._centerMap === e.map.getView().getCenter()) {
            _this2.handleUpEvent(e);
          }
        }, 300);
        // return false to avoid start of drag event
        return false;
      },
      handleUpEvent: function handleUpEvent(e) {
        this.dispatchEvent({
          type: 'picked',
          coordinate: e.coordinate
        });
        // it used to stop drag event
        return false;
      },
      handleMoveEvent: function handleMoveEvent(e) {
        e.map.getViewport().classList.add(this._cursor);
        return true;
      }
    }, opts)));

    _this._cursor = opts.cursor || 'ol-pointer';
    // this.previousCursor_ = null;
    _this._centerMap = null;
    return _this;
  }

  _createClass(PickCoordinatesInteraction, [{
    key: 'shouldStopEvent',
    value: function shouldStopEvent() {
      return false;
    }
  }, {
    key: 'setActive',
    value: function setActive(bool) {
      var map = this.getMap();
      if (map) {
        map.getViewport().classList.remove(this._cursor);
      }
      _get(PickCoordinatesInteraction.prototype.__proto__ || Object.getPrototypeOf(PickCoordinatesInteraction.prototype), 'setActive', this).call(this, bool);
    }
  }, {
    key: 'setMap',
    value: function setMap(map) {
      if (!map) {
        this.getMap().getViewport().classList.remove(this._cursor);
      }
      _get(PickCoordinatesInteraction.prototype.__proto__ || Object.getPrototypeOf(PickCoordinatesInteraction.prototype), 'setMap', this).call(this, map);
    }
  }]);

  return PickCoordinatesInteraction;
}(ol.interaction.Pointer);

exports.default = PickCoordinatesInteraction;

},{}],185:[function(require,module,exports){
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @file ORIGINAL SOURCE: src/app/g3w-ol/interactions/pickfeatureinteraction.js@v3.10.2
 * @since 3.11.0
 */

var PickFeatureInteraction = function (_ol$interaction$Point) {
  _inherits(PickFeatureInteraction, _ol$interaction$Point);

  function PickFeatureInteraction() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, PickFeatureInteraction);

    var _this = _possibleConstructorReturn(this, (PickFeatureInteraction.__proto__ || Object.getPrototypeOf(PickFeatureInteraction)).call(this, _extends({
      handleDownEvent: function handleDownEvent(e) {
        this.pickedFeature_ = this.featuresAtPixel_(e.pixel, e.map);
        return this.pickedFeature_;
      },
      handleUpEvent: function handleUpEvent(e) {
        if (this.pickedFeature_) {
          this.dispatchEvent({
            type: 'picked',
            feature: this.pickedFeature_,
            coordinate: e.coordinate,
            layer: this.pickedLayer_
          });
        }
        return true;
      },
      handleMoveEvent: function handleMoveEvent(e) {
        e.map.getTargetElement().style.cursor = this.featuresAtPixel_(e.pixel, e.map) ? 'pointer' : '';
      }
    }, opts)));

    var features = opts.features;

    _this.features_ = Array.isArray(features) && features.length > 0 ? features : null;
    _this.layers_ = opts.layers || null;
    _this.pickedFeature_ = null;
    _this.pickedLayer_ = null;
    return _this;
  }

  _createClass(PickFeatureInteraction, [{
    key: 'layerFilter_',
    value: function layerFilter_(layer) {
      var include = (this.layers_ || []).includes(layer);
      this.pickedLayer_ = include && layer;
      return include;
    }
  }, {
    key: 'featuresAtPixel_',
    value: function featuresAtPixel_(pixel, map) {
      var _this2 = this;

      var featureFound = null;
      var intersectingFeature = map.forEachFeatureAtPixel(pixel, function (feature) {
        if (_this2.features_) {
          if (_this2.features_.includes(feature)) {
            return feature;
          } else {
            return null;
          }
        }
        return feature;
      }, {
        layerFilter: this.layerFilter_.bind(this),
        hitTolerance: isMobile && isMobile.any ? 10 : 0
      });
      if (intersectingFeature) {
        featureFound = intersectingFeature;
      }
      return featureFound;
    }
  }, {
    key: 'shouldStopEvent',
    value: function shouldStopEvent() {
      return false;
    }
  }, {
    key: 'setMap',
    value: function setMap(map) {
      if (!map) {
        this.getMap().getTargetElement().style.cursor = '';
      }
      _get(PickFeatureInteraction.prototype.__proto__ || Object.getPrototypeOf(PickFeatureInteraction.prototype), 'setMap', this).call(this, map);
    }
  }]);

  return PickFeatureInteraction;
}(ol.interaction.Pointer);

exports.default = PickFeatureInteraction;
;

},{}],186:[function(require,module,exports){
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Feature = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _g3wConstants = require('g3w-constants');

var _g3wConstants2 = _interopRequireDefault(_g3wConstants);

var _getUniqueDomId = require('utils/getUniqueDomId');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @file ORIGINAL SOURCE: src/app/core/layers/features/feature.js@v3.10.2
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @since 3.11.0
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

var Feature = exports.Feature = function (_ol$Feature) {
  _inherits(Feature, _ol$Feature);

  function Feature() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, Feature);

    var _this = _possibleConstructorReturn(this, (Feature.__proto__ || Object.getPrototypeOf(Feature)).call(this));

    _this.state = {
      new: false,
      state: null,
      visible: true
    };

    //store unique id for the feature
    _this._uid = (0, _getUniqueDomId.getUniqueDomId)();

    //{ Boolean }: true if feature has geometry
    _this._geometry = false;

    // check if it has to set only some properties or all feature properties
    if (opts.feature && opts.properties && Array.isArray(opts.properties)) {
      opts.properties.forEach(function (p) {
        return _this.set(p, opts.feature.get(p));
      });
    } else if (opts.feature) {
      _this.setProperties(opts.feature.getProperties());
    }

    if (opts.feature) {
      _this.setId(opts.feature.getId());
      _this.setGeometryName(opts.feature.getGeometryName());
    }

    var geometry = opts.feature && opts.feature.getGeometry();

    //check if feature has geometry
    if (geometry) {
      _this._geometry = true;
      _this.setGeometry(geometry);
    }

    //check if it has style associated
    var style = _this.getStyle();
    if (style) {
      _this.setStyle(style);
    }
    return _this;
  }

  /**
   * Return unique id
   * @returns {*}
   */


  _createClass(Feature, [{
    key: 'getUid',
    value: function getUid() {
      return this._uid;
    }

    /**
     *
     * @return {boolean}
     */

  }, {
    key: 'isGeometry',
    value: function isGeometry() {
      return this._geometry;
    }

    /**
     * Clone a feature with id and pk new
     * @param pk field <Object> send pk field
     * @returns {Feature}
     */

  }, {
    key: 'cloneNew',
    value: function cloneNew(pk) {
      var clone = this.clone();
      //set new unique id
      clone._uid = (0, _getUniqueDomId.getUniqueDomId)();
      clone.setTemporaryId();
      //in the case of send pk field object set temporary new value
      //to avoid duplicate pk when save clone feature on server
      if (pk && false === pk.editable) {
        //need to be set null
        clone.set(pk.name, null);
      }
      return clone;
    }

    /**
     * clone existing feature
     * @returns {Feature}
     */

  }, {
    key: 'clone',
    value: function clone() {
      var feature = _get(Feature.prototype.__proto__ || Object.getPrototypeOf(Feature.prototype), 'clone', this).call(this);
      feature.setId(this.getId());
      //if it has geometry, need to clone geometry
      if (this.isGeometry()) {
        feature.setGeometry(feature.getGeometry().clone());
      }
      var clone = new Feature({ feature: feature });
      clone._uid = this.getUid();
      clone.setState(this.getState());
      if (this.isNew()) {
        clone.setNew();
      }
      return clone;
    }
  }, {
    key: 'setTemporaryId',
    value: function setTemporaryId() {
      this.setId('_new_' + (0, _getUniqueDomId.getUniqueDomId)());
      this.setNew();
    }
  }, {
    key: 'setNew',
    value: function setNew() {
      this.state.new = true;
    }
  }, {
    key: 'delete',
    value: function _delete() {
      this.state.state = 'delete';
      return this;
    }
  }, {
    key: 'update',
    value: function update() {
      this.state.state = 'update';
      return this;
    }
  }, {
    key: 'add',
    value: function add() {
      this.state.state = 'add';
      return this;
    }
  }, {
    key: 'isNew',
    value: function isNew() {
      return this.state.new;
    }
  }, {
    key: 'isAdded',
    value: function isAdded() {
      return 'add' === this.state.state;
    }
  }, {
    key: 'isUpdated',
    value: function isUpdated() {
      return 'update' === this.state.state;
    }
  }, {
    key: 'isDeleted',
    value: function isDeleted() {
      return 'delete' === this.state.state;
    }
  }, {
    key: 'setState',
    value: function setState(state) {
      this.state.state = state;
    }
  }, {
    key: 'getState',
    value: function getState() {
      return this.state.state;
    }

    /**
     * Get only alphanumerical properties. No geometry property is returned
     * @return {{ Object }}
     */

  }, {
    key: 'getAlphanumericProperties',
    value: function getAlphanumericProperties() {
      return Object.entries(this.getProperties()).filter(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            name = _ref2[0],
            _ = _ref2[1];

        return !_g3wConstants2.default.GEOMETRY_FIELDS.includes(name);
      }).reduce(function (attrs, _ref3) {
        var _ref4 = _slicedToArray(_ref3, 2),
            n = _ref4[0],
            v = _ref4[1];

        attrs[n] = v;return attrs;
      }, {});
    }

    /**
     * clean state of the features
     */

  }, {
    key: 'clearState',
    value: function clearState() {
      this.state.state = null;
      this.state.new = false;
    }

    /**
     * need to filter features visiblity on table
     * @returns {boolean}
     */

  }, {
    key: 'isVisible',
    value: function isVisible() {
      return this.state.visible;
    }

    /**
     * Set visibility of feature
     * @param bool
     */

  }, {
    key: 'setVisible',
    value: function setVisible() {
      var bool = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      this.state.visible = bool;
    }
  }]);

  return Feature;
}(ol.Feature);

},{"g3w-constants":159,"utils/getUniqueDomId":252}],187:[function(require,module,exports){
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FeaturesStore = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _g3wObject = require('g3w-object');

var _g3wObject2 = _interopRequireDefault(_g3wObject);

var _promisify = require('utils/promisify');

var _XHR = require('utils/XHR');

var _lodash = require('lodash.clonedeep');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @file ORIGINAL SOURCE: src/app/core/layers/features/featurestore.js@v3.10.2
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @since 3.11.0
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

/** @deprecated */


var FeaturesStore = exports.FeaturesStore = function (_G3WObject) {
  _inherits(FeaturesStore, _G3WObject);

  function FeaturesStore() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, FeaturesStore);

    var _this = _possibleConstructorReturn(this, (FeaturesStore.__proto__ || Object.getPrototypeOf(FeaturesStore)).call(this));

    _this._features = opts.features || [];
    _this._provider = opts.provider || null;
    _this._loadedIds = []; // store features id load by current user
    _this._lockIds = []; // store locked features

    //setters
    _this.setters = {
      /**
       * Add an array of features
       * @param { Array } features
       */
      addFeatures: function addFeatures() {
        var _this2 = this;

        var features = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

        features.forEach(function (f) {
          return _this2._addFeature(f);
        });
      },

      /**
       * Add single feature
       * @param feature
       */
      addFeature: function addFeature(feature) {
        this._addFeature(feature);
      },

      /**
       * Remove a feature
       * @param feature
       */
      removeFeature: function removeFeature(feature) {
        this._removeFeature(feature);
      },

      /**
       * Update (substitute) a feature
       * @param feature
       */
      updateFeature: function updateFeature(feature) {
        this._updateFeature(feature);
      },

      /**
       * Remove all feature
       */
      clear: function clear() {
        this._clearFeatures();
      },

      /**
       * Get features from server
       * @param opts
       * @return { Promise }
       */
      getFeatures: function getFeatures() {
        var _this3 = this;

        var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        return (0, _promisify.$promisify)(_asyncToGenerator(function* () {
          if (_this3._provider) {
            //call provider getFeatures to get features from server
            //get the feature base on response from server features, featurelockis etc ...
            var features = _this3._filterFeaturesResponse((yield _this3._provider.getFeatures(opts)));
            _this3.addFeatures(features);
            return features;
          }
          return _this3._features; // Get features stored. No call to server is done
        }));
      },

      /**
       * Commit changes (add, update, delete) to server
       * @param commitItems
       * @param featurestore Its is used????
       * @return {*}
       */
      commit: function commit(commitItems, featurestore) {
        var _this4 = this;

        return (0, _promisify.$promisify)(_asyncToGenerator(function* () {
          if (commitItems && _this4._provider) {
            commitItems.lockids = _this4._lockIds;
            return yield _XHR.XHR.post({
              url: _this4._provider._layer.getUrl('commit'),
              data: JSON.stringify(commitItems),
              contentType: 'application/json'
            });
          }
          return Promise.reject();
        }));
      },

      /**
       * setter to know when some features are locked
       */
      featuresLockedByOtherUser: function featuresLockedByOtherUser() {
        var features = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      }
    };

    return _this;
  }

  _createClass(FeaturesStore, [{
    key: 'clone',
    value: function clone() {
      return (0, _lodash2.default)(this);
    }
  }, {
    key: 'setProvider',
    value: function setProvider(provider) {
      this._provider = provider;
    }
  }, {
    key: 'getProvider',
    value: function getProvider() {
      return this._provider;
    }

    /**
     *  Unlock features. Other users can edit these features
     */

  }, {
    key: 'unlock',
    value: function unlock() {
      var _this5 = this;

      return (0, _promisify.$promisify)(_asyncToGenerator(function* () {
        return yield _XHR.XHR.post({ url: _this5._provider._layer.getUrl('unlock') });
      }));
    }

    /**
     * Filter features to add
     * @param options
     * @private
     * @return Array of features to add
     */

  }, {
    key: '_filterFeaturesResponse',
    value: function _filterFeaturesResponse() {
      var _this6 = this;

      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      /**
       * features uis array of feature returned from server and feature that are currently locked.
       * featurelocks is array of the feature that can be locker by current client request (not locked by another user)
       * featurelocks array item
       * {
       *   featureid: Is current id of feature locked
       *   lockid: Is a server unique lock id number
       * }
       * ex.
       * {featureid: "1", lockid: "6bbab1c1c03332fb39b8ffae35e557ba"}
       *
       * If featurelocks are less than features, it means that another user is editing these features
       *
       *
       * @type {*[]}
       */
      var _options$features = options.features,
          features = _options$features === undefined ? [] : _options$features,
          _options$featurelocks = options.featurelocks,
          featurelocks = _options$featurelocks === undefined ? [] : _options$featurelocks;

      //if no features locks mean another user locks all feature requests

      if (0 === featurelocks.length) {
        //if there are features on response
        if (features.length > 0) {
          //It means that another user locks these features
          this.featuresLockedByOtherUser(features);
        }
        return [];
      }

      //get already loaded feature id locked by current user
      var fids = this._lockIds.map(function (_ref4) {
        var featureid = _ref4.featureid;
        return featureid;
      });
      featurelocks.filter(function (_ref5) {
        var featureid = _ref5.featureid;
        return !fids.includes(featureid);
      }) //exclude features already locked by current user
      .forEach(function (fl) {
        return _this6._lockIds.push(fl);
      }); //update lockIds based on a featurelocks array from response

      //store features locked by another user
      var lockFeatures = [];

      //Store features to add to layers source
      var featuresToAdd = features.filter(function (f) {
        //get feature id
        var featureId = f.getId();
        //check if feature id is locked features
        //it means that is not locked by another user.
        if (featurelocks.find(function (_ref6) {
          var featureid = _ref6.featureid;
          return featureId == featureid;
        })) {
          //check if feature is not yet added for the current user
          if (_this6._loadedIds.indexOf(featureId) === -1) {
            _this6._loadedIds.push(featureId);
            return true;
          } else {
            return false; //feature locked by the current user
          }
        } else {
          lockFeatures.push(f);
          return false; //feature locked by another user
        }
      });

      //if features locks are less than features get from server,
      // it means that another user locks some features
      if (featurelocks.length < features.length) {
        this.featuresLockedByOtherUser(lockFeatures);
      }

      return featuresToAdd;
    }
  }, {
    key: 'getLockIds',
    value: function getLockIds() {
      return this._lockIds;
    }

    /**
     * Add new lockid
     */

  }, {
    key: 'addLockIds',
    value: function addLockIds(lockIds) {
      var _this7 = this;

      this._lockIds = _.union(this._lockIds, lockIds);
      this._lockIds.forEach(function (_ref7) {
        var featureid = _ref7.featureid;
        return _this7._loadedIds.push(featureid);
      });
    }

    /**
     * Get feature
     * @param id
     * @return { Feature }
     */

  }, {
    key: 'getFeatureById',
    value: function getFeatureById(id) {
      return this._features.find(function (f) {
        return id == f.getId();
      });
    }
  }, {
    key: 'getFeatureByUid',
    value: function getFeatureByUid(uid) {
      return this._features.find(function (f) {
        return uid === f.getUid();
      });
    }
  }, {
    key: '_addFeature',
    value: function _addFeature(feature) {
      this._features.push(feature);
    }

    /**
     * Substitute (update) feature after update
     */

  }, {
    key: '_updateFeature',
    value: function _updateFeature(feature) {
      var _this8 = this;

      this._features.find(function (feat, idx) {
        if (feature.getUid() === feat.getUid()) {
          _this8._features[idx] = feature;
          return true;
        }
      });
    }
  }, {
    key: 'setFeatures',
    value: function setFeatures() {
      var features = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      this._features = features;
    }
  }, {
    key: '_removeFeature',
    value: function _removeFeature(feature) {
      this._features = this._features.filter(function (f) {
        return feature.getUid() !== f.getUid();
      });
    }
  }, {
    key: '_clearFeatures',
    value: function _clearFeatures() {
      this._features = null;
      this._features = [];
      this._lockIds = [];
      this._loadedIds = [];
    }
  }, {
    key: 'getDataProvider',
    value: function getDataProvider() {
      return this._provider;
    }

    // only read downloaded features

  }, {
    key: 'readFeatures',
    value: function readFeatures() {
      return this._features;
    }
  }]);

  return FeaturesStore;
}(_g3wObject2.default);

},{"g3w-object":163,"lodash.clonedeep":24,"utils/XHR":215,"utils/promisify":267}],188:[function(require,module,exports){
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _gui = require('services/gui');

var _gui2 = _interopRequireDefault(_gui);

var _projections = require('store/projections');

var _projections2 = _interopRequireDefault(_projections);

var _getScaleFromResolution = require('utils/getScaleFromResolution');

var _XHR = require('utils/XHR');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @file ORIGINAL SOURCE: src/app/core/layers/mixins/geo.js@v3.10.2
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @since 3.11.0
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

/**
 * @TODO convert it to ES6 class (or external utils)
 *
 * @file
 * @since 3.9.0
 */

/**
 * ES6 mixin
 * 
 * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Classes/extends#mix-ins
 * 
 * @example class ImageLayer extends GeoLayerMixin(Layer) {}
 */
exports.default = function (BaseClass) {
  return function (_BaseClass) {
    _inherits(_class, _BaseClass);

    function _class() {
      _classCallCheck(this, _class);

      return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
    }

    _createClass(_class, [{
      key: 'setup',
      value: function setup() {
        var _this2 = this;

        var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        if (!this.config) {
          console.log("GeoLayerMixin must be used from a valid (geo) Layer instance");
          return;
        }

        Object.assign(this.config, {
          map_crs: options.project.getProjection().getCode(),
          multilayerid: config.multilayer,
          projection: config.projection ? config.projection.getCode() === config.crs.epsg ? config.projection : _projections2.default.get(config.crs) : undefined,
          attributions: config.attributions ? config.attributions : undefined
        });

        this.legendCategories = {};

        // Features that contain
        this.olSelectionFeatures = {}; // key id / fid of feature and values is an object with feature and added

        // state extend of layer setting geolayer property to true
        // and adding information of bbox
        Object.assign(this.state, {
          geolayer: "NoGeometry" !== config.geometrytype,
          legend: {
            url: null,
            loading: false,
            error: false,
            /** @deprecated since 3.8. Will be removed in 4.x. Use `expanded` attribute instead */
            show: true,
            /** used when categories changed (checkbox on TOC) and legend is on TAB */
            change: false
          },
          external: config.source && config.source.external || false,
          bbox: config.bbox || null,
          visible: config.visible || false,
          checked: config.visible || false,
          epsg: config.crs.epsg,
          hidden: config.hidden || false,
          scalebasedvisibility: config.scalebasedvisibility || false,
          minscale: config.minscale,
          maxscale: config.maxscale,
          ows_method: config.ows_method,

          /**
           * @type {boolean}
           */
          exclude_from_legend: 'boolean' === typeof config.exclude_from_legend ? config.exclude_from_legend : true,

          /**
           * Has more than one category's legend
           * 
           * @type {boolean}
           */
          categories: false,

          /**
           * Toggle legend item state (expandend or collapsed) in catalog layers (TOC)
           * 
           * @type {number}
           *
           * @since v3.8
           */
          expanded: config.expanded,

          /**
           * Layer opacity
           * 
           * @type {number} opacity range = [0, 100]
           * 
           * @since v3.8
           */
          opacity: config.opacity || 100
        });

        // sanitize source url
        if (config.source && config.source.url) {
          var checkUrl = new URL(this.config.source.url);
          // reserved WMS params
          ['VERSION', 'REQUEST', 'BBOX', 'LAYERS', 'WIDTH', 'HEIGHT', 'DPI', 'FORMAT', 'CRS'].forEach(function (p) {
            var params = [p.toUpperCase(), p.toLowerCase()];
            for (var i = 0; i < 2; i++) {
              var param = params[i];
              var value = checkUrl.searchParams.get(param);
              if (value) {
                _this2.config.source.url = _this2.config.source.url.replace(param + '=' + value, '');
                break;
              }
            }
          });
        }
      }

      /**
       * Legend Graphic section
       */

    }, {
      key: 'getLegendGraphic',
      value: function getLegendGraphic() {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            _ref$all = _ref.all,
            all = _ref$all === undefined ? true : _ref$all;

        return _XHR.XHR.get({
          url: this.getLegendUrl((window.initConfig.layout || { legend: {} }).legend, {
            categories: true,
            format: 'application/json', // is the format to request categories (icon and label of each category)
            all: all // true meaning no bbox no filter just all referred to
          })
        });
      }

      /**
       * Set layer categories legend
       * @param { Array }categories
       */

    }, {
      key: 'setCategories',
      value: function setCategories() {
        var categories = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

        this.legendCategories[this.getCurrentStyle().name] = categories;
        //set categories state attribute to true only if exist at least a rule key
        this.state.categories = (categories || []).filter(function (category) {
          return category.ruleKey;
        }).length > 0;
      }

      /**
       * Return eventually categories of layers legend
       * @returns {string[] | string | [] | *[] | boolean | {default: {level: *, appenders: string[]}}}
       */

    }, {
      key: 'getCategories',
      value: function getCategories() {
        return this.legendCategories[this.getCurrentStyle().name];
      }

      /**
       * Clear all categories
       */

    }, {
      key: 'clearCategories',
      value: function clearCategories() {
        this.legendCategories = {};
        this.state.categories = false;
      }

      /**
       * End Legend Graphic section
       */

      /**
       * [LAYER SELECTION]
       * 
       * Clear all selection Openlayers features
       */

    }, {
      key: 'clearOlSelectionFeatures',
      value: function clearOlSelectionFeatures() {
        this.olSelectionFeatures = {};
      }

      /**
       * [LAYER SELECTION]
       * 
       * Get OpenLayer selection feature by feature id
       * 
       * @param id
       * @returns {*}
       */

    }, {
      key: 'getOlSelectionFeature',
      value: function getOlSelectionFeature(id) {
        return this.olSelectionFeatures[id];
      }

      /**
       * [LAYER SELECTION]
       * 
       * Update selected feature (Case change geometry)
       * 
       * @param id
       * @param feature
       */

    }, {
      key: 'updateOlSelectionFeature',
      value: function updateOlSelectionFeature() {
        var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            id = _ref2.id,
            feature = _ref2.feature;

        var selected = this.getOlSelectionFeature(id);
        if (selected) {
          selected.feature = feature;
          _gui2.default.getService('map').setSelectionFeatures('update', { feature: feature });
        }
      }

      /**
       * [LAYER SELECTION]
       * 
       * Delete OpenLayer feature selection by feature id
       * 
       * @param id
       */

    }, {
      key: 'deleteOlSelectionFeature',
      value: function deleteOlSelectionFeature(id) {
        var selected = this.getOlSelectionFeature(id);
        if (selected) {
          /** @FIXME undefined variable */
          _gui2.default.getService('map').setSelectionFeatures('remove', { feature: selected.feature });
          delete this.olSelectionFeatures[id];
        }
      }

      /**
       * [LAYER SELECTION]
       * 
       * Get all OpenLayers feature selections
       * 
       * @returns { {} | null }
       */

    }, {
      key: 'getOlSelectionFeatures',
      value: function getOlSelectionFeatures() {
        return this.olSelectionFeatures;
      }

      /**
      * [LAYER SELECTION]
      
      * @param id
      * @param feature
      *
      * @returns {*}
      */

    }, {
      key: 'addOlSelectionFeature',
      value: function addOlSelectionFeature() {
        var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            id = _ref3.id,
            feat = _ref3.feature;

        //create a new ol feature
        var feature = new ol.Feature(feat.geometry);
        feature.setId(id);
        Object.entries(feat.attributes).forEach(function (_ref4) {
          var _ref5 = _slicedToArray(_ref4, 2),
              a = _ref5[0],
              v = _ref5[1];

          return feature.set(a, v);
        });
        this.olSelectionFeatures[id] = this.olSelectionFeatures[id] || {
          feature: feature,
          added: false,
          selected: false /** @since 3.9.9 */
        };
        return this.olSelectionFeatures[id];
      }

      /**
       * [LAYER SELECTION]
       *
       * Set selection layer on a map not visible
       */

    }, {
      key: 'hideOlSelectionFeatures',
      value: function hideOlSelectionFeatures() {
        _gui2.default.getService('map').toggleSelection(false, this.state.id);
      }

      /**
       * [LAYER SELECTION]
       * 
       * Show all selection features
       */

    }, {
      key: 'updateMapOlSelectionFeatures',
      value: function updateMapOlSelectionFeatures() {
        // Loop `added` features (selected)
        Object.values(this.olSelectionFeatures).forEach(function (f) {
          if (f.selected && !f.added) {
            _gui2.default.getService('map').setSelectionFeatures('add', { feature: f.feature });
            f.added = true;
          }

          if (!f.selected && f.added) {
            _gui2.default.getService('map').setSelectionFeatures('remove', { feature: f.feature });
            f.added = false;
          }
        });
        // Ensures visibility of selection layer on a map
        // in case of layer filter active, always not visible
        _gui2.default.getService('map').toggleSelection(!this.state.filter.active && Object.values(this.olSelectionFeatures).some(function (f) {
          return f.selected;
        }), this.state.id);
      }

      /**
       * [LAYER SELECTION]
       * 
       * Toggle `added` property on all features
       */

    }, {
      key: 'setInversionOlSelectionFeatures',
      value: function setInversionOlSelectionFeatures() {
        Object.values(this.olSelectionFeatures).forEach(function (f) {
          //invert select state
          f.selected = !f.selected;
          if (!f.selected && f.added) {
            _gui2.default.getService('map').setSelectionFeatures('remove', { feature: f.feature });
            f.added = false;
          }
          if (f.selected && !f.added) {
            _gui2.default.getService('map').setSelectionFeatures('add', { feature: f.feature });
            f.added = true;
          }
        });
      }

      /**
       * [LAYER SELECTION]
       * 
       * @param fid
       * @param action
       * 
       * @returns {*}
       */

    }, {
      key: 'setOlSelectionFeatureByFid',
      value: function setOlSelectionFeatureByFid(fid, action) {
        var selected = this.getOlSelectionFeature(fid);
        if (selected && selected.feature) {
          //set selected
          selected.selected = 'add' === action;
          return this.setOlSelectionFeatures({
            id: fid,
            feature: selected.feature
          }, action);
        }
      }

      /**
       * [LAYER SELECTION]
       * 
       * @param feature
       * @param action
       * 
       * @returns { boolean }
       */

    }, {
      key: 'setOlSelectionFeatures',
      value: function setOlSelectionFeatures(feature) {
        var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'add';


        // select a single feature
        if (feature) {
          var feat = this.getOlSelectionFeature(feature.id);
          feat.feature.__layerId = 'add' === action && !feat.added ? this.getId() : undefined; // <-- used when working with selected Layer features
          this.updateMapOlSelectionFeatures();
        }

        // select all features
        if (!feature) {
          Object.values(this.olSelectionFeatures).forEach(function (feat) {
            //remove selection feature
            if (feat.added) {
              _gui2.default.getService('map').setSelectionFeatures('remove', { feature: feat.feature });
            }
            feat.added = false;
            feat.selected = false;
          });
        }

        return undefined === Object.values(this.olSelectionFeatures).find(function (feat) {
          return feat.added;
        });
      }
    }, {
      key: 'isLayerCheckedAndAllParents',
      value: function isLayerCheckedAndAllParents() {
        var checked = this.isChecked();
        if (checked) {
          var parentGroup = this.state.parentGroup;
          //loop from bottom to top
          while (checked && parentGroup) {
            checked = checked && parentGroup.checked;
            parentGroup = parentGroup.parentGroup;
          }
        }
        return checked;
      }

      /**
       * Set layer legend item `checked` state (TOC)
       * 
       * @param { boolean } bool
       */

    }, {
      key: 'setChecked',
      value: function setChecked(bool) {
        this.state.checked = bool;
      }

      /**
       * @returns { boolean } whether layer legend item is checked (TOC)
       */

    }, {
      key: 'isChecked',
      value: function isChecked() {
        return this.state.checked;
      }

      /**
       * Is a method that check for visiblitity dissabled (based on scalevisibility) and checked on toc
       * @param { Boolean } bool
       * @returns {*}
       */

    }, {
      key: 'setVisible',
      value: function setVisible(bool) {
        //get current visibility
        var visible = this.state.visible;
        // set visibility bool and is checked
        this.state.visible = bool && this.isChecked();
        //Check if change the visibility
        if (visible !== this.state.visible) {
          this.change();
        }
        return this.state.visible;
      }
    }, {
      key: 'isVisible',
      value: function isVisible() {
        return this.state.visible;
      }
    }, {
      key: 'isDisabled',
      value: function isDisabled() {
        return this.state.disabled;
      }

      /**
       *
       * @param scale
       * @return {boolean}
       */

    }, {
      key: 'isPrintable',
      value: function isPrintable() {
        var _ref6 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            scale = _ref6.scale;

        return this.isLayerCheckedAndAllParents() && (!this.state.scalebasedvisibility || scale >= this.state.maxscale && scale <= this.state.minscale);
      }

      //get style form layer

    }, {
      key: 'getStyles',
      value: function getStyles() {
        return this.config.source.external ? this.config.source.styles : this.config.styles;
      }
    }, {
      key: 'getStyle',
      value: function getStyle() {
        return this.config.source.external ? this.config.source.styles : this.config.styles ? this.config.styles.find(function (s) {
          return s.current;
        }).name : '';
      }

      /**
       * Get transparency property
       * 
       * @returns {number}
       * 
       * @since v3.8
       */

    }, {
      key: 'getOpacity',
      value: function getOpacity() {
        return this.state.opacity;
      }

      /**
       * Method to change the current style of layer
       * @param name
       * @returns { Boolean }
       */

    }, {
      key: 'setCurrentStyle',
      value: function setCurrentStyle(name) {
        var changed = !this.config.styles.find(function (s) {
          return name === s.name;
        }).current;
        this.config.styles.forEach(function (s) {
          return s.current = name === s.name;
        });
        return changed;
      }
    }, {
      key: 'getCurrentStyle',
      value: function getCurrentStyle() {
        return this.config.styles.find(function (s) {
          return s.current;
        });
      }

      /**
       * Disable layer by check scalevisibility configuration value
       * @param resolution
       * @param mapUnits
       */

    }, {
      key: 'setDisabled',
      value: function setDisabled(resolution) {
        var mapUnits = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'm';

        if (this.state.scalebasedvisibility) {
          var mapScale = (0, _getScaleFromResolution.getScaleFromResolution)(resolution, mapUnits);
          this.state.disabled = !(mapScale >= this.state.maxscale && mapScale <= this.state.minscale);
          this.state.disabled = this.state.minscale === 0 ? !(mapScale >= this.state.maxscale) : this.state.disabled;
          // needed to check if call setVisible is change disable property
          // looping through parentfolter checked
          var setVisible = true;
          var parentGroup = this.state.parentGroup;
          while (parentGroup) {
            setVisible = setVisible && parentGroup.checked;
            parentGroup = parentGroup.parentGroup;
          }
          if (setVisible) {
            this.setVisible(!this.state.disabled);
          }
          // change toc highlight property based on disabled otr not
          if (this.isFilterable()) {
            this.setTocHighlightable(!this.state.disabled);
          }
        } else {
          this.state.disabled = false;
        }
      }
    }, {
      key: 'getMultiLayerId',
      value: function getMultiLayerId() {
        return this.config.multilayerid;
      }
    }, {
      key: 'getGeometryType',
      value: function getGeometryType() {
        return this.config.geometrytype;
      }
    }, {
      key: 'getOwsMethod',
      value: function getOwsMethod() {
        return this.config.ows_method;
      }
    }, {
      key: 'setProjection',
      value: function setProjection() {
        var crs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        this.config.projection = _projections2.default.get(crs);
      }
    }, {
      key: 'getProjection',
      value: function getProjection() {
        return this.config.projection;
      }
    }, {
      key: 'getEpsg',
      value: function getEpsg() {
        return this.config.crs.epsg;
      }
    }, {
      key: 'getCrs',
      value: function getCrs() {
        return this.config.projection ? this.config.projection.getCode() : null;
      }
    }, {
      key: 'getMapCrs',
      value: function getMapCrs() {
        return this.config.map_crs;
      }
    }, {
      key: 'isCached',
      value: function isCached() {
        return this.config.cache_url && '' !== this.config.cache_url;
      }
    }, {
      key: 'getCacheUrl',
      value: function getCacheUrl() {
        // mapproxy provider → cache_url already contains "{z}/{x}/{-y}.png"
        if (this.isCached() && this.config.cache_provider && 'mapproxy' === this.config.cache_provider) {
          return this.config.cache_url;
        }
        if (this.isCached()) {
          return this.config.cache_url + '/{z}/{x}/{y}.png';
        }
      }

      // return if layer has inverted axis

    }, {
      key: 'hasAxisInverted',
      value: function hasAxisInverted() {
        var projection = this.getProjection();
        var axisOrientation = projection.getAxisOrientation ? projection.getAxisOrientation() : "enu";
        return axisOrientation.substr(0, 2) === 'ne';
      }

      /**
       * @virtual method need to be implemented by subclasses
       */

    }, {
      key: 'getMapLayer',
      value: function getMapLayer() {
        console.log('overwrite by single layer');
      }

      /**
       *
       * @param projection
       */

    }, {
      key: 'setMapProjection',
      value: function setMapProjection(projection) {
        this._mapProjection = projection;
      }
    }, {
      key: 'getMapProjection',
      value: function getMapProjection() {
        return this._mapProjection;
      }
    }]);

    return _class;
  }(BaseClass);
};

},{"services/gui":207,"store/projections":214,"utils/XHR":215,"utils/getScaleFromResolution":251}],189:[function(require,module,exports){
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RasterLayer = exports.ImageLayer = undefined;

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _g3wConstants = require('g3w-constants');

var _g3wObject = require('g3w-object');

var _g3wObject2 = _interopRequireDefault(_g3wObject);

var _application = require('store/application');

var _application2 = _interopRequireDefault(_application);

var _projections = require('store/projections');

var _projections2 = _interopRequireDefault(_projections);

var _geoMixin = require('map/layers/geo-mixin');

var _geoMixin2 = _interopRequireDefault(_geoMixin);

var _layer = require('map/layers/layer');

var _vectorlayer = require('map/layers/vectorlayer');

var _get_legend_params2 = require('utils/get_legend_params');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @file ORIGINAL SOURCE: src/app/core/layers/imagelayer.js@v3.10.2
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @since 3.11.0
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

/**
 * Stringify a query URL param (eg. `&WIDTH=700`)
 * 
 * @param name
 * @param value
 * 
 * @returns { string | null } a string if value is set or null
 */
function __(name, value) {
  return [null, undefined].includes(value) ? value : '' + name + value;
}

/**
 * @TODO merge "RasterLayer" class into "ImageLayer"
 * 
 * ORIGINAL SOURCE: src/app/core/layers/map/maplayer.js@v3.10.1
 * ORIGINAL SOURCE: src/app/core/layers/map/wmslayer.js@v3.10.1
 * ORIGINAL SOURCE: src/app/core/layers/map/wmstlayer.js@v3.10.1
 * ORIGINAL SOURCE: src/app/core/layers/map/xyzlayer.js@v3.10.1
 * ORIGINAL SOURCE: src/app/core/layers/map/arcgismapserverlayer.js@v3.10.1
 */

var RasterLayer = function (_G3WObject) {
  _inherits(RasterLayer, _G3WObject);

  function RasterLayer() {
    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var extraParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'GET';

    _classCallCheck(this, RasterLayer);

    var _this = _possibleConstructorReturn(this, (RasterLayer.__proto__ || Object.getPrototypeOf(RasterLayer)).call(this));

    _this.config = config;
    _this.id = config.id;
    _this.iframe_internal = config.iframe_internal || false;
    _this.extent = config.extent;
    _this.projection = config.projection;
    _this.layer = null;
    _this.layers = config.layers || []; // store all enabled layers
    _this.allLayers = []; // store all layers
    _this.showSpinnerWhenLoading = true;

    if ('XYZ' !== _this.config.type) {
      _this.LAYERTYPE = {
        LAYER: 'layer',
        MULTILAYER: 'multilayer'
      };
      _this.getInfoFormat = function () {
        return 'application/vnd.ogc.gml';
      };
      _this.getGetFeatureInfoUrl = function (coordinate, resolution, epsg, params) {
        return _this.getOLLayer().getSource().getGetFeatureInfoUrl(coordinate, resolution, epsg, params);
      };
      _this.getQueryUrl = function () {
        if (_this.layers[0].infourl && '' !== _this.layers[0].infourl) {
          return _this.layers[0].infourl;
        }
        return _this.config.url;
      };
    }

    _this.extraParams = extraParams;

    _this._method = method;
    return _this;
  }

  _createClass(RasterLayer, [{
    key: 'getId',
    value: function getId() {
      return this.id;
    }
  }, {
    key: 'getOLLayer',
    value: function getOLLayer(withLayers) {
      if (!this._olLayer) {
        this._olLayer = this._makeOlLayer(withLayers);
      }
      return this._olLayer;
    }
  }, {
    key: 'getSource',
    value: function getSource() {
      return this.getOLLayer().getSource();
    }
  }, {
    key: 'getLayerConfigs',
    value: function getLayerConfigs() {
      return this.layers;
    }
  }, {
    key: 'addLayer',
    value: function addLayer(layer) {
      if (!this.allLayers.find(function (l) {
        return layer === l;
      })) {
        this.allLayers.push(layer);
      }
      if (!this.layers.find(function (l) {
        return layer === l;
      })) {
        this.layers.push(layer);
      }
      if ('XYZ' === this.config.type) {
        this.layer = layer;
      }
    }
  }, {
    key: 'removeLayer',
    value: function removeLayer(layer) {
      this.layers = this.layers.filter(function (l) {
        return layer !== l;
      });
    }
  }, {
    key: 'isVisible',
    value: function isVisible() {
      return this.layers.filter(function (l) {
        return l.isVisible();
      }).length > 0;
    }

    /**
     * @param {boolean} withLayers
     * 
     * @returns { RasterLayer._makeOlLayer }
     * 
     * @listens ol.source.ImageWMS~imageloadstart
     * @listens ol.source.ImageWMS~imageloadend
     * @listens ol.source.ImageWMS~imageloaderror
     */

  }, {
    key: '_makeOlLayer',
    value: function _makeOlLayer(withLayers) {
      var _this2 = this;

      var olLayer = void 0;

      /** @type { 'image' | 'tile' } */
      var image = 'image';

      // ARCGIS LAYER
      if ('ARCGISMAPSERVER' === this.config.type) {
        olLayer = new ol.layer.Tile({
          visible: true,
          source: new ol.source.TileArcGISRest({
            url: this.config.url,
            projection: this.config.projection
          })
        });
      }

      // WMTS LAYER
      else if ('WMTS' === this.config.type) {
          image = 'tile';
          var layerObj = {
            url: 'mapproxy' === this.config.cache_provider || !(this.layers[0] && this.layers[0].getWmsUrl) ? this.config.url : this.layers[0].getWmsUrl(),
            id: this.config.id,
            projection: this.config.projection,
            iframe_internal: this.iframe_internal,
            layers: withLayers ? this.layers.map(function (l) {
              return l.getWMSLayerName();
            }) : this.layers,
            cache_provider: this.config.cache_provider, /** @since 3.10.0 **/
            cache_type: this.config.cache_type, /** @since 3.10.0  tms, wms**/
            cache_layer: this.config.cache_layer,
            cache_extent: this.config.cache_extent,
            cache_grid: this.config.cache_grid,
            cache_grid_extent: this.config.cache_grid_extent
          };

          /** @since 3.10.0 - MapProxy WMTS layer **/
          var resolutions = 'mapproxy' === layerObj.cache_provider && ol.tilegrid.createXYZ({ extent: layerObj.cache_grid_extent }).getResolutions();

          olLayer = resolutions ? new ol.layer.Tile({
            source: new ol.source.WMTS({
              url: layerObj.url,
              layer: layerObj.cache_layer,
              matrixSet: layerObj.cache_grid,
              format: layerObj.cache_format || 'png',
              projection: layerObj.layers[0].getProjection(),
              tileGrid: new ol.tilegrid.WMTS({
                resolutions: resolutions,
                origin: ol.extent.getTopLeft(layerObj.cache_grid_extent),
                matrixIds: resolutions.map(function (_, i) {
                  return i;
                })
              }),
              style: layerObj.style || '',
              transparent: false
            })
          }) : RasterLayer._makeOlLayer({
            layerObj: layerObj,
            extraParams: this.extraParams || {},
            tiled: true
          });
        }

        // XYZ LAYER
        else if ('XYZ' === this.config.type) {
            var projection = this.config.url && this.projection ? this.projection : this.layer.getProjection();

            olLayer = new ol.layer.Tile({
              visible: true,
              projection: projection,
              source: new ol.source.XYZ({
                url: this.config.url,
                maxZoom: 20,
                minZoom: undefined,
                projection: projection,
                crossOrigin: undefined,
                tileLoadFunction: this.iframe_internal ? function (tile, url) {
                  fetch('POST' === _this2._method ? (url || '').split('?')[0] : url, {
                    method: _this2._method,
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
                    body: 'POST' === _this2._method ? url.split('?')[1] : undefined
                  }).then(function () {
                    var _ref = _asyncToGenerator(function* (response) {
                      return tile.getImage().src = window.URL.createObjectURL((yield response.blob()));
                    });

                    return function (_x4) {
                      return _ref.apply(this, arguments);
                    };
                  }()).catch(function (e) {
                    console.error('Invalid tile', ol.TileState.ERROR, e);tile.setState(ol.TileState.ERROR);
                  });
                } : undefined,
                /** @since 3.10.0 - Map Proxy cache_provider **/
                tileGrid: 'degrees' === projection.getUnits() || 'mapproxy' === this.config.cache_provider ? new ol.tilegrid.TileGrid({
                  // Need to remove the first resolution because in this version of ol createXYZ doesn't accept maxResolution options.
                  // The extent of EPSG:4326 is not squared [-180, -90, 180, 90] as EPSG:3857 so the resolution is calculated
                  // by Math.max(width(extent)/tileSize,Height(extent)/tileSize)
                  // we need to calculate to Math.min instead, so we have to remove the first resolution
                  resolutions: ol.tilegrid.createXYZ({ extent: projection.getExtent(), maxZoom: 20 }).getResolutions().slice(1),
                  extent: projection.getExtent()
                }) : undefined
              })
            });
          }

          // WMS LAYER
          else {
              olLayer = RasterLayer._makeOlLayer({
                layerObj: {
                  url: this.layers[0] && this.layers[0].getWmsUrl ? this.layers[0].getWmsUrl() : this.config.url,
                  id: this.config.id,
                  projection: this.config.projection,
                  iframe_internal: this.iframe_internal,
                  layers: withLayers ? this.layers.map(function (l) {
                    return l.getWMSLayerName();
                  }) : this.layers,
                  /** @since 3.9.1 */
                  format: this.config.format
                },
                extraParams: this.extraParams
              }, this._method);
            }

      olLayer.getSource().on(image + 'loadstart', function () {
        return _this2.emit('loadstart');
      });
      olLayer.getSource().on(image + 'loadend', function () {
        return _this2.emit('loadend');
      });
      olLayer.getSource().on(image + 'loaderror', function () {
        return _this2.emit('loaderror');
      });

      return olLayer;
    }

    //update Layers

  }, {
    key: 'update',
    value: function update() {
      var mapState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var extraParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var force = extraParams.force,
          params = _objectWithoutProperties(extraParams, ['force']);

      // check which layers have to be disabled


      if (!force) {
        var resolution = mapState.resolution,
            mapUnits = mapState.mapUnits;

        this.allLayers.forEach(function (l) {
          l.setDisabled(resolution, mapUnits);return l.isDisabled();
        });
      }

      if ('XYZ' === this.config.type) {
        this._olLayer.setVisible(this.layer.isVisible());
        return;
      }

      var layers = this.layers.filter(function (l) {
        return l.isVisible();
      }) || [];

      // skip when ..
      if (layers.length <= 0) {
        this._olLayer.setVisible(false);
        return;
      }

      var STYLES = [];
      var OPACITIES = [];
      var LEGEND_ON = undefined;
      var LEGEND_OFF = undefined;

      layers.forEach(function (l) {
        var _get_legend_params = (0, _get_legend_params2.get_legend_params)(l),
            on = _get_legend_params.LEGEND_ON,
            off = _get_legend_params.LEGEND_OFF;

        STYLES.push(l.getStyle());
        OPACITIES.push(parseInt(l.getOpacity() / 100 * 255));
        if (on) {
          LEGEND_ON = undefined === LEGEND_ON ? on : LEGEND_ON + ';' + on;
        }
        if (off) {
          LEGEND_OFF = undefined === LEGEND_OFF ? off : LEGEND_OFF + ';' + off;
        }
      });

      this._olLayer.setVisible(true);
      //check if a layer source has with updateParams method
      /** @TODO Check a better way to do this */
      if (this._olLayer.getSource().updateParams) {
        this._olLayer.getSource().updateParams(_extends({}, params, {
          LEGEND_ON: LEGEND_ON,
          LEGEND_OFF: LEGEND_OFF,
          filtertoken: _application2.default.tokens.filtertoken,
          LAYERS: '' + (layers[0].isArcgisMapserver() ? 'show:' : '') + layers.map(function (l) {
            return l.getWMSLayerName();
          }).join(','),
          STYLES: STYLES.join(','),
          /** @since 3.8 */
          OPACITIES: OPACITIES.join(',')
        }));
      }
    }
  }, {
    key: 'setupCustomMapParamsToLegendUrl',
    value: function setupCustomMapParamsToLegendUrl() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      if ('XYZ' !== this.config.type) {
        [].concat(this.layer || this.layers).forEach(function (l) {
          return l.setMapParamstoLegendUrl(params);
        });
      }
    }
  }]);

  return RasterLayer;
}(_g3wObject2.default);

/**
 * ORIGINAL SOURCE: src/app/g3w-ol/layers/rasters.js@v3.10.0
 * 
 * @since 3.11.0
 */


RasterLayer._makeOlLayer = function () {
  var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var method = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'GET';

  return new (opts.tiled ? ol.layer.Tile : ol.layer.Image)({
    id: opts.layerObj.id,
    name: opts.layerObj.name,
    opacity: undefined !== opts.layerObj.opacity ? opts.layerObj.opacity : 1.0,
    visible: opts.layerObj.visible,
    extent: opts.layerObj.extent,
    maxResolution: opts.layerObj.maxResolution,
    source: new (opts.tiled ? ol.source.TileWMS : ol.source.ImageWMS)({
      ratio: 1,
      url: opts.layerObj.url,
      projection: opts.layerObj.projection ? opts.layerObj.projection.getCode() : null,
      params: _extends({}, Object.fromEntries(Object.entries({
        DPI: _g3wConstants.DOTS_PER_INCH,
        TRANSPARENT: true,
        FORMAT: opts.layerObj.format,
        LAYERS: undefined !== opts.layerObj.layers ? opts.layerObj.layers : '',
        VERSION: undefined !== opts.layerObj.version ? opts.layerObj.version : '1.3.0',
        SLD_VERSION: undefined !== opts.layerObj.sld_version ? opts.layerObj.sld_version : '1.1.0'
      })
      // prevents sending "FORMAT" parameter when undefined
      .filter(function (_ref2) {
        var _ref3 = _slicedToArray(_ref2, 2),
            key = _ref3[0],
            val = _ref3[1];

        return 'FORMAT' !== key ? true : undefined !== val;
      })), opts.extraParams || {}),
      imageLoadFunction: opts.layerObj.iframe_internal || 'POST' === method ? function (tile, url) {
        fetch('POST' === method ? (url || '').split('?')[0] : url, {
          method: method,
          headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
          body: 'POST' === method ? url.split('?')[1] : undefined
        }).then(function () {
          var _ref4 = _asyncToGenerator(function* (response) {
            return tile.getImage().src = window.URL.createObjectURL((yield response.blob()));
          });

          return function (_x10) {
            return _ref4.apply(this, arguments);
          };
        }()).catch(function (e) {
          console.error('Invalid tile', ol.TileState.ERROR, e);tile.setState(ol.TileState.ERROR);
        });
      } : undefined
    })
  });
};

/**
 * @param config.id
 * @param config.title
 * @param config.name
 * @param config.origname
 * @param config.multilayerid
 * @param config.servertype
 * @param config.source
 * @param config.crs
 * @param config.projection
 * @param config.bbox
 * @param config.capabilities
 * @param config.cache_url
 * @param { string } config.cache_provider since 3.10.0 (eg. "mapproxy")
 * @param config.baselayer
 * @param config.geometrytype
 * @param config.editops
 * @param config.expanded
 * @param config.fields
 * @param config.wmsUrl
 * @param config.infoformat
 * @param config.infourl
 * @param config.maxscale
 * @param config.minscale
 * @param config.visible
 * @param config.scalebasedvisibility
 * @param config.wfscapabilities
 * @param config.ows_method
 * @param config.wms_use_layer_ids
 * @param config.styles
 */

var ImageLayer = function (_GeoLayerMixin) {
  _inherits(ImageLayer, _GeoLayerMixin);

  function ImageLayer() {
    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, ImageLayer);

    var _this3 = _possibleConstructorReturn(this, (ImageLayer.__proto__ || Object.getPrototypeOf(ImageLayer)).call(this, config, options));

    _this3._BASE_LAYER = options._BASE_LAYER;

    _this3.setters = {
      change: function change() {}
    };

    _this3.config.baselayer = config.baselayer || false;
    _this3.type = _layer.Layer.LayerTypes.IMAGE;
    _this3.legendUrl = null;
    _this3.customParams = {};

    _this3.setup(config, options);

    /**
     * ORIGINAL SOURCE: src/app/core/layers/layerfactory.js@v3.10.2
     */
    if ('OSM' === _this3._BASE_LAYER) {
      _this3._makeOlLayer = function () {
        return new ol.layer.Tile({
          source: new ol.source.OSM({ url: _this3.config.url }),
          id: _this3.config.name || 'osm',
          title: _this3.config.title || 'OSM',
          basemap: true
        });
      };
    }

    /**
     * ORIGINAL SOURCE: src/app/core/layers/layerfactory.js@v3.10.2
     */
    if ('Bing' === _this3._BASE_LAYER) {
      _this3._makeOlLayer = function () {
        var name = {
          streets: 'Road',
          aerial: 'Aerial',
          aerialwithlabels: 'AerialWithLabels'
        }[_this3.config.source && _this3.config.source.subtype] || 'Aerial';
        return new ol.layer.Tile({
          name: name,
          visible: false,
          preload: Infinity,
          source: new ol.source.BingMaps({ imagerySet: name, key: _application2.default.keys.vendorkeys.bing }),
          basemap: true
        });
      };
    }

    /**
     * ORIGINAL SOURCE: src/app/core/layers/layerfactory.js@v3.10.2
     */
    if ('TMS' === _this3._BASE_LAYER) {
      _this3._makeOlLayer = function () {
        var url = undefined !== _this3.config.url ? _this3.config.url : null;
        var projection = url && _this3.getProjectionFromCrs(_this3.config.crs);
        if (!url) {
          return;
        }
        return new ol.layer.Tile({
          visible: false,
          projection: projection,
          source: new ol.source.XYZ({
            url: url,
            maxZoom: _this3.config.maxZoom,
            minZoom: _this3.config.minZoom,
            projection: projection,
            crossOrigin: 'anonymous',
            // tileLoadFunction:  undefined,
            /** @since 3.10.0 - Map Proxy cache_provider **/
            tileGrid: 'degrees' === projection.getUnits() ? new ol.tilegrid.TileGrid({
              // Need to remove the first resolution because in this version of ol createXYZ doesn't accept maxResolution options.
              // The extent of EPSG:4326 is not squared [-180, -90, 180, 90] as EPSG:3857 so the resolution is calculated
              // by Math.max(width(extent)/tileSize,Height(extent)/tileSize)
              // we need to calculate to Math.min instead, so we have to remove the first resolution
              resolutions: ol.tilegrid.createXYZ({ extent: projection.getExtent(), maxZoom: _this3.config.maxZoom }).getResolutions().slice(1),
              extent: projection.getExtent()
            }) : undefined
          })
        });
      };
    }

    /**
     * ORIGINAL SOURCE: src/app/core/layers/layerfactory.js@v3.10.2
     */
    if ('WMTS' === _this3._BASE_LAYER) {
      _this3._makeOlLayer = function () {
        // use this config to get params
        var _this3$config = _this3.config,
            url = _this3$config.url,
            layer = _this3$config.layer,
            attributions = _this3$config.attributions,
            matrixSet = _this3$config.matrixSet,
            _this3$config$format = _this3$config.format,
            format = _this3$config$format === undefined ? 'image/png' : _this3$config$format,
            _this3$config$style = _this3$config.style,
            style = _this3$config$style === undefined ? 'default' : _this3$config$style,
            requestEncoding = _this3$config.requestEncoding,
            grid = _this3$config.grid,
            grid_extent = _this3$config.grid_extent;

        /** @since 3.10.0 */

        var projection = _this3.config.projection || _this3.getProjectionFromCrs(_this3.config.crs);

        if (matrixSet) {
          var size = ol.extent.getWidth(projection.getExtent()) / 256;
          return new ol.layer.Tile({
            opacity: .7,
            source: new ol.source.WMTS({
              url: url,
              projection: projection,
              layer: layer,
              matrixSet: matrixSet,
              requestEncoding: requestEncoding,
              format: format,
              attributions: attributions,
              tileGrid: new ol.tilegrid.WMTS({
                origin: ol.extent.getTopLeft(projection.getExtent()),
                resolutions: Array.from({ length: 14 }, function (_, z) {
                  return size / Math.pow(2, z);
                }),
                matrixIds: Array.from({ length: 14 }, function (_, z) {
                  return z;
                })
              }),
              style: style
            })
          });
        }

        /** @since 3.10.0 WMTS based on mapproxy*/
        if (grid && grid_extent) {
          var resolutions = ol.tilegrid.createXYZ({ extent: grid_extent }).getResolutions();
          return new ol.layer.Tile({
            source: new ol.source.WMTS({
              url: url,
              layer: layer,
              projection: projection,
              matrixSet: grid,
              format: format || 'png',
              tileGrid: new ol.tilegrid.WMTS({
                origin: ol.extent.getTopLeft(grid_extent),
                resolutions: resolutions,
                matrixIds: resolutions.map(function (_, z) {
                  return z;
                })
              }),
              style: style,
              transparent: false
            })
          });
        }
      };
    }

    /**
     * ORIGINAL SOURCE: src/app/core/layers/layerfactory.js@v3.10.2
     */
    if ('WMS' === _this3._BASE_LAYER) {
      _this3._makeOlLayer = function () {
        return RasterLayer._makeOlLayer({
          layerObj: {
            url: _this3.config.url,
            projection: _this3.getProjectionFromCrs(_this3.config.crs),
            attributions: _this3.config.attributions,
            layers: _this3.config.layers,
            tiled: undefined === _this3.config.singleTile ? false : _this3.config.singleTile,
            opacity: undefined === _this3.config.opacity ? 1 : _this3.config.opacity
          }
        });
      };
    }

    /**
     * ORIGINAL SOURCE: src/app/core/layers/layerfactory.js@v3.10.2
     */
    if ('ARCGISMAPSERVER' === _this3._BASE_LAYER) {
      _this3._makeOlLayer = function () {
        var _this3$config2 = _this3.config,
            url = _this3$config2.url,
            _this3$config2$visibl = _this3$config2.visible,
            visible = _this3$config2$visibl === undefined ? true : _this3$config2$visibl,
            extent = _this3$config2.extent,
            projection = _this3$config2.projection,
            attributions = _this3$config2.attributions,
            crossOrigin = _this3$config2.crossOrigin;


        return new ol.layer.Tile({
          extent: extent,
          visible: visible,
          source: new ol.source.TileArcGISRest({
            url: url,
            projection: projection,
            attributions: attributions,
            crossOrigin: crossOrigin
          })
        });
      };
    }

    /**
     * ORIGINAL SOURCE: src/app/core/layers/baselayer.js@v3.10.0
     * 
     * @since 3.11.0
     */
    if (_this3._makeOlLayer && _this3.isWMS()) {
      _this3._mapLayer = new RasterLayer({
        url: _this3.getWmsUrl(),
        id: _this3.state.id,
        tiled: _this3.state.tiled
      });
      _this3._mapLayer.addLayer(_this3);
    } else if (_this3._makeOlLayer) {
      _this3._mapLayer = _this3;
    }
    return _this3;
  }

  /**
   *
   * Used by the following plugins: "plugin"
   * @TODO Move it on  https://github.com/g3w-suite/g3w-client-plugin-editing
   *
   *
   * @param force
   * @param vectorurl
   * @param project_type
   * @param project
   * @return {Promise<any|null>}
   */


  _createClass(ImageLayer, [{
    key: 'getLayerForEditing',
    value: function () {
      var _ref5 = _asyncToGenerator(function* () {
        var _ref6 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            _ref6$force = _ref6.force,
            force = _ref6$force === undefined ? false : _ref6$force,
            vectorurl = _ref6.vectorurl,
            project_type = _ref6.project_type,
            project = _ref6.project;

        if (!force && !this.isEditable()) {
          return null;
        }

        // set editing layer
        try {
          var layerForEditing = yield new _vectorlayer.VectorLayer(this.config, {
            vectorurl: vectorurl,
            project_type: project_type,
            project: project || _application2.default.project
          }).layerForEditing;
          this.setEditingLayer(layerForEditing);
          return layerForEditing;
        } catch (e) {
          console.warn(e);
          return Promise.reject(e);
        }
      });

      function getLayerForEditing() {
        return _ref5.apply(this, arguments);
      }

      return getLayerForEditing;
    }()
  }, {
    key: 'isBaseLayer',
    value: function isBaseLayer() {
      return this.config.baselayer;
    }
  }, {
    key: 'isWMS',
    value: function isWMS() {
      return ["QGIS", "Mapserver", "Geoserver", "OGC"].includes(this.config.servertype);
    }
  }, {
    key: 'isLayerProjectionASMapProjection',
    value: function isLayerProjectionASMapProjection() {
      return this.config.crs.epsg === this.config.map_crs;
    }
  }, {
    key: 'getCrs',
    value: function getCrs() {
      return this.config.crs.epsg;
    }
  }, {
    key: 'isExternalWMS',
    value: function isExternalWMS() {
      return !!(this.config.source && this.config.source.external && this.config.source.url);
    }
  }, {
    key: 'isArcgisMapserver',
    value: function isArcgisMapserver() {
      return this.isExternalWMS() && "arcgismapserver" === this.config.source.type;
    }
  }, {
    key: '_getBaseLayerName',
    value: function _getBaseLayerName() {
      return this.isWmsUseLayerIds() ? this.getId() : this.getName();
    }

    /**
     * @since 3.9.0
     */

  }, {
    key: '_hasExternalWMSOrLegend',
    value: function _hasExternalWMSOrLegend() {
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'map';
      var source = this.config.source;


      return source && ('map' !== type || this.isExternalWMS() && this.isLayerProjectionASMapProjection()) && ('legend' !== type || source.external);
    }
  }, {
    key: 'getWMSLayerName',
    value: function getWMSLayerName() {
      var _ref7 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref7$type = _ref7.type,
          type = _ref7$type === undefined ? 'map' : _ref7$type;

      var _ref8 = this.config || { source: {} },
          source = _ref8.source;

      var source_layer = source.layers || source.layer;

      /** @FIXME add description */
      if (source_layer && this._hasExternalWMSOrLegend(type)) {
        return source_layer;
      }

      return this._getBaseLayerName();
    }

    /**
     * @param opts
     * @param { 'map' | 'legend' } opts.type 
     */

  }, {
    key: 'getWmsUrl',
    value: function getWmsUrl() {
      var _ref9 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref9$type = _ref9.type,
          type = _ref9$type === undefined ? 'map' : _ref9$type;

      var _ref10 = this.config || { source: {} },
          source = _ref10.source;

      /** @FIXME add description */


      if (source.url && this._hasExternalWMSOrLegend(type) && ['wms', 'wmst'].includes(source.type)) {
        return source.url;
      }

      return this.config.wmsUrl;
    }
  }, {
    key: 'getWFSLayerName',
    value: function getWFSLayerName() {
      return (this.config.infolayer && '' !== this.config.infolayer ? this.config.infolayer : this.getName()).replace(/\s/g, '_').replaceAll(':', '-');
    }
  }, {
    key: 'useProxy',
    value: function useProxy() {
      return this.isExternalWMS() && this.isLayerProjectionASMapProjection() && this.getInfoFormats();
    }
  }, {
    key: 'getWMSInfoLayerName',
    value: function getWMSInfoLayerName() {
      return this.useProxy() ? this.getSource().layers : this._getBaseLayerName();
    }
  }, {
    key: 'getPrintLayerName',
    value: function getPrintLayerName() {
      return this.isWmsUseLayerIds() ? this.getId() : this.getName();
    }
  }, {
    key: 'getStringBBox',
    value: function getStringBBox() {
      var _config$bbox = this.config.bbox,
          minx = _config$bbox.minx,
          miny = _config$bbox.miny,
          maxx = _config$bbox.maxx,
          maxy = _config$bbox.maxy;

      return minx + ',' + miny + ',' + maxx + ',' + maxy;
    }
  }, {
    key: 'isWfsActive',
    value: function isWfsActive() {
      return Array.isArray(this.config.ows) && this.config.ows.some(function (t) {
        return 'WFS' === t;
      });
    }

    /**
     * Get wms url of the layer
     */

  }, {
    key: 'getFullWmsUrl',
    value: function getFullWmsUrl() {
      var wms_url = _application2.default.project.state.metadata.wms_url;

      /** @FIXME add description */

      if (wms_url && !this.isExternalWMS()) {
        return wms_url;
      }

      return this.getWmsUrl();
    }

    /**
     * Get WMS url (used by Catalog Layer Menu) 
     */

  }, {
    key: 'getCatalogWmsUrl',
    value: function getCatalogWmsUrl() {
      var wms_url = _application2.default.project.state.metadata.wms_url;

      /** @FIXME add description */

      if (wms_url && !this.isExternalWMS()) {
        return wms_url;
      }

      return this.getWmsUrl() + '?service=WMS&version=1.3.0&request=GetCapabilities';
    }

    /**
     * Get WFS url (used by Catalog Layer Menu)  
     */

  }, {
    key: 'getCatalogWfsUrl',
    value: function getCatalogWfsUrl() {
      return this.getWfsUrl() + '?service=WFS&version=1.1.0&request=GetCapabilities';
    }

    /**
     * Get WFS 3 url (used by Catalog Layer Menu)
     * @since 3.10.0
     * @return { String } url
     */

  }, {
    key: 'getCatalogWfs3Url',
    value: function getCatalogWfs3Url() {
      return this.getWfsUrl() + 'wfs3/';
    }
  }, {
    key: 'getWfsUrl',
    value: function getWfsUrl() {
      var wms_url = _application2.default.project.state.metadata.wms_url;

      /** @FIXME add description */

      if (wms_url) {
        return wms_url;
      }

      return this.config.wmsUrl;
    }

    /**
     * Get query url based on type, external or same projection of map
     * 
     * @returns {string}
     */

  }, {
    key: 'getQueryUrl',
    value: function getQueryUrl() {
      var url = _get(ImageLayer.prototype.__proto__ || Object.getPrototypeOf(ImageLayer.prototype), 'getQueryUrl', this).call(this);
      var is_qgis = "QGIS" === this.getServerType() && this.isExternalWMS() && this.isLayerProjectionASMapProjection();

      /** @FIXME add description */
      if (is_qgis && this.getInfoFormats()) {
        return this.getSource().url;
      }

      /** @FIXME add description */
      if (is_qgis) {
        return url + 'SOURCE=' + this.config.source.type;
      }

      return url;
    }
  }, {
    key: 'getIconUrlFromLegend',
    value: function getIconUrlFromLegend() {
      return this.getLegendUrl({ layertitle: false });
    }

    /**
     * Retrieve legend url (ARCGISMAPSERVER or WMS)
     * 
     * ORIGINAL SOURCE: src/app/core/layers/legend/legendservice.js@3.8.5
     * 
     * @param { boolean }                                    opts.categories whether layer has categories
     * @param { boolean }                                    opts.all        whether to show all categories (disables filter by map's BBOX).
     * @param { 'application/json' | 'image/png' | string }  opts.format     MIME Type used to set format of legend:
     *                                                                          - `application/json`: if request from layers categories (icon and label),
     *                                                                          - `image/png`: if request from legend tab
     * 
     * @see https://docs.qgis.org/3.28/en/docs/server_manual/services/wms.html#getlegendgraphics
     */

  }, {
    key: 'getLegendUrl',
    value: function getLegendUrl() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { categories: false, all: false, format: 'image/png' };


      var base_url = void 0,
          url_params = void 0;

      var _params$customParams = _extends({}, params, this.customParams),
          width = _params$customParams.width,
          height = _params$customParams.height,
          _params$customParams$ = _params$customParams.color,
          color = _params$customParams$ === undefined ? "white" : _params$customParams$,
          _params$customParams$2 = _params$customParams.fontsize,
          fontsize = _params$customParams$2 === undefined ? 10 : _params$customParams$2,
          _params$customParams$3 = _params$customParams.transparent,
          transparent = _params$customParams$3 === undefined ? true : _params$customParams$3,
          boxspace = _params$customParams.boxspace,
          layerspace = _params$customParams.layerspace,
          _params$customParams$4 = _params$customParams.layertitle,
          layertitle = _params$customParams$4 === undefined ? true : _params$customParams$4,
          layertitlespace = _params$customParams.layertitlespace,
          symbolspace = _params$customParams.symbolspace,
          iconlabelspace = _params$customParams.iconlabelspace,
          symbolwidth = _params$customParams.symbolwidth,
          symbolheight = _params$customParams.symbolheight,
          itemfontfamily = _params$customParams.itemfontfamily,
          layerfontfamily = _params$customParams.layerfontfamily,
          layerfontbold = _params$customParams.layerfontbold,
          itemfontbold = _params$customParams.itemfontbold,
          itemfontsize = _params$customParams.itemfontsize,
          layerfontitalic = _params$customParams.layerfontitalic,
          layerfontsize = _params$customParams.layerfontsize,
          showfeaturecount = _params$customParams.showfeaturecount,
          itemfontitalic = _params$customParams.itemfontitalic,
          rulelabel = _params$customParams.rulelabel,
          crs = _params$customParams.crs,
          bbox = _params$customParams.bbox,
          _params$customParams$5 = _params$customParams.sld_version,
          sld_version = _params$customParams$5 === undefined ? '1.1.0' : _params$customParams$5;

      /**
       * ARCGIS Server
       * 
       * ORIGINAL SOURCE: src/app/core/layers/legend/arcgismapserverlegend.js@3.8.5
       */


      if (this.isArcgisMapserver()) {
        base_url = this.getConfig().source.url.replace('/rest/', '/') + '/WMSServer';
        url_params = ['request=GetLegendGraphic', 'version=1.3.0', 'format=image/png', 'LAYER=' + this.getConfig().source.layer];
      }

      /**
       * WMS Server
       * 
       * ORIGINAL SOURCE: src/app/core/layers/legend/wmslegend.js@3.8.5
       */
      else {
          var ctx_legend = opts.categories && (['image/png', undefined].includes(opts.format) || _application2.default.project.state.context_base_legend) ? (0, _get_legend_params2.get_legend_params)(this) : undefined // disabled when `FORMAT=application/json` (otherwise it creates some strange behaviour on WMS `getMap` when switching between layer styles)
          ;
          base_url = this.getWmsUrl({ type: 'legend' });
          url_params = ['SERVICE=WMS', 'VERSION=1.3.0', 'REQUEST=GetLegendGraphic', __('SLD_VERSION=', sld_version), __('WIDTH=', width), __('HEIGHT=', height), __('FORMAT=', undefined === opts.format ? 'image/png' : opts.format), __('TRANSPARENT=', transparent), __('ITEMFONTCOLOR=', color), __('LAYERFONTCOLOR=', color), __('LAYERTITLE=', layertitle), __('ITEMFONTSIZE=', itemfontsize || fontsize), //@since 3.11.3 check itemfontsize or fontsize
          __('CRS=', crs), __('BBOX=', true === opts.all ? undefined : [false, undefined].includes(opts.all) && bbox && bbox.join(',')), __('BOXSPACE=', boxspace), __('LAYERSPACE=', layerspace), __('LAYERTITLESPACE=', layertitlespace), __('SYMBOLSPACE=', symbolspace), __('ICONLABELSPACE=', iconlabelspace), __('SYMBOLWIDTH=', opts.categories && 'application/json' === opts.format ? 16 : symbolwidth), __('SYMBOLHEIGHT=', opts.categories && 'application/json' === opts.format ? 16 : symbolheight), __('LAYERFONTFAMILY=', layerfontfamily), __('ITEMFONTFAMILY=', itemfontfamily), __('LAYERFONTBOLD=', layerfontbold), __('ITEMFONTBOLD=', itemfontbold), __('LAYERFONTITALIC=', layerfontitalic), __('LAYERFONTSIZE=', layerfontsize), //@since 3.11.3
          __('SHOWFEATURECOUNT=', showfeaturecount), //@since 3.11.3
          __('ITEMFONTITALIC=', itemfontitalic), __('RULELABEL=', rulelabel), __('LEGEND_ON=', ctx_legend && ctx_legend.LEGEND_ON), __('LEGEND_OFF=', ctx_legend && ctx_legend.LEGEND_OFF), __('STYLES=', opts.categories && 'application/json' === opts.format ? encodeURIComponent(this.getCurrentStyle().name) : undefined), __('LAYER=', this.getWMSLayerName({ type: 'legend' }))];
        }

      // discard nullish parameters (without a value)
      url_params = url_params.filter(function (p) {
        return p;
      });

      this.legendUrl = '' + base_url + (base_url.indexOf('?') > -1 ? '&' : '?') + url_params.join('&');

      return this.legendUrl;
    }
  }, {
    key: 'setMapParamstoLegendUrl',
    value: function setMapParamstoLegendUrl(_ref11) {
      var bbox = _ref11.bbox,
          crs = _ref11.crs;

      this.customParams = _extends({}, this.customParams, { bbox: bbox, crs: crs });
    }
  }, {
    key: 'getWfsCapabilities',
    value: function getWfsCapabilities() {
      return this.config.wfscapabilities || 1 === this.config.capabilities;
    }
  }, {
    key: 'getMapLayer',
    value: function getMapLayer() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var extraParams = arguments[1];


      /**
       * ORIGINAL SOURCE: src/app/core/layers/baselayer.js@v3.10.0
       * 
       * @since 3.11.0
       */
      if (this._mapLayer) {
        return this._mapLayer;
      }

      options.iframe_internal = _application2.default.iframe && !this.isExternalWMS();
      var method = this.isExternalWMS() ? 'GET' : this.getOwsMethod();
      var extent = this.config.bbox ? [this.config.bbox.minx, this.config.bbox.miny, this.config.bbox.maxx, this.config.bbox.maxy] : null;
      var source = this.config.source;
      /** @since  3.10.0 Cache info **/
      var cache_provider = this.config.cache_provider;
      var cache_service_type = this.config.cache_service_type || 'tms'; //default tile
      var cache_layer = this.config.cache_layer;
      var cache_extent = this.config.cache_extent;
      var cache_grid = this.config.cache_grid;
      var cache_grid_extent = this.config.cache_grid_extent;
      //get layer url
      var url = this.isCached() ? this.getCacheUrl() : options.url || this.getWmsUrl();

      if (this.isCached() && 'tms' === cache_service_type) {
        return new RasterLayer(_extends({}, options, { extent: extent, url: url, cache_provider: cache_provider, type: 'XYZ' }), {}, method);
      }

      if (this.isExternalWMS() && source && "arcgismapserver" === source.type) {
        return new RasterLayer(_extends({}, options, source), extraParams);
      }

      if (this.isCached() && 'wmts' === cache_service_type) {
        return new RasterLayer(_extends({}, options, {
          url: url,
          cache_provider: cache_provider,
          cache_layer: cache_layer,
          cache_extent: cache_extent,
          cache_grid: cache_grid,
          cache_grid_extent: cache_grid_extent,
          type: 'WMTS'
        }), extraParams, method);
      }

      if (this.isExternalWMS() && source && "wmst" === source.type) {
        return new RasterLayer(_extends({}, options, { url: url, cache_provider: cache_provider, type: 'WMTS' }), extraParams, method);
      }

      return new RasterLayer(_extends({}, options, { url: url }), extraParams, method);
    }

    /**
     * @override Layer~getFormat
     * 
     * @since 3.9.1
     */

  }, {
    key: 'getFormat',
    value: function getFormat() {
      if (this.isExternalWMS() && this.getSource()) {
        return this.getSource().format;
      }
      return _get(ImageLayer.prototype.__proto__ || Object.getPrototypeOf(ImageLayer.prototype), 'getFormat', this).call(this);
    }

    /**
     * @override ImageLayer~getOwsMethod
     * 
     * @see https://github.com/g3w-suite/g3w-client/issues/616
     * 
     * forces to `GET` when wms layer is external or query url isn't a qgis server endpoint (ie. doesn't start with `/ows/`).
     * 
     * @since 3.10.0
     */

  }, {
    key: 'getOwsMethod',
    value: function getOwsMethod() {
      return this.isExternalWMS() || !/^\/ows/.test(new URL(this.getQueryUrl(), window.initConfig.baseurl).pathname) ? 'GET' : this.config.ows_method;
    }

    /**
     * ORIGINAL SOURCE: src/app/core/layers/baselayer.js@v3.10.0
     * 
     * @since 3.11.0
     */

  }, {
    key: 'update',
    value: function update(mapState, extraParams) {
      if (this.isWMS()) {
        this._mapLayer.update(mapState, extraParams);
      }
    }

    /**
     * ORIGINAL SOURCE: src/app/core/layers/baselayer.js@v3.10.0
     * 
     * @since 3.11.0
     */

  }, {
    key: 'setVisible',
    value: function setVisible(bool) {
      if (this._mapLayer) {
        this.getOLLayer().setVisible(bool);
      }
      return _get(ImageLayer.prototype.__proto__ || Object.getPrototypeOf(ImageLayer.prototype), 'setVisible', this).call(this, bool);
    }

    /**
     * ORIGINAL SOURCE: src/app/core/layers/baselayer.js@v3.10.0
     * 
     * @since 3.11.0
     */

  }, {
    key: 'getSource',
    value: function getSource() {
      if (this._mapLayer) {
        return this.getOLLayer().getSource();
      }
      return _get(ImageLayer.prototype.__proto__ || Object.getPrototypeOf(ImageLayer.prototype), 'getSource', this).call(this);
    }

    /**
     * ORIGINAL SOURCE: src/app/core/layers/baselayer.js@v3.10.0
     * 
     * @since 3.11.0
     */

  }, {
    key: 'getProjectionFromCrs',
    value: function getProjectionFromCrs() {
      var crs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      crs.epsg = crs.epsg ? crs.epsg : 'EPSG:3857';
      return _projections2.default.get(crs);
    }

    /**
     * ORIGINAL SOURCE: src/app/core/layers/baselayer.js@v3.10.0
     * 
     * @since 3.11.0
     */

  }, {
    key: 'getOLLayer',
    value: function getOLLayer() {
      var _this4 = this;

      if (!this._olLayer && this._makeOlLayer) {
        this._olLayer = this._makeOlLayer();
        // register loading event
        this._olLayer.getSource().on('imageloadstart', function () {
          return _this4.emit("loadstart");
        });
        this._olLayer.getSource().on('imageloadend', function () {
          return _this4.emit("loadend");
        });
        if (this._mapLayer.config.attributions) {
          this._olLayer.getSource().setAttributions(this._mapLayer.config.attributions);
        }
        this._olLayer.setVisible(this._mapLayer.state.visible);
      }
      return this._olLayer;
    }
  }]);

  return ImageLayer;
}((0, _geoMixin2.default)(_layer.Layer));

exports.ImageLayer = ImageLayer;
exports.RasterLayer = RasterLayer;

},{"g3w-constants":159,"g3w-object":163,"map/layers/geo-mixin":188,"map/layers/layer":190,"map/layers/vectorlayer":193,"store/application":212,"store/projections":214,"utils/get_legend_params":253}],190:[function(require,module,exports){
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Layer = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * @file ORIGINAL SOURCE: src/app/core/layers/layer.js@v3.10.2
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * @since 3.11.0
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */

var _g3wConstants = require('g3w-constants');

var _application = require('store/application');

var _application2 = _interopRequireDefault(_application);

var _data = require('services/data');

var _data2 = _interopRequireDefault(_data);

var _gui = require('services/gui');

var _gui2 = _interopRequireDefault(_gui);

var _g3wObject = require('g3w-object');

var _g3wObject2 = _interopRequireDefault(_g3wObject);

var _parseAttributes = require('utils/parseAttributes');

var _promisify = require('utils/promisify');

var _downloadFile = require('utils/downloadFile');

var _XHR = require('utils/XHR');

var _prompt = require('utils/prompt');

var _Table = require('components/Table.vue');

var _Table2 = _interopRequireDefault(_Table);

var _parsers = require('utils/parsers');

var _get_legend_params = require('utils/get_legend_params');

var _createRelationsUrl = require('utils/createRelationsUrl');

var _feature = require('map/layers/feature');

var _g3wI18n = require('g3w-i18n');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var is_defined = function is_defined(d) {
  return undefined !== d;
};
var çç = function çç(a, b) {
  return undefined !== a ? a : b;
}; // like a ?? (coalesce operator)

// BACKCOMP v3.x
function createProvider(name, layer) {
  var provider = new Providers[name]();
  return Object.assign(provider, {
    _name: name,
    _layer: layer,
    getLayer: function getLayer() {
      return provider._layer;
    },
    setLayer: function setLayer(l) {
      return provider._layer = l;
    },
    getFeatures: provider.getFeatures || function () {
      return console.log('overwriteby single provider');
    },
    query: provider.query || function () {
      return console.log('overwriteby single provider');
    },
    getName: function getName() {
      return provider._name;
    }
  });
}

/**
 * ORIGINAL SOURCE: src/app/core/layers/providersfactory.js@v3.10.2
 * ORIGINAL SOURCE: src/app/core/layers/providers/geojsonprovider.js@3.8.6
 * ORIGINAL SOURCE: src/app/core/layers/providers/qgisprovider.js@3.8.6
 * ORIGINAL SOURCE: src/app/core/layers/providers/wmsprovider.js@3.8.6
 * ORIGINAL SOURCE: src/app/core/layers/providers/wmsprovider.js@3.8.6
 */
var Providers = {

  geojson: function () {
    function geojson() {
      _classCallCheck(this, geojson);
    }

    _createClass(geojson, [{
      key: 'query',
      value: function query() {
        return (0, _promisify.$promisify)(Promise.resolve([]));
      }
    }, {
      key: 'getFeatures',
      value: function getFeatures() {
        var _this = this;

        var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        return (0, _promisify.$promisify)(_asyncToGenerator(function* () {
          return new ol.format.GeoJSON().readFeatures(opts.data || (yield _XHR.XHR.get({ url: opts.url || _this._layer.get('source').url })).results, {
            featureProjection: opts.mapProjection,
            dataProjection: opts.projection || 'EPSG:4326'
          });
        }));
      }
    }]);

    return geojson;
  }(),

  qgis: function () {
    function qgis() {
      _classCallCheck(this, qgis);
    }

    _createClass(qgis, [{
      key: 'query',


      /**
       * Query by filter
       * 
       * @param { boolean } opts.raw           whether to get raw response
       * @param { number }  opts.feature_count maximum feature for request
       * @param { string }  opts.queryUrl      url for request data
       * @param { Array }   opts.layers        Array or request layers
       * @param opts.I                         wms request parameter 
       * @param opts.J                         wms request parameter 
       */
      value: function query() {
        var _this2 = this;

        var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        this._projections = this._projections || { map: null, layer: null };
        return (0, _promisify.$promisify)(_asyncToGenerator(function* () {
          var is_table = 'table' === _this2._layer.getType();

          // in case not alphanumeric layer set projection
          if (!is_table) {
            _this2._projections.map = _this2._layer.getMapProjection() || _this2._projections.layer;
          }

          var layers = opts.layers ? opts.layers.map(function (l) {
            return l.getWMSLayerName();
          }).join(',') : _this2._layer.getWMSLayerName();

          // skip when ..
          if (!opts.filter) {
            return Promise.reject();
          }

          var filter = [].concat(opts.filter)
          // BACKOMP v3.x
          .map(function (f) {
            return {
              type: f._type || f.type,
              value: f._filter || f.value
            };
          });

          // check if geometry filter. If not i have to remove projection layer
          if ('geometry' !== filter[0].type) {
            _this2._projections.layer = null;
          }

          filter = filter.filter(function (f) {
            return f.value;
          });

          var response = yield _XHR.XHR.get({
            url: opts.queryUrl || _this2._layer.getUrl('query'),
            params: {
              SERVICE: 'WMS',
              VERSION: '1.3.0',
              REQUEST: 'GetFeatureInfo',
              filtertoken: _application2.default.tokens.filtertoken,
              LAYERS: layers,
              QUERY_LAYERS: layers,
              INFO_FORMAT: _this2._layer.getInfoFormat() || 'application/vnd.ogc.gml',
              FEATURE_COUNT: opts.feature_count || 10,
              CRS: is_table ? _application2.default.map.epsg : _this2._projections.map.getCode(),
              I: opts.I,
              J: opts.J,
              FILTER: filter.length ? filter.map(function (f) {
                return f.value;
              }).join(';') : undefined,
              WITH_GEOMETRY: !is_table
            }
          });

          var _layers = undefined === opts.layers ? [_this2._layer] : opts.layers;

          return opts.raw ? response : _parsers.ResponseParser.get(_layers[0].getInfoFormat())({
            response: response,
            projections: _this2._projections,
            layers: _layers,
            wms: true
          });
        }));
      }

      /**
       * get layer config
       */

    }, {
      key: 'getConfig',
      value: function getConfig() {
        return (0, _promisify.$promisify)(_XHR.XHR.get({ url: this._layer.getUrl('config') }));
      }

      /**
       * Load editing features (Read / Write)
       */

    }, {
      key: 'getFeatures',
      value: function getFeatures() {
        var _this3 = this;

        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        // filter null values
        Object.entries(params).forEach(function (_ref3) {
          var _ref4 = _slicedToArray(_ref3, 2),
              key = _ref4[0],
              value = _ref4[1];

          if ([null, undefined].includes(value)) {
            delete params[key];
          }
        });

        return (0, _promisify.$promisify)(_asyncToGenerator(function* () {

          params = new URLSearchParams(params || {}).toString();
          params = (params ? '?' : '') + params;

          // read mode
          if (!options.editing) {
            var _ref6 = yield _XHR.XHR.get({
              url: _this3._layer.getUrl('data') + params
            }),
                vector = _ref6.vector;

            return {
              data: vector.data,
              count: vector.count
            };
          }

          // editing mode
          try {

            var response = void 0;

            if (!options.filter) {
              response = yield _XHR.XHR.post({
                url: _this3._layer.getUrl('editing') + params,
                contentType: 'application/json'
              });
            } else if (is_defined(options.filter.bbox)) {
              // bbox filter
              response = yield _XHR.XHR.post({
                url: _this3._layer.getUrl('editing') + params,
                data: JSON.stringify({
                  in_bbox: options.filter.bbox.join(','),
                  filtertoken: _application2.default.tokens.filtertoken
                }),
                contentType: 'application/json'
              });
            } else if (is_defined(options.filter.fid)) {
              // fid filter
              response = yield _XHR.XHR.get({ url: (0, _createRelationsUrl.createRelationsUrl)(options.filter.fid) });
            } else if (options.filter.field) {
              response = yield _XHR.XHR.post({
                url: _this3._layer.getUrl('editing') + params,
                data: JSON.stringify(options.filter),
                contentType: 'application/json'
              });
            } else if (is_defined(options.filter.fids)) {
              response = yield _XHR.XHR.get({
                url: _this3._layer.getUrl('editing') + params,
                params: options.filter
              });
            } else if (is_defined(options.filter.nofeatures)) {
              response = yield _XHR.XHR.post({
                url: _this3._layer.getUrl('editing') + params,
                data: JSON.stringify({
                  field: (options.filter.nofeatures_field || 'id') + '|eq|__G3W__NO_FEATURES__'
                }),
                contentType: 'application/json'
              });
            }

            // invalid response
            if (!response.result) {
              return;
            }

            var lockIds = response.featurelocks.map(function (lk) {
              return lk.featureid;
            });

            // resolves with features locked and requested
            return {
              count: response.vector.count, // real number of features that request will return
              featurelocks: response.featurelocks,
              features: _parsers.ResponseParser.get('g3w-' + _this3._layer.getType() + '/json')(response.vector.data, 'NoGeometry' === response.vector.geometrytype ? {} : { crs: _this3._layer.getCrs() }).filter(function (f) {
                return lockIds.includes('' + f.getId());
              }).map(function (feature) {
                return new _feature.Feature({ feature: feature });
              })
            };
          } catch (e) {
            console.warn(e);
          }
          return Promise.reject({ message: (0, _g3wI18n.t)("info.server_error") });
        }));
      }
    }]);

    return qgis;
  }(),

  wms: function () {
    function wms() {
      _classCallCheck(this, wms);
    }

    _createClass(wms, [{
      key: 'query',
      value: function query() {
        var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var _opts$layers = opts.layers,
            layers = _opts$layers === undefined ? [this._layer] : _opts$layers,
            _opts$size = opts.size,
            size = _opts$size === undefined ? [101, 101] : _opts$size,
            _opts$coordinates = opts.coordinates,
            coordinates = _opts$coordinates === undefined ? [] : _opts$coordinates,
            resolution = opts.resolution;

        // get extent for view size

        var dx = resolution * size[0] / 2;
        var dy = resolution * size[1] / 2;
        var bbox = [coordinates[0] - dx, coordinates[1] - dy, coordinates[0] + dx, coordinates[1] + dy];

        var projection = this._layer.getMapProjection() || this._layer.getProjection();
        var tolerance = çç(opts.query_point_tolerance, _g3wConstants.QUERY_POINT_TOLERANCE);

        var url = layers[0].getQueryUrl();
        var method = layers[0].getOwsMethod();
        var proxy = layers[0].useProxy();
        var source = (url || '').split('SOURCE');

        // base request
        var params = {
          SERVICE: 'WMS',
          VERSION: '1.3.0',
          REQUEST: 'GetFeatureInfo',
          CRS: projection.getCode(),
          LAYERS: (layers || [this._layer.getWMSInfoLayerName()]).map(function (l) {
            return l.getWMSInfoLayerName();
          }).join(','),
          QUERY_LAYERS: (layers || [this._layer.getWMSInfoLayerName()]).map(function (l) {
            return l.getWMSInfoLayerName();
          }).join(','),
          filtertoken: _application2.default.tokens.filtertoken,
          INFO_FORMAT: this._layer.getInfoFormat() || 'application/vnd.ogc.gml',
          FEATURE_COUNT: çç(opts.feature_count, 10),
          WITH_GEOMETRY: true,
          DPI: _g3wConstants.DOTS_PER_INCH,
          FILTER_GEOM: 'map' === tolerance.unit ? new ol.format.WKT().writeGeometry(ol.geom.Polygon.fromCircle(new ol.geom.Circle(coordinates, tolerance.value))) : undefined,
          FI_POINT_TOLERANCE: 'map' === tolerance.unit ? undefined : tolerance.value,
          FI_LINE_TOLERANCE: 'map' === tolerance.unit ? undefined : tolerance.value,
          FI_POLYGON_TOLERANCE: 'map' === tolerance.unit ? undefined : tolerance.value,
          G3W_TOLERANCE: 'map' === tolerance.unit ? undefined : tolerance.value * resolution,
          I: 'map' === tolerance.unit ? undefined : Math.floor((coordinates[0] - bbox[0]) / resolution), // x
          J: 'map' === tolerance.unit ? undefined : Math.floor((bbox[3] - coordinates[1]) / resolution), // y
          WIDTH: size[0],
          HEIGHT: size[1],
          STYLES: (layers || []).map(function (l) {
            return l.getStyle();
          }).join(','),
          BBOX: ('ne' === projection.getAxisOrientation().substr(0, 2) ? [bbox[1], bbox[0], bbox[3], bbox[2]] : bbox).join(','),
          // HOTFIX for GetFeatureInfo requests and feature layer categories that are not visible (unchecked) at QGIS project setting
          LEGEND_ON: layers.flatMap(function (l) {
            return (0, _get_legend_params.get_legend_params)(l).LEGEND_ON;
          }).filter(Boolean).join(';') || undefined,
          LEGEND_OFF: layers.flatMap(function (l) {
            return (0, _get_legend_params.get_legend_params)(l).LEGEND_OFF;
          }).filter(Boolean).join(';') || undefined,
          SOURCE: !proxy && 'GET' === method && source.length > 1 ? source[1] : undefined
        };

        var timer = void 0;

        // promise with timeout
        return (0, _promisify.$promisify)(Promise.race([new Promise(function (res) {
          timer = setTimeout(function () {
            res({
              data: (layers || []).map(function (layer) {
                return { layer: layer, rawdata: 'timeout' };
              }),
              query: { coordinates: coordinates, resolution: resolution }
            });
          }, _g3wConstants.TIMEOUT);
        }), _asyncToGenerator(function* () {
          try {
            var response = void 0;

            if (proxy) {
              response = yield layers[0].getDataProxyFromServer('wms', { url: url, params: params, method: method, headers: { 'Content-Type': params.INFO_FORMAT } });
            } else if ('GET' === method) {
              var uri = (source.length ? source[0] : url).replace(/[?&]$/, ''); // remove any trailing ? or &
              response = yield _XHR.XHR.get({
                url: uri + (uri.indexOf('?') === -1 ? '?' : '&') + Object.keys(params).filter(function (k) {
                  return ![undefined, null].includes(params[k]);
                }) // skip null and undefined params
                .map(function (k) {
                  return k + '=' + encodeURIComponent(params[k]);
                }).join('&')
              });
            } else if ('POST' === method) {
              response = yield _XHR.XHR.post({ url: url, data: params });
            } else {
              console.warn('unsupported method: ', method);
            }
            return {
              data: _parsers.ResponseParser.get(layers[0].getInfoFormat())({
                response: response,
                layers: layers,
                wms: true,
                projections: { map: projection, layer: null }
              }),
              query: { coordinates: coordinates, resolution: resolution }
            };
          } finally {
            if (!proxy) {
              clearTimeout(timer);
            }
          }
        })()]));
      }
    }]);

    return wms;
  }(),

  wfs: function () {
    function wfs() {
      _classCallCheck(this, wfs);
    }

    _createClass(wfs, [{
      key: 'query',


      // query method
      value: function query() {
        var _this4 = this;

        var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        var filter = opts.filter || {};
        var layers = opts.layers || [this._layer];
        var url = (layers[0].getQueryUrl() + '/').replace(/\/+$/, '/');
        var method = layers[0].getOwsMethod();

        // BACKCOMP v3.x
        Object.assign(filter, {
          config: filter.config || {},
          type: filter._type || filter.type,
          value: filter._filter || filter.value
        });

        params = Object.assign(params, {
          SERVICE: 'WFS',
          VERSION: '1.1.0',
          REQUEST: 'GetFeature',
          MAXFEATURES: çç(opts.feature_count, 10),
          TYPENAME: layers.map(function (l) {
            return l.getWFSLayerName();
          }).join(','),
          OUTPUTFORMAT: layers[0].getInfoFormat(),
          SRSNAME: (opts.reproject ? layers[0].getProjection() : this._layer.getMapProjection()).getCode(),
          FILTER: 'all' !== filter.type ? ('(' + new ol.format.WFS().writeGetFeature({
            featureTypes: [''], //v3.11.0 @TODO need to check https://openlayers.org/en/v5.3.0/apidoc/module-ol_format_WFS-WFS.html#writeGetFeature
            filter: {
              'bbox': function bbox() {
                return ol.format.filter.bbox('the_geom', filter.value);
              },
              'geometry': function geometry() {
                return ol.format.filter[filter.config.spatialMethod || 'intersects']('the_geom', filter.value);
              },
              'expression': function expression() {
                return null;
              }
            }[filter.type]()
          }).children[0].innerHTML + ')').repeat(layers.length || 1) : undefined
        });

        var timer = void 0;

        // promise with timeout
        return (0, _promisify.$promisify)(Promise.race([new Promise(function (res) {
          timer = setTimeout(function () {
            res({
              data: (layers || []).map(function (layer) {
                return { layer: layer, rawdata: 'timeout' };
              }),
              query: {}
            });
          }, _g3wConstants.TIMEOUT);
        }), _asyncToGenerator(function* () {
          try {
            var response = void 0;

            if ('GET' === method && !['all', 'geometry'].includes(filter.type)) {
              response = yield _XHR.XHR.get({ url: url + '?' + new URLSearchParams(params || {}).toString() });
            }

            if ('POST' === method || ['all', 'geometry'].includes(filter.type)) {
              response = yield _XHR.XHR.post({ url: url, data: params });
            }

            var data = _parsers.ResponseParser.get(layers[0].getInfoFormat())({
              response: response,
              projections: {
                map: _this4._layer.getMapProjection(),
                layer: opts.reproject ? _this4._layer.getProjection() : null
              },
              layers: layers,
              wms: false
            });

            // sanitize in case of nil:true
            data.flatMap(function (l) {
              return l.features || [];
            }).forEach(function (f) {
              return Object.entries(f.getProperties()).forEach(function (_ref9) {
                var _ref10 = _slicedToArray(_ref9, 2),
                    attribute = _ref10[0],
                    value = _ref10[1];

                return value && value['xsi:nil'] && feature.set(attribute, 'NULL');
              });
            });
            return { data: data };
          } finally {
            clearTimeout(timer);
          }
        })()]));
      }
    }]);

    return wfs;
  }()

};

var DOWNLOAD_FORMATS = {
  download: { format: 'shapefile', url: 'shp' },
  download_gpkg: { format: 'gpkg', url: 'gpkg' },
  download_gpx: { format: 'gpx', url: 'gpx' },
  download_csv: { format: 'csv', url: 'csv' },
  download_xls: { format: 'xls', url: 'xls' },
  download_raster: { format: 'geotiff', url: 'geotiff' },
  download_pdf: { format: 'pdf', url: 'pdf' }
};

/**
 * Base class for all layers
 */

var Layer = function (_G3WObject) {
  _inherits(Layer, _G3WObject);

  function Layer() {
    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, Layer);

    //get current project object
    var _this5 = _possibleConstructorReturn(this, (Layer.__proto__ || Object.getPrototypeOf(Layer)).call(this));

    var project = options.project || _application2.default.project;
    var suffixUrl = config.baselayer ? '' : project.getType() + '/' + project.getId() + '/' + config.id + '/';
    var vectorUrl = config.baselayer ? '' : project.state.vectorurl;
    var rasterUrl = config.baselayer ? '' : project.state.rasterurl;

    // assign some attributes

    _this5.config = Object.assign(config, _extends({
      id: config.id || 'Layer',
      title: config.title || config.name,
      download: !!config.download,
      geolayer: false,
      baselayer: !!config.baselayer,
      fields: config.fields || {},
      // URLs to get various type of data
      urls: _extends({
        query: config.infourl || config.wmsUrl
      }, config.urls || {}, config.baselayer ? {} : {
        filtertoken: vectorUrl + 'filtertoken/' + suffixUrl,
        data: vectorUrl + 'data/' + suffixUrl,
        shp: vectorUrl + 'shp/' + suffixUrl,
        csv: vectorUrl + 'csv/' + suffixUrl,
        xls: vectorUrl + 'xls/' + suffixUrl,
        gpx: vectorUrl + 'gpx/' + suffixUrl,
        gpkg: vectorUrl + 'gpkg/' + suffixUrl,
        geotiff: rasterUrl + 'geotiff/' + suffixUrl,
        editing: vectorUrl + 'editing/' + suffixUrl,
        commit: vectorUrl + 'commit/' + suffixUrl,
        config: vectorUrl + 'config/' + suffixUrl,
        unlock: vectorUrl + 'unlock/' + suffixUrl,
        widget: {
          unique: vectorUrl + 'widget/unique/data/' + suffixUrl
        },
        /** @since 3.8.0 */
        featurecount: project.getUrl('featurecount'),
        /** @since 3.10.0 */
        pdf: '/html2pdf/'
      })
    }, config.baselayer ? {} : { searchParams: { I: 0, J: 0 } }, {
      /** @deprecated since 3.10.0. Will be removed in v.4.x. */
      search_endpoint: 'api'
    }));

    var relations = project.getRelations().filter(function (r) {
      return [r.referencedLayer, r.referencingLayer].includes(_this5.getId());
    });

    /**
     * Layer relations
     */
    _this5._relations = {

      /**
       * ORIGINAL SOURCE: src/app/core/relations/relation.js@v3.10.1
       * 
       * Relations store
       * 
       * @type { Relation[] }
       */
      _relations: (relations || []).reduce(function (relations) {
        var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        var suffix = Date.now();
        /** relation state */
        var state = {
          /** @type { boolean } loading state (for editing purpose) */
          loading: false,
          /** @type { string } relation id */
          id: config.id || 'id_' + suffix,
          /** @type { string } relation name */
          name: config.name || 'name_' + suffix,
          origname: config.origname || 'origname_' + suffix,
          /** @type { string[] } layerId of father relation */
          father: config.referencedLayer,
          /** @type { string[] } layerId of child relation */
          child: config.referencingLayer,
          /** @type { 'MANY' | ONE' | string } relation type */
          type: config.type,
          /** @since 3.9.0 */
          editable: config.editable || false,
          /** @type { string } relation prefix (for Relation 1:1) @since 3.9.0 */
          prefix: config.prefix,
          /** BACKCOMP (g3w-admin < v.3.7.0) - father relation field name */
          fatherField: [].concat(config.fieldRef.referencedField),
          /** BACKCOMP (g3w-admin < v.3.7.0) - child relation layer field name */
          childField: [].concat(config.fieldRef.referencingField)
        };
        relations[state.id] = Object.assign(new _g3wObject2.default(config), {
          state: state,
          getId: function getId() {
            return state.id;
          },
          setId: function setId(id) {
            return state.id = id;
          },
          getName: function getName() {
            return state.name;
          },
          setName: function setName(n) {
            return state.name = n;
          },
          getChild: function getChild() {
            return state.child;
          },
          getFather: function getFather() {
            return state.father;
          },
          getState: function getState() {
            return state;
          },
          getType: function getType() {
            return state.type;
          },
          getFatherField: function getFatherField() {
            return state.fatherField;
          },
          getChildField: function getChildField() {
            return state.childField;
          },
          setLoading: function setLoading(b) {
            return state.loading = !!b;
          },
          isLoading: function isLoading() {
            return state.loading;
          },
          isEditable: function isEditable() {
            return state.editable;
          },
          getPrefix: function getPrefix() {
            return state.prefix;
          },
          /** @returns {{ father, child }} relation fields */
          getFields: function getFields() {
            return { father: state.fatherField, child: state.childField };
          },
          /** @FIXME `state.title` is not defined */
          getTitle: function getTitle() {
            return state.title;
          },
          /** @FIXME `state.title` is not defined */
          setTitle: function setTitle(t) {
            return state.title = t;
          }
        });
        return relations;
      }, {}),

      /**
       * Number of relations
       * 
       * @type { number }
       */
      _length: relations ? relations.length : 0,

      /**
       * Build relations between layers.
       *
       * @private
       */
      _reloadRelationsInfo: function _reloadRelationsInfo() {

        this._relationsInfo = {
          children: {}, // hashmap: <child_layerId,  Array<father_relationId>>
          fathers: {}, // hashmap: <father_layerId, Array<child_relationId[]>>
          father_child: {} // hashmap: <relationKey, relationId>
        };

        var f = void 0,
            c = void 0;
        var _relationsInfo = this._relationsInfo,
            father_child = _relationsInfo.father_child,
            fathers = _relationsInfo.fathers,
            children = _relationsInfo.children;


        Object.entries(this._relations).forEach(function (_ref11) {
          var _ref12 = _slicedToArray(_ref11, 2),
              relationKey = _ref12[0],
              relation = _ref12[1];

          f = relation.getFather();
          c = relation.getChild();

          father_child[f + c] = relationKey; // relationKey = [father_layerId + child_layerId]
          fathers[f] = fathers[f] || [];
          children[c] = children[c] || [];

          fathers[f].push(c);
          children[c].push(f);
        });
      },


      /**
       * @returns { number } number of relations
       */
      getLength: function getLength() {
        return this._length;
      },


      /**
       * @param relation.type
       *
       * @returns { {} | Relation[] } relations filtered by type
       */
      getRelations: function getRelations() {
        var _ref13 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            _ref13$type = _ref13.type,
            type = _ref13$type === undefined ? null : _ref13$type;

        // type = null
        if (!type) {
          return this._relations;
        }

        // type = { 'ONE' | 'MANY' }
        if (-1 !== ['ONE', 'MANY'].indexOf(type)) {
          var _relations = {};
          for (var name in this._relations) {
            if (type === this._relations[name].getType()) {
              _relations[name] = this._relations[name];
            }
          }
          return _relations;
        }

        return {};
      },
      setRelations: function setRelations() {
        var relations = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        this._relations = Array.isArray(relations) ? relations : [];
      },
      getRelationById: function getRelationById(id) {
        return this._relations[id];
      },
      getArray: function getArray() {
        return Object.entries(this._relations).map(function (r) {
          return r[1];
        });
      },
      getRelationByFatherChildren: function getRelationByFatherChildren(father, child) {
        return this.getRelationById(this._relationsInfo.father_child[father + child]);
      },
      isChild: function isChild(id) {
        return !!this._relationsInfo.children[id];
      },
      isFather: function isFather(id) {
        return !!this._relationsInfo.fathers[id];
      },
      hasChildren: function hasChildren(layer_id) {
        return (this.getChildren(layer_id) || []).length > 0;
      },
      hasFathers: function hasFathers(layer_id) {
        return (this.getFathers(layer_id) || []).length > 0;
      },

      /** @returns { Array | null } child layers (IDs) within same relation */
      getChildren: function getChildren(layer_id) {
        return this.isFather(layer_id) ? this._relationsInfo.fathers[layer_id] : null;
      },

      /** @returns { Array | null } father layers (IDs) within same relation */
      getFathers: function getFathers(layer_id) {
        return this.isChild(layer_id) ? this._relationsInfo.children[layer_id] : null;
      }
    };

    _this5._relations._reloadRelationsInfo();

    // dinamic layer values useful for layerstree
    var defaultstyle = config.styles && config.styles.find(function (s) {
      return s.current;
    }).name;

    /**
     * @TODO make it simpler, `this.config` and `this.state` are essentially duplicated data
     */
    _this5.state = {
      id: config.id,
      title: config.title,
      selected: config.selected || false,
      disabled: config.disabled || false,
      metadata: config.metadata,
      openattributetable: _this5.canShowTable(),
      removable: config.removable || false,
      downloadable: _this5.isDownloadable(),
      source: config.source,
      styles: config.styles,
      defaultstyle: defaultstyle,
      infoformat: _this5.getInfoFormat(),
      infoformats: _this5.config.infoformats || [],
      projectLayer: true,
      geolayer: false,
      attributetable: { pageLength: null },
      visible: config.visible || false,
      tochighlightable: false,
      /** state of if is in editing (setted by editing plugin) */
      inediting: false,
      /** Reactive selection attribute */
      selection: { active: false },
      /** Reactive filter attribute */
      filter: {
        active: false,
        /** @since 3.9.0 whether filter is set from a previously saved filter */
        current: null,
        /** @since v3.11.0 **/
        pagination: false
      },
      /** @type { Array<{{ id: string, name: string }}> } since 3.9.0 - array of saved filters */
      filters: config.filters || [],
      /** @type {number} since 3.8.0 */
      featurecount: config.featurecount,
      /** @type { boolean | Object<number, number> } since 3.8.0 */
      stylesfeaturecount: config.featurecount && defaultstyle && _defineProperty({}, defaultstyle, config.featurecount),
      /** @type { string } since 3.10.0 */
      name: config.name,
      /** @type { boolean } since 3.10.0 */
      expanded: config.expanded,
      /** @type { boolean } since 3.10.0 - whether to show layer on TOC (default: true) */
      toc: 'boolean' === typeof config.toc ? config.toc : true
    };

    /**
     * Store all selections feature `fids`
     */
    _this5.selectionFids = new Set();

    // referred to (layersstore);
    _this5._layersstore = config.layersstore || null;

    var layerType = _this5.config.servertype + ' ' + (_this5.config.source && _this5.config.source.type);

    /**
     * Layer providers used to retrieve layer data from server
     * 
     * 1 - data: raw layer data (editing)
     * 2 - filter
     * 3 - filtertoken
     * 4 - query
     * 5 - search
     */
    _this5.providers = {

      data: function () {
        if (['QGIS virtual', 'QGIS postgres', 'QGIS oracle', 'QGIS mssql', 'QGIS spatialite', 'QGIS ogr', 'QGIS delimitedtext', 'QGIS wfs'].includes(layerType)) {
          return createProvider('qgis', _this5);
        }
        if ('G3WSUITE geojson' === layerType) {
          return createProvider('geojson', _this5);
        }
      }(),

      filter: ['QGIS virtual', 'QGIS postgres', 'QGIS oracle', 'QGIS mssql', 'QGIS spatialite', 'QGIS ogr', 'QGIS delimitedtext', 'QGIS wfs', 'QGIS wmst', 'QGIS wcs', 'QGIS wms'].includes(layerType) && createProvider('wfs', _this5),

      filtertoken: ['QGIS virtual', 'QGIS postgres', 'QGIS oracle', 'QGIS mssql', 'QGIS spatialite', 'QGIS ogr', 'QGIS delimitedtext'].includes(layerType) && createProvider('qgis', _this5),

      query: function () {
        if (['QGIS virtual', 'QGIS postgres', 'QGIS oracle', 'QGIS mssql', 'QGIS spatialite', 'QGIS ogr', 'QGIS delimitedtext', 'QGIS wfs', 'QGIS wmst', 'QGIS wcs', 'QGIS wms', 'QGIS gdal',
        /** @since 3.9.0 */
        'QGIS postgresraster', 'QGIS vector-tile', 'QGIS vectortile', 'QGIS arcgismapserver', 'QGIS mdal', 'OGC wms'].includes(layerType)) {
          return createProvider('wms', _this5);
        }
        if ('G3WSUITE geojson' === layerType) {
          return createProvider('geojson', _this5);
        }
      }(),

      search: ['QGIS virtual', 'QGIS postgres', 'QGIS oracle', 'QGIS mssql', 'QGIS spatialite', 'QGIS ogr', 'QGIS delimitedtext', 'QGIS wfs'].includes(layerType) && createProvider('qgis', _this5)

    };

    /**
     * Store last proxy params (useful for repeat request info formats for wms external layer)
     */
    _this5.proxyData = {
      wms: null // at the moment only wms data from server
    };

    return _this5;
  }

  /******************************************************************************************
   * LAYER DOWNLOAD
   *****************************************************************************************/

  /** 
   * @returns { Promise }
   */


  _createClass(Layer, [{
    key: 'getDownloadFilefromDownloadDataType',
    value: function getDownloadFilefromDownloadDataType(type, _ref15) {
      var _ref15$data = _ref15.data,
          data = _ref15$data === undefined ? {} : _ref15$data;

      data.filtertoken = this.getFilterToken();

      if ('pdf' === type) {
        return (0, _downloadFile.downloadFile)({
          url: this.getUrl('pdf'),
          headers: { 'Content-Type': 'application/json; charset=utf-8' },
          data: JSON.stringify(data),
          mime_type: 'application/pdf',
          method: 'POST'
        });
      }

      return _XHR.XHR.fileDownload({
        url: this.getUrl('shapefile' === type ? 'shp' : type),
        httpMethod: "POST",
        data: data
      });
    }
  }, {
    key: 'getGeoTIFF',
    value: function getGeoTIFF() {
      var _ref16 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref16$data = _ref16.data,
          data = _ref16$data === undefined ? {} : _ref16$data;

      return this.getDownloadFilefromDownloadDataType('geotiff', { data: data });
    }
  }, {
    key: 'getXls',
    value: function getXls() {
      var _ref17 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref17$data = _ref17.data,
          data = _ref17$data === undefined ? {} : _ref17$data;

      return this.getDownloadFilefromDownloadDataType('xls', { data: data });
    }
  }, {
    key: 'getShp',
    value: function getShp() {
      var _ref18 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref18$data = _ref18.data,
          data = _ref18$data === undefined ? {} : _ref18$data;

      return this.getDownloadFilefromDownloadDataType('shapefile', { data: data });
    }
  }, {
    key: 'getGpx',
    value: function getGpx() {
      var _ref19 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref19$data = _ref19.data,
          data = _ref19$data === undefined ? {} : _ref19$data;

      return this.getDownloadFilefromDownloadDataType('gpx', { data: data });
    }
  }, {
    key: 'getGpkg',
    value: function getGpkg() {
      var _ref20 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref20$data = _ref20.data,
          data = _ref20$data === undefined ? {} : _ref20$data;

      return this.getDownloadFilefromDownloadDataType('gpkg', { data: data });
    }
  }, {
    key: 'getCsv',
    value: function getCsv() {
      var _ref21 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref21$data = _ref21.data,
          data = _ref21$data === undefined ? {} : _ref21$data;

      return this.getDownloadFilefromDownloadDataType('csv', { data: data });
    }

    /**
     * @returns { string[] } download formats
     */

  }, {
    key: 'getDownloadableFormats',
    value: function getDownloadableFormats() {
      var _this6 = this;

      return Object.keys(DOWNLOAD_FORMATS).filter(function (d) {
        return _this6.config[d];
      }).map(function (d) {
        return DOWNLOAD_FORMATS[d].format;
      });
    }

    /**
     * @param download url
     * 
     * @returns { string }
     */

  }, {
    key: 'getDownloadUrl',
    value: function getDownloadUrl(format) {
      return (Object.values(DOWNLOAD_FORMATS).find(function (d) {
        return d.format === format;
      }) || {}).url;
    }

    /**
     * @returns { boolean } whether it has a format to download
     */

  }, {
    key: 'isDownloadable',
    value: function isDownloadable() {
      return !!this.getDownloadableFormats().length;
    }
  }, {
    key: 'isGeoTIFFDownloadable',
    value: function isGeoTIFFDownloadable() {
      return !this.isBaseLayer() && this.config.download && 'gdal' === this.config.source.type;
    }
  }, {
    key: 'isShpDownloadable',
    value: function isShpDownloadable() {
      return !this.isBaseLayer() && this.config.download && 'gdal' !== this.config.source.type;
    }
  }, {
    key: 'isXlsDownloadable',
    value: function isXlsDownloadable() {
      return !this.isBaseLayer() && !!this.config.download_xls;
    }
  }, {
    key: 'isGpxDownloadable',
    value: function isGpxDownloadable() {
      return !this.isBaseLayer() && !!this.config.download_gpx;
    }
  }, {
    key: 'isGpkgDownloadable',
    value: function isGpkgDownloadable() {
      return !this.isBaseLayer() && !!this.config.download_gpkg;
    }
  }, {
    key: 'isCsvDownloadable',
    value: function isCsvDownloadable() {
      return !this.isBaseLayer() && !!this.config.download_csv;
    }

    /******************************************************************************************
     * LAYER RELATIONS
     *****************************************************************************************/

    /**
     * @returns {*} relations
     */

  }, {
    key: 'getRelations',
    value: function getRelations() {
      return this._relations;
    }

    /**
     * @param id
     * 
     * @returns {*} relation by id
     */

  }, {
    key: 'getRelationById',
    value: function getRelationById(id) {
      return this._relations.getArray().find(function (r) {
        return id === r.getId();
      });
    }

    /**
     * @param relationName
     * 
     * @returns { * | Array } relation fields
     */

  }, {
    key: 'getRelationAttributes',
    value: function getRelationAttributes(relationName) {
      var relation = this._relations.find(function (r) {
        return relationName === r.name;
      });
      return relation ? relation.fields : [];
    }

    /**
     * [LAYER RELATIONS]
     * 
     * @TODO Add description
     * 
     * @returns { Object } fields
     */

  }, {
    key: 'getRelationsAttributes',
    value: function getRelationsAttributes() {
      return (this.state.relations || []).reduce(function (fields, r) {
        fields[r.name] = r.fields;
        return fields;
      }, {});
    }

    /**
     * @returns { * | boolean } whether layer is a Child of a relation
     */

  }, {
    key: 'isChild',
    value: function isChild() {
      return this.getRelations() ? this._relations.isChild(this.getId()) : false;
    }

    /**
     * @returns { * | boolean } whether layer is a Father of a relation
     */

  }, {
    key: 'isFather',
    value: function isFather() {
      return this.getRelations() ? this._relations.isFather(this.getId()) : false;
    }

    /**
     * @returns { * |Array } children relations
     */

  }, {
    key: 'getChildren',
    value: function getChildren() {
      return this.isFather() ? this._relations.getChildren(this.getId()) : [];
    }

    /**
     * @returns { * | Array } parents relations
     */

  }, {
    key: 'getFathers',
    value: function getFathers() {
      return this.isChild() ? this._relations.getFathers(this.getId()) : [];
    }

    /**
     * @returns { * | boolean } whether it has children
     */

  }, {
    key: 'hasChildren',
    value: function hasChildren() {
      return this.hasRelations() ? this._relations.hasChildren(this.getId()) : false;
    }

    /**
     * @returns { * | boolean } whether it has fathers
     */

  }, {
    key: 'hasFathers',
    value: function hasFathers() {
      return this.hasRelations() ? this._relations.hasFathers(this.getId()) : false;
    }

    /**
     * @TODO add description
     */

  }, {
    key: 'hasRelations',
    value: function hasRelations() {
      return !!this._relations;
    }

    /******************************************************************************************
     * LAYER SELECTION
     *****************************************************************************************/

    /**
     * @returns { boolean } whether is selected
     */

  }, {
    key: 'isSelected',
    value: function isSelected() {
      return this.state.selected;
    }

    /**
     * @param { boolean } selected
     */

  }, {
    key: 'setSelected',
    value: function setSelected(selected) {
      this.state.selected = selected;
    }

    /**
     * Set Selection
     * 
     * @param bool
     * 
     * @returns {Promise<void>}
     * 
     * @fires unselectionall
     */

  }, {
    key: 'setSelection',
    value: function () {
      var _ref22 = _asyncToGenerator(function* () {
        var bool = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

        this.state.selection.active = bool;

        // skip when selection is active
        if (bool) {
          return;
        }

        //check if filter is active
        var is_active = this.state.filter.active;
        var has_current = null !== this.state.filter.current;

        /** @TODO add description */
        if (has_current && is_active) {
          yield this._applyFilterToken(this.state.filter.current);
        }

        /** @TODO add description */
        if (!has_current && is_active) {
          yield this.deleteFilterToken();
        }

        this.emit('unselectionall', this.getId());
      });

      function setSelection() {
        return _ref22.apply(this, arguments);
      }

      return setSelection;
    }()

    /**
     * @returns { boolean } whether selection si active
     */

  }, {
    key: 'isSelectionActive',
    value: function isSelectionActive() {
      return this.state.selection.active;
    }

    /**
     * @returns {{ active: boolean }} selection
     */

  }, {
    key: 'getSelection',
    value: function getSelection() {
      return this.state.selection;
    }

    /**
     * @returns filter
     */

  }, {
    key: 'getFilter',
    value: function getFilter() {
      return this.state.filter;
    }

    /**
     * Set filter Active to layer
     * 
     * @param {boolean} bool
     */

  }, {
    key: 'setFilter',
    value: function setFilter() {
      var bool = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      this.state.filter.active = bool;
      //@since 3.11.0 need to reset pagination filter when bool is false
      this.state.filter.pagination = bool && this.state.filter.pagination;
      if (this.isGeoLayer() && this.state.filter.active) {
        this.hideOlSelectionFeatures();
      }
      if (this.isGeoLayer() && !this.state.filter.active) {
        this.updateMapOlSelectionFeatures();
      }
    }

    /**
     * Apply layer filter by fid
     * 
     * @param filter
     */

  }, {
    key: 'applyFilter',
    value: function () {
      var _ref23 = _asyncToGenerator(function* (filter) {
        if (!this.providers['filtertoken']) {
          return;
        }

        // the current filter is set and is different from current
        if (null === this.state.filter.current || filter.fid !== this.state.filter.current.fid) {
          yield this.clearSelectionFids();
          _gui2.default.closeContent();
        }

        yield this._applyFilterToken(filter);
      });

      function applyFilter(_x21) {
        return _ref23.apply(this, arguments);
      }

      return applyFilter;
    }()

    /**
     * @returns {Promise<void>}
     * 
     * @private
     */

  }, {
    key: '_applyFilterToken',
    value: function () {
      var _ref24 = _asyncToGenerator(function* (filter) {
        try {
          /** @example /vector/api/filtertoken/<qdjango>/<project_id>/<qgs_layer_id>/mode=apply&fid=<fid_filter_saved>|name=<name_filter_saved> */
          var response = yield _XHR.XHR.get({
            url: this.providers['filtertoken']._layer.getUrl('filtertoken'),
            params: { mode: 'apply', fid: filter.fid }
          });
          if (!response || !response.result || !response.data) {
            return;
          }
          this.setFilter(false);
          this.state.filter.current = filter;
          this.setFilterToken(response.data.filtertoken);
        } catch (e) {
          console.warn(e);
        }
      });

      function _applyFilterToken(_x22) {
        return _ref24.apply(this, arguments);
      }

      return _applyFilterToken;
    }()

    /**
     * @since 3.9.0
     */

  }, {
    key: 'saveFilter',
    value: function saveFilter() {

      // skip when ..
      if (!this.providers['filtertoken'] || !this.selectionFids.size > 0) {
        return;
      }

      var layer = this;

      (0, _prompt.prompt)({
        label: (0, _g3wI18n.t)('layer_selection_filter.tools.savefilter'),
        value: layer.state.filter.current ? layer.state.filter.current.name : '',
        callback: function () {
          var _ref25 = _asyncToGenerator(function* (name) {

            /** @example /vector/api/filtertoken/<qdjango>/<project_id>/<qgs_layer_id>/mode=save&name=<name_filter_saved> */
            var response = yield _XHR.XHR.get({
              url: layer.providers['filtertoken']._layer.getUrl('filtertoken'),
              params: { mode: 'save', name: name } });

            // skip when no data return from provider
            if (!response || !response.result || !response.data) {
              return;
            }

            var filter = layer.state.filters.find(function (f) {
              return response.data.fid === f.fid;
            });

            // add saved filter to filters array
            if (undefined === filter) {
              filter = {
                fid: response.data.fid, //get fid
                name: response.data.name //get name
              };
              layer.state.filters.push(filter);
            }

            layer.state.filter.current = filter; // set current filter
            layer.setFilter(false); // set to false
            layer.getSelection().active = false; // reset selection to false
            layer.selectionFids.clear(); // clear current fids

            //in the case of geolayer
            if (layer.isGeoLayer()) {
              //remove selection feature from map
              layer.setOlSelectionFeatures();
            }

            //emit unselectionall
            layer.emit('unselectionall', layer.getId());
          });

          function callback(_x23) {
            return _ref25.apply(this, arguments);
          }

          return callback;
        }()
      });
    }

    /**
     * Toggle filter token on layer
     */

  }, {
    key: 'toggleFilterToken',
    value: function () {
      var _ref26 = _asyncToGenerator(function* () {

        //set to handle select or hide ol
        this.setFilter(!this.state.filter.active);

        var has_current = this.state.filter.current;
        var is_active = this.state.filter.active;

        // there is an active filter --> create a new filter
        if (is_active) {
          yield this.createFilterToken();
        }

        // there is a current saved filter --> apply filter
        if (has_current && !is_active) {
          yield this.applyFilter(this.state.filter.current);
        }

        // there is no current saved filter --> delete it
        if (!has_current && !is_active) {
          yield this.deleteFilterToken();
        }

        return this.state.filter.active;
      });

      function toggleFilterToken() {
        return _ref26.apply(this, arguments);
      }

      return toggleFilterToken;
    }()

    /**
     * Delete filtertoken from server
     * 
     * @param fid  unique id of filter saved to delete
     */

  }, {
    key: 'deleteFilterToken',
    value: function () {
      var _ref27 = _asyncToGenerator(function* (fid) {
        try {
          // skip when no filtertoken provider is set
          if (!this.providers['filtertoken']) {
            return;
          }

          var filtertoken = void 0;
          try {
            // Delete saved filter from server --> `/vector/api/filtertoken/<qdjango>/<project_id>/<qgs_layer_id>/mode=delete_saved&fid=<fid_filter_saved>|name=<name_filter_saved>`
            // Delete current filter           --> `/vector/api/filtertoken/<qdjango>/<project_id>/<qgs_layer_id>/mode=delete`
            var response = yield _XHR.XHR.get({
              url: this.providers['filtertoken']._layer.getUrl('filtertoken'),
              params: { fid: fid, mode: undefined === fid ? 'delete' : 'delete_saved' }
            });
            // filter token if another layer is filtered otherwise filtertoken is undefined
            if (response && response.result && response.data) {
              filtertoken = response.data.filtertoken;
            }
          } catch (e) {
            console.warn(e);
          }

          // remove it from filters list when deleting a saved filter (since v3.9.0)
          if (undefined !== fid) {
            this.state.filters = this.state.filters.filter(function (f) {
              return fid !== f.fid;
            });
          }

          this.state.filter.current = null; // set current filter set to null
          // set active filter to false
          if (this.state.filter.active) {
            this.setFilter(false);
          }
          this.setFilterToken(filtertoken); // pass `filtertoken` to application
        } catch (e) {
          console.warn(e);
        }
      });

      function deleteFilterToken(_x24) {
        return _ref27.apply(this, arguments);
      }

      return deleteFilterToken;
    }()

    /**
     * Set applicaton filter token
     * 
     * @param {string} filtertoken a string passed by server and used as parameter in XHR request
     *
     * @fires filtertokenchange when filtertoken is changed
     * 
     * @since 3.9.0
     */

  }, {
    key: 'setFilterToken',
    value: function setFilterToken() {
      var filtertoken = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;

      _application2.default.tokens.filtertoken = filtertoken;
      this.setFilter(!!filtertoken);
      this.emit('filtertokenchange', { layerId: this.getId() });
    }

    /**
     * Create filter token
     */

  }, {
    key: 'createFilterToken',
    value: function () {
      var _ref28 = _asyncToGenerator(function* () {
        try {

          var provider = this.providers['filtertoken'];
          var selection = this.selectionFids;

          // skip when no filter token provider is set or selectionFids is empty
          if (!provider || !selection.size > 0) {
            return;
          }

          // select all features
          if (selection.has(_g3wConstants.SELECTION.ALL)) {
            try {
              // Delete current filter --> `/vector/api/filtertoken/<qdjango>/<project_id>/<qgs_layer_id>/mode=delete`
              yield _XHR.XHR.get({
                url: this.providers['filtertoken']._layer.getUrl('filtertoken'),
                params: { fid: undefined, mode: 'delete' }
              });
            } catch (e) {
              console.warn(e);
            }
            this.setFilterToken(null);

            return;
          }

          var fids = Array.from(selection);

          var _ref29 = yield _XHR.XHR.post({
            url: provider._layer.getUrl('filtertoken'),
            contentType: 'application/json',
            data: JSON.stringify(selection.has(_g3wConstants.SELECTION.EXCLUDE) ? { fidsout: fids.filter(function (id) {
                return id !== _g3wConstants.SELECTION.EXCLUDE;
              }).join(',') // exclude features from selection
            } : { fidsin: fids.join(',') }) // include features in selection
          }),
              _ref29$data = _ref29.data,
              data = _ref29$data === undefined ? {} : _ref29$data;

          this.setFilterToken(data.filtertoken);
        } catch (e) {
          console.warn(e);
        }
      });

      function createFilterToken() {
        return _ref28.apply(this, arguments);
      }

      return createFilterToken;
    }()

    /**
     * Get Application filter token
     * 
     * @returns {*}
     */

  }, {
    key: 'getFilterToken',
    value: function getFilterToken() {
      return _application2.default.tokens.filtertoken;
    }

    /**
     * @TODO add description
     */

  }, {
    key: 'setSelectionFidsAll',
    value: function setSelectionFidsAll() {
      this.selectionFids.clear();
      this.selectionFids.add(_g3wConstants.SELECTION.ALL);

      /** @TODO add description */
      if (this.isGeoLayer()) {
        //set all features selected
        Object.values(this.olSelectionFeatures).forEach(function (feat) {
          return feat.selected = true;
        });
        this.updateMapOlSelectionFeatures();
      }

      /** @TODO add description */
      this.setSelection(true);
      if (this.state.filter.active) {
        this.createFilterToken();
      }
    }

    /**
     * @returns {Set<any>} stored selection `fids` 
     */

  }, {
    key: 'getSelectionFids',
    value: function getSelectionFids() {
      return this.selectionFids;
    }

    /**
     * Invert current selection fids
     */

  }, {
    key: 'invertSelectionFids',
    value: function invertSelectionFids() {
      var selection = this.selectionFids;

      /** @TODO add description */
      if (selection.has(_g3wConstants.SELECTION.EXCLUDE)) {
        selection.delete(_g3wConstants.SELECTION.EXCLUDE);
      } else if (selection.has(_g3wConstants.SELECTION.ALL)) {
        selection.delete(_g3wConstants.SELECTION.ALL);
      } else if (selection.size > 0) {
        selection.add(_g3wConstants.SELECTION.EXCLUDE);
      }

      /** @TODO add description */
      if (this.isGeoLayer()) {
        this.setInversionOlSelectionFeatures();
      }

      /** In the case of tocken filter active create */
      if (this.state.filter.active) {
        this.createFilterToken();
      }

      this.setSelection(selection.size > 0);
    }

    /**
     * Check if feature id is present
     * 
     * @param fid feature id
     * 
     * @returns {boolean}
     */

  }, {
    key: 'hasSelectionFid',
    value: function hasSelectionFid(fid) {
      var selection = this.selectionFids;

      /** In case contain selection ALL, mean all features selected */
      if (selection.has(_g3wConstants.SELECTION.ALL)) {
        return true;
      }

      /**In case selection contains exclude value, check if id is not in excluded feature id */
      if (selection.has(_g3wConstants.SELECTION.EXCLUDE)) {
        return !selection.has(fid);
      }

      /** Check if id is on selection set */
      return selection.has(fid);
    }

    /**
     * Include fid feature id to selection
     * 
     * @param fid
     * @param createToken
     * 
     * @returns {Promise<void>}
     */

  }, {
    key: 'includeSelectionFid',
    value: function () {
      var _ref30 = _asyncToGenerator(function* (fid) {
        var createToken = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;


        var selection = this.selectionFids;

        // whether fid is excluded from selection
        var is_excluded = selection.has(_g3wConstants.SELECTION.EXCLUDE) && selection.has(fid);

        // remove fid from exclude
        if (is_excluded) {
          selection.delete(fid);
        }

        // add to selection fid
        if (!is_excluded) {
          selection.add(fid);
        }

        // if the only one exclude Set all selected
        if (is_excluded && 1 === selection.size) {
          this.setSelectionFidsAll();
        }

        /** @TODO add description */
        if (!is_excluded && !this.isSelectionActive()) {
          this.setSelection(true);
        }

        /** @TODO add description */
        if (this.isGeoLayer()) {
          this.setOlSelectionFeatureByFid(fid, is_excluded ? 'remove' : 'add');
        }

        /** @TODO add description */
        if (createToken && this.state.filter.active) {
          yield this.createFilterToken();
        }
      });

      function includeSelectionFid(_x27) {
        return _ref30.apply(this, arguments);
      }

      return includeSelectionFid;
    }()

    /**
     * Exclude fid to selection
     * 
     * @param fid
     * @param createToken
     * 
     * @returns {Promise<void>}
     */

  }, {
    key: 'excludeSelectionFid',
    value: function () {
      var _ref31 = _asyncToGenerator(function* (fid) {
        var createToken = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;


        var selection = this.selectionFids;

        /**In case all features are selected or no features are selected */
        if (selection.has(_g3wConstants.SELECTION.ALL) || 0 === selection.size) {
          //set an empty selection set
          selection.clear();
          //add exclude item
          selection.add(_g3wConstants.SELECTION.EXCLUDE);
        }

        /** If has exclude item, mean add fid to exclude */
        if (selection.has(_g3wConstants.SELECTION.EXCLUDE)) {
          //add to exclude
          selection.add(fid);
        } else {
          //remote to exclude
          selection.delete(fid);
        }

        /** If no selection */
        if (0 === selection.size) {
          this.clearSelectionFids();
        }

        /** If contain only exclude fid */
        if (1 === selection.size && selection.has(_g3wConstants.SELECTION.EXCLUDE)) {
          //celar selection set
          selection.clear();
          this.setselectionFidsAll();
        }

        if (this.isGeoLayer()) {
          // whether fid is excluded from selection
          this.setOlSelectionFeatureByFid(fid, selection.has(_g3wConstants.SELECTION.EXCLUDE) ? selection.has(fid) : !selection.has(fid) ? 'remove' : 'add');
        }

        /** If there is a filterActive */
        if (createToken && this.state.filter.active) {
          yield this.createFilterToken();
        }
      });

      function excludeSelectionFid(_x29) {
        return _ref31.apply(this, arguments);
      }

      return excludeSelectionFid;
    }()

    /**
     * @param { Array }   fids
     * @param { boolean } createToken since 3.9.0
     * 
     * @returns { Promise<void> }
     */

  }, {
    key: 'includeSelectionFids',
    value: function () {
      var _ref32 = _asyncToGenerator(function* () {
        var _this7 = this;

        var fids = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        var createToken = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

        // pass false because eventually token filter creation needs to be called after
        fids.forEach(function (fid) {
          return _this7.includeSelectionFid(fid, false);
        });

        /** @TODO add description */
        if (createToken && this.state.filter.active) {
          yield this.createFilterToken();
        }
      });

      function includeSelectionFids() {
        return _ref32.apply(this, arguments);
      }

      return includeSelectionFids;
    }()

    /**
     * Exclude fids from selection
     * 
     * @param { Array }   fids
     * @param { boolean } createToken since 3.9.0
     * 
     * @returns { Promise<void> }
     */

  }, {
    key: 'excludeSelectionFids',
    value: function () {
      var _ref33 = _asyncToGenerator(function* () {
        var _this8 = this;

        var fids = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        var createToken = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

        //pass false because eventually token filter creation needs to be called after
        fids.forEach(function (fid) {
          return _this8.excludeSelectionFid(fid, false);
        });

        /** @TODO add description */
        if (createToken && this.state.filter.active) {
          yield this.createFilterToken();
        }
      });

      function excludeSelectionFids() {
        return _ref33.apply(this, arguments);
      }

      return excludeSelectionFids;
    }()

    /**
     * Clear selection
     */

  }, {
    key: 'clearSelectionFids',
    value: function () {
      var _ref34 = _asyncToGenerator(function* () {
        this.selectionFids.clear();
        // remove selected feature on a map
        if (this.isGeoLayer()) {
          //set all features unselected
          Object.values(this.olSelectionFeatures).forEach(function (feat) {
            return feat.selected = false;
          });
          this.updateMapOlSelectionFeatures();
        }
        // set selection false
        yield this.setSelection(false);
      });

      function clearSelectionFids() {
        return _ref34.apply(this, arguments);
      }

      return clearSelectionFids;
    }()

    /******************************************************************************************
     * LAYER BASE
     *****************************************************************************************/

    /**
     * Proxy params data
     */

  }, {
    key: 'getProxyData',
    value: function getProxyData(type) {
      return type ? this.proxyData[type] : this.proxyData;
    }

    /**
     * Set proxy data
     *
     * @param type
     * @param data
     */

  }, {
    key: 'setProxyData',
    value: function setProxyData(type) {
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      this.proxyData[type] = data;
    }

    /**
     * Clear proxy data
     *
     * @param type
     */

  }, {
    key: 'clearProxyData',
    value: function clearProxyData(type) {
      this.proxyData[type] = null;
    }

    /**
     * Get a proxy request
     *
     * @param type
     * @param proxyParams
     *
     * @returns {Promise<*>}
     */

  }, {
    key: 'getDataProxyFromServer',
    value: function () {
      var _ref35 = _asyncToGenerator(function* () {
        var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'wms';
        var proxyParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        try {
          var _ref36 = yield _data2.default.getData('proxy:' + type, {
            inputs: proxyParams,
            outputs: false
          }),
              response = _ref36.response,
              data = _ref36.data;

          this.setProxyData(type, JSON.parse(data));
          return response;
        } catch (e) {
          console.warn(e);
        }
      });

      function getDataProxyFromServer() {
        return _ref35.apply(this, arguments);
      }

      return getDataProxyFromServer;
    }()

    /**
     * @TODO Add description
     *
     * @param type
     * @param changes
     *
     * @returns {Promise<*>}
     */

  }, {
    key: 'changeProxyDataAndReloadFromServer',
    value: function changeProxyDataAndReloadFromServer() {
      var _this9 = this;

      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'wms';
      var changes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      Object.keys(changes).forEach(function (c) {
        Object.keys(changes[c]).forEach(function (p) {
          _this9.proxyData[type][c][p] = changes[c][p];
        });
      });
      return this.getDataProxyFromServer(type, this.proxyData[type]);
    }

    /**
     * [EDITING PLUGIN] Check if layer is in editing
     *
     * @returns { boolean }
     */

  }, {
    key: 'isInEditing',
    value: function isInEditing() {
      return this.state.inediting;
    }

    /**
     * [EDITING PLUGIN] Set editing state
     *
     * @param {boolean} bool
     */

  }, {
    key: 'setInEditing',
    value: function setInEditing() {
      var bool = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      this.state.inediting = bool;
    }

    /**
     * @TODO Add description here
     *
     * @returns {*}
     */

  }, {
    key: 'getSearchParams',
    value: function getSearchParams() {
      return this.config.searchParams;
    }

    /**
     * @deprecated since 3.10.0. Will be removed in v.4.x.
     */

  }, {
    key: 'getSearchEndPoint',
    value: function getSearchEndPoint() {
      console.warn('getSearchEndPoint is deprecated');
      return 'api';
    }

    /**
     * @TODO Add description
     *
     * @param pageLength
     */

  }, {
    key: 'setAttributeTablePageLength',
    value: function setAttributeTablePageLength(pageLength) {
      this.state.attributetable.pageLength = pageLength;
    }

    /**
     * @TODO add description
     *
     * @returns {null}
     */

  }, {
    key: 'getAttributeTablePageLength',
    value: function getAttributeTablePageLength() {
      return this.state.attributetable.pageLength;
    }

    /**
     * @returns { string } wms layer name for wms request
     */

  }, {
    key: 'getWMSLayerName',
    value: function getWMSLayerName() {
      return this.isWmsUseLayerIds() ? this.getId() : this.getName();
    }

    /**
     * @returns { boolean | *} whether request need to use `layer.id` or `layer.name`
     */

  }, {
    key: 'isWmsUseLayerIds',
    value: function isWmsUseLayerIds() {
      return this.config.wms_use_layer_ids;
    }

    /**
     * @returns {*|null} source type of layer
     */

  }, {
    key: 'getSourceType',
    value: function getSourceType() {
      return this.config.source ? this.config.source.type : null;
    }

    /**
     * @returns {boolean} whether it is a layer with geometry
     */

  }, {
    key: 'isGeoLayer',
    value: function isGeoLayer() {
      return this.state.geolayer;
    }

    /**
     * @TODO Add description
     *
     * @param { Object } opts
     * @param opts.page
     * @param opts.page_size
     * @param opts.ordering
     * @param opts.search
     * @param opts.suggest
     * @param opts.formatter
     * @param opts.custom_params
     * @param opts.field
     * @param opts.in_bbox
     *
     * @returns {*}
     */

  }, {
    key: 'getDataTable',
    value: function getDataTable() {
      var _this10 = this;

      var _ref37 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref37$page = _ref37.page,
          page = _ref37$page === undefined ? null : _ref37$page,
          _ref37$page_size = _ref37.page_size,
          page_size = _ref37$page_size === undefined ? null : _ref37$page_size,
          _ref37$ordering = _ref37.ordering,
          ordering = _ref37$ordering === undefined ? null : _ref37$ordering,
          _ref37$search = _ref37.search,
          search = _ref37$search === undefined ? null : _ref37$search,
          _ref37$suggest = _ref37.suggest,
          suggest = _ref37$suggest === undefined ? null : _ref37$suggest,
          _ref37$formatter = _ref37.formatter,
          formatter = _ref37$formatter === undefined ? 0 : _ref37$formatter,
          _ref37$custom_params = _ref37.custom_params,
          custom_params = _ref37$custom_params === undefined ? {} : _ref37$custom_params,
          field = _ref37.field,
          in_bbox = _ref37.in_bbox;

      return (0, _promisify.$promisify)(_asyncToGenerator(function* () {

        // skip when..
        if (!_this10.getProvider('filter') && !_this10.getProvider('data')) {
          return Promise.reject();
        }

        var response = yield (0, _promisify.promisify)(_this10.getProvider('data').getFeatures({ editing: false }, _extends({}, custom_params, {
          field: field,
          page: page,
          page_size: page_size,
          ordering: ordering,
          search: search,
          formatter: formatter,
          suggest: suggest,
          in_bbox: in_bbox,
          filtertoken: _application2.default.tokens.filtertoken
        })));
        var features = response.data.features && response.data.features || [];
        return {
          headers: (0, _parseAttributes.parseAttributes)(_this10.getAttributes(), features.length ? features[0].properties : []),
          features: features,
          title: _this10.getTitle(),
          count: response.count
        };
      }));
    }

    /**
     * Search layer feature by fids
     *
     * @param fids
     * @param formatter
     */

  }, {
    key: 'getFeatureByFids',
    value: function () {
      var _ref39 = _asyncToGenerator(function* () {
        var _ref40 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            _ref40$fids = _ref40.fids,
            fids = _ref40$fids === undefined ? [] : _ref40$fids,
            _ref40$formatter = _ref40.formatter,
            formatter = _ref40$formatter === undefined ? 0 : _ref40$formatter;

        var url = this.getUrl('data');
        try {
          var response = yield _XHR.XHR.get({
            url: url,
            params: {
              fids: fids.toString(),
              formatter: formatter
            }
          });
          if (response && response.result && response.vector && response.vector.data) {
            return response.vector.data.features;
          }
        } catch (e) {
          console.warn(e);
        }
      });

      function getFeatureByFids() {
        return _ref39.apply(this, arguments);
      }

      return getFeatureByFids;
    }()

    /**
     * @TODO deprecate `search_endpoint = 'ows'`
     *
     * Search Features
     * 
     * @param { Object }        options
     * @param { 'ows' | 'api' } options.search_endpoint
     * @param { boolean }       options.raw
     * @param { 0 | 1 }         options.formatter
     * @param options.filter
     * @param options.suggest
     * @param options.unique
     * @param options.queryUrl
     * @param options.ordering
     * @param options.autofilter //@since 3.11.0
     * @param { Object }        params - OWS search params
     * 
     * @returns { Promise }
     */

  }, {
    key: 'searchFeatures',
    value: function searchFeatures() {
      var _this11 = this;

      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var _options$search_endpo = options.search_endpoint,
          search_endpoint = _options$search_endpo === undefined ? this.config.search_endpoint : _options$search_endpo;


      return new Promise(function () {
        var _ref41 = _asyncToGenerator(function* (resolve, reject) {
          switch (search_endpoint) {

            case 'ows':
              _this11.search(options, params).then(function (results) {
                resolve({ data: results });
              }).fail(function (e) {
                console.warn(e);reject(e);
              });
              break;

            case 'api':
              try {
                resolve((yield _this11.getFilterData({
                  queryUrl: options.queryUrl,
                  field: options.filter,
                  ordering: options.ordering,
                  unique: options.unique,
                  raw: undefined !== options.raw ? options.raw : false,
                  suggest: options.suggest,
                  /** @since 3.9.0 */
                  formatter: undefined !== options.formatter ? options.formatter : 1,
                  /** @since 3.11.0 */
                  autofilter: options.autofilter,
                  page: options.page,
                  page_size: options.page_size
                })));
              } catch (e) {
                console.warn(e);
                reject(e);
              }
              break;
          }
        });

        return function (_x44, _x45) {
          return _ref41.apply(this, arguments);
        };
      }());
    }

    /**
     * Get feature data based on `field` and `suggests`
     * 
     * @param { Object }    opts
     * @param { boolean }   opts.raw
     * @param { Object }    opts.suggest   - (mandatory): object with key is a field of layer and value is value of the field to filter
     * @param { 0 | 1 }     opts.formatter
     * @param { Array }     opts.field     - Array of object with type of suggest (see above)
     * @param opts.unique
     * @param opts.fformatter  since 3.9.0
     * @param opts.ffield      since 3.9.1
     * @param opts.queryUrl
     * @param opts.ordering
     */

  }, {
    key: 'getFilterData',
    value: function () {
      var _ref42 = _asyncToGenerator(function* () {
        var _ref43 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            _ref43$raw = _ref43.raw,
            raw = _ref43$raw === undefined ? false : _ref43$raw,
            suggest = _ref43.suggest,
            field = _ref43.field,
            unique = _ref43.unique,
            fformatter = _ref43.fformatter,
            ffield = _ref43.ffield,
            _ref43$formatter = _ref43.formatter,
            formatter = _ref43$formatter === undefined ? 1 : _ref43$formatter,
            queryUrl = _ref43.queryUrl,
            ordering = _ref43.ordering,
            autofilter = _ref43.autofilter,
            page = _ref43.page,
            page_size = _ref43.page_size;

        var provider = this.getProvider('data');
        provider._projections = provider._projections || { map: null, layer: null };
        var params = {
          field: field,
          suggest: suggest,
          ordering: ordering,
          formatter: formatter,
          unique: unique,
          fformatter: fformatter,
          ffield: ffield,
          filtertoken: _application2.default.tokens.filtertoken,
          autofilter: autofilter,
          page: page,
          page_size: page_size
        };
        try {
          var url = queryUrl ? queryUrl : provider._layer.getUrl('data');
          var response = field // check `field` parameter
          ? yield _XHR.XHR.post({ url: url, contentType: 'application/json', data: JSON.stringify(params) }) // since g3w-admin@v3.7
          : yield _XHR.XHR.get({ url: url, params: params }); // BACKCOMP (`unique` and `ordering` were only GET parameters)

          // vector layer
          if ('table' !== provider._layer.getType()) {
            provider._projections.map = provider._layer.getMapProjection() || provider._projections.layer;
          }

          if (raw) {
            return response;
          }
          if (unique && response.result) {
            return response.data;
          }
          if (fformatter && response.result) {
            return response;
          }

          if (response.result) {
            return {
              data: _parsers.ResponseParser.get('application/json')({
                layers: [provider._layer],
                response: response.vector.data,
                filtertoken: response.filtertoken, //@since v3.11.0 returned filtertoken in case of autofilter request
                projections: provider._projections
              }),
              count: response.vector.count //@since v3.11.0 take in account feature count (all). It use for pagination purpose
            };
          }
        } catch (e) {
          console.warn(e);
          return Promise.reject(e);
        }
        return Promise.reject();
      });

      function getFilterData() {
        return _ref42.apply(this, arguments);
      }

      return getFilterData;
    }()

    /**
     * search method 
     */

  }, {
    key: 'search',
    value: function search() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      options = _extends({}, options, {
        feature_count: options.feature_count || 10
      }, this.config.searchParams, params);
      var provider = this.getProvider('search');
      return (0, _promisify.$promisify)(_asyncToGenerator(function* () {
        if (provider) {
          return yield (0, _promisify.promisify)(provider.query(options));
        }
        return Promise.reject((0, _g3wI18n.t)('sdk.search.layer_not_searchable'));
      }));
    }

    /**
     * Info from layer (only for querable layers) 
     */

  }, {
    key: 'query',
    value: function query() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var provider = this.getProvider(options.filter ? 'filter' : 'query');
      return (0, _promisify.$promisify)(_asyncToGenerator(function* () {
        if (provider) {
          return yield (0, _promisify.promisify)(provider.query(options));
        }
        return Promise.reject((0, _g3wI18n.t)('sdk.search.layer_not_querable'));
      }));
    }

    /**
     * General way to get an attribute 
     */

  }, {
    key: 'get',
    value: function get(property) {
      return this.config[property] ? this.config[property] : this.state[property];
    }

    /**
     * @returns { * | {} } layer fields
     */

  }, {
    key: 'getFields',
    value: function getFields() {
      return this.config.fields;
    }

    /**
     * @returns { Array } editing fields
     */

  }, {
    key: 'getEditingFields',
    value: function getEditingFields() {
      return this.config.editing.fields;
    }

    /**
     * @returns { Array } only show fields
     */

  }, {
    key: 'getTableFields',
    value: function getTableFields() {
      return (this.config.fields || []).filter(function (f) {
        return f.show;
      });
    }

    /**
     * @returns { Array } table fields exclude geometry field
     */

  }, {
    key: 'getTableHeaders',
    value: function getTableHeaders() {
      return this.getTableFields().filter(function (f) {
        return !_g3wConstants.GEOMETRY_FIELDS.includes(f.name);
      });
    }

    /**
     * @returns {*} current project
     */

  }, {
    key: 'getProject',
    value: function getProject() {
      return this.config.project;
    }

    /**
     * @returns { Object } layer config
     */

  }, {
    key: 'getConfig',
    value: function getConfig() {
      return this.config;
    }

    /**
     *
     * @returns { Array } form structure to show on form editing
     */

  }, {
    key: 'getLayerEditingFormStructure',
    value: function getLayerEditingFormStructure() {
      return this.config.editor_form_structure;
    }

    /**
     * @returns { boolean } whether it has form structure
     */

  }, {
    key: 'hasFormStructure',
    value: function hasFormStructure() {
      return !!this.config.editor_form_structure;
    }

    /**
     * @returns custom style (for future implementation)
     */

  }, {
    key: 'getCustomStyle',
    value: function getCustomStyle() {
      return this.config.customstyle;
    }

    /**
     * Get state layer
     *
     * @returns {*|{metadata, downloadable: *, attributetable: {pageLength: null}, defaultstyle: *, source, title: *, infoformats: ((function(): *)|*|*[]), tochighlightable: boolean, featurecount: number, stylesfeaturecount: (number|string|*|{[p: number]: *}), projectLayer: boolean, infoformat: (string|default.watch.infoformat|*), geolayer: boolean, inediting: boolean, disabled: boolean, id: (*|string), selected: boolean, openattributetable: (boolean|boolean), visible: boolean, filters: *[], filter: {current: null, active: boolean}, selection: {active: boolean}, removable: (boolean|*), styles}}
     */

  }, {
    key: 'getState',
    value: function getState() {
      return this.state;
    }

    /**
     * @returns {*} layer source (ex. ogr, spatialite, etc..)
     */

  }, {
    key: 'getSource',
    value: function getSource() {
      return this.state.source;
    }

    /**
     * @returns {*} editing version of layer
     */

  }, {
    key: 'getEditingLayer',
    value: function getEditingLayer() {
      return this._editingLayer;
    }

    /**
     * Set editing layer
     *
     * @param editingLayer
     */

  }, {
    key: 'setEditingLayer',
    value: function setEditingLayer(editingLayer) {
      this._editingLayer = editingLayer;
    }

    /**
     * @returns {string|string[]|boolean|string|*} whether is hidden
     */

  }, {
    key: 'isHidden',
    value: function isHidden() {
      return this.state.hidden;
    }

    /**
     * Set hidden
     *
     * @param bool
     */

  }, {
    key: 'setHidden',
    value: function setHidden() {
      var bool = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      this.state.hidden = bool;
    }

    /**
     * @returns {*|string} id
     */

  }, {
    key: 'getId',
    value: function getId() {
      return this.config.id;
    }

    /**
     * @returns {*} metadata
     */

  }, {
    key: 'getMetadata',
    value: function getMetadata() {
      return this.state.metadata;
    }

    /**
     * @returns {*} title
     */

  }, {
    key: 'getTitle',
    value: function getTitle() {
      return this.config.title;
    }

    /**
     * @returns {*} name
     */

  }, {
    key: 'getName',
    value: function getName() {
      return this.config.name;
    }

    /**
     * @returns {*} origin name
     */

  }, {
    key: 'getOrigName',
    value: function getOrigName() {
      return this.config.origname;
    }

    /**
     * @returns { string } Server type
     */

  }, {
    key: 'getServerType',
    value: function getServerType() {
      return this.config.servertype || "QGIS";
    }

    /**
     * @returns {*} type
     */

  }, {
    key: 'getType',
    value: function getType() {
      return this.type;
    }

    /**
     * Check if layer is a type passed
     *
     * @param type
     *
     * @returns {boolean}
     */

  }, {
    key: 'isType',
    value: function isType(type) {
      return type === this.getType();
    }

    /**
     * Set disabled
     *
     * @param bool
     */

  }, {
    key: 'setDisabled',
    value: function setDisabled(bool) {
      this.state.disabled = bool;
    }

    /**
     * @returns {boolean} whether it is disabled
     */

  }, {
    key: 'isDisabled',
    value: function isDisabled() {
      return this.state.disabled;
    }

    /**
     * @returns {boolean} whether is visible
     */

  }, {
    key: 'isVisible',
    value: function isVisible() {
      return this.state.visible;
    }

    /**
     * Set visibility
     *
     * @param bool
     */

  }, {
    key: 'setVisible',
    value: function setVisible(bool) {
      this.state.visible = bool;
    }

    /**
     * @param { Object } param
     * @param param.map check if request from map point of view or just a capabilities info layer
     */

  }, {
    key: 'isQueryable',
    value: function isQueryable() {
      return !!(this.config.capabilities && this.config.capabilities & Layer.CAPABILITIES.QUERYABLE);
    }

    /**
     * @TODO Description
     *
     * @returns {boolean}
     */

  }, {
    key: 'getTocHighlightable',
    value: function getTocHighlightable() {
      return this.state.tochighlightable;
    }

    /**
     * @TODO Description
     *
     * @param bool
     */

  }, {
    key: 'setTocHighlightable',
    value: function setTocHighlightable() {
      var bool = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      this.state.tochighlightable = bool;
    }

    /**
     * @param conditions plain object with configuration layer attribute and value
     */

  }, {
    key: 'isFilterable',
    value: function isFilterable() {
      var _this12 = this;

      var conditions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      var isFiltrable = !!(this.config.capabilities && this.config.capabilities & Layer.CAPABILITIES.FILTERABLE);
      if (isFiltrable && conditions) {
        var conditionalFiltrable = Object.keys(conditions).reduce(function (bool, attribute) {
          var layer_config_value = _this12.get(attribute);
          var condition_attribute_values = conditions[attribute];
          return bool && Array.isArray(layer_config_value) ? layer_config_value.includes(condition_attribute_values) : condition_attribute_values === layer_config_value;
        }, true);
        isFiltrable = isFiltrable && conditionalFiltrable;
      }
      return isFiltrable;
    }

    /**
     * @returns { boolean } whether layer is set up as time series
     */

  }, {
    key: 'isQtimeseries',
    value: function isQtimeseries() {
      return this.config.qtimeseries;
    }

    /**
     * @returns { boolean } whether is editable
     */

  }, {
    key: 'isEditable',
    value: function isEditable() {
      return !!(this.config.capabilities && this.config.capabilities & Layer.CAPABILITIES.EDITABLE);
    }

    /**
     * @returns {*|boolean} whether is a base layer
     */

  }, {
    key: 'isBaseLayer',
    value: function isBaseLayer() {
      return this.config.baselayer;
    }

    /**
     * @param type get url by type (data, shp, csv, xls, editing, ...)
     */

  }, {
    key: 'getUrl',
    value: function getUrl(type) {
      return this.config.urls[type];
    }

    /**
     * Set config url
     * 
     * @param { Object } url
     * @param url.type
     * @param url.url
     */

  }, {
    key: 'setUrl',
    value: function setUrl() {
      var _ref46 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          type = _ref46.type,
          url = _ref46.url;

      this.config.urls[type] = url;
    }

    /**
     * @returns {*} query url
     */

  }, {
    key: 'getQueryUrl',
    value: function getQueryUrl() {
      return this.config.urls.query;
    }

    /**
     * @TODO Description
     *
     * @returns {*}
     */

  }, {
    key: 'getQueryLayerOrigName',
    value: function getQueryLayerOrigName() {
      return this.state.infolayer && '' !== this.config.infolayer ? this.config.infolayer : this.config.origname;
    }

    /**
     * @TODO Description
     *
     * @param ogcService
     *
     * @returns { default.watch.infoformat | * | string }
     */

  }, {
    key: 'getInfoFormat',
    value: function getInfoFormat(ogcService) {
      // In the case of NETCDF (qtime series)
      if (true === this.config.qtimeseries || 'gdal' === this.getSourceType()) {
        return 'application/json';
      }
      if (this.config.infoformat && '' !== this.config.infoformat && 'wfs' !== ogcService) {
        return this.config.infoformat;
      }
      return 'application/vnd.ogc.gml';
    }

    /**
     * @TODO Description
     *
     * @returns {(function(): *)|*|*[]}
     */

  }, {
    key: 'getInfoFormats',
    value: function getInfoFormats() {
      return this.state.infoformats;
    }

    /**
     * @TODO Description
     *
     * @returns {*}
     */

  }, {
    key: 'getInfoUrl',
    value: function getInfoUrl() {
      return this.config.infourl;
    }

    /**
     * @TODO Description
     *
     * @param infoFormat
     */

  }, {
    key: 'setInfoFormat',
    value: function setInfoFormat(infoFormat) {
      this.config.infoformat = infoFormat;
    }

    /**
     * @TODO Description
     *
     * @returns {*|{}}
     */

  }, {
    key: 'getAttributes',
    value: function getAttributes() {
      return this.config.fields;
    }

    /**
     * @TODO Description
     *
     * @param attribute
     * @param type
     * @param options
     */

  }, {
    key: 'changeAttribute',
    value: function changeAttribute(attribute, type, options) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = this.config.fields[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var field = _step.value;

          if (field.name === attribute) {
            field.type = type;
            field.options = options;
            break;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    }

    /**
     * @TODO Description
     *
     * @param name
     *
     * @returns {*}
     */

  }, {
    key: 'getAttributeLabel',
    value: function getAttributeLabel(name) {
      return (this.getAttributes().find(function (a) {
        return name === a.name;
      }) || {}).label;
    }

    /**
     * Return provider by type
     *
     * @param type
     *
     * @returns {*}
     */

  }, {
    key: 'getProvider',
    value: function getProvider(type) {
      return this.providers[type];
    }

    /**
     * Return all providers
     *
     * @returns {*|{filter: null, search: null, data: null, query: null, filtertoken: null}}
     */

  }, {
    key: 'getProviders',
    value: function getProviders() {
      return this.providers;
    }

    /**
     * @TODO Description
     *
     * @returns {*}
     */

  }, {
    key: 'getLayersStore',
    value: function getLayersStore() {
      return this._layersstore;
    }

    /**
     * @TODO Description
     *
     * @param layerstore
     */

  }, {
    key: 'setLayersStore',
    value: function setLayersStore(layerstore) {
      this._layersstore = layerstore;
    }

    /**
     * Return if it is possible to show table of attribute
     *
     * @returns {boolean}
     */

  }, {
    key: 'canShowTable',
    value: function canShowTable() {
      if (this.config.not_show_attributes_table || this.isBaseLayer()) {
        return false;
      }

      if ("QGIS" === this.getServerType() && ["postgres", "oracle", "wfs", "ogr", "mssql", "spatialite"].includes(this.config.source.type) && this.isQueryable()) {
        return this.getTableFields().length > 0;
      }

      if ("G3WSUITE" === this.getServerType() && "geojson" === this.get('source').type) {
        return true;
      }

      if ("G3WSUITE" !== this.getServerType() && this.isFilterable()) {
        return true;
      }

      return false;
    }

    /**
     * @TODO Description
     *
     * @param { Object } field
     * @param field.name
     * @param field.type
     * @param field.options
     * @param field.reset
     *
     * @returns {*}
     */

  }, {
    key: 'changeFieldType',
    value: function changeFieldType() {
      var _ref47 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          name = _ref47.name,
          type = _ref47.type,
          _ref47$options = _ref47.options,
          options = _ref47$options === undefined ? {} : _ref47$options,
          _ref47$reset = _ref47.reset,
          reset = _ref47$reset === undefined ? false : _ref47$reset;

      var field = this.getFields().find(function (f) {
        return name === f.name;
      });

      if (field && reset) {
        field.type = field._type;
        delete field._type;
        delete field[type + 'options'];
        return field.type;
      }

      if (field && !reset) {
        field._type = field.type;
        field.type = type;
        field[type + 'options'] = options;
        return field._type;
      }
    }

    /**
     * @TODO Description
     *
     * @param { Object } config
     * @param config.name
     * @param config.type
     * @param config.options
     * @param config.reset
     *
     * @returns {*}
     */

  }, {
    key: 'changeConfigFieldType',
    value: function changeConfigFieldType(_ref48) {
      var name = _ref48.name,
          type = _ref48.type,
          _ref48$options = _ref48.options,
          options = _ref48$options === undefined ? {} : _ref48$options,
          _ref48$reset = _ref48.reset,
          reset = _ref48$reset === undefined ? false : _ref48$reset;

      return this.changeFieldType({ name: name, type: type, options: options, reset: reset });
    }

    /**
     * Function called in case of change project to remove all stored information 
     */

  }, {
    key: 'clear',
    value: function clear() {}

    /**
     * @returns {boolean} whether is a vector layer
     */

  }, {
    key: 'isVector',
    value: function isVector() {
      return Layer.LayerTypes.VECTOR === this.getType();
    }

    /**
     * @returns {boolean} whether is a table layer
     */

  }, {
    key: 'isTable',
    value: function isTable() {
      return Layer.LayerTypes.TABLE === this.getType();
    }

    /**
     * @since 3.8.0
     */

  }, {
    key: 'getFeatureCount',
    value: function getFeatureCount() {
      return this.state.featurecount;
    }

    /**
     * @param style
     * 
     * @returns { Promise<Object | void>}
     * 
     * @since 3.8.0
     */

  }, {
    key: 'getStyleFeatureCount',
    value: function () {
      var _ref49 = _asyncToGenerator(function* (style) {
        // skip when layer hasn't feature count option set on QGIS project
        if (undefined === this.state.stylesfeaturecount) {
          return;
        }
        if (undefined === this.state.stylesfeaturecount[style]) {
          try {
            var _ref50 = yield _XHR.XHR.post({
              url: '' + this.config.urls.featurecount + this.getId() + '/',
              data: JSON.stringify({ style: style }),
              contentType: 'application/json'
            }),
                result = _ref50.result,
                data = _ref50.data;

            this.state.stylesfeaturecount[style] = true === result ? data : {};
          } catch (e) {
            cansole.warn(e);
            this.state.stylesfeaturecount[style] = {};
          }
        }
        return this.state.stylesfeaturecount[style];
      });

      function getStyleFeatureCount(_x55) {
        return _ref49.apply(this, arguments);
      }

      return getStyleFeatureCount;
    }()

    /**
     * @returns { string } layer format (eg. 'image/png') 
     * 
     * @since 3.9.1
     */

  }, {
    key: 'getFormat',
    value: function getFormat() {
      return this.config.format || _application2.default.project.state.wms_getmap_format || 'image/png';
    }

    /**
     * @since 3.10.0
     */

  }, {
    key: 'openAttributeTable',
    value: function openAttributeTable() {
      var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      new (Vue.extend(_Table2.default))(_extends({}, opts, { layerId: this.state.id }));
    }
  }]);

  return Layer;
}(_g3wObject2.default);

/******************************************************************************************
 * LAYER PROPERTIES
 *****************************************************************************************/

/**
 * Layer Types
 */


Layer.LayerTypes = {
  TABLE: "table",
  IMAGE: "image",
  VECTOR: "vector"
};

/**
 * Layer Capabilities
 */
Layer.CAPABILITIES = {
  QUERYABLE: 1,
  FILTERABLE: 2,
  EDITABLE: 4
};

exports.Layer = Layer;

},{"components/Table.vue":143,"g3w-constants":159,"g3w-i18n":162,"g3w-object":163,"map/layers/feature":186,"services/data":206,"services/gui":207,"store/application":212,"utils/XHR":215,"utils/createRelationsUrl":228,"utils/downloadFile":235,"utils/get_legend_params":253,"utils/parseAttributes":264,"utils/parsers":265,"utils/promisify":267,"utils/prompt":268}],191:[function(require,module,exports){
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LayersStore = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _g3wObject = require('g3w-object');

var _g3wObject2 = _interopRequireDefault(_g3wObject);

var _getUniqueDomId = require('utils/getUniqueDomId');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @file ORIGINAL SOURCE: src/app/core/layers/layersstore.js@v3.10.2
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @since 3.11.0
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

var LayersStore = exports.LayersStore = function (_G3WObject) {
  _inherits(LayersStore, _G3WObject);

  function LayersStore() {
    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, LayersStore);

    var _this = _possibleConstructorReturn(this, (LayersStore.__proto__ || Object.getPrototypeOf(LayersStore)).call(this));

    _this.config = {
      id: config.id || Date.now(),
      projection: config.projection,
      extent: config.extent,
      initextent: config.initextent,
      wmsUrl: config.wmsUrl,
      //set catalogable property
      catalog: true === config.catalog || false === config.catalog ? config.catalog : true
    };
    _this.state = {
      //useful to build layerstree
      layerstree: [],
      relations: null // useful to build a tree of relations
    };
    _this._isQueryable = true === config.queryable || false === config.queryable ? config.queryable : true;
    _this._layers = _this.config.layers || {};

    _this.setters = {
      setLayerSelected: function setLayerSelected(id, selected) {
        this.getLayers().forEach(function (l) {
          return l.state.selected = id === l.getId() ? selected : false;
        });
      },
      addLayers: function addLayers() {
        var _this2 = this;

        var layers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

        layers.forEach(function (l) {
          return _this2.addLayer(l);
        });
      },
      addLayer: function addLayer(layer) {
        this._addLayer(layer);
      },
      removeLayer: function removeLayer(id) {
        this._removeLayer(id);
      }
    };
    return _this;
  }

  _createClass(LayersStore, [{
    key: 'isQueryable',
    value: function isQueryable() {
      return this._isQueryable;
    }
  }, {
    key: 'setQueryable',


    /**
     *
     * @param { Boolean } bool
     */
    value: function setQueryable(bool) {
      this._isQueryable = !!bool;
    }
  }, {
    key: 'showOnCatalog',
    value: function showOnCatalog() {
      return this.config.catalog;
    }
  }, {
    key: 'setOptions',
    value: function setOptions() {
      var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      this.config = config;
    }
  }, {
    key: 'getId',
    value: function getId() {
      return this.config.id;
    }
  }, {
    key: '_addLayer',
    value: function _addLayer(layer) {
      this._layers[layer.getId()] = layer;
    }
  }, {
    key: '_removeLayer',
    value: function _removeLayer(layer) {
      delete this._layers[layer.getId()];
    }
  }, {
    key: 'removeLayers',
    value: function removeLayers() {
      var _this3 = this;

      Object.entries(this._layers).forEach(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            _ = _ref2[0],
            layer = _ref2[1];

        return _this3.removeLayer(layer);
      });
    }
  }, {
    key: 'getLayersDict',
    value: function getLayersDict() {
      var filter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};


      // skip when no filter is provided (eg. `filter = null`)
      if (!filter || [filter.PRINTABLE, filter.QUERYABLE, filter.FILTERABLE, filter.EDITABLE, filter.VISIBLE, filter.SELECTED, filter.CACHED, filter.SELECTED_OR_ALL, filter.SERVERTYPE, filter.BASELAYER, filter.GEOLAYER, filter.VECTORLAYER, filter.HIDDEN, filter.DISABLED, filter.IDS].every(function (f) {
        return undefined === f;
      })) {
        return this._layers;
      }

      var layers = Object.values(this._layers);

      if (filter.IDS) {
        var ids = [].concat(filter.IDS);
        layers = layers.filter(function (l) {
          return ids.includes(l.getId());
        });
      }

      // check if there are `selected` layers otherwise get all `layers`
      if (filter.SELECTED_OR_ALL) {
        var selected = layers.filter(function (l) {
          return l.isSelected();
        });
        layers = selected.length > 0 ? selected : layers;
      }

      // checks if a boolean filter is setted
      var has = function has(f) {
        return 'boolean' === typeof f;
      };

      if (has(filter.SELECTED) && !filter.SELECTED_OR_ALL) layers = layers.filter(function (l) {
        return filter.SELECTED === l.isSelected();
      });
      if (has(filter.QUERYABLE)) layers = layers.filter(function (l) {
        return filter.QUERYABLE === l.isQueryable();
      });
      if (has(filter.FILTERABLE)) layers = layers.filter(function (l) {
        return filter.FILTERABLE === l.isFilterable(options.filtrable || null);
      });
      if (has(filter.EDITABLE)) layers = layers.filter(function (l) {
        return filter.EDITABLE === l.isEditable();
      });
      if (has(filter.VISIBLE)) layers = layers.filter(function (l) {
        return filter.VISIBLE === l.isVisible();
      });
      if (has(filter.CACHED)) layers = layers.filter(function (l) {
        return filter.CACHED === l.isCached();
      });
      if (has(filter.BASELAYER)) layers = layers.filter(function (l) {
        return filter.BASELAYER === l.isBaseLayer();
      });
      if (has(filter.GEOLAYER)) layers = layers.filter(function (l) {
        return filter.GEOLAYER === l.state.geolayer;
      });
      if (has(filter.VECTORLAYER)) layers = layers.filter(function (l) {
        return filter.VECTORLAYER === l.isType('vector');
      });
      if (has(filter.HIDDEN)) layers = layers.filter(function (l) {
        return filter.HIDDEN === l.isHidden();
      });
      if (has(filter.DISABLED)) layers = layers.filter(function (l) {
        return filter.DISABLED === l.isDisabled();
      });
      if ('string' === typeof filter.SERVERTYPE && filter.SERVERTYPE.length) layers = layers.filter(function (l) {
        return filter.SERVERTYPE === l.getServerType();
      });
      if (filter.PRINTABLE) layers = layers.filter(function (l) {
        return l.state.geolayer && l.isPrintable({ scale: filter.PRINTABLE.scale });
      });

      /**@since v3.10.3 order TOC */
      if (options.TOC_ORDER && this.state.layerstree) {
        return this._getAllSiblingsChildrenLayersId(this.state.layerstree[0]).filter(function (id) {
          return layers.find(function (l) {
            return id === l.getId();
          });
        }).map(function (id) {
          return layers.find(function (l) {
            return id === l.getId();
          });
        });
      }

      return layers;
    }
  }, {
    key: 'getLayers',


    // return layers array
    value: function getLayers() {
      var filter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return Object.values(this.getLayersDict(filter, options));
    }
  }, {
    key: 'getBaseLayers',
    value: function getBaseLayers() {
      return this.getLayersDict({ BASELAYER: true });
    }
  }, {
    key: 'getLayerById',
    value: function getLayerById(id) {
      return this.getLayersDict()[id];
    }
  }, {
    key: 'getLayerByName',
    value: function getLayerByName(name) {
      return this._layers.find(function (l) {
        return name === l.getName();
      });
    }
  }, {
    key: 'getLayerAttributes',
    value: function getLayerAttributes(id) {
      return this.getLayerById(id).getAttributes();
    }
  }, {
    key: 'getLayerAttributeLabel',
    value: function getLayerAttributeLabel(id, name) {
      return this.getLayerById(id).getAttributeLabel(name);
    }
  }, {
    key: 'getGeoLayers',
    value: function getGeoLayers() {
      return this.getLayers({ GEOLAYER: true });
    }
  }, {
    key: '_getAllSiblingsChildrenLayersId',
    value: function _getAllSiblingsChildrenLayersId(layerstree) {
      var nodeIds = [];
      var traverse = function traverse(layerstree) {
        layerstree.nodes.forEach(function (n) {
          if (n.id) {
            nodeIds.push(n.id);
          } else {
            traverse(n);
          }
        });
      };
      traverse(layerstree);
      return nodeIds;
    }
  }, {
    key: '_getAllParentLayersId',
    value: function _getAllParentLayersId(layerstree, node) {
      var nodeIds = [];
      var traverse = function traverse(layerstree) {
        layerstree.nodes.forEach(function (n) {
          if (n.id) {
            nodeIds.push(n.id);
          }
        });
      };

      traverse({ nodes: layerstree.nodes.filter(function (n) {
          return node !== n;
        }) });

      return nodeIds;
    }
  }, {
    key: 'selectLayer',
    value: function selectLayer(id, selected) {
      this.setLayerSelected(id, selected);
    }
  }, {
    key: 'getProjection',
    value: function getProjection() {
      return this.config.projection;
    }
  }, {
    key: 'getExtent',
    value: function getExtent() {
      return this.config.extent;
    }
  }, {
    key: 'getInitExtent',
    value: function getInitExtent() {
      return this.config.initextent;
    }
  }, {
    key: 'getWmsUrl',
    value: function getWmsUrl() {
      return this.config.wmsUrl;
    }
  }, {
    key: 'removeLayersTree',
    value: function removeLayersTree() {
      this.state.layerstree.splice(0, this.state.layerstree.length);
    }
  }, {
    key: 'getLayersTree',
    value: function getLayersTree() {
      return this.state.layerstree;
    }
  }, {
    key: 'setLayersTree',


    /**
     * Set layersstree of layers inside the layersstore
     *
     * @param {unknown[]} layerstree nodes
     * @param {string}    name
     * @param {boolean}   [expanded = true]
     */
    value: function setLayersTree() {
      var layerstree = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var name = arguments[1];
      var expanded = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      var _getInitExtent = this.getInitExtent(),
          _getInitExtent2 = _slicedToArray(_getInitExtent, 4),
          minx = _getInitExtent2[0],
          miny = _getInitExtent2[1],
          maxx = _getInitExtent2[2],
          maxy = _getInitExtent2[3];

      // Root group project that contains all layerstree of qgis project


      var rootGroup = {
        title: name || this.config.id,
        root: true,
        parentGroup: null,
        expanded: expanded,
        disabled: false,
        checked: true,
        /**
         * @since 3.8.0
         */
        bbox: { minx: minx, miny: miny, maxx: maxx, maxy: maxy },
        nodes: layerstree,
        legendurls: [] //@since 3.11.0 Set reactive change legend urls on check TOC visible layers
      };

      if (layerstree.length > 0) {
        this._traverseLayersTree(layerstree, rootGroup);
        this.state.layerstree.splice(0, 0, rootGroup); // at the end
      }
    }
  }, {
    key: 'createLayersTree',


    /**
     * Used by external plugins to build layerstree
     *
     * @param {string}  groupName is a ProjectName
     * @param options
     * @param {Object} [options.layerstree = null ]
     * @param {boolean} [options.expanded   = false]
     * @param {boolean} [options.full       = false]
     */
    value: function createLayersTree(groupName) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        layerstree: null,
        expanded: false,
        full: false
      };


      var layerstree = [];

      // return layerstree from server project config (when setted)
      if (options.layerstree && true === options.full) {
        return this.state.layerstree;
      }

      // compare all layer ids from server config with all layer nodes on layerstree server property
      if (options.layerstree && true !== options.full) {
        var tocLayersId = this.getLayers({ BASELAYER: false }).map(function (l) {
          return l.getId();
        });
        this._traverseLightLayersTree(options.layerstree, layerstree, tocLayersId);
      }

      // retrieve all project layers that have geometry
      if (!options.layerstree) {
        layerstree = this.getGeoLayers().map(function (l) {
          return {
            id: l.getId(),
            name: l.getName(),
            title: l.getTitle(),
            visible: l.isVisible() || false
          };
        });
      }

      // setLayerstree
      this.setLayersTree(layerstree, groupName, options.expanded);
    }
  }, {
    key: '_traverseLightLayersTree',


    /**
     * @since 3.8.0
     */
    value: function _traverseLightLayersTree(nodes, layerstree, tocLayersId) {
      var _this4 = this;

      nodes.forEach(function (n) {
        var lightlayer = null;

        // case TOC has layer ID
        if (null !== n.id && undefined !== n.id && tocLayersId.find(function (id) {
          return n.id === id;
        })) {
          lightlayer = _extends({}, lightlayer, n);
        }

        // case group
        if (null !== n.nodes && undefined !== n.nodes) {
          lightlayer = _extends({}, lightlayer, {
            name: n.name, /** @since 3.10.0 **/
            title: n.name,
            groupId: (0, _getUniqueDomId.getUniqueDomId)(),
            root: false,
            nodes: [],
            checked: n.checked,
            mutually_exclusive: n["mutually-exclusive"],
            'mutually-exclusive': n["mutually-exclusive"] /** @since 3.10.0 */
          });
          _this4._traverseLightLayersTree(n.nodes, lightlayer.nodes, tocLayersId); // recursion step
        }

        // check if lightlayer is not null
        if (null !== lightlayer) {
          lightlayer.expanded = n.expanded; // expand legend item (TOC)
          layerstree.push(lightlayer);
        }
      });
    }
  }, {
    key: '_traverseLayersTree',


    /**
     * @since 3.8.0
     */
    value: function _traverseLayersTree(nodes, parentGroup) {
      var _this5 = this;

      nodes.forEach(function (node, index) {
        // substitute node layer with layer state
        if (undefined !== node.id) {
          nodes[index] = _this5.getLayerById(node.id).getState();
        }
        // case of layer substitute node with layer state
        if (undefined !== node.id) {
          nodes[index] = _this5.getLayerById(node.id).getState();
          // pass bbox and epsg of layer
          if (undefined !== nodes[index].bbox) {
            _this5._setLayersTreeGroupBBox(parentGroup, { bbox: nodes[index].bbox, epsg: nodes[index].epsg });
          }
        }
        if (Array.isArray(node.nodes)) {
          node.nodes.forEach(function (n) {
            return n.parentGroup = parentGroup;
          });
          _this5._traverseLayersTree(node.nodes, node);
        }
        //SET PARENT GROUP
        nodes[index].parentGroup = parentGroup;
      });
    }
  }, {
    key: '_setLayersTreeGroupBBox',


    /**
     * @since 3.8.0
     */
    value: function _setLayersTreeGroupBBox(group) {
      var _ref3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          bbox = _ref3.bbox,
          epsg = _ref3.epsg;

      var project_epsg = this.getProjection().getCode();

      // translate bbox epsg to project epsg code (when they differ)
      if (epsg !== project_epsg) {
        var _ol$proj$transformExt = ol.proj.transformExtent([bbox.minx, bbox.miny, bbox.maxx, bbox.maxy], epsg, project_epsg),
            _ol$proj$transformExt2 = _slicedToArray(_ol$proj$transformExt, 4),
            minx = _ol$proj$transformExt2[0],
            miny = _ol$proj$transformExt2[1],
            maxx = _ol$proj$transformExt2[2],
            maxy = _ol$proj$transformExt2[3];

        bbox = { minx: minx, miny: miny, maxx: maxx, maxy: maxy };
      }

      // get current bbox or compute bbox from an ol extent
      if (undefined === group.bbox) {
        group.bbox = bbox;
      } else {
        group.bbox = ol.extent.extend([group.bbox.minx, group.bbox.miny, group.bbox.maxx, group.bbox.maxy], [bbox.minx, bbox.miny, bbox.maxx, bbox.maxy]).reduce(function (bbox, extentCoordinate, index) {
          switch (index) {
            case 0:
              bbox.minx = extentCoordinate;break;
            case 1:
              bbox.miny = extentCoordinate;break;
            case 2:
              bbox.maxx = extentCoordinate;break;
            case 3:
              bbox.maxy = extentCoordinate;break;
          }
          return bbox;
        }, { minxx: null, miny: null, maxx: null, maxy: null });
      }

      // Recursion
      if (group.parentGroup && false === group.parentGroup.root) {
        this._setLayersTreeGroupBBox(group.parentGroup, { bbox: group.bbox, epsg: project_epsg });
      }
    }
  }]);

  return LayersStore;
}(_g3wObject2.default);

},{"g3w-object":163,"utils/getUniqueDomId":252}],192:[function(require,module,exports){
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TableLayer = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _g3wConstants = require('g3w-constants');

var _waitFor = require('utils/waitFor');

var _promisify = require('utils/promisify');

var _XHR = require('utils/XHR');

var _getCatalogLayerById = require('utils/getCatalogLayerById');

var _layer = require('map/layers/layer');

var _featuresstore = require('map/layers/featuresstore');

var _feature = require('map/layers/feature');

var _lodash = require('lodash.clonedeep');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @file ORIGINAL SOURCE: src/app/core/layers/tablelayer.js@v3.10.2
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @since 3.11.0
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

/** @deprecated */


/**
 * Base Layer that support editing
 */
var TableLayer = exports.TableLayer = function (_Layer) {
  _inherits(TableLayer, _Layer);

  function TableLayer() {
    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, TableLayer);

    /**
     * @TODO Move it on  https://github.com/g3w-suite/g3w-client-plugin-editing
     * Hook setters methods
     */
    var _this = _possibleConstructorReturn(this, (TableLayer.__proto__ || Object.getPrototypeOf(TableLayer)).call(this, config, opts));

    _this.setters = {
      /**
       * Clear all features of the layer
       */
      clearFeatures: function clearFeatures() {
        this._featuresstore.clearFeatures();
      },
      addFeature: function addFeature(feature) {
        this._featuresstore.addFeature(feature);
      },

      /**
       * @TODO it used ????
       * @param feature
       */
      updateFeature: function updateFeature(feature) {
        this._featuresstore.updateFeature(feature);
      },
      setFeatures: function setFeatures(features) {
        this._featuresstore.setFeatures(features);
      },
      setColor: function setColor(color) {
        this._color = color;
      },


      /**
       * get data from every sources (server, wms, etc..)
       * through provider related to featuresstore
       *
       * @param {*} opts
       */
      getFeatures: function getFeatures() {
        var _this2 = this;

        var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        return (0, _promisify.$promisify)(_asyncToGenerator(function* () {
          var features = yield (0, _promisify.promisify)(_this2._featuresstore.getFeatures(opts));
          _this2.emit('getFeatures', features);
          return features;
        }));
      },
      commit: function commit(commitItems) {
        var _this3 = this;

        return (0, _promisify.$promisify)(_asyncToGenerator(function* () {
          var response = yield (0, _promisify.promisify)(_this3._featuresstore.commit(commitItems));
          // sync selection filter features
          if (response && response.result) {
            try {
              var layer = (0, _getCatalogLayerById.getCatalogLayerById)(_this3.getId());
              //if layer has geometry
              if (layer.isGeoLayer()) {
                commitItems.update.forEach(function () {
                  var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                      id = _ref3.id,
                      geometry = _ref3.geometry;

                  if (layer.getOlSelectionFeature(id)) {
                    layer.updateOlSelectionFeature({ id: id, geometry: geometry });
                  }
                });
              }
              commitItems.delete.forEach(function (id) {
                if (layer.hasSelectionFid(id)) {
                  layer.excludeSelectionFid(id);
                }
              });
            } catch (e) {
              console.warn(e);
            }
          }
          return response;
        }));
      }
    };

    /**
     * EDITING API URL: /api/vector/<type of request: data/editing/config>/<project_type>/<project_id>/<layer_id>
     *
     * @example /api/vector/config/qdjango/10/points273849503023
     */
    _this.type = _layer.Layer.LayerTypes.TABLE;

    /**
     * color
     */
    _this._color = null;

    /**
     * @FIXME add description
     */
    _this.layerId = config.id;

    // @TODO Move it on  https://github.com/g3w-suite/g3w-client-plugin-editing
    // editable layer -- > update layer config info
    if (_this.isEditable()) {
      _this.layerForEditing = _asyncToGenerator(function* () {
        // get layer editing config (from server)
        try {
          var _ref5 = yield (0, _promisify.promisify)(_this.getProvider('data').getConfig(opts)),
              vector = _ref5.vector,
              _ref5$constraints = _ref5.constraints,
              constraints = _ref5$constraints === undefined ? {} : _ref5$constraints,
              capabilities = _ref5.capabilities;

          yield (0, _waitFor.waitFor)(function () {
            return window.g3wsdk.core.hasOwnProperty('editing');
          }, _g3wConstants.TIMEOUT); // wait until "editing" plugin is loaded
          // add editing configurations

          _this.config.editing = {
            fields: vector.fields || [],
            format: vector.format,
            constraints: constraints,
            capabilities: capabilities || window.g3wsdk.constant.DEFAULT_EDITING_CAPABILITIES, // default editing capabilities
            form: { perc: null }, // set editing form `perc` to null at beginning
            style: vector.style, // get vector layer style
            geometrytype: vector.geometrytype, // whether is a vector layer,
            visible: (vector.editing || { visible: true }).visible //@since 3.11.0 let know if layer should be editable directly (true) or through relation layer (false)
          };

          if (vector.style) {
            // set vector layer color 
            _this.setColor(vector.style.color);
          }

          _this._editor = new window.g3wsdk.core.editing.Editor({ layer: _this }); // create an instance of editor
          _this.setReady(true); // set ready
          return _this;
        } catch (e) {
          console.warn(e);
          _this.setReady(false);
          return Promise.reject(_this);
        }
      })();

      _this.state = _extends({}, _this.state, {
        editing: {
          started: false,
          modified: false,
          ready: false
        }
      });
    }

    /**
     * Feature wrapper (to store feature)
     */
    _this._featuresstore = new _featuresstore.FeaturesStore({ provider: _this.providers.data });

    return _this;
  }

  /**
   *
   * @param perc
   */


  _createClass(TableLayer, [{
    key: 'setFormPercentage',
    value: function setFormPercentage(perc) {
      this.config.editing.form.perc = perc;
    }
  }, {
    key: 'getFormPercentage',
    value: function getFormPercentage() {
      return this.config.editing.form.perc;
    }
  }, {
    key: 'clone',
    value: function clone() {
      return (0, _lodash2.default)(this);
    }
  }, {
    key: 'getColor',
    value: function getColor() {
      return this._color;
    }
  }, {
    key: 'readFeatures',
    value: function readFeatures() {
      return this._featuresstore.readFeatures();
    }

    /**
     * @TODO Move it on  https://github.com/g3w-suite/g3w-client-plugin-editing
     * Get editing layer
     *
     * @param vectorurl
     *
     * @returns { Promise }
     */

  }, {
    key: 'getLayerForEditing',
    value: function () {
      var _ref6 = _asyncToGenerator(function* () {
        var _ref7 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            vectorurl = _ref7.vectorurl;

        if (vectorurl) {
          //@TODO Check if it used otherwise delete it
          this.vectorUrl = vectorurl;
        }

        try {
          return yield this.clone().layerForEditing; // cloned editable layer
        } catch (e) {
          console.warn(e);
          return e;
        }
      });

      function getLayerForEditing() {
        return _ref6.apply(this, arguments);
      }

      return getLayerForEditing;
    }()

    /**
     * @TODO Move it on  https://github.com/g3w-suite/g3w-client-plugin-editing
     * @returns return ol source of features
     */

  }, {
    key: 'getEditingSource',
    value: function getEditingSource() {
      return this._editor.getEditingSource();
    }

    /**
     * @TODO Move it on  https://github.com/g3w-suite/g3w-client-plugin-editing
     * @returns Array of features
     */

  }, {
    key: 'readEditingFeatures',
    value: function readEditingFeatures() {
      return this._editor.readEditingFeatures();
    }

    /**
     * @TODO Move it on  https://github.com/g3w-suite/g3w-client-plugin-editing
     * @return {TableLayer}
     */

  }, {
    key: 'getEditingLayer',
    value: function getEditingLayer() {
      return this;
    }

    /**
     * @TODO Move it on  https://github.com/g3w-suite/g3w-client-plugin-editing
     * @return {{}}
     */

  }, {
    key: 'getEditingConstrains',
    value: function getEditingConstrains() {
      return this.config.editing.constraints;
    }

    /**
     * @TODO Move it on  https://github.com/g3w-suite/g3w-client-plugin-editing
     * @return {*|string[]}
     */

  }, {
    key: 'getEditingCapabilities',
    value: function getEditingCapabilities() {
      return this.config.editing.capabilities;
    }

    /**
     * @TODO Move it on  https://github.com/g3w-suite/g3w-client-plugin-editing
     * @param fieldName
     * @return {boolean}
     */

  }, {
    key: 'isFieldRequired',
    value: function isFieldRequired(fieldName) {
      return (this.getEditingFields().find(function (f) {
        return fieldName === f.name;
      }) || { validate: { required: false } }).validate.required;
    }

    /**
     * @TODO Move it on  https://github.com/g3w-suite/g3w-client-plugin-editing
     * Unlock editing features
     *
     * @returns jQuery Promise
     */

  }, {
    key: 'unlock',
    value: function unlock() {
      var _this4 = this;

      return (0, _promisify.$promisify)(_asyncToGenerator(function* () {
        return yield (0, _promisify.promisify)(_this4._featuresstore.unlock());
      }));
    }

    /**
     * @TODO Move it on  https://github.com/g3w-suite/g3w-client-plugin-editing
     * @param { Boolean }  editable In case we want only editable fields
     * @returns layer fields
     */

  }, {
    key: 'getEditingFields',
    value: function getEditingFields() {
      var editable = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      return editable ? (this.config.editing.fields || []).filter(function (f) {
        return f.editable;
      }) : this.config.editing.fields || [];
    }

    /**
     * @TODO Move it on  https://github.com/g3w-suite/g3w-client-plugin-editing
     * @param field
     *
     * @returns {boolean} whether field is a Primary Key
     */

  }, {
    key: 'isPkField',
    value: function isPkField(field) {
      return (this.getEditingFields().find(function (f) {
        return field === f.name;
      }) || {}).pk;
    }

    /**
     * @TODO Move it on  https://github.com/g3w-suite/g3w-client-plugin-editing
     * @param field
     * @return {boolean}
     */

  }, {
    key: 'isEditingFieldEditable',
    value: function isEditingFieldEditable(field) {
      return (this.getEditingFields().find(function (f) {
        return f.name === field;
      }) || { editable: false }).editable;
    }

    /**
     * @TODO Move it on  https://github.com/g3w-suite/g3w-client-plugin-editing
     * @return {*}
     */

  }, {
    key: 'getEditingNotEditableFields',
    value: function getEditingNotEditableFields() {
      return this.config.editing.fields.filter(function (f) {
        return !f.editable;
      }).map(function (f) {
        return f.name;
      });
    }

    /**
     * @TODO Move it on  https://github.com/g3w-suite/g3w-client-plugin-editing
     * @param opts
     * @return {*}
     */

  }, {
    key: 'getEditingMediaFields',
    value: function getEditingMediaFields() {
      var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      return this.config.editing.fields.filter(function (f) {
        return 'media' === f.input.type;
      }).map(function (f) {
        return f.name;
      });
    }

    /**
     * @TODO Move it on  https://github.com/g3w-suite/g3w-client-plugin-editing
     * @return {boolean}
     */

  }, {
    key: 'isReady',
    value: function isReady() {
      return this.state.editing.ready;
    }
  }, {
    key: 'setReady',


    /**
     * @TODO Move it on  https://github.com/g3w-suite/g3w-client-plugin-editing
     * @param bool
     */
    value: function setReady() {
      var bool = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      this.state.editing.ready = bool;
    }
  }, {
    key: 'getWidgetData',
    value: function getWidgetData() {
      var _this5 = this;

      var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return (0, _promisify.$promisify)(_asyncToGenerator(function* () {
        return yield _XHR.XHR.get({
          url: _this5.getProvider('data')._layer.getUrl('widget')[opts.type],
          params: { fields: opts.fields }
        });
      }));
    }

    /**
     * @TODO Move it on  https://github.com/g3w-suite/g3w-client-plugin-editing
     * @return {*}
     */

  }, {
    key: 'getEditor',
    value: function getEditor() {
      return this._editor;
    }

    /**
     * @TODO Move it on  https://github.com/g3w-suite/g3w-client-plugin-editing
     * @return {*}
     */

  }, {
    key: 'isStarted',
    value: function isStarted() {
      return this._editor.isStarted();
    }
  }, {
    key: 'getFeaturesStore',
    value: function getFeaturesStore() {
      return this._featuresstore;
    }
  }, {
    key: 'setFeaturesStore',
    value: function setFeaturesStore(featuresstore) {
      this._featuresstore = featuresstore;
    }
  }, {
    key: 'setSource',
    value: function setSource(source) {
      this.setFeaturesStore(source);
    }
  }, {
    key: 'getSource',
    value: function getSource() {
      return this._featuresstore;
    }
  }, {
    key: 'addFeatures',
    value: function addFeatures() {
      var _this6 = this;

      var features = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      features.forEach(function (f) {
        return _this6.addFeature(f);
      });
    }

    /**
     * @TODO Move it on  https://github.com/g3w-suite/g3w-client-plugin-editing
     * @param lockIds
     */

  }, {
    key: 'addLockIds',
    value: function addLockIds(lockIds) {
      this._featuresstore.addLockIds(lockIds);
    }

    /**
     * create attributes from fields
     */

  }, {
    key: 'setFieldsWithValues',
    value: function setFieldsWithValues(feature, fields) {
      var createAttrs = function createAttrs() {
        var fields = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        return fields.reduce(function (acc, f) {
          if ('child' === f.type) {
            acc[f.name] = createAttrs(f.fields);
          } else if ('null' === f.value) {
            f.value = null;
          }
          acc[f.name] = f.value;
          return acc;
        }, {});
      };
      var attributes = createAttrs(fields);
      feature.setProperties(attributes);
      return attributes;
    }

    /**
     * @TODO Move it on  https://github.com/g3w-suite/g3w-client-plugin-editing
     * @param obj
     * @param opts
     * @return {*}
     */

  }, {
    key: 'getFieldsWithValues',
    value: function getFieldsWithValues(obj) {
      var _this7 = this;

      var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var _opts$exclude = opts.exclude,
          exclude = _opts$exclude === undefined ? [] : _opts$exclude,
          _opts$get_default_val = opts.get_default_value,
          get_default_value = _opts$get_default_val === undefined ? true : _opts$get_default_val;


      var fields = (0, _lodash2.default)(this.getEditingFields());
      var feature = void 0;

      if (obj instanceof _feature.Feature) {
        feature = obj;
      } else if (obj instanceof ol.Feature) {
        feature = new _feature.Feature({ feature: obj });
      } else if (obj) {
        feature = this.getFeatureById(obj);
      } else {
        return fields;
      }

      var attributes = feature.getProperties();

      fields.forEach(function (field) {

        field.value = attributes[field.name];
        field._value = attributes[field.name]; // store original value
        field.update = false; // at beginning set update false. Used to form

        field.visible = exclude.indexOf(field.name) === -1; // exclude contain field to set visible false

        // for editing purpose
        if (undefined === field.validate) {
          field.validate = {};
        }

        field.nullOption = undefined === field.nullOption || field.nullOption; //@since 3.11.0 used in InputSelect.vue component.
        field.forceNull = false;
        field.validate.valid = true;
        field.validate._valid = true; // useful to get previous value in certain case
        field.value_from_default_value = false; // need to be checked if the default value is set by server configuration field
        field.get_default_value = get_default_value; // specify if you need to get value from form field.input.options.default value in case of missing value of field.value
        field.validate.exclude_values = new Set(); // for validate.unique purpose to check is new value inserted or change needs to be di
        field.validate.unique = field.validate.unique || false;
        field.validate.required = field.validate.required || false;
        field.validate.mutually_valid = true;
        field.validate.empty = false; // Mean no value (field.value) set start value to false. It will be set once the input field is show
        field.validate.message = null;

        if (field.input) {
          var options = _this7.getEditingFields().find(function (f) {
            return f.name === field.name;
          }).input.options;
          field.input.options.loading = options.loading || { state: null };
          //check if value is defined otherwise set empty array (e.g., required for field.validate unique)
          field.input.options.values = options.values || [];
        }
      });

      return fields;
    }

    /**
     * @TODO Move it on  https://github.com/g3w-suite/g3w-client-plugin-editing
     * @return {Feature}
     */

  }, {
    key: 'createNewFeature',
    value: function createNewFeature() {
      var feature = new _feature.Feature({
        feature: new ol.Feature(this.getEditingFields().reduce(function (props, f) {
          props[f.name] = null;return props;
        }, {}))
      });
      feature.setNew();
      return feature;
    }
  }]);

  return TableLayer;
}(_layer.Layer);

},{"g3w-constants":159,"lodash.clonedeep":24,"map/layers/feature":186,"map/layers/featuresstore":187,"map/layers/layer":190,"utils/XHR":215,"utils/getCatalogLayerById":238,"utils/promisify":267,"utils/waitFor":278}],193:[function(require,module,exports){
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VectorLayer = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _g3wObject = require('g3w-object');

var _g3wObject2 = _interopRequireDefault(_g3wObject);

var _gui = require('services/gui');

var _gui2 = _interopRequireDefault(_gui);

var _isPointGeometryType = require('utils/isPointGeometryType');

var _isLineGeometryType = require('utils/isLineGeometryType');

var _isPolygonGeometryType = require('utils/isPolygonGeometryType');

var _geoMixin = require('map/layers/geo-mixin');

var _geoMixin2 = _interopRequireDefault(_geoMixin);

var _promisify = require('utils/promisify');

var _layer = require('map/layers/layer');

var _tablelayer = require('map/layers/tablelayer');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @file ORIGINAL SOURCE: src/app/core/layers/vectorlayer.js@v3.10.2
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @since 3.11.0
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

var VectorLayer = exports.VectorLayer = function (_GeoLayerMixin) {
  _inherits(VectorLayer, _GeoLayerMixin);

  function VectorLayer() {
    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, VectorLayer);

    var _this = _possibleConstructorReturn(this, (VectorLayer.__proto__ || Object.getPrototypeOf(VectorLayer)).call(this, config, opts));

    _this._mapLayer = null; // later tah will be added to the map
    _this.type = _layer.Layer.LayerTypes.VECTOR;

    var layerType = config.servertype + ' ' + (config.source && config.source.type);

    // need an ol layer for adding to the map
    _this.setup(config, opts);

    if ('G3WSUITE geojson' === layerType) {
      _this._g3w_geojson = true;
      _this.config.style = config.style;
      _this.setup(config);
    }

    return _this;
  }

  _createClass(VectorLayer, [{
    key: 'getEditingLayer',
    value: function getEditingLayer() {
      return this.getMapLayer().getOLLayer();
    }
  }, {
    key: 'resetEditingSource',
    value: function resetEditingSource() {
      var features = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      this.getMapLayer().resetSource(features);
    }
  }, {
    key: 'getEditingGeometryType',
    value: function getEditingGeometryType() {
      return this.config.editing.geometrytype;
    }

    /**
     * ORIGINAL SOURCE: src/app/core/layers/map/vectorlayer.js@v3.10.1
     */

  }, {
    key: 'getMapLayer',
    value: function getMapLayer() {
      var _this2 = this;

      if (this._mapLayer) {
        return this._mapLayer;
      }

      this._mapLayer = new _g3wObject2.default();

      var style = this._g3w_geojson ? this.get('style') : this.config.editing ? this.config.editing.style : this.getCustomStyle();

      var olStyle = style ? new ol.style.Style(Object.entries(style || {}).reduce(function (styles, _ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            type = _ref2[0],
            config = _ref2[1];

        if ('point' === type && config.icon) {
          styles.image = new ol.style.Icon({ src: config.icon.url, imageSize: config.icon.width });
        }
        if ('line' === type) {
          styles.stroke = new ol.style.Stroke({ color: config.color, width: config.width });
        }
        if ('polygon' === type) {
          styles.fill = new ol.style.Fill({ color: config.color });
        }
        return styles;
      }, {})) : null;

      // create ol layer to add to map
      this._mapLayer._olLayer = new ol.layer.Vector({
        id: this.getId(),
        __g3w_editable: this.isEditable(), //@since 3.11.0 is a attribute to specify if layer OL is editable or not for G3W-SUITE
        source: new ol.source.Vector({ features: this._editor && this._editor.getEditingSource().getFeaturesCollection() || [] || new ol.Collection() })
      });

      if (!olStyle && (0, _isPointGeometryType.isPointGeometryType)(this.getGeometryType())) {
        olStyle = new ol.style.Style({
          image: new ol.style.Circle({
            fill: new ol.style.Fill({ color: this.getColor() }),
            radius: 5
          })
        });
      }

      if (!olStyle && (0, _isLineGeometryType.isLineGeometryType)(this.getGeometryType())) {
        olStyle = new ol.style.Style({
          stroke: new ol.style.Stroke({ color: this.getColor(), width: 3 })
        });
      }

      if (!olStyle && (0, _isPolygonGeometryType.isPolygonGeometryType)(this.getGeometryType())) {
        olStyle = new ol.style.Style({
          stroke: new ol.style.Stroke({ color: '#000000', width: 1 }),
          fill: new ol.style.Fill({ color: this.getColor() })
        });
        this._mapLayer._olLayer.setOpacity(0.6);
      }

      this._mapLayer._olLayer.setStyle(olStyle);

      //@since 3.11.0 to has the same compatibility with table layer
      this._mapLayer._olLayer.getEditingSource = function () {
        return _get(VectorLayer.prototype.__proto__ || Object.getPrototypeOf(VectorLayer.prototype), 'getEditingSource', _this2).call(_this2);
      };

      Object.assign(this._mapLayer, {
        _olLayer: this._mapLayer._olLayer,
        mapService: _gui2.default.getService('map'),
        geometryType: this.getGeometryType(),
        geometrytype: null,
        type: null,
        crs: null,
        id: this.getId(),
        name: this._g3w_geojson && this.getName() || '',
        style: style,
        color: this.getColor(),
        projection: this._g3w_geojson ? this.getProjection().getCode() : _gui2.default.getService('map').getProjection().getCode(),
        url: this._g3w_geojson ? this.get('source').url : undefined,
        provider: this.getProvider('data'),
        getProvider: function getProvider() {
          return _this2._mapLayer.provider;
        },
        resetSource: function resetSource() {
          var feats = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
          return _this2._mapLayer.setSource(new ol.source.Vector({ features: feats }));
        },
        getFeatures: function getFeatures() {
          var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          return (0, _promisify.$promisify)(_asyncToGenerator(function* () {
            return _this2._mapLayer.addFeatures((yield (0, _promisify.promisify)(_this2._mapLayer.provider.getFeatures(opts))));
          }));
        },
        addFeatures: function addFeatures() {
          var feats = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
          return _this2._mapLayer.getSource().addFeatures(feats);
        },
        addFeature: function addFeature(feat) {
          return feat && _this2.getSource().addFeature(feat);
        },
        getOLLayer: function getOLLayer() {
          return _this2._mapLayer._olLayer;
        },
        getSource: function getSource() {
          return _this2._mapLayer._olLayer.getSource();
        },
        setSource: function setSource(source) {
          return _this2._mapLayer._olLayer.setSource(source);
        },
        setStyle: function setStyle(style) {
          return _this2._mapLayer._olLayer.setStyle(style);
        },
        getFeatureById: function getFeatureById(id) {
          return id ? _this2._mapLayer._olLayer.getSource().getFeatureById(id) : null;
        },
        isVisible: function isVisible() {
          return _this2._mapLayer._olLayer.getVisible();
        },
        setVisible: function setVisible(bool) {
          return _this2._mapLayer._olLayer.setVisible(bool);
        },
        clear: function clear() {
          return _this2._mapLayer.getSource().clear();
        },
        addToMap: function addToMap(map) {
          return map.addLayer(_this2._mapLayer._olLayer);
        }

      });

      if (this._g3w_geojson) {
        this._mapLayer.getFeatures({
          url: this.get('source').url,
          mapProjection: _gui2.default.getService('map').getProjection().getCode()
        });
      }

      return this._mapLayer;
    }
  }]);

  return VectorLayer;
}((0, _geoMixin2.default)(_tablelayer.TableLayer));

},{"g3w-object":163,"map/layers/geo-mixin":188,"map/layers/layer":190,"map/layers/tablelayer":192,"services/gui":207,"utils/isLineGeometryType":258,"utils/isPointGeometryType":260,"utils/isPolygonGeometryType":261,"utils/promisify":267}],194:[function(require,module,exports){
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getCatalogLayerById = require('utils/getCatalogLayerById');

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                            * @file
                                                                                                                                                                                                                                                                                                                                                                                                                                                                            * @since v3.7
                                                                                                                                                                                                                                                                                                                                                                                                                                                                            */

exports.default = {
  methods: {
    autocompleteRequest: function () {
      var _ref = _asyncToGenerator(function* () {
        var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            layerId = _ref2.layerId,
            field = _ref2.field,
            value = _ref2.value;

        var data = [];
        try {
          data = yield (0, _getCatalogLayerById.getCatalogLayerById)(layerId).getFilterData({
            suggest: field + '|' + value,
            unique: field
          });
        } catch (e) {
          console.warn(e);
        }
        return data.map(function (value) {
          return { id: value, text: value };
        });
      });

      function autocompleteRequest() {
        return _ref.apply(this, arguments);
      }

      return autocompleteRequest;
    }()
  }
};

},{"utils/getCatalogLayerById":238}],195:[function(require,module,exports){
Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * @file
 * @since v3.7
 */

exports.default = {
  computed: {
    tabIndex: function tabIndex() {
      return this.editable ? 0 : -1;
    },
    notvalid: function notvalid() {
      return false === this.state.validate.valid;
    },
    editable: function editable() {
      return this.state.editable;
    },
    showhelpicon: function showhelpicon() {
      return this.state.help && this.state.help.message.trim();
    },
    disabled: function disabled() {
      return !this.editable || ['loading', 'error'].includes(this.loadingState);
    },
    loadingState: function loadingState() {
      return this.state.input.options.loading ? this.state.input.options.loading.state : null;
    }
  },
  methods: {
    /**
     * @since v3.9.1
     * @param bool
     */
    setLoading: function setLoading(bool) {
      this.state.input.options.loading.state = bool ? 'loading' : 'ready';
    },
    showHideHelp: function showHideHelp() {
      this.state.help.visible = !this.state.help.visible;
    },

    // used to text input to listen to mobile changes
    mobileChange: function mobileChange(event) {
      this.state.value = event.target.value;
      this.change();
    },

    // called when input value change
    change: function change() {
      this.service.setEmpty();
      // validate input every time on change
      // because can be inserted a text where state.input.type (widget) is text but state.type is integer
      this.service.validate();
      //after check if is valid need to set update
      this.service.setUpdate();
      // emit change input
      this.$emit('changeinput', this.state);
    },
    isVisible: function isVisible() {}
  }
};

},{}],196:[function(require,module,exports){
Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * @file
 * @since v3.8
 */

exports.default = {
  created: function created() {
    /**
     * Store `click` and `doubleclick` events on a single vue element.
     *
     * @see https://stackoverflow.com/q/41303982
     */
    this.__CLICK_EVENT = {
      count: 0, // count click events
      timeoutID: null // timeoutID return by setTimeout Function
    };
  },


  methods: {

    /**
     * @param {{ '1': () => {}, '2': () => {}}} callbacks hashmap of click event handlers ('1' = click, '2' = double click)
     * @param context
     */
    handleClick: function handleClick() {
      var _this = this;

      var callbacks = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var context = arguments[1];

      if (!this.__CLICK_EVENT) {
        console.warn('click mixin not initialized on context:', context);
        return;
      }
      this.__CLICK_EVENT.count += 1; // increment click count
      if (!this.__CLICK_EVENT.timeoutID) {
        // skip and wait for timeout in order to detect double click
        this.__CLICK_EVENT.timeoutID = setTimeout(function () {
          if (undefined !== callbacks[_this.__CLICK_EVENT.count]) {
            callbacks[_this.__CLICK_EVENT.count].call(context);
          }
          _this.__resetClickMixin();
        }, 300);
      }
    },
    __resetClickMixin: function __resetClickMixin() {
      this.__CLICK_EVENT.count = 0;
      this.__CLICK_EVENT.timeoutID = null;
    },
    __clearClickMixin: function __clearClickMixin() {
      this.__resetClickMixin();
      this.__CLICK_EVENT = null;
    }
  },

  beforeDestroy: function beforeDestroy() {
    this.__clearClickMixin();
  }
};

},{}],197:[function(require,module,exports){
Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * @file
 * @since v3.7
 */

exports.default = {
  methods: {
    getFieldService: function getFieldService() {
      if (undefined === this._fieldsService) {
        this._fieldsService = require('gui/fields/fieldsservice');
      }
      return this._fieldsService;
    },
    getFieldType: function getFieldType(field) {
      return this.getFieldService().getType(field);
    },
    isSimple: function isSimple(field) {
      return this.getFieldService().isSimple(field);
    },
    isLink: function isLink(field) {
      return this.getFieldService().isLink(field);
    },
    isImage: function isImage(field) {
      return this.getFieldService().isImage(field);
    },
    isPhoto: function isPhoto(field) {
      return this.getFieldService().isPhoto(field);
    },
    isVue: function isVue(field) {
      return this.getFieldService().isVue(field);
    },
    sanitizeFieldValue: function sanitizeFieldValue(value) {
      return Array.isArray(value) && !value.length ? '' : value;
    }
  }
};

},{"gui/fields/fieldsservice":38}],198:[function(require,module,exports){
Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * @file
 * @since v3.7
 */

exports.default = {
  data: function data() {
    return {
      valid: false
    };
  },

  methods: {
    addToValidate: function addToValidate(input) {
      this.tovalidate.push(input);
    },
    changeInput: function changeInput(input) {
      this.isValid(input);
    },

    // Every input sends to form it valid value that will change the genaral state of form
    isValid: function isValid(input) {
      var _this = this;

      if (input) {
        // check mutually
        if (input.validate.mutually) {
          if (!input.validate.required) {
            if (!input.validate.empty) {
              input.validate._valid = input.validate.valid;
              input.validate.mutually_valid = input.validate.mutually.reduce(function (previous, inputname) {
                return previous && _this.tovalidate[inputname].validate.empty;
              }, true);
              input.validate.valid = input.validate.mutually_valid && input.validate.valid;
            } else {
              input.value = null;
              input.validate.mutually_valid = true;
              input.validate.valid = true;
              input.validate._valid = true;
              var countNoTEmptyInputName = [];
              for (var i = input.validate.mutually.length; i--;) {
                var name = input.validate.mutually[i];
                if (!this.tovalidate[name].validate.empty) {
                  countNoTEmptyInputName.push(name);
                }
              }
              if (countNoTEmptyInputName.length < 2) {
                countNoTEmptyInputName.forEach(function (name) {
                  _this.tovalidate[name].validate.mutually_valid = true;
                  _this.tovalidate[name].validate.valid = true;
                  setTimeout(function () {
                    _this.tovalidate[name].validate.valid = _this.tovalidate[name].validate._valid;
                    _this.state.valid = _this.state.valid && _this.tovalidate[name].validate.valid;
                  });
                });
              }
            }
          }
          //check if min_field or max_field is set
        } else if (!input.validate.empty && (input.validate.min_field || input.validate.max_field)) {
          var input_name = input.validate.min_field || input.validate.max_field;
          input.validate.valid = input.validate.min_field ? this.tovalidate[input.validate.min_field].validate.empty || 1 * input.value > 1 * this.tovalidate[input.validate.min_field].value : this.tovalidate[input.validate.max_field].validate.empty || 1 * input.value < 1 * this.tovalidate[input.validate.max_field].value;
          if (input.validate.valid) {
            this.tovalidate[input_name].validate.valid = true;
          }
        }
      }
      this.valid = Object.values(this.tovalidate).reduce(function (bool, input) {
        return bool && input.validate.valid;
      }, true);
    }
  },
  created: function created() {
    this.tovalidate = [];
  },
  destroyed: function destroyed() {
    this.tovalidate = null;
  }
};

},{}],199:[function(require,module,exports){
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _gui = require('services/gui');

var _gui2 = _interopRequireDefault(_gui);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  methods: {
    showLayer: function showLayer() {
      this.visible = !this.visible;
      this.layer.setVisible(this.visible);
    }
  },
  created: function created() {
    var data = this.data;
    var mapProjection = _gui2.default.getService('map').getProjection().getCode();
    var style = void 0;
    switch (data.type) {
      case 'Point':
      case 'MultiPoint':
        style = [new ol.style.Style({
          image: new ol.style.Circle({
            radius: 6,
            fill: new ol.style.Fill({ color: [255, 255, 255, 1.0] }),
            stroke: new ol.style.Stroke({ color: [0, 0, 0, 1.0], width: 2 })
          })
        }), new ol.style.Style({
          image: new ol.style.Circle({
            radius: 2,
            fill: new ol.style.Fill({ color: [255, 255, 255, 1.0] }),
            stroke: new ol.style.Stroke({ color: [0, 0, 0, 1.0], width: 2 })
          })
        })];
        break;
      case 'Line':
      case 'MultiLineString':
      case 'Polygon':
      case 'MultiPolygon':
        style = new ol.style.Style({
          fill: new ol.style.Fill({ color: 'rgba(255, 255, 255, 0.3)' }),
          stroke: new ol.style.Stroke({ color: [0, 0, 0, 1.0], width: 2 })
        });
        break;
    }
    this.layer = new ol.layer.Vector({
      source: new ol.source.Vector({
        features: new ol.format.GeoJSON().readFeatures(data, { featureProjection: mapProjection })
      }),
      visible: !!this.visible,
      style: style
    });
    _gui2.default.getService('map').getMap().addLayer(this.layer);
  },
  beforeDestroy: function beforeDestroy() {
    _gui2.default.getService('map').getMap().removeLayer(this.layer);
  }
}; /**
    * @file
    * @since v3.7
    */

},{"services/gui":207}],200:[function(require,module,exports){
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mixins = exports.autocompleteMixin = exports.baseInputMixin = exports.formInputsMixins = exports.select2Mixin = exports.selectMixin = exports.resizeMixin = exports.geoMixin = exports.mediaMixin = exports.fieldsMixin = undefined;

var _autocomplete = require('mixins/autocomplete');

var _autocomplete2 = _interopRequireDefault(_autocomplete);

var _fields = require('mixins/fields');

var _fields2 = _interopRequireDefault(_fields);

var _media = require('mixins/media');

var _media2 = _interopRequireDefault(_media);

var _geo = require('mixins/geo');

var _geo2 = _interopRequireDefault(_geo);

var _resize = require('mixins/resize');

var _resize2 = _interopRequireDefault(_resize);

var _select = require('mixins/select');

var _select2 = _interopRequireDefault(_select);

var _select3 = require('mixins/select2');

var _select4 = _interopRequireDefault(_select3);

var _formInputs = require('mixins/form-inputs');

var _formInputs2 = _interopRequireDefault(_formInputs);

var _baseInput = require('mixins/base-input');

var _baseInput2 = _interopRequireDefault(_baseInput);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mixins = {
  autocompleteMixin: _autocomplete2.default,
  fieldsMixin: _fields2.default,
  mediaMixin: _media2.default,
  geoMixin: _geo2.default,
  resizeMixin: _resize2.default,
  selectMixin: _select2.default,
  select2Mixin: _select4.default,
  formInputsMixins: _formInputs2.default,
  baseInputMixin: _baseInput2.default
}; /**
    * @file
    * @since v3.7
    */
exports.fieldsMixin = _fields2.default;
exports.mediaMixin = _media2.default;
exports.geoMixin = _geo2.default;
exports.resizeMixin = _resize2.default;
exports.selectMixin = _select2.default;
exports.select2Mixin = _select4.default;
exports.formInputsMixins = _formInputs2.default;
exports.baseInputMixin = _baseInput2.default;
exports.autocompleteMixin = _autocomplete2.default;
exports.mixins = mixins;
exports.default = mixins;

},{"mixins/autocomplete":194,"mixins/base-input":195,"mixins/fields":197,"mixins/form-inputs":198,"mixins/geo":199,"mixins/media":201,"mixins/resize":202,"mixins/select":203,"mixins/select2":204}],201:[function(require,module,exports){
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * @file
 * @since v3.7
 */

exports.default = {
  computed: {
    filename: function filename() {
      return this.value ? this.value.split('/').pop() : this.value;
    }
  },
  methods: {
    isMedia: function isMedia(value) {
      if (value && 'object' === (typeof value === 'undefined' ? 'undefined' : _typeof(value)) && Object === value.constructor) {
        return !!value.mime_type;
      }
      return false;
    },
    getMediaType: function getMediaType(mime_type) {
      var media = {
        type: null,
        options: {}
      };

      switch (mime_type) {
        case 'image/gif':
        case 'image/png':
        case 'image/jpeg':
        case 'image/bmp':
          media.type = 'image';
          break;
        case 'application/pdf':
          media.type = 'pdf';
          break;
        case 'video/mp4':
        case 'video/ogg':
        case 'video/x-ms-wmv':
        case 'video/x-msvideo':
        case 'video/quicktime':
          media.type = 'video';
          media.options.format = mime_type;
          break;
        case 'application/gzip':
        case 'application/zip':
          media.type = 'zip';
          break;
        case 'application/msword':
        case 'application/vnd.oasis.opendocument.text':
          media.type = 'text';
          break;
        case 'application/vnd.ms-office':
        case 'application/vnd.oasis.opendocument.spreadsheet':
          media.type = 'excel';
          break;
        case 'application/vnd.openxmlformats-officedocument.presentationml.presentation':
        case 'application/vnd.ms-powerpoint':
        case 'application/vnd.oasis.opendocument.presentation':
          media.type = 'ppt';
          break;
        default:
          media.type = 'unknow';
      }
      return media;
    }
  }
};

},{}],202:[function(require,module,exports){
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _gui = require('services/gui');

var _gui2 = _interopRequireDefault(_gui);

var _throttle = require('utils/throttle');

var _debounce = require('utils/debounce');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                            * @file
                                                                                                                                                                                                                                                                                                                                                                                                                                                                            * @since v3.7
                                                                                                                                                                                                                                                                                                                                                                                                                                                                            */

var DELAY_TYPE = {
  throttle: _throttle.throttle,
  debounce: _debounce.debounce
};

exports.default = {
  created: function created() {
    var delayWrapper = this.delayType && DELAY_TYPE[this.delayType] || DELAY_TYPE.throttle;
    this.delayResize = this.resize ? delayWrapper(this.resize.bind(this), this.delayTime) : null;
    _gui2.default.on('resize', this.delayResize);
  },
  mounted: function () {
    var _ref = _asyncToGenerator(function* () {
      yield this.$nextTick();
      if (this.resize) {
        this.resize();
      }
    });

    function mounted() {
      return _ref.apply(this, arguments);
    }

    return mounted;
  }(),
  beforeDestroy: function beforeDestroy() {
    _gui2.default.off('resize', this.delayResize);
    this.delayResize = null;
    this.delayTime = null;
  }
};

},{"services/gui":207,"utils/debounce":232,"utils/throttle":276}],203:[function(require,module,exports){
Object.defineProperty(exports, "__esModule", {
  value: true
});

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

/**
 * @file
 * @since v3.7
 */

exports.default = {
  methods: {
    getLanguage: function getLanguage() {
      return window.initConfig.user.i18n || "en";
    },
    changeSelect: function () {
      var _ref = _asyncToGenerator(function* (value) {
        this.state.value = 'null' === value ? null : value;
        //need to be waited in case of autocomplete
        yield this.$nextTick();
        this.change();
      });

      function changeSelect(_x) {
        return _ref.apply(this, arguments);
      }

      return changeSelect;
    }(),
    getValue: function getValue(value) {
      return null === value ? 'null' : value;
    },
    resetValues: function resetValues() {
      this.state.input.options.values.splice(0);
    }
  },
  computed: {
    autocomplete: function autocomplete() {
      return 'select_autocomplete' === this.state.input.type && this.state.input.options.usecompleter;
    }
  },
  watch: {
    notvalid: function () {
      var _ref2 = _asyncToGenerator(function* (value) {
        yield this.$nextTick();
        if (this.select2) {
          this.select2.data('select2').$container[value ? "addClass" : "removeClass"]("input-error-validation");
        }
      });

      function notvalid(_x2) {
        return _ref2.apply(this, arguments);
      }

      return notvalid;
    }()
  }
};

},{}],204:[function(require,module,exports){
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _application = require('store/application');

var _application2 = _interopRequireDefault(_application);

var _resize = require('mixins/resize');

var _resize2 = _interopRequireDefault(_resize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @file
 * @since v3.7
 */

exports.default = {
  mixins: [_resize2.default],
  methods: {
    setValue: function setValue() {
      this.select2.val(this.state.value).trigger('change');
    },
    resize: function resize() {
      if (this.select2 && !_application2.default.ismobile) {
        this.select2.select2('close');
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    //destroy a select2  dom element
    if (this.select2) {
      this.select2.select2('destroy');
      // remove all events
      this.select2.off();
      this.select2 = null;
    }
  }
};

},{"mixins/resize":202,"store/application":212}],205:[function(require,module,exports){
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _g3wConstants = require('g3w-constants');

var _g3wObject = require('g3w-object');

var _g3wObject2 = _interopRequireDefault(_g3wObject);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @file
 * @since v3.6
 */
var ApplicationService = new _g3wObject2.default({ setters: {
    online: function online() {},
    offline: function offline() {}
  } });
ApplicationService.version = _g3wConstants.APP_VERSION;

exports.default = ApplicationService;

},{"g3w-constants":159,"g3w-object":163}],206:[function(require,module,exports){
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _g3wConstants = require('g3w-constants');

var _application = require('store/application');

var _application2 = _interopRequireDefault(_application);

var _gui = require('services/gui');

var _gui2 = _interopRequireDefault(_gui);

var _groupBy = require('utils/groupBy');

var _getMapLayersByFilter = require('utils/getMapLayersByFilter');

var _XHR = require('utils/XHR');

var _promisify = require('utils/promisify');

var _g3wI18n = require('g3w-i18n');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                            * @file
                                                                                                                                                                                                                                                                                                                                                                                                                                                                            * @since v3.6
                                                                                                                                                                                                                                                                                                                                                                                                                                                                            */


var handleQueryPromises = function () {
  var _ref = _asyncToGenerator(function* () {
    var promises = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

    var responses = yield Promise.allSettled(promises);
    // at least one response
    if (responses.some(function (r) {
      return 'fulfilled' === r.status;
    })) {
      return responses.filter(function (r) {
        return 'fulfilled' === r.status;
      }).map(function (r) {
        return r.value;
      });
    }
    // show all errors
    return Promise.reject(responses.filter(function (r) {
      return 'rejected' === r.status;
    }).map(function (r) {
      return r.reason;
    }));
  });

  return function handleQueryPromises() {
    return _ref.apply(this, arguments);
  };
}();

exports.default = {

  /**
   * @param { string } contextAndMethod function name (eg. "query:coordinates", "query:bbox", "query:polygon")
   * @param options
   * 
   * @returns {Promise<void>}
   */
  getData: function () {
    var _ref2 = _asyncToGenerator(function* (contextAndMethod) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var _options$inputs = options.inputs,
          inputs = _options$inputs === undefined ? {} : _options$inputs,
          _options$outputs = options.outputs,
          outputs = _options$outputs === undefined ? {} : _options$outputs;

      var promise = this[contextAndMethod](inputs);
      if (outputs) {
        _gui2.default.outputDataPlace(promise, outputs);
      }
      return yield yield promise;
    });

    function getData(_x3) {
      return _ref2.apply(this, arguments);
    }

    return getData;
  }(),


  /**
   * @param {{ coordinates: unknown, layerIds: unknown[], multilayers: boolean, query_point_tolerance: number, feature_count: number }}
   */
  'query:coordinates': function () {
    var _ref3 = _asyncToGenerator(function* () {
      var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          coordinates = _ref4.coordinates,
          _ref4$layerIds = _ref4.layerIds,
          layerIds = _ref4$layerIds === undefined ? [] : _ref4$layerIds,
          _ref4$multilayers = _ref4.multilayers,
          multilayers = _ref4$multilayers === undefined ? false : _ref4$multilayers,
          _ref4$query_point_tol = _ref4.query_point_tolerance,
          query_point_tolerance = _ref4$query_point_tol === undefined ? _g3wConstants.QUERY_POINT_TOLERANCE : _ref4$query_point_tol,
          _ref4$addExternal = _ref4.addExternal,
          addExternal = _ref4$addExternal === undefined ? true : _ref4$addExternal,
          feature_count = _ref4.feature_count;

      var external = _gui2.default.getService('catalog').state.external.vector.some(function (l) {
        return l.selected;
      });
      var layers = (0, _getMapLayersByFilter.getMapLayersByFilter)({
        QUERYABLE: true,
        SELECTED_OR_ALL: 0 === layerIds.length,
        VISIBLE: true,
        IDS: layerIds.length ? layerIds.map(function (id) {
          return id;
        }) : undefined
      });
      try {
        return {
          result: true,
          type: 'ows',
          query: {
            coordinates: coordinates,
            type: 'coordinates',
            external: {
              add: !external || layerIds.length > 0 ? 1 === layers.length && layers[0].isSelected() ? false : addExternal : // avoid querying a temporary layer (external layer) when another layer is selected
              addExternal, // an external layer is selected
              filter: {
                SELECTED: external
              }
            }
          },
          data: ((!external || layerIds.length > 0) && (yield (0, _promisify.promisify)(this.getQueryLayersPromisesByCoordinates(layers, {
            multilayers: multilayers,
            feature_count: feature_count,
            query_point_tolerance: query_point_tolerance,
            coordinates: coordinates
          }))) || []).flatMap(function (_ref5) {
            var _ref5$data = _ref5.data,
                data = _ref5$data === undefined ? [] : _ref5$data;
            return data;
          })

        };
      } catch (error) {
        console.warn(error);
        throw error;
      }
    });

    function queryCoordinates() {
      return _ref3.apply(this, arguments);
    }

    return queryCoordinates;
  }(),


  /**
   * @param bbox
   * @param feature_count
   * @param multilayers
   * @param condition
   * @param filterConfig
   * @param addExternal
   * @param layersFilterObject
   */
  'query:bbox': function () {
    var _ref6 = _asyncToGenerator(function* () {
      var _ref7 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          bbox = _ref7.bbox,
          _ref7$feature_count = _ref7.feature_count,
          feature_count = _ref7$feature_count === undefined ? _application2.default.project.state.feature_count || 5 : _ref7$feature_count,
          _ref7$filterConfig = _ref7.filterConfig,
          filterConfig = _ref7$filterConfig === undefined ? {} : _ref7$filterConfig,
          _ref7$multilayers = _ref7.multilayers,
          multilayers = _ref7$multilayers === undefined ? false : _ref7$multilayers,
          _ref7$condition = _ref7.condition,
          condition = _ref7$condition === undefined ? { filtrable: { ows: 'WFS' } } : _ref7$condition,
          _ref7$excludeSelected = _ref7.excludeSelected,
          excludeSelected = _ref7$excludeSelected === undefined ? null : _ref7$excludeSelected,
          _ref7$addExternal = _ref7.addExternal,
          addExternal = _ref7$addExternal === undefined ? true : _ref7$addExternal,
          _ref7$layersFilterObj = _ref7.layersFilterObject,
          layersFilterObject = _ref7$layersFilterObj === undefined ? { SELECTED_OR_ALL: true, FILTERABLE: true, VISIBLE: true } : _ref7$layersFilterObj;

      var external = _gui2.default.getService('catalog').state.external.vector.some(function (l) {
        return l.selected;
      });
      var selected = external || ('boolean' == typeof excludeSelected ? excludeSelected : false);

      try {
        return {
          result: true,
          type: 'ows',
          query: {
            bbox: bbox,
            type: 'bbox',
            filterConfig: filterConfig,
            external: {
              add: addExternal,
              filter: {
                SELECTED: selected
              }
            }
          },
          data: (!external && (yield this.getQueryLayersPromisesByGeometry(
          // layers
          (0, _getMapLayersByFilter.getMapLayersByFilter)(layersFilterObject, condition),
          // options
          {
            geometry: ol.geom.Polygon.fromExtent(bbox),
            feature_count: feature_count,
            filterConfig: filterConfig,
            multilayers: multilayers,
            projection: _gui2.default.getService('map').getMap().getView().getProjection()
          })) || []).flatMap(function (_ref8) {
            var _ref8$data = _ref8.data,
                data = _ref8$data === undefined ? [] : _ref8$data;
            return data;
          })
        };
      } catch (error) {
        console.warn(error);
        throw error;
      }
    });

    function queryBbox() {
      return _ref6.apply(this, arguments);
    }

    return queryBbox;
  }(),


  /**
   * @param {{ feature: unknown, feature_count: unknown, filterConfig: unknown, multilayers: boolean, condition: boolean, excludeLayers: unknown[] }}
   */
  'query:polygon': function () {
    var _ref9 = _asyncToGenerator(function* () {
      var _ref10 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          feature = _ref10.feature,
          _ref10$feature_count = _ref10.feature_count,
          feature_count = _ref10$feature_count === undefined ? _application2.default.project.state.feature_count || 5 : _ref10$feature_count,
          _ref10$filterConfig = _ref10.filterConfig,
          filterConfig = _ref10$filterConfig === undefined ? {} : _ref10$filterConfig,
          _ref10$multilayers = _ref10.multilayers,
          multilayers = _ref10$multilayers === undefined ? false : _ref10$multilayers,
          _ref10$condition = _ref10.condition,
          condition = _ref10$condition === undefined ? { filtrable: { ows: 'WFS' } } : _ref10$condition,
          _ref10$layerName = _ref10.layerName,
          layerName = _ref10$layerName === undefined ? '' : _ref10$layerName,
          _ref10$excludeSelecte = _ref10.excludeSelected,
          excludeSelected = _ref10$excludeSelecte === undefined ? null : _ref10$excludeSelecte,
          _ref10$external = _ref10.external,
          external = _ref10$external === undefined ? {
        add: true,
        filter: {
          SELECTED: false
        }
      } : _ref10$external,
          _ref10$type = _ref10.type,
          type = _ref10$type === undefined ? 'polygon' : _ref10$type;

      var geometry = feature.getGeometry();

      try {
        return {
          result: true,
          type: 'ows',
          error: !geometry,
          query: {
            fid: _gui2.default.getService('catalog').state.external.vector.some(function (l) {
              return l.selected;
            }) ? feature.getId() : feature.get(_g3wConstants.G3W_FID),
            geometry: geometry,
            layerName: layerName,
            type: type,
            filterConfig: filterConfig,
            external: external
          },
          usermessage: !geometry && {
            type: 'warning',
            message: layerName + ' - ' + (0, _g3wI18n.t)('sdk.mapcontrols.querybypolygon.no_geometry'),
            messagetext: true,
            autoclose: false
          },
          data: ((yield this.getQueryLayersPromisesByGeometry(
          // layers
          (0, _getMapLayersByFilter.getMapLayersByFilter)(_extends({}, "boolean" === typeof excludeSelected ? { SELECTED: !excludeSelected } : { SELECTED_OR_ALL: true }, {
            FILTERABLE: true,
            VISIBLE: true
          }), condition),
          // options
          {
            geometry: geometry,
            multilayers: multilayers,
            feature_count: feature_count,
            filterConfig: filterConfig,
            projection: _application2.default.project.getProjection()
          })) || []).flatMap(function (_ref11) {
            var _ref11$data = _ref11.data,
                data = _ref11$data === undefined ? [] : _ref11$data;
            return data;
          })
        };
      } catch (error) {
        console.warn(error);
        throw error;
      }
    });

    function queryPolygon() {
      return _ref9.apply(this, arguments);
    }

    return queryPolygon;
  }(),


  /**
   * Method to search features
   * 
   * @param options.layer
   * @param options.filter
   * @param options.raw
   * @param options.queryUrl
   * @param options.feature_count
   * @param options.formatter
   * @param options.ordering
   * @param options.autofilter //@since 3.11.0
   * 
   * @returns { Promise<{ data: [], query: { type: 'search', search: * }, type: 'api' | 'ows' }> }
   */
  'search:features': function () {
    var _ref12 = _asyncToGenerator(function* () {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        layer: layer,
        filter: filter,
        raw: false,
        queryUrl: queryUrl,
        feature_count: feature_count,
        formatter: 1,
        ordering: ordering,
        autofilter: 0,
        //@since 3.11.0 pagination
        page: page,
        page_sizes: page_sizes
      };
      return _asyncToGenerator(function* () {
        var layer = options.layer,
            params = _objectWithoutProperties(options, ['layer']);

        params.filter = [].concat(params.filter); // check if filter is an array
        params.page_size = (params.page_sizes || [])[0]; //get page size
        //@since 3.11.0 count features returned by
        var counts = [];
        var page_sizes = []; //set pages based on count feature returned by server
        return {
          data: (yield Promise.allSettled([].concat(layer).map(function (l, i) {
            return l.searchFeatures(_extends({}, params, { filter: params.filter[i] }));
          }))).filter(function (d) {
            return 'fulfilled' === d.status;
          }).map(function () {
            var _ref14 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                value = _ref14.value;

            //@since 3.11.0 In case autofilter set
            if (1 === params.autofilter) {
              (value.data || []).forEach(function (_ref15) {
                var layer = _ref15.layer,
                    filtertoken = _ref15.filtertoken;

                //in the case of filtertoken response attribute set, need to set it to layer
                if (filtertoken) {
                  layer.state.selection.active = layer.state.filter.active = true;
                  layer.setFilterToken(filtertoken);
                }
              });
            }

            if (params.page_sizes) {
              //get max number of elements per page
              var max = Math.max.apply(Math, _toConsumableArray(Array.isArray(params.page_sizes) ? params.page_sizes : [params.page_sizes]));
              //Check if count (total number of elements of search is more o less than max)
              page_sizes.push(max <= value.count ? params.page_sizes : [].concat(_toConsumableArray(params.page_sizes.filter(function (p) {
                return p < value.count;
              })), [value.count]));
              //add a count element on counts array
              counts.push(value.count);
            }
            if (params.raw) {
              return { data: value };
            }
            if (Array.isArray(value.data) && value.data.length > 0) {
              return value.data[0];
            }
          }),
          query: {
            type: 'search',
            search: params.filter, //filter search (array of filter)
            autofilter: !!params.autofilter, //@since 3.11.0 set Boolean
            //@since 3.11.0 pagination
            pagination: params.page_size && {
              pages: params.page && counts.map(function (count) {
                return Math.round(count / params.page_size);
              }), //set number of pages
              current: params.page && counts.map(function () {
                return params.page;
              }), //current page
              page_sizes: page_sizes, //Array contains a number of features that want get with pagination
              counts: counts,
              //Object contains info for do another request by another part of code
              getData: {
                params: params.filter.map(function (filter) {
                  return _extends({}, params, { filter: filter });
                }),
                method: 'searchFeatures',
                layers: layer
              }
            }
          },
          type: 'api'
        };
      })();
    });

    function searchFeatures() {
      return _ref12.apply(this, arguments);
    }

    return searchFeatures;
  }(),


  /**
   * Return feature from api
   * 
   * @param opts.layer
   * @param opts.formatter
   * @param opts.fids
   */
  'search:fids': function () {
    var _ref16 = _asyncToGenerator(function* () {
      var _ref17 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          layer = _ref17.layer,
          _ref17$formatter = _ref17.formatter,
          formatter = _ref17$formatter === undefined ? 0 : _ref17$formatter,
          _ref17$fids = _ref17.fids,
          fids = _ref17$fids === undefined ? [] : _ref17$fids;

      var features = [];
      try {
        // convert API response to Open Layer Features
        features = (layer && (yield layer.getFeatureByFids({ fids: fids, formatter: formatter })) || []).map(function (f) {
          var properties = undefined !== f.properties ? f.properties : {};
          properties[_g3wConstants.G3W_FID] = f.id;
          var olFeat = new ol.Feature(f.geometry && new ol.geom[f.geometry.type](f.geometry.coordinates));
          olFeat.setProperties(properties);
          olFeat.setId(f.id);
          return olFeat;
        });
      } catch (e) {
        console.warn(e);
      }
      return {
        data: [{
          layer: layer,
          features: features
        }],
        query: { type: 'search' }
      };
    });

    function searchFids() {
      return _ref16.apply(this, arguments);
    }

    return searchFids;
  }(),


  /**
   * Search service function to load many layers with each one with its fids
   * 
   * @param options.layers    - Array of layers that we want serach fids features
   * @param options.fids      - Array of array of fids
   * @param options.formatter - how we want visualize
   */
  'search:layersfids': function () {
    var _ref18 = _asyncToGenerator(function* () {
      var _this = this;

      var _ref19 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref19$layers = _ref19.layers,
          layers = _ref19$layers === undefined ? [] : _ref19$layers,
          _ref19$fids = _ref19.fids,
          fids = _ref19$fids === undefined ? [] : _ref19$fids,
          _ref19$formatter = _ref19.formatter,
          formatter = _ref19$formatter === undefined ? 0 : _ref19$formatter;

      var data = [];
      try {
        data = (yield Promise.all(layers.map(function (layer, i) {
          return _this['search:fids']({ layer: layer, fids: fids[i], formatter: formatter });
        }))).map(function (response) {
          return response.data;
        });
      } catch (e) {
        console.warn(e);
      }
      return {
        data: data,
        query: { type: 'search' }
      };
    });

    function searchLayersfids() {
      return _ref18.apply(this, arguments);
    }

    return searchLayersfids;
  }(),


  /**
   * POST only: accepts
   * 
   * Mandatory JSON body: expression
   * Optional JSON body: form_data and qgs_layer_id (QGIS layer id)
   * 
   * @param params.qgis_layer_id layer id owner of the form data
   * @param params.layer_id      layer owner of the data
   * @param params.form_data
   * @param params.field_name    since 3.8.0
   * @param params.expression
   * @param params.formatter
   * @param params.parent
   */
  'expression:expression': function () {
    var _ref20 = _asyncToGenerator(function* () {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      try {
        var response = yield _XHR.XHR.post({
          url: '' + _application2.default.project.getUrl('vector_data') + params.layer_id + '/',
          contentType: 'application/json',
          data: JSON.stringify(params)
        });

        return response.result ? response.vector.data.features || [] : Promise.reject(JSON.stringify(response.error));
      } catch (e) {
        console.warn(e);
        return Promise.reject(e);
      }
    });

    function expressionExpression() {
      return _ref20.apply(this, arguments);
    }

    return expressionExpression;
  }(),


  /**
   * POST only method to return QGIS Expressions evaluated in Project an optional Layer/Form context
   *
   * Mandatory JSON body: expression
   * Optional JSON body: form_data and qgs_layer_id (QGIS layer id)
   * 
   * @param params.layer_id
   * @param params.qgis_layer_id
   * @param params.form_data
   * @param params.field_name    since 3.8.0
   * @param params.expression
   * @param params.formatter
   * @param params.parent
   */
  'expression:expression_eval': function () {
    var _ref21 = _asyncToGenerator(function* () {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      try {
        var _ref22 = yield _XHR.XHR.post({
          url: '/api/expression_eval/' + _application2.default.project.getId() + '/',
          contentType: 'application/json',
          data: JSON.stringify(params)
        }),
            result = _ref22.result,
            value = _ref22.value,
            error = _ref22.error;

        return result ? value : Promise.reject(JSON.stringify(error));
      } catch (e) {
        console.warn(e);
        return Promise.reject(e);
      }
    });

    function expressionExpression_eval() {
      return _ref21.apply(this, arguments);
    }

    return expressionExpression_eval;
  }(),


  /**
   * @param data: Object conitans data to pass to proxy
   */
  'proxy:wms': function () {
    var _ref23 = _asyncToGenerator(function* () {
      var _ref24 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          url = _ref24.url,
          _ref24$method = _ref24.method,
          method = _ref24$method === undefined ? 'GET' : _ref24$method,
          _ref24$params = _ref24.params,
          params = _ref24$params === undefined ? {} : _ref24$params,
          _ref24$headers = _ref24.headers,
          headers = _ref24$headers === undefined ? {} : _ref24$headers;

      if (method === 'GET') {
        url = new URL(url);
        Object.keys(params).forEach(function (p) {
          return url.searchParams.set(p, params[p]);
        });
        url = url.toString();
      }
      try {
        return {
          response: yield _XHR.XHR.post({
            data: JSON.stringify({ url: url, params: params, headers: headers, method: method }),
            contentType: 'application/json',
            url: '' + window.initConfig.proxyurl
          }),
          data: JSON.stringify({ url: url, params: params, headers: headers, method: method })
        };
      } catch (e) {
        console.warn(e);
      }
    });

    function proxyWms() {
      return _ref23.apply(this, arguments);
    }

    return proxyWms;
  }(),


  /**
   * Generic proxy data function
   */
  'proxy:data': function proxyData() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  },


  /**
   * used by the following plugins: "archiweb"
   * 
   * @param layers 
   * @param { Object } opts
   * @param opts.coordinates
   * @param opts.feature_count
   * @param opts.query_point_tolerance
   * @param { boolean } opts.multilayers Group query by layers instead single layer request
   * @param opts.reproject
   *  
   * @returns { JQuery.Promise }
   * 
   * @since 3.11.0
   */
  getQueryLayersPromisesByCoordinates: function getQueryLayersPromisesByCoordinates(layers) {
    var _ref25 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        coordinates = _ref25.coordinates,
        _ref25$feature_count = _ref25.feature_count,
        feature_count = _ref25$feature_count === undefined ? 10 : _ref25$feature_count,
        _ref25$query_point_to = _ref25.query_point_tolerance,
        query_point_tolerance = _ref25$query_point_to === undefined ? _g3wConstants.QUERY_POINT_TOLERANCE : _ref25$query_point_to,
        _ref25$multilayers = _ref25.multilayers,
        multilayers = _ref25$multilayers === undefined ? false : _ref25$multilayers,
        _ref25$reproject = _ref25.reproject,
        reproject = _ref25$reproject === undefined ? true : _ref25$reproject;

    // skip when no features
    if (0 === layers.length) {
      return (0, _promisify.$promisify)(Promise.resolve(layers));
    }

    var map = _gui2.default.getService('map').getMap();
    var size = map.getSize();
    var mapProjection = map.getView().getProjection();
    var resolution = map.getView().getResolution();

    return (0, _promisify.$promisify)(_asyncToGenerator(function* () {
      return yield handleQueryPromises(Object.values(multilayers ? (0, _groupBy.groupBy)(layers, function (l) {
        return l.getInfoFormat() + ':' + l.getInfoUrl() + ':' + l.getMultiLayerId();
      }) : layers).map(function (layers) {
        return (0, _promisify.promisify)([].concat(layers)[0].query(multilayers ? { feature_count: feature_count, coordinates: coordinates, query_point_tolerance: query_point_tolerance, mapProjection: mapProjection, size: size, resolution: resolution, reproject: reproject, layers: layers } : { feature_count: feature_count, coordinates: coordinates, query_point_tolerance: query_point_tolerance, mapProjection: mapProjection, size: size, resolution: resolution }));
      }));
    }));
  },


  /**
   * @param layers
   * @param { Object } opts
   * @param { boolean } opts.multilayers Group query by layers instead single layer request
   * @param opts.bbox
   * @param opts.geometry
   * @param opts.projection
   * @param opts.feature_count
   * 
   * @returns { JQuery.Promise<any, any, any> }
   * 
   * @since 3.11.0
   */
  getQueryLayersPromisesByGeometry: function () {
    var _ref27 = _asyncToGenerator(function* (layers) {
      var _ref28 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          geometry = _ref28.geometry,
          projection = _ref28.projection,
          _ref28$filterConfig = _ref28.filterConfig,
          filterConfig = _ref28$filterConfig === undefined ? {} : _ref28$filterConfig,
          _ref28$multilayers = _ref28.multilayers,
          multilayers = _ref28$multilayers === undefined ? false : _ref28$multilayers,
          _ref28$feature_count = _ref28.feature_count,
          feature_count = _ref28$feature_count === undefined ? 10 : _ref28$feature_count;

      // skip when no features
      if (0 === layers.length) {
        return [];
      }

      var mapCrs = projection.getCode();

      return yield handleQueryPromises(Object.values(multilayers ? (0, _groupBy.groupBy)(layers, function (l) {
        return l.getMultiLayerId() + '_' + l.getProjection().getCode();
      }) : layers).map(function (layers) {
        var layer = [].concat(layers)[0];
        var crs = layer.getProjection().getCode();
        var filter = {
          config: filterConfig,
          type: 'geometry',
          // Convert filter geometry from map to layer CRS
          value: mapCrs === crs ? geometry : geometry.clone().transform(mapCrs, crs)
        };
        return (0, _promisify.promisify)(layer.query(multilayers ? { filter: filter, feature_count: feature_count, layers: layers } : { filter: filter, feature_count: feature_count, filterConfig: filterConfig }));
      }));
    });

    function getQueryLayersPromisesByGeometry(_x17) {
      return _ref27.apply(this, arguments);
    }

    return getQueryLayersPromisesByGeometry;
  }()
};

},{"g3w-constants":159,"g3w-i18n":162,"services/gui":207,"store/application":212,"utils/XHR":215,"utils/getMapLayersByFilter":245,"utils/groupBy":254,"utils/promisify":267}],207:[function(require,module,exports){
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

/** clear all stacks */
var _clearContents = function () {
  var _ref = _asyncToGenerator(function* () {
    yield Promise.allSettled((_application2.default.contentsdata || []).map(function () {
      var _ref2 = _asyncToGenerator(function* (d) {
        if (d.content instanceof _g3wComponent2.default || d.content instanceof _g3wPanel2.default) {
          yield (0, _promisify.promisify)(d.content.unmount());
        } else {
          $(g3wsdk.gui.GUI.getComponent('contents').parent).empty();
        }
      });

      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }()));
    _application2.default.contentsdata.splice(0, _application2.default.contentsdata.length);
  });

  return function _clearContents() {
    return _ref.apply(this, arguments);
  };
}();

/**
 * Convert error to user message showed
 * @param error
 * @returns {string}
 */


var _g3wConstants = require('g3w-constants');

var _g3wObject = require('g3w-object');

var _g3wObject2 = _interopRequireDefault(_g3wObject);

var _g3wComponent = require('g3w-component');

var _g3wComponent2 = _interopRequireDefault(_g3wComponent);

var _g3wPanel = require('g3w-panel');

var _g3wPanel2 = _interopRequireDefault(_g3wPanel);

var _application = require('store/application');

var _application2 = _interopRequireDefault(_application);

var _iframe = require('services/iframe');

var _iframe2 = _interopRequireDefault(_iframe);

var _getUniqueDomId = require('utils/getUniqueDomId');

var _toRawType = require('utils/toRawType');

var _promisify = require('utils/promisify');

var _getListableProjects = require('utils/getListableProjects');

var _getProjectUrl = require('utils/getProjectUrl');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

/** store legacy frontend components */
var COMPONENTS = {};

/* service know by the applications (standard) */
var SERVICES = {
  navbar: null,
  sidebar: null,
  viewport: null
};

function setViewSizes() {
  var state = _application2.default.viewport;

  var viewportWidth = $('#app')[0].getBoundingClientRect().width - ($(".main-sidebar").length ? $(".main-sidebar")[0].getBoundingClientRect().width + $(".main-sidebar").offset().left : 0);
  var viewportHeight = $(document).innerHeight() - $('.navbar').innerHeight();
  // assign all width and height of the view to primary view (map)
  var primaryWidth = void 0;
  var primaryHeight = void 0;
  var secondaryWidth = void 0;
  var secondaryHeight = void 0;
  // percentage of secondary view (content)
  var is_fullview = _application2.default.gui.layout[_application2.default.gui.layout.__current].rightpanel[(state.split === 'h' ? 'width' : 'height') + '_100'];
  var content_perc = _application2.default.gui.layout[_application2.default.gui.layout.__current].rightpanel['h' === state.split ? 'width' : 'height'];
  var scale = (state.secondaryPerc !== 100 && !is_fullview ? content_perc : 100) / 100;
  if ('h' === state.split) {
    secondaryWidth = state.secondaryVisible ? Math.max(viewportWidth * scale, _g3wConstants.VIEWPORT.resize.content.min) : 0;
    secondaryHeight = viewportHeight;
    primaryWidth = viewportWidth - secondaryWidth;
    primaryHeight = viewportHeight;
  } else {
    secondaryWidth = viewportWidth;
    secondaryHeight = state.secondaryVisible ? Math.max(viewportHeight * scale, _g3wConstants.VIEWPORT.resize.content.min) : 0;
    primaryWidth = state.secondaryVisible && scale === 1 ? 0 : viewportWidth;
    primaryHeight = viewportHeight - secondaryHeight;
  }
  state[state.primaryView].sizes.width = primaryWidth;
  state[state.primaryView].sizes.height = primaryHeight;
  state['map' === state.primaryView ? 'content' : 'map'].sizes.width = secondaryWidth;
  state['map' === state.primaryView ? 'content' : 'map'].sizes.height = secondaryHeight;
}

/**
 * ORIGINAL SOURCE: src/services/viewport.js@v3.10.2
 */
function getReducedSizes() {
  var contentEl = $('.content');
  var reducedWidth = 0;
  var reducedHeight = 0;
  var sideBarToggleEl = $('.sidebar-aside-toggle');
  var is_fullview = _application2.default.gui.layout[_application2.default.gui.layout.__current].rightpanel[(_application2.default.viewport.split === 'h' ? 'width' : 'height') + '_100'];
  if (contentEl && _application2.default.viewport.secondaryVisible && is_fullview) {
    if (sideBarToggleEl && sideBarToggleEl.is(':visible')) {
      var toggleWidth = sideBarToggleEl.outerWidth();
      contentEl.css('padding-left', toggleWidth + 5);
      reducedWidth = toggleWidth - 5;
    }
  } else {
    var _toggleWidth = sideBarToggleEl.outerWidth();
    contentEl.css('padding-left', _application2.default.viewport.secondaryPerc === 100 ? _toggleWidth + 5 : 15);
  }
  return {
    reducedWidth: reducedWidth,
    reducedHeight: reducedHeight
  };
}function errorToMessage(error) {
  var type = (0, _toRawType.toRawType)(error);

  if ('Error' === type) {
    return 'CLIENT - ' + error.message;
  }

  if ('Object' === type && error.responseJSON && false === error.responseJSON.result) {
    var e = error.responseJSON.error;
    return (e.code || '').toUpperCase() + ' ' + (e.data || '') + ' ' + (e.message || '');
  }

  if ('Object' === type && error.responseText) {
    return error.responseText;
  }

  if ('Array' === type) {
    return error.map(function (e) {
      return errorToMessage(e);
    }).join(' ');
  }

  return error || 'server_error';
}

// API della GUI.
// methods have been defined by application
// app should call GUI.ready() when GUI is ready
exports.default = new (function (_G3WObject) {
  _inherits(GUI, _G3WObject);

  function GUI(opts) {
    _classCallCheck(this, GUI);

    var _this = _possibleConstructorReturn(this, (GUI.__proto__ || Object.getPrototypeOf(GUI)).call(this, opts));

    _this.setters = {
      setContent: function () {
        var _ref3 = _asyncToGenerator(function* () {
          var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

          this.emit('opencontent', true);

          // close user message before set content
          if (this._closeUserMessage) {
            this.closeUserMessage();
          }

          options.content = options.content || null;
          options.title = options.title || "";
          options.push = true === options.push || false === options.push ? options.push : false;
          options.perc = isMobile.any ? 100 : options.perc;
          options.split = options.split || 'h';
          options.backonclose = true === options.backonclose || false === options.backonclose ? options.backonclose : false;
          options.showtitle = true === options.showtitle || false === options.showtitle ? options.showtitle : true;

          var opts = options;

          var content_perc = _application2.default.gui.layout[_application2.default.gui.layout.__current].rightpanel['h' === _application2.default.viewport.split ? 'width' : 'height'];
          opts.perc = opts.perc !== undefined ? opts.perc : content_perc;

          // check if push is set
          opts.push = opts.push || false;
          var event = opts.perc === 100 ? 'show-content-full' : 'show-content';

          // set all content parameters
          Object.assign(_application2.default.viewport.content, {
            title: opts.title,
            split: undefined === opts.split ? null : opts.split,
            closable: undefined === opts.closable || opts.closable,
            backonclose: undefined === opts.backonclose || opts.backonclose,
            style: undefined === opts.style ? {} : opts.style,
            headertools: undefined === opts.headertools ? [] : opts.headertools,
            showgoback: undefined === opts.showgoback || opts.showgoback,
            contentsdata: this.getComponent('contents').contentsdata
          });

          // call show view (in this case content (other is map)
          this._showView('content', opts);

          var contents = this.getComponent('contents');

          // whether to clean the stack every time, sure to have just one component.
          if (!opts.push) {
            yield _clearContents();
          }

          var content = opts.content;
          var _options = Object.assign(opts, { parent: contents.internalComponent.$el, append: true });
          contents.parent = _options.parent;

          // check the type of content:

          // String or JQuery
          if (content instanceof jQuery || 'string' === typeof content) {
            var el = 'string' === typeof content ? $(content).length ? $('<div> ' + content + ' </div>') : $(content) : content;
            $(contents.parent).append(el);
            _application2.default.contentsdata.push({ content: el, options: _options });
            console.warn('[G3W-CLIENT] jQuery components will be discontinued, please update your code as soon as possible', _application2.default.contentsdata.at(-1));
          }

          // Vue element
          else if (content.mount && 'function' === typeof content.mount) {
              // Check a duplicate element by component id (if already exist)
              var id = _application2.default.contentsdata.findIndex(function (d) {
                return d.content.getId && content.getId() === d.content.getId();
              });
              if (-1 !== id) {
                yield (0, _promisify.promisify)(_application2.default.contentsdata[id].content.unmount());
                _application2.default.contentsdata.splice(id, 1);
              }
              // Mount vue component
              yield (0, _promisify.promisify)(content.mount(contents.parent, _options.append || false));
              $(contents.parent).localize();
              _application2.default.contentsdata.push({ content: content, options: _options });
            }

            // DOM element
            else {
                contents.parent.appendChild(content);
                _application2.default.contentsdata.push({ content: content, options: _options });
              }

          Array.from(contents.internalComponent.$el.children) // hide other elements but not the last one
          .forEach(function (el, i, a) {
            return el.style.display = i === a.length - 1 ? 'block' : 'none';
          });

          contents.setOpen(true);

          this._layoutComponents(event);
        });

        function setContent() {
          return _ref3.apply(this, arguments);
        }

        return setContent;
      }()
    };

    _this.isready = false;

    //property to how a result has to be adding or close all and show new
    // false mean create new and close all open
    _this.push_content = false;

    _this._closeUserMessage = true;

    _this.dialog = bootbox;

    _this.notify = {
      warning: function warning(message) {
        var autoclose = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        _this.showUserMessage({ type: 'warning', message: message, autoclose: autoclose });
      },
      error: function error(message) {
        var autoclose = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        _this.showUserMessage({ type: 'alert', message: message, autoclose: autoclose });
      },
      info: function info(message) {
        var autoclose = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        _this.showUserMessage({ type: 'info', message: message, autoclose: autoclose });
      },
      success: function success(message) {
        _this.showUserMessage({ type: 'success', message: message, autoclose: true });
      }
    };

    /** @since 3.11.0 */
    _this.currentoutputplace = 'gui';
    return _this;
  }

  _createClass(GUI, [{
    key: 'addComponent',
    value: function addComponent(component, placeholder) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      var register = true;
      if (placeholder && Object.keys(SERVICES).indexOf(placeholder) > -1) {
        // add component to the sidebar and set position inside the sidebar
        if ('sidebar' === placeholder) {
          if (!isMobile.any || false !== component.mobile) {
            _application2.default.sidebar.components.push(component);
            new (Vue.extend(require('components/SidebarItem.vue')))({ component: component, opts: options }).$mount();
          }
          register = true;
        } else if (SERVICES[placeholder]) {
          register = SERVICES[placeholder].addComponents([component], options);
        }
      }
      if (register) {
        this.setComponent(component);
      }
      return true;
    }

    /**
     * used by the following plugins: "billboards"
     */

  }, {
    key: 'setPushContent',
    value: function setPushContent() {
      var bool = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      this.push_content = bool;
    }
  }, {
    key: 'setComponent',
    value: function setComponent(component) {
      var id = component.getId();
      if (undefined === COMPONENTS[id]) {
        COMPONENTS[id] = component;
      }
    }
  }, {
    key: 'getComponent',
    value: function getComponent(id) {
      return COMPONENTS[id];
    }
  }, {
    key: 'getComponents',
    value: function getComponents() {
      return COMPONENTS;
    }
  }, {
    key: 'ready',
    value: function ready() {
      var _this2 = this;

      var drawing = false;
      var resizeFired = false;
      function triggerResize() {
        resizeFired = true;
        drawResize();
      }
      /**
       * function called from resize of browser windows (also open dev tool)
       */
      var drawResize = function drawResize() {
        if (true === resizeFired) {
          resizeFired = false;
          drawing = true;
          _this2._layout('resize');
          requestAnimationFrame(drawResize);
        } else {
          drawing = false;
        }
      };

      // SetSidebar width (used by components/Viewport.vue single file component)
      _application2.default.viewport.SIDEBARWIDTH = this.getSize({ element: 'sidebar', what: 'width' });

      this._layout();

      // resize della window
      $(window).resize(function () {
        // set resizedFired to true and execute drawResize if it's not already running
        if (false === drawing) {
          triggerResize();
        }
      });

      // resize on main siedemar open close sidebar
      $('.main-sidebar').on('transitionend', function (event) {
        //be sure that is the main sidebar that is transitioned non his child
        if (event.target === this) {
          $(this).trigger('trans-end');
          triggerResize();
        }
      });

      this.emit('ready');
      this.isready = true;
    }
  }, {
    key: 'isReady',
    value: function isReady() {
      var _this3 = this;

      return new Promise(function (resolve) {
        return _this3.isready ? resolve() : _this3.once('ready', resolve);
      });
    }
  }, {
    key: 'getService',


    /**
     * Passing a component application ui id return service that belongs to component
     * @param componentId
     * @returns {*}
     */
    value: function getService(componentId) {
      var component = this.getComponent(componentId);
      return component && component.getService();
    }

    /* end spinner */

    /**
     * Wrapper for download
     *
     * @param { Function } downloadFnc function to call
     * @param { Object }   options     Object parameters
     *
     * @since 3.9.0
     */

  }, {
    key: 'downloadWrapper',
    value: function () {
      var _ref4 = _asyncToGenerator(function* (downloadFnc) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        this.setLoadingContent(true);

        try {
          yield downloadFnc(options);
        } catch (e) {
          this.showUserMessage({ type: 'alert', message: e || 'server_error', textMessage: !!e });
        }
        _application2.default.download = true;
        _application2.default.download = false;

        this.setLoadingContent(false);
      });

      function downloadWrapper(_x9) {
        return _ref4.apply(this, arguments);
      }

      return downloadWrapper;
    }()

    /** @since 3.10.0 remove _setUpTemplateDependencies method**/

  }, {
    key: 'isMobile',
    value: function (_isMobile) {
      function isMobile() {
        return _isMobile.apply(this, arguments);
      }

      isMobile.toString = function () {
        return _isMobile.toString();
      };

      return isMobile;
    }(function () {
      return isMobile.any;
    })
  }, {
    key: 'getFontClass',
    value: function getFontClass(type) {
      return Vue.prototype.g3wtemplate.getFontClass(type);
    }

    /* Metodos to define */

  }, {
    key: 'getResourcesUrl',
    value: function getResourcesUrl() {
      return window.initConfig.staticurl + window.initConfig.client;
    }

    /**
     * Function called from DataRouterservice for gui output
     * 
     * @param promise // is request data promise
     * @param { Object } output
     * @param { boolean | Function | Object } output.show set output condition (whether to show result or not)
     * @param { boolean } output.add
     * @param { String } output.title
     */

  }, {
    key: 'outputDataPlace',
    value: function () {
      var _ref5 = _asyncToGenerator(function* (promise) {
        var output = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};


        //set current unique request id of request
        var rid = (0, _getUniqueDomId.getUniqueDomId)();

        /** @type { String[] } cached requests (by id) */
        this.outputDataPlace.reqs = (this.outputDataPlace.reqs || []).concat(rid);
        /** In the case of a current output result is iframe, send to IFrameRouterService.outputDataPlace*/
        if ('iframe' === this.currentoutputplace) {
          return _iframe2.default.outputDataPlace(promise, output);
        }

        //set loading state
        this.setLoadingContent(true);

        //check show attribute if is a valid type
        var condition = ['function', 'boolean'].includes(_typeof(output.show));

        Object.assign(output, _extends({
          condition: condition ? output.show : true,
          add: false
        }, condition ? {} : output.show));

        // if request doesn't need to add to a current query result
        if (!output.add) {
          this.showQueryResults(output.title || '');
        }

        try {
          // Store data promise
          var data = (yield promise) || {};

          //Check id we can show data
          var show = 'function' === typeof output.condition ? yield output.condition(data) : false !== output.condition;
          var last = show && rid === this.outputDataPlace.reqs.at(-1);

          // set request output ids empty
          if (last) {
            this.outputDataPlace.reqs.splice(0);
          }

          //if set before call method and wait
          if (last && output.before) {
            yield output.before(data);
          }

          // in case of usermessage show user message
          if (last && data.usermessage) {
            this.showUserMessage({
              type: data.usermessage.type,
              message: data.usermessage.message,
              autoclose: data.usermessage.autoclose
            });
          }

          // check if data can be shown on query result content
          if (last) {
            (this.getService('queryresults') || this.showQueryResults(output.title || '')).setQueryResponse(data, { add: !!output.add });
          }

          // call after is set with data
          if (last && output.after) {
            output.after(data);
          }
        } catch (e) {
          console.warn(e);
          this.showUserMessage({
            type: 'alert',
            message: errorToMessage(e),
            textMessage: true
          });
          //@scince 3.11.0 emit error-output-data
          this.emit('error-output-data', e);
          yield this.closeContent();
        }

        //set loading to false when no pending request
        this.setLoadingContent(this.outputDataPlace.reqs.length > 0);
      });

      function outputDataPlace(_x11) {
        return _ref5.apply(this, arguments);
      }

      return outputDataPlace;
    }()
  }, {
    key: 'showForm',
    value: function showForm() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var _require = require('components/g3w-form'),
          FormComponent = _require.FormComponent;
      // new instance every time


      var formComponent = options.formComponent ? new options.formComponent(options) : new FormComponent(options);
      this.setContent({
        perc: options.perc,
        content: formComponent,
        split: undefined !== options.split ? options.split : 'h',
        crumb: options.crumb,
        push: !!options.push, //only one (if other deletes previous component)
        showgoback: !!options.showgoback,
        closable: false
      });
      // return service
      return formComponent.getService();
    }

    /**
     *
     * @param pop remove or not content or pop
     */

  }, {
    key: 'closeForm',
    value: function closeForm() {
      var _ref6 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref6$pop = _ref6.pop,
          pop = _ref6$pop === undefined ? false : _ref6$pop;

      this.emit('closeform', false);

      var backonclose = !pop && _application2.default.viewport.content.backonclose && _application2.default.viewport.content.contentsdata.length > 1;

      // remove just last component
      if (pop || backonclose) {
        this.popContent();
      }

      // remove all content stacks
      if (!pop && !backonclose) {
        this.closeContent();
        this.setModal(false);
      }
    }
  }, {
    key: 'disableElement',
    value: function disableElement(_ref7) {
      var element = _ref7.element,
          disable = _ref7.disable;

      $(element)[disable ? 'addClass' : 'removeClass']('g3w-disabled');
    }
  }, {
    key: 'disableContent',
    value: function disableContent(disable) {
      _application2.default.viewport.content.disabled = disable;
    }
  }, {
    key: 'disablePanel',
    value: function disablePanel() {
      var disable = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      this.disableElement({
        element: "#g3w-sidebarpanel-placeholder",
        disable: disable
      });
    }

    /**
     * collapse any expanded sidebar component 
     */

  }, {
    key: 'closeSideBar',
    value: function closeSideBar() {
      _application2.default.sidebar.components.forEach(function (c) {
        return c.getOpen() && c.state.closewhenshowviewportcontent && c.collapsible && c.click({ open: false });
      });
    }
  }, {
    key: 'showQueryResults',


    // show results info/search
    value: function showQueryResults(title, results) {
      var queryresults = this.getComponent('queryresults').getService();

      queryresults.clearState();

      if (results) {
        queryresults.setQueryResponse(results);
      }

      // show contextual content
      this.setContent({
        content: this.getComponent('queryresults'),
        title: "info.title",
        crumb: { title: "info.title", trigger: null },
        push: this.push_content,
        post_title: title,
        perc: isMobile.any ? 100 : undefined
      });

      return queryresults;
    }

    /**
     * used by the following plugins: "stress" 
     */

  }, {
    key: 'addNavbarItem',
    value: function addNavbarItem(item) {
      _application2.default.navbaritems.push(item);
    }
  }, {
    key: 'showPanel',
    value: function () {
      var _ref8 = _asyncToGenerator(function* (content) {
        var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        _application2.default.sidebar.title = content.title;
        _application2.default.sidebar.parent = '#g3w-sidebarpanel-placeholder';

        var current = _application2.default.sidebar.contentsdata.at(-1);

        if (current) {
          $(current.content.internalPanel.$el).hide();
        }

        var options = _extends({ parent: '#g3w-sidebarpanel-placeholder' }, opts);
        var parent = _application2.default.sidebar.parent;
        var data = _application2.default.sidebar.contentsdata;

        // check the type of content:

        // String or JQuery
        if (content instanceof jQuery || 'string' === typeof content) {
          var el = 'string' === typeof content ? $(content).length ? $('<div> ' + content + ' </div>') : $(content) : content;
          $(parent).append(el);
          data.push({ content: el, options: options });
          console.warn('[G3W-CLIENT] jQuery components will be discontinued, please update your code as soon as possible', data.at(-1));
        }

        // Vue element
        else if (content.mount && 'function' === typeof content.mount) {
            // Check a duplicate element by component id (if already exist)
            var id = data.findIndex(function (d) {
              return d.content.getId && content.getId() === d.content.getId();
            });
            if (-1 !== id) {
              yield (0, _promisify.promisify)(data[id].content.unmount());
              data.splice(id, 1);
            }
            // Mount vue component
            yield (0, _promisify.promisify)(content.mount(parent, options.append || false));
            $(parent).localize();
            data.push({ content: content, options: options });
          }

          // DOM element
          else {
              parent.appendChild(content);
              data.push({ content: content, options: options });
            }
      });

      function showPanel(_x16) {
        return _ref8.apply(this, arguments);
      }

      return showPanel;
    }()
  }, {
    key: 'closePanel',
    value: function () {
      var _ref9 = _asyncToGenerator(function* () {
        var data = _application2.default.sidebar.contentsdata;
        if (data.length <= 0) {
          return;
        }
        var panel = data.slice(-1)[0].content;
        if (panel instanceof _g3wComponent2.default || panel instanceof _g3wPanel2.default) {
          yield (0, _promisify.promisify)(panel.unmount());
        } else {
          $(_application2.default.sidebar.parent).empty();
        }
        var content = data.pop();
        content = null;
        var current = _application2.default.sidebar.contentsdata.at(-1);
        if (current) {
          $(current.content.internalPanel.$el).show();
          _application2.default.sidebar.title = current.content.title;
        }
      });

      function closePanel() {
        return _ref9.apply(this, arguments);
      }

      return closePanel;
    }()

    //showusermessage

  }, {
    key: 'showUserMessage',
    value: function showUserMessage() {
      var _ref10 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          title = _ref10.title,
          subtitle = _ref10.subtitle,
          message = _ref10.message,
          type = _ref10.type,
          position = _ref10.position,
          size = _ref10.size,
          draggable = _ref10.draggable,
          duration = _ref10.duration,
          _ref10$textMessage = _ref10.textMessage,
          textMessage = _ref10$textMessage === undefined ? false : _ref10$textMessage,
          closable = _ref10.closable,
          autoclose = _ref10.autoclose,
          _ref10$hooks = _ref10.hooks,
          hooks = _ref10$hooks === undefined ? {} : _ref10$hooks,
          _ref10$iconClass = _ref10.iconClass,
          iconClass = _ref10$iconClass === undefined ? null : _ref10$iconClass;

      this.closeUserMessage();

      setTimeout(function () {
        Object.assign(_application2.default.viewport.usermessage, {
          id: (0, _getUniqueDomId.getUniqueDomId)(),
          show: true,
          message: message,
          textMessage: textMessage,
          title: title,
          subtitle: subtitle,
          position: position,
          duration: duration,
          type: type,
          size: size,
          autoclose: autoclose,
          closable: closable,
          draggable: draggable,
          hooks: hooks,
          iconClass: iconClass
        });
      });

      return _application2.default.viewport.usermessage;
    }
  }, {
    key: 'closeUserMessage',
    value: function closeUserMessage() {
      Object.assign(_application2.default.viewport.usermessage, {
        id: null,
        show: false,
        textMessage: false,
        message: ''
      });
    }

    //modal dialog//

  }, {
    key: 'showModalDialog',
    value: function showModalDialog() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return this.dialog.dialog(options);
    }
  }, {
    key: 'showSpinner',
    value: function showSpinner() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var container = options.container || 'body';
      var id = options.id || 'loadspinner';
      var where = options.where || 'prepend'; // append | prepend
      var style = options.style || '';
      var transparent = options.transparent && 'background-color: transparent' || '';
      var center = options.center && 'margin: auto' || '';
      if (!$('#' + id).length) {
        $(container)[where].call($(container), '<div id="' + id + '" class="spinner-wrapper ' + style + '" style="' + transparent + '"><div class="spinner ' + style + '" style="' + center + '"></div></div>');
      }
    }
  }, {
    key: 'hideSpinner',
    value: function hideSpinner() {
      var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'loadspinner';

      $('#' + id).remove();
    }

    /** @since 3.11.0*/

  }, {
    key: 'toggleSidebar',
    value: function toggleSidebar() {
      if (document.body.classList.contains('sidebar-open')) {
        this.hideSidebar();
      } else if (document.body.classList.contains('sidebar-collapse') || window.innerWidth <= 767) {
        this.showSidebar();
      } else {
        this.hideSidebar();
      }
    }

    /**
     * Toggle set full screen modal
     */

  }, {
    key: 'showFullModal',
    value: function showFullModal() {
      var _ref11 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref11$element = _ref11.element,
          element = _ref11$element === undefined ? "#modal-fullscreen" : _ref11$element,
          _ref11$show = _ref11.show,
          show = _ref11$show === undefined ? true : _ref11$show;

      $(element).modal(show ? 'show' : 'hide');
    }
  }, {
    key: 'disableSideBar',
    value: function disableSideBar() {
      var bool = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      _application2.default.gui.sidebar.disabled = bool;
    }

    //  (100%) content

  }, {
    key: 'showContent',
    value: function showContent() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      this.setLoadingContent(false);
      options.perc = isMobile.any ? 100 : options.perc;
      this.setContent(options);
      return true;
    }

    // add component to stack (append)
    // Differences between pushContent and setContent are:
    //  - push every component is added, set is refreshed
    //  - pushContent has a new parameter (backonclose) when is clicked x
    //  - the contentComponent is close all stacks are closed

  }, {
    key: 'pushContent',
    value: function pushContent() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      options.perc = isMobile.any ? 100 : options.perc;
      options.push = true;
      this.setContent(options);
    }

    //return number of a component of stack

  }, {
    key: 'getContentLength',
    value: function getContentLength() {
      return _application2.default.viewport.content.contentsdata.length;
    }

    /**
     * change current content options
     * @param opts: { title, crumb, text }
     */

  }, {
    key: 'setCurrentContentOptions',
    value: function setCurrentContentOptions() {
      var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var content = _application2.default.viewport.content.contentsdata.at(-1) || null;
      if (content && opts.title) {
        content.options.title = opts.title;
      }
      if (content && opts.crumb) {
        content.options.crumb = opts.crumb;
      }
    }
  }, {
    key: 'getCurrentContent',
    value: function getCurrentContent() {
      return _application2.default.viewport.content.contentsdata.at(-1) || null;
    }

    /**
     * used by the following plugins: "archiweb"
     * 
     * ORIGINAL SOURCE: src/components/g3w-projectsmenu.js@v3.10.2
     */

  }, {
    key: 'getProjectMenuDOM',
    value: function getProjectMenuDOM() {
      var _ref12 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref12$projects = _ref12.projects,
          projects = _ref12$projects === undefined ? [] : _ref12$projects,
          host = _ref12.host,
          cbk = _ref12.cbk;

      var opts = {
        projects: projects && Array.isArray(projects) && projects,
        cbk: cbk,
        host: host
      };
      return new _g3wComponent2.default(_extends({}, opts, {
        id: 'projectsmenu',
        title: opts.title || 'menu',
        internalComponent: new (Vue.extend(require('components/ProjectsMenu.vue')))({
          host: opts.host,
          state: {
            menuitems: (opts.projects || (0, _getListableProjects.getListableProjects)()).map(function (p) {
              return {
                title: p.title,
                description: p.description,
                thumbnail: p.thumbnail,
                gid: p.gid,
                cbk: opts.cbk || function () {
                  var o = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                  return (0, _promisify.$promisify)(_asyncToGenerator(function* () {
                    var url = yield GUI.getService('map').addMapExtentUrlParameterToUrl((0, _getProjectUrl.getProjectUrl)(o.gid));
                    try {
                      history.replaceState(null, null, url);
                    } catch (e) {
                      console.warn(e);
                    }location.replace(url);
                  }));
                }
              };
            })
          }
        })
      })).getInternalComponent().$mount().$el;
    }
  }, {
    key: 'toggleUserMessage',
    value: function toggleUserMessage() {
      var bool = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      this._closeUserMessage = bool;
    }

    /**
     * used by the following plugins: "stress"
     */

  }, {
    key: 'hideClientMenu',
    value: function hideClientMenu() {
      window.initConfig.user = null;
    }

    /**
     * used by the following plugins: "stress"
     */

  }, {
    key: 'hideChangeMaps',
    value: function hideChangeMaps() {
      window.initConfig.projects = [];
    }
  }, {
    key: 'setLoadingContent',
    value: function setLoadingContent() {
      var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      _application2.default.viewport.content.loading = loading;
      return loading && new Promise(function (resolve) {
        return setTimeout(resolve, 200);
      });
    }
  }, {
    key: 'toggleFullViewContent',
    value: function toggleFullViewContent() {
      var state = _application2.default.viewport;
      var rightpanel = _application2.default.gui.layout[_application2.default.gui.layout.__current].rightpanel;

      rightpanel[(state.split === 'h' ? 'width' : 'height') + '_100'] = !rightpanel[(state.split === 'h' ? 'width' : 'height') + '_100'];
      this._layoutComponents();
    }

    // hide content

  }, {
    key: 'hideContent',
    value: function hideContent(bool) {
      var content_perc = _application2.default.gui.layout[_application2.default.gui.layout.__current].rightpanel['h' === _application2.default.viewport.split ? 'width' : 'height'];
      _application2.default.viewport.secondaryVisible = !bool;
      this._layout('hide-content');
      // return previous percentage
      return content_perc;
    }
  }, {
    key: 'closeContent',
    value: function () {
      var _ref14 = _asyncToGenerator(function* () {
        this.emit('closecontent', false);

        var state = _application2.default.viewport;
        var open = state.content.contentsdata.length > 0;

        // content is open → remove content
        if (open) {
          var contents = this.getComponent('contents');
          contents.setOpen(false);
          _clearContents();
        }

        // close secondary view
        if (open && 'map' === state.primaryView) {
          yield _clearContents();
          state.secondaryPerc = 0;
        }

        if (open) {
          state.secondaryVisible = false;
          this._layout('close-content');
          yield Vue.nextTick();
        }

        return this.getComponent('map');
      });

      function closeContent() {
        return _ref14.apply(this, arguments);
      }

      return closeContent;
    }()

    // remove last content from stack

  }, {
    key: 'popContent',
    value: function () {
      var _ref15 = _asyncToGenerator(function* () {
        // skip when no content data
        if (0 === _application2.default.viewport.content.contentsdata.length) {
          return Promise.reject();
        }

        var data = this.getComponent('contents').contentsdata.at(-2);
        var opts = data.options;

        Object.assign(_application2.default.viewport.content, {
          title: opts.title,
          split: undefined !== opts.split ? opts.split : null,
          closable: undefined !== opts.closable ? opts.closable : true,
          backonclose: undefined !== opts.backonclose ? opts.backonclose : true,
          contentsdata: this.getComponent('contents').contentsdata,
          style: undefined !== opts.style ? opts.style : {},
          headertools: undefined !== opts.headertools ? opts.headertools : [],
          showgoback: undefined !== opts.showgoback ? opts.showgoback : true
        });

        this._showView('content', data.options);

        if (_application2.default.contentsdata.length <= 0) {
          return;
        }

        // component exists on stack → remove the last from stack
        var content = _application2.default.contentsdata.slice(-1)[0].content;

        if (content instanceof _g3wComponent2.default || content instanceof _g3wPanel2.default) {
          yield (0, _promisify.promisify)(content.unmount());
        } else {
          $(this.getComponent('contents').parent).empty();
        }

        _application2.default.contentsdata.pop();

        Array.from(this.getComponent('contents').internalComponent.$el.children) // hide other elements but not the last one
        .forEach(function (el, i, a) {
          return el.style.display = i === a.length - 1 ? 'block' : 'none';
        });

        _application2.default.viewport.secondaryPerc = data.options.perc;

        this._layout('pop-content');

        return this.getComponent('contents').contentsdata.at(-1);
      });

      function popContent() {
        return _ref15.apply(this, arguments);
      }

      return popContent;
    }()
  }, {
    key: 'isSidebarVisible',
    value: function isSidebarVisible() {
      return !document.body.classList.contains('sidebar-collapse');
    }
  }, {
    key: 'setModal',
    value: function setModal() {
      var bool = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var message = arguments[1];

      var mapService = this.getService('map');
      if (bool) {
        mapService.startDrawGreyCover(message);
      } else {
        mapService.stopDrawGreyCover();
      }
    }
  }, {
    key: 'showSidebar',
    value: function showSidebar() {
      document.body.classList.add('sidebar-open');
      document.body.classList.remove('sidebar-collapse');
      _application2.default.gui.sidebar.open = true;
    }
  }, {
    key: 'hideSidebar',
    value: function hideSidebar() {
      document.body.classList.remove('sidebar-open');
      document.body.classList.add('sidebar-collapse');
      _application2.default.gui.sidebar.open = false;
    }
  }, {
    key: 'getSize',
    value: function getSize(_ref16) {
      var element = _ref16.element,
          what = _ref16.what;

      if (element && what) {
        return _application2.default.sizes[element][what];
      }
    }

    // manage all layout logic
    // viewName: map or content
    //options.  percentage , splitting title etc ..

  }, {
    key: '_showView',
    value: function () {
      var _ref17 = _asyncToGenerator(function* (viewName) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        var state = _application2.default.viewport;

        var _options$perc = options.perc,
            perc = _options$perc === undefined ? viewName == state.primaryView ? 100 : 50 : _options$perc,
            _options$split = options.split,
            split = _options$split === undefined ? 'h' : _options$split;


        state[viewName].aside = viewName == state.primaryView ? undefined === options.aside ? false : options.aside : true;

        //calculate the content
        var secondaryPerc = viewName == state.primaryView ? 100 - perc : perc;

        //show Secondary View content only if more than 0
        if (secondaryPerc > 0) {
          state.secondaryVisible = true;
          state.split = undefined !== split ? split : state.split;
          state.secondaryPerc = undefined !== perc ? perc : state.perc;
          this._layout();
          return;
        }

        // close secondary view
        if ('map' === state.primaryView) {
          yield _clearContents();
          state.secondaryPerc = 0;
        }

        state.secondaryVisible = false;

        this._layout();

        yield Vue.nextTick();
      });

      function _showView(_x32) {
        return _ref17.apply(this, arguments);
      }

      return _showView;
    }()

    /**
     * load components of viewport after right size setting
     * 
     * ORIGINAL SOURCE: src/services/viewport.js@v3.10.2
     */

  }, {
    key: '_layoutComponents',
    value: function _layoutComponents() {
      var _this4 = this;

      var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      requestAnimationFrame(function () {
        var reducesdSizes = getReducedSizes();
        var reducedWidth = reducesdSizes.reducedWidth || 0;
        var reducedHeight = reducesdSizes.reducedHeight || 0;

        // for each component
        setViewSizes();
        _this4.getService('map').layout({
          width: _application2.default.viewport.map.sizes.width - reducedWidth,
          height: _application2.default.viewport.map.sizes.height - reducedHeight
        });

        var parentWidth = _application2.default.viewport.content.sizes.width - reducedWidth;

        // Set layout of the content each time
        Vue.nextTick(function () {
          // run only after that vue state is updated
          var el = _this4.getComponent('contents').internalComponent.$el;
          var height = el.parentElement.clientHeight // parent element is "g3w-view-content"
          - ((el.parentElement.querySelector('.close-panel-block') || {}).offsetHeight || 0) - ((el.parentElement.querySelector('.content_breadcrumb') || {}).offsetHeight || 0) - 10; // margin 10 from bottom
          el.style.height = height + 'px';
          if (el.firstChild) {
            el.firstChild.style.height = height + 'px';
          }
          _application2.default.contentsdata.forEach(function (d) {
            // re-layout each component stored into the stack
            if ('function' == typeof d.content.layout) {
              d.content.layout(parentWidth + 0.5, height);
            }
          });
        });

        if (event) {
          setTimeout(function () {
            _this4.emit(event);
          });
        }
      });
    }

    /**
     * main layout function
     */

  }, {
    key: '_layout',
    value: function _layout() {
      var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      var reducesdSizes = getReducedSizes();
      setViewSizes(reducesdSizes.reducedWidth, reducesdSizes.reducedHeight);
      this._layoutComponents(event);
    }
  }]);

  return GUI;
}(_g3wObject2.default))();

},{"components/ProjectsMenu.vue":124,"components/SidebarItem.vue":141,"components/g3w-form":146,"g3w-component":158,"g3w-constants":159,"g3w-object":163,"g3w-panel":164,"services/iframe":208,"store/application":212,"utils/getListableProjects":244,"utils/getProjectUrl":249,"utils/getUniqueDomId":252,"utils/promisify":267,"utils/toRawType":277}],208:[function(require,module,exports){
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

/**
 * @param epsg: Number Code of epsg Ex.4326
 * 
 * @returns String Normalize epsg: From number ex: 4326 to 'EPSG:4326'
 * 
 * @since 3.9.1
 */
var _getEpsgFromParam = function () {
  var _ref = _asyncToGenerator(function* (epsg) {
    epsg = (0, _normalizeEpsg.normalizeEpsg)(epsg);
    yield _projections2.default.registerProjection(epsg);
    return epsg;
  });

  return function _getEpsgFromParam(_x) {
    return _ref.apply(this, arguments);
  };
}();

/**
 * @example template.html
 * 
 * ```html
 * <!DOCTYPE html>
 * <html lang="en" style="width: 100%; height: 100%">
 * <head>
 *   <meta charset="UTF-8">
 *   <title>Test Iframe</title>
 * </head>
 * <body style="width:100%; height: 100%; margin: 0;">
 * <iframe style="width: 100%; height: 100%; border: 0;" src="http://192.168.1.4:3000/?project=test-iframe/qdjango/62"></iframe>
 * </body>
 * <script>
 *   // send message to iframe when app is ready
 *   const iframe = document.querySelector('iframe');
 *   window.addEventListener('message', evt => {
 *     const { action, response } = evt.data;
 *     if (action === "app:ready") {
 *       setTimeout(() => iframe.contentWindow.postMessage({
 *         id: null,                     // id of action,
 *         action: "<context>:<action>", // eg: "app:zoomtofeature"
 *         data: {}                      // data contain all mandatory attribute information
 *       }, '*'), 2000)
 *     }
 *   }, false);
 * </script>
 * </html>
 * ```
 */


var _g3wObject = require('g3w-object');

var _g3wObject2 = _interopRequireDefault(_g3wObject);

var _gui = require('services/gui');

var _gui2 = _interopRequireDefault(_gui);

var _data = require('services/data');

var _data2 = _interopRequireDefault(_data);

var _application = require('store/application');

var _application2 = _interopRequireDefault(_application);

var _plugins = require('store/plugins');

var _plugins2 = _interopRequireDefault(_plugins);

var _projections = require('store/projections');

var _projections2 = _interopRequireDefault(_projections);

var _normalizeEpsg = require('utils/normalizeEpsg');

var _createSingleFieldParameter = require('utils/createSingleFieldParameter');

var _getUniqueDomId = require('utils/getUniqueDomId');

var _waitFor = require('utils/waitFor');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                            * @file
                                                                                                                                                                                                                                                                                                                                                                                                                                                                            * @since v3.6
                                                                                                                                                                                                                                                                                                                                                                                                                                                                            */

var IframePluginService = function () {
  function IframePluginService() {
    _classCallCheck(this, IframePluginService);

    this.pendingactions = {};
    this.getMessage = this.getMessage.bind(this);
    this.eventResponseServiceHandler = this.eventResponseServiceHandler.bind(this);
  }

  /**
   * @param { Object } opts
   * @param opts.project current project sends by application service
   */


  _createClass(IframePluginService, [{
    key: 'init',
    value: function () {
      var _ref2 = _asyncToGenerator(function* () {
        var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            project = _ref3.project;

        yield _gui2.default.isReady();

        this.services = {
          app: new AppService(),
          editing: new EditingService()
        };

        // get layer attributes from project layers state
        var layers = project.state.layers.map(function (l) {
          return { id: l.id, name: l.name };
        });

        // initialize all services
        var serviceNames = Object.keys(this.services);

        for (var i = 0; i < serviceNames.length; i++) {
          var service = this.services[serviceNames[i]];
          // set common layer attribute service just one time
          if (undefined === service.getLayers()) {
            service.setLayers(layers);
          }
          yield service.init();
          service.on('response', this.eventResponseServiceHandler);
        }

        // Send post-message is ready
        this.postMessage({
          id: null,
          action: 'app:ready',
          response: { result: true, data: { layers: layers } }
        });

        window.addEventListener('message', this.getMessage, false);
      });

      function init() {
        return _ref2.apply(this, arguments);
      }

      return init;
    }()

    // set eventResponse handler to alla services

  }, {
    key: 'eventResponseServiceHandler',
    value: function eventResponseServiceHandler(_ref4) {
      var action = _ref4.action,
          response = _ref4.response;

      this.postMessage({ id: null, action: action, response: response });
    }

    /**
     * Outputplace iframe get by DataRouteService
     * 
     * @param dataPromise
     * @param options
     * 
     * @returns { Promise<void> }
     */

  }, {
    key: 'outputDataPlace',
    value: function () {
      var _ref5 = _asyncToGenerator(function* (dataPromise) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        var outputData = void 0;
        var _options$action = options.action,
            action = _options$action === undefined ? 'app:results' : _options$action;

        var _ref6 = yield dataPromise,
            result = _ref6.result,
            _ref6$data = _ref6.data,
            data = _ref6$data === undefined ? [] : _ref6$data;

        var parser = new ol.format.GeoJSON();
        try {
          outputData = data.map(function (_ref7) {
            var layer = _ref7.layer,
                features = _ref7.features;
            return _defineProperty({}, layer.getId(), { features: parser.writeFeatures(features) });
          });
        } catch (e) {
          console.warn(e);
          result = false;
          outputData = e;
        }

        this.postMessage({
          id: null,
          action: action,
          response: { result: result, data: outputData }
        });
      });

      function outputDataPlace(_x4) {
        return _ref5.apply(this, arguments);
      }

      return outputDataPlace;
    }()

    /**
     * post a message to parent
     */

  }, {
    key: 'postMessage',
    value: function postMessage() {
      var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      if (window.parent) {
        window.parent.postMessage(message, '*');
      }
    }
  }, {
    key: 'stopPendingActions',
    value: function () {
      var _ref9 = _asyncToGenerator(function* () {
        var _this = this;

        var promises = [];
        Object.keys(this.pendingactions).forEach(function (id) {
          promises.push(_this.services[_this.pendingactions[id].context].stop());
          delete _this.pendingactions[id];
        });
        return Promise.allSettled(promises);
      });

      function stopPendingActions() {
        return _ref9.apply(this, arguments);
      }

      return stopPendingActions;
    }()
  }, {
    key: 'getMessage',


    /**
     * handle all messages from the window
     */
    value: function () {
      var _ref10 = _asyncToGenerator(function* (evt) {
        if (evt && evt.data) {
          var _evt$data = evt.data,
              _evt$data$id = _evt$data.id,
              id = _evt$data$id === undefined ? (0, _getUniqueDomId.getUniqueDomId)() : _evt$data$id,
              _evt$data$single = _evt$data.single,
              single = _evt$data$single === undefined ? true : _evt$data$single,
              action = _evt$data.action,
              params = _evt$data.data;

          var _split = (action || '').split(':'),
              _split2 = _slicedToArray(_split, 2),
              context = _split2[0],
              method = _split2[1];

          var result = false;
          var data = void 0;
          try {
            var is_ready = this.services[context].getReady();
            if (is_ready && single) {
              yield this.stopPendingActions();
            }
            if (is_ready) {
              this.pendingactions[id] = { context: context };
              data = yield this.services[context][method](params);
              result = true;
            }
          } catch (e) {
            console.warn(e);
            result = false;
            data = e;
          }
          this.postMessage({
            id: id,
            action: action,
            response: { result: result, data: data }
          });
          delete this.pendingactions[id];
        }
      });

      function getMessage(_x6) {
        return _ref10.apply(this, arguments);
      }

      return getMessage;
    }()

    /**
     * Called when change map or clear
     */

  }, {
    key: 'clear',
    value: function () {
      var _ref11 = _asyncToGenerator(function* () {
        var serviceNames = Object.keys(this.services);
        for (var i = 0; i < serviceNames.length; i++) {
          this.services[serviceNames[i]].off('response', this.eventResponseServiceHandler);
        }
        yield this.stopPendingActions();
        window.removeEventListener('message', this.getMessage, false);
      });

      function clear() {
        return _ref11.apply(this, arguments);
      }

      return clear;
    }()
  }]);

  return IframePluginService;
}();

/**
 * ORIGINAL SOURCE: src/app/core/iframe/services/baseservice.js@3.9.0
 */


var BaseIframeService = function (_G3WObject) {
  _inherits(BaseIframeService, _G3WObject);

  function BaseIframeService() {
    _classCallCheck(this, BaseIframeService);

    /**
     * @type { boolean }
     */
    var _this2 = _possibleConstructorReturn(this, (BaseIframeService.__proto__ || Object.getPrototypeOf(BaseIframeService)).call(this));

    _this2.ready = false;

    /**
     * Map service
     */
    _this2.mapService = _gui2.default.getService('map');

    /**
     * Current project
     */
    _this2.project = _application2.default.project;

    /**
     * @type { Array | undefined }
     */
    _this2.layers = undefined;

    // common attributes between plugin service

    /**
     * ORIGINAL SOURCE: src/app/core/iframe/services/plugins/service.js@3.9.0
     * 
     * @since 3.9.1
     */
    _this2.pluginName;

    /**
     * ORIGINAL SOURCE: src/app/core/iframe/services/plugins/service.js@3.9.0
     * 
     * @since 3.9.1
     */
    _this2.dependencyApi = {};

    return _this2;
  }

  /**
   * ORIGINAL SOURCE: src/app/core/iframe/services/plugins/service.js@3.9.0
   * 
   * @virtual method need to be implemented by subclasses
   * 
   * @since 3.9.1
   */


  _createClass(BaseIframeService, [{
    key: 'init',
    value: function () {
      var _ref12 = _asyncToGenerator(function* () {
        var _this3 = this;

        var _ref13 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            _ref13$layers = _ref13.layers,
            layers = _ref13$layers === undefined ? {} : _ref13$layers;

        this.layers = layers;

        // skip when plugin is not in configuration (ie. added to the application)
        if ('editing' !== this.pluginName || !_application2.default.configurationPlugins.includes('editing')) {
          return;
        }

        // wait until "editing" plugin is loaded
        yield (0, _waitFor.waitFor)(function () {
          return _plugins2.default.getPlugin('editing');
        });

        // BACKOMP v3.x
        this.dependencyApi = _plugins2.default.getPlugin('editing');
        this.dependencyApi.getEditableLayersId = this.dependencyApi.getEditableLayersId || function () {
          return Object.keys(_this3.dependencyApi.getEditableLayers());
        };
        this.dependencyApi.hidePanel = this.dependencyApi.hidePanel || this.dependencyApi.hideEditingPanel;
        this.dependencyApi.resetDefault = this.dependencyApi.resetDefault || this.dependencyApi.resetAPIDefault;

        this.setReady(true);
      });

      function init() {
        return _ref12.apply(this, arguments);
      }

      return init;
    }()
    /**
     * ORIGINAL SOURCE: src/app/core/iframe/services/plugins/service.js@3.9.0
     * 
     * @virtual method need to be implemented by subclasses 
     * 
     * @since 3.9.1
     */

  }, {
    key: 'getDependecyApi',
    value: function getDependecyApi() {
      return this.dependencyApi;
    }

    /**
     * Return a qgs_layer_id array based on passed qgis_layer_id
     * 
     * @param { Object } opts
     * @param { string | string[] | null | undefined } opts.qgs_layer_id
     * @param { Array } noValue
     * 
     * @returns { string[] } qgs_layer_id
     * 
     * @private
     */

  }, {
    key: 'getQgsLayerId',
    value: function getQgsLayerId(_ref14) {
      var qgs_layer_id = _ref14.qgs_layer_id,
          _ref14$noValue = _ref14.noValue,
          noValue = _ref14$noValue === undefined ? this.layers.map(function (l) {
        return l.id;
      }) : _ref14$noValue;

      return qgs_layer_id ? [].concat(qgs_layer_id) : noValue;
    }
  }, {
    key: 'searchFeature',


    /**
     * getFeature from DataProvider
     * 
     * @private
     */
    value: function () {
      var _ref16 = _asyncToGenerator(function* (_ref15) {
        var layer = _ref15.layer,
            feature = _ref15.feature;
        var field = feature.field,
            value = feature.value;

        var _ref17 = yield _data2.default.getData('search:features', {
          inputs: {
            layer: layer,
            filter: (0, _createSingleFieldParameter.createSingleFieldParameter)({ field: field, value: value, operator: 'eq' })
          },
          outputs: false
        }),
            _ref17$data = _ref17.data,
            data = _ref17$data === undefined ? [] : _ref17$data;

        return data;
      });

      function searchFeature(_x8) {
        return _ref16.apply(this, arguments);
      }

      return searchFeature;
    }()
  }, {
    key: 'findFeaturesWithGeometry',


    /**
     * Search feature(s) by field and value
     * 
     * @param { Object } opts
     * @param opts.qgs_layer_id
     * @param opts.feature
     * @param opts.zoom
     * @param opts.highlight
     * 
     * @returns { Promise<{ qgs_layer_id: null, features: [], found: boolean }>}
     */
    value: function () {
      var _ref18 = _asyncToGenerator(function* () {
        var _ref19 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            feature = _ref19.feature,
            _ref19$qgs_layer_id = _ref19.qgs_layer_id,
            qgs_layer_id = _ref19$qgs_layer_id === undefined ? [] : _ref19$qgs_layer_id,
            _ref19$zoom = _ref19.zoom,
            zoom = _ref19$zoom === undefined ? false : _ref19$zoom,
            _ref19$highlight = _ref19.highlight,
            highlight = _ref19$highlight === undefined ? false : _ref19$highlight;

        var response = {
          found: false,
          features: [],
          qgs_layer_id: null
        };
        var layersCount = qgs_layer_id.length;
        var i = 0;
        while (!response.found && i < layersCount) {
          var layer = this.project.getLayerById(qgs_layer_id[i]);
          try {
            var data = layer && (yield this.searchFeature({ layer: layer, feature: feature }));
            var features = data.length && data[0].features;
            response.found = features && features.length > 0 && !!features.find(function (f) {
              return f.getGeometry();
            });
            if (!features || !response.found) {
              throw 'invalid response';
            }
            response.features = features;
            response.qgs_layer_id = qgs_layer_id[i];
            if (zoom) {
              yield this.mapService.zoomToFeatures(features, { highlight: highlight });
            }
          } catch (e) {
            i++;console.warn(e);
          }
        }
        // in case of no response zoom to an initial extent
        if (!response.found) {
          this.mapService.zoomToExtent(this.mapService.project.state.initextent);
        }
        return response;
      });

      function findFeaturesWithGeometry() {
        return _ref18.apply(this, arguments);
      }

      return findFeaturesWithGeometry;
    }()

    /**
     * Set layer function
     * 
     * @param layers
     */

  }, {
    key: 'setLayers',
    value: function setLayers() {
      var layers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      this.layers = layers;
    }
  }, {
    key: 'getLayers',
    value: function getLayers() {
      return this.layers;
    }

    /**
     * Set ready service
     * 
     * @param bool
     */

  }, {
    key: 'setReady',
    value: function setReady() {
      var bool = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      this.ready = bool;
    }
  }, {
    key: 'getReady',
    value: function getReady() {
      return this.ready;
    }

    /**
     * Overwrite single service: Usefult to stop eventually running action
     * 
     * @virtual method need to be implemented by subclasses
     * 
     * @returns { Promise<void> }
     */

  }, {
    key: 'stop',
    value: function () {
      var _ref20 = _asyncToGenerator(function* () {});

      function stop() {
        return _ref20.apply(this, arguments);
      }

      return stop;
    }()

    /**
     * Overwrite each single service
     * 
     * @virtual method need to be implemented by subclasses
     */

  }, {
    key: 'clear',
    value: function clear() {}
  }]);

  return BaseIframeService;
}(_g3wObject2.default);

/**
 * ORIGINAL SOURCE: src/services/iframe-app.js@3.9.0
 */


var AppService = function (_BaseIframeService) {
  _inherits(AppService, _BaseIframeService);

  function AppService() {
    _classCallCheck(this, AppService);

    var _this4 = _possibleConstructorReturn(this, (AppService.__proto__ || Object.getPrototypeOf(AppService)).call(this));

    _this4.mapControls = {
      screenshot: { control: null },
      changeMap: { control: null }
    };
    return _this4;
  }

  /**
   * Init service
   * 
   * @returns { Promise<unknown> }
   */


  _createClass(AppService, [{
    key: 'init',
    value: function init() {
      var _this5 = this;

      return new Promise(function (resolve) {
        _this5.mapService.once('ready', function () {
          _this5._map = _this5.mapService.getMap();
          _this5._mapCrs = _this5.mapService.getCrs();
          _this5.mapControls.screenshot.control = _this5.mapService.getMapControlByType({ type: 'screenshot' });
          _this5.setReady(true);
          resolve();
        });
      });
    }

    /**
     * @returns { Promise<Array> }
     */

  }, {
    key: 'results',
    value: function () {
      var _ref22 = _asyncToGenerator(function* (_ref21) {
        var _ref21$capture = _ref21.capture,
            capture = _ref21$capture === undefined ? true : _ref21$capture;

        _gui2.default.currentoutputplace = capture ? 'iframe' : 'gui';
        return [];
      });

      function results(_x12) {
        return _ref22.apply(this, arguments);
      }

      return results;
    }()

    /**
     * @returns { Promise<void> }
     */

  }, {
    key: 'screenshot',
    value: function () {
      var _ref24 = _asyncToGenerator(function* (_ref23) {
        var _this6 = this;

        var _ref23$capture = _ref23.capture,
            capture = _ref23$capture === undefined ? true : _ref23$capture;

        // skip when ..
        if (!capture) {
          this.mapControls.screenshot.control.resetOriginalOnClickEvent();
          return;
        }

        this.mapControls.screenshot.control.overwriteOnClickEvent(function (blob) {
          var response = void 0;
          try {
            response = { result: true, data: blob };
          } catch (e) {
            console.warn(e);
            response = { result: false, data: e };
          } finally {
            _this6.emit('response', { response: response, action: 'app:screenshot' });
          }
        });
      });

      function screenshot(_x13) {
        return _ref24.apply(this, arguments);
      }

      return screenshot;
    }()

    /**
     * Eventually send as param the projection in which we would like get center of map
     * 
     * @param { Object } params
     * @param params.epsg since 3.9.1
     * 
     * @returns { Promise<void> }
     */

  }, {
    key: 'getcenter',
    value: function () {
      var _ref25 = _asyncToGenerator(function* () {
        var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        var center = this.mapService.getCenter();
        if (undefined !== params.epsg) {
          return ol.proj.transform(center, this.mapService.getEpsg(), (yield _getEpsgFromParam(params.epsg)));
        }
        return center;
      });

      function getcenter() {
        return _ref25.apply(this, arguments);
      }

      return getcenter;
    }()

    /**
     * Zoom to coordinates
     * 
     * @param { Object } params
     * @param { Array } params.coordinates
     * @param params.epsg since 3.9.1
     * 
     * @returns { Promise<Array> }
     */

  }, {
    key: 'zoomtocoordinates',
    value: function () {
      var _ref26 = _asyncToGenerator(function* () {
        var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var _params$coordinates = params.coordinates,
            coordinates = _params$coordinates === undefined ? [] : _params$coordinates,
            epsg = params.epsg;
        // skip when coordinates in params are null or are an array with more than item 2

        if (!(coordinates && Array.isArray(coordinates) && 2 === coordinates.length)) {
          return Promise.reject(coordinates);
        }
        if (undefined !== epsg) {
          // normalized psg code
          epsg = yield _getEpsgFromParam(epsg);
          coordinates = ol.proj.transform(coordinates, epsg, this.mapService.getEpsg());
        }
        this.mapService.zoomTo(coordinates);
        return coordinates;
      });

      function zoomtocoordinates() {
        return _ref26.apply(this, arguments);
      }

      return zoomtocoordinates;
    }()

    /**
     * Eventually send as param the projection in which we would like get center of map
     * 
     * @param { Object } params
     * @param params.epsg since 3.9.1
     * 
     * @returns { Promise<void> }
     */

  }, {
    key: 'getextent',
    value: function () {
      var _ref27 = _asyncToGenerator(function* () {
        var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        var extent = this.mapService.getMapExtent();
        /** @FIXME add description */
        if (undefined !== params.epsg) {
          return ol.proj.transformExtent(extent, this.mapService.getEpsg(), (yield _getEpsgFromParam(params.epsg)));
        }
        return extent;
      });

      function getextent() {
        return _ref27.apply(this, arguments);
      }

      return getextent;
    }()

    /**
     * @param { Object } params
     * @param { Array } params.extent
     * @param params.epsg since 3.9.1
     * 
     * @returns { Promise<Array> }
     */

  }, {
    key: 'zoomtoextent',
    value: function () {
      var _ref28 = _asyncToGenerator(function* () {
        var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var _params$extent = params.extent,
            extent = _params$extent === undefined ? [] : _params$extent,
            epsg = params.epsg;
        // skip when an extent is null ora an array with number of ites not equal to 4

        if (!(extent && Array.isArray(extent) && 4 === extent.length)) {
          return Promise.reject(extent);
        }
        /** If epsg is provide, get epsg definition */
        if (undefined !== epsg) {
          epsg = _getEpsgFromParam(epsg);
          extent = ol.proj.transformExtent(extent, epsg, this.mapService.getEpsg());
        } else {
          this.mapService.goToBBox(extent);
        }
        return extent;
      });

      function zoomtoextent() {
        return _ref28.apply(this, arguments);
      }

      return zoomtoextent;
    }()
  }, {
    key: 'zoomtofeature',


    /**
     * Zoom to features
     * 
     * @param { Object } params
     * @param params.qgs_layer_id
     * @param params.feature
     * @param { boolean } params.highlight 
     * 
     * @returns { Promise } qgs_layer_id
     */
    value: function () {
      var _ref29 = _asyncToGenerator(function* () {
        var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var qgs_layer_id = params.qgs_layer_id,
            feature = params.feature,
            _params$highlight = params.highlight,
            highlight = _params$highlight === undefined ? false : _params$highlight;


        qgs_layer_id = this.getQgsLayerId({ qgs_layer_id: qgs_layer_id });

        var response = yield this.findFeaturesWithGeometry({
          qgs_layer_id: qgs_layer_id,
          feature: feature,
          zoom: true,
          highlight: highlight
        });

        return response.qgs_layer_id;
      });

      function zoomtofeature() {
        return _ref29.apply(this, arguments);
      }

      return zoomtofeature;
    }()
  }]);

  return AppService;
}(BaseIframeService);

/**
 * ORIGINAL SOURCE: src/services/iframe-editing.js@3.9.0
 */


var EditingService = function (_BaseIframeService2) {
  _inherits(EditingService, _BaseIframeService2);

  function EditingService() {
    _classCallCheck(this, EditingService);

    var _this7 = _possibleConstructorReturn(this, (EditingService.__proto__ || Object.getPrototypeOf(EditingService)).call(this));

    _this7.pluginName = 'editing';

    _this7.subscribevents = [];

    _this7.isRunning = false;

    _this7.responseObject = {
      cb: null, // resolve or reject promise method
      qgs_layer_id: null,
      error: null
    };

    _this7.config = {
      tools: {
        add: {
          disabled: [{ id: 'deletefeature' }, { id: 'copyfeatures' }, { id: 'editmultiattributes' }, { id: 'deletePart' }, { id: 'splitfeature' }, { id: 'mergefeatures' }]
        },
        update: {
          disabled: [{ id: 'addfeature' }, { id: 'copyfeatures' }, { id: 'deletefeature' }, { id: 'editmultiattributes' }, { id: 'deletePart' }, { id: 'splitfeature' }, { id: 'mergefeatures' }]
        },
        delete: {
          enabled: [{ id: 'deletefeature', options: { active: true } }]
        }
      }
    };

    /**
     * subscribers handlers
     */
    _this7.subscribersHandlers = {

      canUndo: function canUndo(_ref30) {
        var activeTool = _ref30.activeTool,
            _ref30$disableToolbox = _ref30.disableToolboxes,
            disableToolboxes = _ref30$disableToolbox === undefined ? [] : _ref30$disableToolbox;
        return function (bool) {
          //set currenttoolbocx id in editing to null
          if (false === bool) {
            _this7.responseObject.qgs_layer_id = null;
            _this7.responseObject.error = null;
          }
          activeTool.setEnabled(!bool);
          disableToolboxes.forEach(function (toolbox) {
            return toolbox.setEditing(!bool);
          });
        };
      },

      canRedo: function canRedo() {},

      //run callback
      cancelform: function cancelform(cb) {
        return function () {
          cb();
        };
      },

      addfeature: function addfeature() {
        var _ref31 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            properties = _ref31.properties,
            toolboxes = _ref31.toolboxes;

        return function (feature) {

          Object.keys(properties).forEach(function (p) {
            return feature.set(p, properties[p]);
          });

          var activeTool = void 0;
          var disableToolboxes = [];

          toolboxes.forEach(function (t) {
            var tool = t.getToolById('addfeature');
            if (tool.isActive()) {
              tool.setEnabled(false);
              activeTool = tool;
            } else {
              t.setEditing(false);
              disableToolboxes.push(t);
            }
          });

          // just one time
          if (_this7.subscribevents.find(function (e) {
            return 'canUndo' !== e.event;
          })) {
            _this7.addSubscribeEvents('cancelform', _this7.addSubscribeEvents('canUndo', { activeTool: activeTool, disableToolboxes: disableToolboxes }));
          }
        };
      },

      closeeditingpanel: function closeeditingpanel(_ref32) {
        var qgs_layer_id = _ref32.qgs_layer_id;
        return function () {
          // response to router service
          _this7.responseObject.cb({
            qgs_layer_id: _this7.responseObject.qgs_layer_id,
            error: _this7.responseObject.error
          });
          // stop action
          _this7.stopAction({ qgs_layer_id: qgs_layer_id });
        };
      }

    };

    return _this7;
  }

  // METHODS CALLED FROM EACH ACTION METHOD

  /**
   * run before each action
   */


  _createClass(EditingService, [{
    key: 'startAction',
    value: function () {
      var _ref34 = _asyncToGenerator(function* (_ref33) {
        var _this8 = this;

        var toolboxes = _ref33.toolboxes,
            resolve = _ref33.resolve,
            reject = _ref33.reject;


        this.responseObject.cb = reject;

        // set same mode autosave
        this.dependencyApi.setSaveConfig({
          cb: {
            // called when commit changes are done successuffly
            done: function done(toolbox) {
              //set toolbox id
              _this8.responseObject.cb = resolve;
              _this8.responseObject.qgs_layer_id = toolbox.getId();
              _this8.responseObject.error = null;
              // close panel that fire closeediting panel event
              _this8.dependencyApi.hidePanel();
            },
            // called whe commit change receive an error
            error: function error(toolbox, _error) {
              _this8.responseObject.cb = reject;
              _this8.responseObject.qgs_layer_id = toolbox.getId();
              _this8.responseObject.error = _error;
            }
          }
        });

        // set toolboxes visible base on the value of qgs_layer_id
        this.dependencyApi.showPanel({ toolboxes: toolboxes });

        this.isRunning = true;
      });

      function startAction(_x20) {
        return _ref34.apply(this, arguments);
      }

      return startAction;
    }()

    /**
     * run after each action
     */

  }, {
    key: 'stopAction',
    value: function () {
      var _ref35 = _asyncToGenerator(function* () {
        var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        if (opts.qgs_layer_id) {
          yield this.stopEditing(opts.qgs_layer_id);
        }
      });

      function stopAction() {
        return _ref35.apply(this, arguments);
      }

      return stopAction;
    }()

    /**
     * add subscribe refenrence
     */

  }, {
    key: 'addSubscribeEvents',
    value: function addSubscribeEvents(event) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var handler = this.subscribersHandlers[event](options);
      this.dependencyApi.subscribe(event, handler);
      this.subscribevents.push({ event: event, handler: handler });
      return handler;
    }
  }, {
    key: 'resetSubscribeEvents',


    /**
     * Reset subscriber editing plugin events
     */
    value: function resetSubscribeEvents() {
      var _this9 = this;

      this.subscribevents.forEach(function (d) {
        _this9.dependencyApi.unsubscribe(d.event, d.handler);
      });
    }
  }, {
    key: 'add',


    /**
     * Called whe we want to add a feature
     * 
     * @param { Object } config
     * @param config.qgs_layer_id
     * @param config.properties
     * 
     * @returns { Promise<void> }
     */
    value: function add() {
      var _this10 = this;

      var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return new Promise(function () {
        var _ref36 = _asyncToGenerator(function* (resolve, reject) {
          // skip when ..
          if (_this10.isRunning) {
            return reject();
          }

          // extract `qgs_layer_id9` from a configuration message

          var configQglLayerId = config.qgs_layer_id,
              data = _objectWithoutProperties(config, ['qgs_layer_id']);

          var properties = data.properties;


          var qgs_layer_id = _this10.getQgsLayerId({
            qgs_layer_id: configQglLayerId,
            noValue: _this10.dependencyApi.getEditableLayersId()
          });

          // call method common
          yield _this10.startAction({ toolboxes: qgs_layer_id, resolve: resolve, reject: reject });

          // return all toolboxes
          var toolboxes = (yield _this10.startEditing(qgs_layer_id, {
            tools: _this10.config.tools.add,
            startstopediting: false,
            action: 'add',
            selected: 1 === qgs_layer_id.length
          })).filter(function (p) {
            return 'fulfilled' === p.status;
          }).map(function (p) {
            return p.value;
          });

          /** @FIXME add description */
          if (!_gui2.default.isSidebarVisible()) {
            _gui2.default.showSidebar();
          }

          /** @FIXME add description */
          if (1 === toolboxes.length && toolboxes[0]) {
            toolboxes[0].setActiveTool(toolboxes[0].getToolById('addfeature'));
          }

          // in case of no feature add avent subscribe
          _this10.addSubscribeEvents('addfeature', { properties: properties, toolboxes: toolboxes });
          _this10.addSubscribeEvents('closeeditingpanel', { qgs_layer_id: qgs_layer_id });
        });

        return function (_x24, _x25) {
          return _ref36.apply(this, arguments);
        };
      }());
    }

    /**
     * Called when we want to update a know feature field
     * 
     * @param config
     * 
     * @returns { Promise<unknown> }
     */

  }, {
    key: 'update',
    value: function () {
      var _ref37 = _asyncToGenerator(function* () {
        var _this11 = this;

        var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        return new Promise(function () {
          var _ref38 = _asyncToGenerator(function* (resolve, reject) {
            // skip when ..
            if (_this11.isRunning) {
              return reject();
            }

            var configQglLayerId = config.qgs_layer_id,
                data = _objectWithoutProperties(config, ['qgs_layer_id']);

            var feature = data.feature;

            var qgs_layer_id = _this11.getQgsLayerId({
              qgs_layer_id: configQglLayerId,
              noValue: _this11.dependencyApi.getEditableLayersId()
            });

            var response = yield _this11.findFeaturesWithGeometry({
              qgs_layer_id: qgs_layer_id,
              feature: feature,
              zoom: true,
              highlight: true,
              selected: 1 === qgs_layer_id.length // set selected toolbox
            });

            // skip when ..
            if (!response.found) {
              return reject();
            }

            yield _this11.startAction({ toolboxes: [response.qgs_layer_id], resolve: resolve, reject: reject });

            // return all toolboxes
            yield _this11.startEditing([response.qgs_layer_id], {
              feature: feature,
              tools: _this11.config.tools.update,
              startstopediting: false,
              action: 'update'
            });

            if (!_gui2.default.isSidebarVisible()) {
              _gui2.default.showSidebar();
            }

            _this11.addSubscribeEvents('closeeditingpanel', { qgs_layer_id: [response.qgs_layer_id] });
          });

          return function (_x27, _x28) {
            return _ref38.apply(this, arguments);
          };
        }());
      });

      function update() {
        return _ref37.apply(this, arguments);
      }

      return update;
    }()

    /**
     * @virtual method need to be implemented by subclasses 
     */

  }, {
    key: 'delete',
    value: function _delete() {}

    /**
     * Called when we want to start editing
     * 
     * @param { Array } qgs_layer_id
     * @param { Object } options
     * 
     * @returns { Promise< unknown | void > }
     */

  }, {
    key: 'startEditing',
    value: function () {
      var _ref39 = _asyncToGenerator(function* () {
        var _this12 = this;

        var qgs_layer_id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var _options$action2 = options.action,
            action = _options$action2 === undefined ? 'add' : _options$action2,
            feature = options.feature;

        var filter = {};
        options.filter = filter;
        switch (action) {
          case 'add':
            filter.nofeatures = true;break;
          case 'update':
            filter.field = feature.field + '|eq|' + feature.value;break;
        }
        var promises = [];
        qgs_layer_id.forEach(function (id) {
          promises.push(_this12.dependencyApi.startEditing(id, options));
        });
        return yield Promise.allSettled(promises);
      });

      function startEditing() {
        return _ref39.apply(this, arguments);
      }

      return startEditing;
    }()

    /**
     * Stop editing
     * 
     * @param qgs_layer_id
     * 
     * @returns { Promise<unknown> }
     */

  }, {
    key: 'stopEditing',
    value: function () {
      var _ref40 = _asyncToGenerator(function* (qgs_layer_id) {
        var _this13 = this;

        var promises = [];
        qgs_layer_id.forEach(function (id) {
          promises.push(_this13.dependencyApi.stopEditing(id));
        });
        yield Promise.allSettled(promises);
        this.clear();
      });

      function stopEditing(_x31) {
        return _ref40.apply(this, arguments);
      }

      return stopEditing;
    }()
  }, {
    key: 'stop',
    value: function stop() {
      var _this14 = this;

      return new Promise(function (resolve) {
        _this14.dependencyApi.hidePanel();
        _gui2.default.hideSidebar();
        _this14.once('clear', resolve);
      });
    }

    /**
     * Called wen we want to reset default editing plugin behaviour
     */

  }, {
    key: 'clear',
    value: function clear() {
      this.dependencyApi.resetDefault();
      this.isRunning = false;
      this.responseObject = {
        cb: null, // resolve or reject promise method
        qgs_layer_id: null,
        error: null
      };
      this.resetSubscribeEvents();
      this.emit('clear');
    }
  }]);

  return EditingService;
}(BaseIframeService);

exports.default = new IframePluginService();

},{"g3w-object":163,"services/data":206,"services/gui":207,"store/application":212,"store/plugins":213,"store/projections":214,"utils/createSingleFieldParameter":230,"utils/getUniqueDomId":252,"utils/normalizeEpsg":263,"utils/waitFor":278}],209:[function(require,module,exports){
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MapLayersStoresRegistry = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /**
                                                                                                                                                                                                                                                                   * @file ORIGINAL SOURCE: src/app/gui/map/mapservice.js@v3.10.2
                                                                                                                                                                                                                                                                   * @since 3.11.0
                                                                                                                                                                                                                                                                   */

var _localforage = require('localforage');

var _localforage2 = _interopRequireDefault(_localforage);

var _g3wObject = require('g3w-object');

var _g3wObject2 = _interopRequireDefault(_g3wObject);

var _application = require('store/application');

var _application2 = _interopRequireDefault(_application);

var _plugins = require('store/plugins');

var _plugins2 = _interopRequireDefault(_plugins);

var _projections = require('store/projections');

var _projections2 = _interopRequireDefault(_projections);

var _isPointGeometryType = require('utils/isPointGeometryType');

var _isLineGeometryType = require('utils/isLineGeometryType');

var _isPolygonGeometryType = require('utils/isPolygonGeometryType');

var _createSelectedStyle = require('utils/createSelectedStyle');

var _getMapLayersByFilter = require('utils/getMapLayersByFilter');

var _getScaleFromResolution = require('utils/getScaleFromResolution');

var _getResolutionFromScale = require('utils/getResolutionFromScale');

var _getUniqueDomId = require('utils/getUniqueDomId');

var _throttle = require('utils/throttle');

var _createFilterFromString = require('utils/createFilterFromString');

var _interactioncontrol = require('map/controls/interactioncontrol');

var _interactioncontrol2 = _interopRequireDefault(_interactioncontrol);

var _pickcoordinatesinteraction = require('map/interactions/pickcoordinatesinteraction');

var _pickcoordinatesinteraction2 = _interopRequireDefault(_pickcoordinatesinteraction);

var _queryby = require('map/controls/queryby');

var _geolocationcontrol = require('map/controls/geolocationcontrol');

var _streetviewcontrol = require('map/controls/streetviewcontrol');

var _scalecontrol = require('map/controls/scalecontrol');

var _screenshotcontrol = require('map/controls/screenshotcontrol');

var _measurecontrol = require('map/controls/measurecontrol');

var _data = require('services/data');

var _data2 = _interopRequireDefault(_data);

var _application3 = require('services/application');

var _application4 = _interopRequireDefault(_application3);

var _gui = require('services/gui');

var _gui2 = _interopRequireDefault(_gui);

var _MapControlZoomHistory = require('components/MapControlZoomHistory.vue');

var _MapControlZoomHistory2 = _interopRequireDefault(_MapControlZoomHistory);

var _MapControlGeocoding = require('components/MapControlGeocoding.vue');

var _MapControlGeocoding2 = _interopRequireDefault(_MapControlGeocoding);

var _groupBy = require('utils/groupBy');

var _getProject = require('utils/getProject');

var _getCatalogLayerById = require('utils/getCatalogLayerById');

var _getCatalogLayers = require('utils/getCatalogLayers');

var _waitFor = require('utils/waitFor');

var _vectorlayer = require('map/layers/vectorlayer');

var _imagelayer = require('map/layers/imagelayer');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

/**
 * Open Layers controls (zoom, streetrview, screnshoot, ruler, ...)
 */
var MAP = {
  maxZoom: 1000,
  controls: {},
  offlineids: [],
  selectedLayer: null,
  stores: {},
  externalLayers: [],
  animatingHighlight: false,
  layers: Object.assign(new _g3wObject2.default({ setters: {
      addLayersStore: function addLayersStore(store) {
        MAP.stores[store.getId()] = store;
      },
      removeLayersStore: function removeLayersStore(store) {
        if (store) {
          delete MAP.layers.stores[store.getId()];
        }
      }
    } }), {
    getLayerById: function getLayerById(id) {
      return Object.values(MAP.stores).map(function (s) {
        return s.getLayerById(id);
      }).find(function (l) {
        return l;
      });
    },
    getLayers: function getLayers(filter) {
      return Object.values(MAP.stores).flatMap(function (s) {
        return s.getLayers(filter);
      });
    },
    getQuerableLayersStores: function getQuerableLayersStores() {
      return Object.values(MAP.stores).filter(function (s) {
        return s.isQueryable();
      });
    },
    getLayersStore: function getLayersStore(id) {
      return MAP.stores[id];
    },
    getLayersStores: function getLayersStores() {
      return Object.values(MAP.stores);
    }
  })
};

/**
 * Controls factory
 */
var CONTROLS = {
  'zoomtoextent': function zoomtoextent() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return new _interactioncontrol2.default(_extends({}, opts, { ol: new ol.control.ZoomToExtent(opts) }));
  },
  'zoom': function zoom() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return new _interactioncontrol2.default(_extends({}, opts, { ol: new ol.control.Zoom(opts) }));
  },
  'scaleline': function scaleline() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return new _interactioncontrol2.default(_extends({}, opts, { ol: new ol.control.ScaleLine(opts) }));
  },
  'overview': function overview() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return new _interactioncontrol2.default(_extends({}, opts, { ol: new ol.control.OverviewMap(opts) }));
  },
  /** @since 3.8.0 */
  'zoomhistory': function zoomhistory() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return new _interactioncontrol2.default({ element: new (Vue.extend(_MapControlZoomHistory2.default))().$mount().$el, tipLabel: "sdk.mapcontrols.addlayer.tooltip" });
  },
  'geocoding': function geocoding() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return new _interactioncontrol2.default({ element: new (Vue.extend(_MapControlGeocoding2.default))({ propsData: opts.config }).$mount().$el, offline: false });
  }, // pass configuration from server
  'zoombox': function zoombox() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return new _interactioncontrol2.default(_extends({}, opts, {
      name: 'zoombox',
      tipLabel: 'Zoom to box',
      label: '\uE901',
      interactionClass: ol.interaction.DragBox,
      cursorClass: 'ol-crosshair',
      onSetMap: function onSetMap(_ref) {
        var _this = this;

        var setter = _ref.setter,
            map = _ref.map;

        if ('after' === setter) {
          // zoom box
          this._startCoordinate = null;
          this._interaction.on('boxstart', function (e) {
            return _this._startCoordinate = e.coordinate;
          });
          this._interaction.on('boxend', function (e) {
            _this.dispatchEvent({ type: 'zoomend', extent: ol.extent.boundingExtent([_this._startCoordinate, e.coordinate]) });
            _this._startCoordinate = null;
            if (_this._autountoggle) {
              _this.toggle();
            }
          });
        }
      }
    }));
  },
  'query': function query() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return new _interactioncontrol2.default(_extends({}, opts, {
      offline: false,
      name: "query",
      tipLabel: "sdk.mapcontrols.query.tooltip",
      label: opts.label || '\uEA0F',
      clickmap: true,
      interactionClass: _pickcoordinatesinteraction2.default,
      cursorClass: 'ol-help',
      onSetMap: function onSetMap(_ref2) {
        var _this2 = this;

        var map = _ref2.map,
            setter = _ref2.setter;

        this.runQuery = this.runQuery || function () {
          var _ref4 = _asyncToGenerator(function* (_ref3) {
            var coordinates = _ref3.coordinates;

            _gui2.default.closeSideBar();
            try {
              var project = _application2.default.project;
              yield _data2.default.getData('query:coordinates', {
                inputs: {
                  coordinates: coordinates,
                  feature_count: project.state.feature_count || 5,
                  query_point_tolerance: project.getQueryPointTolerance(),
                  multilayers: [].concat(project.state.querymultilayers).includes(_this2.name)
                }
              });
            } catch (e) {
              console.warn('Error running spatial query: ', e);
            }
          });

          return function (_x9) {
            return _ref4.apply(this, arguments);
          };
        }();
        this.setEventKey({ eventType: 'picked', eventKey: this.on('picked', this.runQuery) });
        if ('after' === setter) {
          this.getInteraction().on('picked', (0, _throttle.throttle)(function () {
            var _ref5 = _asyncToGenerator(function* (evt) {
              _this2.dispatchEvent({ type: 'picked', coordinates: evt.coordinate });
            });

            return function (_x10) {
              return _ref5.apply(this, arguments);
            };
          }()));
        }
      }
    }));
  },
  'queryby': _queryby.QueryBy,
  'geolocation': _geolocationcontrol.GeolocationControl,
  'streetview': _streetviewcontrol.StreetViewControl,
  'addlayers': function addlayers() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return new _interactioncontrol2.default(_extends({}, opts, { tipLabel: "sdk.mapcontrols.addlayer.tooltip", label: '\uE907', name: 'addlayer', onSetMap: function onSetMap(e) {
        var _this3 = this;

        if ('after' === e.setter) $(this.element).on('click', function () {
          return _this3.dispatchEvent('addlayer');
        });
      }
    }));
  },
  'measure': _measurecontrol.MeasureControl,
  'mouseposition': function mouseposition() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return Object.assign(new ol.control.MousePosition(_extends({}, opts, { target: opts.target || 'mouse-position-control' })), { offline: true });
  },
  'scale': _scalecontrol.ScaleControl,
  'onclick': _interactioncontrol2.default,
  'screenshot': _screenshotcontrol.ScreenshotControl
};

/**
 * BACKCOMP v3.x
 */
CONTROLS['nominatim'] = CONTROLS['geocoding'];
CONTROLS['ontoggle'] = CONTROLS['onclick'];
CONTROLS['area'] = CONTROLS['measure'];
CONTROLS['length'] = CONTROLS['measure'];
CONTROLS['geoscreenshot'] = CONTROLS['screenshot'];
CONTROLS['querybbox'] = CONTROLS['queryby'];
CONTROLS['querybycircle'] = CONTROLS['queryby'];
CONTROLS['querybydrawpolygon'] = CONTROLS['queryby'];
CONTROLS['querybypolygon'] = CONTROLS['queryby'];

var MapService = function (_G3WObject) {
  _inherits(MapService, _G3WObject);

  function MapService() {
    _classCallCheck(this, MapService);

    var _this4 = _possibleConstructorReturn(this, (MapService.__proto__ || Object.getPrototypeOf(MapService)).call(this));

    _this4.state = {
      mapUnits: 'm',
      bbox: [],
      hidemaps: [],
      resolution: null,
      center: null,
      loading: false,
      hidden: true,
      scale: 0,
      map_info: { info: null, style: null },
      mapunits: ['metric']
    };

    /**
     * internal promise. Resolved when view is set
     *
     * @since 3.8.3
     */
    _this4._ready = new Promise(function (res) {
      return _this4.once('viewerset', res);
    });

    _this4.viewer = null;

    _this4.target = 'map';

    _this4.layersCount = 0; // useful to set Zindex to layer order on map

    _this4.project = _application2.default.project;

    _this4._controls = [];

    _this4._layers = {
      base: {},
      g3w: [],
      external_wms: [],
      external_vector: [],
      external: []
    };

    /**
     * Store interactions added by plugin or external application
     */
    _this4._externalInteractions = [];

    /**
     * Default layers are OL layers that are add to map by default.
     * Are used to show selection Features and/or highlight Layer feature
     */
    _this4.defaultsLayers = {

      mapcenter: new ol.layer.Vector({
        source: new ol.source.Vector(),
        style: new ol.style.Style({
          image: new ol.style.Icon({
            opacity: 1,
            src: '/static/client/images/mapcentermarker.svg',
            scale: 0.8
          })
        })
      }),

      _style: {
        highlightLayer: { color: undefined },
        selectionLayer: { color: 'red' }
      },

      highlightLayer: new ol.layer.Vector({
        source: new ol.source.Vector(),
        style: function style(feat) {
          return [(0, _createSelectedStyle.createSelectedStyle)({
            geometryType: feat.getGeometry().getType(),
            color: _this4.defaultsLayers._style.highlightLayer.color,
            fill: true
          })];
        }
      }),

      selectionLayer: new ol.layer.Vector({
        source: new ol.source.Vector()
      })

    };

    _this4.layersExtraParams = {};

    _this4._drawShadow = {
      type: 'coordinate',
      outer: [],
      inner: [],
      scale: null,
      rotation: null,
      listener: null
    };

    _this4.config = window.initConfig;

    _this4._howManyAreLoading = 0;

    _this4._marker = null;

    _this4.onLayerLoadStart = _this4.onLayerLoadStart.bind(_this4);
    _this4.onLayerLoadEnd = _this4.onLayerLoadEnd.bind(_this4);
    _this4.onLayerLoadError = _this4.onLayerLoadError.bind(_this4);
    _this4.onExtraParamsSet = _this4.onExtraParamsSet.bind(_this4);
    _this4.updateMapLayers = _this4.updateMapLayers.bind(_this4);

    _this4._keyEvents = {
      ol: [],
      stores: [], // layers stores
      unwatches: []
    };

    _this4.project.onafter('setBaseLayer', function () {
      return _this4.updateMapLayers();
    }); // base layer

    _this4.debounces = {
      setupCustomMapParamsToLegendUrl: {
        fnc: function fnc() {
          _this4._setupCustomMapParamsToLegendUrl.apply(_this4, arguments);
        },
        delay: 1000
      }
    };

    _this4.setters = {
      setupControls: function setupControls() {
        var _this5 = this;

        var _config = this.config,
            header_terms_of_use_text = _config.header_terms_of_use_text,
            header_terms_of_use_link = _config.header_terms_of_use_link;

        // set layers attribution

        var attribution = header_terms_of_use_text ? header_terms_of_use_link ? '<a href="' + header_terms_of_use_link + '">' + header_terms_of_use_text + '</a>' : '<span class="skin-color" style="font-weight: bold">' + header_terms_of_use_text + '</span>' : false;

        this.getMapLayers().forEach(function (l) {
          return l.getSource().setAttributions(attribution);
        });

        // check if a base layer is set. If true, add attribution control
        if (attribution || (0, _getMapLayersByFilter.getMapLayersByFilter)({ BASELAYER: true }).length) {
          this.getMap().addControl(new ol.control.Attribution({ collapsible: false, target: 'map_footer_left' }));
        }

        // skip when no controls
        if (!this.config || !this.config.mapcontrols) {
          return;
        }

        // BACKCOMP (g3w-admin < v3.7.0)
        var mapcontrols = Array.isArray(this.config.mapcontrols) ? this.config.mapcontrols.reduce(function (a, v) {
          a[v] = {};return a;
        }, {}) // convert `initConfig.mapcontrols` from an array of strings to a key-value config Object (eg. ["geocoding"] --> "geocoding" = {})
        : this.config.mapcontrols;

        Object.entries(mapcontrols).forEach(function (_ref6) {
          var _ref7 = _slicedToArray(_ref6, 2),
              type = _ref7[0],
              _ref7$ = _ref7[1],
              config = _ref7$ === undefined ? {} : _ref7$;

          switch (type) {
            case 'zoom':
              _this5.createMapControl(type);
              break;

            case 'zoombox':
              if (!isMobile.any) {
                _this5.createMapControl(type, {}).on('zoomend', function (e) {
                  return _this5.viewer.fit(e.extent);
                });
              }
              break;

            case 'zoomtoextent':
              _this5.createMapControl(type, {
                options: {
                  label: '\uE98C',
                  extent: _this5.project.state.initextent
                }
              });
              break;

            case 'mouseposition':
              if (!isMobile.any) {
                // @since 3.8.
                var degrees = 'degrees' === _this5.getProjection().getUnits();
                var mapEpsg = _this5.getEpsg();
                var coordinateFormat = function coordinateFormat(epsg, coords) {
                  if ('EPSG:4326' === epsg) {
                    return ol.coordinate.format(ol.proj.transform(coords, mapEpsg, 'EPSG:4326'), '\xA0Lng: {x}, Lat: {y}\xA0\xA0 [EPSG:4326]\xA0', 4);
                  }
                  return ol.coordinate.format(coords, '\xA0' + (degrees ? 'Lng' : 'X') + ': {x}, ' + (degrees ? 'Lat' : 'Y') + ': {y}\xA0\xA0 [' + epsg + ']\xA0', degrees ? 4 : 2);
                };
                var control = _this5.createMapControl(type, {
                  add: false,
                  options: {
                    coordinateFormat: coordinateFormat.bind(null, mapEpsg),
                    undefinedHTML: false,
                    projection: _this5.getCrs()
                  }
                });
                if ('EPSG:4326' !== mapEpsg) {
                  control.on('change:epsg', function (e) {
                    return control.setCoordinateFormat(coordinateFormat.bind(null, e.epsg));
                  });
                }
              }
              break;

            case 'screenshot':
            case 'geoscreenshot':
              if (!isMobile.any) {
                if (_this5.getMapControlByType('screenshot')) {
                  _this5.getMapControlByType('screenshot').addType(type);
                } else {
                  _this5.createMapControl('screenshot', {
                    options: {
                      types: [type],
                      layers: [].concat(_toConsumableArray(MAP.layers.getLayers()), _toConsumableArray(_this5._layers.external))
                    }
                  });
                }
              }
              break;

            case 'scale':
              _this5.createMapControl(type, {
                add: false,
                options: {
                  coordinateFormat: ol.coordinate.createStringXY(4),
                  projection: _this5.getCrs(),
                  isMobile: isMobile.any
                }
              });
              break;

            case 'query':
              _this5.createMapControl(type, {
                add: true,
                toggled: true
              });
              break;

            case 'querybypolygon':
            case 'querybbox':
            case 'querybycircle':
            case 'querybydrawpolygon':
              if (!isMobile.any) {
                if (_this5.getMapControlByType('queryby')) {
                  _this5.getMapControlByType('queryby').addType(type);
                } else {
                  _this5.createMapControl('queryby', {
                    options: {
                      types: [type]
                    }
                  });
                }
              }
              break;

            case 'streetview':
              _this5.createMapControl(type, {});
              break;

            case 'scaleline':
              _this5.createMapControl(type, {
                add: false,
                options: {
                  position: 'br'
                }
              });
              break;

            case 'overview':
              if (!isMobile.any && window.initConfig.overviewproject) {
                (0, _getProject.getProject)(window.initConfig.overviewproject).then(function (project) {
                  //create a view for overview map
                  var map = _this5.getMap();
                  var view = new ol.View(_this5._calculateViewOptions({ project: project, width: 200, height: 150 })); // at moment hardcoded
                  view.on('change:center', function () {
                    var current = view.getCenter();
                    var center = map.getView().constrainCenter(current);
                    if (center[0] !== current[0] || center[1] !== current[1]) {
                      view.setCenter(center);
                    }
                  });
                  _this5.createMapControl(type, {
                    add: false,
                    options: {
                      view: view,
                      position: 'bl',
                      collapsed: false,
                      className: 'ol-overviewmap ol-custom-overviewmap',
                      collapseLabel: $('<span class="' + _gui2.default.getFontClass('arrow-left') + '"></span>')[0],
                      label: $('<span class="' + _gui2.default.getFontClass('arrow-right') + '"></span>')[0],
                      layers: Object.entries(
                      //group layer by multilayerId
                      project.getLayersStore().getLayers({ GEOLAYER: true, BASELAYER: false }).reduce(function (group, l) {
                        var id = l.getMultiLayerId();
                        group[id] = group[id] || [];
                        group[id].push(l);
                        return group;
                      }, {}) || []).map(function (_ref8) {
                        var _ref9 = _slicedToArray(_ref8, 2),
                            id = _ref9[0],
                            layers = _ref9[1];

                        var mapLayer = new _imagelayer.RasterLayer({
                          url: project.state.WMSUrl,
                          id: 'overview_layer_' + id,
                          tiled: layers[0].state.tiled
                        });
                        layers.reverse().forEach(function (l) {
                          return mapLayer.addLayer(l);
                        });
                        return mapLayer.getOLLayer(true);
                      }).reverse()
                    }
                  });
                  /** @since 3.10.0 Move another bottom left map controls bottom to a left of overview control**/
                  document.querySelector('.g3w-map-controls-left-bottom').style.left = '230px';
                  var observer = new MutationObserver(function (mutations) {
                    mutations.forEach(function (mutation) {
                      if ("class" === mutation.attributeName) {
                        document.querySelector('.g3w-map-controls-left-bottom').style.left = mutation.target.classList.contains('ol-collapsed') ? '50px' : '230px';
                      }
                    });
                  });
                  observer.observe(document.querySelector('.ol-custom-overviewmap'), { attributes: true });
                }).catch(function (e) {
                  return console.warn(e);
                });
              }
              break;

            case 'geocoding':
            case 'nominatim':
              _this5.createMapControl(type, {
                add: false,
                options: { config: config }
              });
              break;

            case 'geolocation':
              _this5.createMapControl(type).on('click', (0, _throttle.throttle)(function (e) {
                return _this5.showMarker(e.coordinates);
              }));
              break;

            case 'addlayers':
              if (!isMobile.any) {
                _this5.createMapControl(type, {}).on('addlayer', function () {
                  return _this5.showAddLayerModal();
                });
              }
              break;

            case 'length':
            case 'area':
              if (!isMobile.any) {
                if (_this5.getMapControlByType('measure')) {
                  _this5.getMapControlByType('measure').addType(type);
                } else {
                  _this5.createMapControl('measure', {
                    options: {
                      name: "measure",
                      tipLabel: 'sdk.mapcontrols.measures.title',
                      types: [type],
                      interactionClassOptions: {
                        projection: _this5.getProjection(),
                        help: 'sdk.mapcontrols.measures.' + type + '.help'
                      }
                    }
                  });
                }
              }
              break;

            /**
             * @since 3.8.0
             */
            case 'zoomhistory':
              $('.g3w-map-controls-left-bottom').append(_this5.createMapControl(type, { add: false }).element);
              break;

          }
        });
        return this.getMapControls();
      },
      addHideMap: function addHideMap() {
        var _ref10 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            _ref10$switchable = _ref10.switchable,
            switchable = _ref10$switchable === undefined ? false : _ref10$switchable;

        var idMap = {
          id: 'hidemap_' + Date.now(),
          map: null,
          switchable: switchable
        };
        this.state.hidemaps.push(idMap);
        return idMap;
      },
      setHidden: function setHidden(bool) {
        this.state.hidden = bool;
      },


      /** Set view based on project config */
      setupViewer: function () {
        var _ref11 = _asyncToGenerator(function* (width, height) {
          var _this6 = this;

          if (0 === width || 0 === height) {
            console.warn('[G3W-CLIENT] map was hidden during bootstrap');
            return;
          }

          var search = new URLSearchParams(location.search); // search params

          var showmarker = 1 * (search.get('showmarker') || 0); /** @since 3.10.0 0 or 1. Show marker on map center*/
          var iframetype = search.get('iframetype'); /** @since 3.10.0 type of iframe: map (only map, no control)*/
          var zoom_to_fid = search.get('zoom_to_fid');
          var zoom_to_features = search.get('ztf'); // zoom to features
          var coords = {
            lat: parseFloat(search.get('lat')),
            lon: parseFloat(search.get('lon')),
            x: parseFloat(search.get('x')),
            y: parseFloat(search.get('y'))
          };

          if (this.viewer) {
            this.viewer.destroy();
          }

          var olMap = new ol.Map({
            controls: ol.control.defaults({ attribution: false, zoom: false, rotateOptions: { autoHide: true, tipLabel: "Reset rotation (CTRL+DRAG to rotate)" } }),
            interactions: ol.interaction.defaults().extend([new ol.interaction.DragRotate({ condition: ol.events.condition.platformModifierKeyOnly })]),
            ol3Logo: false,
            keyboardEventTarget: document,
            target: this.target,
            view: new ol.View(this._calculateViewOptions({
              width: width,
              height: height,
              project: this.project,
              map_extent: search.get('map_extent') /** @since 3.10.0 */
            }))
          });

          this.viewer = {
            map: olMap,
            getMap: function getMap() {
              return _this6.viewer.map;
            },
            getView: function getView() {
              return _this6.viewer.map.getView();
            },
            getZoom: function getZoom() {
              return _this6.viewer.map.getView().getZoom();
            },
            getResolution: function getResolution() {
              return _this6.viewer.map.getView().getResolution();
            },
            getCenter: function getCenter() {
              return _this6.viewer.map.getView().getCenter();
            },
            destroy: function destroy() {
              if (_this6.viewer.map) {
                _this6.viewer.map.dispose();_this6.viewer.map = null;
              }
            },
            zoomTo: this.zoomTo.bind(this),
            goTo: this.goTo.bind(this),
            fit: this._fit.bind(this),
            /** @TODO check if deprecated */
            changeBaseLayer: function changeBaseLayer(name) {
              return _this6.map.getLayers().insertAt(0, _this6.map.getLayers().find(function (l) {
                return name === l.get('name');
              }));
            }
          };

          var map = this.viewer.getMap();

          // disable douclickzoom
          map.getInteractions().getArray().find(function (i) {
            return i instanceof ol.interaction.DoubleClickZoom;
          }).setActive(false);

          // visual click (sonar effect)
          map.on('click', function (_ref12) {
            var coordinate = _ref12.coordinate;

            var circle = new ol.layer.Vector({
              source: new ol.source.Vector({ features: [new ol.Feature({ geometry: new ol.geom.Point(coordinate) })] }),
              style: new ol.style.Style()
            });
            var start = +new Date();
            var duration = 1700;
            var interval = circle.on('postcompose', function (_ref13) {
              var frameState = _ref13.frameState;

              var elapsed = frameState.time - start;
              var ratio = ol.easing.easeOut(elapsed / duration);
              circle.setStyle(new ol.style.Style({
                image: new ol.style.Circle({
                  radius: 40 * ratio, // start = 0, end = 40
                  fill: new ol.style.Fill({ color: [225, 227, 228, .1] }),
                  stroke: new ol.style.Stroke({ color: [225, 227, 228, 1], width: 1.85 * (1 - ratio) }) // start = 1.85, end = 0
                })
              }));
              if (elapsed > duration) {
                map.removeLayer(circle);
                ol.Observable.unByKey(interval); // stop the effect
              }
            });
            map.addLayer(circle);
          });

          var currentControl = void 0;
          var can_drag = false;

          // set mouse cursor (dragging)
          new Vue().$watch(function () {
            return [_this6.getCurrentToggledMapControl(), _plugins2.default.getPlugin('editing') && _plugins2.default.getPlugin('editing').getActiveTool()];
          }, function (_ref14) {
            var _ref15 = _slicedToArray(_ref14, 2),
                control = _ref15[0],
                activeTool = _ref15[1];

            currentControl = control;
            can_drag = !control && !activeTool;
            map.getViewport().classList.toggle('ol-grab', can_drag);
            map.getInteractions().getArray().find(function (i) {
              return i instanceof ol.interaction.DoubleClickZoom;
            }).setActive(can_drag);
          });
          map.on(['pointerdrag', 'pointerup'], function (e) {
            /** @TODO disable default interaction "shift+zoom" ? */
            map.getViewport().classList.toggle('ol-grabbing', e.type == 'pointerdrag' && (!currentControl || !(currentControl.getInteraction() instanceof ol.interaction.DragBox)));
            map.getViewport().classList.toggle('ol-grab', e.type == 'pointerup' && can_drag);
          });

          var geom = void 0;
          if (zoom_to_fid) {
            yield this.zoomToFid(zoom_to_fid);
          } else if (zoom_to_features) {
            yield this.zoomToFeaturesUrl(zoom_to_features);
          } else if (!isNaN(coords.lat) && !isNaN(coords.lon)) {
            geom = new ol.geom.Point(ol.proj.transform([coords.lon, coords.lat], 'EPSG:4326', this.getEpsg()));
          } else if (!isNaN(coords.x) && !isNaN(coords.y)) {
            geom = new ol.geom.Point([coords.x, coords.y]);
          }

          if (geom && geom.getExtent()) {
            yield this.zoomToGeometry(geom);
          }

          // show marker on map center
          if (1 === showmarker) {
            this.defaultsLayers.mapcenter.getSource().addFeature(new ol.Feature({ geometry: new ol.geom.Point(this.getCenter()) }));
          }

          // iframe → hide map controls (empty object)
          if ('map' === iframetype) {
            this.config.mapcontrols = {};
          }

          // update max scale
          MAP.maxZoom = Math.min((0, _getScaleFromResolution.getScaleFromResolution)(this.getMap().getView().getResolutionForExtent(this.project.state.initextent, this.getMap().getSize()), this.getMapUnits()), MAP.maxZoom);

          this.state.size = this.viewer.map.getSize();
          this.state.mapUnits = this.viewer.map.getView().getProjection().getUnits();

          if (this.config.background_color) {
            $('#' + this.target).css('background-color', this.config.background_color);
          }

          $(this.viewer.map.getViewport()).prepend('<div id="map-spinner" style="position:absolute; top: 50%; right: 50%"></div>');

          this.viewer.map.getInteractions().forEach(function (int) {
            return _this6._watchInteraction(int);
          });
          this.viewer.map.getInteractions().on('add', function (int) {
            return _this6._watchInteraction(int.element);
          });

          this._marker = new ol.Overlay({
            position: null,
            positioning: 'center-center',
            element: document.getElementById('marker'),
            stopEvent: false
          });

          this.viewer.map.addOverlay(this._marker);

          // keep default layers above others
          this.viewer.map.getLayers().on('add', function (e) {
            var zindex = _this6.setLayerZIndex({
              layer: e.element,
              zindex: e.element.get('basemap') || 'bottom' === e.element.get('position') ? 0 : undefined
            });
            if (_this6.defaultsLayers.mapcenter) {
              _this6.defaultsLayers.mapcenter.setZIndex(zindex + 1);
            }
            if (_this6.defaultsLayers.highlightLayer) {
              _this6.defaultsLayers.highlightLayer.setZIndex(zindex + 1);
            }
            if (_this6.defaultsLayers.selectionLayer) {
              _this6.defaultsLayers.selectionLayer.setZIndex(zindex + 2);
            }
          });

          this.viewer.map.getLayers().on('remove', function (e) {
            if (e.element.getZIndex() === _this6.layersCount) {
              _this6.layersCount--;
            }
          });

          this.state.bbox = this.getMapBBOX();
          this.state.resolution = this.viewer.getResolution();
          this.state.center = this.viewer.getCenter();
          this._setupAllLayers();
          this.setUpMapOlEvents();

          // CHECK IF MAPLAYESRSTOREREGISTRY HAS LAYERSTORE
          MAP.layers.getLayersStores().forEach(this._setUpEventsKeysToLayersStore.bind(this));
          MAP.layers.onafter('addLayersStore', this._setUpEventsKeysToLayersStore.bind(this));
          MAP.layers.onafter('removeLayersStore', this._removeEventsKeysToLayersStore.bind(this));

          this.emit('viewerset');
          this.setupControls();
          this.emit('ready');
        });

        function setupViewer(_x14, _x15) {
          return _ref11.apply(this, arguments);
        }

        return setupViewer;
      }(),
      controlClick: function controlClick(mapcontrol) {
        var info = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      },
      loadExternalLayer: function loadExternalLayer(layer) {},
      // used in general to alert external layer is  loaded
      unloadExternalLayer: function unloadExternalLayer(layer) {}
    };

    _this4.on('extraParamsSet', _this4.onExtraParamsSet);
    return _this4;
  }

  /**
   * @since 3.11.0
   */


  _createClass(MapService, [{
    key: 'onExtraParamsSet',
    value: function onExtraParamsSet(extraParams, update) {
      var _this7 = this;

      if (update) {
        this.getMapLayers().forEach(function (l) {
          return l.update(_this7.state, extraParams);
        });
      }
    }

    /**
     * show spinner layers
     *
     * @since 3.11.0
     */

  }, {
    key: 'onLayerLoadStart',
    value: function onLayerLoadStart() {
      if (0 === this._howManyAreLoading) {
        this.emit('loadstart');
        _gui2.default.showSpinner({ container: $('#map-spinner'), id: 'maploadspinner', style: 'transparent' });
      }
      this._howManyAreLoading += 1;
    }

    /**
     * @since 3.11.0
     */

  }, {
    key: 'onLayerLoadEnd',
    value: function onLayerLoadEnd() {
      this._howManyAreLoading -= 1;
      if (0 === this._howManyAreLoading) {
        this.emit('loadend');
        _gui2.default.hideSpinner('maploadspinner');
      }
    }

    /**
     * @since 3.11.0
     */

  }, {
    key: 'onLayerLoadError',
    value: function onLayerLoadError() {
      /** @since 3.10.0 - fails silently */
      if (!this.project.state.show_load_layer_error) {
        return;
      }
      if (!this.onLayerLoadError.shown) {
        _gui2.default.notify.warning('sdk.errors.layers.load');
        this.onLayerLoadError.shown = true;
      }
      this.onLayerLoadEnd();
    }

    /**
     * @returns promise ready
     *
     * @since 3.8.3
     */

  }, {
    key: 'isReady',
    value: function isReady() {
      return this._ready;
    }
  }, {
    key: 'setUpMapOlEvents',
    value: function setUpMapOlEvents() {
      var _this8 = this;

      var dynamicLegend = this.project.state.context_base_legend;
      // set change resolution
      this._keyEvents.ol.forEach(function (k) {
        return ol.Observable.unByKey(k);
      });
      this._keyEvents.ol.push(this.viewer.map.getView().on('change:resolution', function () {
        _this8.state.bbox = _this8.getMapBBOX();
        _this8.state.resolution = _this8.viewer.getResolution();
        _this8.state.center = _this8.viewer.getCenter();
        _this8.updateMapLayers();
        if (dynamicLegend) {
          _this8.setupCustomMapParamsToLegendUrl();
        }
      }));
      if (dynamicLegend) {
        this._keyEvents.ol.push(this.viewer.map.on('moveend', function () {
          return _this8.setupCustomMapParamsToLegendUrl();
        }));
      } else {
        //set always to show legend at the start
        this.setupCustomMapParamsToLegendUrl();
      }
    }

    /**
     * Clear methods to remove all listeners events
     */

  }, {
    key: 'clear',
    value: function clear() {
      this.removeListener('extraParamsSet', this.onExtraParamsSet);
      this._keyEvents.ol.forEach(function (key) {
        return ol.Observable.unByKey(key);
      });
      this._keyEvents.ol.splice(0);
      MAP.layers.getLayersStores().forEach(this._removeEventsKeysToLayersStore.bind(this));
    }

    /**
     * @TODO refactor CDU plugin in order to remove `OlMapViewer` class
     */

  }, {
    key: '_addHideMap',
    value: function _addHideMap() {
      var _ref16 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          ratio = _ref16.ratio,
          _ref16$layers = _ref16.layers,
          layers = _ref16$layers === undefined ? [] : _ref16$layers,
          _ref16$mainview = _ref16.mainview,
          mainview = _ref16$mainview === undefined ? false : _ref16$mainview;

      var idMap = this.state.hidemaps.at(-1);
      var view = this.getMap().getView();

      var olView = mainview ? view : {
        projection: view.getProjection(),
        center: view.getCenter(),
        resolution: this.getResolution()
      };

      // set Map
      idMap.map = new ol.Map({
        controls: ol.control.defaults({ attribution: false, zoom: false }),
        interactions: ol.interaction.defaults(),
        ol3Logo: false,
        view: olView instanceof ol.View ? olView : new ol.View(olView),
        keyboardEventTarget: document,
        target: idMap.id
      });

      // in case of rate
      if (ratio) {
        var _idMap$map$getSize = idMap.map.getSize(),
            _idMap$map$getSize2 = _slicedToArray(_idMap$map$getSize, 2),
            w = _idMap$map$getSize2[0],
            h = _idMap$map$getSize2[1];

        idMap.map.setSize([w, w * ratio]);
      }

      (layers || []).forEach(function (l) {
        return idMap.map.addLayer(l);
      });

      return idMap.map;
    }

    /**
     * Used by the following plugins: "cdu"
     */

  }, {
    key: 'removeHideMap',
    value: function removeHideMap(id) {
      var i = (this.state.hidemaps || []).findIndex(function (m) {
        return id === m.id;
      });
      if (-1 !== i) {
        this.state.hidemaps.splice(i, 1);
      }
    }

    /**
     * Used by the following plugins: "cdu", "archiweb"
     */

  }, {
    key: 'createMapImage',
    value: function createMapImage() {
      var _ref17 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          map = _ref17.map,
          background = _ref17.background;

      return new Promise(function (resolve, reject) {
        try {
          var canvas = $(map ? map.getViewport() : $('#g3w-maps .g3w-map').last().children('.ol-viewport')[0]).children('canvas')[0];
          if (navigator.msSaveBlob) {
            resolve(canvas.msToBlob());
          } else {
            canvas.toBlob(function (blob) {
              return resolve(blob);
            });
          }
        } catch (e) {
          console.warn(e);
          reject(e);
        }
      });
    }
  }, {
    key: 'getProject',
    value: function getProject() {
      return this.project;
    }
  }, {
    key: 'getMap',
    value: function getMap() {
      try {
        return this.viewer.map;
      } catch (e) {
        console.warn(e);
      }
    }
  }, {
    key: 'getProjection',
    value: function getProjection() {
      return this.project.getProjection();
    }
  }, {
    key: 'isMapHidden',
    value: function isMapHidden() {
      return this.state.hidden;
    }
  }, {
    key: 'getCrs',
    value: function getCrs() {
      return this.project.getProjection().getCode();
    }
  }, {
    key: 'getViewport',
    value: function getViewport() {
      return this.viewer.map.getViewport();
    }
  }, {
    key: 'getResolution',
    value: function getResolution() {
      return this.viewer.map.getView().getResolution();
    }
  }, {
    key: 'getEpsg',
    value: function getEpsg() {
      return this.viewer.map.getView().getProjection().getCode();
    }

    /**
     * Show Marker on a map
     * @param coordinates
     * @param duration
     */

  }, {
    key: 'showMarker',
    value: function showMarker(coordinates) {
      var _this9 = this;

      var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1000;

      this._marker.setPosition(coordinates);
      setTimeout(function () {
        return _this9._marker.setPosition();
      }, duration);
    }

    /**
     * @returns layer by name
     */

  }, {
    key: 'getLayerByName',
    value: function getLayerByName(name) {
      return this.getMap().getLayers().getArray().find(function (l) {
        return name === l.get('name');
      });
    }

    /**
     * @returns layer by id
     */

  }, {
    key: 'getLayerById',
    value: function getLayerById(id) {
      return this.getMap().getLayers().getArray().find(function (l) {
        return id === l.get('id');
      });
    }

    /**
     * Used by the following plugins: "strees"
     *
     * get all features from vector layer based on coordinates
     */

  }, {
    key: 'getVectorLayerFeaturesFromCoordinates',
    value: function getVectorLayerFeaturesFromCoordinates(layerId, coordinates) {
      var intersectGeom = void 0;
      var features = [];
      var map = this.getMap();
      var vectorLayer = this.getLayerById(layerId);
      if (Array.isArray(coordinates)) {
        if (2 === coordinates.length) {
          var pixel = map.getPixelFromCoordinate(coordinates);
          map.forEachFeatureAtPixel(pixel, function (feature) {
            return features.push(feature);
          }, {
            layerFilter: function layerFilter(layer) {
              return layer === vectorLayer;
            }
          });
        } else if (4 === coordinates.length) {
          intersectGeom = ol.geom.Polygon.fromExtent(coordinates);
          switch (vectorLayer.constructor) {
            case _vectorlayer.VectorLayer:
              features = vectorLayer.getIntersectedFeatures(intersectGeom);
              break;
            case ol.layer.Vector:
              vectorLayer.getSource().getFeatures().forEach(function (f) {
                return intersectGeom.intersectsExtent(f.getGeometry().getExtent()) && features.push(f);
              });
              break;
          }
        }
      } else if (coordinates instanceof ol.geom.Polygon || coordinates instanceof ol.geom.MultiPolygon) {
        intersectGeom = coordinates;
        switch (vectorLayer.constructor) {
          case _vectorlayer.VectorLayer:
            features = vectorLayer.getIntersectedFeatures(intersectGeom);
            break;
          case ol.layer.Vector:
            vectorLayer.getSource().getFeatures().forEach(function (f) {
              return intersectGeom.intersectsExtent(feature.getGeometry().getExtent()) && features.push(f);
            });
            break;
        }
      }
      return features;
    }

    /**
     * Used by the following plugins: "cdu"
     */

  }, {
    key: 'getQueryLayerByCoordinates',
    value: function getQueryLayerByCoordinates() {
      var _this10 = this;

      var _ref18 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          layer = _ref18.layer,
          coordinates = _ref18.coordinates;

      return new Promise(function (resolve, reject) {
        layer.query({
          coordinates: coordinates,
          mapProjection: _this10.getProjection(),
          resolution: _this10.getResolution()
        }).then(function (response) {
          return resolve(response);
        }).fail(function (e) {
          console.warn(e);reject(e);
        });
      });
    }

    //setup controls
    /*
      layout : {
        lv: <options> h : horizontal (default), v vertical
        lh: <options> h: horizontal: v vertical (default)
      }
    */

  }, {
    key: 'createMapControl',
    value: function createMapControl(type) {
      var _ref19 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          id = _ref19.id,
          visible = _ref19.visible,
          _ref19$add = _ref19.add,
          add = _ref19$add === undefined ? true : _ref19$add,
          _ref19$toggled = _ref19.toggled,
          toggled = _ref19$toggled === undefined ? false : _ref19$toggled,
          _ref19$options = _ref19.options,
          options = _ref19$options === undefined ? {} : _ref19$options;

      var control = CONTROLS[type] ? new CONTROLS[type](_extends({ type: type, toggled: toggled }, options)) : undefined;
      if (undefined === visible) {
        visible = control.isVisible ? control.isVisible() : true;
      }
      if (control) {
        this.addControl(id || type, type, control, add, visible);
      }
      return control;
    }
  }, {
    key: 'showAddLayerModal',
    value: function showAddLayerModal() {
      $('#modal-addlayer').modal('show');
      this.emit('addexternallayer');
    }
  }, {
    key: 'getCenter',
    value: function getCenter() {
      return this.getMap().getView().getCenter();
    }

    /**
     * Zoom to Feature ID
     */

  }, {
    key: 'zoomToFid',
    value: function () {
      var _ref20 = _asyncToGenerator(function* () {
        var zoom_to_fid = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
        var separator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '|';

        var _zoom_to_fid$split = zoom_to_fid.split(separator),
            _zoom_to_fid$split2 = _slicedToArray(_zoom_to_fid$split, 2),
            layerId = _zoom_to_fid$split2[0],
            fid = _zoom_to_fid$split2[1];

        if (undefined === layerId && undefined === fid) {
          return;
        }

        var layer = this.project.getLayerById(layerId);

        var _ref21 = yield _data2.default.getData('search:fids', {
          inputs: {
            layer: layer,
            fids: [fid]
          },
          outputs: {
            show: {
              loading: false,
              condition: function () {
                var _ref22 = _asyncToGenerator(function* () {
                  var _ref23 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                      _ref23$data = _ref23.data,
                      data = _ref23$data === undefined ? [] : _ref23$data;

                  if (layer.isEditable()) {
                    yield (0, _waitFor.waitFor)(function () {
                      return undefined !== layer.config.editing;
                    });
                  }
                  return !!(data[0] && data[0].features.length > 0);
                });

                function condition() {
                  return _ref22.apply(this, arguments);
                }

                return condition;
              }()
            }
          }
        }),
            _ref21$data = _ref21.data,
            data = _ref21$data === undefined ? [] : _ref21$data;

        var feature = data[0] && data[0].features[0];

        if (feature) {
          yield this.zoomToFeatures([feature]);
        }
      });

      function zoomToFid() {
        return _ref20.apply(this, arguments);
      }

      return zoomToFid;
    }()

    /**
     * Handle ztf url parameter
     *
     * @param zoom_to_features
     */

  }, {
    key: 'zoomToFeaturesUrl',
    value: function () {
      var _ref24 = _asyncToGenerator(function* () {
        var zoom_to_features = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

        try {
          var _zoom_to_features$spl = zoom_to_features.split(':'),
              _zoom_to_features$spl2 = _slicedToArray(_zoom_to_features$spl, 2),
              id = _zoom_to_features$spl2[0],
              filter = _zoom_to_features$spl2[1];

          if (!id || !filter) {
            return;
          }

          // find project layer
          var pLayer = this.project.getLayers().find(function (l) {
            return id === l.id || id === l.name || id === l.origname;
          });

          var layer = pLayer && this.project.getLayerById(pLayer.id);

          var r = pLayer && (yield _data2.default.getData('search:features', {
            inputs: {
              layer: layer,
              filter: (0, _createFilterFromString.createFilterFromString)({ layer: layer, filter: filter })
            },
            outputs: {
              show: {
                loading: false,
                condition: function () {
                  var _ref25 = _asyncToGenerator(function* () {
                    var _ref26 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                        _ref26$data = _ref26.data,
                        data = _ref26$data === undefined ? [] : _ref26$data;

                    if (layer.isEditable()) {
                      yield (0, _waitFor.waitFor)(function () {
                        return undefined !== layer.config.editing;
                      });
                    }
                    return !!(data[0] && data[0].features.length > 0);
                  });

                  function condition() {
                    return _ref25.apply(this, arguments);
                  }

                  return condition;
                }()
              }
            }
          }));

          var features = r && r.data && r.data[0] && r.data[0].features;

          if (features) {
            this.zoomToFeatures(features);
          }
        } catch (e) {
          console.warn(e);
        }
      });

      function zoomToFeaturesUrl() {
        return _ref24.apply(this, arguments);
      }

      return zoomToFeaturesUrl;
    }()
  }, {
    key: 'getMapExtent',
    value: function getMapExtent() {
      var map = this.getMap();
      return map.getView().calculateExtent(map.getSize());
    }

    /**
     * @param url
     * @param epsg cordinate referece system (since 3.8.0)
     *
     * @returns {string}
     */

  }, {
    key: 'addMapExtentUrlParameterToUrl',
    value: function () {
      var _ref27 = _asyncToGenerator(function* (url, epsg) {
        url = new URL(url);
        var changed = undefined !== epsg && epsg !== this.getEpsg();
        if (changed) {
          yield _projections2.default.registerProjection(epsg);
        }
        url.searchParams.set('map_extent', (changed ? ol.proj.transformExtent(this.getMapExtent(), this.getEpsg(), epsg) : this.getMapExtent()).toString());
        return url.toString();
      });

      function addMapExtentUrlParameterToUrl(_x27, _x28) {
        return _ref27.apply(this, arguments);
      }

      return addMapExtentUrlParameterToUrl;
    }()
  }, {
    key: 'getMapControlByType',
    value: function getMapControlByType(type) {
      // BACKOMP v3.x
      if ("string" !== typeof type) {
        type = type.type;
      }
      return (this._controls.find(function (c) {
        return type === c.type;
      }) || {}).control;
    }

    /**
     * @param id
     * @param type
     * @param control
     * @param addToMapControls
     * @param visible
     */

  }, {
    key: 'addControl',
    value: function addControl(id, type, control) {
      var _this11 = this;

      var addToMapControls = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
      var visible = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;

      this.viewer.map.addControl(control);

      control.on('toggled', function (e) {
        return _this11.emit('mapcontrol:toggled', e);
      });

      this._controls.push({ id: id, type: type, control: control, visible: visible, mapcontrol: addToMapControls && visible });

      control.on('controlclick', function (_ref28) {
        var mapcontrol = _ref28.target;

        var clickmap = !!(mapcontrol.isClickMap && mapcontrol.isClickMap());
        if (clickmap) {
          _this11._externalInteractions.forEach(function (int) {
            return int.setActive(false);
          });
        }
        _this11.controlClick(mapcontrol, { clickmap: clickmap });
      });

      var buttonControl = $(control.element).find('button');

      buttonControl.tooltip({
        placement: 'left',
        container: 'body',
        trigger: _gui2.default.isMobile() ? 'click' : 'hover'
      });

      // in case of mobile hide tooltip after click
      if (_gui2.default.isMobile()) {
        buttonControl.on('shown.bs.tooltip', function () {
          var _this12 = this;

          setTimeout(function () {
            return $(_this12).tooltip('hide');
          }, 600);
        });
      }

      if (addToMapControls && !visible) {
        control.element.style.display = "none";
      }

      if (addToMapControls) {
        $('.g3w-map-controls').append(control.element);
      }

      MAP.controls[type] = control;

      if (false === control.offline) {
        MAP.offlineids.push({ id: type, enable: control.getEnable() });
      }

      if (false === control.offline && control.getEnable()) {
        control.setEnable(_application2.default.online);
      }
    }
  }, {
    key: 'showControls',
    value: function showControls(types) {
      var _this13 = this;

      this._controls.forEach(function (c) {
        return _this13.viewer.map.removeControl(c.control);
      });
      this._controls.forEach(function (c) {
        c.visible = !types || types.indexOf(c.type) > -1 ? true : c.visible;
        if (c.visible) {
          _this13.viewer.map.addControl(c.control);
        }
      });
    }
  }, {
    key: 'getMapControls',
    value: function getMapControls() {
      return this._controls;
    }

    /**
     * Used by the following plugins: "archiweb"
     */

  }, {
    key: 'removeControlById',
    value: function removeControlById(id) {
      var _this14 = this;

      this._controls.find(function (c, i) {
        if (id === c.id) {
          _this14._controls.splice(i, 1);
          _this14.viewer.map.removeControl(c.control);
          if (c.control.hideControl) {
            c.control.hideControl();
          }
          return true;
        }
      });
    }
  }, {
    key: 'removeControl',
    value: function removeControl(type) {
      var _this15 = this;

      this._controls.find(function (c, i) {
        if (type === c.type) {
          _this15._controls.splice(i, 1);
          _this15.viewer.map.removeControl(c.control);
          if (c.control.hideControl) {
            c.control.hideControl();
          }
          return true;
        }
      });
    }

    /**
     * untoggle mapcontrol
     * @param close GUI content
     * @private
     */

  }, {
    key: '_unToggleControls',
    value: function _unToggleControls() {
      var _ref29 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref29$close = _ref29.close,
          close = _ref29$close === undefined ? true : _ref29$close;

      this._controls.forEach(function (c) {
        if (c.control.isToggled && c.control.isToggled()) {
          c.control.toggle(false);
          if (close) {
            _gui2.default.closeContent();
          }
        }
      });
    }
  }, {
    key: 'deactiveMapControls',
    value: function deactiveMapControls() {
      this._unToggleControls({ close: false });
    }

    /**
     *
     * Method to disable
     */

  }, {
    key: 'disableClickMapControls',
    value: function disableClickMapControls() {
      var bool = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      this._controls.filter(function (c) {
        return c.control.isClickMap && c.control.isClickMap();
      }).forEach(function (c) {
        c.control.isToggled() && c.control.toggle();
        c.control[bool ? 'disable' : 'enable']();
      });
    }
  }, {
    key: '_setupCustomMapParamsToLegendUrl',
    value: function _setupCustomMapParamsToLegendUrl() {
      var bool = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      if (bool) {
        var map = this.getMap();
        var size = map && map.getSize().filter(function (v) {
          return v > 0;
        }) || null;
        var bbox = size && 2 === size.length ? map.getView().calculateExtent(size) : this.project.state.initextent;
        this.getMapLayers().forEach(function (l) {
          return l.setupCustomMapParamsToLegendUrl;
        }) && l.setupCustomMapParamsToLegendUrl({
          crs: this.getEpsg(),
          // in the case of axis orientation inverted if it needs to invert the axis
          bbox: map.getView().getProjection().getAxisOrientation() === "neu" ? [bbox[1], bbox[0], bbox[3], bbox[2]] : bbox
        });
        this.emit('change-map-legend-params');
      }
    }
  }, {
    key: 'getMapLayerByLayerId',
    value: function getMapLayerByLayerId(id) {
      return this.getMapLayers().find(function (l) {
        return l.getLayerConfigs().find(function (l) {
          return id === l.getId();
        });
      });
    }
  }, {
    key: 'getMapLayers',
    value: function getMapLayers() {
      return this._layers.g3w;
    }
  }, {
    key: 'getBaseLayers',
    value: function getBaseLayers() {
      return this._layers.base;
    }
  }, {
    key: 'getMapLayerForLayer',
    value: function getMapLayerForLayer(layer) {
      return this.getMapLayers().find(function (ml) {
        return 'layer_' + layer.getMultiLayerId() === ml.getId();
      });
    }
  }, {
    key: 'getProjectLayer',
    value: function getProjectLayer(id) {
      return MAP.layers.getLayerById(id);
    }

    /**
     * @param project
     * @param width
     * @param height
     * @param { Array } map_extent since 3.10.0: in case of true, use url parameter to set view options
     * @return {{extent: *, maxResolution: number, center: *, projection: *, resolution: number}}
     * @private
     */

  }, {
    key: '_calculateViewOptions',
    value: function _calculateViewOptions() {
      var _ref30 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          project = _ref30.project,
          width = _ref30.width,
          height = _ref30.height,
          map_extent = _ref30.map_extent;

      var initextent = map_extent ? map_extent.split(',').map(function (coord) {
        return 1 * coord;
      }) : project.state.initextent;
      var extent = project.state.extent;
      return {
        extent: extent,
        projection: this.getProjection(),
        center: ol.extent.getCenter(initextent),
        maxResolution: Math.max(ol.extent.getWidth(extent) / width, ol.extent.getHeight(extent) / height), // max(xRes, yRes)
        resolution: Math.max(ol.extent.getWidth(initextent) / width, ol.extent.getHeight(initextent) / height) // max(xInitRes, yInitRes)
      };
    }
  }, {
    key: 'getMapUnits',
    value: function getMapUnits() {
      return this.state.mapUnits;
    }

    // remove all events of layersStore

  }, {
    key: '_removeEventsKeysToLayersStore',
    value: function _removeEventsKeysToLayersStore(store) {
      var id = store.getId();
      if (this._keyEvents.stores[id]) {
        this._keyEvents.stores[id].forEach(function (evt) {
          Object.entries(evt).forEach(function (_ref31) {
            var _ref32 = _slicedToArray(_ref31, 2),
                event = _ref32[0],
                key = _ref32[1];

            return store.un(event, key);
          });
        });
        delete this._keyEvents.stores[id];
      }
    }

    // register all events of layersStore and relative keys

  }, {
    key: '_setUpEventsKeysToLayersStore',
    value: function _setUpEventsKeysToLayersStore(store) {
      var _this16 = this;

      var id = store.getId();
      // check if already store a key of events
      this._keyEvents.stores[id] = [];

      //In the case of store that has layers @since 3.10.0
      store.getLayers().forEach(function (l) {
        return 'vector' === l.getType() && _this16.addLayerToMap(l.getMapLayer());
      });

      this._keyEvents.stores[id].push({
        addLayer: store.onafter('addLayer', function (l) {
          'vector' === l.getType() && _this16.addLayerToMap(l.getMapLayer());
        })
      });
      this._keyEvents.stores[id].push({
        removeLayer: store.onafter('removeLayer', function (l) {
          'vector' === l.getType() && _this16.viewer.map.removeLayer(l.getOLLayer());
        })
      });
    }

    // SETUP ALL LAYERS

  }, {
    key: '_setupAllLayers',
    value: function _setupAllLayers() {
      var _this17 = this;

      // base layers
      var blayers = (0, _getMapLayersByFilter.getMapLayersByFilter)({ BASELAYER: true });
      blayers.forEach(function (l) {
        var base = l.getMapLayer();
        _this17.registerMapLayerListeners(base);
        _this17._layers.base[l.getId()] = base;
      });

      Object.values(blayers.length ? this._layers.base : {}).reverse().forEach(function (l) {
        l.update(_this17.state, _this17.layersExtraParams);
        _this17.addLayerToMap(l);
      });

      // map layers: geolayers exclude baselayers and eventually vector layers
      var layers = (0, _getMapLayersByFilter.getMapLayersByFilter)({ BASELAYER: false, VECTORLAYER: false });

      // set map projection on each layer
      layers.forEach(function (l) {
        return l.setMapProjection(_this17.getProjection());
      });

      //store incremental value for qtimesriable layer with same multilayer id
      var cache = {};
      var mapLayers = [];

      Object.entries(
      // Group layers by multilayer property (from project config)
      // to speed up "qtimeseriesries" loading for single layers
      (0, _groupBy.groupBy)(layers, function (layer) {
        var id = layer.getMultiLayerId();
        if (layer.isQtimeseries()) {
          cache[id] = undefined === cache[id] ? 0 : cache[id] + 1;
          return id + '_' + cache[id];
        }
        return undefined === cache[id] ? id : id + '_' + (cache[id] + 1);
      })).forEach(function (_ref33) {
        var _ref34 = _slicedToArray(_ref33, 2),
            id = _ref34[0],
            layers = _ref34[1];

        var layer = layers[0] || [];
        var mapLayer = layer.getMapLayer({
          id: 'layer_' + id,
          projection: _this17.getProjection(),
          /** @since 3.9.1 */
          format: 1 === layers.length ? layer.getFormat() : null
        }, 1 === layers.length ? {} : _this17.layersExtraParams);
        layers.reverse().forEach(function (l) {
          return mapLayer.addLayer(l);
        });
        mapLayers.push(mapLayer);
        _this17.registerMapLayerListeners(mapLayer);
      });

      mapLayers.reverse().forEach(function (l) {
        _this17._layers.g3w.push(l);
        _this17.addLayerToMap(l);
      });

      this.updateMapLayers();

      // vector layers
      var vlayers = (0, _getMapLayersByFilter.getMapLayersByFilter)({ VECTORLAYER: true });
      // set map projection on each layer
      vlayers.forEach(function (l) {
        l.setMapProjection(_this17.getProjection());_this17.addLayerToMap(l.getMapLayer());
      });

      // set default layers order
      var map = this.getMap();
      map.addLayer(this.defaultsLayers.mapcenter);
      map.addLayer(this.defaultsLayers.selectionLayer);
      map.addLayer(this.defaultsLayers.highlightLayer);

      /** @since 3.11.0 - temporary layers from local storage (ref: `addlayers` map control) */
      _localforage2.default.getItem('externalLayers').then(function (externalLayers) {
        Object.entries(externalLayers || {}).forEach(function (_ref35) {
          var _ref36 = _slicedToArray(_ref35, 2),
              id = _ref36[0],
              layer = _ref36[1];

          var olLayer = new ol.layer.Vector({
            source: new ol.source.Vector({ features: new ol.format.GeoJSON().readFeatures(layer.features) })
          });
          olLayer.set('name', id);
          _this17.addExternalLayer(olLayer, _extends({}, layer.options, { zoomToExtent: false }));
        });
      });
    }
  }, {
    key: 'removeLayers',
    value: function removeLayers() {
      var _this18 = this;

      Object.keys(this._layers.base).forEach(function (id) {
        return _this18.viewer.map.removeLayer(_this18._layers.base[id].getOLLayer());
      });
      this.getMapLayers().forEach(function (l) {
        _this18.unregisterMapLayerListeners(l);_this18.viewer.map.removeLayer(l.getOLLayer());
      });
      this._layers.g3w = [];
      // remove external layers
      this._layers.external.forEach(function (layer) {
        _this18.removeExternalLayer(layer.get('name'));
      });
      this._layers.external.splice(0);
      // remove default layers
      this.defaultsLayers.mapcenter.getSource().clear();
      this.defaultsLayers.highlightLayer.getSource().clear();
      this.defaultsLayers.selectionLayer.getSource().clear();
      this.getMap().removeLayer(this.defaultsLayers.mapcenter);
      this.getMap().removeLayer(this.defaultsLayers.highlightLayer);
      this.getMap().removeLayer(this.defaultsLayers.selectionLayer);
    }

    //set ad increase layerIndex

  }, {
    key: 'setLayerZIndex',
    value: function setLayerZIndex(_ref37) {
      var layer = _ref37.layer,
          _ref37$zindex = _ref37.zindex,
          zindex = _ref37$zindex === undefined ? this.layersCount += 1 : _ref37$zindex;

      //@since 3.11.0 For editing purpose, need to be set on top (add 1000)
      zindex = zindex + (layer.get('__g3w_editable') ? 1000 : 0);
      layer.setZIndex(zindex);
      this.emit('set-layer-zindex', { layer: layer, zindex: zindex });
      return zindex;
    }

    /**
     * Add olLayer to mapLayer
     * @param layer
     */

  }, {
    key: 'addLayerToMap',
    value: function addLayerToMap(layer) {
      var olLayer = layer.getOLLayer();
      if (olLayer) {
        this.getMap().addLayer(olLayer);
      }
    }

    /**
     * Used by the following plugins: "cdu"
     */

  }, {
    key: 'createMapLayer',
    value: function createMapLayer(layer) {
      layer.setMapProjection(this.getProjection());
      var mapLayer = layer.getMapLayer({
        id: 'layer_' + layer.getMultiLayerId(),
        projection: this.getProjection()
      }, this.layersExtraParams);
      mapLayer.addLayer(layer);
      return mapLayer;
    }

    /**
     * Used by the following plugins: "qtimeseries"
     *
     * Update MapLayer
     *
     * @param layer
     * @param options
     * @param options.force
     * @param options.layerId in case of filtertoken change on a single layer of TOC
     * @param { Boolean } showSpinner show or not spinner
     */

  }, {
    key: 'updateMapLayer',
    value: function updateMapLayer(layer) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { force: false };

      var _ref38 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
          _ref38$showSpinner = _ref38.showSpinner,
          showSpinner = _ref38$showSpinner === undefined ? true : _ref38$showSpinner;

      // if force to add g3w_time parameter to force request of map layer from server
      if (options.force) {
        options.g3w_time = Date.now();
      }
      if (showSpinner !== layer.showSpinnerWhenLoading) {
        layer.showSpinnerWhenLoading = showSpinner;
        if (showSpinner) {
          layer.on('loadstart', this.onLayerLoadStart);
          layer.on('loadend', this.onLayerLoadEnd);
          layer.on('loaderror', this.onLayerLoadError);
        } else {
          layer.off('loadstart', this.onLayerLoadStart);
          layer.off('loadend', this.onLayerLoadEnd);
          layer.off('loaderror', this.onLayerLoadError);
        }
      }
      layer.update(this.state, options);
      return layer;
    }

    // run update function on each mapLayer

  }, {
    key: 'updateMapLayers',
    value: function updateMapLayers() {
      var _this19 = this;

      var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      this.getMapLayers().forEach(function (l) {
        return _this19.updateMapLayer(l, opts);
      });
      Object.values(this.getBaseLayers()).forEach(function (l) {
        return l.update(_this19.state, _this19.layersExtraParams);
      });
    }

    // register map Layer listeners of creation

  }, {
    key: 'registerMapLayerListeners',
    value: function registerMapLayerListeners(layer) {
      var _this20 = this;

      var projectLayer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      layer.on('loadstart', this.onLayerLoadStart);
      layer.on('loadend', this.onLayerLoadEnd);
      layer.on('loaderror', this.onLayerLoadError);
      // listen change filter token
      if (projectLayer) {
        (Array.isArray(layer.layers) ? layer.layers : []).forEach(function (l) {
          l.onbefore('change', function () {
            return _this20.updateMapLayer(layer, { force: true });
          });
          //pass layerId to change only layer @since 3.11.0
          l.on('filtertokenchange', function (_ref39) {
            var layerId = _ref39.layerId;
            _this20.updateMapLayer(layer, { force: true, layerId: layerId });
          });
        });
      }
    }

    // unregister listeners of mapLayers creation

  }, {
    key: 'unregisterMapLayerListeners',
    value: function unregisterMapLayerListeners(layer) {
      var projectLayer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      layer.un('loadstart', this.onLayerLoadStart);
      layer.un('loadend', this.onLayerLoadEnd);
      layer.un('loaderror', this.onLayerLoadError);
      // try to remove layer filter token
      if (projectLayer) {
        (Array.isArray(layer.layers) ? layer.layers : []).forEach(function (l) {
          l.un('change');
          l.removeEvent('filtertokenchange');
        });
      }
    }
  }, {
    key: 'setTarget',
    value: function setTarget(elId) {
      this.target = elId;
    }
  }, {
    key: 'getCurrentToggledMapControl',
    value: function getCurrentToggledMapControl() {
      return (this._controls.find(function (c) {
        return c.control && c.control.isToggled && c.control.isToggled();
      }) || {}).control;
    }

    /**
     * close: param to close eventually right content open
     * @param interaction
     * @param options is an object contain: {
     *   active: If set new interaction active or not
     *   active: If set new interaction active or not
     *   close: if eventually close GUI Content (es. result right content)
     * }
     * return object having current toggled control if there is a toggled mapcontrol
     */

  }, {
    key: 'addInteraction',
    value: function addInteraction(interaction) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { active: true, close: true };
      var _options$active = options.active,
          active = _options$active === undefined ? true : _options$active;

      var control = this.getCurrentToggledMapControl();
      var toggled = control && control.isToggled && control.isToggled() || false;
      var untoggleMapControls = control && control.isClickMap ? control.isClickMap() : true;
      if (untoggleMapControls && active) {
        this._unToggleControls(options);
      }
      this.getMap().addInteraction(interaction);
      interaction.setActive(active);
      this._externalInteractions.push(interaction);
      return {
        control: control,
        toggled: toggled // return current toggled map control if toggled
      };
    }
  }, {
    key: 'removeInteraction',
    value: function removeInteraction(interaction) {
      if (interaction) {
        interaction.setActive(false);
      }
      this.viewer.map.removeInteraction(interaction);
      this._externalInteractions = this._externalInteractions.filter(function (_interaction) {
        return interaction !== _interaction;
      });
    }
  }, {
    key: '_watchInteraction',
    value: function _watchInteraction(interaction) {
      var _this21 = this;

      interaction.on('change:active', function (e) {
        if (e.target instanceof ol.interaction.Pointer && e.target.getActive()) {
          _this21.emit('mapcontrol:active', e.target);
        }
      });
    }

    /**
     * Used by the following plugins: "qtimeseries"
     *
     * Show map Info
     * @param info
     */

  }, {
    key: 'showMapInfo',
    value: function showMapInfo() {
      var _ref40 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          info = _ref40.info,
          style = _ref40.style;

      this.state.map_info.info = info;
      this.state.map_info.style = style || this.state.map_info.style;
    }

    /**
     * @param { Array } coordinate
     * @param { Number } zoom
     */

  }, {
    key: 'zoomTo',
    value: function zoomTo(coordinate) {
      var zoom = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 6;

      var view = this.viewer.map.getView();
      view.setCenter(coordinate);
      view.setZoom(zoom);
    }
  }, {
    key: 'goTo',
    value: function goTo(coordinates, zoom) {
      var animate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      var view = this.viewer.map.getView();
      zoom = zoom || 6;

      if (animate) {
        view.animate({ duration: 300, center: coordinates }, zoom ? { zoom: zoom, duration: 300 } : { duration: 300, resolution: view.getResolution() });
      } else {
        view.setCenter(coordinates);
      }

      if (zoom && !animate) {
        view.setZoom(zoom);
      }
    }

    /**
     * Set map center to coordinate at resolution
     *
     * @param { Array } coordinates
     * @param resolution
     * @param { boolean } animate
     */

  }, {
    key: 'goToRes',
    value: function () {
      var _ref41 = _asyncToGenerator(function* (coordinates, resolution) {
        var _this22 = this;

        var animate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;


        resolution = resolution || this.viewer.map.getView().getResolution();

        yield new Promise(function (res) {

          _this22.viewer.map.getView().once('change:center', function () {
            return setTimeout(res, 500);
          });

          if (animate) {
            _this22.viewer.map.getView().animate({ duration: 200, center: coordinates }, { duration: 200, resolution: resolution });
          } else {
            _this22.viewer.map.getView().setCenter(coordinates);
            _this22.viewer.map.getView().setResolution(resolution);
          }
        });
      });

      function goToRes(_x45, _x46) {
        return _ref41.apply(this, arguments);
      }

      return goToRes;
    }()
  }, {
    key: 'getGeometryAndExtentFromFeatures',
    value: function getGeometryAndExtentFromFeatures() {
      var features = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      var extent = void 0;
      var gtype = void 0;
      var geometry = void 0;
      var coordinates = [];
      features.filter(function (f) {
        return f.getGeometry ? f.getGeometry() : f.geometry;
      }).forEach(function (f) {
        var geom = f.getGeometry ? f.getGeometry() : f.geometry;
        var is_ol_geom = geom instanceof ol.geom.Geometry;
        var f_ext = is_ol_geom ? [].concat(_toConsumableArray(geom.getExtent())) : f.bbox;
        extent = ol.extent.extend(undefined === extent ? f_ext : extent, f_ext);
        gtype = gtype ? gtype : is_ol_geom ? geom.getType() : geom.type;
        var coords = is_ol_geom ? geom.getCoordinates() : geom.coordinates;
        coordinates.push(coords);
      });

      //check if features have geometry
      if (coordinates.length > 0) {
        var is_multi = gtype.includes('Multi');
        try {
          geometry = new ol.geom[is_multi ? gtype : 'Multi' + gtype](is_multi ? coordinates.flat() : coordinates);
          extent = undefined === extent ? geometry.getExtent() : extent;
        } catch (e) {
          console.warn(e);
        }
      }

      return {
        extent: extent,
        geometry: geometry
      };
    }
  }, {
    key: 'highlightFeatures',
    value: function highlightFeatures(features) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var _getGeometryAndExtent = this.getGeometryAndExtentFromFeatures(features),
          geometry = _getGeometryAndExtent.geometry;
      // force zoom false


      options.zoom = false;
      this.highlightGeometry(geometry, options);
    }
  }, {
    key: 'zoomToGeometry',
    value: function zoomToGeometry(geometry) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { highlight: false };

      var extent = geometry && geometry.getExtent();
      if (options.highlight && extent) {
        options.highLightGeometry = geometry;
      }
      return this.zoomToExtent(extent, options);
    }
  }, {
    key: 'zoomToFeatures',
    value: function zoomToFeatures(features) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { highlight: false };

      var _getGeometryAndExtent2 = this.getGeometryAndExtentFromFeatures(features),
          geometry = _getGeometryAndExtent2.geometry,
          extent = _getGeometryAndExtent2.extent;

      if (options.highlight && extent) {
        options.highLightGeometry = geometry;
      }
      return this.zoomToExtent(extent, options);
    }

    /**
     * @param   { ol.extent }   extent
     * @param   { Object }      options
     * @param   { boolean }     options.force
     * @param   { ol.geometry } options.highLightGeometry
     *
     * @returns { Promise<void> }
     */

  }, {
    key: 'zoomToExtent',
    value: function () {
      var _ref42 = _asyncToGenerator(function* (extent) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};


        if (!extent) {
          return Promise.resolve();
        }

        var map = this.getMap();

        var resolution = void 0;

        // if outside project extent, return max resolution
        if (false === ol.extent.containsExtent(this.project.state.extent, extent)) {
          resolution = map.getView().getResolutionForExtent(this.project.state.extent, map.getSize());
        }

        // retrieve resolution from given `extent`
        else if (true === options.force) {
            resolution = map.getView().getResolutionForExtent(extent, map.getSize()); // resolution of request extent
          }

          // calculate main resolutions from map
          else {
              var curr = map.getView().getResolution();
              // max resolution of the map
              resolution = Math.max(map.getView().getResolutionForExtent(extent, map.getSize()), (0, _getResolutionFromScale.getResolutionFromScale)(MAP.maxZoom, this.getMapUnits()));
              resolution = curr < resolution && curr > resolution ? curr : resolution;
            }

        yield this.goToRes(ol.extent.getCenter(extent), resolution);

        if (options.highLightGeometry) {
          yield this.highlightGeometry(options.highLightGeometry, { zoom: false, duration: options.duration });
        }
      });

      function zoomToExtent(_x52) {
        return _ref42.apply(this, arguments);
      }

      return zoomToExtent;
    }()
  }, {
    key: 'goToBBox',
    value: function goToBBox(bbox) {
      var epsg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.getEpsg();

      bbox = epsg === this.getEpsg() ? bbox : ol.proj.transformExtent(bbox, epsg, this.getEpsg());
      // compare bbox extent with a project max extent
      this.viewer.fit(ol.extent.containsExtent(this.project.state.extent, bbox) ? bbox : this.project.state.extent);
    }

    /**
     * @since 3.11.0
     */

  }, {
    key: '_fit',
    value: function _fit(geometry) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var view = this.viewer.map.getView();
      var animate = 'boolean' === typeof options.animate ? options.animate : true;

      if (animate) {
        view.animate({ duration: 200, center: view.getCenter() });
        view.animate({ duration: 200, resolution: view.getResolution() });
      }

      delete options.animate; // non lo passo al metodo di OL3 perché è un'opzione interna

      view.fit(geometry, _extends({}, options, {
        constrainResolution: undefined !== options.constrainResolution ? options.constrainResolution : true,
        size: this.viewer.map.getSize()
      }));
    }

    /*
    * geometries = array of geometries
    * action: add, clear, remove :
    *   - add: feature/features to selectionLayer. If selectionLayer doesn't exist, create a new vector layer.
    *   - clear: remove selectionLayer
    *   - remove: remove feature from selection layer. If no more feature is in selectionLayer, it will be removed
    * */

  }, {
    key: 'setSelectionFeatures',
    value: function setSelectionFeatures() {
      var action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'add';
      var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (opts.color) {
        this.defaultsLayers._style.selectionLayer = { color: opts.color };
      }
      var source = this.defaultsLayers.selectionLayer.getSource();
      switch (action) {
        case 'add':
          //In case of add need to set selection style
          opts.feature.setStyle((0, _createSelectedStyle.createSelectedStyle)({
            geometryType: opts.feature.getGeometry().getType(),
            color: this.defaultsLayers._style.selectionLayer.color,
            fill: true
          }));
          source.addFeature(opts.feature);
          break;
        case 'remove':
          source.removeFeature(opts.feature);break;
        case 'update':
          source.getFeatureById(opts.feature.getId()).setGeometry(opts.feature.getGeometry());break;
        case 'clear':
          source.clear();break;
      }
    }

    /**
     * @since 3.11.0
     */

  }, {
    key: 'toggleSelection',
    value: function toggleSelection() {
      var _this23 = this;

      var visible = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var layerId = arguments[1];

      //take in account that of layer id is specified, need to set only
      // features related to layer visible or not
      if (layerId) {
        this.defaultsLayers.selectionLayer.getSource().getFeatures().filter(function (f) {
          return layerId === f.__layerId;
        }).forEach(function (f) {
          return f.setStyle(visible ? (0, _createSelectedStyle.createSelectedStyle)({
            geometryType: f.getGeometry().getType(),
            color: _this23.defaultsLayers._style.selectionLayer.color,
            fill: true
          }) : new ol.style.Style(null));
        });
      } else {
        this.defaultsLayers.selectionLayer.setVisible(visible);
      }
    }

    /**
     *
     * @param { ol.geom.Geometry | * } geometryObj
     * @param { Object } options
     * @param { boolean } options.zoom
     * @param { boolean } options.highlight
     * @param options.style
     * @param options.color
     *
     * @returns { Promise<any> }
     */

  }, {
    key: 'highlightGeometry',
    value: function () {
      var _ref43 = _asyncToGenerator(function* (geometryObj) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        var duration = options.duration || 2000;
        var hlayer = this.defaultsLayers.highlightLayer;
        var hide = 'function' === typeof options.hide ? options.hide : null;
        var highlight = 'boolean' === typeof options.highlight ? options.highlight : true;
        var zoom = 'boolean' === typeof options.zoom ? options.zoom : true;
        var geometry = geometryObj instanceof ol.geom.Geometry ? geometryObj : new ol.format.GeoJSON().readGeometry(geometryObj);

        this.clearHighlightGeometry();
        this.defaultsLayers._style.highlightLayer = { color: options.color };

        if (zoom) {
          yield this.zoomToExtent(geometry.getExtent());
        }

        if (!highlight) {
          return;
        }

        if (options.style) {
          hlayer.setStyle(options.style);
        }

        hlayer.getSource().addFeature(new ol.Feature({ geometry: geometry }));

        return new Promise(function () {
          var _ref44 = _asyncToGenerator(function* (resolve) {

            var cb = function cb() {
              hlayer.getSource().clear();
              // set default style
              if (options.style) {
                hlayer.setStyle(function (feat) {
                  return [(0, _createSelectedStyle.createSelectedStyle)({ geometryType: feat.getGeometry().getType(), color: options.color, fill: true })];
                });
              }
              if (!hide) {
                MAP.animatingHighlight = false;
              }
              resolve();
            };

            if (hide) {
              hide(cb);
            }

            if (duration && duration !== Infinity && !hide) {
              MAP.animatingHighlight = true;
              setTimeout(cb, duration);
            }
          });

          return function (_x60) {
            return _ref44.apply(this, arguments);
          };
        }());
      });

      function highlightGeometry(_x59) {
        return _ref43.apply(this, arguments);
      }

      return highlightGeometry;
    }()
  }, {
    key: 'clearHighlightGeometry',
    value: function clearHighlightGeometry() {
      if (!MAP.animatingHighlight) {
        this.defaultsLayers.highlightLayer.getSource().clear();
      }
      // reset default layer style
      this.defaultsLayers._style.highlightLayer = { color: undefined };
    }

    /**
     * Force to referesh a map
     * @param options
     */

  }, {
    key: 'refreshMap',
    value: function refreshMap() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { force: true };

      this.updateMapLayers(options);
    }

    // called when layout (window) resizes

  }, {
    key: 'layout',
    value: function layout(_ref45) {
      var width = _ref45.width,
          height = _ref45.height;

      var el = document.getElementById(this.target);

      if (el) {
        el.style.height = height + 'px';
        el.style.width = width + 'px';
      }

      var is_hidden = width <= 0 || height <= 0;
      var has_viewer = !!this.viewer;

      if (has_viewer && !is_hidden) {
        this.getMap().updateSize();
        this.state.hidemaps.forEach(function (h) {
          return h.map.updateSize();
        });
        this.state.bbox = this.getMapBBOX();
        this.state.resolution = this.viewer.getResolution();
        this.state.center = this.viewer.getCenter();
        this.updateMapLayers();
      }

      if (!has_viewer) {
        this.setupViewer(width, height);
      }

      this.setHidden(is_hidden);
    }
  }, {
    key: 'getMapBBOX',
    value: function getMapBBOX() {
      return this.viewer.map.getView().calculateExtent(this.viewer.map.getSize());
    }
  }, {
    key: 'setInnerGreyCoverBBox',
    value: function setInnerGreyCoverBBox() {
      var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var map = this.viewer.map;
      var lowerLeft = void 0;
      var upperRight = void 0;

      if (opts.inner) {
        switch (opts.type) {
          case 'pixel':
            lowerLeft = [opts.inner[0], opts.inner[1]];
            upperRight = [opts.inner[2], opts.inner[3]];
            break;
          case 'coordinate':
          default:
            lowerLeft = map.getPixelFromCoordinate([opts.inner[0], opts.inner[1]]);
            upperRight = map.getPixelFromCoordinate([opts.inner[2], opts.inner[3]]);
            break;
        }
        this._drawShadow.inner[0] = lowerLeft[0] * ol.has.DEVICE_PIXEL_RATIO; // x_min
        this._drawShadow.inner[1] = lowerLeft[1] * ol.has.DEVICE_PIXEL_RATIO; // y_min
        this._drawShadow.inner[2] = upperRight[0] * ol.has.DEVICE_PIXEL_RATIO; // x_max
        this._drawShadow.inner[3] = upperRight[1] * ol.has.DEVICE_PIXEL_RATIO; // y_max
      }

      this._drawShadow.scale = [null, undefined].includes(opts.scale) ? this._drawShadow.scale || 1 : opts.scale;
      this._drawShadow.rotation = [null, undefined].includes(opts.rotation) ? this._drawShadow.rotation || 0 : opts.rotation;

      if (this._drawShadow.outer) {
        map.render();
      }
    }

    // grey map precompose mapcompose

  }, {
    key: 'startDrawGreyCover',
    value: function startDrawGreyCover(message) {
      var _this24 = this;

      // after rendering the layer, restore the canvas context
      var map = this.viewer.map;
      var x_min = void 0,
          x_max = void 0,
          y_min = void 0,
          y_max = void 0,
          rotation = void 0,
          scale = void 0;
      this.stopDrawGreyCover();
      this._drawShadow.listener = map.on('postcompose', function (e) {
        var ctx = e.context;
        var size = _this24.getMap().getSize();
        // Inner polygon must be counter-clockwise
        var height = size[1] * ol.has.DEVICE_PIXEL_RATIO;
        var width = size[0] * ol.has.DEVICE_PIXEL_RATIO;
        _this24._drawShadow.outer = [0, 0, width, height];
        ctx.restore();
        ctx.beginPath();
        // Outside polygon must be clockwise
        ctx.moveTo(0, 0);
        ctx.lineTo(width, 0);
        ctx.lineTo(width, height);
        ctx.lineTo(0, height);
        ctx.lineTo(0, 0);
        ctx.closePath();
        // end external bbox (map is cover)
        if (_this24._drawShadow.inner.length) {
          ctx.save();
          x_min = _this24._drawShadow.inner[0];
          y_min = _this24._drawShadow.inner[3];
          x_max = _this24._drawShadow.inner[2];
          y_max = _this24._drawShadow.inner[1];
          rotation = _this24._drawShadow.rotation;
          scale = _this24._drawShadow.scale;
          // Inner polygon must be counter-clockwise antiorario
          ctx.translate((x_max + x_min) / 2, (y_max + y_min) / 2);
          ctx.rotate(rotation * Math.PI / 180);
          ctx.moveTo(-((x_max - x_min) / 2), (y_max - y_min) / 2);
          ctx.lineTo((x_max - x_min) / 2, (y_max - y_min) / 2);
          ctx.lineTo((x_max - x_min) / 2, -((y_max - y_min) / 2));
          ctx.lineTo(-((x_max - x_min) / 2), -((y_max - y_min) / 2));
          ctx.lineTo(-((x_max - x_min) / 2), (y_max - y_min) / 2);
          ctx.closePath();
          // end inner bbox
        }
        ctx.fillStyle = 'rgba(0, 5, 25, 0.40)';
        ctx.fill();
        if (message) {
          ctx.font = "bold 25px Arial";
          ctx.fillStyle = "#ffffff";
          ctx.textAlign = "center";
          message.split('\n').forEach(function (m, i) {
            return ctx.fillText(m, width / 2, height / 2 + 30 * i);
          });
        }
        ctx.restore();
      });
    }
  }, {
    key: 'stopDrawGreyCover',
    value: function stopDrawGreyCover() {
      if (this._drawShadow.listener) {
        ol.Observable.unByKey(this._drawShadow.listener);
        // reset inner draw shadow
        if (this._drawShadow.inner.length) {
          this._drawShadow = {
            type: 'coordinate',
            outer: [],
            inner: [],
            scale: null,
            rotation: null
          };
        }
        this._drawShadow.listener = null;
      }
      this.getMap().render();
    }

    /**
     * Remove external layer
     *
     * @param name
     */

  }, {
    key: 'removeExternalLayer',
    value: function removeExternalLayer(name) {
      var _this25 = this;

      var layer = this.getLayerByName(name);
      var type = layer._type || 'vector';

      _gui2.default.getService('queryresults').unregisterVectorLayer(layer);
      _gui2.default.getService('catalog').removeExternalLayer({ name: name, type: type });

      this.viewer.map.removeLayer(layer);

      if ('vector' === type) {
        this._keyEvents.unwatches[name].forEach(function (unWatch) {
          return unWatch();
        });
        delete this._keyEvents.unwatches[name];
      }

      /** @since 3.11.0 - temporary layers from local storage (ref: `addlayers` map control) */
      if ('vector' === type) {
        _localforage2.default.getItem('externalLayers').then(function (externalLayers) {
          externalLayers = externalLayers || {};
          if (name in externalLayers) {
            delete externalLayers[name];
          }
          _localforage2.default.setItem('externalLayers', externalLayers);
        });
      }

      if ('vector' === type) {
        this._layers.external_vector = this._layers.external_vector.filter(function (l) {
          if (name !== l.name) {
            return true;
          }
          Object.values(MAP.controls).forEach(function (c) {
            return c.onRemoveExternalLayer && c.onRemoveExternalLayer(l);
          });
          if (l === MAP.selectedLayer) {
            MAP.selectedLayer = null;
          }
        });
      }

      if ('wms' === type) {
        this._layers.external_wms = this._layers.external_wms.filter(function (l) {
          if (l.getId() !== layer.id) {
            return true;
          }
          _this25.unregisterMapLayerListeners(l, layer.projectLayer);
        });
      }

      this._layers.external = this._layers.external.filter(function (l) {
        return l.get('id') !== layer.get('id');
      });

      this.unloadExternalLayer(layer);

      this.emit('remove-external-layer', name);
    }

    /**
     * @TODO deprecate in favour of `getExternalLayers`
     *
     * @since 3.11.0
     */

  }, {
    key: 'getLegacyExternalLayers',
    value: function getLegacyExternalLayers() {
      return this._layers.external_vector;
    }

    /**
     * Return external layers added to map
     * @param {String} type 'vector' or 'wms' @since 3.11.0
     * @returns {[]|*[]|T[]}
     */

  }, {
    key: 'getExternalLayers',
    value: function getExternalLayers(type) {
      return undefined === type ? this._layers.external : this._layers.external.filter(function (l) {
        return type === l._type;
      });
    }

    /**
     * Add an external layer to the map (eg. ZIP, KMZ, GPX, ...)
     *
     * @param { ol.layer.Vector | ol.layer.Image | unknown } externalLayer
     * @param { Object }  options
     * @param { unknown } options.position
     * @param { number }  options.opacity
     * @param { boolean } options.visible
     * @param { unknown } options.crs
     * @param { unknown } options.type
     * @param { unknown } options.download
     * @param { string }  options.downloadUrl (since 3.8.3) an alternate external server url where to perfom download.
     * @param { boolean }  options.persistent (since 3.11.0) whether to save layer into local storage (ie. web sessions).
     *
     * @returns { Promise<unknown> }
     */

  }, {
    key: 'addExternalLayer',
    value: function () {
      var _ref46 = _asyncToGenerator(function* (externalLayer) {
        var _this26 = this;

        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};


        //@since 3.11.0 Get original layer passed to method. It used for wms layer to register load/start/end/error event
        var _layer = externalLayer;
        // extract OL layer from a G3W layer
        var olLayer = externalLayer.getOLLayer ? externalLayer.getOLLayer() : externalLayer;

        if (olLayer !== externalLayer) {
          olLayer.set('id', externalLayer.getId());
          olLayer.set('name', externalLayer.getId());
        }

        externalLayer = olLayer;

        var vectorLayer = void 0;

        options.position = undefined === options.position ? 'top' : options.position;
        options.opacity = undefined === options.opacity ? 1 : options.opacity;
        options.visible = undefined === options.visible || options.visible;
        options.persistent = undefined === options.persistent || options.persistent;

        // vector layer
        if (externalLayer instanceof ol.layer.Vector) {

          externalLayer.set('id', externalLayer.get('id') || (0, _getUniqueDomId.getUniqueDomId)());

          vectorLayer = externalLayer;
          vectorLayer.filter = { // used by `selection` for query result purpose ?
            active: false // UNUSED - it means not yet implemented?
          };
          vectorLayer.selection = {
            active: false,
            features: []
          };

          if (options.color) {
            vectorLayer.setStyle(Object.assign(function (feat) {
              options.color = options.color.rgba ? 'rgba(' + [options.color.rgba.r, options.color.rgba.g, options.color.rgba.b, options.color.rgba.a].join() + ')' : options.color;
              var geometryType = feat.getGeometry().getType();
              var color = options.color;

              var style = void 0;
              if ((0, _isPointGeometryType.isPointGeometryType)(geometryType)) {
                // Point
                style = new ol.style.Style({
                  image: new ol.style.Circle({
                    fill: new ol.style.Fill({ color: color }),
                    stroke: new ol.style.Stroke({ color: color, width: 1 }),
                    radius: 5
                  })
                });
              } else if ((0, _isLineGeometryType.isLineGeometryType)(geometryType)) {
                // Line
                style = new ol.style.Style({
                  stroke: new ol.style.Stroke({ color: color, width: 3 })
                });
              } else if ((0, _isPolygonGeometryType.isPolygonGeometryType)(geometryType)) {
                // Polygon
                style = new ol.style.Style({
                  fill: new ol.style.Fill({ color: 'rgba(255,255,255,0.5)' }),
                  stroke: new ol.style.Stroke({ color: color, width: 3 })
                });
              } else {
                console.warn('invalid geometry type: ', geometryType);
              }
              if (options.field) {
                style.setText(new ol.style.Text({
                  text: '' + feat.get(options.field),
                  font: 'bold',
                  scale: 2,
                  offsetY: 15,
                  fill: new ol.style.Fill({ color: options.color }),
                  stroke: new ol.style.Stroke({ color: '#FFF', width: 2 })
                }));
              }
              return style;
            }, { _g3w_options: options }));
          }

          var color = void 0;
          try {
            var style = externalLayer.getStyle();
            color = style._g3w_options ? style._g3w_options.color : 'blue'; //setted by geo utils create style function
          } catch (e) {
            console.warn(e);
          }

          externalLayer = {
            id: externalLayer.get('id'),
            name: vectorLayer.get('name') || vectorLayer.get('id'),
            projectLayer: false,
            title: vectorLayer.get('name') || vectorLayer.get('id'),
            removable: true,
            external: true,
            crs: options.crs,
            type: options.type,
            _type: 'vector',
            visible: options.visible,
            checked: true,
            position: options.position,
            opacity: options.opacity,
            color: color || 'blue',
            filter: vectorLayer.filter,
            selection: vectorLayer.selection,
            /** @since 3.8.0 */
            tochighlightable: false,
            download: options.download || false,
            /**
             * An alternate (external) server url where to perfom download.
             *
             * @example
             *
             * ```js
             * GUI.getService('map').addExternalLayer(layer, {
             *   type: 'geojson',
             *   downloadUrl:  _<URL WHERE DOWNLOAD FILE>_
             * });
             * ```
             *
             * @since 3.8.3
             */
            downloadUrl: options.downloadUrl
          };
        }

        // image layer
        if (externalLayer instanceof ol.layer.Image) {
          externalLayer.id = externalLayer.get('id');
          externalLayer.removable = true;
          externalLayer.projectLayer = false;
          externalLayer.name = externalLayer.get('name');
          externalLayer.title = externalLayer.get('name');
          externalLayer._type = 'wms';
          externalLayer.opacity = options.opacity;
          externalLayer.position = options.position;
          externalLayer.external = true;
          externalLayer.checked = options.visible;
        }

        // skip when another layer with the same name was already added
        if (this.getLayerByName(externalLayer.name)) {
          _gui2.default.notify.warning("layer_is_added", false);
        }

        var type = (externalLayer._type || externalLayer.type || '').toLowerCase().trim('').trim();

        var layer = {
          'vector': vectorLayer,
          'wms': externalLayer
        }[type];

        // skip if is not a valid layer
        if (!layer) {
          console.warn('layer type: ', type, externalLayer);
          return Promise.reject('not a valid layer');
        }

        var features = 'vector' === type && layer.getSource().getFeatures() || [];
        var extent = 'vector' === type && layer.getSource().getExtent() || [];

        // add id value
        features.forEach(function (f, i) {
          return f.setId(i);
        });

        if (features.length) {
          externalLayer.geometryType = features[0].getGeometry().getType();
          externalLayer.selected = false;
        }

        if (extent.length) {
          externalLayer.bbox = { minx: extent[0], miny: extent[1], maxx: extent[2], maxy: extent[3] };
        }

        layer.set('position', options.position);
        layer.setOpacity(options.opacity);
        layer.setVisible(options.visible);

        /** @TODO use a common parent class (project/external layers) */
        externalLayer.set = externalLayer.set || function (a, d) {
          return externalLayer[a] = d;
        };
        externalLayer.get = externalLayer.get || function (a) {
          return externalLayer[a];
        };
        externalLayer.getId = externalLayer.getId || function () {
          return externalLayer.id;
        };
        externalLayer.getName = externalLayer.getName || function () {
          return externalLayer.name;
        };
        externalLayer.getGeometryType = externalLayer.getGeometryType || function () {
          return externalLayer.geometryType;
        };
        externalLayer.setTocHighlightable = externalLayer.setTocHighlightable || function (h) {
          return externalLayer.tochighlightable = h;
        };
        externalLayer.getTocHighlightable = externalLayer.getTocHighlightable || function () {
          return externalLayer.tochighlightable;
        };
        externalLayer.isSelected = externalLayer.isSelected || function () {
          return externalLayer.selected;
        };
        externalLayer.setSelected = externalLayer.setSelected || function (s) {
          return externalLayer.selected = s;
        };
        externalLayer.isQueryable = externalLayer.isQueryable || function () {
          return !!vectorLayer;
        };
        externalLayer.isVisible = externalLayer.isVisible || function () {
          if (vectorLayer) {
            externalLayer.visible = vectorLayer.getVisible();
          }
          return externalLayer.visible;
        };
        externalLayer.setVisible = externalLayer.setVisible || function (v) {
          if (vectorLayer) {
            vectorLayer.setVisible(v);
          }
          externalLayer.visible = v;
        };

        this.viewer.map.addLayer(layer);

        this._layers.external.push(layer);

        if ('vector' === type) {
          this._layers.external_vector.push(externalLayer);
        }

        // register and dispatch layer add event
        if ('wms' === type) {
          this._layers.external_wms.push(externalLayer);
          this.registerMapLayerListeners(_layer, false);
        }

        if (vectorLayer && false !== options.persistent) {
          _localforage2.default.getItem('externalLayers').then(function (externalLayers) {
            _localforage2.default.setItem('externalLayers', _extends({}, externalLayers || {}, _defineProperty({}, vectorLayer.get('name'), {
              features: new ol.format.GeoJSON().writeFeatures(vectorLayer.getSource().getFeatures()),
              options: options
            })));
          });
        }
        _gui2.default.getService('catalog').addExternalLayer({ layer: externalLayer, type: type });
        // invoke `onAddExternalLayer` on each map control
        if ('vector' === type) {
          //add to query result only vector layer
          _gui2.default.getService('queryresults').registerVectorLayer(layer);
          this._keyEvents.unwatches[externalLayer.name] = [];
          Object.values(MAP.controls).forEach(function (c) {
            return c.onAddExternalLayer && c.onAddExternalLayer({ layer: externalLayer, unWatches: _this26._keyEvents.unwatches[externalLayer.name] });
          });
        }

        if (extent && options.zoomToExtent) {
          this.viewer.map.getView().fit(extent);
        }

        this.loadExternalLayer(layer);

        return layer;
      });

      function addExternalLayer(_x64) {
        return _ref46.apply(this, arguments);
      }

      return addExternalLayer;
    }()
  }, {
    key: 'getCookie',
    value: function getCookie(name) {
      Vue.cookie.get(name);
    }

    /**
     * @param { unknown | string | null } layer
     *
     * @since 3.11.0
     */

  }, {
    key: 'selectLayer',
    value: function selectLayer(layer) {
      var id = 'string' === typeof layer ? layer : layer && layer.getId();

      // toggle previous selection
      if (MAP.selectedLayer && id === MAP.selectedLayer.getId()) {
        id = null;
      }

      layer = (0, _getCatalogLayerById.getCatalogLayerById)(id) || this.getLegacyExternalLayers().find(function (l) {
        return id === l.getId();
      });

      // select layer by id
      (0, _getCatalogLayers.getCatalogLayers)().concat(this.getLegacyExternalLayers()).forEach(function (l) {
        return l.setSelected(l.getId() === id);
      });

      MAP.selectedLayer = layer && layer.isSelected() ? layer : null;

      Object.values(MAP.controls).forEach(function (c) {
        return c.onSelectLayer && c.onSelectLayer(MAP.selectedLayer);
      });
    }

    /**
     * @since 3.11.0
     */

  }, {
    key: 'getSelectedLayer',
    value: function getSelectedLayer() {
      return MAP.selectedLayer;
    }
  }]);

  return MapService;
}(_g3wObject2.default);

/** @since 3.8.0 */


_application4.default.onbefore('offline', function () {
  return MAP.offlineids.forEach(function (c) {
    c.enable = MAP.controls[c.id].getEnable();MAP.controls[c.id].setEnable(false);
  });
});

/** @since 3.8.0 */
_application4.default.onbefore('online', function () {
  return MAP.offlineids.forEach(function (_ref47) {
    var id = _ref47.id,
        enable = _ref47.enable;
    return MAP.controls[id].setEnable(enable);
  });
});

var MapLayersStoresRegistry = exports.MapLayersStoresRegistry = MAP.layers;

exports.default = {

  MapService: MapService,

  MapLayersStoresRegistry: MapLayersStoresRegistry
};

},{"components/MapControlGeocoding.vue":116,"components/MapControlZoomHistory.vue":117,"g3w-object":163,"localforage":23,"map/controls/geolocationcontrol":177,"map/controls/interactioncontrol":178,"map/controls/measurecontrol":179,"map/controls/queryby":180,"map/controls/scalecontrol":181,"map/controls/screenshotcontrol":182,"map/controls/streetviewcontrol":183,"map/interactions/pickcoordinatesinteraction":184,"map/layers/imagelayer":189,"map/layers/vectorlayer":193,"services/application":205,"services/data":206,"services/gui":207,"store/application":212,"store/plugins":213,"store/projections":214,"utils/createFilterFromString":226,"utils/createSelectedStyle":229,"utils/getCatalogLayerById":238,"utils/getCatalogLayers":239,"utils/getMapLayersByFilter":245,"utils/getProject":247,"utils/getResolutionFromScale":250,"utils/getScaleFromResolution":251,"utils/getUniqueDomId":252,"utils/groupBy":254,"utils/isLineGeometryType":258,"utils/isPointGeometryType":260,"utils/isPolygonGeometryType":261,"utils/throttle":276,"utils/waitFor":278}],210:[function(require,module,exports){
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _g3wEventbus = require('g3w-eventbus');

var _gui = require('services/gui');

var _gui2 = _interopRequireDefault(_gui);

var _g3wConstants = require('g3w-constants');

var _g3wObject = require('g3w-object');

var _g3wObject2 = _interopRequireDefault(_g3wObject);

var _g3wComponent = require('g3w-component');

var _g3wComponent2 = _interopRequireDefault(_g3wComponent);

var _pickcoordinatesinteraction = require('map/interactions/pickcoordinatesinteraction');

var _pickcoordinatesinteraction2 = _interopRequireDefault(_pickcoordinatesinteraction);

var _application = require('store/application');

var _application2 = _interopRequireDefault(_application);

var _data = require('services/data');

var _data2 = _interopRequireDefault(_data);

var _QueryResultsActionDownloadFormats = require('components/QueryResultsActionDownloadFormats.vue');

var _QueryResultsActionDownloadFormats2 = _interopRequireDefault(_QueryResultsActionDownloadFormats);

var _QueryResultsActionQueryPolygonCSVAttributes = require('components/QueryResultsActionQueryPolygonCSVAttributes.vue');

var _QueryResultsActionQueryPolygonCSVAttributes2 = _interopRequireDefault(_QueryResultsActionQueryPolygonCSVAttributes);

var _getAlphanumericPropertiesFromFeature = require('utils/getAlphanumericPropertiesFromFeature');

var _intersects = require('utils/intersects');

var _within = require('utils/within');

var _printAtlas = require('utils/printAtlas');

var _downloadFile = require('utils/downloadFile');

var _throttle = require('utils/throttle');

var _getUniqueDomId = require('utils/getUniqueDomId');

var _copyUrl = require('utils/copyUrl');

var _getCatalogLayerById = require('utils/getCatalogLayerById');

var _layer4 = require('map/layers/layer');

var _vectorlayer = require('map/layers/vectorlayer');

var _g3wI18n = require('g3w-i18n');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @file ORIGINAL SOURCE: src/app/gui/queryresults/queryresultsservice.js@v3.10.2
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @since 3.11.0
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

function _setRelationField(node) {
  if (node.nodes) {
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = node.nodes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var _node = _step.value;

        _setRelationField(_node);
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
  } else if (node.name) {
    node.relation = true;
  }
}

exports.default = new (function (_G3WObject) {
  _inherits(QueryResultsService, _G3WObject);

  function QueryResultsService() {
    _classCallCheck(this, QueryResultsService);

    /**
     * Core methods used from other classes to react before or after its call
     */
    var _this = _possibleConstructorReturn(this, (QueryResultsService.__proto__ || Object.getPrototypeOf(QueryResultsService)).call(this));

    _this.setters = {

      /**
       * Hook method called when response is handled by Data Provider
       *
       * @param { Object }                             queryResponse
       * @param { Array }                              queryResponse.data
       * @param { 'coordinates' | 'bbox' | 'polygon' } queryResponse.type
       * @param { Object }                             queryResponse.query
       * @param { Object }                             queryResponse.query.external
       * @param { boolean }                            queryResponse.query.external.add       - whether add external layers to response
       * @param { Object }                             queryResponse.query.external.filter
       * @param { boolean }                            queryResponse.query.external.SELECTED
       * @param { Object }                             options
       * @param { boolean }                            options.add                            - whether is a new query request (add/remove query request)
       */
      setQueryResponse: function setQueryResponse(queryResponse) {
        var _this2 = this;

        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { add: false, update: false };

        // set mandatory queryResponse fields
        if (!queryResponse.data) queryResponse.data = [];
        if (!queryResponse.query) queryResponse.query = { external: { add: false, filter: { SELECTED: false } } };
        if (!queryResponse.query.external) queryResponse.query.external = { add: false, filter: { SELECTED: false } };

        if (false === options.add && !!options.update) {
          // in case of new request results reset the query otherwise maintain the previous request
          this.state.query = queryResponse.query;
          this.state.type = queryResponse.type;
        }
        // whether add response to current results using addLayerFeaturesToResultsAction
        if (false === options.add && !options.update) {
          // in case of new request results reset the query otherwise maintain the previous request
          this.clearState();
          this.state.query = queryResponse.query;
          this.state.type = queryResponse.type;
        }
        // whether add external layers to response
        if (true === queryResponse.query.external.add && false === options.add) {
          var catalog = _gui2.default.getService('catalog');

          /** @type { boolean | undefined } */
          var FILTER_SELECTED = queryResponse.query.external.filter.SELECTED;

          // add visible layers to query response (vector layers)
          this._vectorLayers.forEach(function (layer) {
            var id = layer.get('id');
            // TODO: extract this into `layer.isSomething()` ?
            if (layer.getVisible() && [undefined, !!(catalog.state.external.vector.find(function (l) {
              return l.id === id;
            }) || {}).selected].includes(FILTER_SELECTED)) {
              queryResponse.data['__g3w_marker' === id // keep geocoding control "marker" layer at the top
              ? 'unshift' : 'push'](_this2.getVectorLayerFeaturesFromQueryRequest(layer, queryResponse.query));
            }
          });
        }

        var geom = false === options.add && {
          'coordinates': 2 === (this.state.query.coordinates || []).length && new ol.geom.Point(this.state.query.coordinates),
          'bbox': 4 === (this.state.query.bbox || []).length && ol.geom.Polygon.fromExtent(this.state.query.bbox),
          'polygon': this.state.query.geometry,
          'drawpolygon': this.state.query.geometry,
          'circle': this.state.query.geometry
        }[this.state.query.type];

        // show a query result on map
        if (geom) {
          var feature = new ol.Feature(geom);
          feature.setId(undefined);
          this.resultsQueryLayer.getSource().clear();
          _gui2.default.getService('map').getMap().removeLayer(this.resultsQueryLayer);
          this.resultsQueryLayer.getSource().addFeature(feature);
          _gui2.default.getService('map').getMap().addLayer(this.resultsQueryLayer);
          this.resultsQueryLayer.setZIndex(_gui2.default.getService('map').getMap().getLayers().getLength()); // ensure layer is on top of others
        }

        // Convert response from DataProvider into a QueryResult component data structure
        // Skip when the layer has no features or rawdata is undefined (external wms)
        var layers = queryResponse.data.flatMap(function (d) {
          return [].concat(d);
        }).filter(function (d) {
          return d && (undefined !== d.rawdata || Array.isArray(d.features) && d.features.length > 0);
        }).map(function () {
          var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
              layer = _ref.layer,
              features = _ref.features,
              rawdata = _ref.rawdata,
              error = _ref.error;

          var is_layer = layer instanceof _layer4.Layer;
          var is_vector = layer instanceof ol.layer.Vector; // instance of openlayers layer Vector Class
          var is_string = 'string' === typeof layer || layer instanceof String; // can be created by string

          var sourceType = void 0;

          if (is_string) {
            sourceType = _layer4.Layer.LayerTypes.VECTOR;
          } else if (is_layer) {
            try {
              sourceType = layer.getSourceType();
            } catch (error) {
              console.warn('uknown source type for layer:', error, layer);
            }
          }

          var name = is_string && layer.split('_');

          var id = (is_layer ? layer.getId() : undefined) || (is_vector ? layer.get('id') : undefined) || (is_string ? layer : undefined);

          var attributes = void 0;
          var layerAttrs = void 0;

          // sanity check (eg. external layers ?)
          if (!features || !features.length) {
            attributes = [];
          }

          // Sanitize OWS Layer attributes
          if (!attributes && layer instanceof _layer4.Layer) {
            layerAttrs = layer.getAttributes().map(function (attr) {
              return 'ows' === _this2.state.type ? _extends({}, attr, { name: attr.name.replace(/ /g, '_') }) : attr;
            });
          }

          if (!attributes && layer instanceof ol.layer.Vector) {
            layerAttrs = layer.getProperties();
          }

          if (!attributes && 'string' === typeof layer || layer instanceof String) {
            layerAttrs = features[0] ? features[0].getProperties() : [];
          }

          var specialAttrs = (!attributes && layer instanceof _layer4.Layer && layerAttrs || []).filter(function (attr) {
            try {
              return '_' === attr.name[0] || Number.isInteger(1 * attr.name[0]);
            } catch (e) {
              return false;
            }
          }).map(function (attr) {
            return { alias: attr.name.replace(/_/, ''), name: attr.name };
          });

          if (!attributes && specialAttrs.length) {
            features.forEach(function (f) {
              // get attributes special keys from feature properties received by server request
              var attrs = Object.keys(f.getProperties());
              specialAttrs.forEach(function (layerAttr) {
                attrs.find(function (attr) {
                  if (attr === layerAttr.alias) {
                    f.set(layerAttr.name, f.get(attr));
                    return true;
                  }
                });
              });
            });
          }

          // Parse attributes to show on a result based on field

          var attrs = !attributes && (0, _getAlphanumericPropertiesFromFeature.getAlphanumericPropertiesFromFeature)(Object.keys(features[0] instanceof ol.Feature ? features[0].getProperties() : features[0].properties));

          if (!attributes) {
            attributes = layerAttrs && layerAttrs.length > 0 ? layerAttrs.filter(function (attr) {
              return attrs.includes(attr.name);
            }) : attrs.map(function (featureAttr) {
              return {
                name: featureAttr,
                label: featureAttr,
                show: _g3wConstants.G3W_FID !== featureAttr && [undefined, 'gdal', 'wms', 'wcs', 'wmst', 'postgresraster'].includes(sourceType),
                type: 'varchar'
              };
            });
          }

          var external = is_vector || is_string;
          var structure = is_layer && layer.hasFormStructure() && layer.getLayerEditingFormStructure();

          if (structure && Array.isArray(_this2._relations[layer.getId()]) && _this2._relations[layer.getId()].length > 0) {
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
              for (var _iterator2 = structure[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                var node = _step2.value;

                _setRelationField(node);
              }
            } catch (err) {
              _didIteratorError2 = true;
              _iteratorError2 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }
              } finally {
                if (_didIteratorError2) {
                  throw _iteratorError2;
                }
              }
            }
          }

          // layerObj
          return {
            id: id,
            attributes: attributes,
            external: external,
            features: (!rawdata && features || []).map(function (f) {
              return {
                id: external ? f.getId() : f instanceof ol.Feature ? f.getId() : f.id,
                attributes: f instanceof ol.Feature ? f.getProperties() : f.properties,
                geometry: f instanceof ol.Feature ? f.getGeometry() : f.geometry,
                selection: { selected: false },
                show: true
              };
            }),
            hasgeometry: Array.isArray(features) && !rawdata && features.some(function (f) {
              return f instanceof ol.Feature ? f.getGeometry() : f.geometry;
            }),
            hasImageField: Array.isArray(features) && !rawdata && features.length && attributes.some(function (attr) {
              return 'image' === attr.type;
            }),
            loading: false,
            show: true,
            expandable: true,
            addfeaturesresults: { active: false },
            downloadformats: { active: false },
            editable: is_layer ? layer.isEditable() && layer.config.editing.visible : false,
            inediting: is_layer ? layer.isInEditing() : false,
            source: is_layer ? layer.getSource() : undefined,
            infoformat: is_layer ? layer.getInfoFormat() : undefined,
            infoformats: is_layer ? layer.getInfoFormats() : [],
            downloads: is_layer ? layer.getDownloadableFormats() : [],
            formStructure: structure ? {
              structure: structure,
              // get field show
              fields: layer.getFields().filter(function (f) {
                return f.show;
              }).concat((Array.isArray(features) && !rawdata && features.length > 0 && attributes || []).filter(function (attr) {
                return layer.getFields().some(function (f) {
                  return f.name === attr.name;
                });
              }))
            } : undefined,
            relationsattributes: is_layer || is_vector || is_string ? [] : undefined,
            filter: is_layer && !['wms', 'wcs', 'wmst'].includes(sourceType) ? layer.state.filter : {},
            selection: is_layer && !['wms', 'wcs', 'wmst'].includes(sourceType) && layer.state.selection || is_vector && layer.selection || {},
            title: is_layer && layer.getTitle() || is_vector && layer.get('name') || is_string && name && (name.length > 4 ? name.slice(0, name.length - 4).join(' ') : layer) || undefined,
            atlas: _this2._atlas.filter(function (a) {
              return a.atlas.qgs_layer_id === id;
            }),
            rawdata: rawdata || null,
            error: error || '',
            toc: external || layer.state.toc //@since v3.10.0
          };
        });
        this.setLayersData(layers, options);
      },


      /**
       * Setter method called when adding layer and feature for response
       *
       * @param layers
       * @param options
       */
      setLayersData: function setLayersData() {
        var _this3 = this;

        var layers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { add: false, update: false };

        if (false === options.add) {
          // sort layers as Catalog project layers.
          //external layer always on bottom
          layers.sort(function (a, b) {
            return a.external ? 0 : _this3._projectLayerIds.indexOf(a.id) > _this3._projectLayerIds.indexOf(b.id) ? 1 : -1;
          });
        }
        // get features from added pick layer in case of a new request query
        layers.forEach(function (l, index) {
          //@since 3.11.0 check if a result comes from pagination
          l.filter.pagination = l.filter.pagination || !!(_this3.state.query.pagination && _this3.state.query.pagination.counts[index] > l.features.length);
          options.add || options.update ? _this3.updateLayerResultFeatures(l, options.update) : _this3.state.layers.push(l);
        });
        this.setActionsForLayers(layers, { add: options.add, update: options.update });
        this.state.changed = true;
      },


      /**
       * Add custom component in query result
       *
       * @param component
       */
      addComponent: function addComponent(component) {
        this.state.components.push(component);
      },


      /**
       * @FIXME add description
       *
       * @param actions
       * @param layers
       */
      addActionsForLayers: function addActionsForLayers(actions, layers) {},


      /**
       * @FIXME add description
       *
       * @param element
       */
      postRender: function postRender(element) {},


      /**
       * @FIXME add description
       */
      closeComponent: function closeComponent() {},


      /**
       * Called when layer result features is changed
       *
       * @param layer
       */
      changeLayerResult: function changeLayerResult(layer) {
        var _this4 = this;

        this.state.layersactions[layer.id].forEach(function (action) {
          return action.change && action.change(layer);
        }); // call if present change method to action
        // reset layer current actions tools
        (layer.features || []).forEach(function (_, idx) {
          var tool = _this4.state.currentactiontools[layer.id];
          if (undefined === tool) {
            return;
          }
          if (undefined === tool[idx]) {
            Vue.set(tool, idx, null);
          }
          tool[idx] = null;
        });
      },


      /**
       * @FIXME add description
       */
      activeMapInteraction: function activeMapInteraction() {},


      /**
       * Setter method related to relation table
       */
      editFeature: function editFeature() {
        var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            layer = _ref2.layer,
            feature = _ref2.feature;
      },


      /**
       * Setter method called when opening/closing feature info data content.
       *
       * @param opts.open
       * @param opts.layer
       * @param opts.feature
       * @param opts.container
       */
      openCloseFeatureResult: function openCloseFeatureResult() {
        var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            open = _ref3.open,
            layer = _ref3.layer,
            feature = _ref3.feature,
            container = _ref3.container;
      },


      /**
       * Remove a feature from current layer result
       *
       * @param layer
       * @param feature
       * 
       * @since 3.9.0
       */
      removeFeatureLayerFromResult: function removeFeatureLayerFromResult(layer, feature) {
        this.updateLayerResultFeatures({ id: layer.id, external: layer.external, features: [feature] });
      }
    };

    /**
     * @FIXME add description
     */
    _this.unlistenerlayeractionevents = [];

    /**
     * <Object> to store relations (key is referenceLayer of relation)
     */
    _this._relations = {};

    /**
     * @FIXME add description
     */
    _this._atlas = [];

    /**
     * @FIXME add description
     */
    _this.plotLayerIds = [];

    /**
     * Set reactive state
     */
    _this.state = {

      logged: undefined !== _application2.default.user.id,

      /**
       * @FIXME add description
       */
      components: [],

      /**
       * @FIXME add description
       */
      layers: [],

      /**
       * @FIXME add description
       */
      changed: false,

      /**
       * @FIXME add description
       */
      query: null,

      /**
       * 'ows' = default
       * 'api' = search
       */
      type: 'ows',

      /**
       * An action is an object that contains:
       *
       * ```
       * {
       *   "id":       (required) Unique action Id
       *   "download": whether action is download or not
       *   "class":    (required) fontawsome classname to show icon
       *   "state":    need to be reactive. Used for example to toggled state of action icon
       *   "hint":     Tooltip text
       *   "init":     Method called when action is loaded
       *   "clear":    Method called before clear the service. Used for example to clear unwatch
       *   "change":   Method called when feature of layer is changed
       *   "cbk":      (required) Method called when action is cliccked
       * }
       * ```
       **/
      layersactions: {},

      /**
       * Add action tools (for features)
       */
      actiontools: {},

      /**
       * Current action tools contain component
       * of a specific action (eg. download)
       */
      currentactiontools: {},

      /**
       * Contains current action that expose vue component
       * (useful for comparing the id other action is
       * triggered and exposing the component)
       */
      currentactionfeaturelayer: {},

      /**
       * @FIXME add description
       */
      layeractiontool: {},

      /**
       * @FIXME add description
       */
      layersFeaturesBoxes: {},

      /**
       * Used to show a custom component for a layer
       */
      layerscustomcomponents: {}

    };

    /**
     * <Array> where are store vector layer add on runtime
     */
    _this._vectorLayers = [];

    /**
     * @FIXME add description
     */
    _this._addFeaturesLayerResultInteraction = {

      /**
       * Reference to current layer
       */
      id: null,

      /**
       * Interaction bind to layer,
       */
      interaction: null,

      /**
       * Add current toggled map control if toggled
       */
      mapcontrol: null,

      /**
       * Method that handles interaction when a mapcontrol is toggled
       */
      toggleeventhandler: null

    };

    /**
     * @FIXME add description
     */
    _this._asyncFnc = {
      todo: function todo() {},
      zoomToLayerFeaturesExtent: { async: false },
      highLightLayerFeatures: { async: false },
      goToGeometry: { async: false }
    };

    /**
     * Vector layer used by query result to show query
     * request as coordinates, bbox, polygon, etc ..
     *
     * @type {ol.layer.Vector}
     */
    _this.resultsQueryLayer = new ol.layer.Vector({
      source: new ol.source.Vector(),
      style: function style(feat) {
        return new ol.style.Style('Point' === feat.getGeometry().getType() ? { text: new ol.style.Text({ fill: new ol.style.Stroke({ color: 'black' }), text: '\uF3C5', font: '900 3em "Font Awesome 5 Free"', offsetY: -15 }) } : { stroke: new ol.style.Stroke({ color: 'black' }) });
      }
    });

    /**
     * Current project <Project>
     */
    _this._project = _application2.default.project;

    /**
     * Keep the right order for a query result based on TOC order layers
     */
    _this._projectLayerIds = function () {
      var layersId = [];
      var traverse = function traverse(tree) {
        (tree.nodes || [tree]).forEach(function (n) {
          if (n.id) {
            layersId.push(n.id);
          } else {
            traverse(n);
          }
        });
      };
      _this._project.state.layerstree.forEach(traverse);
      return layersId;
    }();

    /**
     * @FIXME add description
     */
    _this._setRelations(_this._project);

    /**
     * @FIXME add description
     */
    _this._atlas = _this._project.getPrint().filter(function (p) {
      return p.atlas;
    }) || [];

    /**
     * @FIXME add description
     */
    _gui2.default.onbefore('setContent', function (options) {
      if (100 === options.perc && _gui2.default.isMobile()) {
        _this._asyncFnc.zoomToLayerFeaturesExtent.async = true;
        _this._asyncFnc.highLightLayerFeatures.async = true;
        _this._asyncFnc.goToGeometry.async = true;
      }
    });

    return _this;
  }

  /**
   * @since 3.11.0
   * Load pagination data
   * @param index
   * @param page
   * @param page_size
   * @param query
   */


  _createClass(QueryResultsService, [{
    key: 'loadPaginationData',
    value: function () {
      var _ref4 = _asyncToGenerator(function* (index, page, page_size, query) {
        var _this5 = this;

        //In the case of first autofilter request in pagination request, remove it from
        if (this.state.query.autofilter && this.state.query.pagination) {
          this.state.query.autofilter = false;
          this.state.query.pagination.getData.params.forEach(function (p) {
            return delete p.autofilter;
          });
        }
        if (page_size) {
          this.state.query.pagination.getData.params[index].page_size = page_size;
          this.state.query.pagination.pages[index] = Math.round(this.state.query.pagination.counts[index] / page_size);
        } //set page size
        //get config from getData object set by pagination method
        var _state$query$paginati = this.state.query.pagination.getData,
            _state$query$paginati2 = _state$query$paginati.layers,
            layers = _state$query$paginati2 === undefined ? [] : _state$query$paginati2,
            method = _state$query$paginati.method,
            params = _state$query$paginati.params;

        var layer = layers[index];
        //check if layer has filter
        var has_filtertoken = !!layer.getFilterToken();
        try {
          //get layer pagination data
          var data = yield layer[method](_extends({}, params[index], { page: page }));
          //set response data
          this.setQueryResponse(_extends({}, data, { query: query }), { add: false, update: true });
          //set the current page
          this.state.query.pagination.current[index] = page;
          //in the case of page size change
          var bool = layer.state.selection.active || has_filtertoken;
          //get selection action
          var action = this.state.layersactions[layer.getId()].find(function (_ref5) {
            var id = _ref5.id;
            return 'selection' === id;
          });
          this.state.layers[index].features.forEach(function (f, i) {
            if (bool && !f.selection.selected && layer.isGeoLayer() && f.geometry) {
              var fid = _this5._getFeatureId(f, _this5.state.layers[index].external);
              layer.addOlSelectionFeature({ id: fid, feature: f }).selected = true;
              layer.includeSelectionFid(fid, false);
            }
            f.selection.selected = bool;
            action.state.toggled[i] = bool;
          });
          layer.state.filter.active = bool;
          layer.state.selection.active = bool;

          this.state.layers[index].filter.pagination = this.state.layers[index].features.length < this.state.query.pagination.counts[index];
          //in the case of layer with geometry, zoom to features
          if (this.state.layers[index].hasgeometry) {
            this.highLightLayerFeatures(this.state.layers[index]);
          }
        } catch (e) {
          console.warn(e);
        }
      });

      function loadPaginationData(_x7, _x8, _x9, _x10) {
        return _ref4.apply(this, arguments);
      }

      return loadPaginationData;
    }()

    /**
     * used by the following plugins: "qplotly"
     */

  }, {
    key: 'addLayersPlotIds',
    value: function addLayersPlotIds() {
      var layerIds = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      this.plotLayerIds = layerIds;
    }

    /**
     * used by the following plugins: "br-service"
     * 
     * Register for plugin or other component of application to add
     * custom component on result for each layer feature or layer
     *
     * @param opts.id        unique id identification
     * @param opts.layerId   Layer id of layer
     * @param opts.component custom component
     * @param opts.type      feature or layer
     * @param opts.position
     */

  }, {
    key: 'registerCustomComponent',
    value: function registerCustomComponent() {
      var _ref6 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref6$id = _ref6.id,
          id = _ref6$id === undefined ? (0, _getUniqueDomId.getUniqueDomId)() : _ref6$id,
          layerId = _ref6.layerId,
          component = _ref6.component,
          _ref6$type = _ref6.type,
          type = _ref6$type === undefined ? 'feature' : _ref6$type,
          _ref6$position = _ref6.position,
          position = _ref6$position === undefined ? 'after' : _ref6$position;

      if (undefined === this.state.layerscustomcomponents[layerId]) {
        this.state.layerscustomcomponents[layerId] = {
          layer: { before: [], after: [] },
          feature: { before: [], after: [] }
        };
      }
      this.state.layerscustomcomponents[layerId][type][position].push({ id: id, component: component });
      return id;
    }

    /**
     * Loop over response features based on layer response and
     * check if features layer needs to be added or removed to
     * current `state.layers` results.
     *
     * @param responseLayer layer structure coming from request
     * @param replace    @since 3.11.0 mean replace current state layer features
     *
     * @since 3.8.0
     */

  }, {
    key: 'updateLayerResultFeatures',
    value: function updateLayerResultFeatures(responseLayer) {
      var _this6 = this;

      var replace = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      var layer = this.state.layers.find(function (l) {
        return l.id === responseLayer.id;
      }); // get layer from current `state.layers` showed on a result
      var responseFeatures = responseLayer.features || []; // extract features from responseLayer object
      var external = (this.state.layers.find(function (l) {
        return l.id === responseLayer.id;
      }) || {}).external; // get id of external layer or not (`external` is a layer added by mapcontrol addexternlayer)
      var has_features = layer && (layer.features || []).length > 0; // check if the current layer has features on response
      if (has_features) {
        var features_ids = replace ? [] : layer.features.map(function (f) {
          return external ? f.id : f.attributes[_g3wConstants.G3W_FID];
        }); // get features id from current layer on a result
        //get action selection;
        var action = this.state.layersactions[layer.id].find(function (a) {
          return 'selection' === a.id;
        });
        if (replace) {
          layer.features.forEach(function (f) {
            return delete _this6.state.layersFeaturesBoxes[_this6.getBoxId(layer, f)];
          });
          layer.features.splice(0);
        }
        responseFeatures.forEach(function (feat, index) {
          var feature_id = _this6._getFeatureId(feat, external);
          // If true, remove the feature because is already loaded
          if (features_ids.some(function (id) {
            return id === feature_id;
          })) {
            //@since 3.11.0
            if (action && feat.selection.selected) {
              (external ? layer : (0, _getCatalogLayerById.getCatalogLayerById)(layer.id)).excludeSelectionFid(feature_id, layer.filter.active);
            }
            //filter feature
            layer.features.splice(index, 1);
            delete _this6.state.layersFeaturesBoxes[_this6.getBoxId(layer, feat)];
            if (action) {
              delete action.state.toggled[index];
              //need to reset toggled state in reactive mode
              action.state.toggled = Vue.observable(layer.features.reduce(function (a, f, i) {
                a[i] = f.selection.selected;return a;
              }, {}));
            }
          } else {
            // add feature
            layer.features.push(feat);
          }
        });
        // toggle layer feature box
        (layer.features || []).forEach(function (f) {
          var collapsed = (layer.features || []).length > 1;
          var box = _this6.state.layersFeaturesBoxes[_this6.getBoxId(layer, f)];
          if (box) {
            setTimeout(function () {
              return box.collapsed = collapsed;
            }); // due to vue reactivity, wait a little bit before update layers
          }
        });
      }

      // no more features on layer → remove interaction pickcoordinate to get a result from a map
      if (layer && 0 === (layer.features || []).length) {
        // due to vue reactivity, wait a little bit before update layers
        setTimeout(function () {
          _this6.state.layers = _this6.state.layers.filter(function (l) {
            return l.id !== layer.id;
          });
          _this6.clearHighlightGeometry(layer);
          _this6.removeAddFeaturesLayerResultInteraction(true);
        });
      }

      // highlight new feature
      if (1 === this.state.layers.length) {
        _gui2.default.getService('map').highlightFeatures(this.state.layers[0].features, { duration: Infinity });
      }

      this.changeLayerResult(layer);
    }

    /**
     * Generate a boxid identifier to query result html
     *
     * @param layer
     * @param feature
     * @param relation_index
     *
     * @returns {string}
     */

  }, {
    key: 'getBoxId',
    value: function getBoxId(layer, feature, relation_index) {
      return null !== relation_index && undefined !== relation_index ? layer.id + '_' + feature.id + '_' + relation_index : layer.id + '_' + feature.id;
    }

    /**
     * @FIXME add description
     *
     * @param layers
     * @param options
     */

  }, {
    key: 'setActionsForLayers',
    value: function setActionsForLayers(layers) {
      var _this7 = this;

      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { add: false, update: false };

      if (options.add || options.update) {
        return;
      }

      // reset array
      this.unlistenerlayeractionevents = [];

      // loop results
      layers.forEach(function (layer) {
        var _state$layersactions$;

        var state = _this7.state;
        // eventually set layer action tool and need to be reactive
        _this7.state.layeractiontool[layer.id] = Vue.observable({ component: null, config: null });
        _this7.state.currentactiontools[layer.id] = Vue.observable(_extends({}, Array((layer.features || []).length).fill(null)));
        _this7.state.currentactionfeaturelayer[layer.id] = Vue.observable(_extends({}, Array((layer.features || []).length).fill(null)));
        _this7.state.layersactions[layer.id] = _this7.state.layersactions[layer.id] || [];

        var download_format = 1 === layer.downloads.length && (layer.downloads || []).at(0); // NB: format == layer.downloads[0]
        var relations = (_this7._relations[layer.id] || []).filter(function (r) {
          return 'MANY' === r.type;
        });
        var chartRelationIds = relations.map(function (r) {
          return _this7.plotLayerIds.find(function (id) {
            return id === r.referencingLayer;
          });
        }).filter(Boolean);

        if (download_format) {
          layer[download_format] = Vue.observable({ active: false });
        }

        // set actionstools configs
        if (layer.downloads.length > 1) {
          _this7.state.actiontools.downloadformats = _this7.state.actiontools.downloadformats || {};
          _this7.state.actiontools.downloadformats[layer.id] = {
            downloads: layer.downloads.map(function (format) {
              return {
                id: 'download_' + format + '_feature',
                download: true,
                format: format,
                class: _gui2.default.getFontClass(format),
                hint: 'sdk.tooltips.download_' + format,
                cbk: function cbk(layer, feature, action, index, html) {
                  // un-toggle downloads action
                  _this7.downloadFeatures(format, layer, feature, action, index, html);
                  if ('polygon' !== _this7.state.query.type) {
                    var downloadsaction = _this7.state.layersactions[layer.id].find(function (a) {
                      return 'downloads' === a.id;
                    });
                    downloadsaction.cbk(layer, feature, downloadsaction, index, html);
                  }
                }
              };
            })
          };
        }

        (_state$layersactions$ = _this7.state.layersactions[layer.id]).push.apply(_state$layersactions$, _toConsumableArray([

        // zoom to geometry
        layer.hasgeometry && {
          id: 'gotogeometry',
          mouseover: true,
          class: _gui2.default.getFontClass('marker'),
          hint: 'sdk.mapcontrols.query.actions.zoom_to_feature.hint',
          cbk: (0, _throttle.throttle)(_this7.goToGeometry.bind(_this7))
        },

        // show relations (query)
        relations.length && {
          id: 'show-query-relations',
          class: _gui2.default.getFontClass('relation'),
          hint: 'sdk.mapcontrols.query.actions.relations.hint',
          cbk: function cbk(layer, feature, action) {
            _gui2.default.setCurrentContentOptions({ title: layer.title, crumb: { text: true, title: layer.title } });
            _gui2.default.pushContent({
              content: new _g3wComponent2.default({
                internalComponent: new (Vue.extend(require('components/RelationsPage.vue')))({
                  relations: action.relations,
                  chartRelationIds: action.chartRelationIds,
                  feature: feature,
                  layer: layer
                })
              }),
              backonclose: true,
              title: 'info.list_of_relations',
              id: '__G3W_LIST_OF_RELATIONS_ID__',
              crumb: {
                title: 'info.list_of_relations',
                trigger: null
              },
              closable: false
            });
          },

          relations: relations,
          chartRelationIds: chartRelationIds
        },

        // show relations (plot)
        chartRelationIds.length && {
          id: 'show-plots-relations',
          opened: true,
          class: _gui2.default.getFontClass('chart'),
          state: Vue.observable({ toggled: layer.features.reduce(function (a, _, i) {
              a[i] = null;return a;
            }, {}) }),
          hint: 'sdk.mapcontrols.query.actions.relations_charts.hint',
          cbk: (0, _throttle.throttle)(function (layer, feature, action, index, container) {
            action.state.toggled[index] = !action.state.toggled[index];
            if (action.state.toggled[index]) {
              _this7.emit('show-chart', chartRelationIds, container, {
                relations: _this7._relations[layer.id],
                fid: feature.attributes[_g3wConstants.G3W_FID],
                height: 400
              });
            } else {
              _this7.hideChart(container);
            }
          })
        },

        // print (atlas)
        _this7._atlas.filter(function (a) {
          return a.atlas.qgs_layer_id === layer.id;
        }).length && {
          id: 'printatlas',
          download: true,
          class: _gui2.default.getFontClass('print'),
          hint: 'sdk.tooltips.atlas',
          cbk: _this7.printAtlas.bind(_this7)
        },

        // download features (single)
        download_format && {
          id: 'download_' + download_format + '_feature',
          download: true,
          state: Vue.observable({ toggled: layer.features.reduce(function (a, _, i) {
              a[i] = null;return a;
            }, {}) }),
          class: _gui2.default.getFontClass('download'),
          hint: 'sdk.tooltips.download_' + download_format,
          cbk: function cbk(layer, feature, action, index, container) {
            action.state.toggled[index] = !action.state.toggled[index];
            if (action.state.toggled[index]) {
              _this7.downloadFeatures(download_format, layer, feature, action, index, 'pdf' === download_format ? container[0].innerHTML : null);
            } else {
              _this7.setCurrentActionLayerFeatureTool({ index: index, action: action, layer: layer });
            }
          }
        },

        // download features (multi)
        layer.downloads.length > 1 && {
          id: 'downloads',
          download: true,
          class: _gui2.default.getFontClass('download'),
          state: Vue.observable({ toggled: layer.features.reduce(function (a, _, i) {
              a[i] = null;return a;
            }, {}) }),
          toggleable: true,
          hint: 'Downloads',
          change: function change(_ref7) {
            var _this8 = this;

            var features = _ref7.features;

            features.forEach(function (_, i) {
              return undefined === _this8.state.toggled[i] ? _g3wEventbus.VM.$set(_this8.state.toggled, i, false) : _this8.state.toggled[i] = false;
            });
          },

          cbk: function cbk(layer, feature, action, index) {
            action.state.toggled[index] = !action.state.toggled[index];
            _this7.setCurrentActionLayerFeatureTool({ layer: layer, index: index, action: action, component: action.state.toggled[index] ? _QueryResultsActionDownloadFormats2.default : null });
          }
        },

        // remove feature not in case of pagination @since 3.11.0
        ('__g3w_marker' === layer.id || !layer.external && 'wms' !== (layer.source || {}).type) && {
          id: 'removefeaturefromresult',
          mouseover: true,
          class: _gui2.default.getFontClass('minus-square'),
          style: { color: 'red' },
          // in case of pagination, disabled @since 3.11.0
          state: Vue.observable({ show: !state.query.pagination && !layer.filter.pagination }), //@since 3.11.0 show false in case of pagination
          hint: 'sdk.mapcontrols.query.actions.remove_feature_from_results.hint',
          cbk: _this7.removeFeatureLayerFromResult.bind(_this7),
          /**
           * @since @3.11.0
           * Need to listen filter layer pagination change
           */
          init: function init() {
            var _this9 = this;

            this.unwatch = _g3wEventbus.VM.$watch(function () {
              return layer.filter.pagination;
            }, function (bool) {
              return _this9.state.show = !bool;
            });
          },

          /**
           * @since @3.11.0
           * Clear action when destroy
           */
          clear: function clear() {
            this.unwatch && this.unwatch();
          },
          change: function change() {
            this.state.disabled = !state.query.pagination && !layer.filter.pagination;
          }
        },

        // select feature
        layer.toc && undefined !== layer.selection.active && {
          id: 'selection',
          class: _gui2.default.getFontClass('success'),
          hint: 'sdk.mapcontrols.query.actions.add_selection.hint',
          state: Vue.observable({
            toggled: layer.features.reduce(function (a, _, i) {
              a[i] = null;return a;
            }, {}),
            // in case of pagination, show @since 3.11.0
            show: !state.query.pagination && !layer.filter.pagination
          }),
          // check feature selection
          init: function init() {
            var _ref8 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                feature = _ref8.feature,
                index = _ref8.index,
                action = _ref8.action;

            if (layer.external && undefined !== layer.selection.active) {
              // external layer
              action.state.toggled[index] = feature.selection.selected;
            } else if (feature && undefined !== layer.selection.active) {
              // project layer
              var pLayer = (0, _getCatalogLayerById.getCatalogLayerById)(layer.id);
              var fid = _this7._getFeatureId(feature, layer.external);
              var is_selected_feature = feature ? pLayer.hasSelectionFid(fid) : false;
              //force to add selection feature in case of no pagination and selection is due an autofilter search
              if (!_this7.state.query.pagination && pLayer.state.filter.active && !is_selected_feature) {
                is_selected_feature = true;
                pLayer.addOlSelectionFeature({ id: fid, feature: feature }).selected = true;
                pLayer.includeSelectionFid(fid, false);
              }
              feature.selection.selected = is_selected_feature;
              action.state.toggled[index] =
              //need to check if set active filter and no saved filter is set
              pLayer.state.filter.active && null == pLayer.state.filter.current ||
              //or if feature fid is in selected array
              is_selected_feature;
              action.unwatch = _g3wEventbus.VM.$watch(function () {
                return layer.filter.pagination;
              }, function (bool) {
                return action.state.show = !bool;
              });
            }
          },
          /**
           * @since @3.11.0
           * Clear action when destroy
           */
          clear: function clear() {
            this.unwatch && this.unwatch();
          },

          /** @since 3.9.0 reactive `toggled` when adding new feature and then bind click on query result context (exclude existing features and add reactive array property) */
          change: function change(_ref9) {
            var _this10 = this;

            var features = _ref9.features;

            this.state.show = !state.query.pagination && !layer.filter.pagination;
            features.forEach(function (_, index) {
              return undefined === _this10.state.toggled[index] && _g3wEventbus.VM.$set(_this10.state.toggled, index, false);
            });
          },

          cbk: (0, _throttle.throttle)(_this7.addToSelection.bind(_this7))
        },

        // permalink (click to copy)
        layer.hasgeometry && !layer.external && 'wms' !== (layer.source || {}).type && {
          id: 'link_zoom_to_fid',
          class: _gui2.default.getFontClass('share-alt'),
          hint: 'sdk.mapcontrols.query.actions.copy_zoom_to_fid_url.hint',
          hint_change: { hint: 'sdk.mapcontrols.query.actions.copy_zoom_to_fid_url.hint_change', duration: 1000 },
          cbk: function cbk(layer, feature, action) {
            var url = new URL(location.href);
            url.searchParams.set('zoom_to_fid', layer.id + '|' + feature.attributes[_g3wConstants.G3W_FID]);
            (0, _copyUrl.copyUrl)(url.toString());
            action.hint_changed = true;
          }
        },

        // edit
        layer.editable && false === layer.inediting && {
          id: 'editing',
          class: _gui2.default.getFontClass('pencil'),
          hint: 'sdk.tooltips.editing',
          cbk: function cbk(layer, feature) {
            return _this7.editFeature({ layer: layer, feature: feature });
          }
        }].filter(Boolean)));

        // In case of external layer don't listen to `selection` event
        if (layer.external && layer.toc && undefined !== layer.selection.active) {
          layer.features.forEach(function (f) {
            return f.selection = (layer.selection.features.find(function (s) {
              return f.id === s.getId();
            }) || { selection: { selected: false } }).selection;
          });
        } else if (!layer.external && layer.toc && undefined !== layer.selection.active) {
          var handler = function handler() {
            return layer.features.forEach(function (_, i) {
              return _this7.state.layersactions[layer.id].find(function (a) {
                return a.id === 'selection';
              }).state.toggled[i] = false;
            });
          };
          (0, _getCatalogLayerById.getCatalogLayerById)(layer.id).on('unselectionall', handler);
          _this7.unlistenerlayeractionevents.push({ layer: (0, _getCatalogLayerById.getCatalogLayerById)(layer.id), event: 'unselectionall', handler: handler });
        }
      });

      this.addActionsForLayers(this.state.layersactions, this.state.layers);
    }

    /**
     * Get action referred to layer getting the action id
     *
     * @param opts.layer layer linked to action
     * @param opts.id    action id
     * 
     * @returns undefined when no action is found
     */

  }, {
    key: 'getActionLayerById',
    value: function getActionLayerById() {
      var _ref10 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          layer = _ref10.layer,
          id = _ref10.id;

      if (this.state.layersactions[layer.id]) {
        return this.state.layersactions[layer.id].find(function (action) {
          return action.id === id;
        });
      }
    }

    /**
     * Set current layer action tool in feature
     *
     * @param {Object } opts
     * @param opts.layer current layer
     * @param opts.index feature index
     * @param opts.action action
     * @param opts.component vue component
     */

  }, {
    key: 'setCurrentActionLayerFeatureTool',
    value: function setCurrentActionLayerFeatureTool() {
      var _ref11 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          layer = _ref11.layer,
          action = _ref11.action,
          index = _ref11.index,
          _ref11$component = _ref11.component,
          component = _ref11$component === undefined ? null : _ref11$component;

      var tools = this.state.currentactiontools[layer.id]; // get current action tools
      var feats = this.state.currentactionfeaturelayer[layer.id];
      feats[index] = component ? action : null;
      tools[index] = component; // set component

      // need to check if pass component and
      if (tools[index] && // if component is set
      action.id !== feats[index].id && // same action
      feats[index].toggleable // check if toggleable
      ) {
          feats[index].state.toggled[index] = false;
        }
    }

    /**
     * @TODO rename misleading method name: `addActionToolsLayer`
     * @param {Object } opts
     * @param opts.id     action layer id
     * @param opts.layer  layer
     * @param opts.config configuration object
     * @param opts.action (since 3.9.0) configuration object
     */

  }, {
    key: 'addCurrentActionToolsLayer',
    value: function addCurrentActionToolsLayer(_ref12) {
      var id = _ref12.id,
          layer = _ref12.layer,
          _ref12$config = _ref12.config,
          config = _ref12$config === undefined ? {} : _ref12$config,
          action = _ref12.action;

      if (!layer) {
        return;
      }
      this.state.actiontools[id] = _defineProperty({}, layer.id, config);
      if (action) {
        this.state.layersactions[layer.id] = this.state.layersactions[layer.id] || [];
        this.state.layersactions[layer.id].push(action);
      }
    }

    /**
     * @FIXME add description
     * @param {Object } opts
     * @param opts.layer current layer
     * @param opts.component vue component
     * @param opts.config configuration Object
     */

  }, {
    key: 'setLayerActionTool',
    value: function setLayerActionTool() {
      var _ref13 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          layer = _ref13.layer,
          _ref13$component = _ref13.component,
          component = _ref13$component === undefined ? null : _ref13$component,
          _ref13$config = _ref13.config,
          config = _ref13$config === undefined ? null : _ref13$config;

      this.state.layeractiontool[layer.id].component = component;
      this.state.layeractiontool[layer.id].config = config;
    }
  }, {
    key: 'clear',


    /**
     * Clear all
     */
    value: function clear() {
      this._asyncFnc.todo();
      // unlistener events actions
      this.unlistenerlayeractionevents.forEach(function (obj) {
        return obj.layer.off(obj.event, obj.handler);
      });
      this.unlistenerlayeractionevents = [];
      _gui2.default.getService('map').clearHighlightGeometry();
      this.resultsQueryLayer.getSource().clear();
      this.removeAddFeaturesLayerResultInteraction(true);
      this._asyncFnc = {
        todo: function todo() {},
        zoomToLayerFeaturesExtent: { async: false },
        highLightLayerFeatures: { async: false },
        goToGeometry: { async: false }
      };
      this.clearState();
      this.closeComponent();
      this.resultsQueryLayer.getSource().clear();
      _gui2.default.getService('map').getMap().removeLayer(this.resultsQueryLayer);
    }

    /**
     * Check if a one layer result
     *
     * @returns {boolean}
     */

  }, {
    key: 'isOneLayerResult',
    value: function isOneLayerResult() {
      return 1 === this.state.layers.length;
    }

    /**
     * @FIXME add description
     *
     * @param {boolean} toggle whether toggle mapcontrol
     */

  }, {
    key: 'removeAddFeaturesLayerResultInteraction',
    value: function removeAddFeaturesLayerResultInteraction(toggle) {
      var interaction = this._addFeaturesLayerResultInteraction;

      if (null !== interaction.toggleeventhandler) {
        _gui2.default.getService('map').off('mapcontrol:toggled', interaction.toggleeventhandler);
      }

      // remove current interaction to get features from layer
      if (null !== interaction.interaction) {
        _gui2.default.getService('map').removeInteraction(interaction.interaction);
      }

      // check if query map control is toggled and registered
      if (null !== interaction.mapcontrol) {
        interaction.mapcontrol.toggle(toggle);
      }

      // reset values
      Object.assign(interaction, {
        interaction: null,
        id: null,
        toggleeventhandler: null,
        mapcontrol: null
      });
    }

    /**
     * Adds feature to Features layer results
     *
     * @param layer
     */

  }, {
    key: 'addLayerFeaturesToResultsAction',
    value: function addLayerFeaturesToResultsAction(layer) {
      var _this11 = this;

      var interaction = this._addFeaturesLayerResultInteraction;

      var not_current = ![null, layer.id].includes(interaction.id);
      var new_layer = not_current && this.state.layers.find(function (l) {
        return l.id === interaction.id;
      });

      // disable previous layer
      if (not_current && new_layer) {
        new_layer.addfeaturesresults.active = false;
      }

      // remove previous interaction
      if (not_current && interaction.interaction) {
        _gui2.default.getService('map').removeInteraction(interaction.interaction);
      }

      // set new layer
      interaction.id = layer.id;

      layer.addfeaturesresults.active = !layer.addfeaturesresults.active;

      if (false === layer.addfeaturesresults.active) {
        this.removeAddFeaturesLayerResultInteraction(true);
      } else {

        this.activeMapInteraction(); // useful to send an event

        var external_layer = (this.state.layers.find(function (l) {
          return l.id === layer.id;
        }) || {}).external;

        interaction.mapcontrol = interaction.mapcontrol || _gui2.default.getService('map').getCurrentToggledMapControl() || null; //need to be set null when this.mapService.getCurrentToggledMapControl() is undefined
        interaction.interaction = new _pickcoordinatesinteraction2.default();

        _gui2.default.getService('map').addInteraction(interaction.interaction, { close: false });

        interaction.interaction.on('picked', function () {
          var _ref15 = _asyncToGenerator(function* (_ref14) {
            var coordinates = _ref14.coordinate;

            if (external_layer) {
              // call setQueryResponse setters method directly in case of external layer 
              _this11.setQueryResponse({
                data: [_this11.getVectorLayerFeaturesFromQueryRequest(_this11._vectorLayers.find(function (v) {
                  return layer.id === v.get('id');
                }), { coordinates: coordinates })],
                query: { coordinates: coordinates }
              }, { add: true });
            } else {
              yield _data2.default.getData('query:coordinates', {
                inputs: {
                  coordinates: coordinates,
                  query_point_tolerance: _this11._project.getQueryPointTolerance(),
                  layerIds: [layer.id],
                  multilayers: false
                },
                outputs: {
                  show: { add: true }
                }
              });
            }
          });

          return function (_x19) {
            return _ref15.apply(this, arguments);
          };
        }());

        interaction.toggleeventhandler = function (evt) {
          if (evt.target.isToggled() && evt.target.isClickMap()) {
            layer.addfeaturesresults.active = false;
          }
        };

        _gui2.default.getService('map').once('mapcontrol:toggled', interaction.toggleeventhandler);
      }
    }

    /**
     * used by the following plugins: "bforest"
     */

  }, {
    key: 'deactiveQueryInteractions',
    value: function deactiveQueryInteractions() {
      this.state.layers.forEach(function (l) {
        if (l.addfeaturesresults) {
          l.addfeaturesresults.active = false;
        }
      });
      this.removeAddFeaturesLayerResultInteraction();
    }

    /**
     * @FIXME add description
     *
     * @param layer
     * @param options
     */

  }, {
    key: 'zoomToLayerFeaturesExtent',
    value: function zoomToLayerFeaturesExtent(layer) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      options.highlight = !this.isOneLayerResult();
      if (this._asyncFnc.zoomToLayerFeaturesExtent.async) {
        this._asyncFnc.todo = _gui2.default.getService('map').zoomToFeatures.bind(_gui2.default.getService('map'), layer.features || [], options);
      } else {
        _gui2.default.getService('map').zoomToFeatures(layer.features || [], options);
      }
    }

    /**
     * @FIXME add description
     *
     * @param layer
     * @param options
     */

  }, {
    key: 'highLightLayerFeatures',
    value: function highLightLayerFeatures(layer) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (this._asyncFnc.highLightLayerFeatures.async) {
        this._asyncFnc.todo = _gui2.default.getService('map').highlightFeatures.bind(_gui2.default.getService('map'), layer.features || [], options);
      } else {
        _gui2.default.getService('map').highlightFeatures(layer.features || [], options);
      }
    }

    /**
     * Reset internal state
     */

  }, {
    key: 'clearState',
    value: function clearState() {
      this.state.layers.splice(0);
      this.state.query = null;
      this.state.querytitle = "";
      this.state.changed = false;
      // clear actions
      Object.values(this.state.layersactions).forEach(function (l) {
        return l.forEach(function (a) {
          return a.clear && a.clear();
        });
      });
      this.state.layersactions = {};
      this.state.actiontools = {};
      this.state.layeractiontool = {};
      this.state.currentactiontools = {};
      this.state.layersFeaturesBoxes = {};
      this.removeAddFeaturesLayerResultInteraction();
    }

    /**
     * @FIXME add description
     */

  }, {
    key: 'getState',
    value: function getState() {
      return this.state;
    }

    /**
     * @FIXME add description
     *
     * @param state
     */

  }, {
    key: 'setState',
    value: function setState(state) {
      this.state = state;
    }

    /**
     * @FIXME add description
     *
     * @param project
     */

  }, {
    key: '_setRelations',
    value: function _setRelations(project) {
      this._relations = (project.getRelations() || []).reduce(function (group, r) {
        group[r.referencedLayer] = group[r.referencedLayer] || [];
        group[r.referencedLayer].push(r);
        return group;
      }, {});
    }

    /**
     * @FIXME add description
     *
     * @param querytitle
     */

  }, {
    key: 'setTitle',
    value: function setTitle(querytitle) {
      this.state.querytitle = querytitle || "";
    }

    /**
     * @FIXME add description
     *
     * @param actionId
     * @param layer
     * @param feature
     * @param index
     * @param container
     */

  }, {
    key: 'trigger',
    value: function () {
      var _ref16 = _asyncToGenerator(function* (actionId, layer, feature, index, container) {
        if ('highlightgeometry' === actionId) {
          this.highlightGeometry(layer, feature, index);
        }
        if ('clearHighlightGeometry' === actionId) {
          this.clearHighlightGeometry(layer, feature, index);
        }
        if (layer && this.state.layersactions[layer.id]) {
          var action = this.state.layersactions[layer.id].find(function (layerAction) {
            return layerAction.id === actionId;
          });
          if (action && action.cbk) {
            yield action.cbk(layer, feature, action, index, container);
          }
          if (action && action.route) {
            var url = action.route.replace(/{(\w*)}/g, function (m, key) {
              return feature.attributes.hasOwnProperty(key) ? feature.attributes[key] : "";
            });
            if (url && '' !== url) {
              _gui2.default.goto(url);
            }
          }
        }
      });

      function trigger(_x22, _x23, _x24, _x25, _x26) {
        return _ref16.apply(this, arguments);
      }

      return trigger;
    }()

    /**
     * @FIXME add description
     *
     * @param vectorLayer
     */

  }, {
    key: 'registerVectorLayer',
    value: function registerVectorLayer(vectorLayer) {
      if (!this._vectorLayers.includes(vectorLayer)) {
        this._vectorLayers.push(vectorLayer);
      }
    }

    /**
     * @FIXME add description
     *
     * @param vectorLayer
     */

  }, {
    key: 'unregisterVectorLayer',
    value: function unregisterVectorLayer(vectorLayer) {
      var _this12 = this;

      this._vectorLayers = this._vectorLayers.filter(function (vl) {
        _this12.state.layers = _this12.state.layers.filter(function (l) {
          return l.id !== vectorLayer.get('id');
        });
        return vl !== vectorLayer;
      });
    }

    /**
     * @FIXME add description
     *
     * @param vectorLayer
     * @param query
     *
     * @returns {Object|Boolean}
     */

  }, {
    key: 'getVectorLayerFeaturesFromQueryRequest',
    value: function getVectorLayerFeaturesFromQueryRequest(vectorLayer) {
      var query = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var coordinates = query.coordinates,
          bbox = query.bbox,
          geometry = query.geometry,
          _query$filterConfig = query.filterConfig,
          filterConfig = _query$filterConfig === undefined ? {} : _query$filterConfig; // extract information about a query type

      var features = [];

      var has_coords = coordinates && Array.isArray(coordinates);
      var has_bbox = bbox && Array.isArray(bbox);

      // case query coordinates
      if (has_coords) {
        _gui2.default.getService('map').viewer.map.forEachFeatureAtPixel(_gui2.default.getService('map').viewer.map.getPixelFromCoordinate(coordinates), function (f) {
          features.push(f);
        }, { layerFilter: function layerFilter(l) {
            return l === vectorLayer;
          } });
      }

      // case query bbox
      if (has_bbox && !has_coords) {
        //set geometry has Polygon
        geometry = ol.geom.Polygon.fromExtent(bbox);
      }

      var is_poly = geometry instanceof ol.geom.Polygon || geometry instanceof ol.geom.MultiPolygon;

      // check query geometry (Polygon or MultiPolygon)
      if (is_poly && !has_coords && _vectorlayer.VectorLayer === vectorLayer.constructor) {
        features = vectorLayer.getIntersectedFeatures(geometry);
      } else if (is_poly && !has_coords && ol.layer.Vector === vectorLayer.constructor) {
        vectorLayer.getSource().getFeatures().forEach(function (f) {
          var add = void 0;
          switch (filterConfig.spatialMethod) {
            case 'within':
              add = (0, _within.within)(geometry, f.getGeometry());break;
            case 'intersects':
            default:
              add = (0, _intersects.intersects)(geometry, f.getGeometry());break;
          }
          if (true === add) {
            features.push(f);
          }
        });
      }

      return {
        features: features,
        layer: vectorLayer
      };
    }

    /**
     *  @FIXME add description
     */

  }, {
    key: '_printSingleAtlas',
    value: function _printSingleAtlas() {
      var _ref17 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref17$atlas = _ref17.atlas,
          atlas = _ref17$atlas === undefined ? {} : _ref17$atlas,
          _ref17$features = _ref17.features,
          features = _ref17$features === undefined ? [] : _ref17$features;

      var field = atlas.atlas && atlas.atlas.field_name ? atlas.atlas.field_name : '$id';
      return (0, _printAtlas.printAtlas)({
        field: field,
        values: features.map(function (feat) {
          return feat.attributes['$id' === field ? _g3wConstants.G3W_FID : field];
        }),
        template: atlas.name,
        download: true
      }).then(function (_ref18) {
        var url = _ref18.url;
        return _gui2.default.downloadWrapper(_downloadFile.downloadFile, { url: url, filename: atlas.name, mime_type: 'application/pdf' });
      });
    }

    /**
     * @FIXME add description
     *
     * @param ids
     * @param container
     * @param relationData
     */

  }, {
    key: 'showChart',
    value: function showChart(ids, container, relationData) {
      this.emit('show-chart', ids, container, relationData);
    }

    /**
     * @FIXME add description
     * 
     * @param container DOM element
     */

  }, {
    key: 'hideChart',
    value: function hideChart(container) {
      this.emit('hide-chart', container);
    }

    /**
     * @FIXME add description
     *
     * @param layer
     * @param feature
     */

  }, {
    key: 'printAtlas',
    value: function printAtlas(layer, feature) {
      var _this13 = this;

      var features = feature ? [feature] : layer.features;
      var atlasLayer = this._atlas.filter(function (a) {
        return a.atlas.qgs_layer_id === layer.id;
      });

      /** @FIXME add description */
      if (atlasLayer.length <= 1) {
        this._printSingleAtlas({ features: features, atlas: atlasLayer[0] });
        return;
      }

      var inputs = '';

      atlasLayer.forEach(function (atlas, index) {
        var id = (0, _getUniqueDomId.getUniqueDomId)();
        inputs += '<input id="' + id + '" g3w_atlas_index="' + index + '" class="magic-radio" type="radio" name="template" value="' + atlas.name + '"/>';
        inputs += '<label for="' + id + '">' + atlas.name + '</label>';
        inputs += '<br>';
      });

      _gui2.default.showModalDialog({
        title: (0, _g3wI18n.t)('sdk.atlas.template_dialog.title'),
        message: inputs,
        buttons: {
          success: {
            label: "OK",
            className: "skin-button",
            callback: function callback() {
              var index = $('input[name="template"]:checked').attr('g3w_atlas_index');
              if (undefined === index) {
                return false; // prevent default
              }
              _this13._printSingleAtlas({ features: features, atlas: atlasLayer[index] });
            }
          }
        }
      });
    }

    /**
     * @FIXME add description
     *
     * @param layer
     */

  }, {
    key: 'showLayerDownloadFormats',
    value: function showLayerDownloadFormats(layer) {
      layer.downloadformats.active = !layer.downloadformats.active;
      this.setLayerActionTool({
        layer: layer,
        component: layer.downloadformats.active ? _QueryResultsActionDownloadFormats2.default : null,
        config: layer.downloadformats.active ? _extends({}, this.state.actiontools.downloadformats[layer.id], {
          //for download layer need to filter pdf format because it works only for a single feature
          downloads: this.state.actiontools.downloadformats[layer.id].downloads.filter(function (d) {
            return 'pdf' !== d.format;
          })
        }) : null
      });
    }

    /**
     * @FIXME add description
     *
     * @param type
     * @param layer
     * @param features
     * @param action
     * @param index
     * @param html
     */

  }, {
    key: 'downloadFeatures',
    value: function () {
      var _ref19 = _asyncToGenerator(function* (type, layer) {
        var features = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
        var action = arguments[3];

        var _this14 = this;

        var index = arguments[4];
        var html = arguments[5];


        if (features && !Array.isArray(features)) {
          features = [features];
        }

        var _state$query = this.state.query,
            query = _state$query === undefined ? {} : _state$query;

        var data = {
          fids: features.map(function (f) {
            return f.attributes[_g3wConstants.G3W_FID];
          }).join(',')
        };

        //In the case of pdf type need to add html element
        if ('pdf' === type) {
          data.html = html;
        }

        /**
         * A function that che be called in case of querybypolygon
         *
         * @param active
         */
        var runDownload = function () {
          var _ref20 = _asyncToGenerator(function* () {
            var active = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;


            if (features.length > 1) {
              layer.downloadformats.active = active;
              _this14.setLayerActionTool({ layer: layer });
            }

            yield _gui2.default.downloadWrapper(function () {
              var _ref21 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                  layer = _ref21.layer,
                  type = _ref21.type,
                  data = _ref21.data;

              return (0, _getCatalogLayerById.getCatalogLayerById)(layer.id).getDownloadFilefromDownloadDataType(type, { data: data }) || Promise.resolve();
            }, {
              layer: layer,
              type: type,
              data: data
            });

            var downloadsactions = _this14.state.layersactions[layer.id].find(function (action) {
              return 'downloads' === action.id;
            });

            /** @FIXME add description */
            if (features.length > 1 && undefined === downloadsactions) {
              layer[type].active = false;
              _this14.setLayerActionTool({ layer: layer });
            }

            /** @FIXME add description */
            if (features.length > 1 && undefined !== downloadsactions) {
              layer.downloadformats.active = false;
            }

            /** @FIXME add description */
            if (features.length <= 1 && undefined === downloadsactions) {
              action.state.toggled[index] = false;
            }

            /** @FIXME add description */
            if (features.length <= 1 && undefined !== downloadsactions) {
              downloadsactions.state.toggled[index] = false;
            }

            /** @FIXME add description */
            if (features.length <= 1) {
              _this14.setCurrentActionLayerFeatureTool({ index: index, action: action, layer: layer });
            }
          });

          return function runDownload() {
            return _ref20.apply(this, arguments);
          };
        }();

        /** @FIXME add description */
        if ('polygon' !== query.type) {
          yield runDownload();
          return;
        }

        // check if multi-download if present
        var downloadsactions = this.state.layersactions[layer.id].find(function (action) {
          return action.id === 'downloads';
        });

        var config = {
          choices: [{
            id: (0, _getUniqueDomId.getUniqueDomId)(),
            type: 'feature',
            label: 'sdk.mapcontrols.querybypolygon.download.choiches.feature.label'
          }, {
            id: (0, _getUniqueDomId.getUniqueDomId)(),
            type: 'polygon',
            label: 'sdk.mapcontrols.querybypolygon.download.choiches.feature_polygon.label'
          }],
          // choose between only feature attribute or also polygon attribute
          download: function download(type) {
            if ('polygon' === type) {
              // id type polygon add parameters to api download
              data.sbp_qgs_layer_id = layer.id;
              data.sbp_fid = query.fid;
            } else {
              // force to remove
              delete data.sbp_fid;
              delete data.sbp_qgs_layer_id;
            }
            runDownload(true);
          }
        };

        /** @FIXME add description */
        if (1 === features.length && undefined === downloadsactions) {
          action.state.toggled[index] = true;
        }

        /** @FIXME add description */
        if (1 === features.length) {
          this.state.actiontools[_QueryResultsActionQueryPolygonCSVAttributes2.default.name] = this.state.actiontools[layer.id] || {};
          this.state.actiontools[_QueryResultsActionQueryPolygonCSVAttributes2.default.name][layer.id] = config;
          this.setCurrentActionLayerFeatureTool({
            layer: layer,
            index: index,
            action: action,
            component: _QueryResultsActionQueryPolygonCSVAttributes2.default
          });
        }

        /** @FIXME add description */
        if (undefined === downloadsactions && 1 !== features.length) {
          layer[type].active = !layer[type].active;
        }

        /** @FIXME add description */
        if (1 !== features.length) {
          var has_config = downloadsactions || layer[type].active && undefined === downloadsactions;
          this.setLayerActionTool({
            layer: layer,
            component: has_config ? _QueryResultsActionQueryPolygonCSVAttributes2.default : null,
            config: has_config ? config : null
          });
        }
      });

      function downloadFeatures(_x30, _x31) {
        return _ref19.apply(this, arguments);
      }

      return downloadFeatures;
    }()

    /**
     * @FIXME add description
     *
     * @param layer
     * @param feature
     */

  }, {
    key: 'goToGeometry',
    value: function goToGeometry(layer, feature) {
      var _this15 = this;

      if (!feature.geometry) {
        return;
      }
      if (this._asyncFnc.goToGeometry.async) {
        this._asyncFnc.todo = _gui2.default.getService('map')[this.isOneLayerResult() ? 'zoomToFeatures' : 'highlightGeometry'].bind(_gui2.default.getService('map'), this.isOneLayerResult() ? [feature] : feature.geometry, this.isOneLayerResult() ? {} : { layerId: layer.id, duration: 1500 });
      } else {
        setTimeout(function () {
          return _gui2.default.getService('map')[_this15.isOneLayerResult() ? 'zoomToFeatures' : 'highlightGeometry'](_this15.isOneLayerResult() ? [feature] : feature.geometry, _this15.isOneLayerResult() ? {} : { layerId: layer.id, duration: 1500 });
        });
      }
    }

    /**
     * @FIXME add description
     *
     * @param layer
     * @param feature
     */

  }, {
    key: 'highlightGeometry',
    value: function highlightGeometry(layer, feature) {
      if (feature.geometry) {
        _gui2.default.getService('map').highlightGeometry(feature.geometry, { layerId: layer.id, zoom: false, duration: Infinity });
      }
    }

    /**
     * @FIXME add description
     *
     * @param layer
     */

  }, {
    key: 'clearHighlightGeometry',
    value: function clearHighlightGeometry(layer) {
      _gui2.default.getService('map').clearHighlightGeometry();
    }

    /**
     * Handle show Relation on result
     * @param { Object } opts
     * @param opts.relation
     * @param opts.layerId  current layer father id
     * @param opts.feature  current feature father id
     */

  }, {
    key: 'showRelation',
    value: function showRelation() {
      var _ref22 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          relation = _ref22.relation,
          layerId = _ref22.layerId,
          feature = _ref22.feature;

      var projectRelation = this._project.getRelationById(relation.name);
      _gui2.default.pushContent({
        content: new _g3wComponent2.default({
          vueComponentObject: require('components/Relation.vue'),
          propsData: {
            relation: projectRelation,
            chartRelationIds: this.plotLayerIds.find(function (pid) {
              return pid == projectRelation.referencingLayer;
            }) ? [projectRelation.referencingLayer] : [],
            nmRelation: this._project.getRelationById(relation.nmRelationId),
            layer: { id: layerId },
            feature: feature
          }
        }),
        crumb: {
          title: projectRelation.name,
          text: true
        },
        title: projectRelation.name,
        text: true,
        closable: false
      });
    }
  }, {
    key: '_getFeatureId',


    /**
     * Get id of the  feature
     *
     * @since 3.9.0
     */
    value: function _getFeatureId(feature, external) {
      return external ? feature.id : feature.attributes[_g3wConstants.G3W_FID];
    }

    /**
     * @TODO make it simpler..
     * @TODO make it a Layers class function ? 
     * 
     * Add / Remove features from selection
     * 
     * ORIGINAL SOURCE: src/app/gui/queryresults/queryresultsservice.js@3.8.12::addToSelection
     * 
     * @since 3.9.0
     */

  }, {
    key: 'addToSelection',
    value: function addToSelection(layer, feature, action, index) {

      var service = _gui2.default.getService('queryresults');
      var map = _gui2.default.getService('map');

      // TODO: avoid referencing this private stuff
      var getFeatureId = service._getFeatureId.bind(service);
      var getActionLayerById = service.getActionLayerById.bind(service);

      //is true when click on the selection icon on top of each layer result
      var layerSelection = undefined === feature && undefined === action && undefined === index;

      var _action = layerSelection ? getActionLayerById({ layer: layer, id: 'selection' }) : action;
      var toggled = layerSelection && Object.values(_action.state.toggled).reduce(function (prev, curr) {
        return prev && curr;
      }, true);
      var _layer = layerSelection ? layer.external ? layer : (0, _getCatalogLayerById.getCatalogLayerById)(layer.id) : (service.state.layers.find(function (l) {
        return l.id === layer.id;
      }) || {}).external || false ? layer : (0, _getCatalogLayerById.getCatalogLayerById)(layer.id);
      var features = layerSelection ? layer.features && layer.features.length ? layer.features : [] : [feature];
      var params = layerSelection ? {
        fids: features.length > 0 ? features.map(function (f) {
          return _layer.external ? f.id : f.attributes[_g3wConstants.G3W_FID];
        }) : null,
        features: features,
        force: toggled ? 'remove' : 'add'
      } : {
        fids: [feature ? getFeatureId(feature, _layer.external) : null],
        features: features,
        index: index,
        force: undefined
      };

      //in case, switch selection for all features of a layer
      if (layerSelection) {
        layer.features.forEach(function (f, i) {
          _action.state.toggled[i] = !toggled;
          f.selection.selected = _action.state.toggled[i];
        });
      } else {
        //in the case of switch selection on single feature layer
        _action.state.toggled[index] = !_action.state.toggled[index];
        feature.selection.selected = _action.state.toggled[index];
      }

      //In case of pagination and toggled selection layer
      if (toggled && layerSelection) {
        _layer.clearSelectionFids();
        return;
      }

      /**
       * PROJECT LAYER
       */
      if (!layer.external && ![null, undefined].includes(params.fids)) {
        var _layer2 = _layer;
        var fids = params.fids,
            _features = params.features,
            force = params.force;


        fids = Array.isArray(fids) ? fids : [fids];
        _features = Array.isArray(_features) ? _features : [_features];

        var include = []; // fid of features to include
        var exclude = []; // fid of features to exclude

        fids.forEach(function (fid, idx) {
          var feature = _features[idx];
          var is_selected = _layer2.state.filter.active || _layer2.hasSelectionFid(fid);

          // if not already selected and feature is not added to OL selection layer on map --> add as feature of selected layer
          if (!is_selected && feature && feature.geometry && !_layer2.getOlSelectionFeature(fid)) {
            _layer2.addOlSelectionFeature({ id: fid, feature: feature });
          }

          // force action
          if (undefined === force) {
            _layer2[is_selected ? 'excludeSelectionFid' : 'includeSelectionFid'](fid);
          }

          // force add
          if ('add' === force && !is_selected) {
            include.push(fid);
          }

          // force remove
          if ('remove' === force) {
            exclude.push(fid);
          }
        });

        _layer2.includeSelectionFids(include, false);
        _layer2.excludeSelectionFids(exclude, false);

        (_layer2.state.filter.active ? _layer2.createFilterToken() : Promise.resolve()).then(function () {
          var _GUI$getService$getSt = _gui2.default.getService('queryresults').getState(),
              layers = _GUI$getService$getSt.layers;

          /** @TODO add description */


          fids.forEach(function (fid, idx) {
            var currentLayer = !_layer2.hasSelectionFid(fid) && _layer2.state.filter.active && _layer2.getSelectionFids().size > 0 && layers.find(function (l) {
              return l.id === _layer2.getId();
            });
            if (currentLayer) {
              currentLayer.features.splice(undefined === index ? idx : index, 1);
            }
          });

          map.clearHighlightGeometry();

          /** @TODO add description */
          if (1 === layers.length && !layers[0].features.length) {
            layers.splice(0);
          }
        });
      }

      /**
       * EXTERNAL LAYER
       */
      if (layer.external && ![null, undefined].includes(params.fids)) {

        var _layer3 = _layer;
        var _fids = params.fids,
            _features2 = params.features,
            _force = params.force;

        //Take in an account array or single fid

        _features2 = Array.isArray(_features2) ? _features2 : [_features2];

        //check if layer.selection.features is undefined
        if (undefined === _layer3.selection.features) {
          //set array
          _layer3.selection.features = [];
        }

        _fids.forEach(function (fid, i) {
          var feature = _features2[i];

          // Set feature used in selection tool action
          if (undefined === _layer3.selection.features.find(function (f) {
            return f.getId() === fid;
          })) {
            // create ol feature from an object
            var feat = feature;
            var attributes = feature.attributes;

            if (feature.geometry) {
              feat = new ol.Feature(feature.geometry);
              feat.setId(fid);
            }
            Object.keys(attributes).forEach(function (attr) {
              return feat.set(attr, attributes[attr]);
            });
            feat.__layerId = _layer3.id;
            feat.selection = feature.selection;
            _layer3.selection.features.push(feat);
          }

          //check if feature is already select or feature is already removed (no selected)
          /** If not, changes to apply return */
          if ('add' === _force && feature.selection.selected || 'remove' === _force && !feature.selection.selected) {
            return;
          }

          /** Need to add selection on map */
          map.setSelectionFeatures(feature.selection.selected ? 'add' : 'remove', {
            feature: _layer3.selection.features.find(function (selectionFeature) {
              return fid === selectionFeature.getId();
            })
          });
        });

        // Set selection layer active based on features selection selected properties.
        _layer3.selection.active = _layer3.selection.features.reduce(function (acc, feature) {
          return acc || feature.selection.selected;
        }, false);
      }
    }
  }]);

  return QueryResultsService;
}(_g3wObject2.default))();

},{"components/QueryResultsActionDownloadFormats.vue":129,"components/QueryResultsActionQueryPolygonCSVAttributes.vue":131,"components/Relation.vue":136,"components/RelationsPage.vue":138,"g3w-component":158,"g3w-constants":159,"g3w-eventbus":160,"g3w-i18n":162,"g3w-object":163,"map/interactions/pickcoordinatesinteraction":184,"map/layers/layer":190,"map/layers/vectorlayer":193,"services/data":206,"services/gui":207,"store/application":212,"utils/copyUrl":224,"utils/downloadFile":235,"utils/getAlphanumericPropertiesFromFeature":237,"utils/getCatalogLayerById":238,"utils/getUniqueDomId":252,"utils/intersects":256,"utils/printAtlas":266,"utils/throttle":276,"utils/within":279}],211:[function(require,module,exports){
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * @file
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * @since v3.6
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */


var _XHR = require('utils/XHR');

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * SERVER
 * """Returns the (possibly) new layer ID where the isochrone
 data has been added. If the task has not yet completed, a status message is returned

 Note: `project_id` is only used for permissions checking!

 Returns 500 in case of exception
 Returns 404 in case of a task didn't find
 Returns 200 ok for all other cases

 Response body:

 {
    "status": "complete",  // or "pending" or "error", full list at
                         // https://huey.readthedocs.io/en/latest/signals.html#signals
    "exception": "Normally empty, error message in case of errors",
    "progress": [
      100,  // Progress %
    ],
    "task_result": {
        "qgis_ayer_id": "4f2a88a1-ca93-4859-9de3-75d9728cde0e"
     }
  }

 **/

/**
 * Singletone service to run async task
 */
exports.default = new (function () {
  function TaskService() {
    _classCallCheck(this, TaskService);

    /**
     * Array contains all task id that are running. Each item is an object contain:
     * {
     *   taskId: //taskId,
     *   intervalId: interval to clear clearInterval()
     * }
     **/
    this.tasks = [];
  }

  /**
   *
   * @param opts: {
   *   method: http method to run task GET/POST
   *   url: api request url (that server start in background task)
   *   taskUrl = url to ask the status og task
   *   params: Object contain param to http/https request
   *   interval: interval in milliseconds to do a request for ask status of task (default 10000 - 1 second)
   *   listener: ()=>{} method to call
   *
   * }
   *
   * return a Promise that return a task id
   */


  _createClass(TaskService, [{
    key: 'runTask',
    value: function () {
      var _ref = _asyncToGenerator(function* () {
        var _this = this;

        var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var _opts$method = opts.method,
            method = _opts$method === undefined ? 'GET' : _opts$method,
            _opts$params = opts.params,
            params = _opts$params === undefined ? {} : _opts$params,
            url = opts.url,
            taskUrl = opts.taskUrl,
            _opts$interval = opts.interval,
            interval = _opts$interval === undefined ? 1000 : _opts$interval,
            _opts$timeout = opts.timeout,
            timeout = _opts$timeout === undefined ? Infinity : _opts$timeout,
            _opts$listener = opts.listener,
            listener = _opts$listener === undefined ? function () {} : _opts$listener;

        try {
          var response = 'GET' === method ? yield _XHR.XHR.get({
            url: url,
            params: params
          }) : yield _XHR.XHR.post({
            url: url,
            data: params.data || {},
            contentType: params.contentType || "application/json"
          });
          var result = response.result,
              task_id = response.task_id;

          if (result) {
            var intervalId = setInterval(_asyncToGenerator(function* () {
              // check if timeout is defined
              timeout = timeout - interval;
              if (timeout > 0) {
                var _response = void 0;
                try {
                  _response = yield _XHR.XHR.get({
                    url: '' + taskUrl + task_id
                  });
                } catch (e) {
                  _response = e;
                  console.warn(e);
                }
                listener({
                  task_id: task_id,
                  timeout: false,
                  response: _response
                });
              } else {
                listener({
                  timeout: true
                });
                _this.stopTask({
                  task_id: task_id
                });
              }
            }), interval);

            // add current task to list of task
            this.tasks.push({
              task_id: task_id,
              intervalId: intervalId
            });

            // run first time listener function
            listener({
              task_id: task_id,
              response: response
            });
          } else {
            return Promise.reject(response);
          }
        } catch (e) {
          console.warn(e);
          return Promise.reject(e);
        }
      });

      function runTask() {
        return _ref.apply(this, arguments);
      }

      return runTask;
    }()
  }, {
    key: 'stopTask',


    /**
     *
     * @param opts: {
     *   taskId: taskId that is running
     * }
     */
    value: function stopTask() {
      var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var task = this.tasks.find(function (t) {
        return opts.task_id === t.task_id;
      });
      if (task) {
        clearInterval(task.intervalId);
      }
    }
  }, {
    key: 'clear',


    /**
     * clare all task
     */
    value: function clear() {
      var _this2 = this;

      this.tasks.forEach(function (_ref3) {
        var taskId = _ref3.taskId;
        return _this2.stopTask({ taskId: taskId });
      });
      //reset to empty tasks
      this.tasks.splice(0);
    }
  }]);

  return TaskService;
}())();

},{"utils/XHR":215}],212:[function(require,module,exports){
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _g3wObject = require('g3w-object');

var _g3wObject2 = _interopRequireDefault(_g3wObject);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * State of application reactive
 * @type {object}
 */
var STATE = Vue.observable({

  /**
   * true = application is ready
   */
  ready: false,

  /**
   * true = application is loaded inside an iframe
   */
  iframe: window.top !== window.self,

  /**
   * true = application is connected
   */
  online: navigator.onLine,

  /**
   * true = application is loaded on a mobile device
   */
  ismobile: isMobile.any,

  /**
   * true = there is a pending download 
   */
  download: false,

  /**
   * true = there is a pending upload
   */
  upload: false,

  /**
   * Store current map base layer id
   */
  baseLayerId: null,

  /**
   * en = default language
   */
  language: 'en',

  /**
   * @deprecated Since v3.8. Will be deleted in v4.x. Use ApplicationState.language instead
   */
  lng: 'en',

  /**
   * Store Array of loading plugins (by name)
   * Every time a plugin is loaded, plugin name is removed from Array
   * It used in v-plugins directive
   */
  plugins: [],

  /** @since 3.11.0 - plugin configs filtered by gid */
  pluginsConfigs: {},

  /** @since 3.11.0 - array of initConfig.plugins names */
  configurationPlugins: [],

  /**
   * Store application current user
   */
  user: null,

  /**
   * Store info of the application map
   */
  map: {
    epsg: '',
    unit: 'metric'
  },

  /**
   * Store info of the elements of GUI of the application
   */
  gui: {

    app: {
      /**
       * true = application is disabled and unclickable (waiting)
       */
      disabled: false
    },

    sidebar: {
      /**
       * true = sidebar is disabled (not responsive)
       */
      disabled: false,
      /**
       * @since v3.11.0
       * true open, false hide - icons only
       */
      open: true
    },

    layout: {
      /**
       * store the current layout owner ("app" = default)
       */
      __current: 'app',

      /**
       * Store application layout info (rightpanel)
       */
      app: {}

    }

  },

  /**
   * Sore vendor keys need it by application third part script
   */
  keys: {
    vendorkeys: {
      google: undefined,
      bing: undefined
    }
  },

  /**
   * Store tokens, used by server, for example, to filter features
   */
  tokens: {
    filtertoken: undefined
  },

  /**
   * @since 3.10.0
   */
  querybuilder: {
    cache: {},
    searches: JSON.parse(window.localStorage.getItem('QUERYBUILDERSEARCHES') || "{}")
  },

  /**
   * @since 3.11.0
   */
  navbaritems: [],

  /**
   * @since 3.11.0
   */
  sidebar: {
    title: '',
    components: [],
    /** DOM element where insert the component/panel  */
    parent: null,
    /** barstack state. It stores the panel array */
    contentsdata: [], // Array<{ content, options }>
    /** @since 3.11.3 - whether to enable close button  */
    btn_close: true,
    /** @since 3.11.3 - custom tooltip for close button */
    tooltip_close: 'close'
  },

  contentsdata: [],

  /**
   * @since 3.11.0
   */
  viewport: {
    primaryView: 'map', // primary view (default)
    // percentage of secondary view
    secondaryPerc: 0, // setted to 0 at beginning (not visible)
    // used to store if content vertical or horizontal is  changed by resised
    resized: {
      start: false,
      'h': false,
      'v': false
    },
    // splitting orientation (h = horizontal, v = vertical)
    split: 'h',
    //map
    map: {
      sizes: {
        width: 0,
        height: 0
      },
      aside: false
    },
    //content
    content: {
      loading: false,
      disabled: false,
      sizes: {
        width: 0,
        height: 0
      },
      // store the resize vertical or horizontal
      resize: {
        'h': { perc: 0 },
        'v': { perc: 0 }
      },
      aside: true,
      showgoback: true,
      stack: [], // array elements of stack contents
      closable: true, // (x) is closable
      backonclose: false, // back on prevoius content
      contentsdata: [] // content data array
    },
    usermessage: {
      id: null, // unique identify
      show: false,
      title: null,
      message: null,
      position: null,
      type: null,
      draggable: null,
      cloasable: null,
      autoclose: null,
      textMessage: false,
      hooks: {
        header: null,
        body: null,
        footer: null
      }
    },
    // content of viewport (map and content)
    components: {
      map: null,
      content: null
    }
  },

  sizes: {
    sidebar: {
      width: 0
    }
  },

  /** @since 3.11.0 */
  i18n: {
    plugins: {} // plugins configs
  },

  /** @since 3.11.0 */
  project: new _g3wObject2.default(),

  /** @since 3.11.0 */
  catalog: {},

  /** @since 3.11.0 */
  highlightlayers: false

}); /**
     * @file State and methods to query the STATE of application
     * @since v3.6
     */

exports.default = STATE;

},{"g3w-object":163}],213:[function(require,module,exports){
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _g3wObject = require('g3w-object');

var _g3wObject2 = _interopRequireDefault(_g3wObject);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Object where store plugin
 *   key   = plugin name
 *   value = plugin instance
 * 
 * @since 3.11.0
 */
var PLUGINS = {}; /**
                   * @file Store G3W-CLIENT plugins (editing, qplotly, qtimeseries, ...)
                   * @since v3.6
                   */

exports.default = Object.assign(new _g3wObject2.default(), { setters: {
    /** store plugin into registry (if not already registered) */
    registerPlugin: function registerPlugin(plugin) {
      PLUGINS[plugin.name] = PLUGINS[plugin.name] || plugin;
    }
  },
  /** @returns Plugin instance */
  getPlugin: function getPlugin(name) {
    return PLUGINS[name];
  }
});

},{"g3w-object":163}],214:[function(require,module,exports){
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _normalizeEpsg = require('utils/normalizeEpsg');

var _proj4Src = require('proj4/dist/proj4-src');

var _proj4Src2 = _interopRequireDefault(_proj4Src);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                            * @file
                                                                                                                                                                                                                                                                                                                                                                                                                                                                            *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                            * @since 3.11.0
                                                                                                                                                                                                                                                                                                                                                                                                                                                                            */


/**
 * ORIGINAL SOURCE: src/app/g3w-ol/projection/projection.js@v3.10.1
 * ORIGINAL SOURCE: src/app/g3w-ol/projection/projections.js@v3.10.1
 */
exports.default = {
  get: function get() {
    var crs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var p = ol.proj.get(crs.epsg);
    if (!p) {
      if (crs.proj4) {
        _proj4Src2.default.defs(crs.epsg, crs.proj4);
      }
      var proj = {
        code: crs.epsg,
        extent: crs.extent,
        axisOrientation: crs.axisinverted ? 'neu' : 'enu',
        units: crs.geographic ? 'degrees' : 'm'
      };
      p = new ol.proj.Projection(proj);
      p.getAxisOrientation = function () {
        return proj.axisOrientation;
      };
      ol.proj.addProjection(p);
      ol.proj.proj4.register(_proj4Src2.default);
    }
    return p;
  },


  /**
   * Check and register epsg
   * 
   * @param epsg : "EPSG:<CODE>" Ex. "EPSG:4326"
   * 
   * @returns { Promise<ol.proj.Projection> }
   * 
   * @since v3.8
   */
  registerProjection: function () {
    var _ref = _asyncToGenerator(function* (epsg) {
      var p = ol.proj.get(epsg) || undefined;

      // check if already registered
      if (!p) {
        var _ref2 = yield (yield fetch('/crs/' + epsg.split(':')[1] + '/')).json(),
            result = _ref2.result,
            data = _ref2.data;

        if (result) {
          data.epsg = (0, _normalizeEpsg.normalizeEpsg)(data.epsg);
          p = this.get(data);
          ol.proj.proj4.register(_proj4Src2.default);
          return p;
        }
      }

      return p;
    });

    function registerProjection(_x2) {
      return _ref.apply(this, arguments);
    }

    return registerProjection;
  }()
};

},{"proj4/dist/proj4-src":26,"utils/normalizeEpsg":263}],215:[function(require,module,exports){
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.XHR = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _g3wConstants = require('g3w-constants');

var _downloadFile = require('utils/downloadFile');

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var XHR = exports.XHR = {

  /**
   *
   * @param url
   * @param params
   * @param signal //@since 3.11.0 (e.g. const controller = new AbortController(); const signal = controller.signal; controller.abort();)   * @return {Promise<any|string>}
   */
  get: function () {
    var _ref = _asyncToGenerator(function* () {
      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          url = _ref2.url,
          _ref2$params = _ref2.params,
          params = _ref2$params === undefined ? {} : _ref2$params,
          signal = _ref2.signal;

      if (!url) {
        return Promise.reject('No url');
      }

      params = new URLSearchParams(JSON.parse(JSON.stringify(params || {}))).toString();

      var response = yield (yield fetch(url + (params ? '?' : '') + params, { signal: signal })).text();

      // Try to parse response as JSON
      try {
        return JSON.parse(response);
      } catch (e) {
        return response;
      }
    });

    function get() {
      return _ref.apply(this, arguments);
    }

    return get;
  }(),


  /**
   * @since 3.11.0
   * @param url
   * @param data
   * @param formdata
   * @param contentType
   * @param signal //@since 3.11.0 (e.g. const controller = new AbortController(); const signal = controller.signal; controller.abort();)
   * @return {Promise<any|string>}
   */
  put: function () {
    var _ref3 = _asyncToGenerator(function* () {
      var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          url = _ref4.url,
          data = _ref4.data,
          _ref4$formdata = _ref4.formdata,
          formdata = _ref4$formdata === undefined ? false : _ref4$formdata,
          contentType = _ref4.contentType,
          signal = _ref4.signal;

      if (formdata) {
        formdata = new FormData();
        Object.entries(data).forEach(function (_ref5) {
          var _ref6 = _slicedToArray(_ref5, 2),
              key = _ref6[0],
              value = _ref6[1];

          return formdata.append(key, value);
        });
      } else if (!contentType) {
        formdata = new URLSearchParams(JSON.parse(JSON.stringify(data || {}))).toString();
      } else {
        formdata = 'string' === typeof data ? data : JSON.stringify(data || {});
      }

      var response = yield (yield fetch(url, {
        method: 'PUT',
        body: formdata,
        headers: {
          'Content-Type': contentType || 'application/x-www-form-urlencoded'
        },
        signal: signal
      })).text();

      // Try to parse response as JSON
      try {
        return JSON.parse(response);
      } catch (e) {
        return response;
      }
    });

    function put() {
      return _ref3.apply(this, arguments);
    }

    return put;
  }(),


  /**
   *
   * @param url
   * @param data
   * @param formdata
   * @param contentType
   * @param signal //@since 3.11.0 (e.g. const controller = new AbortController(); const signal = controller.signal; controller.abort();)
   * @return {Promise<any|string>}
   */
  post: function () {
    var _ref7 = _asyncToGenerator(function* () {
      var _ref8 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          url = _ref8.url,
          data = _ref8.data,
          _ref8$formdata = _ref8.formdata,
          formdata = _ref8$formdata === undefined ? false : _ref8$formdata,
          contentType = _ref8.contentType,
          signal = _ref8.signal;

      if (formdata) {
        formdata = new FormData();
        Object.entries(data).forEach(function (_ref9) {
          var _ref10 = _slicedToArray(_ref9, 2),
              key = _ref10[0],
              value = _ref10[1];

          return formdata.append(key, value);
        });
      } else if (!contentType) {
        formdata = new URLSearchParams(JSON.parse(JSON.stringify(data || {}))).toString();
      } else {
        formdata = 'string' === typeof data ? data : JSON.stringify(data || {});
      }

      var response = yield (yield fetch(url, {
        method: 'POST',
        body: formdata,
        headers: {
          'Content-Type': contentType || 'application/x-www-form-urlencoded'
        },
        signal: signal
      })).text();

      // Try to parse response as JSON
      try {
        return JSON.parse(response);
      } catch (e) {
        return response;
      }
    });

    function post() {
      return _ref7.apply(this, arguments);
    }

    return post;
  }(),
  fileDownload: function fileDownload() {
    var _ref11 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        url = _ref11.url,
        data = _ref11.data,
        _ref11$httpMethod = _ref11.httpMethod,
        httpMethod = _ref11$httpMethod === undefined ? "POST" : _ref11$httpMethod,
        signal = _ref11.signal;

    var timeout = void 0;
    return new Promise(function () {
      var _ref12 = _asyncToGenerator(function* (resolve, reject) {
        try {
          timeout = setTimeout(function () {
            reject('Timeout');
          }, _g3wConstants.TIMEOUT);
          (0, _downloadFile.downloadFile)({
            url: 'GET' === httpMethod ? '' + url + (data ? '?' + new URLSearchParams(JSON.parse(JSON.stringify(data || {}))).toString() : '') : url,
            headers: {
              'Access-Control-Expose-Headers': 'Content-Disposition' //need to get filename from server
            },
            method: httpMethod,
            //set form data to download file @since 3.11.0 to replace $.fileDownload from 3.10.x
            data: 'POST' === httpMethod ? Object.keys(data || {}).reduce(function (a, k) {
              a.append(k, data[k]);return a;
            }, new FormData()) : undefined,
            signal: signal
          });
          return resolve();
        } catch (e) {
          return reject(e);
        } finally {
          clearTimeout(timeout);
        }
      });

      return function (_x5, _x6) {
        return _ref12.apply(this, arguments);
      };
    }());
  },


  /**
   * Delete request
   *
   * @param url
   * @param data
   * @param signal
   * 
   * @returns {Promise<Response>}
   * 
   * @since 3.10.0
   */
  delete: function () {
    var _ref14 = _asyncToGenerator(function* (_ref13) {
      var url = _ref13.url,
          _ref13$data = _ref13.data,
          data = _ref13$data === undefined ? {} : _ref13$data,
          signal = _ref13.signal;

      return (yield fetch(url, {
        method: 'DELETE',
        body: JSON.stringify(data),
        signal: signal
      })).json();
    });

    function _delete(_x7) {
      return _ref14.apply(this, arguments);
    }

    return _delete;
  }()
};

},{"g3w-constants":159,"utils/downloadFile":235}],216:[function(require,module,exports){
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addZValue = addZValue;

var _g3wConstants = require('g3w-constants');

var _is3DGeometry = require('utils/is3DGeometry');

/**
 * @since 3.10.0 Add a 3d coordinate eventually, if coordinates are 2 (x, y)
 * @param coords
 * @return {*}
 */
function add3DCoordinate(coords) {
  if (2 === coords.length) {
    coords.push(0);
  }
  return coords;
}

/**
 * core/geometry/geometry::addZValueToOLFeatureGeometry@v3.4
 */
function addZValue() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      feature = _ref.feature,
      geometryType = _ref.geometryType;

  if (!(0, _is3DGeometry.is3DGeometry)(geometryType)) {
    console.warn('Invalid 3D Geometry Type:', geometryType);
    return feature;
  }

  var geometry = feature.getGeometry();
  var coords = geometry.getCoordinates();

  switch (geometryType || geometry.getType()) {

    // POINT: [x, y]
    case _g3wConstants.GEOMETRY_TYPES.POINTZ:
    case _g3wConstants.GEOMETRY_TYPES.POINTM:
    case _g3wConstants.GEOMETRY_TYPES.POINTZM:
    case _g3wConstants.GEOMETRY_TYPES.POINT25D:
      feature.getGeometry().setCoordinates(add3DCoordinate(coords));
      break;

    // MULTIPOINT: [ [x1, y1], [x2, y2] ]
    case _g3wConstants.GEOMETRY_TYPES.MULTIPOINTZ:
    case _g3wConstants.GEOMETRY_TYPES.MULTIPOINTM:
    case _g3wConstants.GEOMETRY_TYPES.MULTIPOINTZM:
    case _g3wConstants.GEOMETRY_TYPES.MULTIPOINT25D:
    // LINE: [ [x1, y1], [x2, y2] ]
    case _g3wConstants.GEOMETRY_TYPES.LINESTRINGZ:
    case _g3wConstants.GEOMETRY_TYPES.LINESTRINGM:
    case _g3wConstants.GEOMETRY_TYPES.LINESTRINGZM:
    case _g3wConstants.GEOMETRY_TYPES.LINESTRING25D:
    case _g3wConstants.GEOMETRY_TYPES.LINEZ:
    case _g3wConstants.GEOMETRY_TYPES.LINEM:
    case _g3wConstants.GEOMETRY_TYPES.LINEZM:
    case _g3wConstants.GEOMETRY_TYPES.LINE25D:
      coords.forEach(function (c) {
        return add3DCoordinate(c);
      });
      feature.getGeometry().setCoordinates(coords);
      break;

    // MULTILINE: [
    //   [ [x1, y1], [x2, y2] ],
    //   [ [x3, y3], [x4, y4] ]
    // ]
    case _g3wConstants.GEOMETRY_TYPES.MULTILINESTRINGZ:
    case _g3wConstants.GEOMETRY_TYPES.MULTILINESTRINGM:
    case _g3wConstants.GEOMETRY_TYPES.MULTILINESTRINGZM:
    case _g3wConstants.GEOMETRY_TYPES.MULTILINESTRING25D:
    case _g3wConstants.GEOMETRY_TYPES.MULTILINEZ:
    case _g3wConstants.GEOMETRY_TYPES.MULTILINEM:
    case _g3wConstants.GEOMETRY_TYPES.MULTILINEZM:
    case _g3wConstants.GEOMETRY_TYPES.MULTILINE25D:
      coords.forEach(function (l) {
        return l.forEach(function (c) {
          return add3DCoordinate(c);
        });
      });
      feature.getGeometry().setCoordinates(coords);
      break;

    // POLYGON: [
    //   [ [x1, y1], [x2, y2], [x3, y3], [x1, y1] ]
    // ]
    case _g3wConstants.GEOMETRY_TYPES.POLYGONZ:
    case _g3wConstants.GEOMETRY_TYPES.POLYGONM:
    case _g3wConstants.GEOMETRY_TYPES.POLYGONZM:
    case _g3wConstants.GEOMETRY_TYPES.POLYGON25D:
      coords[0].forEach(function (c) {
        return add3DCoordinate(c);
      });
      feature.getGeometry().setCoordinates(coords);
      break;

    // MULTIPOLYGON:[
    //   [ [x1, y1], [x2, y2], [x3, y3], [x1, y1] ],
    //   [ [xa, ya], [xb, yb], [xc, yc], [xa, ya] ]
    // ]
    case _g3wConstants.GEOMETRY_TYPES.MULTIPOLYGONZ:
    case _g3wConstants.GEOMETRY_TYPES.MULTIPOLYGONM:
    case _g3wConstants.GEOMETRY_TYPES.MULTIPOLYGOZM:
    case _g3wConstants.GEOMETRY_TYPES.MULTIPOLYGON25D:
      coords.forEach(function (poly) {
        return poly[0].forEach(function (c) {
          return add3DCoordinate(c);
        });
      });
      feature.getGeometry().setCoordinates(coords);
      break;

    default:
      console.warn('invalid geometry type:', geometryType || geometry.getType());

  }

  return feature;
}

},{"g3w-constants":159,"utils/is3DGeometry":257}],217:[function(require,module,exports){
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.areCoordinatesEqual = areCoordinatesEqual;
/**
 * @param { Array } coordinates1
 * @param { Array } coordinates2
 * 
 * @returns { boolean }
 */
function areCoordinatesEqual() {
  var coordinates1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var coordinates2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  return coordinates1[0] === coordinates2[0] && coordinates1[1] === coordinates2[1];
}

},{}],218:[function(require,module,exports){
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.base = base;
/**
 * google closure library implementation
 */
function base(me, opt_methodName, var_args) {
  // who call base
  // noinspection JSAnnotator
  var caller = arguments.callee.caller;
  if (caller.superClass_) {
    // This function constructor (that inherits from superClass_).
    // Call the superclass constructor.
    //It is an easy way to cal superclass in binding to this
    return caller.superClass_.constructor.apply(me, Array.prototype.slice.call(arguments, 1));
  }
  var args = Array.prototype.slice.call(arguments, 2);
  var foundCaller = false;
  //constructor is the constructor function of the object
  for (var ctor = me.constructor; ctor; ctor = ctor.superClass_ && ctor.superClass_.constructor) {
    if (ctor.prototype[opt_methodName] === caller) {
      foundCaller = true;
    } else if (foundCaller) {
      return ctor.prototype[opt_methodName].apply(me, args);
    }
  }
  // If we did not find the caller in the prototype chain,
  // then one of two things happened:
  // 1) The caller is an instance method.
  // 2) This method was not called by the right caller.
  if (me[opt_methodName] === caller) {
    // call the function from a prototype object
    return me.constructor.prototype[opt_methodName].apply(me, args);
  } else {
    throw Error('base called from a method of one name ' + 'to a method of a different name');
  }
}

},{}],219:[function(require,module,exports){
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.colorHEXToRGB = colorHEXToRGB;
/**
 * Convert Hex value color to RGB array
 * 
 * @param color
 * 
 * @returns {number[]}
 */
function colorHEXToRGB() {
  var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '#FFFFFF';

  return [parseInt(color.substr(1, 2), 16), parseInt(color.substr(3, 2), 16), parseInt(color.substr(5, 2), 16)];
}

},{}],220:[function(require,module,exports){
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.convertFeatureToGEOJSON = convertFeatureToGEOJSON;
/**
 * Convert Feature to GeoJSON Format
 * 
 * @param feature
 */
function convertFeatureToGEOJSON(feature) {
  return new ol.format.GeoJSON().writeFeatureObject(feature);
}

},{}],221:[function(require,module,exports){
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.convertQGISDateTimeFormatToMoment = convertQGISDateTimeFormatToMoment;
/**
 * Covert datetime format from Qgis format to Moment
 * 
 * @param datetimeformat
 * 
 * @returns {*}
 */
function convertQGISDateTimeFormatToMoment(datetimeformat) {
  datetimeformat = datetimeformat.replace(/y/g, 'Y');
  var matchDayInDate = datetimeformat.match(/d/g);
  if (matchDayInDate && matchDayInDate.length < 3) {
    datetimeformat = datetimeformat.replace(/d/g, 'D');
  }
  return datetimeformat;
}

},{}],222:[function(require,module,exports){
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.convertSingleMultiGeometry = convertSingleMultiGeometry;

var _g3wConstants = require('g3w-constants');

var _isMultiGeometry = require('utils/isMultiGeometry');

/**
 * Convert geometry to geometryType (from Single to Multi or viceversa)
 * 
 * @param { ol.geom } geometry       current OL geometry
 * @param { string }  toGeometryType 
 */
function convertSingleMultiGeometry(geometry, toGeometryType) {
  var from_type = geometry.getType();

  if (!toGeometryType || toGeometryType === from_type) {
    return geometry;
  }

  var from_multi = (0, _isMultiGeometry.isMultiGeometry)(from_type);
  var to_multi = (0, _isMultiGeometry.isMultiGeometry)(toGeometryType);

  if (from_multi && !to_multi) {
    switch (geometry.getType()) {
      case _g3wConstants.GEOMETRY_TYPES.MULTIPOLYGON:
        return geometry.getPolygons();
      case _g3wConstants.GEOMETRY_TYPES.MULTILINE:
        return geometry.getLineStrings();
      case _g3wConstants.GEOMETRY_TYPES.MULTILINESTRING:
        return geometry.getLineStrings();
      case _g3wConstants.GEOMETRY_TYPES.MULTIPOINT:
        return geometry.getPoints();
      default:
        console.warn('invalid geometry type', geometry.getType());
    }
    return [];
  }

  if (!from_multi && to_multi) {
    return new ol.geom['Multi' + from_type]([geometry.getCoordinates()]);
  }

  return geometry;
}

},{"g3w-constants":159,"utils/isMultiGeometry":259}],223:[function(require,module,exports){
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.coordinatesToGeometry = coordinatesToGeometry;

var _g3wConstants = require('g3w-constants');

function coordinatesToGeometry(geometryType, coordinates) {

  switch (geometryType) {

    case _g3wConstants.GEOMETRY_TYPES.POLYGON:
    case _g3wConstants.GEOMETRY_TYPES.POLYGONZ:
    case _g3wConstants.GEOMETRY_TYPES.POLYGONM:
    case _g3wConstants.GEOMETRY_TYPES.POLYGONZM:
    case _g3wConstants.GEOMETRY_TYPES.POLYGON25D:
      return new ol.geom.Polygon(coordinates);

    case _g3wConstants.GEOMETRY_TYPES.MULTIPOLYGON:
    case _g3wConstants.GEOMETRY_TYPES.MULTIPOLYGONZ:
    case _g3wConstants.GEOMETRY_TYPES.MULTIPOLYGONM:
    case _g3wConstants.GEOMETRY_TYPES.MULTIPOLYGONZM:
    case _g3wConstants.GEOMETRY_TYPES.MULTIPOLYGON25D:
      return new ol.geom.MultiPolygon(coordinates);

    case _g3wConstants.GEOMETRY_TYPES.LINESTRING:
    case _g3wConstants.GEOMETRY_TYPES.LINESTRINGZ:
    case _g3wConstants.GEOMETRY_TYPES.LINESTRINGM:
    case _g3wConstants.GEOMETRY_TYPES.LINESTRINGZM:
    case _g3wConstants.GEOMETRY_TYPES.LINESTRING25D:
    case _g3wConstants.GEOMETRY_TYPES.LINE:
    case _g3wConstants.GEOMETRY_TYPES.LINEZ:
    case _g3wConstants.GEOMETRY_TYPES.LINEM:
    case _g3wConstants.GEOMETRY_TYPES.LINEZM:
    case _g3wConstants.GEOMETRY_TYPES.LINE25D:
      return new ol.geom.LineString(coordinates);

    case _g3wConstants.GEOMETRY_TYPES.MULTILINE:
    case _g3wConstants.GEOMETRY_TYPES.MULTILINEZ:
    case _g3wConstants.GEOMETRY_TYPES.MULTILINEM:
    case _g3wConstants.GEOMETRY_TYPES.MULTILINEZM:
    case _g3wConstants.GEOMETRY_TYPES.MULTILINE25D:
    case _g3wConstants.GEOMETRY_TYPES.MULTILINESTRING:
    case _g3wConstants.GEOMETRY_TYPES.MULTILINESTRINGZ:
    case _g3wConstants.GEOMETRY_TYPES.MULTILINESTRINGM:
    case _g3wConstants.GEOMETRY_TYPES.MULTILINESTRINGZM:
    case _g3wConstants.GEOMETRY_TYPES.MULTILINESTRING25D:
      return new ol.geom.MultiLineString(coordinates);

    case _g3wConstants.GEOMETRY_TYPES.POINT:
    case _g3wConstants.GEOMETRY_TYPES.POINTZ:
    case _g3wConstants.GEOMETRY_TYPES.POINTM:
    case _g3wConstants.GEOMETRY_TYPES.POINTZM:
    case _g3wConstants.GEOMETRY_TYPES.POINT25D:
      return new ol.geom.Point(coordinates);

    case _g3wConstants.GEOMETRY_TYPES.MULTIPOINT:
    case _g3wConstants.GEOMETRY_TYPES.MULTIPOINTZ:
    case _g3wConstants.GEOMETRY_TYPES.MULTIPOINTM:
    case _g3wConstants.GEOMETRY_TYPES.MULTIPOINTZM:
    case _g3wConstants.GEOMETRY_TYPES.MULTIPOINT25D:
      return new ol.geom.MultiPoint(coordinates);

    default:
      console.warn('invalid geometry type: ', geometryType);
      return new ol.geom.Point(coordinates);

  }
}

},{"g3w-constants":159}],224:[function(require,module,exports){
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.copyUrl = copyUrl;
function copyUrl(url) {
  var tempinput = document.createElement('input');
  document.body.appendChild(tempinput);
  tempinput.value = url;
  tempinput.select();
  document.execCommand('copy');
  document.body.removeChild(tempinput);
};

},{}],225:[function(require,module,exports){
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createFilterFormInputs = createFilterFormInputs;

var _createSingleFieldParameter = require('utils/createSingleFieldParameter');

/**
 * @param layer single layer or an array of layers
 * @param inputs
 * 
 * @returns {*}
 */
function createFilterFormInputs(_ref) {
  var layer = _ref.layer,
      _ref$inputs = _ref.inputs,
      inputs = _ref$inputs === undefined ? [] : _ref$inputs;


  var filters = void 0;

  var fields = inputs.map(function (_ref2, i) {
    var attribute = _ref2.attribute,
        value = _ref2.value,
        operator = _ref2.operator,
        logicop = _ref2.logicop;

    // multi key relation fields
    if (Array.isArray(attribute)) {
      return attribute.map(function (attr, j) {
        return (0, _createSingleFieldParameter.createSingleFieldParameter)({ field: attr, value: value[j], operator: operator, logicop: null });
      }).join('|AND,') || '';
    }
    // input logic operator 
    return '' + (i > 0 ? '|' + inputs[i - 1].logicop + ',' : '') + (0, _createSingleFieldParameter.createSingleFieldParameter)({ field: attribute, value: value, operator: operator, logicop: logicop });
  });

  var filter = fields.join('') || undefined; // NB: comma separator is already added before

  filters = [].concat(layer).map(function () {
    return filter;
  });

  // check if is a single layer of an array of layers
  return Array.isArray(layer) ? filters : filters[0];
}

},{"utils/createSingleFieldParameter":230}],226:[function(require,module,exports){
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.createFilterFromString = createFilterFromString;

var _g3wConstants = require('g3w-constants');

var operators = Object.entries(_g3wConstants.FILTER_EXPRESSION_OPERATORS);

function createFilterFromString(_ref) {
  var _ref$filter = _ref.filter,
      filter = _ref$filter === undefined ? '' : _ref$filter;

  filter = operators.reduce(function (acc, _ref2) {
    var _ref3 = _slicedToArray(_ref2, 2),
        _ = _ref3[0],
        op = _ref3[1];

    return acc.replace(new RegExp('\\s+' + op + '\\s+', 'g'), '' + op) // remove all blank space between operators
    .replace(new RegExp('\'' + op, 'g'), '' + op) // leading single quote
    .replace(new RegExp(op + '\'', 'g'), '' + op);
  } // trailing single quote
  , filter).replace(/'$/g, '').replace(/"/g, '');
  filter = operators.reduce(function (acc, _ref4) {
    var _ref5 = _slicedToArray(_ref4, 2),
        k = _ref5[0],
        op = _ref5[1];

    return acc.replace(new RegExp(op, 'g'), ['AND', 'OR'].includes(op) ? '|' + k + ',' : '|' + k + '|');
  }, filter)
  // encode value
  .split('|').map(function (v, i) {
    return 0 === (i + 1) % 3 ? encodeURIComponent(v) : v;
  }).join('|');

  return filter;
}

},{"g3w-constants":159}],227:[function(require,module,exports){
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createMeasureTooltip = createMeasureTooltip;

var _application = require("store/application");

var _application2 = _interopRequireDefault(_application);

var _isLineGeometryType = require("utils/isLineGeometryType");

var _isPolygonGeometryType = require("utils/isPolygonGeometryType");

var _isMultiGeometry = require("utils/isMultiGeometry");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * create and add measure tooltip 
 */
function createMeasureTooltip() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      map = _ref.map,
      feature = _ref.feature;

  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var element = document.createElement('div');
  element.className = 'mtooltip mtooltip-measure';

  var tooltip = new ol.Overlay({
    element: element,
    offset: [0, -15],
    positioning: 'bottom-center'
  });

  map.addOverlay(tooltip);

  return {
    tooltip: tooltip,
    unbyKey: feature.getGeometry().on('change', function (e) {
      var coords = void 0;
      var geom = e.target;

      if (geom instanceof ol.geom.Polygon) {
        coords = geom.getInteriorPoint().getCoordinates();
      } else if (geom instanceof ol.geom.MultiPolygon) {
        coords = geom.getInteriorPoints().getCoordinates()[0];
      } else if (geom instanceof ol.geom.LineString || geom instanceof ol.geom.MultiLineString) {
        coords = geom.getLastCoordinate();
      }

      var projection = map.getView().getProjection();
      var is_line = (0, _isLineGeometryType.isLineGeometryType)(geom.getType());
      var is_poly = (0, _isPolygonGeometryType.isPolygonGeometryType)(geom.getType());
      var is_multi = (0, _isMultiGeometry.isMultiGeometry)(geom.getType());
      var is_sphere = 'EPSG:3857' === projection.getCode() || 'degrees' === projection.getUnits();
      var segments = [];

      if (is_poly && is_multi) {
        (geom.getPolygons() || []).forEach(function (p) {
          return p.getLinearRing().getCoordinates().forEach(function (coords) {
            return segments.push(coords);
          });
        });
      }

      if (is_poly && !is_multi) {
        segments = geom.getLinearRing().getCoordinates();
      }

      var _geom = is_poly && segments.length > 2 ? new ol.geom.LineString(segments) : geom;

      var length = is_line || is_poly && segments.length > 2 ? is_sphere ? ol.sphere.getLength(_geom, { projection: projection.getCode() }) : (0, _isMultiGeometry.isMultiGeometry)(_geom.getType()) ? _geom.getLineStrings().reduce(function (totalLength, lineGeometry) {
        return totalLength += lineGeometry.getLength();
      }, 0) : _geom.getLength() : undefined;

      var area = is_poly ? Math.round(is_sphere ? ol.sphere.getArea(geom, { projection: projection.getCode() }) : geom.getArea()) : undefined;

      if (undefined !== length) {
        length = 'nautical' === _application2.default.map.unit ? length * 0.0005399568 + " nm" : length > 1000 ? (Math.round(length / 1000 * 100) / 100).toFixed(3) + " km" : (Math.round(length * 100) / 100).toFixed(2) + " m";
      }

      if (undefined !== area) {
        area = 'nautical' === _application2.default.map.unit ? area * 0.000000291553349598122862913947445759414840765222583489217190918463024037990567 + " \u2009nmi\xB2" : area > 1000000 ? (Math.round(area / 1000000 * 100) / 100).toFixed(6) + " km<sup>2</sup>" : (Math.round(area * 100) / 100).toFixed(3) + " m<sup>2</sup>";
      }

      element.innerHTML = (undefined !== area ? "Area: " + area + " <br>" : '') + (undefined !== area && undefined !== length ? "<div style=\"width: 100%; padding: 3px; border-bottom: 2px solid #ffffff\"></div> " : '') + (undefined !== length ? length : '');
      tooltip.setPosition(coords);
    })
  };
}

},{"store/application":212,"utils/isLineGeometryType":258,"utils/isMultiGeometry":259,"utils/isPolygonGeometryType":261}],228:[function(require,module,exports){
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createRelationsUrl = createRelationsUrl;

var _application = require('store/application');

var _application2 = _interopRequireDefault(_application);

var _sanitizeFidFeature = require('utils/sanitizeFidFeature');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * ORIGINAL SOURCE: src/services/relations.js@v3.10.2
 */
function createRelationsUrl(_ref) {
  var _ref$layer = _ref.layer,
      layer = _ref$layer === undefined ? {} : _ref$layer,
      _ref$relation = _ref.relation,
      relation = _ref$relation === undefined ? {} : _ref$relation,
      fid = _ref.fid,
      _ref$type = _ref.type,
      type = _ref$type === undefined ? 'data' : _ref$type,
      _ref$formatter = _ref.formatter,
      formatter = _ref$formatter === undefined ? 1 : _ref$formatter,
      page = _ref.page,
      page_size = _ref.page_size,
      ordering = _ref.ordering;

  return _application2.default.project.getLayerById(undefined === relation.father ? layer.id === relation.referencedLayer ? relation.referencingLayer : relation.referencedLayer : layer.id === relation.father ? relation.child : relation.father).getUrl(type) + '?relationonetomany=' + relation.id + '|' + (0, _sanitizeFidFeature.sanitizeFidFeature)(fid) + '&formatter=' + formatter + (page ? '&page=' + page : '') + (page_size ? '&page_size=' + page_size : '') + ' ' + (ordering ? '&ordering=' + ordering : '');
}

},{"store/application":212,"utils/sanitizeFidFeature":273}],229:[function(require,module,exports){
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createSelectedStyle = createSelectedStyle;

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/**
 * @param { Object } style 
 * @param style.geometryType
 * @param style.color
 * @param style.fill
 * 
 * @returns { ol.style.Style | null } style 
 */
function createSelectedStyle() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      geometryType = _ref.geometryType,
      _ref$color = _ref.color,
      color = _ref$color === undefined ? 'rgb(255,255,0)' : _ref$color,
      _ref$fill = _ref.fill,
      fill = _ref$fill === undefined ? true : _ref$fill;

  switch (geometryType) {

    case 'LineString':
    case 'MultiLineString':
      return new ol.style.Style({
        stroke: new ol.style.Stroke({ color: color, width: 4 })
      });

    case 'Point':
    case 'MultiPoint':
      return new ol.style.Style({
        image: new ol.style.Circle({
          radius: 6,
          fill: fill && new ol.style.Fill({ color: color }),
          stroke: !fill && new ol.style.Stroke({ color: color, width: 4 })
        }),
        zIndex: Infinity
      });

    case 'MultiPolygon':
    case 'Polygon':
      return new ol.style.Style({
        stroke: new ol.style.Stroke({ color: color, width: 4 }),
        fill: fill && new ol.style.Fill({ color: ol.color.asString([].concat(_toConsumableArray(ol.color.asArray(color))).splice(0, 3).concat(.25)) }) // force rgba color transparency (alpha = .25)
      });

    default:
      console.warn('invalid geometry type', geometryType);
      return null;

  }
}

},{}],230:[function(require,module,exports){
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createSingleFieldParameter = createSingleFieldParameter;
/**
 * @param { Object } opts
 * @param opts.layer
 * @param opts.field
 * @param opts.value
 * @param { string } [opts.operator='eq']         'eq' as default
 * @param { string } [opts.logicop='OR']          'OR' as default
 * 
 * @returns { string } filter
 * 
 * @since 3.8.7
 */
function createSingleFieldParameter(_ref) {
  var field = _ref.field,
      value = _ref.value,
      _ref$operator = _ref.operator,
      operator = _ref$operator === undefined ? 'eq' : _ref$operator,
      _ref$logicop = _ref.logicop,
      logicop = _ref$logicop === undefined ? 'OR' : _ref$logicop;

  return [].concat(value).map(function (v) {
    return field + '|' + operator.toLowerCase() + '|' + encodeURIComponent(v);
  }).join('|' + logicop + ',');
}

},{}],231:[function(require,module,exports){
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createVectorLayerFromFile = undefined;

/**
 * @param { Object } file
 * @param { string } file.name
 * @param file.type
 * @param file.crs
 * @param file.mapCrs
 * @param file.data
 * @param file.style
 * 
 * @returns { Promise } layer
 */
var createVectorLayerFromFile = exports.createVectorLayerFromFile = function () {
  var _ref = _asyncToGenerator(function* () {
    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        name = _ref2.name,
        type = _ref2.type,
        crs = _ref2.crs,
        mapCrs = _ref2.mapCrs,
        data = _ref2.data,
        style = _ref2.style;

    var errors = [];
    var epsg = ['zip', 'kml', 'kmz'].includes(type) ? 'EPSG:4326' : crs;
    var features = [];

    // SHAPE FILE
    if ('zip' === type) {
      data = JSON.stringify((yield (0, _shp2.default)((yield data.arrayBuffer(data))))); // un-zip folder data 
    }

    // KMZ FILE
    if ('kmz' === type) {
      var zip = new _jszip2.default();
      zip.load((yield data.arrayBuffer(data)));
      data = zip.file(/.kml$/i).at(-1).asText(); // get last kml file within folder
    }

    // CSV FILE
    if ('csv' === type) {
      data.values.forEach(function (row, i) {
        var props = {};
        var cols = row.split(data.separator);
        if (cols.length !== data.headers.length) {
          return errors.push({ row: i + 1, value: data.values[i] });
        }
        var coords = [];
        cols.forEach(function (value, i) {
          if (data.headers[i] === data.x) {
            coords[0] = 1 * value;
          }
          if (data.headers[i] === data.y) {
            coords[1] = 1 * value;
          }
          props[data.headers[i]] = value;
        });
        // check if all coordinates are right
        if (coords.every(function (d) {
          return !Number.isNaN(d);
        })) {
          var feat = new ol.Feature(new ol.geom.Point(coords).transform(crs, mapCrs));
          feat.setId(i); // incremental id
          feat.setProperties(props);
          features.push(feat);
        }
      });
    }

    if ('csv' !== type) {
      features = {
        'gpx': new ol.format.GPX(),
        'gml': new ol.format.WMSGetFeatureInfo(),
        'geojson': new ol.format.GeoJSON(),
        'zip': new ol.format.GeoJSON(),
        'kml': new ol.format.KML({ extractStyles: false }),
        'kmz': new ol.format.KML({ extractStyles: false })
      }[type].readFeatures(data, { dataProjection: epsg, featureProjection: mapCrs || epsg });
    }

    // ignore kml property [`<styleUrl>`](https://developers.google.com/kml/documentation/kmlreference)
    if (['kml', 'kmz'].includes(type)) {
      features.forEach(function (f) {
        return f.unset('styleUrl');
      });
    }

    if (errors.length) {
      GUI.showUserMessage({
        type: 'warning',
        message: 'sdk.mapcontrols.addlayer.messages.csv.warning',
        hooks: {
          footer: {
            template: /* html */
            '<select v-select2="errors[0].value" class="skin-color" :search="false" style="width:100%">\n            <option v-for="e in errors" :key="e.row" :value="e.value">[{{ e.row}}] {{e.value}}</option>\n          </select>',
            data: function data() {
              return { errors: errors };
            }
          }
        },
        autoclose: false
      });
    }

    if (features.length) {
      return new ol.layer.Vector({
        source: new ol.source.Vector({ features: features }),
        name: name,
        _fields: 'csv' === type ? data.headers : Object.keys(features[0].getProperties()).filter(function (prop) {
          return _g3wConstants.GEOMETRY_FIELDS.indexOf(prop) < 0;
        }),
        id: (0, _getUniqueDomId.getUniqueDomId)(),
        style: style
      });
    }

    return Promise.reject();
  });

  return function createVectorLayerFromFile() {
    return _ref.apply(this, arguments);
  };
}();

var _jszip = require('jszip/dist/jszip.min');

var _jszip2 = _interopRequireDefault(_jszip);

var _shp = require('shpjs/dist/shp');

var _shp2 = _interopRequireDefault(_shp);

var _g3wConstants = require('g3w-constants');

var _getUniqueDomId = require('utils/getUniqueDomId');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

},{"g3w-constants":159,"jszip/dist/jszip.min":22,"shpjs/dist/shp":27,"utils/getUniqueDomId":252}],232:[function(require,module,exports){
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.debounce = debounce;

/**
 * build debounce function
 */
function debounce(func) {
  var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;

  var timeout = void 0;
  return function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    clearTimeout(timeout);
    timeout = setTimeout(function () {
      return func.apply(undefined, args);
    }, delay);
  };
}

},{}],233:[function(require,module,exports){
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dissolve = dissolve;

var _jstsMin = require('jsts/dist/jsts.min.js');

var _jstsMin2 = _interopRequireDefault(_jstsMin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * 
 * @param { Object } opts 
 * @param { Array } opts.features
 * @param { number } opts.index
 * @param { boolean } opts.clone
 * 
 * @returns dissolved feature
 */
function dissolve() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$features = _ref.features,
      features = _ref$features === undefined ? [] : _ref$features,
      _ref$index = _ref.index,
      index = _ref$index === undefined ? 0 : _ref$index,
      _ref$clone = _ref.clone,
      clone = _ref$clone === undefined ? false : _ref$clone;

  var parser = new _jstsMin2.default.io.OL3Parser();
  var featuresLength = features.length;

  /** In case no features to dissolve  */
  if (0 === featuresLength) {
    return null;
  }

  /** In the case of single feature, return feature */
  if (1 === featuresLength) {
    return features[0];
  }

  var jstsdissolvedFeatureGeometry = void 0;

  var baseFeature = clone ? features[index].clone() : features[index];
  var baseFeatureGeometry = baseFeature.getGeometry();
  var baseFeatureGeometryType = baseFeatureGeometry.getType();

  // check if it can build a LineString
  if ('LineString' === baseFeatureGeometryType) {
    var lineMerger = new _jstsMin2.default.operation.linemerge.LineMerger();
    for (var i = 0; i < featuresLength; i++) {
      lineMerger.addLineString(new _jstsMin2.default.geom.GeometryFactory().createLineString(parser.read(features[i].getGeometry()).getCoordinates()));
    }
    var mergedLineString = lineMerger.getMergedLineStrings();
    jstsdissolvedFeatureGeometry = 1 === mergedLineString.size() ? mergedLineString.toArray()[0] : null;
  }

  if ('LineString' !== baseFeatureGeometryType) {
    jstsdissolvedFeatureGeometry = parser.read(baseFeatureGeometry);
    for (var _i = 0; _i < featuresLength; _i++) {
      if (index !== _i) {
        jstsdissolvedFeatureGeometry = jstsdissolvedFeatureGeometry.union(parser.read(features[_i].getGeometry()));
      }
    }
  }

  /** In case of no dissolved geometry  */
  if (!jstsdissolvedFeatureGeometry) {
    return null;
  }

  var dissolvedFeatureGeometry = parser.write(jstsdissolvedFeatureGeometry);
  var dissolvedFeatureGeometryType = dissolvedFeatureGeometry.getType();
  var dissolvedFeatureGeometryCoordinates = dissolvedFeatureGeometryType === baseFeatureGeometryType ? dissolvedFeatureGeometry.getCoordinates() : -1 !== baseFeatureGeometryType.indexOf('Multi') && dissolvedFeatureGeometryType === baseFeatureGeometryType.replace('Multi', '') ? [dissolvedFeatureGeometry.getCoordinates()] : null;

  /** In the case of null feature dissolved coordinates  */
  if (null === dissolvedFeatureGeometryCoordinates) {
    return null;
  }

  baseFeature.getGeometry().setCoordinates(dissolvedFeatureGeometryCoordinates);

  return baseFeature;
}

},{"jsts/dist/jsts.min.js":21}],234:[function(require,module,exports){
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.distance = distance;
/**
 * core/geometry/geom::distance@v3.4
 * core/geometry/geom::squaredDistance@v3.4
 */
function distance(c1, c2) {
  return Math.sqrt(Math.pow(c2[0] - c1[0], 2) + Math.pow(c2[1] - c1[1], 2));
}

},{}],235:[function(require,module,exports){
Object.defineProperty(exports, "__esModule", {
  value: true
});

/**
 * @param { Object } file
 * @param { string } file.filename
 * @param file.content
 * @param { string } file.url
 * @param { string } file.mime_type
 * @param  file.signal
 */
var downloadFile = exports.downloadFile = function () {
  var _ref = _asyncToGenerator(function* () {
    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        filename = _ref2.filename,
        content = _ref2.content,
        url = _ref2.url,
        _ref2$headers = _ref2.headers,
        headers = _ref2$headers === undefined ? {} : _ref2$headers,
        _ref2$method = _ref2.method,
        method = _ref2$method === undefined ? 'GET' : _ref2$method,
        data = _ref2.data,
        _ref2$mime_type = _ref2.mime_type,
        mime_type = _ref2$mime_type === undefined ? 'text/plain' : _ref2$mime_type,
        signal = _ref2.signal;

    var blob = content && new Blob([content], { type: mime_type });

    var d = !content && url && (yield fetch(url, {
      type: mime_type,
      body: data,
      headers: headers,
      method: method,
      signal: signal
    })) || {};

    if (!content && (400 === d.status || 500 === d.status)) {
      throw (yield d.json()).message;
    }

    if (content || 200 === d.status) {
      var a = document.createElement('a');
      a.setAttribute('href', window.URL.createObjectURL(blob || (yield d.blob())));
      a.setAttribute('download', filename || (d.headers.get('content-disposition') || 'filename=g3w_download_file').split('filename=').at(1));
      a.dataset.downloadurl = [mime_type || d.headers.get('content-type'), a.download, a.href].join(':');
      a.click();
      a = null;
    }
  });

  return function downloadFile() {
    return _ref.apply(this, arguments);
  };
}();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

},{}],236:[function(require,module,exports){
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.flattenObject = flattenObject;
/**
 * ORIGINAL SOURCE: https://stackoverflow.com/a/56253298
 * 
 * @example 
 * 
 * ### Sample Input
 * 
 * ```
 * const obj = {
 *  name: "test",
 *  address: {
 *    personal: "abc",
 *      office: {
 *        building: 'random',
 *        street: 'some street'
 *      }
 *    }
 *  }
 * ```
 * 
 * ### Expected Output
 * 
 * ```
 * {
 *   name : "test",
 *   address_personal: "abc"
 *   address_office_building: "random"
 *   address_office_street: "some street"
 * }
 * ```
 * 
 * @since 3.9.0
 */
function flattenObject(obj, parent) {
  var res = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  for (var key in obj) {
    var propName = parent ? parent + '_' + key : key;
    if ('object' === _typeof(obj[key])) {
      flattenObject(obj[key], propName, res);
    } else {
      res[propName] = obj[key];
    }
  }
  return res;
}

},{}],237:[function(require,module,exports){
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAlphanumericPropertiesFromFeature = getAlphanumericPropertiesFromFeature;

var _g3wConstants = require('g3w-constants');

/**
 * @param { Array } properties
 * 
 * @returns { Array }
 */
function getAlphanumericPropertiesFromFeature() {
  var properties = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  return (Array.isArray(properties) ? properties : Object.keys(properties)).filter(function (p) {
    return !_g3wConstants.GEOMETRY_FIELDS.includes(p);
  });
}

},{"g3w-constants":159}],238:[function(require,module,exports){
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCatalogLayerById = getCatalogLayerById;

var _application = require('store/application');

var _application2 = _interopRequireDefault(_application);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * ORIGINAL SOURCE: src/app/core/layers/layersstoreregistry.js@v3.10.2
 */
function getCatalogLayerById(id) {
  return Object.values(_application2.default.catalog).map(function (s) {
    return s.getLayerById(id);
  }).find(function (l) {
    return l;
  });
}

},{"store/application":212}],239:[function(require,module,exports){
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCatalogLayers = getCatalogLayers;

var _application = require('store/application');

var _application2 = _interopRequireDefault(_application);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * ORIGINAL SOURCE: src/app/core/layers/layersstoreregistry.js@v3.10.2
 */
function getCatalogLayers(filter) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return Object.values(_application2.default.catalog).flatMap(function (s) {
    return s.getLayers(filter, options);
  });
}

},{"store/application":212}],240:[function(require,module,exports){
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDataForSearchInput = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

/**
 * @returns { Array } of unique values from field
 */
var getDataForSearchInput = exports.getDataForSearchInput = function () {
  var _ref2 = _asyncToGenerator(function* (_ref) {
    var state = _ref.state,
        field = _ref.field,
        suggest = _ref.suggest;


    try {
      // get unique value from each layers
      return (yield Promise.allSettled(state.search_layers.map(function (l) {
        return l.getFilterData({
          suggest: suggest,
          fformatter: field,
          ordering: field,
          field: getDataForSearchInput.field({
            state: state,
            //in the case of suggested parameter set (case autocomplete field), need to use current field
            field: suggest ? field : (state.forminputs.find(function (i) {
              return i.attribute === field;
            }) || {}).dependance || field,
            fields: []
          })
        });
      }))).filter(function (d) {
        return 'fulfilled' === d.status;
      }).reduce(function (acc, d) {
        return acc.concat(d.value.data || []);
      }, []) // uniques by fformatter
      .map(function (_ref3) {
        var _ref4 = _slicedToArray(_ref3, 2),
            value = _ref4[0],
            key = _ref4[1];

        return { key: key, value: value };
      });
    } catch (e) {
      console.warn(e);
    }

    return [];
  });

  return function getDataForSearchInput(_x) {
    return _ref2.apply(this, arguments);
  };
}();

/**
 * Traverse field dependecies
 */


var _g3wConstants = require('g3w-constants');

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

getDataForSearchInput.field = function () {
  var _ref5 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      state = _ref5.state,
      field = _ref5.field,
      _ref5$fields = _ref5.fields,
      fields = _ref5$fields === undefined ? [] : _ref5$fields;

  field = state.forminputs.find(function (i) {
    return i.attribute === field;
  }); // current input
  var parent = state.forminputs.find(function (i) {
    return i.attribute === field.dependance;
  }); // current input dependance (parent field)

  // get all values (un-filtered)
  if (!parent || _g3wConstants.SEARCH_ALLVALUE === parent.value) {
    return (fields || []).join() || undefined;
  }

  // filter by parent field
  if (undefined !== parent.value) {
    fields.unshift(parent.attribute + '|' + parent.operator.toLowerCase() + '|' + encodeURI(parent.value) + (fields.length ? '|' + parent.logicop : ''));
  }

  // recursion step
  return getDataForSearchInput.field({ state: state, fields: fields, field: parent.attribute });
};

},{"g3w-constants":159}],241:[function(require,module,exports){
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDefaultExpression = undefined;

/**
 * ORIGINAL SOURCE: src/app/core/expression/inputservice.js@3.8.6
 *
 * @param expr.field        related field
 * @param expr.feature      feature to transform in form_data
 * @param expr.qgs_layer_id layer id owner of the feature data
 * @param expr.parentData
 *
 * @returns { void | Promise<unknown> }
 *
 * @since 3.9.0
 */
var getDefaultExpression = exports.getDefaultExpression = function () {
  var _ref = _asyncToGenerator(function* () {
    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        field = _ref2.field,
        feature = _ref2.feature,
        qgs_layer_id = _ref2.qgs_layer_id,
        parentData = _ref2.parentData;

    var _field$input$options = field.input.options,
        _field$input$options$ = _field$input$options.layer_id,
        layer_id = _field$input$options$ === undefined ? qgs_layer_id : _field$input$options$,
        default_expression = _field$input$options.default_expression,
        loading = _field$input$options.loading,
        default_value = _field$input$options.default;

    /**
     * @FIXME should return Promise.reject('some error message') ?
     */

    if (!default_expression) {
      return;
    }

    loading.state = 'loading';

    // Call `expression:expression_eval` to get value from expression and set it to field
    try {

      var value = yield _data2.default.getData('expression:expression_eval', {
        inputs: {
          field_name: field.name,
          layer_id: layer_id, //
          qgs_layer_id: qgs_layer_id, //layer id owner of the data
          form_data: (0, _convertFeatureToGEOJSON.convertFeatureToGEOJSON)(feature),
          formatter: 0,
          expression: default_expression.expression,
          parent: parentData && {
            form_data: (0, _convertFeatureToGEOJSON.convertFeatureToGEOJSON)(parentData.feature),
            qgs_layer_id: parentData.qgs_layer_id,
            formatter: 0
          }
        },
        outputs: false
      });

      field.value = value;

      return value;
    } catch (e) {
      if (undefined !== default_value) {
        field.value = default_value;
      }
      console.warn(e);
      return Promise.reject(e);
    } finally {
      loading.state = 'ready';
    }
  });

  return function getDefaultExpression() {
    return _ref.apply(this, arguments);
  };
}();

var _data = require('services/data');

var _data2 = _interopRequireDefault(_data);

var _convertFeatureToGEOJSON = require('utils/convertFeatureToGEOJSON');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

},{"services/data":206,"utils/convertFeatureToGEOJSON":220}],242:[function(require,module,exports){
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFilterExpression = undefined;

/**
 * ORIGINAL SOURCE: src/app/core/expression/inputservice.js@3.8.6
 *
 * @param expr.field        related field
 * @param expr.feature      feature to transform in form_data
 * @param expr.qgs_layer_id layer id owner of the feature data
 * @param expr.parentData
 *
 * @returns { void | Promise<unknown> }
 *
 * @since 3.9.0
 */
var getFilterExpression = exports.getFilterExpression = function () {
  var _ref = _asyncToGenerator(function* () {
    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        field = _ref2.field,
        feature = _ref2.feature,
        qgs_layer_id = _ref2.qgs_layer_id,
        parentData = _ref2.parentData;

    var _field$input$options = field.input.options,
        key = _field$input$options.key,
        value = _field$input$options.value,
        _field$input$options$ = _field$input$options.layer_id,
        layer_id = _field$input$options$ === undefined ? qgs_layer_id : _field$input$options$,
        filter_expression = _field$input$options.filter_expression,
        loading = _field$input$options.loading,
        orderbyvalue = _field$input$options.orderbyvalue;

    /**
     * @FIXME should return Promise.reject('some error message') ?
     */

    if (!filter_expression) {
      return;
    }

    loading.state = 'loading';

    try {

      var features = yield _data2.default.getData('expression:expression', {
        inputs: {
          field_name: field.name,
          layer_id: layer_id,
          qgs_layer_id: qgs_layer_id,
          form_data: (0, _convertFeatureToGEOJSON.convertFeatureToGEOJSON)(feature),
          parent: parentData && {
            form_data: (0, _convertFeatureToGEOJSON.convertFeatureToGEOJSON)(parentData.feature),
            qgs_layer_id: parentData.qgs_layer_id,
            formatter: 0
          },
          formatter: 0,
          expression: filter_expression.expression,
          ordering: [undefined, false].includes(orderbyvalue) ? key : value //@since 3.11.0
        },
        outputs: false
      });

      if ('select_autocomplete' === field.input.type) {
        field.input.options.values = [];
        // temporary array to sort the keys
        var values = [];
        for (var i = 0; i < features.length; i++) {
          values.push({
            key: features[i].properties[value],
            value: features[i].properties[key]
          });
        }

        field.input.options.values = values;
      }

      return features;
    } catch (e) {
      console.warn(e);
      return Promise.reject(e);
    } finally {
      loading.state = 'ready';
    }
  });

  return function getFilterExpression() {
    return _ref.apply(this, arguments);
  };
}();

var _data = require('services/data');

var _data2 = _interopRequireDefault(_data);

var _convertFeatureToGEOJSON = require('utils/convertFeatureToGEOJSON');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

},{"services/data":206,"utils/convertFeatureToGEOJSON":220}],243:[function(require,module,exports){
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFormDataExpressionRequestFromFeature = getFormDataExpressionRequestFromFeature;

var _g3wConstants = require('g3w-constants');

var _getAlphanumericPropertiesFromFeature = require('utils/getAlphanumericPropertiesFromFeature');

var _convertFeatureToGEOJSON = require('utils/convertFeatureToGEOJSON');

/**
 * Convert feature to form Data for expression/expression_eval request
 * 
 * @param feature
 */
function getFormDataExpressionRequestFromFeature(feature) {
  delete feature.attributes.geometry;

  var _feature = new ol.Feature(feature.geometry);
  var properties = {};

  (0, _getAlphanumericPropertiesFromFeature.getAlphanumericPropertiesFromFeature)(feature.attributes).filter(function (p) {
    return _g3wConstants.G3W_FID !== p;
  }).forEach(function (p) {
    return properties[p] = feature.attributes[p];
  });

  _feature.setProperties(properties);
  _feature.setId(feature.attributes[_g3wConstants.G3W_FID]);

  return (0, _convertFeatureToGEOJSON.convertFeatureToGEOJSON)(_feature);
}

},{"g3w-constants":159,"utils/convertFeatureToGEOJSON":220,"utils/getAlphanumericPropertiesFromFeature":237}],244:[function(require,module,exports){
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getListableProjects = getListableProjects;

var _application = require('store/application');

var _application2 = _interopRequireDefault(_application);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/** used by the following plugins: "iframe", "archiweb" */
function getListableProjects() {
  window.initConfig.projects;
  return window.initConfig.projects.filter(function (p) {
    if (![null, undefined].includes(p.listable)) {
      return p.listable;
    }
    if (p.id === _application2.default.project.getId() || window.initConfig.overviewproject && p.gid === window.initConfig.overviewproject) {
      return false;
    }
    return p;
  }).sort(function (a, b) {
    return (a.title || '').localeCompare(b.title);
  });
}

},{"store/application":212}],245:[function(require,module,exports){
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.getMapLayersByFilter = getMapLayersByFilter;
/**
 * @param filter defaults `GEOLAYER: true`
 * @param options
 * 
 * @returns { Array } map layers based on filtered properties of layer (eg. `GEOLAYER : true`)
 */
function getMapLayersByFilter() {
  var filter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var MapLayersStoresRegistry = require('services/map').default.MapLayersStoresRegistry;

  return MapLayersStoresRegistry.getQuerableLayersStores().flatMap(function (s) {
    return s.getLayers(_extends({
      GEOLAYER: true
    }, filter || {}), options);
  });
}

},{"services/map":209}],246:[function(require,module,exports){
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getOLGeometry = getOLGeometry;

var _g3wConstants = require('g3w-constants');

/**
 * core/geometry/geometry::getOLGeometry@v3.4
 */
function getOLGeometry(geometryType) {

  switch (geometryType) {

    case _g3wConstants.GEOMETRY_TYPES.LINESTRINGZ:
    case _g3wConstants.GEOMETRY_TYPES.LINESTRINGM:
    case _g3wConstants.GEOMETRY_TYPES.LINESTRINGZM:
    case _g3wConstants.GEOMETRY_TYPES.LINESTRING25D:
    case _g3wConstants.GEOMETRY_TYPES.LINE:
    case _g3wConstants.GEOMETRY_TYPES.LINEZ:
    case _g3wConstants.GEOMETRY_TYPES.LINEM:
    case _g3wConstants.GEOMETRY_TYPES.LINEZM:
    case _g3wConstants.GEOMETRY_TYPES.LINE25D:
      return 'LineString';

    case _g3wConstants.GEOMETRY_TYPES.MULTILINESTRINGZ:
    case _g3wConstants.GEOMETRY_TYPES.MULTILINESTRINGM:
    case _g3wConstants.GEOMETRY_TYPES.MULTILINESTRINGZM:
    case _g3wConstants.GEOMETRY_TYPES.MULTILINESTRING25D:
    case _g3wConstants.GEOMETRY_TYPES.MULTILINE:
    case _g3wConstants.GEOMETRY_TYPES.MULTILINEZ:
    case _g3wConstants.GEOMETRY_TYPES.MULTILINEM:
    case _g3wConstants.GEOMETRY_TYPES.MULTILINEZM:
    case _g3wConstants.GEOMETRY_TYPES.MULTILINE25D:
      return 'MultiLineString';

    case _g3wConstants.GEOMETRY_TYPES.POINT:
    case _g3wConstants.GEOMETRY_TYPES.POINTZ:
    case _g3wConstants.GEOMETRY_TYPES.POINTM:
    case _g3wConstants.GEOMETRY_TYPES.POINTZM:
    case _g3wConstants.GEOMETRY_TYPES.POINT25D:
      return 'Point';

    case _g3wConstants.GEOMETRY_TYPES.MULTIPOINT:
    case _g3wConstants.GEOMETRY_TYPES.MULTIPOINTZ:
    case _g3wConstants.GEOMETRY_TYPES.MULTIPOINTM:
    case _g3wConstants.GEOMETRY_TYPES.MULTIPOINTZM:
    case _g3wConstants.GEOMETRY_TYPES.MULTIPOINT25D:
      return 'MultiPoint';

    case _g3wConstants.GEOMETRY_TYPES.POLYGON:
    case _g3wConstants.GEOMETRY_TYPES.POLYGONZ:
    case _g3wConstants.GEOMETRY_TYPES.POLYGONM:
    case _g3wConstants.GEOMETRY_TYPES.POLYGONZM:
    case _g3wConstants.GEOMETRY_TYPES.POLYGON25D:
      return 'Polygon';

    case _g3wConstants.GEOMETRY_TYPES.MULTIPOLYGON:
    case _g3wConstants.GEOMETRY_TYPES.MULTIPOLYGONZ:
    case _g3wConstants.GEOMETRY_TYPES.MULTIPOLYGONM:
    case _g3wConstants.GEOMETRY_TYPES.MULTIPOLYGONZM:
    case _g3wConstants.GEOMETRY_TYPES.MULTIPOLYGON25D:
      return 'MultiPolygon';

    default:
      console.warn('invalid geometry type: ', geometryType);
      return geometryType;
  }
}

},{"g3w-constants":159}],247:[function(require,module,exports){
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getProject = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

/**
 * ORIGINAL SOURCE: src/app/core/project/project.js@v3.10.2
 * 
 * Get project configuration
 *
 * @param { string } gid project gid
 * @param options
 * @param { string } options.map_theme
 */
var getProject = exports.getProject = function () {
  var _ref3 = _asyncToGenerator(function* (gid) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};


    var pendingProject = window.initConfig.projects.find(function (p) {
      return gid === p.gid;
    });

    // skip if a project doesn't exist
    if (!pendingProject) {
      console.log("Project doesn't exist", gid);
      return Promise.reject("Project doesn't exist");
    }

    // fetch project configuration from remote server

    // { Array } config.layers - The order of layers follows layer rendering order set on QGIS project.Can be different to TOC layer order
    var config = !PROJECTS[gid] && (yield _XHR.XHR.get({ url: '' + window.initConfig.urls.baseurl + window.initConfig.urls.config + '/' + window.initConfig.id + '/' + pendingProject.type + '/' + pendingProject.id + '?_t=' + pendingProject.modified
    }));
    var map_theme = config && options.map_theme && Object.values(config.map_themes).flat().find(function (_ref4) {
      var theme = _ref4.theme;
      return theme === options.map_theme;
    });

    /** In the case of url param set map_theme, need to get map theme configuration from server */
    if (map_theme) {
      var _ref5 = yield _XHR.XHR.get({ url: '/' + pendingProject.type + '/api/prjtheme/' + pendingProject.id + '/' + options.map_theme }),
          result = _ref5.result,
          data = _ref5.data;

      if (result) {
        config.layerstree = data;
        map_theme.layetstree = data;
        map_theme.default = true;
      }
    }

    PROJECTS[gid] = Object.assign(PROJECTS[gid] || {}, Object.assign(pendingProject, config));
    PROJECTS[gid] = Object.assign(PROJECTS[gid], {
      WMSUrl: '' + window.initConfig.urls.baseurl + window.initConfig.urls.ows + '/' + window.initConfig.id + '/' + PROJECTS[gid].type + '/' + PROJECTS[gid].id + '/',
      /** @since 3.8.0 */
      relations: (PROJECTS[gid].relations || []).map(function (r) {
        if ("ONE" === r.type) {
          PROJECTS[gid].layers.find(function (l) {
            if (l.id === r.referencingLayer) {
              r.name = l.name;
              r.origname = l.origname;
              return true;
            }
          });
        }
        return r;
      }),
      /** actived catalog tab */
      catalog_tab: PROJECTS[gid].toc_tab_default || PROJECTS[gid]._catalog_tab || 'layers',
      ows_method: PROJECTS[gid].ows_method || 'GET',
      toc_layers_init_status: PROJECTS[gid].toc_layers_init_status || 'not_collapsed',
      toc_themes_init_status: PROJECTS[gid].toc_themes_init_status || 'collapsed',
      query_point_tolerance: PROJECTS[gid].query_point_tolerance || _g3wConstants.QUERY_POINT_TOLERANCE,
      crs: crsToCrsObject(PROJECTS[gid].crs),
      baselayers: PROJECTS[gid].baselayers
      // Remove bing base layer when no vendor API Key is provided
      .filter(function (l) {
        return 'Bing' === l.servertype ? _application2.default.keys.vendorkeys.bing : true;
      }).map(function (l) {
        return Object.assign(l, {
          visible: l.id && l.id === (null !== _application2.default.baseLayerId ? _application2.default.baseLayerId : PROJECTS[gid].initbaselayer) || !!l.fixed,
          baselayer: true
        });
      })
    });

    var project = Object.assign(new _g3wObject2.default(), {
      setters: {
        setBaseLayer: function setBaseLayer(id) {
          var _this = this;

          window.initConfig.baselayers.forEach(function (l) {
            _this._layersStore.getLayerById(l.id).setVisible(id === l.id);
            l.visible = id === l.id;
          });
        }
      },
      state: PROJECTS[gid],
      /** project APIs */
      urls: {
        map_themes: '/' + PROJECTS[gid].type + '/api/prjtheme/' + PROJECTS[gid].id + '/',
        vector_data: PROJECTS[gid].vectorurl + 'data/' + PROJECTS[gid].type + '/' + PROJECTS[gid].id + '/',
        featurecount: PROJECTS[gid].vectorurl + 'featurecount/' + PROJECTS[gid].type + '/' + PROJECTS[gid].id + '/'
      },
      _projection: _projections2.default.get(crsToCrsObject(PROJECTS[gid].crs)),
      _layersStore: new _layersstore.LayersStore(),
      getQueryPointTolerance: function getQueryPointTolerance() {
        return project.state.query_point_tolerance;
      },
      getRelations: function getRelations() {
        return project.state.relations;
      },
      getRelationById: function getRelationById(id) {
        return project.state.relations.find(function (r) {
          return id === r.id;
        });
      },
      getLayerById: function getLayerById(id) {
        return project._layersStore.getLayerById(id);
      },
      getLayers: function getLayers() {
        return [].concat(_toConsumableArray(project.state.layers), _toConsumableArray(project.state.baselayers));
      },
      getState: function getState() {
        return project.state;
      },
      getPrint: function getPrint() {
        return project.state.print || [];
      },
      getId: function getId() {
        return project.state.id;
      },
      getType: function getType() {
        return project.state.type;
      },
      getGid: function getGid() {
        return project.state.gid;
      },
      getName: function getName() {
        return project.state.name;
      },
      getCrs: function getCrs() {
        return project._projection.getCode();
      },
      getProjection: function getProjection() {
        return project._projection;
      },
      getLayersStore: function getLayersStore() {
        return project._layersStore;
      },
      getUrl: function getUrl(type) {
        return project.urls[type];
      },
      /**
       * @param filter property layer config to filter
       * 
       * @returns { Array } configuration layers (from server config)
       */
      getConfigLayers: function getConfigLayers() {
        var _ref6 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            key = _ref6.key;

        return key ? project.state.layers.filter(function (l) {
          return undefined !== l[key];
        }) : project.state.layers;
      }
    });

    // Process layerstree and baselayers of the project (useful info for catalog)
    var traverse = function traverse(nodes) {
      var _loop = function _loop(i) {
        var node = nodes[i];
        //check if layer (node) of folder
        if (undefined !== node.id) {
          project.state.layers.forEach(function (l) {
            if (node.id === l.id) {
              node.name = l.name;
              l.wmsUrl = project.state.WMSUrl;
              l.project = project;
              node[i] = Object.assign(l, node);
              return false;
            }
          });
        }
        if (Array.isArray(node.nodes)) {
          //add title to tree
          node.title = node.name;
          traverse(node.nodes);
        }
      };

      for (var i = 0; i < nodes.length; i++) {
        _loop(i);
      }
    };

    traverse(project.state.layerstree);

    // Build layersstore 
    project._layersStore.setOptions({
      id: project.state.gid,
      projection: project._projection,
      extent: project.state.extent,
      initextent: project.state.initextent,
      wmsUrl: project.state.WMSUrl,
      catalog: window.initConfig.overviewproject !== project.state.gid
    });

    /** ORIGINAL SOURCE: src/app/core/layers/layerfactory.js@v3.10.2 */

    // Layer factory: instance each layer and add to layersstore
    project._layersStore.addLayers(project.getLayers().flatMap(function (l) {
      var config = Object.assign(l, {
        crs: crsToCrsObject(l.crs),
        projection: l.crs ? _projections2.default.get(l.crs) : project._projection,
        ows_method: project.state.ows_method,
        wms_use_layer_ids: project.state.wms_use_layer_ids
      });

      // Check Layer Type
      var layerType = config.servertype + ' ' + (config.source && config.source.type);

      // TABLE LAYERS
      if ('NoGeometry' === config.geometrytype && ["QGIS virtual", "QGIS postgres", "QGIS mssql", "QGIS spatialite", "QGIS wfs", "QGIS delimitedtext", "QGIS oracle", "QGIS ogr", "QGIS mdal"].includes(layerType)) {
        return new _tablelayer.TableLayer(config, { project: project });
      }

      // VECTOR LAYERS
      if (['OGC wfs', 'G3WSUITE geojson'].includes(layerType) || ["Local", "G3WSUITE"].includes(config.servertype)) {
        return new _vectorlayer.VectorLayer(config, { project: project });
      }

      // RASTER LAYERS
      if (config.geometrytype && 'NoGeometry' !== config.geometrytype && ['OGC wms', 'QGIS postgresraster', "QGIS virtual", "QGIS postgres", "QGIS mssql", "QGIS spatialite", "QGIS wfs", "QGIS delimitedtext", "QGIS oracle", "QGIS ogr", "QGIS mdal"].includes(layerType)) {
        return new _imagelayer.ImageLayer(config, { project: project });
      }

      // RASTER LAYERS
      if (!config.geometrytype && ['OGC wms', 'QGIS postgresraster', "QGIS wmst", "QGIS wcs", "QGIS wms", "QGIS gdal", "QGIS vectortile", "QGIS vector-tile", "QGIS mdal", "QGIS arcgismapserver"].includes(layerType)) {
        return new _imagelayer.ImageLayer(config, { project: project });
      }

      // BASE LAYERS
      if (['OSM', 'Bing', 'TMS', 'ARCGISMAPSERVER', 'WMTS', 'WMS'].includes(config.servertype)) {
        return new _imagelayer.ImageLayer(config, { project: project, _BASE_LAYER: config.servertype });
      }

      console.warn('Uknown layer type', config);
      return [];
    }));

    // create layerstree from layerstore
    project._layersStore.createLayersTree(project.state.name, {
      layerstree: project.state.layerstree,
      expanded: 'not_collapsed' === project.state.toc_layers_init_status // config to show layerstrees toc expanded or not
    });

    /** @deprecated since 3.10.0. Will be removed in v.4.x. */
    (project.state.search || []).forEach(function (s) {
      return s.search_endpoint = 'api';
    });

    // add to project
    return project;
  });

  return function getProject(_x2) {
    return _ref3.apply(this, arguments);
  };
}();

var _g3wConstants = require('g3w-constants');

var _g3wObject = require('g3w-object');

var _g3wObject2 = _interopRequireDefault(_g3wObject);

var _application = require('store/application');

var _application2 = _interopRequireDefault(_application);

var _projections = require('store/projections');

var _projections2 = _interopRequireDefault(_projections);

var _normalizeEpsg = require('utils/normalizeEpsg');

var _XHR = require('utils/XHR');

var _tablelayer = require('map/layers/tablelayer');

var _vectorlayer = require('map/layers/vectorlayer');

var _imagelayer = require('map/layers/imagelayer');

var _layersstore = require('map/layers/layersstore');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

Object.entries({
  TableLayer: _tablelayer.TableLayer,
  VectorLayer: _vectorlayer.VectorLayer,
  ImageLayer: _imagelayer.ImageLayer
}).forEach(function (_ref) {
  var _ref2 = _slicedToArray(_ref, 2),
      k = _ref2[0],
      v = _ref2[1];

  return console.assert(undefined !== v, k + ' is undefined');
});

// (lazy loading)
var PROJECTS = {};

/**
 * @param { number | string | null | undefined } crs
 * 
 * @returns { { epsg: string, proj4: string, axisinverted: boolean, geographic: boolean } | null | undefined } crs object
 */
function crsToCrsObject(crs) {

  /** @FIXME add description */
  if ([undefined, null].includes(crs)) {
    return crs;
  }

  /** @FIXME add description */
  if (crs && crs.epsg) {
    crs.epsg = (0, _normalizeEpsg.normalizeEpsg)(crs.epsg);
    return crs;
  }

  return {
    epsg: (0, _normalizeEpsg.normalizeEpsg)(crs),
    proj4: "",
    axisinverted: false,
    geographic: false
  };
}

},{"g3w-constants":159,"g3w-object":163,"map/layers/imagelayer":189,"map/layers/layersstore":191,"map/layers/tablelayer":192,"map/layers/vectorlayer":193,"store/application":212,"store/projections":214,"utils/XHR":215,"utils/normalizeEpsg":263}],248:[function(require,module,exports){
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getProjectConfigByGid = getProjectConfigByGid;
/** used by the following plugins: "iframe", "archiweb" */
function getProjectConfigByGid(gid) {
  return window.initConfig.projects.find(function (p) {
    return gid === p.gid;
  });
}

},{}],249:[function(require,module,exports){
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getProjectUrl = getProjectUrl;
/**
 * @param gid
 * 
 * @returns {string}
 */
function getProjectUrl(gid) {
  var project = window.initConfig.projects.find(function (p) {
    return gid === p.gid;
  });
  try {
    return "" + new URL(window.initConfig.urls.baseurl) + project.url;
  } catch (e) {
    console.warn(e);
    return "" + location.origin + window.initConfig.urls.baseurl + project.url;
  }
}

},{}],250:[function(require,module,exports){
Object.defineProperty(exports, "__esModule", {
   value: true
});
exports.getResolutionFromScale = getResolutionFromScale;

var _g3wConstants = require('g3w-constants');

function getResolutionFromScale(scale) {
   var units = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'm';

   // just to prevent that scale is passed as 1:10000 or 0.0001
   return 1 / ((scale >= 1.0 ? 1.0 / scale : scale) * _g3wConstants.INCHES_PER_UNIT[units] * _g3wConstants.DOTS_PER_INCH);
}

},{"g3w-constants":159}],251:[function(require,module,exports){
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getScaleFromResolution = getScaleFromResolution;

var _g3wConstants = require('g3w-constants');

function getScaleFromResolution(resolution) {
  var units = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'm';

  return Math.round(resolution * _g3wConstants.INCHES_PER_UNIT[units] * _g3wConstants.DOTS_PER_INCH);
}

},{"g3w-constants":159}],252:[function(require,module,exports){
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getUniqueDomId = getUniqueDomId;
var _uid = 0;

function getUniqueDomId() {
  return ++_uid + "_" + Date.now();
}

},{}],253:[function(require,module,exports){
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.get_legend_params = get_legend_params;
/**
 * @param layer
 * 
 * @returns {{ LEGEND_ON: undefined | string, LEGEND_OFF: undefined | string }} 
 */
function get_legend_params(layer) {
  var LEGEND_ON = void 0,
      LEGEND_OFF = void 0;
  (layer.getCategories() || []).forEach(function (_ref) {
    var checked = _ref.checked,
        _checked = _ref._checked,
        ruleKey = _ref.ruleKey;

    // skip when there's no difference from original `checked` status (_checked) and current changed by toc categories (checked)
    if (checked === _checked) {
      return;
    }
    if (checked) {
      LEGEND_ON = (undefined === LEGEND_ON ? layer.getWMSLayerName() + ":" : LEGEND_ON + ",") + ruleKey;
    } else {
      LEGEND_OFF = (undefined === LEGEND_OFF ? layer.getWMSLayerName() + ":" : LEGEND_OFF + ",") + ruleKey;
    }
  });
  return {
    LEGEND_ON: LEGEND_ON,
    LEGEND_OFF: LEGEND_OFF
  };
}

},{}],254:[function(require,module,exports){
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.groupBy = groupBy;
/**
 * Almost the same as lodash@v4.0.0 groupBy
 * 
 * @since 3.10.0
 */
function groupBy(array, keyFn) {
  return array.reduce(function (result, item) {
    var key = keyFn(item);
    if (!result[key]) {
      result[key] = [];
    }
    result[key].push(item);
    return result;
  }, {});
}

},{}],255:[function(require,module,exports){
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.inherit = inherit;
/**
 * google closure library impememtation
 */
function inherit(childCtor, parentCtor) {
  function tempCtor() {}
  tempCtor.prototype = parentCtor.prototype;
  childCtor.superClass_ = parentCtor.prototype;
  childCtor.prototype = new tempCtor();
  childCtor.prototype.constructor = childCtor;
}

},{}],256:[function(require,module,exports){
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.intersects = intersects;

var _jstsMin = require('jsts/dist/jsts.min.js');

var _jstsMin2 = _interopRequireDefault(_jstsMin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Check if `geometryCheck` intersects with `geometry`
 * 
 * @param   {ol.geometry} geometry
 * @param   {ol.geometry} geometryToCheck
 * 
 * @returns {boolean}     whether `geometryToCheck` interesects `geometry`
 * 
 * @since 3.8.0
 */
function intersects(geometry, geometryToCheck) {
  var parser = new _jstsMin2.default.io.OL3Parser();
  parser.inject(ol.geom.Point, ol.geom.LineString, ol.geom.LinearRing, ol.geom.Polygon, ol.geom.MultiPoint, ol.geom.MultiLineString, ol.geom.MultiPolygon);
  return parser.read(geometry).intersects(parser.read(geometryToCheck));
}

},{"jsts/dist/jsts.min.js":21}],257:[function(require,module,exports){
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.is3DGeometry = is3DGeometry;

var _g3wConstants = require('g3w-constants');

function is3DGeometry(geometryType) {
  return [_g3wConstants.GEOMETRY_TYPES.POINTZ, _g3wConstants.GEOMETRY_TYPES.POINTM, _g3wConstants.GEOMETRY_TYPES.POINTZM, _g3wConstants.GEOMETRY_TYPES.POINT25D, _g3wConstants.GEOMETRY_TYPES.MULTIPOINTZ, _g3wConstants.GEOMETRY_TYPES.MULTIPOINTM, _g3wConstants.GEOMETRY_TYPES.MULTIPOINTZM, _g3wConstants.GEOMETRY_TYPES.MULTIPOINT25D, _g3wConstants.GEOMETRY_TYPES.LINESTRINGZ, _g3wConstants.GEOMETRY_TYPES.LINESTRINGM, _g3wConstants.GEOMETRY_TYPES.LINESTRINGZM, _g3wConstants.GEOMETRY_TYPES.LINESTRING25D, _g3wConstants.GEOMETRY_TYPES.MULTILINESTRINGZ, _g3wConstants.GEOMETRY_TYPES.MULTILINESTRINGM, _g3wConstants.GEOMETRY_TYPES.MULTILINESTRINGZM, _g3wConstants.GEOMETRY_TYPES.MULTILINESTRING25D, _g3wConstants.GEOMETRY_TYPES.LINEZ, _g3wConstants.GEOMETRY_TYPES.LINEM, _g3wConstants.GEOMETRY_TYPES.LINEZM, _g3wConstants.GEOMETRY_TYPES.LINE25D, _g3wConstants.GEOMETRY_TYPES.MULTILINEZ, _g3wConstants.GEOMETRY_TYPES.MULTILINEM, _g3wConstants.GEOMETRY_TYPES.MULTILINEZM, _g3wConstants.GEOMETRY_TYPES.MULTILINE25D, _g3wConstants.GEOMETRY_TYPES.POLYGONZ, _g3wConstants.GEOMETRY_TYPES.POLYGONM, _g3wConstants.GEOMETRY_TYPES.POLYGONZM, _g3wConstants.GEOMETRY_TYPES.POLYGON25D, _g3wConstants.GEOMETRY_TYPES.MULTIPOLYGONZ, _g3wConstants.GEOMETRY_TYPES.MULTIPOLYGONM, _g3wConstants.GEOMETRY_TYPES.MULTIPOLYGONZM, _g3wConstants.GEOMETRY_TYPES.MULTIPOLYGON25D].find(function (type3D) {
    return type3D === geometryType;
  });
}

},{"g3w-constants":159}],258:[function(require,module,exports){
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isLineGeometryType = isLineGeometryType;

var _g3wConstants = require('g3w-constants');

/**
 * core/geometry/geometry::isLineGeometryType@v3.4
 * core/geometry/geometry::getAllLineGeometryTypes@v3.4
 */
function isLineGeometryType(geometryType) {
  return [_g3wConstants.GEOMETRY_TYPES.LINESTRING, _g3wConstants.GEOMETRY_TYPES.LINESTRINGZ, _g3wConstants.GEOMETRY_TYPES.LINESTRINGM, _g3wConstants.GEOMETRY_TYPES.LINESTRINGZM, _g3wConstants.GEOMETRY_TYPES.LINESTRING25D, _g3wConstants.GEOMETRY_TYPES.MULTILINESTRING, _g3wConstants.GEOMETRY_TYPES.MULTILINESTRINGZ, _g3wConstants.GEOMETRY_TYPES.MULTILINESTRINGM, _g3wConstants.GEOMETRY_TYPES.MULTILINESTRINGZM, _g3wConstants.GEOMETRY_TYPES.MULTILINESTRING25D, _g3wConstants.GEOMETRY_TYPES.LINE, _g3wConstants.GEOMETRY_TYPES.LINEZ, _g3wConstants.GEOMETRY_TYPES.LINEM, _g3wConstants.GEOMETRY_TYPES.LINEZM, _g3wConstants.GEOMETRY_TYPES.LINE25D, _g3wConstants.GEOMETRY_TYPES.MULTILINE, _g3wConstants.GEOMETRY_TYPES.MULTILINEZ, _g3wConstants.GEOMETRY_TYPES.MULTILINEM, _g3wConstants.GEOMETRY_TYPES.MULTILINEZM, _g3wConstants.GEOMETRY_TYPES.MULTILINE25D].includes(geometryType);
}

},{"g3w-constants":159}],259:[function(require,module,exports){
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isMultiGeometry = isMultiGeometry;

var _g3wConstants = require('g3w-constants');

/**
 * core/geometry/geometry::isMultiGeometry@v3.4
 */
function isMultiGeometry(geometryType) {
  return [_g3wConstants.GEOMETRY_TYPES.MULTIPOINT, _g3wConstants.GEOMETRY_TYPES.MULTIPOINTZ, _g3wConstants.GEOMETRY_TYPES.MULTIPOINTZM, _g3wConstants.GEOMETRY_TYPES.MULTIPOINTM, _g3wConstants.GEOMETRY_TYPES.MULTIPOINT25D, _g3wConstants.GEOMETRY_TYPES.MULTILINESTRING, _g3wConstants.GEOMETRY_TYPES.MULTILINESTRINGZ, _g3wConstants.GEOMETRY_TYPES.MULTILINESTRINGM, _g3wConstants.GEOMETRY_TYPES.MULTILINESTRINGZM, _g3wConstants.GEOMETRY_TYPES.MULTILINESTRING25D, _g3wConstants.GEOMETRY_TYPES.MULTILINE, _g3wConstants.GEOMETRY_TYPES.MULTILINEZ, _g3wConstants.GEOMETRY_TYPES.MULTILINEM, _g3wConstants.GEOMETRY_TYPES.MULTILINEZM, _g3wConstants.GEOMETRY_TYPES.MULTILINE25D, _g3wConstants.GEOMETRY_TYPES.MULTIPOLYGON, _g3wConstants.GEOMETRY_TYPES.MULTIPOLYGONZ, _g3wConstants.GEOMETRY_TYPES.MULTIPOLYGONM, _g3wConstants.GEOMETRY_TYPES.MULTIPOLYGONZM, _g3wConstants.GEOMETRY_TYPES.MULTIPOLYGON25D].includes(geometryType);
}

},{"g3w-constants":159}],260:[function(require,module,exports){
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isPointGeometryType = isPointGeometryType;

var _g3wConstants = require('g3w-constants');

/**
 * core/geometry/geometry::isPointGeometryType@v3.4
 * core/geometry/geometry::getAllPointGeometryTypes@v3.4
 */
function isPointGeometryType(geometryType) {
  return [_g3wConstants.GEOMETRY_TYPES.POINT, _g3wConstants.GEOMETRY_TYPES.POINTZ, _g3wConstants.GEOMETRY_TYPES.POINTM, _g3wConstants.GEOMETRY_TYPES.POINTZM, _g3wConstants.GEOMETRY_TYPES.POINT25D, _g3wConstants.GEOMETRY_TYPES.MULTIPOINT, _g3wConstants.GEOMETRY_TYPES.MULTIPOINTZ, _g3wConstants.GEOMETRY_TYPES.MULTIPOINTM, _g3wConstants.GEOMETRY_TYPES.MULTIPOINTZM, _g3wConstants.GEOMETRY_TYPES.MULTIPOINT25D].includes(geometryType);
}

},{"g3w-constants":159}],261:[function(require,module,exports){
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isPolygonGeometryType = isPolygonGeometryType;

var _g3wConstants = require('g3w-constants');

/**
 * core/geometry/geometry::isPolygonGeometryType@v3.4
 * core/geometry/geometry::getAllPolygonGeometryTypes@v3.4
 */
function isPolygonGeometryType(geometryType) {
  return [_g3wConstants.GEOMETRY_TYPES.POLYGON, _g3wConstants.GEOMETRY_TYPES.POLYGONZ, _g3wConstants.GEOMETRY_TYPES.POLYGONM, _g3wConstants.GEOMETRY_TYPES.POLYGONZM, _g3wConstants.GEOMETRY_TYPES.POLYGON25D, _g3wConstants.GEOMETRY_TYPES.MULTIPOLYGON, _g3wConstants.GEOMETRY_TYPES.MULTIPOLYGONZ, _g3wConstants.GEOMETRY_TYPES.MULTIPOLYGONM, _g3wConstants.GEOMETRY_TYPES.MULTIPOLYGONZM, _g3wConstants.GEOMETRY_TYPES.MULTIPOLYGON25D].includes(geometryType);
}

},{"g3w-constants":159}],262:[function(require,module,exports){
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.noop = noop;
function noop() {}

},{}],263:[function(require,module,exports){
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.normalizeEpsg = normalizeEpsg;
/**
 * @param { number | string } epsg
 * 
 * @returns { string | undefined }
 */
function normalizeEpsg(epsg) {
  if ('number' === typeof epsg) {
    return 'EPSG:' + epsg;
  }
  epsg = epsg.replace(/[^\d\.\-]/g, "");
  if ('' !== epsg) {
    return 'EPSG:' + parseInt(epsg);
  }
}

},{}],264:[function(require,module,exports){
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseAttributes = parseAttributes;

var _g3wConstants = require('g3w-constants');

/**
 * @param layerAttributes
 * @param featureAttributes
 * 
 * @returns { Array }
 */
function parseAttributes() {
  var layerAttributes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var featureAttributes = arguments[1];

  /** @FIXME add description */
  if (layerAttributes && layerAttributes.length > 0) {
    return layerAttributes.filter(function (attr) {
      return Object.keys(featureAttributes).indexOf(attr.name) > -1;
    });
  }
  return Object.keys(featureAttributes).filter(function (name) {
    return -1 === _g3wConstants.GEOMETRY_FIELDS.indexOf(name);
  }).map(function (featureAttributesName) {
    return { name: featureAttributesName, label: featureAttributesName };
  });
}

},{"g3w-constants":159}],265:[function(require,module,exports){
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ResponseParser = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          * @file
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          * 
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          * ORIGINAL SOURCE: src/app/core/utils/parsers.js@3.8
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          * ORIGINAL SOURCE: src/app/core/errors/parser/servererrorparser.js@3.9.1
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          * 
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          * @since 3.9.0
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          */

var _g3wConstants = require('g3w-constants');

var _gui = require('services/gui');

var _gui2 = _interopRequireDefault(_gui);

var _groupBy = require('utils/groupBy');

var _is3DGeometry = require('utils/is3DGeometry');

var _removeZValue = require('utils/removeZValue');

var _sanitizeFidFeature = require('utils/sanitizeFidFeature');

var _reverseGeometry = require('utils/reverseGeometry');

var _feature = require('map/layers/feature');

var _g3wI18n = require('g3w-i18n');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

Object.entries({
  G3W_FID: _g3wConstants.G3W_FID,
  GUI: _gui2.default,
  Feature: _feature.Feature,
  t: _g3wI18n.t,
  is3DGeometry: _is3DGeometry.is3DGeometry,
  removeZValue: _removeZValue.removeZValue,
  sanitizeFidFeature: _sanitizeFidFeature.sanitizeFidFeature,
  reverseGeometry: _reverseGeometry.reverseGeometry
}).forEach(function (_ref) {
  var _ref2 = _slicedToArray(_ref, 2),
      k = _ref2[0],
      v = _ref2[1];

  return console.assert(undefined !== v, k + ' is undefined');
});

var NUMERIC_FIELD = 'GIS3W_ESCAPE_NUMERIC_FIELD_';

/**
 * @example ResponseParser.get('application/vnd.ogc.gml')({ layers, response });
 */
var ResponseParser = exports.ResponseParser = {

  /** Response parser (content types) */
  get: function get(type) {
    switch (type) {

      case 'g3w-error':
        return function () {
          var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          var error = opts.error;

          return {
            parse: function parse() {
              var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                  _ref3$type = _ref3.type,
                  type = _ref3$type === undefined ? 'responseJSON' : _ref3$type;

              /** @FIXME add description */
              if ('responseJSON' === type && error && error.responseJSON && error.responseJSON.error.message) {
                return error.responseJSON.error.message;
              }

              /** @FIXME add description */
              if ('responseJSON' === type && error && error.errors) {
                return _traverseErrorMessage(error.errors);
              }

              /** @FIXME add description */
              if ('String' === type && 'string' === typeof error) {
                return error;
              }

              /** @FIXME add description */
              if ('String' === type) {
                return _traverseErrorMessage(error);
              }

              /** @FIXME add description */
              return (0, _g3wI18n.t)("server_saver_error");
            }
          };
        };

      case 'g3w-table/json':
        return function () {
          var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

          return (data.features || []).map(function (f) {
            var feature = new _feature.Feature();
            feature.setProperties(f.properties);
            feature.setId(f.id);
            return feature;
          });
        };

      case 'g3w-vector/gml':
        return function () {
          var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
              data = _ref4.data,
              layer = _ref4.layer;

          try {
            return new ol.format.WMSGetFeatureInfo({ layers: layer.getQueryLayerOrigName() }).readFeatures(
            // extract gml from multiple (Tuscany region)
            '--' === data.substr(0, 2) ? data.split(/\r\n--/).filter(function (part) {
              return (/<([^ ]*)FeatureCollection/.test(part) || /<([^ ]*)msGMLOutput/.test(part)
              );
            }).map(function (part) {
              return part.substr(part.indexOf('<?xml'));
            }).pop() : data);
          } catch (e) {
            console.warn(e);
            return [];
          }
        };

      case 'g3w-vector/geojson':
      case 'g3w-vector/json':
        return function (data, options) {
          try {
            return new ol.format.GeoJSON({
              geometryName: 'geometry',
              dataProjection: options.crs,
              featureProjection: options.mapCrs || options.crs
            }).readFeatures('string' === typeof data ? JSON.parse(data) : data);
          } catch (e) {
            console.warn(e);
            return [];
          }
        };

      case 'application/json':
        return function () {
          var _ref5 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
              response = _ref5.response,
              projections = _ref5.projections,
              _ref5$layers = _ref5.layers,
              layers = _ref5$layers === undefined ? [] : _ref5$layers,
              _ref5$wms = _ref5.wms,
              wms = _ref5$wms === undefined ? true : _ref5$wms,
              filtertoken = _ref5.filtertoken;

          var layersFeatures = layers.map(function (layer) {
            return { layer: layer, features: [], filtertoken: filtertoken };
          });
          var layersId = layers.map(function (l) {
            return wms ? l.getWMSLayerName() : l.getWFSLayerName();
          });
          // features
          (response ? new ol.format.GeoJSON({
            geometryName: 'geometry',
            defaultDataProjection: projections.layer || projections.map
          }).readFeatures(response) : []).filter(function (feature) {
            var featureId = feature.getId();
            var g3w_fid = (0, _sanitizeFidFeature.sanitizeFidFeature)(featureId);
            // in the case of wms getfeature without a filter return string contain layerName or layerid
            var index = featureId == g3w_fid ? 0 : layersId.indexOf(featureId);
            // skip when ..
            if (-1 === index) {
              return false;
            }
            var props = feature.getProperties();
            feature.set(_g3wConstants.G3W_FID, g3w_fid);
            // fields
            layersFeatures[index].layer.getFields().filter(function (f) {
              return f.show && undefined === props[f.name] && undefined !== props[f.label];
            }).forEach(function (f) {
              return feature.set(f.name, props[f.label]);
            });
            // features
            layersFeatures[index].features.push(feature);
          });
          return layersFeatures;
        };

      case 'application/geojson':
        return function () {
          var _ref6 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
              layers = _ref6.layers,
              response = _ref6.response;

          return response ? layers.map(function (layer) {
            return {
              layer: layer,
              features: ResponseParser.get('g3w-vector/geojson')(response, {})
            };
          }) : [];
        };

      case 'text/plain':
      case 'text/html':
        return function () {
          var _ref7 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
              layers = _ref7.layers,
              response = _ref7.response;

          return layers.map(function (layer) {
            return {
              layer: layer,
              rawdata: response
            };
          });
        };

      case 'text/gml':
        return function (_ref8) {
          var layers = _ref8.layers,
              response = _ref8.response;

          return layers.map(function (layer) {
            return {
              layer: layer,
              features: ResponseParser.get('g3w-vector/gml')({ data: response, layer: layers[0] })
            };
          });
        };

      case 'application/vnd.ogc.gml':
        return function () {
          var _ref9 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
              response = _ref9.response,
              projections = _ref9.projections,
              layers = _ref9.layers,
              _ref9$wms = _ref9.wms,
              wms = _ref9$wms === undefined ? true : _ref9$wms;

          // convert XML response to string
          if (response && 'string' !== typeof response && !(response instanceof String)) {
            response = new XMLSerializer().serializeToString(response);
          }

          // sanitize layer name (removes: whitespaces, quotes, parenthesis, slashes)
          if (response) {
            response = layers.reduce(function (acc, layer, i) {
              var id = (wms && layer.isWmsUseLayerIds() ? layer.getId() : layer.getName()).replace(/[\s'()/]+/g, function (s) {
                return (/\s/g.test(s) && !wms ? '_' : ''
                );
              });
              if (!wms) {
                id = id.replace(/[/\\]+/g, '').replaceAll(':', '-');
              }
              return acc.replace(new RegExp('qgs:' + id, 'g'), 'qgs:layer' + i);
            }, response);
          }

          // fields starting with an invalid key
          var invalids = response && Array.from(response.matchAll(/qgs:(\d+(?:\.\d+)?)(\w+)|qgs:(\w+):(\w+)/g)).filter(function (_, i) {
            return 0 === i % 2;
          });

          // numeric value (integer or float)
          if (invalids) {
            response = invalids.reduce(function (acc, find) {
              return acc.replace(new RegExp(find[0], 'g'), 'qgs:' + NUMERIC_FIELD + find[1] + find[2]);
            }, response);
          }

          // HOTFIX: null characther ("\u0000")
          if (response) {
            response = response.replace(new RegExp(String.fromCharCode(0), 'g'), '0');
          }

          var parsed = []; //Array contains item object ({layer, features})
          var xml = void 0;

          try {
            xml = new DOMParser().parseFromString(response, "text/xml");

            // skip when response has no features
            if (!xml.querySelector('FeatureCollection > featureMember')) {
              throw 'no features in response';
            }

            layers.forEach(function (layer, i) {

              var cloned = xml.cloneNode(true);
              var feats = [];

              // get layers by name (eg. "qgs:layer0")
              var qgs = [].concat(_toConsumableArray(cloned.querySelectorAll('FeatureCollection > featureMember > layer' + i)));

              // set "g3w_fid" attribute from `fid="<layer_name_or_id.fid>"`
              qgs.forEach(function (feat) {
                var fid = (feat.getAttribute('fid') || '.').split('.')[1];
                if (fid) {
                  var g3w_fid = cloned.createElement('gml:' + _g3wConstants.G3W_FID);
                  feat.setAttribute('fid', fid);
                  g3w_fid.textContent = fid;
                  feat.appendChild(g3w_fid);
                }
                feats.push(feat.parentNode);
              });

              // get multi layers wms (eg. "layer0" → "layer0_0" + "layer1_0")
              if (qgs.length > 1) {
                var grouped = (0, _groupBy.groupBy)(qgs, function (feat) {
                  return Object.values(feat.children).map(function (d) {
                    return d.nodeName;
                  });
                });
                if (Object.keys(grouped).length > 1) {
                  Object.keys(grouped).forEach(function (key, i) {
                    return grouped[key].forEach(function (node, j) {
                      // see: https://andreiglingeanu.me/rename-element-tag/
                      var renamed = cloned.createElement('qgs:layer' + i + '_' + j);
                      [].concat(_toConsumableArray(node.attributes)).map(function (_ref10) {
                        var name = _ref10.name,
                            value = _ref10.value;
                        renamed.setAttribute(name, value);
                      });
                      while (node.firstChild) {
                        renamed.appendChild(node.firstChild);
                      }
                      var feat = cloned.createElement('gml:featureMember');
                      feat.appendChild(renamed);
                      node.parentNode.insertAdjacentElement('beforebegin', feat);
                      if (1 === node.parentNode.children.length) {
                        node.parentNode.parentNode.removeChild(node.parentNode);
                      } else {
                        node.parentNode.removeChild(node);
                      }
                      feats.push(feat);
                    });
                  });
                }
              }

              // keep only current layer features
              cloned.querySelectorAll('FeatureCollection > featureMember').forEach(function (node) {
                if (!feats.includes(node)) {
                  node.parentNode.removeChild(node);
                }
              });

              feats = new ol.format.WMSGetFeatureInfo().readFeatures(cloned.documentElement.outerHTML);

              // whether need to re-project features
              var is_reprojected = projections.layer && projections.layer.getCode() !== projections.map.getCode() && feats.length && !!feats[0].getGeometry();

              /** @FIXME add description */
              if (feats.length && invalids) {
                var fields = Object.keys(feats[0].getProperties()).filter(function (p) {
                  return -1 !== p.indexOf(NUMERIC_FIELD);
                });
                feats.forEach(function (f) {
                  fields.forEach(function (_field) {
                    var invalid = invalids.find(function (find) {
                      return '' + find[1] + find[2] === _field.replace(NUMERIC_FIELD, '');
                    });
                    f.set(invalid[0].replace('qgs:', ''), [].concat(f.get(_field))[0]);
                    f.unset(_field);
                  });
                });
              }

              // transform features
              if (is_reprojected) {
                feats.forEach(function (f) {
                  return f.setGeometry(f.getGeometry().transform(projections.layer.getCode(), projections.map.getCode()));
                });
              }

              // inverted axis --> reverse features coordinates
              if (is_reprojected && 'ne' === (projections.layer || projections.map).getAxisOrientation().substr(0, 2)) {
                feats.forEach(function (f) {
                  return f.setGeometry((0, _reverseGeometry.reverseGeometry)(f.getGeometry()));
                });
              }

              // remove Z values added by "ol.format.WMSGetFeatureInfo" readFeatures
              if (layer.isGeoLayer() && !(0, _is3DGeometry.is3DGeometry)(layer.getGeometryType())) {
                feats.forEach(function (f) {
                  return (0, _removeZValue.removeZValue)({ feature: f });
                });
              }

              parsed.unshift({ layer: layer, features: feats });
            });
          } catch (e) {
            console.warn(e);
          }

          /** @since 3.9.1 handle server errors */
          if (xml.querySelector('ServiceException')) {
            _gui2.default.showUserMessage({
              type: 'warning',
              textMessage: true,
              message: layers[0].getName() + ' - ' + xml.querySelector('ServiceException').innerText
            });
          }

          return parsed;
        };

      default:
        return function () {
          var _ref11 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
              _ref11$layers = _ref11.layers,
              layers = _ref11$layers === undefined ? [] : _ref11$layers;

          return layers.map(function (layer) {
            return { layer: layer, rawdata: (0, _g3wI18n.t)('warning.not_supported_format') };
          });
        };

    }
  }
};

/**
 * ORIGINAL SOURCE: src/app/core/errors/parser/servererrorparser.js@3.9.1
 */
function _traverseErrorMessage(errorObject) {
  var error_message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "server_saver_error";

  try {
    var entries = Object.entries(errorObject);
    var entry = entries.find(function (_ref12) {
      var _ref13 = _slicedToArray(_ref12, 2),
          key = _ref13[0],
          _ = _ref13[1];

      return 'fields' === key;
    });

    var _ref14 = entry || entries[0],
        _ref15 = _slicedToArray(_ref14, 2),
        value = _ref15[1];

    /** @FIXME add description */


    if (!entry && !Array.isArray(value) && 'object' === (typeof value === 'undefined' ? 'undefined' : _typeof(value))) {
      return _traverseErrorMessage(value, error_message);
    }

    /** @FIXME add description */
    if (entry && 'string' === typeof value) {
      error_message = '[' + entries.find(function (_ref16) {
        var _ref17 = _slicedToArray(_ref16, 1),
            key = _ref17[0];

        return 'fields' !== key;
      })[0] + '] ' + value;
    }

    /** @FIXME add description */
    if (entry && 'string' !== typeof value) {
      error_message = Object.entries(value).reduce(function (message, _ref18) {
        var _ref19 = _slicedToArray(_ref18, 2),
            field = _ref19[0],
            error = _ref19[1];

        return '' + message + field + ' ' + (Array.isArray(error) ? error[0] : error) + '\n';
      }, '');
    }

    /** @FIXME add description */
    if (entry) {
      return error_message.replace(/\:|\./g, '');
    }
  } catch (e) {
    console.warn(e);
  }
}

},{"g3w-constants":159,"g3w-i18n":162,"map/layers/feature":186,"services/gui":207,"utils/groupBy":254,"utils/is3DGeometry":257,"utils/removeZValue":270,"utils/reverseGeometry":271,"utils/sanitizeFidFeature":273}],266:[function(require,module,exports){
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.printAtlas = printAtlas;

var _application = require('store/application');

var _application2 = _interopRequireDefault(_application);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

/*
 http://localhost/fcgi-bin/qgis_mapserver/qgis_mapserv.fcgi
  ?MAP=/home/marco/geodaten/projekte/composertest.qgs
  &SERVICE=WMS&VERSION=1.3.0
  &REQUEST=GetPrint
  &TEMPLATE=Composer 1
  &map0:extent=693457.466131,227122.338236,700476.845177,230609.807051
  &BBOX=693457.466131,227122.338236,700476.845177,230609.807051
  &CRS=EPSG:21781
  &WIDTH=1467
  &HEIGHT=729
  &LAYERS=layer0,layer1
  &STYLES=,
  &FORMAT=pdf
  &DPI=300
  &TRANSPARENT=true

 In detail, the following parameters can be used to set properties for composer maps:

 <mapname>:EXTENT=<xmin,ymin,xmax, ymax> //mandatory
 <mapname>:ROTATION=<double> //optional, defaults to 0
 <mapname>:SCALE=<double> //optional. Forces scale denominator as server and client may have different scale calculations
 <mapname>:LAYERS=<comma separated list with layer names> //optional. Defaults to all layer in the WMS request
 <mapname>:STYLES=<comma separated list with style names> //optional
 <mapname>:GRID_INTERVAL_X=<double> //set the grid interval in x-direction for composer grids
 <mapname>:GRID_INTERVAL_Y=<double> //set the grid interval in x-direction for composer grids
 */

/**
 * ORIGINAL SOURCE: src\app\core\print\printservice.js@3.9.0
 * 
 * @param { Object } opts
 * @param opts.field
 * @param opts.values
 * @param opts.template
 * @param opts.download
 * @param { 'GET' | 'POST' } method
 */
function printAtlas() {
  var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var method = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'GET';

  var store = _application2.default.project.getLayersStore();
  var multi = opts.values.length > 1;
  return FETCH[method]({
    url: store.getWmsUrl(),
    mime_type: 'application/pdf',
    params: {
      SERVICE: 'WMS',
      VERSION: '1.3.0',
      REQUEST: 'GetPrintAtlas',
      EXP_FILTER: opts.field + (multi ? ' IN (' : '=') + opts.values.map(function (v) {
        return '\'' + v + '\'';
      }).join() + (multi ? ')' : ''),
      TEMPLATE: opts.template,
      filtertoken: _application2.default.tokens.filtertoken,
      DOWNLOAD: opts.download ? 1 : undefined
    }
  });
}

var FETCH = {
  /**
   * @param { Object } opts
   * @param opts.url
   * @param opts.params
   * @param opts.mime_type
   * @return {Promise<{mime_type, layers: boolean, url: string}>}
   */
  POST: function () {
    var _ref2 = _asyncToGenerator(function* (_ref) {
      var url = _ref.url,
          _ref$params = _ref.params,
          params = _ref$params === undefined ? {} : _ref$params,
          mime_type = _ref.mime_type;

      var response = yield fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
        body: new URLSearchParams(params || {}).toString()
      });
      if (!response.ok) {
        //@TODO Need to translate
        throw new Error(500 === response.status ? 'Internal Server Error' : 'Request Failed');
      }
      return {
        mime_type: mime_type,
        layers: true,
        url: URL.createObjectURL((yield response.blob()))
      };
    });

    function POST(_x3) {
      return _ref2.apply(this, arguments);
    }

    return POST;
  }(),

  /**
   * @param { Object } opts
   * @param opts.url
   * @param opts.params
   * @param opts.mime_type
   * @return {Promise<unknown>}
   */
  GET: function () {
    var _ref4 = _asyncToGenerator(function* (_ref3) {
      var url = _ref3.url,
          _ref3$params = _ref3.params,
          params = _ref3$params === undefined ? {} : _ref3$params,
          mime_type = _ref3.mime_type;

      return {
        url: url + '?' + new URLSearchParams(params || {}).toString(),
        layers: true,
        mime_type: mime_type
      };
    });

    function GET(_x4) {
      return _ref4.apply(this, arguments);
    }

    return GET;
  }()
};

},{"store/application":212}],267:[function(require,module,exports){
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.promisify = promisify;
exports.$promisify = $promisify;

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

/**
 * Migrate your consumer code away from jQuery promises.
 * Covert a jQuery promise into an ES6 Promise
 * 
 * @param promise jquery promise
 */
function promisify(promise) {
  if (promise instanceof Promise) {
    return promise;
  }
  if (!promise || !promise.then) {
    console.trace(promise);
    return Promise.reject('not a promise');
  }
  return new Promise(function (resolve, reject) {
    promise.then(resolve).fail(reject);
  });
}

/**
 * Migrate your consumer code away from jQuery promises.
 * Convert ES6 Promise into jQuery
 * 
 * @param promise async function or ES6 promise 
 */
function $promisify(promise) {
  if (undefined === promise) {
    console.trace();
    return $.Deferred(function (d) {
      return d.reject('not a promise');
    }).promise();
  }
  if (promise.always) {
    return promise;
  }
  return $.Deferred(function () {
    var _ref = _asyncToGenerator(function* (d) {
      try {
        d.resolve((yield promise instanceof Promise ? promise : promise()));
      } catch (e) {
        console.trace(e);d.reject(e);
      }
    });

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }()).promise();
}

},{}],268:[function(require,module,exports){
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.prompt = undefined;

/**
 * @TODO make it simpler (native HTML dialogs, Vue SFC components, ..)
 * 
 * Similar to `window.prompt`
 * 
 * @since 3.9.0
 */
var prompt = exports.prompt = function () {
  var _ref2 = _asyncToGenerator(function* (_ref) {
    var value = _ref.value,
        label = _ref.label,
        callback = _ref.callback;


    // Reactive vue object (input instance)
    var _data = {
      value: value,
      id: (0, _getUniqueDomId.getUniqueDomId)()
    };

    var vueInput = new Vue({
      template: /* html */'\n      <div>\n        <label :for="id">' + label + '</label>\n        <input\n          v-model      = "value"\n          :id          = "id"\n          class        = "bootbox-input bootbox-input-text form-control"\n          autocomplete = "off"\n          type         = "text"\n        >\n      </div>',
      data: function data() {
        return _data;
      }
    });

    var prompt = void 0; // store dialog modal window

    new Promise(function (resolve, reject) {
      // modal window with input name
      prompt = _gui2.default.showModalDialog({
        message: vueInput.$mount().$el,
        closeButton: false,
        buttons: {
          ok: { label: 'Ok', className: 'btn-success', callback: function callback() {
              return resolve(_data.value);
            } },
          cancel: { label: 'Cancel', className: 'btn-danger', callback: function callback() {
              return reject();
            } }
        }
      });
      // conditionally disable confirm button (based on input value)
      var okBtn = prompt.find('button.btn-success');
      okBtn.prop('disabled', 0 === _data.value.trim().length);
      vueInput.$watch('value', function (value) {
        okBtn.prop('disabled', 0 === value.trim().length);
      });
    }).then(callback).catch(function (e) {
      return console.warn(e);
    }).finally(function () {
      vueInput.$destroy();
      vueInput = null;
      _data = null;
      prompt = null;
    });
  });

  return function prompt(_x) {
    return _ref2.apply(this, arguments);
  };
}();

var _gui = require('services/gui');

var _gui2 = _interopRequireDefault(_gui);

var _getUniqueDomId = require('utils/getUniqueDomId');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

},{"services/gui":207,"utils/getUniqueDomId":252}],269:[function(require,module,exports){
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.removeMeasureTooltip = removeMeasureTooltip;
/**
 * Remove mesure tootltip
 * 
 * @param { Object } opts
 * @param opts.map
 * @param opts.tooltip
 * @param opts.unByKey 
 */
function removeMeasureTooltip(_ref) {
  var map = _ref.map,
      tooltip = _ref.tooltip,
      unbyKey = _ref.unbyKey;

  map.removeOverlay(tooltip);
  ol.Observable.unByKey(unbyKey);
}

},{}],270:[function(require,module,exports){
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.removeZValue = removeZValue;

var _g3wConstants = require('g3w-constants');

/**
 * Remove Z values from geometry coordinates
 */
function removeZValue() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      feature = _ref.feature;

  var geometry = feature.getGeometry();

  // skip when feature has no geometry (alphanumerical feature)
  if (!geometry) {
    return feature;
  }

  var coords = geometry.getCoordinates();

  switch (geometry.getType()) {

    // POINT: [x, y]
    case _g3wConstants.GEOMETRY_TYPES.POINT:
      coords.splice(2);
      geometry.setCoordinates(coords);
      break;

    // MULTIPOINT: [ [x1, y1], [x2, y2] ]
    case _g3wConstants.GEOMETRY_TYPES.MULTIPOINT:
    // LINE: [ [x1, y1], [x2, y2] ]
    case _g3wConstants.GEOMETRY_TYPES.LINESTRING:
    case _g3wConstants.GEOMETRY_TYPES.LINE:
      coords.forEach(function (c) {
        return c.splice(2);
      });
      geometry.setCoordinates(coords);
      break;

    // MULTILINE: [
    //   [ [x1, y1], [x2, y2] ],
    //   [ [x3, y3], [x4, y4] ]
    // ]
    case _g3wConstants.GEOMETRY_TYPES.MULTILINESTRING:
    case _g3wConstants.GEOMETRY_TYPES.MULTILINE:
      coords.forEach(function (line) {
        return line.forEach(function (c) {
          return c.splice(2);
        });
      });
      geometry.setCoordinates(coords);
      break;

    // POLYGON: [
    //   [ [x1, y1], [x2, y2], [x3, y3], [x1, y1] ]
    // ]
    case _g3wConstants.GEOMETRY_TYPES.POLYGON:
      coords[0].forEach(function (c) {
        return c.splice(2);
      });
      geometry.setCoordinates(coords);
      break;

    // MULTIPOLYGON: [
    //   [ [x1, y1], [x2, y2], [x3, y3], [x1, y1] ],
    //   [ [xa, ya], [xb, yb], [xc, yc], [xa, ya] ]
    // ]
    case _g3wConstants.GEOMETRY_TYPES.MULTIPOLYGON:
      coords.forEach(function (poly) {
        return poly[0].forEach(function (c) {
          return c.splice(2);
        });
      });
      geometry.setCoordinates(coords);
      break;

    default:
      console.warn('unsupported geometry type: ' + geometry.getType());

  }

  return feature;
}

},{"g3w-constants":159}],271:[function(require,module,exports){
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.reverseGeometry = reverseGeometry;
/**
 * @param geometry 
 */
function reverseGeometry(geometry) {
  geometry.setCoordinates(_reverseCoords(geometry.getCoordinates()));
  return geometry;
}

function _reverseCoords(coords) {
  coords.find(function (c) {
    if (!Array.isArray(c)) {
      var _coords = _slicedToArray(coords, 2),
          y = _coords[0],
          x = _coords[1];

      coords[0] = x;coords[1] = y;
      return true;
    }
    _reverseCoords(c);
  });
  return coords;
}

},{}],272:[function(require,module,exports){
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sameOrigin = sameOrigin;
/**
 * @param {string} url1
 * @param {string} url2
 *
 * @returns {boolean} whether URLs have same origin.
 *
 * @since 3.8.0
 */
function sameOrigin(url1, url2) {
  try {
    return new URL(url1).origin === new URL(url2).origin;
  } catch (e) {
    console.warn(e);
    return false;
  }
}

},{}],273:[function(require,module,exports){
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sanitizeFidFeature = sanitizeFidFeature;
function sanitizeFidFeature(fid) {
  if ('string' === typeof fid && Number.isNaN(1 * fid)) {
    fid = fid.split('.');
    fid = fid.at(2 === fid.length ? 1 : 0);
  }
  return fid;
}

},{}],274:[function(require,module,exports){
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.saveBlob = saveBlob;
/**
 * Save blob file to disk, same as: `Content-Disposition: attachment; filename="file name.jpg"` response header
 */
function saveBlob(blob) {
  var filename = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'filename=g3w_file';

  Object.assign(document.createElement('a'), {
    href: URL.createObjectURL(blob),
    download: filename.split('filename=').at(-1)
  }).click();
  URL.revokeObjectURL(blob);
}

},{}],275:[function(require,module,exports){
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.splitFeature = splitFeature;

var _isMultiGeometry = require('utils/isMultiGeometry');

var _isPolygonGeometryType = require('utils/isPolygonGeometryType');

var _isLineGeometryType = require('utils/isLineGeometryType');

var _jstsMin = require('jsts/dist/jsts.min.js');

var _jstsMin2 = _interopRequireDefault(_jstsMin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/**
 * @param { Object } opts
 * @param opts.feature
 * @param opts.splitfeature
 * 
 * @returns { Array } splitted feature geometries
 */
function splitFeature() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      feature = _ref.feature,
      splitfeature = _ref.splitfeature;

  var geometries = {
    feature: feature.getGeometry(), //geometry of the feature to split
    split: splitfeature.getGeometry() // geometry of split feature
  };

  if ('LineString' !== geometries.split.getType()) {
    return [];
  }

  // array of split geometries
  var splittedFeatureGeometries = [];
  var parser = new _jstsMin2.default.io.OL3Parser();
  parser.inject(ol.geom.Point, ol.geom.LineString, ol.geom.LinearRing, ol.geom.Polygon, ol.geom.MultiPoint, ol.geom.MultiLineString, ol.geom.MultiPolygon);
  var is_multi = (0, _isMultiGeometry.isMultiGeometry)(geometries.feature.getType());
  var is_line = (0, _isLineGeometryType.isLineGeometryType)(geometries.feature.getType());
  var is_poly = (0, _isPolygonGeometryType.isPolygonGeometryType)(geometries.feature.getType());
  var polygonFeature = is_poly && (is_multi ? geometries.feature.getPolygons() : geometries.feature);
  var lineFeatureGeometry = is_line && (is_multi ? geometries.feature.getLineStrings() : geometries.feature);

  // MultiPolygon or MultiLineString
  if (is_multi && (is_line || is_poly)) {
    var geomClass = is_poly ? ol.geom.MultiPolygon : ol.geom.MultiLineString;
    (is_poly ? polygonFeature : lineFeatureGeometry).forEach(function (geometry) {
      var splitFeatures = splitFeature({ splitfeature: splitfeature, feature: new ol.Feature({ geometry: geometry }) });
      if (splitFeatures.length > 0) {
        splitFeatures.forEach(function (geometry) {
          return geometry && splittedFeatureGeometries.push(new geomClass([geometry.getCoordinates()]));
        });
      } else {
        splittedFeatureGeometries.push(new geomClass([geometry.getCoordinates()]));
      }
    });
  }

  // Polygon
  if (is_poly && !is_multi) {
    var isZType = polygonFeature.getCoordinates()[0][0][2] !== undefined;
    var polygonFeatureGeometry = parser.read(polygonFeature);
    var externalPolygonFeatureGeometry = parser.read(polygonFeature.getLinearRing(0));
    var splitGeometry = parser.read(geometries.split); // create a line split feature in jsts
    var holePolygons = void 0; // holes geometries

    if (polygonFeature.getLinearRingCount() > 1) {
      var holeFeaturesGeometry = void 0;
      for (var index = 1; index < polygonFeature.getLinearRingCount(); index++) {
        var holeRing = parser.read(polygonFeature.getLinearRing(index));
        holeFeaturesGeometry = undefined === holeFeaturesGeometry ? holeRing : holeFeaturesGeometry.union(holeRing);
      }

      holePolygons = new _jstsMin2.default.operation.polygonize.Polygonizer();

      holePolygons.add(holeFeaturesGeometry);

      var holyPolygonUnion = void 0;

      holePolygons.getPolygons().toArray().forEach(function (polygon) {
        return holyPolygonUnion = undefined === holyPolygonUnion ? polygon : holyPolygonUnion.union(polygon);
      });

      holePolygons = holyPolygonUnion;
    }

    if (isZType) {

      polygonFeature.getCoordinates()[0].forEach(function (c, i) {
        return externalPolygonFeatureGeometry.getCoordinates()[i].z = c[2];
      });

      splitGeometry.getCoordinates().forEach(function (coordinate) {
        return coordinate.z = 0;
      });
    }

    var union = externalPolygonFeatureGeometry.union(splitGeometry);
    var polygonizer = new _jstsMin2.default.operation.polygonize.Polygonizer();

    polygonizer.add(union);

    var polygons = polygonizer.getPolygons().toArray();

    if (polygons.length > 1) {
      polygons.forEach(function (polygon) {
        if (holePolygons) {
          polygon = polygon.difference(holePolygons);
        }

        if (polygonFeatureGeometry.intersects(polygon.getInteriorPoint())) {
          var geometry = parser.write(polygon);
          var polygonCoordinates = polygon.getCoordinates();

          if (isZType) {
            polygonCoordinates.forEach(function (c, i) {
              return c.z = c.z === undefined ? polygonCoordinates[i === 0 ? i + 1 : i - 1].z : c.z;
            });
            var zCoordinates = [];
            geometry.getCoordinates()[0].forEach(function (c, i) {
              c.push(polygonCoordinates[i].z);
              zCoordinates.push(c);
            });
            geometry.setCoordinates([zCoordinates]);
          }

          var is_single = !(0, _isMultiGeometry.isMultiGeometry)(geometry.getType());

          if (is_multi) {
            splittedFeatureGeometries.push(new ol.geom.MultiPolygon(is_single ? [geometry.getCoordinates()] : geometry.getCoordinates()));
          } else {
            if (is_single) {
              splittedFeatureGeometries.push(geometry);
            } else {
              geometry.getCoordinates().forEach(function (c) {
                return splittedFeatureGeometries.push(new ol.geom.Polygon(c));
              });
            }
          }
        }
      });
    }
  }

  // LineString or MultiLineString
  if (is_line && !is_multi) {
    var _ret = function () {
      var splitGeometry = geometries.split;
      var lineGeometry = geometries.feature;
      var isZType = undefined !== lineGeometry.getCoordinates()[0][2];
      var splitted = false;
      var splittedSegments = [];
      var jstsFromWkt = new _jstsMin2.default.io.WKTReader();
      var wktFromOl = new ol.format.WKT();
      var olFromJsts = new _jstsMin2.default.io.OL3Parser();
      olFromJsts.inject(ol.geom.Point, ol.geom.LineString, ol.geom.LinearRing, ol.geom.Polygon, ol.geom.MultiPoint, ol.geom.MultiLineString, ol.geom.MultiPolygon);
      var splitLine = jstsFromWkt.read(wktFromOl.writeGeometry(splitGeometry));
      var wktLineString = wktFromOl.writeGeometry(lineGeometry);

      if (isZType) {
        wktLineString = wktLineString.replace(' Z', '');
      }

      var targetLine = jstsFromWkt.read(wktLineString);
      var targetCoordinates = targetLine.getCoordinates();
      var geometryFactory = new _jstsMin2.default.geom.GeometryFactory();
      var pointsNotSplitted = [];

      var endPoint = void 0;
      var startPoint = void 0;

      for (var i = 0; i < targetCoordinates.length - 1; i++) {
        startPoint = targetCoordinates[i];
        endPoint = targetCoordinates[i + 1];

        if (isZType) {
          startPoint.z = lineGeometry.getCoordinates()[i][2];
          endPoint.z = lineGeometry.getCoordinates()[i + 1][2];
        }

        // create a segment of two vertex
        var segment = geometryFactory.createLineString([startPoint, endPoint]);
        var intersectCoordinates = segment.intersection(splitLine).getCoordinates();

        splitted = splitted || intersectCoordinates.length > 0;

        intersectCoordinates.forEach(function (splitPoint) {
          if (isZType) {
            splitPoint.z = startPoint.z;
          }

          var lineNewSegment = olFromJsts.write(geometryFactory.createLineString((pointsNotSplitted.length ? pointsNotSplitted : []).concat([startPoint, splitPoint])));

          if (isZType) {
            var coordinates = lineNewSegment.getCoordinates();
            lineNewSegment.setCoordinates([[].concat(_toConsumableArray(coordinates[0]), [startPoint.z]), [].concat(_toConsumableArray(coordinates[1]), [splitPoint.z])]);
          }

          if (pointsNotSplitted.length) {
            pointsNotSplitted = [];
          }

          splittedSegments.push(lineNewSegment);

          startPoint = splitPoint;
        });

        pointsNotSplitted = pointsNotSplitted.concat([startPoint, endPoint]);
      }

      var restOfLine = olFromJsts.write(geometryFactory.createLineString(pointsNotSplitted));

      if (isZType) {
        restOfLine.setCoordinates(pointsNotSplitted.map(function (pointNotSplitted, index) {
          var coordinate = restOfLine.getCoordinates()[index];
          coordinate.push(pointNotSplitted.z);
          return coordinate; // z coordinates
        }));
      }

      splittedSegments.push(restOfLine);

      return {
        v: splitted ? splittedSegments : []
      };
    }();

    if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
  }

  return splittedFeatureGeometries;
}

},{"jsts/dist/jsts.min.js":21,"utils/isLineGeometryType":258,"utils/isMultiGeometry":259,"utils/isPolygonGeometryType":261}],276:[function(require,module,exports){
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.throttle = throttle;
/**
 * build throttle function
 */
function throttle(fnc) {
  var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;

  var lastCall = void 0;
  return function () {
    var previousCall = lastCall;
    lastCall = Date.now();
    if (previousCall === undefined // function is being called for the first time
    || lastCall - previousCall > delay) {
      // throttle time has elapsed
      fnc.apply(undefined, arguments);
    }
  };
}

},{}],277:[function(require,module,exports){
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toRawType = toRawType;
function toRawType(value) {
  return Object.prototype.toString.call(value).slice(8, -1);
}

},{}],278:[function(require,module,exports){
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.waitFor = waitFor;
/**
 * Function to wait for predicates.
 * 
 * @param { () => Boolean } predicate - A function that returns a bool
 * @param { number }        [timeout] - Optional maximum waiting time in ms after rejected
 * 
 * @see https://gist.github.com/chrisjhoughton/7890239?permalink_comment_id=4411125#gistcomment-4411125
 */
function waitFor(predicate, timeout) {
  return new Promise(function (resolve, reject) {
    var check = function check() {
      if (!predicate()) {
        return 'invalid predicate';
      }
      clearInterval(interval);
      resolve('predicate');
    };
    var interval = setInterval(check, 100);
    check();
    if (timeout) {
      setTimeout(function () {
        clearInterval(interval);reject('timeout');
      }, timeout);
    }
  });
}

},{}],279:[function(require,module,exports){
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.within = within;

var _jstsMin = require('jsts/dist/jsts.min.js');

var _jstsMin2 = _interopRequireDefault(_jstsMin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Check if `geometryToCheck` is within `geometry`
 * 
 * @param   { ol.geometry } geometry
 * @param   { ol.geometry } geometryToCheck
 * @returns { boolean }     whether `geometryToCheck` is within `geometry`
 * 
 * @since 3.8.0
 */
function within(geometry, geometryToCheck) {
  var parser = new _jstsMin2.default.io.OL3Parser();
  parser.inject(ol.geom.Point, ol.geom.LineString, ol.geom.LinearRing, ol.geom.Polygon, ol.geom.MultiPoint, ol.geom.MultiLineString, ol.geom.MultiPolygon);
  return parser.read(geometryToCheck).within(parser.read(geometry));
}

},{"jsts/dist/jsts.min.js":21}],280:[function(require,module,exports){
Object.defineProperty(exports, "__esModule", {
  value: true
});
/* Generated by gulpfile.js, do not edit manually */

exports.default = '3.11.3';

},{}]},{},[166]);
